(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.detail', [
    'BlurAdmin.pages.personnel.dossier.trainings.edit'
  ])
    .controller('PersonnelDossierTrainingsDetailController', PersonnelDossierTrainingsDetailController);

  /**
  * @description Controller for the personnel-dossier-trainings treeview.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsDetailController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsDetailController(
    $uibModalInstance,
    permissions,
    selectedCtx, member, training, categories
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.selectedCtx = selectedCtx;
    $ctrl.member = member;

    $ctrl.training = training;
    $ctrl.categories = categories;

    $ctrl.trainingsEditUiConfig = {
      showDeleteBtn: false,
      alwaysShowCancelBtn: true
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsDetailController#
    */
    function activate() {
      setUiByPermissions();
    }

    // EVENT-HANDLERS
    $ctrl.trainingsEditFeedbackReceiver = function(eventName, sucessful) {
      switch(eventName) {
      case 'TRAINING_EDIT_COMPONENT_CANCEL_BTN_CLICKED':
        $uibModalInstance.dismiss();
        break;
      case 'TRAINING_EDIT_COMPONENT_SAVE_BTN_CLICKED':
          // check if action was successful
        sucessful && $uibModalInstance.close({});
        break;
      }
    }

    // HELPERS
    function setUiByPermissions() {
      var hasManagePermission = permissions.isPermittedInSome('arno.personnel.dossier.trainings.manage', 'Division', $ctrl.selectedCtx);

      $ctrl.trainingsEditUiConfig.disableFields = !hasManagePermission;
      $ctrl.trainingsEditUiConfig.showSaveBtn = hasManagePermission;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.statistics.timeline', [])
    .component('arnoPersonnelDossierTrainingsTimeline', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsTimeline/trainingsTimeline.tpl.html',
      controller: PersonnelDossierTrainingsTimelineController,
      controllerAs: '$trainingsTimelineCtrl',
      bindings: {
        trainingsData: '=',
        selectedMinDate: '=',
        selectedMaxDate: '='
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings statistics.timeline-component.
  * SEE: https://github.com/NUKnightLab/TimelineJS
  * SEE: https://github.com/fmaturel/angular-timelinejs3 (REQUIRES NUKnightLab/TimelineJS)
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsTimelineController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsTimelineController(
    $scope, $timeout, $translate
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.IMG_BASE_PATH = 'assets/img/app/personnel/dossier/trainings/';
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };
    $ctrl.TRAINING_COMPLETION_STATUS_LABELS = {
      IRRELEVANT: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.IRRELEVANT'),
      OPEN: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.OPEN'),
      COMPLETED: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.COMPLETED'),
    };

    // VARS
    $ctrl.trainingTemplates = [];

    /** ALSO SEE: https://timeline.knightlab.com/docs/options.html
    Native default options from angular-timelinejs3 source
    defaultOptions = {
      debug: false,                       // Can be set to debug timelinejs
      script_path: '',
      // width: will be 100%,
      // height: will be 100%,
      scale_factor: 1,                    // How many screen widths wide should the timeline be
      layout: 'landscape',                // portrait or landscape
      timenav_position: 'bottom',         // timeline on top or bottom
      optimal_tick_width: 100,            // optimal distance (in pixels) between ticks on axis
      base_class: '',
      //timenav_height: 150,
      timenav_height_percentage: 50,      // Overrides timenav height as a percentage of the screen
      timenav_height_min: 150,            // Minimum timenav height
      marker_height_min: 30,              // Minimum Marker Height
      marker_width_min: 150,              // Minimum Marker Width
      marker_padding: 5,                  // Top Bottom Marker Padding
      start_at_slide: 0,
      //menubar_height: 200,
      skinny_size: 650,
      relative_date: false,               // Use momentjs to show a relative date from the slide.text.date.created_time field
      use_bc: false,                      // Use declared suffix on dates earlier than 0
      duration: 1000,                     // Slider animation duration
      ease: TL.Ease.easeInOutQuint,       // Slider animation type
      dragging: true,
      trackResize: true,
      map_type: 'stamen:toner-lite',
      slide_padding_lr: 100,              // padding on slide of slide
      slide_default_fade: '50%',          // landscape fade
      language: 'en'
    };
    */
    $ctrl.timelineOptions = {
      script_path: 'assets/lib/timelinejs3/',
      language: 'de',
      timenav_position: 'top',
      duration: 500,
      start_at_slide: 0,
      slide_default_fade: '25%',
      slide_padding_lr: 0,
      timenav_height_percentage: 60,
      initial_zoom: 2,
      zoom_sequence: [0.125, 0.25, 0.5, 1, 2, 3, 5, 8, 13],
      scale_factor: 2
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsTimelineController#
    */
    function activate() {
      setupWatchers();
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watch($ctrl.timelineOptions, function(newOptions) {
        if($ctrl.timeline) {
          $ctrl.timeline.setOptions(newOptions);
        }
      }, true);

      $scope.$watch('$trainingsTimelineCtrl.trainingsData', function() {
        _.forEach($ctrl.trainingsData, function(training) {
          $ctrl.trainingTemplates[training.TrainingTemplate.id] = training.TrainingTemplate;
        });

        refreshTimeline();
      });
    }

    function refreshTimeline() {
      var newTimelineData = convertTrainingsaDataToTimelineData($ctrl.trainingsData);

      $timeout(function () {
        $ctrl.timeline.setData(newTimelineData);

        $ctrl.timeline.goTo(0);
      }, 200);
    }

    function convertTrainingsaDataToTimelineData(trainingsData) {
      var timelineData = {
        events: []
      }

      var minDate = moment();
      var maxDate = moment();

      _.forEach(trainingsData, function(training) {
        var showDateWarning = false;

        var statusIconUrl = 'graduation_black.png';
        switch(training.Status) {
        case 'SUCCEEDED':
          statusIconUrl = 'graduation_green.png';
          break;
        case 'FAILED':
          statusIconUrl = 'graduation_red.png';
          break;
        }

        // IMPORTANT REMARK: the startdate of the timeline is essential to show the timeline-entries
        // so if the start-date of the training is not given then try to fallback to other dates
        // in the below order, to at least have a anchor point for the rendering of the timeline entry
        var startDate = training.StartDate || training.EndDate || training.CompletionDate;
        startDate = moment(training.StartDate || null);
        // this is the case when no valid date could be determined for the anchor of the timeline element
        if (!startDate.isValid()) {
          startDate = moment();
          showDateWarning = true;
        }

        var timelineStartDate = startDate.isValid() ? {
          year: startDate.year(),
          month: startDate.month() + 1,
          day: startDate.date()
        } : undefined; // if in the worst case no date could be determined for the startdate of the timeline-entry, then take today...

        var endDate = training.CompletionDate || training.EndDate; // CompletionDate has higher prio
        endDate = moment(endDate || null);
        var timelineEndDate = endDate.isValid() ? {
          year: endDate.year(),
          month: endDate.month() + 1,
          day: endDate.date()
        } : undefined;

        // check to find min date of all given trainings startdate
        if (startDate.diff(minDate) < 0) {
          minDate = startDate;
        }

        // check to find max date of all given trainings end-date, TODO-CLEARIFY: use end-date or completion-date?
        if (maxDate.diff(endDate) < 0) {
          maxDate = endDate;
        }

        var countableHoursText = training.CountableHours ? $translate.instant(
          'modules.personnel.dossier.trainings.statistics.countableHoursText',
          { hours: training.CountableHours.toString() }
        ) : '';
        var completionStatusText = $ctrl.TRAINING_COMPLETION_STATUS_LABELS[training.CompletionStatus] || $translate.instant('modules.personnel.dossier.trainings.statistics.unknown');
        var subHeadline = $translate.instant('modules.personnel.dossier.trainings.statistics.subHeadline1', { state: completionStatusText })
          + '<br>'
          + $translate.instant('modules.personnel.dossier.trainings.statistics.subHeadline2', { hours: (training.CountableHours || 0) });

        if (showDateWarning) {
          subHeadline += '<br><br> <small>' + $translate.instant('modules.personnel.dossier.trainings.statistics.subHeadline3') + '</small>';
        }

        timelineData.events.push({
          start_date: timelineStartDate,
          end_date: timelineEndDate,
          text: {
            headline: training.Name + countableHoursText,
            text: subHeadline
          },
          media: {
            url: $ctrl.IMG_BASE_PATH + statusIconUrl,
            credit: 'Status:',
            caption: $ctrl.TRAINING_STATUS_LABELS[training.Status]
          },
          group: training.TrainingTemplate.Name
        })
      });

      return timelineData;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.statistics.qualificationstable', [])
    .component('arnoPersonnelDossierTrainingsQualificationsTable', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsQualificationsTable/trainingsQualificationsTable.tpl.html',
      controller: PersonnelDossierTrainingsQualificationsTableController,
      controllerAs: '$trainingsQualificationsTableCtrl',
      bindings: {
        selectedCtx: '<',
        trainingTemplates: '=',
        memberQualifications: '=',
        qualificationsHierarchy: '=',
        member: '<'
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings statistics.qualificationstable-component.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsQualificationsTableController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsQualificationsTableController(
    $state, $stateParams,
    permissions,
    ArnoDashQualificationsService
  ) {
    var $ctrl = this;


    // VARS
    $ctrl.tablesUiConfig = {
      showHeaderTopbar: false
    }

    $ctrl.allTrainingTemplatesQualifications = [];
    $ctrl.changedQualifications = {};

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsQualificationsTableController#
    */
    function activate() {
      $ctrl.actionInProgress = true;

      $ctrl.qualificationsHierarchyForAdd = $ctrl.qualificationsHierarchy;

      prepareQualificationsStructs();

      setUiByPermissions();

      $ctrl.actionInProgress = false;
    }

    // EVENT-HANDLERS
    $ctrl.saveQualifications = function () {
      // update member-qualifications, changedQualifications must be an array of objects!
      ArnoDashQualificationsService.updateMemberQualificationsWithNotifications($ctrl.member, $ctrl.selectedCtx, $ctrl.changedQualifications)
        .then(function () {
          // OPT-CHECK-N: state reload atm not working for sub-state, recheck and fix and hot-refresh data here
          $state.go('arno.personnel.dossier.trainings.main', {
            recentTrainingsViewMode: $stateParams.recentTrainingsViewMode,
            lastSelectedNodeId: $stateParams.lastSelectedNodeId
          });
        });
    }

    // HELPERS
    function prepareQualificationsStructs() {
      $ctrl.affectedMemberTrainingTemplatesQualifications = [];

      // reduce the qualifications in the training-templates to have only one object for each qualification
      _.forEach($ctrl.trainingTemplates, function (template) {
        if (template && template.Qualifications) {
          template.Qualifications.forEach(function (qualification, index) {
            // also check and pre-fill with the existing qualifications of the member
            var foundMemberQualification = _.find($ctrl.memberQualifications, { Id: qualification.id });
            var existingQualification = _.find($ctrl.allTrainingTemplatesQualifications, { id: qualification.id }) || foundMemberQualification;

            if (existingQualification) {
              template.Qualifications[index] = existingQualification;
            }
            else {
              $ctrl.allTrainingTemplatesQualifications.push(qualification);
            }

            if (foundMemberQualification) {
              $ctrl.affectedMemberTrainingTemplatesQualifications.push(foundMemberQualification);
            }
          });
        }
      });

      $ctrl.affectedMemberTrainingTemplatesQualifications = _.uniqBy($ctrl.affectedMemberTrainingTemplatesQualifications, 'Id');

      // filter all relevant qualifications from the qualificationHierarchy, to only show the qualifications, which can be added to the member
      _.forEach($ctrl.qualificationsHierarchyForAdd, function (qualificationGroup) {

        qualificationGroup && _.forEach(qualificationGroup.Qualifications, function (qualification, index) {
          if (qualification && qualification.id) {
            var foundTrainingTemplatesQualification = _.find($ctrl.allTrainingTemplatesQualifications, { id: qualification.id });

            // check and remove qualification from hierarchy to disallow selection in the qualificationList
            if (!foundTrainingTemplatesQualification) {
              qualificationGroup.Qualifications[index] = undefined;
            }
          }
        });

        qualificationGroup.Qualifications = _.remove(qualificationGroup.Qualifications, undefined);
      });
    }

    function setUiByPermissions() {
      // check and set permissions
      var hasManagePermission = permissions.isPermittedInSome('arno.personnel.dossier.trainings.manage', 'Division', $ctrl.selectedCtx);
      $ctrl.allowQualificationsDelete = hasManagePermission;
      $ctrl.qualificationsViewOnly = !hasManagePermission; // need this to disable edit feature for qualifications in qualificationList
      $ctrl.hasDossierQualificationViewPerm = permissions.isPermittedInSome('arno.personnel.dossier.qualification.viewAll', 'Division', $ctrl.selectedCtx);

      if (!hasManagePermission) {
        $ctrl.qualificationsHierarchyForAdd = null;
      }
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    }

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.statistics.hourstable', [])
    .component('arnoPersonnelDossierTrainingsHoursTable', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsHoursTable/trainingsHoursTable.tpl.html',
      controller: PersonnelDossierTrainingsHoursTableController,
      controllerAs: '$trainingsHoursTableCtrl',
      bindings: {
        trainingsData: '=',
        visibleCols: '<'
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings statistics.hourstable-component.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsHoursTableController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsHoursTableController(
    $translate
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };

    // VARS
    $ctrl.tablesUiConfig = {
      showHeaderTopbar: false
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsHoursTableController#
    */
    function activate() {}

    // VIEW-FUNCTIONS
    $ctrl.recalcCountableHours = function(trainings) {
      // calc the accumulated countable-hours,
      var accumulatedCountableHours = 0;
      _.forEach(trainings, function(training) {
        if (training && training.CountableHours) {
          accumulatedCountableHours += training.CountableHours;
        }
      });

      return +accumulatedCountableHours.toFixed(2);
    };

    $ctrl.checkTrainingValidity = function(training) {
      if (training && training.ValidityEndDate) {
        var validityEndDate = moment(training.ValidityEndDate || null);

        if (validityEndDate.isValid() && validityEndDate.diff(moment()) < 0) {
          return true;
        }
      }

      return false;
    }

    // HELPERS

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
        .module('BlurAdmin.pages.administration.personnel.activityWindow', [])
        .config(routeConfig)

    /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('arno.administration.personnel.activityWindow', {
          url: '/activities/activity/:windowAction/:organizationId/:divisionId/:groupId/:activityId',
          templateUrl: 'app/pages/administration/personnel/activities/activityWindow/activity.html',
          title: 'navigation.administration.personnel.activityWindow',
          controller: 'ActivityWindowCtrl as $activityWindowCtrl',
          resolve: {
            windowAction: function ($stateParams) {
              return $stateParams.windowAction || null;
            },
            groupId: function ($stateParams) {
              return $stateParams.groupId || null;
            },
            activityId: function ($stateParams) {
              return $stateParams.activityId || null;
            },
            organizationId: function ($stateParams) {
              return $stateParams.organizationId || null;
            },
            divisionId: function ($stateParams) {
              return $stateParams.divisionId || null;
            },
          },
          viewPermission: 'arno.administration.personnel.activities.manage',
        })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.activityWindow')
    .controller('RequirementsSetModalCtrl', RequirementsSetModalCtrl);

  /** @ngInject */
  function RequirementsSetModalCtrl($scope, $uibModalInstance, clientApi, toastr, defaultQualifications, withChildrenQualifications,
    wardenQualifications, wardenWithChildrenQualifications, defaultApprovals, withChildrenApprovals, wardenApprovals,
    wardenWithChildrenApprovals, divisionId, organizationId, approvals, qualifications, requirementsSet, activity, $translate) {
    var self = this;
    self.activity = activity;
    self.divisionId = divisionId;
    self.divisionIds = [divisionId];
    self.organizationId = organizationId;

    self.requirementsSet = requirementsSet || {};
    self.requirementsSet.characteristics = self.requirementsSet.characteristics || {};
    self.defaultQualifications = defaultQualifications;
    self.withChildrenQualifications = withChildrenQualifications;
    self.wardenQualifications = wardenQualifications;
    self.wardenWithChildrenQualifications = wardenWithChildrenQualifications;
    self.defaultApprovals = defaultApprovals;
    self.withChildrenApprovals = withChildrenApprovals;
    self.wardenApprovals = wardenApprovals;
    self.wardenWithChildrenApprovals = wardenWithChildrenApprovals;

    self.Qualifications = qualifications;
    self.Approvals = approvals;

    self.tabs = [
      {
        heading: $translate.instant('modules.administration.adminActivities.workInFunction'),
        disabled: false,
        requirementsSetModalCtrl: self,
        characteristic: 'DEFAULT',
        active: true,
        requirements: {},
        showActions: true,
        visible: false,
        activeCharacteristic: true,
        quali: defaultQualifications,
        approvals: defaultApprovals,
      },
      {
        heading: $translate.instant('modules.administration.adminActivities.minors'),
        disabled: false,
        requirementsSetModalCtrl: self,
        characteristic: 'WITH_CHILDREN',
        active: false,
        requirements: {},
        showActions: true,
        visible: true,
        activeCharacteristic: requirementsSet.characteristics.WITH_CHILDREN ? requirementsSet.characteristics.WITH_CHILDREN.active : false,
        quali: withChildrenQualifications,
        approvals: withChildrenApprovals,
      },
      {
        heading: $translate.instant('modules.administration.adminActivities.adults'),
        disabled: false,
        requirementsSetModalCtrl: self,
        characteristic: 'WARDEN',
        active: false,
        requirements: {},
        showActions: true,
        visible: true,
        activeCharacteristic: requirementsSet.characteristics.WARDEN ? requirementsSet.characteristics.WARDEN.active : false,
        quali: wardenQualifications,
        approvals: wardenApprovals,
      },
      {
        heading: $translate.instant('modules.administration.adminActivities.bothGroups'),
        disabled: false,
        requirementsSetModalCtrl: self,
        characteristic: 'WARDEN_WITH_CHILDREN',
        active: false,
        requirements: {},
        showActions: true,
        visible: true,
        activeCharacteristic: requirementsSet.characteristics.WARDEN_WITH_CHILDREN ? requirementsSet.characteristics.WARDEN_WITH_CHILDREN.active : false,
        quali: wardenWithChildrenQualifications,
        approvals: wardenWithChildrenApprovals,
      }
    ];
    self.tabs.active = 0;
    self.tabs.forEach(function (tab) {
      tab.requirements.Qualifications = tab.requirements.Qualifications || {};
      tab.requirements.Approvals = tab.requirements.Approvals || {};
    });

    self.types = ['Approvals', 'Qualifications'];
    $scope.$watch(function () {
      return self.tabs[0].requirements;
    }, function (newValue) {
      self.types.forEach(function (type) {
        if (!(newValue[type].add || newValue[type].delete)) {
          return;
        }

        if (newValue[type].add.length !== 0) {
          // if a qualification or approval was ADDed to the list, remove the qualification/approval from the available choices for the other tabs
          self[type].forEach(function (group) {
            _.remove(group[type], function (element) {
              return (newValue[type].add.indexOf(element.id) !== -1);
            });
          });
        }
        if (newValue[type].delete.length !== 0) {
          // if a qualification or approval was DELETEd from the list, add the qualification/approval to the available choices for the other tabs
          self[type].forEach(function (group) {
            group[type].forEach(function (element) {
              (newValue[type].delete.indexOf(element.id) !== -1) ? group[type].push() : false;
            });
          })
        }
      });
    }, true);

    self.applyModal = function (fn) {
      self.tabs.forEach(function (tab) {

        if (!tab.activeCharacteristic && tab.characteristic !== 'DEFAULT') {
          return;
        }

        self.requirementsSet.characteristics[tab.characteristic] = self.requirementsSet.characteristics[tab.characteristic] || {};
        self.requirementsSet.characteristics[tab.characteristic].active = tab.activeCharacteristic;

        self.requirementsSet.characteristics[tab.characteristic].qualifications = (self.requirementsSet.characteristics[tab.characteristic].qualifications || [])
          .concat(tab.requirements.Qualifications.add || []);
        self.requirementsSet.characteristics[tab.characteristic].qualifications = _.difference(
          self.requirementsSet.characteristics[tab.characteristic].qualifications,
          (tab.requirements.Qualifications.delete || [])
        );

        self.requirementsSet.characteristics[tab.characteristic].approvals = (self.requirementsSet.characteristics[tab.characteristic].approvals || [])
          .concat(tab.requirements.Approvals.add || []);
        self.requirementsSet.characteristics[tab.characteristic].approvals = _.difference(
          self.requirementsSet.characteristics[tab.characteristic].approvals,
          (tab.requirements.Approvals.delete || [])
        );
      });

      $uibModalInstance.close({
        fn: fn,
        requirementsSet: self.requirementsSet,
      });
    };

    self.divisionSelectorEntryPermission = 'arno.administration.personnel.activities.manage';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.inspection', [])
    .controller('InspAssignmentOverrideControl', InspAssignmentOverrideControl);

  function InspAssignmentOverrideControl(assignmentCount) {
    var self = this;
    self.assignmentCount = assignmentCount;
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.wizard', [
    'BlurAdmin.theme.components.trainingsTreeview',
    'BlurAdmin.pages.personnel.dossier.trainings.edit'
  ])
    .controller('PersonnelDossierTrainingsWizardController', PersonnelDossierTrainingsWizardController);

  /**
  * @description Controller for the personnel-dossier-trainings treeview.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsWizardController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsWizardController(
    $rootScope, $state, $uibModalInstance,
    toastr, permissions, commonUtils, // common-services
    ArnoDashTrainingTemplatesService,  ArnoDashTrainingsService, // app-services
    selectedCtx, member, trainingTemplatesGroups, categories, eventId
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.treeviewConfig = {
      showFooterBarRightRow: false,
      showStatusFilter: false
    }

    $ctrl.member = member;
    $ctrl.selectedCtx = selectedCtx;
    $ctrl.trainingTemplateTreeData = trainingTemplatesGroups;
    $ctrl.categories = categories;
    $ctrl.eventId = eventId;

    $ctrl.trainingEditUiConfig = {
      showBottomActionsbar: false
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsWizardController#
    */
    function activate() {
      getUiPermissions();
    }

    // EVENT-HANDLERS
    $ctrl.selectNode = function(nodeToBeSelected) {
      // only allow selection of training-templates
      if (nodeToBeSelected.type !== ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
        return false; // abort selection for treeview
      }

      $ctrl.chooseTrainingTemplateForm.$valid = true;
      $ctrl.chooseTrainingTemplateForm.$dirty = true;
    }

    $ctrl.cancel = function() {
      $uibModalInstance.dismiss();
    }

    $ctrl.chosedTrainingTemplate = function() {
      // check if a training-template is selected (no training-group allowed)
      if (!$ctrl.selectedNode || !$ctrl.selectedNode.model
        || $ctrl.selectedNode.type !== ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE
      ) {
        // using $ctrl.chooseTrainingTemplateForm.$error = true is also possible...
        $ctrl.chooseTrainingTemplateForm.$dirty = false;
        // show form inline error-message
        $ctrl.chooseTrainingTemplateForm.$valid = false;

        return false;
      }

      $ctrl.training = _.pick(_.cloneDeep($ctrl.selectedNode.model), [
        'Name',
        'CountableHours',
        'BaseCategories',
        'Notes',
      ]);

      // IMPORTANT: set id to null, so API will create a new one and set the training-template id for the training to be created!
      $ctrl.training.id = null;
      $ctrl.training.TrainingTemplateId = $ctrl.selectedNode.model.id;
      $ctrl.training.TrainingTemplate = $ctrl.selectedNode.model;

      $ctrl.training.StartDate = moment().toDate(); // preset the current date as start-date
      $ctrl.training.CompletionStatus = 'IRRELEVANT'; // preset the current status

      // because we dont have any real form-inputs in the wizardstep to chose the training (except the tree-view)
      // - which is not counted as input - we must manually set the form to dirty so the blur-admin wizard-component goes to the next step!
      $ctrl.chooseTrainingTemplateForm.$dirty = true;
      $ctrl.chooseTrainingTemplateForm.$valid = true;

      $ctrl.addTrainingForm.$dirty = true;
    }

    $ctrl.finish = function () {

      if ($ctrl.eventId != null && $ctrl.eventId != 0) {
        $ctrl.member.forEach(function (member) {
          return ArnoDashTrainingsService.saveTrainingWithNotifications($ctrl.training, $ctrl.selectedCtx, member.id, $ctrl.eventId);
        });
        $uibModalInstance.close();
      }
      else {
        return ArnoDashTrainingsService.saveTrainingWithNotifications($ctrl.training, $ctrl.selectedCtx, member.id, null)
          .then(function () {
            $uibModalInstance.close({ success: true });
          });
      }
    }

    $ctrl.gotoTrainingsTemplateAdministration = function() {
      $state.go('arno.administration.personnel.trainings')
        .then(function() {
          $uibModalInstance.close({});
        });
    }

    // VIW-FUNCTIONS
    $ctrl.hasTrainingTemplates = function() {
      if ($ctrl.trainingTemplateTreeData && $ctrl.trainingTemplateTreeData.length) {
        var foundTemplate = commonUtils.searchElementInTreeData($ctrl.trainingTemplateTreeData, 'children', 'type', ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE);

        if (foundTemplate) {
          return true;
        }
      }

      return false;
    }

    // HELPERS
    function getUiPermissions() {
      var currentOrgId =  $rootScope.ctx && $rootScope.ctx.organization && $rootScope.ctx.organization.current ? $rootScope.ctx.organization.current.id : null;
      $ctrl.hasManagePermission = permissions.isPermittedInSome('arno.administration.personnel.trainings.manage', 'Organization', [currentOrgId]);
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.treepanel', [
    'BlurAdmin.theme.components.trainingsTreeview'
  ])
    .component('arnoPersonnelDossierTrainingsTreePanel', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsTreePanel/trainingsTreePanel.tpl.html',
      controller: PersonnelDossierTrainingsTreePanelController,
      controllerAs: '$trainingsTreePanelCtrl',
      bindings: {
        selectedCtx: '<',
        member: '<?',
        trainingsTree: '=',
        categories: '<'
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings treeview.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsTreePanelController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsTreePanelController(
    $scope, $state, $stateParams, $uibModal,
    stateChangePrompt, commonUtils, permissions, baModalService,
    ArnoDashTrainingGroupsService, ArnoDashTrainingsService
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.treeviewConfig = {
      showAddTrainingBtn: false
    }

    $ctrl.trainingsEditUiConfig = {
      showDeleteBtn: false
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsTreePanelController#
    */
    function activate() {
      setUiByPermissions();

      // check, if there are filters and apply them
      var lastFiltersString = localStorage.getItem('lastTrainingsTreePanelFilters');
      if (lastFiltersString) {
        var filters;

        try { filters = JSON.parse(lastFiltersString) }
        catch (ex) {} // eslint-disable-line

        if (filters && filters.selectedStatusFilters) {
          $ctrl.selectedTrainingsStatusFilter = filters.selectedStatusFilters;
        }
      }

      if ($stateParams.lastSelectedNodeId) {
        var lastSelectedNode = commonUtils.searchElementInTreeData(
          $ctrl.trainingsTree,
          'children',
          'id',
          $stateParams.lastSelectedNodeId
        );

        if (lastSelectedNode) {
          $ctrl.selectedNode = lastSelectedNode;

          // wait until element is available in DOM and fetch over its class-id and scroll to it
          // IMPORTANT: this only works for the first tree! if you need multiple trees, you need to extend the ba-treeview e.g. to provide ids
          var scrollElementWatcher = $scope.$watch(function() {
            return $('.' + $ctrl.selectedNode.id).get(0);
          }, function(element) {
            if (element) {
              var treeElement = $('.arno__ba-treeview__tree__wrapper').eq(0);
              treeElement.animate({
                scrollTop: $(element).eq(0).offset().top - 350
              }, 1000);

              // done, stop watcher
              scrollElementWatcher();
            }
          });
        }
      }

      setupWatchers();

      stateChangePrompt.evaluate(function () {
        return !($ctrl.trainingEditForm && $ctrl.trainingEditForm.$dirty);
      });
    }

    // EVENT-HANDLERS
    $ctrl.nodeSelect = function(nodeToBeSelected) {
      // check if node to be selected is a training, if not then dont allow selection of node
      if (nodeToBeSelected && nodeToBeSelected.type !== ArnoDashTrainingsService.TRAININGS_NODE_TYPE) {
        return false; // cancel selection of node
      }

      return checkForChanges(nodeToBeSelected);
    }

    $ctrl.addTraining = function() {
      // open wizard and start creation-process
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/dossier/trainings/trainingsWizardModal/trainingsWizardModal.tpl.html',
        size: 'md',
        controller: 'PersonnelDossierTrainingsWizardController as $trainingWizardCtrl',
        resolve: {
          selectedCtx: function() {
            return $ctrl.selectedCtx;
          },
          member: function() {
            return $ctrl.member;
          },
          eventId: function() {
            return null;
          },
          trainingTemplatesGroups: function() {
            // this service fetches all training-groups and also the training-templates
            return ArnoDashTrainingGroupsService.getTrainingTemplateTree();
          },
          categories: function() {
            return $ctrl.categories;
          }
        },
      }).result.then(function() {
        var lastTrainingEditFormDirtyState = $ctrl.trainingEditForm ? $ctrl.trainingEditForm.$dirty : false;
        $ctrl.refreshTrainingsTree(lastTrainingEditFormDirtyState);
      });
    }

    $ctrl.deleteTraining = function(trainingNode) {
      return ArnoDashTrainingsService.deleteTrainingWithMessageModal(trainingNode.model, ($ctrl.member || {}).id, $ctrl.selectedCtx)
        .then(function(results) {
          if (results) {
            $state.reload();
          }
        });
    }

    $ctrl.openTrainingStatistics = function(trainingNode) {
      $state.go('arno.personnel.dossier.trainings.statistics', {
        templateIds: trainingNode.model.TrainingTemplateId,
        recentTrainingsViewMode: 'treeview',
        lastSelectedNodeId: trainingNode.id
      });
    }

    $ctrl.trainingsEditFeedbackReceiver = function(eventName, sucessful) {
      // add handlers here as needed, for delete (remove from arno-trainings-treeview),
      // and update (e.g. Name is currently not updated!)
      switch(eventName) {
      case 'TRAINING_EDIT_COMPONENT_SAVE_BTN_CLICKED':
        if (sucessful) {
          // this has been changed to state-reload, to minimized side-effects and future bugs, due to change-reqests
          $state.go($state.current, {
            lastSelectedNodeId: $ctrl.selectedNode.id
          }, {reload: true});
        }
        break;

      case 'TRAINING_EDIT_COMPONENT_DELETED':
        $state.reload(); // OPT
        break;
      }
    }

    /**
     * @description This method refreshes the trainings-tree and re.redners the tree-node
     * @param {Boolean} lastTrainingEditFormDirtyState With this option, after the re-rendering of the tree-nodes. the open edit-panel form gets the last state
     * so the change-detection state is not overwritten.
     */
    $ctrl.refreshTrainingsTree = function(lastTrainingEditFormDirtyState) {
      // update filters to state-params
      try {
        localStorage.setItem('lastTrainingsTreePanelFilters', JSON.stringify({
          selectedStatusFilters: $ctrl.selectedTrainingsStatusFilter
        }));
      }
      catch (ex) {} // eslint-disable-line

      var queryOptions = {
        filters: {}
      }

      // manually get the filters from tag-pickers
      if ($ctrl.selectedTrainingsStatusFilter && $ctrl.selectedTrainingsStatusFilter.length) {
        queryOptions.filters.Status = $ctrl.selectedTrainingsStatusFilter;
      }

      $ctrl.isLoadingData = true;
      return ArnoDashTrainingsService.getMemberTrainingsWithTemplateGroups(($ctrl.member || {}).id, $ctrl.selectedCtx, queryOptions)
        .then(function(trainingsTemplateGroupsResults) {
          $ctrl.trainingsTree = ArnoDashTrainingsService.buildAngularTreeControlNodes(trainingsTemplateGroupsResults.groupsTree, trainingsTemplateGroupsResults.trainings);

          $ctrl.isLoadingData = false;

          if ($ctrl.selectedNode) {
            if (!commonUtils.searchElementInTreeData($ctrl.trainingsTree, 'children', 'id', ArnoDashTrainingsService.TRAININGS_NODE_TYPE + '-' + $ctrl.selectedNode.model.id)) {
              $ctrl.selectedNode = undefined;
            }

            if ($ctrl.trainingEditForm && lastTrainingEditFormDirtyState == null) {
              $ctrl.trainingEditForm.$setPristine();
            }
            else {
              $ctrl.trainingEditForm.$dirty = lastTrainingEditFormDirtyState;
            }
          }

          return trainingsTemplateGroupsResults.trainings;
        });
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watchCollection('$trainingsTreePanelCtrl.selectedTrainingsStatusFilter', function() {
        $ctrl.refreshTrainingsTree();
      });
    }

    function setUiByPermissions() {
      // check and set permissions
      var hasManagePermission = permissions.isPermittedInSome('arno.personnel.dossier.trainings.manage', 'Division', $ctrl.selectedCtx);
      $ctrl.treeviewConfig.showAddTrainingBtn = hasManagePermission

      $ctrl.trainingsEditUiConfig.disableFields = !hasManagePermission;
      $ctrl.trainingsEditUiConfig.showDeleteBtn = hasManagePermission;
      $ctrl.trainingsEditUiConfig.showSaveBtn = hasManagePermission;
      $ctrl.trainingsEditUiConfig.showCancelBtn = hasManagePermission;
    }

    function checkForChanges(node) {
      // check, if there are changes in the current training edit-form
      if ($ctrl.trainingEditForm && $ctrl.trainingEditForm.$dirty) {
        var contentText = 'Es gibt ungesicherte Änderungen. Willst du diese verwerfen?';

        if (node) {
          contentText = 'Es gibt ungesicherte Änderungen in der Fortbildung "' + node.label + '". Willst du diese verwerfen?';
        }

        return baModalService.messageModal({
          modalType: 'warning',
          allowHtml: false,

          title: 'Änderungen der Fortbildung',
          content: contentText,

          primaryActionText: 'Weiter bearbeiten',
          secondaryActionText: 'Änderungen verwerfen'
        })
          .then(function() {
            // stay clicked, dont allow select of transition node, stay at current node
            return false;
          })
          .catch(function() {
            // cancel clicked
            $ctrl.trainingEditForm.$setPristine();
            return true;
          });
      }

      return true;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.tablepanel', [
    'BlurAdmin.pages.personnel.dossier.trainings.detail'
  ])
    .component('arnoPersonnelDossierTrainingsTablePanel', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsTablePanel/trainingsTablePanel.tpl.html',
      controller: PersonnelDossierTrainingsTablePanelController,
      controllerAs: '$trainingsTablePanelCtrl',
      bindings: {
        selectedCtx: '<',
        member: '<?',
        categories: '<',
        isOverview: '<'
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings treeview.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsTablePanelController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsTablePanelController(
    $scope, $state, $uibModal, $timeout, $translate,
    permissions, baModalService, toastr, commonUtils,
    ArnoDashTrainingGroupsService, ArnoDashTrainingsService, persistFilter, fileUtil
  ) {
    var $ctrl = this;
    var filterStorageKey = 'trainingListFilter';
    $ctrl.storedFilters = localStorage.getItem(filterStorageKey);
    var filters = JSON.parse($ctrl.storedFilters) || {};
    $ctrl.filterApplied = {};
    $ctrl.dates = {};

    $ctrl.divisionIds = commonUtils.division.getCtx({
      multiple: false,
      allowOrgSelection: true,
      entryPermission: 'arno.personnel.dossier.trainings.view'
    });

    // CONSTS
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };
    $ctrl.TRAINING_STATUS = [{
      Name: $ctrl.TRAINING_STATUS_LABELS.PLANNED,
      mapping: 'PLANNED'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.INPROGRESS,
      mapping: 'INPROGRESS'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.PENDING,
      mapping: 'PENDING'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.SUCCEEDED,
      mapping: 'SUCCEEDED'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.FAILED,
      mapping: 'FAILED'
    }];

    $ctrl.TRAINING_COMPLETION_STATUS_LABELS = {
      IRRELEVANT: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.IRRELEVANT'),
      OPEN: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.OPEN'),
      COMPLETED: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.COMPLETED'),
    };
    $ctrl.TRAINING_COMPLETION_STATUS = [{
      Name: $ctrl.TRAINING_COMPLETION_STATUS_LABELS.IRRELEVANT,
      mapping: 'IRRELEVANT'
    }, {
      Name: $ctrl.TRAINING_COMPLETION_STATUS_LABELS.OPEN,
      mapping: 'OPEN'
    }, {
      Name: $ctrl.TRAINING_COMPLETION_STATUS_LABELS.COMPLETED,
      mapping: 'COMPLETED'
    }];

    $ctrl.GRADUATIONS_LABELS = {
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.graduationState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.graduationState.SUCCEEDED'),
    },
      $ctrl.GRADUATIONS = [{
        Name: $ctrl.GRADUATIONS_LABELS.SUCCEEDED,
        mapping: 'SUCCEEDED'
      }, {
        Name: $ctrl.GRADUATIONS_LABELS.FAILED,
        mapping: 'FAILED'
      }];


    // VARS
    $ctrl.trainings = [];
    $ctrl.isLoadingData = false;

    $ctrl.currentFilters;
    $ctrl.lastFilterResultCount;
    $ctrl.selectedTrainingsStatusFilter = [];
    $ctrl.selectedTrainingsCompletionStatusFilter = [];
    $ctrl.selectedTrainingsGraduationFilter = [];

    $ctrl.visibleCols = {
      CountableHours: {
        label: $translate.instant('modules.personnel.dossier.trainings.hours'),
        value: true
      },
      Status: {
        label: $translate.instant('modules.personnel.dossier.trainings.state'),
        value: true
      },
      StartDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.begin'),
        value: false
      },
      EndDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.end'),
        value: false
      },
      CompletionDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.completionDate'),
        value: false
      },
      CompletionStatus: {
        label: $translate.instant('modules.personnel.dossier.trainings.completion'),
        value: false
      },
      Graduation: {
        label: $translate.instant('modules.personnel.dossier.trainings.graduation'),
        value: false
      },
      TrainingTemplate: {
        label: $translate.instant('modules.personnel.dossier.trainings.trainingTemplate'),
        value: true
      },
      ValidityEndDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.validityEndDate'),
        value: true
      },
      Notes: {
        label: $translate.instant('modules.personnel.dossier.trainings.notes'),
        value: false
      }
    };

    $ctrl.tablePageSizes = [5, 10, 15, 20, 30, 50];
    $ctrl.tablePageSize = 10;

    $ctrl.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    $ctrl.endDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    $ctrl.completionDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsTablePanelController#
    */
    function activate() {
      $ctrl.isLoadingData = true; // set this view-var to true to avoid flickering of table-footer pagination

      // check, if there are last table col-configs and apply them
      var lastTableColConfigString = localStorage.getItem('lastTrainingsTablePanelColConfigs');
      if (lastTableColConfigString) {
        var tableColConfigs;

        try { tableColConfigs = JSON.parse(lastTableColConfigString); }
        catch (ex) { } // eslint-disable-line

        if (tableColConfigs) {
          $ctrl.visibleCols = tableColConfigs;
        }
      }

      setUiByPermissions();

      $ctrl.isLoadingData = false;
    }

    // EVENT-HANDLERS
    $ctrl.addTraining = function () {
      // open wizard and start creation-process
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/dossier/trainings/trainingsWizardModal/trainingsWizardModal.tpl.html',
        size: 'md',
        controller: 'PersonnelDossierTrainingsWizardController as $trainingWizardCtrl',
        resolve: {
          selectedCtx: function () {
            return $ctrl.selectedCtx;
          },
          member: function () {
            return $ctrl.member;
          },
          eventId: function () {
            return null;
          },
          trainingTemplatesGroups: function () {
            // this service fetches all training-groups and also the training-templates
            return ArnoDashTrainingGroupsService.getTrainingTemplateTree();
          },
          categories: function () {
            return $ctrl.categories;
          }
        },
      }).result.then(function () {
        $state.reload();
      });
    };

    $ctrl.openTrainingDetails = function (trainingListEntry, event) {
      event.stopPropagation();

      return $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/personnel/dossier/trainings/trainingsTablePanel/trainingsDetailModal/trainingsDetailModal.tpl.html',
        size: 'md',
        backdrop: 'static',
        controller: 'PersonnelDossierTrainingsDetailController as $trainingsDetailsCtrl',
        resolve: {
          selectedCtx: function () {
            return $ctrl.selectedCtx;
          },
          training: function () {
            return _.cloneDeep(trainingListEntry);
          },
          member: function () {
            return $ctrl.member;
          },
          categories: function () {
            return $ctrl.categories;
          }
        },
      })
        .result.then(function () {
          // its better to reload the state, because the changing of the properties may cause the paging
          // to be change
          $state.reload();
        });
    };

    $ctrl.openTrainingStatistics = function (trainingListEntry, event) {
      event.stopPropagation();

      $state.go('arno.personnel.dossier.trainings.statistics', {
        templateIds: trainingListEntry.TrainingTemplateId,
        recentTrainingsViewMode: 'tableview'
      });
    };

    $ctrl.openMultipleTrainingStatistics = function () {
      // get all selected trainings for which statistics ("Auswertung") should be shown
      var selectedTrainingsTemplatesIds = _.uniq(_.filter($ctrl.trainings, function (training) {
        return training.vm && training.vm.selected;
      })
        .map(function (selectedTraining) {
          return selectedTraining.TrainingTemplate.id;
        }), 'id');

      $state.go('arno.personnel.dossier.trainings.statistics', {
        templateIds: selectedTrainingsTemplatesIds,
        recentTrainingsViewMode: 'tableview'
      });
    };

    $ctrl.deleteTraining = function (trainingListEntry, event) {
      event.stopPropagation();

      return ArnoDashTrainingsService.deleteTrainingWithMessageModal(trainingListEntry, ($ctrl.member || {}).id, $ctrl.selectedCtx)
        .then(function (results) {
          if (results) {
            // its better to reload the state instead of e.g. removing the deleted training from the array,
            // because the paging may change
            $state.reload();
          }
        });
    };

    $ctrl.selectAllTableEntries = function () {
      _.forEach($ctrl.trainings, function (training) {
        training.vm = training.vm || {};
        training.vm.selected = $ctrl.selectedAllTableEntries;
      });
    };

    $ctrl.exportTable = function () {
      // get all trainings-ids to be exported
      var trainingsIds = [];

      var modalData = {
        hasSelection: $ctrl.isPartlyExport(),
      };

      return baModalService.exportModal(modalData).then(function (result) {
        var colsConfig = ['Name']; // add Name as standard col, its important, because its not configurable by the table-configurator (visibleCols)
        _.forEach($ctrl.visibleCols, function (visibleCol, key) {
          if (visibleCol.value) {
            colsConfig.push(key);
          }
        });

        if (result.options.filter === 'selected') {
          _.forEach($ctrl.trainings, function (training) {
            if (training && training.vm && training.vm.selected) {
              trainingsIds.push(training.id);
            }
          });
        }

        return ArnoDashTrainingsService.exportTrainings(
          $ctrl.selectedCtx,
          ($ctrl.member || {}).id,
          trainingsIds,
          result.filetyp,
          result.options,
          colsConfig,
          $ctrl.currentFilters
        );
      });
    };

    $ctrl.refreshTrainingsList = function (stParams, controller) {
      if (!$ctrl.stTableCtrl && controller) {
        $ctrl.stTableCtrl = controller;
      }
      var previouslySelected = $ctrl.trainings.filter(function (t) {
        return t.vm && t.vm.selected;
      })
        .map(function (t) {
          return t.id;
        });

      var additionalFilterObj = {
        trainingCompletion: $ctrl.selectedTrainingsCompletionStatusFilter,
        trainingStatus: $ctrl.selectedTrainingsStatusFilter,
        trainingGraduation: $ctrl.selectedTrainingsGraduationFilter,
        dates: $ctrl.dates
      };

      persistFilter.applyAndSave(filters, $ctrl.filterApplied, $ctrl.storedFilters, 'training', stParams, filterStorageKey, additionalFilterObj);

      if (!stParams && $ctrl.stTableCtrl) {
        $ctrl.stTableCtrl.pipe($ctrl.stTableCtrl.tableState());
        return;
      }

      var queryOptions = {
        filters: {},
        stParams: stParams
      };

      if (stParams) {
        queryOptions.paging = {
          offset: (stParams.pagination.start / stParams.pagination.number) * $ctrl.tablePageSize || 0,
          limit: $ctrl.tablePageSize,
        };

        queryOptions.sorting = {
          by: stParams.sort.predicate,
          reverse: stParams.sort.reverse,
        };

        queryOptions.filters = stParams.search.predicateObject ? commonUtils.flattenObject(stParams.search.predicateObject) : queryOptions.filters;
      }

      // manually get the filters from tag-pickers
      if ($ctrl.selectedTrainingsCompletionStatusFilter && $ctrl.selectedTrainingsCompletionStatusFilter.length) {
        queryOptions.filters.CompletionStatus = $ctrl.selectedTrainingsCompletionStatusFilter;
      }
      else {
        delete queryOptions.filters.CompletionStatus;
      }

      if ($ctrl.selectedTrainingsStatusFilter && $ctrl.selectedTrainingsStatusFilter.length) {
        queryOptions.filters.Status = $ctrl.selectedTrainingsStatusFilter;
      }
      else {
        delete queryOptions.filters.Status;
      }

      if ($ctrl.selectedTrainingsGraduationFilter && $ctrl.selectedTrainingsGraduationFilter.length) {
        queryOptions.filters.Graduation = $ctrl.selectedTrainingsGraduationFilter;
      }
      else {
        delete queryOptions.filters.Graduation;
      }

      var startDate = moment($ctrl.dates.trainingStartDate || null);
      if (startDate.isValid()) {
        queryOptions.filters.StartDate = startDate.toDate();
      }
      else {
        delete queryOptions.filters.StartDate;
      }

      var endDate = moment($ctrl.dates.trainingEndDate || null);
      if (endDate.isValid()) {
        queryOptions.filters.EndDate = endDate.toDate();
      }
      else {
        delete queryOptions.filters.EndDate;
      }

      var completionDate = moment($ctrl.dates.trainingCompletionDate || null);
      if (completionDate.isValid()) {
        queryOptions.filters.CompletionDate = completionDate.toDate();
      }
      else {
        delete queryOptions.filters.CompletionDate;
      }

      // set back to null if no filters set
      queryOptions.filters = _.isEmpty(queryOptions.filters, true) ? null : queryOptions.filters;

      $ctrl.currentFilters = queryOptions.filters;
      $ctrl.currentStParams = queryOptions.stParams;

      // finally save settings to local-storage for usage after state-reloads
      try {
        localStorage.setItem('lastTrainingsTablePanelQueryOptions', JSON.stringify(queryOptions));
      }
      catch (ex) { } // eslint-disable-line

      $ctrl.isLoadingData = true;
      return ArnoDashTrainingsService.getMemberTrainingsWithTemplateGroups(($ctrl.member || {}).id, $ctrl.selectedCtx, queryOptions)
        .then(function (trainingsTemplateGroupsResults) {
          if (queryOptions.stParams && queryOptions.stParams.pagination) {
            queryOptions.stParams.pagination.numberOfPages = Math.ceil(trainingsTemplateGroupsResults.count / $ctrl.tablePageSize);
          }

          $ctrl.lastFilterResultCount = trainingsTemplateGroupsResults.count;

          $ctrl.trainings = trainingsTemplateGroupsResults.trainings;

          return trainingsTemplateGroupsResults.trainings;
        })
        .finally(function () {
          $ctrl.trainings.forEach(function (t) {
            if (previouslySelected.indexOf(t.id) > -1) {
              t.vm = { selected: true };
            }
          });
          $ctrl.isLoadingData = false;
        });
    };

    $ctrl.resetFilters = function () {
      $ctrl.currentFilters = undefined;

      $ctrl.nameSearchValue = '';
      $ctrl.templateNameSearchValue = '';
      $ctrl.countableHoursSearchValue = '';
      $ctrl.notesSearchValue = '';

      $ctrl.currentStParams.search.predicateObject = undefined;

      $ctrl.selectedTrainingsStatusFilter = [];
      $ctrl.selectedTrainingsCompletionStatusFilter = [];
      $ctrl.selectedTrainingsGraduationFilter = [];

      $ctrl.dates.trainingStartDate = undefined;
      $ctrl.dates.trainingEndDate = undefined;
      $ctrl.dates.trainingCompletionDate = undefined;

      localStorage.removeItem(filterStorageKey);
      $ctrl.storedFilters = {};
      filters = {};

      localStorage.removeItem('lastTrainingsTablePanelQueryOptions');
    };

    // VIEW-FUNCTIONS
    $ctrl.isPartlyExport = function () {
      var numSelected = 0;

      // native for-loop is used for performance in this view-function
      for (var i = 0, l = $ctrl.trainings.length; i < l; i++) {
        if ($ctrl.trainings[i] && $ctrl.trainings[i].vm && $ctrl.trainings[i].vm.selected) {
          numSelected++;
        }
      }

      return numSelected > 0;
    };

    $ctrl.showStatisticsBtn = function () {
      var show = false;

      // check if any of the table-entries are selected
      _.forEach($ctrl.trainings, function (training) {
        show = training && training.vm && training.vm.selected ? true : show;
      });

      return show;
    };

    $ctrl.checkTrainingValidity = function (training) {
      if (training && training.ValidityEndDate) {
        var validityEndDate = moment(training.ValidityEndDate || null);

        if (validityEndDate.isValid() && validityEndDate.diff(moment()) < 0) {
          return true;
        }
      }

      return false;
    };


    $ctrl.fileHasPreview = fileUtil.fileHasPreview;
    $ctrl.viewOrDownloadFile = function (training, event) {
      event.stopPropagation();

      return fileUtil.viewOrDownloadFile({
        divisionId: $ctrl.divisionIds,
        file: training.File,
        pathData: {
          memberId: $ctrl.member.id,
          trainingId: training.id,
        },
        storageIdent: 'memberTraining',
        ignoreDivPath: true,
      });
    };

    function setUiByPermissions() {
      var hasViewPermission = permissions.isPermittedInSome('arno.personnel.dossier.trainings.view', 'Division', $ctrl.selectedCtx);
      var hasManagePermission = permissions.isPermittedInSome('arno.personnel.dossier.trainings.manage', 'Division', $ctrl.selectedCtx);

      $ctrl.hasManagePermission = hasManagePermission;
      $ctrl.hasViewPermission = hasViewPermission;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    };

    $ctrl.$onDestroy = function () {
      try {
        localStorage.setItem('lastTrainingsTablePanelColConfigs', JSON.stringify($ctrl.visibleCols));
      }
      catch (ex) { } // eslint-disable-line
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.edit', ['BlurAdmin.theme.components'])
    .component('arnoPersonnelDossierTrainingsEdit', {
      templateUrl: 'app/pages/personnel/dossier/trainings/trainingsEdit/trainingsEdit.tpl.html',
      controller: PersonnelDossierTrainingsEditController,
      controllerAs: '$trainingsEditCtrl',
      bindings: {
        selectedCtx: '<?',
        trainingData: '=',
        member: '<',
        categories: '<',
        feedbackReceiver: '&?', // this function-binding will receive notifications, if e.g. the user clicked a button
        formRef: '=',
        uiConfig: '<',
      }
    });

  /**
  * @description Controller for the personnel-dossier-trainings edit-component.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsEditController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsEditController(
    $translate,
    $scope,
    ArnoDashTrainingsService,
    commonUtils,
    clientApi
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.TRAINING_GRADUATION_LIST =  [{
      Name: $translate.instant('modules.personnel.dossier.trainings.graduationState.SUCCEEDED'),
      mapping: 'SUCCEEDED'
    }, {
      Name: $translate.instant('modules.personnel.dossier.trainings.graduationState.FAILED'),
      mapping: 'FAILED'
    }];
    $ctrl.TRAINING_COMPLETION_STATUS_LIST = [{
      Name: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.IRRELEVANT'),
      mapping: 'IRRELEVANT'
    }, {
      Name: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.OPEN'),
      mapping: 'OPEN'
    }, {
      Name: $translate.instant('modules.personnel.dossier.trainings.trainingCompletionState.COMPLETED'),
      mapping: 'COMPLETED'
    }];
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };

    // VARS
    var lastTrainingData = $ctrl.trainingData;

    $ctrl.member = $scope.member;

    $ctrl.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    }

    $ctrl.endDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    }

    $ctrl.disableFields = false;

    $ctrl.fileChanged = false;

    $ctrl.divisionIds = [commonUtils.getDivisionFromSingleCtx('arno.personnel.dossier.trainings.manage', true)]

    $ctrl.fileUploadUrl = '/api/files/cacheFile?divisionId=' + $ctrl.divisionIds[0];
    $ctrl.unallowedFileTypes = [
      'exe',
      'com',
      'bat',
      'cmd',
      'vbs',
      'vbe',
      'js',
      'jse',
      'ws',
      'wsf',
      'wsc',
      'wsh',
      'ps1',
      'ps1xml',
      'ps2',
      'ps2xml',
      'psc1',
      'psc2',
      'msh',
      'msh1',
      'msh2',
      'mshxml',
      'msh1xml',
      'msh2xml',
      'scf',
      'lnk',
      'inf',
      'reg',
      'dll',
      'cpl',
      'ocx',
      'ax',
      'sys',
    ];

    $ctrl.fileUploadActive = false;

    var mimeTypes = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webm: 'video/webm',
      pdf: 'application/pdf'
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsEditController#
    */
    function activate() {
      setupWatchers();
    }

    // EVENT-HANDLERS
    $ctrl.graduationChanged = function(selectedItem) {
      var training = $ctrl.trainingData;

      if (selectedItem && training.vm) {
        switch (selectedItem.mapping) {
        case 'FAILED':
          training.vm.ValidityEndDate = null;
          break;

        case 'SUCCEEDED':
          if (training.vm.CompletionDate) {
            var completionDate = moment(training.vm.CompletionDate || null);

            if (!training.vm.ValidityEndDate && completionDate.isValid() && training.TrainingTemplate
              && (training.TrainingTemplate.ValidityPeriodDays || training.TrainingTemplate.ValidityPeriodMonths || training.TrainingTemplate.ValidityPeriodYears)
            ) {
              training.vm.ValidityEndDate = completionDate
                  .add(training.TrainingTemplate.ValidityPeriodDays, 'day')
                  .add(training.TrainingTemplate.ValidityPeriodMonths, 'month')
                  .add(training.TrainingTemplate.ValidityPeriodYears, 'year')
                  .toDate();
            }
          }
          break;
        }
      }
    }

    $ctrl.saveTraining = function(training, form) {
      if (!form || !form.$valid) {
        return false;
      }

      // execute the action and WAIT for PROMISE!
      return ArnoDashTrainingsService.saveTrainingWithNotifications(training, $ctrl.selectedCtx, ($ctrl.member || {}).id)
        .then(function(savedTraining) {
          // take the saved values from the response
          $ctrl.trainingData = savedTraining;
          form.$setPristine();

          // notify the given feedback-receiver (e.g.  could be a modal or another component/service with a function)
          var feedbackReceiver = $ctrl.feedbackReceiver.call($ctrl);
          if (typeof feedbackReceiver === 'function') {
            feedbackReceiver('TRAINING_EDIT_COMPONENT_SAVE_BTN_CLICKED', true, savedTraining);
          }
        })
        .catch(function() {
          // notify the given feedback-receiver (e.g.  could be a modal or another component/service with a function)
          var feedbackReceiver = $ctrl.feedbackReceiver.call($ctrl);
          if (typeof feedbackReceiver === 'function') {
            feedbackReceiver('TRAINING_EDIT_COMPONENT_SAVE_BTN_CLICKED', false, training);
          }
        });

    }

    $ctrl.deleteTraining = function(training) {
      return ArnoDashTrainingsService.deleteTrainingWithMessageModal(training, ($ctrl.member || {}).id, $ctrl.selectedCtx)
        .then(function(results) {
          if (results) {
            // IMPORTANT: remove from trainings array for the tree OR reload state!
            $ctrl.isDeleted = true;

            var feedbackReceiver = $ctrl.feedbackReceiver.call($ctrl);
            if (typeof feedbackReceiver === 'function') {
              feedbackReceiver('TRAINING_EDIT_COMPONENT_DELETED', true, training);
            }
          }
        });
    }

    $ctrl.cancelAndRollbackTrainingChanges = function(training, form) {
      // apply native values
      formatTraining(training);

      // reset form
      form.$setPristine();

      // notify the given feedback-receiver (e.g.  could be a modal or another component/service with a function)
      var feedbackReceiver = $ctrl.feedbackReceiver.call($ctrl);
      if (typeof feedbackReceiver === 'function') {
        feedbackReceiver('TRAINING_EDIT_COMPONENT_CANCEL_BTN_CLICKED', true, training);
      }
    }

    // VIEW-FUNCTIONS
    $ctrl.checkTrainingValidity = function(training) {
      if (training && training.ValidityEndDate) {
        var validityEndDate = moment(training.ValidityEndDate || null);

        if (validityEndDate.isValid() && validityEndDate.diff(moment()) < 0) {
          return true;
        }
      }

      return false;
    }

    $ctrl.getIconClassForStatus = function(status) {
      return ArnoDashTrainingsService.getIconClsForStatus(status);
    }

    $ctrl.showStartDateCompletionDateWarning = function(training) {
      if (training && training.vm && training.vm.StartDate && training.vm.CompletionDate) {
        var startDate = moment(training.vm.StartDate || null);
        var completionDate = moment(training.vm.CompletionDate || null);

        if (startDate.isValid() && completionDate.isValid()) {
          return startDate.diff(moment(completionDate.toDate()).endOf('day')) > 0;
        }
      }

      return false;
    }

    $ctrl.showCompletionDateWarning = function(training) {
      if (training.vm.CompletionDate) {
        var completionDate = moment(training.vm.CompletionDate || null);

        if (completionDate.isValid()) {
          return completionDate.diff(moment()) > 0;
        }
      }

      return false;
    }

    $ctrl.showValidityWarning = function(training) {
      if (training && training.vm && training.vm.ValidityEndDate) {
        var startDate = moment(training.vm.StartDate || null);
        var endDate = moment(training.vm.EndDate || null);
        var completionDate = moment(training.vm.CompletionDate || null);

        var validityDate = moment(training.vm.ValidityEndDate || null);

        if (validityDate.isValid()) {
          return validityDate.diff(endDate) < 0 || validityDate.diff(completionDate) < 0 || validityDate.diff(startDate) < 0;
        }
      }

      return false;
    }

    $ctrl.onFileUploaded = function (data) {
      // data entries can also be null values when upload/save is canceled
      $ctrl.trainingData.fileCacheKey = data.fileCacheKey;
      $ctrl.trainingData.FileName = data.fileItem && data.fileItem.file.name;
        
      $ctrl.fileChanged = !!data.fileCacheKey; 
      $ctrl.trainingData.fileDelete = false;
      $ctrl.fileUploadActive = false;
    }

    $ctrl.onFileDownload = function(fileName) {
      return clientApi.openTab('files/download', {
        divisionId: $ctrl.divisionIds,
        fileName: fileName,
        pathData: JSON.stringify({
          memberId: $ctrl.member.id,
          trainingId: $ctrl.trainingData.id,
        }),
        storageIdent: 'memberTraining',
        ignoreDivPath: true,
      })
    }

    $ctrl.onFilePreview = function(fileName) {
      var extension = fileName.split('.').pop();
      clientApi.emit('files/download', {
        divisionId: $ctrl.divisionIds,
        fileName: fileName,
        pathData: JSON.stringify({
          memberId: $ctrl.member.id,
          trainingId: $ctrl.trainingData.id,
        }),
        storageIdent: 'memberTraining',
        ignoreDivPath: true,
      }, 'binary')
      .then(function(res) {
        var blobStore = new Blob([res], { type: mimeTypes[extension] });
        var data = window.URL.createObjectURL(blobStore);
        window.open(data);
      })
    }

    $ctrl.onFileDelete = function(revert) {
      if(revert) {
        // revert
        $ctrl.trainingData.File = $ctrl.trainingData.fileDelete;
        $ctrl.trainingData.fileDelete = null;
        $ctrl.fileChanged = false; 
      } else {
        // delete
        $ctrl.trainingData.fileDelete = $ctrl.trainingData.File;
        $ctrl.trainingData.File = null;
        $ctrl.fileChanged = true; 
      }
    }

    $ctrl.onUploadStarted = function() {
      $ctrl.fileUploadActive = true;
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watch('$trainingsEditCtrl.trainingData.vm.StartDate', function(newVal) {
        var training = $ctrl.trainingData;

        if (training) {
          var startDate = moment(newVal || null);
          if (startDate.isValid()) {
            $ctrl.endDatepicker.options.minDate = startDate.toDate();
          }
          else {
            delete $ctrl.endDatepicker.options.minDate;
          }
        }
      });

      var endDateWatcher = $scope.$watch('$trainingsEditCtrl.trainingData.vm.EndDate', function(newVal) {
        var training = $ctrl.trainingData;

        if (training) {
          // recheck if ValidityEndDate have been set meanwhile, if so then dont set and do unwatch
          if (training.ValidityEndDate) {
            // clear watchers, if they exist
            endDateWatcher && endDateWatcher();
            completionDateWatcher && completionDateWatcher();

            return;
          }

          setValidityEndDate(training, newVal);
        }
      });

      var completionDateWatcher = $scope.$watch(
        '$trainingsEditCtrl.trainingData.vm.CompletionDate', function(newVal) {
          var training = $ctrl.trainingData;

          if (training) {
            // recheck if ValidityEndDate have been set meanwhile, if so then dont set and do unwatch
            if (training.vm && training.vm.ValidityEndDate) {
              // clear watchers, if they exist
              endDateWatcher && endDateWatcher();
              completionDateWatcher && completionDateWatcher();
              return;
            }

            if (training && training.vm && training.vm.Graduation && training.vm.Graduation.mapping === 'SUCCEEDED') {
              setValidityEndDate(training, newVal);
            }
          }
        });
    }

    function formatTraining(training) {
      // init the validity helpers
      if (training) {
        training.vm = {
          Name: training.Name,
          Notes: training.Notes,
          Graduation: null,
          StartDate: training.StartDate ? moment(training.StartDate || null).toDate() : null,
          EndDate: training.EndDate ? moment(training.EndDate || null).toDate() : null,
          CompletionDate: training.CompletionDate ? moment(training.CompletionDate || null).toDate() : null,
          ValidityEndDate: training.ValidityEndDate ? moment(training.ValidityEndDate || null).toDate() : null,
          CountableHours: training.CountableHours || 0,
          BaseCategories: []
        };

        if (training.EndDate && !training.ValidityEndDate) {
          setValidityEndDate(training, training.EndDate);
        }

        var startDate = moment(training.StartDate || null);
        if (startDate.isValid()) {
          $ctrl.endDatepicker.options.minDate = startDate.toDate();
        }

        // presets the categories from $ctr.categories so the tag-picker can associate the chosen tags correctly
        // the BaseCategories in a TrainingTemplate object wont work, this is how the tag-picker currently work
        if (training.BaseCategories && training.BaseCategories.length) {
          _.forEach(training.BaseCategories, function(category, index) {
            // ARNO-1639 - fallback to category for display in org
            training.vm.BaseCategories[index] = _.find($ctrl.categories, { id: category.id }) || category;
          });
        }

        // preset graduation
        training.vm.Graduation = _.find($ctrl.TRAINING_GRADUATION_LIST, { mapping: training.Graduation});

        // preset completion-status
        training.vm.CompletionStatus = _.find($ctrl.TRAINING_COMPLETION_STATUS_LIST, { mapping: training.CompletionStatus});
      }
    }

    // HELPERS
    function setValidityEndDate(training, referenceDate) {
      if ((lastTrainingData || {}).ValidityEndDate === null && !training.vm.ValidityEndDate) {
        // was explicitly set to open end, should not automatically recalc to fixed end
        return;
      }

      var refDate = moment(referenceDate || null);

      if (!training || !training.TrainingTemplate || !refDate.isValid()
        || (!training.TrainingTemplate.ValidityPeriodDays && !training.TrainingTemplate.ValidityPeriodMonths && !training.TrainingTemplate.ValidityPeriodYears)
      ) {
        return;
      }

      training.vm.ValidityEndDate = refDate
        .add(training.TrainingTemplate.ValidityPeriodDays, 'day')
        .add(training.TrainingTemplate.ValidityPeriodMonths, 'month')
        .add(training.TrainingTemplate.ValidityPeriodYears, 'year')
        .toDate();
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }

    $ctrl.$doCheck = function() {
      // REMARK: check over the change-detection cycle of the component
      // $onChanges hook will not work for chained component-bindings
      // you could use this for deeper comparison, when need: if (!angular.equals($ctrl.trainingData, lastTrainingData)) {
      if ($ctrl.trainingData !== lastTrainingData) {
        lastTrainingData = $ctrl.trainingData;
        formatTraining($ctrl.trainingData);
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.statistics', [
    'BlurAdmin.pages.personnel.dossier.trainings.statistics.timeline',
    'BlurAdmin.pages.personnel.dossier.trainings.statistics.hourstable',
    'BlurAdmin.pages.personnel.dossier.trainings.statistics.qualificationstable'
  ])
    .controller('PersonnelDossierTrainingsStatisticsController', PersonnelDossierTrainingsStatisticsController);

  /**
  * @description Controller for the personnel-dossier-trainings module.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsStatisticsController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsStatisticsController(
    $scope, $state, $stateParams, $translate,
    ArnoDashTrainingsService,
    ctx, member, allTrainingsByTrainingTemplates, memberQualifications, qualificationsHierarchy
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };

    // VARS
    $ctrl.selectedCtx = ctx;
    $ctrl.member = member;

    $ctrl.allTrainingsByTrainingTemplates = allTrainingsByTrainingTemplates;

    $ctrl.memberQualifications = memberQualifications;
    $ctrl.qualificationsHierarchy = qualificationsHierarchy;

    $ctrl.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    }
    $ctrl.selectedEndDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    }

    // tables config
    $ctrl.allTrainingsTemplatesTableVisibleCols = {
      StartDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.startDateLabel'),
        value: true
      },
      EndDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.endDateLabel'),
        value: true
      },
      ValidityEndDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.validityEndDateLabel'),
        value: true
      },
      CompletionDate: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.completionDateLabel'),
        value: true
      },
      CountableHours: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.countableHoursLabel'),
        value: true
      },
      Status: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.stateLabel'),
        value: true
      },
      TrainingTemplate: {
        label: $translate.instant('modules.personnel.dossier.trainings.edit.trainingTemplateLabel'),
        value: true
      }
    }

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsStatisticsController#
    */
    function activate() {

      $ctrl.trainingsTemplateTableVisibleCols = _.cloneDeep($ctrl.allTrainingsTemplatesTableVisibleCols);
      // dont show the redundant col "Fortbildungsvorlage" for a certain training-template
      $ctrl.trainingsTemplateTableVisibleCols.TrainingTemplate.value = false;

      // create this
      $ctrl.initialTrainingTemplates = [];
      ArnoDashTrainingsService.setUniqTrainingTemplates($ctrl.initialTrainingTemplates, $ctrl.allTrainingsByTrainingTemplates);

      $ctrl.trainingTemplates = _.cloneDeep($ctrl.initialTrainingTemplates);

      setupWatchers();
    }

    // EVENT-HANDLERS
    $ctrl.back = function () {
      $state.go('arno.personnel.dossier.trainings.main', {
        recentTrainingsViewMode: $stateParams.recentTrainingsViewMode,
        lastSelectedNodeId: $stateParams.lastSelectedNodeId
      });
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watch('$trainingsStatisticsCtrl.selectedMinDate', function (newVal) {
        var selectedMinDate = moment(newVal || null);

        if (selectedMinDate.isValid()) {
          $ctrl.selectedEndDatepicker.options.minDate = selectedMinDate.toDate();
        }
        else {
          delete $ctrl.selectedEndDatepicker.options.minDate;
        }

        // update statistics/countable-hours data, if its not the initial assignment
        if ($ctrl.statisticsForm.$dirty) {
          refreshData();
        }
      });

      $scope.$watch('$trainingsStatisticsCtrl.selectedMaxDate', function () {
        // update statistics/countable-hours data, if its not the initial assignment
        if ($ctrl.statisticsForm.$dirty) {
          refreshData();
        }
      });
    }

    function refreshData() {
      var selectedMinDate = moment($ctrl.selectedMinDate || null);
      var selectedMaxDate = moment($ctrl.selectedMaxDate || null);

      var filterOptions = {};
      if (selectedMinDate.isValid()) {
        filterOptions.startDate = selectedMinDate.toDate();
      }

      if (selectedMaxDate.isValid()) {
        filterOptions.endDate = selectedMaxDate.toDate();
      }

      // Important: search by initial training-templates, not the determined ones from $ctrl.trainingsTemplates
      // the user wants to search trainings for the initial-trainings-templates he/she opened!
      // (e.g. by selection from dossier training table-panel)
      var trainingTemplatesIds = _.map($ctrl.initialTrainingTemplates, 'id');

      // update statistics-data
      ArnoDashTrainingsService.getMemberTrainingsByTrainingTemplate(
        ($ctrl.member || {}).id,
        $ctrl.selectedCtx,
        trainingTemplatesIds,
        filterOptions
      )
        .then(function (allTrainingsByTrainingTemplatesResults) {
          $ctrl.allTrainingsByTrainingTemplates = allTrainingsByTrainingTemplatesResults;

          // update training-templates from results
          $ctrl.trainingTemplates = [];
          ArnoDashTrainingsService.setUniqTrainingTemplates($ctrl.trainingTemplates, $ctrl.allTrainingsByTrainingTemplates);

          $ctrl.statisticsForm.$setPristine();
        });
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.helperHours', [])
    .controller('HelperHoursCtrl', HelperHoursCtrl);

  function HelperHoursCtrl(isPermittedOrOwn, $scope, toastr, clientApi, ctx, member, commonUtils, $translate,
    initData, $uibModal, baModalService, isOwnDossier, statisticalDataProvider, helperHoursStatisticData) {
    var self = this;
    var preservedTableParams
    var dateSpanModalVals;

    // show title on cells that are cut by ellipsis
    $(document).on('mouseenter', '.overflow-title', function () {
      var $t = $(this);
      var title = $t.attr('title');
      if (!title) {
        if (this.offsetWidth < this.scrollWidth) {
          $t.attr('title', $t.text())
        }
      } else {
        if (this.offsetWidth >= this.scrollWidth && title == $t.text()) {
          $t.removeAttr('title')
        }
      }
    });

    self.setPageSize = function(num) {
      self.itemsPerPage = commonUtils.getPageSize('helper_hours_dossier_page_size', num);
    }
    self.setPageSize();

    self.isPermittedOrOwn = isPermittedOrOwn;
    self.dossierCtx = ctx[0];

    self.statisticalDataProvider = statisticalDataProvider;
    self.helperHoursStatisticData = helperHoursStatisticData;
    self.collapseFilter = true;

    self.createNewRecord = function() {
      self.openEditModal()
        .then(function(res) {
          if (res) {
            self.submitHelperHours(res);
          }
        })
        .catch(function() {
          toastr.error($translate.instant('modules.helperHours.hours.aFailIsAppeared'), $translate.instant('modules.helperHours.hours.volunteersEntrysNoTracked'));
        })
    }

    self.editRecord = function(row) {
      self.openEditModal(row)
        .then(function(res) {
          if (res) {
            self.formatRecord(res);
            clientApi
              .custom('model/HelperHours', 'editHelperHours', {
                dataSet: res,
                cMemberId: member.id,
              })
              .then(function() {
                toastr.success($translate.instant('modules.helperHours.hours.volunteersEntryWasSuccessEdit'), $translate.instant('modules.helperHours.hours.editHelpHours'));
                self.reloadHelperHours();
                $scope.$broadcast('updateHelperHoursStatistic');
              })
              .catch(function() {
                toastr.error($translate.instant('modules.helperHours.hours.aFailIsAppeared'), $translate.instant('modules.helperHours.hours.dontEditHelpHours'));
              })
          }
        })
        .catch(function() {
          toastr.error($translate.instant('modules.helperHours.hours.aFailIsAppeared'), $translate.instant('modules.helperHours.hours.dontEditHelpHours'));
        })
    }

    self.deleteRecord = function(row) {
      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,

        title: $translate.instant('modules.helperHours.hours.requestedDelete'),
        content: $translate.instant('modules.helperHours.hours.requestedEntry') +
                 (row.Title ? (' "' + row.Title + '"') : '') +
                 $translate.instant('modules.helperHours.hours.requestedDeleteTwo'),

        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
        .then(function () {
          return clientApi.custom('model/HelperHours', 'deleteHelperHours', { id: row.id, divisionId: row.division && row.division.id })
            .then(function () {
              toastr.success($translate.instant('modules.helperHours.hours.entryWasSuccessRemoved'), $translate.instant('modules.helperHours.hours.deleteWasSuccess'));
              self.reloadHelperHours();
              $scope.$broadcast('updateHelperHoursStatistic');
            })
            .catch(function () {
              toastr.error($translate.instant('modules.helperHours.hours.entryCantRemoved'), $translate.instant('modules.helperHours.hours.deleteIsFailed'));
            });
        })
        .catch(function () {
          // mmk
        });
    }

    self.openEditModal = function(row) {
      return $uibModal
        .open({
          backdrop: 'static',
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/helperHours/modals/editHelperHours.html',
          size: 'lg',
          controller: 'HelperHoursEditCtrl as $modalCtrl',
          resolve: {
            member: function() {
              return member;
            },
            ctx: function() {
              return ctx;
            },
            row: function() {
              return row;
            },
            categories: function() {
              var tctx = JSON.parse(JSON.stringify(ctx));
              if (ctx && ctx[0] && ctx[0] === 'rootOrg') {
                tctx = [];
              }
              return clientApi.custom('model/BaseCategory', 'findOrgCategories', {
                divisionIds: tctx,
                usages: ['Event']
              });
            },
            memberDivisions: function() {
              var permittedDivs = ((((initData || {}).permissionsTree || {}).permissions || {}))['arno.personnel.dossier.helperHours.edit'];
              if (!permittedDivs && !isOwnDossier) {
                return [];
              }
              return clientApi
                .custom('model/DivisionMember', 'getAvailableDivisions', { cMemberId: member.id })
                .then(function(res) {
                  if (isOwnDossier) {
                    return res;
                  }
                  if (permittedDivs.Organization &&
                    !!~permittedDivs.Organization.indexOf(initData.organization.current.id)) {
                    // org level perm, return all divs
                    return res;
                  } else {
                    return _.intersectionWith(res, permittedDivs.Division, function(a, b) {
                      return a.id === b;
                    });
                  }
                })
            },
            activities: function() {
              var tctx = JSON.parse(JSON.stringify(ctx));
              if (ctx && ctx[0] && ctx[0] === 'rootOrg') {
                tctx = [];
              }
              return clientApi
                .custom('model/ActivityAllocation', 'getActivityHistoryForMember', {
                  cMemberId: member.id,
                  divisionIds: tctx,
                  includeActivityAllocationsDivInfo: true
                })
                .then(function(res) {
                  if (res && res.length) {
                    return res.filter(function(r) {
                      return r.calculatedState === 'ACTIVE';
                    })
                  }
                  return res;
                })
            },
          }
        })
        .result
        .catch(function(e) {
          if (e === 'escape key press') {
            return;
          }
          throw new Error(e);
        })
    }

    self.submitHelperHours = function(recordToSave) {
      self.formatRecord(recordToSave);
      clientApi
        .custom('model/HelperHours', 'addHelperHours', {
          dataSet: recordToSave,
          cMemberId: member.id,
        })
        .then(function() {
          toastr.success($translate.instant('modules.helperHours.hours.volunteerEntryWasSuccessTracked'), $translate.instant('modules.helperHours.hours.volunteersTracked'));
          self.reloadHelperHours();
          $scope.$broadcast('updateHelperHoursStatistic');
        })
        .catch(function() {
          toastr.error($translate.instant('modules.helperHours.hours.aFailIsAppeared'), $translate.instant('modules.helperHours.hours.volunteersEntrysNoTracked'));
        })
    }

    self.formatRecord = function(recordToSave) {
      if (recordToSave.activity && recordToSave.activity.id) {
        recordToSave.activityTitle = recordToSave.activity.Title;
        recordToSave.activity = recordToSave.activity.id;
      } else {
        recordToSave.activity = null;
      }

      if (recordToSave.categories) {
        recordToSave.categories = recordToSave.categories.map(function(c) { return c.id })
      }

      if (recordToSave.date) {
        if (recordToSave.dateStartTime) {
          recordToSave.dateStartTime = moment(recordToSave.date)
            .startOf('day')
            .minutes(moment((moment(recordToSave.dateStartTime).hours() * 60) + moment(recordToSave.dateStartTime).minutes()));
        }
        recordToSave.date = moment(recordToSave.date).dateOnly().toISOString();
      }
      if (recordToSave.dateEnd) {
        if (recordToSave.dateEndTime) {
          recordToSave.dateEndTime = moment(recordToSave.dateEnd)
            .startOf('day')
            .minutes(moment((moment(recordToSave.dateEndTime).hours() * 60) + moment(recordToSave.dateEndTime).minutes()));
        }
        recordToSave.dateEnd = moment(recordToSave.dateEnd).dateOnly().toISOString();
      }
    }

    self.reloadHelperHours = function(stTableParams) {
      if (!stTableParams && preservedTableParams) {
        stTableParams = preservedTableParams;
      }
      if (stTableParams) {
        var queryWishes = {
          paging: {
            offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.itemsPerPage || 0,
            limit: self.itemsPerPage
          },
          filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
          sort: {
            by: stTableParams.sort.predicate,
            reverse: stTableParams.sort.reverse
          }
        };
      }

      if (self.dateSpan) {
        queryWishes.startDate = moment(self.dateSpan.start).dateOnly().toISOString();
        queryWishes.endDate = moment(self.dateSpan.end).dateOnly().toISOString();
      } else if (self.daysInPast) {
        queryWishes.pastTimestamp = moment(Date.now() + 60000 * 60 * 24 * -self.daysInPast).dateOnly().toISOString();
      }

      preservedTableParams = stTableParams;

      return clientApi
        .custom('model/helperHours', 'fetchHelperHours', {
          cMemberId: member.id,
          divisionId: ctx[0],
          queryWishes: queryWishes,
          includeActivityAllocationsDivInfo: true
        })
        .then(function(res) {
          self.helperHours = res.rows;
          self.totalRows = res.count;
          self.totalTimeSpent = self.formatDuration(res.totalTimeSpent);
          if (stTableParams) {
            stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.itemsPerPage);
            if (res.count > 0 && res.rows.length === 0) {
              stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.itemsPerPage;
            }
          }
        })
    }

    self.formatDuration = function(minutes) {
      return minutes ? commonUtils.formatMinutesToHourString(minutes) : 0;
    }

    self.setColor = function(hex) {
      return {
        'background-color': hex,
        'color': commonUtils.getContrastLabelColor(hex)
      }
    }

    self.openDatespanModal = function() {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/setDatespanModal/setDateSpan.html',
          size: 'md',
          backdrop: 'static',
          controller: 'DatespanCtrl as $dateCtrl',
          resolve: {
            dateVals: dateSpanModalVals
          },
        })
        .result
        .then(function(res) {
          self.dateSpan = { start: res.start, end: res.end };
          dateSpanModalVals = { start: res.start, end: res.end };
          self.reloadHelperHours();
        })
        .catch(function() {
          //mmh k
        })
    }

    self.checkEditPermission = function(data) {
      // permit if the entry is from the user itself
      if (data.CreatedByMemberId === member.id) {
        return true;
      }

      return isPermittedOrOwn('arno.personnel.dossier.helperHours.edit', false, true);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.helperHours')
    .controller('HelperHoursEditCtrl', HelperHoursEditCtrl);

  /** @ngInject */
  function HelperHoursEditCtrl($scope, ctx, toastr, clientApi, $uibModalInstance, categories, memberDivisions,
    activities, member, row, $timeout, helperHoursService, $translate) {
    var self = this;

    self.dossierCtx = ctx[0];
    self.availableCategories = categories;
    self.availableDivisions = memberDivisions.concat([{
      id: null,
      Name: $translate.instant('generalTerms.none'),
    }]);
    if (activities && activities.length) {
      self.availableActivities = activities.concat([{
        id: null,
        Title: $translate.instant('generalTerms.none'),
      }]);
    } else {
      self.availableActivities = [];
    }
    self.disableActivities = false;
    self.datepickerStart = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'day',
        maxDate: moment(),
      }
    };
    self.datepickerEnd = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'day',
      }
    };
    self.setFormDiv = function() {
      if (ctx && ctx[0]) {
        if (ctx[0] !== 'rootOrg') {
          self.newRecord.division = _.find(self.availableDivisions, function(d) {
            return d.id === parseInt(ctx[0]);
          })
        } else if (member && member.MainDivision && member.MainDivision.id) {
          self.newRecord.division = _.find(self.availableDivisions, function(d) {
            return d.id === member.MainDivision.id;
          })
        }
      }
    }

    if (!row) {
      var today = new Date();
      today.setHours(0,0,0,0);
      self.newRecord = {
        date: today,
        hours: 1,
        minutes: 0,
      };
      self.setFormDiv();
    } else {
      self.newRecord = {
        date: new Date(row.ActivityStartDate),
        dateStartTime: row.ActivityStartTime ? new Date(row.ActivityStartTime) : undefined,
        dateEnd: row.ActivityEndDate ? new Date(row.ActivityEndDate) : undefined,
        dateEndTime: row.ActivityEndTime ? new Date(row.ActivityEndTime) : undefined,
        title: row.Title,
        note: row.Note,
        division: row.Division,
        activity: row.Activity,
        hours: Math.floor(row.ActivityMinutes / 60),
        minutes: row.ActivityMinutes % 60,
        categories: row.BaseCategories,
        id: row.id,
      };
      if (row.Activity) {
        self.newRecord.activity.Title = row.Activity.Title;
      }
    }

    ['dateStartTime', 'dateEndTime'].forEach(function(prop) {
      if (!self.newRecord[prop]) {
        self.newRecord[prop] = moment().startOf('day').add(12, 'hours').toDate();
        $timeout(function() {
          self.newRecord[prop] = undefined;
        }, 0);
      }
    })


    $scope.$watch(function() {
      return self.newRecord.division
    }, function(newVal) {
      if (newVal && newVal.id) {
        self.disableActivities = true;
        clientApi
          .custom('model/ActivityAllocation', 'getActivityHistoryForMember', {
            cMemberId: member.id,
            divisionIds: [newVal.id],
            includeActivityAllocationsDivInfo: true
          })
          .then(function(res) {
            if (res && res.length) {
              return res.filter(function(r) {
                return r.calculatedState === 'ACTIVE';
              })
            }
            return res;
          })
          .then(function(res) {
            if (res) {
              self.availableActivities = res.concat([{
                id: null,
                Title: 'Keine',
              }]);
            } else {
              self.availableActivities = [];
            }
            if (self.newRecord.activity) {
              var currAct = _.find(self.availableActivities, function(a) {
                return a.id === self.newRecord.activity.id;
              })
              if (!currAct) {
                self.newRecord.activity = null;
              }
            }
            self.disableActivities = false;
          })
      }
    });

    self.allTimespanFieldsRequired = false;
    $scope.$watch(function () {
      return (self.newRecord.dateStartTime || self.newRecord.dateEnd || self.newRecord.dateEndTime)
    }, function(newVal) {
      self.allTimespanFieldsRequired = newVal;
    });

    self.isValidDate = function () {
      return helperHoursService.isValidDate(self.newRecord);
    };

    $scope.$watch(function () {
      return !self.newRecord.id
             && ((self.submitHoursForm || {}).inputHours || {}).$pristine
             && ((self.submitHoursForm || {}).inputMinutes || {}).$pristine
    }, function(newVal) {
      self.shouldUpdateHelperHoursOnTimeChange = newVal;
    });

    self.automaticHHCalculation = false;
    $scope.$watch(function() {
      if (!self.shouldUpdateHelperHoursOnTimeChange) {
        return false;
      }
      var effective = helperHoursService.fetchEffectiveStartEndDateTime(self.newRecord);
      if (effective.endDateTime) {
        var duration = moment.duration(moment(effective.endDateTime).diff(moment(effective.startDateTime))).asMinutes();
        return (duration > 0 && duration < (24 * 60)) ? duration : false;
      }
      return false;
    }, function(newVal) {
      self.automaticHHCalculation = !!newVal;
      if (newVal) {
        self.newRecord.hours = Math.floor(newVal / 60);
        self.newRecord.minutes = newVal % 60;
      }
    });

    self.isValidHelperHour = function() {
      return (parseInt(self.newRecord.hours, 10) > 0 || parseInt(self.newRecord.minutes, 10) > 0) && helperHoursService.isValidDuration(self.newRecord);
    };

    self.applyModal = function() {
      $uibModalInstance.close(self.newRecord);
    }

    self.setDirty = function() {
      if (self.submitHoursForm.$invalid) {
        angular.forEach(self.submitHoursForm.$error, function (field) {
          angular.forEach(field, function(errorField) {
            errorField.$setDirty();
          })
        });
      }
    }
  }
})();

/**
 * @author ARNO-Team
 * created 02/15/2019
 */
(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoPersonnelDossierBaseDataLanguages
  *
  * @description Component provides an interface with an ngjs ui-select field to select languages and display them in a list for editing
  */
  angular.module('BlurAdmin.pages.personnel.dossier.basedata.languages', [])
    .component('arnoPersonnelDossierBasedataLanguages', {
      templateUrl: 'app/pages/personnel/dossier/baseData/components/languageSelection.comp.html',
      controller: PersonnelDossierBaseDataLanguagesController,
      controllerAs: '$baseDataLanguages',
      bindings: {
        languageSkills: '=',
        languagesCatalogue: '<',
        viewOnly: '<?'
      }
    });

      /**
  * @description Controller for the personnel-dossier-basedata languages-component
  *
  * @namespace BlurAdmin.pages.personnel.dossier.basedata.PersonnelDossierBaseDataLanguagesController
  */
  /** @ngInject */
  function PersonnelDossierBaseDataLanguagesController(
    ARNO_CONSTANTS,
    $scope
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.MEMBER_LANGUAGES_LEVEL = ARNO_CONSTANTS.GENERAL.LANGUAGES_LEVEL;

    // BOOTSTRAPPER
    function activate() {
      $ctrl.MEMBER_LANGUAGES = $ctrl.languagesCatalogue;

      $ctrl.languageSkills = $ctrl.languageSkills || [];

      setupWatchers();
    }

    // EVENT-HANDLERS
    self.tagTransform = function(newTitleTag) {
      if (typeof newTitleTag === 'string' && newTitleTag.trim() === '') {
        return undefined;
      }

      return {
        Name: newTitleTag,
        mapping: newTitleTag
      };
    }

    $ctrl.addMemberLanguage = function()  {
      if (!_.find($ctrl.languageSkills, $ctrl.selectedMemberLanguage)) {
        $ctrl.languageSkills.push(_.merge({
          vm: {
            Name: $ctrl.selectedMemberLanguage.Name,
            mapping: $ctrl.selectedMemberLanguage.mapping,
            Level: ''// REMARK: add another default language-level here if needed, e.g. $ctrl.MEMBER_LANGUAGES_LEVEL[0]
          }
        }, $ctrl.selectedMemberLanguage));
      }
    }

    $ctrl.removeMemberLanguage = function(memberLanguage, event)  {
      event.stopPropagation();

      _.remove($ctrl.languageSkills, { vm: { mapping: memberLanguage.vm.mapping }});
    }

    // VIEW-FUNCTIONS
    $ctrl.getMemberLanguages = function() {
      return _.filter($ctrl.MEMBER_LANGUAGES, function(catalogueLanguage) {
        return !($ctrl.languageSkills && _.find($ctrl.languageSkills, function(languageSkill) {
          if (languageSkill && languageSkill.vm && languageSkill.vm.Name
            && languageSkill.vm.Name.toLowerCase() === catalogueLanguage.Name.toLowerCase()
          ) {
            return true;
          }
        }));
      });
    }

    $ctrl.tagTransform = function(newTitleTag) {
      if (typeof newTitleTag === 'string' && newTitleTag.trim() === '') {
        return undefined;
      }

      return {
        Name: newTitleTag,
        mapping: newTitleTag
      };
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watch('$ctrl.languageSkills', function() {
        formatLanguageSkills($ctrl.languageSkills);
      }, true);
    }

    function formatLanguageSkills(languageSkills) {
      _.forEach(languageSkills, function(language) {
        language.vm = language.vm || {};

        var foundLanguage = _.find($ctrl.MEMBER_LANGUAGES, { mapping: language.Alpha2Code });
        language.vm.Name = (foundLanguage || {}).Name || language.Alpha2Code;
        language.vm.mapping = (foundLanguage || {}).mapping || language.Alpha2Code;

        language.vm.Level = _.find($ctrl.MEMBER_LANGUAGES_LEVEL, { mapping: language.Level }) || { Name: language.Level, mapping: language.Level };
      });
    }

    // INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

/**
 * @author ARNO-Team
 * created 02/15/2019
 */
(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoPersonnelDossierBaseDataEmergencyContacts
  *
  * @description Component provides an interface with an ngjs ui-select field to select emergency-contacts and display them in a list for editing
  */
  angular.module('BlurAdmin.pages.personnel.dossier.basedata.emergencycontacts', [])
    .component('arnoPersonnelDossierBasedataEmergencyContacts', {
      templateUrl: 'app/pages/personnel/dossier/baseData/components/emergencyContacts.comp.html',
      controller: PersonnelDossierBaseDataEmergencyContactsController,
      controllerAs: '$baseDataEmergencyContacts',
      bindings: {
        emergencyContacts: '=',
        formRef: '<?',
        viewOnly: '<?'
      }
    });

      /**
  * @description Controller for the personnel-dossier-basedata emergency-contacts-component
  *
  * @namespace BlurAdmin.pages.personnel.dossier.basedata.PersonnelDossierBaseDataEmergencyContactsController
  */
  /** @ngInject */
  function PersonnelDossierBaseDataEmergencyContactsController(
    $scope, $uibModal, $translate,
    baModalService
  ) {
    var $ctrl = this;

    // BOOTSTRAPPER
    function activate() {
      $ctrl.emergencyContacts = $ctrl.emergencyContacts || [];

      setupWatchers();

      _.forEach($ctrl.emergencyContacts, function (contact) {
        if (contact.PrivacyTermsDeliveredDateTime == null) {
          $ctrl.NoEmergencyContactTerms = true;
        }
      });
    }

    // EVENT-HANDLERS
    $ctrl.addNewEmergencyContact = function(emergencyContact) {
      $ctrl.openEmergencyContactModal(emergencyContact)
        .then(function (addedContact) {
          $ctrl.emergencyContacts.push(addedContact);

          $ctrl.formRef.$setDirty();
        });
    }

    $ctrl.editEmergencyContact = function(emergencyContact) {
      $ctrl.openEmergencyContactModal(emergencyContact)
        .then(function (editContact) {
          emergencyContact = _.merge(emergencyContact, editContact);
          emergencyContact.changed = true;

          $ctrl.formRef.$setDirty();
        });
    }

    $ctrl.removeEmergencyContact = function(emergencyContact) {
      var name = '';

      emergencyContact.FirstName && (name += emergencyContact.FirstName);
      emergencyContact.LastName && (name += ' ' + emergencyContact.LastName);

      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,

        title: $translate.instant('modules.personnel.dossier.baseData.emergencyContactTableHeader.removeContactModalTitle'), 
        content: $translate.instant('modules.personnel.dossier.baseData.emergencyContactTableHeader.removeContactModalTitle', { contact: name.trim() }),

        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
        .then(function () {
          // because there is no id for the emergency-contacts, object-ref has to be taken to remove elements
          $ctrl.emergencyContacts = _.remove($ctrl.emergencyContacts, function(contact) {
            return !(contact == emergencyContact);
          });

          $ctrl.formRef.$setDirty();
        });
    }

    // HELPERS
    $ctrl.openEmergencyContactModal = function(contact) {
      return $uibModal.open({
        controller: 'EmergencyContactModalCtrl as $emergencyContactCtrl',
        animation: true,
        backdrop: 'static',
        size: 'md',
        resolve: {
          emergencyContact: function() {
            return _.cloneDeep(contact);
          },
          viewOnly: function() {
            return $ctrl.viewOnly;
          }
        },
        templateUrl: 'app/pages/personnel/dossier/baseData/emergencyContactModal/emergencyContactModal.tpl.html'
      }).result;
    }

    // HELPERS
    function setupWatchers() {
      $scope.$watch('$ctrl.emergencyContacts', function() {
        formatEmergencyContacts($ctrl.emergencyContacts);
      }, true);
    }

    function formatEmergencyContacts(contacts) {
      _.forEach(contacts, function(contact) {
        contact.address = {
          ZIP: contact.ZipCode,
          City: contact.City,
          Street: contact.Street,
          HouseNumber: contact.HouseNumber,
          AddressAffix: contact.AddressAffix,
        }
      });
    }

    // INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.overview', [])
    .controller('PersonnelDossierOverviewCtrl', PersonnelDossierOverviewCtrl);

  function PersonnelDossierOverviewCtrl(
    ARNO_CONSTANTS,
    $state, $rootScope, member, userQualifications, activityHistory,
    characteristicMap, activityFulfillmentStates, permissions, ctx, approvalProcesses,
    isPermitted, isPermittedOrOwn, isOrgScope, allActivityFulfillmentStates, trainingCategories,
    permittedToStartAnyClearance, tableConfig, clientApi
  ) {
    var self = this;
    self.ctx = ctx;
    self.tableConfig = tableConfig;
    self.trainingCategories = trainingCategories;
    // CONSTS
    self.MEMBER_TYPES_LABELS = ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_TYPES_LABELS;
    self.MEMBER_STATUS_LABELS = ARNO_CONSTANTS.GENERAL.MEMBER_STATUS_LABELS;
    self.MEMBER_TITLES = ARNO_CONSTANTS.GENERAL.MEMBER_TITLE_LABELS;

    self.SALUTATION_LABELS = ARNO_CONSTANTS.GENERAL.SALUTATION_LABELS;
    // VARS
    self.isOrgScope = isOrgScope;
    self.permittedToStartAnyClearance = permittedToStartAnyClearance;

    self.userQualifications = userQualifications;
    self.backToPersonnelList = $rootScope.backToPersonnelList;
    self.activityHistory = activityHistory;
    self.member = member;
    self.divisionIds = ctx;
    self.allActivityFulfillmentStates = allActivityFulfillmentStates;
    self.activityFulfillmentStates = activityFulfillmentStates;
    self.approvalProcesses = approvalProcesses;
    self.account = self.member.Account;
    self.activityStates = [
      { title: 'Aktive Tätigkeitszuweisungen', state: 'ACTIVE' },
      { title: 'Inaktive Tätigkeitszuweisungen', state: 'INACTIVE' },
      { title: 'Ausstehende Tätigkeitszuweisungen', state: 'PENDING' }
    ];
    self.open = function (path) {
      $state.go(path, { backToOverview: true });
    };

    self.activityHistoryByGroup = [];
    for (var i = 0; i < self.activityHistory.length; i++) {
      self.activityHistoryByGroup[self.activityHistory[i].ActivityGroup.id] = self.activityHistoryByGroup[self.activityHistory[i].ActivityGroup.id] || {
        activityGroupId: self.activityHistory[i].ActivityGroup.id,
        activityGroupTitle: self.activityHistory[i].ActivityGroup.Title,
        activityAllocations: [],
      };
      for (var j = 0; j < self.activityHistory[i].ActivityAllocations.length; j++) {
        self.activityHistory[i].ActivityAllocations[j].activity = self.activityHistory[i];
        self.activityHistoryByGroup[self.activityHistory[i].ActivityGroup.id].activityAllocations.push(self.activityHistory[i].ActivityAllocations[j]);
      }
    }
    self.activityHistoryByGroup = _.compact(self.activityHistoryByGroup);

    self.profilePictureData = {
      initials: self.member.initials,
      id: self.member.id,
      ctx: ctx,
      profilePic: self.member.MemberAvatar,
      eMailHash: self.account && self.account.eMailHash
    };
    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'year',
      }
    };

    self.isPermitted = isPermitted;
    self.isPermittedOrOwn = isPermittedOrOwn;

    self.back = function () {
      $state.go('arno.personnel.personnelList');
    };

    self.exportVCard = function () {
      clientApi.openTab('personnel/getVCard', {
        MemberEmail: member.Account.EMail,
        DivisionId: (member.DivisionId ? member.DivisionId : ctx),
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.overview')
    .controller('profilePicModalCtrl', profilePicModalCtrl)
    .directive('fileDropzone', fileHandlerDirective);

  /** @ngInject */
  function profilePicModalCtrl($uibModalInstance, $translate, baModalService, member, ctx, $scope, toastr, clientApi, FileUploader, parentCtrl, divisionIds) {
    // create context for api calls
    $scope.member = member;
    $scope.dossierOwnerId = $scope.member.id;

    // load current profile picture if present
    $scope.getProfileImage = function(id) {
      return clientApi.emit('avatarStorage/get', {
        dossierOwnerId: id,
      })
      .then(function(data) {
        return data.imagedata
      })
      .catch(function(err) {
        console.error(err);
        return 'noimage';
      });
    }

    // initiate edit procedure
    $scope.setSelectState = function() {
      //dialog states: initial, crop, confirmed
      $scope.state = 'select';
      $scope.imageloaded = false;
      $scope.containerClass = '';
      $scope.fileName = '';

      //original image data
      $scope.imagedata = '';

      //cropped Imagedata; base64 & local blob
      $scope.blobUrl = '';
      $scope.croppedImage = '';
    }

    // load current profile picture if present else start edit mode
    if ($scope.member.MemberAvatar) {
      $scope.getProfileImage(
        $scope.member.id
      )
      .then(function(img) {
        if (img !== 'noimage') {
          $scope.currentImage ='data:image/jpeg;base64, ' + img;
        }
      });
      $scope.state = 'initial';
    } else {
      $scope.setSelectState();
    }

    // remove selected image in edit mode
    $scope.removePendingImage = function() {
      $scope.setSelectState();
      $scope.bindClickHandler();
    }

    // remove saved profile picture permanently
    $scope.removeCurrentImage = function() {
      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.personnel.dossier.baseData.profilePicModal.removeModalTitle'),
        content: $translate.instant('modules.personnel.dossier.baseData.profilePicModal.removeModalContentLine1')
                  + '\n\n' +
                  $translate.instant('modules.personnel.dossier.baseData.profilePicModal.removeModalContentLine2'),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
      .then(function () {
        return clientApi.emit('avatarStorage/remove', {
          dossierOwnerId: $scope.dossierOwnerId,
          divisionIds: divisionIds,
        })
        .then(function() {
          $scope.$evalAsync(function() {
            $scope.setSelectState();
            if ($scope.dossierOwnerId === $scope.$root.ctx.currentUser.id) {
              $scope.$root.ctx.currentUser.profilePic = null;
            }
            parentCtrl.profilePictureData.profilePic = null;
            $scope.member.MemberAvatar = null;
            $scope.bindClickHandler();
            toastr.success(
              $translate.instant('modules.personnel.dossier.baseData.profilePicModal.deletePicSuccToastText'),
              $translate.instant('modules.personnel.dossier.baseData.profilePicModal.deletePicSuccToastTitle')
            );
          });
        })
        .catch(function(err) {
          console.error(err);
          toastr.error(
            $translate.instant('modules.personnel.dossier.baseData.profilePicModal.deletePicErrToastText'),
            $translate.instant('modules.personnel.dossier.baseData.profilePicModal.deletePicErrToastTitle')
          );
        });
      });
    }

    // bind click Event to dropzone; map to invisible file-input
    $scope.bindClickHandler = function() {
      angular.element(document.querySelector('.dropzone-container')).bind('click', function() {
        var input = angular.element(document.querySelector('#profilepicture-fileinput'));
        input[0].click();
      });
    }

    $scope.setState = function(newState) {
      $scope.state=newState;
    }

    // ng-fileuploader config
    $scope.uploaderConfig = clientApi.fileUploaderConfig({
      queueLimit: 1,
      url: '/api/avatarStorage/upload',
      onBeforeUploadItem: function (item) {
        item.formData.push({
          dossierOwnerId: $scope.dossierOwnerId,
          divisionIds: divisionIds,
        });
      },
      onSuccessItem: function() {
        $scope.uploader.clearQueue();
        toastr.success(
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicSuccToastText'),
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicSuccToastTitle')
        );
        $uibModalInstance.dismiss();
        $scope.$evalAsync(function() {
          if ($scope.dossierOwnerId === $scope.$root.ctx.currentUser.id) {
            $scope.$root.ctx.currentUser.profilePic = $scope.fileName;
          }
          parentCtrl.profilePictureData.profilePic = $scope.fileName;
          $scope.member.MemberAvatar = $scope.fileName;
        });
      },
      onErrorItem: function(err) {
        console.error(err);
        toastr.success(
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicErrToastText'),
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicErrToastTitle')
        );
        $scope.uploader.clearQueue();
        $uibModalInstance.dismiss();
      },
      onWhenAddingFileFailed: function (item) {
        // ensure that only a single file (the last one added) is in the queue
        $scope.uploader.clearQueue();
        $scope.uploader.addToQueue(item);
      },
    });

    $scope.uploader = new FileUploader($scope.uploaderConfig);

    $scope.onSubmit = function() {
      if ($scope.blobUrl) {
        //fetch blob url and save image va ng-fileuploader
        fetch($scope.blobUrl)
        .then(function(response) {
          return response.blob()
        })
        .then(function(blob) {
          var fileName = ''
            + $scope.member.FirstName.charAt(0).toLowerCase()
            + $scope.member.LastName.charAt(0).toLowerCase()
            + '_' + Date.now()
            + '.jpg';
          $scope.fileName = fileName;
          var image = new File([blob], fileName, {'type': blob.type});
          $scope.uploader.addToQueue(image);
          $scope.uploader.queue.forEach(function(fileToUpload) {
            fileToUpload.upload();
          });
        })
        .catch(function(err) {
          console.error(err)
        });
      } else {
        // ensure that cropped image data is present
        toastr.warning(
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicWarnToastText'),
          $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicWarnToastTitle')
        );
      }
    }

    $scope.throwSizeError = function(maxFileSize) {
      toastr.error(
        $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicSizeErrToastText', { size: maxFileSize }),
        $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicSizeErrToastText')
      );
    }

    $scope.throwFormatError = function() {
      toastr.error(
        $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicFormatErrToastText'),
        $translate.instant('modules.personnel.dossier.baseData.profilePicModal.uploadPicFormatErrToastTitle')
      );
    }
  }

  /** @ngInject */
  function fileHandlerDirective() {
    return {
      restrict: 'A',
      scope: {},
      link: function(scope, element, attrs) {
        var ctrl = scope.$parent;
        var checkSize, isTypeValid, validMimeTypes;
        validMimeTypes = attrs.fileDropzone;

        checkSize = function(size) {
          var _ref;
          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) < attrs.maxFileSize) {
            return true;
          } else {
            //throw error on file size
            ctrl.throwSizeError(attrs.maxFileSize);
            return false;
          }
        };

        isTypeValid = function(type) {
          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
            return true;
          } else {
            //throw error on file type
            ctrl.throwFormatError();
            return false;
          }
        };

        // handler to read and check the uploaded image data
        var checkAndReadFile = function(inputfile) {
          if (inputfile !== undefined) {
            var reader = new FileReader();
            ctrl.imageloaded = false;
            reader.onload = function(evt) {
              if (checkSize(inputfile.size) && isTypeValid(inputfile.type)) {
                // unbind click event after image is selected to prevent element focus malfunctions while cropping
                element.unbind('click');
                scope.$apply(function() {
                  ctrl.imageloaded = true;
                  ctrl.containerClass = '';
                  ctrl.imagedata = evt.target.result;
                  ctrl.state = 'crop';
                });
              }
            };
            reader.readAsDataURL(inputfile);
          }
        }

        //bind drag, drop, click, change Events to dropzone
        element
        .bind('dragover', function (e) {
          e.stopPropagation();
          e.preventDefault();
          e.originalEvent.dataTransfer.dropEffect = 'copy';
        })
        .bind('dragenter', function(e) {
          e.stopPropagation();
          e.preventDefault();
          scope.$apply(function() {
            ctrl.containerClass = 'on-drag-enter';
          });
        })
        .bind('dragleave', function(e) {
          e.stopPropagation();
          e.preventDefault();
          scope.$apply(function() {
            ctrl.containerClass = '';
          });
        })
        .bind('drop', function(event) {
          if (event != null) {
            event.preventDefault();
          }
          checkAndReadFile(event.originalEvent.dataTransfer.files[0])
        });

        ctrl.bindClickHandler();

        angular.element(document.querySelector('#profilepicture-fileinput')).on('change', function(evt) {
          checkAndReadFile(evt.currentTarget.files[0])
        });

        return element;
      }
    }
  }
})();




/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.baseData', [
      'BlurAdmin.pages.personnel.dossier.basedata.languages',
      'BlurAdmin.pages.personnel.dossier.basedata.emergencycontact.modal',
      'uiCropper'
    ])
    .controller('PersonnelDossierBaseDataCtrl', PersonnelDossierBaseDataCtrl)
    .filter('asTel', function () {
      return function (number) {
        var tel = number.toString().replace(/[^0-9]/g, '');
        if (!tel) {
          return 'javascript:void(0)';
        }
        return 'tel:' + tel;
      };
    });

  function PersonnelDossierBaseDataCtrl(
    $rootScope, $scope, member, $uibModal, $translate, clientApi, toastr, stateChangePrompt, validationUtils,
    $state, permissions, ctx, commonUtils, $timeout, $stateParams, ArnoDashAdminMembersService,
    CAT_MEMBER_COUNTRY_IDS, CAT_MEMBER_NATIONALITIES, CAT_MEMBER_LANGUAGES,
    isOrgScope, isOwnDossier, hasAllowedAge, isADUser, privacyTermsChannelMap, memberDivisions, memberStatus, memberTypes, ARNO_CONSTANTS, sensitiveData
  ) {
    var self = this;

    // LIBS VIEW-BINDINGS
    self.moment = moment;

    // CONSTS
    self.MEMBER_STATUSES = memberStatus;
    self.MEMBER_TYPES = memberTypes;

    self.MEMBER_SALUTATIONS = ARNO_CONSTANTS.GENERAL.SALUTATION;
    self.MEMBER_GENDERS = ARNO_CONSTANTS.GENERAL.GENDER;
    self.MEMBER_CONFESSIONS = ARNO_CONSTANTS.GENERAL.CONFESSION;

    self.MEMBER_TITLES = ARNO_CONSTANTS.GENERAL.MEMBER_TITLES;

    self.MEMBER_COUNTRY_IDS = CAT_MEMBER_COUNTRY_IDS;
    self.MEMBER_NATIONALITIES = CAT_MEMBER_NATIONALITIES;
    self.MEMBER_LANGUAGES = CAT_MEMBER_LANGUAGES;
    // VARS
    self.isOrgScope = isOrgScope;

    self.isADUser = isADUser;

    self.privacyTermsChannelMap = privacyTermsChannelMap;
    self.moment = moment;

    self.backToOverview = $stateParams.backToOverview;
    self.backToPersonnelList = $rootScope.backToPersonnelList;
    self.member = _.cloneDeep(member);
    self.sensitiveData = sensitiveData;
    self.member.BirthDate = commonUtils.UTCDateOnlyToLocal(member.BirthDate);
    self.accountTransform = false;
    self.availableDivs = memberDivisions.concat({ id: null, Name: $translate.instant('generalTerms.none') });
    self.choosenEmployerActivities;

    if (self.member.DivisionMembers && self.member.DivisionMembers.length) {
      self.divisionMember = self.member.DivisionMembers[0];
    }

    self.account = self.member.Account;

    self.organizationId = $rootScope.ctx.organization.current.id;
    self.divisionIds = _.cloneDeep(ctx);

    if (ctx.indexOf('rootOrg') > -1) {
      self.divisionIds.splice(ctx.indexOf('rootOrg'), 1);
    }

    self.EmployerActivities = [
      {
        Name: $translate.instant('models.Member.EmployerActivitiesAidOrganizationInDisasterControl'),
        Value: 'AidOrganizationInDisasterControl'
      },
      {
        Name: $translate.instant('models.Member.EmployerActivitiesFireDepartment'),
        Value: 'FireDepartment'
      },
      {
        Name: $translate.instant('models.Member.EmployerActivitiesTechnicalAidOrganization'),
        Value: 'TechnicalAidOrganization'
      },
      {
        Name: $translate.instant('models.Member.EmployerActivitiesReservist'),
        Value: 'Reservist'
      },
      {
        Name: $translate.instant('models.Member.EmployerActivitiesKritis'),
        Value: 'Kritis'
      },
      {
        Name: $translate.instant('models.Member.EmployerActivitiesOther'),
        Value: 'Other'
      }
    ];

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'year',
        maxDate: moment(),
      },
      helperIdValidOptions: {
        showWeeks: false,
        datepickerMode: 'year',
      },
    };

    self.memberAddressCompFieldsConfig = {
      countryId: {
        required: true
      },
      zipCode: {
        required: true
      },
      city: {
        required: true
      },
      street: {
        required: true
      },
      houseNumber: {
        required: true
      }
    };
    self.memberAddressCompUiConfig = {
      firstRow: {
        cssCls: 'row'
      },
      secondRow: {
        cssCls: 'row'
      },

      countryId: {
        wrapperCssCls: 'col-sm-3'
      },
      zipCode: {
        wrapperCssCls: 'col-sm-3'
      },
      city: {
        wrapperCssCls: 'col-sm-6'
      },
      street: {
        wrapperCssCls: 'col-sm-6'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-6'
      },
      addressAffix: {
        wrapperCssCls: 'col-sm-12'
      },
    };

    self.memberEmployerAddressCompFieldsConfig = {
      countryId: {
        show: false
      },
      addressAffix: {
        show: false
      }
    };

    self.memberEmployerAddressCompUiConfig = {
      countryId: {
        show: false
      },
      zipCode: {
        wrapperCssCls: 'col-sm-2 col-md-2'
      },
      city: {
        wrapperCssCls: 'col-sm-4 col-md-4'
      },
      street: {
        wrapperCssCls: 'col-sm-4 col-md-4'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-2 col-md-2'
      },
      addressAffix: {
        show: false
      },
    };

    self.ownDossier = false;
    self.banktransfer = self.banktransfer = (self.member.BankAccount || self.member.BankBIC || self.member.BankIBAN) ? 'transfer' : 'cash';
    if ($rootScope.ctx.currentUser.id === self.member.id) {
      self.ownDossier = true;
    }

    self.changeDetectCompare = '';

    // init toggle sections, collapse some sections by default
    self.toggleSection = {
      profession: true,
      emergency: true,
      languages: true,
      misc: true,
      banking: true,
      legal: true,
    };
    self.toggleSectionSkip = {};

    self.fetchChanges = function () {
      return JSON.stringify([self.member, self.divisionMember], function (key, value) {
        // ARNO-1685 we cannot track ba-address or inner workings of basedata-languages due to timely variations in model changes
        if (~['$$hashKey', 'CountryId', 'address', 'vm'].indexOf(key)) {
          return undefined;
        }
        return value;
      });
    };
    self.setAsChangeCompare = function () {
      self.changeDetectCompare = self.fetchChanges();
      if (self.member.PrivacyAcceptedLocation) {
        self.comparePrivacyLocation = self.member.PrivacyAcceptedLocation;
      }
    };

    // BOOTSTRAPPER
    function activate() {
      formatMemberData(self.member);
      formatDivisionMemberData(self.divisionMember);
      self.setAsChangeCompare();
    }

    self.hasChanges = function () {
      return self.changeDetectCompare !== self.fetchChanges();
    };

    stateChangePrompt.evaluate(function () {
      return !self.hasChanges();
    });

    self.back = function () {
      $state.go('arno.personnel.personnelList');
    };

    self.backOverview = function () {
      $state.go('arno.personnel.dossier.overview');
    };

    self.profilePictureData = {
      initials: self.member.initials,
      id: self.member.id,
      ctx: ctx,
      profilePic: self.member.MemberAvatar,
      eMailHash: self.account && self.account.eMailHash
    };

    self.openProfilePicEditor = function () {
      if (self.canEdit || self.canEditOwn) {
        $uibModal.open({
          controller: 'profilePicModalCtrl as $profilePicModalCtrl',
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/baseData/profilePicModal/profilePicModal.html',
          size: 'md',
          windowClass: 'profile-pic-editor-modal',
          resolve: {
            divisionIds: function () {
              return self.divisionIds;
            },
            member: function () {
              return member;
            },
            ctx: function () {
              return ctx;
            },
            parentCtrl: self
          }
        });
      }
    };

    self.changeEMail = function () {
      $uibModal.open({
        controller: 'changeEMailCtrl as $eMailCtrl',
        animation: true,
        backdrop: 'static',
        size: 'md',
        resolve: {
          ctx: function () {
            return ctx;
          },
          organizationId: function () {
            return self.organizationId;
          }
        },
        templateUrl: 'app/pages/personnel/dossier/baseData/changeEMailModal/changeEMail.html'
      })
        .result.then(function (result) {
          if (result.newEMail) {
            self.account.EMail = result.newEMail;
            toastr.info($translate.instant('modules.personnel.dossier.baseData.changeMemberToastText'),
              $translate.instant('modules.personnel.dossier.baseData.changeMemberToastTitle'));
          }
        });
    };

    self.updateBaseData = function () {
      if (self.banktransfer === 'cash') {
        self.member.BankAccount = null;
        self.member.BankIBAN = null;
        self.member.BankBIC = null;
      }

      if (self.comparePrivacyLocation !== self.member.PrivacyAcceptedLocation) {
        self.member.logPrivacyLocationChange = true;
      }

      self.actionInProgress = true;
      var updateObj = _.cloneDeep(self.member);
      delete updateObj.MemberAvatar;

      return ArnoDashAdminMembersService.updateMemberWithNotifications(self.divisionIds, updateObj, self.divisionMember)
        .then(function () {
          if (self.isPermitted('arno.personnel.dossier.baseData.sensitiveData.manage') || self.ownDossier) {
            return clientApi.custom('model/Member', 'setSensitiveData',
              { cMemberId: updateObj.id, sensitiveData: self.sensitiveData, divIds: self.divisionIds });
          }
          return null;
        })
        .then(function () {
          // IMPORTANT: reload state to avoid issues with ui-fields sync. E.g. for later Change-Requests and feature-change-iterations,
          // because a lot of data has to be remapped to be used in the ui-select/tag-pickers/and other components
          stateChangePrompt.disableEvaluation();
          $state.reload();
        })
        .catch(function () {
          stateChangePrompt.disableEvaluation();

          $state.reload();
        })
        .finally(function () {
          self.actionInProgress = false;
        });
    };

    self.validIBAN = commonUtils.validation.iban;
    self.validBIC = commonUtils.validation.bic;

    self.hasError = function () {
      $timeout(function () {
        if (self.baseDataForm && !self.baseDataForm.$valid) {
          var errorElements = document.getElementsByClassName('has-error');
          $(errorElements).each(function () {
            try {
              var sectionRef = $(this).parents('[toggle-next] + .row').prev().attr('toggle-next');
              sectionRef = sectionRef.split('.');
              sectionRef = sectionRef[sectionRef.length - 1];
              if (sectionRef) {
                // open that ref, skip the animation
                self.toggleSectionSkip[sectionRef] = true;
                self.toggleSection[sectionRef] = false;
              }
            } catch (e) {
              // hm k
            }
          });

          // wait for sections to open
          $timeout(function () {
            var scrollElement = $('html').eq(0);
            // if there is an error element scroll to it
            if (errorElements[0]) {
              // wait for sections to open
              scrollElement.animate({
                scrollTop: $(errorElements[0]).eq(0).offset().top
              }, 250);
            }
          }, 0, false);
        }
      }, 100, true);
    };

    self.isPermitted = function (action, onlyDiv) {
      if (ctx[0] === 'rootOrg') {
        if (onlyDiv) {
          return false;
        }
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id]);
      }
      return permissions.isPermittedInEvery(action, 'Division', ctx);
    };

    self.canEdit = self.isPermitted('arno.personnel.dossier.baseData.manage', true);
    self.hasAllowedAge = hasAllowedAge;
    self.canEditOwn = isOwnDossier && hasAllowedAge;

    // EVENT-HANDLERS
    self.cancel = function () {
      // if the re-prompt, whether the user wants to drop the change, shouldn't be shown, then use the following
      // stateChangePrompt.disableEvaluation();

      $state.reload();
    };

    // VIEW-FUNCTIONS
    self.tagTransform = function (newTitleTag) {
      if (typeof newTitleTag === 'string' && newTitleTag.trim() === '') {
        return undefined;
      }

      return {
        Name: newTitleTag,
        mapping: newTitleTag
      };
    };

    self.setColor = function (item) {
      return {
        'background-color': item.Color,
        'color': commonUtils.getContrastLabelColor(item.Color)
      };
    };

    self.hasErrorClass = validationUtils.hasError;
    self.checkRequiredData = validationUtils.checkRequiredData;
    self.checkPhoneNumber = validationUtils.checkPhoneNumber;

    self.isMemberNumberRequired = function (memberType) {
      return memberType && ~['ACTIVE_MEMBER', 'PASSIVE_MEMBER'].indexOf(memberType.mapping);
    };

    self.checkEmails = function (emails) {
      var hasValidEmail = true;

      _.forEach(emails, function (emailEntry) {
        if (!validationUtils.checkEmail(emailEntry.Name)) {
          emailEntry.Color = '#D40018';
          hasValidEmail = false;
        }
      });

      return hasValidEmail;
    };




    self.formatEmployerActivities = function () {

      if (self.member.EmployerActivities) {

        var splittedActivities = self.member.EmployerActivities.split(';');

        self.choosenEmployerActivities = splittedActivities.map(function (activity) {

          return activity = _.find(self.EmployerActivities, { Value: activity });

        });

        self.choosenEmployerActivities = self.choosenEmployerActivities.filter(Boolean);

      }

    };

    self.formatEmployerActivities();

    self.showDivisionMemberHelperFields = function () {
      return !self.divisionMember || !self.divisionMember.MemberStatus ||
        (self.divisionMember.MemberStatus.length !== 1 || self.divisionMember.MemberStatus[0].mapping !== 'PROBATIONER');
    };

    // HELPERS
    function formatMemberData(memberData) {
      if (memberData) {
        // preset for ui-select, so the references match
        if (memberData.MemberType) {
          memberData.MemberType = _.find(self.MEMBER_TYPES, { mapping: memberData.MemberType });
        }

        // map other fields
        if (memberData.Salutation) {
          memberData.Salutation = _.head(self.MEMBER_SALUTATIONS.filter(function (salutation) {
            return memberData.Salutation === salutation.mapping || memberData.Salutation === salutation.Name;
          }));
        }

        if (memberData.Title) {
          // if title is not in the standard-title-catalogue, then add it as is
          memberData.Title = _.find(self.MEMBER_TITLES, { mapping: memberData.Title }) ||
            { Name: memberData.Title, mapping: memberData.Title };
        } else {
          memberData.Title = _.find(self.MEMBER_TITLES, { mapping: 'none' });
        }

        if (memberData.Gender) {
          memberData.Gender = _.find(self.MEMBER_GENDERS, { mapping: memberData.Gender });
        }

        memberData.Nationality = _.find(self.MEMBER_NATIONALITIES, { mapping: memberData.Nationality }) || _.find(self.MEMBER_NATIONALITIES, { mapping: 'DE' });

        if (memberData.Confession) {
          // if confession is not in the standard-confession-catalogue, then add it as is
          memberData.Confession = _.find(self.MEMBER_CONFESSIONS, { mapping: memberData.Confession }) || {
            Name: memberData.Confession,
            mapping: memberData.Confession
          };
        }

        // map to tag-picker entries
        if (memberData.AdditionalEMails) {
          // IMPORTANT: remove last element with "slice", because it has just been created because of the trailling semicolon ';'
          // which is need for exact search in AdditionalEMails of model!
          memberData.AdditionalEMails = _.map(_.split(memberData.AdditionalEMails, ';').slice(0, -1), function (emailText) {
            // if a entry is not in the frontend app-consts mappings, then just output as is
            // so it can be mapped later by the members.service, e.g. on save
            return {
              Name: emailText,
              mapping: emailText
            };
          });
        }

        // build up member-address data for ba-address component
        memberData.address = {
          CountryId: memberData.CountryId,
          ZIP: memberData.ZIP,
          City: memberData.City,
          Street: memberData.Street,
          HouseNumber: memberData.HouseNumber,
          AddressAffix: memberData.AddressAffix
        };

        memberData.employerAddress = {
          ZIP: memberData.EmployerZipCode,
          City: memberData.EmployerCity,
          Street: memberData.EmployerStreet,
          HouseNumber: memberData.EmployerHouseNumber
        };

        if (memberData.JoiningDate && moment(memberData.JoiningDate || null).isValid()) {
          memberData.JoiningDate = moment(memberData.JoiningDate).toDate();
        } else {
          memberData.JoiningDate = undefined;
        }

        if (memberData.BirthDate) {
          memberData.BirthDate = moment(memberData.BirthDate).toDate();
        }
      }
    }


    $scope.$watch(function () {
      return self.choosenEmployerActivities;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {

        var EmployerActivitiesTemp = '';

        _.forEach(self.choosenEmployerActivities, function (activity) {
          EmployerActivitiesTemp = EmployerActivitiesTemp + activity.Value + ';';
        }
        );

        self.member.EmployerActivities = EmployerActivitiesTemp;
      }
    });

    function formatDivisionMemberData(divMemberData) {
      if (divMemberData) {
        // map to tag-picker entries
        if (divMemberData.MemberStatus) {
          // IMPORTANT: remove last element with "slice", because it has just been created because of the trailling semicolon ';'
          // which is need for exact search in MemberStatus of model!
          divMemberData.MemberStatus = _.map(_.split(divMemberData.MemberStatus, ';').slice(0, -1), function (status) {
            var foundStatus = _.find(self.MEMBER_STATUSES, { mapping: status });
            if (foundStatus) {
              return foundStatus;
            }

            // if a entry is not in the frontend app-consts mappings, then just output as is
            // so it can be mapped later by the members.service, e.g. on save
            return {
              Name: status,
              mapping: status
            };
          });
        }

        // map other field
        if (divMemberData.MemberSince && moment(divMemberData.MemberSince || null).isValid()) {
          divMemberData.MemberSince = moment(divMemberData.MemberSince).toDate();
        } else {
          divMemberData.MemberSince = undefined;
        }

        if (divMemberData.HelperIdValidUntil && moment(divMemberData.HelperIdValidUntil || null).isValid()) {
          divMemberData.HelperIdValidUntil = moment(divMemberData.HelperIdValidUntil).toDate();
        } else {
          divMemberData.HelperIdValidUntil = undefined;
        }

        if (divMemberData.StartOfWorkSince && moment(divMemberData.StartOfWorkSince || null).isValid()) {
          divMemberData.StartOfWorkSince = moment(divMemberData.StartOfWorkSince).toDate();
        } else {
          divMemberData.StartOfWorkSince = undefined;
        }
      }
    }

    // INIT
    self.$onInit = function () {
      activate();
    };
  }
})();

/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.baseData')
    .controller('changePasswordCtrl', changePasswordCtrl);

  function changePasswordCtrl($uibModalInstance, $translate, toastr, clientApi) {
    var self = this;

    self.actPwdInputType = 'password';
    self.newPwdInputType = 'password';
    self.newPwdRepeatInputType = 'password';

    // VIEW-FUNCTIONS
    self.isPwdGoodEnough = function (pwd) {
      // we shouldn't demand a digit, a special char,
      // an excerpt from the british national hymn and a goat sacrifice
      // from the user in order to let his password pass
      // g0dSaveTheQu33n!666
      return (!pwd || pwd.length > 7);
    };

    self.close = function () {
      $uibModalInstance.close();
    };

    self.submit = function () {
      return clientApi.custom('model/Account', 'updateAccountPassword', { oldPwd: self.actPwd, newPwd: self.newPwd })
        .then(function () {
          toastr.success(
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.successToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.successToastTitle')
          );
          $uibModalInstance.close();
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.errorToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.errorToastTitle')
          );
          toastr.info(
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.infoToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editPasswordModal.infoToastTitle')
          );
        });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.basedata.emergencycontact.modal', [
      'BlurAdmin.pages.personnel.dossier.basedata.emergencycontacts'
    ])
    .controller('EmergencyContactModalCtrl', EmergencyContactModalCtrl);

  /** @ngInject */
  function EmergencyContactModalCtrl(
    toastr, $uibModalInstance, $translate,
    clientApi, validationUtils,
    viewOnly, emergencyContact
  ) {
    var $ctrl = this;
    
    // VARS
    $ctrl.emergencyContact = emergencyContact || {
      FirstName:'',
      LastName:'',
      Function:'',
      address: {}
    };
    $ctrl.viewOnly = viewOnly;
    $ctrl.emergencyContact.PrivacyTermsDeliveredDateTime = moment($ctrl.emergencyContact.PrivacyTermsDeliveredDateTime).toDate();
    $ctrl.addressCompUiConfig = {
      firstRow: {
        cssCls: 'row'
      },
      secondRow: {
        cssCls: 'row'
      },

      countryId: {
        show: false
      },
      zipCode: {
        wrapperCssCls: 'col-sm-3'
      },
      city: {
        wrapperCssCls: 'col-sm-9'
      },
      street: {
        wrapperCssCls: 'col-sm-6'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-2'
      },
      addressAffix: {
        wrapperCssCls: 'col-sm-4'
      },
    };

    // EVENT-HANDLERS
    $ctrl.saveEmergencyContact = function(form) {
      if (form && form.$valid && $ctrl.isAtLEastOneFieldFilled() && $ctrl.hasFunction()) {
        $ctrl.emergencyContact.DeclarationofConsent = 1
        $uibModalInstance.close($ctrl.emergencyContact);
      }
    };



    // VIEW-FUNCTIONS
    $ctrl.hasError = validationUtils.hasError;
    $ctrl.checkPhoneNumber = validationUtils.checkPhoneNumber;

    $ctrl.hasFunction = function(){
      if(!$ctrl.emergencyContact.Function || ($ctrl.emergencyContact.Function && $ctrl.emergencyContact.Function.length<1)){
        toastr.error(
          $translate.instant('modules.personnel.dossier.baseData.emergencyContactModal.errorToastText'),
          $translate.instant('modules.personnel.dossier.baseData.emergencyContactModal.errorToastTitle')
        );
        return false;
      }
      return true;
    };

    $ctrl.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        maxDate: moment().toDate(),
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4
      }
    };
    $ctrl.hstep = 1;
    $ctrl.mstep = 15;
    $ctrl.isMeridian = false;
    $ctrl.validForm = false;
    $ctrl.maxTimepick = moment().toDate();

    $ctrl.downloadPrivacyAgreement = function() {
      clientApi.openTab('pdfExport/emergencyContactsPrivacyTerms', {language: $translate.use()});
    }

    $ctrl.isAtLEastOneFieldFilled = function() {
      var valid = true;
      if ($ctrl.emergencyContact) {
        var invalidFields = 0;

        var inputFields = [
          'FirstName', 'LastName', 'MobileNumber', 'PhoneNumber',
          'Email', 'Function','DeclarationofConsent', 'PrivacyTermsDeliveredDateTime', 'PrivacyTermsDeliveredPerson', 'PrivacyTermsDeliveredChannel'
        ];

        var addressFields = ['ZIP', 'City', 'Street', 'HouseNumber', 'AddressAffix'];

        _.forEach(inputFields, function(field) {
          if ($ctrl.emergencyContact[field] == null || (typeof $ctrl.emergencyContact[field] === 'string' && $ctrl.emergencyContact[field].trim() === '')) {
            invalidFields++;
          }
        });

        if ($ctrl.emergencyContact.address) {
          _.forEach(addressFields, function(field) {
            if ($ctrl.emergencyContact.address[field] == null || (typeof $ctrl.emergencyContact.address[field] === 'string' && $ctrl.emergencyContact.address[field].trim() === '')) {
              invalidFields++;
            }
          });
        }

        if (invalidFields >= (inputFields.length + addressFields.length)) {
          valid = false;
        }
  
      }

      return valid;
    };

    
  }
})();

/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.baseData')
    .controller('changeEMailCtrl', changeEMailCtrl);

  function changeEMailCtrl($q, $uibModalInstance, $translate, toastr, ctx, organizationId, clientApi) {
    var self = this;
    self.divisionIds = ctx;
    if (self.divisionIds.indexOf('rootOrg') > -1) {
      self.divisionIds.splice(self.divisionIds.indexOf('rootOrg'), 1);
    }
    self.checkEMail = function (EMail) {
      return $q(function (resolve, reject) {
        return clientApi
          .custom('model/Account', 'hasMemberByEMail', { eMail: EMail })
          .then(function (exists) {
            if (exists) {
              return reject('Account already exists');
            }
            return resolve();
          })
          .catch(function () {
            return null;
          });
      });
    };

    self.close = function () {
      $uibModalInstance.close({ newEMail: null });
    };

    self.submit = function () {
      return clientApi.custom('model/Account', 'updateOwnAccountEmail', {
        newEMail: self.email,
        divId: self.divisionIds
      })
        .then(function () {
          toastr.success(
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.successToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.successToastTitle')
          );
          $uibModalInstance.close({
            newEMail: self.email
          });
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.errorToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.errorToastTitle')
          );
          toastr.info(
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.infoToastText'),
            $translate.instant('modules.personnel.dossier.baseData.editEmailModal.infoToastTitle')
          );
          $uibModalInstance.close({ newEMail: null });
        });

    };
  }

})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration', [])
    .directive('historyDataMapper', function (historyEventMap, $compile, $injector) {
      return {
        link: function (scope, element, attrs) {
          scope.data = scope.history.data;
          if (historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].dataHelper) {
            historyEventMap[attrs.historyDataMapper].dataHelper(scope.data, $injector);
          }
          var tags = historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].tags
            && historyEventMap[attrs.historyDataMapper].tags(scope.data) || [];
          tags = tags.map(function (tag) {
            return '<span class="mr-5 tag label label-' + tag.type + '">' + tag.label + '</span>';
          })
            .join('');
          var template = (historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].logTemplate)
            || 'Für diese Historie wurde noch keine Dateninterpretation hinterlegt.';
          element.append($compile('<span>' + tags + template + '</span>')(scope));
        }
      };
    })
    .directive('historyLabelMapper', function (historyEventMap, $compile) {
      return {
        link: function (scope, element, attrs) {
          var label = (historyEventMap && historyEventMap[attrs.historyLabelMapper] && historyEventMap[attrs.historyLabelMapper].label)
            || 'Für diese Historie wurde noch keine Dateninterpretation hinterlegt.';
          element.append($compile('<span>' + label + '</span>')(scope));
        }
      };
    })
    .controller('PersonnelDossierAdministrationCtrl', PersonnelDossierAdministrationCtrl);

  function PersonnelDossierAdministrationCtrl(
    $scope,
    $state,
    isPermitted,
    isPermittedOrOwn,
    clientApi,
    ctx,
    toastr,
    $timeout,
    commonUtils,
    $translate,
    member,
    isInDivisions,
    currentDivisionName,
    isOwnDossier,
    authInfo,
    $uibModal,
    $window,
    fetchPermissions,
    historyData,
    fetchHistoryData,
    historyEventMap,
    $rootScope,
    ARNO_CONSTANTS,
    notificationPreference,
    notificationService
  ) {
    var self = this;
    self.authInfo = authInfo;
    self.isPermitted = isPermitted;
    self.isPermittedOrOwn = isPermittedOrOwn;
    self.ownDossier = isOwnDossier;
    self.fetchPermissions = fetchPermissions;
    self.backToPersonnelList = $rootScope.backToPersonnelList;
    self.NOTIFICATION_PREFERENCES = ARNO_CONSTANTS.GENERAL.NOTIFICATION_PREFERENCES;
    self.isUserOptedIn = true;

    if ($rootScope.ctx.organization.current) {
      self.currentOrgConf = {
        deletionMonths: $rootScope.ctx.organization.current.deletionPeriodMonths,
        withdrawalDays: $rootScope.ctx.organization.current.withdrawalPeriodDays
      };
    }

    if (self.fetchPermissions
      && self.fetchPermissions.divisionMatrix
      && self.fetchPermissions.divisionMatrix.allZoneIds
      && self.fetchPermissions.divisionMatrix.allZoneIds.length > 100) {
      self.warnDivisionMatrixLength = self.fetchPermissions.divisionMatrix.allZoneIds.length;
    }

    $timeout(function () {
      // scrollable table
      var $th = $('.arno-table-scrollable')
        .find('thead th');
      $('.arno-table-scrollable')
        .on('scroll', function () {
          $th.css('transform', 'translateY(' + this.scrollTop + 'px)');
        });

      // matomo tracking
      var _paq = window._paq = window._paq || [];
      _paq.push([function () {
        if (this.isUserOptedOut()) {
          self.isUserOptedIn = false;
        } else {
          self.isUserOptedIn = true;
        }
      }]);
    });

    $scope.$watch(function () {
      return self.fetchPermissions && self.fetchPermissions.divisionMatrix && self.fetchPermissions.divisionMatrix.internalNameMap;
    }, function () {
      if (self.fetchPermissions && self.fetchPermissions.divisionMatrix && self.fetchPermissions.divisionMatrix.internalNameMap) {
        self.allDivisionPermissions = Object.keys(self.fetchPermissions.divisionMatrix.internalNameMap);
      } else {
        self.allDivisionPermissions = [];
      }
    }, true);

    self.isOrg = ctx && ctx[0] === 'rootOrg';
    self.divActive = member && member.DivisionMembers && member.DivisionMembers.length && member.DivisionMembers[0].Active;
    self.member = member;
    self.currentDivisionName = currentDivisionName;
    self.divActiveSwitcherKeys = {
      on: $translate.instant('modules.personnel.dossier.administration.active'),
      off: $translate.instant('modules.personnel.dossier.administration.inactive')
    };

    self.matomoTrackingChanged = function () {
      var _paq = window._paq = window._paq || [];
      _paq.push([function () {
        if (this.isUserOptedOut()) {
          _paq.push(['forgetUserOptOut']);
        } else {
          _paq.push(['optUserOut']);
        }
      }]);
    };

    self.toggleMemberActivation = function (activate) {
      return clientApi
        .custom('model/DivisionMember', activate ? 'activateDivisionMember' : 'deactivateDivisionMember', {
          divMemberId: member && member.DivisionMembers && member.DivisionMembers.length && member.DivisionMembers[0].id,
          divisionId: ctx
        })
        .then(function () {
          toastr.success(
            $translate.instant('modules.personnel.dossier.administration.memberActivationToastText', { member: member.fullName, ACTIVE: activate }),
            $translate.instant('modules.personnel.dossier.administration.memberActivationToastTitle', { ACTIVE: activate })
          );
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.personnel.dossier.administration.memberActivationErrToastText', { member: member.fullName }),
            $translate.instant('modules.personnel.dossier.administration.memberActivationErrToastTitle')
          );
        });
    };

    $scope.$watch(function () {
      return self.divActive;
    }, function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      // fires after change, so we call toggle with our desired state straight from the switcher state
      self.toggleMemberActivation(self.divActive);
    });
    self.changePassword = function () {
      $uibModal.open({
        controller: 'changePasswordCtrl as $pwdModal',
        animation: true,
        backdrop: 'static',
        size: 'md',
        templateUrl: 'app/pages/personnel/dossier/baseData/passwordModal/changePassword.html'
      });
    };
    self.changeAccountType = function (newType) {
      var oldType = self.member.Account.Type;
      var changeAccountTypeModal = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/administration/changeAccountType.html',
          backdrop: 'static',
          size: 'md',
          controller: 'OnlineSwitchModalCtrl as $onlineSwitchModalCtrl',
          resolve: {
            data: { oldType: oldType, newType: newType },
          },
        });
      changeAccountTypeModal.result.then(function (result) {
        if (result && !result.duplicate) {
          return clientApi
            .custom('model/Account', 'changeAccountType', {
              identifier: result.identifier,
              member: self.member,
              divId: ctx,
            })
            .then(function () {
              self.accountTypeChanged = true;
              toastr.success(
                $translate.instant('modules.personnel.dossier.administration.changeAccToastText'),
                $translate.instant('modules.personnel.dossier.administration.changeAccToastTitle')
              );
              $state.go('arno.personnel.personnelList');
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.personnel.dossier.administration.changeAccErrToastText'),
                $translate.instant('modules.personnel.dossier.administration.changeAccErrToastTitle')
              );
            });
        }
      });
    };
    self.back = function () {
      $state.go('arno.personnel.personnelList');
    };

    self.matrixOrderXAxis = function (zone) {
      return self.fetchPermissions.divisionMatrix.zoneIdMap[zone];
    };

    self.matrixOrderYAxis = function (permission) {
      return self.fetchPermissions.divisionMatrix.internalNameMap[permission].Name;
    };
    self.removeWithdrawal = function (isDiv) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/administration/withdrawal/activateMember.modal.html',
          controller: 'activateCtrl as $activateCtrl',
          backdrop: 'static',
          size: 'md',
          resolve: {
            data: { isDiv: isDiv, isOwn: self.ownDossier }
          }
        })
        .result
        .then(function (reason) {
          if (reason === undefined) {
            return;
          }
          if (isDiv) {
            return clientApi
              .custom('model/DivisionMember', 'removeWithdrawal', {
                divMemberId: member.DivisionMembers[0].id,
                divId: self.member.DivisionMembers[0].DivisionId,
                reasonComment: reason
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.dossier.administration.removeWithdrawalToastText'),
                  $translate.instant('modules.personnel.dossier.administration.removeWithdrawalToastTitle')
                );
                $state.reload();
              });
          }
          return clientApi
            .custom('model/Member', 'removeWithdrawal', {
              memId: member.id,
              reasonComment: reason
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.personnel.dossier.administration.removeWithdrawalToastText'),
                $translate.instant('modules.personnel.dossier.administration.removeWithdrawalToastTitle')
              );
              $state.reload();
            });
        });
    };
    self.leave = function (isDiv) {
      var finishLeave = function (divOption) {
        toastr.success(
          $translate.instant('modules.personnel.dossier.administration.leaveToastText'),
          $translate.instant('modules.personnel.dossier.administration.leaveToastTitle')
        );
        if (isOwnDossier) {
          if (divOption) {
            // user left div, navigate to rootOrg
            commonUtils.division.setCtx(['rootOrg'],
              {
                multiple: false,
                namespace: 'divisionMemberDossier',
                allowOrgSelection: true,
              });
            $state.reload();
          } else {
            if ($rootScope.ctx && $rootScope.ctx.organization && $rootScope.ctx.organization.list && $rootScope.ctx.organization.list.length === 1) {
              // user just left his only org, force logout
              return clientApi.emit('auth/combined/logout')
                .then(function () {
                  window.location.href = '/auth.html?code=17';
                });
            } else {
              // user left org, navigate to dashboard
              $state.go('arno.dashboard', {}, { reload: true });
            }
          }
        } else {
          $state.reload();
        }
      };
      var leaveModalHandling = function (isDivision) {
        return clientApi
          .custom('model/WithdrawalReasons', 'getReasons', {
            isDiv: isDivision
          })
          .then(function (reasons) {
            var leaveHintModal = $uibModal
              .open({
                animation: true,
                templateUrl: 'app/pages/personnel/dossier/administration/withdrawal/leaveHintModal.html',
                backdrop: 'static',
                size: 'md',
                controller: 'leaveModalCtrl as $leaveCtrl',
                resolve: {
                  data: {
                    reasons: reasons.rows,
                    isDiv: isDivision,
                    isOwn: self.ownDossier,
                    divList: isInDivisions,
                    periods: self.currentOrgConf
                  }
                },
              });
            leaveHintModal.result.then(function (result) {
              if (result) {
                var leaveModal = $uibModal
                  .open({
                    animation: true,
                    templateUrl: 'app/pages/personnel/dossier/administration/withdrawal/leaveModal.html',
                    backdrop: 'static',
                    size: 'md',
                    controller: 'leaveModalCtrl as $leaveCtrl',
                    resolve: {
                      data: {
                        reasons: reasons.rows,
                        isDiv: isDivision,
                        isOwn: self.ownDossier,
                        divList: isInDivisions,
                        periods: self.currentOrgConf
                      }
                    },
                  });
                leaveModal.result.then(function (result) {
                  if (result === undefined) {
                    return;
                  }
                  var parsedResult = JSON.parse(result.reason);
                  if (parsedResult.IsDiv) {
                    return clientApi
                      .custom('model/DivisionMember', 'triggerWithdrawal', {
                        divMemberId: self.member.DivisionMembers[0].id,
                        reason: parsedResult,
                        reasonComment: result.comment,
                        divId: self.member.DivisionMembers[0].DivisionId
                      })
                      .then(function () {
                        finishLeave(isDivision);
                      });
                  } else {
                    return clientApi
                      .custom('model/Member', 'triggerWithdrawal', {
                        memId: self.member.id,
                        reason: parsedResult,
                        reasonComment: result.comment,
                      })
                      .then(function () {
                        finishLeave(isDivision);
                      });
                  }
                });
              }
            });
          });
      };

      if (isDiv && self.ownDossier) {
        // if we are in div scope and a user want's to delete itself, we'll ask if he want's to be deleted on org scope
        var askForOrgDelete = $uibModal
          .open({
            animation: true,
            templateUrl: 'app/pages/personnel/dossier/administration/withdrawal/askForOrgDelete.html',
            backdrop: 'static',
            size: 'md',
          });
        askForOrgDelete.result.then(function (divLeave) {
          if (divLeave === undefined) {
            return;
          }
          leaveModalHandling(divLeave);
        });
      } else {
        leaveModalHandling(isDiv);
      }
    };
    self.removeBlockage = function (isDiv) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/administration/blockage/deBlockMember.modal.html',
          controller: 'deBlockCtrl as $deBlockCtrl',
          backdrop: 'static',
          size: 'md',
          resolve: {
            data: { isDiv: isDiv, isOwn: self.ownDossier }
          }
        })
        .result
        .then(function (reason) {
          if (reason === undefined) {
            return;
          }
          if (isDiv) {
            return clientApi
              .custom('model/DivisionMember', 'removeBlockage', {
                divMemberId: member.DivisionMembers[0].id,
                divId: self.member.DivisionMembers[0].DivisionId,
                reasonComment: reason
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.dossier.administration.removeBlockageToastText'),
                  $translate.instant('modules.personnel.dossier.administration.removeBlockageToastTitle')
                );
                $state.reload();
              });
          }
          return clientApi
            .custom('model/Member', 'removeBlockage', {
              memId: member.id,
              reasonComment: reason
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.personnel.dossier.administration.removeBlockageToastText'),
                $translate.instant('modules.personnel.dossier.administration.removeBlockageToastTitle')
              );
              $state.reload();
            });
        });
    };
    self.block = function (isDiv) {
      var finishBlock = function () {
        toastr.success(
          $translate.instant('modules.personnel.dossier.administration.blockToastText'),
          $translate.instant('modules.personnel.dossier.administration.blockToastTitle')
        );
        $state.reload();
      };
      return clientApi
        .custom('model/BlockReasons', 'getReasons', {
          isDiv: isDiv
        })
        .then(function (reasons) {
          var divList = [];
          self.member.DivisionMembers.forEach(function (divMem) {
            divList.push(divMem.Division.Name);
          });
          var blockHintModal = $uibModal
            .open({
              animation: true,
              templateUrl: 'app/pages/personnel/dossier/administration/blockage/blockHintModal.html',
              backdrop: 'static',
              size: 'md',
              controller: 'blockCtrl as $blockCtrl',
              resolve: {
                data: { reasons: reasons.rows, isDiv: isDiv, divList: divList, periods: self.currentOrgConf }
              },
            });
          blockHintModal.result.then(function (result) {
            if (result) {
              var blockModal = $uibModal
                .open({
                  animation: true,
                  templateUrl: 'app/pages/personnel/dossier/administration/blockage/blockModal.html',
                  backdrop: 'static',
                  size: 'md',
                  controller: 'blockCtrl as $blockCtrl',
                  resolve: {
                    data: { reasons: reasons.rows, isDiv: isDiv, divList: divList, periods: self.currentOrgConf }
                  },
                });
              blockModal.result.then(function (result) {
                if (result === undefined) {
                  return;
                }
                var parsedResult = JSON.parse(result.reason);
                if (parsedResult.IsDiv) {
                  return clientApi
                    .custom('model/DivisionMember', 'triggerBlockage', {
                      divMemberId: self.member.DivisionMembers[0].id,
                      reason: parsedResult,
                      divId: self.member.DivisionMembers[0].DivisionId,
                      reasonComment: result.comment,
                    })
                    .then(finishBlock);
                } else {
                  return clientApi
                    .custom('model/Member', 'triggerBlockage', {
                      memId: self.member.id,
                      reason: parsedResult,
                      reasonComment: result.comment,
                    })
                    .then(finishBlock);
                }
              });
            }
          });
        });
    };
    self.historyTableConfig = {
      pageSize: 10,
    };

    self.sendTestPushMessage = function () {
      notificationService.sendTest();
    };

    self.historyCollection = historyData || { data: [] };

    self.getHistoryData = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.historyTableConfig.pageSize || 0,
          limit: self.historyTableConfig.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      return fetchHistoryData(queryWishes)
        .then(function (result) {
          self.historyCollection = result || { data: [] };
          params.pagination.numberOfPages = Math.ceil(self.historyCollection.count / self.historyTableConfig.pageSize);
        });
    };
    self.historyEventMap = historyEventMap;

    self.notifications = {
      preferences: notificationPreference,
      savePreference: function (a, b) {
        if (a === b) {
          return;
        }
        return clientApi
          .custom('model/NotificationPreference', 'createOrUpdate', { preference: self.notifications.preferences, cMemberId: member.id })
          .then(function (preference) {
            if (preference && (preference.Events != 'EMAIL' || preference.Services != 'EMAIL')) {
              notificationService.subscribe();
            }
            else {
              // unsubscribe
            }
            toastr.success(
              $translate.instant('modules.personnel.dossier.administration.savePrefToastText'),
              $translate.instant('modules.personnel.dossier.administration.savePrefToastTitle')
            );
          })
          .catch(function () {
            toastr.error(
              $translate.instant('modules.personnel.dossier.administration.savePrefErrToastText'),
              $translate.instant('modules.personnel.dossier.administration.savePrefErrToastTitle')
            );
          });
      },
    };
    $scope.$watch('$admin.notifications.preferences.Events', self.notifications.savePreference);
    $scope.$watch('$admin.notifications.preferences.Services', self.notifications.savePreference);
    $scope.$watch('$admin.notifications.preferences.NotifyAll', self.notifications.savePreference);
    $scope.$watch('$admin.notifications.preferences.NotifyImportant', self.notifications.savePreference);
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration')
    .controller('leaveModalCtrl', leaveModalCtrl);

  /** @ngInject */
  function leaveModalCtrl($rootScope, $translate, toastr, $uibModalInstance, data) {
    var self = this;

    self.divList = data.divList;
    self.periods = data.periods;
    self.modalInstance = $uibModalInstance;
    self.isDiv = data.isDiv;
    self.reasons = data.reasons;
    self.isOwn = data.isOwn;
    self.selectedReason = false;
    self.reasonComment = '';
    self.nextStep = function(){
      $uibModalInstance.close(true);
    };
    self.finishSelection = function () {
      if (!self.isOwn && !self.selectedReason) {
        return toastr.error(
          $translate.instant('modules.personnel.dossier.administration.withdrawalModal.errToastText'),
          $translate.instant('modules.personnel.dossier.administration.withdrawalModal.errToastTitle')
        );
      }
      
      
      
      if (!self.selectedReason) {
        self.selectedReason = JSON.stringify(_.find(self.reasons, function (reason) {
          return reason.Reason === 'Sonstige/Unbekannt';
        }));

      }
      $uibModalInstance.close({ reason: self.selectedReason, comment: self.reasonComment });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration')
    .controller('activateCtrl', activateCtrl);

  /** @ngInject */
  function activateCtrl($rootScope, toastr, $uibModalInstance, data) {
    var self = this;
    self.modalInstance = $uibModalInstance;
    self.isDiv = data.isDiv;
    self.isOwn = data.isOwn;
    self.selectedReason = false;
    self.reasonComment = '';
    self.finishSelection = function () {
      $uibModalInstance.close(self.reasonComment);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.activity', [])
    .controller('PersonnelDossierActivityCtrl', PersonnelDossierActivityCtrl)
    .filter('activityStateFilter', function () {
      return function (activities, currentActivityState) {
        return activities.filter(function (activity) {
          return activity && activity.calculatedState === currentActivityState;
        });
      }
    })
    .filter('filterAllocatedOrPending', function () {
      return function (activities, allocatedOrPending) {
        return activities.filter(function (activity) {
          return !~allocatedOrPending.indexOf(activity.key);
        });
      }
    });

  function PersonnelDossierActivityCtrl(activityHistory, $uibModal, member, ctx, organizationId, toastr,
    clientApi, $state, activityGroups, characteristicMap, causesOfTermination, permissions, $stateParams, activityFulfillmentStates,
    $rootScope, baModalService, isOrgScope, allActivityHistories, allActivityFulfillmentStates, $translate) {

    var self = this;

    // VARS
    self.isOrgScope = isOrgScope;
    self.backToOverview = $stateParams.backToOverview;

    self.ctx = ctx;
    self.member = member;

    // used if ORG selected
    self.allActivityHistories = allActivityHistories;
    self.hasAllActivity = allActivityHistories && Object.keys(allActivityHistories).length;
    self.allActivityFulfillmentStates = allActivityFulfillmentStates;

    // used if DIVISION selected
    self.activityHistory = activityHistory;
    self.activityFulfillmentStates = activityFulfillmentStates;

    self.backToPersonnelList = $rootScope.backToPersonnelList;

    self.activitiesGroupedByState = _.chain(self.activityHistory).groupBy('ActivityAllocations[0].calculatedState')
    .map(function(value, key) {
      return { state: key, activities: value }; 
    }).value();

    // METHODS
    self.allocatedOrPendingActivities = self.activityHistory.map(function (allocatedOrPendingActivity) {
      return allocatedOrPendingActivity.id;
    });

    self.activityGroups = _.flatten(
      (activityGroups || [])
        .map(function (activityGroup) {
          return (activityGroup.Activities || []).map(function (activity) {
            return {
              key: activity.id,
              value: activity.Title,
              active: activity.Active,
              organizational: !activity.DivisionId,
              allocatedOrPending: !!~self.allocatedOrPendingActivities.indexOf(activity.id),
              groupName: activityGroup.Title,
            }
          })
        })
    )
      .filter(function (activity) {
        return activity.active;
      });

    self.activityStates = [
      { title: $translate.instant('modules.personnel.dossier.activity.stateTitleActive'), state: 'ACTIVE' },
      { title: $translate.instant('modules.personnel.dossier.activity.stateTitleInactive'), state: 'INACTIVE' },
      { title: $translate.instant('modules.personnel.dossier.activity.stateTitlePending'), state: 'PENDING' }
    ];

    self.characteristicMap = characteristicMap;
    self.causesOfTermination = causesOfTermination;

    self.editActivityAssociation = function (activity, activityAllocation, overrideCtx) {
      var updateState = false;
      var context = overrideCtx || ctx;
      var usedActivityAllocation = activityAllocation || (activity.ActivityAllocations && activity.ActivityAllocations[0]);

      $uibModal.open(
        {
          controller: 'activityAssociationUpdate as $aassoc',
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/activity/modal/activityAssoc.html',
          size: 'lg',
          resolve: {
            activity: function () {
              return activity;
            },
            activityAllocation: function () {
              return usedActivityAllocation;
            },
            member: function () {
              return member;
            },
            characteristicMap: function () {
              return self.characteristicMap;
            },
            causesOfTermination : function() {
              return self.causesOfTermination;
            },
            divisionId: function () {
              return context;
            },
            activatedCharacterisitcs: function (clientApi) {
              if (!self.isPermitted('arno.personnel.dossier.activity.characteristicAssign', null, context)) {
                return [];
              }
              return clientApi.custom('model/Activity', 'getActivatedCharacteristicsForActivity', { divisionId: context, activityId: activity.id })
                .catch(function () {
                  return []
                });
            }
          }
        })
        .result
        .then(function (resolve) {
          if (!resolve) {
            return;
          }
          if (resolve.denied) {
            return clientApi
              .custom('model/ActivityAllocation', 'allocateCharacteristic', {
                activityAllocationId: usedActivityAllocation.id,
                characteristic: 'DENY',
                divisionId: context
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.dossier.activity.allocCharDeniedToastText'),
                  $translate.instant('modules.personnel.dossier.activity.allocCharDeniedToastTitle')
                );
                updateState = true;
              })
          }
          if (!resolve.currentCharacteristic
              || !resolve.currentCharacteristic.key
              || !activity.ActivityAllocations
              || !activity.ActivityAllocations.length) {
            throw new Error('No characteristic chosen!');
          }
          if (resolve.currentCharacteristic.key !==  usedActivityAllocation.Characteristic) {
            return clientApi
              .custom('model/ActivityAllocation', 'allocateCharacteristic', {
                activityAllocationId:  usedActivityAllocation.id,
                characteristic: resolve.currentCharacteristic.key,
                divisionId: context
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.dossier.activity.allocCharUpdatedToastText'),
                  $translate.instant('modules.personnel.dossier.activity.allocCharUpdatedToastTitle')
                );
                updateState = true;
                return resolve;
              });
          }
          return resolve;
        })
        .then(function (resolve) {
          if (!resolve) {
            return;
          }
          var crud = (resolve.parsedActivityAllocationPeriods || []).filter(function (period) {
            return !period.id || period.pendingDelete;
          });
          if (activity
              && activity.ActivityAllocations
              && activity.ActivityAllocations.length
              && usedActivityAllocation.ActivityAllocationPeriods) {
            // check if current period data changed from that data that was fetched
            usedActivityAllocation.ActivityAllocationPeriods.forEach(function (period) {
              var parsedPeriod = _.find(resolve.parsedActivityAllocationPeriods, { id: period.id });
              if (!period.pendingDelete
                  && parsedPeriod
                  && (!moment(period.StartDate).isSame(moment(parsedPeriod.StartDate), 'day')
                      || (
                        !moment(period.EndDate).isSame(moment(parsedPeriod.EndDate), 'day')
                        && (period.EndDate !== null || parsedPeriod.EndDate !== period.EndDate)
                      )
                      || period.CauseOfTermination !== parsedPeriod.CauseOfTermination
                      )) {
                crud.push(parsedPeriod);
              }
            });
          }
          if (!crud.length) {
            return;
          }
          if (!activity.ActivityAllocations.length
              || !usedActivityAllocation.id) {
            throw new Error('Unknown ActivityAllocation id');
          }
          return clientApi
            .custom('model/ActivityAllocationPeriod', 'crudActivityAllocationPeriod', {
              activityAllocationId: usedActivityAllocation.id,
              updateActivityAllocationPeriods: crud,
              divisionId: context
            })
            .then(function (result) {
              if (result) {
                toastr.success(
                  $translate.instant('modules.personnel.dossier.activity.updatePeriodToastText'),
                  $translate.instant('modules.personnel.dossier.activity.updatePeriodToastTitle')
                );
                updateState = true;
              }
            })
        })
        .catch(function (e) {
          if (e && !~['backdrop click', 'escape key press'].indexOf(e.toString())) {
            console.error(e.toString());
            toastr.error(
              $translate.instant('modules.personnel.dossier.activity.updatePeriodErrToastText'),
              $translate.instant('modules.personnel.dossier.activity.updatePeriodErrToastTitle')
            );
          }
        })
        .then(function () {
          if (updateState) {
            $state.reload();
          }
        });
    };

    self.addPendingActivity = function () {
      $uibModal.open(
        {
          controller: 'activityCheckFulfillment as $acful',
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/activity/modal/activityCheckFulfillment.html',
          size: 'lg',
          resolve: {
            activityGroups: function () {
              return self.activityGroups;
            },
            allocatedOrPendingActivities: function () {
              return self.allocatedOrPendingActivities;
            },
            member: function () {
              return member;
            },
            ctx: function() {
              return ctx;
            },
            characteristicMap: function() {
              return characteristicMap;
            },
          }
        })
        .result
        .then(function (newActivity) {
          if (!newActivity) {
            return;
          }
          return clientApi
            .custom('model/ActivityAllocation', 'allocatePending', {
              activityId: newActivity.key,
              cMemberId: member.id,
              divisionId: ctx
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.personnel.dossier.activity.allocPendingToastText'),
                $translate.instant('modules.personnel.dossier.activity.allocPendingToastTitle')
              );
              $state.reload();
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.personnel.dossier.activity.allocPendingErrToastText'),
                $translate.instant('modules.personnel.dossier.activity.allocPendingErrToastTitle')
              );
            });
        });
    };

    self.activityExport = function () {
      $uibModal
      .open({
        animation: true,
        templateUrl: 'app/pages/personnel/dossier/activity/modal/activityExport.html',
        size: 'md',
        controller: 'activityExportCtrl as $activityExportCtrl',
        resolve: {
          exportPrivacyNote: function (clientApi) {
            return clientApi.custom('model/ExportPrivacyNote', 'getLatest', {})
          }
        }
      })
      .result
      .then(function () {
        clientApi.openTab('personnel/export/activities', {
          memberId: member.id,
          divisionId: ctx,
        });
        toastr.success(
          $translate.instant('modules.personnel.dossier.activity.downloadStartedToastText'),
          $translate.instant('modules.personnel.dossier.activity.downloadStartedToastTitle')
        );
      })
      .catch(function(){}); 
    };

    self.isPermitted = function (action, checkBoth, ctxOverride) {
      return (
        checkBoth && permissions.isPermittedInEvery(action, 'Organization', ctxOverride || [ $rootScope.ctx.organization.current.id])
        || permissions.isPermittedInEvery(action, 'Division', ctxOverride || ctx)
      );
    };

    self.deleteActivity = function(activity, overrideCtx) {
      var context = overrideCtx || ctx;

      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.personnel.dossier.activity.deleteModalTitle'),
        content: $translate.instant('modules.personnel.dossier.activity.deleteModalContentLine1', { activity: activity.Title })
                + '\n' +
                $translate.instant('modules.personnel.dossier.activity.deleteModalContentLine2'),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel'),
      })
       .then(function() {
         return clientApi
          .custom('model/ActivityAllocation', 'removeActivityAllocation', {
            activityId: activity.id,
            cMemberId: member.id,
            divisionId: context
          })
          .then(function() {
            $state.reload();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.personnel.dossier.activity.deleteErrToastText'),
              $translate.instant('modules.personnel.dossier.activity.deleteErrToastTitle')
            );
          });
       });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.activity')
    .controller('activityExportCtrl', activityExportCtrl);

  function activityExportCtrl($uibModalInstance, exportPrivacyNote) {
    
    var self = this;
    self.readAndAccepted = false;
    self.exportPrivacyNoteContent = new showdown.Converter().makeHtml(exportPrivacyNote.TextContent);

    self.applyModal = function () {
      $uibModalInstance.close();
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.activity')
    .controller('activityCheckFulfillment', activityCheckFulfillment);

  /** @ngInject */
  function activityCheckFulfillment($scope, $uibModalInstance, member, activityGroups,
    allocatedOrPendingActivities, ctx, characteristicMap) {
    var self = this;
    self.member = member;
    self.activityGroups = activityGroups;
    self.allocatedOrPendingActivities = allocatedOrPendingActivities;

    $scope.$watch(function () {
      return self.newActivity;
    }, function () {
      self.fulfillmentCheckData = {
        divisionId: ctx,
        memberId: member.id,
        activityId: self.newActivity.key,
        characteristic: Object.keys(characteristicMap)
      }
    }, true);

    self.applyModal = function () {
      $uibModalInstance.close(self.newActivity);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.activity')
    .controller('activityAssociationUpdate', activityAssociationUpdate);

  /** @ngInject */
  function activityAssociationUpdate(
    $scope, $uibModalInstance, $translate,
    activity, member, characteristicMap, divisionId, activatedCharacterisitcs, activityAllocation,
    permissions, toastr, causesOfTermination
  ) {
    var self = this;

    self.validityPeriodHelperActivated = true;

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    self.expireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    self.activity = activity;
    self.member = member;
    self.divisionId = divisionId;
    self.allocation = activityAllocation || {};
    self.characteristicMap = Object.keys(_.cloneDeep(characteristicMap))
      .map(function (characterisitcKey) {
        return {
          key: characterisitcKey,
          value: characteristicMap[characterisitcKey],
          activated: !!~activatedCharacterisitcs.indexOf(characterisitcKey)
        }
      });
    self.currentCharacteristic = _.find(self.characteristicMap, { key: self.allocation.Characteristic });
    // if no characteristic is chosen, and only one could be chosen, set that one
    if (!self.currentCharacteristic && _.filter(self.characteristicMap, { activated: true }).length === 1) {
      self.currentCharacteristic = _.find(self.characteristicMap, { activated: true });
    }

    self.parsedActivityAllocationPeriods = _.cloneDeep(self.allocation.ActivityAllocationPeriods || []).map(function (period) {
      return {
        id: period.id,
        StartDate: moment(period.StartDate).toDate(),
        EndDate: period.EndDate && moment(period.EndDate).toDate() || null,
        CauseOfTermination: period.CauseOfTermination
      }
    });

    self.causesOfTermination = causesOfTermination;
    self.causeOftermination;

    self.getCausesOfTermination = function (search) {
      var newCauses = self.causesOfTermination.slice();
      if (search && newCauses.indexOf(search) === -1) {
        newCauses.unshift(search);
      }
      return newCauses;
    };

    $scope.$watch(function () {
      return self.newStartDate
    }, function (newVal, oldVal) {
      if (newVal && newVal !== oldVal
          && self.validityPeriodHelperActivated
          && (self.ExpireDateViaValidityPeriodHelper || !self.newEndDate)
          && (self.activity.ValidityPeriodDays || self.activity.ValidityPeriodMonths || self.activity.ValidityPeriodYears)) {
        self.newEndDate = moment(self.newStartDate)
          .add(self.activity.ValidityPeriodDays || 0, 'days')
          .add(self.activity.ValidityPeriodMonths || 0, 'months')
          .add(self.activity.ValidityPeriodYears || 0, 'years')
          .toDate();
        self.ExpireDateViaValidityPeriodHelper = true;
        self.ignoreNextExpireDateChange = true;
      } else {
        self.ExpireDateViaValidityPeriodHelper = false;
      }
      self.expireDatepicker.options.minDate = moment(newVal).toDate();
    }, false);

    $scope.$watch(function () {
      return self.newEndDate
    }, function (newVal) {
      if (self.ignoreNextExpireDateChange && Boolean(+newVal)) {
        self.ignoreNextExpireDateChange = false;
        return;
      }
      self.ExpireDateViaValidityPeriodHelper = false;
    }, false);

    self.hasOverlappingAllocations = function () {
      var parsedActivityAllocationPeriodsIterator = self.parsedActivityAllocationPeriods.length;
      if (parsedActivityAllocationPeriodsIterator) {
        while (parsedActivityAllocationPeriodsIterator--) {
          var current = self.parsedActivityAllocationPeriods[parsedActivityAllocationPeriodsIterator];
          var others = self.parsedActivityAllocationPeriods.slice(0, parsedActivityAllocationPeriodsIterator)
            .filter(function (other) {
              return !other.pendingDelete;
            });
          var collisionPeriods = [];

          // ARNO-1778 also check for endDates being chronologically behind their startDate
          if (current.EndDate && !moment(current.EndDate).isAfter(moment(current.StartDate))) {
            collisionPeriods.push(true);
          }

          if (!current.pendingDelete && others.length) {
            var infiniteDate = moment('9999-12-31');

            collisionPeriods = others.filter(function (period) {
              return moment(current.StartDate).isBetween(moment(period.StartDate), moment(period.EndDate || infiniteDate), null, '()');
            });
            if (current.EndDate) {
              collisionPeriods = collisionPeriods.concat(
                others.filter(function (period) {
                  return moment(current.EndDate).isBetween(moment(period.StartDate), moment(period.EndDate || infiniteDate), null, '()');
                })
              );
            }
            collisionPeriods = collisionPeriods.concat(
              others.filter(function (period) {
                return moment(period.StartDate).isBetween(moment(current.StartDate), moment(current.EndDate || infiniteDate), null, '[)');
              })
            );
          }
          if (collisionPeriods.length) {
            return true;
          }
        }
      }

      return false;
    };

    self.applyModal = function () {
      if (self.hasOverlappingAllocations()) {
        toastr.info(
          $translate.instant('modules.personnel.dossier.activity.overlappingPeriodsToastText'),
          $translate.instant('modules.personnel.dossier.activity.overlappingPeriodsToastTitle')
        );
        return;
      }
      self.validityPeriodHelperActivated = false;
      $uibModalInstance.close({
        currentCharacteristic: self.currentCharacteristic,
        parsedActivityAllocationPeriods: self.parsedActivityAllocationPeriods
      });
    };

    self.addNewDate = function () {
      if (self.newStartDate) {
        self.parsedActivityAllocationPeriods.push({
          StartDate: moment(self.newStartDate).toDate(),
          EndDate: self.newEndDate && moment(self.newEndDate).toDate() || null,
          CauseOfTermination: self.causeOftermination
        });
        self.newStartDate = null;
        self.newEndDate = null;
        self.causeOftermination = null;
      }
    };

    self.deletePeriod = function (period) {
      if (period.id) {
        period.pendingDelete = !period.pendingDelete;
        return;
      }
      self.parsedActivityAllocationPeriods.splice(self.parsedActivityAllocationPeriods.indexOf(period), 1);
    };

    self.denyAssociation = function () {
      $uibModalInstance.close({
        denied: true
      });
    };

    self.checkForValidExpireDate = function () {
      return !(self.newStartDate && self.newEndDate && self.newEndDate < self.newStartDate);
    };

    self.isPermitted = function (action) {
      return permissions.isPermittedInEvery(action, 'Division', divisionId);
    };

    self.allocationPeriodEndDatepickerOpts = {};
    $scope.$watch(function() {
      return self.parsedActivityAllocationPeriods;
    }, function() {
      self.parsedActivityAllocationPeriods.forEach(function(period, index) {
        self.allocationPeriodEndDatepickerOpts[index] = {
          format: 'd!.M!.yyyy',
          options: {
            showWeeks: false,
            minDate: moment(period.StartDate).toDate()
          }
        };
      });
    }, true);
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration')
    .controller('deBlockCtrl', deBlockCtrl);

  /** @ngInject */
  function deBlockCtrl($rootScope, toastr, $uibModalInstance, data) {
    var self = this;
    self.modalInstance = $uibModalInstance;
    self.isDiv = data.isDiv;
    self.isOwn = data.isOwn;
    self.selectedReason = false;
    self.reasonComment = '';
    self.finishSelection = function () {
      $uibModalInstance.close(self.reasonComment);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration')
    .controller('blockCtrl', blockCtrl);

  /** @ngInject */
  function blockCtrl($rootScope, $translate, toastr, $uibModalInstance, data) {
    var self = this;
    self.divList = data.divList;
    self.periods = data.periods;
    self.reasons = data.reasons;
    self.modalInstance = $uibModalInstance;
    self.isDiv = data.isDiv;
    self.selectedReason=false;
    self.reasonComment = '';
    self.nextStep = function(){
      $uibModalInstance.close(true);
    };
    self.finishSelection = function () {
      if(!self.selectedReason){
        //return toastr.error('Bitte hinterlege einen Löschgrund!', 'Vorgang abgebrochen!');
        return toastr.error(
          $translate.instant('modules.personnel.dossier.administration.blockModal.finishSelectionToastText'),
          $translate.instant('modules.personnel.dossier.administration.blockModal.finishSelectionToastTitle')
          );
      }
      $uibModalInstance.close({ reason: self.selectedReason, comment: self.reasonComment });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.general', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.general', {
        url: '/general',
        templateUrl: 'app/pages/administration/personnel/general/general.html',
        title: 'navigation.administration.personnel.general',
        controller: 'AdminPersonnelGeneralCtrl as $ctrl',
        resolve: {
          permittedForAgeSettings: function (permissions) {
            return permissions.isPermittedAnywhere('arno.administration.personnel.ageSettings.manage');
          },
          permittedForDeletionPeriods: function (permissions) {
            return permissions.isPermittedAnywhere('arno.administration.personnel.withdrawal');
          },
          permittedForExternalSystems: function (permissions) {
            return permissions.isPermittedAnywhere('arno.administration.personnel.externalsystems.manage');
          },
          fieldList: function(clientApi, permittedForExternalSystems, $translate) {
            if (!permittedForExternalSystems) {
              return {};
            }

            return clientApi.post('member/getFieldList')
              .then(function (results) {
                var sortedResult = _.sortBy(results, ['i18n']),
                  fieldList = {};
                sortedResult.forEach(function(item){
                  if (item.i18n === 'E-Mail') {
                    fieldList[item.i18n] = item.db;
                  } else {
                    fieldList[$translate.instant('models.' + item.i18n)] = item.i18n;
                  }
                });
                return fieldList;
              });
          },
          periods: function ($rootScope, permittedForDeletionPeriods) {
            if (!permittedForDeletionPeriods) {
              return {};
            }

            return {
              deletionPeriodMonths: $rootScope.ctx.organization.current.deletionPeriodMonths,
              withdrawalPeriodDays: $rootScope.ctx.organization.current.withdrawalPeriodDays
            };
          }
        },
        sidebarMeta: {
          order: 10,
        },
        viewPermission: ['arno.administration.personnel.ageSettings.manage', 'arno.administration.personnel.externalsystems.manage', 'arno.administration.personnel.withdrawal']
      });
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.general')
    .controller('addSystemModalCtrl', addSystemModalCtrl);

  /** @ngInject */
  function addSystemModalCtrl($rootScope, $uibModalInstance, $translate, toastr, data) {
    var self = this;
    self.valid = false;
    self.tagFieldList = [];
    _.forOwn(data.FieldList, function (value, key) {
      self.tagFieldList.push({
        Name: value,
        i18nKey: key,
      });
    });

    self.system = data.system || {
      Name: '',
      EMail: '',
      InfoText: '',
      FieldIdentifier: [],
    };

    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };

    self.validateSystemData = function(){
      if(!self.system.Name){
        toastr.error(
          $translate.instant('modules.administration.adminPersonalSystem.pleaseGiveName'),
          $translate.instant('modules.administration.adminPersonalSystem.incomplete')
          );
        return false;
      }
      if(!self.system.EMail && !self.system.InfoText){
        toastr.error(
          $translate.instant('modules.administration.adminPersonalSystem.pleaseGiveEmail'),
          $translate.instant('modules.administration.adminPersonalSystem.incomplete')
        );
        return false;
      }
      if(!self.system.RequiredFieldIdentifier){
        toastr.error(
          $translate.instant('modules.administration.adminPersonalSystem.pleaseAddReq'),
          $translate.instant('modules.administration.adminPersonalSystem.incomplete')
        );
        return false;
      }
      return true;
    };

    self.close = function() {
      $uibModalInstance.close();
    };

    self.updateSystem = function () {
      if(self.validateSystemData()){
        $uibModalInstance.close(self.system);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.qualifications', [])
    .config(routeConfig);


  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.qualifications', {
        url: '/qualifications',
        title: 'navigation.administration.personnel.qualifications',
        template: '<tabs data="$tabsetCtrl.tabs" template-url="app/pages/administration/personnel/qualifications/tabset/tabset.html"></tabs>',
        controller: 'QualificationTabCtrl as $tabsetCtrl',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.administration.personnel.qualifications.manageQualifications,arno.administration.personnel.qualifications.manageInstructions',
            });
          }
        },
        sidebarMeta: {
          stateRedirect: 'arno.administration.personnel.qualifications.qualifications',
          order: 800,
        },
      })
      .state('arno.administration.personnel.qualifications.qualifications', {
        url: '/qualifications',
        templateUrl: 'app/pages/administration/personnel/qualifications/qualifications.html',
        title: 'navigation.administration.personnel.qualifications',
        controller: 'QualificationCtrl as $ctrl',
        viewPermission: [
          'arno.personnel.dossier.qualification.viewAll',
          'arno.administration.personnel.qualifications.manageQualifications',
        ],
        resolve: {
          ctxSelected: function (divisionId) {
            return divisionId !== null && divisionId.length
          },
          isPermitted: function (permissions, divisionId, $rootScope, isOnOrganizationLevel) {
            if(isOnOrganizationLevel) {
              return permissions.isPermittedInEvery('arno.administration.personnel.qualifications.manageQualifications', 'Organization', [$rootScope.ctx.organization.current.id]);
            }
            return permissions.isPermittedInEvery('arno.administration.personnel.qualifications.manageQualifications', 'Division', [divisionId]);
          },
          qualificationHierarchy: function (clientApi, isPermitted, divisionId) {
            if(isPermitted) {
              return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId:divisionId, type: 'qualification' })
            } 
            return []
          },
          divisionId: function(divisionId) {
            return Array.isArray(divisionId) ? divisionId[0] : divisionId;
          },
          isOnOrganizationLevel: function (divisionId) {
            return divisionId && divisionId === 'rootOrg'
          },
          type: function () {
            return 'qualification';
          },
        },
        sidebarMeta: {
          order: 800,
        },
      })
      .state('arno.administration.personnel.qualifications.instructions', {
        url: '/instructions',
        templateUrl: 'app/pages/administration/personnel/qualifications/qualifications.html',
        title: 'navigation.administration.personnel.qualifications',
        controller: 'QualificationCtrl as $ctrl',
        viewPermission: [
          'arno.personnel.dossier.qualification.viewAll',
          'arno.administration.personnel.qualifications.manageInstructions',
        ],
        resolve: {
          ctxSelected: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.qualifications.manageInstructions', true) !== null 
          },
          isPermitted: function (permissions, divisionId, $rootScope, isOnOrganizationLevel) {
            if(isOnOrganizationLevel) {
              return permissions.isPermittedInEvery('arno.administration.personnel.qualifications.manageInstructions', 'Organization', [$rootScope.ctx.organization.current.id]);
            }
            return permissions.isPermittedInEvery('arno.administration.personnel.qualifications.manageInstructions', 'Division', [divisionId]);
         
          },  
          qualificationHierarchy: function (clientApi, isPermitted, divisionId) {
            if(isPermitted) {
              return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: divisionId, type: 'instruction' })
            }
            return []
          },
          isOnOrganizationLevel: function (divisionId) {
            return divisionId && divisionId === 'rootOrg'
          },
          type: function () {
            return 'instruction';
          },
          divisionId: function(divisionId) {
            return Array.isArray(divisionId) ? divisionId[0] : divisionId;
          }
        },
        sidebarMeta: {
          order: 800,
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.qualifications')
    .controller('QualificationTabCtrl', QualificationTabCtrl);

  function QualificationTabCtrl(permissions, divisionId, $translate) {
    var self = this;
    self.tabs = [
      {
        heading:  $translate.instant('modules.administration.adminQualification.qualifications'),
        route: 'arno.administration.personnel.qualifications.qualifications',
        isPermitted: permissions.isPermittedInSome('arno.administration.personnel.qualifications.view,arno.administration.personnel.qualifications.manageQualifications', 'Division', divisionId),
      },
      {
        heading: $translate.instant('modules.administration.adminQualification.instructions'),
        route: 'arno.administration.personnel.qualifications.instructions',
        isPermitted:permissions.isPermittedInSome('arno.administration.personnel.qualifications.view,arno.administration.personnel.qualifications.manageInstructions', 'Division', divisionId),
      },
    ]

    self.divisionSelectorEntryPermission = 'arno.administration.personnel.qualifications.manageQualifications';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.qualifications')
    .controller('QualificationModalCtrl', QualificationModalCtrl);

  /** @ngInject */
  function QualificationModalCtrl($scope, $uibModalInstance, qualificationHierarchy, qualificationGroup,
    qualification, parentQualifications, childQualifications, toastr, clientApi, $q, commonUtils, $translate, type) {
    var self = this;

    self.isOrg = qualificationGroup.DivisionId === null;
    self.qualificationGroup = qualificationGroup;
    self.qualification = qualification || {};
    self.parentQualifications = parentQualifications;
    self.childQualifications = childQualifications;
    self.qualificationHierarchy = qualificationHierarchy;
    var falsyStates = [null, undefined];
    var validityActiveState = (!~falsyStates.indexOf(self.qualification.ValidityPeriodDays)
      && !~falsyStates.indexOf(self.qualification.ValidityPeriodMonths)
      && !~falsyStates.indexOf(self.qualification.ValidityPeriodYears));
    self.validityHelper = {
      active: validityActiveState,
      days: validityActiveState ? self.qualification.ValidityPeriodDays : 0,
      months: validityActiveState ? self.qualification.ValidityPeriodMonths : 0,
      years: validityActiveState ? self.qualification.ValidityPeriodYears : 1,
    };
    self.type = type;

    self.translateValues = type === 'qualification' ? {
      typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
      typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups'),
      name: self.qualification.Name
    } : {
      typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
      typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups'),
      name: self.qualification.Name
    }

    $scope.$watch(function () {
      return self.validityHelper;
    }, function () {
      if (!self.validityHelper.active) {
        self.qualification.ValidityPeriodDays = null;
        self.qualification.ValidityPeriodMonths = null;
        self.qualification.ValidityPeriodYears = null;
        return;
      }
      self.qualification.ValidityPeriodDays = parseInt(self.validityHelper.days, 10) || 0;
      self.qualification.ValidityPeriodMonths = parseInt(self.validityHelper.months, 10) || 0;
      self.qualification.ValidityPeriodYears = parseInt(self.validityHelper.years, 10) || 0;
    }, true);

    self.excludedParentQualifications = self.qualification.id ? [self.qualification.id] : [];
    self.excludedChildQualifications = self.qualification.id ? [self.qualification.id] : [];

    self.divisionCtx = commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.qualifications.manageQualifications') || commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.qualifications.manageInstructions') || null;
    if (!self.isOrg) {
      // we are in a division, so we have to exclude organizational qualifications from chooseable
      // child qualifications in order to prevent a divisional qualification beeing the parent of
      // a organizational one
      if (self.qualificationHierarchy && self.qualificationHierarchy.length) {
        self.qualificationHierarchy.forEach(function (qualifications) {
          if (qualifications.Qualifications && qualifications.Qualifications.length) {
            self.excludedChildQualifications = self.excludedChildQualifications.concat(
              qualifications.Qualifications
                .filter(function (qualification) {
                  return !qualification.DivisionId; // return those where division id is null (organization level)
                })
                .map(function (qualification) {
                  return qualification.id || qualification.QualificationId;
                })
            )
          }
        })
      }
    }

    self.parentQualificationsChanges = {};
    self.childQualificationsChanges = {};

    self.isQualificationNameExistent = function (qualificationName, exceptionId) {
      return _.find(qualificationHierarchy, function (qualificationGroup) {
        return _.find(qualificationGroup.Qualifications, function (qualification) {
          return qualification.Name && qualificationName && qualification.Name.toLocaleLowerCase() === qualificationName.toLocaleLowerCase() && qualification.id !== exceptionId;
        });
      });
    };

    self.getQualificatioNameFromId = function (id) {
      return clientApi.custom('model/Qualification', 'findOneQualification', { id: id, divisionId: self.divisionCtx })
        .catch(function () {
          return { Name: 'Unknown id ' + id }
        })
        .then(function (qualification) {
          return qualification.Name;
        })
    };

    self.applyModal = function (funcTitle) {
      var resultData = {
        funcTitle: funcTitle,
        qualification: self.qualification,
        translateValues: self.translateValues,
      };
      resultData.qualification.QualificationGroupId = self.qualificationGroup.id;

      if (!resultData.qualification.Type) {
        resultData.qualification.Type = type;
      }
      resultData.type = type;

      var waitForPromises = [];

      /* eslint no-extra-boolean-cast:0 */
      if (!!~['addQualification', 'editQualification'].indexOf(funcTitle)) {

        var parseChanges = function (changes) {
          var parsed = {};
          ['add', 'delete'].forEach(function (mode) {
            parsed[mode] = changes[mode].map(function (qualification) {
              return qualification.IncludedQualificationId || qualification.QualificationId;
            })
          });
          return parsed;
        };

        resultData.changes = {
          parent: { add: [], delete: [] },
          child: { add: [], delete: [] }
        };

        if (self.parentQualificationsChanges && Object.keys(self.parentQualificationsChanges).length) {
          resultData.changes.parent = parseChanges(self.parentQualificationsChanges);
        }

        if (self.childQualificationsChanges && Object.keys(self.childQualificationsChanges).length) {
          resultData.changes.child = parseChanges(self.childQualificationsChanges);
        }

        waitForPromises.push(clientApi.emit('qualification/checkCircularDependency',
          {
            qualificationId: self.qualification.id || null,
            changes: resultData.changes
          })
          .then(function (result) {
            if (result && result.circular && result.circular.parent && result.circular.parent.length) {
              return $q.all(result.circular.parent
                .map(function (circularParent) {
                  return self.getQualificatioNameFromId(circularParent)
                }))
                .then(function (qualificationList) {
                  throw new Error($translate.instant('modules.administration.adminQualification.oneOrMoreAdultQualifications') +
                    $translate.instant('modules.administration.adminQualification.qualification') + (qualificationList.length > 1 ? 'en' : '') + ' "' + qualificationList.join(', ') + $translate.instant('modules.administration.adminQualification.as') +
                    $translate.instant('modules.administration.adminQualification.kidQualification') + (qualificationList.length > 1 ? 'en' : '') + '. ' +
                    $translate.instant('modules.administration.adminQualification.kidReference'));
                });
            }
            return result;
          })
          .then(function (result) {
            if (result && result.circular && result.circular.child && result.circular.child.length) {
              return $q.all(result.circular.child
                .map(function (circularChild) {
                  return self.getQualificatioNameFromId(circularChild)
                }))
                .then(function (qualificationList) {
                  throw new Error($translate.instant('modules.administration.adminQualification.oneOrMoreKidQualifications') +
                    $translate.instant('modules.administration.adminQualification.qualification') + (qualificationList.length > 1 ? 'en' : '') + ' "' + qualificationList.join(', ') + $translate.instant('modules.administration.adminQualification.as') +
                    $translate.instant('modules.administration.adminQualification.adultQualification') + (qualificationList.length > 1 ? 'en' : '') + '. ' +
                    $translate.instant('modules.administration.adminQualification.adultReference'));
                });
            }
            return null;
          }));
      }
      if (waitForPromises.length) {
        $q.all(waitForPromises)
          .then(function () {
            $uibModalInstance.close(resultData);
          })
          .catch(function (e) {
            toastr.warning(e.toString().replace('Error: ', ''), $translate.instant('modules.administration.adminQualification.circleRef'));
          });
      } else {
        $uibModalInstance.close(resultData);
      }
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.withdrawal', [])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.withdrawal', {
        url: '/reasonWithdrawal',
        templateUrl: 'app/pages/administration/personnel/withdrawal/withdrawalList.html',
        title: 'navigation.administration.personnel.withdrawal',
        controller: 'WithdrawalListCtrl as $ctrl',
        resolve: {
          fetchHistoryData: function (clientApi) {
            return function (queryWishes) {
              return clientApi
                .custom('model/LogJournal', 'fetchThingLogs', {
                  queryWishes: queryWishes,
                  types: ['WITHDRAWALREASON_CREATE', 'WITHDRAWALREASON_EDIT', 'WITHDRAWALREASON_DELETE']
                });
            }
          },
          historyData: function (fetchHistoryData) {
            return fetchHistoryData({ paging: { offset: 0, limit: 10 }, sort: { by: 'createdAt', reverse: true } });
          }
        },
        sidebarMeta: {
          order: 20,
        },
        viewPermission: 'arno.administration.personnel.withdrawal'
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.withdrawal')
    .controller('HandleReasonWithdrawal', HandleReasonWithdrawal);

  /** @ngInject */
  function HandleReasonWithdrawal($rootScope, $uibModalInstance, clientApi, data, $translate) {
    var self = this;

    self.reasonName = data.reasonName || '';
    self.reasonId = data.reasonId || false;
    self.isDiv = data.isDiv;
    self.level = data.isDiv ? $translate.instant('modules.administration.adminWithdrawl.divLevel') : $translate.instant('modules.administration.adminWithdrawl.orgaLevel');

    self.handleReason = function () {
      $uibModalInstance.close({reasonName: self.reasonName, id: self.reasonId})
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.withdrawal')
    .controller('ReasonAddWithdrawalCtrl', ReasonAddWithdrawalCtrl);

  /** @ngInject */
  function ReasonAddWithdrawalCtrl($rootScope, toastr, $uibModalInstance, clientApi, data) {
    var self = this;

    self.isDiv = data.isDiv;

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.trainings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.trainings', {
        url: '/trainings',
        templateUrl: 'app/pages/administration/personnel/trainings/overview/trainings.tpl.html',
        title: 'navigation.administration.personnel.trainings',
        controller: 'AdminPersonnelTrainingsController',
        controllerAs: '$ctrl',
        sidebarMeta: {
          order: 800,
        },

        resolve: {
          ctxSelected: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.trainings.manage', true) !== null;
          },

          trainingsNodesData: function(ArnoDashTrainingGroupsService) {
            return ArnoDashTrainingGroupsService.getGroupsTreeData(
              true,
              ArnoDashTrainingGroupsService.FORMAT_TRAININGS_GROUPS_TREE_TYPE_ANGULAR_TREE_CONTROL,
              true
            );
          },

          categories: function (clientApi) {
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { usages: ['Training']});
          },
          qualificationsHierarchy: function (ArnoDashQualificationGroupsService) {
            return ArnoDashQualificationGroupsService.getQualificationGroups();
          },
          flatQualifications: function (qualificationsHierarchy) {
            return _.flatMap(qualificationsHierarchy, function(qualificationGroup) {
              // add a reference of qualification-group to each qualification for later use in qualificationList
              // its important to pick only the 2 needed fields to avoid circularity
              _.forEach(qualificationGroup.Qualifications, function(qualification) {
                qualification.QualificationGroup = _.pick(qualificationGroup, ['id', 'Name']);
              });

              return qualificationGroup.Qualifications;
            });
          },
        },

        viewPermission: 'arno.administration.personnel.trainings',
        viewPermissionScopes: ['Organization'],
      });
  }
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.personnel.trainings')
    .controller('AdminPersonnelTrainingsController', AdminPersonnelTrainingsController);

  /**
  * @description Controller for the administration-personnel-trainings module.
  *
  * @namespace BlurAdmin.pages.administration.personnel.trainings.AdminPersonnelTrainingsController
  */
  /** @ngInject */
  function AdminPersonnelTrainingsController(
    $rootScope, $scope, $timeout, $log, $element, $translate,
    stateChangePrompt, permissions, toastr, commonUtils, baModalService,// common-services
    ArnoDashTrainingGroupsService, ArnoDashTrainingTemplatesService, // app-services
    trainingsNodesData, categories, qualificationsHierarchy, flatQualifications// resolvers
  ) {
    var $ctrl = this;

    // VARS
    var newIdTrainingTemplateGroupCounter = 0;
    var newIdTrainingTemplateCounter = 0;

    // VIEW-VARS
    $ctrl.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP = ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP;
    $ctrl.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE = ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE;

    $ctrl.memberEmail = $rootScope.ctx.currentUser.eMail;
    $ctrl.memberDivisionId = $rootScope.ctx.currentUser.DivisionMember ? $rootScope.ctx.currentUser.DivisionMember.MemberId : null;

    var rootNode = {
      id: '#',
      iconCls: 'fa fa-users',
      children: trainingsNodesData,
      parent: '#',
      label: $rootScope.ctx.organization.current.name,
      state: {
        opened: true
      }
    }
    $ctrl.selectedNode = rootNode;

    $ctrl.trainingsNodesData = [rootNode];

    $ctrl.filterTrainingTemplateOptions = { on: $translate.instant('modules.administration.adminTrainings.showTemplate'), off: $translate.instant('modules.administration.adminTrainings.hideTemplate') };
    $ctrl.filterTrainingTemplateHints = {
      on: $translate.instant('modules.administration.adminTrainings.showAllTrainingTemplates'),
      off: $translate.instant('modules.administration.adminTrainings.hideAllTrainingTemplates')
    };

    $ctrl.categories = categories;
    $ctrl.qualificationsHierarchy = qualificationsHierarchy;

    $ctrl.trainingTemplateGroupsConfig = {
      core: {
        multiple: false,
        check_callback: true,
        themes: {
          responsive: false
        }
      },
      types: {
        default: {
          icon: 'fa fa-sitemap'
        }
      },
      plugins: ['types', 'sort'],
      version: 1
    };

    $ctrl.showTrainingsTemplates = true;
    $ctrl.treeviewCollapsed = false;

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf AdminPersonnelTrainingsController#
    */
    function activate() {
      setupWatchers();

      // further binding helpers to view-functions
      $ctrl.isNewNode = isNewNode;

      // event-binding for treeview
      $ctrl.trainingTemplateGroupsTreeEvents = {
        ready: $ctrl.onReady,
        'select_node': $ctrl.onSelectedNode
      }

      // presets the categories from $ctr.categories so the tag-picker can associate the chosen tags correctly
      // the BaseCategories in a TrainingTemplate object wont work, this is how the tag-picker currently work
      _.forEach($ctrl.trainingsNodesData, function(nodeData) {
        if (nodeData && nodeData.data && nodeData.data.model && nodeData.data.model.BaseCategories) {
          _.forEach(nodeData.data.model.BaseCategories, function(category, index) {
            nodeData.data.model.BaseCategories[index] = _.find(categories, { id: category.id });
          });
        }
      });
    }

    // EVENT-HANDLERS
    $ctrl.selectNode = function(node, form) {
      if (!$ctrl.selectedNode || !$ctrl.selectedNode.id || form && form.$pristine || node.id === '#' || node.id === $ctrl.selectedNode.id) {
        $ctrl.selectedNode = node;
      } else {
        handleNodeChange($ctrl.selectedNode)
          .then(function() {
            // user wants to stay on the current selection
          })
          .catch(function() {
            // time this out otherwise it would run in the next digest cycle and not immediately
            $timeout(function() {
              $ctrl.selectedNode = node;
            })
          })
      }
    }

    $ctrl.addNewNode = function (nodeType) {
      var selectedNode = $ctrl.selectedNode

      var newNodeId;
      var namePrefix = '';
      var parentId;

      // switch nodeType and create either training-template-group or training-group
      // OPTIMIZE: move to helper-fn, reduce complexity here
      switch (nodeType) {
      case ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP:
          // check if parent-node is a training-template, groups cant be added into templates....
        if (selectedNode && selectedNode.data && selectedNode.data.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
          return toastr.warning($translate.instant('modules.administration.adminTrainings.trainingGroupsCantAdd'), $translate.instant('modules.administration.adminTrainings.addFailed'));
        }

        namePrefix = $translate.instant('modules.administration.adminTrainings.newTrainingsGroup');
        newIdTrainingTemplateGroupCounter = getValidNewNodeNameIndex($ctrl.trainingsNodesData, namePrefix, newIdTrainingTemplateGroupCounter);

        newNodeId = 'n-g-' + newIdTrainingTemplateGroupCounter;
        if (selectedNode.modelId) {
          parentId = selectedNode.modelId;
        } else if (selectedNode.data && selectedNode.data.model && selectedNode.data.model.id) {
          parentId = selectedNode.data.model.id;
        } else {
          parentId = '#';
        }

        commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
          if (node.id === selectedNode.id) {
            node.children.push({
              id: newNodeId,
              iconCls: 'fa fa-sitemap',
              data: {
                type: ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP,
                model: {}
              },
              parent: parentId,
              label: namePrefix + newIdTrainingTemplateGroupCounter,
              state: {
                opened: true
              },
              children: [],
            });
            $ctrl.selectedNode = node.children[node.children.length-1];
          }
        })
        break;

      case ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE:
          // check if node-parent is a group (so adding a template w/o group, means adding to org is not possible!), if not then template cant be added
        if (!selectedNode) {
          return toastr.error($translate.instant('modules.administration.adminTrainings.trainingTemplateCantWithoutGroups'), $translate.instant('modules.administration.adminTrainings.addFailed'));
        }

        if (selectedNode.data.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
          return toastr.warning($translate.instant('modules.administration.adminTrainings.trainingsTemplatedIntoEachOther'), $translate.instant('modules.administration.adminTrainings.addFailed'));
        }

        if (selectedNode.data.type !== ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP) {
          return toastr.warning($translate.instant('modules.administration.adminTrainings.requirementForTrainingTemplate'), $translate.instant('modules.administration.adminTrainings.addFailed'));
        }

        namePrefix = $translate.instant('modules.administration.adminTrainings.namePrefix');
        newIdTrainingTemplateCounter = getValidNewNodeNameIndex($ctrl.trainingsNodesData, namePrefix, newIdTrainingTemplateCounter);

        newNodeId = 'n-t-' + newIdTrainingTemplateCounter;

        if (selectedNode.modelId) {
          parentId = selectedNode.modelId;
        } else if (selectedNode.data && selectedNode.data.model && selectedNode.data.model.id) {
          parentId = selectedNode.data.model.id;
        } else {
          parentId = '#';
        }

        commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
          if (node.id === selectedNode.id) {
            if (!node.children) {
              node.children = [];
            }
            node.children.push({
              id: newNodeId,
              iconCls: 'fa fa-file-text-o',
              data: {
                type: ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE,
                validityHelper: { // move this to separate component
                  active: true,
                  days: $ctrl.selectedNode && $ctrl.selectedNode.data.model ? $ctrl.selectedNode.data.model.ValidityPeriodDays || 0 : 0,
                  months: $ctrl.selectedNode && $ctrl.selectedNode.data.model ? $ctrl.selectedNode.data.model.ValidityPeriodMonths  || 0 : 0,
                  years: $ctrl.selectedNode && $ctrl.selectedNode.data.model ? $ctrl.selectedNode.data.model.ValidityPeriodYears || 0 : 1,
                },
                changedQualifications: [],
                displayedCollection: [],
                selectedQualification: {},
                model: {},
                vm: {
                  Qualifications: [],
                  BaseCategories: []
                }
              },
              parent: parentId,
              label: namePrefix + newIdTrainingTemplateCounter,
              icon: 'fa fa-file-text-o',
              state: {
                opened: true
              }
            });
            $ctrl.selectedNode = node.children[node.children.length-1];
          }
        });
        break;

      default:
        $log.error('ERROR: AdminPersonnelTrainingsController#addNewNode: given node-type is unknown!');
        return;
      }
    };

    $ctrl.trainingTemplatesVisibilityChanged = function(newVisibility) {
      commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
        if (node.data && node.data.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
          node.hidden = !newVisibility;
        }
      })

      commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
        if (node.children && node.children.length) {
          node.hideChevron = true;
          node.children.forEach(function(child) {
            if (!child.hidden) {
              node.hideChevron = false;
            }
          })
        }
      })
    }

    $ctrl.toggleCollapsed = function () {
      $ctrl.treeviewCollapsed = !$ctrl.treeviewCollapsed;
      commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
        node.collapsed = $ctrl.treeviewCollapsed;
      })

      commonUtils.preference.bool.set('trainingsTreeViewOpened', $ctrl.treeviewCollapsed);
    }

    $ctrl.removeUnsavedNode = function () {
      if (!$ctrl.deletableNewNode() || !$ctrl.trainingsNodesData.length) {
        return null;
      }

      commonUtils.recurseTree($ctrl.trainingsNodesData, function(node, index, layer) {
        if (node.id === $ctrl.selectedNode.id) {
          layer.splice(index, 1);
        }
      })
      $ctrl.selectedNode = {};
    }

    $ctrl.saveTrainingTemplateGroup = function(nodeToSave, form) {
      if (form && !form.$valid) {
        return false;
      }

      if (nodeToSave.data.type === ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP) {
        var convertedTrainingTemplateGroup = convertTreeNodeToDbData(nodeToSave);

        if (convertedTrainingTemplateGroup) {
          ArnoDashTrainingGroupsService.saveGroup(convertedTrainingTemplateGroup)
            .then(function(results) {
              // check for id if it was a create-operation, or for 1 if it was an update of the TrainingTemplateGroup
              if (results && (results.id || (results.length && results[0] === 1))) {
                // important: update the id in the frontend-cache, so node is not recognized as new node!
                if (results.id) {
                  nodeToSave.data.model = results;
                  var newNodeId = results.id.toString(); // IMPORTANT: a prefix must be added to avoid CPNFLICTS with training-groups-id

                  commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
                    if (node.id === nodeToSave.id) {
                      node.id = newNodeId;
                    }
                  })
                }
                else {
                  // its important to take the cache object because api returns only "[1]" for success,
                  // you could fetch the data after update in api too, but means 1 more db-request
                  // whats not necessary, if you just take the cache object
                  nodeToSave.data.model = convertedTrainingTemplateGroup;
                }

                toastr.success($translate.instant('modules.administration.adminTrainings.theTrainingTemplate')+ convertedTrainingTemplateGroup.Name + $translate.instant('modules.administration.adminTrainings.wasSuccessSaved'), $translate.instant('modules.administration.adminTrainings.saveSuccess'));
                $ctrl.trainingTemplateGroupForm.$setPristine();
              }
            })
            .catch(function(error) {
              switch((error.data || {}).key) {
              case 'TRAINING_TEMPLATE_GROUP_SAVE_NAME_CONFLICTING':
                toastr.error($translate.instant('modules.administration.adminTrainings.itExistATrainingGroup'), $translate.instant('modules.administration.adminTrainings.saveFailed'));
                break;

              default:
                toastr.error('Das Speichern der Fortbildungsgruppe schlug fehl, probiere es bitte erneut!', $translate.instant('modules.administration.adminTrainings.saveFailed'));
              }

              $log.error('ERROR: AdminPersonnelTrainingsController.saveTrainingTemplateGroup: save of TrainingTemplateGroup failed!\n',
                convertedTrainingTemplateGroup, '\n', error
              );
            });
        }
        else {
          $log.error('ERROR: AdminPersonnelTrainingsController.saveTrainingTemplateGroup: Converting treeview-node and data to TrainingTemplateGroup failed!', nodeToSave);
        }
      }
    }

    $ctrl.removeTrainingTemplateGroup = function(nodeToDelete) {
      var convertedTrainingTemplateGroup = convertTreeNodeToDbData(nodeToDelete);

      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: true,

        title: '"' + convertedTrainingTemplateGroup.Name + $translate.instant('modules.administration.adminTrainings.deleteTraining'),
        content: $translate.instant('modules.administration.adminTrainings.requireDeleteTrainingsGroup') + '<br>' + '<br>' +
                  '<b>' + $translate.instant('modules.administration.adminTrainings.attentionTraining') + '</b>' + '<br>' + $translate.instant('modules.administration.adminTrainings.contentAll') +  '<b>' + $translate.instant('modules.administration.adminTrainings.underContentGroups') + '</b>' + $translate.instant('modules.administration.adminTrainings.inContain') + '<b>' + $translate.instant('modules.administration.adminTrainings.trainingTemplates') + '</b>' + $translate.instant('modules.administration.adminTrainings.contentAsWellAs') + '<b>' + $translate.instant('modules.administration.adminTrainings.contentAllAffected') +
                  $translate.instant('modules.administration.adminTrainings.trainings') + '</b>' + $translate.instant('modules.administration.adminTrainings.contentWasDelete'),

        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
        .then(function() {
          ArnoDashTrainingGroupsService.deleteGroup(convertedTrainingTemplateGroup.id)
            .then(function(results) {
              if (results) {
                commonUtils.recurseTree($ctrl.trainingsNodesData, function(node, index, layer) {
                  if (node.id === nodeToDelete.id) {
                    layer.splice(index, 1);
                  }
                })
                $ctrl.selectedNode = {};
                toastr.success($translate.instant('modules.administration.adminTrainings.theTrainingTemplate')+ convertedTrainingTemplateGroup.Name + $translate.instant('modules.administration.adminTrainings.wasSuccesfulDeletion'), $translate.instant('modules.administration.adminTrainings.deletionSuccess'));
              }
            })
            .catch(function(error) {
              toastr.error($translate.instant('modules.administration.adminTrainings.theDelteOfContentGroupIsFailed'), $translate.instant('modules.administration.adminTrainings.deletionFailed'));

              $log.error('ERROR: AdminPersonnelTrainingsController.removeTrainingTemplateGroup: delete of TrainingTemplateGroup failed!\n',
                convertedTrainingTemplateGroup, '\n', error
              );
            });
        });
    }

    $ctrl.saveTrainingTemplate = function(nodeToSave, form) {
      if (form && !form.$valid) {
        return false;
      }

      if (nodeToSave.data.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
        var convertedTrainingTemplate = convertTreeNodeToDbData(nodeToSave);

        if (convertedTrainingTemplate) {
          ArnoDashTrainingTemplatesService.saveTemplate(convertedTrainingTemplate)
            .then(function(results) {
              // check for id if it was a create-operation, or for 1 if it was an update of the TrainingTemplate
              if (results && (results.id || (results.length && results[0] === 1))) {
                // important: update the id in the frontend-cache, so node is not recognized as new node!
                if (results.id) {
                  nodeToSave.data.model = results;
                  var newNodeId = 'template-' + results.id.toString(); // IMPORTANT: a prefix must be added to avoid CPNFLICTS with training-groups-id

                  commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
                    if (node.id === nodeToSave.id) {
                      node.id = newNodeId;
                    }
                  })
                  nodeToSave.id = newNodeId;
                }

                toastr.success($translate.instant('modules.administration.adminTrainings.theTrainingTemplates') + convertedTrainingTemplate.Name + $translate.instant('modules.administration.adminTrainings.wasSuccessSaved'), $translate.instant('modules.administration.adminTrainings.saveSuccess'));
                $ctrl.trainingTemplateForm.$setPristine();
              }
            })
            .catch(function(error) {
              switch((error.data || {}).key) {
              case 'TRAINING_TEMPLATE_SAVE_NAME_CONFLICTING':
                toastr.error($translate.instant('modules.administration.adminTrainings.existAlreadyATemplate'), $translate.instant('modules.administration.adminTrainings.saveFailed'));
                break;

              default:
                toastr.error($translate.instant('modules.administration.adminTrainings.saveOfTrainingTemplateIsFailed'), $translate.instant('modules.administration.adminTrainings.saveFailed'));
              }

              $log.error('ERROR: AdminPersonnelTrainingsController.saveTrainingTemplate: save of TrainingTemplate failed!\n',
                convertedTrainingTemplate, '\n', error
              )
            });
        }
        else {
          $log.error('ERROR: AdminPersonnelTrainingsController.saveTrainingTemplate: Converting treeview-node and data to TrainingTemplate failed!', nodeToSave);
        }
      }
    }

    $ctrl.removeTrainingTemplate = function(nodeToDelete) {
      var convertedTrainingTemplate = convertTreeNodeToDbData(nodeToDelete);

      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: true,

        title: '"' + convertedTrainingTemplate.Name + $translate.instant('modules.administration.adminTrainings.deleteTraining'),
        content:  $translate.instant('modules.administration.adminTrainings.requestDeleteTrainingTemplate') + '<br>' + '<br>' +
                  '<b>' + $translate.instant('modules.administration.adminTrainings.attentionTraining') + '</b>' + '<br>' + $translate.instant('modules.administration.adminTrainings.attentionAllTraining') + $translate.instant('modules.administration.adminTrainings.templateIsLinked'),

        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
        .then(function() {
          ArnoDashTrainingTemplatesService.deleteTemplate(convertedTrainingTemplate.id)
            .then(function(results) {
              if (results) {
                commonUtils.recurseTree($ctrl.trainingsNodesData, function(node, index, layer) {
                  if (node.id === nodeToDelete.id) {
                    layer.splice(index, 1);
                  }
                })
                $ctrl.selectedNode = {};
                toastr.success($translate.instant('modules.administration.adminTrainings.theTrainingTemplates')+ convertedTrainingTemplate.Name + $translate.instant('modules.administration.adminTrainings.wasSuccesfulDeletion'), $translate.instant('modules.administration.adminTrainings.deletionSuccess'));
              }
            })
            .catch(function(error) {
              toastr.error($translate.instant('modules.administration.adminTrainings.deleteOfTrainingsTemplateFailed'), $translate.instant('modules.administration.adminTrainings.deletionFailed'));

              $log.error('ERROR: AdminPersonnelTrainingsController.removeTrainingTemplate: delete of TrainingTemplate failed!\n',
                convertedTrainingTemplate, '\n', error
              );
            });
        });
    }

    // VIEW-FUNCTIONS
    $ctrl.isFieldInvalid = function(form, field) {
      return (field.$touched || form.$submitted) && Object.keys(field.$error).length;
    }

    $ctrl.showAddTrainingTemplateGroupBtn = function() {
      return ($ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.manage')
          && $ctrl.selectedNode && $ctrl.selectedNode.data && !isNewNode($ctrl.selectedNode)
          && $ctrl.selectedNode.data.type === ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP)
        || !$ctrl.selectedNode
        || !$ctrl.selectedNode.data // this indicates the root-node, which does not have a data-prop assigned to it!
    }

    $ctrl.showAddTrainingTemplateBtn = function() {
      return $ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.manage')
        && $ctrl.selectedNode && $ctrl.selectedNode.data && !isNewNode($ctrl.selectedNode)
        && $ctrl.selectedNode.data.type === ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP;
    }

    $ctrl.showTrainingTemplateGroupsEdit = function() {
      return (
        $ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.manage') || $ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.view'))
        && $ctrl.selectedNode && $ctrl.selectedNode.data
        && $ctrl.selectedNode.data.type === ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP;
    }

    $ctrl.showTrainingTemplateEdit = function() {
      return (
        $ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.manage')  || $ctrl.isPermittedInCurrentOrg('arno.administration.personnel.trainings.view'))
        && $ctrl.selectedNode && $ctrl.selectedNode.data
        && $ctrl.selectedNode.data.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE;
    }

    $ctrl.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    }

    $ctrl.deletableNewNode = function () {
      return isNewNode($ctrl.selectedNode);
    }

    $ctrl.showSwitcher = function() {
      var templatesAvailable = false;
      commonUtils.recurseTree($ctrl.trainingsNodesData, function(node) {
        if (node.data && node.type === ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE) {
          templatesAvailable = true;
        }
      })
      return templatesAvailable;
    }

    $ctrl.rollbackTrainingTemplateGroupChanges = function(node, form) {
      if (node) {
        commonUtils.recurseTree($ctrl.trainingsNodesData, function(treeNode) {
          if (node.id === treeNode.id) {
            treeNode.label = node.data.model.Name;
          }
        })
        if (form) {
          form.$setPristine();
        }
      }
    }

    $ctrl.rollbackTrainingTemplateChanges = function(node, form) {
      // TODO-IMPORTANT: after CLEARIFICATION of countable-hours: add logic to rollback to old countable hours from model

      if (node) {
        commonUtils.recurseTree($ctrl.trainingsNodesData, function(treeNode) {
          if (node.id === treeNode.id) {
            treeNode.label = node.data.model.Name;
            treeNode.data.vm.Notes = node.data.model.Notes;
            treeNode.data.vm.CountableHours = node.data.model.CountableHours;
            treeNode.data.vm.BaseCategories = node.data.model.BaseCategories;

            treeNode.data.vm.Qualifications = node.data.model.Qualifications;
            treeNode.data.changedQualifications = {};

            treeNode.data.validityHelper.days = node.data.model.ValidityPeriodDays;
            treeNode.data.validityHelper.months = node.data.model.ValidityPeriodMonths;
            treeNode.data.validityHelper.years = node.data.model.ValidityPeriodYears;
          }
        })
        if (form) {
          form.$setPristine();
        }
      }
    }

    $ctrl.checkName = function(node) {
      if (!node) {
        return false;
      }

      var id = node.id;
      var type = node.data && node.data ? node.data.type : null;
      var name = node.label;
      var parent = node.parent;

      var foundConflicting = _.filter($ctrl.trainingsNodesData, function(filterNode) {
        return (id && filterNode && filterNode.data
          && filterNode.data.model.Name === name
          && filterNode.data.type === type
          && filterNode.id && filterNode.id !== id && filterNode.parent == parent
        );
      });

      // check, if its the same node and same parent
      if (foundConflicting && foundConflicting.length) {
        return false;
      }

      return true;
    }

    // HELPERS
    function setupWatchers() {
      // watcher to switch visibility of training-templates in treeview
      $scope.$watch(function () {
        return $ctrl.showTrainingsTemplates;
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $ctrl.trainingTemplatesVisibilityChanged(newVal);
        }
      }, true);
    }

    function isNewNode(node) {
      return node && node.id && typeof node.id.indexOf === 'function' && node.id.indexOf('n-') === 0;
    }

    function handleNodeChange(currentSelectedNode) {
      if (!currentSelectedNode || !currentSelectedNode.data) {
        return Promise.reject(new Error(false));
      }

      switch(currentSelectedNode.data.type) {
      case ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP:
        // check if there were changes!
        if ($ctrl.trainingTemplateGroupForm && $ctrl.trainingTemplateGroupForm.$dirty || isNewNode(currentSelectedNode)) {
          return baModalService.messageModal({
            modalType: 'warning',
            allowHtml: false,

            title: $translate.instant('modules.administration.adminTrainings.changeOfTrainingGroups'),
            content: $translate.instant('modules.administration.adminTrainings.youHasChangesInTheTrainingGroup') + currentSelectedNode.label + $translate.instant('modules.administration.adminTrainings.willDiscard'),

            primaryActionText: $translate.instant('modules.administration.adminTrainings.moreEdit'),
            secondaryActionText: $translate.instant('modules.administration.adminTrainings.discardChanges')
          })
            .then(function() {
              return true;
            })
            .catch(function() {
              if  (isNewNode(currentSelectedNode)) {
                commonUtils.recurseTree($ctrl.trainingsNodesData, function(node, index, tree) {
                  if (node.id === currentSelectedNode.id) {
                    tree.splice(index, 1);
                  }
                })
              }
              else {
                // ROLLBACK to old data!
                $ctrl.rollbackTrainingTemplateGroupChanges(currentSelectedNode, $ctrl.trainingTemplateGroupForm);
              }

              $ctrl.trainingTemplateGroupForm.$setPristine();
              throw false;
            });
        }

        return Promise.reject(new Error(false));

      case ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE:
        // check if there were changes!
        if ($ctrl.trainingTemplateForm && $ctrl.trainingTemplateForm.$dirty || isNewNode(currentSelectedNode)) {
          return baModalService.messageModal({
            modalType: 'warning',
            allowHtml: false,

            title: $translate.instant('modules.administration.adminTrainings.changeOfTrainingsTemplates'),
            content: $translate.instant('modules.administration.adminTrainings.changeOfTrainingsTemplates') + currentSelectedNode.label + $translate.instant('modules.administration.adminTrainings.willDiscard'),

            primaryActionText: $translate.instant('modules.administration.adminTrainings.moreEdit'),
            secondaryActionText: $translate.instant('modules.administration.adminTrainings.discardChanges')
          })
            .then(function() {
              return true;
            })
            .catch(function() {
              if  (isNewNode(currentSelectedNode)) {
                commonUtils.recurseTree($ctrl.trainingsNodesData, function(node, index, tree) {
                  if (node.id === currentSelectedNode.id) {
                    tree.splice(index, 1);
                  }
                })
              }
              else {
                // ROLLBACK to old data!
                $ctrl.rollbackTrainingTemplateChanges(currentSelectedNode, $ctrl.trainingTemplateForm);
              }

              $ctrl.trainingTemplateForm.$setPristine();
              throw false;
            });
        }

        return Promise.reject(new Error(false));

      default:
        return Promise.reject(new Error(false));
      }
    }

    // OPT: maybe include training-templates here, or handle them separately,
    // so the backend model of TraingTemplateGroup doesn't have to handle it!
    function convertTreeNodeToDbData(treeNode) {
      // take the data.model object in tree-node as base
      if (!treeNode || !treeNode.data || !treeNode.data.model) {
        $log.error('ERROR: AdminPersonnelTrainingsController.convertTreeNodeToDbData: tree-node nodes not have a valid model!\n', treeNode);
        return null;
      }

      switch (treeNode.data.type) {
      case ArnoDashTrainingGroupsService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP:
        // sequelize can handle string-id as numbers, so no convert from string to number is needed here for id
        treeNode.data.model.id = isNewNode(treeNode) ? null : treeNode.data.model.id
        treeNode.data.model.Name = treeNode.label;
        treeNode.data.model.ParentTrainingTemplateGroupId = treeNode.parent === '#' ? null : parseInt(treeNode.parent);
        break;

      case ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE:
          // sequelize can handle string-id as numbers, so no convert from string to number is needed here for id
        treeNode.data.model.id = isNewNode(treeNode) ? null : treeNode.data.model.id,
        treeNode.data.model.Name = treeNode.label;
        treeNode.data.model.TrainingTemplateGroupId = treeNode.parent === '#' ? null : parseInt(treeNode.parent);

        treeNode.data.model.ValidityPeriodDays = treeNode.data.validityHelper.days;
        treeNode.data.model.ValidityPeriodMonths = treeNode.data.validityHelper.months;
        treeNode.data.model.ValidityPeriodYears = treeNode.data.validityHelper.years;

        treeNode.data.model.BaseCategories = treeNode.data.vm.BaseCategories;
        treeNode.data.model.Notes = treeNode.data.vm.Notes;

        // check for added/delete qualifications, from treeNode.data.changedQualifications
        if (treeNode.data.changedQualifications && (treeNode.data.changedQualifications.add || treeNode.data.changedQualifications.delete)) {
          var addedQualifications;

          if (treeNode.data.changedQualifications.add) {
            addedQualifications = _.filter(flatQualifications, function(qualification) {
              return treeNode.data.changedQualifications.add.indexOf(qualification.id) > -1;
            });
          }

          var newQualifications = addedQualifications && addedQualifications.length ? treeNode.data.vm.Qualifications.concat(addedQualifications) : treeNode.data.vm.Qualifications;
          _.remove(newQualifications, function(qualification) {
            return treeNode.data.changedQualifications.delete.indexOf(qualification.id) > -1;
          });

          newQualifications = _.uniqBy(newQualifications, 'id');
          treeNode.data.model.Qualifications = newQualifications;

          treeNode.data.vm.Qualifications = newQualifications; // update the view-model
        }

        treeNode.data.model.CountableHours = treeNode.data.vm.CountableHours;
        break;

      default:
        $log.error('ERROR: AdminPersonnelTrainingsController.convertTreeNodeToDbData: unknown node-type, cant convert tree-node to db-object!\n', treeNode);
        return null;
      }

      return treeNode.data.model;
    }

    function getValidNewNodeNameIndex(treeDataArray, prefixName, counter) {
      // dont use while to find until a valid name was found
      // try max. 10000 names
      var checkName, found;

      for(var i=1;i<10000;i++) {
        checkName = prefixName + (++counter);
        found = _.find(treeDataArray, { text: checkName});

        if (!found) {
          break;
        }
      }

      return counter;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.qualifications')
    .controller('QualificationGroupModalCtrl', QualificationGroupModalCtrl);

  /** @ngInject */
  function QualificationGroupModalCtrl($uibModalInstance, qualificationHierarchy, qualificationGroup, $translate, type) {
    var self = this;

    self.qualificationGroup = qualificationGroup;

    self.translateValues = type === 'qualification' ? {
      typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
      typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups'),
      name: self.qualificationGroup && self.qualificationGroup.Name
    } : {
      typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
      typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups'),
      name: self.qualificationGroup && self.qualificationGroup.Name
    }

    self.isGroupNameExistent = function (qualificationGroupName, exceptionId) {
      return _.find(qualificationHierarchy, function (qualification) {
        return qualification.Name
          && qualificationGroupName
          && qualification.Name.toLocaleLowerCase() === qualificationGroupName.toLocaleLowerCase()
          && qualification.id !== exceptionId;
      });
    };

    self.applyModal = function (name, id, funcTitle, desc) {
      $uibModalInstance.close({
        name: name,
        desc: desc,
        id: id,
        funcTitle: funcTitle,
        children: self.selectedChildren,
        type: type,
        translateValues: self.translateValues
      });
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.arnoAdministration', {
        abstract: true,
        url: '/arnoAdministration',
        title: 'ARNO-Admin',
        template: '<ui-view name="administrators"></ui-view><ui-view name="organizations"></ui-view>',
        sidebarMeta: {
          stateRedirect: 'arno.arnoAdministration.overview',
          order: 1001,
          icon: 'ion-settings'
        },
        viewPermission: 'arno.arnoAdministration',
      })
      .state('arno.arnoAdministration.overview', {
        url: '',
        title: 'ARNO Administration',
        resolve: {
          administrators: function (clientApi) {
            return clientApi.custom('model/Member', 'findSuperAdministrators', {});
          },
          organizations: function (clientApi) {
            return clientApi.custom('model/Organization', 'getNonVirtualOrganizations', {})
          },
          demoOrganizations: function(clientApi) {
            return clientApi.custom('model/Organization', 'getNonVirtualOrganizations', { demoOrgOnly: true })
          }
        },
        params: {
          organization: null,
        },
        views: {
          administrators: {
            controller: 'AdministratorsCtrl as $ctrl',
            templateUrl: 'app/pages/arnoAdministration/administrators.view.html',
          },
          organizations: {
            controller: 'OrganizationManageCtrl as $ctrl',
            templateUrl: 'app/pages/arnoAdministration/organizations.view.html',
          }
        },
        viewPermission: 'arno.arnoAdministration',
      })
      .state('arno.arnoAdministration.editOrganization', {
        url: '/organization/:organizationId',
        title: 'ARNO Administration',
        resolve: {
          organization: function ($stateParams, clientApi) {
            if ($stateParams.organizationId) {
              return clientApi.custom('model/Organization', 'fetchOrganizationById', { orgId: $stateParams.organizationId });
            }
            return {};
          },
          administrators: function ($stateParams, clientApi) {
            if ($stateParams.organizationId) {
              return clientApi.custom('model/Organization', 'findAdministrators', { orgId: $stateParams.organizationId });
            }
            return [];
          },
          isDemoOrg: function($stateParams) {
            return $stateParams.isDemoOrg;
          },
          demoAccounts: function(clientApi, organization) {
            if (organization && organization.id) {
              return clientApi
                .custom('model/Account', 'getDemoAccounts', {
                  orgId: organization.id,
                })
            }
            return [];
          }
        },
        params: {
          organizationId: null,
          isDemoOrg: false,
        },
        views: {
          organizations: {
            controller: 'OrganizationEditCtrl as $ctrl',
            templateUrl: 'app/pages/arnoAdministration/organization.edit.html',
          }
        },
        viewPermission: 'arno.arnoAdministration',
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration')
    .controller('EditResponsiblePersonsModalCtrl', editResponsiblePersonsModalCtrl);

  function editResponsiblePersonsModalCtrl(clientApi, $uibModalInstance, commonUtils, item, isBulk, $translate) {
    var $ctrl = this;
    $ctrl.item = item;
    $ctrl.isBulk = isBulk;

    $ctrl.groupByFirstName = function (member) {
      var groupName;
      if (!member.hint) {
        groupName = member.initials.charAt(0);
      } else {
        groupName = $translate.instant('generalTerms.note');
      }
      return groupName;
    };

    $ctrl.removeMemberFromInitiatingMember = function (memberId) {
      var initiatingMember = [];
      item.InitiatingMember.forEach(function (member) {
        if (member.id !== memberId) {
          initiatingMember.push(member);
        }
      });
      $ctrl.item.InitiatingMember = initiatingMember;
    };

    $ctrl.removeMemberFromAcceptingMember = function (memberId) {
      var acceptingMember = [];
      item.AcceptingMember.forEach(function (member) {
        if (member.id !== memberId) {
          acceptingMember.push(member);
        }
      });
      $ctrl.item.AcceptingMember = acceptingMember;
    };

    $ctrl.searchMembers = function (name, isInitiatingMember) {
      return clientApi
        .custom('model/Member', 'searchMemberInOrg', { searchName: name })
        .then(function (result) {
          $ctrl.members = result;
          $ctrl.members.forEach(function (m) {
            if (_.find($ctrl.groupMembers, { id: m.id })) {
              m.selected = true;
            }
          });
          if (isInitiatingMember) {
            $ctrl.members.forEach(function (m) {
              item.InitiatingMember.forEach(function (member) {
                if (m.id === member.id) {
                  m.selected = true;
                }
              });
            });
          } else {
            $ctrl.members.forEach(function (m) {
              item.AcceptingMember.forEach(function (member) {
                if (m.id === member.id) {
                  m.selected = true;
                }
              });
            });
          }
          return result.concat([{ hint: true }]);
        });
    };

    $ctrl.save = function () {
      $uibModalInstance.close($ctrl.item);
    };

    $ctrl.addInitiatingMember = function () {
      $ctrl.selectedMember.selected = true;
      $ctrl.item.InitiatingMember.push($ctrl.selectedMember);
      $ctrl.selectedMember = null;
    };

    $ctrl.addAcceptingMember = function () {
      $ctrl.selectedMember.selected = true;
      $ctrl.item.AcceptingMember.push($ctrl.selectedMember);
      $ctrl.selectedMember = null;
    };

    $ctrl.removeMember = function (member) {
      member.selected = false;
      $ctrl.groupMembers = $ctrl.groupMembers.filter(function (item) {
        return item.id !== member.id;
      });
    };

    $ctrl.responsilbeTypes = [
      {
        name: $translate.instant('modules.administration.adminClearances.initiatingMember'),
        noMemberMessage: $translate.instant('modules.administration.adminClearances.noInitMember'),
        removeMethod: function (memberId) {
          $ctrl.removeMemberFromInitiatingMember(memberId);
        },
        addMethod: function () {
          $ctrl.addInitiatingMember();
        },
        members: function () {
          return $ctrl.item.InitiatingMember;
        },
        isInitiatingMember: true
      },
      {
        name: $translate.instant('modules.administration.adminClearances.editedMember'),
        noMemberMessage: $translate.instant('modules.administration.adminClearances.noEditedMember'),
        removeMethod: function (memberId) {
          $ctrl.removeMemberFromAcceptingMember(memberId);
        },
        addMethod: function () {
          $ctrl.addAcceptingMember();
        },
        members: function () {
          return $ctrl.item.AcceptingMember;
        },
        isInitiatingMember: false,
      },
    ];
  }
})();

(function(){
  'use strict';

  angular
		.module('BlurAdmin.pages.administration.personnel.clearances', [])
		.controller('ClearanceModalCtrl', ClearanceModalCtrl);

  function ClearanceModalCtrl(
    ARNO_CONSTANTS,
    $uibModalInstance, commonUtils, clientApi, clearances, $timeout, $scope,
    modalTitle, clearance, clearanceGroup, clearanceHierarchy, baModalService, $translate
  ) {
    var self = this;

    // CONSTS
    self.CLEARANCES_TYPES = ARNO_CONSTANTS.ADMIN.CLEARANCES.CLEARANCES_TYPES;

    // VARS
    self.clearanceGroup = clearanceGroup;
    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };
    self.modalTitle = modalTitle;

    if (clearance) {
      self.clonedClearance = _.clone(clearance);

      self.title = self.clonedClearance.Title;
      self.clearanceType = self.clonedClearance.Type
      self.reminder1Title = self.clonedClearance.Reminder1Title;
      self.reminder2Title = self.clonedClearance.Reminder2Title;
      self.resubmissionTitle = self.clonedClearance.ResubmissionTitle;
      self.letterTitle = self.clonedClearance.LetterTitle;
      self.inspectionTitle = self.clonedClearance.InspectionTitle;
      self.description = self.clonedClearance.Description;
      self.allowRejected = self.clonedClearance.AllowRejected;
    }

    self.clearanceHierarchy = clearanceHierarchy;
    self.maxResubTime = {
      active: !!(self.clonedClearance && (self.clonedClearance.MaxResubTimeDays || self.clonedClearance.MaxResubTimeMonths || self.clonedClearance.MaxResubTimeYears)),
      days: self.clonedClearance ? self.clonedClearance.MaxResubTimeDays : 0,
      months: self.clonedClearance ? self.clonedClearance.MaxResubTimeMonths : 0,
      years: self.clonedClearance ? self.clonedClearance.MaxResubTimeYears : 0,
    };

    $scope.$watch(function () {
      return self.maxResubTime;
    }, function () {
      if (!self.maxResubTime.active) {
        self.maxResubTime.days = null;
        self.maxResubTime.months = null;
        self.maxResubTime.years = null;
        return;
      }
      self.maxResubTime.days = parseInt(self.maxResubTime.days, 10) || 0;
      self.maxResubTime.months = parseInt(self.maxResubTime.months, 10) || 0;
      self.maxResubTime.years = parseInt(self.maxResubTime.years, 10) || 0;
    }, true);

    function activate() {
      self.clearance = clearance || null;

      if (self.clearance) {
        if(self.clearance.ClearanceGroupId != null && clearanceGroup && clearanceGroup.id) {
          self.clearance.viewSelectedGroup = clearanceGroup;
        }
      }

      // remap/preset clearance-type
      self.clearanceType = _.find(self.CLEARANCES_TYPES, { mapping: self.clearanceType });
      if (!self.clearanceType || !self.clearanceType.mapping) {
        self.clearanceType = self.CLEARANCES_TYPES[0];
      }
    }

    self.isClearanceTitleExistent = function (clearanceTitle) {
      if (clearance) {
        return false;
      }
      return _.find(clearances, function(clearance){
        return clearance && clearanceTitle && clearance.Title.toLocaleLowerCase() === clearanceTitle.toLocaleLowerCase();
      })
    };

    self.applyModal = function () {
      var assignedGroupIdForClearance = self.clearance && self.clearance.viewSelectedGroup && self.clearance.viewSelectedGroup.id ? self.clearance.viewSelectedGroup.id : self.clearanceGroup.id;
      // force setting a clearance type, if no valid is found take the first  (COMPLEX)
      var assignedClearanceType = self.clearanceType &&  self.clearanceType.mapping ? self.clearanceType.mapping : self.CLEARANCES_TYPES[0].mapping;
      var promise = Promise.resolve();
      if (self.allowRejected === false && self.clonedClearance && self.clonedClearance.AllowRejected === true) {
        promise = baModalService.messageModal({
          modalType: 'danger',
          allowHtml: false,

          title: $translate.instant('modules.administration.adminClearances.releaseProcess'),
          content: $translate.instant('modules.administration.adminClearances.resultOfRemoveStatus'),

          primaryActionText: $translate.instant('generalTerms.save'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        })
      }
      promise
        .then(function() {
          return $uibModalInstance.close({
            Title: self.title,
            Type: assignedClearanceType,
            Description: self.description,
            Reminder1Title: self.reminder1Title,
            Reminder2Title: self.reminder2Title,
            ResubmissionTitle: self.resubmissionTitle,
            LetterTitle: self.letterTitle,
            InspectionTitle: self.inspectionTitle,
            ClearanceGroupId: assignedGroupIdForClearance,
            AllowRejected: self.allowRejected,
            MaxResubTimeDays: self.maxResubTime.days,
            MaxResubTimeMonths: self.maxResubTime.months,
            MaxResubTimeYears: self.maxResubTime.years,
          });
        })
        .catch(function() {
          //mmh k
        })
    };

    self.applyDeleteModal = function() {
      $uibModalInstance.close({})
    };

    // init the controller
    activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.clearances')
    .controller('ApprovalConfirmCopyCtrl', ApprovalConfirmCopyCtrl);

  function ApprovalConfirmCopyCtrl($uibModalInstance, toastr, $translate) {
    var self = this;
    self.opts = {
      copyInit: false,
      copyEdit: false,
    }
    self.applyModal = function () {
      if (!self.opts.copyEdit && !self.opts.copyInit) {
        toastr.warning($translate.instant('modules.administration.adminClearances.pleaseChooseOneOption'), $translate.instant('modules.administration.adminClearances.missingInformation'));
      } else {
        $uibModalInstance.close({
          options: self.opts,
        });
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.clearances')
    .controller('ClearanceGroupModalCtrl', ClearanceGroupModalCtrl);

  /** @ngInject */
  function ClearanceGroupModalCtrl($uibModalInstance, clearanceHierarchy, clearanceGroup) {
    var self = this;

    self.clearanceGroup = clearanceGroup;

    // VIEW-FUNCTIONS
    self.isGroupNameExistent = function (clearanceGroupName, exceptionId) {
      return _.find(clearanceHierarchy, function (clearance) {
        return clearance.Name
                && clearanceGroupName
                && clearance.Name.toLocaleLowerCase() === clearanceGroupName.toLocaleLowerCase()
                && clearance.id !== exceptionId;
      });
    };

    self.applyModal = function (name, id, funcTitle, desc, options) {
      $uibModalInstance.close({
        name: name,
        desc: desc,
        id: id,
        options: options || {},
        funcTitle: funcTitle,
        children: self.selectedChildren
      });
    };

    self.onClickFullDelete = function (name, id, funcTitle, desc) {
      if (!clearanceGroup) {
        throw new Error('ERROR: ClearanceGroupModalCtrl.onClickFullDelete: No group to delete provided!')
      }

      if (!clearanceGroup.Approvals || !clearanceGroup.Approvals.length) {
        throw new Error('ERROR: ClearanceGroupModalCtrl.onClickFullDelete: There are no Clearances/Approvals which can be deleted with this group!')
      }

      self.applyModal(name, id, funcTitle, desc, {
        fullDelete: true
      });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.blockage', [])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.blockage', {
        url: '/reasonBlockage',
        templateUrl: 'app/pages/administration/personnel/blockage/blockageList.html',
        title: 'navigation.administration.personnel.blockage',
        controller: 'BlockageListCtrl as $ctrl',
        resolve: {
          fetchHistoryData: function (clientApi) {
            return function (queryWishes) {
              return clientApi
                .custom('model/LogJournal', 'fetchThingLogs', {
                  queryWishes: queryWishes,
                  types: ['BLOCKAGEREASON_CREATE', 'BLOCKAGEREASON_EDIT', 'BLOCKAGEREASON_DELETE']
                });
            }
          },
          historyData: function (fetchHistoryData) {
            return fetchHistoryData({ paging: { offset: 0, limit: 10 }, sort: { by: 'createdAt', reverse: true } });
          }
        },
        sidebarMeta: {
          order: 30,
        },
        viewPermission: 'arno.administration.personnel.blockage'
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.blockage')
    .controller('HandleReasonBlockage', HandleReasonBlockage);

  /** @ngInject */
  function HandleReasonBlockage($rootScope, $uibModalInstance, clientApi, data, $translate) {
    var self = this;

    self.reasonName = data.reasonName || '';
    self.reasonId = data.reasonId || false;
    self.isDiv = data.isDiv;
    self.level = data.isDiv ? $translate.instant('modules.administration.adminBlockage.divLvl') : $translate.instant('modules.administration.adminBlockage.orgaLvl');

    self.handleReason = function () {
      $uibModalInstance.close({reasonName: self.reasonName, id: self.reasonId})
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.blockage')
    .controller('ReasonAddBlockageCtrl', ReasonAddBlockageCtrl);

  /** @ngInject */
  function ReasonAddBlockageCtrl($rootScope, toastr, $uibModalInstance, clientApi, data) {
    var self = this;

    self.isDiv = data.isDiv;

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.activityWindow')
    .controller('ActivityWindowCtrl', ActivityWindowCtrl);

  /** @ngInject */
  function ActivityWindowCtrl($state, $stateParams, $uibModal, $scope, clientApi, toastr, $translate) {
    var self = this;

    self.windowAction = $stateParams.windowAction;
    self.groupId = $stateParams.groupId;
    self.activityId = $stateParams.activityId;
    self.divisionId = $stateParams.divisionId || null;
    self.organizationId = $stateParams.organizationId;
    self.showActions = false;
    self.activity = {};
    self.activityHierarchy = [];
    var falsyStates = [null, undefined];
    var validityActiveState = (!~falsyStates.indexOf(self.activity.ValidityPeriodDays)
                              && !~falsyStates.indexOf(self.activity.ValidityPeriodMonths)
                              && !~falsyStates.indexOf(self.activity.ValidityPeriodYears));
    
    self.validityHelper = {
      active: validityActiveState,
      days: validityActiveState ? self.activity.ValidityPeriodDays : 0,
      months: validityActiveState ? self.activity.ValidityPeriodMonths : 0,
      years: validityActiveState ? self.activity.ValidityPeriodYears : 1,
    };

    clientApi
      .custom('model/ActivityGroup', 'getActivityGroups', { divisionId: self.divisionId || null })
      .catch(function (e) {
        toastr.error();
        throw e;
      })
      .then(function (result) {
        self.pickedGroup = _.find(result, { 'id': parseInt(self.groupId, 10) });
        self.activityHierarchy = result;
      });

    clientApi.custom('model/Activity', 'getActivityDetail', {
      activityId: self.activityId,
      divisionId: self.divisionId,
    })
      .catch(function (e) {
        toastr.error();
        throw e;
      }).then(function (result) {
        self.activity = result;
        self.validityHelper.days = result.ValidityPeriodDays || 0;
        self.validityHelper.months = result.ValidityPeriodMonths || 0;
        self.validityHelper.years = result.ValidityPeriodYears || 1;
        if (result.ValidityPeriodDays || result.ValidityPeriodMonths || result.ValidityPeriodYears) {
          self.validityHelper.active = true;
        }
      });

    self.requirementsSetGroups = [
      {
        Name: $translate.instant('modules.administration.adminActivities.requirementSet'),
      },
    ];

    $scope.$watch(function () {
      return self.validityHelper;
    }, function () {
      if (!self.validityHelper.active) {
        self.activity.ValidityPeriodDays = null;
        self.activity.ValidityPeriodMonths = null;
        self.activity.ValidityPeriodYears = null;
        return;
      }
      self.activity.ValidityPeriodDays = parseInt(self.validityHelper.days, 10) || 0;
      self.activity.ValidityPeriodMonths = parseInt(self.validityHelper.months, 10) || 0;
      self.activity.ValidityPeriodYears = parseInt(self.validityHelper.years, 10) || 0;
    }, true);

    self.openRequirementsSetModal = function (requirementsSet) {
      var preOpenRequirementsSet = _.cloneDeep(requirementsSet);
      $uibModal.open({
        controller: 'RequirementsSetModalCtrl as $requirementsSetModalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/personnel/activities/activityWindow/requirementsSetModal/requirementsSetModal.html',
        size: 'lg',
        resolve: {
          activity: function () {
            return self.activity;
          },
          divisionId: function () {
            return self.divisionId;
          },
          organizationId: function () {
            return self.organizationId;
          },
          defaultQualifications: function () {
            return requirementsSet && requirementsSet.characteristics.DEFAULT ? clientApi.custom('model/Qualification',
              'getQualifications',
              { ids: requirementsSet.characteristics.DEFAULT.qualifications }) : [];
          },
          withChildrenQualifications: function () {
            return requirementsSet && requirementsSet.characteristics.WITH_CHILDREN ? clientApi.custom('model/Qualification',
              'getQualifications',
              { ids: requirementsSet.characteristics.WITH_CHILDREN.qualifications }) : [];
          },
          wardenQualifications: function () {
            return requirementsSet && requirementsSet.characteristics.WARDEN ? clientApi.custom('model/Qualification',
              'getQualifications',
              { ids: requirementsSet.characteristics.WARDEN.qualifications }) : [];
          },
          wardenWithChildrenQualifications: function () {
            return requirementsSet && requirementsSet.characteristics.WARDEN_WITH_CHILDREN ? clientApi.custom('model/Qualification',
              'getQualifications',
              { ids: requirementsSet.characteristics.WARDEN_WITH_CHILDREN.qualifications }) : [];
          },
          defaultApprovals: function () {
            return requirementsSet && requirementsSet.characteristics.DEFAULT ? clientApi.custom('model/Approval',
              'getApprovalsData',
              { ids: requirementsSet.characteristics.DEFAULT.approvals }) : [];
          },
          withChildrenApprovals: function () {
            return requirementsSet && requirementsSet.characteristics.WITH_CHILDREN ? clientApi.custom('model/Approval',
              'getApprovalsData',
              { ids: requirementsSet.characteristics.WITH_CHILDREN.approvals }) : [];
          },
          wardenApprovals: function () {
            return requirementsSet && requirementsSet.characteristics.WARDEN ? clientApi.custom('model/Approval',
              'getApprovalsData',
              { ids: requirementsSet.characteristics.WARDEN.approvals }) : [];
          },
          wardenWithChildrenApprovals: function () {
            return requirementsSet && requirementsSet.characteristics.WARDEN_WITH_CHILDREN ? clientApi.custom('model/Approval',
              'getApprovalsData',
              { ids: requirementsSet.characteristics.WARDEN_WITH_CHILDREN.approvals }) : [];
          },
          qualifications: function () {
            return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: self.divisionId })
              .catch(function (e) {
                toastr.error();
                throw e;
              });
          },
          approvals: function () {
            var approvals = [];

            return clientApi.custom('model/Approval', 'getApproval', {})
              .then(function(ap) {
                approvals = ap;
                return clientApi.custom('model/ClearanceGroup', 'getClearanceGroups', {})
              })
              .then(function (approvalGroups) {
                var unassignedGroup = {
                  Name: $translate.instant('modules.administration.adminActivities.notRequired'),
                  OrganizationId: parseInt(self.organizationId),
                  Approvals: approvals.filter(function(ap) {
                    return !ap.ClearanceGroupId;
                  }),
                  id: 0
                }
                approvalGroups.unshift(unassignedGroup);
                return approvalGroups;
              })
              .catch(function () {
                toastr.error($translate.instant('modules.administration.adminActivities.tryLater'), $translate.instant('modules.administration.adminActivities.unknownError'));
              });
          },
          requirementsSet: function () {
            return requirementsSet || {};
          }
        }
      })
        .result
        .then(function (result) {
          self[result.fn](result.requirementsSet); // applyReqSetModal()
        })
        .catch(function () {
          _.merge(requirementsSet, preOpenRequirementsSet); // merge to keep object reference
        });
    };

    self.applyReqSetModal = function (requirementsSet) {
      self.activity.requirementsSets = self.activity.requirementsSets || [];
      if (!~self.activity.requirementsSets.indexOf(requirementsSet)) {
        self.activity.requirementsSets.push(requirementsSet);
      }
    };

    self.deleteRequirementsSet = function (requirementsSet) {
      _.remove(self.activity.requirementsSets, requirementsSet);
    };

    // is called after click on the save button. This model doesn't work properly yet.
    self.applyWindow = function (action) {
      switch (action) {
      case 'add':
        if (!self.activity || !self.activity.requirementsSets || !self.activity.requirementsSets.length) {
          toastr.info($translate.instant('modules.administration.adminActivities.thisActivityNeedsARequirement'), $translate.instant('modules.administration.adminActivities.depositRequirement'));
          return;
        }
        self.activity.activityGroupId = self.pickedGroup.id;
        self.activity.active = true;

        self.activity.ValidityPeriodDays = self.validityHelper.active ? self.validityHelper.days : null;
        self.activity.ValidityPeriodMonths = self.validityHelper.active ? self.validityHelper.months : null;
        self.activity.ValidityPeriodYears = self.validityHelper.active ? self.validityHelper.years : null;

        clientApi.custom('model/Activity', 'createOrUpdateActivity', {
          activity: self.activity,
          divisionId: self.divisionId,
        })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminActivities.thisActivity') + self.activity.title + $translate.instant('modules.administration.adminActivities.wasActuallyUpdated'), $translate.instant('modules.administration.adminActivities.updateActivity'));
              $state.go('arno.administration.personnel.activities');
            });
        break;
      case 'cancel':
        $state.go('arno.administration.personnel.activities');
        break;
      default:
        break;
      }
    };

    // DEPRECATED ??
    self.isActivityNameExistent = function (/* activityId */) {
      // return clientApi.custom('model/Activity', 'getActivityDetail', [activityId, self.divisionId, self.organizationId]) || false;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.activities', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.activities', {
        url: '/activities',
        templateUrl: 'app/pages/administration/personnel/activities/activities.html',
        title: 'navigation.administration.personnel.activities',
        controller: 'ActivityCtrl as $ctrl',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.activities.manage');
          },
          ctxSelected: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.activities.manage', true) !== null;
          },
          activityHierarchy: function (clientApi, ctx, organizationId, ctxSelected) {
            if (!ctxSelected) {
              return [];
            }
            return clientApi.custom('model/ActivityGroup', 'getActivityGroups', { divisionId: ctx || null });
          },
        },

        sidebarMeta: {
          order: 800,
        },
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.activities')
    .controller('ActivityGroupModalCtrl', ActivityGroupModalCtrl);

  /** @ngInject */
  function ActivityGroupModalCtrl($uibModalInstance, activityHierarchy, activityGroup) {
    var self = this;

    self.activityGroup = activityGroup;

    self.isGroupNameExistent = function (activityGroupName, exceptionId) {
      return _.find(activityHierarchy, function (activity) {
        return activity.Name
              && activityGroupName
              && activity.Name.toLocaleLowerCase() === activityGroupName.toLocaleLowerCase()
              && activity.id !== exceptionId;
      });
    };

    self.applyModal = function (name, id, funcTitle, desc) {
      $uibModalInstance.close({
        name: name,
        desc: desc,
        id: id,
        funcTitle: funcTitle,
        children: self.selectedChildren,
        divisionId: self.activityGroup.DivisionId,
      });
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material', [
      'BlurAdmin.pages.administration.material.fileStorage',
      'BlurAdmin.pages.administration.material.materialTypes',
      'BlurAdmin.pages.administration.material.inspection',
      'BlurAdmin.pages.administration.material.materialExportTemplates',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.material', {
        url: '/material',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        title: 'navigation.administration.material',
        abstract: true,
        sidebarMeta: {
          order: 95,
        },
        // resolve: {
        // },
        viewPermission: 'arno.administration.material',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material')
    .controller('deleteWarningModalCtrl', deleteWarningModalCtrl);

  /** @ngInject */
  function deleteWarningModalCtrl($uibModalInstance, data) {
    var self = this;

    self.data = data;
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.inspection')
    .controller('InspectionModalCtrl', InspectionModalCtrl);

  function InspectionModalCtrl($uibModalInstance, divisionId, item, assignmentCount, $translate, $uibModal) {
    var self = this;

    self.minInterval = 1;
    self.maxInterval = 60;

    self.inspection = {
      id: item.id,
      divisionId: divisionId,
      name: item.Name || '',
      description: item.Description || '',
      periodicInspection: item.PeriodicInspection || false,
      inspectionIntervalRecommended: item.RecommendedInterval || 1,
      inspectionIntervalMaximum: item.MaximumInterval || 1,
    }

    self.switcherKeys = {
      on: $translate.instant('components.switcherYesNo.on'),
      off: $translate.instant('components.switcherYesNo.off'),
    };

    // EVENT-HANDLERS
    self.upsertInspection = function (inspection) {
      var promise;

      if (assignmentCount > 0 &&
        inspection.periodicInspection &&
        item.MaximumInterval > inspection.inspectionIntervalMaximum
      ) {
        promise = $uibModal.open(
          {
            controller: 'InspAssignmentOverrideControl as self',
            animation: true,
            templateUrl: 'app/pages/administration/material/inspection/inspectionModal/assignmentOverride/assignmentOverride.modal.html',
            size: 'md',
            resolve: {
              assignmentCount: function () {
                return assignmentCount;
              },
            }
          }).result
      } else {
        promise = Promise.resolve();
      }

      return promise
        .then(function(res) {
          if(!inspection.periodicInspection) {
            inspection.inspectionIntervalRecommended = null;
            inspection.inspectionIntervalMaximum = null;
          }
          $uibModalInstance.close({ inspection: inspection, overrideExistingIntervals: res });
        })
        .catch(function() {
          // mmk
        })
    };

    self.valid = function(inspection) {
      if(!inspection.name) {
        return false
      }
      if(!inspection.periodicInspection ||
        (
          inspection.periodicInspection &&
          (
            (!inspection.inspectionIntervalRecommended && inspection.inspectionIntervalMaximum > 0) ||
            (inspection.inspectionIntervalRecommended > 0 && !inspection.inspectionIntervalMaximum) ||
            (inspection.inspectionIntervalRecommended > 0 && inspection.inspectionIntervalMaximum > 0 && inspection.inspectionIntervalMaximum >= inspection.inspectionIntervalRecommended)
          )
        )
      ) {
        return true
      }
      return false
    }

    self.confirmDelete = function (id, name) {
      $uibModalInstance.close({
        id: id,
        name: name
      });
    };

    self.editCategory = function (name, color, id) {
      $uibModalInstance.close({
        newName: name,
        newColor: self.ensureHash(color),
        newUsages: self.selectedCategoryUsages ? self.selectedCategoryUsages.map(function(usage) {
          return usage.mapping;
        }) : null,
        editId: id,
      });
    };

    // HELPERS
    self.ensureHash = function (color) {
      return '#' + ((color || '').replace('#', ''));
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.prices',
      ['BlurAdmin.theme.components.materialTypesPricesTreeview']
    )
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.finances.prices', {
        abstract: true,
        url: '/prices',
        templateUrl: 'app/pages/administration/finances/prices/pricesTabs.html',
        title: 'navigation.administration.finances.prices',
        controller: 'AdminFinancesPricesTabsCtrl as self',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              entryPermission: 'arno.administration.finances.prices.manage',
              allowOrgSelection: true,
            });
          },
          tableConfig: function (commonUtils) {
            var getDefaults = function (availableFields, customTableConfigs) {
              var orgPageSize = commonUtils.preference.object.get('pref_custom_prices_table_page_size_org', 10);

              var tableConfigOrgDefault = {
                ExternalPricePerHour: true,
                ExternalPricePerDay: true,
                ExternalPricePerCount: true,

                pageSize: orgPageSize.pageSize || orgPageSize,

                FilterMissingPrices: false,
              };

              // create own field lists for div and org level
              var orgFields = JSON.parse(JSON.stringify(availableFields));

              return {
                tableConfigAvailableFields: { org: orgFields },
                tableConfigOrgDefault: tableConfigOrgDefault,
                tableConfigCustomPreference: customTableConfigs
              };
            };

            // NOTE: add fetch of custom-price-items table config here later, if its wanted by the product-owner

            return getDefaults([], []);
          },
        },

        sidebarMeta: {
          stateRedirect: 'arno.administration.finances.prices.custom',
          order: 10,
        },
      })
      .state('arno.administration.finances.prices.custom', {
        url: '/custom',
        templateUrl: 'app/pages/administration/finances/prices/prices.html',
        title: 'navigation.administration.finances.prices',
        controller: 'AdminFinancesPricesCtrl as self',
        resolve: {
          priceType: function(ARNO_CONSTANTS) {
            return ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM;
          },
          dataProvider: function (ctx, clientApi) {
            return function (queryOptions) {
              return clientApi.custom('model/CustomPriceItem', 'getCustomPrices', {
                queryOptions: queryOptions,
                divisionId: ctx[0] === 'rootOrg' ? null : ctx[0]
              });
            };
          },
          initialData: function(dataProvider, tableConfig) {
            return dataProvider({
              paging: { limit: tableConfig.tableConfigOrgDefault.pageSize, offset: 0 },
              sort: { by: 'Title', reverse: false }
            });
          }
        },
        viewPermission: 'arno.administration.finances.prices.manage',
      })
      .state('arno.administration.finances.prices.material', {
        url: '/material',
        templateUrl: 'app/pages/administration/finances/prices/prices.html',
        title: 'navigation.administration.finances.prices',
        controller: 'AdminFinancesPricesCtrl as self',
        resolve: {
          priceType: function(ARNO_CONSTANTS) {
            // REMARK: this type includes both material- AND material-type prices!
            return ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE;
          },
          // NOTE: we dont really need this for the new materials-prices component....
          // however to stick with the already existing mechanism for the service-position and custom-prices,
          // we will use a similar setup to fetch the initial data (e.g. the material-types tree data...)
          dataProvider: function (ArnoDashMaterialsService, ctx) {
            return function (queryOptions, filterMissingPrices) {
              return ArnoDashMaterialsService.getMaterialsTypesWithPrices(ctx, queryOptions, true, true, filterMissingPrices);
            };
          },
          initialData: function(dataProvider, tableConfig) {
            return dataProvider({
              paging: { limit: tableConfig.tableConfigOrgDefault.pageSize, offset: 0 },
              sort: { by: 'Name', reverse: false }
            }, tableConfig.tableConfigOrgDefault.FilterMissingPrice);
          }
        },
        viewPermission: 'arno.administration.finances.prices.manage',
      })
      .state('arno.administration.finances.prices.servicePosition', {
        url: '/servicePosition',
        templateUrl: 'app/pages/administration/finances/prices/prices.html',
        title: 'navigation.administration.finances.prices',
        controller: 'AdminFinancesPricesCtrl as self',
        resolve: {
          priceType: function(ARNO_CONSTANTS) {
            return ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION;
          },
          dataProvider: function (ctx, clientApi) {
            return function (queryOptions, filterMissingPrices) {
              return clientApi.custom('model/ServiceFunction', 'listPrices', {
                queryOptions: queryOptions,
                divisionId: ctx[0] === 'rootOrg' ? null : ctx[0],
                filterMissingPrices: filterMissingPrices,
              });
            };
          },
          initialData: function(dataProvider, tableConfig) {
            return dataProvider({
              paging: { limit: tableConfig.tableConfigOrgDefault.pageSize, offset: 0 },
              sort: { by: 'Function', reverse: false }
            }, tableConfig.tableConfigOrgDefault.FilterMissingPrices);
          }
        },
        viewPermission: 'arno.administration.finances.prices.manage',
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.prices')
    .controller('AdminFinancesPricesMaterialSearchModalCtrl', AdminFinancesPricesMaterialSearchModalCtrl);

    /** @ngInject */
  function AdminFinancesPricesMaterialSearchModalCtrl(
    $uibModalInstance,
    clientApi, materialUtil,
    materialTableConfigs, materialMeta, divisionId
  ) {
    var self = this;

    // CONSTS
    self.ALLOWED_MATERIALS_CATEGORIES = [ 'Medicine', 'Clothing', 'Vehicles', 'Tools', 'Consumables', 'Others' ];

    var materialsPrimaryCaptionPropertyByCategory = {
      Medicine: 'Definition',
      Clothing: 'Name',
      Vehicles: 'VehicleModel',
      Tools: 'Definition',
      Consumables: 'Definition',
      Others: 'Name'
    }

    var materialsPriceColsDef = [{
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerHourCol', prop: 'ExternalPricePerHour'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerDayCol', prop: 'ExternalPricePerDay'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerCountCol', prop: 'ExternalPricePerCount'
    }];

    // VARS
    self.materialTableConfigs = materialTableConfigs;
    self.materialMeta = materialMeta;
    self.divisionId = divisionId;

    self.selectedMaterialCategory = self.ALLOWED_MATERIALS_CATEGORIES[0];
    self.materialsTabsIconMapping = materialUtil.materialsTabsIconMapping;

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf AdminFinancesPricesMaterialSearchModalCtrl#
    */
    function activate() {
      // we adjust the table-columns definitions for the material-picker comp. so only the necc. props - especially for prices-data are shown...
      self.materialMeta.columnDefinitions = self.materialMeta.columnDefinitions || {};
      self.materialMeta.defaultTableConfig = self.materialMeta.defaultTableConfig || {};

      _.forEach(self.ALLOWED_MATERIALS_CATEGORIES, function(materialCategory) {
        if (materialCategory) {
          var model = 'Material' + materialCategory;
          var columnDefs = self.materialMeta.columnDefinitions[model];

          if (columnDefs) {
            var primaryCaptionProp = materialsPrimaryCaptionPropertyByCategory[materialCategory];

            self.materialMeta.columnDefinitions[model] = columnDefs.concat(materialsPriceColsDef);

            self.materialMeta.defaultTableConfig[model] = (primaryCaptionProp ? [primaryCaptionProp] : []).concat(materialsPriceColsDef.map(function(colDef) { return colDef.prop }));
          }
        }
      });
    }

    // EVENT-HANDLERS
    self.selectedMaterial = function(selectedMaterials) {
      var materialCategory = self.ALLOWED_MATERIALS_CATEGORIES[self.currentActiveMaterialsTab];

      var material = selectedMaterials[0] || selectedMaterials;
      // NOTE: we need to extend the selected material (e.g. provide Title / Name and priceItemType) for finance-positions comp.
      var primaryCaptionProp = materialsPrimaryCaptionPropertyByCategory[materialCategory];
      material.Title = material[primaryCaptionProp] || '';

      $uibModalInstance.close({
        materialCategory: materialCategory,
        material: material
      });
    }

    self.selectMaterialTab = function(newCategory) {
      self.selectedMaterialCategory = newCategory;
    }

    // HELPERS

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.prices')
    .controller('AdminFinancesPriceDetailsModalCtrl', AdminFinancesPriceDetailsModalCtrl);

    /** @ngInject */
  function AdminFinancesPriceDetailsModalCtrl(
    $rootScope, $uibModalInstance,
    permissions, validationUtils, ArnoDashPricesService,
    selectedDivisionId, uiConfig,
    targetPriceItems, presetPrices
  ) {
    var self = this;

    self.hasManagePermission = false;

    // NOTE: we always take the first target-price-item to prefill the price-data
    self.targetPriceItems = targetPriceItems;
    self.priceItemData = (targetPriceItems || []).length ? _.cloneDeep(targetPriceItems[0]) : {};

    self.uiConfig = uiConfig;

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf AdminFinancesPriceDetailsModalCtrl#
    */
    function activate() {
      getUiPermissions();

      // if the given price-data does not have price-information and a preset-price information are given, then we set them...
      if (!validationUtils.hasValidPriceDefinition(self.priceItemData) &&  presetPrices && validationUtils.hasValidPriceDefinition(presetPrices)) {
        self.priceItemData = Object.assign(self.priceItemData, _.pick(presetPrices, [
          'ExternalPricePerHour', 'ExternalPricePerDay', 'ExternalPricePerCount',
          'InternalPricePerHour', 'InternalPricePerDay', 'InternalPricePerCount',
        ]));
      }
    }

    // EVENT-HANDLERS
    self.applyModal = function (priceItem) {
      if ((self.targetPriceItems || []).length > 1) {
        var newPriceItems = self.targetPriceItems.map(function(targetPriceItem) {
          return Object.assign(targetPriceItem, _.pick(priceItem, [
            'ExternalPricePerHour',
            'ExternalPricePerDay',
            'ExternalPricePerCount',
            'InternalPricePerHour',
            'InternalPricePerDay',
            'InternalPricePerCount',
          ]))
        });

        newPriceItems.splice(_.findIndex(newPriceItems, { id: priceItem.id }), 1, priceItem);
        $uibModalInstance.close(newPriceItems);
      } else {
        $uibModalInstance.close(priceItem);
      }
    };

    // VIEW-FUNCTIONS
    self.isNew = function() {
      // NOTE: for custom-price-items the id determines if its new, for other types like material/material-type and service-functions (dienst-positionen) its the price-info itself...
      return !self.priceItemData.id || !validationUtils.hasValidPriceDefinition(self.priceItemData);
    }

    // HELPERS
    function getUiPermissions() {
      if (self.isNew() && selectedDivisionId && !((selectedDivisionId || []).indexOf('rootOrg') >= 0)) {
        self.hasManagePermission = permissions.isPermittedInEvery('arno.administration.finances.prices.manage', 'Division', [selectedDivisionId]);
      } else if (self.priceItemData.DivisionId != null) {
        self.hasManagePermission = permissions.isPermittedInEvery('arno.administration.finances.prices.manage', 'Division', [self.priceItemData.DivisionId]);
      } else {
        self.hasManagePermission = permissions.isPermittedInOrg('arno.administration.finances.prices.manage', [$rootScope.ctx.organization.current.id]);
      }
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.costCenters', [])
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.finances.costCenters', {
        url: '/costCenters',
        templateUrl: 'app/pages/administration/finances/costCenters/costCenters.html',
        title: 'navigation.administration.finances.costCenters',
        controller: 'AdminFinancesCostCenterCtrl as $ctrl',
        resolve: {
          costCenters: function (ArnoDashCostCentersService) {
            return ArnoDashCostCentersService.getCostCentersForOrg(true);
          },
        },

        sidebarMeta: {
          order: 20,
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.costCenters')
    .controller('AdminFinancesCostCenterSpecificationModalCtrl', AdminFinancesCostCenterSpecificationModalCtrl);

    /** @ngInject */
  function AdminFinancesCostCenterSpecificationModalCtrl(
    $uibModalInstance,
    selectedCostCenterSpecification, costCenter
  ) {
    var self = this;

    self.specificationData = selectedCostCenterSpecification ? _.cloneDeep(selectedCostCenterSpecification) : {};
    self.selectedTaxRateReason = selectedCostCenterSpecification ? selectedCostCenterSpecification.TaxRateReason : null;

    // EVENT-HANDLERS
    self.applyModal = function (id, identifier, name, taxRate, taxRateReason, hint) {
      $uibModalInstance.close({
        id: id,

        Identifier: identifier || null,
        Name: name,

        TaxRatePercent: taxRate,
        TaxRateReason: parseFloat(taxRate) === 0 ? taxRateReason : null,

        Hint: hint,
      });
    };

    // VIEW-FUNCTIONS
    self.validateField = function (fieldName, value) {
      if (!value) {
        return false;
      }

      var costCenterSpecifications = costCenter.CostCenterSpecifications || [];

      if (costCenterSpecifications && costCenterSpecifications.length) {
        return (!costCenterSpecifications
          .some(function (specification) {
            return (specification.id !== self.specificationData.id) && (specification[fieldName].toLocaleLowerCase() === value.toLocaleLowerCase())
          }));
      }
      else {
        return true;
      }
    };

    self.validateTaxRate = function () {
      var val = (self.specificationData || {}).TaxRatePercent;
      return !val || parseFloat(val) >= 0;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.costCenters')
    .controller('AdminFinancesCostCenterDetailsModalCtrl', AdminFinancesCostCenterDetailsModalCtrl);

    /** @ngInject */
  function AdminFinancesCostCenterDetailsModalCtrl(
    $uibModalInstance, selectedCostCenter, costCenters
  ) {
    var self = this;

    self.costCenterData = selectedCostCenter ? _.cloneDeep(selectedCostCenter) : emptyCostCenter();

    self.costCenterSpecifications = self.costCenterData.CostCenterSpecifications || [emptyCostCenterSpecification()];

    // EVENT-HANDLERS
    self.applyModal = function (id, identifier, name, costCenterSpecifications) {
      // NOTE: we clean out all not filled specifications-entries in the table
      $uibModalInstance.close({
        id: id,

        Identifier: identifier || null,
        Name: name,

        CostCenterSpecifications: (costCenterSpecifications || []).filter(function(specEntry) {
          if (parseFloat(specEntry.TaxRatePercent) !== 0) {
            specEntry.TaxRateReason = null;
          }

          return specEntry.Name;
        }),
      });
    };

    self.addSpecificationEntry = function() {
      self.costCenterSpecifications.push(emptyCostCenterSpecification());
    }

    self.deleteSpecificationEntry = function(specIndex) {
      _.pullAt(self.costCenterSpecifications, specIndex);
    }

    // VIEW-FUNCTIONS
    self.validateField = function (fieldName, value) {
      if (!value) {
        return false;
      }

      if (costCenters && costCenters.length) {
        return (!costCenters
          .some(function (costCenter) {
            return (costCenter.id !== self.costCenterData.id) && (costCenter[fieldName].toLocaleLowerCase() === value.toLocaleLowerCase())
          }));
      }
      else {
        return true;
      }
    };

    self.validateSpecificationField = function (fieldName, specIndex) {
      if (typeof specIndex !== 'number') {
        return false;
      }

      if (self.costCenterSpecifications && self.costCenterSpecifications.length) {
        var specAtIndex = self.costCenterSpecifications[specIndex];

        return (!self.costCenterSpecifications
          .some(function (spec) {
            return spec != specAtIndex && spec[fieldName] && specAtIndex[fieldName]
              && spec[fieldName].toLocaleLowerCase() === specAtIndex[fieldName].toLocaleLowerCase()
          }));
      }
      else {
        return true;
      }
    };

    self.validateTaxRate = function (specTaxRate) {
      return !specTaxRate || parseFloat(specTaxRate) >= 0;
    }

    self.taxRateReasonValidator = function(specifications, index) {
      return !!specifications[index].TaxRateReason;
    }

    // HELPERS
    function emptyCostCenter() {
      return {
        Identifier: null,
        Name: null,
      }
    }

    function emptyCostCenterSpecification() {
      return {
        Identifier: null,
        Name: null,
        TaxRatePercent: null,
        TaxRateReason: null,
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances', [
      'BlurAdmin.pages.administration.finances.quotationsAndInvoices',
      'BlurAdmin.pages.administration.finances.costCenters',
      'BlurAdmin.pages.administration.finances.prices',
      'BlurAdmin.pages.administration.finances.general',
    ])
    .constant('MATERIAL_PRICES_VIEWMODE', { MATERIALS: 'MATERIALS', MATERIAL_TYPES: 'MATERIAL_TYPES' })
    .constant('FINANCE_POSITION_DETAILS_MODE', { ADD: 'ADD', EDIT: 'EDIT' })
    .constant('DISCOUNT_UNIT_TYPES', { FLAT: 'FLAT', PERCENT: 'PERCENT' })
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.finances', {
        url: '/finances',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        title: 'navigation.administration.finances',
        abstract: true,
        sidebarMeta: {
          order: 100,
        },
      })
  }
})();


/**
 * @author ARNO-Team
 * created 10/2021
 */
(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name materialsPricesComponent
  *
  * @description Component provides automatich checking for duplicates for a given BusinessPartner
  */
  angular.module('BlurAdmin.pages.administration.finances')
    .component('arnoMaterialsPrices', {
      templateUrl: 'app/pages/administration/finances/components/materialsPrices/materialsPrices.comp.html',
      controller: MaterialsPricesCtrl,
      controllerAs: '$materialsPricesCtrl',
      bindings: {
        context: '<', // NOTE: use later when needed for special-cases

        initialMaterialTypes: '='
      }
    });

  /**
  * @description Controller for the materialsPrices component.
  *
  * @namespace BlurAdmin.pages.administration.finances.materialsPrices.MaterialsPricesCtrl
  */
  /** @ngInject */
  function MaterialsPricesCtrl(
    $rootScope, $scope, $uibModal, $state,
    clientApi, materialUtil, validationUtils, commonUtils, ArnoDashPricesService, ArnoDashMaterialsService, ARNO_CONSTANTS
  ) {
    var self = this;

    // CONSTS
    self.ALLOWED_MATERIALS_CATEGORIES = [ 'Medicine', 'MedicalProducts', 'Clothing', 'Vehicles', 'Tools', 'Consumables', 'Others' ];
    self.materialsTabsIconMapping = materialUtil.materialsTabsIconMapping;

    var materialsTableColsByCategory = {
      Medicine: {
        Definition: 'modules.administration.finances.prices.detailsModal.definitionCol',
        Content: 'modules.administration.finances.prices.detailsModal.contentCol'
      },
      MedicalProducts: {
        Definition: 'modules.administration.finances.prices.detailsModal.typeCol',
        InventoryNumber: 'modules.administration.finances.prices.detailsModal.inventoryCol'
      },
      Clothing: {
        Name: 'modules.administration.finances.prices.detailsModal.nameCol',
        Category: 'modules.administration.finances.prices.detailsModal.categoryCol'
      },
      Vehicles: {
        VehicleModel: 'modules.administration.finances.prices.detailsModal.vehicleModelCol',
        InventoryNumber: 'modules.administration.finances.prices.detailsModal.inventoryCol'
      },
      Tools: {
        Definition: 'modules.administration.finances.prices.detailsModal.captionCol',
        Type: 'modules.administration.finances.prices.detailsModal.gadgetTypeCol'
      },
      Consumables: {
        Definition: 'modules.administration.finances.prices.detailsModal.captionCol',
        Color: 'modules.administration.finances.prices.detailsModal.colorCol'
      },
      Others: {
        Name: 'modules.administration.finances.prices.detailsModal.nameCol',
        Definition: 'modules.administration.finances.prices.detailsModal.captionCol'
      }
    }

    var materialsPriceColsDef = [{
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerHourCol', prop: 'ExternalPricePerHour'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerDayCol', prop: 'ExternalPricePerDay'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.externalPricePerCountCol', prop: 'ExternalPricePerCount'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.internalPricePerHourCol', prop: 'InternalPricePerHour'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.internalPricePerDayCol', prop: 'InternalPricePerDay'
    }, {
      label: 'modules.administration.finances.prices.detailsModal.internalPricePerCountCol', prop: 'InternalPricePerCount'
    }];

    // VARS
    self.materialsTypesTreeUiConfig = {
      addBtnLabel: 'modules.administration.finances.prices.materials.materialTypePriceAddBtnLabel',
      editBtnLabel: 'modules.administration.finances.prices.materials.materialTypePriceEditBtnLabel'
    }

    self.selectedMaterialTypeNode = null;
    self.selectedMaterialCategory = localStorage.getItem('pref_materials_prices_selected_category') || self.ALLOWED_MATERIALS_CATEGORIES[0];
    self.currentActiveMaterialsTab = self.ALLOWED_MATERIALS_CATEGORIES.indexOf(self.selectedMaterialCategory) || 0;
    self.materialTableConfigs = null;
    self.materialMeta = null;

    self.filterItemsWithMissingPrices = false;

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf MaterialsPricesCtrl#
    */
    function activate() {
      getMaterialsTableConfig();
    }

    // WATCHERS
    $scope.$watch(function () {
      return self.filterItemsWithMissingPrices;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        ArnoDashMaterialsService.getMaterialsTypesWithPricesAsTree(self.context, self.filterItemsWithMissingPrices)
          .then(function(results) {
            self.initialMaterialTypes = results;
          });
      }
    }, true);

    // VIEW-FUNCTIONS
    self.isOrgContext = function() {
      return (self.context || []).length == 1 && (self.context || []).indexOf('rootOrg') >= 0;
    }

    self.getMaterialCategory = function() {
      return 'Material' + (self.selectedMaterialCategory || ((self.selectedMaterialTypeNode  || {}).model || {}).Category);
    }

    // EVENT-HANDLERS
    self.materialTypeNodeSelect = function(newSelectedNode) {
      self.selectedMaterialTypeNode = newSelectedNode;

      var newCategory = ((self.selectedMaterialTypeNode  || {}).model || {}).Category;
      self.selectedMaterialCategory = newCategory || self.selectedMaterialCategory;
      var newCategoryIndex = self.ALLOWED_MATERIALS_CATEGORIES.indexOf(newCategory);

      if (newCategoryIndex >= 0) {
        self.currentActiveMaterialsTab = newCategoryIndex;
        localStorage.setItem('pref_materials_prices_selected_category', newCategory);
      }
    }

    self.selectMaterialTab = function(newCategory) {
      self.selectedMaterialCategory = newCategory;
      localStorage.setItem('pref_materials_prices_selected_category', newCategory);

      // check, if the current selected material-type node is is the same category like the new category selected by the tab
      // if not, then we deselect it....
      if (self.selectedMaterialTypeNode && ((self.selectedMaterialTypeNode  || {}).model || {}).Category != newCategory) {
        self.selectedMaterialTypeNode.isSelected = false;
        self.selectedMaterialTypeNode = null;
      }
    }

    self.addMaterialTypePriceItem = function(materialTypeNode) {
      openMaterialTypePriceItemEditModal((materialTypeNode || {}).model ? [materialTypeNode.model] : []);
    }

    self.editMaterialTypePriceItem = function(materialTypeNode) {
      openMaterialTypePriceItemEditModal((materialTypeNode || {}).model ? [materialTypeNode.model] : []);
    }

    self.selectedMaterials = function(materials) {
      if (Array.isArray(materials)) {
        var hasPricesInfo = !!materials.filter(function(material) {
          return validationUtils.hasValidPriceDefinition(material);
        }).length;

        var presetPrices = null;
        if (!hasPricesInfo && materials[0].MaterialType) {
          presetPrices = _.pick((materials[0].MaterialType.PriceItemOverrides || [])[0] || materials[0].MaterialType, [
            'ExternalPricePerHour', 'ExternalPricePerDay', 'ExternalPricePerCount',
            'InternalPricePerHour', 'InternalPricePerDay', 'InternalPricePerCount'
          ]);
        }

        openMaterialPriceItemEditModal(materials, presetPrices);
      }
    }

    self.removeMaterialsPrices = function(materials) {
      if (materials && self.selectedMaterialCategory) {
        var materialsIds = (!Array.isArray(materials) ? [materials] : materials).map(function(material) {
          return material.id;
        });

        ArnoDashPricesService.deleteMaterialsPricesWithMessageModal(self.selectedMaterialCategory, materialsIds || []).then(function() {
          $rootScope.$broadcast('financial-material-picker', { reload: true });
        });
      }
    }


    // HELPERS
    function getMaterialsTableConfig() {
      Promise.all([
        clientApi.custom('model/Service', 'getServiceMaterialMeta'),
        clientApi.custom('model/Service', 'getServiceMaterialTableConfigs')
      ]).then(function(results) {
        self.materialMeta = (results || [])[0] || {};
        self.materialTableConfigs = (results || [])[1] || {};

        self.materialMeta.columnDefinitions = self.materialMeta.columnDefinitions || {};
        self.materialMeta.defaultTableConfig = self.materialMeta.defaultTableConfig || materialUtil.materialDefaultTableConfig;

        _.forEach(self.ALLOWED_MATERIALS_CATEGORIES, function(materialCategory) {
          if (materialCategory) {
            var model = 'Material' + materialCategory;
            var columnDefs = self.materialMeta.columnDefinitions[model];

            if (columnDefs) {
              self.materialMeta.columnDefinitions[model] = columnDefs.concat(materialsPriceColsDef);
              self.materialMeta.defaultTableConfig[model] = _.uniq((self.materialMeta.defaultTableConfig[model] || []).concat(materialsPriceColsDef.map(function(colDef) { return colDef.prop })));
            }
          }
        });
      });
    }

    function openMaterialTypePriceItemEditModal(materialsTypesModels) {
      var priceItemOverride;
      var flatCtx = Array.isArray(self.context) ? self.context[0] : self.context;
      if (Array.isArray(materialsTypesModels) && materialsTypesModels.length === 1) {
        priceItemOverride = ((materialsTypesModels[0] || {}).PriceItemOverrides || [])[0];
      }
      return $uibModal
        .open({
          controller: 'AdminFinancesPriceDetailsModalCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/administration/finances/prices/modals/detailsModal.html',
          size: 'md',
          resolve: {
            uiConfig: function () {
              return {
                showTitleField: false,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixMaterialType'
              }
            },
            targetPriceItems: function () {
              return priceItemOverride ? [priceItemOverride] : materialsTypesModels || [];
            },
            selectedDivisionId: function () {
              return self.context;
            },
            presetPrices: function () {
              return null;
            },
          }
        })
        .result
        .then(function (newPriceItemData) {
          var materialType = (materialsTypesModels || [])[0];
          if ((!priceItemOverride && flatCtx === 'rootOrg') || materialType.DivisionId) {
            Object.assign(materialType, newPriceItemData);

            ArnoDashPricesService.saveMaterialTypePrices(materialType);

            $state.reload();
          } else {
            if (!priceItemOverride) {
              delete newPriceItemData.id;
            }
            ArnoDashPricesService.overridePriceItem(
              flatCtx,
              ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE,
              materialType,
              newPriceItemData
            ).then(function () {
              $state.reload();
            });
          }
        });
    }

    function openMaterialPriceItemEditModal(materialsModels, presetPrices) {
      var materialsCategory = self.selectedMaterialCategory || ((self.selectedMaterialTypeNode || {}).model || {}).Category;
      var materialsTableCols = materialsTableColsByCategory[materialsCategory];

      return $uibModal
        .open({
          controller: 'AdminFinancesPriceDetailsModalCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/administration/finances/prices/modals/detailsModal.html',
          size: (materialsModels || []).length > 1 ? 'lg' : 'md',
          resolve: {
            uiConfig: function () {
              return {
                showTitleField: false,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixMaterial',
                targetPriceItemsTableConf: Object.assign(materialsTableCols || {}, {
                  ExternalPricePerHour: 'modules.administration.finances.prices.detailsModal.externalPricePerHourCol',
                  ExternalPricePerDay: 'modules.administration.finances.prices.detailsModal.externalPricePerDayCol',
                  ExternalPricePerCount: 'modules.administration.finances.prices.detailsModal.externalPricePerCountCol'
                })
              }
            },
            targetPriceItems: function () {
              return materialsModels || [];
            },
            selectedDivisionId: function () {
              return self.context;
            },
            presetPrices: function () {
              return presetPrices;
            },
          }
        })
        .result
        .then(function (newMaterialsWithPrices) {
          return ArnoDashPricesService.saveMaterialsPrices(
            materialsCategory,
            !Array.isArray(newMaterialsWithPrices) ? [newMaterialsWithPrices] : newMaterialsWithPrices
          );
        })
        .then(function() {
          $rootScope.$broadcast('financial-material-picker', { reload: true });
        });
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
}());



/**
 * @author ARNO-Team
 * created 09/2021
 */
 (function () {
   'use strict';

  /**
   * @ngdoc component
   * @name financePositionsComponent
   *
   * @description Component provides automatich checking for duplicates for a given BusinessPartner
   */
   angular.module('BlurAdmin.pages.administration.finances')
    .component('arnoFinancePositions', {
      templateUrl: 'app/pages/administration/finances/components/financePositions/financePositions.comp.html',
      controller: FinancePositionsCtrl,
      controllerAs: '$positionsCtrl',
      bindings: {
        positions: '=',
        context: '<', // NOTE: use later when needed for special-cases

        priceItemsSearchTerm: '=?', // string,

        headerTitle: '<', // could be a translate-key
        showTitle: '<',

        metaData: '=', // object containing meta information, e.g. discount

        disabled: '=ngDisabled',
      }
    })
    .filter('toFixedFinancial', function () {
      return function (value) {
        return typeof value === 'number' ? (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2) : value;
      };
    })
    .directive('onSelectOpen', ['$parse', function ($parse) {
      return {
        require: 'uiSelect',
        link: function (scope, element, attrs, $select) {
          scope.$watch(function () {
            return $select.open;
          }, function (isOpen) {
            if (isOpen) {
              $parse(attrs.onSelectOpen)(scope, { selectCtrl: $select });
            }
          });
        }
      };
    }]);

  /**
   * @description Controller for the financePositions component.
   *
   * @namespace BlurAdmin.pages.administration.finances.financePositions.FinancePositionsCtrl
   */
  /** @ngInject */
   function FinancePositionsCtrl(
    $scope, $translate, $uibModal,
    FINANCE_POSITION_DETAILS_MODE, ARNO_CONSTANTS, DISCOUNT_UNIT_TYPES,
    clientApi, ArnoDashPricesService, toFixedFinancialFilter
  ) {
     var self = this;

    // CONSTS
     self.PRICE_ITEM_TYPE = ARNO_CONSTANTS.PRICE_ITEM_TYPE;
     self.PRICE_ITEM_TYPE_ICON = ARNO_CONSTANTS.PRICE_ITEM_TYPE_ICON;
     self.DISCOUNT_UNIT_TYPES = DISCOUNT_UNIT_TYPES;

     self.PRICE_ITEM_TYPES = ['ALL'];
     self.PRICE_ITEM_TYPES = self.PRICE_ITEM_TYPES.concat(Object.keys(ARNO_CONSTANTS.PRICE_ITEM_TYPE));

    // VARS
     self.priceItems = [];
     self.selectedPriceItem = null;

     self.selectedSearchPriceItemType = self.PRICE_ITEM_TYPES[0];

     self.PosStart = false;

    // BOOTSTRAPPER
    /**
     * @name activate
     * @description Function for controller inits
     * @returns {Void} none
     * @memberOf FinancePositionsCtrl#
     */
     function activate() {
     }

    // WATCHES
     $scope.$watch('$positionsCtrl.priceItemsSearchTerm', function (newVal) {
       searchPriceItems(newVal, self.selectedSearchPriceItemType);
     });

     self.recalculateSums = function () {
       self.metaData.FinalAmount = 0;

       _.forEach(self.positions || [], function (position) {
         var taxRate;
         if (((self.metaData || {}).quotInvBaseData || {}).CostCenterSpecification) {
           taxRate = self.metaData.quotInvBaseData.CostCenterSpecification.TaxRatePercent;
           if (position.CostCenterSpecification && !position.CostCenterSpecification.defaultSelection) {
             taxRate = position.CostCenterSpecification.TaxRatePercent;
           }
         }
         position.PriceUnitType = position.PriceUnitType || ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_HOUR;
         position.Price = position.Price || position.AdditionalMetaJson.ExternalPricePerHour || 0;
         position._taxRate = taxRate;
         position._sum = ArnoDashPricesService.calcSumForPosition(
          position.Price,
          position.PriceUnitCount,
          taxRate === null ? 0 : taxRate
        );

         if (position._sum !== null && self.metaData.FinalAmount !== null) {
           self.metaData.FinalAmount += position._sum;
         } else {
           self.metaData.FinalAmount = null;
         }
       });

       if (self.metaData.FinalAmount !== null) {
         if (self.metaData.discount && self.metaData.discountUnit) {
           self.metaData.FinalAmount = self.metaData.FinalAmount - ArnoDashPricesService.calcDiscount(
            self.metaData.FinalAmount,
            null,
            self.metaData.discount,
            self.metaData.discountUnit
          );
         }

         self.metaData.FinalAmount = parseFloat(toFixedFinancialFilter(self.metaData.FinalAmount));
       }
     };

     $scope.$watch(function () {
       return self.positions;
     }, function () {
       self.recalculateSums();
     }, true);

     $scope.$watch(function () {
       return (self.metaData || {}).quotInvBaseData.CostCenterSpecification;
     }, function (newVal) {
       if (newVal) {
         self.recalculateSums();
       }
     }, true);

     $scope.$watch(function () {
       return (self.metaData.discount || '').toString() + '_' + self.metaData.discountUnit;
     }, function (newVal) {
       if (newVal) {
         self.recalculateSums();
       }
     });

     $scope.$watch(function () {
       return self.positions;
     }, function (newVal) {

       if (newVal && !self.PosStart) {

         var found = _.find(self.positions, function (p) {
           return p.Order == null;
         });

         if (found) {
           for (var i = 0; i < self.positions.length; i++) {
             self.positions[i].Order = i + 1;
           }
         }

         self.PosStart = true;
       }
     });

     self.priceItemGroupFunc = function (priceItem) {
       return $translate.instant('modules.administration.finances.financePositions.priceItemTypes.' + (priceItem.priceItemType || 'ALL'));
     };

    // EVENT-HANDLERS
     self.addPosition = function () {
       if (self.selectedPriceItem) {
         openPositionDetails(FINANCE_POSITION_DETAILS_MODE.ADD, {}, self.selectedPriceItem)
          .then(function () {
            self.selectedPriceItem = null;
          });
       }
     };

     self.addFreePosition = function () {
       openPositionDetails(FINANCE_POSITION_DETAILS_MODE.ADD, {}, null);
     };

     self.editPosition = function (position) {
       openPositionDetails(FINANCE_POSITION_DETAILS_MODE.EDIT, position, null);
     };

     self.deletePosition = function (positionIndex) {
       if (positionIndex != null) {
         var pIndex = _.findIndex(self.positions, function (p) {
           return p.Order === (positionIndex + 1);
         });

         _.pullAt(self.positions, pIndex);
       }
     };

     self.selectedSearchPriceItemTypeChanged = function (newSearchItemType) {
       self.selectedSearchPriceItemType = newSearchItemType;

       if (newSearchItemType === self.PRICE_ITEM_TYPE.MATERIAL) {
         return $uibModal.open({
           controller: 'AdminFinancesPricesMaterialSearchModalCtrl as $modalCtrl',
           animation: true,
           backdrop: 'static',
           templateUrl: 'app/pages/administration/finances/prices/modals/materialSearchModal.html',
           size: 'lg',
           resolve: {
             materialTableConfigs: function () {
               return clientApi.custom('model/Service', 'getServiceMaterialTableConfigs');
             },
             materialMeta: function () {
               return clientApi.custom('model/Service', 'getServiceMaterialMeta', { language: $translate.use() });
             },
             divisionId: function () {
               return self.context;
             }
           }
         })
          .result
          .then(function (selectedMaterialInfo) {
            var selectedMaterial = selectedMaterialInfo.material;
            selectedMaterial.priceItemType = ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL;
            selectedMaterial.priceItemSubType = selectedMaterialInfo.materialCategory;

            self.priceItems = (self.priceItems || []).filter(function (priceItem) {
              return (priceItem || {}).priceItemType === ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL;
            }) || [];

            self.priceItems.push(selectedMaterial);
            self.priceItems = _.uniqBy(self.priceItems, 'id');

            self.selectedPriceItem = selectedMaterial;
            self.addPosition();
          });
       }

       searchPriceItems(self.searchTerm, self.selectedSearchPriceItemType);
     };

     self.deselectPriceItem = function (event) {
       event.stopPropagation();

       self.selectedPriceItem = null;
     };

     self.selectOpenGuard = function ($select) {
       if (self.selectedSearchPriceItemType === self.PRICE_ITEM_TYPE.MATERIAL) {
         $select.close();
         self.selectedSearchPriceItemTypeChanged(self.selectedSearchPriceItemType);
       }
     };

     self.priceItemsSearch = function (newSearchTerm) {
       self.priceItemsSearchTerm = newSearchTerm;
     };

     self.changeDiscountUnit = function (isFlat) {
       self.metaData.discountUnit = isFlat ? self.DISCOUNT_UNIT_TYPES.FLAT : self.DISCOUNT_UNIT_TYPES.PERCENT;
     };

    // HELPERS
     function searchPriceItems(searchTerm, searchPriceItemType, furtherOptions) {
       ArnoDashPricesService.searchPriceItems(searchTerm, Object.assign({}, furtherOptions || {}, {
         selectedPriceItemTypes: searchPriceItemType,
         divisionId: self.context,
       })).then(function (results) {
         if ((results.rows || []).length) {
           self.priceItems = results.rows;
         } else if ((searchTerm || '').trim() !== '') {
           self.priceItems = [{
             isHint: true,
             messageKey: 'controls.uiSelect.hintSearchNoResults',
             priceItemType: searchPriceItemType
           }];
         } else {
           self.priceItems = results.rows;
         }
       });
     }

     self.currentMaxOrder = function () {
       return (_.maxBy(self.positions, 'Order') || { Order: 0 }).Order;
     };

     self.movePosition = function (position, up) {
       var keyedPositions = _.keyBy(self.positions, 'Order');
       var availableOrders = Object.keys(keyedPositions).map(function (key) {
         return parseInt(key, 10);
       });
       availableOrders.sort();
       var switchTargetOrderIndex = availableOrders.indexOf(position.Order) + (up ? -1 : 1);
       if (switchTargetOrderIndex < 0 || switchTargetOrderIndex >= availableOrders.length) {
         return;
       }
       var switchStore = keyedPositions[availableOrders[switchTargetOrderIndex]].Order;
       keyedPositions[availableOrders[switchTargetOrderIndex]].Order = position.Order;
       position.Order = switchStore;
     };

     function openPositionDetails(mode, position, selectedPriceitem) {
       return $uibModal.open({
         controller: 'AdminFinancesFinancePositionModalCtrl as $modalCtrl',
         animation: true,
         backdrop: 'static',
         templateUrl: 'app/pages/administration/finances/components/financePositions/financePositionModal.html',
         size: 'md',
         resolve: {
           mode: function () {
             return mode;
           },
           selectedPriceitem: function () {
             return selectedPriceitem;
           },
           financePosition: function () {
             return position;
           },
           quotInvBaseData: function () {
             return (self.metaData || {}).quotInvBaseData;
           }
         }
       })
        .result
        .then(function (result) {
          if ((result || {}).data) {
            if (result.mode === FINANCE_POSITION_DETAILS_MODE.EDIT) {
              var foundIndex = _.findIndex(self.positions, result.data);

              if (foundIndex >= 0) {
                self.positions.splice(foundIndex, 1, result.data);
              }
            } else {
              result.data.Order = self.currentMaxOrder() + 1;
              self.positions.push(result.data);
            }
          }
        });
     }

     self.getPriceTypeTranslation = function (type, price) {
       if (!(type && price)) {
         return $translate.instant('modules.administration.finances.financePositions.priceUnitTypes.NONE');
       }
       return $translate.instant('modules.administration.finances.financePositions.priceUnitTypes.' + type);
     };

    // CONTROLLER-INIT
     self.$onInit = function () {
       activate();
     };
   }
 }());
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances')
    .controller('AdminFinancesFinancePositionModalCtrl', AdminFinancesFinancePositionModalCtrl);

  /** @ngInject */
  function AdminFinancesFinancePositionModalCtrl(
    $scope, $timeout, $uibModalInstance,
    FINANCE_POSITION_DETAILS_MODE, ARNO_CONSTANTS,
    mode, financePosition, selectedPriceitem, $translate, quotInvBaseData
  ) {
    var self = this;

    $scope.PRICE_UNIT_TYPE = ARNO_CONSTANTS.PRICE_UNIT_TYPE;
    self.PRICE_UNIT_TYPES = Object.keys(ARNO_CONSTANTS.PRICE_UNIT_TYPE);

    self.mode = mode || FINANCE_POSITION_DETAILS_MODE.ADD;
    self.quotInvBaseData = quotInvBaseData;

    if (self.mode === FINANCE_POSITION_DETAILS_MODE.EDIT) {
      self.positionData = _.clone(financePosition);
    } else {
      self.positionData = initNewPosition(selectedPriceitem);
    }

    if (self.quotInvBaseData.CostCenterSpecification) {
      self.defaultCostCenterSpecification = (self.quotInvBaseData.CostCenterSpecification.Identifier || '')
                                            + (self.quotInvBaseData.CostCenterSpecification.Identifier ? ' - ' : '')
                                            + self.quotInvBaseData.CostCenterSpecification.Name;
    }
    if (!self.positionData) {
      self.positionData = {};
    }
    if (!self.positionData.CostCenterSpecification) {
      self.positionData.CostCenterSpecification = {
        defaultSelection: $translate.instant(
          'modules.administration.finances.financePositions.detailsModal.costCenterSpecDefault',
          { defaultCostCenterSpecification: self.defaultCostCenterSpecification }
        )
      }
    }

    self.priceOptions = [];

    self.calculatePriceOptions = function () {
      if (self.positionData) {
        if (((selectedPriceitem || {}).PriceItemOverrides || []).length) {
          var priceItemName = selectedPriceitem.Name || selectedPriceitem.Title || selectedPriceitem.Function;
          self.priceOptions = [];

          _.forEach(selectedPriceitem.PriceItemOverrides, function (priceOverride) {
            var priceitemDivision = priceItemName + ' (' + (priceOverride.Division || {}).Name + ')';

            self.priceOptions = self.priceOptions.concat([
              { price: (priceOverride || {}).ExternalPricePerHour, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_HOUR, name: priceitemDivision },
              { price: (priceOverride || {}).ExternalPricePerDay, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_DAY, name: priceitemDivision },
              { price: (priceOverride || {}).ExternalPricePerCount, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_COUNT, name: priceitemDivision }
            ]);
          });

          self.priceOptions = self.priceOptions.concat([
            { price: selectedPriceitem.ExternalPricePerHour, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_HOUR, name: priceItemName },
            { price: selectedPriceitem.ExternalPricePerDay, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_DAY, name: priceItemName },
            { price: selectedPriceitem.ExternalPricePerCount, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_COUNT, name: priceItemName }
          ]);

          self.priceOptions = self.priceOptions.filter(function (p) {
            return ![undefined, null].includes(p.price);
          });
        } else {
          self.priceOptions = [
            { price: (self.positionData.AdditionalMetaJson || {}).ExternalPricePerHour, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_HOUR },
            { price: (self.positionData.AdditionalMetaJson || {}).ExternalPricePerDay, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_DAY },
            { price: (self.positionData.AdditionalMetaJson || {}).ExternalPricePerCount, type: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_COUNT },
          ].filter(function (p) {
            return ![undefined, null].includes(p.price);
          });
        }
      }
    }

    self.setPrice = function (priceOption) {
      if (!priceOption) {
        if (self.priceOptions.length === 1) {
          self.setPrice(self.priceOptions[0]);
        }
        return;
      }
      self.positionData.PriceUnitType = priceOption.type;
      self.positionData.Price = priceOption.price;
    }

    self.calculatePriceOptions();
    self.setPrice();

    $scope.$watch(function () {
      return self.positionData.AdditionalMetaJson;
    }, self.calculatePriceOptions, true);

    self.administrativePriceSet = function () {
      return !self.priceOptions.length || ![undefined, null].includes(self.positionData.Price)
             && (_.find(self.priceOptions, { type: self.positionData.PriceUnitType }) || {}).price === self.positionData.Price;
    };

    self.costCenterOnSelect = function (selection) {
      self.positionData.CostCenterSpecification = selection;
    }

    self.openPriceOptions = function () {
      $timeout(function () {
        angular.element('#financepositions-details-modal-arno-ui-select-price-options .ui-select-toggle').triggerHandler('click');
      });
    }

    self.applyModal = function () {
      var position = Object.assign(financePosition || {}, self.positionData);

      $uibModalInstance.close({
        mode: self.mode,
        data: position
      });
    }

    // HELPERS
    function initNewPosition(priceItem) {
      if (priceItem) {
        // here we add a position for a price-item
        return {
          Title: priceItem.Title || priceItem.Function || priceItem.Name,

          CostCenterSpecification: priceItem.CostCenterSpecification || null,

          PriceUnitType: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_COUNT,
          Price: null,
          PriceUnitCount: 1,

          TaxRatePercent: (priceItem.CostCenterSpecification || {}).TaxRatePercent,
          TaxRateReason: (priceItem.CostCenterSpecification || {}).TaxRateReason,

          AdditionalMetaJson: {
            InternalPricePerHour: priceItem.InternalPricePerHour,
            InternalPricePerDay: priceItem.InternalPricePerDay,
            InternalPricePerCount: priceItem.InternalPricePerCount,

            ExternalPricePerHour: priceItem.ExternalPricePerHour,
            ExternalPricePerDay: priceItem.ExternalPricePerDay,
            ExternalPricePerCount: priceItem.ExternalPricePerCount,

            PriceItemId: priceItem.id,
            PriceItemType: priceItem.priceItemType,
            PriceItemSubType: priceItem.priceItemSubType || (priceItem.priceItemType === 'MATERIAL_TYPE' && priceItem.Category) || null,
          }
        }
      }

      // here we add a free position
      return {
        CostCenterSpecification: null,

        PriceUnitType: ARNO_CONSTANTS.PRICE_UNIT_TYPE.PER_COUNT,
        PriceUnitCount: 1,

        AdditionalMetaJson: {}
      }
    }
  }
})();

(function () {
  'use strict';
  
  angular
    .module('BlurAdmin.pages.administration.events.serviceTypes', [])
    .controller('serviceTypeModalCtrl', serviceTypeModalCtrl);
  
    /** @ngInject */
  function serviceTypeModalCtrl($scope, $uibModalInstance, selectedServiceType, serviceTypes, $translate) {
    var self = this;

    self.title = selectedServiceType ? $translate.instant('modules.administration.events.editEventType') : $translate.instant('modules.administration.events.addEventType');
    self.ServiceType = selectedServiceType ? _.cloneDeep(selectedServiceType) : {};      

    self.applyModal = function (id, name) {
      $uibModalInstance.close({
        id: id,
        name: name
      });        
    };

    self.validateName = function (name) {
      if (!name) {
        return false;
      }
      if (serviceTypes && serviceTypes.length) {
        return (!serviceTypes
          .filter(function (type) {
            return (type.id !== self.ServiceType.id) && (type.Name.toLocaleLowerCase() === name.toLocaleLowerCase())
          }).length);
      }
      else {
        return true;
      }        
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.businessPartners', [
      'BlurAdmin.pages.contacts.businessPartners.details'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.contacts.businessPartners', {
        url: '/businessPartners',
        templateUrl: 'app/pages/contacts/businessPartners/businessPartners.html',
        title: 'navigation.contacts.businessPartners',
        controller: 'ContactsBusinessPartnersCtrl as $ctrl',
        params: {
          selectedCtxInfo: {
            dynamic: true,
            inherit: false,
            value: null
          },
        },
        resolve: {
          ctx: function ($stateParams, commonUtils) {
            if (($stateParams.selectedCtxInfo || {}).division != null) {
              var divisions = [$stateParams.selectedCtxInfo.division];
              delete $stateParams.selectedCtxInfo.division;

              commonUtils.division.setCtx(divisions, {
                multiple: false,
                entryPermission: 'arno.contacts.businessPartners.view',
                namespace: 'contactsBusinessPartners',
                allowOrgSelection: false,
              });

              return divisions;
            }

            return commonUtils.division.getCtx({
              multiple: false,
              entryPermission: 'arno.contacts.businessPartners.view',
              namespace: 'contactsBusinessPartners',
              allowOrgSelection: false,
            });
          },
          CAT_COUNTRY_IDS: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },

          tableConfig: function (clientApi, commonUtils, ctx, permissions, $rootScope) {
            var getDefaults = function (availableFields, customTableConfigs) {
              var orgPageSize = commonUtils.preference.object.get('pref_businesspartners_table_page_size_org', 10);

              var tableConfigOrgDefault = {
                Name: true,
                TradeName: false,
                TaxIdentifier: false,
                City: true,
                ZIP: true,
                Street: true,
                HouseNumber: true,
                LegalRegistrationIdentifier: false,
                VatIdentifier: false,
                CustomerNumber: false,

                IsBuyer: true,
                IsSeller: true,
                IsMaterialProvider: true,

                pageSize: orgPageSize.pageSize || orgPageSize,
              };

              // create own field lists for div and org level
              var orgFields = JSON.parse(JSON.stringify(availableFields));

              return {
                tableConfigAvailableFields: { org: orgFields },
                tableConfigOrgDefault: tableConfigOrgDefault,
                tableConfigCustomPreference: customTableConfigs
              };
            };

            if (permissions.isPermittedInEvery('arno.contacts.businessPartners.view', 'Division', ctx)
              || permissions.isPermittedInEvery('arno.contacts.businessPartners.view', 'Organization', [$rootScope.ctx.organization.current.id])
            ) {
              return clientApi
                .custom('model/BusinessPartner', 'getTableConfigColumns', {
                  includeSpecialFields: true,
                })
                .then(function (availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'contactsOrganizationList'
                    })
                    .then(function (customTableConfigs) {
                      return getDefaults(availableFields, customTableConfigs);
                    });
                });
            }

            return getDefaults([], []);
          },

        },

        sidebarMeta: {
          order: 800,
        },
      })
      .state('arno.contacts.businessPartnerDetails', {
        url: '/businessPartnerDetails/:id?',
        templateUrl: 'app/pages/contacts/businessPartners/businessPartnerDetails.html',
        title: 'navigation.contacts.businessPartnerDetails',
        controller: 'ContactsBusinessPartnerDetailsCtrl as $ctrl',
        params: {
          id: {
            dynamic: true,
          },
          selectedCtxInfo: {
            dynamic: true,
            inherit: false,
            value: null
          },
        },
        resolve: {

          CAT_COUNTRY_IDS: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },

          businessPartner: function ($stateParams, ArnoDashBusinessPartnersService) {
            var businessPartnerId = $stateParams.id;

            if (!businessPartnerId) {
              return Promise.resolve(null);
            }

            return ArnoDashBusinessPartnersService.getBusinessPartnerDetails(businessPartnerId, true);
          },
          ctx: function ($stateParams, commonUtils, businessPartner) {
            if (($stateParams.selectedCtxInfo || {}).division != null) {
              var divisions = [$stateParams.selectedCtxInfo.division];
              delete $stateParams.selectedCtxInfo.division;

              commonUtils.division.setCtx(divisions, {
                multiple: false,
                entryPermission: 'arno.contacts.businessPartners.view',
                allowOrgSelection: false,
              });

              return divisions;
            }

            if (businessPartner && !businessPartner.DivisionId) {
              return ['rootOrg'];
            }
            return commonUtils.division.getCtx({
              multiple: false,
              entryPermission: 'arno.contacts.businessPartners.view',
              namespace: 'contactsBusinessPartners',
              allowOrgSelection: false,
            });
          },
          attachedContacts: function (clientApi, $stateParams, ctx) {
            var businessPartnerId = $stateParams.id;

            if (businessPartnerId) {
              return clientApi.custom('model/Contact', 'getContactsForBusinessPartner', {
                businessPartnerId: businessPartnerId,
                divisionId: ctx,
              })
              .then(function (contacts) {
                return (contacts || []).map(function (c) {
                  c.Division = c.Divisions && c.Divisions.length && c.Divisions[0].Name;
                  return c;
                });
              });
            }
            return [];
          }
        },
        viewPermission: 'arno.contacts.businessPartners.view'
      });
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.businessPartners')
    .controller('divSelectorCtrl', divSelectorCtrl);

  function divSelectorCtrl($uibModalInstance, clientApi) {
    var self = this;
    self.selectableDivs = [];

    // actually searches businesspartners with divisions included so that it can be linked later
    self.searchDivs = function(searchTerm) {
      return clientApi
        .custom('model/BusinessPartner', 'getSelectorDivs', {
          searchTerm: searchTerm,
        })
        .then(function (res) {
          self.selectableDivs = res;
        })
    }

    self.applyModal = function() {
      return $uibModalInstance.close(self.selectedDiv);
    }
  }
})();
/**
 * @author ARNO-Team
 * created 08/2021
 */
(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name businessPartnerDuplicatesComponent
  *
  * @description Component provides automatich checking for duplicates for a given BusinessPartner
  */
  angular.module('BlurAdmin.pages.contacts.businessPartners')
    .component('businessPartnerDuplicates', {
      templateUrl: 'app/pages/contacts/businessPartners/components/businessPartnerDuplicates.comp.html',
      controller: ContactsBusinessPartnerDuplicatesCtrl,
      controllerAs: '$duplicatesCtrl',
      bindings: {
        businessPartner: '<',
        headerTitle: '<',
        strictMode: '<',
        allowAddLinking: '<',
        divisionId: '<'
      }
    });

    /**
  * @description Controller for the businessPartnerDuplicates component.
  *
  * @namespace BlurAdmin.pages.contacts.businessPartners.ContactsBusinessPartnerDuplicatesCtrl
  */
  /** @ngInject */
  function ContactsBusinessPartnerDuplicatesCtrl(
    $rootScope, $scope, $state, $translate, baModalService, permissions,
    ArnoDashBusinessPartnersService
  ) {
    var self = this;

    // CONSTS
    var FIELDS_TO_CHECK = [
      'Name',
      'TradeName',

      'TaxIdentifier',
      'LegalRegistrationIdentifier',
      'VatIdentifier',

      'CountryId',
      'City',
      'ZIP',
      'ZipCode', // Used for System-businesspartners (division)
      'Street',
      'HouseNumber',
      'AddressAffix',

      'CustomerNumber',
      'Iban',
      'Bic',
      'EMail',
      'BankName',
      'Comment',
      'ElectricAdress',
      'OtherLegalInformation'
    ];

    // VARS
    self.hasOrgViewPermission = false;
    self.hasDivViewPermission = false;
    self.hasDivManagePermission = false;
    self.orgName = $rootScope.ctx.organization.current.name;

    self.duplicates = [];

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ContactsBusinessPartnerDuplicatesCtrl#
    */
    function activate() {
      getUiPermissions();

      searchSimilarBusinessPartners(self.businessPartner);
    }

    // WATCHERS
    $scope.$watch('$duplicatesCtrl.businessPartner', function (newVal) {
      if (newVal) {
        searchSimilarBusinessPartners(newVal);
      }
    }, true);

    // VIEW-FUNCTIONS
    self.getSimilarFields = function(businessPartnerA, businessPartnerB) {
      var businessPartnerANormalizedForCompare = {};
      var businessPartnerBNormalizedForCompare = {};

      FIELDS_TO_CHECK.forEach(function(fieldName) {
        if (fieldName) {
          businessPartnerANormalizedForCompare[fieldName] = businessPartnerA.IsInternal ? businessPartnerA.OwnerDivision[fieldName] : businessPartnerA[fieldName];
          businessPartnerBNormalizedForCompare[fieldName] = businessPartnerB.IsInternal ? businessPartnerB.OwnerDivision[fieldName] : businessPartnerB[fieldName];
        }
      });

      // this function returns a hashmap with key and a score (0, 1] as value, if a match / similarity was found
      return FIELDS_TO_CHECK.reduce(function(acc, fieldName) {
        if (fieldName) {
          if (businessPartnerANormalizedForCompare[fieldName]) {
            if (businessPartnerANormalizedForCompare[fieldName] == businessPartnerBNormalizedForCompare[fieldName]) {
              // exact matches will be colored as green later
              acc[fieldName] = 1;
            } else if (typeof businessPartnerANormalizedForCompare[fieldName] === 'string' && typeof businessPartnerBNormalizedForCompare[fieldName] === 'string') {
              if(businessPartnerANormalizedForCompare[fieldName].toLowerCase().trim() == businessPartnerBNormalizedForCompare[fieldName].toLowerCase().trim()) {
                // similarity will be colored as green as well
                acc[fieldName] = 1;
              } else if(businessPartnerBNormalizedForCompare[fieldName].trim() !== '' && businessPartnerANormalizedForCompare[fieldName].toLowerCase().indexOf(businessPartnerBNormalizedForCompare[fieldName].toLowerCase()) > -1
                || businessPartnerANormalizedForCompare[fieldName].trim() !== '' && businessPartnerBNormalizedForCompare[fieldName].toLowerCase().indexOf(businessPartnerANormalizedForCompare[fieldName].toLowerCase()) > -1
              ) {
                // similarity will be colored as yellow later
                acc[fieldName] = 0.5;
              }
            }
          }
        }

        return acc;
      }, {});
    }

    // EVENT-HANDLERS
    self.gotoBusinessPartnerDetails = function(targetBusinessPartner) {
      if ((targetBusinessPartner || {}).id) {
        // if the business-partner is not new, then we dont need to ask for confirmation,
        // because its unlikely, that the user will lose data, then switching the view to the targetBusinessPartner
        if ((self.businessPartner || {}).id) {
          return $state.go('arno.contacts.businessPartnerDetails', { id: targetBusinessPartner.id }, { reload: true });
        }

        return baModalService.messageModal({
          modalType: 'info',
          allowHtml: false,
          closable: true,

          title: $translate.instant('modules.contacts.businessPartners.duplicatesComp.confirmLeaveTitle'),
          content: $translate.instant('modules.contacts.businessPartners.duplicatesComp.confirmLeaveMsg', {
            businessPartnerName: targetBusinessPartner.IsInternal ? targetBusinessPartner.OwnerDivision.Name : targetBusinessPartner.Name
          }),

          primaryActionText: $translate.instant('generalTerms.call'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        })
        .then(function() {
          $state.go('arno.contacts.businessPartnerDetails', { id: targetBusinessPartner.id }, { reload: true });
        });
      }
    }

    self.addBusinessPartnerAsLinking = function(businessPartner) {
      if ((businessPartner || {}).id && self.divisionId) {
        return ArnoDashBusinessPartnersService.addBusinessPartnerLinkingForDivisionsWithNotifications(businessPartner, [self.divisionId])
          .then(function() {
            $state.go('arno.contacts.businessPartnerDetails', { id: businessPartner.id }, { reload: true });
          });
      }
    }

    self.notAddedYet = function(businessPartner) {
      if ((businessPartner || {}).id) {
        return !_.find(businessPartner.Divisions, { id: parseInt(self.divisionId) });
      }

      return false;
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }

    // HELPERS
    function getUiPermissions() {
      self.hasDivManagePermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.manage', ['Division']);
      self.hasOrgViewPermission = permissions.isPermittedInOrg('arno.contacts.businessPartners.view', [$rootScope.ctx.organization.current.id])
      self.hasDivViewPermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.view', ['Division']);
    }

    function searchSimilarBusinessPartners(businessPartner) {
      if (businessPartner) {
        ArnoDashBusinessPartnersService.searchSimilarBusinessPartners(businessPartner, self.strictMode).then(function(foundResults) {
          if (foundResults) {
            self.duplicates = foundResults;
          }
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('chooseMemberModalCtrl', chooseMemberModalCtrl);

  function chooseMemberModalCtrl($q, $uibModalInstance, clientApi, organizationId, $translate) {
    var self = this;
    self.organizationId = organizationId;
    self.member = {
      Account: { EMail: null },
      OrganizationId: organizationId,
      newAccount: true,
    };
    self.triedSubmit = false;

    self.gender = [
      { name: $translate.instant('Member.Salutation.mister'), value: 'M' },
      { name: $translate.instant('Member.Salutation.miss'), value: 'F' },
    ];

    self.groupByFirstName = function (member) {
      var groupName;
      if (!member.hint) {
        groupName = member.initials.charAt(0);
      } else {
        groupName = $translate.instant('generalTerms.note');
      }
      return groupName;
    };

    self.checkMail = function (address) {
      return $q(function (resolve, reject) {
        return clientApi
          .custom('model/Account', 'hasMemberByEMail', { eMail: address })
          .then(function (exists) {
            if (exists) {
              return reject('Account already exists');
            }
            return resolve();
          })
          .catch(function (err) {
            return reject(err.message);
          });
      });
    };
    self.areInputsValid = function () {
      return self.member.FirstName && self.member.LastName && self.member.EMail && self.member.Gender;
    };

    self.searchMembers = function (name) {
      self.q = name;
      self.loadMembers();
    };

    self.loadMembers = function () {
      var addHintEntry = function (result) {
        result.push({
          hint: true
        });
        return result
      };
      return clientApi
        .custom('model/Member', 'findByOrganizationId', { searchName: self.q, queryWishes: { withAnyTerms: true, nonOffline: true } })
        .then(function (result) {
          self.members = addHintEntry(result);
        });
    };

    self.applyMemberModal = function () {
      $uibModalInstance.close({
        selectedMember: self.selectedMember,
      });
    };
    self.applyNewAccountModal = function (form) {
      if (form.$invalid) {
        self.triedSubmit = true;
        return;
      }
      $uibModalInstance.close({
        selectedMember: self.member,
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftPositionDetailsMetaCtrl', shiftPositionDetailsMetaCtrl);

  /** @ngInject */
  function shiftPositionDetailsMetaCtrl($scope, clientApi, commonUtils, baModalService, characteristicMap, $translate) {
    var self = this;

    self.shift = $scope.shift || {};
    self.position = { id: commonUtils.uuid(), Qualifications: [], Activities: [] };
    if ($scope.position && $scope.position.id) {
      self.position = $scope.position;
    }
    self.availableShiftMembers = $scope.availableShiftMembers || [];
    self.memberPositionList = $scope.memberPositionList;
    self.parentCtrl = $scope.parentCtrl || { shifts: [] };
    self.shiftDivisions = $scope.shiftDivisions;
    self.checkAttendeesIsLegalAge = $scope.checkAttendeesIsLegalAge;
    self.characteristicMap = characteristicMap;
    self.isTemplate = !!$scope.isTemplate; // is position template; different from parentCtrl.templateMode which is usually shift template administration
    self.templateDivision = $scope.templateDivision || null;
    self.requirementValidityCalc = function (position) {
      return ($scope.requirementValidityCalc || (function () {
      }))(position, ($scope.attendeeRequirementFulfillment || (function () {
      })));
    };
    self.getPositionReqValidPopover = function (qualificationValidList, activityValidList, qualificationIdNameMap, activityIdNameMap) {
      return ($scope.getPositionReqValidPopover || (function () {
      }))(qualificationValidList, activityValidList, qualificationIdNameMap, activityIdNameMap, $scope);
    }

    self.isNew = !($scope.position && $scope.position.id);

    if (self.isNew) {
      self.position.PositionCount = 1;
    }

    self.tagTransform = function (newTitleTag) {
      if (typeof newTitleTag === 'string' && newTitleTag.trim() === '') {
        delete self.position.Function;
        return undefined;
      }

      return newTitleTag;
    };

    self.hasFunctionSet = function () {
      return !!self.position.Function;
    };

    self.localFunctionProposals = _.uniq(
      _.flatten(
        self.parentCtrl.shifts.map(function (shift) {
          return (shift.ServiceFunctions || []).map(function (position) {
            return position.Function;
          });
        })
      )
    );
    self.functionProposals = [];

    self.initialSearchFunction = true;
    self.searchFunction = function (search) {
      if (!search) {
        self.functionProposals = [];
        if (!self.initialSearchFunction) {
          delete self.position.Function;
        }
        self.initialSearchFunction = false;
        return;
      }
      self.position.Function = search;
      return clientApi.custom('model/ServiceFunction', 'searchFunction', {
        search: search,
        divisionId: self.parentCtrl.ctx || self.templateDivision || 'rootOrg'
      }).catch(function () {
        return [];
      }).then(function (results) {
        self.functionProposals = _.uniq(
          self.localFunctionProposals.filter(function (localProposal) {
            return ~localProposal.toLocaleLowerCase().indexOf(search.toLocaleLowerCase());
          }).concat(
            results.map(function (result) {
              return result.Function;
            })
          )
        ).slice(0, 10);
      });
    };

    self.qualificationProposals = [{ none: true }];
    self.searchQualification = function (search) {
      if (!search) {
        self.qualificationProposals = [{ none: true }];
        return;
      }
      return clientApi.custom('model/Qualification', 'searchQualificationsByName', {
        name: search,
        details: true,
        divisionIds: self.parentCtrl.templateMode ? undefined : self.shiftDivisions,
        exclude: (self.position.Qualifications || []).map(function (qualification) {
          return qualification.id;
        })
      }).then(function (results) {
        if (!results.length) {
          throw new Error('No results.');
        }
        self.qualificationProposals = results;
      }).catch(function () {
        self.qualificationProposals = [{ none: true, foundNone: true }];
      })
    };

    self.reqEntityGroupFunc = function (entity) {
      if (entity.none) {
        return '';
      }
      return (((entity || {}).QualificationGroup || {}).Name) || (((entity || {}).ActivityGroup || {}).Title);
    };

    self.qualificationAdd = function (qualification) {
      if (qualification && !qualification.none) {
        // precalculate requirementValidity, check every member if they have the new <qualification>/<activity> - if not, ask if it should really be added
        var previewPosition = {
          Qualifications: self.position.Qualifications.concat([qualification]),
          Activities: self.position.Activities
        };
        var previewQualificationMap = (self.requirementValidityCalc(previewPosition) || {}).qualification || {};
        // self.qualificationMap
        var unqualifiedAttendees = (self.memberPositionList || []).filter(function (member) {
          // true if qualification is not in active qualifications of member
          return !~(((previewQualificationMap[member.MemberId || member.Member.id] || {}).validList || {}).active || []).indexOf(qualification.id);
        }).map(function (member) {
          return member.fullName || member.Member.fullName || $translate.instant('modules.events.shiftTemplate.unknownSubscriber');
        });

        return Promise.resolve().then(function () {
          if (unqualifiedAttendees.length) {
            return baModalService.messageModal({
              modalType: 'warning',
              allowHtml: false,
              title: $translate.instant('modules.events.shiftTemplate.modal.qualificationNotMetTitle'),
              content: $translate.instant('modules.events.shiftTemplate.modal.qualificationNotMetMsg', {
                name: qualification.Name,
                be: unqualifiedAttendees.length > 1 ?
                  $translate.instant('modules.events.shiftTemplate.are') :
                  $translate.instant('modules.events.shiftTemplate.is'),
                attendees: unqualifiedAttendees.join(', ')
              }),
              primaryActionText: $translate.instant('modules.events.shiftTemplate.add'),
              secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
              allowDoubleOpening: true,
            })
          }
        }).then(function () {
          $scope.$evalAsync(function () {
            self.position.Qualifications.push(qualification);
            self.qualificationToAdd = null;
          });
        }).catch(function () {
          // hm k
        })
      }
    };

    self.removeQualification = function (qualification) {
      self.position.Qualifications.splice(self.position.Qualifications.indexOf(qualification), 1);
    };

    self.activityProposals = [{ none: true }];
    self.searchActivity = function (search) {
      if (!search) {
        self.activityProposals = [{ none: true }];
        return;
      }
      return clientApi.custom('model/Activity', 'searchActivitiesByName', {
        name: search,
        details: true,
        divisionIds: self.parentCtrl.templateMode ? undefined : self.shiftDivisions,
        exclude: (self.position.Activities || []).map(function (activity) {
          return activity.id;
        })
      }).then(function (results) {
        if (!results.length) {
          throw new Error('No results.');
        }
        self.activityProposals = results;
      }).catch(function () {
        self.activityProposals = [{ none: true, foundNone: true }];
      })
    };

    self.activityAdd = function (pActivity) {
      if (pActivity && !pActivity.none) {
        return Promise.resolve(pActivity).then(function (activity) {
          return clientApi.custom('model/Activity', 'getActivatedCharacteristicsForActivity', {
            activityId: activity.id
          }).catch(function () {
            return []
          }).then(function (characteristics) {
            return Promise.resolve().then(function () {
              if (characteristics.length > 1) {
                return baModalService.messageModal({
                  modalType: 'info',
                  allowHtml: false,
                  title: $translate.instant('modules.events.shiftTemplate.modal.chooseTaskCaracteristicTitle'),
                  content: $translate.instant('modules.events.shiftTemplate.modal.chooseTaskCaracteristicMsg', {
                    title: activity.Title
                  }),
                  primaryActionText: $translate.instant('modules.events.shiftTemplate.confirm'),
                  secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
                  selectionOptions: characteristics.map(function (characterisitc) {
                    return {
                      label: characteristicMap[characterisitc],
                      characterisitc: characterisitc,
                      defaultSelected: characterisitc === 'DEFAULT',
                    };
                  }),
                }).then(function (chosen) {
                  return chosen.characterisitc;
                })
              }
              return characteristics[0];
            }).then(function (characterisitc) {
              activity.Characteristic = characterisitc;
              return activity;
            });
          })
        }).then(function (activity) {
          // precalculate activityValidity, check every member if they have the new <activity> - if not, ask if quali should really be added
          var previewPosition = {
            Qualifications: self.position.Qualifications,
            Activities: self.position.Activities.concat([activity])
          };
          var previewActivityMap = (self.requirementValidityCalc(previewPosition) || {}).activity || {};
          // self.activityMap
          var unqualifiedAttendees = (self.memberPositionList || []).filter(function (member) {
            // true if activity is not in active activities of member
            return !~(((previewActivityMap[member.MemberId || member.Member.id] || {}).validList || {}).active || []).indexOf(activity.id);
          }).map(function (member) {
            return (member.fullName || member.Member.fullName || $translate.instant('modules.events.shiftTemplate.unknownSubscriber'));
          });

          return Promise.resolve().then(function () {
            if (unqualifiedAttendees.length) {
              return baModalService.messageModal({
                modalType: 'warning',
                allowHtml: false,
                title: $translate.instant('modules.events.shiftTemplate.modal.taskRequirementNotMetTitle'),
                content: $translate.instant('modules.events.shiftTemplate.modal.taskRequirementNotMetMsg', {
                  title: activity.Title,
                  be: unqualifiedAttendees.length > 1 ?
                    $translate.instant('modules.events.shiftTemplate.are') :
                    $translate.instant('modules.events.shiftTemplate.is'),
                  attendees: unqualifiedAttendees.join(', ')
                }),
                primaryActionText: $translate.instant('modules.events.shiftTemplate.add'),
                secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
                allowDoubleOpening: true,
              })
            }
          }).then(function () {
            $scope.$evalAsync(function () {
              self.position.Activities.push(activity);
              self.activityToAdd = null;
            });
          }).catch(function () {
            // hm k
          });
        });
      }
    };

    self.removeActivity = function (activity) {
      self.position.Activities.splice(self.position.Activities.indexOf(activity), 1);
    };

    self.shiftMemberFilter = function (searchTerm) {
      return function (member) {
        return ~(member.fullName || member.Member.fullName || '').toLocaleLowerCase().indexOf((searchTerm || '').toLocaleLowerCase());
      }
    };

    self.shiftMemberAdd = function (shiftMember) {
      return Promise.resolve().then(function () {
        var isLegalAge = self.checkAttendeesIsLegalAge[shiftMember.MemberId || shiftMember.Member.id];

        if (!isLegalAge) {
          return baModalService.messageModal({
            modalType: 'warning',
            allowHtml: false,
            title: $translate.instant('modules.events.shiftTemplate.modal.minorityTitle'),
            content: $translate.instant('modules.events.shiftTemplate.modal.minorityMsg', {
              name: shiftMember.fullName || shiftMember.Member.fullName,
              maybe: isLegalAge === false ?
                $translate.instant('modules.events.shiftTemplate.is') :
                $translate.instant('modules.events.shiftTemplate.isMaybe'),
            }),
            primaryActionText: $translate.instant('modules.events.shiftTemplate.assign'),
            secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
          })
        }
      }).then(function () {
        if (
          (
            self.qualificationMap &&
            (
              (((self.qualificationMap[shiftMember.MemberId || shiftMember.Member.id] || {}).validList || {}).inactive || []).length
              || (((self.qualificationMap[shiftMember.MemberId || shiftMember.Member.id] || {}).validList || {}).missing || []).length
            )
          ) || (
            self.activityMap &&
            (
              (((self.activityMap[shiftMember.MemberId || shiftMember.Member.id] || {}).validList || {}).inactive || []).length
              || (((self.activityMap[shiftMember.MemberId || shiftMember.Member.id] || {}).validList || {}).missing || []).length
            )
          )
        ) {
          return baModalService.messageModal({
            modalType: 'warning',
            allowHtml: false,
            title: $translate.instant('modules.events.shiftTemplate.modal.requirementNotMetTitle'),
            content: $translate.instant('modules.events.shiftTemplate.modal.requirementNotMetMsg', {
              name: shiftMember.fullName || shiftMember.Member.fullName
            }),
            primaryActionText: $translate.instant('modules.events.shiftTemplate.assign'),
            secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
            allowDoubleOpening: true,
          })
        }
      }).then(function () {
        $scope.$evalAsync(function () {
          self.memberPositionList.push(shiftMember);
          self.shiftMemberToAdd = null;
        });
      }).catch(function () {
        // hm k
      })
    };

    self.removeMemberPosition = function (shiftMember) {
      self.memberPositionList.splice(self.memberPositionList.indexOf(shiftMember), 1);
    };

    self.refreshAttendeeChoices = function () {
      // force a rerender, because group by function is not triggered reliable
      self.attendeeChoices = [];
      $scope.$evalAsync(function () {
        self.attendeeChoices = self.availableShiftMembers.filter(function (attendee) {
          return !_.find(self.memberPositionList, { MemberId: attendee.MemberId });
        });
      });
    };

    $scope.$watch(function () {
      return self.memberPositionList;
    }, function () {
      self.refreshAttendeeChoices();
      self.combinedValidStateCalc();
    }, true);

    self.qualificationMap = null;
    self.activityMap = null;
    self.positionRequirementWatcher = function (newVal, oldVal) {
      self.showRequirementValidity = !self.parentCtrl.templateMode && ((self.position.Qualifications || []).length || (self.position.Activities || []).length);
      // ARNO-2005 allow recalc of qualifications if last qualification was removed
      if (!self.parentCtrl.templateMode && (
        ((self.position.Qualifications || []).length || (oldVal || []).length)
        || ((self.position.Activities || []).length || (oldVal || []).length)
      )) {
        self.qualificationHelperMap = {};
        (self.position.Qualifications || []).forEach(function (qualification) {
          self.qualificationHelperMap[qualification.id] = qualification;
        });
        self.activityHelperMap = {};
        (self.position.Activities || []).forEach(function (activity) {
          self.activityHelperMap[activity.id] = activity;
        });
        var requirementsValidity = self.requirementValidityCalc(self.position) || {};
        self.qualificationMap = requirementsValidity.qualification;
        self.activityMap = requirementsValidity.activity;
        self.combinedValidStateCalc();
        self.refreshAttendeeChoices();
      }
    };
    $scope.$watch(function () {
      return self.position.Qualifications;
    }, self.positionRequirementWatcher, true);
    $scope.$watch(function () {
      return self.position.Activities;
    }, self.positionRequirementWatcher, true);

    self.attendeeChoiceSortBase = function (attendee) {
      return attendee.fullName || attendee.Member.fullName || '';
    };
    self.attendeeChoiceSortGroup = function (attendee) {
      if (!self.showRequirementValidity) {
        return;
      }
      var memberId = (attendee || {}).MemberId || 0;
      return [
        ((self.qualificationMap || {})[memberId] || {}).validState,
        ((self.activityMap || {})[memberId] || {}).validState
      ].reduce(function (score, validState) {
        return score + ({
          true: 1,
          false: 2,
          null: 3,
          undefined: 4,
        }[validState]);
      }, 0);
    };

    self.combinedValidStateCalc = function () {
      self.combinedValidStateMap = ($scope.combinedValidStateCalc || (function () {
      }))(
        self.memberPositionList,
        self.qualificationMap,
        self.activityMap
      );
    };

    self.groupByRequirementValidity = function (attendee) {
      if (!self.showRequirementValidity) {
        return;
      }
      return {
        null: $translate.instant('modules.events.shiftTemplate.requirementNotMet'),
        false: $translate.instant('modules.events.shiftTemplate.requirementMetNotCompletely'),
        true: $translate.instant('modules.events.shiftTemplate.requirementMet'),
        undefined: ''
      }[self.combinedValidStateMap[(attendee || {}).MemberId || 0]];
    };

    self.submit = function () {
      if ($scope.submit) {
        $scope.submit({
          position: self.position,
          memberPositionList: self.memberPositionList
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('shiftPositionDetails', shiftPositionDetails);

  /** @ngInject */
  function shiftPositionDetails() {
    return {
      restrict: 'AE',
      replace: 'true',
      templateUrl: 'app/theme/components/shiftTemplate/helper/shiftPositionDetails.html',
      scope: {
        shift: '=?',
        position: '=?',
        availableShiftMembers: '=?',
        memberPositionList: '=?',
        parentCtrl: '=?',
        attendeeRequirementFulfillment: '=?',
        requirementValidityCalc: '=?',
        combinedValidStateCalc: '=?',
        getPositionReqValidPopover: '=?',
        checkAttendeesIsLegalAge: '=?',
        shiftDivisions: '=?',
        submit: '=?',
        isTemplate: '=?',
        templateDivision: '=?',
      },
      controller: 'shiftPositionDetailsMetaCtrl as self',
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftPositionDetailsCtrl', shiftPositionDetailsCtrl);

  /** @ngInject */
  function shiftPositionDetailsCtrl($scope, $uibModalInstance,
    position, parentCtrl, availableShiftMembers, memberPositionList, shift, shiftDivisions, checkAttendeesIsLegalAge,
    attendeeRequirementFulfillment, requirementValidityCalc, combinedValidStateCalc, getPositionReqValidPopover) {
    var self = this;

    self.position = position;
    self.parentCtrl = parentCtrl;
    self.availableShiftMembers = availableShiftMembers;
    self.memberPositionList = memberPositionList;
    self.shift = shift;
    self.shiftDivisions = shiftDivisions;
    self.checkAttendeesIsLegalAge = checkAttendeesIsLegalAge;
    self.attendeeRequirementFulfillment = attendeeRequirementFulfillment;
    self.requirementValidityCalc = requirementValidityCalc;
    self.combinedValidStateCalc = combinedValidStateCalc;
    self.getPositionReqValidPopover = getPositionReqValidPopover;

    self.isNew = !position;

    self.triggerSubmit = function() {
      setTimeout(function() {
        document.querySelector('form#shiftPositionDetailsForm button[type="submit"]').click();
      }, 0);
    };

    self.submit = function (data) {
      $uibModalInstance.close(data);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftMetaDetailsCtrl', shiftMetaDetailsCtrl);

  /** @ngInject */
  function shiftMetaDetailsCtrl($scope, $uibModalInstance, shift, parentCtrl, toastr, commonUtils, $translate) {
    var self = this;

    self.isNew = !shift;
    self.shift = shift || { id: commonUtils.uuid(), ServiceFunctions: [] };
    self.parentCtrl = parentCtrl;
    self.templateMode = parentCtrl.options.templateMode;
    self.templateShiftTimespan = !self.templateMode || !!(self.shift.StartDate && self.shift.EndDate);

    if (self.isNew || (self.templateMode && !self.shift.StartDate && !self.shift.EndDate)) {
      if (self.templateMode) {
        self.shift.StartDate = moment(0).startOf('day').add(8, 'hours').toDate();
        self.shift.EndDate = moment(0).startOf('day').add(9, 'hours').toDate();
      } else {
        // prefill new shifts with event timespan
        self.shift.StartDate = moment(self.parentCtrl.options.template.EventStartDate).toDate();
        self.shift.EndDate = moment(self.parentCtrl.options.template.EventEndDate).toDate();
      }
      self.startDateOffsetDays = 0;
      self.endDateOffsetDays = 0;
    } else {
      self.shift.StartDate = moment(self.shift.StartDate).toDate();
      self.shift.EndDate = moment(self.shift.EndDate).toDate();
      var startRef = moment(0).toDate();
      self.startDateOffsetDays = self.parentCtrl.getDateOffset(startRef, self.shift.StartDate);
      self.endDateOffsetDays = self.parentCtrl.getDateOffset(self.shift.StartDate, self.shift.EndDate);
    }

    if (!self.templateMode) {
      self.dynShiftShareAvailable = (self.parentCtrl.options.template.ServiceShares || [])
        .filter(function (serviceShare) {
          return serviceShare.IsShared && !serviceShare.IsGlobal && serviceShare.state !== 'REMOVED';
        })
        .map(function (serviceShare) {
          return {
            id: serviceShare.id,
            Name: serviceShare.Division.Name
          }
        });
      self.dynShiftShareChosen = [];
      (self.shift.ServiceShareShifts || []).forEach(function (serviceShareShift) {
        var found = _.find(self.dynShiftShareAvailable, { id: serviceShareShift.ServiceShareId });
        if (found && !_.find(self.dynShiftShareChosen, { id: found.id })) {
          self.dynShiftShareChosen.push(found);
        }
      });

      // check if a share was removed, and thus cant be chosen anymore
      self.dynShiftShareChosen.forEach(function (chosen) {
        var found = _.find(self.dynShiftShareAvailable, { id: chosen.id });
        if (!found) {
          self.dynShiftShareChosen.splice(self.dynShiftShareChosen.indexOf(chosen), 1);
        }
      });

      $scope.$watch(function () {
        return self.dynShiftShareChosen;
      }, function () {
        self.shift.ServiceShareShifts = self.dynShiftShareChosen.map(function (chosenServiceShare) {
          return { ServiceShareId: chosenServiceShare.id };
        });
      }, true);
    }

    self.applyDateOffset = function (date, offsetDays) {
      return moment(date).add(offsetDays, 'days').toDate();
    };

    $scope.$watch(function () {
      return self.startDateOffsetDays;
    }, function (newVal, oldVal) {
      // we have to break the preexisting date reference for uib-timepicker to pick up changes made to the date via setDate or otherwise
      self.shift.StartDate = self.applyDateOffset(self.shift.StartDate, newVal - oldVal);
      self.shift.EndDate = self.applyDateOffset(self.shift.EndDate, newVal - oldVal);
    });

    $scope.$watch(function () {
      return self.endDateOffsetDays;
    }, function (newVal, oldVal) {
      self.shift.EndDate = self.applyDateOffset(self.shift.EndDate, newVal - oldVal);
    });

    if (!self.isNew) {
      ['StartDate', 'EndDate', 'MeetingTime'].forEach(function (prop) {
        if (self.shift[prop]) {
          // prop has a date associated with it; initialize that date
          self.shift[prop] = moment(self.shift[prop]).toDate();
        }
      })
    }

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4
      }
    };

    self.isValidDate = function () {
      if (!self.templateShiftTimespan) {
        return true;
      }
      return !(!self.shift.StartDate || !self.shift.EndDate || (moment(self.shift.StartDate).diff(moment(self.shift.EndDate)) >= -1));
    };

    if (!self.templateMode) {
      $scope.$watch(function () {
        return self.shift.StartDate;
      }, function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        if (moment(self.shift.StartDate).diff(moment(self.shift.EndDate)) >= -1) {
          var previousDiff = moment(self.shift.EndDate).diff(moment(oldVal));
          if (previousDiff > -1) {
            self.shift.EndDate = moment(self.shift.StartDate).add(moment.duration(previousDiff)).toDate();
            toastr.preventDuplicate(function () {
              toastr.info(
                $translate.instant('modules.events.shiftTemplate.modals.toastr.changedShiftEndMsg'),
                $translate.instant('modules.events.shiftTemplate.modals.toastr.changedShiftEndTitle')
              );
            });
          }
        }
      });
    }

    self.abs = function (x) {
      return Math.abs(x);
    };

    self.applyModal = function () {
      if (!self.templateShiftTimespan) {
        self.shift.StartDate = null;
        self.shift.EndDate = null;
      }
      $uibModalInstance.close(self.shift);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftImportTemplateCtrl', shiftImportTemplateCtrl);

  /** @ngInject */
  function shiftImportTemplateCtrl($scope, $uibModalInstance, parentCtrl, positionMode, parentLabel,
    clientApi, availableServiceTypes, eventCategories, $translate) {
    var self = this;
    self.parentCtrl = parentCtrl;
    self.positionMode = positionMode;
    self.parentLabel = parentLabel;
    self.searchView = true;
    self.chosen = [];
    self.templateMode = parentCtrl.options.templateMode;

    self.availableServiceTypes = [{
      none: true,
      Name: $translate.instant('modules.events.shiftTemplate.modals.allEventTypes'),
    }].concat(availableServiceTypes);
    self.searchServiceType = self.availableServiceTypes[0];
    if (self.parentCtrl.options.template && self.parentCtrl.options.template.ServiceTypeId) {
      self.searchServiceType = _.find(self.availableServiceTypes, { id: self.parentCtrl.options.template.ServiceTypeId }) || self.availableServiceTypes[0];
    }

    self.availableServiceCategories = eventCategories;
    self.searchServiceCategories = [];
    if (self.parentCtrl.options.template && self.parentCtrl.options.template.BaseCategories) {
      self.searchServiceCategories = self.parentCtrl.options.template.BaseCategories.map(function (bc) {
        return _.find(self.availableServiceCategories, { id: bc.id });
      }).filter(function (sc) {
        return sc;
      });
    }

    self.tabsConfig = [
      {
        ident: 'serviceTemplate',
        heading: $translate.instant('modules.events.shiftTemplate.modals.modal.serviceTemplateTitle'),
        description: $translate.instant('modules.events.shiftTemplate.modals.modal.serviceTemplateMsg'),
      },
      {
        ident: 'serviceLive',
        heading: $translate.instant('modules.events.shiftTemplate.modals.modal.createdServicesTitle'),
        description: $translate.instant('modules.events.shiftTemplate.modals.modal.createdServicesMsg'),
      },
    ];

    if (self.positionMode) {
      self.tabsConfig.splice(0, 0, {
        ident: 'positionTemplate',
        heading: $translate.instant('modules.events.shiftTemplate.modals.modal.positionTemplatesTitle'),
        description: $translate.instant('modules.events.shiftTemplate.modals.modal.positionTemplatesTitle'),
      });
    }

    self.searchMode = 'serviceTemplate';
    $scope.$watch(function () {
      return self.searchMode;
    }, function (newVal, oldVal) {
      self.templateTree = null;
      if (newVal !== oldVal) {
        self.search();
      }
    });

    self.setActiveTab = function (ident) {
      self.searchMode = ident;
    };

    self.showSearchView = function () {
      self.searchView = true;
    };

    self.treeOptions = {
      core: {
        multiple: true,
        check_callback: true,
        themes: {
          responsive: false
        },
        dblclick_toggle: false
      },
      types: {
        template: {
          icon: 'fa fa-file-text'
        },
        shift: {
          icon: 'fa fa-hashtag'
        },
        position: {
          icon: 'fa fa-user'
        },
        'position-info': {
          icon: 'fa fa-info'
        }
      },
      checkbox: {
        keep_selected_style: false,
        three_state: true,
        whole_node: true
      },
      search: {
        show_only_matches: true,
        show_only_matches_children: true
      },
      plugins: ['types', 'checkbox', 'search'],
      version: 1
    };

    self.getCheckedTemplateResults = function (onlyCheckedCount) {
      if (!self.templateTree) {
        return 0;
      }

      var jsTreeChecked = self.templateTree.jstree('get_checked', false);
      var jsTreeUndetermined = self.templateTree.jstree('get_undetermined', false);
      if (!Array.isArray(jsTreeChecked) || !Array.isArray(jsTreeUndetermined)) {
        return 0;
      }

      var checked = _.uniq(jsTreeChecked.concat(jsTreeUndetermined));

      if (onlyCheckedCount) {
        return checked.length;
      }

      if (self.searchMode === 'positionTemplate') {
        return self.templateResults
          .filter(function (template) {
            return ~checked.indexOf(template.id);
          })
          .map(function (template) {
            self.updateTreeIdHelper(template);
            delete template.type;
            delete template.text;
            delete template.state;
            return {
              ServiceShifts: [{
                ServiceFunctions: [template]
              }]
            };
          });
      }

      return self.templateResults.filter(function (template) {
        if (!~checked.indexOf(template.id)) {
          return false;
        }
        delete template.type;
        delete template.text;
        delete template.state;
        self.updateTreeIdHelper(template);
        delete template.children;
        template.ServiceShifts = (template.ServiceShifts || [])
          .filter(function (serviceShift) {
            if (!~checked.indexOf(serviceShift.id)) {
              return false;
            }
            delete serviceShift.type;
            delete serviceShift.text;
            delete serviceShift.state;
            self.updateTreeIdHelper(serviceShift);
            delete serviceShift.children;

            // if live service is the template | apply onto template | live service
            if (Object.prototype.hasOwnProperty.call(template, 'Subject')) {
              // live services can be detected by checking existence of Subject field (rather than Label which is set for templates)

              // live service dates need to get shifted to template base (Date(0)) or live service base (eventStartDate)
              // measure distance between date(0) (base for templates) and service EventStartDate (base for live services)
              ['StartDate', 'EndDate'].forEach(function (dateProperty) {
                var distance = moment.duration(moment(serviceShift[dateProperty]).startOf('minute').diff(moment(template.EventStartDate).startOf('day')));
                serviceShift[dateProperty] = moment(self.templateMode ? 0 : self.parentCtrl.options.template.EventStartDate)
                  .startOf('day')
                  .add(distance)
                  //.add(self.templateMode ? moment(0).utcOffset() - moment().utcOffset() : 0, 'minutes') // timezones - AAAAAAAAAAAAAAAAAAAAAAAAAAA
                  .toISOString();
              });
            } else if (!self.templateMode) { // if template is the template :-) - but only when applying to live services
              ['StartDate', 'EndDate'].forEach(function (dateProperty) {
                if (!serviceShift[dateProperty]) {
                  serviceShift[dateProperty] = moment(self.parentCtrl.options.template['Event' + dateProperty])
                    .toISOString();
                } else {
                  var distance = moment.duration(moment(serviceShift[dateProperty]).startOf('minute').diff(moment(0).startOf('day')));
                  serviceShift[dateProperty] = moment(self.parentCtrl.options.template.EventStartDate)
                    .startOf('day')
                    .add(distance)
                    // .add(moment().utcOffset() - moment(0).utcOffset(), 'minutes') // timezones - AAAAAAAAAAAAAAAAAAAAAAAAAAA
                    .toISOString();
                }
              });
            } // else template is the template, applied to template - so templates with base date(0) all around... no date shifting needed

            serviceShift.ServiceFunctions = (serviceShift.ServiceFunctions || []).filter(function (position) {
              if (!~checked.indexOf(position.id)) {
                return false;
              }
              delete position.type;
              delete position.text;
              self.updateTreeIdHelper(position);
              return true;
            });
            return true;
          });
        return true;
      });
    };

    self.updateTreeIdHelper = function (entity) {
      // when we apply a template to a live service, we need to recreate the entities for the live service
      // ... rather then trying to update the template entities
      if (typeof entity.id === 'number') {
        entity.id = entity.id + '-' + entity.type;
      } else {
        entity.id = parseInt(entity.id.split('-')[0], 10);
        if (self.searchMode === 'positionTemplate') {
          entity.ReferenceServiceFunctionId = entity.id;
        }
        if (!self.templateMode) {
          delete entity.id;
        }
      }
      entity.a_attr = entity.Description ? { title: entity.Description } : undefined;
    };

    self.search = function () {
      self.searchInProgress = true;
      var searchOpts = {
        searchTerm: self.searchTerm,
        liveServiceSearch: self.searchMode === 'serviceLive',
      };

      if (!self.searchServiceType.none) {
        searchOpts.serviceTypeId = self.searchServiceType.id;
      }

      if (self.searchServiceCategories.length) {
        searchOpts.baseCategoryIds = self.searchServiceCategories.map(function (bc) {
          return bc.id;
        });
      }

      var targetModel = self.searchMode === 'positionTemplate' ? 'model/ServicePositionTemplate' : 'model/ServiceTemplate';

      self.templateResults = [];
      return clientApi
        .custom(targetModel, 'searchTemplate', searchOpts)
        .catch(function () {
          return [];
        })
        .then(function (results) {
          self.searchView = false;
          $scope.$evalAsync(function () {
            self.searchInProgress = false;
            if (!results.length) {
              self.templateResults = [];
            }
            if (self.searchMode === 'positionTemplate') {
              results = results.map(function (position) {
                var description = position.Description;
                position = position.ServiceFunction;
                position.type = 'position';
                position.Description = description;
                if (description) {
                  position.type = 'position-info';
                }
                position.text = position.Function;
                self.updateTreeIdHelper(position);
                return position;
              });
            } else {
              results.forEach(function (template) {
                template.type = 'template';
                template.text = template.Label || template.Subject;
                template.state = { opened: true, disabled: self.positionMode };
                self.updateTreeIdHelper(template);
                template.children = template.ServiceShifts || [];
                template.children
                  .forEach(function (serviceShift) {
                    serviceShift.type = 'shift';
                    serviceShift.text = serviceShift.Subject;
                    if (self.positionMode) {
                      serviceShift.state = { opened: true };
                    }
                    self.updateTreeIdHelper(serviceShift);
                    serviceShift.children = serviceShift.ServiceFunctions || [];
                    serviceShift.children
                      .forEach(function (position) {
                        position.type = 'position';
                        position.text = position.Function + ' (' + position.PositionCount + ')' + (position.ReferenceServiceFunctionId ?
                          $translate.instant('modules.events.shiftTemplate.modals.adminTemplate') :
                          '');
                        self.updateTreeIdHelper(position);
                      });
                  });
              });
            }
            self.templateResults = results;
            self.possibleResultCutoff = self.templateResults.length === 30;
            // self.treeOptions.version++;
          });
        });
    };

    self.resetAllInput = function () {
      self.searchTerm = '';
      self.searchServiceType = self.availableServiceTypes[0];
      self.searchServiceCategories = [];
    };

    self.applyModal = function () {
      $uibModalInstance.close(self.getCheckedTemplateResults());
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('MemberQualificationModalCtrl', MemberQualificationModalCtrl);

  /** @ngInject */
  function MemberQualificationModalCtrl($scope, $uibModalInstance, qualification, flatQualificationHierarchy, instructingPerson,
    type, availableMaterials, onFileDownload, onFilePreview, member, divisionIds, $translate) {
    var self = this;
    self.qualification = qualification;
    self.editMode = !!self.qualification;
    self.flatQualificationHierarchy = flatQualificationHierarchy;
    self.memberExclude = member ? [member.id] : [];
    self.divisionIds = divisionIds;

    self.translateValues = type === 'qualification' ? {
      typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
      typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups'),
      name: self.qualification ? self.qualification.Name : ''
    } : {
      typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
      typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups'),
      name: self.qualification ? self.qualification.Name : ''
    }
    self.type = type;
    self.availableMaterials = availableMaterials;

    self.missingInstructingPerson = false; // required message

    self.selectedPersonFieldType = getPersonTypeValue();
    self.fileUploadUrl = '/api/files/cacheFile?divisionId=' + (self.divisionIds && self.divisionIds.length > 0 && self.divisionIds[0]);
    self.unallowedFileTypes = [
      'exe',
      'com',
      'bat',
      'cmd',
      'vbs',
      'vbe',
      'js',
      'jse',
      'ws',
      'wsf',
      'wsc',
      'wsh',
      'ps1',
      'ps1xml',
      'ps2',
      'ps2xml',
      'psc1',
      'psc2',
      'msh',
      'msh1',
      'msh2',
      'mshxml',
      'msh1xml',
      'msh2xml',
      'scf',
      'lnk',
      'inf',
      'reg',
      'dll',
      'cpl',
      'ocx',
      'ax',
      'sys',
    ];

    function getPersonTypeValue() {
      if (!self.qualification) {
        return 'member';
      }

      if (self.qualification.InstructingMemberId) {
        return 'member';
      } else if (self.qualification.InstructingContactId) {
        return 'contact';
      } else if (self.qualification.InstructingBusinessPartnerId) {
        return 'organisation';
      }

      return 'member';
    }

    self.qualificationAdd = function (qualificationToAdd) {
      if (qualificationToAdd) {
        self.qualification = _.cloneDeep(qualificationToAdd);
      }
      if (self.qualification) {
        // fix qualificationName
        self.qualification.Name = self.qualification.Name || self.qualification.QualificationName;

        self.validityPeriodHelperActivated = true;

        if (self.qualification.AcquireDate) {
          self.qualification.AcquireDate = moment(self.qualification.AcquireDate).toDate();
        }
        if (self.qualification.ExpireDate) {
          self.qualification.ExpireDate = moment(self.qualification.ExpireDate).toDate();
        }

        if (!self.qualification.InstructingMember) {
          if (instructingPerson && instructingPerson.type === 'member') {
            self.qualification.InstructingMember = instructingPerson.value;
          } else {
            self.qualification.InstructingMember = null;
          }
        }

        if (!self.qualification.InstructingContact) {
          if (instructingPerson && instructingPerson.type === 'contact') {
            self.qualification.InstructingContact = instructingPerson.value;
          } else {
            self.qualification.InstructingContact = undefined;
          }
        }

        if (!self.qualification.InstructingBusinessPartner) {
          if (instructingPerson && instructingPerson.type === 'organisation') {
            self.qualification.InstructingBusinessPartner = instructingPerson.value;
          } else {
            self.qualification.InstructingBusinessPartner = undefined;
          }
        }

        if (!self.qualification.InstructionMaterial) {
          self.qualification.InstructionMaterial = undefined;

          var keyTypeMapping = {
            'InstructionMaterialMedicineId': 'MaterialMedicine',
            'InstructionMaterialVehicleId': 'MaterialVehicles',
            'InstructionMaterialClothingId': 'MaterialClothing',
            'InstructionMaterialToolId': 'MaterialTools',
            'InstructionMaterialOtherId': 'MaterialOthers',
            'InstructionMaterialConsumableId': 'MaterialConsumables',
            'InstructionMaterialMedicalProductId': 'MaterialMedicalProducts',
          }

          Object.keys(keyTypeMapping).forEach(function (key) {
            if (self.qualification[key]) {
              var foundMaterial = availableMaterials.find(function (material) {
                return material.id === self.qualification[key] && material.isMaterialType === keyTypeMapping[key];
              })
              if (foundMaterial) {
                self.qualification.InstructionMaterial = foundMaterial;
              }
            }
          })
        }

        if (!self.qualification.InitialInstructionByManufacturerOrAuthorizedPerson) {
          self.qualification.InitialInstructionByManufacturerOrAuthorizedPerson = false;
        }

        self.qualification.ForeignQualificationAccepted = self.qualification.ForeignQualificationAccepted || false;
      } else {
        self.qualification = {};
      }
    };
    self.qualificationAdd();

    $scope.$watch(function () {
      return self.selectedPersonFieldType
    }, function (newVal, oldVal) {
      // reset values from other pickers
      if (newVal !== oldVal && oldVal) {

        switch (newVal) {
        case 'member':
          self.qualification.InstructingContact = undefined;
          self.qualification.InstructingBusinessPartner = undefined;
          break;
        case 'contact':
          self.qualification.InstructingMember = undefined;
          self.qualification.InstructingBusinessPartner = undefined;
          break;
        case 'organisation':
          self.qualification.InstructingMember = undefined;
          self.qualification.InstructingContact = undefined;
          break;
        }
      }
    })

    $scope.$watch(function () {
      return self.qualification.AcquireDate
    }, function (newVal, oldVal) {
      if (newVal !== oldVal
        && self.validityPeriodHelperActivated
        && self.qualification.AcquireDate
        && (self.ExpireDateViaValidityPeriodHelper || !self.qualification.ExpireDate)
        && (self.qualification.ValidityPeriodDays || self.qualification.ValidityPeriodMonths || self.qualification.ValidityPeriodYears)) {
        self.qualification.ExpireDate = moment(self.qualification.AcquireDate)
          .add(self.qualification.ValidityPeriodDays || 0, 'days')
          .add(self.qualification.ValidityPeriodMonths || 0, 'months')
          .add(self.qualification.ValidityPeriodYears || 0, 'years')
          .toDate();
        self.ExpireDateViaValidityPeriodHelper = true;
        self.ignoreNextExpireDateChange = true;
      } else {
        self.ExpireDateViaValidityPeriodHelper = false;
      }
      if (self.qualification.AcquireDate && self.expireDatepicker) {
        self.expireDatepicker.options.minDate = moment(self.qualification.AcquireDate)
          .add(1, 'days')
          .toDate();
      }
    }, false);

    $scope.$watch(function () {
      return self.qualification.ExpireDate
    }, function () {
      if (self.ignoreNextExpireDateChange) {
        self.ignoreNextExpireDateChange = false;
        return;
      }
      self.ExpireDateViaValidityPeriodHelper = false;
    }, false);

    $scope.$watch(function () {
      return self.qualification.ForeignQualificationAccepted
    }, function () {
      if (self.qualification && Object.keys(self.qualification).length && !self.qualification.ForeignQualificationAccepted) {
        self.qualification.ForeignQualificationRemark = '';
      }
    }, false);

    $scope.$watch(function () {
      return self.qualification
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.qualification.InstructionMaterial = oldVal.InstructionMaterial;
      }
    }, false);

    self.instructingMemberSelected = function (selection) {
      self.qualification.InstructingMember = selection
      self.qualification.InstructingMemberId = selection.MemberId
    }
    self.instructingContactSelected = function (selection) {
      self.qualification.InstructingContact = selection
      self.qualification.InstructingContactId = selection.id
    }
    self.instructingOrganisationSelected = function (selection) {
      self.qualification.InstructingBusinessPartner = selection
      self.qualification.InstructingBusinessPartnerId = selection.id
    }

    self.acquireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      }
    };

    self.expireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      }
    };

    self.checkForValidExpireDate = function () {
      if (self.qualification.ExpireDate && self.qualification.AcquireDate && self.qualification.ExpireDate <= self.qualification.AcquireDate) {
        return false;
      }
      return true;
    };

    self.onFileUploaded = function (data) {
      self.qualification.fileCacheKey = data.fileCacheKey;
      self.qualification.FileName = data.fileItem && data.fileItem.file.name;
    }

    self.onFileDownload = function () {
      onFileDownload ? onFileDownload(self.qualification) : null;
    }

    self.onFilePreview = function () {
      onFilePreview ? onFilePreview(self.qualification) : null;
    }

    self.onFileDelete = function (revert) {
      if (revert) {
        // revert
        self.qualification.File = self.qualification.fileDelete;
        self.qualification.fileDelete = null;
        self.fileChanged = false;
      } else {
        // delete
        self.qualification.fileDelete = self.qualification.File;
        self.qualification.File = null;
        self.fileChanged = true;
      }
    }

    function clearInstructingPersons() {
      // when editing we want to make sure that there is still only one "person" selected
      // otherwise old Ids might remain

      switch (self.selectedPersonFieldType) {
      case 'member':
        self.qualification.InstructingContactId = null;
        self.qualification.InstructingBusinessPartnerId = null;
        break;
      case 'contact':
        self.qualification.InstructingMemberId = null;
        self.qualification.InstructingBusinessPartnerId = null;
        break;
      case 'organisation':
        self.qualification.InstructingMemberId = null;
        self.qualification.InstructingContactId = null;
        break;
      }
    }

    self.applyModal = function () {
      if (type === 'instruction') {
        clearInstructingPersons();
      }

      self.validityPeriodHelperActivated = false;
      $uibModalInstance.close(self.qualification);
    };
  }
})();


(function(){
  'use strict';

  angular
		.module('BlurAdmin.theme.components')
		.controller('pageTopModalCtrl', pageTopModalCtrl);

  function pageTopModalCtrl($uibModalInstance, organizationId, agbinfo, toastr, $translate) {

    var self = this;
    self.agbText = agbinfo.TextContent;

    self.applyModal = function () {
      $uibModalInstance.close({
        accepted: true,
      });
    };
    self.dismissModal = function () {
      toastr.error($translate.instant('components.pageTop.termsForcedAccept'), $translate.instant('components.pageTop.declineTermsOfUse'));
      $uibModalInstance.close({
        accepted: false,
      });
    };


  }
})();

(function () {
  'use strict';
  angular
    .module('BlurAdmin.theme.components')
    .controller('sendMailToMembersCtrl', sendMailToMembersCtrl);
  /** @ngInject */
  function sendMailToMembersCtrl($scope, $uibModalInstance, memberInfos, toastr, $translate) {
    var self = this;
    self.memberInfos = memberInfos
      .filter(function (member) {
        return member.EMail
      });
    self.missingMemberInfos = memberInfos
      .filter(function (member) {
        return !member.EMail
      });
    self.missingMemberNames = self.missingMemberInfos
      .map(function (member) {
        return member.fullName;
      })
      .join(', ');
    self.noMembers = !self.memberInfos.length;
    self.applyModal = function (delimiter, clipboard) {
      var mailAddresses = self.memberInfos
        .map(function (member) {
          return member.EMail;
        })
        .join(delimiter || ' ');

      if (clipboard) {
        Promise.resolve()
          .then(function() {
            if(!navigator.clipboard || !navigator.clipboard.writeText) {
              throw new Error('Not supported.');
            }
            return navigator.clipboard.writeText(mailAddresses);
          })
          .then(function() {
            toastr.success(
              $translate.instant('components.modals.mailModal.successToastText'),
              $translate.instant('components.modals.mailModal.successToastTitle')
            );
          })
          .catch(function() {
            toastr.error(
              $translate.instant('components.modals.mailModal.errToastText'),
              $translate.instant('components.modals.mailModal.errToastTitle')
            );
          });
      } else {
        window.open('mailto:?bcc=' + mailAddresses);
      }

      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material', [
      'BlurAdmin.pages.material.overview',
      'BlurAdmin.pages.material.statistics',
      'BlurAdmin.pages.material.demand',
    ])
    .config(routeConfig);

  var commonResolve = function (divisionId, clientApi, materialUtil, permissions, model) {
    var isPermittedForTab = permissions.isPermittedInSome('arno.virtual.item.' + _.lowerFirst(model) + '.edit,arno.material.view', 'Division', divisionId);
    if (divisionId.length && isPermittedForTab) {
      return clientApi
        .custom('model/' + model, 'getColumns', {
          divisionId: divisionId,
        })
        .then(function (availableFields) {
          return clientApi
            .custom('model/CustomListView', 'getUserTableConfigs', {
              listType: 'materialList' + model,
              divisionId: divisionId
            })
            .then(function (customTableConfigs) {
              return {
                tableConfigAvailableFields: availableFields,
                tableConfigDefault: _.transform(materialUtil.materialDefaultTableConfig[model], function (result, prop) {
                  result[prop] = true;
                }, {}),
                tableConfigCustomPreference: customTableConfigs
              };
            });
        });
    }
    return null;
  };

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.material', {
        url: '/material',
        title: 'navigation.material',
        abstract: true,
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        sidebarMeta: {
          order: 3,
          icon: 'fa fa-cube'
        },
      })
      .state('arno.material.overview', {
        abstract: true,
        url: '/overview',
        title: 'navigation.material.overview',
        template: '<tabs data="$tabsetCtrl.materialTabs" template-url="app/pages/material/tabset/tabset.html"></tabs>',
        controller: 'MaterialTabCtrl as $tabsetCtrl',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              // eslint-disable-next-line max-len
              entryPermission: 'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.view',
            });
          },
        },
        sidebarMeta: {
          stateRedirect: 'arno.material.overview.medicine',
          order: 4,
        },
        stateClick: function (ev, originState, $rootScope) {
          if (originState.startsWith('arno.material.overview')) {
            ev.preventDefault();
            ev.stopPropagation();
            try {
              $rootScope.addMaterialModalInstance.dismiss();
            } catch (e) {
              // hmm k™
            }
          }
        }
      })
      .state('arno.material.demand', {
        url: '/demandForAction',
        title: 'navigation.material.demand',
        templateUrl: 'app/pages/material/demandForAction/materialDemandForAction.html',
        viewPermission: 'arno.material.view',
        controller: 'MaterialDemandCtrl as $demandCtrl',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.material.view',
            });
          }
        },
        sidebarMeta: {
          order: 5,
        },
      })
      .state('arno.material.statistics', {
        url: '/statistics',
        title: 'navigation.material.statistics',
        templateUrl: 'app/pages/material/statistics/statistics.html',
        viewPermission: 'arno.material.view',
        controller: 'MaterialStatisticsCtrl as $matStatCtrl',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.material.view',
            });
          }
        },
        sidebarMeta: {
          order: 6,
        },
      })
      .state('arno.material.overview.medicine', {
        url: '/medicine/:materialId',
        title: 'navigation.material.overview.medicine',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialMedicine');
          }
        }
      })
      .state('arno.material.overview.vehicles', {
        url: '/vehicles/:materialId',
        title: 'navigation.material.overview.vehicles',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialVehicles');
          }
        }
      })
      .state('arno.material.overview.clothing', {
        url: '/clothing/:materialId',
        title: 'navigation.material.overview.clothing',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialClothing');
          },
        }
      })
      .state('arno.material.overview.tools', {
        url: '/tools/:materialId',
        title: 'navigation.material.overview.tools',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: [
          'arno.virtual.item.materialMedicine.edit',
          'arno.virtual.item.materialClothing.edit',
          'arno.virtual.item.materialOthers.edit',
          'arno.virtual.item.materialConsumables.edit',
          'arno.virtual.item.materialTools.edit',
          'arno.virtual.item.materialVehicles.edit',
          'arno.virtual.item.materialMedicalProducts.edit',
          'arno.material.view'
        ],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialTools');
          }
        }
      })
      .state('arno.material.overview.consumables', {
        url: '/consumables/:materialId',
        title: 'navigation.material.overview.consumables',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: ['arno.virtual.item.material.edit', 'arno.material.view'],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialConsumables');
          }
        }
      })
      .state('arno.material.overview.medicalProducts', {
        url: '/medicalProducts/:materialId',
        title: 'navigation.material.overview.medicalProducts',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: ['arno.virtual.item.material.edit', 'arno.material.view'],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialMedicalProducts');
          }
        }
      })
      .state('arno.material.overview.other', {
        url: '/other/:materialId',
        title: 'navigation.material.overview.other',
        templateUrl: 'app/pages/material/overview/materialOverview.html',
        controller: 'MaterialOverviewCtrl as $matCtrl',
        viewPermission: ['arno.virtual.item.material.edit', 'arno.material.view'],
        params: {
          materialId: null,
          tab: 0,
        },
        resolve: {
          tableConfig: function (clientApi, commonUtils, divisionId, materialUtil, permissions) {
            return commonResolve(divisionId, clientApi, materialUtil, permissions, 'MaterialOthers');
          },
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material')
    .controller('addMaterialInspectionCtrl', addMaterialInspectionCtrl);

  function addMaterialInspectionCtrl(ctx, $scope, $uibModalInstance, excludedIds, selectedInspection, meta, materialMode, disableMandatoryChange, viewOnly, maxInterval, $translate) {
    var self = this;
    self.divisionId = ctx;
    self.isEdit = !!selectedInspection;
    self.excludedIds = excludedIds;
    self.materialMode = materialMode;
    self.maxInterval = maxInterval;
    self.disableMandatoryChange = disableMandatoryChange;
    self.selectedInspection = selectedInspection || null;
    self.viewOnly = viewOnly;
    self.fddAutoSet = false;
    self.initialFdd;
    self.inspectionToAdd = {
      meta: JSON.parse(JSON.stringify(meta || {})),
    };
    self.isInheritedInterval = false;
    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
        minDate: new Date(),
      }
    };

    $scope.$watch(function() {
      return self.selectedInspection;
    }, function(newVal) {
      if (newVal && newVal.PeriodicInspection && !meta) {
        self.inspectionToAdd.meta = {};
        if (!newVal.RecommendedInterval) {
          self.inspectionToAdd.meta.Interval = null;
          self.isInheritedInterval = false;
        } else if (!meta) {
          self.inspectionToAdd.meta.Interval = newVal.RecommendedInterval;
          self.isInheritedInterval = true;
        }
        if (self.materialMode && !self.isEdit) {
          self.inspectionToAdd.meta.FirstDueDate = new Date(moment().add(self.inspectionToAdd.meta.Interval, 'days').toISOString());
          self.initialFdd = self.inspectionToAdd.meta.FirstDueDate;
          self.fddAutoSet = true;
        }

        if (self.selectedInspection.Description) {
          self.inspectionToAdd.meta.Description = self.selectedInspection.Description;
          self.autoSetDesc = true;
        }
      } else if (self.materialMode && !self.isEdit) {
        // we dont really do any magic here aside setting todays date so let's not show the magic wand
        self.inspectionToAdd.meta.FirstDueDate = new Date();
      }

      if (!self.isEdit) {
        self.inspectionToAdd.meta.Mandatory = true; // slider is set to true by default, change may be locked further by disableMandatoryChange
      }

      if(newVal && newVal.PeriodicInspection && !self.materialMode) {
        self.disableMandatoryChange = true;
      } 

    }, true)

    $scope.$watch(function() {
      return self.inspectionToAdd.meta.Interval;
    }, function(newVal) {
      if (newVal !== (self.selectedInspection && self.selectedInspection.RecommendedInterval)) {
        self.isInheritedInterval = false;
      }
    }, true)

    $scope.$watch(function() {
      return self.inspectionToAdd.meta.FirstDueDate;
    }, function(newVal) {
      if (!newVal || !self.initialFdd || newVal.toISOString() !== self.initialFdd.toISOString()) {
        self.fddAutoSet = false;
      }
    }, true)

    $scope.$watch(function() {
      return (self.inspectionToAdd.meta.Mandatory || {}).toString()
        + ((self.selectedInspection || {}).PeriodicInspection || {}).toString();
    }, function() {
      self.firstDueDateRequired = (self.selectedInspection || {}).PeriodicInspection === true
                                  || !!self.inspectionToAdd.meta.Mandatory;
    });

    $scope.$watch(function() {
      return self.inspectionToAdd.meta.Description;
    }, function(newVal) {
      if (self.selectedInspection && newVal !== self.selectedInspection.Description) {
        self.autoSetDesc = false;
      }
    }, true)

    self.validateInterval = function(value)  {
      if (!self.selectedInspection.PeriodicInspection || !self.selectedInspection.MaximumInterval) {
        // 3490 non recurring can now have an interval
        // this interval isn't bound by anything
        // 3561 max interval can now be NULL
        return true;
      }
      if (self.maxInterval && value > self.maxInterval) {
        self.inspectionToAdd.meta.Interval = self.maxInterval;
      } else if (value > self.selectedInspection.MaximumInterval) {
        self.inspectionToAdd.meta.Interval = self.selectedInspection.MaximumInterval
      }
    }

    self.applyModal = function() {
      self.inspectionToAdd.meta.Mandatory = !!self.inspectionToAdd.meta.Mandatory;
      self.inspectionToAdd.inspection = self.selectedInspection;
      $uibModalInstance.close(self.inspectionToAdd);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('BlurAdmin.theme.components')
    .controller('helperHoursTransferModalCtrl', helperHoursTransferModalCtrl);
  /** @ngInject */
  function helperHoursTransferModalCtrl($scope, $uibModalInstance, dataSource, commonUtils, toastr, helperHoursService, $translate) {
    var self = this;

    self.BaseCategories = dataSource.BaseCategories;
    self.groupedHelperHours = dataSource.groupedHelperHours;

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    self.accordionTrack = {};
    self.step = 0;

    self.leftPad = function(string, padVal) {
     
      if(String(string).length > 2)
     {
        padVal = '000';
      }
      return String(padVal + string).slice(-padVal.length);
    };

    self.groupedHelperHours.forEach(function(group) {
      self.accordionTrack[group.id] = {};
      group.initialTitle = group.Title;
      group.helperHours.forEach(function(helperHours) {
        helperHours.id = commonUtils.uuid();
        helperHours.parentId = helperHours.id;
        helperHours.Activities = helperHours.Activities || [];
        helperHours.Activities.push({ none: true });
        helperHours.Activity = helperHours.Activities[0];
        helperHours.date = moment(group.StartDate).toDate();
        helperHours.dateEnd = moment(group.EndDate).toDate();
        helperHours.dateStartTime = moment(group.StartDate).toDate();
        helperHours.dateEndTime = moment(group.EndDate).toDate();
        helperHours.hours = helperHours.hours || 0;
        helperHours.minutes = helperHours.minutes || 0;
      });
    });

    self.group = self.groupedHelperHours[0];
    self.someSelected = {};

    $scope.$watch(function() {
      return self.groupedHelperHours;
    }, function() {
      var memberIds = [];
      var minutes = 0;
      self.groupedHelperHours.map(function(group) {
        group.helperHours.forEach(function(helperHour) {
          if (!helperHour.active || (!helperHour.hours && !helperHour.minutes)) {
            return;
          }
          memberIds.push(helperHour.Member.id);
          minutes = minutes + (helperHour.hours * 60) + helperHour.minutes;
        });
        self.someSelected[group.id] = !!group.helperHours
          .filter(function (h) {
            return h.active;
          }).length;
      });
      self.combinedHours = Math.floor(minutes / 60);
      self.combinedMinutes = minutes % 60;
      self.combinedHelpers = _.uniq(memberIds).length;
    }, true);

    self.allSelect = function(groupId) {
      var group = _.find(self.groupedHelperHours, {id: groupId});
      var active = !self.someSelected[groupId];
      if (group) {
        group.helperHours.forEach(function(helperHour) {
          helperHour.active = active;
        });
      }
    };

    self.searchOpenAccordion = function() {
      var found;
      Object
        .keys(self.accordionTrack)
        .forEach(function (gid) {
          Object
            .keys(self.accordionTrack[gid])
            .forEach(function(hhid) {
              if (self.accordionTrack[gid][hhid]) {
                found = _.find((_.find(self.groupedHelperHours, { id: parseInt(gid, 10) }) || {}).helperHours, { id: hhid });
              }
            })
        });
      return found;
    };

    self.closeAllOpenAccordion = function() {
      Object
        .keys(self.accordionTrack)
        .forEach(function (gid) {
          Object
            .keys(self.accordionTrack[gid])
            .forEach(function(hhid) {
              self.accordionTrack[gid][hhid] = false;
            })
        });
    };

    self.accordionClick = function($event, groupId, helperHoursId) {
      if ($event && $event.target && $event.target.classList.contains('no-propagation')) {
        return;
      }
      var found = self.searchOpenAccordion();
      if (found && !self.isHelperHourValid(found)) {
        return;
      }
      self.accordionTrack[groupId][helperHoursId] = !self.accordionTrack[groupId][helperHoursId];
    }

    self.isHelperHourValid = function(helperHour) {
      var isValid = helperHour && helperHoursService.isValidDate(helperHour) && (helperHour.hours || helperHour.minutes);
      if (!isValid) {
        toastr.warning($translate.instant('modules.helperHours.hours.pleaseFillAllDutyFieldsOut'), $translate.instant('modules.helperHours.hours.dataLineIsIncorrect'));
      }
      var isWithinTimeframe = helperHoursService.isValidDuration(helperHour);
      if (!isWithinTimeframe) {
        toastr.warning($translate.instant('modules.helperHours.hours.volunteerHoursDontExceed'), $translate.instant('modules.helperHours.hours.dataLineIsIncorrect'));
      }
      return isValid && isWithinTimeframe;
    }

    self.duplicate = function(groupId, helperHoursId) {
      var group = _.find(self.groupedHelperHours, {id: groupId}) || {};
      var helperHour = _.find(group.helperHours || [], {id: helperHoursId});
      if (helperHour && self.isHelperHourValid(helperHour)) {
        var duplicate = JSON.parse(JSON.stringify(helperHour));
        duplicate.id = commonUtils.uuid();
        duplicate.active = true;
        duplicate.date = moment(helperHour.date).toDate();
        duplicate.dateEnd = moment(helperHour.dateEnd).toDate();
        duplicate.dateStartTime = moment(helperHour.dateStartTime).toDate();
        duplicate.dateEndTime = moment(helperHour.dateEndTime).toDate();
        duplicate.hours = 0;
        duplicate.minutes = 0;
        var otherChosenActivities = _
          .filter(group.helperHours, {parentId: duplicate.parentId})
          .map(function(helperHour) {
            return helperHour.Activity.id;
          });
        otherChosenActivities = _.uniq(_.compact(otherChosenActivities))
          .map(function (id) {
            return { id: id };
          });
        duplicate.Activity = _.differenceBy(duplicate.Activities, otherChosenActivities, 'id')[0];
        group.helperHours.splice(group.helperHours.indexOf(helperHour) + 1, 0, duplicate);

        //self.accordionTrack[groupId][helperHoursId] = false;
        self.accordionTrack[groupId][duplicate.id] = true;
      }
    }

    self.remove = function(groupId, helperHoursId) {
      var group = _.find(self.groupedHelperHours, {id: groupId}) || {};
      var helperHour = _.find(group.helperHours || [], {id: helperHoursId});
      if (helperHour) {
        self.accordionTrack[groupId][helperHour.parentId] = true;
        delete self.accordionTrack[groupId][helperHour.id];
        group.helperHours.splice(group.helperHours.indexOf(helperHour), 1);
      }
    }

    $scope.$watch(function() {
      return self.step;
    }, function(newVal, oldVal) {
      self.group = self.groupedHelperHours[self.step];
      if (newVal !== oldVal) {
        $('body.modal-open .modal').scrollTop(0);
      }
    });

    self.prevNextSave = function(next) {
      var found = self.searchOpenAccordion();
      if (found && !self.isHelperHourValid(found)) {
        return;
      }

      if (!self.groupedHelperHours[self.step].Title) {
        toastr.warning($translate.instant('modules.helperHours.hours.giveAValidateTitle'), $translate.instant('modules.helperHours.hours.titleIsMissing'));
        return;
      }

      if (!next) {
        self.step = self.step - 1
        self.acceptTransferCheckbox = false;
      } else if ((self.step + 1) === self.groupedHelperHours.length) {
        self.applyModal();
      } else {
        self.step = self.step + 1;
      }

      self.closeAllOpenAccordion();
    };

    self.applyModal = function () {
      self.groupedHelperHours.forEach(function(group) {
        group.helperHours.forEach(function(helperHours) {
          helperHours.date = moment(helperHours.date).dateOnly().toISOString();
          helperHours.dateEnd = moment(helperHours.dateEnd).dateOnly().toISOString();
          helperHours.dateStartTime = moment(helperHours.dateStartTime).startOf($translate.instant('modules.helperHours.hours.minute')).toDate();
          helperHours.dateEndTime = moment(helperHours.dateEndTime).startOf($translate.instant('modules.helperHours.hours.minute')).toDate();
        });
      });
      $uibModalInstance.close(self.groupedHelperHours);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('baExportModalController', baExportModalController);

  function baExportModalController($uibModalInstance, modalData, exportPrivacyNoteContent) {
    var $ctrl = this;

    $ctrl.modalData = modalData;

    $ctrl.selectItems = [
      {label: 'XLSX (Excel)', value: 'xlsx'},
      {label: 'CSV (Komma-separiert)', value: 'csv'},
    ];
    $ctrl.selected = $ctrl.selectItems[0];
    $ctrl.fieldOption = 'tableConfig';
    $ctrl.filterOption = 'filtered';

    $ctrl.exportPrivacyNoteContent = new showdown.Converter().makeHtml(exportPrivacyNoteContent.TextContent);

    $ctrl.applyModal = function() {
      $uibModalInstance.close({
        options: {
          fields: $ctrl.fieldOption,
          filter: $ctrl.filterOption,
        },
        filetyp: $ctrl.selected.value,
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('CopyDivisionModalCtrl', CopyDivisionModalCtrl);

  function CopyDivisionModalCtrl($scope, $uibModalInstance, baseDivisionId, divisionTree,
    baModalService, $translate, toastr) {
    var self = this;

    self.division = baseDivisionId;
    self.divisionList = divisionTree
      .filter(function (div) {
        return parseInt(div.id, 10) !== parseInt(self.division, 10);
      })
      .filter(function (div) {
        return !div.disabled;
      });

    self.divisionHierarchy = {};
    divisionTree.forEach(function (division) {
      var parentId = parseInt(division.ParentDivisionId, 10) || null;
      var divisionId = parseInt(division.id, 10);
      self.divisionHierarchy[parentId] = self.divisionHierarchy[parentId] || [];
      self.divisionHierarchy[parentId].push(divisionId);
    });

    self.copyDivision = function () {
      return $uibModalInstance.close(
        self.divisionList.filter(function (division) {
          return division.state;
        })
      );
    };

    self.warnModalCopyCountExceeded = function () {
      return baModalService.messageModal({
        modalType: 'warning',
        allowHtml: true,
        title: $translate.instant('components.modals.copyDivision.warnModalTitle'),
        content: $translate.instant('components.modals.copyDivision.warnModalContent'),
        primaryActionText: $translate.instant('generalTerms.resume'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
    };

    self.selectAllDivisions = function (collection) {
      return Promise.resolve()
        .then(function () {
          if (!self.allSelectionMode && collection && collection.length > 100) {
            return self.warnModalCopyCountExceeded();
          }
        })
        .then(function () {
          $scope.$evalAsync(function () {
            if (collection && collection.length) {
              collection.forEach(function (item) {
                item.state = !self.allSelectionMode;
              });
            }
            self.allSelectionMode = !self.allSelectionMode;
          })
        })
        .catch(function () {

        });
    };

    self.childDivisionIds = [];
    var mappedDivisionList = _.map(self.divisionList, 'id').map(function(n) {
      return parseInt(n, 10);
    });
    self.addChildDivisionIds = function (startDivisionId) {
      if (self.divisionHierarchy[startDivisionId]) {
        self.childDivisionIds = self.childDivisionIds.concat(
          _.intersection(self.divisionHierarchy[startDivisionId], mappedDivisionList)
        );
        self.divisionHierarchy[startDivisionId].forEach(function (childDivisionId) {
          self.addChildDivisionIds(childDivisionId);
        });
      }
    };
    self.addChildDivisionIds(parseInt(self.division, 10));

    self.selectChildDivisions = function () {
      return Promise.resolve()
        .then(function () {
          if (self.childDivisionIds && self.childDivisionIds.length > 100) {
            return self.warnModalCopyCountExceeded();
          }
        })
        .then(function () {
          $scope.$evalAsync(function () {
            self.divisionList.forEach(function (division) {
              if (~self.childDivisionIds.indexOf(parseInt(division.id, 10))) {
                division.state = true;
              }
            });
            var multiple = self.childDivisionIds.length > 1;
            toastr.info(
              $translate.instant('components.modals.copyDivision.divSelectToastText', { multiple: multiple, divisionIdLength: self.childDivisionIds.length }),
              $translate.instant('components.modals.copyDivision.divSelectToastTitle', { multiple: multiple })
            );
          });
        })
        .catch(function () {

        });
    };

  }
})();

(function () {
  'use strict';
  /**
   * The Module file is the rootPoint for the Personnel inviteAdd logic
   * @class module:App.Personnel.inviteAdd
   */
  angular
    .module('BlurAdmin.pages.personnel.inviteAdd', ['angularFileUpload'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.inviteAdd', {
        url: '/addInvite',
        templateUrl: 'app/pages/personnel/inviteAdd/inviteAdd.html',
        title: 'navigation.personnel.inviteAdd',
        controller: 'InviteAddCtrl as $inviteAddCtrl',
        resolve: {
          personnelOrgSelection: function ($rootScope, permissions) {
            return permissions.isPermittedInEvery('arno.personnel.inviteList.manage', 'Organization', [$rootScope.ctx.organization.current.id]);
          },
          authInfo: function ($rootScope, clientApi) {
            return clientApi.custom('model/Organization', 'getAuthInfo', {});
          },
          inviteCtx: function (commonUtils, personnelOrgSelection) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: personnelOrgSelection,
              entryPermission: 'arno.personnel.inviteList.manage'
            });
          },
          orgType: function(clientApi) {
            return clientApi.custom('model/Organization', 'getOrgType'); 
          }
        },
        viewPermission: 'arno.personnel.inviteList.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteAdd')
    .controller('ContactPrivacyModalCtrl', ContactPrivacyModalCtrl);

  /** @ngInject */
  function ContactPrivacyModalCtrl($scope, $translate, toastr, $uibModalInstance, data, privacyTermDate) {
    var self = this;
    self.contact = data.contact;
    self.demandForAction = data.demandForAction || false;
    self.privacyTermDateDisplay = moment(privacyTermDate).format('DD.MM.YYYY - HH:mm');
    self.privacyTermDate = privacyTermDate;    

    self.contact.PrivacyTermsDeliveredDateTime = moment().toDate();
    
    self.close = function () {
      $uibModalInstance.close(false);
    };

    self.add = function (form) {
      if(form.$valid) {
        $uibModalInstance.close(self.contact);
      }
    }
  }
})();

(function () {
  'use strict';
  /* global marked */

  angular
    .module('BlurAdmin.pages.personnel.dossier.fileStorage', [])
    .controller('PersonnelDossierFileStorageCtrl', PersonnelDossierFileStorageCtrl);

  function PersonnelDossierFileStorageCtrl(infoboxText, ctx, isOwnDossier, dossierOwner, folderData) {
    var self = this;
    self.ctx = ctx;
    self.isOwnDossier = isOwnDossier;
    self.dossierOwner = dossierOwner;
    self.folderData = folderData;
    self.infoboxTextContent = marked(infoboxText.Content ? infoboxText.Content : '');
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.fileStorage')
    .controller('uploadModalCtrl', uploadModalCtrl);

  /** @ngInject */
  function uploadModalCtrl($uibModalInstance, $translate, uploader, node, calcFileSize, $scope, parentCtrl) {
    var self = this;

    parentCtrl.uibModalInstance = $uibModalInstance;

    self.calcFileSize = calcFileSize;
    self.node = node;
    self.uploader = uploader;
    self.unfinished = uploader.queue.length;
    self.stateMapping = {
      'isReady': $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.stateIsReady'),
      'isUploading': $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.stateIsUploading'),
      'isUploaded': $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.stateIsUploaded'),
      'isError': $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.stateIsError'),
      'isCancel': $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.stateIsCancel')
    }

    self.uploadAll = function() {
      parentCtrl.closeOnFinish = true;
      self.uploader.queue.forEach(function(file) {
        if (!file.isUploading && !file.isUploaded) {
          file.upload();
        }
      })
    }

    // self.removeAll = function() {
    //   var len = self.fileList.length - 1;
    //   for (var i = len; i >= 0; i--) {
    //     self.fileList[i].remove();
    //   }
    // }

    self.getState = function(file) {
      var keys = Object.keys(file);
      var state = '';
      keys.forEach(function(key) {
        if (file[key] && self.stateMapping[key]) {
          state = self.stateMapping[key];
        }
      })
      if (state) {
        return state;
      }
      return self.stateMapping.isReady;
    }

    self.getCloseButtonText = function() {
      if (self.unfinished) {
        return $translate.instant('modules.personnel.dossier.fileStorage.uploadModal.discardFiles', { number : self.unfinished });
      }
      return $translate.instant('generalTerms.close');
    }

    $scope.$watch(function() {
      return self.uploader.queue.length;
    }, function() {
      checkForUnfinished();
    })

    var checkForUnfinished = function() {
      var unfinished = 0;
      self.uploader.queue.forEach(function(item) {
        if (!item.isError && !item.isUploading && !item.isUploaded && !item.isSuccess) {
          unfinished++;
        }
      })
      self.unfinished = unfinished;
    }
    parentCtrl.checkForUnfinished = checkForUnfinished;
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftMaterialBookingPeriodCtrl', shiftMaterialBookingPeriodCtrl);

  /** @ngInject */
  function shiftMaterialBookingPeriodCtrl($scope, $uibModalInstance, shift, $translate, baModalService, commonUtils, toastr, hasManagePerm) {
    // interpolation in conjunction with uib-datepicker will throw angular AST / $setValidate errors on initial render for uib-datepicker fields
    var self = this;

    self.shift = shift;
    self.hasManagePerm = hasManagePerm;
    self.bookingPeriods = _.cloneDeep(self.shift.BookingMaterialTimes);
    self.bookingPeriods.forEach(function(bookingPeriod) {
      ['StartDate', 'EndDate'].forEach(function(prop) {
        bookingPeriod[prop] = moment(bookingPeriod[prop]).toDate();
      });
    });

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    self.add = function() {
      self.bookingPeriods.push({
        id: commonUtils.uuid(),
        StartDate: moment(shift.StartDate).toDate(),
        EndDate: moment(shift.EndDate).toDate(),
      });
    };

    self.remove = function(bookingPeriod) {
      if (!bookingPeriod || bookingPeriod.IsDefaultPeriod) {
        return;
      }
      if (!bookingPeriod.Title) {
        self.execRemove(bookingPeriod);
        return;
      }
      return baModalService
        .messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: $translate.instant('modules.events.shiftTemplate.modals.removeBookingPeriodTitle'),
          content: $translate.instant('modules.events.shiftTemplate.modals.removeBookingPeriodContent', { title: bookingPeriod.Title }),
          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        })
        .then(function () {
          self.execRemove(bookingPeriod);
        })
    };

    self.execRemove = function(bookingPeriod) {
      self.bookingPeriods.splice(self.bookingPeriods.indexOf(bookingPeriod), 1);
    }

    self.isValidDate = function($index) {
      var startDate = (self.bookingPeriods[$index] || {}).StartDate;
      var endDate = (self.bookingPeriods[$index] || {}).EndDate;
      if (!startDate || !endDate) {
        // required check will catch this one, return as valid
        return true;
      }
      return !(moment(startDate).diff(moment(endDate)) >= -1);
    };

    $scope.$watch(function () {
      return (self.bookingPeriods || [])
        .map(function (bp) {
          return moment(bp.StartDate).toISOString();
        })
        .join(';');
    }, function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      self.bookingPeriods
        .forEach(function(bp, bpIndex) {
          if (moment(bp.StartDate).diff(moment(bp.EndDate)) >= -1) {
            try {
              var prevVal = oldVal.split(';')[bpIndex];
              var previousDiff = moment(bp.EndDate).diff(moment(prevVal));
              if (previousDiff > -1) {
                bp.EndDate = moment(bp.StartDate).add(moment.duration(previousDiff)).toDate();
                toastr.preventDuplicate(function () {
                  toastr.info(
                    $translate.instant('modules.events.shiftTemplate.modals.toastr.changedBPEndMsg'),
                    $translate.instant('modules.events.shiftTemplate.modals.toastr.changedBPEndTitle')
                  );
                });
              }
            } catch (e) {
              // hm k
            }
          }
        });
    }, true);

    self.applyModal = function () {
      self.shift.BookingMaterialTimes.splice(0, self.shift.BookingMaterialTimes.length);
      Array.prototype.push.apply(self.shift.BookingMaterialTimes, self.bookingPeriods);
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftImportQuotationCtrl', shiftImportQuotationCtrl);

  /** @ngInject */
  function shiftImportQuotationCtrl($scope, $uibModalInstance, parentCtrl, parentLabel, quotationBase, materialKey, materialUtil,
    isMaterialTypeImport) {
    var self = this;
    self.parentCtrl = parentCtrl;
    self.parentLabel = parentLabel;
    self.quotationBase = quotationBase;
    self.materialKey = materialKey;
    self.isMaterialTypeImport = isMaterialTypeImport;

    self.priceItemType = 'SERVICE_POSITION';
    if (self.materialKey) {
      self.priceItemType = self.isMaterialTypeImport ? 'MATERIAL_TYPE' : 'MATERIAL';
    }

    self.positions = _
      .filter(
        self.quotationBase.positions || [],
        { AdditionalMetaJson: { PriceItemType: self.priceItemType } }
      )
      .filter(function (position) {
        return position.AdditionalMetaJson.PriceItemId
               && (!self.materialKey || ('Material' + position.AdditionalMetaJson.PriceItemSubType) === self.materialKey);
      });

    self.positionInUseStatusMap = {};
    $scope.$watch(function () {
      return self.parentCtrl.shifts;
    }, function (shifts) {
      self.positionInUseStatusMap = {};
      shifts.forEach(function (shift) {
        if (!self.materialKey) {
          (shift.ServiceFunctions || []).forEach(function (serviceFunction) {
            self.positionInUseStatusMap[serviceFunction.ReferenceServiceFunctionId] = true;
          });
          return;
        }
        if (!self.isMaterialTypeImport) {
          (shift['ServiceShift' + (materialUtil.materialPluralizationMap[self.materialKey] || self.materialKey)] || [])
            .forEach(function (material) {
              self.positionInUseStatusMap[self.materialKey + material.id] = true;
            });
          return;
        }
        (shift['ServiceShift' + (materialUtil.materialPluralizationMap[self.materialKey] || self.materialKey)] || [])
          .forEach(function (material) {
            self.positionInUseStatusMap[self.materialKey + material.MaterialTypeId] = true;
          });
      });
    }, true);

    self.applyPosition = function (position) {
      $uibModalInstance.close(position);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('shiftAddMaterialCtrl', shiftAddMaterialCtrl);

  /** @ngInject */
  function shiftAddMaterialCtrl($scope, $uibModalInstance, materialUtil, currentMaterial, divisionIds, clientApi,
    tableConfig, sharedTblState, materialColumns, associatedMaterials, materialModelName, ctxName, additionalTblQuery, bookingMaterialTimeDefault,
    baseType, ArnoDashMaterialsService) {
    var self = this;

    self.ctxName = ctxName;
    self.applyFieldConfig = materialUtil.applyFieldConfig;
    self.propTypes = materialUtil.propTypes;
    self.currentMaterial = currentMaterial;
    self.currentPropSet = self.propTypes[self.currentMaterial];
    self.matData = [];
    self.isMultiDiv = divisionIds.length > 1;
    self.itemsPerPage = 10;
    self.materialModelName = materialModelName;

    self.tableConfig = tableConfig;
    self.sharedTblState = sharedTblState;
    self.materialColumns = materialColumns;
    self.initialAssociatedMaterials = _.clone(associatedMaterials || []);
    self.associatedMaterials = associatedMaterials || [];
    self.bookingMaterialTimeDefault = bookingMaterialTimeDefault;

    self.baseType = baseType;

    self.additionalTblQuery = additionalTblQuery;

    self.parseDate = function (date) {
      return materialUtil.parseDate(date, { Aggregations: (self.sharedTblState.agg && self.sharedTblState.agg.length ? { agg: true } : false) });
    };

    self.boolFormatter = materialUtil.boolFormatter;
    self.checkAggExcludes = materialUtil.checkAggregateExcludes;

    self.searchableCheck = function (header) {
      return materialUtil.searchableCheck(self.currentPropSet, header);
    };

    self.isIn = function (arr, content) {
      return !!(arr && ~arr.indexOf(content));
    };

    self.diff = function (arr, arr2) {
      return _.difference(arr, arr2).length;
    };

    self.setMaterialView = function (view) {
      if (self.tableCtrl) {
        var tableState = self.tableCtrl.tableState();
        tableState.search = {};
        self.sharedTblState.sf = {};
        tableState.sort = {};

        self.sharedTblState.agg = view.Aggregations || [];
        self.sharedTblState.view = view;

        Object.keys(view.Sort || {}).forEach(function (sortKey) {
          self.tableCtrl.sortBy(view.Sort[sortKey].sortProp, !(view.Sort[sortKey].direction === 'asc'));
        });

        self.tableCtrl.pipe();
      }
    };

    self.toggleMaterialAggregate = function ($event, prop) {
      if ($event) {
        $event.stopPropagation();
      }

      if (self.tableCtrl) {
        self.sharedTblState.agg = self.sharedTblState.agg || [];

        var found = self.sharedTblState.agg.indexOf(prop);
        if (~found) {
          self.sharedTblState.agg.splice(found, 1);
        } else {
          self.sharedTblState.agg.push(prop);
        }

        self.tableCtrl.pipe();
      }
    };

    self.isInitCall = true;
    self.reloadMaterial = function (stParams, $ctrl) {
      if (!self.tableCtrl) {
        self.tableCtrl = $ctrl;
        _.assign(self.tableCtrl.tableState(), self.sharedTblState.tableState); // we overwrite the table state with our parent tbl state
        stParams.pagination.number = self.itemsPerPage;
      }
      var queryWishes = {
        aggregateIds: true
      };

      if (self.additionalTblQuery && Object.keys(self.additionalTblQuery).length) {
        queryWishes.where = self.additionalTblQuery;
      }

      queryWishes.aggregations = _.uniq(_.concat(self.sharedTblState.agg, Object.keys(self.additionalTblQuery || {})));
      queryWishes.visibleNonAgg = _.concat(_.difference(self.sharedTblState.view.Fields, self.sharedTblState.agg), ['Amount']);

      if (stParams) {
        if (stParams.search && stParams.search.predicateObject) {
          materialUtil.handleSTSearchParams(stParams, queryWishes, self.currentPropSet);
        }
        if (stParams.sort) {
          queryWishes.sort = {
            by: stParams.sort.predicate,
            reverse: stParams.sort.reverse
          }
        }
        if (stParams.pagination) {
          queryWishes.paging = {
            offset: (stParams.pagination.start / stParams.pagination.number) * self.itemsPerPage || 0,
            limit: self.itemsPerPage
          };
        }
      }

      return clientApi
        .custom('model/' + self.currentMaterial, 'getMaterial', {
          divisionId: divisionIds,
          queryWishes: queryWishes
        })
        .then(function (res) {
          $scope.$evalAsync(function () {
            self.matData.splice(0, self.matData.length);
            Array.prototype.push.apply(self.matData, res.count && res.rows);
            if (Array.isArray(res.count)) {
              res.count = res.count.length;
            }
            if (stParams && stParams.pagination) {
              stParams.pagination.numberOfPages = Math.ceil(res.count / self.itemsPerPage);
              if (res.count > 0 && res.rows.length === 0) {
                stParams.pagination.start = (stParams.pagination.numberOfPages * self.itemsPerPage) - self.itemsPerPage;
              }
            }

            (self.matData || [])
              .forEach(function (material) {
                if (material && material.id) {
                  material.id = material.id
                    .toString()
                    .split(',')
                    .map(function (materialId) {
                      return parseInt(materialId.trim(), 10);
                    });
                }
              });
            if (self.isInitCall) {
              // angular.element('#modal-shift-add-material-table-rows').animate({ height: 'toggle', opacity: 'toggle' }, 300);
              self.isInitCall = false;
            }
          })
        })
    };

    self.materialInFetch = [];
    self.materialInFetchIds = [];
    self.fetchMaterial = function (material) {
      var toFetch = _.difference(material.id, self.initialAssociatedMaterials, self.materialInFetchIds);
      self.materialInFetch.push(
        clientApi
          .custom('model/Service', 'getServiceMaterial', {
            materialRef: self.currentMaterial,
            materialIds: toFetch,
            divisionId: divisionIds,
          }, { backgroundRequest: true })
          .catch(function () {
            return [];
          })
      );
      self.materialInFetchIds = _.union(self.materialInFetchIds, toFetch);
    };

    self.linkMaterial = function (material, unlink) {
      self.associatedMaterials = _[unlink ? 'difference' : 'union'](self.associatedMaterials, material.id);
      if (!unlink) {
        self.fetchMaterial(material);
      }
    };

    self.applyModal = function () {
      return Promise
        .all(self.materialInFetch)
        .then(function (materialChunks) {
          var neededIds = _.difference(self.associatedMaterials, self.initialAssociatedMaterials);
          return _
            .flatten(materialChunks)
            .filter(function (material) {
              return ~neededIds.indexOf(material.id);
            })
            .map(function (material) {
              material.MaxCount = material.Amount || 1;
              material.Count = 1;
              if (self.bookingMaterialTimeDefault) {
                material.BookingMaterialTimeId = self.bookingMaterialTimeDefault.id;
              }
              return material;
            })
        })
        .then(function (addedMaterials) {
          $uibModalInstance.close({
            addedMaterials: addedMaterials,
            removedMaterialIds: _.difference(self.initialAssociatedMaterials, self.associatedMaterials),
          });
        });
    };

    self.openMaterialDossier = function(materialId) {
      return ArnoDashMaterialsService.openAddModal(
        { id: materialId[0] },
        'update',
        false,
        divisionIds,
        self.currentMaterial
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('materialHierarchyCtrl', materialHierarchyCtrl);

  /** @ngInject */
  function materialHierarchyCtrl($scope, $uibModalInstance, hierarchy, bookingMaterialUtilizationBaseRef, bookingMaterialTimeId, active, storageIconMap) {
    var self = this;

    self.bookingMaterialUtilizationBaseRef = bookingMaterialUtilizationBaseRef;
    self.active = active;
    self.storageIconMap = storageIconMap;

    $scope.$watch(function() {
      return self.bookingMaterialUtilizationBaseRef;
    }, function() {
      self.hierarchy = [JSON.parse(
        JSON.stringify(
          hierarchy,
          function(key, value) {
            if (value && value.id && value.materialModel) {
              var candidates = ((self.bookingMaterialUtilizationBaseRef.bookingMaterialUtilizationBase || {})[value.materialModel] || {})[value.id] || {};
              if (candidates) {
                // first key fallback is only an approximation
                value.utilization = candidates[bookingMaterialTimeId] || (Object.keys(candidates).length && candidates[Object.keys(candidates)[0]]) || undefined;
              }
            }
            return value;
          }
        )
      )];
    }, true);
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances', [
      'BlurAdmin.pages.finances.quotations',
      'BlurAdmin.pages.finances.quotationInvoiceDetails',
      'BlurAdmin.pages.finances.demandForAction',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.finances', {
        url: '/finances',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        title: 'navigation.finances',
        abstract: true,
        sidebarMeta: {
          order: 5,
          icon: 'af af-finance-coins',
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances')
    .controller('businessPartnerDetailsModalCtrl', businessPartnerDetailsModalCtrl);

  function businessPartnerDetailsModalCtrl($translate, businessPartner) {
    var self = this;
    if (businessPartner.OwnerDivision && businessPartner.OwnerDivision.ZipCode) {
      businessPartner.OwnerDivision.ZIP = businessPartner.OwnerDivision.ZipCode;
    }
    self.bp = businessPartner;
    self.i18nMap = {
      Name: $translate.instant('modules.contacts.businessPartners.overview.nameCol'),
      TradeName: $translate.instant('modules.contacts.businessPartners.overview.tradeNameCol'),
      City: $translate.instant('modules.contacts.businessPartners.overview.cityCol'),
      ZIP: $translate.instant('modules.contacts.businessPartners.overview.zipCol'),
      CountryId: $translate.instant('modules.contacts.businessPartners.overview.countryCol'),
      Street: $translate.instant('modules.contacts.businessPartners.overview.streetCol'),
      HouseNumber: $translate.instant('generalTerms.houseNumber'),
      AddressAffix: $translate.instant('models.Member.AddressAffix'),
      EMail: $translate.instant('modules.contacts.businessPartners.overview.EMail'),
      ElectricAdress: $translate.instant('modules.contacts.businessPartners.details.ElectricAddress'),
      Comment: $translate.instant('modules.contacts.businessPartners.details.Comment'),
      OtherLegalInformation: $translate.instant('modules.contacts.businessPartners.details.OtherLegalInformation'),
    }
    self.relevantCols = [
      'Name',
      'TradeName',
      'City',
      'ZIP',
      'CountryId',
      'Street',
      'HouseNumber',
      'AddressAffix',
      'EMail',
      'ElectricAdress',
      'Comment',
      'OtherLegalInformation',
    ];
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('bookingMaterialCalendarDetailCtrl', bookingMaterialCalendarDetailCtrl);

  /** @ngInject */
  function bookingMaterialCalendarDetailCtrl($scope, $uibModalInstance, event, materialName, permissions, divisionId, $state) {
    var self = this;

    self.event = event;
    self.materialName = materialName;
    self.startDate = self.event.start.toDate();
    self.endDate = self.event.end.toDate();
    self.isService = !!self.event.serviceShiftId;

    self.showAsked = self.event.askedDiff ? self.event.askedFlat : 0;

    self.permission = self.isService ? 'arno.events.service.view,arno.virtual.item.events.service.manage'
                                     : 'arno.events.basic.view,arno.virtual.item.events.basic.manage';
    self.canOpenEvent = permissions.isPermittedInEvery(self.permission, 'Division', divisionId);

    self.eventColorClass = function() {
      var eventColorClass = 'success';
      /* if (!self.event.availDiff) {
        eventColorClass = 'info';
      } */
      if (self.event.askedDiff) {
        eventColorClass = 'danger';
      }
      return eventColorClass;
    }

    self.openEvent = function () {
      $uibModalInstance.close();
      if (self.isService) {
        $state.go('arno.events.serviceDetail', { serviceId: self.event.serviceId, '#': 'sidref' + event.serviceShiftId });
      } else {
        $state.go('arno.events.eventDetail', { eventId: self.event.eventId });
      }
    };

    self.applyModal = function () {
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  /** @ngInject */
  angular.module('BlurAdmin.theme.components')
    .controller('IncompatCtrl', IncompatCtrl);

  function IncompatCtrl(failedApprovals) {
    var self = this;
    self.failedApprovals = failedApprovals;
  }

})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.approvals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.approvals', {
        url: '/approvals?affectedDivs&approvalAllocId&approvalAllocVersion',
        templateUrl: 'app/pages/personnel/approvals/approvals.html',
        title: 'navigation.personnel.approvals',
        params: {
          affectedDivs: {
            dynamic: true,
          },
          approvalAllocId: {
            dynamic: true,
          },
          approvalAllocVersion: {
            dynamic: true,
          },
        },
        resolve: {
          ctx: function (commonUtils, $stateParams) {
            var linkedDivs = $stateParams.affectedDivs ? $stateParams.affectedDivs.split(',') : null;
            if (linkedDivs) {
              commonUtils.division.setCtx(linkedDivs,
                {
                  multiple: true,
                  allowOrgSelection: false,
                });
            }
            var selectedDivision = commonUtils.division.getCtx({
              multiple: true,
              allowOrgSelection: false,
              entryPermission: 'arno.personnel.clearance.view'
            });
            if (selectedDivision.length && selectedDivision[0]) {
              if (selectedDivision[0] === 'rootOrg') {
                return false;
              }
              return selectedDivision;
            }
            return [];
          },
          ctxSelected: function (ctx) {
            return !!ctx;
          },
          preSelected: function($stateParams) {
            return {
              approvalAllocId: $stateParams.approvalAllocId ? (Number.parseInt || parseInt)($stateParams.approvalAllocId, 10) : null,
              approvalAllocVersion: $stateParams.approvalAllocVersion ? $stateParams.approvalAllocVersion : null,
            };
          },
          allowedReferences: function(ArnoDashAdminClearancesService,commonUtils) {
            return ArnoDashAdminClearancesService.getApprovalStartAndEditReferences(commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }));
          },
          tableConfig: function(clientApi, commonUtils, ctx, $translate) {
            if (ctx.length) {
              return clientApi
                .custom('model/Approval', 'getColumns', {
                  divisionId: ctx,
                  language: $translate.use(),
                })
                .then(function(availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'approvalProcessList',
                      divisionId: ctx
                    })
                    .then(function(customTableConfigs) {
                      var tableConfigDefault = {
                        'Approval.ClearanceGroup': true,
                        'Division.Name': true,
                        'StatusLight': true,
                        'AffectedMember.fullName': true,
                        'Approval.Title': true,
                        'Approval.State': true,
                        'Approval.Type': true,
                      };


                      var Fields = JSON.parse(JSON.stringify(availableFields));
                      Fields.forEach(function (field) {
                        // eslint-disable-next-line no-extra-boolean-cast
                        if (!!~[
                          'ApprovalEXP.ReleasedTitle',
                          'ApprovalEXP.ReleasedType',
                        ].indexOf(field.label)) {
                          field.label = 'exports.' + field.label;
                        } else if (!field.field){
                          // update the field definition to work for include model
                          field.label = 'models.' + field.label;
                        }
                      });




                      return {
                        tableConfigAvailableFields: Fields,
                        tableConfigDefault: tableConfigDefault,
                        tableConfigCustomPreference: customTableConfigs
                      };
                    });
                });
            }
            return null;
          },
          memberGroups: function(ctx, clientApi) {
            if (ctx.length) {
              return clientApi.custom('model/MemberGroup', 'groupsWithDivision', { divisionIds: ctx });
            }
            return [];
          },
        },
        viewPermission: 'arno.personnel.clearance.view',
        controller: 'PersonnelApprovalCtrl as $ctrl',
        sidebarMeta: {
          order: 3,
        },
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.approvals')
    .controller('ApprovalprocessModalCtrl', ApprovalprocessModalCtrl);

  /** @ngInject */
  function ApprovalprocessModalCtrl(
    ARNO_CONSTANTS,
    $uibModalInstance, $rootScope, $translate, clientApi, permissions, commonUtils, validationUtils, permittedDivs, $scope, $uibModal,
    organizationId, divisionId, approvals, divisionMembers, approvalprocess, toastr, isPermitted, approvalAcceptors, fixedMembers, disabledApprovals, approvalProccessMode
  ) {
    var self = this;
    // CONSTS
    self.CLEARANCES_TYPES = ARNO_CONSTANTS.ADMIN.CLEARANCES.CLEARANCES_TYPES;

    // VARS
    self.permittedDivs = permittedDivs;
    if (approvalprocess.Division) {
      self.permittedDivs = self.permittedDivs.concat([{
        Name: $translate.instant('modules.personnel.approvals.noDivision'),
        id: null
      }]);
    }
    self.divisionId = divisionId;
    self.organizationId = organizationId;
    self.approvals = approvals;
    self.divisionMembers = divisionMembers;
    self.approvalprocess = approvalprocess || [];
    self.approvalProcesses = [];
    self.affectedMembers = [];
    self.membersForApproval = {};
    self.approvalAcceptors = approvalAcceptors;
    self.selectedDivision = approvalprocess.Division || { Name: $translate.instant('modules.personnel.approvals.noDivision'), id: null };

    self.fixedMembers = fixedMembers;
    self.disabledApprovals = disabledApprovals;

    self.approvalProccessMode = approvalProccessMode;

    // BOOTSTRAPPING

    // do an initial check if we are editing in bulk
    if (Array.isArray(self.approvalprocess)) {
      self.bulkApprovals = JSON.parse(JSON.stringify(self.approvalprocess));
      self.approvalprocess = {
        Approval: {}
      };
    }

    function activate() {
      self.filteredApprovals = _.filter(self.approvals, function (approval) {
        return self.approvalSelectionFilter(approval);
      });

      if (self.fixedMembers === true) {
        self.affectedMembers = _.concat(self.affectedMembers, divisionMembers);
      }

      if (self.disabledApprovals && self.disabledApprovals.length) {
        _.forEach(self.filteredApprovals, function (approval) {
          if (_.find(self.disabledApprovals, { ApprovalId: approval.id })) {
            approval.disabled = true;
          } else {
            approval.disabled = false;
          }
        });
      }
      self.resubMaxEnabled = self.approvalprocess.Approval.MaxResubTimeDays || self.approvalprocess.Approval.MaxResubTimeMonths || self.approvalprocess.Approval.MaxResubTimeYears;
      self.setResubMaxDate();
    }

    $scope.$watch(function () {
      return self.selectedDivision;
    }, function (newVal, oldVal) {
      if (newVal) {
        var index = _.findIndex(self.permittedDivs, function (pdiv) {
          return pdiv.id === newVal.id;
        })
        if (index > -1) {
          self.permittedDivs.splice(index, 1);
          self.permittedDivs.push(oldVal);
        }
        self.permittedDivs = _.sortBy(self.permittedDivs, 'Name');
        return self.permittedDivs;
      }
    });

    $scope.$watch(function () {
      return self.dates.inspection.value
    }, function (newVal, oldVal) {
      if (self.dates.resub.value && newVal !== oldVal) {
        if (self.savedResubDiff) {
          var maxResub = moment(self.dates.resub.options.maxDate);
          var newResub = moment(self.dates.inspection.value).add(self.savedResubDiff, 'days');
          self.dates.resub.value = newResub.isAfter(maxResub) ? maxResub._d : newResub._d;
        } else {
          self.dates.resub.value = moment(self.dates.inspection.value)
            .add(self.approvalprocess.Approval.MaxResubTimeDays || 1, 'days')
            .add(self.approvalprocess.Approval.MaxResubTimeMonths || 0, 'months')
            .add(self.approvalprocess.Approval.MaxResubTimeYears || 0, 'years')._d;
        }
        toastr.warning($translate.instant('modules.personnel.approvals.resubmissionChangedToastText'),
          $translate.instant('modules.personnel.approvals.resubmissionChangedToastTitle'));
      }
    })

    $scope.$watch(function () {
      return self.dates.resub.value
    }, function () {
      if (self.dates.inspection.value && self.dates.resub.value) {
        self.savedResubDiff = moment(self.dates.resub.value).diff(self.dates.inspection.value, 'days');
      } else {
        delete self.savedResubDiff;
      }
    })

    self.checkIfDisabledApproval = function (approval) {
      // sort out approvals which are blacklisted by the optional disabledApprovals-Array
      if (self.disabledApprovals && self.disabledApprovals.length) {
        if (_.find(self.disabledApprovals, { ApprovalId: approval.id })) {
          approval.disabled = true;
          return true;
        }
      }

      approval.disabled = false;
      return false;
    }

    self.setResubMaxDate = function () {
      if (self.approvalprocess && self.approvalprocess.Approval && self.resubMaxEnabled) {
        // maximum resub time is set, limit the resub max date
        if (self.dates.inspection.value) {
          var maxDate = moment(self.dates.inspection.value);
          maxDate.add(self.approvalprocess.Approval.MaxResubTimeDays || 0, 'days');
          maxDate.add(self.approvalprocess.Approval.MaxResubTimeMonths || 0, 'months');
          maxDate.add(self.approvalprocess.Approval.MaxResubTimeYears || 0, 'years');
          self.dates.resub.options.maxDate = maxDate;
        }
      }
    }

    self.searchMembers = function (name) {
      return self.loadMembers({ searchName: name });
    };

    self.loadMembers = function (options) {
      var addHintEntry = function (result) {
        return result.concat([{ hint: true }]);
      }

      return clientApi
        .custom('model/Member', 'findByDivisionId', {
          divisionId: divisionId,
          searchName: (options && options.searchName),
          queryWishes: {
            activeDivisionMember: true,
          }
        })
        .then(function (result) {
          result.forEach(function (loadedMember) {
            if (_.find(self.affectedMembers, { id: loadedMember.id })) {
              loadedMember.selected = true;
            }
          });

          self.divisionMembers = addHintEntry(result);

          self.refreshDisabledMembers(self.divisionMembers, self.approvalsMembersMapping);
        });
    };

    self.addMember = function () {
      self.selectedMember.selected = true;
      self.affectedMembers.push(self.selectedMember);
      self.selectedMember = null;
    };

    self.removeMember = function (member) {
      member.selected = false;
      self.affectedMembers = self.affectedMembers.filter(function (item) {
        return item.id !== member.id;
      });
    };

    self.approvalGroupBy = function (approval) {
      return approval.ClearanceGroup && approval.ClearanceGroup.Name || $translate.instant('modules.personnel.approvals.notAssigned');
    };

    self.approvalSelectionFilter = function (approval) {
      var isPermittedToStartSimpleClearances = (approval.Type === 'SIMPLE' && permissions.isPermittedInEvery(
        'arno.personnel.clearance.start.simple',
        'Division',
        divisionId ? [divisionId] : commonUtils.division.getCtx({ multiple: true })
      ));

      var isPermittedToStartComplexClearances = isPermitted('arno.item.approval.start', {
        Division: {
          id: divisionId,
        },
        Approval: {
          id: approval.id,
        }
      });

      return isPermittedToStartSimpleClearances || isPermittedToStartComplexClearances;
    };

    self.disableMembers = function (approval) {
      if (!self.membersForApproval[approval.id]) {
        clientApi.custom('model/ApprovalAllocation', 'getMembersForApproval', { approvalId: approval.id, divisionId: self.divisionId })
          .then(function (result) {
            self.membersForApproval[approval.id] = true;

            self.approvalsMembersMapping = result;
            self.refreshDisabledMembers(self.divisionMembers, result);
          })
          .catch(function () {
            // well, I guess that didn't work..
          });
      }
    };

    self.checkIfDisabled = function (member, approvalId) {
      if (member.disabledForApproval) {
        var index = _.findIndex(member.disabledForApproval, function (disabled) {
          return disabled.id === approvalId;
        });
        if (index > -1 && member.disabledForApproval[index].divisionId !== self.divisionId) {
          if (member.disabledForApproval[index].divisionId !== null) {
            member.disabledTooltip = member.disabledTooltip = $translate.instant(
              'modules.personnel.approvals.memberDisabledTooltip',
              { division: member.disabledForApproval[index].division }
            ) + member.disabledForApproval[index].acceptor.length ? $translate.instant('modules.personnel.approvals.responsible', { members: member.disabledForApproval[index].acceptor.join(', ') }) : '';
          } else {
            member.voidTooltip = $translate.instant('modules.personnel.approvals.voidTooltip');
          }
        } else if (index > -1) {
          member.disabledTooltip = $translate.instant('modules.personnel.approvals.memberDisabledTooltip2')
                                   + member.disabledForApproval[index].acceptor.length ? $translate.instant('modules.personnel.approvals.responsible', { members: member.disabledForApproval[index].acceptor.join(', ') }) : '';
        }
        if (member.disabledForApproval[index] && member.disabledForApproval[index].divisionId === null) {
          return false;
        }
        return !!~index;
      }
      delete member.disabledTooltip;
      return false;
    };

    self.saveApprovalprocess = function (form) {
      if (form.$invalid) {
        return;
      }

      self.affectedMembers.forEach(function (member) {
        var approvalprocess = {
          ApprovalId: self.selectedApproval.id,
          DivisionId: self.divisionId,
          InitiatingMemberId: $rootScope.ctx.currentUser.id,
        };

        approvalprocess.AffectedMemberId = member.id;
        if (member.voidTooltip) {
          var approval = _.find(member.disabledForApproval, function (disabled) {
            return disabled.id === self.selectedApproval.id;
          });
          if (approval) {
            approvalprocess.id = approval.processId;
          }
        }

        self.approvalProcesses.push(approvalprocess);
      });

      return clientApi.custom('model/ApprovalAllocation', 'createOrUpdate', { data: self.approvalProcesses })
        .then(function () {
          toastr.success($translate.instant('modules.personnel.approvals.createdSuccessToastText'),
            $translate.instant('modules.personnel.approvals.createdSuccessToastTitle'));
          $uibModalInstance.close();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.personnel.approvals.createdErrorToastText'),
            $translate.instant('modules.personnel.approvals.createdErrorToastTitle'));
        });
    };

    // Edit

    self.dates = {
      date: {
        title: 'Datum',
        isOpen: false,
        value: (self.approvalprocess.Letter !== null && self.approvalprocess.Letter !== undefined) ? new Date(self.approvalprocess.Letter) : null,
        isHidden: self.approvalProccessMode != 2,
        isReminder: false,
        options: {
          showWeeks: true,
          datepickerMode: 'day',
        },
      },
      letter: {
        title: self.approvalprocess.Approval.LetterTitle || $translate.instant('models.ApprovalAllocation.Letter'),
        isOpen: false,
        value: (self.approvalprocess.Letter !== null && self.approvalprocess.Letter !== undefined) ? new Date(self.approvalprocess.Letter) : null,
        isHidden: self.approvalProccessMode == 1 || self.approvalProccessMode == 2,
        isReminder: false,
        options: {
          showWeeks: true,
          datepickerMode: 'day',
        },
      },
      firstReminder: {
        title: self.approvalprocess.Approval.Reminder1Title || $translate.instant('models.ApprovalAllocation.Reminder1'),
        isOpen: false,
        isHidden: true,
        isReminder: true,
        minDependency: (self.approvalProccessMode == 1 || self.approvalProccessMode == 2) ? null : ['letter'],
        maxDependency: ['secondReminder', 'resub'],
        hideDependency: 'letter',
        value: (self.approvalprocess.Reminder1 !== null && self.approvalprocess.Reminder1 !== undefined) ? new Date(self.approvalprocess.Reminder1) : null,
        options: {
          showWeeks: false,
          datepickerMode: 'day',
        },
      },
      secondReminder: {
        title: self.approvalprocess.Approval.Reminder2Title || $translate.instant('models.ApprovalAllocation.Reminder2'),
        isOpen: false,
        isHidden: true,
        isReminder: true,
        minDependency: (self.approvalProccessMode == 1 || self.approvalProccessMode == 2) ? ['firstReminder'] : ['letter', 'firstReminder'],
        maxDependency: ['resub'],
        hideDependency: 'firstReminder',
        value: (self.approvalprocess.Reminder2 !== null && self.approvalprocess.Reminder2 !== undefined) ? new Date(self.approvalprocess.Reminder2) : null,
        options: {
          showWeeks: false,
          datepickerMode: 'day',
        },
      },
      inspection: {
        title: self.approvalprocess.Approval.InspectionTitle || $translate.instant('models.ApprovalAllocation.Inspection'),
        isOpen: false,
        isHidden: self.approvalProccessMode == 2,
        isReminder: false,
        minDependency: [],
        maxDependency: [],
        value: (self.approvalprocess.Inspection !== null && self.approvalprocess.Inspection !== undefined) ? new Date(self.approvalprocess.Inspection) : null,
        options: {
          showWeeks: false,
          datepickerMode: 'day',
        },
      },
      resub: {
        title: self.approvalprocess.Approval.ResubmissionTitle || $translate.instant('models.ApprovalAllocation.Resubmission'),
        isOpen: false,
        isHidden: self.approvalProccessMode == 2,
        isReminder: false,
        minDependency: ['inspection'],
        dependency: 'inspection',
        value: (self.approvalprocess.Resubmission !== null && self.approvalprocess.Resubmission !== undefined) ? new Date(self.approvalprocess.Resubmission) : null,
        options: {
          showWeeks: false,
          datepickerMode: 'year',
          minDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), // min date is tomorrow
        },
      },
    };

    var checkValidity = function (singleProcess) {
      var inspectionChanged = (self.dates.inspection.value && !(moment(self.dates.inspection.value).isSame(moment(singleProcess.Inspection)))) || false;

      var validatedProcess = {
        letter: self.dates.letter.value || (singleProcess.Letter ? new Date(singleProcess.Letter) : null),
        firstReminder: self.dates.firstReminder.value || (singleProcess.Reminder1 ? new Date(singleProcess.Reminder1) : null),
        secondReminder: self.dates.secondReminder.value || (singleProcess.Reminder2 ? new Date(singleProcess.Reminder2) : null),
        inspection: self.dates.inspection.value || (singleProcess.Inspection ? new Date(singleProcess.Inspection) : null),
        resub: self.dates.resub.value || (singleProcess.Resubmission ? new Date(singleProcess.Resubmission) : null),
        resubMax: singleProcess.Approval.MaxResubTimeDays || singleProcess.Approval.MaxResubTimeMonths || singleProcess.Approval.MaxResubTimeYears,
        resubDays: singleProcess.Approval.MaxResubTimeDays,
        resubMonths: singleProcess.Approval.MaxResubTimeMonths,
        resubYears: singleProcess.Approval.MaxResubTimeYears,
        id: singleProcess.id,
        ApprovalId: singleProcess.ApprovalId,
        DivisionId: singleProcess.DivisionId,
        savedApproval: singleProcess,
        valid: true,
        restart: false
      }

      if (self.dates.letter.value && singleProcess.Letter && singleProcess.Inspection) {
        if (moment(singleProcess.Inspection).add(1, 'days').isBetween(moment(singleProcess.Letter), moment(self.dates.letter.value), undefined, '[]')) {
          validatedProcess.restart = true;
          validatedProcess.firstReminder = null;
          validatedProcess.secondReminder = null;
        }
      }

      if (validatedProcess.resubMax) {
        var maxDate = moment(self.dates.inspection.value);
        maxDate.add(validatedProcess.resubDays || 0, 'days');
        maxDate.add(validatedProcess.resubMonths || 0, 'months');
        maxDate.add(validatedProcess.resubYears || 0, 'years');
        if (self.dates.inspection.value && (!validatedProcess.resub || !moment(self.dates.resub.value).isBetween(moment(self.dates.inspection.value), maxDate, undefined, '[]'))) {
          validatedProcess.valid = false;
          validatedProcess.invalidMessage = $translate.instant('modules.personnel.approvals.invalidResubMsg');
          return validatedProcess;
        }
      }

      Object.keys(self.dates).forEach(function (key) {
        var excludeMax = [];
        if (validatedProcess.inspection && moment(validatedProcess.inspection).isBefore(moment(validatedProcess.letter))) {
          excludeMax = ['inspection', 'resub'];
        }
        if (self.dates[key].minDependency && validatedProcess[key]) {
          var minDependencyVals = [];
          self.dates[key].minDependency.forEach(function (dep) {
            if (validatedProcess[dep] && ((!excludeMax.includes(key)) || inspectionChanged)) {
              minDependencyVals.push(+validatedProcess[dep]);
            }
          })
          if (minDependencyVals.length && moment(_.max(minDependencyVals)).add(1, 'days').isAfter(validatedProcess[key])) {
            validatedProcess.valid = false;
            validatedProcess.invalidMessage = $translate.instant('modules.personnel.approvals.invalidChronologyMsg');
          }
        }
        if (self.dates[key].maxDependency && validatedProcess[key]) {
          var maxDependencyVals = [];
          self.dates[key].maxDependency.forEach(function (dep) {
            if (validatedProcess[dep] && (!excludeMax.includes(dep))) {
              maxDependencyVals.push(+validatedProcess[dep]);
            }
          })
          if (maxDependencyVals.length && moment(_.min(maxDependencyVals)).subtract(1, 'days').isBefore(validatedProcess[key])) {
            validatedProcess.valid = false;
            validatedProcess.invalidMessage = $translate.instant('modules.personnel.approvals.invalidChronologyMsg');
          }
        }
      })
      return validatedProcess;
    }

    self.saveDates = function () {
      if (!self.bulkApprovals) {
        var validated = checkValidity(self.approvalprocess);
        if (!self.dates.resub.value && self.resubMaxEnabled && self.dates.inspection.value) {
          toastr.error($translate.instant('modules.personnel.approvals.resubRequiredToastText'),
            $translate.instant('modules.personnel.approvals.resubRequiredToastTitle'));
          return;
        }
        if (self.approvalProccessMode == 1) {
          self.approvalprocess.Letter = null;
          self.approvalprocess.Reminders = null;
        } else {
          self.approvalprocess.Letter = self.dates.letter.value;
          self.approvalprocess.Reminders = validated.restart ? [null, null] : [self.dates.firstReminder.value, self.dates.secondReminder.value];
        }
        self.approvalprocess.Inspection = self.dates.inspection.value;
        self.approvalprocess.Resubmission = self.dates.resub.value;
        if (self.selectedDivision && (self.selectedDivision.id || self.selectedDivision.id === null)) {
          self.approvalprocess.DivisionId = self.selectedDivision.id;
        }

        if (validated.valid) {
          return clientApi.custom('model/ApprovalAllocation', 'createOrUpdate', { data: self.approvalprocess })
            .then(function () {
              toastr.success($translate.instant('modules.personnel.approvals.editSuccessToastText'),
                $translate.instant('modules.personnel.approvals.editSuccessToastTitle'));
              $uibModalInstance.close();
            })
            .catch(function () {
              toastr.error($translate.instant('modules.personnel.approvals.editFailedToastText'),
                $translate.instant('modules.personnel.approvals.editFailedToastTitle'));
            });
        } else {
          toastr.error(validated.invalidMessage);
          return;
        }

      } else {
        var checkedApprovals = [];
        self.bulkApprovals.forEach(function (singleProcess) {
          checkedApprovals.push(checkValidity(singleProcess));
        })
        var partitions = _.partition(checkedApprovals, function (ap) {
          return ap.valid
        });
        if (partitions[0] && partitions[0].length) {
          // some (maybe all) approvals are valid, update them and give the user a list of invalid ones afterwards
          partitions[0] = partitions[0].map(function (sp) {
            return {
              id: sp.savedApproval.id,
              ApprovalId: sp.savedApproval.ApprovalId,
              DivisionId: sp.savedApproval.DivisionId,
              Letter: self.approvalProccessMode == 1 ? null : sp.letter,
              Reminders: (sp.restart || self.approvalProccessMode == 1) ? [null, null] : [sp.firstReminder, sp.secondReminder],
              Inspection: sp.inspection,
              Resubmission: sp.resub,
            }
          })
          return clientApi.custom('model/ApprovalAllocation', 'createOrUpdate', { data: partitions[0] })
            .then(function () {
              if (!partitions[1] || !partitions[1].length) {
                toastr.success($translate.instant('modules.personnel.approvals.bulkEditSuccessToastText'),
                  $translate.instant('modules.personnel.approvals.bulkEditSuccessToastTitle', { number: self.bulkApprovals.length }));
              } else {
                toastr.warning($translate.instant('modules.personnel.approvals.bulkEditWarnToastText'),
                  $translate.instant('modules.personnel.approvals.bulkEditWarnToastText', { number: partitions[0].length ? partitions[0].length.toString() : '' }));
                return $uibModal.open({
                  animation: true,
                  backdrop: 'static',
                  templateUrl: 'app/theme/components/approvalProcessList/approvalprocessModal/incompatibleApproval.html',
                  size: 'md',
                  controller: 'IncompatCtrl as $ctrl',
                  resolve: {
                    failedApprovals: function () {
                      return _.compact(partitions[1].map(function (p) {
                        return p.savedApproval;
                      }));
                    },
                  },
                })
                  .result
                  .catch(function () {
                    $uibModalInstance.close();
                  })
              }
            })
            .then(function () {
              $uibModalInstance.close();
            })
            .catch(function () {
              toastr.error($translate.instant('modules.personnel.approvals.bulkEditErrorToastText'),
                $translate.instant('modules.personnel.approvals.bulkEditErrorToastTitle'));
            });
        } else {
          // none of the selected approvals are valid with what the user is trying to alter here
          var invalidMessages = _.uniq(partitions[1].map(function (p) {
            return p.invalidMessage
          }));
          if (invalidMessages.length === 1) {
            toastr.error(invalidMessages[0]);
          } else {
            toastr.error($translate.instant('modules.personnel.approvals.bulkEditErrorToastText2'),
              $translate.instant('modules.personnel.approvals.bulkEditErrorToastTitle'));
          }
        }
      }
    };

    self.isBlockField = function (key) {
      return key !== 'letter' && self.dates[key].dependency && !self.dates[self.dates[key].dependency].value;
    }

    self.fillNextField = function (date) {
      if(self.bulkApprovals) {
        self.bulkApprovals.forEach(function (approval) {
          if (self.approvalProccessMode == 2) {
            if (approval.Letter == null) {
              approval.Letter = date.value;
  
            } else if (approval.Reminder1 == null) {
              approval.Reminder1 = date.value;
            } else if (approval.Reminder2 == null) {
              approval.Reminder2 = date.value;
            } else {
              toastr.error('Kein Freies Feld vorhanden!');
            }
          }
        });
      }     
    }

    self.refreshDisabledMembers = function (divisionMembers, approvalsMembersMapping) {
      divisionMembers.forEach(function (divMember) {
        if (approvalsMembersMapping) {
          approvalsMembersMapping.forEach(function (approvalMap) {
            if (approvalMap.AffectedMember.id === divMember.id) {
              if (!divMember.disabledForApproval) {
                divMember.disabledForApproval = [];
              }
              if (!~divMember.disabledForApproval.indexOf(approvalMap.Approval.id)) {
                var acceptors = [];
                self.approvalAcceptors.forEach(function (acceptor) {
                  if (approvalMap.Division && acceptor.Division.id === approvalMap.Division.id) {
                    acceptors.push(acceptor.Member.fullName);
                  }
                });
                divMember.disabledForApproval.push({
                  processId: approvalMap.id,
                  id: approvalMap.Approval.id,
                  division: (approvalMap.Division && approvalMap.Division.Name) || null,
                  divisionId: (approvalMap.Division && approvalMap.Division.id) || null,
                  acceptor: acceptors
                });
              }
            }
          })
        }
      });
    }

    self.checkForUpdates = function () {
      Object.keys(self.dates).forEach(function (key) {
        if (self.dates[key].minDependency) {
          var minDependencyVals = [];
          self.dates[key].minDependency.forEach(function (dep) {
            if (self.dates[dep].value) {
              minDependencyVals.push(+self.dates[dep].value);
            }
          })
          if (minDependencyVals.length) {
            self.dates[key].options.minDate = moment(_.max(minDependencyVals)).add(1, 'days');
          }
        }
        if (self.dates[key].maxDependency) {
          var maxDependencyVals = [];
          var exclude = (self.dates.inspection.value && moment(self.dates.inspection.value).isBefore(moment(self.dates.letter.value))) ? ['inspection', 'resub'] : [];
          self.dates[key].maxDependency.forEach(function (dep) {
            if (self.dates[dep].value) {
              if (!exclude.includes(dep)) {
                maxDependencyVals.push(+self.dates[dep].value);
              }
            }
          })
          if (maxDependencyVals.length) {
            self.dates[key].options.maxDate = moment(_.min(maxDependencyVals)).subtract(1, 'days');
          } else if (self.dates[key].options.maxDate) {
            delete self.dates[key].options.maxDate;
          }
        }
        if (self.dates[key].hideDependency && self.dates[self.dates[key].hideDependency].value) {
          self.dates[key].isHidden = false;
        } else if (self.dates[key].hideDependency) {
          self.dates[key].options.minDate = '';
          self.dates[key].isHidden = true;
          self.dates[key].value = null;
        }

        if (!self.dates[key].value) {
          // null it for db
          self.dates[key].value = null;
        }
      })
      if (self.dates.resub.value && !self.dates.inspection.value) {
        self.dates.resub.value = null;
        toastr.warning($translate.instant('modules.personnel.approvals.inspectionRequiredToastText'),
          $translate.instant('modules.personnel.approvals.inspectionRequiredToastTitle'));
      }
      self.setResubMaxDate();
    }
    self.checkForUpdates();

    self.toggleRejection = function (rejectionState, process) {
      var toastrContent = rejectionState ? $translate.instant('modules.personnel.approvals.rejectionStateAuthorized')
                                         : $translate.instant('modules.personnel.approvals.rejectionStateRejected');
      return clientApi.custom('model/ApprovalAllocation', 'toggleRejection', { data: _.assign(process, { rejected: rejectionState }) })
        .then(function () {
          toastr.success($translate.instant('modules.personnel.approvals.rejectionSuccessToastText', { rejectionstate: toastrContent }),
            $translate.instant('modules.personnel.approvals.rejectionSuccessToastTitle', { rejectionstate: toastrContent }));
          $uibModalInstance.close();
        })
        .catch(function () {
          toastr.success($translate.instant('modules.personnel.approvals.rejectionErrorToastText', { rejectionstate: toastrContent }),
            $translate.instant('modules.personnel.approvals.rejectionErrorToastTitle', { rejectionstate: toastrContent }));
        });
    }

    // VIEW-FUNCTIONS
    self.hasError = validationUtils.hasError;

    self.allApprovalsDisabled = function () {
      return _.every(self.filteredApprovals, { disabled: true });
    }

    // CONTROLLER-INIT
    self.$onInit = function () {
      activate();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.approvals')
    .controller('approvalExportCtrl', approvalExportCtrl);

  function approvalExportCtrl($uibModalInstance, exportPrivacyNote, multipleSelected) {
    
    var self = this;
    self.readAndAccepted = false;
    self.fieldOption = 'tableConfig';
    self.filterOption = 'filtered';
    self.useCurrentSelection = false;
    self.hasSelection = !!multipleSelected;
    self.exportPrivacyNoteContent = new showdown.Converter().makeHtml(exportPrivacyNote.TextContent);

    self.applyModal = function () {
      $uibModalInstance.close({
        options: {
          fields: self.fieldOption,
          filter: self.filterOption,
          groupByOption: self.groupByOption,
        },
      })
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('MemberApprovalModalCtrl', MemberApprovalModalCtrl);

  /** @ngInject */
  function MemberApprovalModalCtrl($uibModalInstance, approval) {
    var self = this;
    self.approval = approval;
    if (self.approval) {
      if (self.approval.AcquireDate) {
        self.approval.AcquireDate = moment(self.approval.AcquireDate).toDate();
      }
      if (self.approval.ExpireDate) {
        self.approval.ExpireDate = moment(self.approval.ExpireDate).toDate();
      }
    }

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false
      }
    };

    self.applyModal = function () {
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.personnelList', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.personnel.personnelList', {
      url: '/personnelList',
      templateUrl: 'app/pages/personnel/personnelList/personnelList.html',
      title: 'navigation.personnel.personnelList',
      controller: 'PersonnelListCtrl as $ctrl',
      resolve: {
        personnelListCtx: function (commonUtils) {
          return commonUtils.division.getCtx({
            multiple: true,
            allowOrgSelection: false,
            entryPermission: 'arno.personnel.personnelList.view',
          });
        },
        tableConfig: function (
          clientApi,
          commonUtils,
          personnelListCtx,
          permissions,
          $rootScope,
          $translate
        ) {
          var getDefaults = function (availableFields, customTableConfigs) {
            var orgPageSize = commonUtils.preference.object.get(
              'pref_personnel_page_size_org',
              10
            );
            var tableConfigOrgDefault = {
              Active: true,
              Mobile: false,
              FirstName: true,
              LastName: true,
              EMail: true,
              MemberActivityState: true,
              pageSize: orgPageSize.pageSize || orgPageSize,
            };
            var divPageSize = commonUtils.preference.object.get(
              'pref_personnel_page_size_div',
              10
            );
            var tableConfigDivDefault = {
              Active: true,
              Mobile: false,
              FirstName: true,
              LastName: true,
              Groups: true,
              EMail: true,
              MemberActivityState: true,
              pageSize: divPageSize.pageSize || divPageSize,
            };
            // create own field lists for div and org level
            var divFields = JSON.parse(JSON.stringify(availableFields));
            var orgFields = JSON.parse(JSON.stringify(availableFields));
            divFields.forEach(function (field) {
              if (!field.field) {
                // update the field definition to work for include model
                field.field = 'Member.' + field.prop;
              }
            });
            // add div specific fields
            divFields.push({
              label: $translate.instant('generalTerms.group'),
              prop: 'Groups',
              field: 'Member.MemberGroup.Name',
              sort: 15,
            });
            divFields.push({
              label: $translate.instant('generalTerms.memberState'),
              prop: 'MemberStatus',
              sort: 12,
            });
            divFields.push({
              label: $translate.instant('generalTerms.divisions'),
              prop: 'DivisionName',
              field: 'Division.Name',
              sort: 14,
            });

            divFields.push({
              label: $translate.instant('generalTerms.demandForAction'),
              prop: 'DemandForAction',
              field: 'DemandForAction',
            });
            divFields.push({
              label: $translate.instant('models.Member.JobCharacteristics'),
              prop: 'JobCharacteristics',
              field: 'JobCharacteristics',
              sort: 35,
            });
            divFields.push({
              label: $translate.instant('models.Member.QualificationFeatures'),
              prop: 'QualificationFeatures',
              field: 'QualificationFeatures',
              sort: 36,
            });
            divFields.push({
              label: $translate.instant('models.Member.AccountType'),
              prop: 'AccountType',
              field: 'AccountType',
              sort: 18,
            });

            // add org specific fields

            return {
              tableConfigAvailableFields: { div: divFields, org: orgFields },
              tableConfigOrgDefault: tableConfigOrgDefault,
              tableConfigDivDefault: tableConfigDivDefault,
              tableConfigCustomPreference: customTableConfigs,
            };
          };
          if (
            permissions.isPermittedInEvery(
              'arno.personnel.personnelList.view',
              'Division',
              personnelListCtx
            ) ||
            permissions.isPermittedInEvery(
              'arno.personnel.personnelList.view',
              'Organization',
              [$rootScope.ctx.organization.current.id]
            )
          ) {
            return clientApi
              .custom('model/Member', 'getAvailableFields', {
                divisionId: personnelListCtx,
                includeSpecialFields: true,
                language: $translate.use(),
              })
              .then(function (availableFields) {
                return clientApi
                  .custom('model/CustomListView', 'getUserTableConfigs', {
                    listType: 'personnelList',
                    divisionId: personnelListCtx,
                  })
                  .then(function (customTableConfigs) {
                    return getDefaults(availableFields, customTableConfigs);
                  });
              });
          }
          return getDefaults([], []);
        },
        personnelListPermissions: function ($rootScope, permissions) {
          return {
            org: permissions.isPermittedInEvery(
              'arno.personnel.personnelList.view',
              'Organization',
              [$rootScope.ctx.organization.current.id]
            ),
            div: permissions.isPermittedAnywhere(
              'arno.personnel.personnelList.view',
              ['Division']
            ),
          };
        },
        groups: function (clientApi, organizationId, personnelListCtx) {
          if (!personnelListCtx || !personnelListCtx.length) {
            return null;
          }
          return clientApi.custom('model/MemberGroup', 'groupsWithDivision', {
            divisionIds: personnelListCtx,
          });
        },
      },
      sidebarMeta: {
        order: 1,
      },
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.personnelList')
    .controller('PersonnelQualificationExportCtrl', PersonnelQualificationExportCtrl);

  function PersonnelQualificationExportCtrl($uibModalInstance, $translate, exportPrivacyNote) {
    var self = this;

    self.selectItems = [
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelXlsx'),
        value: 'xlsx'
      },
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelCsv'),
        value: 'csv'
      },
    ];
    self.selected = self.selectItems[0];

    self.readAndAccepted = false;

    if(exportPrivacyNote && exportPrivacyNote.TextContent) {
      self.exportPrivacyNoteContent = new showdown.Converter().makeHtml(exportPrivacyNote.TextContent);
    }

    self.applyModal = function () {
      $uibModalInstance.close({
        filetyp: self.selected.value,
      });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.personnelList')
    .controller('PersonnelChooseExportTypeCtrl', PersonnelChooseExportTypeCtrl);

  function PersonnelChooseExportTypeCtrl($uibModalInstance, $translate, selectedCalcData, exportPrivacyNote) {
    var self = this;
    if (selectedCalcData && selectedCalcData.enabled) {
      self.includeCalcOption = true;
      self.liveCalc = selectedCalcData.initVal;
    }
    self.cKeys = { 
      on: $translate.instant('modules.personnel.personnelList.exportModalRadioKeyOn'),
      off: $translate.instant('modules.personnel.personnelList.exportModalRadioKeyOff')
    };
    self.selectItems = [
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelXlsx'),
        value: 'xlsx'
      },
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelCsv'),
        value: 'csv'
      },
    ];

    self.calcHints = {
      on: $translate.instant('modules.personnel.personnelList.exportModalcalcHintOn'),
      off: $translate.instant('modules.personnel.personnelList.exportModalcalcHintOff')
    };
    self.selected = self.selectItems[0];
    self.fieldOption = 'tableConfig';
    self.filterOption = 'filtered';

    self.readAndAccepted = false;
    self.exportPrivacyNoteContent = new showdown.Converter().makeHtml(exportPrivacyNote.TextContent);

    self.applyModal = function () {
      $uibModalInstance.close({
        options: {
          fields: self.fieldOption,
          filter: self.filterOption,
        },
        filetyp: self.selected.value,
        liveCalc: self.liveCalc,
      });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteAdd')
    .controller('ShowMemberDataCtrl', ShowMemberDataCtrl);

  /** @ngInject */
  function ShowMemberDataCtrl($rootScope, $scope, $uibModalInstance, $translate, membersToAdd, commonUtils,
    initialInviteType) {
    var self = this;
    self.utils = commonUtils;
    self.membersToAdd = membersToAdd;
    self.initialInviteType = initialInviteType;

    self.calculateDifferingTypes = function () {
      self.differingTypeAlert = {};
      self.membersToAdd.forEach(function (member) {
        if (member.Account.Type !== self.initialInviteType) {
          self.differingTypeAlert[member['$$hashKey']] = true;
        }
      });
    };
    self.calculateDifferingTypes();

    self.showDifferingTypeAlert = function () {
      return Object.keys(self.differingTypeAlert).length;
    };

    self.removeMemberToAdd = function (member) {
      var memberPosition = self.membersToAdd.map(function (e) {
        return e['$$hashKey'];
      })
        .indexOf(member['$$hashKey']);
      if (!!~memberPosition) { //eslint-disable-line no-extra-boolean-cast
        self.membersToAdd.splice(memberPosition, 1);
      }
      self.calculateDifferingTypes();
    };

    self.add = function () {
      $uibModalInstance.close(self.membersToAdd);
    };

    self.close = function () {
      $uibModalInstance.close(false);
    };

    self.hasSomethingToSend = function () {
      return self.membersToAdd.filter(function (memberToAdd) {
        return memberToAdd.inviteStatus === 0;
      }).length;
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteAdd')
    .controller('InviteModalCtrl', InviteModalCtrl);

  /** @ngInject */
  function InviteModalCtrl($rootScope, $scope, $uibModalInstance, $translate, member, commonUtils) {
    var self = this;
    self.utils = commonUtils;
    self.currentMember = member;

    self.acceptMatch = function (selectedMatch) {
      if (!selectedMatch.DivisionMember && self.currentMember && self.currentMember.DivisionMember) {
        selectedMatch.DivisionMember = self.currentMember.DivisionMember;
      }
      $uibModalInstance.close(selectedMatch);
    };

    self.matchIsDismissable = (function() {
      if (!self.currentMember.toastr) {
        return true;
      }
      return !~['differentTypeExists', 'sameOrgaExists', 'differentOrgaExists'].indexOf(self.currentMember.toastr);
    })();

    self.dismissMatch = function () {
      if (self.currentMember.toastr) {
        self.currentMember.inviteStatus = 0;
      }
      delete self.currentMember.matches;
      $uibModalInstance.close(self.currentMember);
    };

    self.close = function () {
      $uibModalInstance.close(false);
    };

    self.displayTypeOf = function(type) {
      return {'offline': 'Offline', 'local': 'ARNO', 'azure': 'Azure AD'}[type] || type;
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteAdd')
    .controller('InviteImportModalCtrl', InviteImportModalCtrl);

  /**
   * This controller handles the invite import logic within a module
   * @method InviteImportModalCtrl
   * @memberOf module:App.Personnel.inviteAdd
   * @param {object} [ctx = injected] - Context with divisionIds and rootOrg
   * @param {object} [type = injected] - Member type ('local' or 'offline')
   * @param {object} [FileUploader = injected] - Angular plugin that handles file uploads
   * @param {object} [toastr = injected] - The toastr framework
   * @param {object} [clientApi = injected] - The clientApi
   * @param {object} [$uibModalInstance = injected] - The $uibModalInstance framework
   * @return {void}
   */

  /** @ngInject */
  function InviteImportModalCtrl($translate, type, FileUploader, toastr, clientApi, $uibModalInstance, ctx) {
    var self = this;
    self.records = {};
    self.okDisabled = true;
    self.enableCheckbox = false;
    self.type = type;
    self.checked = false;
    self.validate = function (click) {
      if (click) {
        self.checked = !self.checked;
      }
      if (self.checked) {
        self.okDisabled = self.records.length <= 0;
      } else {
        self.okDisabled = true;
        // toastr.success('Die Datei ist bereit zum Import. Bitte bestätige die Richtigkeit der enthaltenen Daten um den Import zu starten.', 'Upload durchgeführt');
        toastr.success($translate.instant('modules.personnel.inviteList.importToastSuccText'),
          $translate.instant('modules.personnel.inviteList.importToastSuccTitle'));
        self.enableCheckbox = true;
      }
    };
    self.uploaderConfig = clientApi.fileUploaderConfig({
      autoUpload: true,
      queueLimit: 1,
      url: '/api/personnel/upload?division=' + ctx + '&type=' + self.type,
      onSuccessItem: function (item, response) {
        self.records = response.records;
        self.validate(null);
      },
      onErrorItem: function (item, response) {
        self.okDisabled = true;
        self.enableCheckbox = false;
        if (response.error === 'wrong fileformat') {
          toastr.error($translate.instant('modules.personnel.inviteList.importToastErr1Text'),
          $translate.instant('modules.personnel.inviteList.importToastErrTitle'));
        } else if (response.error === 'workbook error') {
          toastr.error($translate.instant('modules.personnel.inviteList.importToastErr2Text'),
          $translate.instant('modules.personnel.inviteList.importToastErrTitle'));
        } else if (response.error === 'invalid filedata') {
          toastr.error(
            (response.details && response.details.length) ?
            $translate.instant('modules.personnel.inviteList.importToastErr3Text1', { cells: response.details.join('; ') }) :
            $translate.instant('modules.personnel.inviteList.importToastErr3Text2'),
            $translate.instant('modules.personnel.inviteList.importToastErrTitle')
          );
        } else {
          toastr.error($translate.instant('modules.personnel.inviteList.importToastErr4Text'),
          $translate.instant('modules.personnel.inviteList.importToastErrTitle'));
        }
        self.uploader.clearQueue(); // remove item from queue
        $uibModalInstance.dismiss();
      },
      onWhenAddingFileFailed: function (item) {
        // ensure that only a single file (the last one added) is in the queue
        self.uploader.clearQueue();
        self.uploader.addToQueue(item);
      },
    });
    self.uploader = new FileUploader(self.uploaderConfig);

    self.downloadTemplate = function () {
      var nameSchemeType = self.type === 'local' ? 'ARNO' : 'OFFLINE';
      var nameSchemeDivision = (ctx.length && ctx[0] === 'rootOrg') ? 'ORG' : 'GL';
      window.open('/assets/templates/Mitgliederimport-' + nameSchemeType + '-' + nameSchemeDivision + '.xlsx', '_blank');
    };

    self.applyModal = function () {
      $uibModalInstance.close(self.records);
    };
  }

})();

/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.qualification', [])
    .controller('PersonnelDossierQualificationCtrl', PersonnelDossierQualificationCtrl);

  function PersonnelDossierQualificationCtrl($uibModal, $translate, permissions, member, clientApi, toastr, stateChangePrompt,
    userQualifications, choosableQualifications, availableMaterials, $state, ctx, $stateParams, $scope, $rootScope, isOwnDossier) {
    var self = this;
    self.divisionIds = _.cloneDeep(ctx);

    if (ctx.indexOf('rootOrg') > -1) {
      self.divisionIds.splice(ctx.indexOf('rootOrg'), 1); 
    }

    self.isOwnDossier = isOwnDossier;
    self.backToOverview = $stateParams.backToOverview;
    self.backToPersonnelList = $rootScope.backToPersonnelList;
    self.member = member;
    self.isRootOrgView = (ctx && ctx.length === 1 && ctx[0] === 'rootOrg');
    self.hasEditRights = !self.isRootOrgView && permissions.isPermittedInEvery('arno.personnel.dossier.qualification.manageAll', 'Division', ctx);

    self.userQualifications = userQualifications;
    self.choosableQualifications = choosableQualifications;
    if (availableMaterials && availableMaterials.get) {
      availableMaterials.get().then(function (result) {
        self.availableMaterials = result;
      });
    }
    self.changedQualifications = {
      add: [],
      edit: [],
      delete: []
    };

    self.translateValues = {
      typePlural: $translate.instant('modules.personnel.dossier.overview.allQualificationTypesNamed'),
    };

    self.changeDetectCompare = '';

    self.setAsChangeCompare = function () {
      self.changeDetectCompare = JSON.stringify([self.changedQualifications]);
    };

    self.hasChanges = function () {
      return self.changeDetectCompare !== JSON.stringify([self.changedQualifications]);
    };

    self.setAsChangeCompare();

    stateChangePrompt.evaluate(function () {
      return !self.hasChanges();
    });

    self.updateQualification = function () {
      if (self.changedQualifications && ((self.changedQualifications.add && self.changedQualifications.add.length)
        || (self.changedQualifications.edit && self.changedQualifications.edit.length)
        || (self.changedQualifications.delete && self.changedQualifications.delete.length))) {
        return clientApi
          .custom('model/MemberQualification', 'updateMemberQualifications', {
            cMemberId: self.member.id,
            qualificationChanges: self.changedQualifications,
            divisionIds: self.divisionIds,
            lastEditTime: new Date(),
          })
          .then(function () {
            toastr.success(
              $translate.instant('modules.personnel.dossier.overview.qualificationList.updateToastText', self.translateValues),
              $translate.instant('modules.personnel.dossier.overview.qualificationList.updateToastTitle', self.translateValues)
            );
            stateChangePrompt.disableEvaluation();

            $state.reload();
          })
          .catch(function () {
            toastr.error(
              $translate.instant('modules.personnel.dossier.overview.qualificationList.updateErrToastText', self.translateValues),
              $translate.instant('modules.personnel.dossier.overview.qualificationList.updateErrToastTitle', self.translateValues)
            );
          });
      } else {
        toastr.info(
          $translate.instant('modules.personnel.dossier.overview.qualificationList.noChangesToastText', self.translateValues),
          $translate.instant('modules.personnel.dossier.overview.qualificationList.noChangesToastTitle', self.translateValues)
        );
      }
    };
    self.back = function () {
      $state.go('arno.personnel.personnelList');
    };

    self.isPermitted = function (action) {
      if (ctx[0] === 'rootOrg') {
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id]);
      }
      return permissions.isPermittedInEvery(action, 'Division', ctx);
    };

    self.backOverview = function () {
      $state.go('arno.personnel.dossier.overview');
    };

    self.getShowElement = function (element) {
      switch (element) {
      case 'actions':
        return self.hasEditRights;
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.personnel.dossier.trainings.main', [])
    .controller('PersonnelDossierTrainingsController', PersonnelDossierTrainingsController);

  /**
  * @description Controller for the personnel-dossier-trainings module.
  *
  * @namespace BlurAdmin.pages.personnel.dossier.trainings.PersonnelDossierTrainingsController
  */
  /** @ngInject */
  function PersonnelDossierTrainingsController(
    $scope, $state, $stateParams,
    ctx, permissions, organizationId,
    trainings, trainingsTree, trainingCategories, member
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.TRAININGS = {
      VIEWMODE: {
        TREE: 'treeview',
        TABLE: 'tableview'
      }
    }

    // VARS
    $ctrl.selectedCtx = ctx;
    $ctrl.organizationId = organizationId;
    $ctrl.member = member;
    $ctrl.trainings = trainings;
    $ctrl.trainingsTree = trainingsTree;
    $ctrl.trainingCategories = trainingCategories;

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf PersonnelDossierTrainingsController#
    */
    function activate() {
      $ctrl.viewMode = $stateParams.recentTrainingsViewMode || $ctrl.TRAININGS.VIEWMODE.TABLE;

      getUiPermissions();
    }

    // EVENT-HANDLERS
    // REMARK: instead of setting the last view-mode over the state-param
    // you could also separate the tablepanel-view and treepanel-view into distinct states
    // and then do a hard state-go
    $ctrl.changeViewMode = function(newViewMode) {
      $ctrl.viewMode = newViewMode;
      $state.go('arno.personnel.dossier.trainings.main', {recentTrainingsViewMode: newViewMode});
    }

    // HELPERS
    function getUiPermissions() {
      $ctrl.hasViewPermission = permissions.isPermittedAnywhere('arno.personnel.dossier.trainings.view');
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }

  }
})();

/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.notAssigned', [])
    .controller('PersonnelDossierNotAssignedCtrl', PersonnelDossierNotAssignedCtrl);

  function PersonnelDossierNotAssignedCtrl(memberFallback) {
    var self = this;

    self.unknownMember = {};
    if (memberFallback) {
      self.unknownMember.fullName = memberFallback.fullName;
    }

    self.translationData = {
      memberName: self.unknownMember.fullName
    }
  }
})();

/**
 * Created by michael.sengteller on 21.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.clearance', [])
    .controller('PersonnelDossierClearanceCtrl', PersonnelDossierClearanceCtrl);

  function PersonnelDossierClearanceCtrl(
    $rootScope, $scope, $stateParams, $state, $uibModal, tableConfig, memberGroups,
    approvalProcesses, permissions, commonUtils,  ctx, organizationId, member, isOrgScope,
    permittedToStartAnyClearance, ArnoDashAdminClearancesService, allowedReferences, clientApi
  ) {
    var self = this;

    // VARS
    self.ctx = ctx;
    self.organizationId = organizationId;

    self.isOrgScope = isOrgScope;
    self.permittedToStartAnyClearance = permittedToStartAnyClearance;

    self.backToOverview = $stateParams.backToOverview;
    self.backToPersonnelList = $rootScope.backToPersonnelList;
    self.approvalProcesses = approvalProcesses;

    self.allowedReferences = allowedReferences;
    self.tableConfig = tableConfig;
    self.memberGroups = memberGroups;
    self.dossierOwnerId = member.id;
    
    // EVENT-HANDLERS
    self.isPermitted = function (action) {
      if (ctx[0] === 'rootOrg') {
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id]);
      }
      return permissions.isPermittedInEvery(action, 'Division', ctx);
    };


    self.isPermittedForApprovalProcess = function (permission, approvalProcess) {
      var permittedReferences = self.allowedReferences
        && self.allowedReferences[permission]
        && self.allowedReferences[permission][
          (approvalProcess && approvalProcess.Division && approvalProcess.Division.id || '').toString()
          ];

      return approvalProcess
        && approvalProcess.Approval
        && approvalProcess.Approval.id
        && !!~(permittedReferences || []).indexOf(approvalProcess.Approval.id);
    };

    self.approvalprocessModal = function (action, approvalprocess) {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/approvalProcessList/approvalprocessModal/' + action + 'Approvalprocess.html',
        size: 'md',
        controller: 'ApprovalprocessModalCtrl as $ctrl',
        resolve: {
          divisionId: function () {
            return parseInt(self.ctx[0]);
          },
          organizationId: function () {
            return self.organizationId;
          },
          approvals: function () {
            return ArnoDashAdminClearancesService.getClearancesForProcessList();
          },
          fixedMembers: function() {
            return true;
          },
          approvalProccessMode: function () {
            return null;
          },
          disabledApprovals: function() {
            return approvalProcesses;
          },
          divisionMembers: function () {
            return [member];
          },
          approvalprocess: function () {
            return approvalprocess || { Approval: {}, };
          },
          action: function () {
            return action || null;
          },
          isPermitted: function () {
            return self.isPermittedForApprovalProcess;
          },
          permittedDivs: function() {
            var permittedDivs = [];
            if (approvalprocess) {
              if (approvalprocess.Approval.Type === 'SIMPLE') {
                var simpleEditPerms = $rootScope.ctx.permissionsTree.permissions['arno.personnel.clearance.edit.simple'].Division;
                commonUtils.division.divisionTreeData.forEach(function(div) {
                  if (!!~simpleEditPerms.indexOf(parseInt(div.id, 10)) && div.Active) {
                    permittedDivs.push({
                      Name: div.Name,
                      id: div.id,
                    })
                  }
                })
                return clientApi.custom('model/Approval', 'checkAffectedMemberInDiv', {
                  ownDivId: self.divisionId,
                  approvalId: approvalprocess.ApprovalId,
                  divIds: permittedDivs.map(function(div) {
                    return div.id;
                  }),
                  affectedMemberId: approvalprocess.AffectedMemberId,
                })
                .then(function(res) {
                  return permittedDivs.filter(function(pdiv) {
                    return !!~res.indexOf(parseInt(pdiv.id, 10)) && pdiv.id != approvalprocess.Division.id;
                  })
                })
              } else {
                // fetch item perms for that approval
                return clientApi.custom('model/Approval', 'getApprovalStartDivisionReferences', {
                  itemReferenceId: approvalprocess.ApprovalId,
                  affectedMemberId: approvalprocess.AffectedMemberId,
                })
                .then(function(res) {
                  return res.map(function(row) {
                    return row.Division;
                  }).filter(function(div) {
                    return div.id != approvalprocess.Division.id;
                  })
                })
              }
            }
            return [];
          },
          approvalAcceptors: function () {
            return ArnoDashAdminClearancesService.getInitiatingOrEditingMembers(self.ctx[0], true)
              .catch(function () {
                return [];
              })
          }
        },
      })
        .result
        .then(function () {
          $state.reload();
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.administration')
    .controller('OnlineSwitchModalCtrl', OnlineSwitchModalCtrl);

  /** @ngInject */
  function OnlineSwitchModalCtrl($rootScope, $translate, toastr, $uibModalInstance, clientApi, data) {
    var self = this;

    self.userIdentifiers = false;
    self.newType = data.newType;
    self.oldType = data.oldType;
    self.modalInstance = $uibModalInstance;
    self.invalidInput = true;
    self.searchedUser = {};
    self.newOffline = {};

    self.selectedADUser = function (user) {
      self.userIdentifiers = {
        EMail: user.Member.Account.EMail,
        ObjectId: user.Member.id,
        newType: self.newType,
        oldType: self.oldType,
      };
      self.searchedUser = { Name: user.Member.fullName, EMail: user.Member.Account.EMail };
      self.checkForDuplicates(self.userIdentifiers);
    };

    self.finishLinking = function () {
      if (self.newType === 'offline') {
        self.userIdentifiers = {
          newType: self.newType,
          oldType: self.oldType,
          ContactEMail: self.newOffline.ContactEMail,
        }
      }
      $uibModalInstance.close( { identifier: self.userIdentifiers, duplicate: self.duplicate } );
    };

    self.azureDuplicateCheck = function (userIdentifiers) {
      clientApi.custom('model/LoginAzureAd', 'checkForAdDuplicates', { identifiers: userIdentifiers })
        .then(function (beHint) {
          self.duplicate = beHint.duplicate;
          if (beHint.duplicate) {
            self.userIdentifiers = false;
          }
        });
    };

    self.arnoDuplicateCheck = function (mail) {
      // test for proper mail input, otherwise the backend will throw us errors
      var regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (regex.test(mail)) {
        clientApi.custom('model/Account', 'hasMemberByEMail', { eMail: mail })
        .then(function (beHint) {
          if(!beHint){
            self.userIdentifiers = {
              EMail: mail,
              newType: self.newType,
              oldType: self.oldType,
            };
          }
          self.invalidInput = beHint;
          self.duplicate = beHint;
        });
      } else {
        self.invalidInput = true;
        self.duplicate = false;
      }
    };

    self.checkForDuplicates = function (param) {
      if (param) {
        switch (self.newType) {
        case 'azure':
          self.azureDuplicateCheck(param);
          break;
        case 'local':
          self.arnoDuplicateCheck(param);
          break;
        default:
          toastr.error(
            $translate.instant('modules.personnel.dossier.administration.changeAccountType.errModalText', { type: self.newType }),
            $translate.instant('modules.personnel.dossier.administration.changeAccountType.errModalTitle')
          );
        }
      }
    };

    self.clearAzureSearch = function() {
      self.searchedUser = false;
      self.userIdentifiers = false;
      self.duplicate = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.demandForAction', ['angularFileUpload'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.demandForAction', {
        url: '/demandForAction',
        templateUrl: 'app/pages/personnel/demandForAction/demandForAction.html',
        title: 'navigation.personnel.demandForAction',
        controller: 'DemandForActionCtrl as $ctrl',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.personnel.privacyTerms.manage',
            });
          },
          ctxHH: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              allowOrgSelection: false,
              entryPermission: 'arno.personnel.helperHours.approve',
            });
          },
          findMembersWithDemandForAction: function (clientApi, ctx, commonUtils) {
            return function (self, params, optOverride) {
              if (!ctx.length) {
                return {};
              }
              var opts = optOverride || {
                countAll: true,
                limit: self.pageSize,
                offset: (params.pagination.start / params.pagination.number) * self.pageSize || 0,
                filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
                sort: {
                  by: params.sort.predicate,
                  reverse: params.sort.reverse
                }
              };
              return clientApi
                .custom('model/PrivacyTerms', 'findMembersWithDemandForAction', {
                  ctx: ctx,
                  options: opts
                })
                .then(function (result) {
                  result.opts = opts;
                  return result;
                });
            };
          },
          originRequest: function (findMembersWithDemandForAction) {
            // params as if smart table would initially load page
            return findMembersWithDemandForAction(
              { pageSize: 10 },
              {
                sort: { predicate: 'FirstName', reverse: false },
                search: {},
                pagination: { start: 0, totalItemCount: 0, number: 20, numberOfPages: null }
              }
            );
          },
          openPromises: function (clientApi) {
            return clientApi.custom('model/PrivacyTerms', 'openPromises');
          },
        },
        sidebarMeta: {
          order: 5,
        },
        viewPermission: ['arno.personnel.privacyTerms.manage', 'arno.personnel.helperHours.approve'],
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.demandForAction')
    .controller('DemandForActionImportSelectionModalCtrl', DemandForActionImportSelectionModalCtrl);

  /** @ngInject */
  function DemandForActionImportSelectionModalCtrl($translate, ctx, FileUploader, toastr, clientApi, $uibModalInstance) {
    var self = this;

    self.uploaderConfig = clientApi.fileUploaderConfig({
      autoUpload: true,
      queueLimit: 1,
      url: '/api/personnel/uploaddemandforaction?ctx=' + ctx[0],
      onSuccessItem: function (item, response) {
        if (response.ids && response.ids.length) {
          $uibModalInstance.close(response.ids);
          return;
        }
        toastr.info(
          $translate.instant('modules.personnel.demandForAction.importModalSuccToastText'),
          $translate.instant('modules.personnel.demandForAction.importModalSuccToastTitle')
        );

        self.uploader.clearQueue();
        $uibModalInstance.dismiss();
      },
      onErrorItem: function () {
        toastr.error(
          $translate.instant('modules.personnel.demandForAction.importModalErrToastText'),
          $translate.instant('modules.personnel.demandForAction.importModalErrToastTitle')
        );
        self.uploader.clearQueue();
        $uibModalInstance.dismiss();
      },
      onWhenAddingFileFailed: function (item) {
        // ensure that only a single file (the last one added) is in the queue
        self.uploader.clearQueue();
        self.uploader.addToQueue(item);
      },
    });
    self.uploader = new FileUploader(self.uploaderConfig);
  }
})();

/* eslint-disable indent */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview', [])
    .controller('MaterialOverviewCtrl', MaterialOverviewCtrl);

  function MaterialOverviewCtrl($state, $location, clientApi, commonUtils, divisionId, $uibModal, toastr, tableConfig, $rootScope, permissions,
    baModalService, $scope, materialUtil, stateChangePrompt, $translate, ArnoDashMaterialsService, $stateParams, screenSize) {
    var self = this;
    self.isLoading = true;
    if (!tableConfig) {
      return;
    }
    var stateMap = {
      'arno.material.overview.medicine': {
        material: 'MaterialMedicine',
        category: 'medicine',
      },
      'arno.material.overview.vehicles': {
        material: 'MaterialVehicles',
        category: 'vehicles',
      },
      'arno.material.overview.clothing': {
        material: 'MaterialClothing',
        category: 'clothing',
      },
      'arno.material.overview.tools': {
        material: 'MaterialTools',
        category: 'tools',
      },
      'arno.material.overview.consumables': {
        material: 'MaterialConsumables',
        category: 'consumables',
      },
      'arno.material.overview.other': {
        material: 'MaterialOthers',
        category: 'others',
      },
      'arno.material.overview.medicalProducts': {
        material: 'MaterialMedicalProducts',
        category: 'medicalProducts',
      },
    };

    self.aKeys = { on: $translate.instant('navigation.material.activeMaterials'), off: $translate.instant('navigation.material.allMaterials') };
    self.modelMap = materialUtil.materialModelMap;
    self.storageIconMap = materialUtil.materialStorageIconMap;
    var preservedTableQueryparams;
    var preservedQueryWish = {};
    self.active = true;
    self.splitEdit = {};
    self.isMultiDiv = divisionId && Array.isArray(divisionId) && divisionId.length > 1;
    self.propTypes = materialUtil.propTypes;
    self.currentTableHead = [];
    self.matData = [];
    self.currentMaterial = stateMap[$state.current.name].material;
    self.currentCategory = stateMap[$state.current.name].category;
    self.currentPropSet = self.propTypes[self.currentMaterial];
    self.sortableFields = [];
    self.preflanguange = $translate.preferredLanguage();
    self.generateSortFields = function () {
      tableConfig.tableConfigAvailableFields.forEach(function (field) {
        self.sortableFields.push({
          fieldName: field.prop,
          sortProp: field.prop
        });
      });
    };

    self.mediaSizeSM = screenSize.on('sm', function (match) {
      self.mediaSizeSM = match;
    });
    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });

    self.currentSize = screenSize.get();


    self.generateSortFields();
    var matView = commonUtils.preference.object.get('pref_current_material_list_view_' + self.currentMaterial, '0');
    self.tableViewsMaterial = {};

    // show title on cells that are cut by ellipsis
    $(document).on('mouseenter', '.overflow-title', function () {
      var $t = $(this);
      var title = $t.attr('title');
      if (!title) {
        if (this.offsetWidth < this.scrollWidth) {
          $t.attr('title', $t.text());
        }
      } else {
        if (this.offsetWidth >= this.scrollWidth && title == $t.text()) {
          $t.removeAttr('title');
        }
      }
    });

    var matTableConf = tableConfig.tableConfigDefault;
    if (matView.id) {
      var selectedView = _.find(tableConfig.tableConfigCustomPreference, function (view) {
        return view.id == matView.id;
      });
      if (selectedView) {
        matTableConf = JSON.parse(selectedView.Fields);
      } else {
        matView = '0';
      }
    }

    var getCurrentTableView = function () {
      if (self.currentTableConf.hasViewModifications) {
        return self.currentTableConf.tmp;
      } else if (self.currentTableConf.selectedView !== '0') {
        return self.currentTableConf.customViews[self.currentTableConf.selectedView];
      }
      return self.currentTableConf.defaultView;
    };

    self.setPageSize = function (num) {
      self.itemsPerPage = commonUtils.getPageSize('mat_list_page_size', num);
    };
    self.setPageSize();

    self.applyFieldConfig = materialUtil.applyFieldConfig;

    self.addAgg = function (agg, event) {
      if (event) {
        event.stopPropagation();
      }

      if (self.currentTableConf.selectedView) {
        var view = getCurrentTableView();
        // if we add an aggregation, it modifies the current view
        // treat it as such, so that it doesn't alter the actual configs
        if (!self.currentTableConf.hasViewModifications) {
          self.currentTableConf.hasViewModifications = true;
          self.currentTableConf.tmp = JSON.parse(JSON.stringify(view));
          view = self.currentTableConf.tmp;
        }
        if (!view.Aggregations) {
          view.Aggregations = {};
        }
        if (!view.Aggregations[agg]) {
          view.Aggregations[agg] = true;
        } else {
          delete view.Aggregations[agg];
        }
      }

      self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
    };

    self.checkActiveAggs = function (prop) {
      return materialUtil.checkActiveAggregations(prop, getCurrentTableView());
    };
    self.checkAggExcludes = materialUtil.checkAggregateExcludes;

    self.searchableCheck = function (header) {
      return materialUtil.searchableCheck(self.currentPropSet, header);
    };

    self.isPermitted = function (action) {
      return permissions.isPermittedInEvery(action, 'Division', divisionId, true);
    };

    self.currentTableConf = {
      title: 'Materialansicht',
      active: true,
      selectedView: matView.id || matView,
      isOrgList: false,
      tableConfig: matTableConf,
      customViews: self.tableViewsMaterial,
      defaultView: {
        Fields: tableConfig.tableConfigDefault,
      },
      ctx: divisionId,
    };

    self.parseDate = function (date) {
      return materialUtil.parseDate(date, getCurrentTableView());
    };

    self.boolFormatter = materialUtil.boolFormatter;

    self.handleCustomLists = function (customTableConfigs) {
      // preserve an unreferenced config
      tableConfig.tableConfigCustomPreference = JSON.parse(JSON.stringify(customTableConfigs));

      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        conf.initialSort = true;
        conf.Aggregations = JSON.parse(conf.Aggregations);
        self.tableViewsMaterial[conf.id] = conf;
      });
    };
    self.handleCustomLists(tableConfig.tableConfigCustomPreference);

    self.changeListView = function (list, val, storageIdentifier) {
      // restore original config values and then switch view
      self.handleCustomLists(tableConfig.tableConfigCustomPreference);
      delete self.currentTableConf.defaultView.Aggregations;
      self.currentTableConf.hasViewModifications = false;
      delete self.currentTableConf.tmp;
      if (val === '0') {
        list.tableConfig = JSON.parse(JSON.stringify(list.defaultView.Fields));
      } else {
        list.tableConfig = JSON.parse(JSON.stringify(val.Fields));
      }
      list.selectedView = storageIdentifier;
      storeTableConfig(list);
      if (preservedTableQueryparams.search && preservedTableQueryparams.search.predicateObject) {
        preservedTableQueryparams.search.predicateObject = {};
      }
      return self.reloadMaterial(preservedTableQueryparams, null, list, true);
    };

    function storeTableConfig(list) {
      if (list.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_material_list_view_' + self.currentMaterial);
      } else {
        commonUtils.preference.object.set(
          'pref_current_material_list_view_' + self.currentMaterial, {
          id: list.selectedView
        }
        );
      }
    }

    self.reloadMaterial = function (stParams, stCtrl, currTableConfig, wipeTableSort) {
      if (stParams) {
        if (!stParams.search.predicateObject) {
          stParams.search.predicateObject = {};
        }
        if (self.active) {
          stParams.search.predicateObject.Active = '1';
        } else {
          delete stParams.search.predicateObject.Active;
        }
      }

      if (!currTableConfig) {
        currTableConfig = self.currentTableConf;
      }
      var promise = Promise.resolve();
      if (self.splitMode) {
        // if we're in split edit mode, just return our split datasets
        var splitRows = [];
        Object.keys(self.splitEdit.splitRows).forEach(function (rowKey) {
          splitRows.push(self.splitEdit.splitRows[rowKey]);
        });

        // sorting and filtering can be done on FE side, as we only have temporary data anyway
        if (stParams) {
          if (stParams.search && stParams.search.predicateObject) {
            Object.keys(stParams.search.predicateObject).forEach(function (key) {
              splitRows = splitRows.filter(function (row) {
                if (row[key]) {
                  return row[key].toString().toLowerCase().indexOf(stParams.search.predicateObject[key].toLowerCase()) > -1;
                }
                return null;
              });
            });
          }
          if (stParams.sort) {
            splitRows = _.sortBy(splitRows, stParams.sort.predicate);
            if (stParams.sort.reverse) {
              splitRows = splitRows.reverse();
            }
          }
        }
        promise = Promise.resolve(splitRows);
      } else {
        var queryWishes = {};
        if (currTableConfig) {
          if (currTableConfig.selectedView) {
            var view = getCurrentTableView();
            if (view.Sort && (!stParams || (stParams && !stParams.sort))) {
              Object.keys(view.Sort).forEach(function (key) {
                queryWishes.sort = {
                  by: view.Sort[key].sortProp,
                  reverse: view.Sort[key].direction === 'desc',
                };
              });
            }

            materialUtil.addAggToQW(view, queryWishes);
            materialUtil.addNonAggToQW(view, queryWishes);
          }
          if (stParams) {
            if (wipeTableSort) {
              stParams.sort = {};
            }




            if (stParams.search && stParams.search.predicateObject) {
              materialUtil.handleSTSearchParams(stParams, queryWishes, self.currentPropSet);
            }
            if ((!stParams.sort || !stParams.sort.predicate) && view.Sort && view.initialSort) {
              Object
                .keys(view.Sort)
                .forEach(function (key) {
                  stParams.sort.predicate = key;
                  stParams.sort.reverse = view.Sort[key].direction !== 'asc';
                });
              view.initialSort = false;
            }
            if (stParams.sort) {
              queryWishes.sort = {
                by: stParams.sort.predicate,
                reverse: stParams.sort.reverse
              };
            }
            if (stParams.pagination) {
              queryWishes.paging = {
                offset: (stParams.pagination.start / stParams.pagination.number) * self.itemsPerPage || 0,
                limit: self.itemsPerPage
              };
            }
            preservedTableQueryparams = stParams;
          }
        }

        // save this queryWish so we can accurately request the current view as export
        queryWishes.visibleNonAgg[queryWishes.visibleNonAgg.length] = 'Active';
        preservedQueryWish = queryWishes;
        promise = clientApi.custom('model/' + self.currentMaterial, 'getMaterial', {
          divisionId: divisionId,
          queryWishes: queryWishes
        });
      }

      return promise
        .then(function (res) {
          $scope.$evalAsync(function () {
            self.matData.splice(0, self.matData.length);
            Array.prototype.push.apply(self.matData, res.count && res.rows && !self.splitMode ? res.rows : res);
            self.isLoading = false;
            var resKeys;
            if (res && res.length) {
              resKeys = Object.keys(res[0]);
            }
            if (Array.isArray(res.count)) {
              // aggregated count results, just count how many we have in here for the number we need...
              res.count = res.count.length;
            }
            if (stParams && stParams.pagination && !self.splitMode) {
              stParams.pagination.numberOfPages = Math.ceil(res.count / self.itemsPerPage);
              if (res.count > 0 && res.rows.length === 0) {
                stParams.pagination.start = (stParams.pagination.numberOfPages * self.itemsPerPage) - self.itemsPerPage;
              }
            }
            self.currentTableHead = tableConfig.tableConfigAvailableFields.filter(function (field) {
              field.label = $translate.instant('models.' + self.currentMaterial + '.' + field.prop);
              if (self.currentTableConf.tableConfig[field.prop]) {
                return !resKeys || (resKeys && !!~resKeys.indexOf(field.prop));
              }
              return false;
            });
          });
        });

    };

    self.startExport = function () {
      $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/export/chooseMaterialExportType.html',
          size: 'md',
          controller: 'MaterialChooseExportTypeCtrl as $chooseExportTypeCtrl',
        })
        .result
        .then(function (res) {
          clientApi.openTab('material/export', {
            divisionId: divisionId,
            queryWish: res.options.filter === 'all' ? '' : JSON.stringify(preservedQueryWish),
            materialType: self.currentMaterial,
            tableHead: res.options.fields === 'all' ?
              JSON.stringify(tableConfig.tableConfigAvailableFields.map(function (head) {
                return head.prop;
              })) : JSON.stringify(self.currentTableHead.map(function (head) {
                return head.prop;
              })),
            format: res.filetype
          }, { post: true });

          toastr.success($translate.instant('modules.material.overview.DownloadStarted'), $translate.instant('modules.material.overview.ExportStarted'));
        });
    };
    self.startInventoryExport = function () {
      $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/export/inventoryExport.html',
          size: 'md',
          controller: 'InventoryExportCtrl as $inventoryExportCtrl',
          resolve: {
            basicFields: function () {
              return tableConfig.tableConfigAvailableFields;
            },
            businessPartnerFields: function () {
              return clientApi.custom('model/BusinessPartner', 'getTableConfigColumns');
            }
          }
        })
        .result
        .then(function (res) {
          clientApi.openTab('material/export', {
            divisionId: divisionId,
            materialType: self.currentMaterial,
            queryWish: '',
            tableHead: JSON.stringify(res.selectedFields.map(function (head) {
              return head.prop;
            })),
            lookupTablesHead: JSON.stringify(res.lookupTablesHead),
            format: res.filetype
          }, { post: true });

          toastr.success($translate.instant('modules.material.overview.DownloadStarted'), $translate.instant('modules.material.overview.ExportStarted'));
        });
    };
    self.allowedInventoryExport = function () {
      return self.currentMaterial === 'MaterialMedicine'
        || self.currentMaterial === 'MaterialTools'
        || self.currentMaterial === 'MaterialVehicles'
        || self.currentMaterial === 'MaterialMedicalProducts';
    };
    self.handleMaterialRemove = function (material) {
      return clientApi
        .custom('model/' + self.currentMaterial, 'deleteMaterial', {
          divisionId: divisionId,
          ids: material.id ? [material.id] : material.map(function (mat) {
            return mat.id;
          })
        })
        .then(function (result) {
          if (result.isStillPermitted === false && !result.refusal) {
            $state.go('arno.dashboard', {}, { reload: true });
            return { abort: true };
          }
          if (result.conflict) {
            return baModalService
              .messageModal({
                modalType: 'warning',
                allowHtml: false,
                title: $translate.instant('modules.material.overview.removalConflict.title'),
                content: $translate.instant(
                  'modules.material.overview.removalConflict.body',
                  {
                    matPlural: Array.isArray(material) && material.length > 1,
                    evtPlural: result.conflicts.length > 1,
                    potentiallyLimited: result.potentiallyLimited,
                    eventList: result.conflicts
                      .map(function (conflict) {
                        var conflictMeta = _.compact([
                          $translate.instant('modules.material.overview.removalConflict.' + conflict.type),
                          (conflict.SourceDivision || {}).Name,
                          (conflict.Organizer || {}).fullName,
                        ]).join(', ');
                        return conflict.Subject + ' (' + conflictMeta + ')';
                      })
                      .join('\n')
                  }
                ),
                secondaryActionText: $translate.instant('generalTerms.cancel'),
              });
          }
        })
        .then(function (res) {
          if (res && (res || {}).abort) {
            return;
          }
          toastr.success(
            $translate.instant(
              'modules.material.overview.MaterialDeletedSucess'),
            $translate.instant('modules.material.overview.MaterialDeleted')
          );
          self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
        });
    };



    self.migrate_responsible_to_handover = function () {

      var materialLimit = 10;
      var isResponsibleMemberDeleted = true;

      return $uibModal.open({
        controller: 'MigrateResponsibleToHandoverModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/material/overview/migrate-responsible-to-handover/migrate-responsible-to-handover.html',
        size: 'md',
        resolve: {
          materialLimit: function () {
            return materialLimit;
          },
          isResponsibleMemberDeleted: function () {
            return isResponsibleMemberDeleted;
          },
        }
      })
        .result
        .then(function (result) {
          return clientApi.custom('model/' + self.currentMaterial, 'migrateResponsiblePerson', {
            divisionId: divisionId,
            materialLimit: result.materialLimit,
            isResponsibleMemberDeleted: result.isResponsibleMemberDeleted,
          }).then(function () {
            self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
          }).catch(function (err) {
            console.error(err);
          });
        });
    };

    self.deleteMaterial = function (material) {
      var title;
      var storageMaterials = [];
      if (material && material.length === 1) {
        material = material[0];
      }
      if (!Array.isArray(material)) {
        title = $translate.instant(
          'modules.material.overview.deleteModalTitle',
          {
            material: (material.Definition || material.VehicleModel || material.Name || 'Material'),
          });
        if (self.checkIfStorageLocation(material)) {
          storageMaterials.push(material.Definition || material.VehicleModel || material.Name);
        }
      } else {
        title = material.length + $translate.instant('modules.material.overview.deleteMaterials');
        material.forEach(function (mat) {
          if (self.checkIfStorageLocation(mat)) {
            storageMaterials.push(mat.Definition || mat.VehicleModel || mat.Name);
          }
        });
      }
      // none or multiple selected materials are storage locations
      // notify with a hint to check them
      if (storageMaterials.length !== 1 || (storageMaterials.length === 1 && Array.isArray(material) && material.length > 1)) {
        return $uibModal
          .open({
            animation: true,
            templateUrl: 'app/pages/material/overview/deleteModal/deleteMaterial.html',
            size: 'md',
            backdrop: 'static',
            controller: 'MaterialDeleteCtrl as $delCtrl',
            resolve: {
              storageMaterials: function () {
                return storageMaterials;
              },
              material: function () {
                return material;
              },
              title: function () {
                return title;
              },
            }
          })
          .result
          .then(function () {
            return self.handleMaterialRemove(material);
          })
          .catch(function (err) {
            if (err && err.action !== 'BA_MODAL_SECONDARY_BTN_CLICKED') {
              toastr.error(
                $translate.instant('modules.material.overview.MaterialDeletedFailed'),
                $translate.instant('modules.material.overview.DeletedFailed')
              );
            }
          });
      } else {
        // only the one material that is selected is a storage location
        // open detail modal with deletion confirmation
        return $uibModal
          .open({
            animation: true,
            templateUrl: 'app/pages/material/storageDetails/storageDetails.html',
            size: 'md',
            backdrop: 'static',
            controller: 'MaterialStorageDetailsCtrl as $storageCtrl',
            resolve: {
              material: function () {
                return material;
              },
              storageIconMap: function () {
                return self.storageIconMap;
              },
              modelMap: function () {
                return self.modelMap;
              },
              deleteHint: function () {
                return true;
              }
            }
          })
          .result
          .then(function (res) {
            if (res) {
              return self.handleMaterialRemove(material);
            }
          })
          .catch(function (err) {
            if (err && !err === 'escape key press') {
              toastr.error(
                $translate.instant('modules.material.overview.MaterialDeletedFailed'),
                $translate.instant('modules.material.overview.DeletedFailed')
              );
            }
          });
      }
    };

    self.precisionSelect = function (material, preSelect, multiSelect) {
      var preFetch = function () {
        if (self.currentTableConf.selectedView) {
          var view = getCurrentTableView();
          var queryWishes = {};
          queryWishes.where = {};
          queryWishes.aggWhere = {};
          queryWishes.exact = true;
          if (view.Aggregations) {
            Object.keys(view.Aggregations).forEach(function (aggKey) {
              if (aggKey === 'LicenseClass') {
                queryWishes.reFetch = true;
                queryWishes.aggWhere['$LicenseClass.Name$'] = material[aggKey];
              } else if (aggKey === 'ResponsibleMember') {
                queryWishes.reFetch = true;
                queryWishes.aggWhere.ResponsibleMemberId = material.ResponsibleMemberId;
              } else {
                queryWishes.aggWhere[aggKey] = material[aggKey];
              }
            });
          }
          queryWishes.visibleNonAgg = tableConfig.tableConfigAvailableFields.map(function (field) {
            return field.prop;
          });
          if (preservedTableQueryparams && preservedTableQueryparams.search && preservedTableQueryparams.search.predicateObject) {
            materialUtil.handleSTSearchParams(preservedTableQueryparams, queryWishes, self.currentPropSet);
          }

          return clientApi.custom('model/' + self.currentMaterial, 'getMaterial', {
            divisionId: divisionId,
            queryWishes: queryWishes
          })
            .then(function (res) {
              var obj = {};
              var uniqProps = [];

              // find out what rows have unique values so the user has an easier time picking the right entry
              res.rows.forEach(function (row) {
                Object.keys(row).forEach(function (key) {
                  if (!obj[key]) {
                    obj[key] = [];
                  }
                  obj[key].push(row[key]);
                });
              });

              Object.keys(obj).forEach(function (key) {
                if (_.uniq(obj[key]).length > 1) {
                  uniqProps.push(key);
                }
              });

              self.currentTableHead.forEach(function (head) {
                // eslint-disable-next-line no-extra-boolean-cast
                if (!~uniqProps.indexOf(head.prop)) {
                  uniqProps.push(head.prop);
                }
              });
              return { data: res.rows, uniqProps: uniqProps };
            });
        }
        return Promise.resolve();
      };
      return preFetch()
        .then(function (fetchVals) {
          if (fetchVals && fetchVals.data && fetchVals.data.length === 1) {
            return fetchVals.data;
          }
          return $uibModal
            .open({
              animation: true,
              templateUrl: 'app/pages/material/precisionSelectModal/precisionSelect.html',
              size: 'lg',
              backdrop: 'static',
              controller: 'SelectCtrl as $selectCtrl',
              resolve: {
                fullDataset: function () {
                  return fetchVals.data;
                },
                currentTableHead: function () {
                  if (fetchVals && fetchVals.uniqProps) {
                    return tableConfig.tableConfigAvailableFields.filter(function (field) {
                      return !!~fetchVals.uniqProps.indexOf(field.prop);
                    });
                  }
                  return self.currentTableHead;
                },
                currentPropSet: function () {
                  return self.currentPropSet;
                },
                preSelect: function () {
                  return preSelect && multiSelect;
                },
                multiSelect: function () {
                  return multiSelect;
                }
              }
            })
            .result;
        });
    };

    self.prepareDelete = function (material) {
      if (material && material.id) {
        self.deleteMaterial(material);
      } else {
        // aggregated material, open dialog with selection option
        self.precisionSelect(material, true, true)
          .then(function (res) {
            self.deleteMaterial(res);
          });
      }
    };

    self.openTableConfig = function (currentConf) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return currentConf.isOrgList;
            },
            isMaterialList: function () {
              return true;
            },
            aggExclusion: function () {
              return materialUtil.aggregateExcludes;
            },
            sortableFields: function () {
              return self.sortableFields;
            },
            availableFields: function () {
              var cleanFieldsPerView = function (fieldArr) {
                fieldArr.forEach(function (prop) {
                  var obj = _.find(fields, {
                    'prop': prop
                  });
                  if (obj) {
                    fields.splice(fields.indexOf(obj), 1);
                  }
                });
              };
              var fields = JSON.parse(JSON.stringify(tableConfig.tableConfigAvailableFields));
              cleanFieldsPerView(['id', 'DivisionId']);
              return fields;
            },
            currentList: function () {
              return {
                'current': currentConf.tableConfig
              };
            },
            availableLists: function () {
              return JSON.parse(JSON.stringify(currentConf.customViews));
            }
          },
        })
        .result
        .then(function (res) {
          if (!res) {
            return;
          }
          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;
          if (res.modifiedCurrentList) {
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;
            currentConf.tmp = { Fields: res.modifiedCurrentList };
          }
          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  self.changeListView(currentConf, '0', '0');
                }
                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id,
                    divisionId: divisionId
                  })
                  .then(function () {
                    toastr.success(
                      $translate.instant('modules.material.overview.theList')
                      + list.ListName
                      + $translate.instant('modules.material.overview.theListHasBeenDeleted'),
                      $translate.instant('modules.material.overview.listDeleted')
                    );
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }
          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (!currentConf.hasViewModifications && (val.id && val.id === JSON.parse(currentConf.selectedView))) {
                currentConf.tableConfig = _.merge(currentConf.tableConfig, val.Fields);
              }
              customLists.push({
                id: val.id || false,
                ListType: 'materialList' + self.currentMaterial,
                ListName: val.Name,
                Fields: val.Fields,
                Sort: val.Sort,
                Aggregations: val.Aggregations,
              });
              newListAdded = !val.id ? true : newListAdded;
            });
            if (customLists.length > 0) {
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: divisionId
                })
                .then(function () {
                  customLists.forEach(function (list) {
                    if (list.id) {
                      toastr.success(
                        $translate.instant('modules.material.overview.theList')
                        + list.ListName
                        + $translate.instant('modules.material.overview.theListHasBeenSaved'),
                        $translate.instant('modules.material.overview.listSaved')
                      );
                    }
                  });
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'materialList' + self.currentMaterial,
                      divisionId: divisionId
                    })
                    .then(function (lists) {
                      self.handleCustomLists(lists);
                      if (newListAdded) {
                        var maxId = Math.max.apply(Math, Object.values(_.mapValues(lists, function (l) { return l.id; })));
                        var newList = Object.values(_.pickBy(lists, function (list) {
                          return list.id == maxId;
                        }))[0];
                        self.changeListView(currentConf, newList, maxId);
                      }
                      self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
                    });
                });
            } else {
              self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
            }
          }
        })
        .catch(function (err) {
          if (err && !err === 'escape key press') {
            toastr.error($translate.instant('modules.material.overview.ListCouldNotBeCreated'), $translate.instant('modules.material.overview.ChangeFailed'));
          }
        });
    };

    self.openStorageDetailModal = function (material) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/storageDetails/storageDetails.html',
          size: 'md',
          backdrop: 'static',
          controller: 'MaterialStorageDetailsCtrl as $storageCtrl',
          resolve: {
            material: function () {
              return material;
            },
            storageIconMap: function () {
              return self.storageIconMap;
            },
            modelMap: function () {
              return self.modelMap;
            },
            deleteHint: function () {
              return false;
            }
          }
        });
    };

    self.checkIfStorageLocation = function (material) {
      if (material.MaterialMedicineStorageContent ||
        material.MaterialToolsStorageContent ||
        material.MaterialOthersStorageContent ||
        material.MaterialVehiclesStorageContent ||
        material.MaterialConsumablesStorageContent ||
        material.MaterialMedicalProductsStorageContent ||
        material.MaterialClothingStorageContent
      ) {
        return true;
      }
      return false;
    };

    self.openAddModal = function (origMat, mode, isStorage) {
      ArnoDashMaterialsService.openAddModal(
        origMat,
        mode,
        isStorage,
        divisionId,
        self.currentMaterial,
        {
          view: getCurrentTableView(),
          reloadMaterial: self.reloadMaterial,
          pqp: preservedTableQueryparams,
          splitIntermediate: self.splitEdit
        },
        true
      );
    };

    self.UpdateState = function (material, state) {

      material.Active = state;

      var ret = {
        toCreate: [],
        toUpdate: [material],
        originMaterialId: material.id,
      };

      return clientApi.custom('model/' + self.currentMaterial, 'saveMaterial', {
        divisionId: divisionId,
        data: ret,
        mode: 'upsert'
      })
        .then(function () {
          toastr.success(
            $translate.instant('modules.material.overview.MaterialStateUpdated'),
            $translate.instant('modules.material.overview.MaterialStateUpdated')
          );
          self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.material.overview.MaterialStateUpdated'),
            $translate.instant('modules.material.overview.MaterialStateUpdated')
          );
        });
    };

    self.handOverMaterial = function (material) {
      $scope.path = $location.path();
      var newState = $scope.path.replace(/\//g, '.');
      newState = 'arno'.concat(newState.replace(/\.$/, ''));
      $state.go(newState, { materialId: material.id, tab: 8 });

    };

    self.splitMaterial = function (material) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/material/splitCountModal/splitMaterial.html',
        size: 'md',
        backdrop: 'static',
        controller: 'SplitMaterialCtrl as $splitMaterialCtrl',
        resolve: {
          material: function () {
            return material;
          }
        },
      }).result.then(function (result) {
        return clientApi.custom('model/' + self.currentMaterial, 'getMaterial', {
          divisionId: divisionId,
          queryWishes: {
            where: { id: material.id },
            visibleNonAgg: tableConfig.tableConfigAvailableFields.map(function (field) {
              return field.prop;
            })
          }
        }).then(function (dbMaterialResult) {
          var dbMaterial = dbMaterialResult.rows[0];
          var create = Object.assign({}, dbMaterial);
          delete create.id;
          create.Amount = result.amount;
          var update = Object.assign({}, dbMaterial);
          update.Amount = material.Amount - result.amount;

          return clientApi.custom('model/' + self.currentMaterial, 'splitMaterial', {
            divisionId: divisionId,
            itemId: material.id,
            options: {
              splitAmount: result.amount,
              duplicateFiles: result.isFile,
              duplicateEvents: result.isEvent,
            }
          }).then(function (result) {
            return result[0];
          });
        });
      }).then(function (id) {
        return clientApi.custom('model/' + self.currentMaterial, 'getMaterial', {
          divisionId: divisionId,
          queryWishes: {
            where: { id: id }, visibleNonAgg: tableConfig.tableConfigAvailableFields.map(function (field) {
              return field.prop;
            })
          }
        });
      }).then(function () {
        self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
      }).catch(function (err) {
        console.error(err);
      });
    };

    self.checkOrigEntry = function (material) {
      if (material.id === undefined) {
        return false;
      } else {
        return !!~material.id;
      }
    };

    $scope.$watch(function () {
      return self.active;
    }, function (newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal))
        self.reloadMaterial(preservedTableQueryparams, null, self.currentTableConf);
    }, true);

    // eval state param
    if ($stateParams && $stateParams.materialId) {
      ArnoDashMaterialsService.openAddModal(
        { id: $stateParams.materialId },
        'update',
        false,
        divisionId,
        self.currentMaterial,
        {
          view: getCurrentTableView(),
          reloadMaterial: self.reloadMaterial,
          pqp: preservedTableQueryparams,
          splitIntermediate: self.splitEdit
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MigrateResponsibleToHandoverModalCtrl', MigrateResponsibleToHandoverModalCtrl);

  /** @ngInject */
  function MigrateResponsibleToHandoverModalCtrl(
    $scope,
    $timeout,
    $uibModalInstance,
    materialLimit,
    isResponsibleMemberDeleted
  ) {
    var self = this;
    self.materialLimit = materialLimit || 10;
    self.isResponsibleMemberDeleted = isResponsibleMemberDeleted || true;

    self.applyModal = function () {

      $uibModalInstance.close({
        materialLimit: self.materialLimit,
        isResponsibleMemberDeleted: self.isResponsibleMemberDeleted
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialDeleteCtrl', MaterialDeleteCtrl);

  function MaterialDeleteCtrl(storageMaterials, material, title) {
    var self = this;
    self.storageMaterials = storageMaterials;
    self.material = material;
    self.title = title;
    self.centerContent = !(self.storageMaterials && self.storageMaterials.length);
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialQualificationModalCtrl', MaterialQualificationModal);

  function MaterialQualificationModal($scope, $rootScope, $uibModal, $state, $uibModalInstance, viewOnly, materialQualifications, flatQualificationHierarchy) {
    var self = this;

    self.viewOnly = viewOnly;
    self.materialQualifications = materialQualifications;
    self.flatQualificationHierarchy = flatQualificationHierarchy;

    self.displayKeepOrDeleteQualificationBtn = function (qualification) {
      return !qualification.pendingAction || !!~['edit', 'delete'].indexOf(qualification.pendingAction);
    };

    self.onQualificationPendingDelete = function (qualification) {
      _.remove(self.materialQualifications, function (q) {
        return q.Qualification.id === qualification.Qualification.id;
      })
    }

    self.onQualificationDelete = function (qualification) {
      if (qualification.pendingAction === 'edit') {
        var originalEntry = self.originalMaterialQualifications.find(function (q) {
          return q.Qualification.id === qualification.Qualification.id;
        });
        qualification = Object.assign(qualification, originalEntry);
        qualification.pendingAction = '';
      } else {
        qualification.pendingAction = qualification.pendingAction ? null : 'delete';
      }
    }
  
    self.openQualificationModal = function (mode, qualification) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/addMaterialModal/materialQualificationModal/materialQualificationAddModal.html',
          controller: 'MaterialQualificationAddModalCtrl as self',
          size: 'md',
          backdrop: 'static',
          resolve: {
            flatQualificationHierarchy: function () {
              return self.flatQualificationHierarchy;
            },
            data: function () {
              return qualification;
            },
            mode: function () {
              return mode;
            }
          }
        }).result
        .then(function (result) {
          if (!result.mode || !result.data) {
            return;
          }

          if(!result.data.pendingAction || result.data.pendingAction !== 'add') {
            // prevent overwrite of 'add' with 'edit'
            result.data.pendingAction = result.mode;
          }

          if (result.mode === 'add') {
            self.materialQualifications.push(result.data);
          } else if (result.mode === 'edit') {
            var index = self.materialQualifications.findIndex(function (entry) {
              return entry.Qualification.id === result.data.id;
            });
            self.materialQualifications[index] = result.data;
          }
        })
    }

    self.applyModal = function () {
      $uibModalInstance.close({
        materialQualifications: self.materialQualifications,
      });
    }
  }
   
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller(
      'MaterialQualificationDocumentModalCtrl',
      MaterialQualificationDocumentModal
    );

  function MaterialQualificationDocumentModal(
    $scope,
    $rootScope,
    $uibModal,
    $state,
    $uibModalInstance,
    $translate,
    configuredQualifications,
    data,
    mode,
    divisionId
  ) {
    var self = this;

    self.configuredQualifications = configuredQualifications;
    self.mode = mode;
    self.divisionIds = [divisionId];

    self.translateValues = {
      typeSingular: $translate.instant(
        'modules.administration.adminQualification.instruction'
      ),
      typePlural: $translate.instant(
        'modules.administration.adminQualification.instructions'
      ),
    };

    self.typeSingular = $translate.instant('modules.administration.adminQualification.instruction');

    self.formData = data
      ? data
      : {
        MaterialQualification: [],
        AcquireDate: new Date(),
        ExpireDate: null,
        InitialInstructionByManufacturerOrAuthorizedPerson: false,
        InstructedMembers: [],
        InstructingMember: null,
        InstructingContact: null,
        InstructingBusinessPartner: null,
      };

    self.selectedPersonFieldType = 'member';
    self.instructedMemberExclude = [];
    self.instructingMemberExclude = [];

    if (data) {
      if(!data.MaterialQualification && data.QualificationId) {
        data.MaterialQualification = self.configuredQualifications.find(function (mq) {
          return mq.QualificationId === data.QualificationId;
        }) || { Qualification: data.Qualification, DivisionId: data.DivisionId };
      }

      self.formData.MaterialQualification = Array.isArray(data.MaterialQualification) ? data.MaterialQualification : [data.MaterialQualification];
      self.configuredQualifications = self.formData.MaterialQualification;
      self.formData.AcquireDate = new Date(data.AcquireDate);
      self.formData.ExpireDate = data.ExpireDate ? new Date(data.ExpireDate) : null;

      self.formData.InstructedMembers = [data.Member]
      self.selectedPersonFieldType = data.InstructingPerson ? data.InstructingPerson.type : 'null';
    } else {
      // pre select qualifications
      self.formData.MaterialQualification = self.configuredQualifications.filter(function (mq) {
        return mq.PartOfInstruction;
      });
    }

    $scope.$watch(
      function () {
        return self.formData.AcquireDate;
      },
      function (newVal, oldVal) {
        if (
          newVal !== oldVal &&
          self.validityPeriodHelperActivated &&
          self.formData.AcquireDate &&
          (self.ExpireDateViaValidityPeriodHelper ||
            !self.formData.ExpireDate) &&
          (self.divisionIdsformData.Qualification.ValidityPeriodDays ||
            self.divisionIdsformData.Qualification.ValidityPeriodMonths ||
            self.divisionIdsformData.Qualification.ValidityPeriodYears)
        ) {
          self.formData.ExpireDate = moment(self.formData.AcquireDate)
            .add(
              self.divisionIdsformData.Qualification.ValidityPeriodDays || 0,
              'days'
            )
            .add(
              self.divisionIdsformData.Qualification.ValidityPeriodMonths || 0,
              'months'
            )
            .add(
              self.divisionIdsformData.Qualification.ValidityPeriodYears || 0,
              'years'
            )
            .toDate();
          self.ExpireDateViaValidityPeriodHelper = true;
          self.ignoreNextExpireDateChange = true;
        } else {
          self.ExpireDateViaValidityPeriodHelper = false;
        }
        if (self.formData.AcquireDate && self.expireDatepicker) {
          self.expireDatepicker.options.minDate = moment(
            self.formData.AcquireDate
          )
            .add(1, 'days')
            .toDate();
        }
      },
      false
    );

    $scope.$watch(
      function () {
        return self.formData.ExpireDate;
      },
      function () {
        if (self.ignoreNextExpireDateChange) {
          self.ignoreNextExpireDateChange = false;
          return;
        }
        self.ExpireDateViaValidityPeriodHelper = false;
      },
      false
    );

    self.acquireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      },
    };

    self.expireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      },
    };

    self.checkForValidExpireDate = function () {
      if (
        self.formData.ExpireDate &&
        self.formData.AcquireDate &&
        self.formData.ExpireDate <= self.formData.AcquireDate
      ) {
        return false;
      }
      return true;
    };

    function clearInstructingPersons() {
      // when editing we want to make sure that there is still only one "person" selected
      // otherwise old Ids might remain
      switch (self.selectedPersonFieldType) {
      case 'member':
        self.formData.InstructingContactId = null;
        self.formData.InstructingContact = null;
        self.formData.InstructingBusinessPartnerId = null;
        self.formData.InstructingBusinessPartner = null;
        break;
      case 'contact':
        self.formData.InstructingMemberId = null;
        self.formData.InstructingMember = null;
        self.formData.InstructingBusinessPartnerId = null;
        self.formData.InstructingBusinessPartner = null;
        break;
      case 'organisation':
        self.formData.InstructingMemberId = null;
        self.formData.InstructingMember = null;
        self.formData.InstructingContactId = null;
        self.formData.InstructingContact = null;
        break;
      }
    }

    self.addInstructedMember = function (selection) {
      self.formData.InstructedMembers.push(selection);
      self.instructingMemberExclude.push(selection.MemberId);
      self.instructedMemberExclude.push(selection.MemberId);
    };
    self.removeInstructedMember = function (selection) {
      self.formData.InstructedMembers.splice(
        self.formData.InstructedMembers.indexOf(selection),
        1
      );
      self.instructingMemberExclude.splice(
        self.instructingMemberExclude.indexOf(selection.MemberId),
        1
      );
      self.instructedMemberExclude.splice(
        self.instructedMemberExclude.indexOf(selection.MemberId),
        1
      );
    }

    self.instructingMemberSelected = function (selection) {
      self.formData.InstructingMember = selection;
      self.formData.InstructingMemberId = selection.MemberId;
      self.instructedMemberExclude.push(selection.MemberId);
    };
    self.instructingContactSelected = function (selection) {
      self.formData.InstructingContact = selection;
      self.formData.InstructingContactId = selection.id;
    };
    self.instructingOrganisationSelected = function (selection) {
      self.formData.InstructingBusinessPartner = selection;
      self.formData.InstructingBusinessPartnerId = selection.id;
    };
    

    self.applyModal = function () {
      clearInstructingPersons();
      self.validityPeriodHelperActivated = false;
      $uibModalInstance.close(self.formData);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialQualificationAddModalCtrl', MaterialQualificationAddModal);

  function MaterialQualificationAddModal($scope, $rootScope, $uibModal, $state, $uibModalInstance, $translate, flatQualificationHierarchy, data, mode) {
    var self = this;

    self.flatQualificationHierarchy = flatQualificationHierarchy;
    self.mode = mode;

    self.translateValues = {
      typeSingular: $translate.instant('modules.administration.adminQualification.allTypeSingular'),
      typePlural: $translate.instant('modules.administration.adminQualification.allTypePlural'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.allTypeGroupSingular'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.allTypeGroupPlural'),
    }

    self.formData = data ? data : {
      Qualification: null,
      Required: false,
      PartOfInstruction: false,
    }

    self.applyModal = function () {
      $uibModalInstance.close({
        mode: mode,
        data: self.formData,
      });
    }
  }
   
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material')
    .controller('addMaterialInspectionEventCtrl', addMaterialInspectionEventCtrl);

  function addMaterialInspectionEventCtrl($scope, $uibModalInstance, ctx, materialId, materialModel, $translate, inspectionEvt, descent,
    fileUtil, preSetInspections) {
    var self = this;

    self.viewMode = !!inspectionEvt && !descent;
    self.descent = !!descent;

    self.inspections = preSetInspections || [];
    self.preSetInspections = !!preSetInspections;
    self.inspectionEventMeta = {};
    self.divisionId = ctx;
    self.materialId = materialId;
    self.materialModel = materialModel;
    self.fileUploadUrl = '/api/files/cacheFile?divisionId=' + self.divisionId;
    self.unallowedFileTypes = [
      'exe',
      'com',
      'bat',
      'cmd',
      'vbs',
      'vbe',
      'js',
      'jse',
      'ws',
      'wsf',
      'wsc',
      'wsh',
      'ps1',
      'ps1xml',
      'ps2',
      'ps2xml',
      'psc1',
      'psc2',
      'msh',
      'msh1',
      'msh2',
      'mshxml',
      'msh1xml',
      'msh2xml',
      'scf',
      'lnk',
      'inf',
      'reg',
      'dll',
      'cpl',
      'ocx',
      'ax',
      'sys',
    ];
    self.states = {
      PASSED: $translate.instant('modules.material.addMaterial.inspection.eventStatePassed'),
      FAILED: $translate.instant('modules.material.addMaterial.inspection.eventStateFailed'),
      DONE: $translate.instant('modules.material.addMaterial.inspection.eventStateDone'),
    }
    self.selectorProps = Object.keys(self.states).map(function(k) {
      return {
        value: k,
        label: self.states[k]
      }
    })
    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };

    self.resultGroupFn = function(item) {
      return item.value === 'DONE' ? 'Durchführung' : 'Prüfergebnis';
    };

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      },
      expoptions: {
        showWeeks: false,
        minDate: new Date(),
      }
    };

    $scope.$watch(function () {
      return { minInterval: _.min(_.map(self.inspections, 'Interval')), date: self.inspectionEventMeta.Date };
    }, function (w) {
      self.datepicker.expoptions.maxDate = (w.minInterval && w.date)
                                           ? moment(w.date).add(w.minInterval, 'days').endOf('day').toDate()
                                           : undefined;
    }, true);

    if (self.viewMode) {
      self.inspections = [inspectionEvt.Inspection];
      self.inspectionEventMeta = _.omit(inspectionEvt, ['Inspection', 'InspectionId']);

      self.selectedPersonFieldType = (self.inspectionEventMeta.BusinessPartnerId && 'organisation')
                                     || (self.inspectionEventMeta.ContactId && 'contact')
                                     || 'member';
      self.inspectionEventMeta.Date = new Date(self.inspectionEventMeta.Date);
      if (self.inspectionEventMeta.ValidUntil) {
        self.inspectionEventMeta.ValidUntil = new Date(self.inspectionEventMeta.ValidUntil);
      }

      self.inspectionEventMeta.Result = _.find(self.selectorProps, { value: self.inspectionEventMeta.Result });
    } else {
      self.inspectionEventMeta.Date = new Date();
    }

    if (self.descent) {
      // we want to reuse specific properties from our parent inspection, but we will generate a new inspection event overall
      self.inspections = [inspectionEvt.Inspection];
      if (~['PASSED', 'DONE'].indexOf(inspectionEvt.Result)) {
        self.inspectionEventMeta.Result = _.find(self.selectorProps, { value: inspectionEvt.Result });
      }
    }

    $scope.$watch(function() {
      return self.selectedPersonFieldType;
    }, function(newVal, oldVal) {
      if (newVal !== oldVal && oldVal) {
        delete self.inspectionEventMeta.TestingOrg;
        delete self.inspectionEventMeta.TestingContact;
        delete self.inspectionEventMeta.TestingMember1;
        delete self.inspectionEventMeta.TestingMember2;
      }
    });

    $scope.$watch(function() {
      return self.inspectionEventMeta.HasTasks;
    }, function(newVal) {
      if (newVal === false) {
        delete self.inspectionEventMeta.Description;
      }
    });

    $scope.$watch(function() {
      return self.inspectionEventMeta.Date;
    }, function(newVal) {
      if (newVal) {
        self.datepicker.expoptions.minDate = newVal;
      } else {
        self.datepicker.expoptions.minDate = new Date();
      }
    });

    self.responsibleExcludeList = [];
    $scope.$watch(function() {
      return (self.inspectionEventMeta.TestingMemberOne || {}).MemberId + '_' + (self.inspectionEventMeta.TestingMemberTwo || {}).MemberId;
    }, function() {
      self.responsibleExcludeList = _.compact([
        (self.inspectionEventMeta.TestingMemberOne || {}).MemberId,
        (self.inspectionEventMeta.TestingMemberTwo || {}).MemberId,
      ]);
    });

    self.setOrg = function(bp) {
      self.inspectionEventMeta.TestingOrg = bp;
    }

    self.setContact = function(bp) {
      self.inspectionEventMeta.TestingContact = bp;
    }

    self.setTestingMemberOne = function(m) {
      self.inspectionEventMeta.TestingMemberOne = m;
    }

    self.setTestingMemberTwo = function(m) {
      self.inspectionEventMeta.TestingMemberTwo = m;
    }

    self.applyModal = function() {
      $uibModalInstance.close({
        inspections: self.inspections,
        meta: self.inspectionEventMeta,
      });
    }

    self.onFileUploaded = function (data) {
      self.inspectionEventMeta.fileCacheKey = data.fileCacheKey || null;
      self.inspectionEventMeta.FileName = (data.fileItem && data.fileItem.file.name) || null;
    }

    self.onFileDelete = function (revert) {
      if(revert) {
        // revert
        self.inspectionEventMeta.File = self.inspectionEventMeta.fileDelete;
        self.inspectionEventMeta.fileDelete = null;
        self.fileChanged = false; 
      } else {
        // delete
        self.inspectionEventMeta.fileDelete = self.inspectionEventMeta.File;
        self.inspectionEventMeta.File = null;
        self.fileChanged = true; 
      }
    }

    self.viewOrDownloadFile = function() {
      return fileUtil.viewOrDownloadFile({
        divisionId: self.divisionId,
        file: self.inspectionEventMeta.FileName,
        path: self.materialId + '_' + self.inspectionEventMeta.id,
        prefix: '_' + _.lowerFirst(self.materialModel),
        storageIdent: 'inspectionEvents'
      });
    };
    self.fileHasPreview = fileUtil.fileHasPreview;

    self.isValidDate = function () {
      return self.viewMode
             || !self.inspectionEventMeta.ValidUntil
             || (
               moment(self.inspectionEventMeta.ValidUntil).endOf('day').isSameOrAfter(moment(self.eventData.EndDate).endOf('day'))
               && (
                 !self.datepicker.expoptions.maxDate
                 || moment(self.inspectionEventMeta.ValidUntil).endOf('day').isSameOrBefore(moment(self.datepicker.expoptions.maxDate).endOf('day'))
               )
             );
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('RecordEventQualificationModalCtrl', RecordEventQualificationModalCtrl);

  /** @ngInject */
  function RecordEventQualificationModalCtrl($scope, $uibModalInstance, qualification, flatQualificationHierarchy, instructingPerson,
    type, availableMaterials, onFileDownload, onFilePreview, member, divisionIds, $translate) {
    var self = this;
    self.qualification = qualification;
    self.editMode = !!self.qualification;
    self.flatQualificationHierarchy = flatQualificationHierarchy;
    self.memberExclude = member ? [member.id] : [];
    self.divisionIds = divisionIds;
    self.qualifications = [];
    self.qualification = { AcquireDate: Date.now() };




    self.translateValues = type === 'qualification' ? {
      typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
      typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups'),
      name: self.qualification ? self.qualification.Name : ''
    } : {
      typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
      typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups'),
      name: self.qualification ? self.qualification.Name : ''
    };
    self.type = type;
    self.availableMaterials = availableMaterials;

    self.missingInstructingPerson = false; // required message

    self.selectedPersonFieldType = getPersonTypeValue();
    self.fileUploadUrl = '/api/files/cacheFile?divisionId=' + (self.divisionIds && self.divisionIds.length > 0 && self.divisionIds[0]);
    self.unallowedFileTypes = [
      'exe',
      'com',
      'bat',
      'cmd',
      'vbs',
      'vbe',
      'js',
      'jse',
      'ws',
      'wsf',
      'wsc',
      'wsh',
      'ps1',
      'ps1xml',
      'ps2',
      'ps2xml',
      'psc1',
      'psc2',
      'msh',
      'msh1',
      'msh2',
      'mshxml',
      'msh1xml',
      'msh2xml',
      'scf',
      'lnk',
      'inf',
      'reg',
      'dll',
      'cpl',
      'ocx',
      'ax',
      'sys',
    ];

    function getPersonTypeValue() {
      if (!self.qualification) {
        return 'member';
      }

      if (self.qualification.InstructingMemberId) {
        return 'member';
      } else if (self.qualification.InstructingContactId) {
        return 'contact';
      } else if (self.qualification.InstructingBusinessPartnerId) {
        return 'organisation';
      }

      return 'member';
    }
    $scope.$watch(function () {
      return self.selectedPersonFieldType;
    }, function (newVal, oldVal) {
      // reset values from other pickers
      if (newVal !== oldVal && oldVal) {

        self.qualifications.forEach(function (qualification) {

          switch (newVal) {
          case 'member':
            qualification.InstructingContact = undefined;
            qualification.InstructingBusinessPartner = undefined;
            break;
          case 'contact':
            qualification.InstructingMember = undefined;
            qualification.InstructingBusinessPartner = undefined;
            break;
          case 'organisation':
            qualification.InstructingMember = undefined;
            qualification.InstructingContact = undefined;
            break;
          }


        });

      }
    });

    self.onQualificationsChanged = function () {
      if (
        self.qualifications.some(function (selectedQual) {
          return !moment(selectedQual.expireDate).isSame(moment(), 'day');
        })
      ) {
        var filteredSorted = self.qualifications
          .filter(function (selectedQual) {
            return !moment(selectedQual.expireDate).isSame(moment(), 'day');
          })
          // Sort by expireDate ascending (soonest first)
          .sort(function (a, b) {
            return moment(a.expireDate).diff(moment(b.expireDate));
          });
        self.qualification.ExpireDate = moment(filteredSorted[0].expireDate).toDate();
      } else {
        self.qualification.ExpireDate = null;
      }
    };

    $scope.$watch(function () {
      return self.qualification.AcquireDate;
    }, function () {
      self.qualifications.forEach(function (qualification) {
        qualification.AcquireDate = moment(self.qualification.AcquireDate).toDate();
      });
    }, false);

    $scope.$watch(function () {
      return self.qualification.ExpireDate;
    }, function () {


      self.qualifications.forEach(function (qualification) {

        qualification.ExpireDate = moment(self.qualification.ExpireDate).toDate();
      });

    }, false);

    $scope.$watch(function () {
      return self.qualification.ForeignQualificationAccepted;
    }, function () {

      self.qualifications.forEach(function (qualification) {

        if (qualification && Object.keys(qualification).length && !qualification.ForeignQualificationAccepted) {
          qualification.ForeignQualificationRemark = '';
        }

      });

    }, false);

    self.instructingMemberSelected = function (selection) {

      self.qualifications.forEach(function (qualification) {
        qualification.InstructingMember = selection;
        qualification.InstructingMemberId = selection.MemberId;
      });

    };

    self.instructingContactSelected = function (selection) {
      self.qualifications.forEach(function (qualification) {
        qualification.InstructingContact = selection;
        qualification.InstructingContactId = selection.id;
      });
    };

    self.instructingOrganisationSelected = function (selection) {

      self.qualifications.forEach(function (qualification) {
        qualification.InstructingBusinessPartner = selection;
        qualification.InstructingBusinessPartnerId = selection.id;
      });


    };

    self.acquireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      }
    };

    self.expireDatepicker = {
      format: 'd!.M!.yyyy',
      options: {
        showWeeks: false,
      }
    };

    self.checkForValidExpireDate = function () {
      if (self.qualification.ExpireDate && self.qualification.AcquireDate && self.qualification.ExpireDate <= self.qualification.AcquireDate) {
        return false;
      }
      return true;
    };

    self.onFileUploaded = function (data) {
      self.qualification.fileCacheKey = data.fileCacheKey;
      self.qualification.FileName = data.fileItem && data.fileItem.file.name;
    };

    self.onFileDownload = function () {
      onFileDownload ? onFileDownload(self.qualification) : null;
    };

    self.onFilePreview = function () {
      onFilePreview ? onFilePreview(self.qualification) : null;
    };

    self.onFileDelete = function (revert) {
      if (revert) {
        // revert
        self.qualification.File = self.qualification.fileDelete;
        self.qualification.fileDelete = null;
        self.fileChanged = false;
      } else {
        // delete
        self.qualification.fileDelete = self.qualification.File;
        self.qualification.File = null;
        self.fileChanged = true;
      }
    };

    function clearInstructingPersons() {
      // when editing we want to make sure that there is still only one "person" selected
      // otherwise old Ids might remain

      switch (self.selectedPersonFieldType) {
      case 'member':
        self.qualification.InstructingContactId = null;
        self.qualification.InstructingBusinessPartnerId = null;
        break;
      case 'contact':
        self.qualification.InstructingMemberId = null;
        self.qualification.InstructingBusinessPartnerId = null;
        break;
      case 'organisation':
        self.qualification.InstructingMemberId = null;
        self.qualification.InstructingContactId = null;
        break;
      }
    }

    self.applyModal = function () {

      if (type === 'instruction') {
        clearInstructingPersons();
      }



      if (!self.qualifications[0].AcquireDate) {
        self.qualifications.forEach(function (qualification) {

          qualification.AcquireDate = moment(self.qualification.AcquireDate).toDate();
        });
      }

      self.validityPeriodHelperActivated = false;
      $uibModalInstance.close(self.qualifications);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('RecordEventModalCtrl', RecordEventModalCtrl);

  /** @ngInject */
  function RecordEventModalCtrl($uibModalInstance, eventDetailCtrl) {
    var self = this;
    self.attendances = (eventDetailCtrl.eventData.attendance || [])
      .filter(function (attendee) {
        return !!attendee.Acceptance;
      }
    );
    self.recordQualification = false;
    self.recordTraining = false;

    self.applyModal = function () {
      $uibModalInstance.close({
        recordQualification: self.recordQualification,
        recordTraining: self.recordTraining,
        selectedMembers: self.attendances
      });        
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('PeriodicEventHelperModalCtrl', PeriodicEventHelperModalCtrl);

  /** @ngInject */
  function PeriodicEventHelperModalCtrl($scope, $uibModalInstance, eventDetailCtrl, toastr, $translate) {
    var self = this;

    self.edCtrl = eventDetailCtrl;

    self.activeTab = 'daily';
    self.setActiveTab = function (tab) {
      self.activeTab = tab;
    };

    self.MAX_RECURRENCE_COUNT = 500;

    $scope.$watch(function () {
      return self.edCtrl.eventData.series.eventEndCount;
    }, function () {
      if ((self.edCtrl.eventData.series.eventEndCount && self.edCtrl.eventData.series.eventEndCount > self.MAX_RECURRENCE_COUNT)
        || self.edCtrl.eventData.series.eventEndCount === undefined) {
        self.edCtrl.eventData.series.eventEndCount = self.MAX_RECURRENCE_COUNT;
        toastr.info(
          $translate.instant('modules.events.event.modals.toastr.maxSeriesDurationSetMsg', { maxRecurrenceCount: self.MAX_RECURRENCE_COUNT }),
          $translate.instant('modules.events.event.modals.toastr.maxSeriesDurationTitle')
        );
      }
    });

    self.applyPerodicPattern = function () {
      var eData = self.edCtrl.eventData.series[self.activeTab];
      var eType = eData.eType;
      var series = self.edCtrl.eventData.series;
      var targetRecurrences = Math.min(series.eventEndType === 'maxCount' ? self.MAX_RECURRENCE_COUNT : series.eventEndCount, self.MAX_RECURRENCE_COUNT);
      var recurrenceEndByDate = series.eventEndType === 'date';
      var recurrence = [];
      var sanityStop = 25000;

      var newRecur = function () {
        return moment().recur({
          start: self.edCtrl.eventData.series.startDate
        });
      };

      /* eslint no-extra-boolean-cast:0 */
      var getRecurrence = function (recurrencePattern) {
        if (recurrenceEndByDate) {
          recurrencePattern.endDate(series.endDate);
          return recurrencePattern.all();
        } else {
          // we can't use all cause we dont have a specific end date, we will use next instead
          // next will give us (as the method name suggests) the next x dates excluding the current date.
          // We will add the current date if it matches the pattern. In that case we only need x-1 more dates
          // from our next() call
          var currentDayMatchesPattern = recurrencePattern.matches(moment(self.edCtrl.eventData.series.startDate));

          var recurrenceUserCount = series.eventEndType === 'count' ? targetRecurrences : self.MAX_RECURRENCE_COUNT;

          var resultRecurrence = recurrencePattern.next(recurrenceUserCount - (currentDayMatchesPattern ? 1 : 0));
          if (currentDayMatchesPattern) { // add start day
            resultRecurrence.unshift(moment(self.edCtrl.eventData.series.startDate).startOf('day'));
          }
          return resultRecurrence;
        }
      };

      if (eType === 'daily') {
        if (eData.type === 'count') {
          recurrence = getRecurrence(newRecur().every(eData.count).days());
        }
        if (eData.type === 'moToFr') {
          recurrence = getRecurrence(newRecur().every([1, 2, 3, 4, 5]).daysOfWeek());
        }
        if (eData.type === 'businessDay') {
          recurrence = getRecurrence(newRecur().every([1, 2, 3, 4, 5, 6]).daysOfWeek());
        }
      }

      var startDate = moment(self.edCtrl.eventData.series.startDate).startOf('day');
      var endDate = moment(self.edCtrl.eventData.series.endDate).startOf('day');
      var monthDayFirst = null;
      var monthDayLast = null;
      var monthDayDate = null;
      var lastDate = null;
      var month = null;
      var dayCounter = null;

      if (eType === 'weekly') {
        var startWithDay = startDate.isoWeekday(); // monday 1, sunday 7

        // add dates while startDate < endDate or the recurrences are reached
        while (((recurrenceEndByDate && (startDate.diff(endDate) <= 0))
          || (!recurrenceEndByDate && (recurrence.length < targetRecurrences)) && sanityStop--)) {
          //start at the day of the current startDate
          var weekDayFirst = startDate.clone().startOf('week');
          var weekDayLast = startDate.clone().endOf('week');

          for (var i = startWithDay; i < 8; i++) {
            if (eData.days[i]) {
              // start with monday (= 1), add 1-1 (= 0) to set monday, 2-1 (= 1) to set tuesday...
              var weekDayDate = weekDayFirst.clone().add(i - 1, 'days');

              if (weekDayDate.diff(weekDayLast) <= 0) { // didn't overflow act week
                if ((recurrenceEndByDate && weekDayDate.diff(endDate) <= 0)
                  || (!recurrenceEndByDate && recurrence.length < targetRecurrences)) { // didn't overflow endDate
                  recurrence.push(weekDayDate.startOf('day'));
                }
              }
            }
          }

          //raise the startDate to the specified week count
          startDate.add(eData.count, 'weeks');
          //get the first day of the week, to start at monday for next run
          startWithDay = 1;
        }
      }
      if (eType === 'monthly') {
        if (eData.type === 'date') {
          while (((recurrenceEndByDate && (startDate.diff(endDate) <= 0))
            || (!recurrenceEndByDate && (recurrence.length < targetRecurrences)) && sanityStop--)) {
            monthDayFirst = startDate.clone().startOf('month');
            monthDayLast = startDate.clone().endOf('month');

            // we selected the first day of the month; if the user typed 2 to get the 2nd day of month, we
            // need to add 2-1 (= 1) days
            monthDayDate = monthDayFirst.clone().add(eData.dateDay - 1, 'days');

            if (moment(self.edCtrl.eventData.series.startDate).startOf('day').diff(monthDayDate) <= 0) { // is after our first occurrence
              if (monthDayDate.diff(monthDayLast) >= 0) {
                // oh! our month is ending earlier then the user expected
                // for example, user wants to insert an event on the 31th of every month
                // -> thats not gonna happen in febuary. Solution: drop (bäh!) or move
                // to last valid date of month (yeah!)
                monthDayDate = monthDayLast.clone();
              }
              if ((recurrenceEndByDate && monthDayDate.diff(endDate) <= 0)
                || (!recurrenceEndByDate && recurrence.length < targetRecurrences)) { // didn't overflow endDate
                recurrence.push(monthDayDate.startOf('day'));
              }
            }

            startDate.add(eData.dateMonth, 'months').startOf('month');
          }
        }
        if (eData.type === 'day') {
          while (((recurrenceEndByDate && (startDate.diff(endDate) <= 0))
            || (!recurrenceEndByDate && (recurrence.length < targetRecurrences)) && sanityStop--)) {
            var monthDay = startDate.clone().startOf('month');
            lastDate = monthDay.clone();
            month = monthDay.month();
            dayCounter = 0;

            while (month === monthDay.month()) {
              if (monthDay.isoWeekday() === eData.dayDay.id) {
                lastDate = monthDay.clone();
                dayCounter++;

                if (eData.dayPlace.id === dayCounter) {
                  break;
                }
              }

              monthDay.add(1, 'day');
            }

            if (eData.dayPlace.id === 5) {
              monthDay = lastDate;
            }

            if (moment(self.edCtrl.eventData.series.startDate).startOf('day').diff(monthDay) <= 0) { // is after our first occurrence
              if ((recurrenceEndByDate && monthDay.diff(endDate) <= 0)
                || (!recurrenceEndByDate && recurrence.length < targetRecurrences)) { // didn't overflow endDate
                recurrence.push(monthDay.startOf('day'));
              }
            }

            startDate.add(eData.dayMonthCount, 'months');
          }
        }
      }
      if (eType === 'yearly') {
        if (eData.type === 'date') {
          while (((recurrenceEndByDate && (startDate.diff(endDate) <= 0))
            || (!recurrenceEndByDate && (recurrence.length < targetRecurrences)) && sanityStop--)) {
            var yearDayFirst = startDate.clone().startOf('year');
            var yearDayLast = startDate.clone().endOf('year');

            var yearDayDate = yearDayFirst.clone().set('month', eData.dateMonth.id - 1);
            var targetMonth = yearDayDate.month();
            yearDayDate.set('date', eData.dateDay).startOf('day');
            if (yearDayDate.month() !== targetMonth) { // our month wrapped while setting the dateDay, use last day instead
              yearDayDate = yearDayFirst.clone().set('month', eData.dateMonth.id - 1).endOf('month').startOf('day');
            }

            if (moment(self.edCtrl.eventData.series.startDate).startOf('day').diff(yearDayDate) <= 0) { // is after our first occurrence
              if (yearDayDate.diff(yearDayLast) >= 0) {
                yearDayDate = yearDayLast.clone().startOf('day');
              }
              if ((recurrenceEndByDate && yearDayDate.diff(endDate) <= 0)
                || (!recurrenceEndByDate && recurrence.length < targetRecurrences)) { // didn't overflow endDate
                recurrence.push(yearDayDate.startOf('day'));
              }
            }

            startDate.add(eData.count, 'years');
          }
        }
        if (eData.type === 'day') {
          while (((recurrenceEndByDate && (startDate.diff(endDate) <= 0))
            || (!recurrenceEndByDate && (recurrence.length < targetRecurrences)) && sanityStop--)) {

            var dateToAdd = startDate.clone().set('month', eData.dayMonth.id - 1).startOf('month');
            lastDate = dateToAdd.clone();
            month = dateToAdd.month();
            dayCounter = 0;

            while (month === dateToAdd.month()) {
              if (dateToAdd.isoWeekday() === eData.dayDay.id) {
                lastDate = dateToAdd.clone();
                dayCounter++;

                if (eData.dayPlace.id === dayCounter) {
                  break;
                }
              }

              dateToAdd.add(1, 'day');
            }

            if (eData.dayPlace.id === 5) {
              dateToAdd = lastDate;
            }

            if (moment(self.edCtrl.eventData.series.startDate).startOf('day').diff(dateToAdd) <= 0) { // is after our first occurrence
              if ((recurrenceEndByDate && dateToAdd.diff(endDate) <= 0)
                || (!recurrenceEndByDate && recurrence.length < targetRecurrences)) { // didn't overflow endDate
                recurrence.push(dateToAdd.startOf('day'));
              }
            }

            startDate.add(eData.count, 'years');
          }
        }
      }

      if (recurrence && recurrence.length) {
        if ((self.edCtrl.eventData.seriesDates.length + recurrence.length) > self.MAX_RECURRENCE_COUNT) {
          toastr.warning(
            $translate.instant('modules.events.event.modals.toastr.maxSeriesDurationNotMsg', { maxRecurrenceCount: self.MAX_RECURRENCE_COUNT }),
            $translate.instant('modules.events.event.modals.toastr.maxSeriesDurationTitle')
          );
          return;
        }
        var firstRecureDate = null;
        recurrence.forEach(function (recurDate) {
          var dateToAdd = recurDate.local().startOf('day').toDate().getTime();
          firstRecureDate = firstRecureDate || recurDate;
          if (!~self.edCtrl.eventData.seriesDates.indexOf(dateToAdd)) {
            self.edCtrl.eventData.seriesDates.push(dateToAdd);
          }
        });
        self.edCtrl.seriesPicker.active = firstRecureDate; // force datepicker rerender by changing active date
        toastr.success(
          $translate.instant('modules.events.event.modals.toastr.eventAddedMsg'),
          $translate.instant('modules.events.event.modals.toastr.eventAddedTitle')
        );
      } else {
        toastr.warning(
          $translate.instant('modules.events.event.modals.toastr.eventNotCreatedMsg'),
          $translate.instant('modules.events.event.modals.toastr.eventNotCreatedTitle')
        );
      }

      $uibModalInstance.close();
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.events.eventDetail', [])
    .controller('AttendeeRemarkModalCtrl', AttendeeRemarkModalCtrl);

  /** @ngInject */
  function AttendeeRemarkModalCtrl(userId, clientApi, $uibModalInstance, attendee, eventDetailCtrl, toastr, $translate, canEditRemark, isShift, serviceId) {
    var self = this;
    self.remark = attendee.Remark;
    self.canEditRemark = canEditRemark;

    if(isShift && attendee.Member != null)
    {

      self.attendeeName = attendee.Member.FirstName + ' ' + attendee.Member.LastName;
    }
    else {
      self.attendeeName = attendee.FirstName + ' ' + attendee.LastName;
    }

    self.applyModal = function () {

      self.otherRemark = 'updateRemark';
      self.ownRemark = 'updateOwnAttendance';

      self.call = (userId == attendee.id) ? self.ownRemark : self.otherRemark;

      if (self.canEditRemark && !isShift) {
        return clientApi
          .custom('model/EventMember', self.call, {
            eventId: eventDetailCtrl.eventData.id,
            divisionId: eventDetailCtrl.eventData.SourceDivisionId,
            attendeeMemberId: attendee.id,
            acceptance: attendee.Acceptance,
            remark: self.remark || null,
          }).then(function () {
            $uibModalInstance.close({
              remark: self.remark,
            });
          })

      }
      else if (self.canEditRemark && isShift) {
        return clientApi.custom('model/ServiceShiftMember', self.call, {
          serviceId: serviceId,
          shiftId: eventDetailCtrl.id,
          divisionId: attendee.DivisionId || attendee.Division.id,
          attendeeMemberId: attendee.MemberId,
          acceptance: true,
          remark: self.remark || null,
        }).then(function () {
          $uibModalInstance.close({
            remark: self.remark,
          });
        })

      }




    }
  }
})();


(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.supervisors', [
      'BlurAdmin.pages.administration.supervisors.approvals',
      'BlurAdmin.pages.administration.supervisors.statistics'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.administration.supervisors', {
      url: '/supervisors',
      template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
      title: 'navigation.administration.supervisors',
      abstract: true,
      sidebarMeta: {
        order: 102
      },
      viewPermission: 'arno.administration'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.supervisors')
    .controller('StatisticsSupervisorsCtrl', StatisticsSupervisorsCtrl);

  /** @ngInject */
  function StatisticsSupervisorsCtrl(
    $rootScope, $uibModal, $state, stateChangePrompt,
    organizationId, selectedCtx,
    divisionTree, divisionNodesData, organizationData
  ) {
    var $ctrl = this;

    $ctrl.organizationId = organizationId;

    // for organization-management
    if (organizationData) {
      $ctrl.organizationData = organizationData;
    }

    // for division supervisors-management
    $ctrl.selectedCtx = selectedCtx;
    $ctrl.divisionTree = divisionTree;
    $ctrl.divisionNodesData = divisionNodesData;

    $ctrl.allowOrgSelection = true;
    $ctrl.divisionSelectorEntryPermission = '';

    if (selectedCtx && selectedCtx !== 'rootOrg') {
      $ctrl.selectedDivision = _.find($ctrl.divisionNodesData, {
        id: selectedCtx.toString()
      });
      if ($ctrl.selectedDivision && $ctrl.selectedDivision.statisticsSupervisors && Array.isArray($ctrl.selectedDivision.statisticsSupervisors)) {
        $ctrl.selectedDivision.statisticsSupervisors = $ctrl.selectedDivision.statisticsSupervisors.filter(function(member) {
          return member.FirstName && member.LastName;
        })
      }
    }

    // create holder-object for e.g. added users
    $ctrl.changes = {
      statisticsSupervisors: {
        changed: false,
        saveError: false,
        potentialChanges: false,
      },
    }

    $ctrl.supervisorsListConfig = {
      roleName: 'Statistikzuweiser',
      scopeOfMembers: 'statisticsSupervisors',
      controlPermission: 'arno.administration.statisticsassign.manage'
    }

    $ctrl.$onInit = function() {
      stateChangePrompt.evaluate(function () {
        return !$ctrl.changes.statisticsSupervisors.potentialChanges;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.supervisors')
    .controller('ApprovalsSupervisorsCtrl', ApprovalsSupervisorsCtrl);

   /** @ngInject */
  function ApprovalsSupervisorsCtrl(
    $rootScope, $uibModal, $state, stateChangePrompt,
    organizationId, divisionId,
    divisionTree, divisionNodesData
  ) {
    var $ctrl = this;

    $ctrl.organizationId = organizationId;
    $ctrl.divisionId = divisionId;

    $ctrl.divisionTree = divisionTree;
    $ctrl.divisionNodesData = divisionNodesData;

    $ctrl.divisionSelectorEntryPermission = '';

    // create holder-object for e.g. added users
    $ctrl.selectedDivision = _.find($ctrl.divisionNodesData, {
      id: divisionId.toString()
    });

    if ($ctrl.selectedDivision && $ctrl.selectedDivision.approvalsSupervisors && Array.isArray($ctrl.selectedDivision.approvalsSupervisors)) {
      $ctrl.selectedDivision.approvalsSupervisors = $ctrl.selectedDivision.approvalsSupervisors.filter(function(member) {
        return member.FirstName && member.LastName;
      })
    }

    $ctrl.changes = {
      approvalsSupervisors: {
        changed: false,
        saveError: false,
        potentialChanges: false,
      },
    }

    $ctrl.supervisorsListConfig = {
      roleName: 'Freigabezuweiser',
      scopeOfMembers: 'approvalsSupervisors',
      controlPermission: 'arno.administration.divisions.approvalassign.manage'
    }

    $ctrl.$onInit = function() {
      stateChangePrompt.evaluate(function () {
        return !$ctrl.changes.approvalsSupervisors.potentialChanges;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.roles', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.roles', {
        url: '/roles',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        title: 'navigation.administration.roles',
        abstract: true,
        sidebarMeta: {
          order: 101,
        },
        resolve: {
          permHierarchy: function(clientApi) {
            return clientApi.custom('model/DivisionPermission', 'getPermissionHierarchy', {});
          },
          orgPermHierarchy: function(clientApi) {
            return clientApi.custom('model/OrganizationPermission', 'getOrganizationPermissionHierarchy', {});
          },
        },
        viewPermission: 'arno.administration.roles.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.roles')
    .controller('RoleModalCtrl', RoleModalCtrl);

  function RoleModalCtrl($scope, $uibModalInstance, permissions, permHierarchy, commonUtils, clientApi, $timeout, roles,
    formattedRoles, selectedPerm, toastr, fetchTooltip, $filter, $translate) {

    var self = this;

    self.permissions = [];

    permissions.forEach(function(permission) {
      if (permission) {
        // REMARK: atm only structuring for the division-permissions exist, but not for the orgs,
        // so org-permissions dont have the system-module association!
        // this controller is however used for org-roles-management AND division-roles-management,
        // so it should always be checked if system-module association is present for a permission
        if (permission.SystemModule && permission.SystemModule.Name) {
          permission.Group = permission.SystemModule.Name;
          delete permission.SystemModule;
        }

        if (permission.Assignable) {
          self.permissions.push(permission);
        }
      }
    });
    self.permHierarchy = permHierarchy;
    self.permIds = [];
    self.curRole = selectedPerm ? _.cloneDeep(selectedPerm) : {};
    self.title = $translate.instant('modules.administration.roles.addRole');

    if (selectedPerm) {
      self.originalName = selectedPerm.RoleName;
      self.title = 'Rolle bearbeiten';
    }

    if (selectedPerm && permissions) {
      self.selectedPermissions = [];
      permissions.forEach(function(permission) {
        if (selectedPerm.PermissionId.indexOf(permission.id) > -1) {
          self.selectedPermissions.push(permission);
        }
      });
    } else {
      self.selectedPermissions = [];
    }

    self.fetchTooltip = fetchTooltip;

    self.applyModal = function (id) {
      if (self.selectedPermissions && self.selectedPermissions.length > 0) {
        for (var i = 0; i < self.selectedPermissions.length; i++) {
          self.permIds.push(self.selectedPermissions[i].id);
        }

        $uibModalInstance.close({
          name: self.curRole.RoleName,
          description: self.curRole.Description,
          permissions: self.permIds,
          id: id
        });
      }
    };

    self.validateName = function (name) {
      if (!name) {
        return false;
      }
      if (!roles.length) {
        return true;
      }
      return (!roles
        .filter(function (role) {
          return (role.id !== self.curRole.RoleId) && (role.Name.toLocaleLowerCase() === name.toLocaleLowerCase())
        })
        .length);
    };

    self.confirmDelete = function (id, name) {
      $uibModalInstance.close({
        id: id,
        deletedName: name
      });
    };

    self.orderBy = $filter('orderBy');

    $scope.$watch(function() {
      return (self.selectedPermissions || []).length;
    }, function() {
      self.selectedPermissions = self.orderBy(self.selectedPermissions, 'Name', false);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.general')
    .controller('AdminPersonnelGeneralCtrl', AdminPersonnelGeneralCtrl);

  function AdminPersonnelGeneralCtrl(
    $rootScope, $scope, $state, $translate, toastr, $uibModal, clientApi,
    permittedForAgeSettings, permittedForDeletionPeriods, permittedForExternalSystems, fieldList, periods
  ) {
    var self = this;

    self.hasManagePermAgeSettings = permittedForAgeSettings;
    self.hasManagePermDeletionPeriods = permittedForDeletionPeriods;
    self.hasManagePermExternalSystems = permittedForExternalSystems;

    // Age-Settings vars
    self.ageRestrictionActive = !!$rootScope.ctx.organization.current.restrictedAgeProfileEdit;
    self.restrictedAgeProfileEdit = $rootScope.ctx.organization.current.restrictedAgeProfileEdit;

    // Deletetion-Periods vars
    self.periods = periods;
    self.periods.deletionPeriodMonths=Math.round(self.periods.deletionPeriodMonths * 10) / 10;
    self.retrospective = {
      withdrawal: false,
      deletion: false
    };

    // External Personnel-Systems vars
    var makeFieldList = function(item, open){
      item.FieldIdentifier = [];
      item.RequiredFieldIdentifier = [];
      if(item.PersonnelSystemFields.length > 0) {
        item.PersonnelSystemFields.forEach(function(value){
          item.FieldIdentifier.push({ Name: self.FieldList[value.FieldIdentifier] || self.FieldList['Member.' + value.FieldIdentifier]});
        });
      }
      if(item.PersonnelSystemRequiredFields.length > 0) {
        item.PersonnelSystemRequiredFields.forEach(function(value){
          item.RequiredFieldIdentifier.push({ Name: self.FieldList[value.FieldIdentifier] || self.FieldList['Member.' + value.FieldIdentifier]});
        });
      }
      item.TabOpen = open || false;
      delete item.PersonnelSystemFields;
      return item;
    };

    self.FieldList = _.invert(fieldList);


    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf AdminPersonnelGeneralCtrl#
    */
    function activate() {
      if (permittedForExternalSystems) {
        self.getSystemList();
      }
    }

    // EVENT-HANDLERS
    self.saveAgeSettings = function() {
      return clientApi.custom('model/Organization', 'updateAgeSettings', {
        restrictedAgeProfileEdit: self.ageRestrictionActive ? self.restrictedAgeProfileEdit : null
      })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.personnel.general.ageSettings.saveAgeSettingsSuccess'),
            $translate.instant('modules.administration.personnel.general.ageSettings.saveAgeSettingsTitle')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.personnel.general.ageSettings.saveAgeSettingsFailed'),
            $translate.instant('modules.administration.personnel.general.ageSettings.saveAgeSettingsTitle')
          );
        })
    }

    self.deleteSystem = function(sys){
      return $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/administration/personnel/general/modals/removeSystem.modal.html',
          size: 'md'
        })
        .result
        .then(function () {
          return clientApi
            .custom('model/PersonnelSystems', 'deleteSystem', {systemId: sys.id})
            .then(function () {
              self.systemList.splice(_.findIndex(self.systemList, sys), 1);
              toastr.success(
                $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.deleteSuccessMsg'),
                $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.deleteSuccessTitle')
              );
            });
        });
    };

    self.getSystemList = function () {
      self.systemList  = [];
      return clientApi
        .custom('model/PersonnelSystems', 'getSystemList', {})
        .then(function (results) {
          if(results){
            results.forEach(function(result) {
              self.systemList.push(makeFieldList(result));
            });
          }
        });
    };

    self.systemAdd = function (sys) {
      var systemToUpdate = false;
      if (sys) {
        systemToUpdate = _.cloneDeep(sys);
      }
      return $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/administration/personnel/general/modals/addSystemModal.html',
          size: 'md',
          resolve: {
            data: {
              system: systemToUpdate,
              FieldList: self.FieldList,
            }
          },
          controller: 'addSystemModalCtrl as $addSystemModalCtrl',
        })
        .result
        .then(function (newSystem) {
          if (newSystem) {
            return clientApi
              .custom('model/PersonnelSystems', 'handleSystem', {
                id: newSystem.id || false,
                name: newSystem.Name,
                email: newSystem.EMail,
                infoText: newSystem.InfoText,
                ignoreInitialValues: newSystem.IgnoreInitialValues,
                fieldIdentifier: newSystem.FieldIdentifier,
                requiredFieldIdentifier: newSystem.RequiredFieldIdentifier
              })
              .then(function (result) {
                // for some reason the update function does not return the updated system... therefor reload the whole list
                self.getSystemList();

                if(result){
                  toastr.success(
                    $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.addSuccessMsg'),
                    $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.addSuccessTitle')
                  );
                }else{
                  toastr.error(
                    $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.addFailedMsg'),
                    $translate.instant('modules.administration.personnel.general.externalPersonnelSystems.addFailedTitle')
                  );
                }

              });
          }
        });
    };

    self.changeRetrospectively = function(periodType){
      var askchangeRetrospectively = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/general/modals/changeRetrospectively.modal.html',
          backdrop: 'static',
          size: 'md',
        });

      askchangeRetrospectively.result.then(function (apply) {
        if (apply === undefined) {
          return;
        }
        var saveFunction = periodType === 'deletion' ? self.saveDeletionPeriodMonths : self.saveWithdrawalPeriodDays;
        if(apply){
          self.retrospective[periodType] = true;
        }
        saveFunction();
      });
    };

    self.saveDeletionPeriodMonths = function () {
      return clientApi
        .custom('model/Organization', 'updateDeletionPeriod', { months: self.periods.deletionPeriodMonths, retrospectiveMemberUpdate: self.retrospective.deletion })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.personnel.general.deletionPeriods.saveDeletionPeriodSuccessMsg'),
            $translate.instant('modules.administration.personnel.general.deletionPeriods.saveDeletionPeriodSuccessTitle')
          );
          $state.reload();
        });
    };

    self.saveWithdrawalPeriodDays = function () {
      if(self.periods.withdrawalPeriodDays >= 1){
        return clientApi
          .custom('model/Organization', 'updateWithdrawalPeriod', { days: self.periods.withdrawalPeriodDays, retrospectiveMemberUpdate: self.retrospective.withdrawal })
          .then(function () {
            toastr.success(
              $translate.instant('modules.administration.personnel.general.deletionPeriods.saveWithdrawalSuccessMsg'),
              $translate.instant('modules.administration.personnel.general.deletionPeriods.saveWithdrawalSuccessTitle')
            );
            $state.reload();
          });
      }else{
        toastr.error(
          $translate.instant('modules.administration.personnel.general.deletionPeriods.saveWithdrawalFailedTooShortMsg'),
          $translate.instant('modules.administration.personnel.general.deletionPeriods.saveWithdrawalFailedTooShortTitle')
        );
        self.periods.withdrawalPeriodDays = 1;
      }
    };

    self.formatInput = function(val) {
      self.periods.deletionPeriodMonths = (Math.round(val) || 1);
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.statistics', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.statistics', {
        url: '/statistics',
        templateUrl: 'app/pages/administration/statistics/statistics.html',
        title: 'navigation.administration.statistics',
        controller: 'StatisticCtrl as $ctrl',
        resolve: {
          selectedCtx: function(commonUtils) {
            return (commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.administration.statistics.assign.distributor'
            }) || [])[0];
          },
          permitted: function (permissions) {
            return permissions.isPermittedAnywhere('arno.administration.statistics.assign.distributor');
          },
          statisticHierarchy: function (clientApi, selectedCtx) {
            return clientApi.custom('model/StatisticGroup', 'getStatisticGroups', { divisionIds: selectedCtx });
          },
          statistics: function (clientApi, selectedCtx) {
            return clientApi.custom('model/Statistic', 'findStatistics', { divisionIds: selectedCtx });
          },
          usingMembers: function (clientApi, organizationId, selectedCtx, permissions, statistics) {
            if (permissions.isPermittedInSome('arno.administration.statistics.assign.distributor', 'Division', [selectedCtx])
              || permissions.isPermittedInEvery('arno.administration.statistics.assign.distributor', 'Organization', [organizationId])
            ) {
              var statisticsItemNames = statistics.filter(function(stat) {
                return stat && typeof stat.ItemPermissionInternalName === 'string' && stat.ItemPermissionInternalName.trim() !== '';
              })
                .map(function(stat) {
                  return stat && stat.ItemPermissionInternalName ? stat.ItemPermissionInternalName: null;
                });

              return clientApi.custom('model/Statistic', 'getUsingMembers', { context: selectedCtx, statisticsItemNames: statisticsItemNames })
                .catch(function () {
                  return null;
                });
            }
            return null;
          },
        },
        viewPermission: 'arno.administration.statistics.assign.distributor',
        viewPermissionScopes: ['Organization', 'Division'],
        sidebarMeta: {
          order: 7,
        },
      });
  }
})();


(function(){
  'use strict';

  angular
		.module('BlurAdmin.pages.administration.statistics')
		.controller('StatisticModalCtrl', StatisticModalCtrl);

  function StatisticModalCtrl(
    $uibModalInstance, commonUtils, clientApi, statistics, $timeout,
    title, description, modalTitle, statistic, statisticGroup, statisticHierarchy
  ) {
    var self = this;
    self.statisticGroup = statisticGroup;
    self.modalTitle = modalTitle;
    self.title = title;
    self.description = description;
    self.statisticHierarchy = statisticHierarchy;

    function activate() {
      self.statistic = statistic || null;

      if (self.statistic && self.statistic.StatisticGroupId != null && statisticGroup && statisticGroup.id) {
        self.statistic.viewSelectedGroup = statisticGroup;
      }
    }

    self.isStatisticTitleExistent = function (statisticTitle) {
      if (statistic) {
        return false;
      }
      return _.find(statistics, function(statistic){
        return statistic && statisticTitle && statistic.Title.toLocaleLowerCase() === statisticTitle.toLocaleLowerCase();
      })
    };

    self.applyModal = function () {
      var assignedGroupIdForStatistic = self.statistic && self.statistic.viewSelectedGroup && self.statistic.viewSelectedGroup.id ? self.statistic.viewSelectedGroup.id : self.statisticGroup.id;

      $uibModalInstance.close({
        Title: self.title,
        Description: self.description,
        StatisticGroupId: assignedGroupIdForStatistic
      });
    };

    // init the controller
    activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.statistics')
    .controller('StatisticGroupModalCtrl', StatisticGroupModalCtrl);

  /** @ngInject */
  function StatisticGroupModalCtrl($uibModalInstance, statisticHierarchy, statisticGroup) {
    var self = this;

    self.statisticGroup = statisticGroup;

    // VIEW-FUNCTIONS
    self.isGroupNameExistent = function (statisticGroupName, exceptionId) {
      return _.find(statisticHierarchy, function (statistic) {
        return statistic.Name
               && statisticGroupName
               && statistic.Name.toLocaleLowerCase() === statisticGroupName.toLocaleLowerCase()
               && statistic.id !== exceptionId;
      });
    };

    self.applyModal = function (name, id, funcTitle, desc, options) {
      $uibModalInstance.close({
        name: name,
        desc: desc,
        id: id,
        options: options || {},
        funcTitle: funcTitle,
        children: self.selectedChildren
      });
    };

  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.statistics')
    .controller('StatisticsEditResponsiblePersonsModalCtrl', editResponsiblePersonsModalCtrl);

  function editResponsiblePersonsModalCtrl(clientApi, $uibModalInstance, commonUtils, item) {
    var $ctrl = this;
    $ctrl.item = item;

    $ctrl.groupByFirstName = function (member) {
      var groupName;
      if (!member.hint) {
        groupName = member.initials.charAt(0);
      } else {
        groupName = 'Hinweis';
      }
      return groupName;
    };

    $ctrl.removeMemberFromUsingMember = function (memberId) {
      var usingMember = [];
      item.UsingMember.forEach(function (member) {
        if (member.id !== memberId) {
          usingMember.push(member);
        }
      });
      $ctrl.item.UsingMember = usingMember;
    };

    $ctrl.searchMembers = function (name, isUsingMember) {
      return clientApi
        .custom('model/Member', 'searchMemberInOrg', { searchName: name })
        .then(function (result) {
          $ctrl.members = result;
          $ctrl.members.forEach(function (m) {
            if (_.find($ctrl.groupMembers, { id: m.id })) {
              m.selected = true;
            }
          });
          if (isUsingMember) {
            $ctrl.members.forEach(function (m) {
              item.UsingMember.forEach(function (member) {
                if (m.id === member.id) {
                  m.selected = true;
                }
              });
            });
          }

          $ctrl.members.push({
            hint: true
          });
        });
    };

    $ctrl.save = function () {
      $uibModalInstance.close($ctrl.item);
    };

    $ctrl.addUsingMember = function () {
      $ctrl.selectedMember.selected = true;
      $ctrl.item.UsingMember.push($ctrl.selectedMember);
      $ctrl.selectedMember = null;
    };

    $ctrl.removeMember = function (member) {
      member.selected = false;
      $ctrl.groupMembers = $ctrl.groupMembers.filter(function (item) {
        return item.id !== member.id;
      });
    };

    $ctrl.responsilbeTypes = [
      {
        name: 'Mitglieder mit Nutzungsrechten',
        noMemberMessage: 'Keine Mitglieder mit Nutzungsrechten zugewiesen.',
        removeMethod: function (memberId) {
          $ctrl.removeMemberFromUsingMember(memberId);
        },
        addMethod: function () {
          $ctrl.addUsingMember();
        },
        members: function () {
          return $ctrl.item.UsingMember;
        },
        isUsingMember: true
      }
    ];
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.withdrawal')
    .controller('WithdrawalListCtrl', WithdrawalListCtrl);

  /** @ngInject */
  function WithdrawalListCtrl($scope, $rootScope, clientApi, commonUtils, $uibModal, toastr, historyData, fetchHistoryData, $translate) {
    var $ctrl = this;
    $ctrl.historyData = historyData;
    $ctrl.fetchHistoryData = fetchHistoryData;

    $ctrl.reasonAdd = function (panel) {
      var addModal = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/withdrawal/modals/handleReason.html',
          size: 'md',
          controller: 'HandleReasonWithdrawal as $ctrl',
          resolve: {
            data: {
              isDiv: panel.isDiv
            },
          },
        });

      addModal.result.then(function (newReasonData) {
        if (newReasonData.reasonName) {
          return clientApi
            .custom('model/WithdrawalReasons', 'addReason', { reason: newReasonData.reasonName, isDiv: panel.isDiv })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminWithdrawl.exitReasonWasDeposited'), $translate.instant('modules.administration.adminWithdrawl.exitReasonAdded'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        } else {
          toastr.error($translate.instant('modules.administration.adminWithdrawl.exitReasonDeposited'), $translate.instant('modules.administration.adminWithdrawl.exitReasonRequired'));
        }
      });
    };

    $ctrl.reasonDelete = function (reasonId, reasonText, panel) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/withdrawal/modals/deleteReason.html',
          size: 'md',
          controller: function ($scope) {
            $scope.deletionElement = reasonText;
          }
        })
        .result
        .then(function () {
          return clientApi
            .custom('model/WithdrawalReasons', 'deleteReason', { reasonId: reasonId })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminWithdrawl.exitReasonWasRemove'), $translate.instant('modules.administration.adminWithdrawl.exitReasonDeleted'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        });
    };

    $ctrl.reasonEdit = function (reasonId, oldReasonText, panel) {
      var editModal = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/withdrawal/modals/handleReason.html',
          size: 'md',
          controller: 'HandleReasonWithdrawal as $ctrl',
          resolve: {
            data: {
              reasonId: reasonId,
              reasonName: oldReasonText
            },
          },
        });
      editModal.result.then(function (newReasonData) {
        if (newReasonData.reasonName) {
          return clientApi
            .custom('model/WithdrawalReasons', 'editReason', {
              reasonId: reasonId,
              reasonText: newReasonData.reasonName
            })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminWithdrawl.exitReasonWasUpdated'), $translate.instant('modules.administration.adminWithdrawl.exitReasonChanged'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        } else {
          toastr.error($translate.instant('modules.administration.adminWithdrawl.exitReasonDeposited'), $translate.instant('modules.administration.adminWithdrawl.exitReasonRequired'));
        }
      });
    };

    $ctrl.getReasons = function (params, panel) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * panel.pageSize || 0,
          limit: panel.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      panel.isLoading = true;
      return clientApi
        .custom('model/WithdrawalReasons', 'getReasons', { isDiv: panel.isDiv, queryWishes: queryWishes })
        .then(function (results) {
          if(results){
            panel.displayedCollection = results;
            panel.isLoading = false;
            params.pagination.numberOfPages = Math.ceil(results.count / panel.pageSize);
          }else{
            params.pagination.numberOfPages = 0;
          }

        });
    };
    $ctrl.getHistoryData = function (params) {
      $ctrl.historyPanel.isLoading = true;
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * $ctrl.historyPanel.pageSize || 0,
          limit: $ctrl.historyPanel.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };

      return fetchHistoryData(queryWishes)
        .then(function (results) {
          if(results.rows.length>0){
            results.rows.forEach(function(entry){
              var parsedJSON = JSON.parse(entry.JSONData);
              if(!parsedJSON.oldValue){
                parsedJSON.oldValue='---';
              }
              if(!parsedJSON.newValue){
                parsedJSON.newValue='---';
              }
              entry.parsedJSON = parsedJSON;
            });
            $ctrl.historyPanel.displayedCollection = results || {rows:[], count:0};
            params.pagination.numberOfPages = Math.ceil($ctrl.historyPanel.displayedCollection.count / $ctrl.historyPanel.pageSize);
          }else{
            params.pagination.numberOfPages=0;
          }
          $ctrl.historyPanel.isLoading = false;
        });
    };
    $ctrl.historyPanel = {
      title: $translate.instant('modules.administration.adminWithdrawl.adminHistory'),
      isLoading: true,
      pageSize: 10,
      tableCtrl:{},
      displayedCollection : [],
      getData: function (params, ctrl) {
        $ctrl.historyPanel.tableCtrl = ctrl || $ctrl.historyPanel.tableCtrl;
        $ctrl.getHistoryData(params);
      },
      reloadTable: function () {
        if($ctrl.historyPanel.tableCtrl && $ctrl.historyPanel.tableCtrl.tableState){
          return $ctrl.historyPanel.getData($ctrl.historyPanel.tableCtrl.tableState(), null);
        }
      },
      changePageSize: function(num) {
        $ctrl.historyPanel.pageSize = commonUtils.getPageSize('del_list_reason_history_page_size', num);
        $ctrl.historyPanel.reloadTable();
      }
    };
    $ctrl.historyPanel.changePageSize();

    $ctrl.displayPanels = [
      {
        title: $translate.instant('modules.administration.adminWithdrawl.orgaReasons'),
        isDiv: false,
        pageSize: 10,
        displayedCollection : [],
        changePageSize: function(num) {
          this.pageSize = commonUtils.getPageSize('del_list_reason_org_page_size', num);
          this.reloadTable();
        }
      },
      {
        title: $translate.instant('modules.administration.adminWithdrawl.divReasons'),
        isDiv: true,
        pageSize: 10,
        displayedCollection : [],
        changePageSize: function(num) {
          this.pageSize = commonUtils.getPageSize('del_list_reason_div_page_size', num);
          this.reloadTable();
        }
      }
    ];
    $ctrl.displayPanels.forEach(function (panel) {
      panel.tableCtrl = {};
      panel.getData = function (params, ctrl) {
        panel.tableCtrl = ctrl || panel.tableCtrl;
        $ctrl.getReasons(params, panel);
      };
      panel.reloadTable = function (panel) {
        if(panel && panel.tableCtrl){
          return panel.getData(panel.tableCtrl.tableState(), null);
        }
      }
      panel.changePageSize();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.qualifications')
    .controller('QualificationCtrl', QualificationCtrl);

  /** @ngInject */
  function QualificationCtrl($rootScope, $uibModal, clientApi, qualificationHierarchy, isOnOrganizationLevel,
    toastr, type, $state, screenSize, divisionId, isPermitted, organizationId, ctxSelected, $translate) {

    var self = this;
    self.isPermitted = isPermitted;
    self.allowOrgSelection = true;
    self.qualificationHierarchy = qualificationHierarchy;
    self.orgLevel = isOnOrganizationLevel;
    self.organizationId = organizationId;
    self.ctxSelected = ctxSelected;
    self.type = type;

    self.translateValues = type === 'qualification' ? {
      typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
      typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups')
    } : { 
      typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
      typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
      typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
      typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups')
    }

    self.mediaSizeXs = screenSize.on('xs', function (match) {
      self.mediaSizeXs = match;
    });

    self.openGroup = function (modalPage, qualificationGroup) {
      var preOpenQualificationGroup = _.cloneDeep(qualificationGroup);
      $uibModal.open(
        {
          controller: 'QualificationGroupModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/personnel/qualifications/qualificationGroupModal/' + modalPage + '.html',
          size: 'md',
          resolve: {
            qualificationHierarchy: function () {
              return qualificationHierarchy;
            },
            qualificationGroup: function () {
              return qualificationGroup;
            },
            type: function () {
              return self.type;
            }
          }
        }).result
        .then(function (result) {
          self.children = result.children;
          self[result.funcTitle](result); // call ctrl function, like self.addQualificationGroup()
        })
        .catch(function () {
          // reset qualificationGroup properties if modal window was canceled
          // this will prevent unvalidated or unsaved data to be displayed in list
          _.merge(qualificationGroup, preOpenQualificationGroup); // merge to keep object reference
        });
    };

    self.addQualificationGroup = function (modalResult) {
      return clientApi
        .custom('model/QualificationGroup', 'addQualificationGroup', {
          qualificationName: modalResult.name,
          divisionId: divisionId,
          type: self.type
        })
        .then(function (result) {
          result.Qualifications = [];
          result.DivisionId = result.DivisionId ? parseInt(result.DivisionId, 10) : result.DivisionId;
          self.qualificationHierarchy.push(result);
          toastr.success($translate.instant('modules.administration.adminQualification.qualificationGroupSuccessfullyCreated', Object.assign(modalResult.translateValues, { name: modalResult.name })),
            $translate.instant('modules.administration.adminQualification.groupCreated', modalResult.translateValues));
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminQualification.qualificationGroupErrorOnCreate', Object.assign(modalResult.translateValues, { name: modalResult.name })),
            $translate.instant('modules.administration.adminQualification.addFailed'));
          $state.reload();
        });
    };

    self.editQualificationGroup = function (modalResult) {
      return clientApi
        .custom('model/QualificationGroup', 'updateOneQualificationGroup', {
          id: modalResult.id,
          name: modalResult.name,
          divisionId: divisionId,
          type: self.type
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.adminQualification.qualificationGroupSuccessfullyEdited', Object.assign(modalResult.translateValues, { name: modalResult.name })),
            $translate.instant('modules.administration.adminQualification.groupEdited', modalResult.translateValues));
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminQualification.qualificationGroupErrorOnEdit', Object.assign(modalResult.translateValues, { name: modalResult.name })),
            $translate.instant('modules.administration.adminQualification.updateFailed'));
          $state.reload();
        });
    };

    self.deleteQualificationGroup = function (modalResult) {
      clientApi
        .custom('model/QualificationGroup', 'getQualificationGroupDeletable', {
          groupId: modalResult.id,
          divisionId: divisionId,
          type: self.type
        })
        .then(function (result) {
          if (result && result.Qualifications && result.Qualifications.length) {
            var blockingQualifications = {};
            var blockingCount = 0;
            result.Qualifications.forEach(function (blockingQualification) {
              blockingQualifications[blockingQualification.Division && blockingQualification.Division.Name
                || $rootScope.ctx.organization.current.name] = blockingQualification.Name;
              blockingCount += 1;
            });
            var blockingKeys = Object.keys(blockingQualifications);
            toastr.error($translate.instant('modules.administration.adminQualification.qualificationGroupErrorOnDeleteBlocking', Object.assign(modalResult.translateValues, { count: blockingCount, blockingKeys: blockingKeys })),
              $translate.instant('modules.administration.adminQualification.deleteIsFailed'));
            return blockingQualifications;
          }
          return null;
        })
        .then(function (blocking) {
          if (!blocking) {
            return clientApi
              .custom('model/QualificationGroup', 'deleteQualificationGroup', {
                groupId: modalResult.id,
                divisionId: divisionId,
                type: self.type
              })
              .then(function () {
                self.qualificationHierarchy.splice(self.qualificationHierarchy.indexOf(_.find(self.qualificationHierarchy, { id: modalResult.id })), 1);
                toastr.success($translate.instant('modules.administration.adminQualification.qualificationGroupSuccessfullyDeleted', modalResult.translateValues),
                  $translate.instant('modules.administration.adminQualification.groupDeleted', modalResult.translateValues));
              })
              .catch(function () {
                toastr.error(toastr.error($translate.instant('modules.administration.adminQualification.qualificationGroupErrorOnDelete', Object.assign(modalResult.translateValues, { name: modalResult.name }))),
                  $translate.instant('modules.administration.adminQualification.deleteFailed'));
                $state.reload();
              });
          }
          return null;
        });
    };

    self.openQualification = function (modalPage, qualificationGroup, qualification) {
      var preOpenQualification = _.cloneDeep(qualification);
      $uibModal.open(
        {
          controller: 'QualificationModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/personnel/qualifications/qualificationModal/' + modalPage + '.html',
          size: 'lg',
          resolve: {
            qualificationHierarchy: function () {
              return qualificationHierarchy;
            },
            qualificationGroup: function () {
              return qualificationGroup;
            },
            qualification: function () {
              return qualification;
            },
            parentQualifications: function () {
              return qualification ? clientApi.custom('model/Qualification',
                'getParentQualification',
                {
                  id: qualification.id,
                  withInclude: true,
                  divisionId: divisionId,
                  type: self.type
                }) : null;
            },
            childQualifications: function () {
              return qualification ? clientApi.custom('model/Qualification',
                'getIncludedQualification',
                {
                  id: qualification.id,
                  withInclude: true,
                  divisionId: divisionId,
                  type: self.type
                }) : null;
            },
            type: function () {
              return self.type
            }
          }
        }).result
        .then(function (result) {
          self.children = result.children;
          self[result.funcTitle](result); // call ctrl function, like self.addQualification()
        })
        .catch(function () {
          // reset qualification properties if modal window was canceled
          // this will prevent unvalidated or unsaved data to be displayed in list
          _.merge(qualification, preOpenQualification);
        });
    };

    self.addQualification = function (modalResult) {
      return clientApi
        .custom('model/Qualification', 'addEditQualification', {
          qualification: modalResult.qualification,
          changes: modalResult.changes,
          divisionId: divisionId,
        })
        .then(function (result) {
          var actQualificationGroup = _.find(self.qualificationHierarchy, { id: result.QualificationGroupId });
          actQualificationGroup.Qualifications = actQualificationGroup.Qualifications || [];
          actQualificationGroup.Qualifications.push(result);
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.adminQualification.qualificationSuccessfullyCreated', Object.assign(modalResult.translateValues, { name: modalResult.qualification.Name })),
            $translate.instant('modules.administration.adminQualification.qualificationCreated', modalResult.translateValues));
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminQualification.qualificationErrorOnCreate', Object.assign(modalResult.translateValues, { name: modalResult.qualification.Name })),
            $translate.instant('modules.administration.adminQualification.addFailed'));
          $state.reload();
        });
    };

    self.editQualification = function (modalResult) {
      return clientApi
        .custom('model/Qualification', 'addEditQualification', {
          qualification: modalResult.qualification,
          changes: modalResult.changes,
          divisionId: divisionId,
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.adminQualification.qualificationSuccessfullyEdited', Object.assign(modalResult.translateValues, { name: modalResult.qualification.Name })),
            $translate.instant('modules.administration.adminQualification.qualificationEdited', modalResult.translateValues));
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminQualification.qualificationErrorOnEdit', Object.assign(modalResult.translateValues, { name: modalResult.qualification.Name })),
            $translate.instant('modules.administration.adminQualification.updateFailed'));
          $state.reload();
        });
    };

    self.deleteQualification = function (modalResult) {
      return clientApi
        .custom('model/Qualification', 'deleteQualificationAndLinks', {
          id: modalResult.qualification.id,
          divisionId: divisionId,
          type: self.type
        })
        .then(function () {
          self.qualificationHierarchy.forEach(function (qualificationGroup) {
            if (qualificationGroup.Qualifications && qualificationGroup.Qualifications.length) {
              var deletedQualification = _.find(qualificationGroup.Qualifications, { id: modalResult.qualification.id });
              if (deletedQualification) {
                qualificationGroup.Qualifications.splice(qualificationGroup.Qualifications.indexOf(deletedQualification), 1);
              }
            }
          });
          toastr.success($translate.instant('modules.administration.adminQualification.qualificationSuccessfullyDeleted', modalResult.translateValues),
            $translate.instant('modules.administration.adminQualification.qualificationDeleted', modalResult.translateValues));
        })
        .catch(function () {
          toastr.error(toastr.error($translate.instant('modules.administration.adminQualification.qualificationErrorOnDelete', Object.assign(modalResult.translateValues, { name: modalResult.qualification.Name }))),
            $translate.instant('modules.administration.adminQualification.deleteFailed'));
          $state.reload();
        });
    };

    self.runCalc = function() {
      return clientApi.emit('personnel/calculateMemberQualificationValidityDates', { organizationId: organizationId })
        .then(function() {
          toastr.success('Die Berechnung der Daten wurde gestartet.', 'Berechnung gestartet');
        })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.fileStorage', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.fileStorage', {
        url: '/fileStorage',
        templateUrl: 'app/pages/administration/personnel/fileStorage/fileStorage.html',
        title: 'navigation.administration.personnel.fileStorage',
        controller: 'fileCtrl',
        controllerAs: '$ctrl',
        sidebarMeta: {
          order: 900,
        },
        resolve: {
          infoboxText: function(clientApi) {
            return clientApi.custom('model/FileStorageConfig', 'getConfig', {
              configKey: 'FILE-STORAGE_INFO-TEXT'
            })
          },
          folderData: function(clientApi, commonUtils, $rootScope) {
            return clientApi.custom('model/FileStorageFolder', 'getFoldersForOrg', { storageIdent: 'dossier' })
              .then(function(result) {
                return commonUtils.fileStorage.buildFolderTree(result, { rootOrg: $rootScope.ctx.organization.current.name });
              });
          }
        },
        viewPermission: 'arno.personnel.administration.files.manage',
        viewPermissionScopes: ['Organization'],
      });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.personnel.fileStorage')
    .controller('fileCtrl', fileCtrl);

  /** @ngInject */
  function fileCtrl($rootScope, $scope, $state, baModalService, permissions, clientApi, commonUtils,
    infoboxText, toastr, folderData, $translate) {
    var self = this;

    self.folderData = folderData;

    self.infoboxTextContent = infoboxText.Content ? infoboxText.Content : '';
    self.infoboxTextContentPristine = self.infoboxTextContent;
    self.markdownEditorConfig = {
      autofocus: true,
      language: $translate.use(),
      fullscreen: {
        enable: false
      },
      iconlibrary: 'fa',
      addExtraButtons: true
    }

    self.viewPermSelector = {
      edit: $translate.instant('modules.administration.adminFileStorage.viewPermSelectorEdit'),
      view: $translate.instant('modules.administration.adminFileStorage.viewPermSelectorView'),
    };

    self.saveText = function() {
      clientApi.custom('model/FileStorageConfig', 'upsertFileStorageConfig', {
        configKey: 'FILE-STORAGE_INFO-TEXT',
        content: self.infoboxTextContent
      })
      .then(function() {
        toastr.success($translate.instant('modules.administration.adminFileStorage.infotextWasSuccessSave'), $translate.instant('modules.administration.adminFileStorage.saveIsFinish'))
        self.infoboxTextContentPristine = self.infoboxTextContent;
      })
      .catch(function() {
        toastr.error($translate.instant('modules.administration.adminFileStorage.infotextCantSuccessSave'), $translate.instant('modules.administration.adminFileStorage.saveIsFailed'))
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.clearances')
    .controller('ClearanceCtrl', ClearanceCtrl);

  function ClearanceCtrl(
    $uibModal, commonUtils, toastr, clientApi, $state, divisionList,
    ArnoDashAdminClearancesService, ArnoDashAdminClearancesGroupsService,
    clearanceHierarchy, clearances, organizationId, $timeout, initiatingMembers,
    editingMembers, divisionId, permitted, $rootScope, permissions, unassignedClearances, $translate
  ) {
    var self = this;

    // CONSTS
    self.CLEARANCES_TYPES_LABELS = {
      SIMPLE: $translate.instant('models.Approval.Type.SIMPLE'),
      COMPLEX: $translate.instant('models.Approval.Type.COMPLEX')
    }

    // VARS
    self.clearances = clearances;
    self.permitted = permitted;
    self.clearanceHierarchy = clearanceHierarchy;
    self.organizationId = organizationId;
    self.childrenDivs = commonUtils.findAllChildrensBy(divisionList, 'ParentDivisionId', { id: divisionId[0] }, 'id');

    // manual clearance-group for unassigned clearances/approvals
    self.unassignedClearanceGroup = {
      viewExpando: {
        tabWasOpenOnce: true,
        tabOpen: false, // could be done in view with ng-init too, or sep-var
      },
      Approvals: unassignedClearances
    }

    if (initiatingMembers && editingMembers) {
      self.clearanceResponsiblePersons = getClearancesResponsiblePersons(self.clearances);
    }

    self.editingItem = null;

    // METHODS
    self.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    };

    self.openEditResponsiblePersons = function (item, clearanceGroupId) {
      if (clearanceGroupId) {
        // get all clearances from that group for bulk edits
        var selectedClearances = self.clearanceResponsiblePersons.filter(function(clr) {
          return clr.ClearanceGroupId === clearanceGroupId;
        });

        var selectedClearanceIds = selectedClearances.map(function(clr) {
          return clr.Clearance.id
        })
        // just give an empty item, crucial is just that we pass the array of ids later since the edited contents will be the same for all of them
        item = {
          InitiatingMember: [],
          AcceptingMember: [],
        };
      }
      $uibModal.open({
        controller: 'EditResponsiblePersonsModalCtrl as $ctrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/personnel/clearances/editResponsiblePersonsModal/editResponsiblePersonsModal.html',
        size: 'md',
        resolve: {
          item: function () {
            // Let's clone the object
            self.editingItem = JSON.parse(JSON.stringify(item));
            return self.editingItem;
          },
          isBulk: function () {
            return !!clearanceGroupId;
          }
        }
      })
        .result
        .then(function (editedItem) {
          var changes = findChanges(selectedClearances || [item], editedItem, clearanceGroupId ? true : false)
          return clientApi.custom('model/Approval', 'updateChanges', {
            initiatingMemberChanges: changes.initiatingMemberChanges,
            acceptingMemberChanges: changes.acceptingMemberChanges,
            divisionId: divisionId,
            approvalIds: selectedClearanceIds || item.Clearance.id,
          })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminClearances.theReleaseManagerWasChanged'), $translate.instant('modules.administration.adminClearances.changeSuccess'));

              $state.reload();
            })
            .catch(function () {
              toastr.error($translate.instant('modules.administration.adminClearances.theReleaseManagerCantChanged'), $translate.instant('modules.administration.adminClearances.changeFailed'));
            });
        });
    };

    self.pushToSubDivs = function(clearanceGroupId, clearanceId) {
      $uibModal.open({
        controller: 'ApprovalConfirmCopyCtrl as $ctrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/personnel/clearances/clearanceModal/confirmSubDivCopy.html',
        size: 'md',
      })
        .result
        .then(function (opts) {
          var selectedClearances = self.clearanceResponsiblePersons.filter(function(clr) {
            if (clearanceGroupId) {
              return clr.ClearanceGroupId === clearanceGroupId;
            }
            return clr.Clearance.id === clearanceId;
          }).map(function(clr) {
            return {
              id: clr.Clearance.id,
              InitiatingMember: clr.InitiatingMember.map(function(initMem) {
                return initMem.id
              }),
              AcceptingMember: clr.AcceptingMember.map(function(accMem) {
                return accMem.id
              })
            }
          })
          return clientApi.custom('model/Approval', 'updateForSubDivisions', {
            approvals: selectedClearances,
            divisionIds: self.childrenDivs,
            opts: opts.options,
          })
          .then(function () {
            toastr.success($translate.instant('modules.administration.adminClearances.releaseManagerWasChangedIn') + self.childrenDivs.length + $translate.instant('modules.administration.adminClearances.underDivCopy'), $translate.instant('modules.administration.adminClearances.changeSuccess'));

            $state.reload();
          })
          .catch(function () {
            toastr.error($translate.instant('modules.administration.adminClearances.releaseManagerCantCopy'), $translate.instant('modules.administration.adminClearances.changeFailed'));
          });
        })
    }

    function findChanges(initialClearances, editedClearance, noEmptyOverride) {
      var initiatingMemberChanges = {};
      var acceptingMemberChanges = {};
      var imc;
      var amc;
      var editInitMemIds = editedClearance.InitiatingMember.map(function (member) {
        return member.id
      })
      var editAccMemIds = editedClearance.AcceptingMember.map(function (member) {
        return member.id
      })
      initialClearances.forEach(function(clr) {
        initiatingMemberChanges[clr.Clearance.id] = {
          added: [],
          removed: []
        }
        acceptingMemberChanges[clr.Clearance.id] = {
          added: [],
          removed: []
        }
        imc = initiatingMemberChanges[clr.Clearance.id];
        amc = acceptingMemberChanges[clr.Clearance.id];
        var origInitMemIds = clr.InitiatingMember.map(function (member) {
          return member.id
        })
        var origAccMemIds = clr.AcceptingMember.map(function (member) {
          return member.id
        })

        if (!noEmptyOverride || editInitMemIds.length) {
          imc.removed = imc.removed.concat(_.difference(origInitMemIds, editInitMemIds));
        }
        imc.added = imc.added.concat(_.difference(editInitMemIds, origInitMemIds));

        if (!noEmptyOverride || editAccMemIds.length) {
          amc.removed = amc.removed.concat(_.difference(origAccMemIds, editAccMemIds));
        }
        
        amc.added = amc.added.concat(_.difference(editAccMemIds, origAccMemIds));
        imc.removed = _.uniq(imc.removed); 
        imc.added = _.uniq(imc.added); 
        amc.removed = _.uniq(amc.removed); 
        amc.added = _.uniq(amc.added); 
      })
      return { initiatingMemberChanges: initiatingMemberChanges, acceptingMemberChanges: acceptingMemberChanges };
    }

    // GROUP-CONTROLLER
    self.openGroup = function (modalPage, clearanceGroup) {
      var preOpenClearanceGroup = angular.copy(clearanceGroup);

      $uibModal.open(
        {
          controller: 'ClearanceGroupModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/personnel/clearances/clearanceGroupModal/' + modalPage + '.html',
          size: 'md',
          resolve: {
            clearanceHierarchy: function () {
              return clearanceHierarchy;
            },
            clearanceGroup: function () {
              return clearanceGroup;
            }
          }
        }).result
        .then(function (result) {
          self.children = result.children;
          self[result.funcTitle](result); // call ctrl function, like self.addClearanceGroup()
        })
        .catch(function () {
          // reset clearanceGroup properties if modal window was canceled
          // this will prevent unvalidated or unsaved data to be displayed in list
          _.merge(clearanceGroup, preOpenClearanceGroup); // merge to keep object reference
        });
    };

    self.addClearanceGroup = function (modalResult) {
      return clientApi
        .custom('model/ClearanceGroup', 'addClearanceGroup', {
          clearanceGroupName: modalResult.name,
        })
        .then(function (result) {
          result.Clearances = [];
          result.DivisionId = result.DivisionId ? parseInt(result.DivisionId, 10) : result.DivisionId;
          self.clearanceHierarchy.push(result);
          toastr.success($translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.wasSuccessAdd'), $translate.instant('modules.administration.adminClearances.releaseGroupAdded'));
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.cantCreate')
            + $translate.instant('modules.administration.adminClearances.anotherPersonHasCreated'),
            $translate.instant('modules.administration.adminClearances.createIsFailed')
          );

          $state.reload();
        })
        .finally(function () { // its always good to refresh this dynamic list from the available data again
          self.clearanceResponsiblePersons = getClearancesResponsiblePersons(self.clearances);
        });
    };

    self.editClearanceGroup = function (modalResult) {
      return clientApi.custom('model/ClearanceGroup', 'updateOneClearanceGroup', {
        groupId: modalResult.id,
        name: modalResult.name,
      })
        .then(function () {
          toastr.success($translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.wasSuccessEdited'), $translate.instant('modules.administration.adminClearances.groupEdited'));
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.cantUpdated'),
            $translate.instant('modules.administration.adminClearances.updateFailed')
          );

          $state.reload();
        });
    };

    self.deleteClearanceGroup = function (modalResult) {
      // check for fullDelete option flag and delete clearances in group if neccessary
      var isFullDelete = modalResult.options ? modalResult.options.fullDelete : false;

      return ArnoDashAdminClearancesGroupsService.deleteGroup(modalResult.id, isFullDelete)
        .then(function (results) {
          clearanceHierarchy.splice(clearanceHierarchy.indexOf(_.find(clearanceHierarchy, { id: modalResult.id })), 1);

          // check, which delete operations were performed, and show according message
          if (!isFullDelete) {
            toastr.success(
              $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.wasSuccessDelete'),
              $translate.instant('modules.administration.adminClearances.deleteGroup')
            );

            // if it wasnt a full delete then add the clearances from the deleted group to the unassigned-group list
            if (results && results.group.Approvals && results.group.Approvals.length > 0) {
              // update the clearances/approvals information
              self.clearances = self.clearances.map(function (clearance) {
                var foundChangedClearance = _.find(results.group.Approvals, { id: clearance.id });

                if (foundChangedClearance && foundChangedClearance.id) {
                  return foundChangedClearance;
                }

                return clearance;
              });

              // Update list of unlinked clearances
              self.unassignedClearanceGroup.Approvals = _.uniqBy(_.concat(self.unassignedClearanceGroup.Approvals, results.group.Approvals), 'id');
            }
          } else {
            if (results.fullDeleteSucces == false) {
              toastr.warning(
                $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.wasSuccessfulDeleteForRelease'),
                'Gruppe gelöscht, Freigaben noch vorhanden'
              );
            } else {
              toastr.success(
                $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.andYourReleasesWasSuccessDeleted'),
                $translate.instant('modules.administration.adminClearances.groupDeleteReleaseDelete')
              );

              // update the list of clearances: remove the clearances/approvals fromt he cached-list, because no state-reload is made for the clearance-groups
              self.clearances = _.filter(self.clearances, function(clearance)  {
                return !_.find(results.group.Approvals, { id: clearance.id });
              });
            }
          }
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminClearances.theClearanceGroup') + modalResult.name + $translate.instant('modules.administration.adminClearances.cantDelete'),
            $translate.instant('modules.administration.adminClearances.deleteFailed')
          );

          $state.reload();
        })
        .finally(function () { // its always good to refresh this dynamic list from the available data again
          self.clearanceResponsiblePersons = getClearancesResponsiblePersons(self.clearances);
        });
    };

    self.openClearance = function (page, clearanceGroup, clearance, size, modalTitle) {
      $uibModal.open({
        controller: 'ClearanceModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/personnel/clearances/clearanceModal/' + page + '.html',
        size: size,
        resolve: {
          clearanceGroup: function () {
            return clearanceGroup;
          },
          clearances: function () {
            return self.clearances;
          },
          modalTitle: function () {
            return modalTitle;
          },
          clearance: function () {
            return clearance;
          },
          clearanceHierarchy: function () {
            return clearanceHierarchy;
          },
        }
      })
        .result.then(function (result) {
          if (clearance != undefined) {
            clearance.Title = result.Title;
            clearance.Type = result.Type;
            clearance.Description = result.Description;
            clearance.LetterTitle = result.LetterTitle;
            clearance.Reminder1Title = result.Reminder1Title;
            clearance.Reminder2Title = result.Reminder2Title;
            clearance.ResubmissionTitle = result.ResubmissionTitle;
            clearance.InspectionTitle = result.InspectionTitle;
            clearance.ClearanceGroupId = result.ClearanceGroupId;
            clearance.AllowRejected = result.AllowRejected;
            clearance.MaxResubTimeDays = result.MaxResubTimeDays;
            clearance.MaxResubTimeMonths = result.MaxResubTimeMonths;
            clearance.MaxResubTimeYears = result.MaxResubTimeYears;

            self.updateClearance(clearance, organizationId);
            toastr.success($translate.instant('modules.administration.adminClearances.theReleaseWasSuccessChange'), $translate.instant('modules.administration.adminClearances.changeSuccess'));
          } else {
            self.addToApproval(
              result.Title,
              result.Type,
              result.Description,
              result.LetterTitle,
              result.Reminder1Title,
              result.Reminder2Title,
              result.ResubmissionTitle,
              result.InspectionTitle,
              organizationId,
              result.ClearanceGroupId,
              result.AllowRejected,
              result.MaxResubTimeDays,
              result.MaxResubTimeMonths,
              result.MaxResubTimeYears
            );
            toastr.success($translate.instant('modules.administration.adminClearances.theReleaseWasSuccessAdded'), $translate.instant('modules.administration.adminClearances.addedSuccessful'));
          }

          $state.reload();
        });
    }
    self.addToApproval = function (title, type, description, letterTitle, reminder1Title, reminder2Title, resubmissionTitle,
     inspectionTitle, orgId, clearanceGroupId, allowRejected, resubMaxDays, resubMaxMonths, resubMaxYears) {
      clientApi.custom('model/Approval', 'createApproval', {
        approval: {
          Title: title,
          Type: type,
          Description: description,
          LetterTitle: letterTitle,
          Reminder1Title: reminder1Title,
          Reminder2Title: reminder2Title,
          ResubmissionTitle: resubmissionTitle,
          InspectionTitle: inspectionTitle,
          ClearanceGroupId: clearanceGroupId,
          AllowRejected: allowRejected,
          MaxResubTimeDays: resubMaxDays,
          MaxResubTimeMonths: resubMaxMonths,
          MaxResubTimeYears: resubMaxYears,
        }
      });
    };
    self.updateClearance = function (clearance) {
      $timeout(function () {
        clientApi.custom('model/Approval', 'updateOneApproval', {
          approvalId: clearance.id,
          approval: {
            Title: clearance.Title,
            Type: clearance.Type,
            Description: clearance.Description,
            LetterTitle: clearance.LetterTitle,
            Reminder1Title: clearance.Reminder1Title,
            Reminder2Title: clearance.Reminder2Title,
            ResubmissionTitle: clearance.ResubmissionTitle,
            InspectionTitle: clearance.InspectionTitle,
            ClearanceGroupId: clearance.ClearanceGroupId,
            AllowRejected: clearance.AllowRejected,
            MaxResubTimeDays: clearance.MaxResubTimeDays,
            MaxResubTimeMonths: clearance.MaxResubTimeMonths,
            MaxResubTimeYears: clearance.MaxResubTimeYears,
          }
        });
      });
    };
    self.deleteThisClearance = function (page, clearanceGroup, clearance, size) {
      $uibModal.open({
        controller: 'ClearanceModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          clearanceGroup: function () {
            return clearanceGroup;
          },
          title: function () {
            return null;
          },
          description: function () {
            return null;
          },
          reminder1Title: function () {
            return null;
          },
          reminder2Title: function () {
            return null;
          },
          resubmissionTitle: function () {
            return null;
          },
          letterTitle: function () {
            return null;
          },
          inspectionTitle: function () {
            return null;
          },
          clearances: function () {
            return null;
          },
          modalTitle: function () {
            return null;
          },
          clearance: function () {
            return clearance;
          },
          clearanceHierarchy: function () {
            return clearanceHierarchy;
          }
        }
      })
        .result
        .then(function () {
          clientApi.custom('model/Approval', 'deleteApproval', {
            approvalId: clearance.id,
          })
            .then(function() {
              toastr.success(
                $translate.instant('modules.administration.adminClearances.theClearanceWasSuccessDelete'),
                $translate.instant('modules.administration.adminClearances.clearanceDeleted')
              );
  
              $state.reload();
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.administration.adminClearances.clearanceDeleteFailed'),
                $translate.instant('modules.administration.adminClearances.theClearanceCantDelete')
              );
            })
        });
    };

    // VIEW-FUNCTIONS
    self.onChangeClearanceGroupAssignment = function (clearance) {
      $timeout(function () {
        clearance.viewChangingSelectedGroup = true;

        ArnoDashAdminClearancesService.changeGroup(clearance, clearance.viewSelectedGroup.id)
          .then(function () {
            toastr.success(
              $translate.instant('modules.administration.adminClearances.theClearanceWasGroupAdded') + clearance.viewSelectedGroup.Name + $translate.instant('modules.administration.adminClearances.successAdded'),
              $translate.instant('modules.administration.adminClearances.assignGroup')
            );

            $state.reload();
          })
          .catch(function () {
            toastr.error(
              $translate.instant('modules.administration.adminClearances.theClearanceCantGroupAdded') + clearance.viewSelectedGroup.Name + $translate.instant('modules.administration.adminClearances.tryAgainLater'),
              $translate.instant('modules.administration.adminClearances.cantAssignGroup')
            );
          })
          .finally(function () {
            // unblock select-field for the affected clearance
            clearance.viewChangingSelectedGroup = false;
          });
      });
    }

    // HELPERS
    function getClearancesResponsiblePersons(clearances) {
      return clearances.map(function (clearance) {
        var clearanceData = {
          Clearance: {
            id: clearance.id,
            Title: clearance.Title,
            Type: clearance.Type,
            Description: clearance.description,
          },
          InitiatingMember: [],
          AcceptingMember: [],
          ClearanceGroupId: clearance.ClearanceGroupId,
        };

        if (initiatingMembers) {
          initiatingMembers.forEach(function (memberData) {
            if (memberData.Approvals.indexOf(clearance.id) !== -1) {
              clearanceData.InitiatingMember.push(memberData.Member);
            }
          });
        }

        if (editingMembers) {
          editingMembers.forEach(function (memberData) {
            if (memberData.Approvals.indexOf(clearance.id) !== -1) {
              clearanceData.AcceptingMember.push(memberData.Member);
            }
          });
        }
        return clearanceData;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.blockage')
    .controller('BlockageListCtrl', BlockageListCtrl);

  /** @ngInject */
  function BlockageListCtrl($scope, $rootScope, clientApi, commonUtils, $uibModal, toastr, historyData, fetchHistoryData, $translate) {
    var $ctrl = this;
    $ctrl.historyData = historyData;
    $ctrl.fetchHistoryData = fetchHistoryData;

    $ctrl.reasonAdd = function (panel) {
      var addModal = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/blockage/modals/handleReason.html',
          size: 'md',
          controller: 'HandleReasonBlockage as $ctrl',
          resolve: {
            data: {
              isDiv: panel.isDiv
            },
          },
        });

      addModal.result.then(function (newReasonData) {
        if (newReasonData.reasonName) {
          return clientApi
            .custom('model/BlockReasons', 'addReason', { reason: newReasonData.reasonName, isDiv: panel.isDiv })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminBlockage.lockReasonWasDeposited'), $translate.instant('modules.administration.adminBlockage.lockReasonAdded'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        } else {
          toastr.error($translate.instant('modules.administration.adminBlockage.lockReasonMustDeposited'), $translate.instant('modules.administration.adminBlockage.lockReasonRequired'));
        }
      });
    };

    $ctrl.reasonDelete = function (reasonId, reasonText, panel) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/blockage/modals/deleteReason.html',
          size: 'md',
          controller: function ($scope) {
            $scope.deletionElement = reasonText;
          }
        })
        .result
        .then(function () {
          return clientApi
            .custom('model/BlockReasons', 'deleteReason', { reasonId: reasonId })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminBlockage.deleteLockReasonSuccess'), $translate.instant('modules.administration.adminBlockage.lockReasonDeleted'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        });
    };

    $ctrl.reasonEdit = function (reasonId, oldReasonText, panel) {
      var editModal = $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/administration/personnel/blockage/modals/handleReason.html',
          size: 'md',
          controller: 'HandleReasonBlockage as $ctrl',
          resolve: {
            data: {
              reasonId: reasonId,
              reasonName: oldReasonText
            },
          },
        });
      editModal.result.then(function (newReasonData) {
        if (newReasonData.reasonName) {
          return clientApi
            .custom('model/BlockReasons', 'editReason', {
              reasonId: reasonId,
              reasonText: newReasonData.reasonName
            })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminBlockage.lockReasonWasUpdated'), $translate.instant('modules.administration.adminBlockage.changedLockReason'));
              panel.reloadTable(panel);
              $ctrl.historyPanel.reloadTable();
            });
        } else {
          toastr.error($translate.instant('modules.administration.adminBlockage.lockReasonMustDeposited'), $translate.instant('modules.administration.adminBlockage.lockReasonRequired'));
        }
      });
    };

    $ctrl.getReasons = function (params, panel) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * panel.pageSize || 0,
          limit: panel.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      panel.isLoading = true;
      return clientApi
        .custom('model/BlockReasons', 'getReasons', { isDiv: panel.isDiv, queryWishes: queryWishes })
        .then(function (results) {
          if(results){
            panel.displayedCollection = results;
            panel.isLoading = false;
            params.pagination.numberOfPages = Math.ceil(results.count / panel.pageSize);
          }else{
            params.pagination.numberOfPages = 0;
          }

        });
    };
    $ctrl.getHistoryData = function (params) {
      $ctrl.historyPanel.isLoading = true;
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * $ctrl.historyPanel.pageSize || 0,
          limit: $ctrl.historyPanel.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };

      return fetchHistoryData(queryWishes)
        .then(function (results) {
          if(results.rows.length>0){
            results.rows.forEach(function(entry){
              var parsedJSON = JSON.parse(entry.JSONData);
              if(!parsedJSON.oldValue){
                parsedJSON.oldValue='---';
              }
              if(!parsedJSON.newValue){
                parsedJSON.newValue='---';
              }
              entry.parsedJSON = parsedJSON;
            });
            $ctrl.historyPanel.displayedCollection = results || {rows:[], count:0};
            params.pagination.numberOfPages = Math.ceil($ctrl.historyPanel.displayedCollection.count / $ctrl.historyPanel.pageSize);
          }else{
            params.pagination.numberOfPages=0;
          }
          $ctrl.historyPanel.isLoading = false;
        });
    };
    $ctrl.historyPanel = {
      title: $translate.instant('modules.administration.adminWithdrawl.adminHistory'),
      isLoading: true,
      pageSize: 10,
      tableCtrl:{},
      displayedCollection : [],
      getData: function (params, ctrl) {
        $ctrl.historyPanel.tableCtrl = ctrl || $ctrl.historyPanel.tableCtrl;
        $ctrl.getHistoryData(params);
      },
      reloadTable: function () {
        if($ctrl.historyPanel.tableCtrl && $ctrl.historyPanel.tableCtrl.tableState){
          return $ctrl.historyPanel.getData($ctrl.historyPanel.tableCtrl.tableState(), null);
        }
      },
      changePageSize: function(num) {
        $ctrl.historyPanel.pageSize = commonUtils.getPageSize('block_list_reason_history_page_size', num);
        $ctrl.historyPanel.reloadTable();
      }
    };
    $ctrl.historyPanel.changePageSize();

    $ctrl.displayPanels = [
      {
        title: $translate.instant('modules.administration.adminBlockage.reasonOfDiv'),
        isDiv: false,
        pageSize: 10,
        displayedCollection : [],
        changePageSize: function(num) {
          this.pageSize = commonUtils.getPageSize('block_list_reason_org_page_size', num);
          this.reloadTable();
        }
      },
      {
        title: $translate.instant('modules.administration.adminBlockage.reasonOfOrga'),
        isDiv: true,
        pageSize: 10,
        displayedCollection : [],
        changePageSize: function(num) {
          this.pageSize = commonUtils.getPageSize('block_list_reason_div_page_size', num);
          this.reloadTable();
        }
      }
    ];
    $ctrl.displayPanels.forEach(function (panel) {
      panel.tableCtrl = {};
      panel.getData = function (params, ctrl) {
        panel.tableCtrl = ctrl || panel.tableCtrl;
        $ctrl.getReasons(params, panel);
      };
      panel.reloadTable = function (panel) {
        if(panel && panel.tableCtrl){
          return panel.getData(panel.tableCtrl.tableState(), null);
        }
      };
      panel.changePageSize();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.permissions', [])
    .controller('PermissionCtrl', PermissionCtrl);

  function PermissionCtrl($uibModal, $state, clientApi, includedPermission, roles, ctxSelected,
    memberRoles, toastr, permissionGroups, divisionMember, divisionList, permissions, divisionId, organizationId, $translate) {

    var self = this;

    self.permissions = permissions;
    self.currentDivision = divisionId;
    self.ctxSelected = ctxSelected;
    self.allowOrgSelection = true;
    self.roles = roles;

    function fnBind(retVal) {
      // used as a shorthand to bind simple resolve values
      return function () {
        return retVal;
      };
    }

    self.formattedRoles = (function () {
      if (includedPermission.length > 0 && self.roles.length > 0) {
        return _.chain(includedPermission)
          .groupBy('RoleId')
          .map(function (value, key) {
            return {
              RoleId: Number(key),
              RoleName: value[0].RoleName,
              Description: value[0].Description,
              PermissionId: _.map(value, function (o) {
                return o.PermissionId;
              }),
              formattedPermissions: _.filter(value, function(role) {
                return (typeof role.PermissionName === 'string' && role.PermissionName.trim() !== '');
              })
              .map(function (o) {
                return {
                  Name: o.PermissionName,
                  Description: o.PermissionDescription || '',
                }
              }),
              RoleAssignable: value[0].RoleAssignable,
              Immutable: value[0].Immutable,
            }
          })
          .value();
      }
    })();

    self.openRoleData = function(name, data) {
      $uibModal.open(
        {
          controller: 'PermissionRoleDataModalCtrl as $modalCtrl',
          templateUrl: 'app/pages/administration/permissions/permissionModalTemplate/roleDataModalTemplate.html',
          resolve: {
            permissions: function () {
              return data.includedPermsContent;
            },
            name: function () {
              return name;
            }
          }
        })
    }

    self.formattedMemberRoles = (function () {
      if (memberRoles.length > 0) {
        return _.chain(memberRoles)
          .groupBy('MemberId')
          .map(function (value, key) {
            return {
              MemberId: Number(key),
              MemberFirstName: value[0].Firstname,
              MemberLastName: value[0].Lastname,
              fullName: value[0].Firstname + ' ' + value[0].Lastname,
              RoleId: _.map(value, function (o) {
                return o.RoleId;
              }),
              RoleName: _.map(value, function (o) {
                return o.Name;
              }),
              Assignable: _.map(value, function (o) {
                return o.Assignable;
              })
            }
          })
          .filter(function (roleItem) {
            var unassignableCount = 0;
            roleItem.Assignable.forEach(function(assignable) {
              if (!assignable) {
                unassignableCount++;
              }
            })
            if (unassignableCount === roleItem.Assignable.length) {
              return false;
            }
            return true;
          })
          .value();
      }
    })();

    self.formattedPermissionGroups = (function () {
      if (permissionGroups && permissionGroups.length > 0) {
        return _.chain(permissionGroups)
          .groupBy('PermissionGroupId')
          .map(function (permGroup, key) {
            var uniqGroupsMemberId = _.uniqBy(permGroup, 'MemberId');

            return {
              id: Number(key),
              Description: permGroup[0].PermissionDescription,
              GroupName: permGroup[0].PermissionGroupName,
              Static: permGroup[0].IsStaticPermissionGroup,
              MemberEmail: _.map(_.uniqBy(permGroup, 'MemberEmail'), function (o) {
                return o.MemberEmail;
              }),
              MemberId: _.map(uniqGroupsMemberId, function (o) {
                return o.MemberId;
              }),
              MemberFullName: _.map(uniqGroupsMemberId, function (o) {
                return (o.MemberFirstName && o.MemberLastName ? o.MemberFirstName + ' ' + o.MemberLastName : null);
              }),
              MemberFirstName: _.map(uniqGroupsMemberId, function (o) {
                return o.MemberFirstName;
              }),
              MemberLastName: _.map(uniqGroupsMemberId, function (o) {
                return o.MemberLastName;
              }),
              RoleId: _.map(_.uniqBy(permGroup, 'RoleId'), function (o) {
                return o.RoleId;
              })
                .filter(function (val) {
                  return !!val;
                }),
              RoleName: _.map(_.uniqBy(permGroup, 'RoleName'), function (o) {
                return o.RoleName;
              })
                .filter(function (val) {
                  return !!val;
                })
            }
          })
          .value();
      }
    })();

    self.fetchTooltipCache = {};

    self.fetchTooltip = function (memberRole, role, formattedRoles) {
      self.fetchTooltipCache[memberRole.MemberId] = self.fetchTooltipCache[memberRole.MemberId] || {};

      if (self.fetchTooltipCache[memberRole.MemberId][role]) {
        return self.fetchTooltipCache[memberRole.MemberId][role];
      }

      var includedPerms = _.flatten(
        (formattedRoles || [])
          .filter(function (includedRole) {
            return includedRole.RoleName === role;
          })
          .map(function (includedRole) {
            return includedRole.formattedPermissions;
          })
      );

      includedPerms.sort();

      self.fetchTooltipCache[memberRole.MemberId][role] = {
        includedPermsContent: includedPerms,
        isAggregated: true,
      };

      return self.fetchTooltipCache[memberRole.MemberId][role];
    };

    self.open = function (page, size, selectedItem, selectState, group) {
      $uibModal.open({
        controller: 'PermissionModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          roles: fnBind(self.formattedRoles),
          selectedItem: fnBind(selectedItem),
          selectState: fnBind(selectState),
          permittedMembers: fnBind(self.formattedMemberRoles),
          selectedGroup: fnBind(group),
          groups: fnBind(self.formattedPermissionGroups),
          organizationId: fnBind(organizationId),
          divisionId: fnBind(divisionId),
          divisionList: fnBind(divisionList),
          fetchTooltip: fnBind(self.fetchTooltip)
        }
      })
        .result
        .then(function (result) {
          if (!result.deletedName && self.currentDivision) {
            self.setDivisionRoleMember(result.memberId, result.roles, result.memberName);
          } else if (self.currentDivision) {
            self.removeDivisionRoleMember(result.memberId, result.deletedName);
          } else if (!result.deletedName) {
            self.setOrganizationRoleMember(result.memberId, result.roles, result.memberName);
          } else {
            self.removeOrganizationRoleMember(result.memberId, result.deletedName);
          }
        });
    };

    self.setDivisionRoleMember = function (memId, roleIds, name) {
      return clientApi.custom('model/Member', 'setDivisionRoles', {
        memId: memId,
        divId: self.currentDivision,
        roleIds: roleIds
      })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.adminPerm.permissionAddSuccToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.permissionAddSuccToastTitle')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.adminPerm.permissionAddErrToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.permissionAddErrToastTitle')
          );
        });
    };

    self.removeDivisionRoleMember = function (memId, name) {
      return clientApi.custom('model/Member', 'setDivisionRoles', {
        memId: memId,
        divId: self.currentDivision,
        roleIds: [],
      })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.adminPerm.permissionRemoveSuccToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.permissionRemoveSuccToastTitle')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.adminPerm.permissionRemoveErrToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.permissionRemoveErrToastTitle')
          );
        });
    };

    self.setOrganizationRoleMember = function (memId, roleIds, name) {
      clientApi.custom('model/Member', 'setOrganizationRoles', {
        memId: memId,
        roleIds: roleIds,
      })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.adminPerm.orgPermissionAddSuccToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.orgPermissionAddSuccToastTitle')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.adminPerm.orgPermissionAddErrToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.orgPermissionAddErrToastTitle')
          );
        });
    };

    self.removeOrganizationRoleMember = function (memId, name) {
      return clientApi.custom('model/Member', 'setOrganizationRoles', {
        memId: memId,
        roleIds: [],
      })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.adminPerm.orgPermissionRemoveSuccToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.orgPermissionRemoveSuccToastTitle')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.adminPerm.orgPermissionRemoveErrToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.orgPermissionRemoveErrToastTitle')
          );
        });
    };

    self.setMemberColor = function (id) {
      return !!(
        (divisionMember || [])
          .filter(function (dMember) {
            return dMember.id == id;
          })
          .length
      );
    };

    self.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    self.divisionSelectorEntryPermission = 'arno.administration.permissions.manage';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.permissions')
    .controller('PermissionRoleDataModalCtrl', PermissionRoleDataModalCtrl);

  function PermissionRoleDataModalCtrl($uibModalInstance, name, permissions) {
    var self = this;
    self.roleName = name;
    self.permissions = _.sortBy(permissions, function(x) {
      return x.Name;
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.permissions')
    .controller('PermissionModalCtrl', PermissionModalCtrl);

  function PermissionModalCtrl($scope, $uibModalInstance, $q, $state, clientApi, commonUtils, roles,
    selectedItem, selectState, permittedMembers, toastr, selectedGroup, groups, organizationId, $translate,
    divisionId, divisionList, fetchTooltip, baModalService) {

    var self = this;

    self.roles = roles.filter(function (role) {
      return role.RoleAssignable || role.RoleAssignable === undefined;
    });

    self.roleIds = [];
    self.memberIds = [];
    self.groupMembers = [];
    self.division = divisionId;
    self.mode = 'create';
    self.originalName = '';
    self.selectState = selectState;
    self.cKeys = { on: $translate.instant('modules.administration.adminPerm.onlyDivMembers'), off: $translate.instant('modules.administration.adminPerm.allOrgMembers') };

    self.divisionList = divisionList.filter(function(div) {
      return (Number.parseInt || parseInt)(div.id, 10) !== (Number.parseInt || parseInt)(self.division, 10);
    });
    self.divisionMode = !!self.division;

    self.divisionHierarchy = {};
    self.divisionList.forEach(function (division) {
      if (division.ParentDivisionId) {
        var parentId = (Number.parseInt || parseInt)(division.ParentDivisionId, 10);
        var divisionId = (Number.parseInt || parseInt)(division.id, 10);
        self.divisionHierarchy[parentId] = self.divisionHierarchy[parentId] || [];
        self.divisionHierarchy[parentId].push(divisionId);
      }
    });

    if (selectedGroup) {
      self.originalName = selectedGroup.GroupName;
    }

    if (selectedItem && roles) {
      self.curMember = _.cloneDeep(selectedItem);
      self.selectedRoles = self.roles.filter(function (role) {
        return !!~selectedItem.RoleId.indexOf(role.RoleId);
      });
      self.selectedMember = {};
      self.selectedMember.fullName = selectedItem.fullName;
      self.disableMemberChoice = true;
    } else {
      self.selectedRoles = [];
      self.disableMemberChoice = false;
    }

    if (selectedGroup && roles) {
      self.mode = 'edit';
      self.selectedRoles = self.roles.filter(function (role) {
        return !!~selectedGroup.RoleId.indexOf(role.RoleId);
      });
      self.curGroup = _.cloneDeep(selectedGroup);

      for (var i = 0; i < selectedGroup.MemberId.length; i++) {
        if (selectedGroup.MemberId[i]) {
          self.groupMembers.push({
            id: selectedGroup.MemberId[i],
            LastName: selectedGroup.MemberLastName[i],
            FirstName: selectedGroup.MemberFirstName[i],
            Account: {
              EMail: selectedGroup.MemberEmail[i]
            }
          });
        }
      }
    }

    self.searchMembers = function (name) {
      self.q = {
        searchName: name
      };
      self.loadMembers();
    };

    self.groupByFirstName = function (member) {
      var groupName;
      if (!member.hint) {
        groupName = member.initials.charAt(0);
      } else {
        groupName = 'Hinweis';
      }
      return groupName;
    };

    self.applyModal = function (id) {
      if (self.selectedRoles) {
        for (var i = 0; i < self.selectedRoles.length; i++) {
          self.roleIds.push(self.selectedRoles[i].RoleId);
        }
      }

      $uibModalInstance.close({
        memberName: self.selectedMember.fullName || self.curMember.fullName,
        memberId: self.selectedMember.id || self.curMember.MemberId,
        roles: self.roleIds,
        id: id
      });
    };

    self.confirmDelete = function (memberId, memberName) {
      $uibModalInstance.close({
        memberId: memberId,
        deletedName: memberName
      });
    };

    self.fetchTooltip = fetchTooltip;

    self.loadMembers = function () {
      var addHintEntry = function (result) {
        return result.concat([{ hint: true }]);
      }
      if (self.divisionMode === true) {
        return clientApi
          .custom('model/Member', 'findByDivisionId', {
            divisionId: divisionId,
            searchName: (self.q && self.q.searchName),
            queryWishes: {
              activeDivisionMember: true,
              nonOffline: true
            }
          })
          .then(function (result) {
            self.members = addHintEntry(result);
          });
      } else {
        return clientApi
          .custom('model/Member', 'findByOrganizationId', {
            searchName: (self.q && self.q.searchName) || '',
            queryWishes: {
              nonOffline: true
            }
          })
          .then(function (result) {
            self.members = addHintEntry(result);
          });
      }
    };

    self.checkForRoles = function (user) {
      if (permittedMembers && roles) {
        self.selectedRoles = [];
        for (var i = 0; i < permittedMembers.length; i++) {
          if (user.id == permittedMembers[i].MemberId) {
            for (var j = 0; j < self.roles.length; j++) {
              if (~permittedMembers[i].RoleId.indexOf(self.roles[j].RoleId)) {
                self.selectedRoles.push(self.roles[j])
              }
            }
          }
        }
      } else {
        self.selectedRoles = [];
      }
    };

    self.addMember = function (member) {
      self.selectedMember = null;
      self.groupMembers.push(member);
    }

    self.removeMember = function (member) {
      var index = _.findIndex(self.groupMembers, function (o) {
        return o.id == member.id;
      })
      self.groupMembers.splice(index, 1);
    };

    self.createGroup = function (name, desc, id) {
      if (self.selectedRoles) {
        for (var i = 0; i < self.selectedRoles.length; i++) {
          self.roleIds.push(self.selectedRoles[i].RoleId);
        }
      }

      if (self.groupMembers) {
        for (i = 0; i < self.groupMembers.length; i++) {
          self.memberIds.push(self.groupMembers[i].id);
        }
      }

      if (self.mode === 'create') {
        return clientApi
          .custom('model/PermissionGroup', 'createPermissionGroup', {
            name: name,
            desc: desc,
            divId: self.division,
            memberIds: self.memberIds,
            roleIds: self.roleIds
          })
          .then(function () {
            toastr.success(
              $translate.instant('modules.administration.adminPerm.permGroupCreateToastText', { name: name }),
              $translate.instant('modules.administration.adminPerm.permGroupCreateToastTitle')
            );
            $uibModalInstance.dismiss();

            $state.reload();
          });
      } else if (self.mode === 'edit') {
        return clientApi
          .custom('model/PermissionGroup', 'updateOnePermissionGroup', {
            groupId: id,
            name: name,
            desc: desc,
            divId: self.division || null,
            memberIds: self.memberIds,
            roleIds: self.roleIds,
          })
          .then(function () {
            toastr.success(
              $translate.instant('modules.administration.adminPerm.permGroupEditToastText', { name: name }),
              $translate.instant('modules.administration.adminPerm.permGroupEditToastTitle')
            );
            $uibModalInstance.dismiss();

            $state.reload();
          });
      }
    };

    self.checkTable = function (id) {
      return _.find(self.groupMembers, function (o) {
        return o.id == id;
      })
    };

    self.removeGroup = function (id, name) {
      return clientApi
        .custom('model/PermissionGroup', 'deletePermissionGroup', { groupId: id, divId: self.division })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.adminPerm.permGroupDeleteToastText', { name: name }),
            $translate.instant('modules.administration.adminPerm.permGroupDeleteToastTitle')
          );
          $uibModalInstance.dismiss();

          $state.reload();
        });
    };

    // REMARK: atm copy permission-groups is only useful for divisions (gliederungen),
    // copying permisson-groups between orgs will likely not arrive. copying permissions from org-level to division-level
    // is currently not a feature, even then its difficult, because some permissions match by name, but most of them will not match
    // and will not have the same permission-mechanic!
    self.copyPermission = function () {
      var i = 0;

      if (!self.curGroup) {
        for (i = 0; i < self.selectedRoles.length; i++) {
          self.roleIds.push(self.selectedRoles[i].RoleId);
        }

        // REMARK: this is now partly refactored, but its better to have a bulkCreate or copy endpoint on api-side and do this job with one request...
        var divisionRoleBulk = [];
        _.forEach(self.divisionList, function(division) {
          if (division.state) {
            divisionRoleBulk.push({
              memId: self.curMember.MemberId,
              divId: division.id,
              roleIds: self.roleIds,
            });
          }
        });

        clientApi.custom('model/Member', 'setDivisionRolesBulk', { divisionRoleBulk: divisionRoleBulk })
          .then(function() {
            toastr.success(
              $translate.instant('modules.administration.adminPerm.permsCopiedToastText', { name: self.curMember.fullName }),
              $translate.instant('modules.administration.adminPerm.permsCopiedToastTitle')
            );
            $uibModalInstance.dismiss();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.administration.adminPerm.permsNotCopiedToastText', { name: self.curMember.fullName }),
              $translate.instant('modules.administration.adminPerm.permsNotCopiedToastTitle')
            );
          });
      } else {
        if (self.selectedRoles) {
          for (i = 0; i < self.selectedRoles.length; i++) {
            self.roleIds.push(self.selectedRoles[i].RoleId);
          }
        }

        if (self.groupMembers) {
          for (i = 0; i < self.groupMembers.length; i++) {
            self.memberIds.push(self.groupMembers[i].id);
          }
        }

        // REMARK: this is now partly refactored, but its better to have a bulkCreate or copy endpoint on api-side and do this job with one request...
        var permissionGroupBulk = [];
        _.forEach(self.divisionList, function(division) {
          if (division.state) {
            permissionGroupBulk.push({
              name: self.curGroup.GroupName,
              desc: self.curGroup.Description,
              divId: division.id,
              memberIds: self.memberIds,
              roleIds: self.roleIds
            });
          }
        });

        clientApi.custom('model/PermissionGroup', 'createPermissionGroupBulk', { permissionGroupBulk: permissionGroupBulk })
          .then(function() {
            toastr.success(
              $translate.instant('modules.administration.adminPerm.copyPermGroupToastText', { name: self.curGroup.GroupName }),
              $translate.instant('modules.administration.adminPerm.copyPermGroupToastTitle')
            );
            $uibModalInstance.dismiss();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.administration.adminPerm.copyPermGroupErrToastText', { name: self.curGroup.GroupName }),
              $translate.instant('modules.administration.adminPerm.copyPermGroupErrToastTitle')
            );
          });
      }
    };

    self.warnModalCopyCountExceeded = function() {
      return baModalService.messageModal({
        modalType: 'warning',
        allowHtml: true,
        title: $translate.instant('modules.administration.adminPerm.warnModalTitle'),
        content: $translate.instant('modules.administration.adminPerm.warnModalContent'),
        primaryActionText: $translate.instant('generalTerms.resume'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
    };

    self.selectAllDivisions = function (collection) {
      return Promise.resolve()
        .then(function () {
          if (!self.allSelectionMode && collection && collection.length > 100) {
            return self.warnModalCopyCountExceeded();
          }
        })
        .then(function() {
          $scope.$evalAsync(function() {
            if (collection && collection.length) {
              collection.forEach(function (item) {
                item.state = !self.allSelectionMode;
              });
            }
            self.allSelectionMode = !self.allSelectionMode;
          })
        })
        .catch(function() {

        });
    };

    self.childDivisionIds = [];
    self.addChildDivisionIds = function(startDivisionId) {
      if (self.divisionHierarchy[startDivisionId]) {
        self.childDivisionIds = self.childDivisionIds.concat(self.divisionHierarchy[startDivisionId]);
        self.divisionHierarchy[startDivisionId].forEach(function(childDivisionId) {
          self.addChildDivisionIds(childDivisionId);
        });
      }
    };
    self.addChildDivisionIds((Number.parseInt || parseInt)(self.division, 10));

    self.selectChildDivisions = function () {
      return Promise.resolve()
        .then(function () {
          if (self.childDivisionIds && self.childDivisionIds.length > 100) {
            return self.warnModalCopyCountExceeded();
          }
        })
        .then(function() {
          $scope.$evalAsync(function() {
            self.divisionList.forEach(function (division) {
              if (~self.childDivisionIds.indexOf((Number.parseInt || parseInt)(division.id, 10))) {
                division.state = true;
              }
            });
            var multiple = self.childDivisionIds.length > 1;
            toastr.info(
              $translate.instant('modules.administration.adminPerm.divSelectToastText', { multiple: multiple, divisionIdLength: self.childDivisionIds.length }),
              $translate.instant('modules.administration.adminPerm.divSelectToastTitle', { multiple: multiple })
            );
          });
        })
        .catch(function() {

        });
    };

    self.validateGroupName = function (name) {
      if (groups) {
        if (name) {
          for (var i = 0; i < groups.length; i++) {
            if (name.toLocaleLowerCase() == groups[i].GroupName.toLocaleLowerCase() && !(self.originalName.toLocaleLowerCase() == groups[i].GroupName.toLocaleLowerCase())) {
              return false;
            } else if (i == groups.length - 1) {
              return true
            }
          }
        }
      } else {
        return true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.activities')
    .controller('ActivityCtrl', ActivityCtrl);

  /** @ngInject */
  function ActivityCtrl($rootScope, activityHierarchy, $uibModal, $window, clientApi, ctx,
    toastr, commonUtils, $state, screenSize, organizationId, ctxSelected, baModalService, $translate) {

    var self = this;
    self.allowOrgSelection = true;
    self.activityHierarchy = activityHierarchy;
    self.orgLevel = !ctx;
    self.divisionId = ctx || null;
    self.ctxSelected = ctxSelected;
    self.organizationId = organizationId;

    self.mediaSizeXs = screenSize.on('xs', function (match) {
      self.mediaSizeXs = match;
    });

    self.openGroup = function (modalPage, activityGroup) {
      var preOpenActivityGroup = _.cloneDeep(activityGroup);
      $uibModal.open(
        {
          controller: 'ActivityGroupModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/personnel/activities/activityGroupModal/' + modalPage + '.html',
          size: 'md',
          resolve: {
            activityHierarchy: function () {
              return activityHierarchy;
            },
            activityGroup: function () {
              return activityGroup;
            },
          }
        }).result
        .then(function (result) {
          self.children = result.children;
          self.activityGroup = result;
          self[result.funcTitle](result); // call ctrl function, like self.addActivityGroup()
        })
        .catch(function () {
          // reset activityGroup properties if modal window was canceled
          // this will prevent unvalidated or unsaved data to be displayed in list
          _.merge(activityGroup, preOpenActivityGroup); // merge to keep object reference
        });
    };

    self.addActivityGroup = function (modalResult) {
      return clientApi
        .custom('model/ActivityGroup', 'addActivityGroup', {
          divisionId: commonUtils.getDivisionFromSingleCtx('arno.administration.personnel.activities.manage') || undefined,
          title: modalResult.name,
        })
        .then(function (result) {
          result.activities = [];
          result.DivisionId = result.DivisionId ? parseInt(result.DivisionId, 10) : result.DivisionId;
          self.activityHierarchy.push(result);
          toastr.success($translate.instant('modules.administration.adminActivities.theActivityGroup') + modalResult.name + $translate.instant('modules.administration.adminActivities.activityGroupWasSuccessDeposited'), $translate.instant('modules.administration.adminActivities.activityGroupDeposited'));
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminActivities.theActivityGroup') + modalResult.name + $translate.instant('modules.administration.adminActivities.cantDepositedActivityGroup') +
          $translate.instant('modules.administration.adminActivities.hasBeenCreated'), $translate.instant('modules.administration.adminActivities.addFailed'));
        });
    };

    self.editActivityGroup = function (modalResult) {
      return clientApi.custom('model/ActivityGroup', 'updateActivityGroup', {
        id: modalResult.id,
        title: modalResult.name,
        divisionId: self.divisionId,
      })
        .then(function () {
          toastr.success($translate.instant('modules.administration.adminActivities.theActivityGroup') + modalResult.name + $translate.instant('modules.administration.adminActivities.wasSuccessEdit'), $translate.instant('modules.administration.adminActivities.activGroupEdit'));
          $state.reload();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminActivities.theActivityGroup') + modalResult.name + $translate.instant('modules.administration.adminActivities.cantUpdated'), $translate.instant('modules.administration.adminActivities.updateFailed'));
          $state.reload();
        });
    };

    // ToDo: Backend -> implement model function
    self.deleteActivityGroup = function (modalResult) {
      clientApi.custom('model/ActivityGroup', 'activityGroupDelete', {
        groupId: modalResult.id,
        divisionId: modalResult.divisionId,
      })
        .then(function (result) {
          if (result.failed && result.failed.length) {
            toastr.error(
              $translate.instant('modules.administration.adminActivities.groupDeleteToastErrText'),
              $translate.instant('modules.administration.adminActivities.groupDeleteToastErrTitle')
            );
          }
          $state.reload();
        });
    };

    self.openActivity = function (windowAction, activityGroup, activity) {
      if (windowAction !== 'add' && windowAction !== 'edit' && windowAction !== 'delete') {
        return null;
      }

      $state.go('arno.administration.personnel.activityWindow', {
        windowAction: windowAction,
        groupId: activityGroup.id,
        activityId: activity ? activity.id : null,
        divisionId: self.divisionId,
        organizationId: activityGroup.OrganizationId || self.organizationId,
      });
    };

    self.activateActivity = function (activity, activityGroup, isActive) {
      activity.Active = isActive;
      return clientApi.custom('model/Activity', 'getActivityDetail', {
        activityId: activity.id,
        divisionId: activityGroup.DivisionId || self.divisionId,
      })
        .catch(function (e) {
          toastr.error();
          throw e;
        })
        .then(function (result) {
          var activityData = result;
          activityData.active = isActive;
          return clientApi.custom('model/Activity', 'createOrUpdateActivity', {
            activity: activityData,
            divisionId: activityGroup.DivisionId || self.divisionId
          })
            .then(function () {
              toastr.success(
                $translate.instant('modules.administration.adminActivities.activityUpdateSuccessToastText'),
                $translate.instant('modules.administration.adminActivities.activityUpdateSuccessToastTitle')
              );
            })
            .catch(function (e) {
              toastr.error();
              throw e;
            })
        })
    };

    self.deleteActivity = function (activity) {
      return baModalService
        .messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: $translate.instant('modules.administration.adminActivities.deleteEventType'),
          content: $translate.instant('modules.administration.adminActivities.willThisActivity') + activity.Title + $translate.instant('modules.administration.adminActivities.reallyDeleteActivity')
                   + $translate.instant('modules.administration.adminActivities.members') + activity.Title + $translate.instant('modules.administration.adminActivities.removePermForever')
                   + '"' + activity.Title + $translate.instant('modules.administration.adminActivities.outArchiv')
                   + $translate.instant('modules.administration.adminActivities.linksAndServices'),
          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel'),
        })
        .then(function() {
          return clientApi
            .custom('model/Activity', 'deleteActivityAndLinks', {
              id: activity.id,
              divisionId: activity.DivisionId || undefined
            })
            .then(function () {
              toastr.success($translate.instant('modules.administration.adminActivities.thisActivity') + activity.Title + $translate.instant('modules.administration.adminActivities.wasSuccessfulDelete'), $translate.instant('modules.administration.adminActivities.activityDeleted'));
            })
            .catch(function () {
              toastr.error($translate.instant('modules.administration.adminActivities.thisActivity') + activity.Title + $translate.instant('modules.administration.adminActivities.cantDelete'), $translate.instant('modules.administration.adminActivities.cantActivityDelete'));
            })
            .then(function() {
              $state.reload();
            })
        })
        .catch(function() {
          // hm k
        })
    }

    self.divisionSelectorEntryPermission = 'arno.administration.personnel.activities.manage';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.materialTypes', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.material.materialTypes', {
        url: '/materialTypes/:category',
        templateUrl: 'app/pages/administration/material/materialTypes/materialTypes.html',
        title: 'navigation.administration.material.materialTypes',
        controller: 'materialTypesCtrl as $ctrl',
        params: {
          category: {
            value: 'Medicine',
          }
        },
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.material.manage');
          },
          materialTypesData: function (clientApi, ctx, $stateParams) {
            return clientApi.custom('model/MaterialType', 'fetchMaterialTypes', {
              divisionId: ctx,
              opts: {
                category: $stateParams.category,
              },
            });
          },
        },
        sidebarMeta: {
          order: 0,
        },
        viewPermission: 'arno.administration.material.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.materialTypes')
    .controller('materialTypesCtrl', materialTypesCtrl);

  /** @ngInject */
  function materialTypesCtrl(
    $uibModal, $rootScope, $state, $stateParams, $translate, commonUtils, toastr, clientApi,
    organizationId, ctx, permissions, stateChangePrompt, materialTypesData, baModalService
  ) {
    var baseAttrs = [
      'id',
      'Name',
      'Description',
      'Category',
      'OrganizationId',
      'DivisionId',
      'BriefingInheritable',
      'BriefingRequired',
      'MaterialsAssignable',
      'AvailableInFinance',
      'ExternalPricePerCount',
      'ExternalPricePerDay',
      'ExternalPricePerHour',
      'InternalPricePerCount',
      'InternalPricePerDay',
      'InternalPricePerHour',
      'ParentMaterialTypeId',
      'OverwrittenMaterialTypeId',
    ];

    var recurseNode = function(node, fn) {
      node.children.forEach(function(childNode) {
        recurseNode(childNode, fn);
      });
      fn(node);
    };

    var setNodeAttrsRecursively = function(nodes) {
      nodes.forEach(function(node) {
        if (node.children.length) {
          node.collapsed = false;
          setNodeAttrsRecursively(node.children);
        } else {
          node.collapsed = true;
        }
      });
    };

    var instantiateMaterialType = function(inheritedAttrs) {
      self.tmpIdCounter++;

      var instance = _.merge({
        id: 'n-' + (self.tmpIdCounter),
        Name: $translate.instant('modules.administration.material.materialTypes.newMaterialType'),
        Description: '',
        children: [],
        OrganizationId: self.currentOrg,
        DivisionId: self.currentDivision ? self.currentDivision : null,
        Category: self.activeCategory,
        BriefingInheritable: false,
        BriefingRequired: false,
        MaterialsAssignable: true,
        AvailableInFinance: self.currentDivision ? true : null,
        ExternalPricePerCount: null,
        ExternalPricePerDay: null,
        ExternalPricePerHour: null,
        InternalPricePerCount: null,
        InternalPricePerDay: null,
        InternalPricePerHour: null,
        ParentMaterialTypeId: null,
        collapsed: false,
        newNode: true,
      }, inheritedAttrs);

      return instance;
    }

    var self = this;

    self.tmpIdCounter = 0;

    self.divisionSelectorEntryPermission = 'arno.administration.material.manage';

    self.allowOrgSelection = true;
    self.treeEnableDrag = false; // todo: check via permission
    self.selectedMaterialType = false;

    self.currentDivision = ctx;
    self.currentOrg = organizationId;

    self.materialTypesData = materialTypesData;

    self.materialTypesTreeData = commonUtils.buildTreeFromFlatArray(self.materialTypesData, 'ParentMaterialTypeId', 'id', null);
    self.displayedInspectionMaterialType = [];

    commonUtils.recurseTree(self.materialTypesTreeData, function (node) {
      node.initialState = _.pick(node, baseAttrs);
    });

    self.initialMaterialTypesTreeData = _.cloneDeep(self.materialTypesTreeData);

    setNodeAttrsRecursively(self.materialTypesTreeData);

    self.treeOptions = {
      beforeDrag: function(sourceNodeScope) {
        if (sourceNodeScope.$modelValue.RootElement) {
          return false;
        } else if (!self.currentDivision) { // if we are in an organization view
          return true;
        }

        // don't allow dragging of organization-type or clone-type nodes
        return sourceNodeScope.$modelValue.DivisionId && !sourceNodeScope.$modelValue.OverwrittenMaterialTypeId;
      },
      beforeDrop: function(event) {
        // Handle cases for Division Material-Types
        if (event.source.nodeScope.$modelValue.DivisionId) {
          if (event.dest.nodesScope.depth() === 0) {
            return false;
          }
        }
      },
      dropped: function(event) {
        if (event.dest.nodesScope && event.dest.nodesScope.depth() > 0) {
          event.source.nodeScope.$modelValue.ParentMaterialTypeId = event.dest.nodesScope.$parent.$modelValue.id;
          event.dest.nodesScope.$parent.$modelValue.collapsed = false;
        } else {
          event.source.nodeScope.$modelValue.ParentMaterialTypeId = null;
        }
      }
    }

    self.tabs = [
      {
        heading: $translate.instant('modules.material.addMaterial.medication'),
        category: 'Medicine',
        icon: 'fa fa-medkit',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.medicalProducts'),
        category: 'MedicalProducts',
        icon: 'fa fa-heartbeat',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.carpool'),
        category: 'Vehicles',
        icon: 'fa fa-car',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.clothing'),
        category: 'Clothing',
        icon: 'ion-tshirt',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.TechnDevices'),
        category: 'Tools',
        icon: 'ion-hammer',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.consumables'),
        category: 'Consumables',
        icon: 'ion-cube',
      },
      {
        heading: $translate.instant('modules.material.addMaterial.other'),
        category: 'Others',
        icon: 'fa fa-archive',
      },
    ];

    self.activeCategory = $stateParams.category ? $stateParams.category : self.tabs[0].category;

    self.activeTabIndex = _.findIndex(self.tabs, {category: self.activeCategory});

    self.switcherKeysText = {
      on: $translate.instant('components.switcherYesNo.on'),
      off: $translate.instant('components.switcherYesNo.off'),
    };

    self.hasNodeChanged = function(node) {
      return !_.isEqual(
        _.pick(node, baseAttrs),
        _.pick(node.initialState, baseAttrs)
      );
    };

    // EVENT-HANDLERS
    self.canDeleteNode = function() {
      if (self.selectedMaterialType) {
        // if in organization and selecting a non-root organization material type
        if (!self.currentDivision) {
          if (!self.selectedMaterialType.DivisionId && !self.selectedMaterialType.RootElement) {
            return true;
          }
        // if in division and selecting a division material type
        } else if (self.selectedMaterialType.DivisionId == self.currentDivision) {
          return true;
        }
      }

      return false;
    }

    self.deleteButtonDisabled = function() {
      if (self.selectedMaterialType.id[0] === 'n') {
        return true;
      } else if (
        self.selectedMaterialType.ParentMaterialTypeId
        && self.selectedMaterialType.id[0] !== 'n'
        && self.selectedMaterialType.ParentMaterialTypeId[0] === 'n'
      ) {
        return true;
      }
      return false;
    }

    self.selectNode = function(node) {
      self.getInspectionMaterialType(null, node.id);
      if (self.prohibitSelectionChange()) {
        toastr.warning(
          $translate.instant('modules.administration.material.materialTypes.toasts.prohibitSelection.text'),
          $translate.instant('modules.administration.material.materialTypes.toasts.prohibitSelection.title')
        );
        return;
      }

      self.selectedMaterialType = node;
    };

    self.canAddNewNode = function() {
      if (!self.currentDivision || self.selectedMaterialType) {
        return true;
      }
      return false
    }

    self.addNewNode = function() {
      if (self.prohibitSelectionChange()) {
        toastr.warning(
          $translate.instant('modules.administration.material.materialTypes.toasts.prohibitSelection.text'),
          $translate.instant('modules.administration.material.materialTypes.toasts.prohibitSelection.title')
        );
        return;
      }

      var newMaterialType;

      if (self.selectedMaterialType) {
        newMaterialType = instantiateMaterialType({
          ParentMaterialTypeId: self.selectedMaterialType.id
        });
        self.selectedMaterialType.children.push(newMaterialType);
        self.selectedMaterialType.collapsed = false;
      } else {
        newMaterialType = instantiateMaterialType();
        self.materialTypesTreeData.push(newMaterialType);
      }
      self.selectedMaterialType = newMaterialType;
    };

    self.denyStateChange = function () {
      var deny = false;

      commonUtils.recurseTree(self.materialTypesTreeData, function (node) {
        if (self.hasNodeChanged(node)) {
          deny = true;
        }
      });

      return deny;
    }

    self.prohibitSelectionChange = function() {
      return self.selectedMaterialType && !self.validateNode(self.selectedMaterialType);
    }

    self.wouldOverwriteMaterialType = function() {
      return self.selectedMaterialType.OverwrittenMaterialTypeId || self.currentDivision && !self.selectedMaterialType.DivisionId
    }

    self.validateField = function(field, type) {
      switch(type) {
      case 'Name':
        return field && field.length && typeof field === 'string'
      default: break;
      }
    }

    self.validateNode = function(node) {
      return self.validateField(node.Name, 'Name');
    };

    self.upsertInspectionMaterialType = function(item) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/modals/inspectionAssignmentModal/addInspection.modal.html',
          size: 'md',
          backdrop: 'static',
          controller: 'addMaterialInspectionCtrl as self',
          resolve: {
            ctx: function() {
              return self.currentDivision;
            },
            excludedIds: function() {
              var excludedIds = [];
              for(var i=0; i < self.displayedInspectionMaterialType.length; i++) {
                if(self.selectedMaterialType && self.selectedMaterialType.id === self.displayedInspectionMaterialType[i].MaterialTypeId) {
                  excludedIds.push(self.displayedInspectionMaterialType[i].InspectionId)
                }                
              } 
              return excludedIds;
            },
            selectedInspection: function() {
              return (item && item.Inspection) || null;
            },
            disableMandatoryChange: function() {
              return false;
            },
            meta: function() {
              if (!item) {
                return null;
              }
              return {
                Mandatory: item.Mandatory,
                Interval: item.Interval,
                Description: item.Description,
              }
            },
            materialMode: function() {
              return false;
            },
            maxInterval: function () {
              return null;
            },
            viewOnly: function () {
              return false;
            },
          },
        })
        .result
        .then(function(res) {
          return clientApi.custom('model/InspectionMaterialType', 'upsertInspectionMaterialType', {
            divisionId: self.currentDivision,
            inspectionId: res.inspection.id,
            materialTypeId: self.selectedMaterialType.id,
            description: res.meta.Description || '', 
            interval: res.meta.Interval, 
            mandatory: res.meta.Mandatory,
          })
        })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.material.inspection.saveInspectionSuccessContent'),
            $translate.instant('modules.administration.material.inspection.saveInspectionSuccessTitle')
          );
          self.getInspectionMaterialType();
        })
        .catch(function(e) {
          if(e) {
            toastr.error(
              $translate.instant('modules.administration.material.inspection.saveInspectionFailContent'),
              $translate.instant('modules.administration.material.inspection.saveInspectionFailTitle')
            )
          }
        })
    }

    self.getInspectionMaterialTypeViaTable = function(params) {
      self.getInspectionMaterialType(params, self.selectedMaterialType.id);
    }

    self.getInspectionMaterialType = function (params, selectedMaterialType) {
      var sel = selectedMaterialType || self.selectedMaterialType;
      if (!sel
          || ((typeof sel === 'string') ? (sel.indexOf('n-') === 0) : sel.newNode)
          || self.wouldOverwriteMaterialType()) {
        return;
      }

      var queryWishes = {};
      if(params) {
        queryWishes = {
          paging: {
            offset: (params.pagination.start / params.pagination.number) * self.itemsPerPage || 0,
            limit: self.itemsPerPage
          },
          sort: {
            by: params.sort.predicate,
            reverse: params.sort.reverse
          },
          search: (params.search || {}).predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined
        };
  
        if (queryWishes.search && !Object.keys(queryWishes.search).length) {
          delete queryWishes.search;
        }
      }      

      return clientApi
        .custom('model/InspectionMaterialType', 'getInspectionMaterialType', { queryWishes: queryWishes, materialTypeId: selectedMaterialType || self.selectedMaterialType.id, divisionId: ctx })
        .then(function (result) {
          if (result) {
            var materialTypeId = selectedMaterialType || self.selectedMaterialType.id;
            var displayedInspectionMaterialType = [];
            for(var i=0; i < result.length; i++) {
              if(result[i].MaterialTypeId === materialTypeId) {
                displayedInspectionMaterialType.push(result[i]);
              }
            }
            for(i=0; i < result.length; i++) {
              if(result[i].MaterialTypeId !== materialTypeId) {
                var inspectionExists = false;
                for(var j=0; j < displayedInspectionMaterialType.length; j++) {
                  if(displayedInspectionMaterialType[j].InspectionId === result[i].InspectionId) {
                    inspectionExists = true;
                  }
                }
                if(!inspectionExists) {
                  displayedInspectionMaterialType.push(result[i]);
                }
              }
            }
            
            self.displayedInspectionMaterialType = displayedInspectionMaterialType;
          }
        });
    };

    self.deleteInspectionMaterialType = function(item) {
      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.administration.material.inspection.modal.deleteInspection'),
        content: $translate.instant('modules.administration.material.inspection.modal.permanentDeleteInspection', { name: item.Inspection.Name }) + '\n\n' +
        $translate.instant('modules.administration.adminDesign.thisActionIsirrevocale'),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
      .then(function() {
        return clientApi
          .custom(
            'model/InspectionMaterialType', 'deleteInspectionMaterialType',
            { divisionId: self.currentDivision, inspectionId: item.InspectionId, materialTypeId: item.MaterialTypeId }
          )
          .then(function() {
            toastr.success(
              $translate.instant('modules.administration.material.inspection.deleteSuccessContent'),
              $translate.instant('modules.administration.material.inspection.deleteSuccessTitle')
            );
            self.getInspectionMaterialType();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.administration.material.inspection.deleteFailContent'),
              $translate.instant('modules.administration.material.inspection.deleteFailTitle')
            )
          })
      })
    }

    self.saveNodes = function() {
      if (self.selectedMaterialType && !self.validateNode(self.selectedMaterialType)) {
        toastr.warning(
          $translate.instant('modules.administration.material.materialTypes.toasts.invalid.text'),
          $translate.instant('modules.administration.material.materialTypes.toasts.invalid.title')
        );
        return;
      }

      var changedNodes = [];

      commonUtils.recurseTree(self.materialTypesTreeData, function (node) {
        if (node.newNode || self.hasNodeChanged(node)) {

          // if currently in a division and node-to-be-saved is from org
          if (self.currentDivision && (!node.DivisionId || node.DivisionId === 'rootOrg')) {
            node = instantiateMaterialType(_.merge(_.omit(node, ['$$hashkey', 'id', 'children']), {
              OverwrittenMaterialTypeId: node.id,
              DivisionId: self.currentDivision,
            }));
          }

          changedNodes.push(_.pick(node, baseAttrs));
        }
      })

      if (changedNodes.length) {
        return clientApi
          .custom('model/MaterialType', 'bulkUpdateMaterialTypes', {
            divisionId: self.currentDivision,
            materialTypes: changedNodes
          })
          .then(function() {
            toastr.success(
              $translate.instant('modules.administration.material.materialTypes.toasts.saveSuccess.text'),
              $translate.instant('modules.administration.material.materialTypes.toasts.saveSuccess.title')
            );

            stateChangePrompt.ignoreNextEvaluation();
            $state.reload();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.administration.material.materialTypes.toasts.saveError.text'),
              $translate.instant('modules.administration.material.materialTypes.toasts.saveError.title')
            );
          });
      } else {
        toastr.info(
          $translate.instant('modules.administration.material.materialTypes.toasts.noChanges.text'),
          $translate.instant('modules.administration.material.materialTypes.toasts.noChanges.title')
        );
      }
    }
    self.checkDeleteViolations = function() {
      if (self.denyStateChange()) {
        return Promise.resolve({errors: {error: 'denyStateChange'}});
      }

      return clientApi.custom('model/MaterialType', 'checkDeleteViolations', {
        divisionId: self.currentDivision,
        materialTypeId: self.selectedMaterialType.id,
      })
    };
    self.deleteSelectedNode = function() {
      self.checkDeleteViolations()
        .then(function(deleteViolation) {

          if (deleteViolation.errors) {
            if (deleteViolation.errors.error === 'denyStateChange') {
              stateChangePrompt.openConfirmModal()
                .then(function() {
                  stateChangePrompt.ignoreNextEvaluation();
                  self.deleteCall();
                })
                .catch(function() {
                  return;
                })
            }

            if (deleteViolation.errors.error === 'materialTypeOverwritten') {

              clientApi.custom('model/MaterialType', 'fetchOverwrittenMaterialTypes', {
                divisionId: self.currentDivision,
                materialTypeId: self.selectedMaterialType.id,
              }).then(function(overwrittenDivisions) {
                $uibModal
                  .open({
                    controller: 'deleteWarningModalCtrl as $modalCtrl',
                    templateUrl: 'app/pages/administration/material/materialTypes/modals/deleteWarningModal.html',
                    resolve: {
                      data: function() {
                        return {
                          modalType: 'overwrittenDivisions',
                          overwrittenDivisions: overwrittenDivisions,
                        }
                      }
                    }
                  })
              });
              return;
            }

            if (deleteViolation.errors.error === 'materialTypeHasDivisionChildren') {
              clientApi.custom('model/MaterialType', 'fetchMaterialTypesDivisionChildren', {
                divisionId: self.currentDivision,
                materialTypeId: self.selectedMaterialType.id,
              }).then(function(divisionChildren) {
                $uibModal
                  .open({
                    controller: 'deleteWarningModalCtrl as $modalCtrl',
                    templateUrl: 'app/pages/administration/material/materialTypes/modals/deleteWarningModal.html',
                    resolve: {
                      data: function() {
                        return {
                          modalType: 'divisionChildren',
                          divisionChildren: divisionChildren,
                        }
                      }
                    }
                  })
              });
              return;
            }


            if (deleteViolation.errors.error === 'materialTypeInUse') {
              toastr.error(
                $translate.instant(deleteViolation.errors.translation + '.text'),
                $translate.instant(deleteViolation.errors.translation + '.title')
              );
            }

            return;
          }

          self.deleteCall();
        });
    }

    self.deleteCall = function() {
      return clientApi.custom('model/MaterialType', 'deleteMaterialType', {
        divisionId: self.currentDivision,
        materialTypeId: self.selectedMaterialType.id,
      })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.material.materialTypes.toasts.deleteSuccess.text'),
            $translate.instant('modules.administration.material.materialTypes.toasts.deleteSuccess.title')
          );

          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.material.materialTypes.toasts.deleteError.text'),
            $translate.instant('modules.administration.material.materialTypes.toasts.deleteError.title')
          );
        });
    }
    self.navigateCategory = function(category) {
      self.activeCategory = category;
      self.activeTabIndex = _.findIndex(self.tabs, {category: self.activeCategory});

      stateChangePrompt.ignoreNextEvaluation();

      $state.go('arno.administration.material.materialTypes', {
        category: category,
      });
    }

    self.setTab = function(tab) {
      if (self.activeCategory === tab.category) {
        return;
      }

      if (self.denyStateChange()) {
        stateChangePrompt.openConfirmModal()
          .then(function() {
            self.navigateCategory(tab.category);
          });
      } else {
        stateChangePrompt.ignoreNextEvaluation();
        self.navigateCategory(tab.category);
      }
    };

    // CONTROLLER-INIT
    self.$onInit = function() {
      // attach function to state change guard
      stateChangePrompt.evaluate(function() {
        return !self.denyStateChange();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.inspection')
    .controller('InspectionCtrl', InspectionCtrl);

  function InspectionCtrl($state, $uibModal, $translate, $scope, commonUtils, clientApi, toastr, validationUtils, ctx) {
    var self = this;
    self.displayedCollection = [];
    self.itemsPerPage = 10;
    
    self.setPageSize = function (num) {
      self.itemsPerPage = num;
    }

    self.openModal = function (modalPage, size, item) {
      $uibModal.open(
        {
          controller: 'InspectionModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/material/inspection/inspectionModal/' + modalPage + '.html',
          size: size,
          resolve: {
            divisionId: function() {
              return ctx
            },
            item: function() {
              return item || {}
            },
            assignmentCount: function() {
              return null;
            }
          }
        }).result
        .then(function (result) {
          self.saveInspection(result)
        })
    };

    self.setInspectionState = function(id, state) {
      return clientApi
        .custom('model/Inspection', 'setInspectionActiveState', { inspectionId: id, state: state, divisionId: ctx })
        .then(function() {
          toastr.success(
            $translate.instant(state ? 'modules.administration.material.inspection.setStateActiveSuccessContent' : 'modules.administration.material.inspection.setStateInactiveSuccessContent'),
            $translate.instant(state ? 'modules.administration.material.inspection.setStateActiveSuccessTitle' : 'modules.administration.material.inspection.setStateInactiveSuccessTitle')
          );
          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.material.inspection.setStateFailContent'),
            $translate.instant('modules.administration.material.inspection.setStateFailTitle')
          )
        })
    }

    self.saveInspection = function(data) {
      return clientApi.custom('model/Inspection', 'upsertInspection', { inspection: data.inspection, divisionId: ctx, overrideExistingIntervals: data.overrideExistingIntervals })
      .then(function() {
        toastr.success(
          $translate.instant('modules.administration.material.inspection.saveInspectionSuccessContent'),
          $translate.instant('modules.administration.material.inspection.saveInspectionSuccessTitle')
        );
        $state.reload();
      })
      .catch(function() {
        self.back = false;
        toastr.error(
          $translate.instant('modules.administration.material.inspection.saveInspectionFailContent'),
          $translate.instant('modules.administration.material.inspection.saveInspectionFailTitle')
        )
      })
    }

    self.getInspections = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.itemsPerPage || 0,
          limit: self.itemsPerPage
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        search: (params.search || {}).predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined
      };

      if (queryWishes.search && !Object.keys(queryWishes.search).length) {
        delete queryWishes.search;
      }

      return clientApi
        .custom('model/Inspection', 'getInspections', { queryWishes: queryWishes, divisionId: ctx })
        .then(function (result) {
          if (result) {
            self.displayedCollection = result.rows;
            params.pagination.numberOfPages = Math.ceil((result.count || 0) / self.itemsPerPage);
          } else {
            params.pagination.numberOfPages = 0;
          }
        });
    };

    self.deleteInspection = function(item) {
      $uibModal.open(
        {
          controller: 'InspectionModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/material/inspection/inspectionModal/deleteInspection.html',
          size: 'md',
          resolve: {
            divisionId: function() {
              return self.currentDivision;
            },
            item: function() {
              return item;
            },
            assignmentCount: function() {
              return null;
            }
          }
        }).result
        .then(function () {
          return item.id;
        })
        .then(function(id) {
          return clientApi
            .custom('model/Inspection', 'deleteInspection', { inspectionId: id, divisionId: ctx })
            .then(function() {
              toastr.success(
                $translate.instant('modules.administration.material.inspection.deleteSuccessContent'),
                $translate.instant('modules.administration.material.inspection.deleteSuccessTitle')
              );
              $state.reload();
            })
            .catch(function() {
              toastr.error(
                $translate.instant('modules.administration.material.inspection.deleteFailContent'),
                $translate.instant('modules.administration.material.inspection.deleteFailTitle')
              )
            })
        })
      
    }

    self.openDetails = function(item) {
      $uibModal.open(
        {
          controller: 'InspectionModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/material/inspection/inspectionModal/editInspection.html',
          size: 'md',
          resolve: {
            divisionId: function() {
              return ctx
            },
            item: function() {
              return item;
            },
            assignmentCount: function() {
              return clientApi
                .custom('model/Inspection', 'getAssignmentCounts', { inspectionId: item.id, divisionId: ctx })
            }
          }
        }).result
        .then(function (result) {
          result.inspection.id = item.id;
          self.saveInspection(result)
        })
    }

    self.ctc = function(key) {
      return commonUtils.copyToClipboard(key);
    }

    self.validationScroll = function (form) {
      validationUtils.validationScroll($scope, form);
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.personnel.fileStorage')
    .controller('matFileCtrl', matFileCtrl);

  /** @ngInject */
  function matFileCtrl($rootScope, $scope, $state, baModalService, permissions, clientApi, commonUtils, toastr, folderData, $translate) {
    var self = this;

    self.folderData = folderData;

    self.viewPermSelector = {
      edit: $translate.instant('modules.administration.material.fileStorage.folderPermEdit'),
      view: $translate.instant('modules.administration.material.fileStorage.folderPermView'),
      item: $translate.instant('modules.administration.material.fileStorage.folderPermItem'),
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.materialExportTemplates', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.material.materialExportTemplates', {
        url: '/materialExportTemplates/:type',
        templateUrl: 'app/pages/administration/material/exportTemplates/materialExportTemplates.html',
        title: 'navigation.administration.material.materialExportTemplates',
        controller: 'MaterialExportTplCtrl as self',
        params: {
          type: {
            value: 'materialMedicalProductBook',
          }
        },
        resolve: {
          docxTemplate: function (clientApi, $stateParams) {
            return clientApi.emit('docxTemplateStorage/check', {
              divisionId: 'rootOrg',
              type: $stateParams.type,
            });
          },
        },
        sidebarMeta: {
          order: 0,
        },
        viewPermission: 'arno.administration.material.templates.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.materialExportTemplates')
    .controller('MaterialExportTplCtrl', MaterialExportTplCtrl);

  function MaterialExportTplCtrl($translate, docxTemplate, $state, $stateParams) {
    var self = this;
    self.docxTemplate = docxTemplate;
    self.type = $stateParams.type;
    self.tabs = [
      {
        heading: $translate.instant('components.templateUpload.materialMedicalProductBook.name'),
        type: 'materialMedicalProductBook',
        // icon: '',
      },
    ];
    self.currentTab = _.find(self.tabs, function(t) {
      return t.type === self.type;
    });
    
    self.setTab = function(tab) {
      $state.go('arno.administration.material.materialExportTemplates', {
        type: tab.type,
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.prices')
    .controller('AdminFinancesPricesTabsCtrl', AdminFinancesPricesTabsCtrl);

  /** @ngInject */
  function AdminFinancesPricesTabsCtrl($state, $translate, ctx, ARNO_CONSTANTS) {
    var self = this;

    self.rootOrgSelected = ctx[0] === 'rootOrg';
    self.PRICE_ITEM_TYPE_ICON = ARNO_CONSTANTS.PRICE_ITEM_TYPE_ICON;

    self.pricesTabs = [
      {
        type: 'CUSTOM',
        route: 'arno.administration.finances.prices.custom'
      },
      {
        type: 'MATERIAL',
        route: 'arno.administration.finances.prices.material'
      },
      {
        type: 'SERVICE_POSITION',
        route: 'arno.administration.finances.prices.servicePosition'
      },
    ]
      .map(function (tab) {
        tab.heading = '<i class="' + self.PRICE_ITEM_TYPE_ICON[tab.type] + '"></i> '
                      + $translate.instant('modules.administration.finances.financePositions.priceItemTypes.' + tab.type);
        return tab;
      })
      .filter(function (tab) {
        return !self.rootOrgSelected || !tab.onlyDivision;
      });

    if (!_.find(self.pricesTabs, { route: $state.current.name })) {
      $state.go(self.pricesTabs[0].route);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.prices')
    .controller('AdminFinancesPricesCtrl', AdminFinancesPricesCtrl);

  /** @ngInject */
  function AdminFinancesPricesCtrl(
    $rootScope, $uibModal, $scope, $state, $translate,
    ARNO_CONSTANTS, MATERIAL_PRICES_VIEWMODE,
    permissions, commonUtils, uxUtils,
    validationUtils, ArnoDashPricesService, ArnoDashMaterialsService, ctx,
    tableConfig, dataProvider, initialData, priceType
  ) {
    // VARS
    var self = this;

    $scope.PRICE_ITEM_TYPE = ARNO_CONSTANTS.PRICE_ITEM_TYPE;

    self.ctx = ctx || [];
    self.divisionId = self.ctx[0] === 'rootOrg' ? null : self.ctx[0];
    self.priceType = priceType;

    self.hasOrgManagePermission = false;
    self.hasDivManagePermission = false;
    self.hasCurrentCtxManagePermission = false;

    self.currentTableConf = {
      title: $translate.instant('modules.administration.finances.prices.overview.title'),
      isOrgList: true,
      tableConfig: tableConfig.tableConfigOrgDefault,
      displayedCollection: (initialData || { rows: [] }).rows,
    }

    // we need to extend the table config specific for the current price-item-type (materials, service-position or custom)
    extendTableConfigByPriceType(self.currentTableConf);

    self.fmpKeys = {
      on: $translate.instant('modules.administration.finances.prices.overview.fmpOn'),
      off: $translate.instant('modules.administration.finances.prices.overview.fmpOff')
    };
    self.fmpHints = {
      on: $translate.instant('modules.administration.finances.prices.overview.fmpOnHint'),
      off: $translate.instant('modules.administration.finances.prices.overview.fmpOffHint')
    };

    $scope.MATERIAL_PRICES_VIEWMODE = MATERIAL_PRICES_VIEWMODE;

    // BOOTSTRAPPER
    /**
     * @name activate
     * @description Function for controller inits
     * @returns {Void} none
     * @memberOf AdminFinancesPricesCtrl#
     */
    function activate() {
      getUiPermissions();

      var recentMaterialsPricesViewMode = localStorage.getItem('recentMaterialsPricesViewMode');
      self.materialPricesViewMode = recentMaterialsPricesViewMode || MATERIAL_PRICES_VIEWMODE.MATERIAL_TYPES;

      if (priceType == ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE) {
        ArnoDashMaterialsService.getMaterialsTypesWithPricesAsTree(ctx, self.currentTableConf.tableConfig.FilterMissingPrices)
          .then(function (results) {
            self.initialMaterialTypesTreeData = results;
          });
      }
    }

    // VIEW-FUNCTIONS
    self.canManageItem = function (priceItem) {
      // NOTE: if the user only has the div-perm, then its still should be possible to edit the price-override (for this div) of the org price-item
      if (priceItem.DivisionId != self.divisionId && (((priceItem || {}).PriceItemOverrides || [])[0] || {}).DivisionId != self.divisionId) {
        return false;
      }
      return (priceItem.DivisionId == null && (self.hasOrgManagePermission || ((priceItem || {}).PriceItemOverrides || []).length))
        || (priceItem.DivisionId != null
            && permissions.isPermittedInEvery('arno.administration.finances.prices.manage', 'Division', [priceItem.DivisionId]));
    }

    self.canOverrideItem = function (priceItem) {
      // overrides of org price-items are atm only allowed for divisions
      return self.divisionId && priceItem && priceItem.DivisionId == null
             && permissions.isPermittedInEvery('arno.administration.finances.prices.manage', 'Division', [self.divisionId])
             && (priceItem.PriceItemOverrides || []).length < 1;
    }

    self.hasPriceDefinition = validationUtils.hasValidPriceDefinition;

    self.getTooltipForMainCol = function (priceItem) {
      return !priceItem.PriceItemOverrides[0] ? (priceItem.DivisionId ? 'modules.administration.finances.prices.overview.divPriceItemTooltip' : 'modules.administration.finances.prices.overview.orgPriceItemTooltip') : 'modules.administration.finances.prices.overview.orgPriceItemOverrideTooltip';
    }

    // EVENT-HANDLERS
    self.addCustomPriceItem = function () {
      ArnoDashPricesService
        .openPriceDetailsModal(self.divisionId, priceType)
        .then(function () {
          $state.reload();
        });
    }

    self.editPriceItem = function (priceItem) {
      if ((priceItem || {}).id) {
        // check, if we have to edit a normal price-item or a price-item-override
        if (!(priceItem.PriceItemOverrides || []).length) {
          ArnoDashPricesService
            .openPriceDetailsModal(self.divisionId, priceType, priceItem)
            .then(function () {
              $state.reload();
            });
        } else {
          self.overridePriceItem(priceItem);
        }
      }
    }

    self.overridePriceItem = function (priceItem) {
      var priceItemOverride = ((priceItem || {}).PriceItemOverrides || [])[0];

      ArnoDashPricesService.openPriceOverrideModal(self.divisionId, self.priceType, priceItemOverride, !(priceItemOverride || {}).id ? priceItem : null)
        .then(function (priceItemOverride) {
          ArnoDashPricesService.overridePriceItem(self.divisionId, self.priceType, priceItem, priceItemOverride).then(function () {
            $state.reload();
          });
        });
    }

    self.deletePriceItem = function (priceItem) {
      if ((priceItem || {}).id) {
        // check, if we have to edit a normal price-item or a price-item-override
        if (!(priceItem.PriceItemOverrides || []).length) {
          ArnoDashPricesService
            .deletePriceItemWithMessageModal(self.divisionId, priceType, priceItem)
            .then(function () {
              $state.reload();
            });
        } else {
          ArnoDashPricesService
            .deletePriceItemOverrideWithMessageModal(priceItem, ((priceItem || {}).PriceItemOverrides || [])[0])
            .then(function () {
              $state.reload();
            });
        }
      }
    }

    if (self.priceType === ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM) {
      self.showCopyOption = true;
    }

    self.copyPriceItem = function (priceItem) {
      return $uibModal
        .open({
          controller: 'CopyDivisionModalCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/modals/copyToDivisionsModal/copyDivision.html',
          size: 'md',
          resolve: {
            baseDivisionId: function () {
              return ((priceItem.PriceItemOverrides || [])[0] || {}).DivisionId || priceItem.DivisionId || null;
            },
            divisionTree: function (commonUtils) {
              return commonUtils.division.treeData()
                .then(function (nodes) {
                  return commonUtils.division.treeDataPermissionFilter(nodes, 'arno.administration.finances.prices.manage');
                });
            },
          }
        })
        .result
        .then(function (divisions) {
          var divisionIds = (divisions || []).map(function (division) {
            return division.id;
          });
          if (divisionIds.length) {
            var priceItemOverride = ((priceItem || {}).PriceItemOverrides || [])[0];
            if (priceItemOverride) {
              return ArnoDashPricesService.overridePriceItem(divisionIds, priceType, priceItem, priceItemOverride)
                .then(function () {
                  $state.reload();
                });
            }
            var bulkPriceItem = _.cloneDeep(priceItem);
            delete bulkPriceItem.id;
            return ArnoDashPricesService.savePriceItemWithNotifications(bulkPriceItem, divisionIds, priceType)
              .then(function () {
                $state.reload();
              });
          }
        });
    }

    self.getData = function (params, ctrl, listType, resetPagination) {
      if (params.pagination.numberOfPages === undefined) {
        // initial call
        params.pagination.numberOfPages = Math.ceil((initialData || { count: 0 }).count / listType.tableConfig.pageSize);
      }

      listType.tableCtrl = ctrl || listType.tableCtrl;

      if (resetPagination == true) {
        params.pagination.start = 1;
      }

      dataProvider({
        paging: {
          limit: listType.tableConfig.pageSize,
          offset: resetPagination == true ? 0 : (params.pagination.start / params.pagination.number) * listType.tableConfig.pageSize || 0,
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
      }, self.currentTableConf.tableConfig.FilterMissingPrices)
        .then(function (result) {
          params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
          self.currentTableConf.displayedCollection = (result.rows || []);
        });
    };

    self.currentTableConf.getData = function (params, ctrl) {
      return self.getData(params, ctrl, self.currentTableConf);
    };

    self.reloadTable = function (listType, resetPagination) {
      if (listType && listType.tableCtrl) {
        return self.getData(listType.tableCtrl.tableState(), null, listType, resetPagination);
      }
    };

    $scope.$watch(function () {
      return self.currentTableConf.tableConfig.FilterMissingPrices;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        storeTableConfig(self.currentTableConf);
        return self.reloadTable(self.currentTableConf, true);
      }
    }, true);

    self.changeMaterialPricesViewMode = function (newViewMode) {
      self.materialPricesViewMode = newViewMode;

      try {
        localStorage.setItem('recentMaterialsPricesViewMode', newViewMode);
      } catch (ex) {
        // hm k
      }
    }

    self.changePageSize = function (listType, num) {
      listType.tableConfig.pageSize = num;
      storeTableConfig(listType);
    };

    self.getFullCSpan = uxUtils.getFullCSpan;

    self.preventPropagation = function (event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    // HELPERS
    function getUiPermissions() {
      self.hasOrgManagePermission = permissions.isPermittedInOrg('arno.administration.finances.prices.manage', [$rootScope.ctx.organization.current.id]);

      // REMARK: this check is only for the SELECTED division, if you want to check for custom-price-item you have to do it separately!
      self.hasDivManagePermission = permissions.isPermittedInEvery('arno.administration.finances.prices.manage', 'Division', self.ctx);

      if (self.ctx.length) {
        self.hasCurrentCtxManagePermission = self.ctx.indexOf('rootOrg') >= 0 ? self.hasOrgManagePermission : self.hasDivManagePermission;
      }
    }

    function storeTableConfig(listType) {
      commonUtils.preference.object.set(
        'pref_custom_prices_table_page_size_' + (listType.isOrgList ? 'org' : 'div'), {
          pageSize: listType.tableConfig.pageSize
        });

      if (listType.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_custom_prices_list_view_' + (listType.isOrgList ? 'org' : 'div'));
      } else {
        // store the id of the currently selected view
        commonUtils.preference.object.set(
          'pref_current_custom_prices_list_view_' + (listType.isOrgList ? 'org' : 'div'),
          { id: listType.selectedView }
        );
      }
    }

    function extendTableConfigByPriceType(currentTableConf) {
      if ((currentTableConf || {}).tableConfig) {
        delete currentTableConf.tableConfig.Title;
        delete currentTableConf.tableConfig.Name;
        delete currentTableConf.tableConfig.Function;

        switch (priceType) {
        case ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM:
          Object.assign(currentTableConf.tableConfig, {
            Title: true,
          });
          break;
        case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE:
        case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL:
          Object.assign(currentTableConf.tableConfig, {
            Name: true,
          });
          break;
        case ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION:
          Object.assign(currentTableConf.tableConfig, {
            Function: true,
          });
          break;
        }
      }
    }

    // CONTROLLER-INIT
    self.$onInit = function () {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.quotationsAndInvoices', [])
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.finances.quotationsAndInvoices', {
        url: '/quotationsAndInvoices/:type',
        templateUrl: 'app/pages/administration/finances/quotationsAndInvoices/quotationsAndInvoices.html',
        title: 'navigation.administration.finances.quotationsAndInvoices',
        controller: 'AdminFinancesQuotationsAndInvoicesCtrl as $ctrl',
        params: {
          type: {
            value: 'quotation',
          }
        },
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.finances.quotationsAndInvoices.manage') || 'rootOrg';
          },
          docxTemplate: function (ctx, clientApi, $stateParams) {
            return clientApi.emit('docxTemplateStorage/check', {
              divisionId: ctx,
              type: $stateParams.type,
            });
          },
        },
        sidebarMeta: {
          order: 5,
        },
        viewPermission: 'arno.administration.finances.quotationsAndInvoices.manage'
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.quotationsAndInvoices')
    .controller('AdminFinancesQuotationsAndInvoicesCtrl', AdminFinancesQuotationsAndInvoicesCtrl);

  /** @ngInject */
  function AdminFinancesQuotationsAndInvoicesCtrl($scope, $state, $stateParams, $translate, organizationId, ctx,
    docxTemplate, FileUploader, clientApi, toastr) {
    if (!_.includes(['quotation', 'invoice', 'reversalInvoice'], $stateParams.type)) {
      $state.go('arno.dashboard');
      toastr.error($translate.instant('generalTerms.invalidPath'), $translate.instant('generalTerms.invalidPath'));
    }
    // VARS
    var self = this;

    self.currentDivision = ctx;
    self.currentOrg = organizationId;

    self.templateType = $stateParams.type;

    self.divisionSelectorEntryPermission = 'arno.administration.finances.quotationsAndInvoices.manage';

    self.docxTemplate = docxTemplate;

    self.tabs = [
      {
        heading: $translate.instant('navigation.finances.quotations'),
        type: 'quotation',
        // icon: '',
      },
      {
        heading: $translate.instant('navigation.finances.invoices'),
        type: 'invoice',
        // icon: '',
      },
      {
        heading: $translate.instant('navigation.finances.reversalInvoices'),
        type: 'reversalInvoice',
        // icon: '',
      }
    ];

    self.activeTabIndex = _.findIndex(self.tabs, { type: self.templateType });

    self.setTab = function (tab) {
      self.activeTabIndex = _.findIndex(self.tabs, { type: self.templateType });
      $state.go('arno.administration.finances.quotationsAndInvoices', {
        type: tab.type,
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.costCenters')
    .controller('AdminFinancesCostCenterCtrl', AdminFinancesCostCenterCtrl);

  /** @ngInject */
  function AdminFinancesCostCenterCtrl(
    $rootScope, $uibModal, $state, permissions,
    ArnoDashCostCentersService, ArnoDashCostCenterSpecificationsService,
    costCenters
  ) {
    // VARS
    var self = this;

    self.countCostCenters = (costCenters || {}).count;
    self.costCenters = (costCenters || {}).rows;
    self.filteredCostCenters = (costCenters || {}).rows;

    self.hasManagePermission = false;

    self.searchTerm = '';

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf AdminFinancesCostCenterCtrl#
    */
    function activate() {
      getUiPermissions();

      getRecentUiSettings();
    }

    // EVENT-HANDLERS
    self.searchTermChanged = function(newValue) {
      var newSearchTerm = newValue || '';

      if (newSearchTerm) {
        self.filteredCostCenters = (self.costCenters || []).filter(function(costCenter) {
          if (typeof (costCenter || {}).Identifier !== 'string' || typeof (costCenter || {}).Name !== 'string') {
            return false;
          }

          return costCenter.Identifier.toUpperCase().indexOf(newSearchTerm.toUpperCase()) > -1
            || costCenter.Name.toUpperCase().indexOf(newSearchTerm.toUpperCase()) > -1
            || (costCenter.CostCenterSpecifications || []).some(function(spec) {
              return spec.Identifier.toUpperCase().indexOf(newSearchTerm.toUpperCase()) > -1 || spec.Name.toUpperCase().indexOf(newSearchTerm.toUpperCase()) > -1
            })
        });
      } else {
        self.filteredCostCenters = self.costCenters;
      }
    }

    self.addCostCenter = function() {
      openCostCenterDetailsModal('app/pages/administration/finances/costCenters/modals/detailsModal.html', 'lg', null);
    }

    self.editCostCenter = function(costCenter) {
      if ((costCenter || {}).id) {
        openCostCenterDetailsModal('app/pages/administration/finances/costCenters/modals/detailsModal.html', 'lg', costCenter);
      }
    }

    self.deleteCostCenter = function(costCenter) {
      if ((costCenter || {}).id) {
        ArnoDashCostCentersService.deleteCostCenterWithMessageModal(costCenter).then(function() {
          $state.reload();
        });
      }
    }

    self.addSpecification = function(costCenter) {
      openCostCenterSpecificationModal('app/pages/administration/finances/costCenters/modals/specificationModal.html', 'md', null, costCenter);
    }

    self.editSpecification = function(costCenterSpecification, costCenter) {
      if ((costCenterSpecification || {}).id) {
        openCostCenterSpecificationModal('app/pages/administration/finances/costCenters/modals/specificationModal.html', 'md', costCenterSpecification, costCenter);
      }
    }

    self.deleteSpecification = function(costCenterSpecification) {
      if ((costCenterSpecification || {}).id) {
        ArnoDashCostCenterSpecificationsService.deleteSpecificationWithMessageModal(costCenterSpecification).then(function() {
          $state.reload();
        });
      }
    }

    self.expandedCostCenterTab = function(costCenterWithTabInfo) {
      if (costCenterWithTabInfo) {
        setRecentUiSettings(Object.assign({}, self.costCenterListConfig, {
          selectedCostCenterId: costCenterWithTabInfo.id
        }));
      }
    }

    self.preventPropagation = function(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    // HELPERS
    function openCostCenterDetailsModal(page, size, costCenter) {
      $uibModal.open({
        controller: 'AdminFinancesCostCenterDetailsModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          selectedCostCenter: function() { return costCenter },
          costCenters: function () { return self.costCenters }
        }
      })
        .result
        .then(function (result) {
          // NOTE: we only check, if  "CostCenterSpecifications" is not empty, when a cost-center is created!
          // We'll handle the requirement, that at least one cost-center-specification must be present,
          // through the checks for the cost-center specification CRUD-actions! This way we still can update
          // only the base fields of a cost-center withput affecting the cost-center-specifications for the update-case
          if(result && result.Name && (result.id || (result.CostCenterSpecifications || []).length)) {
            ArnoDashCostCentersService.saveCostCenterWithNotifications({
              id: result.id || null,

              Identifier: result.Identifier || null,
              Name: result.Name,

              // we dont send "CostCenterSpecifications" info to api, when updating a cost-center
              CostCenterSpecifications: !result.id ? result.CostCenterSpecifications : null,
            }).then(function(newCostCenterData) {
              // if a cost-center was created, then we focus it
              if (result.id == null) {
                self.expandedCostCenterTab(newCostCenterData);
              }

              $state.reload();
            });
          } else {
            console.error('openCostCenterDetailsModal: invalid cost-center data!');
          }
        });
    }

    function openCostCenterSpecificationModal(page, size, costCenterSpecification, costCenter) {
      $uibModal.open({
        controller: 'AdminFinancesCostCenterSpecificationModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          selectedCostCenterSpecification: function() { return costCenterSpecification },
          costCenter: function () { return costCenter }
        }
      })
        .result
        .then(function (result) {
          if(result && result.Name) {
            ArnoDashCostCenterSpecificationsService.saveSpecificationWithNotifications({
              id: result.id || null,
              CostCenterId: costCenter.id,

              Identifier: result.Identifier || null,
              Name: result.Name,

              TaxRatePercent: result.TaxRatePercent,
              TaxRateReason: result.TaxRateReason,

              Hint: result.Hint
            }).then(function() {
              $state.reload();
            });
          } else {
            console.error('openCostCenterSpecificationModal: invalid cost-center-specification data!');
          }
        });
    }

    function getUiPermissions() {
      self.hasManagePermission = permissions.isPermittedInOrg('arno.administration.finances.costCenters.manage', [$rootScope.ctx.organization.current.id]);
    }

    function getRecentUiSettings() {
      // check, if there are last table col-configs and apply them
      var recentCostCenterListConfig = localStorage.getItem('recentCostCenterListConfig');
      if (recentCostCenterListConfig) {
        var costCenterListConfig;

        try { costCenterListConfig = JSON.parse(recentCostCenterListConfig) }
        catch (ex) {} // eslint-disable-line

        self.costCenterListConfig = costCenterListConfig || {};

        (_.find(self.filteredCostCenters, { id: self.costCenterListConfig.selectedCostCenterId }) || {}).tabOpen = true;
      }
    }

    function setRecentUiSettings(costCenterListConfig) {
      // save settings to local-storage for usage after state-reloads
      try {
        localStorage.setItem('recentCostCenterListConfig', JSON.stringify(costCenterListConfig));
      }
      catch (ex) {} // eslint-disable-line
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.general')
    .controller('AdminFinancesGeneralCtrl', AdminFinancesGeneralCtrl);

  function AdminFinancesGeneralCtrl($translate, $state, $scope, toastr, clientApi, payableUntilPeriod, permissions,
    invoiceExportCtx, invoiceExportRecipient, invoiceExportSettings, $rootScope) {
    var self = this;
    self.payableUntilPeriod = payableUntilPeriod;
    self.invoiceExportAllowed = (invoiceExportSettings || {}).InvoiceExportEnabled;
    self.invoiceExportSettings = invoiceExportSettings;
    self.invoiceExportRecipient = invoiceExportRecipient;
    self.invoiceExportCtx = invoiceExportCtx;

    self.isPermittedInOrg = function(action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    }

    self.savePayableUntil = function () {
      clientApi
        .custom('model/Organization', 'fetchUpdatePayableUntilPeriod', {
          payableUntilPeriod: self.payableUntilPeriod,
        })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.finances.general.payableUntilSavedBody'),
            $translate.instant('modules.administration.finances.general.payableUntilSavedTitle')
          );
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.finances.general.payableUntilSaveFailedBody'),
            $translate.instant('modules.administration.finances.general.payableUntilSaveFailedTitle')
          );
        })
        .then(function () {
          $state.reload();
        })
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.language', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.language', {
        url: '/languageConfig',
        templateUrl: 'app/pages/administration/language/language.html',
        title: 'navigation.administration.language',
        controller: 'LanguageAdminCtrl as $ctrl',
        sidebarMeta: {
          order: 7,
        },
        resolve: {
          dictionary: function($rootScope, clientApi) {
            return clientApi.emit('i18n/getDictionary', {
              lang: $rootScope.ctx.currentUser.prefLanguage || 'de',
              raw: true,
            })
          }
        },
        viewPermission: 'arno.administration.language.edit',
        viewPermissionScopes: ['Organization'],
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.language')
    .controller('editTranslationCtrl', editTranslationCtrl);

  /** @ngInject */
  function editTranslationCtrl($uibModalInstance, translations) {
    var self = this;
    self.retObj = {};

    if (translations.custom) {
      Object.keys(translations.custom).forEach(function(lang) {
        if (translations.custom[lang]) {
          self.retObj[lang] = translations.custom[lang];
        }
      })
    }

    self.translations = translations;

    self.undo = function(lang) {
      self.retObj[lang] = translations.custom[lang];
    }

    self.reset = function(lang) {
      self.retObj[lang] = null;
    }
  }
})();


/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.divisions', [])
    .config(routeConfig)
    .config(function () {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = 'assets/img/theme/vendor/jstree/dist/themes';
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.divisions', {
        url: '/adminDivisions',
        templateUrl: 'app/pages/administration/divisions/divisions.html',
        title: 'navigation.administration.divisions',
        controller: 'AdminDivisionCtrl as $ctrl',
        resolve: {
          isPermittedForTreeView: function (permissions, $rootScope) {
            return permissions.isPermittedInOrg('arno.administration.divisions.manage', [$rootScope.ctx.organization.current.id])
              || permissions.isPermittedInOrg('arno.administration.divisions.administrators.manage', [$rootScope.ctx.organization.current.id]);
          },
          baseDataCtx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.administration.divisions.baseData.manage'
            });
          },
          isPermittedForBaseData: function (permissions, baseDataCtx) {
            return permissions.isPermittedInEvery('arno.administration.divisions.baseData.manage', 'Division', baseDataCtx, true);
          },
          divisions: function (commonUtils, isPermittedForTreeView) {
            if (!isPermittedForTreeView) {
              return [];
            }
            return commonUtils.division.treeData();
          },
          divisionData: function ($rootScope, commonUtils, ArnoDashAdminDivisionsService, divisions, isPermittedForTreeView) {
            if (!isPermittedForTreeView) {
              return [];
            }
            return commonUtils.division.buildTreeNodes(divisions, {
              statePref: 'divisionAdminTreeViewOpened',
              fetchMembers: true,
              rootOrg: $rootScope.ctx.organization.current.name
            })
              .then(function (results) {
                if (results && results.angularTreeData && results.members) {
                  return ArnoDashAdminDivisionsService.fetchMembersOfDivisionRoleToNodeData(
                    'Gliederungsadministrator',
                    results.angularTreeData, results.members,
                    'admins',
                    true
                  )
                    .then(function (res) {
                      results.angularTreeData = res;
                      return results;
                    });
                }

                return results;
              });
          },
          invoiceExportSettings: function (clientApi, permissions, $rootScope) {
            if (permissions.isPermittedInOrg('arno.administration.divisions.manage', [$rootScope.ctx.organization.current.id]) &&
              permissions.isPermittedInOrg('arno.administration.finances.quotationsAndInvoices.manage', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/Organization', 'getInvoiceExportSettings');
            }
            return {};
          },
          invoiceExportRecipients: function (clientApi, permissions, $rootScope) {
            if (permissions.isPermittedInOrg('arno.administration.divisions.manage', [$rootScope.ctx.organization.current.id]) &&
              permissions.isPermittedInOrg('arno.administration.finances.quotationsAndInvoices.manage', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/Division', 'getInvoiceExportRecipient', {
                  fullTree: true,
                })
                .then(function (res) {
                  return res || {};
                });
            } else {
              return {};
            }
          },
          CAT_MEMBER_COUNTRY_IDS: function (ArnoDashCataloguesService, isPermittedForBaseData) {
            if (!isPermittedForBaseData) {
              return {};
            }
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },
          accountingAreas: function (isPermittedForBaseData, baseDataCtx, clientApi) {
            if (!isPermittedForBaseData) {
              return [];
            }
            return clientApi.custom('model/AccountingArea', 'getAllAccountingAreas', { divisionId: baseDataCtx }).then(function (response) {
              return response.sort(function (a, b) {
                return a.DepartmentNumber > b.DepartmentNumber
                  ? 1 : a.DepartmentNumber < b.DepartmentNumber
                    ? -1 : 0;
              });
            });
          },
          divisionBaseData: function (isPermittedForBaseData, baseDataCtx, clientApi) {
            if (!isPermittedForBaseData) {
              return null;
            }
            return clientApi.custom('model/Division', 'fetchDivisionBaseData', { divisionId: baseDataCtx, resolveOwnedBusinessPartner: true });
          }
        },
        sidebarMeta: {
          order: 5,
        },
        viewPermission: 'arno.administration.divisions',
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.divisions')
    .controller('deactivationModalCtrl', deactivationModalCtrl);

  /** @ngInject */
  function deactivationModalCtrl($uibModalInstance, division, deactivation, constraint) {
    var self = this;

    self.division = division;
    self.deactivation = deactivation;
    self.constraint = constraint;

    var getConstrainedChildren = function() {
      var conChild = [];
      var divs = self.constraint.children.divisions.slice();
      if (constraint.children && constraint.children.divisions && constraint.children.constrainedIds && constraint.children.constrainedIds.length) {
        constraint.children.constrainedIds.forEach(function(id) {
          conChild.push(_.find(divs, function(el) {
            return el.id === id;
          }));
        })
      }
      return conChild;
    }
    if (!deactivation && constraint.children) {
      self.constrainedChildren = getConstrainedChildren();
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.serviceTypes')
    .controller('serviceTypesCtrl', serviceTypesCtrl);

  /** @ngInject */
  function serviceTypesCtrl($uibModal, $state, toastr, clientApi, baModalService, serviceTypes, $translate) {

    var self = this;
    self.serviceTypes = serviceTypes;
    
    self.open = function (page, size, selectedItem) {
      $uibModal.open({
        controller: 'serviceTypeModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          selectedServiceType: function() { return selectedItem },
          serviceTypes: function () { return self.serviceTypes }
        }
      })
        .result
        .then(function (result) {
          if(!result.id) {
            self.addServiceType(result.name);
          }
          else {
            if(result.name) {
              self.editServiceType(result.id, result.name);
            }
          }
        });
    };

    self.addServiceType = function(name) {
      return clientApi
        .custom('model/ServiceType', 'createServiceType', {
          name: name,
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.events.theEventType') + name + $translate.instant('modules.administration.events.successAddEvent'), $translate.instant('modules.administration.events.eventAddType'));
          return $state.reload();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.events.theEventType') + name + $translate.instant('modules.administration.events.cantCreateEventType'), $translate.instant('modules.administration.events.createFailed'));
        });
    };
    self.editServiceType = function(id, name) {
      return clientApi
        .custom('model/ServiceType', 'updateServiceType', {
          id: id,
          name: name,
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.events.theEventType') + name + $translate.instant('modules.administration.events.successEditEvent'), $translate.instant('modules.administration.events.eventEditType'));
          return $state.reload();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.events.theEventType') + name + $translate.instant('modules.administration.events.cantSaveEventType') + $translate.instant('modules.administration.events.possiblyDeletetEventType'), $translate.instant('modules.administration.events.editEventTypeFailed'));
        });
    };
    self.deleteServiceType = function(serviceType) {
      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.administration.events.eventJsTitle'),
        content: $translate.instant('modules.administration.events.eventJsContent') + serviceType.Name + $translate.instant('modules.administration.events.eventJsContentDelete'),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel'),
      })
      .then(function() {
        return clientApi
        .custom('model/ServiceType', 'deactivateServiceType', {
          id: serviceType.id,
        })
        .then(function () {
          toastr.success($translate.instant('modules.administration.events.editEventType') + serviceType.Name + $translate.instant('modules.administration.events.wasAccessfulDelete'), $translate.instant('modules.administration.events.cantDeleteEventType'));
          return $state.reload();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.events.editEventType') + serviceType.Name + $translate.instant('modules.administration.events.eventTypeSuccessDelete'), $translate.instant('modules.administration.events.deleteIsFailed'));
        });
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.serviceTemplates', [
      'BlurAdmin.pages.administration.events.serviceTemplateDetail',
      'BlurAdmin.pages.administration.events.servicePositionTemplateDetail',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.events.serviceTemplates', {
        url: '/serviceTemplates',
        templateUrl: 'app/pages/administration/events/serviceTemplates/serviceTemplates.html',
        title: 'navigation.administration.events.serviceTemplates',
        controller: 'ServiceTemplateCtrl as $svct',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.events.manage', true);
          },
          ctxSelected: function (ctx) {
            return ctx !== null;
          },
          fetchServiceTemplateData: function (clientApi, ctx) {
            return function (queryWishes) {
              return clientApi
                .custom('model/ServiceTemplate', 'fetchServiceTemplates', {
                  divisionId: ctx || 'rootOrg',
                  queryWishes: queryWishes
                });
            }
          },
          serviceTemplateData: function (ctxSelected, fetchServiceTemplateData) {
            if (!ctxSelected) {
              return [];
            }
            return fetchServiceTemplateData({ paging: { offset: 0, limit: 10 }, sort: { by: 'Label' } });
          },
          fetchServicePositionTemplateData: function (clientApi, ctx) {
            return function (queryWishes) {
              return clientApi
                .custom('model/ServicePositionTemplate', 'fetchServicePositionTemplates', {
                  divisionId: ctx || 'rootOrg',
                  queryWishes: queryWishes
                });
            }
          },
          servicePositionTemplateData: function (ctxSelected, fetchServicePositionTemplateData) {
            if (!ctxSelected) {
              return [];
            }
            return fetchServicePositionTemplateData({ paging: { offset: 0, limit: 10 }, sort: { by: 'Label' } });
          },
        },

        sidebarMeta: {
          order: 1,
        },
        viewPermission: 'arno.administration.events.manage',
      })
      .state('arno.administration.events.serviceTemplateDetail', {
        url: '/serviceTemplateDetail?templateId',
        templateUrl: 'app/pages/administration/events/serviceTemplates/serviceTemplateDetails.html',
        title: 'navigation.administration.events.serviceTemplates',
        controller: 'ServiceTemplateDetailCtrl as $svctd',
        params: {
          templateId: {
            dynamic: true,
          },
        },
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.events.manage', true);
          },
          preexistingTemplate: function ($stateParams, clientApi) {
            if (!$stateParams.templateId) {
              return null;
            }
            return clientApi
              .custom('model/ServiceTemplate', 'fetchTemplate', {
                templateId: $stateParams.templateId,
              });
          },
          availableServiceTypes: function (clientApi) {
            return clientApi.custom('model/ServiceType', 'findServiceTypes');
          },
          eventCategories: function (clientApi, ctx, preexistingTemplate) {
            var divisionIds = [];
            if (preexistingTemplate && preexistingTemplate.DivisionId) {
              divisionIds.push(preexistingTemplate.DivisionId);
            }
            if (!preexistingTemplate && ctx) {
              divisionIds.push(ctx);
            }
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { divisionIds: divisionIds, usages: ['Event'] });
          },
        },
        viewPermission: 'arno.administration.events.manage',
      })
      .state('arno.administration.events.servicePositionTemplateDetail', {
        url: '/servicePositionTemplateDetail?templateId',
        templateUrl: 'app/pages/administration/events/serviceTemplates/servicePositionTemplateDetails.html',
        title: 'navigation.administration.events.servicePositionTemplateDetail',
        controller: 'ServicePositionTemplateDetailCtrl as self',
        params: {
          templateId: {
            dynamic: true,
          },
        },
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.events.manage', true);
          },
          preexistingTemplate: function ($stateParams, clientApi) {
            if (!$stateParams.templateId) {
              return null;
            }
            return clientApi
              .custom('model/ServicePositionTemplate', 'fetchTemplate', {
                templateId: $stateParams.templateId,
              });
          },
          availableServiceTypes: function (clientApi) {
            return clientApi.custom('model/ServiceType', 'findServiceTypes');
          },
          eventCategories: function (clientApi, ctx, preexistingTemplate) {
            var divisionIds = [];
            if (preexistingTemplate && preexistingTemplate.DivisionId) {
              divisionIds.push(preexistingTemplate.DivisionId);
            }
            if (!preexistingTemplate && ctx) {
              divisionIds.push(ctx);
            }
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { divisionIds: divisionIds, usages: ['Event'] });
          },
        },
        viewPermission: 'arno.administration.events.manage',
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.serviceTemplates')
    .controller('ServiceTemplateCtrl', ServiceTemplateCtrl);

  /** @ngInject */
  function ServiceTemplateCtrl(ctx, ctxSelected, serviceTemplateData, fetchServiceTemplateData, clientApi,
    baModalService, $state, toastr, fetchServicePositionTemplateData, servicePositionTemplateData, commonUtils, $translate) {
    var self = this;
    self.ctx = ctx;
    self.ctxSelected = ctxSelected;

    self.serviceTemplateConfig = {
      pageSize: 10,
    };
    self.serviceTemplateCollection = serviceTemplateData || { rows: [] };
    self.getServiceTemplateData = function (params, ctrlRef) {
      self.ctrlRef = ctrlRef || self.ctrlRef;
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.serviceTemplateConfig.pageSize || 0,
          limit: self.serviceTemplateConfig.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      return fetchServiceTemplateData(queryWishes)
        .then(function (result) {
          self.serviceTemplateCollection = result || { rows: [] };
          params.pagination.numberOfPages = Math.ceil(self.serviceTemplateCollection.count / self.serviceTemplateConfig.pageSize);
        });
    };

    self.openTemplate = function (serviceTemplate) {
      $state.go('arno.administration.events.serviceTemplateDetail', { templateId: (serviceTemplate && serviceTemplate.id) || null });
    };

    self.removeTemplate = function (serviceTemplate) {
      if (serviceTemplate && serviceTemplate.id) {
        return baModalService
          .messageModal({
            modalType: 'danger',
            allowHtml: false,

            title: $translate.instant('modules.administration.events.eventTemplateRemove'),
            content: $translate.instant('modules.administration.events.eventJsContentEvent') + serviceTemplate.Label + $translate.instant('modules.administration.events.eventJsContentDelete'),

            primaryActionText: $translate.instant('generalTerms.delete'),
            secondaryActionText: $translate.instant('generalTerms.cancel')
          })
          .then(function () {
            return clientApi
              .custom('model/ServiceTemplate', 'removeTemplate', {
                templateId: serviceTemplate.id,
                divisionId: ctx || 'rootOrg',
              })
              .then(function () {
                toastr.success($translate.instant('modules.administration.events.TheTemplateWasDelete'), $translate.instant('modules.administration.events.eventTemplateRemoved'));
                if (self.ctrlRef) {
                  self.getServiceTemplateData(self.ctrlRef.tableState());
                } else {
                  $state.reload();
                }
              })
          })
          .catch(function () {
            // hm k
          });
      }
    }

    self.servicePositionTemplateConfig = {
      pageSize: 10,
    };
    self.servicePositionTemplateCollection = servicePositionTemplateData || { rows: [] };
    self.getServicePositionTemplateData = function (params, ctrlRef) {
      self.ctrlPosRef = ctrlRef || self.ctrlPosRef;
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.servicePositionTemplateConfig.pageSize || 0,
          limit: self.servicePositionTemplateConfig.pageSize
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      return fetchServicePositionTemplateData(queryWishes)
        .then(function (result) {
          self.servicePositionTemplateCollection = result || { rows: [] };
          params.pagination.numberOfPages = Math.ceil(self.servicePositionTemplateCollection.count / self.servicePositionTemplateConfig.pageSize);
        });
    };

    self.openPositionTemplate = function (svcPosTpl) {
      $state.go('arno.administration.events.servicePositionTemplateDetail', { templateId: (svcPosTpl && svcPosTpl.id) || null });
    };

    self.removePositionTemplate = function (servicePositionTemplate) {
      if (servicePositionTemplate && servicePositionTemplate.id) {
        return baModalService
          .messageModal({
            modalType: 'danger',
            allowHtml: false,

            title: $translate.instant('modules.administration.events.position.removeTitle'),
            content: $translate.instant('modules.administration.events.position.removeBody', { title: servicePositionTemplate.Function }),

            primaryActionText: $translate.instant('generalTerms.delete'),
            secondaryActionText: $translate.instant('generalTerms.cancel'),
          })
          .then(function () {
            return clientApi
              .custom('model/ServicePositionTemplate', 'removeTemplate', {
                templateId: servicePositionTemplate.id,
                divisionId: ctx || 'rootOrg',
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.administration.events.position.toastRemoveSuccessBody'),
                  $translate.instant('modules.administration.events.position.toastRemoveSuccessTitle')
                );
                if (self.ctrlPosRef) {
                  self.getServicePositionTemplateData(self.ctrlRef.tableState());
                } else {
                  $state.reload();
                }
              })
          })
          .catch(function () {
            // hm k
          });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.serviceTemplateDetail', [])
    .controller('ServiceTemplateDetailCtrl', ServiceTemplateDetailCtrl);

  /** @ngInject */
  function ServiceTemplateDetailCtrl(preexistingTemplate, availableServiceTypes, eventCategories, ctx,
    $state, stateChangePrompt, clientApi, toastr, $translate) {
    var self = this;
    self.isNew = !preexistingTemplate;
    self.tpl = preexistingTemplate || { BaseCategories: [], ServiceShifts: [] };
    self.tplPanelTitle = $translate.instant('modules.administration.events.templateOfEvents', { isNew : self.isNew, tplLabel: self.tpl? self.tpl.Label : null });

    self.availableServiceCategories = eventCategories || [];
    if (preexistingTemplate && preexistingTemplate.BaseCategories) {
      var chosenServiceCategories = [];
      preexistingTemplate.BaseCategories.forEach(function(baseCat) {
        var found = _.find(self.availableServiceCategories, {id: baseCat.id});
        if (found) {
          chosenServiceCategories.push(found);
        }
      });
      self.tpl.BaseCategories = chosenServiceCategories;
    }

    self.availableServiceTypes = [{none: true, Name: $translate.instant('modules.administration.events.templateForMoreEvents')}].concat(availableServiceTypes);
    self.chosenServiceType = self.availableServiceTypes[0];
    if (preexistingTemplate && preexistingTemplate.ServiceType && preexistingTemplate.ServiceType.id) {
      var found = _.find(self.availableServiceTypes, {id: preexistingTemplate.ServiceType.id});
      if (!found) {
        found = {deprecated: true, id: preexistingTemplate.ServiceType.id, Name: (preexistingTemplate.ServiceType.Name + ' (inaktiv)')};
        self.availableServiceTypes.push(found);
      }
      self.chosenServiceType = found;
    }

    self.serviceTypeChosen = function(serviceType) {
      if (!serviceType || serviceType.none || !serviceType.id) {
        self.tpl.ServiceTypeId = null;
        return;
      }
      self.tpl.ServiceTypeId = serviceType.id;
    };

    self.shiftTemplateOpts = {
      templateMode: true,
      ctx: ctx,
      template: self.tpl,
      shifts: self.tpl.ServiceShifts,
    };

    self.fetchChanges = function() {
      return JSON.stringify(self.tpl, function(key, value) {
        if (key === '$$hashKey') {
          return undefined;
        }
        return value;
      })
    };
    self.changeDetectCompare = self.fetchChanges();
    stateChangePrompt.evaluate(function () {
      return self.changeDetectCompare === self.fetchChanges();
    });

    self.back = function () {
      $state.go('arno.administration.events.serviceTemplates');
    };

    self.submitServiceTemplate = function () {
      return clientApi.custom('model/ServiceTemplate', 'saveTemplate', { template: self.tpl, divisionId: (ctx || 'rootOrg') })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.events.serviceTemplateSavedToastMsg'),
            $translate.instant('modules.administration.events.serviceTemplateSavedToastTitle')
          );
          stateChangePrompt.disableEvaluation();
          self.back();
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.events.serviceTemplateSaveErrToastMsg'),
            $translate.instant('modules.administration.events.serviceTemplateSaveErrToastTitle')
          );
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.servicePositionTemplateDetail', [])
    .controller('ServicePositionTemplateDetailCtrl', ServicePositionTemplateDetailCtrl);

  /** @ngInject */
  function ServicePositionTemplateDetailCtrl($scope, preexistingTemplate, availableServiceTypes, eventCategories, ctx,
    $state, stateChangePrompt, clientApi, toastr, $translate) {
    var self = this;
    self.isNew = !preexistingTemplate;
    self.tpl = preexistingTemplate || { BaseCategories: [], ServiceFunction: {} };
    self.ctx = ctx;

    self.availableServiceCategories = eventCategories || [];
    if (preexistingTemplate && preexistingTemplate.BaseCategories) {
      var chosenServiceCategories = [];
      preexistingTemplate.BaseCategories.forEach(function (baseCat) {
        var found = _.find(self.availableServiceCategories, { id: baseCat.id });
        if (found) {
          chosenServiceCategories.push(found);
        }
      });
      self.tpl.BaseCategories = chosenServiceCategories;
    }

    self.availableServiceTypes = [
      { none: true, Name: $translate.instant('modules.administration.events.positionDetail.notServiceTyped') }
    ]
      .concat(availableServiceTypes);
    self.chosenServiceType = self.availableServiceTypes[0];
    if (preexistingTemplate && preexistingTemplate.ServiceType && preexistingTemplate.ServiceType.id) {
      var found = _.find(self.availableServiceTypes, { id: preexistingTemplate.ServiceType.id });
      if (!found) {
        found = { deprecated: true, id: preexistingTemplate.ServiceType.id, Name: (preexistingTemplate.ServiceType.Name + ' (inaktiv)') };
        self.availableServiceTypes.push(found);
      }
      self.chosenServiceType = found;
    }

    self.serviceTypeChosen = function (serviceType) {
      if (!serviceType || serviceType.none || !serviceType.id) {
        self.tpl.ServiceTypeId = null;
        return;
      }
      self.tpl.ServiceTypeId = serviceType.id;
    };

    self.shiftTemplateOpts = {
      templateMode: true,
      ctx: ctx,
      template: self.tpl,
      shifts: self.tpl.ServiceShifts,
    };

    self.fetchChanges = function () {
      return JSON.stringify(self.tpl, function (key, value) {
        if (key === '$$hashKey') {
          return undefined;
        }
        return value;
      })
    };
    self.changeDetectCompare = self.fetchChanges();
    stateChangePrompt.evaluate(function () {
      return self.changeDetectCompare === self.fetchChanges();
    });

    self.back = function () {
      $state.go('arno.administration.events.serviceTemplates');
    };

    self.positionDetailsSubmit = function (submitted) {
      _.extend(self.tpl.ServiceFunction, submitted.position);
      return clientApi.custom('model/ServicePositionTemplate', 'saveTemplate', { template: self.tpl, divisionId: (ctx || 'rootOrg') })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.events.positionDetail.toastSuccessTitle'),
            $translate.instant('modules.administration.events.positionDetail.toastSuccessBody')
          );
          stateChangePrompt.disableEvaluation();
          self.back();
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.events.positionDetail.toastErrorTitle'),
            $translate.instant('modules.administration.events.positionDetail.toastErrorBody')
          );
        });
    };

    self.submit = function () {
      setTimeout(function () {
        document.querySelector('form#shiftPositionDetailsForm button[type="submit"]').click();
      }, 0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.fileStorage', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.events.fileStorage', {
        url: '/fileStorage',
        templateUrl: 'app/pages/administration/events/fileStorage/fileStorageAdmin.html',
        title: 'navigation.administration.events.fileStorage',
        controller: 'serviceFileStorageCtrl',
        controllerAs: 'self',
        sidebarMeta: {
          order: 2,
        },
        resolve: {
          folderData: function (clientApi, commonUtils, $rootScope, $translate) {
            return Promise
              .all(
                ['event', 'service'].map(function (ident) {
                  return clientApi
                    .custom('model/FileStorageFolder', 'getFoldersForOrg', { storageIdent: ident })
                    .then(function (result) {
                      return commonUtils.fileStorage.buildFolderTree(
                        result,
                        {
                          rootOrg: $translate.instant('modules.administration.events.fileStorage.' + ident + '.treeRoot'),
                          rootIcon: 'fa ion-calendar'
                        }
                      );
                    });
                })
              )
              .then(function (eventServiceFolder) {
                return {
                  event: eventServiceFolder[0],
                  service: eventServiceFolder[1],
                }
              });
          }
        },
        viewPermission: 'arno.administration.events.manage',
        viewPermissionScopes: ['Organization'],
      });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.events.fileStorage')
    .controller('serviceFileStorageCtrl', serviceFileStorageCtrl);

  /** @ngInject */
  function serviceFileStorageCtrl($rootScope, $scope, $state, baModalService, permissions, clientApi, commonUtils, toastr, folderData, $translate) {
    var self = this;

    self.eventFolder = folderData.event;
    self.serviceFolder = folderData.service;

    self.viewPermSelector = {
      edit: $translate.instant('modules.administration.events.fileStorage.folderPermEdit'),
      view: $translate.instant('modules.administration.events.fileStorage.folderPermView'),
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.categories', ['ui.bootstrap.materialPicker'])
    .controller('CategoryModalCtrl', CategoryModalCtrl);

  function CategoryModalCtrl(ARNO_CONSTANTS, $uibModalInstance, category, currentDivision) {
    var self = this;

    // CONST
    // REMARK: this could be moved to the backend, but then you'll a definition table where the definition,
    // which usage for a category can occur has to be defined and stored!!!
    self.ADMIN_CATEGORIES_USAGE_LIST = ARNO_CONSTANTS.ADMIN.CATEGORIES.USAGELIST;
    self.ADMIN_CATEGORIES_USAGE_LIST_LABELS = ARNO_CONSTANTS.ADMIN.CATEGORIES.USAGELIST_LABELS;

    // VARS
    self.category = category;
    self.currentDivision = currentDivision;

    self.options = {
      required: true,
      allowEmpty: false,
      format: 'hexString',
      alpha: false,
      swatch: false,
      swatchOnly: true,
      inline: true
    };

    // INITIALIZATION-FUNCTION for controller
    function activate() {
      self.colorForNewCategory = '#FF0000';

      if (self.category && self.category.BaseCategoryUsages && self.category.BaseCategoryUsages.length) {
        // format usage-data of category to be shown and used in tag-picker
        self.selectedCategoryUsages = self.category.BaseCategoryUsages.map(function(categoryUsage) {
          return {
            Name: self.ADMIN_CATEGORIES_USAGE_LIST_LABELS[categoryUsage.UsedFor],
            mapping: categoryUsage.UsedFor,
          }
        });
      }
    }

    // VIEW-FUNCTIONS
    self.showCategoryUsageField = function() {
      return self.currentDivision != null && self.currentDivision != false; // commonUtils seems to return "false" if division is not selected...
    }

    // EVENT-HANDLERS
    self.createCategory = function (name, color) {
      $uibModalInstance.close({
        name: name,
        color: self.ensureHash(color),
        usages: self.selectedCategoryUsages ? self.selectedCategoryUsages.map(function(usage) {
          return usage.mapping;
        }) : null,
      });
    };

    self.confirmDelete = function (id, name) {
      $uibModalInstance.close({
        id: id,
        name: name
      });
    };

    self.editCategory = function (name, color, id) {
      $uibModalInstance.close({
        newName: name,
        newColor: self.ensureHash(color),
        newUsages: self.selectedCategoryUsages ? self.selectedCategoryUsages.map(function(usage) {
          return usage.mapping;
        }) : null,
        editId: id,
      });
    };

    // HELPERS
    self.ensureHash = function (color) {
      return '#' + ((color || '').replace('#', ''));
    };

    // initialization
    activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.apikey.details', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.apikey.details', {
        url: '/details/:id',
        templateUrl: 'app/pages/administration/apikey/apiKeyDetails/apiKeyDetails.html',
        controller: 'ApiKeyDetailsCtrl as self',
        title: 'navigation.administration.apikey',
        params: {
          id: null
        },
        resolve: {
          apiKey: function($stateParams, clientApi) {
            if ($stateParams.id) {
              return clientApi.custom('model/ApiKey', 'getApiKeys', { keyId: $stateParams.id });
            }
            return null;
          },
          ctx: function(commonUtils) {
            var ctx = commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.administration.apikey.manage',
            })
            return ctx && ctx[0];
          },
          availableAndAssignedPermissions: function(ctx, clientApi, $stateParams) {
            return clientApi.custom('model/ApiKey', 'getApiKeyPermissions', { keyId: $stateParams.id, divisionId: ctx === 'rootOrg' ? null : ctx });
          },
          permHierarchy: function(clientApi, ctx) {
            if (ctx === 'rootOrg') {
              return clientApi.custom('model/OrganizationPermission', 'getOrganizationPermissionHierarchy', {});
            }
            return clientApi.custom('model/DivisionPermission', 'getPermissionHierarchy', {});
          },
        },
        viewPermission: 'arno.administration.apikey.manage',
        viewPermissionScopes: ['Organization'],
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.apikey.details')
    .controller('ApiKeyDetailsCtrl', ApiKeyDetailsCtrl);

  function ApiKeyDetailsCtrl($translate, $state, apiKey, clientApi, toastr, availableAndAssignedPermissions, ctx, stateChangePrompt, permHierarchy, commonUtils) {
    var self = this;
    self.availablePermissions = availableAndAssignedPermissions.availablePerms;
    self.selectedPerms = {};
    self.keyPerms = (availableAndAssignedPermissions.keyPerms || []);
    if (!apiKey) {
      self.isNew = true;
    }
    self.apiKey = apiKey || {};

    if (self.keyPerms) {
      self.selectedPermissions = _.compact(self.keyPerms.map(function(kp) {
        if (!kp.PermissionId) {
          return null;
        }
        return {
          ApiKeyEligible: kp.ApiKeyEligible,
          Assignable: kp.Assignable,
          Description: kp.PermissionDescription,
          Name: kp.PermissionName,
          Virtual: kp.Virtual,
          id: kp.PermissionId,
        }
      }));
    }

    stateChangePrompt.evaluate(function () {
      return self.apiKeyDetailsForm.$pristine && !_.difference(
        self.selectedPermissions.map(function(sp) {
          return sp.id;
        }),
        self.keyPerms.map(function(kp) { return kp.PermissionId })
      ).length
    });

    self.goBack = function() {
      $state.go('arno.administration.apikey');
    }

    self.saveApiKey = function() {
      return clientApi.custom('model/ApiKey', 'upsertApiKey', {
        keyId: self.apiKey.id || null,
        name: self.apiKey.Name,
      })
      .then(function(res) {
        stateChangePrompt.disableEvaluation();
        toastr.success(
          $translate.instant('modules.administration.apikey.saveKeySuccessContent'),
          $translate.instant('modules.administration.apikey.saveKeySuccessTitle')
        );
        if (self.back) {
          self.goBack();
        } else if (res && res.id) {
          $state.go(
            'arno.administration.apikey.details',
            { id: res.id || undefined }
          );
        }
      })
      .catch(function() {
        self.back = false;
        toastr.error(
          $translate.instant('modules.administration.apikey.saveKeyFailContent'),
          $translate.instant('modules.administration.apikey.saveKeyFailTitle')
        )
      })
    }

    self.savePermissions = function(back) {
      return clientApi.custom('model/ApiKey', 'setApiKeyPermissions', {
        keyId: self.apiKey.id,
        permissions: self.selectedPermissions.map(function(sp) {
          return sp.id;
        }),
        divisionId: ctx === 'rootOrg' ? null : ctx,
      })
      .then(function() {
        stateChangePrompt.disableEvaluation();
        toastr.success(
          $translate.instant('modules.administration.apikey.savePermsSuccessContent'),
          $translate.instant('modules.administration.apikey.savePermsSuccessTitle')
        );
        if (back) {
          self.goBack();
        } else {
          $state.reload();
        }
      })
      .catch(function() {
        toastr.error(
          $translate.instant('modules.administration.apikey.savePermsFailContent'),
          $translate.instant('modules.administration.apikey.savePermsFailTitle')
        )
      })
    }

    self.tooltipCache = {};
    self.fetchTooltip = function (item) {
      if (self.tooltipCache[item.id]) {
        return self.tooltipCache[item.id];
      }
      var includedIds = _.without(commonUtils.fetchIncludedPermissions(item.id, permHierarchy), item.id);
      var includedPerms = [];

      if (includedIds.length) {
        includedPerms = includedIds
          .map(function (includedId) {
            var foundPerm = _.find(self.availablePermissions, { id: includedId });

            if (foundPerm) {
              return {
                Name: foundPerm.Name,
                Description: foundPerm.Description,
              }
            }

            return null;
          })
          .filter(function (included) {
            return !!included;
          });
      }
      includedPerms.sort();

      var permDescription = '';
      if (!includedPerms.length) {
        permDescription = (_.find(self.availablePermissions, { id: item.id }) || {}).Description;
      }

      self.tooltipCache[item.id] = {
        isAggregated: includedPerms.length,
        aggregatedDescription: (_.find(self.availablePermissions, { id: item.id }) || {}).Description || '',
        includedPermsContent: includedPerms.length === 0 ? { Description: permDescription } : includedPerms
      };

      return self.tooltipCache[item.id];
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.contactManagement.details', [])
    .controller('ContactManagementDetailsCtrl', ContactManagementDetailsCtrl);

  /** @ngInject */
  function ContactManagementDetailsCtrl(ARNO_CONSTANTS, divisionIds, contact, $state, permissions,
    divisionDataProvider, ArnoDashContactManagementService, validationUtils, $translate,
    $uibModal, clientApi, privacyTermsChannelMap, isLinked
  ) {
    var self = this;
    self.divisionIds = divisionIds;
    self.divisionList = [];
    self.divisionDataProvider = divisionDataProvider;
    self.hasManagePermission = permissions.isPermittedAnywhere('arno.contacts.contactManagement.manage', ['Division', 'Organization']);
    self.displayedPages = 2;
    self.rowsPerPage = 5;
    self.isLinked = isLinked;
    
    self.contact = _.cloneDeep(contact);
    self.newContact = {
      Salutation: null,
      Title: null,
      FirstName: null,
      LastName: null,
      PhoneNumber: null,
      MobileNumber: null,
      MailAddress: null,
      Function: null,
      BusinessPartnerId: null,
      BusinessPartner: {
        id: null,
        Name: null
      }
    };

    if (contact && contact.businessPartner && contact.businessPartner.IsInternal) {
      contact.businessPartner.Name = (contact.businessPartner.OwnerDivision || {}).Name;
    }

    self.checkEmail = validationUtils.checkEmail;
    self.checkPhoneNumber = validationUtils.checkPhoneNumber;

    self.salutationList = ARNO_CONSTANTS.GENERAL.SALUTATION;

    self.titleList = ARNO_CONSTANTS.GENERAL.MEMBER_TITLES;

    if (self.contact) {
      self.contact.Salutation = _.find(self.salutationList, function(sl) {
        return sl.mapping === (contact || {}).Salutation;
      })

      self.contact.Title = _.find(self.titleList, function(sl) {
        return sl.mapping === (contact || {}).Title;
      })
    }

    self.toggleSection = {
      privacy: false
    }

    self.toggleSection = {
      privacy: true
    }

    self.moment = moment;
    self.privacyTermsChannelMap = privacyTermsChannelMap;

    self.isNew = function () {
      return !(self.contact || {}).id;
    }

    self.$onInit = function() {
      if (self.isNew()) {
        self.contact = _.cloneDeep(self.newContact);
      }
    }

    self.updateDivisionData = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.rowsPerPage || 0,
          limit: self.rowsPerPage
        },
        order: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        search: {
          term: params.search.predicateObject && params.search.predicateObject.name ? params.search.predicateObject.name : false
        }
      };

      return self.divisionDataProvider(
        queryWishes
      ).then(function (divisionData) {
        self.divisionList = divisionData.divisionList;
        params.pagination.numberOfPages = divisionData.numberOfPages;
      });
    };

    self.save = function(form) {
      if (form.$valid && ArnoDashContactManagementService.isValid(self.contact)) {
        if (self.contact) {
          self.contact.Title = (self.contact.Title || {}).mapping;
          self.contact.Salutation = (self.contact.Salutation || {}).mapping;
          if (self.contact.Title === 'none') {
            self.contact.Title = null;
          }

          if (self.contact.Salutation === 'none') {
            self.contact.Salutation = null;
          }
          if (!self.divisionList.length) {
            self.divisionList.push(self.divisionIds[0]);
          }
          if(!self.contact.PrivacyTermsDeliveredDateTime && self.contact.FirstName && self.contact.LastName) {
            $uibModal
              .open({
                backdrop: 'static',
                animation: true,
                templateUrl: 'app/theme/components/modals/contactPrivacyModal/contactPrivacyModal.html',
                size: 'mg',
                controller: 'ContactPrivacyModalCtrl as $contactPrivacyModalCtrl',
                resolve: {
                  data: {
                    contact: self.contact,
                  },
                  privacyTermDate: null,
                }
              }).result
              .then(function (result) {
                return result ? ArnoDashContactManagementService.saveContact(result, self.divisionList, self.divisionIds) : null;
              })
              .then(function () {
                $state.go('arno.contacts.contactManagement');
              })
          } else {
            ArnoDashContactManagementService.saveContact(self.contact, self.divisionList, self.divisionIds).then(function(){
              $state.go('arno.contacts.contactManagement');
            });
          }
        }
      }
    };

    self.back = function() {
      $state.go('arno.contacts.contactManagement');
    };

    self.toggleLink = function () {
      if (self.isLinked) {
        return ArnoDashContactManagementService.removeDivisions(self.contact, self.divisionIds).then(function(result){
          if (result > 0) {
            $state.go('arno.contacts.contactManagement');
          } else {
            $state.reload();
          }
        });
      } else {
        return ArnoDashContactManagementService.addDivisions(self.contact, self.divisionIds).then(function(){
          $state.reload();
        });
      }
    };

    self.setBusinessPartner = function (businessPartner) {
      if (!self.contact) {
        self.contact = self.initNewContact();
      }
      self.contact.BusinessPartnerId = businessPartner.id;
      self.contact.BusinessPartner = {
        id: businessPartner.id,
        Name: businessPartner.IsInternal ? (businessPartner.OwnerDivision || {}).Name : businessPartner.Name,
      };
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.contactManagement', [
      'BlurAdmin.pages.contacts.contactManagement.details'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.contacts.contactManagement', {
      url: '/contactManagement',
      templateUrl: 'app/pages/contacts/contactManagement/contactManagement.html',
      title: 'navigation.contacts.contactManagement',
      controller: 'ContactManagementCtrl as $ctrl',
      resolve: {
        divisionIds: function($stateParams, commonUtils) {
          if ($stateParams.divisionIds) {
            var divisionIds = $stateParams.divisionIds;
            delete $stateParams.divisionIds;
            commonUtils.division.getCtx(divisionIds, {
              multiple: true,
              allowOrgSelection: false,
              entryPermission: 'arno.contacts.contactManagement.view',
            });
            return divisionIds;
          }

          return (commonUtils.division.getCtx({
            multiple: true,
            allowOrgSelection: false,
            entryPermission: 'arno.contacts.contactManagement.view',
          }) || []);
        },
        contactDataProvider: function(ArnoDashContactManagementService, divisionIds) {
          return function (queryWishes) {
            return ArnoDashContactManagementService.getContactAllWithOrg(divisionIds, queryWishes);
          };
        },
        contactDataInit: function(contactDataProvider) {
          return contactDataProvider({});
        }
      },
      sidebarMeta: {
        order: 800,
      },
    }).state('arno.contacts.contactManagementDetails', {
      url: '/contactManagementDetails/:contactId?',
      templateUrl: 'app/pages/contacts/contactManagement/contactManagementDetails.html',
      title: 'navigation.contacts.contactManagementDetails',
      controller: 'ContactManagementDetailsCtrl as $ctrl',
      params: {
        contactId: {
          dynamic: true,
        }
      },
      resolve: {
        divisionIds: function($stateParams, commonUtils) {
          return (commonUtils.division.getCtx({
            multiple: false,
            allowOrgSelection: false,
            entryPermission: 'arno.contacts.contactManagement.view',
          }) || []);
        },
        contact: function(ArnoDashContactManagementService, divisionIds, $stateParams) {
          if ($stateParams.contactId) {
            return ArnoDashContactManagementService.getContactOneWithOrg($stateParams.contactId, divisionIds);
          }
          return Promise.resolve(null);
        },
        divisionDataProvider: function(ArnoDashContactManagementService, contact, divisionIds) {
          return function (queryWishes) {
            if (!contact) {
              return Promise.resolve({ divisionList : [], numberOfPages: 0 });
            } else {
              return ArnoDashContactManagementService.getDivisionData(contact, divisionIds, queryWishes)
            }
          };
        },
        divisionDataInit: function(divisionDataProvider) {
          return divisionDataProvider({});
        },
        isLinked: function(clientApi, divisionIds, contact) {
          return clientApi.custom('model/Contact', 'isLinked', { divisionId: divisionIds, contactId: (contact || {}).id });
        },
      },
      viewPermission: 'arno.contacts.contactManagement.view',
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.contactManagement')
    .controller('ContactManagementCtrl', ContactManagementCtrl);

  /** @ngInject */
  function ContactManagementCtrl(
    ARNO_CONSTANTS, $rootScope, divisionIds, contactDataProvider, $state, permissions,
    ArnoDashContactManagementService, commonUtils
  ) {
    var self = this;
    self.divisionIds = divisionIds;
    self.isMultiDiv = Array.isArray(divisionIds) && divisionIds.length > 1;
    self.contactDataProvider = contactDataProvider;
    self.displayedPages = 5;
    self.rowsPerPage = 10;
    self.rowsPerPageList = [5, 10, 20, 50];

    self.addTooltipVars = { isMultiDiv: self.isMultiDiv };
    
    self.hasManagePermission = permissions.isPermittedAnywhere('arno.contacts.contactManagement.manage', ['Division', 'Organization']);

    self.changeRowsPerPage = function (rowsPerPage) {
      self.rowsPerPage = rowsPerPage;
    };
    self.salutationList = ARNO_CONSTANTS.GENERAL.SALUTATION;
    self.titleList = ARNO_CONSTANTS.GENERAL.MEMBER_TITLES;
    self.orgName = $rootScope.ctx.organization.current.name;

    self.resolveDropdownValue = function(val, isTitle) {
      if (isTitle) {
        return (_.find(self.titleList, function(sl) {
          return sl.mapping === val;
        }) || {}).Name;
      }
      return (_.find(self.salutationList, function(sl) {
        return sl.mapping === val;
      }) || {}).Name;
    }

    self.updateContactData = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.rowsPerPage || 0,
          limit: self.rowsPerPage
        },
        order: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        search: []
      };

      if (params.search.predicateObject) {
        Object.keys(params.search.predicateObject).forEach(function (key) {
          queryWishes.search.push({
            property: key,
            term: params.search.predicateObject[key]
          });
        });
      }

      return self.contactDataProvider(
        queryWishes
      ).then(function (contactData) {
        self.contactData = contactData;
        params.pagination.numberOfPages = self.contactData.numberOfPages;
      });
    };

    self.setDetailCtx = function() {
      commonUtils.division.setCtx(self.divisionIds, {
        multiple: false,
        allowOrgSelection: false,
        entryPermission: 'arno.contacts.contactManagement.view',
      });
    }

    self.goContactDetails = function (contact) {
      self.setDetailCtx();
      $state.go('arno.contacts.contactManagementDetails', { contactId: contact.id });
    }

    self.addContact = function () {
      self.setDetailCtx();
      $state.go('arno.contacts.contactManagementDetails', { contactId: null });
    };

    self.editContact = function (contact) {
      self.setDetailCtx();
      $state.go('arno.contacts.contactManagementDetails', { contactId: contact.id });
    };
    
    self.removeContact = function (contact) {
      return ArnoDashContactManagementService.removeDivisions(contact, self.divisionIds).then(function(){
        $state.reload();
      });
    };

    self.preventPropagation = function(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    self.linkable = function () {
      return self.divisionIds.length == 1 && !self.divisionIds.includes('rootOrg');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.businessPartners')
    .controller('ContactsBusinessPartnersCtrl', ContactsBusinessPartnersCtrl);

  /** @ngInject */
  function ContactsBusinessPartnersCtrl(
    $rootScope, $scope, $uibModal, $state, $translate, commonUtils, uxUtils, permissions,
    ArnoDashBusinessPartnersService, tableConfig, toastr, clientApi, CAT_COUNTRY_IDS,
    ctx
  ) {
    // VARS
    var self = this;
    self.tableViewsOrg = {};

    self.ctx = ctx;

    self.hasDivViewPermission = false;
    self.hasOrgViewPermission = false;
    self.hasDivManagePermission = false;
    self.hasOrgManagePermission = false;
    self.hasConfigurePermission = false;

    self.orgName = $rootScope.ctx.organization.current.name;

    // get the list to display initially from the localstorage
    self.sortableOrg = [
      { fieldName: 'Name', sortProp: 'Name' },
      { fieldName: 'TaxIdentifier', sortProp: 'TaxIdentifier' },
      { fieldName: 'TradeName', sortProp: 'TradeName' },
      { fieldName: 'City', sortProp: 'City' },
      { fieldName: 'ZIP', sortProp: 'ZIP' },
      { fieldName: 'Street', sortProp: 'Street' },
      { fieldName: 'HouseNumber', sortProp: 'HouseNumber' },
      { fieldName: 'LegalRegistrationIdentifier', sortProp: 'LegalRegistrationIdentifier' },
      { fieldName: 'VatIdentifier', sortProp: 'VatIdentifier' },
      { fieldName: 'CustomerNumber', sortProp: 'CustomerNumber' },
      { fieldName: 'IsBuyer'},
      { fieldName: 'IsSeller'},
    ];

    var orgView = commonUtils.preference.object.get('pref_current_businesspartners_list_view_org', '0');
    var orgTableConf = tableConfig.tableConfigOrgDefault;

    self.handleCustomLists = function (customTableConfigs) {
      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        if (conf.IsOrg) {
          // get the pageSize retrieved from localstorage and stored in defaultView and add it to customViews
          conf.Fields.pageSize = tableConfig.tableConfigOrgDefault.pageSize;
          self.tableViewsOrg[conf.id] = conf;
        }
      });
    };
    self.handleCustomLists(tableConfig.tableConfigCustomPreference);

    if (orgView.id) {
      if (self.tableViewsOrg[orgView.id]) {
        orgTableConf = self.tableViewsOrg[orgView.id].Fields;
      } else {
        orgView = '0';
      }
    }

    self.tableConfig = orgTableConf;
    self.currentTableConf = {
      title: $translate.instant('modules.contacts.businessPartners.overview.title'),
      active: self.hasDivViewPermission,
      selectedView: orgView.id || orgView,
      isOrgList: true,
      tableConfig: orgTableConf,
      customViews: self.tableViewsOrg,
      defaultView: tableConfig.tableConfigOrgDefault,
      // NOTE: even divisions can be selected as context, atm we only allow 1 table view-config for the whole org
      ctx: ['rootOrg'],

      displayedCollection: [],

      showBuyers: false,
      showSellers: false,
      showMaterialProviders: false
    };

    self.orgTableConfig = {
      tableConfig: tableConfig.tableConfigOrgDefault,
      pageSize: 20,
      displayedCollection: [],
      showBuyers: false,
      showSellers: false,
      showMaterialProviders: false
    };
    self.orgTableCtrl = null;

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ContactsBusinessPartnersCtrl#
    */
    function activate() {
      getUiPermissions();
    }

    // WATCHERS
    $scope.$watch('$ctrl.currentTableConf.showBuyers', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.reloadTable(self.currentTableConf, false);
      }
    });
    $scope.$watch('$ctrl.currentTableConf.showSellers', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.reloadTable(self.currentTableConf, false);
      }
    });
    $scope.$watch('$ctrl.currentTableConf.showMaterialProviders', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.reloadTable(self.currentTableConf, false);
      }
    });

    $scope.$watch('$ctrl.orgTableConfig.showBuyers', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.getOrgBusinessPartners(self.orgTableCtrl.tableState(), self.orgTableCtrl);
      }
    });
    $scope.$watch('$ctrl.orgTableConfig.showSellers', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.getOrgBusinessPartners(self.orgTableCtrl.tableState(), self.orgTableCtrl);
      }
    });
    $scope.$watch('$ctrl.orgTableConfig.showMaterialProviders', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.getOrgBusinessPartners(self.orgTableCtrl.tableState(), self.orgTableCtrl);
      }
    });

    // EVENT-HANDLERS
    self.addBusinessPartner = function () {
      var stateParams = { id: null };

      if ((self.ctx || []).length > 0) {
        // NOTE: self.ctx[1] will be undefined, when rootOrg exists
        var selectedDivision = self.ctx[0] !== 'rootOrg' ? self.ctx[0] : self.ctx[1];

        stateParams.selectedCtxInfo = {
          division: selectedDivision
        };
      }

      $state.go('arno.contacts.businessPartnerDetails', stateParams, { inherit: false });
    };

    self.editBusinessPartner = function (businessPartner) {
      var stateParams = { id: businessPartner.id };

      if ((self.ctx || []).length > 0) {
        stateParams.selectedCtxInfo = {
          division: !businessPartner.DivisionId ? 'rootOrg' : self.ctx[0],
        };
      }

      $state.go('arno.contacts.businessPartnerDetails', stateParams, { inherit: false });
    };

    self.removeBusinessPartnerLinking = function (businessPartner) {
      if ((businessPartner || {}).id) {
        var divisionId = self.ctx[0] || self.ctx;

        if (divisionId === 'rootOrg') {
          divisionId = self.ctx[1];
        }

        ArnoDashBusinessPartnersService.removeLinkedBusinessPartnerWithMessageModal(divisionId, businessPartner)
          .then(function (results) {
            if (results) {
              $state.reload();
            }
          });
      }
    };

    self.addOrgBusinessPartner = function () {
      $state.go('arno.contacts.businessPartnerDetails', {
        id: null,
        selectedCtxInfo: {
          division: 'rootOrg'
        }
      }, { inherit: false });
    };

    self.editOrgBusinessPartner = function (businessPartner) {
      $state.go('arno.contacts.businessPartnerDetails', {
        id: businessPartner.id,
        selectedCtxInfo: {
          division: 'rootOrg'
        }
      }, { inherit: false });
    };

    self.deleteOrgBusinessPartner = function (businessPartner) {
      if ((businessPartner || {}).id && businessPartner.DivisionId == null) {
        ArnoDashBusinessPartnersService.deleteBusinessPartnerWithMessageModal(businessPartner)
          .then(function (results) {
            if (results) {
              $state.reload();
            }
          });
      }
    };

    self.getData = function (params, ctrl, listType) {
      listType.tableCtrl = ctrl || listType.tableCtrl;

      ArnoDashBusinessPartnersService.getLinkedBusinessPartnersForDivisions({
        paging: {
          limit: listType.tableConfig.pageSize,
          offset: (params.pagination.start / params.pagination.number) * listType.tableConfig.pageSize || 0,
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        isBuyer: self.currentTableConf.showBuyers ? true : null,
        isSeller: self.currentTableConf.showSellers ? true : null,
        isMaterialProvider: self.currentTableConf.showMaterialProviders ? true : null,
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
      }, self.ctx)
      .then(function (result) {
        params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
        self.currentTableConf.displayedCollection = result.rows;
      });
    };

    self.currentTableConf.getData = function (params, ctrl) {
      return self.getData(params, ctrl, self.currentTableConf);
    };

    self.changeListView = function (listType, val, storageIdentifier) {
      listType.hasViewModifications = false;

      if (val === '0') {
        listType.tableConfig = listType.defaultView;
      } else {
        listType.tableConfig = val.Fields;
      }

      listType.selectedView = storageIdentifier;
      storeTableConfig(listType);
      var state = listType.tableCtrl.tableState();

      if (state) {
        state.sort = {};
      }

      if (listType.customViews[listType.selectedView]) {
        listType.customViews[listType.selectedView].initialSort = true;
      }

      return self.reloadTable(listType, true);
    };

    self.changePageSize = function (listType, num) {
      listType.tableConfig.pageSize = num;
      storeTableConfig(listType);
    };

    self.reloadTable = function (listType, clearFilters) {
      if (listType && listType.tableCtrl) {
        var tableState = listType.tableCtrl.tableState();

        if (clearFilters && tableState && tableState.search && tableState.search.predicateObject) {
          tableState.search.predicateObject = {};
        }

        return self.getData(listType.tableCtrl.tableState(), null, listType);
      }
    };

    self.changeOrgTablePageSize = function (tableConfig, num) {
      tableConfig.pageSize = num;
      self.getOrgBusinessPartners(self.orgTableCtrl.tableState(), self.orgTableCtrl);
    };

    self.getOrgBusinessPartners = function (params, ctrl) {
      self.orgTableCtrl = ctrl || self.orgTableCtrl;

      ArnoDashBusinessPartnersService.getFilteredBusinessPartnersForOrg({
        paging: {
          limit: self.orgTableConfig.pageSize,
          offset: (params.pagination.start / params.pagination.number) * self.orgTableConfig.pageSize || 0,
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        isBuyer: self.orgTableConfig.showBuyers ? true : null,
        isSeller: self.orgTableConfig.showSellers ? true : null,
        isMaterialProvider: self.orgTableConfig.showMaterialProviders ? true : null,
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
      }, self.ctx)
      .then(function (result) {
        params.pagination.numberOfPages = Math.ceil(result.count / self.orgTableConfig.pageSize);
        self.orgTableConfig.displayedCollection = result.rows;
      });
    };

    // VIEW-FUNCTIONS
    self.getFullCSpan = uxUtils.getFullCSpan;

    self.openTableConfig = function (currentConf) {
      if (!self.hasConfigurePermission) {
        return false;
      }

      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'md',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return currentConf.isOrgList;
            },
            sortableFields: function () {
              return self.sortableOrg;
            },
            availableFields: function () {
              return tableConfig.tableConfigAvailableFields.org;
            },
            currentList: function () {
              return { 'current': currentConf.tableConfig };
            },
            availableLists: function () {
              return JSON.parse(JSON.stringify(currentConf.customViews));
            },
            isMaterialList: function () { return false; },
            aggExclusion: function () { return []; }
          },
        })
        .result
        .then(function (res) {
          if (!res) {
            return;
          }

          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;

          if (res.modifiedCurrentList) {
            // if we modified a current view we'll create a pseudo list which will not be stored
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;

            if (!currentConf.tableConfig.pageSize) {
              currentConf.tableConfig.pageSize = tableConfig.tableConfigOrgDefault.pageSize;
            }
          }

          toastr.success(
            $translate.instant('controls.table.config.tblConfToastSuccText'),
            $translate.instant('controls.table.config.tblConfToastSuccTitle')
          );

          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  // if we deleted the currently selected list, switch back to default view
                  self.changeListView(currentConf, '0', '0');
                }

                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id
                  })
                  .then(function () {
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }

          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (!currentConf.hasViewModifications && (val.id && val.id === JSON.parse(currentConf.selectedView))) {
                // to immediately update the table if we edited our current, db stored list. If we modified just the current view do nothing
                currentConf.tableConfig = _.merge(currentConf.tableConfig, val.Fields);
              }

              // update or create a new list
              customLists.push({
                id: val.id || false,
                ListType: 'contactsOrganizationList',
                ListName: val.Name,
                IsOrg: currentConf.isOrgList,
                Fields: val.Fields,
                Sort: val.Sort,
              });

              newListAdded = !val.id ? true : newListAdded;
            });

            if (customLists.length > 0) {
              var divisionId = self.ctx[0] || self.ctx;

              if (divisionId === 'rootOrg') {
                divisionId = null;
              }
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: divisionId
                })
                .then(function () {
                  return clientApi
                      .custom('model/CustomListView', 'getUserTableConfigs', {
                        listType: 'contactsOrganizationList'
                      })
                      .then(function (lists) {
                        self.handleCustomLists(lists);
                        if (newListAdded) {
                          var maxId = Math.max.apply(Math, Object.values(_.mapValues(lists, function (l) { return l.id; })));
                          var newList = Object.values(_.pickBy(lists, function (list) {
                            return list.id == maxId;
                          }))[0];
                          self.changeListView(currentConf, newList, maxId);
                        }
                        self.reloadTable(currentConf, res.modifiedCurrentList ? true : false);
                      });
                }
                );
            }
          }

          self.reloadTable(currentConf, res.modifiedCurrentList ? true : false);
        });
    };

    self.getCountryByMapping = function (code) {
      var countryObj = _.find(CAT_COUNTRY_IDS, function (c) {
        return c.mapping === code;
      });

      if (countryObj) {
        return code + ' (' + countryObj.FullName + ')';
      }
      return code;
    };

    self.preventPropagation = function (event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    // HELPERS
    function getUiPermissions() {
      self.hasDivManagePermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.manage', ['Division']);
      self.hasOrgManagePermission = permissions.isPermittedInOrg('arno.contacts.businessPartners.manage', [$rootScope.ctx.organization.current.id]);

      self.hasOrgViewPermission = permissions.isPermittedInOrg('arno.contacts.businessPartners.view', [$rootScope.ctx.organization.current.id]);
      self.hasDivViewPermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.view', ['Division']);

      self.hasConfigurePermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.configure', ['Organization', 'Division']);
    }

    function storeTableConfig(listType) {
      commonUtils.preference.object.set(
        'pref_businesspartners_table_page_size_' + (listType.isOrgList ? 'org' : 'div'), {
          pageSize: listType.tableConfig.pageSize
        });
      if (listType.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_businesspartners_list_view_' + (listType.isOrgList ? 'org' : 'div'));
      } else {
        // store the id of the currently selected view
        commonUtils.preference.object.set(
          'pref_current_businesspartners_list_view_' + (listType.isOrgList ? 'org' : 'div'),
          { id: listType.selectedView }
        );
      }

    }

    // CONTROLLER-INIT
    self.$onInit = function () {
      activate();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.contacts.businessPartners.details', [])
    .controller('ContactsBusinessPartnerDetailsCtrl', ContactsBusinessPartnerDetailsCtrl);

  /** @ngInject */
  function ContactsBusinessPartnerDetailsCtrl(
    CAT_COUNTRY_IDS, $uibModal, clientApi,
    $rootScope, $scope, $state, permissions,
    ArnoDashBusinessPartnersService, attachedContacts,
    ctx, businessPartner, commonUtils, $translate, validationUtils
  ) {
    // CONSTS
    var USED_FIELDS_OWNER_DIVISION = [
      'Name',

      'TaxIdentifier',
      'LegalRegistrationIdentifier',
      'VatIdentifier',

      'CountryId',
      'City',
      'ZipCode',
      'Street',
      'HouseNumber',
      'AddressAffix',

      'CustomerNumber',
      'CustomerNumberIsDebtorNumber',
      'Iban',
      'Bic',
      'EMail',
      'BankName',
      'Comment',
      'ElectricAdress',
      'OtherLegalInformation'
    ];

    var newBusinessPartner = {
      TaxIdentifier: null,

      Name: null,
      TradeName: null,

      LegalRegistrationIdentifier: null,
      VatIdentifier: null,

      City: null,
      ZIP: null,
      Street: null,
      HouseNumber: null,

      Iban: null,
      BankName: null,
      Bic: null,
      CustomerNumber: null,
      CustomerNumberIsDebtorNumber: false,
      EMail: null,
      ElectricAdress: null,
      Comment: null,
      OtherLegalInformation: null,

    };

    // VARS
    var self = this;

    self.ctx = ctx;

    self.hasViewPermission = false;
    self.hasDivManagePermission = false;
    self.hasOrgManagePermission = false;

    self.validIBAN = commonUtils.validation.iban;
    self.validBIC = commonUtils.validation.bic;
    self.validEMail = validationUtils.checkEmail;
    self.contacts = attachedContacts;
    self.displayedCollection = [];

    self.CAT_COUNTRY_IDS = CAT_COUNTRY_IDS;

    self.addressCompFieldsConfig = {
      countryId: {
        required: false
      },
      zipCode: {
        required: false
      },
      city: {
        required: false
      },
      street: {
        required: false
      },
      houseNumber: {
        required: false
      }
    };

    self.addressCompUiConfig = {
      firstRow: {
        cssCls: 'row'
      },
      secondRow: {
        cssCls: 'row'
      },
      city: {
        wrapperCssCls: 'col-sm-6'
      },
      zipCode: {
        wrapperCssCls: 'col-sm-3'
      },
      countryId: {
        wrapperCssCls: 'col-sm-3',
        dropdownCssCls: 'dropdown-menu-right',
      },
      street: {
        wrapperCssCls: 'col-sm-6'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-6'
      },
      addressAffix: {
        wrapperCssCls: 'col-sm-12'
      },
    };

    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };

    self.pristineBusinessPartner = _.cloneDeep(businessPartner);
    self.businessPartner = _.cloneDeep(businessPartner || {});

    if ((self.ctx || [])[0] || self.ctx) {
      self.currentDivisionId = parseInt(self.ctx);

      // if its a rootOrg or if the given selected ctx is invalid (not a divisionId), then we does not allow div-selection
      if (isNaN(self.currentDivisionId) || (self.businessPartner.id && self.businessPartner.DivisionId == null)) {
        self.currentDivisionId = null;
      }
    }

    self.isLinkedWithCurrentDivision = !!_.find((self.businessPartner || {}).Divisions, { id: self.currentDivisionId });

    self.currentDivisionLink = _.find((businessPartner || {}).Divisions || [], { id: self.currentDivisionId });
    self.businessPartnerDivisionLinkData = _.cloneDeep((self.currentDivisionLink || {}).DivisionsLinkedBusinessPartners);

    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ContactsBusinessPartnerDetailsCtrl#
    */
    function activate() {
      getUiPermissions();

      if (self.isNew()) {
        self.businessPartner = _.cloneDeep(newBusinessPartner);
      }

      if (self.businessPartner.IsInternal == true) {
        // REMARK: if its a system-businesspartner, then we temp. copy the fields from the division, so we have the information for the input-fields and the form...
        // however we forbid to edit the form-fields
        self.businessPartner = Object.assign(self.businessPartner, _.pick(self.businessPartner.OwnerDivision, USED_FIELDS_OWNER_DIVISION));
        self.businessPartner.ZIP = self.businessPartner.OwnerDivision.ZipCode;
      }
    }

    // EVENT-HANDLERS
    self.save = function (form) {
      if (form.$valid) {
        // we forbid edit of fields of system-businesspartners
        var businessPartnerData = Object.assign({}, self.businessPartner);

        if (self.businessPartner.IsInternal == true) {
          businessPartnerData = _.omit(businessPartnerData, USED_FIELDS_OWNER_DIVISION);
        }

        if (businessPartnerData.CountryId) {
          businessPartnerData.CountryId = businessPartnerData.CountryId.Name || businessPartnerData.CountryId;
        }

        ArnoDashBusinessPartnersService.saveBusinessPartnerWithNotifications(
          businessPartnerData,
          self.currentDivisionId,
          undefined,
          self.businessPartnerDivisionLinkData
        )
          .then(function () {
            $state.go('arno.contacts.businessPartners', {
              selectedCtxInfo: {
                division: self.currentDivisionId
              }
            });
          });
      }
    };

    self.deleteOrgBusinessPartner = function (businessPartner) {
      if ((businessPartner || {}).id && businessPartner.DivisionId == null) {
        ArnoDashBusinessPartnersService.deleteBusinessPartnerWithMessageModal(businessPartner)
          .then(function (results) {
            if (results) {
              $state.go('arno.contacts.businessPartners');
            }
          });
      }
    };

    self.toggleBusinessPartnerLinking = function (businessPartner) {
      if (self.isLinkedWithCurrentDivision) {
        self.removeBusinessPartnerLinking(businessPartner);
      } else {
        self.addBusinessPartnerAsLinking(businessPartner);
      }
    };

    self.addBusinessPartnerAsLinking = function (businessPartner) {
      if ((businessPartner || {}).id) {
        return ArnoDashBusinessPartnersService.addBusinessPartnerLinkingForDivisionsWithNotifications(
          businessPartner, self.ctx
        ).then(function () {
          $state.go('arno.contacts.businessPartners', {
            selectedCtxInfo: {
              division: self.currentDivisionId
            }
          });
        });
      }
    };

    self.removeBusinessPartnerLinking = function (businessPartner) {
      if ((businessPartner || {}).id) {
        ArnoDashBusinessPartnersService.removeLinkedBusinessPartnerWithMessageModal(self.currentDivisionId, businessPartner)
          .then(function (results) {
            if (results) {
              $state.go('arno.contacts.businessPartners', {
                selectedCtxInfo: {
                  division: self.currentDivisionId
                }
              });
            }
          });
      }
    };

    self.back = function () {
      $state.go('arno.contacts.businessPartners');
    };

    // VIEW-FUNCTIONS
    self.isNew = function () {
      return !(self.businessPartner || {}).id;
    };

    self.getTitle = function () {
      var name = self.businessPartner.IsInternal ? (self.businessPartner.OwnerDivision || {}).Name : self.businessPartner.Name;
      return self.isNew() ? 'modules.contacts.businessPartners.details.titleNew' : name;
    };

    self.checkRequiredCustomerNumber = function (newValue) {
      return !((typeof newValue !== 'string' || newValue.trim() === '')
        && !(self.businessPartner || {}).IsInternal
        && (
          (self.businessPartner || {}).IsSeller == true || (self.businessPartner || {}).IsBuyer == true
          || (self.businessPartnerDivisionLinkData || {}).IsSeller == true || (self.businessPartnerDivisionLinkData || {}).IsBuyer == true
        )
      );
    };

    self.checkIsUniqTaxIdent = function (newValue) {
      if ((self.businessPartner || {}).IsInternal) {
        // internal (division) bps are allowed to duplicate with other (division) bps and one regular bp (which is ensured to be one on create of it)
        return true;
      }
      return ArnoDashBusinessPartnersService.checkUniqBusinessPartner(Object.assign({}, self.businessPartner, { TaxIdentifier: newValue }))
        .then(function (checkInfo) {
          if (((checkInfo || {}).conflicts || []).length) {
            if (checkInfo.conflicts.indexOf('BUSINESSPARTNER_NOT_UNIQ_TAX_IDENTIFIER') > -1) {
              return Promise.reject(new Error('BUSINESSPARTNER_NOT_UNIQ_TAX_IDENTIFIER'));
            }
          }

          return true;
        });
    };

    self.checkIsUniqLegalRegIdent = function (newValue) {
      if ((self.businessPartner || {}).IsInternal) {
        // internal (division) bps are allowed to duplicate with other (division) bps and one regular bp (which is ensured to be one on create of it)
        return true;
      }
      return ArnoDashBusinessPartnersService.checkUniqBusinessPartner(
        Object.assign({}, self.businessPartner, { LegalRegistrationIdentifier: newValue })
      )
        .then(function (checkInfo) {
          if (((checkInfo || {}).conflicts || []).length) {
            if (checkInfo.conflicts.indexOf('BUSINESSPARTNER_NOT_UNIQ_LEGAL_REG_IDENTIFIER') > -1) {
              return Promise.reject(new Error('BUSINESSPARTNER_NOT_UNIQ_LEGAL_REG_IDENTIFIER'));
            }
          }

          return true;
        });
    };
    self.checkIsUniqVatIdent = function (newValue) {
      if ((self.businessPartner || {}).IsInternal) {
        // internal (division) bps are allowed to duplicate with other (division) bps and one regular bp (which is ensured to be one on create of it)
        return true;
      }
      return ArnoDashBusinessPartnersService.checkUniqBusinessPartner(
        Object.assign({}, self.businessPartner, { VatIdentifier: newValue })
      )
        .then(function (checkInfo) {
          if (((checkInfo || {}).conflicts || []).length) {
            if (checkInfo.conflicts.indexOf('BUSINESSPARTNER_NOT_UNIQ_VAT_IDENTIFIER') > -1) {
              return Promise.reject(new Error('BUSINESSPARTNER_NOT_UNIQ_VAT_IDENTIFIER'));
            }
          }

          return true;
        });
    };

    self.gotoContact = function (contact) {
      $state.go('arno.contacts.contactManagementDetails', { contactId: contact.id });
    };

    self.preventPropagation = function (event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    self.openDivSelector = function () {
      $uibModal.open(
        {
          controller: 'divSelectorCtrl as $ctrl',
          animation: true,
          templateUrl: 'app/pages/contacts/businessPartners/modals/businessPartnerDivSelector.html',
          size: 'md',
          resolve: {}
        })
        .result
        .then(function (div) {
          return self.addBusinessPartnerAsLinking(div);
        });
    };

    // HELPERS
    function getUiPermissions() {
      self.hasDivManagePermission = permissions.isPermittedAnywhere('arno.contacts.businessPartners.manage', ['Division']);
      self.hasOrgManagePermission = permissions.isPermittedInOrg('arno.contacts.businessPartners.manage', [$rootScope.ctx.organization.current.id]);

      self.hasViewPermission = permissions.isPermittedInOrg('arno.contacts.businessPartners.view', [$rootScope.ctx.organization.current.id])
        || permissions.isPermittedAnywhere('arno.contacts.businessPartners.view', ['Division']);
      if (ctx && ctx[0] !== 'rootOrg') {
        self.permittedToViewContacts = permissions.isPermittedInEvery('arno.contacts.contactManagement.view', 'Division', ctx);
      } else {
        self.permittedToViewContacts = permissions.isPermittedInOrg('arno.contacts.contactManagement.view', [$rootScope.ctx.organization.current.id]);
      }
    }


    // CONTROLLER-INIT
    self.$onInit = function () {
      activate();
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
    .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher($translate) {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherWidth: '=?',
        switcherKeys: '=?',
        switcherHints: '=?',
        switcherDisabled: '=',
        switcherForceDefault: '=?'
      },
      controller: function ($scope) {
        if (!$scope.switcherWidth) {
          $scope.switcherWidth = 42;
        }

        if (!$scope.switcherKeys || !$scope.switcherKeys.on || !$scope.switcherKeys.off) {
          $scope.switcherKeys = { on: $translate.instant('components.switcher.on'), off: $translate.instant('components.switcher.off') };
        } else {
          $scope.customSwitch = !$scope.switcherForceDefault;
        }

        if (!$scope.switcherHints) {
          $scope.switcherHints = { on: '', off: '' };
        }

        $scope.getStyle = function (elementName) {
          if (elementName === 'switcher') {
            return {
              width: ($scope.switcherWidth * 2) + 'px'
            }
          }
          if (elementName === 'handleContainer') {
            if ($scope.customSwitch) {
              return {
                width: ($scope.switcherWidth * 2) + 'px',
                cursor: $scope.switcherDisabled ? 'not-allowed' : 'pointer',
              }
            }
            return {
              width: ($scope.switcherWidth * 3) + 'px',
              transform: 'translate3d(-' + $scope.switcherWidth + 'px, 0, 0)'
            }
          }
          // else | default: handle
          return {
            width: $scope.switcherWidth + 'px',
            opacity: $scope.switcherDisabled ? 0.6 : 1,
          }
        };

        $scope.getHint = function (isOn) {
          return $scope.switcherHints[(isOn ? 'on' : 'off')];
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('smart-table')
    .directive('stMultiselectSearch', ['stConfig', '$timeout', function (stConfig, $timeout) {
      return {
        require: '^stTable',
        link: function (scope, element, attr, ctrl) {
          var tableCtrl = ctrl;
          var promise = null;
          var throttle = attr.stDelay || stConfig.search.delay;
          var idProp = attr.idProp || 'id';
          var multiSelectModelCtrl = element.controller('ngModel');

          var transformInput = function(input) {
            if (input) {
              var transformedInput = angular.isArray(input) ? input : [input];
              transformedInput = transformedInput.map(function(i) {
                if (i && i[idProp]) {
                  return i[idProp];
                }
                return i;
              });
              if (transformedInput.length === 1) {
                transformedInput = transformedInput[0];
              }
              return transformedInput;
            }
            return null;
          }

          attr.$observe('stMultiselectSearch', function (newValue, oldValue) {
            var input = transformInput(multiSelectModelCtrl.$modelValue);

            if (newValue !== oldValue && input) {
              ctrl.tableState().search = {};
              tableCtrl.search(input, newValue);
            }
          });

          //table state -> view
          /* scope.$watch(function () {
            return ctrl.tableState().search;
          }, function (newValue, oldValue) {
            var predicateExpression = attr.stMultiselectSearch || '$';
            if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
              element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
            }
          }, true); */

          // view -> table state
          scope.$watch(function () {
            return multiSelectModelCtrl.$modelValue;
          }, function (newValue) {
            if (promise !== null) {
              $timeout.cancel(promise);
            }

            promise = $timeout(function () {
              tableCtrl.search(transformInput(newValue), attr.stMultiselectSearch || '');
              promise = null;
            }, throttle);
          }, true);
        }
      };
    }]);

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
    'toastr',
    'BlurAdmin.theme.components',
    'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('groupBy', groupBy);

  /** @ngInject */
  function groupBy($parse) {
    return function (list, group_by) {
      var filtered = [];
      var prev_item = null;
      var group_changed = { unchangedFor: 0, newItem: true };
      var isSame = false;

      angular.forEach(list, function (item) {
        item.byGroupNewItem = true;
        if (prev_item !== null) {
          group_by = angular.isArray(group_by) ? group_by : [group_by];
          for (var i = 0, len = group_by.length; i < len; i++) {
            if ($parse(group_by[i])(prev_item) !== $parse(group_by[i])(item)) {
              isSame = false;
              break;
            } else {
              isSame = true;
            }
          }
          if (isSame) {
            group_changed.unchangedFor = group_changed.unchangedFor + 1;
            item.byGroupNewItem = false;
          } else {
            group_changed = { unchangedFor: 0 };
          }
        }

        item.byGroup = group_changed;

        filtered.push(item);
        prev_item = item;
      });

      return filtered;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  // REMARK: 03/11/2019: seems this is not used atm. but could be useful later, so its leaved here
  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoTrainingsTreeviewController', ArnoTrainingsTreeviewController);

  /**
  * @description Controller for the ba-treeview component.
  *
  * @namespace BlurAdmin.theme.components.ArnoTrainingsTreeviewController
  */
  /** @ngInject */
  function ArnoTrainingsTreeviewController(
    $translate,
    ArnoDashTrainingsService
  ) {
    var $ctrl = this;

    // CONSTS
    $ctrl.NODE_TYPE_TRAINING = ArnoDashTrainingsService.TRAININGS_NODE_TYPE;
    $ctrl.TRAINING_STATUS_LABELS = {
      PLANNED: $translate.instant('modules.personnel.dossier.trainings.trainingState.PLANNED'),
      INPROGRESS: $translate.instant('modules.personnel.dossier.trainings.trainingState.INPROGRESS'),
      PENDING: $translate.instant('modules.personnel.dossier.trainings.trainingState.PENDING'),
      SUCCEEDED: $translate.instant('modules.personnel.dossier.trainings.trainingState.SUCCEEDED'),
      FAILED: $translate.instant('modules.personnel.dossier.trainings.trainingState.FAILED'),
    };
    $ctrl.TRAINING_STATUS = [{
      Name: $ctrl.TRAINING_STATUS_LABELS.PLANNED,
      mapping: 'PLANNED'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.INPROGRESS,
      mapping: 'INPROGRESS'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.PENDING,
      mapping: 'PENDING'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.SUCCEEDED,
      mapping: 'SUCCEEDED'
    }, {
      Name: $ctrl.TRAINING_STATUS_LABELS.FAILED,
      mapping: 'FAILED'
    }];
    


    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoTrainingsTreeviewController#
    */
    function activate() {}

    // EVENT-HANDLERS
    $ctrl.openTrainingStatistics = function(trainingNode, event) {
      event.stopPropagation();

      if (typeof $ctrl.openStatisticsHandler === 'function') {
        $ctrl.openStatisticsHandler.call($ctrl)(trainingNode);
      }
    }

    $ctrl.addTraining = function() {
      // you could also use angular.isFunction here
      if (typeof $ctrl.addTrainingHandler === 'function') {
        // the consumer decides what to do, this is only a wrapper for the button
        $ctrl.addTrainingHandler.call($ctrl)();
      }
    }

    $ctrl.deleteTraining = function(trainingNode, event) {
      event.stopPropagation();

      // you could also use angular.isFunction here
      if (typeof $ctrl.deleteTrainingHandler === 'function') {
        // the consumer decides what to do, this is only a wrapper for the button
        $ctrl.deleteTrainingHandler.call($ctrl)(trainingNode);
      }
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoTrainingsTreeviewComponent
  *
  * @description Component provides a tree-view with pre-defined arno elements like expand/collapse button,
  * or a std-tree-component for trainings-data
  */
  angular.module(
    'BlurAdmin.theme.components.trainingsTreeview',
    ['BlurAdmin.theme.components.baTreeview'],
    function($rootScopeProvider) {
      // IMPORTANT: set the max digest-cycle loops from 10 (STANDARD by angularjs) to 20
      // to allow a max deep of the nested nodes level of the angular-ui-tree
      // ADJUST this if you encounter users create a tree with a level-dept of larger than 20....
      $rootScopeProvider.digestTtl(20);
    })
    .component('arnoTrainingsTreeview', {
      templateUrl: 'app/theme/components/trainingsTreeview/trainingsTreeview.tpl.html',
      controller: 'ArnoTrainingsTreeviewController',
      controllerAs: '$trainingsTreeviewCtrl',
      bindings: {
        selectedCtx: '<?',
        trainingsTreeData: '=',
        selectedNode: '=',
        nodeSelect: '&?',
        addTrainingHandler: '&?',
        deleteTrainingHandler: '&?',
        openStatisticsHandler: '&?',
        trainingsStatusFilter: '=?',
        isLoading: '<',
        hasError: '<?',
        uiConfig: '<?'
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('templateUpload', templateUpload);

  /** @ngInject */
  function templateUpload() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/templateUpload/templateUpload.html',
      scope: {
        ctx: '=',
        type: '=',
        template: '=',
        i18nKey: '=',
        disablePreviewGeneration: '=',
        allowRootOrgRemoval: '=',
      },
      controller: 'templateUploadCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function templateUploadCtrl($scope, $rootScope, $translate, clientApi, toastr, $state, FileUploader) {
    var self = this;
    var maxAllowedFileSize = 262144000; // 25MB
    var i18nKey = $scope.i18nKey;

    self.currentDivision = $scope.ctx;
    self.currentOrg = $rootScope.ctx.organization.current.id;
    self.disablePreviewGeneration = $scope.disablePreviewGeneration;

    self.templateType = $scope.type;
    self.currentFileName = undefined;
    self.allowRootOrgRemoval = $scope.allowRootOrgRemoval;

    self.state = 'initial';

    self.template = $scope.template;
    self.templateMissingText = self.template.exists ? '' : 'modules.docxTemplates.noPreview';
    self.changeFileBtnText = $translate.instant('components.templateUpload.' + i18nKey + '.changeFileBtn', { exists: self.template.exists });

    self.tplName = $translate.instant('components.templateUpload.'+i18nKey+'.tplName');
    self.name = $translate.instant('components.templateUpload.'+i18nKey+'.name');

    self.activeTabIndex = _.findIndex(self.tabs, { type: self.templateType });

    self.getText = function () {
      return self.texts[self.templateType]
    };

    self.getApiUploadUrl = function () {
      return '/api/docxTemplateStorage/upload?divisionId=' + self.currentDivision + '&type=' + self.templateType;
    };

    self.uploaderConfig = clientApi.fileUploaderConfig({
      queueLimit: 3,
      url: self.getApiUploadUrl(),
      onAfterAddingFile: function (fileItem) {
        if (fileItem.file.type === '.docx') {
          self.uploader.removeFromQueue(fileItem);
          toastr.error($translate.instant('components.templateUpload.general.mustDoxc'), $translate.instant('components.templateUpload.general.falseFileFormat'));
          return false
        }
        if (fileItem.file.size > maxAllowedFileSize) {
          self.uploader.removeFromQueue(fileItem);
          toastr.error($translate.instant('components.templateUpload.general.notLargerThan25MB'), $translate.instant('components.templateUpload.general.fileToBig'));
          return false
        }

        self.uploader.queue = [fileItem];
        self.currentFileName = fileItem._file.name;
      },
      onCompleteAll: function () {
        self.uploader.clearQueue();
        toastr.success($translate.instant('components.templateUpload.general.templateWasSuccessfulSaved'), $translate.instant('components.templateUpload.general.templateSave'));
        $state.reload();
      },
      onErrorItem: function () {
        toastr.error($translate.instant('components.templateUpload.general.templateCantSave'), $translate.instant('components.templateUpload.general.editFailed'));
      },
      onWhenAddingFileFailed: function () {
        toastr.error($translate.instant('components.templateUpload.general.addWasFailed'), $translate.instant('components.templateUpload.general.error'));
      },
    });

    self.uploader = new FileUploader(self.uploaderConfig);

    self.uploadTemplate = function () {
      self.uploader.url = self.getApiUploadUrl();

      self.uploader.queue.forEach(function (file, index) {
        file.alias = 'file';
        file.url = self.getApiUploadUrl();

        self.uploader.uploadItem(index);
      });
    };

    self.btnSetStateUpload = function () {
      self.state = 'upload';
    };
    self.btnDownloadExample = function () {
      var exampleFileName = $translate.instant('components.templateUpload.'+ i18nKey +'.exampleFileName');
      window.open(
        '/assets/templates/' + exampleFileName + '.docx',
        '_blank'
      );
    };

    self.btnDownloadTemplate = function () {
      clientApi.openTab('docxTemplateStorage/download', {
        divisionId: $scope.ctx,
        type: self.templateType,
      });
    };

    self.btnRemoveTemplate = function () {
      return clientApi
        .emit('docxTemplateStorage/removal', {
          divisionId: $scope.ctx,
          type: $scope.type,
        })
        .then(function () {
          toastr.success(
            $translate.instant('components.templateUpload.general.removalSuccessBody'),
            $translate.instant('components.templateUpload.general.removalSuccessTitle')
          );
          $state.reload();
        });
    };

    self.btnGeneratePdf = function () {
      clientApi.openTab('docxTemplateStorage/generatePdf', {
        divisionId: $scope.ctx,
        type: self.templateType,
        preview: true,
      });
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('templateUploadCtrl', templateUploadCtrl);
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('tagPicker', tagPicker);

  /** @ngInject */
  function tagPicker() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/tagPicker/tagPicker.html',
      scope: {
        defaultLabel: '=',
        tags: '=',
        selectedTags: '=',
        disabled: '<?',
        allowNewTags: '<?',
        newTagsTaggingLabel: '<?',
        appendToBodyWithClass: '=?',
        appendToButtonWithClass: '=?',
        onGroupFunc: '=?',
        hideDivisionName: '=?',
      },
      controller: 'TagPickerCtrl as $tagPick'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('TagPickerCtrl', TagPickerCtrl);

  function TagPickerCtrl($scope, commonUtils) {
    var self = this;

    // VARS
    self.allowNewTags = $scope.allowNewTags;
    self.newTagsTaggingLabel = ($scope.newTagsTaggingLabel === true);

    self.aTBC = $scope.appendToBodyWithClass || '';
    self.aTB = $scope.appendToBodyWithClass ? true : false;
    self.buttonClass = $scope.appendToButtonWithClass || '';
    self.onGroupFunc = $scope.onGroupFunc || undefined;
    self.hideDivisionName = !!$scope.hideDivisionName;

    self.emptySelection = function () {
      // keep category reference
      if ($scope.selectedTags && $scope.selectedTags.length) {
        $scope.selectedTags.splice(0, $scope.selectedTags.length);
      }
    };

    self.setColor = function (item) {
      return {
        'background-color': item.Color,
        'color': commonUtils.getContrastLabelColor(item.Color)
      }
    };

    self.tagTransform = function(newTagName) {
      if (_.find(self.tags, { Name: newTagName }) || newTagName.trim() === '') {
        return undefined;
      }

      return {
        Name: newTagName,
        mapping: newTagName
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('smart-table')
      .directive('stTable', tableSortOverride);

  /** @ngInject */
  function tableSortOverride() {
    return {
      priority: -1000,
      link: function (scope, element) {
        scope.$watch( 
          function() { return element.find('th[st-sort]').length }, 
          function() { addSortIcons(element) }
        );        
      }
    }
  }

  function addSortIcons(table) {
    var sortIconTemplate = 
        '<span class="column-control sort-icon">'
          + '<i class="fa fa-caret-up"></i>'
          + '<i class="fa fa-caret-down"></i>'
        + '</span>';
    
    table.find('tr.sortable').each( function() {
      $(this).find('th[st-sort]').each(function() {
        if ( $(this).find('.sort-icon').length === 0) {
          var sortIcon = angular.element(sortIconTemplate)
          if ( $(this).find('.column-control').length >= 1 ) {
            sortIcon.insertBefore( $(this).find('.column-control').first() );
          }
          else {
            if ($(this).children().length) {
              if ($(this).children().last().hasClass('aggregatable')) {
                $(this).children()[$(this).children().length - 1].append(sortIcon)
              } else {
                $(this).children().last().append(sortIcon);
              }
            } else {
              $(this).append(sortIcon);
            }
          }
        }
      })
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.personnelList')
    .controller('tableConfigCtrl', tableConfigCtrl);

  function tableConfigCtrl(clientApi, toastr, $uibModal, $uibModalInstance, aggExclusion, isOrgList, availableLists, availableFields, currentList, sortableFields, isMaterialList, $translate) {
    var self = this;
    self.availableFields = _.orderBy(availableFields, ['sort'], ['asc']);

    self.availableLists = availableLists;
    self.tempModification = false;
    self.unmodifiedCurrentList = currentList;
    // create a clone of current list
    self.currentList = JSON.parse(JSON.stringify(currentList));
    self.deletedLists = [];
    self.isMaterialList = isMaterialList;

    self.sort = function (direction, list, prop) {
      var add = true;
      if (!list.Sort) {
        list.Sort = {};
      } else {
        if (list.Sort[prop] && list.Sort[prop].direction === direction) {
          add = false;
          delete list.Sort[prop];
        }
      }
      if (add) {
        var sort = _.find(sortableFields, { 'fieldName': prop });
        if (!list.Fields[prop]) {
          list.Fields[prop] = true;
        }
        list.Sort = {};
        list.Sort[prop] = { direction: direction, sortProp: sort.sortProp };
      }
    };
    self.isSortable = function (property) {
      var sort = _.find(sortableFields, { 'fieldName': property });
      if (!sort) {
        return false;
      }
      return !!sort.sortProp;
    };
    self.aggregate = function (agg, list) {
      if (list.Fields[agg] && self.checkAggExclusion(agg)) {
        if (!list.Aggregations) {
          list.Aggregations = {};
        }

        if (agg) {
          // aggregate the prop
          if (list.Aggregations[agg]) {
            delete list.Aggregations[agg];
          } else {
            list.Aggregations[agg] = true;
          }
        }
      }
    }
    self.checkAggExclusion = function(prop) {
      return !~aggExclusion.indexOf(prop);
    }
    self.updateCurrentSortAggSettings = function(prop, list) {
      if (list.Fields[prop]) {
        if (list.Aggregations && list.Aggregations[prop]) {
          delete list.Aggregations[prop];
        }
        if (list.Sort && list.Sort[prop]) {
          delete list.Sort[prop];
        }
      }
    }

    self.createNewList = function () {
      // open modal to enter listName
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/customListName.modal.html',
          size: 'md',
          controller: function ($scope) {
            $scope.name = '';
            $scope.preSelectAll = false;
            $scope.showSelectAllCheckBox = true;
            $scope.enter = function(keyEvent){
              if (keyEvent.which === 13){
                $scope.close();
              }
            };
            $scope.close = function() {
              if ($scope.name) {
                this.$close({name: this.name, preSelectAll: this.preSelectAll});
              }
            };
          },
        })
        .result
        .then(function (listConfig) {
          var listCount = Object.keys(self.availableLists).length;
          self.availableLists['newList_' + listCount] = {
            Name: listConfig.name,
            Fields: {}
          };
          if (listConfig.preSelectAll) {
            self.availableFields.forEach(function(field) {
              self.availableLists['newList_' + listCount].Fields[field.prop] = true;
            });
          }
        });
    };
    self.editListName = function (id, list) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/customListName.modal.html',
          size: 'md',
          controller: function ($scope) {
            $scope.name = list.Name;
            $scope.showSelectAllCheckBox = false;
            $scope.enter = function(keyEvent){
              if (keyEvent.which === 13){
                this.$close(this.name)
              }
            }
            $scope.close = function() {
              if ($scope.name) {
                this.$close(this.name);
              }
            };
          },
        })
        .result
        .then(function (listName) {
          list.Name = listName;
        });
    };
    self.removeList = function (id, list) {
      if (self.availableLists[id]) {
        // open modal to confirm deletion
        return $uibModal
          .open({
            animation: true,
            templateUrl: 'app/theme/components/tableConfig/removeList.modal.html',
            size: 'md',
            controller: function ($scope) {
              $scope.name = list.Name;
            },
          })
          .result
          .then(function () {
            delete self.availableLists[id];
            if (list.id) {
              // just make a database delete if this list already exists in it
              self.deletedLists.push(list);
            }
          });
      }
    };
    self.save = function () {
      var valid = true;
      _.forOwn(self.availableLists, function (value) {
        var validList = false;
        if (Object.keys(value.Fields).length > 0) {
          _.forOwn(value.Fields, function (value) {
            if (value === true || value === 'true') {
              validList = true;
            }
          });
        }
        if (!validList) {
          valid = false;
          toastr.error($translate.instant('components.tableConfig.errToastText') + value.Name, $translate.instant('components.tableConfig.errToastTitle'));
        }
      });
      if (valid) {
        var returnObj = {
          availableLists: self.availableLists,
          deletedLists: self.deletedLists,
        };
        if (self.tempModification) {
          // apparently we modified the current list so we'll return the modified version as current View
          returnObj.modifiedCurrentList = self.currentList.current;
        }
        $uibModalInstance.close(returnObj);
      }
    };
  }

})();


(function () {
  'use strict';


  // CONTROLLER
  /**
  * @ngdoc controller
  * @name arnoDashAdminOrgSupervisorsListController
  *
  * @description Controller for arnoDashAdminOrgSupervisorsListComponent.
  *
  * @namespace arnoDashAdminOrgSupervisorsListController
  */
  function arnoDashAdminOrgSupervisorsListController(
    $rootScope, $scope, $state, $uibModal, stateChangePrompt,
    clientApi, toastr, $translate,
    permissions
  ) {
    var  $ctrl = this;

    activate();

    /**
    * @name activate
    *
    * @description Function for controller inits
    * @memberOf arnoDashAdminOrgSupervisorsListController#
    */
    function activate() {
      // ADD as needed, this is a template for later components
    }

    // LIFE-CYCLE-HOOKS
    $ctrl.$onChanges = function() {
      // add as needed
    }

    // EVENT-HANDLERS
    $ctrl.save = function () {
      $ctrl.saveSupervisorsAssignments()
        .then(function () {
          if (!$ctrl.changeIndicator.changed) {
            return toastr.info(
              $translate.instant('components.superVisorsList.Toast1Text'),
              $translate.instant('components.superVisorsList.Toast1Title')
            );
          }

          if ($ctrl.changeIndicator.changed && !$ctrl.changeIndicator.saveError) {
            toastr.success(
              $translate.instant('components.superVisorsList.Toast2Text'),
              $translate.instant('components.superVisorsList.Toast2Title')
            );
          }

          $ctrl.selfReload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('components.superVisorsList.Toast11Text'),
            $translate.instant('components.superVisorsList.Toast11Title')
          );
        });
    };

    $ctrl.refresh = function () {
      $ctrl.selfReload();
      toastr.error(
        $translate.instant('components.superVisorsList.Toast3Text'),
        $translate.instant('components.superVisorsList.Toast3Title')
      );
    };

    // REMARK: The choose-member modal could/should be refactored to be used somewhere else. its a generic component
    $ctrl.openModal = function (newOrChoose, rolename) {
      if (!rolename) {
        return Promise.reject();
      }

      $uibModal.open({
        controller: 'chooseMemberModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/supervisorsList/membersModal/' + newOrChoose + '.html',
        size: 'md',
        resolve: {
          organizationId: function () {
            return $ctrl.organizationData ? $ctrl.organizationData.id : $rootScope.ctx.organization.current.id;
          },
        }
      })
      .result.then(function (result) {
        if (result.selectedMember) {
          var member = result.selectedMember;
          var exists = false;
          var memberCollection = $ctrl.supervisors;

          memberCollection.forEach(function (roleMember) {
            if (roleMember.EMail == member.Account.EMail) {
              if (roleMember.delete) {
                roleMember.delete = null;
                $ctrl.changeIndicator.potentialChanges = true;
              } else {
                exists = true;
              }

            }
          });
          if (exists) {
            toastr.error('Es wurde versucht ein Duplikat anzulegen!', 'Bereits vorhanden');
            toastr.error(
              $translate.instant('components.superVisorsList.Toast4Text'),
              $translate.instant('components.superVisorsList.Toast4Title')
            );
          } else {
            if (member.Account) {
              member.EMail = member.Account.EMail;
              member.Account = null;
            }

            member.isNewRolemember = true;
            if (member.FirstName && member.LastName && member.EMail) {
              $ctrl.supervisors.push(member);
              $ctrl.changeIndicator.potentialChanges = true;
            }
          }
        }
      });
    }

    $ctrl.deleteSupervisor = function (index) {
      var supervisor = $ctrl.supervisors[index];
      if (supervisor.isNewRolemember) {
        $ctrl.supervisors.splice(index, 1);
      } else {
        supervisor.delete = true;
      }
      $ctrl.changeIndicator.potentialChanges = true;
    };

    // VIEW-FUNCTIONS
    $ctrl.isPermitted = function() {
      if (!$ctrl.organizationData || !$ctrl.organizationData.id) {
        return false;
      }

      return $ctrl.isPermittedInCurrentOrg($ctrl.config.controlPermission);
    }

    $ctrl.isPermittedInCurrentOrg = function(action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    }

    // HELPERS
    $ctrl.saveSupervisorsAssignments = function() {
      if ($ctrl.changeIndicator.potentialChanges
        && permissions.isPermittedInEvery($ctrl.config.controlPermission, 'Organization', [$rootScope.ctx.organization.current.id])
      ) {
        var changePromises = []

        $ctrl.organizationData[$ctrl.config.scopeOfMembers].forEach(function (supervisor) {
          if (supervisor.isNewRolemember) {
            $ctrl.changeIndicator.changed = true;

            changePromises.push(clientApi.custom('model/OrganizationRoleMember', 'createOrganizationRoleMember', {
              roleId: $ctrl.roleId,
              memId: supervisor.id || supervisor.MemberId,
            }));
          }

          if (supervisor.delete) {
            $ctrl.changeIndicator.changed = true;

            changePromises.push(clientApi.custom('model/OrganizationRoleMember', 'deleteOrganizationRoleMember', {
              roleId: $ctrl.roleId,
              memId: supervisor.MemberId,
            }));
          }
        });

        return Promise.all(changePromises);
      } else {
        return Promise.resolve();
      }
    }

    $ctrl.selfReload = function () {
      stateChangePrompt.disableEvaluation();
      $state.reload();
    };
  }


  // COMPONENT
  /**
  * @ngdoc component
  * @name arnoDashAdminOrgSupervisorsList
  *
  * @description This component is used to control the supervisors (e.g. for approvals, statistics...) for divisions
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoDashAdminOrgSupervisorsList', {
      ngName: 'arnoDashAdminOrgSupervisorsList', // not mandatory atm, but later if this component is separately defined then its better to define the name explicitly
      templateUrl: 'app/theme/components/supervisorsList/adminSupervisorsList.tpl.html',
      bindings: {
        organizationData: '=',
        roleId: '<',
        supervisors: '=',
        config: '=',

        // From parent-object, the HOLDER for (overall)-changes indicator.
        // The reason is that there is a save button for the whole division-management-page, which may affect functions of this and other components
        changeIndicator: '='
      },
      controllerAs: '$ctrl',
      controller: arnoDashAdminOrgSupervisorsListController
    });

})();

(function () {
  'use strict';


  // CONTROLLER
  /**
  * @ngdoc controller
  * @name arnoDashAdminDivisionsSupervisorsListController
  *
  * @description Controller for arnoDashAdminDivisionsSupervisorsListComponent.
  *
  * @namespace arnoDashAdminDivisionsSupervisorsListController
  */
  function arnoDashAdminDivisionsSupervisorsListController(
    $rootScope, $scope, $state, $uibModal, stateChangePrompt,
    clientApi, toastr, $translate,
    permissions, ArnoDashAdminDivisionsService
  ) {
    var  $ctrl = this;

    activate();

    /**
    * @name activate
    *
    * @description Function for controller inits
    * @memberOf arnoDashAdminDivisionsSupervisorsListController#
    */
    function activate() {
      // ADD as needed, this is a template for later components
    }

    // LIFE-CYCLE-HOOKS
    $ctrl.$onChanges = function() {
      // add as needed
    }

    // EVENT-HANDLERS
    $ctrl.save = function () {
      $ctrl.saveSupervisorsAssignments()
        .then(function () {
          if (!$ctrl.changeIndicator.changed) {
            return toastr.info(
              $translate.instant('components.superVisorsList.Toast1Text'),
              $translate.instant('components.superVisorsList.Toast1Title')
            );
          }

          if ($ctrl.changeIndicator.changed && !$ctrl.changeIndicator.saveError) {
            toastr.success(
              $translate.instant('components.superVisorsList.Toast2Text'),
              $translate.instant('components.superVisorsList.Toast2Title')
            );
          }

          $ctrl.selfReload();
        })
    };

    $ctrl.refresh = function () {
      $ctrl.selfReload();
      toastr.info(
        $translate.instant('components.superVisorsList.Toast3Text'),
        $translate.instant('components.superVisorsList.Toast3Title')
      );
    };

    // REMARK: The choose-member modal could/should be refactored to be used somewhere else. its a generic component
    $ctrl.openModal = function (newOrChoose, rolename) {
      if (!rolename) {
        return Promise.reject();
      }

      $uibModal.open({
        controller: 'chooseMemberModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/supervisorsList/membersModal/' + newOrChoose + '.html',
        size: 'md',
        resolve: {
          selectedDivision: function () {
            return $ctrl.selectedDivision;
          },
          organizationId: function () {
            return $ctrl.organizationId;
          },
        }
      })
      .result.then(function (result) {
        if (result.selectedMember) {
          var member = result.selectedMember;
          var exists = false;
          var memberCollection = $ctrl.supervisors;

          memberCollection.forEach(function (roleMember) {
            if (roleMember.EMail == member.Account.EMail) {
              if (roleMember.delete) {
                roleMember.delete = null;
                $ctrl.changeIndicator.potentialChanges = true;
              } else {
                exists = true;
              }

            }
          });
          if (exists) {
            toastr.error(
              $translate.instant('components.superVisorsList.Toast4Text'),
              $translate.instant('components.superVisorsList.Toast4Title')
            );
          } else {
            if (member.Account) {
              member.EMail = member.Account.EMail;
              member.Account = null;
            }

            member.isNewRolemember = true;
            if (member.FirstName && member.LastName && member.EMail) {
              $ctrl.supervisors.push(member);
              $ctrl.changeIndicator.potentialChanges = true;
            }
          }
        }
      });
    }

    $ctrl.deleteSupervisor = function (index) {
      var supervisor = $ctrl.supervisors[index];
      if (supervisor.isNewRolemember) {
        $ctrl.supervisors.splice(index, 1);
      } else {
        supervisor.delete = true;
      }
      $ctrl.changeIndicator.potentialChanges = true;
    };

    $ctrl.pushToSubdivisions = function (role, selectedDivision) {
      ArnoDashAdminDivisionsService.pushToSubdivisions(role, selectedDivision, $ctrl.divisionTree, $ctrl.divisionNodesData)
        .then(function(copyResults) {
          if (!copyResults || !copyResults.success) {
            toastr.error(
              $translate.instant('components.superVisorsList.Toast5Text'),
              $translate.instant('components.superVisorsList.Toast5Title')
            );
          }
          else if (copyResults.success && !copyResults.changesOccured) {
            toastr.warning(
              $translate.instant('components.superVisorsList.Toast6Text'),
              $translate.instant('components.superVisorsList.Toast6Title')
            );
          }
          else if(copyResults.success && copyResults.changesOccured) {
            $ctrl.changeIndicator.potentialChanges = true;
            // NOTE: maybe show a toastr that the temp. action was succesful, however the toastr could be missleading, because the changes haven't been saved yet
            // they are saved if the user clicks on the "save" button from the division-management-panel
            toastr.info(
              $translate.instant('components.superVisorsList.Toast7Text'),
              $translate.instant('components.superVisorsList.Toast7Title')
            );
          }
        })
        .catch(function(error) {
          switch((error || {}).errorKey) {
          case 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERR_NO_ROLES':
            toastr.error(
                $translate.instant('components.superVisorsList.Toast8Text'),
                $translate.instant('components.superVisorsList.Toast8Title')
              );
            break;

          case 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERROR_NO_CHILD_DIVISIONS':
            toastr.warning(
                $translate.instant('components.superVisorsList.Toast9Text'),
                $translate.instant('components.superVisorsList.Toast9Title')
              );
            break;

          default:
            toastr.error(
                $translate.instant('components.superVisorsList.Toast10Text'),
                $translate.instant('components.superVisorsList.Toast10Title')
              );
          }
        });
    }

    // VIEW-FUNCTIONS
    $ctrl.isPermitted = function() {
      if (!this.selectedDivision || !this.selectedDivision.id ) {
        return false;
      }

      return $ctrl.isPermittedInCurrentOrg($ctrl.config.controlPermission);
    }

    $ctrl.isPermittedInCurrentOrg = function(action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    }

    // HELPERS
    $ctrl.saveSupervisorsAssignments = function() {
      if ($ctrl.changeIndicator.potentialChanges
        && permissions.isPermittedInEvery($ctrl.config.controlPermission, 'Organization', [$rootScope.ctx.organization.current.id])
      ) {
        var supervisorRoleId;

        return clientApi.custom('model/DivisionRole', 'findDivisionRoles', {
          name: $ctrl.config.roleName,
        })
          .then(function (result) {
            if (result.length && result[0].Name === $ctrl.config.roleName) {
              supervisorRoleId = result[0].id;
            } else {
              throw 'no supervisor role: ' + $ctrl.config.roleName + ' found!';
            }

            var promises = [];

            $ctrl.divisionNodesData.forEach(function (division) {
              division[$ctrl.config.scopeOfMembers].forEach(function (supervisor) {
                if (supervisor.isNewRolemember) {
                  $ctrl.changeIndicator.changed = true;

                  promises.push(clientApi.custom('model/DivisionRoleMember', 'createDivisionRoleMember', {
                    roleId: supervisorRoleId,
                    memId: supervisor.id || supervisor.MemberId,
                    divId: division.id,
                  }))
                }

                if (supervisor.delete) {
                  $ctrl.changeIndicator.changed = true;

                  promises.push(clientApi.custom('model/DivisionRoleMember', 'deleteDivisionRoleMember', {
                    roleId: supervisorRoleId,
                    memId: supervisor.MemberId,
                    divId: division.id,
                  }));
                }
              });
            });

            return Promise.all(promises);
          })
      } else {
        return Promise.resolve();
      }
    }

    $ctrl.selfReload = function () {
      stateChangePrompt.disableEvaluation();
      $state.reload();
    };
  }


  // COMPONENT
  /**
  * @ngdoc component
  * @name arnoDashAdminDivisionsSupervisorsList
  *
  * @description This component is used to control the supervisors (e.g. for approvals, statistics...) for divisions
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoDashAdminDivisionsSupervisorsList', {
      ngName: 'arnoDashAdminDivisionsSupervisorsList', // not mandatory atm, but later if this component is separately defined then its better to define the name explicitly
      templateUrl: 'app/theme/components/supervisorsList/adminSupervisorsList.tpl.html',
      bindings: {
        organizationId: '<',
        divisionNodesData: '=',
        divisionTree: '=',
        selectedDivision: '=',
        supervisors: '=',
        config: '=',

        // From parent-object, the HOLDER for (overall)-changes indicator.
        // The reason is that there is a save button for the whole division-management-page, which may affect functions of this and other components
        changeIndicator: '='
      },
      controllerAs: '$ctrl',
      controller: arnoDashAdminDivisionsSupervisorsListController
    });

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('statusLight', statusLight);

  /** @ngInject */
  function statusLight() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/statusLight/statusLight.html',
      scope: {
        isGreen: '=?',
        useYellowLight: '=',
        useOneLight: '=',
        isYellow: '=?',
        isInactive: '=?',
        greenTitle: '=?',
        yellowTitle: '=?',
        inactiveTitle: '=?',
        redTitle: '=?',
        class: '=?',
      },
      controller: 'statusLightCtrl as $slight'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function statusLightCtrl($scope, $translate) {
    var self = this;
    $scope.$watch(function () {
      return $scope.isGreen;
    }, function () {
      self.isGreen = !!$scope.isGreen;
    });
    $scope.$watch(function () {
      return $scope.useYellowLight;
    }, function () {
      self.useYellowLight = $scope.useYellowLight;
    });
    $scope.$watch(function () {
      return $scope.useOneLight;
    }, function () {
      self.useOneLight = $scope.useOneLight;
    });
    $scope.$watch(function () {
      return $scope.isYellow;
    }, function () {
      self.isYellow = !!$scope.isYellow;
    });
    $scope.$watch(function () {
      return $scope.isInactive;
    }, function () {
      self.isInactive = !!$scope.isInactive;
    });
    $scope.$watch(function () {
      return $scope.class;
    }, function () {
      self.class = $scope.class;
    });
    $scope.$watch(function () {
      return $scope.greenTitle;
    }, function () {
      self.greenTitle = $translate.instant($scope.greenTitle);
    });
    $scope.$watch(function () {
      return $scope.yellowTitle;
    }, function () {
      self.yellowTitle = $translate.instant($scope.yellowTitle);
    });
    $scope.$watch(function () {
      return $scope.redTitle;
    }, function () {
      self.redTitle = $translate.instant($scope.redTitle);
    });
    $scope.$watch(function () {
      return $scope.inactiveTitle;
    }, function () {
      self.inactiveTitle = $translate.instant($scope.inactiveTitle);
    });
  }

  angular.module('BlurAdmin.theme.components')
    .controller('statusLightCtrl', statusLightCtrl);
})();

(function () {
  'use strict';

  /** @ngInject */
  function statisticHelperHoursCtrl($translate, $scope, toastr, clientApi) {
    var self = this;

    self.provider = $scope.provider;
    self.currentData = $scope.currentData;
    self.collapseFilter = $scope.collapseFilter || false;
    self.divisionIds = $scope.divisionIds;

    self.timeSpanFrom = moment().subtract(7, 'days').toDate();
    self.timeSpanDates = [7, 6, 5, 4, 3, 2, 1].map(function (i) {
      return +moment().subtract(i, 'days').startOf('day').toDate();
    });

    self.tableShow = $scope.tableShow || false;
    self.tableProvider = $scope.tableProvider;
    self.tableData = $scope.tableData;
    self.helperListColumns = '2';
    self.rowsPerPage = 5;

    self.tableUpdate = function (params) {
      var timeSpan = self.setTimeSpan();
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.rowsPerPage || 0,
          limit: self.rowsPerPage
        },
        order: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        search: {
          fullNameTerm: params.search.predicateObject && params.search.predicateObject.fullNameSearch ? params.search.predicateObject.fullNameSearch : false,
        }
      };
      if (timeSpan.startDate && timeSpan.endDate) {
        return self.tableProvider(
          timeSpan.startDate,
          timeSpan.endDate,
          (self.selectedActivity || {}).id,
          (self.selectedBaseCategory || {}).id,
          queryWishes
        ).then(function (tableData) {
          self.tableData = tableData;
          params.pagination.numberOfPages = self.tableData.maxPages;
        });
      }
    };

    self.activities = [];
    self.selectedActivity = null;
    self.searchActivities = function (searchTerm) {
      if (!searchTerm) {
        if (self.selectedActivity) {
          self.activities = [{ none: true }];
        } else {
          self.activities = [];
        }
        return null;
      }
      return clientApi.custom('model/activity', 'getActivityAll', {
        divisionIds: self.divisionIds,
        searchTerm: searchTerm,
      }).then(function (activities) {
        self.activities = activities;
        self.activities.push({ none: true });
      });
    };
    $scope.$watch(function () {
      return self.selectedActivity;
    }, function (newVal, oldVal) {
      if (self.selectedActivity && self.selectedActivity.none) {
        self.selectedActivity = null;
      }
      self.filterWatcher(newVal, oldVal);
    }, true);

    self.baseCategories = [];
    self.selectedBaseCategory = null;
    self.searchBaseCategories = function (searchTerm) {
      if (!searchTerm) {
        if (self.selectedBaseCategory) {
          self.baseCategories = [{ none: true }];
        } else {
          self.baseCategories = [];
        }
        return null;
      }
      return clientApi.custom('model/basecategory', 'getBaseCategoryAll', {
        divisionIds: self.divisionIds,
        searchTerm: searchTerm,
      }).then(function (baseCategories) {
        self.baseCategories = baseCategories;
        self.baseCategories.push({ none: true });
      });
    };
    $scope.$watch(function () {
      return self.selectedBaseCategory;
    }, function (newVal, oldVal) {
      if (self.selectedBaseCategory && self.selectedBaseCategory.none) {
        self.selectedBaseCategory = null;
      }
      self.filterWatcher(newVal, oldVal);
    }, true);

    if (self.currentData && self.currentData.rangeStart && self.currentData.rangeEnd) {
      self.timeSpanFrom = moment(self.currentData.rangeStart).startOf('day').toDate();
      var dayIterator = moment(self.currentData.rangeStart).startOf('day');
      var endDate = moment(self.currentData.rangeEnd).startOf('day');
      self.timeSpanDates = [];
      while (dayIterator.isSameOrBefore(endDate)) {
        self.timeSpanDates.push(+dayIterator);
        dayIterator.add(1, 'day');
      }
    }

    self.datepickerOptions = {
      range: {
        maxDate: moment().subtract(1, 'day').subtract(1, 'hour').toDate(),
        customClass: function (data) {
          if (self.timeSpanDates
            .filter(function (date) {
              return +new Date(date).setHours(0, 0, 0, 0) === data.date.setHours(0, 0, 0, 0);
            })
            .length) {
            return 'multiple-selected';
          }
          return '';
        }
      },
      day: {
        maxDate: moment().subtract(1, 'day').subtract(1, 'hour').toDate(),
      }
    };

    self.timeSpanType = true;

    self.timeSpanSwitcherKeys = {
      on: $translate.instant('components.statisticHelperHours.timePeriod'),
      off: $translate.instant('components.statisticHelperHours.singleDayPeriod'),
    };

    self.setTimeSpan = function () {
      var timeSpan = {};
      if (self.timeSpanType && self.timeSpanDates.length > 1) {
        var dates = _.clone(self.timeSpanDates).sort();
        timeSpan.startDate = new Date(dates.slice(0, 1)[0]);
        timeSpan.endDate = new Date(dates.slice(dates.length - 1, dates.length)[0]);
        if (moment.duration(moment(timeSpan.endDate).diff(moment(timeSpan.startDate))).asDays() >= (365 * 5.1)) {
          toastr.warning(
            $translate.instant('components.statisticHelperHours.timePeriodWarningText'),
            $translate.instant('components.statisticHelperHours.timePeriodWarningTitle')
          );
          return;
        }
      }
      if (!self.timeSpanType) {
        timeSpan.startDate = moment(self.timeSpanFrom).toDate();
        timeSpan.endDate = moment(self.timeSpanFrom).toDate();
      }
      return timeSpan;
    };

    self.filterWatcher = function (newVal, oldVal) {
      if (newVal !== oldVal) {
        var timeSpan = self.setTimeSpan();
        if (timeSpan.startDate && timeSpan.endDate || newVal.hasOwnProperty('Title') || newVal.hasOwnProperty('Name')) {
          self.provider(
            timeSpan.startDate,
            timeSpan.endDate,
            (self.selectedActivity || {}).id,
            (self.selectedBaseCategory || {}).id
          ).then(function (statisticData) {
            self.currentData = statisticData;
          });
          self.tableProvider(
            timeSpan.startDate,
            timeSpan.endDate,
            (self.selectedActivity || {}).id,
            (self.selectedBaseCategory || {}).id,
            { paging: { offset: 0, limit: self.rowsPerPage } }
          ).then(function (tableData) {
            self.tableData = tableData;
          });
        }
      }
    }

    $scope.$on('updateHelperHoursStatistic', function () {
      self.filterWatcher(true, false);
    });

    $scope.$watch(function () {
      return self.timeSpanDates;
    }, function (newVal, oldVal) {
      self.filterWatcher(newVal, oldVal);
    }, true);

    $scope.$watch(function () {
      return self.timeSpanFrom;
    }, function (newVal, oldVal) {
      self.filterWatcher(newVal, oldVal);
    }, true);

    $scope.$watch(function () {
      return self.timeSpanType;
    }, function (newVal, oldVal) {
      self.filterWatcher(newVal, oldVal);
    }, true);

    $scope.$watch(function () {
      return self.currentData;
    }, function () {
      self.heatmapData = Object.keys(self.currentData.helperHoursActivityGraph || {}).map(function (key) {
        var current = self.currentData.helperHoursActivityGraph[key];
        return {
          date: key,
          value: current.hours,
          members: current.members,
        };
      });
      self.activityGraphHasMemberCount = !!self.heatmapData.filter(function (hd) {
        return hd.members
      }).length;
      self.rangeStart = moment(self.currentData.rangeStart).startOf('day').toISOString();
      self.rangeEnd = moment(self.currentData.rangeEnd).startOf('day').toISOString();

      self.rangeTimeframe = 'day';
      if (self.currentData.detailList.detailTimespanDays > 96) {
        self.rangeTimeframe = 'month';
      }
      if (self.currentData.detailList.detailTimespanDays > (365 * 2.1)) {
        self.rangeTimeframe = 'year';
      }

      self.timeChartOpts = {
        legend: {
          display: true,
          position: 'top'
        },
        scales: {
          yAxes: [{
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Date',
            },
            type: 'time',
            time: {
              parser: self.rangeTimeframe === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM',
              unit: self.rangeTimeframe,
            }
          }]
        }
      };

      self.activityDataset = [
        {
          label: $translate.instant('components.statisticHelperHours.volunteerHours'),
          borderWidth: 2,
          type: 'line',
        },
        {
          label: $translate.instant('components.statisticHelperHours.volunteerCount'),
          borderWidth: 3,
          type: 'line',
        }
      ];

      self.activityLabel = [];
      self.activityData = [[], []];
      (self.currentData.detailList.detailTimespanDays === 1 ? [+moment(self.currentData.rangeStart).startOf('day')] : _.clone(self.timeSpanDates).sort())
        .forEach(function (timestamp) {
          if (self.rangeTimeframe === 'day') {
            var current = moment(timestamp);
            var dataset = self.currentData.helperHoursActivityGraph[current.format('YYYY-MM-DD')] || {};
            self.activityData[0].push(dataset.hours || 0);
            self.activityData[1].push(dataset.members || 0);
            self.activityLabel.push(current.format('YYYY-MM-DD'));
          } else {
            var mCurrent = moment(timestamp);
            var mDataset = self.currentData.helperHoursActivityGraph[mCurrent.format('YYYY-MM-DD')] || {};
            var mMonth = mCurrent.format('YYYY-MM');
            if (~self.activityLabel.indexOf(mMonth)) {
              self.activityData[0][self.activityData[0].length - 1] += mDataset.hours || 0;
              self.activityData[1][self.activityData[1].length - 1] += mDataset.members || 0;
            } else {
              self.activityLabel.push(mMonth);
              self.activityData[0].push(mDataset.hours || 0);
              self.activityData[1].push(mDataset.members || 0);
            }
          }
        });

      if (!self.activityGraphHasMemberCount) {
        // remove member count from line chart
        self.activityData = self.activityData[0];
        self.activityDataset = self.activityDataset[0];
        self.activityDataset.pointRadius = 0;
      }

      var evtSvcDoughnutData = self.currentData.eventServiceDist || {};
      self.evtSvcDoughnutData = [
        evtSvcDoughnutData.event || 0,
        evtSvcDoughnutData.service || 0,
        evtSvcDoughnutData.other || 0,
      ];
      self.evtSvcDoughnutLabel = [
        $translate.instant('components.statisticHelperHours.event'),
        $translate.instant('components.statisticHelperHours.service'),
        $translate.instant('components.statisticHelperHours.directEntry'),
      ];

      [
        { cDataSource: 'activityDist', title: 'Title', scope: 'activity', numberable: 'count' },
        { cDataSource: 'baseCategoryDist', title: 'Name', scope: 'baseCategory', numberable: 'count' },
        { cDataSource: 'divisionDist', title: 'Name', scope: 'division', numberable: 'count' },
        { cDataSource: 'memberDist', title: 'fullName', scope: 'member', numberable: 'count' },

        { cDataSource: 'activityHDist', title: 'Title', scope: 'activityH', numberable: 'hours' },
        { cDataSource: 'baseCategoryHDist', title: 'Name', scope: 'baseCategoryH', numberable: 'hours' },
        { cDataSource: 'divisionHDist', title: 'Name', scope: 'divisionH', numberable: 'hours' },
        { cDataSource: 'memberHDist', title: 'fullName', scope: 'memberH', numberable: 'hours' },
      ].forEach(function (conf) {
        var statisticalData = _.orderBy(
          self.currentData[conf.cDataSource] || [],
          [function (e) {
            return e[conf.title] ? 0 : 1;
          }, conf.numberable, conf.title],
          ['asc', 'desc', 'asc']
        );
        self[conf.scope + 'DoughnutData'] = [];
        self[conf.scope + 'DoughnutLabel'] = [];
        statisticalData.forEach(function (d) {
          self[conf.scope + 'DoughnutData'].push(d[conf.numberable]);
          if (d[conf.title]) {
            self[conf.scope + 'DoughnutLabel'].push(d[conf.title]);
          } else {
            self[conf.scope + 'DoughnutLabel'].push(
              d.other ? $translate.instant('components.statisticHelperHours.other') : $translate.instant('components.statisticHelperHours.withoutAssignment')
            );
          }

        });
      });
    }, false);

    self.heatmapLabel = function (day) {
      var infoText = $translate.instant('components.statisticHelperHours.noVolunteerHoursRecorded');
      if (day && day.value && (day.members || !self.activityGraphHasMemberCount)) {
        infoText = $translate.instant(
          self.activityGraphHasMemberCount ? 'components.statisticHelperHours.heatMapInfo' : 'components.statisticHelperHours.heatMapInfoSingleMember',
          { hours: day.value, members: day.members, PLURAL: day.members > 1 }
        );
      }
      if (!day || !day.date) {
        return infoText;
      }
      return moment(day.date).format('LL') + ' - ' + infoText;
    }

    self.setDateSpan = function (timeframe, subtract) {
      var dayIterator = moment().startOf(timeframe).subtract(subtract || 0, timeframe);
      var endDate = moment().subtract(1, 'day').startOf('day');
      if (subtract) {
        endDate = moment().subtract(subtract || 0, timeframe).endOf(timeframe).startOf('day');
      }

      var timeRangeDates = [];
      while (dayIterator.isSameOrBefore(endDate)) {
        timeRangeDates.push(+dayIterator);
        dayIterator.add(1, 'day');
      }

      if (timeRangeDates.length === 1) {
        self.timeSpanType = false;
      } else {
        self.timeSpanDates.splice(0, self.timeSpanDates.length);
        Array.prototype.push.apply(self.timeSpanDates, timeRangeDates);
      }
      self.timeSpanFrom = moment(timeRangeDates[0]).toDate();
    }

    self.monthYearLabel = function (date) {
      return moment(date).format('MMMM YYYY');
    }

    self.rowSpanByKey = function (value) {
      return Object.keys(value).length + 1;
    };

    self.validTimeFrameJump = function (timeframe) {
      return !moment().startOf('day').isSame(moment().startOf(timeframe));
    };

    [
      { scope: 'evtSvc', title: $translate.instant('components.statisticHelperHours.sourceOfVh') },

      { scope: 'activity', title: $translate.instant('components.statisticHelperHours.vheByActivity') },
      { scope: 'baseCategory', title: $translate.instant('components.statisticHelperHours.vheByCategory') },
      { scope: 'division', title: $translate.instant('components.statisticHelperHours.vheByDivision') },
      { scope: 'member', title: $translate.instant('components.statisticHelperHours.vheByMember') },

      { scope: 'activityH', title: $translate.instant('components.statisticHelperHours.vhByActivity') },
      { scope: 'baseCategoryH', title: $translate.instant('components.statisticHelperHours.vhByCategory') },
      { scope: 'divisionH', title: $translate.instant('components.statisticHelperHours.vhByDivision') },
      { scope: 'memberH', title: $translate.instant('components.statisticHelperHours.vhByMember') },
    ].forEach(function (conf) {
      self[conf.scope + 'DoughnutOpts'] = {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontSize: 10,
            boxWidth: 25,
          }
        },
        title: {
          display: true,
          text: conf.title
        },
      };
    });
  }

  angular.module('BlurAdmin.theme.components')
    .controller('statisticHelperHoursCtrl', statisticHelperHoursCtrl);

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('statisticHelperHours', statisticHelperHours);

  /** @ngInject */
  function statisticHelperHours() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/statisticHelperHours/statisticHelperHours.html',
      scope: {
        provider : '=?',
        currentData : '=?',
        collapseFilter: '=?',
        divisionIds: '=?',
        tableShow: '=?',
        tableProvider: '=?',
        tableData: '=?',
      },
      controller: 'statisticHelperHoursCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  angular.module('smart-table')
    .directive('configInject', tableConfigInjector);

  /** @ngInject */
  function tableConfigInjector() {
    return {
      priority: -999,
      require: '^stTable',
      scope: {
        tableConfig: '&',
        ctrlSync: '=?',
      },
      link: function (scope, el, attr, ctrl) {
        scope.ctrlSync = ctrl;
        if (scope.tableConfig) {
          scope.$watch(scope.tableConfig, function () {
            var stParams = ctrl.tableState();
            var view = scope.tableConfig;
            if (typeof scope.tableConfig === 'function') {
              view = scope.tableConfig();
            }
            if (stParams && view && view.Sort && view.initialSort) {
              Object.keys(view.Sort).forEach(function (key) {
                ctrl.sortBy(key, !(view.Sort[key].direction === 'asc'));
              });
              view.initialSort = false;
            }
          });
        }
      }
    }
  }
})();

(function () {
  angular.module('BlurAdmin.theme.components')
    .controller('ShiftTemplateCtrl', ShiftTemplateCtrl);

  /** @ngInject */
  function ShiftTemplateCtrl($scope, $uibModal, baModalService, $location, $anchorScroll, stateChangePrompt,
    clientApi, $rootScope, toastr, commonUtils, $timeout, eventUtil, materialUtil, $templateRequest, $templateCache,
    $compile, $translate, screenSize) {
    var self = this;
    self.options = $scope.options;
    self.options.template = self.options.template || {};
    self.templateMode = self.options.templateMode || false;
    self.shifts = self.options.shifts;
    self.ctx = parseInt(self.options.ctx, 10) || false;
    self.ctxName = self.options.ctxName || '';
    self.hide = self.options.hideComponent || {};
    self.quotationBase = (self.options.template.QuotationBaseJson || {}).id ? self.options.template.QuotationBaseJson : null;
    self.sharedWithDivision = self.options.template.ServiceShares && self.options.template.ServiceShares.length > 0;
    self.sharedDivisions = $scope.sharedDivisions;

    if (self.quotationBase) {
      self.hasServiceFunctionInQuotationBase = !!_.filter(
        self.quotationBase.positions || [],
        { AdditionalMetaJson: { PriceItemType: 'SERVICE_POSITION' } }
      ).length;
    }

    self.spudc = 15; // shiftPositionUserDisplayCount
    self.toggleNextState = {};

    self.shiftMetaDataMap = [
      // { ident: 'Subject', label: 'Titel', type: 'text' },
      { ident: 'StartDate', label: $translate.instant('modules.events.shiftTemplate.shiftStart'), type: self.templateMode ? 'offsetDate' : 'datetime' },
      { ident: 'EndDate', label: $translate.instant('modules.events.shiftTemplate.shiftEnd'), type: self.templateMode ? 'offsetDate' : 'datetime' },
      {
        ident: 'StartDateNull',
        showFunc: function (shift) {
          return !shift.StartDate;
        },
        label: $translate.instant('modules.events.shiftTemplate.shiftStart'),
        value: $translate.instant('modules.events.shiftTemplate.startOfEvent'),
        type: 'static',
      },
      {
        ident: 'EndDateNull',
        showFunc: function (shift) {
          return !shift.EndDate;
        },
        label: $translate.instant('modules.events.shiftTemplate.shiftEnd'),
        value: $translate.instant('modules.events.shiftTemplate.endOfEvent'),
        type: 'static',
      },
      { ident: 'JobSite', label: $translate.instant('modules.events.shiftTemplate.placeOfUse'), type: 'text' },
      { ident: 'MeetingPlaceName', label: $translate.instant('modules.events.shiftTemplate.meetingPlace'), type: 'text' },
      { ident: 'MeetingTime', label: $translate.instant('modules.events.shiftTemplate.meetingTime'), type: 'time' },
      { ident: 'Remark', label: $translate.instant('modules.events.shiftTemplate.comment'), type: 'text' },
    ];

    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });

    if (!self.templateMode) {
      self.eventMaterialReverseShare = {};
      self.bookingMaterialUtilizationFetch = function () {
        var serviceDataPartial = _.pick(self.options.serviceDataSubmitTransformer(), ['ServiceShifts']);
        serviceDataPartial.ServiceShifts = (serviceDataPartial.ServiceShifts || [])
          .map(function (serviceShift) {
            return _.pick(serviceShift, Object.keys(serviceShift).filter(function (shiftKey) {
              return shiftKey.indexOf('ServiceShiftMaterial') === 0
            }).concat(['BookingMaterialTimes', 'id']))
          });

        (serviceDataPartial.ServiceShifts || [])
          .forEach(function (serviceShift) {
            return Object
              .keys(serviceShift)
              .filter(function (key) {
                return key.indexOf('ServiceShiftMaterial') === 0
              })
              .forEach(function (key) {
                var serviceShiftMaterials = (serviceShift[key] || []);
                var iter = serviceShiftMaterials.length;
                while (iter--) {
                  var serviceShiftMaterial = serviceShiftMaterials[iter];
                  if (!serviceShiftMaterial.BookingMaterialTimeId) {
                    serviceShiftMaterials.splice(serviceShiftMaterials.indexOf(serviceShiftMaterial), 1);
                  }
                }
              })
          });

        return clientApi
          .custom('model/Service', 'prefetchBookingMaterialUtilization', {
            serviceId: self.options.template.id,
            serviceDataPartial: serviceDataPartial,
          }, { backgroundRequest: true });
      }

      self.quotationPositionImporter = function (evtMatCtrl, shift, position, materialKey, isMaterialTypeImport) {
        return Promise.resolve()
          .then(function () {
            if (materialKey) {
              if (isMaterialTypeImport) {
                return evtMatCtrl
                  .addMaterial(shift, materialKey, { MaterialTypeId: position.AdditionalMetaJson.PriceItemId })
                  .catch(function (e) {
                    if (!e) {
                      return;
                    }
                    throw e;
                  });
              }
              return clientApi
                .custom('model/Service', 'getServiceMaterial', {
                  materialRef: materialKey,
                  materialIds: [position.AdditionalMetaJson.PriceItemId],
                  divisionId: [evtMatCtrl.ctx],
                })
                .then(function (result) {
                  if (!result || result.length !== 1) {
                    throw new Error('Invalid material');
                  }
                  var material = result[0];
                  material.MaxCount = material.Amount || 1;
                  material.Count = 1;
                  evtMatCtrl.handleMaterialAssocChange(shift, materialKey, {
                    addedMaterials: [material],
                    removedMaterialIds: [],
                  });
                });
            }
            return clientApi
              .custom('model/ServicePositionTemplate', 'searchTemplate', { servicePositionTemplateId: position.AdditionalMetaJson.PriceItemId })
              .then(function (templates) {
                if (!templates || templates.length !== 1) {
                  throw new Error('Invalid position template result.');
                }
                var template = templates[0].ServiceFunction;
                template.ReferenceServiceFunctionId = template.id;
                self.handleServiceFunctionTemplateResultAdd({
                  ServiceShifts: [{
                    ServiceFunctions: [template]
                  }]
                }, shift);
              });
          })
          .catch(function () {
            toastr.error(
              'Die Angebotsposition kann nicht (mehr) abgerufen werden.',
              'Angebotsposition nicht verfügbar'
            );
          });
      }

      $scope.$watch(function () {
        return self.eventMaterialReverseShare;
      }, function () {
        self.options.bookingMaterialExpectedShortAmounts = self.eventMaterialReverseShare.bookingMaterialExpectedShortAmounts;
        self.updateBookingMaterialUtilizationBase = self.eventMaterialReverseShare.updateBookingMaterialUtilizationBase;
        self.editBookingPeriods = self.eventMaterialReverseShare.editBookingPeriods;
        self.importFromQuotation = self.eventMaterialReverseShare.importFromQuotation;
      }, true);

      self.attendanceStore = {};

      self.shiftMetaDataMap.push({
        ident: 'dynShiftShare',
        showFunc: function (shift) {
          return self.dynShiftShare && self.dynShiftShare[shift.id] && self.dynShiftShare[shift.id].length;
        },
        label: $translate.instant('modules.events.shiftTemplate.sharedDivisions'),
        type: 'share',
      });

      self.updateDynShiftShare = function () {
        self.dynShiftShare = self.dynShiftShare || {};
        var globalShares = (self.options.template.ServiceShares || [])
          .filter(function (serviceShare) {
            return serviceShare.IsShared && serviceShare.IsGlobal && serviceShare.state !== 'REMOVED';
          });
        self.shifts.forEach(function (shift) {
          self.dynShiftShare[shift.id] = globalShares.concat(
            (shift.ServiceShareShifts || [])
              .map(function (sharedShift) {
                var found = _.find((self.options.template.ServiceShares || []), { id: sharedShift.ServiceShareId });
                if (found && !found.IsGlobal && found.state !== 'REMOVED') {
                  return found;
                }
                return null;
              })
              .filter(function (isSet) {
                return isSet;
              })
          );
        });
      };
      self.updateDynShiftShare();

      self.attendanceRemovalWarning = {};
      self.options.attendanceRemovalWarning = self.attendanceRemovalWarning; // child component to parent reverse share
      self.attendanceRemovalCalc = function (shift) {
        (shift.ServiceShiftMembers || [])
          .forEach(function (attendee) {
            self.attendanceRemovalWarning[attendee.MemberId] = self.attendanceRemovalWarning[attendee.MemberId] || {};
            self.attendanceRemovalWarning[attendee.MemberId][shift.id] = !~(self.dynShiftShare[shift.id] || [])
              .map(function (dynShift) {
                return dynShift.DivisionId;
              })
              .concat([self.ctx])
              .indexOf(parseInt(attendee.DivisionId || (attendee.Division && attendee.Division.id), 10));
          });
      };

      self.scheduleConflictWarning = {};
      self.options.scheduleConflictWarning = self.scheduleConflictWarning; // child component to parent reverse share
      self.scheduleConflictWarningTitle = {};
      self.scheduleConflictCalc = function (conflictData) {
        Object.keys(self.scheduleConflictWarning).forEach(function (warningKey) {
          delete self.scheduleConflictWarning[warningKey];
        });
        Object
          .keys(conflictData)
          .map(function (memberId) {
            return parseInt(memberId, 10);
          })
          .forEach(function (memberId) {
            var memberConflicts = conflictData[memberId.toString()];
            Object
              .keys(memberConflicts)
              .map(function (shiftId) {
                return commonUtils.isUUID.test(shiftId) ? shiftId : parseInt(shiftId, 10);
              })
              .forEach(function (shiftId) {
                var memberShiftConflicts = memberConflicts[shiftId.toString()];
                self.scheduleConflictWarning[memberId] = self.scheduleConflictWarning[memberId] || {};
                self.scheduleConflictWarningTitle[memberId] = self.scheduleConflictWarningTitle[memberId] || {};
                self.scheduleConflictWarning[memberId][shiftId] = memberShiftConflicts;
                self.scheduleConflictWarningTitle[memberId][shiftId] = self.calcScheduleConflictWarningTitle(memberShiftConflicts);
              });
          });
      };
      var scheduleConflictUpdateProgress = null;
      var queueScheduleConflictUpdate = false;
      var lastConflictMap = '';
      self.updateScheduleConflict = function () {
        if (!self.options.hasManagePermsInSourceDivOrForItem) {
          return;
        }
        if (scheduleConflictUpdateProgress) {
          queueScheduleConflictUpdate = true;
          return;
        }
        var conflictCandidateMap = {};
        self.shifts.forEach(function (shift) {
          (shift.ServiceShiftMembers || [])
            .filter(function (attendee) {
              return !!attendee.ServiceFunctionId;
            })
            .forEach(function (attendee) {
              conflictCandidateMap[attendee.MemberId] = conflictCandidateMap[attendee.MemberId] || [];
              conflictCandidateMap[attendee.MemberId].push({
                shiftId: shift.id,
                start: moment(shift.StartDate).toISOString(),
                end: moment(shift.EndDate).toISOString(),
              });
            });
        });

        var currentConflictMap = JSON.stringify(conflictCandidateMap);
        if (lastConflictMap !== currentConflictMap) {
          lastConflictMap = currentConflictMap;
        } else {
          return; // early exit
        }

        scheduleConflictUpdateProgress = clientApi
          .custom(
            'model/ServiceShiftMember',
            'scheduleConflictDetection',
            { serviceId: self.options.template.id, divisionId: self.options.ctx, candidates: conflictCandidateMap }
          )
          .then(function (result) {
            $scope.$evalAsync(function () {
              self.scheduleConflictCalc(result);
            });
          })
          .catch(function () {
            console.warn('Could not update schedule conflict data.');
          })
          .then(function () {
            scheduleConflictUpdateProgress = null;
            if (queueScheduleConflictUpdate) {
              queueScheduleConflictUpdate = false;
              self.updateScheduleConflict();
            }
          })
      };

      var scheduleConflictTypeMap = {
        ownCollision: $translate.instant('modules.events.shiftTemplate.ownCollision'),
        serviceCollision: $translate.instant('modules.events.shiftTemplate.serviceCollision'),
        eventCollision: $translate.instant('modules.events.shiftTemplate.eventCollision'),
      };
      self.calcScheduleConflictWarningTitle = function (warning) {
        var conflicts = _.compact(
          Object
            .keys(scheduleConflictTypeMap)
            .map(function (conflictType) {
              if (warning[conflictType]) {
                return scheduleConflictTypeMap[conflictType];
              }
              return null;
            })
        )
        var conflictText = '';
        if (!conflicts.length) {
          conflictText = $translate.instant('modules.events.shiftTemplate.otherObligation');
        } else {
          var tmp = conflicts.splice(0, conflicts.length - 2).join(', ');
          conflictText = tmp + (tmp.length ? ', ' : '') + conflicts.join($translate.instant('modules.events.shiftTemplate.andSpaces'));
        }

        return $translate.instant('modules.events.shiftTemplate.timeConflictText', {
          conflict: warning.collisions > 1 ?
            $translate.instant('modules.events.shiftTemplate.timeConflicts', { warning: warning.collisions }) :
            $translate.instant('modules.events.shiftTemplate.timeConflict'),
          obligation: conflictText,
        });
      }

      self.qualificationRemovalWarning = {};
      self.activityRemovalWarning = {};
      self.requirementRemovalCalc = function (shift) {
        (shift.ServiceFunctions || []).forEach(function (position) {
          [
            { map: 'qualificationRemovalWarning', requirementList: 'Qualifications' },
            { map: 'activityRemovalWarning', requirementList: 'Activities' },
          ].forEach(function (requirement) {
            self[requirement.map][shift.id] = self[requirement.map][shift.id] || {};
            self[requirement.map][shift.id][position.id] = (position[requirement.requirementList] || [])
              .filter(function (req) {
                return req.DivisionId && !~(self.dynShiftShare[shift.id] || [])
                  .map(function (dynShift) {
                    return dynShift.DivisionId;
                  })
                  .concat([self.ctx])
                  .indexOf(req.DivisionId);
              })
              .map(function (req) {
                return req.id;
              });
          });
        });
      };

      self.removalWarningInMemberPositionListMap = {};
      self.removalWarningInMemberPositionListCalc = function (shift) {
        (shift.ServiceFunctions || []).forEach(function (position) {
          self.removalWarningInMemberPositionListMap[shift.id] = self.removalWarningInMemberPositionListMap[shift.id] || {};
          self.removalWarningInMemberPositionListMap[shift.id][position.id] = ((self.memberPositionList[shift.id] || {})[position.id] || [])
            .map(function (attendee) {
              return self.attendanceRemovalWarning[attendee.MemberId][shift.id];
            })
            .filter(function (hasRemovalWarning) {
              return hasRemovalWarning;
            })
            .length
        });
      };

      self.positionNameMap = {};
      self.positionNameMapCalc = function (shift) {
        self.positionNameMap[shift.id] = self.positionNameMap[shift.id] || {};
        (shift.ServiceFunctions || []).forEach(function (position) {
          self.positionNameMap[shift.id][position.id] = position.Function || '';
        });
      };

      self.ownAttendanceState = {};
      self.memberPositionList = {};
      self.removalWarningInMemberPositionListMap = {};
      self.memberPositionCalc = function (shift) {
        self.memberPositionList[shift.id] = self.memberPositionList[shift.id] || {};
        var svcFunctionList = {};
        (shift.ServiceShiftMembers || []).forEach(function (serviceShiftMember) {
          if (serviceShiftMember.ServiceFunctionId) {
            if (!_.find(shift.ServiceFunctions, { id: serviceShiftMember.ServiceFunctionId })) {
              // position no longer existing
              serviceShiftMember.ServiceFunctionId = null;
              return;
            }
            var svcFunctionId = serviceShiftMember.ServiceFunctionId;
            svcFunctionList[svcFunctionId] = svcFunctionList[svcFunctionId] || [];
            svcFunctionList[svcFunctionId].push(serviceShiftMember);
          }
        });

        Object.keys(self.memberPositionList[shift.id]).forEach(function (svcFunctionId) {
          self.memberPositionList[shift.id][svcFunctionId].splice(0, self.memberPositionList[shift.id][svcFunctionId].length);
        });

        Object.keys(svcFunctionList).forEach(function (svcFunctionId) {
          self.memberPositionList[shift.id][svcFunctionId] = self.memberPositionList[shift.id][svcFunctionId] || [];
          self.memberPositionList[shift.id][svcFunctionId].splice(0, self.memberPositionList[shift.id][svcFunctionId].length);
          Array.prototype.push.apply(self.memberPositionList[shift.id][svcFunctionId], svcFunctionList[svcFunctionId]);
        });
      };

      self.positionCountMap = {};
      self.positionCountMapCalc = function (shift) {
        (shift.ServiceFunctions || []).forEach(function (position) {
          self.positionCountMap[shift.id] = self.positionCountMap[shift.id] || {};
          self.positionCountMap[shift.id][position.id] = new Array(
            Math.min(
              Math.max(
                position.PositionCount,
                (self.memberPositionList && self.memberPositionList[shift.id] && self.memberPositionList[shift.id][position.id] && self.memberPositionList[shift.id][position.id].length) || 0
              ),
              self.spudc
            )
          )
        });
      };

      self.isUnderaged = {};
      self.memberUnderagedCalc = function (members) {
        members.forEach(function (member) {
          var memberId = member.MemberId;
          var birthDate = member.BirthDate || (member.Member || {}).BirthDate;
          if (!birthDate) {
            return;
          }
          var age = moment.duration(moment().diff(moment(birthDate))).as('years');
          if (age < 18) {
            self.isUnderaged[memberId] = age.toFixed(1).toString().replace('.', ',');
          }
        });
      };

      $scope.$watch(function () {
        return self.options.template.ServiceShares;
      }, function () {
        self.updateDynShiftShare();

        self.shifts.forEach(function (shift) {
          self.attendanceRemovalCalc(shift);
          self.removalWarningInMemberPositionListCalc(shift);
          self.requirementRemovalCalc(shift);
        });
      }, true);

      $scope.$watch(function () {
        return self.shifts;
      }, function () {
        self.updateDynShiftShare();
        self.updateScheduleConflict();
        self.shifts.forEach(function (shift) {
          self.attendanceStore[shift.id] = self.attendanceStore[shift.id] || {};
          self.attendanceStore[shift.id].choices = self.attendanceStore[shift.id].choices || [{ none: true }];

          self.attendanceRemovalCalc(shift);

          self.ownAttendanceState[shift.id] = _.find((shift.ServiceShiftMembers || []), { MemberId: $rootScope.ctx.currentUser.id });

          self.memberPositionCalc(shift);
          self.positionNameMapCalc(shift);

          self.removalWarningInMemberPositionListCalc(shift); // after attendanceRemovalCalc && memberPositionCalc

          self.positionCountMapCalc(shift);

          self.requirementRemovalCalc(shift);
          self.memberUnderagedCalc(shift.ServiceShiftMembers || []);
        });
      }, true);

      // prevent choosing <none> option
      $scope.$watch(function () {
        return self.attendanceStore;
      }, function () {
        self.shifts.forEach(function (shift) {
          if (self.attendanceStore[shift.id] && self.attendanceStore[shift.id].target && self.attendanceStore[shift.id].target.none) {
            self.attendanceStore[shift.id].target = null;
          }
        });
      }, true);
    }

    self.canHandleAttendance = function (shift, attendee) {
      if (!attendee || !attendee.Division || !attendee.Division.id
        || attendee.MemberId === $rootScope.ctx.currentUser.id
        || ((self.attendanceRemovalWarning || {})[attendee.MemberId] || {})[shift.id]) {
        return false;
      }
      return ~(
        _.compact(
          _.union(
            self.options.managePermissionsList || [],
            self.options.hasManagePermsInSourceDivOrForItem ? [self.ctx] : []
          )
        )
      ).indexOf(attendee.Division.id);
    };

    self.canEditAttendance = function (shift, returnDivisions) {
      var permittedDivisions = _.intersection(
        _.union((self.options.managePermissionsList || []), self.options.hasManagePermsInSourceDivOrForItem ? [self.ctx] : []),
        self.dynShiftShare[shift.id]
          .map(function (shiftShare) {
            return shiftShare.DivisionId;
          })
          .concat([self.ctx])
      );
      return returnDivisions ? permittedDivisions : permittedDivisions.length;
    };

    self.canSelfAttend = function (shift, ignoreHide) {
      return _.intersection(
        (self.options.viewPermissionsList || []),
        self.dynShiftShare[shift.id]
          .map(function (shiftShare) {
            return shiftShare.DivisionId;
          })
          .concat([self.ctx])
      ).length && (ignoreHide || !self.hide.selfAttend);
    };

    self.removePositionAssoc = function (shift, attendance) {
      if (attendance && attendance.ServiceFunctionId) {
        var found = _.find(shift.ServiceFunctions, { id: attendance.ServiceFunctionId });
        baModalService
          .messageModal({
            modalType: 'danger',
            allowHtml: false,
            title: $translate.instant('modules.events.shiftTemplate.modal.deletePositionAssignmentTitle'),
            content: $translate.instant('modules.events.shiftTemplate.modal.deletePositionAssignmentMsg', {
              function: found && found.Function ? ' "' + found.Function + '"' : '',
              name: attendance.fullName || attendance.Member.fullName,
            }),
            primaryActionText: $translate.instant('modules.events.shiftTemplate.remove'),
            secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
          })
          .then(function () {
            attendance.ServiceFunctionId = null;
            attendance.state = attendance.state || 'UPDATED';
          })
          .catch(function () {

          });
      }
    };

    self.ensureDefaultShiftBookingMaterialTime = function (shift) {
      if (!self.templateMode) {
        shift.BookingMaterialTimes = shift.BookingMaterialTimes || [];
        var shiftDefaultBookingTime = _.find(shift.BookingMaterialTimes, { IsDefaultPeriod: true }) || {};
        if (!shiftDefaultBookingTime.id) {
          shift.BookingMaterialTimes.push(shiftDefaultBookingTime);
        }
        shiftDefaultBookingTime.id = shiftDefaultBookingTime.id || commonUtils.uuid();
        shiftDefaultBookingTime.Title = shift.Subject;
        shiftDefaultBookingTime.IsDefaultPeriod = true;
        if (!shiftDefaultBookingTime.StartDate || !shiftDefaultBookingTime.EndDate || !(
          moment(shift.StartDate).isSame(moment(shiftDefaultBookingTime.StartDate), 'minute')
          && moment(shift.EndDate).isSame(moment(shiftDefaultBookingTime.EndDate), 'minute')
        )) {
          shiftDefaultBookingTime.StartDate = shift.StartDate;
          shiftDefaultBookingTime.EndDate = shift.EndDate;
          self.updateBookingMaterialUtilizationBase && self.updateBookingMaterialUtilizationBase();

          if (shift.BookingMaterialTimes.length > 1) {
            toastr.info(
              $translate.instant('modules.events.shiftTemplate.toastr.checkBookingTimesMsg'),
              $translate.instant('modules.events.shiftTemplate.toastr.checkBookingTimesTitle')
            );
          }
        }
      }
    }

    self.openMetaDetails = function (shift) {
      $uibModal.open({
        controller: 'shiftMetaDetailsCtrl as $smd',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/shiftTemplate/modals/shiftMetaDetails.html',
        size: 'md',
        resolve: {
          shift: function () {
            return (shift && _.cloneDeep(shift)) || null;
          },
          parentCtrl: function () {
            return self;
          }
        }
      }).result
        .then(function (resultingShift) {
          if (!shift) {
            self.shifts.push(resultingShift);
            return resultingShift;
          }

          return Promise
            .resolve()
            .then(function () {
              if (
                // when in live mode, check if start/end date change affected attendees, if so - ask if attendee states should be resetted
                !self.templateMode
                && self.options.template.id // don't ever ask while creating a new live mode service
                && !shift.resetAttendees
                && (
                  (shift.ServiceShiftMembers || [])
                    .filter(function (attendee) {
                      return attendee.Acceptance !== false; // accepted & interested
                    })
                    .length
                )
                && !(
                  moment(shift.StartDate).isSame(moment(resultingShift.StartDate), 'minute')
                  && moment(shift.EndDate).isSame(moment(resultingShift.EndDate), 'minute')
                )
              ) {
                var attendanceChanged = (shift.ServiceShiftMembers || []).filter(function (attendee) {
                  return attendee.state; // added or changed
                }).length;
                var cannotResetAttendanceStatusText;
                if (attendanceChanged) {
                  cannotResetAttendanceStatusText = $translate.instant('modules.events.shiftTemplate.unsavedStatus')
                }
                if (self.hide.attendeeEdit || self.hide.positionEdit) {
                  cannotResetAttendanceStatusText = $translate.instant('modules.events.shiftTemplate.unsuitableShift');
                }
                return baModalService
                  .messageModal({
                    modalType: 'warning',
                    allowHtml: false,
                    title: $translate.instant('modules.events.shiftTemplate.modal.shiftShiftTitle'),
                    content: $translate.instant('modules.events.shiftTemplate.modal.shiftShiftMsg', {
                      text: cannotResetAttendanceStatusText || $translate.instant('modules.events.shiftTemplate.modal.resetParticipation')
                    }),
                    primaryActionText: $translate.instant('modules.events.shiftTemplate.continue'),
                    secondaryActionText: $translate.instant('modules.events.shiftTemplate.modal.discardTimeChanges'),
                  })
                  .then(function () {
                    if (cannotResetAttendanceStatusText) {
                      return;
                    }
                    return baModalService.messageModal({
                      modalType: 'info',
                      allowHtml: false,
                      title: $translate.instant('modules.events.shiftTemplate.modal.administrateParticipationTitle'),
                      content: $translate.instant('modules.events.shiftTemplate.modal.administrateParticipationMsg'),
                      primaryActionText: $translate.instant('modules.events.shiftTemplate.modal.resetStatus'),
                      secondaryActionText: $translate.instant('modules.events.shiftTemplate.modal.maintainedStatus'),
                      allowDoubleOpening: true,
                    })
                      .then(function () {
                        $scope.$evalAsync(function () {
                          shift.resetAttendees = true;
                        });
                      })
                      .catch(function () {
                        // hm k
                      })
                  })
                  .catch(function () {
                    resultingShift.StartDate = shift.StartDate;
                    resultingShift.EndDate = shift.EndDate;
                  })
              }
            })
            .then(function () {
              _.assign(shift, resultingShift);
              return shift;
            })
        })
        .then(function (resultingShift) {
          self.ensureDefaultShiftBookingMaterialTime(resultingShift);
        });
    };

    self.cancelResetAttendees = function (shift) {
      return baModalService.messageModal({
        modalType: 'warning',
        allowHtml: false,
        title: $translate.instant('modules.events.shiftTemplate.modal.dontResetParticipationTitle'),
        content: $translate.instant('modules.events.shiftTemplate.modal.dontResetParticipationMsg'),
        primaryActionText: $translate.instant('modules.events.shiftTemplate.modal.dontReset'),
        secondaryActionText: $translate.instant('modules.events.shiftTemplate.modal.unchangedReset'),
      }).then(function () {
        $scope.$evalAsync(function () {
          delete shift.resetAttendees;
        })
      }).catch(function () {
        // hm k
      })
    };

    self.attendeeRequirementFulfillment = function (availableShiftMembers) {
      if (self.templateMode || !self.options.hasManagePermsInSourceDivOrForItem) {
        return Promise.resolve([]);
      }
      var candidates = availableShiftMembers
        .map(function (shiftMember) {
          return {
            MemberId: shiftMember.MemberId,
            DivisionId: shiftMember.DivisionId || shiftMember.Division.id,
          }
        });
      if (!candidates.length) {
        return Promise.resolve([]);
      }
      return clientApi
        .custom('model/ServiceShiftMember', 'attendeeRequirementFulfillment', {
          serviceId: self.options.template.id,
          candidates: candidates,
        })
        .catch(function () {
          return [];
        });
    };

    self.requirementValidityCalc = function (position, attendeeRequirementFulfillment) {
      var attendeeRequirementFulfillmentMap = {};
      [
        {
          type: 'qualification',
          field: 'memberQualifications',
          requirements: position.Qualifications.map(function (qualification) {
            return qualification.id;
          }),
        },
        {
          type: 'activity',
          field: 'memberActivities',
          requirements: position.Activities.map(function (activity) {
            return activity.id;
          }),
        }
      ].forEach(function (entity) {
        attendeeRequirementFulfillmentMap[entity.type] = JSON.parse(JSON.stringify(attendeeRequirementFulfillment || []))
          .map(function (candidate) {
            var validState = null;
            var validList = {
              active: [],
              inactive: [],
            };
            var relevantRequirements = (candidate[entity.field] || [])
              // fetch all relevant entity.requirements
              .filter(function (memberRequirement) {
                return ~entity.requirements.indexOf(memberRequirement.id);
              })
              .map(function (memberRequirement) {
                if (entity.type === 'activity') {
                  memberRequirement.valid = (memberRequirement.valid
                    && (memberRequirement.Characteristic ===
                      (_.find(position.Activities, { id: memberRequirement.id }) || {}).Characteristic || false));
                }
                return memberRequirement;
              })
            if (
              relevantRequirements.length === entity.requirements.length
            ) {
              validState = relevantRequirements
                .filter(function (memberRequirement) {
                  return memberRequirement.valid;
                })
                .length === entity.requirements.length;
            }

            relevantRequirements.forEach(function (relevantRequirement) {
              validList[relevantRequirement.valid ? 'active' : 'inactive'].push(relevantRequirement.id);
            });
            validList.missing = _.difference(
              entity.requirements,
              relevantRequirements.map(function (relevantRequirement) {
                return relevantRequirement.id;
              })
            );
            return {
              MemberId: candidate.MemberId,
              validState: validState,
              validList: validList,
            };
          });
      })

      var map = {};
      Object.keys(attendeeRequirementFulfillmentMap).forEach(function (type) {
        map[type] = {};
        attendeeRequirementFulfillmentMap[type].forEach(function (result) {
          map[type][result.MemberId] = result;
        });
      })
      return map;
    };

    self.updateShiftPositionMemberValidStateMap = function (specificShift, specificPosition) {
      if (self.templateMode) {
        return Promise.resolve();
      }
      var shifts = specificShift ? [specificShift] : self.shifts;
      return Promise
        .all(
          shifts
            .map(function (shift) {
              return self
                .attendeeRequirementFulfillment(
                  (shift.ServiceShiftMembers || [])
                    .filter(function (shiftMember) {
                      return shiftMember.Acceptance;
                    })
                )
                .then(function (attendeeRequirementFulfillment) {
                  $scope.$evalAsync(function () {
                    self.shiftPositionMemberValidStateMap = self.shiftPositionMemberValidStateMap || {};
                    self.shiftPositionMemberValidStateMap[shift.id] = self.shiftPositionMemberValidStateMap[shift.id] || {};
                    self.requirementValidityMap = self.requirementValidityMap || {};
                    self.requirementValidityMap[shift.id] = self.requirementValidityMap[shift.id] || {};
                    self.qualificationHelperMap = self.qualificationHelperMap || {};
                    self.activityHelperMap = self.activityHelperMap || {};

                    var groupedMembers = _.groupBy(
                      (shift.ServiceShiftMembers || [])
                        .filter(function (attendee) {
                          return attendee.ServiceFunctionId && (!specificPosition || attendee.ServiceFunctionId === specificPosition.id);
                        }),
                      'ServiceFunctionId'
                    );

                    Object
                      .keys(groupedMembers)
                      .forEach(function (sServiceFunctionId) {
                        var attendees = groupedMembers[sServiceFunctionId];
                        var attendeeIds = attendees.map(function (attendee) {
                          return { MemberId: attendee.MemberId || attendee.Member.id }
                        });
                        var position = _.find((shift.ServiceFunctions || []), { id: attendees[0].ServiceFunctionId });
                        (position.Qualifications || []).forEach(function (qualification) {
                          self.qualificationHelperMap[qualification.id] = qualification;
                        });
                        (position.Activities || []).forEach(function (activity) {
                          self.activityHelperMap[activity.id] = activity;
                        });
                        var requirementValidityMap = self.requirementValidityCalc(
                          position,
                          _.intersectionBy(
                            attendeeRequirementFulfillment,
                            attendeeIds,
                            'MemberId'
                          )
                        );
                        self.requirementValidityMap[shift.id][position.id] = requirementValidityMap;
                        self.shiftPositionMemberValidStateMap[shift.id][position.id] = self.combinedValidStateCalc(
                          attendeeIds,
                          requirementValidityMap.qualification,
                          requirementValidityMap.activity
                        );
                      });
                  });
                });
            })
        )
    };
    self.updateShiftPositionMemberValidStateMap();

    var positionReqValidPopoverTpl = 'app/theme/components/shiftTemplate/helper/positionValidPopoverContent.html';
    var compiledPositionReqValidTpl = $templateCache.get(positionReqValidPopoverTpl);
    var popoverScope;
    var compiled;
    if (!compiledPositionReqValidTpl) {
      // fire and forget fetch, as it should near immediately resolve; impact while not resolved: no popover display
      // mostly needed for dev, as build files will have all templates already in tplCache
      $templateRequest(positionReqValidPopoverTpl)
        .then(function () {
          compiledPositionReqValidTpl = $templateCache.get(positionReqValidPopoverTpl);
        });
    }

    self.getPositionReqValidPopover = function (member, qualificationValidList, activityValidList, qualificationIdNameMap, activityIdNameMap, parentScope) {
      if (!compiledPositionReqValidTpl ||
        !self.options.hasManagePermsInSourceDivOrForItem ||
        (
          (
            !qualificationValidList ||
            (
              !qualificationValidList.missing.length &&
              !qualificationValidList.active.length &&
              !qualificationValidList.inactive.length
            )
          ) &&
          (
            !activityValidList ||
            (
              !activityValidList.missing.length &&
              !activityValidList.active.length &&
              !activityValidList.inactive.length
            )
          )
        )
      ) {
        return null;
      }
      if (compiled) {
        return compiled.html();
      }
      if (popoverScope) {
        popoverScope.$destroy();
      }
      (parentScope || $scope).$evalAsync(function () {
        popoverScope = (parentScope || $scope).$new(true);
        popoverScope.shiftPositionAttendeeStatusMap = [
          { label: 'Aktiv', className: 'label-success', prop: 'active' },
          { label: 'Inaktiv', className: 'label-warning', prop: 'inactive' },
          { label: 'Fehlend', className: 'label-danger', prop: 'missing' },
        ];
        popoverScope.member = member ? (member.FirstName + ' ' + member.LastName) : null;
        popoverScope.qualificationValidList = qualificationValidList;
        popoverScope.activityValidList = activityValidList;
        popoverScope.qualificationIdNameMap = qualificationIdNameMap;
        popoverScope.activityIdNameMap = activityIdNameMap;
        compiled = $compile(compiledPositionReqValidTpl)(popoverScope);
        $timeout(function () {
          compiled = null;
        }, 0, false);
      });
      return '<div></div>';
    };

    self.combinedValidStateCalc = function (memberPositionList, qualificationMap, activityMap) {
      var combinedValidStateMap = {};
      memberPositionList.forEach(function (member) {
        var validStates = [
          ((qualificationMap || {})[member.MemberId] || {}).validState,
          ((activityMap || {})[member.MemberId] || {}).validState
        ];
        var validityPriorityMap = [undefined, true, false, null]; // sorted least (0) to highest (3) priority
        var validityPriority = Math.max(validityPriorityMap.indexOf(validStates[0]), validityPriorityMap.indexOf(validStates[1])) || 0;
        combinedValidStateMap[member.MemberId] = validityPriorityMap[validityPriority];
      });
      return combinedValidStateMap;
    };

    self.openPositionDetails = function (shift, position) {
      var memberPositionList = (position && position.id && shift && shift.id
        && self.memberPositionList && self.memberPositionList[shift.id] && self.memberPositionList[shift.id][position.id]
        && _.cloneDeep(self.memberPositionList[shift.id][position.id])) || [];
      var availableShiftMembers = (shift.ServiceShiftMembers || [])
        .filter(function (shiftMember) {
          return shiftMember.Acceptance && !shiftMember.ServiceFunctionId;
        })
        .concat(memberPositionList);
      $uibModal
        .open({
          controller: 'shiftPositionDetailsCtrl as $spd',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/shiftTemplate/modals/shiftPositionDetails.html',
          size: 'md',
          resolve: {
            shift: function () {
              return shift;
            },
            position: function () {
              return (position && _.cloneDeep(position)) || null;
            },
            availableShiftMembers: function () {
              return availableShiftMembers;
            },
            memberPositionList: function () {
              return memberPositionList;
            },
            parentCtrl: function () {
              return self;
            },
            attendeeRequirementFulfillment: function () {
              return self.attendeeRequirementFulfillment(availableShiftMembers);
            },
            requirementValidityCalc: function () {
              return self.requirementValidityCalc;
            },
            combinedValidStateCalc: function () {
              return self.combinedValidStateCalc;
            },
            getPositionReqValidPopover: function () {
              return self.getPositionReqValidPopover;
            },
            checkAttendeesIsLegalAge: function () {
              if (availableShiftMembers.length) {
                return clientApi
                  .custom('model/ServiceShiftMember', 'checkAttendeesIsLegalAge', {
                    memberIds: availableShiftMembers.map(function (member) {
                      return member.MemberId || member.Member.id;
                    }, { backgroundRequest: true }),
                  })
                  .catch(function () {
                    return {};
                  });
              }
              return {};
            },
            shiftDivisions: function () {
              if (self.templateMode) {
                return [self.ctx];
              }
              return self.dynShiftShare[shift.id]
                .map(function (shiftShare) {
                  return shiftShare.DivisionId;
                })
                .concat([self.ctx]);
            },
          }
        })
        .result
        .then(function (results) {
          if (!position) {
            shift.ServiceFunctions.push(results.position);
          } else {
            if (position.ReferenceServiceFunctionId) {
              // we need to check if certain properties of our position changed, as our ReferenceServiceFunction link will expire in those cases
              var hasChanges = !!(
                ['Function'].filter(function (prop) {
                  return position[prop] !== results.position[prop];
                }).length + ['Qualifications', 'Activities'].filter(function (prop) {
                  return position[prop].length !== results.position[prop].length
                    || _.difference(_.map(position[prop], 'id'), _.map(results.position[prop], 'id')).length;
                }).length
              );
              if (hasChanges) {
                results.position.ReferenceServiceFunctionId = null;
              }
            }
            _.assign(position, results.position);
          }
          var currentPosition = position || results.position;
          var existing = [];
          (results.memberPositionList || []).forEach(function (memberPosition) {
            var found = _.find(shift.ServiceShiftMembers, { MemberId: memberPosition.MemberId });
            if (found) {
              existing.push(found);
              if (found.ServiceFunctionId !== currentPosition.id) {
                found.ServiceFunctionId = currentPosition.id;
                found.state = found.state || 'UPDATED';
              }
            }
          });
          (shift.ServiceShiftMembers || [])
            .filter(function (origMemberPosition) {
              return origMemberPosition.ServiceFunctionId === currentPosition.id;
            })
            .forEach(function (origMemberPosition) {
              // handle removed service function ids
              if (!_.find(existing, { MemberId: origMemberPosition.MemberId })) {
                origMemberPosition.ServiceFunctionId = null;
                origMemberPosition.state = origMemberPosition.state || 'UPDATED';
              }
            });
          self.updateShiftPositionMemberValidStateMap(shift, position);
        });
    };

    self.addRemark = function (attendee, canEditRemark, shift) {

      var preexistingAttendee = _.find(shift.ServiceShiftMembers || [], { MemberId: attendee ? (attendee.id || attendee.MemberId) : $rootScope.ctx.currentUser.id });

      $uibModal.open(
        {
          controller: 'AttendeeRemarkModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/events/event/modals/attendeeRemarkModal.html',
          size: 'md',
          resolve: {
            attendee: function () {
              return preexistingAttendee;
            },
            eventDetailCtrl: function () {
              return shift;
            },
            canEditRemark: function () {
              return canEditRemark;
            },
            isShift: function () {
              return true;
            },
            serviceId: function () {
              return self.options.template.id;
            },
            userId: function () {
              return $rootScope.ctx.currentUser.id;
            },
          }
        }).result
        .then(function (result) {
          if (result) {
            var preexistingAttendee = _.find(shift.ServiceShiftMembers || [], { MemberId: attendee ? (attendee.id || attendee.MemberId) : $rootScope.ctx.currentUser.id });
            if (preexistingAttendee) {
              preexistingAttendee.Remark = result.remark;
            }
          }
        })

    };


    self.removeShiftOrPosition = function ($event, shift, position) {
      if ($event) {
        $event.stopPropagation();
      }
      if (shift && shift.ServiceFunctions) {
        return baModalService.messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: position ?
            $translate.instant('modules.events.shiftTemplate.modal.removePositionTitle') :
            $translate.instant('modules.events.shiftTemplate.modal.removeShiftTitle'),
          content: $translate.instant('modules.events.shiftTemplate.modal.removePositionShiftMsg', {
            type: position ?
              $translate.instant('modules.events.shiftTemplate.position') :
              $translate.instant('modules.events.shiftTemplate.shift'),
            subject: position ? position.Function : shift.Subject,
          }),
          primaryActionText: $translate.instant('modules.events.shiftTemplate.remove'),
          secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
        }).then(function () {
          if (!position) {
            var y = self.shifts.indexOf(shift);
            if (~y) {
              self.shifts.splice(y, 1);
            }
            return;
          }
          var i = shift.ServiceFunctions.indexOf(position);
          if (~i) {
            shift.ServiceFunctions.splice(i, 1);
          }
        }).catch(function () {

        });
      }
    };

    self.isInternalQualification = function (shift, position, qualification) {
      // true if qualification is from organizational or source division scope
      // false if qualification is from a shared division scope
      // null if qualification is not from an organizational, source division or shared division scope
      if (self.qualificationRemovalWarning && self.qualificationRemovalWarning[shift.id]
        && self.qualificationRemovalWarning[shift.id][position.id]
        && ~self.qualificationRemovalWarning[shift.id][position.id].indexOf(qualification.id)) {
        return null;
      }
      return !qualification.DivisionId || qualification.DivisionId === self.ctx;
    };

    self.isInternalActivity = function (shift, position, activity) {
      // true if activity is from organizational or source division scope
      // false if activity is from a shared division scope
      // null if activity is not from an organizational, source division or shared division scope
      if (self.activityRemovalWarning && self.activityRemovalWarning[shift.id]
        && self.activityRemovalWarning[shift.id][position.id]
        && ~self.activityRemovalWarning[shift.id][position.id].indexOf(activity.id)) {
        return null;
      }
      return !activity.DivisionId || activity.DivisionId === self.ctx;
    };

    self.isInternalAttendee = function (shift, attendee) {
      // like isInternalQualification
      if (self.attendanceRemovalWarning[attendee.MemberId][shift.id]) {
        return null;
      }
      return (attendee.DivisionId || attendee.Division.id) === self.ctx;
    };

    self.getDateOffset = function (start, end) {
      return moment(end).diff(moment(start), 'days');
    };

    self.calcDateOffsetText = function (offsetDays, isStartDate) {
      if (!offsetDays) {
        return $translate.instant('modules.events.shiftTemplate.dayOfBegin', {
          day: isStartDate ?
            $translate.instant('modules.events.shiftTemplate.startOfEventS') :
            $translate.instant('modules.events.shiftTemplate.startOfShiftS')
        });
      }
      return $translate.instant('modules.events.shiftTemplate.dayOfEvent', {
        days: Math.abs(offsetDays),
        plural: Math.abs(offsetDays),
        order: offsetDays > 0 ?
          $translate.instant('modules.events.shiftTemplate.after') :
          $translate.instant('modules.events.shiftTemplate.before'),
        type: isStartDate ?
          $translate.instant('modules.events.shiftTemplate.startOfEvent') :
          $translate.instant('modules.events.shiftTemplate.startOfShift')
      });
    };

    self.dateOffsetTextHelper = function (shift, lineIdent) {
      var isStartDate = lineIdent === 'StartDate';
      var calcRef = shift.StartDate;
      if (isStartDate) {
        calcRef = moment(0).toDate();
      }
      return self.calcDateOffsetText(self.getDateOffset(calcRef, shift[lineIdent]), isStartDate);
    };

    self.handleServiceFunctionTemplateResultAdd = function (template, shift) {
      (template.ServiceShifts || []).forEach(function (serviceShift) {
        serviceShift.id = commonUtils.uuid();
        (serviceShift.ServiceFunctions || []).forEach(function (position) {
          position.id = commonUtils.uuid();
        });
      });
      if (shift) {
        (template.ServiceShifts || []).forEach(function (serviceShift) {
          shift.ServiceFunctions = shift.ServiceFunctions || [];
          Array.prototype.push.apply(shift.ServiceFunctions, serviceShift.ServiceFunctions);
        });
        return;
      }
      (template.ServiceShifts || []).forEach(function (serviceShift) {
        self.ensureDefaultShiftBookingMaterialTime(serviceShift);
      });
      Array.prototype.push.apply(self.shifts, template.ServiceShifts);
    };

    self.importFromTemplate = function (shift) {
      $uibModal
        .open({
          controller: 'shiftImportTemplateCtrl as $sit',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/shiftTemplate/modals/shiftImportTemplate.html',
          size: 'md',
          resolve: {
            positionMode: function () {
              return !!shift;
            },
            parentLabel: function () {
              return shift ? shift.Subject : (self.options.template.Label || self.options.template.Subject || $translate.instant('modules.events.service.NewService'));
            },
            parentCtrl: function () {
              return self;
            },
            availableServiceTypes: function (clientApi) {
              return clientApi.custom('model/ServiceType', 'findServiceTypes');
            },
            eventCategories: function (clientApi) {
              return clientApi.custom('model/BaseCategory', 'findOrgCategories', { allAvailable: true, usages: ['Event'] });
            },
          }
        })
        .result
        .then(function (result) {
          if (result && result.length) {
            result.forEach(function (template) {
              self.handleServiceFunctionTemplateResultAdd(template, shift);
            });
          }
        });
    };

    self.intervalGnattRecalcTimer = null;
    self.intervalGnattRecalc = function () {
      self.intervalGnattRecalcTimer = $timeout(self.intervalGnattRecalc, 1000 * 30);
    };

    $scope.$on('$destroy', function () {
      if (self.intervalGnattRecalcTimer) {
        $timeout.cancel(self.intervalGnattRecalcTimer);
      }
    });

    $scope.$watch(function () {
      return JSON.stringify(self.shifts)
        + (+self.options.template.EventStartDate) + (+self.options.template.EventEndDate)
        + (self.intervalGnattRecalcTimer || {}).$$timeoutId;
    }, function () {
      if (!self.shifts || !self.shifts.length) {
        return;
      }
      var outerBounds = [null, null];
      self.shifts.forEach(function (shift) {
        ['StartDate', 'EndDate'].forEach(function (dateProp, i) {
          if (shift[dateProp] && (!outerBounds[i] || moment(shift[dateProp])[i ? 'isAfter' : 'isBefore'](moment(outerBounds[i])))) {
            outerBounds[i] = shift[dateProp];
          }
        });
      });
      [self.options.template.EventStartDate, self.options.template.EventEndDate].forEach(function (eventDate, i) {
        if (eventDate && (!outerBounds[i] || moment(eventDate)[i ? 'isAfter' : 'isBefore'](moment(outerBounds[i])))) {
          outerBounds[i] = eventDate;
        }
      });
      if (!outerBounds[0] || !outerBounds[1]) {
        outerBounds[0] = moment().startOf('day');
        outerBounds[1] = moment().endOf('day');
      }
      outerBounds.forEach(function (boundary, i) {
        outerBounds[i] = moment(boundary).valueOf();
      });
      var boundDistance = outerBounds[1] - outerBounds[0];
      self.gnattLanes = [[]];
      _
        .orderBy(self.shifts, [
          function (s) {
            return moment(s.StartDate).valueOf();
          },
          'Subject',
        ])
        .forEach(function (s) {
          var shift = _.cloneDeep(s);
          shift.orig = s;
          shift.percentStart = ((moment(shift.StartDate || outerBounds[0]).valueOf() - outerBounds[0]) / boundDistance) * 100;
          shift.percentEnd = ((moment(shift.EndDate || outerBounds[1]).valueOf() - outerBounds[0]) / boundDistance) * 100;
          shift.gnattLabel = s.Subject;
          shift.attendanceClass = '';
          if (!self.templateMode) {
            shift.gnattLabel += $translate.instant('modules.events.shiftTemplate.gnatt', {
              start: moment(shift.StartDate).format('DD.MM.YYYY, HH:mm'),
              end: moment(shift.EndDate).format('DD.MM.YYYY, HH:mm')
            });

            var ownAttendance = (shift.ServiceShiftMembers || []).filter(function (member) {
              return member.MemberId === $rootScope.ctx.currentUser.id;
            });

            if (ownAttendance[0]) {
              if (ownAttendance[0].Interested) {
                shift.attendanceClass = 'attendance-interested';
              }
              if (ownAttendance[0].Acceptance) {
                shift.attendanceClass = 'attendance-accepted';
              }
              if (ownAttendance[0].Acceptance === false) {
                shift.attendanceClass = 'attendance-declined';
              }
            }
            if (!self.canSelfAttend(shift.orig, true)) {
              shift.attendanceClass = 'attendance-unavailable';
            }
          }
          var wasAssigned = false;
          self.gnattLanes.forEach(function (lane) {
            if (wasAssigned) {
              return;
            }
            if (!lane.length) {
              lane.push(shift);
              wasAssigned = true;
              return;
            }
            var sorted = _.sortBy(lane.concat(shift), [function (s) {
              return moment(s.StartDate || outerBounds[0]).valueOf();
            }]);
            var collisionCount = sorted
              .map(function (a, i) {
                var b = sorted[i + 1] || null;
                if (!b) {
                  return false;
                }
                return moment(a.EndDate || outerBounds[1]).isAfter(moment(b.StartDate || outerBounds[0]));
              })
              .filter(function (bool) {
                return bool;
              })
              .length;
            if (!collisionCount) {
              lane.push(shift);
              lane.sort(function (a, b) {
                return moment(a.StartDate).valueOf() - moment(b.StartDate).valueOf();
              });
              wasAssigned = true;
            }
          });
          if (!wasAssigned) {
            self.gnattLanes.push([shift]);
          }
        });
      self.gnattMilestones = [
        {
          id: 'event-start',
          gnattLabel: $translate.instant('modules.events.shiftTemplate.startOfEvent'),
          percentStart: ((moment(self.templateMode ? 0 : self.options.template.EventStartDate).valueOf() - outerBounds[0]) / boundDistance) * 100,
          classlist: self.templateMode ? [] : ['event-start'],
        }
      ];
      if (!self.templateMode) {
        self.currentTimeMilestone = ((moment().valueOf() - outerBounds[0]) / boundDistance) * 100;
        if (self.currentTimeMilestone > 0) {
          if (!self.intervalGnattRecalcTimer) {
            self.intervalGnattRecalc();
          }
          self.gnattMilestones.push({
            id: 'time-current-backdrop',
            percentStart: self.currentTimeMilestone,
            classlist: ['current-time-backdrop'],
            style: { 'width': 'calc(' + self.currentTimeMilestone + '% + 10px)' }
          });
          if (self.currentTimeMilestone <= 100) {
            self.gnattMilestones.push({
              id: 'time-current-indicator',
              gnattLabel: $translate.instant('modules.events.shiftTemplate.gnattToday', {
                time: moment().format('HH:mm')
              }),
              percentStart: self.currentTimeMilestone,
              classlist: ['current-time-milestone'],
            })
          }
        }

        self.gnattMilestones.push({
          id: 'event-end',
          gnattLabel: $translate.instant('modules.events.shiftTemplate.endOfEvent'),
          percentStart: ((moment(self.options.template.EventEndDate).valueOf() - outerBounds[0]) / boundDistance) * 100,
          classlist: ['event-end'],
        })
      }
    });

    self.shiftScrollRef = function (shift) {
      return 'sidref' + (shift.orig || shift).id;
    };

    self.scrollRefShiftId = function (scrollRef) {
      return parseInt((scrollRef || '').replace('sidref', ''), 10) || false;
    };

    self.jumpToShiftById = function (shiftId) {
      var shift = _.find(self.shifts, { id: shiftId });
      if (shift) {
        self.jumpToShift(shift);
      }
    }

    self.requirementsNotFullfilled = function (shiftId, positionId) {

      if (self.requirementValidityMap && self.requirementValidityMap[shiftId] && self.requirementValidityMap[shiftId][positionId]) {
        var found = _.find(self.requirementValidityMap[shiftId][positionId].qualification, { validState: null });
        if (found) {
          return true;
        }
      }
      return false;

    };

    self.jumpToShift = function (shift) {
      self.skipNextToggleAnimation = true;
      self.toggleNextState[shift.id] = false;
      var reference = self.shiftScrollRef(shift);
      // wait for toggles to happen
      $timeout(function () {
        if ($location.hash() !== reference) {
          stateChangePrompt.ignoreNextEvaluation();
          $location.hash(reference);
        } else {
          $anchorScroll();
        }
      }, 0);
    };

    self.initJumpToShift = false;
    if ($location.hash()) {
      var shiftId = self.scrollRefShiftId($location.hash());
      if (shiftId) {
        var shift = _.find(self.shifts, { id: shiftId });
        if (shift) {
          self.initJumpToShift = shiftId;
          // wait for page to load initially
          $timeout(function () {
            self.jumpToShift(shift);
          }, 400);
        }
      }
    }

    self.orderByStartDate = function (shift) {
      return moment(shift.StartDate || 0).valueOf();
    };

    self.attendanceSearch = function (searchTerm, shift, exactly, includeInactive) {
      if (!searchTerm && !exactly) {
        self.attendanceStore[shift.id].choices = [{ none: true }];
        return null;
      }

      var relevantShiftDivisions = self.dynShiftShare[shift.id]
        .map(function (shiftShare) {
          return shiftShare.DivisionId;
        })
        .concat([self.ctx]);

      if (exactly) {
        relevantShiftDivisions = _.intersection((self.options.viewPermissionsList || []), relevantShiftDivisions);
      }

      var searchOpts = {
        divisionIds: relevantShiftDivisions,
        serviceId: self.options.template.id,
      };

      if (searchTerm) {
        searchOpts.search = searchTerm;
      } else if (exactly) {
        searchOpts.exactly = exactly;
      }

      if (includeInactive) {
        searchOpts.includeInactive = true;
      }

      return clientApi
        .custom('model/ServiceShiftMember', 'searchServiceMembers', searchOpts)
        .then(function (results) {
          results.forEach(function (result) {
            result.MemberId = result.id;
          });

          self.memberUnderagedCalc(results);

          if (exactly) {
            return results;
          }

          if (results && results.length) {
            self.attendanceStore[shift.id].choices = results;
          } else {
            self.attendanceStore[shift.id].choices = [{ none: true, foundNone: true }];
          }
        });
    };

    self.attendanceGroupFunc = function (attendee) {
      if (attendee.none) {
        return undefined;
      }
      if (!attendee || !attendee.DivisionMembers || attendee.DivisionMembers.length !== 1 || !attendee.DivisionMembers[0].Division) {
        return $translate.instant('modules.events.shiftTemplate.manyOutlines');
      }
      return attendee.DivisionMembers[0].Division.Name;
    };

    self.currentAcceptance = function (shift, attendee) {
      var result = {
        className: '',
        label: $translate.instant('modules.events.shiftTemplate.open'),
        division: '----',
      };
      var preexistingAttendee = _.find(shift.ServiceShiftMembers || [], { MemberId: (attendee || { id: $rootScope.ctx.currentUser.id }).id });
      if (preexistingAttendee) {
        result = {
          className: preexistingAttendee.Interested ? 'label-warning' : (preexistingAttendee.Acceptance ? 'label-success' : 'label-danger'),
          label: preexistingAttendee.Interested ?
            $translate.instant('modules.events.shiftTemplate.interest') :
            (preexistingAttendee.Acceptance ?
              $translate.instant('modules.events.shiftTemplate.confirmed') :
              $translate.instant('modules.events.shiftTemplate.canceled')),
          division: (preexistingAttendee.Division || {}).Name || '----',
        };
      }
      return result;
    };

    self.attendanceAdd = function (shift, attendee, accept, freshAttendeeSource, immediate) {
      var preexistingAttendee = _.find(shift.ServiceShiftMembers || [], { MemberId: attendee ? (attendee.id || attendee.MemberId) : $rootScope.ctx.currentUser.id });
      var updateAttendee = preexistingAttendee || attendee;
      var acceptance = accept;
      var interested = (updateAttendee || {}).Interested || null;
      var isImmediate = immediate && self.options.template.id;

      return Promise.resolve().then(function () {
        if (!freshAttendeeSource || !attendee || !attendee.DivisionMembers) {
          return self.attendanceSearch(null, shift, (attendee || { MemberId: $rootScope.ctx.currentUser.id }).MemberId).then(function (results) {
            if (!results || results.length !== 1) {
              var attendeeName = attendee ? (attendee.fullName || attendee.Member.fullName || 'Teilnehmer') : $rootScope.ctx.currentUser.fullName;
              toastr.error(
                $translate.instant('modules.events.shiftTemplate.toastr.missingDivisionAssignmentMsg', {
                  attendeeName: attendeeName
                }),
                $translate.instant('modules.events.shiftTemplate.toastr.missingDivisionAssignmentTitle')
              );
              throw new Error('Invalid member search.');
            }
            return results[0];
          })
        }
        return attendee;
      }).then(function (freshAttendee) {
        if (!updateAttendee) {
          updateAttendee = freshAttendee;
        }
        updateAttendee.DivisionMembers = freshAttendee.DivisionMembers;
        updateAttendee.fullName = updateAttendee.fullName || updateAttendee.Member.fullName;
      }).then(function () {
        if (!acceptance && updateAttendee.ServiceFunctionId) {
          var found = _.find(shift.ServiceFunctions, { id: updateAttendee.ServiceFunctionId });
          return baModalService.messageModal({
            modalType: 'danger',
            allowHtml: false,
            title: 'Absagen und Positionszuweisung entfernen',
            content: $translate.instant('modules.events.shiftTemplate.modal.sureToCancel', {
              name: updateAttendee.fullName || updateAttendee.Member.fullName,
              function: found && found.Function
            }),
            primaryActionText: $translate.instant('modules.events.shiftTemplate.canceling'),
            secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
          })
        }
      }).then(function () {
        if (updateAttendee.DivisionMembers.length > 1) {
          return eventUtil.chooseAttendanceDivisionModal(
            updateAttendee,
            updateAttendee.DivisionMembers.map(function (dm) {
              return {
                label: dm.Division.Name,
                dm: dm,
                defaultSelected: dm.DivisionId === (updateAttendee.Division || {}).id,
              };
            }),
            'SERVICE'
          ).then(function (choice) {
            return choice.dm;
          });
        }
        return updateAttendee.DivisionMembers[0];
      }).then(function (divisionMember) {
        return Promise.resolve().then(function () {
          if (updateAttendee.Division && updateAttendee.Division.id && updateAttendee.Division.id !== divisionMember.DivisionId) {
            // user decided to change the division of an already reported attendee
            // warn user about possible impacts
            return eventUtil.attendanceDivisionChangeWarnModal(updateAttendee, divisionMember, 'SERVICE');
          }
          return null;
        }).then(function () {
          return divisionMember;
        })
      }).then(function (divisionMember) {
        var share = _.find((self.options.template.ServiceShares || []), { DivisionId: divisionMember.DivisionId });
        if (isImmediate && ((share && commonUtils.isUUID.test(share.id)) || commonUtils.isUUID.test(shift.id))) {
          // can't immediately update attendance for new shares;
          // needs to go to save flow; will only happen for managers who updated shares - they are not dependent on immediate save mode anyway
          // if share was not found, it is the source division which can be updated immediately
          isImmediate = false;
        }
        if (isImmediate) {
          return clientApi.custom('model/ServiceShiftMember', 'updateOwnAttendance', {
            serviceId: self.options.template.id,
            shiftId: shift.id,
            divisionId: divisionMember.DivisionId,
            acceptance: acceptance,
          }).then(function (updatedAttendee) {
            acceptance = updatedAttendee.Acceptance;
            interested = updatedAttendee.Interested;
            toastr.success(
              $translate.instant('modules.events.shiftTemplate.toastr.participationRegisteredMsg'),
              $translate.instant('modules.events.shiftTemplate.toastr.participationRegisteredTitle')
            );
          }).catch(function () {
            toastr.error(
              $translate.instant('modules.events.shiftTemplate.toastr.participationFailedMsg'),
              $translate.instant('modules.events.shiftTemplate.toastr.participationFailedTitle')
            );
          }).then(function () {
            return divisionMember;
          });
        }
        return divisionMember;
      }).then(function (divisionMember) {
        $scope.$evalAsync(function () {
          updateAttendee.Acceptance = acceptance;
          updateAttendee.Interested = interested;
          updateAttendee.Division = { id: divisionMember.DivisionId, Name: divisionMember.Division.Name };

          if (preexistingAttendee) {
            if (preexistingAttendee.state !== 'ADDED' && !isImmediate) {
              preexistingAttendee.state = 'UPDATED';
            }
          } else {
            if (!isImmediate) {
              updateAttendee.state = 'ADDED';
            }
            shift.ServiceShiftMembers = shift.ServiceShiftMembers || [];
            shift.ServiceShiftMembers.push(updateAttendee);
          }

          if (!updateAttendee.Acceptance) {
            updateAttendee.ServiceFunctionId = null;
          }
        });
      }).catch(function () {
        // hm k
      })
    };

    self.removeAttendance = function (shift, attendee) {
      if (attendee) {
        var preexistingAttendee = _.find(shift.ServiceShiftMembers || [], { MemberId: attendee.id });
        if (preexistingAttendee) {
          shift.ServiceShiftMembers.splice(shift.ServiceShiftMembers.indexOf(preexistingAttendee), 1);
        }
      }
    };

    self.downloadICAL = function ($event, shifts) {
      if ($event) {
        $event.stopPropagation();
      }
      if (!self.templateMode && shifts && shifts.length) {
        if (!self.options.template.id && self.options.isUnchangedFunc && !self.options.isUnchangedFunc()) {
          return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.shiftTemplate.beforeStartDownload'));
        }
        clientApi.openTab('event/service-shift-ical', {
          serviceId: self.options.template.id,
          shiftIds: shifts.map(function (shift) {
            return shift.id;
          }).filter(function (sid) {
            return sid;
          }),
        }, { post: true });
      }
    };
    self.options.downloadICAL = self.downloadICAL; // child component to parent reverse share

    self.closeDropdown = function () {
      try {
        document.querySelector('body').click(); // it listens for a window click to close, this will bubble up
      } catch (e) {
        // hm k
      }
      return true;
    };
    self.options.closeDropdown = self.closeDropdown;

    self.sendMessage = function (shifts, messageType) {
      if (!self.templateMode && shifts && shifts.length) {
        if ((self.options.isUnchangedFunc && !self.options.isUnchangedFunc()) || !self.options.template.id) {
          return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.shiftTemplate.beforeSendMessage'));
        }
        return $uibModal.open({
          controller: 'sendAttendeeMessageCtrl as $msg',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventModalShare/sendAttendeeMessage.html',
          size: 'md',
          resolve: {
            shifts: function () {
              return shifts;
            },
            attendeeInfos: function () {
              return clientApi
                .custom('model/Service', 'fetchAttendeeEMail', {
                  serviceId: self.options.template.id,
                  shiftIds: shifts
                    .map(function (shift) {
                      return shift.id;
                    })
                    .filter(function (sid) {
                      return sid;
                    }),
                  messageType: messageType
                })
            },
          }
        });
      }
    };
    self.options.sendMessage = self.sendMessage;

    self.inviteAttendee = function (shifts) {
      if (!self.templateMode && self.options.template.id && shifts && shifts.length) {
        if (self.options.isUnchangedFunc && !self.options.isUnchangedFunc()) {
          return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.shiftTemplate.beforeSendInvitations'));
        }
        return $uibModal.open({
          controller: 'inviteAttendeeCtrl as $ia',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventModalShare/inviteAttendee.html',
          size: 'md',
          resolve: {
            entityId: function () {
              return self.options.template.id;
            },
            shifts: function () {
              return shifts;
            },
            divisionOptions: function () {
              var permittedDivisionIds = _.uniq(
                _.flatten(
                  shifts.map(function (shift) {
                    return self.canEditAttendance(shift, true);
                  })
                )
              );

              return clientApi.custom('model/Division', 'fetchDivisionName', {
                divisionIds: permittedDivisionIds
              });
            },
            membersWithAttendeeStatus: function () {
              return _.uniq(
                _.flatten(
                  shifts.map(function (shift) {
                    return (shift.ServiceShiftMembers || []).filter(function (member) {
                      return member.Acceptance || member.Interested;
                    }).map(function (member) {
                      return member.MemberId || member.Member.id;
                    });
                  })
                )
              );
            },
          }
        }).result.then(function (inviteOpts) {

          inviteOpts.divisionIds.forEach(function (divisionId) {

            var inviteList = _.filter(inviteOpts.inviteList, function (member) {
              return member.DivisionId == divisionId
            }).map(function (member) {
              return member.MemberId;
            })

            if (inviteList.length > 0 || (inviteList.length == 0 && inviteOpts.sendOption == 'ALL_DIVISION')) {
              return clientApi.custom('model/ServiceShiftMember', 'inviteMember', {
                divisionId: divisionId,
                inviteList: inviteList,
                serviceId: self.options.template.id,
                shiftIds: shifts.map(function (shift) {
                  return shift.id;
                }),
                filterExisting: true
              })
                .then(function (result) {
                  if (result && result.sendCount) {
                    var successStr = $translate.instant('modules.events.shiftTemplate.toastr.invitationsWereSentMsg', {
                      count: result.sendCount
                    });
                    if (result.sendCount === 1) {
                      successStr = $translate.instant('modules.events.shiftTemplate.toastr.invitationWasSentMsg');
                    }
                    toastr.success(
                      successStr,
                      $translate.instant('modules.events.shiftTemplate.toastr.invitationSendTitle')
                    );
                  } else {
                    toastr.warning(
                      $translate.instant('modules.events.shiftTemplate.toastr.invitationNotSendMsg'),
                      $translate.instant('modules.events.shiftTemplate.toastr.invitationNotSendTitle')
                    );
                  }
                }).catch(function () {
                  toastr.error(
                    $translate.instant('modules.events.shiftTemplate.toastr.invitationSendFailedMsg'),
                    $translate.instant('modules.events.shiftTemplate.toastr.invitationSendFailedTitle')
                  );
                })
            }
          })
        }
        ).catch(function () {
          // hm k
        });
      }
    };
    self.options.inviteAttendee = self.inviteAttendee; // child component to parent reverse share

    if (!self.templateMode) {
      // toggle open those shifts, where the user is a (potential) attendee
      var isAttendeeIn = [];
      (self.shifts || []).forEach(function (shift) {
        (shift.ServiceShiftMembers || []).forEach(function (attendee) {
          if (attendee.MemberId === $rootScope.ctx.currentUser.id && (attendee.Interested || attendee.Acceptance)) {
            isAttendeeIn.push(shift.id);
          }
        })
      });
      // + shifts where the user can edit attendances
      var attendanceManagerIn = _.compact(
        (self.shifts || []).map(function (shift) {
          return self.canEditAttendance(shift) && shift.id;
        })
      );
      var selfAttendIn = [];
      if (!isAttendeeIn.length) {
        // + shifts where the user can self attend, but only if he has not attended any shifts yet
        selfAttendIn = _.compact(
          (self.shifts || []).map(function (shift) {
            return self.canSelfAttend(shift) && shift.id;
          })
        );
      }
      var toggleCloseIn = _.difference(_.map(self.shifts || [], 'id'), isAttendeeIn, attendanceManagerIn, selfAttendIn);
      if (self.initJumpToShift) {
        toggleCloseIn = _.difference(_.map(self.shifts || [], 'id'), [self.initJumpToShift]); // toggle all close except shift that got jumped upon
      }
      toggleCloseIn.forEach(function (noAttendanceShiftId) {
        self.toggleNextState[noAttendanceShiftId] = true;
      });
    }

    $scope.$watch(function () {
      return true; // once with initial watcher calc
    }, function () {

    });
  }
})
  ();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('shiftTemplate', shiftTemplate);

  /** @ngInject */
  function shiftTemplate() {
    return {
      restrict: 'AE',
      replace: 'true',
      templateUrl: 'app/theme/components/shiftTemplate/shiftTemplate.html',
      scope: {
        options: '=',
        sharedDivisions: '=',
      },
      controller: 'ShiftTemplateCtrl as $shift',
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('DatespanCtrl', DatespanCtrl);

  function DatespanCtrl(toastr, dateVals, $uibModalInstance, $translate) {
    var self = this;
    self.datePickerStates = {};
    self.datepicker = {
      format: 'dd.MM.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'year',
      }
    };

    if (dateVals) {
      self.startDate = new Date(dateVals.start);
      self.endDate = new Date(dateVals.end);
    }

    self.applyModal = function() {
      if (!self.startDate || !self.endDate) {
        toastr.error(
          $translate.instant('components.modals.setDateSpan.errToast1Text'),
          $translate.instant('components.modals.setDateSpan.errToast1Title')
        );
        return;
      }

      if (new Date(self.startDate).getTime() > new Date(self.endDate).getTime()) {
        toastr.error(
          $translate.instant('components.modals.setDateSpan.errToast2Text'),
          $translate.instant('components.modals.setDateSpan.errToast2Title')
        );
        return;
      }

      $uibModalInstance.close({ start: self.startDate.toISOString(), end: self.endDate.toISOString() });
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('serviceDivisionShareList', serviceDivisionShareList);

  /** @ngInject */
  function serviceDivisionShareList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/serviceDivisionShareList/serviceDivisionShareList.html',
      scope: {
        divisionShares: '=',
        eventShareCtx: '=?',
      },
      controller: 'serviceDivCtrl as $svcDivCtrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function serviceDivCtrl($scope, toastr, clientApi, baModalService, $state, $translate) {
    var self = this;
    self.divisionShares = $scope.divisionShares;
    self.eventShareCtx = $scope.eventShareCtx;
    self.handleShare = function (action, divisionShare) {
      if (action === 'DETAILS') {
        if (divisionShare.Service) {
          $state.go('arno.events.serviceDetail', { serviceId: divisionShare.ServiceId, ctx: divisionShare.Service.SourceDivision.id });
        } else {
          $state.go('arno.events.eventDetail', { eventId: divisionShare.EventId });
        }
        return;
      }

      Promise.resolve()
        .then(function () {
          if (action === 'DECLINE') {
            return baModalService.messageModal({
              modalType: 'danger',
              allowHtml: false,

              title: $translate.instant('modules.arnoDashboard.board.rejectShare'),
              content: $translate.instant('modules.arnoDashboard.board.shareEvent') + divisionShare.Event.Subject + $translate.instant('modules.arnoDashboard.board.reallyDiscard'),

              primaryActionText: $translate.instant('modules.arnoDashboard.board.decline'),
              secondaryActionText: $translate.instant('generalTerms.cancel')
            })
          }
          return null;
        })
        .then(function () {
          if (divisionShare.Service) {
            return clientApi
              .custom('model/ServiceShare', 'setShareState', {
                serviceId: divisionShare.ServiceId,
                divisionId: divisionShare.DivisionId,
                isShared: action === 'ACCEPT',
              })
          }
          return clientApi
            .custom('model/DivisionEvent', 'setDivisionShareState', {
              eventId: divisionShare.EventId,
              divisionId: divisionShare.DivisionId,
              isShared: action === 'ACCEPT',
            })
        })
        .then(function () {
          if (action === 'ACCEPT') {
            toastr.success($translate.instant('modules.arnoDashboard.board.allreadyShareEvent'), $translate.instant('modules.arnoDashboard.board.acceptParts'));
          } else {
            toastr.info($translate.instant('modules.arnoDashboard.board.eventWasNotShared'), $translate.instant('modules.arnoDashboard.board.discardParts'));
          }
          $state.reload();
        })
        .catch(function () {
        });
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('serviceDivCtrl', serviceDivCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('serviceAttendanceInterestList', serviceAttendanceInterestList);

  /** @ngInject */
  function serviceAttendanceInterestList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/serviceAttendanceInterestList/serviceAttendanceInterestList.html',
      scope: {
        openServiceAttendeeInterest: '=',
      },
      controller: 'serviceInterestCtrl as $svcIntCtrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function serviceInterestCtrl($scope, $state) {
    var self = this;
    self.openServiceAttendeeInterest = $scope.openServiceAttendeeInterest;
    self.openServiceDetails = function(service) {
      $state.go('arno.events.serviceDetail', { serviceId: service.id, ctx: service.SourceDivision.id });
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('serviceInterestCtrl', serviceInterestCtrl);
})();

(function () {
  'use strict';

  /** @ngInject */
  function qualificationListCtrl($location, $scope, $translate, screenSize, $uibModal, permissions, fileUtil) {
    var self = this;
    var isOwnDossier = $scope.isOwnDossier;
    self.currentUrl = $location.$$path;
    self.isOverviewTab = self.currentUrl === '/personnel/dossier/' && $scope.member + $scope.member.Account.EMail;

    // REMARK: this will create a reference-check watch, which is better than to watch only $scope.qualificationList,
    // which is a deep-watch and thus expensive
    var lastQualificationListRef = $scope.qualificationList;
    $scope.$watch(
      function () {
        return lastQualificationListRef !== $scope.qualificationList;
      },
      function (newVal) {
        lastQualificationListRef = $scope.qualificationList;

        if (newVal === true) {
          activate();
        }
      }
    );

    // BOOTSTRAPPER Function
    function activate() {
      self.alwaysShow = $scope.alwaysShow;
      self.cssConfigs = $scope.cssConfigs;

      self.typeSettings = {
        qualification: {
          translations: {
            typeSingular: $translate.instant('modules.administration.adminQualification.qualification'),
            typePlural: $translate.instant('modules.administration.adminQualification.qualifications'),
            typeGroupSingular: $translate.instant('modules.administration.adminQualification.qualificationGroup'),
            typeGroupPlural: $translate.instant('modules.administration.adminQualification.qualificationGroups'),
          },
        },
        instruction: {
          translations: {
            typeSingular: $translate.instant('modules.administration.adminQualification.instruction'),
            typePlural: $translate.instant('modules.administration.adminQualification.instructions'),
            typeGroupSingular: $translate.instant('modules.administration.adminQualification.instructionGroup'),
            typeGroupPlural: $translate.instant('modules.administration.adminQualification.instructionGroups'),
          },
        },
        all: {
          translations: {
            typeSingular: $translate.instant('modules.administration.adminQualification.allTypeSingular'),
            typePlural: $translate.instant('modules.administration.adminQualification.allTypePlural'),
            typeGroupSingular: $translate.instant('modules.administration.adminQualification.allTypeGroupSingular'),
            typeGroupPlural: $translate.instant('modules.administration.adminQualification.allTypeGroupPlural'),
          },
        },
      };
      self.type = $scope.qualificationType || 'all';

      self.member = $scope.member;
      self.divisionId = $scope.divisionIds;
      self.translateValues = Object.assign(self.typeSettings[self.type].translations, $scope.qualificationTranslations);

      self.qualificationStates =
        $scope.qualificationStates && $scope.qualificationStates.length
          ? $scope.qualificationStates.map(function (qs) {
            return {
              title: $translate.instant(qs.title),
              intext: $translate.instant(qs.intext),
              showSectionHeader: qs.showSectionHeader,
            };
          })
          : null;

      self.formattedQualificationGroups = {}; // this is used to easily map the qualification-group-names to the groups for the view

      self.qualificationStates = self.qualificationStates || [
        {
          title: $translate.instant(
            'modules.personnel.dossier.overview.qualificationList.qualificationStateTitle',
            Object.assign(self.translateValues, { active: true })
          ),
          validity: true,
          intext: $translate.instant(
            'modules.personnel.dossier.overview.qualificationList.qualificationStateInText',
            Object.assign(self.translateValues, { active: true })
          ),
        },
        {
          title: $translate.instant(
            'modules.personnel.dossier.overview.qualificationList.qualificationStateTitle',
            Object.assign(self.translateValues, { active: false })
          ),
          validity: false,
          intext: $translate.instant(
            'modules.personnel.dossier.overview.qualificationList.qualificationStateInText',
            Object.assign(self.translateValues, { active: false })
          ),
        },
      ]; 

      self.mediaSizeXs = screenSize.on('xs', function (match) {
        self.mediaSizeXs = match;
      });

      self.defineQualificationValidity = function (qualification) {
        var curDate = new moment().hour(0).toDate();
        var acquireDate = new Date(qualification.AcquireDate);
        var expireDate = new Date(qualification.ExpireDate);
        if (qualification.AcquireDate) {
          if ((acquireDate < curDate && curDate < expireDate) || (acquireDate < curDate && !qualification.ExpireDate)) {
            qualification.Valid = true;
          } else {
            qualification.Valid = false;
          }
        } else {
          qualification.Valid = true;
        }
      };

      self.displayMemberQualMode = $scope.qualificationListMemberData;

      self.qualificationList = _.cloneDeep($scope.qualificationList || []);
      self.qualificationList = self.qualificationList.filter(function (qualification) {
        if (self.isOverviewTab) {
          return qualification.IncludedQualificationId ? false : true;
        }
        return true;
      });

      self.qualificationList.forEach(function (qualificationItem) {
        // set common values to accept different datasources
        if (!qualificationItem.QualificationId) {
          qualificationItem.QualificationId = qualificationItem.id || qualificationItem.Id || qualificationItem.IncludedQualificationId;
        }
        if (!qualificationItem.QualificationName && qualificationItem.Name) {
          qualificationItem.QualificationName = qualificationItem.Name;
        }
        if (!qualificationItem.GroupName && qualificationItem.QualificationGroup) {
          qualificationItem.GroupName = qualificationItem.QualificationGroup.Name;
        }
      });

      var qualificationListLength = self.qualificationList.length;
      while (qualificationListLength--) {
        var qualificationItem = self.qualificationList[qualificationListLength];

        if (self.displayMemberQualMode && qualificationItem.IncludedQualificationId) {
          // show member qualification mode
          // IncludedQualificationId implies it is not a directly associated qualificaion,
          // could be a duplicate of an qualification with an association,
          // check and may remove this qualification from list

          var associatedQualification = _.find(self.qualificationList, function (qualification) {
            return qualification.QualificationId == qualificationItem.QualificationId && !qualification.IncludedQualificationId;
          });
          if (associatedQualification) {
            associatedQualification.isAlsoInherited = true;
            self.qualificationList.splice(qualificationListLength, 1);
          } else {
            qualificationItem.onlyInherited = true;
          }
        }
      }

      self.qualificationHierarchy = _.cloneDeep($scope.qualificationAdd);
      self.onlyView = $scope.qualificationOnlyView;

      self.qualificationList = _.sortBy(self.qualificationList, function (o) {
        return o.GroupName;
      });

      self.flatQualificationHierarchy = [];
      if (self.qualificationHierarchy && self.qualificationHierarchy.length) {
        // flatten the hierarchy (removing the groups) and write the group name on every single qualification
        self.flatQualificationHierarchy = [].concat.apply(
          [],
          _.sortBy(self.qualificationHierarchy, 'Name').map(function (qualificationHierarchyItem) {
            return _.sortBy(qualificationHierarchyItem.Qualifications, 'Name').map(function (qualificationItem) {
              qualificationItem.GroupName = qualificationHierarchyItem.Name;
              qualificationItem.QualificationName = qualificationItem.Name;
              qualificationItem.QualificationId = qualificationItem.id;
              qualificationItem.Type = qualificationHierarchyItem.Type || 'qualification';
              return qualificationItem;
            });
          })
        );

        if (self.qualificationList && self.qualificationList.length) {
          // transfer validilityPeriods from hierarchy to qualification list if possible
          self.qualificationList.forEach(function (qualification) {
            var searchInHierarchy = _.find(self.flatQualificationHierarchy, { QualificationId: qualification.QualificationId });
            if (searchInHierarchy) {
              ['ValidityPeriodDays', 'ValidityPeriodMonths', 'ValidityPeriodYears'].forEach(function (transferProp) {
                qualification[transferProp] = searchInHierarchy[transferProp] || null;
              });
            }
          });
        }

        var qualificationIdsToExclude = [];
        if ($scope.qualificationExclude && $scope.qualificationExclude.length) {
          qualificationIdsToExclude = qualificationIdsToExclude.concat($scope.qualificationExclude);
        }

        _.remove(self.flatQualificationHierarchy, function (flatQualification) {
          return !!~qualificationIdsToExclude.indexOf(flatQualification.QualificationId);
        });

        self.flatHierarchyByType = {
          qualification: self.flatQualificationHierarchy.filter(function (el) {
            return el.Type === 'qualification';
          }),
          instruction: self.flatQualificationHierarchy.filter(function (el) {
            return el.Type === 'instruction';
          }),
        };
      }
      self.originalQualifications = _.cloneDeep(self.qualificationList);

      if ($scope.qualificationAdd && $scope.qualificationAdd.length) {
        $scope.qualificationAdd.forEach(function (group) {
          if (group.Name) {
            //map all qualifications by their name for easy access
            if (group && group.Qualifications && group.Qualifications.length) {
              group.mappedQualifications = {};
              group.Qualifications.forEach(function (qualification) {
                group.mappedQualifications[qualification.Name] = qualification;
              });
            }
            self.formattedQualificationGroups[group.Name] = group;
          }
        });
      }
    }

    // METHODS
    self.defineQualificationValidity = function (qualification) {
      var curDate = new moment().hour(0).toDate();
      var acquireDate = new Date(qualification.AcquireDate);
      var expireDate = new Date(qualification.ExpireDate);
      if (qualification.AcquireDate) {
        if ((acquireDate < curDate && curDate < expireDate) || (acquireDate < curDate && !qualification.ExpireDate)) {
          qualification.Valid = true;
        } else {
          qualification.Valid = false;
        }
      } else {
        qualification.Valid = true;
      }
    };

    self.displayKeepOrDeleteQualificationBtn = function (qualification) {
      return (
        $scope.qualificationDelete &&
        (!qualification.pendingAction || !!~['edit', 'delete'].indexOf(qualification.pendingAction)) &&
        (!self.displayMemberQualMode || !qualification.onlyInherited)
      );
    };

    self.onQualificationDelete = function (qualification) {
      if (qualification.pendingAction === 'edit') {
        var orgData = self.originalQualifications.find(function (orgQual) {
          return orgQual.ListId === qualification.ListId;
        });
        for (var key in qualification) {
          if (orgData.hasOwnProperty(key)) {
            if (!qualification[key] || qualification[key] !== orgData[key]) {
              qualification[key] = orgData[key];
            }
          }
        }

        if (qualification.fileDelete) {
          qualification.File = qualification.fileDelete || qualification.File;
          delete qualification.fileDelete;
        }

        qualification.pendingAction = '';
      } else {
        qualification.pendingAction = qualification.pendingAction ? null : 'delete';
      }
      self.updateChangeModel();
    };

    self.onQualificationPendingDelete = function (qualification) {
      delete qualification.pendingAction;
      delete qualification.AcquireDate;
      delete qualification.ExpireDate;
      self.flatQualificationHierarchy.push(qualification);
      if (!qualification.onlyInherited) {
        self.qualificationList.splice(self.qualificationList.indexOf(qualification), 1);
      }
      self.updateChangeModel();
    };

    self.isModalOpen = function () {
      return $('.modal-open').length;
    };

    self.qualificationAdd = function (qualificationToAdd, suppressModalOpen, type) {
      if (qualificationToAdd) {
        var isAlreadyInherited =
          self.displayMemberQualMode &&
          _.find(self.qualificationList, { onlyInherited: true, QualificationId: qualificationToAdd.QualificationId });
        if (self.displayMemberQualMode && !suppressModalOpen) {
          return self.openMemberQualificationModal(isAlreadyInherited || qualificationToAdd, true, type);
        }
        if (isAlreadyInherited) {
          isAlreadyInherited.pendingAction = 'add';
          _.extend(isAlreadyInherited, qualificationToAdd);
        } else {
          qualificationToAdd.pendingAction = 'add';
          // set the Valid state so it gets filtered into the correct table
          self.defineQualificationValidity(qualificationToAdd);
          self.qualificationList.push(qualificationToAdd);
        }
        self.flatQualificationHierarchy.splice(self.flatQualificationHierarchy.indexOf(qualificationToAdd), 1);
        // self.qualificationToAdd = undefined;
        self.updateChangeModel();
      }
    };

    self.editQualification = function (qualification) {
      var type = qualification.Type;

      if (qualification.onlyInherited && !qualification.pendingAction) {
        self.qualificationAdd(_.find(self.flatQualificationHierarchy, { QualificationId: qualification.QualificationId }, type));
      } else {
        self.openMemberQualificationModal(qualification, false, type);
      }
    };

    self.updateChangeModel = function () {
      $scope.qualificationChangeModel.add = [];
      if (self.displayMemberQualMode) {
        $scope.qualificationChangeModel.edit = [];
      }
      $scope.qualificationChangeModel.delete = [];
      if (self.qualificationList && self.qualificationList.length) {
        self.qualificationList.forEach(function (searchPendingQualifications) {
          if (searchPendingQualifications.pendingAction) {
            $scope.qualificationChangeModel[searchPendingQualifications.pendingAction].push(
              searchPendingQualifications[$scope.qualificationChangeProperty] || searchPendingQualifications
            );
          }
        });
      }
    };

    self.getShowElement = function (element) {
      var permissionByMode = self.displayMemberQualMode
        ? 'arno.personnel.dossier.qualification.manageAll'
        : ['arno.personnel.dossier.qualification.manageAll', 'arno.administration.personnel.activities.manage'];

      switch (element) { 
      case 'addQualification':
      case 'actions':      
        if (self.isOverviewTab) {
          return false;
        }
        if (Array.isArray(permissionByMode)) {
          var checks = [];
          permissionByMode.forEach(function (perm) {
            checks.push(permissions.isPermittedAnywhere(perm));
          });
          return _.compact(checks).length;
        }
        return permissions.isPermittedAnywhere(permissionByMode);
      }
    };

    self.checkExpired = function (expireDate) {
      if (expireDate && new Date(expireDate) < new Date()) {
        return true;
      }
      return false;
    };

    // VIEW-FUNCTIONS
    self.filterByValidity = function (validity) {
      // if no "validity" attribute is set for qualificationState, then all the contained qualification should be shown,
      // so treat them as Valid for the view, so they will be displayed
      if (validity != null) {
        return function (item) {
          return item.Valid === validity;
        };
      }

      return function () {
        return true;
      };
    };

    self.qualificationInRootOrg = function (qualification) {
      var formattedQualificationGroup =
        (self.formattedQualificationGroups && self.formattedQualificationGroups[qualification.GroupName]) || {};
      var mappedQualification = formattedQualificationGroup[qualification.Name || qualification.QualificationName] || {};

      return !mappedQualification.divisionId && !qualification.DivisionId;
    };

    self.openMemberQualificationModal = function (qualification, addMode, type) {
      var onCancelQualification = _.cloneDeep(qualification);
      $uibModal
        .open({
          controller: 'MemberQualificationModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/theme/components/qualificationList/memberQualificationModal/memberQualification.html',
          size: 'md',
          backdrop: 'static',
          resolve: {
            qualification: function () {
              return qualification;
            },
            flatQualificationHierarchy: function () {
              return (self.flatHierarchyByType && self.flatHierarchyByType[type]) || self.flatQualificationHierarchy;
            },
            type: function () {
              return type;
            },
            availableMaterials: function () {
              return $scope.instructionMaterials;
            },
            member: function () {
              return self.member;
            },
            instructingPerson: function (clientApi) {
              // load data to pre-fill picker correctly for edits
              if (!qualification) {
                return undefined;
              }

              if (qualification.InstructingMemberId) {
                return clientApi
                  .custom(
                    'model/DivisionMember',
                    'memberSelectorFind',
                  {
                    divisions: [self.divisionId],
                    searchById: qualification.InstructingMemberId,
                  },
                    { backgroundRequest: true }
                  )
                  .then(function (response) {
                    return {
                      type: 'member',
                      value: response && response[0],
                    };
                  });
              } else if (qualification.InstructingContactId) {
                return clientApi
                  .custom('model/Contact', 'getContactOneWithOrg', {
                    divisionIds: [self.divisionId],
                    contactId: qualification.InstructingContactId,
                    slim: true,
                  })
                  .then(function (response) {
                    return {
                      type: 'contact',
                      value: response,
                    };
                  });
              } else if (qualification.InstructingBusinessPartnerId) {
                return clientApi
                  .custom('model/BusinessPartner', 'searchBusinessPartners', {
                    searchById: qualification.InstructingBusinessPartnerId,
                    divisionId: self.divisionId,
                  })
                  .then(function (response) {
                    return {
                      type: 'organisation',
                      value: response && response[0],
                    };
                  });
              }
            },
            onFileDownload: function () {
              return self.viewOrDownloadFile;
            },
            onFilePreview: function () {
              return self.viewOrDownloadFile;
            },
            divisionIds: function () {
              return self.divisionId;
            },
          },
        })
        .result.then(function (result) {
          if (addMode) {
            self.qualificationAdd(result, true);
          } else {
            if (!qualification.pendingAction) {
              qualification.pendingAction = 'edit';
            }
            self.updateChangeModel();
          }
        })
        .catch(function () {
          _.merge(qualification, onCancelQualification);
        });
    };
    self.viewOrDownloadFile = function (qualification) {
      // here you will find some workarounds to make ressources available
      // which are otherwise blocked by permission System
      // this might not work in your case
      // however the permission System is too complex to be fixed at this point
      var divisionId = function () {
        if (qualification.DivisionId) return qualification.DivisionId;
        if (self.divisionId && self.divisionId.length) return self.divisionId;
        if (self.member.MainDivisionId) return self.member.MainDivisionId;
        return 'rootOrg';
      };

      return fileUtil.viewOrDownloadFile({
        divisionId: divisionId(),
        file: qualification.File,
        pathData: {
          memberId: self.member.id,
          qualificationId: qualification.ListId,
        },
        storageIdent: 'memberQualifications',
        ignoreDivPath: true,
        isOwnDossier: isOwnDossier
      });
    };
    self.fileHasPreview = fileUtil.fileHasPreview;

    // BOOTSTRAPPING, (not by ngjs $onInit lifecycle-hook)
    activate();
  }

  angular.module('BlurAdmin.theme.components').controller('qualificationListCtrl', qualificationListCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('qualificationList', qualificationList);

  /** @ngInject */
  function qualificationList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/qualificationList/qualificationList.html',
      scope: {
        qualificationListMemberData : '=?',
        qualificationList : '=',
        qualificationAdd : '=?',
        qualificationDelete : '=?',
        qualificationExclude : '=?',
        qualificationChangeModel : '=?',
        qualificationChangeProperty : '@',
        qualificationTranslations: '=?',
        qualificationType: '=?', 
        instructionMaterials: '=?',
        divisionIds: '=?',
        member: '<?',
        isOwnDossier: '<?',

        /** OPTIONAL: explicitly sets the states for the qualification-list. its an array.
         * As of 14.02.2019: The below given example structure is the default if you havent provided this binding! It may change...
         *
         * The properties in the objects have special meanings for the view:
         *
         * 'title' is shown in the section-header <h3>-tag of the view.
         * 'intext' is the text used e.g. to show the message for the user, that there are no qualifications.
         * 'validity' is used to filter the given qualificationList by its validity
         *
         * example STRUCTURE:
         * [
         *    { title: 'Aktive Qualifikationen', validity: true, intext: 'aktiven Qualifikationen' }
         *    { title: 'Inaktive Qualifikationen', validity: false, intext: 'inaktiven Qualifikationen'}
         * ]
         */
        qualificationStates: '<?',

        qualificationOnlyView : '=?',

        /** sets additional style-classes for certain view-elements, where it is necessary. e.g. the width for the add-qualificationbar at the bottom.
        * example STRUCTURE:
        * {
        *     addQualificationBottomBarClass: 'col-xs-12 col-sm-6 myadd-class'
        * }
        */
        cssConfigs : '<?',

        /** this forces the qualification-list comp to always be shown (the tables generated from qualificationStates are shown!),
        * even if there are no qualifications for the list - in that case the user is informed, that there are no qualifications.
        */
        alwaysShow : '<?',
      },
      compile: function (element, attrs) {
        if (!attrs.qualificationDelete) {
          attrs.qualificationDelete = 'false';
        }
        return {
          pre: function () {},
          post: function () {}
        };
      },
      controller: 'qualificationListCtrl as $qualListCtrl'
    };
  }

})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name ArnoPricesInputComponent
  *
  * @description Component provides a fieldset for prices input for external / internal prices
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoPricesInput', {
      templateUrl: 'app/theme/components/pricesInput/pricesInput.comp.html',
      controller: ArnoPricesInputController,
      controllerAs: '$pricesInputCtrl',
      bindings: {
        priceItem: '=',
        disabled: '<'
      }
    });

  /**
  * @description Controller for the prices-input component.
  *
  * @namespace BlurAdmin.theme.components.ArnoPricesInputController
  */
  /** @ngInject */
  function ArnoPricesInputController(
    validationUtils
  ) {
    var self = this;

    // VARS
    self.pricesSet = null; // NOTE: this is only a dummy field for the fieldset for "ui-validate" validation

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoPricesInputController#
    */
    function activate() {}

    // VIEW-FUNCTIONS
    self.validatePrices = function() {
      return validationUtils.checkRequiredPricesSet(self.priceItem);
    }

    self.isExternalPricesInvalid = function(pricesForm) {
      return pricesForm.$submitted && (pricesForm.pricesSet.$error || {}).atLeastOneExternalPrice;
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('arnoPermissionPopoverCtrl', arnoPermissionPopoverCtrl);

  /**
  * @description Controller for BlurAdmin.theme.components.arnoPermissionPopover
  * REMARK: atm this controller doesnt have functionality, it has been added for later extension
  *
  * @namespace BlurAdmin.theme.components.arnoPermissionPopoverCtrl
  */
  /** @ngInject */
  function arnoPermissionPopoverCtrl() {
    var $ctrl = this;

    function activate() {
      $ctrl.showIncludedPermissionsPopup = false;
      $ctrl.showDescriptionsArray = {};
    }

    // LIFE-CYCLE-HOOKS
    $ctrl.$onInit = function() {
      // init the controller
      activate();
    }

    // EVENT-HANDLERS

    // HELPERS
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    /**
    * @ngdoc component
    * @name arnoPermissionPopover
    *
    * @description Component is responsible to show a popover to inform about a permission/role and also provide descriptions for them as needed
    */
    .component('arnoPermissionPopover', {
      templateUrl: 'app/theme/components/permissionPopover/permissionPopover.tpl.html',
      controller: 'arnoPermissionPopoverCtrl as $permissionPopoverCtrl',
      bindings: {
        /** STRUCTURE of rolesPermissionData: {
         *  includedPermsContent: [
         *    {
         *      Name: 'Rolle vergeben',
         *      Description: 'Man kann Rollen vergeben',
         *      showPopupDescription: Boolean // this is only a helper var for showing popover permission description
         *    },
         *    {
         *      Name: 'Gliederungen verwalten',
         *      Description: 'Kann Gliederungen verwalten',
         *      showPopupDescription: Boolean // helper, option to show or hide the popover, used with ng-mouseleave, ng-mouseenter
         *    }
         * ]
         *  showIncludedPermissionsPopup: Boolean
         * }
         */
        rolesPermissionData: '=',

        // the text for the popover-trigger, usually its the permission-name
        permissionPopoverLabel: '<',

        // wrapper for the angular-ui popover-placement option
        permissionPopoverPlacement: '@',

        // option to always show ALL descriptions, regardless of the mouseenter
        permissionPopoverAlwaysDescription: '<',

        // force hide ALL descriptions (also if permissionPopoverAlwaysDescription is true)
        permissionPopoverForceHideDescriptions: '<',

        // use this and set to true, if there are issues with ng-mouseleave
        permissionPopoverUseMouseout: '<',

        // wrapper for the angular-ui popover-append-to-body option
        permissionPopoverAppendToBody: '<'
      }
    });
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('pageTop', pageTop);

  /* @ngInject */
  function PageTopCtrl($rootScope, $scope, $window, clientApi, toastr, commonUtils, $state, $translate, tmhDynamicLocale, APP_NG_LOCALES_MAPPING, permissions, notificationService) {
    var self = this;

    self.userLogout = function () {
      localStorage.removeItem('lastPath');
      clientApi.emit('auth/combined/logout');
      window.location.href = '/';
    };

    self.switchUserOrganization = function ($event, organization) {
      $event.preventDefault();
      $event.stopPropagation();

      commonUtils.setTargetOrganizationCookie(organization.id);

      var currentSubdomain = commonUtils.getSubdomainFromHost();
      var redirectUrl = document.location.href;
      if (organization.subdomain) {
        redirectUrl = document.location.href.replace('//' + (currentSubdomain && (currentSubdomain + '.') || ''), '//' + organization.subdomain + '.');
      } else if (currentSubdomain) {
        redirectUrl = $rootScope.ctx.hostAddress;
      }
      if (redirectUrl === document.location.href) {
        $window.location.assign('/');
      } else {
        document.location.href = redirectUrl.split('#!')[0];
      }
    };
    self.showResourceMapLink = function () {
      return window.location && window.location.hash.includes('#!/material');
    };
    self.openDossier = function () {
      commonUtils.dossier.open('rootOrg', $rootScope.ctx.currentUser.eMail);
    };
    self.openOwnBaseData = function () {
      $state.go('arno.personnel.dossier.baseData', { memberEMail: $rootScope.ctx.currentUser.eMail }, { reload: true });
    };
    self.openOwnHelperHours = function () {
      $state.go('arno.personnel.dossier.helperHours', { memberEMail: $rootScope.ctx.currentUser.eMail }, { reload: true });
    };
    self.openAllEvents = function () {
      $state.go('arno.events.overview', { memberEMail: $rootScope.ctx.currentUser.eMail }, { reload: true });
    };

    self.goBigOrGoHome = function () {
      $state.go('arno.dashboard', {}, { reload: true });
    };

    self.openHelp = function () {
      $window.open($rootScope.ctx.HelpLink, '_blank');
    }

    self.switchLanguage = function ($event, lng) {
      $event.preventDefault();
      $event.stopPropagation();
      if (self.isActiveLanguage(lng)) {
        return;
      }
      // update account settings
      return clientApi.custom('model/Account', 'updatePreferredLanguage', { langKey: lng })
        .then(function () {
          // additional refresh to prevent problems with open editing dialogs
          return $state.reload();
        })
        .then(function () {
          tmhDynamicLocale.set(APP_NG_LOCALES_MAPPING[lng]);

          return $translate.use(lng);
        })
        .then(function () {
          toastr.success($translate.instant('components.pageTop.languageSettingsChanged'), $translate.instant('components.pageTop.changeLanguage'));
          $state.reload();
        })
        .catch(function () {
          toastr.info($translate.instant('components.pageTop.languageSettingsCantChanged'), $translate.instant('components.pageTop.failedChanges'));
        });
    }

    self.isActiveLanguage = function (lng) {
      return lng === $translate.use();
    }

    self.isPermittedAnywhere = function (action) {
      return permissions.isPermittedAnywhere(action);
    }

    self.openOwnAdministration = function () {
      $state.go('arno.personnel.dossier.administration', { memberEMail: $rootScope.ctx.currentUser.eMail }, { reload: true });
    };

    $scope.$watch(function () {
      return $scope.stateCurrentName
    }, function () {
      self.isDashboard = $scope.stateCurrentName === 'arno.dashboard';
      self.isArnoOrg = $rootScope.ctx.organization.current.id === 1
    })

    $scope.$watch(function () {
      return $scope.activePageTitle
    }, function () {
      if ($scope.stateCurrentName === 'arno.dashboard' && $rootScope.ctx.currentUser.firstName) {
        $scope.activePageTitle = {
          title: 'navigation.dashboardGreeting',
          params: { name: $rootScope.ctx.currentUser.firstName }
        }
      }

      // workaround, ß is - literally defined to be by JS' unicode standard - replaced by SS when we uppercase it
      // so we replace it with it's special uppercase variant ẞ so that we can accurately replace that with the correct ß again
      if ($scope.activePageTitle) {
        if (typeof $scope.activePageTitle === 'object') {
          $scope.translatedPageTitle = $translate.instant($scope.activePageTitle.title, $scope.activePageTitle.params)
            .replace(/ß+?/gmi, 'ẞ').toLocaleUpperCase().replace(/ẞ+?/gmi, 'ß');
        } else {
          $scope.translatedPageTitle = $translate.instant($scope.activePageTitle)
            .replace(/ß+?/gmi, 'ẞ').toLocaleUpperCase().replace(/ẞ+?/gmi, 'ß');
        }
      }
    })

    $scope.availableLanguages = $rootScope.availableLanguages;


    function activatePushSubscription() {
      clientApi.custom('model/NotificationPreference', 'findByMemberId', { cMemberId: $rootScope.ctx.currentUser.id })
        .then(function (preference) {
          if (!Object.keys(preference).length || (preference.Events && preference.Events != 'EMAIL') || (preference.Services && preference.Services != 'EMAIL')) {
            notificationService.subscribe();
          }
        })
    }

    self.$onInit = function () {
      activatePushSubscription();
    }
  }

  /** @ngInject */
  function pageTop($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: PageTopCtrl,
      controllerAs: '$ctrl',
      link: function ($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = ($state.current.dynamicTitle || $state.current.title || '')
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('onRender', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          $timeout(function () {
            scope.$eval(attrs.onRender);
          }, 0);
        }
      };
    });
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('baModalService', baModalService)
    .component('baModalComp', baModalComponent);

  function baModalComponent() {
    // Base baModal component
    return {
      template: 'app/theme/components/modals/messageModal.tpl.html',
      controller: 'baModalCtrl as $baModalCtrl',
      bindings: {
        modalType: '<',

        title: '<',
        content: '<',

        primaryActionText: '<',
        primaryActionHandler: '<',

        selectionOptions: '<',
        textInput: '<',

        secondaryActionText: '<',
        secondaryActionHandler: '<',

        closeable: '<',
      }
    };
  }

  /**
   * @name baModalService
   *
   * @description This service for blur-admin provides several methods to show standard-modals, like message-modal/prompts...
   *
   */
  /** @ngInject */
  function baModalService($q, $uibModal) {
    var self = this;

    /**
     * @name messageModal
     *
     * @description This method shows a standard-modal with header-title, content-text and options to have primary/secondary-buttons
     *
     * REMARK: the button for which the text is not given (primrayActionText / secondaryActionText) is not shown,
     * this way you can customize the number of buttons/actions
     */
    self.messageModal = function(data, options) {
      options = options || {};

      return $uibModal.open({
        controller: 'baModalCtrl as $baModalCtrl',
        animation: true,
        backdrop: data.closable ? true : 'static',
        templateUrl: 'app/theme/components/modals/messageModal.tpl.html',
        size: options.size || 'md',
        resolve: {
          modalData: data,
        },
        allowDoubleOpening: data.allowDoubleOpening || undefined,
      }).result;
    };

    /**
     * @name exportModal
     *
     * @description This method shows a standard-export-modal with a select to choose the file-type (e.g. excel and csv)
     * and the option to restrict the export or use all data
     *
     */
    self.exportModal = function(data, options) {
      options = options || {};

      return $uibModal.open({
        controller: 'baExportModalController as $baExportModalCtrl',
        animation: true,
        templateUrl: 'app/theme/components/modals/exportModal/exportModal.tpl.html',
        size: options.size || 'md',
        resolve: {
          modalData: data,
          exportPrivacyNoteContent: function(clientApi) {
            return clientApi.custom('model/ExportPrivacyNote', 'getLatest', {});
          },
        }
      }).result;
    };
  }

})();

(function(){
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('baModalCtrl', baModalController);

  function baModalController(
    $uibModalInstance, $sce,
    modalData
  ) {
    var $ctrl = this;

    function activate() {
      // REMARK: the properties added in modalData have priority over the component-bindings for the component
      // this way you can override the modal component-bindings in your view even in runtime!
      assignModalData();

      $ctrl.modalType = $ctrl.modalType || 'info';
      $ctrl.allowHtml = $ctrl.allowHtml || false;
    }

    // LIFE-CYCLE-HOOKS
    $ctrl.$onInit = function() {
      // init the controller
      activate();
    }

    // EVENT-HANDLERS
    $ctrl.clickedPrimaryAction = function() {
      if (typeof $ctrl.primaryActionHandler === 'function') {
        return $ctrl.primaryActionHandler.call($ctrl, $uibModalInstance);
      }

      if ($ctrl.selectionOptions) {
        return $uibModalInstance.close($ctrl.selectedOption);
      }

      if ($ctrl.textInput) {
        return $uibModalInstance.close($ctrl.textInputValue);
      }

      // REMARK: most of the time the secondary button will be the close or cancel button, so if no action is given for it
      // then assume the std. close-action !!!
      return $uibModalInstance.close({
        action: 'BA_MODAL_PRIMARY_BTN_CLICKED',
      });
    };

    $ctrl.clickedSecondaryAction = function() {
      if (typeof $ctrl.secondaryActionHandler === 'function') {
        return $ctrl.secondaryActionHandler.call($ctrl, $uibModalInstance);
      }

      // REMARK: most of the time the secondary button will be the close or cancel button, so if no action is given for it
      // then assume the std. close-action !!!
      return $uibModalInstance.dismiss({
        action: 'BA_MODAL_SECONDARY_BTN_CLICKED',
      });
    };

    $ctrl.clickedClose = function() {
      return $uibModalInstance.dismiss({
        action: 'BA_MODAL_CLOSE_BTN_CLICKED',
      });
    };

    // HELPERS
    function assignModalData() {
      if (modalData) {
        $ctrl.modalType = modalData.modalType || $ctrl.modalType;
        $ctrl.allowHtml = modalData.allowHtml || $ctrl.allowHtml;

        $ctrl.textInput = modalData.textInput || $ctrl.textInput || false;

        $ctrl.selectionOptions = modalData.selectionOptions || $ctrl.selectionOptions || false;
        if ($ctrl.selectionOptions) {
          $ctrl.selectedOption = _.find($ctrl.selectionOptions, {defaultSelected: true}) || undefined;
        }

        $ctrl.title = modalData.title || $ctrl.title;
        $ctrl.content = modalData.content || $ctrl.content;
        if ($ctrl.allowHtml === true) {
          $ctrl.title = $sce.trustAsHtml(modalData.title);
          $ctrl.content = $sce.trustAsHtml(modalData.content);
        }

        $ctrl.primaryActionText = modalData.primaryActionText || $ctrl.primaryActionText;
        $ctrl.primaryActionHandler = modalData.primaryActionHandler || $ctrl.primaryActionHandler;

        $ctrl.secondaryActionText = modalData.secondaryActionText || $ctrl.secondaryActionText;
        $ctrl.secondaryActionHandler = modalData.secondaryActionHandler || $ctrl.secondaryActionHandler;

        $ctrl.closeable = modalData.closeable || $ctrl.closeable;
      }
    }
  }
})();

(function () {
  'use strict';

  /** @ngInject */
  function memberSelectorCtrl($rootScope, $scope, clientApi) {
    var self = this;

    self.onMemberSelect = $scope.onMemberSelect;
    self.divisions = $scope.divisions;
    self.memberExclude = $scope.memberExclude || [];
    self.onlyActive = !!$scope.onlyActive;
    self.explicitQualifications = !!$scope.explicitQualifications;
    self.organizationScope = !!$scope.organizationScope;
    self.azure = !!$scope.azure;
    self.members = [];
    self.searchTerm = $scope.searchTerm;
    self.blankSearchOnClick = $scope.blankSearchOnClick;
    self.parentSelectedMember = $scope.selectedMember;
    self.selectedMember = $scope.initialMemberValue;
    self.enableDelete = $scope.enableDelete;

    $scope.$watch(function () {
      return self.selectedMember;
    }, function () {
      if (self.selectedMember && angular.isFunction(self.onMemberSelect)) {
        if (!self.selectedMember.none) {
          self.onMemberSelect(self.selectedMember);
        }
        if (self.enableDelete && self.selectedMember.none) {
          self.selectedMember = undefined;
          self.onMemberSelect(self.selectedMember);
        }
        if (!self.parentSelectedMember && !$scope.keepAfterSelection) {
          self.selectedMember = undefined;
        }
      }

      if (self.parentSelectedMember) {
        self.parentSelectedMember.value = self.selectedMember;
      }
    });

    $scope.$watch(function () {
      return self.parentSelectedMember;
    }, function () {
      if (self.parentSelectedMember) {
        self.selectedMember = self.parentSelectedMember.value;
      }
    }, true);

    $scope.$watch(function () {
      return $scope.memberExclude
    }, function () {
      self.memberExclude = $scope.memberExclude
      self.searchMembers();
    })

    self.groupByFirstName = function (member) {
      if (member && member.Member && member.Member.initials) {
        return member.Member.initials.charAt(0);
      }
    };

    self.searchMembers = function (searchTerm) {
      if (!searchTerm && !self.blankSearchOnClick) {
        self.members = [];
        return null;
      } else if (self.blankSearchOnClick && !searchTerm) {
        searchTerm = '';
      }
      // todo: refactor organizationId
      if (self.organizationScope) {
        if (self.azure) {
          return clientApi.post('personnel/searchAzureAD',
            {
              search: searchTerm,
              exclude: self.memberExclude
            })
            .then(function (results) {
              if (results && results.length) {
                self.members = results.map(function (result) {
                  return {
                    Type: 'azure',
                    Member: {
                      Account: {
                        EMail: result.userPrincipalName || result.mail,
                        Type: 'azure',
                      },
                      id: result.objectId || result.id,
                      FirstName: result.givenName || result.FirstName || result.displayName || result.mailNickname,
                      LastName: result.surname || result.LastName,
                      fullName: result.displayName,
                    },
                    Division: {
                      Name: null
                    }
                  }
                });
              } else {
                self.members = [{ none: true }];
              }
            });
        } else {
          return clientApi
            .custom('model/Member', 'memberSelectorFind', { memberExclude: self.memberExclude, searchTerm: searchTerm }, { backgroundRequest: true })
            .then(function (results) {
              if (results && results.length) {
                self.members = results.map(function (result) {
                  return {
                    Type: 'local',
                    Member: result,
                    Division: {
                      Name: null
                    }
                  }
                });
              } else {
                self.members = [{ none: true }];
              }
            });
        }
      } else {
        if (!Array.isArray(self.divisions)) {
          self.divisions = [self.divisions];
        }
        return clientApi
          .custom('model/DivisionMember', 'memberSelectorFind', {
            divisions: self.divisions,
            onlyActive: self.onlyActive,
            memberExclude: self.memberExclude,
            searchTerm: searchTerm,
            withExplicitQualifications: self.explicitQualifications
          }, { backgroundRequest: true })
          .then(function (result) {
            if (result && result.length) {
              self.members = result;
            } else {
              self.members = [{ none: true }];
            }
          });
      }
    };
    /* TODO fill in the search term into the input field after invite base date where provided
    if($scope.searchTerm){
      $scope.focus();
      self.searchMembers($scope.searchTerm);
    }*/

    self.disabled = $scope.disabled;
    $scope.$watch(function () {
      return $scope.disabled;
    }, function () {
      self.disabled = $scope.disabled;
    });
  }

  angular.module('BlurAdmin.theme.components')
    .controller('memberSelectorCtrl', memberSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('memberSelector', memberSelector);

  /** @ngInject */
  function memberSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/memberSelector/memberSelector.html',
      scope: {
        divisions: '=',
        memberExclude: '=',
        onMemberSelect: '=',
        selectedMember : '=?',
        onlyActive: '=',
        explicitQualifications: '=?',
        organizationScope: '=?',
        azure: '=?',
        searchTerm: '=?',
        blankSearchOnClick: '=',
        keepAfterSelection: '=?',
        initialMemberValue: '=?',
        enableDelete: '=?',
        disabled:'=ngDisabled',
      },
      controller: 'memberSelectorCtrl as $memSelCtrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function memberGroupSelectorCtrl($rootScope, $scope, clientApi) {
    var self = this;

    self.onMemberGroupSelect = $scope.onMemberGroupSelect;
    self.memberExclude = $scope.memberExclude || [];
    self.explicitQualifications = !!$scope.explicitQualifications;
    self.azure = !!$scope.azure;
    self.groups = [];
    self.parentSelectedMemberGroup = $scope.selectedMemberGroup;

    self.pauseWatch = false;

    $scope.$watch(function () {
      return self.selectedMemberGroup;
    }, function () {
      if (self.selectedMemberGroup && angular.isFunction(self.onMemberGroupSelect)) {
        if (!self.selectedMemberGroup.none) {
          self.onMemberGroupSelect(self.selectedMemberGroup);
        }
        if (!self.parentSelectedMemberGroup) {
          self.selectedMemberGroup = undefined;
        }
      }
      if (self.parentSelectedMemberGroup) {
        self.parentSelectedMemberGroup.value = self.selectedMemberGroup;
      }
    });

    $scope.$watch(function () {
      return self.parentSelectedMemberGroup;
    }, function () {
      if (self.parentSelectedMemberGroup) {
        self.selectedMemberGroup = self.parentSelectedMemberGroup.value;
      }
    }, true);

    self.searchGroups = function (searchTerm) {
      if (!searchTerm) {
        self.groups = [];
        return null;
      }
      // todo: refactor organizationId
      if (self.azure) {
        return clientApi.post('personnel/searchAzureAD',
          {
            search: searchTerm,
            group: true,
          })
          .then(function (results) {
            if (results && results.length) {
              self.groups = results.map(function (result) {
                if(self.memberExclude.indexOf(result.objectId) === -1){
                  return {
                    Type: 'azureGroup',
                    id: result.objectId,
                    Name: result.displayName,
                  }
                }
                return {
                  Name: result.displayName,
                  exists: true,
                }
              });
            } else {
              self.groups = [{ none: true }];
            }
          });
      } else {
        return clientApi
          .custom('model/MemberGroup', 'memberGroupSelectorFind', {
            divisions: $scope.divisions,
            searchTerm: searchTerm,
            withExplicitQualifications: self.explicitQualifications
          })
          .then(function (result) {
            if (result && result.length) {
              self.groups = result;
            } else {
              self.groups = [{ none: true }];
            }
          });
      }
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('memberGroupSelectorCtrl', memberGroupSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('memberGroupSelector', memberGroupSelector);

  /** @ngInject */
  function memberGroupSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/memberGroupSelector/memberGroupSelector.html',
      scope: {
        divisions : '=',
        onMemberGroupSelect : '=',
        selectedMemberGroup : '=?',
        explicitQualifications : '=?',
        memberExclude: '=',
        azure: '=?',
      },
      controller: 'memberGroupSelectorCtrl as $memGrpSelCtrl'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .component('arnoMaterialTypesTreeView', {
      templateUrl: 'app/theme/components/materialTypesTreeView/materialTypesTreeView.comp.html',
      controller: ArnoMaterialTypesTreeViewController,
      controllerAs: '$materialTypesTreeViewCtrl',
      transclude: {
        'top-buttons': 'topButtons',
        'bottom-buttons': 'bottomButtons',
      },
      bindings: {
        materialTypesTreeData: '=',
        selectedMaterialType: '=',
        treeOptions: '=',
        onSelectNode: '<',
      },
    });

  function ArnoMaterialTypesTreeViewController(commonUtils) {
    var self = this;

    self.treeviewCollapsed = false;

    self.toggleCollapsed = function() {
      self.treeviewCollapsed = !self.treeviewCollapsed;
      commonUtils.recurseTree(self.materialTypesTreeData, function (node) {
        node.collapsed = !node.collapsed;
      })
    };

    self.getIcon = function(materialType) {
      if(materialType.OverwrittenMaterialTypeId) {
        return 'fa fa-clone';
      } else if (materialType.DivisionId && materialType.DivisionId !== 'rootOrg') {
        return 'fa fa-sitemap';
      } else {
        return 'fa fa-users';
      }
    };

    self.$onInit = function() {

    }
  }
})();
(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoMaterialTypesPricesTreeviewComponent
  *
  * @description Component provides a tree-view with pre-defined arno elements like expand/collapse button,
  * or a std-tree-component for material-types
  */
  angular.module(
    'BlurAdmin.theme.components.materialTypesPricesTreeview',
    ['BlurAdmin.theme.components.baTreeview'],
    function($rootScopeProvider) {
      // IMPORTANT: set the max digest-cycle loops from 10 (STANDARD by angularjs) to 20
      // to allow a max deep of the nested nodes level of the angular-ui-tree
      // ADJUST this if you encounter users create a tree with a level-dept of larger than 20....
      $rootScopeProvider.digestTtl(20);
    })
    .component('arnoMaterialTypesPricesTreeview', {
      templateUrl: 'app/theme/components/materialTypesPricesTreeview/materialTypesPricesTreeview.comp.html',
      controller: ArnoMaterialTypesPricesTreeviewController,
      controllerAs: '$materialTypesPricesTreeviewCtrl',
      bindings: {
        selectedCtx: '<?',
        materialTypesTreeData: '=',

        selectedNode: '=',
        nodeSelect: '&?',

        addHandler: '&?',
        editHandler: '&?',

        uiConfig: '<',

        isLoading: '<',
        hasError: '<?'
      }
    });


  /**
  * @description Controller for the materialTypes-treeview component.
  *
  * @namespace BlurAdmin.theme.components.ArnoMaterialTypesPricesTreeviewController
  */
  /** @ngInject */
  function ArnoMaterialTypesPricesTreeviewController(
    $scope, $translate,
    validationUtils
  ) {
    var self = this;

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoMaterialTypesPricesTreeviewController#
    */
    function activate() {}

    // VIEW-FUNCTIONS
    self.hasPriceDefinition = validationUtils.hasValidPriceDefinition;

    // EVENT-HANDLERS
    self.clickedMaterialTypeItemAdd = function(node, event) {
      event.stopPropagation();

      // you could also use angular.isFunction here
      if (typeof self.addHandler === 'function') {
        // the consumer decides what to do, this is only a wrapper for the button
        self.addHandler.call(self)(node);
      }
    }

    self.clickedMaterialTypeItemEdit = function(node, event)  {
      event.stopPropagation();

      // you could also use angular.isFunction here
      if (typeof self.editHandler === 'function') {
        // the consumer decides what to do, this is only a wrapper for the button
        self.editHandler.call(self)(node);
      }
    }

    // CONTROLLER-INIT
    self.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /** @ngInject */
  function invoiceExportInputCtrl($scope, clientApi, toastr, $translate, $state) {
    var self = this;
    self.hasDbVal = !!$scope.invoiceExportRecipient;
    self.invoiceExportSuffixes = ($scope.invoiceExportSettings || {}).AllowedInvoiceMailSuffixes || [];
    self.fullInvoiceExportEmail = '';
    self.invoiceExportRecipient = $scope.invoiceExportRecipient;
    self.invoiceExportCtx = $scope.invoiceExportCtx;

    $scope.$watch(function() {
      return $scope.invoiceExportCtx;
    }, function(newVal) {
      self.invoiceExportCtx = newVal;
    })

    $scope.$watch(function() {
      return $scope.invoiceExportRecipient + $scope.version;
    }, function() {
      if ($scope.invoiceExportRecipient) {
        self.fullInvoiceExportEmail = $scope.invoiceExportRecipient || '';
        var split = $scope.invoiceExportRecipient.split('@');
        self.invoiceExportMailSuffix = _.last(split);
        self.invoiceExportMailPrefix = _.first(split);
      } else {
        self.invoiceExportRecipient = null;
        self.invoiceExportMailSuffix = null;
        self.invoiceExportMailPrefix = null;
      }
    })

    $scope.$watch(
      function() {
        if (!self.invoiceExportMailPrefix || !self.invoiceExportMailSuffix || self.invoiceExportSuffixes.indexOf(self.invoiceExportMailSuffix) === -1) {
          return null;
        }
        return self.invoiceExportMailPrefix + '@' + self.invoiceExportMailSuffix;
      },
      function(newVal) {
        // simple regex to catch common oopsies
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newVal)) {
          self.fullInvoiceExportEmail = null;
        } else {
          self.fullInvoiceExportEmail = newVal;
        }
      }
    )

    self.saveRecipientMail = function(copyToSubDiv, setNull) {
      return clientApi
        .custom('model/Division', 'saveInvoiceExportRecipient', {
          mail: setNull ? null : self.fullInvoiceExportEmail,
          divisionId: self.invoiceExportCtx,
          copyToSubDivs: copyToSubDiv,
        })
        .then(function () {
          if (setNull) {
            toastr.success(
              $translate.instant('modules.administration.finances.general.deleteMailSuccessBody'),
              $translate.instant('modules.administration.finances.general.deleteMailSuccessTitle')
            )
          } else {
            toastr.success(
              $translate.instant(copyToSubDiv ? 
                'modules.administration.finances.general.exportRecipientCopiedBody' : 'modules.administration.finances.general.exportRecipientSavedBody'),
              $translate.instant(copyToSubDiv ? 
                'modules.administration.finances.general.exportRecipientCopiedTitle' : 'modules.administration.finances.general.exportRecipientSavedTitle')
            );
          }
        })
        .catch(function () {
          if (setNull) {
            toastr.success(
              $translate.instant('modules.administration.finances.general.deleteMailFailedBody'),
              $translate.instant('modules.administration.finances.general.deleteMailFailedTitle')
            )
          } else {
            toastr.error(
              $translate.instant(copyToSubDiv ? 
                'modules.administration.finances.general.exportRecipientCopiedFailedBody' : 'modules.administration.finances.general.exportRecipientSaveFailedBody'),
              $translate.instant(copyToSubDiv ? 
                'modules.administration.finances.general.exportRecipientCopiedFailedTitle' : 'modules.administration.finances.general.exportRecipientSaveFailedTitle')
            );
          }
        })
        .then(function () {
          $state.reload();
        })
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('invoiceExportInputCtrl', invoiceExportInputCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('invoiceExportInput', invoiceExportInput);

  /** @ngInject */
  function invoiceExportInput() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/invoiceExportMailInput/invoiceExportMailInput.html',
      scope: {
        invoiceExportRecipient: '=',
        invoiceExportSettings: '=',
        invoiceExportCtx: '=',
        version: '=',
      },
      controller: 'invoiceExportInputCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('inspectionSelector', inspectionSelector);

  /** @ngInject */
  function inspectionSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/inspectionSelector/inspectionSelector.html',
      scope: {
        selectedInspection: '=',
        ctx: '=?',
        onlyDivision: '=?',
        excludedIds: '=?',
        multiple: '=?',
        pickFromSelectedMaterialId: '=',
        materialModel: '=?',
        disabled:'=ngDisabled',
      },
      controller: 'inspectionSelectorCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function inspectionSelectorCtrl($scope, clientApi) {
    var self = this;
    self.divisionId = $scope.ctx;
    self.onlyDivision = $scope.onlyDivision;
    self.excludedIds = $scope.excludedIds;
    self.disabled = $scope.disabled;
    $scope.$watch(function () {
      return $scope.disabled;
    }, function () {
      self.disabled = $scope.disabled;
    });
    self.multiple = $scope.multiple;
    self.materialModel = $scope.materialModel;
    self.pickFromSelectedMaterialId = $scope.pickFromSelectedMaterialId;
    self.selectedInspection = $scope.selectedInspection && $scope.selectedInspection.Name ? $scope.selectedInspection : null;
    if (self.multiple) {
      self.selectedInspection = $scope.selectedInspection || [];
    }
    self.inspections = $scope.selectedInspection || [];

    $scope.$watch(function () {
      return self.selectedInspection;
    }, function () {
      $scope.selectedInspection = self.selectedInspection;
    })

    self.fetchInspections = function(queryText) {
      if (self.disabled) {
        return;
      }

      var promise = Promise.resolve();

      if (self.pickFromSelectedMaterialId && self.materialModel) {
        var queryWishes = {
          paging: {
            offset: 0,
            limit: 10,
          },
          order: {
            by: 'SelectorOrder',
            reverse: true,
          }
        };
        if (queryText) {
          queryWishes.search['Inspection.Name'] = queryText;
        }
        promise = clientApi.custom('model/' + self.materialModel + 'Inspection', 'getAssignedInspections', {
          queryWishes: queryWishes,
          divisionId: self.divisionId,
          materialId: self.pickFromSelectedMaterialId,
          onlyMandatory: false,
        })
        .then(function(res) {
          return res.rows.map(function(r) {
            return _.assign(r.Inspection, { Interval: r.Interval });
          });
        })
      } else {
        promise = clientApi.custom('model/Inspection', 'inspectionSelectorFind', {
          divisionId: self.divisionId || null,
          queryText: queryText || null,
          onlyDivision: self.onlyDivision,
          excludedIds: self.excludedIds,
        });
      }

      return promise
        .then(function (results) {
          if (!results.length) {
            self.inspections = [{ none: true }]
          } else {
            self.inspections = _.differenceBy(results, Array.isArray(self.selectedInspection) ? self.selectedInspection : [self.selectedInspection], 'id');
          }
        })
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('inspectionSelectorCtrl', inspectionSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('input', addCustomNumberSpinnerControls);

  /** @ngInject */
  
  function addCustomNumberSpinnerControls($parse) {
    return {
      restrict: 'E',
      link: function (scope, element, attrs) {
        if (!attrs.decimal && (attrs.type === 'number' && attrs.class.indexOf('inherit-spinbutton') === -1)) {
          element.removeClass('form-control');
          element.wrap('<div class=\'number-spinner ' + attrs.class + '\'></div>');
          var decreaser = $('<button type="button" class=\'decrease btn\'><i class=\'ion-minus\'></i></button>');
          var increaser = $('<button type="button" class=\'increase btn\'><i class=\'ion-plus\'></i></button>');
          scope.$watch(function() {
            return $parse(attrs.ngDisabled)(scope);
          }, function(disabled) {
            if (disabled) {
              decreaser.addClass('arno-not-allowed');
              increaser.addClass('arno-not-allowed');
              element.addClass('arno-not-allowed');
            } else {
              decreaser.removeClass('arno-not-allowed');
              increaser.removeClass('arno-not-allowed');
              element.removeClass('arno-not-allowed');
            }
            decreaser.prop('disabled', disabled);
            increaser.prop('disabled', disabled);
          });
          var step = 1;
          if (attrs.step !== undefined) {
            step = attrs.step;
          }
          if (attrs.controlStep !== undefined) {
            step = attrs.controlStep;
          }
          var parseValue = function(v, step) {
            var value;
            var splitStep;
            var decimalCount;
            if (step) {
              splitStep = step.toString().split('.');
              decimalCount = splitStep[1] && splitStep[1].length;
            }
            if (decimalCount) {
              value = parseFloat(v).toFixed(decimalCount);
            } else {
              value = parseInt(v, 10);
            }
            return value;
          }
          var doAdd = function(v, step) {
            var value;
            var splitStep;
            var decimalCount;
            if (step) {
              splitStep = step.toString().split('.');
              decimalCount = splitStep[1] && splitStep[1].length;
            }
            if (decimalCount) {
              value = parseFloat(parseFloat(v).toFixed(decimalCount)) + parseFloat(step);
            } else {
              value = parseInt(v, 10) + parseInt(step);
            }
            return value;
          }
          decreaser.on('click', function() {
            var value = parseValue(element.val(), step);
            value = isNaN(value) ? 0 : value;
            if (attrs.min !== undefined) {
              if (value-step >= attrs.min) value = value-step;            
            } else {
              value = value-step;
            }
            element.val(parseValue(value, step));
            element.trigger('input');
          });
          increaser.on('click', function() {
            var value = parseValue(element.val(), step);
            value = isNaN(value) ? 0 : value;
            if (attrs.max !== undefined) {
              if (value+step <= attrs.max) value = parseInt(value)+parseInt(step);
            } else {
              value = doAdd(value, step);
            }
            element.val(parseValue(value, step));
            element.trigger('input');
          });
          element.before(decreaser);
          element.after(increaser);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoHistoryDisplay
  *
  * @description this component provides history display functionality
  */
  angular.module('BlurAdmin.theme.components.historyDisplay', [])
    .component('historyDisplay', {
      bindings: {
        mode: '@',
        isOrg: '=',
        historyData: '=',
        fetchHistoryData: '<'
      },
      templateUrl: 'app/theme/components/historyDisplay/historyDisplay.tpl.html',
      controller: 'historyDisplayController'
    })
    .value('historyEventMap', {
      'WITHDRAWAL_TRIGGERED': {
        label: 'Löschantrag gestellt',
        logTemplate: 'Grund "<strong>{{data.SelectedReasonName}}</strong>". ',
      },
      'WITHDRAWAL_CANCELED': {
        label: 'Löschantrag abbgebrochen',
        logTemplate: 'Mitglied wurde nicht gelöscht',
      },
      'WITHDRAWAL_PROCESSED': {
        label: 'Löschantrag ausgeführt',
        logTemplate: 'Mitglied entfernt',
      },
      'ACTIVITY_PERIOD_ALLOCATION': {
        label: 'Zuweisung Tätigkeitszeitraum',
        logTemplate: 'Zeiträume für "<strong>{{data.ActivityTitle}}</strong>" aktualisiert. ',
        tags: function (data) {
          if (data.updatedPeriods && data.updatedPeriods.length) {
            var deleted = data.updatedPeriods.filter(function (period) {
              return period.pendingDelete;
            }).length;
            var checkedUpdated = data.updatedPeriods.filter(function (period) {
              return period.id;
            }).length;
            var created = data.updatedPeriods.length - (deleted + checkedUpdated);
            var result = [];
            if (deleted) {
              result.push({ type: 'danger', label: deleted + ' Periode' + (deleted > 1 ? 'n' : '') + ' gelöscht' });
            }
            if (checkedUpdated) {
              result.push({ type: 'info', label: checkedUpdated + ' Periode' + (checkedUpdated > 1 ? 'n' : '') + ' geprüft' });
            }
            if (created) {
              result.push({ type: 'success', label: created + ' Periode' + (created > 1 ? 'n' : '') + ' erstellt' });
            }
            return result;
          }
          return [];
        },
      },
      'ACTIVITY_ALLOCATION': {
        label: 'Tätigkeitszuweisung',
        logTemplate: 'Tätigkeit "<strong>{{data.ActivityTitle}}</strong>" zugewiesen. ',
      },
      'ACTIVITY_ALLOCATION_DELETE': {
        label: 'Löschen Tätigkeitszuweisung',
        logTemplate: 'Tätigkeitszuweisung "<strong>{{data.ActivityTitle}}</strong>" gelöscht. ',
      },
      'ACTIVITY_CHARACTERISITC_ALLOCATION': {
        label: 'Zuweisung Tätigkeitsmerkmal',
        logTemplate: 'Tätigkeit "<strong>{{data.ActivityTitle}}</strong>" durch Auswahl des Merkmals "{{data.mappedCharacteristic}}" bestätigt. ',
        dataHelper: function (data, $injector) {
          var charMap = $injector.get('characteristicMap');
          data.mappedCharacteristic = charMap[data.Characteristic];
          data.MappedCharacteristic = data.mappedCharacteristic;
          data.mappedCharacteristic = data.mappedCharacteristic.charAt(0).toLocaleLowerCase() + data.mappedCharacteristic.slice(1);
        },
        tags: function (data) {
          return [
            { type: 'info', label: data.MappedCharacteristic }
          ];
        },
      },
      'FILE_UPLOAD': {
        label: 'Dateiupload',
        logTemplate: 'Datei "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) wurde in "<strong>{{data.Folder}}</strong>" hochgeladen. ',
        tags: function () {
          return [
            { type: 'success', label: 'Upload' }
          ];
        },
      },
      'FILE_OVERWRITE': {
        label: 'Datei überschrieben',
        logTemplate: 'Datei "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) wurde in "<strong>{{data.Folder}}</strong>" überschrieben. ',
        tags: function () {
          return [
            { type: 'info', label: 'Überschreiben' }
          ];
        },
      },
      'FILE_DELETE': {
        label: 'Datei gelöscht',
        logTemplate: 'Datei "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) wurde in "<strong>{{data.Folder}}</strong>" gelöscht. ',
        tags: function () {
          return [
            { type: 'danger', label: 'Löschen' }
          ];
        },
      },
      'FILE_RENAME': {
        label: 'Datei umbenannt',
        logTemplate: 'Datei "<strong>{{data.OldName}}</strong>" wurde innerhalb von "<strong>{{data.Folder}}</strong>" in "<strong>{{data.NewName}}</strong>" umbenannt. ',
        tags: function () {
          return [
            { type: 'info', label: 'Umbenennung' }
          ];
        },
      },
      // TRAININGS-SPECIFIC LOGS
      'TRAINING_CREATE': {
        label: 'Fortbildung erstellt',
        logTemplate: '"<strong>{{data.Name}}</strong>" wurde erstellt.',
        tags: function () {
          return [
            { type: 'success', label: 'Erstellt'},
          ];
        },
        dataHelper: function () {}
      },
      'TRAINING_UPDATE': {
        label: 'Fortbildung geändert',
        logTemplate: '"<strong>{{data.Name}}</strong>" wurde geändert.',
        tags: function () {
          return [
            { type: 'info', label: 'Geändert'},
          ];
        },
        dataHelper: function () {}
      },
      'TRAINING_CREATED_STATUS_PENDING': {
        label: 'Fortbildung erstellt - Status: Ausstehend',
        logTemplate: '"<strong>{{data.Name}}</strong>" wurde erstellt und der Status ist ausstehend.',
        tags: function () {
          return [
            { type: 'warning', label: 'Ausstehend'},
          ];
        },
        dataHelper: function () {}
      },
      'TRAINING_STATUS_PENDING': {
        label: 'Fortbildung geändert - Status: Ausstehend',
        logTemplate: '"<strong>{{data.Name}}</strong>" wurde geändert und der Status befindet sich nun auf ausstehend.',
        tags: function () {
          return [
            { type: 'warning', label: 'Ausstehend'},
          ];
        },
        dataHelper: function () {}
      },
      'TRAINING_DELETE': {
        label: 'Fortbildung gelöscht',
        logTemplate: '"<strong>{{data.Name}}</strong>" wurde gelöscht.',
        tags: function () {
          return [
            { type: 'danger', label: 'Gelöscht'},
          ];
        },
        dataHelper: function () {}
      },

      // MISC LOGS
      'PRIVACY_ACCEPTED_FOR_OFFLINE_USER': {
        label: 'Datenschutzerklärung akzeptiert',
        logTemplate: 'Die Datenschutzerklärung wurde akzeptiert. <span ng-if="data.PrivacyLocation">Hinterlegte Erklärung/Hinweis: {{data.PrivacyLocation}}</span> ',
      },
    })
    .directive('historyDataMapper', function (historyEventMap, $compile, $injector) {
      return {
        link: function (scope, element, attrs) {
          scope.data = scope.history.data;
          if (historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].dataHelper) {
            historyEventMap[attrs.historyDataMapper].dataHelper(scope.data, $injector);
          }
          var tags = historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].tags
            && historyEventMap[attrs.historyDataMapper].tags(scope.data) || [];
          tags = tags.map(function (tag) {
            return '<span class="mr-5 tag label label-' + tag.type + '">' + tag.label + '</span>';
          })
            .join('');
          var template = (historyEventMap && historyEventMap[attrs.historyDataMapper] && historyEventMap[attrs.historyDataMapper].logTemplate)
            || 'Für diese Historie wurde noch keine Dateninterpretation hinterlegt.';

          element.append($compile('<span>' + tags + template + '</span>')(scope));
        }
      };
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components.historyDisplay')
    .controller('historyDisplayController', historyDisplayController);

  /** @ngInject */
  function historyDisplayController($rootScope, $scope, historyEventMap) {
    var self = this;
    self.historyTableConfig = {
      pageSize: 10,
    };

    self.getHistoryData = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.historyTableConfig.pageSize || 0,
          limit: self.historyTableConfig.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };
      return $scope.fetchHistoryData(queryWishes)
        .then(function (result) {
          self.historyCollection = result || { data: [] };
          params.pagination.numberOfPages = Math.ceil(self.historyCollection.count / self.historyTableConfig.pageSize);
        });
    };
    self.historyEventMap = historyEventMap;
  }
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('flowBar', flowBar);

  /** @ngInject */
  function flowBar() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/flowBar/flowBar.html',
      scope: {
        flow: '=',
        flowLabel: '=',
        viewOnly: '=?',
      },
      controller: 'flowBarCtrl as $flow'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function flowBarCtrl($scope, screenSize, baModalService, $translate) {
    var self = this;
    self.flow = $scope.flow;
    self.viewOnly = !!$scope.viewOnly;
    $scope.$watch(function () {
      return !!$scope.viewOnly;
    }, function (newVal) {
      self.viewOnly = newVal;
    });
    self.flowLabel = $scope.flowLabel;

    self.mediaSizeSM = screenSize.on('sm', function (match) {
      self.mediaSizeSM = match;
    });
    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });

    //step.label = $translate.instant('modules.events.service.' + step.ident.lowercase());

    self.availableStepChanges = [];
    if (self.flow.steps[self.flow.lastSavedStep] && self.flow.steps[self.flow.lastSavedStep].config
        && self.flow.steps[self.flow.lastSavedStep].config.backAvailable) {
      self.availableStepChanges = self.flow.steps.slice(0, self.flow.lastSavedStep);
    }
    self.availableStepChanges = self.availableStepChanges.concat(self.flow.steps.slice(self.flow.lastSavedStep + 1));

    self.flow.steps.forEach(function (step) {
      step.label = $translate.instant('modules.events.flowbar.' + step.label.toLowerCase());
    });

    if ($translate.use() == 'en') {
      self.flowLabel = _.lowerFirst(self.flowLabel);
    }

    self.stepChange = function (toStep) {
      if (toStep === undefined) {
        if (self.flow.activeStep !== self.flow.lastSavedStep) {
          self.flow.activeStep = self.flow.lastSavedStep;
          return;
        }
        if (self.availableStepChanges.length) {
          return baModalService
            .messageModal({
              modalType: 'info',
              allowHtml: true,
              title: $translate.instant('modules.events.flowbar.ChangePhaseTitle', { var: self.flowLabel }),
              content: '<div class="text-left mb-5"><span class="font-weight-500">' + $translate.instant('modules.events.flowbar.currentPhase', { flowLabel: self.flowLabel }) + ':</span> ' +
                       '<span class="text-' + self.flow.steps[self.flow.lastSavedStep].activeClass + '">' +
                       self.flow.steps[self.flow.lastSavedStep].label +
                       '</span>' +
                       '</div>' +
                       '<div class="text-left mb-20"><i>' + $translate.instant('modules.events.flowbar.changePhaseText') + '</i></div>' +
                       '<div class="text-left">' + $translate.instant('modules.events.flowbar.changePhaseTitle', { var: self.flowLabel }) + '</div>',
              primaryActionText: $translate.instant('generalTerms.confirm'),
              secondaryActionText: $translate.instant('generalTerms.cancel'),
              selectionOptions: self.availableStepChanges
                .map(function (asc) {
                  return {
                    label: asc.label,
                    step: asc,
                    defaultSelected: asc === self.flow.steps[self.flow.activeStep + 1],
                  };
                }),
            })
            .then(function (selection) {
              self.stepChange(self.flow.steps.indexOf(selection.step));
            })
        }
        return;
      }
      if (!self.flow.steps[toStep]
          || !(_.find(self.availableStepChanges, { ident: self.flow.steps[toStep].ident })
          || (toStep === self.flow.lastSavedStep && self.flow.lastSavedStep !== self.flow.activeStep))
      ) {
        return;
      }
      self.flow.activeStep = toStep;
    };

    self.stepFilter = function (value, index) {
      // show all steps for screen sizes > sm; only current step for screen sizes <= sm
      return !(self.mediaSizeXS || self.mediaSizeSM) || index === self.flow.activeStep;
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('flowBarCtrl', flowBarCtrl);
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('financialMaterialPickerCtrl', financialMaterialPickerCtrl);

  /** @ngInject */
  function financialMaterialPickerCtrl($scope, materialUtil, validationUtils, clientApi, commonUtils, $log, $translate) {
    var self = this;

    self.applyFieldConfig = materialUtil.applyFieldConfig;
    self.propTypes = materialUtil.propTypes;
    self.materialModel = $scope.materialModel;
    self.materialTypeId = $scope.materialTypeId;
    self.currentPropSet = self.propTypes[self.materialModel];
    self.matData = [];
    self.tableState = {};
    self.divisionIds = $scope.divisionIds;
    self.isMultiDiv = (self.divisionIds || []).length > 1;
    self.itemsPerPage = 10;

    self.allowAggregation = $scope.allowAggregation;
    self.filterWithPrices = !!$scope.filterWithPrices;
    self.filterMissingPrices = !!$scope.filterMissingPrices;
    self.uiConfig = $scope.uiConfig;

    self.onlyMissingPricesKeys = {
      on: $translate.instant('components.financialMaterialPicker.onlyMissingPricesOn'),
      off: $translate.instant('components.financialMaterialPicker.onlyMissingPricesOff')
    };
    self.onlyMissingPricesHints = {
      on: $translate.instant('components.financialMaterialPicker.onlyMissingPricesOnHint'),
      off: $translate.instant('components.financialMaterialPicker.pricesOffHint')
    };

    self.onlyWithPricesKeys = {
      on: $translate.instant('components.financialMaterialPicker.onlyWithPricesOn'),
      off: $translate.instant('components.financialMaterialPicker.onlyWithPricesOff')
    };
    self.onlyWithPricesHints = {
      on: $translate.instant('components.financialMaterialPicker.onlyWithPricesOnHint'),
      off: $translate.instant('components.financialMaterialPicker.pricesOffHint')
    };

    self.DEFAULT_TABLE_VIEW_NAME = $translate.instant('components.financialMaterialPicker.defaultViewName');

    self.materialMeta = $scope.materialMeta || {};
    self.materialMeta.defaultTableConfig = ($scope.materialMeta || {}).defaultTableConfig || materialUtil.materialDefaultTableConfig;
    self.materialMeta.customTableConfig = $scope.materialTableConfigs;
    self.materialMeta.columns = self.materialMeta.columnDefinitions || [];

    var defaultTableConfig = (self.materialMeta || {}).defaultTableConfig || {};
    var customTableConfig = (self.materialMeta || {}).customTableConfig || [];
    Object.keys(defaultTableConfig).forEach(function (defaultKey) {
      customTableConfig.unshift({
        Name: $translate.instant('components.financialMaterialPicker.allFieldsViewName'),
        ListType: defaultKey,
        Fields: self.materialMeta.columns[defaultKey]
          .map(function (header) {
            return header.prop;
          }),
        Aggregations: [],
      });
      customTableConfig.unshift({
        Name: self.DEFAULT_TABLE_VIEW_NAME,
        ListType: defaultKey,
        Fields: defaultTableConfig[defaultKey],
        Aggregations: [],
      });
    });
    self.materialMeta.tableConfig = _.groupBy(customTableConfig, 'ListType');
    Object.keys(self.materialMeta.tableConfig)
      .forEach(function (modelKey) {
        // remove Amount from view and column definition, it will be added manually as first col
        self.materialMeta.tableConfig[modelKey]
          .forEach(function (viewConfig) {
            if (viewConfig && viewConfig.Fields && viewConfig.Fields.length) {
              var vcAmountIndex = viewConfig.Fields.indexOf('Amount');
              if (~vcAmountIndex) {
                viewConfig.Fields.splice(vcAmountIndex, 1);
              }
            }
          });
        var colAmountIndex = self.materialMeta.columns[modelKey]
          .map(function (header) {
            return header.prop;
          })
          .indexOf('Amount');
        if (~colAmountIndex) {
          self.materialMeta.columns[modelKey].splice(colAmountIndex, 1);
        }
      });
    self.tableConfig = self.materialMeta.tableConfig[self.materialModel];

    // WATCHERS
    $scope.$watch(function () {
      return self.filterMissingPrices;
    }, function () {
      if (self.tableCtrl) {
        self.reloadMaterial(self.tableCtrl.tableState(), null, false);
      }
    }, true);

    $scope.$watch(function () {
      return self.filterWithPrices;
    }, function () {
      if (self.tableCtrl) {
        self.reloadMaterial(self.tableCtrl.tableState(), null, false);
      }
    }, true);

    $scope.$watch(function () {
      return $scope.materialModel + '_' + $scope.materialTypeId + '_' + ($scope.divisionIds || []).join(',');
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.materialModel = $scope.materialModel;
        self.materialTypeId = $scope.materialTypeId;
        self.tableConfig = self.materialMeta.tableConfig[self.materialModel];

        self.divisionIds = $scope.divisionIds;
        self.isMultiDiv = (self.divisionIds || []).length > 1;

        self.reloadMaterial(self.tableCtrl.tableState(), null, true);
      }
    });

    self.parseDate = function (date) {
      return materialUtil.parseDate(date, { Aggregations: (self.tableState.agg && self.tableState.agg.length ? { agg: true } : false) });
    };

    self.boolFormatter = materialUtil.boolFormatter;
    self.checkAggExcludes = materialUtil.checkAggregateExcludes;

    self.searchableCheck = function (header) {
      return materialUtil.searchableCheck(self.currentPropSet, header);
    };

    self.isIn = function (arr, content) {
      return !!(arr && ~arr.indexOf(content));
    };

    self.setMaterialView = function (view, withoutReload) {
      if (self.tableCtrl) {
        var tableState = self.tableCtrl.tableState();
        tableState.search = {};
        self.tableState.sf = {};
        tableState.sort = {};

        self.tableState.agg = view.Aggregations || [];
        self.tableState.view = view;

        Object.keys(view.Sort || {}).forEach(function (sortKey) {
          self.tableCtrl.sortBy(view.Sort[sortKey].sortProp, !(view.Sort[sortKey].direction === 'asc'));
        });

        if (!withoutReload) {
          self.tableCtrl.pipe();
        }

        commonUtils.preference.object.set('pref_financial_material_' + self.materialModel + '_view', { Name: view.Name });
      }
    };

    self.toggleMaterialAggregate = function ($event, prop) {
      if ($event) {
        $event.stopPropagation();
      }

      if (self.tableCtrl) {
        self.tableState.agg = self.tableState.agg || [];

        var found = self.tableState.agg.indexOf(prop);
        if (~found) {
          self.tableState.agg.splice(found, 1);
        } else {
          self.tableState.agg.push(prop);
        }

        self.tableCtrl.pipe();
      }
    };

    $scope.$on('financial-material-picker', function(event, args) {
      if (args.reload) {
        self.reloadMaterial(self.tableCtrl.tableState(), null, false);
      }
    });

    self.reloadMaterial = function (stParams, $ctrl, manualReload) {
      if (!self.tableCtrl || manualReload) {
        // initial call - need to initialize some st table ctrl fields
        // initial call & manual reload - need to set default table view from table config
        if (!self.tableCtrl) {
          self.tableCtrl = $ctrl;
          stParams.pagination.number = self.itemsPerPage;
        }
        var defaultViewName = (commonUtils.preference.object
                                 .get('pref_financial_material_' + self.materialModel + '_view', { Name: self.DEFAULT_TABLE_VIEW_NAME }) || {}).Name;
        var defaultView = (defaultViewName && _.find(self.materialMeta.tableConfig[self.materialModel], { Name: defaultViewName }))
                          || _.find(self.materialMeta.tableConfig[self.materialModel], { Name: self.DEFAULT_TABLE_VIEW_NAME });
        if (defaultView) {
          self.setMaterialView(defaultView, true);
        }
      }
      var queryWishes = {
        aggregateIds: true
      };

      if (self.materialTypeId) {
        queryWishes.where = {
          MaterialTypeId: self.materialTypeId,
        };
      }

      queryWishes.aggregations = (self.tableState.agg || []).length ? _.concat(self.tableState.agg, ['MaterialTypeId']) : self.tableState.agg;
      queryWishes.visibleNonAgg = _.concat(_.difference(self.tableState.view.Fields, self.tableState.agg), ['Amount']);

      if (stParams) {
        if (stParams.search && stParams.search.predicateObject) {
          materialUtil.handleSTSearchParams(stParams, queryWishes, self.currentPropSet);
        }
        if (stParams.sort) {
          queryWishes.sort = {
            by: stParams.sort.predicate,
            reverse: stParams.sort.reverse
          }
        }
        if (stParams.pagination) {
          queryWishes.paging = {
            offset: (stParams.pagination.start / stParams.pagination.number) * self.itemsPerPage || 0,
            limit: self.itemsPerPage
          };
        }
      }

      return clientApi
        .custom('model/' + self.materialModel, 'getMaterial', {
          divisionId: self.divisionIds,
          filterWithPrices: self.filterWithPrices,
          filterMissingPrices: self.filterMissingPrices,
          queryWishes: queryWishes
        })
        .then(function (res) {
          $scope.$evalAsync(function () {
            self.matData.splice(0, self.matData.length);
            Array.prototype.push.apply(self.matData, res.count && res.rows);
            if (Array.isArray(res.count)) {
              res.count = res.count.length;
            }
            if (stParams && stParams.pagination) {
              stParams.pagination.numberOfPages = Math.ceil(res.count / self.itemsPerPage);
              if (res.count > 0 && res.rows.length === 0) {
                stParams.pagination.start = (stParams.pagination.numberOfPages * self.itemsPerPage) - self.itemsPerPage;
              }
            }

            (self.matData || [])
              .forEach(function (material) {
                if (material && material.id) {
                  material.id = material.id
                    .toString()
                    .split(',')
                    .map(function (materialId) {
                      return parseInt(materialId.trim(), 10);
                    });
                }
              });
          })
        })
    };

    self.fetchMaterial = function (material) {
      return clientApi
        .custom('model/Service', 'getServiceMaterialForFinance', {
          materialRef: self.materialModel,
          materialIds: material.id,
          divisionIds: self.divisionIds,
          includeCostCenterSpecs: true
        })
        .catch(function () {
          return [];
        })
    };

    self.selectMaterials = function (materials) {
      self.fetchMaterial(materials)
        .then(function (selectedMaterials) {
          if (typeof $scope.onSelectFunc === 'function') {
            $scope.onSelectFunc(selectedMaterials);
          }
        });
    };

    self.removePricesBtnClicked = function(materials) {
      if (materials) {
        self.fetchMaterial(materials)
        .then(function (selectedMaterials) {
          if (typeof $scope.onRemovePricesFn === 'function') {
            $scope.onRemovePricesFn(selectedMaterials);
          }
        });
      }
    }

    // VIEW-FUNCTIONS
    self.hasPriceDefinition = validationUtils.hasValidPriceDefinition;

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('financialMaterialPicker', financialMaterialPicker);

  /** @ngInject */
  function financialMaterialPicker() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/financialMaterialPicker/financialMaterialPicker.html',
      scope: {
        materialModel: '=',
        materialTypeId: '=?',
        materialMeta: '=',
        materialTableConfigs: '=',
        divisionIds: '=',
        onSelectFunc: '=',
        onRemovePricesFn: '=',
        allowAggregation: '<',
        filterWithPrices: '<',
        filterMissingPrices: '<',
        uiConfig: '<',
      },
      controller: 'financialMaterialPickerCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('financeProcessList', financeProcessList);

  /** @ngInject */
  function financeProcessList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/financeProcessList/financeProcessList.html',
      scope: {
        processSteps: '=',
        process: '=',
        flowStepConfigs: '=',
        onSelect: '=',
        viewOnly: '=',
        originParams: '=',
        modalDismiss: '=',
        originUnapproved: '=',
      },
      controller: 'financeProcessCtrl as $ctrl'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('financeProcessCtrl', financeProcessCtrl)
    .filter('processCustomFilter',
      function ($filter, $translate) {
        return function (input, predicate) {
          var safeInput;
          if (Object.keys(predicate).indexOf('processFlowStateCustom') > -1) {
            safeInput = JSON.parse(JSON.stringify(input))
            safeInput.forEach(function (step) {
              step.processFlowStateCustom = getFlowStateLabel(step);
            })
            return $filter('filter')(safeInput, predicate, false);
          }
          if (Object.keys(predicate).indexOf('processTypeCustom') > -1) {
            safeInput = JSON.parse(JSON.stringify(input))
            safeInput.forEach(function (step) {
              step.processTypeCustom = $translate.instant(typeMap[step.type]);
            })
            return $filter('filter')(safeInput, predicate, false);
          }
          return $filter('filter')(input, predicate, false);
        };
      }
    );

  var flowStepConfigs;
  var typeMap;
  function getFlowStateLabel(processElement, $translate) {
    if (!processElement || !processElement.FlowState) {
      return $translate.instant('generalTerms.alreadyDelete');
    }
    if (flowStepConfigs[processElement.type]) {
      var label = (_.find(flowStepConfigs[processElement.type], function (flow) {
        return flow.ident === processElement.FlowState
      }) || {}).label;

      if (label) {
        var translation = $translate.instant('modules.finances.processStepSelector.flowsteps.' + label);
        if (translation.indexOf('modules.finances.processStepSelector.flowsteps.' > -1)) {
          translation = $translate.instant('modules.events.flowbar.' + label);
        }
      }
      return translation || processElement.FlowState;
    }
    return processElement.FlowState;
  }

  /** @ngInject */
  function financeProcessCtrl($scope, $state, $translate, permissions, clientApi, $uibModal) {
    var self = this;
    self.processSteps = $scope.processSteps;
    self.process = $scope.process;
    self.flowStepConfigs = $scope.flowStepConfigs;
    self.onSelect = $scope.onSelect;
    flowStepConfigs = $scope.flowStepConfigs;
    self.ctx = $scope.ctx;
    self.viewOnly = $scope.viewOnly;
    self.originParams = $scope.originParams;
    self.typeMap = {
      Quotation: 'modules.finances.processStepSelector.quotation',
      Invoice: 'modules.finances.processStepSelector.invoice',
      Service: 'modules.finances.processStepSelector.service',
      ReversalInvoice: 'modules.finances.processStepSelector.reversalInvoice',
    }
    typeMap = self.typeMap;

    self.getFlowStateLabel = function (el) {
      return getFlowStateLabel(el, $translate);
    }

    if (self.originParams && self.onSelect) {
      self.originParams.onSelect = self.onSelect;
    }

    // if all prices are null, then the backend filtered them out since the user is not permitted
    self.canViewPrices = _.compact(self.processSteps.map(function (s) {
      return s.FinalAmount
    })).length;

    self.openDetails = function (processElement) {
      var processParams = JSON.parse(JSON.stringify(self.originParams));
      processParams.process = processElement;
      if (processElement.type === 'Service') {
        $uibModal.open(
          {
            controller: 'financeProcessServiceDetailsCtrl as $ctrl',
            animation: true,
            templateUrl: 'app/pages/finances/modals/financeProcessServiceDetails.html',
            size: 'md',
            resolve: {
              serviceDetails: function () {
                return clientApi.custom('model/SalesDocMeta', 'generateFromService', { serviceId: processElement.id, divisionId: processElement.SourceDivisionId });
              }
            }
          }).result
          .catch(function () {
            // hmm k
          });
      } else {
        if ($scope.modalDismiss) {
          $scope.modalDismiss();
        }
        $state.go('arno.finances.quotationInvoiceDetails', {
          ctx: self.ctx,
          id: processElement.id,
          type: _.lowerFirst(processElement.type),
          processSelectorParams: processParams,
          originUnapproved: $scope.originUnapproved,
        })
      }
    }

    self.select = function (step) {
      return self.onSelect(step);
    }

    self.isPermittedToView = function (step) {
      // we'll display a heavily trimmed down version of services that only shows financial data in a small list
      // show if user has any relevant finance perms, users with only service view perms cannot view this due to price information contained therein
      if (step.type === 'Service') {
        return permissions.isPermittedInEvery('arno.finances.quotations.edit', 'Division', [step.DivisionId]) ||
          permissions.isPermittedInEvery('arno.finances.invoices.edit', 'Division', [step.DivisionId])
      }
      if (step.type === 'Quotation') {
        return permissions.isPermittedInEvery('arno.finances.quotations.edit', 'Division', [step.DivisionId])
      }
      if (step.type === 'Invoice') {
        return permissions.isPermittedInEvery('arno.finances.invoices.edit', 'Division', [step.DivisionId])
      }
      return null;
    }
    // self.checkQuotation = function (step) {
    //   return step.type === 'Quotation' && !step.deleted;
    // }
    // self.updateServiceQuotationReference = function (step) {
    //   console.log('---------------------------updateServiceQuotationReference---------------------------');
    //   console.log(step);
    //   self.processSteps.forEach(function (it) {
    //     if (it.type === 'Service') {
    //       it.QuotationBaseJson.id = step.id;
    //     }
    //     console.log(it);
    //   });
    //   console.log('---------------------------updateServiceQuotationReference---------------------------');
    // }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('fileUpload', fileUpload);

  /** @ngInject */
  function fileUpload() {
    return {
      templateUrl: 'app/theme/components/fileUpload/fileUpload.html',
      scope: {
        unallowedFileTypes: '=?',
        maxAllowedFileSize: '=?',
        uploadUrl: '=',
        fileName: '=?',
        downloadableFile: '=?',
        onFileUploaded: '=?',
        onFileDownload: '=?',
        onFileDelete: '=?', // allows to delete the file from the storage
        onFilePreview: '=?',
        onUploadStarted: '=?', // to determine when to disable/enable save or apply buttons for the current dialog
        showRemoveButton: '=?', // allows to revert to the previous file - "undo"
        labelText: '=?',
        isUploading: '=?',
      },
      controller: 'fileUploadCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('fileUploadCtrl', fileUploadCtrl);

  /** @ngInject */
  function fileUploadCtrl($scope, $translate, FileUploader, toastr, clientApi, commonUtils) {
    var self = this;

    self.maxAllowedFileSize = $scope.maxAllowedFileSize || 262144000; // 25MB
    self.unallowedFileTypes = $scope.unallowedFileTypes || []
    self.uploadUrl = $scope.uploadUrl;

    self.fileError = false;
    self.fileCacheSuccess = false;
    self.currentFileName = $scope.fileName;
    self.downloadableFile = $scope.downloadableFile;

    self.onFileDownload = $scope.onFileDownload;
    self.onFilePreview = $scope.onFilePreview;
    self.onFileDelete = $scope.onFileDelete;
    self.labelText = $scope.labelText;
    self.onUploadStarted = $scope.onUploadStarted;
    self.showRemoveButton = $scope.showRemoveButton || false;

    self.fileDeletePending = false;

    self.currentCacheKey = null;

    if ($scope.fileName) {
      self.fileCacheSuccess = true;
    }

    $scope.$watch(function () {
      return $scope.fileName
    }, function () {
      self.currentFileName = $scope.fileName;
    })


    self.canPreview = function () {
      var ext = self.downloadableFile.split('.').pop().toLowerCase();
      return !!~['jpg', 'jpeg', 'png', 'webm', 'pdf'].indexOf(ext);
    }

    self.uploaderConfig = clientApi.fileUploaderConfig({
      queueLimit: 1,
      url: self.uploadUrl,
      onAfterAddingFile: function (fileItem) {
        if (self.unallowedFileTypes.indexOf(fileItem.file.type) > -1) {
          toastr.error($translate.instant('modules.administration.adminQualification.unallowedFileType'));
          self.uploader.clearQueue();
          return false;
        }
        if (fileItem.file.size > self.maxAllowedFileSize) {
          self.uploader.removeFromQueue(fileItem);
          toastr.error($translate.instant('modules.administration.finances.quotationsAndInvoices.notLargerThan25MB'), $translate.instant('modules.administration.finances.quotationsAndInvoices.fileToBig'));
          return false
        }

        self.fileError = false;
        self.fileCacheSuccess = false;

        self.uploader.queue = [fileItem];
        self.currentFileName = fileItem._file.name;

        if (self.onUploadStarted) {
          self.onUploadStarted();
        }

        self.uploader.uploadItem(0);

      },
      onSuccessItem: function (fileItem, response) {
        if (response.fileCacheKey) {
          if ($scope.onFileUploaded) {
            if (self.fileDeletePending) {
              self.fileDeletePending = false;
              self.onFileDelete(true); // revert
            }

            $scope.onFileUploaded({
              fileCacheKey: response.fileCacheKey,
              fileItem: fileItem
            });

            if (self.currentCacheKey) {
              self.removeCacheKey(false);
            }

            self.currentCacheKey = response.fileCacheKey;

          }

        } else {
          self.fileError = true;
        }
      },
      onCompleteAll: function () {
        self.uploader.clearQueue();
        self.fileCacheSuccess = true;
      },
      onErrorItem: function () {
        self.fileError = true;
      },
    });

    self.uploader = new FileUploader(self.uploaderConfig);

    self.removeFile = function () {
      self.removeCacheKey(true);
      self.uploader.queue = [];
      self.currentFileName = null;
      self.currentCacheKey = null;

    };

    self.removeCacheKey = function (emitToParent) {
      self.fileCacheSuccess = false;
      if ($scope.onFileUploaded) {
        if (emitToParent) {
          // only done if deletion of file is wanted
          $scope.onFileUploaded({
            fileCacheKey: null,
            fileItem: null
          });
        }

        return clientApi.post('files/clearCacheFile', {
          keysToDelete: [self.currentCacheKey],
          divisionId: commonUtils.getDivisionFromSingleCtx('arno.personnel.dossier.qualification.viewAll', true)
        });
      }
    };

    self.uploadTemplate = function () {
      self.uploader.url = self.getApiUploadUrl();

      self.uploader.queue.forEach(function (file, index) {
        file.alias = 'file';
        file.url = self.getApiUploadUrl();

        self.uploader.uploadItem(index);
      });
    };
    $scope.$watch(function () {
      return self.uploader.isUploading;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        $scope.isUploading = newVal
      }
    }, true);

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('fileStorageAdmin', fileStorageAdmin);

  /** @ngInject */
  function fileStorageAdmin() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/fileStorageAdmin/fileStorageAdmin.html',
      scope: {
        maxDepth: '=',
        folderData: '=',
        storageIdent: '=',
        panelTitle: '=',
        viewPermSelector: '=',
      },
      controller: 'fileStorageAdminCtrl as $fs'
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('fileStorageAdminCtrl', fileStorageAdminCtrl);

  /** @ngInject */
  function fileStorageAdminCtrl($rootScope, $scope, $state, baModalService, permissions, clientApi, commonUtils, toastr, stateChangePrompt, $translate) {
    var self = this;
    self.selectedNode = {};
    self.panelTitle = $translate.instant($scope.panelTitle);
    self.folderStructureData = $scope.folderData.angularTreeData || [];
    self.originalNodeData = $scope.folderData.mappedNodes || [];
    self.treeviewCollapsed = false;
    self.changedNodes = [];
    self.maxDepth = $scope.maxDepth || 3; // how many layers we are allowed to create
    self.viewPermSelectorMap = $scope.viewPermSelector;
    self.viewPermSelector = Object.keys(self.viewPermSelectorMap);
    var newId = 1;
    var storageIdent = $scope.storageIdent;

    var isNewNode = function(node) {
      return node && node.id && (node.id.toString().indexOf('n-') === 0);
    }

    stateChangePrompt.evaluate(function () {
      return (self.changedNodes && !self.changedNodes.length && self.infoboxTextContentPristine === self.infoboxTextContent);
    });

    var checkMaxDepth = function(tree, newNode, depth, fn) {
      depth++;
      tree.forEach(function(node) {
        if (node.id === newNode.id) {
          fn(depth);
        } else if (node.children && node.children.length) {
          checkMaxDepth(node.children, newNode, depth, fn);
        }
      })
    }

    self.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    };

    self.selectNode = function(node) {
      if (node.id !== 'rootOrg') {
        self.selectedNode = node;
      } else {
        self.selectedNode = {};
      }
    }

    self.addNewNode = function() {
      var selectedNode;
      if (!self.selectedNode || (typeof self.selectedNode === 'object' && !Object.keys(self.selectedNode).length)) {
        // No node selected, we have to push it into the root layer
        selectedNode = self.folderStructureData[0];
      } else {
        selectedNode = self.selectedNode;
      }
      if (!selectedNode.children) {
        selectedNode.children = [];
      }
      checkMaxDepth(self.folderStructureData, selectedNode, null, function(depth) {
        if (depth <= self.maxDepth) {
          var newNodeId = 'n-'+(newId);
          selectedNode.children.push({
            id: newNodeId,
            parent: selectedNode.id || null,
            text: $translate.instant('components.fileStorageAdmin.newFolder') + ' ',
            active: true,
            children: [],
            icon: 'fa fa-folder',
            viewPermission: 'view',
            admins: [],
            newNode: true,
          })
          newId++;
          self.selectNode(selectedNode.children[selectedNode.children.length-1]);
        } else {
          toastr.warning(
            $translate.instant('components.fileStorageAdmin.addFolderWarnToastText', { maxDepth: self.maxDepth }),
            $translate.instant('components.fileStorageAdmin.addFolderWarnToastTitle')
          );
        }
      })
    }

    self.toggleCollapsed = function() {
      commonUtils.recurseTree(self.folderStructureData, function(node) {
        node.collapsed = !node.collapsed;
      })
      self.treeviewCollapsed = !self.treeviewCollapsed;
    }

    self.getIcon = function(node) {
      if (node.id === 'rootOrg' || node.icon !== 'fa fa-folder') {
        return node.icon;
      }

      if (!node.active) {
        return 'fa fa-ban';
      }

      if (node.collapsed || !node.children.length) {
        return node.icon;
      } else {
        return 'fa fa-folder-open';
      }
    }

    self.saveTree = function() {
      if (self.changedNodes && self.changedNodes.length) {
        clientApi.emit('fileStorage/updateBulk', {
          folders: _.map(self.changedNodes, function(node) {
            return {
              Name: node.text,
              ParentFolderId: node.parent === 'rootOrg' ? null : node.parent,
              viewPermission: node.viewPermission,
              Active: true,
              id: node.id,
            }
          }),
          storageIdent: storageIdent,
        })
        .then(function() {
          toastr.success(
            $translate.instant('components.fileStorageAdmin.structureSavedToastText'),
            $translate.instant('components.fileStorageAdmin.structureSavedToastTitle')
          );
          stateChangePrompt.disableEvaluation();
          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('components.fileStorageAdmin.structureSaveErrToastText'),
            $translate.instant('components.fileStorageAdmin.structureSaveErrToastTitle')
          );
        })
      } else {
        toastr.info(
          $translate.instant('components.fileStorageAdmin.structureNoChangesToastText'),
          $translate.instant('components.fileStorageAdmin.structureNoChangesToastTitle')
        );
      }
    }

    self.removeChangedNode = function(node) {
      var index = _.findIndex(self.changedNodes, function(changedNode) {
        return changedNode.id === node.id;
      })
      if (!!~index) {
        self.changedNodes.splice(index, 1);
      }
    }

    self.isParentRestricted = commonUtils.fileStorage.isParentRestricted;

    self.getAvailablePerms = function(node, viewPerms) {
      return viewPerms.filter(function(vp) {
        if (vp === 'view' && self.isParentRestricted(node, self.folderStructureData)) {
          return false;
        }
        return true;
      })
    }

    self.deleteNode = function(node) {
      if (isNewNode(node)) {
        commonUtils.recurseTree(self.folderStructureData, function(treeNode, i, layer) {
          if (node.id === treeNode.id) {
            commonUtils.recurseTree(treeNode.children, function(tn) {
              self.removeChangedNode(tn);
            })
            self.removeChangedNode(node);
            layer.splice(i, 1);
          }
        })
        self.selectedNode = {};
      } else if (node && node.id) {
        baModalService.messageModal({
          modalType: 'danger',
          allowHtml: true,  
  
          title: $translate.instant('components.fileStorageAdmin.deleteModalTitle', { node: node.text }),
          // content: 'Willst du den Ordner wirklich löschen?<br><br>' +
          //          '<b>ACHTUNG</b>: Alle <b>Unterordner</b> werden ebenfalls gelöscht!',
          content: $translate.instant('components.fileStorageAdmin.deleteModalContent1') + '<br><br><b>' +
          $translate.instant('components.fileStorageAdmin.deleteModalContent2') + '</b>' +
          $translate.instant('components.fileStorageAdmin.deleteModalContent3') +'<b>' +
          $translate.instant('components.fileStorageAdmin.deleteModalContent4') +'</b>'+ 
          $translate.instant('components.fileStorageAdmin.deleteModalContent5'),
  
          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        })
        .then(function() {
          return clientApi.custom('model/FileStorageFolder', 'deleteFolder', { folderId: node.id, storageIdent: storageIdent })
        })
        .then(function() {
          toastr.success(
            $translate.instant('components.fileStorageAdmin.folderDeletedToastText', { node: node.text }),
            $translate.instant('components.fileStorageAdmin.folderDeletedToastTitle')
          );
          $state.reload();
        })
        .catch(function(error) {
          if (error && error.action !== 'BA_MODAL_SECONDARY_BTN_CLICKED') {
            toastr.error(
              $translate.instant('components.fileStorageAdmin.folderDeleteFailedToastText'),
              $translate.instant('components.fileStorageAdmin.folderDeleteFailedToastTitle')
            );
          }
        });
      }
    }

    /* eslint no-extra-boolean-cast:0 */
    function getChanges(newVal, originalData) {
      newVal.forEach(function(node) {
        // rootOrg can NEVER change, ignore it and run through its children
        if (node.id !== 'rootOrg' && !isNaN(parseInt(node.id))) {
          originalData.forEach(function(origNode) {
            if (node.id === origNode.id) {
              if (node.parent !== origNode.parent ||
                node.id !== origNode.id ||
                node.text !== origNode.text ||
                node.viewPermission !== origNode.viewPermission
              ) {
                var index = _.findIndex(self.changedNodes, function(changedNode) {
                  return changedNode.id === node.id;
                })
                if (!!~index) {
                  self.changedNodes[index] = node;
                } else {
                  self.changedNodes.push(node);
                }
              } else {
                self.removeChangedNode(node);
              }
            }
          })
        } else if (node.id !== 'rootOrg' && isNaN(parseInt(node.id))) {
          var index = _.findIndex(self.changedNodes, function(changedNode) {
            return changedNode.id === node.id;
          })
          if (!!~index) {
            self.changedNodes[index] = node;
          } else {
            self.changedNodes.push(node);
          }
        }
        if (node.children && node.children.length) {
          getChanges(node.children, originalData)
        }
      })
    }

    $scope.$watch(function() {
      return self.folderStructureData
    }, function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        getChanges(newVal, self.originalNodeData);
      }
    }, true)

    self.checkTitle = function(value) {
      if (value === '' || value === undefined) {
        self.emptyError = true;
      } else {
        self.emptyError = false;
      }
    }

    self.setActiveState = function(node, active) {
      return clientApi.custom('model/FileStorageFolder', 'setActiveState', {
        active: active,
        folderId: node.id,
        storageIdent: storageIdent,
      })
      .then(function() {
        toastr.success(
          $translate.instant('components.fileStorageAdmin.activeStateToastrSuccess', { active: active }),
          $translate.instant('components.fileStorageAdmin.activeStateToastrSuccessTitle', { active: active })
        );
        $state.reload();
      })
      .catch(function() {
        toastr.error(
          $translate.instant('components.fileStorageAdmin.activeStateToastrFail', { active: active }),
          $translate.instant('components.fileStorageAdmin.activeStateToastrFailTitle', { active: active })
        );
      })
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('eventTileDashboard', eventTileDashboard);

  /** @ngInject */
  function eventTileDashboard() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/eventTileDashboard/eventTileDashboard.html',
      scope: {
        tileData: '=',
      },
      controller: 'eventTileDashboard as $ctrl'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('eventTileDashboard', eventTileDashboardCtrl);

  /** @ngInject */
  function eventTileDashboardCtrl($rootScope, $state, $location, $scope, permissions, eventUtil, $translate, toastr, clientApi) {
    var self = this;

    self.currentUrl = $location.$$path;

    self.data = $scope.tileData;

    self.meeting_acceptance = Array.isArray(self.data.attendanceInfo) && self.data.attendanceInfo.filter(function (attendance) {
      return attendance.Acceptance === true;
    }) || undefined;

    self.clickTile = function (event) {      
      if (event.isService) {
        $state.go('arno.events.serviceDetail', { serviceId: event.id, ctx: event.sourceDivisionId });
      } else {
        $state.go('arno.events.eventDetail', { eventId: event.id });
      }
    };
    self.memberCount = {
      title: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;

        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return acceptedMemberCount;
          default:
            return positionedMemberCount + ' eingeteilte Teilnehmer + '
              + (acceptedMemberCount - positionedMemberCount)
              + ' Zusagen , '
              + positionedMemberCount + ' von ' + positionCount + ' Positionen zugewiesen';
        }
        /* eslint-enable indent */
      },
      text: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;


        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return acceptedMemberCount;
          case acceptedMemberCount === positionedMemberCount:
            return positionedMemberCount + ' / ' + positionCount;
          default:
            return positionedMemberCount + ' + ' + (acceptedMemberCount - positionedMemberCount) + ' / ' + positionCount;
        }
        /* eslint-enable indent */
      },
      style: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;

        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return 'label-info';
          case positionedMemberCount >= positionCount:
            return 'label-success';
          case acceptedMemberCount >= positionCount:
            return 'label-warning';
          default:
            return 'label-danger';
        }
        /* eslint-enable indent */
      }
    };

    self.attendanceAdd = function (acceptance) {
      self.permittedToAttend = permissions.getPermittedIds(
        'arno.events.basic.view',
        'Division',
        self.data.context,
        false
      );
      if (!self.permittedToAttend || !self.permittedToAttend.length) {
        return;
      }
      var updateAttendee = $rootScope.ctx.currentUser;
      updateAttendee.fullName = updateAttendee.fullName || updateAttendee.Member.fullName;
      var divsUserCanSelect = _.intersection(self.data.context, self.data.shiftRelevantDivisions);

      return Promise.resolve().then(function () {
        if (divsUserCanSelect.length > 1) {
          clientApi.custom('model/Division', 'fetchDivisionName', {
            divisionIds: divsUserCanSelect,
          }).then(function (response) {            
            return eventUtil.chooseAttendanceDivisionModal(
              $rootScope.ctx.currentUser,
              response.map(function (dm) {
                return {
                  label: dm.Name,
                  dm: dm,
                  defaultSelected: (function () {
                    if (acceptance && self.data.context.length === 1) {
                      return dm.id === self.data.context[0];
                    }
                    return dm.id === ((self.data.serviceShiftMember || {}).Division || {}).id;
                  })(),
                };
              }),
              'SERVICE'
            ).then(function (choice) {
              return choice.dm;
            }).then(function (choice) {
              return clientApi.custom('model/ServiceShiftMember', 'updateOwnAttendance', {
                serviceId: self.data.id,
                shiftId: self.data.shiftId,
                divisionId: choice.id,
                acceptance: acceptance,
              }).then(function (newShiftMember) {
                $scope.$evalAsync(function () {
                  self.data.serviceShiftMember = newShiftMember;
                  if (self.data.serviceShiftMember.Acceptance && self.data.attendanceInfo) {
                    self.data.attendanceInfo.acceptedMemberCount++;
                  }
                  if (!self.data.serviceShiftMember.Acceptance && !self.data.serviceShiftMember.Interested && self.data.attendanceInfo) {
                    self.data.attendanceInfo.acceptedMemberCount--;
                  }
                  var divisionInfo = _.find(updateAttendee.DivisionMembers || [], { DivisionId: newShiftMember.DivisionId });
                  if (divisionInfo && divisionInfo.Division) {
                    self.data.serviceShiftMember.Division = { Name: divisionInfo.Division.Name, id: divisionInfo.DivisionId };
                  }
                });
                toastr.success(
                  $translate.instant('modules.events.calendar.toastr.participationReportRecordedMsg'),
                  $translate.instant('modules.events.calendar.toastr.participationReportRecordedTitle')
                );
                $state.reload();
              }).catch(function () {
                toastr.error(
                  $translate.instant('modules.events.calendar.toastr.participationReportFailedMsg'),
                  $translate.instant('modules.events.calendar.toastr.participationReportFailedTitle')
                );
              });
            }).catch(function () {
              // hm k
            });
          });
        } else {
          return clientApi.custom('model/ServiceShiftMember', 'updateOwnAttendance', {
            serviceId: self.data.id,
            shiftId: self.data.shiftId,
            divisionId: self.data.shiftRelevantDivisions[0],
            acceptance: acceptance,
          }).then(function (newShiftMember) {
            $scope.$evalAsync(function () {
              self.data.serviceShiftMember = newShiftMember;
              if (self.data.serviceShiftMember.Acceptance && self.data.attendanceInfo) {
                self.data.attendanceInfo.acceptedMemberCount++;
              }
              if (!self.data.serviceShiftMember.Acceptance && !self.data.serviceShiftMember.Interested && self.data.attendanceInfo) {
                self.data.attendanceInfo.acceptedMemberCount--;
              }
              var divisionInfo = _.find(updateAttendee.DivisionMembers || [], { DivisionId: newShiftMember.DivisionId });
              if (divisionInfo && divisionInfo.Division) {
                self.data.serviceShiftMember.Division = { Name: divisionInfo.Division.Name, id: divisionInfo.DivisionId };
              }
            });
            toastr.success(
              $translate.instant('modules.events.calendar.toastr.participationReportRecordedMsg'),
              $translate.instant('modules.events.calendar.toastr.participationReportRecordedTitle')
            );
            $state.reload();
          }).catch(function () {
            toastr.error(
              $translate.instant('modules.events.calendar.toastr.participationReportFailedMsg'),
              $translate.instant('modules.events.calendar.toastr.participationReportFailedTitle')
            );
          });
        }
      });
    };

    self.attendanceAddEvent = function (acceptance) {
      self.permittedToAttend = permissions.getPermittedIds(
        'arno.events.basic.view',
        'Division',
        self.data.context,
        false
      );

      var options = {
        eventId: self.data.id,
      };

      clientApi
        .custom('model/Event', 'getEventDetails', {
          options: options,
        })
        .then(function (response) {
          var Event = response.results[0];
          var SourceDivision = {
            Name: Event.SourceDivisionName,
            id: Event.SourceDivisionId,
          };
          if (Event.canSelfAttend === Event.divisionShareUserDivision.length + 1) {
            Event.divisionShareUserDivision.push(SourceDivision);
          }
          if (Event.divisionShareUserDivision.length > 1) {
            return eventUtil
              .chooseAttendanceDivisionModal(
              $rootScope.ctx.currentUser,
              Event.divisionShareUserDivision.map(function (div) {
                return {
                  label: div.Name,
                  dm: div,
                  defaultSelected: (function () {
                    if (acceptance && self.data.context.length === 1) {
                      return div.id === self.data.context[0];
                    }
                    return div.id === ((self.data.serviceShiftMember || {}).Division || {}).id;
                  })(),
                };
              }),
              'EVENT'
              )
              .then(function (choice) {
                return choice.dm;
              });
          } else {
            return Event.divisionShareUserDivision[0];
          }
        })
        .then(function (divisionMember) {
          return clientApi.custom('model/EventMember', 'updateOwnAttendance', {
            eventId: self.data.id,
            divisionId: divisionMember && divisionMember.id,
            acceptance: acceptance,
          }).then(function () {
            $state.reload();
          });
        })
        .catch(function () {
          toastr.error(
            $translate.instant(
              'modules.events.calendar.toastr.participationReportFailedMsg'
            ),
            $translate.instant(
              'modules.events.calendar.toastr.participationReportFailedTitle'
            )
          );

        });
      toastr.success(
        $translate.instant(
          'modules.events.calendar.toastr.participationReportRecordedMsg'
        ),
        $translate.instant(
          'modules.events.calendar.toastr.participationReportRecordedTitle'
        )
      );

      if (self.eventAcceptance == null) {
        self.eventAcceptance = acceptance;
      } else {
        self.eventAcceptance = !self.eventAcceptance;
      }
    };
    self.preventClick = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }
    };
  }
}
)();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('fileStorage', fileStorage);

  /** @ngInject */
  function fileStorage() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/fileStorage/fileStorage.html',
      scope: {
        isOwnDossier: '=',
        itemId: '=',
        storageIdent: '=',
        ctx: '=',
        folderData: '=',
        editPermission: '=',
        showEditPermIcon: '=?',
      },
      controller: 'fileStorageCtrl as $fs'
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('fileStorageCtrl', fileStorageCtrl);

  /** @ngInject */
  function fileStorageCtrl($rootScope, $scope, $state, $uibModal, $translate, baModalService, commonUtils,
    permissions, FileUploader, toastr, clientApi) {
    var self = this;
    var isOwnDossier = $scope.isOwnDossier;
    var itemId = $scope.itemId;
    var storageIdent = $scope.storageIdent;
    var ctx = $scope.ctx;
    var folderData = $scope.folderData;
    self.storageIdent = storageIdent;
    self.editPerm = $scope.editPermission;
    self.selectedNode = {};
    self.folderStructureData = (folderData && folderData.angularTreeData) || [];
    self.originalNodeData = (folderData && folderData.mappedNodes) || [];
    self.treeviewCollapsed = false;
    self.changedNodes = [];
    self.currentDivision = Array.isArray(ctx) ? ctx[0] : ctx;
    self.uploadNodeId;
    self.isOrg = (ctx === 'rootOrg' || ctx[0] === 'rootOrg');
    self.showEditPermIcon = $scope.showEditPermIcon || false;

    var mimeTypes = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webm: 'video/webm',
      pdf: 'application/pdf'
    }

    var uploaderCfg = clientApi.fileUploaderConfig({
      url: '/api/fileStorage/upload',
      onBeforeUploadItem: function(item) {
        item.formData.push({
          division: self.currentDivision,
          folder: self.uploadNodeId ? self.uploadNodeId : self.selectedNode.id,
          affectedId: itemId,
          storageIdent: storageIdent,
        });
      },
      onSuccessItem: function(item, response) {
        if (response && response.result) {
          if (!Number(response.result.id)) {
            // push a new node
            commonUtils.recurseTree(self.folderStructureData, function(node) {
              if (node.id == response.result.parent) {
                response.result.uploader = {
                  fullName: $rootScope.ctx.currentUser.fullName
                }
                response.result.icon = commonUtils.fileStorage.fileExtToIconMap(response.result.extension);
                node.children.push(response.result);
                self.docList = _.filter(self.selectedNode.children, function(child) {
                  return child.type === 'file';
                })
              }
            })
          } else {
            // update existing node
            response.result.id = 'f-' + response.result.id;
            commonUtils.recurseTree(self.folderStructureData, function(node, i, layer) {
              if (node.id === response.result.id) {
                response.result.uploader = {
                  fullName: $rootScope.ctx.currentUser.fullName
                }
                response.result.icon = commonUtils.fileStorage.fileExtToIconMap(response.result.extension);
                layer[i] = response.result;
                self.docList = _.filter(self.selectedNode.children, function(child) {
                  return child.type === 'file';
                })
              }
            })
          }
        }
      },
      onAfterAddingAll: function() {
        self.openUploadDialog(self.selectedNode);
      },
      onErrorItem: function(item) {
        toastr.error(
          $translate.instant('modules.personnel.dossier.fileStorage.uploadErrToastText', {
            file: item.file.name
          }),
          $translate.instant('modules.personnel.dossier.fileStorage.uploadErrToastTitle')
        );
      },
      onAfterAddingFile: function(item) {
        var toAdd = true;
        self.uploader.queue.pop(); // we don't have an on-before, pop what it already added
        self.uploader.queue.forEach(function(fileToUpload) {
          if (fileToUpload.file.name === item.file.name) {
            toastr.warning(
              $translate.instant('modules.personnel.dossier.fileStorage.uploadWarnToastText', {
                file: item.file.name
              }),
              $translate.instant('modules.personnel.dossier.fileStorage.uploadWarnToastTitle')
            );
            toAdd = false;
          }
        })
        if (toAdd) {
          self.uploader.queue.push(item);
        }
        if (self.checkForUnfinished) {
          self.checkForUnfinished();
        }
      },
      onCompleteAll: function() {
        if (self.closeOnFinish) {
          // manually check if everything was successful
          var closeDialog = true;
          self.uploader.queue.forEach(function(file) {
            if (file.isError) {
              closeDialog = false;
            }
          })

          if (closeDialog) {
            self.closeOnFinish = false;
            self.uibModalInstance.close();
            toastr.success(
              $translate.instant('modules.personnel.dossier.fileStorage.completeAllToastText'),
              $translate.instant('modules.personnel.dossier.fileStorage.completeAllToastTitle')
            );
          }
        }
      },
      onCompleteItem: function() {
        self.checkForUnfinished();
      },
      filters: [{
        name: 'size',
        fn: function(item) {
          // if file > 10MB -> reject
          if (!!~item.size && item.size <= 10490000) {
            return true;
          }
          toastr.warning(
            $translate.instant('modules.personnel.dossier.fileStorage.fileToBigToastText'),
            $translate.instant('modules.personnel.dossier.fileStorage.fileToBigToastTitle')
          );
          return false;
        }
      }, {
        name: 'org',
        fn: function() {
          if (self.isOrg) {
            toastr.warning(
              $translate.instant('modules.personnel.dossier.fileStorage.orgUploadFailToastText'),
              $translate.instant('modules.personnel.dossier.fileStorage.orgUploadFailToastTitle')
            );
            return false;
          }
          return true;
        }
      }]
    })

    self.uploader = new FileUploader(uploaderCfg);

    var newId = 1;

    self.selectNode = function(node, isFileDrop) {
      if (node.id !== 'rootOrg') {
        self.selectedNode = node;
      } else {
        self.selectedNode = {};
      }

      if (self.selectedNode.type === 'folder') {
        self.docList = _.filter(self.selectedNode.children, function(child) {
          return child.type === 'file';
        })
      } else {
        self.docList = [];
        self.fileNodeCopy = _.cloneDeep(node);
        if (isFileDrop) {
          // if we drop files onto files, select the folder they're in and open the upload dialog there instead
          commonUtils.recurseTree(self.folderStructureData, function(treeNode) {
            treeNode.children.forEach(function(child) {
              if (child.id === node.id) {
                self.selectedNode = treeNode;
              }
            })
          })
        }
      }
    }

    self.addNewNode = function() {
      var selectedNode;
      if (!self.selectedNode || (typeof self.selectedNode === 'object' && !Object.keys(self.selectedNode).length)) {
        // No node selected, we have to push it into the root layer
        selectedNode = self.folderStructureData[0];
      } else {
        selectedNode = self.selectedNode;
      }
      if (!selectedNode.children) {
        selectedNode.children = [];
      }
      var newNodeId = 'n-' + (newId);
      selectedNode.children.push({
        id: newNodeId,
        parent: selectedNode.id || null,
        text: 'Neuer Datei',
        active: true,
        children: [],
        icon: 'fa fa-file',
        admins: [],
        newNode: true,
      })
      newId++;
      self.selectNode(selectedNode.children[selectedNode.children.length - 1]);
    }

    self.toggleCollapsed = function() {
      commonUtils.recurseTree(self.folderStructureData, function(node) {
        node.collapsed = !self.treeviewCollapsed;
      })
      self.treeviewCollapsed = !self.treeviewCollapsed;
    }

    self.getIcon = function(node) {
      if (node.id === 'rootOrg' || node.icon !== 'fa fa-folder') {
        return node.icon;
      }

      if (!node.active) {
        return 'fa fa-ban';
      }

      if (node.collapsed || !node.children.length) {
        return node.icon;
      } else {
        return 'fa fa-folder-open';
      }
    }

    self.getIconByFileExtension = function(file) {
      if (!file) {
        file = self.selectedNode;
      }
      return commonUtils.fileStorage.fileExtToIconMap(file.extension);
    }

    self.isPermittedInCurrentDiv = function(action, isAllowedInOwn) {
      if (isOwnDossier && isAllowedInOwn) {
        // user is permitted view and download files in his own dossier
        return true;
      }
      if (typeof action === 'function') {
        return action();
      }
      if (self.isOrg) {
        return permissions.isPermittedInEvery(action, 'Organization', [self.currentDivision])
      }
      return permissions.isPermittedInEvery(action, 'Division', [self.currentDivision]);
    }

    self.calcFileSize = function(size) {
      size = size / 1024;
      if (size > 1000) {
        return (size / 1024).toFixed(2) + ' MB';
      }

      return size.toFixed(2) + ' KB';
    }

    self.downloadFile = function(file) {
      if (file && file.type === 'file' && file.id.startsWith('f-')) {
        return clientApi.openTab('fileStorage/download', {
          division: self.currentDivision,
          fileId: file.id.split('f-')[1],
          affectedId: itemId,
          storageIdent: storageIdent,
        })
      } else {
        toastr.error(
          $translate.instant('modules.personnel.dossier.fileStorage.unknownErrorText'),
          $translate.instant('modules.personnel.dossier.fileStorage.downloadErrToastTitle')
        );
      }
    }

    self.canPreview = function(ext) {
      return !!~['jpg', 'jpeg', 'png', 'webm', 'pdf'].indexOf(ext);
    }

    self.previewFile = function(file) {
      clientApi.emit('fileStorage/download', {
        division: self.currentDivision,
        fileId: file.id.split('f-')[1],
        affectedId: itemId,
        storageIdent: storageIdent,
      }, 'binary')
      .then(function(res) {
        var blobStore = new Blob([res], { type: mimeTypes[file.extension] });
        var data = window.URL.createObjectURL(blobStore);
        window.open(data);
      })
    }

    self.deleteFile = function(file) {
      if (file && file.type === 'file' && file.id.startsWith('f-')) {
        baModalService.messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: $translate.instant('modules.personnel.dossier.fileStorage.fileDeleteMessageModalTitle', {title: file.text}),
          content: $translate.instant('modules.personnel.dossier.fileStorage.fileDeleteMessageModalContent'),
          primaryActionText: $translate.instant('modules.personnel.dossier.fileStorage.fileDeleteMessageModalDeleteBtn'),
          secondaryActionText: $translate.instant('generalTerms.cancel'),
        })
          .then(function() {
            return clientApi
              .custom('model/FileStorageFile', 'removeFile', {
                divisionId: self.currentDivision,
                fileId: file.id.split('f-')[1],
                affectedId: itemId,
                storageIdent: storageIdent,
              })
              .then(function(result) {
                if (result) {
                  toastr.success(
                    $translate.instant('modules.personnel.dossier.fileStorage.fileDeletedToastText'),
                    $translate.instant('modules.personnel.dossier.fileStorage.fileDeletedToastTitle')
                  );
                  self.selectedNode = {};
                  self.deleteTreeFile(file.id, folderData.angularTreeData);
                }
              })
              .catch(function() {
                toastr.error(
                  $translate.instant('modules.personnel.dossier.fileStorage.unknownErrorText'),
                  $translate.instant('modules.personnel.dossier.fileStorage.fileDeleteFailedToastTitle')
                );
              })
          })
      } else {
        toastr.warning(
          $translate.instant('modules.personnel.dossier.fileStorage.selectFileToastText'),
          $translate.instant('modules.personnel.dossier.fileStorage.selectFileToastTitle')
        );
      }
    }

    self.isParentRestricted = commonUtils.fileStorage.isParentRestricted;
    self.hasChildFiles = commonUtils.fileStorage.hasChildFiles;

    self.renameFile = function(file) {
      if (self.selectedNode && self.selectedNode.type === 'file' && self.selectedNode.id.startsWith('f-')) {
        return clientApi.custom('model/FileStorageFile', 'renameFile', {
          divisionId: self.currentDivision,
          fileId: file.id.split('f-')[1],
          newName: file.baseName + '.' + file.extension,
          affectedId: itemId,
          storageIdent: storageIdent,
        })
          .then(function(result) {
            if (result) {
              toastr.success(
                $translate.instant('modules.personnel.dossier.fileStorage.renameFileToastText'),
                $translate.instant('modules.personnel.dossier.fileStorage.renameFileToastTitle')
              );
              var treeFile = self.getTreeFile(file.id, folderData.angularTreeData);
              treeFile.text = file.baseName + '.' + file.extension;
            } else {
              toastr.error(
                $translate.instant('modules.personnel.dossier.fileStorage.unknownErrorText'),
                $translate.instant('modules.personnel.dossier.fileStorage.renameFailedToastTitle')
              );
            }
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.personnel.dossier.fileStorage.unknownErrorText'),
              $translate.instant('modules.personnel.dossier.fileStorage.renameFailedToastTitle')
            );
          })
      } else {
        toastr.warning(
          $translate.instant('modules.personnel.dossier.fileStorage.selectFileToastText'),
          $translate.instant('modules.personnel.dossier.fileStorage.selectFileToastTitle')
        );
      }
    }

    self.checkTitle = function(value) {
      if (value === '' || value === undefined) {
        self.emptyError = true;
      } else {
        self.emptyError = false;
      }
    }

    self.openUploadDialog = function(node) {
      if (self.isOrg) {
        return;
      }
      var perm = self.editPerm && self.isPermittedInCurrentDiv(self.editPerm, false);
      if (!perm) {
        toastr.error(
          $translate.instant('modules.personnel.dossier.fileStorage.missingPermissionToastText'),
          $translate.instant('modules.personnel.dossier.fileStorage.missingPermissionToastTitle')
        );
        return;
      }
      var folder;
      if (node.type !== 'folder') {
        commonUtils.recurseTree(self.folderStructureData, function(treeNode) {
          treeNode.children.forEach(function(child) {
            if (child.id === node.id) {
              folder = treeNode;
              self.uploadNodeId = treeNode.id;
            }
          })
        })
      }
      $uibModal
        .open({
          controller: 'uploadModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/theme/components/fileStorage/modals/uploadModal.html',
          size: 'lg',
          resolve: {
            uploader: function() {
              return self.uploader;
            },
            node: function() {
              return folder ? folder : node;
            },
            calcFileSize: function() {
              return self.calcFileSize;
            },
            parentCtrl: function() {
              return self;
            }
          }
        })
        .result
        .then(function() {
          self.uploadNodeId = null;
          self.uploader.queue = []; // clear queue
        })
        .catch(function() {
          self.uploadNodeId = null;
          self.uploader.queue = []; // clear queue
        });
    }

    self.getTreeFile = function(id, data) {
      var foundNode;
      commonUtils.recurseTree(data, function(treeNode) {
        if (id === treeNode.id) {
          foundNode = treeNode;
        }
      });
      return foundNode;
    }

    self.deleteTreeFile = function(id, data) {
      commonUtils.recurseTree(data, function(treeNode, i, layer) {
        if (id === treeNode.id) {
          layer.splice(i, 1);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('sendAttendeeMessageCtrl', sendAttendeeMessageCtrl);

  /** @ngInject */
  function sendAttendeeMessageCtrl($scope, $uibModalInstance, attendeeInfos, shifts, toastr) {
    var self = this;
    self.shifts = shifts;
    self.attendeeInfos = attendeeInfos
      .filter(function (attendee) {
        return attendee.EMail;
      });
    self.missingAttendeeInfos = attendeeInfos
      .filter(function (attendee) {
        return !attendee.EMail;
      });
    self.missingAttendeeInfosStr = self.missingAttendeeInfos
      .map(function (attendee) {
        return attendee.fullName;
      })
      .join(',');
    self.noAttendees = !self.attendeeInfos.length;
    self.envelopeType = (!self.shifts || self.shifts.length > 1) ? 'fa fa-envelope' : 'fa fa-envelope-o';


    self.applyModal = function (delimiter, clipboard) {
      var mailAddresses = self.attendeeInfos
        .map(function (attendee) {
          return attendee.EMail;
        })
        .join(delimiter || ' ');

      if (clipboard) {
        Promise.resolve()
          .then(function() {
            if(!navigator.clipboard || !navigator.clipboard.writeText) {
              throw new Error('Not supported.');
            }
            return navigator.clipboard.writeText(mailAddresses);
          })
          .then(function() {
            toastr.success('Die E-Mail Adressen wurden in die Zwischenablage kopiert.', 'In Zwischenablage kopiert');
          })
          .catch(function() {
            toastr.error(
              'Die E-Mail Adressen konnten nicht in die Zwischenablage kopiert werden. Gegebenenfalls unterstützt dieser Browser die Funktion nicht.',
              'Aktion gescheitert'
            );
          });
      } else {
        window.open('mailto:?bcc=' + mailAddresses);
      }

      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .controller('inviteAttendeeCtrl', inviteAttendeeCtrl);

  /** @ngInject */
  function inviteAttendeeCtrl($rootScope, $scope, $uibModalInstance, shifts, divisionOptions, entityId, clientApi,
    membersWithAttendeeStatus, baModalService, toastr) {
    var self = this;
    self.shifts = shifts;
    self.entityId = entityId;
    self.divisionOptions = divisionOptions;
    self.divisionSelect = divisionOptions.slice();
    self.membersWithAttendeeStatus = membersWithAttendeeStatus || [];
    self.sendOption = 'ALL_DIVISION';
    self.customInviteList = [];
    self.inviteDivisionList = [];
    self.foundMemberList = [];
    self.inviteChoices = [{ none: true }];
    self.groupsInSuitable = false;
    self.mapDivisions = self.divisionSelect.map(function (division) { return division.id;});

    self.searchInviteMember = function (searchTerm) {

      return clientApi
        .custom(
          self.shifts ? 'model/ServiceShiftMember' : 'model/EventMember',
          self.shifts ? 'searchServiceMembers' : 'searchEventMembers', {
            divisionIds: self.inviteDivisionList.length > 0 ? self.mapDivisions : [self.divisionOptions[0].id],
            search: searchTerm,
            exclude: self.customInviteList
              .map(function (member) {
                return member.id;
              }),
            eventId: self.entityId,
            serviceId: self.entityId,
          })
        .then(function (results) {
          if (results && results.length && searchTerm == '*searchForAll*') {

            self.foundMemberList = results;
            self.searchSuitableMembers(results);
          }

          if (results && results.length) {
            self.inviteChoices = results;
          } else {
            self.inviteChoices = [{ none: true, foundNone: true }];
          }
        });
    };

    if (self.shifts) { 
      self.positions = [];
      self.shifts.forEach(function (shift) {
        shift.ServiceFunctions.forEach(function (position) {
          if (shift.ServiceShiftMembers.filter(function (ServiceShiftMember) {
            return ServiceShiftMember.ServiceFunctionId == position.id;
          }).length < position.PositionCount && position.Qualifications.length > 0) {

            self.positions.push(position.Qualifications);
          }
        });
      });
    }

    self.searchSuitableMembers = function (members) {
      var candidates = members
        .map(function (member) {
          return {
            MemberId: member.id,
            DivisionId: member.DivisionMembers ? member.DivisionMembers[0].DivisionId : member.divisionId,
          };
        });
      if (!candidates.length) {
        return Promise.resolve([]);
      }
      return clientApi
        .custom('model/ServiceShiftMember', 'attendeeRequirementFulfillment', {
          serviceId: self.entityId,
          candidates: candidates,
        })
        .then(function (result) {
          result.forEach(function (member) {
            self.positions.forEach(function (qualifications) {
              var notSuitable = false;
              qualifications.forEach(function (qualification) {
                var qualificationFound = _.find(member.memberQualifications, { id: qualification.id });
                if (!qualificationFound) {
                  notSuitable = true;
                }
              });
              if (!notSuitable && qualifications.length > 0) {
                self.customInviteList.push(_.find(self.foundMemberList, { id: member.MemberId }));
              }
            });
          });
          if (self.groupsInSuitable && self.customInviteList.length == 0)
          {
            toastr.warning('In der ausgewählten Gruppe sind keine passenden Mitglieder vorhanden.');
          }
        }
        )
        .catch(function () {
          return [];
        });
    };

    self.memberHasAttendeeStatus = function (member) {
      return !!~self.membersWithAttendeeStatus.indexOf(member.id);
    };

    $scope.$watch(function () {
      return self.memberToInvite;
    }, function () {
      if (self.memberToInvite && self.memberToInvite.none) {
        self.memberToInvite = null;
      }
    }, true);

    self.checkResetCustomInviteList = function (oldVal) {
      baModalService
        .messageModal({
          modalType: 'warning',
          allowHtml: false,
          title: 'Mitgliedsauswahl zurücksetzen',
          content: 'Bitte beachte, dass beim Wechsel des Gliederungsbereichs die aktuelle Mitgliedsauswahl zurückgesetzt wird!',
          primaryActionText: 'Fortfahren',
          secondaryActionText: 'Abbrechen',
        })
        .then(function () {
          self.customInviteList = [];
        })
        .catch(function () {
          self.ignoreNextSelectedDivisionWatch = true;
          self.divisionOptions[0] = _.find(self.divisionOptions, { id: oldVal.id });
        });
    };

    self.ignoreNextSelectedDivisionWatch = false;
    $scope.$watch(function () {
      return self.divisionOptions[0];
    }, function (newVal, oldVal) {
      if (newVal !== oldVal && !self.ignoreNextSelectedDivisionWatch) {
        if (self.customInviteList.length && self.sendOption === 'CUSTOM') {
          self.checkResetCustomInviteList(oldVal);
          return;
        }
        self.customInviteList = [];
      }
      self.ignoreNextSelectedDivisionWatch = false;
    }, true);

    $scope.$watch(function () {
      return self.sendOption;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal && newVal === 'SUITABLE') {
        self.searchInviteMember('*searchForAll*');
      }
      if (newVal !== oldVal && newVal === 'CUSTOM') {
        self.customInviteList = [];
      }
    });

    self.addInvite = function () {
      if (self.memberToInvite) {
        self.customInviteList.push(self.memberToInvite);
      }
      self.memberToInvite = null;
    };

    self.addDivision = function () {
      if (self.choosenDivision) {
        self.inviteDivisionList.push(self.choosenDivision);

        var divIndex = _.findIndex(self.divisionSelect, function (division) {
          return division.id === self.choosenDivision.id;
        });

        self.divisionSelect.splice(divIndex, 1);
        self.mapDivisions = self.inviteDivisionList.map(function (division) {
          return division.id;
        });

      }
      self.choosenDivision = null;

      if (self.sendOption === 'SUITABLE')
      {
        self.suitableMemberreset();
      }
    };

    self.addAllDivisions = function () {
     
      self.inviteDivisionList = self.divisionSelect.slice();

      self.choosenDivision = null;

      if (self.sendOption === 'SUITABLE')
      {
        self.suitableMemberreset();
      }
    };

    self.removeDivision = function (deletingDivision) {

      self.divisionSelect.push(deletingDivision);

      var divIndex = _.findIndex(self.inviteDivisionList, function (division) {
        return division.id === deletingDivision.id;
      });
      self.inviteDivisionList.splice(divIndex, 1);

      if (self.sendOption === 'SUITABLE')
      {
        self.suitableMemberreset();
      }
    };

    self.selectedMemberGroup = {};
    self.addGroupInvite = function () {

      if (!self.groupsInSuitable && self.sendOption === 'SUITABLE')
      {
        self.customInviteList = [];
        self.groupsInSuitable = true;
      }

      if (self.selectedMemberGroup && self.selectedMemberGroup.value) {
       
        var tempMembers = [];
        (self.selectedMemberGroup.value.Members || [])
          .forEach(function (member) {
            if (member.id !== $rootScope.ctx.currentUser.id && !_.find(self.customInviteList, { id: member.id })) {
              member.divisionId = self.selectedMemberGroup.value.DivisionId;

              if (self.sendOption === 'CUSTOM')
              {
                self.customInviteList.push(member);
              }
              if (self.sendOption === 'SUITABLE')
              {

                tempMembers.push(member);
              }
            }
          });

        if (self.sendOption === 'SUITABLE')
        {
          self.searchSuitableMembers(tempMembers);
        }

        self.selectedMemberGroup.value = undefined;
      }
    };

    self.removeInvite = function (member) {
      if (member) {
        self.customInviteList.splice(self.customInviteList.indexOf(member), 1);
        if (self.groupsInSuitable && self.customInviteList.length == 0)
        {
          self.suitableMemberreset();
        }
      }
    };

    self.suitableMemberreset = function () {
      self.customInviteList = [];
      self.groupsInSuitable = false;
      self.searchInviteMember('*searchForAll*');
    };

    self.applyModal = function ()
    {
     
      $uibModalInstance.close({
        divisionIds:  self.inviteDivisionList.length > 0 ? self.mapDivisions : [self.divisionOptions[0].id],
        sendOption: self.sendOption,
        inviteList: (self.sendOption === 'CUSTOM' || (self.sendOption === 'SUITABLE') ) ? self.customInviteList.map(function (member) { 
          return {
            MemberId: member.id,
            DivisionId: member.divisionId || member.DivisionMembers[0].DivisionId,
          };
        }) : []
      });
    };
  }
})();

(function () {

  angular.module('BlurAdmin.theme.components')
    .controller('EventMaterialCtrl', EventMaterialCtrl);

  /** @ngInject */
  function EventMaterialCtrl($scope, $timeout, commonUtils, $translate, $uibModal, materialUtil, baModalService, clientApi, ArnoDashMaterialsService) {

    // in the origin of this component it was integrated in shiftTemplate and therefore exclusively part of services;
    // we extracted all templates and logics and placed it in this component in order to make it reusable for simple events;
    // in order to not break existing logic and to not introduce a myriad of conditions for this material component to work with simple events,
    // ... we opted to introduce a "compatibility" layer where simple events pretend to have a matching datastructure to services like having shifts

    var self = this;

    self.materialsPerPage = 10;

    self.baseType = $scope.baseType;

    self.reverseShare = $scope.reverseShare;
    self.shift = $scope.shift;
    self.shifts = $scope.shifts;

    self.ctx = $scope.ctx;
    self.ctxName = $scope.ctxName;
    self.serviceMaterialMeta = $scope.materialMeta;
    self.hasManagePerm = $scope.hasManagePerm;
    self.initialBookingMaterialUtilization = $scope.initialBookingMaterialUtilization;
    self.bookingMaterialUtilizationFetch = $scope.bookingMaterialUtilizationFetch;
    self.quotationBase = $scope.quotationBase;
    self.quotationPositionImporter = $scope.quotationPositionImporter;

    self.bookingMaterialIncludedTree = [];

    self.addToBookingMaterialIncludedTree = function (trees) {
      if (!(trees || []).length) {
        return;
      }
      trees.forEach(function (tree) {
        var toAdd = [];
        var adder = function (base) {
          if ((base.children || []).length) {
            toAdd.push(base);
            base.children.forEach(function (child) {
              adder(child);
            });
          }
        };
        if (!_.find(self.bookingMaterialIncludedTree, { materialModel: tree.materialModel, id: tree.id })) {
          adder(tree);
          Array.prototype.push.apply(self.bookingMaterialIncludedTree, toAdd);
        }
      });
    };
    self.addToBookingMaterialIncludedTree($scope.initialBookingMaterialIncludedTree);

    self.hide = {
      materialEdit: $scope.hideEdit,
    }

    if (self.quotationBase) {
      self.hasMaterialPriceItemTypeInQuotationBase = _
        .filter(
          self.quotationBase.positions || [],
          { AdditionalMetaJson: { PriceItemType: 'MATERIAL' } }
        )
        .reduce(function (reduceObj, currentValue) {
          reduceObj['Material' + currentValue.AdditionalMetaJson.PriceItemSubType] = true;
          return reduceObj;
        }, {});

      self.hasMaterialTypePriceItemTypeInQuotationBase = _
        .filter(
          self.quotationBase.positions || [],
          { AdditionalMetaJson: { PriceItemType: 'MATERIAL_TYPE' } }
        )
        .reduce(function (reduceObj, currentValue) {
          reduceObj['Material' + currentValue.AdditionalMetaJson.PriceItemSubType] = true;
          return reduceObj;
        }, {});
    }

    self.isArray = function (candidate) {
      return Array.isArray(candidate);
    }

    self.isIn = function (arr, content) {
      return !!(arr && ~arr.indexOf(content));
    };

    self.materialModelMap = materialUtil.materialModelMap;
    self.materialMeta = {
      modelMap: self.materialModelMap,
      storageIconMap: materialUtil.materialStorageIconMap,
      assocKeys: {},
      columns: (self.serviceMaterialMeta || {}).columnDefinitions || [],
      util: materialUtil,
    };

    Object.keys(self.materialModelMap).forEach(function (fromKey) {
      self.materialMeta.assocKeys[fromKey] = 'ServiceShift' + (materialUtil.materialPluralizationMap[fromKey] || fromKey);
    });

    var defaultTableConfig = (self.serviceMaterialMeta || {}).defaultTableConfig || {};
    var customTableConfig = (self.serviceMaterialMeta || {}).customTableConfig || [];
    Object.keys(defaultTableConfig).forEach(function (defaultKey) {
      customTableConfig.unshift({
        Name: $translate.instant('modules.events.shiftTemplate.allFields'),
        ListType: defaultKey,
        Fields: self.materialMeta.columns[defaultKey]
          .map(function (header) {
            return header.prop;
          }),
        Aggregations: [],
      });
      customTableConfig.unshift({
        Name: $translate.instant('modules.events.shiftTemplate.standardView'),
        ListType: defaultKey,
        Fields: defaultTableConfig[defaultKey],
        Aggregations: [],
      });
    });
    self.materialMeta.tableConfig = _.groupBy(customTableConfig, 'ListType');

    Object.keys(self.materialMeta.modelMap)
      .forEach(function (key) {
        // remove Amount from view and column definition, it will be added manually as first col
        self.materialMeta.tableConfig[key]
          .forEach(function (viewConfig) {
            if (viewConfig && viewConfig.Fields && viewConfig.Fields.length) {
              var vcAmountIndex = viewConfig.Fields.indexOf('Amount');
              if (~vcAmountIndex) {
                viewConfig.Fields.splice(vcAmountIndex, 1);
              }
            }
          });
        var colAmountIndex = self.materialMeta.columns[key]
          .map(function (header) {
            return header.prop;
          })
          .indexOf('Amount');
        if (~colAmountIndex) {
          self.materialMeta.columns[key].splice(colAmountIndex, 1);
        }
      });

    self.material = {
      r: {}, // rows
      dc: {}, // display collection
      ctrl: {}, // smart table ctrl
      view: {}, // active view
      sf: {}, // search field
      agg: {}, // aggregations
      ts: {}, // tab state
      tsi: {}, // tab state initialized
      po: {}, // pre open func
    };

    self.restoreMaterialRowsFromSrc = function (shiftId, key) {
      var shift = _.find(self.shifts, { id: shiftId });
      self.material.r[shiftId][key] = self.material.r[shiftId][key] || [];
      self.material.r[shiftId][key].splice(0, self.material.r[shiftId][key].length);
      Array.prototype.push.apply(self.material.r[shiftId][key], _.cloneDeep(shift[self.materialMeta.assocKeys[key]]));
    };

    self.getSearchField = function (prop) {
      return ({
        'ResponsibleMember': 'ResponsibleMember.fullName',
        'LicenseClass': 'LicenseClass.Name',
        'Storage': 'Storage.Name',
        'MaterialType': 'MaterialType.Name',
      })[prop] || prop;
    };

    self.preOpenFactory = function (shiftId, key) {
      return function (callback) {
        // we set tsi to true, triggering the ng-if surrounding or st-table
        self.material.tsi[shiftId][key] = true;
        // the st-table will begin loading which could take a moment, depending on our data
        // it will block the event loop until it is ready
        // after it is ready, our timeout will fire, triggering the pre open callback, leading to the uib-accourdion-group to swing open
        // this way, the uib dosent immediately opens without the table having fully loaded; we need the ng-if on the table to improve loading performance
        // -> when all st-tables initialize upon event creation, page performance drastically deteriorates
        $timeout(callback, 0);
      };
    };

    $scope.$watch(function () {
      return self.shifts;
    }, function () {
      (self.shifts || []).forEach(function (shift) {
        Object.keys(self.material).forEach(function (initProp) {
          self.material[initProp][shift.id] = self.material[initProp][shift.id] || {};
        });
        Object
          .keys(self.materialMeta.modelMap)
          .forEach(function (key) {
            shift[self.materialMeta.assocKeys[key]] = shift[self.materialMeta.assocKeys[key]] || [];
            self.material.sf[shift.id][key] = self.material.sf[shift.id][key] || {};

            self.material.po[shift.id][key] = self.material.po[shift.id][key] || self.preOpenFactory(shift.id, key);

            self.restoreMaterialRowsFromSrc(shift.id, key);
          });
      });
    }, true);

    self.setMaterialView = function (shiftId, key, view) {
      if (self.material.ctrl[shiftId] && self.material.ctrl[shiftId][key]) {
        var $ctrl = self.material.ctrl[shiftId][key];

        // reset all current states
        var tableState = $ctrl.tableState();
        tableState.search = {};
        self.material.sf[shiftId][key] = {};
        tableState.sort = {};

        // apply view
        Object.keys(view.Sort || {}).forEach(function (sortKey) {
          $ctrl.sortBy(view.Sort[sortKey].sortProp, !(view.Sort[sortKey].direction === 'asc'));
        });
        self.material.agg[shiftId][key] = view.Aggregations || [];

        self.material.view[shiftId][key] = view;
        self.calculateAggregations(shiftId, key);

        $ctrl.pipe();

        commonUtils.preference.object.set('pref_service_material_' + key + '_view', { Name: view.Name });
      }
    };

    self.reapplyTableAggregation = function (shiftId, key) {
      // reapply aggregation after st collection recalc
      var watchOnce = $scope.$watch(function () {
        return self.material.r[shiftId] && self.material.r[shiftId][key];
      }, function () {
        watchOnce();
        self.calculateAggregations(shiftId, key, true);
      }, true);
    };

    self.processMaterialCount = function (shift, key, material, pCount) {
      var aggregatedCount = Array.isArray(material.id) ? material.id.length : 1;
      var previousCount = parseInt(pCount, 10) || 0;
      if (!parseInt(material.Count, 10)) {
        material.Count = 1;
      }
      if (material.Count > material.MaxCount) {
        material.Count = material.MaxCount;
      }
      if (material.Count < aggregatedCount) {
        material.Count = aggregatedCount;
      }

      var origMaterials = shift[self.materialMeta.assocKeys[key]];
      var countAddDiff = material.Count - previousCount; // positive for added counts

      if (countAddDiff === 0) {
        return;
      }

      var aggregatedIds = Array.isArray(material.id) ? material.id : [material.id];
      if (aggregatedCount > 1) {
        var materialMap = material.id
          .reduce(function (accumulator, materialId, index) {
            accumulator[materialId] =
              (((self.bookingMaterialUtilizationBase || {})[key] || {})[materialId] || {})[(material.BookingMaterialTimeIdRaw || [])[index]].fullyAvailable;
            return accumulator;
          }, {});
        aggregatedIds = _.sortBy(aggregatedIds, function (materialId) {
          return !materialMap[materialId];
        });
      }
      if (countAddDiff < 0) {
        aggregatedIds.reverse();
      }

      for (var i = 0; (i < aggregatedIds.length && countAddDiff !== 0); i++) {
        var currMaterialId = aggregatedIds[i];
        var found = _.find(origMaterials, { id: currMaterialId });
        if (countAddDiff > 0) {
          if (found.Count < found.MaxCount) {
            var addable = found.MaxCount - found.Count;
            var appliedAdd = Math.min(addable, countAddDiff);
            found.Count += appliedAdd;
            countAddDiff -= appliedAdd;
          }
        } else {
          if (found.Count > 1) {
            var appliedDiff = Math.min(found.Count - 1, Math.abs(countAddDiff));
            found.Count -= appliedDiff;
            countAddDiff += appliedDiff;
          }
        }
      }

      self.reapplyTableAggregation(shift.id, key);
      self.updateBookingMaterialUtilizationBase();
    };

    self.processBookingMaterialTimeChange = function (shift, key, material) {
      var origMaterials = shift[self.materialMeta.assocKeys[key]];
      var aggregatedIds = Array.isArray(material.id) ? material.id : [material.id];

      aggregatedIds.forEach(function (materialId) {
        var found = _.find(origMaterials, { id: materialId });
        found.BookingMaterialTimeId = material.BookingMaterialTimeId;
      });

      self.reapplyTableAggregation(shift.id, key);
      self.updateBookingMaterialUtilizationBase();
    };

    self.toggleMaterialAggregate = function ($event, shiftId, key, prop) {
      if ($event) {
        $event.stopPropagation();
      }
      self.material.agg[shiftId][key] = self.material.agg[shiftId][key] || [];

      var found = self.material.agg[shiftId][key].indexOf(prop);
      if (~found) {
        self.material.agg[shiftId][key].splice(found, 1);
      } else {
        self.material.agg[shiftId][key].push(prop);
      }

      self.calculateAggregations(shiftId, key);
    };

    self.handleMaterialAssocChange = function (shift, key, materialResult) {
      shift[self.materialMeta.assocKeys[key]] = shift[self.materialMeta.assocKeys[key]] || [];
      var materialIter = shift[self.materialMeta.assocKeys[key]].length;
      while (materialIter--) {
        if (~(materialResult.removedMaterialIds || []).indexOf((shift[self.materialMeta.assocKeys[key]][materialIter] || {}).id)) {
          shift[self.materialMeta.assocKeys[key]].splice(materialIter, 1);
        }
      }
      Array.prototype.push.apply(shift[self.materialMeta.assocKeys[key]], materialResult.addedMaterials);
      self.fetchBookingMaterialIncludedTree(materialResult.addedMaterials);
      self.reapplyTableAggregation(shift.id, key);
    }

    self.addMaterial = function (shift, key, filter) {
      return $uibModal
        .open({
          controller: 'shiftAddMaterialCtrl as $ama',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventMaterial/modals/shiftAddMaterial.html',
          size: 'lg',
          resolve: {
            materialModelName: function () {
              return self.materialMeta.modelMap[key];
            },
            divisionIds: function () {
              return [self.ctx];
            },
            ctxName: function () {
              return self.ctxName;
            },
            currentMaterial: function () {
              return key;
            },
            tableConfig: function () {
              return self.materialMeta.tableConfig[key];
            },
            sharedTblState: function () {
              return _.cloneDeep({
                view: self.material.view[shift.id][key],
                sf: self.material.sf[shift.id][key],
                agg: self.material.agg[shift.id][key],
                tableState: self.material.ctrl[shift.id][key] && self.material.ctrl[shift.id][key].tableState(),
              });
            },
            materialColumns: function () {
              return self.materialMeta.columns[key];
            },
            associatedMaterials: function () {
              return (shift[self.materialMeta.assocKeys[key]] || [])
                .map(function (material) {
                  return material.id;
                });
            },
            additionalTblQuery: function () {
              return filter;
            },
            bookingMaterialTimeDefault: function () {
              return ((shift.BookingMaterialTimes || [])[0]) || null;
            },
            baseType: function () {
              return self.baseType;
            },
            ArnoDashMaterialsService: function () {
              return ArnoDashMaterialsService;
            }
          }
        })
        .result
        .then(function (result) {
          self.handleMaterialAssocChange(shift, key, result);
          self.updateBookingMaterialUtilizationBase();
          self.updateMaterialApplicability();
        });
    };

    self.removeMaterial = function (shift, key, material) {
      baModalService
        .messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: $translate.instant('modules.events.shiftTemplate.modal.removeMaterialFromShift', {
            subject: shift.Subject || $translate.instant('modules.events.shiftTemplate.' + (self.baseType === 'SERVICE' ? 'newShift' : 'newEvent'))
          }),
          content: $translate.instant('modules.events.shiftTemplate.modal.doYouWantToRemove', {
            theMaterial:
              Array.isArray(material.id) && material.id.length > 1 ?
              $translate.instant('modules.events.shiftTemplate.modal.theMaterialPlural') :
              $translate.instant('modules.events.shiftTemplate.modal.theMaterialSingular'),
            name:
              material.Definition || material.VehicleModel || material.Name || $translate.instant('modules.events.shiftTemplate.modal.material'),
            newShift:
              shift.Subject || $translate.instant('modules.events.shiftTemplate.' + (self.baseType === 'SERVICE' ? 'newShift' : 'newEvent')),
            amount:
              Array.isArray(material.id) && material.id.length > 1 ?
              $translate.instant('modules.events.shiftTemplate.modal.pleaseNote', { amount: material.id.length }) :
              ''
          }),
          primaryActionText: $translate.instant('modules.events.shiftTemplate.remove'),
          secondaryActionText: $translate.instant('modules.events.shiftTemplate.cancel'),
        })
        .then(function () {
          var origMaterials = shift[self.materialMeta.assocKeys[key]];
          var aggregatedIds = Array.isArray(material.id) ? material.id : [material.id];
          aggregatedIds.forEach(function (currMaterialId) {
            var found = _.find(origMaterials, { id: currMaterialId });
            origMaterials.splice(origMaterials.indexOf(found), 1);
          });
          self.reapplyTableAggregation(shift.id, key);
          self.updateBookingMaterialUtilizationBase();
          self.updateMaterialApplicability();
        })
        .catch(function () {

        });
    };

    self.editBookingPeriods = function (shift) {
      $uibModal
        .open({
          controller: 'shiftMaterialBookingPeriodCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventMaterial/modals/shiftMaterialBookingPeriod.html',
          size: 'md',
          resolve: {
            shift: function () {
              return shift;
            },
            hasManagePerm: function () {
              return  self.hasManagePerm;
            },
          }
        })
        .result
        .then(function () {
          // set material bookingMaterialTimeId to valid id if previously selected BookingMaterialTime got deleted
          if (shift.BookingMaterialTimes && shift.BookingMaterialTimes.length) {
            var materialsToCheck = _.flatten(Object
              .keys(self.materialMeta.modelMap)
              .map(function (key) {
                return shift[self.materialMeta.assocKeys[key]] || [];
              }));
            var validBookingMaterialTimeIds = _.map(shift.BookingMaterialTimes, 'id');
            var fallbackBookingMaterialTimeId = (_.find(shift.BookingMaterialTimes, { IsDefaultPeriod: true }) || shift.BookingMaterialTimes[0] || {}).id;
            if (validBookingMaterialTimeIds.length && fallbackBookingMaterialTimeId) {
              materialsToCheck.forEach(function (material) {
                if (!~validBookingMaterialTimeIds.indexOf(material.BookingMaterialTimeId)) {
                  material.BookingMaterialTimeId = fallbackBookingMaterialTimeId;
                }
              });
            }
          }

          self.updateBookingMaterialUtilizationBase();
        })
        .catch(function () {
          // hm k
        });
    };
    self.reverseShare.editBookingPeriods = self.editBookingPeriods;

    self.calculateAggregations = function (shiftId, key, alreadyRestored) {
      if (!self.material.r[shiftId] || !self.material.r[shiftId][key] || !self.material.r[shiftId][key].length) {
        return;
      }
      if (!alreadyRestored) {
        self.restoreMaterialRowsFromSrc(shiftId, key);
      }

      var aggFields = ((self.material.agg[shiftId] || {})[key] || []);
      if (!aggFields.length) {
        return;
      }

      var aggregationReplacer = function (key, value) {
        if (key && key.indexOf && key.indexOf('_Material') === 0) {
          return undefined;
        }
        return value;
      };

      var rowSets = _
        .values(
          _.groupBy(self.material.r[shiftId][key], function (row) {
            return aggFields
              .map(function (aggField) {
                return JSON.stringify(row[aggField] || '', aggregationReplacer);
              })
              .join('⨝');
          })
        );
      rowSets = rowSets.map(function (rows) {
        var combined = {};
        Object
          .keys(rows[0])
          .forEach(function (rowProp) {
            if (rowProp === 'id') {
              combined[rowProp] = rows.map(function (row) {
                return row[rowProp];
              });
              return;
            }

            if (~['Amount', 'Count', 'MaxCount'].indexOf(rowProp)) {
              combined[rowProp] = rows.reduce(function (acc, row) {
                return acc + row[rowProp];
              }, 0);
              return;
            }

            if (~['ResponsibleMember', 'Storage', 'LicenseClass'].indexOf(rowProp)) {
              combined[rowProp] = _.intersectionBy(
                _.flatten(
                  rows
                    .map(function (row) {
                      return row[rowProp];
                    })
                ),
                { ResponsibleMember: 'fullName', Storage: 'Name', LicenseClass: 'Name' }[rowProp]
              );
              return;
            }

            if (rowProp === 'BookingMaterialTimeId') {
              combined[rowProp + 'Raw'] = rows
                .map(function (row) {
                  return row[rowProp];
                });
              combined[rowProp] = _.compact(_.uniq(combined[rowProp + 'Raw']));
              if (combined[rowProp].length < 2) {
                combined[rowProp] = combined[rowProp][0] || undefined;
              }
              return;
            }

            combined[rowProp] = _
              .uniq(
                rows
                  .map(function (row) {
                    var val = row[rowProp];
                    if (!self.materialMeta.util.propTypes[key][rowProp] || (
                      self.materialMeta.util.propTypes[key][rowProp]
                      && self.materialMeta.util.propTypes[key][rowProp].type !== 'date'
                      && self.materialMeta.util.propTypes[key][rowProp].type !== 'bool'
                    )) {
                      if (~[true, false].indexOf(row[rowProp])) {
                        val = row[rowProp] ? 'Ja' : 'Nein';
                      }
                      if (self.materialMeta.util.propTypes[key][rowProp] && self.materialMeta.util.propTypes[key][rowProp].formatter) {
                        try {
                          val = self.materialMeta.util.propTypes[key][rowProp].formatter(val);
                        } catch (e) {
                          // hm k
                        }
                      }
                    } else if (self.materialMeta.util.propTypes[key][rowProp]) {
                      if (self.materialMeta.util.propTypes[key][rowProp].type === 'date') {
                        val = self.materialMeta.util.parseDate(row[rowProp], { Aggregations: { aggregated: true } });
                      }
                      if (self.materialMeta.util.propTypes[key][rowProp].type === 'bool') {
                        val = self.materialMeta.util.boolFormatter(row[rowProp]);
                      }
                    }
                    return val || '-';
                  })
              )
              .sort()
              .join(', ')
          });
        return combined;
      });

      self.material.r[shiftId][key].splice(0, self.material.r[shiftId][key].length);
      Array.prototype.push.apply(self.material.r[shiftId][key], rowSets);
    };

    $scope.$watch(function () {
      return self.material.ctrl;
    }, function () {
      // ctrl inits
      (self.shifts || []).forEach(function (shift) {
        Object
          .keys(self.materialMeta.modelMap)
          .forEach(function (key) {
            if (!self.material.view[shift.id][key] && (self.material.ctrl[shift.id] && self.material.ctrl[shift.id][key])) {
              // a material table without a set view, but with a ctrl - ready to initialize default view
              var defaultViewName = (commonUtils.preference.object
                                       .get('pref_service_material_' + key + '_view', {
                                         Name: $translate.instant('modules.events.shiftTemplate.standardView')
                                       }) || {}).Name;
              var defaultView = (defaultViewName && _.find(self.materialMeta.tableConfig[key], { Name: defaultViewName }))
                                || _.find(self.materialMeta.tableConfig[key], { Name: $translate.instant('modules.events.shiftTemplate.standardView') });
              if (defaultView) {
                self.setMaterialView(shift.id, key, defaultView);
              }
            }
          });
      });
    }, true);

    self.bmubRef = {};
    self.bookingMaterialUtilizationBase = {};
    self.bmubRef.bookingMaterialUtilizationBase = self.bookingMaterialUtilizationBase;
    self.initialBookingMaterialUtilizationBase = {};
    self.shiftMaterialBookingIndicator = {};
    self.implicitInAvailability = {};
    self.reverseShare.updateBookingMaterialUtilizationBaseInProgress = false;
    self.updateBookingMaterialUtilizationBaseImmediate = function (bookingMaterialUtilization, initial) {
      if (!bookingMaterialUtilization && !self.hasManagePerm) {
        return;
      }
      if (self.reverseShare.updateBookingMaterialUtilizationBaseInProgress) {
        self.updateBookingMaterialUtilizationBase(bookingMaterialUtilization, initial);
        return;
      }
      self.reverseShare.updateBookingMaterialUtilizationBaseInProgress = true;

      var bookingMaterialTimeMap = {};
      (self.shifts || [])
        .forEach(function (serviceShift) {
          _.map(serviceShift.BookingMaterialTimes || [], 'id')
            .forEach(function (bookingMaterialTimeId) {
              bookingMaterialTimeMap[bookingMaterialTimeId] = serviceShift.id;
            });
        });

      Promise
        .resolve()
        .then(function () {
          if (bookingMaterialUtilization) {
            return bookingMaterialUtilization;
          }

          return self.bookingMaterialUtilizationFetch()
            .then(function (bookingMaterialUtilizationFetchResult) {
              self.informTheFleetAboutMaterialUtilizationFetch(bookingMaterialUtilizationFetchResult);
              return bookingMaterialUtilizationFetchResult;
            });
        })
        .catch(function () {
          return [];
        })
        .then(function (utilizations) {
          $scope.$evalAsync(function () {
            self.reverseShare.updateBookingMaterialUtilizationBaseInProgress = false;
            self.bookingMaterialUtilizationBase = {};
            self.bmubRef.bookingMaterialUtilizationBase = self.bookingMaterialUtilizationBase;
            self.implicitInAvailability = {};
            if (initial) {
              self.initialBookingMaterialUtilizationBase = self.bookingMaterialUtilizationBase;
            }
            self.shiftMaterialBookingIndicator = {};
            self.shiftMaterialBookingIncludedIndicator = {};

            self.bookingMaterialExpectedShortAmounts = {};
            self.reverseShare.bookingMaterialExpectedShortAmounts = self.bookingMaterialExpectedShortAmounts; // child component to parent reverse share

            utilizations.forEach(function (utilization) {
              var key = 'Material' + utilization.modelPartial;
              self.bookingMaterialUtilizationBase[key] = self.bookingMaterialUtilizationBase[key] || {};
              self.bookingMaterialUtilizationBase[key][utilization.materialId] = self.bookingMaterialUtilizationBase[key][utilization.materialId] || {};
              self.bookingMaterialUtilizationBase[key][utilization.materialId][utilization.bookingMaterialTimeId] = utilization;

              var current = self.bookingMaterialUtilizationBase[key][utilization.materialId][utilization.bookingMaterialTimeId];

              current.isImplicit = !!utilization.ImplicitInId;
              current.fullyAvailable = current.EffectiveAmount >= current.AskedAmount;
              current.unchangedFromInitial = current.AskedAmount ===
                                             (((self.initialBookingMaterialUtilizationBase[key] || {})[utilization.materialId] || {})[utilization.bookingMaterialTimeId] || {}).AskedAmount;

              if (current.isImplicit) {
                self.implicitInAvailability[utilization.ImplicitInId] = self.implicitInAvailability[utilization.ImplicitInId] || [];
                self.implicitInAvailability[utilization.ImplicitInId].push(current.fullyAvailable);
              }

              var shiftId = bookingMaterialTimeMap[utilization.bookingMaterialTimeId];
              self.shiftMaterialBookingIndicator[shiftId] = self.shiftMaterialBookingIndicator[shiftId] || {};
              self.shiftMaterialBookingIndicator[shiftId][key] = self.shiftMaterialBookingIndicator[shiftId][key]
                                                                 || (!current.isImplicit && !current.fullyAvailable);

              if (self.hasManagePerm && !current.isImplicit && !current.fullyAvailable) {
                self.bookingMaterialExpectedShortAmounts[key.replace('Material', '') + '|' + utilization.materialId + '|' + utilization.bookingMaterialTimeId] =
                  current.EffectiveAmount;
              }
            });

            var shiftReapply = [];
            utilizations.forEach(function (utilization) {
              var key = 'Material' + utilization.modelPartial;
              var current = self.bookingMaterialUtilizationBase[key][utilization.materialId][utilization.bookingMaterialTimeId];
              if (current.isImplicit) {
                (self.shifts || []).forEach(function (shift) {
                  var explicitBaseMaterial = _.find(
                    shift[self.materialMeta.assocKeys['Material' + utilization.modelPartial]] || [],
                    { id: utilization.materialId }
                  );

                  // make sure we found the material and that it isn't in a different shift
                  if (explicitBaseMaterial && _.find(shift.BookingMaterialTimes, { id: utilization.bookingMaterialTimeId })) {
                    if (explicitBaseMaterial.Count !== utilization.AskedAmount) {
                      explicitBaseMaterial.Count = utilization.AskedAmount;
                      shiftReapply.push({ shiftId: shift.id, key: key });
                    }
                    if (explicitBaseMaterial.BookingMaterialTimeId !== utilization.bookingMaterialTimeId) {
                      explicitBaseMaterial.BookingMaterialTimeId = utilization.bookingMaterialTimeId;
                      shiftReapply.push({ shiftId: shift.id, key: key });
                    }
                  }
                });

                return;
              }
              var shiftId = bookingMaterialTimeMap[utilization.bookingMaterialTimeId];
              self.shiftMaterialBookingIncludedIndicator[shiftId] = self.shiftMaterialBookingIncludedIndicator[shiftId] || {};
              self.shiftMaterialBookingIncludedIndicator[shiftId][key] = self.shiftMaterialBookingIncludedIndicator[shiftId][key]
                                                                         || (
                                                                           current.EffectiveAmount
                                                                           && (self.implicitInAvailability[utilization.bookingMaterialId] || []).length
                                                                           && (
                                                                             _.compact(self.implicitInAvailability[utilization.bookingMaterialId]).length
                                                                             !== self.implicitInAvailability[utilization.bookingMaterialId].length
                                                                           )
                                                                         );
            });

            if (shiftReapply.length) {
              _
                .uniqBy(shiftReapply, function (sr) {
                  sr.shiftId + '#' + sr.key
                })
                .forEach(function (sr) {
                  self.reapplyTableAggregation(sr.shiftId, sr.key);
                });
            }
          });
        });
    };
    self.updateBookingMaterialUtilizationBase = _.debounce(self.updateBookingMaterialUtilizationBaseImmediate, 1200)
    self.reverseShare.updateBookingMaterialUtilizationBase = self.updateBookingMaterialUtilizationBase;
    self.updateBookingMaterialUtilizationBaseImmediate(self.initialBookingMaterialUtilization, true);

    self.reverseShare.updateBookingMaterialUtilizationBaseImmediates = self.reverseShare.updateBookingMaterialUtilizationBaseImmediates || [];
    self.reverseShare.updateBookingMaterialUtilizationBaseImmediates.push(self.updateBookingMaterialUtilizationBaseImmediate);

    self.informTheFleetAboutMaterialUtilizationFetch = function (fetchResult) {
      var others = _.difference(self.reverseShare.updateBookingMaterialUtilizationBaseImmediates, [self.updateBookingMaterialUtilizationBaseImmediate]);
      if (others.length) {
        others.forEach(function (other) {
          other(fetchResult);
        })
      }
    }

    $scope.$on('$destroy', function () {
      self.reverseShare.updateBookingMaterialUtilizationBaseImmediates.splice(
        self.reverseShare.updateBookingMaterialUtilizationBaseImmediates.indexOf(self.updateBookingMaterialUtilizationBaseImmediate),
        1
      );
    });

    self.stableBookingMaterialUtilizationAggregationObjCache = {};
    self.bookingMaterialUtilizationAggregationCalc = function (key, material) {
      if (!key || !material || !Array.isArray(material.id) || !material.id.length) {
        return {};
      }
      self.stableBookingMaterialUtilizationAggregationObjCache[key] = self.stableBookingMaterialUtilizationAggregationObjCache[key] || {};
      self.stableBookingMaterialUtilizationAggregationObjCache[key][material.id] = self.stableBookingMaterialUtilizationAggregationObjCache[key][material.id] || {};

      var materialUtilizations = material.id
        .map(function (materialId, index) {
          return (((self.bookingMaterialUtilizationBase || {})[key] || {})[materialId] || {})[(material.BookingMaterialTimeIdRaw || [])[index]];
        });
      var materialUtilizationsLength = materialUtilizations.length;
      var isInactive =
        _.compact(materialUtilizations).length !== materialUtilizationsLength || _.sumBy(materialUtilizations, 'AskedAmount') !== material.Count;
      var isGreen = !isInactive && _.compact(_.map(materialUtilizations, 'fullyAvailable')).length === materialUtilizationsLength;
      var isYellow = !isInactive && !isGreen;
      Object.assign(self.stableBookingMaterialUtilizationAggregationObjCache[key][material.id], {
        isInactive: isInactive,
        isGreen: isGreen,
        isYellow: isYellow,
        AskedAmount: _.sumBy(materialUtilizations, 'AskedAmount'),
        EffectiveAmount: _.sumBy(materialUtilizations, 'EffectiveAmount'),
        unchangedFromInitial: _.compact(_.map(materialUtilizations, 'unchangedFromInitial')).length === materialUtilizationsLength,
      });
      return self.stableBookingMaterialUtilizationAggregationObjCache[key][material.id];
    };

    self.bookingMaterialIncludedAvailableClass = function (current) {
      var availabilityIndicatorList = (self.implicitInAvailability || {})[current.bookingMaterialId] || [];
      if (!current.EffectiveAmount || _.compact(availabilityIndicatorList).length === availabilityIndicatorList.length) {
        return 'btn-default';
      }
      return 'btn-warning';
    };

    self.importFromQuotation = function (shift, materialKey, isMaterialTypeImport) {
      $uibModal
        .open({
          controller: 'shiftImportQuotationCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventMaterial/modals/shiftImportQuotation.html',
          size: 'md',
          resolve: {
            quotationBase: function () {
              return self.quotationBase;
            },
            parentCtrl: function () {
              return self;
            },
            parentLabel: function () {
              return shift ? shift.Subject : (self.options.template.Label || self.options.template.Subject || $translate.instant('modules.events.service.NewService'));
            },
            materialKey: function () {
              return materialKey;
            },
            isMaterialTypeImport: function () {
              return !!isMaterialTypeImport;
            },
          }
        })
        .result
        .then(function (position) {
          if (position) {
            self.quotationPositionImporter(self, shift, position, materialKey, isMaterialTypeImport);
          }
        });
    };
    self.reverseShare.importFromQuotation = self.importFromQuotation;

    self.fetchBookingMaterialIncludedTree = function (addedMaterials) {
      var materialsToFetchIncludedFor = addedMaterials
        .filter(function (mat) {
          return mat.StorageContents && mat.StorageContents.OriginId && mat.StorageContents.OriginModel;
        })
        .map(function (mat) {
          return {
            id: parseInt(mat.StorageContents.OriginId, 10),
            materialModel: mat.StorageContents.OriginModel,
          };
        });
      if (materialsToFetchIncludedFor.length) {
        return clientApi
          .custom(
            'model/BookingMaterial',
            'bookingMaterialIncludedTree',
            { materials: materialsToFetchIncludedFor },
            { backgroundRequest: true }
          )
          .then(function (trees) {
            $scope.$evalAsync(function () {
              self.addToBookingMaterialIncludedTree(trees || []);
            });
          });
      }
    };

    self.hasMaterialHierarchy = function (materialKey, materialId) {
      return _.find(self.bookingMaterialIncludedTree, { materialModel: materialKey, id: materialId });
    };

    self.openMaterialHierarchy = function (materialKey, materialId, bookingMaterialTimeId, active) {
      $uibModal
        .open({
          controller: 'materialHierarchyCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventMaterial/modals/materialHierarchy.html',
          size: 'md',
          resolve: {
            hierarchy: function () {
              return self.hasMaterialHierarchy(materialKey, materialId);
            },
            bookingMaterialUtilizationBaseRef: function () {
              return self.bmubRef;
            },
            bookingMaterialTimeId: function () {
              return bookingMaterialTimeId;
            },
            active: function () {
              return active;
            },
            storageIconMap: function () {
              return self.materialMeta.storageIconMap;
            },
          }
        });
    };

    self.materialApplicability = {};
    self.hasMaterialApplicabilities = false;
    self.updateMaterialApplicability = function () {
      var materials = _.flattenDeep(
        Object
          .keys(self.materialMeta.modelMap)
          .map(function (key) {
            return (self.shift[self.materialMeta.assocKeys[key]] || [])
              .map(function (material) {
                var hierarchy = self.hasMaterialHierarchy(key, material.id);
                var fromHierarchy = [];
                if (hierarchy) {
                  var mapChildren = function(path) {
                    if (!path.children || !path.children.length) {
                      return [];
                    }
                    return path.children
                      .map(function(child) {
                        return [{ id: child.id, materialModel: child.materialModel }].concat(mapChildren(child));
                      });
                  }
                  fromHierarchy = mapChildren(hierarchy);
                }
                return fromHierarchy.concat([{ id: material.id, materialModel: key }]);
              });
          })
      )

      return clientApi
        .custom(
          'model/MaterialInspectionDemand',
          'materialApplicability', {
            divisionId: self.ctx,
            materials: _.uniqWith(materials,_.isEqual),
          },
          { backgroundRequest: true }
        )
        .then(function (applicabilities) {
          $scope.$evalAsync(function () {
            self.hasMaterialApplicabilities = applicabilities.length;
            self.materialApplicability = {
              overdue: _.filter(applicabilities, 'Overdue'),
              failed: _.filter(applicabilities, 'Failed'),
              task: _.filter(applicabilities, 'Task'),
            };
          });
        });
    };

    self.openMaterialDossier = function(materialId, materialModel) {
      return ArnoDashMaterialsService.openAddModal(
        { id: materialId },
        'update',
        false,
        [self.ctx],
        materialModel
      );
    }

    self.updateMaterialApplicability();
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('eventMaterial', eventMaterial);

  /** @ngInject */
  function eventMaterial() {
    return {
      restrict: 'AE',
      replace: 'true',
      templateUrl: 'app/theme/components/eventMaterial/eventMaterial.html',
      scope: {
        baseType: '=',

        reverseShare: '=',
        shift: '=',
        shifts: '=',
        hideEdit: '=',

        ctx: '<',
        ctxName: '<',
        materialMeta: '<',
        hasManagePerm: '<',
        initialBookingMaterialUtilization: '<',

        bookingMaterialUtilizationFetch: '=',
        quotationPositionImporter: '=',

        quotationBase: '=?',

        initialBookingMaterialIncludedTree: '<',
      },
      controller: 'EventMaterialCtrl as self',
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('eventCalendar', eventCalendar);

  /** @ngInject */
  function eventCalendar() {
    return {
      restrict: 'AE',
      replace: 'true',
      templateUrl: 'app/theme/components/eventCalender/eventCalender.html',
      scope: {
        categories: '=',
        attendanceStates: '<',
        chosenSharedFilters: '=',
        eventTypes: '<',
        ctx: '<',
        calView: '=?',
        calMode: '=?',
        loopBack: '=?',
        flowStepConfig: '=?',
      },
      controller: 'EventCalenderCtrl as $eventCalCtrl',
    }
  }
})
();


(function () {

  angular.module('BlurAdmin.theme.components')
    .controller('EventCalenderCtrl', EventCalenderCtrl);
  /** @ngInject */
  function EventCalenderCtrl(clientApi, $location, $state, $scope, toastr, $timeout, $rootScope, commonUtils, $compile, $translate, screenSize) {
    var self = this;

    self.isOverviewPage = $location.$$path === '/events/overview';
    self.categories = $scope.categories;
    self.chosen = $scope.chosenSharedFilters;
    self.ctx = ($scope.ctx || []).map(function (divId) {
      return parseInt(divId, 10);
    });
    self.calMode = $scope.calMode || false;
    self.previewDetails = !!~['listMonth', 'nearFuture'].indexOf($scope.calView);
    self.loopBack = $scope.loopBack || {};
    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });
    self.flowStepConfig = $scope.flowStepConfig;
    self.choosenLanguage = $translate.use();

    $.fullCalendar.views.nearFuture = {
      'class': ($.fullCalendar.views.list['class']).extend({
        computeRange: function (date) {
          return {
            intervalUnit: 'day',
            intervalStart: moment(date).startOf('day'),
            intervalEnd: moment(date).add(3, 'months').endOf('day'),
            start: moment(date).startOf('day'),
            end: moment(date).add(3, 'months').endOf('day'),
          };
        },
      }),
      defaults: {
        listDayAltFormat: 'dddd',
        listDayFormat: 'LL'
      }
    };

    $.fullCalendar.views.listMonth.defaults.listDayFormat = 'W | LL';

    self.initCalendarElement = function (ovStartDate) {
      if (self.calendar) {
        self.calendar.fullCalendar('destroy');
      }
      self.calendarPrefKey = 'event-cal-' + $scope.calView + '-' + self.calMode;
      self.calendar = $('#calendarSheet').fullCalendar({
        locale: self.choosenLanguage,
        lang: 'de',
        height: 650,
        firstDay: 1,
        header: {
          left: 'listMonth, month',
          center: 'title',
          right: $scope.calView === 'nearFuture' ? '' : 'today prev,next'
        },
        buttonText: {
          listDay: $translate.instant('modules.events.calendar.day'),
          listWeek: $translate.instant('modules.events.calendar.week'),
          listMonth: $translate.instant('modules.events.calendar.listMonth'),
          month: $translate.instant('modules.events.calendar.calendar'),
        },
        noEventsMessage: $translate.instant('modules.events.calendar.noEvents'),
        defaultDate: (function () {
          return ovStartDate || moment().startOf('day');
        })(),
        defaultView: $scope.calView || (self.mediaSizeXS ? 'listMonth' : 'month'),
        timeFormat: 'HH:mm',
        timezone: 'local',
        selectable: true,
        selectHelper: true,
        eventLimit: false,
        weekNumbers: true,
        editable: false,
        eventStartEditable: false,
        eventDurationEditable: false,
        nextDayThreshold: '00:00:00',
        dayClick: function (date) {
          self.createEvent(date, self.ctx);
        },
        eventClick: function (event) {
          if (event.IsService) {
            var stateGoOpts = {
              serviceId: event.id,
            };
            if (event.shiftId) {
              stateGoOpts['#'] = 'sidref' + event.shiftId;
            }
            $state.go('arno.events.serviceDetail', stateGoOpts);
            return;
          }
          $state.go('arno.events.eventDetail', { eventId: event.id });
        },
        eventRender: function (event, element) {
          var isPassed = false;
          var isToday = false;
          var timeStr = '';
          var isListItem = element.hasClass('fc-list-item');

          try {
            var isSameDay = event._start.isSame(event._end, 'day');
            var timeFormat = 'HH:mm';
            if (!isSameDay) {
              timeFormat = 'DD.MM.YYYY HH:mm';
            }
            isPassed = event._end.isBefore(moment());
            isToday = !isPassed && (
              (event._start.isBefore(moment().startOf('day')) && event._end.isAfter(moment().startOf('day')))
              || (event._start.isAfter(moment().startOf('day')) && event._start.isBefore(moment().endOf('day')))
            );
            timeStr = event._start.format(timeFormat) + ' - ' + event._end.format(timeFormat);
            if (!isSameDay && timeStr.split(' ').length === 5) {
              var splittedTime = timeStr.split(' ');
              timeStr = '<i>' + splittedTime[0] + '</i> ' + splittedTime[1] + ' ' + splittedTime[2] + ' <i>' + splittedTime[3] + '</i>' + ' ' + splittedTime[4];
            }
          } catch (e) {
            console.warn('Unable to fully render event "' + event.id  + '" due to: ' + ((e && e.stack) || (e && e.message) || (e && e.toString())));
          }

          var contentNode = element.find('.fc-content');
          if (!contentNode.length) {
            element.html('<td colspan="3" class="fc-event"><div class="fc-content fc-listview-content"></div></td>');
            contentNode = element.find('.fc-content');
          }
          contentNode.html('<event-calendar-tile></event-calendar-tile>');

         

          var compileScope = $scope.$new();
          compileScope.tileData = {
            id: event.id,
            isListItem: isListItem,
            isService: event.IsService,
            shiftId: event.shiftId,
            title: event.title,
            metaTitle: event.metaTitle,
            time: timeStr,
            iconInfos: event.iconInfo || [],
            categories: event.categories || [],
            categoriesAllNames: (event.categories || []).map(function (cat) {
              return cat.name;
            }).join(', '),
            previewDetails: event.previewDetails,
            calMode: self.calMode,
            remark: event.remark,
            jobSite: event.jobSite,
            refiner: self.chosen.refiner,
            ownEventMember: event.ownEventMember || undefined,
            shiftRelevantDivisions: event.shiftRelevantDivisions || [],
            serviceShiftMember: event.serviceShiftMember,
            attendanceInfo: event.attendanceInfo,
            isServiceShift: event.IsServiceShift,
            context: self.ctx,
            selfAttend: event.selfAttend,
            ServiceType: event.ServiceType,
            flowState: event.flowState,
            divisionName: event.divisionName,
            location_name: event.location_name,
            meeting_place_name: event.meeting_place_name,
            meeting_time: event.meeting_time ? moment(event.meeting_time).format('HH:mm') : undefined,
            canSelfAttend: event.canSelfAttend,
          };
          $compile(contentNode)(compileScope);

          if (isPassed) {
            element.addClass('cal-event-passed');
          }
          if (isToday) {
            element.addClass('cal-event-today-not-passed');
          }
        },
        eventAfterAllRender: function (view) {
          if (view && ~['nearFuture', 'listMonth'].indexOf(view.type) && view.el && view.el.length) {
            view.el.find('.fc-list-heading').each(function () {
              var headingDate = moment($(this).attr('data-date')).startOf('day');
              var nowStartOfDay = moment().startOf('day');
              var nowEndOfDay = moment().endOf('day');
              if (headingDate.isSame(nowStartOfDay, 'day')) {
                $(this).addClass('cal-event-list-present');
              } else if (headingDate.isBefore(nowStartOfDay)) {
                $(this).addClass('cal-event-list-past');
              } else if (headingDate.isAfter(nowEndOfDay)) {
                $(this).addClass('cal-event-list-future');
              }
            });
          }

          $scope.$evalAsync(function () {
            if (view && view.calendar && view.calendar.getEventCache && (view.calendar.getEventCache() || []).length) {
              self.refreshSize(4);
            }
          });
        },
        events: self.getEvents,
        windowResize: function () {
          if (!self.calMode) {
            var viewMode = self.mediaSizeXS ? 'listMonth' : 'month';
            $('#calendarSheet').fullCalendar( 'changeView', viewMode);
          }
        }
      });

      self.refreshSize = function (repeat, sleep) {
        var view = self.calendar && self.calendar.fullCalendar('getView');
        if (view && view.updateSize) {
          view.updateSize(true);
        }
        if (repeat) {
          setTimeout(function () {
            self.refreshSize(repeat - 1, sleep);
          }, sleep || 100);
        }
      };

      $scope.$watch(function () {
        return self.chosen;
      }, function () {
        self.calendar.fullCalendar('refetchEvents');
      }, true);
    };

    self.loopBack.calendarInit = self.initCalendarElement;

    self.getEvents = function (start, end, aParam, callback) {
      if (!self.ctx || !self.ctx.length) {
        return callback([]);
      }
      var detailAttributes = [];
      if (self.previewDetails) {
        // event & (through stored procedure mapped) service fields
        detailAttributes = detailAttributes.concat(['Description', 'LocationName', 'MeetingPlaceName', 'MeetingTime']);
      }
      var options = {
        divisionId: self.ctx,
        startDate: start,
        endDate: end,
        categories: self.chosen.categories.map(function (category) {
          return category.id;
        }),
        showArchived: !self.chosen.onlyActive,
        previewDetails: true,
        attributes: [
          'id',
          'Subject',
          'StartDate',
          'EndDate',
          'BaseCategory',
          'SourceDivisionId',
          'OrganizerId',
          'Series',
          'Attendance',
          'LocationName',
          'MeetingPlaceName',
          'MeetingTime',
          'JobSite',
        ].concat(detailAttributes),
        fetchType: self.calMode || undefined,
        eventType: self.chosen.eventType || undefined,
        showShifts: (~['MY_SERVICES'].indexOf(self.chosen.refiner)) || false,
        hideServiceMeta: (self.previewDetails && ~['MY_SERVICES'].indexOf(self.chosen.refiner)) || false,
        onlyAttendingState: !self.previewDetails || (self.previewDetails && self.chosen.refiner === 'MY_SERVICES') || false,
        attendingState: !self.previewDetails || false,
        exactAttendingTypes: self.chosen.attendanceType.map(function (at) {
          return at.type;
        }) || undefined,
        serviceType: (self.chosen.serviceType && self.chosen.serviceType.id) || undefined,
      };
      return clientApi.custom('model/Event', 'getCalendarEvents', { options: options })
        .then(function (events) {
          var result = [];

          self.categories.splice(0, self.categories.length);
          Array.prototype.push.apply(self.categories, events.baseCategories || []);
          self.categories.push({
            id: null,
            Name: $translate.instant('modules.events.calendar.notCategorized'),
            Color: '#FFF',
            DivisionId: null,
            OrganizationId: $rootScope.ctx.organization.current.id,
            italic: true,
          });

          if (events && events.results && events.results.length) {
            result = events.results.map(function (event) {
              var iconInfo = [];
              if (event.OrganizerId === $rootScope.ctx.currentUser.id) {
                iconInfo.push({ class: 'fa fa-star', title: $translate.instant('modules.events.calendar.ownEvents') });
              }
              if (!~self.ctx.map(function (c) {
                return c.toString();
              }).indexOf(event.SourceDivisionId.toString())) {
                iconInfo.push({ class: 'fa fa-share-square-o', title: $translate.instant('modules.events.calendar.sharedEvent') });
              }
              if (event.Series) {
                iconInfo.push({ class: 'fa fa-repeat', title: $translate.instant('modules.events.calendar.eventSeries') });
              }
              if (self.isOverviewPage && event.IsServiceShift && event.serviceShiftMember === undefined) {
                return null; // skip shifts without any kind of reaction of the user from overview page
              }

              commonUtils.division.divisionTreeData.forEach(function (div) {
                if (div.id == event.SourceDivisionId) {
                  self.sourceDivisionName = div.Name;
                }
              });
             
              return {
                id: event.ServiceId || event.id,
                shiftId: event.ServiceId && event.id,
                title: event.ServiceSubject ? event.ServiceSubject : event.Subject,
                metaTitle: event.ServiceSubject ? event.Subject : undefined,
                remark: event.Remark || undefined,
                jobSite: event.JobSite || undefined,
                start: event.StartDate,
                end: event.EndDate,
                divisionName: self.sourceDivisionName,
                color: '#FFF',
                textColor: '#000',
                location_name: event.LocationName || undefined,
                meeting_place_name: event.MeetingPlaceName || undefined,
                meeting_time: event.MeetingTime || undefined,
                categories: (event.BaseCategory || [])
                  .filter(function (cat) {
                    return cat;
                  })
                  .map(function (cat) {
                    return {
                      color: cat.Color,
                      name: (_.find(self.categories, { id: cat.id }) || {}).Name || cat.Name
                    };
                  }),
                iconInfo: iconInfo.reverse(),
                previewDetails: detailAttributes.length ? detailAttributes.reduce(function (accumulator, currentValue) {
                  accumulator[currentValue] = event[currentValue];
                  if (currentValue === 'MeetingTime' && event[currentValue]) {
                    accumulator[currentValue] = moment(event[currentValue]).format('HH:mm');
                  }
                  return accumulator;
                }, {}) : null,
                IsService: !!event.IsService,
                IsServiceShift: !!event.IsServiceShift,
                ownEventMember: events.ownEventMember || undefined,
                shiftRelevantDivisions: event.shiftRelevantDivisions || event.divisionShare,
                serviceShiftMember: event.serviceShiftMember,
                attendanceInfo: event.attendanceInfo || event.Attendance,
                selfAttend: event.selfAttend,
                ServiceType: event.ServiceType,
                flowState: (event.FlowState && _.find(self.flowStepConfig || [], { ident: event.FlowState })) || undefined,
                canSelfAttend: event.canSelfAttend || false,
              };
            })
            .filter(function (event) {
              return event !== null;
            });
            if (events.limited) {
              toastr.warning(
                $translate.instant('modules.events.calendar.toasterWarning'),
                $translate.instant('modules.events.calendar.toasterWarning2')
              );
            }
          }

          var startDate = moment(start);
          if (startDate.date() !== 1) {
            // the calendar sheet displays the end of the previous month most of the time
            // save the start of the month in view
            startDate.add(1, 'month').startOf('month');
          }
          commonUtils.preference.object.set(self.calendarPrefKey + -'startDate', { start: startDate.toISOString() }, 1000 * 60 * 60 * 8);

          return result;
        })
        .catch(function () {
          return [];
        })
        .then(function (events) {
          callback(events);
        });
    };

    self.createEvent = commonUtils.event.createEvent;
    self.getShowElement = commonUtils.event.getShowElement;

    self.initCalendarElement();
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('eventCalendarTile', eventCalendarTile);

  /** @ngInject */
  function eventCalendarTile() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/eventCalendarTile/eventCalendarTile.html',
      scope: false,
      controller: 'eventCalendarTileCtrl as $tile'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('eventCalendarTileCtrl', eventCalendarTileCtrl);

  /** @ngInject */
  function eventCalendarTileCtrl($rootScope, $location, $scope, clientApi, toastr, permissions, eventUtil, $translate, screenSize) {
    var self = this;

    self.currentUrl = $location.$$path;

    self.data = $scope.tileData;

    self.data.isSharedEvent = self.data.iconInfos.some(function (iconInfo) {
      return iconInfo.title === 'Geteilte Veranstaltung';
    });

    self.divisionCount = $scope.$parent.ctx.length;

    self.currentUser = $scope.$root.ctx.currentUser;

    self.eventAcceptance = null;

    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });

    self.eventAttendanceCount = _.filter(
      self.data.attendanceInfo,
      function (attendanceInfo) {
        return attendanceInfo.Acceptance === true;
      }
    ).length;

    if (self.data.attendanceInfo.length > 0) {
      var acceptanceFound;
      acceptanceFound = _.find(
        self.data.attendanceInfo,
        function (attendanceInfo) {
          return attendanceInfo.MemberId === self.currentUser.id;
        }
      );

      if (acceptanceFound != null) {
        self.eventAcceptance = acceptanceFound.Acceptance;
      }
    }

    self.truncate = function (text, length) {
      return _.truncate(text, { 'length': length, 'separator': ' ', omission: ' [...]' });
    };

    self.downloadICAL = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }
      clientApi.openTab('event/service-shift-ical', {
        serviceId: self.data.id,
        shiftIds: [self.data.shiftId],
      });
    };

    self.preventClick = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }
    };

    self.openServiceScrollToShift = function () {
      $rootScope.openServiceScrollToShift = true;
    };

    self.attendanceAdd = function (acceptance) {
      self.permittedToAttend = permissions.getPermittedIds(
        'arno.events.basic.view',
        'Division',
        self.data.context,
        false
      );
      if (!self.permittedToAttend || !self.permittedToAttend.length) {
        return;
      }
      var updateAttendee = self.data.ownEventMember;
      updateAttendee.fullName = updateAttendee.fullName || updateAttendee.Member.fullName;
      var currentPermittedContext = _.intersection(self.permittedToAttend, self.data.context);

      return Promise.resolve().then(function () {
        if (self.permittedToAttend.length > 1) {
          return eventUtil.chooseAttendanceDivisionModal(
            updateAttendee,
            updateAttendee.DivisionMembers.filter(function (dm) {
              return ~self.permittedToAttend.indexOf(dm.DivisionId);
            }).map(function (dm) {
              return {
                label: dm.Division.Name,
                dm: dm,
                defaultSelected: (function () {
                  if (acceptance && currentPermittedContext.length === 1) {
                    return dm.DivisionId === currentPermittedContext[0];
                  }
                  return dm.DivisionId === ((self.data.serviceShiftMember || {}).Division || {}).id;
                })(),
              };
            }),
            'SERVICE'
          ).then(function (choice) {
            return choice.dm;
          });
        }
        return _.find(updateAttendee.DivisionMembers, { DivisionId: self.permittedToAttend[0] });
      }).then(function (divisionMember) {
        return Promise.resolve().then(function () {
          if (self.data.serviceShiftMember && self.data.serviceShiftMember.Division
            && self.data.serviceShiftMember.Division.id !== divisionMember.DivisionId) {
            self.data.serviceShiftMember.fullName = self.data.ownEventMember.fullName;
            return eventUtil.attendanceDivisionChangeWarnModal(self.data.serviceShiftMember, divisionMember, 'SERVICE');
          }
          return null;
        }).then(function () {
          return divisionMember;
        });
      }).then(function (divisionMember) {
        return clientApi.custom('model/ServiceShiftMember', 'updateOwnAttendance', {
          serviceId: self.data.id,
          shiftId: self.data.shiftId,
          divisionId: divisionMember.DivisionId,
          acceptance: acceptance,
        }).then(function (newShiftMember) {
          $scope.$evalAsync(function () {
            self.data.serviceShiftMember = newShiftMember;
            if (self.data.serviceShiftMember.Acceptance && self.data.attendanceInfo) {
              self.data.attendanceInfo.acceptedMemberCount++;
            }
            if (!self.data.serviceShiftMember.Acceptance && !self.data.serviceShiftMember.Interested && self.data.attendanceInfo) {
              self.data.attendanceInfo.acceptedMemberCount--;
            }
            var divisionInfo = _.find(updateAttendee.DivisionMembers || [], { DivisionId: newShiftMember.DivisionId });
            if (divisionInfo && divisionInfo.Division) {
              self.data.serviceShiftMember.Division = { Name: divisionInfo.Division.Name, id: divisionInfo.DivisionId };
            }
          });
          toastr.success(
            $translate.instant('modules.events.calendar.toastr.participationReportRecordedMsg'),
            $translate.instant('modules.events.calendar.toastr.participationReportRecordedTitle')
          );
        }).catch(function () {
          toastr.error(
            $translate.instant('modules.events.calendar.toastr.participationReportFailedMsg'),
            $translate.instant('modules.events.calendar.toastr.participationReportFailedTitle')
          );
        });
      }).catch(function () {
        // hm k
      });
    };

    self.attendanceAddEvent = function (acceptance) {
      self.permittedToAttend = permissions.getPermittedIds(
        'arno.events.basic.view',
        'Division',
        self.data.context,
        false
      );

      var options = {
        eventId: self.data.id,
      };

      clientApi
        .custom('model/Event', 'getEventDetails', {
          options: options,
        })
        .then(function (response) {
          var Event = response.results[0];
          var SourceDivision = {
            Name: Event.SourceDivisionName,
            id: Event.SourceDivisionId,
          };
          if (Event.canSelfAttend === Event.divisionShareUserDivision.length + 1) {
            Event.divisionShareUserDivision.push(SourceDivision);
          }
          if (Event.divisionShareUserDivision.length > 1) {
            return eventUtil
              .chooseAttendanceDivisionModal(
                self.currentUser,
                Event.divisionShareUserDivision
                  .filter(function (dm) {
                    return ~$scope.$parent.ctx.includes(dm);
                  })
                  .map(function (dm) {
                    return {
                      label: dm.Name,
                      dm: dm,
                      defaultSelected: (function () {
                        if (dm.id === Event.SourceDivisionId) {
                          return true;
                        } else {
                          var defaultselect;

                          _.find(Event.divisionShareUserDivision, function (divisionShare) {
                            if (divisionShare.id === dm.id) defaultselect = true;
                          });

                          _.find(Event.divisionShareUserDivision, function (divisionShare) {
                            if (divisionShare.id === Event.SourceDivisionId) {
                              defaultselect = false;
                            }
                          });
                          return defaultselect;
                        }
                      })(),
                    };
                  }),
                'EVENT'
              )
              .then(function (choice) {
                return choice.dm;
              });
          } else {
            return Event.divisionShareUserDivision[0];
          }
        })
        .then(function (divisionMember) {
          return clientApi.custom('model/EventMember', 'updateOwnAttendance', {
            eventId: self.data.id,
            divisionId: divisionMember && divisionMember.id,
            acceptance: acceptance,
          });
        })
        .catch(function () {
          toastr.error(
            $translate.instant(
              'modules.events.calendar.toastr.participationReportFailedMsg'
            ),
            $translate.instant(
              'modules.events.calendar.toastr.participationReportFailedTitle'
            )
          );

        });
      toastr.success(
        $translate.instant(
          'modules.events.calendar.toastr.participationReportRecordedMsg'
        ),
        $translate.instant(
          'modules.events.calendar.toastr.participationReportRecordedTitle'
        )
      );

      if (self.eventAcceptance == null) {
        self.eventAcceptance = acceptance;
      } else {
        self.eventAcceptance = !self.eventAcceptance;
      }
    };
    self.memberCount = {
      title: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;

        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return acceptedMemberCount;
          default:
            return positionedMemberCount + ' eingeteilte Teilnehmer + '
              + (acceptedMemberCount - positionedMemberCount)
              + ' Zusagen , '
              + positionedMemberCount + ' von ' + positionCount + ' Positionen zugewiesen';
        }
        /* eslint-enable indent */
      },
      text: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;


        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return acceptedMemberCount;
          case acceptedMemberCount === positionedMemberCount:
            return positionedMemberCount + ' / ' + positionCount;
          default:
            return positionedMemberCount + ' + ' + (acceptedMemberCount - positionedMemberCount) + ' / ' + positionCount;
        }
        /* eslint-enable indent */
      },
      style: function () {
        var acceptedMemberCount = self.data.attendanceInfo.acceptedMemberCount;
        var positionedMemberCount = self.data.attendanceInfo.positionedMemberCount;
        var positionCount = self.data.attendanceInfo.positionCount;

        /* eslint-disable indent */
        switch (true) {
          case positionCount === 0:
            return 'label-info';
          case positionedMemberCount >= positionCount:
            return 'label-success';
          case acceptedMemberCount >= positionCount:
            return 'label-warning';
          default:
            return 'label-danger';
        }
        /* eslint-enable indent */
      }
    };

    self.showStatusLight = self.data.calMode && ~['MY_SERVICES', 'INVITES'].indexOf(self.data.refiner);
    if (self.showStatusLight) {
      $scope.$watch(function () {
        return self.data.serviceShiftMember;
      }, function () {
        self.statusLightTitle = (function () {
          if (self.data.serviceShiftMember) {
            if (self.data.serviceShiftMember.Acceptance) {
              return $translate.instant('modules.events.calendar.participationConfirmed');
            } else if (self.data.serviceShiftMember.Interested) {
              return $translate.instant('modules.events.calendar.interestReported');
            }
            return $translate.instant('modules.events.calendar.participationCanceled');
          }
          return $translate.instant('modules.events.calendar.participationOpen');
        })();
      }, true);
    }

    if (self.data.calMode === 'SERVICE' && ~['MY_SERVICES', 'INVITES'].indexOf(self.data.refiner)
      && self.data.ownEventMember && self.data.ownEventMember.DivisionMembers) {
      self.permittedToAttend = permissions.getPermittedIds(
        'arno.events.service.view',
        'Division',
        self.data.shiftRelevantDivisions,
        false
      );
      self.showAttend = self.data.selfAttend && !!self.permittedToAttend.length;
    }

  }
}
)();

(function () {
  'use strict';

  /** @ngInject */
  function divisionSelectorCtrl($scope, $rootScope, commonUtils, $state, stateChangePrompt, permissions,
    $uibModal, $timeout, toastr, $translate) {
    var self = this;

    self.divisionTitleList = false;
    self.isActive = $scope.isActive !== false; // undefined is active
    self.searchInputModel = '';

    self.divisionSelectionConfig = {
      core: {
        multiple: $scope.multiple,
        check_callback: true,
        themes: {
          responsive: false
        },
        dblclick_toggle: false
      },
      types: {
        default: {
          icon: 'ion-ios-people-outline'
        },
        rootOrg: {
          icon: 'ion-ios-people'
        }
      },
      checkbox: {
        keep_selected_style: false,
        cascade: '',
        three_state: false,
        whole_node: false
      },
      search: {
        show_only_matches: true,
        show_only_matches_children: true
      },
      plugins: ['types', 'checkbox', 'sort', 'search'],
      version: 1
    };

    self.preventPropagation = function ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    };

    self.openHelp = function () {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/divisionSelector/divisionSelectorModal/help.html',
        size: 'lg',
        resolve: {
          imgResolve: function (preloader, $q) {
            var imagePath = 'app/theme/components/divisionSelector/divisionSelectorModal/img/';
            var imageFileNames = [
              'single.gif',
              'single_allow_org.gif',
              'multiple_1.gif',
              'multiple_2.gif',
              'multiple_allow_org_1.gif',
              'multiple_allow_org_2.gif'
            ];
            var resultPromises = imageFileNames.map(function (imgFileName) {
              return preloader.loadImg(imagePath + imgFileName);
            });
            return $q.all(resultPromises);
          }
        },
        controller: function (imgResolve) {
          return imgResolve; // just to use the variable
        }
      });
    };

    self.toggleZindex = function (open) {
      /* TODO is it not possible to get the element directly here if the uib-dropdown plugin calls this directive? If yes, the setOpen function is obsolete! */
      var panel = self.toggler && self.toggler.parents('.panel:first');
      if (panel) {
        panel.css('z-index', open ? 10 : '');
      }
    };

    self.setOpen = function (event) {
      self.stopBlink();
      self.toggler = event && event.currentTarget && $(event.currentTarget);
    };

    self.refreshTree = function () {
      return self.getTreeData()
        .then(function () {
          self.divisionSelectionConfig.core.multiple = $scope.multiple;
          self.divisionSelectionConfig.checkbox.cascade = $scope.multiple ? 'down' : '';
        });
    };

    $scope.$watch(function () {
      return $scope.multiple + '_' + $scope.allowOrgSelection + '_' + $scope.entryPermission + '_' + $scope.namespace;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.refreshTree();
      }
    });

    $scope.$watch(function () {
      return self.searchInputModel;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        self.divisionSelectionTree && self.divisionSelectionTree.jstree(true).search(self.searchInputModel);
      }
    });

    self.getChecked = function () {
      var currentlyChecked = self.divisionSelectionTree.jstree('get_checked', null, true);
      // if multiple true and allowOrgSelection false -> return checked without rootOrg node,
      // else return the rootOrg if its checked
      return (($scope.multiple && !$scope.allowOrgSelection) ?
              currentlyChecked.filter(function (checkedNodeID) {
                return checkedNodeID !== 'rootOrg'
              }) : currentlyChecked);
    };

    self.expand = function () {
      commonUtils.preference.bool.set('divisionSelectorTreeViewOpened', true);
      self.divisionSelectionTree.jstree('open_all');
    };

    self.collapse = function () {
      commonUtils.preference.bool.set('divisionSelectorTreeViewOpened', false);
      self.divisionSelectionTree.jstree('close_all');
    };

    /* eslint no-extra-boolean-cast:0 */
    self.applyDivisions = function () {
      var ctxOptions = {
        multiple: $scope.multiple,
        namespace: $scope.namespace,
        allowOrgSelection: $scope.allowOrgSelection,
        entryPermission: $scope.entryPermission
      };

      var actCtx = commonUtils.division.getCtx(ctxOptions);

      var currentlyChecked = self.getChecked();
      commonUtils.division.setCtx(currentlyChecked, ctxOptions);

      commonUtils.preference.object.set(
        'util_divisionSelector', {
          lastSelectionIdent: commonUtils.division.getSelectionIdent(currentlyChecked)
        }
      );

      $state.reload()
        .catch(function (e) {
          // if we use the state change prompt the transition will be prevented but the
          // context will still be changed which is okay if the user decides to discard
          // changes and change the state, but problematic if the user does not change
          // the state and saves his data, probably under an unexpected/wrong context
          if (e && (e.detail || '').indexOf('aborted transition')) {
            stateChangePrompt.setAbortContext(actCtx, ctxOptions);
          }
        })
    };

    self.readyCB = function () {
    };

    self.selectNodeCB = function (event, data) {
      if ($scope.multiple && data.event && data.event.ctrlKey) {
        var nodeList = data.instance.settings.core.data;
        var childIds = data.node.children_d;
        nodeList.forEach(function (node) {
          var idIndex = _.findIndex(childIds, function (id) {
            return id === node.id;
          });
          if (idIndex > -1) {
            if (node.state.disabled) {
              childIds.splice(idIndex, 1);
            }
          }
        });
        self.divisionSelectionTree.jstree(true).select_node(data.node.children_d);
      }
    };

    self.deselectNodeCB = function (event, data) {
      if ($scope.multiple && data.event && data.event.ctrlKey) {
        self.divisionSelectionTree.jstree(true).deselect_node(data.node.children_d);
      }
    };

    self.letItBlink = function () {
      $scope.$evalAsync(function () {
        toastr.preventDuplicate(function() {
          toastr.info('', $translate.instant('generalTerms.pleaseCheckAreaSelector'), {
            preventDuplicates: true,
            timeOut: 3000
          });
        });
        self.selectorBlink = true;
        $timeout(function () {
          self.selectorBlink = false;
        }, 3100);
      });
    };

    self.stopBlink = function () {
      $scope.$evalAsync(function () {
        self.selectorBlink = false;
      });
    };

    self.getTreeData = function () {
      var currentContextOptions = {
        multiple: $scope.multiple,
        namespace: $scope.namespace,
        dossierOwnerId: $scope.dossierOwnerId,
        allowOrgSelection: $scope.allowOrgSelection,
        entryPermission: $scope.entryPermission
      };

      var currentDivisionCtx = commonUtils.division.getCtx(currentContextOptions);
      var currentSelectionIdent = commonUtils.division.getSelectionIdent(currentDivisionCtx);
      
      var lastSelectionIdent = commonUtils.preference.object.get('util_divisionSelector', {
        lastSelectionIdent: ''
      }).lastSelectionIdent;
      if (!lastSelectionIdent || lastSelectionIdent !== currentSelectionIdent) {
        self.letItBlink();
        commonUtils.preference.object.set('util_divisionSelector', {
          lastSelectionIdent: currentSelectionIdent
        });
      } else {
        self.stopBlink();
      }
  
      var treeNodeBuilderOpts = {
        statePref: 'divisionSelectorTreeViewOpened',
        selected: currentDivisionCtx,
        entryPermission: $scope.entryPermission,
        multiple: $scope.multiple,
      };

      if ($scope.allowOrgSelection /* || $scope.multiple */) {
        treeNodeBuilderOpts.rootOrg = $rootScope.ctx.organization.current.name;
      }
  
      return commonUtils.division.treeData(currentContextOptions)
        .then(function (nodes) {
          return commonUtils.division.treeDataPermissionFilter(nodes, $scope.entryPermission);
        })
        .then(function (treeData) {
          return commonUtils.division.buildTreeNodes(treeData, treeNodeBuilderOpts)
            .then(function(results) {
              return (results || {}).nodeResults;
            });
        })
        .then(function (treeNodes) {
          self.divisionSelectionData = treeNodes;
          self.divisionSelectionConfig.version++; // update the config so that ngJsTree directive will detect it and re-render
          if (currentDivisionCtx && currentDivisionCtx.length && self.divisionSelectionData && self.divisionSelectionData.length) {
            self.isRootOrg = !!~currentDivisionCtx.indexOf('rootOrg') && currentDivisionCtx.length === 1;
            
            var count = _.toArray(self.divisionSelectionData).filter(function (divi) {
              return !divi.state.disabled && currentDivisionCtx.indexOf(divi.id) !== -1;
            }).length;
            var actDivisionNode = _.find(self.divisionSelectionData, {
              id: currentDivisionCtx[0]
            });
            self.divisionTitleList = ((actDivisionNode && actDivisionNode.text) || $translate.instant('components.divisionSelector.unknown')) +
                                     ((count > 1) ? (' (' + count + ' ' + $translate.instant('components.divisionSelector.selected') + ')') : '');
          }
        });      
    };

    if (self.isActive) {
      self.getTreeData();
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('divisionSelectorCtrl', divisionSelectorCtrl)
    .config(function () {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = 'assets/img/theme/vendor/jstree/dist/themes';
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('divisionSelector', divisionSelector);

  /** @ngInject */
  function divisionSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/divisionSelector/divisionSelector.html',
      scope: {
        isActive: '=?',
        multiple: '=?',
        namespace: '@',
        dossierOwnerId: '@',
        allowOrgSelection: '=',
        entryPermission: '@'
      },
      compile: function (element, attrs) {
        if (!attrs.multiple) {
          attrs.multiple = 'false';
        }
        return {
          pre: function () {
          },
          post: function () {
          }
        }
      },
      controller: 'divisionSelectorCtrl as $divSelCtrl'
    };
  }

})();



/**
 * Taken from: https://embed.plnkr.co/DgWeerIlDjFpZO6DCzDD/
 *
 * This directive uses "jquery-maskmoney" v3.x, see: https://github.com/plentz/jquery-maskmoney
 *
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('arnoCurrencyInput', function($timeout, $translate, $compile) {
        return {
          restrict: 'A',
          require: 'ngModel',
          scope: {
            model: '=ngModel',
            mmOptions: '=?',
            prefix: '@',
            suffix: '@',
            affixesStay: '=',
            thousands: '@',
            decimal: '@',
            precision: '=',
            allowZero: '=',
            allowNegative: '=',
            allowEmpty: '=',
            disabled:'=ngDisabled',
          },
          link: function(scope, el, attr, ctrl) {
            var modelFormatter = function(value) {
              var val = parseFloat(value).toFixed(2);
              return isNaN(val) ? '' : val;
            }
            var preInitVal = modelFormatter(scope.model);

            scope.$watch(checkOptions, init, true);

            scope.$watch(attr.ngModel, eventHandler, true);

            scope.$watch(function () {
              return ctrl.$modelValue;
            }, function(newValue) {
              if (newValue) {
                preInitVal = modelFormatter(scope.model);
              }
            });

            function checkOptions() {
              return scope.mmOptions;
            }

                //this parser will unformat the string for the model behid the scenes
            function parser() {
              var val = $(el).maskMoney('unmasked')[0];
              if (!val && $(el).val() === '') {
                return null;
              }
              return val;
            }

            ctrl.$parsers.push(parser);

            ctrl.$formatters.push(function(value){
              $timeout(function(){
                init();
              });
              return modelFormatter(value);
            });

            function eventHandler() {
              $timeout(function() {
                scope.$apply(function() {
                  ctrl.$setViewValue($(el).val());
                });
              });
            }

            function init() {
              $timeout(function() {
                var elOptions = {
                  prefix: scope.prefix || '',
                  suffix: scope.suffix || '',
                  affixesStay: scope.affixesStay,
                  thousands: scope.thousands || $translate.instant('generalTerms.numbers.thousands'),
                  decimal: scope.decimal || $translate.instant('generalTerms.numbers.decimal'),
                  precision: scope.precision,
                  allowZero: true,
                  allowNegative: scope.allowNegative,
                  allowEmpty: scope.allowEmpty !== false, // true as default
                };

                if (!scope.mmOptions) {
                  scope.mmOptions = {};
                }

                for (var elOption in elOptions) {
                  if (elOptions[elOption]) {
                    scope.mmOptions[elOption] = elOptions[elOption];
                  }
                }
                $(el).maskMoney('destroy');
                $(el).val(
                  preInitVal.toString().replace('.', '#DECIMAL').replace(/,/g, scope.mmOptions.thousands).replace('#DECIMAL', scope.mmOptions.decimal)
                );
                ctrl.$setViewValue($(el).val());

                $(el).maskMoney(scope.mmOptions);
                $(el).maskMoney('mask');
                eventHandler();
              }, 0);

              $timeout(function() {
                scope.$apply(function() {
                  ctrl.$setViewValue($(el).val());
                });
              });
            }

            scope.$on('$destroy', function() {
              $(el).maskMoney('destroy');
            });

            scope.emptyVal = function() {
              ctrl.$setViewValue('');
              el.val('');
            }

            // clear input btn
            var wrapper = angular.element('<div>').addClass('input-clear-wrapper');
            var button = angular
              .element('<i ng-if="mmOptions.allowEmpty && !disabled" ng-click="emptyVal()">')
              .addClass('input-clear-button fa fa-times text-danger arno-pointing-pointer');
            var compiled = $compile(button)(scope);

            el.wrap(wrapper);
            el.parent().append(compiled);
          }
        };
      });

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('dashboardServiceShareList', dashboardServiceShareList);

  /** @ngInject */
  function dashboardServiceShareList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/dashboard/dashboard-service-share-list.html',
      scope: {
        divisionShares: '=',
        eventShareCtx: '=?',
      },
      controller: 'dashboardServiceShareCtrl as $dshbrdscrvcCtrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function dashboardServiceShareCtrl($scope, toastr, clientApi, baModalService, $state, $translate) {
    var self = this;
    self.divisionShares = $scope.divisionShares;
    self.eventShareCtx = $scope.eventShareCtx;
    self.handleShare = function (action, divisionShare) {
      if (action === 'DETAILS') {
        if (divisionShare.Service) {
          $state.go('arno.events.serviceDetail', { serviceId: divisionShare.ServiceId, ctx: divisionShare.Service.SourceDivision.id });
        } else {
          $state.go('arno.events.eventDetail', { eventId: divisionShare.EventId });
        }
        return;
      }

      Promise.resolve()
        .then(function () {
          if (action === 'DECLINE') {
            return baModalService.messageModal({
              modalType: 'danger',
              allowHtml: false,

              title: $translate.instant('modules.arnoDashboard.board.rejectShare'),
              content:
                $translate.instant('modules.arnoDashboard.board.shareEvent')
                + divisionShare.Event.Subject
                + $translate.instant('modules.arnoDashboard.board.reallyDiscard'),

              primaryActionText: $translate.instant('modules.arnoDashboard.board.decline'),
              secondaryActionText: $translate.instant('generalTerms.cancel')
            });
          }
          return null;
        })
        .then(function () {
          if (divisionShare.Service) {
            return clientApi
              .custom('model/ServiceShare', 'setShareState', {
                serviceId: divisionShare.ServiceId,
                divisionId: divisionShare.DivisionId,
                isShared: action === 'ACCEPT',
              });
          }
          return clientApi
            .custom('model/DivisionEvent', 'setDivisionShareState', {
              eventId: divisionShare.EventId,
              divisionId: divisionShare.DivisionId,
              isShared: action === 'ACCEPT',
            });
        })
        .then(function () {
          if (action === 'ACCEPT') {
            toastr.success($translate.instant('modules.arnoDashboard.board.allreadyShareEvent'), $translate.instant('modules.arnoDashboard.board.acceptParts'));
          } else {
            toastr.info($translate.instant('modules.arnoDashboard.board.eventWasNotShared'), $translate.instant('modules.arnoDashboard.board.discardParts'));
          }
          $state.reload();
        })
        .catch(function () {
        });
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('dashboardServiceShareCtrl', dashboardServiceShareCtrl);
})();

(function () {
  'use strict';

  /** @ngInject */
  function costCenterSpecSelectorCtrl($rootScope, $scope, clientApi) {
    var self = this;

    self.costCenterSpec = [];
    self.onCostCenterSpecSelect = $scope.onCostCenterSpecSelect;
    self.selectedCostCenterSpec = $scope.selectedCostCenterSpec;
    self.costCenterIdFilter = $scope.costCenterIdFilter;
    self.enableDelete = $scope.enableDelete;

    self.appendToBody = $scope.appendToBody === undefined ? true : $scope.appendToBody;

    $scope.$watch(function () {
      return self.selectedCostCenterSpec;
    }, function (newVal, oldVal) {
      if (newVal === oldVal || self.selectedCostCenterSpec === null) {
        return;
      }
      if (self.selectedCostCenterSpec && angular.isFunction(self.onCostCenterSpecSelect)) {
        if (!self.selectedCostCenterSpec.none) {
          self.onCostCenterSpecSelect(self.selectedCostCenterSpec);
        } else {
          self.onCostCenterSpecSelect(null);
          self.selectedCostCenterSpec = null;
        }
      }
    });

    self.disabled = $scope.disabled;
    $scope.$watch(function () {
      return $scope.disabled;
    }, function () {
      self.disabled = $scope.disabled;
    });

    self.groupBy = function (costCenterSpec) {
      if (!costCenterSpec || !costCenterSpec.CostCenter) {
        return '';
      }
      return (costCenterSpec.CostCenter.Identifier || '') + (costCenterSpec.CostCenter.Identifier ? ' - ' : '') + costCenterSpec.CostCenter.Name;
    };

    self.searchCostCenterSpec = function (searchTerm) {
      if (!searchTerm) {
        self.costCenterSpec = null;
        return null;
      }

      return clientApi
        .custom('model/CostCenterSpecification', 'searchSpecifications', {
          queryOptions: {
            searchTerm: searchTerm,
            costCenterId: self.costCenterIdFilter,
          }
        })
        .then(function (result) {
          if (result && result.length) {
            self.costCenterSpec = result;
          } else {
            self.costCenterSpec = [{ none: true }];
          }
        });
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('costCenterSpecSelectorCtrl', costCenterSpecSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('costCenterSpecSelector', costCenterSpecSelector);

  /** @ngInject */
  function costCenterSpecSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/costCenterSpecSelector/costCenterSpecSelector.html',
      scope: {
        onCostCenterSpecSelect: '=',
        selectedCostCenterSpec : '=?',
        costCenterIdFilter: '=?',
        appendToBody : '=?',
        enableDelete: '=?',
        disabled:'=ngDisabled'
      },
      controller: 'costCenterSpecSelectorCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function contactSelectorCtrl($rootScope, $scope, clientApi, $translate) {
    var self = this;

    self.onSelect = $scope.onSelect;
    self.divisions = $scope.divisions;
    self.onlyActive = !!$scope.onlyActive;
    self.explicitQualifications = !!$scope.explicitQualifications;
    self.organizationScope = !!$scope.organizationScope;
    self.azure = !!$scope.azure;
    self.contacts = [];
    self.searchTerm = $scope.searchTerm;
    self.blankSearchOnClick = $scope.blankSearchOnClick;
    self.selectedContact = $scope.selectedContact;

    if (self.selectedContact && !self.selectedContact.asString) {
      self.selectedContact.asString = contactToString($scope.selectedContact);
    }


    $scope.$watch(function () {
      return self.selectedContact;
    }, function () {
      if (self.selectedContact && angular.isFunction(self.onSelect)) {
        if (!self.selectedContact.none) {
          self.onSelect(self.selectedContact);
        }
      }

      self.selectedContactString = contactToString(self.selectedContact)
    });

    function contactToString(contact) {
      if (!contact) {
        return '';
      }

      var result = contact.Function + ' (' + contact.BusinessPartner.Name + ')';
      if (contact.FirstName || contact.LastName) {
        result += ' - '
        if (contact.Salutation) {
          result += $translate.instant('models.Member.Salutation.' + contact.Salutation) + ' ';
        }

        result += (contact.FirstName ? (contact.FirstName + ' ') : '') + (contact.LastName || '');
      }

      return result;
    }

    self.groupByCompany = function (contact) {
      if (contact && contact.BusinessPartner && contact.BusinessPartner.Name) {
        return contact.BusinessPartner.Name;
      }
    };

    self.searchContacts = function (searchTerm) {
      var queryWishes = {
        paging: {
          offset: 0,
          limit: 0
        },
      };

      if (searchTerm) {
        queryWishes.searchSettings = {
          allOr: true,
        }
        queryWishes.search = [
          {
            property: 'Function',
            term: searchTerm,
          },
          {
            property: 'FirstName',
            term: searchTerm,
          },
          {
            property: 'LastName',
            term: searchTerm,
          },
          {
            property: 'businesspartner',
            term: searchTerm,
          },
        ]
      }
      if (!Array.isArray($scope.divisions)) {
        $scope.divisions = [$scope.divisions];
      }
      clientApi.custom('model/contact', 'getContactAllWithOrg', {
        divisionIds: $scope.divisions,
        queryWishes: queryWishes,
      }).then(function (result) {

        if (result && result.contactList) {
          self.contacts = result.contactList.map(function (contact) {
            return Object.assign(contact, {
              asString: contactToString(contact)
            });
          });
        } else {
          self.contacts = [{ none: true }];
        }
      });
    };

    self.disabled = $scope.disabled;
    $scope.$watch(function () {
      return $scope.disabled;
    }, function () {
      self.disabled = $scope.disabled;
    });
  }

  angular.module('BlurAdmin.theme.components')
    .controller('contactSelectorCtrl', contactSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('contactSelector', contactSelector);

  /** @ngInject */
  function contactSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contactSelector/contactSelector.html',
      scope: {
        divisions: '=',
        onSelect: '=',
        selectedContact : '=?',
        onlyActive: '=',
        explicitQualifications: '=?',
        organizationScope: '=?',
        azure: '=?',
        searchTerm: '=?',
        blankSearchOnClick: '=',
        disabled:'=ngDisabled',
      },
      controller: 'contactSelectorCtrl as self'
    };
  }

})();

 (function () {
   'use strict';

   angular.module('BlurAdmin.theme.components')
    .controller('contactPrivacyCtrl', contactPrivacyCtrl);


  /** @ngInject */
   function contactPrivacyCtrl(
    $location, $scope, validationUtils, clientApi
  ) {
     var self = this;

     self.currentUrl = $location.$$path;

     self.datepicker = {
       format: 'd!.M!.yyyy',
       options: {
         maxDate: moment().toDate(),
         startingDay: 1,
         showWeeks: false,
         yearColumns: 4
       }
     };
     self.hstep = 1;
     self.mstep = 15;
     self.isMeridian = false;
     self.maxTimepick = moment().toDate();

     self.privacyTermsAlreadyDelivered = '1';

     self.outdatedTermsDelivered = false;

     self.hasError = validationUtils.hasError;

     self.downloadPrivacyAgreement = function () {
       clientApi.openTab('pdfExport/emergencyContactsPrivacyTerms', {});
     };

     self.downloadPrivacyTerms = function () {
       clientApi.openTab('pdfExport/privacyTerms', {});
     };

     $scope.$watch(function () {
       return self.contact.PrivacyTermsDeliveredDateTime;
     }, function (newVal) {
       if (self.privacyTermDate) {
         if (newVal) {
           self.outdatedTermsDelivered = new Date(self.contact.PrivacyTermsDeliveredDateTime) < new Date(self.privacyTermDate);
         } else {
           self.outdatedTermsDelivered = false;
         }
       }      
     });

     $scope.$watch(function () {
       return self.privacyTermDate;
     }, function () {
       if (self.privacyTermDate) {
         self.privacyTermDateDisplay = moment(self.privacyTermDate).format('DD.MM.YYYY - HH:mm');
       }
     });

     $scope.$watch(function () {
       return self.contact && self.contact.ContactEMail;
     }, function (newVal) {
       self.contactAddressGiven = !!newVal;
     });

     $scope.$watch(function () {
       return self.privacyTermsAlreadyDelivered;
     }, function (newVal) {
       if (newVal !== '1') {
         self.contact.PrivacyTermsDeliveredDateTime = null;
         self.contact.PrivacyTermsDeliveredPerson = null;
         self.contact.PrivacyTermsDeliveredChannel = null;
       }
     });
   }
 })();

 (function () {
   'use strict';

   angular.module('BlurAdmin.theme.components')
    .component('contactPrivacy', {
      templateUrl: 'app/theme/components/contactPrivacy/contactPrivacy.html',
      controller: 'contactPrivacyCtrl as $contactPrivacyCtrl',
      controllerAs: '$contactPrivacyCtrl',
      bindings: {
        contact: '=',
        formReference:'<',
        privacyTermDate: '<',
        demandForAction: '<',
        onUpdate:'&'
      }
    });
 })();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('contactManagementDuplicatesCtrl', contactManagementDuplicatesCtrl);

  /** @ngInject */
  function contactManagementDuplicatesCtrl(
    $rootScope, $scope, $state, $translate, baModalService, permissions,
    ArnoDashContactManagementService
  ) {
    var self = this;
    self.hasViewPermission = false;
    self.hasManagePermission = false;
    self.isNew = $scope.isNew;
    self.headerTitle = self.isNew ? 'modules.contacts.contactManagement.duplicates.titleNew' : 'modules.contacts.contactManagement.duplicates.titleEdit';
    self.contact = $scope.contact;
    self.divisionIds = $scope.divisionIds;
    self.duplicateList = [];
    self.linkedList = [];

    function searchSimilarContacts(contact) {
      if (contact) {
        ArnoDashContactManagementService.getSimilarContacts(contact).then(function(duplicateList) {
          self.duplicateList = duplicateList;
          ArnoDashContactManagementService.getContactAllInDivision(duplicateList, self.divisionIds).then(function(linkedList) {
            self.linkedList = linkedList;
          });
        });
      }
    }

    self.$onInit = function() {
      self.hasManagePermission =
        permissions.isPermittedAnywhere('arno.contacts.contactManagement.manage', ['Division']);
      self.hasViewPermission =
        permissions.isPermittedInOrg('arno.contacts.contactManagement.view', [$rootScope.ctx.organization.current.id]) ||
        permissions.isPermittedAnywhere('arno.contacts.contactManagement.view', ['Division']);
      searchSimilarContacts(self.contact);
    }

    $scope.$watch('$ctrl.contact', function (newVal) {
      if (newVal) {
        searchSimilarContacts(newVal);
      }
    }, true);

    self.getSimilarFields = function(contactA, contactB) {
      return (Object.keys(contactA || {}) || []).reduce(function(acc, fieldName) {
        if (fieldName) {
          if (contactA[fieldName]) {
            if (contactA[fieldName] == contactB[fieldName]) {
              acc[fieldName] = 1;
            } else if (typeof contactA[fieldName] === 'string' && typeof contactB[fieldName] === 'string') {
              if(contactA[fieldName].toLowerCase().trim() == contactB[fieldName].toLowerCase().trim()) {
                acc[fieldName] = 1;
              } else if(contactB[fieldName].trim() !== '' && contactA[fieldName].toLowerCase().indexOf(contactB[fieldName].toLowerCase()) > -1
              || contactA[fieldName].trim() !== '' && contactB[fieldName].toLowerCase().indexOf(contactA[fieldName].toLowerCase()) > -1
            ) {
                acc[fieldName] = 0.5;
              }
            }
          }
        }
        return acc;
      }, {});
    }

    self.gotoContactDetails = function(targetContact) {
      if ((targetContact || {}).id) {
        if ((self.contact || {}).id) {
          return $state.go('arno.contacts.contactManagementDetails', {
            contactId: targetContact.id,
            divisionIds: self.divisionIds
          }, {
            reload: true
          });
        }
        return baModalService.messageModal({
          modalType: 'info',
          allowHtml: false,
          closable: true,
          title: $translate.instant('modules.contacts.contactManagement.duplicates.leaveTitle'),
          content: $translate.instant('modules.contacts.contactManagement.duplicates.leaveMessage', { contactName: targetContact.Name }),
          primaryActionText: $translate.instant('generalTerms.call'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        }).then(function() {
          $state.go('arno.contacts.contactManagementDetails', {
            contactId: targetContact.id,
            divisionIds: self.divisionIds
          }, {
            reload: true
          });
        });
      }
    }

    self.addDivisionToContact = function(contact) {
      if ((contact || {}).id && self.divisionIds) {
        return ArnoDashContactManagementService.addDivisions(contact, self.divisionIds).then(function() {
          $state.go('arno.contacts.contactManagementDetails', { contactId: contact.id }, { reload: true });
        });
      }
    }

    self.isLinked = function(duplicate) {
      if ((duplicate || {}).id) {
        var found = self.linkedList.findIndex(function (entry) {
          return entry.id == duplicate.id;
        });
        return found != -1;
      }
      return false;
    }

    self.isRootOrgSelected = function() {
      return self.divisionIds.includes('rootOrg');
    };

  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.contacts.contactManagement')
    .directive('contactManagementDuplicates', contactManagementDuplicates);

  /** @ngInject */
  function contactManagementDuplicates() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contactManagementDuplicates/contactManagementDuplicates.html',
      controller: 'contactManagementDuplicatesCtrl as $ctrl',
      scope: {
        contact: '<',
        isNew: '<',
        divisionIds: '<'
      }
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function clientSelectorCtrl($rootScope, $scope, clientApi) {
    var self = this;

    self.divisions = $scope.divisions;
    self.clientExclude = $scope.client.excluded || [];
    self.onlyActive = !!$scope.onlyActive;
    self.selectorDisabled = $scope.selectorDisabled || false;
    self.clients = [];

    self.searchClients = function (searchTerm) {
      if (!searchTerm) {
        self.clients = [];
        return null;
      }
      // todo: refactor organizationId
      return clientApi
        .custom('model/Client', 'clientSelectorFind', {
          divisions: self.divisions,
          onlyActive: self.onlyActive,
          clientExclude: self.clientExclude,
          searchTerm: searchTerm
        })
        .then(function (results) {
          if (results && results.length) {
            self.clients = results;
          } else {
            self.clients = [{ none: true }];
          }
        });
    };

    self.removeSelection = function () {
      self.clients = [{ none: true }];
      $scope.client.selected = self.clients[0];
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('clientSelectorCtrl', clientSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('clientSelector', clientSelector);

  /** @ngInject */
  function clientSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/clientSelector/clientSelector.html',
      scope: {
        divisions : '=',
        client : '=',
        onlyActive : '=',
        selectorDisabled : '='
      },
      controller: 'clientSelectorCtrl as $clSelCtrl'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('calHeatmapCtrl', calHeatmapCtrl);

  /** @ngInject */
  function calHeatmapCtrl($translate, $scope) {
    var self = this;
    var SCALE_STEPS = 3;

    // $scope.heatmap -> [{date: new Date(), value: 10, customPayloadDataProps: 'foo'}]

    self.update = function (data) {
      var startDate = moment($scope.startDate).startOf('day');
      var endDate = moment($scope.endDate).startOf('day');

      if (moment(startDate).isAfter(moment(endDate))) {
        return;
      }
      var maxValue = (_.maxBy(data, 'value') || { value: 1 }).value;
      var mappedData = {};
      data.forEach(function (d) {
        d.date = moment(d.date).startOf('day');
        d.scale = Math.floor(Math.abs(((d.value / maxValue) * SCALE_STEPS) - 0.0001));
        mappedData[+d.date] = d;
      });

      var histogramDates = [];
      var dayIterator = moment(startDate).weekday(0);
      while (dayIterator.isSameOrBefore(endDate)) {
        histogramDates.push(+dayIterator);
        dayIterator.add(1, 'day');
      }

      self.histogramDates = _.chunk(histogramDates, 7);
      self.histogramDay = mappedData;
      self.histogramDates[0]
        .slice(0, moment(startDate).weekday())
        .forEach(function (d) {
          self.histogramDay[d] = { filler: true };
        });
    };

    self.getDayClass = function (day) {
      if ((self.histogramDay[day] || {}).filler) {
        return 'day-filler';
      }
      return 'scale-' + ((self.histogramDay[day] || { scale: -1 }).scale + 1);
    }

    $scope.$watch(function () {
      return $scope.heatmap
    }, function () {
      self.update($scope.heatmap);
    }, false);

    self.mouseover = function ($event) {
      if (((($event || {}).target || {}).dataset || {}).day
          && (!self.histogramDay[$event.target.dataset.day] || !self.histogramDay[$event.target.dataset.day].filler)) {
        self.dayInfo = $scope.labelFunc(self.histogramDay[$event.target.dataset.day] || { date: parseInt($event.target.dataset.day, 10) });
      } else {
        self.dayInfo = '';
      }
    }

    self.mouseleave = function () {
      self.dayInfo = '';
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('calHeatmap', calHeatmap);

  /** @ngInject */
  function calHeatmap() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/calHeatmap/calHeatmap.html',
      scope: {
        heatmap : '=',
        startDate : '=',
        endDate : '=',
        labelFunc : '=',
      },
      controller: 'calHeatmapCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function businessPartnersSelectorCtrl($rootScope, $scope, clientApi, ArnoDashBusinessPartnersService, $translate, $uibModal) {
    var self = this;

    self.BusinessPartnersProposals = $scope.selectionProposals || [];
    self.businessPartners = self.BusinessPartnersProposals;
    self.division = $scope.division || undefined;
    self.onBusinessPartnerSelect = $scope.onBusinessPartnerSelect;
    self.selectedBusinessPartner = $scope.selectedBusinessPartner;
    self.customPlaceholder = $scope.customPlaceholder;
    self.enableDelete = $scope.enableDelete;
    self.enableDetails = $scope.enableDetails;
    self.detailsExtraLabel = $scope.detailsExtraLabel;
    self.extraLabelCls = $scope.extraLabelCls;
    self.requiredLabel = $scope.requiredLabel;

    self.isBuyer = $scope.isBuyer || undefined;
    self.isSeller = $scope.isSeller || undefined;
    self.isMaterialProvider = $scope.isMaterialProvider || undefined;

    self.appendToBody = $scope.appendToBody === undefined ? true : $scope.appendToBody;
    self.orgName = $rootScope.ctx.organization.current.name;

    $scope.$watch(function () {
      return self.selectedBusinessPartner;
    }, function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (self.selectedBusinessPartner && angular.isFunction(self.onBusinessPartnerSelect)) {
        if (!self.selectedBusinessPartner.none) {
          self.onBusinessPartnerSelect.apply(null, [self.selectedBusinessPartner].concat($scope.additionalOnSelectParams || []));
        } else {
          self.onBusinessPartnerSelect.apply(null, [null].concat($scope.additionalOnSelectParams || []));
        }
      }
    });

    self.disabled = $scope.disabled;
    $scope.$watch(function () {
      return $scope.disabled;
    }, function () {
      self.disabled = $scope.disabled;
    });

    self.groupBy = function (businessPartner) {
      if (businessPartner && businessPartner.Divisions && businessPartner.Divisions.length) {
        return $translate.instant('components.businessPartnerSelector.groupFavorite', { division: businessPartner.Divisions[0].Name });
      }
      return $translate.instant('components.businessPartnerSelector.groupDefault');
    };

    self.searchBusinessPartners = function (searchTerm) {
      if (!searchTerm) {
        self.businessPartners = self.BusinessPartnersProposals;
        return null;
      }

      return clientApi
        .custom('model/BusinessPartner', 'searchBusinessPartners', {
          searchTerm: searchTerm,
          divisionId: self.division,
          isBuyer: self.isBuyer,
          isSeller: self.isSeller,
          isMaterialProvider: self.isMaterialProvider,
        })
        .then(function (result) {
          if (result && result.length) {
            self.businessPartners = result;
          } else {
            self.businessPartners = [{ none: true }];
          }
        });
    };

    self.openDetails = function() {
      return $uibModal.open(
        {
          controller: 'businessPartnerDetailsModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/theme/components/businessPartnersSelector/modals/businessPartnerDetailsModal.html',
          size: 'md',
          resolve: {
            businessPartner: function() {
              return ArnoDashBusinessPartnersService.getBusinessPartnerDetails(self.selectedBusinessPartner.id, false, true);
            },
          }
        })
        .result
        .catch(function() {
          // hmm k
        })
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('businessPartnersSelectorCtrl', businessPartnersSelectorCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('businessPartnersSelector', businessPartnersSelector);

  /** @ngInject */
  function businessPartnersSelector() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/businessPartnersSelector/businessPartnersSelector.html',
      scope: {
        division: '=',
        onBusinessPartnerSelect: '=',
        selectedBusinessPartner : '=?',
        selectionProposals: '=?',
        isBuyer: '=?',
        isSeller: '=?',
        isMaterialProvider: '=?',
        appendToBody : '=?',
        additionalOnSelectParams: '=?',
        customPlaceholder: '=?',
        enableDelete: '=?',
        enableDetails: '=?',
        detailsExtraLabel: '=?',
        extraLabelCls: '=?',
        disabled:'=ngDisabled',
        requiredLabel: '=?',
      },
      controller: 'businessPartnersSelectorCtrl as self'
    };
  }

})();

(function () {

  angular.module('BlurAdmin.theme.components')
    .controller('BookingMaterialCalendarCtrl', BookingMaterialCalendarCtrl);

  /** @ngInject */
  function BookingMaterialCalendarCtrl(clientApi, $state, $scope, toastr, $timeout, $rootScope, commonUtils, $compile, $translate, $uibModal) {
    var self = this;

    self.choosenLanguage = $translate.use();

    self.calcHeight = function() {
      var height = 650;
      var addMaterialModal = document.querySelector('.add-material-dialog .modal-header + .ng-isolate-scope');
      if (addMaterialModal) {
        var tabsRow = addMaterialModal.querySelector('ul.nav-tabs');
        var staticContentSpacerHeight = 31;
        if (tabsRow) {
          height = addMaterialModal.clientHeight - (tabsRow.clientHeight + staticContentSpacerHeight);
          if (height < 150) {
            height = 150;
          }
        }
      }
      return height;
    }

    self.initCalendarElement = function () {
      var bmc = $('#bookingMaterialCalendar');

      if (self.calendar) {
        self.calendar.fullCalendar('destroy');
      }

      self.calendar = bmc.fullCalendar({
        locale: self.choosenLanguage,
        lang: 'de',
        height: self.calcHeight(),
        firstDay: 1,
        header: {
          left: 'title',
          center: '',
          right: 'today prev,next'
        },
        buttonText: {
          listDay: $translate.instant('modules.events.calendar.day'),
          listWeek: $translate.instant('modules.events.calendar.week'),
          listMonth: $translate.instant('modules.events.calendar.month')
        },
        noEventsMessage: $translate.instant('modules.material.addMaterial.bookingMaterialCalendar.noEvents'),
        defaultDate: (function () {
          return moment().startOf('week');
        })(),
        defaultView: 'agendaWeek',
        timeFormat: 'HH:mm',
        timezone: 'local',
        selectable: false,
        selectHelper: false,
        eventLimit: false,
        editable: false,
        weekNumbers: true,
        eventStartEditable: false,
        eventDurationEditable: false,
        nextDayThreshold: '00:00:00',
        slotEventOverlap: false,
        eventClick: function (event) {
          self.showEventDetail(event);
        },
        eventRender: function (event, element) {
          var eventColorClass = 'success';
          /* if (!event.availDiff) {
            eventColorClass = 'info';
          } */
          if (event.askedDiff) {
            eventColorClass = 'danger';
          }
          element.addClass(eventColorClass);
          element.attr('title', event.title);
        },
        eventAfterAllRender: function (view) {
          $scope.$evalAsync(function () {
            if (view && view.calendar && view.calendar.getEventCache && (view.calendar.getEventCache() || []).length) {
              self.refreshSize(4);
            }
          });
        },
        events: self.getEvents,
        windowResize: function() {
          bmc.fullCalendar('option', 'height', 0);
          bmc.fullCalendar('option', 'height', self.calcHeight());
        }
      });

      self.refreshSize = function (repeat, sleep) {
        var view = self.calendar && self.calendar.fullCalendar('getView');
        if (view && view.updateSize) {
          view.updateSize(true);
        }
        if (repeat) {
          setTimeout(function () {
            self.refreshSize(repeat - 1, sleep);
          }, sleep || 100);
        }
      };
    };

    self.getEvents = function (start, end, aParam, callback) {
      var options = {
        startDate: start,
        endDate: end,
        materialId: $scope.materialId,
        materialModel: $scope.model,
        divisionId: $scope.divisionId,
      };
      return clientApi.custom('model/BookingMaterial', 'fetchBookingMaterialEvents', options)
        .then(function (events) {
          return events.map(function (event) {
            return {
              id: event.id,
              title: event.Title,
              timeframeTitle: event.BookingMaterialTime.Title,
              start: moment(event.BookingMaterialTime.StartDate),
              end: moment(event.BookingMaterialTime.EndDate),
              allDay: false,
              eventId: event.BookingMaterialTime.EventId,
              serviceShiftId: event.BookingMaterialTime.ServiceShiftId,
              serviceId: event.BookingMaterialTime.ServiceId,
              type: event.Type,
              amount: event.EffectiveAmount + '/' + $scope.materialAmount,
              askedDiff: event.AskedAmount - event.EffectiveAmount,
              availDiff: $scope.materialAmount - event.EffectiveAmount,
              askedFlat: event.AskedAmount,
              color: '#FFF',
              textColor: '#000',
            };
          });
        })
        .catch(function () {
          return [];
        })
        .then(function (events) {
          callback(events);
        });
    };

    $scope.$watch(function() {
      return $scope.version;
    }, function(newVal) {
      if (newVal.version) {
        $timeout(function() {
          self.initCalendarElement();
        }, 0, false);
      }
    }, true);

    self.showEventDetail = function (event) {
      return $uibModal
        .open({
          controller: 'bookingMaterialCalendarDetailCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/bookingMaterialCalendar/modals/bookingMaterialCalendarDetail.html',
          size: 'lg',
          resolve: {
            materialName: function() {
              return $scope.materialName;
            },
            event: function() {
              return event;
            },
            divisionId: function() {
              return $scope.divisionId;
            }
          }
        });
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('bookingMaterialCalendar', bookingMaterialCalendar);

  /** @ngInject */
  function bookingMaterialCalendar() {
    return {
      restrict: 'AE',
      replace: 'true',
      templateUrl: 'app/theme/components/bookingMaterialCalendar/bookingMaterialCalendar.html',
      scope: {
        version: '=',
        model: '=',
        materialId: '=',
        divisionId: '=',
        materialAmount: '=',
        materialName: '=',
      },
      controller: 'BookingMaterialCalendarCtrl as self',
    }
  }
})
();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '=',
        onSubmit: '=',
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev,
          scope: $scope,
        };

        wizard.addTab(tab);

        $scope.$on('$destroy', wizard.removeTab.bind(this, tab));

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
          if ((!$scope.form || $scope.form.$valid) && angular.isFunction($scope.onSubmit)) {
            return $scope.onSubmit();
          }
        }

        function isComplete() {
          return $scope.form ? (!$scope.form.$pending && $scope.form.$dirty && $scope.form.$valid) : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope, $timeout, $q) {
    var vm = this;
    vm.tabs = [];

    vm.allowBack = $scope.allowBack;
    vm.hideProgress = $scope.hideProgress;
    vm.hideNavigation = $scope.hideNavigation;
    vm.tabNum = 0;
    vm.progress = 0;
    vm.pending = false;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    vm.removeTab = function(tab) {
      var idx = vm.tabs
        .map(function(t) { return t.scope.$id; })
        .indexOf(tab.scope.$id);

      vm.tabs.splice(idx, 1);

      if (vm.tabs[idx]) {
        vm.tabs[idx].setPrev(vm.tabs[idx - 1]);
      }
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), function() {
      vm.isFirstTab = vm.tabNum === 0;
      vm.isLastTab = vm.tabNum === vm.tabs.length - 1;
      calcProgress();
    });

    $scope.$watch(angular.bind(vm, function () {return vm.tabs.length;}), function() {
      vm.isLastTab = vm.tabNum === vm.tabs.length - 1;
      calcProgress();
    });

    vm.selectTab = function (tabNum, submit) {
      var form = vm.tabs[vm.tabNum].scope.form;
      (submit ? $q.resolve(vm.tabs[vm.tabNum].submit()) : $q.resolve())
        .then(function() {
          form && (form.$pending = vm.pending = false);
          if (vm.tabs[tabNum].isAvailiable()) {
            vm.tabNum = tabNum;
            vm.tabs.forEach(function (t, tIndex) {
              tIndex == vm.tabNum ? t.select(true) : t.select(false);
            });
          }
        });
    };

    vm.nextTab = function (submit) {
      var form = vm.tabs[vm.tabNum].scope.form;
      form && submit && (form.$pending = vm.pending = true);
      if (vm.isLastTab) {
        (submit ? $q.resolve(vm.tabs[vm.tabNum].submit()) : $q.resolve())
          .then(function() {
            form && submit && (form.$pending = vm.pending = false);
            if (angular.isFunction($scope.onFinish) && vm.tabs[vm.tabNum].isComplete()) {
              return $scope.onFinish();
            }
          });
      } else {
        return vm.selectTab(vm.tabNum + 1, submit);
      }
    };

    vm.previousTab = function () {
      if (vm.isFirstTab) {
        if (angular.isFunction($scope.onCancel)) {
          return $scope.onCancel();
        }
      } else if (vm.allowBack) {
        return vm.selectTab(vm.tabNum - 1);
      }
    };

    function calcProgress() {
      $timeout(function() {
        vm.progress = vm.isFirstTab ? 10 : (vm.isLastTab ? 100 : ((vm.tabNum + 1) / vm.tabs.length) * 100);
      }, 200);
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl',
      scope: {
        onFinish: '=',
        onCancel: '=',
        allowBack: '=',
        hideProgress: '=',
        hideNavigation: '=',
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoBaTreeviewController', ArnoBaTreeviewController);

  /**
   * @description Controller for the ba-treeview component.
   *
   * @namespace BlurAdmin.theme.components.ArnoBaTreeviewController
   */
  /** @ngInject */
  function ArnoBaTreeviewController(
    $scope, $transclude
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.treeviewCollapsed = false;

    $ctrl.treeOptions;
    $ctrl.selectedNode;

    // BOOTSTRAPPER
    /**
     * @name activate
     * @description Function for controller inits
     * @returns {Void} none
     * @memberOf ArnoBaTreeviewController#
     */
    function activate() {
      $ctrl.contentSlotPresent = $transclude.isSlotFilled('content');
      $ctrl.footerBarRightButtonRowSlotPresent = $transclude.isSlotFilled('footerBarRightButtonRow');

      // reset view-values like isSelected, matched...
      resetViewValues($ctrl.treeNodesData);

      setupWatchers();
    }

    // EVENT-HANDLERS
    $ctrl.selectNodeHandler = function (node) {
      if (node.selectable === false) {
        return false;
      }

      if (typeof $ctrl.nodeSelect === 'function') {
        // you could add a check here to let the consumer of this component cancel the selection of the new node
        var result = $ctrl.nodeSelect.call($ctrl)(node);

        // check if its a promise
        if (result && result.then && result.catch) {
          return result
            .then(function (result) {
              if (result !== false) {
                selectNewNode(node);
              }
            })
            .catch(function () {
              //cancel selection of node, nothing to do
            });
        } else if (result !== false) {
          selectNewNode(node);
        }
      } else {
        selectNewNode(node);
      }
    }

    $ctrl.expandNodeHandler = function (node, $event) {
      $event.stopPropagation();
      node.toggle();
    }

    // HELPERS
    function selectNewNode(node) {
      // same node clicked again, so its a deselect-action
      if ($ctrl.selectedNode === node
          || ($ctrl.selectedNode && $ctrl.selectedNode.id === node.id)
      ) {
        $ctrl.selectedNode.isSelected = false;
        $ctrl.selectedNode = null;
        return false;
      }

      // reset old node
      $ctrl.selectedNode && ($ctrl.selectedNode.isSelected = false);

      node && (node.isSelected = true);
      $ctrl.selectedNode = node;
    }

    function nestedSearch(treeNodesDataLevel, searchValue) {
      _.forEach(treeNodesDataLevel, function (treeNode) {
        if (treeNode && treeNode.children && treeNode.children.length) {
          nestedSearch(treeNode.children, searchValue);
        }

        if (typeof treeNode.label === 'string'
            && typeof searchValue === 'string' && searchValue !== ''
            && treeNode.label.toUpperCase().indexOf(searchValue.toUpperCase()) > -1
        ) {
          treeNode.matched = true;
          treeNode.collapsed = false;
        } else {
          treeNode.matched = false;
        }
      });
    }

    $ctrl.visible = function (node) {
      return !(
        $ctrl.nodesSearchValue
        && $ctrl.nodesSearchValue.length > 0
        && !(node.matched || node.hasMatchingChildren || (node.children && node.children.filter(function (c) {
          return c.matched
        }).length))
      );
    };

    function searchValueChanged(newVal) {
      // you could also use angular.isFunction
      if (typeof $ctrl.searchValueChange === 'function') {
        $ctrl.searchValueChange.call($ctrl)(newVal);
      }

      nestedSearch($ctrl.treeNodesData, newVal);
    }

    function setupWatchers() {
      $scope.$watch('$baTreeviewCtrl.nodesSearchValue', function (newVal) {
        searchValueChanged(newVal);
      });
    }

    function resetViewValues(treeNodesDataLevel) {
      _.forEach(treeNodesDataLevel, function (treeNode) {
        if (treeNode && treeNode.children && treeNode.children.length) {
          resetViewValues(treeNode.children);
        }

        // these reset-values can be adjusted to provide certain features like keep the matched (found) tree nodes
        treeNode.isSelected = false;
        treeNode.matched = false;
      });
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoBaTreeviewComponent
  *
  * @description Component is provides a tree-view with pre-defined arno elements like expand/collapse button, or a std-tree-component
  */
  angular.module('BlurAdmin.theme.components.baTreeview', [])
    .component('arnoBaTreeview', {
      templateUrl: 'app/theme/components/baTreeview/baTreeview.tpl.html',
      controller: 'ArnoBaTreeviewController',
      controllerAs: '$baTreeviewCtrl',
      transclude: {
        'content': '?arnoBaTreeviewContent',
        'headerBarLeftButtonRow': '?arnoBaTreeviewHeaderBarLeftButtonRow',
        'headerBarRightButtonRow': '?arnoBaTreeviewHeaderBarRightButtonRow',
        'footerBarRightButtonRow': '?arnoBaTreeviewFooterBarRightButtonRow'
      },
      bindings: {
        treeNodesData: '=',
        selectedNode: '=',
        nodeSelect: '=?',
        hasError: '<?',
        uiConfig: '<?'
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoBaTableviewController', ArnoBaTableviewController);

  /**
  * @description Controller for the ba-tableview component.
  *
  * @namespace BlurAdmin.theme.components.ArnoBaTableviewController
  */
  /** @ngInject */
  function ArnoBaTableviewController(
    $transclude,
    $uibModal,
    commonUtils
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.tableConfig = $ctrl.tableConfig || {
      visibleCols: $ctrl.listVisibleCols // maybe add a std-definition for visible cols here, e.g. Name
    }

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoBaTableviewController#
    */
    function activate() {
      $ctrl.contentSlotPresent = $transclude.isSlotFilled('content');
      $ctrl.listPageSizes = $ctrl.listPageSizes || [5, 10, 20, 50];
      $ctrl.listPageSize = commonUtils.getPageSize('personnel_dossier_trainings_tableview', null) || $ctrl.listPageSizes[0];
    }

    // LIFE-CYCLE-HOOKS
    $ctrl.$onChanges = function(changes) {
      if (changes) {
        // you could add a further if-check for changes.listVisibleCols too
        $ctrl.tableConfig.visibleCols = $ctrl.listVisibleCols; // could take from changes.visibleCols.currentValue too

        // you could add a further if-check for changes.listPageSizes too
        // only reassign, if $ctrl.listPageSizes is valid
        if ($ctrl.listPageSizes) {
          $ctrl.listPageSize = $ctrl.listPageSize || $ctrl.listPageSizes[0];
        }
      }
    }

    // VIEW-FUNCTIONS


    // EVENT-HANDLERS
    $ctrl.openTableConfigModal = function() {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/baTableview/baTableviewConfigModal.tpl.html',
          size: 'md',
          resolve: {
            tableConfig: $ctrl.tableConfig,
          },
          controller: function (tableConfig) {
            this.tableConfig = tableConfig;
          },
          controllerAs: '$baTableviewModalCtrl'
        });
    }

    $ctrl.changePageSize = function(newSize) {
      $ctrl.listPageSize = commonUtils.getPageSize('personnel_dossier_trainings_tableview', newSize);

      if (typeof $ctrl.listPageSizeChange === 'function') {
        $ctrl.listPageSizeChange.call($ctrl, newSize);
      }
    }

    $ctrl.refreshData = function(params) {
      if (typeof $ctrl.listRefreshData === 'function') {
        return $ctrl.listRefreshData.call($ctrl, params, $ctrl);
      }
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoBaTableviewComponent
  *
  * @description Component is provides a table-view with pre-defined arno elements like pagination, entries-per-page or table-configuration (with modal)
  */
  angular.module('BlurAdmin.theme.components')
    // REMARK: must be directive to have the linking to replace the root-element of a transclusion-slot! everything else is the same
    .component('arnoBaTableview', {
      templateUrl: 'app/theme/components/baTableview/baTableview.tpl.html',
      controller: 'ArnoBaTableviewController',
      controllerAs: '$baTableviewCtrl',
      transclude: {
        'content': '?arnoBaTableviewContent',
        'headerBarLeftButtonRow': '?arnoBaTableviewHeaderBarLeftButtonRow',
        'headerBarRightButtonRow': '?arnoBaTableviewHeaderBarRightButtonRow'
      },
      bindings: {
        listData: '=?',
        listColsDefinition: '<?',
        listSelectedEntry: '=?',
        listVisibleCols: '=',
        listPageSizes: '<?',
        listPageSize: '=?',
        listPageSizeChange: '=?',
        listRefreshData: '=?',
        uiConfig: '<?'
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoBaSpinnerController', ArnoBaSpinnerController);

  /**
  * @description Controller for the ba-spinner component.
  *
  * @namespace BlurAdmin.theme.components.ArnoBaSpinnerController
  */
  /** @ngInject */
  function ArnoBaSpinnerController(
    $scope, $transclude
  ) {
    var $ctrl = this;

    // VARS

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoBaSpinnerController#
    */
    function activate() {
      $ctrl.contentSlotPresent = $transclude.isSlotFilled('content');

      setupWatchers();
    }

    // VIEW-FUNCTIONS
    $ctrl.circleSpinnerStyles = function() {
      return {
        width: $ctrl.size || '50px',
        height: $ctrl.size || '50px',

        'border-width': $ctrl.weight || '10px',
        'animation-duration': $ctrl.animDuration || '2s'
      }
    }

    // HELPERS
    function setupWatchers() {
      var showDebounced;

      showDebounced = _.debounce(function() {
        $ctrl.showSpinner = true;
      }, getDelay());

      $scope.$watch('$baSpinnerCtrl.show', function(newVal){
        if (newVal) {
          showDebounced();
        }
        else {
          showDebounced.cancel();
          $ctrl.showSpinner = false;
        }
      });
    }

    function getDelay() {
      var delay = parseInt($ctrl.delay || 750);
      return angular.isNumber(delay) ? delay : 750;
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoBaSpinnerComponent
  *
  * @description Component is provides a tree-view with pre-defined arno elements like expand/collapse button, or a std-tree-component
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoBaSpinner', {
      templateUrl: 'app/theme/components/baSpinner/baSpinner.tpl.html',
      controller: 'ArnoBaSpinnerController',
      controllerAs: '$baSpinnerCtrl',
      transclude: {
        'content': '?arnoBaSpinnerContent',
      },
      bindings: {
        type: '@?',
        text: '@?',
        show: '<',
        customCls: '@?',
        size: '@?', // in pixel of the spinner
        weight: '@?',
        animDuration: '@?', // in seconds for the animation
        delay: '@' // seconds to wait before showing the spinner, std is 1s
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baPanelTitleTagList', baPanelTitleTagList);

  /** @ngInject */
  function baPanelTitleTagList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baPanelTitleTagList/baPanelTitleTagList.html',
      scope: false,
      controller: 'baPanelTitleTagListCtrl as self'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baPanelTitleTagListCtrl', baPanelTitleTagListCtrl);

  /** @ngInject */
  function baPanelTitleTagListCtrl($scope) {
    var self = this;

    $scope.$watch(function() {
      return $scope.baPanelTagList;
    }, function() {
      self.tagList = $scope.baPanelTagList;
    }, true);
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baSidebarToggleMenu', baSidebarToggleMenu)
    .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
    .directive('baSidebarTogglingItem', baSidebarTogglingItem)
    .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
    .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
    .directive('baUiSrefToggler', baUiSrefToggler)
    .directive('baSidebarHighlight', baSidebarHighlight);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.on('click', function ($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function () {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.on('click', function ($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function () {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, $transitions, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function () {
        console.log('$$expandSubmenu');
        console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu')
      };
      vm.$$collapseSubmenu = function () {
        console.log('$$collapseSubmenu');
        console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu')
      };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function () {
        vm.$$expandSubmenu();
        // find out if current main menu has the current state as a child
        if($element.hasClass('tmpSelected') && $element.find('.selected').length>0){
          // if parent of current state element is collapsed, set tmp class to parent
          var toggleParent = $element.find('.selected').parents('.with-sub-menu:first');
          if(!toggleParent.hasClass('ba-sidebar-item-expanded')){
            baSidebarService.setTmpSelect(toggleParent);
          }
          // just remove the tmpClass from the current main Element
          baSidebarService.removeTmpSelect($element);
        }
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function () {
        vm.$$collapseSubmenu();
        // if element contains the current selected state entry, set parent to tmpSelected
        if($element.find('.selected').length>0){
          baSidebarService.setTmpSelect($element);
        }
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function () {
        $element.hasClass('ba-sidebar-item-expanded') ?
        vm.$collapse() :
        vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $transitions.onStart({}, function (trans) {
        if (!_isState(trans.to()) && $element.hasClass('ba-sidebar-item-expanded')) {
          $element.removeClass('ba-sidebar-item-expanded');
          vm.$collapse();
        }
      });

      $transitions.onSuccess({}, function (trans) {
        if (_isState(trans.to()) && !$element.hasClass('ba-sidebar-item-expanded')) {
          $element.addClass('ba-sidebar-item-expanded');
          vm.$expand();
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function (subItemState) {
        return state.name.indexOf(subItemState) == 0;
      });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu() {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function (scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function () {
          el.slideDown();
        };
        baSidebarTogglingItem.$$collapseSubmenu = function () {
          el.slideUp();
        };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function (scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function () {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function () {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarHighlight(baSidebarService, $state, $transitions,$timeout) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        baSidebarService.sideBarElement = el;
        $timeout(function () {
          if(el.find('.selected').length==0){
            baSidebarService.handleTmpSelect($state.$current);
          }
        }, 250);
        $transitions.onSuccess({}, function () {
          baSidebarService.removeAllTmpStates();
          baSidebarService.handleTmpSelect($state.$current);
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function () {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function ($state, layoutSizes, permissions, pageButtons) {
      return new _factory();

      function _factory() {
        this.sideBarElement = '';// this element will be set in baSidebarHelpers.directive.js in "baSidebarHighlight" directive
        var self = this;
        var isMenuCollapsed = shouldMenuBeCollapsed();
        if (isMenuCollapsed) {
          pageButtons.addClass('menu-collapsed');
        }

        this.getMenuItems = function () {
          var states = defineMenuItemStates();
          //result shoud like [0,1,2]
          addTreeInfo(states);
          return states
            .filter(function (e) {
              return e.level === 0;
            })
            .concat(staticMenuItems)
            ;
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function (isCollapsed) {
          isMenuCollapsed = isCollapsed;
          self.handleSubMenuToggle();
        };

        this.isMenuCollapsed = function () {
          return isMenuCollapsed;
        };

        this.handleSubMenuToggle = function () {
          // isn't it possible to solve sufft like this without jQuery DOM manipulation?
          var currentSelected = self.sideBarElement.find('.selected');
          if (!isMenuCollapsed) {
            //open the sideBar
            if (currentSelected.parents('.ba-sidebar-item-expanded').length > 0) {
              self.removeTmpSelect(currentSelected.parents('.ba-sidebar-item-expanded'));
            }
          } else {
            //close the sideBar
            if (currentSelected.parents('.ba-sidebar-item-expanded').length > 0) {
              self.setTmpSelect(currentSelected.parents('.ba-sidebar-item-expanded'));
            }
          }
          if (isMenuCollapsed) {
            pageButtons.addClass('menu-collapsed');
          } else {
            pageButtons.removeClass('menu-collapsed');
          }
        };
        this.handleTmpSelect = function (state) {
          var stateName = state.name;
          if (stateName != '') {
            // do we have a menuEntry which matches the current state?
            var currentFinding = self.sideBarElement.find('a[data-route-name="' + stateName + '"]');
            if (currentFinding.length == 0) {
              // find the parent state of our current state to highlight in sideBar
              //var parent = {name:stateName.substr(0, stateName.lastIndexOf('.'))};
              self.handleTmpSelect(state.parent);
            } else {
              self.setTmpSelect(currentFinding.parent());
              return true;
            }
          } else {
            return false;
          }
        };
        this.removeAllTmpStates = function () {
          self.sideBarElement.find('.tmpSelected').removeClass('tmpSelected');
        };
        this.removeTmpSelect = function (element) {
          element.removeClass('tmpSelected');
        };
        this.setTmpSelect = function ($element) {
          $element.addClass('tmpSelected');
        };
        this.toggleMenuCollapsed = function () {
          isMenuCollapsed = !isMenuCollapsed;
          self.handleSubMenuToggle();
        };

        this.getAllStateRefsRecursive = function (item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          var states = $state.get();

          var tmpStates = states.map(function (s) {
            return {
              name: s.name,
              level: (s.name.replace(/^arno\./, '').match(/\./g) || []).length,
              abstract: s.abstract,
              viewPermission: s.viewPermission,
              viewPermissionScopes: s.viewPermissionScopes,
              sidebarMeta: s.sidebarMeta,
              stateClick: s.stateClick,
            };
          });
          // keep only states where permitted
          tmpStates = tmpStates.filter(function (s) {
            return permissions.isPermittedAnywhere(s.viewPermission || s.name, s.viewPermissionScopes);
          });
          addTreeInfo(tmpStates);
          var subMenuCheck = function(s) {
            return s.subMenu && s.subMenu.length && s.subMenu.filter(function (sub) {
              return ((!sub.abstract && sub.sidebarMeta) || (sub.sidebarMeta && sub.sidebarMeta.stateRedirect))
                     || subMenuCheck(sub);
            }).length
          };
          var statesToKeep = tmpStates
            // drop abstract states without submenus
            .filter(function (s) {
              return ((!s.abstract && s.sidebarMeta) || (s.sidebarMeta && s.sidebarMeta.stateRedirect))
                     || subMenuCheck(s);
            })
            // keep only names
            .map(function (s) {
              return s.name;
            });
          states = states
          // drop other states
            .filter(function (s) {
              return statesToKeep.indexOf(s.name) !== -1;
            })
            .filter(function (s) {
              return s.sidebarMeta;
            })
            .map(function (s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: meta.title || s.title,
                level: (s.name.replace(/^arno\./, '').match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: meta.stateRedirect || s.name,
                stateOrig: meta.stateRedirect ? s.name : false,
                stateClick: s.stateClick,
              };
            })
            .sort(function (a, b) {
              var order = (a.level - b.level) * 100 + a.order - b.order;
              if (!order) {
                order = a.name < b.name ? -1 : 1;
              }
              return order;
            })
          ;
          return states;
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }

        function addTreeInfo(states) {
          //result shoud like [0,1,2]
          var levels = states.map(function (e) {
            return e.level;
          }).filter(function (e, i, arr) {
            return i === arr.indexOf(e);
          });
          //add subMenu for each level item
          levels.forEach(function (level) {
            var menuItems = states.filter(function (e) {
              return e.level === level;
            });
            menuItems.forEach(function (item) {
              var children = states.filter(function (child) {
                return child.level - level === 1 && child.name.indexOf(item.name) === 0;
              });
              item.subMenu = children.length ? children : null;
            });
          });
        }
      }

    }
    ;

  }
})
();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, ScrollbarService, portalLogoService) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl as $baSidebarCtrl',
      link: function (scope, el) {
        scope.menuHeight = el[0].childNodes[0].clientHeight - (portalLogoService.showOrgLabel ? 180 : 140);

        scope.$on('sidebarupdate', function() {
          $('.scroll-content').css('height', _calculateMenuHeight()+'px')
        });

        $('.scroll-content').css('height', scope.menuHeight+'px'); // adjust scrollable field height
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function () {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baSidebarService.shouldMenuBeCollapsed() && baSidebarService.isMenuCollapsed()) {
            baSidebarService.setMenuCollapsed(true);
          }
          if (baUtil.isDescendant(el[0], $evt.target)) {
            var scrollbar = ScrollbarService.getInstance('bar');
            setTimeout(function() {
              scrollbar.$$state.value.update();
            }, 300)
          }
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.shouldMenuBeCollapsed()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          $('.scroll-content').css('height', newMenuHeight+'px'); // adjust scrollable field height
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - (portalLogoService.showOrgLabel ? 180 : 140);
        }
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($rootScope, $scope, $transitions, baSidebarService, progressBar, $state, portalLogoService) {
    $scope.menuItems = baSidebarService.getMenuItems();

    $transitions.onSuccess({}, function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });

    $scope.$watch(function() {
      return $state.current.name;
    }, function() {
      $scope.stateCurrentName = $state.current.name;  
    })

    $scope.portalLogo = portalLogoService;
    progressBar.progressInstance.setParent(document.querySelector('.al-main'));

    $rootScope.$hidePreLoad();
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 *
 * modified by ARNO-Team on 21.01.2019: added multi-slot transclusion for panel-footer
 * modified by ARNO-Team on 07.03.2019: added tooltip possibilty for header
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel($translate) {

    /** Base baPanel directive
     * @description This widely used BlurAdmin panel provides the possibilty to add a simple header + optional tooltip,
     * and per transclusion a panel-body or panel-footer.
     *
     * The whole markup inside the directive will be added as bootstrap "panel-body". Whereas only the markup inside the slot
     * "<ba-panel-footer></ba-panel-footer>" is rendered as bootstrap "panel-footer".
     *
     * The tooltip for the header can be added by specifying
     *
     */
    return {
      restrict: 'AE',
      transclude: {
        'footer': '?baPanelFooter'
      },
      scope: true,
      template: function (elem, attrs) {
        var res = '\
          <div class="panel-body" ng-transclude></div> \
          <div ng-transclude="footer" class="panel-footer" ng-if="footerSlotPresent"></div> \
        ';

        var sideTitle = '';

        if (attrs.baPanelTagList) {
          sideTitle = '<ba-panel-title-tag-list tag-list="tagList"></ba-panel-title-tag-list>';
        }

        if (attrs.baPanelDivisionSelector) {
          var multiple = '';
          var namespace = '';
          var allowOrgSelection = '';
          var entryPermission = '';
          if (attrs.baPanelDivisionSelectorMultiple === 'true') {
            multiple = ' multiple="true"';
          }
          if (attrs.baPanelDivisionSelectorNamespace) {
            namespace = ' namespace="' + attrs.baPanelDivisionSelectorNamespace + '"';
          }
          if (attrs.baPanelDivisionSelectorAllowOrgSelection) {
            allowOrgSelection = ' allow-org-selection="' + attrs.baPanelDivisionSelectorAllowOrgSelection + '"';
          }
          if (attrs.baPanelDivisionSelectorEntryPermission) {
            entryPermission = ' entry-permission="' + attrs.baPanelDivisionSelectorEntryPermission + '"';
          } else if (attrs.baPanelDivisionSelectorEntryPermissionScoped) {
            entryPermission = ' entry-permission="{{baPanelDivisionSelectorEntryPermissionScoped}}"';
          }
          sideTitle = '<division-selector is-active="' + attrs.baPanelDivisionSelector + '" class="ml-8" '
                             + multiple + namespace + allowOrgSelection + entryPermission + '></division-selector>';
        }

        var tooltipIconCls = attrs.baPanelHeaderTooltipIconCls || 'fa fa-info-circle';
        var titleTpl = '';

        if (attrs.baPanelTitle && !attrs.baPanelDivisionSelectorDashboard) {
          titleTpl += '<div class="panel-heading clearfix d-flex align-items-center">';
        } else if (attrs.baPanelTitle && attrs.baPanelDivisionSelectorDashboard) {
          titleTpl += '<div style="display: flex; align-items: center; flex-direction: column; padding: 14px 22px;">';
        } else {
          titleTpl += '<div ng-if="baPanelHeaderTooltipTemplate" class="panel-heading clearfix">';
        }
        var titleToolTip = '';
        if (attrs.baPanelHelpIcon) {
          // TODO CSI make texts configurable
          var params = 'text="' + attrs.baPanelHelpIcon + '"';
          if (attrs.baPanelHelpIconType == 'directLink') {
            params = params + ' type="directLink"';
          }
          titleToolTip = '<arno-ba-help-tooltip ' + params + '></arno-ba-help-tooltip>';
        }
        titleTpl += '<h3 id="dashboard-panel" class="panel-title flex-grow-1 '
                    + (sideTitle ? 'with-side-title' : 'text-overflow')
                    + '"'
                    + (attrs.baPanelTitle && attrs.baPanelDivisionSelectorDashboard ? 'style="width: 100%;margin-bottom: 8px"' : '')
                    +'>'
                    + '{{ parsedPanelTitle }}'
                    + titleToolTip
                    + '<span ng-if="baPanelHeaderTooltipTemplate" class="{{baPanelHeaderTooltipCls}}">\
                  <span \
                    uib-tooltip-template="baPanelHeaderTooltipTemplate" \
                    tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" \
                    tooltip-placement="bottom" \
                    tooltip-append-to-body="true" \
                    > \
                    <i class="' + tooltipIconCls + '"></i>\
                  </span> \
                </span> \
              </h3>'
                    + sideTitle
                    + '</div>';

        res = titleTpl + res; // title should be before

        return res;
      },
      link: function (scope, element, attrs, ctrl, trfn) {
        scope.footerSlotPresent = trfn.isSlotFilled('footer');

        // bindings for tooltip
        scope.baPanelHeaderTooltipTemplate = attrs.baPanelHeaderTooltipTemplate;
        // arrange icon to the right as standard
        scope.baPanelHeaderTooltipCls = attrs.baPanelHeaderTooltipCls || 'pull-right';

        // alternative scoped bindings
        ['baPanelTitle', 'baPanelTagList', 'baPanelTitleTranslateVars', 'baPanelDivisionSelectorEntryPermissionScoped'].forEach(function (attribute) {
          scope.$parent.$watch(attrs[attribute], function (newVal) {
            scope[attribute] = newVal;
          });
          scope.$watch(attribute, function (newVal) {
            scope.$parent[attrs[attribute]] = newVal;
          });
        });

        scope.$watch('baPanelTitleTranslateVars', function (translateVars) {
          scope.parsedPanelTitle = (
            $translate.instant(
              scope.baPanelTitle,
              translateVars || {}
            ) ? $translate.instant(scope.baPanelTitle, scope.baPanelTitleTranslateVars || {}) : scope.baPanelTitle);
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
    .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function (el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '');
        if (el.closest('[uib-modal-window]').length
            || (attrs.baPanelClass && !!~attrs.baPanelClass.indexOf('inline-panel'))) {
          // we are in a modal window, or have an inline panel (a panel-in-panel)
          // so please no animations
          res += ' ' + (attrs.baPanelClass || '');
          res += '" ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        } else {
          res += ' full-invisible ' + (attrs.baPanelClass || '');
          res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        }
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoBaHelpTooltipController', ArnoBaHelpTooltipController);

  /**
   * @description Controller for the ba-helpTooltip component.
   *
   * @namespace BlurAdmin.theme.components.ArnoBaHelpTooltipController
   */
  /** @ngInject */
  function ArnoBaHelpTooltipController( $translate, ARNO_TEXTS) {
    var $ctrl = this;

    // VARS
    $ctrl.renderedText = '';
    $ctrl.helpTooltip = $translate.instant('generalTerms.goToHelp');

    // BOOTSTRAPPER
    /**
     * @name activate
     * @description Function for controller inits
     * @returns {Void} none
     * @memberOf ArnoBaHelpTooltipController#
     */
    function activate() {
      // try to find text with given key, if not, then just output the text as it!
      if (ARNO_TEXTS[$ctrl.text]) {
        $ctrl.renderedText = ARNO_TEXTS[$ctrl.text];
      } else {
        $ctrl.renderedText = $ctrl.text;
      }
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    };
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoBaHelpTooltipComponent
  *
  * @description Component is provides a tree-view with pre-defined arno elements like expand/collapse button, or a std-tree-component
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoBaHelpTooltip', {
      templateUrl: 'app/theme/components/baHelpTooltip/baHelpTooltip.tpl.html',
      controller: 'ArnoBaHelpTooltipController',
      controllerAs: '$baHelpTooltipCtrl',
      bindings: {
        text: '@',
        type: '@',
        customIconCls: '@?',
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('ArnoBaAddressController', ArnoBaAddressController);

  /**
  * @description Controller for the ba-address component.
  *
  * @namespace BlurAdmin.theme.components.ArnoBaAddressController
  */
  /** @ngInject */
  function ArnoBaAddressController(
    $scope,
    commonUtils, validationUtils
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.elementsIds = commonUtils.uuid();

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoBaAddressController#
    */
    function activate() {
      $ctrl.COUNTRY_IDS = $ctrl.countryIdsCatalogue;
      $ctrl.canEdit = $ctrl.canEdit;
    }

    // VIEW-FUNCTIONS
    $ctrl.hasError = function (form, formFieldsNames, errorTypes, considerTouched) {
      var fieldsNames = formFieldsNames;

      if (typeof fieldsNames === 'string') {
        fieldsNames += '-' + $ctrl.elementsIds;
      }
      else if (Array.isArray(fieldsNames)) {
        fieldsNames = _.map(formFieldsNames, function (fieldName) {
          return fieldName + '-' + $ctrl.elementsIds;
        });
      }

      return validationUtils.hasError(form, fieldsNames, errorTypes, considerTouched)
    }

    $ctrl.showHouseNumberWarning = function () {
      return ($ctrl.formRef['inputHouseNumber-' + $ctrl.elementsIds].$touched || $ctrl.formRef.$submitted) && !validationUtils.isValidHouseNumber($ctrl.address.HouseNumber);
    }

    $ctrl.takeAdressfromBusinessPartner = function () {
      $ctrl.address.City = $ctrl.address.BusinessPartner.City;
      $ctrl.address.ZIP = $ctrl.address.BusinessPartner.ZIP;
      $ctrl.address.Street = $ctrl.address.BusinessPartner.Street;
      $ctrl.address.HouseNumber = $ctrl.address.BusinessPartner.HouseNumber;
      $ctrl.address.AddressAffix = $ctrl.address.BusinessPartner.AddressAffix;
      $ctrl.address.CountryId = $ctrl.address.BusinessPartner.CountryId;
    }

    $scope.$watch(function () {
      return $ctrl.address.CountryId
    }, function (newVal) {
      if (typeof newVal === 'string') {
        // when a string is passed, it's most likely the mapping string, so find the correct object and assign it
        var countryCodeObj = _.find($ctrl.COUNTRY_IDS, function (countryObj) {
          return countryObj.mapping === newVal;
        })
        if (countryCodeObj) {
          $ctrl.address.CountryId = countryCodeObj;
        }
      }
    })

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    }
  }
})();

(function () {
  'use strict';

  /**
  * @ngdoc component
  * @name arnoBaAddressComponent
  *
  * @description Component is provides multiple inputs to enter a full-address structure: zip, city, street, housenumber, address-addition
  */
  angular.module('BlurAdmin.theme.components')
    .component('arnoBaAddress', {
      templateUrl: 'app/theme/components/baAddress/baAddress.tpl.html',
      controller: 'ArnoBaAddressController as $baAddressCtrl',
      controllerAs: '$baAddressCtrl',
      bindings: {
        address: '=', // object which holds/provides the input-data/values
        formRef: '<',
        countryIdsCatalogue: '<?', // if a pre-loaded catalogue for country-ids should be taken, instead of dynamically loading one from api
        labelsPrefix: '@?',
        viewOnly: '<?', // disable field inputs
        canEdit: '<?', // disable field inputs
        fieldsConfig: '<?', // used to set e.g. required fields...
        uiConfig: '<?' // used to set e.g. css-classes for the input-fields
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('attendingEventList', attendingEventList);

  /** @ngInject */
  function attendingEventList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/attendingEventList/attendingEventList.html',
      scope: {
        ownAttendingServices: '=',
        userEmail: '=',
      },
      controller: 'attendingCtrl as $svcIntCtrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function attendingCtrl($scope, $state) {
    var self = this;
    self.ownAttendingServices = $scope.ownAttendingServices;
    self.userEmail = $scope.userEmail;

    self.openServiceDetails = function(event) {

      if(event.IsService)
      {
        $state.go('arno.events.serviceDetail', { serviceId: event.sourceServiceId, ctx: event.SourceDivisionId});
      }
      else
      {
        $state.go('arno.events.eventDetail', { eventId: event.id });
      }
    
    };
  }
  angular.module('BlurAdmin.theme.components')
    .controller('attendingCtrl', attendingCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('arnoAdminOrgList', arnoAdminOrgList);

  /** @ngInject */
  function arnoAdminOrgList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/arnoAdminOrgList/arnoAdminOrgList.html',
      scope: {
        organizations: '=',
        isDemo: '=',
      },
      controller: 'arnoAdminOrgListCtrl as $ctrl'
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function arnoAdminOrgListCtrl($scope, $uibModal, $state, clientApi, toastr, baModalService) {
    var self = this;
    self.organizations = $scope.organizations;
    self.isDemo = $scope.isDemo;

    self.export = function (organization, detail) {
      $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/arnoAdministration/export/chooseExportTypeModal.html',
          size: 'md',
          controller: 'ChooseExportTypeCtrl as $chooseExportTypeCtrl',
        })
        .result
        .then(function (result) {
          clientApi.openTab('organization/export', {
            format: result.filetyp,
            detailed: detail,
            organizationId: organization.id,
          });

          toastr.info('Dein Download wurde gestartet.', 'Export gestartet');
        });
    };

    self.delete = function(item) {
      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: 'Demo-Organisation löschen',
        content: 'Möchtest du die Demo-Organisation "' + item.Name + '" wirklich löschen?',
        primaryActionText: 'Löschen',
        secondaryActionText: 'Abbrechen',
      })
      .then(function() {
        return clientApi
        .custom('model/Organization', 'deleteDemoOrganization', {
          orgId: item.id,
        })
        .then(function () {
          toastr.success('Die Demo-Organisation ' + item.Name + ' wurde erfolgreich gelöscht.', 'Demo-Organisation gelöscht');
          return $state.reload();
        })
        .catch(function () {
          toastr.error('Die Demo-Organisation ' + item.Name + ' konnte nicht gelöscht werden.', 'Löschen gescheitert');
        });
      });
    }
  }
  angular.module('BlurAdmin.theme.components')
    .controller('arnoAdminOrgListCtrl', arnoAdminOrgListCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('approvalProcessListCtrl', approvalProcessListCtrl);

  /** @ngInject */
  function approvalProcessListCtrl(
    ARNO_CONSTANTS, commonUtils, $uibModal, $state, $translate, toastr, clientApi, $rootScope, $scope, permissions,
    ArnoDashAdminClearancesService, baModalService
  ) {
    var self = this;

    // CONSTS
    self.CLEARANCES_TYPES_LABELS = ARNO_CONSTANTS.ADMIN.CLEARANCES.CLEARANCES_TYPES_LABELS;
    self.CONSTANTS_GENERAL = ARNO_CONSTANTS.GENERAL;

    // VARS
    var ctx = $scope.ctx;
    self.divisionId = ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' });
    self.chosen = {};
    self.chosenCount = 0;
    self.previewAttempts = 0;
    self.chosenIds = [];
    self.tableConfig = $scope.tableConfig;
    self.memberGroups = $scope.memberGroups;
    self.organizationId = $rootScope.ctx.organization.current.id;
    self.showMemberName = $scope.showMemberName;
    self.disallowEdit = $scope.disallowEdit;
    self.allowStartPerm = false;
    self.demandForActionBtnActive = $scope.onlyDemandForAction;
    self.allowExport = $scope.allowExport;
    self.chosenApprovals = [];
    self.displayCollection = [];
    self.allowedReferences = $scope.allowedReferences || {};
    self.aggregations = {
      'Approval.ClearanceGroup.id': false,
      'AffectedMember.id': false
    };
    self.groupAndOrderBy = [];
    self.allowStartPerm = !!Object.keys(self.allowedReferences['arno.item.approval.start'] || {}).filter(function (division) {
      return self.allowedReferences['arno.item.approval.start'][division] && self.allowedReferences['arno.item.approval.start'][division].length;
    }).length;
    self.state = {
      PENDING: $translate.instant('models.Approval.State.PENDING'),
      PROCESSING: $translate.instant('models.Approval.State.PROCESSING'),
      ASSIGNED: $translate.instant('models.Approval.State.ASSIGNED'),
      RESUB_APPROACHING: $translate.instant('models.Approval.State.RESUB_APPROACHING'),
      RESUB_OVERDUE: $translate.instant('models.Approval.State.RESUB_OVERDUE'),
      REJECTED: $translate.instant('models.Approval.State.REJECTED'),
      PAUSED: $translate.instant('models.Approval.State.PAUSED'),
    };
    self.preSelectedId = (Number.parseInt || parseInt)($scope.preSelectedId, 10);
    self.preSelectedVersion = $scope.preSelectedVersion;
    self.tableViewsApproval = {};
    var preferenceView = commonUtils.preference.object.get('pref_current_approval_list_view', '0');
    var approvalTableConf = $scope.tableConfig.tableConfigDefault;
    if (preferenceView.id && $scope.tableConfig && self.showMemberName) {
      var selectedView = _.find($scope.tableConfig.tableConfigCustomPreference, function (view) {
        return view.id == preferenceView.id;
      });
      if (selectedView) {
        approvalTableConf = JSON.parse(selectedView.Fields);
      } else {
        preferenceView = '0';
      }
    }
    self.currentTableConf = {
      title: $translate.instant('MaterialMedicine.View'),
      active: true,
      selectedView: preferenceView.id || preferenceView,
      isOrgList: false,
      tableConfig: approvalTableConf,
      customViews: self.tableViewsApproval,
      defaultView: {
        Fields: $scope.tableConfig.tableConfigDefault,
      },
      ctx: self.divisionId,
    };

    function storeTableConfig(list) {
      if (list.selectedView === '0') {
        commonUtils.preference.object.delete('pref_current_approval_list_view');
      } else {
        commonUtils.preference.object.set(
          'pref_current_approval_list_view', {
            id: list.selectedView
          }
        );
      }
    }

    function getBulkData() {
      calcSelected();
      return self.chosenApprovals.map(function (ap) {
        return {
          id: ap.id,
          ApprovalId: ap.ApprovalId,
          DivisionId: ap.DivisionId,
        };
      });
    }

    self.$onInit = function () {
      // Call reloadProcesses during component initialization
      self.reloadProcesses();
    };

    self.demandForActionSwitcherKeys = {
      on: $translate.instant('generalTerms.demandForAction'),
      off: $translate.instant('modules.personnel.approvals.allApprovals'),
    };

    self.getCurrentTableView = function () {
      if (self.currentTableConf.hasViewModifications) {
        return self.currentTableConf.tmp;
      } else if (self.currentTableConf.selectedView !== '0') {
        return self.currentTableConf.customViews[self.currentTableConf.selectedView];
      }
      return self.currentTableConf.defaultView;
    };

    function applyAggregations(override, view) {
      if (view === '0') {
        view = self.currentTableConf.defaultView;
      }
      var currentView = view || self.getCurrentTableView();
      if (override) {
        Object.keys(self.aggregations).forEach(function (key) {
          delete self.aggregations[key];
        });
      }
      if (currentView) {
        if (override && currentView.Aggregations) {
          // wipe without killing reference
          _.assign(self.aggregations, currentView.Aggregations);
          if (_.isBoolean(self.aggregations['Approval.ClearanceGroup'])) {
            self.aggregations['Approval.ClearanceGroup.id'] = self.aggregations['Approval.ClearanceGroup'];
            delete self.aggregations['Approval.ClearanceGroup'];
          }
        }
        self.groupAndOrderBy = Object.keys(self.aggregations)
          .filter(function (key) {
            return self.aggregations[key];
          });
        var cl = Object.keys(self.chosen);
        if (cl.length && Object.keys(self.aggregations).filter(function (key) { return self.aggregations[key];}).length) {
          toastr.warning(
            $translate.instant('modules.personnel.approvals.applyAggregationsWarnToastText'),
            $translate.instant('modules.personnel.approvals.applyAggregationsWarnToastTitle')
          );
          cl.forEach(function (key) {
            delete self.chosen[key];
          });
        }
      }
    }

    function calcSelected() {
      self.chosenApprovals = [];
      self.chosenIds.forEach(function (approvalId) {
        self.chosenApprovals.push(_.find($scope.approvalProcesses, function (ap) {
          return ap.id === parseInt(approvalId, 10);
        }));
      });
      self.chosenApprovals = _.compact(self.chosenApprovals);
      self.bulkPausable = _.compact(self.chosenApprovals.map(function (ca) {
        return !ca.Paused;
      })).length;
      self.bulkResumable = _.compact(self.chosenApprovals.map(function (ca) {
        return ca.Paused === true;
      })).length;
    }

    self.aggregate = function (prop, event) {
      if (event) {
        event.stopPropagation();
      }
      self.aggregations[prop] = !self.aggregations[prop];
      applyAggregations();
    };

    self.changeListView = function (list, val, storageIdentifier) {
      // restore original config values and then switch view
      self.handleCustomLists($scope.tableConfig.tableConfigCustomPreference);
      delete self.currentTableConf.defaultView.Aggregations;
      self.currentTableConf.hasViewModifications = false;
      delete self.currentTableConf.tmp;
      if (val === '0') {
        list.tableConfig = JSON.parse(JSON.stringify(list.defaultView.Fields));
      } else {
        list.tableConfig = JSON.parse(JSON.stringify(val.Fields));
      }
      list.selectedView = storageIdentifier;
      applyAggregations(true, val);
      storeTableConfig(list);
    };

    self.handleCustomLists = function (customTableConfigs) {
      // preserve an unreferenced config
      $scope.tableConfig.tableConfigCustomPreference = JSON.parse(JSON.stringify(customTableConfigs));

      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        conf.initialSort = true;
        conf.Aggregations = JSON.parse(conf.Aggregations);
        if (conf.Aggregations['AffectedMember.fullName']) {
          delete conf.Aggregations['AffectedMember.fullName'];
          conf.Aggregations['AffectedMember.id'] = true;
        }
        self.tableViewsApproval[conf.id] = conf;
      });
    };
    self.handleCustomLists($scope.tableConfig.tableConfigCustomPreference);
    applyAggregations(true);

    self.possibleStates = Object.entries(self.state).map(function (entry) {
      // we create an Object with the shape { id: status, label: statusLabel }
      // example: { id: ''PENDING', label: 'ausstehend' }
      var key = entry[0];
      var value = entry[1];
      return {
        id: key,
        label: value,
      };
    });

    self.chosenGroups = [];
    self.filterStates = [];

    self.watchFilter = function () {
      var approvals = [];
      if (self.filterStates.length) {
        var uniqueFilterReleaseStates = self.filterStates.map( function (filterState) {
          // get our id 'PENDING' || 'RESUB_APPROACHING' ...
          return Object.values(filterState)[0];
        });
        approvals = $scope.approvalProcesses.filter(function (process) {
          return uniqueFilterReleaseStates.includes(process.State);
        });
      } else {
        approvals = $scope.approvalProcesses;
      }
      
      if (self.demandForActionBtnActive) {
        approvals = approvals.filter(function (process) {
          return process.State === 'PENDING'
          || process.State === 'PROCESSING'
          || process.State === 'RESUB_APPROACHING'
          || process.State === 'RESUB_OVERDUE';
        });
      }

      var groups = self.chosenGroups.map(function (d) { return d.Name; });
      approvals = approvals.filter(function (process) {
        return _.findIndex(process.AffectedMember.MemberGroups, function (memberGroup) {
          return !!~groups.indexOf(memberGroup.Name);
        }) > -1 || self.chosenGroups.length === 0;
      });

      if (self.groupSearch && self.groupSearch.length) {
        approvals = approvals.filter(function (process) {
          if ($translate.instant('modules.personnel.approvals.noGroupAssinged').indexOf(self.groupSearch) > -1) {
            return process.Approval.ClearanceGroup === null ||
              (process.Approval.ClearanceGroup && process.Approval.ClearanceGroup.Name.toLowerCase().indexOf(self.groupSearch.toLowerCase()) > -1);
          }
          return process.Approval.ClearanceGroup && process.Approval.ClearanceGroup.Name.toLowerCase().indexOf(self.groupSearch.toLowerCase()) > -1;
        });
      }      

      self.approvalProcesses = approvals;
    };

    $scope.$watch(function () {
      return JSON.stringify(self.filterStates) + JSON.stringify(self.chosenGroups) + JSON.stringify(self.groupSearch);
    }, function () {
      self.watchFilter();
    });

    $scope.$watch(function () {
      return self.chosen;
    }, function () {
      self.chosenIds = Object.keys(self.chosen).filter(function (key) {
        return self.chosen[key];
      });
      self.chosenCount = self.chosenIds.length;
    }, true);

    $scope.$watch(function () {
      return self.demandForActionBtnActive;
    }, function () {
      self.watchFilter();
    });

    // unnamed legacy code
    function applySomeLegacyCode(approvals) {
      if ((
        self.preSelectedId
        && self.preSelectedVersion
        && !self.detailsShown
        && (approvals || []).length)
        || (self.previewAttempts >= 5 && self.preSelectedId))
      {
        self.detailsShown = true;
        self.previewAttempts = -1;
        var found = false;
        approvals.forEach(function (process) {
          if (process.id === self.preSelectedId) {
            found = process.updatedAt;
            self.approvalprocessModal('edit', process);
          }
        });

        if (!found) {
          toastr.warning(
            $translate.instant('modules.personnel.approvals.approvalNotFoundToastText'),
            $translate.instant('modules.personnel.approvals.approvalNotFoundToastTitle')
          );
        } else {
          if (self.preSelectedVersion !== moment(found).toISOString()) {
            toastr.info(
              $translate.instant('modules.personnel.approvals.approvalChangedToastText'),
              $translate.instant('modules.personnel.approvals.approvalChangedToastTitle')
            );
          }
        }
      } else if (self.previewAttempts > -1) {
        self.previewAttempts++;
      }
    }

    self.approvalProcesses = $scope.approvalProcesses;

    self.isPermitted = function (permission, approvalProcess) {
      var permittedReferences = self.allowedReferences
                                && self.allowedReferences[permission]
                                && self.allowedReferences[permission][
                                  (approvalProcess && approvalProcess.Division && approvalProcess.Division.id || '').toString()
                                  ];
      return approvalProcess
             && approvalProcess.Approval
             && approvalProcess.Approval.id
             && !!~(permittedReferences || []).indexOf(approvalProcess.Approval.id);
    };

    self.approvalprocessModal = function (action, approvalprocess, openBulk, approvalProccessMode) {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/approvalProcessList/approvalprocessModal/' + action + 'Approvalprocess.html',
        size: 'md',
        controller: 'ApprovalprocessModalCtrl as $ctrl',
        resolve: {
          divisionId: function () {
            return parseInt(self.divisionId[0]);
          },
          organizationId: function () {
            return self.organizationId;
          },
          approvals: function () {
            return ArnoDashAdminClearancesService.getClearancesForProcessList();
          },
          fixedMembers: function () {
            return false;
          },
          disabledApprovals: function () {
            return [];
          },
          divisionMembers: function () {
            return clientApi.custom('model/Member', 'findByDivisionId', {
              divisionId: parseInt(self.divisionId[0]),
              queryWishes: { activeDivisionMember: true, nonOffline: true, }
            });
          },
          approvalprocess: function () {
            if (openBulk) {
              calcSelected();
              return self.chosenApprovals;
            }
            return approvalprocess || { Approval: {}, };
          },
          action: function () {
            return action || null;
          },
          isPermitted: function () {
            return self.isPermitted;
          },
          approvalProccessMode: function () {
            return approvalProccessMode;
          },
          approvalAcceptors: function () {
            return clientApi.custom('model/Approval', 'getInitiatingOrEditingMembers', { divisionId: self.divisionId[0], editing: true })
              .catch(function () {
                return [];
              });
          },
          permittedDivs: function () {
            var apc = {};
            if (openBulk) {
              calcSelected();
              apc = self.chosenApprovals;
            } else {
              apc = approvalprocess || { Approval: {}, };
            }
            var permittedDivs = [];
            if (approvalprocess) {
              if (approvalprocess.Approval.Type === 'SIMPLE') {
                var simpleEditPerms = $rootScope.ctx.permissionsTree.permissions['arno.personnel.clearance.edit.simple'] &&
                  $rootScope.ctx.permissionsTree.permissions['arno.personnel.clearance.edit.simple'].Division;
                if (simpleEditPerms) {
                  commonUtils.division.divisionTreeData.forEach(function (div) {
                    if (!!~simpleEditPerms.indexOf(parseInt(div.id, 10)) && div.Active) {
                      permittedDivs.push({
                        Name: div.Name,
                        id: div.id,
                      });
                    }
                  });
                }
                return clientApi.custom('model/Approval', 'checkAffectedMemberInDiv', {
                  ownDivId: self.divisionId,
                  approvalId: Array.isArray(apc) ? apc.map(function (ap) {
                    return ap.Approval.id;
                  }) : apc.Approval.id,
                  divIds: permittedDivs.map(function (div) {
                    return div.id;
                  }),
                  affectedMemberId: approvalprocess.AffectedMemberId,
                })
                .then(function (res) {
                  return permittedDivs.filter(function (pdiv) {
                    return !!~res.indexOf(parseInt(pdiv.id, 10)) && pdiv.id != (approvalprocess.Division && approvalprocess.Division.id);
                  });
                });
              } else {
                // fetch item perms for that approval
                return clientApi.custom('model/Approval', 'getApprovalStartDivisionReferences', {
                  itemReferenceId: approvalprocess.ApprovalId,
                  affectedMemberId: approvalprocess.AffectedMemberId,
                })
                .then(function (res) {
                  return res.map(function (row) {
                    return row.Division;
                  }).filter(function (div) {
                    return div.id != approvalprocess.Division.id;
                  });
                });
              }
            }
            return [];
          },
        },
      })
        .result
        .then(function () {
          self.reloadProcesses();
        });
    };

  
    self.changePageSize = function (num) {
      self.pageSize = commonUtils.getPageSize('approval_proc_list_page_size', num);
    };
    self.changePageSize();

    self.getColspan = function () {
      var colSpan = Object.keys(self.currentTableConf.tableConfig).length +1;
      return colSpan;
    };

    self.reloadProcesses = function () {
      var opts = {
        divisionIds: ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' })
      };
      if ($scope.affectedMemberId) {
        opts.affectedMemberIds = [$scope.affectedMemberId];
        opts.divisionSpanning = true;
      }
      clientApi.custom('model/ApprovalAllocation', 'getApprovalsForDivision', opts)
        .then(function (res) {
          $scope.approvalProcesses = res;
          self.watchFilter();
          applySomeLegacyCode($scope.approvalProcesses);
        });
    };

    self.removeApprovalprocess = function (approvalProcess, useBulkData) {
      var approvalData = [];
      if (useBulkData) {
        approvalData = getBulkData();
      } else {
        approvalData.push({
          id: approvalProcess.id,
          ApprovalId: approvalProcess.ApprovalId,
          DivisionId: approvalProcess.DivisionId,
        });
      }
      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: true,

        title: approvalData.length > 1
          ? approvalData.length + ( ' ' + $translate.instant('modules.personnel.approvals.removeApprovalsModalTitle'))
          : $translate.instant('modules.personnel.approvals.removeApprovalModalTitle'),
        content: approvalData.length > 1
          ? $translate.instant('modules.personnel.approvals.removeApprovalsModalText')
          : $translate.instant('modules.personnel.approvals.removeApprovalModalText') +
          '<br/>' + $translate.instant('modules.personnel.approvals.canNotBeUndoneText'),

        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel'),
      })
      .then(function () {
        return clientApi
          .custom('model/ApprovalAllocation', 'removeApprovalAllocation', {
            data: approvalData,
          });
      })
      .then(function () {
        useBulkData
          ? toastr.success(
              $translate.instant('modules.personnel.approvals.approvalsDeletedToastText'),
              $translate.instant('modules.personnel.approvals.approvalsDeletedToastTitle')
            )
          : toastr.success(
              $translate.instant('modules.personnel.approvals.approvalDeletedToastText'),
              $translate.instant('modules.personnel.approvals.approvalDeletedToastTitle')
            );
        self.reloadProcesses();
      })
      .catch(function (err) {
        if (err && err.action !== 'BA_MODAL_SECONDARY_BTN_CLICKED') {
          useBulkData
            ? toastr.error(
              $translate.instant('modules.personnel.approvals.approvalsDeletedToastText'),
              $translate.instant('modules.personnel.approvals.approvalsDeletedToastTitle')
            )
            : toastr.error(
              $translate.instant('modules.personnel.approvals.approvalDeletedToastText'),
              $translate.instant('modules.personnel.approvals.approvalDeletedToastTitle')
            );
        }
      });
    };

    self.export = function () {
      $uibModal
      .open({
        animation: true,
        templateUrl: 'app/theme/components/approvalProcessList/approvalExportModal/approvalExport.html',
        size: 'md',
        controller: 'approvalExportCtrl as $approvalExportCtrl',
        resolve: {
          exportPrivacyNote: function (clientApi) {
            return clientApi.custom('model/ExportPrivacyNote', 'getLatest', {});
          },
          multipleSelected: function () {
            calcSelected();
            return !!self.chosenCount;
          }
        }
      })
      .result
      .then(function (res) {
        var requestedFields = [];
        var idsToExport = [];
        var filterOpts = {};
        if (res.options.fields === 'all') {
          requestedFields = self.tableConfig.tableConfigAvailableFields.map(function (field) {
            return field.prop;
          });
        } else {
          var currFields = (self.getCurrentTableView()).Fields;
          requestedFields = Object.keys(currFields).filter(function (fKey) {
            return currFields[fKey];
          });
        }

        if (res.options.filter === 'selected') {
          calcSelected();
          idsToExport = self.chosenApprovals.map(function (ap) { return ap.id; });
        } else if (res.options.filter === 'filtered') {
          filterOpts = self.search ? self.search : {};
          filterOpts.affectedMemberGroupIds = self.chosenGroups.map(function (group) { return group.id; });
          filterOpts.states = self.filterStates.map(function (state) {
            return Object.keys(self.state).find(function (key) {
              return key === state.id;
            });
          });
        }

        if (self.demandForActionBtnActive && !self.filterStates.length) {
          filterOpts.states.push('PENDING','PROCESSING' ,'RESUB_APPROACHING' ,'RESUB_OVERDUE');
        }

        clientApi.openTab('personnel/export/approval', {
          divisionId: ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }),
          requestedFields: requestedFields,
          idsToExport: idsToExport,
          groupByOption: !!res.options.groupByOption,
          filter: JSON.stringify(filterOpts),
          FileName: $translate.instant('generalTerms.approvals'),
          language: $translate.use()
        }, {
          post: true,
        });
        toastr.success(
          $translate.instant('modules.personnel.approvals.exportStartedToastText'),
          $translate.instant('modules.personnel.approvals.exportStartedToastTitle')
        );
      })
      .catch(function () {});
    };

    // VIEW FUNCTIONS
    self.hasStartSimpleClearancePerm = function () {
      return permissions.isPermittedInEvery(
        'arno.personnel.clearance.start.simple',
        'Division',
        (ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }))
      );
    };

    self.hasEditSimpleClearancePerm = function () {
      return permissions.isPermittedInEvery(
        'arno.personnel.clearance.edit.simple',
        'Division',
        (ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }))
      );
    };

    self.hasViewClearancePerm = function () {
      return permissions.isPermittedInEvery(
        'arno.personnel.clearance.view',
        'Division',
        (ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }))
      );
    };

    self.hasViewSimpleClearancePerm = function () {
      return permissions.isPermittedInEvery(
        'arno.personnel.clearance.view.simple',
        'Division',
        (ctx || commonUtils.division.getCtx({ multiple: true, entryPermission: 'arno.personnel.clearance.view' }))
      );
    };

    self.showEditBtn = function (approvalprocess) {
      try {
        return  (self.isPermitted('arno.item.approval.edit', approvalprocess)
          || (approvalprocess.Approval && approvalprocess.Approval.Type === 'SIMPLE' && self.hasEditSimpleClearancePerm()))
          && approvalprocess.Division;
      }
      catch (ex) { return false; }
    };

    self.showDeleteBtn = function (approvalprocess) {
      // if user has perm to edit, then also to delete, if another behavior is needed then replace this function by perm-checks!
      return self.showEditBtn(approvalprocess);
    };

    self.showDetailsBtn = function (approvalprocess) {
      return !self.showEditBtn(approvalprocess);
    };

    self.setPaused = function (process, state, useBulkData) {
      var approvalData = [];
      if (useBulkData) {
        approvalData = getBulkData();
      } else {
        approvalData.push({
          id: process.id,
          ApprovalId: process.ApprovalId,
          DivisionId: process.DivisionId,
        });
      }
      var toastrContent = state
        ? $translate.instant('modules.personnel.approvals.statePaused')
        : $translate.instant('modules.personnel.approvals.stateContinued');
      return clientApi.custom('model/ApprovalAllocation', 'setPauseState', { data: approvalData, state: state })
        .then(function () {
          useBulkData ? toastr.success($translate.instant('modules.personnel.approvals.setApprovalsPausedToastText', { state: toastrContent }),
            $translate.instant('modules.personnel.approvals.setApprovalsPausedToastTitle', { state: toastrContent }))
          : toastr.success($translate.instant('modules.personnel.approvals.setApprovalPausedToastText', { state: toastrContent }),
            $translate.instant('modules.personnel.approvals.setApprovalPausedToastTitle', { state: toastrContent }));
          self.reloadProcesses();
        })
        .catch(function () {
          useBulkData ? toastr.success($translate.instant('modules.personnel.approvals.setApprovalsPausedErrText', { state: toastrContent }),
            $translate.instant('modules.personnel.approvals.setApprovalsPausedErrTitle', { state: toastrContent }))
          : toastr.success($translate.instant('modules.personnel.approvals.setApprovalPausedErrText', { state: toastrContent }),
            $translate.instant('modules.personnel.approvals.setApprovalPausedErrTitle', { state: toastrContent }));
        });
    };

    self.setSelection = function (select) {
      self.chosen = {};
      $scope.stFilteredCollection.forEach(function (ap) {
        if (self.showEditBtn(ap)) {
          self.chosen[ap.id] = select;
        }
      });
    };

    self.select = function (approvalprocess, isGrouped) {
      var aggs = Object.keys(self.aggregations).filter(function (agg) {
        return self.aggregations[agg];
      });
      if (aggs && aggs.length && isGrouped) {
        var groupedRows = _.filter(self.displayCollection, function (row) {
          for (var i = 0; i < aggs.length; i++) {
            var key = aggs[i];
            var prop = _.get(row, key);
            var origProp = _.get(approvalprocess, key);
            if (prop !== origProp) {
              return false;
            }
          }
          return true;
        });
        groupedRows.forEach(function (row) {
          self.chosen[row.id] = !self.chosen[row.id];
        });
      } else {
        self.chosen[approvalprocess.id] = !self.chosen[approvalprocess.id];
      }
    };

    self.checkBoxAggCond = function (approvalprocess) {
      return ((self.aggregations['AffectedMember.id'] || self.aggregations['Approval.ClearanceGroup.id']) && approvalprocess.byGroupNewItem) ||
          (!self.aggregations['AffectedMember.id'] && !self.aggregations['Approval.ClearanceGroup.id']);
    };

    self.getPaginationSpan = function () {
      return Object.keys(self.currentTableConf.tableConfig).filter(function (key) { return self.currentTableConf.tableConfig[key]; }).length + 2;
    };

    self.openTableConfig = function (currentConf) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return false;
            },
            isMaterialList: function () {
              return true;
            },
            aggExclusion: function () {
              return self.tableConfig.tableConfigAvailableFields.filter(function (field) {
                return field.prop !== 'Approval.ClearanceGroup' && field.prop !== 'AffectedMember.fullName';
              }).map(function (field) {
                return field.prop;
              });
            },
            sortableFields: function () {
              return self.tableConfig.tableConfigAvailableFields.filter(function (field) {
                return field.prop !== 'Approval.ClearanceGroup' && field.prop !== 'AffectedMember.Group';
              }).map(function (field) {
                return {
                  fieldName: field.prop,
                  sortProp: field.prop
                };
              });
            },
            availableFields: function () {
              var cleanFieldsPerView = function (fieldArr) {
                fieldArr.forEach(function (prop) {
                  var obj = _.find(fields, {
                    'prop': prop
                  });
                  if (obj) {
                    fields.splice(fields.indexOf(obj), 1);
                  }
                });
              };
              var fields = JSON.parse(JSON.stringify(self.tableConfig.tableConfigAvailableFields));
              cleanFieldsPerView([
                'ApprovalAllocation.id',
                'ApprovalAllocation.DivisionId',
                'ApprovalAllocation.InitiatingMemberId',
                'ApprovalAllocation.AffectedMemberId',
                'ApprovalAllocation.ApprovalId',
                'ApprovalAllocation.updatedAt',
                'ApprovalAllocation.createdAt',
              ]);
              return fields;
            },
            currentList: function () {
              return {
                'current': currentConf.tableConfig
              };
            },
            availableLists: function () {
              var views = JSON.parse(JSON.stringify(currentConf.customViews));
              Object.keys(views).forEach(function (key) {
                var cv = views[key];
                if (cv.Aggregations && cv.Aggregations['AffectedMember.id']) {
                  delete cv.Aggregations['AffectedMember.id'];
                  cv.Aggregations['AffectedMember.fullName'] = true;
                }
              });
              return views;
            }
          },
        })
        .result
        .then(function (res) {
          if (!res) {
            return;
          }
          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;
          if (res.modifiedCurrentList) {
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;
            currentConf.tmp = { Fields: res.modifiedCurrentList };
          }
          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  self.changeListView(currentConf, '0', '0');
                }
                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id,
                    divisionId: self.divisionId
                  })
                  .then(function () {
                    toastr.success(
                      $translate.instant(
                        'modules.personnel.approvals.listDeletedText',
                        { list: list.ListName }),
                        $translate.instant('modules.personnel.approvals.listDeletedTitle')
                      );
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }
          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (!currentConf.hasViewModifications && (val.id && val.id === JSON.parse(currentConf.selectedView))) {
                currentConf.tableConfig = _.merge(currentConf.tableConfig, val.Fields);
              }
              customLists.push({
                id: val.id || false,
                ListType: 'approvalProcessList',
                ListName: val.Name,
                Fields: val.Fields,
                Sort: val.Sort,
                Aggregations: val.Aggregations,
              });
              newListAdded = !val.id ? true : newListAdded;
            });
            if (customLists.length > 0) {
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: self.divisionId
                })
                .then(function () {
                  customLists.forEach(function (list) {
                    if (list.id) {
                      toastr.success(
                        $translate.instant(
                          'modules.personnel.approvals.listSavedText',
                          { list: list.ListName }),
                          $translate.instant('modules.personnel.approvals.listSavedTitle')
                        );
                    }
                  });
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'approvalProcessList',
                      divisionId: self.divisionId
                    })
                    .then(function (lists) {
                      self.handleCustomLists(lists);
                      if (newListAdded) {
                        var maxId = Math.max.apply(Math, Object.values(_.mapValues(lists, function (l) { return l.id; })));
                        var newList = Object.values(_.pickBy(lists, function (list) {
                          return list.id == maxId;
                        }))[0];
                        self.changeListView(currentConf, newList, maxId);
                      }
                    });
                });
            }
          }
        })
        .catch(function (err) {
          if (err && !err === 'escape key press') {
            toastr.success($translate.instant('modules.personnel.approvals.listErrText'), $translate.instant('modules.personnel.approvals.listErrTitle'));
          }
        });
    };

    self.showBaseDataField = function (byGroupNewItem, field) {
      return (
        (
          (
            (self.aggregations['AffectedMember.id'] && byGroupNewItem)
            || !self.aggregations['AffectedMember.id']
          )
          && self.currentTableConf.tableConfig[field]
        )
        && self.showMemberName);
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('approvalProcessList', approvalProcessList);

  /** @ngInject */
  function approvalProcessList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/approvalProcessList/approvalProcessList.html',
      controller: 'approvalProcessListCtrl as $ctrl',
      scope: {
        approvalProcesses: '=',
        affectedMemberId: '=',
        tableConfig: '=',
        memberGroups: '=',
        allowedReferences: '=?',
        disallowEdit: '=',
        showMemberName: '=',
        allowExport: '=',
        ctx: '=',
        preSelectedId: '=?',
        preSelectedVersion: '=?',
        onlyDemandForAction: '=',
      },
    };
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  function approvalListCtrl($scope, screenSize, $uibModal, permissions, $timeout) {
    var self = this;

    self.mediaSizeXs = screenSize.on('xs', function (match) {
      self.mediaSizeXs = match;
    });

    self.displayMemberApprovalMode = $scope.approvalListMemberData;

    self.approvalList = angular.copy($scope.approvalList || []);
    self.approvalList.forEach(function (approvalItem) {

      // set common values to accept different datasources
      if (!approvalItem.ApprovalId) {
        approvalItem.ApprovalId = approvalItem.id || approvalItem.Id || approvalItem.IncludedApprovalId;
      }
      if (!approvalItem.ApprovalName && approvalItem.Name) {
        approvalItem.ApprovalName = approvalItem.Name;
      }
      if (!approvalItem.ApprovalName && approvalItem.Title) {
        approvalItem.ApprovalName = approvalItem.Title;
      }
      if (!approvalItem.GroupName && approvalItem.ApprovalGroup) {
        approvalItem.GroupName = approvalItem.ApprovalGroup.Name;
      }
    });

    var approvalListLength = self.approvalList.length;
    while (approvalListLength--) {
      var approvalItem = self.approvalList[approvalListLength];

      if (self.displayMemberApprovalMode && !approvalItem.AcquireDate) {
        // show member approval mode
        // no acquire date set, could be a duplicate of an approval with an acquire date,
        // check and may remove this approval from list

        var accquiredApproval = _.find(self.approvalList,
          function (approval) {
            return approval.ApprovalId == approvalItem.ApprovalId && !!approval.AcquireDate;
          });
        if (accquiredApproval) {
          accquiredApproval.isAlsoInherited = true;
          self.approvalList.splice(approvalListLength, 1);
        } else {
          approvalItem.onlyInherited = true;
        }
      }
    }

    self.approvalHierarchy = angular.copy($scope.approvalAdd);
    self.onlyView = false || $scope.approvalOnlyView;
    if (self.approvalHierarchy && self.approvalHierarchy.length) {
      // flatten the hierarchy (removing the groups) and write the group name on every single approval
      self.flatApprovalHierarchy = [].concat.apply([],
        _.sortBy(self.approvalHierarchy, 'Name').map(function (approvalHierarchyItem) {
          return _.sortBy(approvalHierarchyItem.Approvals, 'Title').map(function (approvalItem) {
            approvalItem.GroupName = approvalHierarchyItem.Name;
            approvalItem.ApprovalName = approvalItem.Title;
            approvalItem.ApprovalId = approvalItem.id;
            return approvalItem;
          });
        })
      );

      var approvalIdsToExclude = [];
      if (self.approvalList && self.approvalList.length) {
        // dont exclude inherited _only_ approvals as those can still be added
        approvalIdsToExclude = self.approvalList
          .filter(function (approval) {
            return !approval.onlyInherited;
          })
          .map(function (approvalListItem) {
            return (approvalListItem.id || approvalListItem.ApprovalId);
          })
      }
      if ($scope.approvalExclude && $scope.approvalExclude.length) {
        approvalIdsToExclude = approvalIdsToExclude.concat($scope.approvalExclude);
      }

      _.remove(self.flatApprovalHierarchy, function (flatApproval) {
        return !!~approvalIdsToExclude.indexOf(flatApproval.ApprovalId);
      });
    }

    self.displayKeepOrDeleteApprovalBtn = function (approval) {
      return $scope.approvalDelete
             && (!approval.pendingAction || !!~['edit', 'delete'].indexOf(approval.pendingAction))
             && (!self.displayMemberApprovalMode || !approval.onlyInherited);
    };

    self.onApprovalDelete = function (approval) {
      if (approval.pendingAction === 'edit') {
        approval.AcquireDate = approval.OriginalAcquireDate;
        approval.ExpireDate = approval.OriginalExpireDate;
        delete approval.OriginalAcquireDate;
        delete approval.OriginalExpireDate;
        approval.pendingAction = '';
      } else {
        approval.pendingAction = approval.pendingAction ? null : 'delete';
      }
      self.updateChangeModel();
    };

    self.onApprovalPendingDelete = function (approval) {
      delete approval.pendingAction;
      delete approval.AcquireDate;
      delete approval.ExpireDate;
      self.flatApprovalHierarchy.push(approval);
      if (!approval.onlyInherited) {
        self.approvalList.splice(self.approvalList.indexOf(approval), 1);
      }
      self.updateChangeModel();
    };

    self.approvalAdd = function (acquiredAdditionalData) {
      if (self.approvalToAdd) {
        self.stopApprovalWatch = true;
        $timeout(function () {
          delete self.stopApprovalWatch;
        }, 0, false);
        var isAlreadyInherited = self.displayMemberApprovalMode
                                 && _.find(self.approvalList, { onlyInherited: true, ApprovalId: self.approvalToAdd.ApprovalId });
        if (self.displayMemberApprovalMode && !acquiredAdditionalData) {
          return self.openMemberApprovalModal(isAlreadyInherited || self.approvalToAdd, true);
        }
        if (isAlreadyInherited) {
          isAlreadyInherited.pendingAction = 'add';
          _.extend(isAlreadyInherited, self.approvalToAdd);
        } else {
          self.approvalToAdd.pendingAction = 'add';
          self.approvalList.push(self.approvalToAdd);
        }
        self.flatApprovalHierarchy.splice(self.flatApprovalHierarchy.indexOf(self.approvalToAdd), 1);
        self.approvalToAdd = undefined;
        self.updateChangeModel();
      }
    };

    self.editApproval = function (approval) {
      if (approval.onlyInherited && !approval.pendingAction) {
        self.approvalToAdd = _.find(self.flatApprovalHierarchy, { ApprovalId: approval.ApprovalId });
        self.approvalAdd();
      } else {
        self.openMemberApprovalModal(approval);
      }
    };

    self.openMemberApprovalModal = function (approval, addMode) {
      var onCancleApproval = angular.copy(approval);
      if (!approval.OriginalAcquireDate && approval.AcquireDate) {
        approval.OriginalAcquireDate = approval.AcquireDate;
      }
      if (!approval.OriginalExpireDate && approval.ExpireDate) {
        approval.OriginalExpireDate = approval.ExpireDate;
      }
      $uibModal.open(
        {
          controller: 'MemberApprovalModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/theme/components/approvalList/memberApprovalModal/memberApproval.html',
          size: 'md',
          resolve: {
            approval: function () {
              return approval;
            }
          }
        }).result
        .then(function () {
          if (addMode) {
            self.approvalAdd(true);
          } else {
            if (!approval.pendingAction) {
              approval.pendingAction = 'edit';
            }
            self.updateChangeModel();
          }
        })
        .catch(function () {
          _.merge(approval, onCancleApproval);
        })
    };

    self.updateChangeModel = function () {
      $scope.approvalChangeModel.add = [];
      if (self.displayMemberApprovalMode) {
        $scope.approvalChangeModel.edit = [];
      }
      $scope.approvalChangeModel.delete = [];
      if (self.approvalList && self.approvalList.length) {
        self.approvalList.forEach(function (searchPendingApprovals) {
          if (searchPendingApprovals.pendingAction) {
            $scope.approvalChangeModel[searchPendingApprovals.pendingAction].push(searchPendingApprovals[$scope.approvalChangeProperty] || searchPendingApprovals);
          }
        })
      }
    };

    self.isModalOpen = function () {
      return $('.modal-open').length;
    };

    self.getShowElement = function (element) {
      var permissionByMode = self.displayMemberApprovalMode ?
                             'arno.personnel.dossier.manageClearances' : ['arno.administration.personnel.approval.manage', 'arno.administration.personnel.activities.manage'];
      switch (element) {
      case 'addApproval':
      case 'actions':
        if (Array.isArray(permissionByMode)) {
          var checks = [];
          permissionByMode.forEach(function(perm) {
            checks.push(permissions.isPermittedAnywhere(perm));
          })
          return _.compact(checks).length;
        }
        return permissions.isPermittedAnywhere(permissionByMode);
      }
    };
  }

  angular.module('BlurAdmin.theme.components')
    .controller('approvalListCtrl', approvalListCtrl);
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('approvalList', approvalList);

  /** @ngInject */
  function approvalList() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/approvalList/approvalList.html',
      scope: {
        approvalListMemberData : '=?',
        approvalList : '=',
        approvalAdd : '=?',
        approvalDelete : '=?',
        approvalExclude : '=?',
        approvalChangeModel : '=?',
        approvalChangeProperty : '@',
        approvalOnlyView: '=?'
      },
      compile: function(element, attrs) {
        if (!attrs.approvalDelete) {
          attrs.approvalDelete = 'false';
        }
        return {
          pre: function() {},
          post: function() {}
        }
      },
      controller: 'approvalListCtrl as $approvalListCtrl'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('allocReqFulfillment', allocReqFulfillment);

  /** @ngInject */
  function allocReqFulfillment() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/allocReqFulfillment/allocReqFulfillment.html',
      scope: {
        divisionId: '=',
        memberId: '=',
        activityId: '=',
        characteristic: '='
      },
      controller: 'allocReqFulfillmentCtrl as $arf'
    };
  }

})();
(function () {
  'use strict';

  /** @ngInject */
  function allocReqFulfillmentCtrl($rootScope, $scope, clientApi, characteristicMap) {
    var self = this;
    self.fulfillment = {};
    self.characteristicMap = characteristicMap;

    self.fetchFulfillment = function () {
      clientApi
        .custom('model/ActivityAllocation', 'checkActivityAllocationRequirementFulfillment', {
          divisionId: $scope.divisionId,
          cMemberId: $scope.memberId,
          activityId: $scope.activityId,
          characteristic: $scope.characteristic
        })
        .then(function (result) {
          $scope.$evalAsync(function () {
            self.fulfillment = result;
          });
        });
    };

    $scope.$watch(function () {
      return $scope.divisionId + '_' + $scope.memberId + '_' + $scope.activityId + '_' + JSON.stringify($scope.characteristic)
    }, function () {
      self.fetchFulfillment();
    });

    self.isIn = function (id, isIn) {
      return !!~(isIn || []).indexOf(id);
    };

    self.hasAdditionalCharacteristics = function (characteristics) {
      return (
               Object.keys(characteristics || {})
                 .map(function (charKey) {
                   return characteristics[charKey].active;
                 })
                 .filter(function (bool) {
                   return bool;
                 })
             ).length - 1;
    };

    self.hasFulfilledState = function (requirementSet) {
      return Object.hasOwnProperty.call(requirementSet, 'fulfilled');
    }
  }

  angular.module('BlurAdmin.theme.components')
    .controller('allocReqFulfillmentCtrl', allocReqFulfillmentCtrl);
})();

// https://github.com/bentorfs/angular-bootstrap-multiselect
// http://bentorfs.github.io/angular-bootstrap-multiselect/
(function () {
  'use strict';

  angular
    .module('BlurAdmin.theme.components')
    .directive('abMultiselect', abMultiselect);

  /** @ngInject */
  function abMultiselect($translate, $document, $log) {
    return {
      restrict: 'AE',
      scope: {
        options: '=',
        displayProp: '@',
        idProp: '@',
        searchLimit: '=?',
        selectionLimit: '=?',
        showSelectAll: '=?',
        showUnselectAll: '=?',
        showSearch: '=?',
        searchFilter: '=?',
        disabled: '=?ngDisabled',
        labels: '=?',
        classesBtn: '=?',
        showTooltip: '=?',
        placeholder: '@?'
      },
      require: 'ngModel',
      templateUrl: 'app/theme/components/abMultiselect/abMultiselect.html',
      controller: function ($scope) {
        if (angular.isUndefined($scope.classesBtn)) {
          $scope.classesBtn = ['btn-block', 'btn-default'];
        }
      },
      link: function ($scope, $element, $attrs, $ngModelCtrl) {
        $scope.selectionLimit = $scope.selectionLimit || 0;
        $scope.searchLimit = $scope.searchLimit || 25;
        $scope.searchFilter = '';

        $scope.getRecursiveProperty = function (object, path) {
          return path.split('.').reduce(function (object, x) {
            if (object) {
              return object[x];
            } else {
              return null;
            }
          }, object)
        };

        $scope.resolvedOptions = [];
        if (typeof $scope.options !== 'function') {
          $scope.resolvedOptions = $scope.options;
        }

        if (typeof $attrs.disabled != 'undefined') {
          $scope.disabled = true;
        }

        var closeHandler = function (event) {
          if (!$element[0].contains(event.target)) {
            $scope.$apply(function () {
              $scope.open = false;
            });
          }
        };

        $document.on('click', closeHandler);

        var updateSelectionLists = function () {
          if (!$ngModelCtrl.$viewValue) {
            if ($scope.selectedOptions) {
              $scope.selectedOptions = [];
            }
            $scope.unselectedOptions = $scope.resolvedOptions.slice(); // Take a copy
          } else {
            $scope.selectedOptions = $scope.resolvedOptions.filter(function (el) {
              var id = $scope.getId(el);
              for (var i = 0; i < $ngModelCtrl.$viewValue.length; i++) {
                var selectedId = $scope.getId($ngModelCtrl.$viewValue[i]);
                if (id === selectedId) {
                  return true;
                }
              }
              return false;
            });
            $scope.unselectedOptions = $scope.resolvedOptions.filter(function (el) {
              return $scope.selectedOptions.indexOf(el) < 0;
            });
          }
        };

        $scope.toggleDropdown = function () {
          $scope.resolvedOptions = $scope.options;
          updateSelectionLists();
        };

        $ngModelCtrl.$render = function () {
          updateSelectionLists();
        };

        $ngModelCtrl.$viewChangeListeners.push(function () {
          updateSelectionLists();
        });

        $ngModelCtrl.$isEmpty = function (value) {
          if (value) {
            return (value.length === 0);
          } else {
            return true;
          }
        };

        var watcher = $scope.$watch('selectedOptions', function () {
          $ngModelCtrl.$setViewValue(angular.copy($scope.selectedOptions));
        }, true);

        $scope.$on('$destroy', function () {
          $document.off('click', closeHandler);
          if (watcher) {
            watcher(); // Clean watcher
          }
        });

        $scope.getButtonText = function () {
          if ($scope.selectedOptions && $scope.selectedOptions.length === 1) {
            return $scope.getDisplay($scope.selectedOptions[0]);
          }
          if ($scope.selectedOptions && $scope.selectedOptions.length > 1) {
            var totalSelected = angular.isDefined($scope.selectedOptions) ? $scope.selectedOptions.length : 0;
            if (totalSelected === 0) {
              return $scope.labels && $scope.labels.select ?
              $scope.labels.select : 
              ($scope.placeholder || $translate.instant('components.abMultiselect.Select'));
            } else {
              return totalSelected + ' ' + ($scope.labels && $scope.labels.itemsSelected ? 
                $scope.labels.itemsSelected : 
                $translate.instant('components.abMultiselect.selected'));
            }
          } else {
            return $scope.labels && $scope.labels.select ? 
            $scope.labels.select : 
            ($scope.placeholder || $translate.instant('components.abMultiselect.Select'));
          }
        };

        $scope.selectAll = function () {
          $scope.selectedOptions = $scope.resolvedOptions.slice(); // Take a copy;
          $scope.unselectedOptions = [];
        };

        $scope.unselectAll = function () {
          $scope.selectedOptions = [];
          $scope.unselectedOptions = $scope.resolvedOptions.slice(); // Take a copy;
        };

        $scope.toggleItem = function (item) {
          if (typeof $scope.selectedOptions === 'undefined') {
            $scope.selectedOptions = [];
          }
          var selectedIndex = $scope.selectedOptions.indexOf(item);
          var currentlySelected = (selectedIndex !== -1);
          if (currentlySelected) {
            $scope.unselectedOptions.push($scope.selectedOptions[selectedIndex]);
            $scope.selectedOptions.splice(selectedIndex, 1);
          } else if (!currentlySelected && ($scope.selectionLimit === 0 || $scope.selectedOptions.length < $scope.selectionLimit)) {
            var unselectedIndex = $scope.unselectedOptions.indexOf(item);
            $scope.unselectedOptions.splice(unselectedIndex, 1);
            $scope.selectedOptions.push(item);
          }
        };

        $scope.getId = function (item) {
          if (angular.isString(item)) {
            return item;
          } else if (angular.isObject(item)) {
            if ($scope.idProp) {
              return $scope.getRecursiveProperty(item, $scope.idProp);
            } else {
              $log.error('Multiselect: when using objects as model, a idProp value is mandatory.');
              return '';
            }
          } else {
            return item;
          }
        };

        $scope.getDisplay = function (item) {
          if (angular.isString(item)) {
            return item;
          } else if (angular.isObject(item)) {
            if ($scope.displayProp) {
              return $scope.getRecursiveProperty(item, $scope.displayProp);
            } else {
              $log.error('Multiselect: when using objects as model, a displayProp value is mandatory.');
              return '';
            }
          } else {
            return item;
          }
        };

        $scope.isSelected = function (item) {
          if (!$scope.selectedOptions) {
            return false;
          }
          var itemId = $scope.getId(item);
          for (var i = 0; i < $scope.selectedOptions.length; i++) {
            var selectedElement = $scope.selectedOptions[i];
            if ($scope.getId(selectedElement) === itemId) {
              return true;
            }
          }
          return false;
        };

        $scope.updateOptions = function () {
          if (typeof $scope.options === 'function') {
            $scope.options().then(function (resolvedOptions) {
              $scope.resolvedOptions = resolvedOptions;
              updateSelectionLists();
            });
          }
        };

        // This search function is optimized to take into account the search limit.
        // Using angular limitTo filter is not efficient for big lists, because it still runs the search for
        // all elements, even if the limit is reached
        $scope.search = function () {
          var counter = 0;
          return function (item) {
            if (counter > $scope.searchLimit) {
              return false;
            }
            var displayName = $scope.getDisplay(item);
            if (displayName) {
              var result = displayName.toLowerCase().indexOf($scope.searchFilter.toLowerCase()) > -1;
              if (result) {
                counter++;
              }
              return result;
            }
          }
        };

      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.orgTerms', [])
    .config(routeConfig)
    .controller('OrganizationTermsCtrl', OrganizationTermsCtrl);

  /* @ngInject */
  function OrganizationTermsCtrl(terms, privacyTerms, clientApi, $rootScope, $uibModal, $state) {
    var $ctrl = this;

    $ctrl.termstext = new showdown.Converter().makeHtml(terms.TextContent);
    $ctrl.privacyTermsText = new showdown.Converter().makeHtml(privacyTerms.TextContent);
    $ctrl.privacyTermsDeliveredDateTime = $rootScope.ctx.currentUser.privacyTermsDeliveredDateTime;

    $ctrl.acceptAGB = function () {
      $rootScope.ctx.currentUser.latestTermsAccepted = true;
      if (!$rootScope.ctx.currentUser.privacyTermsDeliveredDateTime) {
        $ctrl.openPrivacy();
        return;
      }
      clientApi.custom('model/Member', 'acceptTerms', {
        termsVersion: terms.Version,
      })
        .then(function () {
          $state.reload();
        });
    };

    $ctrl.declineAGB = function () {
      return $uibModal
        .open({
          controller: 'DisagreeAGBCtrl as $ctrl',
          animation: true,
          templateUrl: 'app/pages/terms/disagreetermsModal/disagreeAGBModal.html',
          size: 'md',
        })
        .result
        .then(function (res) {
          clientApi.custom('model/Member', 'declineTerms', {
            isOrgAgb: true,
            declineComment: res.declineComment,
          });
          localStorage.removeItem('lastPath');
          clientApi.emit('auth/combined/logout');
          window.location.href = '/';
        })
        .catch(function () {
          $ctrl.openAGB();
        });
    };

    $ctrl.openAGB = function () {
      return $uibModal
        .open({
          controller: 'agbModalCtrl as $ctrl',
          animation: true,
          templateUrl: 'app/pages/terms/agbModal/agbModal.html',
          size: 'lg',
          resolve: {
            termstext: function () {
              return $ctrl.termstext;
            },
            privacyTermsDeliveredDateTime: function () {
              return $ctrl.privacyTermsDeliveredDateTime;
            },
          },
        })
        .result
        .then(function () {
          $ctrl.acceptAGB();
        })
        .catch(function () {
          $ctrl.declineAGB();
        });
    };
    $ctrl.acceptPrivacy = function () {
      if (!$rootScope.ctx.currentUser.latestTermsAccepted) {
        $ctrl.openAGB();
        return;
      }
      return clientApi
        .custom('model/Member', 'acceptTerms', {
          termsVersion: terms.Version
        })
          .then(function () {
            $state.reload();
          });
    };

    $ctrl.declinePrivacy = function () {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/terms/disagreetermsModal/disagreePrivacyModal.html',
          size: 'md',
        })
        .result
        .then(function () {
          localStorage.removeItem('lastPath');
          clientApi.emit('auth/combined/logout');
          window.location.href = '/';
        })
        .catch(function () {
          $ctrl.openPrivacy();
        });
    };

    $ctrl.openPrivacy = function () {
      return $uibModal
        .open({
          controller: 'privacyModalCtrl as $ctrl',
          animation: true,
          templateUrl: 'app/pages/terms/privacyModal/privacyModal.html',
          size: 'lg',
          resolve: {
            privacyTermsText: function () {
              return $ctrl.privacyTermsText;
            },
          },
        })
        .result
        .then(function () {
          $ctrl.acceptPrivacy();
        })
        .catch(function () {
          $ctrl.declinePrivacy();
        });
    };
    if (!$rootScope.ctx.currentUser.latestTermsAccepted) {
      $ctrl.openAGB();
      return;
    } else if (!$rootScope.ctx.currentUser.privacyTermsDeliveredDateTime) {
      $ctrl.openPrivacy();
    } else {
      $state.go('arno.dashboard');
    }
  }

  /* @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.terms', {
        url: '/terms',
        template: '<div></div>',
        controller: 'OrganizationTermsCtrl as $ctrl',
        resolve: {
          terms: function (clientApi, toastr) {
            return clientApi
              .custom('model/Terms', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim Laden der Nutzungsbedingungen', 'Laden der Nutzungsbedingungen gescheitert');
                throw err;
              });
          },
          privacyTerms: function (clientApi, toastr) {
            return clientApi
              .custom('model/PrivacyTerms', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim Laden der Datenschutzerklärung', 'Laden der Datenschutzerklärung gescheitert');
                throw err;
              });
          }
        }
      });
  }
})
();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.orgTerms')
    .controller('privacyModalCtrl', privacyModalCtrl);

  function privacyModalCtrl(privacyTermsText) {
    var self = this;
    self.accepts = false;
    self.privacyTermsText = privacyTermsText;
    self.accept=function(cb){
      self.accepts=true;
      cb();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.orgTerms')
    .controller('DisagreeAGBCtrl', DisagreeAGBCtrl);

  function DisagreeAGBCtrl($rootScope) {
    var self = this;
    self.acceptedLatestTerms = $rootScope.ctx.currentUser.latestTermsAccepted;
    self.timeUntilWithdrawal = $rootScope.ctx.organization.current.withdrawalPeriodDays;
    self.hasAcceptedAnyTerms = $rootScope.ctx.currentUser.termsAcceptedVersion;
    self.declineComment = null;
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.orgTerms')
    .controller('agbModalCtrl', agbModalCtrl);

  function agbModalCtrl(termstext, privacyTermsDeliveredDateTime, $uibModalInstance) {
    var self = this;
    self.accepts = false;
    self.privacyTermsDeliveredDateTime = privacyTermsDeliveredDateTime;
    self.termstext = termstext;
    self.accept=function(){
      self.accepts=true;
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics.usage', [])
    .controller('usageChartCtrl', usageChartCtrl);

  /** @ngInject */
  function usageChartCtrl($rootScope, $scope, $timeout, statisticalDataProvider, initStatData, toastr, permissions, selectedCtx) {
    var self = this;

    self.selectedCtx = selectedCtx;

    self.initStatData = initStatData;

    self.updateUsageData = function (data) {
      self.usageLabel = data.label.map(function (dateLabel) {
        return moment(dateLabel).format('DD.MM.YYYY');
      });
      self.usageData = [
        data.timeData.map(function (minutes) {
          return Math.ceil(minutes / 60);
        }),
        data.userCountData,
      ];
      self.usageDataAverage = [
        data.timeData.map(function (time, i) {
          try {
            return Math.round(time / data.userCountData[i]) || 0;
          } catch (e) {
            return 0;
          }
        })
      ];

      self.usageLengthData = data.usageLength;
      self.usageLengthLabel = ['0-15 min', '15-30 min', '30-60 min', '> 1h'];
    };

    $scope.datasetOverride1 = [
      {
        label: 'Override Series A',
        backgroundColor: [
          '#FF0000',
          '#ffb300',
          '#fffb00',
          '#5ae200'
        ],
      },
      {
        label: 'Override Series B',
        backgroundColor: [
          '#FF0000',
          '#ffb300',
          '#fffb00',
          '#5ae200'
        ],
      },
    ];

    self.usageDataset = [
      {
        label: 'Gesamtnutzungszeit in Stunden',
        borderWidth: 2,
        type: 'bar'
      },
      {
        label: 'Nutzerzahl',
        borderWidth: 3,
        type: 'line'
      }
    ];
    self.usageSeriesAverage = ['Ø Verweildauer (min) pro Nutzer'];

    self.chartOpts = {
      legend: {
        display: true,
        position: 'top'
      },
      scales: {
        yAxes: [{
          ticks: { beginAtZero: true }
        }]
      }
    };

    self.doughnutOpts = {
      legend: {
        display: true,
        position: 'top',
      },
      title: {
        display: true,
        text: 'Verweildauer pro Nutzer'
      },
    };

    self.usageDataFrom = moment().subtract(7, 'days').toDate();
    self.usageDates = [7, 6, 5, 4, 3, 2, 1].map(function (i) {
      return +moment().subtract(i, 'days').startOf('day').toDate();
    });

    $scope.$watch(function () {
      return self.usageDates;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        var dates = _.clone(self.usageDates).sort();
        if (dates.length > 1) {
          if (moment(new Date(dates[0])).add(3, 'months').isBefore(moment(dates.slice(dates.length - 1, dates.length)[0]))) {
            toastr.warning('Abfragezeiträume, die länger sind als 3 Monate, sind nicht zulässig.', 'Ungültiger Abfragezeitraum');
            return;
          }
          statisticalDataProvider('USAGE_TIME', new Date(dates.slice(0, 1)[0]), new Date(dates.slice(dates.length - 1, dates.length)[0]))
            .then(function (statisticData) {
              self.updateUsageData(statisticData);
            });
        }
      }
    }, true);

    self.timescaleLabel = initStatData.usageTimescale.label;
    self.timescaleData = [
      initStatData.usageTimescale.timescaleData
    ];
    self.timescaleSeries = ['Nutzerzahl pro Stundenzeitraum'];
    self.timescaleSelection = moment().subtract(1, 'day').toDate();

    $scope.$watch(function () {
      return self.timescaleSelection;
    }, function () {
      statisticalDataProvider('USAGE_TIMESCALE', moment(self.timescaleSelection).startOf('day'), moment(self.timescaleSelection).endOf('day'))
        .then(function (statisticData) {
          self.timescaleLabel = statisticData.label;
          self.timescaleData = [statisticData.timescaleData];
        });
    });

    self.datepickerOptions = {
      usage: {
        maxDate: moment().subtract(1, 'day').subtract(1, 'hour').toDate(),
        customClass: function (data) {
          if (self.usageDates
              .filter(function (date) {
                return +new Date(date).setHours(0, 0, 0, 0) === data.date.setHours(0, 0, 0, 0);
              })
              .length) {
            return 'multiple-selected';
          }
          return '';
        }
      },
      timescale: {
        maxDate: moment().subtract(1, 'day').subtract(1, 'hour').toDate(),
      }
    };

    self.updatePlusMarginUsage = function () {
      var plusMarginUsage = (($('#arno-statistic-user-usage-chart').height() - $('#arno-statistic-user-usage-picker').height()) / 2) - 28;
      if (plusMarginUsage > 0) {
        self.plusMarginUsagePicker = plusMarginUsage + 'px';
      } else {
        self.plusMarginUsageChart = Math.abs(plusMarginUsage) + 'px';
      }
    };

    self.updatePlusMarginTimescale = function () {
      var plusMarginTimescale = (($('#arno-statistic-user-timescale-chart').height() - $('#arno-statistic-user-timescale-picker').height()) / 2) - 28;
      if (plusMarginTimescale > 0) {
        self.plusMarginTimescalePicker = plusMarginTimescale + 'px';
      } else {
        self.plusMarginTimescaleChart = Math.abs(plusMarginTimescale) + 'px';
      }
    };

    $timeout(function () {
      $(window).trigger('resize');
      self.updatePlusMarginUsage();
      self.updatePlusMarginTimescale();
    }, 500);
    // make it two, the first one is exact, the second one for slow devices as security
    $timeout(function () {
      $(window).trigger('resize');
      self.updatePlusMarginUsage();
      self.updatePlusMarginTimescale();
    }, 750);
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics.helperhours', [])
    .controller('hhChartCtrl', hhChartCtrl);

  /** @ngInject */
  function hhChartCtrl(
    statisticalDataProvider,
    helperHoursStatisticData,
    selectedCtx,
    helperTableProvider,
    helperTableData
  ) {
    var self = this;
    self.statisticalDataProvider = statisticalDataProvider;
    self.helperHoursStatisticData = helperHoursStatisticData;
    self.divisionIds = selectedCtx;
    self.showHelperTable = true;
    self.helperTableProvider = helperTableProvider;
    self.helperTableData = helperTableData;
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.personnelList')
    .controller('PersonnelListCtrl', PersonnelListCtrl);

  /** @ngInject */
  function PersonnelListCtrl(
    $scope,
    $rootScope,
    $uibModal,
    $log,
    $state,
    $translate,
    commonUtils,
    tableConfig,
    persistFilter,
    ArnoDashAdminMembersService,
    clientApi,
    permissions,
    toastr,
    personnelListCtx,
    organizationId,
    personnelListPermissions,
    groups,
    currentUser
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.groups = groups;
    $ctrl.liveCalcMode = false;
    $ctrl.memberId = (currentUser || {}).id;
    var filterStorageKey = 'personnelListFilter';
    $ctrl.storedFilters = localStorage.getItem(filterStorageKey);
    var filters = JSON.parse($ctrl.storedFilters) || {};
    var exportQueryWishesOrg;
    var exportQueryWishesDiv;
    $ctrl.divMemCount;
    $ctrl.orgMemCount;
    $ctrl.filterApplied = {};

    $ctrl.subtypes = [
      {
        field: 'MemberQualifications',
        label: $translate.instant('generalTerms.qualifications'),
      },
      {
        field: 'MemberActivities',
        label: $translate.instant('generalTerms.activities'),
      },
    ];

    $ctrl.aKeys = {
      on: $translate.instant('modules.personnel.personnelList.activeMembers'),
      off: $translate.instant('modules.personnel.personnelList.allMembers'),
    };
    $ctrl.aHints = {
      on: $translate.instant(
        'modules.personnel.personnelList.activeMembersHint'
      ),
      off: $translate.instant('modules.personnel.personnelList.allMembersHint'),
    };

    $ctrl.chosableSalutations = [
      {
        Name: $translate.instant('models.Member.Salutation.mister'),
        Value: 'mister',
      },
      {
        Name: $translate.instant('models.Member.Salutation.miss'),
        Value: 'miss',
      },
      {
        Name: $translate.instant('models.Member.Salutation.other'),
        Value: 'other',
      },
    ];

    $ctrl.chosableMemberTypes = [
      {
        Name: $translate.instant('models.Member.MemberType.ACTIVE_MEMBER'),
        Value: 'ACTIVE_MEMBER',
      },
      {
        Name: $translate.instant('models.Member.MemberType.PASSIVE_MEMBER'),
        Value: 'PASSIVE_MEMBER',
      },
      {
        Name: $translate.instant('models.Member.MemberType.NONE_MISC_MEMBER'),
        Value: 'NONE_MISC_MEMBER',
      },
    ];

    $ctrl.demandForActions = [
      {
        Name: 'Abgelaufene Qualifikation/Einweisung',
        Value: 'allQualificationsActive',
        Label: 'label-warning',
      },
      {
        Name: 'Ausstehende Tätigkeitszuweisung',
        Value: 'activitiesPending',
        Label: 'label-warning',
      },
      {
        Name: 'Tätigkeitsvoraussetzungen nicht erfüllt',
        Value: 'allActivitiesNotFulfilled',
        Label: 'label-danger',
      },
      {
        Name: 'Keine Tätigkeit zugewiesen',
        Value: 'NoMemberActivities',
        Label: 'label-tag',
      },
      {
        Name: 'Keine Qualifikation zugewiesen',
        Value: 'NoMemberQualifications',
        Label: 'label-tag',
      },
    ];

    $ctrl.jobCharacteristics = [
      {
        Name: 'Ausstehende Tätigkeitszuweisung',
        Value: 'activitiesPending',
        Label: 'label-warning',
        sortProp: 'MemberStatus',
      },
      {
        Name: 'Tätigkeitsvoraussetzungen nicht erfüllt',
        Value: 'allActivitiesNotFulfilled',
        Label: 'label-danger',
      },
      {
        Name: 'Tätigkeitsvoraussetzungen erfüllt',
        Value: 'allActivitiesFulfilled',
        Label: 'label-success',
      },
      {
        Name: 'Keine Tätigkeit zugewiesen',
        Value: 'NoMemberActivities',
        Label: 'label-tag',
      },
    ];

    $ctrl.qualificationFeatures = [
      {
        Name: 'Abgelaufene Qualifikation/Einweisung',
        Value: 'qualificationExpired',
        Label: 'label-warning',
      },
      {
        Name: 'Keine Qualifikation/Einweisung zugewiesen',
        Value: 'noQualifications',
        Label: 'label-tag',
      },
    ];

    $ctrl.accountTypes = {
      offline: { name: 'Offline-Account', label: 'label-tag' },
      local: { name: 'ARNO-Account', label: 'label-success' },
      azure: { name: 'Organisations-Account', label: 'label-success' },
    };

    $ctrl.chosableGenders = [
      { Name: $translate.instant('models.Member.Gender.M'), Value: 'M' },
      { Name: $translate.instant('models.Member.Gender.F'), Value: 'F' },
      { Name: $translate.instant('models.Member.Gender.O'), Value: 'O' },
    ];

    // get the list to display initially from the localstorage
    var divView = commonUtils.preference.object.get(
      'pref_current_personnel_list_view_div',
      '0'
    );
    var orgView = commonUtils.preference.object.get(
      'pref_current_personnel_list_view_org',
      '0'
    );
    // store custom tableViews here
    $ctrl.tableViewsDiv = {};
    $ctrl.tableViewsOrg = {};

    // get the default table views per div and org
    var divTableConf = tableConfig.tableConfigDivDefault;
    var orgTableConf = tableConfig.tableConfigOrgDefault;

    $ctrl.handleCustomLists = function (customTableConfigs) {
      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        if (conf.IsOrg) {
          // get the pageSize retrieved from localstorage and stored in defaultView and add it to customViews
          conf.Fields.pageSize = tableConfig.tableConfigOrgDefault.pageSize;
          $ctrl.tableViewsOrg[conf.id] = conf;
        } else {
          conf.Fields.pageSize = tableConfig.tableConfigDivDefault.pageSize;
          $ctrl.tableViewsDiv[conf.id] = conf;
        }
      });
    };
    $ctrl.handleCustomLists(tableConfig.tableConfigCustomPreference);

    $ctrl.tryTranslate = function (path, target, params) {
      var fullPath = target ? path + '.' + target : path;
      var notFound = target ? target : '';
      var result = params
        ? $translate.instant(fullPath, params)
        : $translate.instant(fullPath);
      return result === fullPath ? notFound : result;
    };

    // if we got a custom view selected for initial display make sure it was not deleted before. if so, display default view
    if (divView.id) {
      // if we found an actual id in the localstorage, we assume its a custom table view
      if ($ctrl.tableViewsDiv[divView.id]) {
        divTableConf = $ctrl.tableViewsDiv[divView.id].Fields;
      } else {
        // if it is a custom view which got deleted already, reset to default view
        divView = '0';
      }
    }
    if (orgView.id) {
      if ($ctrl.tableViewsOrg[orgView.id]) {
        orgTableConf = $ctrl.tableViewsOrg[orgView.id].Fields;
      } else {
        orgView = '0';
      }
    }

    $ctrl.listTypes = [
      {
        title: $translate.instant(
          'modules.personnel.personnelList.divisionListTitle'
        ),
        active: personnelListPermissions.div,
        selectedView: divView.id || divView, // will be used to determine the config to use
        isOrgList: false,
        tableConfig: divTableConf, // stores the current config
        customViews: $ctrl.tableViewsDiv, // stores the configs of custom lists
        defaultView: tableConfig.tableConfigDivDefault, // stores the default config
        chosenGroups: [],
        ctx: personnelListCtx,
        displayedCollection: [],
      },
      {
        title: $translate.instant(
          'modules.personnel.personnelList.orgListTitle'
        ),
        active: personnelListPermissions.org,
        selectedView: orgView.id || orgView,
        isOrgList: true,
        tableConfig: orgTableConf,
        customViews: $ctrl.tableViewsOrg,
        defaultView: tableConfig.tableConfigOrgDefault,
        ctx: ['rootOrg'],
        displayedCollection: [],
      },
    ];
    $ctrl.listTypes.forEach(function (listType) {
      listType.getData = function (params, ctrl) {
        return $ctrl.getData(params, ctrl, listType);
      };
    });

    $ctrl.sortableOrg = [
      { fieldName: 'FirstName', sortProp: 'FirstName' },
      { fieldName: 'MemberNumber', sortProp: 'MemberNumber' },
      { fieldName: 'LastName', sortProp: 'LastName' },
      { fieldName: 'Phone', sortProp: 'Phone' },
      { fieldName: 'Mobile', sortProp: 'Mobile' },
      { fieldName: 'EMail', sortProp: 'Account.EMail' },
      { fieldName: 'MainDivision', sortProp: 'MainDivision.Name' },
    ];
    $ctrl.sortableDiv = [
      { fieldName: 'FirstName', sortProp: 'Member.FirstName' },
      { fieldName: 'MemberNumber', sortProp: 'Member.MemberNumber' },
      { fieldName: 'LastName', sortProp: 'Member.LastName' },
      { fieldName: 'Phone', sortProp: 'Member.Phone' },
      { fieldName: 'Mobile', sortProp: 'Member.Mobile' },
      { fieldName: 'EMail', sortProp: 'Member.Account.EMail' },
      { fieldName: 'MemberStatus', sortProp: 'MemberStatus' },
      { fieldName: 'MainDivision', sortProp: 'MainDivision.Name' },
    ];

    // METHODS
    function storeTableConfig(listType) {
      commonUtils.preference.object.set(
        'pref_personnel_page_size_' + (listType.isOrgList ? 'org' : 'div'),
        {
          pageSize: listType.tableConfig.pageSize,
        }
      );
      if (listType.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_personnel_list_view_' +
            (listType.isOrgList ? 'org' : 'div')
        );
      } else {
        // store the id of the currently selected view
        commonUtils.preference.object.set(
          'pref_current_personnel_list_view_' +
            (listType.isOrgList ? 'org' : 'div'),
          { id: listType.selectedView }
        );
      }
    }

    $ctrl.checkState = function (state) {
      if (state === 'available') {
        return { color: 'green' };
      } else if (state === 'away') {
        return { color: '#ffff66' };
      } else {
        return { color: '#c2c2a3' };
      }
    };

    $ctrl.changePageSize = function (listType, num) {
      listType.tableConfig.pageSize = num;
      storeTableConfig(listType);
    };

    $ctrl.changeListView = function (listType, val, storageIdentifier) {
      listType.hasViewModifications = false;
      if (val === '0') {
        listType.tableConfig = listType.defaultView;
      } else {
        listType.tableConfig = val.Fields;
      }
      listType.selectedView = storageIdentifier;
      storeTableConfig(listType);
      var state = listType.tableCtrl.tableState();
      if (state) {
        state.sort = {};
      }
      listType.customViews[listType.selectedView].initialSort = true;
      return $ctrl.reloadTable(listType, true);
    };

    $ctrl.activateMember = function (scope, listType) {
      /* only on div-level */
      var activate = function () {
        return clientApi
          .custom('model/DivisionMember', 'activateDivisionMember', {
            divMemberId: scope.divisionMember.id,
            divisionId: scope.divisionMember.DivisionId,
          })
          .then(function () {
            toastr.success(
              $translate.instant(
                'modules.personnel.personnelList.activateToastSuccText',
                { member: scope.divisionMember.Member.fullName }
              ),
              $translate.instant(
                'modules.personnel.personnelList.activateToastSuccTitle'
              )
            );
            return $ctrl.reloadTable(listType);
          })
          .catch(function () {
            toastr.error(
              $translate.instant(
                'modules.personnel.personnelList.activateToastErrText_1',
                { member: scope.divisionMember.Member.fullName }
              ),
              $translate.instant(
                'modules.personnel.personnelList.activateToastErrTitle_1'
              )
            );
          });
      };
      if (!scope.divisionMember.WithdrawalTriggeredDate) {
        return activate();
      } else {
        toastr.error(
          $translate.instant(
            'modules.personnel.personnelList.activateToastErrText_2',
            { member: scope.divisionMember.Member.fullName }
          ),
          $translate.instant(
            'modules.personnel.personnelList.activateToastErrTitle_2'
          )
        );
      }
    };

    $ctrl.deactivateMember = function (scope, listType) {
      /* only on div-level */
      return $uibModal
        .open({
          animation: true,
          templateUrl:
            'app/pages/personnel/personnelList/deactivateMember.modal.html',
          size: 'md',
          scope: scope,
        })
        .result.then(function () {
          return clientApi.custom(
            'model/DivisionMember',
            'deactivateDivisionMember',
            {
              divMemberId: scope.divisionMember.id,
              divisionId: scope.divisionMember.DivisionId,
            }
          );
        })
        .then(function () {
          toastr.success(
            $translate.instant(
              'modules.personnel.personnelList.deactivateToastSuccText',
              { member: scope.divisionMember.Member.fullName }
            ),
            $translate.instant(
              'modules.personnel.personnelList.deactivateToastSuccTitle'
            )
          );
          return $ctrl.reloadTable(listType);
        });
    };

    $ctrl.removeMember = function (scope, listType) {
      return $uibModal
        .open({
          animation: true,
          templateUrl:
            'app/pages/personnel/personnelList/removeMember.modal.html',
          size: 'md',
          scope: scope,
        })
        .result.then(function () {
          return clientApi.custom('model/DivisionMember', 'deleteDivMember', {
            divMemberId: scope.divisionMember.id,
            divisionId: scope.divisionMember.DivisionId,
          });
        })
        .then(function () {
          toastr.success(
            $translate.instant(
              'modules.personnel.personnelList.removeToastSuccText',
              { member: scope.divisionMember.Member.fullName }
            ),
            $translate.instant(
              'modules.personnel.personnelList.removeToastSuccTitle'
            )
          );
          return $ctrl.reloadTable(listType);
        });
    };

    $ctrl.reloadTable = function (listType, clearFilters) {
      if (listType && listType.tableCtrl) {
        var tableState = listType.tableCtrl.tableState();
        if (
          clearFilters &&
          tableState &&
          tableState.search &&
          tableState.search.predicateObject
        ) {
          tableState.search.predicateObject = {};
        }
        return $ctrl.getData(listType.tableCtrl.tableState(), null, listType);
      }
    };

    $ctrl.openTableConfig = function (currentConf) {
      if (
        !$ctrl.isPermitted(
          currentConf,
          'arno.personnel.personnelList.configure',
          currentConf.ctx
        )
      ) {
        return false;
      }
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return currentConf.isOrgList;
            },
            isMaterialList: function () {
              return false;
            },
            aggExclusion: function () {
              return [];
            },
            sortableFields: function () {
              return currentConf.isOrgList
                ? $ctrl.sortableOrg
                : $ctrl.sortableDiv;
            },
            availableFields: function () {
              return currentConf.isOrgList
                ? tableConfig.tableConfigAvailableFields.org
                : tableConfig.tableConfigAvailableFields.div;
            },
            currentList: function () {
              return { current: currentConf.tableConfig };
            },
            availableLists: function () {
              return JSON.parse(JSON.stringify(currentConf.customViews));
            },
          },
        })
        .result.then(function (res) {
          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;
          if (res.modifiedCurrentList) {
            // if we modified a current view we'll create a pseudo list which will not be stored
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;
            if (!currentConf.tableConfig.pageSize) {
              currentConf.tableConfig.pageSize =
                tableConfig.tableConfigDivDefault.pageSize;
            }
          }
          toastr.success(
            $translate.instant(
              'modules.personnel.personnelList.tblConfToastSuccText'
            ),
            $translate.instant(
              'modules.personnel.personnelList.tblConfToastSuccTitle'
            )
          );
          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  // if we deleted the currently selected list, switch back to default view
                  $ctrl.changeListView(currentConf, '0', '0');
                }
                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id,
                    divisionId: personnelListCtx,
                  })
                  .then(function () {
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }
          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (
                !currentConf.hasViewModifications &&
                val.id &&
                val.id === JSON.parse(currentConf.selectedView)
              ) {
                // to immediately update the table if we edited our current, db stored list. If we modified just the current view do nothing
                currentConf.tableConfig = _.merge(
                  currentConf.tableConfig,
                  val.Fields
                );
              }
              // update or create a new list
              customLists.push({
                id: val.id || false,
                ListType: 'personnelList',
                ListName: val.Name,
                IsOrg: currentConf.isOrgList,
                Fields: val.Fields,
                Sort: val.Sort,
              });
              newListAdded = !val.id ? true : newListAdded;
            });
            if (customLists.length > 0) {
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: personnelListCtx,
                })
                .then(function () {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'personnelList',
                      divisionId: personnelListCtx,
                    })
                    .then(function (lists) {
                      $ctrl.handleCustomLists(lists);
                      if (newListAdded) {
                        var maxId = Math.max.apply(
                          Math,
                          Object.values(
                            _.mapValues(lists, function (l) {
                              return l.id;
                            })
                          )
                        );
                        var newList = Object.values(
                          _.pickBy(lists, function (list) {
                            return list.id == maxId;
                          })
                        )[0];
                        $ctrl.changeListView(currentConf, newList, maxId);
                      }
                      $ctrl.reloadTable(currentConf);
                    });
                });
            }
          }
          $ctrl.reloadTable(currentConf);
        });
    };

    $ctrl.openExportDialog = function (listType, exportName) {
      var config = _.cloneDeep(listType.tableConfig);
      config.Email = true;
      config.FirstName = true;
      config.LastName = true;
      $uibModal
        .open({
          animation: true,
          templateUrl:
            'app/pages/personnel/personnelList/export/personnelChooseExportTypeModal.html',
          size: 'md',
          controller: 'PersonnelChooseExportTypeCtrl as $chooseExportTypeCtrl',
          resolve: {
            selectedCalcData: function () {
              return {
                enabled:
                  listType.tableConfig.MemberActivityState ||
                  listType.tableConfig.MemberQualifications ||
                  listType.tableConfig.MemberActivities,
                initVal: listType.tableConfig.LiveCalcMode,
              };
            },
            exportPrivacyNote: function (clientApi) {
              return clientApi.custom(
                'model/ExportPrivacyNote',
                'getLatest',
                {}
              );
            },
          },
        })
        .result.then(function (result) {
          var savedQW = listType.isOrgList
            ? exportQueryWishesOrg
            : exportQueryWishesDiv;
          clientApi.openTab(
            exportName,
            {
              format: result.filetyp,
              divisionIds: JSON.stringify(listType.ctx),
              allOption: result.options.fields,
              dataFields: JSON.stringify(config),
              liveData: result.liveCalc,
              queryWishes:
                result.options.filter === 'filtered'
                  ? JSON.stringify(savedQW)
                  : null,
              language: $translate.use(),
            },
            { post: true }
          );

          toastr.success(
            $translate.instant(
              'modules.personnel.personnelList.exportToastSuccText'
            ),
            $translate.instant(
              'modules.personnel.personnelList.exportToastSuccTitle'
            )
          );
        });
    };

    $ctrl.openSubModuleExportDialog = function (listType, exportName) {
      var tableState = listType.tableCtrl.tableState();

      var groupIds = [];
      if (
        !listType.isOrgList &&
        listType.chosenGroups &&
        listType.chosenGroups.length
      ) {
        listType.chosenGroups.forEach(function (group) {
          groupIds.push(group.id);
        });
      }
      var queryWishes = {
        filter: tableState.search.predicateObject
          ? commonUtils.flattenObject(tableState.search.predicateObject)
          : undefined,
        memberGroups: groupIds ? groupIds : undefined,
        onlyActive: listType.tableConfig.Active,
      };
      $uibModal
        .open({
          animation: true,
          templateUrl:
            'app/pages/personnel/personnelList/export/personnelQualificationExportModal.html',
          size: 'md',
          controller:
            'PersonnelQualificationExportCtrl as $qualificationExportTypeCtrl',
          resolve: {
            exportPrivacyNote: function (clientApi) {
              return clientApi.custom(
                'model/ExportPrivacyNote',
                'getLatest',
                {}
              );
            },
          },
        })
        .result.then(function (result) {
          clientApi.openTab(
            exportName,
            {
              format: result.filetyp,
              divisionIds: JSON.stringify(listType.ctx),
              queryWishes: JSON.stringify(queryWishes),
              language: $translate.use(),
            },
            { post: true }
          );
          toastr.success(
            $translate.instant(
              'modules.personnel.personnelList.exportToastSuccText'
            ),
            $translate.instant(
              'modules.personnel.personnelList.exportToastSuccTitle'
            )
          );
        });
    };

    $ctrl.getData = function (params, ctrl, listType) {
      listType.tableCtrl = ctrl || listType.tableCtrl;
      /* only for div level */
      var configuredSort = {
        predicate: false,
        reverse: false,
      };
      if (!params.sort.predicate) {
        if (
          listType.customViews[listType.selectedView] &&
          listType.customViews[listType.selectedView].initialSort &&
          listType.customViews[listType.selectedView].Sort &&
          Object.keys(listType.customViews[listType.selectedView].Sort).length
        ) {
          var propName = Object.keys(
            listType.customViews[listType.selectedView].Sort
          )[0];
          var predicate =
            listType.customViews[listType.selectedView].Sort[propName].sortProp;
          var reverse =
            listType.customViews[listType.selectedView].Sort[propName]
              .direction === 'desc';
          configuredSort = {
            predicate: predicate,
            reverse: reverse,
          };
          var state = listType.tableCtrl.tableState();
          state.sort = configuredSort;
          listType.customViews[listType.selectedView].initialSort = false;
        }
      }
      var groupIds = [];
      if (
        !listType.isOrgList &&
        listType.chosenGroups &&
        listType.chosenGroups.length
      ) {
        listType.chosenGroups.forEach(function (group) {
          groupIds.push(group.id);
        });
      }
      var currentCtx = listType.isOrgList ? 'rootOrg' : 'division';
      persistFilter.applyAndSave(
        filters,
        $ctrl.filterApplied,
        $ctrl.storedFilters,
        currentCtx,
        params,
        filterStorageKey,
        {
          groupIds: groupIds,
          chosenGroups: listType.chosenGroups,
        },
        listType.isOrgList
          ? tableConfig.tableConfigAvailableFields.org
          : tableConfig.tableConfigAvailableFields.div,
        listType.tableConfig
      );

      var queryWishes = {
        attributes: [],
        paging: {
          offset:
            (params.pagination.start / params.pagination.number) *
              listType.tableConfig.pageSize || 0,
          limit: listType.tableConfig.pageSize,
        },
        filter: params.search.predicateObject
          ? commonUtils.flattenObject(params.search.predicateObject)
          : undefined,
        memberGroups: groupIds ? groupIds : undefined,
        sort: {
          by: params.sort.predicate || configuredSort.predicate,
          reverse: params.sort.reverse || configuredSort.reverse,
        },
        includeQualifications:
          listType.tableConfig.MemberQualifications ||
          listType.tableConfig.QualificationFeatures ||
          listType.tableConfig.DemandForAction,
        includeActivities:
          listType.tableConfig.MemberActivities ||
          listType.tableConfig.MemberActivityState ||
          listType.tableConfig.JobCharacteristics ||
          listType.tableConfig.DemandForAction,
        useLiveData: listType.tableConfig.LiveCalcMode,
      };
      if (listType.chosenMemberTypes && listType.chosenMemberTypes.length) {
        if (queryWishes.filter === undefined) {
          queryWishes.filter = {};
        }
        queryWishes.filter['MemberType'] = listType.chosenMemberTypes.map(
          function (Type) {
            return Type.Value;
          }
        );
      }

      if (listType.chosenSalutations && listType.chosenSalutations.length) {
        if (queryWishes.filter === undefined) {
          queryWishes.filter = {};
        }
        queryWishes.filter['Salutation'] = listType.chosenSalutations.map(
          function (Type) {
            return Type.Value;
          }
        );
      }

      if (listType.chosenGenders && listType.chosenGenders.length) {
        if (queryWishes.filter === undefined) {
          queryWishes.filter = {};
        }
        queryWishes.filter['Gender'] = listType.chosenGenders.map(function (
          Type
        ) {
          return Type.Value;
        });
      }

      if (
        listType.chosenJobCharacteristics &&
        listType.chosenJobCharacteristics.length
      ) {
        if (queryWishes.filter === undefined) {
          queryWishes.filter = {};
        }
        queryWishes.filter[
          'Member.JobCharacteristics'
        ] = listType.chosenJobCharacteristics.map(function (Type) {
          return Type.Value;
        });
      }

      var availableFields = listType.isOrgList
        ? tableConfig.tableConfigAvailableFields.org
        : tableConfig.tableConfigAvailableFields.div;
      _.forOwn(listType.tableConfig, function (value, key) {
        // find the property definitions for configured fields to add proper fieldName to query attributes
        if (value === true || value === 'true') {
          var found = _.find(availableFields, { prop: key });
          if (found) {
            queryWishes.attributes.push(found.field || found.prop);
          }
        }
      });

      if (listType.isOrgList) {
        exportQueryWishesOrg = queryWishes;
      } else {
        exportQueryWishesDiv = queryWishes;
      }
      if (
        $ctrl.isPermitted(
          listType,
          'arno.personnel.personnelList.view',
          listType.ctx
        )
      ) {
        if (listType.isOrgList) {
          return clientApi
            .custom('model/Member', 'findOrgMemberByOrganizationId', {
              queryWishes: queryWishes,
            })
            .then(function (result) {
              $ctrl.orgMemCount = (result && result.count) || 0;
              params.pagination.numberOfPages = Math.ceil(
                result.count / listType.tableConfig.pageSize
              );
              if (result.count > 0 && result.rows.length === 0) {
                params.pagination.start =
                  params.pagination.numberOfPages *
                  listType.tableConfig.pageSize;
                persistFilter.setPaginationPersist(
                  filters,
                  currentCtx,
                  params.pagination,
                  filterStorageKey
                );
                $ctrl.getData(params, ctrl, listType);
              }
              persistFilter.setPaginationPersist(
                filters,
                currentCtx,
                params.pagination,
                filterStorageKey
              );
              var formattedResults = [];
              result.rows.forEach(function (member) {
                var Member = { Member: member };
                formattedResults.push(Member);
              });
              listType.displayedCollection = formattedResults;
            });
        } else {
          return ArnoDashAdminMembersService.findDivisionMembers(
            listType.ctx,
            queryWishes,
            listType.tableConfig.Active,
            null,
            false
          ).then(function (result) {
            $ctrl.divMemCount = (result && result.count) || 0;
            var formattedResults = [];
            result.rows.forEach(function (member) {
              $ctrl.giveTag(member);
              formattedResults.push(member);
            });
            params.pagination.numberOfPages = Math.ceil(
              result.count / listType.tableConfig.pageSize
            );
            // we got a result that is paged wrongly (maybe the only entry on a page was removed by a dossier action)
            // move the paging one page back if we did actually get results, but no row entries
            if (result.count > 0 && result.rows.length === 0) {
              params.pagination.start =
                params.pagination.numberOfPages *
                  listType.tableConfig.pageSize -
                listType.tableConfig.pageSize;
              persistFilter.setPaginationPersist(
                filters,
                currentCtx,
                params.pagination,
                filterStorageKey
              );
              $ctrl.getData(params, ctrl, listType);
            }
            persistFilter.setPaginationPersist(
              filters,
              currentCtx,
              params.pagination,
              filterStorageKey
            );
            listType.displayedCollection = formattedResults;
          });
        }
      } else {
        params.pagination.numberOfPages = 0;
        listType.displayedCollection = [];
      }
    };

    $ctrl.isInGroup = function (listType, member) {
      if (listType.chosenGroups.length === 0) {
        return true;
      }
      return _.find(member.Member.MemberGroups, function (memberGroup) {
        return _.find(listType.chosenGroups, function (chosenGroup) {
          return memberGroup.MemberGroupMember.MemberGroupId === chosenGroup.id;
        });
      });
    };

    $ctrl.memberGroupFilter = function (divisionMember) {
      return function (memberGroup) {
        return divisionMember.DivisionId === memberGroup.DivisionId;
      };
    };

    $ctrl.openDossier = function (member, listType) {
      if (
        $ctrl.isPermitted(
          listType,
          'arno.personnel.dossier,arno.administration.personnel.accountType.manage',
          [member.DivisionId]
        )
      ) {
        commonUtils.dossier.open(
          member.DivisionId,
          member.Member.Account.EMail
        );
        return false;
      }
      if (
        listType.isOrgList &&
        $ctrl.isPermitted(listType, 'arno.personnel.dossier', listType.ctx)
      ) {
        commonUtils.dossier.open(listType.ctx, member.Member.Account.EMail);
      }
      return false;
    };

    $ctrl.showMemberEditBtn = function (divisionMember, listType) {
      return (
        $ctrl.isPermitted(
          listType,
          'arno.personnel.dossier,arno.administration.personnel.accountType.manage',
          [divisionMember.DivisionId]
        ) ||
        (listType.isOrgList &&
          $ctrl.isPermitted(
            listType,
            'arno.personnel.dossier,arno.administration.personnel.accountType.manage',
            listType.ctx
          ))
      );
    };

    $ctrl.isPermitted = function (listType, action, opt) {
      if (listType.isOrgList) {
        return permissions.isPermittedInEvery(
          action,
          'Organization',
          [$rootScope.ctx.organization.current.id],
          true
        );
      }
      return permissions.isPermittedInEvery(action, 'Division', opt, true);
    };

    $ctrl.giveTag = function (member) {
      // var Member = Object.assign({}, member);

      // Member.demandForAction = [];
      function giveTagJobCharacteristics() {
        if (member.Member && member.Member.activitiesPending) {
          member.Member['highestAvaliableJobCharacteristic'] =
            $ctrl.jobCharacteristics[0];
          return;
        }
        if (member.Member.MemberActivities && member.Member.MemberActivities.length === 0) {
          member.Member['highestAvaliableJobCharacteristic'] =
            $ctrl.jobCharacteristics[3];
          return;
        }
        if (member.Member.allActivitiesFulfilled) {
          member.Member['highestAvaliableJobCharacteristic'] =
            $ctrl.jobCharacteristics[2];
          return;
        } else {
          member.Member['highestAvaliableJobCharacteristic'] =
            $ctrl.jobCharacteristics[1];
          return;
        }
      }
      giveTagJobCharacteristics();

      function giveTagMemberQualifications() {
        if (member.Member.MemberQualifications && member.Member.MemberQualifications.length === 0) {
          member.Member['highestAvaliableQualificationFeature'] =
            $ctrl.qualificationFeatures[1];
          return;
        }
        if (member.Member.allQualificationsActive === false) {
          member.Member['highestAvaliableQualificationFeature'] =
            $ctrl.qualificationFeatures[0];
          return;
        }
      }
      giveTagMemberQualifications();

      function giveTagDemandForAction() {
        member.Member['demandForActions'] = [];
        if (member.Member.MemberActivities && member.Member.MemberActivities.length === 0) {
          member.Member['demandForActions'].push($ctrl.demandForActions[3]);
        }
        if (member.Member.allQualificationsActive === false) {
          member.Member['demandForActions'].push($ctrl.demandForActions[0]);
        }
        if (member.Member.activitiesPending) {
          member.Member['demandForActions'].push($ctrl.demandForActions[1]);
        }
        if (member.Member.allActivitiesFulfilled === false) {
          member.Member['demandForActions'].push($ctrl.demandForActions[2]);
        }
        if (member.Member.MemberQualifications && member.Member.MemberQualifications.length === 0) {
          member.Member['demandForActions'].push($ctrl.demandForActions[4]);
        }
      }
      giveTagDemandForAction();
    };

    $ctrl.getFullCSpan = function (tblConf) {
      var cSpan = 0;
      _.forOwn(tblConf, function () {
        cSpan++;
      });
      return cSpan;
    };

    $ctrl.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    $ctrl.listTypes.forEach(function (listType) {
      $scope.$watch(
        function () {
          return listType.tableConfig.Active;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            storeTableConfig(listType);
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.tableConfig.LiveCalcMode;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.tableConfig.pageSize;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            storeTableConfig(listType);
          }
        },
        true
      );

      if (listType.chosenGroups) {
        $scope.$watch(
          function () {
            return listType.chosenGroups;
          },
          function (newVal, oldVal) {
            if (newVal !== oldVal) {
              return $ctrl.reloadTable(listType);
            }
          },
          true
        );
      }

      $scope.$watch(
        function () {
          return listType.chosenMemberTypes;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenDemandForActions;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenJobCharacteristics;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenQualificationFeatures;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenAccountTypes;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenSalutations;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenGenders;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );

      $scope.$watch(
        function () {
          return listType.chosenJobCharacteristics;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        },
        true
      );
    });
    // VIEW-FUNCTIONS
    /**
     @name canFullyEditMember
     @description Checks, if a member can be edited
     ATM, the edit button text/icon is only for the member who is logged in
     REASON: there there are distinct permissions for the sections of a members profile (e.g. base-data, prevention, qualification....)
     it may confuse the user, if the button is "Bearbeiten" (because user has rights to only edit qualifications of a member)
     BUT the user DOES NOT have the permission to edit the base-data of a member, and so the user wonder why
     he cant edit the base-data of the selected member, even the button was "Bearbeiten" !!

     @memberOf BlurAdmin.pages.personnel.personnelList.PersonnelListCtrl
     @namespace BlurAdmin.pages.personnel.personnelList
     */
    $ctrl.canFullyEditMember = function (divisionMember) {
      return (
        divisionMember.Member.MemberId === $ctrl.memberId ||
        divisionMember.Member.id === $ctrl.memberId
      );
    };

    $ctrl.getMemberStatusText = function (divisionMember) {
      if (divisionMember && divisionMember.MemberStatus) {
        // IMPORTANT: remove last element with "slice", because it has just been created because of the trailling semicolon ';'
        // which is need for exact search in MemberStatus of model!
        return _.flatMap(
          _.split(divisionMember.MemberStatus, ';').slice(0, -1),
          function (status) {
            return status.length
              ? $translate.instant('models.Member.MemberStatus.' + status)
              : $translate.instant('models.Member.MemberStatus');
          }
        ).join('<br>');
      }

      return '';
    };

    $ctrl.sendMailToMembers = function (listType, filtered) {
      var savedQW = listType.isOrgList
        ? exportQueryWishesOrg
        : exportQueryWishesDiv;
      var queryWishes = {
        attributes: savedQW.attributes.concat([
          'Member.FirstName',
          'Member.LastName',
          'Member.ContactEMail',
          'Account.EMail',
        ]),
        filter: filtered ? savedQW.filter : null,
        memberGroups: savedQW.memberGroups,
        sort: savedQW.sort,
      };

      var promise = Promise.resolve();

      if (listType.isOrgList) {
        promise = clientApi.custom(
          'model/Member',
          'findOrgMemberByOrganizationId',
          { queryWishes: queryWishes, noLimit: true }
        );
      } else {
        promise = ArnoDashAdminMembersService.findDivisionMembers(
          listType.ctx,
          queryWishes,
          listType.tableConfig.Active,
          null,
          true
        );
      }

      return $uibModal.open({
        controller: 'sendMailToMembersCtrl as $ctrl',
        animation: true,
        backdrop: 'static',
        templateUrl:
          'app/theme/components/modals/mailModal/sendMailToMembers.html',
        size: 'md',
        resolve: {
          memberInfos: promise.then(function (result) {
            var results = result.rows.map(function (row) {
              if (row.Member) {
                row = row.Member;
              }
              return {
                fullName: row.fullName,
                EMail:
                  row.ContactEMail ||
                  (row.Account &&
                    row.Account.Type !== 'offline' &&
                    row.Account.EMail) ||
                  null,
              };
            });
            return _.uniqWith(results, function (leftSide, rightSide) {
              var equallity = _.isEqual(leftSide.EMail, rightSide.EMail);
              if (equallity && !leftSide.EMail) {
                equallity = false;
              }
              return equallity;
            });
          }),
        },
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.memberHistory', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.memberHistory', {
        url: '/memberHistory',
        viewPermission: 'arno.personnel.personnelList.view.MEMBERHISTORY',
        templateUrl: 'app/pages/personnel/memberHistory/memberHistoryList.html',
        title: 'navigation.personnel.memberHistory',
        controller: 'MemberHistoryCtrl as $ctrl',
        resolve: {
          memberFieldList: function (clientApi) {
            return clientApi.post('member/getFieldList', {flat: true, db2i18n: true})
              .then(function (fieldList) {
                return fieldList
              });
          },
          memberChangeHistory: function () {
            return [
              {
                version: 1,
                updateDate: new Date(),
                updatedBy: {
                  FirstName: 'name des bearbeiters'
                },
                updatedFields: {
                  LastName: {
                    from: 'alterName',
                    to: 'neuerName'
                  },
                  ZIP: {
                    from: '01099',
                    to: '01133'
                  },
                  FirstName: {
                    from: 'alterVorName',
                    to: 'neuerVorName'
                  },
                  Street: {
                    from: 'alte Straße',
                    to: 'neue Straße'
                  }
                }
              }
            ];
          },
          personnelSystemChangeNotification: function () {
            return [
              {
                systemName: 'EinSystem',
                systemId: 1,
                systemInfoText: 'hihi',
                systemMail: 'christian.silbermann@outlook.com',
                notifyAboutFields: {
                  LastName: {
                    from: 'Hirni',
                    to: 'spacko'
                  },
                  ZIP: {
                    from: '01099',
                    to: '01133'
                  },
                }
              },
              {
                systemName: 'EinAnderesSystem',
                sytemId: 8,
                systemInfoText: 'blabla',
                systemMail: 'christian.silbermann@outlook.com',
                notifyAboutFields: {
                  FirstName: {
                    from: 'Lutz',
                    to: 'Futz'
                  },
                  Street: {
                    from: 'KatzenStraße',
                    to: 'HundeStraße'
                  },
                }
              }
            ];
          },
        },
        sidebarMeta: {
          order: 2,
        },
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.memberHistory')
    .controller('MemberHistoryCtrl', MemberHistoryCtrl);

  /** @ngInject */
  function MemberHistoryCtrl(memberChangeHistory, personnelSystemChangeNotification, memberFieldList) {
    var self = this;
    self.memberChangeHistory = memberChangeHistory;
    self.personnelSystemChangeNotification = personnelSystemChangeNotification;
    self.memberFieldList = memberFieldList;

    /*self.showHistory = function(version){

    };

    self.sendMail = function(eMail, version){

    };*/
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteAdd')
    .controller('InviteAddCtrl', InviteAddCtrl);

  /**
   * This controller handles the invite add logic
   * @method InviteAddCtrl
   * @memberOf module:App.Personnel.inviteAdd
   * @param {object} [$rootScope = injected] - The angularJS $rootScope
   * @param {object} [$scope = injected] - The angularJS $scope
   * @param {object} [clientApi = injected] - The clientApi
   * @param {object} [personnelOrgSelection = injected]
   * @param {object} [toastr = injected] - The toastr framework
   * @param {object} [$uibModal = injected] - The $uibModal framework
   * @param {object} [inviteCtx = injected] - The inviteCtx
   * @param {object} [authInfo = injected] - The authInfo
   * @param {object} [stateChangePrompt = injected]
   * @param {object} [commonUtils = injected]
   * @return {void}
   */

  /** @ngInject */
  function InviteAddCtrl($rootScope, $scope, $timeout, clientApi, personnelOrgSelection, toastr, $uibModal,
    inviteCtx, authInfo, $state, stateChangePrompt, commonUtils, orgType, $translate) {
    var self = this;

    $timeout(function() {
      self.isDemo = orgType && orgType.DemoOrg;
    })
    self.organizationId = $rootScope.ctx.organization.current.id;
    self.divisionId = _.cloneDeep(inviteCtx);

    self.orgLvl = false;
    self.divLvl = false;

    if (inviteCtx.indexOf('rootOrg') < 0) {
      self.divLvl = self.divisionId.splice(inviteCtx.indexOf('rootOrg'), 1)[0];
    } else {
      self.orgLvl = true;
    }

    self.utils = commonUtils;
    self.authInfo = authInfo;
    self.allowOrgSelection = personnelOrgSelection;
    self.openedDatepickerBirthDate = false;
    self.pageSize = 50;
    self.membersToAdd = [];
    self.membersToCheck = [];
    self.userChecked = false;

    stateChangePrompt.evaluate(function () {
      return !self.membersToAdd.length;
    });
    self.restartWizzard = function () {
      self.membersToAdd = [];
      self.membersToCheck = [];
      self.newUser = self.returnNewUserObject();
    };
    self.switchTab = function (userType) {
      self.newUser = self.returnNewUserObject(userType);
    };
    self.returnNewUserObject = function (userType) {
      if (userType) {
        self.userType = userType;
      }
      self.userChecked = false;
      return {
        Title: null,
        FirstName: null,
        LastName: null,
        Gender: null,
        ContactEMail: null,
        ZIP: null,
        City: null,
        Street: null,
        HouseNumber: null,
        AddressAffix: null,
        Phone: null,
        Mobile: null,
        MemberNumber: null,
        BirthDate: null,
        BirthLocation: null,
        MemberSince: null,
        Profession: null,
        BankAccount: null,
        BankIBAN: null,
        BankBIC: null,
        LastLoginAt: null,
        TermsAcceptedVersion: null,
        PrivacyTermsDeliveredDateTime: null,
        PrivacyTermsDeliveredPerson: null,
        PrivacyTermsDeliveredChannel: null,
        Account: {
          EMail: null,
          Type: self.userType
        },
        matches: [],
        inviteToDivisions: self.divLvl ? [self.divLvl] : false,
        inviteStatus: 0, // false wird nicht versendet weil grund, 0 wird versendet, 1 ist versendet, 2 is mitglied
      };
    };

    self.createUserObj = function (userData) {
      return _.merge(self.returnNewUserObject(), userData);
    };

    self.showDuplicates = function (member) {
      var inviteModal = $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/personnel/inviteAdd/modals/inviteData.html',
          size: 'lg',
          controller: 'InviteModalCtrl as $inviteDataCtrl',
          resolve: {
            member: function () {
              return member;
            },
          },
        });
      inviteModal.result.then(function (newMember) {
        if (newMember) {
          inviteModal.memberResult = newMember;
        }
        inviteModal.close();
      });
      return inviteModal.closed.then(function () {
        if (inviteModal.memberResult) {
          if (inviteModal.memberResult.notComplete) {
            self.addMissingData(inviteModal.memberResult);
          } else {
            self.membersToCheck.push(inviteModal.memberResult);
            self.handleMemberCheck();
          }
        } else {
          self.handleMemberCheck();
        }
      });
    };

    self.checkForDuplicates = function (user) {
      var userArr = [];
      if (!user.length) {
        userArr.push(user);
      } else {
        userArr = user;
      }
      return clientApi
        .custom('model/Account', 'findDuplicates', { memberArray: userArr, divId: parseInt(self.divLvl) })
        .then(function (memberList) {
          // auf Toastr prüfen, ggf einlade prozess beenden mit toastr einblendung!
          self.membersToCheck = memberList;
          self.handleMemberCheck();
        });
    };
    self.showMemberSelection = function () {
      var show = $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/personnel/inviteAdd/modals/showMemberData.html',
          size: 'lg',
          controller: 'ShowMemberDataCtrl as $showCtrl',
          resolve: {
            membersToAdd: function () {
              return self.membersToAdd;
            },
            initialInviteType: function () {
              return self.userType;
            }
          },
        });
      return show.result.then(function (list) {
        if (list) {
          self.createMembers();
        } else {
          self.restartWizzard();
        }
      });
    };
    self.handleMemberCheck = function (isBulk) {
      var markAsBulk = false;
      if(self.membersToCheck.length>1 || isBulk){
        // if there is more then one member in the que we assume an import so we'll skip to completion dialog
        markAsBulk = true;
      }
      if (self.membersToCheck.length > 0) {
        var memberToCheck = self.membersToCheck.splice(0, 1)[0];
        if (memberToCheck.notValid) {
          self.handleMemberCheck();
          return
        }
        if (!memberToCheck.matches || memberToCheck.matches.length === 0) {
          if (memberToCheck.notComplete && !markAsBulk) {
            // online/offline daten hinzufügen wenn single invite
            self.addMissingData(memberToCheck);
          } else {
            // Member ist sauber, wird zur finalen Liste hinzugefügt
            self.membersToAdd.push(memberToCheck);
            // schauen ob es weitere member in der que gibt
            self.handleMemberCheck(markAsBulk);
          }
        } else {
          // matches anzeigen
          self.showDuplicates(memberToCheck);
        }

      } else {
        if (self.membersToAdd.length > 0) {
          self.showMemberSelection();
        } else {
          toastr.info($translate.instant('modules.personnel.inviteList.noChangesText'),
            $translate.instant('modules.personnel.inviteList.noChangesTitle'));
          self.restartWizzard();
        }
      }
    };
    self.addMissingData = function (user) {
      if (user) {
        self.newUser = user;
      }
      if (user.FirstName && user.LastName) {
        var contactModal = $uibModal
          .open({
            backdrop: 'static',
            animation: true,
            templateUrl: 'app/theme/components/modals/contactPrivacyModal/contactPrivacyModal.html',
            size: 'mg',
            controller: 'ContactPrivacyModalCtrl as $contactPrivacyModalCtrl',
            resolve: {              
              data: {
                contact: self.newUser,
              },
              privacyTermDate: function () {
                return clientApi
                  .custom('model/PrivacyTerms', 'getLatest', { options: { onlyDate: true } })
              },
            }
          });
        contactModal.result.then(function (result) {
          if (result) {
            delete result.toastr;
            contactModal.memberResult = result;
          }
          contactModal.close();
        });
        return contactModal.closed.then(function () {
          if (contactModal.memberResult) {
            self.membersToAdd.push(contactModal.memberResult);
            self.handleMemberCheck();
          } else {
            self.handleMemberCheck();
          }
        });
      } else {
        toastr.error($translate.instant('modules.personnel.inviteList.addingErrToastText'),
          $translate.instant('modules.personnel.inviteList.addingErrToastTitle'));
      }
      return false;
    };

    self.createMembers = function () {
      var createFunc = function () {
        return clientApi
          .custom('model/Member', 'memberCreationBulk', { divisionId: inviteCtx, membersToAdd: self.membersToAdd })
          .then(function (result) {
            stateChangePrompt.disableEvaluation();
            if (result && result.successful && result.successful.length > 0) {
              toastr.info($translate.instant('modules.personnel.inviteList.createInfo1Text'), $translate.instant('modules.personnel.inviteList.createInfo1Title'));
            }
            if (!result || (result.failed && result.failed.length > 0)) {
              if (result && result.successful && result.successful.length > 0) {
                toastr.error($translate.instant('modules.personnel.inviteList.createErr1Text'),
                $translate.instant('modules.personnel.inviteList.createErr1Title'));
              } else {
                toastr.error($translate.instant('modules.personnel.inviteList.createErr2Text'),
                  $translate.instant('modules.personnel.inviteList.createErr2Title'));
              }
            } else if (result.successful && result.successful.length > 0) {
              toastr.success($translate.instant('modules.personnel.inviteList.createSuccText', { count: result.successful.length.toString() }),
                $translate.instant('modules.personnel.inviteList.createSuccTitle', { count: result.successful.length.toString() }));
            } else {
              toastr.info($translate.instant('modules.personnel.inviteList.noChangesText'),
                $translate.instant('modules.personnel.inviteList.noChangesTitle'));
            }
            $state.go('arno.personnel.inviteList', {}, { reload: true });
          })
          .catch(function () {
            toastr.error($translate.instant('modules.personnel.inviteList.createErr1Text'),
              $translate.instant('modules.personnel.inviteList.createErr1Title'));
            stateChangePrompt.disableEvaluation();
            $state.go('arno.personnel.inviteList', {}, { reload: true });
          });
      };
      createFunc();
    };
    self.excelImport = function (type) {
      self.switchTab(type);
      var importer = $uibModal.open({
        controller: 'InviteImportModalCtrl as $inviteImportModalCtrl',
        animation: true,
        templateUrl: 'app/pages/personnel/inviteAdd/modals/inviteImport.modal.html',
        size: 'md',
        resolve: {
          type: function () {
            return type;
          },
          ctx: function () {
            return inviteCtx;
          }
        }
      })
        .result
        .then(function (result) {
          var membersToImport = [];
          result.forEach(function (impMember) {
            var sortedMemberObj = impMember.Member;
            sortedMemberObj.Account = impMember.Account;
            sortedMemberObj.DivisionMember = impMember.DivisionMember;
            membersToImport.push(self.createUserObj(sortedMemberObj));
          });
          self.checkForDuplicates(membersToImport);
          importer.close();
        });
    };

    self.selectedADUser = function (user) {
      var member = user.Member;
      self.checkForDuplicates(self.createUserObj(member));
    };

    $scope.$watch(function () {
      return self.newUser;
    });

    if (!authInfo.ArnoAuth) {
      if (authInfo.Offline) {
        self.newUser = self.returnNewUserObject('offline');
      } else if (authInfo.AzureAuth) {
        self.newUser = self.returnNewUserObject('azure');
      }
    } else {
      self.newUser = self.returnNewUserObject('local');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteList', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.inviteList', {
        url: '/inviteList',
        templateUrl: 'app/pages/personnel/inviteList/inviteList.html',
        title: 'navigation.personnel.inviteList',

        controller: 'InviteListCtrl as $ctrl',
        resolve: {
          personnelOrgSelection: function ($rootScope, permissions) {
            return permissions.isPermittedInEvery('arno.personnel.inviteList.manage', 'Organization', [$rootScope.ctx.organization.current.id]);
          },
          inviteCtx: function (commonUtils, personnelOrgSelection) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: personnelOrgSelection,
              entryPermission: 'arno.personnel.inviteList.manage'
            });
          },
          authInfo: function ($rootScope, clientApi) {
            return clientApi.custom('model/Organization', 'getAuthInfo', {});
          },
        },
        sidebarMeta: {
          order: 2,
        },
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.inviteList')
    .controller('InviteListCtrl', InviteListCtrl);

  /** @ngInject */
  function InviteListCtrl($scope, $rootScope, $uibModal, $window, $log, $state, $translate,  commonUtils,
    clientApi, permissions, toastr, inviteCtx, organizationId, personnelOrgSelection, authInfo) {

    var self = this;
    var tableCtrl;
    self.utils = commonUtils;
    self.pageSize = 10;
    self.onlyDivisionSelection = true;
    self.ctx = inviteCtx;

    self.displayedCollection = [];

    self.aTBC = 'arno-tag-picker-tbl-header';

    self.isOrgList = inviteCtx.length === 1 && inviteCtx[0] === 'rootOrg';
    self.panelTitle = self.isOrgList ? $translate.instant('modules.personnel.inviteList.orgMember') : $translate.instant('modules.personnel.inviteList.divMember');
    self.allowOrgSelection = personnelOrgSelection;
    self.sort = {};
    self.sort.firstName = 'Member.FirstName';
    self.sort.lastName = 'Member.LastName';
    self.sort.birthDate = 'Member.BirthDate';
    self.sort.type = 'Member.Account.Type';
    self.sort.email = 'Member.Account.Email';
    self.sort.expiryDate = 'expirationDate';

    self.changePageSize = function(num) {
      self.pageSize = commonUtils.getPageSize('invite_list_page_size', num);
    }
    self.changePageSize();

    self.removeInvite = function (scope) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/inviteList/removeInvite.modal.html',
          size: 'md',
          scope: scope
        })
        .result
        .then(function () {
          return clientApi
            .custom('model/Invites', 'deleteInvite', { inviteId: scope.inviteEntry.id, inviteDivisionId: scope.inviteEntry.DivisionId });
        })
        .then(function () {
          toastr.success($translate.instant('modules.personnel.inviteList.removeInviteToastText', { member: scope.inviteEntry.Member.fullName }),
            $translate.instant('modules.personnel.inviteList.removeInviteToastTitle'));
          return self.reloadTable();
        });
    };

    self.reloadTable = function () {
      return self.getData(tableCtrl.tableState());
    };

    self.memberAdd = function () {
      if (authInfo.Offline && !authInfo.ArnoAuth && !authInfo.AzureAuth && !!~self.ctx.indexOf('rootOrg') && self.ctx.length === 1) {
        toastr.warning($translate.instant('modules.personnel.inviteList.memberAddWarnText'),
          $translate.instant('modules.personnel.inviteList.memberAddWarnTitle'));
      } else {
        $state.go('arno.personnel.inviteAdd');
      }
    };

    self.generateDateObj4SqlQuery = function (searchedDate, dateObjContainer) {
      /* TODO PRU -> expiration time soll aus der config kommen, nicht hardcoded */
      var day, month, year, tmpDate = 0;
      var pattern = /(.*?)\.(.*?)\.(\d{4})/;

      if (dateObjContainer.columnName === 'BirthDate') {
        tmpDate = new Date(searchedDate.replace(pattern, '$3-$2-$1'));
        day = tmpDate.getDate() - 1;
        month = tmpDate.getUTCMonth() + 1;
        year = tmpDate.getUTCFullYear();
        dateObjContainer.data = { day: day, month: month, year: year };
        dateObjContainer.activeSearch = true;
        return dateObjContainer;

      }
      var expirationTime = 1000 * 60 * 60 * 24 * 30;
      tmpDate = new Date(searchedDate.replace(pattern, '$3-$2-$1'));
      var timeDiff = tmpDate.getTime() - expirationTime;

      var targetDate = new Date(timeDiff);
      day = targetDate.getDate();
      month = targetDate.getUTCMonth() + 1;
      year = targetDate.getUTCFullYear();

      dateObjContainer.data = { day: day, month: month, year: year };
      dateObjContainer.activeSearch = true;
      return dateObjContainer;
    };

    self.getData = function (params, ctrl) {
      tableCtrl = ctrl || tableCtrl;

      params.pagination.numberOfPages = 0;

      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.pageSize || 0,
          limit: self.pageSize
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        }
      };

      if (self.ctx && (self.ctx.length || !Array.isArray(self.ctx))) {
        return clientApi
          .custom('model/Invites', 'findInvites', { ctx: self.ctx, queryWishes: queryWishes })
          .then(function (result) {
            if (result && result.count > 0) {
              params.pagination.numberOfPages = Math.ceil(result.count / self.pageSize);
              self.displayedCollection = result.rows;

              self.displayedCollection.map(function(invitation) {
                // ATM: the backend gives a date in not standardized format (e.g. 01/01/1970), so just quick format here and change later in backend
                invitation.expirationDateFormatted = moment(invitation.expirationDate).format('L');

                return invitation;
              });
            } else {
              params.pagination.numberOfPages = 0;
              self.displayedCollection = [];
            }
          })
          .catch(function () {
            params.pagination.numberOfPages = 0;
            self.displayedCollection = [];
            toastr.error($translate.instant('modules.personnel.inviteList.loadingErrToastText'),
              $translate.instant('modules.personnel.inviteList.loadingErrToastTitle'));
          });
      }
    };

    self.isPermitted = function (action, opt) {
      if (!opt || !opt.length) {
        return false;
      }
      var orgPermissionCheck = true;
      if (opt[0] === 'rootOrg') {
        orgPermissionCheck = permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id]);
      }
      if (opt.length > 1) {
        return orgPermissionCheck && permissions.isPermittedInEvery(action, 'Division', opt.slice(1))
      }
      return orgPermissionCheck;
    };

    self.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

  }
})();
/* eslint-disable max-len */
/**
 * Created by dirk.roessler on 05.04.2017.
 */
(function () {
  'use strict';
  angular
    .module('BlurAdmin.pages.personnel.dossier', [
      'BlurAdmin.pages.personnel.dossier.baseData',
      'BlurAdmin.pages.personnel.dossier.qualification',
      'BlurAdmin.pages.personnel.dossier.notAssigned',
      'BlurAdmin.pages.personnel.dossier.clearance',
      'BlurAdmin.pages.personnel.dossier.activity',
      'BlurAdmin.pages.personnel.dossier.overview',
      'BlurAdmin.pages.personnel.dossier.trainings',
      'BlurAdmin.pages.personnel.dossier.administration',
      'BlurAdmin.pages.personnel.dossier.fileStorage',
      'BlurAdmin.pages.personnel.dossier.helperHours',
    ])
    .config(routeConfig)
    .value('historyEventMap', {
      'ACTIVITY_PERIOD_ALLOCATION': {
        label: '{{ ("modules.personnel.dossier.history.activityPeriodAllocation" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate2" | translate) }} ',
        tags: function (data) {
          if (data.updatedPeriods && data.updatedPeriods.length) {
            var deleted = data.updatedPeriods.filter(function (period) {
              return period.pendingDelete;
            }).length;
            var checkedUpdated = data.updatedPeriods.filter(function (period) {
              return period.id;
            }).length;
            var created = data.updatedPeriods.length - (deleted + checkedUpdated);
            var result = [];
            if (deleted) {
              result.push({
                type: 'danger',
                label: deleted + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate6" | translate) }}' + (deleted > 1 ? 'n' : '') + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate3" | translate) }}'
              });
            }
            if (checkedUpdated) {
              result.push({
                type: 'info',
                label: checkedUpdated + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate6" | translate) }}' + (checkedUpdated > 1 ? 'n' : '') + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate4" | translate) }}'
              });
            }
            if (created) {
              result.push({
                type: 'success',
                label: created + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate6" | translate) }}' + (created > 1 ? 'n' : '') + '{{ ("modules.personnel.dossier.history.activityPeriodAllocationTemplate5" | translate) }}'
              });
            }
            return result;
          }
          return [];
        },
      },
      'BLOCKAGE_TRIGGERED': {
        label: '{{ ("modules.personnel.dossier.history.blockageTriggered" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.blockageTriggeredTemplate" | translate) }} "<strong>{{data.SelectedReasonName}}</strong>". <span ng-if="data.ReasonComment">{{ ("modules.personnel.dossier.history.blockageTriggeredTemplate2" | translate) }} <strong>{{ data.ReasonComment }}</strong></span>',
        tags: function () {
          return [
            { type: 'primary', label: '{{ ("modules.personnel.dossier.history.blockageTriggeredTemplate3" | translate) }}' }
          ];
        },
      },
      'BLOCKAGE_CANCELED': {
        label: '{{ ("modules.personnel.dossier.history.blockageCanceled" | translate) }}',
        logTemplate: '<span ng-if="data.ReasonComment">{{ ("modules.personnel.dossier.history.blockageCanceledTemplate" | translate) }} "<strong>{{data.ReasonComment}}</strong>".</span>',
        tags: function () {
          return [
            { type: 'success', label: '{{ ("modules.personnel.dossier.history.blockageCanceledTemplate2" | translate) }}' }
          ];
        },
      },
      'WITHDRAWAL_TRIGGERED': {
        label: '{{ ("modules.personnel.dossier.history.withdrawalTriggered" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.withdrawalTriggeredTemplate" | translate) }} "<strong>{{data.SelectedReasonName}}</strong>". <span ng-if="data.ReasonComment">{{ ("modules.personnel.dossier.history.withdrawalTriggeredTemplate2" | translate) }} <strong>{{ data.ReasonComment }}</strong></span>',
        tags: function () {
          return [
            { type: 'primary', label: '{{ ("modules.personnel.dossier.history.withdrawalTriggeredTemplate3" | translate) }}' }
          ];
        },
      },
      'WITHDRAWAL_CANCELED': {
        label: '{{ ("modules.personnel.dossier.history.withdrawalCanceled" | translate) }}',
        logTemplate: '<span ng-if="data.ReasonComment">{{ ("modules.personnel.dossier.history.withdrawalCanceledTemplate" | translate) }} "<strong>{{data.ReasonComment}}</strong>".</span>',
        tags: function () {
          return [
            { type: 'success', label: '{{ ("modules.personnel.dossier.history.withdrawalCanceledTemplate2" | translate) }}' }
          ];
        },
      },
      'WITHDRAWAL_PROCESSED': {
        label: '{{ ("modules.personnel.dossier.history.withdrawal_processed" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.withdrawal_processedTemplate" | translate) }} {{ data.DeletionTargetDate | date:"dd.MM.yyyy" }}',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.withdrawal_processedTemplate2" | translate) }}' }
          ];
        },
      },

      'ACTIVITY_ALLOCATION': {
        label: '{{ ("modules.personnel.dossier.history.activity_allocation" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_allocationTemplate" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_allocationTemplate2" | translate) }} ',
      },
      'ACTIVITY_ALLOCATION_GROUP': {
        label: '{{ ("modules.personnel.dossier.history.activity_allocation_group" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_allocation_group_template1" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_allocation_group_template2" | translate) }} "<strong>{{data.MemberGroup}}</strong>" {{ ("modules.personnel.dossier.history.activity_allocation_group_template3" | translate) }}',
      },
      'ACTIVITY_ALLOCATION_DELETE': {
        label: '{{ ("modules.personnel.dossier.history.activity_allocation_delete" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_allocation_deleteTemplate" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_allocation_deleteTemplate2" | translate) }} ',
      },
      'ACTIVITY_PERIOD_GROUP_FINISH': {
        label: '{{ ("modules.personnel.dossier.history.activity_period_group_finish" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_period_group_finish_template1" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_period_group_finish_template2" | translate) }} "<strong>{{data.MemberGroup}}</strong>" {{ ("modules.personnel.dossier.history.activity_period_group_finish_template3" | translate) }}',
      },
      'ACTIVITY_PERIOD_GROUP_RESTART': {
        label: '{{ ("modules.personnel.dossier.history.activity_period_group_restart" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_period_group_restart_template1" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_period_group_restart_template2" | translate) }} "<strong>{{data.MemberGroup}}</strong>" {{ ("modules.personnel.dossier.history.activity_period_group_restart_template3" | translate) }}',
      },
      'ACTIVITY_CHARACTERISTIC_GROUP_UPGRADE': {
        label: '{{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade_template1" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade_template2" | translate) }} "<strong>{{data.OldCharacteristic}}</strong>" {{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade_template3" | translate) }} "<strong>{{data.Characteristic}}</strong>" {{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade_template4" | translate) }} "<strong>{{data.memberGroup}}</strong>" {{ ("modules.personnel.dossier.history.activity_characteristic_group_upgrade_template5" | translate) }}',
        dataHelper: function (data, $injector) {
          var charMap = $injector.get('characteristicMap');
          data.OldCharacteristic = charMap[data.OldCharacteristic];
          data.Characteristic = charMap[data.Characteristic];
        },
      },
      'ACTIVITY_CHARACTERISITC_ALLOCATION': {
        label: '{{ ("modules.personnel.dossier.history.activity_characterisitc_allocation" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.activity_characterisitc_allocationTemplate" | translate) }} "<strong>{{data.ActivityTitle}}</strong>" {{ ("modules.personnel.dossier.history.activity_characterisitc_allocationTemplate2" | translate) }} "{{data.mappedCharacteristic}}" {{ ("modules.personnel.dossier.history.activity_characterisitc_allocationTemplate3" | translate) }} ',
        dataHelper: function (data, $injector) {
          var charMap = $injector.get('characteristicMap');
          data.mappedCharacteristic = charMap[data.Characteristic];
          data.MappedCharacteristic = data.mappedCharacteristic;
          data.mappedCharacteristic = data.mappedCharacteristic.charAt(0).toLocaleLowerCase() + data.mappedCharacteristic.slice(1);
        },
        tags: function (data) {
          return [
            { type: 'info', label: data.MappedCharacteristic }
          ];
        },
      },
      'FILE_UPLOAD': {
        label: '{{ ("modules.personnel.dossier.history.file_upload" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.file_deleteTemplate" | translate) }} "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) {{ ("modules.personnel.dossier.history.file_deleteTemplate2" | translate) }} "<strong>{{data.Folder}}</strong>" {{ ("modules.personnel.dossier.history.file_uploadTemplate" | translate) }} ',
        tags: function () {
          return [
            { type: 'success', label: '{{ ("modules.personnel.dossier.history.file_uploadTemplate2" | translate) }}' }
          ];
        },
      },
      'FILE_OVERWRITE': {
        label: '{{ ("modules.personnel.dossier.history.file_overwrite" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.file_deleteTemplate" | translate) }} "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) {{ ("modules.personnel.dossier.history.file_deleteTemplate2" | translate) }} "<strong>{{data.Folder}}</strong>" {{ ("modules.personnel.dossier.history.file_overwriteTemplate" | translate) }} ',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.file_overwriteTemplate2" | translate) }}' }
          ];
        },
      },
      'FILE_DELETE': {
        label: '{{ ("modules.personnel.dossier.history.file_delete" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.file_deleteTemplate" | translate) }} "<strong>{{data.FileName}}</strong>" ({{(data.FileSize / 1024 / 1024).toFixed(2)}} MB) {{ ("modules.personnel.dossier.history.file_deleteTemplate2" | translate) }} "<strong>{{data.Folder}}</strong>" {{ ("modules.personnel.dossier.history.file_deleteTemplate3" | translate) }} ',
        tags: function () {
          return [
            { type: 'danger', label: '{{ ("modules.personnel.dossier.history.file_deleteTemplate4" | translate) }}' }
          ];
        },
      },
      'FILE_RENAME': {
        label: '{{ ("modules.personnel.dossier.history.file_rename" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.file_renameTemplate" | translate) }} "<strong>{{data.OldName}}</strong>" {{ ("modules.personnel.dossier.history.file_renameTemplate2" | translate) }} "<strong>{{data.Folder}}</strong>" {{ ("modules.personnel.dossier.history.file_renameTemplate3" | translate) }} "<strong>{{data.NewName}}</strong>" {{ ("modules.personnel.dossier.history.file_renameTemplate4" | translate) }} ',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.file_renameTemplate5" | translate) }}' }
          ];
        },
      },
      // TRAININGS-SPECIFIC LOGS
      'TRAINING_CREATE': {
        label: '{{ ("modules.personnel.dossier.history.training_create" | translate) }}',
        logTemplate: '"<strong>{{data.Name}}</strong>" {{ ("modules.personnel.dossier.history.training_createTemplate" | translate) }}',
        tags: function () {
          return [
            { type: 'success', label: '{{ ("modules.personnel.dossier.history.training_createTemplate2" | translate) }}' },
          ];
        },
        dataHelper: function () {
        }
      },
      'TRAINING_UPDATE': {
        label: '{{ ("modules.personnel.dossier.history.training_update" | translate) }}',
        logTemplate: '"<strong>{{data.Name}}</strong>" {{ ("modules.personnel.dossier.history.training_updateTemplate" | translate) }}',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.training_updateTemplate2" | translate) }}' },
          ];
        },
        dataHelper: function () {
        }
      },
      'TRAINING_CREATED_STATUS_PENDING': {
        label: '{{ ("modules.personnel.dossier.history.training_created_status_pending" | translate) }}',
        logTemplate: '"<strong>{{data.Name}}</strong>" {{ ("modules.personnel.dossier.history.training_created_status_pendingTemplate" | translate) }}',
        tags: function () {
          return [
            { type: 'warning', label: '{{ ("modules.personnel.dossier.history.training_created_status_pendingTemplate2" | translate) }}' }
          ];
        },
        dataHelper: function () {
        }
      },
      'TRAINING_STATUS_PENDING': {
        label: '{{ ("modules.personnel.dossier.history.training_status_pending" | translate) }}',
        logTemplate: '"<strong>{{data.Name}}</strong>" {{ ("modules.personnel.dossier.history.training_status_pendingTemplate" | translate) }}',
        tags: function () {
          return [
            { type: 'warning', label: '{{ ("modules.personnel.dossier.history.training_status_pendingTemplate2" | translate) }}' }
          ];
        },
        dataHelper: function () {
        }
      },
      'TRAINING_DELETE': {
        label: '{{ ("modules.personnel.dossier.history.training_delete" | translate) }}',
        logTemplate: '"<strong>{{data.Name}}</strong>" {{ ("modules.personnel.dossier.history.training_delete" | translate) }}',
        tags: function () {
          return [
            { type: 'danger', label: '{{ ("modules.personnel.dossier.history.training_deleteTemplate2" | translate) }}' }
          ];
        },
        dataHelper: function () {
        }
      },
      'MEMBER_DIVISIONMEMBER_BASEDATA_UPDATE': {
        label: 'Personalstammdaten geändert',
        logTemplate: '{{data.displayData}}',
        tags: function (data) {
          data.count = 0;
          if (data.Changes && data.Changes.toMember) {
            data.count += data.Changes.toMember.changeCount;
          }
          if (data.Changes && data.Changes.toDivisionMember) {
            data.count += data.Changes.toDivisionMember.changeCount;
          }
          return [{ type: 'info', label: data.count + ' Änderungen' }];
        },
        dataHelper: function (data, $injector) {
          data.displayData = null;
          function displayChanges(modelName, changesObj) {
            var returnString = '';
            for (var key in changesObj) {
              if (changesObj[key] && _.isObject(changesObj[key])) {
                if (_.isArray(changesObj[key])) {
                  var arrayChanges = '';
                  _.forEach(changesObj[key], function (item) {
                    var model = null;
                    var modelI18n = null;
                    switch (key) {
                    case 'EmergencyContacts':
                      model = 'EmergencyContact';
                      if (item.DeclarationofConsent) {
                        if (item.DeclarationofConsent.oldVal === 0 || item.DeclarationofConsent.oldVal === '0') {
                          item.DeclarationofConsent.oldVal = $translate.instant('models.EmergencyContact.DeclarationofConsent.notGiven');
                        }

                        if (item.DeclarationofConsent.newVal === 0 || item.DeclarationofConsent.newVal === '0') {
                          item.DeclarationofConsent.newVal = $translate.instant('models.EmergencyContact.DeclarationofConsent.notGiven');
                        }

                        if (item.DeclarationofConsent.oldVal === 1 || item.DeclarationofConsent.oldVal === '1') {
                          item.DeclarationofConsent.oldVal = $translate.instant('models.EmergencyContact.DeclarationofConsent.given');
                        }

                        if (item.DeclarationofConsent.newVal === 1 || item.DeclarationofConsent.newVal === '1') {
                          item.DeclarationofConsent.newVal = $translate.instant('models.EmergencyContact.DeclarationofConsent.given');
                        }
                      }
                      modelI18n = $translate.instant('models.' + model);
                      break;
                    case 'LanguageSkills':
                      model = 'LanguageSkill';
                      modelI18n = $translate.instant('models.' + model);
                      break;
                    default:
                      model = null;
                      modelI18n = null;
                    }
                    if (item) {
                      var i18nModelName = modelI18n || key;
                      if (item.hasOwnProperty('objectId')) {
                        var itemChangesString = displayChanges(model, item);
                        arrayChanges += (arrayChanges ? '; ' : '') + i18nModelName + ' [' + item.objectId + ']: (' + itemChangesString + ')';
                      }
                      else {
                        if (item.newVal && _.isObject(item.newVal)) {
                          arrayChanges += (arrayChanges ? '; ' : '') + i18nModelName + ' [' + $translate.instant('modules.personnel.dossier.history.new') + ']: (';
                          var newValChanges = '';
                          for (var attribute in item.newVal) {
                            if (attribute !== 'MemberId') {
                              var attrTranslated = $translate.instant('models.' + model + '.' + attribute);
                              var newVal = (item.newVal[attribute] || item.newVal[attribute] === false) ? item.newVal[attribute] : null;
                              if (newVal) {
                                var newValTranslated = $translate.instant('models.' + model + '.' + attribute + '.' + newVal);
                                newVal = newValTranslated.includes('models.' + model + '.' + attribute) ? newVal : newValTranslated;
                                newVal = (isNaN(newVal) && moment(newVal, moment.ISO_8601, true).isValid()) ? moment(new Date(newVal)).format('DD.MM.YYYY') : newVal;
                                newVal = ('"' + newVal + '"');
                              }
                              else {
                                newVal = '<' + $translate.instant('modules.personnel.dossier.history.nothing') + '>';
                              }
                              newValChanges += (newValChanges ? ', ' : '') + attrTranslated + '=' + newVal;
                            }
                          }
                          arrayChanges += newValChanges + ')';
                        }
                        else if (item.oldVal && _.isObject(item.oldVal)) {
                          arrayChanges += (arrayChanges ? '; ' : '') + i18nModelName + ' [' + $translate.instant('modules.personnel.dossier.history.removed') + ']: (';
                          var oldValChanges = '';
                          for (var attr in item.oldVal) {
                            if (attr !== 'MemberId') {
                              var attrTrans = $translate.instant('models.' + model + '.' + attr);
                              var oldVal = (item.oldVal[attr] || item.oldVal[attr] === false) ? item.oldVal[attr] : null;
                              if (oldVal) {
                                var oldValTranslated = $translate.instant('models.' + model + '.' + attr + '.' + oldVal);
                                oldVal = oldValTranslated.includes('models.' + model + '.' + attr) ? oldVal : oldValTranslated;
                                oldVal = (isNaN(oldVal) && moment(oldVal, moment.ISO_8601, true).isValid()) ? moment(new Date(oldVal)).format('DD.MM.YYYY') : oldVal;
                                oldVal = ('"' + oldVal + '"');
                              }
                              else {
                                oldVal = '<' + $translate.instant('modules.personnel.dossier.history.nothing') + '>';
                              }
                              oldValChanges += (oldValChanges ? ', ' : '') + attrTrans + '=' + oldVal;
                            }
                          }
                          arrayChanges += oldValChanges + ')';
                        }
                      }
                    }
                  });
                  if (returnString) {
                    returnString = arrayChanges ? returnString += '; ' + arrayChanges : returnString;
                  } else {
                    returnString = arrayChanges ? arrayChanges : returnString;
                  }
                }
                else {
                  if (changesObj[key].hasOwnProperty('oldVal') && changesObj[key].hasOwnProperty('newVal')) {
                    var property = $translate.instant('models.' + modelName + '.' + key);
                    var oldVal = null;
                    var newVal = null;
                    if (key === 'MemberStatus') {
                      if (changesObj[key].newVal) {
                        newVal = changesObj[key].newVal.split(';').map(function (val) {
                          var translatedVal = $translate.instant('models.' + modelName + '.' + key + '.' + val);
                          return translatedVal.includes('models.' + modelName + '.' + key) ? val : translatedVal;
                        }).join(';');
                      }
                      if (changesObj[key].oldVal) {
                        oldVal = changesObj[key].oldVal.split(';').map(function (val) {
                          var translatedVal = $translate.instant('models.' + modelName + '.' + key + '.' + val);
                          return translatedVal.includes('models.' + modelName + '.' + key) ? val : translatedVal;
                        }).join(';');
                      }
                    }
                    else {
                      oldVal = (changesObj[key].oldVal || changesObj[key].oldVal === false) ? changesObj[key].oldVal : null;
                      if (oldVal) {
                        var oldValTranslated = $translate.instant('models.' + modelName + '.' + key + '.' + oldVal);
                        oldVal = oldValTranslated.includes('models.' + modelName + '.' + key) ? oldVal : oldValTranslated;
                        oldVal = (isNaN(oldVal) && moment(oldVal, moment.ISO_8601, true).isValid()) ? moment(new Date(oldVal)).format('DD.MM.YYYY') : oldVal;
                      }
                      else {
                        oldVal = '<' + $translate.instant('modules.personnel.dossier.history.nothing') + '>';
                      }
                      newVal = (changesObj[key].newVal || changesObj[key].newVal === false) ? changesObj[key].newVal : null;
                      if (newVal) {
                        var newValTranslated = $translate.instant('models.' + modelName + '.' + key + '.' + newVal);
                        newVal = newValTranslated.includes('models.' + modelName + '.' + key) ? newVal : newValTranslated;
                        newVal = (isNaN(newVal) && moment(newVal, moment.ISO_8601, true).isValid()) ? moment(new Date(newVal)).format('DD.MM.YYYY') : newVal;
                      }
                      else {
                        newVal = '<' + $translate.instant('modules.personnel.dossier.history.nothing') + '>';
                      }
                    }
                    oldVal = ('"' + oldVal + '"');
                    newVal = ('"' + newVal + '"');
                    if (newVal !== oldVal) {
                      returnString += (returnString ? '; ' : '') + property + ': ' + oldVal + ' --> ' + newVal;
                    }
                  }
                }
              }
            }
            return returnString;
          }
          var $translate = $injector.get('$translate');
          if (data.Changes && data.Changes.toMember && data.Changes.toMember.changeCount > 0) {
            data.displayData = data.displayData ? data.displayData + '; ' + displayChanges('Member', data.Changes.toMember, null) : displayChanges('Member', data.Changes.toMember);
          }
          if (data.Changes && data.Changes.toDivisionMember && data.Changes.toDivisionMember.changeCount > 0) {
            data.displayData = data.displayData ? data.displayData + '; ' + displayChanges('DivisionMember', data.Changes.toDivisionMember, null) : displayChanges('DivisionMember', data.Changes.toDivisionMember);
          }
        },
      },
      'ACCOUNT_TYPE_CHANGED': {
        label: '{{ ("modules.personnel.dossier.history.account_type_changed" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.account_type_changedTemplate" | translate) }} "<strong>{{data.fromType}}</strong>" {{ ("modules.personnel.dossier.history.account_type_changedTemplate2" | translate) }} "<strong>{{data.toType}}</strong>".',
        dataHelper: function (data) {
          var typeMap = {
            offline: 'Offline',
            local: 'Arno',
            azure: 'Azure',
          };
          data.fromType = typeMap[data.From];
          data.toType = typeMap[data.To];
        },
      },

      // MISC LOGS

      'QUALIFICATION_ADDED': {
        label: '{{ (\'modules.personnel.dossier.history.qualification_added\' | translate) }}',
        logTemplate: '{{ data.template }}',
        dataHelper: function (data, $injector) {
          var $translate = $injector.get('$translate');
          data.template = $translate.instant('modules.personnel.dossier.history.qualification_addedTemplate', { name: data.Name, group: data.Group, typeSingular: $translate.instant('modules.administration.adminQualification.' + (data.QualificationType || 'qualification')) });
        }
      },

      'QUALIFICATION_UPDATED': {
        label: '{{ (\'modules.personnel.dossier.history.qualification_updated\' | translate) }}',
        logTemplate: '{{ data.template }}',
        dataHelper: function (data, $injector) {
          var $translate = $injector.get('$translate');
          data.template = $translate.instant('modules.personnel.dossier.history.qualification_updatedTemplate', { name: data.Name, group: data.Group, typeSingular: $translate.instant('modules.administration.adminQualification.' + (data.QualificationType || 'qualification')) });
        }
      },

      'QUALIFICATION_DELETED': {
        label: '{{ (\'modules.personnel.dossier.history.qualification_deleted\' | translate) }}',
        logTemplate: '{{ data.template }}',
        dataHelper: function (data, $injector) {
          var $translate = $injector.get('$translate');
          data.template = $translate.instant('modules.personnel.dossier.history.qualification_deletedTemplate', { name: data.Name, group: data.Group, typeSingular: $translate.instant('modules.administration.adminQualification.' + (data.QualificationType || 'qualification')) });
        }
      },

      'QUALIFICATION_REMOVED': {
        label: '{{ (\'modules.personnel.dossier.history.qualification_removed\' | translate) }}',
        logTemplate: '{{ data.template }}',
        dataHelper: function (data, $injector) {
          var $translate = $injector.get('$translate');
          data.template = $translate.instant('modules.personnel.dossier.history.qualification_removedTemplate', { name: data.Name, group: data.Group, typeSingular: $translate.instant('modules.administration.adminQualification.' + (data.QualificationType || 'qualification')) });
        }
      },

      'PRIVACY_ACCEPTED_FOR_OFFLINE_USER': {
        label: '{{ (\'modules.personnel.dossier.history.privacy_accepted_for_offline_user\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.privacy_accepted_for_offline_user" | translate) }} <span ng-if="data.PrivacyLocation"> {{ ("modules.personnel.dossier.history.privacy_accepted_for_offline_userTemplate2" | translate) }} {{data.PrivacyLocation}}</span> ',
      },

      'PRIVACY_TERMS_ACCEPTED_FOR_OFFLINE_USER': {
        label: '{{ ("modules.personnel.dossier.history.privacy_terms_accepted_for_offline_user" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.privacy_terms_accepted_for_offline_userTemplate" | translate) }} ' +
          '<span ng-if="data.PrivacyTermsDeliveredDateTime">{{ ("modules.personnel.dossier.history.privacy_terms_accepted_for_offline_userTemplate2" | translate) }} {{moment(data.PrivacyTermsDeliveredDateTime).format(\'DD.MM.YYYY - HH:mm\')}}</span> ' +
          '<span ng-if="data.PrivacyTermsDeliveredPerson">{{ ("modules.personnel.dossier.history.privacy_terms_accepted_for_offline_userTemplate3" | translate) }} {{data.PrivacyTermsDeliveredPerson}}</span> ' +
          '<span ng-if="data.PrivacyTermsDeliveredChannel">{{ ("modules.personnel.dossier.history.privacy_terms_accepted_for_offline_userTemplate4" | translate) }} {{data.PrivacyTermsDeliveredChannel}}</span>.',
      },
      'HELPER_HOURS_ADD': {
        label: '{{ ("modules.personnel.dossier.history.helper_hours_add" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.helper_hours_addTemplate" | translate) }} "<strong>{{data.title}}</strong>" {{ ("modules.personnel.dossier.history.helper_hours_addTemplate2" | translate) }} '
          + '<strong>{{((data.minutes / 60).toString().split(".")[0] + ":" + (data.minutes % 60 < 10 ? "0" : "") + data.minutes % 60)}}</strong> {{ ("modules.personnel.dossier.history.helper_hours_addTemplate3" | translate) }} '
          + '{{ ("modules.personnel.dossier.history.helper_hours_addTemplate4" | translate) }} <strong>{{data.date | date:"dd.MM.yyyy"}}</strong> {{(data.activity ? (("modules.personnel.dossier.history.helper_hours_addTemplate5" | translate) + data.activity + ("modules.personnel.dossier.history.helper_hours_addTemplate6" | translate)) : ("modules.personnel.dossier.history.helper_hours_addTemplate6" | translate))}} ',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.helper_hours_addTemplate7" | translate) }}' }
          ];
        },
      },
      'HELPER_HOURS_EDIT': {
        label: '{{ ("modules.personnel.dossier.history.helper_hours_edit" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.helper_hours_editTemplate" | translate) }} "<strong>{{data.oldTitle}}</strong>" {{ (data.newTitle ? ("modules.personnel.dossier.history.helper_hours_editTemplate2" | translate) + data.newTitle + \'")\': "" ) }} {{ ("modules.personnel.dossier.history.helper_hours_editTemplate3" | translate) }}',
        tags: function () {
          return [
            { type: 'info', label: '{{ ("modules.personnel.dossier.history.helper_hours_editTemplate4" | translate) }}' }
          ];
        },
      },
      'HELPER_HOURS_DELETE': {
        label: '{{ ("modules.personnel.dossier.history.helper_hours_delete" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.helper_hours_deleteTemplate" | translate) }} "<strong>{{data.title}}</strong>" {{ ("modules.personnel.dossier.history.helper_hours_deleteTemplate2" | translate) }}',
        tags: function () {
          return [
            { type: 'danger', label: '{{ ("modules.personnel.dossier.history.helper_hours_deleteTemplate3" | translate) }}' }
          ];
        },
      },
      'HELPER_HOURS_APPROVED': {
        label: '{{ ("modules.personnel.dossier.history.helper_hours_approved" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.helper_hours_approvedTemplate" | translate) }} "<strong>{{data.title}}</strong>" {{ ("modules.personnel.dossier.history.helper_hours_approvedTemplate2" | translate) }}',
        tags: function () {
          return [
            { type: 'success', label: '{{ ("modules.personnel.dossier.history.helper_hours_approvedTemplate3" | translate) }}' }
          ];
        },
      },
      'HELPER_HOURS_DENIED': {
        label: '{{ ("modules.personnel.dossier.history.helper_hours_denied" | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.helper_hours_deniedTemplate" | translate) }} "<strong>{{data.title}}</strong>" {{ ("modules.personnel.dossier.history.helper_hours_deniedTemplate2" | translate) }}',
        tags: function () {
          return [
            { type: 'danger', label: '{{ ("modules.personnel.dossier.history.helper_hours_deniedTemplate3" | translate) }}' }
          ];
        },
      },
      'APPROVALALLOCATION_CREATE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_create\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_createTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_createTemplate2" | translate) }} ',
      },
      'APPROVALALLOCATION_UPDATE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_update\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_updateTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_updateTemplate2" | translate) }} {{data.Inspection && data.Inspection.fieldValue ? (data.Inspection.fieldName ? data.Inspection.fieldName + ": " : ("modules.personnel.dossier.history.inspection" | translate)) + data.Inspection.fieldValue  : "" }}{{data.Resubmission && data.Resubmission.fieldValue ? ";" : ""}} {{data.Resubmission && data.Resubmission.fieldValue ? (data.Resubmission && data.Resubmission.fieldName ? data.Resubmission.fieldName + ": " : ("modules.personnel.dossier.history.resub" | translate)) + data.Resubmission.fieldValue : "" }}',
      },
      'APPROVALALLOCATION_PAUSE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_pause\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_pauseTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_pauseTemplate2" | translate) }} {{data.Inspection && data.Inspection.fieldValue ? (data.Inspection.fieldName ? data.Inspection.fieldName + ": " : ("modules.personnel.dossier.history.inspection" | translate)) + data.Inspection.fieldValue  : "" }}{{data.Resubmission && data.Resubmission.fieldValue ? ";" : ""}} {{data.Resubmission && data.Resubmission.fieldValue ? (data.Resubmission && data.Resubmission.fieldName ? data.Resubmission.fieldName + ": " : ("modules.personnel.dossier.history.resub" | translate)) + data.Resubmission.fieldValue : "" }}',
      },
      'APPROVALALLOCATION_CONTINUE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_continue\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_continueTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_continueTemplate2" | translate) }} {{data.Inspection && data.Inspection.fieldValue ? (data.Inspection.fieldName ? data.Inspection.fieldName + ": " : ("modules.personnel.dossier.history.inspection" | translate)) + data.Inspection.fieldValue  : "" }}{{data.Resubmission && data.Resubmission.fieldValue ? ";" : ""}} {{data.Resubmission && data.Resubmission.fieldValue ? (data.Resubmission && data.Resubmission.fieldName ? data.Resubmission.fieldName + ": " : ("modules.personnel.dossier.history.resub" | translate)) + data.Resubmission.fieldValue : "" }}',
      },
      'APPROVALALLOCATION_DELETE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_delete\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_deleteTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_deleteTemplate2" | translate) }} {{data.Inspection && data.Inspection.fieldValue ? (data.Inspection.fieldName ? data.Inspection.fieldName + ": " : ("modules.personnel.dossier.history.inspection" | translate)) + data.Inspection.fieldValue  : "" }}{{data.Resubmission && data.Resubmission.fieldValue ? ";" : ""}} {{data.Resubmission && data.Resubmission.fieldValue ? (data.Resubmission && data.Resubmission.fieldName ? data.Resubmission.fieldName + ": " : ("modules.personnel.dossier.history.resub" | translate)) + data.Resubmission.fieldValue : "" }}',
      },
      'APPROVALALLOCATION_REMOVE': {
        label: '{{ (\'modules.personnel.dossier.history.approvalallocation_remove\' | translate) }}',
        logTemplate: '{{ ("modules.personnel.dossier.history.approvalallocation_removeTemplate1" | translate) }} "<strong>{{data.ApprovalTitle}}</strong>" {{ ("modules.personnel.dossier.history.approvalallocation_removeTemplate2" | translate) }} {{data.Inspection && data.Inspection.fieldValue ? (data.Inspection.fieldName ? data.Inspection.fieldName + ": " : ("modules.personnel.dossier.history.inspection" | translate)) + data.Inspection.fieldValue  : "" }}{{data.Resubmission && data.Resubmission.fieldValue ? ";" : ""}} {{data.Resubmission && data.Resubmission.fieldValue ? (data.Resubmission && data.Resubmission.fieldName ? data.Resubmission.fieldName + ": " : ("modules.personnel.dossier.history.resub" | translate)) + data.Resubmission.fieldValue : "" }}',
      },
    })
    .value('privacyTermsChannelMap', {
      'IN_PERSON': 'Persönlich',
      'POSTAL': 'Postalisch',
      'E_MAIL_EXT': 'E-Mail (extern versandt)',
      'E_MAIL_ARNO': 'E-Mail (via ARNO)',
      'ONLINE': 'ARNO (Selbstabruf)'
    });

  var dynamicDossierTitle = function (transition) {
    var member = transition.injector().get('member');
    var isOrg = transition.injector().get('ctx')[0] === 'rootOrg';
    var result = isOrg ? 'navigation.personnel.dossier.organization' : 'navigation.personnel.dossier.division';
    if (member && member.fullName) {
      result = {
        title: result,
        params: {
          user: ' - ' + member.fullName
        }
      };
    }
    return result;
  };

  var permittedToStartAnyClearance = function (ctx, isOrgScope, ArnoDashAdminClearancesService, commonUtils, permissions) {
    if (isOrgScope) {
      return Promise.resolve(false);
    }
    var allowStartPerm;
    var hasStartSimpleClearancePerm;
    return ArnoDashAdminClearancesService.getApprovalStartAndEditReferences(ctx)
      .then(function (result) {
        _.assign(self.allowedReferences, result);
        allowStartPerm = !!Object.keys(result['arno.item.approval.start'] || {}).filter(function (division) {
          return result['arno.item.approval.start'][division] && result['arno.item.approval.start'][division].length;
        }).length;
      })
      .then(function () {
        hasStartSimpleClearancePerm = permissions.isPermittedInEvery('arno.personnel.clearance.start.simple', 'Division', ctx);
      })
      .then(function () {
        return allowStartPerm || hasStartSimpleClearancePerm;
      });
  };

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.dossier', {
        abstract: true,
        url: '/dossier/:memberEMail?scope',
        templateUrl: 'app/pages/personnel/dossier/dossier.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierCtrl as $dossier',
        resolve: {
          divisionSelectorEntryPermission: function () {
            return 'Division:arno.personnel.dossier,Organization:arno.personnel.dossier';
          },
          isOwnDossier: function ($stateParams, $rootScope) {
            return $stateParams.memberEMail === $rootScope.ctx.currentUser.eMail;
          },
          ctx: function (commonUtils, $stateParams, isOwnDossier, divisionSelectorEntryPermission) {
            if ($stateParams.scope === 'org') {
              return ['rootOrg'];
            }
            if (isOwnDossier) {
              return commonUtils.division.getCtx({
                multiple: false,
                namespace: 'divisionMemberDossier',
                allowOrgSelection: true,
              });
            }
            return commonUtils.division.getCtx({
              multiple: false,
              namespace: 'divisionMemberDossier',
              allowOrgSelection: true,
              entryPermission: divisionSelectorEntryPermission
            });
          },
          member: function ($stateParams, clientApi, ctx) {
            if (!ctx || !ctx.length) {
              return {};
            }
            return clientApi.custom('model/Member', 'findByMemberEMail', {
              divisionIds: (~ctx.indexOf('rootOrg') ? [] : ctx),
              eMail: $stateParams.memberEMail
            });
          },
          characteristicMap: function ($translate) {
            return {
              DEFAULT: $translate.instant('modules.personnel.charMap.DEFAULT'),
              WARDEN: $translate.instant('modules.personnel.charMap.WARDEN'),
              WITH_CHILDREN: $translate.instant('modules.personnel.charMap.WITH_CHILDREN'),
              WARDEN_WITH_CHILDREN: $translate.instant('modules.personnel.charMap.WARDEN_WITH_CHILDREN')
            };
          },
          causesOfTermination: function ($translate) {
            return [
              $translate.instant('modules.personnel.causesOfTermination.periodEnd'),
              $translate.instant('modules.personnel.causesOfTermination.otherActivity'),
              $translate.instant('modules.personnel.causesOfTermination.generationalChange'),
              $translate.instant('modules.personnel.causesOfTermination.lackOfTime'),
              $translate.instant('modules.personnel.causesOfTermination.TooMuchWorkload'),
              $translate.instant('modules.personnel.causesOfTermination.differences'),
              $translate.instant('modules.personnel.causesOfTermination.ownRequest'),
              $translate.instant('modules.personnel.causesOfTermination.divisionExit'),
              $translate.instant('modules.personnel.causesOfTermination.other'),
            ];
          },
          memberStatus: function (ARNO_CONSTANTS) {
            return ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_STATUS;
          },
          memberTypes: function (ARNO_CONSTANTS) {
            return ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_TYPES;
          },
        }
      })
      .state('arno.personnel.dossier.baseData', {
        url: '/baseData',
        templateUrl: 'app/pages/personnel/dossier/baseData/baseData.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierBaseDataCtrl as $baseData',
        params: {
          backToOverview: false,
        },
        resolve: {
          isOrgScope: function (ctx) {
            return ctx && (ctx === 'rootOrg' || ctx[0] === 'rootOrg');
          },
          isADUser: function (member) {
            return member.Account ? member.Account.Type === 'azure' : false;
          },
          hasAllowedAge: function ($rootScope, member) {
            if ($rootScope.ctx.organization.current.restrictedAgeProfileEdit == null) {
              return true;
            }

            var birthDate = (member || {}).BirthDate ? member.BirthDate : null;

            if (!(moment(birthDate).isValid()) || Number.isNaN(parseFloat($rootScope.ctx.organization.current.restrictedAgeProfileEdit))) {
              return false;
            }

            var yearsDiff = moment().diff(moment(birthDate), 'years', true);

            return yearsDiff >= $rootScope.ctx.organization.current.restrictedAgeProfileEdit;
          },
          memberDivisions: function (clientApi, member) {
            return clientApi
              .custom('model/DivisionMember', 'getAvailableDivisions', { cMemberId: member.id });
          },
          CAT_MEMBER_COUNTRY_IDS: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },
          CAT_MEMBER_NATIONALITIES: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueNationality');
          },
          CAT_MEMBER_LANGUAGES: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueLanguage')
              .then(function (languageCatalogue) {
                // list with important languages which should be shown at top of the list
                var topEntriesList = [
                  'deu',
                  'eng',
                  'fra',
                  'spa',
                  'por',
                  'tur',
                  'rus',
                  'nld',
                  'ara',
                  'lat',
                ];

                // sort and normalize
                languageCatalogue.Entries = _.sortBy(languageCatalogue.Entries, function (entry) {
                  var prioIndex = topEntriesList.indexOf(entry.mapping.toLowerCase());
                  if (prioIndex > -1) {
                    // add '+, so the sortBy will put the entry at the top of the sorted list, other prio-chars are also possible
                    return '+' + prioIndex;
                  }

                  return entry.Name;
                });

                return languageCatalogue;
              });
          },
          sensitiveData: function (clientApi, member, ctx, permissions, $rootScope) {
            var isPermittedInDiv = permissions.isPermittedInEvery('arno.personnel.dossier.baseData.sensitiveData.manage', 'Division', ctx);
            if (
              isPermittedInDiv ||
              permissions.isPermittedInEvery('arno.personnel.dossier.baseData.sensitiveData.manage', 'Organization', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/Member', 'getSensitiveData', { cMemberId: member.id, divIds: isPermittedInDiv ? ctx : null })
                .catch(function () {
                  return null;
                });
            }
            return null;
          }
        }
      })
      .state('arno.personnel.dossier.qualification', {
        url: '/qualification',
        templateUrl: 'app/pages/personnel/dossier/qualification/qualification.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierQualificationCtrl as $qual', 
        resolve: {
          userQualifications: function (clientApi, member, ctx) {
            if (member && Object.keys(member).length) {
              return clientApi.custom('model/MemberQualification', 'getMemberQualification', { divisionId: ctx, cMemberId: member.id });
            }
          },
          isOwnDossier: function ($stateParams, $rootScope) {
            return $stateParams.memberEMail === $rootScope.ctx.currentUser.eMail;
          },
          choosableQualifications: function (clientApi, ctx, permissions) {
            if (!permissions.isPermittedInEvery('arno.personnel.dossier.qualification.manageAll', 'Division', ctx)) {
              return [];
            }
            return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: ctx[0] });
          },
          availableMaterials: function (clientApi, $translate, ctx, permissions) {
            if (!permissions.isPermittedInEvery('arno.personnel.dossier.qualification.manageAll', 'Division', ctx)) {
              return [];
            }
            var materialList = {
              'MaterialMedicine': $translate.instant('navigation.material.overview.medicine'),
              'MaterialMedicalProducts': $translate.instant('navigation.material.overview.medicalProducts'),
              'MaterialVehicles': $translate.instant('navigation.material.overview.vehicles'),
              'MaterialClothing': $translate.instant('navigation.material.overview.clothing'),
              'MaterialTools': $translate.instant('navigation.material.overview.tools'),
              'MaterialConsumables': $translate.instant('navigation.material.overview.consumables'),
              'MaterialOthers': $translate.instant('navigation.material.overview.other'),
            };
            return {
              get: function () {
                var promises = Object.keys(materialList).map(function (material) {
                  return clientApi.custom('model/' + material, 'getMaterialIdAndName', {
                    divisionId: ctx
                  }).then(function (response) {
                    return response.map(function (r) {
                      return Object.assign(r, { isMaterialType: material, TypeTranslated: materialList[material] });
                    });
                  });
                });

                return Promise.all(promises).then(function (results) {
                  // flatten results
                  return results.reduce(function (acc, val) {
                    return acc.concat(val);
                  }, []).map(function (material) {
                    var asString = '';
                    switch (material.isMaterialType) {
                    case 'MaterialMedicine':
                      asString = material.Definition;
                      break;
                    case 'MaterialMedicalProducts':
                      asString = material.Type;
                      break;
                    case 'MaterialVehicles':
                      asString = material.VehicleModel
                          ? material.VehicleModel + ' '
                          : '' + (material.LicensePlate || '');
                      break;
                    case 'MaterialClothing':
                      asString = material.Name;
                      break;
                    case 'MaterialTools':
                      asString = material.Definition;
                      break;
                    case 'MaterialConsumables':
                      asString = material.Definition;
                      break;
                    case 'MaterialOthers':
                      asString = material.Name;
                      break;
                    }
                    return Object.assign(
                      material,
                      {
                        asString: asString,
                      }
                    );
                  });
                });
              }
            };
          },
        },
        params: {
          backToOverview: false,
        },
      })
      .state('arno.personnel.dossier.activity', {
        url: '/occupation/',
        templateUrl: 'app/pages/personnel/dossier/activity/activity.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierActivityCtrl as $act',
        resolve: {
          isOrgScope: function (ctx) {
            return ctx && (ctx === 'rootOrg' || ctx[0] === 'rootOrg');
          },
          // For ORG-view
          allActivityHistories: function (clientApi, organizationId, member, isOrgScope) {
            if (isOrgScope === true) {
              if (!member || !Object.keys(member).length) {
                return [];
              }

              return clientApi
                .custom('model/ActivityAllocation', 'getActivityHistoryForMember', { cMemberId: member.id, includeActivityAllocationsDivInfo: true })
                .then(function (results) {
                  // map all activity-allocations to their divisions
                  var mappedActivityAllocations = {};

                  if ((results || {}).length) {
                    _.forEach(results, function (activity) {
                      if (activity && (activity.ActivityAllocations || {}).length) {
                        _.forEach(activity.ActivityAllocations, function (activityAllocation) {
                          // reverse-assign to get the activity-state
                          activityAllocation.vm = activityAllocation.vm || {
                            activity: activity
                          };

                          if (activityAllocation.DivisionMember && activityAllocation.DivisionMember.Division) {
                            var division = activityAllocation.DivisionMember.Division;

                            mappedActivityAllocations[division.id] = mappedActivityAllocations[division.id] || {
                              divisionId: division.id,
                              Name: division.Name,
                              activities: {},
                              //activityAllocations: [],
                              activityGroups: []
                            };
                            //mappedActivityAllocations[division.id].activities[activity.id] = activity;
                            //mappedActivityAllocations[division.id].activityAllocations.push(activityAllocation);

                            mappedActivityAllocations[division.id].activityGroups[activity.ActivityGroup.id] = mappedActivityAllocations[division.id].activityGroups[activity.ActivityGroup.id] || {
                              activityGroupId: activity.ActivityGroup.id,
                              activityGroupTitle: activity.ActivityGroup.Title,
                              activityAllocations: []
                            };
                            mappedActivityAllocations[division.id].activityGroups[activity.ActivityGroup.id].activityAllocations.push(activityAllocation);
                          }
                        });
                      }
                    });
                  }

                  return mappedActivityAllocations;
                })
                .catch(function () {
                  return [];
                });
            }

            // return empty-list for better splitting for org/divisions-case
            // otherwise the results from activityHistory could be added here,
            // because its a subset of allActivityHistories
            return [];
          },
          // For DIVISION-view
          activityHistory: function (clientApi, organizationId, member, ctx, isOrgScope) {
            if (!member || !Object.keys(member).length || !ctx || !ctx.length || isOrgScope === true) {
              return [];
            }

            return clientApi
              .custom('model/ActivityAllocation', 'getActivityHistoryForMember', { cMemberId: member.id, divisionIds: ctx })
              .catch(function () {
                return [];
              });
          },
          activityGroups: function (clientApi, organizationId, permissions, ctx) {
            if (!permissions.isPermittedInEvery('arno.personnel.dossier.activity.assign', 'Division', ctx)) {
              return [];
            }
            if (!ctx || !ctx.length) {
              return [];
            }

            return clientApi
              .custom('model/ActivityGroup', 'getActivityGroups', { divisionId: ctx })
              .catch(function () {
                return [];
              });
          },
          // For ORG-view
          allActivityFulfillmentStates: function (clientApi, organizationId, member, ctx, allActivityHistories, isOrgScope) {
            // fulfillment states must be fetched for ALL divisions!
            // get all chosen divisionIds from allActivityHistories
            // ALTERNATIVE: only send cMemberId and let the api refetch ALL div-information with is activities
            // Its "cleaner", BUT this would be more overhead
            var divisionActivitiesMapping = {};

            if (isOrgScope === true) {
              _.forEach(allActivityHistories, function (activityHistory, divisionId) {
                divisionActivitiesMapping[divisionId] = [];

                activityHistory.activityGroups.forEach(function (group) {
                  group.activityAllocations.forEach(function (allocation) {
                    divisionActivitiesMapping[divisionId].push({
                      activityId: allocation.vm.activity.id,
                      characteristic: (allocation.Characteristic) || 'DEFAULT'
                    });
                  });
                });
              });

              return clientApi.custom('model/ActivityAllocation', 'getAllActivitiesFulfillmentStates', {
                divisionActivitiesMapping: divisionActivitiesMapping,
                cMemberId: member.id
              });
            }

            return {};
          },
          // For DIVISION-view
          activityFulfillmentStates: function (clientApi, organizationId, member, ctx, activityHistory, isOrgScope) {
            var divisionIds = ctx;

            if (!member || !Object.keys(member).length || !ctx || !ctx.length || isOrgScope === true) {
              return [];
            }

            if (isOrgScope) {
              divisionIds = null;
            }

            return clientApi
              .custom('model/ActivityAllocation', 'getActivitiesFulfillmentState', {
                divisionId: divisionIds,
                cMemberId: member.id,
                activities: activityHistory.map(function (history) {
                  return {
                    activityId: history.id,
                    characteristic: (history.ActivityAllocations && history.ActivityAllocations.length && history.ActivityAllocations[0].Characteristic) || 'DEFAULT'
                  };
                })
              })
              .catch(function () {
                return [];
              });
          }
        },
        params: {
          backToOverview: false,
        }
      })
      .state('arno.personnel.dossier.overview', {
        url: '',
        templateUrl: 'app/pages/personnel/dossier/overview/overview.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierOverviewCtrl as $over',
        resolve: {
          isOrgScope: function (ctx) {
            return ctx && (ctx === 'rootOrg' || ctx[0] === 'rootOrg');
          },
          isPermitted: function (permissions, ctx, $rootScope) {
            return function (action, onlyDiv) {
              if (ctx[0] === 'rootOrg') {
                if (onlyDiv) {
                  return false;
                }
                return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
              }
              return permissions.isPermittedInEvery(action, 'Division', ctx, true);
            };
          },
          tableConfig: function (clientApi, commonUtils, ctx, isPermittedOrOwn, $translate) {
            var tableConfigDefault = {
              'Approval.ClearanceGroup': true,
              'Division.Name': true,
              'StatusLight': true,
              'Approval.Title': true,
              State: true,
              'Approval.Type': true,
            };
            if (ctx.length && !~ctx.indexOf('rootOrg') && isPermittedOrOwn('arno.personnel.dossier.clearance')) {
              return clientApi
                .custom('model/Approval', 'getColumns', {
                  divisionId: ctx,
                  language: $translate.use(),
                })
                .then(function (availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'approvalProcessList',
                      divisionId: ctx
                    })
                    .then(function (customTableConfigs) {

                      return {
                        tableConfigAvailableFields: availableFields,
                        tableConfigDefault: tableConfigDefault,
                        tableConfigCustomPreference: customTableConfigs
                      };
                    });
                })
                .catch(function () {
                  return {
                    tableConfigAvailableFields: {},
                    tableConfigDefault: tableConfigDefault,
                    tableConfigCustomPreference: []
                  };
                });
            }
            return {
              tableConfigAvailableFields: {},
              tableConfigDefault: tableConfigDefault,
              tableConfigCustomPreference: []
            };
          },
          isPermittedOrOwn: function (isOwnDossier, isPermitted, ctx) {
            return function (action, onlyDiv) {
              if (ctx[0] === 'rootOrg' && onlyDiv) {
                return false;
              }
              return isOwnDossier || isPermitted(action, onlyDiv);
            };
          },
          userQualifications: function (clientApi, member, ctx, organizationId, isPermittedOrOwn) {
            if (!member || !Object.keys(member).length || !ctx || !ctx.length
              || !isPermittedOrOwn('arno.personnel.dossier.qualification')) {
              return [];
            }
            return clientApi.custom('model/MemberQualification', 'getMemberQualification', { divisionId: ctx, cMemberId: member.id });
          },
          // USED for both selected DIVISION AND ORG!
          activityHistory: function (clientApi, organizationId, member, ctx, isOrgScope, isPermittedOrOwn) {
            if (!member || !Object.keys(member).length || !ctx || !isPermittedOrOwn('arno.personnel.dossier.activity')) {
              return [];
            }

            var divisionIds = ctx;
            var includeActivityAllocationsDivInfo = false;

            if (isOrgScope === true) {
              divisionIds = undefined;
              includeActivityAllocationsDivInfo = true;
            }

            return clientApi
              .custom('model/ActivityAllocation', 'getActivityHistoryForMember', {
                cMemberId: member.id,
                divisionIds: divisionIds,
                includeActivityAllocationsDivInfo: includeActivityAllocationsDivInfo
              })
              .catch(function () {
                return [];
              });
          },
          // For selected ORG
          allActivityFulfillmentStates: function (clientApi, organizationId, member, ctx, activityHistory, isOrgScope, isPermittedOrOwn) {
            // fulfillment states must be fetched for ALL divisions!
            // get all chosen divisionIds from allActivityHistories
            // ALTERNATIVE: only send cMemberId and let the api refetch ALL div-information with is activities
            // Its "cleaner", BUT this would be more overhead
            var divisionActivitiesMapping = {};

            if (isOrgScope === true && isPermittedOrOwn('arno.personnel.dossier.activity')) {
              _.forEach(activityHistory, function (activity) {
                _.forEach(activity.ActivityAllocations, function (activityAllocation) {
                  if (((activityAllocation || {}).DivisionMember || {}).Division) {
                    var divisionId = activityAllocation.DivisionMember.Division.id;
                    divisionActivitiesMapping[divisionId] = divisionActivitiesMapping[divisionId] || [];

                    divisionActivitiesMapping[divisionId].push({
                      activityId: activity.id,
                      characteristic: (activityAllocation.Characteristic) || 'DEFAULT'
                    });
                  }
                });
              });

              return clientApi.custom('model/ActivityAllocation', 'getAllActivitiesFulfillmentStates', {
                divisionActivitiesMapping: divisionActivitiesMapping,
                cMemberId: member.id
              });
            }

            return {};
          },
          // for selected DIVISION
          activityFulfillmentStates: function (clientApi, organizationId, member, ctx, activityHistory, isPermittedOrOwn, isOrgScope) {
            if (!member || !Object.keys(member).length || !ctx || !ctx.length || !isPermittedOrOwn('arno.personnel.dossier.activity')) {
              return [];
            }
            var divisionIds = ctx;

            if (isOrgScope === true) {
              divisionIds = undefined;
            }

            return clientApi
              .custom('model/ActivityAllocation', 'getActivitiesFulfillmentState', {
                divisionId: divisionIds,
                cMemberId: member.id,
                activities: activityHistory.map(function (history) {
                  return {
                    activityId: history.id,
                    characteristic: (history.ActivityAllocations && history.ActivityAllocations.length && history.ActivityAllocations[0].Characteristic) || 'DEFAULT'
                  };
                })
              })
              .catch(function () {
                return [];
              });
          },
          trainingCategories: function (ArnoDashAdminCategoriesService) {
            return ArnoDashAdminCategoriesService.findCategories({ usages: ['Training'] });
          },
          approvalProcesses: function (clientApi, member, commonUtils, organizationId, $rootScope, ctx, isPermittedOrOwn) {
            if (!member || !Object.keys(member).length || !ctx || !ctx.length
              || !isPermittedOrOwn('arno.personnel.dossier.clearance')) {
              return [];
            }
            return clientApi.custom('model/ApprovalAllocation', 'getApprovalsForDivision', {
              divisionIds: ctx,
              affectedMemberIds: [member.id],
              divisionSpanning: true
            });
          },
          permittedToStartAnyClearance: function (ctx, isOrgScope, ArnoDashAdminClearancesService, commonUtils, permissions) {
            return permittedToStartAnyClearance(ctx, isOrgScope, ArnoDashAdminClearancesService, commonUtils, permissions);
          }
        }
      })
      .state('arno.personnel.dossier.clearance', {
        url: '/clearance',
        templateUrl: 'app/pages/personnel/dossier/clearance/clearance.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierClearanceCtrl as $ctrl',
        resolve: {
          approvalProcesses: function (clientApi, member, commonUtils, organizationId, $rootScope, ctx) {
            if (!member || !Object.keys(member).length || !ctx || !ctx.length) {
              return [];
            }
            return clientApi.custom('model/ApprovalAllocation', 'getApprovalsForDivision', {
              divisionIds: ctx,
              affectedMemberIds: [member.id],
              divisionSpanning: true
            });
          },
          isOrgScope: function (ctx) {
            return ctx && (ctx === 'rootOrg' || ctx[0] === 'rootOrg');
          },
          tableConfig: function (clientApi, commonUtils, ctx, $translate) {
            var tableConfigDefault = {
              'Approval.ClearanceGroup': true,
              'Division.Name': true,
              'StatusLight': true,
              'Member.FirstName': true,
              'Member.Lastname': true,
              'Approval.Title': true,
              'Approval.State': true,
            };
            if (ctx.length && !~ctx.indexOf('rootOrg')) {
              return clientApi
                .custom('model/Approval', 'getColumns', {
                  divisionId: ctx,
                  language: $translate.use(),
                })
                .then(function (availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'approvalProcessList',
                      divisionId: ctx
                    })
                    .then(function (customTableConfigs) {

                      return {
                        tableConfigAvailableFields: availableFields,
                        tableConfigDefault: tableConfigDefault,
                        tableConfigCustomPreference: customTableConfigs
                      };
                    });
                })
                .catch(function () {
                  return {
                    tableConfigAvailableFields: {},
                    tableConfigDefault: tableConfigDefault,
                    tableConfigCustomPreference: []
                  };
                });
            }
            return {
              tableConfigAvailableFields: {},
              tableConfigDefault: tableConfigDefault,
              tableConfigCustomPreference: []
            };
          },
          memberGroups: function (ctx, clientApi, member) {
            if (!~ctx.indexOf('rootOrg')) {
              return clientApi.custom('model/MemberGroup', 'groupsWithDivision', { divisionIds: ctx, dossierOwnerId: member.id });
            }
            return [];
          },
          permittedToStartAnyClearance: function (ctx, isOrgScope, ArnoDashAdminClearancesService, commonUtils, permissions) {
            return permittedToStartAnyClearance(ctx, isOrgScope, ArnoDashAdminClearancesService, commonUtils, permissions);
          },
          allowedReferences: function (ArnoDashAdminClearancesService, commonUtils, ctx) {
            return ArnoDashAdminClearancesService.getApprovalStartAndEditReferences(ctx);
          }
        },
        params: {
          backToOverview: false,
        },
      })
      .state('arno.personnel.dossier.administration', {
        url: '/administration',
        templateUrl: 'app/pages/personnel/dossier/administration/administration.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierAdministrationCtrl as $admin',
        resolve: {
          isInDivisions: function (clientApi, isPermittedOrOwn, ctx, member) {
            if (!member.id || !isPermittedOrOwn('arno.personnel.administration.deleteMember')) {
              return {};
            }
            return clientApi
              .custom('model/Member', 'findMemberDivisions', {
                targetMemberId: member.id,
                divisionId: ctx,
              });
          },
          isPermitted: function (permissions, ctx, $rootScope) {
            return function (action, onlyDiv) {
              if (ctx[0] === 'rootOrg') {
                if (onlyDiv) {
                  return false;
                }
                return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
              }
              return permissions.isPermittedInEvery(action, 'Division', ctx, true);
            };
          },
          isPermittedOrOwn: function (isOwnDossier, isPermitted, ctx) {
            return function (action, onlyDiv) {
              if (ctx[0] === 'rootOrg' && onlyDiv) {
                return false;
              }
              return isOwnDossier || isPermitted(action, onlyDiv);
            };
          },
          currentDivisionName: function (clientApi, ctx) {
            if (!ctx || !ctx.length || ctx[0] === 'rootOrg') {
              return '';
            }
            return clientApi
              .custom('model/Division', 'fetchDivisionName', {
                divisionIds: ctx[0]
              })
              .then(function (result) {
                return ((result || {}).Name) || '';
              });
          },
          fetchPermissions: function (clientApi, member, ctx, isPermittedOrOwn) {
            if (!member.id || !isPermittedOrOwn('arno.personnel.dossier.permissions.view')) {
              return {};
            }
            return clientApi
              .custom('model/Member', 'getPermissionOverviewForMember', {
                targetMemberId: member.id,
                divisionId: ctx.filter(function (c) {
                  return c !== 'rootOrg';
                })
              });
          },
          fetchHistoryData: function (clientApi, member, ctx) {
            return function (queryWishes) {
              return clientApi
                .custom('model/LogJournal', 'fetchMemberLogs', {
                  cMemberId: member.id,
                  divisionId: (ctx && ctx.length && ctx[0] !== 'rootOrg' && ctx[0]) || null,
                  queryWishes: queryWishes
                });
            };
          },
          historyData: function (isPermittedOrOwn, fetchHistoryData) {
            if (!isPermittedOrOwn('arno.personnel.dossier.history.view')) {
              return [];
            }
            return fetchHistoryData({ paging: { offset: 0, limit: 10 }, sort: { by: 'createdAt', reverse: true } });
          },
          historyEventMap: function (historyEventMap) {
            return historyEventMap;
          },
          authInfo: function ($rootScope, clientApi) {
            return clientApi.custom('model/Organization', 'getAuthInfo', {});
          },
          notificationPreference: function (clientApi, member, ctx) {
            var result = clientApi.custom('model/NotificationPreference', 'findByMemberId', { cMemberId: member.id, divisionId: ctx });
            return result;
          }
        }
      })
      .state('arno.personnel.dossier.helperHours', {
        url: '/helperHours',
        templateUrl: 'app/pages/personnel/dossier/helperHours/helperHours.html',
        title: dynamicDossierTitle,
        controller: 'HelperHoursCtrl as $helperCtrl',
        resolve: {
          isPermitted: function (permissions, ctx, $rootScope) {
            return function (action, onlyDiv) {
              if (ctx[0] === 'rootOrg') {
                if (onlyDiv) {
                  return false;
                }
                return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
              }
              return permissions.isPermittedInEvery(action, 'Division', ctx, true);
            };
          },
          isPermittedOrOwn: function (isOwnDossier, isPermitted, ctx) {
            return function (action, onlyDiv, disallowOwn) {
              if (ctx[0] === 'rootOrg' && onlyDiv) {
                return false;
              }
              return (!disallowOwn && isOwnDossier) || isPermitted(action, onlyDiv);
            };
          },
          statisticalDataProvider: function (clientApi, ctx, member) {
            return function (rangeStart, rangeEnd, activityId, baseCategoryId) {
              return clientApi
                .custom('model/statistic', 'getHelperHoursStatisticData', {
                  divisionIds: ctx,
                  options: {
                    rangeStart: rangeStart,
                    rangeEnd: rangeEnd,
                    memberId: member.id,
                    activityId: activityId,
                    baseCategoryId: baseCategoryId,
                  }
                });
            };
          },
          helperHoursStatisticData: function (statisticalDataProvider) {
            return statisticalDataProvider(
              moment().subtract(90, 'day'),
              moment().subtract(1, 'day'),
              null,
              null
            );
          },
        },
        viewPermission: 'arno.personnel.dossier.helperHours.view',
      })
      .state('arno.personnel.dossier.notAssigned', {
        url: '/notAssigned',
        templateUrl: 'app/pages/personnel/dossier/notAssigned/notAssigned.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierNotAssignedCtrl as $notAssigned',
        resolve: {
          memberFallback: function (clientApi, organizationId, $stateParams) {
            return clientApi.custom('model/Member', 'getMemberNameByEMail', { eMail: $stateParams.memberEMail });
          }
        },
        viewPermission: 'arno.personnel.dossier',
      })
      .state('arno.personnel.dossier.fileStorage', {
        url: '/fileStorage',
        templateUrl: 'app/pages/personnel/dossier/fileStorage/fileStorage.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierFileStorageCtrl as $fs',
        resolve: {
          folderData: function (clientApi, commonUtils, $rootScope, member, ctx) {
            return clientApi
              .custom('model/FileStorageFolder', 'getFoldersForOrg', {
                divisionId: ctx,
                affectedId: member.id,
                dossierOwnerId: member.id,
                storageIdent: 'dossier',
              })
              .then(function (faf) {
                if (faf && faf.folders && faf.folders.length) {
                  return commonUtils.fileStorage.buildFolderTree(faf.folders, {
                    rootOrg: $rootScope.ctx.organization.current.name,
                    includeFiles: faf.files,
                  });
                }
              });
          },
          infoboxText: function (clientApi, ctx, member) {
            return clientApi.custom('model/FileStorageConfig', 'getConfig', {
              divisionId: ctx,
              dossierOwnerId: member.id,
              configKey: 'FILE-STORAGE_INFO-TEXT'
            });
          },
          isOwnDossier: function ($stateParams, $rootScope) {
            return $stateParams.memberEMail === $rootScope.ctx.currentUser.eMail;
          },
          dossierOwner: function (member) {
            return member;
          }
        },
        params: {
          backToOverview: false,
        },
      });
  }
})
  ();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier')
    .controller('PersonnelDossierCtrl', PersonnelDossierCtrl);

  function PersonnelDossierCtrl(member, $state, $translate, commonUtils, ctx, permissions, organizationId,
    isOwnDossier, divisionSelectorEntryPermission) {
    var self = this;
    self.member = member;

    self.rootOrgSelected = (!ctx || !ctx.length || ctx[0]) === 'rootOrg';
    //don't check for permission if it's your own dossier
    self.divisionSelectorEntryPermission = isOwnDossier ? '' : divisionSelectorEntryPermission;

    self.showDossierTab = function (permission) {
      return isOwnDossier || permissions.isPermittedInEvery(
        permission,
        self.rootOrgSelected ? 'Organization' : 'Division',
        self.rootOrgSelected ? [organizationId] : ctx,
        true
      );
    };

    self.checkMemberAssigned = function (toState) {
      if (member && Object.keys(member).length) {
        if (!self.dossierTabs || self.dossierTabs.length < 2) {
          self.dossierTabs = [
            {
              heading: '<i class="fa fa-user-circle-o"></i> ' + $translate.instant('modules.personnel.dossier.tabs.overview'),
              route: 'arno.personnel.dossier.overview'
            },
            {
              heading: '<i class="ion-android-person"></i> ' + $translate.instant('modules.personnel.dossier.tabs.baseData'),
              route: 'arno.personnel.dossier.baseData'
            },
            {
              heading: '<i class="fa fa-paint-brush"></i> ' + $translate.instant('modules.personnel.dossier.tabs.activity'),
              route: 'arno.personnel.dossier.activity',
            },
            {
              heading: '<i class="ion-ribbon-b"></i> ' + $translate.instant('modules.personnel.dossier.tabs.qualifications'),
              route: 'arno.personnel.dossier.qualification',
            },
            {
              heading: '<i class="fa fa-graduation-cap"></i> ' + $translate.instant('modules.personnel.dossier.tabs.trainings'),
              route: 'arno.personnel.dossier.trainings.main',
              permitted: function () {
                return (self.showDossierTab('arno.personnel.dossier.trainings.manage'))
                       || self.showDossierTab('arno.personnel.dossier.trainings.view')
              },
            },
            {
              heading: '<i class="fa fa-thumbs-o-up"></i> ' + $translate.instant('modules.personnel.dossier.tabs.clearance'),
              route: 'arno.personnel.dossier.clearance',
              permitted: function () {
                if (isOwnDossier) {
                  return true;
                }
                return self.showDossierTab('arno.personnel.dossier.clearance') ||
                  self.showDossierTab('arno.personnel.clearance.view.simple')
              },
            },
            {
              heading: '<i class="fa fa-folder-open"></i> ' + $translate.instant('modules.personnel.dossier.tabs.fileStorage'),
              route: 'arno.personnel.dossier.fileStorage',
              permitted: function() {
                if (isOwnDossier) {
                  return true;
                }

                return self.showDossierTab('arno.personnel.files.view', false);
              }
            },
            {
              heading: '<i class="fa fa-clock-o"></i> ' + $translate.instant('modules.personnel.dossier.tabs.helperHours'),
              route: 'arno.personnel.dossier.helperHours',
              permitted: function() {
                if (isOwnDossier) {
                  return true;
                }

                return self.showDossierTab('arno.personnel.dossier.helperHours.view');
              }
            },
            {
              heading: '<i class="fa fa-cogs"></i> ' + $translate.instant('modules.personnel.dossier.tabs.administration'),
              route: 'arno.personnel.dossier.administration',
              permitted: function () {
                if (isOwnDossier) {
                  return true;
                }
                return (!self.rootOrgSelected && self.showDossierTab('arno.personnel.dossier.activeState.manage')) ||
                  self.showDossierTab('arno.personnel.dossier.permissions.view') ||
                  self.showDossierTab('arno.personnel.administration.deleteMember') ||
                  self.showDossierTab('arno.administration.personnel.accountType.manage') ||
                  self.showDossierTab('arno.personnel.dossier.history.view');
              },
            }
          ]
            .filter(function (tab) {
              if (tab.permitted) {
                return tab.permitted();
              }
              return self.showDossierTab(tab.route);
            })
            .filter(function (tab) {
              return !self.rootOrgSelected || !tab.onlyDivision;
            });
          if (!self.dossierTabs.length) {
            // not permitted to anything; could happen for example by only having org baseData manage; then manipulating url to a div baseData
            $state.go('arno.forbidden');
            return;
          }
          if ($state.current.name === 'arno.personnel.dossier.notAssigned') {
            $state.go(self.getLastTab());
            return;
          }
          if (!self.dossierTabs
            .filter(function (tab) {
              return tab.route === toState;
            }).length) {
            $state.go(self.dossierTabs[0].route);
          }
        }
        return true;
      } else {
        if (!self.dossierTabs || self.dossierTabs.length > 1) {
          self.dossierTabs = [
            {
              heading: '<i class="ion-android-person"></i> ' + $translate.instant('modules.personnel.dossier.tabs.notAssigned'),
              route: 'arno.personnel.dossier.notAssigned'
            }
          ];
        }
        self.lastTab(toState);
        $state.go('arno.personnel.dossier.notAssigned');
        return false;
      }
    };

    self.onTabChange = function (tab) {
      return self.checkMemberAssigned(tab.route);
    };

    self.lastTab = function (route) {
      if (route !== 'arno.personnel.dossier.notAssigned') {
        commonUtils.preference.object.set('util_lastDossierTab', { route: route });
      }
    };
    self.getLastTab = function () {
      return commonUtils.preference.object.get('util_lastDossierTab', { route: 'arno.personnel.dossier.overview' }).route;
    };

    var toCheck = $state.current.name;
    if ($state.current.name === 'arno.personnel.dossier.notAssigned') {
      toCheck = self.getLastTab();
    }

    self.checkMemberAssigned(toCheck);
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.groups', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.groups', {
        url: '/groups',
        controller: 'PersonnelGroupCtrl as $ctrl',
        templateUrl: 'app/pages/personnel/groups/groups.html',
        title: 'navigation.personnel.groups',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              entryPermission: 'arno.personnel.groups.manage',
            })[0];
          },
          groups: function (clientApi, organizationId, divisionId) {
            if (!divisionId) {
              return [];
            }
            return clientApi
              .custom('model/MemberGroup', 'findGroupMembers', { divisionId: divisionId })
              .then(function (groups) {
                groups.forEach(function (group) {
                  group.MemberNames = group.Members
                  .sort(function (a,b) {
                    return (a.LastName > b.LastName) ? 1 : ((b.LastName > a.LastName) ? -1 : 0);
                  })
                  .map(function (m) {
                    return m.fullName;
                  });
                });
                return groups;
              });
          },
        },
        sidebarMeta: {
          order: 2,
        },
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.groups')
    .controller('PersonnelGroupCtrl', PersonnelGroupCtrl);

  /** @ngInject */
  function PersonnelGroupCtrl($scope, $state, initData, groups, $uibModal, $translate, clientApi, toastr, organizationId, divisionId) {
    var $ctrl = this;
    $ctrl.groups = groups;
    $ctrl.divisionSelectorEntryPermission = 'arno.personnel.groups.manage';
    $ctrl.division = divisionId;
    $ctrl.dupliCheckSource = {};
    var permittedForActivities = ((((initData.permissionsTree || {}).permissions || {})['arno.personnel.dossier.activity.view'] || {}).Division || {}).length;

    $ctrl.edit = function (group) {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/groups/group.modal.html',
        size: 'md',
        controller: 'GroupModalCtrl as $ctrl',
        resolve: {
          memberGroup: function () {
            return group;
          },
          divisionId: function () {
            return divisionId;
          },
          organizationId: function () {
            return organizationId;
          },
          dupliCheckSource: function () {
            return $ctrl.dupliCheckSource;
          },
          initData: function() {
            return initData;
          },
          availableActivities: function() {
            if (permittedForActivities) {
              return clientApi.custom('model/ActivityGroup', 'getActivityGroups', { divisionId: divisionId, includeCharacteristics: true });
            }
            return [];
          }
        },
      })
        .result
        .then(function (group) {
          toastr.success($translate.instant('modules.personnel.groups.editedToastText', { group: group.Name }), $translate.instant('modules.personnel.groups.editedToastTitle'));
          $state.reload();
        });
    };

    $ctrl.delete = function (group) {
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/groups/deleteGroup.modal.html',
        size: 'md',
        controller: 'GroupModalCtrl as $ctrl',
        resolve: {
          memberGroup: function () {
            return group;
          },
          divisionId: function () {
            return divisionId;
          },
          organizationId: function () {
            return organizationId;
          },
          dupliCheckSource: function () {
            return $ctrl.dupliCheckSource;
          },
          initData: function() {
            return initData;
          },
          availableActivities: function() {
            if (permittedForActivities) {
              return clientApi.custom('model/ActivityGroup', 'getActivityGroups', { divisionId: divisionId, includeCharacteristics: true });
            }
            return [];
          }
        },
      })
        .result
        .then(function () {
          return clientApi
            .custom('model/MemberGroup', 'deleteGroup', { divisionId: divisionId, groupId: group.id });
        })
        .then(function () {
          toastr.success($translate.instant('modules.personnel.groups.deletedToastText', { group: group.Name }), $translate.instant('modules.personnel.groups.deletedToastTitle'));
          $state.reload();
        })
    };

    $ctrl.create = function () {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/groups/group.modal.html',
        size: 'md',
        controller: 'GroupModalCtrl as $ctrl',
        resolve: {
          memberGroup: function () {
            return {
              Members: []
            };
          },
          divisionId: function () {
            return divisionId;
          },
          organizationId: function () {
            return organizationId;
          },
          dupliCheckSource: function () {
            return $ctrl.dupliCheckSource;
          },
          initData: function() {
            return initData;
          },
          availableActivities: function() {
            if (permittedForActivities) {
              return clientApi.custom('model/ActivityGroup', 'getActivityGroups', { divisionId: divisionId, includeCharacteristics: true });
            }
            return [];
          }
        },
      })
        .result
        .then(function (group) {
          toastr.success($translate.instant('modules.personnel.groups.createdToastText', { group: group.Name }), $translate.instant('modules.personnel.groups.createdToastTitle'));
          $state.reload();
        });
    };

    $ctrl.sendMessage = function(group) {
      return $uibModal
          .open({
            controller: 'sendMailToMembersCtrl as $ctrl',
            animation: true,
            backdrop: 'static',
            templateUrl: 'app/theme/components/modals/mailModal/sendMailToMembers.html',
            size: 'md',
            resolve: {
              memberInfos: function() {
                var results = group.Members.map(function(member) {
                  return {
                    fullName: member.fullName,
                    EMail: (member.ContactEMail || (member.Account && member.Account.Type !== 'offline' && member.Account.EMail) || null)
                  };
                });

                return _.uniqBy(results, 'EMail');
              }
            }
          });
    }

    $scope.$watch(function () {
      return $ctrl.groups;
    }, function () {
      $ctrl.dupliCheckSource = _.keyBy($ctrl.groups, function (group) {
        return (group.Name || '').toLocaleLowerCase();
      });
    });

    $ctrl.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.groups')
    .controller('GroupModalCtrl', GroupModalCtrl);

  /** @ngInject */
  function GroupModalCtrl($scope, $translate, $uibModal, initData, memberGroup, clientApi, $uibModalInstance, organizationId, divisionId, dupliCheckSource, availableActivities, toastr) {
    var $ctrl = this;
    $ctrl.group = memberGroup;
    $ctrl.groupMembers = memberGroup.Members;
    $ctrl.dupliCheckSource = dupliCheckSource || {};
    $ctrl.activities = memberGroup.MemberGroupActivities || [];
    $ctrl.permittedForActivities = ((((initData.permissionsTree || {}).permissions || {})['arno.personnel.dossier.activity.view'] || {}).Division || {}).length;
    $ctrl.characteristicMap = {
      DEFAULT: $translate.instant('modules.personnel.charMap.DEFAULT'),
      WARDEN: $translate.instant('modules.personnel.charMap.WARDEN'),
      WITH_CHILDREN: $translate.instant('modules.personnel.charMap.WITH_CHILDREN'),
      WARDEN_WITH_CHILDREN: $translate.instant('modules.personnel.charMap.WARDEN_WITH_CHILDREN')
    };
    $ctrl.formattedActivities = _.flatMap(availableActivities, function(ava) {
      return (ava.Activities || []).map(function(act) {
        act.groupName = ava.Title;
        return act;
      })
    })
    $ctrl.groupByFirstName = function (member) {
      var groupName;
      if (!member.hint) {
        groupName = member.initials.charAt(0);
      } else {
        groupName = $translate.instant('generalTerms.note');
      }
      return groupName;
    };

    $ctrl.checkForDuplicates = function (pGroupName) {
      var groupName = (pGroupName || '').toLocaleLowerCase();
      if ($ctrl.dupliCheckSource[groupName]) {
        return !!($ctrl.group.id && ($ctrl.dupliCheckSource[groupName].id === $ctrl.group.id));
      }
      return true;
    };

    $ctrl.searchMembers = function (name) {
      return clientApi
        .custom('model/Member', 'findByDivisionId', { divisionId: divisionId, searchName: name, queryWishes: { activeDivisionMember: true } })
        .then(function (result) {
          $ctrl.members = result;
          $ctrl.members.forEach(function (m) {
            if (_.find($ctrl.groupMembers, { id: m.id })) {
              m.selected = true;
            }
          });
          $ctrl.members.push({
            hint: true
          });
        });
    };

    $ctrl.saveGroup = function () {
      if ($scope.form.$invalid) {
        return;
      }
      var promise;
      var activityData = {};
      if ($ctrl.activities && $ctrl.activities.length) {
        $ctrl.activities.forEach(function(act) {
          activityData[act.id] = act.Characteristic;
        })
      }
      if ($ctrl.group.id) {
        /* for group name update */
        promise = clientApi
          .custom('model/MemberGroup', 'updateGroup', { divisionId: divisionId, groupId: $ctrl.group.id, groupName: $ctrl.group.Name, activityData: activityData });
      } else {
        /* for group creation */
        promise = clientApi
          .custom('model/MemberGroup', 'createGroup', { divisionId: divisionId, groupName: $ctrl.group.Name, activityData: activityData });
      }

      return promise
        .then(function (gid) {
          $ctrl.group.id = $ctrl.group.id || gid;
          var members = $ctrl.groupMembers.map(function (m) {
            return m.id
          });
          return clientApi
            .custom('model/MemberGroup', 'setGroupMembers', { divisionId: divisionId, groupId: $ctrl.group.id, memberIds: members })
        })
        .then(function () {
          $uibModalInstance.close($ctrl.group);
        })
        .catch(function () {
          toastr.error($translate.instant('modules.personnel.groups.errorToastText'), $translate.instant('modules.personnel.groups.errorToastTitle'));
        });
    };

    $ctrl.addMember = function () {
      $ctrl.selectedMember.selected = true;
      $ctrl.groupMembers.push($ctrl.selectedMember);
      $ctrl.selectedMember = null;
    };

    $ctrl.removeMember = function (member) {
      member.selected = false;
      $ctrl.groupMembers = $ctrl.groupMembers.filter(function (item) {
        return item.id !== member.id;
      });
    };

    $ctrl.addActivity = function () {
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/personnel/groups/addActivity.modal.html',
        size: 'md',
        controller: 'AddMemGroupActivityCtrl as self',
        resolve: {
          existingActivities: function () {
            return $ctrl.activities;
          },
          divisionId: function () {
            return divisionId;
          },
          selectableActivities: function() {
            return $ctrl.formattedActivities;
          },
          characteristicMap: function() {
            return $ctrl.characteristicMap;
          }
        },
      })
        .result
        .then(function (act) {
          $ctrl.activities.push(act);
        });
    };

    $ctrl.removeActivity = function (activity) {
      var index = _.findIndex($ctrl.activities, function(act) {
        return act.id === activity.id
      })
      if (index > -1) {
        $ctrl.activities.splice(index, 1);
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.groups')
    .controller('AddMemGroupActivityCtrl', AddMemGroupActivityCtrl);

  /** @ngInject */
  function AddMemGroupActivityCtrl($scope, $uibModalInstance, selectableActivities, divisionId, characteristicMap, existingActivities) {
    var self = this;
    self.selectableActivities = selectableActivities;
    self.divisionId = divisionId;
    self.characteristicMap = characteristicMap;
    if (existingActivities) {
      var existingIds = existingActivities.map(function(ca) { return ca.id });
      self.selectableActivities.map(function(act) {
        if (existingIds.indexOf(act.id) > -1) {
          act.disabled = true;
        }
      });
    }

    $scope.$watch('self.selectedActivity', function() {
      self.selectedCharacteristic = null;
    }, true)

    self.applyModal = function() {
      self.selectedActivity.Characteristic = self.selectedCharacteristic;
      return $uibModalInstance.close(self.selectedActivity);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.demandForAction')
    .controller('DemandForActionCtrl', PersonnelListCtrl);

  /** @ngInject */
  function PersonnelListCtrl(
    $scope, $rootScope, commonUtils, clientApi, permissions, toastr, ctx, ctxHH, originRequest, findMembersWithDemandForAction,
    baModalService, $uibModal, $state, openPromises, $translate
  ) {
    var self = this;

    self.chosen = {};
    self.chosenHelperHours = {};
    self.ctx = ctx;
    self.ctxHH = ctxHH;
    self.isOrg = ctx.length && ctx[0] === 'rootOrg';
    self.openPromises = openPromises.exist;

    self.pageSize = 10;
    self.showPager = false;
    self.showPagerHH = false;
    self.originPageNum = Math.ceil(originRequest.count / self.pageSize);
    self.displayedCollection = originRequest.rows;
    self.displayedCollectionHelperHours = [];

    self.lastOpts = null;
    self.detailedIds = {};

    var preservedTableParams;

    self.getData = function (params) {
      if (self.originPageNum !== null) {
        params.pagination.numberOfPages = self.originPageNum;
        self.originPageNum = null;
      }
      return findMembersWithDemandForAction(self, params)
        .then(function (result) {
          $scope.$evalAsync(function () {
            params.pagination.numberOfPages = Math.ceil(result.count / self.pageSize);
            self.displayedCollection = result.rows;
            result.rows.forEach(function (row) {
              self.detailedIds[row.id] = row;
            });
            self.showPager = params.pagination.numberOfPages > 1;
            self.lastOpts = result.opts;
          });
        });
    };

    self.chosenCount = 0;
    self.chosenCountHelperHours = 0;
    self.cleanedChosen = [];
    self.cleanedChosenHelperHours = [];

    self.cleanChosen = function () {
      self.cleanedChosen = Object
        .keys(self.chosen)
        .filter(function (c) {
          return self.chosen[c];
        })
        .map(function (c) {
          return self.detailedIds[c] || { id: c };
        });

      self.chosenCount = Object.keys(self.cleanedChosen).length;
    };
    $scope.$watch(function () {
      return self.chosen;
    }, self.cleanChosen, true);
    $scope.$watch(function () {
      return self.detailedIds;
    }, self.cleanChosen, true);

    $scope.$watch(function () {
      return self.chosenHelperHours;
    }, function(newVal) {
      self.chosenCountHelperHours = _.compact(Object.keys(newVal).map(function(k) {
        return self.chosenHelperHours[k];
      })).length;
    }, true);

    self.openDossier = function (eMail) {
      if (self.isPermitted('arno.personnel.dossier', ['rootOrg'], true)) {
        return (self.chosenCount > 1 ? baModalService.messageModal({
          modalType: 'warning',
          allowHtml: false,

          title: $translate.instant('modules.personnel.demandForAction.openDossierModalTitle'),
          content: $translate.instant('modules.personnel.demandForAction.openDossierModalContent'),

          primaryActionText: $translate.instant('modules.personnel.demandForAction.continue'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        }) : Promise.resolve())
          .then(function () {
            commonUtils.dossier.open(['rootOrg'], eMail);
          });
      }
    };

    self.prevent = function ($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    };

    self.isPermitted = function (action, opt, forceCheckOrg) {
      if (self.isOrg || forceCheckOrg) {
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
      }
      return permissions.isPermittedInEvery(action, 'Division', opt, true);
    };

    self.isPermittedAnywhere = function(action) {
      return permissions.isPermittedAnywhere(action);
    }

    self.reset = function (source) {
      var content;
      if (source === 'helperHours') {
        content = $translate.instant('modules.helperHours.personnel.youHaveCurrently') + self.chosenCountHelperHours + $translate.instant('modules.helperHours.personnel.reallyResetThisSection');
      } else {
        content = $translate.instant('modules.helperHours.personnel.youHaveCurrently') + self.chosenCount + $translate.instant('modules.helperHours.personnel.reallyResetThisPersons');
      }
      return (self.chosenCount > 10 ? baModalService.messageModal({
        modalType: 'warning',
        allowHtml: false,

        title: $translate.instant('modules.personnel.demandForAction.resetSelection'),
        content: content,

        primaryActionText: $translate.instant('modules.personnel.demandForAction.reset'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      }) : Promise.resolve())
        .then(function () {
          $scope.$evalAsync(function () {
            if (source === 'helperHours') {
              self.chosenHelperHours = {};
            } else {
              self.chosen = {};
            }
          });
        });
    };

    self.showedChooseAllMessage = 0;
    self.showedChooseAllHHMessage = 0;

    self.chooseAll = function () {
      return (!(self.showedChooseAllMessage++) ? baModalService.messageModal({
        modalType: 'info',
        allowHtml: false,

        title: $translate.instant('modules.personnel.demandForAction.selectAll'),
        content: $translate.instant('modules.personnel.demandForAction.chooseAllModalContent'),

        primaryActionText: $translate.instant('modules.personnel.demandForAction.continue'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      }) : Promise.resolve())
        .then(function () {
          return findMembersWithDemandForAction(self, {}, _.assign({}, self.lastOpts, { offset: 0, limit: 100000, countAll: false }))
            .then(function (result) {
              $scope.$evalAsync(function () {
                result.forEach(function (row) {
                  self.chosen[row.id] = true;
                });
              });
            });
        });
    };

    self.chooseAllHelperHours = function () {
      return (!(self.showedChooseAllHHMessage++) ? baModalService.messageModal({
        modalType: 'info',
        allowHtml: false,

        title: $translate.instant('modules.helperHours.personnel.allChoose'),
        content: $translate.instant('modules.helperHours.personnel.extendsChoose') +
        $translate.instant('modules.helperHours.personnel.tableFilterAdded'),

        primaryActionText: $translate.instant('generalTerms.resume'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      }) : Promise.resolve())
        .then(function () {
          return self.loadHelperHours(null, null, true)
            .then(function (result) {
              $scope.$evalAsync(function () {
                result.rows.forEach(function (row) {
                  self.chosenHelperHours[row.id] = true;
                });
              });
            });
        });
    };

    self.capture = function (specificChosen) {
      return ((specificChosen && (self.chosenCount > 1)) ? baModalService.messageModal({
        modalType: 'warning',
        allowHtml: false,

        title: $translate.instant('modules.personnel.demandForAction.resetSelection'),
        content: $translate.instant('modules.personnel.demandForAction.captureModalContent'),

        primaryActionText: 'Fortfahren',
        secondaryActionText: 'Abbrechen'
      }) : Promise.resolve())
        .then(function () {
          var chosenList = specificChosen ? [specificChosen] : self.cleanedChosen;
          $uibModal
            .open({
              backdrop: 'static',
              animation: true,
              templateUrl: 'app/theme/components/modals/contactPrivacyModal/contactPrivacyModal.html',
              size: 'mg',
              controller: 'ContactPrivacyModalCtrl as $contactPrivacyModalCtrl',
              resolve: {
                data: {
                  contact: {},
                  demandForAction: (function () {
                    var demandForAction = chosenList
                      .map(function (chosen) {
                        return chosen.fullName;
                      })
                      .filter(function (c) {
                        return c;
                      })
                      .slice(0, 20);
                    if (demandForAction.length < chosenList.length) {
                      demandForAction.push('... (' + (chosenList.length - demandForAction.length) + ' weitere)');
                    }
                    return demandForAction;
                  })()
                },
                privacyTermDate: function () {
                  return clientApi
                    .custom('model/PrivacyTerms', 'getLatest', { options: { onlyDate: true } })
                },
              }
            }).result
            .then(function (result) {
              if (!result) {
                throw new Error('Aborted.');
              }
              return clientApi
                .custom('model/Member', 'bulkRecordPrivacyTermsForUsers', {
                  PrivacyTermsDeliveredChannel: result.PrivacyTermsDeliveredChannel,
                  PrivacyTermsDeliveredDateTime: result.PrivacyTermsDeliveredDateTime,
                  PrivacyTermsDeliveredPerson: result.PrivacyTermsDeliveredPerson,
                  memberIds: chosenList.map(function (chosen) {
                    return chosen.id;
                  }),
                });
            })
            .then(function () {
              $state.reload();
            });
        });
    };

    self.export = function () {
      baModalService
        .messageModal({
          modalType: 'info',
          allowHtml: true,

          title: $translate.instant('modules.personnel.demandForAction.exportModalTitle'),
          content: '<div class="text-left">'+
                    $translate.instant('modules.personnel.demandForAction.exportModalContent1') +
                   '<div class="alert bg-primary mt-10 mb-0">' +
                   $translate.instant('modules.personnel.demandForAction.exportModalContent2') +
                   '</div>' +
                   '<div class="alert bg-primary mt-10 mb-0">' +
                   $translate.instant('modules.personnel.demandForAction.exportModalContent3') +
                   '<br>' +
                   $translate.instant('modules.personnel.demandForAction.exportModalContent4') +
                   '</div>' +
                   '<div class="alert bg-warning mt-10 mb-0">' +
                   $translate.instant('modules.personnel.demandForAction.exportModalContent5') +
                   '</div>' +
                   '</div>',

          primaryActionText: $translate.instant('modules.personnel.demandForAction.exportModalbtnText'),
          secondaryActionText:  $translate.instant('generalTerms.cancel')
        })
        .then(function () {
          clientApi.openTab('personnel/export/demandforaction', {
            memberIds: self.cleanedChosen.map(function (chosen) {
              return chosen.id;
            }),
            divisionId: self.isOrg ? undefined : self.ctx,
          }, {
            post: true,
          });

          toastr.success($translate.instant('modules.personnel.demandForAction.exportToastText'), $translate.instant('modules.personnel.demandForAction.exportToastTitle'));
        });
    };

    self.import = function () {
      $uibModal.open({
        controller: 'DemandForActionImportSelectionModalCtrl as $dfaism',
        animation: true,
        templateUrl: 'app/pages/personnel/demandForAction/modals/importSelection.html',
        size: 'md',
        resolve: {
          ctx: function() {
            return ctx;
          },
        }
      })
        .result
        .then(function (result) {
          if (result && result.length) {
            result.forEach(function(memberId) {
              self.chosen[memberId] = true;
            });
          }
        });
    };

    self.formatDuration = function(minutes) {
      return commonUtils.formatMinutesToHourString(minutes);
    }

    self.loadHelperHours = function(stTableParams, stCtrl, infinite) {
      if (!stTableParams && preservedTableParams) {
        stTableParams = preservedTableParams;
      }
      queryWishes = {};
      if (stTableParams) {
        var queryWishes = {
          paging: {
            offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.pageSize,
            limit: self.pageSize
          },
          filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
          sort: {
            by: stTableParams.sort.predicate,
            reverse: stTableParams.sort.reverse
          }
        };
      }
      if (infinite) {
        queryWishes.paging.offset = 0;
        queryWishes.paging.limit = 100000;
      }

      queryWishes.onlyUnapproved = true;
      queryWishes.includeOrgEntries = true;
      queryWishes.includeAccount = true;
      var promise = clientApi
        .custom('model/helperHours', 'fetchHelperHours', {
          divisionId: ctxHH,
          queryWishes: queryWishes,
          includeActivityAllocationsDivInfo: true
        });
      if (!infinite) {
        preservedTableParams = stTableParams;
        promise = promise
          .then(function(res) {
            self.displayedCollectionHelperHours = res.rows;
            self.totalRows = res.count;
            if (stTableParams) {
              stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.pageSize);
              self.showPagerHH = stTableParams.pagination.numberOfPages > 1;
              if (res.count > 0 && res.rows.length === 0) {
                stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.pageSize;
              }
            }
          })
      }

      return promise;
    }

    self.approveEntries = function(id, approvalState) {
      return clientApi
        .custom('model/helperHours', 'approveHelperHours', {
          selectedIds: id ? [id] : Object.keys(self.chosenHelperHours).filter(function(key) {
            return self.chosenHelperHours[key];
          }),
          approvalState: approvalState,
        })
        .then(function() {
          if (approvalState) {
            toastr.success($translate.instant('modules.helperHours.personnel.volunteerHoursSuccessRelease'), $translate.instant('modules.helperHours.personnel.releaseVolunteerHours'));
          } else {
            toastr.success($translate.instant('modules.helperHours.personnel.volunteerHoursSuccesDiscard'), $translate.instant('modules.helperHours.personnel.discardVolunteerHours'));
          }
          $scope.$evalAsync(function () {
            self.chosenHelperHours = {};
          });
          self.loadHelperHours();
        })
        .catch(function() {
          if (approvalState) {
            toastr.error($translate.instant('modules.helperHours.personnel.tryLaterHelperMessage'), $translate.instant('modules.helperHours.personnel.volunteerHoursNoRelease'));
          } else {
            toastr.error($translate.instant('modules.helperHours.personnel.volunteerHoursCantDiscard'), $translate.instant('modules.helperHours.personnel.volunteerHoursNoRelease'));
          }
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.deletionList', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.deletionList', {
        url: '/deletionList',
        templateUrl: 'app/pages/personnel/deletionList/deletionList.html',
        title: 'navigation.personnel.deletionList',
        controller: 'deletionListCtrl as $ctrl',
        resolve: {
          deletionListCtx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.personnel.administration.deleteMember',
            });
          },
          tableConfig: function (clientApi, deletionListCtx, commonUtils, permissions, $rootScope, $translate) {
            var getDefaults = function(availableFields, customTableConfigs) {
              var orgPageSize = commonUtils.preference.object.get('pref_personnel_deletion_page_size_org', 10);
              var tableConfigOrgDefault = {
                FirstName: true,
                LastName: true,
                WithdrawalReasons: true,
                WithdrawalTargetDate: true,
                pageSize: orgPageSize.pageSize || orgPageSize,
              };
              var divPageSize = commonUtils.preference.object.get('pref_personnel_deletion_page_size_div', 10);
              var tableConfigDivDefault = {
                FirstName: true,
                LastName: true,
                WithdrawalReasons: true,
                WithdrawalTargetDate: true,
                pageSize: divPageSize.pageSize || divPageSize,
              };
              // create own field lists for div and org level
              var divFields = JSON.parse(JSON.stringify(availableFields));
              var orgFields = JSON.parse(JSON.stringify(availableFields));
              divFields.forEach(function (field) {
                if(!field.field){
                  // update the field definition to work for include model
                  field.field = 'Member.' + field.prop;
                }
              });
              
              
              
              
              divFields.push({ label: $translate.instant('modules.personnel.deletionList.deleteReason'), prop: 'WithdrawalReasons', field: 'WithdrawalReasons.Name', sort: 15 });
              divFields.push({ label: $translate.instant('modules.personnel.deletionList.withdrawalTargetDate'), prop: 'WithdrawalTargetDate', sort: 12 });
              orgFields.push({ label: $translate.instant('modules.personnel.deletionList.deleteReason'), prop: 'WithdrawalReasons', field: 'WithdrawalReasons.Name', sort: 15 });
              orgFields.push({ label: $translate.instant('modules.personnel.deletionList.withdrawalTargetDate'), prop: 'WithdrawalTargetDate', sort: 12 });

              return {
                tableConfigAvailableFields: { div: divFields, org: orgFields },
                tableConfigOrgDefault: tableConfigOrgDefault,
                tableConfigDivDefault: tableConfigDivDefault,
                tableConfigCustomPreference: customTableConfigs
              };
            }
            if (permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Division', deletionListCtx) ||
              permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Organization', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/Member', 'getAvailableFields', {
                  divisionId: deletionListCtx,
                  language: $translate.use(),
                })
                .then(function (availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'deletionList',
                      divisionId: deletionListCtx,
                    })
                    .then(function (customTableConfigs) {
                      return getDefaults(availableFields, customTableConfigs)
                    });
                });
            }
            return getDefaults([], []);
          },
          deletionListPermissions: function ($rootScope, permissions) {
            return {
              org: permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Organization', [$rootScope.ctx.organization.current.id]),
              div: permissions.isPermittedAnywhere('arno.personnel.administration.deleteMember', ['Division'])
            };
          }
        },
        viewPermission: 'arno.personnel.administration.deleteMember',
        sidebarMeta: {
          order: 7,
        },
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.deletionList')
    .controller('deletionListCtrl', deletionListCtrl);

  /** @ngInject */
  function deletionListCtrl(
    constants,
    $scope, $rootScope, $uibModal, $log, $state, $translate, commonUtils, tableConfig, persistFilter, ArnoDashAdminMembersService,
    clientApi, permissions, toastr, deletionListCtx, organizationId, deletionListPermissions, currentUser
  ) {
    var $ctrl = this;
    $ctrl.constants=constants;
    $ctrl.memberId = (currentUser || {}).id;
    var filterStorageKey = 'deletionListFilter';
    $ctrl.storedFilters = localStorage.getItem(filterStorageKey);
    var filters = JSON.parse($ctrl.storedFilters) || {};
    $ctrl.filterApplied = {};


    // get the list to display initially from the localstorage
    var divView = commonUtils.preference.object.get('pref_current_deletion_list_view_div', '0');
    var orgView = commonUtils.preference.object.get('pref_current_deletion_list_view_org', '0');
    // store custom tableViews here
    $ctrl.tableViewsDiv = {};
    $ctrl.tableViewsOrg = {};

    // get the default table views per div and org
    var divTableConf = tableConfig.tableConfigDivDefault;
    var orgTableConf = tableConfig.tableConfigOrgDefault;

    $ctrl.showMemberEditBtn = function (divisionMember, listType) {
      return ($ctrl.isPermitted(listType, 'arno.personnel.dossier', [divisionMember.DivisionId])
        || (listType.isOrgList && $ctrl.isPermitted(listType, 'arno.personnel.dossier', listType.ctx)));
    };

    $ctrl.handleCustomLists = function (customTableConfigs) {
      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        if (conf.IsOrg) {
          // get the pageSize retrieved from localstorage and stored in defaultView and add it to customViews
          conf.Fields.pageSize = tableConfig.tableConfigOrgDefault.pageSize;
          $ctrl.tableViewsOrg[conf.id] = conf;
        } else {
          conf.Fields.pageSize = tableConfig.tableConfigDivDefault.pageSize;
          $ctrl.tableViewsDiv[conf.id] = conf;
        }
      });
    };
    $ctrl.handleCustomLists(tableConfig.tableConfigCustomPreference);


    // if we got a custom view selected for initial display make sure it was not deleted before. if so, display default view
    if (divView.id) {
      // if we found an actual id in the localstorage, we assume its a custom table view
      if ($ctrl.tableViewsDiv[divView.id]) {
        divTableConf = $ctrl.tableViewsDiv[divView.id].Fields;
      } else {
        // if it is a custom view which got deleted already, reset to default view
        divView = '0';
      }
    }
    if (orgView.id) {
      if ($ctrl.tableViewsOrg[orgView.id]) {
        orgTableConf = $ctrl.tableViewsOrg[orgView.id].Fields;
      } else {
        orgView = '0';
      }
    }


    $ctrl.listTypes = [
      {
        title: $translate.instant('modules.personnel.deletionList.divMembers'),
        active: deletionListPermissions.div,
        selectedView: divView.id || divView, // will be used to determine the config to use
        isOrgList: false,
        tableConfig: divTableConf, // stores the current config
        customViews: $ctrl.tableViewsDiv, // stores the configs of custom lists
        defaultView: tableConfig.tableConfigDivDefault, // stores the default config
        chosenGroups: [],
        ctx: deletionListCtx,
        displayedCollection: []
      },
      {
        title: $translate.instant('modules.personnel.deletionList.orgMembers'),
        active: deletionListPermissions.org,
        selectedView: orgView.id || orgView,
        isOrgList: true,
        tableConfig: orgTableConf,
        customViews: $ctrl.tableViewsOrg,
        defaultView: tableConfig.tableConfigOrgDefault,
        ctx: ['rootOrg'],
        displayedCollection: []
      }
    ];
    $ctrl.listTypes.forEach(function (listType) {
      listType.getData = function (params, ctrl) {
        return $ctrl.getData(params, ctrl, listType);
      };
    });


    $ctrl.sortableOrg = [
      { fieldName: 'FirstName', sortProp: 'FirstName' },
      { fieldName: 'LastName', sortProp: 'LastName' },
      { fieldName: 'WithdrawalReason', sortProp: 'WithdrawalReasons.Reason' },
      { fieldName: 'DeletionTargetDate', sortProp: 'DeletionTargetDate' },
      { fieldName: 'EMail', sortProp: 'Account.EMail' },
    ];
    $ctrl.sortableDiv = [
      { fieldName: 'FirstName', sortProp: 'Member.FirstName' },
      { fieldName: 'LastName', sortProp: 'Member.LastName' },
      { fieldName: 'WithdrawalReason', sortProp: 'WithdrawalReasons.Reason' },
      { fieldName: 'DeletionTargetDate', sortProp: 'DeletionTargetDate' },
      { fieldName: 'EMail', sortProp: 'Member.Account.EMail' },
      { fieldName: 'DivisionName', sortProp: 'Division.Name' }
    ];

    // METHODS
    function storeTableConfig(listType) {
      commonUtils.preference.object.set(
        'pref_deletion_page_size_' + (listType.isOrgList ? 'org' : 'div'), {
          pageSize: listType.tableConfig.pageSize
        });
      if (listType.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_deletion_list_view_' + (listType.isOrgList ? 'org' : 'div'));
      } else {
        // store the id of the currently selected view
        commonUtils.preference.object.set(
          'pref_current_deletion_list_view_' + (listType.isOrgList ? 'org' : 'div'),
          { id: listType.selectedView }
        );
      }

    }

    $ctrl.checkState = function (state) {
      if (state === 'available') {
        return { 'color': 'green' };
      } else if (state === 'away') {
        return { 'color': '#ffff66' };
      } else {
        return { 'color': '#c2c2a3' };
      }
    };

    $ctrl.changePageSize = function (listType, num) {
      (listType ? [listType] : $ctrl.listTypes).forEach(function(list) {
        if (list.isOrgList) {
          list.tableConfig.pageSize = commonUtils.getPageSize('personnel_del_org_list_page_size', num);
        } else {
          list.tableConfig.pageSize = commonUtils.getPageSize('personnel_del_div_list_page_size', num);
        }
      })
      if (listType) {
        storeTableConfig(listType);
      }
    };
    $ctrl.changePageSize();

    $ctrl.changeListView = function (listType, val, storageIdentifier) {
      listType.hasViewModifications = false;
      if (val === '0') {
        listType.tableConfig = listType.defaultView;
      } else {
        listType.tableConfig = val.Fields;
      }
      listType.selectedView = storageIdentifier;
      storeTableConfig(listType);
      return $ctrl.reloadTable(listType);
    };


    $ctrl.reloadTable = function (listType) {
      if (listType && listType.tableCtrl) {
        return $ctrl.getData(listType.tableCtrl.tableState(), null, listType);
      }
    };


    $ctrl.openTableConfig = function (currentConf) {
      if (!$ctrl.isPermitted(currentConf,'arno.personnel.personnelList.configure', currentConf.ctx)) {
        return false;
      }
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return currentConf.isOrgList;
            },
            isMaterialList: function () {
              return false;
            },
            aggExclusion: function () {
              return [];
            },
            sortableFields: function () {
              return currentConf.isOrgList ? $ctrl.sortableOrg : $ctrl.sortableDiv;
            },
            availableFields: function () {
              return currentConf.isOrgList ? tableConfig.tableConfigAvailableFields.org : tableConfig.tableConfigAvailableFields.div;
            },
            currentList: function () {
              return { 'current': currentConf.tableConfig };
            },
            availableLists: function () {
              return JSON.parse(JSON.stringify(currentConf.customViews));
            }
          },
        })
        .result
        .then(function (res) {
          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;
          if (res.modifiedCurrentList) {
            // if we modified a current view we'll create a pseudo list which will not be stored
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;
            if (!currentConf.tableConfig.pageSize) {
              currentConf.tableConfig.pageSize = tableConfig.tableConfigDivDefault.pageSize;
            }
            $ctrl.reloadTable(currentConf);
          }
          toastr.success(
            $translate.instant('modules.personnel.deletionList.unblockToastText'),
            $translate.instant('modules.personnel.deletionList.unblockToastTitle')
          );
          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  // if we deleted the currently selected list, switch back to default view
                  $ctrl.changeListView(currentConf, '0', '0');
                }
                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id,
                    divisionId: deletionListCtx
                  })
                  .then(function () {
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }
          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (!currentConf.hasViewModifications && (val.id && val.id === JSON.parse(currentConf.selectedView))) {
                // to immediately update the table if we edited our current, db stored list. If we modified just the current view do nothing
                currentConf.tableConfig = _.merge(currentConf.tableConfig, val.Fields);
              }
              // update or create a new list
              customLists.push({
                id: val.id || false,
                ListType: 'deletionList',
                ListName: val.Name,
                IsOrg: currentConf.isOrgList,
                Fields: val.Fields,
                Sort: val.Sort,
              });
              newListAdded = !val.id ? true : newListAdded;
            });
            if (customLists.length > 0) {
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: deletionListCtx
                })
                .then(function () {
                  return clientApi
                      .custom('model/CustomListView', 'getUserTableConfigs', {
                        listType: 'deletionList',
                        divisionId: deletionListCtx
                      })
                      .then(function (lists) {
                        $ctrl.handleCustomLists(lists);
                        if (newListAdded) {
                          var maxId = Math.max.apply(Math, Object.values(_.mapValues(lists, function(l) { return l.id; })));
                          var newList = Object.values(_.pickBy(lists, function(list) {
                            return list.id == maxId;
                          }))[0];
                          $ctrl.changeListView(currentConf, newList, maxId);
                        }
                      });
                }
                );
            }
          }
          $ctrl.reloadTable(currentConf);
        });
    };

    $ctrl.removeWithdrawal = function (id, divId) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/administration/withdrawal/activateMember.modal.html',
          controller: 'activateCtrl as $activateCtrl',
          backdrop: 'static',
          size: 'md',
          resolve: {
            data: { isDiv: !!divId, isOwn: false }
          }
        })
        .result
        .then(function (reason) {
          if (reason === undefined) {
            return;
          }
          if (divId) {
            return clientApi
              .custom('model/DivisionMember', 'removeWithdrawal', {
                divMemberId: id,
                divId: divId,
                reasonComment: reason
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.deletionList.undoDeletionToastText'),
                  $translate.instant('modules.personnel.deletionList.undoDeletionToastTitle')
                );
                $state.reload();
              });
          }
          return clientApi
            .custom('model/Member', 'removeWithdrawal', {
              memId: id,
              reasonComment: reason
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.personnel.deletionList.undoDeletionToastText'),
                $translate.instant('modules.personnel.deletionList.undoDeletionToastTitle')
              );
              $state.reload();
            });
        });
    };

    $ctrl.getData = function (params, ctrl, listType) {
      listType.tableCtrl = ctrl || listType.tableCtrl;
      /* only for div level */
      var configuredSort = {
        predicate: false,
        reverse: false,
      };
      if (!params.sort.predicate) {
        if (listType.customViews[listType.selectedView] &&
          (listType.customViews[listType.selectedView].Sort &&
            Object.keys(listType.customViews[listType.selectedView].Sort).length
          )) {
          var propName = Object.keys(listType.customViews[listType.selectedView].Sort)[0];
          var predicate = listType.customViews[listType.selectedView].Sort[propName].sortProp;
          var reverse = listType.customViews[listType.selectedView].Sort[propName].direction === 'desc';
          configuredSort = {
            predicate: predicate,
            reverse: reverse,
          };
        }
      }
      var groupIds = [];
      if (!listType.isOrgList && listType.chosenGroups && listType.chosenGroups.length) {
        listType.chosenGroups.forEach(function (group) {
          groupIds.push(group.id);
        });
      }
      var currentCtx = listType.isOrgList ? 'rootOrg' : 'division';
      persistFilter.applyAndSave(filters, $ctrl.filterApplied, $ctrl.storedFilters, currentCtx, params, filterStorageKey, {
        groupIds: groupIds,
        chosenGroups: listType.chosenGroups
      });

      var queryWishes = {
        attributes: [],
        paging: {
          offset: (params.pagination.start / params.pagination.number) * listType.tableConfig.pageSize || 0,
          limit: listType.tableConfig.pageSize
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        memberGroups: groupIds ? groupIds : undefined,
        sort: {
          by: (params.sort && params.sort.predicate) || configuredSort.predicate,
          reverse: (params.sort && params.sort.reverse) || configuredSort.reverse
        }
      };
      var availableFields = listType.isOrgList ? tableConfig.tableConfigAvailableFields.org : tableConfig.tableConfigAvailableFields.div;
      _.forOwn(listType.tableConfig, function (value, key) {
        // find the property definitions for configured fields to add proper fieldName to query attributes
        if (value === true || value === 'true') {
          var found = _.find(availableFields, { prop: key });
          if (found) {
            queryWishes.attributes.push(found.field || found.prop);
          }
        }
      });
      if ($ctrl.isPermitted(listType, 'arno.personnel.administration.deleteMember', listType.ctx)) {
        if (listType.isOrgList) {
          return clientApi
            .custom('model/Member', 'findWithdrawingOrgMemberByOrganizationId', { queryWishes: queryWishes })
            .then(function (result) {
              params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
              if (result.count > 0 && result.rows.length === 0) {
                params.pagination.start = params.pagination.numberOfPages * listType.tableConfig.pageSize;
                persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
                $ctrl.getData(params, ctrl, listType);
              }
              persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
              var formattedResults = [];
              result.rows.forEach(function (member) {
                var Member = { Member: member };
                formattedResults.push(Member);
              });
              listType.displayedCollection = formattedResults;
            });
        } else {
          return ArnoDashAdminMembersService.findDivisionMembers(listType.ctx, queryWishes, false, {WithdrawalReasonId: true}, false)
            .then(function (result) {
              var formattedResults = result.rows;
              params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
              // we got a result that is paged wrongly (maybe the only entry on a page was removed by a dossier action)
              // move the paging one page back if we did actually get results, but no row entries
              if (result.count > 0 && result.rows.length === 0) {
                params.pagination.start = (params.pagination.numberOfPages * listType.tableConfig.pageSize) - listType.tableConfig.pageSize;
                persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
                $ctrl.getData(params, ctrl, listType);
              }
              persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
              listType.displayedCollection = formattedResults;
            });
        }
      } else {
        params.pagination.numberOfPages = 0;
        listType.displayedCollection = [];
      }
    };

    $ctrl.openDossier = function (member, listType) {
      if (member
        && $ctrl.isPermitted(listType, 'arno.personnel.dossier', [member.DivisionId])) {
        commonUtils.dossier.open(member.DivisionId, member.Member.Account.EMail);
      }
      if (listType.isOrgList && $ctrl.isPermitted(listType, 'arno.personnel.dossier', listType.ctx)) {
        commonUtils.dossier.open(listType.ctx, member.Member.Account.EMail);
      }
      return false;
    };


    $ctrl.isPermitted = function (listType, action, opt) {
      if (listType.isOrgList) {
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
      }
      return permissions.isPermittedInEvery(action, 'Division', opt, true);
    };

    $ctrl.getFullCSpan = function (tblConf) {
      var cSpan = 0;
      _.forOwn(tblConf, function () {
        cSpan++;
      });
      return cSpan;
    };

    $ctrl.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    $ctrl.listTypes.forEach(function (listType) {
      $scope.$watch(function () {
        return listType.tableConfig.Active;
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          storeTableConfig(listType);
          return $ctrl.reloadTable(listType);
        }
      }, true);

      $scope.$watch(function () {
        return listType.tableConfig.pageSize;
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          storeTableConfig(listType);
        }
      }, true);

      if (listType.chosenGroups) {
        $scope.$watch(function () {
          return listType.chosenGroups;
        }, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        }, true);
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.blockList', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel.blockList', {
        url: '/blockList',
        templateUrl: 'app/pages/personnel/blockList/blockList.html',
        title: 'navigation.personnel.blockList',
        controller: 'blockListCtrl as $ctrl',
        resolve: {
          blockListCtx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.personnel.administration.deleteMember',
            });
          },
          tableConfig: function (clientApi, blockListCtx, commonUtils, permissions, $rootScope, $translate) {
            var getDefaults = function (availableFields, customTableConfigs) {
              var orgPageSize = commonUtils.preference.object.get('pref_personnel_block_page_size_org', 10);
              var tableConfigOrgDefault = {
                FirstName: true,
                LastName: true,
                BlockReasons: true,
                pageSize: orgPageSize.pageSize || orgPageSize,
              };
              var divPageSize = commonUtils.preference.object.get('pref_personnel_block_page_size_div', 10);
              var tableConfigDivDefault = {
                FirstName: true,
                LastName: true,
                BlockReasons: true,
                pageSize: divPageSize.pageSize || divPageSize,
              };
              var divFields = JSON.parse(JSON.stringify(availableFields));
              var orgFields = JSON.parse(JSON.stringify(availableFields));
              // create own field lists for div and org level
              divFields.forEach(function (field) {
                if(!field.field){
                  // update the field definition to work for include model
                  field.field = 'Member.' + field.prop;
                }
              });
             
              
            
              
              divFields.push({ label:  $translate.instant('modules.personnel.blockList.blockReason'), prop: 'BlockReasons', field: 'BlockReasons.Name', sort: 15 });
              orgFields.push({ label:  $translate.instant('modules.personnel.blockList.blockReason'), prop: 'BlockReasons', field: 'BlockReasons.Name', sort: 15 });
              return {
                tableConfigAvailableFields: { div: divFields, org: orgFields },
                tableConfigOrgDefault: tableConfigOrgDefault,
                tableConfigDivDefault: tableConfigDivDefault,
                tableConfigCustomPreference: customTableConfigs
              };
            }
            if (permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Division', blockListCtx) ||
              permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Organization', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/Member', 'getAvailableFields', {
                  divisionId: blockListCtx,
                  language: $translate.use(),
                })
                .then(function (availableFields) {
                  return clientApi
                    .custom('model/CustomListView', 'getUserTableConfigs', {
                      listType: 'blockList',
                      divisionId: blockListCtx,
                    })
                    .then(function (customTableConfigs) {
                      return getDefaults(availableFields, customTableConfigs);
                    });
                });
            }
            return getDefaults([], []);
          },
          blockListPermissions: function ($rootScope, permissions) {
            return {
              org: permissions.isPermittedInEvery('arno.personnel.administration.deleteMember', 'Organization', [$rootScope.ctx.organization.current.id]),
              div: permissions.isPermittedAnywhere('arno.personnel.administration.deleteMember', ['Division'])
            };
          }
        },
        viewPermission: 'arno.personnel.administration.deleteMember',
        sidebarMeta: {
          order: 6,
        },
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.blockList')
    .controller('blockListCtrl', blockListCtrl);

  /** @ngInject */
  function blockListCtrl(
    constants,
    $scope, $rootScope, $uibModal, $log, $state, $translate,  commonUtils, tableConfig, persistFilter, ArnoDashAdminMembersService,
    clientApi, permissions, toastr, blockListCtx, organizationId, blockListPermissions, currentUser
  ) {
    var $ctrl = this;
    $ctrl.memberId = (currentUser || {}).id;
    var filterStorageKey = 'blockListFilter';
    $ctrl.storedFilters = localStorage.getItem(filterStorageKey);
    var filters = JSON.parse($ctrl.storedFilters) || {};
    $ctrl.filterApplied = {};
    $ctrl.constants=constants;

    // get the list to display initially from the localstorage
    var divView = commonUtils.preference.object.get('pref_current_block_list_view_div', '0');
    var orgView = commonUtils.preference.object.get('pref_current_block_list_view_org', '0');
    // store custom tableViews here
    $ctrl.tableViewsDiv = {};
    $ctrl.tableViewsOrg = {};

    // get the default table views per div and org
    var divTableConf = tableConfig.tableConfigDivDefault;
    var orgTableConf = tableConfig.tableConfigOrgDefault;

    $ctrl.showMemberEditBtn = function (divisionMember, listType) {
      return ($ctrl.isPermitted(listType, 'arno.personnel.dossier', [divisionMember.DivisionId])
        || (listType.isOrgList && $ctrl.isPermitted(listType, 'arno.personnel.dossier', listType.ctx)));
    };

    $ctrl.handleCustomLists = function (customTableConfigs) {
      customTableConfigs.forEach(function (conf) {
        conf.Fields = JSON.parse(conf.Fields);
        conf.Sort = JSON.parse(conf.Sort);
        if (conf.IsOrg) {
          // get the pageSize retrieved from localstorage and stored in defaultView and add it to customViews
          conf.Fields.pageSize = tableConfig.tableConfigOrgDefault.pageSize;
          $ctrl.tableViewsOrg[conf.id] = conf;
        } else {
          conf.Fields.pageSize = tableConfig.tableConfigDivDefault.pageSize;
          $ctrl.tableViewsDiv[conf.id] = conf;
        }
      });
    };
    $ctrl.handleCustomLists(tableConfig.tableConfigCustomPreference);


    // if we got a custom view selected for initial display make sure it was not deleted before. if so, display default view
    if (divView.id) {
      // if we found an actual id in the localstorage, we assume its a custom table view
      if ($ctrl.tableViewsDiv[divView.id]) {
        divTableConf = $ctrl.tableViewsDiv[divView.id].Fields;
      } else {
        // if it is a custom view which got deleted already, reset to default view
        divView = '0';
      }
    }
    if (orgView.id) {
      if ($ctrl.tableViewsOrg[orgView.id]) {
        orgTableConf = $ctrl.tableViewsOrg[orgView.id].Fields;
      } else {
        orgView = '0';
      }
    }

    $ctrl.removeBlockage = function (id, divId) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/personnel/dossier/administration/blockage/deBlockMember.modal.html',
          controller: 'deBlockCtrl as $deBlockCtrl',
          backdrop: 'static',
          size: 'md',
          resolve: {
            data: { isDiv: !!divId, isOwn: false }
          }
        })
        .result
        .then(function (reason) {
          if (reason === undefined) {
            return;
          }
          if (divId) {
            return clientApi
              .custom('model/DivisionMember', 'removeBlockage', {
                divMemberId: id,
                divId: divId,
                reasonComment: reason
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.personnel.blockList.unblockToastText'),
                  $translate.instant('modules.personnel.blockList.unblockToastTitle')
                );
                $state.reload();
              });
          }
          return clientApi
            .custom('model/Member', 'removeBlockage', {
              memId: id,
              reasonComment: reason
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.personnel.blockList.unblockToastText'),
                $translate.instant('modules.personnel.blockList.unblockToastTitle')
              );
              $state.reload();
            });
        });
    };

    $ctrl.listTypes = [
      {
        title: $translate.instant('modules.personnel.blockList.divMembers'),
        active: blockListPermissions.div,
        selectedView: divView.id || divView, // will be used to determine the config to use
        isOrgList: false,
        tableConfig: divTableConf, // stores the current config
        customViews: $ctrl.tableViewsDiv, // stores the configs of custom lists
        defaultView: tableConfig.tableConfigDivDefault, // stores the default config
        chosenGroups: [],
        ctx: blockListCtx,
        displayedCollection: []
      },
      {
        title: $translate.instant('modules.personnel.blockList.orgMembers'),
        active: blockListPermissions.org,
        selectedView: orgView.id || orgView,
        isOrgList: true,
        tableConfig: orgTableConf,
        customViews: $ctrl.tableViewsOrg,
        defaultView: tableConfig.tableConfigOrgDefault,
        ctx: ['rootOrg'],
        displayedCollection: []
      }
    ];
    $ctrl.listTypes.forEach(function (listType) {
      listType.getData = function (params, ctrl) {
        return $ctrl.getData(params, ctrl, listType);
      };
    });


    $ctrl.sortableOrg = [
      { fieldName: 'FirstName', sortProp: 'FirstName' },
      { fieldName: 'LastName', sortProp: 'LastName' },
      { fieldName: 'BlockReason', sortProp: 'BlockReasons.Reason' },
      { fieldName: 'EMail', sortProp: 'Account.EMail' },
    ];
    $ctrl.sortableDiv = [
      { fieldName: 'FirstName', sortProp: 'Member.FirstName' },
      { fieldName: 'LastName', sortProp: 'Member.LastName' },
      { fieldName: 'BlockReason', sortProp: 'BlockReasons.Reason' },
      { fieldName: 'EMail', sortProp: 'Member.Account.EMail' },
      { fieldName: 'DivisionName', sortProp: 'Division.Name' }
    ];

    // METHODS
    function storeTableConfig(listType) {
      commonUtils.preference.object.set(
        'pref_block_page_size_' + (listType.isOrgList ? 'org' : 'div'), {
          pageSize: listType.tableConfig.pageSize
        });
      if (listType.selectedView === '0') {
        commonUtils.preference.object.delete(
          'pref_current_block_list_view_' + (listType.isOrgList ? 'org' : 'div'));
      } else {
        // store the id of the currently selected view
        commonUtils.preference.object.set(
          'pref_current_block_list_view_' + (listType.isOrgList ? 'org' : 'div'),
          { id: listType.selectedView }
        );
      }

    }

    $ctrl.checkState = function (state) {
      if (state === 'available') {
        return { 'color': 'green' };
      } else if (state === 'away') {
        return { 'color': '#ffff66' };
      } else {
        return { 'color': '#c2c2a3' };
      }
    };

    $ctrl.changePageSize = function (listType, num) {
      (listType ? [listType] : $ctrl.listTypes).forEach(function(list) {
        if (list.isOrgList) {
          list.tableConfig.pageSize = commonUtils.getPageSize('personnel_block_org_list_page_size', num);
        } else {
          list.tableConfig.pageSize = commonUtils.getPageSize('personnel_block_div_list_page_size', num);
        }
      })
      if (listType) {
        storeTableConfig(listType);
      }
    };
    $ctrl.changePageSize();

    $ctrl.changeListView = function (listType, val, storageIdentifier) {
      listType.hasViewModifications = false;
      if (val === '0') {
        listType.tableConfig = listType.defaultView;
      } else {
        listType.tableConfig = val.Fields;
      }
      listType.selectedView = storageIdentifier;
      storeTableConfig(listType);
      return $ctrl.reloadTable(listType);
    };


    $ctrl.reloadTable = function (listType) {
      if (listType && listType.tableCtrl) {
        return $ctrl.getData(listType.tableCtrl.tableState(), null, listType);
      }
    };


    $ctrl.openTableConfig = function (currentConf) {
      if (!$ctrl.isPermitted(currentConf,'arno.personnel.personnelList.configure', currentConf.ctx)) {
        return false;
      }
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/tableConfig/tableConfig.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'tableConfigCtrl as $tableConfigCtrl',
          resolve: {
            isOrgList: function () {
              return currentConf.isOrgList;
            },
            isMaterialList: function () {
              return false;
            },
            aggExclusion: function () {
              return [];
            },
            sortableFields: function () {
              return currentConf.isOrgList ? $ctrl.sortableOrg : $ctrl.sortableDiv;
            },
            availableFields: function () {
              return currentConf.isOrgList ? tableConfig.tableConfigAvailableFields.org : tableConfig.tableConfigAvailableFields.div;
            },
            currentList: function () {
              return { 'current': currentConf.tableConfig };
            },
            availableLists: function () {
              return JSON.parse(JSON.stringify(currentConf.customViews));
            }
          },
        })
        .result
        .then(function (res) {
          var availableLists = res.availableLists;
          var deletedLists = res.deletedLists;
          if (res.modifiedCurrentList) {
            // if we modified a current view we'll create a pseudo list which will not be stored
            currentConf.hasViewModifications = true;
            currentConf.tableConfig = res.modifiedCurrentList;
            if (!currentConf.tableConfig.pageSize) {
              currentConf.tableConfig.pageSize = tableConfig.tableConfigDivDefault.pageSize;
            }
            $ctrl.reloadTable(currentConf);
          }
          toastr.success(
            $translate.instant('modules.personnel.blockList.tblConfToastText'),
            $translate.instant('modules.personnel.blockList.tblConfToastTitle')
          );
          if (deletedLists.length > 0) {
            deletedLists.forEach(function (list) {
              if (list) {
                if (list.id === JSON.parse(currentConf.selectedView)) {
                  // if we deleted the currently selected list, switch back to default view
                  $ctrl.changeListView(currentConf, '0', '0');
                }
                clientApi
                  .custom('model/CustomListView', 'removeUserTableConfig', {
                    listId: list.id,
                    divisionId: blockListCtx
                  })
                  .then(function () {
                    if (currentConf.customViews[list.id]) {
                      delete currentConf.customViews[list.id];
                    }
                  });
              }
            });
          }
          if (availableLists) {
            var customLists = [];
            var newListAdded = false;
            _.forOwn(availableLists, function (val) {
              if (!currentConf.hasViewModifications && (val.id && val.id === JSON.parse(currentConf.selectedView))) {
                // to immediately update the table if we edited our current, db stored list. If we modified just the current view do nothing
                currentConf.tableConfig = _.merge(currentConf.tableConfig, val.Fields);
              }
              // update or create a new list
              customLists.push({
                id: val.id || false,
                ListType: 'blockList',
                ListName: val.Name,
                IsOrg: currentConf.isOrgList,
                Fields: val.Fields,
                Sort: val.Sort,
              });
              newListAdded = !val.id ? true : newListAdded;
            });
            if (customLists.length > 0) {
              return clientApi
                .custom('model/CustomListView', 'storeUserTableConfigs', {
                  customLists: customLists,
                  divisionId: blockListCtx
                })
                .then(function () {
                  return clientApi
                      .custom('model/CustomListView', 'getUserTableConfigs', {
                        listType: 'blockList',
                        divisionId: blockListCtx
                      })
                      .then(function (lists) {
                        $ctrl.handleCustomLists(lists);
                        if (newListAdded) {
                          var maxId = Math.max.apply(Math, Object.values(_.mapValues(lists, function(l) { return l.id; })));
                          var newList = Object.values(_.pickBy(lists, function(list) {
                            return list.id == maxId;
                          }))[0];
                          $ctrl.changeListView(currentConf, newList, maxId);
                        }
                      });
                }
                );
            }
          }
          $ctrl.reloadTable(currentConf);
        });
    };


    $ctrl.getData = function (params, ctrl, listType) {
      listType.tableCtrl = ctrl || listType.tableCtrl;
      /* only for div level */
      var configuredSort = {
        predicate: false,
        reverse: false,
      };
      if (!params.sort.predicate) {
        if (listType.customViews[listType.selectedView] &&
          (listType.customViews[listType.selectedView].Sort &&
            Object.keys(listType.customViews[listType.selectedView].Sort).length
          )) {
          var propName = Object.keys(listType.customViews[listType.selectedView].Sort)[0];
          var predicate = listType.customViews[listType.selectedView].Sort[propName].sortProp;
          var reverse = listType.customViews[listType.selectedView].Sort[propName].direction === 'desc';
          configuredSort = {
            predicate: predicate,
            reverse: reverse,
          };
        }
      }
      var groupIds = [];
      if (!listType.isOrgList && listType.chosenGroups && listType.chosenGroups.length) {
        listType.chosenGroups.forEach(function (group) {
          groupIds.push(group.id);
        });
      }
      var currentCtx = listType.isOrgList ? 'rootOrg' : 'division';
      persistFilter.applyAndSave(filters, $ctrl.filterApplied, $ctrl.storedFilters, currentCtx, params, filterStorageKey, {
        groupIds: groupIds,
        chosenGroups: listType.chosenGroups
      });

      var queryWishes = {
        attributes: [],
        paging: {
          offset: (params.pagination.start / params.pagination.number) * listType.tableConfig.pageSize || 0,
          limit: listType.tableConfig.pageSize
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        memberGroups: groupIds ? groupIds : undefined,
        sort: {
          by: (params.sort && params.sort.predicate) || configuredSort.predicate,
          reverse: (params.sort && params.sort.reverse) || configuredSort.reverse
        }
      };
      if (!tableConfig.tableConfigAvailableFields) {
        tableConfig.tableConfigAvailableFields = {};
      }
      var availableFields = listType.isOrgList ? tableConfig.tableConfigAvailableFields.org : tableConfig.tableConfigAvailableFields.div;
      _.forOwn(listType.tableConfig, function (value, key) {
        // find the property definitions for configured fields to add proper fieldName to query attributes
        if (value === true || value === 'true') {
          var found = _.find(availableFields, { prop: key });
          if (found) {
            queryWishes.attributes.push(found.field || found.prop);
          }
        }
      });
      if ($ctrl.isPermitted(listType, 'arno.personnel.administration.deleteMember', listType.ctx)) {
        if (listType.isOrgList) {
          return clientApi
            .custom('model/Member', 'findBlockedOrgMemberByOrganizationId', { queryWishes: queryWishes })
            .then(function (result) {
              params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
              if (result.count > 0 && result.rows.length === 0) {
                params.pagination.start = params.pagination.numberOfPages * listType.tableConfig.pageSize;
                persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
                $ctrl.getData(params, ctrl, listType);
              }
              persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
              var formattedResults = [];
              result.rows.forEach(function (member) {
                var Member = { Member: member };
                formattedResults.push(Member);
              });
              listType.displayedCollection = formattedResults;
            });
        } else {
          return ArnoDashAdminMembersService.findDivisionMembers(listType.ctx, queryWishes, false, {BlockReasonId: true}, false)
            .then(function (result) {
              var formattedResults = result.rows;
              params.pagination.numberOfPages = Math.ceil(result.count / listType.tableConfig.pageSize);
              // we got a result that is paged wrongly (maybe the only entry on a page was removed by a dossier action)
              // move the paging one page back if we did actually get results, but no row entries
              if (result.count > 0 && result.rows.length === 0) {
                params.pagination.start = (params.pagination.numberOfPages * listType.tableConfig.pageSize) - listType.tableConfig.pageSize;
                persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
                $ctrl.getData(params, ctrl, listType);
              }
              persistFilter.setPaginationPersist(filters, currentCtx, params.pagination, filterStorageKey);
              listType.displayedCollection = formattedResults;
            });
        }
      } else {
        params.pagination.numberOfPages = 0;
        listType.displayedCollection = [];
      }
    };

    $ctrl.openDossier = function (member, listType) {
      if (member
        && $ctrl.isPermitted(listType, 'arno.personnel.dossier', [member.DivisionId])) {
        commonUtils.dossier.open(member.DivisionId, member.Member.Account.EMail);
      }
      if (listType.isOrgList && $ctrl.isPermitted(listType, 'arno.personnel.dossier', listType.ctx)) {
        commonUtils.dossier.open(listType.ctx, member.Member.Account.EMail);
      }
      return false;
    };


    $ctrl.isPermitted = function (listType, action, opt) {
      if (listType.isOrgList) {
        return permissions.isPermittedInEvery(action, 'Organization', [$rootScope.ctx.organization.current.id], true);
      }
      return permissions.isPermittedInEvery(action, 'Division', opt, true);
    };

    $ctrl.getFullCSpan = function (tblConf) {
      var cSpan = 0;
      _.forOwn(tblConf, function () {
        cSpan++;
      });
      return cSpan;
    };

    $ctrl.prevent = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    $ctrl.listTypes.forEach(function (listType) {
      $scope.$watch(function () {
        return listType.tableConfig.Active;
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          storeTableConfig(listType);
          return $ctrl.reloadTable(listType);
        }
      }, true);

      $scope.$watch(function () {
        return listType.tableConfig.pageSize;
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          storeTableConfig(listType);
        }
      }, true);

      if (listType.chosenGroups) {
        $scope.$watch(function () {
          return listType.chosenGroups;
        }, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            return $ctrl.reloadTable(listType);
          }
        }, true);
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier')
    .controller('PersonnelApprovalCtrl', PersonnelDossierCtrl);

  function PersonnelDossierCtrl(preSelected, allowedReferences, tableConfig, memberGroups) {
    var self = this;
    self.approvalProcesses = [];
    self.allowedReferences = allowedReferences;
    self.tableConfig = tableConfig;
    self.memberGroups = memberGroups;
    self.preSelected = {};
    if (preSelected && preSelected.approvalAllocId && preSelected.approvalAllocVersion) {
      self.preSelected = preSelected;
      window.location.hash = window.location.hash.replace(/\?.*$/, '');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialTabCtrl', MaterialTabCtrl);

  function MaterialTabCtrl(permissions, divisionId, $translate) {
    var self = this;
    self.materialTabs = [
      {
        heading: '<i class="fa fa-medkit mr-4"></i>' + $translate.instant('modules.material.addMaterial.medication'),
        route: 'arno.material.overview.medicine',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialMedicine.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="fa fa-heartbeat mr-4"></i>' + $translate.instant('modules.material.addMaterial.medicalProducts'),
        route: 'arno.material.overview.medicalProducts',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialMedicalProducts.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="fa fa-car mr-4"></i>' + $translate.instant('modules.material.addMaterial.carpool'),
        route: 'arno.material.overview.vehicles',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialVehicles.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="ion-tshirt mr-4"></i>' + $translate.instant('modules.material.addMaterial.clothing'),
        route: 'arno.material.overview.clothing',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialClothing.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="ion-hammer mr-4"></i>' + $translate.instant('modules.material.addMaterial.TechnDevices'),
        route: 'arno.material.overview.tools',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialTools.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="ion-cube mr-4"></i>' + $translate.instant('modules.material.addMaterial.consumerMaterial'),
        route: 'arno.material.overview.consumables',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialConsumables.edit,arno.material.view', 'Division', divisionId),
      },
      {
        heading: '<i class="fa fa-archive mr-4"></i>' + $translate.instant('modules.material.addMaterial.other'),
        route: 'arno.material.overview.other',
        isPermitted: permissions.isPermittedInSome('arno.virtual.item.materialOthers.edit,arno.material.view', 'Division', divisionId),
      },
    ]

    self.divisionSelectorEntryPermission = 'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.view';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialStorageDetailsCtrl', MaterialStorageDetailsCtrl);

  function MaterialStorageDetailsCtrl(material, storageIconMap, modelMap, deleteHint) {
    var self = this;
    self.storageIconMap = storageIconMap;
    self.modelMap = modelMap;
    self.deleteHint = deleteHint;
    self.contents = {};
    self.material = material;
    self.tabStates = {};
    Object.keys(material).forEach(function(key) {
      if (key.endsWith('StorageContent')) {
        if (material[key]) {
          self.contents[key.split('StorageContent')[0]] = material[key].split('✂');
        }
      }
    })
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('SplitMaterialCtrl', SplitMaterialCtrl);

  function SplitMaterialCtrl(material) {
    var self = this;

    self.originalAmount = material.Amount;
    self.initialValue = Math.floor(self.originalAmount / 2);
    // duplicate OR dont the files ( Tab Dokumentenablage )
    self.isFile = false;
    // duplicate OR dont the Events ( Tab Fristen und Ereignisse )
    self.isEvent = false;
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('SplitCountCtrl', SplitCountCtrl);

  function SplitCountCtrl(originalAmount) {
    var self = this;
    self.originalAmount = originalAmount;
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.statistics', [])
    .controller('MaterialStatisticsCtrl', MaterialStatisticsCtrl);

  function MaterialStatisticsCtrl() {
    var self = this;
    self.showTip = false;
    self.toggleTip = function () {
      self.showTip = !self.showTip;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('SelectCtrl', SelectCtrl);

  function SelectCtrl($uibModal, $state, $scope, currentTableHead, fullDataset, preSelect, multiSelect, currentPropSet, toastr, $uibModalInstance) {
    var self = this;
    self.currentTableHead = currentTableHead;
    self.fullTableData = fullDataset;
    self.currentPropSet = currentPropSet;
    self.selectedItems = {};
    self.multiSelect = multiSelect;
    fullDataset.forEach(function(material) {
      self.selectedItems[material.id] = preSelect;
    })

    self.checkSelection = function(id) {
      if (!multiSelect) {
        // wipe selection as we are only allowed to select one
        Object.keys(self.selectedItems).forEach(function(key) {
          // int == str
          if (key != id) {
            delete self.selectedItems[key];
          }
        });
      }
    }
    self.confirmSelection = function(data) {
      $uibModalInstance.close(fullDataset.filter(function(material) {
        return data[material.id];
      }));
    }
  }
})();

(function () {
  'use strict';
  
  angular
      .module('BlurAdmin.pages.material.overview')
      .controller('InventoryExportCtrl', InventoryExportCtrl);
  
  function InventoryExportCtrl($uibModalInstance, $scope, $translate, basicFields, businessPartnerFields) {
    var self = this;
  
    self.selectItems = [
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelXlsx'),
        value: 'xlsx'
      },
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelCsv'),
        value: 'csv'
      },
    ];
    self.isTabVisible = function (propName) {
      var found = basicFields.find(function(element) {
        return element.prop === propName;
      });
      return found !== undefined;
    };

    self.selected = self.selectItems[0];


    var fieldToExclude = [
      'Owner',
      'Manufacturer',
      'Supplier',
      'MaintenanceCompany',
      'ExtensionManufacturer',
      'ResponsibleWorkshop',
      'ResponsibleCompany'
    ]
    var availableFields = basicFields.filter(function (head) {
      return fieldToExclude.indexOf(head.prop) == -1 
    }).map(function (head) {
      return { label: head.label, prop: head.prop, selected: false };
    });       

    var unfilteredFieldSetsWithVisibility = {
      'base': true,
      'manufacturer': true,
      'owner': true,
      'supplier': self.isTabVisible('Supplier'),
      'maintenanceCompany': self.isTabVisible('MaintenanceCompany'),
      'responsibleCompany': self.isTabVisible('ResponsibleCompany'),
      'extensionManufacturer': self.isTabVisible('ExtensionManufacturer'),
      'responsibleWorkshop': self.isTabVisible('ResponsibleWorkshop'),
    }

    // apply field settings and filter by visibility
    self.fieldSets = Object.keys(unfilteredFieldSetsWithVisibility).reduce(function (acc, key) {
      if (unfilteredFieldSetsWithVisibility[key]) {
        // currently all other fields are organisations/business partners and will have the same fields everywhere
        acc[key] = key === 'base' ? availableFields : _.cloneDeep(businessPartnerFields);
      } 
      return acc
    }, {})

    self.toggleCheckboxesStates = {}

    self.toggleFields = function (propName) {
      var checked = self.toggleCheckboxesStates[propName];

      if (propName === 'all') {
        Object.keys(self.fieldSets).forEach(function (key) {
          self.fieldSets[key].forEach(function (element) {
            element.selected = checked;
          });
        });
      } else {
        self.fieldSets[propName].forEach(function (element) {
          element.selected = checked;
        });
      }
    }

    $scope.$watch(function () { return self.fieldSets }, function (newVal) {
      // check if inputs are full to also check according "select all" boxes
      var allSelected = true;

      Object.keys(newVal).forEach(function (key) {
        var allSelectedInSet = newVal[key].every(function (element) {
          return element.selected;
        });
        self.toggleCheckboxesStates[key] = allSelectedInSet;
        allSelected = allSelected && allSelectedInSet;
      })

      self.toggleCheckboxesStates['all'] = allSelected;
    }, true)


    self.applyModal = function () {
      var data = {
        selectedFields: [],
        lookupTablesHead: [],
        filetype: self.selected.value,
      }

      Object.keys(self.fieldSets).forEach(function (key) {
        if (key === 'base') {
          data.selectedFields = self.fieldSets[key].filter(function (entry) {
            return entry.selected;
          })
        } else {
          // get all checked entries
          var selected = (self.fieldSets[key].filter(function (entry) {
            return entry.selected;
          }) || []).map(function (entry) {
            return entry.prop;
          });

          if (selected.length > 0) {
            data.lookupTablesHead.push({
              lookupColumn: _.upperFirst(key),
              columns: selected,
              columnLabelKeys: businessPartnerFields.filter(function (entry) {
                return selected.indexOf(entry.prop) !== -1;
              })
            });
            data.selectedFields.push({
              prop: _.upperFirst(key),
              label: $translate.instant('components.tableConfig.fields.' + key)
            })
          }
        }
      })

      $uibModalInstance.close(
        data
      );
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('MaterialChooseExportTypeCtrl', MaterialChooseExportTypeCtrl);

  function MaterialChooseExportTypeCtrl($uibModalInstance, $translate) {
    var self = this;

    self.selectItems = [
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelXlsx'),
        value: 'xlsx'
      },
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelCsv'),
        value: 'csv'
      },
    ];
    self.selected = self.selectItems[0];
    self.fieldOption = 'tableConfig';
    self.filterOption = 'filtered';

    self.applyModal = function () {
      $uibModalInstance.close({
        options: {
          fields: self.fieldOption,
          filter: self.filterOption,
        },
        filetype: self.selected.value,
      });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.demand', [])
    .controller('MaterialDemandCtrl', MaterialDemandCtrl);

  function MaterialDemandCtrl($scope, divisionId, clientApi, commonUtils, $uibModal, toastr, $translate,
    ArnoDashMaterialsService, permissions) {
    var self = this;
    self.daysInFuture = 7;
    self.itemsPerPage = 10;
    self.demandData = [];
    self.demandDataMap = {};
    self.dateSpan = false;
    self.isMultiDiv = divisionId && divisionId.length > 1;
    var preservedTableParams;
    var modalVals;

    self.hasEdit = permissions.isPermittedInEvery('arno.material.edit', 'Division', divisionId, true);

    self.taskMode = {
      keys: {
        on: $translate.instant('modules.material.demandForAction.taskModeAll'),
        off: $translate.instant('modules.material.demandForAction.taskModeOpenTasks'),
      },
      width: 150,
      disabled: true,
    };

    $scope.$watch(function() {
      return self.taskMode.disabled;
    }, function(newVal, oldVal) {
      if (newVal !== oldVal) {
        self.reload(null, { resetPaging: true });
      }
    });

    self.selected = {};
    self.selectCount = 0;
    $scope.$watch(function() {
      return _.compact(Object.values(self.selected)).length;
    }, function(selectCount) {
      self.selectCount = selectCount;
    });

    self.deselectAll = function() {
      Object
        .keys(self.selected)
        .forEach(function (key) {
          delete self.selected[key];
        });
    }

    self.addInspectionEvent = function() {
      var demands = _
        .keys(self.selected)
        .filter(function(demandId) {
          return self.selected[demandId];
        })
        .map(function (demandId) {
          return self.demandDataMap[demandId];
        });
      return ArnoDashMaterialsService
        .addInspectionEvent(
          divisionId,
          _.uniq(_.map(demands, 'MaterialId')),
          _.mapValues(
            _.groupBy(demands, 'MaterialId'),
            function (v) {
              return v.map(function (e) {
                return e.MaterialCategory
              })
            }
          ),
          null,
          false,
          demands.map(function (demand) {
            return _.pick(demand, ['MaterialId', 'InspectionId', 'InspectionLabel', 'MaterialCategory']);
          })
        )
        .then(function () {
          self.deselectAll();
          self.reload();
        });
    }

    self.setPageSize = function(num) {
      self.itemsPerPage = commonUtils.getPageSize('mat_demand_list_page_size', num);
    }
    self.setPageSize();

    self.setWellKnownDateSpan = function(days) {
      self.daysInFuture = days;
      self.dateSpan = null;
      self.reload(null, { resetPaging: true });
    }

    self.openDateSpanModal = function() {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/setDatespanModal/setDateSpan.html',
          size: 'md',
          backdrop: 'static',
          controller: 'DatespanCtrl as $dateCtrl',
          resolve: {
            dateVals: modalVals
          },
        })
        .result
        .then(function(res) {
          self.dateSpan = { start: res.start, end: res.end };
          modalVals = { start: res.start, end: res.end };
          self.reload(null, { resetPaging: true });
        })
        .catch(function() {
          //mmh k
        })
    }

    self.reload = function(stTableParams, opts) {
      var options = opts || {};
      // options.resetPaging

      if (!stTableParams && preservedTableParams) {
        stTableParams = preservedTableParams;
      }
      if (!stTableParams) {
        return;
      }

      if (options.resetPaging) {
        stTableParams.pagination.start = 0;
      }

      if (!self.taskMode.disabled) {
        delete stTableParams.sort.predicate;
        delete stTableParams.sort.reverse;
      }

      var queryWishes = {
        paging: {
          offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.itemsPerPage || 0,
          limit: self.itemsPerPage
        },
        filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
        sort: {
          by: stTableParams.sort.predicate,
          reverse: stTableParams.sort.reverse
        },
        onlyTasks: !self.taskMode.disabled,
      };

      if (self.dateSpan) {
        queryWishes.startDate = self.dateSpan.start;
        queryWishes.endDate = self.dateSpan.end;
      } else {
        queryWishes.endDate = Date.now() + 60000 * 60 * 24 * self.daysInFuture;
      }

      preservedTableParams = stTableParams;

      if (!divisionId || !divisionId.length) {
        return null;
      }

      return clientApi
        .custom('model/MaterialInspectionDemand', 'getDemandForAction', { divisionId: divisionId, queryWishes: queryWishes })
        .then(function(res) {
          if (res.result) {
            res = res.result;
          }
          res.rows
            .forEach(function (row) {
              row.MaterialCategoryLabel = $translate.instant('navigation.material.overview.' + _.lowerFirst(row.MaterialCategory.replace(/^Material/, '')));
            });
          self.demandData = res.rows;
          self.demandDataMap = _.assign(self.demandDataMap, _.keyBy(self.demandData, 'id'));

          if (stTableParams) {
            stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.itemsPerPage);
            if (res.count > 0 && res.rows.length === 0) {
              stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.itemsPerPage;
            }
          }
        });
    }

    self.openMaterialDossier = function(materialId, materialModel, event) {
      event.stopPropagation();
      return ArnoDashMaterialsService.openAddModal(
        { id: materialId },
        'update',
        false,
        divisionId,
        materialModel
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.material.overview')
    .controller('AddMaterialCtrl', AddMaterialCtrl);

  function AddMaterialCtrl($scope, $location, $rootScope, $uibModal, $state, isAggregatedView, aggregatedAmount, availableFields, fullRow, fieldConfig, toastr,
    $uibModalInstance, divisionId, licenses, templateAvailable, materialTypes, storageIconMap, modelMap, saveMaterial, viewOnly,
    clientApi, currentModel, permissions, folderData, flatQualificationHierarchy, $translate, $timeout, commonUtils, $stateParams,
    screenSize, baModalService, isSplit, ArnoDashMaterialsService, isAdd) {
    var self = this;
    self.fieldConfig = fieldConfig;
    self.divisionId = divisionId;
    self.isAggregatedView = isAggregatedView;
    self.aggregatedAmount = aggregatedAmount;
    self.back = false;
    self.isSplit = isSplit;
    self.isAdd = isAdd;
    self.viewOnly = viewOnly;
    self.availableFields = availableFields;
    self.storageIconMap = storageIconMap;
    self.folderData = folderData;
    self.templateAvailable = (templateAvailable || {}).exists;
    self.materialAddForm;
    self.model = currentModel;
    self.memberInputPristine = true;
    self.flatQualificationHierarchy = flatQualificationHierarchy;
    self.showOptionalInspections = false;
    self.storageIdent = _.lowerFirst(currentModel);
    self.instructionConfigurationPendingActions = 0;
    self.materialName = fullRow ? (fullRow[0].Name || fullRow[0].Definition || fullRow[0].VehicleModel || fullRow[0].Type) : null;
    self.materialId = fullRow ? (fullRow.id || (fullRow[0] && fullRow[0].id)) : null;
    self.activeTabIndex = parseInt($stateParams.tab);

    if (fullRow) {
      self.materialName = Array.isArray(fullRow) ?
        (fullRow[0].Name || fullRow[0].Definition || fullRow[0].VehicleModel || fullRow[0].Type) :
        (fullRow.Name || fullRow.Definition || fullRow.VehicleModel || fullRow.Type);
    }

    $rootScope.addMaterialModalInstance = $uibModalInstance;

    $scope.$on('$destroy', function () {
      delete $rootScope.addMaterialModalInstance;
    });

    self.fieldGroupDefinitions = {
      MaterialVehicles: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.basicData'),
            fields: [
              'VehicleModel',
              'Manufacturer',
              'MaterialType',
              'LicensePlate',
              'ExtensionManufacturer',
              'ChassisNumber',
              'BuiltIn',
              'InitialRegistration',
              'Length',
              'Width',
              'Height',
              'AllowedTotalWeight',
              'EmptyWeight',
              'CarryWeight',
            ]
          },
          {
            title: $translate.instant('modules.material.addMaterial.organizational'),
            fields: ['ResponsibleWorkshop']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Owner', 'RadioCallName', 'AcquisitionDate', 'InfoLink', 'Amount', 'Note', 'VehicleType']
          },
          {
            title: $translate.instant('modules.material.addMaterial.equipment'),
            fields: [
              'FuelType',
              'Seats',
              'SpecialEquipment',
              'CommunicationsEquipment',
              'SpecialSignallingDevice',
              'ElectricFeeding',
              'TailLift',
              'TrailerHitch',
              'HitchType',
              'TowingCapacity',
            ]
          }
        ]
      },
      MaterialClothing: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.properties'),
            fields: ['Name', 'Manufacturer', 'MaterialType', 'Category', 'Size', 'Color', 'Condition', 'Standards', 'Equipment', 'Logo']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Owner', 'AcquisitionDate', 'Amount', 'InfoLink', 'Note']
          }
        ]
      },
      MaterialTools: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.basicData'),
            fields: [
              'Manufacturer',
              'Definition',
              'MaterialType',
              'CreationDate',
              'BuiltIn',
              'AcquisitionDate',
              'Color',
              'RadioCallName',
              'ISSI',
              'SerialNumber',
              'CEIdent',
              'TEI',
              'Properties',
              'Weight',
            ]
          },
          {
            title: $translate.instant('modules.material.addMaterial.organizational'),
            fields: ['Owner', 'Supplier', 'ResponsibleCompany', 'MaintenanceCompany', 'IntroductionNeeded', 'Extras']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Amount', 'InfoLink', 'Note', 'Handover']
          }
        ]
      },
      MaterialOthers: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.basicData'),
            fields: ['Name', 'Manufacturer', 'MaterialType', 'Definition', 'Color', 'Size']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Owner', 'AcquisitionDate', 'Amount', 'InfoLink', 'Note', 'Storage']
          }
        ]
      },
      MaterialMedicine: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.medicalData'),
            fields: ['Definition', 'MaterialType', 'Content', 'Properties', 'Manufacturer', 'BatchNumber', 'PharmacyCentralNumber']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Owner', 'AcquisitionDate', 'Amount', 'InfoLink']
          }
        ]
      },
      MaterialConsumables: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.basicData'),
            fields: ['Definition', 'MaterialType', 'Color', 'Manufacturer', 'Brand', 'Type']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['Note', 'Owner', 'AcquisitionDate', 'Amount', 'InfoLink']
          }

        ]
      },
      MaterialMedicalProducts: {
        PropGroups: [
          {
            title: $translate.instant('modules.material.addMaterial.basicData'),
            fields: [
              'Type',
              'Manufacturer',
              'Definition',
              'MaterialType',
              'CreationDate',
              'BuiltIn',
              'AcquisitionDate',
              'Color',
              'RadioCallName',
              'ISSI',
              'SerialNumber',
              'CEIdent',
              'UniqDeviceIdent',
              'RiskClass',
              'MPBVAssignment',
              'OperatingMode',
              'Properties',
            ]
          },
          {
            title: $translate.instant('modules.material.addMaterial.organizational'),
            fields: ['Owner', 'Supplier', 'ResponsibleCompany', 'MaintenanceCompany', 'IntroductionNeeded', 'Extras']
          },
          {
            title: $translate.instant('modules.material.addMaterial.internalData'),
            fields: ['InventoryNumber', 'Amount', 'InfoLink', 'Note']
          }
        ]
      }
    };

    self.HitchTypes = [{
      Name: $translate.instant('models.MaterialVehicles.BallCoupling'),
      Value: 'BALL_COUPLING',
    }, {
      Name: $translate.instant('models.MaterialVehicles.JawCoupling'),
      Value: 'JAW_COUPLING',
    }, {
      Name: $translate.instant('models.MaterialVehicles.PinCoupling'),
      Value: 'PIN_COUPLING',
    }];

    self.VehicleTypes = [{
      Name: $translate.instant('models.MaterialVehicles.NoMotorVehicle'),
      Value: null,
    }, {
      Name: $translate.instant('models.MaterialVehicles.Streetable'),
      Value: 'streetable',
    }, {
      Name: $translate.instant('models.MaterialVehicles.OffRoadCapable'),
      Value: 'off_road_capable',
    }, {
      Name: $translate.instant('models.MaterialVehicles.AllTerrain'),
      Value: 'all_terrain',
    }];



    self.mediaSizeXs = screenSize.on('xs', function (match) {
      self.mediaSizeXs = match;
    });

    self.fieldGroups = [];
    self.setFieldGroups = function () {
      angular.forEach(self.fieldGroupDefinitions[currentModel].PropGroups, function (group) {
        var objectGroup = [];
        angular.forEach(group.fields, function (gField) {
          var field = _.find(self.availableFields, function (field) {
            return field.prop === gField;
          });
          if (field) {
            objectGroup.push(field);
          }
        });
        self.fieldGroups.push({
          title: group.title,
          fields: objectGroup
        });
      });
    };

    self.intructionByMemberTabState = {};
    self.instructionTabState = function (fullName) {
      return self.intructionByMemberTabState[fullName];
    };
    self.setInstructionMemberTabState = function (fullName) {
      self.intructionByMemberTabState[fullName] = !self.intructionByMemberTabState[fullName];
    };
    self.setFieldGroups();
    self.licenseClasses = licenses;

    self.configuredInstructions = [];

    self.getRelevantInstructions = function () {
      var qualificationIds = _.uniq(_.map(self.materialQualifications, 'QualificationId'));
      return clientApi
        .custom('model/MemberQualification', 'getMaterialQualifications', {
          qualificationIds: qualificationIds,
          divisionId: divisionId,
          materialModel: currentModel,
          materialId: self.addModel.id
        })
        .then(function (result) {
          var mappedResult = result.map(function (mqd) {
            return self.formatInstructorForTable(mqd);
          });

          self.materialQualificationDocumentationsGrouped = self.createGroupFromDocumentedQualifications(mappedResult);
          self.materialQualificationDocumentations = mappedResult;
        });
    };

    self.createGroupFromDocumentedQualifications = function (materialQualificationDocumentations) {
      var groupedByQualification = materialQualificationDocumentations.reduce(function (acc, mqd) {
        var find = acc.find(function (a) {
          return a.QualificationId === mqd.QualificationId;
        });

        if (find) {
          find.content.push(mqd);
        } else {
          acc.push({
            Qualification: mqd.Qualification,
            QualificationId: mqd.QualificationId,
            content: [mqd],
          });
        }

        return acc;
      }, []);
      groupedByQualification = groupedByQualification.map(function (group) {
        var personDistinctCount = _.countBy(group.content, 'MemberId');

        return Object.assign(group, {
          personDistinctCount: personDistinctCount,
          personCount: Object.keys(personDistinctCount).length
        });
      });

      _.groupBy(materialQualificationDocumentations, 'Qualification');

      // create group for all required entries (first dropdown in ui)
      // group shows users who are instructed to ALL required ones and instruction is not expired
      var requiredQualificationIds = self.materialQualifications.filter(function (mq) {
        return mq.Required;
      }).map(function (mq) {
        return mq.QualificationId;
      });
      var reqAndStdQualIds = self.materialQualifications.filter(function (mq) {
        return mq.Required && mq.PartOfInstruction;
      }).map(function (mq) {
        return mq.QualificationId;
      });

      var fullyInstructedUsers = _.uniq(_.map(materialQualificationDocumentations, 'MemberId')).map(function (memberId) {
        var memberEntries = materialQualificationDocumentations.filter(function (mq) {
          return mq.MemberId === memberId;
        });

        // check if all requiredQualificationIds exist in memberEntries
        var allRequiredQualificationsExist = requiredQualificationIds.every(function (requiredId) {
          return memberEntries.some(function (memberEntry) {
            return requiredId === (
              memberEntry.includedByChildQualificationId
              || memberEntry.QualificationId)
              && (
                !memberEntry.ExpireDate
                || new Date(memberEntry.ExpireDate) > new Date());
          });
        });

        if (!allRequiredQualificationsExist) {
          return null;
        }

        var withIcon = reqAndStdQualIds && reqAndStdQualIds.length ? reqAndStdQualIds.every(function (requiredId) {
          return memberEntries.some(function (memberEntry) {
            return requiredId === memberEntry.QualificationId
            && (!memberEntry.ExpireDate || new Date(memberEntry.ExpireDate) > new Date())
            && memberEntry.InitialInstructionByManufacturerOrAuthorizedPerson;
          });
        }) : false;

        return {
          memberId: memberId,
          member: memberEntries[0].Member,
          entries: memberEntries,
          withIcon: withIcon
        };
      }).filter(function (m) { return m; });

      var allEntriesList = {
        Qualification: {
          Name: $translate.instant('modules.material.addMaterial.allInstructionEntries')
        },
        QualificationId: null,
        content: fullyInstructedUsers,
        personCount: fullyInstructedUsers.length,
        open: true
      };
      groupedByQualification.unshift(allEntriesList);

      return groupedByQualification;
    };

    self.setPageSize = function (num, key, varKey) {
      self[varKey] = commonUtils.getPageSize(key, num);
    };
    self.setPageSize(null, 'addmat_assigned_inspections', 'itemsPerPageAssignedInspections');
    self.setPageSize(null, 'addmat_assigned_inspection_events', 'itemsPerPageAssignedInspectionEvents');

    self.materialTypes = materialTypes.map(function (materialType) {
      return _.pick(materialType, ['id', 'Name', 'MaterialsAssignable', 'ParentMaterialType', 'Division']);
    });

    self.addModel = {};
    self.updateMode = Array.isArray(fullRow) || fullRow;
    self.responsibleMembers = [];
    self.HandedOverToMember = [];
    self.isHandedOverToMemberUpdated = false;
    // fullRow.forEach(function (material) {
    //   if (material.MaterialsHandedOver) {
    //     var isMemberAlreadyInTheList = self.HandedOverToMember.some(function (listMember) {
    //       return listMember.HandedOverToId === material.MaterialsHandedOver.HandedOverToId;
    //     });
    //     if (isMemberAlreadyInTheList === false) {
    //       self.HandedOverToMember.push(material.MaterialsHandedOver);
    //     }
    //   }
    // });
    self.materialQualifications = [];
    self.originalMaterialQualifications = [];

    self.editPlaceholders = Array.isArray(fullRow) ? fullRow[0] : (fullRow || {});
    if (!self.editPlaceholders) {
      self.editPlaceholders = {};
    }
    self.datePickerStates = {};
    self.switcherKeys = { on: $translate.instant('generalTerms.yes'), off: $translate.instant('generalTerms.no') };
    self.memberExclude = [];
    self.storageCategoryOptions = [
      {
        label: $translate.instant('modules.material.addMaterial.allCategories'),
      },
      {
        key: 'MaterialMedicine',
        label: $translate.instant('modules.material.addMaterial.medication'),
      },
      {
        key: 'MaterialVehicles',
        label: $translate.instant('modules.material.addMaterial.carpool'),
      },
      {
        key: 'MaterialClothing',
        label: $translate.instant('modules.material.addMaterial.clothing'),
      },
      {
        key: 'MaterialTools',
        label: $translate.instant('modules.material.addMaterial.TechnDevices'),
      },
      {
        key: 'MaterialConsumables',
        label: $translate.instant('modules.material.addMaterial.consumerMaterial'),
      },
      {
        key: 'MaterialOthers',
        label: $translate.instant('modules.material.addMaterial.other'),
      },
      {
        key: 'MaterialMedicalProducts',
        label: $translate.instant('modules.material.addMaterial.medicalProducts'),
      },
      {
        key: 'nonMaterial',
        label: $translate.instant('modules.material.addMaterial.freetext'),
      },
    ];
    self.tabStates = {};
    self.modelMap = modelMap;
    self.activeCategory = {
      label: $translate.instant('modules.material.addMaterial.allCategories'),
    };
    self.tooltipStates = {};
    self.materialHead = self.editPlaceholders.Name
      || self.editPlaceholders.Definition
      || self.editPlaceholders.VehicleModel
      || ('(' + modelMap[currentModel] + ')');
    self.materialHead = '(' + $translate.instant('models.' + currentModel + '.Titel') + ')';

    if (Array.isArray(fullRow) && fullRow.length > 1) {
      self.materialHead = fullRow.length + ' ' + $translate.instant('modules.material.addMaterial.datasets');
    }
    self.datepicker = {
      format: 'dd.MM.yyyy',
      options: {
        showWeeks: false,
        datepickerMode: 'year',
      }
    };

    self.isPermitted = function (perm) {
      return permissions.isPermittedInEvery(perm, 'Division', Array.isArray(divisionId) ? divisionId : [divisionId], true);
    };
    self.isSingleMaterial = (fullRow && (!Array.isArray(fullRow) || fullRow.length === 1)) || fullRow === null;
    self.isNew = !fullRow;
    if (self.isSingleMaterial && !self.isNew) {
      self.currentMaterialType = _.find(materialTypes, function (t) {
        return t.id === ((fullRow.MaterialType || {}).id || ((fullRow[0] || {}).MaterialType || {}).id);
      });
    }
    if (self.isSingleMaterial && !self.isNew) {
      var row = fullRow[0] || fullRow;
      self.priceInfo = {
        ExternalPricePerCount: row.ExternalPricePerCount,
        ExternalPricePerDay: row.ExternalPricePerDay,
        ExternalPricePerHour: row.ExternalPricePerHour,
        InternalPricePerCount: row.InternalPricePerCount,
        InternalPricePerDay: row.InternalPricePerDay,
        InternalPricePerHour: row.InternalPricePerHour,
      };
      if (!_.compact(Object.keys(self.priceInfo).map(function (p) {
        return self.priceInfo[p];
      })).length) {
        var base = (row.MaterialType || {}).PriceItemOverrides
        && (row.MaterialType || {}).PriceItemOverrides.length ? row.MaterialType.PriceItemOverrides[0] : (row.MaterialType || {});
        self.priceInfo = {
          ExternalPricePerCount: base.ExternalPricePerCount,
          ExternalPricePerDay: base.ExternalPricePerDay,
          ExternalPricePerHour: base.ExternalPricePerHour,
          InternalPricePerCount: base.InternalPricePerCount,
          InternalPricePerDay: base.InternalPricePerDay,
          InternalPricePerHour: base.InternalPricePerHour,
        };
      }
    }

    self.isPermittedForFileStorage = self.isPermitted([
      'arno.material.edit',
      'arno.material.view',
      'arno.virtual.item.materialMedicine.edit',
      'arno.virtual.item.materialClothing.edit',
      'arno.virtual.item.materialOthers.edit',
      'arno.virtual.item.materialConsumables.edit',
      'arno.virtual.item.materialTools.edit',
      'arno.virtual.item.materialVehicles.edit',
      'arno.virtual.item.materialMedicalProducts.edit',
    ].join(','));
    var rowIds = [];

    var mergeRows = function (rows) {
      rowIds = rows.map(function (r) {
        return r.id;
      });
      // mimic the aggregation here by comma separating all different values
      // this will also allow us to immediately fill any fields that only have 1 true value
      // and set placeholders for the ones that have multiple values
      var tmpObj = {};
      var exclude = [
        'ResponsibleMember',
        'LicenseClass',
        'id',
        'Storage',
        'StorageId',
        'StorageContents',
        'StorageTags',
        'CostCenterSpecification',
      ]; // arrays get merged later

      var dateExcludes = [
        'LastMTK',
        'NextMTK',
        'LastSTK',
        'NextSTK',
      ];

      $scope.$watch('self.documentationsTableShowMultiplicator', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          self.reloadTable(self.currentTableConf, false);
        }
      });

      self.ctc = function () {
        return commonUtils.copyToClipboard($location.absUrl());
      };

      var isUniqMaterialType = _.uniq(rows.map(function (r) {
        return (r.MaterialType || {}).id;
      })).length <= 1;
      rows.forEach(function (row) {
        if (row.MaterialsHandedOver) {
          var isMemberAlreadyInTheList = self.HandedOverToMember.some(function (listMember) {
            return listMember.HandedOverToId === row.MaterialsHandedOver.HandedOverToId;
          });
          if (isMemberAlreadyInTheList === false) {
            self.HandedOverToMember.push(row.MaterialsHandedOver);
          }
        }
        if (row.StorageContents) {
          // will only be resolved on single rows when we click detail view on storage tags
          var storageObj = {};
          Object.keys(row.StorageContents).forEach(function (storageKey) {
            if (storageKey.startsWith('Material')) {
              var modelKey = modelMap[storageKey] ? storageKey : storageKey.substr(0, storageKey.length - 1);
              storageObj[modelKey] = row.StorageContents[storageKey];
            }
          });
          self.StorageContents = storageObj;
        }
        Object.keys(row)
          .filter(function (r) {
            return !~exclude.indexOf(r);
          })
          .forEach(function (prop) {
            if (row[prop]) {
              if (prop === 'MaterialType') {
                if (rows.length > 1 && !isUniqMaterialType) {
                  row[prop] = (row[prop] || {}).Name;
                } else {
                  row[prop] = (row[prop] || {}).id;
                }
              }
              if (
                fieldConfig[prop] &&
                fieldConfig[prop].type === 'date' &&
                ((!~dateExcludes.indexOf(prop) && rows.length === 1) ||
                  (rows.length > 1 && _.uniq(rows.map(function (r) {
                    return r[prop];
                  })).length !== 1))
              ) {
                row[prop] = moment(row[prop]).format('DD.MM.YYYY');
              } else if (prop === 'BuiltIn') {
                row[prop] = row[prop].toString();
              }
              if (!tmpObj[prop]) {
                tmpObj[prop] = row[prop];
              } else {
                if ((fieldConfig[prop] || {}).type === 'businessPartner') {
                  var concatStr = (typeof tmpObj[prop] === 'string'
                      ? tmpObj[prop]
                      : tmpObj[prop].Name) + '|~~~|' + (typeof row[prop] === 'string'
                        ? row[prop] : row[prop].Name);
                  if (typeof tmpObj[prop] !== 'object') {
                    tmpObj[prop] = {};
                  }
                  tmpObj[prop].Name = concatStr;

                } else {
                  tmpObj[prop] = tmpObj[prop] + '|~~~|' + row[prop];
                }
              }
            } else if (!row[prop]) {
              if (!tmpObj[prop]) {
                tmpObj[prop] = '#~EMPTY~#';
              } else {
                if ((fieldConfig[prop] || {}).type === 'businessPartner' && typeof tmpObj[prop] === 'object') {
                  tmpObj[prop].Name = tmpObj[prop].Name + '|~~~|#~EMPTY~#';
                } else {
                  tmpObj[prop] = tmpObj[prop] + '|~~~|#~EMPTY~#';
                }
              }
            }
          });
      });

      Object.keys(tmpObj).forEach(function (prop) {
        if (fieldConfig[prop] && fieldConfig[prop].type === 'businessPartner' && rows.length === 1) {
          // preserve the bp object
          self.addModel[prop] = tmpObj[prop];
          return;
        }
        var splitVal = _.uniq((((tmpObj[prop] || {}).Name || tmpObj[prop]) || '').toString().split('|~~~|'));
        // only join non-empty vals
        // we just keep them to identify if the value is a uniq among all resolved rows
        // if it isn't we can only set it as a placeholder, otherwise we can fill the model
        var joinedVal = splitVal.filter(function (v) {
          return v !== '#~EMPTY~#';
        }).join(', ');

        // careful with dates and bools
        // switcher can't display multivalue so definitely never set the model, or we might override something we're not supposed to
        // dates are wonky in the picker input, no reason to set as model as you have to use the pick functionality anyways
        if (splitVal.length > 1 || (fieldConfig[prop] &&
          (fieldConfig[prop].type === 'date' || (splitVal.length > 1 && fieldConfig[prop].type === 'bool'))) &&
          prop !== 'BuiltIn') {
          if (!!~dateExcludes.indexOf(prop) && !~joinedVal.indexOf('|~~~|')) {
            self.addModel[prop] = joinedVal;
          } else {
            self.editPlaceholders[prop] = joinedVal;
          }
        } else if (joinedVal) {
          try {
            if (prop === 'BuiltIn') {
              self.addModel[prop] = joinedVal;
            } else if (fieldConfig[prop].type === 'businessPartner') {
              if (!self.addModel[prop]) {
                self.addModel[prop] = {};
              }
              self.addModel[prop].Name = joinedVal;
            }
            // also check length because it will parse strings that start with a number as a number even if it might not be
            else if (!isNaN(parseInt(joinedVal)) && parseInt(joinedVal).toString().length === joinedVal.length) {
              self.addModel[prop] = parseInt(joinedVal);
            } else if (!isNaN(parseFloat(joinedVal)) && parseFloat(joinedVal).toString().length === joinedVal.length) {
              self.addModel[prop] = parseFloat(joinedVal);
            } else if (fieldConfig[prop].type === 'bool') {
              self.addModel[prop] = tmpObj[prop];
            } else {
              self.addModel[prop] = joinedVal;
            }
          } catch (e) {
            self.addModel[prop] = joinedVal;
          }
        }
      });

      // merge arrays
      rows.forEach(function (row) {
        if (row.ResponsibleMember && typeof Array.isArray(row.ResponsibleMember)) {
          self.responsibleMembers = _.uniqBy(self.responsibleMembers.concat(row.ResponsibleMember), 'MemberId');
          self.updateExcludes();
        }

        if (row.LicenseClass && typeof Array.isArray(row.LicenseClass)) {
          self.addModel.LicenseClass = _.uniqBy(self.addModel.LicenseClass.concat(row.LicenseClass), 'Name');
        }

        if (row.MaterialQualification && typeof Array.isArray(row.MaterialQualification)) {
          self.materialQualifications = _.uniqBy(self.materialQualifications.concat(row.MaterialQualification), 'QualificationId');
        }
      });

      function contactToString(contact) {
        if (!contact) {
          return '';
        }

        var result = contact.Function;
        if (contact.FirstName || contact.LastName) {
          result += ' ';
          if (contact.Salutation) {
            result += $translate.instant('models.Member.Salutation.' + contact.Salutation) + ' ';
          }

          result += (contact.FirstName ? (contact.FirstName + ' ') : '') + (contact.LastName || '');
        }

        return result;
      }






      if (self.addModel && self.addModel.HitchType) {
        self.addModel.HitchType = _.find(self.HitchTypes, function (type) {
          return type.Value === self.addModel.HitchType;
        });

      }

      if (self.addModel && self.addModel.VehicleType) {
        self.addModel.VehicleType = _.find(self.VehicleTypes, function (type) {
          return type.Value === self.addModel.VehicleType;
        });

      }

      self.formatInstructorForTable = function (mqd) {
        if (mqd.InstructingContact) {
          mqd.InstructingPerson = {
            type: 'contact',
            id: mqd.InstructingContact.ContactId,
            data: mqd.InstructingContact,
            asString: contactToString(mqd.InstructingContact)
          };
        } else if (mqd.InstructingMember) {
          mqd.InstructingPerson = {
            type: 'member',
            id: mqd.InstructingMember.MemberId,
            data: mqd.InstructingMember,
            asString: mqd.InstructingMember.fullName || mqd.InstructingMember.Member.fullName,
          };
        } else if (mqd.InstructingBusinessPartner) {
          mqd.InstructingPerson = {
            type: 'businessPartner',
            id: mqd.InstructingBusinessPartner.BusinessPartnerId,
            data: mqd.InstructingBusinessPartner,
            asString: mqd.InstructingBusinessPartner.Name,
          };
        }

        return mqd;
      };

      self.getRelevantInstructions();
      self.originalMaterialQualifications = _.cloneDeep(self.materialQualifications);

      // merge objects
      var uniqStorages = _.uniqWith(rows.map(function (row) {
        return row.Storage;
      }), function (x, y) {
        if ((x && !y) || (!x && y)) {
          return false;
        }
        if (!x && !y) {
          return true;
        }
        return x.OriginId === y.OriginId && x.Name === y.Name && x.OriginName === y.OriginName;
      });
      if (rows.length > 1 && uniqStorages.length > 1) {
        self.editPlaceholders.Storage = {};
        self.editPlaceholders.Storage.Name = uniqStorages.map(function (obj) {
          return (obj && obj.Name) || '-';
        })
          .join(', ');
      } else if (uniqStorages.length === 1) {
        self.addModel.Storage = uniqStorages[0];
      }

      // will only be displayed when a single row is selected, so just grab index 0
      self.addModel.CostCenterSpecification = (rows[0] || {}).CostCenterSpecification;
    };

    if (self.updateMode) {
      self.addModel.id = self.editPlaceholders.id;
    }

    if (!self.addModel.Amount && !Array.isArray(fullRow) && !self.updateMode) {
      self.addModel.Amount = self.editPlaceholders.Amount || 1;
    }

    if (self.editPlaceholders && self.editPlaceholders.LicenseClass) {
      self.editPlaceholders.LicenseClass.forEach(function (lc) {
        delete lc._MaterialLicenseClass;
      });
      self.addModel.LicenseClass = self.editPlaceholders.LicenseClass;
    }

    self.findMaterialTypeById = function (id) {
      return self.materialTypes.find(function (materialType) {
        return materialType.id === id;
      });
    };

    self.removePlaceholder = function (prop) {
      delete self.editPlaceholders[prop];
    };

    self.addResponsibleMember = function (member) {
      self.responsibleMembers.push(member);
      self.memberInputPristine = false;
      self.updateExcludes();
    };

    self.updateExcludes = function () {
      self.memberExclude.splice(0, self.memberExclude.length);
      _.merge(self.memberExclude, self.responsibleMembers.map(function (m) {
        return m.MemberId;
      }));
    };
    if (self.editPlaceholders && self.editPlaceholders.ResponsibleMember) {
      self.responsibleMembers = self.editPlaceholders.ResponsibleMember;
      self.updateExcludes();
    }
    if (self.updateMode && Array.isArray(fullRow)) {
      mergeRows(fullRow);
    } else if (self.updateMode) {
      mergeRows([fullRow]);
    }

    self.removeHandedOverTo = function (HandedOverToId) {
      self.HandedOverToMember = self.HandedOverToMember.filter(function (member) {
        return member.HandedOverToId !== HandedOverToId;
      });
      if (self.HandedOverToMember.length <= 1) {
        self.isHandedOverToMemberUpdated = true;
      }
    };

    self.setHandedOverTo = function (member) {
      var newHandedOverTo = member.Member;
      newHandedOverTo.HandedOverToId  = member.MemberId;
      self.HandedOverToMember = [newHandedOverTo];
      self.isHandedOverToMemberUpdated = true;
    };

    self.removeMember = function (member) {
      self.memberInputPristine = false;
      var index = _.findIndex(self.responsibleMembers, function (m) {
        return m.MemberId === member.MemberId;
      });
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!~index) {
        self.responsibleMembers.splice(index, 1);
        self.updateExcludes();
      }
    };

    self.searchOrSetStorageLocations = function (searchValue) {
      // set it to the searchvalue in case the user enters a new self-defined location
      // if the user sees something in the search result he wants to pick, this will get overwritten with the proper object
      if (searchValue) {
        self.removePlaceholder('Storage');
        self.addModel.Storage = {
          Name: searchValue,
          OriginModel: null,
          OriginId: null,
        };
      }
      return clientApi.custom('model/StorageLocationMaterial', 'getStorageLocations', {
        divisionId: self.divisionId,
        materialModel: self.activeCategory.key,
        searchValue: searchValue,
        excludes: rowIds,
        exclusionSource: currentModel
      }, { backgroundRequest: true })
        .then(function (result) {
          self.storageResults = result;
        });
    };

    self.getDossierUrl = function (member) {
      var memberObj = member.Member || member;
      return commonUtils.dossier.getUrl(memberObj.Account.EMail);
    };

    self.isPermittedForDossier = function () {
      return self.isPermitted('arno.personnel.dossier,arno.administration.personnel.accountType.manage');
    };

    function updatePendingActions(listToUpdate) {
      return listToUpdate.filter(function (mq) {
        return mq.pendingAction !== 'delete';
      }).map(function (mq) {
        mq.pendingAction = null;
        if (mq.Qualification && mq.Qualification.id) {
          mq.QualificationId = mq.Qualification.id;
        }
        return mq;
      });
    }

    self.saveMaterial = function (data) {
      var valid = true;
      var idsToUpdate = [];
      if (!self.updateMode) {
        Object.keys(fieldConfig).forEach(function (key) {
          if (fieldConfig[key] && fieldConfig[key].required && !data[key]) {
            valid = false;
          }
        });
      }
      if (valid) {
        if (data.MaterialType && typeof data.MaterialType === 'number') {
          data.MaterialType = _.find(materialTypes, function (t) {
            return t.id === data.MaterialType;
          });
        }
        if (data.HitchType) {
          data.HitchType = data.HitchType.Value;
        }

        if (data.VehicleType) {
          data.VehicleType = data.VehicleType.Value;
        }
        Object.keys(self.fieldConfig).forEach(function (field) {
          if (self.fieldConfig[field].pickerFormatter && self.addModel[field]) {
            self.addModel[field] = self.fieldConfig[field].pickerFormatter(self.addModel[field]);
          }
        });

        Object.keys(data).forEach(function (key) {
          if (data[key] === '') {
            data[key] = null;
          }
        });
        // update tags manually for splitting
        if (data.Storage && typeof data.Storage !== 'string') {
          data.StorageTags = [{
            id: data.Storage.OriginId,
            model: data.Storage.OriginModel,
            label: data.Storage.Name,
            permitted: data.Storage.permitted,
          }];
        }

        if (fullRow && Array.isArray(fullRow)) {
          // prevent updating these values with nulls if they haven't been touched
          if (fullRow.length > 1 && currentModel === 'MaterialTools') {
            [
              'LastMTK',
              'LastSTK',
              'NextMTK',
              'NextSTK',
            ].forEach(function (key) {
              if ((self.materialAddForm[key + 'Input'] && self.materialAddForm[key + 'Input'].$pristine) || !moment(data[key])._isValid) {
                delete data[key];
              }
            });
            if (self.materialAddForm.DeadlineMTKInput.$pristine && data.DeadlineMTK === null) {
              delete data.DeadlineMTK;
            }
            if (self.materialAddForm.DeadlineSTKInput.$pristine && data.DeadlineSTK === null) {
              delete data.DeadlineSTK;
            }
          }
          idsToUpdate = fullRow.map(function (row) {
            return row.id;
          });
        } else if (fullRow && fullRow.id) {
          idsToUpdate.push(fullRow.id);
        }

        if (self.HandedOverToMember.length > 1) {
          self.isHandedOverToMemberUpdated = false;
          if (self.HandedOverToMember.length === 1 && self.isHandedOverToMemberUpdated) {
            data.HandedOverToId = self.HandedOverToMember[0].MemberId;
          }
          if (self.HandedOverToMember.length === 0 && self.isHandedOverToMemberUpdated) {
            data.HandedOverToId = null;
          }
        }

        var handedOverToMemberData = {
          isHandedOverToMemberUpdated: self.isHandedOverToMemberUpdated,
          handedOverToMember: self.HandedOverToMember.length === 1 ? self.HandedOverToMember[0] : null,
        };

        return saveMaterial({
          material: data,
          responsibleMembers: self.memberInputPristine && !isSplit ? null : self.responsibleMembers,
          handedOverToMember: handedOverToMemberData,
          materialQualifications: self.materialQualifications,
          materialQualificationDocumentations: self.materialQualificationDocumentations,
          idsToUpdate: idsToUpdate,
        }).then(function (r) {
          if (!r) {
            return;
          }

          self.getAssignedInspections();

          self.materialQualifications = updatePendingActions(self.materialQualifications);
          self.instructionConfigurationPendingActions = 0; // reset unsaved changes
          self.getRelevantInstructions();
          if (self.back) {
            $uibModalInstance.close(r);
          } else if (r.id) {
            // only for 'add' mode
            $state.go($state.current.name, {
              materialId: r.id,
            });
          }
          // fix for bad handling of value and name in Frontend <-> saving value
          self.addModel.VehicleType = _.find(self.VehicleTypes, function (type) {
            return type.Value === self.addModel.VehicleType;
          });
        });
      } else {
        toastr.error($translate.instant('modules.material.addMaterial.neccessaryfields'), $translate.instant('modules.material.addMaterial.neccessaryfields2'));
      }
    };

    self.setBusinessPartner = function (bp, prop) {
      self.removePlaceholder(prop);
      self.addModel[prop] = bp;
    };

    self.setCostCenterSpec = function (ccsp) {
      self.removePlaceholder('CostCenterSpecification');
      self.addModel.CostCenterSpecification = ccsp;
      self.addModel.CostCenterSpecificationId = (ccsp || {}).id || null;
    };

    self.execHooks = function (prop) {
      if (fieldConfig[prop] && fieldConfig[prop].hookTo && fieldConfig[prop].hookTo.length) {
        var ll = fieldConfig[prop].hookTo.length;
        // hooks eval with OR, if one of them evals to true the field will not be disabled
        for (var i = 0; i < ll; i++) {
          if (Object(fieldConfig[prop].hookTo[i])) {
            var keys = Object.keys(fieldConfig[prop].hookTo[i]);
            for (var j = 0; j < keys.length; j++) {
              if (Array.isArray(fieldConfig[prop].hookTo[i][keys[j]])) {
                // eslint-disable-next-line no-extra-boolean-cast
                if (!!~fieldConfig[prop].hookTo[i][keys[j]].indexOf(self.addModel[keys[j]])) {
                  self.tooltipStates[prop] = false;
                  return false;
                }
              } else if (self.addModel[keys[j]] === fieldConfig[prop].hookTo[i][keys[j]]) {
                self.tooltipStates[prop] = false;
                return false;
              }
            }
          } else if (typeof fieldConfig[prop].hookTo[i] === 'string') {
            if (self.addModel[fieldConfig[prop].hookTo[i]]) {
              self.tooltipStates[prop] = false;
              return false;
            }
          }
        }
      } else {
        return false;
      }
      self.tooltipStates[prop] = true;
      delete self.addModel[prop];
      self.removePlaceholder(prop);
      return true;
    };

    self.getStorageIcon = function (model) {
      if (!model) {
        return 'ion-ios-filing';
      }
      return self.storageIconMap[model];
    };

    self.getPH = function (ph) {
      return (ph && typeof ph === 'string' ? ph : '');
    };

    self.materialTypeGroupByParent = function (type) {
      return (type.ParentMaterialType || {}).Name || (type.Division || {}).Name || $rootScope.ctx.organization.current.name;
    };

    self.onDocumentationPendingDelete = function (index) {
      self.materialQualificationDocumentations.splice(index, 1);
    };

    self.openQualificationModal = function (mode) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/addMaterialModal/materialQualificationModal/materialQualificationModal.html',
          controller: 'MaterialQualificationModalCtrl as self',
          size: 'xl',
          backdrop: 'static',
          resolve: {
            flatQualificationHierarchy: function () {
              if (mode === 'edit') {
                return self.flatQualificationHierarchy;
              }

              // do not show qualifications to select that are already configured
              var selectedQualificationIds = self.materialQualifications.map(function (entry) {
                return entry.Qualification.id;
              });
              return self.flatQualificationHierarchy.filter(function (qualification) {
                return !~selectedQualificationIds.indexOf(qualification.id);
              });
            },
            viewOnly: function () {
              return self.viewOnly;
            },
            materialQualifications: function () {
              return self.materialQualifications;
            }
          }
        }).result
        .then(function (result) {
          self.materialQualifications = result.materialQualifications;

          self.instructionConfigurationPendingActions = result.materialQualifications.reduce(function (acc, entry) {
            if (entry.pendingAction) {
              acc++;
            }
            return acc;
          }, 0);
        });
    };

    self.openDocumentQualificationModal = function (mode, documentation) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/pages/material/addMaterialModal/materialQualificationModal/materiaQualificationDocumentModal.html',
          controller: 'MaterialQualificationDocumentModalCtrl as self',
          size: 'md',
          backdrop: 'static',
          resolve: {
            data: function () {
              return documentation;
            },
            mode: function () {
              return mode;
            },
            configuredQualifications: function () {
              if (mode !== 'view') {
                return clientApi.custom('model/' + self.model + 'Qualification', 'getAllForMaterial', {
                  divisionId: self.divisionId,
                  materialId: self.addModel.id
                });
              }
              return [];
            },
            divisionId: function () {
              return self.divisionId;
            }
          }
        }).result
        .then(function (result) {
          result.MaterialQualification.forEach(function (qualification) {
            var singleEntry = Object.assign(_.cloneDeep(result), { MaterialQualification: qualification });
            self.materialQualificationDocumentations.push(Object.assign(singleEntry, {
              pendingAction: 'add',
              Qualification: singleEntry.MaterialQualification && singleEntry.MaterialQualification.Qualification || {},
              QualificationId: singleEntry.MaterialQualification.Qualification.id,
            }));
          });

          self.materialQualificationDocumentations.forEach(function (mqd) {
            mqd = self.formatInstructorForTable(mqd);

            if (mqd.InstructedMembers) {
              mqd.Member = mqd.InstructedMembers.shift();
              mqd.MemberId = mqd.Member.MemberId;

              while (mqd.InstructedMembers.length > 0) {
                var newMember = mqd.InstructedMembers.shift();
                self.materialQualificationDocumentations.push(Object.assign(_.cloneDeep(mqd), {
                  Member: newMember,
                  MemberId: newMember.MemberId
                }));
              }

              delete mqd.InstructedMembers;
            }
          });

          self.materialQualificationDocumentationsGrouped = self.createGroupFromDocumentedQualifications(self.materialQualificationDocumentations);
        });
    };

    // Inspections

    self.fromMatType = {
      NO: $translate.instant('generalTerms.no'),
      YES: $translate.instant('generalTerms.yes'),
      ALTERED: $translate.instant('modules.material.addMaterial.inspection.altered'),
    };

    self.inspectionEventResults = {
      PASSED: $translate.instant('modules.material.addMaterial.inspection.eventStatePassed'),
      FAILED: $translate.instant('modules.material.addMaterial.inspection.eventStateFailed'),
      DONE: $translate.instant('modules.material.addMaterial.inspection.eventStateDone'),
    };

    $scope.$watch(function () {
      return self.showOptionalInspections;
    }, function () {
      if (self.savedQw) {
        self.getAssignedInspections();
      }
    });

    self.addInspection = function (item) {
      return $uibModal
        .open({
          animation: true,
          templateUrl: 'app/theme/components/modals/inspectionAssignmentModal/addInspection.modal.html',
          size: 'md',
          backdrop: 'static',
          controller: 'addMaterialInspectionCtrl as self',
          resolve: {
            ctx: function () {
              return self.divisionId;
            },
            excludedIds: function () {
              return clientApi
                .custom('model/' + currentModel + 'Inspection', 'getInspectionSelectorExcludes', {
                  divisionId: self.divisionId,
                  materialId: self.materialId,
                })
                .then(function (res) {
                  return res.excludeIds || [];
                });
            },
            selectedInspection: function () {
              return (item && item.Inspection) || null;
            },
            meta: function () {
              if (!item) {
                return null;
              }
              return {
                Mandatory: item.Mandatory,
                Interval: item.Interval,
                Description: item.Description,
              };
            },
            disableMandatoryChange: function () {
              return item && item.FromMaterialType === 'YES' && item.Mandatory;
            },
            maxInterval: function () {
              return item && item.FromMaterialType === 'YES' ? item.Interval : null;
            },
            materialMode: function () {
              return true;
            },
            viewOnly: function () {
              return !!self.viewOnly;
            },
          },
        })
        .result
        .then(function (res) {
          if (item && item.FromMaterialType !== 'NO') {
            res.meta.FromMaterialType = 'ALTERED';
          }
          return clientApi
            .custom('model/' + currentModel + 'Inspection', 'assignInspections', {
              materialId: self.materialId,
              data: [{
                inspection: {
                  id: res.inspection.id,
                },
                meta: res.meta,
              }],
              divisionId: divisionId,
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.material.addMaterial.inspection.assignSuccessContent'),
                $translate.instant('modules.material.addMaterial.inspection.assignSuccessTitle')
              );
              if (!res.meta.Mandatory && !self.showOptionalInspections) {
                self.showOptionalInspections = true;
              } else {
                self.getAssignedInspections();
              }
              self.getUpcomingInspection();
            })
            .catch(function (e) {
              if (e) {
                toastr.error(
                  $translate.instant('modules.material.addMaterial.inspection.assignFailContent'),
                  $translate.instant('modules.material.addMaterial.inspection.assignFailTitle')
                );
              }
            });
        });
    };

    self.addInspectionEvent = function (inspectionEvt, descent) {
      return ArnoDashMaterialsService
        .addInspectionEvent(
          self.divisionId,
          fullRow[0].id,
          currentModel,
          inspectionEvt,
          descent
        )
        .then(function (res) {
          if (res && res.meta) {
            self.getInspectionEvents();
            self.getAssignedInspections();
            self.getUpcomingInspection();
          }
        });
    };

    self.showDescent = function (inspection, isRepeat) {
      if (!~(self.latestInspectionEvents || []).indexOf(inspection.id)) {
        return false;
      }
      if (inspection.HasTasks) {
        return !isRepeat;
      }
      if (inspection.Result === 'FAILED') {
        return !!isRepeat;
      }
    };

    self.removeInspection = function (item, reset) {
      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: reset
          ? $translate.instant('modules.material.addMaterial.inspection.resetInspectionTitle')
          : $translate.instant('modules.material.addMaterial.inspection.deleteInspectionTitle'),
        content: reset ?
          $translate.instant('modules.material.addMaterial.inspection.resetInspectionContent', {
            inspectionName: item.Inspection.Name,
            materialName: self.materialName,
          }) : $translate.instant('modules.material.addMaterial.inspection.deleteInspectionContent', {
            inspectionName: item.Inspection.Name,
            materialName: self.materialName,
          }),
        primaryActionText: reset ? $translate.instant('generalTerms.reset') : $translate.instant('generalTerms.remove'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
        .then(function () {
          return clientApi.custom('model/' + currentModel + 'Inspection', 'removeInspectionAssignments', {
            materialId: self.materialId,
            inspectionIds: [item.Inspection.id],
            divisionId: divisionId,
          });
        })
        .then(function () {
          toastr.success(
            reset
              ? $translate.instant('modules.material.addMaterial.inspection.resetSuccessContent')
              : $translate.instant('modules.material.addMaterial.inspection.removeSuccessContent'),
            reset
              ? $translate.instant('modules.material.addMaterial.inspection.resetSuccessTitle')
              : $translate.instant('modules.material.addMaterial.inspection.removeSuccessTitle')
          );
          self.getAssignedInspections();
          self.getUpcomingInspection();
        })
        .catch(function (e) {
          if (e && !e.action) {
            toastr.error(
              reset
                ? $translate.instant('modules.material.addMaterial.inspection.resetFailContent')
                : $translate.instant('modules.material.addMaterial.inspection.removeFailContent'),
              reset
                ? $translate.instant('modules.material.addMaterial.inspection.resetFailTitle')
                : $translate.instant('modules.material.addMaterial.inspection.removeFailTitle')
            );
          }
        });
    };

    self.savedQw;
    self.savedQwEvents;
    self.savedStParams;
    self.savedStParamsEvents;
    self.inspSwitcherKeys = {
      on: $translate.instant('modules.material.addMaterial.inspection.includeOptional'),
      off: $translate.instant('modules.material.addMaterial.inspection.onlyMandatory')
    };
    self.getAssignedInspections = function (params) {
      if (self.isNew || !self.materialId) {
        return;
      }
      var queryWishes;
      if (!params) {
        queryWishes = self.savedQw;
      } else {
        queryWishes = {
          paging: {
            offset: (params.pagination.start / params.pagination.number) * self.itemsPerPageAssignedInspections || 0,
            limit: self.itemsPerPageAssignedInspections
          },
          order: {
            by: params.sort.predicate,
            reverse: params.sort.reverse
          },
          search: (params.search || {}).predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        };

        if (queryWishes.search && !Object.keys(queryWishes.search).length) {
          delete queryWishes.search;
        }
        self.savedQw = queryWishes;
      }

      return clientApi
        .custom('model/' + currentModel + 'Inspection', 'getAssignedInspections', {
          queryWishes: queryWishes,
          divisionId: self.divisionId,
          materialId: self.materialId,
          onlyMandatory: !self.showOptionalInspections,
        })
        .then(function (result) {
          if (result) {
            self.materialInspectionColl = result.rows;
            (params || self.savedStParams).pagination.numberOfPages = Math.ceil((result.count || 0) / self.itemsPerPageAssignedInspections);
          } else {
            (params || self.savedStParams).pagination.numberOfPages = 0;
          }
          if (params) {
            self.savedStParams = params;
          }
        });
    };

    self.getInspectionEvents = function (params) {
      if (self.isNew) {
        return;
      }
      var queryWishes;
      if (!params) {
        queryWishes = self.savedQwEvents;
      } else {
        queryWishes = {
          paging: {
            offset: (params.pagination.start / params.pagination.number) * self.itemsPerPageAssignedInspectionEvents || 0,
            limit: self.itemsPerPageAssignedInspectionEvents
          },
          order: {
            by: params.sort.predicate,
            reverse: params.sort.reverse
          },
          search: (params.search || {}).predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
        };

        if (queryWishes.search && !Object.keys(queryWishes.search).length) {
          delete queryWishes.search;
        }
        self.savedQwEvents = queryWishes;
      }

      return clientApi
        .custom('model/' + currentModel + 'InspectionEvent', 'getInspectionEvents', {
          queryWishes: queryWishes,
          divisionId: self.divisionId,
          materialId: self.materialId,
          onlyMandatory: false,
        })
        .then(function (result) {
          if (result) {
            self.materialInspectionEventsColl = result.rows;
            (params || self.savedStParamsEvents).pagination.numberOfPages = Math.ceil((result.count || 0) / self.itemsPerPageAssignedInspectionEvents);
          } else {
            (params || self.savedStParamsEvents).pagination.numberOfPages = 0;
          }
          if (params) {
            self.savedStParamsEvents = params;
          }
        });
    };

    self.getUpcomingInspection = function () {
      // splitmode does not have material ids
      if (self.materialId) {
        return clientApi
          .custom('model/' + currentModel + 'Inspection', 'getUpcomingInspection', {
            divisionId: self.divisionId,
            materialId: self.materialId,
            opts: {
              nextDueBannerMandatoryOnly: true,
              overdueBannerMandatoryOnly: true,
            },
          })
          .then(function (res) {
            self.upcomingInspection = res;
            self.hasUpcomingInspectionSection = !!_.compact(
              _.flatten([
                [self.upcomingInspection.next],
                self.upcomingInspection.overdue,
                self.upcomingInspection.todo,
                self.upcomingInspection.failed,
              ])
            ).length;
            self.latestInspectionEvents = res.latestInspectionEvents;
          });
      }
      return null;
    };
    if (!self.isNew) {
      self.getUpcomingInspection();
    }

    self.pdfExport = function (type) {
      return clientApi.openTab('docxTemplateStorage/generatePdf', {
        divisionId: self.divisionId,
        type: type,
        fillDataProviderId: self.materialId,
        fillDataOpts: JSON.stringify({
          model: currentModel,
        })
      });
    };

    self.bookingMaterialCalendarVersion = { version: 0 };
    self.refreshBookingCalendar = function () {
      $timeout(function () {
        self.bookingMaterialCalendarVersion.version++;
      }, 0);
    };

    // additional init

    var initFieldWatchers = function () {
      if (self.fieldConfig) {
        Object.keys(fieldConfig).forEach(function (key) {
          if (self.fieldConfig[key].watchFn) {
            $scope.$watch(function () {
              return self.addModel[key];
            }, function (n, o) {
              return self.fieldConfig[key].watchFn(n, o, self.addModel, self.materialAddForm);
            }, true);
          }
        });
      }
    };

    $timeout(initFieldWatchers());
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.legalPages.termsOfUse', [])
    .controller('TermsOfUseCtrl', TermsOfUseCtrl);

  function TermsOfUseCtrl(terms, termsARNO) {
    var self = this;
    self.terms = terms;
    self.termsARNO = termsARNO;
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.legalPages.privacyStatement', [])
    .controller('PrivacyStatementCtrl', PrivacyStatementCtrl);

  function PrivacyStatementCtrl(privacyTerms) {
    var self = this;
    self.privacyTerms = privacyTerms;
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.quotations', [])
    .config(routeConfig)

  /** @ngInject */
  var commonResolve = {
    isInvoice: function($state) {
      return $state.transition._treeChanges.to[$state.transition._treeChanges.to.length - 1].state.name === 'arno.finances.invoices';
    },
    entryPermission: function(isInvoice) {
      return isInvoice ? 'arno.finances.invoices.edit' : 'arno.finances.quotations.edit';
    },
    ctx: function(commonUtils, entryPermission) {
      return commonUtils.division.getCtx({
        multiple: true,
        allowOrgSelection: false,
        entryPermission: entryPermission,
      });
    },
    listDataProvider: function(clientApi, ctx, isInvoice) {
      return function(queryWishes) {
        return clientApi.custom('model/' + (isInvoice ? 'Invoice' : 'Quotation'), 'list', {
          divisionId: ctx,
          queryWishes: queryWishes,
        });
      }
    },
    initialListData: function(listDataProvider) {
      return listDataProvider();
    },
    flowStepConfig: function (clientApi, isInvoice) {
      return clientApi.custom('model/' + (isInvoice ? 'Invoice' : 'Quotation'), 'fetchFlowStepConfig');
    }
  }

  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.finances.quotations', {
        url: '/quotations',
        templateUrl: 'app/pages/finances/quotInvList/quotInvList.html',
        title: 'navigation.finances.quotations',
        controller: 'FinancesQuotInvListCtrl as self',
        resolve: commonResolve,
        sidebarMeta: {
          order: 10,
        },
      })
      .state('arno.finances.invoices', {
        url: '/invoices',
        templateUrl: 'app/pages/finances/quotInvList/quotInvList.html',
        title: 'navigation.finances.invoices',
        controller: 'FinancesQuotInvListCtrl as self',
        resolve: commonResolve,
        sidebarMeta: {
          order: 20,
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.quotations')
    .controller('FinancesQuotInvListCtrl', FinancesQuotInvListCtrl);

  /** @ngInject */
  function FinancesQuotInvListCtrl($state, $rootScope, ctx, organizationId, isInvoice, entryPermission, commonUtils, clientApi, $translate,
    toastr, listDataProvider, initialListData, flowStepConfig, dateFilter, QuotInvService, $uibModal) {
    var self = this;

    self.ctx = ctx;
    self.isInvoice = isInvoice;
    self.entryPermission = entryPermission;
    self.translateIsInvoice = { isInvoice: self.isInvoice };
    self.orgName = $rootScope.ctx.organization.current.name;
    self.tableConfig = { pageSize: 10 };

    self.possibleStates = flowStepConfig.map(function (state) {
      state.label = $translate.instant('modules.events.flowbar.' + state.label);
      return state;
    });
    self.flowStateMap = _.mapKeys(flowStepConfig, 'ident');

    self.openDetails = function (quotInv) {
      if (!quotInv && (!self.ctx || self.ctx.length !== 1)) {
        return;
      }
      $state.go(
        'arno.finances.quotationInvoiceDetails',
        {
          type: isInvoice ? 'invoice' : 'quotation',
          id: (quotInv && quotInv.id) || undefined,
          ctx: (quotInv && quotInv.DivisionId) || self.ctx
        }
      );
    };    

    self.changePageSize = function (num) {
      self.tableConfig.pageSize = num;
    };

    self.setDisplayedCollection = function (result, params) {
      if (result && result.count > 0) {
        params.pagination.numberOfPages = Math.ceil(result.count / self.tableConfig.pageSize);
        self.displayedCollection = result.rows;
      } else {
        params.pagination.numberOfPages = 0;
        self.displayedCollection = [];
      }
    };

    self.initialCall = true;
    self.getData = function (params, ctrl) {
      self.tableCtrl = ctrl || self.tableCtrl;
      params.pagination.numberOfPages = 0;

      if (self.initialCall) {
        self.initialCall = false;
        self.setDisplayedCollection(initialListData, params);
      }
      console.log('params --------------------------> ', params);
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.tableConfig.pageSize || 0,
          limit: self.tableConfig.pageSize,
        },
        filter: params.search.predicateObject ? commonUtils.flattenObject(params.search.predicateObject, true) : undefined,
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
      };

      if (self.ctx && (self.ctx.length || !Array.isArray(self.ctx))) {
        return listDataProvider(queryWishes)
          .then(function (result) {
            return self.setDisplayedCollection(result, params);
          })
          .catch(function () {
            params.pagination.numberOfPages = 0;
            self.displayedCollection = [];
            toastr.error(
              $translate.instant('modules.personnel.inviteList.loadingErrToastText'),
              $translate.instant('modules.personnel.inviteList.loadingErrToastTitle')
            );
          });
      }
    };

    self.openProcessDetails = function (financeProcess) {
      return clientApi
        .custom(
          'model/FinanceProcess',
          'resolveProcess',
          { divisionId: self.ctx, id: financeProcess.id }
        )
        .then(function (result) {
          $uibModal.open(
            {
              controller: 'selectProcessElementCtrl as $selCtrl',
              animation: true,
              templateUrl: 'app/pages/finances/modals/selectProcessElement.html',
              size: 'xl',
              backdrop: 'static',
              resolve: {
                processSteps: function () {
                  return commonUtils.finances.formatProcessSteps(result.FinanceProcessSteps);
                },
                financeProcess: function () {
                  return result;
                },
                flowStepConfigs: function () {
                  return clientApi.custom('model/FinanceProcess', 'resolveProcessFlowStepConfigs');
                },
                ctx: function () {
                  return self.ctx;
                },
                viewOnly: function () {
                  return true;
                },
                enableTitleEdit: function () {
                  return true;
                },
                originParams: function () {
                  return {
                    state: $state.current.name,
                    enableRepick: false,
                  };
                }
              }
            }).result
            .then(function (res) {
              if (res) {
                // title change
                return clientApi.custom(
                  'model/FinanceProcess',
                  'renameProcess',
                  { divisionId: self.ctx, processId: financeProcess.id, title: res }
                );
              }
            })
            .then(function () {
              toastr.success(
                $translate.instant('modules.finances.quotInvDetails.saveProcessTitleSuccessBody'),
                $translate.instant('modules.finances.quotInvDetails.saveProcessTitleSuccessTitle')
              );
              $state.reload();
            })
            .catch(function (e) {
              if (e) {
                toastr.error(
                  $translate.instant('modules.finances.quotInvDetails.saveProcessTitleFailBody'),
                  $translate.instant('modules.finances.quotInvDetails.saveProcessTitleFailTitle')
                );
              }
            });
        })
        .catch(function () {
          // hmm k
        });
    };

    self.remove = function (quotInv) {
      return QuotInvService
        .removeQuotInv(quotInv.id, self.isInvoice, self.ctx, quotInv.Creator, dateFilter(quotInv.createdAt, 'dd.MM.yyyy HH:mm'))
        .then(function () {
          $state.reload();
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.quotationInvoiceDetails', [])
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.finances.quotationInvoiceDetails', {
        url: '/details/:type/:id/:ctx',
        templateUrl: 'app/pages/finances/quotInvDetails/quotInvDetails.html',
        title: function (transition) {
          var isProcessSelection = transition.injector().get('processSelectorParams');
          if (isProcessSelection) {
            return 'modules.finances.quotInvDetails.titleProcessSelection';
          }
          var isInvoice = transition.injector().get('isInvoice');
          return isInvoice ? 'modules.finances.quotInvDetails.titleInvoice' : 'modules.finances.quotInvDetails.titleQuotation';
        },
        params: {
          type: null,
          needsApproval: false,
          id: null,
          ctx: null,
          serviceId: null,
          recreate: false,
          deleteFloatingId: null,
          processSelectorParams: null,
          originUnapproved: null,
        },
        controller: 'FinancesQuotInvDetailsCtrl as self',
        resolve: {
          needsApproval: function ($stateParams) {
            return $stateParams.needsApproval;
          },
          processSelectorParams: function ($stateParams) {
            return $stateParams.processSelectorParams;
          },
          deleteFloatingId: function ($stateParams) {
            return $stateParams.deleteFloatingId;
          },
          originUnapproved: function ($stateParams) {
            return $stateParams.originUnapproved;
          },
          isInvoice: function ($stateParams) {
            return ($stateParams.type || '').toLocaleLowerCase() === 'invoice';
          },
          preCtx: function ($stateParams, commonUtils, isInvoice) {
            if ($stateParams.ctx && parseInt($stateParams.ctx, 10)) {
              return parseInt($stateParams.ctx, 10);
            }
            return parseInt(
              commonUtils.division.getCtx({
                multiple: true,
                allowOrgSelection: false,
                entryPermission: isInvoice ? 'arno.finances.invoices.edit' : 'arno.finances.quotations.edit',
              })[0],
              10
            );
          },
          createdFrom: function ($stateParams) {
            if ($stateParams.serviceId) {
              return {
                id: $stateParams.serviceId,
                model: 'Service',
              }
            }
            if ($stateParams.recreate) {
              return {
                id: parseInt($stateParams.recreate.id, 10),
                model: _.upperFirst($stateParams.recreate.sourceType),
              }
            }
            return {};
          },
          preexistingCall: function (clientApi, preCtx, $stateParams, isInvoice) {
            var fetchPayload = {
              divisionId: preCtx,
            };
            var fetchModel = 'model/' + (isInvoice ? 'Invoice' : 'Quotation');
            var fetchFn = 'fetch' + (isInvoice ? 'Invoice' : 'Quotation');
            if ($stateParams.serviceId) {
              // get quotation/invoice with basic data from a selected service
              fetchPayload.serviceId = $stateParams.serviceId;
            } else if ($stateParams.recreate && $stateParams.recreate.sourceType && $stateParams.recreate.resultType) {
              fetchModel = 'model/Quotation';
              fetchFn = 'recreateQuotInv';
              fetchPayload.sourceType = $stateParams.recreate.sourceType;
              fetchPayload.resultType = $stateParams.recreate.resultType;
              fetchPayload.id = parseInt($stateParams.recreate.id, 10);
            } else {
              fetchPayload[isInvoice ? 'invoiceId' : 'quotationId'] = parseInt($stateParams.id, 10) || undefined;
            }

            return clientApi.custom(fetchModel, fetchFn, fetchPayload);
          },
          exportAvailable: function (preexistingCall, clientApi, isInvoice) {
            if (preexistingCall.FlowState && preexistingCall.FlowState !== 'DRAFT') {
              return true;
            }
            return clientApi
              .emit('docxTemplateStorage/check', {
                divisionId: preexistingCall.DivisionId,
                type: isInvoice ? 'invoice' : 'quotation',
                orgFallback: true,
              })
              .then(function (result) {
                return result.exists || false;
              });
          },
          reversalExportAvailable: function (preexistingCall, clientApi, isInvoice) {
            if (!isInvoice || (preexistingCall.FlowState && preexistingCall.FlowState === 'DRAFT')) {
              return false;
            }
            return clientApi
              .emit('docxTemplateStorage/check', {
                divisionId: preexistingCall.DivisionId,
                type: 'reversalInvoice',
                orgFallback: true,
              })
              .then(function (result) {
                return result.exists || false;
              });
          },
          flowStepConfig: function (clientApi, isInvoice) {
            return clientApi.custom('model/' + (isInvoice ? 'Invoice' : 'Quotation'), 'fetchFlowStepConfig');
          },
          ctx: function (preCtx, preexistingCall) {
            if (preexistingCall) {
              return preexistingCall.DivisionId;
            }
            return preCtx;
          },
          MEMBER_COUNTRY_IDS: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },
          divisionBusinessPartners: function (ctx, clientApi) {
            return clientApi
              .custom('model/BusinessPartner', 'searchBusinessPartners', {
                divisionId: ctx,
                onlyDivision: true,
                isBuyer: true,
              })
          },
          reversalInvoiceInfo: function(clientApi, preexistingCall, isInvoice) {
            if (!preexistingCall || !preexistingCall.id  || !isInvoice) {
              return null;
            }
            return clientApi
              .custom('model/FinanceProcess', 'reversalInvoiceInfo', {
                divisionId: preexistingCall.DivisionId,
                invoiceId: preexistingCall.id,
              });
          },
        },
        viewPermission: ['arno.finances.quotations', 'arno.finances.invoices']
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.quotationInvoiceDetails')
    .controller('FinancesQuotInvDetailsCtrl', FinancesQuotInvDetailsCtrl);

  /** @ngInject */
  function FinancesQuotInvDetailsCtrl($rootScope, $scope, $state, $translate, commonUtils, validationUtils, ctx, isInvoice,
    MEMBER_COUNTRY_IDS, DISCOUNT_UNIT_TYPES,
    divisionBusinessPartners, preexistingCall, clientApi, flowStepConfig, toastr, stateChangePrompt,
    QuotInvService, dateFilter, needsApproval, createdFrom, deleteFloatingId, $uibModal, permissions,
    baModalService, processSelectorParams, exportAvailable, originUnapproved, $stateParams, reversalInvoiceInfo,
    reversalExportAvailable
  ) {
    var self = this;

    self.creationUnavailableDivisionDataMissing = !preexistingCall.AccountingArea || !preexistingCall.SalesDocMeta.Office;
    self.creationUnavailable = self.creationUnavailableDivisionDataMissing;
    self.ctx = ctx;
    self.isInvoice = !!isInvoice;
    self.translateIsInvoice = { isInvoice: self.isInvoice };
    self.isReversalInvoice = self.isInvoice && !!preexistingCall.Reversal;
    self.MEMBER_COUNTRY_IDS = MEMBER_COUNTRY_IDS;
    self.isNew = !preexistingCall || !preexistingCall.id;
    self.divisionBusinessPartners = divisionBusinessPartners;
    self.sourceDivisionName = (_.find(commonUtils.division.divisionTreeData || [], { id: (self.ctx).toString() }) || { Name: '' }).Name;
    self.needsApproval = needsApproval || (!self.isNew ? !preexistingCall.Approved : false);
    self.isSent = (preexistingCall || {}).SentState;
    self.processSelectorParams = processSelectorParams;
    self.isProcessDetails = !!processSelectorParams;
    self.panelTitle = self.isProcessDetails ? 'modules.finances.quotInvDetails.processStepDetailTitle' : 'modules.finances.quotInvDetails.title';
    self.exportAvailable = exportAvailable;
    self.reversalExportAvailable = reversalExportAvailable;
    self.businessPartnerConf = { buyer: true, seller: false };

    self.baseData = preexistingCall;
    self.baseData.Discount = self.baseData.Discount || 0;
    self.baseData.DiscountUnit = self.baseData.DiscountUnit || DISCOUNT_UNIT_TYPES.FLAT;
    self.baseData.FinalAmount = self.baseData.FinalAmount || 0;
    self.metaData = {
      discount: self.baseData.Discount || 0,
      discountUnit: self.baseData.DiscountUnit || DISCOUNT_UNIT_TYPES.FLAT,
    };
    self.metaData.quotInvBaseData = self.baseData;
    self.metaData.isInvoice = self.isInvoice;

    self.reversalInvoiceTargetId = (reversalInvoiceInfo && reversalInvoiceInfo.targetId) || null;

    self.canEditInvoices = permissions.isPermittedInEvery('arno.finances.invoices.edit', 'Division', [self.ctx]);

    var addressFields = [
      'CountryId',
      'ZipCode',
      'City',
      'Street',
      'HouseNumber',
      'AddressAffix'
    ];

    self.baseData.SalesDocMeta.address = _.pick(self.baseData.SalesDocMeta, addressFields);
    self.baseData.SalesDocMeta.address.ZIP = self.baseData.SalesDocMeta.address.ZipCode;
    delete self.baseData.SalesDocMeta.address.ZipCode;
    self.baseData.SalesDocMeta = _.omit(self.baseData.SalesDocMeta, addressFields);
    if (self.baseData.SalesDocMeta.address.CountryId) {
      self.baseData.SalesDocMeta.address.CountryId = _.find(self.MEMBER_COUNTRY_IDS, { mapping: self.baseData.SalesDocMeta.address.CountryId });
    }
    var untilField = self.isInvoice ? 'PayableUntil' : 'ValidUntil';
    self.baseData.untilDate = self.baseData[untilField] ? new Date(self.baseData[untilField]) : undefined;
    self.baseData.FinalizationDate = self.baseData.FinalizationDate ? new Date(self.baseData.FinalizationDate) : undefined;
    delete self.baseData[untilField];

    if (self.isInvoice) {
      self.baseData.OrderDate = self.baseData.OrderDate ? new Date(self.baseData.OrderDate) : undefined;
      self.baseData.PerformanceDate = self.baseData.PerformanceDate ? new Date(self.baseData.PerformanceDate) : undefined;
    }

    if (self.baseData && self.baseData.util && self.baseData.util.templateCoverNote && !self.baseData.CoverNote) {
      self.baseData.CoverNote = self.baseData.util.templateCoverNote;
    }

    var requiredMetaFields = [
      'SalesDocMeta.Office',
      'SalesDocMeta.InstitutionCode',
      'SalesDocMeta.address.CountryId',
      'SalesDocMeta.address.ZIP',
      'SalesDocMeta.address.City',
      'SalesDocMeta.address.Street',
      'SalesDocMeta.address.HouseNumber',
      'AccountingArea',
      'SalesDocMeta.IBAN',
      'SalesDocMeta.BIC',
      'SalesDocMeta.Bank',
    ];

    self.metaSectionToggleClose = requiredMetaFields.filter(function (propPath) {
      return _.get(self.baseData, propPath);
    }).length === requiredMetaFields.length;

    self.baseDataAddressFieldsConfig = {
      countryId: { required: true },
      zipCode: { required: true },
      city: { required: true },
      street: { required: true },
      houseNumber: { required: true }
    };
    self.baseDataAddressUiConfig = {
      firstRow: { cssCls: 'row' },
      secondRow: { cssCls: 'row' },
      // first row
      city: { wrapperCssCls: 'col-md-12 col-lg-6' },
      zipCode: { wrapperCssCls: 'col-sm-8 col-lg-3' },
      countryId: { wrapperCssCls: 'col-sm-4 col-lg-3' },

      // second row
      street: { wrapperCssCls: 'col-sm-8 col-lg-9' },
      houseNumber: { wrapperCssCls: 'col-sm-4 col-lg-3' },
      addressAffix: { wrapperCssCls: 'col-xs-12' },
    };

    self.sentStateOptions = [
      { state: '', value: null, highlight: 'default' },
      { state: 'sent', value: true, highlight: 'success' },
      { state: 'notSent', value: false, highlight: 'warning' },
    ];
    self.sentStateModel = _.find(self.sentStateOptions, { value: self.baseData.SentState }) || self.sentStateOptions[0];
    if (self.sentStateModel !== self.sentStateOptions[0]) {
      self.sentStateOptions.splice(0, 1);
    }

    self.closingStateOptions = [
      { state: '', value: null, highlight: 'default' },
      { state: 'positive', value: 'POSITIVE', highlight: 'success' },
      { state: 'negative', value: 'NEGATIVE', highlight: 'danger' },
      { state: 'reversal', value: 'REVERSAL', highlight: 'danger', nonSelectableSticky: true },
    ];
    self.closingStateOptionsArchive = [
      { state: 'positive', value: 'POSITIVE', highlight: 'success' },
    ];
    self.closingStateModel = _.find(self.closingStateOptions, { value: self.baseData.ClosingState }) || self.closingStateOptions[0];
    if (self.closingStateModel !== self.closingStateOptions[0]) {
      self.closingStateOptions.splice(0, 1);
    }
    if (self.closingStateModel.nonSelectableSticky) {
      self.closingStateOptions = [self.closingStateModel];
    } else {
      _.remove(self.closingStateOptions, { nonSelectableSticky: true });
    }

    self.panelTagList = [];
    if (self.sentStateModel.value !== null) {
      self.panelTagList.push({
        label: $translate.instant('modules.finances.quotInvDetails.sentState.' + self.sentStateModel.state),
        labelClass: 'label-' + self.sentStateModel.highlight,
        icon: self.sentStateModel.value ? 'fa fa-envelope-o' : 'fa fa-envelope-open-o',
      });
    }
    if (self.closingStateModel.value !== null) {
      self.panelTagList.push({
        label: $translate.instant('modules.finances.quotInvDetails.closingState.' + self.closingStateModel.state),
        labelClass: 'label-' + self.closingStateModel.highlight,
        icon: self.closingStateModel.value === 'POSITIVE' ? 'fa fa-check' : 'fa fa-times',
      });
    }
    if (self.isReversalInvoice) {
      self.panelTagList.push({
        label: $translate.instant('modules.finances.quotInvList.reversal'),
        labelClass: 'label-info',
        icon: 'fa fa-undo',
      });
    }
    if (self.baseData.Exported == true) {
      self.panelTagList.push({
        label: $translate.instant('modules.finances.quotInvList.accountingTag'),
        labelClass: 'label-success',
        icon: 'fa fa-flag-checkered',
        tooltip: $translate.instant('modules.finances.quotInvList.accountingTagTooltip'),
      });
    }

    self.validIBAN = commonUtils.validation.iban;
    self.validBIC = commonUtils.validation.bic;
    self.validEMail = function (email) {
      return !!validationUtils.checkEmail(email, false);
    };

    // self.baseData.CostCenterSpecification
    self.costCenterOnSelect = function (selection) {
      self.baseData.CostCenterSpecification = selection;
    };

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4
      }
    };

    self.flow = {
      steps: flowStepConfig,
      lastSavedStep: 0,
      activeStep: 0,
    };

    if (self.baseData.FlowState) {
      var found = _.find(self.flow.steps, { ident: self.baseData.FlowState });
      self.flow.activeStep = (found && self.flow.steps.indexOf(found)) || 0;
      self.flow.lastSavedStep = self.flow.activeStep;
    } else {
      self.baseData.FlowState = self.flow.steps[0].ident;
    }

    self.metaFieldFrozen = self.creationUnavailable || !!(self.flow.steps[self.flow.lastSavedStep].config || {}).freezeMetadata || self.processSelectorParams;
    self.canDelete = !self.isNew && !self.metaFieldFrozen;

    // WATCHERS
    $scope.$watch(function () {
      return self.flow.activeStep;
    }, function () {
      self.baseData.FlowState = self.flow.steps[self.flow.activeStep].ident;

      self.lastSavedStepConfig = (self.flow.steps[self.flow.lastSavedStep].config || {});
      self.activeStepConfig = (self.flow.steps[self.flow.activeStep].config || {});
      self.lastSavedStepRequirements = (self.flow.steps[self.flow.lastSavedStep].requirements || {});
      self.activeStepRequirements = (self.flow.steps[self.flow.activeStep].requirements || {});
      self.shouldShowSentStateField = !!self.lastSavedStepConfig.sentStateAvailable || !!self.activeStepConfig.sentStateAvailable
                                      || !!self.lastSavedStepRequirements.sentStateRequired || !!self.activeStepRequirements.sentStateRequired;
      self.shouldShowClosingStateField = !!self.lastSavedStepConfig.closingStateAvailable || self.activeStepConfig.closingStateAvailable
                                         || !!self.lastSavedStepRequirements.closingStateRequired || !!self.activeStepRequirements.closingStateRequired;
      self.shouldShowStatusArea = self.shouldShowSentStateField || self.shouldShowClosingStateField
                                  || !!self.lastSavedStepConfig.accessibleByArchive || !!self.activeStepConfig.accessibleByArchive;
      self.sentStateFieldRequired = !!self.lastSavedStepRequirements.sentStateRequired || !!self.activeStepRequirements.sentStateRequired;
      self.closingStateFieldRequired = !!self.lastSavedStepRequirements.closingStateRequired || !!self.activeStepRequirements.closingStateRequired;
      self.ccdsFieldRequired = !!(self.flow.steps[self.flow.activeStep].config || {}).freezeMetadata;
      self.orderDateFieldRequired = (self.flow.steps[self.flow.activeStep].requirements || {}).orderDate;
      self.performanceDateFieldRequired = (self.flow.steps[self.flow.activeStep].requirements || {}).performanceDate;

      self.exportAvailable = !(!self.exportAvailable && !self.lastSavedStepConfig.freezeMetadata && self.activeStepConfig.freezeMetadata);
      self.saveAvailable = !self.creationUnavailable && self.exportAvailable;
      self.shouldUseArchivalStates = self.baseData.FlowState === 'ARCHIVED' && self.isInvoice;
    });

    $scope.$watch(function () {
      return ((self.baseData.CostCenterSpecification || {}).CostCenter || {}).id;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        (self.baseData.SalesDocPositions || []).forEach(function (position) {
          position.CostCenterSpecification = null;
        });
      }
    });

    // VIEW-FUNCTIONS
    self.panelTitleVars = {
      isInvoice: self.isInvoice,
      reversal: self.isReversalInvoice,
      isNew: self.isNew,
      processDetails: (self.processSelectorParams || {}).process,
      needsApproval: self.needsApproval,
      quotInvNumber: self.isInvoice ? self.baseData.InvoiceNumber : self.baseData.QuotationNumber,
    };

    self.getFlowstepLabelByIdent = function (ident) {
      return (_.find(self.flow.steps, { ident: ident }) || {}).label;
    };

    // EVENT-HANDLERS
    self.setBusinessPartner = function (businessPartner) {
      self.baseData.BusinessPartner = businessPartner;
    };

    self.back = function () {
      if (self.processSelectorParams && self.processSelectorParams.state) {
        $state.go(self.processSelectorParams.state);
      } else if (self.needsApproval) {
        $state.go('arno.finances.demandForAction');
      } else {
        $state.go($rootScope.transitionHistoryFetchState(['arno.finances.quotations', 'arno.finances.invoices'], 'arno.finances.quotations'));
      }
    };

    self.selectProcessElement = function () {
      goToConvertState('Invoice', self.processSelectorParams.process);
    };

    self.reselectProcessElement = function () {
      self.convert(self.processSelectorParams.elementId, 'invoice', self.processSelectorParams.source, originUnapproved);
    };

    self.validationScroll = function (form) {
      validationUtils.validationScroll($scope, form);
    };

    // metaData -> baseData sync
    var mdSyncList = ['discount', 'discountUnit', 'FinalAmount'];
    $scope.$watch(function () {
      return self.metaData;
    }, function () {
      if (self.metaData && Object.keys(self.metaData).length) {
        self.baseData = Object.assign(
          self.baseData,
          _.mapKeys(
            _.pickBy(self.metaData, function (value, key) {
              return mdSyncList.includes(key);
            }),
            function (value, key) {
              return _.upperFirst(key);
            })
        );
      }
    }, true);

    self.saveQuotInv = function () {
      if (self.baseData.ClosingState !== 'POSITIVE' && self.baseData.ClosingState !== 'REVERSAL' && self.baseData.FlowState === 'ARCHIVED' && self.isInvoice) {
        toastr.warning(
          $translate.instant('modules.finances.quotInvDetails.archiveRequireToastr'),
          $translate.instant('modules.finances.quotInvDetails.archiveRequireToastrTitle')
        );
        return;
      }
      var fieldsData = JSON.parse(JSON.stringify(self.baseData));
      _.assign(fieldsData.SalesDocMeta, fieldsData.SalesDocMeta.address);
      delete fieldsData.SalesDocMeta.address;
      fieldsData.SalesDocMeta.ZipCode = fieldsData.SalesDocMeta.ZIP;
      delete fieldsData.ZIP;
      fieldsData.SalesDocMeta.CountryId = (fieldsData.SalesDocMeta.CountryId || {}).mapping;
      fieldsData[self.isInvoice ? 'PayableUntil' : 'ValidUntil'] = fieldsData.untilDate;
      delete fieldsData.untilDate;

      if (self.needsApproval) {
        fieldsData.Approved = true;
      }

      var existPromise = Promise.resolve(false);

      if (self.isNew && (createdFrom || fieldsData.id) && self.isInvoice) {
        existPromise = clientApi
          .custom('model/FinanceProcess', 'hasInvoice', {
            divisionId: self.ctx,
            originId: createdFrom.id || fieldsData.id,
            originModel: createdFrom.model || (self.isInvoice ? 'Invoice' : 'Quotation'),
          });
      }

      return existPromise
        .then(function (res) {
          if (res && Object.keys(res).length > 0) {
            return baModalService.messageModal({
              modalType: 'warning',
              allowHtml: false,
              title: $translate.instant('modules.finances.quotInvDetails.hasInvoiceModalTitle'),
              content: $translate.instant('modules.finances.quotInvDetails.hasInvoiceModalText', { origin: res.originTitle, invoice: res.invoiceTitle }),
              primaryActionText: $translate.instant('generalTerms.confirm'),
              secondaryActionText: $translate.instant('generalTerms.cancel')
            });
          }
        })
        .then(function () {
          if (createdFrom || fieldsData.id) {
            return clientApi
              .custom('model/FinanceProcess', 'checkForExisting', {
                divisionId: self.ctx,
                originId: createdFrom.id || fieldsData.id,
                originModel: createdFrom.model || (self.isInvoice ? 'Invoice' : 'Quotation'),
              });
          }
          return Promise.resolve();
        })
        .then(function (res) {
          if (res !== true) {
            return $uibModal.open(
              {
                controller: 'renameProcessCtrl as $ctrl',
                animation: true,
                templateUrl: 'app/pages/finances/modals/renameProcess.html',
                size: 'md',
                resolve: {
                  financeProcess: function () {
                    return null;
                  },
                  preSelectedTitle: function () {
                    return self.baseData.Title;
                  }
                }
              }).result;
          }
        })
        .then(function (res) {
          fieldsData.processTitle = res;
          return clientApi
            .custom(
              'model/Quotation',
              'saveQuotInv',
            {
              divisionId: self.ctx,
              fieldsData: fieldsData,
              isInvoice: self.isInvoice,
              createdFrom: createdFrom,
              deleteFloatingId: deleteFloatingId
            })
            .then(function (quotInv) {
              toastr.success(
                $translate.instant('modules.finances.quotInvDetails.saveSuccessBody', self.translateIsInvoice),
                $translate.instant('modules.finances.quotInvDetails.saveSuccessTitle', self.translateIsInvoice)
              );

              stateChangePrompt.disableEvaluation();
              if (self.refreshOnSave) {
                $state.go('arno.finances.quotationInvoiceDetails', {
                  type: self.isInvoice ? 'invoice' : 'quotation',
                  id: quotInv.id,
                  ctx: self.ctx,
                  processSelectorParams: $stateParams.processSelectorParams,
                  needsApproval: false,
                  serviceId: null,
                  recreate: false,
                  deleteFloatingId: null,
                }, { reload: true });
                return;
              }
              self.back();
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.finances.quotInvDetails.saveFailBody', self.translateIsInvoice),
                $translate.instant('modules.finances.quotInvDetails.saveFailTitle', self.translateIsInvoice)
              );
            });
        })
        .catch(function () {
        });
    };

    self.checkUntilFieldRequirement = function () {
      return !self.isInvoice && self.baseData.FlowState !== 'DRAFT';
    };

    self.remove = function () {
      if (!self.baseData.id) {
        return;
      }
      return QuotInvService
        .removeQuotInv(
          self.baseData.id,
          self.isInvoice,
          self.ctx,
          self.baseData.Creator,
          dateFilter(self.baseData.createdAt, 'dd.MM.yyyy HH:mm'),
          self.needsApproval
        )
        .then(function () {
          stateChangePrompt.disableEvaluation();
          self.back();
        });
    };

    self.fetchChanges = function () {
      return JSON.stringify(self.baseData, function (key, value) {
        if (~['$$hashKey', 'CountryId', '_taxRate', '_sum'].indexOf(key)) {
          return undefined;
        }
        if (key === 'FinalAmount' && value === null) {
          return 0;
        }
        return value;
      });
    };

    self.changeDetectCompare = self.fetchChanges();
    self.isUnchanged = function () {
      return self.changeDetectCompare === self.fetchChanges();
    };

    self.saveFirstToast = function () {
      toastr.warning(
        $translate.instant('modules.finances.quotInvDetails.saveUnchangedFirstBody', self.translateIsInvoice),
        $translate.instant('modules.finances.quotInvDetails.saveUnchangedFirstTitle', self.translateIsInvoice)
      );
    };

    self.export = function () {
      if (!self.isUnchanged()) {
        self.saveFirstToast();
        return;
      }
      var pdfType = self.isInvoice ? 'invoice' : 'quotation';
      if (self.isReversalInvoice) {
        pdfType = 'reversalInvoice';
      }
      return clientApi.openTab('docxTemplateStorage/generatePdf', {
        divisionId: self.ctx,
        type: pdfType,
        fillDataProviderId: self.baseData.id,
      });
    };

    self.openReversalTarget = function (targetId) {
      $state.go('arno.finances.quotationInvoiceDetails', {
        id: targetId,
        type: 'invoice',
        ctx: ctx,
      }, { reload: true });
    };

    function goToConvertState(resultType, processStep) {
      var stateParams = {
        type: resultType,
        ctx: ctx,
        processSelectorParams: null,
      };
      if (processStep.type === 'Service') {
        stateParams.serviceId = processStep.id;
      } else {
        stateParams.recreate = {
          resultType: resultType,
          sourceType: self.isInvoice ? 'invoice' : 'quotation',
          id: processStep.id,
        };
      }
      $state.go('arno.finances.quotationInvoiceDetails', stateParams, { reload: true });
    }

    self.convert = function (id, resultType, source, usePrevOrigin) {
      if (!self.isUnchanged()) {
        self.saveFirstToast();
        return;
      }
      var convertArgs = arguments;
      if (resultType === 'service') {
        // early exit for services;
        // those don't care about other elements of a process, they will just create a service out of the currently opened quotInv
        if (permissions.isPermittedInEvery('arno.events.service.manage', 'Division', [self.ctx])) {
          $state.go('arno.events.serviceDetail', { ctx: self.ctx, quotationBaseId: id });
          return;
        }
        return baModalService
          .messageModal({
            modalType: 'info',
            allowHtml: false,

            title: $translate.instant('modules.finances.quotInvDetails.serviceDemandCreateTitle'),
            content: $translate.instant('modules.finances.quotInvDetails.serviceDemandCreateBody'),

            primaryActionText: $translate.instant('generalTerms.yes'),
            secondaryActionText: $translate.instant('generalTerms.cancel')
          })
          .then(function () {
            return clientApi.custom('model/Quotation', 'serviceDemand', { quotationId: id, divisionId: self.ctx })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.finances.quotInvDetails.serviceDemandSuccessBody'),
                  $translate.instant('modules.finances.quotInvDetails.serviceDemandSuccessTitle')
                );
                $state.reload();
              })
              .catch(function () {
                toastr.error(
                  $translate.instant('modules.finances.quotInvDetails.serviceDemandFailBody'),
                  $translate.instant('modules.finances.quotInvDetails.serviceDemandFailTitle')
                );
              });
          });
      }
      if (resultType === 'reversalInvoice') {
        // early exit for reversal invoices
        return baModalService
          .messageModal({
            modalType: 'danger',
            allowHtml: false,
            title: $translate.instant('modules.finances.quotInvDetails.reversalInvoiceMsgTitle', { invoiceNumber: self.baseData.InvoiceNumber }),
            content: $translate.instant(
              'modules.finances.quotInvDetails.reversalInvoiceMsgContent',
              { invoiceNumber: self.baseData.InvoiceNumber, title: self.baseData.Title }
            ),
            primaryActionText: $translate.instant('generalTerms.confirm'),
            secondaryActionText: $translate.instant('generalTerms.cancel'),
            textInput: self.baseData.Title,
            allowDoubleOpening: true,
          })
          .then(function (result) {
            if (result !== self.baseData.Title) {
              self.convert.apply(this, convertArgs);
              toastr.error(
                $translate.instant('modules.finances.quotInvDetails.reversalInvoiceMsgMismatchMsg'),
                $translate.instant('modules.finances.quotInvDetails.reversalInvoiceMsgMismatchTitle')
              );
              return;
            }
            return clientApi
              .custom('model/Invoice', 'createReversal', { invoiceId: id, divisionId: self.ctx })
              .then(function (result) {
                if (!result || !result.id) {
                  throw new Error('Creation failed.');
                }
                toastr.success(
                  $translate.instant('modules.finances.quotInvDetails.reversalInvoiceCreationMsg'),
                  $translate.instant('modules.finances.quotInvDetails.reversalInvoiceCreationTitle')
                );
                self.openReversalTarget(result.id);
              })
              .catch(function () {
                toastr.error(
                  $translate.instant('modules.finances.quotInvDetails.reversalInvoiceCreationFailedMsg'),
                  $translate.instant('modules.finances.quotInvDetails.reversalInvoiceCreationFailedTitle')
                );
              });
          });
      }
      var sourceType = source || (self.isInvoice ? 'invoice' : 'quotation');
      var promise = Promise.resolve([]);
      if (resultType === 'invoice') {
        promise = clientApi
          .custom(
            'model/FinanceProcessStep',
            'getRelevantSelections',
            { divisionId: self.ctx, elementId: id, type: sourceType, usePrevOrigin: !!usePrevOrigin }
          );
      }
      return promise
        .then(function (result) {
          if (result && result.processSteps && result.processSteps.length > 1) {
            $uibModal.open(
              {
                controller: 'selectProcessElementCtrl as $selCtrl',
                animation: true,
                templateUrl: 'app/pages/finances/modals/selectProcessElement.html',
                size: 'xl',
                resolve: {
                  processSteps: function () {
                    return result.processSteps;
                  },
                  financeProcess: function () {
                    return result.process;
                  },
                  flowStepConfigs: function () {
                    return clientApi.custom('model/FinanceProcess', 'resolveProcessFlowStepConfigs');
                  },
                  ctx: function () {
                    return self.ctx;
                  },
                  viewOnly: function () {
                    return false;
                  },
                  enableTitleEdit: function () {
                    return false;
                  },
                  originParams: function () {
                    return {
                      source: sourceType,
                      elementId: id,
                      enableRepick: true,
                    };
                  }
                }
              }).result
              .then(function (result) {
                goToConvertState(resultType, result);
              })
              .catch(function () {
                // hmm k
              });
          } else {
            $state.go('arno.finances.quotationInvoiceDetails', {
              id: null,
              type: resultType,
              ctx: ctx,
              recreate: {
                id: id,
                resultType: resultType,
                sourceType: sourceType,
              },
            }, { reload: true });
          }
        });
    };

    stateChangePrompt.evaluate(self.isUnchanged);

  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances')
    .controller('selectProcessElementCtrl', selectProcessElementCtrl);

  function selectProcessElementCtrl($uibModalInstance, processSteps, financeProcess, flowStepConfigs, viewOnly, enableTitleEdit, originParams, ctx) {
    var self = this;
    self.processSteps = processSteps;
    self.process = financeProcess;
    self.flowStepConfigs = flowStepConfigs;
    self.ctx = ctx;
    self.viewOnly = viewOnly;
    self.enableTitleEdit = enableTitleEdit;
    self.originParams = originParams;
    self.originUnapproved = financeProcess.Approved !== null && financeProcess.Approved !== undefined ? !financeProcess.Approved : false;

    self.title = self.process.Title;

    self.onSelect = function(step) {
      return $uibModalInstance.close(step);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances')
    .controller('renameProcessCtrl', renameProcessCtrl);

  function renameProcessCtrl($uibModalInstance, financeProcess, preSelectedTitle) {
    var self = this;
    self.process = financeProcess || {};
    self.process.Title = preSelectedTitle;

    self.applyModal = function() {
      return $uibModalInstance.close(self.process.Title);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances')
    .controller('financeProcessServiceDetailsCtrl', financeProcessServiceDetailsCtrl);

  function financeProcessServiceDetailsCtrl($uibModalInstance, serviceDetails) {
    var self = this;
    self.positions = serviceDetails.SalesDocPositions;
  }
})();
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.demandForAction', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.finances.demandForAction', {
        url: '/demandForAction',
        templateUrl: 'app/pages/finances/demandForAction/demandForAction.html',
        title: 'navigation.finances.demandForAction',
        controller: 'DemandCtrl as $ctrl',
        resolve: {
          quotCtx: function(commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.finances.quotations.edit',
            });
          },
          invoiceCtx: function(commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.finances.invoices.edit',
            });
          },
        },
        sidebarMeta: {
          order: 30,
        },
        viewPermission: ['arno.finances.quotations', 'arno.finances.invoices'],
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.finances.demandForAction')
    .controller('DemandCtrl', DemandCtrl);

  /** @ngInject */
  function DemandCtrl(quotCtx, invoiceCtx, commonUtils, clientApi, QuotInvService, dateFilter, permissions, $state, $uibModal) {
    var self = this;
    self.unapprovedQuotations = [];
    self.showPager = {};
    self.ctx = {
      quotation: quotCtx,
      invoice: invoiceCtx
    };

    self.isPermitted = function(perm, type) {
      return permissions.isPermittedInEvery(perm, 'Division', self.ctx[type]);
    }

    self.types = [{
      key: 'quotation',
      getterFn: function(stParams, tableCtrl) {
        return self.loadUnapprovedQuotInvs(stParams, tableCtrl, 'quotation');
      },
      panelTitleVars: { isInvoice: false },
      perm: 'arno.finances.quotations.edit',
    }, {
      key: 'invoice',
      getterFn: function(stParams, tableCtrl) {
        return self.loadUnapprovedQuotInvs(stParams, tableCtrl, 'invoice');
      },
      panelTitleVars: { isInvoice: true },
      perm: 'arno.finances.invoices.edit',
    }];
    
    self.pageSize = {
      quotation: commonUtils.getPageSize('finance_demand_page_size'),
      invoice: commonUtils.getPageSize('finance_demand_page_size'),
    }
    self.changePageSize = function (num, type) {
      self.pageSize[type] = commonUtils.getPageSize('finance_demand_' + type + '_page_size', num);
    };

    self.loadUnapprovedQuotInvs = function(stTableParams, tableCtrl, type) {
      queryWishes = {};
      if (stTableParams) {
        var queryWishes = {
          paging: {
            offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.pageSize,
            limit: self.pageSize
          },
          filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
          sort: {
            by: stTableParams.sort.predicate,
            reverse: stTableParams.sort.reverse
          }
        };
      }

      queryWishes.filter = queryWishes.filter ? queryWishes.filter : {};
      queryWishes.filter.Approved = false;
      queryWishes.includeOrigin = true;
      return clientApi.custom('model/' + _.upperFirst(type), 'list', {
        divisionId: self.ctx[type],
        queryWishes: queryWishes,
      })
      .then(function(res) {
        self[type] = res.rows;
        if (stTableParams) {
          stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.pageSize[type]);
          self.showPager[type] = stTableParams.pagination.numberOfPages > 1;
          if (res.count > 0 && res.rows.length === 0) {
            stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.pageSize[type];
          }
        }
      });
    }

    self.edit = function(quotInv, type) {
      var promise = Promise.resolve([]);
      if (type === 'invoice') {
        promise = clientApi
          .custom(
            'model/FinanceProcessStep',
            'getRelevantSelections',
            { divisionId: type === 'invoice' ? invoiceCtx : quotCtx, elementId: quotInv.id, type: type, usePrevOrigin: true }
          )
      }

      return promise
        .then(function (result) {
          if (result && result.processSteps && result.processSteps.length > 1) {
            $uibModal.open(
              {
                controller: 'selectProcessElementCtrl as $selCtrl',
                animation: true,
                templateUrl: 'app/pages/finances/modals/selectProcessElement.html',
                size: 'xl',
                resolve: {
                  processSteps: function() {
                    return result.processSteps;
                  },
                  financeProcess: function() {
                    result.process.Approved = false;
                    return result.process;
                  },
                  flowStepConfigs: function() {
                    return clientApi.custom('model/FinanceProcess', 'resolveProcessFlowStepConfigs');
                  },
                  ctx: function() {
                    return self.ctx;
                  },
                  viewOnly: function() {
                    return false;
                  },
                  enableTitleEdit: function() {
                    return false;
                  },
                  originParams: function() {
                    return {
                      source: _.upperFirst(type),
                      elementId: quotInv.id,
                      enableRepick: true,
                    }
                  }
                }
              }).result
              .then(function(result) {
                var stateParams = {
                  type: type,
                  ctx: type === 'invoice' ? invoiceCtx : quotCtx,
                  needsApproval: true,
                }
                if (result.type === 'Service') {
                  stateParams.id = quotInv.id;
                } else {
                  stateParams.recreate = {
                    resultType: type,
                    sourceType: result.type,
                    id: result.id,
                  };
                  stateParams.deleteFloatingId = quotInv.id;
                }
                $state.go('arno.finances.quotationInvoiceDetails', stateParams, { reload: true });
              })
              .catch(function() {
                // hmm k
              })
          } else {
            $state.go('arno.finances.quotationInvoiceDetails', {
              type: type,
              id: quotInv.id,
              ctx: self.ctx[type],
              needsApproval: true,
            });
          }
        })
    }

    self.deny = function (quotInv, type) {
      return QuotInvService
        .removeQuotInv(quotInv.id, type === 'invoice', self.ctx[type], quotInv.Creator, dateFilter(quotInv.createdAt, 'dd.MM.yyyy HH:mm'), true)
        .then(function () {
          $state.reload();
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.events.serviceDetail', [])
    .controller('ServiceDetailCtrl', ServiceDetailCtrl);

  function ServiceDetailCtrl($timeout, $rootScope, $scope, $state, commonUtils, MEMBER_COUNTRY_IDS, screenSize,
    availableServiceTypes, eventCategories, eventCtx, $stateParams, EVENT_CONSTANTS, stateChangePrompt,
    clientApi, toastr, preexistingCall, permissions, baModalService, flowStepConfig, validationUtils,
    eventUtil, materialUtil, serviceMaterialMeta, serviceMaterialTableConfigs, $uibModal, fileStorage,
    $translate, quotationBase, divisionBusinessPartners, financeProcess) {
    $timeout(function () {
      if ($rootScope.openServiceScrollToShift) {
        var el = document.getElementById('shift-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });

        // reset flag
        $rootScope.openServiceScrollToShift = false;
      }
    }, 300);

    var self = this;

    self.mediaSizeSM = screenSize.on('sm', function (match) {
      self.mediaSizeSM = match;
    });
    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });


    self.EVENT_CONSTANTS = EVENT_CONSTANTS;

    self.division = eventCtx;
    self.Treedata = commonUtils.division.divisionTreeData;

    self.creatingNewService = !$stateParams.service && !preexistingCall;



    if ($stateParams.service) {

      self.serviceData = $stateParams.service;

      self.serviceData.id = null;
      self.serviceData.ServiceShifts = [];
      self.serviceData.FlowState = 'DRAFT';
      self.serviceData.HelperHoursTransferred = false;
      self.serviceData.createdAt = null;
      self.serviceData.updatedAt = null;
      self.serviceData.ServiceShares = [];
    }
    else if (preexistingCall) {
      self.serviceData = preexistingCall;
    }

    else {
      self.serviceData = {
        BaseCategories: [],
        ServiceShifts: [],
        ServiceShares: [],
        BusinessPartnerId: null,
        BusinessPartner: null,
        ServiceTypeId: null,
        ServiceOperationsManagers: [],
        QuotationBaseJson: {},
      };
    }

    if (!preexistingCall && quotationBase) {
      self.serviceData.BusinessPartner = quotationBase.BusinessPartner;
      self.serviceData.BusinessPartnerId = quotationBase.BusinessPartner.id;
      self.serviceData.Subject = quotationBase.Title;
      self.serviceData.QuotationBaseJson = quotationBase;
    }

    self.createEvent = commonUtils.event.createEvent;

    self.quotationBaseId = (self.serviceData.QuotationBaseJson || {}).id || null;

    self.serviceData.newRemark = '';

    self.fileStorage = fileStorage;
    self.divisionBusinessPartners = divisionBusinessPartners;

    self.division = eventCtx;
    if (Array.isArray(self.division) && self.division.length) {
      self.division = self.division[0];
    }
    self.sourceDivisionName = (_.find(commonUtils.division.divisionTreeData || [], { id: self.division }) || { Name: '' }).Name;
    if (preexistingCall && preexistingCall.SourceDivision) {
      self.division = preexistingCall.SourceDivision.id;
      self.sourceDivisionName = preexistingCall.SourceDivision.Name;
    }

    self.availableServiceTypes = availableServiceTypes;
    if (self.serviceData.ServiceTypeId) {
      self.chosenServiceType = _.find(self.availableServiceTypes, { id: self.serviceData.ServiceTypeId });
    }
    $scope.$watch(function () {
      return self.chosenServiceType;
    }, function () {
      self.serviceData.ServiceTypeId = (self.chosenServiceType || { id: null }).id;
    });

    self.availableServiceCategories = eventCategories;
    if (self.serviceData.BaseCategories.length) {
      self.serviceData.BaseCategories = self.serviceData.BaseCategories
        .map(function (bc) {
          return _.find(self.availableServiceCategories, { id: bc.id }) || bc;
        });
    }

    self.MEMBER_COUNTRY_IDS = MEMBER_COUNTRY_IDS;
    self.eventAddressConf = {
      countryId: {
        required: true,
      },
      zipCode: {
        required: true,
      },
      city: {
        required: true,
        label: $translate.instant('modules.events.service.venue'),
      },
      street: {
        required: true,
      },
      houseNumber: {
        required: true,
      }
    };
    self.eventAddressUIConf = {
      countryId: {
        wrapperCssCls: 'col-sm-3'
      },
      zipCode: {
        wrapperCssCls: 'col-sm-3'
      },
      city: {
        wrapperCssCls: 'col-sm-6'
      },
      street: {
        wrapperCssCls: 'col-sm-9'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-3'
      },
      addressAffix: {
        wrapperCssCls: 'col-sm-12'
      },
    };

    self.eventAddress = {
      CountryId: self.serviceData.CountryId,
      ZIP: self.serviceData.ZIP,
      City: self.serviceData.City,
      Street: self.serviceData.Street,
      HouseNumber: self.serviceData.HouseNumber,
      AddressAffix: self.serviceData.AddressAffix
    };

    self.serviceMaterialMeta = serviceMaterialMeta || {};
    self.serviceMaterialMeta.defaultTableConfig = materialUtil.materialDefaultTableConfig;
    self.serviceMaterialMeta.customTableConfig = serviceMaterialTableConfigs;

    self.flow = {
      steps: flowStepConfig,
      lastSavedStep: 0,
      activeStep: 0,
    };

    self.wantsTransferHelperHours = true;

    if (self.serviceData.FlowState) {
      var found = _.find(self.flow.steps, { ident: self.serviceData.FlowState });
      self.flow.activeStep = (found && self.flow.steps.indexOf(found)) || 0;
      self.flow.lastSavedStep = self.flow.activeStep;
    } else {
      self.serviceData.FlowState = self.flow.steps[0].ident;
    }

    self.flowStateMap = {};
    (self.flow.steps || []).forEach(function (step) {
      self.flowStateMap[step.ident] = step;
    });

    self.stepChangeHints = {};
    $scope.$watch(function () {
      return (self.flow.lastSavedStep !== self.flow.activeStep) && self.flow.activeStep;
    }, function (newVal) {
      if (newVal === false) {
        self.stepChangeHints = {};
        return;
      }
      var from = self.flow.steps[self.flow.lastSavedStep];
      var to = self.flow.steps[self.flow.activeStep];
      ['requirements', 'config'].forEach(function (type) {
        var typeMap = [from[type], to[type]].map(function (source, isToStep) {
          return Object
            .keys(source)
            .filter(function (key) {
              if (!isToStep && from.ident === 'DRAFT' && key === 'backAvailable') {
                // that back is unavailable in DRAFT is a technicality due to it being the first step, we need it to be true for hint calc
                return true;
              }
              return !!source[key];
            });
        });
        self.stepChangeHints[type] = _.difference(typeMap[1], typeMap[0]);
        self.stepChangeHints[type + 'Removed'] = _.difference(typeMap[0], typeMap[1]);
      });
      self.calcCanTransferHelperHours();
    });

    self.calcCanTransferHelperHours = function () {
      self.canTransferHelperHours = self.hasManagePermsInSourceDivOrForItem && !self.serviceData.HelperHoursTransferred
        && !!(self.flow.steps[self.flow.activeStep].config || {}).canTransferHelperHours;
    };

    self.validationScroll = function (form) {
      validationUtils.validationScroll($scope, form);
    };

    self.flowFieldRequired = function (requirement) {
      return ({
        true: {
          label: 'required-label',
          val: true,
        },
        false: {
          label: '',
          val: false,
        }
      })[!!(self.flow.steps[self.flow.activeStep].requirements || {})[requirement || 'metaFieldsRequired']];
    };

    self.cloneService = function () {

      var detailOpts = {

        ctx: [self.division],
        service: self.serviceData
      };
      $state.go('arno.events.serviceDetail', detailOpts, { reload: true });
    };

    self.showReportField = function (asEditable) {
      if (!self.hasManagePermsInSourceDivOrForItem && !self.canPartiallyEdit) {
        return false;
      }
      if (asEditable) {
        return self.viewMode !== 'view' && !~['FINISHED', 'ARCHIVED'].indexOf(self.flow.steps[self.flow.lastSavedStep].ident);
      }
      return !!~['REALISED', 'FINISHED', 'ARCHIVED'].indexOf(self.flow.steps[self.flow.activeStep].ident);
    };

    self.isArchived = !!(self.flow.steps[self.flow.lastSavedStep].config || {}).accessibleByArchive;

    self.positionTakenTrackCalc = function () {
      var unfilledPositions = {};
      var positionMetaMap = {};
      (self.serviceData.ServiceShifts || []).forEach(function (shift) {
        (shift.ServiceFunctions || []).forEach(function (position) {
          unfilledPositions[position.id] = position.PositionCount || 0;
          positionMetaMap[position.id] = { shift: shift, position: position };
        });
        (shift.ServiceShiftMembers || []).forEach(function (attendee) {
          if (attendee.ServiceFunctionId // if attendee has service function id set
            // and service function has a position count index
            && Object.prototype.hasOwnProperty.call(unfilledPositions, attendee.ServiceFunctionId)
            // and the attendee has no removal warning, originating from a removed shift share, were the position would open up directly after saving
            && (!self.shiftTemplateOpts.attendanceRemovalWarning || !self.shiftTemplateOpts.attendanceRemovalWarning[attendee.MemberId]
              || !self.shiftTemplateOpts.attendanceRemovalWarning[attendee.MemberId][positionMetaMap[attendee.ServiceFunctionId].shift.id])
          ) {
            // then remove one count from our open position index, in hopes to get it to zero (^= all positions taken)
            // could go into negative, if positions were over provisioned, that's okay as it would also fail this check - as it should
            unfilledPositions[attendee.ServiceFunctionId]--;
          }
        });
      });
      self.positionTakenTrack = { type: 'allPositionsTaken', over: [], under: [] };
      ['over', 'under'].forEach(function (type) {
        self.positionTakenTrack[type] = Object.keys(unfilledPositions).filter(function (positionId) {
          return type === 'over' ? (unfilledPositions[positionId] < 0) : (unfilledPositions[positionId] > 0);
        }).map(function (positionId) {
          return {
            shift: positionMetaMap[positionId].shift.Subject || $translate.instant('modules.events.service.newShift'),
            position: positionMetaMap[positionId].position.Function || $translate.instant('modules.events.service.newPosition')
          };
        });
      });
    };

    $scope.$watch(function () {
      return self.serviceData.ServiceShifts;
    }, self.positionTakenTrackCalc, true);
    $scope.$watch(function () {
      return self.shiftTemplateOpts.attendanceRemovalWarning;
    }, self.positionTakenTrackCalc, true);

    self.serviceShiftValid = function (forValidator) {
      var invalid = [];

      if ((self.flow.steps[self.flow.activeStep].requirements || {}).shiftCountRequired && !(self.serviceData.ServiceShifts || []).length) {
        invalid.push('shiftCountRequired');
      }
      if ((self.flow.steps[self.flow.activeStep].requirements || {}).allPositionsTaken) {
        if (self.positionTakenTrack.over.length || self.positionTakenTrack.under.length) {
          // currently deactivated position track validation check
          // invalid.push(self.positionTakenTrack);
        }
      }

      var bookingMaterialTimes = _.flattenDeep(
        (self.serviceData.ServiceShifts || [])
          .map(function (serviceShift) {
            return Object
              .keys(serviceShift)
              .filter(function (key) {
                return key.indexOf('ServiceShiftMaterial') === 0;
              })
              .map(function (key) {
                return _.map(serviceShift[key], 'BookingMaterialTimeId');
              });
          })
      );
      if (_.compact(bookingMaterialTimes).length !== bookingMaterialTimes.length) {
        invalid.push('bookingMaterialTimeRequired');
      }

      if (forValidator) {
        return !invalid.length;
      }
      return invalid;
    };

    $scope.$watch(function () {
      return self.flow.activeStep;
    }, function () {
      self.serviceData.FlowState = self.flow.steps[self.flow.activeStep].ident;

      // handle required state of address component
      ['countryId', 'zipCode', 'city', 'street', 'houseNumber'].forEach(function (prop) {
        self.eventAddressConf[prop].required = self.flowFieldRequired().val;
      });

      // handle self attend button in shift template component
      self.hideComponent.selfAttend = !(
        (self.flow.steps[self.flow.activeStep].config || {}).selfAttend || self.hasManagePermsInSourceDivOrForItem || self.canPartiallyEdit
      ) || (self.metaFieldFrozen && !self.metaFieldPartialViewThaw);
      self.hideComponent.shiftEdit = !self.hasManagePermsInSourceDivOrForItem || self.metaFieldFrozen;
      self.hideComponent.positions = !self.hasManagePermsInSourceDivOrForItem && !self.canPartiallyEdit
        && !(self.flow.steps[self.flow.activeStep].config || {}).displayPositionAssocForAll;
      self.hideComponent.attendeeEdit = 
        (!self.hasManagePermsInSourceDivOrForItem && !self.canPartiallyEdit)
        || (self.metaFieldFrozen && !self.metaFieldPartialEditThaw);
      self.hideComponent.positionEdit = !self.hasManagePermsInSourceDivOrForItem || self.metaFieldFrozen;
      self.hideComponent.materialEdit = !self.hasManagePermsInSourceDivOrForItem || self.metaFieldFrozen;
      self.hideComponent.flowSelfAttend = !(self.flow.steps[self.flow.activeStep].config || {}).selfAttend;
    });

    self.BusinessPartner = {};
    if (self.serviceData.BusinessPartner) {
      self.BusinessPartner = self.serviceData.BusinessPartner;
    }

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4
      }
    };

    self.datepickerReminder = {
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        minDate: new Date(),
        showWeeks: false,
        yearColumns: 4
      }
    };

    self.isValidDate = function () {
      return !!(self.serviceData.EventStartDate
        && self.serviceData.EventEndDate
        && (moment(self.serviceData.EventStartDate).diff(moment(self.serviceData.EventEndDate)) < 0));
    };

    if (preexistingCall) {
      [/* 'StartDate', 'EndDate', */ 'EventStartDate', 'EventEndDate', 'AttendanceReminderDate'].forEach(function (dateProp) {
        if (self.serviceData[dateProp]) {
          self.serviceData[dateProp] = moment(self.serviceData[dateProp]).toDate();
        }
      });
    } else {
      [/* { s: 'StartDate', e: 'EndDate' }, */ { s: 'EventStartDate', e: 'EventEndDate' }]
        .forEach(function (date) {
          self.serviceData[date.s] = moment().add(commonUtils.time.getNextQuarter(moment().minutes()), 'minutes').toDate();
          if ($stateParams.startDate && !moment($stateParams.startDate).isSame(moment(), 'day')) {
            self.serviceData[date.s] = moment($stateParams.startDate).add(8, 'hours').toDate();
          }
          self.serviceData[date.e] = moment(self.serviceData[date.s]).add(1, 'hours').toDate();
        });
    }

    $scope.$watch(function () {
      return self.serviceData.EventStartDate;
    }, function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (moment(self.serviceData.EventStartDate).diff(moment(self.serviceData.EventEndDate)) >= -1) {
        var previousDiff = moment(self.serviceData.EventEndDate).diff(moment(oldVal));
        if (previousDiff > -1) {
          self.serviceData.EventEndDate = moment(self.serviceData.EventStartDate).add(moment.duration(previousDiff)).toDate();
          toastr.preventDuplicate(function () {
            toastr.info($translate.instant('modules.events.service.dateToaster'), $translate.instant('modules.events.service.dateToaster2'));
          });
        }
      }
    });

    self.availableCateringTypes = Object.keys(self.EVENT_CONSTANTS.CATERING_TYPE)
      .map(function (key) {
        return { id: key, label: self.EVENT_CONSTANTS.CATERING_TYPE[key] };
      });
    if (self.serviceData.CateringType) {
      self.chosenCateringType = _.find(self.availableCateringTypes, { id: self.serviceData.CateringType });
    } else {
      self.chosenCateringType = self.availableCateringTypes[0];
    }
    self.cateringTypeChosen = function (cateringType) {
      self.serviceData.CateringType = (cateringType || {}).id || undefined;
    };
    self.cateringTypeChosen(self.chosenCateringType);

    self.managePermissionsIn = function (divisionId, inSome) {
      if (!divisionId) {
        return false;
      }
      var divId = divisionId.id || divisionId;
      divId = Array.isArray(divId) ? divId : [divId];
      return permissions[inSome ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.service.manage', 'Division', divId);
    };

    self.viewPermissionsList = [];
    self.managePermissionsList = [];
    self.permissionsListCalc = function () {
      [
        { list: 'viewPermissionsList', perm: 'arno.events.service.view' },
        { list: 'managePermissionsList', perm: 'arno.events.service.manage' }
      ].forEach(function (permConf) {
        self[permConf.list].splice(0, self[permConf.list].length);
        Array.prototype.push.apply(
          self[permConf.list],
          permissions.getPermittedIds(
            permConf.perm,
            'Division',
            self.serviceData.ServiceShares.map(function (serviceShare) {
              return serviceShare.DivisionId;
            }).concat([self.division]).map(function (divisionId) {
              return parseInt(divisionId, 10);
            }),
            false
          )
        );
      });
    };
    self.permissionsListCalc();
    $scope.$watch(function () {
      return self.serviceData.ServiceShares;
    }, function () {
      $scope.$evalAsync(self.permissionsListCalc);
    }, true);

    self.hideComponent = {};
    if (preexistingCall) {
      self.hasManagePermsInSourceDiv = self.managePermissionsIn(preexistingCall.SourceDivisionId) || false;
      self.hasManageItemPermForService = !!(_.find(self.serviceData.ServiceOperationsManagers || [], { MemberId: $rootScope.ctx.currentUser.id })) || false;
      self.hasManagePermsInSourceDivOrForItem = self.hasManagePermsInSourceDiv || self.hasManageItemPermForService;

      self.viewMode = self.hasManagePermsInSourceDivOrForItem ? 'edit' : 'view';
      self.canDeleteService = self.hasManagePermsInSourceDivOrForItem;

      self.canPartiallyEdit = self.managePermissionsIn(
        (self.serviceData.ServiceShares || [])
          .filter(function (divShare) {
            return divShare.IsShared;
          })
          .map(function (divShare) {
            return divShare.DivisionId;
          }),
        true
      );

      self.canPartiallyEditServiceShares = self.managePermissionsIn(
        (self.serviceData.ServiceShares || [])
          .filter(function (divShare) {
            return divShare.IsShared === null;
          })
          .map(function (divShare) {
            return divShare.DivisionId;
          }),
        true
      );
    } else {
      self.hasManagePermsInSourceDiv = true;
      self.hasManagePermsInSourceDivOrForItem = true;
    }

    if (financeProcess && Object.keys(financeProcess).length && (financeProcess.FinanceProcessSteps || []).length) {
      self.panelTagList = [{
        label: financeProcess.Title,
        labelClass: 'label-warning',
        clickFn: function () {
          $uibModal.open(
            {
              controller: 'selectProcessElementCtrl as $selCtrl',
              animation: true,
              templateUrl: 'app/pages/finances/modals/selectProcessElement.html',
              size: 'xl',
              backdrop: 'static',
              resolve: {
                processSteps: function () {
                  return commonUtils.finances.formatProcessSteps(financeProcess.FinanceProcessSteps);
                },
                financeProcess: function () {
                  return financeProcess;
                },
                flowStepConfigs: function () {
                  return clientApi.custom('model/FinanceProcess', 'resolveProcessFlowStepConfigs');
                },
                ctx: function () {
                  return eventCtx;
                },
                viewOnly: function () {
                  return true;
                },
                enableTitleEdit: function () {
                  return false;
                },
                originParams: function () {
                  return {
                    state: $state.current.name,
                    enableRepick: false,
                  };
                }
              }
            }
          );
        }
      }];
    }
    else if (!self.hasManagePermsInSourceDivOrForItem) {
      self.hasManagePermsInSourceDivOrForItem = self.hasManagePermsInSourceDiv || self.hasManageItemPermForService;
      self.panelTagList = [{
        label: $translate.instant('modules.events.flowbar.' + self.serviceData.FlowState.toLowerCase()),
        labelClass: 'label-info',
        icon: '',
      }];

    }

    self.calcManagePermissionListWithItemPerm = function () {
      self.managePermissionListWithItemPerm = self.managePermissionsList.concat(self.hasManageItemPermForService ? [self.division] : []);
    };
    self.calcManagePermissionListWithItemPerm();
    if (self.hasManageItemPermForService) {
      $scope.$watch(function () {
        return self.managePermissionsList;
      }, self.calcManagePermissionListWithItemPerm);
    }

    self.metaSectionToggleClose = !self.managePermissionsList.length && !self.hasManageItemPermForService;

    self.calcCanTransferHelperHours();

    self.metaFieldFrozen = self.viewMode === 'view' || !!(self.flow.steps[self.flow.lastSavedStep].config || {}).freezeMetadata;
    if (self.viewMode === 'view' && !(self.flow.steps[self.flow.lastSavedStep].config || {}).freezeMetadata && self.canPartiallyEditServiceShares) {
      // partial editor views, may want to trigger chosen actions like accept division share
      self.metaFieldPartialShareThaw = true;
    }
    if (self.viewMode === 'view' && !(self.flow.steps[self.flow.lastSavedStep].config || {}).freezeMetadata && self.canPartiallyEdit) {
      // partial editor views, may want to trigger chosen actions like accept division share
      self.metaFieldPartialEditThaw = true;
    }
    if (self.viewMode === 'view' && !(self.flow.steps[self.flow.lastSavedStep].config || {}).freezeMetadata) {
      // partial editor views, may want to trigger chosen actions like accept division share
      self.metaFieldPartialViewThaw = true;
    }
    self.metaRemarkAvailable = self.viewMode !== 'view' && (self.hasManagePermsInSourceDivOrForItem || self.canPartiallyEdit)
      && (self.flow.steps[self.flow.lastSavedStep].config || {}).remarkAvailable;

    self.isUnchanged = function () {
      return !self.canSaveService || self.changeDetectCompare === self.fetchChanges();
    };

    self.serviceDataSubmitTransformer = function () {
      var toSave = _.cloneDeep(self.serviceData);
      (toSave.ServiceShifts || []).forEach(function (shift) {
        Object
          .keys(shift)
          .filter(function (shiftKey) {
            return shiftKey.indexOf('ServiceShiftMaterial') === 0;
          })
          .forEach(function (shiftMaterialKey) {
            shift[shiftMaterialKey] = (shift[shiftMaterialKey] || [])
              .map(function (shiftMaterial) {
                return { id: shiftMaterial.id, Count: shiftMaterial.Count, BookingMaterialTimeId: shiftMaterial.BookingMaterialTimeId };
              });
          });
      });

      return toSave;
    };

    self.shiftTemplateOpts = {
      templateMode: false,
      mobileEdit: self.creatingNewService,
      ctx: self.division,
      ctxName: self.sourceDivisionName,
      template: self.serviceData,
      shifts: self.serviceData.ServiceShifts,
      hasManagePermsInSourceDiv: self.hasManagePermsInSourceDiv,
      hasManagePermsInSourceDivOrForItem: self.hasManagePermsInSourceDivOrForItem,
      managePermissionsList: self.managePermissionsList,
      viewPermissionsList: self.viewPermissionsList,
      hideComponent: self.hideComponent,
      isUnchangedFunc: self.isUnchanged,
      serviceMaterialMeta: self.serviceMaterialMeta,
      mediaSizeXS: self.mediaSizeXS,
      serviceDataSubmitTransformer: self.serviceDataSubmitTransformer,
    };

    self.fileStorageEditPermissionCheck = function () {
      if ((self.flow.steps[self.flow.lastSavedStep].config || {}).freezeFileStorage) {
        return false;
      }
      return self.hasManagePermsInSourceDivOrForItem;
    };

    self.deleteService = function () {
      baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.events.service.deleteTitle'),
        content: $translate.instant('modules.events.service.deleteContent',
          { subject: self.serviceData.Subject ? (' "' + self.serviceData.Subject + '"') : '' }),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      }).then(function () {
        return clientApi.custom('model/Service', 'removeService', { serviceId: self.serviceData.id, divisionId: self.division })
          .then(function () {
            toastr.success(
              $translate.instant('modules.events.service.deleteContentSucess'),
              $translate.instant('modules.events.service.deleteContentSucess2')
            );
            self.back(true);
          }).catch(function () {
            toastr.error(
              $translate.instant('modules.events.service.deleteContentError'),
              $translate.instant('modules.events.service.deleteContentError2')
            );

            stateChangePrompt.disableEvaluation();
            $state.reload();
          });
      }).catch(function () {

      });
    };

    self.serviceShareChoices = [{ none: true }];
    self.serviceShare = [];
    self.serviceShareSearch = function (searchTerm) {
      if (!searchTerm) {
        self.serviceShareChoices = [{ none: true }];
        return null;
      }

      return clientApi.custom('model/Division', 'searchDivisions', {
        search: searchTerm,
        exclude: self.serviceData.ServiceShares.map(function (ds) {
          return ds.DivisionId;
        }).concat([self.division])
      }).then(function (results) {
        if (results && results.length) {
          self.serviceShareChoices = results;
        } else {
          self.serviceShareChoices = [{ none: true, foundNone: true }];
        }
      });
    };

    // prevent choosing <none> option
    $scope.$watch(function () {
      return self.serviceShareTarget;
    }, function () {
      if (self.serviceShareTarget && self.serviceShareTarget.none) {
        self.serviceShareTarget = null;
      }
    });

    self.serviceShareAdd = function (division) {
      if (division) {
        var serviceShare = {
          id: commonUtils.uuid(),
          state: 'ADDED',
          DivisionId: division.id,
          Division: division,
        };
        if (self.managePermissionsIn(division.id)) {
          // user has manage permissions, we can assume that the share will be instantly accepted by backend event save without further user interactions
          serviceShare.IsShared = true;
        }
        self.serviceData.ServiceShares.push(serviceShare);
        self.serviceShareTarget = null;
      }
    };

    self.handleServiceShare = function (action, divisionShare) {
      Promise.resolve().then(function () {
        if (action === 'DECLINE') {
          return baModalService.messageModal({
            modalType: 'danger',
            allowHtml: false,
            title: $translate.instant('modules.events.service.ServiceShareTitle'),
            content:
              $translate.instant('modules.events.service.ServiceShareContent')
              + divisionShare.Division.Name + $translate.instant('modules.events.service.ServiceShareContent2'),
            primaryActionText: $translate.instant('generalTerms.decline'),
            secondaryActionText: $translate.instant('generalTerms.cancel')
          });
        }
        return null;
      }).then(function () {
        return clientApi.custom('model/ServiceShare', 'setShareState', {
          serviceId: self.serviceData.id,
          divisionId: divisionShare.DivisionId,
          isShared: action === 'ACCEPT',
        });
      }).then(function () {
        if (action === 'ACCEPT') {
          toastr.success(
            $translate.instant('modules.events.service.ServiceShareContentSucess'),
            $translate.instant('modules.events.service.ServiceShareContentSucess2')
          );
          if (self.viewMode === 'view') {
            $state.reload();
          }
        } else {
          toastr.info(
            $translate.instant('modules.events.service.ServiceShareContentInfo'),
            $translate.instant('modules.events.service.ServiceShareContentInfo2')
          );
        }
        $scope.$evalAsync(function () {
          divisionShare.IsShared = action === 'ACCEPT';
          delete divisionShare.state;
        });
      }).catch(function () {

      });
    };

    self.setServiceShareGlobal = function (serviceShare) {
      if (serviceShare.state !== 'REMOVED') {
        serviceShare.IsGlobal = !serviceShare.IsGlobal;
        serviceShare.state = serviceShare.state || 'CHANGED';
      }
    };

    self.divisionShareAddAllSubs = function () {
      var division = { id: self.division };
      self.addSubDivions(division);

    };

    self.addSubDivions = function (division) {
      self.divisionList = self.Treedata.filter(function (div) {
        if (div.ParentDivisionId == division.id) {
          return div;

        }
      });

      self.divisionList.forEach(function (div) {
        if (!_.find(self.serviceData.ServiceShares, { id: parseInt(div.id) })) {
          self.serviceShareAdd(div);
          self.addSubDivions(div);
        }
      });
    };

    self.subDivCheck = function () {
      var divisionList = self.Treedata.filter(function (div) {
        if (div.ParentDivisionId == self.division) {
          return div;

        }
      });

      if (divisionList.length) {
        return true;
      }
      return false;
    };

    self.SubDivisionsExist = self.subDivCheck();

    self.removeServiceShareTitle = function (serviceShare) {
      if (!serviceShare.state) {
        if (serviceShare.IsShared) {
          return $translate.instant('modules.events.service.removeService');
        }
        if (serviceShare.IsShared === null) {
          return $translate.instant('modules.events.service.removeService2');
        }
      }
      if (serviceShare.state === 'REMOVED') {
        return serviceShare.IsShared
          ? $translate.instant('modules.events.service.removeService3')
          : $translate.instant('modules.events.service.removeService4');
      }
      return 'Löschen';
    };
    self.removeServiceShare = function (serviceShare) {
      if (serviceShare) {
        var attendeeCount = 0;
        var positionCount = 0;
        self.serviceData.ServiceShifts.forEach(function (shift) {
          (shift.ServiceShiftMembers || []).forEach(function (attendee) {
            if ((attendee.DivisionId || attendee.Division.id) === serviceShare.DivisionId && attendee.Acceptance !== false) {
              attendeeCount++;
              if (attendee.ServiceFunctionId) {
                positionCount++;
              }
            }
          });
        });

        return Promise.resolve().then(function () {
          if (attendeeCount && serviceShare.state !== 'REMOVED') {
            return baModalService.messageModal({
              modalType: 'danger',
              allowHtml: false,
              title: $translate.instant('modules.events.service.endShare'),
              content: $translate.instant('modules.events.service.endShare2')
                + serviceShare.Division.Name
                + $translate.instant('modules.events.service.endShare3')
                + '\n\n'
                + $translate.instant('modules.events.service.endShare4')
                + (attendeeCount === 1
                  ? $translate.instant('modules.events.service.endShare5')
                  : attendeeCount)
                + $translate.instant('modules.events.service.endShare6')
                + serviceShare.Division.Name
                + $translate.instant('modules.events.service.endShare7')
                + '\n'
                + (positionCount
                  ? ((positionCount === 1
                    ? $translate.instant('modules.events.service.8')
                    : positionCount)
                    + $translate.instant('modules.events.service.endShare9')
                    + (positionCount === 1
                      ? $translate.instant('modules.events.service.endShare10')
                      : $translate.instant('modules.events.service.endShare11'))
                      + $translate.instant('modules.events.service.endShare12'))
                    : '') + '\n\n'
                    + $translate.instant('modules.events.service.endShare13'),
              primaryActionText: $translate.instant('modules.events.service.endShare14'),
              secondaryActionText: 'Abbrechen'
            });
          }
        }).then(function () {
          $scope.$evalAsync(function () {
            if (serviceShare.state === 'ADDED') {
              // was just added and not reported to server yet, simply remove from list
              _.remove(self.serviceData.ServiceShares, { DivisionId: serviceShare.DivisionId });
              return;
            }
            if (serviceShare.state === 'REMOVED') {
              // accidental delete clicks can be reversed by clicking again
              delete serviceShare.state;
              if (serviceShare.preRemoveState) {
                // restore previous state (e.g. CHANGED)
                serviceShare.state = serviceShare.preRemoveState;
                delete serviceShare.preRemoveState;
              }
              return;
            }
            if (serviceShare.state) {
              serviceShare.preRemoveState = serviceShare.state;
            }
            serviceShare.state = 'REMOVED';
          });
        }).catch(function () {
          //hm k
        });
      }
    };

    self.canHandleServiceShare = function (serviceShare) {
      return !serviceShare.state && serviceShare.IsShared === null && ~self.managePermissionsList.indexOf(serviceShare.DivisionId);
    };

    self.serviceShareGroupFunc = function (divShare) {
      if (divShare.none) {
        return '';
      }
      return ((divShare || {}).ParentDivision || {}).Name || ($rootScope.ctx.organization.current.name + ' (Organisation)');
    };

    self.selectedOperationsManager = {};
    self.operationsManagerExclude = (self.serviceData.ServiceOperationsManagers || []).map(function (operationsManager) {
      return operationsManager.MemberId;
    });

    self.addOperationsManager = function () {
      var currentSelection = (self.selectedOperationsManager || {}).value;
      if (currentSelection && !_.find(self.serviceData.ServiceOperationsManagers, { MemberId: currentSelection.MemberId })) {
        self.serviceData.ServiceOperationsManagers.push(currentSelection);
        self.operationsManagerExclude.push(currentSelection.MemberId);
        self.selectedOperationsManager.value = undefined;
      }
    };
    self.removeOperationsManager = function (operationsManager) {
      if (operationsManager) {
        var removedOperationsManager = self.serviceData.ServiceOperationsManagers.splice(
          self.serviceData.ServiceOperationsManagers.indexOf(operationsManager),
          1
        );
        self.operationsManagerExclude.splice(self.operationsManagerExclude.indexOf(removedOperationsManager[0].MemberId), 1);
      }
    };

    self.exportWorkingHours = function () {
      if (self.serviceData.ServiceShifts.length && (self.hasManagePermsInSourceDivOrForItem || self.canPartiallyEdit)) {
        if (!self.isUnchanged() || !self.serviceData.id) {
          return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.service.beforeExportWorkingHours'));
        }
        clientApi.openTab('event/service-working-hours', {
          serviceId: self.serviceData.id,
        });
      }
    };

    self.exportAttendeeList = function () {
      if (self.serviceData.ServiceShifts.length && self.hasManagePermsInSourceDivOrForItem) {
        if (!self.isUnchanged() || !self.serviceData.id) {
          return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.service.beforeExportParticipants'));
        }
        clientApi.openTab('event/service-attendee-list', {
          serviceId: self.serviceData.id,
        });
      }
    };

    self.helperHoursTransfer = function (assumeSaved, svcId) {
      if (!assumeSaved && (!self.isUnchanged() || !self.serviceData.id)) {
        return eventUtil.saveBeforeProceedModal($translate.instant('modules.events.service.beforeShareHelpingHours'));
      }
      var serviceId = self.serviceData.id || svcId;
      return $uibModal.open({
        controller: 'helperHoursTransferModalCtrl as self',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/modals/helperHoursTransferModal/helperHoursTransferModal.html',
        size: 'lg',
        resolve: {
          dataSource: function () {
            return clientApi.custom('model/Service', 'fetchHelperHours', { serviceId: serviceId });
          }
        }
      }).result.then(function (helperHours) {
        return clientApi.custom('model/Service', 'saveHelperHours', { serviceId: serviceId, helperHours: helperHours });
      }).then(function (helperHours) {
        toastr.success(
          $translate.instant('modules.events.service.shareHelpingHourseToaster'),
          $translate.instant('modules.events.service.shareHelpingHourseToaster2')
        );
        if (!assumeSaved) {
          $state.reload();
        }
        return helperHours;
      }).catch(function (e) {
        if (e) {
          toastr.error(
            $translate.instant('modules.events.service.shareHelpingHourseToaster3'),
            $translate.instant('modules.events.service.shareHelpingHourseToaster4')
          );
        }
      });
    };

    self.expectsExpectedShortAmountCount = true;
    $scope.$watch(function () {
      return self.shiftTemplateOpts.bookingMaterialExpectedShortAmounts && Object.keys(self.shiftTemplateOpts.bookingMaterialExpectedShortAmounts).length;
    }, function (newVal, oldVal) {
      self.expectedShortAmountCount = newVal;
      if (newVal !== oldVal && oldVal !== undefined) {
        self.expectsExpectedShortAmountCount = false;
      }
    });

    self.submitService = function () {
      var savedService;
      return clientApi
        .custom('model/Service', 'saveService', {
          serviceData: self.serviceDataSubmitTransformer(),
          divisionId: self.division,
          bookingMaterialExpectedShortAmounts: self.shiftTemplateOpts.bookingMaterialExpectedShortAmounts,
        })
        .then(function (saveResult) {
          savedService = saveResult;
          toastr.success(
            $translate.instant('modules.events.service.saveService'),
            $translate.instant('modules.events.service.saveService2')
          );
          if (!saveResult.helperHoursTransferred && self.canTransferHelperHours && self.wantsTransferHelperHours) {
            return self.helperHoursTransfer(true, saveResult.id);
          }
        })
        .then(function () {
          if (self.refreshOnSave) {
            stateChangePrompt.disableEvaluation();
            if (!self.serviceData.id) {
              $state.go('arno.events.serviceDetail', { serviceId: savedService.id });
              return;
            }
            $state.reload();
            return;
          }
          self.back(true);
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.events.service.saveServiceFailed'),
            $translate.instant('modules.events.service.saveServiceFailed2')
          );
        });
    };

    self.back = function (force) {
      if (force) {
        stateChangePrompt.disableEvaluation();
      }
      $state.go(
        $rootScope.transitionHistoryFetchState(
          ['arno.events.overview', 'arno.events.serviceList', 'arno.events.demandForAction'],
          'arno.events.overview'
        )
      );
    };

    self.fetchChanges = function () {
      return JSON.stringify(self.serviceData, function (key, value) {
        if (~['$$hashKey', 'CountryId', 'bookingMaterialUtilization'].indexOf(key)) {
          return undefined;
        }
        return value;
      });
    };

    self.canSaveService = (self.viewMode !== 'view' || self.canPartiallyEdit) && !self.isArchived;
    if (self.canSaveService) {
      self.changeDetectCompare = self.fetchChanges();
      stateChangePrompt.evaluate(self.isUnchanged);
    }

    self.createQuotInv = function (svc, type) {
      if (permissions.isPermittedInEvery(
        type === 'quotation'
        ? 'arno.finances.quotations.edit'
        : 'arno.finances.invoices.edit', 'Division', [svc.SourceDivisionId])) {
        var promise = Promise.resolve([]);
        if (type === 'invoice') {
          promise = clientApi
            .custom(
              'model/FinanceProcessStep',
              'getRelevantSelections',
              { divisionId: svc.SourceDivisionId, elementId: svc.id, type: 'Service' }
            );
        }
        return promise
          .then(function (result) {
            if (result && result.processSteps && result.processSteps.length > 1) {
              $uibModal.open(
                {
                  controller: 'selectProcessElementCtrl as $selCtrl',
                  animation: true,
                  templateUrl: 'app/pages/finances/modals/selectProcessElement.html',
                  size: 'xl',
                  resolve: {
                    processSteps: function () {
                      return result.processSteps;
                    },
                    financeProcess: function () {
                      return result.process;
                    },
                    flowStepConfigs: function () {
                      return clientApi.custom('model/FinanceProcess', 'resolveProcessFlowStepConfigs');
                    },
                    ctx: function () {
                      return self.ctx;
                    },
                    viewOnly: function () {
                      return false;
                    },
                    enableTitleEdit: function () {
                      return false;
                    },
                    originParams: function () {
                      return {
                        serviceData: self.serviceData,
                        source: 'Service',
                        elementId: svc.id,
                        enableRepick: true,
                      };
                    }
                  }
                }).result
                .then(function (result) {
                  var stateParams = {
                    type: type,
                    ctx: svc.SourceDivisionId,
                  };
                  if (result.type === 'Service') {
                    stateParams.serviceId = result.id;
                  } else {
                    stateParams.recreate = {
                      resultType: type,
                      sourceType: result.type,
                      id: result.id,
                    };
                  }
                  $state.go('arno.finances.quotationInvoiceDetails', stateParams, { reload: true });
                })
                .catch(function () {
                  // hmm k
                });
            } else {
              $state.go('arno.finances.quotationInvoiceDetails', {
                serviceId: svc.id,
                type: type,
                ctx: [svc.SourceDivisionId],
              });
            }
          });
      } else {
        // if no perms to create quot, send a request to have a quot created
        baModalService.messageModal({
          modalType: 'info',
          allowHtml: false,
          title: $translate.instant('modules.finances.demandForAction.noPermConfirmTitle', { type: type }),
          content: $translate.instant('modules.finances.demandForAction.noPermConfirmContent', { type: type }),
          primaryActionText: $translate.instant('generalTerms.confirm'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        }).then(function () {
          return clientApi.custom('model/' + _.upperFirst(type), 'create' + _.upperFirst(type) + 'FromService', {
            divisionId: [svc.SourceDivisionId],
            serviceId: svc.id,
          }).then(function () {
            toastr.success(
              $translate.instant('modules.finances.demandForAction.noPermCreationSuccessToaster', { type: type }),
              $translate.instant('modules.finances.demandForAction.noPermCreationSuccessToasterTitle', { type: type })
            );
            self.back(true);
          }).catch(function () {
            toastr.error(
              $translate.instant('modules.finances.demandForAction.noPermCreationFailToaster', { type: type }),
              $translate.instant('modules.finances.demandForAction.noPermCreationFailToasterTitle', { type: type })
            );
          });
        }).catch(function () {
          // hmm k
        });
      }
    };

    self.setBusinessPartner = function (bp) {
      self.serviceData.BusinessPartnerId = (bp || {}).id || null;
      self.serviceData.BusinessPartner = bp || null;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.events.overview', [])
    .controller('OverviewCtrl', OverviewCtrl);

  function OverviewCtrl($scope, $state, commonUtils, ctx, screenSize, availableServiceTypes, divisionShares,
    openServiceAttendeeInterest, flowStepConfig, $translate) {
    var self = this;
    self.categories = [];
    self.ctx = ctx;
    self.loopBack = {};
    self.divisionShares = divisionShares;
    self.openServiceAttendeeInterest = openServiceAttendeeInterest;
    self.availableEventTypes = [{ Name: $translate.instant('modules.events.overview.allEvents'), val: null }, { Name: $translate.instant('modules.events.overview.date'), val: 'EVENT' }, { Name: $translate.instant('modules.events.overview.service'), val: 'SERVICE' }];
    self.selectedEventType = self.availableEventTypes[0];
    self.flowStepConfig = flowStepConfig;

    self.mediaSizeSM = screenSize.on('sm', function (match) {
      self.mediaSizeSM = match;
    });
    self.mediaSizeXS = screenSize.on('xs', function (match) {
      self.mediaSizeXS = match;
    });

    self.createEvent = commonUtils.event.createEvent;
    self.getShowElement = commonUtils.event.getShowElement;
    self.chosen = {
      categories: [],
      eventType: null,
      onlyActive: true,
      nearFutureView: true,
      refiner: 'MY_SERVICES',
      serviceType: null,
    };
    $scope.$watch(function () {
      return self.selectedEventType;
    }, function () {
      self.chosen.eventType = self.selectedEventType.val;
    });
    if ($state && $state.current && $state.current.name === 'arno.events.serviceList') {
      var savedRefiner = commonUtils.preference.object.get('serviceListRefiner');
      if (savedRefiner) {
        if (savedRefiner.refiner !== 'MANAGE' || self.getShowElement('hasServiceManageOrItemPerm', true, self.ctx)) {
          self.chosen = savedRefiner;
          if (!self.chosen.nearFutureView) {
            self.dateJump = (commonUtils.preference.object.get('serviceListDateJump') || {}).val;
            if (self.dateJump) {
              self.dateJump = new Date(self.dateJump);
            }
          }
        }
        if (!self.getShowElement('hasServiceManageOrItemPerm', true, self.ctx)) {
          self.chosen.refiner = 'MY_SERVICES';
          self.chosen.onlyActive = true;
        }
      }
    }

    self.categoryGroupFunc = function (cat) {
      return ((cat || {}).Division || {}).Name || $translate.instant('modules.events.overview.organizationWide');
    };

    self.dateJumper = {
      minMode: 'month'
    };

    $scope.$watch(function () {
      return self.dateJump;
    }, function (newVal) {
      if (newVal && self.loopBack.calendarInit) {
        commonUtils.preference.object.set('serviceListDateJump', {
          val: newVal,
        }, 1000 * 60 * 60 * 8);
        self.loopBack.calendarInit(moment(newVal).startOf('month'));
      }
    });

    self.onlyActiveKeys = { on: $translate.instant('modules.events.overview.onlyActive'), off: $translate.instant('modules.events.overview.ActiveArchive') };
    self.onlyActiveHints = {
      on: $translate.instant('modules.events.overview.onlyActiveHintsOn'),
      off: $translate.instant('modules.events.overview.onlyActiveHintOff')
    };

    self.nearFutureKeys = { on: $translate.instant('modules.events.overview.nearFuture'), off: $translate.instant('modules.events.overview.month') };
    self.nearFutureHints = {
      on: $translate.instant('modules.events.overview.nearFutureHint1'),
      off: $translate.instant('modules.events.overview.nearFutureHint2')
    };

    $scope.$watch(function () {
      return self.chosen.nearFutureView;
    }, function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      self.loopBack.calendarInit(self.chosen.nearFutureView ? null : moment().startOf('month'));
      self.dateJump = undefined;
    });

    $scope.$watch(function () {
      return self.chosen;
    }, function (newVal) {
      commonUtils.preference.object.set('serviceListRefiner', newVal, 1000 * 60 * 60 * 8);
    }, true)

    self.availableServiceTypes = [{ none: true, Name: $translate.instant('modules.events.overview.allEventTypes') }].concat(availableServiceTypes);
    if (!self.chosen.serviceType || !_.find(self.availableServiceTypes, function (st) {
      return st.id === self.chosen.serviceType.id;
    })) {
      self.chosen.serviceType = self.availableServiceTypes[0];
    }

    self.availableAttendanceTypes = [
      { Name: $translate.instant('modules.events.overview.open') , type: 'UNSPECIFIED', filterDefault: true },
      { Name: $translate.instant('modules.events.overview.confirmed') , type: 'ACCEPTED', filterDefault: true },
      { Name: $translate.instant('modules.events.overview.interested'), type: 'INTERESTED', filterDefault: true },
      { Name: $translate.instant('modules.events.overview.canceled'), type: 'DECLINED' },
    ]
    self.filterAttendanceTypesDefaults = function (typesList) {
      return typesList.filter(function (attendanceType) {
        return attendanceType.filterDefault;
      });
    }
    self.setAttendanceTypeDefaultView = function () {
      self.chosen.attendanceType = self.filterAttendanceTypesDefaults(self.availableAttendanceTypes);
    }
    self.setAttendanceTypeDefaultView();

    $scope.$watch(function () {
      return self.chosen.attendanceType;
    }, function () {
      var defaults = self.filterAttendanceTypesDefaults(self.availableAttendanceTypes);
      self.attendanceTypeDefaultViewPlausibleReset = !(
        self.chosen.attendanceType.length === defaults.length
        && self.chosen.attendanceType
          .filter(function (chosenType) {
            return _.find(defaults, { type: chosenType.type });
          })
          .length === defaults.length
      );
    }, true);
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.events.demandForAction', [])
    .controller('EventDemandForActionCtrl', EventDemandForActionCtrl);

  /** @ngInject */
  function EventDemandForActionCtrl(serviceCtx, commonUtils, clientApi, QuotInvService, dateFilter, permissions, $state,
    toastr, baModalService, $translate) {
    var self = this;
    self.showPager = {};
    self.ctx = {
      service: serviceCtx,
      event: null
    };

    self.isPermitted = function (perm, type) {
      return permissions.isPermittedInEvery(perm, 'Division', self.ctx[type]);
    }

    // currently only one type; already roughly prepared to handle multiple demand for action panels
    self.types = [{
      key: 'service',
      getterFn: function (stParams, tableCtrl) {
        return self.loadDFAQuotInvEvents(stParams, tableCtrl, 'service');
      },
      panelTitleVars: { isService: true },
      perm: 'arno.events.service.manage',
      pageSizePrefKey: 'events_demand_service_page_size',
      modelFetchFunc: 'fetchServiceDemands',
      modelDenyFunc: 'rejectServiceDemand',
    }];
    self.byType = _.keyBy(self.types, 'key');

    self.pageSize = {
      service: commonUtils.getPageSize(self.byType.service.pageSizePrefKey),
    }
    self.changePageSize = function (num, type) {
      self.pageSize[type] = commonUtils.getPageSize(self.byType[type].pageSizePrefKey, num);
    };

    self.loadDFAQuotInvEvents = function (stTableParams, tableCtrl, type) {
      queryWishes = {};
      if (stTableParams) {
        var queryWishes = {
          paging: {
            offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.pageSize,
            limit: self.pageSize
          },
          filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
          sort: {
            by: stTableParams.sort.predicate,
            reverse: stTableParams.sort.reverse
          }
        };
      }

      return clientApi.custom('model/Quotation', self.byType[type].modelFetchFunc, {
        divisionId: self.ctx[type],
        queryWishes: queryWishes,
      })
        .then(function (res) {
          self[type] = res.rows;
          if (stTableParams) {
            stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.pageSize[type]);
            self.showPager[type] = stTableParams.pagination.numberOfPages > 1;
            if (res.count > 0 && res.rows.length === 0) {
              stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.pageSize[type];
            }
          }
        });
    }

    self.edit = function (quotInv) {
      $state.go('arno.events.serviceDetail', { ctx: quotInv.DivisionId, quotationBaseId: quotInv.id });
    }

    self.deny = function (quotInv, type) {
      return baModalService
        .messageModal({
          modalType: 'danger',
          allowHtml: false,

          title: 'Handlungsbedarf löschen?',
          content: 'Soll der Handlungsbedarf für das Angebot "' + quotInv.Title + '" wirklich gelöscht werden?',

          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        })
        .then(function() {
          return clientApi
            .custom('model/Quotation', self.byType[type].modelDenyFunc, {
              divisionId: quotInv.DivisionId,
              quotationId: quotInv.id,
            })
            .then(function () {
              toastr.success(
                'Der Handlungsbedarf wurde abgelehnt.',
                'Handlungsbedarf zurückgewiesen'
              );
              $state.reload();
            })
            .catch(function() {
              toastr.error(
                'Beim Ablehnen des Handlungsbedarfs ist ein Fehler aufgetreten.',
                'Ablehnen fehlgeschlagen'
              );
            });
        })
        .catch(function() {
          // hm k
        });
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.events.eventDetail').controller('EventDetailCtrl', EventDetailCtrl);

  function EventDetailCtrl(
    $rootScope,
    $scope,
    screenSize,
    $uibModal,
    toastr,
    clientApi,
    commonUtils,
    $state,
    $stateParams,
    $translate,
    preexistingEvent,
    permissions,
    stateChangePrompt,
    categories,
    baModalService,
    eventCtx,
    eventUtil,
    flowStepConfig,
    fileStorage,
    eventMaterialMeta,
    materialUtil,
    eventMaterialTableConfigs,
    ArnoDashTrainingGroupsService
  ) {
    // eventData properties follow camelCase scheme if they >can't< be
    // saved directly into an appropriate db field (by property name)
    // and PascalCase if they can
    var self = this;

    self.division = eventCtx;
    if (Array.isArray(self.division) && self.division.length) {
      self.division = self.division[0];
    }
    self.sourceDivisionName = (_.find(commonUtils.division.divisionTreeData || [], { id: self.division }) || { Name: '' }).Name;

    self.Treedata = commonUtils.division.divisionTreeData;

    self.mediaSizeXs = screenSize.on('xs', function (match) {
      self.mediaSizeXs = match;
    });

    self.jumpToEditSeries = function ($event, id) {
      $event.stopPropagation();
      $state.go('arno.events.eventDetail', { eventId: id }, { reload: true });
    };

    self.datepicker = {
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4,
      },
    };

    self.seriesPicker = {
      active: null,
      format: 'd!.M!.yyyy',
      options: {
        startingDay: 1,
        showWeeks: false,
        yearColumns: 4,
        customClass: function (data) {
          if (self.eventData.seriesDates.indexOf(data.date.setHours(0, 0, 0, 0)) > -1) {
            return 'multiple-selected';
          }
          return '';
        },
      },
    };

    self.eventSeriesSwitch = {
      keys: {
        on: $translate.instant('modules.events.event.seriesSwitch.on'),
        off: $translate.instant('modules.events.event.seriesSwitch.off'),
      },
      width: 100,
    };

    self.commonSelectValues = {
      place: [
        { id: 1, name: $translate.instant('generalTerms.rank.first') },
        { id: 2, name: $translate.instant('generalTerms.rank.second') },
        { id: 3, name: $translate.instant('generalTerms.rank.third') },
        { id: 4, name: $translate.instant('generalTerms.rank.fourth') },
        { id: 5, name: $translate.instant('generalTerms.rank.last') },
      ],
      day: [
        { id: 1, name: $translate.instant('generalTerms.weekdays.monday') },
        { id: 2, name: $translate.instant('generalTerms.weekdays.tuesday') },
        { id: 3, name: $translate.instant('generalTerms.weekdays.wednesday') },
        { id: 4, name: $translate.instant('generalTerms.weekdays.thursday') },
        { id: 5, name: $translate.instant('generalTerms.weekdays.friday') },
        { id: 6, name: $translate.instant('generalTerms.weekdays.saturday') },
        { id: 7, name: $translate.instant('generalTerms.weekdays.sunday') },
      ],
      month: [
        { id: 1, name: $translate.instant('generalTerms.month.january') },
        { id: 2, name: $translate.instant('generalTerms.month.february') },
        { id: 3, name: $translate.instant('generalTerms.month.march') },
        { id: 4, name: $translate.instant('generalTerms.month.april') },
        { id: 5, name: $translate.instant('generalTerms.month.may') },
        { id: 6, name: $translate.instant('generalTerms.month.june') },
        { id: 7, name: $translate.instant('generalTerms.month.july') },
        { id: 8, name: $translate.instant('generalTerms.month.august') },
        { id: 9, name: $translate.instant('generalTerms.month.september') },
        { id: 10, name: $translate.instant('generalTerms.month.october') },
        { id: 11, name: $translate.instant('generalTerms.month.november') },
        { id: 12, name: $translate.instant('generalTerms.month.december') },
      ],
    };

    self.checkboxDays = [
      { id: 1, name: $translate.instant('generalTerms.weekdays.monday') },
      { id: 2, name: $translate.instant('generalTerms.weekdays.tuesday') },
      { id: 3, name: $translate.instant('generalTerms.weekdays.wednesday') },
      { id: 4, name: $translate.instant('generalTerms.weekdays.thursday') },
      { id: 5, name: $translate.instant('generalTerms.weekdays.friday') },
      { id: 6, name: $translate.instant('generalTerms.weekdays.saturday') },
      { id: 7, name: $translate.instant('generalTerms.weekdays.sunday') },
    ];

    self.actMultipleEventEndRadio = 0;
    self.multipleEventEndRadioUp = function () {
      self.actMultipleEventEndRadio++;
    };

    // validations
    self.checkRequiredData = function (data) {
      return !!(data && Object.keys(data).length);
    };

    self.isValidDate = function () {
      return !(
        !self.eventData.StartDate ||
        !self.eventData.EndDate ||
        moment(self.eventData.StartDate).diff(moment(self.eventData.EndDate)) >= -1
      );
    };

    self.categories = categories;

    self.managePermissionsList = [];

    // init event data objects
    self.eventData = {};

    self.eventData.isSingleEvent = true;
    self.eventData.isEventSeries = false;

    self.eventData.categories = [];

    self.flow = {
      steps: flowStepConfig,
      lastSavedStep: 0,
      activeStep: 0,
    };

    // convert both toDate() for bootstrap components to handle the date correctly
    self.eventData.StartDate = moment().add(commonUtils.time.getNextQuarter(moment().minutes()), 'minutes').toDate();
    if ($stateParams.startDate && !moment($stateParams.startDate).isSame(moment(), 'day')) {
      // 'today' events will use standard logic to set the time of day better then just to 8 o'clock AM
      self.eventData.StartDate = moment($stateParams.startDate).add(8, 'hours').toDate();
    }
    self.eventData.EndDate = moment(self.eventData.StartDate).add(30, 'minutes').toDate();

    self.seriesPicker.active = moment(self.eventData.StartDate).startOf('day').toDate().getTime();

    self.fileStorage = fileStorage;

    self.eventData.divisionShare = [];

    self.attendanceRemovalWarning = {};
    self.attendanceRemovalWarningCheck = function () {
      self.eventData.attendance.forEach(function (attendee) {
        self.attendanceRemovalWarning[attendee.id] = !~(self.eventAssociatedDivisionIds || []).indexOf(parseInt(attendee.Division.id, 10));
      });
    };

    self.wantsTransferHelperHours = true;

    self.isUnderaged = {};
    self.memberUnderagedCalc = function (members) {
      members.forEach(function (member) {
        var memberId = member.id;
        var birthDate = member.BirthDate || (member.Member || {}).BirthDate;
        if (!birthDate) {
          return;
        }
        var age = moment.duration(moment().diff(moment(birthDate))).as('years');
        if (age < 18) {
          self.isUnderaged[memberId] = age.toFixed(1).toString().replace('.', ',');
        }
      });
    };

    $scope.$watch(
      function () {
        return self.eventData.attendance
          .map(function (attendee) {
            return attendee.id;
          })
          .join(',');
      },
      function () {
        self.attendanceRemovalWarningCheck();
        self.memberUnderagedCalc(self.eventData.attendance);
      }
    );

    self.eventResponsibleRemovalWarning = {};
    self.eventResponsibleRemovalWarningCheck = function () {
      self.eventData.eventResponsibles.forEach(function (evtMember) {
        self.eventResponsibleRemovalWarning[evtMember.MemberId] = !_.intersection(
          self.eventAssociatedDivisionIds || [],
          evtMember.Member.DivisionMembers.map(function (member) {
            return member.DivisionId;
          })
        ).length;
      });
    };

    self.downloadICAL = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }
      if (!self.eventData.id || self.hasChanges()) {
        return eventUtil.saveBeforeProceedModal(
          $translate.instant('modules.events.event.modal.beforeICALDownload'),
          $translate.instant('modules.events.event.modal.beforeTitle')
        );
      }

      clientApi.openTab(
        'event/event-appointment-ical',
        {
          eventId: self.eventData.id,
        },
        { post: true }
      );
    };

    $scope.$watch(function () {
      return self.eventData.eventResponsibles
        .map(function (evtMember) {
          return evtMember.MemberId;
        })
        .join(',');
    }, self.eventResponsibleRemovalWarningCheck);

    $scope.$watch(
      function () {
        return self.eventData.divisionShare;
      },
      function () {
        $scope.$evalAsync(function () {
          self.managePermissionsList.splice(0, self.managePermissionsList.length);
          Array.prototype.push.apply(
            self.managePermissionsList,
            permissions.getPermittedIds(
              'arno.events.basic.manage',
              'Division',
              self.eventData.divisionShare
                .map(function (div) {
                  return parseInt(div.id, 10);
                })
                .concat([parseInt(self.division, 10)]),
              false
            )
          );

          self.eventAssociatedDivisionIds = self.eventData.divisionShare
            .filter(function (ds) {
              return ds.IsShared && ds.state !== 'REMOVED';
            })
            .map(function (ds) {
              return parseInt(ds.id, 10);
            })
            .concat([parseInt(self.division, 10)]);

          self.attendanceRemovalWarningCheck();
          self.eventResponsibleRemovalWarningCheck();
        });
      },
      true
    );

    self.eventData.attendance = [];

    self.eventData.series = {
      daily: { eType: 'daily' },
      weekly: { eType: 'weekly' },
      monthly: { eType: 'monthly' },
      yearly: { eType: 'yearly' },
    };

    self.eventData.seriesDates = [];
    self.eventData.series.eventEndType = 'count';
    self.eventData.series.eventEndCount = 1;
    self.eventData.series.startDate = moment(self.eventData.StartDate).toDate();
    self.eventData.series.endDate = moment(self.eventData.series.startDate).add(7, 'days').toDate();

    self.eventData.series.daily.type = 'count';
    self.eventData.series.daily.count = 1;
    self.eventData.series.weekly.count = 1;
    self.eventData.series.weekly.days = {};
    self.eventData.series.monthly.type = 'date';
    self.eventData.series.monthly.dateDay = 1;
    self.eventData.series.monthly.dateMonth = 1;
    self.eventData.series.monthly.dayPlace = self.commonSelectValues.place[0];
    self.eventData.series.monthly.dayDay = self.commonSelectValues.day[0];
    self.eventData.series.monthly.dayMonthCount = 1;
    self.eventData.series.yearly.count = 1;
    self.eventData.series.yearly.type = 'date';
    self.eventData.series.yearly.dateDay = 1;
    self.eventData.series.yearly.dateMonth = self.commonSelectValues.month[0];
    self.eventData.series.yearly.dayPlace = self.commonSelectValues.place[0];
    self.eventData.series.yearly.dayDay = self.commonSelectValues.day[0];
    self.eventData.series.yearly.dayMonth = self.commonSelectValues.month[0];

    self.eventData.eventResponsibles = [];

    self.managePermissionsIn = function (divisionId, inSome) {
      if (!divisionId) {
        return false;
      }
      var divId = divisionId.id || divisionId;
      divId = Array.isArray(divId) ? divId : [divId];
      return permissions[inSome ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.basic.manage', 'Division', divId);
    };

    // material compatibility layer
    self.eventMaterialReverseShare = {};
    self.compatShifts = [
      {
        id: 'base',
        BookingMaterialTimes: [],
      },
    ];
    self.compatShift = self.compatShifts[0];
    $scope.$watch(
      function () {
        return self.eventData.Subject || '';
      },
      function () {
        self.compatShift.Subject = self.eventData.Subject;
      }
    );
    Object.keys(materialUtil.materialModelMap).forEach(function (key) {
      self.compatShift['ServiceShift' + (materialUtil.materialPluralizationMap[key] || key)] = [];
    });
    self.hideMaterialEdit = false;
    self.eventMaterialMeta = eventMaterialMeta || {};
    self.eventMaterialMeta.defaultTableConfig = materialUtil.materialDefaultTableConfig;
    self.eventMaterialMeta.customTableConfig = eventMaterialTableConfigs;
    self.bookingMaterialUtilization = [];
    self.bookingMaterialUtilizationFetch = function () {
      var eventDataPartial = _.cloneDeep(_.omit(self.compatShift, ['id']));

      Object.keys(eventDataPartial)
        .filter(function (key) {
          return key.indexOf('ServiceShiftMaterial') === 0;
        })
        .forEach(function (key) {
          var eventMaterials = eventDataPartial[key] || [];
          var iter = eventMaterials.length;
          while (iter--) {
            var serviceShiftMaterial = eventMaterials[iter];
            if (!serviceShiftMaterial.BookingMaterialTimeId) {
              eventMaterials.splice(eventMaterials.indexOf(serviceShiftMaterial), 1);
            }
          }
        });

      return clientApi.custom(
        'model/Event',
        'prefetchBookingMaterialUtilization',
        {
          eventId: self.eventData.id,
          eventDataPartial: eventDataPartial,
        },
        { backgroundRequest: true }
      );
    };
    self.bookingMaterialIncludedTree = [];

    // view, create or edit mode?
    if (preexistingEvent) {
      // its not create (create is default state)
      // so is it view or edit mode? Edit mode when the user is in the source division (^= division where event was originally created)
      // and view mode for all other users; the edit mode is useable for viewing aswell - duh
      var hasManagePermsInSourceDiv = self.managePermissionsIn(preexistingEvent.SourceDivisionId);
      var hasItemPermissionManageForEvent = preexistingEvent.hasItemPermissionManageForEvent;
      delete preexistingEvent.hasItemPermissionManageForEvent;
      var hasItemPermissionManageForMetaEvent = preexistingEvent.hasItemPermissionManageForMetaEvent;
      delete preexistingEvent.hasItemPermissionManageForMetaEvent;
      var hasManageFromSourceDivOrItemPerm = hasManagePermsInSourceDiv || hasItemPermissionManageForEvent || false;

      var found = _.find(self.flow.steps, { ident: preexistingEvent.FlowState });
      self.flow.activeStep = (found && self.flow.steps.indexOf(found)) || 0;
      self.flow.lastSavedStep = self.flow.activeStep;

      // in template we will sometimes just test if viewMode is set, as this will disable some items regardless
      // of edit or view mode
      self.viewMode = hasManageFromSourceDivOrItemPerm ? 'edit' : 'view';
      self.viewModeSeries = preexistingEvent.Series ? (preexistingEvent.EventSeriesId ? 'eventSeries' : 'eventSeriesMeta') : false;
      self.canJumpToSeries = self.viewModeSeries === 'eventSeries' && (hasManagePermsInSourceDiv || hasItemPermissionManageForMetaEvent);
      self.isArchived = !!(self.flow.steps[self.flow.lastSavedStep].config || {}).accessibleByArchive;
      self.canDeleteEvent = hasManageFromSourceDivOrItemPerm && !self.isArchived;
      self.hasManagePermsInSourceDiv = hasManagePermsInSourceDiv;
      self.hasManageFromSourceDivOrItemPerm = hasManageFromSourceDivOrItemPerm;
      self.hasItemPermissionForEventInDivision = hasItemPermissionManageForEvent && preexistingEvent.SourceDivisionId;

      self.metaFieldFrozen = self.viewMode === 'view' || self.isArchived;
      self.hideMaterialEdit = self.metaFieldFrozen;

      var sharedWithDivisions = (preexistingEvent.divisionShare || [])
        .filter(function (divShare) {
          return divShare.IsShared;
        })
        .map(function (divShare) {
          return divShare.id;
        });
      self.canPartiallyEdit = self.managePermissionsIn(sharedWithDivisions, true);
      self.canSelfAttend = !!preexistingEvent.canSelfAttend;

      self.division = preexistingEvent.SourceDivisionId;
      self.sourceDivisionName = preexistingEvent.SourceDivisionName;

      // fix a few things in preexistingEvent
      preexistingEvent.StartDate = moment(preexistingEvent.StartDate).toDate();
      preexistingEvent.EndDate = moment(preexistingEvent.EndDate).toDate();
      if (preexistingEvent.MeetingTime) {
        preexistingEvent.MeetingTime = moment(preexistingEvent.MeetingTime).toDate();
      }

      preexistingEvent.categories = preexistingEvent.BaseCategory.filter(function (cat) {
        return cat;
      });
      delete preexistingEvent.BaseCategory;

      preexistingEvent.isEventSeries = preexistingEvent.Series;
      preexistingEvent.isSingleEvent = !preexistingEvent.isEventSeries;
      delete preexistingEvent.Series;

      preexistingEvent.attendance = preexistingEvent.Attendance;
      delete preexistingEvent.Attendance;

      // we cant set the startDate as it is often after the actual date which is the min date
      // if we set a date as active that is before the minDate, angular will set the validation
      // state to $error
      self.seriesPicker.active = null;

      _.merge(self.compatShift, preexistingEvent.materials || {});
      delete preexistingEvent.materials;

      self.bookingMaterialUtilization = preexistingEvent.bookingMaterialUtilization;
      delete preexistingEvent.bookingMaterialUtilization;

      self.bookingMaterialIncludedTree = preexistingEvent.bookingMaterialIncludedTree;
      delete preexistingEvent.bookingMaterialIncludedTree;

      _.merge(self.eventData, preexistingEvent);

      // copy the exact object reference from category dropdown and simulate a direct selection when loading preselected categories
      self.eventData.categories = self.eventData.categories.map(function (category) {
        return _.find(self.categories, { id: category.id }) || category;
      });

      self.eventData.eventResponsibles = preexistingEvent.EventResponsible;
    } else {
      self.eventData.FlowState = self.flow.steps[0].ident;
      self.hasManagePermsInSourceDiv = true;
      self.hasManageFromSourceDivOrItemPerm = true;

      $scope.$watch(
        function () {
          return self.eventData.isSingleEvent;
        },
        function () {
          self.eventData.isEventSeries = !self.eventData.isSingleEvent;
          if (self.eventData.isEventSeries) {
            self.flow.activeStep = self.flow.lastSavedStep;
          }
        }
      );
    }

    $scope.$watch(
      function () {
        return self.flow.activeStep;
      },
      function () {
        self.eventData.FlowState = self.flow.steps[self.flow.activeStep].ident;
      }
    );

    $scope.$watch(
      function () {
        return self.flow.activeStep;
      },
      function () {
        self.eventData.FlowState = self.flow.steps[self.flow.activeStep].ident;
      }
    );

    // watch start date as well as end date for changes that would put the one over the other in an
    // invalid way (e.g. start date > end date) and fix it
    self.disableDateWatcher = {};
    self.firstDateWatcherUsed = null;
    self.watcherTypes = [
      { comp: 'StartDate', change: 'EndDate' },
      { comp: 'EndDate', change: 'StartDate' },
    ];
    self.enableDateWatcher = function (type, restartFunc) {
      if (self.disableDateWatcher[self.watcherTypes[type].comp]) {
        self.disableDateWatcher[self.watcherTypes[type].comp]();
        self.disableDateWatcher[self.watcherTypes[type].comp] = null;
      }
      if (restartFunc) {
        restartFunc();
      }
      self.disableDateWatcher[self.watcherTypes[type].comp] = $scope.$watch(
        function () {
          return self.eventData[self.watcherTypes[type].comp];
        },
        function (newValue, oldValue) {
          // if start date after end date
          if (newValue !== oldValue) {
            // activate watcher for first used date input, as long as only this date input was used
            if (self.firstDateWatcherUsed === null) {
              self.firstDateWatcherUsed = type;
            } else {
              if (self.firstDateWatcherUsed !== type) {
                [0, 1].forEach(function (dateWatcherType) {
                  if (self.disableDateWatcher[self.watcherTypes[dateWatcherType].comp]) {
                    self.disableDateWatcher[self.watcherTypes[dateWatcherType].comp]();
                    self.disableDateWatcher[self.watcherTypes[dateWatcherType].comp] = null;
                  }
                });
                return;
              }
            }

            var momentComparisonDate = moment(self.eventData[self.watcherTypes[type].comp]);
            if (momentComparisonDate.diff(moment(self.eventData[self.watcherTypes[type].change])) * (type ? -1 : 1) >= -1) {
              self.enableDateWatcher(type ? 0 : 1, function () {
                // try to only alter date first for possible user convinience
                self.eventData[self.watcherTypes[type].change] = moment(self.eventData[self.watcherTypes[type].change]).set({
                  year: momentComparisonDate.year(),
                  month: momentComparisonDate.month(),
                  date: momentComparisonDate.date(),
                });
                if (momentComparisonDate.diff(moment(self.eventData[self.watcherTypes[type].change])) * (type ? -1 : 1) >= -1) {
                  // setting day/month/year wasn't enough, we have to fix time as well
                  self.eventData[self.watcherTypes[type].change] = self.eventData[self.watcherTypes[type].change].set({
                    hour: momentComparisonDate.hour(),
                    minute: momentComparisonDate.minute(),
                  });
                  if (type) {
                    self.eventData[self.watcherTypes[type].change] = self.eventData[self.watcherTypes[type].change].subtract(
                      15 + commonUtils.time.getNextQuarter(momentComparisonDate.minutes()),
                      'minutes'
                    );
                  } else {
                    self.eventData[self.watcherTypes[type].change] = self.eventData[self.watcherTypes[type].change].add(
                      15 + commonUtils.time.getNextQuarter(momentComparisonDate.minutes()),
                      'minutes'
                    );
                  }
                }
                self.eventData[self.watcherTypes[type].change] = self.eventData[self.watcherTypes[type].change].toDate();
              });
            }
          }
        }
      );
    };
    [0, 1].forEach(function (dateWatcherType) {
      self.enableDateWatcher(dateWatcherType);
    });

    self.updateDefaultMaterialBookingTime = function () {
      var shiftDefaultBookingTime = _.find(self.compatShift.BookingMaterialTimes, { IsDefaultPeriod: true }) || {};
      if (!shiftDefaultBookingTime.id) {
        self.compatShift.BookingMaterialTimes.push(shiftDefaultBookingTime);
      }
      shiftDefaultBookingTime.id = shiftDefaultBookingTime.id || commonUtils.uuid();
      shiftDefaultBookingTime.Title = self.eventData.Subject || $translate.instant('modules.events.event.newEvent');
      shiftDefaultBookingTime.IsDefaultPeriod = true;
      if (
        !shiftDefaultBookingTime.StartDate ||
        !shiftDefaultBookingTime.EndDate ||
        !(
          moment(self.eventData.StartDate).isSame(moment(shiftDefaultBookingTime.StartDate), 'minute') &&
          moment(self.eventData.EndDate).isSame(moment(shiftDefaultBookingTime.EndDate), 'minute')
        )
      ) {
        shiftDefaultBookingTime.StartDate = self.eventData.StartDate;
        shiftDefaultBookingTime.EndDate = self.eventData.EndDate;
        self.eventMaterialReverseShare.updateBookingMaterialUtilizationBase &&
          self.eventMaterialReverseShare.updateBookingMaterialUtilizationBase();

        if (self.compatShift.BookingMaterialTimes.length > 1) {
          toastr.info(
            $translate.instant('modules.events.event.toastr.checkBookingTimesMsg'),
            $translate.instant('modules.events.event.toastr.checkBookingTimesTitle')
          );
        }
      }
    };
    $scope.$watch(function () {
      return (
        (self.eventData.Subject || '') +
        '⨝' +
        moment(self.eventData.StartDate).toISOString() +
        '⨝' +
        moment(self.eventData.EndDate).toISOString()
      );
    }, self.updateDefaultMaterialBookingTime);
    self.updateDefaultMaterialBookingTime();

    self.openPeriodicEventHelper = function () {
      $uibModal
        .open({
          controller: 'PeriodicEventHelperModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/events/event/modals/periodicEventHelper.html',
          size: 'lg',
          resolve: {
            eventDetailCtrl: function () {
              return self;
            },
          },
        })
        .result.catch(function () {});
    };

    self.openRecordModal = function () {
      $uibModal
        .open({
          controller: 'RecordEventModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/events/event/modals/recordEventModal.html',
          size: 'md',
          resolve: {
            eventDetailCtrl: function () {
              return self;
            },
          },
        })
        .result.then(function (result) {
          if (result.recordQualification) {
            self.selectedMembers = result.selectedMembers;

            clientApi
              .custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: self.division })
              .then(function (qualifications) {
                self.qualificationHierarchy = qualifications;

                self.flatQualificationHierarchy = [];
                if (self.qualificationHierarchy && self.qualificationHierarchy.length) {
                  // flatten the hierarchy (removing the groups) and write the group name on every single qualification
                  self.flatQualificationHierarchy = [].concat.apply(
                    [],
                    _.sortBy(self.qualificationHierarchy, 'Name').map(function (qualificationHierarchyItem) {
                      return _.sortBy(qualificationHierarchyItem.Qualifications, 'Name').map(function (qualificationItem) {
                        qualificationItem.GroupName = qualificationHierarchyItem.Name;
                        qualificationItem.QualificationName = qualificationItem.Name;
                        qualificationItem.QualificationId = qualificationItem.id;
                        qualificationItem.expireDate = moment()
                                                      .add(qualificationItem.ValidityPeriodYears, 'years')
                                                      .add(qualificationItem.ValidityPeriodMonths, 'months')
                                                      .add(qualificationItem.ValidityPeriodDays, 'days')
                                                      .format('DD.MM.YYYY');
                        qualificationItem.Type = qualificationHierarchyItem.Type || 'qualification';
                        return qualificationItem;
                      });
                    })
                  );
                }
                $uibModal
                  .open({
                    controller: 'RecordEventQualificationModalCtrl as $modalCtrl',
                    animation: true,
                    templateUrl: 'app/pages/events/event/modals/recordEventQualificationModal.html',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                      qualification: function () {
                        return null;
                      },
                      flatQualificationHierarchy: function () {
                        return self.flatQualificationHierarchy;
                      },
                      type: function () {
                        return 'qualification';
                      },
                      availableMaterials: function () {
                        return null;
                      },
                      member: function () {
                        return self.member;
                      },
                      instructingPerson: function () {
                        return undefined;
                      },
                      onFileDownload: function () {
                        return null;
                      },
                      onFilePreview: function () {
                        return null;
                      },
                      divisionIds: function () {
                        return self.division;
                      },
                    },
                  })
                  .result.then(function (result) {
                    var changedQualifications = { add: result };
                    if (result.length > 0) {
                      self.selectedMembers.forEach(function (member) {
                        if (member.checked) {
                          return clientApi
                            .custom('model/MemberQualification', 'updateMemberQualifications', {
                              cMemberId: member.id,
                              qualificationChanges: changedQualifications,
                              divisionIds: self.division,
                              lastEditTime: new Date(),
                              eventId: self.eventData.id,
                            })
                            .then(function () {
                              toastr.success(
                                $translate.instant(
                                  'modules.personnel.dossier.overview.qualificationList.updateToastText',
                                  self.translateValues
                                ),
                                $translate.instant(
                                  'modules.personnel.dossier.overview.qualificationList.updateToastTitle',
                                  self.translateValues
                                )
                              );
                              stateChangePrompt.disableEvaluation();

                              $state.reload();
                            })
                            .catch(function () {
                              toastr.error(
                                $translate.instant(
                                  'modules.personnel.dossier.overview.qualificationList.updateErrToastText',
                                  self.translateValues
                                ),
                                $translate.instant(
                                  'modules.personnel.dossier.overview.qualificationList.updateErrToastTitle',
                                  self.translateValues
                                )
                              );
                            });
                        } else {
                          toastr.info(
                            $translate.instant(
                              'modules.personnel.dossier.overview.qualificationList.noChangesToastText',
                              self.translateValues
                            ),
                            $translate.instant(
                              'modules.personnel.dossier.overview.qualificationList.noChangesToastTitle',
                              self.translateValues
                            )
                          );
                        }
                      });
                    }
                  });
              });
          }

          if (result.recordTraining) {
            return $uibModal
              .open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/personnel/dossier/trainings/trainingsWizardModal/trainingsWizardModal.tpl.html',
                size: 'md',
                controller: 'PersonnelDossierTrainingsWizardController as $trainingWizardCtrl',
                resolve: {
                  selectedCtx: function () {
                    return self.eventCtx;
                  },
                  member: function () {
                    return result.selectedMembers;
                  },
                  eventId: function () {
                    return self.eventData.id;
                  },
                  trainingTemplatesGroups: function () {
                    // this service fetches all training-groups and also the training-templates
                    return ArnoDashTrainingGroupsService.getTrainingTemplateTree();
                  },
                  categories: function () {
                    return self.categories;
                  },
                },
              })
              .result.then(function () {
                $state.reload();
              });
          }
        });
    };

    self.resetPerodicPatterns = function () {
      self.eventData.seriesDates.splice(0, self.eventData.seriesDates.length);
      self.seriesPicker.active = null;
    };

    self.handleDivisionShare = function (action, divisionShare) {
      Promise.resolve()
        .then(function () {
          if (action === 'DECLINE') {
            return baModalService.messageModal({
              modalType: 'danger',
              allowHtml: false,
              title: $translate.instant('modules.events.modal.shareDeclineTitle'),
              content: $translate.instant('modules.events.modal.shareDeclineMessage', { divisionShareName: divisionShare.Name }),
              primaryActionText: $translate.instant('generalTerms.decline'),
              secondaryActionText: $translate.instant('generalTerms.cancel'),
            });
          }
          return null;
        })
        .then(function () {
          return clientApi.custom('model/DivisionEvent', 'setDivisionShareState', {
            eventId: self.eventData.id,
            divisionId: divisionShare.id,
            isShared: action === 'ACCEPT',
          });
        })
        .then(function () {
          if (action === 'ACCEPT') {
            toastr.success(
              $translate.instant('modules.events.toastr.shareAcceptedMessage'),
              $translate.instant('modules.events.toastr.shareAcceptedTitle')
            );
            if (self.viewMode === 'view') {
              $state.reload();
            }
          } else {
            toastr.info(
              $translate.instant('modules.events.toastr.shareDeclinedMessage'),
              $translate.instant('modules.events.toastr.shareDeclinedTitle')
            );
          }
          $scope.$evalAsync(function () {
            divisionShare.IsShared = action === 'ACCEPT';
            delete divisionShare.state;
          });
        })
        .catch(function () {});
    };

    // event save
    self.getEventDataForSaving = function () {
      var eventData = _.cloneDeep(self.eventData);

      // get chosen ids from category
      ['categories'].forEach(function (evntProp) {
        eventData[evntProp] =
          eventData[evntProp] && eventData[evntProp].length
            ? eventData[evntProp]
                .map(function (propObj) {
                  return propObj && propObj.id;
                })
                .filter(function (p) {
                  return p;
                })
            : null;
      });

      eventData.divisionShare = eventData.divisionShare
        .map(function (division) {
          return {
            id: division.id,
            state: division.state,
          };
        })
        .filter(function (division) {
          return division.state;
        });

      eventData.attendance = eventData.attendance
        .filter(function (attendee) {
          return attendee.state;
        })
        .map(function (attendee) {
          return {
            memberId: attendee.id,
            divisionId: attendee.Division.id,
            acceptance: attendee.Acceptance,
            remark: attendee.Remark,
          };
        });

      // series event dates will be saved @ eventData.seriesDates
      // everything under series was previously used to generate those series dates, but
      // at this point its just network overhead for us
      delete eventData.series;

      // reconvert the timestamps to date objects to ensure timezone information is available
      eventData.seriesDates = eventData.seriesDates.map(function (seriesDate) {
        return moment(seriesDate);
      });

      if (eventData.isEventSeries && !eventData.EventSeriesId) {
        // is series meta event
        delete eventData.FlowState;
      }

      var materialData = _.omit(self.compatShift, 'id');

      return _.assign(eventData, materialData);
    };

    self.hasChanges = function (deduplicateSaving) {
      return JSON.stringify(deduplicateSaving || self.getEventDataForSaving()) !== self.initialEventData;
    };

    if (self.viewMode !== 'view') {
      stateChangePrompt.evaluate(function () {
        return !self.hasChanges();
      });
    }

    self.divisionShareChoices = [{ none: true }];
    self.divisionShare = [];
    self.divisionShareSearch = function (searchTerm) {
      if (!searchTerm) {
        self.divisionShareChoices = [{ none: true }];
        return null;
      }

      return clientApi
        .custom('model/Division', 'searchDivisions', {
          search: searchTerm,
          exclude: self.eventData.divisionShare
            .map(function (ds) {
              return ds.id;
            })
            .concat([self.division]),
        })
        .then(function (results) {
          if (results && results.length) {
            self.divisionShareChoices = results;
          } else {
            self.divisionShareChoices = [{ none: true, foundNone: true }];
          }
        });
    };

    // prevent choosing <none> option
    $scope.$watch(
      function () {
        return self.divisionShareTarget;
      },
      function () {
        if (self.divisionShareTarget && self.divisionShareTarget.none) {
          self.divisionShareTarget = null;
        }
      }
    );

    self.divisionShareAdd = function (division) {
      if (division) {
        division.state = 'ADDED';
        self.eventData.divisionShare.push(division);
        self.divisionShareTarget = null;
        if (self.managePermissionsIn(division.id)) {
          // user has manage permissions, we can assume that the share will be instantly accepted by backend event save without further user interactions
          division.IsShared = true;
        }
      }
    };

    self.divisionShareAddAllSubs = function () {
      var division = { id: self.division };
      self.addSubDivions(division);
    };

    self.addSubDivions = function (division) {
      var divisionList = self.Treedata.filter(function (div) {
        if (div.ParentDivisionId == division.id) {
          return div;
        }
      });

      divisionList.forEach(function (div) {
        if (!_.find(self.eventData.divisionShare, { id: parseInt(div.id) })) {
          self.divisionShareAdd(div);
          self.addSubDivions(div);
        }
      });
    };

    self.subDivCheck = function () {
      var divisionList = self.Treedata.filter(function (div) {
        if (div.ParentDivisionId == self.division) {
          return div;
        }
      });

      if (divisionList.length) {
        return true;
      }
      return false;
    };

    self.SubDivisionsExist = self.subDivCheck();

    self.removeDivisionShareTitle = function (division) {
      if (!division.state) {
        if (division.IsShared) {
          return $translate.instant('modules.events.event.shareDecline');
        }
        if (division.IsShared === null) {
          return $translate.instant('modules.events.event.inviteWithdraw');
        }
      }
      if (division.state === 'REMOVED') {
        return division.IsShared ? $translate.instant('modules.events.event.shareDontDecline') : $translate.instant('generalTerms.delete');
      }
      return $translate.instant('generalTerms.delete');
    };
    self.removeDivisionShare = function (division) {
      if (division) {
        if (division.state === 'ADDED') {
          // was just added and not reported to server yet, simply remove from list
          _.remove(self.eventData.divisionShare, { id: division.id });
          return;
        }
        if (division.state === 'REMOVED') {
          // accidental delete clicks can be reversed by clicking again
          delete division.state;
          return;
        }
        division.state = 'REMOVED';
      }
    };

    self.canHandleDivisionShare = function (division) {
      return !self.isArchived && !division.state && division.IsShared === null && ~self.managePermissionsList.indexOf(division.id);
    };

    self.categoryGroupFunc = function (cat) {
      return ((cat || {}).Division || {}).Name || $translate.instant('modules.events.event.organizationWide');
    };

    self.divisionShareGroupFunc = function (divShare) {
      if (divShare.none) {
        return '';
      }
      return (
        ((divShare || {}).ParentDivision || {}).Name ||
        $rootScope.ctx.organization.current.name + ' (' + $translate.instant('generalTerms.organization') + ')'
      );
    };

    self.selectedEventResponsible = null;
    $scope.$watch(
      function () {
        return self.eventData.eventResponsibles;
      },
      function () {
        self.eventResponsibleExclude = (self.eventData.eventResponsibles || [])
          .filter(function (eventResponsible) {
            return !eventResponsible.Exception;
          })
          .map(function (eventResponsible) {
            return eventResponsible.MemberId;
          });
      },
      true
    );

    self.addEventResponsible = function () {
      if (self.selectedEventResponsible) {
        self.selectedEventResponsible.MemberId = self.selectedEventResponsible.id;
        self.selectedEventResponsible.Member = _.pick(self.selectedEventResponsible, [
          'id',
          'FirstName',
          'LastName',
          'Title',
          'fullName',
          'initials',
        ]);
        self.selectedEventResponsible.Member.DivisionMembers = self.selectedEventResponsible.DivisionMembers;
        var availableEventResponsible = _.find(self.eventData.eventResponsibles, { MemberId: self.selectedEventResponsible.MemberId });
        if (!availableEventResponsible) {
          self.eventData.eventResponsibles.push(self.selectedEventResponsible);
        } else {
          availableEventResponsible.Exception = false;
        }
        self.selectedEventResponsible = null;
      }
    };
    self.removeEventResponsible = function (eventResponsible) {
      if (eventResponsible) {
        eventResponsible.Exception = true;
      }
    };

    self.eventResponsibleFilter = function (value) {
      return value && !value.Exception;
    };

    self.responsibleChoices = [{ none: true }];
    self.responsibleSearch = function (searchTerm) {
      if (!searchTerm) {
        self.responsibleChoices = [{ none: true }];
        return null;
      }

      var searchOpts = {
        divisionIds: _.compact(_.union(self.managePermissionsList, [self.hasItemPermissionForEventInDivision])),
        exclude: self.eventResponsibleExclude,
        eventId: self.eventData.id,
      };

      searchOpts.search = searchTerm;

      return clientApi.custom('model/EventMember', 'searchEventMembers', searchOpts).then(function (results) {
        if (results && results.length) {
          self.responsibleChoices = results;
        } else {
          self.responsibleChoices = [{ none: true, foundNone: true }];
        }
      });
    };

    // prevent choosing <none> option
    $scope.$watch(
      function () {
        return self.selectedEventResponsible;
      },
      function () {
        if (self.selectedEventResponsible && self.selectedEventResponsible.none) {
          self.selectedEventResponsible = null;
        }
      }
    );

    self.attendanceChoices = [{ none: true }];
    self.attendanceSearch = function (searchTerm, exactly, includeInactive) {
      if (!searchTerm && !exactly) {
        self.attendanceChoices = [{ none: true }];
        return null;
      }

      var searchOpts = {
        divisionIds: self.eventAssociatedDivisionIds,
        eventId: self.eventData.id,
      };

      if (searchTerm) {
        searchOpts.search = searchTerm;
      } else if (exactly) {
        searchOpts.exactly = exactly;
      }

      if (includeInactive) {
        searchOpts.includeInactive = true;
      }

      return clientApi.custom('model/EventMember', 'searchEventMembers', searchOpts).then(function (results) {
        self.memberUnderagedCalc(results);

        if (exactly) {
          return results;
        }

        if (results && results.length) {
          self.attendanceChoices = results;
        } else {
          self.attendanceChoices = [{ none: true, foundNone: true }];
        }
      });
    };

    self.genericEventMemberGroupFunc = function (evtMem) {
      if (evtMem.none) {
        return undefined;
      }
      if (!evtMem || !evtMem.DivisionMembers || evtMem.DivisionMembers.length !== 1 || !evtMem.DivisionMembers[0].Division) {
        return '- ' + $translate.instant('modules.events.event.severalDivisionAssignments') + ' -';
      }
      return evtMem.DivisionMembers[0].Division.Name;
    };

    // prevent choosing <none> option
    $scope.$watch(
      function () {
        return self.attendanceTarget;
      },
      function () {
        if (self.attendanceTarget && self.attendanceTarget.none) {
          self.attendanceTarget = null;
        }
      }
    );

    self.attendanceAdd = function (attendee, acceptance, freshAttendeeSource, immediate, includeInactive) {
      var preexistingAttendee = _.find(self.eventData.attendance, { id: (attendee || { id: $rootScope.ctx.currentUser.id }).id });
      var updateAttendee = preexistingAttendee || attendee;

      return Promise.resolve()
        .then(function () {
          if (!freshAttendeeSource || !attendee || !attendee.DivisionMembers) {
            return self
              .attendanceSearch(null, (attendee || { id: $rootScope.ctx.currentUser.id }).id, includeInactive)
              .then(function (results) {
                if (!results || results.length !== 1) {
                  toastr.error(
                    $translate.instant('modules.events.event.toastr.userdataUnknownMsg'),
                    $translate.instant('modules.events.event.toastr.userdataUnknownTitle')
                  );
                  throw new Error('Invalid member search.');
                }
                return results[0];
              });
          }
          return attendee;
        })
        .then(function (freshAttendee) {
          if (!updateAttendee) {
            updateAttendee = freshAttendee;
          }
          updateAttendee.DivisionMembers = freshAttendee.DivisionMembers;
        })
        .then(function () {
          if (updateAttendee.DivisionMembers.length > 1) {
            return eventUtil
              .chooseAttendanceDivisionModal(
                updateAttendee,
                updateAttendee.DivisionMembers.map(function (dm) {
                  return {
                    label: dm.Division.Name,
                    dm: dm,
                    defaultSelected: dm.DivisionId === (updateAttendee.Division || {}).id,
                  };
                }),
                'EVENT'
              )
              .then(function (choice) {
                return choice.dm;
              });
          }
          return updateAttendee.DivisionMembers[0];
        })
        .then(function (divisionMember) {
          return Promise.resolve()
            .then(function () {
              if (updateAttendee.Division && updateAttendee.Division.id && updateAttendee.Division.id !== divisionMember.DivisionId) {
                // user decided to change the division of an already reported attendee
                // warn user about possible impacts
                return eventUtil.attendanceDivisionChangeWarnModal(updateAttendee, divisionMember, 'EVENT');
              }
              return null;
            })
            .then(function () {
              return divisionMember;
            });
        })
        .then(function (divisionMember) {
          if (immediate) {
            return clientApi
              .custom('model/EventMember', 'updateOwnAttendance', {
                eventId: self.eventData.id,
                divisionId: divisionMember.DivisionId,
                acceptance: acceptance,
              })
              .then(function () {
                toastr.success(
                  $translate.instant('modules.events.event.toastr.partizipationRecordMsg'),
                  $translate.instant('modules.events.event.toastr.partizipationRecordTitle')
                );
              })
              .catch(function () {
                toastr.error(
                  $translate.instant('modules.events.event.toastr.partizipationRecordFailedMsg'),
                  $translate.instant('modules.events.event.toastr.partizipationRecordFailedTitle')
                );
              })
              .then(function () {
                return divisionMember;
              });
          }
          return divisionMember;
        })
        .then(function (divisionMember) {
          $scope.$evalAsync(function () {
            updateAttendee.Acceptance = acceptance;
            updateAttendee.Division = { id: divisionMember.DivisionId, Name: divisionMember.Division.Name };

            if (preexistingAttendee) {
              if (preexistingAttendee.state !== 'ADDED') {
                preexistingAttendee.state = 'UPDATED';
              }
            } else {
              updateAttendee.state = 'ADDED';
              self.eventData.attendance.push(updateAttendee);
            }

            self.attendanceTarget = null;
          });
        })
        .catch(function () {
          // hm k
        });
    };

    self.addRemark = function (attendee, canEditRemark) {
      var preexistingAttendee = _.find(self.eventData.attendance, { id: (attendee || { id: $rootScope.ctx.currentUser.id }).id });

      $uibModal
        .open({
          controller: 'AttendeeRemarkModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/events/event/modals/attendeeRemarkModal.html',
          size: 'md',
          resolve: {
            attendee: function () {
              return preexistingAttendee;
            },
            eventDetailCtrl: function () {
              return self;
            },
            canEditRemark: function () {
              return canEditRemark;
            },
            isShift: function () {
              return false;
            },
            serviceId: function () {
              return null;
            },
            userId: function () {
              return $rootScope.ctx.currentUser.id;
            },
          },
        })
        .result.then(function (result) {
          if (result) {
            var preexistingAttendee = _.find(self.eventData.attendance, { id: (attendee || { id: $rootScope.ctx.currentUser.id }).id });
            if (preexistingAttendee) {
              preexistingAttendee.Remark = result.remark;
            }
          }
        });
    };

    self.removeAttendance = function (attendee) {
      if (attendee) {
        var preexistingAttendee = _.find(self.eventData.attendance, { id: attendee.id });
        if (preexistingAttendee) {
          self.eventData.attendance.splice(self.eventData.attendance.indexOf(preexistingAttendee), 1);
        }
      }
    };

    self.currentAcceptance = function (attendee) {
      var result = {
        className: '',
        label: $translate.instant('modules.events.event.open'),
        division: '----',
      };
      var preexistingAttendee = _.find(self.eventData.attendance, { id: (attendee || { id: $rootScope.ctx.currentUser.id }).id });
      if (preexistingAttendee) {
        result = {
          className: preexistingAttendee.Acceptance ? 'label-success' : 'label-danger',
          label: preexistingAttendee.Acceptance
            ? $translate.instant('modules.events.event.partials.approved')
            : $translate.instant('modules.events.event.partials.canceled'),
          division: (preexistingAttendee.Division || {}).Name || '----',
        };
      }
      return result;
    };

    self.currentRemark = function () {
      var preexistingAttendee = _.find(self.eventData.attendance, { id: { id: $rootScope.ctx.currentUser.id }.id });
      if (preexistingAttendee) {
        return preexistingAttendee.Remark;
      }
    };

    self.canHandleAttendance = function (attendee) {
      if (
        self.isArchived ||
        !attendee ||
        !attendee.Division ||
        !attendee.Division.id ||
        (self.attendanceRemovalWarning || {})[attendee.id]
      ) {
        return false;
      }
      return ~_.compact(_.union(self.managePermissionsList, [self.hasItemPermissionForEventInDivision])).indexOf(attendee.Division.id);
    };

    self.attendeeTblFilter = function (attendee) {
      if (self.viewMode !== 'view' || self.canPartiallyEdit) {
        return true;
      }
      return attendee.id !== $rootScope.ctx.currentUser.id;
    };

    self.attendeeListExport = function () {
      if (!self.eventData.id || self.hasChanges()) {
        return eventUtil.saveBeforeProceedModal(
          $translate.instant('modules.events.event.modal.beforeParticipantListMsg'),
          $translate.instant('modules.events.event.modal.beforeTitle')
        );
      }
      clientApi.openTab('event/event-attendee-list', {
        eventId: self.eventData.id,
        divisionId: self.division,
      });
    };

    self.sendMessage = function (messageType) {
      if (!self.eventData.id || self.hasChanges()) {
        return eventUtil.saveBeforeProceedModal(
          $translate.instant('modules.events.event.modal.beforeMessageSendMsg'),
          $translate.instant('modules.events.event.modal.beforeTitle')
        );
      }
      return $uibModal.open({
        controller: 'sendAttendeeMessageCtrl as $msg',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/theme/components/eventModalShare/sendAttendeeMessage.html',
        size: 'md',
        resolve: {
          shifts: function () {
            return null;
          },
          attendeeInfos: function () {
            return clientApi.custom('model/Event', 'fetchAttendeeEMail', {
              eventId: self.eventData.id,
              messageType: messageType,
            });
          },
        },
      });
    };

    self.inviteAttendee = function () {
      if (!self.eventData.id || self.hasChanges()) {
        return eventUtil.saveBeforeProceedModal(
          $translate.instant('modules.events.event.modal.beforeInvitationSendMsg'),
          $translate.instant('modules.events.event.modal.beforeTitle')
        );
      }
      return $uibModal
        .open({
          controller: 'inviteAttendeeCtrl as $ia',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/eventModalShare/inviteAttendee.html',
          size: 'md',
          resolve: {
            entityId: function () {
              return self.eventData.id;
            },
            shifts: function () {
              return null;
            },
            divisionOptions: function () {
              return clientApi.custom('model/Division', 'fetchDivisionName', {
                divisionIds: _.compact(_.union(self.managePermissionsList, [self.hasItemPermissionForEventInDivision])),
              });
            },
            membersWithAttendeeStatus: function () {
              return _.uniq(
                (self.eventData.attendance || [])
                  .filter(function (attendee) {
                    return attendee.Acceptance;
                  })
                  .map(function (attendee) {
                    return attendee.id;
                  })
              );
            },
          },
        })
        .result.then(function (inviteOpts) {
          var options = inviteOpts.inviteList.length > 0
            ? {
              divisionId: [self.division],
              inviteList: inviteOpts.inviteList.map(function (member) {
                return member.MemberId;
              }),
              eventId: self.eventData.id,
            }
            : {
              divisionId: [self.division],
              inviteListDivisions: inviteOpts.divisionIds,
              eventId: self.eventData.id,
            };
          clientApi
            .custom('model/EventMember', 'inviteMember', options)
            .then(function (result) {
              if (result && result.sendCount) {
                var successStr = $translate.instant('modules.events.shiftTemplate.toastr.invitationsWereSentMsg', {
                  count: result.sendCount,
                });
                if (result.sendCount === 1) {
                  successStr = $translate.instant('modules.events.shiftTemplate.toastr.invitationWasSentMsg');
                }
                toastr.success(successStr, $translate.instant('modules.events.shiftTemplate.toastr.invitationSendTitle'));
              } else {
                toastr.warning(
                  $translate.instant('modules.events.shiftTemplate.toastr.invitationNotSendMsg'),
                  $translate.instant('modules.events.shiftTemplate.toastr.invitationNotSendTitle')
                );
              }
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.events.shiftTemplate.toastr.invitationSendFailedMsg'),
                $translate.instant('modules.events.shiftTemplate.toastr.invitationSendFailedTitle')
              );
            });
        })
        .catch(function (err) {
          console.error(err);
        });
    };

    $scope.$watch(
      function () {
        return self.flow.lastSavedStep !== self.flow.activeStep && self.flow.activeStep;
      },
      function () {
        self.calcCanTransferHelperHours();
      }
    );

    self.calcCanTransferHelperHours = function () {
      self.canTransferHelperHours =
        self.hasManageFromSourceDivOrItemPerm &&
        !self.eventData.HelperHoursTransferred &&
        !!(self.flow.steps[self.flow.activeStep].config || {}).canTransferHelperHours;
    };
    self.calcCanTransferHelperHours();

    self.helperHoursTransfer = function (assumeSaved, evtId) {
      if (!assumeSaved && (self.hasChanges() || !self.eventData.id)) {
        return eventUtil.saveBeforeProceedModal(
          $translate.instant('modules.events.event.modal.beforeHelperhoursTransferMsg'),
          $translate.instant('modules.events.event.modal.beforeTitle')
        );
      }
      var eventId = self.eventData.id || evtId;
      return $uibModal
        .open({
          controller: 'helperHoursTransferModalCtrl as self',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/theme/components/modals/helperHoursTransferModal/helperHoursTransferModal.html',
          size: 'lg',
          resolve: {
            dataSource: function () {
              return clientApi.custom('model/Event', 'fetchHelperHours', { eventId: eventId, divisionId: self.division });
            },
          },
        })
        .result.then(function (helperHours) {
          return clientApi.custom('model/Event', 'saveHelperHours', {
            eventId: eventId,
            divisionId: self.division,
            helperHours: helperHours,
          });
        })
        .then(function (helperHours) {
          toastr.success(
            $translate.instant('modules.events.event.toastr.transferedHelperhoursSuccessMsg'),
            $translate.instant('modules.events.event.toastr.transferedHelperhoursSuccessTitle')
          );
          if (!assumeSaved && self.eventData.id) {
            $state.reload();
          }

          if (self.wantsRecordAttendances) {
            return self.openRecordModal();
          }
          return helperHours;
        })
        .catch(function (e) {
          if (e) {
            toastr.error(
              $translate.instant('modules.events.event.toastr.transferedHelperhoursFailedMsg'),
              $translate.instant('modules.events.event.toastr.transferedHelperhoursFailedTitle')
            );
          }
          if (self.wantsRecordAttendances) {
            return self.openRecordModal();
          }
        });
    };

    $scope.$watch(
      function () {
        return (
          self.viewMode !== 'view' &&
          !self.eventData.attendance.length &&
          self.flow.activeStep !== self.flow.lastSavedStep &&
          !!(self.flow.steps[self.flow.activeStep].config || {}).accessibleByArchive
        );
      },
      function (newVal) {
        self.showArchiveWithoutAttendeesWarning = newVal;
      }
    );

    self.panelTagList = [];
    if (self.viewMode === 'view') {
      self.panelTagList.push({
        label: self.flow.activeStep
          ? $translate.instant('modules.events.flowbar.archived')
          : $translate.instant('modules.events.flowbar.active'),
        labelClass: self.flow.activeStep ? 'label-warning' : 'label-success',
        icon: '',
      });
    }
    self.expectsExpectedShortAmountCount = true;
    $scope.$watch(
      function () {
        return (
          self.eventMaterialReverseShare.bookingMaterialExpectedShortAmounts &&
          self.eventData.isSingleEvent &&
          Object.keys(self.eventMaterialReverseShare.bookingMaterialExpectedShortAmounts).length
        );
      },
      function (newVal, oldVal) {
        self.expectedShortAmountCount = newVal;
        if (newVal !== oldVal && oldVal !== undefined) {
          self.expectsExpectedShortAmountCount = false;
        }
      }
    );

    self.saveEvent = function (eventDataToSave) {
      var savedEvent;
      return clientApi
        .custom('model/Event', 'saveEvent', {
          eventData: eventDataToSave,
          divisionId: self.division,
          bookingMaterialExpectedShortAmounts: self.eventMaterialReverseShare.bookingMaterialExpectedShortAmounts,
        })
        .then(function (saveResult) {
          savedEvent = saveResult;
          if (self.eventData.id) {
            toastr.success(
              $translate.instant('modules.events.event.toastr.eventUpdatedMsg', { subject: self.eventData.Subject }),
              $translate.instant('modules.events.event.toastr.eventUpdatedTitle')
            );
          } else {
            toastr.success(
              $translate.instant('modules.events.event.toastr.eventCreatedMsg', { subject: self.eventData.Subject }),
              $translate.instant('modules.events.event.toastr.eventCreatedTitle')
            );
          }
          if (!savedEvent.helperHoursTransferred && self.canTransferHelperHours && self.wantsTransferHelperHours) {
            return self.helperHoursTransfer(true, savedEvent.id);
          }
          if (self.wantsRecordAttendances && !self.wantsTransferHelperHours) {
            return self.openRecordModal();
          }
        })
        .then(function () {
          if (self.refreshOnSave) {
            stateChangePrompt.disableEvaluation();
            if (!self.eventData.id) {
              $state.go('arno.events.eventDetail', { eventId: savedEvent.id });
              return;
            }
            $state.reload();
            return;
          }
          self.back(true);
        })
        .catch(function () {
          if (self.eventData.id) {
            toastr.error(
              $translate.instant('modules.events.event.toastr.updateFailedMsg', { subject: self.eventData.Subject }),
              $translate.instant('modules.events.event.toastr.updateFailedTitle')
            );
          } else {
            toastr.error(
              $translate.instant('modules.events.event.toastr.createFailedMsg', { subject: self.eventData.Subject }),
              $translate.instant('modules.events.event.toastr.createFailedTitle')
            );
          }
          self.eventSubmissionPending = false;
        });
    };

    self.submitEvent = function () {
      if (self.eventSubmissionPending) {
        return;
      }
      var eventDataToSave = self.getEventDataForSaving();
      if (!self.hasChanges(eventDataToSave)) {
        return toastr.info(
          $translate.instant('modules.events.event.toastr.notSavedMsg', { subject: self.eventData.Subject }),
          $translate.instant('modules.events.event.toastr.notSavedTitle')
        );
      }
      self.eventSubmissionPending = true;
      self.saveEvent(eventDataToSave);
    };

    self.deleteEvent = function ($event, eventId) {
      $event.stopPropagation();

      var eventTypeText = self.eventData.isEventSeries
        ? self.eventData.EventSeriesId
          ? $translate.instant('modules.events.event.TheEventOfSeries')
          : $translate.instant('modules.events.event.TheSeries')
        : $translate.instant('modules.events.event.TheEvent');
      var eventTypeTextTwo = self.eventData.isEventSeries
        ? self.eventData.EventSeriesId
          ? $translate.instant('modules.events.event.theEventOfSeries')
          : $translate.instant('modules.events.event.theSeries')
        : $translate.instant('modules.events.event.theEvent');

      var divisionSharedHint = '\n\n' + $translate.instant('modules.events.event.divisionSharedHintOfEvent');
      if (self.viewModeSeries === 'eventSeriesMeta') {
        divisionSharedHint = '\n\n' + $translate.instant('modules.events.event.divisionSharedHintOfSeries');
      }

      baModalService
        .messageModal({
          modalType: 'danger',
          allowHtml: false,
          title: $translate.instant('modules.events.event.modal.rlyDeleteTitle'),
          content: $translate.instant('modules.events.event.modal.rlyDeleteMsg', {
            subject: eventTypeTextTwo + (self.eventData.Subject ? ' "' + self.eventData.Subject + '"' : ''),
            hint: (self.eventData.divisionShare || []).length || self.viewModeSeries === 'eventSeriesMeta' ? divisionSharedHint : '',
          }),
          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel'),
        })
        .then(function () {
          return clientApi
            .custom('model/Event', 'deleteEvent', { eventId: eventId })
            .then(function () {
              toastr.success(
                $translate.instant('modules.events.event.toastr.deleteEventSuccessMsg', { eventTypeText: eventTypeText }),
                $translate.instant('modules.events.event.toastr.deleteEventSuccessTitle')
              );
              stateChangePrompt.disableEvaluation();
              $state.go('arno.events.overview');
            })
            .catch(function () {
              toastr.error(
                $translate.instant('modules.events.event.toastr.deleteEventFailedMsg', { eventTypeText: eventTypeText }),
                $translate.instant('modules.events.event.toastr.deleteEventFailedTitle')
              );
              stateChangePrompt.disableEvaluation();
              $state.reload();
            });
        })
        .catch(function () {});
    };

    self.canSaveEvent = (self.viewMode !== 'view' || self.canPartiallyEdit) && !self.isArchived;

    self.fileStorageEditPermissionCheck = function () {
      if ((self.flow.steps[self.flow.lastSavedStep].config || {}).freezeFileStorage) {
        return false;
      }
      return self.hasManageFromSourceDivOrItemPerm;
    };

    self.back = function (force) {
      if (force) {
        stateChangePrompt.disableEvaluation();
      }
      $state.go($rootScope.transitionHistoryFetchState(['arno.events.overview', 'arno.events.eventList'], 'arno.events.overview'));
    };

    self.initialEventData = JSON.stringify(self.getEventDataForSaving());
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.welcomepage', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.welcomepage', {
        url: '/welcomepage',
        templateUrl: 'app/pages/administration/welcomepage/welcomepage.tpl.html',
        title: 'navigation.administration.welcomepage',
        controller: 'ArnoWelcomePageEditCtrl as $ctrl',
        resolve: {
          welcomeTitleContent: function(ArnoDashAdminOrganizationConfigService) {
            return ArnoDashAdminOrganizationConfigService.getOrgConfigEntry('WELCOME-PAGE_INTRO-TITLE')
              .then(function(result) {
                if (result && result.length) {
                  return result[0].Content;
                }

                return result.Content;
              });
          },
          welcomeTextContent: function(ArnoDashAdminOrganizationConfigService) {
            return ArnoDashAdminOrganizationConfigService.getOrgConfigEntry('WELCOME-PAGE_INTRO-TEXT')
            .then(function(result) {
              if (result && result.length) {
                return result[0].Content;
              }

              return result.Content;
            });
          }
        },
        sidebarMeta: {
          order: 6
        },
        viewPermission: 'arno.administration.welcomepage.edit',
      });
  }

})();

(function () {
  'use strict';
  /* global marked*/

  angular.module('BlurAdmin.pages.administration.welcomepage')
    .controller('ArnoWelcomePageEditCtrl', ArnoWelcomePageEditCtrl);

  /** @ngInject */
  function ArnoWelcomePageEditCtrl(
    $scope, $q, $uibModal,
    toastr, stateChangePrompt, ArnoDashAdminOrganizationConfigService,
    welcomeTitleContent, welcomeTextContent, $translate
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.welcomeTitleContent = welcomeTitleContent;
    $ctrl.welcomeTextContent = welcomeTextContent;

    $ctrl.markdownEditorConfig = {
      autofocus: true,
      language: $translate.use(),
      fullscreen: {
        enable: false
      },
      iconlibrary: 'fa',
      addExtraButtons: true
    }

    // BOOTSTRAPPER
    /**
    * @name activate
    * @description Function for controller inits
    * @returns {Void} none
    * @memberOf ArnoWelcomePageEditCtrl#
    */
    function activate() {
      $ctrl.welcomeTitlePristine = $ctrl.welcomeTitleContent;
      $ctrl.welcomeTextPristine = $ctrl.welcomeTextContent;

      stateChangePrompt.evaluate(function () {
        return ($ctrl.welcomeTitleContent === $ctrl.welcomeTitlePristine && $ctrl.welcomeTextContent === $ctrl.welcomeTextPristine);
      });
    }

    // EVENT-HANDLERS
    $ctrl.showSyntax = function () {
      $uibModal.open({
        templateUrl: 'app/theme/templates/syntax.modal.tpl.html',
        size: 'lg',
        backdrop: true,
      });
    };

    $ctrl.showPreview = function (welcomeTitleContent, welcomeTextContent) {
      $uibModal.open({
        templateUrl: 'app/pages/administration/welcomepage/preview.modal.tpl.html',
        size: 'lg',
        backdrop: 'static',
        scope: angular.extend($scope.$new(), {
          welcomeTitleContentText: marked(welcomeTitleContent),
          welcomeTextContentText: marked(welcomeTextContent)
        }),
      });
    };

    $ctrl.save = function() {
      var promises = [
        ArnoDashAdminOrganizationConfigService.saveOrgConfigEntry('WELCOME-PAGE_INTRO-TITLE', undefined, $ctrl.welcomeTitleContent),
        ArnoDashAdminOrganizationConfigService.saveOrgConfigEntry('WELCOME-PAGE_INTRO-TEXT', undefined, $ctrl.welcomeTextContent),
      ];

      return Promise.all(promises)
        .then(function() {
          $ctrl.welcomeTitlePristine = $ctrl.welcomeTitleContent;
          $ctrl.welcomeTextPristine = $ctrl.welcomeTextContent;
          toastr.success(
            $translate.instant('modules.administration.adminWelcom.successToastText'),
            $translate.instant('modules.administration.adminWelcom.successToastTitle')
          );
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.adminWelcom.errorToastText'),
            $translate.instant('modules.administration.adminWelcom.errorToastTitle')
          );
        });
    }

    // VIEW-FUNCTIONS
    $ctrl.getMarkedPreview = function(markdownContent) {
      return marked(markdownContent);
    }

    // CONTROLLER-INIT
    $ctrl.$onInit = function() {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.terms', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.terms', {
        url: '/terms',
        templateUrl: 'app/pages/administration/terms/terms.html',
        title: 'navigation.administration.terms',
        controller: 'TermsEditCtrl as $ctrl',
        resolve: {
          terms: function (clientApi, toastr) {
            return clientApi
              .custom('model/Terms', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim laden der Nutzungsbedingungen', 'Laden der Nutzungsbedingungen gescheitert');
                throw err;
              });
          },
          privacyTerms: function (clientApi, toastr) {
            return clientApi
              .custom('model/PrivacyTerms', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim Laden der Datenschutzerklärung', 'Laden der Datenschutzerklärung gescheitert');
                throw err;
              });
          },
          exportPrivacyNote: function (clientApi, toastr) {
            return clientApi
              .custom('model/ExportPrivacyNote', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim Laden der Hinweise zur Datenspeicherung', 'Laden der Hinweise zur Datenspeicherung gescheitert');
                throw err;
              });
          },
          emergencyContactPrivacyTerms: function (clientApi, toastr) {
            return clientApi
              .custom('model/EmergencyContactPrivacyTerms', 'getLatest', {})
              .catch(function (err) {
                toastr.error('Fehler beim Laden der Datenschutzerklärung für Notallkontakte', 'Laden der Datenschutzerklärung für Notfallkontakte gescheitert');
                throw err;
              });
          }
        },
        sidebarMeta: {
          order: 3
        },
        viewPermission: 'arno.administration.terms.edit',
      });
  }

})();

(function () {
  'use strict';
  /* global marked*/

  angular.module('BlurAdmin.pages.administration.terms')
    .controller('TermsEditCtrl', TermsEditCtrl);

  /** @ngInject */
  function TermsEditCtrl(
    $scope, $q, $uibModal, toastr, clientApi, stateChangePrompt, terms, privacyTerms, exportPrivacyNote, organizationId, baModalService, emergencyContactPrivacyTerms, $translate
  ) {
    var $ctrl = this;

    // VARS
    $ctrl.markdownEditorConfig = {
      autofocus: true,
      language: $translate.use(),
      fullscreen: {
        enable: false
      },
      iconlibrary: 'fa',
      addExtraButtons: true,
      hiddenButtons: ['cmdImage', 'cmdCode', 'cmdQuote', 'cmdTable'],
    };

    $ctrl.privacyTerms = privacyTerms;

    $ctrl.terms = terms;

    $ctrl.exportPrivacyNote = exportPrivacyNote;

    $ctrl.organizationId = organizationId;

    $ctrl.EmergencyContactPrivacyTerms =  emergencyContactPrivacyTerms;

    if ($ctrl.terms) {
      $ctrl.termsContent = $ctrl.terms.TextContent;
      $ctrl.termsPristine = $ctrl.termsContent;
    }

    if ($ctrl.privacyTerms) {
      $ctrl.privacyTermsContent = $ctrl.privacyTerms.TextContent;
      $ctrl.privacyTermsPristine = $ctrl.privacyTermsContent;
    }

    if ($ctrl.exportPrivacyNote) {
      $ctrl.exportPrivacyNoteContent = $ctrl.exportPrivacyNote.TextContent;
      $ctrl.exportPrivacyNotePristine = $ctrl.exportPrivacyNoteContent;
    }

    if ($ctrl.EmergencyContactPrivacyTerms) {
      $ctrl.EmergencyContactPrivacyTermsContent = $ctrl.EmergencyContactPrivacyTerms.TextContent;
      $ctrl.EmergencyContactPrivacyTermsPristine = $ctrl.EmergencyContactPrivacyTermsContent;
    }


    // BOOTSTRAPPER
    /**
     * @name activate
     * @description Function for controller inits
     * @returns {Void} none
     * @memberOf ArnoWelcomePageEditCtrl#
     */
    function activate() {
      stateChangePrompt.evaluate(function () {
        return $ctrl.termsContent === $ctrl.termsPristine
          && $ctrl.privacyTermsContent === $ctrl.privacyTermsPristine
          && $ctrl.exportPrivacyNoteContent === $ctrl.exportPrivacyNotePristine
          && $ctrl.EmergencyContactPrivacyTermsContent === $ctrl.EmergencyContactPrivacyTermsPristine;
      });
    }

    // EVENT-HANDLERS-
    $ctrl.showPreview = function (content, title) {
      $uibModal.open({
        templateUrl: 'app/pages/administration/terms/preview.modal.html',
        size: 'lg',
        backdrop: 'static',
        scope: angular.extend($scope.$new(), {
          content: marked(content),
          previewTitle: title || ''
        })
      });
    };

    $ctrl.showSyntax = function () {
      $uibModal.open({
        templateUrl: 'app/theme/templates/syntax.modal.tpl.html',
        size: 'lg',
        backdrop: true,
      });
    };

    
    $ctrl.save = function (type) {
      var promise = $q.resolve();
      if ($ctrl.termsPristine !== $ctrl.termsContent && type === 'terms') {
        if ($ctrl.terms) {
          promise = $uibModal
            .open({ templateUrl: 'app/pages/administration/terms/updateTerms.modal.html' })
            .result
            .then(function () {
              return true;
            })
            .catch(function () {
              return false;
            }); // important!
        }
      }

      promise.then(function (notify) {
        $ctrl.notify = notify;
        if ($ctrl.termsContent === $ctrl.termsPristine || type !== 'terms') {
          return Promise.resolve(false);
        }
        return clientApi.post('terms/update', {
          content: $ctrl.termsContent,
          notify: notify,
          version: ($ctrl.terms && $ctrl.terms.Version) ? $ctrl.terms.Version : 1,
        });
      })
        .then(function (termsInstance) {
          if (termsInstance === false) {
            return;
          }
          $ctrl.termsPristine = $ctrl.termsContent;
          $ctrl.terms = { Version: termsInstance.Version };
          if (!$ctrl.terms && termsInstance.Action === 'create') {
            toastr.success(
              $translate.instant('modules.administration.adminTerms.termsCreateToastSucc1Text'),
              $translate.instant('modules.administration.adminTerms.termsCreateToastSucc1Title')
            );
          } else if ($ctrl.notify) {
            toastr.success(
              $translate.instant('modules.administration.adminTerms.termsEditToastSucc1Text'),
              $translate.instant('modules.administration.adminTerms.termsEditToastSucc1Title')
            );
          } else {
            toastr.success(
              $translate.instant('modules.administration.adminTerms.termsEditToastSucc2Text'),
              $translate.instant('modules.administration.adminTerms.termsEditToastSucc2Title')
            );
          }
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminTerms.termsToastErrText'),
            $translate.instant('modules.administration.adminTerms.termsToastErrTitle')
          );
        })
        .then(function () {
          if ($ctrl.privacyTermsContent === $ctrl.privacyTermsPristine || type !== 'privacyTerms') {
            return Promise.resolve(false);
          }
          return baModalService
            .messageModal({
              modalType: 'warning',
              allowHtml: false,

              title:  $translate.instant('modules.administration.adminTerms.termsModalTitle'),
              content:  $translate.instant('modules.administration.adminTerms.termsModalContent'),
              primaryActionText: $translate.instant('modules.administration.adminTerms.termsModalPrimary'),
              secondaryActionText:  $translate.instant('modules.administration.adminTerms.termsModalSecondary')
            })
            .then(function () {
              return true;
            })
            .catch(function () {
              return false;
            })
            .then(function (isNew) {
              return clientApi.custom('model/PrivacyTerms', 'updatePrivacyTerms', {
                privacyTermsContent: $ctrl.privacyTermsContent,
                isUpdate: !isNew
              });
            });
        })
        .then(function (privacyTermsInstance) {
          if (privacyTermsInstance === false) {
            return;
          }
          $ctrl.privacyTermsPristine = $ctrl.privacyTermsContent;
          toastr.success(
            $translate.instant('modules.administration.adminTerms.privacyNoteEditToastSuccText'),
            $translate.instant('modules.administration.adminTerms.privacyNoteEditToastSuccTitle')
          );
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminTerms.privacyNoteEditToastErrText'),
            $translate.instant('modules.administration.adminTerms.privacyNoteEditToastErrTitle')
          );
        })
        .then(function(){
          if ($ctrl.exportPrivacyNoteContent === $ctrl.exportPrivacyNotePristine || type !== 'privacyNote') {
            return Promise.resolve(false);
          }
          return clientApi.custom('model/ExportPrivacyNote', 'createOrUpdate', {
            noteContent: $ctrl.exportPrivacyNoteContent
          });
        })
        .then(function (exportPrivacyNote) {
          if (exportPrivacyNote === false) {
            return;
          }
          $ctrl.exportPrivacyNotePristine = $ctrl.exportPrivacyNoteContent;
          toastr.success(
            $translate.instant('modules.administration.adminTerms.exportNoteEditToastSuccText'),
            $translate.instant('modules.administration.adminTerms.exportNoteEditToastSuccTitle')
          );
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminTerms.exportNoteEditToastErrText'),
            $translate.instant('modules.administration.adminTerms.exportNoteEditToastErrTitle')
          );
        })
        .then(function () {
          if ($ctrl.EmergencyContactPrivacyTermsContent === $ctrl.EmergencyContactPrivacyTermsPristine || type !== 'EmergencyContactPrivacyTerms') {
            return Promise.resolve(false);
          }
          return clientApi.custom('model/EmergencyContactPrivacyTerms', 'updateEmergencyContactPrivacyTerms', {
            EmergencyContactPrivacyTermsContent: $ctrl.EmergencyContactPrivacyTermsContent,
            isUpdate: true
          });
        })
        .then(function (EmergencyContactPrivacyTermsInstance) {
          if (EmergencyContactPrivacyTermsInstance === false) {
            return;
          }
          $ctrl.EmergencyContactPrivacyTermsPristine = $ctrl.EmergencyContactPrivacyTermsContent;
          toastr.success(
            $translate.instant('modules.administration.adminTerms.emergencyNoteEditToastSuccText'),
            $translate.instant('modules.administration.adminTerms.emergencyNoteEditToastSuccTitle')
          );
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.adminTerms.emergencyNoteEditToastErrText'),
            $translate.instant('modules.administration.adminTerms.emergencyNoteEditToastErrTitle')
          );
        });
    };

    // VIEW-FUNCTIONS
    $ctrl.getMarkedPreview = function (markdownContent) {
      return marked(markdownContent);
    };

    // CONTROLLER-INIT
    $ctrl.$onInit = function () {
      activate();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.roles')
    .controller('RoleCtrl', RoleCtrl);

  /** @ngInject */
  function RoleCtrl($uibModal, commonUtils, toastr, clientApi, $state, permissions,
    permHierarchy, orgPermHierarchy, includedPermission, roles, organizationId, isOrg, $translate) {
    var self = this;

    self.permissions = permissions;
    self.permHierarchy = permHierarchy;
    self.orgPermHierarchy = orgPermHierarchy;
    self.roles = roles;

    self.isDivisional = ($state.current.name === 'arno.administration.roles.division');

    self.fetchTooltipCache = {};

    self.formattedRoles = (function mergeIncPerm() {
      if (includedPermission.length > 0 && self.roles.length > 0) {
        return _.chain(includedPermission)
          .groupBy('RoleId')
          .map(function (value, key) {
            return {
              RoleId: Number(key),
              Immutable: value[0].Immutable,
              RoleName: value[0].RoleName,
              Description: value[0].Description,
              PermissionId: _.map(value, function (o) {
                return o.PermissionId;
              }),
              PermissionName: _.map(value, function (o) {
                return o.PermissionName;
              }),
              Permissions: _.map(value, function (o) {
                return { id: o.PermissionId, name: o.PermissionName, description: (_.find(self.permissions, { id: o.PermissionId }) || {}).Description };
              }),
            }
          })
          .value()
          .filter(function (formattedRole) {
            return _.find(self.roles, { id: formattedRole.RoleId });
          })
      }
    })();

    self.fetchTooltip = function (role, item) {
      role.RoleId = role.RoleId; // set scope to all if no valid rol is given or new role is added
      self.fetchTooltipCache[role.RoleId] = self.fetchTooltipCache[role.RoleId] || {};

      if (self.fetchTooltipCache[role.RoleId][item.id] && self.fetchTooltipCache[role.RoleId][item.id].includedPermsContent) {
        return self.fetchTooltipCache[role.RoleId][item.id];
      }

      var includedIds = _.without(commonUtils.fetchIncludedPermissions(item.id, isOrg ? self.orgPermHierarchy : self.permHierarchy), item.id);
      var includedPerms = [];

      if (includedIds.length) {
        includedPerms = includedIds
          .map(function (includedId) {
            var foundPerm = _.find(self.permissions, { id: includedId });

            if (foundPerm) {
              return {
                Name: foundPerm.Name,
                Description: foundPerm.Description,
              }
            }

            return null;
          })
          .filter(function (included) {
            return !!included;
          });
      }
      includedPerms.sort();

      // if its not an aggreagted permission (which contains other permissions, then just show the popover with a description
      var permDescription = '';
      if (!includedPerms.length) {
        permDescription = (_.find(self.permissions, { id: item.id }) || {}).Description;
      }

      self.fetchTooltipCache[role.RoleId][item.id] = {
        isAggregated: includedPerms.length,
        aggregatedDescription: (_.find(self.permissions, { id: item.id }) || {}).Description || '',
        includedPermsContent: includedPerms.length === 0 ? { Description: permDescription } : includedPerms
      };

      return self.fetchTooltipCache[role.RoleId][item.id];
    };

    self.open = function (page, size, perm) {
      if (perm && perm.Immutable) {
        toastr.info(
          $translate.instant('modules.administration.roles.standardRolesCantBeChanged')
        );        
        return null;
      }
      return $uibModal.open({
        controller: 'RoleModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: page,
        size: size,
        resolve: {
          permissions: function () {
            return self.permissions;
          },
          permHierarchy: function () {
            if (self.isDivisional) {
              return self.permHierarchy;
            }
            return self.orgPermHierarchy
          },
          selectedPerm: function () {
            return perm;
          },
          roles: function () {
            return roles
          },
          includedPermissions: function () {
            return includedPermission;
          },
          formattedRoles: function () {
            return self.formattedRoles;
          },
          fetchTooltip: function () {
            return self.fetchTooltip;
          }
        }
      })
        .result
        .then(function (result) {
          if (self.isDivisional) {
            if (!result.deletedName && !result.id) {
              self
                .addDivisionRole(result.name, result.description, result.permissions)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast1Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast1Title')
                  );   
                })
                .catch(function () {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast2Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast2Text')
                  );   
                });
            } else if (!result.deletedName) {
              self
                .editDivisionRole(result.id, result.name, result.description, result.permissions)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast3Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast3Title')
                  );   
                })
                .catch(function () {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast4Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast4Title')
                  );   
                });
            } else {
              self
                .deleteDivisionRole(result.id)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast5Text', { name: result.deletedName }),
                    $translate.instant('modules.administration.roles.toast5Title')
                  );   
                })
                .catch(function () {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast6Text', { name: result.deletedName }),
                    $translate.instant('modules.administration.roles.toast6Title')
                  );   
                });
            }
          } else {
            if (!result.deletedName && !result.id) {
              self
                .addOrganizationRole(result.name, result.description, result.permissions)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast1Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast1Title')
                  );   
                })
                .catch(function () {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast2Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast2Title')
                  );   
                });
            } else if (!result.deletedName) {
              self
                .editOrganizationRole(result.id, result.name, result.description, result.permissions)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast3Text', { name: result.name }),
                    $translate.instant('modules.administration.roles.toast3Title')
                  );   
                })
                .catch(function (error) {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast10Text', { name: result.name, error: error }),
                    $translate.instant('modules.administration.roles.toast10Title')
                  );   
                });
            } else {
              self
                .deleteOrganizationRole(result.id)
                .then(function () {
                  toastr.success(
                    $translate.instant('modules.administration.roles.toast5Text', { name: result.deletedName }),
                    $translate.instant('modules.administration.roles.toast5Title')
                  );   
                })
                .catch(function () {
                  toastr.error(
                    $translate.instant('modules.administration.roles.toast12Text', { name: result.deletedName }),
                    $translate.instant('modules.administration.roles.toast12Title')
                  );   
                });
            }
          }
        })
    };

    self.addDivisionRole = function (name, desc, permIds) {
      return clientApi
        .custom('model/DivisionRole', 'createDivisionRole', {
          name: name,
          desc: desc
        })
        .then(function (result) {
          return clientApi.custom('model/DivisionRole', 'setDivisionPermissions', { id: result.id, includedIds: permIds });
        })
        .then(function () {
          return $state.reload();
        });
    };

    self.addOrganizationRole = function (name, desc, permIds) {
      return clientApi
        .custom('model/OrganizationRole', 'createOrganizationRole', {
          name: name,
          desc: desc,
        })
        .then(function (result) {
          return clientApi.custom('model/OrganizationRole', 'setOrganizationPermissions', {
            id: result.id,
            includedIds: permIds,
          });
        })
        .then(function () {
          return $state.reload();
        });
    };

    self.editDivisionRole = function (id, name, desc, permIds) {
      return clientApi
        .custom('model/DivisionRole', 'updateDivisionRole', {
          id: id,
          cName: name,
          description: desc
        })
        .then(function () {
          return clientApi.custom('model/DivisionRole', 'setDivisionPermissions', {
            id: id,
            includedIds: permIds,
          });
        })
        .then(function () {
          return $state.reload();
        });
    };

    self.editOrganizationRole = function (id, name, desc, permIds) {
      return clientApi
        .custom('model/OrganizationRole', 'updateOrganizationRole', {
          content: {
            id: id,
            Name: name,
            Description: desc
          },
        })
        .then(function () {
          return clientApi.custom('model/OrganizationRole', 'setOrganizationPermissions', {
            id: id,
            includedIds: permIds,
          });
        })
        .then(function () {
          return $state.reload();
        });
    };

    self.deleteDivisionRole = function (id) {
      return clientApi
        .custom('model/DivisionRole', 'deleteDivisionRole', { roleId: id })
        .then(function () {
          return $state.reload();
        });
    };

    self.deleteOrganizationRole = function (id) {
      return clientApi
        .custom('model/OrganizationRole', 'deleteOrganizationRole', { roleId: id })
        .then(function () {
          return $state.reload();
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.statistics')
    .controller('StatisticCtrl', StatisticCtrl);

  function StatisticCtrl(
    $uibModal, commonUtils, toastr, clientApi, $state,
    ArnoDashAdminStatisticsService, ArnoDashAdminStatisticsGroupsService,
    statisticHierarchy, statistics, organizationId, $timeout, usingMembers,
    selectedCtx, permitted, $rootScope, permissions
  ) {

    var self = this;

    self.selectedCtx = selectedCtx;

    self.statistics = statistics;
    self.permitted = permitted;
    self.statisticHierarchy = statisticHierarchy;
    self.organizationId = organizationId;

    if (usingMembers) {
      self.statisticResponsiblePersons = getStatisticsResponsiblePersons(statistics);
    }

    self.editingItem = null;

    self.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    };

    self.openEditResponsiblePersons = function (item) {
      $uibModal.open({
        controller: 'StatisticsEditResponsiblePersonsModalCtrl as $ctrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/statistics/editResponsiblePersonsModal/editResponsiblePersonsModal.html',
        size: 'md',
        resolve: {
          item: function () {
            self.editingItem = JSON.parse(JSON.stringify(item));
            return self.editingItem;
          }
        }
      })
        .result
        .then(function (editedItem) {
          var usingMemberChanges = findChanges(
            item.UsingMember.map(function (member) {
              return member.id;
            }),
            editedItem.UsingMember.map(function (member) {
              return member.id;
            }));

          return clientApi.custom('model/Statistic', 'updateChanges', {
            usingMemberChanges: usingMemberChanges,
            divisionId: selectedCtx,
            statisticId: item.Statistic.id,
            itemPermissionInternalName: item.Statistic.ItemPermissionInternalName,
          })
            .then(function () {
              toastr.success('Der Statistikverantwortliche wurde erfolgreich geändert.', 'Änderung erfolgreich');

              $state.reload();
            })
            .catch(function () {
              toastr.error('Der Statistikverantwortliche konnte nicht geändert werden.', 'Änderung fehlgeschlagen');
            });
        });
    };

    function findChanges(array1, array2) {
      return { added: _.differenceWith(array2, array1), removed: _.differenceWith(array1, array2) };
    }

    self.openStatistic = function (page, statisticGroup, statistic, size, modalTitle) {
      $uibModal.open({
        controller: 'StatisticModalCtrl as $modalCtrl',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/statistics/statisticModal/' + page + '.html',
        size: size,
        resolve: {
          statisticGroup: function () {
            return statisticGroup;
          },
          title: function () {
            return statistic ? statistic.Title : null;
          },
          description: function () {
            return statistic ? statistic.Description : null;
          },
          statistics: function () {
            return statistics;
          },
          modalTitle: function () {
            return modalTitle;
          },
          statistic: function () {
            return statistic;
          },
          statisticHierarchy: function () {
            return statisticHierarchy;
          },
        }
      })
        .result.then(function (result) {
          if (statistic != undefined) {
            statistic.Title = result.Title;
            statistic.Description = result.Description;
            statistic.ItemPermissionInternalName = result.ItemPermissionInternalName;
            statistic.StatisticGroupId = result.StatisticGroupId;

            self.updateStatistic(statistic, organizationId);
            toastr.success('Die Statistik wurde erfolgreich geändert.', 'Änderung erfolgreich');
          } else {
            self.addToStatistic(result.Title, result.Description, result.ItemPermissionInternalName, organizationId, result.StatisticGroupId);
            toastr.success('Die Statistik wurde erfolgreich hinzugefügt.', 'Anlegen erfolgreich');
          }

          $state.reload();
        });
    }
    self.addToStatistic = function (title, description, itemPermissionInternalName, orgId, statisticGroupId) {
      clientApi.custom('model/Statistic', 'createStatistic', {
        statisticData: {
          Title: title,
          Description: description,
          ItemPermissionInternalName: itemPermissionInternalName,
          StatisticGroupId: statisticGroupId
        },
      });
    };
    self.updateStatistic = function (statistic) {
      $timeout(function () {
        clientApi.custom('model/Statistic', 'updateOneStatistic', {
          statisticId: statistic.id,
          statisticData: {
            Title: statistic.Title,
            ItemPermissionInternalName: statistic.ItemPermissionInternalName, // TODO: dont allow update of this link
            Description: statistic.Description,
            StatisticGroupId: statistic.StatisticGroupId // TODO: dont allow re-assign to another group
          },
        });
      });
    };

    // VIEW-FUNCTIONS
    self.onChangeStatisticGroupAssignment = function (statistic) {
      $timeout(function () {
        statistic.viewChangingSelectedGroup = true;

        ArnoDashAdminStatisticsService.changeGroup(statistic, statistic.viewSelectedGroup.id)
          .then(function () {
            toastr.success(
              'Die Statistik wurde der Gruppe "' + statistic.viewSelectedGroup.Name + '" erfolgreich hinzugefügt.',
              'Gruppe zuweisen erfolgreich'
            );

            $state.reload();
          })
          .catch(function () {
            toastr.error(
              'Die Statistik konnte nicht der Gruppe "' + statistic.viewSelectedGroup.Name + '" zugewiesen werden. Probiere es später bitte noch einmal',
              'Gruppe zuweisen gescheitert'
            );
          })
          .finally(function () {
            // unblock select-field for the affected statistic
            statistic.viewChangingSelectedGroup = false;
          });
      });
    }

    // HELPERS
    function getStatisticsResponsiblePersons(statistics) {
      return statistics.map(function (statistic) {
        var statisticData = {
          Statistic: {
            id: statistic.id,
            Title: statistic.Title,
            ItemPermissionInternalName: statistic.ItemPermissionInternalName,
            Description: statistic.description,
          },
          UsingMember: [],
          StatisticGroupId: statistic.StatisticGroupId,
        };

        usingMembers.forEach(function (memberData) {
          // find the right members for a given statistics
          if (memberData && memberData.Statistics.indexOf(statistic.id) !== -1
              && memberData.itemPermissionInternalName === statistic.ItemPermissionInternalName
          ) {
            if ((selectedCtx && memberData.Division && memberData.Division.id && Number(selectedCtx) == memberData.Division.id)
                || selectedCtx === 'rootOrg' || (memberData.Division && !memberData.Division.id)
            ) {
              statisticData.UsingMember.push(memberData.Member);
            }
          }
        });

        return statisticData;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.language')
    .controller('LanguageAdminCtrl', LanguageAdminCtrl)
    .filter('languageCustomFilter',
      function($filter, $translate) {
        return function(input, predicate) {
          if (Object.keys(predicate).indexOf('flatKey') === -1) {
            return $filter('filter')(input, predicate, false);
          }
          var safePredicate = JSON.parse(JSON.stringify(predicate));
          delete safePredicate.flatKey;
          return $filter('filter')(input.filter(function(row) {
            return formatPath(row.flatKey, $translate).toLowerCase().indexOf(predicate.flatKey.toLowerCase()) > -1;
          }), safePredicate, false)
        };
      }
    );

  function formatPath(pathKey, t) {
    var parts = pathKey.split('.');
    parts.pop();
    var incrPath = '';
    return parts.map(function(p, i) {
      if (i === 0) {
        return t.instant('self.' + p) || p;
      } else {
        if (!incrPath) {
          incrPath = 'navigation.' + p;
        } else {
          incrPath += '.' + p;
        }
        var translatedIncrPath = t.instant(incrPath);
        return (!translatedIncrPath || translatedIncrPath === incrPath) ? p : translatedIncrPath;
      }
    }).join(' > ');
  }

  function LanguageAdminCtrl($rootScope, $translate, $uibModal, toastr, commonUtils, dictionary, clientApi) {
    var self = this;
    self.forms = {};

    self.setPageSize = function (num) {
      self.itemsPerPage = commonUtils.getPageSize('lang_admin_page_size', num);
    }
    self.setPageSize();

    var isObject = function(obj) {
      return obj === Object(obj) && !Array.isArray(obj);
    }

    var flattenDictionary = function(dict, flatDict, lastLevelKey, innerDict) {
      if (!flatDict) {
        flatDict = {};
      }
      var levelKeys = Object.keys(innerDict || dict);
      levelKeys.forEach(function(key) {
        var compoundKey;
        if (lastLevelKey) {
          compoundKey = lastLevelKey + '.' + key;
        }
        var val = _.get(dict, compoundKey || key);
        if (val && !isObject(val)) {
          flatDict[(compoundKey || key)] = val;
        } else if (val) {
          flattenDictionary(dict, flatDict, compoundKey || key, val);
        }
      })
      return flatDict;
    }
    var fd = flattenDictionary(dictionary);
    var arrayDict = [];
    // convert to collection because smart table hates ng-repeat over objects with pagination enabled
    Object.keys(fd).forEach(function(key) {
      if (!key.startsWith('self.')) {
        arrayDict.push({
          flatKey: key,
          value: fd[key],
        })
      }
    })
    self.flattenedDict = arrayDict;
    
    self.formatPath = function(pathKey) {
      return formatPath(pathKey, $translate);
    }

    self.edit = function(key) {
      var tObj;
      var old;
      var currentLang = $rootScope.ctx.currentUser.prefLanguage || 'de';
      $uibModal
        .open({
          controller: 'editTranslationCtrl as $modalCtrl',
          animation: true,
          backdrop: 'static',
          templateUrl: 'app/pages/administration/language/modals/editTranslationModal.html',
          size: 'md',
          resolve: {
            translations: function() {
              return clientApi.emit('i18n/getTranslation', { key: key })
                .catch(function() {
                  return {};
                })
            }
          }
        })
        .result
        .then(function(res) {
          tObj = res.ret;
          old = res.old;
          if (res) {
            return clientApi.custom('model/Translations', 'upsertChanges', {
              key: key,
              translationObj: tObj,
            })
          }
        })
        .then(function() {
          toastr.success(
            $translate.instant('modules.administration.language.editToastrSuccess'),
            $translate.instant('modules.administration.language.editToastrSuccessTitle')
          )
          var flatDictObj = _.find(arrayDict, function(o) {
            return o.flatKey === key;
          })
          flatDictObj.value = tObj[currentLang] || old.original[currentLang];
          $translate.refresh();
        })
        .catch(function(e) {
          if (e !== 'USER_DISMISS') {
            toastr.error(
              $translate.instant('modules.administration.language.editToastrFail'),
              $translate.instant('modules.administration.language.editToastrFailTitle')
            )
          }
        })
    }
  }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.divisions')
    .controller('AdminDivisionCtrl', AdminDivisionCtrl);

  /** @ngInject */
  function AdminDivisionCtrl(
    $scope, $uibModal,
    ArnoDashBusinessPartnersService, organizationId, divisions, divisionData,
    commonUtils, toastr, clientApi, $state, stateChangePrompt, $timeout, $rootScope, permissions,
    ArnoDashAdminDivisionsService, accountingAreas, CAT_MEMBER_COUNTRY_IDS, isPermittedForTreeView, isPermittedForBaseData,
    divisionBaseData, baseDataCtx, validationUtils, $translate, invoiceExportSettings, invoiceExportRecipients
  ) {
    var self = this;

    if (divisionData && divisionData.nodeResults && Object.keys(divisionData).length < 2) {
      divisionData = divisionData.nodeResults;
    }

    self.accountingAreas = accountingAreas.map(function (it) {
      it.group = '(' + it.AccountingAreaNumber + ') ' + it.AccountingAreaName;

      return it;
    });
    self.accountingArea = undefined;
    self.isPermittedForTreeView = isPermittedForTreeView;
    self.isPermittedForBaseData = isPermittedForBaseData;
    self.isPermittedForTreeMove = permissions.isPermittedInOrg('arno.administration.divisions.manage', [$rootScope.ctx.organization.current.id]);
    self.isPermittedForFinanceExport = permissions.isPermittedInOrg('arno.administration.divisions.manage', [$rootScope.ctx.organization.current.id]) &&
      permissions.isPermittedInOrg('arno.administration.finances.quotationsAndInvoices.manage', [$rootScope.ctx.organization.current.id]);
    self.selectedDivision = {};
    self.organizationId = organizationId;
    self.divisions = divisions;
    self.constraint = {};
    self.showInactive = false;
    self.invoiceExportSettings = invoiceExportSettings;
    self.invoiceExportAllowed = (self.invoiceExportSettings || {}).InvoiceExportEnabled;
    self.divisionTreeData = divisionData.angularTreeData ? divisionData.angularTreeData : divisionData;
    var sortDivisionTree = function (tree) {
      var sortedTree = _.orderBy(tree, ['text'], ['asc']);
      sortedTree.forEach(function (child) {
        if (child.children && child.children.length) {
          child.children = sortDivisionTree(child.children);
        }
      });
      return sortedTree;
    };
    self.divisionTreeData = sortDivisionTree(self.divisionTreeData);
    self.originalNodeData = _.cloneDeep(divisionData.nodeResults);
    var recursiveAdminDataSearch = function (children) {
      children.forEach(function (child) {
        if (child.admins && child.admins.length) {
          var found = _.find(self.originalNodeData, { id: child.id });
          if (found) {
            found.admins = _.cloneDeep(child.admins);
          }
        }
        if (child.children && child.children.length) {
          recursiveAdminDataSearch(child.children);
        }
      });
    };
    if (self.divisionTreeData && self.divisionTreeData.length && self.divisionTreeData[0].children && self.divisionTreeData[0].children.length) {
      recursiveAdminDataSearch(self.divisionTreeData[0].children);
    }
    self.dnd = false;
    self.treeviewCollapsed = false;
    self.changedNodes = [];

    var lastDragAttempt = {};
    self.treeOptions = {
      beforeDrag: function (sourceNodeScope) {
        var found = -1;
        if (lastDragAttempt.id) {
          found = _.findIndex(sourceNodeScope.$modelValue.children, function (srcNode) {
            return lastDragAttempt.id === srcNode.id;
          });
        }
        if (sourceNodeScope.$modelValue.id !== 'rootOrg' && sourceNodeScope.$modelValue.active && !~found) {
          return true;
        }
        if (sourceNodeScope.$modelValue.id !== 'rootOrg') {
          lastDragAttempt = sourceNodeScope.$modelValue;
        }
        return false;
      },
      accept: function (sourceNodeScope, destNodesScope) {
        if (
          destNodesScope.$modelValue[0]
          && destNodesScope.$modelValue[0].id === self.divisionTreeData[0].id
          || !destNodesScope.$nodeScope.$modelValue.active
        ) {
          return false;
        }
        return true;
      },
      dropped: function (event) {
        if (event.dest.nodesScope && event.dest.nodesScope.$parent) {
          event.source.nodeScope.$modelValue.parent = event.dest.nodesScope.$parent.$modelValue.id;
        }
      },
    };

    self.search = '';

    // for arno-dash-admin-divisions-supervisors-list
    self.adminsListConfig = {
      roleName: $translate.instant('modules.administration.divisions.divAdmin'),
      scopeOfMembers: 'admins',
      controlPermission: 'arno.administration.divisions.administrators.manage',

      positionMembersActionsbar: 'bottom',
      showBottomActionsbar: false,

      btnCopyToSubDivsLabel: $translate.instant('modules.administration.divisions.copyAdmins'),
      btnChooseMemberLabel: $translate.instant('modules.administration.divisions.selectAdmin'),
      emptyListLabel: $translate.instant('modules.administration.divisions.noAdminAssigned'),
    };

    var newId = 1;

    self.changes = {
      admins: {
        changed: false,
        saveError: false,
        potentialChanges: false,
      },
      divisions: {
        title: false,
        tree: false,
      },
    };


    self.getInvoiceExportRecipient = function (divId) {
      return clientApi
        .custom('model/Division', 'getInvoiceExportRecipient', {
          divisionId: divId,
        })
        .then(function (res) {
          if (res) {
            return res.InvoiceExportRecipientEMail;
          }
          return '';
        });
    };
    self.getInvoiceExportSettings = function (divId) {
      return clientApi
        .custom('model/Organization', 'getInvoiceExportSettings', {
          divisionId: divId,
        });
    };

    // self.changedTitle = false;
    // self.changedDivision = false;

    self.treeviewCollapsed = !!commonUtils.preference.bool.get('divisionAdminTreeViewOpened', self.treeviewCollapsed);

    self.divisionConfig = {
      core: {
        multiple: false,
        check_callback: true,
        themes: {
          responsive: false
        }
      },
      types: {
        default: {
          icon: 'ion-ios-people-outline'
        }
      },
      plugins: ['types', 'sort'],
      version: 1
    };

    self.addNewNode = function () {
      var selectedDiv;
      if (!self.selectedDivision || (typeof self.selectedDivision === 'object' && !Object.keys(self.selectedDivision).length)) {
        // No node selected, just set it to root as parent node
        selectedDiv = self.divisionTreeData[0];
      } else {
        selectedDiv = self.selectedDivision;
      }
      if (!selectedDiv.children) {
        selectedDiv.children = [];
      }
      var newNodeId = 'n-' + (newId);
      selectedDiv.children.push({
        id: newNodeId,
        parent: selectedDiv.id,
        text: $translate.instant('modules.administration.divisions.newDiv'),
        active: true,
        children: [],
        icon: 'fa fa-sitemap',
        admins: [],
        newNode: true,
      });
      newId++;
      self.selectNode(selectedDiv.children[selectedDiv.children.length - 1]);
    };

    self.save = function () {
      var promises = [
        self.saveAdmins(),
      ];

      Promise.all(promises)
        .then(function () {
          var prom;

          if (self.adminSaveError) {
            toastr.error(
              $translate.instant('modules.administration.divisions.saveAdminErrToastText'),
              $translate.instant('modules.administration.divisions.saveAdminErrToastTitle')
            );
          }
          if ((!self.changedNodes || !self.changedNodes.length)
            && !self.changes.admins.changed
          ) {
            return toastr.info(
              $translate.instant('modules.administration.divisions.divNotSavedToastText'),
              $translate.instant('modules.administration.divisions.divNotSavedToastTitle')
            );
          }
          if (self.isPermittedInCurrentOrg('arno.administration.divisions.manage')) {
            prom = clientApi.emit('division/updateBulk', {
              divisions: _.map(self.changedNodes, function (node) {
                return {
                  Name: node.text,
                  ParentDivisionId: node.parent === 'rootOrg' ? null : node.parent,
                  id: node.id,
                };
              }),
            });
          } else {
            prom = Promise.resolve();
          }

          prom
            .then(function () {
              if ((self.changes.admins.changed && !self.changes.admins.saveError)) {
                toastr.success(
                  $translate.instant('modules.administration.divisions.saveAdminSuccToastText'),
                  $translate.instant('modules.administration.divisions.saveAdminSuccToastTitle')
                );
              } else {
                toastr.success(
                  $translate.instant('modules.administration.divisions.divTreeSavedToastText'),
                  $translate.instant('modules.administration.divisions.divTreeSavedToastTitle')
                );
              }
              $state.reload();
            })
            .catch(function (e) {
              console.log(e);
              toastr.error(
                $translate.instant('modules.administration.divisions.divTreeErrToastText'),
                $translate.instant('modules.administration.divisions.divTreeErrToastTitle')
              );
            });
        });
    };

    /* eslint no-extra-boolean-cast:0 */
    self.saveAdmins = function () {
      if (self.isPermittedInCurrentOrg('arno.administration.divisions.administrators.manage')) {
        var adminRoleId;
        var roleName = 'Gliederungsadministrator';

        return clientApi.custom('model/DivisionRole', 'findDivisionRoles', {
          name: roleName,
        })
          .then(function (result) {
            if (result.length && result[0].Name === roleName) {
              adminRoleId = result[0].id;
            } else {
              throw 'no administrator role found!';
            }
            var adminChanges = { deleted: [], created: [] };
            self.changedNodes.forEach(function (division) {
              // Administrator
              division.admins.forEach(function (admin) {
                if (admin.delete) {
                  self.changes.admins.changed = true;
                  adminChanges.deleted.push({
                    roleId: adminRoleId,
                    memId: admin.MemberId,
                    divId: division.id,
                  });
                }

                if (admin && !admin.delete && admin.isNewRolemember) {
                  self.changes.admins.changed = true;

                  adminChanges.created.push({
                    roleId: adminRoleId,
                    memId: admin.id || admin.MemberId || null,
                    divId: division.id,
                  });
                }
              });
            });

            return clientApi.custom('model/DivisionRoleMember', 'changeDivisionRoleMembers', adminChanges);
          })
          .catch(function () {
            self.changes.admins.saveError = true;
          });
      } else {
        return Promise.resolve();
      }
    };

    self.deleteAdmin = function (index) {
      var admin = self.selectedDivision.admins[index];
      if (admin.isNewRolemember) {
        self.selectedDivision.admins.splice(index, 1);
      } else {
        admin.delete = true;
      }
      self.changes.admins.potentialChanges = true;
    };

    self.divisionData = divisionData;

    self.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    };

    self.enableDnDIfAllowed = function () {
      if (self.isPermittedInCurrentOrg('arno.administration.divisions.manage')) {
        //self.divisionConfig.plugins.push('dnd');
        self.dnd = true;
      }
    };

    self.enableDnDIfAllowed();

    self.pushToSubdivisions = function (role, selectedDivision) {
      ArnoDashAdminDivisionsService.pushToSubdivisions(role, selectedDivision, self.divisionTree, self.divisionData)
        .then(function () {
          self.changes[role].potentialChanges = true;

          // NOTE: maybe show a toastr, however the toastr could be missleading, because the changes haven't been saved yet
          // they are saved if the user clicks on the "save" button from the division-management-panel
        })
        .catch(function (error) {
          if (error.errorKey === 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERR_NO_ROLES') {
            toastr.error(
              $translate.instant('modules.administration.divisions.subDivPushErr1ToastText'),
              $translate.instant('modules.administration.divisions.subDivPushErr1ToastTitle')
            );
          } else {
            toastr.error(
              $translate.instant('modules.administration.divisions.subDivPushErr2ToastText'),
              $translate.instant('modules.administration.divisions.subDivPushErr2ToastTitle')
            );
          }
        });
    };

    self.checkTitle = function (value) {
      if (value === '' || value === undefined) {
        self.emptyError = true;
      } else {
        self.emptyError = false;
      }
    };

    self.deactivate = function () {
      $uibModal
        .open({
          controller: 'deactivationModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/divisions/deactivationModal/deactivationModal.html',
          size: 'md',
          resolve: {
            division: self.selectedDivision,
            deactivation: true,
            constraint: self.constraint,
          }
        })
        .result
        .then(function () {
          return clientApi
            .custom('model/Division', 'deactivateDivision', {
              divId: self.selectedDivision.id,
              recursive: self.constraint.isParent,
            });
        })
        .then(function () {
          $state.reload();
        })
        .catch(function (err) {
          if (err) {
            toastr.error(
              $translate.instant('modules.administration.divisions.deactivateDivErrToastText'),
              $translate.instant('modules.administration.divisions.deactivateDivErrToastTitle')
            );
          }
        });
    };

    self.activate = function () {
      return clientApi
        .custom('model/Division', 'activateDivision', {
          divId: self.selectedDivision.id,
          recursive: true,
        })
        .then(function () {
          $state.reload();
        })
        .catch(function (err) {
          if (err) {
            toastr.error(
              $translate.instant('modules.administration.divisions.activateDivErrToastText'),
              $translate.instant('modules.administration.divisions.activateDivErrToastTitle')
            );
          }
        });
    };

    self.delete = function () {
      if (self.selectedDivision.newNode) {
        var index = _.findIndex(self.changedNodes, function (node) {
          return node.id === self.selectedDivision.id;
        });
        self.changedNodes.splice(index, 1);
        commonUtils.recurseTree(self.divisionTreeData, function (node, index, containerArray) {
          if (node.id === self.selectedDivision.id) {
            containerArray.splice(index, 1);
          }
        });
        self.selectedDivision = {};
      } else {
        $uibModal
          .open({
            controller: 'deactivationModalCtrl as $modalCtrl',
            animation: true,
            templateUrl: 'app/pages/administration/divisions/deactivationModal/deactivationModal.html',
            size: 'md',
            resolve: {
              division: self.selectedDivision,
              deactivation: false,
              constraint: self.constraint,
            }
          })
          .result
          .then(function () {
            return clientApi
              .custom('model/Division', 'deleteDivision', {
                divId: self.selectedDivision.id,
              })
              .then(function () {
                $state.reload();
              })
              .catch(function (err) {
                if (err) {
                  toastr.success(
                    $translate.instant('modules.administration.divisions.deleteDivErrToastText'),
                    $translate.instant('modules.administration.divisions.deleteDivErrToastTitle')
                  );
                }
              });
          });
      }
    };

    self.selectNode = function (node) {
      self.selectedDivision = null;
      if (node.id !== 'rootOrg') {
        self.selectedDivision = node;
      }

      if (!isNaN(parseInt(node.id))) {
        self.reqInProg = true;
        return clientApi
          .custom('model/Division', 'isConstrained', {
            divId: node.id,
          })
          .then(function (result) {
            self.constraint = result;
            self.reqInProg = false;
          });
      } else {
        self.constraint = {};
      }
    };

    function getChanges(newVal, originalData) {
      newVal.forEach(function (node) {
        // rootOrg can NEVER change, ignore it and run through its children
        if (node.id !== 'rootOrg' && !isNaN(parseInt(node.id))) {
          originalData.forEach(function (origNode) {
            if (node.id === origNode.id) {
              if (node.parent !== origNode.parent || node.id !== origNode.id || node.text !== origNode.text ||
                !angular.equals(node.admins, origNode.admins)) {
                var index = _.findIndex(self.changedNodes, function (changedNode) {
                  return changedNode.id === node.id;
                });
                if (!!~index) {
                  self.changedNodes[index] = node;
                } else {
                  self.changedNodes.push(node);
                }
              } else {
                var i = _.findIndex(self.changedNodes, function (changedNode) {
                  return changedNode.id === node.id;
                });
                if (!!~i) {
                  self.changedNodes.splice(i, 1);
                }
              }
            }
          });
        } else if (node.id !== 'rootOrg' && isNaN(parseInt(node.id))) {
          var index = _.findIndex(self.changedNodes, function (changedNode) {
            return changedNode.id === node.id;
          });
          if (!!~index) {
            self.changedNodes[index] = node;
          } else {
            self.changedNodes.push(node);
          }
        }
        if (node.children && node.children.length) {
          getChanges(node.children, originalData);
        }
      });
    }

    // collapse all division with more than 10 children
    commonUtils.recurseTree(self.divisionTreeData, function (node) {
      node.collapsed = node.children && node.children.length > 10;
    });

    self.toggleCollapsed = function () {
      commonUtils.recurseTree(self.divisionTreeData, function (node) {
        node.collapsed = !node.collapsed;
      });
    };

    self.checkForDisabledChildren = function (node) {
      // we have to separately check if a node has -only- disabled children
      // in this case, we have to disable the expansion chevron if the mode isn't on "all divisions" via the switcher
      var active = false;
      if (node.children && node.children.length && !self.showInactive) {
        node.children.forEach(function (child) {
          if (child.active) {
            active = true;
          }
        });
      } else {
        active = true;
      }
      return active;
    };

    $scope.$watch(function () {
      return self.divisionTreeData;
    }, function (newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        getChanges(newVal, self.originalNodeData);
      }
    }, true);

    $scope.$watch(function () {
      return self.selectedDivision;
    }, function (newVal) {
      if (self.isPermittedForFinanceExport && newVal && newVal.id && !isNaN(parseInt(newVal.id, 10)) &&
        (invoiceExportRecipients[newVal.id] || invoiceExportRecipients[newVal.id] === null)) {
        self.invoiceExportRecipient = invoiceExportRecipients[newVal.id];
        self.invoiceExportCtx = newVal.id;
      } else {
        self.invoiceExportCtx = null;
      }
    });

    self.MEMBER_COUNTRY_IDS = CAT_MEMBER_COUNTRY_IDS;
    //self.MEMBER_COUNTRY_IDS2 = CAT_MEMBER_COUNTRY_IDS_PAGES;


    // all fields are optional, accept empty value for each used validator
    [
      ['validIBAN', commonUtils.validation.iban],
      ['validBIC', commonUtils.validation.bic],
      ['validEMail', validationUtils.checkEmail],
    ].forEach(function (validator) {
      self[validator[0]] = function (value) {
        if (!value) {
          return true;
        }
        return !!validator[1](value);
      };
    });

    self.divisionBaseData = {
      address: {}
    };

    self.divisionBaseDataId = (divisionBaseData || {}).id;

    var addressFields = [
      'CountryId',
      'ZipCode',
      'City',
      'Street',
      'HouseNumber',
      'AddressAffix'
    ];

    if (divisionBaseData) {
      self.divisionBaseData = divisionBaseData;
      delete self.divisionBaseData.id;
      self.divisionBaseData.address = _.pick(self.divisionBaseData, addressFields);
      self.divisionBaseData.address.ZIP = self.divisionBaseData.address.ZipCode;
      delete self.divisionBaseData.address.ZipCode;
      self.divisionBaseData = _.omit(self.divisionBaseData, addressFields);
      if (self.divisionBaseData.address.CountryId) {
        self.divisionBaseData.address.CountryId = _.find(self.MEMBER_COUNTRY_IDS, { mapping: self.divisionBaseData.address.CountryId });
      }
      self.accountingArea = self.accountingAreas.find(function (it) {
        return it.AccountingAreaNumber === divisionBaseData.OfficeNumber &&
          it.DepartmentNumber === divisionBaseData.AccountingArea;
      });
    }

    self.divisionBaseDataAddressFieldsConfig = {
      countryId: {
        required: false
      },
      zipCode: {
        required: false
      },
      city: {
        required: false
      },
      street: {
        required: false
      },
      houseNumber: {
        required: false
      }
    };
    self.divisionBaseDataAddressUiConfig = {
      firstRow: {
        cssCls: 'row'
      },
      secondRow: {
        cssCls: 'row'
      },

      countryId: {
        wrapperCssCls: 'col-sm-3'
      },
      zipCode: {
        wrapperCssCls: 'col-sm-3'
      },
      city: {
        wrapperCssCls: 'col-sm-6'
      },
      street: {
        wrapperCssCls: 'col-sm-6'
      },
      houseNumber: {
        wrapperCssCls: 'col-sm-6'
      },
      addressAffix: {
        wrapperCssCls: 'col-sm-12'
      },
    };

    self.setDirty = function () {
      if (self.divisionBaseDataForm.$invalid) {
        angular.forEach(self.divisionBaseDataForm.$error, function (field) {
          angular.forEach(field, function (errorField) {
            errorField.$setDirty();
          });
        });
      }
    };

    self.updateDivisionBaseData = function () {
      var fieldsData = JSON.parse(JSON.stringify(self.divisionBaseData));
      delete fieldsData.Name;
      _.assign(fieldsData, fieldsData.address);
      delete fieldsData.address;
      fieldsData.ZipCode = fieldsData.ZIP;
      delete fieldsData.ZIP;
      fieldsData.CountryId = (fieldsData.CountryId || {}).mapping;

      clientApi
        .custom('model/Division', 'saveDivisionBaseData', {
          divisionId: baseDataCtx,
          fields: fieldsData
        })
        .then(function () {
          toastr.success(
            $translate.instant('modules.administration.divisions.toastSaveSuccessText'),
            $translate.instant('modules.administration.divisions.toastSaveSuccessTitle')
          );

          $state.reload();
        })
        .catch(function () {
          toastr.error(
            $translate.instant('modules.administration.divisions.toastSaveErrorText'),
            $translate.instant('modules.administration.divisions.toastSaveErrorTitle')
          );
        });
    };
    self.setAccountingArea = function (accountingArea) {
      self.accountingArea = accountingArea;
      self.divisionBaseData.AccountingArea = accountingArea.DepartmentNumber;
      self.divisionBaseData.OfficeNumber = accountingArea.AccountingAreaNumber;
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration.design', [])
    .controller('DesignCtrl', DesignCtrl)
    .directive('uploadlogo', function () {
      return {
        restrict: 'A',
        link: function(scope, element) {
          var target = element.attr('data-upload-target');
          element.bind('click', function() {
            var targetEl = angular.element('#'+target).get(0)
            if (targetEl) {
              targetEl.dispatchEvent(
                new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          });
        }
      };
    });

  /** @ngInject */
  function DesignCtrl($scope, $rootScope, clientApi, commonUtils, toastr, FileUploader, $state, permissions, initData, stateChangePrompt, portalLogoService, baModalService, $translate) {
    var $ctrl = this;
    $ctrl.selectedColor = initData.organization.current.primaryColor || '#CA3E30';
    $ctrl.originalColor = initData.organization.current.primaryColor || '#CA3E30';
    $ctrl.fontColor = '#000000';
    $ctrl.paging = 5;
    $ctrl.changeConfirmed = false;
    $ctrl.testCollection = [{
      firstName: 'John',
      lastName: 'Mayflower'
    }, {
      firstName: 'Judy',
      lastName: 'Mayflower'
    }, {
      firstName: 'Jacob',
      lastName: 'Mayflower'
    }]

    $ctrl.switchKeys = { 
      on: $translate.instant('modules.administration.adminDesign.activeMembers'),
      off: $translate.instant('modules.administration.adminDesign.allMembers') 
    }

    $ctrl.logoSetup = {
      useSquareInNavigation: portalLogoService.useSquareInNavigation || false,
      useExtInNavigation: portalLogoService.useExtInNavigation || false,
      useFilter: portalLogoService.useFilter || false,
      showOrgLabel: portalLogoService.showOrgLabel || false,
      showInFooter: portalLogoService.showInFooter || false,
    };
    $ctrl.origLogoSetup = Object.assign({}, $ctrl.logoSetup);

    // logo upload
    $ctrl.logoSettingsChanged = false;
    $ctrl.currentSquareLogoSrc = null;
    $ctrl.currentExtendedLogoSrc = null;
    $ctrl.changeCurrentOrgLogo = false;

    var allowedFileTypes= ['image/png', 'image/svg+xml'];
    var maxAllowedFileSize = 1048576; // 1MB

    $ctrl.uploaderConfig = clientApi.fileUploaderConfig({
      queueLimit: 3,
      url: '/api/orglogoStorage/upload',
      onAfterAddingFile: function (fileItem) {
        var logoType = fileItem.alias;
        if (!allowedFileTypes.includes(fileItem.file.type)) {
          $ctrl.uploader.removeFromQueue(fileItem);
          toastr.error($translate.instant('modules.administration.adminDesign.theOrgaLogoPng'), $translate.instant('modules.administration.adminDesign.falseDataFormat'));
          return false
        }
        if (fileItem.file.size > maxAllowedFileSize) {
          $ctrl.uploader.removeFromQueue(fileItem);
          toastr.error($translate.instant('modules.administration.adminDesign.dataDontExceed'), $translate.instant('modules.administration.adminDesign.dataIsToBig'));
          return false
        }
        // check for older square logo data and remove
        if (logoType === 'square') {
          fileItem.file.name = 'orglogo_square'
          _.filter($ctrl.uploader.queue, (function(qItem) {
            return qItem.alias === 'square' && qItem !== fileItem;
          })).forEach(function(fileItem) {
            $ctrl.uploader.removeFromQueue(fileItem);
          });
        }
        // check for older extended logo data and remove
        if (logoType === 'extended') {
          fileItem.file.name = 'orglogo_extended'
          _.filter($ctrl.uploader.queue, (function(qItem) {
            return qItem.alias === 'extended' && qItem !== fileItem;
          })).forEach(function(fileItem) {
            $ctrl.uploader.removeFromQueue(fileItem);
          });
        }

        var reader = new FileReader();
        reader.readAsDataURL(fileItem._file);
        reader.onloadend = function(evt) {
          $scope.$apply(function() {
            $ctrl.currentLogoDiff = true;
            if (logoType==='square') {
              $ctrl.currentSquareLogoSrc = evt.target.result;
              portalLogoService.data = $ctrl.currentSquareLogoSrc;
            }
            if (logoType==='extended') {
              $ctrl.currentExtendedLogoSrc = evt.target.result;
              portalLogoService.dataExt = $ctrl.currentExtendedLogoSrc;
            }
          });
        };
      },
      onCompleteAll : function() {
        $ctrl.uploader.clearQueue();
        toastr.success($translate.instant('modules.administration.adminDesign.theOrgaLogoWasSuccessSave'), $translate.instant('modules.administration.adminDesign.orgaLogoSaved'));
        if ($ctrl.currentSquareLogoSrc) {
          portalLogoService.data = $ctrl.currentSquareLogoSrc;
        }
        if ($ctrl.currentExtendedLogoSrc) {
          portalLogoService.dataExt = $ctrl.currentExtendedLogoSrc;
        }
      },
      onErrorItem: function(err) {
        console.error(err);
        toastr.error($translate.instant('modules.administration.adminDesign.theOrgaLogoCantSave'), $translate.instant('modules.administration.adminDesign.editFailed'));
      },
      onWhenAddingFileFailed: function (err) {
        console.error(err);
        toastr.error($translate.instant('modules.administration.adminDesign.toAddTheDataIsFailed'), $translate.instant('modules.administration.adminDesign.fail'));
      },
    });

    $ctrl.uploader = new FileUploader( $ctrl.uploaderConfig );

    $ctrl.uploadOrglogo = function() {
      $ctrl.uploader.queue.forEach(function(file, index) {
        file.alias = 'file';
        $ctrl.uploader.uploadItem(index);
      })
    };

    $ctrl.removeCurrentLogo = function(type, skipModal) {
      if (['square', 'extended'].indexOf(type) >= 0) {
        var modalTextContent = (type === 'square')
          ? $translate.instant('modules.administration.adminDesign.sureLogoDelete')
          : $translate.instant('modules.administration.adminDesign.sureExeedlogoDelete');

        if ( !skipModal ) {
          baModalService.messageModal({
            modalType: 'danger',
            allowHtml: false,
            title: $translate.instant('modules.administration.adminDesign.deleteOrgaLogo'),
            content: modalTextContent + '\n\n' +
            $translate.instant('modules.administration.adminDesign.thisActionIsirrevocale'),
            primaryActionText: $translate.instant('generalTerms.delete'),
            secondaryActionText: $translate.instant('generalTerms.cancel')
          })
            .then(function () {
              return clientApi.emit('orglogoStorage/remove', {
                type: type,
              })
                .then(function() {
                  if ( type === 'square') {
                    $ctrl.currentSquareLogoSrc = null;
                    $ctrl.logoSetup.useSquareInNavigation = false;

                    portalLogoService.data = null;
                    portalLogoService.useSquareInNavigation = false;

                    clientApi.emit('orglogoStorage/remove', {
                      type: 'extended',
                    });

                    $ctrl.currentExtendedLogoSrc = null;
                    $ctrl.logoSetup.useExtInNavigation = false;
                    $ctrl.logoSetup.showInFooter = false;

                    portalLogoService.dataExt = null;
                    portalLogoService.useExtInNavigation = false;
                    portalLogoService.showInFooter = false;
                  }

                  if ( type === 'extended' ) {
                    $ctrl.currentExtendedLogoSrc = null;
                    $ctrl.logoSetup.useExtInNavigation = false;
                    $ctrl.logoSetup.showInFooter = false;

                    portalLogoService.dataExt = null;
                    portalLogoService.useExtInNavigation = false;
                    portalLogoService.showInFooter = false;
                  }

                  toastr.warning($translate.instant('modules.administration.adminDesign.theOrgaLogoWasSuccessDelete'), $translate.instant('modules.administration.adminDesign.orgaLogoDelete'));
                  $ctrl.saveLogoSettings();
                })
                .catch(function(err) {
                  console.error(err);
                  toastr.error($translate.instant('modules.administration.adminDesign.theLogoCantDelete'), $translate.instant('modules.administration.adminDesign.deleteIsFailed'));
                });
            });
        }
      }
      else {
        console.err('Unknown logo type');
      }
    }

    $scope.$watch('$ctrl.logoSetup.useSquareInNavigation', function(newVal) {
      $ctrl.logoSettingsChanged = portalLogoService.useSquareInNavigation !== newVal;
      if (newVal && $ctrl.logoSetup.useExtInNavigation) {
        $ctrl.logoSetup.useExtInNavigation = false;
      }
      portalLogoService.useSquareInNavigation = $ctrl.logoSetup.useSquareInNavigation;
    });

    $scope.$watch('$ctrl.logoSetup.useExtInNavigation', function(newVal) {
      $ctrl.logoSettingsChanged = portalLogoService.useExtInNavigation !== newVal;
      if (newVal && $ctrl.logoSetup.useSquareInNavigation) {
        $ctrl.logoSetup.useSquareInNavigation = false;
      }
      if (!newVal) {
        $ctrl.logoSetup.showOrgLabel = false;
      }
      portalLogoService.showOrgLabel = $ctrl.logoSetup.showOrgLabel;
      portalLogoService.useExtInNavigation = $ctrl.logoSetup.useExtInNavigation;
    });

    $scope.$watchGroup([
      '$ctrl.logoSetup.useFilter',
      '$ctrl.logoSetup.showInFooter',
      '$ctrl.logoSetup.showOrgLabel'
    ], function(newVal) {
      $ctrl.logoSettingsChanged = (portalLogoService.useFilter !== newVal[0]) ||
        (portalLogoService.showInFooter !== newVal[1]) ||
        (portalLogoService.showOrgLabel !== newVal[2]);

      portalLogoService.useFilter = $ctrl.logoSetup.useFilter;
      portalLogoService.showInFooter = $ctrl.logoSetup.showInFooter;
      portalLogoService.showOrgLabel = $ctrl.logoSetup.showOrgLabel;
      // update scrollarea height in navigation
      $rootScope.$broadcast('sidebarupdate');
    });

    $ctrl.logoSetupHasChanges = function() {
      return $ctrl.logoSettingsChanged ||
        $ctrl.currentExtendedLogoSrc ||
        $ctrl.currentSquareLogoSrc
    }

    stateChangePrompt.evaluate(function () {
      return ($ctrl.selectedColor === $ctrl.originalColor) && !$ctrl.logoSetupHasChanges()
    });

    // reset portal logo settings to orig on route change
    $scope.$on('$destroy', function() {
      if (!$ctrl.changeConfirmed) {
        portalLogoService.useSquareInNavigation = $ctrl.origLogoSetup.useSquareInNavigation;
        portalLogoService.useExtInNavigation = $ctrl.origLogoSetup.useExtInNavigation;
        portalLogoService.useFilter = $ctrl.origLogoSetup.useFilter;
        portalLogoService.showOrgLabel = $ctrl.origLogoSetup.showOrgLabel;
        portalLogoService.showInFooter = $ctrl.origLogoSetup.showInFooter;
      }
    });

    $ctrl.validateHex = function(col) {
      var match = col.match(/#[0-9a-fA-F]+/g);
      if ((col.length === 4 || col.length === 7) &&
        match &&
        match[0] &&
        match[0].length === col.length
      ) {
        return true;
      }
      return false;
    };

    $scope.$watch('$ctrl.selectedColor', function(newVal) {
      if (newVal) {
        if ($ctrl.validateHex(newVal)) {
          $ctrl.fontColor = commonUtils.getContrastLabelColor(newVal);
          commonUtils.setPortalPrimaryColor(newVal);
          portalLogoService.inverted = $ctrl.fontColor.startsWith('#000');
        }
      } else {
        $ctrl.fontColor = '#000000';
      }
    });

    $ctrl.isPermittedInCurrentOrg = function (action) {
      return permissions.isPermittedInOrg(action, [$rootScope.ctx.organization.current.id]);
    };

    $ctrl.saveLogoSettings = function() {
      $ctrl.changeConfirmed = true;

      if ($ctrl.currentSquareLogoSrc || $ctrl.currentExtendedLogoSrc) {
        this.uploadOrglogo();
      }

      return clientApi.custom('model/Organization', 'setCustomLogo', { config: $ctrl.logoSetup })
        .then(function (res) {
          if (!res) {
            toastr.error($translate.instant('modules.administration.adminDesign.theLogoSettingsAreFailed'), $translate.instant('modules.administration.adminDesign.noSecured'));
            return false
          }
          toastr.success($translate.instant('modules.administration.adminDesign.theSettingsForLogoAreSaved'), $translate.instant('modules.administration.adminDesign.settingsSecured'));
          $rootScope.portalLogoSetup = $ctrl.logoSetup;
          stateChangePrompt.disableEvaluation();
          $state.reload();
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminDesign.unknownError'), $translate.instant('modules.administration.adminDesign.noSecured'));
        });
    }

    $ctrl.saveColorSettings = function() {
      if ($ctrl.selectedColor.toLowerCase() === '#fff' || $ctrl.selectedColor.toLowerCase() === '#ffffff') {
        $ctrl.selectedColor = '#EEEEEE';
      }

      return clientApi.custom('model/Organization', 'setColorScheme', { hexColor: $ctrl.selectedColor })
        .then(function (res) {
          if (res) {
            toastr.success($translate.instant('modules.administration.adminDesign.thePrimaryColorWasSaved'), $translate.instant('modules.administration.adminDesign.settingsSecured'));
            $rootScope.portalColor = $ctrl.selectedColor;
            stateChangePrompt.disableEvaluation();
            $state.reload();
          } else {
            toastr.error($translate.instant('modules.administration.adminDesign.thePrimaryDontColorCode'), $translate.instant('modules.administration.adminDesign.noSecured'));
          }
        })
        .catch(function () {
          toastr.error($translate.instant('modules.administration.adminDesign.unknownError'), $translate.instant('modules.administration.adminDesign.noSecured'));
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.categories')
    .controller('CategoryCtrl', CategoryCtrl);

  function CategoryCtrl(
    ARNO_CONSTANTS,
    $state, $uibModal,
    commonUtils, toastr, clientApi,
    categories, organizationId, ctxSelected,
    ArnoDashAdminCategoriesService, $translate
  ) {
    var self = this;

    self.ADMIN_CATEGORIES_USAGE_LIST_LABELS = ARNO_CONSTANTS.ADMIN.CATEGORIES.USAGELIST_LABELS;

    self.allowOrgSelection = true;
    self.currentDivision = commonUtils.getDivisionFromSingleCtx('arno.administration.categories.manage');
    self.currentOrg = organizationId;
    self.ctxSelected = ctxSelected;

    self.openModal = function (modalPage, size, categoryItem) {
      $uibModal.open(
        {
          controller: 'CategoryModalCtrl as $modalCtrl',
          animation: true,
          templateUrl: 'app/pages/administration/categories/categoryModal/' + modalPage + '.html',
          size: size,
          resolve: {
            category: function () {
              return _.cloneDeep(categoryItem);
            },
            currentDivision: function() {
              return self.currentDivision;
            },
          }
        }).result
        .then(function (result) {
          if (!result.id && !result.newName) {
            self.createCategory(result.name, result.color, result.usages)
              .then(function() {
                toastr.success(
                  $translate.instant('modules.administration.adminCategories.toast1Text', { name: result.name }),
                  $translate.instant('modules.administration.adminCategories.toast1Title')
                );

                $state.reload();
              })
              .catch(function(error) {
                // distinguish between general error and COUNT-EXCEEDED error!
                if (error && error.data && error.data.key === 'BASECATEGORY_CREATE_MAX_COUNT_EXCEEDED') {
                  var scopeText = ' pro ' + (self.currentDivision ? 'Gliederung' : 'Organisation');
                  toastr.error(
                    $translate.instant('modules.administration.adminCategories.toast2Text', { count: error.data.maxCount, scopeText: scopeText }),
                    $translate.instant('modules.administration.adminCategories.toast2itle')
                  );

                  return error;
                }

                toastr.error(
                  $translate.instant('modules.administration.adminCategories.toast3Text'),
                  $translate.instant('modules.administration.adminCategories.toast3Title')
                );
              });
          } else if (result.newName) {
            self.updateCategory(result.newName, result.newColor, result.newUsages, result.editId)
              .then(function() {
                toastr.success(
                  $translate.instant('modules.administration.adminCategories.toast4Text', { name: result.newName }),
                  $translate.instant('modules.administration.adminCategories.toast4Title')
                );

                $state.reload();
              })
              .catch(function() {
                toastr.error(
                  $translate.instant('modules.administration.adminCategories.toast5Text', { name: result.newName }),
                  $translate.instant('modules.administration.adminCategories.toast5Title')
                );
              });
          } else {
            self.deleteCategory(result.id)
              .then(function() {
                toastr.success(
                  $translate.instant('modules.administration.adminCategories.toast6Text', { name: result.name }),
                  $translate.instant('modules.administration.adminCategories.toast6Title')
                );

                $state.reload();
              })
              .catch(function() {
                toastr.success(
                  $translate.instant('modules.administration.adminCategories.toast7Text', { name: result.name }),
                  $translate.instant('modules.administration.adminCategories.toast7Title')
                );
              });
          }
        });
    };

    self.createCategory = function (name, color, usages) {
      return ArnoDashAdminCategoriesService.createCategory(name, color, usages, self.currentDivision || null);
    };

    self.updateCategory = function (name, color, usages, id) {
      return clientApi.custom('model/BaseCategory', 'updateOneBaseCategory', {
        name: name,
        color: color,
        id: id,
        usages: usages,
        divId: self.currentDivision || null,
      })
    };

    self.deleteCategory = function (id) {
      return clientApi.custom('model/BaseCategory', 'deleteBaseCategory', {
        id: id,
        divId: self.currentDivision || null,
      })
    };

    self.setColor = function (color) {
      return {
        'background-color': color,
        'height': '20px',
        'width': '75%',
        'border': '1px solid #555',
        'border-radius': '3px'
      }
    };

    self.categories = categories;

    self.divisionSelectorEntryPermission = 'arno.administration.categories.manage';
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.apikey', [
      'BlurAdmin.pages.administration.apikey.details'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.apikey', {
        url: '/apikey',
        templateUrl: 'app/pages/administration/apikey/apikey.html',
        title: 'navigation.administration.apikey',
        controller: 'ApiKeyCtrl as self',
        sidebarMeta: {
          order: 1,
        },
        resolve: {
        },
        viewPermission: 'arno.administration.apikey.manage',
        viewPermissionScopes: ['Organization'],
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.apikey')
    .controller('ApiKeyCtrl', ApiKeyCtrl);

  function ApiKeyCtrl($state, $translate, $scope, commonUtils, clientApi, toastr, validationUtils, baModalService) {
    var self = this;
    self.displayedCollection = [];
    self.itemsPerPage = 10;

    self.setPageSize = function (num) {
      self.itemsPerPage = commonUtils.getPageSize('apikey_admin_page_size', num);
    }
    self.setPageSize();

    self.getKeys = function (params) {
      var queryWishes = {
        paging: {
          offset: (params.pagination.start / params.pagination.number) * self.pageSize || 0,
          limit: self.pageSize
        },
        sort: {
          by: params.sort.predicate,
          reverse: params.sort.reverse
        },
        search: (params.search || {}).predicateObject ? commonUtils.flattenObject(params.search.predicateObject) : undefined,
      };

      if (queryWishes.search && !Object.keys(queryWishes.search).length) {
        delete queryWishes.search;
      }

      return clientApi
        .custom('model/ApiKey', 'getApiKeys', { queryWishes: queryWishes })
        .then(function (result) {
          if (result) {
            self.displayedCollection = result.rows;
            params.pagination.numberOfPages = Math.ceil((result.count || 0) / self.itemsPerPage);
          } else {
            params.pagination.numberOfPages = 0;
          }
        });
    };

    self.setKeyState = function(id, state) {
      return clientApi
        .custom('model/ApiKey', 'setApiKeyActiveState', { keyId: id, state: state })
        .then(function() {
          toastr.success(
            $translate.instant(state ? 'modules.administration.apikey.setStateActiveSuccessContent' : 'modules.administration.apikey.setStateInactiveSuccessContent'),
            $translate.instant(state ? 'modules.administration.apikey.setStateActiveSuccessTitle' : 'modules.administration.apikey.setStateInactiveSuccessTitle')
          );
          $state.reload();
        })
        .catch(function() {
          toastr.error(
            $translate.instant('modules.administration.apikey.setStateFailContent'),
            $translate.instant('modules.administration.apikey.setStateFailTitle')
          )
        })
    }

    self.deleteKey = function(key) {
      return baModalService.messageModal({
        modalType: 'danger',
        allowHtml: false,
        title: $translate.instant('modules.administration.apikey.deleteKeyConfirmationTitle'),
        content: $translate.instant('modules.administration.apikey.deleteKeyConfirmationContent', { name: key.Name }) + '\n\n' +
        $translate.instant('modules.administration.adminDesign.thisActionIsirrevocale'),
        primaryActionText: $translate.instant('generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel')
      })
      .then(function() {
        return clientApi
          .custom('model/ApiKey', 'deleteApiKey', { keyId: key.id })
          .then(function() {
            toastr.success(
              $translate.instant('modules.administration.apikey.deleteSuccessContent'),
              $translate.instant('modules.administration.apikey.deleteSuccessTitle')
            );
            $state.reload();
          })
          .catch(function() {
            toastr.error(
              $translate.instant('modules.administration.apikey.deleteFailContent'),
              $translate.instant('modules.administration.apikey.deleteFailTitle')
            )
          })
      })
    }

    self.openDetails = function(id) {
      $state.go(
        'arno.administration.apikey.details',
        { id: id || undefined }
      );
    }

    self.ctc = function(key) {
      return commonUtils.copyToClipboard(key);
    }

    self.validationScroll = function (form) {
      validationUtils.validationScroll($scope, form);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration')
    .controller('ChooseExportTypeCtrl', ChooseExportTypeCtrl);

  function ChooseExportTypeCtrl($uibModalInstance, commonUtils, permissions, $translate) {
    var self = this;

    self.selectItems = [
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelXlsx'),
        value: 'xlsx'
      },
      { 
        label: $translate.instant('modules.personnel.personnelList.exportModalFileTypeLabelCsv'),
        value: 'csv'
      },
    ];
    self.selected = self.selectItems[0];
    self.selectedOption = 'tableConfig';

    self.applyModal = function() {
      $uibModalInstance.close({
        options: self.selectedOption,
        filetyp: self.selected.value,
      });
    };

    self.getShowElement = function (element) {
      switch (element) {
      case 'actions':
        return permissions.isPermittedInEvery('BlurAdmin.pages.arnoAdministration', 'Division', commonUtils.division.getCtx({ multiple: true }));
      }
    };
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        if (img.complete) {
          d.resolve();
        } else {
          img.onload = function () {
            d.resolve();
          };
          img.onerror = function () {
            //d.reject();
            d.resolve();
            // we still resolve because a broken image won't kill
            // a website - but a rejected promise in a resolve might
          };
        }
        return d.promise;
      },
      loadAmCharts: function () {
        var d = $q.defer();
        AmCharts.ready(function () {
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
          {
            total: event.total,
            loaded: event.loaded
          });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
  function baProgressModal($uibModal) {
    var methods = {};
    var progress = 0;
    var max = 100;
    var opened = false;

    return {
      setProgress: function (value) {
        if (value > max) {
          throw Error('Progress can\'t be greater than max');
        }
        progress = value;
      },
      getProgress: function () {
        return progress;
      },
      open: function() {
        if (!opened) {
          methods = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
            size: 'sm',
            keyboard: false,
            backdrop: 'static'
          });
          opened = true;
        } else {
          throw Error('Progress modal opened now');
        }

      },
      close: function() {
        if (opened) {
          methods.close();
          opened = false;
        } else {
          throw Error('Progress modal is not active');
        }

      }
    };
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('toggleNext', toggleNext);

  /** @ngInject */
  function toggleNext() {
    return {
      scope: {
        toggleNext: '=?',
        toggleSkipNextAnimation: '=?',
      },
      link: function (scope, element) {
        var chevron = $('<i class="toggle-next-chevron fa fa-chevron-down"></i>');

        if (element.find('> *').length) {
          element.find('> *').first().append(chevron);
        } else {
          element.append(chevron);
        }

        // initially set toggle state. its important so the toggling-icon matches the toggling state!
        if (scope.toggleNext === true) {
          animatedToggling(element, scope.toggleNext, chevron, true);
        }

        scope.chevron = chevron;

        // listen for toggle-changes
        element.click(function () {
          scope.toggleNext = !scope.toggleNext;
          scope.$apply();
        });
      },
      /** @ngInject */
      controller: function($scope, $element) {
        var $ctrl = this;

        var wasCollapsedState = !!$scope.toggleNext; // not collapsed when undefined or false

        // doCheck Life-Cycle hook for better change-watching than $scope.$watch
        $ctrl.$doCheck = function() {
          if (!$scope.chevron) {
            return;
          }
          var isCollapsedState = !!$scope.toggleNext;
          if (wasCollapsedState !== isCollapsedState) {
            wasCollapsedState = isCollapsedState;
            animatedToggling($element, isCollapsedState, $scope.chevron, $scope.toggleSkipNextAnimation);
          }
          $scope.toggleSkipNextAnimation = undefined; // reset even when no animation was concluded, due to the state already being where it should
        }
      }
    }
  }

  // HELPERS
  function animatedToggling(element, collapsed, chevron, withoutAnimation) {
    element.next().animate({ height: 'toggle', opacity: 'toggle' }, withoutAnimation ? 0 : 400);
    chevron.css({ 'transform': 'rotate(' + ((collapsed === true) ? 90 : 0) + 'deg)' });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('stFilteredCollection', stFilteredCollection);

  /** @ngInject */
  function stFilteredCollection() {
    return {
      require: '^stTable',
      link: function (scope, element, attr, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function(val) {
          scope.stFilteredCollection = val;
        })
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture() {
    return {
      scope: {
        profilePicture: '=',
      },
      controller: function($scope, $element, $attrs, clientApi) {
        $scope.$root.profilePicChange = 0;
        $scope.getProfileImage = function(id) {
          return clientApi.emit('avatarStorage/get', {
            dossierOwnerId: id
          })
          .then(function(data) {
            return data.imagedata
          })
          .catch(function(err) {
            console.error(err);
            return 'noimage';
          });
        };
        $scope.$watch(function() {
          return $scope.profilePicture.profilePic;
        }, function() {
          refreshProfilePicture($scope, $element, $attrs, $scope.profilePicture);
        });
      },
    };
  }

  function refreshProfilePicture(scope, elem, attrs, user) {
    elem.hide(); // hide immediately to prevent flickering 
    var initialsElem = elem.parent().children('span');
    if (initialsElem.length) {
      initialsElem.hide();
    }

    if (user.profilePic) {
      scope.getProfileImage(
        user.id
      )
      .then(function(img) {
        elem.prop('src', 'data:image/jpeg;base64, ' + img);
        elem.show();
      })
    } else {
      var color = (
        parseInt(
          parseInt(user.eMailHash, 16)
            .toExponential()
            .slice(2, -5)
          , 10) & 0xFFFFFF
      ).toString(16).toUpperCase();

      var span = document.createElement('span');
      span.style.display = 'block';
      span.style.fontSize = (attrs.fontSize || 16) + 'px';
      span.style.color = function() {
        var r = parseInt(color.substr(0, 2), 16);
        var g = parseInt(color.substr(2, 2), 16);
        var b = parseInt(color.substr(4, 2), 16);
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#000' : '#fff';
      }();
      span.className = 'user-profile-initials';
      span.style.backgroundColor = '#' + color;
      span.style.width = attrs.width || '45px';
      span.style.height = attrs.height || '45px';
      span.style.lineHeight = attrs.height || '45px';
      span.style.textAlign = 'center';
      span.style.borderRadius = '50%';
      span.textContent = user.initials;

      if (initialsElem.length) {
        initialsElem.show();
      } else {
        elem.parent().append(span);
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ngEnter', ngEnter);

  /** @ngInject */
  function ngEnter() {
    return function (scope, element, attrs) {
      element.bind('keydown keypress', function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter, { 'event': event });
          });

          event.preventDefault();
        }
      });
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('maxChar', maxChar);

  /** @ngInject */
  function maxChar() {
    return {
      restrict: 'A',
      require: '?ngModel',
      scope: {
        maxChar: '=',
      },
      link: function (scope, element, attrs, ngModel) {
        if (!ngModel || !scope.maxChar || !isFinite(scope.maxChar)) {
          return;
        }

        scope.$watch(function() {
          return !ngModel.$modelValue || ((ngModel.$modelValue.length || 0) <= scope.maxChar);
        }, function (isValid) {
          ngModel.$setValidity('maxChar', isValid);
        });

        var label;
        var currElement = element;
        var sanity = 50;
        while(currElement && currElement.length && !label && sanity--) {
          currElement = currElement.parent();
          var search = currElement.find('label');
          if (search.length) {
            label = search;
          }
        }

        if (!label || !label.length) {
          return;
        }

        var appendix = $('<span class="label-max-char-indicator"></span>');
        appendix.appendTo(label.first());

        scope.$watch(function() {
          return (ngModel.$modelValue && ngModel.$modelValue.length) || 0;
        }, function (currentCharCount, prevCharCount) {
          if (currentCharCount === prevCharCount) {
            // don't show on init, only after something changes to prevent all fields in a form getting this indicator, even when only viewed
            return;
          }
          if ((currentCharCount / scope.maxChar) >= 0.8) {
            // 80% or more of maxChars were typed
            appendix.html(currentCharCount + ' / ' + scope.maxChar);
          } else {
            appendix.html('');
          }
          appendix[currentCharCount > scope.maxChar ? 'addClass' : 'removeClass']('label-max-char-reached');
        });
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
        $element.ionRangeSlider({
          min: $scope.min,
          max: $scope.max,
          type: $scope.type,
          prefix: $scope.prefix,
          maxPostfix: $scope.maxPostfix,
          prettify_enabled: $scope.prettify,
          prettify_separator: $scope.prettifySeparator,
          grid: $scope.grid,
          gridMargin: $scope.gridMargin,
          postfix: $scope.postfix,
          step: $scope.step,
          hideMinMax: $scope.hideMinMax,
          hideFromTo: $scope.hideFromTo,
          from: $scope.from,
          to: $scope.to,
          disable: $scope.disable,
          onChange: $scope.onChange,
          onFinish: $scope.onFinish,
          values: $scope.values
        });

        $scope.$watch('min', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({min: value});
          });
        }, true);
        $scope.$watch('max', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({max: value});
          });
        });
        $scope.$watch('from', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({from: value});
          });
        });
        $scope.$watch('to', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({to: value});
          });
        });
        $scope.$watch('disable', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({disable: value});
          });
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();


(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('compareWithStartDate', function () {
        return {
          restrict: 'A',
          require: 'ngModel',
          link: function(scope, elem, attr, ngModel) {
            function validate(startDate, endDate) {
              var start = moment(startDate || null).startOf('day');
              var end =  moment(endDate || null).startOf('day');
              return end.diff(start) >= 0;
            }
            ngModel.$validators.checkEndDate = function (endDate) {
              return attr.startDate && endDate ? validate(attr.startDate.replace(/['"]+/g, ''), endDate) : true;
            }
            attr.$observe('startDate', function (value) {
              ngModel.$setValidity('checkEndDate', validate(value.replace(/['"]+/g, ''), ngModel.$modelValue));
            });
          }
        };
      });
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
(function () {
  'use strict';

  /**
  * @ngdoc directive
  * @name ArnoAccessControlList
  *
  * @description Directives are responsible to restrict or grant access to a given e.g. (html)-element (through e.g. hide/show)
  * REMARK: the atm not used linker for arnoAcl is added for completeness
  *
  */
  angular.module('BlurAdmin.theme')
    .directive('arnoAcl', function() {
      return ArnoAccessControlListRootDirective;
    })
    .directive('aclGrant', function() {
      return ArnoAccessControlListGrantDirective;
    });

  // DIRECTIVE DEFINITIONS
  var ArnoAccessControlListRootDirective = {
    restrict: 'A',
    scope: {
      /**
       * This is an array of context ids, e.g. ['rootOrg'] or ['2'] or ['1', '2'] ....
       * This applies to all arnoGrant directives! However it can be overridden by each arnoGrant
       */
      aclCtx: '<',
      /**
       * the scopes to check against, either as string or array of strings (multiple scopes)
       * for the final permission-check, only ONE scope and permission must match to be granted (element shown)!
       * This applies to all arnoGrant directives! However it can be overridden by each arnoGrant
       */
      aclScope: '<?',

      /**
        * {
        *   mustMatchAllCtx: boolean         if this is true, then the given permissions and scope must must all given ctx (ids)
        *   mustMatchAllScopes: boolean   if this is true, then the given permissions and ids must must all given scopes
        *   withSubPerms: boolean             if this is true, then the given permissions will be checked against sub-permissions
        * }
        *
        * This applies to all arnoGrant directives! However it can be overridden by each arnoGrant
        */
      aclOptions: '<?',
    },
    controller: ArnoAccessControlListRootController
  };

  var ArnoAccessControlListGrantDirective = {
    restrict: 'A',
    require: ['?^^arnoAcl', '?^^divisionSelector'], // add a good way to access the division-selector, if no acl-root given
    scope: {
      /**
       * self-binding of the directive. This should provide the permission(s) either as string (permission) or array of strings (array of permissions)
       */
      aclGrant: '<',

      /**
       * This is an array of context ids, e.g. ['rootOrg'] or ['2'] or ['1', '2'] ....
       * This overrides the aclCtx of the "arnoAcl" directive
       */
      aclCtx: '<',

      /**
       * the scopes to check against, either as string or array of strings (multiple scopes)
       * for the final permission-check, only ONE scope and permission must match to be granted (element shown)!
       * This overrides the aclScope of the "arnoAcl" directive
       */
      aclScope: '<?',

      /**
        * {
        *   mustMatchAllCtx: boolean         if this is true, then the given permissions and scope must must all given ctx (ids)
        *   withSubPerms: boolean             if this is true, then the given permissions will be checked against sub-permissions
        *   mustMatchAllScopes: boolean   if this is true, then the given permissions and ids must must all given scopes
        *   showInitially: boolean                if this is true, then the affected element is initially show (where no permission check is done)
        * }
        */
      aclOptions: '<?',
    },
    link: ArnoAccessControlListGrantLinker,
    controller: ArnoAccessControlListGrantController
  };

  /** @ngInject */
  function ArnoAccessControlListGrantLinker(scope, element, attributes, aclRootCtrls) {
    if (aclRootCtrls && aclRootCtrls.length) {
      if (aclRootCtrls[0] instanceof ArnoAccessControlListRootController) {
        scope.arnoAclRootCtrl = aclRootCtrls[0];
      }
      if (aclRootCtrls[1]) {
        scope.divisionSelectorCtrl = aclRootCtrls[1];
      }
    }
  }

  // CONTROLLERS
  /** @ngInject */
  function ArnoAccessControlListRootController($rootScope, $scope) {
    var $aclCtrl = this;

    // BOOTSTRAPPER Function
    function activate() {
      // CAN BE EXTENDED / OPT: directive should access e.g. common-utils or division-selector to get current selected ctx
      $aclCtrl.aclCtx = $scope.aclCtx;
      $aclCtrl.aclScope = $scope.aclScope;
      $aclCtrl.aclOptions = $scope.aclOptions;
    }

    // INIT
    $aclCtrl.$onInit = function() {
      activate();
    }

  }

  // ======
  /** @ngInject */
  function ArnoAccessControlListGrantController($rootScope, $scope, $element, commonUtils, permissions) {
    var $aclCtrl = this;

    // VARS

    // BOOTSTRAPPER Function
    function activate() {
      $aclCtrl.aclGrant = $scope.aclGrant; // assign self-binding to controller

      $aclCtrl.arnoAclRootCtrl = $scope.arnoAclRootCtrl;

      $aclCtrl.aclCtx = $scope.aclCtx;
      $aclCtrl.aclScope = $scope.aclScope;
      $aclCtrl.aclOptions = $scope.aclOptions;

      // initially hide element, if option to show it initially is not true
      if (!$aclCtrl.aclOptions || !$aclCtrl.aclOptions.showInitially) {
        $element.hide();
      }

      setupWatchers();

      // OPT: add watcher to track change of permission (e.g. by var)
    }

    // HELPERS
    function setupWatchers() {
      // wait until arno-acl-root is available!
      $scope.$watch('arnoAclRootCtrl.aclCtx', function() {
        checkPermissions();
      });
    }

    /**
     * @description This function check if the given permissions and scopes are matching one or all of the users permissions
     * to grant (atm: hide or show) an affected element (affected by the arnoGrant directive).
     * IMPORTANT: All checks against the given permissions (given by arno-grant="SomePermission")
     * and scopes (given by acl-scope="SomeScope") are OR-compares. so only one of the possible combination must match!
     * Sub-Permissions can be considered by setting the acl-options = { withSubPerms: true,...... }
     */
    function checkPermissions() {
      // take ctx and scopes from arno-grant or get it from root "arnoAcl", if given
      var selectedCtx = $scope.aclCtx || ($scope.arnoAclRootCtrl && $scope.arnoAclRootCtrl.aclCtx);
      var targetScopes = $scope.aclScope || ($scope.arnoAclRootCtrl && $scope.arnoAclRootCtrl.aclScope);
      var targetPermissions = $scope.aclGrant;
      var options = ($scope.arnoAclRootCtrl && $scope.arnoAclRootCtrl.aclOptions) || {
        withSubPerms: false,
        mustMatchAllCtx: false,
        mustMatchAllScopes: false
      }; // set standard options

      if (selectedCtx && !(selectedCtx instanceof Array)) {
        selectedCtx = [selectedCtx];
      }

      // normalize permissions var
      if (typeof targetPermissions === 'string') {
        targetPermissions = [targetPermissions];
      }

      // normalize targetScopes var
      // if no scope is given then check against all current known scopes (Division, Organization)
      if (typeof targetScopes === 'string') {
        targetScopes = [targetScopes];
      }
      else if (!targetScopes) {
        targetScopes = ['Organization', 'Division'];
      }

      options = _.merge(options, $scope.aclOptions);

      var isPermitted = false;

      var isPermittedInAllScope = true;
      var isPermittedInAtLeastOneScope = false;

      if (options.mustMatchAllCtx === true) {
        if (targetScopes instanceof Array) {
          _.forEach(targetScopes, function(targetScope) {
            // if no context is given then check if permitted anywhere
            if (!selectedCtx) {
              if (permissions.isPermittedAnywhere(targetPermissions[0])) {
                isPermittedInAtLeastOneScope = true;
              }
              else {
                isPermittedInAllScope = false;
              }
            }
            else {
              if (permissions.isPermittedInEvery(targetPermissions[0], targetScope, selectedCtx, options.withSubPerms)) {
                isPermittedInAtLeastOneScope = true;
              }
              else {
                isPermittedInAllScope = false;
              }
            }
          });
        }
        else {
          // set back to false, if no scopes given - treat it like not permitted!
          isPermittedInAllScope = false;
        }

        // OPT: introduce option to force that all scopes must match, use isPermittedInAllScope
        isPermitted = isPermittedInAtLeastOneScope;
        isPermitted = options.mustMatchAllScopes === true ? isPermittedInAllScope : isPermitted;
      }
      else {
        if (targetScopes instanceof Array) {
          _.forEach(targetScopes, function(targetScope) {
            if (!selectedCtx) {
              if (permissions.isPermittedAnywhere(targetPermissions[0])) {
                isPermittedInAtLeastOneScope = true;
              }
              else {
                isPermittedInAllScope = false;
              }
            }
            else {
              if (permissions.isPermittedInSome(targetPermissions[0], targetScope, selectedCtx, options.withSubPerms)) {
                isPermittedInAtLeastOneScope = true;
              }
              else {
                isPermittedInAllScope = false;
              }
            }
          });
        }
        else {
          // set back to false, if no scopes given - treat it like not permitted!
          isPermittedInAllScope = false;
        }

        // OPT: introduce option to force that all scopes must match, use isPermittedInAllScope
        isPermitted = isPermittedInAtLeastOneScope;
        isPermitted = options.mustMatchAllScopes === true ? isPermittedInAllScope : isPermitted;
      }

      if (!isPermitted) {
        $element.hide();
      }
      else {
        $element.show();
      }
    }


    // INIT
    $aclCtrl.$onInit = function() {
      activate();
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoDashboard', [])
    .config(routeConfig);

  /* @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/arnoDashboard/arnoDashboard.html',
        title: 'navigation.dashboard',
        controller: 'DashboardCtrl as $ctrl',
        resolve: {
          isPermitted: function (permissions) {
            return function (action) {
              return permissions.isPermittedAnywhere(action, ['Division']);
            };
          },
          viewPermissions: function (isPermitted, permissions) {
            return {
              event:
                isPermitted('arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage'),
              eventView: isPermitted('arno.events.basic.view') || isPermitted('arno.events.service.view'),
              eventShare: isPermitted('arno.events.basic.manage') || isPermitted('arno.events.service.manage'),
              serviceManage: isPermitted('arno.events.service.manage'),
              demandForAction: permissions.isPermittedAnywhere('arno.personnel.privacyTerms.manage', ['Organization', 'Division'])
            };
          },
          eventCtx: function (commonUtils, viewPermissions) {
            if (!viewPermissions.event) {
              return [];
            }
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage'
            });
          },
          eventTypes: function ($translate) {
            return [
              { Color: '#FFF', Name: $translate.instant('modules.arnoDashboard.board.dates'), Type: 'event' },
              { Color: '#FFF', Name: $translate.instant('modules.arnoDashboard.board.service'), Type: 'service' },
            ];
          },
          attendanceStates: function ($translate) {
            return [
              { Color: '#00BCD4', Name: $translate.instant('modules.arnoDashboard.board.invited'), Status: 'invited' },
              { Color: '#CDDC39', Name: $translate.instant('modules.arnoDashboard.board.accepted'), Status: 'accepted' },
              { Color: '#F44336', Name: $translate.instant('modules.arnoDashboard.board.declined'), Status: 'declined' },
              { Color: '#4CAF50', Name: $translate.instant('modules.arnoDashboard.board.planned'), Status: 'planned' },
            ];
          },
          chosenSharedFilters: function () {
            return {
              categories: [],
            };
          },
          categories: function (clientApi, commonUtils, $rootScope, eventCtx, viewPermissions, $translate) {
            if (!viewPermissions.event || !eventCtx || !eventCtx.length) {
              return [];
            }
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { divisionIds: eventCtx, usages: ['Event'] })
              .then(function (categories) {
                categories.push({
                  id: null,
                  Name: $translate.instant('modules.arnoDashboard.board.noCatEntries'),
                  Color: '#FFF',
                  DivisionId: null,
                  OrganizationId: $rootScope.ctx.organization.current.id
                });
                return categories;
              });
          },
          baseShareCtx: function (commonUtils, viewPermissions) {
            if (!viewPermissions.eventShare) {
              return [];
            }
            return commonUtils.division.getCtx({
              multiple: true,
              namespace: 'divisionShareRequests',
              entryPermission: 'arno.events.basic.manage,arno.events.service.manage'
            });
          },
          eventShareCtx: function (baseShareCtx, permissions) {
            return permissions.getPermittedIds(
              'arno.events.basic.manage',
              'Division',
              baseShareCtx,
              false
            );
          },
          serviceShareCtx: function (baseShareCtx, permissions) {
            return permissions.getPermittedIds(
              'arno.events.service.manage',
              'Division',
              baseShareCtx,
              false
            );
          },
          divisionShares: function (viewPermissions, clientApi, baseShareCtx, eventShareCtx, serviceShareCtx) {
            if (!viewPermissions.eventShare || !baseShareCtx || !baseShareCtx.length) {
              return [];
            }
            return Promise
              .all([
                Promise.resolve()
                  .then(function () {
                    if (!eventShareCtx.length) {
                      return [];
                    }
                    return clientApi.custom(
                      'model/DivisionEvent', 'getOpenDivisionShares',
                      { divisionId: eventShareCtx, isFuture: true, isForDashboard: true }
                    );
                  }),
                Promise.resolve()
                  .then(function () {
                    if (!serviceShareCtx.length) {
                      return [];
                    }
                    return clientApi.custom('model/ServiceShare', 'getOpenShares', { divisionId: serviceShareCtx });
                  }),
              ])
              .then(function (result) {
                var combined = _.flatten(result);
                combined.forEach(function (evt) {
                  if (evt.Service) {
                    evt.Event = evt.Service;
                    evt['isService'] = true;
                  } else {
                    evt['isService'] = false;
                  }
                  if (!evt.Event.StartDate) {
                    evt.Event.EventStartDate;
                  }
                });
                return _.orderBy(combined, ['Subject'], ['asc']);
              });
          },
          serviceCtx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.service.manage'
            });
          },

          openServiceAttendeeInterest: function (viewPermissions, serviceCtx, clientApi) {
            if (!viewPermissions.serviceManage || !serviceCtx.length) {
              return [];
            }
            return clientApi.custom('model/ServiceShiftMember', 'getOpenServiceAttendeeInterest', { divisionId: serviceCtx });
          },
          welcomeTitleContent: function (ArnoDashAdminOrganizationConfigService) {
            return ArnoDashAdminOrganizationConfigService.getOrgConfigEntry('WELCOME-PAGE_INTRO-TITLE')
              .then(function (result) {
                if (result && result.length) {
                  return result[0].Content;
                }

                return result.Content;
              });
          },
          welcomeTextContent: function (ArnoDashAdminOrganizationConfigService) {
            return ArnoDashAdminOrganizationConfigService.getOrgConfigEntry('WELCOME-PAGE_INTRO-TEXT')
              .then(function (result) {
                if (result && result.length) {
                  return result[0].Content;
                }

                return result.Content;
              });
          },
          demandForActionCount: function (viewPermissions, clientApi) {
            if (!viewPermissions.demandForAction) {
              return 0;
            }
            return clientApi.custom('model/PrivacyTerms', 'membersWithDemandForActionExist')
              .then(function (result) {
                return result;
              })
              .catch(function () {
                return 0;
              });
          },
          availableHHDivs: function (clientApi, $rootScope, initData) {
            var permittedDivs = ((initData.permissionsTree || {}).permissions || {})['arno.personnel.helperHours.approve'];
            if (!permittedDivs) {
              return [];
            }
            return clientApi
              .custom('model/DivisionMember', 'getAvailableDivisions', { cMemberId: $rootScope.ctx.currentUser.id })
              .then(function (res) {
                return _.intersectionWith(res, permittedDivs.Division, function (a, b) {
                  return a.id === b;
                })
                  .map(function (d) {
                    return d.id;
                  });
              });
          },
          openHelperHours: function (clientApi, availableHHDivs) {
            if (availableHHDivs && availableHHDivs.length) {
              return clientApi
                .custom('model/helperHours', 'fetchHelperHours', {
                  divisionId: availableHHDivs,
                  queryWishes: {
                    paging: {
                      offset: 0,
                      limit: 2,
                    },
                    onlyUnapproved: true,
                    includeOrgEntries: true,
                    includeAccount: true,
                  },
                  includeActivityAllocationsDivInfo: true
                });
            }
          },
          openQuotations: function (clientApi, initData) {
            var permittedDivs = ((((initData || {}).permissionsTree || {}).permissions || {})['arno.finances.quotations.edit'] || {}).Division;
            if (!permittedDivs || !permittedDivs.length) {
              return 0;
            }
            return clientApi
              .custom('model/Quotation', 'fetchOpenCount', { isInvoice: false });
          },
          openInvoices: function (clientApi, initData) {
            var permittedDivs = ((((initData || {}).permissionsTree || {}).permissions || {})['arno.finances.invoices.edit'] || {}).Division;
            if (!permittedDivs || !permittedDivs.length) {
              return 0;
            }
            return clientApi
              .custom('model/Quotation', 'fetchOpenCount', { isInvoice: true });
          },
        },
        sidebarMeta: {
          order: 1,
          icon: 'ion-android-home'
        },
        viewPermission: '',
      });
  }
})();

(function () {
  'use strict';
  /* global marked*/

  angular
    .module('BlurAdmin.pages.arnoDashboard')
    .controller('DashboardCtrl', DashboardCtrl);

  /* @ngInject */
  function DashboardCtrl(
    clientApi, $timeout, $compile, $rootScope, commonUtils, attendanceStates, chosenSharedFilters, eventTypes,
    categories, toastr, viewPermissions, welcomeTitleContent, welcomeTextContent, demandForActionCount,
    divisionShares, eventShareCtx, $state, baModalService, eventCtx, serviceCtx, openServiceAttendeeInterest,
    $translate, availableHHDivs, openHelperHours, openQuotations, openInvoices, $scope, screenSize, $window
  ) {
    var self = this;
    // VARS
    self.welcomeTitleContentText = marked(welcomeTitleContent);
    self.welcomeTextContentText = marked(welcomeTextContent);

    self.divisionShares = divisionShares;
    self.eventShareCtx = eventShareCtx;
    self.attendanceStates = attendanceStates;
    self.chosenSharedFilters = chosenSharedFilters;
    self.eventTypes = eventTypes;
    self.eventCtx = eventCtx;
    self.serviceCtx = serviceCtx;
    self.categories = categories;
    self.openDivisionInvites = [];
    self.availableHHDivs = availableHHDivs;
    self.openHelperHours = openHelperHours;
    self.openQuotations = openQuotations;
    self.openInvoices = openInvoices;
    self.helperHoursPageSize = 5;
    self.attendingEvents = [];
    self.noReactionEvents = [];
    self.UserEmail = $rootScope.ctx.currentUser.eMail;
    self.firstName = $rootScope.ctx.currentUser.firstName;

    self.isMobile = $window.innerWidth < 768; // Bootstrap "xs" breakpoint

    angular.element($window).on('resize', function () {
      $scope.$apply(function () {
        self.isMobile = $window.innerWidth < 768;
      });
    });

    var disableFirstLoad = true;

    self.tableConfigMaterialRequest = {
      Status: false,
    };

    self.demandForActionCount = demandForActionCount;
    self.openServiceAttendeeInterest = openServiceAttendeeInterest;

    self.mediaSizeXs = screenSize.on('lg', function (match) {
      self.mediaSizeXs = match;
    });
    self.openServiceDetails = function (event) {
      $rootScope.openServiceScrollToShift = true;
      $state.go('arno.events.serviceDetail', { serviceId: event.id, ctx: event.SourceDivisionId});
    };

    self.getCalenderEvents = function () {
      if (
        $rootScope.ctx.permissionsTree
        && $rootScope.ctx.permissionsTree.permissions
        && ($rootScope.ctx.permissionsTree.permissions['arno.events.basic.view']|| $rootScope.ctx.permissionsTree.permissions['arno.events.service.view'])
      ) {
        var detailAttributes = [];
        return clientApi
          .custom('model/DivisionMember', 'getDivListForMember', { cMemberId: $rootScope.ctx.currentUser.id }).then(function (divisionMembers) {
            var divIds = divisionMembers.map(function (dm) { return dm.DivisionId; });
            detailAttributes = detailAttributes.concat(['Description', 'LocationName', 'MeetingPlaceName', 'MeetingTime']);
            var options = {
              'attendingState': true,
              'attributes': [
                'id',
                'Subject',
                'StartDate',
                'EndDate',
                'BaseCategory',
                'SourceDivisionId',
                'OrganizerId',
                'Series',
                'Attendance',
                'LocationName',
                'MeetingPlaceName',
                'MeetingTime',
                'JobSite'
              ],
              'categories': [],
              'divisionId': divIds,
              endDate: moment().add(1, 'month'),
              'exactAttendingTypes': [
                'UNSPECIFIED',
                'ACCEPTED',
                'INTERESTED'
              ],
              'hideServiceMeta': false,
              'onlyAttendingState': true,
              'previewDetails': true,
              'showArchived': false,
              'showShifts': -1,
              startDate: moment(),
            };

            return clientApi.custom('model/Event', 'getCalendarEvents', { options: options })
              .then(function (events) {
                var results = events.results.filter(
                  function (result) {
                    return moment(result.EndDate).isAfter(moment());
                  }
                ).map(function (event) {
                  return {
                    id: event.ServiceId || event.id,
                    shiftId: event.ServiceId && event.id,
                    title: event.ServiceSubject ? event.ServiceSubject : event.Subject,
                    metaTitle: event.ServiceSubject ? event.Subject : undefined,
                    remark: event.Remark || undefined,
                    jobSite: event.JobSite || undefined,
                    start: event.StartDate,
                    end:
                      moment(event.StartDate).isSame(event.EndDate, 'day')
                      || moment(event.EndDate).isSame(moment(event.StartDate).add(1, 'day'), 'day') && moment(event.EndDate).hour() < 8
                        ? moment(event.EndDate).format('HH:mm')
                        : event.EndDate,
                    divisionName:
                      divIds.length > 1
                      || event.SourceDivisionId !== divIds[0]
                        ? (_.find(commonUtils.division.divisionTreeData || [], { id: (event.SourceDivisionId).toString() }) || { Name: '' }).Name
                        : undefined,
                    sourceDivisionId: event.SourceDivisionId,
                    color: '#FFF',
                    textColor: '#000',
                    location_name: event.LocationName || undefined,
                    meeting_place_name: event.MeetingPlaceName || undefined,
                    meeting_time:
                      event.MeetingTime
                        ? moment(event.MeetingTime).format('HH:mm')
                        : undefined,
                    categories: (event.BaseCategory || [])
                      .filter(function (cat) {
                        return cat;
                      })
                      .map(function (cat) {
                        return {
                          color: cat.Color,
                          name: (_.find(self.categories, { id: cat.id }) || {}).Name || cat.Name
                        };
                      }),
                    previewDetails: detailAttributes.length ? detailAttributes.reduce(function (accumulator, currentValue) {
                      accumulator[currentValue] = event[currentValue];
                      if (currentValue === 'MeetingTime' && event[currentValue]) {
                        accumulator[currentValue] = moment(event[currentValue]).format('HH:mm');
                      }
                      return accumulator;
                    }, {}) : null,
                    isService: !!event.IsService,
                    isServiceShift: !!event.IsServiceShift,
                    ownEventMember: event.ownEventMember || undefined,
                    shiftRelevantDivisions: event.shiftRelevantDivisions || event.divisionShare,
                    serviceShiftMember: event.serviceShiftMember,
                    attendanceInfo: event.attendanceInfo || event.Attendance,
                    selfAttend: Array.isArray(event.Attendance) && event.Attendance.some(function (attendee) {
                      return attendee.MemberId === $rootScope.ctx.currentUser.id && attendee.Acceptance === true;
                    }),
                    ServiceType: event.ServiceType,
                    flowState: (event.FlowState && _.find(self.flowStepConfig || [], { ident: event.FlowState })) || undefined,
                    canSelfAttend: event.canSelfAttend || false,
                    context: divIds,
                    divisionIntersection: event.divisionIntersection || [],
                  };
                });

                var acceptedResults = results.filter(
                  function (event) {
                    // only accepted / interested events
                    if (
                      (event.isServiceShift || event.isService === false)
                      && event.ownEventMember
                        || event.eventAcceptance
                          || event.serviceShiftMember && event.serviceShiftMember.Acceptance
                          || event.serviceShiftMember && event.serviceShiftMember.Interested
                          || event.selfAttend
                    ) {
                      return event;
                    }
                  }
                );

                var noReactionResults = results.filter(
                  function (event) {
                    // eslint-disable-next-line no-constant-condition
                    if (
                      (event.isServiceShift || event.isService === false)
                      && !event.ownEventMember
                      && !event.eventAcceptance
                      && !event.serviceShiftMember
                      && !event.selfAttend
                      && !(Array.isArray(event.attendanceInfo)
                        && event.attendanceInfo.some(function (att) { return att.MemberId === $rootScope.ctx.currentUser.id; }))
                    ) {
                      return event;
                    }
                  }
                );

                var accepted = _.orderBy(
                  acceptedResults, 'start', 'asc'
                );

                var noReaction = _.orderBy(
                  noReactionResults, 'start', 'asc'
                );

                self.attendingEvents = accepted.slice(0, 3);
                self.noReactionEvents = noReaction.slice(0, 3);
              })
              .catch(function (error) {
                console.error('Error fetching calendar events:', error);
                return [];
              });
          });
      }
    };

    self.hasDivisionInvites = function () {
      clientApi
        .custom('model/Invites', 'getUserDivInvites', {})
        .then(function (inviteList) {
          /* TODO make paging available */
          self.openDivisionInvites = inviteList.rows;

          self.openDivisionInvites = _.filter(self.openDivisionInvites, function (inv) {
            return new Date(inv.expirationDate) > new Date();
          });

          self.openDivisionInvites.map(function (invitation) {
            // ATM: the backend gives a date in not standardized format (e.g. 01/01/1970), so just quick format here and change later in backend
            invitation.expirationDateFormatted = moment(invitation.expirationDate).format('L');

            return invitation;
          });
        });
    };
    self.declineInvite = function (divId) {
      return clientApi
        .custom('model/Invites', 'declineDivInvite', { divisionId: divId })
        .then(function () {
          self.hasDivisionInvites();
          toastr.success($translate.instant('modules.arnoDashboard.board.addRole'), $translate.instant('modules.arnoDashboard.board.declineInvite'));
        });
    };
    self.acceptInvite = function (inviteId) {
      return clientApi
        .custom('model/Invites', 'acceptDivInvite', { inviteId: inviteId })
        .then(function () {
          self.hasDivisionInvites();
          toastr.success($translate.instant('modules.arnoDashboard.board.inviteSuccessAccept'), $translate.instant('modules.arnoDashboard.board.acceptinvite'));
        });
    };
    self.viewPermissions = viewPermissions;

    self.openDossier = function () {
      commonUtils.dossier.open('rootOrg', $rootScope.ctx.currentUser.eMail);
    };
    self.hasDivisionInvites();

    self.loadHelperHours = function (stTableParams) {
      queryWishes = {};
      if (stTableParams) {
        var queryWishes = {
          paging: {
            offset: (stTableParams.pagination.start / stTableParams.pagination.number) * self.helperHoursPageSize,
            limit: self.helperHoursPageSize
          },
          filter: stTableParams.search.predicateObject ? commonUtils.flattenObject(stTableParams.search.predicateObject) : undefined,
          sort: {
            by: stTableParams.sort.predicate,
            reverse: stTableParams.sort.reverse
          }
        };
      }

      queryWishes.onlyUnapproved = true;
      queryWishes.includeOrgEntries = true;
      queryWishes.includeAccount = true;
      var promise = Promise.resolve();
      if (disableFirstLoad) {
        disableFirstLoad = false;
        promise = Promise.resolve(self.openHelperHours);
      } else {
        promise = clientApi
          .custom('model/helperHours', 'fetchHelperHours', {
            divisionId: availableHHDivs,
            queryWishes: {
              paging: {
                offset: 0,
                limit: 2,
              },
              onlyUnapproved: true,
              includeOrgEntries: true,
              includeAccount: true,
            },
            includeActivityAllocationsDivInfo: true
          });
      }
      promise = promise.then(function (res) {
        if (res) {
          self.displayedCollectionHelperHours = JSON.parse(JSON.stringify(res.rows));
          self.totalRows = res.count;
          if (stTableParams) {
            stTableParams.pagination.numberOfPages = Math.ceil(res.count / self.helperHoursPageSize);
            self.showPagerHH = stTableParams.pagination.numberOfPages > 1;
            if (res.count > 0 && res.rows.length === 0) {
              stTableParams.pagination.start = stTableParams.pagination.numberOfPages * self.helperHoursPageSize;
            }
          }
        }
      });

      return promise;
    };

    self.formatDuration = function (minutes) {
      return minutes ? commonUtils.formatMinutesToHourString(minutes) : 0;
    };

    self.approveEntries = function (item, approvalState) {
      return clientApi
        .custom('model/helperHours', 'approveHelperHours', {
          selectedIds: [item.id],
          approvalState: approvalState,
        })
        .then(function () {
          if (approvalState) {
            toastr.success('Helferstunden erfolgreich freigegeben!', 'Helferstunden freigegeben');
          } else {
            toastr.success('Helferstunden erfolgreich abgelehnt!', 'Helferstunden abgelehnt');
          }
          self.loadHelperHours();
        })
        .catch(function () {
          if (approvalState) {
            toastr.error('Helferstunden konnten nicht freigegeben werden, versuche es später noch einmal.', 'Helferstunden nicht freigegeben');
          } else {
            toastr.error('Helferstunden konnten nicht abgelehnt werden, versuche es später noch einmal.', 'Helferstunden nicht freigegeben');
          }
        });
    };
    self.$onInit = function () {
      self.getCalenderEvents();
      self.loadHelperHours();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration')
    .controller('OrganizationEditCtrl', OrganizationEditCtrl);

  /** @ngInject */
  function OrganizationEditCtrl($state, $q, $rootScope, organization, administrators, clientApi, toastr, isDemoOrg, demoAccounts, $translate) {
    var self = this;
    self.organization = organization;
    self.organization.DemoOrg = self.organization.DemoOrg || isDemoOrg;
    self.isDemo = self.organization.DemoOrg;
    self.demoAccounts = demoAccounts;
    self.administrators = administrators;
    self.noStateChange = false;
    self.existingInvoiceExportDomains = (self.organization || {}).AllowedInvoiceMailSuffixes || [];
    self.newDomain = '';

    self.demoAccountTypes = [{
      perm: 'fullControl',
      label: $translate.instant('modules.arnoAdministration.edit.fullControl'),
      amount: 0,
    }, {
      perm: 'orgAdmin',
      label: $translate.instant('modules.arnoAdministration.edit.orgAdmin'),
      amount: 0,
    }, {
      perm: 'divAdmin',
      label: $translate.instant('modules.arnoAdministration.edit.divAdmin'),
      amount: 0,
    }, {
      perm: 'powerUser',
      label: $translate.instant('modules.arnoAdministration.edit.powerUser'),
      amount: 0,
    }, {
      perm: 'member',
      label: $translate.instant('modules.arnoAdministration.edit.member'),
      amount: 0,
    }];

    self.flowOptions = [{
      title: 'Gemischter Flow (Standard)',
      value: 'DEFAULT'
    }, {
      title: 'Arno Flow',
      value: 'ArnoAuth'
    }, {
      title: 'Azure Flow',
      value: 'AzureAuth'
    }];
    self.switcherHints = { on: '', off: '' };
    if (self.isDemo) {
      self.switcherHints = {
        on: 'Accountoptionen können in einer Demo-Organisation nicht geändert werden',
        off: 'Accountoptionen können in einer Demo-Organisation nicht geändert werden'
      }
    }

    if (self.organization.PrimaryFlow) {
      self.primaryLoginFlow = _.find(self.flowOptions, function (flow) {
        return flow.value === self.organization.PrimaryFlow;
      });
    }

    if (self.organization.ArnoAuth === null) {
      self.organization.ArnoAuth = false;
    }
    if (self.organization.AzureAuth === null) {
      self.organization.AzureAuth = false;
    }
    if (self.organization.Offline === null) {
      self.organization.Offline = false;
    }

    self.setNewFlow = function (item) {
      self.organization.PrimaryFlow = item.value;
    }

    self.createAdministrator = function (member) {
      return clientApi
        .post('member/create', member)
        .then(function (result) {
          member.id = result.MemberId;
        })
        .catch(function () {
          toastr.error('Das Mitglied ' + member.FirstName + ' ' + member.LastName + ' konnte nicht erstellt werden: Dieses Mitglied existiert bereits, bitte füge das Mitglied über "Administrator hinzufügen" der Organisation hinzu!', 'Anlegen fehlgeschlagen');
        });
    };

    self.fetchDemoAccounts = function (orgId) {
      return clientApi
        .custom('model/Account', 'getDemoAccounts', {
          memberData: {
            orgId: orgId,
          }
        })
    }

    self.save = function () {
      var orgPromise = $q.resolve();
      var org;
      if (self.organization.id) {
        organization.new = true;
      }

      if (self.existingInvoiceExportDomains) {
        self.organization.AllowedInvoiceMailSuffixes = self.existingInvoiceExportDomains;
      }

      if (self.isDemo) {
        self.organization.demoAccounts = self.demoAccountTypes;
      }

      if (!self.organization.id || self.form.$dirty || self.addSuffixForm.$dirty) {
        if ((!self.organization.AzureAuth || !self.organization.TenantId) && self.organization.PrimaryFlow !== 'DEFAULT') {
          toastr.warning('Ein nicht-standard primärer Loginflow benötigt einen eingerichteten Azure Tenant und aktivierte Azure Authentifizierung!', 'Azure Tenant erforderlich');
          return;
        }
        if (!self.organization.AzureAuth && self.organization.PrimaryFlow === 'AzureAuth') {
          toastr.warning('Authentifizierungsmethode kann nicht deaktiviert werden, da sie als primärer Loginflow ausgewählt wurde.', 'Unzulässige Deaktivierung');
          return;
        }
        if (self.organization.AuthHost && (encodeURIComponent(self.organization.AuthHost) !== self.organization.AuthHost || ~self.organization.AuthHost.indexOf('.'))) {
          toastr.error('Bitte gib eine gültige Subdomain an!', 'Ungültige Subdomain');
          return;
        }
        orgPromise = clientApi.custom('model/Organization', 'createOrUpdateOrganization', { orgData: self.organization });
      }

      return orgPromise.then(function (orgData) {
        org = orgData;
        var promises = [];
        if (!isDemoOrg) {
          self.organization.id = self.organization.id || orgData.id || orgData;
          _.filter(self.administrators, function (m) {
            return !m.id
          }).forEach(function (m) {
            m.OrganizationId = self.organization.id;
            m.CreatorId = $rootScope.ctx.currentUser.id;
            promises.push(self.createAdministrator(m))
          });
        }
        return Promise
          .all(promises)
          .then(function () {
            if (!isDemoOrg) {
              var members = self.administrators.map(function (m) {
                return m.id
              });
              return clientApi.custom('model/Organization', 'setAdministrators', { orgId: self.organization.id, memberIds: members });
            }
          })
          .then(function () {
            toastr.success('Änderungen wurden erfolgreich gespeichert.', 'Organisation gespeichert');
            if (self.noStateChange) {
              if (org && org.id) {
                $state.go('arno.arnoAdministration.editOrganization', { organizationId: org.id, isDemoOrg: isDemoOrg }, { reload: true });
              } else {
                $state.reload();
              }
            } else {
              $state.go('^.overview', { organization: self.organization }, { reload: true });
            }
          });
      })
        .then(function() {
          if (!self.organization.AuthHost) {
            return clientApi.custom('model/Organization', 'removeAuthHost', {});
          } else {
            self.organization.AuthHost = self.organization.AuthHost.toLocaleLowerCase();
            return clientApi
              .custom('model/Organization', 'authHostAvailable', { host: self.organization.AuthHost, orgId: self.organization.id })
              .then(function (result) {
                if (!result) {
                  toastr.error('Diese Subdomain is bereits in Benutzung!', 'Ungültige Subdomain');
                  return null;
                }
                return clientApi
                  .custom('model/Organization', 'setAuthHost', {
                    authHost: self.organization.AuthHost,
                    orgId: self.organization.id,
                  })
              });
          }
        });
    };

    self.groupByFirstName = function (member) {
      return member.initials.charAt(0);
    };

    self.isInAdministratorsList = function (email) {
      return !_.find(self.administrators, function (m) {
        return email === m.Account.EMail
      });
    };

    self.addAdministrator = function () {
      self.selectedMember.selected = true;
      self.administrators.push(self.selectedMember);
      self.selectedMember = null;
    };

    self.removeAdministrator = function (member) {
      member.selected = false;
      self.administrators = _.filter(self.administrators, function (m) {
        return (m.Account.EMail !== member.Account.EMail);
      });
    };

    self.addInvoiceExportDomain = function () {
      self.addSuffixForm.$dirty = true;
      self.existingInvoiceExportDomains.push(self.newDomain);
      self.newDomain = '';
    };

    self.removeInvoiceExportDomain = function (domain) {
      self.addSuffixForm.$dirty = true;
      self.existingInvoiceExportDomains = _.filter(self.existingInvoiceExportDomains, function (d) {
        return d !== domain;
      });
    };

    self.searchMembers = function (name) {
      return clientApi
        .custom('model/Member', 'findByOrganizationId', { searchName: name, queryWishes: { withAnyTerms: true } })
        .then(function (result) {
          self.members = result;
          self.members.forEach(function (m) {
            if (_.find(self.administrators, { id: m.id })) {
              m.selected = true;
            }
          });
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration')
    .controller('OrganizationManageCtrl', OrganizationManageCtrl);

  /** @ngInject */
  function OrganizationManageCtrl($uibModal, $stateParams, toastr, organizations, demoOrganizations, clientApi) {
    var self = this;
    self.organizations = organizations;
    self.demoOrganizations = demoOrganizations;

    if ($stateParams.organization) {
      if ($stateParams.organization.new) {
        toastr.success('Die Organisation ' + $stateParams.organization.Name + ' wurde erfolgreich erstellt.', 'Organisation erstellt');
      } else {
        toastr.success('Die Organisation ' + $stateParams.organization.Name + ' wurde aktualisiert.', 'Organisation aktualisiert');
      }
    }

    self.runCalc = function() {
      return clientApi.emit('personnel/calculateQualificationActivities', {})
        .then(function() {
          toastr.success('Die Berechnung der Daten wurde gestartet.', 'Berechnung gestartet');
        })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.arnoAdministration')
    .controller('AdministratorsCtrl', AdministratorsCtrl);

  /** @ngInject */
  function AdministratorsCtrl($q, $rootScope, clientApi, toastr, administrators) {
    var self = this;
    var _tpl = {
      FirstName: null,
      LastName: null,
      Account: {
        EMail: null,
      },
    };

    self.administrators = administrators;

    self.checkFirstName = function (data) {
      return (data ? true : 'Bitte Vornamen eingeben!');
    };

    self.checkLastName = function (data) {
      return (data ? true : 'Bitte Nachnamen eingeben!');
    };

    self.checkMail = function (data) {
      var msg = 'Bitte gültige E-Mail Adresse eingeben!';
      if (!data) {
        return msg;
      }
      if (_.find(self.administrators, { Account: { EMail: data } })) {
        return 'Diese E-Mail Adresse is bereits vergeben.';
      }
      return clientApi
        .custom('model/Account', 'validateEMail', { eMail: data })
        .then(function (result) {
          return (result ? true : msg);
        })
    };

    self.findOrCreateAdministrator = function (member) {
      return clientApi
        .post('member/create', member)
        .then(function (result) {
          return result.MemberId;
        })
        .catch(function (err) {
          if (err.message === 'Validation error') {
            // member already exists, so ignore this error
            return clientApi
              .custom('model/Member', 'findByEMail', { eMail: member.Account.EMail })
              .then(function (result) {
                return (result && result.length ? result[0].id : null);
              })
          }
          toastr.error('Das Mitglied ' + member.FirstName + ' ' + member.LastName + ' konnte nicht erstellt werden: ' + err, 'Fehler');
          throw new Error(err);
        });
    };

    self.onCancel = function (member) {
      self.isAdding = false;
      if (!member.id) {
        var idx = _.findIndex(self.administrators, _tpl);
        idx > -1 && self.administrators.splice(idx, 1);
      }
    };

    self.saveAdministrator = function (member, data) {
      if (member.id) {
        // just update the member and exit
        return clientApi
          .custom('model/Member', 'superEditMember', {
            memberData: {
              id: member.id,
              FirstName: data.FirstName,
              LastName: data.LastName,
            }
          })
          .then(function () {
            toastr.success('Das Mitglied ' + data.FirstName + ' ' + data.LastName + ' wurde gespeichert.');
          })
          .catch(function (err) {
            toastr.error('Das Mitglied ' + data.FirstName + ' ' + data.LastName + ' konnte nicht aktualisiert werden:' + err, 'Fehler');
          });
      }

      return self
        .findOrCreateAdministrator({
          FirstName: data.FirstName,
          LastName: data.LastName,
          Account: {
            EMail: data.EMail,
          },
          OrganizationId: 1,
          CreatorId: $rootScope.ctx.currentUser.id,
        })
        .then(function (id) {
          if (!id) {
            return toastr.error('Es ist ein unbekannter Fehler beim Zuweisen/Erstellen des Mitglieds aufgetreten.', 'Hinzufügen nicht möglich');
          }
          member.id = id;
          member.Account.EMail = data.EMail;
          return clientApi.custom('model/Member', 'addSuperAdministrator', { cMemberId: id });
        })
        .then(function () {
          toastr.success('Das Mitglied ' + data.FirstName + ' ' + data.LastName + ' wurde gespeichert.');
        })
        .finally(function () {
          self.isAdding = false;
        });
    };

    self.removeAdministrator = function (member) {
      return clientApi
        .custom('model/Member', 'removeSuperAdministrator', { memId: member.id })
        .then(function () {
          self.administrators = _.filter(self.administrators, function (m) {
            return m.id !== member.id;
          });
        })
        .then(function () {
          toastr.success('Das Mitglied ' + member.FirstName + ' ' + member.LastName + ' wurde gelöscht.');
        })
        .catch(function (err) {
          toastr.error('Das Mitglied ' + member.FirstName + ' ' + member.LastName + ' konnte nicht gelöscht werden: ' + err);
        });
    };

    self.addAdministrator = function () {
      self.isAdding = true;
      self.inserted = _.cloneDeep(_tpl);
      self.administrators.unshift(self.inserted);
    }
  }
})();

(function () {
  'use strict';
  /* global marked*/

  // CONSTS
  var APP_DEFAULT_LOCALE = 'de';

  // GLOBAL INITS: change this or make this configurable, if ARNO later should actively support i18n
  moment.locale(APP_DEFAULT_LOCALE);

  // GLOBAL settings for marked.js
  var renderer = new marked.Renderer();
  var linkRenderer = renderer.link;
  renderer.link = function (href, title, text) {
    var localLink =
      href.startsWith(location.protocol + '//' + location.hostname) ||
      href.startsWith('/');
    var html = linkRenderer.call(renderer, href, title, text);
    return localLink
      ? html
      : html.replace(
          /^<a /,
          '<a target="_blank" rel="noreferrer noopener nofollow" '
        );
  };

  marked.setOptions({
    renderer: renderer,
    pedantic: false,
    gfm: true,
    tables: true,
    breaks: false,
    sanitize: true,
    smartLists: true,
    smartypants: false,
    xhtml: false,
  });

  /**
   * This module provides all the FE Sources we need to display the magic of ARNO
   * @module App
   */
  angular
    .module('BlurAdmin', [
      'pascalprecht.translate',
      'ngAnimate',
      'ui.bootstrap',
      'ui.sortable',
      'ui.router',
      'ui.validate',
      'angular-markdown-editor',
      'ngTouch',
      'ngTimeline',
      'toastr',
      'smart-table',
      'xeditable',
      'ui.slimscroll',
      'ngJsTree',
      'ui.tree',
      'angular-progress-button-styles',
      'chart.js',
      'SmoothScrollbar',

      'BlurAdmin.theme',
      'BlurAdmin.pages',

      'ArnoDash',
      'matchMedia',
      'angularValidator',
      'ui.select',
      'ui.router.tabs',
      'gm.datepickerMultiSelect',
      'ngProgress',
      'ngMessages',
    ])
    .constant('APP_DEFAULT_LOCALE', APP_DEFAULT_LOCALE)
    .constant('APP_NG_LOCALES_MAPPING', {
      // REMARK: we need this to be able to map the lang-settings between angularjs, $translate
      // and bower angularjs-locales-packages files (see: https://github.com/angular/bower-angular-i18n)
      de: 'de-de',
      en: 'en-us',
    })
    .factory(
      'dictionaryLoader',
      function (APP_DEFAULT_LOCALE, clientApi, $rootScope) {
        return function (options) {
          return clientApi
            .emit('i18n/getDictionary', {
              lang:
                options.key ||
                $rootScope.ctx.currentUser.prefLanguage ||
                APP_DEFAULT_LOCALE,
            })
            .catch(function () {
              return options.key;
            });
        };
      }
    );

  var gToastrConfig;
  angular
    .module('ArnoDash', [
      'tmh.dynamicLocale', // see: https://github.com/lgalfaso/angular-dynamic-locale/blob/master/README.md#user-content-usage
    ])
    .constant('toastrCustomConfig', {
      autoDismiss: false,
      positionClass: 'toast-bottom-right',
      type: 'success',
      timeOut: 5000,
      extendedTimeOut: 2000,
      allowHtml: false, // don't allow, we call toasts with user data that could contain xss
      closeButton: false,
      tapToDismiss: true,
      progressBar: true,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
    })
    .run(function ($rootScope, $injector, $window, progressBar) {
      var editableOptions = $injector.get('editableOptions');
      var $transitions = $injector.get('$transitions');
      var permissions = $injector.get('permissions');
      var $uiRouter = $injector.get('$uiRouter');
      var commonUtils = $injector.get('commonUtils');
      var toastr = $injector.get('toastr');
      var $translate = $injector.get('$translate');
      var clientApi = $injector.get('clientApi');

      // set angular xeditable theme
      editableOptions.theme = 'bs3';

      // handle last route on session timeout or login
      $rootScope.$on('$locationChangeSuccess', function (e, next) {
        if ($rootScope.ctx && $rootScope.ctx.currentUser) {
          localStorage.setItem('lastPath', next);
          localStorage.setItem('lastVisit', new Date().getTime());
        }
      });

      // handle state permissions
      // if page has already been initialized, redirect actually requesting data from server,
      // if not, wait for initialization and check then
      var transitionHookFn = function (trans) {
        var targetState = trans.targetState();
        var permitted = permissions.isPermittedAnywhere(targetState);
        if (!permitted) {
          return trans.router.stateService.target('arno.forbidden', null, {
            location: false,
            notify: false,
          });
        }
        var initDataOptions = {};
        var chosenOrganization = parseInt(
          commonUtils.getCookie('targetOrganization'),
          10
        );
        if (chosenOrganization) {
          initDataOptions.organization = chosenOrganization;
        } else {
          initDataOptions.organization = $rootScope.ctx.organization.current.id;
        }
        if (
          !$rootScope.ctx.currentUser.latestTermsAccepted ||
          !$rootScope.ctx.currentUser.privacyTermsDeliveredDateTime
        ) {
          return trans.router.stateService.target('arno.terms', null, {
            location: false,
            notify: false,
          });
        }
      };

      $rootScope.beforeTransitionHookList = [];

      $transitions.onBefore(
        {
          to: function (state) {
            // fires if initial data is already resolved
            // for accordion reopen
            try {
              var reopenPreference = commonUtils.preference.object.get(
                'accordion_reopen_last',
                {}
              );
              if (
                reopenPreference.path &&
                Array.isArray(reopenPreference.path)
              ) {
                if (!~reopenPreference.path.indexOf(state.name)) {
                  commonUtils.preference.object.set(
                    'accordion_reopen_last',
                    {}
                  );
                }
              }
            } catch (e) {
              // hm k
            }

            return (
              $rootScope.ctx &&
              state.name !== 'arno.forbidden' &&
              state.name !== 'arno.terms'
            );
          },
        },
        transitionHookFn
      );

      $transitions.onEnter({}, function (trans) {
        var targetUrl = trans.router.urlService.path();

        if (
          !window.redirectChecked &&
          $rootScope.ctx &&
          $rootScope.ctx.currentUser &&
          $rootScope.ctx.currentUser.eMail &&
          $rootScope.ctx.hostAddress
        ) {
          clientApi
            .checkRedirectMember($rootScope.ctx.currentUser.eMail)
            .then(function (redirect) {
              if (redirect) {
                window.location.href =
                  '/redirect.html?target=' + encodeURIComponent(targetUrl);
              } else {
                window.redirectChecked = true;
              }
              return false;
            });
        }
      });

      $transitions.onFinish(
        {
          to: function (state) {
            // relevant only for the first page load (once)
            return (
              !$rootScope.ctx &&
              state.name !== 'arno.forbidden' &&
              state.name !== 'arno.terms'
            );
          },
        },
        transitionHookFn
      );

      $transitions.onError({}, function (transition) {
        var transitionErr = transition.error();
        if (~transitionErr.toString().indexOf('transition has been aborted')) {
          if (transition.abortedDueTo === 'STATE_CHANGE_PROMPT') {
            progressBar.complete();
          } else {
            progressBar.error();
          }
          return;
        }
        if (~transitionErr.toString().indexOf('transition was ignored')) {
          // needed because of our button disable progress bar
          // we start it when the route from route is equal to the to route, but we will never hit success
          // when the user clicked on an already active route through ui-sref links rather than state.reload() navigation
          // so we stop the progressbar here when an transition was ignored
          progressBar.complete();
          return;
        }
        if (
          ~transitionErr.toString().indexOf('transition has been superseded')
        ) {
          progressBar.complete();
        } else {
          console.error(transitionErr);
          progressBar.error();
        }
      });

      $uiRouter.stateService.defaultErrorHandler(function () {
        // Do not log transitionTo errors
      });

      $rootScope.transitionHistory = [];
      var pushToHistory = function (location) {
        if (location) {
          if ($rootScope.transitionHistory.length === 25) {
            $rootScope.transitionHistory.shift();
            1;
          }
          $rootScope.transitionHistory.push(location);
        }
      };
      $rootScope.transitionHistoryFetchState = function (pLikes, fallback) {
        var length = $rootScope.transitionHistory.length;
        var likes = (Array.isArray(pLikes) ? pLikes : [pLikes]).reverse();
        while (length--) {
          var likesLength = likes.length;
          while (likesLength--) {
            if (
              ~$rootScope.transitionHistory[length].indexOf(likes[likesLength])
            ) {
              return $rootScope.transitionHistory[length];
            }
          }
        }
        return fallback;
      };

      // add dynamic page titel
      // save history
      $transitions.onSuccess({}, function (transition) {
        pushToHistory(transition.to().name);
        var title = transition.to().title;
        var isDynamic = false;
        if (title && typeof title === 'function') {
          title = title.call(this, transition);
          isDynamic = true;
        }
        title = $translate.instant(
          (title && title.title) || title,
          title && title.params ? title.params : {}
        );
        if (isDynamic) {
          transition.to().dynamicTitle = title;
        }
        $window.document.title = 'ARNO' + (title ? ' - ' + title : '');
      });

      $transitions.onSuccess(
        {
          to: function (state) {
            // move to anywhere else than back to our personnel list or any dossier subtab
            return (
              !state.name.startsWith('arno.personnel.dossier') &&
              state.name !== 'arno.personnel.personnelList'
            );
          },
        },
        function () {
          // clear any personnel list filters we may have saved
          localStorage.removeItem('personnelListFilter');
        }
      );

      $transitions.onSuccess(
        {
          from: function (state) {
            // move from material list tabs...
            return !state.name.startsWith('arno.material');
          },
          to: function (state) {
            // ... to anywhere else than a detail view of materials
            return (
              state.name.startsWith('arno.material.administration') ||
              !state.name.startsWith('arno.material')
            );
          },
        },
        function () {
          // clear any material list filters we may have saved
          delete $rootScope.fromMaterialOverview;
          localStorage.removeItem('materialListFilter');
        }
      );

      $transitions.onBefore(
        {
          from: 'arno.material.administration.overview',
          to: function (state) {
            return (
              !state.name.startsWith('arno.material.administration') &&
              state.name.startsWith('arno.material')
            );
          },
        },
        function (transition) {
          $rootScope.fromMaterialOverview = transition.from().name;
        }
      );

      $transitions.onSuccess(
        {
          from: 'arno.administration.design',
          to: function (state) {
            return !state.name.startsWith('arno.administration.design');
          },
        },
        function () {
          commonUtils.setPortalPrimaryColor($rootScope.portalColor);
        }
      );

      $transitions.onSuccess(
        {
          from: function (state) {
            // move from training main list...
            return state.name.startsWith('arno.personnel.dossier.trainings');
          },
          to: function (state) {
            // ... to anywhere else than another state within the training sector
            return !state.name.startsWith('arno.personnel.dossier.trainings');
          },
        },
        function () {
          // clear any training list filters we may have saved
          localStorage.removeItem('trainingListFilter');
        }
      );

      $transitions.onBefore(
        {
          from: 'arno.personnel.personnelList',
          to: function (state) {
            return state.name.startsWith('arno.personnel.dossier');
          },
        },
        function () {
          $rootScope.backToPersonnelList = true;
        }
      );

      $transitions.onSuccess(
        {
          from: function (state) {
            return state.name.startsWith('arno.personnel.dossier');
          },
          to: function (state) {
            return !state.name.startsWith('arno.personnel.dossier');
          },
        },
        function () {
          delete $rootScope.backToPersonnelList;
        }
      );

      $transitions.onBefore({}, function (transition) {
        var opts = transition.options();

        // disable buttons on state.reload()
        if (opts.reload) {
          progressBar.start(); // will use implicit button disable in progress bar
        }
      });

      $transitions.onSuccess({}, function (transition) {
        var opts = transition.options();

        // disable buttons on state.reload()
        if (opts.reload) {
          progressBar.complete(); // will use implicit button disable in progress bar
        }
      });

      $transitions.onBefore({}, function (transition) {
        var opts = transition.options();
        $rootScope.beforeTransitionHookList.forEach(
          function (beforeTransitionHook) {
            beforeTransitionHook(opts, transition);
          }
        );
        $rootScope.beforeTransitionHookList = [];
      });

      toastr.preventDuplicate = function (toastFunc) {
        if (!toastFunc) {
          return;
        }
        if (!gToastrConfig) {
          return toastFunc();
        }
        gToastrConfig.preventOpenDuplicates = true;
        var toastFuncReturn = toastFunc();
        gToastrConfig.preventOpenDuplicates = false;
        return toastFuncReturn;
      };
    })
    .config(
      function (
        $httpProvider,
        toastrConfig,
        toastrCustomConfig,
        stConfig,
        ChartJsProvider,
        $provide,
        tmhDynamicLocaleProvider,
        $translateProvider
      ) {
        // angularjs dynamic locales loader config. we need the mapping because we have a diff. file-structure caused by the bower-package
        // for the angularjs-locale files
        tmhDynamicLocaleProvider.localeLocationPattern(
          '/locale/angular-locale_{{locale}}/index.js'
        );

        $translateProvider.useLoader('dictionaryLoader');

        // smart-table defaults
        stConfig.sort.delay = 100;
        stConfig.pipe.delay = 200;

        // showdown markdown converter
        showdown.setOption('headerLevelStart', 3);

        // $httpProvider defaults
        $httpProvider.defaults.headers.common = {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'If-Modified-Since': '0',
        };

        $httpProvider.interceptors.push(function ($q) {
          return {
            responseError: function (rejection) {
              if (rejection.status === 401) {
                if (window.ahAuthInfos && window.ahAuthInfos.authInfos) {
                  var authInfoPrimaryKey = Object.keys(
                    window.ahAuthInfos.authInfos
                  );
                  if (authInfoPrimaryKey && authInfoPrimaryKey.length) {
                    authInfoPrimaryKey = authInfoPrimaryKey[0];
                    if (
                      window.ahAuthInfos.authInfos[authInfoPrimaryKey]
                        .customLogin
                    ) {
                      window.ahAuthInfos.authInfos[
                        authInfoPrimaryKey
                      ].customLogin();
                    }
                  }
                } else {
                  return (window.location = '/auth.html?code=4');
                }
              } else {
                return $q.reject(rejection);
              }
            },
          };
        });

        angular.extend(toastrConfig, toastrCustomConfig);
        gToastrConfig = toastrConfig;

        // Configure all charts
        ChartJsProvider.setOptions({
          chartColors: ['#FE7191', '#4BC0C0', '#FFCE56', '#36A2EB'],
          animation: {
            duration: 1500,
          },
        });

        var FORMATS = {
          datetime: 'MMM D, YYYY, h:mm:ss a',
          millisecond: 'h:mm:ss.SSS a',
          second: 'h:mm:ss a',
          minute: 'h:mm a',
          hour: 'hA',
          day: 'MMM D',
          week: 'll',
          month: 'MMM YYYY',
          quarter: '[Q]Q - YYYY',
          year: 'YYYY',
        };

        ChartJsProvider.$get().Chart._adapters._date.override({
          _id: 'moment',

          formats: function () {
            return FORMATS;
          },

          parse: function (value, format) {
            if (typeof value === 'string' && typeof format === 'string') {
              value = moment(value, format);
            } else if (!(value instanceof moment)) {
              value = moment(value);
            }
            return value.isValid() ? value.valueOf() : null;
          },

          format: function (time, format) {
            return moment(time).format(format);
          },

          add: function (time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
          },

          diff: function (max, min, unit) {
            return moment.duration(moment(max).diff(moment(min))).as(unit);
          },

          startOf: function (time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') {
              return time.isoWeekday(weekday).valueOf();
            }
            return time.startOf(unit).valueOf();
          },

          endOf: function (time, unit) {
            return moment(time).endOf(unit).valueOf();
          },

          _create: function (time) {
            return moment(time);
          },
        });

        $provide.decorator('$exceptionHandler', [
          '$delegate',
          function ($delegate) {
            return function (exception, cause) {
              var causeStr = exception.toString();
              if (~causeStr.indexOf('transition has been superseded')) {
                return; //do nothing on superseeded transition errors
              }
              if (~causeStr.indexOf('Possibly unhandled rejection')) {
                return; //do nothing on "missing" catches and modal dismisses
              }
              if (
                ~causeStr.indexOf('Token \'{\' invalid key') &&
                ~causeStr.indexOf('isValidDate')
              ) {
                return; //do nothing on "missing" catches and modal dismisses
              }
              $delegate(exception, cause);
            };
          },
        ]);

        $provide.decorator('$uibModal', [
          '$delegate',
          '$rootScope',
          function $uibModalDecorator($delegate, $rootScope) {
            var uibModalOpen = $delegate.open;
            var currentlyOpen = {};

            var simpleFakePromise = function () {};
            simpleFakePromise.prototype.then = function () {
              return this;
            };
            simpleFakePromise.prototype.catch =
              simpleFakePromise.prototype.then;
            simpleFakePromise.prototype.finally =
              simpleFakePromise.prototype.then;

            $delegate.open = function decoratedModalOpen(options) {
              var openKey =
                options && (options.templateUrl || options.controller);
              if (openKey && !options.allowDoubleOpening) {
                if (currentlyOpen[openKey]) {
                  // do nothing if double opening isn't allowed and modal is currently open
                  return {
                    result: new simpleFakePromise(), // it is okay if this leads to a type error; fe won't get harmed by it and function won't be executed
                    // fake promise just prevents type errors in console
                  };
                }
                currentlyOpen[openKey] = true;
              }

              if (options.size === 'fullscreen') {
                options.backdrop = false;
                options.animation = false;
              }

              var modalInstance = uibModalOpen(options);

              var closeOnTransition;
              if (options.size === 'fullscreen') {
                closeOnTransition = function () {
                  modalInstance.dismiss(
                    'FULLSCREEN_MODAL_CLOSED_DUE_ROUTE_TRANSITION'
                  );
                };
                $rootScope.beforeTransitionHookList.push(closeOnTransition);
              }

              var handleInstanceResult = function () {
                delete currentlyOpen[openKey];

                if (closeOnTransition) {
                  var bthlIndex =
                    $rootScope.beforeTransitionHookList.indexOf(
                      closeOnTransition
                    );
                  if (bthlIndex > -1) {
                    $rootScope.beforeTransitionHookList.splice(bthlIndex, 1);
                  }
                }
              };

              modalInstance.result
                .catch(function (e) {
                  handleInstanceResult();
                  throw e;
                })
                .then(function (result) {
                  handleInstanceResult();
                  return result;
                });
              return modalInstance;
            };

            return $delegate;
          },
        ]);

        $provide.decorator('uibAccordionGroupDirective', [
          '$delegate',
          'commonUtils',
          '$location',
          '$anchorScroll',
          '$state',
          function ($delegate, commonUtils, $location, $anchorScroll, $state) {
            var originalLinkFn = $delegate[0].link;
            angular.extend($delegate[0].scope, {
              preOpen: '=?',
            });
            $delegate[0].compile = function () {
              return function newLinkFn(scope, elem, attr) {
                originalLinkFn.apply($delegate[0], arguments);

                scope.getAccordionReopenPreference = function () {
                  try {
                    var reopenPreference = commonUtils.preference.object.get(
                      'accordion_reopen_last',
                      {}
                    );
                    if (
                      Object.prototype.toString.call(reopenPreference) !==
                      '[object Object]'
                    ) {
                      reopenPreference = {};
                    }
                    return reopenPreference;
                  } catch (e) {
                    return {};
                  }
                };

                var newId = commonUtils.hashCode(
                  attr.reopenLast + '-' + attr.reopenKey
                );
                if (attr.reopenLast && attr.reopenKey) {
                  $(elem).attr('id', newId);
                }

                var originalToggleOpen = scope.toggleOpen;
                var toggleOpen = function () {
                  originalToggleOpen();
                  if (attr.reopenLast && attr.reopenKey) {
                    var reopenPreference = scope.getAccordionReopenPreference();
                    reopenPreference[attr.reopenLast] =
                      attr.reopenKey.toString();
                    reopenPreference.path = reopenPreference.path || [];
                    reopenPreference.path.push($state.current.name);
                    if (attr.reopenRetainFor) {
                      var retainFor = attr.reopenRetainFor;
                      try {
                        retainFor = JSON.parse(retainFor);
                      } catch (e) {
                        // hm k
                      }
                      if (!Array.isArray(retainFor)) {
                        retainFor = [retainFor];
                      }
                      reopenPreference.path =
                        reopenPreference.path.concat(retainFor);
                    }
                    reopenPreference.path = _.uniq(reopenPreference.path);
                    commonUtils.preference.object.set(
                      'accordion_reopen_last',
                      reopenPreference
                    );
                  }
                };

                scope.toggleOpen = function () {
                  if (scope.preOpen) {
                    scope.preOpen(function () {
                      scope.$evalAsync(function () {
                        toggleOpen();
                      });
                    });
                    return;
                  }
                  toggleOpen();
                };

                var reopenPreference = scope.getAccordionReopenPreference();
                if (
                  (attr.reopenKey || '').toString() ===
                  reopenPreference[attr.reopenLast]
                ) {
                  scope.$evalAsync(function () {
                    scope.toggleOpen();

                    if ($location.hash() !== newId) {
                      $location.hash(newId);
                    } else {
                      $anchorScroll();
                    }
                  });
                }
              };
            };
            delete $delegate[0].link;
            return $delegate;
          },
        ]);

        var jQueryDispatch = jQuery.event.dispatch;
        jQuery.event.dispatch = function () {
          try {
            return jQueryDispatch.apply(this, arguments);
          } catch (e) {
            // last resort workaround for currencyInput/maskMoney bug when using suffixes; bug will have no detrimental effect on the jQuery plugin
            // itself, but will log error messages on some input events
            if (
              e &&
              e.message === 'Invalid array length' &&
              e.stack &&
              ~e.stack.indexOf('jquery.maskMoney.min.js')
            ) {
              return;
            }
            throw e;
          }
        };
      }
    );
})();

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .factory('validationUtils', function ($http, $q, clientApi) {
      return {
        validateEMail: function(address) {
          return $q(function(resolve, reject) {
            clientApi
              .emit('validate/email', { address: address })
              .then(function(valid) {
                return (valid ? resolve() : reject());
              })
          });
        },

        validateIBAN: function(iban) {
          return $q(function(resolve, reject) {
            clientApi
              .emit('validate/iban', { iban: iban })
              .then(function(valid) {
                if (!valid) {
                  return reject();
                }
                $http
                  .get('https://openiban.com/validate/' + iban + '?getBIC=true', {
                    headers: {
                      // reset cache control headers because service does not support CORS on OPTIONS requests
                      'Cache-Control': undefined,
                      'If-Modified-Since': undefined,
                    }
                  })
                  .then(function(resp) {
                    return resolve(resp.data.bankData);
                  })
                  .catch(resolve); // also resolve if we get an invalid or no answer fromthe external service
              });
          });
        },

        validateBIC: function(bic) {
          return $q(function(resolve, reject) {
            clientApi
              .emit('validate/bic', { bic: bic })
              .then(function(valid) {
                return (valid ? resolve() : reject());
              });
          });
        },

        // FRONTEND methods, for validation e.g. in field-inputs
        checkRequiredData: function (data) {
          return !!(data && Object.keys(data).length);
        },

        hasError: function(form, formFieldsNames, errorTypes, considerTouched) {
          var hasError;
          var normalizedErrorTypes = errorTypes;

          if (!Array.isArray(errorTypes)) {
            normalizedErrorTypes = [errorTypes];
          }

          if (typeof formFieldsNames === 'string') {
            var hasErrorKey = normalizedErrorTypes.some(function(k) {return form[formFieldsNames] && (k in form[formFieldsNames].$error) })

            if (form[formFieldsNames] && ((considerTouched && form[formFieldsNames].$touched) || form.$submitted) && hasErrorKey) {
              return form[formFieldsNames].$error;
            }
          }
          else if (Array.isArray(formFieldsNames)) {
            _.forEach(formFieldsNames, function(field) {
              var hasErrorKey = normalizedErrorTypes.some(function(k) {return (form[field] && (k in form[field].$error)) || k === undefined; })

              if (form[field] && ((considerTouched && form[field].$touched) || form.$submitted) && hasErrorKey && form[field].$error) {
                hasError = form[field].$error;
              }
            });
          }

          return hasError;
        },

        validationScroll: function(scope, form) {
          setTimeout(function() {
            scope.$evalAsync(function() {
              if (form && form.$$element && form.$$element.find) {
                var firstErrorNode = form.$$element.find('.has-error').get(0);
                var formGroupOfFirstErrorNode;
                if (firstErrorNode) {
                  formGroupOfFirstErrorNode = jQuery(firstErrorNode).closest('.form-group').get(0);
                }
                var scrollToElem = formGroupOfFirstErrorNode || firstErrorNode;
                if (scrollToElem && scrollToElem.scrollIntoView) {
                  scrollToElem.scrollIntoView();
                }
              }
            });
          }, 0);
        },

        checkPhoneNumber: function(phoneNumber, required) {
          if (typeof phoneNumber === 'string' && (required === true || phoneNumber.trim() !== '')) {
            return !!phoneNumber.match(/^(\(?([\d \-\)\–\+\/\(]+){6,}\)?([ .\-–\/]?)([\d]+))$/);
          }

          return true;
        },

        checkEmail: function(email, required) {
          if (typeof email === 'string' && (required === true || email.trim() !== '')) {
            return email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
          }

          return true;
        },

        checkZipCode: function(zipCode) {
          if (typeof zipCode === 'string') {
            return !!zipCode.match(/^[0-9]{5}$/);
          }

          return false;
        },

        checkCity: function(city) {
          if (typeof city === 'string') {
            return !!city.match(/^[ A-Za-z0-9äöüÄÖÜß\(\)_./\\&+-]*$/);
          }

          return false;
        },

        isValidHouseNumber: function(houseNumber) {
          if (typeof houseNumber === 'string' && houseNumber.trim() !== '' ) {
            return houseNumber.match(/^(\d+(?: ?- ?\d+)?[a-zA-Z]?)$/gi);
          }

          return true;
        },

        // NOTE: convinient validator for  models, which used the mixin "PriceUnitBase".
        // Returns true, if valid, false otherwise
        checkRequiredPricesSet: function(priceItem) {
          return (priceItem || {}).ExternalPricePerHour !== null && priceItem.ExternalPricePerHour >= 0
            || (priceItem || {}).ExternalPricePerDay !== null && priceItem.ExternalPricePerDay >= 0
            || (priceItem || {}).ExternalPricePerCount !== null && priceItem.ExternalPricePerCount >= 0;
        },

        hasValidPriceDefinition:  function(priceItem) {
          return priceItem
            && (priceItem.ExternalPricePerHour !== null && priceItem.ExternalPricePerHour >= 0
              || priceItem.ExternalPricePerDay !== null && priceItem.ExternalPricePerDay >= 0
              || priceItem.ExternalPricePerCount !== null && priceItem.ExternalPricePerCount >= 0
              || priceItem.InternalPricePerHour !== null && priceItem.InternalPricePerHour >= 0
              || priceItem.InternalPricePerDay !== null && priceItem.InternalPricePerDay >= 0
              || priceItem.InternalPricePerCount !== null && priceItem.InternalPricePerCount >= 0
            );
        }
      }
    });
})();

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('uxUtils', function () {
      var self = {
        getFullCSpan: function (tblConf) {
          var cSpan = 10;

          if (tblConf) {
            Object.keys(tblConf).forEach(function (prop) {
              if (tblConf[prop]) {
                cSpan++;
              }
            });
          }
          return cSpan;
        },
      }

      return self;
    });
})();

(function () {

  function flattenObject(data, preserveArray) {
    var result = {};

    function recurse(cur, prop) {
      if (Object(cur) !== cur || (preserveArray && Array.isArray(cur))) {
        result[prop] = cur;
      } else if (Array.isArray(cur)) {
        for (var i = 0, l = cur.length; i < l; i++) {
          recurse(cur[i], prop + '[' + i + ']');
        }
        if (l == 0) {
          result[prop] = [];
        }
      } else {
        var isEmpty = true;
        for (var p in cur) {
          isEmpty = false;
          recurse(cur[p], prop ? prop + '.' + p : p);
        }
        if (isEmpty && prop) {
          result[prop] = {};
        }
      }
    }

    recurse(data, '');
    return result;
  }

  /** @ngInject */
  angular.module('ArnoDash')
    .service('commonUtils', function (
      $rootScope, $state, $uibModal, clientApi, permissions, toastr, baModalService, $translate
    ) {
      var self = {
        copyToClipboard: function(content, fireNoToasters) {
          if(!navigator.clipboard || !navigator.clipboard.writeText) {
            if (!fireNoToasters) {
              toastr.warning(
                $translate.instant('generalTerms.copyToClipboardNotSupportedContent'),
                $translate.instant('generalTerms.copyToClipboardNotSupportedTitle')
              );
            }
            return;
          }
          navigator.clipboard.writeText(content);
          if (!fireNoToasters) {
            toastr.success(
              '',
              $translate.instant('generalTerms.copyToClipboardDone')
            );
          }
        },
        uuid: function () {
          var d = new Date().getTime();
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + (Math.random() * 16)) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
        },
        isUUID: /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
        preference: {
          prefix: function (preferenceName) {
            return 'preference_o' + $rootScope.ctx.organization.current.id
                   + '_u' + $rootScope.ctx.currentUser.id + '_' + preferenceName;
          },
          bool: {
            get: function (preferenceName, defaultPreference) {
              var prefResult = localStorage.getItem(self.preference.prefix(preferenceName));
              return prefResult ? !!parseInt(prefResult, 10) : defaultPreference;
            },
            set: function (preferenceName, setter) {
              if (setter !== undefined) {
                try {
                  localStorage.setItem(self.preference.prefix(preferenceName), (setter ? '1' : '0'));
                } catch (e) {
                  return false;
                }
                return true;
              }
              return false;
            }
          },
          object: {
            delete: function (preferenceName) {
              localStorage.removeItem(self.preference.prefix(preferenceName));
            },
            get: function (preferenceName, defaultPreference) {
              var prefResult = localStorage.getItem(self.preference.prefix(preferenceName));
              if (prefResult) {
                try {
                  prefResult = JSON.parse(prefResult);
                } catch (e) {
                  prefResult = null;
                }
                if (prefResult) {
                  if (typeof prefResult !== 'object') {
                    return defaultPreference;
                  }
                  if (prefResult.expireISOTime && moment().isAfter(moment(prefResult.expireISOTime))) {
                    return defaultPreference;
                  }
                }
              }
              return prefResult || defaultPreference;
            },
            set: function (preferenceName, setter, expiresInMS) {
              var itemToSet = JSON.parse(JSON.stringify(setter));
              if (itemToSet) {
                if (expiresInMS && typeof itemToSet === 'object') {
                  itemToSet.expireISOTime = moment().add(parseInt(expiresInMS, 10), 'ms').toISOString();
                }
                try {
                  localStorage.setItem(self.preference.prefix(preferenceName), JSON.stringify(itemToSet));
                } catch (e) {
                  return false;
                }
                return true;
              }
              return false;
            }
          }
        },
        hashCode: function (str) {
          var hash = 0;
          if (str.length === 0) {
            return hash;
          }
          for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
          }
          return parseInt(hash.toString().replace('-', '1'), 10);
        },
        validation: {
          iban: function (value) {
            var iban = (value || '').replace(/ /g, '').toUpperCase(),
              ibancheckdigits = '',
              leadingZeroes = true,
              cRest = '',
              cOperator = '',
              countrycode, ibancheck, charAt, cChar, bbanpattern, bbancountrypatterns, ibanregexp, i, p;

            var minimalIBANlength = 5;
            if (iban.length < minimalIBANlength) {
              return false;
            }

            countrycode = iban.substring(0, 2);
            bbancountrypatterns = {
              AL: '\\d{8}[\\dA-Z]{16}',
              AD: '\\d{8}[\\dA-Z]{12}',
              AT: '\\d{16}',
              AZ: '[\\dA-Z]{4}\\d{20}',
              BE: '\\d{12}',
              BH: '[A-Z]{4}[\\dA-Z]{14}',
              BA: '\\d{16}',
              BR: '\\d{23}[A-Z][\\dA-Z]',
              BG: '[A-Z]{4}\\d{6}[\\dA-Z]{8}',
              CR: '\\d{17}',
              HR: '\\d{17}',
              CY: '\\d{8}[\\dA-Z]{16}',
              CZ: '\\d{20}',
              DK: '\\d{14}',
              DO: '[A-Z]{4}\\d{20}',
              EE: '\\d{16}',
              FO: '\\d{14}',
              FI: '\\d{14}',
              FR: '\\d{10}[\\dA-Z]{11}\\d{2}',
              GE: '[\\dA-Z]{2}\\d{16}',
              DE: '\\d{18}',
              GI: '[A-Z]{4}[\\dA-Z]{15}',
              GR: '\\d{7}[\\dA-Z]{16}',
              GL: '\\d{14}',
              GT: '[\\dA-Z]{4}[\\dA-Z]{20}',
              HU: '\\d{24}',
              IS: '\\d{22}',
              IE: '[\\dA-Z]{4}\\d{14}',
              IL: '\\d{19}',
              IT: '[A-Z]\\d{10}[\\dA-Z]{12}',
              KZ: '\\d{3}[\\dA-Z]{13}',
              KW: '[A-Z]{4}[\\dA-Z]{22}',
              LV: '[A-Z]{4}[\\dA-Z]{13}',
              LB: '\\d{4}[\\dA-Z]{20}',
              LI: '\\d{5}[\\dA-Z]{12}',
              LT: '\\d{16}',
              LU: '\\d{3}[\\dA-Z]{13}',
              MK: '\\d{3}[\\dA-Z]{10}\\d{2}',
              MT: '[A-Z]{4}\\d{5}[\\dA-Z]{18}',
              MR: '\\d{23}',
              MU: '[A-Z]{4}\\d{19}[A-Z]{3}',
              MC: '\\d{10}[\\dA-Z]{11}\\d{2}',
              MD: '[\\dA-Z]{2}\\d{18}',
              ME: '\\d{18}',
              NL: '[A-Z]{4}\\d{10}',
              NO: '\\d{11}',
              PK: '[\\dA-Z]{4}\\d{16}',
              PS: '[\\dA-Z]{4}\\d{21}',
              PL: '\\d{24}',
              PT: '\\d{21}',
              RO: '[A-Z]{4}[\\dA-Z]{16}',
              SM: '[A-Z]\\d{10}[\\dA-Z]{12}',
              SA: '\\d{2}[\\dA-Z]{18}',
              RS: '\\d{18}',
              SK: '\\d{20}',
              SI: '\\d{15}',
              ES: '\\d{20}',
              SE: '\\d{20}',
              CH: '\\d{5}[\\dA-Z]{12}',
              TN: '\\d{20}',
              TR: '\\d{5}[\\dA-Z]{17}',
              AE: '\\d{3}\\d{16}',
              GB: '[A-Z]{4}\\d{14}',
              VG: '[\\dA-Z]{4}\\d{16}'
            };

            bbanpattern = bbancountrypatterns[countrycode];

            if (typeof bbanpattern !== 'undefined') {
              ibanregexp = new RegExp('^[A-Z]{2}\\d{2}' + bbanpattern + '$', '');
              if (!(ibanregexp.test(iban))) {
                return false;
              }
            }

            ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
            for (i = 0; i < ibancheck.length; i++) {
              charAt = ibancheck.charAt(i);
              if (charAt !== '0') {
                leadingZeroes = false;
              }
              if (!leadingZeroes) {
                ibancheckdigits += '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(charAt);
              }
            }

            // Calculate the result of: ibancheckdigits % 97
            for (p = 0; p < ibancheckdigits.length; p++) {
              cChar = ibancheckdigits.charAt(p);
              cOperator = '' + cRest + '' + cChar;
              cRest = cOperator % 97;
            }
            return cRest === 1;
          },
          bic: function (value) {
            return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test((value || '').toUpperCase());
          }
        },
        time: {
          getNextQuarter: function (fromMinutes) {
            // gets next quarter that is more then five minutes due
            // beware, can produce minutes that exceed 60!
            // use moment().add(<minutes>, 'm') for no worries as it will bump hours and so fourth
            return (20 - ((fromMinutes + 5) % 15));
          },
        },
        getContrastLabelColor: function (hexColor) {
          if (hexColor) {
            var colorSeperationRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
            if (hexColor.length < 5) {
              colorSeperationRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            }
            var result = colorSeperationRegex.exec(hexColor);

            var getRealColorPartial = function (partial) {
              return partial.length > 1 ? partial : (partial.toString() + partial.toString());
            };

            var r = parseInt(getRealColorPartial(result[1]), 16);
            var g = parseInt(getRealColorPartial(result[2]), 16);
            var b = parseInt(getRealColorPartial(result[3]), 16);

            var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

            return (yiq >= 140) ? '#000' : '#FFF';
          }
          return '#000';
        },
        hexToHSL: function (hex) {
          if (hex.length === 4) {
            hex = hex.substr(1, 4).split('').map(function (h) {
              return h + h;
            }).join('');
          }
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          var r = parseInt(result[1], 16);
          var g = parseInt(result[2], 16);
          var b = parseInt(result[3], 16);
          r /= 255, g /= 255, b /= 255;
          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var h, s, l = (max + min) / 2;
          if (max == min){
            h = s = 0; // achromatic
          } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
          }
          var HSL = new Object();
          h = h*360;
          s = s*100;
          l = l*100;
          HSL['h'] = h;
          HSL['s'] = s + '%';
          HSL['l'] = l + '%';
          return HSL;
        },
        setPortalPrimaryColor: function(hex) {
          var hsl = self.hexToHSL(hex);
          var fontColor = self.getContrastLabelColor(hex);
          var root = document.documentElement;
          root.style.setProperty('--base-color', [hsl.h, hsl.s].join(', '));
          root.style.setProperty('--l', hsl.l);
          root.style.setProperty('--font-color', fontColor);
          if (fontColor.startsWith('#fff')) {
            root.style.setProperty('--color-logo-bg', fontColor);
            root.style.setProperty('--color-logo-puzzle-left', '#1A1918');
            root.style.setProperty('--color-logo-puzzle-right', '#9E9F9E');
            root.style.setProperty('--color-logo-n', '#343433');
          } else {
            root.style.setProperty('--color-logo-bg', '#262625');
            root.style.setProperty('--color-logo-puzzle-left', '#504D49');
            root.style.setProperty('--color-logo-puzzle-right', '#B7B8B7');
            root.style.setProperty('--color-logo-n', '#999996');
          }
        },
        translateMemberAuthType: function (typeIdentifier) {
          var type = '';
          switch (typeIdentifier) {
          case 'local':
            type = 'Arno Online';
            break;
          case 'azure':
            type = 'Azure Online';
            break;
          case 'offline':
            type = 'Offline';
            break;
          }
          return type;
        },
        division: {
          generateKey: function (options) {
            options = options || {};
            return 'ctx_div_o' +
                   $rootScope.ctx.organization.current.id + '_u' +
                   $rootScope.ctx.currentUser.id + '_' +
                   (options.multiple ? 'multiple_' : 'single_') +
                   (options.allowOrgSelection ? 'withOrg_' : '_') +
                   ((options.entryPermission || '') + '_') +
                   (options.namespace ? options.namespace : '')
          },
          getCtx: function (options) {
            var ctx = localStorage.getItem(self.division.generateKey(options));
            ctx = ctx ? JSON.parse(ctx) : {};
            ctx.SelectionValue = ctx.SelectionValue ? ctx.SelectionValue.split(';') : [];
            ctx.SelectionValue = options.multiple ? ctx.SelectionValue : ctx.SelectionValue.splice(0, 1);
            var selectedDivIds = _.clone(ctx.SelectionValue);
            selectedDivIds = selectedDivIds.filter(function (c) {
              return c === 'rootOrg' || !!_.find(self.division.divisionTreeData, { id: c.toString() });
            });
            if (options.entryPermission) {
              selectedDivIds = selectedDivIds.filter(function (dId) {
                var scope = dId === 'rootOrg' ? 'Organization' : 'Division';
                return permissions.isPermittedInEvery(
                  permissions.getScopedPermission(options.entryPermission, scope),
                  scope,
                  (dId === 'rootOrg' ? [$rootScope.ctx.organization.current.id] : [dId]),
                  true
                )
              });
            }
            var fallbackSelection = false;
            if (!selectedDivIds.length) {
              // we would return an empty selection
              // return first available selection instead
              var availableTree = self.division.treeDataPermissionFilter(self.division.treeData(options, true), options.entryPermission);
              availableTree = availableTree.filter(function (node) {
                return node.id && !node.disabled;
              });
              availableTree = _.orderBy(
                availableTree,
                [
                  function (node) {
                    // sort mainDivision to front (if available)
                    return (parseInt(node.id, 10) === parseInt((($rootScope.ctx.currentUser || {}).mainDivision || {}).id, 10)) ? 0 : 1;
                  },
                  function (node) {
                    return node.ParentDivisionId ? parseInt(node.ParentDivisionId, 10) : 0;
                  },
                  'Name',
                ],
                ['asc', 'asc', 'asc']
              );
              if (availableTree.length) {
                selectedDivIds.push(availableTree[0].id);
                fallbackSelection = true;
              } else if (options.allowOrgSelection) {
                var isPermittedOnRoot = options.entryPermission ? permissions.isPermittedInEvery(
                  permissions.getScopedPermission(options.entryPermission, 'Organization'),
                  'Organization',
                  [$rootScope.ctx.organization.current.id],
                  true
                ) : true;
                if (isPermittedOnRoot) {
                  selectedDivIds.push('rootOrg');
                  fallbackSelection = true;
                }
              }
            }
            if (ctx.SelectionValue.length !== selectedDivIds.length || fallbackSelection) {
              self.division.setCtx(selectedDivIds, options);
            }
            return selectedDivIds;
          },
          setCtx: function (divisionList, options) {
            if ((!divisionList || !divisionList.length) && localStorage.getItem(self.division.generateKey(options))) {
              localStorage.removeItem(self.division.generateKey(options));
              return true;
            }
            var valObj = {
              SelectionValue: divisionList.join(';'),
              LastUpdated: Date.now()
            };
            localStorage.setItem(self.division.generateKey(options), JSON.stringify(valObj));
            if (valObj.SelectionValue) {
              clientApi.custom('model/DivisionSelection', 'createOrUpdate', {
                selectionKey: self.division.generateKey(options),
                selectionValue: valObj.SelectionValue,
                lastUpdated: valObj.LastUpdated,
                cMemberId: $rootScope.ctx.currentUser.id
              })
                .catch(function () {
                  // silently continue
                });
            }
            return true;
          },
          getSelectionIdent: function (ctx) {
            var divisionCtx = _.clone(ctx || []);
            divisionCtx.sort();
            return divisionCtx.join('|');
          },
          divisionTreeData: [],
          buildDossierTreeData: function (confirmedDivs, treeData) {
            var cDivIds = _.map(confirmedDivs, function (div) {
              return div.id;
            })
            confirmedDivs.forEach(function (cDiv) {
              var treeDiv = _.find(treeData, function (treeNode) {
                return treeNode.id === cDiv.id;
              })
              treeDiv.hasMember = true;
              if (treeDiv.ParentDivisionId) {
                var nextDiv = _.find(treeData, function (treeNode) {
                  return treeNode.id === treeDiv.ParentDivisionId;
                })
              }

              while (nextDiv) {
                if (!!~cDivIds.indexOf(nextDiv.id)) { // eslint-disable-line no-extra-boolean-cast
                  nextDiv.hasMember = true;
                } else {
                  nextDiv.noDossierMember = true;
                  nextDiv.disabled = true;
                }

                if (nextDiv.ParentDivisionId) {
                  nextDiv = _.find(treeData, function (treeNode) {
                    return treeNode.id === nextDiv.ParentDivisionId;
                  })
                } else {
                  nextDiv = null;
                }
              }
            })

            treeData.forEach(function (treeNode) {
              if (!treeNode.hasMember && !treeNode.noDossierMember) {
                treeNode.Active = false;
              }
            })

            return treeData;
          },
          treeData: function (opts, sync) {
            if (sync) {
              if (opts && opts.namespace === 'divisionMemberDossier') {
                return [];
              }
              return _.cloneDeep(self.division.divisionTreeData || []);
            }
            if (opts && opts.namespace === 'divisionMemberDossier') {
              var divIds = [];
              self.division.divisionTreeData.forEach(function (div) {
                divIds.push(div.id);
              });
              return clientApi
                .custom('model/DivisionMember', 'checkForMemberInDiv', { divisionIds: divIds, cMemberId: opts.dossierOwnerId })
                .then(function (result) {
                  var dossierAvailable = _.filter(_.cloneDeep(self.division.divisionTreeData), function (treeDiv) {
                    return !!~result.indexOf(+treeDiv.id);
                  })
                  var treeData = self.division.buildDossierTreeData(dossierAvailable, _.cloneDeep(self.division.divisionTreeData));

                  return treeData;
                })
                .catch(function () {
                  return Promise.resolve(_.cloneDeep(self.division.divisionTreeData || []));
                })
            }
            return Promise.resolve(_.cloneDeep(self.division.divisionTreeData || []));
          },
          treeDataPermissionFilter: function (nodes, entryPermission) {
            entryPermission = entryPermission || '';
            nodes = nodes.filter(function (node) {
              return node.Active;
            })
            var treeOutObject = {};
            var treeInObject = {};
            nodes.forEach(function (node) {
              treeInObject[node.id] = node;
            });
            var scopedPermission = permissions.getScopedPermission(entryPermission, 'Division');
            nodes.forEach(function (node) {
              if (!treeOutObject[node.id]) {
                if (!entryPermission || permissions.isPermittedInEvery(scopedPermission, 'Division', [node.id], true)) {
                  if (node.disabled && !node.noDossierMember) {
                    node.disabled = false;
                  }
                  treeOutObject[node.id] = node;
                  var nodeCursor = node;
                  var visitedNodes = [];
                  while (nodeCursor.ParentDivisionId) {
                    if (visitedNodes.indexOf(nodeCursor.id) !== -1) {
                      throw new Error('circular division structure detected');
                    }
                    visitedNodes.push(nodeCursor.id);
                    nodeCursor = treeInObject[nodeCursor.ParentDivisionId];
                    if (!treeOutObject[nodeCursor.id]) {
                      if (entryPermission && !permissions.isPermittedInEvery(scopedPermission, 'Division', [nodeCursor.id], true)) {
                        nodeCursor.disabled = true;
                      }
                      treeOutObject[nodeCursor.id] = nodeCursor;
                    }
                  }
                }
              }
            });
            return _.toArray(treeOutObject);
          },
          buildTreeNodes: function (dbDivisions, options) {
            options = options || {};
            options.selected = options.selected || [];

            var rootIdSelector = options.rootOrg ? 'rootOrg' : '#';
            var isPermittedOnRoot = false;

            if (options.rootOrg && options.entryPermission) {
              var scopedPermission = permissions.getScopedPermission(options.entryPermission, 'Organization');
              isPermittedOnRoot = permissions.isPermittedInEvery(scopedPermission, 'Organization', [$rootScope.ctx.organization.current.id], true);
            }

            // we have a root organisation, add an entry in node results with a special rootOrg id
            if (options.rootOrg) {
              var rootOrgNode = {
                id: 'rootOrg',
                parent: '#',
                text: options.rootOrg,
                active: true, // rootOrg is always active
                icon: 'fa fa-users',
                state: {
                  selected: !!~options.selected.indexOf('rootOrg'),
                  opened: true //rootOrg should always be opened
                },
                type: 'rootOrg',
              };
            }

            if (dbDivisions && (dbDivisions.length || isPermittedOnRoot)) {
              var nodeResults = dbDivisions.map(function (dbDivision) {
                return {
                  id: dbDivision.id,
                  parent: dbDivision.ParentDivisionId ? dbDivision.ParentDivisionId : rootIdSelector,
                  text: dbDivision.Name,
                  icon: 'fa fa-sitemap',
                  active: dbDivision.Active,
                  state: {
                    selected: !dbDivision.disabled && !!~options.selected.indexOf(dbDivision.id),
                    opened: (options.statePref && typeof options.statePref === 'string') ? self.preference.bool.get(options.statePref, false) : options.statePref,
                    disabled: !!dbDivision.disabled
                  },
                  admins: [],
                };
              });

              var angularTreeNodes = [];

              if (options.rootOrg) {
                if (options.entryPermission) {
                  rootOrgNode.state.disabled = !isPermittedOnRoot;
                }
                nodeResults.push(rootOrgNode);
                // clone it so it doesn't affect the regular node results for the div selector
                angularTreeNodes.push(_.cloneDeep(rootOrgNode));
              }
              this.buildChildrenRecursively(angularTreeNodes, _.cloneDeep(nodeResults), true, this);

              if (options.keepReference) {
                // empty array from 'keepReference' to keep its reference (doh!)
                options.keepReference.length && options.keepReference.splice(0, options.keepReference.length);
                // write nodeResults entries into keepReference array
                options.keepReference.push.apply(options.keepReference, nodeResults);
                return Promise.resolve(options.keepReference);
              }

              if (!options.fetchMembers) {
                return Promise.resolve({ nodeResults: nodeResults });
              }

              var divisionIds = [];
              dbDivisions.forEach(function (division) {
                divisionIds.push(division.id);
              });

              return clientApi
                .custom('model/DivisionRoleMember', 'findDivisionRoleMembers', { divisionIds: divisionIds })
                .then(function (result) {
                  var memberIds = result.map(function (member) {
                    return member.MemberId;
                  });

                  return clientApi.custom('model/Member', 'findByOrganizationId', { queryWishes: { withAnyTerms: true, idIn: _.uniq(memberIds) } });
                })
                .then(function (members) {
                  return { nodeResults: nodeResults, members: members, angularTreeData: angularTreeNodes };
                })
                .catch(function (error) {
                  console.error(error);
                  return options.keepReference ? options.keepReference : [];
                });
            }

            return Promise.resolve(options.keepReference ? options.keepReference : { nodeResults: [rootOrgNode] });
          },
          buildChildrenRecursively: function (layer, sourceData, isRootLayer, ref) {
            layer.forEach(function (layerDiv) {
              layerDiv.children = [];
              sourceData.forEach(function (div) {
                if (isRootLayer && !div.parent) {
                  layerDiv.children.push(div);
                }
                if (div.parent === layerDiv.id) {
                  layerDiv.children.push(div);
                }
              })
              if (layerDiv.children.length) {
                ref.buildChildrenRecursively(layerDiv.children, sourceData, false, ref);
              }
            })
            return layer;
          },
        },
        getPageSize: function (prefKey, num) {
          if (!num) {
            var pref = this.preference.object.get(prefKey);
            return (pref && pref.itemsPerPage || 10);
          } else {
            this.preference.object.set(prefKey, {
              itemsPerPage: num
            });
            return num;
          }
        },
        flattenObject: flattenObject,
        recurseTree: function (tree, fn) {
          tree.forEach(function (node, i) {
            fn(node, i, tree);
            if (node.children && node.children.length) {
              self.recurseTree(node.children, fn)
            }
          })
        },
        finances: {
          formatProcessSteps: function(steps) {
            return steps.map(function(step) {
              step.type = step.ResultingModel;
              var resultKey;
              Object.keys(step).forEach(function(key) {
                if (key.startsWith('Resulting') && step[key] && typeof step[key] === 'object') {
                  resultKey = key;
                  step[key].type = key.replace('Resulting', '');
                  if ((step.ResultingInvoice || {}).Reversal) {
                    step[key].type = 'ReversalInvoice';
                  }
                  step[key].stepCreatedAt = step.createdAt;
                  step[key].Member = step.Member;
                  step[key].CommonName = step[key].Name || step[key].Subject || step[key].Title;
                }
              })
              if (resultKey) {
                return step[resultKey];
              }
              step.deleted = true;
              return step;
            })
          }
        },
        fileStorage: {
          buildFolderTree: function (dbFolders, options) {
            if (dbFolders) {
              var nodes = dbFolders.map(function (folder) {
                return {
                  id: folder.id,
                  text: folder.Name,
                  parent: folder.ParentFolderId || 'rootOrg',
                  children: [],
                  icon: 'fa fa-folder',
                  type: 'folder',
                  viewPermission: folder.ViewPermission,
                  active: folder.Active,
                }
              })
              var nodeCopy = _.cloneDeep(nodes);

              if (options.rootOrg) {
                var rootOrgNode = {
                  id: 'rootOrg',
                  parent: '#',
                  text: options.rootOrg,
                  icon: options.rootIcon || 'fa fa-users',
                };

                var treeNodes = [];
                treeNodes.push(rootOrgNode);
              } else {
                _.cloneDeep(nodes).forEach(function (node) {
                  if (!node.parent) {
                    treeNodes.push(node);
                    var i = _.findIndex(nodes, function (origNode) {
                      return node.id === origNode.id;
                    })
                    nodes.splice(i, 1);
                  }
                })
              }

              self.division.buildChildrenRecursively(treeNodes || [], _.cloneDeep(nodes), true, self.division);

              if (options.includeFiles && options.includeFiles.length) {
                // add files to tree nodes here
                var fileSplit;
                options.includeFiles.forEach(function (file) {
                  self.recurseTree(treeNodes, function (node) {
                    if (node.id === file.FolderId && node.type === 'folder') {
                      fileSplit = file.Name.split('.');
                      node.children.push({
                        id: 'f-' + file.id,
                        text: file.Name,
                        extension: fileSplit[fileSplit.length - 1],
                        baseName: fileSplit[0],
                        fileSize: Number(file.Size),
                        uploader: file.CreatingMember,
                        parent: file.FolderId,
                        children: [],
                        icon: self.fileStorage.fileExtToIconMap(fileSplit[fileSplit.length - 1]),
                        type: 'file',
                        createdAt: file.createdAt,
                        updatedAt: file.updatedAt,
                      })
                    }
                  })
                })
              }

              return { angularTreeData: treeNodes, mappedNodes: nodeCopy };
            }
          },
          fileExtToIconMap: function (extension) {
            var map = {
              'fa fa-file-archive-o': ['zip', '7z'],
              'fa fa-file-code-o': ['js', 'c', 'jar', 'ps1', 'bat', 'cs', 'html', 'json'],
              'fa fa-file-pdf-o': ['pdf'],
              'fa fa-file-excel-o': ['xlsx', 'xlsm', 'xltx', 'xltm'],
              'fa fa-file-word-o': ['docx', 'docm', 'dotx', 'dotm', 'docb'],
              'fa fa-file-image-o': ['jpg', 'png', 'gif', 'tiff'],
              'fa fa-file-powerpoint-o': ['ppt', 'pptx'],
              'fa fa-file-audio-o': ['mp3', 'wav', 'wma', 'ogg'],
            }
            var keys = Object.keys(map);
            var icon;
            keys.forEach(function (key) {
              if (extension && !!~map[key].indexOf(extension.toLowerCase())) { // eslint-disable-line no-extra-boolean-cast
                icon = key;
              }
            })
            return icon ? icon : 'fa fa-file-o';
          },
          checkIfParentOf: function(node, childId, first) {
            if (node.id !== childId) {
              if (node.children && node.children.length) {
                for (var i = 0; i < node.children.length; i++) {
                  if (self.fileStorage.checkIfParentOf(node.children[i], childId)) {
                    return true;
                  }
                }
              }
            } else if (!first && node.id === childId) {
              return true;
            }
            return false;
          },
          isParentRestricted: function(node, folderStructureData, checkDisabled) {
            if (!node.id) {
              return false;
            }
            var parentRestricted = false;
            var pastNode = false;
            var firstLevel = folderStructureData[0].children;
            for (var i = 0; i < firstLevel.length; i++) {
              if (parentRestricted || pastNode) {
                break;
              }
              if (self.fileStorage.checkIfParentOf(firstLevel[i], node.id, true)) {
                self.recurseTree([firstLevel[i]], function(treeNode, level, layer) {
                  var currentLayer = _.find(layer, function(layerNode) {
                    return layerNode.id === node.id;
                  })
                  if (checkDisabled) {
                    if (node.id !== treeNode.id && treeNode.active === false && !pastNode && !currentLayer) {
                      parentRestricted = true;
                    } else if (node.id === treeNode.id) {
                      pastNode = true;
                    }
                  } else {
                    if (node.id !== treeNode.id && treeNode.viewPermission && treeNode.viewPermission !== 'view' && !pastNode && !currentLayer) {
                      parentRestricted = true;
                    } else if (node.id === treeNode.id) {
                      pastNode = true;
                    }
                  }
                })
              }
            }
            return parentRestricted;
          },
          hasChildFiles: function(node) {
            var children = node.children;
            var found = false;
            for (var i = 0; i < children.length; i++) {
              if (children[i].type === 'file') {
                found = true;
                break;
              } else if (children[i].children && children[i].children.length) {
                found = self.fileStorage.hasChildFiles(children[i]);
                if (found) {
                  return found;
                }
              }
            }
            return found;
          }
        },
        dossier: {
          open: function (divisionId, eMail) {
            var isOwnDossier = $rootScope.ctx.currentUser.eMail === eMail;
            self.division.setCtx(Array.isArray(divisionId) ? divisionId : [divisionId],
              {
                multiple: false,
                namespace: 'divisionMemberDossier',
                allowOrgSelection: true,
                //don't check for permission if it's your own dossier
                entryPermission: (isOwnDossier) ? '' : 'Division:arno.personnel.dossier,Organization:arno.personnel.dossier',
              });
            $state.go('arno.personnel.dossier.overview', { memberEMail: eMail }, { reload: true });
          },
          getUrl: function (eMail) {
            return '#!/personnel/dossier/' + eMail;
          }
        },
        clothes: {
          open: function (divisionId, materialId) {
            self.division.setCtx([divisionId], {
              multiple: false,
              allowOrgSelection: true,
            });
            $state.go('arno.material.clothes.baseData', { mid: materialId }, { reload: true });
          }
        },
        event: {
          eventCtxOpts: { multiple: true, entryPermission: 'arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage' },
          getShowElement: function (element, some, ctx) {
            var divisions = self.division.getCtx(self.event.eventCtxOpts);
            if (!(ctx || divisions).length) {
              return false;
            }
            switch (element) {
            case 'addBasicEvent':
            case 'hasEventManage':
              return permissions[some ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.basic.manage', 'Division', ctx || divisions);
            case 'addService':
            case 'hasServiceManage':
              return permissions[some ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.service.manage', 'Division', ctx || divisions);
            case 'hasServiceManageOrItemPerm':
              return permissions[some ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.service.manage,arno.virtual.item.events.service.manage', 'Division', ctx || divisions);
            case 'hasEventManageOrItemPerm':
              return permissions[some ? 'isPermittedInSome' : 'isPermittedInEvery']('arno.events.basic.manage,arno.virtual.item.events.basic.manage', 'Division', ctx || divisions);
            }
          },
          createEvent: function (date, ctx, type) {
            // don't allow event creation when multiple divisions are selected
            if ((ctx || self.division.getCtx(self.event.eventCtxOpts)).length !== 1) {
              toastr.warning(
                $translate.instant('modules.events.invalidContextSelectionMsg'),
                $translate.instant('modules.events.invalidContextSelectionTitle')
              );
              return false;
            }
            return Promise.resolve()
              .then(function () {
                if (!type && (self.event.getShowElement('addBasicEvent', false, ctx) && self.event.getShowElement('addService', false, ctx))) {
                  return baModalService
                    .messageModal({
                      modalType: 'default',
                      allowHtml: false,
                      title: $translate.instant('modules.events.overview.addEvent'),
                      content: $translate.instant('modules.events.overview.addEventTitle'),
                      primaryActionText: $translate.instant('modules.events.overview.date'),
                      secondaryActionText: $translate.instant('modules.events.overview.service'),
                      closable: true,
                      primaryActionHandler: function (uibmi) {
                        uibmi.close('EVENT');
                      },
                      secondaryActionHandler: function (uibmi) {
                        uibmi.close('SERVICE');
                      }
                    });
                }
                return type;
              })
              .then(function (result) {
                var detailOpts = {};
                if (date) {
                  detailOpts.startDate = date.toISOString();
                }
                if (ctx) {
                  detailOpts.ctx = ctx;
                }

                if ((result === 'EVENT' || !result) && self.event.getShowElement('addBasicEvent', false, ctx)) {
                  $state.go('arno.events.eventDetail', detailOpts);
                  return;
                }
                if ((result === 'SERVICE' || !result) && self.event.getShowElement('addService', false, ctx)) {
                  $state.go('arno.events.serviceDetail', detailOpts);
                  return;
                }
                toastr.warning(
                  $translate.instant('modules.events.noEventCreatePermMsg'),
                  $translate.instant('modules.events.noEventCreatePermTitle')
                );
              });
          }
        },
        getDivisionFromSingleCtx: function (entryPermission, nullOnUnset, allowOrgSelection) {
          // helper function to quickly fetch the ctx for a multiple:false allowOrgSelection:true
          // will return false when rootOrg is selected (falsy); or a single divisionId without array (truthy)
          var selectedDivision = self.division.getCtx({
            multiple: false,
            allowOrgSelection: allowOrgSelection === undefined || allowOrgSelection,
            entryPermission: (entryPermission ? entryPermission : undefined)
          });
          if (selectedDivision.length && selectedDivision[0]) {
            if (selectedDivision[0] === 'rootOrg') {
              return false;
            }
            return selectedDivision[0];
          }
          return nullOnUnset ? null : false;
        },

        /**
         * @name findAllChildrensBy
         * @description Finds all children (also sub-childrens with endless-depth), by a given property-name
         *
         * @param {Array} array   Flat Array structure to search in
         * @param {String} propName The name of the property to check against
         * @param {Any} value The value of the given parent
         * @param {String} keyName The name of the key-property for compare
         *
         * @return {Array} Flat array with all given childs
         */
        findAllChildrensBy: function (source, propName, element, keyName) {
          if (!source || !(typeof propName === 'string' || !(typeof keyName === 'string') || !element)) {
            throw new Error('ERROR: commonUtils.findAllChildrensBy: Not all params given!');
          }

          // find children with native for performance, avoid forEach
          var children = [element[keyName]];
          var alreadyAdded = false;

          for (var i = 0, l = source.length; i < l; i++) {
            for (var j = 0, k = children.length; j < k; j++) {
              if (source[i][propName] == children[j]) {
                // check, if already added to found array
                alreadyAdded = false;
                for (var m = 0; m < k; m++) {
                  // already in found-source
                  if (source[i][keyName] == children[m]) {
                    alreadyAdded = true;
                    m = k; // simulates break of current loop, instead of using "break label"...
                  }
                }

                if (alreadyAdded === false) {
                  children.push(source[i][keyName]);
                  i = 0;
                  j = k; // simulates break of current loop, instead of using "break label"...
                }
              }
            }
          }

          children.shift();
          return children;
        },

        /**
         * @name searchElementInTreeData
         * @description Finds all children (also sub-childrens with endless-depth), by a given property-name
         *
         * @param {Object} tree   tree structure to search in
         * @param {String} childrenContainerProp The name of the property, which holds the children
         * @param {String} matchProp The property which is used to match against the matchValue
         * @param {String} matchValue The valueto match against
         * @param {Boolean} removeFromTreeIfExisting If the element was found, then remove it from the tree,
         *                                      but return the ref to the found object. if its the root, then no remove is done
         *
         * @return {Array} Flat array with all given childs
         */
        searchElementInTreeData: function (tree, childrenContainerProp, matchProp, matchValue, removeFromTreeIfExisting) {
          var searchTree;
          var found;

          // first check, if its an array
          if (tree && tree.length) {
            searchTree = tree;
          } else {
            // no array, so it has a root-element, stat search from there
            if (tree[matchProp] == matchValue) {
              return tree;
            }

            searchTree = tree[childrenContainerProp];
          }

          for (var i = 0, l = searchTree.length; i < l; i++) {
            // check if it matches the given criteria
            if (searchTree[i][matchProp] == matchValue) {
              if (removeFromTreeIfExisting === true) {
                searchTree[i] = undefined;
              }

              return searchTree[i];
            }

            // check if it has children
            if (searchTree[i][childrenContainerProp] && searchTree[i][childrenContainerProp].length) {
              found = found || this.searchElementInTreeData(searchTree[i][childrenContainerProp], childrenContainerProp, matchProp, matchValue);

              if (found) {
                return found;
              }
            }
          }

          return found;
        },

        buildTreeFromFlatArray: function (flatArray, parentPropName, matchPropName, popNameOfDirectChildrensToCopy) {
          var formattedArray = _.forEach(flatArray, function (f) {
            f.children = _.filter(flatArray, function (g) {
              return g[parentPropName] == f[matchPropName];
            });
          });

          var resultArray = _.filter(formattedArray, function (f) {
            if (popNameOfDirectChildrensToCopy) {
              f.children = f.children.concat(f[popNameOfDirectChildrensToCopy]);
            }

            return f[parentPropName] == null;
          });

          return resultArray;
        },

        getSubdomainFromHost: function (host) {
          var splitted = (host || window.location.hostname).split('.');
          if (splitted.length === 2) {
            return false;
          }
          if (~['dev', 'qa', 'int'].indexOf(splitted[0])) { // protected sub sub domains
            return false;
          }
          return splitted[0].toLocaleLowerCase();
        },
        getCookie: function (cname) {
          var name = cname + '=';
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return '';
        },
        setCookie: function (name, value, expires, path, theDomain, secure) {
          try {
            document.cookie = name + '=' + value +
                              ((expires) ? '; expires=' + expires.toUTCString() : '') +
                              ((path) ? '; path=' + path : '') +
                              ((theDomain) ? '; domain=' + theDomain : '') +
                              ((secure) ? '; secure' : '');
          } catch (e) {
            // kk
          }
        },
        setTargetOrganizationCookie: function (org, subdomain) {
          var host = window.location.hostname;
          var globalDomain = '.' + host;
          if (self.getSubdomainFromHost(host)) {
            globalDomain = host.substring(host.split('.')[0].length);
          }
          self.setCookie('targetOrganization', org, null, '/', globalDomain);
          self.setCookie('lastOrganization', subdomain || '', subdomain ? null : new Date((+new Date()) + (1)), '/', globalDomain);
        },
        UTCDateOnlyToLocal: function (date) {
          var localDateTemp = new Date(moment(date).utc().format('YYYY-MM-DD'));
          return new Date(localDateTemp.getUTCFullYear(), localDateTemp.getUTCMonth(), localDateTemp.getUTCDate());
        },
        formatMinutesToHourString: function(minutes) {
          var splitMins = minutes % 60;
          return Math.floor(minutes / 60) + ':' + (splitMins < 10 ? '0' : '') + splitMins;
        },
        findParentScopeWithProp: function(scope, prop) {
          if (scope.hasOwnProperty(prop)) {
            return scope
          }
          if (scope.$parent) {
            return self.findParentScopeWithProp(scope.$parent, prop)
          }
          return null;
        },
        fetchIncludedPermissions: function (permId, hierarchy) {
          var included = _.filter(hierarchy, { PermissionId: permId })
            .map(function (includedPermission) {
              return includedPermission.IncludedPermissionId;
            });
          if (included.length) {
            included = included.concat(included.map(function (includedPermission) {
              return self.fetchIncludedPermissions(includedPermission);
            }));
          }
          return _.uniq(_.flattenDeep(included.concat([permId])));
        },
      };
      return self;
    });
})();


/**
 * @name ArnoDashTrainingsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Training centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashTrainingsService', ArnoDashTrainingsService);

/** @ngInject */
function ArnoDashTrainingsService(
  $q, $log, commonUtils, clientApi, toastr, baModalService,
  ArnoDashTrainingGroupsService, $translate
) {
  var self = this;

  // CONSTS
  self.TRAININGS_NODE_TYPE = 'Training';


  // METHODS
  /**
   * @name saveTrainingWithNotifications
   * @description This method add/or save a training-training-training.
   * IMPORTANT: if the training-object has a vm-property,
   * then the data of "vm" is assumed to be newer and therefore taken from there!
   *
   * @param {Object} training
   * @param {Object} divisionId
   * @param {Number} memberId
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.saveTrainingWithNotifications = function(training, divisionId, memberId, eventId) {
    if (training) {
      var transferObj = _.clone(training);

      if (transferObj.TrainingTemplate && transferObj.TrainingTemplate.children) {
        transferObj.TrainingTemplate.children = undefined;
      }
      if (transferObj.TrainingTemplate && transferObj.TrainingTemplate.vmTrainings) {
        transferObj.TrainingTemplate.vmTrainings = undefined;
      }

      if (training.vm) {
        transferObj.Name = training.vm.Name;
        transferObj.Notes = training.vm.Notes;

        if (training.vm.CompletionStatus) {
          transferObj.CompletionStatus = training.vm.CompletionStatus.mapping;
        }

        transferObj.CompletionDate = training.vm.CompletionDate;

        if (training.vm.Graduation) {
          transferObj.Graduation = training.vm.Graduation.mapping;
        }

        transferObj.CountableHours = training.vm.CountableHours;
        transferObj.BaseCategories = training.vm.BaseCategories;
        transferObj.StartDate = training.vm.StartDate;
        transferObj.EndDate = training.vm.EndDate;
        transferObj.ValidityEndDate = training.vm.ValidityEndDate;

        // if completion-status is "open" or "irrelevant" then clear the completion-date and graduation-field
        switch (transferObj.CompletionStatus) {
        case 'OPEN':
        case 'IRRELEVANT':
          transferObj.CompletionDate = null;
          transferObj.Graduation = null;
          break;
        }

        delete transferObj.vm; // strip out to reduce payload
      }

      return clientApi.custom('model/Training', 'saveTraining', {
        training: transferObj,
        divisionId: divisionId,
        cMemberId: memberId,
        eventId: eventId || null,
      })
        .then(function(savedTraining) {
          toastr.success(
            $translate.instant('modules.personnel.dossier.trainings.saveSuccToastText'),
            $translate.instant('modules.personnel.dossier.trainings.saveSuccToastTitle')
          );

          // update the old model from, applying this merge chain will also ensure,
          // that the recalculated "Status" by the backend will be updated to the frontend
          training = _.merge(training, transferObj, savedTraining);

          return training;
        })
        .catch(function(error) {
          switch((error.data || {}).key) {
          case 'TRAINING_SAVE_NAME_MUST_NOT_EMPTY':
            toastr.error(
              $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastText'),
              $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastTitle')
            );
            break;

          case 'TRAINING_SAVE_NAME_CONFLICTING':
            toastr.error(
                $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastText'),
                $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastTitle')
            );
            break;

          default:
            toastr.error(
              $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastText'),
              $translate.instant('modules.personnel.dossier.trainings.saveErr1ToastTitle')
            );
          }

          return Promise.reject(error);
        });
    }

    return $q.reject('ERROR: ArnoDashTrainingsService.saveTrainingWithNotifications: You have to provide a training object!');
  };

  /**
   * @name deleteTraining
   * @description This method deletes a given training by id
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.deleteTraining = function(training, memberId, divisionId) {
    // remove possible circularity to be able to convert into request param
    // the whole object is sent (instead of only id) to be saved with log-journal
    var trainingObj = _.cloneDeep(_.omit(training, ['vm', 'TrainingTemplate']));

    return clientApi.custom('model/Training', 'deleteTraining', {
      training: trainingObj,
      cMemberId: memberId,
      divisionId: divisionId
    });
  }

  /**
   * @name getMemberTrainingsWithTemplateGroups
   * @description This method returns trainings with all of their training-groups/templates for a given memberid
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getMemberTrainingsWithTemplateGroups = function(memberId, divisionId, queryOptions) {
    return clientApi.custom('model/Training', 'getMemberTrainingsWithTemplateGroups', {
      cMemberId: memberId,
      divisionId: divisionId,
      queryOptions: queryOptions
    });
  }

  /**
   * @name getMemberTrainingsByTrainingTemplate
   * @description This method returns trainings for a given member and training-template
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getMemberTrainingsByTrainingTemplate = function(memberId, divisionId, trainingTemplateIds, filterOptions) {
    if (trainingTemplateIds && !angular.isArray(trainingTemplateIds)) {
      trainingTemplateIds = [trainingTemplateIds];
    }

    return clientApi.custom('model/Training', 'getMemberTrainingsByTrainingTemplate', {
      cMemberId: memberId,
      divisionId: divisionId,
      trainingTemplateIds: trainingTemplateIds,
      filterOptions: filterOptions
    });
  }

  /**
   * @name deleteTrainingWithMessageModal
   * @description This method show a message-modal and asks the user to delete a training
   * it handles success and error cases with toastr
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.deleteTrainingWithMessageModal = function(training, memberId, divisionId) {
    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.personnel.dossier.trainings.deleteModalTitle'),
      content: $translate.instant('modules.personnel.dossier.trainings.deleteModalText', training.Name),

      primaryActionText: $translate.instant('generalTerms.delete'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function() {
        return self.deleteTraining(training, memberId, divisionId)
          .then(function(results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.personnel.dossier.trainings.deleteSuccToastText', training.Name),
                $translate.instant('modules.personnel.dossier.trainings.deleteSuccToastTitle')
              );
            }

            return results;
          })
          .catch(function(error) {
            toastr.error(
              $translate.instant('modules.personnel.dossier.trainings.deleteErrToastText'),
              $translate.instant('modules.personnel.dossier.trainings.deleteErrToastTitle')
            );

            $log.error('ERROR: PersonnelDossierTrainingsController.deleteTraining: delete of Training failed!\n',
              training, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }

  this.exportTrainings = function(divisionId, memberId, trainingsIds, format, options, colsConfig, filterCriteria) {
    if (!memberId || !divisionId) {
      return $q.reject('ERROR: ArnoDashTrainingsService.exportTrainings: You have to provide all required params!');
    }

    return clientApi.openTab('trainings/export', {
      divisionId: divisionId,
      cMemberId: memberId,
      trainingsIds: trainingsIds && trainingsIds.length ? JSON.stringify(trainingsIds) : '',
      format: format,
      allOption: options.fields,
      filterCriteria: options.filter === 'filtered' && filterCriteria ? JSON.stringify(filterCriteria) : '',
      dataFields: options.fields === 'all' ? '{}' : JSON.stringify(colsConfig)
    }, { post: true });
  }

  // HELPERS
  this.setUniqTrainingTemplates = function(trainingTemplatesStore, allTrainingsByTrainingTemplates) {
    // build up mapping for training-templates
    _.forEach(allTrainingsByTrainingTemplates, function(training) {
      var existingTrainingTemplate = _.find(trainingTemplatesStore, {id: training.TrainingTemplate.id});

      if (!existingTrainingTemplate) {
        trainingTemplatesStore.push(training.TrainingTemplate);
        existingTrainingTemplate = training.TrainingTemplate;
      }

      existingTrainingTemplate.vmTrainings = existingTrainingTemplate.vmTrainings || [];
      existingTrainingTemplate.vmTrainings.push(training);
    });
  }

  this.buildAngularTreeControlNodes = function(trainingsTemplatesGroupsTree, trainingsWithTemplates) {
    if (!trainingsTemplatesGroupsTree) {
      return [];
    }

    var trainingTemplates = [];
    this.setUniqTrainingTemplates(trainingTemplates, trainingsWithTemplates);

    _.forEach(trainingTemplates, function(template) {
      template.children = _.map(template.vmTrainings, function(training) {
        return self.convertTrainingToNode(training);
      });

      var foundGroup = _.find(trainingsTemplatesGroupsTree, {id: template.TrainingTemplateGroupId});

      if (foundGroup) {
        foundGroup.TrainingTemplates = foundGroup.TrainingTemplates || [];
        foundGroup.TrainingTemplates.push(template);
      }
    });

    var groupsTree = ArnoDashTrainingGroupsService.buildAngularTreeControlNodes(trainingsTemplatesGroupsTree, true);

    return groupsTree;
  }

  this.convertTrainingToNode = function(model) {
    return {
      id: self.TRAININGS_NODE_TYPE + '-' + model.id,
      type: self.TRAININGS_NODE_TYPE,
      label: model.Name,
      matched: false,
      isSelected: false,
      iconCls: self.getIconClsForStatus(model.Status),
      labelCls: self.getLabelCls(model),

      model: model,

      TrainingTemplateId: model.TrainingTemplateId || model.TrainingTemplate.id
    }
  }

  this.getLabelCls = function(training) {
    if (!training) {
      return '';
    }

    var validityDate = moment(training.ValidityEndDate || null);
    if (validityDate.isValid() && validityDate.diff(moment()) < 0) {
      return 'training-validity-expired';
    }
  }

  this.getIconClsForStatus = function(trainingStatus) {
    var iconCls;

    switch (trainingStatus) {
    case 'PLANNED':
      iconCls = 'af af-graduation-cap-question';
      break;
    case 'INPROGRESS':
      iconCls = 'af af-graduation-cap-gear';
      break;
    case 'PENDING':
      iconCls = 'af af-graduation-cap-hourglass training-status-pending';
      break;
    case 'SUCCEEDED':
      iconCls = 'fa fa-graduation-cap training-status-succeeded';
      break;
    case 'FAILED':
      iconCls = 'fa fa-graduation-cap training-status-failed';
      break;

    default:
      iconCls = 'fa fa-graduation-cap';
    }

    return iconCls;
  }

}


/**
 * @name ArnoDashTrainingTemplatesService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide TrainingTemplate centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashTrainingTemplatesService', ArnoDashTrainingTemplatesService);

/** @ngInject */
function ArnoDashTrainingTemplatesService($q, commonUtils, clientApi) {
  var self = this;

  // CONSTS
  self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE = 'Template';

  /**
   * @name saveTemplate
   * @description This method add/or save a training-template-template.
   *
   * @param {Object} trainingTemplate
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.saveTemplate = function(trainingTemplate) {
    if (trainingTemplate) {
      return clientApi.custom('model/TrainingTemplate', 'saveTemplate', {
        trainingTemplate: trainingTemplate
      });
    }

    return $q.reject('ERROR: ArnoDashTrainingTemplatesService.saveTemplate: You have to provide a training-template object!');
  };

  /**
   * @name getTemplate
   * @description This method finds certain templates from db and returns as tree-data.
   *
   * @param {Object} templateId Id of the template
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getTemplate = function(templateId) {
    return clientApi.custom('model/TrainingTemplate', 'getTrainingTemplate', {trainingTemplateId: templateId});
  }

  /**
   * @name deleteTemplate
   * @description This method deletes a given training with all associated trainings! in the current org
   *
   * @param {Object} templateId Id of the template
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.deleteTemplate = function(templateId) {
    return clientApi.custom('model/TrainingTemplate', 'deleteTemplate', {trainingTemplateId: templateId});
  }
}


/**
 * @name ArnoDashTrainingGroupsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide TrainingTemplateGroup centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashTrainingGroupsService', ArnoDashTrainingGroupsService);

/** @ngInject */
function ArnoDashTrainingGroupsService($q, commonUtils, clientApi, ArnoDashTrainingTemplatesService) {
  var self = this;

  // CONSTS
  self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP = 'Group';

  self.FORMAT_TRAININGS_GROUPS_TREE_TYPE_ANGULAR_TREE_CONTROL = 'AngularUiTree';
  self.FORMAT_TRAININGS_GROUPS_TREE_TYPE_JS_TREE = 'JsTree';

  /**
   * @name saveGroup
   * @description This method add/or save a training-template-group.
   *
   * @param {Object} trainingTemplateGroup
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.saveGroup = function(trainingTemplateGroup) {
    if (trainingTemplateGroup) {
      return clientApi.custom('model/TrainingTemplateGroup', 'saveTrainingTemplateGroup', {
        trainingTemplateGroup: trainingTemplateGroup
      });
    }

    return $q.reject('ERROR: ArnoDashTrainingGroupsService.saveGroup: You have to provide a training-template-group object!');
  };

  /**
   * @name getGroupsTreeData
   * @description This method finds certain groups from db and returns as tree-data.
   *
   * @param {Object} trainingTemplateGroup
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getGroupsTreeData = function(includeTrainingTemplateData, formatForTreeview, onlyGroupsWithTrainingTemplates) {
    return clientApi.custom('model/TrainingTemplateGroup', 'getTrainingTemplateGroupTreeData', {
      includeTrainingTemplateData: includeTrainingTemplateData,
      onlyGroupsWithTrainingTemplates: onlyGroupsWithTrainingTemplates
    })
      .then(function(results) {
        switch(formatForTreeview) {
        case self.FORMAT_TRAININGS_GROUPS_TREE_TYPE_JS_TREE:
          return buildJsTreeNodes(results);

        case self.FORMAT_TRAININGS_GROUPS_TREE_TYPE_ANGULAR_TREE_CONTROL:
          return self.buildAngularTreeControlNodes(results);

        default:
          return results;
        }
      });
  }

  /**
   * @name getTrainingTemplateTree
   * @description This method retrieves the training-template with the template-groups to build up a tree
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getTrainingTemplateTree = function() {
    return clientApi.custom('model/TrainingTemplateGroup', 'getTrainingTemplateTreeData', {})
      .then(function(results) {
        if (results) {
          return self.buildAngularTreeControlNodesForTrainingTemplates(results.groups, results.trainingTemplates);
        }

        return results;
      });
  }

  this.deleteGroup = function (groupId) {
    return clientApi.custom('model/TrainingTemplateGroup', 'deleteGroup', { trainingTemplateGroupId: groupId });
  }

  // HELPERS
  this.buildAngularTreeControlNodes = function(trainingTemplateGroups, templatesHaveChildren) {
    // first create the required object-structure for tree-component
    var trainingTemplateGroupsTreeData = _.map(trainingTemplateGroups, function(trainingTemplateGroup) {
      var templateGroup = {
        id: self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP + '-' + trainingTemplateGroup.id,
        modelId: trainingTemplateGroup.id, // this is added for later easier access of the model.id
        type: self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP,
        data: {
          type: self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP,
          model: trainingTemplateGroup,
        },
        label: trainingTemplateGroup.Name,
        matched: false,
        isSelected: false,
        iconCls: 'fa fa-sitemap',

        model: trainingTemplateGroup,

        ParentTrainingTemplateGroupId: trainingTemplateGroup.ParentTrainingTemplateGroupId
      }

      templateGroup.trainingTemplates = _.map(templateGroup.model.TrainingTemplates, function(trainingTemplate) {
        return {
          id: ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE + '-' + trainingTemplate.id,
          modelId: trainingTemplate.id, // this is added for later easier access of the model.id
          type: ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE,
          label: trainingTemplate.Name,
          parent: templateGroup.modelId.toString(),
          data: {
            type: ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE,
            model: trainingTemplate,
            validityHelper: { // move this to separate component
              active: true,
              days: trainingTemplate.ValidityPeriodDays,
              months: trainingTemplate.ValidityPeriodMonths,
              years: trainingTemplate.ValidityPeriodYears,
            },
            changedQualifications: {},
            displayedCollection: [],
            selectedQualification: {},
            vm: {
              Qualifications: trainingTemplate.Qualifications || [],
              BaseCategories: trainingTemplate.BaseCategories || [],
              Notes: trainingTemplate.Notes,
              CountableHours: trainingTemplate.CountableHours,
            },
          },
          matched: false,
          isSelected: false,
          iconCls: 'fa fa-file-text-o',

          model: trainingTemplate,

          children: templatesHaveChildren ? trainingTemplate.children : undefined,

          ParentTrainingTemplateGroupId: templateGroup.id
        }
      });

      return templateGroup;
    });

    //now build up the tree-hierarchy
    return commonUtils.buildTreeFromFlatArray(trainingTemplateGroupsTreeData, 'ParentTrainingTemplateGroupId', 'modelId', 'trainingTemplates');
  }

  this.buildAngularTreeControlNodesForTrainingTemplates = function(trainingsTemplatesGroups, trainingTemplates) {
    if (!trainingsTemplatesGroups) {
      return [];
    }

    _.forEach(trainingTemplates, function(template) {
      var foundGroup = _.find(trainingsTemplatesGroups, {id: template.TrainingTemplateGroupId});

      if (foundGroup) {
        foundGroup.TrainingTemplates = foundGroup.TrainingTemplates || [];
        foundGroup.TrainingTemplates.push(template);
      }
    });

    // build the groups-tree with the templates
    return self.buildAngularTreeControlNodes(trainingsTemplatesGroups);
  }

  /**
   * @description This function is used for the old jsTree treeviews. It builds up the neccessary datastructure, which then can be rendered by jsTree
   */
  function buildJsTreeNodes(trainingTemplateGroups, options) {
    if (!trainingTemplateGroups) {
      return [];
    }

    var nodeResults = trainingTemplateGroups.reduce(function (redu, trainingTemplateGroup) {
      var rootIdSelector = options && options.rootOrg ? 'rootOrg' : '#';

      redu.push({
        // toString() is needed for "id" because jstree-view returns the id of the node as string...matching against it with number would fail
        id: trainingTemplateGroup.id.toString(),
        parent: trainingTemplateGroup.ParentTrainingTemplateGroupId ? trainingTemplateGroup.ParentTrainingTemplateGroupId : rootIdSelector,
        text: trainingTemplateGroup.Name,
        data: {
          type: self.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP,
          model: trainingTemplateGroup
        },
        state: {
          selected: options && !trainingTemplateGroup.disabled && options.selected  && !!~options.selected.indexOf(trainingTemplateGroup.id),
          opened: true
        },
      });

      // unwind the training-groups info about training-template to the same array as for training-groups (so the treeview can render also training-templates)
      if (trainingTemplateGroup.TrainingTemplates && trainingTemplateGroup.TrainingTemplates.length) {
        var trainingTemplateNodes = trainingTemplateGroup.TrainingTemplates.map(function(trainingTemplate) {
          return {
            id: 'template-' + trainingTemplate.id.toString(), // important: CONFLICTING ids !! because groups and templates have different table, so ids can have same value....
            parent: trainingTemplateGroup.id.toString(),
            text: trainingTemplate.Name,
            data: {
              type: ArnoDashTrainingTemplatesService.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE,
              validityHelper: { // move this to separate component
                active: true,
                days: trainingTemplate.ValidityPeriodDays,
                months: trainingTemplate.ValidityPeriodMonths,
                years: trainingTemplate.ValidityPeriodYears,
              },
              changedQualifications: {},
              displayedCollection: [],
              selectedQualification: {},
              model: trainingTemplate,
              vm: {
                Qualifications: trainingTemplate.Qualifications || [],
                BaseCategories: trainingTemplate.BaseCategories || [],
                Notes: trainingTemplate.Notes,
                CountableHours: trainingTemplate.CountableHours,
              }
            },
            icon: 'fa fa-file-text-o',
            state: {
              selected: options && !trainingTemplate.disabled && options.selected  && !!~options.selected.indexOf(trainingTemplate.id),
              opened: true,
              disabled: !!trainingTemplate.disabled
            },
          }
        });

        redu = redu.concat(trainingTemplateNodes); // use spread-operator after at least es6 have been added
      }

      return redu;
    }, []);

    return nodeResults;
  }
}


/**
 * @name ArnoDashAdminStatisticsGroupsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide StatisticGroup centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminStatisticsGroupsService', ArnoDashAdminStatisticsGroupsService);

/** @ngInject */
function ArnoDashAdminStatisticsGroupsService($q, clientApi) {

  /**
   * @name deleteGroup
   * @description This method deletes a group, with the option to delete the statistics too
   *
   * IMPORTANT REMARK: it was decided to remove all backend-endpoints to remove things from statistics-module
   * so for this to work you have to add back the source in models/StatisticGroup.js
   *
   * @param {String} groupId
   * @param {Boolean}  isFullDelete
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.deleteGroup = function(groupId, isFullDelete) {
    if (groupId) {
      return clientApi.custom('model/StatisticGroup', 'deleteGroup', {
        groupId: groupId,
        isFullDelete: isFullDelete,
      });
    }

    return $q.reject('ERROR: ArnoDashAdminStatisticsGroupsService.deleteGroup: You have to provide the groupId!');
  };
}


/**
 * @name ArnoDashAdminStatisticsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Statistic (Statistic) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminStatisticsService', ArnoDashAdminStatisticsService);

/** @ngInject */
function ArnoDashAdminStatisticsService($q, clientApi) {
  /**
   * @name changeGroup
   * @description This method changes the current group the statistic belongs to
   *
   * @param {Statistic} statistic    The "Statistic" (statistic) object defined with sequelize
   * @param {Number}  newGroupId  The id of the new group which the statistic should be assigned to
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.changeGroup = function(statistic, newGroupId) {
    if (statistic && newGroupId) {
      return clientApi.custom('model/Statistic', 'updateOneStatistic', {
        statisticId: statistic.id,
        statisticData: {
          Title: statistic.Title,
          OrganizationId: statistic.OrganizationId,
          Description: statistic.Description,
          StatisticGroupId: newGroupId
        },
      });
    }

    return $q.reject('ERROR: ArnoDashAdminStatisticsService.changeGroup: You must provide the statistic and the id of the new group!');
  };

}

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('stateChangePrompt', function ($q, $timeout, $uibModal, $transitions, commonUtils) {
      var self = {
        nextChangeEvaluationFn: null,
        changeDeregistrationFn: null,
        abortContext: false,
        skipNext: false,
        evaluate: function (evaluationFunc) {
          // evaluationFunc should return true if state change is unproblematic
          // ... and false if we should prompt the user
          self.nextChangeEvaluationFn = evaluationFunc;
          self.abortLocationChangeWatch();

          // cut out possible initial location state changes
          $timeout(function () {
            self.changeDeregistrationFn = $transitions.onBefore({}, self.locationChangeStart);
          }, 0, false);
        },
        disableEvaluation: function () {
          self.abortLocationChangeWatch();
          self.nextChangeEvaluationFn = null;
          self.abortContext = false;
        },
        ignoreNextEvaluation: function() {
          self.skipNext = true;
        },
        abortLocationChangeWatch: function () {
          if (angular.isFunction(self.changeDeregistrationFn)) {
            self.changeDeregistrationFn();
            self.changeDeregistrationFn = null;
          }
        },
        locationChangeStart: function (transition) {
          if (self.skipNext) {
            self.skipNext = false;
            return true;
          }
          self.abortContext = false;
          if (!angular.isFunction(self.nextChangeEvaluationFn) || self.nextChangeEvaluationFn()) {
            self.disableEvaluation();
            return true;
          }
          var deferred = $q.defer();
          self.openConfirmModal()
            .then(function () {
              self.disableEvaluation();
              deferred.resolve(true);
            })
            .catch(function () {
              // user has denied state change
              // reset ctx if it was changed
              self.abortContext = true;
              transition.abortedDueTo = 'STATE_CHANGE_PROMPT';
              deferred.resolve(false);
            });

          return deferred.promise;
        },
        setAbortContext: function (abortContext, ctxOptions) {
          if (self.abortContext) {
            self.abortContext = false;
            commonUtils.division.setCtx(abortContext, ctxOptions);
          }
        },
        openConfirmModal: function () {
          return $uibModal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'app/pages/service/confirmStateChange.html',
            size: 'md'
          }).result;
        }
      };
      return self;
    });
})();


/**
 * @name ArnoDashPricesService
 * @description This Service is responsible to communicate with the backend through the clientApi-Service
 * to provide CustomPriceItem centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('QuotInvService', QuotInvService);

/** @ngInject */
function QuotInvService(
  $translate, clientApi, toastr, baModalService, dateFilter
) {
  var self = this;

  self.removeQuotInv = function(id, isInvoice, ctx, creator, createdAt, needsApproval) {
    self.translateIsInvoice = { isInvoice: isInvoice };

    return baModalService
      .messageModal({
        modalType: 'danger',
        allowHtml: false,

        title: $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestTitle' : 'modules.finances.quotInvDetails.removeTitle', self.translateIsInvoice),
        content: $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestBody' : 'modules.finances.quotInvDetails.removeBody', {
          isInvoice: isInvoice,
          creator: creator,
          createdAt: dateFilter(createdAt, 'dd.MM.yyyy HH:mm'),
        }),

        primaryActionText: $translate.instant(needsApproval ? 'generalTerms.deny' : 'generalTerms.delete'),
        secondaryActionText: $translate.instant('generalTerms.cancel'),
      })
      .then(function () {
        return clientApi
          .custom(
            isInvoice ? 'model/Invoice' : 'model/Quotation',
            isInvoice ? 'removeInvoice' : 'removeQuotation',
            { divisionId: ctx, quotationId: id, invoiceId: id }
          )
          .then(function () {
            toastr.success(
              $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestSuccessBody' : 'modules.finances.quotInvDetails.removeSuccessBody', self.translateIsInvoice),
              $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestSuccessTitle' : 'modules.finances.quotInvDetails.removeSuccessTitle', self.translateIsInvoice)
            );
          })
          .catch(function () {
            toastr.error(
              $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestFailBody' : 'modules.finances.quotInvDetails.removeFailBody', self.translateIsInvoice),
              $translate.instant(needsApproval ? 'modules.finances.quotInvDetails.removeRequestFailTitle' : 'modules.finances.quotInvDetails.removeFailTitle', self.translateIsInvoice)
            );
          });
      });
  }
}


/**
 * @name ArnoDashQualificationsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Qualification (Qualification) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashQualificationsService', ArnoDashQualificationsService);

/** @ngInject */
function ArnoDashQualificationsService($q, clientApi, toastr) {
  /**
   * @name getAllQualifications
   * @description This method changes the current group the qualification belongs to
   *
   * @param {Array<String>} attributes  The attributes/properties which should be returned from api
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getAllQualifications = function(attributes) {
    return clientApi.custom('model/Qualification', 'getAllQualifications', {
      attributes: attributes
    });
  };

  /**
   * @name searchQualifications
   * @description This method changes the current group the qualification belongs to
   *
   * @param {String} name  The name of the qualification to look for
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.searchQualifications = function(name) {
    return clientApi.custom('model/Qualification', 'searchQualificationsByName', {
      name: name
    });
  }

  /**
   * @name getMemberQualifications
   * @description This method changes the current group the qualification belongs to
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getMemberQualifications = function(divisionId, memberId) {
    return clientApi.custom('model/MemberQualification', 'getMemberQualification', { divisionId: divisionId, cMemberId: memberId });
  }

  /**
   * @name updateMemberQualifications
   * @description This method updates the with the given qualifications-changes
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.updateMemberQualificationsWithNotifications = function(member, divisionIds, changedQualifications) {
    if (!changedQualifications || !member || !member.id || !divisionIds) {
      throw new Error('ArnoDashQualificationsService.updateMemberQualificationsWithNotifications: Not all required params given!')
    }

    if ((changedQualifications.add && changedQualifications.add.length)
      || (changedQualifications.edit && changedQualifications.edit.length)
      || (changedQualifications.delete && changedQualifications.delete.length)
    ) {
      return clientApi
        .custom('model/MemberQualification', 'updateMemberQualifications', {
          cMemberId: member.id,
          qualificationChanges: changedQualifications,
          divisionIds: divisionIds,
          lastEditTime: new Date(),
        })
        .then(function (result) {
          toastr.success('Die Qualifikationen wurden erfolgreich gespeichert.', 'Qualifikationen gesichert');

          return result;
        })
        .catch(function (error) {
          toastr.error('Die Qualifikationen konnten nicht gespeichert werden.', 'Bearbeitung gescheitert');

          return Promise.reject(error);
        });
    }
    else {
      toastr.info('Es wurden keine Änderungen zum Abspeichern erkannt.', 'Kein Änderungen');
    }
  }

}


/**
 * @name ArnoDashQualificationGroupsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide QualificationGroup (QualificationGroup) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashQualificationGroupsService', ArnoDashQualificationGroupsService);

/** @ngInject */
function ArnoDashQualificationGroupsService($q, clientApi) {
  /**
   * @name getAllQualificationGroups
   * @description This method fetches qualifciation-groups with its hierarchy
   *
   * @param {Array<String>} divisionId  OPTIONAL, the id for a specific division, if it should be restricted
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getQualificationGroups = function (divisionId, isOwnDossier) {
    var divId = divisionId;

    if (divisionId && (divisionId === 'rootOrg' || (divisionId.length === 1 && divisionId[0] === 'rootOrg'))) {
      divId = null;
    }

    return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: divId, isOwnDossier: isOwnDossier});
  };
}

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('progressBar', function (ngProgressFactory, $timeout, pageButtons) {
      var self = {
        progressInstance: null,
        stacks: 0,
        inErrorState: false,
        startPending: null,
        endPending: null,
        resolveStartPending: function () {
          if (self.startPending) {
            $timeout.cancel(self.startPending);
            self.startPending = null;
          }
        },
        start: function () {
          if (!self.inErrorState) {
            if (!self.stacks++) {
              if (self.endPending) {
                $timeout.cancel(self.endPending);
                self.endPending = null;
              } else {
                self.startPending = $timeout(function () {
                  self.startPending = null;
                  self.progressInstance && self.progressInstance.start();
                }, 300);
              }
              pageButtons.disable();
            }
          }
        },
        complete: function (err) {
          if (!self.inErrorState) {
            if (err) {
              return self.error();
            }
            if (!--self.stacks) {
              self.stacks = 0; // never fall below zero
              if (self.startPending) {
                self.resolveStartPending();
              } else {
                self.endPending = $timeout(function () {
                  self.endPending = null;
                  self.progressInstance && self.progressInstance.complete();
                }, 250);
              }
              pageButtons.enable();
            }
          }
        },
        setInc: function (inc) {
          self.progressInstance && self.progressInstance.set(inc);
        },
        error: function () {
          if (self.progressInstance) {
            self.resolveStartPending();
            self.setInc(100);
            var ngProgress = $('#ngProgress');
            var d = 200;
            ngProgress.delay(d * 2).hide(0).delay(d).show(0)
              .delay(d).hide(0).delay(d).show(0)
              .delay(d).hide(0).delay(d).show(0);
            self.inErrorState = $timeout(function () {
              self.inErrorState = false;
              self.resolveError();
            }, d * 7, false);
          }
        },
        resolveError: function () {
          if (self.progressInstance) {
            if (self.inErrorState) {
              self.inErrorState();
            }
            self.progressInstance.complete();
            self.stacks = 0;
            self.inErrorState = false;
            pageButtons.enable();
          }
        }
      };
      self.progressInstance = ngProgressFactory.createInstance();
      return self;
    });
})();

/**
 * @name ArnoDashPricesService
 * @description This Service is responsible to communicate with the backend through the clientApi-Service
 * to provide CustomPriceItem centric methods.
 *
 */
angular
  .module('ArnoDash')
  .service('ArnoDashPricesService', ArnoDashPricesService);

/** @ngInject */
function ArnoDashPricesService(
  $q, $log, $translate, clientApi, toastr, baModalService, $uibModal,
  ARNO_CONSTANTS
) {
  var self = this;

  // METHODS
  /**
   * @params price                              Price for calcualation
   * @params priceUnitCount               Count of selected price-unit-type
   * @params taxRatePercent              Tax-rate in percent, so 16% tax-rate will / must be passed as 16
   */
  self.calcSumForPosition = function (price, priceUnitCount, taxRatePercent) {
    if (typeof price === 'number' && typeof priceUnitCount === 'number' && typeof taxRatePercent === 'number'
      && !Number.isNaN(price) && !Number.isNaN(priceUnitCount) && !Number.isNaN(taxRatePercent)
    ) {
      var sum = 0;
      var tempSum = 0;

      tempSum = price * priceUnitCount;
      sum = tempSum + tempSum * taxRatePercent / 100;

      return sum;
    }

    return null;
  }

  self.calcDiscount = function (totalSum, priceUnitBases, discount, discountUnit) {
    var parsedDiscount = parseFloat(discount);
    var total = totalSum;
    if (!total && priceUnitBases) {
      total = self.calcTotalSumForPositions(priceUnitBases);
    }

    if (total) {
      if (discountUnit === 'PERCENT') {
        return total * parsedDiscount / 100;
      }
      return parsedDiscount;
    }
    return 0;
  }

  self.searchPriceItems = function (searchTerm, queryOptions) {
    return clientApi.emit('priceItems/search', { searchTerm: searchTerm, queryOptions: queryOptions });
  }

  self.saveMaterialTypePrices = function (materialTypeWithPrices) {
    return clientApi
      .custom('model/MaterialType', 'savePrices', {
        materialType: materialTypeWithPrices
      });
  }

  /**
   * @name savePriceItemWithNotifications
   *
   * @param {Object} priceItem Data of the cost-center to be saved. If no id is present, then a new cost-center will be created!
   *
   * @return The promise for the api request from clientApi-Service
   */
  self.savePriceItemWithNotifications = function (priceItem, divisionId, priceType) {
    if (priceItem) {
      var transferObj = _.clone(priceItem);
      transferObj.CostCenterSpecificationId = (transferObj.CostCenterSpecification || { id: transferObj.CostCenterSpecificationId }).id;

      var priceSavePromise;

      switch (priceType) {
      case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE:
        priceSavePromise = self.saveMaterialTypePrices(transferObj);
        break;

      case ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM: case ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION: default:
        var priceTypeApiConf = {
          CUSTOM: { model: 'model/CustomPriceItem', route: 'saveCustomPriceItem' },
          SERVICE_POSITION: { model: 'model/ServiceFunction', route: 'updatePrices' }
        };

        priceSavePromise = clientApi.custom(priceTypeApiConf[priceType].model, priceTypeApiConf[priceType].route, {
          divisionId: divisionId,
          priceItem: transferObj,
        });
        break;
      }

      return priceSavePromise.then(function () {
        toastr.success(
          $translate.instant('modules.administration.finances.prices.saveSuccessMsg'),
          $translate.instant('modules.administration.finances.prices.saveSuccessTitle')
        );
      })
        .catch(function (error) {
          toastr.error(
            $translate.instant('modules.administration.finances.prices.saveFailedGenericMsg'),
            $translate.instant('modules.administration.finances.prices.saveFailedTitle')
          );
          throw error;
        });
    }

    return $q.reject('ERROR: ArnoDashCustomPricesService.savePriceItemWithNotifications: You have to provide a customPriceItem object!');
  };

  /**
   * @name deletePriceItem
   * @description This method deletes a given priceItem by id
   */
  self.deletePriceItem = function (divisionId, priceType, priceItem) {
    var transferObj = _.clone(priceItem);

    var priceDeletePromise;

    switch (priceType) {
    case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE:
      priceDeletePromise = self.deleteMaterialTypesPrices(priceItem.id);
      break;

    case ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM: case ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION: default:
      var priceTypeApiConf = {
        CUSTOM: { model: 'model/CustomPriceItem', route: 'deleteCustomPriceItem' },
        SERVICE_POSITION: { model: 'model/ServiceFunction', route: 'deletePrices' },
      };

      priceDeletePromise = clientApi.custom(priceTypeApiConf[priceType].model, priceTypeApiConf[priceType].route, {
        divisionId: divisionId,
        priceItemId: transferObj.ServicePositionTemplateId || transferObj.id,
      });
      break;
    }

    return priceDeletePromise;
  }

  /**
   * @name deletePriceItemWithMessageModal
   * @description This method show a message-modal and asks the user to delete a customPriceItem
   * it handles success and error cases with toastr
   */
  self.deletePriceItemWithMessageModal = function (divisionId, priceType, priceItem) {
    var priceItemTitle = (priceItem || {}).Title || (priceItem || {}).Name || (priceItem || {}).Function;

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.administration.finances.prices.deleteConfirmTitle'),
      content: $translate.instant('modules.administration.finances.prices.deleteConfirmMsg', { priceItemTitle: priceItemTitle }),

      primaryActionText: $translate.instant('generalTerms.remove'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function () {
        return self.deletePriceItem(divisionId, priceType, priceItem)
          .then(function (results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.administration.finances.prices.deleteSuccessMsg', { priceItemTitle: priceItemTitle }),
                $translate.instant('modules.administration.finances.prices.deleteSuccessTitle')
              );
            }

            return results;
          })
          .catch(function (error) {
            toastr.error(
              $translate.instant('modules.administration.finances.prices.deleteFailedMsg'),
              $translate.instant('modules.administration.finances.prices.deleteFailedTitle')
            );

            $log.error('ERROR: ArnoDashCustomPricesService.deleteCustomPriceItem: delete of CustomPriceItem failed!\n',
              priceItem, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }

  self.deleteMaterialTypesPrices = function (materialTypeId) {
    return clientApi
      .custom('model/MaterialType', 'deletePrices', {
        materialTypeId: materialTypeId
      });
  }

  self.saveMaterialsPrices = function (category, materialsWithPrices) {
    if (category && materialsWithPrices) {
      return clientApi.emit('priceItems/saveMaterialsPrices', {
        materialCategory: 'Material' + category,
        materials: materialsWithPrices
      }).then(function () {
        toastr.success(
          $translate.instant('modules.administration.finances.prices.saveSuccessMsg'),
          $translate.instant('modules.administration.finances.prices.saveSuccessTitle')
        );
      })
        .catch(function (error) {
          toastr.error(
            $translate.instant('modules.administration.finances.prices.saveFailedGenericMsg'),
            $translate.instant('modules.administration.finances.prices.saveFailedTitle')
          );
          throw error;
        });
    }

    return Promise.reject(new Error('ArnoDashPricesService.saveMaterialsPrices: missing params!'));
  }

  self.deleteMaterialsPrices = function (category, materialsIds) {
    if (category && materialsIds) {
      return clientApi.emit('priceItems/deleteMaterialsPrices', {
        materialCategory: 'Material' + category,
        materialsIds: materialsIds
      });
    }

    return Promise.reject(new Error('ArnoDashPricesService.deleteMaterialsPrices: missing params!'));
  }

  self.deleteMaterialsPricesWithMessageModal = function (materialCategory, materialsIds) {
    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.administration.finances.prices.deleteConfirmTitle'),
      content: $translate.instant('modules.administration.finances.prices.deleteConfirmMsg'),

      primaryActionText: $translate.instant('generalTerms.remove'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function () {
        return self.deleteMaterialsPrices(materialCategory, materialsIds)
          .then(function (results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.administration.finances.prices.deleteSuccessMsg'),
                $translate.instant('modules.administration.finances.prices.deleteSuccessTitle')
              );
            }

            return results;
          })
          .catch(function (error) {
            toastr.error(
              $translate.instant('modules.administration.finances.prices.deleteFailedMsg'),
              $translate.instant('modules.administration.finances.prices.deleteFailedTitle')
            );

            $log.error('ERROR: ArnoDashPricesService.deleteMaterialsPricesWithMessageModal: delete of price-data failed!\n',
              materialsIds, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }

  self.overridePriceItem = function (divisionId, priceType, priceItem, priceItemOverride) {
    if (!priceType || !priceItem) {
      return $q.reject('ERROR: ArnoDashCustomPricesService.overridePriceItem: missing params!');
    }

    return clientApi.custom('model/PriceItemOverride', 'savePriceItemOverride', {
      divisionId: divisionId,

      priceType: priceType,
      priceItem: priceItem,
      priceItemOverride: priceItemOverride,
    });
  }

  self.deletePriceItemOverride = function (priceItemOverrideId) {
    if (!priceItemOverrideId) {
      return $q.reject('ERROR: ArnoDashCustomPricesService.deletePriceItemOverride: missing params!');
    }

    return clientApi.custom('model/PriceItemOverride', 'deletePriceItemOverride', {
      priceItemOverrideId: priceItemOverrideId,
    });
  }

  self.deletePriceItemOverrideWithMessageModal = function (priceItem, priceItemOverride) {
    if (!priceItem || !priceItemOverride) {
      return $q.reject('ERROR: ArnoDashCustomPricesService.deletePriceItemOverrideWithMessageModal: missing params!');
    }

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.administration.finances.prices.deleteOverrideConfirmTitle'),
      content: $translate.instant('modules.administration.finances.prices.deleteOverrideConfirmMsg', {
        title: priceItem.Title || priceItem.Name || priceItem.Function
      }),

      primaryActionText: $translate.instant('generalTerms.remove'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function () {
        return self.deletePriceItemOverride(priceItemOverride.id)
          .then(function (results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.administration.finances.prices.deleteOverrideSuccessMsg'),
                $translate.instant('modules.administration.finances.prices.deleteOverrideSuccessTitle')
              );
            }

            return results;
          })
          .catch(function (error) {
            toastr.error(
              $translate.instant('modules.administration.finances.prices.deleteOverrideFailedMsg'),
              $translate.instant('modules.administration.finances.prices.deleteOverrideFailedTitle')
            );

            $log.error('ERROR: ArnoDashPricesService.deletePriceItemOverrideWithMessageModal: delete of price-item-override failed!\n',
              priceItemOverride, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }


  self.openPriceDetailsModal = function (divisionId, priceType, priceItem) {
    return $uibModal
      .open({
        controller: 'AdminFinancesPriceDetailsModalCtrl as self',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/finances/prices/modals/detailsModal.html',
        size: 'md',
        resolve: {
          priceType: function () {
            return priceType;
          },
          uiConfig: function () {
            // NOTE: material / material-type price-types dont call this service-method
            switch (priceType) {
            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM:
              return {
                showTitleField: true,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixCustom'
              }

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL:
              return {
                showTitleField: false,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixMaterial'
              }

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE:
              return {
                showTitleField: false,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixMaterialType'
              }

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION:
              return {
                showTitleField: false,
                titlePrefix: 'modules.administration.finances.prices.detailsModal.titlePrefixServiceFunction'
              }
            }

          },
          targetPriceItems: function () {
            return priceItem ? [priceItem] : [];
          },
          selectedDivisionId: function () {
            return divisionId
          },
          presetPrices: function () {
            return null;
          }
        }
      })
      .result
      .then(function (priceItem) {
        return self.savePriceItemWithNotifications(priceItem, divisionId, priceType);
      });
  }

  self.openPriceOverrideModal = function (divisionId, priceType, priceItemOverride, presetPrices) {
    return $uibModal
      .open({
        controller: 'AdminFinancesPriceDetailsModalCtrl as self',
        animation: true,
        backdrop: 'static',
        templateUrl: 'app/pages/administration/finances/prices/modals/detailsModal.html',
        size: 'md',
        resolve: {
          priceType: function () {
            return priceType;
          },
          uiConfig: function () {
            var uiConfig = {
              showIdField: false,
              showTitleField: false,
              title: !(priceItemOverride || {}).id ? 'modules.administration.finances.prices.detailsModal.titleOverride' : 'modules.administration.finances.prices.detailsModal.titleOverrideEdit'
            }

            switch (priceType) {
            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.CUSTOM:
              uiConfig.titlePrefix = 'modules.administration.finances.prices.detailsModal.titlePrefixCustom';
              break;

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL:
              uiConfig.titlePrefix = 'modules.administration.finances.prices.detailsModal.titlePrefixMaterial';
              break;

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.MATERIAL_TYPE:
              uiConfig.titlePrefix = 'modules.administration.finances.prices.detailsModal.titlePrefixMaterialType';
              break;

            case ARNO_CONSTANTS.PRICE_ITEM_TYPE.SERVICE_POSITION:
              uiConfig.titlePrefix = 'modules.administration.finances.prices.detailsModal.titlePrefixServiceFunction';
              break;
            }

            return uiConfig;
          },
          targetPriceItems: function () {
            return priceItemOverride ? [priceItemOverride] : [];
          },
          selectedDivisionId: function () {
            return divisionId;
          },
          presetPrices: function () {
            return presetPrices;
          },
        }
      })
      .result;
  }
}

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('portalLogoService', function ($rootScope, commonUtils, clientApi) {
      var self = {
        // Color sets for default ARNO logo
        logoColorsDefault: {
          logoBg: '#FFFFFF',
          primary: '#D9222A',
          stroke: '#B4B5B4',
          puzzleRight: '#9E9F9E',
          puzzleLeft: '#1A1918',
          secondary: '#343433',
        },

        logoColorsInverted: {
          logoBg: '#D9222A',
          primary: '#FFFFFF',
          stroke: '#D9222A',
          puzzleRight: '#1A1918',
          puzzleLeft: '#9E9F9E',
          secondary: '#343433',
        },

        logoColorsFilter:{
          logoBg: 'var(--color-logo-bg)',
          primary: 'var(--color-primary)',
          colorStroke: '#B4B5B4',
          puzzleRight: 'var(--color-logo-puzzle-right)',
          puzzleLeft: 'var(--color-logo-puzzle-left)',
          secondary: 'var(--color-logo-n)',
        }        ,

        //initial data
        useSquareInNavigation: false,
        useExtInNavigation: false,
        showInFooter: false,
        useFilter: false,
        showOrgLabel: false,
        inverted: false,
        data: null,
        dataExt: null,

        getOrgLogo: function(type) {
          return clientApi.emit('orglogoStorage/get', {
            type: type,
          })
            .then(function(data) {
              if (data.imagedata && data.filetype) {
                return data;
              }
              return null
            })
            .catch(function(err) {
              console.error(err);
              return null;
            });
        }
      };
      return self;
    });
})();

/**
 * @name persistFilters
 * @description This Service is responsible for persisting selected filters in tables across a multitude of modules
 */
(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('persistFilter', function () {
      var self = {
        applyAndSave: function (filters, appliedCheck, storedFilters, currentCtx, params, storageKey, specialFilters, availableFields, tableConfig) {
          // persist filter settings in local storage, apply if filters are initially empty (normal state reload)
          if (params) {
            if (appliedCheck[currentCtx] || !storedFilters) {
              filters[currentCtx] = {
                regularFilters: (params && params.search && params.search.predicateObject ? params.search.predicateObject : null),
                sort: params.sort,
                pagination: {},
              };

              if (specialFilters && Object.keys(specialFilters).length) {
                if (filters[currentCtx] && !filters[currentCtx].specialFilters) {
                  filters[currentCtx].specialFilters = {};
                }

                if (filters[currentCtx]) {
                  var special = filters[currentCtx].specialFilters;
                  Object.keys(specialFilters).forEach(function (key) {
                    special[key] = specialFilters[key];
                  });
                }
              }
              localStorage.setItem(storageKey, JSON.stringify(filters));
            }

            if (storedFilters && !appliedCheck[currentCtx]) {
              appliedCheck[currentCtx] = true;
              try {
                var parsedFilters = JSON.parse(storedFilters)[currentCtx];
              } catch (e) {
                // filter is empty, nothing to apply
              }

              if (availableFields && tableConfig && parsedFilters && parsedFilters.sort && parsedFilters.sort.predicate) {
                // remove sort in parsed filter when table config doesn't contain column (anymore)
                var sortProp = (_.find(availableFields, {field: parsedFilters.sort.predicate}) || {}).prop;
                if (!sortProp || !tableConfig[sortProp]) {
                  parsedFilters.sort = {};
                }
              }
              
              if (params && params.search && !params.search.predicateObject) {
                params.search.predicateObject = {};
              }
              if (parsedFilters) {
                if (params && params.search && !params.search.predicateObject) {
                  _.extend(params.search.predicateObject, parsedFilters.regularFilters);
                }
                if (parsedFilters.specialFilters) {
                  // clean out any arrays or objects we have in the special filters
                  // this way we keep the reference to the origin array/object
                  Object.keys(specialFilters).forEach(function (key) {
                    if (specialFilters[key] && Array.isArray(specialFilters[key]) &&
                      parsedFilters.specialFilters[key] && Array.isArray(parsedFilters.specialFilters[key]) && !!~parsedFilters.specialFilters[key].length) { // eslint-disable-line no-extra-boolean-cast
                      specialFilters[key].splice(0, specialFilters[key].length);
                      // array wiped, now we push stored values in
                      parsedFilters.specialFilters[key].forEach(function (element) {
                        specialFilters[key].push(element);
                      });
                    } else if (
                      typeof specialFilters[key] === 'object'
                      && typeof parsedFilters.specialFilters[key] === 'object'
                      && Object.keys(parsedFilters.specialFilters[key]).length
                    ) {
                      Object.keys(specialFilters[key]).forEach(function (subKey) {
                        delete specialFilters[key][subKey];
                      });
                      // object wiped, now we assign the stored object
                      _.extendWith(specialFilters[key], parsedFilters.specialFilters[key], function (obj, src) {
                        if (!isNaN(new Date(src).getTime())) {
                          return moment(src).toDate();
                        }
                      });
                    }
                  });
                }
                params.sort = parsedFilters.sort;
                
                if (parsedFilters.pagination) {
                  params.pagination = parsedFilters.pagination;
                }
              }
            }          
          }
        },
        setPaginationPersist: function (filters, currentCtx, pagination, storageKey) {
          if (!filters[currentCtx]) {
            filters[currentCtx] = {};
          }
          if (!filters[currentCtx].pagination) {
            filters.pagination = {};
          }
          filters[currentCtx].pagination = pagination;
          localStorage.setItem(storageKey, JSON.stringify(filters));
        }
      };
      return self;
    });
})();

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('permissions', function () {
      var permissions = {};
      // var scopes = {};

      var self = {
        /**
         * initialize permissions service with db result
         *
         * @param  {Array} flatPermissions array with permission information
         */
        init: function (permissionsTree) {
          if (permissionsTree) {
            permissions = permissionsTree.permissions || {};
            // scopes = permissionsTree.scopes || {};
          }
        },

        /**
         * filter given ids and only keep ids with specified permission
         *
         * @param  {string}   permission  permission name
         * @param  {string}   scope       scope ('Division' | 'Organization' | 'Tenant')
         * @param  {Array}    ids         Array of ids {number|string}
         * @param  {boolean}  allowSub    will also succeed if a subpermission of the given permission was found
         * @return {Array}                filtered ids  {number|string} - depending on input
         */
        getPermittedIds: function (permission, scope, ids, allowSub) {
          if (!ids) {
            return [];
          }

          var permittedIds = [];
          permission.split(',').forEach(function(perm) {
            if (allowSub) {
              var useableSubPermissions = _.pickBy(permissions, function (scopes, basePermission) {
                return basePermission.indexOf(perm) === 0 && scopes[scope];
              });
              permittedIds = permittedIds.concat(_.flatten(Object.keys(useableSubPermissions).map(function (subPermissionKey) {
                return (useableSubPermissions[subPermissionKey] && useableSubPermissions[subPermissionKey][scope]) || [];
              })));
            }
            permittedIds = permittedIds.concat(_.uniq(permittedIds.concat((permissions[perm] && permissions[perm][scope]) || [])));
          });

          if (permittedIds.length) {
            return ids.filter(function (id) {
              // some + == comparison due to varying types in ids
              return permittedIds.some(function (permittedId) {
                return permittedId == id
              });
            });
          } else {
            return [];
          }
        },

        /**
         * pulls permission name for a specific scope from a multi scope permission config
         * e.g. 'Division:arno.example.divPermission,Organization:arno.example.orgPermission' + 'Division'
         * --> 'arno.example.divPermission'
         *
         * @param  {string} permission permission config like 'arno.example.divPermission' or 'Division:arno.example.divPermission,Organization:arno.example.orgPermission'
         * @param  {string} scope      permission scope like 'Division'
         * @return {string}            permission name like 'arno.example.divPermission'
         */
        getScopedPermission: function (permission, scope) {
          var toCheck = {};
          if (permission.indexOf(':') !== -1) {
            permission.split(',').forEach(function (rule) {
              var split = rule.split(':');
              toCheck[split[0]] = split[1];
            });
          } else {
            toCheck[scope] = permission;
          }
          return toCheck[scope];
        },

        /**
         * check if permission or subpermission has been granted on specified scope (or any scope if scope was omitted)
         *
         * @param  {string|Object} targetState       permission name like 'arno.personnel.personnelList.view' or TargetState
         * @param  {Array}         optionalScopes    [{string}], if provided check for these scopes, if not ignore scope
         * @return {boolean}                         true if (for example) 'arno.personnel.personnelList.view' or 'arno.personnel' (, ...) has been granted
         */
        isPermittedAnywhere: function (targetState, optionalScopes) {
          var permissionToCheck = targetState;
          var scopes = optionalScopes;
          if (typeof targetState === 'object' && !Array.isArray(targetState)) {
            var state = targetState.state();
            scopes = scopes || state.viewPermissionScopes;
            permissionToCheck = state.viewPermission || targetState.name();
          }
          if (~['arno.dashboard', 'arno.legal.termsOfUse', 'arno.legal.privacyStatement'].indexOf(targetState && targetState.name && targetState.name() || targetState)) {
            return true; // permit visiting dashboard and legal pages - even for brand new users
          }
          if (((targetState && targetState.name && targetState.name() || targetState).indexOf('arno.personnel.dossier') === 0)) {
            return true; // permit visiting dossier, dossier will check for unpermitted access
          }
          if ((permissionToCheck && Array.isArray(permissionToCheck)) || (targetState && Array.isArray(targetState))) {
            var permittedColl = [];
            (permissionToCheck || targetState).forEach(function(vp) {
              permittedColl.push(self.isPermittedAnywhere(vp, optionalScopes));
            });
            return _.compact(permittedColl).length;
          }

          return Object.keys(permissions).some(function (permission) {
            // if multiple opts, check if ONE of them is permitted
            var isPermitted = permission === permissionToCheck || (permission + '.').indexOf(permissionToCheck) === 0;
            if (isPermitted && scopes) {
              isPermitted = scopes.some(function (scope) {
                return !!permissions[permission][scope];
              });
            }
            return isPermitted;
          });
        },

        /**
         * true if given permission was found in all of the ids for specified scope,
         * if permission name is an empty string, returns true
         *
         * @param  {string}   permission permission name
         * @param  {string}   scope      scope ('Division' | 'Organization' | 'Tenant')
         * @param  {Array}    ids        Array of ids {number|string}
         * @param  {boolean}  allowSub   will also succeed if a subpermission of the given permission was found
         */
        isPermittedInEvery: function (permission, scope, ids, allowSub) {
          if (!permission || !ids || !ids.length) {
            return false;
          }
          return self.getPermittedIds(permission, scope, ids, allowSub).length === ids.length;
        },

        /**
         * true if given permission was found in any of the ids for specified scope,
         * if permission name is an empty string, returns true
         *
         * @param  {string} permission permission name
         * @param  {string} scope      scope ('Division' | 'Organization' | 'Tenant')
         * @param  {Array}  ids        Array of ids {number|string}
         * @param  {boolean}  allowSub   will also succeed if a subpermission of the given permission was found
         */
        isPermittedInSome: function (permission, scope, ids, allowSub) {
          if (!permission) {
            return false;
          }
          return self.getPermittedIds(permission, scope, ids, allowSub).length > 0;
        },

        /**
         * true if given permission was found in the specified id for the 'Organization' scope
         *
         * @param {string} permission permission name
         * @param {number} id         id of the organization
         */
        isPermittedInOrg: function(permission, id) {
          if (!permission || !id || !id.length) {
            return false;
          }
          return self.isPermittedInEvery(permission, 'Organization', Array.isArray(id) ? id : [id]);
        }
      };

      return self;
    });
})();

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('pageButtons', function ($rootScope) {
      var self = {
        addClass: function(cssClass) {
          // instantly add class to dom, don't wait for next angular tick
          $('body').addClass(cssClass);
          // also add class to angular way of handling classes, so that our
          // manually added class isn't overwritten
          if (!$rootScope.$bodyClassList || !$rootScope.$bodyClassList.length) {
            $rootScope.$bodyClassList = [cssClass];
          }
          if (!~$rootScope.$bodyClassList.indexOf(cssClass)) {
            $rootScope.$bodyClassList.push(cssClass);
          }
        },
        removeClass: function(cssClass) {
          if ($rootScope.$bodyClassList) {
            var searchIndex = $rootScope.$bodyClassList.indexOf(cssClass);
            if (~searchIndex) {
              $rootScope.$bodyClassList.splice(searchIndex, 1);
            }
          }
        },
        disable: function() {
          self.addClass('disable-page-buttons');
          $rootScope.pageButtonsDisabled = true;
        },
        enable: function() {
          self.removeClass('disable-page-buttons');
          $rootScope.pageButtonsDisabled = false;
        }
      };
      return self;
    });
})();

/**
 * @name ArnoDashAdminOrganizationsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Organization (Approval) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminOrganizationsService', ArnoDashAdminOrganizationsService);

// NOTE: Do further refactoring from the controller-fns to this service, clientApi will be used
/** @ngInject */
function ArnoDashAdminOrganizationsService($q, clientApi) {

  // PUBLIC METHODS
  /**
   * @name fetchMembersOfOrganizationRole
   * @description This method fetch members of organization-roles and attaches them to a given organizations-node-data
   *
   * @param {String} roleName                      The role-name for which members should be fetched
   * @param {String} scopeOfMembers          The property-name under which the fetched members for organization-roles should be put for a organization.
   *                                                                      e.g. 'admins' will lead to organization.admins = [.......]
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.fetchMembersOfOrganizationRole = function (roleName, orgData, scopeOfMembers) {
    if (typeof roleName !== 'string' || typeof scopeOfMembers !== 'string') {
      return Promise.reject(new Error('ERROR: ArnoDashAdminOrganizationsService.fetchMembersOfOrganizationRole: Not all params provided'));
    }

    return clientApi.custom('model/OrganizationRole', 'membersOfOrganizationRole', {
      roleName: roleName
    })
    .then(function(roleMembersResults) {
      orgData[scopeOfMembers] = orgData[scopeOfMembers] || [];
      orgData.roleId = roleMembersResults.id;

      if (roleMembersResults && roleMembersResults.Members) {
        _.forEach(roleMembersResults.Members, function (roleMember) {
          orgData[scopeOfMembers].push({
            FirstName: roleMember.FirstName,
            LastName: roleMember.LastName,
            EMail: roleMember.Account ? roleMember.Account.EMail : null,
            MemberId: roleMember.OrganizationRoleMember.MemberId,
          });
        });
      }

      return orgData;
    });
  }
}

/**
 * @name ArnoDashAdminOrganizationConfigService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Organization (Approval) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminOrganizationConfigService', ArnoDashAdminOrganizationConfigService);

// NOTE: Do further refactoring from the controller-fns to this service, clientApi will be used
/** @ngInject */
function ArnoDashAdminOrganizationConfigService($q, clientApi) {

  // PUBLIC METHODS
  /**
   * @name getOrgConfigEntry
   * @description This method fetch members of organization-roles and attaches them to a given organizations-node-data
   *
   * @param {String} configKey                The key-name for which config should be fetched
   * @param {String} scope                      The scope-name for which config should be fetched
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getOrgConfigEntry = function (configKey, scope) {
    if (typeof configKey !== 'string') {
      return Promise.reject(new Error('ERROR: ArnoDashAdminOrganizationConfigService.getOrgConfigEntry: Not all params provided'));
    }

    return clientApi.custom('model/OrganizationConfig', 'getOrgConfigEntry', {
      configKey: configKey,
      configScope: scope
    });
  }

  this.saveOrgConfigEntry = function (configKey, scope, content) {
    if (typeof configKey !== 'string') {
      return Promise.reject(new Error('ERROR: ArnoDashAdminOrganizationConfigService.saveOrgConfigEntry: Not all params provided'));
    }

    return clientApi.custom('model/OrganizationConfig', 'updateOrgConfigEntry', {
      configKey: configKey,
      configScope: scope,
      content: content
    });
  }
}

angular
  .module('ArnoDash')
  .service('notificationService', NotificationService);

/** @ngInject */
function NotificationService(clientApi, $rootScope, toastr) {
  var self = this;
  self.registration = undefined

  self.subscribe = function () {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(function (registration) {
          self.registration = registration
          self.handleActivatedServiceWorker();
        })
        .catch(function (e) {
          toastr.error('Service Worker Error', 'Error' + e);
        });
    } else {
      // The current browser doesn't support service workers.
      // Perhaps it is too old or we are not in a Secure Context.
      toastr.error('Web push not supported', 'Error');
    }
  }
  self.sendTest = function () {
    clientApi.emit('pushNotifications/sendTest', {
      type: 'Events',
      cMemberId: $rootScope.ctx.currentUser.id,
    }).catch(function () {
      toastr.error('Notification Error', 'Error')
    });
  }
  self.getOrCreateSubscription = function () {
    return self.getPublicKey().then(function (publickey) {
      if (publickey && publickey.length > 0) {
        var subscribeOptions = { applicationServerKey: publickey, userVisibleOnly: true };
        return self.registration.pushManager.getSubscription().then(function (oldSub) {
          if (!oldSub) {
            return self.registration.pushManager.subscribe(subscribeOptions).then(function (newSub) {
              return Promise.resolve(newSub);
            }).catch(function (e) {
              return Promise.reject(e);
            });
          }
          else {
            return Promise.resolve(oldSub);
          }
        })
      }
      else {
        self.registration.unregister();
        return Promise.reject(new Error('no server push key'));
      }
    })
      .catch(function (e) {
        self.registration.unregister();
        return Promise.reject(e);
      });
  }
  self.storeSubscription = function (subscription) {
    if (subscription) {
      clientApi.emit('pushNotifications/subscribe', {
        subscription: subscription,
        cMemberId: $rootScope.ctx.currentUser.id,
      });
    }
  }
  self.storePreference = function (preference) {
    if (preference) {
      clientApi.emit('pushNotifications/preference', {
        preference: preference,
        cMemberId: $rootScope.ctx.currentUser.id,
      });
    }
  }
  self.getPublicKey = function () {
    return clientApi.emit('pushNotifications/publicKey');
  }
  self.handleActivatedServiceWorker = function () {
    self.getOrCreateSubscription().then(function (sub) {
      // set preferences to BOTH but do not update existing
      self.storePreference({ noUpdate: true, Events: 'BOTH', Services: 'BOTH' });
      self.storeSubscription(sub);
    }).catch(function (e) {
      if (e.message === 'Registration failed - permission denied') {
        // set preferences to EMAIL and update existing
        self.storePreference({ noUpdate: false, Events: 'EMAIL', Services: 'EMAIL' });
      }
    });
  }
}

/**
 * @name ArnoDashAdminMembersService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Member (Approval) centric methods
 *
 */
angular
  .module('ArnoDash')
  .service('ArnoDashAdminMembersService', ArnoDashAdminMembersService);

// NOTE: Do further refactoring from the controller-fns to this service, clientApi will be used
/** @ngInject */
function ArnoDashAdminMembersService(ARNO_CONSTANTS, $q, clientApi, toastr, $translate) {

  // PUBLIC METHODS
  /**
   * @name updateMemberWithNotifications
   * @description This method updates a given member
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.updateMemberWithNotifications = function (divIds, memberData, divMemberData) {
    if (memberData) {
      // convert data-structures for api
      memberData.MemberType = (memberData.MemberType || {}).mapping;
      memberData.BirthDate = moment(memberData.BirthDate).format('MM-DD-YYYY');

      memberData.Salutation = (memberData.Salutation || {}).mapping;
      memberData.Title = (memberData.Title || {}).mapping || (memberData.Title || {}).Name;
      memberData.Title = memberData.Title === 'none' ? null : memberData.Title;

      memberData.Gender = (memberData.Gender || {}).mapping;
      memberData.Nationality = (memberData.Nationality || {}).mapping;
      memberData.Confession = ((memberData.Confession || {}).mapping === null) ? null : ((memberData.Confession || {}).mapping || (memberData.Confession || {}).Name);

      // convert address-object from ba-address component to member-fields
      memberData.CountryId = ((memberData.address || {}).CountryId || {}).mapping || (memberData.address || {}).CountryId || memberData.CountryId;
      memberData.ZIP = (memberData.address || {}).ZIP || memberData.ZIP;
      memberData.City = (memberData.address || {}).City || memberData.City;
      memberData.Street = (memberData.address || {}).Street || memberData.Street;
      memberData.HouseNumber = (memberData.address || {}).HouseNumber || memberData.HouseNumber;
      memberData.AddressAffix = (memberData.address || {}).AddressAffix || memberData.AddressAffix;
      memberData.address = undefined; // important: remove the view-object

      // convert employer-address-object from ba-address component to member-employer-fields
      memberData.EmployerZipCode = (memberData.employerAddress || {}).ZIP || memberData.EmployerZipCode;
      memberData.EmployerCity = (memberData.employerAddress || {}).City || memberData.EmployerCity;
      memberData.EmployerStreet = (memberData.employerAddress || {}).Street || memberData.EmployerStreet;
      memberData.EmployerHouseNumber = (memberData.employerAddress || {}).HouseNumber || memberData.EmployerHouseNumber;
      memberData.employerAddress = undefined; // important: remove the view-object
      memberData.MainDivisionId = memberData.MainDivision ? memberData.MainDivision.id : null;

      // IMPORTANT: append the last semicolon at the end, so the memberstatus string with the statusKeys
      // REASON: later in model, you have to search for the AdditionalEMails by the statusKeys with $like.
      // to be uniq all stausKeys in the AdditionalEMails should end with a semicolon!
      if (memberData.AdditionalEMails && memberData.AdditionalEMails.length) {
        memberData.AdditionalEMails = _.flatten(_.map(memberData.AdditionalEMails, function (language) {
          return language.Name;
        })).join(';') + ';';
      } else {
        memberData.AdditionalEMails = ''; // to avoid the case where AdditionalEMails is ';' which leads to errors in the tag-picker
      }

      // IMPORTANT: language skills mappings
      if (memberData.LanguageSkills && memberData.LanguageSkills.length) {
        memberData.LanguageSkills = _.map(memberData.LanguageSkills, function (language) {
          return {
            id: language.id,

            Alpha2Code: language.vm.mapping,
            Level: language.vm.Level.mapping || language.vm.Level.name,
            Notes: language.Notes,
          }
        });
      }

      // IMPORTANT: emergency-contacts mappings
      if (memberData.EmergencyContacts && memberData.EmergencyContacts.length) {
        memberData.EmergencyContacts = _.map(memberData.EmergencyContacts, function (contact) {
          return {
            id: contact.id,

            FirstName: contact.FirstName,
            LastName: contact.LastName,
            MobileNumber: contact.MobileNumber,
            PhoneNumber: contact.PhoneNumber,
            Email: contact.Email,
            Function: contact.Function,
            ZipCode: (contact.address || {}).ZIP,
            City: (contact.address || {}).City,
            Street: (contact.address || {}).Street,
            HouseNumber: (contact.address || {}).HouseNumber,
            AddressAffix: (contact.address || {}).AddressAffix,
            DeclarationofConsent: contact.DeclarationofConsent,
            PrivacyTermsDeliveredDateTime: contact.PrivacyTermsDeliveredDateTime, 
            PrivacyTermsDeliveredPerson: contact.PrivacyTermsDeliveredPerson,
            PrivacyTermsDeliveredChannel: contact.PrivacyTermsDeliveredChannel
          }
        });
      }
    }

    if (divMemberData) {
      // convert data-structures for api
      if (Array.isArray(divMemberData.MemberStatus)) {
        // IMPORTANT: append the last semicolon at the end, so the memberstatus string with the statusKeys
        // is well-formed! so e.g. instead saving: FULLTIME;VOLUNTARY
        // IT MUST BE: FULLTIME;VOLUNTARY;
        // REASON: later in model, you have to search for the MemberStatus by the statusKeys with $like.
        // to be uniq all stausKeys in the MemberStatus should end with a semicolon!
        if (_.flatMap(divMemberData.MemberStatus, 'mapping').length) {
          divMemberData.MemberStatus = _.flatMap(divMemberData.MemberStatus, 'mapping').join(';') + ';';
        } else {
          divMemberData.MemberStatus = ''; // to avoid the case where MemberStatus is ';' which leads to errors in the tag-picker
        }
      }
    }

    return clientApi.custom('model/Member', 'updateMember', { divId: divIds, member: memberData, divisionMember: divMemberData })
      .then(function (results) {
        toastr.success(
          $translate.instant('modules.personnel.dossier.baseData.profileEditSuccToastText'),
          $translate.instant('modules.personnel.dossier.baseData.profileEditSuccToastTitle')
        );

        return results;
      })
      .catch(function (error) {
        toastr.error(
          $translate.instant('modules.personnel.dossier.baseData.profileEditErrToastText'),
          $translate.instant('modules.personnel.dossier.baseData.profileEditErrToastTitle')
        );
        throw error;
      });
  }

  this.findDivisionMembers = function (ctx, queryWishes, activeMemberSwitch, baseQueryExtend, noLimit) {
    //important, check if filter for MemberStatus is present, if yes then map the search-string to the possible
    // values for the MemberStatus field in model
    var memberStatusSearchKeys = [];
    if (queryWishes && queryWishes.filter && queryWishes.filter.MemberStatus) {
      _.filter(ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_STATUS, function (status) {
        if (status && typeof status.Name === 'string' && (status.Name.toUpperCase().indexOf(queryWishes.filter.MemberStatus.toUpperCase()) > -1)) {
          memberStatusSearchKeys.push(status.mapping);
        }
      });

      // if no matching statusKeys could be found, then add a special key to indicate not matching keys for MemberStatus!
      if (!memberStatusSearchKeys.length) {
        queryWishes.filter.MemberStatus = ['_NOT_MATCHING_'];
      } else {
        queryWishes.filter.MemberStatus = memberStatusSearchKeys;
      }
    }

    return clientApi.custom('model/DivisionMember', 'findDivisionMember', {
      divId: ctx,
      queryWishes: queryWishes,
      switchActiveMember: activeMemberSwitch,
      baseQueryExtend: baseQueryExtend,
      whitelistedFields: null,
      noLimit: noLimit
    })
  }

  this.findByDivisionId = function (divisionId, queryWishes) {
    return clientApi.custom('model/Member', 'findByDivisionId', {
      divisionId: divisionId,
      queryWishes: queryWishes
    });
  }

}


/**
 * @name ArnoDashMaterialsService
 * @description This Service is responsible to provide Materials centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashMaterialsService', ArnoDashMaterialsService);

/** @ngInject */
function ArnoDashMaterialsService($log, $translate, toastr, clientApi, $uibModal, materialUtil, $state) {
  var self = this;

  // CONSTS
  self.MATERIALS_TYPE_NODE_TYPE = 'MaterialType';

  // METHODS
  self.getMaterialsTypesWithPrices = function (divisionId, queryOptions, fetchOrgItems, fetchDivItems, filterMissingPrices) {
    return clientApi.custom('model/MaterialType', 'getFilteredTypesWithPricesByDivOrOrg', {
      divisionId: divisionId,
      queryOptions: queryOptions,
      filterMissingPrices: filterMissingPrices,
      fetchOrgItems: fetchOrgItems,
      fetchDivItems: fetchDivItems,
    });
  };

  self.getMaterialsTypesWithPricesAsTree = function (divisionId, filterMissingPrices) {
    return clientApi.custom('model/MaterialType', 'getAllTypesByDivOrOrg', {
      divisionId: divisionId,
      filterMissingPrices: filterMissingPrices,
      includeCostCenterSpecs: true
    }).then(function (results) {
      if (results) {
        var rootMaterialTypes = _.filter(results, function (materialType) {
          return (materialType || {}).ParentMaterialTypeId == null;
        }).sort(function (a, b) { return a.DivisionId - b.DivisionId; });

        var materialTypeTree = buildAngularTreeControlNodes(rootMaterialTypes, results, divisionId);

        return materialTypeTree;
      }
    });
  };

  // HELPERS
  function buildAngularTreeControlNodes(materialTypesParent, allMaterialTypes, divisionId) {
    if (!(materialTypesParent || []).length || !(allMaterialTypes || []).length) {
      return [];
    }

    var materialTypesTreePart = [];

    _.forEach(materialTypesParent, function (materialTypeParent) {
      var convertedMaterialTypeParent = convertMaterialTypeToNode(materialTypeParent, divisionId);
      materialTypesTreePart.push(convertedMaterialTypeParent);

      var children = _.filter(allMaterialTypes, { ParentMaterialTypeId: materialTypeParent.id });

      if ((children || []).length) {
        convertedMaterialTypeParent.children = buildAngularTreeControlNodes(children, allMaterialTypes, divisionId);
      }
    });

    return materialTypesTreePart;
  }

  function convertMaterialTypeToNode(model, divisionId) {
    return {
      id: self.MATERIALS_TYPE_NODE_TYPE + '-' + model.id,
      type: self.MATERIALS_TYPE_NODE_TYPE,
      label: model.Name,
      matched: false,
      isSelected: false,
      selectable: !Array.isArray(divisionId) ? divisionId && divisionId != 'rootOrg': !(divisionId.indexOf('rootOrg') >= 0),
      iconCls:
        model.ParentMaterialTypeId == null
        ? getIconClsForMaterialTypeScope(model.DivisionId, model.PriceItemOverrides && model.PriceItemOverrides.length)
        : '',
      iconSecondaryCls: getIconClsForMaterialTypeCategory(model.Category),
      labelCls: '',

      model: model,

      // NOTE: add further data here as needed for the tree-node of the material-type
    };
  }

  function getIconClsForMaterialTypeCategory(type) {
    switch (type) {
    case 'Medicine': return 'fa fa-medkit';
    case 'MedicalProducts': return 'fa fa-heartbeat';
    case 'Clothing': return 'ion-tshirt';
    case 'Consumables': return 'ion-cube';
    case 'Others': return 'fa fa-archive';
    case 'Tools': return 'ion-hammer';
    case 'Vehicles': return 'fa fa-car';
    default:
      return 'fa fa-cube';
    }
  }

  function getIconClsForMaterialTypeScope(divisionId, hasOverrides) {
    if (divisionId != null) {
      return 'fa fa-sitemap';
    }

    if (divisionId == null) {
      if (hasOverrides) {
        return 'fa fa-exchange';
      }
      return 'fa fa-users';
    }

    return '';
  }

  self.openAddModal = function (origMat, mode, isStorage, divisionId, model, tableOpts, allowStateChange) {
    /*
      origMat - original material, you'll want to at least have this have the material id in it
      mode - "update" || "add" || "split" || "viewOnly"

      - relevant for material overview table
      tableOpts: {
        reloadMaterial - material overview fn to reload table
        pqp - preserved query params - intermediate object to save table queries
        splitIntermediate - object to handle split saving
        view - tableConfig param - relevant for opening with aggregations
        {
          Aggregations: <Object of aggregated fields>,
          Fields: <Array of fieldKeys in view>,
          tableConfigAvailableFields: <Array of available fields in config>,
        }
      }
    */

    var material;
    var opts = tableOpts || {};
    var view = opts.view || {};
    try {
      material = JSON.parse(JSON.stringify(origMat));
    } catch (e) {
      // hmmk
      material = origMat;
    }

    if (tableOpts && tableOpts.view &&
      (!tableOpts.view.Aggregations || !Object.keys(tableOpts.view.Aggregations).length) &&
      material && material.id && $state.$current.name.includes('material.overview') && allowStateChange) {
      $state.go($state.$current.name, { materialId: material.id });
    }

    var typeResolve = function () {
      return clientApi.custom('model/MaterialType', 'fetchMaterialTypes', {
        divisionId: divisionId,
        opts: {
          category: model.replace('Material', ''),
          materialsAssignable: true,
          includeRoot: true,
          includeParent: true,
        }
      });
    };

    var flattenQualifications = function (hierarchy) {
      return [].concat.apply([],
        _.sortBy(hierarchy, 'Name').map(function (qualificationHierarchyItem) {
          return _.sortBy(qualificationHierarchyItem.Qualifications, 'Name').map(function (qualificationItem) {
            qualificationItem.GroupName = qualificationHierarchyItem.Name;
            qualificationItem.QualificationName = qualificationItem.Name;
            qualificationItem.QualificationId = qualificationItem.id;
            qualificationItem.Type = qualificationHierarchyItem.Type || 'qualification';
            return qualificationItem;
          });
        })
      );
    };

    var saveMaterial = function (data) {
      return Promise.resolve()
      .then(function () {

        if (mode === 'update') {
          var queryWishes = {};
          queryWishes.where = {};
          if (view.Aggregations && !material.id) {
            Object.keys(view.Aggregations).forEach(function (aggKey) {
              queryWishes.where[aggKey] = material[aggKey];
            });
          } else if (material.id) {
            queryWishes.where.id = material.id;
          }

        // safety measure to prevent sending any div reliant info when there's multi div action going on
          var useMatDiv;
          if (origMat.isMultiDiv) {
            delete data.material.Division;
            delete data.material.DivisionId;
            delete data.material.Storage;
            delete data.material.StorageTags;
            delete data.responsibleMembers;
          } else if (divisionId.length > 1) {
            useMatDiv = true;
          }

          return clientApi.custom('model/' + model, 'saveMaterial', {
            divisionId: useMatDiv ? data.material.DivisionId : divisionId,
            data: data,
            mode: mode,
            queryWishes: queryWishes
          });
        }
        if (mode !== 'split') {
          return clientApi.custom('model/' + model, 'saveMaterial', {
            divisionId: divisionId,
            data: data,
            mode: mode
          });
        } else {
          if (data.responsibleMembers) {
            data.material.ResponsibleMember = data.responsibleMembers;
          }

          if (data.materialQualifications) {
            data.material.MaterialQualification = data.materialQualifications;
          }
          var matId = material.id !== undefined ? 0 : material.tempId;
          if (opts.splitIntermediate) {
            delete opts.splitIntermediate.splitRows[matId].ResponsibleMember;
            delete opts.splitIntermediate.splitRows[matId].MaterialQualification;
            delete opts.splitIntermediate.splitRows[matId].LicenseClass;
            _.merge(opts.splitIntermediate.splitRows[matId], data.material);
          }
          return material;
        }
      })
      .then(function (data) {
        if (mode === 'add') {
          toastr.success($translate.instant('modules.material.overview.MaterialCreated2'), $translate.instant('modules.material.overview.MaterialCreated'));
        } else if (mode === 'update') {
          toastr.success($translate.instant('modules.material.overview.MaterialEdit2'), $translate.instant('modules.material.overview.MaterialEdit'));
        }
        if (opts.reloadMaterial) {
          opts.reloadMaterial(opts.pqp || null, null);
        }
        return data;
      })
      .catch(function (err) {
        if (err && err !== 'escape key press' && mode !== 'split') {
          toastr.error($translate.instant('modules.material.overview.MaterialNotCreated2'), $translate.instant('modules.material.overview.MaterialNotCreated'));
        }
      });
    };

    if (mode === 'split') {
      self.splitPristine = false;
    }
    if (mode === 'viewOnly' && (!origMat.id || (!origMat.permitted && isStorage))) {
      return;
    }
    return typeResolve()
      .then(function (materialTypes) {
        return $uibModal
          .open({
            animation: true,
            templateUrl: 'app/pages/material/addMaterial/addMaterial.html',
            size: 'fullscreen',
            controller: 'AddMaterialCtrl as $matAddCtrl',
            windowClass: 'add-material-dialog',
            resolve: {
              isAggregatedView: !!view.Aggregations,
              aggregatedAmount: origMat && origMat.Amount || 0,
              availableFields: function () {
                var promise = Promise.resolve(view && view.tableConfigAvailableFields);
                if (model || !view.tableConfigAvailableFields) {
                  promise = clientApi.custom('model/' + model, 'getColumns', {
                    divisionId: divisionId,
                  });
                }
                return promise
                  .then(function (fields) {
                    if (view.Aggregations && Object.keys(view.Aggregations).length && mode !== 'split') {
                      // exclude amount on aggregated updates
                      return fields.filter(function (field) {
                        return field.prop !== 'Amount';
                      });
                    }
                    return fields;
                  });
              },
              saveMaterial: function () {
                return saveMaterial;
              },
              viewOnly: function () {
                return mode === 'viewOnly';
              },
              modelMap: function () {
                return materialUtil.materialModelMap;
              },
              storageIconMap: function () {
                return materialUtil.materialStorageIconMap;
              },
              fieldConfig: function () {
                return materialUtil.propTypes[model];
              },
              divisionId: function () {
                return divisionId;
              },
              isSplit: function () {
                return mode === 'split';
              },
              isAdd: function () {
                return mode === 'add';
              },
              templateAvailable: function () {
                if (model === 'MaterialMedicalProducts') {
                  return clientApi.emit('docxTemplateStorage/check', {
                    divisionId: divisionId,
                    type: 'materialMedicalProductBook',
                    orgFallback: true,
                  });
                }
                return false;
              },
              fullRow: function () {
                if ((mode === 'viewOnly' || mode === 'update' ||
                   (mode === 'split' && !!~material.id && 
                   (typeof material.Storage === 'string' || !Array.isArray(material.ResponsibleMember) || typeof material.MaterialType === 'string')))) {
                  var queryWishes = {};
                  queryWishes.where = {};
                  queryWishes.resolveMaterial = true;
                  queryWishes.resolvePriceOverride = true;
                  if (!material.id && !material.fetchId) {
                    Object.keys((view.Aggregations || {})).forEach(function (agg) {
                      if (agg === 'ResponsibleMember') {
                        queryWishes.where.ResponsibleMemberId = material.ResponsibleMemberId;
                      }
                      if (agg === 'Storage' && material[agg] === '-') {
                        queryWishes.where[agg] = null;
                      } else if (agg === 'MaterialsHandedOver') {
                        queryWishes.where.HandedOverToId = material.HandedOverToId;
                      } else {
                        queryWishes.where[agg] = material[agg];
                      }
                    });
                  } else {
                    queryWishes.where.id = material.id || material.fetchId;
                  }
                  queryWishes.visibleNonAgg = (view.tableConfigAvailableField || []).filter(function (field) {
                    if ((view.Aggregations && !view.Aggregations[field.prop]) || !view.Aggregations) {
                      return true;
                    }
                  }).map(function (field) {
                    return field.prop;
                  });

                  return clientApi.custom('model/' + model, 'getMaterial', {
                    divisionId: divisionId,
                    queryWishes: queryWishes
                  })
                    .then(function (res) {
                      if (!res || (Array.isArray(res) && !res.length)) {
                        // throw to not init controller and break the page incase someone opens a router state with an ID that dos not exist
                        throw new Error('Material does not exist');
                      }
                      var mainRow = Array.isArray(res) ? res[0] : res;
                      if (mode === 'split') {
                        material.ResponsibleMember = mainRow.ResponsibleMember;
                        material.Storage = mainRow.Storage;
                        material.MaterialType = mainRow.MaterialType;
                        if (mainRow.LicenseClass) {
                          material.LicenseClass = mainRow.LicenseClass;
                        }
                        return material;
                      }
                      return res;
                    });
                } else if (mode === 'split') {
                  if (typeof material.MaterialType === 'number') {
                    var tmpMat = JSON.parse(JSON.stringify(material));
                    var matType = _.find(materialTypes, function (t) {
                      return t.id === tmpMat.MaterialType;
                    });
                    tmpMat.MaterialType = matType || { id: tmpMat.MaterialType };
                    return [tmpMat];
                  }
                  return [JSON.parse(JSON.stringify(material))];
                }
                return null;
              },
              materialTypes: function () {
                return materialTypes;
              },
              licenses: function () {
                if (model === 'MaterialVehicles') {
                  // resolve licenseclasses for tagpicker
                  return clientApi.custom('model/LicenseClass', 'getLicenses', { divisionId: divisionId });
                }
                return null;
              },
              currentModel: function () {
                return model;
              },
              folderData: function (clientApi, commonUtils) {
                if (origMat && !Object.keys((view.Aggregations || {})).length) {
                  return clientApi
                    .custom('model/FileStorageFolder', 'getFoldersForOrg', {
                      storageIdent: _.lowerFirst(model),
                      divisionId: divisionId,
                      itemOpts: {
                        materialModel: model,
                        itemId: origMat.id,
                      }
                    })
                    .then(function (faf) {
                      if (faf && faf.folders && faf.folders.length) {
                        return commonUtils.fileStorage.buildFolderTree(faf.folders, {
                          rootOrg: (origMat && (origMat.Name || origMat.Definition || origMat.VehicleModel || origMat.label || origMat.Type)) || 'Material',
                          rootIcon: materialUtil.materialStorageIconMap[model],
                          includeFiles: faf.files,
                        });
                      }
                    });
                }
                return [];
              },
              flatQualificationHierarchy: function (clientApi) {
                if (mode === 'viewOnly') {
                  return [];
                }

                return clientApi.custom('model/QualificationGroup', 'getQualificationGroups', { divisionId: divisionId })
                  .then(function (res) {
                    return (flattenQualifications(res) || []);
                  })
                  .catch(function (e) {
                    toastr.error();
                    throw e;
                  });
              },
            }
          })
          .result
          .then(function (res) {  
            if ($state.params.materialId) {
              $state.go($state.current.name, {}, {inherit:false} );
              return;
            }
            return res;
          })
          .catch(function (err) {
            if (err && !err === 'escape key press' && mode !== 'split') {
              toastr.error(
                $translate.instant('modules.material.overview.MaterialNotCreated2'), $translate.instant('modules.material.overview.MaterialNotCreated')
              );
            }
            if ($state.params.materialId && err !== 'FULLSCREEN_MODAL_CLOSED_DUE_ROUTE_TRANSITION') {
              $state.go($state.current.name, {}, {inherit:false} );
            }
          });
      });

  };

  self.addInspectionEvent = function (divisionId, materialId, materialModel, inspectionEvt, descent, preSetInspections) {
    return $uibModal
      .open({
        animation: true,
        templateUrl: 'app/pages/material/addMaterial/addInspectionEvent/addInspectionEvent.modal.html',
        size: 'md',
        backdrop: 'static',
        controller: 'addMaterialInspectionEventCtrl as self',
        resolve: {
          ctx: function () {
            return divisionId;
          },
          materialId: function () {
            return materialId;
          },
          materialModel: function () {
            return materialModel;
          },
          inspectionEvt: function () {
            if (inspectionEvt) {
              return Promise
                .all(
                  [inspectionEvt.TestingMemberOneId, inspectionEvt.TestingMemberTwoId]
                    .map(function (testingMemberId) {
                      if (!testingMemberId) {
                        return null;
                      }
                      return clientApi
                        .custom(
                          'model/DivisionMember',
                          'memberSelectorFind',
                          { divisions: [divisionId], searchById: testingMemberId },
                          { backgroundRequest: true }
                        )
                        .then(function (response) {
                          return (response && response[0]) || null;
                        })
                        .catch(function () {
                          return null;
                        });
                    })
                )
                .then(function (testingMembers) {
                  inspectionEvt.TestingMemberOneInitial = (testingMembers || [])[0] || null;
                  inspectionEvt.TestingMemberTwoInitial = (testingMembers || [])[1] || null;
                })
                .then(function () {
                  if (!inspectionEvt.ContactId) {
                    return false;
                  }
                  return clientApi
                    .custom('model/contact', 'getContactAllWithOrg', {
                      divisionIds: [divisionId],
                      searchById: inspectionEvt.ContactId
                    })
                    .then(function (result) {
                      return ((result || {}).contactList || [])[0] || null;
                    })
                    .catch(function () {
                      return null;
                    })
                    .then(function (contact) {
                      inspectionEvt.TestingContact = contact;
                    });
                })
                .then(function () {
                  if (!inspectionEvt.BusinessPartnerId) {
                    return false;
                  }
                  return clientApi
                    .custom('model/BusinessPartner', 'searchBusinessPartners', {
                      searchById: inspectionEvt.BusinessPartnerId,
                      divisionId: divisionId,
                    })
                    .then(function (response) {
                      return (response && response[0]) || null;
                    })
                    .catch(function () {
                      return null;
                    })
                    .then(function (bp) {
                      inspectionEvt.TestingOrg = bp;
                    });
                })
                .then(function () {
                  if (descent) {
                    var commonIntervalMaterialModelDefinition = {};
                    commonIntervalMaterialModelDefinition[materialId] = [materialModel];
                    return clientApi
                      .custom('model/MaterialInspectionDemand', 'commonInterval', {
                        inspections: [{
                          InspectionId: inspectionEvt.InspectionId,
                          MaterialId: inspectionEvt.MaterialId,
                          MaterialCategory: materialModel,
                        }],
                        materialId: [materialId],
                        materialModel: commonIntervalMaterialModelDefinition,
                        divisionId: divisionId,
                      })
                      .then(function (commonInterval) {
                        if (commonInterval.interval) {
                          inspectionEvt.Inspection.Interval = commonInterval.interval;
                        }
                      })
                      .catch(function () {
                        // hm k
                      });
                  }
                })
                .then(function () {
                  return inspectionEvt;
                });
            }
            return null;
          },
          descent: function () {
            return !!descent;
          },
          preSetInspections: function () {
            if (preSetInspections) {
              return clientApi
                .custom('model/MaterialInspectionDemand', 'commonInterval', {
                  inspections: preSetInspections,
                  materialId: materialId,
                  materialModel: materialModel,
                  divisionId: divisionId,
                })
                .then(function (commonInterval) {
                  return _
                    .uniqBy(preSetInspections, 'InspectionId')
                    .map(function (psi) {
                      return {
                        id: psi.InspectionId,
                        Name: psi.InspectionLabel,
                        Interval: commonInterval.interval,
                      };
                    });
                });
            }
            return null;
          },
        },
      })
      .result
      .then(function (res) {
        if (res) {
          // new/edit will emit a res, save it
          return clientApi
            .custom(
              preSetInspections ? ('model/MaterialInspectionDemand') : ('model/' + materialModel + 'InspectionEvent'),
              'upsertInspectionEvents', {
                materialId: materialId,
                materialModel: materialModel,
                data: {
                  inspections: preSetInspections || res.inspections.map(function (r) {
                    return r.id;
                  }),
                  meta: res.meta,
                },
                divisionId: divisionId,
              })
            .then(function () {
              toastr.success(
                $translate.instant('modules.material.addMaterial.inspection.assignEventSuccessContent'),
                $translate.instant('modules.material.addMaterial.inspection.assignEventSuccessTitle')
              );

              return res;
            })
            .catch(function (e) {
              if (e) {
                toastr.error(
                  $translate.instant('modules.material.addMaterial.inspection.assignEventFailContent'),
                  $translate.instant('modules.material.addMaterial.inspection.assignEventFailTitle')
                );
              }
            });
        }
      });
  };
}


angular.module('ArnoDash')
  .service('materialUtil', materialUtil);

/** @ngInject */
function materialUtil($translate) {
  var self = {
    materialModelMap: {
      'MaterialMedicine': $translate.instant('modules.material.addMaterial.medication'),
      'MaterialMedicalProducts': $translate.instant('modules.material.addMaterial.medicalProducts'),
      'MaterialVehicles': $translate.instant('modules.material.addMaterial.carpool'),
      'MaterialClothing': $translate.instant('modules.material.addMaterial.clothing'),
      'MaterialTools': $translate.instant('modules.material.addMaterial.TechnDevices'),
      'MaterialConsumables': $translate.instant('modules.material.addMaterial.consumerMaterial'),
      'MaterialOthers': $translate.instant('modules.material.addMaterial.other'),
    },
    materialPluralizationMap: {
      'MaterialClothing': 'MaterialClothings',
      'MaterialMedicine': 'MaterialMedicines',
    },
    materialStorageIconMap: {
      MaterialMedicine: 'fa fa-medkit',
      MaterialMedicalProducts: 'fa fa-heartbeat',
      MaterialVehicles: 'fa fa-car',
      MaterialClothing: 'ion-tshirt',
      MaterialTools: 'ion-hammer',
      MaterialConsumables: 'ion-cube',
      MaterialOthers: 'fa fa-archive',
    },
    materialDefaultTableConfig: {
      MaterialMedicine: ['Definition', 'Content', 'Properties', 'Amount', 'Storage'], 
      MaterialMedicalProducts: ['Type', 'MaterialType', 'Amount', 'Storage'],
      MaterialVehicles: ['VehicleModel', 'Manufacturer', 'MaterialType', 'Licenseclass', 'Amount'],
      MaterialClothing: ['Name', 'MaterialType', 'Category', 'Size', 'MaterialsHandedOver', 'Amount'],
      MaterialTools: ['Definition', 'Type', 'Amount', 'MaterialType', 'Storage'],
      MaterialConsumables: ['Definition', 'Amount', 'MaterialType', 'Storage'],
      MaterialOthers: ['Name', 'MaterialType', 'Amount', 'Storage'],
    },
    materialsTabsIconMapping: {
      MaterialMedicine: 'fa fa-medkit',
      MaterialMedicalProducts: 'fa fa-heartbeat',
      MaterialClothing: 'ion-tshirt',
      MaterialVehicles: 'fa fa-car',
      MaterialTools: 'ion-hammer',
      MaterialConsumables: 'ion-cube',
      MaterialOthers: 'fa fa-archive',
    },
    memberFormatter: function (memberObj) {
      if (!memberObj) {
        return null;
      }
      if (Array.isArray(memberObj)) {
        return memberObj.map(function (m) {
          return (m.Member && m.Member.fullName) || m.fullName;
        }).join(', ').trim();
      }
      return memberObj.trim();
    },
    objFormatter: function (obj) {
      if (obj && typeof obj === 'object' && obj.Name) {
        return obj.Name;
      }
      return obj;
    },
    licenseFormatter: function (licenseObj) {
      if (licenseObj === null) {
        return ' - ';
      }
      if (Array.isArray(licenseObj)) {
        return (licenseObj || []).map(function (l) {
          return l.Name;
        }).join(', ').trim();
      }

      return (licenseObj || '').trim();
    },
    storageFormatter: function (storageObj) {
      if (typeof storageObj === 'string') {
        return storageObj;
      }
      if (storageObj === null || storageObj.Name === null) {
        return '-';
      }
      return storageObj.Name;
    },
    applyFieldConfig: function (currentPropSet, materialProp, propKey) {
      if (currentPropSet[propKey] && currentPropSet[propKey].formatter) {
        return currentPropSet[propKey].formatter(materialProp);
      }
      return materialProp;
    },
    parseDate: function (date, view) {
      if (!date || date === '-') {
        return ' - ';
      }
      if (date instanceof Date) {
        return date;
      }
      var dateSplit = _.compact(date.split(', '));
      var ret = [];
      dateSplit.forEach(function (date) {
        if (view && view.Aggregations && Object.keys(view.Aggregations).length) {
          // workaround
          // aggregated rows will return broken datestrings missing TZ info
          // get users offset and apply it to a freshly parsed date
          try {
            if (date.startsWith('1900-01-01')) {
              if (dateSplit.length === 1) {
                ret.push(' - ');
              }
            } else {
              var offset = new Date().getTimezoneOffset() * 60 * 1000; // offset in ms
              date = moment(new Date(date).getTime() - offset).format('DD.MM.YYYY');
            }
          } catch (e) {
            //mmh k
          }
          if (date !== 'Invalid date') {
            ret.push(date);
          }
        }
      });
      return ret.join(', ') || date;
    },
    boolFormatter: function (val) {
      if (val === null || val === undefined) {
        return val;
      }
      if (val === true) {
        return 'Ja';
      } else if (val === false) {
        return 'Nein';
      }
      return val.replace('1', 'Ja').replace('0', 'Nein');
    },
    searchableCheck: function (currentPropSet, header) {
      return (currentPropSet[header.prop] &&
        (currentPropSet[header.prop].searchable ||
          (currentPropSet[header.prop].type !== 'int' && currentPropSet[header.prop].type !== 'date')
        )
      ) || !currentPropSet[header.prop];
    },
    aggregateExcludes: [
      'Amount', 'InventoryNumber',
      'ExternalPricePerHour', 'ExternalPricePerDay', 'ExternalPricePerCount', 'InternalPricePerHour', 'InternalPricePerDay', 'InternalPricePerCount'
    ],
    checkAggregateExcludes: function (prop) {
      return !~self.aggregateExcludes.indexOf(prop);
    },
    checkActiveAggregations: function (prop, view) {
      if (view.Aggregations) {
        return view.Aggregations[prop];
      }
      return false;
    },
    addAggToQW: function (view, queryWishes) {
      if (view.Aggregations) {
        queryWishes.aggregations = [];
        Object
          .keys(view.Aggregations)
          .forEach(function (agg) {
            queryWishes.aggregations.push(agg);
          });
        queryWishes.aggregations = _.uniq(queryWishes.aggregations);
      }
    },
    addNonAggToQW: function (view, queryWishes) {
      if (view.Fields) {
        queryWishes.visibleNonAgg = [];
        Object
          .keys(view.Fields)
          .forEach(function (vis) {
            if (((view.Aggregations && !view.Aggregations[vis]) || !view.Aggregations) && view.Fields[vis]) {
              queryWishes.visibleNonAgg.push(vis);
            }
          });
        queryWishes.visibleNonAgg = _.uniq(queryWishes.visibleNonAgg);
      }
    },
    handleSTSearchParams: function (stParams, queryWishes, currentPropSet) {
      if (!queryWishes.where) {
        queryWishes.where = {};
      }
      Object
        .keys(stParams.search.predicateObject)
        .forEach(function (key) {
          var boolTerm;
          if (currentPropSet[key] && currentPropSet[key].type === 'bool') {
            // bools have to be searched via 1 and 0 but since the user only sees the formatted values we have to reformat them here
            if ('ja' === stParams.search.predicateObject[key].toLowerCase()) {
              boolTerm = '1';
            } else if ('nein' === stParams.search.predicateObject[key].toLowerCase()) {
              boolTerm = '0';
            }
          }
          queryWishes.where[key] = boolTerm || stParams.search.predicateObject[key];
        });
    },
  };

  var carryWeightWatcher = function (newVal, oldVal, addModel, form) {
    if (addModel.AllowedTotalWeight && addModel.EmptyWeight && form && form.CarryWeightInput.$pristine) {
      addModel.CarryWeight = addModel.AllowedTotalWeight - addModel.EmptyWeight;
      if (addModel.CarryWeight < 0) {
        addModel.CarryWeight = 0;
      }
      form.CarryWeightInput.autoCalc = true;
    }
  };

  self.propTypes = {
    MaterialVehicles: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      VehicleModel: {
        type: 'string',
      },
      Length: {
        type: 'int',
      },
      Width: {
        type: 'int',
      },
      Height: {
        type: 'int',
      },
      LicenseClass: {
        type: 'tagpicker',
        formatter: self.licenseFormatter,
      },
      FuelType: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.petrol'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.diesel'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.electro'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.twoStrokeMix'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.gas'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.hybrid'),
          $translate.instant('modules.material.materialUtils.vehicleFuelTypes.noFuel'),
          $translate.instant('modules.material.materialUtils.other'),
        ]
      },
      CommunicationsEquipment: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.communicationsEquipment.digital'),
          $translate.instant('modules.material.materialUtils.communicationsEquipment.analog'),
          $translate.instant('modules.material.materialUtils.communicationsEquipment.analogAndDigital'),
          $translate.instant('generalTerms.none'),
        ]
      },
      SpecialSignallingDevice: {
        type: 'bool',
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      ResponsibleWorkshop: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      ExtensionManufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      AcquisitionDate: {
        type: 'date',
      },
      ElectricFeeding: {
        type: 'bool'
      },
      TailLift: {
        type: 'bool'
      },
      AllowedTotalWeight: {
        type: 'int',
        watchFn: carryWeightWatcher,
      },
      EmptyWeight: {
        type: 'int',
        watchFn: carryWeightWatcher
      },
      CarryWeight: {
        type: 'int',
        watchFn: function (newVal, oldVal, addModel, form) {
          if (newVal && form && !form.CarryWeightInput.$pristine) {
            form.CarryWeightInput.autoCalc = false;
          }
        }
      },
      BuiltIn: {
        type: 'int',
        customClass: 'col-sm-6',
        usePicker: true,
        pickerOptions: {
          minMode: 'year',
          datepickerMode: 'year',
          showWeeks: false,
        },
        pickerDateFormat: 'yyyy',
        pickerFormatter: function (value) {
          try {
            return value.getYear() + 1900;
          } catch (e) {
            return value;
          }
        },
        searchable: true
      },
      PurchaseDate: {
        type: 'date'
      },
      InitialRegistration: {
        type: 'date',
        customClass: 'col-sm-6',
      },
      Amount: {
        type: 'int',
        required: true
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      Note: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      CostCenterSpecification: {
        type: 'special',
      },
      TrailerHitch: {
        type: 'bool',
      },
      HitchType: {
        type: 'enum',
      },
      VehicleType: {
        type: 'enum',
      },
      TowingCapacity: {
        type: 'int',
        hookTo: [
          {
            TrailerHitch: [true]
          }
        ],
        hookTooltip: $translate.instant('modules.material.materialUtils.trailerHitchHookTooltip')
      },
      Active: {
        type: 'bool',
      },


    },
    MaterialClothing: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      AcquisitionDate: {
        type: 'date',
      },
      Name: {
        type: 'string',
        required: true,
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_NAME_TOOLTIP'),
      },
      Condition: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_CONDITION_TOOLTIP'),
      },
      Equipment: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_EQUIPMENT_TOOLTIP'),
      },
      Logo: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LOGO_TOOLTIP'),
      },
      Standards: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_STANDARDS_TOOLTIP'),
      },
      Type: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.clothingTypes.vest'),
          $translate.instant('modules.material.materialUtils.clothingTypes.sweatshirt'),
          $translate.instant('modules.material.materialUtils.clothingTypes.polo'),
          $translate.instant('modules.material.materialUtils.clothingTypes.blouse'),
          $translate.instant('modules.material.materialUtils.clothingTypes.helmet'),
          $translate.instant('modules.material.materialUtils.clothingTypes.trousers'),
          $translate.instant('modules.material.materialUtils.clothingTypes.jacket'),
          $translate.instant('modules.material.materialUtils.clothingTypes.tShirt'),
          $translate.instant('modules.material.materialUtils.clothingTypes.shirt'),
          $translate.instant('modules.material.materialUtils.clothingTypes.cap'),
          $translate.instant('modules.material.materialUtils.other')
        ]
      },
      Category: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.clothingTypes.deploymentClothing'),
          $translate.instant('modules.material.materialUtils.clothingTypes.serviceClothing'),
          $translate.instant('modules.material.materialUtils.clothingTypes.youthClothing'),
          $translate.instant('modules.material.materialUtils.other')
        ]
      },
      Amount: {
        type: 'int',
        required: true
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      Note: {
        type: 'text'
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
    },
    MaterialTools: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      AcquisitionDate: {
        type: 'date',
      },
      Definition: {
        type: 'string',
        required: true
      },
      Type: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.toolsTypes.radio'),
          $translate.instant('modules.material.materialUtils.toolsTypes.bulbs'),
          $translate.instant('modules.material.materialUtils.toolsTypes.mpg'),
          $translate.instant('modules.material.materialUtils.toolsTypes.aggregate'),
          $translate.instant('modules.material.materialUtils.toolsTypes.pc'),
          $translate.instant('modules.material.materialUtils.toolsTypes.monitor'),
          $translate.instant('modules.material.materialUtils.toolsTypes.consumerElectronics'),
          $translate.instant('modules.material.materialUtils.toolsTypes.radioTransmitter'),
          $translate.instant('modules.material.materialUtils.toolsTypes.homeAppliance'),
          $translate.instant('modules.material.materialUtils.other'),
        ]
      },
      IntroductionNeeded: {
        type: 'bool'
      },
      Properties: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      Extras: {
        type: 'string',
        customClass: 'col-sm-12',
      },
      Note: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      Handover: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      Amount: {
        type: 'int',
        required: true
      },
      Weight: {
        type: 'int',
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      ISSI: {
        type: 'string',
        // ARNO-2871 Changed with dynamic material type, disabled until further notice
        // hookTo: [
        //   {
        //     Type: [$translate.instant('modules.material.materialUtils.toolsTypes.radioTransmitter'), $translate.instant('modules.material.materialUtils.toolsTypes.radio')]
        //   }
        // ],
        // hookTooltip: $translate.instant('modules.material.materialUtils.toolsHookTooltip')
      },
      RadioCallName: {
        type: 'string',
        // ARNO-2871 Changed with dynamic material type, disabled until further notice
        // hookTo: [
        //   {
        //     Type: [$translate.instant('modules.material.materialUtils.toolsTypes.radioTransmitter'), $translate.instant('modules.material.materialUtils.toolsTypes.radio')]
        //   }
        // ],
        // hookTooltip: $translate.instant('modules.material.materialUtils.toolsHookTooltip')
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      BuiltIn: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_BUILTIN_AUTOFILL'),
        watchFn: function (newVal, oldVal, addModel, form) {
          if (form) {
            if (addModel.BuiltIn && !form.BuiltInInput.$pristine && newVal) {
              form.BuiltInInput.autoCalc = false;
            }
          }
        }
      },
      CreationDate: {
        type: 'date',
        watchFn: function (newVal, oldVal, addModel, form) {
          if (form) {
            if (!addModel.BuiltIn && form.BuiltInInput.$pristine && newVal && moment(newVal)._isValid) {
              addModel.BuiltIn = moment(newVal).year();
              form.BuiltInInput.autoCalc = true;
            }
          }
        }
      },
      SerialNumber: {
        type: 'string',
      },
      CEIdent: {
        type: 'string',
      },
      TEI: {
        type: 'string',
      },
      Supplier: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      ResponsibleCompany: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      MaintenanceCompany: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Active: {
        type: 'bool',
      },
    },
    MaterialMedicalProducts: {
      Type: {
        type: 'string',
        required: true,
      },
      SerialNumber: {
        type: 'string',
      },
      UniqDeviceIdent: {
        type: 'string',
      },
      BuiltIn: {
        type: 'string',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_BUILTIN_AUTOFILL'),
        watchFn: function (newVal, oldVal, addModel, form) {
          if (form) {
            if (addModel.BuiltIn && !form.BuiltInInput.$pristine && newVal) {
              form.BuiltInInput.autoCalc = false;
            }
          }
        }
      },
      CreationDate: {
        type: 'date',
        watchFn: function (newVal, oldVal, addModel, form) {
          if (form) {
            if (!addModel.BuiltIn && form.BuiltInInput.$pristine && newVal && moment(newVal)._isValid) {
              addModel.BuiltIn = moment(newVal).year();
              form.BuiltInInput.autoCalc = true;
            }
          }
        }
      },
      AcquisitionDate: {
        type: 'date',
      },
      RiskClass: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass1'),
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass1s'),
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass1m'),
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass2a'),
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass2b'),
          $translate.instant('modules.material.materialUtils.medicalProductRisks.riskClass3'),
        ]
      },
      MPBVAssignment: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.medicalProductMBPV.mbpv1'),
          $translate.instant('modules.material.materialUtils.medicalProductMBPV.mbpv2'),
          $translate.instant('modules.material.materialUtils.medicalProductMBPV.mbpv3'),
          $translate.instant('modules.material.materialUtils.medicalProductMBPV.noAssignment'),
        ],
        required: false,
      },
      CEIdent: {
        type: 'string',
      },
      OperatingMode: {
        type: 'autocompletion',
        opts: [
          $translate.instant('modules.material.materialUtils.medicalProductOperatingMode.active'),
          $translate.instant('modules.material.materialUtils.medicalProductOperatingMode.withMeasureFunc'),
        ],
      },
      Properties: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      Extras: {
        type: 'string',
        customClass: 'col-sm-12',
      },
      Note: {
        type: 'text',
        customClass: 'col-sm-12',
      },
      Amount: {
        type: 'int',
        required: true
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InventoryNumber: {
        type: 'string'
      },
      Color: {
        type: 'string'
      },
      Supplier: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        customClass: 'col-lg-6',
      },
      ResponsibleCompany: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        customClass: 'col-lg-6',
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        required: true,
      },
      MaintenanceCompany: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        customClass: 'col-lg-6',
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        customClass: 'col-lg-6',
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Active: {
        type: 'bool',
      },
    },
    MaterialOthers: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      AcquisitionDate: {
        type: 'date',
      },
      Name: {
        type: 'string',
        required: true
      },
      Type: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.otherTypes.furniture'),
          $translate.instant('modules.material.materialUtils.otherTypes.ladders'),
          $translate.instant('modules.material.materialUtils.otherTypes.tent'),
          $translate.instant('modules.material.materialUtils.otherTypes.promotionalMaterial'),
          $translate.instant('modules.material.materialUtils.otherTypes.outdoorEquipment'),
          $translate.instant('modules.material.materialUtils.otherTypes.officeSupplies'),
          $translate.instant('modules.material.materialUtils.other'),
        ]
      },
      Amount: {
        type: 'int',
        required: true
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      Note: {
        type: 'text'
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      Active: {
        type: 'bool',
      },
    },
    MaterialMedicine: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      AcquisitionDate: {
        type: 'date',
      },
      Definition: {
        type: 'string',
        required: true
      },
      Amount: {
        type: 'int',
        required: true
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      BatchNumer: {
        type: 'string'
      },
      PharmacyCentralNumber: {
        type: 'string',
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Active: {
        type: 'bool',
      },
    },
    MaterialConsumables: {
      ResponsibleMember: {
        type: 'special',
        formatter: self.memberFormatter,
      },
      Owner: {
        type: 'businessPartner',
        formatter: self.objFormatter,
        onModeAddPlaceholder: $translate.instant('modules.material.materialUtils.automaticCurrentDivision'),
      },
      AcquisitionDate: {
        type: 'date',
      },
      Definition: {
        type: 'string',
        required: true
      },
      Amount: {
        type: 'int',
        required: true
      },
      Storage: {
        type: 'special',
        source: [],
        formatter: self.storageFormatter,
      },
      Type: {
        type: 'dropdown',
        opts: [
          $translate.instant('modules.material.materialUtils.consumableTypes.sterileGoods'),
          $translate.instant('modules.material.materialUtils.consumableTypes.bandages'),
          $translate.instant('modules.material.materialUtils.other'),
          $translate.instant('modules.material.materialUtils.consumableTypes.hygiene'),
          $translate.instant('modules.material.materialUtils.consumableTypes.officeSupplies'),
        ]
      },
      Note: {
        type: 'text'
      },
      MaterialType: {
        type: 'dropdownMaterialType',
        required: true,
        formatter: self.objFormatter,
      },
      InfoLink: {
        type: 'link',
        tooltip: $translate.instant('modules.material.materialUtils.MATERIAL_HELP_LINK'),
      },
      InternalOrder: {
        type: 'special',
      },
      AcquisitionPrice: {
        type: 'special',
      },
      Manufacturer: {
        type: 'businessPartner',
        formatter: self.objFormatter,
      },
      CostCenterSpecification: {
        type: 'special',
      },
      Active: {
        type: 'bool',
      },
    }
  };

  return self;
}

angular
    .module('ArnoDash')
    .service('helperHoursService', HelperHoursService);

/** @ngInject */
function HelperHoursService() {
  var self = this;

  self.fetchEffectiveStartEndDateTime = function(dt) {
    var startDateTime = moment(dt.date).startOf('day');
    var endDateTime = dt.dateEnd ? moment(dt.dateEnd).startOf('day') : undefined;
    if (dt.dateStartTime || dt.dateEndTime) {
      if (!dt.dateStartTime || !dt.dateEnd || !dt.dateEndTime) {
        return false; // if one is set, all need to be set
      }
      var dateStartTime = moment(dt.dateStartTime);
      var startMinutes = (dateStartTime.hours() * 60) + dateStartTime.minutes();
      startDateTime = startDateTime.minutes(startMinutes);

      var dateEndTime = moment(dt.dateEndTime);
      var endMinutes = (dateEndTime.hours() * 60) + dateEndTime.minutes();
      endDateTime = endDateTime.minutes(endMinutes);
    }
    return { startDateTime: startDateTime, endDateTime: endDateTime };
  };

  self.isValidDate = function (dt) {
    if (!dt.date) {
      return false;
    }
    var effective = self.fetchEffectiveStartEndDateTime(dt);
    return effective && (!effective.endDateTime || moment(effective.startDateTime).isBefore(effective.endDateTime));
  };

  self.isValidDuration = function(dt) {
    var activityMinutes = dt.hours * 60 + dt.minutes;

    if (!dt.dateEndTime) {
      return activityMinutes <= (24 * 60);
    }

    var diff = moment(dt.dateEnd).hours(moment(dt.dateEndTime).hour()).minutes(moment(dt.dateEndTime).minute())
      .diff(moment(dt.date).hours(moment(dt.dateStartTime).hour()).minutes(moment(dt.dateStartTime).minute()), 'minutes')
    return diff >= activityMinutes;
  }
}

angular
    .module('ArnoDash')
    .service('fileUtil', ArnoFileUtilService);

/** @ngInject */
function ArnoFileUtilService(clientApi) {
  var self = this;

  self.mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webm: 'video/webm',
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/msexcel',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc: 'application/msword',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ppt: 'application/mspowerpoint',

  };

  self.fileHasPreview = function (fileName) {
    var ext = fileName.split('.').pop().toLowerCase();
    return !!~['jpg', 'jpeg', 'png', 'webm', 'pdf'].indexOf(ext);
  };

  self.viewOrDownloadFile = function (entity) {
    if (!entity) {
      return;
    }

    var entityData = self.normalizeEntityData(entity);

    if (!entityData.fileName) {
      return;
    }

    if (self.fileHasPreview(entityData.fileName)) {
      self.previewFile(entity);
    } else {
      self.downloadFile(entity); 
    }
  };

  self.normalizeEntityData = function (entity) {
    var entityData = {
      divisionId: entity.DivisionId || entity.divisionId,
      fileName: entity.File || entity.file,
      storageIdent: entity.StorageIdent || entity.storageIdent,
      prefix: entity.Prefix || entity.prefix,
      ignoreDivPath: entity.IgnoreDivPath || entity.ignoreDivPath,
    };

    if (entity.path || entity.Path) {
      entityData.path = entity.path || entity.Path;
    }

    if (entity.pathData || entity.PathData) {
      entityData.pathData = JSON.stringify(entity.pathData || entity.PathData);
    }

    if (entity.isOwnDossier) {
      entityData.isOwnDossier = entity.isOwnDossier;
    }

    return entityData;
  };

  self.previewFile = function (entity) {
    var entityData = self.normalizeEntityData(entity);
    var extension = entityData.fileName.split('.').pop().toLowerCase();

    clientApi
      .emit('files/download', entityData, 'binary')
      .then(function (res) {
        var blobStore = new Blob([res], { type: self.mimeTypes[extension] });
        var data = window.URL.createObjectURL(blobStore);
        window.open(data);
      });
  };

  self.downloadFile = function (entity) {
    return clientApi.openTab(
      'files/download',
      self.normalizeEntityData(entity)
    );
  };
}

(function () {
  /** @ngInject */
  angular.module('ArnoDash')
    .service('eventUtil', function (baModalService, $translate) {
      var self = {
        chooseAttendanceDivisionModal: function (updateAttendee, selectionOptions, type) {
          return baModalService
            .messageModal({
              modalType: 'info',
              allowHtml: false,
              title: $translate.instant('modules.events.event.modal.chooseAttendanceDivisionModalTitle'),
              content: $translate.instant(
                'modules.events.event.modal.chooseAttendanceDivisionModalContent', {
                  serviceType: type === 'SERVICE',
                  fullName: updateAttendee.fullName,
                  Interested: updateAttendee.Interested,
                  DivisionName: (updateAttendee.Division || {}).Name,
                }),
              primaryActionText: $translate.instant('generalTerms.confirm'),
              secondaryActionText: $translate.instant('generalTerms.cancel'),
              selectionOptions: selectionOptions,
            })
        },
        attendanceDivisionChangeWarnModal: function (currentAttendee, newDivisionMember, type) {
          return baModalService
            .messageModal({
              modalType: 'warning',
              allowHtml: false,
              title: $translate.instant('modules.events.event.modal.attendanceDivisionChangeWarnModalTitle'),
              content: $translate.instant(
                'modules.events.event.modal.attendanceDivisionChangeWarnModalContent', {
                  serviceType: type === 'SERVICE',
                  fullName: currentAttendee.fullName,
                  DivisionName: (currentAttendee.Division || {}).Name,
                  NewDivisionName: (newDivisionMember.Division || {}).Name,
                  Acceptance: currentAttendee.Acceptance,
                  Interested: currentAttendee.Interested,
                }),
              primaryActionText: $translate.instant('generalTerms.continue'),
              secondaryActionText: $translate.instant('generalTerms.cancel'),
            })
        },
        saveBeforeProceedModal: function (requestActionNaturalLanguage, eventTypeNaturalLanguage) {
          return baModalService
            .messageModal({
              modalType: 'info',
              allowHtml: false,
              title: $translate.instant('modules.events.event.modal.pleaseSaveEventChangesTitle'),
              content: $translate.instant('modules.events.event.modal.pleaseSaveEventChangesMsg', { eventTypeNaturalLanguage: eventTypeNaturalLanguage })
                       + ', ' + (requestActionNaturalLanguage || '') + '.',
              primaryActionText: $translate.instant('generalTerms.ok'),
            });
        },
      };

      return self;
    });
})();

/**
 * @name ArnoDashAdminDivisionsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Division (Approval) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminDivisionsService', ArnoDashAdminDivisionsService);

// NOTE: Do further refactoring from the controller-fns to this service, clientApi will be used
/** @ngInject */
function ArnoDashAdminDivisionsService($q, clientApi, commonUtils) {

  // PUBLIC METHODS
  /**
   * @name fetchMembersOfDivisionRoleToNodeData
   * @description This method fetch members of division-roles and attaches them to a given divisions-node-data
   *
   * @param {String} roleName                      The role-name for which members should be fetched
   * @param {Object} nodeResults                 The node-results returned by commonUtils.division.buildTreeNodes()
   * @param {Object} members                      The members returned by commonUtils.division.buildTreeNodes()
   * @param {String} scopeOfMembers          The property-name under which the fetched members for division-roles should be put for a division.
   *                                                                      e.g. 'admins' will lead to division.admins = [.......]
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.fetchMembersOfDivisionRoleToNodeData = function (roleName, nodeResults, members, scopeOfMembers, angularNodeMode) {
    if (typeof roleName !== 'string' || !nodeResults || !members || typeof scopeOfMembers !== 'string') {
      return Promise.reject(new Error('ERROR: ArnoDashAdminDivisionsService.fetchMembersOfDivisionRoleToNodeData: Not all params provided'));
    }

    var recurse = function(nodeData, additionalData) {
      nodeData.forEach(function(node) {
        if (node.id !== 'rootOrg') {
          additionalData.forEach(function(data) {
            if (node.id === data.DivisionId.toString()) {
              members.forEach(function (member) {
                if (data.MemberId == member.id) {
                  data.LastName = member.LastName;
                  data.FirstName = member.FirstName;
                  data.EMail = member.Account.EMail;
                  delete data.id;
                  node[scopeOfMembers].push(data);
                }
              });
            }
          })
        }
        if (node.children && node.children.length) {
          recurse(node.children, additionalData)
        }
      })
    };

    return clientApi.custom('model/DivisionRole', 'membersOfDivisionRole', {
      roleName: roleName
    })
      .then(function(roleMembersResults) {
        if (angularNodeMode) {
          recurse(nodeResults, roleMembersResults);
        } else {
          nodeResults.forEach(function (division) {
            division[scopeOfMembers] = division[scopeOfMembers] || [];

            _.forEach(roleMembersResults, function (roleMember) {
              if (division.id == roleMember.DivisionId) {
                members.forEach(function (member) {
                  if (roleMember.MemberId == member.id) {
                    roleMember.LastName = member.LastName;
                    roleMember.FirstName = member.FirstName;
                    roleMember.EMail = member.Account.EMail;
                    delete roleMember.id;
                  }
                });

                division[scopeOfMembers].push(roleMember);
              }
            });
          });
        }

        return nodeResults;
      });
  }

  /**
   * @name pushToSubdivisions
   * @description This method copies the responsible-persons  for a selectedDivision to the sub-divisions
   *
   * @param {String} role                 The role for which responsible-persons should be copied
   * @param {Object} selectedDivision     The selected division (selected by view-components), see divisionCtrl.js for its structure
   * @param {Object} divisionTree         The division-tree of the app, see commonUtils.division.treeData() for its structure
   * @param {Object} divisionData         The division-data from the division-management-panel, see: commonUtils.division.buildTreeNodes()
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.pushToSubdivisions = function (scopeOfMembers, selectedDivision, divisionTree, divisionData) {
    function getChildrenRecursively(divisions, children) {
      if (!children) {
        children = [];
      }
      if (divisions && divisions.length) {
        children = children.concat(divisions);
        return getChildrenRecursively(_.flatMap(divisions, function(x) { return x.children }), children);
      }
      children.shift();
      return children;
    }

    if (typeof scopeOfMembers !== 'string' || !selectedDivision || !divisionTree || !divisionData) {
      // you could also use error-code-mapping, such a system have to be defined with the team first
      return $q.reject({
        errorKey: 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERROR_PARAMS'
      });
    }

    if (selectedDivision[scopeOfMembers].length === 0) {
      return $q.reject({
        errorKey: 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERROR_NO_ROLES'
      });
    }
    var children;

    if (selectedDivision.children && selectedDivision.children.length) {
      // we got angular tree data, so we already have the children here
      children = getChildrenRecursively([selectedDivision]);
      var angularData = true;
    } else {
      children = commonUtils.findAllChildrensBy(divisionTree, 'ParentDivisionId', selectedDivision, 'id');

      if (!children || !children.length) {
        return $q.reject({
          errorKey: 'DIVISION_SERVICE_PUSH_TO_SUB_DIV_ERROR_NO_CHILD_DIVISIONS'
        });
      }
    }

    var changesOccured = false;
    children.forEach(function (child) {
      var division = angularData ? child : _.find(divisionData, ['id', child]);
      var selDivisionCopy = _.cloneDeep(selectedDivision);

      selDivisionCopy[scopeOfMembers].forEach(function (supervisor) {
        // if we copy already saved people, we need to set them to new rolemember for the save to properly apply to sub divisions
        if (!supervisor.delete) {
          supervisor.isNewRolemember = true;
        }

        if (supervisor.id && !supervisor.MemberId) {
          supervisor.MemberId = supervisor.id;
        }
      })

      division[scopeOfMembers] = _.unionBy(division[scopeOfMembers], selDivisionCopy[scopeOfMembers], 'MemberId');

      // recheck, if there were changes by the merging of all members to sub-div
      _.forEach(division[scopeOfMembers], function(supervisor) {
        if (supervisor && supervisor.isNewRolemember === true) {
          changesOccured = true;
        }
      });
    });

    return $q.resolve({success: true, changesOccured: changesOccured});
  }

  this.fetchDivisionsWithName = function(divisionIds) {
    return clientApi.custom('model/Division', 'fetchDivisionName', { divisionIds: divisionIds });
  }

}


/**
 * @name ArnoDashCostCentersService
 * @description This Service is responsible to communicate with the backend through the clientApi-Service
 * to provide CostCenter centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashCostCentersService', ArnoDashCostCentersService);

/** @ngInject */
function ArnoDashCostCentersService(
  $q, $log, $translate, clientApi, toastr, baModalService
) {
  var self = this;

  // METHODS
  /**
   * @name getCostCentersForOrg
   * @description This method returns costCenters for the whole organization
   */
  this.getCostCentersForOrg = function(loadSpecifications) {
    return clientApi.custom('model/CostCenter', 'getCostCentersForOrg', { loadSpecifications: loadSpecifications || false });
  }

  /**
   * @name saveCostCenterWithNotifications
   *
   * @param {Object} costCenter Data of the cost-center to be saved. If no id is present, then a new cost-center will be created!
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.saveCostCenterWithNotifications = function(costCenter) {
    if (costCenter) {
      var transferObj = _.clone(costCenter);

      return clientApi.custom('model/CostCenter', 'saveCostCenter', {
        costCenter: transferObj,
      })
        .then(function(savedCostCenter) {
          toastr.success(
            $translate.instant('modules.administration.finances.costCenters.saveSuccessMsg'),
            $translate.instant('modules.administration.finances.costCenters.saveSuccessTitle')
          );

          // update the old model from, applying this merge chain will also ensure,
          // that the updated data by the backend will be updated to the frontend
          costCenter = _.merge(costCenter, transferObj, savedCostCenter);

          return costCenter;
        })
        .catch(function(error) {
          switch((error.data || {}).key) {
          case 'COSTCENTER_SAVE_INVALID_DATA':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.saveFailedInvalidDataMsg'),
              $translate.instant('modules.administration.finances.costCenters.saveFailedTitle')
            );
            break;

          case 'COSTCENTER_SAVE_IDENTIFIER_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.saveFailedInvalidIdMsg'),
              $translate.instant('modules.administration.finances.costCenters.saveFailedTitle')
            );
            break;

          case 'COSTCENTER_SAVE_NAME_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.saveFailedInvalidNameMsg'),
              $translate.instant('modules.administration.finances.costCenters.saveFailedTitle')
            );
            break;

          default:
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.saveFailedGenericMsg'),
              $translate.instant('modules.administration.finances.costCenters.saveFailedTitle')
            );
          }

          return Promise.reject(error);
        });
    }

    return $q.reject('ERROR: ArnoDashCostCentersService.saveCostCenterWithNotifications: You have to provide a costCenter object!');
  };

  /**
   * @name deleteCostCenter
   * @description This method deletes a given costCenter by id
   */
  this.deleteCostCenter = function(costCenter) {
    if (!(costCenter || {}).id) {
      return $q.reject('ERROR: ArnoDashCostCentersService.deleteCostCenter: Invalid costCenter id!');
    }

    return clientApi.custom('model/CostCenter', 'deleteCostCenter', {
      costCenterId: costCenter.id,
    });
  }

  /**
   * @name deleteCostCenterWithMessageModal
   * @description This method show a message-modal and asks the user to delete a costCenter
   * it handles success and error cases with toastr
   */
  this.deleteCostCenterWithMessageModal = function(costCenter) {
    var costCenterName = (costCenter || {}).Name;

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.administration.finances.costCenters.deleteConfirmTitle'),
      content: $translate.instant('modules.administration.finances.costCenters.deleteConfirmMsg', { costCenterName: costCenterName }),

      primaryActionText: $translate.instant('generalTerms.delete'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function() {
        return self.deleteCostCenter(costCenter)
          .then(function(results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.administration.finances.costCenters.deleteSuccessMsg', { costCenterName: costCenterName }),
                $translate.instant('modules.administration.finances.costCenters.deleteSuccessTitle')
              );
            }

            return results;
          })
          .catch(function(error) {
            toastr.error(
                $translate.instant('modules.administration.finances.costCenters.deleteFailedMsg'),
                $translate.instant('modules.administration.finances.costCenters.deleteFailedTitle')
              );

            $log.error('ERROR: ArnoDashCostCentersService.deleteCostCenter: delete of CostCenter failed!\n',
              costCenter, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }

  // HELPERS

}


/**
 * @name ArnoDashCostCenterSpecificationsService
 * @description This Service is responsible to communicate with the backend through the clientApi-Service
 * to provide CostCenterSpecification centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashCostCenterSpecificationsService', ArnoDashCostCenterSpecificationsService);

/** @ngInject */
function ArnoDashCostCenterSpecificationsService(
  $q, $log, $translate, clientApi, toastr, baModalService
) {
  var self = this;


  // METHODS
  /**
   * @name getSpecificationsForCostCenter
   * @description This method returns cost-center specifications for the given cost-center
   */
  this.getSpecificationsForCostCenter = function(costCenterId) {
    return clientApi.custom('model/CostCenterSpecification', 'getSpecificationsForCostCenter', { costCenterId: costCenterId });
  }

  /**
   * @name saveSpecificationWithNotifications
   *
   * @param {Object} costCenterSpecification Data to be saved. If no id is present, then a new cost-center-specification will be created!
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.saveSpecificationWithNotifications = function(costCenterSpecification) {
    if (costCenterSpecification) {
      var transferObj = _.clone(costCenterSpecification);

      return clientApi.custom('model/CostCenterSpecification', 'saveCostCenterSpecification', {
        costCenterSpecification: transferObj,
      })
        .then(function(savedCostCenterSpecification) {
          toastr.success(
            $translate.instant('modules.administration.finances.costCenters.specifications.saveSuccessMsg'),
            $translate.instant('modules.administration.finances.costCenters.specifications.saveSuccessTitle')
          );

          // update the old model from, applying this merge chain will also ensure,
          // that the updated data by the backend will be updated to the frontend
          costCenterSpecification = _.merge(costCenterSpecification, transferObj, savedCostCenterSpecification);

          return costCenterSpecification;
        })
        .catch(function(error) {
          switch((error.data || {}).key) {
          case 'COSTCENTER_SPECIFICATION_SAVE_INVALID_DATA':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedInvalidDataMsg'),
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedTitle')
            );
            break;

          case 'COSTCENTER_SPECIFICATION_SAVE_IDENTIFIER_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedInvalidIdMsg'),
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedTitle')
            );
            break;

          case 'COSTCENTER_SPECIFICATION_SAVE_NAME_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedInvalidNameMsg'),
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedTitle')
            );
            break;

          case 'COSTCENTER_SPECIFICATION_SAVE_TAX_RATE_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedInvalidTaxRateMsg'),
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedTitle')
            );
            break;

          default:
            toastr.error(
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedGenericMsg'),
              $translate.instant('modules.administration.finances.costCenters.specifications.saveFailedTitle')
            );
          }

          return Promise.reject(error);
        });
    }

    return $q.reject('ERROR: ArnoDashCostCenterSpecificationsService.saveSpecificationWithNotifications: You have to provide a cost-center specification object!');
  };

  /**
   * @name deleteSpecification
   * @description This method deletes a given cost-center specification by id
   */
  this.deleteSpecification = function(costCenterSpecification) {
    if (!(costCenterSpecification || {}).id) {
      return $q.reject('ERROR: ArnoDashCostCenterSpecificationsService.deleteSpecification: Invalid costCenterSpecification id!');
    }

    return clientApi.custom('model/CostCenterSpecification', 'deleteCostCenterSpecification', {
      costCenterSpecificationId: costCenterSpecification.id,
    });
  }

  /**
   * @name deleteSpecificationWithMessageModal
   * @description This method shows a message-modal and asks the user to delete a cost-center specification
   * it handles success and error cases with toastr
   */
  this.deleteSpecificationWithMessageModal = function(costCenterSpecification) {
    var specificationName = (costCenterSpecification || {}).Name;

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.administration.finances.costCenters.specifications.deleteConfirmTitle'),
      content: $translate.instant('modules.administration.finances.costCenters.specifications.deleteConfirmMsg', { specificationName: specificationName }),

      primaryActionText: $translate.instant('generalTerms.delete'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function() {
        return self.deleteSpecification(costCenterSpecification)
          .then(function(results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.administration.finances.costCenters.specifications.deleteSuccessMsg', { specificationName: specificationName }),
                $translate.instant('modules.administration.finances.costCenters.specifications.deleteSuccessTitle')
              );
            }

            return results;
          })
          .catch(function(error) {
            toastr.error(
                $translate.instant('modules.administration.finances.costCenters.specifications.deleteFailedMsg'),
                $translate.instant('modules.administration.finances.costCenters.specifications.deleteFailedTitle')
              );

            $log.error('ERROR: ArnoDashCostCenterSpecificationsService.deleteSpecification: delete of CostCenter failed!\n',
              costCenterSpecification, '\n', error
            );

            return Promise.reject(error);
          });
      });
  }
}

angular
  .module('ArnoDash')
  .service('ArnoDashContactManagementService', ArnoDashContactManagementService);

/** @ngInject */
function ArnoDashContactManagementService(clientApi, toastr, $translate, baModalService) {
  var self = this;

  self.getContactAllWithOrg = function (divisionIds, queryWishes) {
    return clientApi.custom('model/contact', 'getContactAllWithOrg', {
      divisionIds: divisionIds,
      queryWishes: queryWishes,
    });
  };

  self.getContactOneWithOrg = function (contactId, divisionIds) {
    return clientApi.custom('model/contact', 'getContactOneWithOrg', {
      contactId: contactId,
      divisionIds: divisionIds,
    });
  };

  self.getDivisionData = function (contact, divisionIds, queryWishes) {
    return clientApi.custom('model/division', 'getDivisionData', {
      contactId: contact.id,
      queryWishes: queryWishes,
      divisionIds: divisionIds
    });
  };

  self.getContactAllInDivision = function (contactList, divisionIds) {
    var contactIdList = [];
    contactList.forEach(function (entry) {
      contactIdList.push(entry.id);
    });
    return clientApi.custom('model/contact', 'getContactAllInDivision', {
      contactIdList: contactIdList,
      divisionIds: divisionIds
    });
  };

  self.saveContact = function (contact, divisionList, sourceDivision) {
    if (contact && divisionList) {
      if (contact.BusinessPartner && contact.BusinessPartner.id) {
        var transferObj = _.clone(contact);
        return clientApi.custom('model/contact', 'saveContact', {
          contact: transferObj,
          divisionList: divisionList,
          sourceDivision: sourceDivision,
        }).then(function(savedContact) {
          toastr.success(
            $translate.instant('modules.contacts.contactManagement.toastr.saveContactSuccessMessage'),
            $translate.instant('modules.contacts.contactManagement.toastr.saveContactSuccessTitle')
          );
          contact = _.merge(contact, transferObj, savedContact);
          return contact;
        }).catch(function() {
          toastr.error(
            $translate.instant('modules.contacts.contactManagement.toastr.saveContactFailedMessage'),
            $translate.instant('modules.contacts.contactManagement.toastr.saveContactFailedTitle')
          );
          return Promise.reject();
        });
      } else {
        return Promise.reject();
      }
    }
  };

  self.addDivisions = function (contact, divisionIds) {
    return clientApi.custom('model/contact', 'addDivisions', {
      contactId: contact.id,
      divisionIds: divisionIds,
    }).catch(function() {
      toastr.error(
        $translate.instant('modules.contacts.contactManagement.toastr.ownRootOrgNotSelectableMsg'),
        $translate.instant('modules.contacts.contactManagement.toastr.ownRootOrgNotSelectableTitle')
      );
    });
  };

  self.removeDivisions = function (contact, divisionIds) {
    var remove = function() {
      return clientApi.custom('model/contact', 'removeDivisions', {
        contactId: contact.id,
        divisionIds: divisionIds,
      }).then(function (result) {
        if (result > 0) {
          toastr.success(
            $translate.instant('modules.contacts.contactManagement.toastr.removedDivisionAndDeletedMsg'),
            $translate.instant('modules.contacts.contactManagement.toastr.removedDivisionAndDeletedTitle')
          );
        }
        return result;
      }).catch(function() {
        toastr.error(
          $translate.instant('modules.contacts.contactManagement.toastr.ownRootOrgNotSelectableMsg'),
          $translate.instant('modules.contacts.contactManagement.toastr.ownRootOrgNotSelectableTitle')
        );
      });
    }

    return clientApi.custom('model/Contact', 'getDivisionIds', {
      contactId: contact.id,
    })
    .then(function(foundIds) {
      if(divisionIds && divisionIds.length === 1 && foundIds && foundIds.length && divisionIds[0] === foundIds[0].toString()) {
        return baModalService.messageModal({
          modalType: 'danger',
          allowHtml: false,    
          title: $translate.instant('modules.contacts.contactManagement.toastr.deleteContactTitle'),
          content: $translate.instant('modules.contacts.contactManagement.toastr.deleteContactMsg', { contact: contact.Function }),    
          primaryActionText: $translate.instant('generalTerms.delete'),
          secondaryActionText: $translate.instant('generalTerms.cancel')
        }).then(remove);
      }
      else {
        return remove();
      }
    });    
  };

  self.getBusinessPartnerList = function () {
    return clientApi.custom('model/businesspartner', 'getBusinessPartnerList');
  };

  self.searchBusinessPartnerByName = function (searchTerm, divisionIds) {
    return clientApi.custom('model/businesspartner', 'searchBusinessPartnerByName', {
      searchTerm: searchTerm,
      divisionIds: divisionIds
    });
  };

  self.getSimilarContacts = function (contact) {
    if (contact.BusinessPartner && contact.BusinessPartner.id) {
      return clientApi.custom('model/contact', 'getSimilarContacts', {
        contact: contact,
      });
    }
    return Promise.resolve([]);
  };

  self.isValid = function (contact) {
    if (!contact.BusinessPartnerId || !contact.BusinessPartner.id) {
      toastr.error(
        $translate.instant('modules.contacts.contactManagement.toastr.businesspartnerNotEmptyMsg'),
        $translate.instant('modules.contacts.contactManagement.toastr.businesspartnerNotEmptyTitle')
      );
      contact.BusinessPartnerId = null;
      contact.BusinessPartner.id = null;
      contact.BusinessPartner.Name = null;
      return false;
    } else if (!contact.Function) {
      toastr.error(
        $translate.instant('modules.contacts.contactManagement.toastr.functionEmptyMsg'),
        $translate.instant('modules.contacts.contactManagement.toastr.functionEmptyTitle')
      );
      return false;
    } else {
      return true;
    }
  };

}
(function () {
  /** @ngInject */
  angular
    .module('ArnoDash')
    .service(
      'clientApi',
      function (
        $rootScope,
        webCore,
        $http,
        $httpParamSerializer,
        $log,
        $injector,
        progressBar,
        toastr,
        $translate
      ) {
        var self = {
          helper: {
            getCookie: function (cname) {
              var name = cname + '=';
              var decodedCookie = decodeURIComponent(document.cookie);
              var ca = decodedCookie.split(';');
              for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return '';
            },
            currentlyInPromise: {},
            checkRequestAlreadyInPromise: function (request) {
              var requestKey = JSON.stringify(request);
              if (self.helper.currentlyInPromise.hasOwnProperty(requestKey)) {
                return self.helper.currentlyInPromise[requestKey];
              }

              self.helper.currentlyInPromise[requestKey] = $http(request);

              return self.helper.currentlyInPromise[requestKey].finally(
                function () {
                  delete self.helper.currentlyInPromise[requestKey];
                }
              );
            },
          },
          openTab: function (action, paramsObj, opts) {
            var options = opts || {};

            paramsObj.xsrf = self.prepareContext(paramsObj, action);
            paramsObj.c = JSON.stringify(paramsObj.c);

            if (options.post) {
              var form = document.createElement('form');
              form.setAttribute('method', 'post');
              form.setAttribute('action', '/api?action=' + action);
              form.setAttribute('target', '_blank');

              Object.keys(paramsObj).forEach(function (paramKey) {
                var tmpField = document.createElement('input');
                tmpField.setAttribute('type', 'hidden');
                tmpField.setAttribute('name', paramKey);
                tmpField.setAttribute('value', paramsObj[paramKey]);
                form.appendChild(tmpField);
              });

              document.body.appendChild(form);
              form.submit();
              document.body.removeChild(form);
            } else {
              window.open(
                '/api?action=' +
                  action +
                  '&' +
                  Object.keys(paramsObj)
                    .map(function (paramKey) {
                      return (
                        paramKey + '=' + encodeURIComponent(paramsObj[paramKey])
                      );
                    })
                    .join('&')
              );
            }
          },
          checkRedirectMember: function (email) {
            return fetch('/api?action=redirect/checkMember&email=' + email)
              .then(function (response) {
                return response.json();
              })
              .then(function (json) {
                return json && json.redirect;
              })
              .catch(function (error) {
                console.error('checkRedirectMember failed', error);
              });
          },
          prepareContext: function (data, requestIdent) {
            // append context data to request
            data.c = {};

            if ($rootScope.ctx) {
              data.c.organizationId = $rootScope.ctx.organization.current.id;
            } else if (
              !~['initData', 'organization/getOrgByAuthHost'].indexOf(
                requestIdent
              )
            ) {
              throw new Error(
                'This request was sent without organization context. Please make sure to inject rootResolve into your resolve.'
              );
            }

            return self.helper.getCookie('XSRF-TOKEN');
          },
          request: function (method, endPoint, data, pRequestOpts, type) {
            var requestOpts = pRequestOpts || {};
            if (!requestOpts.backgroundRequest) {
              progressBar.start();
            }
            data = data || {};
            var csrf = self.prepareContext(data, endPoint);

            var request = {
              url: webCore.url + '/api/' + endPoint,
              method: method,
              headers: {
                'X-XSRF-TOKEN': csrf,
              },
            };

            if (type === 'binary') {
              request.responseType = 'arraybuffer';
            }

            if (method === 'GET') {
              if (data.q) {
                data.q = JSON.stringify(data.q);
              }
              request.params = data;
            } else {
              request.data = data;
            }

            return self.helper
              .checkRequestAlreadyInPromise(request)
              .then(function (response) {
                if (!requestOpts.backgroundRequest) {
                  progressBar.complete();
                }
                return response.data;
              })
              .catch(function (err) {
                if (!requestOpts.backgroundRequest) {
                  progressBar.complete(true);
                }

                switch ((err || {}).status) {
                case 404:
                    // return error for 404, maybe this should be reworked later,  err.data.error is added as string to Error.message
                    // this was kept to avoid possible side effects maybe with othr consumers of this function in the source, which may need this...
                  return Promise.reject(
                      new Error(
                        err.data ? err.data.error : 'unknown error occurred'
                      )
                    );

                case 403:
                    // inform the user that this action was forbidden, if the suppress-option for notifications is not true (default-case)
                  toastr.error(
                      $translate.instant(
                        'modules.system.networkActionForbiddenMsg'
                      ),
                      $translate.instant(
                        'modules.system.networkActionForbiddenTitle'
                      )
                    );
                  break;

                default:
                }

                $log.debug(err);
                // use this construct to add data to the Error-object, w/o Error-object bluebird would moan about that
                var errorResult = new Error('error occurred');
                errorResult.data =
                  err && err.data ? err.data.error : 'unknown error';

                return Promise.reject(errorResult);
              });
          },
          fileUploaderConfig: function (fileUploaderConfig) {
            var cStore = {};
            var csrf = self.prepareContext(cStore, '');
            return _.assign(fileUploaderConfig, {
              headers: {
                'X-XSRF-TOKEN': csrf,
              },
              formData: [{ c: JSON.stringify(cStore.c) }],
            });
          },
        };

        var result = {
          custom: function (model, method, options, requestOpts) {
            var args = {};
            options && (args.q = options);
            return self.request(
              'POST',
              'core/' + model + '/' + method,
              args,
              requestOpts
            );
          },
          emit: function (action, data, type) {
            data = data || {};
            return self.request('POST', action, data, null, type);
          },
          post: function (action, data) {
            return result.emit(action, data);
          },
          openTab: self.openTab,
          checkRedirectMember: self.checkRedirectMember,
          fileUploaderConfig: self.fileUploaderConfig,
        };
        return result;
      }
    );
})();


/**
 * @name ArnoDashAdminClearancesGroupsService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide ClearanceGroup centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminClearancesGroupsService', ArnoDashAdminClearancesGroupsService);

/** @ngInject */
function ArnoDashAdminClearancesGroupsService($q, clientApi) {

  /**
   * @name deleteGroup
   * @description This method deletes a group, with the option to delete the clearances too
   *
   * @param {String} groupId
   * @param {Boolean}  isFullDelete
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.deleteGroup = function(groupId, isFullDelete) {
    if (groupId) {
      return clientApi.custom('model/ClearanceGroup', 'deleteGroup', { groupId: groupId, isFullDelete: isFullDelete });
    }

    return $q.reject('ERROR: ArnoDashAdminClearancesGroupsService.deleteGroup: You have to provide the groupId!');
  };
}


/**
 * @name ArnoDashAdminClearancesService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Clearance (Approval) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminClearancesService', ArnoDashAdminClearancesService);

/** @ngInject */
function ArnoDashAdminClearancesService($q, clientApi) {
  /**
   * @name changeGroup
   * @description This method changes the current group the clearance belongs to
   *
   * @param {Approval} clearance    The "Approval" (clearance) object defined with sequelize
   * @param {Number}  newGroupId  The id of the new group which the clearance should be assigned to
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.changeGroup = function(clearance, newGroupId) {
    // SECURITY
    if (clearance && newGroupId) {
      return clientApi.custom('model/Approval', 'updateOneApproval', {
        approvalId: clearance.id,
        approval: {
          Title: clearance.Title,
          OrganizationId: clearance.OrganizationId,
          Description: clearance.Description,
          LetterTitle: clearance.LetterTitle,
          Reminder1Title: clearance.Reminder1Title,
          Reminder2Title: clearance.Reminder2Title,
          ResubmissionTitle: clearance.ResubmissionTitle,
          InspectionTitle: clearance.InspectionTitle,
          ClearanceGroupId: newGroupId,
        },
      }, {
        where: {
          id: clearance.id
        }
      });
    }

    return $q.reject('ERROR: ArnoDashAdminClearancesService.changeGroup: You must provide the clearance and the id of the new group!');
  };

  /**
   * @name getUnassignedClearances
   * @description This method gets all clearances from backend, which are not assigned to any clearances-group
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getUnassignedClearances = function () {
    return clientApi.custom('model/Approval', 'getUnassignedClearances', {});
  }

  /**
   * @name getApprovalStartAndEditReferences
   * @description This method gets all the start and edit-reference through the item-permissions for the given divisionIds
   * REMARK: even if you want to fetch only for 1 division, the provided divisionIds must be an array for the api-endpoint!
   *
   * @param {Array<String | Number>}    divisionIds The divisions-ids for which start/edit references should be fetched
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.getApprovalStartAndEditReferences = function(divisionIds) {
    return clientApi.custom('model/Approval', 'getApprovalStartAndEditReferences', {
      divisionIds: divisionIds
    });
  }

  this.getClearancesForProcessList = function() {
    return clientApi.custom('model/Approval', 'getClearancesForProcessList', {});
  }

  this.getInitiatingOrEditingMembers = function(divisionId, editing) {
    return clientApi.custom('model/Approval', 'getInitiatingOrEditingMembers', {
      divisionId: divisionId,
      editing: editing
    });
  }
}


/**
 * @name ArnoDashAdminCategoriesService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Category (Category) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashAdminCategoriesService', ArnoDashAdminCategoriesService);

/** @ngInject */
function ArnoDashAdminCategoriesService($q, clientApi) {
  /**
   * @name createCategory
   * @description This method creates a new category with the given properties
   *
   * @param {String} name    Name of the category
   * @param {String} color    Color of the category in Hex-String format, e.g. '#FF0000'
   * @param {Array<String>} usages    Array of Names of the mappings for the category, e.g. ['Event', 'Training']
   * @param {Number} divId    OPTIONAL: id of the division
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.createCategory = function(name, color, usages, divId) {
    if (name, color) {
      return clientApi.custom('model/BaseCategory', 'createBaseCategory', {
        name: name,
        color: color,
        usages: usages,
        divId: divId,
      });
    }

    return $q.reject('ERROR: ArnoDashAdminCategoriesService.createCategory: You must provide the required data for the new category!');
  };

  /**
   * @name findCategories
   * @description This method fetches organization and division categories
   *
   * @param {Object} options    Options to fetch the categories
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.findCategories = function(options) {
    return clientApi.custom('model/BaseCategory', 'findOrgCategories', options);
  }

}


/**
 * @name ArnoDashCataloguesService
 * @description This Service is responsible to communicate with thte backend through the clientApi-Service
 * to provide Catalogue (Catalogue) centric methods
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashCataloguesService', ArnoDashCataloguesService);

/** @ngInject */
function ArnoDashCataloguesService($q, clientApi, $translate) {
  /**
   * @name fetchCatalogue
   * @description This method fetches a catalogue from api by its key
   *
   * @param {String} key    Name/Key (see field "CatalogueKey" in model MetaCatalogue) of the catalogue
   * @param {String} version    Version for which entries of the catalogue should be fetched
   *
   * @return The promise for the api request from clientApi-Service
   */
  this.fetchCatalogue = function(key, customAttributes, version) {
    if (key) {
      return clientApi.custom('model/MetaCatalogue', 'fetchCatalogue', {
        catalogueKey: key,
        customAttributes: customAttributes,
        catalogueVersion: version
      })
      .then(function(catalogue) {
        catalogue.Entries = (catalogue.Entries || []).map(function (entry) {
          var compoundKey = 'catalogues.' + key + '.' + entry.mapping;
          var translation = $translate.instant('catalogues.' + key + '.' + entry.mapping);

          if (translation !== compoundKey) {
            if (key === 'CatalogueCountry') {
              entry.FullName = translation;
            } else {
              entry.Name = translation;
            }
          }
          return entry;
        })
        catalogue.Entries = _.sortBy(catalogue.Entries, 'Name');
        return catalogue.Entries;
      })
    }

    return $q.reject('ERROR: ArnoDashCataloguesService.fetchCatalogue: You must provide the required params to fetch the catalogue!');
  };

}


/**
 * @name ArnoDashBusinessPartnersService
 * @description This Service is responsible to communicate with the backend through the clientApi-Service
 * to provide BusinessPartner centric methods.
 *
 */
angular
    .module('ArnoDash')
    .service('ArnoDashBusinessPartnersService', ArnoDashBusinessPartnersService);

/** @ngInject */
function ArnoDashBusinessPartnersService(
  $q, $log, $translate, clientApi, toastr, baModalService
) {
  var self = this;

  // METHODS
  this.getFilteredBusinessPartnersForOrg = function(queryOptions) {
    return clientApi.custom('model/BusinessPartner', 'getFilteredBusinessPartnersForOrg', {
      queryOptions: queryOptions || {},
    });
  }

  /**
   * @name getLinkedBusinessPartnersForDivisions
   * @description This method returns businessPartners for the whole organization
   */
  this.getLinkedBusinessPartnersForDivisions = function(queryOptions, divisionIds) {
    return clientApi.custom('model/BusinessPartner', 'getLinkedBusinessPartnersForDivisions', {
      queryOptions: queryOptions || {},
      divisionIds: divisionIds
    });
  }

  this.getBusinessPartnerDetails = function(businessPartnerId, loadDivisions, limitedAccess) {
    return clientApi.custom('model/BusinessPartner', 'getBusinessPartnerDetails', {
      businessPartnerId: businessPartnerId,
      loadDivisions: loadDivisions,
      limitedAccess: limitedAccess,
    });
  }

  this.checkUniqBusinessPartner = function(businessPartner) {
    if (businessPartner) {
      return clientApi.custom('model/BusinessPartner', 'checkUniqBusinessPartner', {
        businessPartner: businessPartner
      })
      // NOTE: if there was an error, when determining conflicts, then we treat it like
      // there is no conflict, and the api will handle the validation for the fields during the creation / save process...
      .catch(function() { return Promise.resolve() });
    }

    return Promise.reject('checkUniqBusinessPartner: param not valid!');
  }

  this.searchSimilarBusinessPartners = function(businessPartner, strictMode) {
    if (businessPartner) {
      return clientApi.custom('model/BusinessPartner', 'searchSimilarBusinessPartners', {
        businessPartner: businessPartner,
        strictMode: strictMode || false
      });
    }

    return Promise.reject('searchSimilarBusinessPartners: param not valid!');
  }

  /**
   * @name saveBusinessPartnerWithNotifications
   */
  this.saveBusinessPartnerWithNotifications = function(businessPartner, divisionId, customSuccessToast, businessPartnerDivisionLinkData) {
    if (businessPartner) {
      var transferObj = _.clone(businessPartner);
      var successToast = Object.assign({}, {
        title: 'modules.contacts.businessPartners.saveSuccessTitle',
        message: 'modules.contacts.businessPartners.saveSuccessMsg'
      }, customSuccessToast || {});

      return clientApi.custom('model/BusinessPartner', 'saveBusinessPartner', {
        businessPartner: transferObj,
        divisionId: divisionId,
        businessPartnerDivisionLinkData: businessPartnerDivisionLinkData
      })
        .then(function(savedBusinessPartner) {
          toastr.success(
            $translate.instant(successToast.message, { businessPartnerName: businessPartner.Name }),
            $translate.instant(successToast.title)
          );

          // update the old model from, applying this merge chain will also ensure,
          // that the updated data by the backend will be updated to the frontend
          businessPartner = _.merge(businessPartner, transferObj, savedBusinessPartner);

          return businessPartner;
        })
        .catch(function(error) {
          switch((error.data || {}).key) {
          case 'BUSINESSPARTNER_SAVE_INVALID_DATA':
            toastr.error(
              $translate.instant('modules.contacts.businessPartners.saveFailedInvalidDataMsg'),
              $translate.instant('modules.contacts.businessPartners.saveFailedTitle')
            );
            break;

          case 'BUSINESSPARTNER_SAVE_CUSTOMER_NUMBER_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.contacts.businessPartners.saveFailedInvalidTaxIdentMsg'),
              $translate.instant('modules.contacts.businessPartners.saveFailedTitle')
            );
            break;

          case 'BUSINESSPARTNER_SAVE_NAME_MUST_NOT_BE_EMPTY':
            toastr.error(
              $translate.instant('modules.contacts.businessPartners.saveFailedInvalidNameMsg'),
              $translate.instant('modules.contacts.businessPartners.saveFailedTitle')
            );
            break;

          default:
            toastr.error(
              $translate.instant('modules.contacts.businessPartners.saveFailedGenericMsg'),
              $translate.instant('modules.contacts.businessPartners.saveFailedTitle')
            );
          }

          return Promise.reject(error);
        });
    }

    return $q.reject('ERROR: ArnoDashBusinessPartnersService.saveBusinessPartnerWithNotifications: You have to provide a businessPartner object!');
  };

  this.changeBusinessPartnerActiveStatusWithNotification = function(businessPartner) {
    if (businessPartner) {
      var transferObj = _.clone(businessPartner);

      return clientApi.custom('model/BusinessPartner', 'changeBusinessPartnerActiveStatus', {
        businessPartner: transferObj,
      })
        .then(function(updatedBusinessPartner) {
          toastr.success(
            $translate.instant('modules.contacts.businessPartners.updateStatusSuccessMsg', { businessPartnerName: businessPartner.Name }),
            $translate.instant('modules.contacts.businessPartners.updateStatusSuccessTitle')
          );

          // update the old model from, applying this merge chain will also ensure,
          // that the updated data by the backend will be updated to the frontend
          businessPartner = _.merge(businessPartner, transferObj, updatedBusinessPartner);

          return businessPartner;
        })
        .catch(function(error) {
          toastr.error(
            $translate.instant('modules.contacts.businessPartners.saveFailedGenericMsg'),
            $translate.instant('modules.contacts.businessPartners.saveFailedTitle')
          );

          return Promise.reject(error);
        });
    }

    return $q.reject('ERROR: ArnoDashBusinessPartnersService.changeBusinessPartnerActiveStatusWithNotification: You have to provide a businessPartner object!');
  }

  this.changeBusinessPartnerActiveStatusWithMessageModal = function(businessPartner, newActivateStatus) {
    var self = this;

    if (!(businessPartner || {}).id) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.changeBusinessPartnerActiveStatusWithMessageModal: Invalid businessPartner object!');
    }

    return baModalService.messageModal({
      modalType: !newActivateStatus ? 'danger' : 'success',
      allowHtml: false,
      closable: true,

      title: $translate.instant('modules.contacts.businessPartners.updateStatusConfirmTitle'),
      content: $translate.instant(
        !newActivateStatus ? 'modules.contacts.businessPartners.updateStatusConfirmMsgDeactivate' : 'modules.contacts.businessPartners.updateStatusConfirmMsgActivate',
        { businessPartnerName: businessPartner.Name }
      ),

      primaryActionText: $translate.instant(!newActivateStatus ? 'generalTerms.deactivate' : 'generalTerms.activate'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    }).then(function() {
      return self.changeBusinessPartnerActiveStatusWithNotification({ id: businessPartner.id, Active: newActivateStatus });
    });
  }

  /**
   * @name deleteBusinessPartner
   * @description This method deletes a given businessPartner by id
   */
  this.deleteBusinessPartner = function(businessPartner) {
    if (!(businessPartner || {}).id) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.deleteBusinessPartner: Invalid businessPartner id!');
    }

    return clientApi.custom('model/BusinessPartner', 'deleteBusinessPartner', {
      businessPartnerId: businessPartner.id,
    })
      .catch(function(error) {
        switch((error.data || {}).key) {
        case 'BUSINESSPARTNER_DELETE_ASSOCS_EXISTING':
          toastr.error(
              $translate.instant('modules.contacts.businessPartners.deleteFailedDependenciesMsg'),
              $translate.instant('modules.contacts.businessPartners.deleteFailedTitle')
            );
          break;

        default:
          toastr.error(
              $translate.instant('modules.contacts.businessPartners.deleteFailedMsg'),
              $translate.instant('modules.contacts.businessPartners.deleteFailedTitle')
            );
        }

        $log.error('ERROR: ArnoDashBusinessPartnersService.deleteBusinessPartner: delete of BusinessPartner failed!\n',
          businessPartner, '\n', error
        );

        return Promise.reject(error);
      });
  }

  /**
   * @name deleteBusinessPartnerWithMessageModal
   * @description This method show a message-modal and asks the user to delete a businessPartner
   * it handles success and error cases with toastr
   */
  this.deleteBusinessPartnerWithMessageModal = function(businessPartner) {
    if (!(businessPartner || {}).id) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.deleteBusinessPartnerWithMessageModal: Invalid businessPartner object!');
    }

    var businessPartnerName = businessPartner.Name;

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.contacts.businessPartners.deleteConfirmTitle'),
      content: $translate.instant('modules.contacts.businessPartners.deleteConfirmMsg', { businessPartnerName: businessPartnerName }),

      primaryActionText: $translate.instant('generalTerms.delete'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    })
      .then(function() {
        return self.deleteBusinessPartner(businessPartner)
          .then(function(results) {
            if (results) {
              toastr.success(
                $translate.instant('modules.contacts.businessPartners.deleteSuccessMsg', { businessPartnerName: businessPartnerName }),
                $translate.instant('modules.contacts.businessPartners.deleteSuccessTitle')
              );
            }

            return results;
          });
      });
  }

  this.removeLinkedBusinessPartnerFromDivision = function(divisionId, businessPartnerId) {
    if (!divisionId || !businessPartnerId) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.removeLinkedBusinessPartnerFromDivision: Invalid params!');
    }

    return clientApi.custom('model/BusinessPartner', 'removeLinkedBusinessPartnerFromDivision', {
      divisionId: divisionId,
      businessPartnerId: businessPartnerId
    });
  }

  this.removeLinkedBusinessPartnerWithMessageModal = function(divisionId, businessPartner) {
    if (!divisionId || !businessPartner) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.removeLinkedBusinessPartnerWithMessageModal: Invalid params!');
    }

    var businessPartnerName = businessPartner.IsInternal ? (businessPartner.OwnerDivision || {}).Name : businessPartner.Name;
    var businessPartnerId = businessPartner.id

    return baModalService.messageModal({
      modalType: 'danger',
      allowHtml: false,

      title: $translate.instant('modules.contacts.businessPartners.unlinkConfirmTitle'),
      content: $translate.instant('modules.contacts.businessPartners.unlinkConfirmMsg', { businessPartnerName: businessPartnerName }),

      primaryActionText: $translate.instant('generalTerms.remove'),
      secondaryActionText: $translate.instant('generalTerms.cancel')
    }).then(function() {
      return self.removeLinkedBusinessPartnerFromDivision(divisionId, businessPartnerId)
        .then(function(results) {
          if (results) {
            toastr.success(
              $translate.instant('modules.contacts.businessPartners.unlinkSuccessMsg', { businessPartnerName: businessPartnerName }),
              $translate.instant('modules.contacts.businessPartners.unlinkSuccessTitle')
            );
          }

          return results;
        })
        .catch(function(error) {
          toastr.error(
            $translate.instant('modules.contacts.businessPartners.unlinkFailedMsg'),
            $translate.instant('modules.contacts.businessPartners.unlinkFailedTitle')
          );

          $log.error('ERROR: ArnoDashBusinessPartnersService.removeLinkedBusinessPartnerWithMessageModal: unlink of BusinessPartner failed!\n',
            businessPartner, '\n', error
          );

          return Promise.reject(error);
        });
    });
  }

  this.addBusinessPartnerLinkingForDivisionsWithNotifications = function(businessPartner, divisionIds) {
    if (!(divisionIds || []).length || !(businessPartner || {}).id) {
      return $q.reject('ERROR: ArnoDashBusinessPartnersService.addBusinessPartnerLinkingForDivisionsWithNotifications: Invalid params!');
    }

    return clientApi.custom('model/BusinessPartner', 'addBusinessPartnerLinkingForDivisions', {
      divisionIds: divisionIds,
      businessPartnerId: businessPartner.id
    }).then(function(results) {
      if (results) {
        toastr.success(
          $translate.instant('modules.contacts.businessPartners.addLinkingSuccessMsg', { businessPartnerName: businessPartner.Name }),
          $translate.instant('modules.contacts.businessPartners.addLinkingSuccessTitle')
        );
      }

      return results;
    });
  }

  // HELPERS

}

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($log, $timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService) {

    $rootScope.$on('$stateChangeError',
      function (event, toState, toParams, fromState, fromParams, error) {
        $log.error(error);
      });

    var whatToWait = [
      // preloader.loadImg(layoutPaths.images.root + 'arno-bg.jpg'),
    ];

    $rootScope.$hidePreLoad = function () {
      $timeout(function () {
        $rootScope.$hidePreLoader = true;
        $timeout(function () {
          $rootScope.$disablePreLoader = true;
        }, 600);
      }, 0);
    };

    $q.all(whatToWait)
      .then(function () {
        // $log.debug('Initial page load promises finished.');
        $rootScope.$pageFinishedLoading = true;
      })
      .catch(function (e) {
        $log.error(e);
      });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading || !$rootScope.$hidePreLoader) {
        $rootScope.$hidePreLoader = true;
        $rootScope.$pageFinishedLoading = true;
        $log.error('Loading wasn\'t finished after 7s!');
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  /*
  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }
  */

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = '#';
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    // baConfigProvider.changeTheme({blur: true});

    // baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    // });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, 'autoscroll-body-top')) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

angular
  .module('ui.bootstrap.materialPicker', [])

  .directive('materialPicker', [
    '$parse',
    function ($parse) {
      var swatches = [
        {
          name: 'Red',
          camel: 'red',
          colors: [
            { name: '50', hex: 'FFEBEE' },
            { name: '100', hex: 'FFCDD2' },
            { name: '200', hex: 'EF9A9A' },
            { name: '300', hex: 'E57373' },
            { name: '400', hex: 'EF5350' },
            { name: '500', hex: 'F44336' },
            { name: '600', hex: 'E53935' },
            { name: '700', hex: 'D32F2F' },
            { name: '800', hex: 'C62828' },
            { name: '900', hex: 'B71C1C' },
            { name: 'A100', hex: 'FF8A80' },
            { name: 'A200', hex: 'FF5252' },
            { name: 'A400', hex: 'FF1744' },
            { name: 'A700', hex: 'D50000' },
          ],
        },
        {
          name: 'Pink',
          camel: 'pink',
          colors: [
            { name: '50', hex: 'FCE4EC' },
            { name: '100', hex: 'F8BBD0' },
            { name: '200', hex: 'F48FB1' },
            { name: '300', hex: 'F06292' },
            { name: '400', hex: 'EC407A' },
            { name: '500', hex: 'E91E63' },
            { name: '600', hex: 'D81B60' },
            { name: '700', hex: 'C2185B' },
            { name: '800', hex: 'AD1457' },
            { name: '900', hex: '880E4F' },
            { name: 'A100', hex: 'FF80AB' },
            { name: 'A200', hex: 'FF4081' },
            { name: 'A400', hex: 'F50057' },
            { name: 'A700', hex: 'C51162' },
          ],
        },
        {
          name: 'Purple',
          camel: 'purple',
          colors: [
            { name: '50', hex: 'F3E5F5' },
            { name: '100', hex: 'E1BEE7' },
            { name: '200', hex: 'CE93D8' },
            { name: '300', hex: 'BA68C8' },
            { name: '400', hex: 'AB47BC' },
            { name: '500', hex: '9C27B0' },
            { name: '600', hex: '8E24AA' },
            { name: '700', hex: '7B1FA2' },
            { name: '800', hex: '6A1B9A' },
            { name: '900', hex: '4A148C' },
            { name: 'A100', hex: 'EA80FC' },
            { name: 'A200', hex: 'E040FB' },
            { name: 'A400', hex: 'D500F9' },
            { name: 'A700', hex: 'AA00FF' },
          ],
        },
        {
          name: 'Deep Purple',
          camel: 'deepPurple',
          colors: [
            { name: '50', hex: 'EDE7F6' },
            { name: '100', hex: 'D1C4E9' },
            { name: '200', hex: 'B39DDB' },
            { name: '300', hex: '9575CD' },
            { name: '400', hex: '7E57C2' },
            { name: '500', hex: '673AB7' },
            { name: '600', hex: '5E35B1' },
            { name: '700', hex: '512DA8' },
            { name: '800', hex: '4527A0' },
            { name: '900', hex: '311B92' },
            { name: 'A100', hex: 'B388FF' },
            { name: 'A200', hex: '7C4DFF' },
            { name: 'A400', hex: '651FFF' },
            { name: 'A700', hex: '6200EA' },
          ],
        },
        {
          name: 'Indigo',
          camel: 'indigo',
          colors: [
            { name: '50', hex: 'E8EAF6' },
            { name: '100', hex: 'C5CAE9' },
            { name: '200', hex: '9FA8DA' },
            { name: '300', hex: '7986CB' },
            { name: '400', hex: '5C6BC0' },
            { name: '500', hex: '3F51B5' },
            { name: '600', hex: '3949AB' },
            { name: '700', hex: '303F9F' },
            { name: '800', hex: '283593' },
            { name: '900', hex: '1A237E' },
            { name: 'A100', hex: '8C9EFF' },
            { name: 'A200', hex: '536DFE' },
            { name: 'A400', hex: '3D5AFE' },
            { name: 'A700', hex: '304FFE' },
          ],
        },
        {
          name: 'Blue',
          camel: 'blue',
          colors: [
            { name: '50', hex: 'E3F2FD' },
            { name: '100', hex: 'BBDEFB' },
            { name: '200', hex: '90CAF9' },
            { name: '300', hex: '64B5F6' },
            { name: '400', hex: '42A5F5' },
            { name: '500', hex: '2196F3' },
            { name: '600', hex: '1E88E5' },
            { name: '700', hex: '1976D2' },
            { name: '800', hex: '1565C0' },
            { name: '900', hex: '0D47A1' },
            { name: 'A100', hex: '82B1FF' },
            { name: 'A200', hex: '448AFF' },
            { name: 'A400', hex: '2979FF' },
            { name: 'A700', hex: '2962FF' },
          ],
        },
        {
          name: 'Light Blue',
          camel: 'lightBlue',
          colors: [
            { name: '50', hex: 'E1F5FE' },
            { name: '100', hex: 'B3E5FC' },
            { name: '200', hex: '81D4FA' },
            { name: '300', hex: '4FC3F7' },
            { name: '400', hex: '29B6F6' },
            { name: '500', hex: '03A9F4' },
            { name: '600', hex: '039BE5' },
            { name: '700', hex: '0288D1' },
            { name: '800', hex: '0277BD' },
            { name: '900', hex: '01579B' },
            { name: 'A100', hex: '80D8FF' },
            { name: 'A200', hex: '40C4FF' },
            { name: 'A400', hex: '00B0FF' },
            { name: 'A700', hex: '0091EA' },
          ],
        },
        {
          name: 'Cyan',
          camel: 'cyan',
          colors: [
            { name: '50', hex: 'E0F7FA' },
            { name: '100', hex: 'B2EBF2' },
            { name: '200', hex: '80DEEA' },
            { name: '300', hex: '4DD0E1' },
            { name: '400', hex: '26C6DA' },
            { name: '500', hex: '00BCD4' },
            { name: '600', hex: '00ACC1' },
            { name: '700', hex: '0097A7' },
            { name: '800', hex: '00838F' },
            { name: '900', hex: '006064' },
            { name: 'A100', hex: '84FFFF' },
            { name: 'A200', hex: '18FFFF' },
            { name: 'A400', hex: '00E5FF' },
            { name: 'A700', hex: '00B8D4' },
          ],
        },
        {
          name: 'Teal',
          camel: 'teal',
          colors: [
            { name: '50', hex: 'E0F2F1' },
            { name: '100', hex: 'B2DFDB' },
            { name: '200', hex: '80CBC4' },
            { name: '300', hex: '4DB6AC' },
            { name: '400', hex: '26A69A' },
            { name: '500', hex: '009688' },
            { name: '600', hex: '00897B' },
            { name: '700', hex: '00796B' },
            { name: '800', hex: '00695C' },
            { name: '900', hex: '004D40' },
            { name: 'A100', hex: 'A7FFEB' },
            { name: 'A200', hex: '64FFDA' },
            { name: 'A400', hex: '1DE9B6' },
            { name: 'A700', hex: '00BFA5' },
          ],
        },
        {
          name: 'Green',
          camel: 'green',
          colors: [
            { name: '50', hex: 'E8F5E9' },
            { name: '100', hex: 'C8E6C9' },
            { name: '200', hex: 'A5D6A7' },
            { name: '300', hex: '81C784' },
            { name: '400', hex: '66BB6A' },
            { name: '500', hex: '4CAF50' },
            { name: '600', hex: '43A047' },
            { name: '700', hex: '388E3C' },
            { name: '800', hex: '2E7D32' },
            { name: '900', hex: '1B5E20' },
            { name: 'A100', hex: 'B9F6CA' },
            { name: 'A200', hex: '69F0AE' },
            { name: 'A400', hex: '00E676' },
            { name: 'A700', hex: '00C853' },
          ],
        },
        {
          name: 'Light Green',
          camel: 'lightGreen',
          colors: [
            { name: '50', hex: 'F1F8E9' },
            { name: '100', hex: 'DCEDC8' },
            { name: '200', hex: 'C5E1A5' },
            { name: '300', hex: 'AED581' },
            { name: '400', hex: '9CCC65' },
            { name: '500', hex: '8BC34A' },
            { name: '600', hex: '7CB342' },
            { name: '700', hex: '689F38' },
            { name: '800', hex: '558B2F' },
            { name: '900', hex: '33691E' },
            { name: 'A100', hex: 'CCFF90' },
            { name: 'A200', hex: 'B2FF59' },
            { name: 'A400', hex: '76FF03' },
            { name: 'A700', hex: '64DD17' },
          ],
        },
        {
          name: 'Lime',
          camel: 'lime',
          colors: [
            { name: '50', hex: 'F9FBE7' },
            { name: '100', hex: 'F0F4C3' },
            { name: '200', hex: 'E6EE9C' },
            { name: '300', hex: 'DCE775' },
            { name: '400', hex: 'D4E157' },
            { name: '500', hex: 'CDDC39' },
            { name: '600', hex: 'C0CA33' },
            { name: '700', hex: 'AFB42B' },
            { name: '800', hex: '9E9D24' },
            { name: '900', hex: '827717' },
            { name: 'A100', hex: 'F4FF81' },
            { name: 'A200', hex: 'EEFF41' },
            { name: 'A400', hex: 'C6FF00' },
            { name: 'A700', hex: 'AEEA00' },
          ],
        },
        {
          name: 'Yellow',
          camel: 'yellow',
          colors: [
            { name: '50', hex: 'FFFDE7' },
            { name: '100', hex: 'FFF9C4' },
            { name: '200', hex: 'FFF59D' },
            { name: '300', hex: 'FFF176' },
            { name: '400', hex: 'FFEE58' },
            { name: '500', hex: 'FFEB3B' },
            { name: '600', hex: 'FDD835' },
            { name: '700', hex: 'FBC02D' },
            { name: '800', hex: 'F9A825' },
            { name: '900', hex: 'F57F17' },
            { name: 'A100', hex: 'FFFF8D' },
            { name: 'A200', hex: 'FFFF00' },
            { name: 'A400', hex: 'FFEA00' },
            { name: 'A700', hex: 'FFD600' },
          ],
        },
        {
          name: 'Amber',
          camel: 'amber',
          colors: [
            { name: '50', hex: 'FFF8E1' },
            { name: '100', hex: 'FFECB3' },
            { name: '200', hex: 'FFE082' },
            { name: '300', hex: 'FFD54F' },
            { name: '400', hex: 'FFCA28' },
            { name: '500', hex: 'FFC107' },
            { name: '600', hex: 'FFB300' },
            { name: '700', hex: 'FFA000' },
            { name: '800', hex: 'FF8F00' },
            { name: '900', hex: 'FF6F00' },
            { name: 'A100', hex: 'FFE57F' },
            { name: 'A200', hex: 'FFD740' },
            { name: 'A400', hex: 'FFC400' },
            { name: 'A700', hex: 'FFAB00' },
          ],
        },
        {
          name: 'Orange',
          camel: 'orange',
          colors: [
            { name: '50', hex: 'FFF3E0' },
            { name: '100', hex: 'FFE0B2' },
            { name: '200', hex: 'FFCC80' },
            { name: '300', hex: 'FFB74D' },
            { name: '400', hex: 'FFA726' },
            { name: '500', hex: 'FF9800' },
            { name: '600', hex: 'FB8C00' },
            { name: '700', hex: 'F57C00' },
            { name: '800', hex: 'EF6C00' },
            { name: '900', hex: 'E65100' },
            { name: 'A100', hex: 'FFD180' },
            { name: 'A200', hex: 'FFAB40' },
            { name: 'A400', hex: 'FF9100' },
            { name: 'A700', hex: 'FF6D00' },
          ],
        },
        {
          name: 'Deep Orange',
          camel: 'deepOrange',
          colors: [
            { name: '50', hex: 'FBE9E7' },
            { name: '100', hex: 'FFCCBC' },
            { name: '200', hex: 'FFAB91' },
            { name: '300', hex: 'FF8A65' },
            { name: '400', hex: 'FF7043' },
            { name: '500', hex: 'FF5722' },
            { name: '600', hex: 'F4511E' },
            { name: '700', hex: 'E64A19' },
            { name: '800', hex: 'D84315' },
            { name: '900', hex: 'BF360C' },
            { name: 'A100', hex: 'FF9E80' },
            { name: 'A200', hex: 'FF6E40' },
            { name: 'A400', hex: 'FF3D00' },
            { name: 'A700', hex: 'DD2C00' },
          ],
        },
        {
          name: 'Brown',
          camel: 'brown',
          colors: [
            { name: '50', hex: 'EFEBE9' },
            { name: '100', hex: 'D7CCC8' },
            { name: '200', hex: 'BCAAA4' },
            { name: '300', hex: 'A1887F' },
            { name: '400', hex: '8D6E63' },
            { name: '500', hex: '795548' },
            { name: '600', hex: '6D4C41' },
            { name: '700', hex: '5D4037' },
            { name: '800', hex: '4E342E' },
            { name: '900', hex: '3E2723' },
          ],
        },
        {
          name: 'Grey',
          camel: 'grey',
          colors: [
            { name: '50', hex: 'FAFAFA' },
            { name: '100', hex: 'F5F5F5' },
            { name: '200', hex: 'EEEEEE' },
            { name: '300', hex: 'E0E0E0' },
            { name: '400', hex: 'BDBDBD' },
            { name: '500', hex: '9E9E9E' },
            { name: '600', hex: '757575' },
            { name: '700', hex: '616161' },
            { name: '800', hex: '424242' },
            { name: '900', hex: '212121' },
          ],
        },
        {
          name: 'Blue Grey',
          camel: 'blueGrey',
          colors: [
            { name: '50', hex: 'ECEFF1' },
            { name: '100', hex: 'CFD8DC' },
            { name: '200', hex: 'B0BEC5' },
            { name: '300', hex: '90A4AE' },
            { name: '400', hex: '78909C' },
            { name: '500', hex: '607D8B' },
            { name: '600', hex: '546E7A' },
            { name: '700', hex: '455A64' },
            { name: '800', hex: '37474F' },
            { name: '900', hex: '263238' },
          ],
        },
        {
          name: 'Misc',
          camel: '',
          colors: [
            { name: 'white', hex: 'FFFFFF', x: 19, y: 0 },
            { name: 'black', hex: '000000', x: 19, y: 1 },
          ],
        },
      ];
      var hexToRgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
            }
          : null;
      };
      var cToHex = function (c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
      };
      var rgbToHex = function (r, g, b) {
        return '#' + cToHex(r) + cToHex(g) + cToHex(b);
      };
      var h = function (c) {
        if (c == '') {
          return 0;
        }
        var t = parseInt(c);
        return t >= 0 && t <= 255 ? t : 0;
      };
      var getName = function (hex) {
        if (!hex) {
          return '';
        }
        for (var i = 0; i < 19; i++) {
          for (var j = 0; j < swatches[i].colors.length; j++) {
            if (swatches[i].colors[j].hex == hex.replace('#', '')) {
              return swatches[i].camel + swatches[i].colors[j].name;
            }
          }
        }
        return '';
      };
      return {
        restrict: 'E',
        require: 'ngModel',
        link: function ($scope, element, attrs, ngModel) {
          angular.element(element).addClass('materialpicker');
          var selection = [];
          for (var x = 0; x <= 20; x++) {
            selection.push([]);
          }
          var size = 15;
          var state = {
            mousedown: false,
            ignore: false,
            selected: { color: null, x: 0, y: 0 },
          };
          var container = angular.element('<div>');
          container.addClass('materialpicker-colors');
          container.on('mouseout', function () {
            if (attrs.hoverModel) {
              var model = $parse(attrs.hoverModel);
              model.assign($scope, null);
              $scope.$apply();
            }
          });
          container.on('mousedown', function () {
            state.mousedown = true;
          });
          container.on('mouseup', function () {
            state.mousedown = false;
          });
          function mouseup() {
            state.mousedown = false;
            angular.element(window.document).off('mouseup', mouseup);
          }
          container.on('mouseleave', function () {
            angular.element(window.document).on('mouseup', mouseup);
          });
          container.on('mouseenter', function () {
            angular.element(window.document).off('mouseup', mouseup);
          });
          var action = function (color, apply) {
            selection[state.selected.x][state.selected.y].ele.removeClass('selected');
            state.selected.color = color.hex;
            state.selected.x = color.x;
            state.selected.y = color.y;
            var camel = swatches[color.x].camel;
            var format = $parse(attrs.format);
            if (format() === 'hex') {
              ngModel.$setViewValue('#' + color.hex);
            } else {
              var rgb = hexToRgb(color.hex);
              ngModel.$setViewValue({
                hex: '#' + color.hex,
                name: camel + color.name,
                r: rgb.r,
                g: rgb.g,
                b: rgb.b,
              });
            }
            state.ignore = true;
            selection[color.x][color.y].ele.addClass('selected');
          };
          var isHex = function (hex) {
            if (typeof hex == 'undefined') {
              return null;
            }
            return hex.match(/^#([0-9A-F]{6})$/i);
          };
          var selectColor = function (hex) {
            var m = null;
            if ((m = isHex(hex))) {
              selection[state.selected.x][state.selected.y].ele.removeClass('selected');
              outer: for (var i = 0; i < swatches.length; i++) {
                inner: for (var j = 0; j < swatches[i].colors.length; j++) {
                  if (swatches[i].colors[j].hex == m[1]) {
                    selection[i][j].ele.addClass('selected');
                    state.selected.x = i;
                    state.selected.y = j;
                    break outer;
                  }
                }
              }
            }
          };
          for (var i = 0; i < 19; i++) {
            var column = angular.element('<div>');
            column.css({
              display: 'inline-block',
              verticalAlign: 'top',
            });
            for (var j = 0; j < swatches[i].colors.length; j++) {
              var row = angular.element('<div>');
              selection[i][j] = { ele: row };
              swatches[i].colors[j].x = i;
              swatches[i].colors[j].y = j;
              row.css({
                background: '#' + swatches[i].colors[j].hex,
                height: size + 'px',
              });
              row.on(
                'mouseover',
                (function (swatch, color) {
                  return function () {
                    if (attrs.hoverModel) {
                      var model = $parse(attrs.hoverModel);
                      var rgb = hexToRgb(color.hex);
                      model.assign($scope, {
                        hex: '#' + color.hex,
                        name: swatch.camel + color.name,
                        r: rgb.r,
                        g: rgb.g,
                        b: rgb.b,
                      });
                      $scope.$apply();
                    }
                  };
                })(swatches[i], swatches[i].colors[j])
              );
              row.on(
                'click',
                (function (color) {
                  return function () {
                    action(color);
                  };
                })(swatches[i].colors[j])
              );
              row.on(
                'mouseover',
                (function (color) {
                  return function () {
                    if (!state.mousedown || (color.x === state.selected.x && color.y === state.selected.y)) {
                      return;
                    }
                    action(color);
                  };
                })(swatches[i].colors[j])
              );
              column.append(row);
            }
            container.append(column);
          }
          var white = angular.element('<div>');
          white.css({
            background: '#FFF',
            display: 'inline-block',
            width: size * 3 + 'px',
            height: size * 2 + 'px',
            position: 'absolute',
            left: size * 16 + 'px',
            top: size * 10 + 'px',
          });
          selection[19][0] = { ele: white };
          white.on(
            'click',
            (function (color) {
              return function () {
                action(color);
              };
            })(swatches[19].colors[0])
          );
          white.on(
            'mouseover',
            (function (swatch, color) {
              return function () {
                if (attrs.hoverModel) {
                  var model = $parse(attrs.hoverModel);
                  model.assign($scope, {
                    hex: '#' + color.hex,
                    name: swatch.camel + color.name,
                    r: 255,
                    g: 255,
                    b: 255,
                  });
                  $scope.$apply();
                }
                if (!state.mousedown || (color.x === state.selected.x && color.y === state.selected.y)) {
                  return;
                }
                action(color);
              };
            })(swatches[19], swatches[19].colors[0])
          );
          white.addClass('materialpicker-white');
          container.append(white);
          var black = angular.element('<div>');
          black.css({
            background: '#000',
            display: 'inline-block',
            width: size * 3 + 'px',
            height: size * 2 + 'px',
            position: 'absolute',
            left: size * 16 + 'px',
            top: size * 12 + 'px',
          });
          selection[19][1] = { ele: black };
          black.on(
            'click',
            (function (color) {
              return function () {
                action(color);
              };
            })(swatches[19].colors[1])
          );
          black.on(
            'mouseover',
            (function (swatch, color) {
              return function () {
                if (attrs.hoverModel) {
                  var model = $parse(attrs.hoverModel);
                  model.assign($scope, {
                    hex: '#' + color.hex,
                    name: swatch.camel + color.name,
                    r: 0,
                    g: 0,
                    b: 0,
                  });
                  $scope.$apply();
                }
                if (!state.mousedown || (color.x === state.selected.x && color.y === state.selected.y)) {
                  return;
                }
                action(color);
              };
            })(swatches[19], swatches[19].colors[1])
          );
          container.append(black);
          element.append(container);
          var format = $parse(attrs.format);
          var watch = format() === 'hex' ? '$watch' : '$watchCollection';
          $scope[watch](attrs.ngModel, function (value, oldValue) {
            if (typeof value == 'undefined') {
              return;
            }
            if (format() !== 'hex') {
              if (value.hex.match(/^[^#]/)) {
                value.hex = '#' + value.hex;
              }
              var color = hexToRgb(value.hex);
              if (color) {
                if (
                  (value.r == color.r || typeof value.r == 'undefined') &&
                  (value.g == color.g || typeof value.g == 'undefined') &&
                  (value.b == color.b || typeof value.b == 'undefined')
                ) {
                  if (value.r != '') {
                    value.r = color.r;
                  }
                  if (value.g != '') {
                    value.g = color.g;
                  }
                  if (value.b != '') {
                    value.b = color.b;
                  }
                } else {
                  if (value.hex != oldValue.hex) {
                    value.r = color.r;
                    value.g = color.g;
                    value.b = color.b;
                  } else {
                    value.hex = rgbToHex(h(value.r) || 0, h(value.g) || 0, h(value.b) || 0);
                  }
                }
              } else {
                var revertColor = hexToRgb(oldValue.hex);
                if (revertColor) {
                  value.r = h(revertColor.r) || 0;
                  value.g = h(revertColor.g) || 0;
                  value.b = h(revertColor.b) || 0;
                }
              }
            }
            value.name = getName(value.hex || oldValue.hex);
            if (isHex(value.hex || value)) {
              ngModel.$setValidity('required', true);
            } else {
              ngModel.$setValidity('required', false);
            }
            var v = format() === 'hex' ? value : value.hex;
            selectColor(v);
          });
          if (attrs.size) {
            $scope.$watch(attrs.size, function (nSize) {
              for (var i = 0; i < selection.length; i++) {
                for (var j = 0; j < selection[i].length; j++) {
                  selection[i][j].ele.css({
                    width: nSize + 'px',
                    height: nSize + 'px',
                  });
                }
              }
              white.css({
                width: nSize * 3 + 'px',
                height: nSize * 2 + 'px',
                left: nSize * 16 + 'px',
                top: nSize * 10 + 'px',
              });
              black.css({
                width: nSize * 3 + 'px',
                height: nSize * 2 + 'px',
                left: nSize * 16 + 'px',
                top: nSize * 12 + 'px',
              });
            });
          }
        },
      };
    },
  ]);


// REMARK: if later texts should be stored in e.g. in db then move this to a service, e.g. ArnoDashTextsService
// which then would fetch all labels/texts from api to provide then to the frontend-component. This step is especially
// necessary, if the dashboard should be made ready for i18n!
var allTexts = { 
  ARNO_SOCURA: 'https://maltesercloud.sharepoint.com/sites/ARNOHandbuch'
}

// bind all texts definitions to ngjs "ArnoDash"-app module
angular.module('ArnoDash').constant('ARNO_TEXTS', allTexts);

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.personnel.dossier.trainings', [
      'BlurAdmin.pages.personnel.dossier.trainings.main',
      'BlurAdmin.pages.personnel.dossier.trainings.statistics',
      'BlurAdmin.pages.personnel.dossier.trainings.tablepanel',
      'BlurAdmin.pages.personnel.dossier.trainings.treepanel',
      'BlurAdmin.pages.personnel.dossier.trainings.wizard'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var dynamicDossierTitle = function (transition) {
      var member = transition.injector().get('member');
      var isOrg = transition.injector().get('ctx')[0] === 'rootOrg';
      var result = isOrg ? 'Organisationsdossier' : 'Gliederungsdossier';

      if (member && member.fullName) {
        result += ' - ' + member.fullName;
      }

      return result;
    };

    $stateProvider
      .state('arno.personnel.dossier.trainings', {
        url: '/trainings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          order: 4
        },
        viewPermission: 'arno.personnel.dossier.trainings',
        viewPermissionScopes: ['Division']
      })
      .state('arno.personnel.dossier.trainings.main', {
        url: '/manage?:recentTrainingsViewMode:lastSelectedNodeId',
        templateUrl: 'app/pages/personnel/dossier/trainings/trainings.tpl.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierTrainingsController as $trainingsCtrl',
        resolve: {
          // flat trainings array, for tableview
          trainingsTemplateGroupsResults: function (ArnoDashTrainingsService, member, ctx) {
            return ArnoDashTrainingsService.getMemberTrainingsWithTemplateGroups(member.id, ctx);
          },
          trainings: function (trainingsTemplateGroupsResults) {
            return trainingsTemplateGroupsResults.trainings;
          },
          // treedata for treeview
          trainingsTree: function (ArnoDashTrainingsService, trainingsTemplateGroupsResults) {
            return ArnoDashTrainingsService.buildAngularTreeControlNodes(trainingsTemplateGroupsResults.groupsTree, trainingsTemplateGroupsResults.trainings);
          },
          trainingCategories: function (ArnoDashAdminCategoriesService, ctx) {
            var divisionIds = ctx;
            if (!divisionIds || divisionIds === 'rootOrg' || divisionIds[0] === 'rootOrg') {
              divisionIds = null;
            }
            return ArnoDashAdminCategoriesService.findCategories({ usages: ['Training'], divisionIds: divisionIds });
          }
        }
      })
      .state('arno.personnel.dossier.trainings.statistics', {
        url: '/statistics?:templateIds:recentTrainingsViewMode:lastSelectedNodeId',
        templateUrl: 'app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsStatistics.tpl.html',
        title: dynamicDossierTitle,
        controller: 'PersonnelDossierTrainingsStatisticsController as $trainingsStatisticsCtrl',
        resolve: {
          allTrainingsByTrainingTemplates: function (ArnoDashTrainingsService, commonUtils, ctx, member, $stateParams) {
            var lastTrainingTemplateIds =
              $stateParams.templateIds
              || commonUtils.preference.object.get('personnelDossierTrainingsStatisticsRecentTrainingTemplate');

            return ArnoDashTrainingsService.getMemberTrainingsByTrainingTemplate(member.id, ctx, lastTrainingTemplateIds);
          },
          qualificationsHierarchy: function (ctx, ArnoDashQualificationGroupsService, isOwnDossier) {
            return ArnoDashQualificationGroupsService.getQualificationGroups(ctx, isOwnDossier);
          },
          memberQualifications: function (clientApi, ArnoDashQualificationsService, member, ctx) {
            if (member && Object.keys(member).length) {
              return ArnoDashQualificationsService.getMemberQualifications(ctx, member.id);
            }

            return [];
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.supervisors.statistics', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.administration.supervisors.statistics', {
      url: '/statistics',
      templateUrl: 'app/pages/administration/supervisors/statisticsSupervisors/statisticsSupervisors.html',
      title: 'navigation.administration.supervisors.statistics',
      controller: 'StatisticsSupervisorsCtrl as $ctrl',
      resolve: {
        selectedCtx: function(commonUtils) {
          return commonUtils.division.getCtx({
            multiple: false,
            allowOrgSelection: true
          })[0];
        },
        divisionTree: function (commonUtils) {
          return commonUtils.division.treeData();
        },
        divisionNodesData: function (commonUtils, ArnoDashAdminDivisionsService, divisionTree) {
          return commonUtils.division.buildTreeNodes(divisionTree, { fetchMembers: true })
            .then(function(results) {
              if (results && results.nodeResults && results.members) {
                return ArnoDashAdminDivisionsService.fetchMembersOfDivisionRoleToNodeData(
                  'Statistikzuweiser',
                  results.nodeResults, results.members,
                  'statisticsSupervisors'
                );
              }

              return results;
            });
        },
        organizationData: function(ArnoDashAdminOrganizationsService, organizationId, selectedCtx) {
          if (selectedCtx === 'rootOrg') {
            return ArnoDashAdminOrganizationsService.fetchMembersOfOrganizationRole(
              'Statistikzuweiser',
              {
                id: organizationId,
                roleId: null
              },
              'statisticsSupervisors'
            );
          }
        }
      },
      sidebarMeta: {
        order: 400
      },
      viewPermission: 'arno.administration.statisticsassign.manage'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.supervisors.approvals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.administration.supervisors.approvals', {
      url: '/approvals',
      templateUrl:
        'app/pages/administration/supervisors/approvalSupervisors/approvalSupervisors.html',
      title: 'navigation.administration.supervisors.approvals',
      controller: 'ApprovalsSupervisorsCtrl as $ctrl',
      resolve: {
        divisionId: function(commonUtils) {
          return ~~commonUtils.division.getCtx({
            multiple: false,
            allowOrgSelection: false
          })[0];
        },
        divisionTree: function (commonUtils, divisionId) {
          if (divisionId) {
            return commonUtils.division.treeData();
          }

          return [];
        },
        divisionNodesData: function (commonUtils, ArnoDashAdminDivisionsService, divisionTree) {
          return commonUtils.division.buildTreeNodes(divisionTree, { fetchMembers: true })
            .then(function(results) {
              if (results && results.nodeResults && results.members) {
                return ArnoDashAdminDivisionsService.fetchMembersOfDivisionRoleToNodeData(
                  'Freigabezuweiser',
                  results.nodeResults, results.members,
                  'approvalsSupervisors'
                );
              }

              return results;
            });
        },
      },
      sidebarMeta: {
        order: 400
      },
      viewPermission: 'arno.administration.divisions.approvalassign.manage'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.roles')
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.roles.division', {
        url: '/division',
        templateUrl: 'app/pages/administration/roles/roles.html',
        title: 'navigation.administration.roles.division',
        controller: 'RoleCtrl as $ctrl',
        resolve: {
          isOrg: function () {
            return false;
          },
          permissions: function (clientApi) {
            return clientApi.custom('model/DivisionPermission', 'getFeDivisionPermission', {});
          },
          roles: function (clientApi) {
            return clientApi.custom('model/DivisionRole', 'findDivisionRoles', { excludeUnassignable: true });
          },
          includedPermission: function (clientApi) {
            return clientApi.custom('model/DivisionRole', 'getDivisionRolesWithPermissions', {});
          }
        },
        sidebarMeta: {
          title: 'navigation.administration.roles.division',
          order: 800,
        },
        viewPermission: 'arno.administration.roles.manage',
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.roles')
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.roles.organization', {
        url: '/organization',
        templateUrl: 'app/pages/administration/roles/roles.html',
        title: 'navigation.administration.roles.organization',
        controller: 'RoleCtrl as $ctrl',
        resolve: {
          isOrg: function() {
            return true;
          },
          permissions: function (clientApi) {
            return clientApi.custom('model/OrganizationPermission', 'getFeOrganizationPermission', {});
          },
          roles: function (clientApi) {
            return clientApi.custom('model/OrganizationRole', 'findOrganizationRoles', { excludeUnassignableRoles: true });
          },
          includedPermission: function (clientApi) {
            return clientApi.custom('model/OrganizationRole', 'getOrganizationRolesWithPermissions', {});
          }
        },
        sidebarMeta: {
          order: 800,
        },
        viewPermission: 'arno.administration.roles.manage',
      })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel.clearances')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel.approval', {
        url: '/approvals',
        templateUrl: 'app/pages/administration/personnel/clearances/clearances.html',
        title: 'navigation.administration.personnel.approval',
        controller: 'ClearanceCtrl as $ctrl',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.administration.personnel.approval.assign.distributor',
            });
          },
          permitted: function (permissions) {
            return permissions.isPermittedAnywhere('arno.administration.personnel.approval.assign.distributor');
          },
          orgPermitted: function (permissions) {
            return permissions.isPermittedInEvery('arno.administration.personnel.approval.manage', 'Organization');
          },
          clearanceHierarchy: function (clientApi) {
            return clientApi.custom('model/ClearanceGroup', 'getClearanceGroups', {});
          },
          clearances: function (clientApi, orgPermitted, permitted, divisionId) {
            if (orgPermitted || permitted && divisionId && divisionId.length) {
              return clientApi.custom('model/Approval', 'findApprovals', { divId: divisionId });
            }

            // if no division was initially selected, then no data can be fetched from backend, so only show an empty comp, resolve is auto-done by ngjs
            return [];
          },
          unassignedClearances: function (ArnoDashAdminClearancesService) {
            return ArnoDashAdminClearancesService.getUnassignedClearances();
          },
          initiatingMembers: function (clientApi, divisionId, permissions) {
            if (permissions.isPermittedInSome('arno.administration.personnel.approval.assign.distributor', 'Division', divisionId)) {
              return clientApi.custom('model/Approval', 'getInitiatingOrEditingMembers', { divisionId: divisionId, editing: false })
                .catch(function () {
                  return null;
                });
            }
            return null;
          },
          editingMembers: function (clientApi, divisionId, permissions) {
            if (permissions.isPermittedInSome('arno.administration.personnel.approval.assign.distributor', 'Division', divisionId)) {
              return clientApi.custom('model/Approval', 'getInitiatingOrEditingMembers', { divisionId: divisionId, editing: true })
                .catch(function () {
                  return null;
                });
            }
            return null;
          },
          divisionList: function (clientApi) {
            return clientApi.custom('model/Division', 'getPermitted', {
              permissionName: 'arno.administration.personnel.approval.assign.distributor',
            });
          },
        },
        sidebarMeta: {
          order: 800,
        },
      });
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.inspection')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.material.inspection', {
        url: '/inspection',
        templateUrl: 'app/pages/administration/material/inspection/inspection.html',
        title: 'navigation.administration.material.inspection',
        controller: 'InspectionCtrl as self',
        sidebarMeta: {
          order: 901,
        },
        resolve: {
          ctx: function (commonUtils) {
            return parseInt(commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.administration.material.inspection.manage'
            })[0])
          },
        },
        viewPermission: 'arno.administration.material.inspection.manage',
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.material.fileStorage', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.material.fileStorage', {
        url: '/fileStorage',
        templateUrl: 'app/pages/administration/material/fileStorage/fileStorageAdminMaterial.html',
        title: 'navigation.administration.material.fileStorage',
        controller: 'matFileCtrl',
        controllerAs: '$ctrl',
        sidebarMeta: {
          order: 900,
        },
        resolve: {
          folderData: function(clientApi, commonUtils, $rootScope, $translate) {
            return clientApi.custom('model/FileStorageFolder', 'getFoldersForOrg', { storageIdent: 'material' })
              .then(function(result) {
                return commonUtils.fileStorage.buildFolderTree(result, { rootOrg: $translate.instant('modules.administration.material.fileStorage.treeRoot'), rootIcon: 'fa fa-cube' });
              });
          }
        },
        viewPermission: 'arno.administration.material.fileStorage.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.finances.general', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.finances.general', {
        url: '/general',
        templateUrl: 'app/pages/administration/finances/general/general.html',
        title: 'navigation.administration.finances.general',
        controller: 'AdminFinancesGeneralCtrl as self',
        resolve: {
          payableUntilPeriod: function (clientApi, permissions, $rootScope) {
            if (permissions.isPermittedInOrg('arno.administration.finances.quotationsAndInvoices.manage', [$rootScope.ctx.organization.current.id])) {
              return clientApi.custom('model/Organization', 'fetchUpdatePayableUntilPeriod', {})
            }
            return null;
          },
          invoiceExportCtx: function(commonUtils) {
            return commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: false,
              entryPermission: 'arno.administration.finances.quotationsAndInvoices.manage',
            });
          },
          invoiceExportRecipient: function(clientApi, invoiceExportCtx, permissions) {
            if (permissions.isPermittedInEvery('arno.administration.finances.quotationsAndInvoices.manage', 'Division', invoiceExportCtx, true)) {
              return clientApi
                .custom('model/Division', 'getInvoiceExportRecipient', {
                  divisionId: invoiceExportCtx,
                })
                .then(function(res) {
                  if (res) {
                    return res.InvoiceExportRecipientEMail;
                  }
                  return '';
                })
            } else {
              return '';
            }
          },
          invoiceExportSettings: function(clientApi, invoiceExportCtx, permissions) {
            if (permissions.isPermittedInEvery('arno.administration.finances.quotationsAndInvoices.manage', 'Division', invoiceExportCtx, true)) {
              return clientApi
                .custom('model/Organization', 'getInvoiceExportSettings', {
                  divisionId: invoiceExportCtx,
                });
            } else {
              return {};
            }
          }
        },
        sidebarMeta: {
          order: 0,
        },
        viewPermission: 'arno.administration.finances.quotationsAndInvoices.manage',
        viewPermissionScopes: ['Organization', 'Division'],
      });
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events.serviceTypes')
    .config(routeConfig);

    /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('arno.administration.events.serviceTypes', {
          url: '/serviceTypes',
          templateUrl: 'app/pages/administration/events/serviceTypes/serviceTypes.html',
          controller: 'serviceTypesCtrl as $ctrl',
          title: 'navigation.administration.events.serviceTypes',
          resolve: {
            serviceTypes: function (clientApi) {
              return clientApi
                .custom('model/ServiceType', 'findServiceTypes', {})
                .then(function(serviceTypes) {
                  return _.filter(serviceTypes, { Active: true });
                });
            },
          },
          sidebarMeta: {
            order: 3,
          },
          viewPermission: 'arno.administration.events.manage',
          viewPermissionScopes: ['Organization']
        })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.personnel', [
      'BlurAdmin.pages.administration.personnel.qualifications',
      'BlurAdmin.pages.administration.personnel.clearances',
      'BlurAdmin.pages.administration.personnel.activities',
      'BlurAdmin.pages.administration.personnel.activityWindow',
      'BlurAdmin.pages.administration.personnel.trainings',
      'BlurAdmin.pages.administration.personnel.general',
      'BlurAdmin.pages.administration.personnel.fileStorage',
      'BlurAdmin.pages.administration.personnel.withdrawal',
      'BlurAdmin.pages.administration.personnel.blockage'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.personnel', {
        url: '/personnel',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        title: 'navigation.administration.personnel',
        abstract: true,

        sidebarMeta: {
          order: 100,
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.permissions')
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.permissions', {
        url: '/permissions',
        templateUrl: 'app/pages/administration/permissions/permissions.html',
        title: 'navigation.administration.permissions',
        controller: 'PermissionCtrl as $ctrl',
        resolve: {
          divisionId: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.permissions.manage');
          },
          ctxSelected: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.permissions.manage', true) !== null;
          },
          divisionMember: function (clientApi, divisionId, ctxSelected) {
            if (!ctxSelected) {
              return [];
            }
            return clientApi
              .custom('model/Member', 'findByDivisionId', {
                divisionId: divisionId,
                queryWishes: { activeDivisionMember: false },
              })
              .catch(function () {
                return [];
              });
          },
          roles: function (clientApi, commonUtils, ctxSelected, divisionId, permissions, $rootScope) {
            if (ctxSelected) {
              return clientApi
                .custom('model/DivisionRole', 'assignableRoles', { divisionId: divisionId || null })
                .catch(function () {
                  return [];
                })
            }
            if (permissions.isPermittedInEvery('arno.administration.permissions.manage', 'Organization', [$rootScope.ctx.organization.current.id])) {
              // fetch only assignable roles
              return clientApi
                .custom('model/OrganizationRole', 'findOrganizationRoles', { includeUnassignable: false })
                .catch(function() {
                  return [];
                });
            }
            return [];
          },
          includedPermission: function (clientApi, commonUtils, permissions, $rootScope) {
            if (commonUtils.getDivisionFromSingleCtx('arno.administration.permissions.manage')) {
              return clientApi.custom('model/DivisionRole', 'getDivisionRolesWithPermissions', {});
            }
            if (permissions.isPermittedInEvery('arno.administration.permissions.manage', 'Organization', [$rootScope.ctx.organization.current.id])) {
              return clientApi.custom('model/OrganizationRole', 'getOrganizationRolesWithPermissions', { excludeUnassignableRoles: true });
            }
            return [];
          },
          memberRoles: function (clientApi, commonUtils, organizationId, ctxSelected) {
            if (!ctxSelected) {
              return [];
            }
            if (commonUtils.getDivisionFromSingleCtx('arno.administration.permissions.manage')) {
              return clientApi
                .custom('model/Member', 'getMemberRoles', {
                  divisionId: commonUtils.getDivisionFromSingleCtx('arno.administration.permissions.manage'),
                  mode: 'division'
                })
                .catch(function () {
                  return [];
                });
            }
            return clientApi.custom('model/Member', 'getMemberRoles', { mode: 'organization' });
          },
          permissionGroups: function (clientApi, divisionId, permissions, $rootScope) {
            if (divisionId) {
              return clientApi
                .custom('model/PermissionGroup', 'getPermissionGroups', { divisionId: divisionId })
                .catch(function() {
                  return [];
                });
            } else if (permissions.isPermittedInEvery('arno.administration.permissions.manage', 'Organization', [$rootScope.ctx.organization.current.id])) {
              return clientApi
                .custom('model/PermissionGroup', 'getPermissionGroups', {})
                .catch(function() {
                  return [];
                });
            }
            return [];
          },
          divisionList: function (clientApi) {
            return clientApi.custom('model/Division', 'getPermitted', {
              permissionName: 'arno.administration.permissions.manage',
            });
          },
        },
        sidebarMeta: {
          order: 4,
        },
      })
  }
})();


(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.events', [
      'BlurAdmin.pages.administration.events.serviceTypes',
      'BlurAdmin.pages.administration.events.serviceTemplates',
      'BlurAdmin.pages.administration.events.fileStorage',
    ])
    .config(routeConfig);

    /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('arno.administration.events', {
          url: '/events',
          template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          title: 'navigation.administration.events',
          abstract: true,
          sidebarMeta: {
            order: 102,
          },
          viewPermission: 'arno.administration.events.manage',
        })
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.design')
    .config(routeConfig)

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.design', {
        url: '/design',
        templateUrl: 'app/pages/administration/design/design.html',
        title: 'Design',
        controller: 'DesignCtrl as $ctrl',
        sidebarMeta: {
          order: 2,
        },
        viewPermission: 'arno.administration.design.manage',
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration.categories')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.administration.categories', {
        url: '/categories',
        templateUrl: 'app/pages/administration/categories/categories.html',
        title: 'navigation.administration.categories',
        controller: 'CategoryCtrl as $ctrl',
        sidebarMeta: {
          order: 6,
        },
        resolve: {
          ctxSelected: function (commonUtils) {
            return commonUtils.getDivisionFromSingleCtx('arno.administration.categories.manage', true) !== null;
          },
          categories: function (clientApi, commonUtils, ctxSelected) {
            if (!ctxSelected) {
              return [];
            }
            if (commonUtils.getDivisionFromSingleCtx('arno.administration.categories.manage')) {
              return clientApi.custom('model/BaseCategory', 'findOrgCategories', {
                divisionIds: commonUtils.getDivisionFromSingleCtx('arno.administration.categories.manage'),
                excludeOrgCategories: true,
              });
            } else {
              return clientApi.custom('model/BaseCategory', 'findOrgCategories', {});
            }
          }
        },
        viewPermission: 'arno.administration.categories.manage',
        viewPermissionScopes: ['Division', 'Organization'],
      });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.contacts', [
    'BlurAdmin.pages.contacts.contactManagement',
    'BlurAdmin.pages.contacts.businessPartners',
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.contacts', {
      url: '/contacts',
      template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
      title: 'navigation.contacts',
      abstract: true,
      sidebarMeta: {
        order: 6,
        icon: 'fa fa-user-circle-o',
      },
    })
  }
})();


/**
 * @author c.silbermann
 * created on 15.05.2017
 */
(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.statistics', [
      'BlurAdmin.pages.statistics.usage',
      'BlurAdmin.pages.statistics.helperhours'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.statistics', {
        url: '/statistics',
        title: 'navigation.statistics',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          order: 6,
          icon: 'ion-stats-bars'
        }
      })
      .state('arno.statistics.usage', {
        url: '/usage',
        templateUrl: 'app/pages/statistics/usage/usage.html',
        controller: 'usageChartCtrl as $usage',
        title: 'Nutzungsstatistik',
        resolve: {
          selectedCtx: function (commonUtils) {
            return (commonUtils.division.getCtx({
              multiple: false,
              allowOrgSelection: true,
              entryPermission: 'arno.statistics.userUsage'
            }) || [])[0];
          },

          statisticalDataProvider: function (clientApi) {
            return function (mode, rangeStart, rangeEnd) {
              var timeRangeStart = (rangeStart ? moment(rangeStart) : moment().subtract(7, 'days')).format('YYYY-MM-DD');
              var timeRangeEnd = (rangeEnd ? moment(rangeEnd) : moment().subtract(1, 'days')).format('YYYY-MM-DD');
              return clientApi.post('statistic/queryUserUsage', { mode: mode, rangeStart: timeRangeStart, rangeEnd: timeRangeEnd });
            };
          },
          initStatData: function (statisticalDataProvider) {
            return statisticalDataProvider('USAGE_TIME') // default, 1 week ago to today
              .then(function (usageTime) {
                return statisticalDataProvider('USAGE_TIMESCALE', moment().subtract(1, 'day'), moment())
                  .then(function (usageTimescale) {
                    return { usageData: usageTime, usageTimescale: usageTimescale }
                  });
              });
          },
        },
        viewPermission: 'arno.statistics.userUsage',
        viewPermissionScopes: ['Division', 'Organization'],
        sidebarMeta: {
          order: 1
        }
      })
      .state('arno.statistics.helperHours', {
        url: '/helperhours',
        templateUrl: 'app/pages/statistics/helperhours/helperhours.html',
        controller: 'hhChartCtrl as self',
        title: 'navigation.statistics.helperhours',
        resolve: {
          selectedCtx: function (commonUtils) {
            return (commonUtils.division.getCtx({
              multiple: true,
              allowOrgSelection: true,
              entryPermission: 'arno.statistics.helperHours'
            }) || []);
          },
          statisticalDataProvider: function (clientApi, selectedCtx) {
            return function (rangeStart, rangeEnd, activityId, baseCategoryId) {
              return clientApi.custom('model/statistic', 'getHelperHoursStatisticData', {
                divisionIds: selectedCtx,
                options: {
                  rangeStart: rangeStart,
                  rangeEnd: rangeEnd,
                  activityId: activityId,
                  baseCategoryId: baseCategoryId,
                }
              });
            };
          },
          helperHoursStatisticData: function (statisticalDataProvider) {
            return statisticalDataProvider(
              moment().subtract(90, 'day'),
              moment().subtract(1, 'day'),
              null,
              null
            );
          },
          helperTableProvider: function (clientApi, selectedCtx) {
            return function (rangeStart, rangeEnd, activityId, baseCategoryId, queryWishes) {
              return clientApi.custom('model/statistic', 'getHelperHoursTable', {
                divisionIds: selectedCtx,
                options: {
                  rangeStart: rangeStart,
                  rangeEnd: rangeEnd,
                  activityId: activityId,
                  baseCategoryId: baseCategoryId,
                },
                queryWishes: queryWishes
              });
            };
          },
          helperTableData: function (helperTableProvider) {
            return helperTableProvider(
              moment().subtract(90, 'day'),
              moment().subtract(1, 'day'),
              null,
              null,
              {}
            );
          },
        },
        viewPermission: 'arno.statistics.helperHours',
        viewPermissionScopes: ['Division', 'Organization'],
        sidebarMeta: {
          order: 2
        }
      })
  }

})();

(function () {
  'use strict';
  /**
   * The module file is the rootPoint for personnel related functions
   * @class module:App.Personnel
   */
  angular
    .module('BlurAdmin.pages.personnel', [
      'BlurAdmin.pages.personnel.inviteList',
      'BlurAdmin.pages.personnel.inviteAdd',
      'BlurAdmin.pages.personnel.personnelList',
      'BlurAdmin.pages.personnel.groups',
      'BlurAdmin.pages.personnel.dossier',
      'BlurAdmin.pages.personnel.approvals',
      'BlurAdmin.pages.personnel.demandForAction',
      'BlurAdmin.pages.personnel.deletionList',
      'BlurAdmin.pages.personnel.blockList'
    ])
    .filter('reverse', function() {
      return function(items) {
        return items.slice().reverse();
      };
    })
    .config(routeConfig)
    .constant('characteristicMap', {
      DEFAULT: 'Sonst. Funktion (Standard)',
      WARDEN: 'Erw. Schutzbefohlene',
      WITH_CHILDREN: 'Minderjährige',
      WARDEN_WITH_CHILDREN: 'Minderjährige und erw. Schutzbefohlene'
    })
    .constant('causesOfTermination', [
      'Ende des Berufungszeitraums',
      'Übernahme einer anderen Tätigkeit',
      'Generationswechsel',
      'Zeitmangel',
      'Zu hohe Arbeitsbelastung',
      'Differenzen mit anderen Personen',
      'Auf eigenen Wunsch ohne Mitteilung von Gründen',
      'Austritt aus der Gliederung',
      'Sonstige/Unbekannt',
    ]);


  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.personnel', {
        url: '/personnel',
        title: 'navigation.personnel',
        abstract: true,
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        resolve: {
          personnelOrgSelection: function ($rootScope, permissions) {
            return permissions.isPermittedInEvery('arno.personnel.personnelList.view', 'Organization', [$rootScope.ctx.organization.current.id]);
          },
          currentUser: function($rootScope) {
            return $rootScope.ctx && $rootScope.ctx.currentUser ? $rootScope.ctx.currentUser : null;
          },
          constants: function(ARNO_CONSTANTS){
            var constants = {};
            // CONSTS
            constants.MEMBER_STATUS_LABELS = ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_STATUS_LABELS;
            constants.MEMBER_TYPES_LABELS = {};
            ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_TYPES.forEach(function(memberType) {
              constants.MEMBER_TYPES_LABELS[memberType.mapping] = memberType.Name;
            });
            constants.MEMBER_TYPES = ARNO_CONSTANTS.PERSONNEL.DOSSIER.MEMBER_TYPES;

            constants.MEMBER_SALUTATIONS = ARNO_CONSTANTS.GENERAL.SALUTATION;
            constants.MEMBER_TITLES = ARNO_CONSTANTS.GENERAL.MEMBER_TITLES;
            return constants;
          }
        },
        sidebarMeta: {
          order: 2,
          icon: 'ion-android-people'
        },
      })
  }
})();


(function () {
  'use strict';
  /* global marked*/

  angular
    .module('BlurAdmin.pages.legalPages', [
      'BlurAdmin.pages.legalPages.termsOfUse',
      'BlurAdmin.pages.legalPages.privacyStatement',
    ])
    .config(routeConfig);

  /* @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.legal', {
        url: '/legal',
        title: 'Rechtliches',
        abstract: true,
        viewPermission: '',
      })
      .state('arno.legal.termsOfUse', {
        url: '/termsOfUse',
        title: 'Rechtliches',
        templateUrl: 'app/pages/legalPages/termsOfUse/termsOfUse.html',
        controller: 'TermsOfUseCtrl as $ctrl',
        resolve: {
          termsARNO: function (clientApi, $rootScope) {
            if ($rootScope.ctx.organization.current.id === 1) {
              // we are already in ARNO org, no need to display twice
              return null;
            }
            return clientApi.custom('model/Terms', 'getLatestARNO', {})
              .then(function (termsARNO) {
                termsARNO.TextContent = marked(termsARNO.TextContent);
                termsARNO.updatedAt = moment(termsARNO.updatedAt).format('DD.MM.YYYY # HH:mm').replace('#', 'um');
                return termsARNO;
              });
          },
          terms: function (clientApi) {
            return clientApi.custom('model/Terms', 'getLatest', {})
              .then(function (terms) {
                terms.TextContent = marked(terms.TextContent);
                terms.updatedAt = moment(terms.updatedAt).format('DD.MM.YYYY # HH:mm').replace('#', 'um');
                return terms;
              });
          },
        },
        viewPermission: '',
      })
      .state('arno.legal.privacyStatement', {
        url: '/privacyStatement',
        title: 'Rechtliches',
        templateUrl: 'app/pages/legalPages/privacyStatement/privacyStatement.html',
        controller: 'PrivacyStatementCtrl as $ctrl',
        resolve: {
          privacyTerms: function (clientApi) {
            return clientApi.custom('model/PrivacyTerms', 'getLatest', {})
              .then(function (privacy) {
                privacy.TextContent = marked(privacy.TextContent);
                privacy.updatedAt = moment(privacy.updatedAt).format('DD.MM.YYYY # HH:mm').replace('#', 'um');
                privacy.createdAt = moment(privacy.createdAt).format('DD.MM.YYYY # HH:mm').replace('#', 'um');
                return privacy;
              });
          }
        },
        viewPermission: '',
      });
  }
})
();

(function () {
  'use strict';

  angular
    .module('BlurAdmin.pages.events', [
      'BlurAdmin.pages.events.overview',
      'BlurAdmin.pages.events.eventDetail',
      'BlurAdmin.pages.events.serviceDetail',
      'BlurAdmin.pages.events.demandForAction',
    ])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('arno.events', {
        url: '/events',
        title: 'navigation.events',
        abstract: true,
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        sidebarMeta: {
          order: 4,
          icon: 'ion-calendar'
        },
        viewPermission: ['arno.events', 'arno.virtual.item.events.basic.manage', 'arno.virtual.item.events.service.manage'],
      })
      .state('arno.events.overview', {
        url: '/overview',
        title: 'navigation.events.overview',
        templateUrl: 'app/pages/events/overview/overview.html',
        controller: 'OverviewCtrl as $viewSheet',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage',
            });
          },
          availableServiceTypes: function () {
            return [];
          },
          divisionShares: function () {
            return [];
          },
          openServiceAttendeeInterest: function () {
            return [];
          },
          flowStepConfig: function () {
            return [];
          },
        },
        sidebarMeta: {
          order: 1,
        },
        viewPermission: ['arno.events', 'arno.virtual.item.events.basic.manage', 'arno.virtual.item.events.service.manage'],
      })
      .state('arno.events.eventList', {
        url: '/eventlist',
        title: 'navigation.events.eventList',
        templateUrl: 'app/pages/events/overview/eventList.html',
        controller: 'OverviewCtrl as $viewSheet',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.basic.view,arno.virtual.item.events.basic.manage',
            });
          },
          availableServiceTypes: function () {
            return [];
          },
          divisionShares: function () {
            return [];
          },
          openServiceAttendeeInterest: function () {
            return [];
          },
          flowStepConfig: function (clientApi) {
            return clientApi.custom('model/Event', 'fetchFlowStepConfig');
          },
        },
        sidebarMeta: {
          order: 2,
        },
        viewPermission: ['arno.events.basic', 'arno.virtual.item.events.basic.manage'],
      })
      .state('arno.events.eventDetail', {
        url: '/eventDetail/:eventId/:ctx',
        title: 'navigation.events.eventDetail',
        templateUrl: 'app/pages/events/event/event.html',
        params: {
          eventId: null,
          startDate: null,
          ctx: null,
        },
        controller: 'EventDetailCtrl as $ceEvent',
        resolve: {
          flowStepConfig: function (clientApi) {
            return clientApi.custom('model/Event', 'fetchFlowStepConfig');
          },
          preexistingCall: function (clientApi, $rootScope, $stateParams, $state) {
            if ($stateParams.eventId) {
              var options = {
                eventId: $stateParams.eventId,
              };

              return clientApi.custom('model/Event', 'getEventDetails', { options: options })
                .then(function (event) {
                  if (event && event.results && event.results.length) {
                    if (event.results[0].Series && !event.results[0].EventSeriesId) {
                      // is series metadata event
                      // get eventDates of connected series events
                      return clientApi.custom('model/Event', 'findEvents', { eventSeriesId: event.results[0].id })
                        .then(function (seriesEvents) {
                          event.results[0].seriesDates = (seriesEvents || []).map(function (seriesEvent) {
                            return moment(seriesEvent.StartDate).startOf('day').toDate().getTime();
                          });
                          return event;
                        })
                    }
                    return event;
                  }
                  return null;
                })
                .catch(function () {
                  $state.go('arno.events.overview');
                });
            }
          },
          eventCtx: function ($stateParams, commonUtils, preexistingCall) {
            if (preexistingCall && preexistingCall.results && preexistingCall.results.length
                && preexistingCall.results[0] && preexistingCall.results[0].SourceDivisionId) {
              return [preexistingCall.results[0].SourceDivisionId];
            }
            if ($stateParams.ctx && (!Array.isArray($stateParams.ctx) || $stateParams.ctx.length)) {
              return Array.isArray($stateParams.ctx) ? $stateParams.ctx : [$stateParams.ctx];
            }
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.basic.view,arno.virtual.item.events.basic.manage',
            });
          },
          categories: function (clientApi, eventCtx, preexistingCall) {
            if (preexistingCall && preexistingCall.baseCategories) {
              return preexistingCall.baseCategories;
            }
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { divisionIds: eventCtx, usages: ['Event'] });
          },
          preexistingEvent: function (preexistingCall) {
            if (preexistingCall && preexistingCall.results && preexistingCall.results.length) {
              return preexistingCall.results[0];
            }
            return null;
          },
          foldersAndFiles: function (clientApi, eventCtx, $stateParams) {
            if (!$stateParams.eventId || !eventCtx) {
              return null;
            }
            return clientApi
              .custom('model/FileStorageFolder', 'getFoldersForOrg', {
                divisionId: eventCtx,
                storageIdent: 'event',
                itemOpts: { itemId: $stateParams.eventId },
              })
              .then(function (faf) {
                if (!faf || !faf.folders || !faf.folders.length) {
                  return null;
                }
                return faf;
              });
          },
          fileStorage: function (foldersAndFiles, preexistingCall, commonUtils, $translate) {
            if (!foldersAndFiles || !preexistingCall) {
              return null;
            }
            return commonUtils.fileStorage.buildFolderTree(foldersAndFiles.folders, {
              rootOrg: preexistingCall.Subject || $translate.instant('modules.administration.events.fileStorage.event.treeRoot'),
              rootIcon: 'fa ion-calendar', // not a fa icon, but its inline-style is beneficial for us here
              includeFiles: foldersAndFiles.files,
            });
          },
          eventMaterialMeta: function (clientApi) {
            return clientApi.custom('model/Service', 'getServiceMaterialMeta');
          },

          eventMaterialTableConfigs: function (clientApi) {
            return clientApi.custom('model/Service', 'getServiceMaterialTableConfigs');
          },
        },
        viewPermission: ['arno.events.basic', 'arno.virtual.item.events.basic.manage'],
      })
      .state('arno.events.serviceList', {
        url: '/servicelist',
        title: 'navigation.events.serviceList',
        templateUrl: 'app/pages/events/overview/serviceList.html',
        controller: 'OverviewCtrl as $viewSheet',
        resolve: {
          ctx: function (commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.service.view,arno.virtual.item.events.service.manage',
            });
          },
          isPermitted: function (permissions) {
            return function (action) {
              return permissions.isPermittedAnywhere(action, ['Division']);
            };
          },
          availableServiceTypes: function (clientApi) {
            return clientApi.custom('model/ServiceType', 'findServiceTypes');
          },
          eventShareCtx: function (ctx, permissions) {
            return permissions.getPermittedIds(
              'arno.events.basic.manage',
              'Division',
              ctx,
              false
            );
          },
          serviceShareCtx: function (ctx, permissions) {
            return permissions.getPermittedIds(
              'arno.events.service.manage',
              'Division',
              ctx,
              false
            );
          },
          divisionShares: function (clientApi, eventShareCtx, permissions, serviceShareCtx) {
            if (!eventShareCtx.length && !serviceShareCtx.length) {
              return [];
            }
            return Promise
              .all([
                Promise.resolve()
                  .then(function () {
                    if (!eventShareCtx.length) {
                      return [];
                    }
                    return clientApi.custom('model/DivisionEvent', 'getOpenDivisionShares', { divisionId: eventShareCtx });
                  }),
                Promise.resolve()
                  .then(function () {
                    if (!serviceShareCtx.length) {
                      return [];
                    }
                    return clientApi.custom('model/ServiceShare', 'getOpenShares', { divisionId: serviceShareCtx });
                  }),
              ])
              .then(function (result) {
                var combined = _.flatten(result);
                combined.forEach(function (evt) {
                  if (evt.Service) {
                    evt.Event = evt.Service;
                  }
                  if (!evt.Event.StartDate) {
                    evt.Event.EventStartDate;
                  }
                });
                return _.orderBy(combined, ['Subject'], ['asc']);
              });
          },
          openServiceAttendeeInterest: function (permissions, ctx, clientApi) {
            var permittedDivs = permissions.getPermittedIds('arno.events.service.manage', 'Division', ctx);
            if (!permittedDivs.length || !ctx || !ctx.length) {
              return [];
            }
            return clientApi.custom('model/ServiceShiftMember', 'getOpenServiceAttendeeInterest', { divisionId: permittedDivs });
          },
          flowStepConfig: function (clientApi) {
            return clientApi.custom('model/Service', 'fetchFlowStepConfig');
          },
        },
        sidebarMeta: {
          order: 2,
        },
        viewPermission: ['arno.events.service', 'arno.virtual.item.events.service.manage'],
      })
      .state('arno.events.serviceDetail', {
        url: '/serviceDetail/:serviceId/:ctx',
        title: 'navigation.events.serviceDetail',
        templateUrl: 'app/pages/events/service/service.html',
        params: {
          serviceId: null,
          startDate: null,
          ctx: null,
          quotationBaseId: null,
          service: null,
        },
        controller: 'ServiceDetailCtrl as $ceService',
        resolve: {
          flowStepConfig: function (clientApi) {
            return clientApi.custom('model/Service', 'fetchFlowStepConfig');
          },
          preexistingCall: function (clientApi, $stateParams, $state) {
            if ($stateParams.serviceId) {
              return clientApi
                .custom('model/Service', 'getServiceDetails', { serviceId: $stateParams.serviceId })
                .catch(function () {
                  $state.go('arno.events.overview');
                });
            }
            return null;
          },
          quotationBase: function ($stateParams, clientApi, permissions, eventCtx) {
            if (!$stateParams.quotationBaseId || !permissions.isPermittedInEvery('arno.finances.quotations.edit', 'Division', eventCtx)) {
              return null;
            }
            return clientApi.custom('model/Quotation', 'serviceQuotationBase', { quotationId: $stateParams.quotationBaseId });
          },
          eventCtx: function ($stateParams, commonUtils, preexistingCall) {
            if (preexistingCall && preexistingCall.SourceDivisionId) {
              return [preexistingCall.SourceDivisionId];
            }
            if ($stateParams.ctx && (!Array.isArray($stateParams.ctx) || $stateParams.ctx.length)) {
              return Array.isArray($stateParams.ctx) ? $stateParams.ctx : [$stateParams.ctx];
            }
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.service.view,arno.virtual.item.events.service.manage',
            });
          },
          MEMBER_COUNTRY_IDS: function (ArnoDashCataloguesService) {
            return ArnoDashCataloguesService.fetchCatalogue('CatalogueCountry', ['FullName', 'id']);
          },
          EVENT_CONSTANTS: function (ARNO_CONSTANTS) {
            return ARNO_CONSTANTS.EVENT;
          },
          availableServiceTypes: function (clientApi, toastr, preexistingCall, $translate) {
            return clientApi.custom('model/ServiceType', 'findServiceTypes')
              .then(function (results) {
                if (results && results.length) {
                  var available = results.filter(function (serviceType) {
                    return serviceType.Active || (preexistingCall && (preexistingCall.ServiceTypeId === serviceType.id));
                  });
                  if (available.length) {
                    return available;
                  }
                }
                toastr.warning(
                  $translate.instant('modules.events.availableServicesTypesWarningMsg'),
                  $translate.instant('modules.events.availableServicesTypesWarningTitle')
                );
                return [];
              });
          },
          divisionShares: function () {
            return [];
          },
          openServiceAttendeeInterest: function () {
            return [];
          },
          eventCategories: function (clientApi, eventCtx) {
            return clientApi.custom('model/BaseCategory', 'findOrgCategories', { divisionIds: eventCtx, usages: ['Event'] });
          },
          serviceMaterialMeta: function (clientApi) {
            return clientApi.custom('model/Service', 'getServiceMaterialMeta');
          },
          serviceMaterialTableConfigs: function (clientApi) {
            return clientApi.custom('model/Service', 'getServiceMaterialTableConfigs');
          },
          foldersAndFiles: function (clientApi, eventCtx, $stateParams) {
            if (!$stateParams.serviceId || !eventCtx) {
              return null;
            }
            return clientApi
              .custom('model/FileStorageFolder', 'getFoldersForOrg', {
                divisionId: eventCtx,
                storageIdent: 'service',
                itemOpts: { itemId: $stateParams.serviceId },
              })
              .then(function (faf) {
                if (!faf || !faf.folders || !faf.folders.length) {
                  return null;
                }
                return faf;
              });
          },
          fileStorage: function (foldersAndFiles, preexistingCall, commonUtils, $translate) {
            if (!foldersAndFiles || !preexistingCall) {
              return null;
            }
            return commonUtils.fileStorage.buildFolderTree(foldersAndFiles.folders, {
              rootOrg: preexistingCall.Subject || $translate.instant('modules.administration.events.fileStorage.service.treeRoot'),
              rootIcon: 'fa ion-calendar', // not a fa icon, but its inline-style is beneficial for us here
              includeFiles: foldersAndFiles.files,
            });
          },
          divisionBusinessPartners: function (eventCtx, clientApi) {
            return clientApi
              .custom('model/BusinessPartner', 'searchBusinessPartners', {
                divisionId: eventCtx,
                onlyDivision: true,
                isBuyer: true,
                isSeller: false,
              })
          },
          financeProcess: function(clientApi, eventCtx, $stateParams, permissions) {
            var isPerm = permissions.isPermittedInEvery(
              'arno.events.service.manage,arno.virtual.item.events.service.manage',
              'Division',
              eventCtx
            )
            if ($stateParams.serviceId && isPerm) {
              return clientApi
                .custom(
                  'model/FinanceProcess',
                  'resolveProcess',
                  { divisionId: eventCtx, preFetch: { Service: $stateParams.serviceId } }
                )
            }
            return {};
          }
        },
        viewPermission: ['arno.events.service', 'arno.virtual.item.events.service.manage'],
      })
      .state('arno.events.demandForAction', {
        url: '/demandForAction',
        templateUrl: 'app/pages/events/demandForAction/demandForAction.html',
        title: 'navigation.events.demandForAction',
        controller: 'EventDemandForActionCtrl as self',
        resolve: {
          serviceCtx: function(commonUtils) {
            return commonUtils.division.getCtx({
              multiple: true,
              entryPermission: 'arno.events.service.manage',
            });
          },
        },
        sidebarMeta: {
          order: 10,
        },
        viewPermission: 'arno.events.service.manage',
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('BlurAdmin.pages.administration', [
      'BlurAdmin.pages.administration.roles',
      'BlurAdmin.pages.administration.permissions',
      'BlurAdmin.pages.administration.divisions',
      'BlurAdmin.pages.administration.supervisors',
      'BlurAdmin.pages.administration.personnel',
      'BlurAdmin.pages.administration.statistics',
      'BlurAdmin.pages.administration.terms',
      'BlurAdmin.pages.administration.categories',
      'BlurAdmin.pages.administration.welcomepage',
      'BlurAdmin.pages.administration.events',
      'BlurAdmin.pages.administration.design',
      'BlurAdmin.pages.administration.language',
      'BlurAdmin.pages.administration.material',
      'BlurAdmin.pages.administration.finances',
      'BlurAdmin.pages.administration.apikey',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('arno.administration', {
      url: '/administration',
      title: 'navigation.administration',
      abstract: true,
      template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
      sidebarMeta: {
        order: 900,
        icon: 'ion-wrench'
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.arnoDashboard',
    'BlurAdmin.pages.personnel',
    'BlurAdmin.pages.contacts',
    'BlurAdmin.pages.material',
    'BlurAdmin.pages.arnoAdministration',
    'BlurAdmin.pages.administration',
    'BlurAdmin.pages.events',
    'BlurAdmin.pages.statistics',
    'BlurAdmin.pages.orgTerms',
    'BlurAdmin.pages.legalPages',
    'BlurAdmin.pages.finances',
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider, $translateProvider, $provide) {
    $urlRouterProvider.otherwise('/dashboard');
    $stateProvider
      .state('arno', {
        abstract: true,
        templateUrl: 'app/pages/main.html',
        resolve: {
          initData: function (
            $rootScope, $location, permissions, $state, $translate, tmhDynamicLocale,
            APP_DEFAULT_LOCALE, APP_NG_LOCALES_MAPPING,
            commonUtils, clientApi, portalLogoService
          ) {
            var initDataOptions = {};
            var currentSubdomain = commonUtils.getSubdomainFromHost();
            return Promise.resolve()
              .then(function () {
                var chosenOrganization = parseInt(commonUtils.getCookie('targetOrganization'), 10);
                if (chosenOrganization) {
                  initDataOptions.organization = chosenOrganization;
                }

                if (currentSubdomain) {
                  return clientApi.post('organization/getOrgByAuthHost', { authHost: currentSubdomain, suppressBadRequest: true })
                }
                return null;
              })
              .catch(function () {
                return null;
              })
              .then(function (chosenBySubdomain) {
                if (chosenBySubdomain && chosenBySubdomain.data && chosenBySubdomain.data.id
                    && initDataOptions.organization !== parseInt(chosenBySubdomain.data.id, 10)) {
                  initDataOptions.organization = parseInt(chosenBySubdomain.data.id, 10);
                  commonUtils.setTargetOrganizationCookie(initDataOptions.organization, currentSubdomain);
                }
                return clientApi.emit('initData', initDataOptions);
              })
              .then(function (data) {
                if (!data.data || !data.data.organization) {
                  // initData could have failed to fetch a complete dataset
                  // e.g. when there is no account found for an email
                  $rootScope.ctx = { organization: { current: { id: -1 } }, currentUser: { id: -1 } };
                  $state.go('arno.forbidden');
                  return Promise.reject(new Error('Initial user data incomplete. Can\'t proceed. InitData action or user account data unavailable.'));
                }
                permissions.init(data.data.permissionsTree);
                delete data.data.permissions;
                commonUtils.division.divisionTreeData = data.data.divisionTreeData;
                delete data.data.divisionTreeData;
                $rootScope.ctx = data.data;
                localStorage.setItem('lastPath', $location.absUrl());
                localStorage.setItem('lastVisit', new Date().getTime());

                // init color scheme
                if (data.data.organization.current.primaryColor) {
                  commonUtils.setPortalPrimaryColor(data.data.organization.current.primaryColor);
                  $rootScope.portalColor = data.data.organization.current.primaryColor;
                }

                // init portal logo setup
                if (data.data.organization.current.portalLogoSetup) {
                  var portalLogoSetup = JSON.parse(data.data.organization.current.portalLogoSetup);
                  portalLogoService.useSquareInNavigation = portalLogoSetup.useSquareInNavigation;
                  portalLogoService.useExtInNavigation = portalLogoSetup.useExtInNavigation;
                  portalLogoService.showInFooter = portalLogoSetup.showInFooter;
                  portalLogoService.showOrgLabel = portalLogoSetup.showOrgLabel;
                  portalLogoService.useFilter = portalLogoSetup.useFilter;
                  portalLogoService.inverted = commonUtils.getContrastLabelColor($rootScope.portalColor).startsWith('#000');

                  // square logo
                  portalLogoService.getOrgLogo('orglogo_square')
                    .then(function(result) {
                      if (result) {
                        portalLogoService.data = 'data:' + result.filetype + ';base64, ' + result.imagedata;
                      }
                    })
                  // extended logo
                  portalLogoService.getOrgLogo('orglogo_extended')
                    .then(function(result) {
                      if (result) {
                        portalLogoService.dataExt = 'data:' + result.filetype + ';base64, ' + result.imagedata;
                      }
                    });
                }
                return data.data;
              })
              .then(function (ctx) {
                // remove divisionSelector items using the old format from localStorage
                var oldKeyPrefix = 'ctx_division';
                var removeEntries = [];
                for (var i = 0; i < localStorage.length; i++) {
                  if (localStorage.key(i).substring(0,oldKeyPrefix.length) == oldKeyPrefix) {
                    removeEntries.push(localStorage.key(i));
                  }
                }
                for (var j = 0; j < removeEntries.length; j++) {
                  localStorage.removeItem(removeEntries[j]);
                }
                // update localStorage entries for divisionSelector
                return clientApi.custom('model/DivisionSelection', 'findByMemberId', { cMemberId: ctx.currentUser.id })
                .then(function(result) {
                  if(result && result.length) {
                    result.forEach(function(dbDivSelection) {
                      var localDivSelection;
                      try {
                        localDivSelection = JSON.parse(localStorage.getItem(dbDivSelection.SelectionKey));
                      } catch (e) {
                        // hmm k
                      }

                      dbDivSelection.LastUpdated = +new Date(dbDivSelection.LastUpdated);
                      if(!localDivSelection || !localDivSelection.LastUpdated || dbDivSelection.LastUpdated > localDivSelection.LastUpdated) {
                        localStorage.removeItem(dbDivSelection.SelectionKey);
                        var valObj = {
                          SelectionValue: dbDivSelection.SelectionValue,
                          LastUpdated : dbDivSelection.LastUpdated
                        };
                        localStorage.setItem(dbDivSelection.SelectionKey, JSON.stringify(valObj) );
                      }
                    });
                  }
                  return ctx;
                })
              })
              .then(function(ctx) {
                // angular translate setup
                $translateProvider.useSanitizeValueStrategy('escape');

                $translateProvider
                  .fallbackLanguage(APP_DEFAULT_LOCALE)

                $translateProvider.determinePreferredLanguage();
                $translate.use($rootScope.ctx.currentUser.prefLanguage || APP_DEFAULT_LOCALE);

                tmhDynamicLocale.set(APP_NG_LOCALES_MAPPING[$rootScope.ctx.currentUser.prefLanguage || APP_DEFAULT_LOCALE]);

                return clientApi
                  .emit('i18n/getTranslation', { key: 'languages.de' })
                  .then(function(res) {
                    if (res) {
                      $rootScope.availableLanguages = res.availableLangs;
                    }
                  })
                  .then(function() {
                    return ctx;
                  });
              })
              .catch(function (err) {
                localStorage.setItem('lastPath', $location.absUrl());
                localStorage.setItem('lastVisit', new Date().getTime());
                console.error(err);
              }); // $log provider not available in config phase
          },
          translateReady: function($translate) {
            return $translate.onReady();
          },
          constants: function (translateReady, $translate) {
            function createLabelsMapping(list) {
              var labelsMapping = {};

              _.forEach(list, function(entry) {
                // NOTE: null is a technically valid key, used here for ease for label like "Keine ...."
                labelsMapping[entry.mapping] = entry.Name;
              });

              return labelsMapping;
            }

            var generalConstants = {
              SALUTATION: [{
                Name: $translate.instant('models.Member.Salutation.mister'),
                mapping: 'mister'
              }, {
                Name: $translate.instant('models.Member.Salutation.miss'),
                mapping: 'miss'
              }, {
                Name: $translate.instant('models.Member.Salutation.other'),
                mapping: 'other'
              }],

              // REMARK: must be capitalize letter for correct mapping, because backend will capitalize
              GENDER: [{
                Name: $translate.instant('models.Member.Gender.M'),
                mapping: 'M'
              }, {
                Name: $translate.instant('models.Member.Gender.F'),
                mapping: 'F'
              }, {
                Name: $translate.instant('models.Member.Gender.O'),
                mapping: 'O'
              }],

              MEMBER_TITLES: [{
                Name: $translate.instant('models.Member.Title.none'),
                mapping: 'none'
              },{
                Name: $translate.instant('models.Member.Title.DR'),
                mapping: 'DR'
              }, {
                Name: $translate.instant('models.Member.Title.PROF'),
                mapping: 'PROF'
              }, {
                Name: $translate.instant('models.Member.Title.PROFDR'),
                mapping: 'PROFDR'
              }],

              LANGUAGES_LEVEL: [{
                Name: $translate.instant('constants.languageLevel.native'),
                mapping: 'NATIVE'
              }, {
                Name: $translate.instant('constants.languageLevel.businessFluent'),
                mapping: 'BUSINESS_FLUENT'
              }, {
                Name: $translate.instant('constants.languageLevel.good'),
                mapping: 'GOOD'
              }, {
                Name: $translate.instant('constants.languageLevel.basic'),
                mapping: 'BASIC'
              }],

              CONFESSION: [{
                Name: $translate.instant('models.Member.Confession.evangelian'),
                mapping: 'evangelian'
              }, {
                Name: $translate.instant('models.Member.Confession.islamic'),
                mapping: 'islamic'
              }, {
                Name: $translate.instant('models.Member.Confession.jewish'),
                mapping: 'jewish'
              }, {
                Name: $translate.instant('models.Member.Confession.catholic'),
                mapping: 'catholic'
              }, {
                Name: $translate.instant('models.Member.Salutation.other'),
                mapping: null
              }],

              NOTIFICATION_PREFERENCES: [{
                Name: $translate.instant('constants.notificationPreference.email'),
                mapping: 'EMAIL'
              },{
                Name: $translate.instant('constants.notificationPreference.push'),
                mapping: 'PUSH'
              }, {
                Name: $translate.instant('constants.notificationPreference.both'),
                mapping: 'BOTH'
              }],
            }
            generalConstants.SALUTATION_LABELS = createLabelsMapping(generalConstants.SALUTATION);
            generalConstants.MEMBER_TITLE_LABELS = createLabelsMapping(generalConstants.MEMBER_TITLES);


            var administrationModuleConstants = {
              CATEGORIES: {
                // this array is for iterating components, like ui-select, which shows the usage-list e.g. in add/edit of a category
                USAGELIST: [{
                  Name: $translate.instant('constants.administrationModule.categoryUsageList.events'),
                  mapping: 'Event'
                }, {
                  Name: $translate.instant('constants.administrationModule.categoryUsageList.trainings'),
                  mapping: 'Training'
                }]
              },

              CLEARANCES: {
                CLEARANCES_TYPES: [{
                  Name: $translate.instant('constants.administrationModule.clearanceTypes.simple'),
                  mapping: 'SIMPLE'
                }, {
                  Name: $translate.instant('constants.administrationModule.clearanceTypes.complex'),
                  mapping: 'COMPLEX'
                }]
              }
            }
            // for easy mapping in frontend
            administrationModuleConstants.CATEGORIES.USAGELIST_LABELS = createLabelsMapping(administrationModuleConstants.CATEGORIES.USAGELIST);
            administrationModuleConstants.CLEARANCES.CLEARANCES_TYPES_LABELS = createLabelsMapping(administrationModuleConstants.CLEARANCES.CLEARANCES_TYPES);


            var personnelModuleConstants = {
              DOSSIER: {
                // used for dossier base-data page
                MEMBER_TYPES: [{
                  Name: $translate.instant('constants.personalModule.memberTypes.active'),
                  mapping: 'ACTIVE_MEMBER'
                }, {
                  Name: $translate.instant('constants.personalModule.memberTypes.passive'),
                  mapping: 'PASSIVE_MEMBER'
                }, {
                  Name: $translate.instant('constants.personalModule.memberTypes.noneMisc'),
                  mapping: 'NONE_MISC_MEMBER'
                }],

                // used for dossier base-data page
                MEMBER_STATUS: [{
                  Name: $translate.instant('constants.personalModule.memberStatus.voluntary'),
                  mapping: 'VOLUNTARY'
                }, {
                  Name: $translate.instant('constants.personalModule.memberStatus.fulltime'),
                  mapping: 'FULLTIME'
                }, {
                  Name: $translate.instant('constants.personalModule.memberStatus.probationer'),
                  mapping: 'PROBATIONER'
                }],
              }
            }
            // for easy mapping in frontend
            personnelModuleConstants.DOSSIER.MEMBER_TYPES_LABELS = createLabelsMapping(personnelModuleConstants.DOSSIER.MEMBER_TYPES);
            personnelModuleConstants.DOSSIER.MEMBER_STATUS_LABELS = createLabelsMapping(personnelModuleConstants.DOSSIER.MEMBER_STATUS);

            var eventConstants = {
              CATERING_TYPE: [{
                Name: $translate.instant('constants.eventModule.cateringType.notProvided'),
                mapping: 'NOT_PROVIDED'
              }, {
                Name: $translate.instant('constants.eventModule.cateringType.byOrganizer'),
                mapping: 'PROVIDED_BY_ORGANIZER'
              }, {
                Name: $translate.instant('constants.eventModule.cateringType.byDivision'),
                mapping: 'PROVIDED_BY_DIVISION'
              }],
            };
            // for easy mapping in frontend
            eventConstants.CATERING_TYPE = createLabelsMapping(eventConstants.CATERING_TYPE);

            $provide.constant('ARNO_CONSTANTS', {
              GENERAL: generalConstants,
              ADMIN: administrationModuleConstants,
              PERSONNEL: personnelModuleConstants,
              EVENT: eventConstants,
              PRICE_ITEM_TYPE: {
                CUSTOM: 'CUSTOM',
                MATERIAL: 'MATERIAL',
                MATERIAL_TYPE: 'MATERIAL_TYPE',
                SERVICE_POSITION: 'SERVICE_POSITION'
              },
              PRICE_ITEM_TYPE_ICON: {
                ALL: 'fa fa-circle',
                CUSTOM: 'fa fa-pencil-square-o',
                MATERIAL: 'fa fa-cube',
                MATERIAL_TYPE: 'fa fa-cubes',
                SERVICE_POSITION: 'ion-calendar'
              },
              PRICE_UNIT_TYPE: {
                PER_HOUR: 'PER_HOUR',
                PER_DAY: 'PER_DAY',
                PER_COUNT: 'PER_COUNT'
              }
            });

            return null;
          },
          organizationId: function (initData) {
            return initData && initData.organization.current.id || -1;
          }
        },
        controller: function ($rootScope, $scope, $state, portalLogoService) {
          $scope.heartCount = 0;
          $scope.heartReload = function () {
            $scope.heartCount++;
            if ($scope.heartCount > 4) {
              $scope.heartCount = 0;
              $state.reload();
            }
          }
          $scope.portalLogo = portalLogoService;
        }
      })
      .state('arno.forbidden', {
        url: '/forbidden',
        title: 'No access',
        templateUrl: 'app/pages/forbidden.html',
        controller: function ($scope, clientApi, $translate) {
          $scope.$resolve.$state$.title = $translate.instant('modules.forbidden.noAccess');
          $scope.userLogout = function () {
            clientApi.emit('auth/combined/logout');
            window.location.href = '/';
          };
        }
      });
  }
})();

var _paq = window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['disableCookies']);
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function () {
  var u='https://piwik.socura.de/piwik/';
  _paq.push(['setTrackerUrl', u+'matomo.php']);
  _paq.push(['setSiteId', '8']);
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true;
  g.src=u+'matomo.js';
  s.parentNode.insertBefore(g,s);
})();
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/forbidden.html','<div class="forbidden-page"><div class="alert bg-info"><div class="alert-table"><div class="alert-cell"><i class="fa fa-ban"></i><div class="align-center">{{ (\'modules.forbidden.noPermToView\' | translate) }}</div></div></div><div class="alert-logout-hint">{{ (\'modules.forbidden.contactAdmin\' | translate) }}<p class="mt-15"><button type="button" class="btn btn-default" ng-click="userLogout()" translate="modules.forbidden.logout">Logout</button> <button type="button" class="btn btn-primary" ui-sref="arno.dashboard" translate="modules.forbidden.backToStart">Zur Startseite</button></p></div></div></div>');
$templateCache.put('app/pages/main.html','<ba-sidebar></ba-sidebar><div class="al-main"><div class="al-content"><page-top></page-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix hidden-print"><div ng-if="(portalLogo.dataExt || portalLogo.data) && portalLogo.showInFooter" class="al-footer-right"><div class="custom-footer-logo"><img ng-src="{{portalLogo.dataExt || portalLogo.data}}"></div></div><div ng-if="!portalLogo.showInFooter || !portalLogo.data" class="al-footer-right heart-logo" title="Created with love">Created with <i class="ion-heart" ng-click="heartReload()"></i></div><div class="al-footer-main clearfix"><div class="al-copy">ARNO v{{$root.ctx.portalVersion}} <span class="divider"></span> <a href="" ui-sref="arno.legal.termsOfUse" translate="generalTerms.terms"></a> <span class="divider"></span> <a href="" ui-sref="arno.legal.privacyStatement" translate="generalTerms.dataPrivacy"></a></div></div></footer>');
$templateCache.put('app/pages/arnoAdministration/administrators.view.html','<div ba-panel="" ba-panel-title="\'Administratoren\'"><div class="add-row-editable-table"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.addAdministrator()" ng-disabled="$ctrl.isAdding" data-cy="arno-admin-add-admin"><i class="ion-plus"></i><span>Administrator hinzuf\xFCgen</span></button></div><br><div class="table-responsive" ng-if="$ctrl.administrators.length > 0"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.administrators" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="FirstName">Vorname</th><th st-sort="LastName">Nachname</th><th st-sort="Account.EMail">E-Mail</th><th class="align-right-force">Aktionen</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="admin in $ctrl.displayedCollection" class="editable-row" data-cy="arno-admin-row"><td><span editable-text="admin.FirstName" e-name="FirstName" e-placeholder="Vorname" e-form="rowform" onbeforesave="$ctrl.checkFirstName($data)" e-required="" data-cy="arno-admin-add-admin-firstname">{{ admin.FirstName }}</span></td><td><span editable-text="admin.LastName" e-name="LastName" e-placeholder="Nachname" e-form="rowform" onbeforesave="$ctrl.checkLastName($data)" e-required="" data-cy="arno-admin-add-admin-lastname">{{ admin.LastName }}</span></td><td><span ng-if="admin.id" data-cy="arno-admin-email-col">{{ admin.Account.EMail }}</span> <span ng-if="!admin.id" editable-email="admin.Account.EMail" e-form="rowform" e-name="EMail" e-placeholder="E-Mail" onbeforesave="$ctrl.checkMail($data)" e-required="" data-cy="arno-admin-add-admin-email">{{ admin.Account.EMail }}</span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform" ng-show="rowform.$visible" oncancel="$ctrl.onCancel(admin, $index)" onbeforesave="$ctrl.saveAdministrator(admin, $data)" class="form-buttons form-inline" shown="$ctrl.inserted === admin"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary btn-with-icon btn-xs" data-cy="arno-admin-add-admin-save"><i class="ion-checkmark"></i><span class="hidden-xs">Speichern</span></button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default btn-with-icon btn-xs"><i class="glyphicon glyphicon-remove"></i><span class="hidden-xs">Abbrechen</span></button></form><div class="buttons" ng-if="!rowform.$visible && !$ctrl.isAdding"><button class="btn btn-default btn-with-icon btn-xs" ng-click="rowform.$show()"><i class="ion-edit"></i><span class="hidden-xs">Bearbeiten</span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.removeAdministrator(admin)" ng-if="$ctrl.administrators.length > 1" data-cy="arno-admin-delete"><i class="ion-ios-trash"></i><span class="hidden-xs">L\xF6schen</span></button></div></td></tr><tr ng-if="$ctrl.displayedCollection && $ctrl.displayedCollection.length === 0"><td class="text-center" colspan="4"><i>Keine Administratoren verzeichnet.</i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/arnoAdministration/organization.edit.html','<div ba-panel="" ba-panel-title="\'navigation.arnoAdministration.edit\'"><form name="$ctrl.form" ng-submit="($ctrl.administrators.length || $ctrl.isDemo) && $ctrl.save()" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group"><label for="nameInput" class="required-label">Name der Organisation</label> <input type="text" ng-model="$ctrl.organization.Name" name="OrganizationName" class="form-control" id="nameInput" placeholder="Name" required="" data-cy="arno-admin-organization-edit-name"></div></div><div class="col-sm-6"><div class="form-group"><label for="contractnrInput">Vertragsnummer</label> <input type="text" ng-model="$ctrl.organization.ContractNr" name="ContractNr" class="form-control" id="contractnrInput" placeholder="Vertragsnummer"></div></div></div><div class="row" ng-if="$ctrl.isDemo"><div class="col-sm-12"><h3 class="with-line" translate="modules.arnoAdministration.edit.demoinfo"></h3></div><div class="col-sm-12"><ng-form name="$ctrl.demoForm"><div class="form-group"><label for="DemoEMail" translate="modules.arnoAdministration.edit.demoEmail"></label><arno-ba-help-tooltip text="{{(\'modules.arnoAdministration.edit.demoEmailTolltipText\' | translate )}}"></arno-ba-help-tooltip><input type="email" class="form-control" name="DemoEMail" ng-model="$ctrl.organization.DemoEMail"> <label ng-if="$ctrl.demoForm.DemoEMail.$error.email" role="alert" class="control-label has-error validationMessage"><span translate="modules.arnoAdministration.edit.invalidEmail"></span></label></div></ng-form></div><div class="col-sm-12 mt-10" ng-if="$ctrl.isDemo"><h5 translate="modules.arnoAdministration.edit.addDemoAccounts"></h5><div class="row"><div class="col-sm-12" ng-repeat="accountType in $ctrl.demoAccountTypes"><div class="qualification-form-validity-input"><input type="number" min="0" step="1" class="form-control" ng-model="accountType.amount"> <label>{{ accountType.label }}</label></div></div></div></div><div class="col-sm-12 mt-10" ng-if="$ctrl.organization.id"><h5 translate="modules.arnoAdministration.edit.existingDemoAccounts"></h5><table st-table="$ctrl.tableDemoAccounts" st-safe-src="$ctrl.demoAccounts" class="table table-condensed table-hover"><thead><tr><th translate="generalTerms.firstName"></th><th translate="generalTerms.lastName"></th><th translate="generalTerms.email"></th><th translate="generalTerms.password"></th><th translate="generalTerms.organizationRole" translate-values="{ PLURAL: true }"></th><th translate="generalTerms.divisionRole" translate-values="{ PLURAL: true }"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Members.FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Members.LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="account in $ctrl.tableDemoAccounts"><td>{{ account.Members[0].FirstName }}</td><td>{{ account.Members[0].LastName }}</td><td>{{ account.EMail }}</td><td>{{ account.DemoPassword}}</td><td><span class="arno-tag tag label label-tag label-warning" ng-repeat="orgRole in account.Members[0].OrganizationRoles">{{ orgRole.Name }}</span></td><td><span class="arno-tag tag label label-tag label-warning" ng-repeat="divRole in account.Members[0].DivisionRoles">{{ divRole.Name }}</span></td></tr><tr ng-if="$ctrl.tableDemoAccounts && $ctrl.tableDemoAccounts.length === 0"><td class="text-center" colspan="3"><i translate="modules.arnoAdministration.edit.noDemoAccount"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div class="row" ng-if="!$ctrl.isDemo"><div class="col-md-12"><h3 class="with-line" translate="modules.arnoAdministration.edit.invoiceExportTitle"></h3><ba-switcher switcher-style="primary" switcher-value="$ctrl.organization.InvoiceExportEnabled" switcher-hints="$ctrl.switcherHints"></ba-switcher></div><div class="col-sm-8" ng-if="$ctrl.organization.InvoiceExportEnabled"><div class="alert bg-warning"><h4 translate="modules.arnoAdministration.edit.invoiceExportHintTitle"></h4><p translate="modules.arnoAdministration.edit.invoiceExportHint"></p></div></div><div class="col-sm-12" ng-if="$ctrl.organization.InvoiceExportEnabled"><ng-form name="$ctrl.addSuffixForm"><div class="form-group" ng-class="{\'has-error\': $ctrl.addSuffixForm.$error.alreadyExists}"><label translate="modules.arnoAdministration.edit.addDomain"></label><div class="row"><div class="col-sm-3"><div class="form-group"><input type="text" class="form-control" placeholder="{{ \'modules.arnoAdministration.edit.addDomainPlaceholder\' | translate }}" name="Domain" ng-model="$ctrl.newDomain" ui-validate="{ alreadyExists: \'$ctrl.existingInvoiceExportDomains.indexOf($modelValue) === -1\' }" required=""></div></div><div class="col-sm-3 no-padding-sm-left"><button type="button" class="btn btn-success btn-with-icon" ng-disabled="$ctrl.addSuffixForm.$invalid || !$ctrl.newDomain" ng-click="$ctrl.addInvoiceExportDomain()"><i class="ion-plus"></i><span translate="generalTerms.add"></span></button></div></div><div class="help-block error-block basic-block" ng-show="$ctrl.addSuffixForm.$error.alreadyExists" translate="modules.arnoAdministration.edit.domainAlreadyExists"></div></div></ng-form><div class="table-responsive" ng-show="$ctrl.existingInvoiceExportDomains.length > 0 && !$ctrl.isDemo"><table st-table="$ctrl.displayedDomainCollection" st-safe-src="$ctrl.existingInvoiceExportDomains" class="table table-condensed table-hover"><thead><tr><th translate="modules.arnoAdministration.edit.domain"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="domain in $ctrl.displayedDomainCollection"><td>{{ ::domain }}</td><td class="arno-table-button-cell"><button type="button" class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$ctrl.removeInvoiceExportDomain(domain)"><i class="ion-ios-trash"></i><span translate="generalTerms.remove"></span></button></td></tr><tr ng-if="$ctrl.displayedDomainCollection && $ctrl.displayedDomainCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.arnoAdministration.edit.noDomains"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div><div class="row" ng-if="!$ctrl.isDemo" ng-class="{ \'has-error\': $ctrl.form.$submitted && !$ctrl.administrators.length }"><div class="col-sm-12"><h3 class="with-line">Administratoren</h3><ng-form name="$ctrl.addForm"><div class="form-group" ng-class="{\'has-error\': $ctrl.addForm.$error.alreadyExists}"><label>Administrator erstellen</label><div class="row"><div class="col-sm-3"><div class="form-group"><input type="text" class="form-control" placeholder="Vorname" name="FirstName" ng-model="$ctrl.selectedMember.FirstName" required="" data-cy="arno-admin-organization-edit-firstname"></div></div><div class="col-sm-3 no-padding-sm-left"><div class="form-group"><input type="text" class="form-control" placeholder="Nachname" name="LastName" ng-model="$ctrl.selectedMember.LastName" required="" data-cy="arno-admin-organization-edit-lastname"></div></div><div class="col-sm-4 no-padding-sm-left"><div class="form-group"><input type="email" class="form-control" placeholder="E-Mail" name="EMail" ui-validate="{ alreadyExists: \'$ctrl.isInAdministratorsList($modelValue)\' }" ng-model="$ctrl.selectedMember.Account.EMail" required="" data-cy="arno-admin-organization-edit-email"> <label ng-if="$ctrl.addForm.EMail.$error.email" role="alert" class="control-label has-error validationMessage"><span>Die angegebene Email ist ung\xFCltig!</span></label></div></div><div class="col-sm-2 no-padding-sm-left"><button type="button" class="btn btn-success btn-with-icon" ng-disabled="$ctrl.addForm.$invalid" ng-click="$ctrl.addAdministrator()" data-cy="arno-admin-organization-edit-add-admin"><i class="ion-plus"></i><span>Hinzuf\xFCgen</span></button></div></div><div class="help-block error-block basic-block" ng-show="$ctrl.addForm.$error.alreadyExists">Dieses Mitglied ist bereits Organisationsadministrator.</div></div></ng-form></div><div class="col-sm-12" ng-show="!$ctrl.form.$submitted && !$ctrl.administrators.length"><span>Diese Organisation enth\xE4lt keine Administratoren.</span></div><div class="col-sm-12 help-block error-block basic-block" ng-show="$ctrl.form.$submitted && !$ctrl.administrators.length"><span>Bitte w\xE4hle mindestens einen Administrator aus!</span></div></div><div class="table-responsive" ng-show="$ctrl.administrators.length > 0 && !$ctrl.isDemo"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.administrators" class="table table-condensed table-hover"><thead><tr><th>Vorname</th><th>Name</th><th>E-Mail</th><th>Aktion</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr style="cursor: default" class="arno-pointing-pointer" ng-repeat="member in $ctrl.displayedCollection"><td>{{ ::member.FirstName }}</td><td>{{ ::member.LastName }}</td><td>{{ ::member.Account.EMail }}</td><td class="arno-table-button-cell"><button type="button" class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$ctrl.removeAdministrator(member)"><i class="ion-ios-trash"></i><span>Entfernen</span></button></td></tr><tr ng-if="$ctrl.displayedCollection && $ctrl.displayedCollection.length === 0"><td class="text-center" colspan="3"><i>Keine Administratoren verzeichnet.</i></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div><br><div class="row"><div class="col-sm-12"><h3 class="with-line">Authentifizierung</h3><div class="form-group"><div style="padding-top: 2px; padding-right: 8px;"><div class="col-md-3 no-padding-right no-padding-left" style="line-height: 32px"><div>Offline-Account</div></div><div class="col-md-9 no-padding-left"><ba-switcher switcher-style="primary" switcher-disabled="$ctrl.isDemo" switcher-value="$ctrl.organization.Offline" switcher-hints="$ctrl.switcherHints"></ba-switcher></div></div><div style="padding-top: 2px; padding-right: 8px;"><div class="col-md-3 no-padding-right no-padding-left" style="line-height: 32px"><div>ARNO-Account</div></div><div class="col-md-9 no-padding-left"><ba-switcher switcher-style="primary" switcher-disabled="$ctrl.isDemo" switcher-value="$ctrl.organization.ArnoAuth" switcher-hints="$ctrl.switcherHints"></ba-switcher></div></div><div style="padding-top: 2px; padding-right: 8px;"><div class="col-md-3 no-padding-right no-padding-left" style="line-height: 32px"><div>Organisations-Account</div></div><div class="col-md-9 no-padding-left"><ba-switcher switcher-style="primary" switcher-disabled="$ctrl.isDemo" switcher-value="$ctrl.organization.AzureAuth" switcher-hints="$ctrl.switcherHints"></ba-switcher></div></div><div class="input-group mt-20 mb-20"><label for="flowSelect">Prim\xE4rer Loginflow<arno-ba-help-tooltip text="Hier kannst du angeben welche Art der Authentifizierung w\xE4hrend des Logins in den Vordergrund r\xFCckt."></arno-ba-help-tooltip></label><ui-select ng-model="$ctrl.primaryLoginFlow" class="btn-group bootstrap-select form-control" name="flowSelect" on-select="$ctrl.setNewFlow($item)" id="flowSelect" search-enabled="false" spinner-enabled="false"><ui-select-match placeholder="Prim\xE4ren Loginflow w\xE4hlen">{{ $ctrl.primaryLoginFlow.title }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="option.value !== \'DEFAULT\' && !$ctrl.organization.TenantId" repeat="option in $ctrl.flowOptions"><span tooltip-enable="option.value !== \'DEFAULT\' && !$ctrl.organization.TenantId" uib-tooltip="Ein Azure Tenant muss eingerichtet sein." tooltip-placement="left" tooltip-append-to-body="true">{{ option.title }}</span></ui-select-choices></ui-select></div><div class="col-sm-12 row" ng-show="$ctrl.organization.AzureAuth"><div class="alert bg-info"><h4 translate="modules.administration.authentification.azureAuthInfoTitle"></h4><ol><li translate="modules.administration.authentification.azureAuthStep1"></li><li translate="modules.administration.authentification.azureAuthStep2"></li><li translate="modules.administration.authentification.azureAuthStep3"></li><li translate="modules.administration.authentification.azureAuthStep4"></li></ol></div><div class="form-group clearfix" ng-class="{\'has-error\': !$ctrl.form.TenantId.$valid}"><label for="TenantId" class="control-label">TenantId</label><input type="text" class="form-control" name="TenantId" placeholder="TenantId" ng-required="true" ng-pattern="\'([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}){1}\'" ng-model="$ctrl.organization.TenantId"> <label ng-messages="($ctrl.form.TenantId.$touched || $ctrl.form.$submitted) && $ctrl.form.TenantId.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required">Die TenantId muss vorhanden sein</span> <span ng-message="pattern">Die eingegebene TenantId ist im falschen Format!</span></label></div></div></div></div></div><div class="form-group"><label for="Subdomain" class="control-label">Subdomain<arno-ba-help-tooltip text="Hier kannst du angeben unter welcher Subdomain die Organisation erreichbar sein soll: <subdomain>.arno.cloud"></arno-ba-help-tooltip></label> <input type="text" class="form-control" name="Subdomain" id="Subdomain" placeholder="Subdomain" ng-required="!!$ctrl.organization.AzureAuth" ng-model="$ctrl.organization.AuthHost"></div><br><br><div class="row btns-row pull-right"><div class="col-sm-12"><button type="button" class="btn btn-default" ui-sref="^.overview">Abbrechen</button> <button type="submit" class="btn btn-primary" ng-click="$ctrl.noStateChange = false" ng-disabled="$ctrl.form.OrganizationName.$invalid || (!$ctrl.administrators.length && !$ctrl.isDemo) || $ctrl.demoForm.DemoEMail.$error.email || $ctrl.organization.AzureAuth && !$ctrl.form.TenantId.$valid" data-cy="arno-admin-organization-edit-save">Speichern und Zur\xFCck</button> <button type="submit" ng-click="$ctrl.noStateChange = true" class="btn btn-primary" ng-disabled="$ctrl.form.OrganizationName.$invalid || (!$ctrl.administrators.length && !$ctrl.isDemo) || $ctrl.demoForm.DemoEMail.$error.email || $ctrl.organization.AzureAuth && !$ctrl.form.TenantId.$valid">Speichern</button></div></div></form></div>');
$templateCache.put('app/pages/arnoAdministration/organizations.view.html','<div ba-panel="" ba-panel-title="\'Organisationen\'"><h5 ng-if="$ctrl.organizations.length < 1">Es existieren noch keine Organisationen. Klicke auf den Button um eine neue Organisation zu erstellen.</h5><br><button type="button" class="btn btn-primary btn-with-icon" ui-sref="arno.arnoAdministration.editOrganization" data-cy="arno-admin-add-organization"><i class="ion-plus"></i><span>Organisation hinzuf\xFCgen</span></button><br><br><arno-admin-org-list organizations="$ctrl.organizations" is-demo="false"></arno-admin-org-list></div><div ba-panel="" ba-panel-title="\'Demo-Organisationen\'"><h5 ng-if="$ctrl.organizations.length < 1">Es existieren noch keine Demo-Organisationen. Klicke auf den Button um eine neue Demo-Organisation zu erstellen.</h5><br><button type="button" class="btn btn-primary btn-with-icon" ui-sref="arno.arnoAdministration.editOrganization({ isDemoOrg: true })"><i class="ion-plus"></i><span>Demo-Organisation hinzuf\xFCgen</span></button><br><br><arno-admin-org-list organizations="$ctrl.demoOrganizations" is-demo="true"></arno-admin-org-list></div><div ba-panel="" ba-panel-title="\'Aktionen\'"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.runCalc()"><i class="fa fa-refresh"></i><span>Qualifikationen und T\xE4tigkeiten berechnen</span></button></div>');
$templateCache.put('app/pages/arnoDashboard/arnoDashboard.html','<div class="arno-dashboard"><div class="row"><div class="col-xs-12" ng-if="$ctrl.openDivisionInvites.length > 0"><div class="alert bg-info ng-scope" ng-repeat="item in $ctrl.openDivisionInvites"><h4 class="ng-scope">Einladung in Gliederung - {{ ::item.Division.Name }}</h4><h5 class="ng-binding">Hallo {{ $ctrl.firstName }},<br><br>du wurdest am {{ ::item.InviteDate | date:\'dd.MM.yyyy\' }} in die Gliederung {{ ::item.Division.Name }} eingeladen.<br><br>Falls du damit einverstanden bist, kannst du \xFCber die folgende Schaltfl\xE4che deine Zugeh\xF6rigkeit best\xE4tigen.</h5><div class="mb-12"><button class="btn btn-success btn-with-icon" ng-click="$ctrl.acceptInvite(item.id, item.DivisionId)" title="Annehmen"><i class="ion-plus"></i> <span class="ng-scope" translate="modules.arnoDashboard.board.acception">Einladung annehmen</span></button> <button class="btn btn-danger btn-with-icon" ng-click="$ctrl.declineInvite(item.DivisionId)" title="Einladung ablehnen"><i class="ion-ios-trash"></i> <span class="ng-scope" translate="modules.arnoDashboard.board.decline">Einladung ablehnen</span></button></div><span>Hinweis: Solltest du diese Einladung nicht bis zum {{ ::item.expirationDateFormatted }} akzeptieren, wird sie automatisch gel\xF6scht.</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4"><div class="alert bg-warning" ng-if="$ctrl.demandForActionCount"><h4 translate="modules.arnoDashboard.board.pendingPrivatPolicy" translate-values="{demandForAction: $ctrl.demandForActionCount}"></h4><strong>{{ \'modules.arnoDashboard.board.privacyPendingStates1\' | translate:{ demandForAction: $ctrl.demandForActionCount } }} <a href="" ui-sref="arno.personnel.demandForAction" translate="modules.arnoDashboard.board.actionRequiredOverview"></a> {{ \'modules.arnoDashboard.board.privacyPendingStates2\' | translate:{ demandForAction: $ctrl.demandForActionCount } }}</strong></div><div class="alert bg-info pb-0" ng-if="$ctrl.availableHHDivs.length && $ctrl.openHelperHours && $ctrl.openHelperHours.rows && $ctrl.openHelperHours.rows.length"><div class="mb-8"><h4>{{ \'modules.arnoDashboard.board.helperHours\' | translate }}</h4><strong><span translate="modules.arnoDashboard.board.openRequests" translate-values="{ count: $ctrl.totalRows }" class="ng-scope">{{ \'modules.arnoDashboard.board.openRequests\' | translate : { count: $ctrl.totalRows } }}</span> <a href="" ui-sref="arno.personnel.demandForAction" target="_blank">{{ \'modules.arnoDashboard.board.actionRequiredOverview\' | translate }}</a> <span class="ng-binding">{{ \'modules.dashboard.helperHours.infoboxPart3\' | translate }}</span></strong></div><div class="row" ng-repeat="item in $ctrl.displayedCollectionHelperHours"><div class="col-xs-12"><div class="panel panel-default panel-sm"><div class="panel-body p-10"><div class="row"><div title="{{item.Title}}" class="col-xs-12 col-sm-6"><strong>{{item.Title}}</strong> <small style="display: block;"><i class="fa fa-user mr-4" aria-hidden="true"></i><b>{{item.Member.fullName}}</b></small> <small style="display: block;"><i class="fa fa-hourglass-o mr-4" aria-hidden="true"></i> <span ng-if="(item.ActivityMinutes - (item.ActivityMinutes % 60)) / 60">{{(item.ActivityMinutes - (item.ActivityMinutes % 60)) / 60}} {{ \'modules.dashboard.helperHours.hours\' | translate }}</span> <span ng-if="item.ActivityMinutes % 60">{{item.ActivityMinutes % 60}} {{ \'modules.dashboard.helperHours.minutes\' | translate }}</span></small> <small style="display: block;"><i class="fa fa-calendar-o mr-4" aria-hidden="true"></i>{{item.ActivityStartDate | date:\'dd.MM.yyyy\' }}</small></div><div class="col-xs-12 col-sm-6 text-right" style="display: flex;flex-wrap: wrap;align-items: flex-end;justify-content: end;gap: 12px;"><button class="btn btn-xs btn-success" ng-click="$ctrl.approveEntries(item, true)"><i class="fa fa-check"></i> {{ \'modules.dashboard.helperHours.approve\' | translate }}</button> <button class="btn btn-xs btn-danger" ng-click="$ctrl.approveEntries(item, false)"><i class="fa fa-times"></i> {{ \'modules.dashboard.helperHours.decline\' | translate }}</button></div></div></div></div></div></div></div><div class="w-100 m-1" ng-if="$ctrl.openQuotations || $ctrl.openInvoices"><div ba-panel="" ba-panel-title="\'modules.dashboard.quotInv.quotPanelTitle\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" class="table-responsive"><div class="alert bg-warning"><h4 translate="modules.dashboard.quotInv.openQuotTitle" translate-values="{ openQuotCount: $ctrl.openQuotations, openInvoiceCount: $ctrl.openInvoices }"></h4><strong><span translate="modules.dashboard.quotInv.openQuotPart1" translate-values="{ openQuotCount: $ctrl.openQuotations, openInvoiceCount: $ctrl.openInvoices }"></span> <a href="" ui-sref="arno.finances.demandForAction"><span translate="modules.dashboard.quotInv.openQuotPart2"></span></a> <span translate="modules.dashboard.quotInv.openQuotPart3" translate-values="{ openQuotCount: $ctrl.openQuotations, openInvoiceCount: $ctrl.openInvoices }"></span></strong></div></div></div><div class="w-100 m-1" ng-if="$ctrl.viewPermissions.serviceManage"><div class="alert bg-warning pb-0" ng-if="$ctrl.openServiceAttendeeInterest.length > 0"><div class="mb-8"><h4>{{ \'modules.dashboard.interests.title\' | translate }}</h4><strong><span translate="modules.dashboard.interests.message" translate-values="{ count: $ctrl.openServiceAttendeeInterest.length }" class="ng-scope">{{ \'modules.dashboard.interests.message\' | translate : { count: $ctrl.openServiceAttendeeInterest.length } }}</span></strong></div><div class="row" ng-repeat="item in $ctrl.openServiceAttendeeInterest"><div class="col-xs-12"><div class="panel panel-default panel-sm"><div class="panel-body p-10"><div class="row"><div title="{{item.Subject}}" class="col-xs-12 col-sm-6"><strong>{{item.Subject}}</strong> <small style="display: block;">{{item.SourceDivision.Name}}</small> <small style="display: block;"><i class="fa fa-calendar-o mr-4" aria-hidden="true"></i>{{item.StartDate | date:\'dd.MM.yyyy\' }}</small></div><div class="col-xs-12 col-sm-6 text-right" style="display: flex;flex-wrap: wrap;align-items: flex-end;justify-content: end;gap: 12px;"><button class="btn btn-info btn-with-icon btn-xs" ng-click="$ctrl.openServiceDetails(item)" title="Details aufrufen"><i class="glyphicon glyphicon-calendar"></i><span class="hidden-xs">{{ \'modules.dashboard.interests.button\' | translate }}</span></button></div></div></div></div></div></div></div></div><div class="w-100 m-1" ng-if="!$ctrl.openDivisionInvites.length > 0 && !$ctrl.demandForActionCount && !($ctrl.availableHHDivs.length && $ctrl.openHelperHours && $ctrl.openHelperHours.rows && $ctrl.openHelperHours.rows.length) && !($ctrl.openQuotations || $ctrl.openInvoices) && !$ctrl.openServiceAttendeeInterest.length > 0 && !$ctrl.isMobile"><div ba-panel="" ba-panel-title="\'{{\'modules.arnoDashboard.board.noReactionEvents\' | translate}}\'" ba-panel-division-selector="false" ba-panel-division-selector-multiple="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.events.service.view" ng-if="$ctrl.noReactionEvents.length > 0"><event-tile-dashboard ng-repeat="event in $ctrl.noReactionEvents" tile-data="event"></event-tile-dashboard></div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="w-100 m-1" ng-if="$ctrl.viewPermissions.eventView"><div ba-panel="" ba-panel-title="\'{{\'modules.arnoDashboard.board.yourEvents\' | translate}}\'" ba-panel-division-selector="false" ba-panel-division-selector-multiple="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.events.service.view" ng-if="$ctrl.attendingEvents.length > 0"><event-tile-dashboard ng-repeat="event in $ctrl.attendingEvents" tile-data="event"></event-tile-dashboard></div></div><div class="w-100 m-1" ng-if="$ctrl.viewPermissions.eventView" ng-hide="!$ctrl.openDivisionInvites.length > 0 && !$ctrl.demandForActionCount && !($ctrl.availableHHDivs.length && $ctrl.openHelperHours && $ctrl.openHelperHours.rows && $ctrl.openHelperHours.rows.length) && !($ctrl.openQuotations || $ctrl.openInvoices) && !$ctrl.openServiceAttendeeInterest.length > 0 && !$ctrl.isMobile"><div ba-panel="" ba-panel-title="\'{{\'modules.arnoDashboard.board.noReactionEvents\' | translate}}\'" ba-panel-division-selector="false" ba-panel-division-selector-multiple="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.events.service.view" ng-if="$ctrl.noReactionEvents.length > 0"><event-tile-dashboard ng-repeat="event in $ctrl.noReactionEvents" tile-data="event"></event-tile-dashboard></div></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="w-100 m-1" ng-if="$ctrl.viewPermissions.eventShare"><div ba-panel="" ba-panel-title="\'modules.arnoDashboard.board.requestToShareEvents\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-namespace="divisionShareRequests" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.events.basic.manage,arno.events.service.manage" ba-panel-division-selector-dashboard="true"><dashboard-service-share-list division-shares="$ctrl.divisionShares" event-share-ctx="$ctrl.eventShareCtx"></dashboard-service-share-list></div></div><div class="w-100 m-1"><div class="panel"><div class="panel-heading clearfix panel-title pb-0"><h3><div ng-bind-html="$ctrl.welcomeTitleContentText"></div></h3></div><div class="panel-body"><div ng-bind-html="$ctrl.welcomeTextContentText"></div></div></div></div></div></div><div class="row"><div class="col-12"><div data-cy="dashboard-event" ng-if="$ctrl.viewPermissions.event"><div ba-panel="" ba-panel-title="\'modules.arnoDashboard.board.dates\'" ba-panel-division-selector="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage"><event-calendar attendance-states="$ctrl.attendanceStates" chosen-shared-filters="$ctrl.chosenSharedFilters" event-types="$ctrl.eventTypes" categories="$ctrl.categories" ctx="$ctrl.eventCtx"></event-calendar></div></div></div></div></div>');
$templateCache.put('app/pages/service/confirmStateChange.html','<div class="modal-content buttons-enabled-while-network"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Abbrechen"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" translate="components.confirmStateChange.unsavedChanges"></h4></div><div class="modal-body">{{\'components.confirmStateChange.whenContinueDeleteUnsavedFiles\' |translate}}<p class="mt-5" translate="components.confirmStateChange.requestToContinue"></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-with-icon mt-10" ng-click="$close()"><i class="fa fa-trash"></i> {{\'components.confirmStateChange.discardChanges\' |translate}}</button> <button type="button" class="btn btn-primary btn-with-icon mt-10" ng-click="$dismiss()"><i class="fa fa-pencil"></i> {{\'components.confirmStateChange.editContinue\' |translate}}</button></div></div>');
$templateCache.put('app/theme/templates/syntax.modal.tpl.html','<div class="panel"><div class="panel-heading"><button type="button" class="close" ng-click="$close()" aria-hidden="true">&times;</button><h4 class="panel-title">Syntax</h4></div><div class="panel-body" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div><div class="panel-footer" style="height: 64px"><button type="button" class="btn btn-default pull-right" ng-click="$close()">Schlie\xDFen</button></div></div>');
$templateCache.put('app/theme/templates/syntax.tpl.html','<h3>{{(\'components.syntaxTemplate.title\' | translate )}}</h3><h5>Basics</h5><pre><code><i>*{{(\'components.syntaxTemplate.italic\' | translate )}}*</i>      <b>**{{\'components.syntaxTemplate.bold\' | translate }}**</b><br><i>_{{(\'components.syntaxTemplate.italic\' | translate )}}_</i>      <b>__{{\'components.syntaxTemplate.bold\' | translate }}__</b></code></pre><h5>{{(\'components.syntaxTemplate.links\' | translate )}}</h5><pre><code>{{(\'components.syntaxTemplate.exampleUrl\' | translate )}}</code></pre><h5>{{(\'components.syntaxTemplate.headlines\' | translate )}}</h5><pre><code># {{(\'components.syntaxTemplate.headline\' | translate )}} 1<br>## {{(\'components.syntaxTemplate.headline\' | translate )}} 2<br>### {{(\'components.syntaxTemplate.headline\' | translate )}} 3</code></pre><h5>{{(\'components.syntaxTemplate.listsNumbered\' | translate )}}</h5><pre><code>1. {{(\'components.syntaxTemplate.item1\' | translate )}}<br>2. {{(\'components.syntaxTemplate.item2\' | translate )}}</code></pre><h5>{{(\'components.syntaxTemplate.listsDisordered\' | translate )}}</h5><pre><code>* {{(\'components.syntaxTemplate.item1\' | translate )}}<br>  * {{(\'components.syntaxTemplate.subitem1\' | translate )}}<br>* {{(\'components.syntaxTemplate.item2\' | translate )}}<br>  1. {{(\'components.syntaxTemplate.subitem2\' | translate )}}<br>  2. {{(\'components.syntaxTemplate.subitem3\' | translate )}}</code></pre><h5>{{(\'components.syntaxTemplate.lineBreaks\' | translate )}}</h5><pre><code>{{(\'components.syntaxTemplate.manual\' | translate )}}<br>{{(\'components.syntaxTemplate.lineBreak\' | translate )}}</code></pre>');
$templateCache.put('app/pages/administration/apikey/apikey.html','<ui-view><div ba-panel="" ba-panel-title="\'modules.administration.apikey.panelTitle\'"><div class="mb-20"><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ self.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="self.setPageSize(i)">{{ i }}</a></li></ul></div><button type="button" ng-click="self.openDetails()" class="btn btn-primary btn-with-icon pull-right"><i class="ion-plus"></i> <span translate="modules.administration.apikey.addKey"></span></button></div><div class="table-responsive"><table st-table="self.displayedCollection" st-pipe="self.getKeys" class="table"><thead><tr class="sortable"><th st-sort="Name" translate="generalTerms.name"></th><th translate="generalTerms.active"></th><th translate="modules.administration.apikey.fields.generatedKey"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="row in self.displayedCollection"><td><span>{{ row.Name }}</span></td><td>{{ (row.Active ? \'generalTerms.yes\' : \'generalTerms.no\') | translate }}</td><td><div><span>{{ row.Key }}</span> <button type="button" class="btn btn-default btn-xs btn-with-icon" title="{{ \'generalTerms.copyToClipboard\' | translate }}" ng-click="self.ctc(row.Key)"><i class="fa fa-clipboard"></i></button></div></td><td><button class="btn btn-default btn-with-icon btn-xs" ng-click="self.openDetails(row.id)" title="{{ \'generalTerms.edit\' | translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-default btn-with-icon btn-xs btn-danger" ng-click="self.deleteKey(row)" title="{{ \'generalTerms.delete\' | translate }}"><i class="fa fa-trash"></i><span translate="generalTerms.delete"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-click="self.setKeyState(row.id, !row.Active)" ng-class="{ \'btn-success-outline\': !row.Active, \'btn-danger\': row.Active }" title="{{ (row.Active ? \'generalTerms.deactivate\' : \'generalTerms.activate\') | translate }}"><i class="ion-checkmark" ng-if="!row.Active"></i> <i class="fa fa-ban" ng-if="row.Active"></i> <span>{{ (row.Active ? \'generalTerms.deactivate\' : \'generalTerms.activate\') | translate }}</span></button></td></tr><tr ng-if="self.displayedCollection && self.displayedCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.administration.apikey.noKey"></i></td></tr></tbody><tfoot><tr ng-if="self.displayedCollection && self.displayedCollection.length"><td colspan="99" class="text-center"><st-pagination st-items-by-page="self.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></ui-view>');
$templateCache.put('app/pages/administration/categories/categories.html','<div ba-panel="" ba-panel-title="\'modules.administration.adminCategories.manageCat\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="{{ $ctrl.divisionSelectorEntryPermission }}"><div><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.openModal(\'createCategory\', \'md\')" ng-disabled="!$ctrl.ctxSelected"><i class="fa ion-plus"></i><span class="hidden-xs" translate="modules.administration.adminCategories.addCat"></span></button></div><br><div class="row" ng-if="$ctrl.ctxSelected"><p class="col-xs-12" translate="modules.administration.adminCategories.catWarning"></p></div><br><div ng-if="$ctrl.categories.length"><table st-table="$ctrl.categoryCollection" st-safe-src="$ctrl.categories" class="table"><thead><tr class="sortable"><th st-sort="Name" translate="modules.administration.adminCategories.nameOfCat"></th><th ng-if="$ctrl.currentDivision" translate="modules.administration.adminCategories.usageOfCat"></th><th st-sort="Color" translate="modules.administration.adminCategories.colorOfCat"></th><th translate="modules.administration.adminCategories.actionOfCat"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" maxlength="254" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th ng-if="$ctrl.currentDivision"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.categoryCollection"><td><i ng-class="{ \'ion-ios-people-outline\': item.DivisionId != null, \'ion-ios-people\': item.DivisionId == null }"></i> {{item.Name}}</td><td ng-if="$ctrl.currentDivision"><span ng-repeat="usage in item.BaseCategoryUsages" ng-bind="::$ctrl.ADMIN_CATEGORIES_USAGE_LIST_LABELS[usage.UsedFor] + ($last ? \'\' : \', \')"></span></td><td><div ng-style="$ctrl.setColor(item.Color)"></div></td><td class="arno-table-button-cell"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openModal(\'editCategory\', \'md\', item)" title="{{(\'modules.administration.adminCategories.editCat\' | translate)}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.openModal(\'deleteCategory\', \'md\', item)" title="{{(\'modules.administration.adminCategories.deleteCat\' | translate)}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></td></tr><tr ng-if="$ctrl.categoryCollection && $ctrl.categoryCollection.length === 0"><td class="text-center" colspan="3" translate="modules.administration.adminCategories.noCatsRecorded"></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div ng-if="!$ctrl.categories.length" class="text-center mb-10"><i translate="modules.administration.adminCategories.noCatsDeposited"></i></div></div>');
$templateCache.put('app/pages/administration/design/design.html','<div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.design.manage\')" ba-panel="" ba-panel-title="\'modules.administration.adminDesign.orgaLogo\'" class="logo-setup"><div class="row mb-10"><div class="col-lg-6 mb-20"><div class="row"><div class="col-sm-12"><form id="orgLogoUpload" class="mb-10"><div class="row" ng-if="$ctrl.currentSquareLogoSrc || portalLogo.data || $ctrl.currentExtendedLogoSrc || portalLogo.dataExt || $ctrl.changeCurrentOrgLogo"><div class="col-sm-6 logo-data-container"><p><strong translate="modules.administration.adminDesign.quadLogo"></strong></p><div ng-if="$ctrl.currentSquareLogoSrc || portalLogo.data" class="preview-image-container square"><img ng-src="{{$ctrl.currentSquareLogoSrc || portalLogo.data}}"></div><div ng-if="$ctrl.changeCurrentOrgLogo"><div nv-file-drop="" uploadlogo="" data-upload-target="orglogo-square-fileinput" :options="{alias: \'square\'}" uploader="$ctrl.uploader" class="col-9 well arno-file-drop-area mt-10" translate="modules.administration.adminDesign.uploadNewQuadLogo"></div><input type="file" class="hidden" nv-file-select="" id="orglogo-square-fileinput" :options="{alias: \'square\'}" uploader="$ctrl.uploader"> <button class="btn btn-primary btn-sm btn-with-icon mr-5 my-5" type="button" uploadlogo="" data-upload-target="orglogo-square-fileinput"><i class="ion-plus"></i><span class="ml-5" translate="modules.administration.adminDesign.uploadLogo"></span></button> <button class="btn btn-danger btn-sm btn-with-icon my-5" ng-if="$ctrl.currentSquareLogoSrc || portalLogo.data" ng-click="$ctrl.removeCurrentLogo(\'square\')"><i class="fa fa-trash"></i><span class="ml-5" translate="generalTerms.delete"></span></button></div></div><div class="col-sm-6 logo-data-container" ng-style="{\'opacity\': !($ctrl.currentSquareLogoSrc || portalLogo.data) ? \'0.5\': \'1\'}"><p><strong translate="modules.administration.adminDesign.extendetLogo"></strong></p><div ng-if="$ctrl.currentExtendedLogoSrc || portalLogo.dataExt" class="preview-image-container extended"><img ng-src="{{$ctrl.currentExtendedLogoSrc || portalLogo.dataExt}}"></div><div ng-if="$ctrl.changeCurrentOrgLogo"><div ng-if="($ctrl.currentSquareLogoSrc || portalLogo.data)"><div nv-file-drop="" uploadlogo="" data-upload-target="orglogo-extended-fileinput" :options="{alias: \'extended\'}" uploader="$ctrl.uploader" class="col-9 well arno-file-drop-area" ng-class="!($ctrl.currentExtendedLogoSrc || portalLogo.dataExt) ? \'placeholder\' : \'mt-10\'" translate="modules.administration.adminDesign.newExtendetLogoForUpload"></div><input type="file" class="hidden" nv-file-select="" id="orglogo-extended-fileinput" :options="{alias: \'extended\'}" uploader="$ctrl.uploader"> <button class="btn btn-primary btn-sm btn-with-icon mr-5 my-5" type="button" uploadlogo="" data-upload-target="orglogo-extended-fileinput"><i class="ion-plus"></i><span class="ml-5" translate="modules.administration.adminDesign.uploadLogo"></span></button> <button class="btn btn-danger btn-sm btn-with-icon my-5" ng-if="$ctrl.currentExtendedLogoSrcLogoSrc || portalLogo.dataExt" ng-click="$ctrl.removeCurrentLogo(\'extended\')"><i class="fa fa-trash"></i><span class="ml-5" translate="generalTerms.delete"></span></button></div><div ng-if="!$ctrl.currentSquareLogoSrc && !portalLogo.data" translate="modules.administration.adminDesign.quadLogoIsRequired"></div></div></div></div></form><div class="mb-10"><button class="btn btn-primary" ng-if="!$ctrl.changeCurrentOrgLogo" ng-click="$ctrl.changeCurrentOrgLogo = true" ng-class="($ctrl.currentLogoSrc || portalLogo.data) ? \'mt-10\' : \'\'">{{ !($ctrl.currentLogoSrc || portalLogo.data) ? \'modules.administration.adminDesign.uploadOrgaLogo\' : \'modules.administration.adminDesign.changeLogo\' | translate}}</button></div><div class="format-hints mt-25" ng-if="$ctrl.changeCurrentOrgLogo"><h5 translate="modules.administration.adminDesign.designNotes"></h5><ul style="padding-left: 1.25em; margin-left: 0"><li class="mt-5" translate="modules.administration.adminDesign.theImageNoBiggerThan1Mb"></li><li class="mt-5" translate="modules.administration.adminDesign.theImageMusstSvgOrPng"></li><li class="mt-5" translate="modules.administration.adminDesign.transparentBackgroundRecom"></li><li class="mt-5" translate="modules.administration.adminDesign.attentionImage"></li><li class="mt-5" translate="modules.administration.adminDesign.attentionDark"></li></ul></div></div></div></div><div class="col-lg-6"><div class="form-group"><div class="row mx-0"><div class="col-lg-offset-1"><ba-switcher switcher-style="primary" switcher-disabled="!($ctrl.currentSquareLogoSrc || portalLogo.data)" switcher-value="$ctrl.logoSetup.useSquareInNavigation"></ba-switcher><span class="selector-label" ng-class="[{\'text-muted\': !($ctrl.currentSquareLogoSrc || portalLogo.data)}]" translate="modules.administration.adminDesign.quadLogoInMainMenu"></span></div></div><div class="row mx-0"><div class="col-lg-offset-1"><ba-switcher switcher-style="primary" switcher-disabled="!($ctrl.currentExtendedLogoSrc || portalLogo.dataExt)" switcher-value="$ctrl.logoSetup.useExtInNavigation"></ba-switcher><span class="selector-label" ng-class="[{\'text-muted\': !($ctrl.currentExtendedLogoSrc || portalLogo.dataExt)}]" translate="modules.administration.adminDesign.extendetLogoInMainMenu"></span></div></div><div class="row mx-0"><div class="col-lg-offset-1"><ba-switcher switcher-style="primary" switcher-value="$ctrl.logoSetup.useFilter"></ba-switcher><span class="selector-label" translate="modules.administration.adminDesign.colorFilterApply"></span></div></div><div class="row mx-0"><div class="col-lg-offset-1"><ba-switcher switcher-style="primary" switcher-disabled="!$ctrl.logoSetup.useExtInNavigation || !($ctrl.currentExtLogoSrc || portalLogo.dataExt )" switcher-value="$ctrl.logoSetup.showOrgLabel"></ba-switcher><span class="selector-label" ng-class="[{\'text-muted\': !$ctrl.logoSetup.useExtInNavigation || !($ctrl.currentExtLogoSrc || portalLogo.dataExt)}]" translate="modules.administration.adminDesign.orgaNameShow"></span></div></div><div class="row mx-0"><div class="col-lg-offset-1"><ba-switcher switcher-style="primary" switcher-disabled="!($ctrl.currentLogoSrc || portalLogo.data)" switcher-value="$ctrl.logoSetup.showInFooter"></ba-switcher><span class="selector-label" ng-class="[{\'text-muted\': !($ctrl.currentSquareLogoSrc || portalLogo.data || $ctrl.currentExtLogoSrc || portalLogo.dataExt)}]" translate="modules.administration.adminDesign.logoInFooter"></span></div></div></div></div></div><button type="submit" ng-disabled="!$ctrl.logoSetupHasChanges()" ng-click="$ctrl.saveLogoSettings()" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="modules.administration.adminDesign.logoSettingsSave"></span></button></div><div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.design.manage\')" ba-panel="" ba-panel-title="\'modules.administration.adminDesign.colorShema\'"><div class="row mb-10"><div class="col-xlg-3 col-lg-5 col-md-6 col-sm-12 mb-20"><material-picker ng-model="$ctrl.selectedColor" format="\'hex\'" size="15"></material-picker><div class="mt-20"><label><span>{{\'modules.administration.adminDesign.actuallyColor\' | translate}}<arno-ba-help-tooltip text="{{ \'modules.administration.adminDesign.theTextColorChanged\' |translate }}"></arno-ba-help-tooltip><input ng-model="$ctrl.selectedColor" ng-style="{ \'background-color\': $ctrl.selectedColor, color: $ctrl.fontColor }" class="arno-colorpicker-preview-with-font"></span></label></div></div><div class="col-xlg-9 col-lg-7 col-md-6 col-sm-12"><div class="arno-preview-panel-bg"><div class="arno-nested-panel" ba-panel="" ba-panel-title="\'modules.administration.adminDesign.theTextDisplay\'" ba-panel-help-icon="{{ \'modules.administration.adminDesign.allElementsInDisplay\' |translate }}"><div class="col-md-12 mt-10 mb-10 p-0"><div class="col-md-2 p-0"><ba-switcher switcher-style="primary" switcher-keys="$ctrl.switchKeys"></ba-switcher></div><div class="paging-input pull-right"><ui-select ng-model="$ctrl.paging" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{ \'modules.administration.adminDesign.resultsProSite\' |translate }}">({{ $ctrl.paging }})</ui-select-match><ui-select-choices position="down" repeat="option in [50, 20, 10, 5, 2]"><span>{{ option }}</span></ui-select-choices></ui-select></div></div><div><table st-table="displayedCollection" st-safe-src="$ctrl.testCollection" class="table arno-preview-table"><thead><tr class="sortable"><th st-sort="firstName" translate="generalTerms.firstName"></th><th st-sort="lastName" translate="generalTerms.lastName"></th><th class="arno-table-button-cell preview-action-col" translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="firstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="lastName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{row.firstName}}</td><td>{{row.lastName}}</td><td><button class="btn btn-default btn-with-icon btn-xs" title="{{ \'modules.administration.adminDesign.detailsOfDesign\' |translate }}"><span class="hidden-xs hidden-sm" translate="modules.administration.adminDesign.detailsOfDesign"><i class="fa fa-eye"></i></span></button> <button class="btn btn-danger btn-with-icon btn-xs" title="{{ \'modules.administration.adminDesign.deleteMember\' |translate }}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$ctrl.paging" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><button class="btn btn-primary btn-with-icon mt-20 mr-10"><i class="ion-checkmark"></i><span translate="generalTerms.ok"></span></button> <button class="btn btn-default btn-with-icon mt-20"><i class="ion-close"></i><span translate="generalTerms.back"></span></button></div></div></div></div><button type="submit" ng-disabled="!$ctrl.validateHex($ctrl.selectedColor)" ng-click="$ctrl.saveColorSettings()" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="modules.administration.adminDesign.colorSettingsSave"></span></button></div>');
$templateCache.put('app/pages/administration/divisions/divisions.html','<div class="row" ng-if="$ctrl.isPermittedForTreeView"><div class="col-xs-12 col-md-5"><div ba-panel="" ba-panel-title="\'generalTerms.overview\'" ba-panel-class="with-scroll administration__divisions__treeview"><div class="row btns-row"><div class="col-xs-12 control-side"><button data-cy="org-admin-division-expand-all" type="button" class="btn btn-default btn-sm btn-with-icon" ng-click="$ctrl.toggleCollapsed()"><i ng-class="{\'ion-chevron-up\': $ctrl.treeviewCollapsed === false, \'ion-chevron-down\': $ctrl.treeviewCollapsed === true }"></i> <span translate="generalTerms.all">Alle <span ng-show="!$ctrl.treeviewCollapsed" translate="generalTerms.collapse"></span> <span ng-show="$ctrl.treeviewCollapsed" translate="generalTerms.unfold"></span></span></button> <button class="btn btn-primary btn-sm btPn-with-icon pull-right" type="button" ng-click="$ctrl.addNewNode()" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\')" data-cy="org-admin-add-division"><i class="ion-plus"></i><span class="ml-5" translate="modules.administration.adminDivision.newDiv"></span></button></div></div><div class="row"><div class="col-xs-12"><div><script type="text/ng-template" id="nodesRenderer.tpl.html"><div ng-if="node.active && !$ctrl.showInactive || $ctrl.showInactive" class="node-embed" ui-tree-handle ng-click="$ctrl.selectNode(node)" ng-class="{\'node-active\': $ctrl.selectedDivision.id === node.id, \'disabled-division\': !node.active}" data-drag-enabled="$ctrl.dnd"> <a ng-if="node.children.length" class="btn btn-clear btn-xs division-chevron"> <i class="fa" ng-if="$ctrl.checkForDisabledChildren(node)" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}" ng-click="node.collapsed = !node.collapsed"></i> </a> <div ng-class="{\'inline-block\': node.children.length, \'ml-30\' : !node.children.length}"> <div class="ba-treeview-node-icon {{::node.icon}}"></div> <span class="ba-treeview-node-label" ng-bind="node.text"></span> </div> </div> <ol ui-tree-nodes="options" class="ml-6" ng-model="node.children" ng-class="{hidden: node.collapsed, displayed: !node.collapsed}"> <li ng-repeat="node in node.children" class="{{::node.id}}" ui-tree-node ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div class="division-tree" ui-tree="$ctrl.treeOptions" data-drag-delay="200"><ol ui-tree-nodes="" ng-model="$ctrl.divisionTreeData"><li ng-repeat="node in $ctrl.divisionTreeData" collapsed="$ctrl.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div></div></div><ba-panel-footer class="clearfix administration__divisions__treeview__footer-bar" ng-if="$ctrl.isPermittedForTreeMove"><div class="pull-left mb-10"><input id="divMode" type="checkbox" class="form-control division-active-checkbox inline-block mt-0 mr-5" ng-model="$ctrl.showInactive"> <span translate="modules.administration.adminDivision.allDivView"></span></div><div class="pull-right"><button title="{{(\'modules.administration.adminDivision.removeChanges\' | translate)}}" class="btn btn-default btn-with-icon" type="button" ng-click="$ctrl.refresh()" ng-show="$ctrl.detectedChanges"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="modules.administration.adminDivision.removeChanges"></span></button> <button class="btn btn-danger btn-with-icon" ng-click="$ctrl.delete()" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\') && $ctrl.selectedDivision.active" ng-disabled="!$ctrl.selectedDivision.id || $ctrl.constraint.isConstrained || $ctrl.reqInProg" type="button"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button> <button class="btn btn-danger btn-with-icon" ng-click="$ctrl.deactivate()" ng-disabled="!$ctrl.selectedDivision.id || !$ctrl.constraint.isConstrained || $ctrl.reqInProg" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\') && !$ctrl.selectedDivision.newNode && $ctrl.selectedDivision.active" type="button"><i class="ion-close"></i><span translate="generalTerms.deactivate"></span></button> <button class="btn btn-success btn-with-icon" ng-click="$ctrl.activate()" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\') && !$ctrl.selectedDivision.newNode && !$ctrl.selectedDivision.active && $ctrl.selectedDivision.id" type="button"><i class="ion-checkmark"></i><span translate="generalTerms.activate"></span></button> <button class="btn btn-primary btn-with-icon" ng-click="$ctrl.save()" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\') || $ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.administrators.manage\')" data-cy="org-admin-division-save" type="button" ng-disabled="$ctrl.emptyError"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></ba-panel-footer></div></div><div class="col-xs-12 col-md-7"><div ba-panel="" ba-panel-title="\'Details\'" ng-if="$ctrl.selectedDivision.id"><div ng-show="$ctrl.selectedDivision.id && $ctrl.selectedDivision.active"><h3>{{ \'modules.administration.adminDivision.detailsDivFor\' | translate}} <span ng-bind="$ctrl.selectedDivision.text"></span></h3><h4 class="with-line" toggle-next="">{{ \'generalTerms.generalInfo\' | translate }}</h4><div class="row"><div class="col-sm-12"><form><div class="form-group"><label for="divisionTitle" translate="generalTerms.title"></label> <input type="text" class="form-control" id="divisionTitle" ng-model="$ctrl.selectedDivision.text" ng-disabled="!$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\')" placeholder="{{(\'modules.administration.divisions.divTitlePlaceholder\' | translate)}}" data-cy="org-admin-add-division-title" ng-change="$ctrl.checkTitle($ctrl.selectedDivision.text)"> <span ng-if="$ctrl.emptyError" class="help-block basic-block" translate="modules.administration.adminDivision.divCallTitle"></span></div></form><div class="align-right"><button class="btn btn-default btn-with-icon" ng-show="$ctrl.deletableNode()" ng-click="$ctrl.removeUnsavedNode()" type="button"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="generalTerms.discard"></span></button></div></div></div><div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.administrators.manage\') && !($ctrl.selectedDivision.id.indexOf(\'n-\') >=0)" data-cy="org-admin-division-administrator-details-panel"><h4 class="with-line" toggle-next="">{{ \'generalTerms.admin\' | translate }}</h4><div class="row"><div class="col-sm-12"><arno-dash-admin-divisions-supervisors-list ng-if="$ctrl.selectedDivision" config="$ctrl.adminsListConfig" organization-id="$ctrl.organizationId" division-tree="$ctrl.divisions" division-nodes-data="$ctrl.originalNodeData" selected-division="$ctrl.selectedDivision" supervisors="$ctrl.selectedDivision.admins" change-indicator="$ctrl.changes.admins"></arno-dash-admin-divisions-supervisors-list></div></div></div></div><div ng-show="$ctrl.selectedDivision.id && !$ctrl.selectedDivision.active" translate="modules.administration.adminDivision.deactivatedDiv"></div><div ng-show="!$ctrl.selectedDivision.id" class="text-center" translate="modules.administration.adminDivision.chooseDiv"></div><ba-panel-footer class="clearfix administration__divisions__treeview__footer-bar"><div class="pull-right"><button title="{{(\'modules.administration.adminDivision.removeChanges\' | translate)}}" class="btn btn-default btn-with-icon" type="button" ng-click="$ctrl.refresh()" ng-show="$ctrl.detectedChanges"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="modules.administration.adminDivision.removeChanges"></span></button> <button class="btn btn-primary btn-with-icon" ng-click="$ctrl.save()" ng-show="$ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.manage\') || $ctrl.isPermittedInCurrentOrg(\'arno.administration.divisions.administrators.manage\')" data-cy="org-admin-division-save" type="button" ng-disabled="$ctrl.emptyError"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></ba-panel-footer></div><div ng-if="$ctrl.invoiceExportAllowed && $ctrl.invoiceExportCtx"><div ba-panel="" ba-panel-title="\'modules.administration.finances.general.exportInvoices\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><invoice-export-input invoice-export-recipient="$ctrl.invoiceExportRecipient" invoice-export-settings="$ctrl.invoiceExportSettings" invoice-export-ctx="$ctrl.invoiceExportCtx" version="$ctrl.selectedDivision.id"></invoice-export-input></div></div></div></div><div class="row" ng-if="$ctrl.isPermittedForBaseData"><div class="col-md-12"><div ba-panel="" ba-panel-title="(\'modules.administration.divisions.divisionBaseData\' | translate) + \' - \' + $ctrl.divisionBaseData.Name" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="arno.administration.divisions.baseData.manage"><form id="divisionBaseDataForm" name="$ctrl.divisionBaseDataForm" novalidate="" angular-validator="" angular-validator-submit="$ctrl.updateDivisionBaseData()"><div class="row"><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.divisionType"></label> <input type="text" class="form-control" placeholder="" id="dbdType" name="dbdType" required-message="\'\'" required="" ng-model="$ctrl.divisionBaseData.DivisionType"></div><div class="form-group col-md-3"><label class="control-label" translate="modules.administration.divisions.divisionNr"></label> <input type="text" class="form-control" placeholder="" id="dbdDivisionNr" name="dbdDivisionNr" ng-model="$ctrl.divisionBaseData.DivisionNr"></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.office"></label> <input type="text" class="form-control" placeholder="" id="dbdOffice" name="dbdOffice" required-message="\'\'" required="" ng-model="$ctrl.divisionBaseData.Office"></div><div class="form-group col-md-3"><label class="control-label" translate="modules.administration.divisions.institutionCode"></label> <input type="text" class="form-control" placeholder="" name="dbdInstitutionCode" ng-model="$ctrl.divisionBaseData.InstitutionCode"></div></div><h3 class="with-line" translate="modules.administration.divisions.address"></h3><div class="row"><div class="col-md-6"><arno-ba-address class="clearfix" address="$ctrl.divisionBaseData.address" form-ref="$ctrl.divisionBaseDataForm" country-ids-catalogue="$ctrl.MEMBER_COUNTRY_IDS" fields-config="$ctrl.divisionBaseDataAddressFieldsConfig" ui-config="$ctrl.divisionBaseDataAddressUiConfig"></arno-ba-address></div></div><h3 class="with-line" translate="modules.administration.divisions.contact"></h3><div class="row"><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.phone"></label> <input type="text" class="form-control" placeholder="" name="dbdPhone" ng-model="$ctrl.divisionBaseData.Phone"></div><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.fax"></label> <input type="text" class="form-control" placeholder="" name="dbdFax" ng-model="$ctrl.divisionBaseData.Fax"></div><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.email"></label> <input type="text" class="form-control" placeholder="" id="dbdEMail" name="dbdEMail" ng-model="$ctrl.divisionBaseData.EMail" invalid-message="\'modules.administration.divisions.emailInvalid\' | translate" validator="$ctrl.validEMail($ctrl.divisionBaseData.EMail)"></div><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.website"></label> <input type="text" class="form-control" placeholder="" name="dbdWebsite" ng-model="$ctrl.divisionBaseData.Website"></div></div><h3 class="with-line" translate="modules.administration.divisions.finance"></h3><div class="row"><div class="form-group col-md-6"><div class="mr-5"><span>{{ \'modules.administration.divisions.search\' | translate}}<span style="color: red">{{ \'modules.administration.divisions.accountingArea\' | translate}}</span> {{ \'modules.administration.divisions.pick\' | translate}}</span> <input type="text" ng-model="$ctrl.search"></div><label class="control-label" translate="modules.administration.divisions.accountingArea" style="color: red"></label><ui-select ng-if="$ctrl.search.length >= 3" ng-model="$ctrl.accountingArea"><ui-select-match>{{$ctrl.divisionBaseData.OfficeNumber}}</ui-select-match><ui-select-choices group-by="\'group\'" repeat="accountingArea in $ctrl.accountingAreas | filter:{ DepartmentName: $ctrl.search } track by accountingArea.id"><span ng-click="$ctrl.setAccountingArea(accountingArea)">({{accountingArea.DepartmentNumber}}) {{accountingArea.DepartmentName}}</span></ui-select-choices></ui-select></div><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.officeNumber"></label> <input class="form-control" disabled="" ng-value="$ctrl.divisionBaseData.AccountingArea"></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.iban"></label> <input type="text" class="form-control" placeholder="" id="dbdIBAN" name="dbdIBAN" ng-model="$ctrl.divisionBaseData.IBAN" invalid-message="\'modules.administration.divisions.ibanInvalid\' | translate" validator="$ctrl.validIBAN($ctrl.divisionBaseData.IBAN)"></div><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.bic"></label> <input type="text" class="form-control" placeholder="" id="dbdBIC" name="dbdBIC" ng-model="$ctrl.divisionBaseData.BIC" invalid-message="\'modules.administration.divisions.bicInvalid\' | translate" validator="$ctrl.validBIC($ctrl.divisionBaseData.BIC)"></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.bank"></label> <input type="text" class="form-control" placeholder="" name="dbdBank" ng-model="$ctrl.divisionBaseData.Bank"></div></div><h3 class="with-line" translate="modules.administration.divisions.businesspartnerSectionTitle"></h3><div class="row"><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><label for="CustomerNumberInput" class="control-label" translate="modules.contacts.businessPartners.details.CustomerNumber">Kundennummer</label> <input type="text" maxlength="1000" ng-model="$ctrl.divisionBaseData.CustomerNumber" ng-model-options="{ debounce: 500 }" class="form-control" id="CustomerNumberInput" name="CustomerNumberInput" placeholder="{{ modules.contacts.businessPartners.details.CustomerNumberFieldLabel }}"></div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="form-group"><label for="ElectricAdressInput" translate="modules.contacts.businessPartners.details.ElectricAddress">Elektronische Adresse</label> <input type="text" maxlength="1000" ng-model="$ctrl.divisionBaseData.ElectricAdress" ng-model-options="{ debounce: 500 }" class="form-control" id="ElectricAdressInput" name="ElectricAdressInput" placeholder="{{ modules.contacts.businessPartners.details.ElectricAdressFieldLabel }}"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group"><label for="OtherLegalInformationInput" translate="modules.contacts.businessPartners.details.OtherLegalInformation">Weitere rechtliche Informationen</label> <input type="text" maxlength="1000" ng-model="$ctrl.divisionBaseData.OtherLegalInformation" ng-model-options="{ debounce: 500 }" class="form-control" id="OtherLegalInformationInput" name="OtherLegalInformationInput" placeholder="{{ modules.contacts.businessPartners.details.OtherLegalInformationFieldLabel }}"></div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="form-group"><label for="CommentInput" translate="modules.contacts.businessPartners.details.Comment">Kommentar</label> <input type="text" maxlength="1000" ng-model="$ctrl.divisionBaseData.Comment" ng-model-options="{ debounce: 500 }" class="form-control" id="CommentInput" name="CommentInput" placeholder="{{ modules.contacts.businessPartners.details.CommentFieldLabel }}"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group angular-validator-error-message-hidden" ng-class="{\'has-error\': $ctrl.divisionBaseDataForm.taxIdentInput.$invalid}"><label for="taxIdentInput" class="control-label" translate="modules.contacts.businessPartners.details.taxIdentFieldLabel">Steuernummer</label> <input type="text" maxlength="255" ng-model="$ctrl.divisionBaseData.TaxIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="taxIdentInput" name="taxIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.taxIdentFieldLabel\' | translate }}"> <span ng-messages="$ctrl.divisionBaseDataForm.$error" class="help-block error-block basic-block mt-4 --color-danger"><span ng-message="taxIdentExists" translate="modules.contacts.businessPartners.details.taxIdentFieldErrorExists">Steuernummer existiert bereits!</span></span></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group angular-validator-error-message-hidden" ng-class="{\'has-error\': $ctrl.divisionBaseDataForm.vatIdentInput.$invalid}"><label for="vatIdentInput" translate="modules.contacts.businessPartners.details.vatIdentFieldLabel">Umsatzsteuer ID</label> <input type="text" maxlength="255" ng-model="$ctrl.divisionBaseData.VatIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="vatIdentInput" name="vatIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.vatIdentFieldLabel\' | translate }}"> <span ng-show="$ctrl.divisionBaseDataForm.$error.vatIdentExists" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.vatIdentFieldErrorExists">Umsatzsteuer-ID existiert bereits!</span></div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="form-group angular-validator-error-message-hidden" ng-class="{\'has-error\': $ctrl.divisionBaseDataForm.legalRegIdentInput.$invalid}"><label for="legalRegIdentInput" translate="modules.contacts.businessPartners.details.legalRegIdentFieldLabel">Registernummer</label> <input type="text" maxlength="255" ng-model="$ctrl.divisionBaseData.LegalRegistrationIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="legalRegIdentInput" name="legalRegIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.legalRegIdentFieldLabel\' | translate }}"> <span ng-show="$ctrl.divisionBaseDataForm.$error.legalRegIdentExists" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.legalRegIdentFieldErrorExists">Registernummer existiert bereits!</span></div></div></div><div class="mt-10"><button type="submit" ng-click="$ctrl.setDirty()" class="btn btn-primary btn-with-icon pull-right"><i class="ion-checkmark"></i><span translate="modules.personnel.dossier.baseData.save"></span></button></div></form></div></div></div>');
$templateCache.put('app/pages/administration/language/language.html','<div ba-panel="" ba-panel-title="\'modules.administration.language.editPanel\'"><div class="mb-20"><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $ctrl.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.setPageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive"><table st-table="$ctrl.flattenedDict" st-set-filter="languageCustomFilter" class="table"><thead><tr><th translate="modules.administration.language.path"></th><th translate="modules.administration.language.term"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="flatKey" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="value" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="row in $ctrl.flattenedDict"><td><span title="{{ row.flatKey }}">{{ $ctrl.formatPath(row.flatKey) }}</span></td><td>{{ row.value }}</td><td><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.edit(row.flatKey)" title="{{ \'generalTerms.edit\' | translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$ctrl.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/administration/permissions/permissions.html','<div ba-panel="" ba-panel-title="\'generalTerms.perm\'" ba-panel-class="administration__permissions__members-panel" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}"><div class="row btns-row"><div class="col-md-12"><button ng-disabled="!$ctrl.ctxSelected" class="btn btn-primary btn-with-icon" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/addPermittedMembers.html\', \'md\', null, (\'modules.administration.adminPerm.selectMember\' | translate))"><i class="fa ion-plus"></i> <span translate="modules.administration.adminPerm.addRole"></span></button></div></div><div class="row"><div class="col-md-12"><div class="table-responsive overflow"><table st-table="$ctrl.userCollection" st-safe-src="$ctrl.formattedMemberRoles" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="MemberFirstName" st-sort-default="true" translate="modules.administration.adminPerm.firstName"></th><th st-sort="MemberLastName" translate="generalTerms.createName"></th><th st-sort="role" translate="modules.administration.adminPerm.rolls"></th><th class="default-cursor" translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberFirstName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberLastName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="RoleName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.userCollection" class="arno-pointing-pointer" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/addPermittedMembers.html\', \'md\', item, (\'models.Member\' | translate))"><td><span>{{ ::item.MemberFirstName }}</span></td><td><span>{{ ::item.MemberLastName }}</span></td><td><div ng-repeat="role in item.RoleName track by $index" class="roles-included-permission-hover" ng-click="$ctrl.openRoleData(role, $ctrl.fetchTooltip(item, role, $ctrl.formattedRoles)); $ctrl.prevent($event)"><div class="arno-tag tag label label-tag label-warning" ng-if="item.Assignable[$index]">{{ role }}</div></div></td><td class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.prevent($event)"><button data-cy="administration-permission-edit" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/addPermittedMembers.html\', \'md\', item, (\'models.Member\' | translate))" title="{{(\'modules.administration.adminPerm.asignRoles\' | translate)}}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="$ctrl.currentDivision" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/copyPermission.html\', \'md\', item)" title="{{(\'modules.administration.adminPerm.copyInPerm\' | translate)}}"><i class="ion-ios-copy"></i><span class="hidden-xs hidden-sm" translate="generalTerms.copy"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/removePermittedMember.html\', \'md\', item, null)" title="{{(\'modules.administration.adminPerm.deletePermissionsOfMember\' | translate)}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="$ctrl.userCollection && $ctrl.userCollection.length === 0"><td class="text-center" colspan="4"><i translate="modules.administration.adminPerm.noPermissionsRecorded"></i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div></div></div><div ba-panel="" ba-panel-title="\'modules.administration.adminPerm.permissionGroup\'" ba-panel-class="administration__permission-groups__panel" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}"><div class="row btns-row"><div class="col-md-12"><button ng-disabled="!$ctrl.ctxSelected" class="btn btn-primary btn-with-icon" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/addPermissionGroup.html\', \'md\')"><i class="ion-plus"></i><span translate="modules.administration.adminPerm.addPermissionsGroup"></span></button></div></div><div class="row"><div class="col-md-12"><div class="table-responsive overflow"><table st-table="$ctrl.groupCollection" st-safe-src="$ctrl.formattedPermissionGroups" class="table"><thead><tr class="sortable"><th st-sort="Name" translate="generalTerms.createName"></th><th st-sort="MemberFullName" translate="generalTerms.members">Mitglieder ( <span class="text-danger" translate="generalTerms.organisation"></span> <span ng-if="$ctrl.currentDivision">/ <span class="text-success" translate="generalTerms.divisions"></span></span> <span>)</span></th><th st-sort="RoleName" translate="modules.administration.adminPerm.rolls"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="GroupName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberFullName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="RoleName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.groupCollection"><td><span>{{ ::(item.GroupName === \'all\' ? \'modules.administration.adminPerm.allGroupMember\' : item.GroupName) | translate }}</span></td><td><span ng-if="item.MemberFullName[0] === null" class="more-text-widget"><i class="gray" translate="modules.administration.adminPerm.noMembers"></i></span> <span class="arno-tag tag label" ng-class="{\'label-success\' : $ctrl.setMemberColor(item.MemberId[$index]), \'label-danger\' : !$ctrl.setMemberColor(item.MemberId[$index])}" ng-repeat="member in item.MemberFullName track by $index">{{::member }}</span></td><td><div class="arno-pointing-pointer arno-tag tag label label-tag label-warning roles-included-permission-hover" ng-repeat="role in item.RoleName" ng-click="$ctrl.openRoleData(role, $ctrl.fetchTooltip(item, role, $ctrl.formattedRoles))">{{ role }}</div></td><td class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.prevent($event)"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/addPermissionGroup.html\', \'md\', null, (\'models.Member\' | translate), item)" title="{{(\'modules.administration.adminPerm.joinNewGroup\' | translate)}}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button ng-if="::!item.Static && $ctrl.currentDivision" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/copyPermission.html\', \'md\', null, null, item)" title="{{(\'modules.administration.adminPerm.copyPermInGroup\' | translate)}}"><i class="ion-ios-copy"></i><span class="hidden-xs hidden-sm" translate="generalTerms.copy"></span></button> <button ng-if="::!item.Static" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/permissions/permissionModalTemplate/removePermissionGroup.html\', \'md\', null, null, item)" title="{{(\'modules.administration.adminPerm.deleteGroup\' | translate)}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="$ctrl.groupCollection && $ctrl.groupCollection.length === 0"><td class="text-center" colspan="4"><i translate="modules.administration.adminPerm.noPermissionsRecorded"></i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/administration/roles/roles.html','<div ba-panel="" ba-panel-title="\'modules.administration.roles.manageRole\'"><div class="row btns-row"><div class="col-md-12"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.open(\'app/pages/administration/roles/roleModalTemplate/addRoles.html\', \'md\', null)"><i class="fa ion-plus"></i><span class="hidden-xs" translate="modules.administration.roles.addRole"></span></button></div></div><div class="row"><div class="col-md-12"><div class="table-responsive overflow"><table ng-if="$ctrl.formattedRoles.length > 0" st-table="displayedCollection" st-safe-src="$ctrl.formattedRoles" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="RoleName" translate="modules.administration.roles.roleName"></th><th translate="modules.administration.roles.roleRights"></th><th translate="modules.administration.roles.roleActions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="RoleName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="PermissionName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="role in displayedCollection" class="arno-pointing-pointer" ng-click="$ctrl.open(\'app/pages/administration/roles/roleModalTemplate/addRoles.html\', \'md\', role)"><td><span class="nowrap">{{ ::role.RoleName }}</span></td><td><div ng-repeat="perm in role.Permissions | orderBy:\'name\'" class="roles-included-permission"><div ng-if="perm.id != null && perm.name != null" class="arno-tag tag label label-tag" ng-class="::{\'label-success\': !$ctrl.fetchTooltipCache[role.RoleId][perm.id].isAggregated, \'label-warning\': $ctrl.fetchTooltipCache[role.RoleId][perm.id].isAggregated}"><arno-permission-popover roles-permission-data="::$ctrl.fetchTooltip(role, perm)" permission-popover-label="perm.name" permission-popover-placement="bottom"></arno-permission-popover></div></div></td><td class="arno-table-button-cell"><span ng-if="role.Immutable" translate="modules.administration.roles.noModRole"></span> <span ng-if="!role.Immutable" class="pull-right"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/roles/roleModalTemplate/addRoles.html\', \'md\', role); $event.stopPropagation();" title="{{(\'modules.administration.roles.editRole\' | translate)}}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.open(\'app/pages/administration/roles/roleModalTemplate/deleteRole.html\', \'md\', role); $event.stopPropagation();" title="{{(\'modules.administration.roles.deleteRole\' | translate)}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></span></td></tr><tr ng-if="displayedCollection && displayedCollection.length === 0"><td class="text-center" colspan="3"><i translate="modules.administration.roles.noWriteRoles"></i></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/administration/statistics/statistics.html','<div class="row"><div class="col-md-12"><div ng-if="$ctrl.permitted" ba-panel="" ba-panel-title="\'Statistikverantwortliche\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.administration.statistics.assign.distributor"><div ng-if="$ctrl.selectedCtx" class="row"><div class="col-md-12"><uib-accordion ng-if="$ctrl.statisticResponsiblePersons.length> 0"><uib-accordion-group ng-if="$ctrl.unassignedStatisticGroup.Statistics.length > 0" is-open="$ctrl.unassignedStatisticGroup.statisticRespGroupTabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><i class="fa fa-warning"></i> <span>Nicht zugewiesene Statistiken</span> (<span ng-bind="$ctrl.unassignedStatisticGroup.Statistics.length"></span>) <i class="pull-right" ng-class="{\'ion-chevron-down\': $ctrl.unassignedStatisticGroup.statisticRespGroupTabOpen, \'ion-chevron-right\': !$ctrl.unassignedStatisticGroup.statisticRespGroupTabOpen}"></i></uib-accordion-heading><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true">Statistik</th><th st-sort-default="true">Mitglieder mit Nutzungsrechten</th><th class="text-center">Aktionen</th></tr></thead><tbody class="without-top-border"><tr ng-repeat="statistic in $ctrl.statisticResponsiblePersons | orderBy:[\'Title\'] | filter:{ StatisticGroupId: null }:true track by $index"><td class="align-left-force">{{statistic.Statistic.Title}}</td><td><span ng-repeat="member in statistic.UsingMember">{{ member.FirstName }} {{ member.LastName }}<br></span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openEditResponsiblePersons(statistic)" title="Gliederungsstatistikverantwortliche bearbeiten"><i class="ion-edit"></i><span class="hidden-xs">Bearbeiten</span></button></form></td></tr></tbody></table></uib-accordion-group><uib-accordion-group ng-if="statisticGroup.Statistics.length > 0" ng-repeat="statisticGroup in $ctrl.statisticHierarchy | orderBy:[\'Name\']" ng-init="statisticGroup.statisticRespGroupTabOpen = true" is-open="statisticGroup.statisticRespGroupTabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span>{{statisticGroup.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': statisticGroup.statisticRespGroupTabOpen, \'ion-chevron-right\': !statisticGroup.statisticRespGroupTabOpen}"></i></uib-accordion-heading><div class="row" ng-if="statisticGroup.statisticRespGroupTabOpen || statisticGroup.statisticRespGroupTabWasOpenOnce"><div class="col-md-12" ng-init="statisticGroup.statisticRespGroupTabWasOpenOnce = true"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true">Statistik</th><th st-sort-default="true">Mitglieder mit Nutzungsrechten</th><th>Aktionen</th></tr></thead><tbody class="without-top-border"><tr ng-repeat="statistic in $ctrl.statisticResponsiblePersons | orderBy:[\'Title\'] | filter:{ StatisticGroupId: statisticGroup.id }:true track by $index" class="editable-row"><td><span>{{ ::statistic.Statistic.Title }}</span></td><td><span ng-repeat="member in statistic.UsingMember">{{ member.FirstName }} {{ member.LastName }}<br></span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openEditResponsiblePersons(statistic)" title="Gliederungsstatistikverantwortliche bearbeiten"><i class="ion-edit"></i><span class="hidden-xs">Bearbeiten</span></button></form></td></tr></tbody></table></div></div></div></uib-accordion-group></uib-accordion><div class="text-center" ng-if="!($ctrl.statisticResponsiblePersons.length > 0)">Es sind keine Eintr\xE4ge vorhanden</div></div></div><div ng-if="!$ctrl.selectedCtx" class="row text-center">W\xE4hle bitte zuerst einen Bereich aus.</div></div></div></div>');
$templateCache.put('app/pages/administration/terms/preview.modal.html','<div class="panel"><div class="panel-heading"><h4 class="panel-title" ng-bind="::previewTitle"></h4></div><div class="panel-body" ng-bind-html="::content" data-cy="terms-preview-modal-content"></div><div class="panel-footer" style="height: 64px"><button type="button" class="btn btn-default pull-right" ng-click="$close()" data-cy="terms-preview-modal-close" translate="generalTerms.close"></button></div></div>');
$templateCache.put('app/pages/administration/terms/terms.html','<div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title"><span translate="generalTerms.terms"></span> <button class="btn btn-default btn-with-icon pull-right" ng-disabled="$ctrl.form.content.$invalid || !$ctrl.termsContent" ng-click="$ctrl.showPreview($ctrl.termsContent, (\'generalTerms.terms\' | translate))" data-cy="terms-preview"><i class="ion-search"></i><span translate="generalTerms.overallPreview"></span></button></h3></div><div class="panel-body"><form name="$ctrl.form" ng-submit="$ctrl.save(\'terms\')"><div class="row"><div class="col-md-8"><div class="form-group arno-markdown-editor"><textarea class="form-control administration__terms__terms-edit__input" id="termsContent" name="content" markdown-editor="$ctrl.markdownEditorConfig" data-cy="terms-content" ng-model="$ctrl.termsContent" placeholder="{{ \'modules.administration.adminTerms.capturedTerms\' |translate }}"></textarea></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div><br><div class="row btns-row"><div class="col-sm-12"><button type="button" class="btn btn-default btn-with-icon" ng-disabled="$ctrl.termsContent === $ctrl.termsPristine" ng-click="$ctrl.termsContent = $ctrl.termsPristine" data-cy="terms-reset"><i class="ion-refresh"></i><span translate="generalTerms.reset"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$ctrl.form.OrganizationName.$invalid || $ctrl.termsContent === $ctrl.termsPristine" data-cy="terms-save"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-default btn-with-icon pull-right hidden-md hidden-lg" ng-click="$ctrl.showSyntax()"><i class="ion-help"></i><span translate="generalTerms.syntax"></span></button></div></div></form></div></div><div class="panel animated zoomIn" ng-if="$ctrl.organizationId !== 1"><div class="panel-heading clearfix"><h3 class="panel-title"><span translate="generalTerms.dataPrivacy"></span> <button class="btn btn-default btn-with-icon pull-right" ng-disabled="$ctrl.form.content.$invalid || !$ctrl.privacyTermsContent" ng-click="$ctrl.showPreview($ctrl.privacyTermsContent, (\'generalTerms.dataPrivacy\' | translate))" data-cy="agreement-preview"><i class="ion-search"></i><span translate="generalTerms.overallPreview"></span></button></h3></div><div class="panel-body"><form name="$ctrl.form" ng-submit="$ctrl.save(\'privacyTerms\')"><div class="row"><div class="col-md-8"><div class="form-group arno-markdown-editor"><textarea class="form-control administration__terms__privacy-terms-edit__input" id="privacyTermsContent" name="content" markdown-editor="$ctrl.markdownEditorConfig" data-cy="privacy-content" ng-model="$ctrl.privacyTermsContent" placeholder="{{ \'modules.administration.adminTerms.canCapturedTerms\' |translate }}"></textarea></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div><br><div class="row btns-row"><div class="col-sm-12"><button type="button" class="btn btn-default btn-with-icon" ng-disabled="$ctrl.privacyTermsContent === $ctrl.privacyTermsPristine" ng-click="$ctrl.privacyTermsContent = $ctrl.privacyTermsPristine" data-cy="agreement-reset"><i class="ion-refresh"></i><span translate="generalTerms.reset"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$ctrl.form.OrganizationName.$invalid || $ctrl.privacyTermsContent === $ctrl.privacyTermsPristine" data-cy="agreement-save"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-default btn-with-icon pull-right hidden-md hidden-lg" ng-click="$ctrl.showSyntax()"><i class="ion-help"></i><span translate="generalTerms.syntax"></span></button></div></div></form></div></div><div class="panel animated zoomIn" ng-if="$ctrl.organizationId !== 1"><div class="panel-heading clearfix"><h3 class="panel-title"><span translate="modules.administration.adminTerms.notesOnDataStorage"></span> <button class="btn btn-default btn-with-icon pull-right" ng-disabled="$ctrl.form.content.$invalid || !$ctrl.exportPrivacyNote" ng-click="$ctrl.showPreview($ctrl.exportPrivacyNoteContent, (\'modules.administration.adminTerms.notesOnDataStorage\' | translate))"><i class="ion-search"></i><span translate="generalTerms.overallPreview"></span></button></h3></div><div class="panel-body"><form name="$ctrl.form" ng-submit="$ctrl.save(\'privacyNote\')"><div class="row"><div class="col-md-8"><div class="form-group arno-markdown-editor"><textarea class="form-control administration__terms__export-privacy-note-edit__input" id="exportPrivacyNoteContent" name="content" markdown-editor="$ctrl.markdownEditorConfig" ng-model="$ctrl.exportPrivacyNoteContent" placeholder="{{ \'modules.administration.adminTerms.canCapturedTermsData\' |translate }}"></textarea></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div><br><div class="row btns-row"><div class="col-sm-12"><button type="button" class="btn btn-default btn-with-icon" ng-disabled="$ctrl.exportPrivacyNoteContent === $ctrl.exportPrivacyNotePristine" ng-click="$ctrl.exportPrivacyNoteContent = $ctrl.exportPrivacyNotePristine"><i class="ion-refresh"></i><span translate="generalTerms.reset"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$ctrl.form.OrganizationName.$invalid || $ctrl.exportPrivacyNoteContent === $ctrl.exportPrivacyNotePristine"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-default btn-with-icon pull-right hidden-md hidden-lg" ng-click="$ctrl.showSyntax()"><i class="ion-help"></i><span translate="generalTerms.syntax"></span></button></div></div></form></div></div><div class="panel animated zoomIn" ng-if="$ctrl.organizationId !== 1"><div class="panel-heading clearfix"><h3 class="panel-title"><span translate="modules.administration.adminTerms.thirdPartyPrivayNote"></span> <button class="btn btn-default btn-with-icon pull-right" ng-disabled="$ctrl.form.content.$invalid || !$ctrl.EmergencyContactPrivacyTermsContent" ng-click="$ctrl.showPreview($ctrl.EmergencyContactPrivacyTermsContent, (\'modules.administration.adminTerms.thirdPartyPrivayNote\' | translate))"><i class="ion-search"></i><span translate="generalTerms.overallPreview"></span></button></h3></div><div class="panel-body"><form name="$ctrl.form" ng-submit="$ctrl.save(\'EmergencyContactPrivacyTerms\')"><div class="row"><div class="col-md-8"><div class="form-group arno-markdown-editor"><textarea class="form-control administration__terms__export-privacy-note-edit__input" id="EmergencyContactPrivacyTermsContent" name="content" markdown-editor="$ctrl.markdownEditorConfig" ng-model="$ctrl.EmergencyContactPrivacyTermsContent" placeholder="{{ \'modules.administration.adminTerms.thirdPartyPlaceholder\' | translate }}"></textarea></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div><br><div class="row btns-row"><div class="col-sm-12"><button type="button" class="btn btn-default btn-with-icon" ng-disabled="$ctrl.EmergencyContactPrivacyTermsContent === $ctrl.EmergencyContactPrivacyTermsPristine" ng-click="$ctrl.EmergencyContactPrivacyTermsContent = $ctrl.EmergencyContactPrivacyTermsPristine"><i class="ion-refresh"></i><span translate="generalTerms.reset"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="$ctrl.form.OrganizationName.$invalid || $ctrl.EmergencyContactPrivacyTermsContent === $ctrl.EmergencyContactPrivacyTermsPristine"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-default btn-with-icon pull-right hidden-md hidden-lg" ng-click="$ctrl.showSyntax()"><i class="ion-help"></i><span translate="generalTerms.syntax"></span></button></div></div></form></div></div>');
$templateCache.put('app/pages/administration/terms/updateTerms.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminTerms.aggainApproval"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminTerms.agreeToChangeConsent"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" data-cy="terms-update-no-re-approve" translate="modules.administration.adminTerms.btnNo"></button> <button type="button" class="btn btn-danger" ng-click="$close()" data-cy="terms-update-re-approve" translate="modules.administration.adminTerms.btnYes"></button></div></div>');
$templateCache.put('app/pages/administration/welcomepage/preview.modal.tpl.html','<div><div class="panel animated"><div class="panel-heading pb-0"><h3 class="panel-title"><div ng-bind-html="welcomeTitleContentText"></div></h3></div><div class="panel-body pl-20 pr-20"><div ng-bind-html="welcomeTextContentText"></div></div><div class="row"><div class="col-xs-12 pb-15"><div class="col-xs-12"><button type="button" class="btn btn-default pull-right" ng-click="$close()" data-cy="welcomepage-preview-modal-close" translate="generalTerms.close"></button></div></div></div></div></div>');
$templateCache.put('app/pages/administration/welcomepage/welcomepage.tpl.html','<div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title"><span translate="modules.administration.adminWelcom.textOfWelcomPage"></span> <button class="btn btn-default btn-with-icon pull-right" ng-disabled="$ctrl.form.welcomeTitleContent.$invalid || $ctrl.form.welcomeTextContent.$invalid || (!$ctrl.welcomeTitleContent && !$ctrl.welcomeTextContent)" ng-click="$ctrl.showPreview($ctrl.welcomeTitleContent, $ctrl.welcomeTextContent)" data-cy="welcome-text-preview"><i class="ion-search"></i><span translate="modules.administration.adminWelcom.previewOfWelcomPage"></span></button></h3></div><div class="panel-body"><form name="$ctrl.form" ng-submit="$ctrl.save()"><div class="row"><div class="col-md-8"><div class="form-group administration__welcomepage__intro-title-edit"><h5 translate="modules.administration.adminWelcom.introTitle"></h5><textarea class="form-control administration__welcomepage__intro-title-edit__input --vresize" name="welcomeTitleContent" markdown-editor="$ctrl.markdownEditorConfig" data-cy="welcome-title-content" ng-model="$ctrl.welcomeTitleContent" placeholder="{{ \'modules.administration.adminWelcom.titlePlaceholder\' |translate }}"></textarea></div><div class="form-group administration__welcomepage__intro-text-edit mt-20"><h5 translate="modules.administration.adminWelcom.introText"></h5><textarea class="form-control administration__welcomepage__intro-text-edit__input --vresize" markdown-editor="$ctrl.markdownEditorConfig" name="welcomeTextContent" data-cy="welcome-text-content" ng-model="$ctrl.welcomeTextContent" placeholder="{{ \'modules.administration.adminWelcom.titlePlaceholder\' |translate }}"></textarea></div><div class="form-group"></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div><br><div class="row btns-row"><div class="col-sm-12"><button type="button" class="btn btn-default btn-with-icon" ng-disabled="$ctrl.welcomeTextContent === $ctrl.welcomeTextPristine && $ctrl.welcomeTitleContent === $ctrl.welcomeTitlePristine" ng-click="$ctrl.welcomeTextContent = $ctrl.welcomeTextPristine" data-cy="welcome-text-reset"><i class="ion-refresh"></i><span translate="generalTerms.reset"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" data-cy="welcome-text-save"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-default btn-with-icon pull-right hidden-md hidden-lg" ng-click="$ctrl.showSyntax()"><i class="ion-help"></i><span translate="generalTerms.syntax"></span></button></div></div></form></div></div>');
$templateCache.put('app/pages/arnoAdministration/export/chooseExportTypeModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">Dateityp des Exportes w\xE4hlen</h4></div><div class="modal-body"><form name="groupForm"><div class="form-group"><ui-select ng-model="$chooseExportTypeCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $chooseExportTypeCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $chooseExportTypeCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <span><button type="button" class="btn btn-primary" ng-click="$chooseExportTypeCtrl.applyModal()">Herunterladen</button></span></div></div>');
$templateCache.put('app/pages/contacts/businessPartners/businessPartnerDetails.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-title="$ctrl.getTitle() | translate" ba-panel-division-selector="$ctrl.businessPartner.DivisionId != null || $ctrl.currentDivisionId != null ? true : false" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-namespace="contactsBusinessPartners" ba-panel-division-selector-entry-permission="arno.contacts.businessPartners.view" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><form id="businessPartnerDetailsForm" name="businessPartnerDetailsForm" novalidate="" angular-validator="" angular-validator-submit="$ctrl.save(businessPartnerDetailsForm)"><fieldset class="block"><h4 class="with-line" toggle-next="">{{ \'modules.contacts.businessPartners.details.generalDataSection\' | translate}}</h4><fieldset class="row" ng-disabled="!($ctrl.isNew() && ($ctrl.hasDivManagePermission || $ctrl.hasOrgManagePermission) || $ctrl.businessPartner.DivisionId != null && $ctrl.hasDivManagePermission || $ctrl.businessPartner.DivisionId == null && $ctrl.hasOrgManagePermission) || $ctrl.businessPartner.IsInternal == true"><div class="col-xs-12 col-md-7"><div class="row"><div class="col-xs-12"><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.nameInput.$invalid}"><label for="nameInput" class="control-label required-label" translate="modules.contacts.businessPartners.details.nameFieldLabel">Name</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.Name" ng-model-options="{ debounce: 500 }" class="form-control" id="nameInput" name="nameInput" placeholder="{{ \'modules.contacts.businessPartners.details.nameFieldLabel\' | translate }}" required="" required-message="\'\'"> <span ng-show="businessPartnerDetailsForm.nameInput.$error.required" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.nameFieldRequiredError">Name der Organisation fehlt!</span></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="tradeNameInput" translate="modules.contacts.businessPartners.details.tradeNameFieldLabel">Handelsname</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.TradeName" ng-model-options="{ debounce: 500 }" class="form-control" id="tradeNameInput" name="tradeNameInput" placeholder="{{ \'modules.contacts.businessPartners.details.tradeNameFieldLabel\' | translate }}"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.EMailInput.$invalid}"><label for="EMailInput">E-Mail</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.EMail" ng-model-options="{ debounce: 500 }" class="form-control" id="EMailInput" validator="{{ $ctrl.businessPartner.EMail.length > 0 ? $ctrl.validEMail($ctrl.businessPartner.EMail) : true }}" name="EMailInput" placeholder="{{ modules.contacts.businessPartners.details.EMailFieldLabel }}"></div></div><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.OtherLegalInformationInput.$invalid}"><label for="OtherLegalInformationInput" translate="modules.contacts.businessPartners.details.OtherLegalInformation">Weitere rechtliche Informationen</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.OtherLegalInformation" ng-model-options="{ debounce: 500 }" class="form-control" id="OtherLegalInformationInput" name="OtherLegalInformationInput" placeholder="{{ modules.contacts.businessPartners.details.OtherLegalInformationFieldLabel }}"></div></div><div class="col-xs-12"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.CommentInput.$invalid}"><label for="CommentInput" translate="modules.contacts.businessPartners.details.Comment">Kommentar</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.Comment" ng-model-options="{ debounce: 500 }" class="form-control" id="CommentInput" name="CommentInput" placeholder="{{ modules.contacts.businessPartners.details.CommentFieldLabel }}"></div></div></div></div></div></div><div class="col-xs-12 col-md-5"><arno-ba-address class="block" address="$ctrl.businessPartner" form-ref="businessPartnerDetailsForm" country-ids-catalogue="$ctrl.CAT_COUNTRY_IDS" fields-config="$ctrl.addressCompFieldsConfig" ui-config="$ctrl.addressCompUiConfig" view-only="false"></arno-ba-address></div></fieldset><h4 class="with-line" toggle-next="financeTgl">{{ \'modules.contacts.businessPartners.details.financeDataSection\' | translate}}</h4><fieldset class="row" ng-disabled="!($ctrl.isNew() && ($ctrl.hasDivManagePermission || $ctrl.hasOrgManagePermission) || $ctrl.businessPartner.DivisionId != null && $ctrl.hasDivManagePermission || $ctrl.businessPartner.DivisionId == null && $ctrl.hasOrgManagePermission) || $ctrl.businessPartner.IsInternal == true"><div class="col-xs-12"><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.taxIdentInput.$invalid}"><label for="taxIdentInput" class="control-label" translate="modules.contacts.businessPartners.details.taxIdentFieldLabel">Steuernummer</label> <input type="text" maxlength="255" ng-model="$ctrl.businessPartner.TaxIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="taxIdentInput" name="taxIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.taxIdentFieldLabel\' | translate }}" ui-validate-async="{ taxIdentExists: \'$ctrl.checkIsUniqTaxIdent($value)\' }" required-message="\'\'"> <span ng-show="businessPartnerDetailsForm.$error.taxIdentExists" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.taxIdentFieldErrorExists">Steuernummer existiert bereits!</span></div></div><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.vatIdentInput.$invalid}"><label for="vatIdentInput" translate="modules.contacts.businessPartners.details.vatIdentFieldLabel">Umsatzsteuer ID</label> <input type="text" maxlength="255" ng-model="$ctrl.businessPartner.VatIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="vatIdentInput" name="vatIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.vatIdentFieldLabel\' | translate }}" ui-validate-async="{ vatIdentExists: \'$ctrl.checkIsUniqVatIdent($value)\' }" invalid-message="\'\'"> <span ng-show="businessPartnerDetailsForm.$error.vatIdentExists" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.vatIdentFieldErrorExists">Umsatzsteuer-ID existiert bereits!</span></div></div></div></div><div class="col-xs-12"><div class="row"><div class="col-xs-12 col-sm-6" ng-class="{ \'col-sm-6\': $ctrl.businessPartner.DivisionId == null && $ctrl.currentDivisionId == null }"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.legalRegIdentInput.$invalid}"><label for="legalRegIdentInput" translate="modules.contacts.businessPartners.details.legalRegIdentFieldLabel">Registernummer</label> <input type="text" maxlength="255" ng-model="$ctrl.businessPartner.LegalRegistrationIdentifier" ng-model-options="{ allowInvalid: true, debounce: 500 }" class="form-control" id="legalRegIdentInput" name="legalRegIdentInput" placeholder="{{ \'modules.contacts.businessPartners.details.legalRegIdentFieldLabel\' | translate }}" ui-validate-async="{ legalRegIdentExists: \'$ctrl.checkIsUniqLegalRegIdent($value)\' }" invalid-message="\'\'"> <span ng-show="businessPartnerDetailsForm.$error.legalRegIdentExists" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.legalRegIdentFieldErrorExists">Registernummer existiert bereits!</span></div></div><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.ElectricAdressInput.$invalid}"><label for="ElectricAdressInput" translate="modules.contacts.businessPartners.details.ElectricAddress">Elektronische Adresse</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.ElectricAdress" ng-model-options="{ debounce: 500 }" class="form-control" id="ElectricAdressInput" name="ElectricAdressInput" placeholder="{{ modules.contacts.businessPartners.details.ElectricAdressFieldLabel }}"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="BankNameInput" translate="modules.contacts.businessPartners.details.BankName">Name der Bank</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.BankName" ng-model-options="{ debounce: 500 }" class="form-control" id="BanknameInput" name="BanknameInput" placeholder="{{ modules.contacts.businessPartners.details.BankNameFieldLabel }}"></div></div><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.CustomerNumberInput.$invalid}"><label for="CustomerNumberInput" class="control-label" ng-class="{ \'required-label\': $ctrl.businessPartner.IsSeller == true || $ctrl.businessPartner.IsBuyer == true || $ctrl.businessPartnerDivisionLinkData.IsSeller == true || $ctrl.businessPartnerDivisionLinkData.IsBuyer == true }" translate="modules.contacts.businessPartners.details.CustomerNumber">Kundennummer</label> <input ng-disabled="$ctrl.businessPartner.CustomerNumberIsDebtorNumber" type="text" maxlength="1000" ng-model="$ctrl.businessPartner.CustomerNumber" ng-model-options="{ debounce: 500 }" class="form-control" id="CustomerNumberInput" name="CustomerNumberInput" placeholder="{{ modules.contacts.businessPartners.details.CustomerNumberFieldLabel }}" ui-validate="{ required: \'$ctrl.checkRequiredCustomerNumber($value)\' }" ui-validate-watch-collection="\'[ $ctrl.businessPartner.IsSeller, $ctrl.businessPartner.IsBuyer, $ctrl.businessPartnerDivisionLinkData.IsSeller, $ctrl.businessPartnerDivisionLinkData.IsBuyer, ]\'" required-message="\'\'"> <span ng-show="businessPartnerDetailsForm.CustomerNumberInput.$error.required" class="help-block error-block basic-block mt-4 --color-danger" translate="modules.contacts.businessPartners.details.CustomerNumberFieldRequiredError">Kundennummer fehlt!</span><div><input type="checkbox" ng-model="$ctrl.businessPartner.CustomerNumberIsDebtorNumber" id="CustomerNumberIsDebtorNumber" name="CustomerNumberIsDebtorNumber"> <span for="CustomerNumberIsDebtorNumber">{{\'modules.contacts.businessPartners.details.customerNumberIsDebtorNumber\' | translate }}</span><arno-ba-help-tooltip text="{{\'modules.contacts.businessPartners.details.customerNumberIsDebtorNumberTtip\' | translate }}"></arno-ba-help-tooltip></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.IbanInput.$invalid}"><label for="IbanInput" translate="modules.contacts.businessPartners.details.Iban">IBAN</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.Iban" ng-model-options="{ debounce: 500 }" class="form-control" id="IbanInput" name="IbanInput" validator="{{ $ctrl.businessPartner.Iban.length > 0 ? $ctrl.validIBAN($ctrl.businessPartner.Iban) : true }}" placeholder="{{ modules.contacts.businessPartners.details.IbanFieldLabel }}"></div></div><div class="col-xs-12 col-sm-6"><div class="form-group" ng-class="{\'has-error\': businessPartnerDetailsForm.BicInput.$invalid}"><label for="BicInput" translate="modules.contacts.businessPartners.details.Bic">BIC</label> <input type="text" maxlength="1000" ng-model="$ctrl.businessPartner.Bic" ng-model-options="{ debounce: 500 }" class="form-control" id="BicInput" name="BicInput" validator="{{ $ctrl.businessPartner.Bic.length > 0 ? $ctrl.validBIC($ctrl.businessPartner.Bic) : true }}" placeholder="{{ modules.contacts.businessPartners.details.BicFieldLabel }}"></div></div></div></div></fieldset><div class="row mt-12"><div class="col-xs-12"><business-partner-duplicates business-partner="$ctrl.businessPartner" division-id="$ctrl.currentDivisionId" strict-mode="!$ctrl.isNew()" allow-add-linking="$ctrl.currentDivisionId" header-title="$ctrl.isNew() ? \'modules.contacts.businessPartners.duplicatesComp.titleNew\' : \'modules.contacts.businessPartners.duplicatesComp.titleEdit\'"></business-partner-duplicates></div></div><h4 ng-if="$ctrl.businessPartnerDivisionLinkData.DivisionId || $ctrl.isNew()" class="with-line mt-20" toggle-next="">{{ \'modules.contacts.businessPartners.details.divisionLinkingTitle\' | translate:{ divisionName: $ctrl.currentDivisionLink.Name } }}</h4><div ng-if="($ctrl.businessPartnerDivisionLinkData.DivisionId || $ctrl.isNew())" class="row"><div class="col-xs-12"><fieldset ng-disabled="!($ctrl.isNew() && ($ctrl.hasDivManagePermission || $ctrl.hasOrgManagePermission) || $ctrl.businessPartner.DivisionId != null && $ctrl.hasDivManagePermission || $ctrl.businessPartner.DivisionId == null && $ctrl.hasOrgManagePermission)" class="row"><div class="col-xs-12"><div class="form-group"><div ng-if="$ctrl.currentDivisionId != null"><label class="checkbox-inline custom-checkbox nowrap mt-8 mr-20"><input type="checkbox" ng-model="$ctrl.businessPartnerDivisionLinkData.IsBuyer"> <span translate="modules.contacts.businessPartners.details.isBuyerFieldLabel">Auftraggeber</span></label> <label class="checkbox-inline custom-checkbox nowrap mt-8 mr-20"><input type="checkbox" ng-model="$ctrl.businessPartnerDivisionLinkData.IsSeller"> <span translate="modules.contacts.businessPartners.details.isSellerFieldLabel">Auftragnehmer</span></label> <label class="checkbox-inline custom-checkbox nowrap mt-8 ml-0"><input type="checkbox" ng-model="$ctrl.businessPartnerDivisionLinkData.IsMaterialProvider"> <span translate="modules.contacts.businessPartners.details.isMaterialProviderFieldLabel">Material</span></label></div><div ng-if="$ctrl.businessPartner.DivisionId == null && $ctrl.currentDivisionId == null"><label class="checkbox-inline custom-checkbox nowrap mt-8 mr-20"><input type="checkbox" ng-model="$ctrl.businessPartner.IsBuyer"> <span translate="modules.contacts.businessPartners.details.isBuyerFieldLabel">Auftraggeber</span></label> <label class="checkbox-inline custom-checkbox nowrap mt-8 mr-20"><input type="checkbox" ng-model="$ctrl.businessPartner.IsSeller"> <span translate="modules.contacts.businessPartners.details.isSellerFieldLabel">Auftragnehmer</span></label> <label class="checkbox-inline custom-checkbox nowrap mt-8 ml-0"><input type="checkbox" ng-model="$ctrl.businessPartner.IsMaterialProvider"> <span translate="modules.contacts.businessPartners.details.isMaterialProviderFieldLabel">Material</span></label></div></div></div></fieldset></div></div><h4 ng-if="$ctrl.hasViewPermission && !$ctrl.isNew() && $ctrl.businessPartner.DivisionId != null" class="with-line mt-20" toggle-next="">{{ \'modules.contacts.businessPartners.details.titleBusinessPartnerDivisions\' | translate}}</h4><div ng-if="$ctrl.hasViewPermission && !$ctrl.isNew() && $ctrl.businessPartner.DivisionId != null" class="row"><div class="table-responsive col-xs-12"><table st-table="$ctrl.businessPartner.Divisions" class="table table-condensed"><thead><tr class="sortable"><th st-sort="Name" st-sort-default="true">{{ \'modules.contacts.businessPartners.details.divNameCol\' | translate }}</th><th class="text-center">{{ \'modules.contacts.businessPartners.details.isBuyerCol\' | translate }}</th><th class="text-center">{{ \'modules.contacts.businessPartners.details.isSellerCol\' | translate }}</th><th class="text-center">{{ \'modules.contacts.businessPartners.details.isMaterialProviderCol\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="division in $ctrl.businessPartner.Divisions"><td>{{ division.Name || "" }}</td><td class="text-center"><span><i ng-if="division.DivisionsLinkedBusinessPartners.IsBuyer" class="fa fa-check color-success"></i></span></td><td class="text-center"><span><i ng-if="division.DivisionsLinkedBusinessPartners.IsSeller" class="fa fa-check color-success"></i></span></td><td class="text-center"><span><i ng-if="division.DivisionsLinkedBusinessPartners.IsMaterialProvider" class="fa fa-check color-success"></i></span></td></tr><tr ng-if="$ctrl.ctx.length && $ctrl.businessPartner.Divisions.length === 0"><td class="text-center" colspan="99"><i translate="modules.contacts.businessPartners.details.noLinks">Keine Verlinkungen vorhanden</i></td></tr></tbody></table></div></div><h4 ng-if="$ctrl.permittedToViewContacts && !$ctrl.isNew() && $ctrl.contacts.length" class="with-line mt-20" toggle-next="">{{ \'modules.contacts.businessPartners.details.titleBusinessPartnerContacts\' | translate}}</h4><div ng-if="$ctrl.permittedToViewContacts && !$ctrl.isNew() && $ctrl.contacts.length" class="row"><div class="table-responsive col-xs-12"><table st-safe-src="$ctrl.contacts" st-table="$ctrl.displayedCollection" class="table table-condensed"><thead><tr class="sortable"><th st-sort="Function" st-sort-default="true">{{ \'modules.contacts.contactManagement.contact.function\' | translate }}</th><th st-sort="FirstName">{{ \'generalTerms.firstName\' | translate }}</th><th st-sort="LastName">{{ \'generalTerms.lastName\' | translate }}</th><th st-sort="MailAddress">{{ \'generalTerms.email\' | translate }}</th><th st-sort="Division" ng-if="$ctrl.ctx[0] === \'rootOrg\'">{{ \'generalTerms.division\' | translate }}</th><th></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Function" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MailAddress" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$ctrl.ctx[0] === \'rootOrg\'"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="contact in $ctrl.displayedCollection"><td>{{ contact.Function || "" }}</td><td>{{ contact.FirstName || "" }}</td><td>{{ contact.LastName || "" }}</td><td>{{ contact.MailAddress || "" }}</td><td ng-if="$ctrl.ctx[0] === \'rootOrg\'">{{ contact.Division || "" }}</td><td><button type="button" ng-click="$ctrl.gotoContact(contact)" class="btn btn-default btn-with-icon btn-xs ml-8" title="{{ ::(\'generalTerms.call\' | translate) }}"><i class="fa fa-external-link"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.call">Aufrufen</span></button></td></tr><tr ng-if="$ctrl.ctx.length && $ctrl.displayedCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.contacts.businessPartners.details.noContacts">Keine Kontakte vorhanden</i></td></tr></tbody></table></div></div></fieldset><div class="row btns-row"><div class="col-xs-12 mt-20 mb-0 d-flex"><button type="button" class="btn btn-default btn-with-icon" ng-click="$ctrl.back()"><i class="ion-chevron-left font-size-12"></i> <span translate="generalTerms.back">Zur\xFCck</span></button> <span class="flex-grow-1"></span> <button ng-if="$ctrl.hasDivManagePermission && !$ctrl.isNew() && $ctrl.businessPartner.DivisionId != null" type="button" ng-click="$ctrl.toggleBusinessPartnerLinking($ctrl.businessPartner)" class="btn btn-with-icon" ng-class="{ \'btn-danger\': $ctrl.isLinkedWithCurrentDivision, \'btn-success\': !$ctrl.isLinkedWithCurrentDivision }" title="{{ ::(($ctrl.isLinkedWithCurrentDivision ? \'modules.contacts.businessPartners.overview.linkingRemoveBtnLabel\' : \'modules.contacts.businessPartners.overview.linkingAddBtnLabel\') | translate) }}"><i class="fa" ng-class="{ \'fa-link\': !$ctrl.isLinkedWithCurrentDivision, \'fa-chain-broken\': $ctrl.isLinkedWithCurrentDivision }"></i> <span class="hidden-xs" translate="{{ $ctrl.isLinkedWithCurrentDivision ? \'generalTerms.remove\' : \'generalTerms.add\' }}">Hinzuf\xFCgen</span></button> <button ng-if="!$ctrl.isNew() && $ctrl.hasOrgManagePermission && $ctrl.businessPartner.DivisionId == null" type="button" ng-click="$ctrl.deleteOrgBusinessPartner($ctrl.businessPartner)" class="btn btn-danger btn-with-icon btn-xs"><i class="ion-ios-trash"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.delete">L\xF6schen</span></button> <button ng-if="$ctrl.isNew() && (($ctrl.hasDivManagePermission || $ctrl.hasOrgManagePermission) || ($ctrl.businessPartner.DivisionId != null && $ctrl.hasDivManagePermission) || ($ctrl.businessPartner.DivisionId == null && $ctrl.hasOrgManagePermission))" type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openDivSelector()"><i class="fa fa-sitemap"></i> <span translate="modules.contacts.businessPartners.details.searchDivBtnLabel">Gliederung Verkn\xFCpfen</span></button> <button ng-if="$ctrl.isNew() && ($ctrl.hasDivManagePermission || $ctrl.hasOrgManagePermission) || ($ctrl.businessPartner.DivisionId != null && $ctrl.hasDivManagePermission) || ($ctrl.businessPartner.DivisionId == null && $ctrl.hasOrgManagePermission)" type="submit" class="btn btn-primary btn-with-icon" ng-disabled="!businessPartnerDetailsForm.$dirty || businessPartnerDetailsForm.$invalid"><i class="ion-checkmark"></i> <span translate="{{$ctrl.isNew() ? \'modules.contacts.businessPartners.details.addBtnLabel\' : \'generalTerms.save\'}}">Speichern</span></button></div></div></form></div></div></div>');
$templateCache.put('app/pages/contacts/businessPartners/businessPartners.html','<div class="row arno-contacts-businesspartners"><div ng-if="$ctrl.hasDivViewPermission" class="col-xs-12"><div ba-panel="" ba-panel-title="\'modules.contacts.businessPartners.overview.titleLinkedBusinessPartners\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-namespace="contactsBusinessPartners" ba-panel-division-selector-entry-permission="arno.contacts.businessPartners.view" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-xs-12"><div class="arno-contacts-businesspartners-panel-header"><div class="btn-toolbar pull-left"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ $ctrl.currentTableConf.hasViewModifications ? (\'generalTerms.currentView\' | translate) : $ctrl.currentTableConf.selectedView===\'0\' ? (\'generalTerms.defaultView\' | translate) : $ctrl.currentTableConf.customViews[$ctrl.currentTableConf.selectedView].Name }} <span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem"><a href="" ng-if="$ctrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$ctrl.changeListView($ctrl.currentTableConf, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in $ctrl.currentTableConf.customViews"><a href="" ng-click="$ctrl.changeListView($ctrl.currentTableConf, val, key)">{{ val.Name }}</a></li></ul></div><button class="btn btn-default btn-with-icon mr-12" ng-click="$ctrl.openTableConfig($ctrl.currentTableConf)" ng-class="{\'disabled\': !$ctrl.hasConfigurePermission }"><i class="ion-wrench"></i></button></div><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="controls.table.itemsPerPage">Ergebnisse pro Seite</span> ({{ $ctrl.currentTableConf.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize($ctrl.currentTableConf, i)">{{ i }}</a></li></ul></div></div><div class="btn-toolbar pull-right"><button class="btn btn-primary btn-with-icon" ng-if="$ctrl.hasDivManagePermission" ng-click="$ctrl.addBusinessPartner()"><i class="ion-plus"></i> <span class="hidden-xs" translate="modules.contacts.businessPartners.addBtnLabel">Organisation hinzuf\xFCgen</span></button></div></div></div></div><div class="row mt-20"><div class="col-xs-12"><div class="table-responsive arno-contacts-businesspartners-table"><table st-table="$ctrl.currentTableConf.displayedCollection" st-pipe="$ctrl.currentTableConf.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Name" st-sort-default="true">{{ \'modules.contacts.businessPartners.overview.nameCol\' | translate}}</th><th st-sort="TradeName" ng-show="$ctrl.currentTableConf.tableConfig.TradeName">{{ \'modules.contacts.businessPartners.overview.tradeNameCol\' | translate}}</th><th ng-show="$ctrl.currentTableConf.tableConfig.City" st-sort="City">{{ \'modules.contacts.businessPartners.overview.cityCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.CountryId" st-sort="CountryId">{{ \'modules.contacts.businessPartners.overview.countryCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.ZIP" st-sort="ZIP">{{ \'modules.contacts.businessPartners.overview.zipCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.Street" st-sort="Street">{{ \'modules.contacts.businessPartners.overview.streetCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.HouseNumber" st-sort="HouseNumber">{{ \'modules.contacts.businessPartners.overview.houseNumberCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.TaxIdentifier" st-sort="TaxIdentifier">{{ \'modules.contacts.businessPartners.overview.taxIdentCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.LegalRegistrationIdentifier" st-sort="LegalRegistrationIdentifier">{{ \'modules.contacts.businessPartners.overview.legalRegIdentCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.VatIdentifier" st-sort="VatIdentifier">{{ \'modules.contacts.businessPartners.overview.vatIdentCol\' | translate }}</th><th ng-show="$ctrl.currentTableConf.tableConfig.CustomerNumber" st-sort="CustomerNumber">Kundennummer</th><th ng-show="$ctrl.currentTableConf.tableConfig.IsBuyer" translate="modules.contacts.businessPartners.overview.isBuyerCol">Auftraggeber</th><th ng-show="$ctrl.currentTableConf.tableConfig.IsSeller" translate="modules.contacts.businessPartners.overview.isSellerCol">Auftragnehmer</th><th ng-show="$ctrl.currentTableConf.tableConfig.IsMaterialProvider" translate="modules.contacts.businessPartners.overview.isMaterialProviderCol">Material</th><th ng-show="$ctrl.hasDivManagePermission" translate="modules.contacts.businessPartners.overview.actionsCol" class="text-right">Aktionen</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.TradeName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="TradeName" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.City"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="City" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.CountryId"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="CountryId" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.ZIP"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="ZIP" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.Street"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Street" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.HouseNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="HouseNumber" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.TaxIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="TaxIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.LegalRegistrationIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LegalRegistrationIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.VatIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="VatIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.CustomerNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="CustomerNumber" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.currentTableConf.tableConfig.IsBuyer" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.currentTableConf.showBuyers"> <span></span></label></th><th ng-show="$ctrl.currentTableConf.tableConfig.IsSeller" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.currentTableConf.showSellers"> <span></span></label></th><th ng-show="$ctrl.currentTableConf.tableConfig.IsMaterialProvider" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.currentTableConf.showMaterialProviders"> <span></span></label></th><th ng-show="$ctrl.hasDivManagePermission"></th></tr></thead><tbody><tr ng-if="$ctrl.currentTableConf.displayedCollection" ng-repeat="businessPartner in $ctrl.currentTableConf.displayedCollection" class="editable-row" ng-class="{\'arno-pointing-pointer\': $ctrl.hasDivManagePermission}" ng-click="$ctrl.editBusinessPartner(businessPartner)"><td><i ng-if="businessPartner.IsInternal" class="fa fa-sitemap" title="{{ ::(\'modules.contacts.businessPartners.overview.systemDivisionBusinessPartnerTooltip\' | translate) }}"></i> <i ng-if="!businessPartner.IsInternal" class="ion-ios-people-outline" title="{{ ::(\'modules.contacts.businessPartners.overview.divisionBusinessPartnerTooltip\' | translate) }}"></i> <span ng-if="businessPartner.IsInternal">({{ ::$ctrl.orgName }})</span> <span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.Name || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.Name || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.TradeName"><span ng-if="!businessPartner.IsInternal">{{ businessPartner.TradeName || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.City"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.City || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.City || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.CountryId"><span ng-if="businessPartner.IsInternal">{{ $ctrl.getCountryByMapping(businessPartner.OwnerDivision.CountryId) || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ $ctrl.getCountryByMapping(businessPartner.CountryId) || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.ZIP"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.ZipCode || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.ZIP || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.Street"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.Street || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.Street || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.HouseNumber"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.HouseNumber || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.HouseNumber || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.TaxIdentifier"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.TaxIdentifier || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.TaxIdentifier || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.LegalRegistrationIdentifier"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.LegalRegistrationIdentifier || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.LegalRegistrationIdentifier || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.VatIdentifier"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.VatIdentifier || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.VatIdentifier || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.CustomerNumber"><span ng-if="businessPartner.IsInternal">{{ businessPartner.OwnerDivision.CustomerNumber || "" }}</span> <span ng-if="!businessPartner.IsInternal">{{ businessPartner.CustomerNumber || "" }}</span></td><td ng-show="$ctrl.currentTableConf.tableConfig.IsBuyer" class="text-center"><span><i ng-if="businessPartner.DivisionId && businessPartner.Divisions[0].DivisionsLinkedBusinessPartners.IsBuyer" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.currentTableConf.tableConfig.IsSeller" class="text-center"><span><i ng-if="businessPartner.DivisionId && businessPartner.Divisions[0].DivisionsLinkedBusinessPartners.IsSeller" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.currentTableConf.tableConfig.IsMaterialProvider" class="text-center"><span><i ng-if="businessPartner.DivisionId && businessPartner.Divisions[0].DivisionsLinkedBusinessPartners.IsMaterialProvider" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.hasDivManagePermission" class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.preventPropagation($event)"><div class="pull-right"><button ng-if="$ctrl.hasDivManagePermission" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.editBusinessPartner(businessPartner)" title="{{ ::(\'modules.contacts.businessPartners.editBtnLabel\' | translate) }}"><i class="ion-edit"></i> <span class="hidden-xs hidden-sm" translate="modules.contacts.businessPartners.editBtnLabel">Bearbeiten</span></button> <button ng-if="$ctrl.hasDivManagePermission && $ctrl.ctx.length && $ctrl.ctx.indexOf(\'rootOrg\') < 0" type="button" ng-click="$ctrl.removeBusinessPartnerLinking(businessPartner)" ng-disabled="$ctrl.businessPartnerActionsNotAllowed()" class="btn btn-danger btn-with-icon btn-xs" title="{{ ::(\'modules.contacts.businessPartners.overview.linkingRemoveBtnLabel\' | translate) }}"><i class="fa fa-chain-broken"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.remove">Entfernen</span></button></div></td></tr><tr ng-if="($ctrl.currentTableConf.displayedCollection || []).length === 0"><td class="text-center" colspan="{{$ctrl.getFullCSpan($ctrl.currentTableConf.tableConfig)}}"><i translate="modules.contacts.businessPartners.overview.noOrganizations">Keine Organisationen verzeichnet</i></td></tr></tbody><tfoot><tr ng-if="($ctrl.currentTableConf.displayedCollection || []).length"><td colspan="16" class="text-center"><div st-pagination="" st-items-by-page="$ctrl.currentTableConf.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div></div></div></div><div ng-if="$ctrl.hasOrgViewPermission" class="col-xs-12"><div ba-panel="" ba-panel-title="\'modules.contacts.businessPartners.overview.titleOrgBusinessPartners\'" ba-panel-division-selector="false" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="arno.contacts.businessPartners.view" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-xs-12"><div class="arno-contacts-businesspartners-panel-header"><div class="btn-toolbar pull-left"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="controls.table.itemsPerPage">Ergebnisse pro Seite</span> ({{ $ctrl.orgTableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changeOrgTablePageSize($ctrl.orgTableConfig, i)">{{ i }}</a></li></ul></div></div><div class="btn-toolbar pull-right"><button class="btn btn-primary btn-with-icon" ng-if="$ctrl.hasOrgManagePermission" ng-click="$ctrl.addOrgBusinessPartner()"><i class="ion-plus"></i> <span class="hidden-xs" translate="modules.contacts.businessPartners.addBtnLabel">Organisation hinzuf\xFCgen</span></button></div></div></div></div><div class="row mt-20"><div class="col-xs-12"><div class="table-responsive arno-contacts-businesspartners-table"><table st-table="$ctrl.orgTableConfig.displayedCollection" st-pipe="$ctrl.getOrgBusinessPartners" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Name" st-sort-default="true">{{ \'modules.contacts.businessPartners.overview.nameCol\' | translate}}</th><th st-sort="TradeName" ng-show="$ctrl.orgTableConfig.tableConfig.TradeName">{{ \'modules.contacts.businessPartners.overview.tradeNameCol\' | translate}}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.City" st-sort="City">{{ \'modules.contacts.businessPartners.overview.cityCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.ZIP" st-sort="ZIP">{{ \'modules.contacts.businessPartners.overview.zipCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.Street" st-sort="Street">{{ \'modules.contacts.businessPartners.overview.streetCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.HouseNumber" st-sort="HouseNumber">{{ \'modules.contacts.businessPartners.overview.houseNumberCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.TaxIdentifier" st-sort="TaxIdentifier">{{ \'modules.contacts.businessPartners.overview.taxIdentCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.LegalRegistrationIdentifier" st-sort="LegalRegistrationIdentifier">{{ \'modules.contacts.businessPartners.overview.legalRegIdentCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.VatIdentifier" st-sort="VatIdentifier">{{ \'modules.contacts.businessPartners.overview.vatIdentCol\' | translate }}</th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsBuyer" translate="modules.contacts.businessPartners.overview.isBuyerCol">Auftraggeber</th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsSeller" translate="modules.contacts.businessPartners.overview.isSellerCol">Auftragnehmer</th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsMaterialProvider" translate="modules.contacts.businessPartners.overview.isMaterialProviderCol">Material</th><th ng-show="$ctrl.hasOrgManagePermission" translate="modules.contacts.businessPartners.overview.actionsCol" class="text-right">Aktionen</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.TradeName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="TradeName" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.City"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="City" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.ZIP"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="ZIP" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.Street"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Street" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.HouseNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="HouseNumber" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.TaxIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="TaxIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.LegalRegistrationIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LegalRegistrationIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.VatIdentifier"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="VatIdentifier" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsBuyer" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.orgTableConfig.showBuyers"> <span></span></label></th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsSeller" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.orgTableConfig.showSellers"> <span></span></label></th><th ng-show="$ctrl.orgTableConfig.tableConfig.IsMaterialProvider" class="text-center"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$ctrl.orgTableConfig.showMaterialProviders"> <span></span></label></th><th ng-show="$ctrl.hasOrgManagePermission"></th></tr></thead><tbody><tr ng-if="$ctrl.orgTableConfig.displayedCollection" ng-repeat="businessPartner in $ctrl.orgTableConfig.displayedCollection" class="editable-row" ng-class="{\'arno-pointing-pointer\': $ctrl.hasOrgManagePermission}" ng-click="$ctrl.editBusinessPartner(businessPartner)"><td><i class="ion-ios-people" title="{{ ::(\'modules.contacts.businessPartners.overview.orgBusinessPartnerTooltip\' | translate) }}"></i> <span>{{ businessPartner.Name || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.TradeName"><span>{{ businessPartner.TradeName || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.City"><span>{{ businessPartner.City || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.ZIP"><span>{{ businessPartner.ZIP || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.Street"><span>{{ businessPartner.Street || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.HouseNumber"><span>{{ businessPartner.HouseNumber || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.TaxIdentifier"><span>{{ businessPartner.TaxIdentifier || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.LegalRegistrationIdentifier"><span>{{ businessPartner.LegalRegistrationIdentifier || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.VatIdentifier"><span>{{ businessPartner.VatIdentifier || "" }}</span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.IsBuyer" class="text-center"><span><i ng-if="businessPartner.IsBuyer" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.IsSeller" class="text-center"><span><i ng-if="businessPartner.IsSeller" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.orgTableConfig.tableConfig.IsMaterialProvider" class="text-center"><span><i ng-if="businessPartner.IsMaterialProvider" class="fa fa-check color-success"></i></span></td><td ng-show="$ctrl.hasOrgManagePermission" class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.preventPropagation($event)"><div class="pull-right"><button ng-if="$ctrl.hasOrgManagePermission" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.editOrgBusinessPartner(businessPartner)" title="{{ ::(\'modules.contacts.businessPartners.editBtnLabel\' | translate) }}"><i class="ion-edit"></i> <span class="hidden-xs hidden-sm" translate="modules.contacts.businessPartners.editBtnLabel">Bearbeiten</span></button> <button ng-if="$ctrl.hasOrgManagePermission" type="button" ng-click="$ctrl.deleteOrgBusinessPartner(businessPartner)" class="btn btn-danger btn-with-icon btn-xs"><i class="ion-ios-trash"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.delete">L\xF6schen</span></button></div></td></tr><tr ng-if="($ctrl.orgTableConfig.displayedCollection || []).length === 0"><td class="text-center" colspan="{{$ctrl.getFullCSpan($ctrl.orgTableConfig.tableConfig)}}"><i translate="modules.contacts.businessPartners.overview.noOrganizations">Keine Organisationen verzeichnet</i></td></tr></tbody><tfoot><tr ng-if="($ctrl.orgTableConfig.displayedCollection || []).length"><td colspan="16" class="text-center"><div st-pagination="" st-items-by-page="$ctrl.orgTableConfig.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div></div></div></div><div ng-if="!$ctrl.hasDivViewPermission && !$ctrl.hasOrgViewPermission" class="col-xs-12" translate="modules.contacts.businessPartners.noViewPermission">Du hast nicht die erforderlichen Berechtigungen, um Organisationen einzusehen!</div></div>');
$templateCache.put('app/pages/contacts/contactManagement/contactManagement.html','<div><div ba-panel="" ba-panel-title="\'modules.contacts.contactManagement.overview.title\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.contacts.contactManagement.view" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-6"><div class="btn-toolbar pull-left"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="controls.table.itemsPerPage">Ergebnisse pro Seite</span> ({{ $ctrl.rowsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="rowsPerPage in $ctrl.rowsPerPageList"><a href="" ng-click="$ctrl.changeRowsPerPage(rowsPerPage)">{{ rowsPerPage }}</a></li></ul></div></div></div><div class="col-md-6"><div class="btn-toolbar pull-right"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.addContact()" ng-disabled="$ctrl.isMultiDiv" title="{{ ::(\'modules.contacts.contactManagement.addButtonLabel\' | translate:$ctrl.addTooltipVars) }}"><i class="ion-plus"></i> <span class="hidden-xs">{{ \'modules.contacts.contactManagement.addButtonLabel\' | translate}}</span></button></div></div></div><div class="row mt-20"><div class="col-md-12"><div><div class="table-responsive"><table class="table table-condensed table-hover" st-table="$ctrl.contactData.contactList" st-pipe="$ctrl.updateContactData"><thead><tr class="sortable"><th st-sort="businesspartner">{{ \'modules.contacts.contactManagement.contact.businesspartner\' | translate }}</th><th st-sort="function">{{ \'modules.contacts.contactManagement.contact.function\' | translate }}</th><th st-sort="salutation">{{ \'modules.contacts.contactManagement.contact.salutation\' | translate }}</th><th st-sort="title">{{ \'modules.contacts.contactManagement.contact.title\' | translate }}</th><th st-sort="firstname">{{ \'modules.contacts.contactManagement.contact.firstname\' | translate }}</th><th st-sort="lastname">{{ \'modules.contacts.contactManagement.contact.lastname\' | translate }}</th><th st-sort="phonenumber">{{ \'modules.contacts.contactManagement.contact.phonenumber\' | translate }}</th><th st-sort="mobilenumber">{{ \'modules.contacts.contactManagement.contact.mobilenumber\' | translate }}</th><th st-sort="mailaddress">{{ \'modules.contacts.contactManagement.contact.mail\' | translate }}</th><th ng-if="$ctrl.hasManagePermission">{{ \'modules.contacts.contactManagement.overview.actions\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="businesspartner" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="function" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="salutation" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="title" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="firstname" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="lastname" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="phonenumber" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="mobilenumber" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="mailaddress" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$ctrl.hasManagePermission"></th></tr></thead><tbody><tr class="editable-row" ng-repeat="contact in $ctrl.contactData.contactList" ng-click="$ctrl.goContactDetails(contact)"><td><i ng-if="contact.BusinessPartner.IsInternal" class="fa fa-sitemap" title="{{ ::(\'modules.contacts.businessPartners.overview.systemDivisionBusinessPartnerTooltip\' | translate) }}"></i> <i ng-if="!contact.BusinessPartner.IsInternal" class="ion-ios-people-outline" title="{{ ::(\'modules.contacts.businessPartners.overview.divisionBusinessPartnerTooltip\' | translate) }}"></i> <span ng-if="contact.BusinessPartner.IsInternal">({{ ::$ctrl.orgName }})</span> <span>{{ (contact.BusinessPartner.IsInternal ? contact.BusinessPartner.OwnerDivision.Name : contact.BusinessPartner.Name) }}</span></td><td>{{ contact.Function }}</td><td>{{ ::($ctrl.resolveDropdownValue(contact.Salutation)) }}</td><td>{{ ::($ctrl.resolveDropdownValue(contact.Title, true)) }}</td><td>{{ contact.FirstName }}</td><td>{{ contact.LastName }}</td><td>{{ contact.PhoneNumber }}</td><td>{{ contact.MobileNumber }}</td><td>{{ contact.MailAddress }}</td><td ng-if="$ctrl.hasManagePermission" class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.preventPropagation($event)"><div class="pull-right"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.editContact(contact)" title="{{ ::(\'modules.contacts.contactManagement.editButtonLabel\' | translate) }}"><i class="ion-edit"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button type="button" ng-click="$ctrl.removeContact(contact)" ng-disabled="!$ctrl.linkable()" class="btn btn-danger btn-with-icon btn-xs" title="{{ ::(\'modules.contacts.contactManagement.removeButtonLabel\' | translate) }}"><i class="fa fa-chain-broken"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.remove"></span></button></div></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-template="app/theme/components/paging/paging.html" st-items-by-page="$ctrl.rowsPerPage" st-displayed-pages="$ctrl.displayedPages"></st-pagination></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contacts/contactManagement/contactManagementDetails.html','<div><div ba-panel="" ba-panel-title="!$ctrl.contact ? \'modules.contacts.contactManagement.details.newContact\' : \'modules.contacts.contactManagement.details.existingContact\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-entry-permission="arno.contacts.contactManagement.view" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><form id="contactDetailsForm" name="contactDetailsForm" novalidate="" angular-validator="" angular-validator-submit="$ctrl.save(contactDetailsForm)"><div class="row"><div class="col-md-8"><div><fieldset class="block" ng-disabled="!$ctrl.hasManagePermission"><div class="row"><div class="form-group col-md-6"><label for="functionInput" class="control-label required-label" translate="modules.contacts.contactManagement.contact.function"></label> <input type="text" ng-model="$ctrl.contact.Function" class="form-control" id="functionInput" name="functionInput" placeholder="{{ modules.contacts.contactManagement.contact.Function }}"></div><div class="form-group col-md-6"><business-partners-selector division="$ctrl.divisionIds" selection-proposals="$ctrl.businessPartnerList" on-business-partner-select="$ctrl.setBusinessPartner" selected-business-partner="$ctrl.contact.BusinessPartner" details-extra-label="\'modules.contacts.contactManagement.contact.businesspartner\'" extra-label-cls="\'control-label required-label\'" enable-details="true"></business-partners-selector></div><div class="form-group col-md-6"><label for="salutationInput" class="control-label" translate="modules.contacts.contactManagement.contact.salutation"></label><ui-select ng-model="$ctrl.contact.Salutation" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input"><ui-select-match>{{ $ctrl.contact.Salutation.Name }}</ui-select-match><ui-select-choices position="down" repeat="salutation in $ctrl.salutationList track by $index"><div><span>{{ salutation.Name }}</span></div></ui-select-choices></ui-select></div><div class="form-group col-md-6"><label for="titleInput" class="control-label" translate="modules.contacts.contactManagement.contact.title"></label><ui-select ng-model="$ctrl.contact.Title" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input"><ui-select-match>{{ $ctrl.contact.Title.Name }}</ui-select-match><ui-select-choices position="down" repeat="title in $ctrl.titleList track by $index"><div><span>{{ title.Name }}</span></div></ui-select-choices></ui-select></div><div class="form-group col-md-6"><label for="firstnameInput" class="control-label" translate="modules.contacts.contactManagement.contact.firstname"></label> <input type="text" ng-model="$ctrl.contact.FirstName" class="form-control" id="firstnameInput" name="firstnameInput" placeholder="{{ \'modules.contacts.contactManagement.contact.firstname\' | translate }}" ng-class="{\'has-error\': contactDetailsForm.firstnameInput.$invalid}"></div><div class="form-group col-md-6"><label for="lastnameInput" class="control-label" translate="modules.contacts.contactManagement.contact.lastname"></label> <input type="text" ng-model="$ctrl.contact.LastName" class="form-control" id="lastnameInput" name="lastnameInput" placeholder="{{ \'modules.contacts.contactManagement.contact.lastname\' | translate }}" ng-class="{\'has-error\': contactDetailsForm.lastnameInput.$invalid}"></div><div class="form-group col-md-6"><label for="phonenumberInput" class="control-label" translate="modules.contacts.contactManagement.contact.phonenumber"></label> <input type="text" ng-model="$ctrl.contact.PhoneNumber" class="form-control" id="phonenumberInput" name="phonenumberInput" placeholder="{{ \'modules.contacts.contactManagement.contact.phonenumber\' | translate }}" validator="$ctrl.checkPhoneNumber($ctrl.contact.PhoneNumber)" ng-class="{\'has-error\': contactDetailsForm.phonenumberInput.$invalid}"></div><div class="form-group col-md-6"><label for="mobilenumberInput" class="control-label" translate="modules.contacts.contactManagement.contact.mobilenumber"></label> <input type="text" ng-model="$ctrl.contact.MobileNumber" class="form-control" id="mobilenumberInput" name="mobilenumberInput" placeholder="{{ \'modules.contacts.contactManagement.contact.mobilenumber\' | translate }}" validator="$ctrl.checkPhoneNumber($ctrl.contact.MobileNumber)" ng-class="{\'has-error\': contactDetailsForm.mobilenumberInput.$invalid}"></div><div class="form-group col-md-6"><label for="mailInput" class="control-label" translate="modules.contacts.contactManagement.contact.mail"></label> <input type="text" ng-model="$ctrl.contact.MailAddress" class="form-control" id="mailInput" name="mailInput" placeholder="{{ \'modules.contacts.contactManagement.contact.mail\' | translate }}" validator="!!$ctrl.checkEmail($ctrl.contact.MailAddress)" ng-class="{\'has-error\': contactDetailsForm.mailInput.$invalid}"></div><div class="form-group col-md-12 mt-4" ng-if="$ctrl.contact.PrivacyTermsDeliveredDateTime"><h3 class="with-line" toggle-next="$ctrl.toggleSection.privacy">{{\'modules.contacts.contactManagement.details.privacyAgreementContacts\' | translate}}</h3><div class="row"><div class="col-xs-12 col-sm-9 col-md-9"><table class="table table-condensed"><head><tr><th colspan="2"><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverThirdParty"></strong></th></tr></head><tbody><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverOn"></strong></td><td>{{$ctrl.moment($ctrl.contact.PrivacyTermsDeliveredDateTime).format(\'DD.MM.YYYY # HH:mm\').replace(\'#\', \'um\')}} Uhr</td></tr><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverBy"></strong></td><td>{{$ctrl.contact.PrivacyTermsDeliveredPerson}}</td></tr><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverVia"></strong></td><td>{{$ctrl.privacyTermsChannelMap[$ctrl.contact.PrivacyTermsDeliveredChannel]}}</td></tr></tbody></table></div></div></div></div></fieldset></div></div><div class="col-md-4"><div class="table-responsive"><table class="table table-condensed table-hover" st-table="$ctrl.divisionList" st-pipe="$ctrl.updateDivisionData"><thead><tr class="sortable"><th st-sort="name">{{ \'modules.contacts.contactManagement.contact.divisions\' | translate}}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="name" type="search" class="form-control with-default-addon input-sm"></div></th></tr></thead><tbody><tr class="editable-row" ng-repeat="division in $ctrl.divisionList"><td>{{ division.Name }}</td></tr></tbody><tfoot><tr><td colspan="1" class="text-center"><st-pagination st-template="app/theme/components/paging/paging.html" st-items-by-page="$ctrl.rowsPerPage" st-displayed-pages="$ctrl.displayedPages"></st-pagination></td></tr></tfoot></table></div></div></div><div class="row mt-12 mb-20"><div class="col-xs-12"><contact-management-duplicates contact="$ctrl.contact" division-ids="$ctrl.divisionIds" is-new="$ctrl.isNew()"></contact-management-duplicates></div></div><div><div class="pull-left"><button type="button" class="btn btn-default btn-with-icon" ng-click="$ctrl.back()"><i class="ion-chevron-left font-size-12"></i> <span translate="generalTerms.back"></span></button></div><div class="pull-right"><button ng-if="$ctrl.hasManagePermission && !$ctrl.isNew()" type="button" class="btn btn-default btn-with-icon" ng-click="$ctrl.toggleLink()" ng-class="{ \'btn-danger\': $ctrl.isLinked, \'btn-success\': !$ctrl.isLinked }" title="{{ $ctrl.isLinked ? \'generalTerms.remove\' : \'generalTerms.add\' }}"><i class="fa" ng-class="{ \'fa-link\': !$ctrl.isLinked, \'fa-chain-broken\': $ctrl.isLinked }"></i> <span class="hidden-xs" translate="{{ $ctrl.isLinked ? \'generalTerms.remove\' : \'generalTerms.add\' }}"></span></button> <button ng-if="$ctrl.hasManagePermission" type="submit" class="btn btn-primary btn-with-icon" ng-disabled="!contactDetailsForm.$dirty || !contactDetailsForm.$valid"><i class="ion-checkmark"></i> <span translate="{{ $ctrl.isNew() ? \'modules.contacts.contactManagement.details.addContact\' : \'modules.contacts.contactManagement.details.saveContact\' }}"></span></button></div></div></form></div></div>');
$templateCache.put('app/pages/events/demandForAction/demandForAction.html','<div ng-repeat="type in self.types" ng-if="self.isPermitted(type.perm, type.key)" ba-panel="" ba-panel-title="\'modules.finances.demandForAction.panelTitle\'" ba-panel-title-translate-vars="type.panelTitleVars" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission-scoped="type.perm"><div><div><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm">{{ \'generalTerms.entriesPerPage\' | translate }}</span> ({{ self.pageSize[type.key] }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="self.changePageSize(i, type.key)">{{ i }}</a></li></ul></div></div><div class="table-responsive mt-20"><table st-table="self[type.key]" st-pipe="type.getterFn" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="QuotationNumber">{{ (\'models.Quotation.QuotationNumber\' | translate) }}</th><th st-sort="Title">{{ (\'models.Quotation.Title\' | translate) }}</th><th st-sort="Creator">{{ (\'models.Quotation.Creator\' | translate) }}</th><th st-sort="BusinessPartner.Name">{{ (\'modules.finances.quotInvList.clientName\' | translate) }}</th><th st-sort="FinalAmount">{{ (\'models.Quotation.FinalAmount\' | translate) }}</th><th class="arno-table-button-cell">{{ \'generalTerms.actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat="quotation in self[type.key]"><td class="force-minimal"><span>{{ ::quotation.QuotationNumber }}</span></td><td><span>{{ ::quotation.Title }}</span></td><td><span>{{ ::quotation.Creator }}</span></td><td><span>{{ ::quotation.BusinessPartner.Name }}</span></td><td><span>{{ ::quotation.FinalAmount | currency: \'\u20AC\' }}</span></td><td class="arno-default-pointer"><div class="nowrap"><button class="btn btn-default btn-with-icon btn-xs" ng-click="self.edit(quotation, type.key)" translate-attr="{ title: \'generalTerms.edit\' }"><i class="fa fa-pencil"></i> {{ \'generalTerms.open\' | translate }}</button> <button class="btn btn-danger btn-with-icon btn-xs ml-5" ng-click="self.deny(quotation, type.key)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!self[type.key] || self[type.key].length === 0"><td class="text-center" colspan="99"><i>{{ \'modules.finances.demandForAction.notAvailable\' | translate }}</i></td></tr></tbody><tfoot ng-if="self.showPager[type.key]"><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="self.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/events/event/event.html','<div ba-panel="" ba-panel-title="$ceEvent.eventData.Subject ? \'modules.events.event.event\' : \'modules.events.event.newEvent\'" ba-panel-tag-list="$ceEvent.panelTagList" class="arno-events" ba-panel-title-translate-vars="{ subject: $ceEvent.eventData.Subject }"><form id="eventEditForm" name="eventEditForm" novalidate="" angular-validator="" angular-validator-submit="$ceEvent.submitEvent()"><div class="organizer-hint" ng-class="{\'mb-5\': !$ceEvent.canJumpToSeries && !$ceEvent.canDeleteEvent}">{{ \'modules.events.event.createdBy\' | translate }} <span ng-class="{\'font-weight-500\': !$ceEvent.eventData.Organizer.isInactive, \'member-inactive\': $ceEvent.eventData.Organizer.isInactive}">{{ $ceEvent.eventData.Organizer.fullName || $root.ctx.currentUser.fullName }} {{ $ceEvent.eventData.Organizer.isInactive ? (\'modules.events.event.inactiveWithBrackets\' | translate) : \'\' }}</span> in <span class="font-weight-500">{{ $ceEvent.sourceDivisionName }}</span>.</div><div class="mb-15" ng-show="$ceEvent.canJumpToSeries || $ceEvent.canDeleteEvent"><button type="button" class="btn btn-info btn-sm btn-with-icon ion-refresh mr-3" ng-show="$ceEvent.canJumpToSeries" ng-click="$ceEvent.jumpToEditSeries($event, $ceEvent.eventData.EventSeriesId)"><span class="hidden-xs">{{ \'modules.events.event.switchToSeries\' | translate }}</span></button> <button type="button" class="btn btn-danger btn-sm btn-with-icon ion-ios-trash" ng-show="$ceEvent.canDeleteEvent" ng-click="$ceEvent.deleteEvent($event, $ceEvent.eventData.id)"><span class="hidden-xs">{{ \'modules.events.event.deleteEventBtn\' | translate:{ isSeries: $ceEvent.eventData.isEventSeries, isOccurence: $ceEvent.eventData.EventSeriesId } }}</span></button></div><div class="row mb-15" ng-if="(!$ceEvent.eventData.isEventSeries || $ceEvent.eventData.EventSeriesId) && $ceEvent.viewMode === \'edit\'"><div class="col-md-12"><flow-bar flow="$ceEvent.flow" view-only="$ceEvent.viewMode === \'view\'" flow-label="\'modules.events.event.event\' | translate"></flow-bar></div><div ng-if="$ceEvent.flow.lastSavedStep === 0 && $ceEvent.flow.activeStep === 1" class="col-md-6"><div class="alert bg-info mb-0 mt-20"><div><span class="font-weight-500">{{ \'modules.events.event.impactOfEventChanges\' | translate }}</span><ul class="mb-0"><li>{{ \'modules.events.event.switchLocked\' | translate }}</li><li>{{ \'modules.events.event.eventNotModifiable\' | translate }}</li><li>{{ \'modules.events.event.eventOnlyAchive\' | translate }}</li></ul></div></div></div></div><div ng-include="\'app/pages/events/event/partials/mainEventData.html\'"></div><div class="pt-20 hidden-sm hidden-xs"></div><div ng-include="\'app/pages/events/event/partials/meetingData.html\'"></div><div ng-include="\'app/pages/events/event/partials/eventMeta.html\'" class="mb-20"></div><div ng-include="\'app/pages/events/event/partials/divisionShare.html\'" class="mb-20" ng-if="!$ceEvent.eventData.isEventSeries || $ceEvent.viewModeSeries === \'eventSeries\'"></div><div ng-include="\'app/pages/events/event/partials/attendance.html\'"></div><div class="row mt-20" ng-if="$ceEvent.eventData.id && $ceEvent.fileStorage"><div class="col-md-12"><h5 class="with-line mb-5" toggle-next=""><span>{{ \'modules.events.event.documentFiling\' | translate }}<arno-ba-help-tooltip text="{{ modules.events.event.documentFilingTooltip }}"></arno-ba-help-tooltip></span></h5><div class="row"><file-storage item-id="$ceEvent.eventData.id" storage-ident="\'event\'" ctx="$ceEvent.division" folder-data="$ceEvent.fileStorage" edit-permission="$ceEvent.fileStorageEditPermissionCheck" show-edit-perm-icon="true"></file-storage></div></div></div><div ng-include="\'app/pages/events/event/partials/material.html\'" class="mt-20" ng-if="!$ceEvent.eventData.isEventSeries || $ceEvent.viewModeSeries === \'eventSeries\'"></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="$ceEvent.expectedShortAmountCount"><label class="custom-checkbox"><input type="checkbox" name="expectsExpectedShortAmountCount" class="from-control" ng-model="$ceEvent.expectsExpectedShortAmountCount" required="" required-message="\'modules.events.service.requiredExpectShortAmountCount\' | translate"> <span><span>(<i class="fa fa-cube ml-1 text-danger"></i>)</span> <span class="font-weight-500">{{ (\'modules.events.service.expectBookingMaterialShortAmountCount\' | translate:{ amount: $ceEvent.expectedShortAmountCount }) }}</span></span></label></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="$ceEvent.canTransferHelperHours && $ceEvent.flow.lastSavedStep !== $ceEvent.flow.activeStep"><label class="custom-checkbox"><input type="checkbox" name="wantsTransferHelperHoursCheckbox" class="from-control" ng-model="$ceEvent.wantsTransferHelperHours"> <span><span class="font-weight-500">{{ \'modules.events.event.helperhoursTransferExecute\' | translate}}</span></span></label><div class="mt-10" ng-if="$ceEvent.flow.lastSavedStep !== $ceEvent.flow.activeStep"><label class="custom-checkbox"><input type="checkbox" name="wantsTransferHelperHoursCheckbox" class="from-control" ng-model="$ceEvent.wantsRecordAttendances"> <span><span class="font-weight-500">{{ \'modules.events.event.recordAttendeesExecute\' | translate}}</span></span></label></div></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="$ceEvent.showArchiveWithoutAttendeesWarning"><label class="custom-checkbox"><input type="checkbox" name="archiveWithoutAttendees" class="from-control" ng-model="$ceEvent.acceptGuidelineCheckbox" required="" required-message="\'modules.events.event.archiveWithoutAttendeesMessage\' | translate"> <span><span class="font-weight-500">{{ \'modules.events.event.eventWithoutReportArchive\' | translate }}</span></span></label><div class="ml-20 pl-2"><i><span class="font-weight-500">{{ \'modules.events.event.note\' | translate }}</span> {{ \'modules.events.event.avoidIncorrectEntries\' | translate }}</i></div></div><div class="row btns-row mt-20"><div class="col-md-12"><button type="button" class="btn btn-default btn-with-icon" ng-click="$ceEvent.back()"><i class="ion-ios-arrow-back"></i><span>{{ \'generalTerms.back\' | translate }}</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="$ceEvent.canSaveEvent" ng-click="$ceEvent.refreshOnSave=true" ng-disabled="$ceEvent.showArchiveWithoutAttendeesWarning && !$ceEvent.acceptGuidelineCheckbox"><i class="ion-checkmark"></i><span>{{ \'generalTerms.save\' | translate }}</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-if="$ceEvent.canSaveEvent" ng-click="$ceEvent.refreshOnSave=false" ng-disabled="$ceEvent.showArchiveWithoutAttendeesWarning && !$ceEvent.acceptGuidelineCheckbox"><i class="ion-checkmark"></i><span>{{ \'modules.events.service.saveAndBack\' | translate }}</span></button> <button type="button" class="btn btn-info btn-with-icon pull-right" ng-if="$ceEvent.canTransferHelperHours && $ceEvent.flow.lastSavedStep === $ceEvent.flow.activeStep" ng-click="$ceEvent.helperHoursTransfer()"><i class="fa fa-clock-o"></i> {{ \'modules.events.event.helperhoursTransfer\' | translate }}</button></div></div></form></div>');
$templateCache.put('app/pages/events/overview/eventList.html','<div class="row arno-events arno-events-list"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.events.overview.titleEventList\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.events.basic.view,arno.virtual.item.events.basic.manage" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-4 col-md-push-8"><div class="mb-14 align-right" ng-if="$viewSheet.getShowElement(\'addBasicEvent\', true, $viewSheet.ctx)"><button type="button" class="btn btn-primary btn-with-icon w-100" ng-click="$viewSheet.createEvent(null, $viewSheet.ctx, \'EVENT\')" ng-disabled="$viewSheet.ctx.length > 1" title="{{ $viewSheet.ctx.length > 1 ? (\'modules.events.overview.createEventTitle\' | translate) : (\'modules.events.overview.newDate\' | translate) }}"><i class="fa fa-calendar-plus-o"></i> {{ (\'modules.events.overview.newDate\' | translate) }}</button></div><div class="mb-8"><label>{{ (\'modules.events.overview.view\' | translate) }}</label><div class="ml-5"><ba-switcher switcher-style="info" switcher-value="$viewSheet.chosen.nearFutureView" switcher-width="120" switcher-keys="$viewSheet.nearFutureKeys" switcher-hints="$viewSheet.nearFutureHints"></ba-switcher></div></div><div class="mb-20" ng-if="!$viewSheet.chosen.nearFutureView"><div class="dp-responsive ml-5"><div uib-datepicker="" class="calender-series-date-select" ng-model="$viewSheet.dateJump" datepicker-options="$viewSheet.dateJumper"></div></div></div><div><label>Filter</label></div><div class="mb-5 ml-5 form-group" ng-if="$viewSheet.getShowElement(\'hasEventManageOrItemPerm\', true, $viewSheet.ctx)"><ba-switcher switcher-style="info" switcher-value="$viewSheet.chosen.onlyActive" switcher-width="120" switcher-keys="$viewSheet.onlyActiveKeys" switcher-hints="$viewSheet.onlyActiveHints"></ba-switcher></div><div class="mb-15 ml-5 form-group"><label>{{ (\'modules.events.overview.filter\' | translate) }}</label><tag-picker default-label="\'modules.events.overview.allCategories\' | translate" tags="$viewSheet.categories" selected-tags="$viewSheet.chosen.categories" hide-division-name="true" on-group-func="$viewSheet.categoryGroupFunc" disabled="!$viewSheet.categories.length"></tag-picker></div><div class="mb-15 ml-5 form-group" ng-if="$viewSheet.chosen.refiner === \'MY_SERVICES\'"><label class="filter-label-with-reset">{{ (\'modules.events.overview.attendanceStatus\' | translate) }} <a href="" ng-click="$viewSheet.setAttendanceTypeDefaultView()" ng-if="$viewSheet.attendanceTypeDefaultViewPlausibleReset"><i class="fa fa-undo mr-1"></i> {{ (\'modules.events.overview.reset\' | translate) }}</a></label><ab-multiselect ng-model="$viewSheet.chosen.attendanceType" options="$viewSheet.availableAttendanceTypes" id-prop="type" display-prop="Name" show-tooltip="true" classes-btn="\'multiselect-block-dropdown cursive-empty\'" placeholder="{{ (\'modules.events.overview.allEventTypes\' | translate) }}"></ab-multiselect></div></div><div class="col-md-8 col-md-pull-4"><event-calendar chosen-shared-filters="$viewSheet.chosen" categories="$viewSheet.categories" cal-view="$viewSheet.chosen.nearFutureView ? \'nearFuture\' : \'listMonth\'" cal-mode="\'EVENT\'" loop-back="$viewSheet.loopBack" flow-step-config="$viewSheet.flowStepConfig" ctx="$viewSheet.ctx"></event-calendar></div></div></div></div></div>');
$templateCache.put('app/pages/events/overview/overview.html','<div class="row arno-events"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.events.overview.title\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.events.basic.view,arno.events.service.view,arno.virtual.item.events.basic.manage,arno.virtual.item.events.service.manage" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row btns-row" ng-if="$viewSheet.getShowElement(\'addBasicEvent\', true) || $viewSheet.getShowElement(\'addService\', true)"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$viewSheet.createEvent(null, $viewSheet.ctx)" ng-disabled="$viewSheet.ctx.length > 1" title="{{$viewSheet.ctx.length > 1 ? \'Bitte w\xE4hle im Bereichsw\xE4hler eine einzelne Gliederung aus um fortzufahren.\' : \'Neue Veranstaltung\'}}"><i class="fa fa-calendar-plus-o"></i><span class="hidden-xs">{{ (\'modules.events.overview.newEvent\' | translate) }}</span></button></div></div><div class="row"><div class="col-md-6 col-lg-4"><div class="form-group"><label>{{ (\'modules.events.overview.eventType\' | translate) }}</label><ui-select ng-model="$viewSheet.selectedEventType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$viewSheet.selectedEventType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="eventType in $viewSheet.availableEventTypes"><span>{{eventType.Name}}</span></ui-select-choices></ui-select></div></div><div class="col-md-6 col-lg-4" ng-show="$viewSheet.categories.length"><div class="form-group"><label>{{ (\'modules.events.overview.category\' | translate) }}</label><tag-picker default-label="\'modules.events.overview.allCategories\' | translate" tags="$viewSheet.categories" selected-tags="$viewSheet.chosen.categories" hide-division-name="true" on-group-func="$viewSheet.categoryGroupFunc"></tag-picker></div></div></div><div class="row btns-row"><div class="col-md-12"><event-calendar chosen-shared-filters="$viewSheet.chosen" categories="$viewSheet.categories" ctx="$viewSheet.ctx"></event-calendar></div></div></div></div></div>');
$templateCache.put('app/pages/events/overview/serviceList.html','<div class="row"><div class="col-lg-12" ng-if="$viewSheet.divisionShares.length"><div ba-panel="" ba-panel-title="\'modules.events.overview.serviceListTitle\' | translate" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><service-division-share-list division-shares="$viewSheet.divisionShares" event-share-ctx="$viewSheet.ctx"></service-division-share-list></div></div><div class="col-lg-12" ng-if="$viewSheet.openServiceAttendeeInterest.length"><div ba-panel="" ba-panel-title="\'modules.events.overview.attendeeInterestTitle\' | translate" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><service-attendance-interest-list open-service-attendee-interest="$viewSheet.openServiceAttendeeInterest"></service-attendance-interest-list></div></div></div><div class="row arno-events arno-events-list arno-events-list-service"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.events.overview.serviceList\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.events.service.view,arno.virtual.item.events.service.manage" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-4 col-md-push-8"><div class="mb-14 align-right" ng-if="$viewSheet.getShowElement(\'addService\', true, $viewSheet.ctx)"><button type="button" class="btn btn-primary btn-with-icon w-100" ng-click="$viewSheet.createEvent(null, $viewSheet.ctx, \'SERVICE\')" ng-disabled="$viewSheet.ctx.length > 1" title="{{$viewSheet.ctx.length > 1 ? (\'modules.events.overview.createEventTitle\' | translate) : (\'modules.events.overview.newService\' | translate) }}"><i class="fa fa-calendar-plus-o"></i> {{ (\'modules.events.overview.newService\' | translate) }}</button></div><div class="mb-8"><label>{{ (\'modules.events.overview.duration\' | translate) }}</label><div class="ml-5"><ba-switcher switcher-style="info" switcher-value="$viewSheet.chosen.nearFutureView" switcher-width="120" switcher-keys="$viewSheet.nearFutureKeys" switcher-hints="$viewSheet.nearFutureHints"></ba-switcher></div></div><div class="mb-20" ng-if="!$viewSheet.chosen.nearFutureView"><div class="dp-responsive ml-5"><div uib-datepicker="" class="calender-series-date-select" ng-model="$viewSheet.dateJump" datepicker-options="$viewSheet.dateJumper"></div></div></div><div><label>{{ \'modules.events.overview.filter\' | translate }}</label></div><div class="mb-5 ml-5 form-group" ng-if="$viewSheet.getShowElement(\'hasServiceManageOrItemPerm\', true, $viewSheet.ctx)"><ba-switcher switcher-style="info" switcher-value="$viewSheet.chosen.onlyActive" switcher-width="120" switcher-keys="$viewSheet.onlyActiveKeys" switcher-hints="$viewSheet.onlyActiveHints"></ba-switcher></div><div class="mb-15 ml-5 form-group" ng-if="$viewSheet.chosen.refiner === \'MY_SERVICES\'"><label class="filter-label-with-reset">{{ (\'modules.events.overview.attendanceStatus\' | translate) }} <a href="" ng-click="$viewSheet.setAttendanceTypeDefaultView()" ng-if="$viewSheet.attendanceTypeDefaultViewPlausibleReset"><i class="fa fa-undo mr-1"></i> {{ (\'modules.events.overview.reset\' | translate) }}</a></label><ab-multiselect ng-model="$viewSheet.chosen.attendanceType" options="$viewSheet.availableAttendanceTypes" id-prop="type" display-prop="Name" show-tooltip="true" classes-btn="\'multiselect-block-dropdown cursive-empty\'" placeholder="{{ (\'modules.events.overview.allEventTypes\' | translate) }}"></ab-multiselect></div><div class="mb-15 ml-5 form-group"><label>{{ (\'modules.events.overview.eventType\' | translate) }}</label><ui-select ng-model="$viewSheet.chosen.serviceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="true" search-enabled="false"><ui-select-match><span ng-if="$viewSheet.chosen.serviceType.none"><i>{{(\'modules.events.overview.allEventTypes\' | translate)}}</i></span> <span ng-if="!$viewSheet.chosen.serviceType.none">{{$viewSheet.chosen.serviceType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="serviceType in $viewSheet.availableServiceTypes"><span>{{serviceType.Name}}</span></ui-select-choices></ui-select></div><div class="mb-15 ml-5 form-group"><label>{{ (\'modules.events.overview.category\' | translate) }}</label><tag-picker default-label="\'modules.events.overview.allCategories\' | translate" tags="$viewSheet.categories" selected-tags="$viewSheet.chosen.categories" hide-division-name="true" on-group-func="$viewSheet.categoryGroupFunc" disabled="!$viewSheet.categories.length"></tag-picker></div></div><div class="col-md-8 col-md-pull-4"><div class="btn-group mb-15 service-refiner dual" ng-if="$viewSheet.getShowElement(\'hasServiceManageOrItemPerm\', true, $viewSheet.ctx)"><button type="button" class="btn" ng-class="$viewSheet.chosen.refiner === \'MY_SERVICES\' ? \'btn-primary active\' : \'btn-default\'" ng-click="$viewSheet.chosen.refiner = \'MY_SERVICES\'">{{ (\'modules.events.overview.myServices\' | translate) }}</button> <button type="button" class="btn" ng-if="$viewSheet.getShowElement(\'hasServiceManageOrItemPerm\', true, $viewSheet.ctx)" ng-class="$viewSheet.chosen.refiner === \'MANAGE\' ? \'btn-primary active\' : \'btn-default\'" ng-click="$viewSheet.chosen.refiner = \'MANAGE\'">{{ (\'modules.events.overview.manage\' | translate) }}</button></div><event-calendar chosen-shared-filters="$viewSheet.chosen" categories="$viewSheet.categories" cal-view="$viewSheet.chosen.nearFutureView ? \'nearFuture\' : \'listMonth\'" cal-mode="\'SERVICE\'" loop-back="$viewSheet.loopBack" flow-step-config="$viewSheet.flowStepConfig" ctx="$viewSheet.ctx"></event-calendar></div></div></div></div></div>');
$templateCache.put('app/pages/events/service/service.html','<div ba-panel="" ba-panel-tag-list="$ceService.panelTagList" ba-panel-title="$ceService.serviceData.Subject ? (\'modules.events.service.service\' | translate) + \' - \' + $ceService.serviceData.Subject : \'modules.events.service.NewService\'" class="arno-events arno-services"><form id="serviceEditForm" name="serviceEditForm" novalidate="" angular-validator="" angular-validator-submit="$ceService.submitService()"><div class="organizer-hint mb-5">{{ \'modules.events.event.createdBy\' | translate}} <span ng-class="{\'font-weight-500\': !$ceService.serviceData.Organizer.isInactive, \'member-inactive\': $ceService.serviceData.Organizer.isInactive}">{{ ::$ceService.serviceData.Organizer.fullName || $root.ctx.currentUser.fullName }}</span> in <span class="font-weight-500">{{ ::$ceService.sourceDivisionName }}</span>.<div class="pull-right" ng-show="$ceService.canDeleteService && !$ceService.metaFieldFrozen"><button type="button" class="btn btn-danger btn-xs btn-with-icon mt-5" ng-show="$ceService.canDeleteService" ng-click="$ceService.deleteService()"><i class="ion-ios-trash"></i> {{ (\'modules.events.service.deleteService\' | translate) }}</button></div></div><div class="row mt-4 mb-15" ng-if="$ceService.hasManagePermsInSourceDivOrForItem"><div class="col-md-12"><flow-bar flow="$ceService.flow" view-only="$ceService.viewMode === \'view\' || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" flow-label="\'modules.events.service.service\' | translate"></flow-bar></div><div ng-if="$ceService.stepChangeHints.requirements.length || $ceService.stepChangeHints.config.length || $ceService.stepChangeHints.configRemoved.length" class="col-md-6"><div class="alert bg-info mb-0 mt-20"><div ng-if="$ceService.stepChangeHints.requirements.length"><span class="font-weight-500">{{ (\'modules.events.service.newRequirments\' | translate) }}</span><ul><li ng-repeat="hint in $ceService.stepChangeHints.requirements"><span ng-if="::hint === \'metaFieldsRequired\'">{{ (\'modules.events.service.changeHints.changeHints\' | translate) }}</span> <span ng-if="::hint === \'shiftCountRequired\'">{{ (\'modules.events.service.changeHints.changeHints2\' | translate) }}</span> <span ng-if="::hint === \'allPositionsTaken\'">{{ (\'modules.events.service.changeHints.changeHints3\' | translate) }}</span> <span ng-if="::hint === \'reportRequired\'">{{ (\'modules.events.service.changeHints.changeHints4\' | translate) }}</span></li></ul></div><div ng-if="$ceService.stepChangeHints.config.length || $ceService.stepChangeHints.configRemoved.length"><span class="font-weight-500">{{ (\'modules.events.service.changeHints.changeHints5\' | translate) }}</span><div ng-repeat="(hintAdded, type) in [\'configRemoved\', \'config\']"><ul ng-repeat="hint in $ceService.stepChangeHints[type]" class="mb-0"><li ng-if="::hint === \'backAvailable\' && !hintAdded">{{ (\'modules.events.service.changeHints.changeHints6\' | translate) }}</li><li ng-if="::hint === \'freezeMetadata\'">{{ (\'modules.events.service.changeHints.theServiceCan\' | translate) }} {{::hintAdded ? (\'modules.events.service.changeHints.not\' | translate) : \'\'}} {{ (\'modules.events.service.changeHints.changeHints7\' | translate) }}</li><li ng-if="::hint === \'freezeMetadata\'">{{ (\'modules.events.service.changeHints.changeHints8\' | translate) }} {{::hintAdded ? (\'modules.events.service.changeHints.not\' | translate) : \'\'}} {{ (\'modules.events.service.changeHints.changeHints7\' | translate) }}</li><li ng-if="::hint === \'freezeMetadata\'">{{ (\'modules.events.service.changeHints.changeHints9\' | translate) }} {{::hintAdded ? (\'modules.events.service.changeHints.madePossible\' | translate) : (\'modules.events.service.changeHints.madePossible\' | translate) }}</li><li ng-if="::hint === \'freezeMetadata\' && hintAdded">{{ (\'modules.events.service.changeHints.participantsRemoved\' | translate) }}</li><li ng-if="::hint === \'freezeMetadata\' && hintAdded">{{ (\'modules.events.service.changeHints.materialsRemoved\' | translate) }}</li><li ng-if="::hint === \'displayPositionAssocForAll\'">{{ (\'modules.events.service.changeHints.changeHints21\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate)}}</li><li ng-if="::hint === \'accessibleByView\'">{{ (\'modules.events.service.changeHints.theServiceCan\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate) }} {{ (\'modules.events.service.changeHints.changeHints10\' | translate) }}</li><li ng-if="::hint === \'accessibleByManage\'">{{ (\'modules.events.service.changeHints.theServiceCan\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate) }} {{ (\'modules.events.service.changeHints.changeHints11\' | translate) }}</li><li ng-if="::hint === \'accessibleByAttendee\'">{{ (\'modules.events.service.changeHints.theServiceCan\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate) }} {{ (\'modules.events.service.changeHints.changeHints12\' | translate) }}</li><li ng-if="::hint === \'accessibleByArchive\'">{{ (\'modules.events.service.changeHints.theServiceCan\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate) }} {{ (\'modules.events.service.changeHints.changeHints13\' | translate) }}</li><li ng-if="::hint === \'selfAttend\'">{{ (\'modules.events.service.changeHints.changeHints14\' | translate) }} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.notAnymore\' | translate)}} {{ (\'modules.events.service.changeHints.changeHints15\' | translate) }}</li><li ng-if="::hint === \'reportAvailable\'">{{::hintAdded ? (\'modules.events.service.changeHints.changeHints16\' | translate) : (\'modules.events.service.changeHints.changeHints17\' | translate)}}</li><li ng-if="::hint === \'remarkAvailable\'">{{(\'modules.events.service.changeHints.changeHints18\' | translate)}} {{::hintAdded ? \'\' : (\'modules.events.service.changeHints.changeHints19\' | translate)}} {{(\'modules.events.service.changeHints.changeHints20\' | translate)}}</li></ul></div></div></div></div></div><div ng-show="$ceService.mediaSizeXS && $ceService.hasManagePermsInSourceDivOrForItem"><label class="custom-checkbox"><input type="checkbox" ng-model="$ceService.shiftTemplateOpts.mobileEdit"> <span>{{ \'modules.events.service.editActivate\' | translate }}</span></label><arno-ba-help-tooltip text="{{ \'modules.events.service.mobildeView\' | translate }}"></arno-ba-help-tooltip></div><h3 class="with-line" toggle-next="$ceService.metaSectionToggleClose">{{ \'modules.events.service.characteristics\' | translate }}</h3><div><div ng-include="\'app/pages/events/service/partials/mainServiceData.html\'"></div><div ng-include="\'app/pages/events/service/partials/serviceShare.html\'" class="mb-10"></div></div><h3 class="with-line" id="shift-section" toggle-next=""><span>{{ (\'modules.events.service.shifts\' | translate) }}</span><div class="btn-group pull-right ml-5" ng-if="$ceService.serviceData.ServiceShifts.length" ng-click="$event.stopPropagation()" uib-dropdown=""><button uib-dropdown-toggle="" type="button" ng-if="(!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)" class="btn btn-default btn-xs btn-with-icon mt-9"><i class="fa fa-download"></i> <span class="hidden-xs">{{ \'modules.events.service.download\' | translate }}</span> <span class="caret ml-3 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li role="menuitem" ng-if="$ceService.serviceData.ServiceShifts.length"><a href="" ng-click="$ceService.shiftTemplateOpts.closeDropdown() && $ceService.shiftTemplateOpts.downloadICAL($event, $ceService.serviceData.ServiceShifts)"><i class="fa fa-calendar dropdown-icon"></i> {{ (\'modules.events.service.shiftcalendar\' | translate) }}</a></li><li role="menuitem" ng-if="$ceService.serviceData.ServiceShifts.length && ($ceService.hasManagePermsInSourceDivOrForItem || $ceService.canPartiallyEdit)"><a href="" ng-click="$ceService.shiftTemplateOpts.closeDropdown() && $ceService.exportWorkingHours()"><i class="fa fa-clock-o dropdown-icon"></i> {{ (\'modules.events.service.exportWorkingHours\' | translate) }}</a></li><li role="menuitem" ng-if="$ceService.serviceData.ServiceShifts.length && $ceService.hasManagePermsInSourceDivOrForItem"><a href="" ng-click="$ceService.shiftTemplateOpts.closeDropdown() && $ceService.exportAttendeeList()"><i class="fa fa-user dropdown-icon"></i> {{ (\'modules.events.service.exportAttendeeList\' | translate) }}</a></li></ul></div><div class="btn-group pull-right" ng-if="$ceService.serviceData.ServiceShifts.length && $ceService.hasManagePermsInSourceDivOrForItem" ng-click="$event.stopPropagation()" uib-dropdown=""><button uib-dropdown-toggle="" type="button" ng-if="(!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)" class="btn btn-default btn-xs btn-with-icon mt-9"><i class="fa fa-envelope"></i><span class="hidden-xs">{{ (\'modules.events.service.Message\' | translate) }}</span><span class="caret ml-3 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li class="dropdown-header">{{ (\'modules.events.service.ServiceWideViaEmail\' | translate) }}</li><li role="menuitem"><a href="" ng-click="$ceService.shiftTemplateOpts.closeDropdown() && $ceService.shiftTemplateOpts.sendMessage($ceService.serviceData.ServiceShifts, \'ACCEPTED_PLANNED\')">{{ (\'modules.events.service.ToPlannedParticipants\' | translate) }}</a></li><li role="separator" class="divider"></li><li class="dropdown-header">{{ (\'modules.events.service.ServiceWideViaArno\' | translate) }}</li><li role="menuitem" ng-class="{\'disabled\': $ceService.hideComponent.flowSelfAttend}" title="{{$ceService.hideComponent.flowSelfAttend ? (\'modules.events.service.inviteAttendeeTitle\' | translate) : \'\'}}"><a href="" ng-click="!$ceService.hideComponent.flowSelfAttend && $ceService.shiftTemplateOpts.closeDropdown() && $ceService.shiftTemplateOpts.inviteAttendee($ceService.serviceData.ServiceShifts)">{{ (\'modules.events.service.participantInvitation\' | translate) }}</a></li></ul></div></h3><div><input type="hidden" class="form-control" name="serviceShiftValidation" ng-model="$ceService.serviceShiftValidationEmpty" validator="$ceService.serviceShiftValid(true)" invalid-message="\'\'"><div class="alert bg-danger inline-block has-error" ng-if="!$ceService.serviceShiftValid(true)"><strong>{{ (\'modules.events.service.shiftConfigurationInvalid\' | translate) }}</strong><div ng-repeat="reason in $ceService.serviceShiftValid()"><div ng-if="!reason.type"><ul class="mb-0"><li ng-if="reason === \'shiftCountRequired\'">{{ (\'modules.events.service.oneShiftNeeded\' | translate) }}</li><li ng-if="reason === \'bookingMaterialTimeRequired\'">{{ (\'modules.events.service.bookingMaterialTimeRequired\' | translate) }}</li></ul></div><div ng-if="reason.type === \'allPositionsTaken\'"><ul ng-repeat="(isOver, metaList) in [reason.under, reason.over]" class="mb-0"><li ng-repeat="meta in metaList">{{ (\'modules.events.service.shiftPositionText\' | translate) }} "{{meta.position}}" {{ (\'modules.events.service.shiftPositionText2\' | translate) }} "{{meta.shift}}" {{ (\'modules.events.service.shiftPositionText3\' | translate) }} {{isOver ? (\'modules.events.service.shiftPositionText4\' | translate) : (\'modules.events.service.shiftPositionText5\' | translate)}} {{ (\'modules.events.service.shiftPositionText6\' | translate) }}</li></ul></div></div></div><shift-template shareddivisions="$ceService.serviceData" options="$ceService.shiftTemplateOpts"></shift-template></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="$ceService.expectedShortAmountCount"><label class="custom-checkbox"><input type="checkbox" name="expectsExpectedShortAmountCount" class="from-control" ng-model="$ceService.expectsExpectedShortAmountCount" required="" required-message="\'modules.events.service.requiredExpectShortAmountCount\' | translate"> <span><span>(<i class="fa fa-cube ml-1 text-danger"></i>)</span> <span class="font-weight-500">{{ (\'modules.events.service.expectBookingMaterialShortAmountCount\' | translate:{ amount: $ceService.expectedShortAmountCount }) }}</span></span></label></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="$ceService.canTransferHelperHours && $ceService.flow.lastSavedStep !== $ceService.flow.activeStep"><label class="custom-checkbox"><input type="checkbox" name="wantsTransferHelperHoursCheckbox" class="from-control" ng-model="$ceService.wantsTransferHelperHours"> <span><span class="font-weight-500">{{ (\'modules.events.service.carryOutHelperHours\' | translate) }}</span></span></label></div><div class="mt-10 p-10 pb-13 border-top border-bottom" ng-if="!$ceService.serviceData.id"><label class="custom-checkbox"><input type="checkbox" name="acceptGuidelineCheckbox" class="from-control" ng-model="$ceService.acceptGuidelineCheckbox" required="" required-message="\'modules.events.service.AcceptGuideText3\' | translate"> <span><span class="font-weight-500">{{ (\'modules.events.service.AcceptGuideText\' | translate) }}<br>{{ (\'modules.events.service.AcceptGuideText2\' | translate) }}</span></span></label><div class="ml-20 pl-2"><i><span class="font-weight-500">{{ (\'modules.events.service.AcceptGuideHint\' | translate) }}</span> {{ (\'modules.events.service.AcceptGuideHint2\' | translate) }}</i></div></div><div class="row btns-row mt-20"><div class="col-md-12"><button type="button" class="btn btn-default btn-with-icon" ng-click="$ceService.back()"><i class="ion-ios-arrow-back"></i><span>{{ (\'modules.events.service.back\' | translate) }}</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$ceService.refreshOnSave=true;$ceService.validationScroll(serviceEditForm)" ng-if="$ceService.canSaveService && (!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)"><i class="ion-checkmark"></i><span>{{ (\'generalTerms.save\' | translate) }}</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$ceService.refreshOnSave=false;$ceService.validationScroll(serviceEditForm)" ng-if="$ceService.canSaveService && (!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)"><i class="ion-checkmark"></i><span>{{ (\'modules.events.service.saveAndBack\' | translate) }}</span></button> <button type="button" class="btn btn-info btn-with-icon pull-right" ng-if="$ceService.canTransferHelperHours && $ceService.flow.lastSavedStep === $ceService.flow.activeStep" ng-click="$ceService.helperHoursTransfer()"><i class="fa fa-clock-o"></i> {{ (\'modules.events.service.tranferHelperHours\' | translate) }}</button><div class="btn-group pull-right dropup" uib-dropdown="" is-open="self.actionsOpen" ng-if="(!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit) && $ceService.hasManagePermsInSourceDivOrForItem"><button type="button" class="btn btn-info" uib-dropdown-toggle=""><span translate="generalTerms.actions"></span> <span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-with-icons" uib-dropdown-menu="" role="menu"><li class="arno-pointing-pointer" ng-click="$ceService.createQuotInv($ceService.serviceData, \'invoice\')"><a class="arno-pointing-pointer"><i class="af af-finance-coins mr-2"></i> <span>{{ (\'modules.events.service.createBill\' | translate) }}</span></a></li><li class="arno-pointing-pointer" ng-click="$ceService.createQuotInv($ceService.serviceData, \'quotation\')"><a class="arno-pointing-pointer"><i class="ion ion-ios-paper-outline"></i> <span>{{ (\'modules.events.service.createOffer\' | translate) }}</span></a></li><li class="arno-pointing-pointer" ng-click="$ceService.cloneService()"><a class="arno-pointing-pointer" data-toggle="tooltip" data-placement="bottom" title="{{ (\'modules.events.service.cloneServiceTooltip\' | translate) }}"><i class="ion ion-ios-copy-outline"></i> <span>{{ (\'modules.events.service.cloneService\' | translate) }}</span></a></li></ul></div></div></div></form></div>');
$templateCache.put('app/pages/finances/demandForAction/demandForAction.html','<div ng-repeat="type in $ctrl.types" ng-if="$ctrl.isPermitted(type.perm, type.key)" ba-panel="" ba-panel-title="\'modules.finances.demandForAction.panelTitle\'" ba-panel-title-translate-vars="type.panelTitleVars" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission-scoped="type.perm"><div><div><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm">{{ \'generalTerms.entriesPerPage\' | translate }}</span> ({{ $ctrl.pageSize[type.key] }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(i, type.key)">{{ i }}</a></li></ul></div></div><div class="table-responsive mt-20"><table st-table="$ctrl[type.key]" st-pipe="type.getterFn" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Creator">{{ (\'modules.finances.demandForAction.requestedBy\' | translate) }}</th><th>{{ (\'modules.finances.demandForAction.originServiceName\' | translate) }}</th><th>{{ (\'modules.finances.demandForAction.requestCreatedAt\' | translate) }}</th><th class="arno-table-button-cell">{{ \'generalTerms.actions\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Creator" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th sort="createdAt"></th><th></th></tr></thead><tbody><tr ng-repeat="quotInv in $ctrl[type.key]"><td><span>{{ ::quotInv.Creator }}</span></td><td><span>{{ ::(quotInv.Origin.element.Subject || quotInv.Origin.element.Title || quotInv.Origin.element.Name) }}</span></td><td><span>{{ ::quotInv.createdAt | date:\'dd.MM.yyyy HH:mm\' }}</span></td><td class="arno-default-pointer"><div class="nowrap"><button class="btn btn-danger btn-with-icon btn-xs ml-5" ng-click="$ctrl.deny(quotInv, type.key)"><i class="fa fa-ban"></i> <span class="btn-span hidden-xs" translate="generalTerms.deny"></span></button> <button class="btn btn-primary btn-with-icon btn-xs" ng-click="$ctrl.edit(quotInv, type.key)" translate-attr="{ title: \'generalTerms.edit\' }"><i class="fa fa-pencil"></i> {{ \'generalTerms.edit\' | translate }}</button></div></td></tr><tr ng-if="!$ctrl[type.key] || $ctrl[type.key].length === 0"><td class="text-center" colspan="99"><i>{{ \'modules.finances.demandForAction.notAvailable\' | translate }}</i></td></tr></tbody><tfoot ng-if="$ctrl.showPager[type.key]"><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$ctrl.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/finances/modals/financeProcessServiceDetails.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.finances.processStepSelector.serviceDetailsTitle"></h4></div><div class="modal-body"><div><table ng-if="$ctrl.positions && $ctrl.positions.length" st-table="$ctrl.positions" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Title">{{ \'generalTerms.title\' | translate }}</th><th st-sort="Amount">{{ \'modules.finances.processStepSelector.table.amount\' | translate }}</th></tr><tr></tr></thead><tbody><tr ng-repeat="pos in $ctrl.positions"><td>{{ pos.Title }}</td><td>{{ pos.Amount }}</td></tr></tbody></table><div ng-if="!$ctrl.positions || !$ctrl.positions.length" class="text-center"><i>{{ \'modules.finances.processStepSelector.noServicePositions\' | translate }}</i></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.close"></button></div></div>');
$templateCache.put('app/pages/finances/modals/renameProcess.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.finances.processStepSelector.editProcessTitle"></h4></div><div class="modal-body"><div class="alert bg-warning"><h4 translate="modules.finances.processStepSelector.nameProcessInfoTitle"></h4><p translate="modules.finances.processStepSelector.nameProcessInfoText"></p></div><div><input class="form-control" placeholder="{{ \'models.FinanceProcess.Title\' | translate }}" ng-model="$ctrl.process.Title"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.process.Title" ng-click="$ctrl.applyModal()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/finances/modals/selectProcessElement.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" ng-if="!$selCtrl.viewOnly" translate="modules.finances.processStepSelector.modalTitle"></h4><h4 class="modal-title" ng-if="$selCtrl.viewOnly" translate="modules.finances.processStepSelector.viewOnlyTitle" translate-values="{ title: $selCtrl.process.Title }"></h4></div><div class="modal-body"><div ng-if="!$selCtrl.viewOnly" class="alert bg-warning"><h4 translate="modules.finances.processStepSelector.infoTitle"></h4><p translate="modules.finances.processStepSelector.infoText"></p></div><div ng-if="$selCtrl.enableTitleEdit" class="mb-20"><label translate="models.FinanceProcess.Title"></label> <input class="form-control" ng-model="$selCtrl.title" type="text"></div><finance-process-list process-steps="$selCtrl.processSteps" process="$selCtrl.process" flow-step-configs="$selCtrl.flowStepConfigs" ctx="$selCtrl.ctx" view-only="$selCtrl.viewOnly" on-select="$selCtrl.onSelect" origin-params="$selCtrl.originParams" modal-dismiss="$dismiss" origin-unapproved="$selCtrl.originUnapproved"></finance-process-list></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-if="$selCtrl.enableTitleEdit" ng-disabled="!$selCtrl.title" ng-click="$close($selCtrl.title)" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/finances/quotInvDetails/quotInvDetails.html','<div class="arno-finances"><div ba-panel="" ba-panel-title="self.panelTitle" ba-panel-title-translate-vars="self.panelTitleVars" ba-panel-tag-list="self.panelTagList"><div class="creator-hint mb-5"><span translate="modules.finances.quotInvDetails.createdBy"></span> <span class="font-weight-500">{{::self.baseData.Creator || $root.ctx.currentUser.fullName }}</span> in <span class="font-weight-500">{{ ::self.sourceDivisionName }}</span>.<div class="pull-right" ng-if="self.canDelete && !self.needsApproval"><button type="button" class="btn btn-danger btn-xs btn-with-icon mt-5" ng-click="self.remove()"><i class="ion-ios-trash"></i> <span translate="modules.finances.quotInvDetails.remove" translate-values="self.translateIsInvoice"></span></button></div></div><div class="row mt-4 mb-15"><div class="col-md-12"><flow-bar flow="self.flow" flow-label="\'modules.finances.quotInvDetails.flowStepPhase\' | translate:self.translateIsInvoice"></flow-bar></div></div><div class="alert bg-danger mb-10" ng-if="self.creationUnavailableDivisionDataMissing">{{ \'modules.finances.quotInvDetails.creationUnavailableDivisionDataMissing\' | translate }}</div><form id="quotInvDetailsDataForm" name="quotInvDetailsDataForm" novalidate="" angular-validator="" angular-validator-submit="self.saveQuotInv()"><h3 class="with-line" toggle-next=""><span><span translate="modules.finances.quotInvDetails.process"></span></span></h3><div><div class="row"><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.finances.quotInvDetails.titleField" translate-values="self.translateIsInvoice"></label> <input type="text" class="form-control" placeholder="" name="qidTitle" required-message="\'\'" required="" ng-model="self.baseData.Title" ng-disabled="self.metaFieldFrozen"></div></div><div class="form-group row clearfix mb-10"><div class="col-md-6" ng-if="!self.baseData.QuotInvRemarks.length"><i>{{ (\'modules.finances.quotInvDetails.noRemarks\' | translate) }}</i></div><div class="col-md-6 mt-1" ng-if="self.baseData.QuotInvRemarks.length"><div class="quotinv-remark" ng-repeat="remark in self.baseData.QuotInvRemarks | orderBy:[\'createdAt\'] track by $index"><h5 class="quotinv-remark-heading" title="{{ (\'modules.finances.quotInvDetails.quotInvRemarkTitle1\' | translate) }} {{remark.Member.fullName}} {{ (\'modules.finances.quotInvDetails.quotInvRemarkTitle2\' | translate) }} {{remark.createdAt | date:\'dd.MM.yyyy HH:mm\'}} {{ (\'modules.finances.quotInvDetails.quotInvRemarkTitle3\' | translate:self.translateIsInvoice) }} {{self.getFlowstepLabelByIdent(remark.FlowState)}}">{{remark.Member.fullName}} <span>{{ (\'modules.events.ServiceData.oclock\' | translate: { time: (remark.createdAt | date:\'dd.MM.yyyy HH:mm\') }) }}</span></h5><div class="quotinv-remark-body white-space-pre-line word-break">{{remark.Content}}</div></div></div><div class="form-group col-md-6"><label class="control-label" translate="modules.finances.quotInvDetails.internalComment"></label><arno-ba-help-tooltip text="{{ (\'modules.finances.quotInvDetails.quotInvRemarkInfo\' | translate) }}"></arno-ba-help-tooltip><textarea ng-if="!self.lastSavedStepConfig.accessibleByArchive" class="form-control no-resize" style="height: 104px;" id="qidInternalComment" name="qidInternalComment" max-char="4000" ng-model="self.baseData.InternalComment"></textarea><div ng-if="self.lastSavedStepConfig.accessibleByArchive" style="min-height: 104px;" class="alert bg-light-gray mb-0 white-space-pre-line">{{self.baseData.InternalComment}}</div></div></div><div class="row" ng-if="self.baseData.FinalizationDate"><div class="form-group col-md-6"><label class="control-label" translate="models.Quotation.FinalizationDate"></label><p class="input-group"><input type="text" name="finalizationDate" class="form-control" ng-disabled="true" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="self.baseData.FinalizationDate" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-disabled="true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="row" ng-if="self.shouldShowStatusArea"><div class="form-group col-md-6" ng-if="self.shouldShowSentStateField"><label class="control-label" ng-class="{\'required-label\': self.sentStateFieldRequired}" translate="modules.finances.quotInvDetails.sentState.label"></label><ui-select ng-model="self.sentStateModel" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" on-select="self.baseData.SentState = self.sentStateModel.value" search-enabled="false" ng-disabled="self.lastSavedStepConfig.accessibleByArchive" append-to-body="false"><ui-select-match placeholder=""><span ng-if="self.sentStateModel.state">{{ (\'modules.finances.quotInvDetails.sentState.\' + self.sentStateModel.state | translate) }}</span> <span ng-if="!self.sentStateModel.state">&nbsp;</span></ui-select-match><ui-select-choices position="down" repeat="sentState in self.sentStateOptions"><span ng-if="sentState.state">{{ (\'modules.finances.quotInvDetails.sentState.\' + sentState.state | translate) }}</span> <span ng-if="!sentState.state"><i translate="modules.finances.quotInvDetails.notSpecified"></i></span></ui-select-choices></ui-select><input type="hidden" class="form-control" name="sentStateModelValidation" ng-model="self.sentStateModelValidationEmpty" validator="!self.sentStateFieldRequired || (self.sentStateModel && self.sentStateModel.value !== null)" invalid-message="\'\'"></div><div class="form-group col-md-6" ng-if="self.shouldShowClosingStateField"><label class="control-label" ng-class="{\'required-label\': self.closingStateFieldRequired}" translate="modules.finances.quotInvDetails.closingState.label" translate-values="self.translateIsInvoice"></label><ui-select ng-model="self.closingStateModel" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" on-select="self.baseData.ClosingState = self.closingStateModel.value" search-enabled="false" ng-disabled="self.lastSavedStepConfig.accessibleByArchive || self.closingStateModel.nonSelectableSticky" append-to-body="false"><ui-select-match placeholder=""><span ng-if="self.closingStateModel.state">{{ (\'modules.finances.quotInvDetails.closingState.\' + self.closingStateModel.state | translate:self.translateIsInvoice)}}</span> <span ng-if="!self.closingStateModel.state">&nbsp;</span></ui-select-match><ui-select-choices position="down" repeat="closingState in (self.shouldUseArchivalStates ? self.closingStateOptionsArchive : self.closingStateOptions)"><span ng-if="closingState.state">{{ (\'modules.finances.quotInvDetails.closingState.\' + closingState.state | translate:self.translateIsInvoice) }}</span> <span ng-if="!closingState.state"><i translate="modules.finances.quotInvDetails.notSpecified"></i></span></ui-select-choices></ui-select><input type="hidden" class="form-control" name="closingStateModelValidation" ng-model="self.closingStateModelValidationEmpty" validator="!self.sentStateFieldRequired || (self.closingStateModel && self.closingStateModel.value !== null)" invalid-message="\'\'"></div></div></div><h3 class="with-line" toggle-next="self.metaSectionToggleClose"><span><span translate="modules.finances.quotInvDetails.creator"></span></span></h3><div><div class="row"><div class="col-xs-12 col-md-6"><h4 class="with-line" translate="modules.administration.divisions.address"></h4><div class="row"><div class="col-xs-12"><arno-ba-address class="clearfix" address="self.baseData.SalesDocMeta.address" form-ref="quotInvDetailsDataForm" country-ids-catalogue="self.MEMBER_COUNTRY_IDS" fields-config="self.baseDataAddressFieldsConfig" ui-config="self.baseDataAddressUiConfig" view-only="self.metaFieldFrozen"></arno-ba-address></div></div></div><div class="col-xs-12 col-md-6"><h4 class="with-line" translate="modules.administration.divisions.contact"></h4><div><div class="row"><div class="form-group col-md-6"><label class="control-label" translate="modules.finances.quotInvDetails.contactPersonName"></label> <input type="text" class="form-control" placeholder="" name="qidContactPersonName" ng-model="self.baseData.SalesDocMeta.ContactPersonName" ng-disabled="self.metaFieldFrozen"></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.phone"></label> <input type="text" class="form-control" placeholder="" name="qidPhone" ng-model="self.baseData.SalesDocMeta.Phone" ng-disabled="self.metaFieldFrozen"></div><div class="form-group col-md-6"><label class="control-label" translate="modules.administration.divisions.fax"></label> <input type="text" class="form-control" placeholder="" name="qidFax" ng-model="self.baseData.SalesDocMeta.Fax" ng-disabled="self.metaFieldFrozen"></div><div class="form-group col-lg-6"><label class="control-label" translate="modules.administration.divisions.email"></label> <input type="text" class="form-control" placeholder="" id="qidEMail" name="qidEMail" ng-model="self.baseData.SalesDocMeta.EMail" invalid-message="\'modules.administration.divisions.emailInvalid\' | translate" validator="self.validEMail(self.baseData.SalesDocMeta.EMail)" ng-disabled="self.metaFieldFrozen"></div><div class="form-group col-lg-6"><label class="control-label" translate="modules.administration.divisions.website"></label> <input type="text" class="form-control" placeholder="" name="qidWebsite" ng-model="self.baseData.SalesDocMeta.Website" ng-disabled="self.metaFieldFrozen"></div></div></div></div></div><h4 class="with-line" translate="modules.administration.divisions.finance"></h4><div class="row"><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.iban"></label> <input type="text" class="form-control" placeholder="" id="qidIBAN" name="qidIBAN" ng-model="self.baseData.SalesDocMeta.IBAN" ng-disabled="self.metaFieldFrozen" required-message="\'\'" required="" invalid-message="\'modules.administration.divisions.ibanInvalid\' | translate" validator="self.validIBAN(self.baseData.SalesDocMeta.IBAN)"></div><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.bic"></label> <input type="text" class="form-control" placeholder="" id="qidBIC" name="qidBIC" ng-model="self.baseData.SalesDocMeta.BIC" ng-disabled="self.metaFieldFrozen" required-message="\'\'" required="" invalid-message="\'modules.administration.divisions.bicInvalid\' | translate" validator="self.validBIC(self.baseData.SalesDocMeta.BIC)"></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label required-label" translate="modules.administration.divisions.bank"></label> <input type="text" class="form-control" placeholder="" id="qidBank" name="qidBank" ng-model="self.baseData.SalesDocMeta.Bank" ng-disabled="self.metaFieldFrozen" required-message="\'\'" required=""></div></div></div><h3 class="with-line" toggle-next=""><span><span translate="modules.finances.quotInvDetails.meta"></span></span></h3><div><div class="row"><div class="col-md-6"><div class="form-group"><business-partners-selector division="self.ctx" is-buyer="self.businessPartnerConf.buyer" is-seller="self.businessPartnerConf.seller" selection-proposals="self.divisionBusinessPartners" on-business-partner-select="self.setBusinessPartner" selected-business-partner="self.baseData.BusinessPartner" details-extra-label="\'modules.finances.quotInvDetails.client\'" extra-label-cls="\'control-label required-label\'" enable-details="true" ng-disabled="self.metaFieldFrozen"></business-partners-selector><input type="hidden" class="form-control" id="businessPartnerValidation" name="businessPartnerValidation" ng-model="self.businessPartnerValidationEmpty" validator="!!self.baseData.BusinessPartner" invalid-message="\'modules.finances.quotInvDetails.wrongMessageClient\' | translate"></div><div class="form-group" ng-if="!self.isReversalInvoice"><label class="control-label" ng-class="{\'required-label\': self.checkUntilFieldRequirement()}" translate="modules.finances.quotInvDetails.untilDate" translate-values="self.translateIsInvoice"></label><p class="input-group"><input type="text" name="inputEventUntilDate" class="form-control" ng-disabled="self.metaFieldFrozen || self.isInvoice" placeholder="{{ self.isInvoice ? (\'modules.finances.quotInvDetails.payableUntilHint\' | translate) : \'\'}}" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="self.baseData.untilDate" is-open="self.openedInputUntilDate" close-text="{{\'generalTerms.close\' | translate}}" show-button-bar="false" required-message="\'\'" invalid-message="\'\'" ng-required="self.checkUntilFieldRequirement()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.openedInputUntilDate = !self.openedInputUntilDate" ng-disabled="self.metaFieldFrozen || self.isInvoice"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" translate="modules.finances.quotInvDetails.coverNote"></label> <textarea ng-if="!self.metaFieldFrozen" class="form-control no-resize" style="height: 104px;" id="qidCoverNote" name="qidCoverNote" max-char="4000" ng-model="self.baseData.CoverNote"></textarea><div ng-if="self.metaFieldFrozen" style="min-height: 104px;" class="alert bg-light-gray mb-0 white-space-pre-line">{{self.baseData.CoverNote}}</div></div></div></div><div class="row" ng-if="self.isInvoice"><div class="col-md-6"><div class="form-group"><label class="control-label" ng-class="{\'required-label\': self.orderDateFieldRequired}" translate="modules.finances.quotInvDetails.orderDate"></label><p class="input-group"><input type="text" name="inputEventOrderDate" class="form-control" ng-disabled="self.metaFieldFrozen" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="self.baseData.OrderDate" is-open="self.openedInputOrderDate" close-text="{{\'generalTerms.close\' | translate}}" show-button-bar="false" ng-required="self.orderDateFieldRequired" invalid-message="\'\'" required-message="\'\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.openedInputOrderDate = !self.openedInputOrderDate" ng-disabled="self.metaFieldFrozen"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" ng-class="{\'required-label\': self.performanceDateFieldRequired}" translate="modules.finances.quotInvDetails.performanceDate"></label><p class="input-group"><input type="text" name="inputEventPerformanceDate" class="form-control" ng-disabled="self.metaFieldFrozen" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="self.baseData.PerformanceDate" is-open="self.openedInputPerformanceDate" close-text="{{\'generalTerms.close\' | translate}}" show-button-bar="false" ng-required="self.performanceDateFieldRequired" invalid-message="\'\'" required-message="\'\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.openedInputPerformanceDate = !self.openedInputPerformanceDate" ng-disabled="self.metaFieldFrozen"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" ng-class="{\'required-label\': self.ccdsFieldRequired}" translate="modules.finances.quotInvDetails.costCenterAndDefaultSpec" translate-values="self.translateIsInvoice"></label><cost-center-spec-selector selected-cost-center-spec="self.baseData.CostCenterSpecification" on-cost-center-spec-select="self.costCenterOnSelect" ng-disabled="self.metaFieldFrozen"></cost-center-spec-selector><input type="hidden" class="form-control" id="costCenterSpecificationModelValidation" name="costCenterSpecificationModelValidation" ng-model="self.costCenterSpecificationModelValidationEmpty" validator="!self.ccdsFieldRequired || !!self.baseData.CostCenterSpecification" invalid-message="\'\'"></div></div></div></div><h3 class="with-line" toggle-next=""><span><span translate="modules.finances.quotInvDetails.positions" translate-values="self.translateIsInvoice"></span></span></h3><div><arno-finance-positions positions="self.baseData.SalesDocPositions" context="self.ctx" meta-data="self.metaData" ng-disabled="self.metaFieldFrozen"></arno-finance-positions></div><div class="row btns-row mt-20"><div ng-if="!self.processSelectorParams" class="col-md-12"><div class="alert bg-danger has-error" ng-if="!self.exportAvailable"><strong translate="modules.finances.quotInvDetails.saveUnavailableExportMissing"></strong></div><button type="button" class="btn btn-default btn-with-icon" ng-click="self.back()"><i class="ion-ios-arrow-back"></i> <span translate-values="{ needsApproval: self.needsApproval }" translate="modules.finances.quotInvDetails.back"></span></button> <button type="button" ng-if="self.needsApproval" class="btn btn-danger btn-with-icon" ng-click="self.remove()"><i class="fa fa-ban"></i> <span translate="modules.finances.quotInvDetails.deny" translate-values="self.translateIsInvoice"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="self.refreshOnSave=true;self.validationScroll(quotInvDetailsDataForm)" ng-disabled="!self.saveAvailable || self.lastSavedStepConfig.accessibleByArchive" title="{{ self.exportAvailable ? \'\' : (\'modules.docxTemplates.noExport\' | translate) }}"><i class="ion-checkmark"></i> <span translate-values="{ needsApproval: self.needsApproval, isInvoice: self.isInvoice }" translate="modules.finances.quotInvDetails.save"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="self.refreshOnSave=false;self.validationScroll(quotInvDetailsDataForm)" ng-disabled="!self.saveAvailable || self.lastSavedStepConfig.accessibleByArchive" title="{{ self.exportAvailable ? \'\' : (\'modules.docxTemplates.noExport\' | translate) }}"><i class="ion-checkmark"></i> <span translate-values="{ needsApproval: self.needsApproval, isInvoice: self.isInvoice }" translate="modules.finances.quotInvDetails.saveAndBack"></span></button> <button type="button" class="btn btn-info btn-with-icon pull-right" ng-click="self.openReversalTarget(self.reversalInvoiceTargetId)" ng-if="self.baseData.id && !self.needsApproval && self.isInvoice && self.reversalInvoiceTargetId"><i class="fa fa-undo"></i> <span translate="modules.finances.quotInvDetails.jumpToReversalInvoice" translate-values="{isReversal: self.isReversalInvoice}"></span></button><div class="btn-group pull-right dropup" uib-dropdown="" is-open="self.actionsOpen" ng-if="self.baseData.id && !self.needsApproval"><button type="button" class="btn btn-info" uib-dropdown-toggle=""><span translate="generalTerms.actions"></span> <span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-with-icons" uib-dropdown-menu="" role="menu"><li class="arno-pointing-pointer" ng-if="self.baseData.id && !self.needsApproval && self.isSent && !self.isInvoice && self.canEditInvoices" ng-click="self.convert(self.baseData.id, \'invoice\')"><a class="arno-pointing-pointer"><i class="af af-finance-coins mr-2"></i> <span>{{ \'modules.finances.quotInvDetails.convertToInvoice\' | translate }}</span></a></li><li ng-if="self.baseData.id && !self.needsApproval && !self.isInvoice" ng-click="self.convert(self.baseData.id, \'quotation\')"><a class="arno-pointing-pointer"><i class="ion-ios-paper-outline"></i> <span>{{ \'modules.finances.quotInvDetails.convertToQuotation\' | translate:{ recreate: !self.isInvoice } }}</span></a></li><li class="arno-pointing-pointer" ng-class="{ disabled: self.baseData.ConvertToServiceDemand }" ng-if="self.baseData.id && !self.needsApproval && !self.isInvoice" title="{{ self.baseData.ConvertToServiceDemand ? (\'modules.finances.quotInvDetails.convertToServiceInProgressHint\' | translate) : \'\'}}" ng-click="!self.baseData.ConvertToServiceDemand && self.convert(self.baseData.id, \'service\')"><a class="arno-pointing-pointer"><i class="ion-calendar"></i> <span>{{ \'modules.finances.quotInvDetails.convertToService\' | translate }}</span></a></li><li class="arno-pointing-pointer" ng-class="{ disabled: !self.reversalExportAvailable }" ng-if="self.baseData.id && !self.needsApproval && self.metaFieldFrozen && self.isInvoice && !self.isReversalInvoice && !self.reversalInvoiceTargetId" title="{{self.reversalExportAvailable ? \'\' : (\'modules.finances.quotInvDetails.reversalInvoiceTemplateUnavailable\' | translate)}}" ng-click="self.reversalExportAvailable && self.convert(self.baseData.id, \'reversalInvoice\')"><a class="arno-pointing-pointer"><i class="fa fa-undo"></i> <span>{{ \'modules.finances.quotInvDetails.reversalInvoice\' | translate }}</span></a></li><li class="arno-pointing-pointer" ng-if="self.baseData.id" title="{{ self.exportAvailable ? \'\' : (\'modules.docxTemplates.noExport\' | translate) }}" ng-class="{ disabled: !self.exportAvailable }" ng-click="self.exportAvailable && self.export()"><a class="arno-pointing-pointer"><i class="fa fa-file-pdf-o"></i> <span>{{ \'modules.finances.quotInvDetails.downloadPdf\' | translate:{ needsApproval: self.needsApproval } }}</span></a></li></ul></div></div><div ng-if="self.isProcessDetails" class="col-md-12"><button ng-if="!self.processSelectorParams.enableRepick" type="button" class="btn btn-default btn-with-icon" ng-click="self.back()"><i class="ion-ios-arrow-back"></i> <span translate="modules.finances.quotInvDetails.back"></span></button> <button ng-if="self.processSelectorParams.enableRepick" type="button" class="btn btn-default btn-with-icon" ng-click="self.reselectProcessElement()"><i class="fa fa-undo"></i> <span translate="modules.finances.quotInvDetails.reselectProcessElement"></span></button> <button ng-if="self.processSelectorParams.enableRepick" type="button" class="btn btn-success btn-with-icon" ng-click="self.selectProcessElement()"><i class="fa fa-check"></i> <span translate="modules.finances.quotInvDetails.selectProcessElement"></span></button></div></div></form></div></div>');
$templateCache.put('app/pages/finances/quotInvList/quotInvList.html','<div class="arno-finances arno-finances-list"><div ba-panel="" ba-panel-title="\'modules.finances.quotInvList.title\'" ba-panel-title-translate-vars="self.translateIsInvoice" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="{{self.entryPermission}}"><div class="row"><div class="col-xs-2"><button class="btn btn-primary btn-with-icon" ng-disabled="!self.ctx || self.ctx.length !== 1" title="{{(!self.ctx || self.ctx.length !== 1) ? (\'modules.finances.quotInvList.newQuotInvDisabled\' | translate:self.translateIsInvoice) : \'\'}}" ng-click="self.openDetails()"><i class="fa ion-plus"></i><span class="hidden-xs" translate="modules.finances.quotInvList.newQuotInv" translate-values="self.translateIsInvoice"></span></button></div><div uib-dropdown="" dropdown-toggle="" class="col-xs-2"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ self.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="self.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive mt-20"><table st-table="self.displayedCollection" st-pipe="self.getData" class="table table-condensed table-hover"><thead><tr class="sortable" ng-if="self.isInvoice"><th>{{ (\'models.FinanceProcess\' | translate) }}</th><th st-sort="InvoiceNumber">{{ (\'models.Invoice.InvoiceNumber\' | translate) }}</th><th>{{ (\'models.Invoice.Title\' | translate) }}</th><th st-sort="FlowState">{{ (\'models.Invoice.FlowState\' | translate) }}</th><th st-sort="BusinessPartner.Name">{{ (\'modules.finances.quotInvList.clientName\' | translate) }}</th><th st-sort="PayableUntil">{{ (\'models.Invoice.PayableUntil\' | translate) }}</th><th st-sort="FinalizationDate">{{ (\'models.Quotation.FinalizationDate\' | translate) }}</th><th st-sort="FinalAmount">{{ (\'models.Invoice.FinalAmount\' | translate) }}</th><th ng-if="self.ctx && self.ctx.length > 1" st-sort="Division.Name">{{ (\'models.Division\' | translate) }}</th><th>{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr class="sortable" ng-if="!self.isInvoice"><th>{{ (\'models.FinanceProcess\' | translate) }}</th><th st-sort="QuotationNumber">{{ (\'models.Quotation.QuotationNumber\' | translate) }}</th><th>{{ (\'models.Quotation.Title\' | translate) }}</th><th st-sort="FlowState">{{ (\'models.Quotation.FlowState\' | translate) }}</th><th st-sort="BusinessPartner.Name">{{ (\'modules.finances.quotInvList.clientName\' | translate) }}</th><th st-sort="ValidUntil">{{ (\'models.Quotation.ValidUntil\' | translate) }}</th><th st-sort="FinalizationDate">{{ (\'models.Quotation.FinalizationDate\' | translate) }}</th><th st-sort="FinalAmount">{{ (\'models.Quotation.FinalAmount\' | translate) }}</th><th ng-if="self.ctx && self.ctx.length > 1" st-sort="Division.Name">{{ (\'models.Division\' | translate) }}</th><th>{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="{{ (self.isInvoice ? \'InvoiceNumber\' : \'QuotationNumber\') }}" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Title" type="search" class="form-control with-default-addon input-sm"></div></th><th><ab-multiselect st-multiselect-search="FlowState" ng-model="self.flowStateFilter" options="self.possibleStates" id-prop="ident" display-prop="label" show-tooltip="true" classes-btn="\'btn-block btn-sm\'" placeholder="{{(\'modules.finances.quotInvList.flowStateFilterPlaceholder\' | translate:self.translateIsInvoice)}}"></ab-multiselect></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="BusinessPartner.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FinalAmount" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="self.ctx && self.ctx.length > 1"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="quotInv in self.displayedCollection"><td><span ng-click="self.openProcessDetails(quotInv.FinanceProcess)" class="arno-tag tag label label-tag label-warning arno-pointing-pointer mr-0">{{ ::quotInv.FinanceProcess.Title }}</span> <span ng-if="quotInv.SentState !== null" class="arno-tag tag label label-tag mr-3" ng-class="quotInv.SentState ? \'label-success\' : \'label-danger\'" title="{{\'modules.finances.quotInvDetails.sentState.\' + (quotInv.SentState ? \'sent\' : \'notSent\') | translate}}"><i class="fa" ng-class="quotInv.SentState ? \'fa fa-envelope-o\' : \'fa fa-envelope-open-o\'"></i></span></td><td ng-if="self.isInvoice"><span ng-if="::quotInv.InvoiceNumber">{{ ::quotInv.InvoiceNumber }}</span> <i ng-if="::!quotInv.InvoiceNumber">{{ (\'modules.finances.quotInvList.draft\' | translate) }}</i></td><td ng-if="!self.isInvoice"><span ng-if="::quotInv.QuotationNumber">{{ ::quotInv.QuotationNumber }}</span> <i ng-if="::!quotInv.QuotationNumber">{{ (\'modules.finances.quotInvList.draft\' | translate) }}</i></td><td>{{ ::quotInv.Title }} <span ng-if="quotInv.Reversal" class="arno-tag tag label label-tag label-info mr-3"><i class="fa fa-undo"></i> {{ \'modules.finances.quotInvList.reversal\' | translate }}</span> <span ng-if="quotInv.ClosingState !== null" class="arno-tag tag label label-tag mr-3" ng-class="quotInv.ClosingState === \'POSITIVE\' ? \'label-success\' : \'label-danger\'" title="{{\'modules.finances.quotInvDetails.closingState.\' + (quotInv.ClosingState.toLocaleLowerCase()) | translate:self.translateIsInvoice}}"><i class="fa" ng-class="quotInv.ClosingState === \'POSITIVE\' ? \'fa fa-check\' : \'fa fa-times\'"></i> <span>{{\'modules.finances.quotInvDetails.closingState.\' + (quotInv.ClosingState.toLocaleLowerCase()) | translate:self.translateIsInvoice}}</span></span></td><td><span>{{ ::self.flowStateMap[quotInv.FlowState].label }}</span></td><td><i ng-if="quotInv.BusinessPartner.IsInternal" class="fa fa-sitemap" title="{{ ::(\'modules.contacts.businessPartners.overview.systemDivisionBusinessPartnerTooltip\' | translate) }}"></i> <i ng-if="!quotInv.BusinessPartner.IsInternal" class="ion-ios-people-outline" title="{{ ::(\'modules.contacts.businessPartners.overview.divisionBusinessPartnerTooltip\' | translate) }}"></i> <span ng-if="quotInv.BusinessPartner.IsInternal">({{ ::self.orgName }})</span> <span>{{ ::(quotInv.BusinessPartner.IsInternal ? quotInv.BusinessPartner.OwnerDivision.Name : quotInv.BusinessPartner.Name) }}</span></td><td ng-if="self.isInvoice"><span ng-if="::!quotInv.Reversal">{{ ::quotInv.PayableUntil | date: \'dd.MM.yyyy\' }}</span> <span ng-if="::quotInv.Reversal">---</span></td><td ng-if="!self.isInvoice"><span>{{ ::quotInv.ValidUntil | date: \'dd.MM.yyyy\' }}</span></td><td><span>{{ ::quotInv.FinalizationDate | date: \'dd.MM.yyyy\' }}</span></td><td><span>{{ ::quotInv.FinalAmount | currency: \'\u20AC\' }}</span></td><td ng-if="self.ctx && self.ctx.length > 1"><span>{{ ::quotInv.Division.Name }}</span></td><td><button class="btn btn-default btn-with-icon btn-xs" ng-click="self.openDetails(quotInv)" title="{{ quotInv.FlowState !== \'DRAFT\' ? \'generalTerms.view\' : \'generalTerms.edit\' | translate }}"><i ng-class="quotInv.FlowState === \'DRAFT\' ? \'ion-edit\' : \'fa fa-eye\'"></i> <span translate="{{ quotInv.FlowState !== \'DRAFT\' ? \'generalTerms.view\' : \'generalTerms.edit\' }}"></span></button> <button class="btn btn-danger btn-with-icon btn-xs ml-5" ng-click="self.remove(quotInv)" ng-if="quotInv.FlowState === \'DRAFT\'"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="self.displayedCollection && self.displayedCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.finances.quotInvList.quotInvPlaceholder" translate-values="self.translateIsInvoice"></i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="self.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/legalPages/privacyStatement/privacyStatement.html','<div><div ba-panel="" ba-panel-title="\'Datenschutzerkl\xE4rung\'"><div ng-bind-html="$ctrl.privacyTerms.TextContent"></div><p class="small-text mt-15"><i>Letzte Ver\xF6ffentlichung: {{$ctrl.privacyTerms.createdAt}} Uhr. Letzte Aktualisierung: {{$ctrl.privacyTerms.updatedAt}} Uhr</i></p></div></div>');
$templateCache.put('app/pages/legalPages/termsOfUse/termsOfUse.html','<div><div ba-panel="" ba-panel-title="\'Nutzungsbedingungen (ARNO Portal)\'" ng-if="$ctrl.termsARNO"><div ng-bind-html="$ctrl.termsARNO.TextContent"></div><p class="small-text mt-15"><i>Letzte Ver\xF6ffentlichung: {{$ctrl.termsARNO.updatedAt}} Uhr</i></p></div><div ba-panel="" ba-panel-title="\'Nutzungsbedingungen \' + $root.ctx.organization.current.name"><div ng-bind-html="$ctrl.terms.TextContent"></div><p class="small-text mt-15"><i>Letzte Ver\xF6ffentlichung: {{$ctrl.terms.updatedAt}} Uhr</i></p></div></div>');
$templateCache.put('app/pages/material/addMaterial/addMaterial.html','<div class="modal-content"><div class="modal-header"><div><h4 class="modal-title" ng-if="!$matAddCtrl.updateMode && !$matAddCtrl.viewOnly">{{(\'modules.material.addMaterial.title\' | translate)}} {{$matAddCtrl.materialName}} {{ $matAddCtrl.materialHead }}</h4><div><h4 class="modal-title" ng-if="$matAddCtrl.updateMode && !$matAddCtrl.viewOnly">Material - {{$matAddCtrl.materialName}} {{ $matAddCtrl.materialHead }} <button type="button" ng-click="$matAddCtrl.ctc()" class="btn btn-default btn-xs btn-with-icon" title="{{ \'generalTerms.copyToClipboard\' | translate }}"><i class="fa fa-clipboard"></i></button></h4></div><h4 class="modal-title" ng-if="$matAddCtrl.updateMode && $matAddCtrl.viewOnly">{{(\'modules.material.addMaterial.title3\' | translate)}} - {{$matAddCtrl.materialName}} {{ $matAddCtrl.materialHead }}</h4><span class="badge bg-info mr-5 mt-3" ng-if="$matAddCtrl.HandedOverToMember.length > 0"><i class="fa fa-user mr-3"></i> <span>Ausgegeben an {{ $matAddCtrl.HandedOverToMember.length === 1 ? $matAddCtrl.HandedOverToMember[0].fullName: \'mehrere Personen\'}}</span></span><div ng-if="$matAddCtrl.hasUpcomingInspectionSection"><span class="badge bg-danger mr-5 mt-3" ng-if="$matAddCtrl.upcomingInspection.failed.length"><i class="fa fa-ban mr-3"></i> <span ng-repeat="failed in $matAddCtrl.upcomingInspection.failed">{{ failed.Name }}{{ !$last ? \', \' : \' \'}} <span ng-if="$last">{{ \'modules.material.addMaterial.inspection.upcomingInspectionFailed\' | translate }}</span></span></span> <span class="badge bg-danger mr-5 mt-3" ng-if="$matAddCtrl.upcomingInspection.overdue.length"><i class="fa fa-exclamation-triangle mr-3"></i> <span ng-repeat="overdue in $matAddCtrl.upcomingInspection.overdue">{{ overdue.Name }} ({{overdue.since | date:\'dd.MM.yyyy\'}}){{ !$last ? \', \' : \' \'}} <span ng-if="$last">{{ \'modules.material.addMaterial.inspection.upcomingInspectionOverdue\' | translate }}</span></span></span> <span class="badge bg-warning mr-5 mt-3" ng-if="$matAddCtrl.upcomingInspection.todo.length"><i class="fa fa-undo mr-3"></i> <strong>{{ \'modules.material.addMaterial.inspection.upcomingInspectionTodo\' | translate }}</strong> <span ng-repeat="todo in $matAddCtrl.upcomingInspection.todo">{{ $first ? \'(\' : \'\'}}{{ todo.Name }}{{ !$last ? \', \' : \'\'}}{{ $last ? \')\' : \'\'}}</span></span> <span class="badge mt-3" ng-if="$matAddCtrl.upcomingInspection.next"><i class="fa fa-refresh mr-3"></i> <strong>{{ \'modules.material.addMaterial.inspection.upcomingInspectionNext\' | translate }}</strong> <span>{{ $matAddCtrl.upcomingInspection.next.Name }} ({{$matAddCtrl.upcomingInspection.next.due | date:\'dd.MM.yyyy\'}})</span></span></div></div><i class="fa fa-times modal-close" ng-click="$dismiss(null)"></i></div><uib-tabset active="$matAddCtrl.activeTabIndex"><uib-tab index="0" heading="{{ (\'modules.material.addMaterial.basedata\' | translate) }}"><div ng-include="\'app/pages/material/addMaterial/partials/baseData.html\'"></div></uib-tab><uib-tab index="1" heading="{{ (\'modules.material.addMaterial.bookingCalendar\' | translate) }}" select="$matAddCtrl.refreshBookingCalendar()" ng-if="$matAddCtrl.isSingleMaterial"><div ng-if="$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/saveRequired.html\'"></div><div ng-if="!$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/bookingCalendar.html\'"></div></uib-tab><uib-tab index="2" heading="{{\'generalTerms.fileStorage\' | translate }}" ng-if="$matAddCtrl.isPermittedForFileStorage && $matAddCtrl.isSingleMaterial"><div ng-if="$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/saveRequired.html\'"></div><div ng-if="!$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/fileStorage.html\'"></div></uib-tab><uib-tab index="3" heading="{{ (\'modules.administration.adminQualification.instructions\' | translate) }}"><div ng-include="\'app/pages/material/addMaterial/partials/instructions.html\'"></div></uib-tab><uib-tab index="4" heading="{{\'generalTerms.finances\' | translate }}" ng-if="$matAddCtrl.isPermitted(\'arno.administration.finances.prices.manage,arno.material.view.prices\') && $matAddCtrl.isSingleMaterial"><div ng-include="\'app/pages/material/addMaterial/partials/finance.html\'"></div></uib-tab><uib-tab index="5" heading="{{\'modules.material.addMaterial.inspection.tab\' | translate }}" ng-if="$matAddCtrl.isSingleMaterial && !$matAddCtrl.isSplit"><div ng-if="$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/saveRequired.html\'"></div><div ng-if="!$matAddCtrl.isNew" ng-include="\'app/pages/material/addMaterial/partials/inspections.html\'"></div></uib-tab><uib-tab index="6" heading="{{\'generalTerms.contents\' | translate }}" ng-if="$matAddCtrl.StorageContents"><div ng-include="\'app/pages/material/addMaterial/partials/storageContents.html\'"></div></uib-tab><uib-tab index="7" heading="{{ (\'modules.material.addMaterial.storageLocation\' | translate) }}"><div ng-include="\'app/pages/material/addMaterial/partials/storageLocation.html\'"></div></uib-tab><uib-tab index="8" heading="{{ (\'modules.material.addMaterial.personInCharge\' | translate) }}"><div class="material__responsiblePerson"><div><h2>Materialverantwortlicher</h2><div ng-include="\'app/pages/material/addMaterial/partials/responsibleMember.html\'"></div></div><div><h2>{{ (\'modules.material.addMaterial.handedOverTo\' | translate) }}</h2><div ng-include="\'app/pages/material/addMaterial/partials/handed-over-to-member.html\'"></div></div></div></uib-tab></uib-tabset><div class="modal-footer"><button ng-click="$dismiss(null)" type="button" class="btn btn-default pull-left"><i class="ion-chevron-left font-size-12 mr-5"></i><span translate="generalTerms.back"></span></button> <button type="submit" ng-if="!$matAddCtrl.viewOnly && !$matAddCtrl.isSplit" class="btn btn-with-icon btn-primary" ng-click="$matAddCtrl.back = false; $matAddCtrl.saveMaterial($matAddCtrl.addModel)"><i class="ion-checkmark"></i> <span translate="generalTerms.save"></span></button> <button type="submit" ng-if="!$matAddCtrl.viewOnly" class="btn btn-with-icon btn-primary" ng-click="$matAddCtrl.back = true; $matAddCtrl.saveMaterial($matAddCtrl.addModel)"><span translate="generalTerms.saveAndBack"></span></button> <button type="button" class="btn btn-primary pull-left ml-10" ng-if="$matAddCtrl.model === \'MaterialMedicalProducts\' && $matAddCtrl.isSingleMaterial && !$matAddCtrl.isNew" ng-disabled="!$matAddCtrl.templateAvailable" title="{{ (!$matAddCtrl.templateAvailable ? \'modules.material.addMaterial.exports.medicalProductBookDisabled\' : \'\') | translate }}" ng-click="$matAddCtrl.pdfExport(\'materialMedicalProductBook\')" translate="modules.material.addMaterial.exports.medicalProductBook"></button></div></div><style>\n  .material__responsiblePerson {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 20px;\n  }\n\n  @media (max-width: 1350px) {\n  .material__responsiblePerson {\n    grid-template-columns: 1fr;\n    row-gap: 32px;\n  }\n}\n</style>');
$templateCache.put('app/pages/material/demandForAction/materialDemandForAction.html','<div ba-panel="" ba-panel-title="\'modules.material.demandForAction.demandForAction\'" ba-panel-class="with-scroll" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-entry-permission="arno.material.view"><div class="arno-material-demand"><div class="clearfix"><div class="btn-toolbar"><div class="btn-group dropdown mr-10" uib-dropdown="" dropdown-append-to-body="" ng-if="$demandCtrl.taskMode.disabled"><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span ng-if="!$demandCtrl.dateSpan">{{ (\'modules.material.demandForAction.demandForAction\' | translate) }} in {{ $demandCtrl.daysInFuture }} {{ (\'modules.material.demandForAction.days\' | translate) }}</span> <span ng-if="$demandCtrl.dateSpan">{{ $demandCtrl.dateSpan.start | date:\'dd.MM.yyyy\'}} - {{ $demandCtrl.dateSpan.end | date:\'dd.MM.yyyy\'}}</span> <span class="ml-10 caret"></span></button><ul uib-dropdown-menu="" role="menu"><li role="menuitem" ng-repeat="i in [1,7,31,365]"><a href="" ng-click="$demandCtrl.setWellKnownDateSpan(i)">{{ (\'modules.material.demandForAction.dropdownMenuItem\' | translate:{ days: i }) }}</a></li></ul></div><button type="button" class="btn btn-default" ng-click="$demandCtrl.openDateSpanModal()"><span><i class="ion-wrench"></i></span></button></div><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm">{{ (\'generalTerms.entriesPerPage\' | translate) }}</span> ({{ $demandCtrl.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$demandCtrl.setPageSize(i)">{{ i }}</a></li></ul></div></div><div class="btn-toolbar" ng-class="$demandCtrl.hasEdit ? \'pull-right\' : \'v-align-top\'"><ba-switcher class="btn-height ml-5" switcher-style="primary" switcher-keys="$demandCtrl.taskMode.keys" switcher-width="$demandCtrl.taskMode.width" switcher-value="$demandCtrl.taskMode.disabled"></ba-switcher><button type="button" class="btn btn-primary pull-right" ng-if="$demandCtrl.hasEdit" ng-disabled="!$demandCtrl.selectCount" ng-click="$demandCtrl.addInspectionEvent()">{{ (\'modules.material.demandForAction.addInspectionEvent\' | translate:{ n: $demandCtrl.selectCount }) }}</button></div></div><div class="table-responsive"><table st-table="$demandCtrl.demandData" st-pipe="$demandCtrl.reload" class="table table-condensed table-hover arno-aggregatable-table"><thead><tr class="sortable"><th ng-if="$demandCtrl.hasEdit">{{ (\'modules.material.demandForAction.select\' | translate) }}</th><th st-sort="InspectionLabel">{{ (\'modules.material.demandForAction.inspection\' | translate) }}</th><th st-sort="Material">{{ (\'modules.material.demandForAction.material\' | translate) }}</th><th>{{ (\'modules.material.demandForAction.materialType\' | translate) }}</th><th st-sort="MaterialCategory">{{ (\'modules.material.demandForAction.materialCategory\' | translate) }}</th><th>{{ (\'modules.material.demandForAction.storageLocation\' | translate) }}</th><th>{{ (\'modules.material.demandForAction.personInCharge\' | translate) }}</th><th st-sort="Due" ng-if="$demandCtrl.taskMode.disabled">{{ (\'modules.material.demandForAction.Date\' | translate) }}</th><th>{{ (\'modules.material.demandForAction.inventoryNumber\' | translate) }}</th><th ng-if="$demandCtrl.isMultiDiv">{{ (\'generalTerms.division\' | translate) }}</th><th>{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th class="selection-row" ng-if="$demandCtrl.hasEdit"><span>({{ $demandCtrl.selectCount }})</span> <i ng-if="$demandCtrl.selectCount" class="fa fa-times text-danger arno-pointing-pointer" ng-click="$demandCtrl.deselectAll()"></i></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="InspectionLabel" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Material" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MaterialType" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Storage" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="ResponsibleMember" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$demandCtrl.taskMode.disabled"></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="InventoryNumber" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$demandCtrl.isMultiDiv"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$demandCtrl.demandData && $demandCtrl.demandData.length" ng-repeat="demand in $demandCtrl.demandData" ng-click="$demandCtrl.selected[demand.id] = !$demandCtrl.selected[demand.id]" class="arno-pointing-pointer"><td class="selection-row" ng-if="$demandCtrl.hasEdit"><input class="from-control" type="checkbox" ng-model="$demandCtrl.selected[demand.id]"></td><td class="align-left-force"><div>{{ demand.InspectionLabel }}</div><span class="arno-tag tag label label-tag label-danger" ng-if="demand.Failed">{{ (\'modules.material.demandForAction.failed\' | translate) }}</span> <span class="arno-tag tag label label-tag label-warning" ng-if="demand.Task">{{ (\'modules.material.demandForAction.task\' | translate) }}</span></td><td class="align-left-force">{{ demand.Material }}</td><td class="align-left-force">{{ demand.MaterialType }}</td><td class="align-left-force">{{ demand.MaterialCategoryLabel }}</td><td class="align-left-force">{{ demand.Storage }}</td><td class="align-left-force"><ul ng-if="demand.ResponsibleMember && demand.ResponsibleMember.length" class="responsible-member-table-row"><li ng-repeat="member in demand.ResponsibleMember" ng-class="{\'member-inactive\': (member.BlockReasonId || member.WithdrawalReasonId)}">{{ member.fullName + ((member.BlockReasonId || member.WithdrawalReasonId) ? \' (inaktiv)\' : \'\') }}</li></ul></td><td class="align-left-force" ng-if="$demandCtrl.taskMode.disabled"><div>{{ demand.Due | date:\'dd.MM.yyyy\' }}</div><span class="arno-tag tag label label-tag label-danger" ng-if="demand.Overdue">{{ (\'modules.material.demandForAction.overdue\' | translate) }}</span></td><td class="align-left-force">{{ demand.InventoryNumber }}</td><td ng-if="$demandCtrl.isMultiDiv" class="align-left-force">{{ demand.Division.Name }}</td><td class="align-left-force"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$demandCtrl.openMaterialDossier(demand.MaterialId, demand.MaterialCategory, $event)" title="{{ \'modules.material.demandForAction.toDossier\' | translate }}"><i class="fa fa-eye"></i><span translate="modules.material.demandForAction.toDossier"></span></button></td></tr><tr ng-if="!$demandCtrl.demandData || !$demandCtrl.demandData.length"><td class="text-center" colspan="99"><i>{{ (\'modules.material.demandForAction.noMaterials\' | translate) }}</i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$demandCtrl.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/material/export/chooseMaterialExportType.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.material.export.title\' | translate) }}</h4></div><div class="modal-body"><form name="groupForm"><div class="form-group"><ui-select ng-model="$chooseExportTypeCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $chooseExportTypeCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $chooseExportTypeCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div><div class="text-left"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" ng-model="$chooseExportTypeCtrl.fieldOption" value="tableConfig"> <span>{{ (\'modules.material.export.noteTable\' | translate) }}</span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" ng-model="$chooseExportTypeCtrl.fieldOption" value="all"> <span>{{ (\'modules.material.export.chooseFields\' | translate) }}</span></label></div></div></div><div class="text-left mt-10"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio3" ng-model="$chooseExportTypeCtrl.filterOption" value="filtered"> <span>{{ (\'modules.material.export.filteredData\' | translate) }}</span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio4" ng-model="$chooseExportTypeCtrl.filterOption" value="all"> <span>{{ (\'modules.material.export.allData\' | translate) }}</span></label></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ (\'generalTerms.cancel\' | translate) }}</button> <span><button type="button" class="btn btn-primary" ng-click="$chooseExportTypeCtrl.applyModal()">{{ (\'modules.material.export.download\' | translate) }}</button></span></div></div>');
$templateCache.put('app/pages/material/export/inventoryExport.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">Bestandsverzeichnis exportieren</h4></div><div class="modal-body"><form name="groupForm"><div class="form-group"><ui-select ng-model="$inventoryExportCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $inventoryExportCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $inventoryExportCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div></form><div><label class="d-flex align-items-center"><span translate="generalTerms.selectAll">Select All</span> <input type="checkbox" ng-change="$inventoryExportCtrl.toggleFields(\'all\')" ng-model="$inventoryExportCtrl.toggleCheckboxesStates.all" class="custom-control-input mt-0 ml-6"></label></div><section class="accordion" ng-repeat="(key, fields) in $inventoryExportCtrl.fieldSets"><input type="checkbox" name="collapse" id="handle-{{key}}" checked="checked"><h3 class="with-line handle modal-title"><label for="handle-{{key}}" translate="components.tableConfig.fields.{{key}}"></label></h3><div class="content table-responsive"><table class="table table-condensed"><thead><tr><th class="left-col top-row force-minimal" translate="components.tableConfig.availableFields">Verf\xFCgbare Felder</th><th class="top-row force-minimal text-center"><label class="d-flex align-items-center justify-content-center"><span translate="components.tableConfig.fieldsChoice">Auswahl</span> <input type="checkbox" ng-change="$inventoryExportCtrl.toggleFields(key)" ng-model="$inventoryExportCtrl.toggleCheckboxesStates[key]" class="custom-control-input mt-0 ml-6"></label></th></tr></thead><tbody><tr ng-repeat="field in fields"><td class="left-col force-minimal vertical-align-middle">{{ field.label | translate }}</td><td class="text-center force-minimal"><input type="checkbox" ng-model="field.selected" class="custom-control-input ng-pristine ng-untouched ng-valid ng-not-empty vertical-align-middle"> <span></span></td></tr></tbody></table></div></section></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ (\'generalTerms.cancel\' | translate) }}</button> <span><button type="button" class="btn btn-primary" ng-click="$inventoryExportCtrl.applyModal()">{{ (\'modules.material.export.download\' | translate) }}</button></span></div></div>');
$templateCache.put('app/pages/material/overview/materialOverview.html','<div class="tab-content" ng-if="$matCtrl.currentTableConf"><div class="btn-toolbar"><div class="btn-group dropdown" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ $matCtrl.currentTableConf.hasViewModifications ? (\'generalTerms.currentView\' | translate) : $matCtrl.currentTableConf.selectedView===\'0\' ? (\'generalTerms.defaultView\' | translate) : $matCtrl.currentTableConf.customViews[$matCtrl.currentTableConf.selectedView].Name }}<span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu"><li role="menuitem"><a href="" ng-if="$matCtrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$matCtrl.changeListView($matCtrl.currentTableConf, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in $matCtrl.currentTableConf.customViews"><a href="" ng-click="$matCtrl.changeListView($matCtrl.currentTableConf, val, key)">{{ val.Name }}</a></li></ul></div><button type="button" ng-if="::$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.view\')" class="btn btn-default" ng-click="$matCtrl.openTableConfig($matCtrl.currentTableConf)"><span><i class="ion-wrench"></i></span></button></div><div uib-dropdown="" dropdown-toggle="" class="ml-20 inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $matCtrl.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$matCtrl.setPageSize(i)">{{ i }}</a></li></ul></div><div class="btn-toolbar" ng-class="$demandCtrl.hasEdit ? \'pull-right\' : \'v-align-top\'"><ba-switcher class="btn-height ml-5" switcher-style="primary" switcher-keys="$matCtrl.aKeys" switcher-width="120" switcher-value="$matCtrl.active"></ba-switcher></div></div><div ng-if="!$matCtrl.splitMode" class="pull-right"><div uib-dropdown="" dropdown-toggle="" ng-if="$matCtrl.isPermitted(\'arno.material.view\')" class="pull-right ml-20"><button class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-download"></i> Export <span class="caret"></span></button><div uib-dropdown-menu="" role="menu" aria-labelledby="single-button" class="dropdown-menu-right"><li role="menuitem"><a href="" data-cy="personnel-personnellist-divisionmember-export" ng-click="$matCtrl.startExport()" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$matCtrl.migrate_responsible_to_handover()" translate="Material an Verantwortliche ausgeben"></a></li><li ng-if="$matCtrl.allowedInventoryExport()" role="menuitem"><a href="" ng-click="$matCtrl.startInventoryExport()" translate="modules.material.overview.ExportInventory"></a></li></div></div><button ng-if="$matCtrl.isPermitted(\'arno.material.edit\')" class="btn btn-primary btn-with-icon pull-right" ng-click="$matCtrl.openAddModal(null, \'add\')" ng-disabled="::$matCtrl.isMultiDiv" title="{{ $matCtrl.isMultiDiv ? \'Nicht verf\xFCgbar in mehrfacher Gliederungswahl\' : (\'modules.material.overview.addMaterial\' | translate) }}"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.material.overview.addMaterial"></span></button></div><div class="mt-40 table-responsive"><table ng-show="!$matCtrl.isLoading" st-table="$matCtrl.matData" st-pipe="$matCtrl.reloadMaterial" st-safe-src="$matCtrl.tableData" class="table table-condensed table-hover arno-aggregatable-table"><thead><tr class="sortable"><th st-sort="{{ header.prop }}" ng-repeat="header in $matCtrl.currentTableHead" ng-class="{aggregatable: $matCtrl.checkAggExcludes(header.prop) && !$matCtrl.splitMode}"><span>{{ header.label }}</span> <button class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-if="$matCtrl.checkAggExcludes(header.prop) && !$matCtrl.splitMode" title="{{ header.label }} {{(\'modules.material.overview.aggregate\' | translate)}}" ng-class="{active: $matCtrl.checkActiveAggs(header.prop)}" ng-click="$matCtrl.addAgg(header.prop, $event)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th ng-if="$matCtrl.isMultiDiv" st-sort="Division.Name" class="aggregatable"><span>{{(\'generalTerms.division\' | translate)}}</span> <button class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-if="$matCtrl.checkAggExcludes(header.prop) && !$matCtrl.splitMode" title="{{(\'modules.material.overview.ggregatedivision\' | translate)}}" ng-class="{active: $matCtrl.checkActiveAggs(\'Division.Name\')}" ng-click="$matCtrl.addAgg(\'Division.Name\', $event)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th class="arno-table-button-cell" translate="generalTerms.actions"></th></tr><tr><th ng-repeat="header in $matCtrl.currentTableHead"><div class="input-group" ng-if="$matCtrl.searchableCheck(header)"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="{{ header.prop }}" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$matCtrl.isMultiDiv"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$matCtrl.matData && $matCtrl.matData.length" ng-repeat="material in $matCtrl.matData track by $index" ng-style="{ \'color\': material.Active ? \'inherit\' : \'#aaa\' }"><td ng-repeat="header in $matCtrl.currentTableHead" class="align-left-force text-overflow overflow-title" ng-click="$matCtrl.openAddModal(material, \'update\')"><div ng-if="header.prop !== \'Storage\' && header.prop !== \'ResponsibleMember\'"><span ng-if="!$matCtrl.currentPropSet[header.prop] || ($matCtrl.currentPropSet[header.prop] && $matCtrl.currentPropSet[header.prop].type !== \'date\' && $matCtrl.currentPropSet[header.prop].type !== \'link\' && $matCtrl.currentPropSet[header.prop].type !== \'bool\') && !$matCtrl.currentPropSet[header.prop].type !== \'link\'">{{ (material[header.prop] === false ? \'Nein\' : material[header.prop] === true ? \'Ja\' : $matCtrl.applyFieldConfig($matCtrl.currentPropSet, material[header.prop], header.prop)) || \'-\'}}</span> <span ng-if="$matCtrl.currentPropSet[header.prop] && $matCtrl.currentPropSet[header.prop].type === \'link\'"><a href="{{ material[header.prop] }}" target="_blank" ng-if="material[header.prop].startsWith(\'http://\') || material[header.prop].startsWith(\'https://\')">{{ material[header.prop] }}</a> <span ng-if="!material[header.prop].startsWith(\'http://\') && !material[header.prop].startsWith(\'https://\')">{{ material[header.prop] }}</span></span> <span ng-if="$matCtrl.currentPropSet[header.prop] && $matCtrl.currentPropSet[header.prop].type === \'date\'">{{ $matCtrl.parseDate(material[header.prop]) || \'-\' | date:\'dd.MM.yyyy\'}}</span> <span ng-if="$matCtrl.currentPropSet[header.prop] && $matCtrl.currentPropSet[header.prop].type === \'bool\'">{{ $matCtrl.boolFormatter(material[header.prop]) || \'-\' }}</span></div><div ng-if="header.prop === \'ResponsibleMember\'"><ul ng-if="material[header.prop]"><li ng-repeat="member in material[header.prop].split(\', \')" ng-class="{\'member-inactive\': (member.indexOf(\'(inaktiv)\') > -1)}">{{ member.replace(\'Member.Title.PROFDR\', \'Prof. Dr\').replace(\'Member.Title.PROF\', \'Prof.\').replace(\'Member.Title.DR\', \'Dr.\') }}</li></ul></div><div ng-if="header.prop === \'Storage\'"><span class="arno-tag arno-storage-tag tag label label-tag" ng-class="{\'label-warning\': storage.id === null, \'label-danger\': !storage.permitted && storage.id, \'label-success\': storage.id && storage.permitted, \'arno-pointing-pointer\': storage.id && storage.permitted, \'arno-tag-noselect\': storage.id === null || !storage.permitted, }" ng-repeat="storage in material.StorageTags" ng-if="material.StorageTags && material.StorageTags.length" ng-click="$matCtrl.openAddModal(storage, \'viewOnly\', true)">{{ storage.label }}</span> <span ng-if="!material.StorageTags || !material.StorageTags.length">{{ material[header.prop] }}</span></div></td><td ng-if="$matCtrl.isMultiDiv" class="align-left-force" ng-click="$matCtrl.openAddModal(material, \'update\')"><span>{{ material[\'Division.Name\'] }}</span></td><td ng-if="!$matCtrl.splitMode" class="row-actions"><div uib-dropdown="" dropdown-toggle=""><button class="btn btn-default btn-small btn-with-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-plus"></i> Aktionen <span class="caret"></span></button><div uib-dropdown-menu="" role="menu" aria-labelledby="single-button" class="dropdown-menu-right"><li role="menuitem" ng-if="material.Amount > 1"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" ng-disabled="::$matCtrl.isMultiDiv || material.Amount<2" ng-if="$matCtrl.isPermitted(\'arno.material.edit\')" title="{{ $matCtrl.isMultiDiv ? (\'modules.material.overview.notAvailable\' | translate) : (\'modules.material.overview.divideMaterial\' | translate) }}" ng-click="$matCtrl.splitMaterial(material)"><i class="fa fa-arrows-alt" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Aufteilen</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" ng-disabled="::$matCtrl.isMultiDiv" title="{{ $matCtrl.isMultiDiv ? (\'modules.material.overview.notAvailable\' | translate) : (\'modules.material.overview.handOverMaterial\' | translate) }}" ng-click="$matCtrl.handOverMaterial(material)"><i class="fa fa-arrows-alt" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">{{ \'modules.material.overview.handOverMaterial\' | translate }}</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" ng-if="!$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.edit\') && $matCtrl.isPermitted(\'arno.material.view\')" title="{{ $matCtrl.isMultiDiv ? \'Nicht verf\xFCgbar in mehrfacher Gliederungswahl\' : \'Material einsehen\' }}" ng-disabled="::$matCtrl.isMultiDiv" ng-click="$matCtrl.openAddModal(material, \'viewOnly\')"><i class="fa fa-eye" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Einsehen</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="Material Inaktiv setzen" ng-if="$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.edit\') && material.Active" ng-disabled="::$matCtrl.isMultiDiv" ng-click="$matCtrl.UpdateState(material, false)"><i class="fa fa-cube" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Inaktiv setzen</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="Material Aktiv setzen" ng-if="$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.edit\') && !material.Active" ng-disabled="::$matCtrl.isMultiDiv" ng-click="$matCtrl.UpdateState(material, true)"><i class="fa fa-cube" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Aktiv setzen</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="{{ $matCtrl.isMultiDiv ? (\'modules.material.overview.notAvailable\' | translate) : (\'modules.material.overview.deleteMaterial\' | translate) }}" ng-disabled="::$matCtrl.isMultiDiv" ng-if="$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.edit\') && !material.Active" ng-click="$matCtrl.prepareDelete(material)"><i class="ion-ios-trash" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">L\xF6schen</span></a></li><li role="menuitem"><a href="" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" ng-if="$matCtrl.isPermitted(\'arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.view\') && $matCtrl.checkIfStorageLocation(material)" title="Details zu diesem Lagerort" ng-click="$matCtrl.openStorageDetailModal(material)"><i class="ion-search" aria-hidden="true"></i> <span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Details</span></a></li></div></div></td><td ng-if="$matCtrl.splitMode" class="row-actions"><button class="btn btn-default btn-with-icon btn-xs" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="{{ material.Amount <= 1 ? (\'modules.material.overview.divideMaterial2\' | translate) : (\'modules.material.overview.divideMaterial\' | translate) }}" ng-disabled="material.Amount <= 1" ng-click="$matCtrl.splitMaterial(material)"><span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Aufteilen</span> <i class="fa fa-expand" aria-hidden="true"></i></button> <button class="btn btn-default btn-with-icon btn-xs" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="{{(\'modules.material.overview.editMaterial\' | translate)}}" ng-click="$matCtrl.openAddModal(material, \'split\')"><span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">Bearbeiten</span> <i class="fa fa-pencil" aria-hidden="true"></i></button> <button class="btn btn-success btn-with-icon btn-xs" ng-class="{\'arno-customMaterialButton\': !$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS, \'arno-customMaterialButton-mobile\': $matCtrl.mediaSizeSM || $matCtrl.mediaSizeXS }" title="{{ material.id ? (\'modules.material.overview.deleteMaterialentry2\' | translate) : (\'modules.material.overview.deleteMaterialentry\' | translate) }}" ng-disabled="$matCtrl.checkOrigEntry(material)" ng-click="$matCtrl.deleteSplitMaterial(material)"><span ng-if="!$matCtrl.mediaSizeSM && !$matCtrl.mediaSizeXS">L\xF6schen</span> <i class="ion-ios-trash" aria-hidden="true"></i></button></td></tr><tr ng-if="!$matCtrl.matData || !$matCtrl.matData.length"><td class="text-center" colspan="{{ $matCtrl.currentTableHead.length + 1 + $matCtrl.isMultiDiv }}"><i translate="modules.material.overview.noMaterialsAvailable"></i></td></tr></tbody><tfoot style="height: 60px;"><tr><td colspan="{{( $matCtrl.currentTableHead.length + 1 )}}" class="text-center"><st-pagination st-items-by-page="$matCtrl.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div ng-if="$matCtrl.splitMode" class="mt-40"><button ng-if="$matCtrl.isPermitted(\'arno.material.edit\')" class="btn btn-primary btn-with-icon pull-right mb-20" ng-click="$matCtrl.saveSplitMaterial($matCtrl.splitEdit.splitRows)"><i class="ion-checkmark"></i> <span class="hidden-xs" translate="generalTerms.save"></span></button> <button class="btn btn-default btn-with-icon pull-left mb-20" ng-click="$matCtrl.abortSplit()"><i class="fa fa-chevron-left"></i><span class="hidden-xs" translate="modules.material.overview.backToTheList"></span></button></div></div><div ng-if="!$matCtrl.currentTableConf"><div class="arno-background-info ng-scope"><div class="info-icon"><i class="fa fa-sitemap"></i></div><div class="missing-text ng-scope" translate="modules.material.overview.pleaseChooseArea"></div></div></div>');
$templateCache.put('app/pages/material/precisionSelectModal/precisionSelect.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.material.precisionSelect.selection\' | translate) }} {{ ::$selectCtrl.multiSelect ? \'(Mehrfachauswahl)\' : \'(Einzelauswahl)\' }}</h4></div><div class="modal-body"><div class="table-responsive"><table st-table="$selectCtrl.fullTableData" class="table table-condensed table-hover arno-aggregatable-table"><thead><tr class="sortable"><th>{{ (\'modules.material.precisionSelect.selection\' | translate) }}</th><th st-sort="{{ header.prop }}" ng-repeat="header in $selectCtrl.currentTableHead"><span>{{ header.label }}</span></th></tr></thead><tbody><tr ng-if="$selectCtrl.fullTableData && $selectCtrl.fullTableData.length" ng-repeat="material in $selectCtrl.fullTableData"><td><label class="custom-checkbox"><input type="checkbox" ng-change="$selectCtrl.checkSelection(material.id)" ng-model="$selectCtrl.selectedItems[material.id]" class="custom-control-input"> <span></span></label></td><td ng-repeat="header in $selectCtrl.currentTableHead" class="align-left-force"><span ng-if="!$selectCtrl.currentPropSet[header.prop] || ($selectCtrl.currentPropSet[header.prop] && $selectCtrl.currentPropSet[header.prop].type !== \'date\' && $selectCtrl.currentPropSet[header.prop].type !== \'bool\')">{{ (material[header.prop] === false ? \'Nein\' : material[header.prop] === true ? \'Ja\' : material[header.prop]) || \'-\'}}</span> <span ng-if="$selectCtrl.currentPropSet[header.prop] && $selectCtrl.currentPropSet[header.prop].type === \'date\'">{{ material[header.prop] || \'-\' | date:\'dd.MM.yyyy\'}}</span> <span ng-if="$selectCtrl.currentPropSet[header.prop] && $selectCtrl.currentPropSet[header.prop].type === \'bool\'">{{ (material[header.prop] === false || material[header.prop] === \'0\' ? \'Nein\' : material[header.prop] === true || material[header.prop] === \'1\' ? \'Ja\' : material[header.prop]) || \'-\' }}</span></td></tr></tbody></table></div></div><div class="modal-footer"><button type="submit" ng-click="$selectCtrl.confirmSelection($selectCtrl.selectedItems)" class="btn btn-primary">{{ (\'generalTerms.confirm\' | translate) }}</button> <button ng-click="$dismiss(null)" type="button" class="btn btn-default">{{ (\'generalTerms.close\' | translate) }}</button></div></div>');
$templateCache.put('app/pages/material/splitCountModal/splitCount.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.material.splitCount.materialCount\' | translate) }}</h4></div><div class="modal-body"><p>{{ (\'modules.material.splitCount.materialCount2\' | translate) }} (Max. {{::($splitCtrl.originalAmount - 1)}}):</p><input class="form-control" type="number" min="1" max="{{::($splitCtrl.originalAmount - 1)}}" step="1" ng-init="$splitCtrl.newAmount = 1" ng-model="$splitCtrl.newAmount"></div><div class="modal-footer"><hr><button type="submit" ng-click="$close($splitCtrl.newAmount)" class="btn btn-primary">{{ (\'generalTerms.save\' | translate) }}</button> <button ng-click="$dismiss(null)" type="button" class="btn btn-default">{{ (\'generalTerms.close\' | translate) }}</button></div></div>');
$templateCache.put('app/pages/material/splitCountModal/splitMaterial.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.material.splitCount.materialCount\' | translate) }}</h4></div><div class="modal-body"><div class="row"><div class="alert bg-warning ng-scope"><span>{{ (\'modules.material.splitCount.info\' | translate:{splitCount: $splitMaterialCtrl.newAmount || $splitMaterialCtrl.initialValue}) }}</span></div></div><p>{{ (\'modules.material.splitCount.materialCount2\' | translate) }} (Max. {{$splitMaterialCtrl.originalAmount - 1}}): {{$splitMaterialCtrl.newAmount}}</p><div class="row"><div class="col-md-9"><input class="form-control" type="range" min="1" max="{{$splitMaterialCtrl.originalAmount - 1}}" step="1" ng-value="$splitMaterialCtrl.initialValue" ng-model="$splitMaterialCtrl.newAmount"></div><div class="col-md-3"><input class="form-control" type="number" ng-model="$splitMaterialCtrl.newAmount" ng-value="$splitMaterialCtrl.initialValue"></div></div><div class="row"><div class="col-md-9"><label class="custom-checkbox"><input type="checkbox" name="duplicateFiles" ng-model="$splitMaterialCtrl.isFile"> <span><span>{{ \'modules.material.splitCount.copy_files\' | translate }}</span></span></label></div></div><div class="row"><div class="col-md-9"><label class="custom-checkbox"><input type="checkbox" name="duplicateEvents" ng-model="$splitMaterialCtrl.isEvent"> <span><span>{{ \'modules.material.splitCount.copy_events\' | translate }}</span></span></label></div></div></div><div class="modal-footer"><hr><button type="submit" ng-click="$close({ amount: $splitMaterialCtrl.newAmount, isFile: $splitMaterialCtrl.isFile, isEvent: $splitMaterialCtrl.isEvent })" class="btn btn-primary">{{ (\'generalTerms.save\' | translate) }}</button> <button ng-click="$dismiss(null)" type="button" class="btn btn-default">{{ (\'generalTerms.close\' | translate) }}</button></div></div>');
$templateCache.put('app/pages/material/statistics/statistics.html','<h1>Lagebild</h1><div role="spacer" style="margin: 7rem 0;"></div><div class="row"><div class="col-md-3"><h2>Link</h2><a ng-show="$ctrl.showResourceMapLink()" href="https://lagebild.arno.cloud" target="_blank" title="Link zur Lagebild-App" style="margin-right: 1rem;"><button class="btn btn-default" style="border: 1px solid red;"><img width="30" height="30" src="assets/img/lagebild-logo.png" style="margin-right: 1rem;"> <span style="font-weight: 600; font-size: 13px;">Lagebild App</span></button></a></div><div class="col-md-9"><h2>Anmeldung</h2><p>Die Anmeldung zur Lagebild-App erfolgt \xFCber das SelfService-Portal und kann als Administrator oder Benutzer erfolgen</p><img ng-click="$matStatCtrl.toggleTip()" height="150" src="assets/img/lagebild/lagebild1.jpeg" style="margin-right: 1rem;"> <img ng-click="$matStatCtrl.toggleTip()" height="150" src="assets/img/lagebild/lagebild2.jpeg" style="margin-right: 1rem;"></div></div><div role="spacer" style="margin: 7rem 0;"></div><div class="row"><div class="col-md-12"><div class="alert alert-danger" style="color: #f33;" ng-show="$matStatCtrl.showTip">Ein direkter Link zum SelfServicePortal wird noch angelegt!</div></div></div>');
$templateCache.put('app/pages/material/storageDetails/storageDetails.html','<div class="modal-content"><div class="modal-header" ng-class="{\'bg-danger\': $storageCtrl.deleteHint}"><h4 class="modal-title" ng-if="!$storageCtrl.deleteHint">{{ (\'modules.material.storageDetails.storageLocationDetails\' | translate) }} - "{{ $storageCtrl.material.Definition || $storageCtrl.material.Name || $storageCtrl.material.VehicleModel || $storageCtrl.material.Type}}"</h4><h4 class="modal-title" ng-if="$storageCtrl.deleteHint">{{ (\'modules.material.storageDetails.deleteAction\' | translate) }}: {{ (\'modules.material.storageDetails.storageLocationDetails\' | translate) }} - "{{ $storageCtrl.material.Definition || $storageCtrl.material.Name || $storageCtrl.material.VehicleModel || $storageCtrl.material.Type}}"</h4></div><div class="modal-body"><div class="mb-20" ng-if="$storageCtrl.deleteHint"><p>{{ (\'modules.material.storageDetails.storageLocationText\' | translate) }}</p><strong>{{ (\'modules.material.storageDetails.storageLocationText2\' | translate) }}</strong></div><uib-accordion ng-repeat="(key, content) in $storageCtrl.contents track by $index" panel-class="panel-default bootstrap-panel accordion-panel" is-open="$storageCtrl.tabStates[key]" ng-click="$storageCtrl.tabStates[key] = !$storageCtrl.tabStates[key]"><div uib-accordion-group="" class="panel-default accordion-panel"><uib-accordion-heading><i class="pull-left mr-5" ng-class="$storageCtrl.storageIconMap[key]"></i> {{($storageCtrl.modelMap[key] + \' (\' + content.length + \')\')}} <i class="pull-right" ng-class="{\'ion-chevron-down\': $storageCtrl.tabStates[key], \'ion-chevron-right\': !$storageCtrl.tabStates[key]}"></i></uib-accordion-heading><div><ul class="arno-storage-list"><li ng-repeat="row in content track by $index">{{row}}</li></ul></div></div></uib-accordion></div><div class="modal-footer"><button type="submit" ng-if="$storageCtrl.deleteHint" ng-click="$close(true)" class="btn btn-danger">{{ (\'generalTerms.delete\' | translate) }}</button> <button ng-click="$dismiss(null)" type="button" class="btn btn-default">{{ ($storageCtrl.deleteHint ? \'generalTerms.cancel\' : \'generalTerms.close\') | translate }}</button></div></div>');
$templateCache.put('app/pages/material/tabset/tabset.html','<div class="row arno-material"><div class="col-md-12"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div><div class="divisionAtTab"><h3 class="panel-heading panel-title arno-material-edit-header" ng-if="$parent.$parent.$tabsetCtrl.editMode">{{(\'modules.material.overview.DivideMaterial\' | translate)}} - {{ $parent.$parent.$parent.$tabsetCtrl.editMaterial }}</h3><uib-tabset ng-show="!$parent.$parent.$tabsetCtrl.editMode" active="tabs.active" class="suppress-tab-content"><uib-tab class="tab {{tab.class}}" ng-repeat="tab in tabs" ng-if="tab.isPermitted" ng-click="go(tab)"><uib-tab-heading ng-bind-html="tab.heading" class="d-flex align-items-center"></uib-tab-heading></uib-tab></uib-tabset><division-selector ng-show="!$parent.$parent.$tabsetCtrl.editMode" multiple="true" entry-permission="arno.virtual.item.materialMedicalProducts.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit,arno.material.view"></division-selector><div class="clearfix"></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/personnel/approvals/approvals.html','<div ba-panel="" ba-panel-title="\'modules.personnel.approvals.panelTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="arno.personnel.clearance.view"><approval-process-list show-member-name="true" disallow-edit="false" approval-processes="$ctrl.approvalProcesses" member-groups="$ctrl.memberGroups" table-config="$ctrl.tableConfig" allowed-references="$ctrl.allowedReferences" allow-export="true" pre-selected-id="$ctrl.preSelected.approvalAllocId" pre-selected-version="$ctrl.preSelected.approvalAllocVersion" only-demand-for-action="true"></approval-process-list></div>');
$templateCache.put('app/pages/personnel/blockList/blockList.html','<div ng-repeat="listType in $ctrl.listTypes"><div ng-if="listType.active" ba-panel="" ba-panel-title="listType.title" ba-panel-division-selector="!listType.isOrgList" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.administration.deleteMember"><div class="arno-personnel-list-panel-header form-group clearfix"><div><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button data-cy="personnel-blocklist-divisionmember-pagingsize" type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ listType.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(listType, i)">{{ i }}</a></li></ul></div><div class="btn-group" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ listType.hasViewModifications ? (\'generalTerms.currentView\' | translate) : listType.selectedView===\'0\' ? (\'generalTerms.defaultView\' | translate) : listType.customViews[listType.selectedView].Name }} <span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem"><a href="" ng-if="$ctrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$ctrl.changeListView(listType, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in listType.customViews"><a href="" ng-click="$ctrl.changeListView(listType, val, key)">{{ val.Name }}</a></li></ul></div><button data-cy="personnel-blocklist-divisionmember-tableconfiguration" class="btn btn-default btn-with-icon pull-left mr-20" ng-click="$ctrl.openTableConfig(listType)"><i class="ion-wrench"></i></button></div></div></div></div><div class="table-responsive"><table data-cy="personnel-blocklist-divisionmember-table" st-table="listType.displayedCollection" st-pipe="listType.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th ng-if="listType.tableConfig.Salutation && listType.isOrgList">{{ (\'models.Member.Salutation\' | translate) }}</th><th ng-if="listType.tableConfig.Salutation && !listType.isOrgList">{{ (\'models.Member.Salutation\' | translate) }}</th><th ng-if="listType.tableConfig.MailSalutation && listType.isOrgList">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="listType.tableConfig.MailSalutation && !listType.isOrgList">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="listType.tableConfig.Title && listType.isOrgList">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="listType.tableConfig.Title && !listType.isOrgList">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && listType.isOrgList" st-sort="FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && !listType.isOrgList" st-sort="Member.FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && listType.isOrgList" st-sort="LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && !listType.isOrgList" st-sort="Member.LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && !listType.isOrgList" st-sort="Member.Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && listType.isOrgList" st-sort="Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && !listType.isOrgList" st-sort="Member.Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && listType.isOrgList" st-sort="Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && listType.isOrgList" st-sort="Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && !listType.isOrgList" st-sort="Member.Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.ContactEMail && listType.isOrgList">{{ (\'models.Member.ContactEMail\' | translate) }}</th><th ng-if="listType.tableConfig.ContactEMail && !listType.isOrgList">{{ (\'models.Member.ContactEMail\' | translate) }}</th><th ng-if="listType.tableConfig.Street && listType.isOrgList">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="listType.tableConfig.Street && !listType.isOrgList">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="listType.tableConfig.HouseNumber && listType.isOrgList">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="listType.tableConfig.HouseNumber && !listType.isOrgList">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="listType.tableConfig.ZIP && listType.isOrgList">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="listType.tableConfig.ZIP && !listType.isOrgList">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="listType.tableConfig.City && listType.isOrgList">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="listType.tableConfig.City && !listType.isOrgList">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="listType.tableConfig.CountryId && listType.isOrgList">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="listType.tableConfig.CountryId && !listType.isOrgList">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="listType.tableConfig.BirthDate && listType.isOrgList">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="listType.tableConfig.BirthDate && !listType.isOrgList">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && !listType.isOrgList" st-sort="Member.MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && listType.isOrgList" st-sort="MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberType && listType.isOrgList">{{ (\'models.Member.MemberType\' | translate) }}</th><th ng-if="listType.tableConfig.MemberType && !listType.isOrgList">{{ (\'models.Member.MemberType\' | translate) }}</th><th ng-if="listType.tableConfig.BlockReasons">{{ (\'modules.personnel.blockList.blockingReason\' | translate) }}</th><th class="arno-table-button-cell">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th ng-show="listType.tableConfig.Salutation"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Salutation" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Salutation" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MailSalutation"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MailSalutation" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MailSalutation" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Title"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Title" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Title" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.FirstName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.FirstName" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="FirstName" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.LastName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.LastName" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="LastName" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Phone"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Phone" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Phone" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Mobile"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Mobile" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Mobile" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.EMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Account.EMail" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Account.EMail" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ContactEMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ContactEMail" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ContactEMail" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Street"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Street" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Street" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.HouseNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.HouseNumber" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="HouseNumber" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ZIP"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ZIP" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ZIP" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.City"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.City" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="City" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.CountryId"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.CountryId" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="CountryId" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.BirthDate"></th><th ng-show="listType.tableConfig.MemberNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberNumber" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MemberNumber" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberType"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberType" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MemberType" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberStatus" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.BlockReasons"></th><th></th></tr></thead><tbody><tr ng-repeat="divisionMember in listType.displayedCollection" ng-class="{\'arno-pointing-pointer\': ($ctrl.isPermitted(listType,\'arno.personnel.dossier\', [divisionMember.DivisionId]) || listType.isOrgList && $ctrl.isPermitted(listType,\'arno.personnel.dossier\', listType.ctx))}" ng-click="::$ctrl.showMemberEditBtn(divisionMember, listType) && $ctrl.openDossier(divisionMember, listType)"><td ng-show="listType.tableConfig.Salutation" class="align-left-force"><span>{{ ((divisionMember.Member.Salutation.length ? \'models.Member.Salutation.\' + divisionMember.Member.Salutation : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.MailSalutation">{{ ::divisionMember.Member.MailSalutation }}</td><td ng-show="listType.tableConfig.Title"><span>{{ ((divisionMember.Member.Title.length ? \'models.Member.Title.\' + divisionMember.Member.Title : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.FirstName"><span>{{ ::divisionMember.Member.FirstName }}</span></td><td ng-show="listType.tableConfig.LastName"><span>{{ ::divisionMember.Member.LastName }}</span></td><td ng-show="listType.tableConfig.Phone"><span>{{ ::divisionMember.Member.Phone }}</span></td><td ng-show="listType.tableConfig.Mobile"><span>{{ ::divisionMember.Member.Mobile }}</span></td><td ng-show="listType.tableConfig.EMail"><span ng-if="divisionMember.Member.Account.Type !== \'offline\'">{{ ::divisionMember.Member.Account.EMail }}</span> <span ng-if="divisionMember.Member.Account.Type === \'offline\'">-----</span></td><td ng-show="listType.tableConfig.ContactEMail"><span ng-if="divisionMember.Member.ContactEMail">{{ ::divisionMember.Member.ContactEMail }}</span></td><td ng-show="listType.tableConfig.Street"><span ng-if="divisionMember.Member.Street">{{ ::divisionMember.Member.Street }}</span></td><td ng-show="listType.tableConfig.HouseNumber"><span ng-if="divisionMember.Member.HouseNumber">{{ ::divisionMember.Member.HouseNumber }}</span></td><td ng-show="listType.tableConfig.ZIP"><span ng-if="divisionMember.Member.ZIP">{{ ::divisionMember.Member.ZIP }}</span></td><td ng-show="listType.tableConfig.City"><span ng-if="divisionMember.Member.City">{{ ::divisionMember.Member.City }}</span></td><td ng-show="listType.tableConfig.CountryId"><span ng-if="divisionMember.Member.CountryId">{{ ::divisionMember.Member.CountryId }}</span></td><td ng-show="listType.tableConfig.BirthDate"><span ng-if="divisionMember.Member.BirthDate">{{ ::divisionMember.Member.BirthDate | date:\'dd.MM.yyyy\' : \'UTC\'}}</span></td><td ng-show="listType.tableConfig.MemberNumber"><span>{{ ::divisionMember.Member.MemberNumber }}</span></td><td ng-show="listType.tableConfig.MemberType"><span>{{ ((divisionMember.Member.MemberType ? \'models.Member.MemberType.\' + divisionMember.Member.MemberType : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><span ng-bind-html="::$ctrl.getMemberStatusText(divisionMember)"></span></td><td ng-show="listType.tableConfig.BlockReasons && !listType.isOrgList"><span>{{ ::(divisionMember.BlockReason.Reason || (\'modules.personnel.blockList.blockedInOrg\' | translate)) }}</span></td><td ng-show="listType.tableConfig.BlockReasons && listType.isOrgList"><span>{{ ::divisionMember.Member.BlockReason.Reason }}</span></td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer"><div class="nowrap"><button ng-if="::$ctrl.showMemberEditBtn(divisionMember, listType)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(divisionMember, listType)" title="{{ (\'modules.personnel.blockList.openDossier\' | translate) }}"><span ng-switch="$ctrl.canFullyEditMember(divisionMember)"><span class="hidden-xs hidden-sm" ng-switch-when="true"><i class="fa fa-pencil"></i> {{ (\'generalTerms.edit\' | translate) }}</span> <span class="hidden-xs hidden-sm" ng-switch-default=""><i class="fa fa-eye"></i> {{ (\'generalTerms.detail\' | translate) }}</span></span></button> <button ng-disabled="!divisionMember.BlockReasonId && !listType.isOrgList" ng-click="$ctrl.removeBlockage(divisionMember.id || divisionMember.Member.id, divisionMember.DivisionId || false)" class="btn btn-default btn-with-icon btn-xs"><span class="hidden-xs hidden-sm"><i class="fa ion-trash"></i> {{ (\'modules.personnel.blockList.unblock\' | translate) }}</span></button></div></td></tr><tr ng-if="!listType.displayedCollection" ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}">...</td></tr><tr ng-if="listType.displayedCollection && listType.displayedCollection.length === 0"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}"><i translate="modules.personnel.personnelList.noPersonEntries"></i></td></tr></tbody><tfoot><tr><td colspan="{{$ctrl.getFullCSpan(listType.tableConfig)}}" class="text-center"><st-pagination st-items-by-page="listType.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/personnel/deletionList/deletionList.html','<div ng-repeat="listType in $ctrl.listTypes"><div ng-if="listType.active" ba-panel="" ba-panel-title="listType.title" ba-panel-division-selector="!listType.isOrgList" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.administration.deleteMember"><div class="arno-personnel-list-panel-header form-group clearfix"><div><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button data-cy="personnel-deletionlist-divisionmember-pagingsize" type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ listType.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(listType, i)">{{ i }}</a></li></ul></div><div class="btn-group" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ listType.hasViewModifications ? (\'generalTerms.currentView\' | translate) : listType.selectedView===\'0\' ? (\'generalTerms.defaultView\' | translate) : listType.customViews[listType.selectedView].Name }} <span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem"><a href="" ng-if="$ctrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$ctrl.changeListView(listType, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in listType.customViews"><a href="" ng-click="$ctrl.changeListView(listType, val, key)">{{ val.Name }}</a></li></ul></div><button data-cy="personnel-deletionlist-divisionmember-tableconfiguration" class="btn btn-default btn-with-icon pull-left mr-20" ng-click="$ctrl.openTableConfig(listType)"><i class="ion-wrench"></i></button></div></div></div></div><div class="table-responsive"><table data-cy="personnel-deletionlist-divisionmember-table" st-table="listType.displayedCollection" st-pipe="listType.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th ng-if="listType.tableConfig.Salutation && listType.isOrgList">{{ (\'models.Member.Salutation\' | translate) }}</th><th ng-if="listType.tableConfig.Salutation && !listType.isOrgList">{{ (\'models.Member.Salutation\' | translate) }}</th><th ng-if="listType.tableConfig.MailSalutation && listType.isOrgList">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="listType.tableConfig.MailSalutation && !listType.isOrgList">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="listType.tableConfig.Title && listType.isOrgList">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="listType.tableConfig.Title && !listType.isOrgList">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && listType.isOrgList" st-sort="FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && !listType.isOrgList" st-sort="Member.FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && listType.isOrgList" st-sort="LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && !listType.isOrgList" st-sort="Member.LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && !listType.isOrgList" st-sort="Member.Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && listType.isOrgList" st-sort="Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && !listType.isOrgList" st-sort="Member.Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && listType.isOrgList" st-sort="Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && listType.isOrgList" st-sort="Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && !listType.isOrgList" st-sort="Member.Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.ContactEMail && listType.isOrgList">{{ (\'models.Member.ContactEMail\' | translate) }}</th><th ng-if="listType.tableConfig.ContactEMail && !listType.isOrgList">{{ (\'models.Member.ContactEMail\' | translate) }}</th><th ng-if="listType.tableConfig.Street && listType.isOrgList">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="listType.tableConfig.Street && !listType.isOrgList">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="listType.tableConfig.HouseNumber && listType.isOrgList">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="listType.tableConfig.HouseNumber && !listType.isOrgList">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="listType.tableConfig.ZIP && listType.isOrgList">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="listType.tableConfig.ZIP && !listType.isOrgList">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="listType.tableConfig.City && listType.isOrgList">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="listType.tableConfig.City && !listType.isOrgList">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="listType.tableConfig.CountryId && listType.isOrgList">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="listType.tableConfig.CountryId && !listType.isOrgList">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="listType.tableConfig.BirthDate && listType.isOrgList">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="listType.tableConfig.BirthDate && !listType.isOrgList">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && !listType.isOrgList" st-sort="Member.MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && listType.isOrgList" st-sort="MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberType && listType.isOrgList">{{ (\'models.Member.MemberType\' | translate) }}</th><th ng-if="listType.tableConfig.MemberType && !listType.isOrgList">{{ (\'models.Member.MemberType\' | translate) }}</th><th ng-if="listType.tableConfig.WithdrawalReasons">{{ (\'modules.personnel.deletionList.deleteReason\' | translate) }}</th><th ng-if="listType.tableConfig.WithdrawalTargetDate">{{ (\'modules.personnel.deletionList.plannedDeletionDate\' | translate) }}</th><th class="arno-table-button-cell">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th ng-show="listType.tableConfig.Salutation"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Salutation" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Salutation" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MailSalutation"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MailSalutation" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MailSalutation" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Title"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Title" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Title" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.FirstName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.FirstName" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="FirstName" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.LastName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.LastName" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="LastName" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Phone"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Phone" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Phone" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Mobile"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Mobile" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Mobile" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.EMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Account.EMail" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Account.EMail" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ContactEMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ContactEMail" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ContactEMail" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Street"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Street" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Street" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.HouseNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.HouseNumber" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="HouseNumber" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ZIP"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ZIP" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ZIP" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.City"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.City" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="City" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.CountryId"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.CountryId" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="CountryId" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.BirthDate"></th><th ng-show="listType.tableConfig.MemberNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberNumber" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MemberNumber" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberType"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberType" type="search" ng-hide="listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MemberType" type="search" ng-show="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberStatus" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.WithdrawalReasons"></th><th ng-show="listType.tableConfig.WithdrawalTargetDate"></th><th ng-show="listType.tableConfig.DivisionName && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.DivisionName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="divisionMember in listType.displayedCollection" ng-class="{\'arno-pointing-pointer\': ($ctrl.isPermitted(listType,\'arno.personnel.dossier\', [divisionMember.DivisionId]) || listType.isOrgList && $ctrl.isPermitted(listType,\'arno.personnel.dossier\', listType.ctx))}" ng-click="::$ctrl.showMemberEditBtn(divisionMember, listType) && $ctrl.openDossier(divisionMember, listType)"><td ng-show="listType.tableConfig.Salutation" class="align-left-force"><span>{{ ((divisionMember.Member.Salutation.length ? \'models.Member.Salutation.\' + divisionMember.Member.Salutation : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.MailSalutation">{{ ::divisionMember.Member.MailSalutation }}</td><td ng-show="listType.tableConfig.Title"><span>{{ ((divisionMember.Member.Title.length ? \'models.Member.Title.\' + divisionMember.Member.Title : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.FirstName"><span>{{ ::divisionMember.Member.FirstName }}</span></td><td ng-show="listType.tableConfig.LastName"><span>{{ ::divisionMember.Member.LastName }}</span></td><td ng-show="listType.tableConfig.Phone"><span>{{ ::divisionMember.Member.Phone }}</span></td><td ng-show="listType.tableConfig.Mobile"><span>{{ ::divisionMember.Member.Mobile }}</span></td><td ng-show="listType.tableConfig.EMail"><span ng-if="divisionMember.Member.Account.Type !== \'offline\'">{{ ::divisionMember.Member.Account.EMail }}</span> <span ng-if="divisionMember.Member.Account.Type === \'offline\'">-----</span></td><td ng-show="listType.tableConfig.ContactEMail"><span ng-if="divisionMember.Member.ContactEMail">{{ ::divisionMember.Member.ContactEMail }}</span></td><td ng-show="listType.tableConfig.Street"><span ng-if="divisionMember.Member.Street">{{ ::divisionMember.Member.Street }}</span></td><td ng-show="listType.tableConfig.HouseNumber"><span ng-if="divisionMember.Member.HouseNumber">{{ ::divisionMember.Member.HouseNumber }}</span></td><td ng-show="listType.tableConfig.ZIP"><span ng-if="divisionMember.Member.ZIP">{{ ::divisionMember.Member.ZIP }}</span></td><td ng-show="listType.tableConfig.City"><span ng-if="divisionMember.Member.City">{{ ::divisionMember.Member.City }}</span></td><td ng-show="listType.tableConfig.CountryId"><span ng-if="divisionMember.Member.CountryId">{{ ::divisionMember.Member.CountryId }}</span></td><td ng-show="listType.tableConfig.BirthDate"><span ng-if="divisionMember.Member.BirthDate">{{ ::divisionMember.Member.BirthDate | date:\'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-show="listType.tableConfig.MemberNumber"><span>{{ ::divisionMember.Member.MemberNumber }}</span></td><td ng-show="listType.tableConfig.MemberType"><span>{{ ((divisionMember.Member.MemberType ? \'models.Member.MemberType.\' + divisionMember.Member.MemberType : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><span ng-bind-html="::$ctrl.getMemberStatusText(divisionMember)"></span></td><td ng-show="listType.tableConfig.WithdrawalReasons && !listType.isOrgList"><span>{{ ::(divisionMember.WithdrawalReason.Reason || \'L\xF6schung auf Organisationsebene\') }}</span></td><td ng-show="listType.tableConfig.WithdrawalTargetDate && !listType.isOrgList"><span>{{ ::(divisionMember.WithdrawalTargetDate || divisionMember.Member.WithdrawalTargetDate) | date:"dd.MM.yyyy" }}</span></td><td ng-show="listType.tableConfig.WithdrawalReasons && listType.isOrgList"><span>{{ ::divisionMember.Member.WithdrawalReason.Reason }}</span></td><td ng-show="listType.tableConfig.WithdrawalTargetDate && listType.isOrgList"><span>{{ ::divisionMember.Member.WithdrawalTargetDate | date:"dd.MM.yyyy" }}</span></td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer"><div class="nowrap"><button ng-if="::$ctrl.showMemberEditBtn(divisionMember, listType)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(divisionMember, listType)" title="{{ (\'modules.personnel.blockList.openDossier\' | translate) }}"><span ng-switch="$ctrl.canFullyEditMember(divisionMember)"><span class="hidden-xs hidden-sm" ng-switch-when="true"><i class="fa fa-pencil"></i> {{ (\'generalTerms.edit\' | translate) }}</span> <span class="hidden-xs hidden-sm" ng-switch-default=""><i class="fa fa-eye"></i> {{ (\'generalTerms.detail\' | translate) }}</span></span></button> <button ng-disabled="!divisionMember.WithdrawalReasonId && !listType.isOrgList" ng-click="$ctrl.removeWithdrawal(divisionMember.id || divisionMember.Member.id, divisionMember.DivisionId || false)" class="btn btn-default btn-with-icon btn-xs"><span class="hidden-xs hidden-sm"><i class="fa ion-trash"></i> {{ (\'modules.personnel.deletionList.undoDeletion\' | translate) }}</span></button></div></td></tr><tr ng-if="!listType.displayedCollection" ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}">...</td></tr><tr ng-if="listType.displayedCollection && listType.displayedCollection.length === 0"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}"><i translate="modules.personnel.deletionList.noPersonEntries"></i></td></tr></tbody><tfoot><tr><td colspan="{{$ctrl.getFullCSpan(listType.tableConfig)}}" class="text-center"><st-pagination st-items-by-page="listType.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/personnel/demandForAction/demandForAction.html','<div ba-panel="" ba-panel-title="\'modules.helperHours.personnel.pendingApprovals\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.helperHours.approve" ng-if="$ctrl.isPermittedAnywhere(\'arno.personnel.helperHours.approve\')"><div class="table-responsive"><table st-table="$ctrl.displayedCollectionHelperHours" st-pipe="$ctrl.loadHelperHours" class="table table-condensed table-hover"><thead><tr class="sortable"><th class="force-minimal sort-exception text-center" translate="modules.helperHours.personnel.choose"></th><th st-sort="Member.FirstName" translate="generalTerms.firstName"></th><th st-sort="Member.LastName" translate="generalTerms.lastName"></th><th st-sort="Title" translate="generalTerms.title"></th><th st-sort="ActivityStartDate" translate="generalTerms.date"></th><th st-sort="ActivityMinutes" translate="modules.helperHours.personnel.hourNumber"></th><th st-sort="Activity" translate="modules.helperHours.hours.volunteerActivity"></th><th translate="modules.helperHours.personnel.remark"></th><th translate="generalTerms.division"></th><th class="arno-table-button-cell" translate="generalTerms.actions"></th></tr><tr><th class="text-center pb-10"><strong>{{$ctrl.chosenCountHelperHours}}</strong></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Title" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Activity" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Note" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="row in $ctrl.displayedCollectionHelperHours"><td class="text-center"><label class="custom-checkbox mt-0 mb-0 ml-9"><input type="checkbox" ng-model="$ctrl.chosenHelperHours[row.id]"><span>&nbsp;</span></label></td><td class="align-left-force">{{ row.Member.FirstName }}</td><td class="align-left-force">{{ row.Member.LastName }}</td><td class="align-left-force">{{ row.Title }}</td><td class="align-left-force">{{ row.ActivityStartDate | date:\'dd.MM.yyyy\' }}</td><td class="align-left-force">{{ $ctrl.formatDuration(row.ActivityMinutes) }}</td><td class="align-left-force">{{ row.Activity.Title }}</td><td class="align-left-force text-overflow overflow-title arno-overflow-cell">{{ row.Note }}</td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer"><div class="nowrap"><button ng-if="$ctrl.isPermitted(\'arno.personnel.dossier\', [\'rootOrg\'], true)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(row.Member.Account.EMail)" title="{{\'modules.helperHours.personnel.openDossier\' |translate}}"><i class="fa fa-eye"></i> {{\'modules.helperHours.personnel.dossier\' |translate}}</button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.approveEntries(row.id, false)" title="{{\'modules.helperHours.personnel.discard\' |translate}}"><i class="fa fa-ban"></i> {{\'modules.helperHours.personnel.discard\' |translate}}</button> <button class="btn btn-primary btn-with-icon btn-xs" ng-click="$ctrl.approveEntries(row.id, true)" title="{{\'generalTerms.approve\' |translate}}"><i class="fa fa-check"></i> {{\'generalTerms.approve\' |translate}}</button></div></td></tr><tr ng-if="!$ctrl.ctxHH.length"><td class="text-center" colspan="99"><i translate="modules.helperHours.personnel.pleaseChooseArea"></i></td></tr><tr ng-if="$ctrl.ctxHH.length && (!$ctrl.displayedCollectionHelperHours || $ctrl.displayedCollectionHelperHours.length === 0)"><td class="text-center" colspan="99"><i translate="modules.helperHours.personnel.noHandlingNeeds"></i></td></tr></tbody><tfoot ng-if="$ctrl.showPagerHH"><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$ctrl.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div class="row btns-row mt-10"><div class="col-md-6"><button type="button" class="btn btn-default" ng-click="$ctrl.chooseAllHelperHours()" ng-disabled="!$ctrl.displayedCollectionHelperHours.length"><span translate="modules.helperHours.personnel.allChoose"></span></button> <button type="button" class="btn btn-default" ng-click="$ctrl.reset(\'helperHours\')" ng-disabled="!$ctrl.chosenCountHelperHours"><span translate="modules.helperHours.personnel.chooseReset"></span></button></div><div class="col-md-6 text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.approveEntries(null, true)" ng-disabled="!$ctrl.chosenCountHelperHours"><i class="fa fa-check-square-o"></i><span translate="modules.helperHours.personnel.chooseHoursRelease"></span></button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="$ctrl.approveEntries(null, false)" ng-disabled="!$ctrl.chosenCountHelperHours"><i class="fa fa-ban"></i><span translate="modules.helperHours.personnel.discardChooseHours"></span></button></div></div></div><div ba-panel="" ba-panel-title="\'modules.personnel.demandForAction.panelTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.privacyTerms.manage" ng-if="$ctrl.isPermittedAnywhere(\'arno.personnel.privacyTerms.manage\')"><div class="row" ng-if="$ctrl.openPromises"><div class="col-md-12"><div class="alert bg-info mb-15"><h4 translate="modules.personnel.demandForAction.openPromiseHeadline"></h4><p translate="modules.personnel.demandForAction.openPromiseParagraph1"></p><p translate="modules.personnel.demandForAction.openPromiseParagraph2"></p></div></div></div><div class="row btns-row mt-10"><div class="col-md-12 text-right"><button class="btn btn-default btn-with-icon no-animation" ng-click="$ctrl.import()" ng-if="!$ctrl.chosenCount"><i class="fa fa-upload"></i><span class="hidden-xs" translate="modules.personnel.demandForAction.importBtnText"></span></button> <button class="btn btn-default btn-with-icon no-animation" ng-click="$ctrl.export()" ng-if="$ctrl.chosenCount"><i class="fa fa-download"></i><span class="hidden-xs" translate="modules.personnel.demandForAction.exportBtnText"></span></button></div></div><div class="table-responsive"><table st-table="$ctrl.displayedCollection" st-pipe="$ctrl.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th class="force-minimal sort-exception text-center">{{ (\'modules.personnel.demandForAction.selection\' | translate) }}</th><th st-sort="FirstName" st-sort-default="true">{{ (\'models.Member.FirstName\' | translate) }}</th><th st-sort="LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th>E-Mail</th><th class="arno-table-button-cell">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th class="text-center pb-10"><strong>{{$ctrl.chosenCount}}</strong></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="row in $ctrl.displayedCollection"><td class="text-center"><label class="custom-checkbox mt-0 mb-0 ml-9"><input type="checkbox" ng-model="$ctrl.chosen[row.id]"><span>&nbsp;</span></label></td><td class="align-left-force"><span>{{ ::row.FirstName }}</span></td><td><span>{{ ::row.LastName }}</span></td><td><span>{{ ::row.ContactEMail || (row.Account.Type === \'offline\' ? \'----\' : row.Account.EMail)}}</span></td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer"><div class="nowrap"><button ng-if="$ctrl.isPermitted(\'arno.personnel.dossier\', [\'rootOrg\'], true)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(row.Account.EMail)" title="{{ \'modules.personnel.demandForAction.openDossierBtnTitle\' | translate }}"><i class="fa fa-eye"></i> {{ (\'modules.personnel.demandForAction.openDossierBtnText\' | translate) }}</button> <button class="btn btn-primary btn-with-icon btn-xs" ng-click="$ctrl.capture(row)" title="{{ \'modules.personnel.demandForAction.openDossierBtnTitle\' | translate }}"><i class="fa fa-pencil-square-o"></i> {{ (\'modules.personnel.demandForAction.captureBtnText\' | translate) }}</button></div></td></tr><tr ng-if="!$ctrl.ctx.length"><td class="text-center" colspan="5"><i translate="modules.personnel.demandForAction.selectAreaText"></i></td></tr><tr ng-if="$ctrl.ctx.length && (!$ctrl.displayedCollection || $ctrl.displayedCollection.length === 0)"><td class="text-center" colspan="5"><i translate="modules.personnel.demandForAction.noDemandText"></i></td></tr></tbody><tfoot ng-if="$ctrl.showPager"><tr><td colspan="5" class="text-center"><st-pagination st-items-by-page="$ctrl.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div class="row btns-row mt-10"><div class="col-md-6"><button type="button" class="btn btn-default" ng-click="$ctrl.chooseAll()" ng-disabled="!$ctrl.lastOpts || !$ctrl.displayedCollection.length"><span translate="modules.personnel.demandForAction.selectAll"></span></button> <button type="button" class="btn btn-default" ng-click="$ctrl.reset()" ng-disabled="!$ctrl.chosenCount"><span translate="modules.personnel.demandForAction.resetSelection"></span></button></div><div class="col-md-6 text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.capture()" ng-disabled="!$ctrl.chosenCount"><i class="fa fa-check-square-o"></i><span translate="modules.personnel.demandForAction.captureSelection"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/dossier.html','<div class="row personnel-dossier profile-page"><div class="col-md-12"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default"><tabs data="$dossier.dossierTabs" template-url="app/pages/personnel/dossier/dossierTabset.html"></tabs></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/dossierTabset.html','<div><uib-tabset active="tabs.active" class="suppress-tab-content"><uib-tab class="tab {{tab.class}}" ng-repeat="tab in tabs" disable="tab.disable" ng-click="$parent.$parent.$parent.$parent.$dossier.onTabChange(tab) && go(tab)"><uib-tab-heading ng-bind-html="tab.heading"></uib-tab-heading></uib-tab><division-selector multiple="false" allow-org-selection="true" namespace="divisionMemberDossier" dossier-owner-id="{{ $parent.$parent.$parent.$parent.$dossier.member.id }}" entry-permission="{{ $parent.$parent.$parent.$parent.$dossier.divisionSelectorEntryPermission }}"></division-selector></uib-tabset><ui-view></ui-view></div>');
$templateCache.put('app/pages/personnel/groups/addActivity.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.groups.assignMemGroupActivity"></h4></div><div class="modal-body"><div><label for="actSel" translate="generalTerms.activity"></label><ui-select id="actSel" ng-model="self.selectedActivity" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{ \'modules.personnel.groups.assignActPH\' | translate }}">{{ self.selectedActivity.Title }}</ui-select-match><ui-select-choices ui-disable-choice="option.disabled" position="down" repeat="option in self.selectableActivities | filter: { Title: $select.search }" group-by="\'groupName\'"><i class="fa fa-ban" ng-if="option.disabled"></i> <span title="{{ option.disabled ? ( \'modules.personnel.groups.alreadyAdded\' | translate) : \'\' }}">{{ option.Title }}</span></ui-select-choices></ui-select></div><div class="mt-20"><label for="actCharSel" translate="modules.personnel.dossier.activity.characteristic"></label><ui-select id="actCharSel" ng-model="self.selectedCharacteristic" ng-disabled="!self.selectedActivity" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{ \'modules.personnel.groups.assignActCharPH\' | translate }}">{{ self.characteristicMap[self.selectedCharacteristic] }}</ui-select-match><ui-select-choices position="down" repeat="option in self.selectedActivity.ActivityReqSets"><span>{{ self.characteristicMap[option] }}</span></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!self.selectedActivity || !self.selectedCharacteristic" ng-click="self.applyModal()"><span>{{ \'generalTerms.confirm\' | translate }}</span></button></div></div>');
$templateCache.put('app/pages/personnel/groups/deleteGroup.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.groups.deleteModalTitle"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.personnel.groups.deleteModalText" translate-values="{ group: $ctrl.group.Name }"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i> {{ \' \' + (\'generalTerms.delete\' | translate) }}</button></div></div>');
$templateCache.put('app/pages/personnel/groups/group.modal.html','<div class="modal-content"><form name="form" ba-rescue-panel="groupForm" novalidate="" angular-validator="" angular-validator-submit="$ctrl.saveGroup()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.groups.modalTitle"></h4></div><div class="modal-body"><div class="form-group"><label class="control-label required-label" translate="modules.personnel.groups.modalGroupNameLabel"></label> <input data-cy="personnel-groups-addgroup-name" type="text" ng-model="$ctrl.group.Name" class="form-control" id="nameInput" name="nameInput" placeholder="{{ (\'modules.personnel.groups.memberNamePlaceholder\' | translate) }}" maxlength="254" validator="$ctrl.checkForDuplicates($ctrl.group.Name)" required-message="\'modules.personnel.groups.memberNameRequiredMsg\' | translate" invalid-message="\'modules.personnel.groups.memberNameInvalidMsg\' | translate" required=""></div><div class="form-group"><label translate="modules.personnel.groups.modalAddMemberLabel"></label><div class="input-group"><ui-select data-cy="personnel-groups-addgroup-select" ng-model="$ctrl.selectedMember" class="btn-group bootstrap-select form-control" search-enabled="true" on-select="$ctrl.addMember()" spinner-enabled="true"><ui-select-match data-cy="personnel-groups-addgroup-selectmember" placeholder="{{ (\'modules.personnel.groups.memberSearchPlaceholder\' | translate) }}">{{ $select.selected.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="member.selected || member.hint" repeat="member in $ctrl.members" refresh="$ctrl.searchMembers($select.search)" refresh-delay="200" group-by="$ctrl.groupByFirstName"><span class="person-select" ng-if="!member.hint"><i class="ion-person"></i> <span>{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span> <span ng-show="member.selected" style="color: #AAA; font-style: italic" translate="modules.personnel.groups.alreadyAdded"></span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="modules.personnel.groups.selectPlaceholder"></span></span></ui-select-choices></ui-select></div></div><div class="table-responsive"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.groupMembers" class="table table-condensed table-hover"><thead><tr><th translate="models.Member.FirstName"></th><th translate="models.Member.LastName"></th><th translate="models.Account.EMail"></th><th class="fix-to-right"><div class="white-background" translate="generalTerms.actions"></div></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th class="fix-to-right"><div class="white-background"></div></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in $ctrl.displayedCollection"><td>{{ member.FirstName }}</td><td>{{ member.LastName }}</td><td>{{ member.Account.EMail }}</td><td class="arno-table-button-cell fix-to-right"><div class="white-background"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$ctrl.removeMember(member)"><i class="ion-ios-trash"></i><span class="btn-span hidden-xs" translate="generalTerms.remove"></span></button></div></td></tr><tr ng-if="!$ctrl.groupMembers.length"><td colspan="4"><i translate="modules.personnel.groups.noMembersText"></i></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div ng-if="$ctrl.permittedForActivities" class="mt-20 mb-10"><button type="button" class="btn-primary btn btn-with-icon" ng-click="$ctrl.addActivity()"><i class="ion-plus"></i> <span translate="modules.administration.adminActivities.addActivity"></span></button></div><div ng-if="$ctrl.permittedForActivities" class="table-responsive"><table st-table="$ctrl.activityColl" st-safe-src="$ctrl.activities" class="table table-condensed table-hover"><thead><tr><th translate="generalTerms.title"></th><th translate="modules.personnel.dossier.activity.characteristic"></th><th class="fix-to-right"><div class="white-background" translate="generalTerms.actions"></div></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Title" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th class="fix-to-right"><div class="white-background"></div></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="act in $ctrl.activityColl"><td>{{ act.Title }}</td><td>{{ $ctrl.characteristicMap[act.Characteristic] }}</td><td class="arno-table-button-cell fix-to-right"><div class="white-background"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$ctrl.removeActivity(act)"><i class="ion-ios-trash"></i><span class="btn-span hidden-xs" translate="generalTerms.remove"></span></button></div></td></tr><tr ng-if="!$ctrl.activityColl.length"><td colspan="99"><i translate="modules.personnel.groups.noMemGroupActivities"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/personnel/groups/groups.html','<div ba-panel="" ba-panel-title="\'modules.personnel.groups.panelTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="{{ $ctrl.divisionSelectorEntryPermission }}"><div class="form-group"><button data-cy="personnel-groups-addgroup" ng-show="$ctrl.division.length" ng-disabled="$ctrl.couldAdd()" class="btn btn-with-icon btn-primary" ng-click="$ctrl.create()"><i class="ion-plus"></i><span translate="modules.personnel.groups.addGroupBtnText"></span></button></div><div class="table-responsive"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.groups" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Name" st-sort-default="true">{{ (\'models.MemberGroup.Name\' | translate) }}</th><th st-sort="MemberNames">{{ (\'models.Member\' | translate:{ PLURAL: true }) }}</th><th class="text-center">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Members.fullName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$ctrl.displayedCollection.length" ng-repeat="group in $ctrl.displayedCollection" class="arno-pointing-pointer" ng-click="$ctrl.edit(group)"><td>{{ ::group.Name }}</td><td ng-if="::group.Members.length"><span class="arno-tag tag label label-tag" ng-repeat="member in ::group.Members track by member.id">{{ ::member.fullName }}</span></td><td ng-if="::!group.Members.length" style="font-style: italic; color: #666" translate="modules.personnel.groups.noMemberPlaceholder"></td><td class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.prevent($event)"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.sendMessage(group)"><i class="fa fa-envelope"></i><span class="hidden-xs hidden-sm">E-Mail</span></button> <button class="btn btn-default btn-with-icon btn-xs" title="Gruppe bearbeiten" translate-attr="{title : \'modules.personnel.groups.editGroupTooltip\'}" ng-click="$ctrl.edit(group)"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.delete(group)"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="!$ctrl.displayedCollection.length"><td colspan="9" class="text-center"><i translate="modules.personnel.groups.noGroupPlaceholder"></i></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/personnel/inviteAdd/inviteAdd.html','<div ba-panel="" ba-panel-title="\'modules.personnel.inviteList.addPanelTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$inviteAddCtrl.allowOrgSelection" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.inviteList.manage"><div class="arno-invite arno-invite-add"><div class="row" ng-show="!$inviteAddCtrl.authInfo.ArnoAuth && !$inviteAddCtrl.authInfo.AzureAuth && !$inviteAddCtrl.authInfo.Offline"><div class="col-md-12 text-center"><i translate="modules.personnel.inviteList.noAuthMethodText"></i></div></div><div class="row"><div class="col-md-12 col-lg-6" ng-show="$inviteAddCtrl.authInfo.ArnoAuth || $inviteAddCtrl.authInfo.AzureAuth || $inviteAddCtrl.authInfo.Offline" id="invite" role="tabpanel" aria-labelledby="invite-tab"><div ng-if="!$inviteAddCtrl.orgLvl && !$inviteAddCtrl.divLvl" translate="modules.personnel.inviteList.chooseOrgDivText"></div><form ng-if="$inviteAddCtrl.orgLvl || $inviteAddCtrl.divLvl" name="newUser" class="input-group invalid-color-indicator inviteAddTabs"><uib-tabset active="active"><uib-tab index="0" heading="{{ (\'modules.personnel.inviteList.accountTypeArno\' | translate) }}" class="tab" ng-if="$inviteAddCtrl.authInfo.ArnoAuth || $inviteAddCtrl.isDemo" ng-click="$inviteAddCtrl.switchTab(\'local\')"><div ng-include="\'app/pages/personnel/inviteAdd/partials/offlineAndArnoUser.html\'"></div></uib-tab><uib-tab index="1" heading="{{ (\'modules.personnel.inviteList.accountTypeOffline\' | translate) }}" class="tab" ng-if="$inviteAddCtrl.authInfo.Offline && !$inviteAddCtrl.orgLvl" ng-click="$inviteAddCtrl.switchTab(\'offline\')"><div ng-include="\'app/pages/personnel/inviteAdd/partials/offlineAndArnoUser.html\'"></div></uib-tab><uib-tab index="3" heading="{{ (\'modules.personnel.inviteList.accountTypeAzure\' | translate) }}" class="tab" ng-if="$inviteAddCtrl.authInfo.AzureAuth || $inviteAddCtrl.isDemo" ng-click="$inviteAddCtrl.switchTab(\'azure\')"><div ng-if="$inviteAddCtrl.isDemo" class="alert bg-warning"><h4>Hinweis</h4><strong>In Demo-Organisationen sind Nutzeraccounts auf Offline Accounts beschr\xE4nkt.</strong></div><div class="form-group"><div class="row"><div class="col-md-12"><label class="required-label" translate="modules.personnel.inviteList.accountTypeAzure"></label><member-selector ng-if="!$inviteAddCtrl.isDemo" organization-scope="true" on-member-select="$inviteAddCtrl.selectedADUser" azure="true" member-exclude="$inviteAddCtrl.azureMemberExclude"></member-selector><input type="text" class="form-control" placeholder="{{\'modules.personnel.groups.memberSearchPlaceholder\' | translate }}" disabled="" ng-if="$inviteAddCtrl.isDemo"></div></div></div></uib-tab><uib-tab index="4" ng-if="$inviteAddCtrl.authInfo.Offline && !$inviteAddCtrl.orgLvl" heading="{{ (\'modules.personnel.inviteList.excelImport\' | translate) }}" class="tab"><div class="row btns-row mb-0 mt-15"><div class="col-md-12"><button ng-if="$inviteAddCtrl.authInfo.ArnoAuth || $inviteAddCtrl.isDemo" type="button" data-cy="personnel-inviteadd-importmember" class="btn btn-primary btn-with-icon" ng-disabled="$inviteAddCtrl.isDemo" title="{{($inviteAddCtrl.isDemo ? \'Funktion nicht f\xFCr Demo-Organisationen verf\xFCgbar\' : \'\')}}" ng-click="$inviteAddCtrl.excelImport(\'local\')"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.inviteList.accountsTypeArno"></span></button> <button ng-if="$inviteAddCtrl.authInfo.Offline && !$inviteAddCtrl.orgLvl" data-cy="personnel-inviteadd-importmember" type="button" class="btn btn-primary btn-with-icon" ng-click="$inviteAddCtrl.excelImport(\'offline\')"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.inviteList.accountsTypeOffline"></span></button></div></div></uib-tab></uib-tabset></form></div></div></div></div>');
$templateCache.put('app/pages/personnel/inviteList/inviteList.html','<div ba-panel="" ba-panel-title="$ctrl.panelTitle" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="arno.personnel.inviteList.manage" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="arno-invite-list-panel-header form-group clearfix"><div><div class="pre-paging-legend invite-list"><span class="first-element"><i class="ion-android-checkbox-outline-blank"></i> {{ (\'modules.personnel.inviteList.inviteNotSent\' | translate) }}</span> <span><i class="ion-android-checkbox-outline"></i> {{ (\'modules.personnel.inviteList.inviteSent\' | translate)}}</span></div><div class="btn-toolbar"><button data-cy="personnel-inviteliste-addperson" class="btn btn-primary btn-with-icon" ng-click="$ctrl.memberAdd()" ng-if="$ctrl.ctx.length"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.inviteList.inviteBtnText"></span></button><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $ctrl.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(i)">{{ i }}</a></li></ul></div></div></div><div class="table-responsive"><table st-table="$ctrl.displayedCollection" st-pipe="$ctrl.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th class="inviteMinWidthCol" st-sort="{{$ctrl.sort.type}}">{{ (\'models.Account.Type\' | translate) }}</th><th st-sort="{{$ctrl.sort.firstName}}" st-sort-default="true">{{ (\'models.Member.FirstName\' | translate) }}</th><th st-sort="{{$ctrl.sort.lastName}}">{{ (\'models.Member.LastName\' | translate) }}</th><th st-sort="{{$ctrl.sort.email}}">{{ (\'models.Account.EMail\' | translate) }}</th><th st-sort="{{$ctrl.sort.expiryDate}}">{{ (\'models.Invite.ExpiryDate\' | translate) }}</th><th class="inviteMinWidthCol">{{ (\'models.Invite.State\' | translate) }}</th><th class="arno-table-button-cell">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ContactEMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="inviteEntry in $ctrl.displayedCollection" ng-style="{ \'color\': inviteEntry.InviteDate ? \'inherit\' : \'#aaa\' }"><td class="align-left-force"><span>{{ ::$ctrl.utils.translateMemberAuthType(inviteEntry.Member.Account.Type) }}</span></td><td><span>{{ ::inviteEntry.Member.FirstName }}</span></td><td><span>{{ ::inviteEntry.Member.LastName }}</span></td><td ng-if="inviteEntry.Member.Account.Type===\'offline\'"><span ng-if="inviteEntry.Member.ContactEMail">{{ ::inviteEntry.Member.ContactEMail }}</span> <span ng-if="!inviteEntry.Member.ContactEMail">-----</span></td><td ng-if="inviteEntry.Member.Account.Type!==\'offline\'"><span ng-if="inviteEntry.Member.Account.EMail">{{ ::inviteEntry.Member.Account.EMail }}</span></td><td><span ng-if="inviteEntry.expirationDateFormatted" ng-bind="inviteEntry.expirationDateFormatted"></span></td><td><i ng-class="{ \'ion-android-checkbox-outline-blank\' : !inviteEntry.InviteDate, \'ion-android-checkbox-outline\' : inviteEntry.InviteDate}"></i> <span>{{ inviteEntry.Division.Name || inviteEntry.Organization.Name }}</span></td><td ng-click="$ctrl.prevent($event)"><div class="nowrap arno-invite-list-center-content"><button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.removeInvite(this)" title="{{ (\'modules.personnel.inviteList.deleteMemberBtn\' | translate) }}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!$ctrl.displayedCollection" ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"><td class="text-center" colspan="8">...</td></tr><tr ng-if="$ctrl.displayedCollection && $ctrl.displayedCollection.length === 0"><td class="text-center" colspan="8"><i translate="modules.personnel.inviteList.memberListPlaceholder"></i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="$ctrl.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/personnel/inviteList/removeInvite.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.inviteList.removeInviteModalTitle"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.personnel.inviteList.removeInviteModalText1" translate-values="{ member: inviteEntry.Member.fullName, division: inviteEntry.Division.Name }"></p><p><b>{{ (\'generalTerms.caution\' | translate) + \':\' }}</b> {{ (\'modules.personnel.inviteList.removeInviteModalText2\' | translate) }}</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i> {{ (\'generalTerms.remove\' | translate) }}</button></div></div>');
$templateCache.put('app/pages/personnel/memberHistory/memberHistoryList.html','<div ba-panel="" ba-panel-title="\'\xC4nderungen die eine Benachrichtigung erfordern\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="arno-member-history-list form-group clearfix"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><th>Personalsystem</th><th>Personalsystem InfoText</th><th>Mitzuteilende Felder</th><th>Aktionen</th></thead><tbody><tr ng-repeat="system in $ctrl.personnelSystemChangeNotification"><td>{{ system.systemName }}</td><td>{{ system.systemInfoText || system.systemMail }}</td><td ng-if="system.notifyAboutFields"><button type="button" class="fieldPill btn btn-xs btn-info" ng-repeat="(key, value) in system.notifyAboutFields" title="{{ key }}"><span class="btn-span hidden-xs">{{ key }}</span></button></td><td><button class="btn btn-success btn-with-icon btn-xs" ng-click="$ctrl.showHistory(system.notifyAboutFields)" title="Zeige History"><i class="ion-android-list"></i><span class="hidden-xs hidden-sm">Zeige History</span></button> <button ng-if="system.systemMail" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.sendMail(system.systemMail, system.notifyAboutFields)" title="Benachrichtigung senden"><i class="ion-email"></i><span class="hidden-xs hidden-sm">Benachrichtigung senden</span></button></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/personnel/personnelList/deactivateMember.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.personnelList.deactivateMemberModalTitle"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.personnel.personnelList.deactivateMemberModalText" translate-values="{ fullname: divisionMember.Member.fullName }"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-danger" ng-click="$close()" translate="modules.personnel.personnelList.setInactive"></button></div></div>');
$templateCache.put('app/pages/personnel/personnelList/personnelList.html','<div ng-repeat="listType in $ctrl.listTypes"><div ng-if="listType.active" ba-panel="" ba-panel-title="listType.title" ba-panel-division-selector="!listType.isOrgList" ba-panel-division-selector-multiple="true" ba-panel-division-selector-allow-org-selection="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.personnelList.view"><div class="arno-personnel-list-panel-header form-group clearfix"><div><div class="btn-toolbar"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ listType.hasViewModifications ? (\'generalTerms.currentView\' | translate) : listType.selectedView===\'0\' ? (\'generalTerms.defaultView\' | translate) : listType.customViews[listType.selectedView].Name }} <span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem"><a href="" ng-if="$ctrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$ctrl.changeListView(listType, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in listType.customViews"><a href="" ng-click="$ctrl.changeListView(listType, val, key)">{{ val.Name }}</a></li></ul></div><button data-cy="personnel-personnellist-divisionmember-tableconfiguration" class="btn btn-default btn-with-icon mr-12" ng-click="$ctrl.openTableConfig(listType)" ng-class="{\'disabled\': $ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx) === false}"><i class="ion-wrench"></i></button></div><div uib-dropdown="" dropdown-toggle="" class="mr-8"><button data-cy="personnel-personnellist-divisionmember-pagingsize" type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ listType.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(listType, i)">{{ i }}</a></li></ul></div><div ng-if="!listType.isOrgList" class="arno-personnel-list-custom-switcher btn-toolbar"><div ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure,arno.personnel.dossier.activeState.manage\', listType.ctx)"><ba-switcher switcher-style="primary" switcher-value="listType.tableConfig.Active" switcher-width="120" switcher-keys="$ctrl.aKeys" switcher-hints="$ctrl.aHints"></ba-switcher></div></div></div><div class="btn-toolbar pull-right" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.view\', listType.ctx) || $ctrl.isPermitted(listType,\'arno.personnel.dossier.qualification.viewAll\', listType.ctx) || $ctrl.isPermitted(listType, \'arno.personnel.dossier.clearance.view\', listType.ctx) || $ctrl.isPermitted(listType,\'arno.personnel.dossier.activity.view\', listType.ctx) || $ctrl.isPermitted(listType,\'arno.personnel.dossier.trainings.view\', listType.ctx)"><button class="btn btn-default btn-with-icon dropdown-toggle" type="button" ng-click="$ctrl.sendMailToMembers(listType, true)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-envelope"></i> E-Mail</button><div uib-dropdown="" dropdown-toggle=""><button class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-download"></i> Export <span class="caret"></span></button><div uib-dropdown-menu="" role="menu" aria-labelledby="single-button" class="dropdown-menu-right"><li role="menuitem" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.view\', listType.ctx)"><a href="" data-cy="personnel-personnellist-divisionmember-export" ng-click="$ctrl.openExportDialog(listType, \'personnel/export\')" translate="generalTerms.currentView"></a></li><li role="menuitem" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.dossier.qualification.viewAll\', listType.ctx)"><a href="" ng-click="$ctrl.openSubModuleExportDialog(listType, \'personnel/export/personnellistqualifications\')" translate="generalTerms.qualifications"></a></li><li role="menuitem" ng-if="::$ctrl.isPermitted(listType, \'arno.personnel.dossier.clearance.view\', listType.ctx)"><a href="" ng-click="$ctrl.openSubModuleExportDialog(listType, \'personnel/export/personnellistapprovals\')" translate="generalTerms.approvals"></a></li><li role="menuitem" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.dossier.activity.view\', listType.ctx)"><a href="" ng-click="$ctrl.openSubModuleExportDialog(listType, \'personnel/export/personnellistactivities\')" translate="generalTerms.activities"></a></li><li role="menuitem" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.dossier.trainings.view\', listType.ctx)"><a href="" ng-click="$ctrl.openSubModuleExportDialog(listType, \'personnel/export/personnellisttrainings\')" translate="generalTerms.trainings"></a></li><li role="menuitem" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.dossier.activity.view\', listType.ctx) && $ctrl.isPermitted(listType, \'arno.personnel.dossier.clearance.view\', listType.ctx) && $ctrl.isPermitted(listType,\'arno.personnel.dossier.qualification.viewAll\', listType.ctx)"><a href="" ng-click="$ctrl.openSubModuleExportDialog(listType, \'personnel/export/personnellistopenrequirements\')" translate="modules.personnel.personnelList.openRequirements"></a></li></div></div></div></div></div><div class="table-responsive"><table data-cy="personnel-personnellist-divisionmember-table" st-table="listType.displayedCollection" st-pipe="listType.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th class="text-center" ng-if="listType.tableConfig.MemberActivityState"></th><th ng-if="listType.tableConfig.Salutation">{{ (\'models.Member.Salutation\' | translate) }}</th><th ng-if="listType.tableConfig.MailSalutation">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="listType.tableConfig.Title">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && listType.isOrgList" st-sort="FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.FirstName && !listType.isOrgList" st-sort="Member.FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && listType.isOrgList" st-sort="LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.LastName && !listType.isOrgList" st-sort="Member.LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="listType.tableConfig.NameAffix && !listType.isOrgList" st-sort="Member.NameAffix">{{ (\'models.Member.NameAffix\' | translate) }}</th><th ng-if="listType.tableConfig.NameAffix && listType.isOrgList" st-sort="NameAffix">{{ (\'models.Member.NameAffix\' | translate) }}</th><th ng-if="listType.tableConfig.Gender && !listType.isOrgList" st-sort="Member.Gender">{{ (\'models.Member.Gender\' | translate) }}</th><th ng-if="listType.tableConfig.Gender && listType.isOrgList" st-sort="Gender">{{ (\'models.Member.Gender\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && !listType.isOrgList" st-sort="Member.Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Phone && listType.isOrgList" st-sort="Phone">{{ (\'models.Member.Phone\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && !listType.isOrgList" st-sort="Member.Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.Mobile && listType.isOrgList" st-sort="Mobile">{{ (\'models.Member.Mobile\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && listType.isOrgList" st-sort="Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.EMail && !listType.isOrgList" st-sort="Member.Account.EMail">{{ (\'models.Account.EMail\' | translate) }}</th><th ng-if="listType.tableConfig.ContactEMail">{{ (\'models.Member.ContactEMail\' | translate) }}</th><th ng-if="listType.tableConfig.Street">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="listType.tableConfig.HouseNumber">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="listType.tableConfig.ZIP">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="listType.tableConfig.City">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="listType.tableConfig.AddressAffix && !listType.isOrgList" st-sort="Member.AddressAffix">{{ (\'models.Member.AddressAffix\' | translate) }}</th><th ng-if="listType.tableConfig.AddressAffix && listType.isOrgList" st-sort="AddressAffix">{{ (\'models.Member.AddressAffix\' | translate) }}</th><th ng-if="listType.tableConfig.CountryId">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="listType.tableConfig.BirthDate">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="listType.tableConfig.MemberBirthday" st-sort="Member.MemberBirthday">{{ (\'models.Member.MemberBirthday\' | translate) }}</th><th ng-if="listType.tableConfig.Nationality">{{ (\'models.Member.Nationality\' | translate) }}</th><th ng-if="!listType.isOrgList && listType.chosenGroups && listType.tableConfig.Groups">{{ (\'generalTerms.group\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && !listType.isOrgList" st-sort="Member.MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberNumber && listType.isOrgList" st-sort="MemberNumber">{{ (\'models.Member.MemberNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberType">{{ (\'models.Member.MemberType\' | translate) }}</th><th ng-if="listType.tableConfig.DemandForAction">{{ (\'generalTerms.demandForAction\' | translate) }} <button class="btn btn-with-icon btn-xs pull-right" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" title="{{ listType.tableConfig.LiveCalcMode ? $ctrl.tryTranslate(\'modules.personnel.personnelList.liveDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) : $ctrl.tryTranslate(\'modules.personnel.personnelList.calcDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) }}" ng-class="{\'btn-default\': !listType.tableConfig.LiveCalcMode, \'btn-primary active\': listType.tableConfig.LiveCalcMode}" ng-click="listType.tableConfig.LiveCalcMode = !listType.tableConfig.LiveCalcMode"><i class="fa" ng-class="{\'fa-database\': !listType.tableConfig.LiveCalcMode, \'fa-bolt\': listType.tableConfig.LiveCalcMode}"></i></button></th><th ng-if="listType.tableConfig.JobCharacteristics">{{ (\'models.Member.JobCharacteristics\' | translate) }} <button class="btn btn-with-icon btn-xs pull-right" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" title="{{ listType.tableConfig.LiveCalcMode ? $ctrl.tryTranslate(\'modules.personnel.personnelList.liveDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) : $ctrl.tryTranslate(\'modules.personnel.personnelList.calcDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) }}" ng-class="{\'btn-default\': !listType.tableConfig.LiveCalcMode, \'btn-primary active\': listType.tableConfig.LiveCalcMode}" ng-click="listType.tableConfig.LiveCalcMode = !listType.tableConfig.LiveCalcMode"><i class="fa" ng-class="{\'fa-database\': !listType.tableConfig.LiveCalcMode, \'fa-bolt\': listType.tableConfig.LiveCalcMode}"></i></button></th><th ng-if="listType.tableConfig.QualificationFeatures">{{ (\'models.Member.QualificationFeatures\' | translate) }} <button class="btn btn-with-icon btn-xs pull-right" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" title="{{ listType.tableConfig.LiveCalcMode ? $ctrl.tryTranslate(\'modules.personnel.personnelList.liveDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) : $ctrl.tryTranslate(\'modules.personnel.personnelList.calcDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) }}" ng-class="{\'btn-default\': !listType.tableConfig.LiveCalcMode, \'btn-primary active\': listType.tableConfig.LiveCalcMode}" ng-click="listType.tableConfig.LiveCalcMode = !listType.tableConfig.LiveCalcMode"><i class="fa" ng-class="{\'fa-database\': !listType.tableConfig.LiveCalcMode, \'fa-bolt\': listType.tableConfig.LiveCalcMode}"></i></button></th><th ng-if="listType.tableConfig.AccountType">{{ (\'models.Member.AccountType\' | translate) }}</th><th ng-if="listType.tableConfig.MemberStatus && !listType.isOrgList" st-sort="MemberStatus">{{ (\'models.Member.MemberStatus\' | translate) }}</th><th ng-if="listType.tableConfig.MainDivision" st-sort="MainDivision.Name">Stammgliederung</th><th ng-if="listType.tableConfig.DivisionName && !listType.isOrgList">{{ (\'generalTerms.division\' | translate) }}</th><th ng-if="listType.tableConfig.JoiningDate">{{ (\'models.Member.JoiningDate\' | translate) }}</th><th ng-if="listType.tableConfig.StaffNumber && !listType.isOrgList" st-sort="Member.StaffNumber">{{ (\'models.Member.StaffNumber\' | translate) }}</th><th ng-if="listType.tableConfig.StaffNumber && listType.isOrgList" st-sort="StaffNumber">{{ (\'models.Member.StaffNumber\' | translate) }}</th><th ng-if="listType.tableConfig.MemberSince && !listType.isOrgList">{{ (\'models.DivisionMember.MemberSince\' | translate) }}</th><th ng-if="listType.tableConfig.HelperIdNumber && !listType.isOrgList">{{ (\'models.DivisionMember.HelperIdNumber\' | translate) }}</th><th ng-if="listType.tableConfig.HelperIdValidUntil && !listType.isOrgList">{{ (\'models.DivisionMember.HelperIdValidUntil\' | translate) }}</th><th class="arno-qualification-activity-tablecell" ng-repeat="subtype in $ctrl.subtypes" ng-if="listType.tableConfig[subtype.field]">{{ subtype.label }} <button class="btn btn-with-icon btn-xs pull-right" ng-if="::$ctrl.isPermitted(listType,\'arno.personnel.personnelList.configure\', listType.ctx)" title="{{ listType.tableConfig.LiveCalcMode ? $ctrl.tryTranslate(\'modules.personnel.personnelList.liveDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) : $ctrl.tryTranslate(\'modules.personnel.personnelList.calcDataBtnText\', null, {subtype: subtype.label.toLowerCase()}) }}" ng-class="{\'btn-default\': !listType.tableConfig.LiveCalcMode, \'btn-primary active\': listType.tableConfig.LiveCalcMode}" ng-click="listType.tableConfig.LiveCalcMode = !listType.tableConfig.LiveCalcMode"><i class="fa" ng-class="{\'fa-database\': !listType.tableConfig.LiveCalcMode, \'fa-bolt\': listType.tableConfig.LiveCalcMode}"></i></button></th><th class="arno-table-button-cell" translate="generalTerms.actions"></th></tr><tr><th ng-show="listType.tableConfig.MemberActivityState"></th><th ng-show="listType.tableConfig.Salutation"><div class="input-group"><tag-picker default-label="$ctrl.tryTranslate(\'modules.personnel.personnelList.salutationsInputPlaceholder\')" tags="$ctrl.chosableSalutations" selected-tags="listType.chosenSalutations" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'"></tag-picker></div></th><th ng-show="listType.tableConfig.MailSalutation"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MailSalutation" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MailSalutation" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Title"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Title" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Title" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.FirstName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.FirstName" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="FirstName" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.LastName"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.LastName" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="LastName" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.NameAffix"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.NameAffix" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="NameAffix" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Gender"><div class="input-group"><tag-picker default-label="$ctrl.tryTranslate(\'modules.personnel.personnelList.genderInputPlaceholder\')" tags="$ctrl.chosableGenders" selected-tags="listType.chosenGenders" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'"></tag-picker></div></th><th ng-show="listType.tableConfig.Phone"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Phone" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Phone" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Mobile"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Mobile" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Mobile" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.EMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Account.EMail" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Account.EMail" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ContactEMail"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ContactEMail" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ContactEMail" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.Street"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.Street" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="Street" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.HouseNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.HouseNumber" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="HouseNumber" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.ZIP"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.ZIP" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="ZIP" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.City"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.City" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="City" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.AddressAffix"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.AddressAffix" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="AddressAffix" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.CountryId"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.CountryId" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="CountryId" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.BirthDate"></th><th ng-if="listType.tableConfig.MemberBirthday"></th><th ng-show="listType.tableConfig.Nationality"></th><th ng-show="listType.tableConfig.Groups && listType.chosenGroups && !listType.isOrgList" class="force-minimal"><div><div class="input-group"><tag-picker default-label="$ctrl.tryTranslate(\'modules.personnel.personnelList.groupInputPlaceholder\')" tags="$ctrl.groups" selected-tags="listType.chosenGroups" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'"></tag-picker></div></div></th><th ng-show="listType.tableConfig.MemberNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberNumber" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="MemberNumber" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberType"><div class="input-group"><tag-picker default-label="$ctrl.tryTranslate(\'modules.personnel.personnelList.memberTypeInputPlaceholder\')" tags="$ctrl.chosableMemberTypes" selected-tags="listType.chosenMemberTypes" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'"></tag-picker></div></th><th ng-show="listType.tableConfig.DemandForAction"></th><th ng-show="listType.tableConfig.JobCharacteristics"></th><th ng-show="listType.tableConfig.QualificationFeatures"></th><th ng-show="listType.tableConfig.AccountType"></th><th ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MemberStatus" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MainDivision"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="MainDivision.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.DivisionName && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.JoiningDate"></th><th ng-show="listType.tableConfig.StaffNumber"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.StaffNumber" type="search" ng-if="!listType.isOrgList" class="form-control with-default-addon input-sm"> <input st-search="StaffNumber" type="search" ng-if="listType.isOrgList" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.MemberSince && !listType.isOrgList"></th><th ng-show="listType.tableConfig.HelperIdNumber && !listType.isOrgList"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="HelperIdNumber" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="listType.tableConfig.HelperIdValidUntil && !listType.isOrgList"></th><th ng-show="listType.tableConfig.MemberSince && !listType.isOrgList"></th><th class="arno-qualification-activity-tablecell" ng-show="listType.tableConfig.MemberQualifications"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberQualifications" type="search" class="form-control with-default-addon input-sm" title="{{(listType.tableConfig.LiveCalcMode ? (\'modules.personnel.personnelList.noLiveDataSearch\' | translate) : (listType.ctx && listType.ctx.length > 100) ? (\'modules.personnel.personnelList.toManyDivisionSearch\' | translate) : \'\')}}" ng-disabled="listType.tableConfig.LiveCalcMode || (listType.ctx && listType.ctx.length > 100)"></div></th><th class="arno-qualification-activity-tablecell" ng-show="listType.tableConfig.MemberActivities"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.MemberActivities" type="search" class="form-control with-default-addon input-sm" title="{{(listType.tableConfig.LiveCalcMode ? (\'modules.personnel.personnelList.noLiveDataSearch\' | translate) : (listType.ctx && listType.ctx.length > 100) ? (\'modules.personnel.personnelList.toManyDivisionSearch\' | translate) : \'\')}}" ng-disabled="listType.tableConfig.LiveCalcMode || (listType.ctx && listType.ctx.length > 100)"></div></th><th></th></tr></thead><tbody><tr ng-repeat="divisionMember in listType.displayedCollection" ng-style="{ \'color\': divisionMember.Active || listType.isOrgList ? \'inherit\' : \'#aaa\' }" ng-class="{\'arno-pointing-pointer\': (($ctrl.isPermitted(listType,\'arno.personnel.dossier\', [divisionMember.DivisionId])) || listType.isOrgList && $ctrl.isPermitted(listType,\'arno.personnel.dossier\', listType.ctx))}" ng-click="::$ctrl.showMemberEditBtn(divisionMember, listType) && !$root.pageButtonsDisabled && $ctrl.openDossier(divisionMember, listType)"><td ng-show="listType.tableConfig.MemberActivityState" class="text-center"><status-light class="\'light-inline\'" is-green="(divisionMember.Member.allActivitiesFulfilled && divisionMember.Member.MemberActivities.length > 0)" use-yellow-light="true" use-one-light="true" red-title="(\'modules.personnel.personnelList.activityStateLightRed\' | translate)" yellow-title="(\'modules.personnel.personnelList.activityStateLightYellow\' | translate)" green-title="(\'modules.personnel.personnelList.activityStateLightGreen\' | translate)" inactive-title="(\'modules.personnel.personnelList.activityStateLightGray\' | translate)" is-yellow="(divisionMember.Member.activitiesPending && divisionMember.Member.allActivitiesFulfilled)" is-inactive="(divisionMember.Member.MemberActivities.length === 0 && !divisionMember.Member.activitiesPending && divisionMember.Member.allActivitiesFulfilled)"></status-light></td><td ng-show="listType.tableConfig.Salutation" class="align-left-force"><span>{{ ((divisionMember.Member.Salutation.length ? \'models.Member.Salutation.\' + divisionMember.Member.Salutation : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.MailSalutation"><span>{{ ::divisionMember.Member.MailSalutation }}</span></td><td ng-show="listType.tableConfig.Title"><span>{{ ((divisionMember.Member.Title.length ? $ctrl.tryTranslate(\'models.Member.Title\', divisionMember.Member.Title, null) : \'\' ) | translate) }}</span></td><td ng-show="listType.tableConfig.FirstName"><span>{{ ::divisionMember.Member.FirstName }}</span></td><td ng-show="listType.tableConfig.LastName"><span>{{ ::divisionMember.Member.LastName }}</span></td><td ng-show="listType.tableConfig.NameAffix"><span>{{ ::divisionMember.Member.NameAffix }}</span></td><td ng-show="listType.tableConfig.Gender"><span>{{ ((divisionMember.Member.Gender.length ? $ctrl.tryTranslate(\'models.Member.Gender\', divisionMember.Member.Gender, null) : \'\' ) | translate) }}</span></td><td ng-show="listType.tableConfig.Phone"><span>{{ ::divisionMember.Member.Phone }}</span></td><td ng-show="listType.tableConfig.Mobile"><span>{{ ::divisionMember.Member.Mobile }}</span></td><td ng-show="listType.tableConfig.EMail"><span ng-if="divisionMember.Member.Account.Type !== \'offline\'">{{ ::divisionMember.Member.Account.EMail }}</span> <span ng-if="divisionMember.Member.Account.Type === \'offline\'">-----</span></td><td ng-show="listType.tableConfig.ContactEMail"><span ng-if="divisionMember.Member.ContactEMail">{{ ::divisionMember.Member.ContactEMail }}</span></td><td ng-show="listType.tableConfig.Street"><span ng-if="divisionMember.Member.Street">{{ ::divisionMember.Member.Street }}</span></td><td ng-show="listType.tableConfig.HouseNumber"><span ng-if="divisionMember.Member.HouseNumber">{{ ::divisionMember.Member.HouseNumber }}</span></td><td ng-show="listType.tableConfig.ZIP"><span ng-if="divisionMember.Member.ZIP">{{ ::divisionMember.Member.ZIP }}</span></td><td ng-show="listType.tableConfig.City"><span ng-if="divisionMember.Member.City">{{ ::divisionMember.Member.City }}</span></td><td ng-show="listType.tableConfig.AddressAffix"><span ng-if="divisionMember.Member.AddressAffix">{{ ::divisionMember.Member.AddressAffix }}</span></td><td ng-show="listType.tableConfig.CountryId"><span ng-if="divisionMember.Member.CountryId">{{ ::divisionMember.Member.CountryId }}</span></td><td ng-show="listType.tableConfig.BirthDate"><span ng-if="divisionMember.Member.BirthDate">{{ ::divisionMember.Member.BirthDate | date: \'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-show="listType.tableConfig.MemberBirthday"><span ng-if="divisionMember.Member.BirthDate">{{ ::divisionMember.Member.BirthDate | date: \'dd.MM\' : \'UTC\' }} {{ divisionMember.Age >= 0 || divisionMember.Member.Age >= 0 ? $ctrl.tryTranslate(\'modules.personnel.personnelList.birthdayTurnsText\', null, { age: ((divisionMember.Age || divisionMember.Member.Age) + 1).toString()}) : \'\' }}</span></td><td ng-show="listType.tableConfig.Nationality"><span>{{ ((divisionMember.Member.Nationality.length ? $ctrl.tryTranslate(\'catalogues.CatalogueNationality\', divisionMember.Member.Nationality, null) : \'\' ) | translate) }}</span></td><td ng-show="!listType.isOrgList && listType.tableConfig.Groups"><span ng-repeat="group in divisionMember.Member.MemberGroups | filter: $ctrl.memberGroupFilter(divisionMember) | limitTo:2 track by $index">{{ :: group.Name}}{{$index+1 < divisionMember.Member.MemberGroups.length ? \', \': \'\' }}</span> <span ng-if="divisionMember.Member.MemberGroups.length > 2">...</span></td><td ng-show="listType.tableConfig.MemberNumber"><span>{{ ::divisionMember.Member.MemberNumber }}</span></td><td ng-show="listType.tableConfig.MemberType"><span>{{ ((divisionMember.Member.MemberType ? \'models.Member.MemberType.\' + divisionMember.Member.MemberType : \'\') | translate) }}</span></td><td ng-show="listType.tableConfig.DemandForAction"><div ng-if="::divisionMember.Member.demandForActions" ng-repeat="demandForActions in ::divisionMember.Member.demandForActions"><div class="arno-tag tag label wide mr-0" ng-class="demandForActions.Label">{{ demandForActions.Name }}</div></div></td><td ng-show="listType.tableConfig.JobCharacteristics"><div ng-if="::divisionMember.Member.highestAvaliableJobCharacteristic" class="arno-tag tag label wide mr-0" ng-class="::divisionMember.Member.highestAvaliableJobCharacteristic.Label">{{ ::divisionMember.Member.highestAvaliableJobCharacteristic.Name }}</div></td><td ng-show="listType.tableConfig.QualificationFeatures"><div ng-if="::divisionMember.Member.highestAvaliableQualificationFeature" class="arno-tag tag label wide mr-0" ng-class="::divisionMember.Member.highestAvaliableQualificationFeature.Label">{{ ::divisionMember.Member.highestAvaliableQualificationFeature.Name }}</div></td><td ng-show="listType.tableConfig.AccountType"><div class="arno-tag tag label wide mr-0" ng-class="::$ctrl.accountTypes[divisionMember.Member.Account.Type].label">{{ ::$ctrl.accountTypes[divisionMember.Member.Account.Type].name }}</div></td><td ng-show="listType.tableConfig.MemberStatus && !listType.isOrgList"><span ng-bind-html="::$ctrl.getMemberStatusText(divisionMember)"></span></td><td ng-show="listType.tableConfig.MainDivision"><span>{{ ::divisionMember.Member.MainDivision.Name }}</span></td><td ng-show="listType.tableConfig.DivisionName && !listType.isOrgList"><span>{{ ::divisionMember.Member.DivisionName }}</span></td><td ng-show="listType.tableConfig.JoiningDate"><span ng-if="divisionMember.Member.JoiningDate">{{ ::divisionMember.Member.JoiningDate | date: \'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-show="listType.tableConfig.StaffNumber"><span>{{ ::divisionMember.Member.StaffNumber }}</span></td><td ng-show="listType.tableConfig.MemberSince && !listType.isOrgList"><span ng-if="divisionMember.MemberSince">{{ ::divisionMember.MemberSince | date: \'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-show="listType.tableConfig.HelperIdNumber && !listType.isOrgList"><span>{{ ::divisionMember.HelperIdNumber }}</span></td><td ng-show="listType.tableConfig.HelperIdValidUntil && !listType.isOrgList"><span ng-if="divisionMember.HelperIdValidUntil">{{ ::divisionMember.HelperIdValidUntil | date: \'dd.MM.yyyy\' : \'UTC\' }}</span></td><td class="arno-qualification-activity-tablecell" ng-show="listType.tableConfig.MemberQualifications"><ul class="arno-qualification-activity-tablecontent"><li ng-repeat="q in divisionMember.Member.MemberQualifications">{{ ::q }}</li></ul></td><td class="arno-qualification-activity-tablecell" ng-show="listType.tableConfig.MemberActivities"><ul class="arno-qualification-activity-tablecontent"><li ng-repeat="a in divisionMember.Member.MemberActivities">{{ ::a }}</li></ul></td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer"><div class="nowrap"><button ng-if="::$ctrl.showMemberEditBtn(divisionMember, listType) && $ctrl.canFullyEditMember(divisionMember)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(divisionMember, listType)" title="{{ \'modules.personnel.personnelList.openDossier\' | translate }}"><i class="fa fa-pencil"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button ng-if="::$ctrl.showMemberEditBtn(divisionMember, listType) && !$ctrl.canFullyEditMember(divisionMember)" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openDossier(divisionMember, listType)" title="{{ \'modules.personnel.personnelList.openDossier\' | translate }}"><i class="fa fa-eye"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.personnelList.detail"></span></button> <button ng-if="::(!divisionMember.Active && divisionMember.Active !== null && $ctrl.isPermitted(listType,\'arno.personnel.personnelList.deleteMember\', [divisionMember.DivisionId]))" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.removeMember(this, listType)" title="{{ \'modules.personnel.personnelList.deleteMember\' | translate }}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button> <button ng-if="::(divisionMember.Active && $ctrl.isPermitted(listType,\'arno.personnel.dossier.activeState.manage\', [divisionMember.DivisionId]))" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deactivateMember(this, listType)" title="{{ \'modules.personnel.personnelList.deactivateMember\' | translate }}"><i class="ion-person"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.personnelList.setInactive"></span></button> <button ng-if="::(!divisionMember.Active && divisionMember.Active !== null && $ctrl.isPermitted(listType,\'arno.personnel.dossier.activeState.manage\', [divisionMember.DivisionId]))" class="btn btn-success btn-with-icon btn-xs" ng-click="$ctrl.activateMember(this, listType)" title="{{ \'modules.personnel.personnelList.reactivateMember\' | translate }}"><i class="ion-checkmark-round"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.personnelList.setActive"></span></button></div></td></tr><tr ng-if="!listType.displayedCollection" ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}">...</td></tr><tr ng-if="listType.displayedCollection && listType.displayedCollection.length === 0"><td class="text-center" colspan="{{$ctrl.getFullCSpan(listType.tableConfig, listType.isOrgList)}}"><i translate="modules.personnel.personnelList.noPersonEntries"></i></td></tr></tbody><tfoot><tr><td colspan="{{$ctrl.getFullCSpan(listType.tableConfig)}}" class="text-center"><st-pagination st-items-by-page="listType.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/personnel/personnelList/removeMember.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.personnelList.removeMemberModalTitle"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.personnel.personnelList.removeMemberModalText1" translate-values="{ member: divisionMember.Member.fullName, division: divisionMember.Member.DivisionName }"></p><p><b>{{ (\'generalTerms.caution\' | translate) + \':\' }}</b> {{ (\'modules.personnel.personnelList.removeMemberModalText2\' | translate) }}</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i> {{(\'generalTerms.caution\' | translate)}}</button></div></div>');
$templateCache.put('app/pages/statistics/helperhours/helperhours.html','<div class="row arno-statistic-user-usage"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.statistic.helperhours.panelTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="true" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.statistics.helperHours"><statistic-helper-hours current-data="self.helperHoursStatisticData" provider="self.statisticalDataProvider" division-ids="self.divisionIds" table-show="self.showHelperTable" table-provider="self.helperTableProvider" table-data="self.helperTableData"></statistic-helper-hours></div></div></div>');
$templateCache.put('app/pages/statistics/usage/usage.html','<div class="row arno-statistic-user-usage"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'Nutzungszeit\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.statistics.userUsage"><div ng-if="$usage.selectedCtx === \'rootOrg\'" ng-init="$usage.updateUsageData($usage.initStatData.usageData)"><div class="row"><div class="col-xs-12 col-md-4 mb-10" id="arno-statistic-user-usage-picker" ng-style="{ \'margin-top\': $usage.plusMarginUsagePicker }"><p class="align-center">Zeitspanne (2 unterschiedliche Tage w\xE4hlen)</p><div uib-datepicker="" ng-model="$usage.usageDataFrom" multi-select="$usage.usageDates" select-range="true" datepicker-options="$usage.datepickerOptions.usage"></div></div><div class="col-xs-12 col-md-8" id="arno-statistic-user-usage-chart" ng-style="{ \'margin-top\': $usage.plusMarginUsageChart }"><canvas class="chart chart-bar" chart-data="$usage.usageData" chart-labels="$usage.usageLabel" chart-options="$usage.chartOpts" chart-dataset-override="$usage.usageDataset"></canvas></div></div><div class="row mt-40"><div class="col-xs-12 col-md-8"><canvas class="chart chart-bar" chart-data="$usage.usageDataAverage" chart-labels="$usage.usageLabel" chart-options="$usage.chartOpts" chart-series="$usage.usageSeriesAverage"></canvas></div><div class="col-xs-12 col-md-4"><canvas class="chart chart-doughnut" chart-data="$usage.usageLengthData" chart-labels="$usage.usageLengthLabel" chart-options="$usage.doughnutOpts"></canvas></div></div></div><div ng-if="!$usage.selectedCtx || !($usage.selectedCtx === \'rootOrg\')" class="text-center">Keine Statistik vorhanden.</div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="\'Nutzungszeitr\xE4ume\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.statistics.userUsage"><div ng-if="$usage.selectedCtx === \'rootOrg\'"><div class="row"><div class="col-md-4 mb-10" id="arno-statistic-user-timescale-picker" ng-style="{ \'margin-top\': $usage.plusMarginTimescalePicker }"><p class="align-center">Zeitpunkt</p><div uib-datepicker="" ng-model="$usage.timescaleSelection" datepicker-options="$usage.datepickerOptions.timescale"></div></div><div class="col-md-8" id="arno-statistic-user-timescale-chart" ng-style="{ \'margin-top\': $usage.plusMarginTimescaleChart }"><canvas class="chart chart-line" chart-options="$usage.chartOpts" chart-labels="$usage.timescaleLabel" chart-data="$usage.timescaleData" chart-series="$usage.timescaleSeries"></canvas></div></div></div><div ng-if="!$usage.selectedCtx || !($usage.selectedCtx === \'rootOrg\')" class="text-center">Keine Statistik vorhanden.</div></div></div></div>');
$templateCache.put('app/pages/terms/agbModal/agbModal.html','<div ba-panel="" ba-panel-title="\'Nutzungsbedingungen\'"><form class="termsForm"><div ng-bind-html="$ctrl.termstext"></div><hr><div class="form-group"><div class="col-xs-12"><div class="text-right"><button data-cy="terms-agbmodal-button-dismiss" type="button" class="btn btn-default" ng-click="$dismiss()">Ablehnen</button> <button data-cy="terms-agbmodal-button-accept" type="button" class="btn btn-primary" ng-click="$ctrl.accept()">Nutzungsbedingung akzeptieren</button></div></div></div></form></div>');
$templateCache.put('app/pages/terms/disagreetermsModal/disagreeAGBModal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title">Nutzungsbedingungen ablehnen?</h4></div><div class="modal-body text-center"><div class="section-block red-text"><p>Wenn du die Nutzungsbedingungen ablehnst, trittst du aus der Organisation aus!</p><p ng-if="$ctrl.acceptedLatestTerms || !$ctrl.hasAcceptedAnyTerms">Falls du die Nutzungsbedingungen nicht innerhalb von 30 Tagen annimmst, werden deine Daten in dieser Organisation gel\xF6scht.</p><p ng-if="!$ctrl.acceptedLatestTerms && $ctrl.hasAcceptedAnyTerms">Alle Rechte werden sofort entzogen und deine Daten werden nach {{ $ctrl.timeUntilWithdrawal }} Tagen unwiderruflich gel\xF6scht.</p></div><div class="mt-10 text-left"><label for="declineComment">Kommentar</label> <input type="text" class="form-control" id="declineComment" ng-model="$ctrl.declineComment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$close({ declineComment: $ctrl.declineComment })">Best\xE4tigen</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">Zur\xFCck</button></div></div>');
$templateCache.put('app/pages/terms/disagreetermsModal/disagreePrivacyModal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title">Datenschutzerkl\xE4rung widersprechen?</h4></div><div class="modal-body text-center"><div class="section-block red-text"><p>Wenn du die Datenschutzerkl\xE4rung ablehnst wirst du abgemeldet!</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$close()">Ablehnen</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">Zur\xFCck</button></div></div>');
$templateCache.put('app/pages/terms/privacyModal/privacyModal.html','<div ba-panel="" ba-panel-title="\'Datenschutzerkl\xE4rung\'"><form class="termsForm"><div ng-bind-html="$ctrl.privacyTermsText"></div><hr><div class="form-group"><div class="col-xs-12"><div class="text-right"><button data-cy="terms-privacymodal-button-accept" type="submit" class="btn btn-primary" ng-click="$close()">Zur Kenntnis genommen</button></div></div></div></form></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container" ng-class="::{\'switcher-custom\' : customSwitch}"><input ng-disabled="switcherDisabled" type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle" ng-style="getStyle(\'switcher\')"><div class="handle-container" ng-style="getStyle(\'handleContainer\')"><span class="handle handle-on" title="{{getHint(true)}}" ng-class="{\'handle-active\':switcherValue}" ng-style="getStyle(\'handle\')">{{switcherKeys.on}}</span> <span class="handle handle-plain" ng-style="getStyle(\'handle\')"></span> <span class="handle handle-off" title="{{getHint(false)}}" ng-class="{\'handle-active\':!switcherValue}" ng-style="getStyle(\'handle\')">{{switcherKeys.off}}</span></div></div></label>');
$templateCache.put('app/theme/components/abMultiselect/abMultiselect.html','<div class="btn-group" style="width: 100%"><div uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default ng-binding dropdown-toggle" ng-class="classesBtn" ng-click="toggleDropdown()" uib-dropdown-toggle="" ng-disabled="disabled" style="background-color: #FFF;">{{ getButtonText() }}&nbsp;<span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-form" uib-dropdown-menu=""><li ng-show="showSelectAll"><a ng-click="selectAll()" href=""><span class="glyphicon glyphicon-ok"></span> {{ labels.selectAll || (\'components.abMultiselect.selectAll\' | translate) }}</a></li><li ng-show="showUnselectAll"><a ng-click="unselectAll()" href=""><span class="glyphicon glyphicon-remove"></span> {{ labels.unselectAll || (\'components.abMultiselect.deselectAll\' | translate) }}</a></li><li ng-show="(showSelectAll || showUnselectAll)" class="divider"></li><li role="presentation" ng-repeat="option in selectedOptions" class="active"><a class="item-selected" href="" title="{{showTooltip ? getDisplay(option) : \'\'}}" ng-click="toggleItem(option)" style="overflow-x: hidden;text-overflow: ellipsis"><span class="glyphicon glyphicon-remove"></span> {{ getDisplay(option) }}</a></li><li ng-show="selectedOptions.length > 0" class="divider"></li><li ng-show="showSearch"><div class="dropdown-header"><input type="text" class="form-control input-sm" style="width: 100%;" ng-model="searchFilter" placeholder="{{ labels.search || (\'components.abMultiselect.search\' | translate) }}" ng-change="updateOptions()"></div></li><li ng-show="showSearch" class="divider"></li><li role="presentation" ng-repeat="option in unselectedOptions | filter:search() | limitTo: searchLimit" ng-if="!isSelected(option)" ng-class="{disabled : selectionLimit && selectedOptions.length >= selectionLimit}"><a class="item-unselected" href="" title="{{showTooltip ? getDisplay(option) : \'\'}}" ng-click="toggleItem(option)" style="overflow-x: hidden;text-overflow: ellipsis">{{ getDisplay(option) }}</a></li><li class="divider" ng-show="selectionLimit > 1"></li><li role="presentation" ng-show="selectionLimit > 1"><a>{{ selectedOptions.length || 0 }} / {{ selectionLimit }} {{ labels.itemsSelected || (\'components.abMultiselect.selected\' | translate) }}</a></li></ul></div></div>');
$templateCache.put('app/theme/components/allocReqFulfillment/allocReqFulfillment.html','<div class="arno-alloc-req-fulfillment"><uib-accordion><uib-accordion-group style="overflow-x: auto;width: 100%;" is-open="$first" panel-class="bootstrap-panel accordion-panel panel-default" ng-repeat="requirementSet in $arf.fulfillment.requirementsSets"><uib-accordion-heading>{{requirementSet.title}}<status-light is-green="requirementSet.fulfilled" class="\'pull-right\'" ng-if="$arf.hasFulfilledState(requirementSet)"></status-light></uib-accordion-heading><h4><span translate="components.allocReqFulfillment.workInOtherFunction"></span></h4><table class="table table-condensed"><tbody class="without-top-border"><tr><td class="align-left-force" translate="generalTerms.qualifications"></td><td><span ng-if="requirementSet.characteristics.DEFAULT.nonExistent"><i translate="generalTerms.notAvailable"></i></span><ul ng-if="requirementSet.characteristics.DEFAULT.qualifications.length"><li ng-repeat="qualificationId in requirementSet.characteristics.DEFAULT.qualifications"><status-light is-green="!$arf.isIn(qualificationId, requirementSet.characteristics.DEFAULT.unfulfilledQualifications)" class="\'light-inline\'"></status-light>{{ $arf.fulfillment.qualificationMap[qualificationId] }}</li></ul><span ng-if="!requirementSet.characteristics.DEFAULT.nonExistent && !requirementSet.characteristics.DEFAULT.qualifications.length">&mdash;</span></td></tr><tr><td class="align-left-force" translate="models.Approval" translate-values="{ PLURAL: true }"></td><td><span ng-if="requirementSet.characteristics.DEFAULT.nonExistent"><i translate="generalTerms.notAvailable"></i></span><ul ng-if="requirementSet.characteristics.DEFAULT.approvals.length"><li ng-repeat="approvalId in requirementSet.characteristics.DEFAULT.approvals"><status-light is-green="!$arf.isIn(approvalId, requirementSet.characteristics.DEFAULT.unfulfilledApprovals)" class="\'light-inline\'"></status-light>{{ $arf.fulfillment.approvalMap[approvalId] }}</li></ul><span ng-if="!requirementSet.characteristics.DEFAULT.nonExistent && !requirementSet.characteristics.DEFAULT.approvals.length">&mdash;</span></td></tr></tbody></table><div ng-if="$arf.hasAdditionalCharacteristics(requirementSet.characteristics)"><h4 class="additional-characteristics"><span translate="components.allocReqFulfillment.additionalFeatures"></span></h4><table class="table table-condensed"><thead><tr class="black-muted-bg"><th class="align-left-force" translate="components.allocReqFulfillment.requirements"></th><th ng-repeat="(characteristicKey, characteristicValue) in requirementSet.characteristics" ng-if="characteristicKey !== \'DEFAULT\'">{{$arf.characteristicMap[characteristicKey] || characteristicKey}}</th></tr></thead><tbody><tr><td class="align-left-force" translate="generalTerms.qualifications"></td><td ng-repeat="(characteristicKey, characteristicValue) in requirementSet.characteristics" ng-if="characteristicKey !== \'DEFAULT\'"><span ng-if="characteristicValue.nonExistent"><i translate="generalTerms.notAvailable"></i></span><ul ng-if="characteristicValue.qualifications.length"><li ng-repeat="qualificationId in characteristicValue.qualifications"><status-light is-green="!$arf.isIn(qualificationId, characteristicValue.unfulfilledQualifications)" class="\'light-inline\'"></status-light>{{ $arf.fulfillment.qualificationMap[qualificationId] }}</li></ul><span ng-if="!characteristicValue.nonExistent && !characteristicValue.qualifications.length">&mdash;</span></td></tr><tr><td class="align-left-force" translate="models.Approval" translate-values="{ PLURAL: true }"></td><td ng-repeat="(characteristicKey, characteristicValue) in requirementSet.characteristics" ng-if="characteristicKey !== \'DEFAULT\'"><span ng-if="characteristicValue.nonExistent"><i translate="generalTerms.notAvailable"></i></span><ul ng-if="characteristicValue.approvals.length"><li ng-repeat="approvalId in characteristicValue.approvals"><status-light is-green="!$arf.isIn(approvalId, characteristicValue.unfulfilledApprovals)" class="\'light-inline\'"></status-light>{{ $arf.fulfillment.approvalMap[approvalId] }}</li></ul><span ng-if="!characteristicValue.nonExistent && !characteristicValue.approvals.length">&mdash;</span></td></tr></tbody></table></div></uib-accordion-group></uib-accordion></div>');
$templateCache.put('app/theme/components/approvalList/approvalList.html','<div class="arno-approval-list"><div class="horizontal-scroll" ng-show="$approvalListCtrl.approvalList.length"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr class="black-muted-bg"><th class="align-left-force" ng-if="!$approvalListCtrl.mediaSizeXs && $approvalListCtrl.displayApprovalGroup" translate="generalTerms.approvalGroup"></th><th class="align-left-force" translate="generalTerms.release"></th><th ng-if="$approvalListCtrl.displayMemberApprovalMode" translate="generalTerms.moveInData"></th><th ng-if="$approvalListCtrl.displayMemberApprovalMode" translate="generalTerms.approvalGroup"></th><th ng-if="::$approvalListCtrl.getShowElement(\'actions\') && !$approvalListCtrl.onlyView" translate="generalTerms.action"></th></tr></thead><tbody><tr ng-repeat="approval in $approvalListCtrl.approvalList | orderBy:[\'GroupName\', \'ApprovalName\'] | groupBy:\'GroupName\'"><td ng-if="approval.byGroupNewItem && !$approvalListCtrl.mediaSizeXs && $approvalListCtrl.displayApprovalGroup" rowspan="{{approval.byGroup.unchangedFor + 1}}" class="align-left-force">{{approval.GroupName}}</td><td class="align-left-force"><span ng-if="$approvalListCtrl.displayMemberApprovalMode"><i class="ion-ribbon-b" ng-class="{\'arno-primary-text\':!approval.onlyInherited || approval.pendingAction === \'add\'}" title="{{(!approval.onlyInherited || approval.pendingAction === \'add\') ? \'Zugewiesene Freigabe\' : \'Geerbte Freigabe\'}}"></i></span> {{approval.ApprovalName}}</td><td ng-if="$approvalListCtrl.displayMemberApprovalMode">{{(approval.AcquireDate | date : \'dd.MM.yyyy\' ) || ((!approval.onlyInherited || approval.pendingAction === \'add\') ? \'(nie)\' : \'(geerbt)\')}}</td><td ng-if="$approvalListCtrl.displayMemberApprovalMode">{{(approval.ExpireDate | date : \'dd.MM.yyyy\' ) || ((!approval.onlyInherited || approval.pendingAction === \'add\') ? (\'generalTerms.cancel\' | translate) : \'(geerbt)\')}}</td><td ng-if="::$approvalListCtrl.getShowElement(\'actions\') && !$approvalListCtrl.onlyView"><button class="btn btn-xs btn-default" ng-if="$approvalListCtrl.displayMemberApprovalMode" ng-class="{\'btn-icon btn-xs-small-height\': $approvalListCtrl.mediaSizeXs, \'btn-with-icon\': !$approvalListCtrl.mediaSizeXs}" ng-click="$approvalListCtrl.editApproval(approval)"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit"></span></button> <button class="btn btn-xs" type="button" ng-if="$approvalListCtrl.displayKeepOrDeleteApprovalBtn(approval)" ng-class="{\'btn-danger\':approval.pendingAction !== \'delete\', \'btn-warning\': approval.pendingAction === \'delete\', \'btn-icon btn-xs-small-height\': $approvalListCtrl.mediaSizeXs, \'btn-with-icon\': !$approvalListCtrl.mediaSizeXs}" ng-click="$approvalListCtrl.onApprovalDelete(approval)"><i ng-class="{\'ion-ios-trash\':approval.pendingAction !== \'delete\', \'ion-plus-round\':approval.pendingAction === \'delete\'}"></i> <span class="btn-span hidden-xs">{{approval.pendingAction === \'delete\' ? \'Beibehalten\' : approval.pendingAction === \'edit\' ? \'Nicht \xE4ndern\' : \'Entfernen\'}}</span></button> <button class="btn btn-xs btn-danger" type="button" ng-if="$parent.approvalAdd && approval.pendingAction === \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $approvalListCtrl.mediaSizeXs, \'btn-with-icon\': !$approvalListCtrl.mediaSizeXs}" ng-click="$approvalListCtrl.onApprovalPendingDelete(approval)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.dontAdd"></span></button></td></tr></tbody></table></div></div><div ng-show="!$approvalListCtrl.approvalList.length"><p translate="generalTerms.noReleases"></p></div><div class="row"><div class="col-md-12 col-xs-12"><div ng-show="$approvalListCtrl.flatApprovalHierarchy && !$approvalListCtrl.onlyView" class="form-group list-form-add-new"><label translate="generalTerms.addRelease"></label><div class="input-group input-group-with-select input-group-with-btn-text" ng-show="::$approvalListCtrl.getShowElement(\'addApproval\')"><ui-select ng-model="$approvalListCtrl.approvalToAdd" class="btn-group bootstrap-select form-control" append-to-body="!$approvalListCtrl.isModalOpen()" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{\'generalTerms.addRelease\' | translate}}">{{$select.selected.Title}}</ui-select-match><ui-select-choices repeat="approvalChoice in $approvalListCtrl.flatApprovalHierarchy | filter: {$: $select.search} | orderBy:[\'GroupName\',\'ApprovalName\']" group-by="\'GroupName\'"><i ng-class="{\'ion-ios-people\':!approvalChoice.DivisionId,\'ion-ios-people-outline\':approvalChoice.DivisionId}"></i> <span>{{ approvalChoice.ApprovalName }}</span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$approvalListCtrl.approvalAdd()" ng-disabled="!$approvalListCtrl.approvalToAdd" translate="generalTerms.add"><i class="ion-plus-round"></i></button></span></div></div></div></div></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalProcessList.html','<div><div ng-if="$ctrl.allowExport || $ctrl.showMemberName" class="arno-personnel-list-panel-header form-group clearfix"><div><div ng-if="$ctrl.allowExport" class="btn-toolbar pull-right"><button class="btn btn-default btn-with-icon" ng-click="$ctrl.export()" ng-disabled="!$ctrl.divisionId || !$ctrl.divisionId.length"><i class="fa fa-download"></i><span class="hidden-xs">Export</span></button></div><div ng-if="$ctrl.showMemberName" class="btn-toolbar"><button class="btn btn-primary btn-with-icon" type="button" ng-if="$ctrl.allowStartPerm || $ctrl.hasStartSimpleClearancePerm()" ng-click="$ctrl.approvalprocessModal(\'add\')" ng-disabled="$ctrl.divisionId.length > 1"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.approvals.applyForApprovalBtn"></span></button><div class="btn-group dropdown mr-10" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ $ctrl.currentTableConf.hasViewModifications ? (\'generalTerms.currentView\' | translate) : $ctrl.currentTableConf.selectedView === \'0\' ? (\'generalTerms.defaultView\' | translate) : $ctrl.currentTableConf.customViews[$ctrl.currentTableConf.selectedView].Name }}<span class="caret ml-10"></span></button><ul uib-dropdown-menu="" role="menu"><li role="menuitem"><a href="" ng-if="$ctrl.hasViewModifications" translate="generalTerms.currentView"></a></li><li role="menuitem"><a href="" ng-click="$ctrl.changeListView($ctrl.currentTableConf, \'0\', \'0\')" translate="generalTerms.defaultView"></a></li><li role="menuitem" ng-repeat="(key, val) in $ctrl.currentTableConf.customViews"><a href="" ng-click="$ctrl.changeListView($ctrl.currentTableConf, val, key)">{{ val.Name }}</a></li></ul></div><button type="button" class="btn btn-default" ng-click="$ctrl.openTableConfig($ctrl.currentTableConf)"><span><i class="ion-wrench"></i></span></button></div><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $ctrl.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.changePageSize(i)">{{ i }}</a></li></ul></div><div class="arno-personnel-list-custom-switcher btn-toolbar ml-5"><ba-switcher switcher-style="primary" switcher-value="$ctrl.demandForActionBtnActive" switcher-keys="$ctrl.demandForActionSwitcherKeys" switcher-width="130"></></ba-switcher></div></div></div></div><div class="table-responsive arno-aggregatable-table"><table st-table="$ctrl.displayCollection" st-safe-src="$ctrl.approvalProcesses" config-inject="" st-filtered-collection="" table-config="$ctrl.getCurrentTableView()" class="table table-condensed table-hover"><thead><tr class="sortable black-muted-bg"><th ng-if="!$ctrl.disallowEdit" class="force-minimal sort-exception text-center">{{ (\'modules.personnel.approvals.selected\' | translate) }}<span ng-if="!$ctrl.showMemberName">({{$ctrl.chosenCount}})</span></th><th ng-if="$ctrl.currentTableConf.tableConfig[\'StatusLight\']"></th><th ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.ClearanceGroup\']" class="aggregatable">{{ (\'models.ClearanceGroup\' | translate) }} <button class="btn btn-default btn-with-icon btn-xs agg-icon column-control" title="{{ \'modules.personnel.approvals.aggregateGroupBtnTitle\' | translate }}" ng-class="{active: $ctrl.aggregations[\'Approval.ClearanceGroup.id\']}" ng-click="$ctrl.aggregate(\'Approval.ClearanceGroup.id\', $event)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th ng-if="$ctrl.currentTableConf.tableConfig[\'Division.Name\']" st-sort="Division.Name">{{ (\'models.Division\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'createdAt\']" st-sort="createdAt">{{ (\'models.ApprovalAllocation.createdAt\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'updatedAt\']" st-sort="updatedAt">{{ (\'models.ApprovalAllocation.updatedAt\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'InitiatingMember.fullName\']" st-sort="InitiatingMember.fullName">{{ (\'models.ApprovalAllocation.InitiatingMember\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.FirstName\']" st-sort="AffectedMember.FirstName">{{ (\'models.Member.FirstName\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.LastName\']" st-sort="AffectedMember.LastName">{{ (\'models.Member.LastName\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.fullName\']" st-sort="AffectedMember.fullName" class="aggregatable">{{ (\'models.Member.fullName\' | translate) }} <button class="btn btn-default btn-with-icon btn-xs agg-icon column-control" title="{{ \'modules.personnel.approvals.aggregateNameBtnTitle\' | translate }}" ng-class="{active: $ctrl.aggregations[\'AffectedMember.id\']}" ng-click="$ctrl.aggregate(\'AffectedMember.id\', $event)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Title\']" st-sort="AffectedMember.Title">{{ (\'models.Member.Title\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Salutation\']" st-sort="AffectedMember.Salutation">{{ (\'models.Member.Salutation\' | translate) }}selectPage(page)</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.MailSalutation\']" st-sort="AffectedMember.MailSalutation">{{ (\'models.Member.MailSalutation\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.NameAffix\']" st-sort="AffectedMember.NameAffix">{{ (\'models.Member.NameAffix\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Street\']" st-sort="AffectedMember.Street">{{ (\'models.Member.Street\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.HouseNumber\']" st-sort="AffectedMember.HouseNumber">{{ (\'models.Member.HouseNumber\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.AddressAffix\']" st-sort="AffectedMember.AddressAffix">{{ (\'models.Member.AddressAffix\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.ZIP\']" st-sort="AffectedMember.ZIP">{{ (\'models.Member.ZIP\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.City\']" st-sort="AffectedMember.City">{{ (\'models.Member.City\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.CountryId\']" st-sort="AffectedMember.CountryId">{{ (\'models.Member.CountryId\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.BirthDate\']" st-sort="AffectedMember.BirthDate">{{ (\'models.Member.BirthDate\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Gender\']" st-sort="AffectedMember.Gender">{{ (\'models.Member.Gender\' | translate) }}</th><th ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Group\']">{{ (\'models.MemberGroup\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Letter\']" st-sort="Approval.ApprovalAllocations[0].Letter">{{ (\'models.ApprovalAllocation.Letter\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder1\']" st-sort="Approval.ApprovalAllocations[0].Reminder1">{{ (\'models.ApprovalAllocation.Reminder1\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder2\']" st-sort="Approval.ApprovalAllocations[0].Reminder2">{{ (\'models.ApprovalAllocation.Reminder2\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Inspection\']" st-sort="Approval.ApprovalAllocations[0].Inspection">{{ (\'models.ApprovalAllocation.Inspection\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Resubmission\']" st-sort="Approval.ApprovalAllocations[0].Resubmission">{{ (\'models.ApprovalAllocation.Resubmission\' | translate) }}</th><th ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.updatedAt\']" st-sort="Approval.ApprovalAllocations[0].updatedAt">{{ (\'generalTerms.lastChange\' | translate) }}</th><th st-sort="Approval.Title" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Title\']">{{ (\'models.Approval\' | translate) }}</th><th st-sort="DisplayState" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.State\']">{{ (\'models.Approval.State\' | translate) }}</th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Type\']" st-sort="Type">{{ (\'models.Approval.Type\' | translate) }}</th><th class="arno-table-button-cell">{{ (\'generalTerms.actions\' | translate) }}</th></tr><tr ng-if="$ctrl.showMemberName"><th class="text-center pb-10" ng-if="!$ctrl.disallowEdit"><strong>{{$ctrl.chosenCount}}</strong></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'StatusLight\']"></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'Approval.ClearanceGroup\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$ctrl.groupSearch" class="form-control with-default-addon input-sm" ng-change="$ctrl.search.ClearanceGroup.Name=$ctrl.groupSearch;"></div></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'Division.Name\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" ng-model="$ctrl.search.Division.Name" class="form-control with-default-addon input-sm"></div></th><th ng-if="$ctrl.currentTableConf.tableConfig[\'createdAt\']"></th><th ng-if="$ctrl.currentTableConf.tableConfig[\'updatedAt\']"></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'InitiatingMember.fullName\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="InitiatingMember.fullName" type="search" ng-model="$ctrl.search.InitiatingMember.fullName" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.FirstName\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.FirstName" type="search" ng-model="$ctrl.search.AffectedMember.FirstName" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.LastName\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.LastName" type="search" ng-model="$ctrl.search.AffectedMember.LastName" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.fullName\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.fullName" type="search" ng-model="$ctrl.search.fullName" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Title\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.Title" type="search" ng-model="$ctrl.search.AffectedMember.Title" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Salutation\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.Salutation" type="search" ng-model="$ctrl.search.AffectedMember.Salutation" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.MailSalutation\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.MailSalutation" type="search" ng-model="$ctrl.search.AffectedMember.MailSalutation" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.NameAffix\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.NameAffix" type="search" ng-model="$ctrl.search.AffectedMember.NameAffix" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Street\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.Street" type="search" ng-model="$ctrl.search.AffectedMember.Street" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.HouseNumber\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.HouseNumber" type="search" ng-model="$ctrl.search.AffectedMember.HouseNumber" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.AddressAffix\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.AddressAffix" type="search" ng-model="$ctrl.search.AffectedMember.AddressAffix" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.ZIP\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.ZIP" type="search" ng-model="$ctrl.search.AffectedMember.ZIP" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.City\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.City" type="search" ng-model="$ctrl.search.AffectedMember.City" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.CountryId\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.CountryId" type="search" ng-model="$ctrl.search.AffectedMember.CountryId" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.BirthDate\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.BirthDate" type="search" ng-model="$ctrl.search.AffectedMember.BirthDate" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Gender\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="AffectedMember.Gender" type="search" ng-model="$ctrl.search.AffectedMember.Gender" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.showMemberName && $ctrl.currentTableConf.tableConfig[\'AffectedMember.Group\']" style="max-width: 230px;"><div><div class="input-group"><tag-picker default-label="(\'modules.personnel.approvals.groupInputPlaceholder\' | translate)" tags="$ctrl.memberGroups" selected-tags="$ctrl.chosenGroups" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'"></tag-picker></div></div></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Letter\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder1\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder2\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Inspection\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Resubmission\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.updatedAt\']"></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Title\']"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Approval.Title" type="search" ng-model="$ctrl.search.Approval.Title" class="form-control with-default-addon input-sm"></div></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.State\']" style="max-width: 230px;"><ab-multiselect ng-model="$ctrl.filterStates" options="$ctrl.possibleStates" id-prop="id" display-prop="label" show-tooltip="true" classes-btn="\'btn-block btn-sm\'" placeholder="{{(\'modules.personnel.approvals.filterStateDefaultLabel\' | translate)}}"></ab-multiselect></th><th class="force-minimal" ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Type\']"></th><th class="force-minimal"></th></tr></thead><tbody><tr ng-repeat="(key, approvalprocess) in $ctrl.displayCollection | groupBy: $ctrl.groupAndOrderBy"><td ng-if="$ctrl.checkBoxAggCond(approvalprocess) && !$ctrl.disallowEdit" class="text-center" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] || $ctrl.aggregations[\'Approval.ClearanceGroup.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}"><label class="custom-checkbox mt-0 mb-0 ml-9"><input type="checkbox" ng-disabled="!$ctrl.showEditBtn(approvalprocess)" ng-model="$ctrl.chosen[approvalprocess.id]" ng-click="$ctrl.select(approvalprocess, (approvalprocess.byGroup.unchangedFor + 1) > 1)"><span>&nbsp;</span></label></td><td ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" ng-if="$ctrl.currentTableConf.tableConfig[\'StatusLight\']"><status-light class="\'light-inline\'" is-green="(approvalprocess.State === \'ASSIGNED\' || approvalprocess.State === \'REJECTED\' || approvalprocess.State === \'RESUB_APPROACHING\')" use-yellow-light="true" use-one-light="true" green-title="(\'modules.personnel.approvals.statusLightGreenTitle\' | translate)" yellow-title="(\'modules.personnel.approvals.statusLightYellowTitle\' | translate)" red-title="(\'modules.personnel.approvals.statusLightRedTitle\' | translate)" is-yellow="(approvalprocess.State === \'PENDING\' || approvalprocess.State === \'PROCESSING\')"></status-light></td><td ng-if="(($ctrl.aggregations[\'Approval.ClearanceGroup.id\'] && approvalprocess.byGroupNewItem) || !$ctrl.aggregations[\'Approval.ClearanceGroup.id\']) && $ctrl.currentTableConf.tableConfig[\'Approval.ClearanceGroup\']" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'Approval.ClearanceGroup.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}">{{ ::approvalprocess.Approval.ClearanceGroup.Name || (\'modules.personnel.approvals.noGroupAssinged\' | translate) }}</td><td ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" ng-if="$ctrl.currentTableConf.tableConfig[\'Division.Name\']"><span>{{ ::approvalprocess.Division.Name || (\'modules.personnel.approvals.noDivision\' | translate) }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'createdAt\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.createdAt | date:\'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'updatedAt\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.updatedAt | date:\'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'InitiatingMember.fullName\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.InitiatingMember.fullName }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.FirstName\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.FirstName }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.LastName\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.LastName }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.fullName\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.fullName }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.Title\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ approvalprocess.AffectedMember.Title ? ((\'models.Member.Title.\' + approvalprocess.AffectedMember.Title) | translate) : \'\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.Salutation\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ approvalprocess.AffectedMember.Salutation ? ((\'models.Member.Salutation.\' + approvalprocess.AffectedMember.Salutation) | translate) : \'\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.MailSalutation\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.MailSalutation }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.NameAffix\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.NameAffix }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.Street\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.Street }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.HouseNumber\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.HouseNumber }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.AddressAffix\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.AddressAffix }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.ZIP\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.ZIP }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.City\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.City }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.CountryId\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.CountryId }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.BirthDate\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ ::approvalprocess.AffectedMember.BirthDate | date:\'dd.MM.yyyy\' : \'UTC\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.Gender\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span>{{ approvalprocess.AffectedMember.Gender ? ((\'models.Member.Gender.\' + approvalprocess.AffectedMember.Gender) | translate) : \'\' }}</span></td><td ng-if="$ctrl.showBaseDataField(approvalprocess.byGroupNewItem, \'AffectedMember.Group\')" ng-class="{\'vertical-align-middle\': approvalprocess.byGroup.unchangedFor}" rowspan="{{( $ctrl.aggregations[\'AffectedMember.id\'] ? approvalprocess.byGroup.unchangedFor + 1 : 1)}}"><span ng-repeat="group in approvalprocess.AffectedMember.MemberGroups">{{ :: group.Name}}{{$index + 1 < approvalprocess.AffectedMember.MemberGroups.length ? \', \' : \'\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Letter\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].Letter | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder1\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].Reminder1 | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Reminder2\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].Reminder2 | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Inspection\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].Inspection | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.Resubmission\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].Resubmission | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'ApprovalAllocation.updatedAt\']"><span>{{ ::approvalprocess.Approval.ApprovalAllocations[0].updatedAt | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Title\']"><span>{{ ::approvalprocess.Approval.Title }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.State\']"><span>{{ ::$ctrl.state[approvalprocess.State] }}</span></td><td ng-if="$ctrl.currentTableConf.tableConfig[\'Approval.Type\']"><span>{{ ::((\'models.Approval.Type.\' + approvalprocess.Approval.Type) | translate) || (\'modules.personnel.approvals.notSpecified\' | translate) }}</span></td><td ng-click="$ctrl.prevent($event)" class="arno-default-pointer actionbar"><div class="nowrap"><span ng-class="{ \'pull-right\': !approvalprocess.Approval.AllowRejected && !disallowEdit }"><button ng-class="{\'full-invisible\': ($ctrl.disallowEdit || !$ctrl.showEditBtn(approvalprocess) || approvalprocess.Paused)}" ng-if="!$ctrl.disallowEdit" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.approvalprocessModal(\'edit\', approvalprocess)" title="{{ \'modules.personnel.approvals.editBtnTitle\' | translate }}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="!approvalprocess.Paused && $ctrl.showEditBtn(approvalprocess) && !$ctrl.disallowEdit" ng-click="$ctrl.setPaused(approvalprocess, true)" title="{{ \'modules.personnel.approvals.pauseBtnTitle\' | translate }}"><i class="fa fa-pause"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.approvals.pause"></span></button> <button ng-if="approvalprocess.Paused && $ctrl.showEditBtn(approvalprocess) && !$ctrl.disallowEdit" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.setPaused(approvalprocess, false)" title="{{ \'modules.personnel.approvals.continueBtnTitle\' | translate }}"><i class="fa fa-play"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.approvals.continue"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="$ctrl.disallowEdit || $ctrl.showDetailsBtn(approvalprocess)" ng-click="$ctrl.approvalprocessModal(\'details\', approvalprocess)" title="{{ \'modules.personnel.approvals.detailBtnTitle\' | translate }}"><i class="fa fa-eye"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.approvals.detail"></span></button> <button ng-if="!$ctrl.disallowEdit && $ctrl.showDeleteBtn(approvalprocess)" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.removeApprovalprocess(approvalprocess)" title="{{ \'modules.personnel.approvals.deleteBtnTitle\' | translate }}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></span></div></td></tr><tr ng-if="!$ctrl.displayCollection || $ctrl.displayCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.personnel.approvals.noProcessesText"></i></td></tr></tbody><tfoot><tr><td colspan="{{$ctrl.getColspan()}}" class="text-center"><st-pagination st-items-by-page="$ctrl.pageSize" st-template="app/theme/components/paging/paging.html">></st-pagination></td></tr></tfoot></table></div><div ng-if="!$ctrl.disallowEdit" class="mt-20 mb-10 clearfix"><div class="pull-left"><button class="btn btn-default" ng-disabled="!$ctrl.displayCollection || !$ctrl.displayCollection.length" ng-click="$ctrl.setSelection(true)" title="{{ \'modules.personnel.approvals.selectAllBtnTitle\' | translate }}"><span class="hidden-xs hidden-sm" translate="generalTerms.selectAll"></span></button> <button class="btn btn-default" ng-click="$ctrl.setSelection(false)" ng-disabled="!$ctrl.chosenCount" title="{{ \'modules.personnel.approvals.deSelectAllBtnTitle\' | translate }}"><span class="hidden-xs hidden-sm" translate="generalTerms.resetSelection"></span></button></div><div class="pull-right"><button class="btn btn-default btn-with-icon" ng-click="$ctrl.approvalprocessModal(\'edit\', null, true, 1)" ng-disabled="!$ctrl.chosenCount" title="{{ \'modules.personnel.approvals.inspectionBtnTitle\' | translate }}"><i class="fa fa-check"></i><span class="hidden-xs hidden-sm" translate="modules.administration.adminClearances.inspection"></span></button> <button class="btn btn-default btn-with-icon" ng-click="$ctrl.approvalprocessModal(\'edit\', null, true, 2)" ng-disabled="!$ctrl.chosenCount" title="{{ \'modules.personnel.approvals.letterBtnTitle\' | translate }}"><i class="fa fa-info"></i><span class="hidden-xs hidden-sm" translate="models.ApprovalAllocation.Letter"></span></button><div class="btn-group" uib-dropdown=""><button uib-dropdown-toggle="" type="button" ng-disabled="!$ctrl.chosenCount" class="btn btn-primary btn-with-icon ml-3"><i class="fa fa-gear"></i> <span translate="generalTerms.actions"></span> <span class="caret ml-6 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li role="menuitem"><a href="" ng-click="$ctrl.approvalprocessModal(\'edit\', null, true, 0)"><i class="ion-edit"></i> {{ \'generalTerms.edit\' | translate }}</a></li><li role="menuitem"><a href="" ng-click="$ctrl.setPaused(null, true, true)"><i class="fa fa-pause"></i> {{ \'modules.personnel.approvals.pause\' | translate }}</a></li><li role="menuitem"><a href="" ng-click="$ctrl.setPaused(null, false, true)"><i class="fa fa-play"></i> {{ \'modules.personnel.approvals.continue\' | translate }}</a></li><li role="menuitem"><a href="" ng-click="$ctrl.removeApprovalprocess(null, true)"><i class="ion-ios-trash color-danger"></i> <span class="text-danger">{{ \'modules.personnel.approvals.delete\' | translate }}</span></a></li></ul></div></div></div></div><style>\n  .arno-aggregatable-table span {\n    overflow-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n</style>');
$templateCache.put('app/theme/components/arnoAdminOrgList/arnoAdminOrgList.html','<div><div class="table-responsive" ng-if="$ctrl.organizations.length > 0"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.organizations" class="table table-condensed table-hover table-organization-list"><thead><tr><th class="align-left-force" st-sort="Name" st-sort-default="true">Name</th><th st-sort="ContractNr">Vertragsnummer</th><th class="text-right">Aktionen</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="ContractNr" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.displayedCollection"><td>{{ ::item.Name }}</td><td>{{ ::item.ContractNr }}</td><td class="align-right-force"><button class="btn btn-primary btn-with-icon btn-xs" ui-sref="arno.arnoAdministration.editOrganization({ organizationId: item.id, isDemoOrg: $ctrl.isDemo })"><i class="ion-edit"></i><span class="hidden-xs">Bearbeiten</span></button> <button ng-if="$ctrl.isDemo" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.delete(item)"><i class="ion-ios-trash"></i><span class="hidden-xs">L\xF6schen</span></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn btn-default btn-with-icon btn-xs" uib-dropdown-toggle=""><i class="ion-share"></i><span class="hidden-xs">Reports</span><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li><a href="" ng-click="$ctrl.export(item, true)">Modulnutzung nach Mitglied</a></li><li><a href="" ng-click="$ctrl.export(item, false)">Modulnutzung aggregiert</a></li></ul></div></td></tr><tr ng-if="$ctrl.displayedCollection && $ctrl.displayedCollection.length === 0"><td class="text-center" colspan="3"><i>Keine Organisationen verzeichnet.</i></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/theme/components/attendingEventList/attendingEventList.html','<div><div class="table-responsive"><table class="table table-condensed table-hover"><thead ng-if="$svcIntCtrl.ownAttendingServices.length"><tr><th class="col-xs-4" translate="modules.arnoDashboard.board.event">Veranstaltung</th><th class="col-xs-4" translate="generalTerms.type">Typ</th><th class="col-xs-4" translate="modules.events.event.modals.beginning">Beginn</th><th class="col-xs-4 hidden-xs" translate="generalTerms.division">Gliederung</th><th class="col-xs-4 pl-15" translate="generalTerms.actions">Aktionen</th></tr></thead><tbody ng-class="{\'without-top-border\': !$svcIntCtrl.ownAttendingServices.length}"><tr ng-repeat="service in $svcIntCtrl.ownAttendingServices"><td>{{ ::service.Subject }}</td><td>{{ ::service.IsService ? \'Dienst\' : \'Termin\' }}</td><td>{{ ::service.StartDate }}</td><td class="hidden-xs">{{ ::service.sourceDivisionName }}</td><td class="force-minimal pl-15"><button class="btn btn-info btn-with-icon btn-xs" ng-click="$svcIntCtrl.openServiceDetails(service)" title="Details aufrufen"><i class="glyphicon glyphicon-calendar"></i><span class="hidden-xs">Details</span></button></td></tr><tr ng-if="!$svcIntCtrl.ownAttendingServices.length"><td colspan="99" class="text-center"><i translate="modules.arnoDashboard.board.noAttendances">Keine Zusage zu einer Veranstaltung vorhanden!</i></td></tr></tbody></table><a class="btn btn-default btn-with-icon btn-xs mt-15 ml-10 hidden-xxs page-top-quick-action" data-route-name="arno.events.eventList" target="_self" title="Alle Termine aufrufen" href="#!/events/eventlist"><i class="glyphicon glyphicon-calendar"></i><span translate="modules.arnoDashboard.board.allEvents">Alle Termine</span></a> <a class="btn btn-default btn-with-icon btn-xs mt-15 ml-10 hidden-xxs page-top-quick-action" data-route-name="arno.events.serviceList" target="_self" title="Alle Dienste aufrufen" href="#!/events/servicelist"><i class="glyphicon glyphicon-calendar"></i><span translate="modules.arnoDashboard.board.allServices">Details</span></a></div></div>');
$templateCache.put('app/theme/components/baAddress/baAddress.tpl.html','<div class="row"><div class="col-sm-5 px-30 py-5" ng-if="$baAddressCtrl.canEdit && $baAddressCtrl.address.BusinessPartner && $baAddressCtrl.fieldsConfig.city.label"><button class="btn btn-default btn-xs btn-with-icon pull-left" type="button" ng-click="$baAddressCtrl.takeAdressfromBusinessPartner()"><i class="fa fa-pencil"></i><span class="ml-5" translate="modules.events.event.partials.takeAddressfromBusinessPartner"></span></button></div><div class="col-xs-12"><div class="{{$baAddressCtrl.uiConfig.firstRow.cssCls}}"><div class="form-group {{$baAddressCtrl.uiConfig.city.wrapperCssCls}} col-xs-12" ng-if="$baAddressCtrl.uiConfig.city.show !== false" ng-class="{\'has-error\': $baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputCity\', [\'required\', \'pattern\'], true)}"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.city.required}"><span ng-if="$baAddressCtrl.fieldsConfig.city.label">{{$baAddressCtrl.fieldsConfig.city.label}}</span> <span ng-if="!$baAddressCtrl.fieldsConfig.city.label"><span ng-bind="$baAddressCtrl.labelsPrefix"></span> {{\'components.address.cityLabel\' | translate}}</span></label> <input data-cy="ba-address-city" maxlength="254" type="text" name="inputCity-{{$baAddressCtrl.elementsIds}}" class="form-control {{$baAddressCtrl.uiConfig.city.inputCssCls}}" placeholder="" ng-model="$baAddressCtrl.address.City" ng-model-options="{ debounce: 500 }" ng-disabled="$baAddressCtrl.viewOnly" ng-required="$baAddressCtrl.fieldsConfig.city.required ? true : null" required-message="\'\'" invalid-message="\'\'"> <span ng-messages="$baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputCity\', [\'required\', \'pattern\'], true)" role="alert" class="control-label"><span ng-message="required" translate="components.address.cityRequiredText"></span> <span ng-message="pattern" translate="components.address.cityInvalidText"></span></span></div><div class="form-group col-xs-12 {{$baAddressCtrl.uiConfig.zipCode.wrapperCssCls}}" ng-if="$baAddressCtrl.uiConfig.zipCode.show !== false" ng-class="{\'has-error\': $baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputZIP\', [\'required\', \'pattern\'], true)}"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.zipCode.required}"><span ng-bind="$baAddressCtrl.labelsPrefix"></span> {{\'components.address.zipLabel\' | translate}}</label> <input data-cy="ba-address-zip" type="text" class="form-control {{$baAddressCtrl.uiConfig.zipCode.inputCssCls}}" name="inputZIP-{{$baAddressCtrl.elementsIds}}" placeholder="" ng-model="$baAddressCtrl.address.ZIP" ng-model-options="{ debounce: 500 }" ng-disabled="$baAddressCtrl.viewOnly" ng-required="$baAddressCtrl.fieldsConfig.zipCode.required ? true : null" required-message="\'\'" invalid-message="\'\'"> <span ng-messages="$baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputZIP\', [\'required\', \'pattern\'], true)" role="alert" class="control-label"><span ng-message="required" translate="components.address.zipRequiredText"></span> <span ng-message="pattern" translate="components.address.zipInvalidText"></span></span></div><div class="form-group {{$baAddressCtrl.uiConfig.countryId.wrapperCssCls}} col-xs-12" ng-if="$baAddressCtrl.uiConfig.countryId.show !== false" ng-class="{\'has-error\': $baAddressCtrl.hasError($baAddressCtrl.formRef, \'selectAddressCountryId\', \'required\', true)}"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.countryId.required}"><span ng-bind="$baAddressCtrl.labelsPrefix"></span>{{\'components.address.countryIdLabel\' | translate}}</label><ui-select name="selectAddressCountryId-{{$baAddressCtrl.elementsIds}}" ng-model="$baAddressCtrl.address.CountryId" search-enabled="true" class="btn-group bootstrap-select form-control {{$baAddressCtrl.uiConfig.countryId.inputCssCls}} --ui-select-dropdown-width-fix" ng-disabled="$baAddressCtrl.viewOnly" ng-required="$baAddressCtrl.fieldsConfig.countryId.required" required-message="\'L\xE4nderkennz. erforderlich!\'"><ui-select-match>{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" class="{{$baAddressCtrl.uiConfig.countryId.dropdownCssCls}}" repeat="item in $baAddressCtrl.COUNTRY_IDS | filter: $select.search"><span ng-bind="item.Name"></span> (<span ng-bind="item.FullName"></span>)</ui-select-choices></ui-select><span ng-messages="$baAddressCtrl.hasError($baAddressCtrl.formRef, \'selectAddressCountryId\', \'required\', true)" role="alert" class="control-label"><span ng-message="required" translate="components.address.countryIdRequiredText"></span></span></div></div><div class="{{$baAddressCtrl.uiConfig.secondRow.cssCls}}"><div class="form-group {{$baAddressCtrl.uiConfig.street.wrapperCssCls}} col-xs-12" ng-if="$baAddressCtrl.uiConfig.street.show !== false" ng-class="{\'has-error\': $baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputStreet\', \'required\', true)}"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.street.required}"><span ng-bind="$baAddressCtrl.labelsPrefix"></span> {{\'components.address.streetLabel\' | translate}}</label> <input data-cy="ba-address-street" maxlength="254" type="text" name="inputStreet-{{$baAddressCtrl.elementsIds}}" class="form-control {{$baAddressCtrl.uiConfig.street.inputCssCls}}" placeholder="" ng-model="$baAddressCtrl.address.Street" ng-model-options="{ debounce: 500 }" ng-disabled="$baAddressCtrl.viewOnly" ng-required="$baAddressCtrl.fieldsConfig.street.required ? true : null" required-message="\'\'"> <span ng-messages="$baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputStreet\', \'required\', true)" role="alert" class="control-label"><span ng-message="required" translate="components.address.streetRequiredText"></span></span></div><div class="form-group {{$baAddressCtrl.uiConfig.houseNumber.wrapperCssCls}} col-xs-12" ng-if="$baAddressCtrl.uiConfig.houseNumber.show !== false" ng-class="{\'has-error\': $baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputHouseNumber\', \'required\', true)}"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.houseNumber.required}"><span ng-bind="$baAddressCtrl.labelsPrefix"></span> <span translate="components.address.houseNumberLabel"></span></label> <input data-cy="ba-address-housenumber" maxlength="254" type="text" name="inputHouseNumber-{{$baAddressCtrl.elementsIds}}" class="form-control {{$baAddressCtrl.uiConfig.houseNumber.inputCssCls}}" placeholder="" ng-model="$baAddressCtrl.address.HouseNumber" ng-model-options="{ debounce: 500 }" ng-disabled="$baAddressCtrl.viewOnly" ng-required="$baAddressCtrl.fieldsConfig.houseNumber.required ? true : null" required-message="\'\'"> <span ng-messages="$baAddressCtrl.hasError($baAddressCtrl.formRef, \'inputHouseNumber\', \'required\', true)" role="alert" class="control-label"><span ng-message="required" translate="components.address.houseNumberRequiredText"></span></span> <label ng-if="$baAddressCtrl.showHouseNumberWarning()" class="text-warning" translate="components.address.houseNumberInvalidText"></label></div><div ng-if="$baAddressCtrl.uiConfig.addressAffix.show !== false" class="form-group {{$baAddressCtrl.uiConfig.addressAffix.wrapperCssCls}} col-xs-12"><label class="control-label" ng-class="{\'required-label\': $baAddressCtrl.fieldsConfig.addressAffix.required === true}"><span ng-bind="$baAddressCtrl.labelsPrefix"></span> {{\'components.address.affixLabel\' | translate}}</label> <input data-cy="ba-address-addressaffix" maxlength="254" type="text" class="form-control {{$baAddressCtrl.uiConfig.addressAffix.inputCssCls}}" name="inputAddressAffix-{{$baAddressCtrl.elementsIds}}" placeholder="" ng-model="$baAddressCtrl.address.AddressAffix" ng-model-options="{ debounce: 500 }" ng-required="$baAddressCtrl.fieldsConfig.addressAffix.required ? true : null" ng-disabled="$baAddressCtrl.viewOnly"></div></div></div></div>');
$templateCache.put('app/theme/components/baHelpTooltip/baHelpTooltip.tpl.html','<span class="ml-5 arno-help-tooltip-handler" ng-if="!$baHelpTooltipCtrl.type || $baHelpTooltipCtrl.type !== \'directLink\'"><span uib-tooltip="{{$baHelpTooltipCtrl.renderedText}}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa {{$baHelpTooltipCtrl.customIconCls}}" ng-class="{\'fa-info-circle\': !$baHelpTooltipCtrl.customIconCls}"></i></span></span> <span class="ml-5 arno-help-tooltip-handler hidden-xs" ng-if="$baHelpTooltipCtrl.type && $baHelpTooltipCtrl.type === \'directLink\'"><a href="{{$baHelpTooltipCtrl.renderedText}}" target="_blank"><span uib-tooltip="{{$baHelpTooltipCtrl.helpTooltip}}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa {{$baHelpTooltipCtrl.customIconCls}}" ng-class="{\'fa-info-circle\': !$baHelpTooltipCtrl.customIconCls}"></i></span></a></span>');
$templateCache.put('app/theme/components/baPanelTitleTagList/baPanelTitleTagList.html','<div class="title-tag-list"><div class="arno-tag tag label label-tag" ng-repeat="tag in self.tagList" ng-click="tag.clickFn()" ng-class="[tag.labelClass, {\'mr-0\': $last, \'arno-pointing-pointer\': tag.clickFn}]" data-toggle="tooltip" data-placement="bottom" title="{{tag.tooltip}}"><i ng-if="tag.icon" class="mr-3" ng-class="tag.icon"></i> {{ tag.label }}</div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar hidden-print" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemHeight=0 ;hoverElemTop=selectElemTop"><div class="al-sidebar-header"><div ng-if="!portalLogo.useExtInNavigation || (portalLogo.useExtInNavigation && $baSidebarService.isMenuCollapsed())"><a ng-if="(!portalLogo.data && ((portalLogo.useExtInNavigation || portalLogo.useSquareInNavigation))) || (!portalLogo.useExtInNavigation && !portalLogo.useSquareInNavigation)" title="ARNO" href="#" class="al-logo custom-color"><div ng-if="portalLogo.useFilter" ng-include="\'app/theme/components/pageTop/arno-logo.svg.html\'" ng-init="colors = portalLogo.logoColorsFilter" class="al-logo-img"></div><div ng-if="!portalLogo.useFilter && portalLogo.inverted" ng-include="\'app/theme/components/pageTop/arno-logo.svg.html\'" ng-init="colors = portalLogo.logoColorsInverted" class="al-logo-img"></div><div ng-if="!portalLogo.useFilter && !portalLogo.inverted" ng-include="\'app/theme/components/pageTop/arno-logo.svg.html\'" ng-init="colors = portalLogo.logoColorsDefault" class="al-logo-img"></div></a><a ng-if="(portalLogo.data && portalLogo.useSquareInNavigation) || (portalLogo.dataExt && portalLogo.useExtInNavigation && $baSidebarService.isMenuCollapsed())" title="{{$root.ctx.organization.current.name}}" href="#" class="al-logo"><div ng-class="[\'custom-logo\', \'al-logo-img\', {\'no-filter\': !portalLogo.useFilter}, {\'darken\': portalLogo.inverted}]"><img ng-src="{{portalLogo.data}}"></div></a><div class="al-logo-text clearfix" ng-class="{\'hasSpace\': (((($root.ctx.organization.current.name || \'\').indexOf(\' \') !== -1) && $root.ctx.organization.current.name.length > 12) || $root.ctx.organization.current.name.length > 14)}">{{$root.ctx.organization.current.name}}</div></div><div ng-if="portalLogo.dataExt && portalLogo.useExtInNavigation && !$baSidebarService.isMenuCollapsed()" class="extended-logo"><a title="{{$root.ctx.organization.current.name}}" href="#" class="al-logo"><div ng-class="[\'custom-logo\', {\'no-filter\': !portalLogo.useFilter}, {\'darken\': portalLogo.inverted}]"><img ng-src="{{portalLogo.dataExt}}"></div></a><div class="al-logo-text" ng-if="portalLogo.showOrgLabel" ng-class="{\'hasSpace\': (((($root.ctx.organization.current.name || \'\').indexOf(\' \') !== -1) && $root.ctx.organization.current.name.length > 12) || $root.ctx.organization.current.name.length > 14)}">{{$root.ctx.organization.current.name}}</div></div></div><ul id="sideBar" ba-sidebar-highlight="" class="al-sidebar-list"><scrollbar name="bar"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a data-route-name="{{::item.stateRef}}" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span translate="{{ item.title }}"></span></a> <a data-route-name="{{::item.stateRef}}" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span translate="{{ item.title }}"></span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a data-route-name="{{::subitem.stateRef}}" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span translate="{{ subitem.title }}"></span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a data-route-name="{{::subSubitem.stateRef}}" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link" translate="{{ subSubitem.title }}"></a> <a data-route-name="{{::subSubitem.stateRef}}" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}" translate="{{ subSubitem.title }}"></a></li></ul><a data-route-name="{{::subitem.stateRef}}" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link" translate="{{ subitem.title }}"></a> <a data-route-name="{{::subitem.stateRef}}" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-click="subitem.stateClick && subitem.stateClick($event, stateCurrentName, $root)" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}" translate="{{ subitem.title}}"></a></li></ul></li></scrollbar></ul><a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a></aside>');
$templateCache.put('app/theme/components/baSpinner/baSpinner.tpl.html','<div ng-if="$baSpinnerCtrl.showSpinner === true" class="arno__ba-spinner__wrapper text-center" ng-style="{width: $baSpinnerCtrl.size || \'100px\'}"><div ng-switch="$baSpinnerCtrl.contentSlotPresent === true"><div ng-switch-when="true" ng-transclude="content"></div><div ng-switch-default=""><div ng-switch="$baSpinnerCtrl.type"><div ng-switch-when="whirl" class="whirl-loader {{$baSpinnerCtrl.customCls}}" ng-style="{width: $baSpinnerCtrl.size || \'100px\', height: $baSpinnerCtrl.size || \'100px\'}"><div class="whirl-loader__inner"></div></div><div ng-switch-default="" class="loader {{$baSpinnerCtrl.customCls}}" ng-style="$baSpinnerCtrl.circleSpinnerStyles()"></div></div></div></div><small ng-bind="$baSpinnerCtrl.text"></small></div>');
$templateCache.put('app/theme/components/baTableview/baTableview.tpl.html','<div class="arno__ba-tableview__panel__wrapper"><div ng-if="$baTableviewCtrl.uiConfig.showHeaderTopbar !== false" class="arno__ba-tableview__panel__header-bar form-group clearfix"><div class="btn-toolbar ml-0"><div ng-transclude="headerBarLeftButtonRow" class="inline"></div><div class="dropdown"><button class="btn btn-default dropdown-toggle mb-0" type="button" data-toggle="dropdown"><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $baTableviewCtrl.listPageSize }}) <i class="caret"></i></button><ul class="dropdown-menu"><li role="menuitem" ng-repeat="i in $baTableviewCtrl.listPageSizes"><a href="" ng-click="$baTableviewCtrl.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="btn-toolbar pull-right"><button class="btn btn-default btn-with-icon pull-right" ng-click="$baTableviewCtrl.openTableConfigModal()"><i class="ion-wrench"></i> <span class="hidden-xs" translate="components.tableView.tableConfig"></span></button><div ng-transclude="headerBarRightButtonRow" class="inline"></div></div></div><div ng-switch="$baTableviewCtrl.contentSlotPresent"><div ng-switch-when="true" ng-transclude="content"></div><div ng-switch-default="" class="row"><div class="col-sm-12"><div class="table-responsive"><table st-table="$baTableviewCtrl.listData" st-pipe="$baTableviewCtrl.refreshData" class="table table-condensed table-hover"><thead><tr class="sortable {{$baTableviewCtrl.uiConfig.cssHeaderTopbar}}"><th ng-repeat="colDefinition in $baTableviewCtrl.listColsDefinition" ng-if="$baTableviewCtrl.listVisibleCols[colDefinition.key].value !== false" st-sort="{{colDefinition.key}}"><span ng-bind="colDefinition.label"></span></th></tr></thead><tbody><tr ng-repeat="listEntry in $baTableviewCtrl.listData" class="editable-row"><td ng-repeat="colDefinition in $baTableviewCtrl.listColsDefinition" ng-if="$baTableviewCtrl.listVisibleCols[colDefinition.key].value !== false"><span ng-if="listEntry[colDefinition.key]" ng-bind="listEntry[colDefinition.key]"></span></td></tr></tbody><tfoot><tr><td colspan="12"><st-pagination st-items-by-page="$baTableviewCtrl.listPageSize" st-template="app/theme/components/paging/paging.html" st-displayed-pages="5"></st-pagination></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/theme/components/baTableview/baTableviewConfigModal.tpl.html','<div class="modal-content"><div class="modal-header pb-0"><h4 class="modal-title with-line" translate="components.tableView.tableConfig"></h4></div><div class="modal-body"><div ng-if="$baTableviewModalCtrl.tableConfig.visibleCols" class="table-responsive"><table class="table table-condensed table-hover"><thead><th><label translate="components.tableView.tableConfig"></label></th><th></th></thead><tbody><tr ng-repeat="colConfig in $baTableviewModalCtrl.tableConfig.visibleCols"><td><label>{{(\'models.TableViewConfig.\' + colConfig.label | translate)}}</label></td><td><ba-switcher switcher-style="primary" switcher-value="colConfig.value"></ba-switcher></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close()" translate="generalTerms.close"></button></div></div>');
$templateCache.put('app/theme/components/baTreeview/baTreeview.tpl.html','<div class="arno__ba-treeview__wrapper"><div class="row"><div class="col-sm-12"><div class="row arno__ba-treeview__panel__header-bar"><div class="col-xs-12"><div class="btn-toolbar ml-0"><button type="button" ng-if="$baTreeviewCtrl.treeNodesData.length" class="btn btn-default btn-with-icon" ng-click="$baTreeviewCtrl.treeviewCollapsed = !$baTreeviewCtrl.treeviewCollapsed"><i ng-class="{\'ion-chevron-up\': $baTreeviewCtrl.treeviewCollapsed === false, \'ion-chevron-down\': $baTreeviewCtrl.treeviewCollapsed === true }"></i> <span class="hidden-xs"><span translate="components.treeView.collapseBtnText" translate-values="{ collapse: !$baTreeviewCtrl.treeviewCollapsed }"></span></span></button><div ng-transclude="headerBarLeftButtonRow" class="inline"></div></div><div class="btn-toolbar pull-right"><div class="input-group arno__ba-treeview__panel__search-field mb-5"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$baTreeviewCtrl.nodesSearchValue" ng-model-options="{debounce: 500}" class="form-control with-default-addon" placeholder="{{(\'components.treeView.markEntries\') | translate}}"></div><div ng-transclude="headerBarRightButtonRow" class="inline"></div></div></div></div><div ng-if="$baTreeviewCtrl.treeNodesData.length" class="row mt-10"><label ng-if="$baTreeviewCtrl.uiConfig.showSelectedNodeText !== false" class="col-xs-12">{{(\'components.treeView.selected\' | translate)}}: <strong ng-if="$baTreeviewCtrl.selectedNode.label" ng-bind="$baTreeviewCtrl.selectedNode.label"></strong> <strong ng-if="!$baTreeviewCtrl.selectedNode.label" translate="components.treeView.noSelection"></strong></label></div><div ng-switch="$baTreeviewCtrl.contentSlotPresent" class="arno__ba-treeview__tree__wrapper mt-10" ng-class="{\'has-error\': $baTreeviewCtrl.hasError === true}"><div ng-switch-when="true" ng-transclude="content"></div><div ng-switch-default="" class="row"><div class="col-xs-12"><div><script type="text/ng-template" id="nodesRenderer.tpl.html"><div class="node-embed" ui-tree-handle ng-click="$baTreeviewCtrl.selectNodeHandler(node, this)" ng-class="{\'node-active\': node.isSelected || $baTreeviewCtrl.selectedNode.id === node.id, matched: node.matched}" > <a ng-if="node.children.length" class="btn btn-clear btn-xs" ng-click="$baTreeviewCtrl.expandNodeHandler(this, $event)" > <i class="fa" ng-class="{\'fa-chevron-right\': collapsed, \'fa-chevron-down\': !collapsed}"></i> </a> <div ng-class="{inline: node.children.length}"> <div class="ba-treeview-node-icon {{::node.iconCls}}"></div> <span class="ba-treeview-node-label {{node.labelCls}}" ng-bind="node.label"></span> </div> </div> <ol ui-tree-nodes="options" ng-model="node.children" ng-class="{hidden: collapsed, displayed: !collapsed}"> <li ng-repeat="node in node.children" ng-class="{\'ml-25\' : !node.children.length}" class="{{::node.id}}" ui-tree-node ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div ui-tree="" data-drag-enabled="false" ng-show="$baTreeviewCtrl.treeNodesData.length"><ol id="ba-treeview-root" ng-class="{hidden: collapsed, displayed: !collapsed}" ui-tree-nodes="" ng-model="$baTreeviewCtrl.treeNodesData"><li ng-repeat="node in $baTreeviewCtrl.treeNodesData" collapsed="$baTreeviewCtrl.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div><div ng-if="!$baTreeviewCtrl.treeNodesData.length" class="text-center mt-40 mb-40" translate="components.treeView.noEntriesPlaceholder"></div></div></div></div></div><div ng-if="$baTreeviewCtrl.footerBarRightButtonRowSlotPresent" class="col-xs-12"><div class="btn-toolbar pull-right mt-10"><div ng-transclude="footerBarRightButtonRow" class="inline"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div ng-if="!$baWizardController.hideNavigation" class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index, true)">{{t.title}}</div></div><div ng-if="!$baWizardController.hideProgress" class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous" ng-show="$baWizardController.isFirstTab"><button data-cy="components-bawizard-cancel" ng-click="$baWizardController.previousTab()" ng-disabled="$baWizardController.pending" class="btn btn-default" translate="generalTerms.cancel"></button></li><li class="previous" ng-show="$baWizardController.allowBack && !$baWizardController.isFirstTab"><button data-cy="components-bawizard-back" ng-click="$baWizardController.previousTab()" ng-disabled="$baWizardController.pending" class="btn btn-default"><span aria-hidden="true">&larr;</span></button></li><li class="next" ng-show="!$baWizardController.isLastTab"><button data-cy="components-bawizard-next" ng-click="$baWizardController.nextTab(true)" ng-disabled="$baWizardController.pending" class="btn btn-primary" translate="generalTerms.next"><span aria-hidden="true">&rarr;</span></button></li><li class="next" ng-show="$baWizardController.isLastTab"><button data-cy="components-bawizard-ok" ng-click="$baWizardController.nextTab(true)" ng-disabled="$baWizardController.pending" class="btn btn-primary" translate="generalTerms.complete"></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/bookingMaterialCalendar/bookingMaterialCalendar.html','<div><div id="bookingMaterialCalendar" class="responsive-calendar booking-material-calendar"></div></div>');
$templateCache.put('app/theme/components/businessPartnersSelector/businessPartnersSelector.html','<div class="business-partner-selector"><div><div ng-if="self.enableDetails"><label class="{{ self.extraLabelCls }}" ng-if="self.detailsExtraLabel" ng-class="{ \'required-label\' : self.requiredLabel }">{{self.detailsExtraLabel | translate}}</label> <button type="button" ng-click="self.openDetails()" ng-disabled="!self.selectedBusinessPartner || !self.selectedBusinessPartner.id" class="btn btn-with-icon btn-xs btn-default pull-right"><i class="fa fa-eye"></i></button></div><div ng-class="{ \'input-group-with-select\' : self.enableDelete }" class="input-group ui-select-addon-fixed"><ui-select ng-model="self.selectedBusinessPartner" ng-disabled="self.disabled" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="self.appendToBody" search-enabled="true"><ui-select-match placeholder="{{ (self.customPlaceholder || \'components.businessPartnerSelector.searchPlaceholder\') | translate }}">{{ self.selectedBusinessPartner.IsInternal ? \'(\' + self.orgName + \') \' + (self.selectedBusinessPartner.OwnerDivision.Name || self.selectedBusinessPartner.Name.replace(\'(\' + self.orgName + \') \', \'\')) : self.selectedBusinessPartner.Name }}</ui-select-match><ui-select-choices position="down" repeat="businessPartner in self.businessPartners" refresh="self.searchBusinessPartners($select.search)" refresh-delay="200" group-by="self.groupBy"><div ng-if="!businessPartner.none" class="btn-with-icon"><i ng-show="!businessPartner.IsInternal" class="fa fa-user"></i> <i ng-show="businessPartner.IsInternal" class="fa fa-sitemap" title="{{ ::(\'modules.contacts.businessPartners.overview.systemDivisionBusinessPartnerTooltip\' | translate) }}"></i> <span ng-show="businessPartner.IsInternal">({{ ::self.orgName }})</span> <span>{{ businessPartner.IsInternal ? (businessPartner.OwnerDivision.Name || businessPartner.Name) : businessPartner.Name }}</span></div><div ng-if="businessPartner.none" class="btn-with-icon"><i class="fa fa-times"></i><span><i translate="components.businessPartnerSelector.notFound"></i></span></div></ui-select-choices></ui-select><span ng-if="self.enableDelete" class="input-group-btn"><button type="button" ng-disabled="!self.selectedBusinessPartner || self.disabled" ng-click="self.selectedBusinessPartner = { none: true }" class="btn btn-danger ion-ios-trash"></button></span></div></div></div>');
$templateCache.put('app/theme/components/calHeatmap/calHeatmap.html','<div class="arno-cal-heatmap"><div class="heatmap-container"><div class="week-label"><div translate="components.calHeatmap.mon"></div><div translate="components.calHeatmap.tue"></div><div translate="components.calHeatmap.wed"></div><div translate="components.calHeatmap.thu"></div><div translate="components.calHeatmap.fri"></div><div translate="components.calHeatmap.sat"></div><div translate="components.calHeatmap.sun"></div></div><div class="table-responsive"><div class="graph" ng-mouseover="self.mouseover($event)" ng-mouseleave="self.mouseleave()"><div class="week" ng-repeat="week in self.histogramDates"><div class="day" ng-repeat="day in ::week" ng-class="::self.getDayClass(day)" data-day="{{::day}}"></div></div></div></div></div><div class="heatmap-container mt-5"><span class="day-info">{{self.dayInfo}}&nbsp;</span></div></div>');
$templateCache.put('app/theme/components/clientSelector/clientSelector.html','<div class="client-selector"><div class="input-group input-group-with-select"><ui-select ng-model="client.selected" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="true" ng-disabled="$clSelCtrl.selectorDisabled"><ui-select-match placeholder="Auftraggeber suchen..."><span ng-class="{\'client-excluded btn-with-icon\' : (!$select.selected.none && $select.selected.excluded)}" title="{{(!$select.selected.none && $select.selected.excluded) ? \'Durch die aktuelle Gliederungsauswahl wird dieser Auftraggeber entfernt.\' : \'\'}}"><i class="fa fa-times" ng-if="!$select.selected.none && $select.selected.excluded"></i> {{($select.selected.none ? \'\' : ($select.selected.Name + \' (\' + $select.selected.Division.Name + \')\'))}}</span></ui-select-match><ui-select-choices position="down" repeat="client in $clSelCtrl.clients" refresh="$clSelCtrl.searchClients($select.search)" refresh-delay="200" group-by="client.Division.Name"><div ng-if="!client.none" class="btn-with-icon"><i class="fa fa-user"></i> <span>{{ client.Name + \' (\' + client.Division.Name + \')\' }}</span></div><div ng-if="client.none" class="btn-with-icon"><i class="fa fa-times"></i><span><i>Kein Auftraggeber gefunden</i></span></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-disabled="$clSelCtrl.selectorDisabled" ng-click="$clSelCtrl.removeSelection()" class="btn btn-danger"><i class="ion-ios-trash"></i></button></span></div></div>');
$templateCache.put('app/theme/components/contactManagementDuplicates/contactManagementDuplicates.html','<div ng-if="$ctrl.isNew && $ctrl.duplicateList.length > 0"><h5>{{ $ctrl.headerTitle | translate }}</h5><div class="table-responsive"><table class="table table-condensed"><thead><tr><th translate="modules.contacts.contactManagement.contact.salutation"></th><th translate="modules.contacts.contactManagement.contact.title"></th><th translate="modules.contacts.contactManagement.contact.firstname"></th><th translate="modules.contacts.contactManagement.contact.lastname"></th><th translate="modules.contacts.contactManagement.contact.function"></th><th translate="modules.contacts.contactManagement.contact.phonenumber"></th><th translate="modules.contacts.contactManagement.contact.mobilenumber"></th><th translate="modules.contacts.contactManagement.contact.mail"></th><th translate="modules.contacts.contactManagement.contact.businesspartner"></th><th class="text-center" translate="modules.contacts.contactManagement.duplicates.linked"></th><th class="text-center" translate="modules.contacts.contactManagement.overview.actions"></th></tr></thead><tbody><tr ng-repeat="duplicate in $ctrl.duplicateList" class="--cell-text-middle" ng-init="duplicate.similarFields=$ctrl.getSimilarFields($ctrl.contact, duplicate)"><td ng-class="{success: duplicate.similarFields[\'Salutation\'] == 1, warning: duplicate.similarFields[\'Salutation\'] < 1 }">{{ duplicate.Salutation }}</td><td ng-class="{success: duplicate.similarFields[\'Title\'] == 1, warning: duplicate.similarFields[\'Title\'] < 1 }">{{ duplicate.Title }}</td><td ng-class="{success: duplicate.similarFields[\'FirstName\'] == 1, warning: duplicate.similarFields[\'FirstName\'] < 1 }">{{ duplicate.FirstName }}</td><td ng-class="{success: duplicate.similarFields[\'LastName\'] == 1, warning: duplicate.similarFields[\'LastName\'] < 1 }">{{ duplicate.LastName }}</td><td ng-class="{success: duplicate.similarFields[\'Function\'] == 1, warning: duplicate.similarFields[\'Function\'] < 1 }">{{ duplicate.Function }}</td><td ng-class="{success: duplicate.similarFields[\'PhoneNumber\'] == 1, warning: duplicate.similarFields[\'PhoneNumber\'] < 1 }">{{ duplicate.PhoneNumber }}</td><td ng-class="{success: duplicate.similarFields[\'MobileNumber\'] == 1, warning: duplicate.similarFields[\'MobileNumber\'] < 1 }">{{ duplicate.MobileNumber }}</td><td ng-class="{success: duplicate.similarFields[\'MailAddress\'] == 1, warning: duplicate.similarFields[\'MailAddress\'] < 1 }">{{ duplicate.MailAddress }}</td><td ng-class="{success: duplicate.similarFields[\'LegalRegistrationIdentifier\'] == 1, warning: duplicate.similarFields[\'LegalRegistrationIdentifier\'] < 1 }">{{ duplicate.BusinessPartner.Name }}</td><td class="text-center"><span ng-if="$ctrl.isLinked(duplicate)"><i class="fa fa-check color-success"></i></span></td><td class="d-flex justify-content-center"><button type="button" ng-click="$ctrl.gotoContactDetails(duplicate)" class="btn btn-default btn-with-icon btn-xs" title="{{ ::(\'modules.contacts.contactManagement.duplicates.accessContact\' | translate) }}"><i class="fa fa-external-link"></i> <span class="hidden-xs hidden-sm" translate="modules.contacts.contactManagement.duplicates.accessContact"></span></button> <button ng-class="{ \'full-invisible\': !$ctrl.hasManagePermission || !$ctrl.isNew || $ctrl.isLinked(duplicate) || $ctrl.isRootOrgSelected() }" type="button" ng-click="$ctrl.addDivisionToContact(duplicate)" class="btn btn-success btn-with-icon btn-xs ml-8" title="{{ ::(\'modules.contacts.contactManagement.linkingAddBtnLabel\' | translate) }}"><i class="fa fa-link"></i> <span class="hidden-xs" translate="generalTerms.add"></span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/theme/components/contactPrivacy/contactPrivacy.html','<div class="row pt-5"><div class="col-sm-12"><div class="form-group clearfix" ng-if="$contactPrivacyCtrl.privacyTermDate && !$contactPrivacyCtrl.demandForAction"><input type="radio" name="privacyTermsAlreadyDelivered" ng-model="$contactPrivacyCtrl.privacyTermsAlreadyDelivered" value="0" ng-disabled="!$contactPrivacyCtrl.contactAddressGiven" id="privacyTermsNotYetDelivered"> <label for="privacyTermsNotYetDelivered" class="control-label ml-10">{{$contactPrivacyCtrl.contact.ContactEMail ? (\'components.contactPrivacy.sendtoContactMailText\' | translate:{ adress: $contactPrivacyCtrl.contact.ContactEMail }) : (\'components.contactPrivacy.sendFromArnoText\' | translate ) }}</label></div><div class="form-group clearfix" ng-if="$contactPrivacyCtrl.privacyTermDate && !$contactPrivacyCtrl.demandForAction"><input type="radio" name="privacyTermsAlreadyDelivered" ng-model="$contactPrivacyCtrl.privacyTermsAlreadyDelivered" value="1" id="privacyTermsAlreadyDelivered"> <label for="privacyTermsAlreadyDelivered" class="control-label ml-10" ng-if="!$contactPrivacyCtrl.demandForAction" translate="components.contactPrivacy.alreadyPassedText1"></label></div><label ng-if="$contactPrivacyCtrl.demandForAction"><strong>{{ (\'components.contactPrivacy.alreadyPassedText2\' | translate ) }}</strong> {{ $contactPrivacyCtrl.demandForAction.join(\', \') }}</label><div class="form-group clearfix"><div class="inline-date"><label ng-if="!$contactPrivacyCtrl.privacyTermDate" for="deliveredDateTime" class="control-label required-label" translate="components.contactPrivacy.privacyDeliveredText"></label> <label ng-if="$contactPrivacyCtrl.privacyTermDate" for="deliveredDateTime" class="control-label required-label" translate="components.contactPrivacy.alreadyPassedText3"></label><div class="input-group" ng-class="{\'has-error\': $contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\' ? $contactPrivacyCtrl.hasError($contactPrivacyCtrl.formReference , \'deliveredPerson\', [\'required\']) : false}"><input type="text" id="deliveredDateTime" name="deliveredDateTime" class="form-control" uib-datepicker-popup="{{$contactPrivacyCtrl.datepicker.format}}" datepicker-options="$contactPrivacyCtrl.datepicker.options" ng-model="$contactPrivacyCtrl.contact.PrivacyTermsDeliveredDateTime" is-open="$contactPrivacyCtrl.openedDeliveredDateTime" close-text="{{ (\'generalTerms.close\' | translate) }}" show-button-bar="false" ng-disabled="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'0\'" ng-required="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$contactPrivacyCtrl.openedDeliveredDateTime = !$contactPrivacyCtrl.openedDeliveredDateTime" ng-disabled="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'0\'"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="inline-time"><div uib-timepicker="" ng-model="$contactPrivacyCtrl.contact.PrivacyTermsDeliveredDateTime" hour-step="$contactPrivacyCtrl.hstep" minute-step="$contactPrivacyCtrl.mstep" max="$contactPrivacyCtrl.maxTimepick" show-meridian="$contactPrivacyCtrl.isMeridian" ng-disabled="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'0\'"></div></div></div><div class="alert bg-warning" ng-if="$contactPrivacyCtrl.outdatedTermsDelivered"><h4 translate="components.contactPrivacy.outdatedWarningHeader"></h4><p translate="components.contactPrivacy.outdatedWarningP1"></p><p translate="components.contactPrivacy.outdatedWarningP2"></p><p translate="components.contactPrivacy.outdatedWarningP3" translate-values="{ date: $contactPrivacyCtrl.privacyTermDateDisplay }"></p></div><div class="form-group clearfix" ng-class="{\'has-error\': $contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\' ? $contactPrivacyCtrl.hasError($contactPrivacyCtrl.formReference , \'deliveredPerson\', [\'required\']) : false}"><label for="deliveredPerson" class="control-label required-label" translate="components.contactPrivacy.deliveredBy"></label> <input type="text" class="form-control" name="deliveredPerson" id="deliveredPerson" ng-disabled="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'0\'" ng-model="$contactPrivacyCtrl.contact.PrivacyTermsDeliveredPerson" ng-required="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\'"></div><div class="form-group clearfix" ng-class="{\'has-error\': $contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\' ? $contactPrivacyCtrl.hasError($contactPrivacyCtrl.formReference , \'deliveredPerson\', [\'required\']) : false}"><label for="deliveredChannel" class="control-label required-label" translate="components.contactPrivacy.deliveredVia"></label><select name="deliveredChannel" id="deliveredChannel" class="form-control" ng-model="$contactPrivacyCtrl.contact.PrivacyTermsDeliveredChannel" ng-disabled="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'0\'" ng-required="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\'"><option value="IN_PERSON" translate="models.Member.PrivacyTermsDeliveredChannel.IN_PERSON"></option><option value="POSTAL" translate="models.Member.PrivacyTermsDeliveredChannel.POSTAL"></option><option value="E_MAIL_EXT" translate="models.Member.PrivacyTermsDeliveredChannel.E_MAIL_EXT"></option></select><div class="mt-12" ng-if="$contactPrivacyCtrl.privacyTermsAlreadyDelivered === \'1\' && $contactPrivacyCtrl.currentUrl === \'/personnel/addInvite\'"><button type="button" class="btn btn-default" ng-click="$contactPrivacyCtrl.downloadPrivacyTerms()" translate="generalTerms.dataPrivacyDownload"></button></div></div><div class="form-group clearfix" ng-if="!$contactPrivacyCtrl.privacyTermDate"><button type="button" class="btn btn-default" ng-click="$contactPrivacyCtrl.downloadPrivacyAgreement()" translate="components.contactPrivacy.downloadPrivacyAgreement"></button></div></div></div>');
$templateCache.put('app/theme/components/contactSelector/contactSelector.html','<div class="contact-selector"><div class="input-group"><ui-select ng-model="self.selectedContact" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="true" ng-disabled="self.disabled"><ui-select-match placeholder="{{ \'components.contactSelector.searchContact\' | translate }}">{{ self.selectedContact.asString }}</ui-select-match><ui-select-choices position="down" repeat="contact in self.contacts" refresh="self.searchContacts($select.search)" refresh-delay="200" group-by="self.groupByCompany"><div ng-if="!contact.none" class="btn-with-icon"><i class="fa fa-user"></i> {{ contact.asString }}</div><div ng-if="contact.none" class="btn-with-icon"><i class="fa fa-times"></i> <span><i>{{ \'components.contactSelector.noUserFound\' | translate }}</i></span></div></ui-select-choices></ui-select></div></div>');
$templateCache.put('app/theme/components/costCenterSpecSelector/costCenterSpecSelector.html','<div class="cost-center-spec-selector"><div ng-class="{ \'input-group-with-select\' : self.enableDelete }" class="input-group"><ui-select ng-model="self.selectedCostCenterSpec" ng-disabled="self.disabled" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="self.appendToBody" search-enabled="true"><ui-select-match placeholder="{{ \'components.costCenterSpecSelector.searchPlaceholder\' | translate }}"><div ng-if="self.selectedCostCenterSpec.defaultSelection" class="cost-center-spec-defaultsel" title="{{self.selectedCostCenterSpec.defaultSelection}}">{{ self.selectedCostCenterSpec.defaultSelection }}</div><div ng-if="!self.selectedCostCenterSpec.defaultSelection && self.selectedCostCenterSpec.id"><div class="arno-tag tag label label-tag label-success cost-center-spec-tag mr-0"><i class="ion-ios-people mr-2"></i> {{ self.selectedCostCenterSpec.CostCenter.Identifier || \'\' }}{{ self.selectedCostCenterSpec.CostCenter.Identifier ? \' - \' : \'\' }}{{ self.selectedCostCenterSpec.CostCenter.Name }}</div><div class="arno-tag tag label label-tag cost-center-spec-tag mr-0 ml-3" title="{{ (self.selectedCostCenterSpec.Identifier || \'\')+(self.selectedCostCenterSpec.Identifier ? \' - \' : \'\')+(self.selectedCostCenterSpec.Name) }}"><i class="fa fa-money mr-2"></i> {{ self.selectedCostCenterSpec.Identifier || \'\' }}{{ self.selectedCostCenterSpec.Identifier ? \' - \' : \'\' }}{{ self.selectedCostCenterSpec.Name }}</div><div class="arno-tag tag label label-tag label-info cost-center-spec-tag mr-0 ml-3" ng-if="self.selectedCostCenterSpec.TaxRatePercent !== null">{{ self.selectedCostCenterSpec.TaxRatePercent }} %</div></div></ui-select-match><ui-select-choices position="down" repeat="costCenterSpec in self.costCenterSpec" refresh="self.searchCostCenterSpec($select.search)" refresh-delay="200" group-by="self.groupBy"><div popover-placement="top-left" popover-trigger="mouseenter" popover-append-to-body="true" uib-popover="{{ costCenterSpec.Hint || (\'components.costCenterSpecSelector.withoutSpecialNotes\' | translate) }}"><div ng-if="costCenterSpec.id" class="btn-with-icon">{{ costCenterSpec.Identifier || \'\' }}{{ costCenterSpec.Identifier ? \' - \' : \'\' }}{{ costCenterSpec.Name }}<div class="arno-tag tag label label-tag label-info pull-right" ng-if="costCenterSpec.TaxRatePercent !== null">{{ costCenterSpec.TaxRatePercent }} %</div></div></div><div ng-if="costCenterSpec.none" class="btn-with-icon"><i class="fa fa-times"></i><span><i translate="components.costCenterSpecSelector.notFound"></i></span></div></ui-select-choices></ui-select><span ng-if="self.enableDelete" class="input-group-btn"><button type="button" ng-disabled="!self.selectedCostCenterSpec" ng-click="self.selectedCostCenterSpec = { none: true }" class="btn btn-danger ion-ios-trash"></button></span></div></div>');
$templateCache.put('app/theme/components/dashboard/dashboard-service-share-list.html','<div class="container-fluid"><div class="row" ng-repeat="divisionShare in $dshbrdscrvcCtrl.divisionShares"><div class="col-xs-12"><div class="panel panel-default panel-sm"><div class="panel-body p-10" ng-click="$dshbrdscrvcCtrl.handleShare(\'DETAILS\', divisionShare)"><div class="row"><div class="col-xs-12 col-sm-6"><strong>{{ divisionShare.Event.Subject }}</strong><div><small><i ng-if="divisionShare.Event.StartDate" class="fa fa-calendar-o" aria-hidden="true"></i> {{ divisionShare.Event.StartDate | date:\'dd.MM.yyyy HH:mm\' }}</small></div></div><div class="col-xs-12 col-sm-6 text-right"><div class="arno-tag tag label label-tag label-info ng-binding ng-scope mr-0">{{ divisionShare.isService? \'modules.arnoDashboard.board.service\' : \'modules.arnoDashboard.board.event\' |translate }}</div><div><small><strong>{{ \'generalTerms.from\' | translate }}:</strong> {{ divisionShare.Event.SourceDivision.Name }}</small><br><small><strong>{{ \'generalTerms.to\' | translate }}:</strong> {{ divisionShare.Division.Name }}</small></div></div></div><div class="row m-t-5"><div class="col-xs-12 text-right"><button class="btn btn-xs btn-success" ng-click="$dshbrdscrvcCtrl.handleShare(\'ACCEPT\', divisionShare)"><i class="ion-plus"></i> {{ \'generalTerms.accept\' | translate }}</button> <button class="btn btn-xs btn-danger" ng-click="$dshbrdscrvcCtrl.handleShare(\'DECLINE\', divisionShare)"><i class="fa fa-times"></i> {{ \'generalTerms.decline\' | translate }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/dataChangeHandler/dataChangeHandler.tpl.html','');
$templateCache.put('app/theme/components/divisionSelector/divisionSelector.html','<div class="arno-division-selector"><div uib-dropdown="" on-toggle="$divSelCtrl.toggleZindex(open)" ng-if="$divSelCtrl.isActive"><a href="" uib-dropdown-toggle="" class="division-selector-toggle-text" ng-click="$divSelCtrl.setOpen($event)" ng-class="{\'division-selector-blink\': $divSelCtrl.selectorBlink}"><span ng-if="$divSelCtrl.divisionTitleList"><i data-cy="components-divisionselector-divisiontitlelist" ng-class="{\'ion-ios-people-outline\': !$divSelCtrl.isRootOrg, \'ion-ios-people\': $divSelCtrl.isRootOrg}"></i> {{$divSelCtrl.divisionTitleList}}</span> <span data-cy="components-divisionselector-divisiontitlelist-default" ng-if="!$divSelCtrl.divisionTitleList"><i translate="components.divisionSelector.pleaseSelectDivision">Bitte w\xE4hle einen Bereich!</i></span></a><div uib-dropdown-menu="" class="division-selector-dropdown-menu dropdown-menu-right" ng-click="$divSelCtrl.preventPropagation($event)"><i class="dropdown-arr"></i><h5 translate="components.divisionSelector.divSelectorTitle">Bereichsw\xE4hler</h5><span class="fa fa-question arno-help arno-pointing-pointer" ng-click="$divSelCtrl.openHelp()" translate-attr="{ title: \'generalTerms.help\' }"></span><div class="pull-right control-side"><button class="btn btn-default btn-icon" ng-click="$divSelCtrl.collapse()"><i class="ion-chevron-up"></i></button> <button class="btn btn-default btn-icon" ng-click="$divSelCtrl.expand()"><i class="ion-chevron-down"></i></button></div><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input class="form-control with-default-addon input-sm" type="text" ng-model="$divSelCtrl.searchInputModel" ng-model-options="{ debounce: 200 }"></div><p ng-if="!$divSelCtrl.divisionSelectionData.length" translate="components.divisionSelector.noSelectionAvailable">Keine Auswahl verf\xFCgbar!</p><div data-cy="components-divisionselector-treeview" ng-if="$divSelCtrl.divisionSelectionData" js-tree="$divSelCtrl.divisionSelectionConfig" tree="$divSelCtrl.divisionSelectionTree" ng-model="$divSelCtrl.divisionSelectionData" ng-class="{\'division-selector-jstree-with-org-selection\':allowOrgSelection}" tree-events="ready:$divSelCtrl.readyCB;select_node:$divSelCtrl.selectNodeCB;deselect_node:$divSelCtrl.deselectNodeCB"></div><div class="btn-row division-selector-btn-row"><div class="light-text divison-selector-multi-hint"><p><i class="divison-selector-hint-icon" ng-class="{\'ion-close-round\': !multiple, \'ion-checkmark-round\': multiple}"></i> {{multiple ? (\'components.divisionSelector.multiSelection\' | translate) : (\'components.divisionSelector.noMultiSelection\' | translate)}}</p><p ng-if="allowOrgSelection===true || allowOrgSelection===\'true\'"><i class="divison-selector-hint-icon ion-checkmark-round"></i> {{ (\'components.divisionSelector.orgSelectableIndividually\' | translate) }}</p></div><button data-cy="divisionselector-apply" type="button" ng-click="$divSelCtrl.applyDivisions()" class="btn btn-primary btn-with-icon ion-android-checkmark-circle"><span class="hidden-xs" translate="generalTerms.choose">Ausw\xE4hlen</span></button></div></div></div></div>');
$templateCache.put('app/theme/components/eventCalendarTile/eventCalendarTile.html','<div><div class="clearfix"><div class="pull-left cal-time"><span class="fc-time" ng-bind-html="$tile.data.time"></span></div><div class="pull-right"><i ng-if="::$tile.data.categories.length < 3" ng-hide="!$tile.data.isListItem && $tile.data.isServiceShift" ng-repeat="category in $tile.data.categories" ng-style="::{background: category.color}" class="cal-circle" title="{{::category.name}}"></i> <span ng-if="::$tile.data.categories.length >= 3" class="cal-square cal-square-all" title="{{::$tile.data.categoriesAllNames}}">{{::$tile.data.categories.length}}</span> <span ng-if="::$tile.data.previewDetails && $tile.data.ServiceType" class="arno-tag tag label label-tag label-info ml-5 mr-0 v-align-top service-type-label" title="{{ \'modules.events.calendar.eventType\' | translate }}">{{::$tile.data.ServiceType.Name}}</span><div ng-if="$tile.currentUrl === \'/events/overview\'" ng-hide="!$tile.data.isListItem && $tile.data.isServiceShift" class="arno-tag tag label label-tag label-info ml-5 mr-0 v-align-top service-type-label">{{ $tile.data.isService ? (\'modules.events.calendar.service\' | translate) : (\'modules.events.calendar.meeting\' | translate) }}</div></div></div><div class="cal-title" id="{{::$tile.data.id}}"><div ng-if="$tile.data.isService" ng-hide="!$tile.data.isListItem && $tile.data.isServiceShift">{{::$tile.data.title}}</div><i ng-if="$tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Acceptance || $tile.eventAcceptance" class="fa fa-check-circle" aria-hidden="true" style="color: #90B900;" title="{{ \'modules.events.calendar.participationConfirmed\' | translate }}"></i> <i ng-if="$tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Interested" class="fa fa-circle-o" aria-hidden="true" style="color: #DFB81C;" title="{{ \'modules.events.calendar.interestReported\' | translate }}"></i> <i ng-if="$tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Acceptance === false) || $tile.eventAcceptance === false" class="fa fa-times-circle" aria-hidden="true" style="color: #D40018;" title="{{ \'modules.events.calendar.participationCanceled\' | translate }}"></i> <i ng-if="!$tile.data.serviceShiftMember && $tile.eventAcceptance == null && $tile.data.canSelfAttend" ng-hide="$tile.data.isService && !$tile.data.isServiceShift" class="fa fa-question-circle" aria-hidden="true" style="color: #DDD;" title="{{ \'modules.events.calendar.participationOpen\' | translate }}"></i> <i ng-if="::$tile.data.metaTitle" title="{{ \'modules.events.calendar.shiftOfService\' | translate: { title: $tile.data.title } }}">{{::$tile.data.metaTitle}}</i> <span ng-if="!$tile.data.isService">{{::$tile.data.title}}</span></div><div ng-if="($tile.divisionCount > 1) || $tile.data.isSharedEvent" ng-hide="!$tile.data.isListItem && $tile.data.isServiceShift" class="cal-preview-meeting" title="{{ \'modules.events.calendar.division\' | translate }}{{::$tile.data.divisionName}}"><span ng-if="$tile.data.isListItem" class="hidden-xs">{{ \'modules.events.calendar.division\' | translate }}</span> <span>{{::$tile.data.divisionName}}</span></div><div><span ng-if="::$tile.data.previewDetails && $tile.data.previewDetails.LocationName" class="cal-preview-meeting ng-scope" title="{{ \'modules.events.calendar.place\' | translate }}"><i class="fa fa-map-marker mr-3"></i> {{::$tile.data.previewDetails.LocationName}}</span></div><div ng-if="$tile.data.isListItem && $tile.currentUrl === \'/events/overview\'"><div ng-if="$tile.data.location_name && !$tile.data.isServiceShift" class="hidden-xs"><span class="cal-preview-meeting ng-scope" title="{{ \'modules.events.calendar.location\' | translate: { location: $tile.data.location_name } }}"><i class="fa fa-map-marker mr-3"></i> {{::$tile.data.location_name}}</span></div><div><span ng-if="$tile.data.isService && $tile.data.isServiceShift && $tile.data.jobSite" class="hidden-xs">{{ \'modules.events.calendar.placeOfUse\' | translate: { job: $tile.data.jobSite } }}</span></div><div><span ng-if="$tile.data.meeting_place_name" class="hidden-xs">{{ \'modules.events.calendar.meetingPoint\' | translate: { name: $tile.data.meeting_place_name } }}</span> <span ng-if="$tile.data.meeting_place_name && $tile.data.meeting_time" class="hidden-xs">{{ \'modules.events.calendar.atOclockBrackets\' | translate: { time: $tile.data.meeting_time } }}</span></div></div><div class="cal-preview-details" ng-if="::$tile.data.previewDetails"><div class="cal-preview-description" ng-if="::$tile.data.remark || $tile.data.previewDetails.Description">{{:: $tile.truncate($tile.data.remark || $tile.data.previewDetails.Description, 750) }}</div><div class="cal-preview-meeting block" ng-if="::$tile.data.jobSite">{{ \'modules.events.calendar.placeOfUse\' | translate: { job: $tile.data.jobSite } }}</div><div class="cal-preview-meeting" ng-if="::$tile.data.previewDetails.MeetingPlaceName">{{ \'modules.events.calendar.meetingPoint\' | translate: { name: $tile.data.previewDetails.MeetingPlaceName } }} <span ng-if="::$tile.data.previewDetails.MeetingTime">{{ \'modules.events.calendar.atOclockBrackets\' | translate: { time: $tile.data.previewDetails.MeetingTime } }}</span></div><div ng-if="::!$tile.data.previewDetails.MeetingPlaceName && $tile.data.previewDetails.MeetingTime" class="cal-preview-meeting">{{ \'modules.events.calendar.meetingAtOclock\' | translate: { time: $tile.data.previewDetails.MeetingTime } }}</div></div><div ng-if="$tile.data.isListItem" class="cal-bottom-info clearfix" ng-class="::{\'cal-bottom-info-with-actions\': ($tile.data.previewDetails && $tile.data.calMode === \'SERVICE\' || $tile.data.previewDetails && $tile.data.calMode === \'EVENT\' && $tile.data.refiner === \'MY_SERVICES\') || $tile.showAttend}"><div><span ng-if="::$tile.data.flowState" class="arno-tag tag label label-tag" translate="{{ \'modules.events.calendar.\' + $tile.data.flowState.label | translate }}" ng-class="\'label-\' + $tile.data.flowState.activeClass" title="{{ \'modules.events.calendar.servicePhase\' | translate }}"><i class="fa fa-dot-circle-o mr-3"></i></span></div><div><span ng-if="$tile.data.isListItem && $tile.data.isService" class="arno-tag tag label label-tag" ng-class="$tile.memberCount.style()" title="{{$tile.memberCount.title()}}"><i class="fa fa-user mr-3"></i> {{$tile.memberCount.text()}}</span></div><div><span ng-if="$tile.data.isListItem && !$tile.data.isService" class="arno-tag tag label label-tag" ng-class="(!$tile.data.attendanceInfo.positionCount || ($tile.data.attendanceInfo.positionCount - $tile.data.attendanceInfo.positionedMemberCount > 0)) ? \'label-info\' : \'label-success\'" title="{{ \'modules.events.calendar.participants\' | translate: { count: $tile.eventAttendanceCount } }}"><i class="fa fa-user mr-3"></i> {{$tile.eventAttendanceCount}} <span ng-if="$tile.data.attendanceInfo.positionCount">/ {{::$tile.eventAttendanceCount }}</span></span></div><div ng-if="::$tile.data.iconInfos.length" class="cal-info-icons" ng-class="{\'mr-5 mt-2\': $tile.data.previewDetails}"><i ng-repeat="iconInfo in $tile.data.iconInfos" ng-class="[iconInfo.class, {\'hidden-xs\': iconInfo.title === \'Geteilte Veranstaltung\'}]" title="{{::iconInfo.title}}"></i></div><div><button type="button" class="btn btn-default btn-xs no-animation ml-5 mb-0" ng-click="$tile.openServiceScrollToShift($tile)" ng-if="$tile.data.isService && $tile.data.isServiceShift === false">{{ \'modules.events.calendar.navigateShifts\' | translate }}</button></div><div id="cal-bottom-info-actions" class="cal-bottom-info-actions" ng-if="::($tile.data.previewDetails && $tile.data.calMode === \'EVENT\' && $tile.data.refiner === \'MY_SERVICES\' && $tile.data.canSelfAttend && !($tile.data.serviceShiftMember.Acceptance || $tile.eventAcceptance || $tile.data.serviceShiftMember.Interested)) || ($tile.data.canSelfAttend && $tile.data.selfAttend === undefined && !($tile.data.serviceShiftMember.Acceptance || $tile.eventAcceptance || $tile.data.serviceShiftMember.Interested) && !($tile.data.serviceShiftMember.Acceptance === false || $tile.eventAcceptance === false) && !($tile.data.isService && $tile.data.isServiceShift === false))" ng-hide="($tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Acceptance === false) || $tile.eventAcceptance === false) || ($tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Acceptance === true) || $tile.eventAcceptance === true) || $tile.eventAcceptance || ($tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Interested) || !$tile.data.canSelfAttend" ng-click="$tile.preventClick($event)"><button type="button" class="btn btn-success btn-xs no-animation ml-5" ng-if="(!$tile.eventAcceptance && $tile.data.calMode === \'EVENT\' && $tile.data.refiner === \'MY_SERVICES\' ) || $tile.eventAcceptance === null && $tile.currentUrl === \'/events/overview\' || $tile.data.serviceShiftMember === undefined && $tile.currentUrl === \'/events/overview\'" ng-click="$tile.data.isServiceShift ? $tile.attendanceAdd(true) : $tile.attendanceAddEvent(true)" title="{{ \'modules.events.calendar.acceptYourself\' | translate }}"><i class="fa-user-check fix-btn"><i class="fa fa-user"></i> <i class="fa fa-check offset-color"></i></i> {{ \'modules.events.calendar.accept\' | translate }}</button> <button type="button" class="btn btn-danger btn-xs no-animation ml-5" ng-if="($tile.eventAcceptance || $tile.eventAcceptance === null && $tile.data.calMode === \'EVENT\' && $tile.data.refiner === \'MY_SERVICES\') || $tile.eventAcceptance === null && $tile.currentUrl === \'/events/overview\' || $tile.data.serviceShiftMember === undefined && $tile.currentUrl === \'/events/overview\'" ng-click="$tile.data.isServiceShift ? $tile.attendanceAdd(false) : $tile.attendanceAddEvent(false)" title="{{ \'modules.events.calendar.cancelYourself\' | translate }}"><i class="fa fa-user-times"></i> {{ \'modules.events.calendar.cancel\' | translate }}</button></div><div class="cal-bottom-info-actions" ng-if="$tile.data.calMode === \'EVENT\' && $tile.data.canSelfAttend || $tile.data.previewDetails && $tile.data.calMode === \'SERVICE\' && $tile.data.refiner === \'MY_SERVICES\' || $tile.showAttend" ng-click="$tile.preventClick($event)"><button type="button" class="btn btn-default btn-xs btn-with-icon ml-5" ng-if="::($tile.data.previewDetails && $tile.data.calMode === \'SERVICE\' && $tile.data.refiner === \'MY_SERVICES\') && !$tile.mediaSizeXS" ng-click="$tile.downloadICAL($event)"><i class="fa fa-download"></i> {{ \'modules.events.calendar.meeting\' | translate }}</button> <button type="button" class="btn btn-success btn-xs no-animation ml-5" ng-if="$tile.showAttend && (!$tile.data.serviceShiftMember || (!$tile.data.serviceShiftMember.Interested && !$tile.data.serviceShiftMember.Acceptance))" ng-click="$tile.attendanceAdd(true)" title="{{ \'modules.events.calendar.acceptYourself\' | translate }}"><i class="fa-user-check fix-btn"><i class="fa fa-user"></i> <i class="fa fa-check offset-color"></i></i> {{ \'modules.events.calendar.accept\' | translate }}</button> <button type="button" class="btn btn-danger btn-xs no-animation ml-5" ng-if="$tile.showAttend && ($tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Interested || $tile.data.serviceShiftMember.Acceptance)) || $tile.showAttend && !$tile.data.serviceShiftMember" ng-click="$tile.attendanceAdd(false)" title="{{ \'modules.events.calendar.cancelYourself\' | translate }}"><i class="fa fa-user-times"></i> {{ \'modules.events.calendar.cancel\' | translate }}</button></div><div class="eventlist-status" ng-if="$tile.data.isListItem && ( ($tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Acceptance || $tile.eventAcceptance) || ($tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Acceptance === false) || $tile.eventAcceptance === false) || ($tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Interested) || !$tile.data.canSelfAttend )" title="{{ \'modules.events.calendar.participationConfirmed\' | translate }}"><span class="arno-tag label label-default ml-5 all-events-tag mr-0" title="{{ \'modules.events.calendar.participationNotPossibleTtip\' | translate }}" ng-if="!$tile.data.canSelfAttend && $tile.data.isServiceShift"><div><i class="fa fa-exclamation-triangle"></i> <span>{{ \'modules.events.calendar.participationNotPossible\' | translate }}</span></div></span> <span class="arno-tag label label-success ml-5 all-events-tag" ng-if="$tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Acceptance || $tile.eventAcceptance"><div><i class="fa fa-check"></i> <span class="ml-4">{{ \'modules.events.calendar.accepted\' | translate }}</span></div></span> <span class="arno-tag label label-danger ml-5 all-events-tag" ng-if="$tile.data.serviceShiftMember && ($tile.data.serviceShiftMember.Acceptance === false) || $tile.eventAcceptance === false" title="{{ \'modules.events.calendar.participationCanceled\' | translate }}"><div><i class="fa fa-user-times"></i> <span class="ml-4">{{ \'modules.events.calendar.declined\' | translate }}</span></div></span> <span class="arno-tag label label-warning ml-5 all-events-tag" title="{{ \'modules.events.calendar.interestReported\' | translate }}" ng-if="$tile.data.serviceShiftMember && $tile.data.serviceShiftMember.Interested"><div><i class="fa fa-circle-o mt-2"></i> <span class="ml-4">{{ \'modules.events.calendar.interested\' | translate }}</span></div></span></div></div></div>');
$templateCache.put('app/theme/components/eventCalender/eventCalender.html','<div class="row"><div class="col-md-12"><div id="calendarSheet" class="responsive-calendar arno-event-calendar"></div></div></div>');
$templateCache.put('app/theme/components/eventMaterial/eventMaterial.html','<div class="event-material-component"><uib-accordion panel-class="panel-default bootstrap-panel accordion-panel" close-others="true" class="service-material-accordion"><div uib-accordion-group="" class="panel-default accordion-panel" ng-repeat="(key, modelName) in self.materialMeta.modelMap" is-open="self.material.ts[shift.id][key]" pre-open="self.material.po[shift.id][key]" ng-if="self.hasManagePerm || shift[self.materialMeta.assocKeys[key]].length > 0"><uib-accordion-heading><i class="pull-left mr-5" ng-class="self.materialMeta.storageIconMap[key]"></i> {{ modelName }} <span class="badge" ng-class="{\'active\': shift[self.materialMeta.assocKeys[key]].length}">{{ shift[self.materialMeta.assocKeys[key]].length }}</span> <i class="fa fa-cube ml-6 text-danger" ng-if="self.shiftMaterialBookingIndicator[shift.id][key]" title="{{ \'modules.events.shiftTemplate.matBookingShiftIndicator\' | translate }}"></i> <i class="fa fa-sitemap ml-4 text-warning" ng-if="self.shiftMaterialBookingIncludedIndicator[shift.id][key]" title="{{ \'modules.events.shiftTemplate.matBookingShiftIncludedIndicator\' | translate }}"></i> <i class="pull-right" ng-class="{\'ion-chevron-down mt-1\': self.material.ts[shift.id][key], \'ion-chevron-left mr-6 ml-5\': !self.material.ts[shift.id][key]}"></i></uib-accordion-heading><div class="service-material-accordion-actions clearfix"><div class="btn-group" ng-click="$event.stopPropagation()" uib-dropdown="" dropdown-append-to-body="true" ng-class="{\'active\': self.material.ts[shift.id][key]}"><button uib-dropdown-toggle="" type="button" class="btn btn-info btn-xs btn-with-icon"><i class="fa fa-table"></i><span>{{ (\'modules.events.shiftTemplate.view\' | translate) }}</span><span class="caret ml-3 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-left"><li role="menuitem" ng-repeat="view in self.materialMeta.tableConfig[key]"><a href="" ng-click="self.setMaterialView(shift.id, key, view)">{{ view.Name }}</a></li></ul></div><button type="button" class="btn btn-xs btn-success btn-with-icon pull-right" ng-if="!self.hide.materialEdit" ng-click="self.addMaterial(shift, key)"><i class="ion-plus"></i> {{ (\'modules.events.shiftTemplate.addMaterial\' | translate) }}</button> <button type="button" class="btn btn-xs btn-info btn-with-icon pull-right mr-5" ng-if="!self.hide.materialEdit && self.hasMaterialPriceItemTypeInQuotationBase[key]" ng-click="self.importFromQuotation(shift, key)"><i class="af af-finance-coins pl-3 pr-4"></i> Material aus Angebot</button> <button type="button" class="btn btn-xs btn-info btn-with-icon pull-right mr-5" ng-if="!self.hide.materialEdit && self.hasMaterialTypePriceItemTypeInQuotationBase[key]" ng-click="self.importFromQuotation(shift, key, true)"><i class="af af-finance-coins pl-3 pr-4"></i> Materialtyp aus Angebot</button></div><div class="table-responsive p-5" ng-if="self.material.tsi[shift.id][key]"><table st-table="self.material.dc[shift.id][key]" st-safe-src="self.material.r[shift.id][key]" config-inject="" ctrl-sync="self.material.ctrl[shift.id][key]" class="table table-condensed arno-aggregatable-table"><thead><tr class="sortable"><th st-sort="\'Amount\'" class="force-minimal" colspan="{{self.hide.materialEdit ? 2 : 1}}">{{ (\'modules.events.shiftTemplate.count\' | translate) }}</th><th class="force-minimal" colspan="3" ng-if="!self.hide.materialEdit">{{ (\'modules.events.shiftTemplate.booking\' | translate) }}</th><th st-sort="{{ header.prop }}" ng-repeat="header in self.materialMeta.columns[key]" ng-if="!self.material.view[shift.id][key] || self.material.view[shift.id][key].Fields.indexOf(header.prop) !== -1" ng-class="{aggregatable: self.materialMeta.util.checkAggregateExcludes(header.prop)}"><span>{{ header.label }}</span> <button type="button" class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-if="self.materialMeta.util.checkAggregateExcludes(header.prop)" title="{{ header.label }} {{ \'modules.events.shiftTemplate.aggregate\' | translate }}" ng-class="{active: self.isIn(self.material.agg[shift.id][key],header.prop)}" ng-click="self.toggleMaterialAggregate($event, shift.id, key, header.prop)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th colspan="2" class="force-minimal" ng-if="!self.hide.materialEdit">{{ (\'modules.events.shiftTemplate.actions\' | translate) }}</th></tr><tr><th colspan="{{self.hide.materialEdit ? 2 : 1}}"></th><th colspan="3" ng-if="!self.hide.materialEdit"></th><th ng-repeat="header in self.materialMeta.columns[key]" ng-if="!self.material.view[shift.id][key] || self.material.view[shift.id][key].Fields.indexOf(header.prop) !== -1"><div class="input-group" ng-if="self.materialMeta.util.searchableCheck(self.materialMeta.util.propTypes[key], header)"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="{{ ::self.getSearchField(header.prop) }}" type="search" ng-model="self.material.sf[shift.id][key][header.prop]" ng-enter="" class="form-control with-default-addon input-sm"></div></th><th colspan="2" ng-if="!self.hide.materialEdit"></th></tr></thead><tbody><tr ng-repeat="material in self.material.dc[shift.id][key] track by material.id" class="no-top-border"><td class="align-left-force text-overflow overflow-title" ng-class="{\'force-minimal\': self.hide.materialEdit}"><input type="number" class="form-control" ng-class="{\'input-warn\': !material.Count}" ng-if="!self.hide.materialEdit" ng-model="material.Count" min="1" step="1" ng-disabled="self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].ImplicitInId" title="{{ self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].ImplicitInId ? (\'modules.events.shiftTemplate.matBookingIsImplicitMaterial\' | translate) : \'\' }}" ng-change="self.processMaterialCount(shift, key, material, {{ material.Count }})"> <span ng-if="self.hide.materialEdit && (!self.isArray(material.id) || material.id.length === 1)"><span ng-if="self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId]">{{ self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount }} <span class="text-muted" ng-if="self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount !== material.Count">{{(\'modules.events.shiftTemplate.matBookingOfAmountAvailable\' | translate:{ asked: material.Count })}}</span></span> <span ng-if="!self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId]">{{ material.Count || \'0\' }}</span></span> <span ng-if="self.hide.materialEdit && self.isArray(material.id) && material.id.length !== 1"><span ng-if="self.bookingMaterialUtilizationAggregationCalc(key, material)">{{ self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount }} <span class="text-muted" ng-if="self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount !== material.Count">{{(\'modules.events.shiftTemplate.matBookingOfAmountAvailable\' | translate:{ asked: material.Count })}}</span></span> <span ng-if="!self.bookingMaterialUtilizationAggregationCalc(key, material)">{{ material.Count || \'0\' }}</span></span></td><td class="force-minimal white-space-no-wrap" ng-if="!self.hide.materialEdit && (!self.isArray(material.id) || material.id.length === 1)"><status-light class="\'light-inline\'" use-one-light="true" is-inactive="!self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId] || self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount !== material.Count" is-green="self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].fullyAvailable" green-title="(\'modules.events.shiftTemplate.matBookingGreen\' | translate)" red-title="(\'modules.events.shiftTemplate.matBookingRed\' | translate: { available: self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount })"></status-light><span class="badge ml-3 material-booking-amount-badge" ng-class="{\'active\': self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].unchangedFromInitial && self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount === material.Count}" title="{{ (self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].unchangedFromInitial && self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount === material.Count) ? (\'modules.events.shiftTemplate.matBookingActiveIndicator\' | translate) : (\'modules.events.shiftTemplate.matBookingPendingIndicator\' | translate)}}"><i class="fa fa-refresh" ng-if="(!(self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount >= 0)) || self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount !== material.Count"></i> <span ng-if="!((!(self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount >= 0)) || self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount !== material.Count)">{{ self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].EffectiveAmount }}</span></span></td><td class="force-minimal white-space-no-wrap" ng-if="!self.hide.materialEdit && self.isArray(material.id) && material.id.length !== 1"><status-light class="\'light-inline\'" use-one-light="true" use-yellow-light="true" is-inactive="self.bookingMaterialUtilizationAggregationCalc(key, material).isInactive" is-green="self.bookingMaterialUtilizationAggregationCalc(key, material).isGreen" is-yellow="self.bookingMaterialUtilizationAggregationCalc(key, material).isYellow" green-title="(\'modules.events.shiftTemplate.matBookingGreen\' | translate)" red-title="(\'modules.events.shiftTemplate.matBookingRed\' | translate: { available: self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount })" yellow-title="(\'modules.events.shiftTemplate.matBookingRed\' | translate: { available: self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount })"></status-light><span class="badge ml-3 material-booking-amount-badge" ng-class="{\'active\': self.bookingMaterialUtilizationAggregationCalc(key, material).unchangedFromInitial && self.bookingMaterialUtilizationAggregationCalc(key, material).AskedAmount === material.Count}" title="{{ (self.bookingMaterialUtilizationAggregationCalc(key, material).unchangedFromInitial && self.bookingMaterialUtilizationAggregationCalc(key, material).AskedAmount === material.Count) ? (\'modules.events.shiftTemplate.matBookingActiveIndicator\' | translate) : (\'modules.events.shiftTemplate.matBookingPendingIndicator\' | translate)}}"><i class="fa fa-refresh" ng-if="(!(self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount >= 0)) || self.bookingMaterialUtilizationAggregationCalc(key, material).AskedAmount !== material.Count"></i> <span ng-if="!((!(self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount >= 0)) || self.bookingMaterialUtilizationAggregationCalc(key, material).AskedAmount !== material.Count)">{{ self.bookingMaterialUtilizationAggregationCalc(key, material).EffectiveAmount }}</span></span></td><td class="align-left-force text-overflow overflow-title" ng-class="{\'has-error\': !material.BookingMaterialTimeId}" ng-if="!self.hide.materialEdit"><select class="form-control input-sm" ng-model="material.BookingMaterialTimeId" ng-change="self.processBookingMaterialTimeChange(shift, key, material)" ng-disabled="self.hide.materialEdit || self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].ImplicitInId" title="{{ self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].ImplicitInId ? (\'modules.events.shiftTemplate.matBookingIsImplicitMaterial\' | translate) : \'\' }}" ng-class="{\'text-italic\': self.isArray(material.BookingMaterialTimeId)}"><option ng-repeat="bookingMaterialTime in shift.BookingMaterialTimes track by bookingMaterialTime.id" ng-value="bookingMaterialTime.id">{{bookingMaterialTime.Title}}</option><option ng-value="material.BookingMaterialTimeId" ng-if="self.isArray(material.BookingMaterialTimeId)">{{ \'modules.events.shiftTemplate.variousBookingPeriods\' | translate }}</option></select></td><td class="force-minimal"><button type="button" class="btn btn-with-icon btn-booking-hierarchy" ng-class="self.bookingMaterialIncludedAvailableClass(self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId])" ng-if="(!self.isArray(material.id) || material.id.length === 1) && self.hasMaterialHierarchy(key, material.id)" ng-click="self.openMaterialHierarchy(key, material.id, material.BookingMaterialTimeId, self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].unchangedFromInitial && self.bookingMaterialUtilizationBase[key][material.id][material.BookingMaterialTimeId].AskedAmount === material.Count)" title="{{ \'modules.events.shiftTemplate.matBookingShowImplicitMaterials\' | translate }}"><i class="fa fa-sitemap"></i></button></td><td ng-repeat="header in self.materialMeta.columns[key]" class="align-left-force text-overflow overflow-title" ng-if="!self.material.view[shift.id][key] || self.material.view[shift.id][key].Fields.indexOf(header.prop) !== -1"><div ng-if="header.prop !== \'Storage\' && header.prop !== \'ResponsibleMember\'"><span ng-if="!self.materialMeta.util.propTypes[key][header.prop] || ( self.materialMeta.util.propTypes[key][header.prop] && self.materialMeta.util.propTypes[key][header.prop].type !== \'date\' && self.materialMeta.util.propTypes[key][header.prop].type !== \'bool\' )">{{:: (material[header.prop] === false ? (\'modules.events.shiftTemplate.no\' | translate) : material[header.prop] === true ? (\'modules.events.shiftTemplate.no\' | translate) : self.materialMeta.util.applyFieldConfig(self.materialMeta.util.propTypes[key], material[header.prop], header.prop)) || \'-\'}}</span> <span ng-if="self.materialMeta.util.propTypes[key][header.prop] && self.materialMeta.util.propTypes[key][header.prop].type === \'date\'">{{:: self.materialMeta.util.parseDate(material[header.prop]) || \'-\' | date:\'dd.MM.yyyy\'}}</span> <span ng-if="self.materialMeta.util.propTypes[key][header.prop] && self.materialMeta.util.propTypes[key][header.prop].type === \'bool\'">{{:: self.materialMeta.util.boolFormatter(material[header.prop]) || \'-\' }}</span></div><ul ng-if="header.prop === \'ResponsibleMember\'"><li ng-repeat="member in material[header.prop] track by $index" ng-class="{\'member-inactive\': member.isInactive}">{{:: member.fullName }} {{::member.isInactive ? \'(inaktiv)\' : \'\'}}</li></ul><div ng-if="header.prop === \'Storage\'"><span ng-repeat="(key, val) in material[header.prop]"><span class="arno-tag arno-storage-tag tag label label-tag label-info" ng-if="val.Name || key === \'Name\'">{{:: val.Name || val }}</span></span></div></td><td class="align-left-force" ng-if="!self.hide.materialEdit"><button type="button" class="btn btn-default btn-with-icon btn-xs" title="{{ \'modules.material.demandForAction.toDossier\' | translate }}" ng-click="self.openMaterialDossier(material.id, key)"><i class="fa fa-eye"></i> {{ (\'\' | translate) }}</button></td><td class="align-left-force" ng-if="!self.hide.materialEdit"><button type="button" class="btn btn-xs btn-danger" title="{{ \'modules.events.shiftTemplate.remove\' | translate }}" ng-click="self.removeMaterial(shift, key, material)"><i class="ion-ios-trash"></i> {{ (\'modules.events.shiftTemplate.remove\' | translate) }}</button></td></tr><tr ng-if="!shift[self.materialMeta.assocKeys[key]].length" class="no-top-border"><td colspan="99" class="text-center"><i>{{ (\'modules.events.shiftTemplate.shiftNoMaterials\' | translate) }} "{{modelName}}" {{ (\'modules.events.shiftTemplate.shiftNoMaterials2\' | translate) }}</i></td></tr></tbody><tfoot><tr class="no-top-border"><td colspan="99" class="p-0"><st-pagination st-items-by-page="self.materialsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></uib-accordion><div class="event-material-hint-section mt-10" ng-if="self.hasMaterialApplicabilities"><span class="event-material-hint-heading">{{ \'modules.events.shiftTemplate.applicabilityConstraint.heading\' | translate }}:</span><ul class="ml-5"><li ng-repeat="(constraint, materials) in self.materialApplicability" ng-if="materials.length"><span class="badge bg-danger">{{materials.length}}</span> <span class="event-material-hint-constraint">{{ (\'modules.events.shiftTemplate.applicabilityConstraint.\' + constraint) | translate }}:</span><ul><li ng-repeat="material in materials"><i class="mr-2" ng-class="self.materialMeta.storageIconMap[material.materialModel]"></i> <span>{{material.label}}</span></li></ul></li></ul>{{ s }}</div></div>');
$templateCache.put('app/theme/components/eventModalShare/inviteAttendee.html','<div class="modal-content event-service-invite-attendee"><form id="inviteAttendeeForm" name="inviteAttendeeForm" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.events.invitationModal.inviteAttendeeTitle"></h4></div><div class="modal-body pt-0"><div class="mb-20" ng-if="$ia.divisionOptions.length > 1"><span translate="modules.events.invitationModal.chooseInviteDiv"></span><table class="table table-condensed" ng-if="$ia.inviteDivisionList.length"><tbody><tr ng-repeat="division in $ia.inviteDivisionList | orderBy:\'division.Name\' track by division.id" class="no-top-border"><td class="align-left-force white-space-no-wrap force-minimal">{{::division.Name}}</td><td class="align-right-force pr-0"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ia.removeDivision(division)"><i class="ion-ios-trash"></i><span translate="generalTerms.remove"></span></button></td></tr></tbody></table></div><div ng-if="$ia.divisionOptions.length > 1" class="input-group input-group-with-btn-text mt-5 mb-20 fix-height"><ui-select ng-model="$ia.choosenDivision" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="false"><ui-select-match placeholder="{{ \'modules.events.serviceShare.searchDivison\' | translate }}">{{ $ia.choosenDivision.Name }}</ui-select-match><ui-select-choices position="down" repeat="division in $ia.divisionSelect" refresh-delay="200"><div ng-if="!division.none"><span>{{ division.Name }}</span></div></ui-select-choices></ui-select><div class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ia.addDivision(division)" ng-disabled="!$ia.inviteDivisionList"><i class="ion-plus"></i> <span translate="generalTerms.add"></span></button> <button type="button" class="btn btn-info" ng-click="$ia.addAllDivisions()" ng-disabled="!$ia.inviteDivisionList"><i class="ion-plus"></i> <span translate="modules.events.invitationModal.addAllDivisions"></span></button></div></div><div><span translate="modules.events.invitationModal.selectAttendeePart1"></span> <span ng-if="$ia.shifts" translate="modules.events.invitationModal.selectAttendeePart2" translate-values="{ shiftAmount: $ia.shifts.length, shiftSubject: $ia.shifts[0].Subject || \'Neue Schicht\' }"></span> <span ng-if="!$ia.shifts" translate="modules.events.invitationModal.selectAttendeePart3"></span> <span translate="modules.events.invitationModal.selectAttendeePart4"></span></div><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" ng-model="$ia.sendOption" value="ALL_DIVISION"> <span translate="modules.events.invitationModal.allInDiv"></span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" ng-model="$ia.sendOption" value="CUSTOM"> <span translate="modules.events.invitationModal.selectedMembers"></span></label></div><div class="col-md-6" ng-if="$ia.positions.length > 0"><label class="radio-inline custom-radio nowrap"><input type="radio" (click)="searchInviteMember(\'*SelectAll*\')" name="inlineRadioOptions" id="inlineRadio2" ng-model="$ia.sendOption" value="SUITABLE"> <span translate="modules.events.invitationModal.onlyNotifySuitableMembers"></span></label></div></div><table class="table table-condensed" ng-if="$ia.customInviteList.length && ($ia.sendOption === \'CUSTOM\' || $ia.groupsInSuitable)"><tbody><tr ng-repeat="member in $ia.customInviteList | orderBy:\'fullName\' track by member.id" class="no-top-border"><td class="align-left-force white-space-no-wrap force-minimal">{{::member.fullName}} <i class="fa fa-bell" ng-if="member.NotificationPreference && (member.NotificationPreference.Events == \'PUSH\' || member.NotificationPreference.Services == \'PUSH\' || member.NotificationPreference.Events == \'BOTH\' || member.NotificationPreference.Services == \'BOTH\')" translate-attr="{ title: \'pageTop.iconList.pushnotifications\' }"></i></td><td><div class="arno-tag tag label label-tag label-info" ng-if="$ia.memberHasAttendeeStatus(member)"><span translate="modules.events.invitationModal.inList"></span></div></td><td class="align-right-force pr-0"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ia.removeInvite(member)"><i class="ion-ios-trash"></i><span translate="modules.events.invitationModal.removeInvite"></span></button></td></tr></tbody></table><div ng-if="$ia.sendOption === \'CUSTOM\'"><div class="input-group input-group-with-select input-group-with-btn-text mt-5 mb-0 fix-height"><ui-select ng-model="$ia.memberToInvite" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="false"><ui-select-match placeholder="{{ \'components.memberSelector.searchMember\' | translate }}">{{ $ia.memberToInvite.fullName }}</ui-select-match><ui-select-choices position="down" repeat="member in $ia.inviteChoices" refresh="$ia.searchInviteMember($select.search)" refresh-delay="200" ui-disable-choice="member.id && $root.ctx.currentUser.id === member.id"><div ng-if="!member.none"><span>{{ member.fullName }} ({{ member.ContactEMail || (member.Account.Type === \'offline\' ? \'----\' : member.Account.EMail)}})</span><div class="arno-tag tag label label-tag label-info mr-0 ml-5" ng-if="$ia.memberHasAttendeeStatus(member) && $root.ctx.currentUser.id !== member.id"><span translate="modules.events.invitationModal.inList"></span></div><div class="arno-tag tag label label-tag mr-0 ml-5" ng-if="$root.ctx.currentUser.id === member.id"><span translate="modules.events.invitationModal.myself"></span></div></div><div ng-if="member.none" class="btn-with-icon"><span ng-if="member.foundNone"><i class="fa fa-times"></i><span><i translate="modules.events.invitationModal.foundNone"></i></span></span> <span ng-if="!member.foundNone"><i translate="modules.events.invitationModal.searchMember"></i></span></div></ui-select-choices></ui-select><div class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ia.addInvite()" ng-disabled="!$ia.memberToInvite"><i class="ion-plus"></i> <span translate="modules.events.invitationModal.invite"></span></button></div></div></div><div ng-if="$ia.sendOption === \'SUITABLE\' || $ia.sendOption === \'CUSTOM\'"><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height"><member-group-selector divisions="$ia.mapDivisions" selected-member-group="$ia.selectedMemberGroup"></member-group-selector><div class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ia.addGroupInvite()" ng-disabled="!$ia.selectedMemberGroup.value"><i class="ion-plus"></i> <span translate="modules.events.invitationModal.invite"></span></button></div></div></div><div ng-if="$ia.sendOption === \'SUITABLE\'"><div class="alert bg-primary" role="alert"><i class="fa fa-eye"></i> <span translate="modules.events.invitationModal.alertText"></span></div><div class="alert bg-warning" role="alert" ng-if="$ia.sendOption === \'SUITABLE\' && !$ia.customInviteList.length"><i class="fa fa-info-circle"></i> <span translate="modules.events.invitationModal.warningText"></span></div></div><div class="mt-10"><i translate="modules.events.invitationModal.sentBySystem"></i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" ng-disabled="!$ia.divisionOptions[0] || ($ia.sendOption !== \'ALL_DIVISION\' && $ia.sendOption !== \'SUITABLE\' && !$ia.customInviteList.length) || ($ia.sendOption === \'SUITABLE\' && !$ia.customInviteList.length)" ng-click="$ia.applyModal()"><span translate="modules.events.invitationModal.send"></span></button></div></form></div>');
$templateCache.put('app/theme/components/eventModalShare/sendAttendeeMessage.html','<div class="modal-content"><form id="sendAttendeeMessageForm" name="sendAttendeeMessageForm" novalidate=""><div class="modal-header" ng-class="{\'bg-warning text-white\': $msg.noAttendees}"><h4 ng-class="{\'modal-title\': !$msg.noAttendees}" translate="modules.events.invitationModal.sendMsgTitle"></h4></div><div class="modal-body"><div ng-if="$msg.noAttendees"><p translate="modules.events.invitationModal.noAttendeesPart1"></p><ul ng-if="$msg.shifts"><li translate="modules.events.invitationModal.noAttendeesPart2" translate-values="{ shiftCount: $msg.shifts.length }"></li><li translate="modules.events.invitationModal.noAttendeesPart3" translate-values="{ shiftCount: $msg.shifts.length }"></li><li translate="modules.events.invitationModal.noAttendeesPart4"></li></ul><ul ng-if="!$msg.shifts"><li translate="modules.events.invitationModal.noAttendeesPart5"></li><li translate="modules.events.invitationModal.noAttendeesPart6"></li><li translate="modules.events.invitationModal.noAttendeesPart7"></li></ul></div><div ng-if="!$msg.noAttendees"><p translate="modules.events.invitationModal.instructionsPart1"></p><p><span translate="modules.events.invitationModal.instructionsPart2" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></span> <strong translate="modules.events.invitationModal.instructionsPart3" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></strong> <span translate="modules.events.invitationModal.instructionsPart4" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></span></p><p ng-if="$msg.missingAttendeeInfos.length"><strong translate="modules.events.invitationModal.instructionsPart5"></strong> <span translate="modules.events.invitationModal.instructionsPart6" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></span><br><br><span translate="modules.events.invitationModal.instructionsPart7" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></span><u translate="modules.events.invitationModal.instructionsPart8"></u><span translate="modules.events.invitationModal.instructionsPart9" translate-values="{ attendeeCount: $msg.attendeeInfos.length }"></span><br><br>{{$msg.missingAttendeeInfosStr}}</p><p ng-if="$msg.attendeeInfos.length > 1"><strong translate="modules.events.invitationModal.instructionsPart10"></strong> <span translate="modules.events.invitationModal.instructionsPart11"></span><br><br><span class="my-5 inline-block"><u translate="modules.events.invitationModal.instructionsPart12"></u><span translate="modules.events.invitationModal.instructionsPart13"></span><u translate="modules.events.invitationModal.instructionsPart14"></u><span translate="modules.events.invitationModal.instructionsPart15"></span></span><br><br><span translate="modules.events.invitationModal.instructionsPart16"></span></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="{\'pull-left\': !$msg.noAttendees}" ng-click="$dismiss()"><span translate="generalTerms.cancel"></span></button> <button type="submit" class="btn btn-default" ng-if="!$msg.noAttendees" ng-click="$msg.applyModal(\',\', true)" title="{{ \'components.modals.mailModal.copyToClipboard\' | translate }}"><i class="fa fa-clipboard"></i></button> <button type="submit" class="btn btn-info" ng-if="!$msg.noAttendees && $msg.attendeeInfos.length === 1" ng-click="$msg.applyModal()"><i class="fa" ng-class="$msg.envelopeType"></i>&nbsp;<span translate="modules.events.invitationModal.invite"></span></button> <button type="submit" class="btn btn-info" ng-if="!$msg.noAttendees && $msg.attendeeInfos.length > 1" ng-click="$msg.applyModal(\';\')"><i class="fa" ng-class="$msg.envelopeType"></i>&nbsp;<span translate="modules.events.invitationModal.sendOutlook"></span></button> <button type="submit" class="btn btn-info" ng-if="!$msg.noAttendees && $msg.attendeeInfos.length > 1" ng-click="$msg.applyModal(\',\')"><i class="fa" ng-class="$msg.envelopeType"></i>&nbsp;<span translate="modules.events.invitationModal.sendOther"></span></button></div></form></div>');
$templateCache.put('app/theme/components/eventTileDashboard/eventTileDashboard.html','<div class="event-tile-dashboard" ng-click="$ctrl.clickTile($ctrl.data)"><div class="event-tile-dashboard__top-section"><div><span>{{$ctrl.data.start | date : \'dd.MM.yyyy HH:mm\' }}</span> - <span>{{$ctrl.data.end | date : \'dd.MM.yyyy HH:mm\' }}</span></div><div><i ng-if="::$ctrl.data.categories.length < 3" ng-repeat="category in $ctrl.data.categories" ng-style="::{background: category.color}" class="cal-circle" title="{{::category.name}}"></i><div class="arno-tag tag label label-tag label-info ml-5 mr-0 v-align-top service-type-label">{{ $ctrl.data.isService ? (\'modules.events.calendar.service\' | translate) : (\'modules.events.calendar.meeting\' | translate) }}</div></div></div><div class="event-tile-dashboard__body-section"><div class="event-tile-dashboard__body-section__title"><div><span title="$ctrl.data.title" ng-if="$ctrl.data.isService">{{$ctrl.data.title}}</span></div><i ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Acceptance || $ctrl.eventAcceptance || $ctrl.data.ownEventMember || $ctrl.data.selfAttend" class="fa fa-check-circle" aria-hidden="true" style="color: #90B900;" title="{{ \'modules.events.calendar.participationConfirmed\' | translate }}"></i> <i ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Interested" class="fa fa-circle-o" aria-hidden="true" style="color: #DFB81C;" title="{{ \'modules.events.calendar.interestReported\' | translate }}"></i> <i ng-if="!$ctrl.data.serviceShiftMember && $ctrl.eventAcceptance == null && !$ctrl.data.selfAttend" ng-hide="$ctrl.data.isService && !$ctrl.data.isServiceShift" class="fa fa-question-circle" aria-hidden="true" style="color: #DDD;" title="{{ \'modules.events.calendar.participationOpen\' | translate }}"></i> <span title="$ctrl.data.title" ng-if="!$ctrl.data.isService">{{$ctrl.data.title}}</span> <i ng-if="$ctrl.data.metaTitle" class="ng-binding ng-scope"><span title="$ctrl.data.metaTitle">{{$ctrl.data.metaTitle}}</span></i></div><div class="event-tile-dashboard__body-section__info"><div class="event-tile-dashboard__body-section__info__division" title="{{ \'modules.events.calendar.division\' | translate }}{{::$ctrl.data.divisionName}}" ng-if="$ctrl.data.divisionName"><span class="hidden-xs">{{ \'modules.events.calendar.division\' | translate }}</span> <span>{{::$ctrl.data.divisionName}}</span></div><div ng-if="$ctrl.data.location_name" class="event-tile-dashboard__body-section__info__location hidden-xs"><span class="cal-preview-meeting ng-scope" title="{{ \'modules.events.calendar.location\' | translate: { location: $ctrl.data.location_name } }}"><i class="fa fa-map-marker mr-3"></i> {{::$ctrl.data.location_name}}</span></div><div ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Acceptance || $ctrl.data.eventAcceptance || $ctrl.data.ownEventMember || $ctrl.data.selfAttend && $ctrl.data.serviceShiftMember.Interested !== true"><div ng-if="$ctrl.data.isService && $ctrl.data.isServiceShift && $ctrl.data.jobSite">{{ \'modules.events.calendar.placeOfUse\' | translate: { job: $ctrl.data.jobSite } }}</div><span ng-if="$ctrl.data.meeting_place_name">{{ \'modules.events.calendar.meetingPoint\' | translate: { name: $ctrl.data.meeting_place_name } }}</span> <span ng-if="$ctrl.data.meeting_place_name && $ctrl.data.meeting_time">{{ \'modules.events.calendar.atOclockBrackets\' | translate: { time: $ctrl.data.meeting_time } }}</span></div></div></div><hr class="event-tile-dashboard__divider"><div class="event-tile-dashboard__bottom-section"><div><span ng-if="$ctrl.data.isService" class="arno-tag tag label label-tag" ng-class="$ctrl.memberCount.style()" title="{{$ctrl.memberCount.title()}}"><i class="fa fa-user mr-3"></i> {{$ctrl.memberCount.text()}}</span> <span ng-if="!$ctrl.data.isService" class="arno-tag tag label label-tag" ng-class="(!$ctrl.data.attendanceInfo.positionCount || ($ctrl.data.attendanceInfo.positionCount - $ctrl.data.attendanceInfo.positionedMemberCount > 0)) ? \'label-info\' : \'label-success\'" title="{{ \'modules.events.calendar.participants\' | translate: { count: $ctrl.data.attendanceInfo.length || 0 } }}"><i class="fa fa-user mr-3"></i> {{$ctrl.meeting_acceptance.length || 0}} <span ng-if="$ctrl.data.attendanceInfo.positionCount">/ {{$ctrl.data.attendanceInfo.length || 0 }}</span></span></div><div ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Interested || $ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Acceptance || $ctrl.data.eventAcceptance || $ctrl.data.ownEventMember || $ctrl.data.selfAttend"><span class="arno-tag label label-success ml-5 all-events-tag mr-0" ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Acceptance || $ctrl.data.eventAcceptance || $ctrl.data.ownEventMember || $ctrl.data.selfAttend && $ctrl.data.serviceShiftMember.Interested !== true"><div><i class="fa fa-check"></i> <span class="ml-4">{{ \'modules.events.calendar.accepted\' | translate }}</span></div></span> <span class="arno-tag label label-warning ml-5 all-events-tag mr-0" title="{{ \'modules.events.calendar.interestReported\' | translate }}" ng-if="$ctrl.data.serviceShiftMember && $ctrl.data.serviceShiftMember.Interested"><div><i class="fa fa-circle-o mt-2"></i> <span class="ml-4">{{ \'modules.events.calendar.interested\' | translate }}</span></div></span></div><div class="event-tile-dashboard__bottom-section__buttons" ng-if="!$ctrl.data.ownEventMember && !$ctrl.data.eventAcceptance && !$ctrl.data.serviceShiftMember && !$ctrl.data.selfAttend" ng-click="$ctrl.preventClick($event)"><button type="button" class="btn btn-success btn-xs no-animation ml-5" ng-click="$ctrl.data.isServiceShift ? $ctrl.attendanceAdd(true) : $ctrl.attendanceAddEvent(true)" title="{{ \'modules.events.calendar.acceptYourself\' | translate }}"><i class="fa-user-check fix-btn"><i class="fa fa-user"></i> <i class="fa fa-check offset-color"></i></i> {{ \'modules.events.calendar.accept\' | translate }}</button> <button type="button" class="btn btn-danger btn-xs no-animation ml-5" ng-click="$ctrl.data.isServiceShift ? $ctrl.attendanceAdd(false) : $ctrl.attendanceAddEvent(false)" title="{{ \'modules.events.calendar.cancelYourself\' | translate }}"><i class="fa fa-user-times"></i> {{ \'modules.events.calendar.cancel\' | translate }}</button></div></div></div>');
$templateCache.put('app/theme/components/fileStorage/fileStorage.html','<div class="arno-file-storage"><div class="col-xs-12 col-sm-6 mt-15 mb-20"><div><div class="row"><div class="col-xs-12 control-side"><button type="button" class="btn btn-default btn-sm btn-with-icon" ng-click="$fs.toggleCollapsed()"><i ng-class="{\'ion-chevron-up\': $fs.treeviewCollapsed === false, \'ion-chevron-down\': $fs.treeviewCollapsed === true }"></i> <span translate="modules.personnel.dossier.fileStorage.collapse" translate-values="{ collapse: $fs.treeviewCollapsed }"></span></button> <button class="btn btn-primary btn-sm btn-with-icon pull-right" type="button" ng-if="!$fs.isOrg" ng-disabled="!$fs.selectedNode.type || $fs.selectedNode.active === false || $fs.isParentRestricted($fs.selectedNode, $fs.folderStructureData, true)" ng-click="$fs.openUploadDialog($fs.selectedNode)" ng-show="$fs.isPermittedInCurrentDiv($fs.editPerm, false)"><i class="ion-plus"></i><span class="ml-5" translate="modules.personnel.dossier.fileStorage.upload"></span></button></div></div></div><div class="row"><div class="col-xs-12"><br><div ng-if="$fs.folderStructureData && $fs.folderStructureData.length"><script type="text/ng-template" id="nodesRenderer.tpl.html"><div ng-if="node.id !== \'rootOrg\' && ((node.active !== false && !$fs.isParentRestricted(node, $fs.folderStructureData, true)) || node.type === \'file\' || $fs.hasChildFiles(node))" type="file" nv-file-drop uploader="$fs.uploader" ng-dblClick="node.collapsed = !node.collapsed" ng-on-drop="$fs.selectNode(node, true)" class="node-embed tree-no-select" ui-tree-handle ng-click="$fs.selectNode(node)" ng-class="{\'node-active\': $fs.selectedNode.id === node.id}"> <a ng-click="node.collapsed = !node.collapsed" ng-if="node.children.length" class="btn btn-clear btn-xs division-chevron"> <i class="fa" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}"></i> </a> <div ng-class="{ \'inline-block text-node-with-children\': node.children.length, \'ml-30\' : !node.children.length, \'text-gray\': (node.active === false || $fs.isParentRestricted(node, $fs.folderStructureData, true)) && node.id !== \'rootOrg\'}"> <div class="ba-treeview-node-icon inline {{$fs.getIcon(node)}}"></div> <span class="ba-treeview-node-label"> {{node.text}} <div ng-if="$fs.showEditPermIcon && (node.viewPermission === \'edit\' || node.viewPermission === \'item\')" class="arno-tag tag label label-tag label-warning pull-right m-0 ml-5" title="{{\'components.fileStorage.onlyEditPerm\' | translate}}"> <i class="fa fa-eye"></i> </div> </span> </div> </div> <div ng-if="node.id === \'rootOrg\'" ng-dblClick="node.collapsed = !node.collapsed" class="node-embed tree-no-select" ui-tree-handle ng-click="$fs.selectNode(node)" ng-class="{\'node-active\': $fs.selectedNode.id === node.id}"> <a ng-click="node.collapsed = !node.collapsed" ng-if="node.children.length" class="btn btn-clear btn-xs division-chevron"> <i class="fa" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}"></i> </a> <div ng-class="{\'inline-block text-node-with-children\': node.children.length, \'ml-30\' : !node.children.length}"> <div class="ba-treeview-node-icon inline {{$fs.getIcon(node)}}"></div> <span class="ba-treeview-node-label"> {{node.text}} <div ng-if="$fs.showEditPermIcon && node.viewPermission === \'edit\'" class="arno-tag tag label label-tag label-warning pull-right m-0 ml-5" title="{{\'components.fileStorage.onlyEditPerm\' | translate}}"> <i class="fa fa-eye"></i> </div> </span> </div> </div> <ol ui-tree-nodes="options" class="ml-6" ng-model="node.children" ng-class="{hidden: node.collapsed, displayed: !node.collapsed}"> <li ng-repeat="node in node.children" class="{{::node.id}}" ui-tree-node ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div class="division-tree" ui-tree="$fs.treeOptions" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="$fs.folderStructureData"><li ng-repeat="node in $fs.folderStructureData" collapsed="$fs.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div></div></div></div><div class="col-xs-12 col-md-6 mt-10"><div><div ng-show="$fs.selectedNode.id" ng-class="{\'event-spacer\' : $fs.storageIdent === \'service\'}"><h4 ng-if="$fs.selectedNode.type === \'folder\'" class="with-line" translate="modules.personnel.dossier.fileStorage.docsIn" translate-values="{ folder: $fs.selectedNode.text }"></h4><h4 ng-if="$fs.selectedNode.type === \'file\'" class="with-line"><span>{{ $fs.selectedNode.text }}</span> <button type="button" ng-if="($fs.selectedNode.id === \'rootOrg\' || $fs.selectedNode.id) && $fs.isPermittedInCurrentDiv($fs.editPerm, false) && !$fs.isOrg" class="btn btn-danger btn-with-icon btn-sm pull-right mt-5" title="{{ \'generalTerms.delete\' | translate }}" ng-click="$fs.deleteFile($fs.selectedNode)"><i class="ion-ios-trash"></i></button></h4><div class="row"><div class="col-sm-12"><form ng-show="$fs.selectedNode.type === \'folder\'"><div class="form-group"><div ng-if="$fs.docList.length"><div class="table-responsive"><table class="table table-condensed table-hover" st-table="$fs.docList"><thead><tr class="sortable"><th class="arno-search-field" st-sort="text" translate="modules.personnel.dossier.fileStorage.fileName"></th><th class="arno-search-field" st-sort="extension" translate="modules.personnel.dossier.fileStorage.tableHeaderFileType"></th><th st-sort="fileSize" translate="modules.personnel.dossier.fileStorage.tableHeaderFileSize"></th><th st-sort="CreatingMember.fullName" translate="modules.personnel.dossier.fileStorage.tableHeaderFileUploadedBy"></th><th st-sort="createdAt" translate="modules.personnel.dossier.fileStorage.tableHeaderFileCreatedAt"></th><th st-sort="updatedAt" translate="modules.personnel.dossier.fileStorage.tableHeaderFileUpdatedAt"></th><th translate="generalTerms.action"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="text" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="extension" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in $fs.docList"><td>{{ item.baseName }}</td><td><i class="{{$fs.getIconByFileExtension(item)}} mr-5"></i> {{ item.extension }}</td><td>{{ $fs.calcFileSize(item.fileSize) }}</td><td>{{ item.uploader.fullName}}</td><td>{{ item.createdAt | date:\'dd.MM.yyyy HH:mm\'}}</td><td>{{ item.updatedAt | date:\'dd.MM.yyyy HH:mm\'}}</td><td><div class="nowrap pull-right"><button ng-if="$fs.canPreview(item.extension)" type="button" class="btn btn-default btn-with-icon btn-xs" ng-click="$fs.previewFile(item)"><i class="fa fa-eye"></i> <span translate="generalTerms.view"></span></button> <button type="button" class="btn btn-default btn-with-icon btn-xs" ng-click="$fs.downloadFile(item)"><i class="fa fa-arrow-down"></i> <span translate="modules.personnel.dossier.fileStorage.download"></span></button> <button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-if="$fs.isPermittedInCurrentDiv($fs.editPerm, false) && !$fs.isOrg" ng-click="$fs.deleteFile(item)"><i class="ion-ios-trash"></i> <span translate="generalTerms.delete"></span></button></div></td></tr></tbody></table></div></div><div ng-if="!$fs.docList.length" class="mb-10"><i translate="modules.personnel.dossier.fileStorage.emptyFolder"></i></div><div ng-if="$fs.selectedNode.type === \'folder\' && !$fs.isOrg && $fs.isPermittedInCurrentDiv($fs.editPerm, false) && $fs.selectedNode.active !== false && !$fs.isParentRestricted($fs.selectedNode, $fs.folderStructureData, true)" nv-file-drop="" ng-on-drop="$fs.selectNode($fs.selectedNode, true)" uploader="$fs.uploader" class="well arno-file-drop-area" translate="modules.personnel.dossier.fileStorage.drop"></div></div></form><form ng-show="$fs.selectedNode.type === \'file\'"><div class="form-group"><div><label class="bold-text" for="fileTitle" translate="modules.personnel.dossier.fileStorage.fileName"></label> <input type="text" class="form-control mb-15" id="fileTitle" ng-model="$fs.selectedNode.baseName" placeholder="Dateiname" ng-change="$fs.checkTitle($fs.selectedNode.baseName)"> <span ng-if="$fs.emptyError" class="help-block basic-block" translate="modules.personnel.dossier.fileStorage.nameMissing"></span><table><thead><tr><td></td><td></td></tr></thead><tbody><tr><td><p translate="modules.personnel.dossier.fileStorage.fileSize"></p></td><td><p class="ml-10">{{$fs.calcFileSize($fs.selectedNode.fileSize)}}</p></td></tr><tr><td><p translate="modules.personnel.dossier.fileStorage.fileType"></p></td><td><p class="ml-10"><i class="{{$fs.getIconByFileExtension()}} mr-5"></i> {{$fs.selectedNode.extension}}</p></td></tr><tr><td><p translate="modules.personnel.dossier.fileStorage.fileUploadedBy"></p></td><td><p class="ml-10">{{$fs.selectedNode.uploader.fullName}}</p></td></tr><tr><td><p translate="modules.personnel.dossier.fileStorage.fileCreatedAt"></p></td><td><p class="ml-10">{{$fs.selectedNode.createdAt | date:\'dd.MM.yyyy HH:mm\'}}</p></td></tr><tr><td><p translate="modules.personnel.dossier.fileStorage.fileUpdatedAt"></p></td><td><p class="ml-10">{{$fs.selectedNode.updatedAt | date:\'dd.MM.yyyy HH:mm\'}}</p></td></tr></tbody></table></div></div></form></div></div></div><div ng-show="!$fs.selectedNode.id" class="text-center mt-10"><i translate="modules.personnel.dossier.fileStorage.chooseFolder"></i></div><div class="row btns-row mt-20"><div ng-show="$fs.selectedNode.type === \'file\'" class="col-md-12"><button type="button" ng-if="($fs.selectedNode.id === \'rootOrg\' || $fs.selectedNode.id) && $fs.isPermittedInCurrentDiv($fs.editPerm, false) && !$fs.isOrg" ng-disabled="$fs.fileNodeCopy.baseName === $fs.selectedNode.baseName" class="btn btn-primary btn-with-icon pull-right ml-10" ng-click="$fs.renameFile($fs.selectedNode)"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button ng-if="$fs.canPreview($fs.selectedNode.extension)" type="button" class="btn btn-default btn-with-icon pull-right ml-10" ng-click="$fs.previewFile($fs.selectedNode)"><i class="fa fa-eye"></i> <span translate="generalTerms.view"></span></button> <button type="button" ng-if="$fs.selectedNode.id === \'rootOrg\' || $fs.selectedNode.id" class="btn btn-default btn-with-icon pull-right ml-10" ng-click="$fs.downloadFile($fs.selectedNode)"><i class="fa fa-arrow-down"></i><span translate="modules.personnel.dossier.fileStorage.download"></span></button></div></div></div></div></div>');
$templateCache.put('app/theme/components/fileStorageAdmin/fileStorageAdmin.html','<div ba-panel="" ba-panel-title="$fs.panelTitle" ba-panel-class="with-scroll administration__divisions__treeview"><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-5 mt-15"><div class="row btns-row"><div class="row"><div class="col-xs-12 control-side"><button type="button" class="btn btn-default btn-sm btn-with-icon" ng-click="$fs.toggleCollapsed()"><i ng-class="{\'ion-chevron-up\': $fs.treeviewCollapsed === false, \'ion-chevron-down\': $fs.treeviewCollapsed === true }"></i> <span translate="components.fileStorageAdmin.collapseBtnText" translate-values="{ collapse: !$fs.treeviewCollapsed }"></span></button> <button class="btn btn-primary btn-sm btn-with-icon pull-right" type="button" ng-click="$fs.addNewNode()" ng-show="$fs.isPermittedInCurrentOrg(\'arno.personnel.administration.files.manage\')"><i class="ion-plus"></i><span class="ml-5" translate="components.fileStorageAdmin.newFolder">Neuer Ordner</span></button></div></div></div><div class="row"><div class="col-xs-12"><br><div ng-if="$fs.folderStructureData && $fs.folderStructureData.length"><script type="text/ng-template" id="nodesRenderer.tpl.html"><div class="node-embed tree-no-select" ui-tree-handle ng-dblClick="node.collapsed = !node.collapsed" ng-click="$fs.selectNode(node)" ng-class="{\'node-active\': $fs.selectedNode.id === node.id}"> <a ng-if="node.children.length" class="btn btn-clear btn-xs division-chevron" ng-click="node.collapsed = !node.collapsed"> <i class="fa" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}"></i> </a> <div ng-class="{inline: node.children.length, \'ml-30\' : !node.children.length, \'text-gray\': (!node.active || $fs.isParentRestricted(node, $fs.folderStructureData, true)) && node.id !== \'rootOrg\'}"> <div class="ba-treeview-node-icon {{$fs.getIcon(node)}}"></div> <span class="ba-treeview-node-label" ng-bind="node.text"></span> <i class="fa fa-exclamation-triangle tree-node-warning pull-right" title="{{ \'components.fileStorageAdmin.subFolderIncompatiblePerm\' | translate }}" ng-if="node.viewPermission === \'view\' && $fs.isParentRestricted(node, $fs.folderStructureData)" ></i> </div> </div> <ol ui-tree-nodes="options" class="ml-6" ng-model="node.children" ng-class="{hidden: node.collapsed, displayed: !node.collapsed}"> <li ng-repeat="node in node.children" class="{{::node.id}}" ui-tree-node ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div class="division-tree" ui-tree="$fs.treeOptions" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="$fs.folderStructureData"><li ng-repeat="node in $fs.folderStructureData" collapsed="$fs.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div></div></div></div><div class="col-xs-12 col-sm-7 mt-15"><div><div ng-show="$fs.selectedNode.id"><h4 class="with-line" toggle-next="">{{(\'components.fileStorageAdmin.folder\' | translate)}}</h4><div class="row"><div class="col-sm-12"><form><div class="form-group"><label for="folderTitle" translate="generalTerms.title">Titel</label> <input type="text" class="form-control" id="folderTitle" ng-model="$fs.selectedNode.text" placeholder="Titel" ng-change="$fs.checkTitle($fs.selectedNode.text)"> <span ng-if="$fs.emptyError" class="help-block basic-block" translate="components.fileStorageAdmin.noFolderTitle">Ein Ordner muss einen Titel haben!</span><div class="mt-20"><label>{{(\'components.fileStorageAdmin.folderVisibility\' | translate)}}<arno-ba-help-tooltip ng-if="$fs.selectedNode.parent && $fs.selectedNode.parent !== \'rootOrg\'" text="{{\'components.fileStorageAdmin.possiblyRestrictedVisibilityHint\' | translate}}"></arno-ba-help-tooltip></label><ui-select ng-model="$fs.selectedNode.viewPermission" class="btn-group bootstrap-select form-control" search-enabled="false" spinner-enabled="false"><ui-select-match placeholder="Recht f\xFCr Ordnersichtbarkeit w\xE4hlen"><span>{{ $fs.viewPermSelectorMap[$fs.selectedNode.viewPermission] }}</span></ui-select-match><ui-select-choices position="down" repeat="option in $fs.getAvailablePerms($fs.selectedNode, $fs.viewPermSelector)">{{ $fs.viewPermSelectorMap[option] }}</ui-select-choices></ui-select></div></div></form></div></div></div><div ng-show="!$fs.selectedNode.id" class="text-center" translate="components.fileStorageAdmin.selectAFolder">W\xE4hle bitte einen Ordner aus, oder erstelle einen neuen Ordner um Details anzuzeigen.</div></div></div></div></div><ba-panel-footer class="clearfix administration__divisions__treeview__footer-bar"><div class="pull-right"><button ng-if="$fs.selectedNode.id && !$fs.selectedNode.id.startsWith(\'n-\') && $fs.selectedNode.active && $fs.selectedNode.id !== \'rootOrg\'" class="btn btn-danger btn-with-icon" ng-click="$fs.setActiveState($fs.selectedNode, false)"><i class="fa fa-ban"></i><span translate="generalTerms.deactivate">Deaktivieren</span></button> <button ng-if="$fs.selectedNode.id && !$fs.selectedNode.id.startsWith(\'n-\') && !$fs.selectedNode.active && $fs.selectedNode.id !== \'rootOrg\'" class="btn btn-success btn-with-icon" ng-click="$fs.setActiveState($fs.selectedNode, true)"><i class="fa fa-check"></i><span translate="generalTerms.activate">Aktivieren</span></button> <button ng-disabled="$fs.selectedNode.id === \'rootOrg\' || !$fs.selectedNode.id" class="btn btn-danger btn-with-icon" ng-click="$fs.deleteNode($fs.selectedNode)"><i class="ion-ios-trash"></i><span translate="generalTerms.delete">L\xF6schen</span></button> <button class="btn btn-primary btn-with-icon" ng-click="$fs.saveTree()" ng-disabled="$fs.emptyError"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></ba-panel-footer></div>');
$templateCache.put('app/theme/components/fileUpload/fileUpload.html','<div><label>{{ (self.labelText ? self.labelText : \'components.fileUpload.attachedFile\') | translate:self.translateValues }}</label> <label ng-if="self.fileError" class="control-label has-error"><i class="fa fa-exclamation-triangle text-danger mr-3"></i> <span translate="components.fileUpload.uploadError"></span></label><div><div nv-file-drop="" uploadlogo="" data-upload-target="qualification-fileinput" :options="{alias: \'file\'}" uploader="self.uploader" class="col-9 well mb-10 arno-file-drop-area mt-10"><div ng-if="self.currentFileName"><b>{{self.currentFileName}}</b> {{\'components.fileUpload.dragOrChange\' | translate}}</div><div ng-if="!self.currentFileName"><span translate="components.fileUpload.uploadText"></span></div></div><input type="file" class="hidden" nv-file-select="" id="qualification-fileinput" :options="{alias: \'file\'}" uploader="self.uploader"> <button class="btn btn-default btn-sm btn-with-icon" type="button" uploadlogo="" data-upload-target="qualification-fileinput"><i class="ion-plus"></i><span class="ml-5" translate="components.fileUpload.uploadBtnText" translate-values="{ \'replace\': self.downloadableFile }"></span></button><button ng-if="self.showRemoveButton && self.currentFileName && self.downloadableFile !== self.currentFileName" class="btn btn-default btn-sm btn-with-icon" type="button" ng-click="self.removeFile()"><i class="fa fa-ban"></i><span class="ml-5" translate="components.fileUpload.doNotUploadFile"></span></button><button ng-if="self.downloadableFile && self.downloadableFile === self.currentFileName && self.canPreview() && self.onFilePreview" class="btn btn-default btn-sm btn-with-icon" type="button" ng-click="self.onFilePreview(self.downloadableFile)"><i class="fa fa-eye"></i><span>{{ \'generalTerms.view\' | translate}}</span></button><button ng-if="self.downloadableFile && self.downloadableFile === self.currentFileName && self.onFileDownload" class="btn btn-default btn-sm btn-with-icon" type="button" ng-click="self.onFileDownload(self.downloadableFile)"><i class="fa fa-download"></i><span>{{ self.downloadableFile }}</span></button><button ng-if="self.downloadableFile && self.downloadableFile === self.currentFileName && self.onFileDelete" class="btn btn-danger btn-sm btn-with-icon" type="button" ng-click="self.onFileDelete(); self.fileDeletePending = true;"><i class="fa fa-trash"></i><span>{{ \'generalTerms.delete\' | translate}}</span></button><button ng-if="!self.currentFileName && self.fileDeletePending" class="btn btn-danger btn-sm btn-with-icon" type="button" ng-click="self.onFileDelete(true); self.fileDeletePending = false;"><i class="fa fa-undo"></i><span>{{ \'generalTerms.dontDelete\' | translate}}</span></button></div></div>');
$templateCache.put('app/theme/components/financeProcessList/financeProcessList.html','<div><h5 ng-if="$ctrl.process.Title && !$ctrl.viewOnly" translate="modules.finances.processStepSelector.tableTitle" translate-values="{ title: $ctrl.process.Title }"></h5><table st-table="$ctrl.processSteps" st-set-filter="processCustomFilter" class="table table-condensed table-hover"><thead><tr class="sortable"><th>{{ \'modules.finances.processStepSelector.table.type\' | translate }}</th><th st-sort="CommonName">{{ \'modules.finances.processStepSelector.table.name\' | translate }}</th><th>{{ \'modules.finances.processStepSelector.table.phase\' | translate }}</th><th st-sort="Member.fullName">{{ \'modules.finances.processStepSelector.table.creator\' | translate }}</th><th st-sort="stepCreatedAt">{{ \'modules.finances.processStepSelector.table.createdAt\' | translate }}</th><th ng-if="$ctrl.canViewPrices" st-sort="FinalAmount">{{ \'models.Quotation.FinalAmount\' | translate }}</th><th></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="processTypeCustom" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="CommonName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="processFlowStateCustom" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Member.fullName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th ng-if="$ctrl.canViewPrices"></th><th></th></tr></thead><tbody><tr ng-repeat="step in $ctrl.processSteps"><td>{{ ($ctrl.typeMap[step.type] || step.type) | translate }}</td><td>{{ step.CommonName }}</td><td>{{ $ctrl.getFlowStateLabel(step) }}</td><td>{{ step.Member.fullName }}</td><td>{{ step.stepCreatedAt | date:\'dd.MM.yyyy HH:mm\' }}</td><td ng-if="$ctrl.canViewPrices">{{ (step.FinalAmount ? step.FinalAmount.toFixed(2) + \' \u20AC\' : \'-\') }}</td><td><div ng-if="!step.deleted" class="white-space-no-wrap"><button type="button" ng-if="!$ctrl.viewOnly" ng-click="$ctrl.select(step)" class="btn btn-success btn-with-icon btn-xs"><i class="fa fa-check"></i> <span translate="modules.finances.processStepSelector.table.select"></span></button> <button type="button" ng-if="$ctrl.isPermittedToView(step)" ng-click="$ctrl.openDetails(step)" class="btn btn-default btn-with-icon btn-xs"><i class="fa fa-eye"></i> <span translate="modules.finances.processStepSelector.table.details"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/theme/components/financialMaterialPicker/financialMaterialPicker.html','<div><div class="mb-10 d-flex"><div class="btn-group" uib-dropdown=""><button uib-dropdown-toggle="" type="button" class="btn btn-info btn-with-icon"><i class="fa fa-table"></i> <span translate="components.financialMaterialPicker.view"></span> <span class="caret ml-6 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-left"><li role="menuitem" ng-repeat="view in self.tableConfig"><a href="" ng-click="self.setMaterialView(view)">{{ view.Name }}</a></li></ul></div><div class="ml-8"><ba-switcher class="btn-height v-align-top" ng-show="self.uiConfig.showOnlyWithPricesSwitcher" switcher-style="primary" switcher-value="self.filterWithPrices" switcher-width="130" switcher-keys="self.onlyWithPricesKeys" switcher-hints="self.onlyWithPricesHints"></ba-switcher></div><div class="ml-8"><ba-switcher class="btn-height v-align-top" ng-show="self.uiConfig.showOnlyMissingPricesSwitcher" switcher-style="primary" switcher-value="self.filterMissingPrices" switcher-width="130" switcher-keys="self.onlyMissingPricesKeys" switcher-hints="self.onlyMissingPricesHints"></ba-switcher></div></div><div class="table-responsive"><table st-table="self.matData" st-pipe="self.reloadMaterial" st-safe-src="self.tableData" class="table table-condensed table-hover arno-aggregatable-table"><thead><tr class="sortable"><th class="arno-table-button-cell force-minimal">{{ \'generalTerms.actions\' | translate }}</th><th st-sort="\'Amount\'" class="force-minimal">{{ \'components.financialMaterialPicker.count\' | translate }}</th><th></th><th st-sort="{{ header.prop }}" ng-repeat="header in self.materialMeta.columns[self.materialModel]" ng-if="!self.tableState.view || self.tableState.view.Fields.indexOf(header.prop) !== -1" ng-class="{aggregatable: self.checkAggExcludes(header.prop) && self.allowAggregation != false}"><span>{{ header.label | translate }}</span> <button ng-if="self.checkAggExcludes(header.prop) && self.allowAggregation != false" title="{{ header.label | translate }} aggregieren" class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-class="{active: self.isIn(self.tableState.agg, header.prop)}" ng-click="self.toggleMaterialAggregate($event, header.prop)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th ng-if="self.isMultiDiv" st-sort="Division.Name" class="aggregatable"><span translate="generalTerms.division"></span> <button ng-if="self.checkAggExcludes(header.prop) && self.allowAggregation != false" title="Gliederung aggregieren" class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-class="{active: self.isIn(self.tableState.agg, \'Division.Name\')}" ng-click="self.toggleMaterialAggregate($event, \'Division.Name\')"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th></tr><tr><th></th><th></th><th></th><th ng-repeat="header in self.materialMeta.columns[self.materialModel]" ng-if="!self.tableState.view || self.tableState.view.Fields.indexOf(header.prop) !== -1"><div class="input-group" ng-if="self.searchableCheck(header)"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="{{ header.prop }}" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="self.isMultiDiv"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="self.matData && self.matData.length" ng-repeat="material in self.matData track by $index"><td><div class="row-actions pull-right"><button class="btn btn-default btn-xs no-animation" ng-click="self.selectMaterials(material)"><i class="{{ self.uiConfig.chooseBtnIcon }} mr-4" ng-class="{ \'fa fa-check\': !self.uiConfig.chooseBtnIcon }"></i> {{ (self.uiConfig.chooseBtnLabel || \'components.financialMaterialPicker.choose\') | translate }}</button> <button ng-if="self.uiConfig.showRemovePricesBtn == true" class="btn btn-danger btn-xs no-animation" ng-disabled="!self.hasPriceDefinition(material)" ng-click="self.removePricesBtnClicked(material)"><i class="{{ self.uiConfig.removePricesBtnIcon }} mr-4" ng-class="{ \'fa fa-trash\': !self.uiConfig.removePricesBtnIcon }"></i> {{ (self.uiConfig.removePricesBtnLabel || \'components.financialMaterialPicker.removePrices\') | translate }}</button></div></td><td class="align-left-force text-overflow overflow-title"><span>{{ material.Amount || \'0\' }}</span></td><td><i ng-show="self.hasPriceDefinition(material)" class="af af-finance-coins mx-4" title="{{ ::(\'components.financialMaterialPicker.hasPriceDefinitionTooltip\' | translate) }}"></i></td><td ng-repeat="header in self.materialMeta.columns[self.materialModel]" ng-if="!self.tableState.view || self.tableState.view.Fields.indexOf(header.prop) !== -1" class="align-left-force text-overflow overflow-title"><div ng-if="header.prop !== \'Storage\' && header.prop !== \'ResponsibleMember\'"><span ng-if="!self.currentPropSet[header.prop] || (self.currentPropSet[header.prop] && self.currentPropSet[header.prop].type !== \'date\' && self.currentPropSet[header.prop].type !== \'bool\')">{{ (material[header.prop] === false ? (\'generalTerms.no\' | translate) : material[header.prop] === true ? (\'generalTerms.yes\' | translate) : self.applyFieldConfig(self.currentPropSet, material[header.prop], header.prop)) || \'-\'}}</span> <span ng-if="self.currentPropSet[header.prop] && self.currentPropSet[header.prop].type === \'date\'">{{ self.parseDate(material[header.prop]) || \'-\' | date:\'dd.MM.yyyy\'}}</span> <span ng-if="self.currentPropSet[header.prop] && self.currentPropSet[header.prop].type === \'bool\'">{{ self.boolFormatter(material[header.prop]) || \'-\' }}</span></div><ul ng-if="header.prop === \'ResponsibleMember\' && material[header.prop]"><li ng-repeat="member in material[header.prop].split(\', \')" ng-class="{\'member-inactive\': (member.indexOf(\'(inaktiv)\') > -1)}">{{ member }}</li></ul><div ng-if="header.prop === \'Storage\'"><span class="arno-tag arno-storage-tag tag label label-tag label-info" ng-repeat="storage in material.StorageTags" ng-if="material.StorageTags && material.StorageTags.length">{{ storage.label }}</span> <span ng-if="!material.StorageTags || !material.StorageTags.length">{{ material[header.prop] }}</span></div></td><td ng-if="self.isMultiDiv" class="align-left-force"><span>{{ material[\'Division.Name\'] }}</span></td></tr><tr ng-if="!self.matData || !self.matData.length"><td class="text-center" colspan="99"><i translate="components.financialMaterialPicker.emptyList"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="p-0"><div class="d-flex align-items-center justify-content-center mt-8"><st-pagination st-items-by-page="self.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/theme/components/flowBar/flowBar.html','<div><table class="table flow-step-indicator-bar"><tr><td ng-repeat="step in $flow.flow.steps | filter:$flow.stepFilter" class="text-center p-0 flow-step" ng-click="!$flow.viewOnly && !($flow.mediaSizeXS || $flow.mediaSizeSM) && $flow.stepChange($index)" ng-class="[ {\'arno-pointing-pointer\': !$flow.viewOnly && ($flow.availableStepChanges.indexOf(step) !== -1 || ($flow.flow.steps.indexOf(step) === $flow.flow.lastSavedStep && $flow.flow.lastSavedStep !== $flow.flow.activeStep))}, $flow.flow.steps.indexOf(step) <= $flow.flow.lastSavedStep ? (\'bg-\' + step.activeClass) : \'bg-light-gray\', $flow.flow.steps.indexOf(step) < $flow.flow.lastSavedStep ? \'progress-bar-striped\' : \'\' ]" ng-style="{width: (100/$flow.flow.steps.length) + \'%\'}"><div class="flow-step-inner py-5" ng-class="{\'active\': $flow.flow.activeStep !== $flow.flow.lastSavedStep && $flow.flow.activeStep === $flow.flow.steps.indexOf(step)}">{{::step.label}}</div></td></tr></table><button type="button" class="btn btn-default btn-sm btn-with-icon mt-5 no-animation" ng-if="!$flow.viewOnly && $flow.flow.activeStep === $flow.flow.lastSavedStep && $flow.availableStepChanges.length" ng-click="$flow.stepChange()"><i class="fa fa-sliders"></i> {{\'modules.events.flowbar.ChangePhaseTitle\' | translate:{var: $flow.flowLabel} }}</button> <button type="button" class="btn btn-danger btn-sm btn-with-icon mt-5 no-animation" ng-if="!$flow.viewOnly && $flow.flow.activeStep !== $flow.flow.lastSavedStep" ng-click="$flow.stepChange()"><i class="fa fa-times"></i> {{ \'modules.events.flowbar.phaseChange\' | translate:{var: ($flow.flow.steps[$flow.flow.activeStep].label)} }}</button></div>');
$templateCache.put('app/theme/components/historyDisplay/historyDisplay.tpl.html','<div class="row"><div class="col-md-12"><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm">Ereignisse pro Seite</span> ({{ $ctrl.historyTableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.historyTableConfig.pageSize = i">{{ i }}</a></li></ul></div></div></div><div class="col-md-12"><div class="table-responsive"><table st-table="$ctrl.historyCollection" st-pipe="$ctrl.getHistoryData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Type">Ereignis</th><th>Beschreibung</th><th st-sort="createdAt" st-sort-default="reverse">Zeitpunkt</th><th>Ausl\xF6ser</th><th ng-if="$ctrl.isOrg">Gliederung</th></tr></thead><tbody><tr ng-repeat="history in $ctrl.historyCollection.data"><td class="align-left-force"><span>{{ ::$ctrl.historyEventMap[history.Type].label || history.Type }}</span></td><td class="align-left-force"><span history-data-mapper="{{::history.Type}}"></span></td><td class="align-left-force"><span>{{ ::history.createdAt | date : \'dd.MM.yyyy - HH:mm:ss\' }}</span></td><td class="align-left-force"><span>{{ ::history.TriggeringMember }}</span></td><td class="align-left-force" ng-if="$ctrl.isOrg"><span>{{ ::history.Division }}</span></td></tr><tr ng-if="$ctrl.historyCollection.data && $ctrl.historyCollection.data.length === 0"><td class="text-center" colspan="{{$ctrl.isOrg ? 5 : 4}}"><i>Keine Historieneintr\xE4ge verzeichnet.</i></td></tr></tbody><tfoot ng-if="$ctrl.historyCollection.data || $ctrl.historyCollection.data.length > 0"><tr><td colspan="{{$ctrl.isOrg ? 5 : 4}}" class="text-center"><st-pagination st-items-by-page="$ctrl.historyTableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/theme/components/inspectionSelector/inspectionSelector.html','<div class="member-selector"><div ng-if="!self.multiple" class="input-group"><ui-select ng-disabled="self.disabled" ng-model="self.selectedInspection" append-to-body="false" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="true"><ui-select-match placeholder="{{ \'components.inspectionSelector.searchInspection\' | translate }}">{{ self.selectedInspection.Name }}</ui-select-match><ui-select-choices position="down" repeat="inspection in self.inspections" class="modal-fs-input" refresh="self.fetchInspections($select.search)" refresh-delay="200" ui-disable-choice="!inspection.id"><div ng-if="!inspection.none" class="btn-with-icon"><span>{{ inspection.Name }}</span></div><div ng-if="inspection.none" class="btn-with-icon"><i class="fa fa-times"></i> <span><i>{{ \'components.inspectionSelector.noInspectionFound\' | translate }}</i></span></div></ui-select-choices></ui-select></div><div ng-if="self.multiple" class="input-group input-group-with-select"><ui-select multiple="" ng-model="self.selectedInspection" search-enabled="true" append-to-body="false" ng-disabled="self.disabled" class="form-control arno-roleselect"><ui-select-match placeholder="{{ \'components.inspectionSelector.searchInspection\' | translate }}"><span>{{ $item.Name }}</span></ui-select-match><ui-select-choices position="down" repeat="inspection in self.inspections" class="modal-fs-input" refresh="self.fetchInspections($select.search)" refresh-delay="200" ui-disable-choice="!inspection.id"><div ng-if="!inspection.none" class="btn-with-icon"><span>{{ inspection.Name }}</span></div><div ng-if="inspection.none" class="btn-with-icon"><i class="fa fa-times"></i> <span><i>{{ \'components.inspectionSelector.noInspectionFound\' | translate }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="self.disabled || !self.selectedInspection.length" ng-click="self.selectedInspection = undefined" class="btn btn-danger ion-ios-trash"></button></span></div></div>');
$templateCache.put('app/theme/components/invoiceExportMailInput/invoiceExportMailInput.html','<div class="row"><div class="col-md-12"><div class="alert bg-info"><h4 translate="modules.administration.finances.general.exportHintTitle"></h4><p translate="modules.administration.finances.general.exportHint"></p></div></div><div class="col-md-12"><div class="input-group dropdown input-group-addon-button"><input type="text" ng-model="self.invoiceExportMailPrefix" class="form-control"> <span uib-dropdown=""><button id="suffix-btn" type="button" class="btn dropdown-toggle btn-dropdown-addon" uib-dropdown-toggle=""><span>{{ (self.invoiceExportMailSuffix ? \'@\' + self.invoiceExportMailSuffix : (\'modules.administration.finances.general.pickSuffix\' | translate)) }}</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu"><li role="menuitem" ng-repeat="suffix in self.invoiceExportSuffixes" ng-click="self.invoiceExportMailSuffix = suffix"><a href="">{{ \'@\' + suffix }}</a></li></ul></span></div></div></div><div class="row mt-20"><div class="col-md-12"><button type="submit" ng-disabled="!self.fullInvoiceExportEmail" ng-click="self.saveRecipientMail()" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button> <button type="submit" ng-disabled="!self.fullInvoiceExportEmail" ng-click="self.saveRecipientMail(true)" class="btn btn-default btn-with-icon"><i class="fa fa-clone"></i><span translate="modules.administration.finances.general.copyToSubDiv"></span></button> <button type="submit" ng-disabled="!self.hasDbVal" ng-click="self.saveRecipientMail(false, true)" class="btn btn-danger btn-with-icon"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></div>');
$templateCache.put('app/theme/components/materialTypesPricesTreeview/materialTypesPricesTreeview.comp.html','<div class="arno__material-types-prices__treeview__wrapper"><arno-ba-treeview tree-nodes-data="$materialTypesPricesTreeviewCtrl.materialTypesTreeData" selected-node="$materialTypesPricesTreeviewCtrl.selectedNode" node-select="$materialTypesPricesTreeviewCtrl.nodeSelect" has-error="$materialTypesPricesTreeviewCtrl.hasError"><arno-ba-treeview-content><div ng-if="!$materialTypesPricesTreeviewCtrl.materialTypesTreeData.length && !$materialTypesPricesTreeviewCtrl.isLoading" class="text-center mt-40 mb-40"><span ng-show="!$materialTypesPricesTreeviewCtrl.materialTypesStatusFilter.length" translate="components.materialTypesTreeView.noMaterialTypesPlaceholder"></span> <span ng-show="$materialTypesPricesTreeviewCtrl.materialTypesStatusFilter.length" translate="components.materialTypesTreeView.noSuitableMaterialTypesPlaceholder"></span></div><div ng-if="!$materialTypesPricesTreeviewCtrl.isLoading"><script type="text/ng-template" id="nodesRenderer.tpl.html"><div class="node-embed" ui-tree-handle ng-click="$baTreeviewCtrl.selectNodeHandler(node, this)" ng-class="{\'node-active\': node.isSelected || $baTreeviewCtrl.selectedNode.id === node.id, matched: node.matched}" ng-show="$baTreeviewCtrl.visible(node)" > <a ng-if="node.children.length" class="btn btn-clear btn-xs" ng-click="$baTreeviewCtrl.expandNodeHandler(this, $event)" > <i class="fa" ng-class="{\'fa-chevron-right\': collapsed, \'fa-chevron-down\': !collapsed}"></i> </a> <div ng-class="{inline: node.children.length}"> <span class="ba-treeview-node-icon {{node.iconCls}} color-primary"></span> <span class="ba-treeview-node-icon {{node.iconSecondaryCls}}"></span> <span class="ba-treeview-node-label {{node.labelCls}}" ng-bind="node.label"></span> <div ng-switch="$materialTypesPricesTreeviewCtrl.hasPriceDefinition(node.model)" class="inline pull-right arno__ba-treeview__panel__item__buttons__right" > <a ng-switch-when="false" acl-grant="\'arno.administration.finances.prices\'" ng-click="$materialTypesPricesTreeviewCtrl.clickedMaterialTypeItemAdd(node, $event)" translate-attr="{title : $materialTypesPricesTreeviewCtrl.uiConfig.addBtnLabel}" class="btn btn-clear btn-xs mr-10" > <i class="af af-finance-add arno__ba-treeview__panel__item__buttons__right__icon"></i> </a> <a ng-switch-when="true" acl-grant="\'arno.administration.finances.prices\'" ng-click="$materialTypesPricesTreeviewCtrl.clickedMaterialTypeItemEdit(node, $event)" translate-attr="{title : $materialTypesPricesTreeviewCtrl.uiConfig.editBtnLabel}" class="btn btn-clear btn-xs mr-10 ml-12" > <i class="af af-finance-edit arno__ba-treeview__panel__item__buttons__right__icon"></i> </a> </div> </div> </div> <ol ui-tree-nodes="options" ng-model="node.children" ng-class="{hidden: collapsed, displayed: !collapsed}"> <li ng-repeat="node in node.children" ui-tree-node ng-class="{\'ml-25\' : !node.children.length}" class="{{::node.id}}" collapsed="$baTreeviewCtrl.treeviewCollapsed" ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div ui-tree="" data-drag-enabled="false" ng-show="$materialTypesPricesTreeviewCtrl.materialTypesTreeData.length"><ol id="ba-treeview-root" ng-class="{hidden: collapsed, displayed: !collapsed}" ui-tree-nodes="" ng-model="$materialTypesPricesTreeviewCtrl.materialTypesTreeData"><li ng-repeat="node in $materialTypesPricesTreeviewCtrl.materialTypesTreeData" collapsed="$baTreeviewCtrl.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'" onload="$baTreeviewCtrl = $parent.$parent.$parent.$parent.$parent[\'$baTreeviewCtrl\']"></li></ol></div></div></arno-ba-treeview-content></arno-ba-treeview></div>');
$templateCache.put('app/theme/components/materialTypesTreeView/materialTypesTreeView.comp.html','<div><div class="padded-container control-side"><button type="button" class="btn btn-default btn-sm btn-with-icon" ng-click="$materialTypesTreeViewCtrl.toggleCollapsed()"><i ng-class="{\'ion-chevron-up\': !$materialTypesTreeViewCtrl.treeviewCollapsed, \'ion-chevron-down\': $materialTypesTreeViewCtrl.treeviewCollapsed }"></i> <span class="hidden-xs"><span translate="components.treeView.collapseBtnText" translate-values="{ collapse: !$materialTypesTreeViewCtrl.treeviewCollapsed }"></span></span></button><div ng-transclude="top-buttons" class="pull-right"></div></div><div><script type="text/ng-template" id="nodesRenderer.tpl.html"><div ui-tree-handle ng-click="$materialTypesTreeViewCtrl.onSelectNode(node)" class="node-embed" ng-class="{\'node-active\': $materialTypesTreeViewCtrl.selectedMaterialType.id === node.id}"> <a ng-if="node.children.length" class="btn btn-clear btn-xs division-chevron"> <i class="fa" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}" ng-click="node.collapsed = !node.collapsed"></i> </a> <div ng-class="{\'inline-block\': node.children.length, \'ml-30\' : !node.children.length}"> <div class="ba-treeview-node-icon" ng-class="::$materialTypesTreeViewCtrl.getIcon(node)"></div> <span class="ba-treeview-node-label" ng-bind="node.id[0] === \'n\' ? node.Name + \' *\' : node.Name"></span> </div> </div> <ol ui-tree-nodes="options" class="ml-6" ng-class="{hidden: node.collapsed, displayed: !node.collapsed}" ng-model="node.children"> <li ng-repeat="node in node.children" ui-tree-node ng-include="\'nodesRenderer.tpl.html\'"></li> </ol></script><div ng-show="$materialTypesTreeViewCtrl.materialTypesTreeData.length > 0" class="padded-container"><div class="division-tree" ui-tree="$materialTypesTreeViewCtrl.treeOptions" data-drag-delay="200"><ol ui-tree-nodes="" ng-model="$materialTypesTreeViewCtrl.materialTypesTreeData"><li ng-repeat="node in $materialTypesTreeViewCtrl.materialTypesTreeData" collapsed="$materialTypesTreeViewCtrl.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div><div ng-show="$materialTypesTreeViewCtrl.materialTypesTreeData.length <= 0" class="padded-container" translate="modules.administration.material.materialTypes.noMaterialTypes">Keine Materialtypen gefunden. Erstelle einen neuen Materialtypen, um die Bearbeitung zu beginnen.</div></div></div><div ng-transclude="bottom-buttons"></div>');
$templateCache.put('app/theme/components/memberGroupSelector/memberGroupSelector.html','<div class="member-group-selector"><ui-select ng-model="$memGrpSelCtrl.selectedMemberGroup" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="true"><ui-select-match placeholder="{{ \'components.memberGroupSelector.searchPH\' | translate }}">{{ ($memGrpSelCtrl.selectedMemberGroup.Name + \' (\' + $memGrpSelCtrl.selectedMemberGroup.Division.Name + \')\') }}</ui-select-match><ui-select-choices position="down" repeat="group in $memGrpSelCtrl.groups" refresh="$memGrpSelCtrl.searchGroups($select.search)" refresh-delay="200"><div ng-if="!group.none && !group.exists" class="btn-with-icon"><i class="ion-person-stalker"></i> <span>{{ (group.Name + \' (\' + group.Division.Name + \')\') }}</span></div><div ng-if="group.none" class="btn-with-icon"><i class="fa fa-times"></i><span><i translate="components.memberGroupSelector.noneFound"></i></span></div><div ng-if="group.exists" class="btn-with-icon"><i class="fa fa-check"></i><span><i translate="components.memberGroupSelector.alreadySelected" translate-values="{ groupName: group.name }"></i></span></div></ui-select-choices></ui-select></div>');
$templateCache.put('app/theme/components/memberSelector/memberSelector.html','<div class="member-selector"><div class="input-group"><ui-select ng-model="$memSelCtrl.selectedMember" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="true" ng-disabled="$memSelCtrl.disabled"><ui-select-match placeholder="{{ \'components.memberSelector.searchMember\' | translate }}">{{ $memSelCtrl.selectedMember.Member.fullName + \' (\' + $memSelCtrl.selectedMember.Member.Account.EMail + \')\' }}</ui-select-match><ui-select-choices position="down" repeat="member in $memSelCtrl.members" refresh="$memSelCtrl.searchMembers($select.search)" refresh-delay="200" group-by="$memSelCtrl.groupByFirstName"><div ng-if="!member.none" class="btn-with-icon"><i class="fa fa-user"></i> <span>{{ member.Member.fullName + \' (\' + member.Member.Account.EMail + \')\' }}</span></div><div ng-if="member.none" class="btn-with-icon"><i class="fa fa-times"></i> <span><i>{{ \'components.memberSelector.noUserFound\' | translate }}</i></span></div></ui-select-choices></ui-select><span ng-if="$memSelCtrl.enableDelete" class="input-group-btn"><button type="button" ng-disabled="!$memSelCtrl.selectedMember || $memSelCtrl.disabled" ng-click="$memSelCtrl.selectedMember = { none: true }" class="btn btn-danger ion-ios-trash"></button></span></div></div>');
$templateCache.put('app/theme/components/modals/messageModal.tpl.html','<div class="modal-content"><div ng-if="$baModalCtrl.title" class="modal-header" ng-class="{ \'arno-default-text\': $baModalCtrl.modalType === \'default\', \'bg-info\': $baModalCtrl.modalType === \'info\', \'bg-success\': $baModalCtrl.modalType === \'success\', \'bg-warning\': $baModalCtrl.modalType === \'warning\', \'bg-danger\': $baModalCtrl.modalType === \'danger\' }"><h4><span ng-if="::!$baModalCtrl.allowHtml" ng-bind="$baModalCtrl.title"></span> <span ng-if="::$baModalCtrl.allowHtml" ng-bind-html="$baModalCtrl.title"></span> <i class="fa fa-times arno-pointing-pointer pull-right" ng-click="$baModalCtrl.clickedClose()"></i></h4></div><div class="modal-body"><div class="text-center"><div class="white-space-pre-line" ng-if="!$baModalCtrl.allowHtml" ng-bind="$baModalCtrl.content"></div><div ng-if="$baModalCtrl.allowHtml" ng-bind-html="$baModalCtrl.content"></div><div ng-if="$baModalCtrl.selectionOptions" class="mt-10"><select class="form-control" ng-model="$baModalCtrl.selectedOption" ng-options="option.label for option in $baModalCtrl.selectionOptions"></select></div><div ng-if="$baModalCtrl.textInput" class="mt-10"><input type="text" class="form-control" ng-model="$baModalCtrl.textInputValue" placeholder="{{$baModalCtrl.textInput !== true ? $baModalCtrl.textInput : \'\'}}"></div></div></div><div ng-if="$baModalCtrl.primaryActionText || $baModalCtrl.secondaryActionText" class="modal-footer"><button type="button" ng-if="$baModalCtrl.secondaryActionText" class="btn btn-default" ng-click="$baModalCtrl.clickedSecondaryAction()"><span ng-if="::!$baModalCtrl.allowHtml" ng-bind="$baModalCtrl.secondaryActionText"></span> <span ng-if="::$baModalCtrl.allowHtml" ng-bind-html="$baModalCtrl.secondaryActionText"></span></button> <button type="button" ng-if="$baModalCtrl.primaryActionText" ng-disabled="$baModalCtrl.selectionOptions && !$baModalCtrl.selectedOption" class="btn" ng-click="$baModalCtrl.clickedPrimaryAction()" ng-class="{ \'btn-default\': $baModalCtrl.modalType === \'default\', \'btn-info\': $baModalCtrl.modalType === \'info\', \'btn-success\': $baModalCtrl.modalType === \'success\', \'btn-warning\': $baModalCtrl.modalType === \'warning\', \'btn-danger\': $baModalCtrl.modalType === \'danger\' }"><span ng-if="::!$baModalCtrl.allowHtml" ng-bind="$baModalCtrl.primaryActionText"></span> <span ng-if="::$baModalCtrl.allowHtml" ng-bind-html="$baModalCtrl.primaryActionText"></span></button></div></div>');
$templateCache.put('app/theme/components/pageTop/arno-logo.svg.html','<svg viewbox="0 0 87 87" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Group" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)"><path d="M84.822,67.777 C84.822,77.014 77.336,84.5 68.102,84.5 L17.126,84.5 C7.89,84.5 0.404,77.014 0.404,67.777 L0.404,16.803 C0.404,7.568 7.89,0.081 17.126,0.081 L68.102,0.081 C77.336,0.081 84.822,7.568 84.822,16.803 L84.822,67.777" id="Fill-11" fill="{{colors.logoBg}}" sketch:type="MSShapeGroup"></path><path d="M84.822,67.777 C84.822,77.014 77.336,84.5 68.102,84.5 L17.126,84.5 C7.89,84.5 0.404,77.014 0.404,67.777 L0.404,16.803 C0.404,7.568 7.89,0.081 17.126,0.081 L68.102,0.081 C77.336,0.081 84.822,7.568 84.822,16.803 L84.822,67.777 L84.822,67.777 Z" id="Stroke-12" stroke="{{colors.stroke}}" sketch:type="MSShapeGroup"></path><path d="M33.368,28.926 L25.64,10.134 C25.464,9.702 25.296,9.222 25.136,8.694 C24.992,9.222 24.824,9.702 24.632,10.134 L16.904,28.926 L33.368,28.926 L33.368,28.926 Z M39.752,41.022 L38.72,41.022 C38.479,41.022 38.304,40.886 38.192,40.614 L33.8,29.934 L16.472,29.934 L12.08,40.614 C12,40.886 11.816,41.022 11.528,41.022 L10.544,41.022 L24.513,7.278 L25.784,7.278 L39.752,41.022 L39.752,41.022 Z" id="Fill-14" fill="{{colors.primary}}" sketch:type="MSShapeGroup"></path><path d="M49.256,24.126 L55.688,24.126 C57.271,24.126 58.699,23.938 59.971,23.562 C61.244,23.186 62.324,22.642 63.211,21.93 C64.1,21.218 64.779,20.358 65.252,19.35 C65.723,18.342 65.959,17.206 65.959,15.942 C65.959,13.334 65.111,11.414 63.416,10.182 C61.719,8.95 59.271,8.334 56.071,8.334 L49.256,8.334 L49.256,24.126 L49.256,24.126 Z M70.328,41.022 L69.248,41.022 C69.07,41.022 68.914,40.998 68.779,40.95 C68.643,40.902 68.512,40.79 68.383,40.614 L56.479,26.046 C56.352,25.87 56.219,25.726 56.084,25.614 C55.947,25.502 55.795,25.41 55.627,25.338 C55.459,25.266 55.26,25.214 55.027,25.182 C54.795,25.15 54.512,25.134 54.176,25.134 L49.256,25.134 L49.256,41.022 L47.936,41.022 L47.936,7.278 L56.071,7.278 C59.734,7.278 62.52,7.99 64.424,9.414 C66.326,10.838 67.279,12.998 67.279,15.894 C67.279,17.222 67.031,18.426 66.535,19.506 C66.039,20.586 65.344,21.522 64.447,22.314 C63.551,23.106 62.463,23.738 61.184,24.21 C59.902,24.682 58.487,24.966 56.936,25.062 C57.224,25.222 57.504,25.462 57.775,25.782 L70.328,41.022 L70.328,41.022 Z" id="Fill-15" fill="{{colors.primary}}" sketch:type="MSShapeGroup"></path><path d="M59.134,48.421 C58.884,48.359 58.623,48.325 58.354,48.325 C56.551,48.325 55.089,49.752 55.089,51.516 C55.089,53.278 56.551,54.707 58.354,54.707 C58.623,54.707 58.884,54.671 59.134,54.611 L59.134,59.439 L76.384,59.439 C76.382,49.916 68.661,42.195 59.136,42.195 L59.134,42.195 L59.134,48.421" id="Fill-16" fill="{{colors.primary}}" sketch:type="MSShapeGroup"></path><path d="M70.155,59.437 C70.216,59.186 70.253,58.926 70.253,58.656 C70.253,56.853 68.821,55.391 67.058,55.391 C65.3,55.391 63.866,56.853 63.866,58.656 C63.866,58.926 63.903,59.186 63.964,59.437 L59.136,59.437 L59.136,76.688 C68.661,76.685 76.38,68.963 76.38,59.437 L70.155,59.437" id="Fill-17" fill="{{colors.puzzleRight}}" sketch:type="MSShapeGroup"></path><path d="M59.13,70.463 C59.38,70.521 59.642,70.559 59.91,70.559 C61.714,70.559 63.177,69.127 63.177,67.366 C63.177,65.604 61.714,64.175 59.91,64.175 C59.642,64.175 59.38,64.208 59.13,64.271 L59.13,59.441 L41.88,59.441 C41.882,68.967 49.604,76.685 59.13,76.685 L59.13,70.463" id="Fill-18" fill="{{colors.primary}}" sketch:type="MSShapeGroup"></path><path d="M48.111,59.439 C48.048,59.691 48.014,59.951 48.014,60.22 C48.014,62.024 49.442,63.487 51.206,63.487 C52.969,63.487 54.397,62.024 54.397,60.22 C54.397,59.951 54.361,59.691 54.302,59.439 L59.13,59.439 L59.13,42.188 C49.605,42.192 41.886,49.913 41.886,59.439 L48.111,59.439" id="Fill-19" fill="{{colors.puzzleLeft}}" sketch:type="MSShapeGroup"></path><path d="M59.157,59.441 L59.157,42.197 L59.146,42.197 L59.132,42.197 L59.132,48.421 C58.882,48.359 58.621,48.325 58.351,48.325 C56.549,48.325 55.085,49.754 55.085,51.518 C55.085,53.28 56.549,54.709 58.351,54.709 C58.621,54.709 58.882,54.673 59.132,54.613 L59.132,59.441 L59.157,59.441" id="Fill-20" fill="{{colors.primary}}" sketch:type="MSShapeGroup"></path><path d="M37.819,42.569 L37.819,76.313 L37.269,76.313 C37.06,76.313 36.884,76.216 36.739,76.025 L13.579,44.729 C13.595,44.873 13.608,45.021 13.616,45.173 C13.624,45.326 13.628,45.465 13.628,45.593 L13.628,76.313 L12.476,76.313 L12.476,42.569 L13.075,42.569 C13.204,42.569 13.308,42.589 13.388,42.628 C13.468,42.669 13.556,42.753 13.651,42.88 L36.716,74.057 C36.7,73.914 36.688,73.769 36.681,73.625 C36.671,73.481 36.667,73.345 36.667,73.216 L36.667,42.569 L37.819,42.569" id="Fill-22" fill="{{colors.secondary}}" sketch:type="MSShapeGroup"></path></g></g></svg>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><h1 class="al-title" data-cy="page-top-title" title="{{ translatedPageTitle }}">{{ translatedPageTitle }}</h1><div class="user-profile clearfix hidden-print"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link" data-cy="user-profile-avatar"><img ng-if="$root.ctx.currentUser" profile-picture="$root.ctx.currentUser"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li class="arno-info-data"><div data-cy="user-profile-list"><p>{{ ::$root.ctx.currentUser.fullName }}</p><p class="mt-5">{{ ::$root.ctx.currentUser.eMail }}</p></div></li><div class="arno-organization-list" data-cy="user-profile-org-list" ng-show="$root.ctx.organization.list.length > 1"><li><p class="mb-5" translate="pageTop.organizationChange"></p></li><li class="arno-org-chooser" ng-repeat="organization in $root.ctx.organization.list | orderBy:\'name\'"><a ng-show="!organization.current" class="arno-pointing-pointer" ng-click="!organization.current && $ctrl.switchUserOrganization($event, organization)"><i class="fa fa-refresh" ng-if="!organization.current"></i>{{organization.name}}</a></li></div><div class="user-language-selection" ng-if="availableLanguages && availableLanguages.length > 1"><li><p class="mb-5" translate="pageTop.switchLanguage"></p></li><li ng-repeat="langKey in availableLanguages"><a class="no-animation" ng-class="$ctrl.isActiveLanguage(langKey) ? \'active-language\' : \'selectable-language\'" ng-click="$ctrl.switchLanguage($event, langKey)"><i ng-if="$ctrl.isActiveLanguage(langKey)" class="fa fa-check"></i><div class="country-flag" style="background-image: url(\'../../assets/img/app/flags/{{ langKey }}.png\');"></div><span class="language-key-text" translate="{{ \'languages.\' + langKey }}"></span></a></li></div><li><a data-cy="page-top-profile" href="" ng-click="$ctrl.openDossier()"><i class="fa fa-user"></i>{{ "pageTop.user.profile" | translate }}</a></li><li><a data-cy="page-top-profile" href="" ng-click="$ctrl.openHelp()"><i class="fa fa-info"></i>{{ "pageTop.user.portalHelp" | translate }}</a></li><li><a data-cy="page-top-profile" href="" ui-sref="arno.legal.termsOfUse"><i class="fa fa-balance-scale"></i>{{ "generalTerms.terms" | translate }}</a></li><li><a data-cy="page-top-profile" href="" ui-sref="arno.legal.privacyStatement"><i class="fa fa-balance-scale"></i>{{ "pageTop.user.dataPrivacy" | translate }}</a></li><li><a href="" class="signout" ng-click="$ctrl.userLogout()"><i class="fa fa-power-off"></i>{{ "pageTop.user.logout" | translate }}</a></li></ul></div></div><button ng-if="$ctrl.isDashboard && !$ctrl.isArnoOrg && ($ctrl.isPermittedAnywhere(\'arno.events.service.view\') || $ctrl.isPermittedAnywhere(\'arno.events.basic.view\'))" title="{{ \'pageTop.allEvents\' | translate }}" class="btn btn-default btn-xs btn-with-icon mt-15 ml-10 hidden-xxs page-top-quick-action" ng-click="$ctrl.openAllEvents()" type="button"><i class="ion-calendar"></i> <span class="hidden-sm hidden-xs" translate="pageTop.allEvents"></span></button> <button ng-if="$ctrl.isDashboard && !$ctrl.isArnoOrg" title="{{ \'pageTop.personalData\' | translate }}" class="btn btn-default btn-xs btn-with-icon mt-15 ml-5 hidden-sm hidden-xs hidden-md page-top-quick-action" ng-click="$ctrl.openOwnBaseData()" type="button"><i class="ion-person"></i> <span class="hidden-sm hidden-xs" translate="pageTop.personalData"></span></button> <button ng-if="$ctrl.isDashboard && !$ctrl.isArnoOrg" title="{{ \'pageTop.helperHours\' | translate }}" class="btn btn-default btn-xs btn-with-icon mt-15 ml-5 hidden-xxs page-top-quick-action" ng-click="$ctrl.openOwnHelperHours()" type="button"><i class="ion-clock"></i> <span class="hidden-sm hidden-xs" translate="pageTop.helperHours"></span></button><div class="page-top-icon-bar hidden-print"><i class="fa ion-android-home" ng-click="$ctrl.goBigOrGoHome()" translate-attr="{ title: \'pageTop.iconList.home\' }"></i> <i class="fa fa-bell" ng-click="$ctrl.openOwnAdministration()" translate-attr="{ title: \'pageTop.iconList.pushnotifications\' }"></i> <i class="fa fa-user" ng-click="$ctrl.openDossier()" translate-attr="{ title: \'pageTop.iconList.profile\' }"></i> <i class="fa fa-info" ng-click="$ctrl.openHelp()" translate-attr="{ title: \'pageTop.iconList.help\' }"></i> <i class="fa fa-power-off" ng-click="$ctrl.userLogout()" translate-attr="{ title: \'pageTop.iconList.logout\' }"></i></div></div>');
$templateCache.put('app/theme/components/paging/paging.html','<nav class="arnoPaging" ng-if="pages.length >= 2"><ul class="pagination"><li ng-class="{disabled: currentPage == 1}"><a ng-click="selectPage(currentPage-1)" aria-label="Zur\xFCck"><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a></li><li ng-show="pages.indexOf(1) == -1"><a ng-click="selectPage(1)">1</a></li><li ng-show="pages.indexOf(2) == -1"><a ng-click="selectPage(pages[0])">...</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-show="pages.indexOf(numPages -1) == -1"><a ng-click="selectPage(pages[pages.length - 1])">...</a></li><li ng-show="pages.indexOf(numPages) == -1"><a ng-click="selectPage(numPages)">{{numPages}}</a></li><li ng-class="{disabled: currentPage == numPages}"><a ng-click="selectPage(currentPage+1)" aria-label="Weiter"><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a></li></ul></nav>');
$templateCache.put('app/theme/components/permissionPopover/permissionPopover.tpl.html','<div ng-mouseenter="$permissionPopoverCtrl.showIncludedPermissionsPopup = true" ng-mouseleave="$permissionPopoverCtrl.showIncludedPermissionsPopup = false" ng-mouseout="(!$permissionPopoverCtrl.permissionPopoverUseMouseout || ($permissionPopoverCtrl.showIncludedPermissionsPopup = false))"><span uib-popover-template="\'permissionPopoverContent.html\'" popover-class="arno-permission-popover" popover-placement="{{ ::$permissionPopoverCtrl.permissionPopoverPlacement }}" popover-is-open="$permissionPopoverCtrl.showIncludedPermissionsPopup === true" popover-trigger="none" popover-enable="$permissionPopoverCtrl.rolesPermissionData.includedPermsContent.Description.trim() !== \'\'" popover-append-to-body="{{ ::$permissionPopoverCtrl.permissionPopoverAppendToBody }}">{{ $permissionPopoverCtrl.permissionPopoverLabel }}</span><script type="text/ng-template" id="permissionPopoverContent.html"><div> <div> <!-- Permission is not aggregated, so just show description --> <div> <ul ng-if="$permissionPopoverCtrl.rolesPermissionData.includedPermsContent.Description || $permissionPopoverCtrl.rolesPermissionData.aggregatedDescription"> <li>Beschreibung:</li> <li><span ng-bind="$permissionPopoverCtrl.rolesPermissionData.includedPermsContent.Description || $permissionPopoverCtrl.rolesPermissionData.aggregatedDescription"></span></li> </ul> </div> <ul ng-if="$permissionPopoverCtrl.rolesPermissionData.isAggregated"> <li>Enthalten:</li> <!-- Permission is aggregated, show contained permission-names and the description on mouseenter --> <li ng-repeat="includedContent in $permissionPopoverCtrl.rolesPermissionData.includedPermsContent" ng-mouseenter="$permissionPopoverCtrl.showDescriptionsArray[includedContent.Name].showPopupDescription = true" ng-mouseleave="$permissionPopoverCtrl.showDescriptionsArray[includedContent.Name].showPopupDescription = false" > <div> <i class="fa fa-angle-down"></i> <span> <span ng-bind="::includedContent.Name"></span> </span> </div> <!-- description of contained permission --> <div ng-if="includedContent.Description && ($permissionPopoverCtrl.showDescriptionsArray[includedContent.Name].showPopupDescription || $permissionPopoverCtrl.permissionPopoverAlwaysDescription) && !$permissionPopoverCtrl.permissionPopoverForceHideDescriptions"> <div class="description-accordion" ng-class="{ \'animated fadeIn delay-1s\': !$permissionPopoverCtrl.permissionPopoverAlwaysDescription }"> <span class="small"><span ng-bind="::includedContent.Description"></span></span> </div> </div> </li> </ul> </div> <div></script></div>');
$templateCache.put('app/theme/components/pricesInput/pricesInput.comp.html','<ng-form name="pricesForm" novalidate="" class="arno-prices-input"><fieldset ng-model="$pricesInputCtrl.pricesSet" name="pricesSet" ng-model-options="{ debounce: 500, allowInvalid: true }" ng-disabled="$pricesInputCtrl.disabled" ui-validate="{ atLeastOneExternalPrice: \'$pricesInputCtrl.validatePrices()\' }" ui-validate-watch-collection="\'[ $pricesInputCtrl.priceItem.ExternalPricePerHour, $pricesInputCtrl.priceItem.ExternalPricePerDay, $pricesInputCtrl.priceItem.ExternalPricePerCount ]\'" class="row"><div class="col-xs-12 col-sm-4"><div class="row"><label class="col-xs-12" translate="controls.pricesInput.pricePerHourFieldLabel">Preis pro Stunde</label><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.externalPricePerHour.$invalid || $pricesInputCtrl.isExternalPricesInvalid(pricesForm)}"><label for="externalPricePerHour" class="control-label" translate="controls.pricesInput.externalPriceLabel">Extern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.ExternalPricePerHour" ng-model-options="{ allowInvalid: true, debounce: 250 }" class="form-control" name="externalPricePerHour"> <label ng-messages="pricesForm.externalPricePerHour.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.internalPricePerHour.$invalid}"><label for="internalPricePerHour" class="control-label" translate="controls.pricesInput.internalPriceLabel">Intern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.InternalPricePerHour" ng-model-options="{ debounce: 250 }" class="form-control" name="internalPricePerHour"> <label ng-messages="pricesForm.internalPricePerHour.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div></div></div><div class="col-xs-12 col-sm-4"><div class="row"><label class="col-xs-12" translate="controls.pricesInput.pricePerDayFieldLabel">Preis pro Tag</label><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.externalPricePerDay.$invalid || $pricesInputCtrl.isExternalPricesInvalid(pricesForm)}"><label for="externalPricePerDay" class="control-label" translate="controls.pricesInput.externalPriceLabel">Extern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.ExternalPricePerDay" ng-model-options="{ allowInvalid: true, debounce: 250 }" class="form-control" name="externalPricePerDay"> <label ng-messages="pricesForm.externalPricePerDay.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.internalPricePerDay.$invalid}"><label for="internalPricePerDay" class="control-label" translate="controls.pricesInput.internalPriceLabel">Intern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.InternalPricePerDay" ng-model-options="{ debounce: 250 }" class="form-control" name="internalPricePerDay"> <label ng-messages="pricesForm.internalPricePerDay.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div></div></div><div class="col-xs-12 col-sm-4"><div class="row"><label class="col-xs-12" translate="controls.pricesInput.pricePerCountFieldLabel">Preis pro Mengeneinheit</label><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.externalPricePerCount.$invalid || $pricesInputCtrl.isExternalPricesInvalid(pricesForm)}"><label for="externalPricePerCount" class="control-label" translate="controls.pricesInput.externalPriceLabel">Extern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.ExternalPricePerCount" ng-model-options="{ allowInvalid: true, debounce: 250 }" class="form-control" name="externalPricePerCount"> <label ng-messages="pricesForm.externalPricePerCount.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div><div class="col-xs-12"><div class="form-group mb-0" ng-class="{\'has-error\': pricesForm.internalPricePerCount.$invalid}"><label for="internalPricePerCount" class="control-label" translate="controls.pricesInput.internalPriceLabel">Intern</label> <input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$pricesInputCtrl.priceItem.InternalPricePerCount" ng-model-options="{ debounce: 250 }" class="form-control" name="internalPricePerCount"> <label ng-messages="pricesForm.internalPricePerCount.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="number" translate="controls.pricesInput.priceInvalidError"></span> <span ng-message="min" translate="controls.pricesInput.priceMinError"></span></label></div></div></div></div><div ng-if="pricesForm.$submitted && pricesForm.pricesSet.$invalid" class="col-xs-12 form-group has-error"><label ng-messages="pricesForm.$submitted && pricesForm.pricesSet.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="atLeastOneExternalPrice" translate="controls.pricesInput.priceFieldAtLeastOneExternalPriceError">Es muss mindestens ein externer Preis angegeben werden!</span></label></div></fieldset></ng-form>');
$templateCache.put('app/theme/components/qualificationList/qualificationList.html','<div class="arno-qualification-dossier arno-qualification-list"><div class="row mb-10" ng-show="$qualListCtrl.flatQualificationHierarchy && !$qualListCtrl.onlyView && $qualListCtrl.getShowElement(\'addQualification\') && $qualListCtrl.displayMemberQualMode"><div class="col-xs-12 {{$qualListCtrl.cssConfigs.addQualificationBottomBarClass}}"><button data-cy="components-qualificationlist-assign" type="button" class="btn btn-primary btn-with-icon" ng-disabled="!instructionMaterials" ng-click="$qualListCtrl.openMemberQualificationModal(null, true, \'qualification\')"><i class="ion-plus"></i> {{ instructionMaterials ? (\'modules.personnel.dossier.overview.qualificationList.assignBtnText\' | translate:$qualListCtrl.typeSettings.qualification.translations) : (\'modules.personnel.dossier.overview.qualificationList.loading\' | translate:$qualListCtrl.typeSettings.qualification.translations) }}</button> <button data-cy="components-qualificationlist-assign" type="button" class="btn btn-primary btn-with-icon" ng-disabled="!instructionMaterials" ng-click="$qualListCtrl.openMemberQualificationModal(null, true, \'instruction\')"><i class="ion-plus"></i> {{ instructionMaterials ? (\'modules.personnel.dossier.overview.qualificationList.assignBtnText\' | translate:$qualListCtrl.typeSettings.instruction.translations) : (\'modules.personnel.dossier.overview.qualificationList.loading\' | translate:$qualListCtrl.typeSettings.qualification.translations) }}</button></div></div><div class="horizontal-scroll" ng-show="$qualListCtrl.qualificationList.length || $qualListCtrl.alwaysShow"><div class="arno-qualification-section" ng-repeat="qualificationState in $qualListCtrl.qualificationStates"><h3 ng-if="qualificationState.showSectionHeader !== false" class="with-line" toggle-next="">{{qualificationState.title}}</h3><div class="horizontal-scroll"><div class="table-responsive"><table class="table table-condensed table-hover"><col width="15%"><col width="30%"><col width="8%"><col width="8%"><col width="10%"><thead><tr class="black-muted-bg"><th class="align-left-force hidden-xs" translate="modules.personnel.dossier.overview.qualificationList.group"></th><th class="align-left-force" translate="modules.personnel.dossier.overview.qualificationList.title"></th><th ng-if="$qualListCtrl.displayMemberQualMode" translate="modules.personnel.dossier.overview.qualificationList.referenceDate"></th><th ng-if="$qualListCtrl.displayMemberQualMode" translate="modules.personnel.dossier.overview.qualificationList.expireDate"></th><th ng-if="$qualListCtrl.displayMemberQualMode" translate="modules.personnel.dossier.overview.qualificationList.lastChange"></th><th ng-if="$qualListCtrl.displayMemberQualMode" translate="modules.personnel.dossier.overview.qualificationList.lastEditor"></th><th ng-if="::$qualListCtrl.getShowElement(\'actions\')" translate="generalTerms.actions"></th></tr></thead><tbody><tr ng-repeat="qualification in $qualListCtrl.qualificationList | filter: $qualListCtrl.filterByValidity(qualificationState.validity):true | groupBy:\'GroupName\' as filteredItems track by $index"><td ng-if="qualification.byGroupNewItem" class="hidden-xs" rowspan="{{qualification.byGroup.unchangedFor + 1}}"><span ng-if="!qualification.onlyInherited" class="mr-4" uib-tooltip="{{ $qualListCtrl.typeSettings[qualification.Type].translations.typeGroupSingular }}" tooltip-class="arno-tooltip" tooltip-placement="bottom" tooltip-append-to-body="true"><i ng-if="qualification.Type === \'qualification\'" class="ion-ribbon-b"></i> <i ng-if="qualification.Type === \'instruction\'" class="fa fa-cube"></i></span> {{qualification.GroupName}}</td><td class="align-left-force"><span ng-if="$qualListCtrl.displayMemberQualMode" class="mr-10"><status-light is-green="qualification.Valid" class="\'light-inline\'"></status-light></span> <span ng-if="$qualListCtrl.formattedQualificationGroups[qualification.GroupName]"><i ng-class="{\'ion-ios-people-outline\': !$qualListCtrl.qualificationInRootOrg(qualification), \'ion-ios-people\': $qualListCtrl.qualificationInRootOrg(qualification)}" title="{{$qualListCtrl.qualificationInRootOrg(qualification) ? \'Organisationsebene\' : \'Gliederungsebene\'}}"></i></span> <span ng-if="$qualListCtrl.displayMemberQualMode"><i class="ion-ribbon-b" ng-class="{\'arno-primary-text\':!qualification.onlyInherited || qualification.pendingAction === \'add\'}" title="{{(!qualification.onlyInherited || qualification.pendingAction === \'add\') ? \'Zugewiesene Qualifikation\' : \'Geerbte Qualifikation\'}}"></i></span> <span ng-if="$qualListCtrl.displayMemberQualMode && qualification.InitialInstructionByManufacturerOrAuthorizedPerson"><i class="fa fa-graduation-cap" title="{{qualification.Type === \'instruction\' ? (\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturer\' | translate) : qualification.Type === \'qualification\' ? (\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturerQual\' | translate) : \'\'}}"></i></span> <span ng-if="qualification.AssignedByExternalSystem"><i class="fa fa-exchange" title="{{ \'modules.personnel.dossier.overview.qualificationList.externalSystemTooltip\' | translate:{sys:qualification.AssignedByExternalSystem} }}"></i></span> {{qualification.QualificationName}}</td><td ng-if="$qualListCtrl.displayMemberQualMode">{{(qualification.AcquireDate | date : \'dd.MM.yyyy\' ) || ( \'modules.personnel.dossier.overview.never\' | translate ) }}</td><td ng-if="$qualListCtrl.displayMemberQualMode" ng-class="{\'arno-expired-date\': $qualListCtrl.checkExpired(qualification.ExpireDate) }">{{(qualification.ExpireDate | date : \'dd.MM.yyyy\' ) || ( \'modules.personnel.dossier.overview.never\' | translate ) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.overview.qualificationList.autoUpdateTooltip\' | translate )}}" ng-if="qualification.AutoUpdateValidity"></arno-ba-help-tooltip></td><td ng-if="$qualListCtrl.displayMemberQualMode" title="{{qualification.onlyInherited ? \'\' : qualification.LastEditedAt | date : \'dd.MM.yyyy HH:mm:ss\'}}"><span ng-hide="qualification.onlyInherited">{{qualification.LastEditedAt | date : \'dd.MM.yyyy\'}}</span></td><td ng-if="$qualListCtrl.displayMemberQualMode">{{(qualification.LastEditor) || qualification.AssignedByExternalSystem || \'System\'}}</td><td ng-if="::$qualListCtrl.getShowElement(\'actions\') && !$qualListCtrl.onlyView"><button class="btn btn-xs btn-default" ng-if="$qualListCtrl.displayMemberQualMode" ng-class="{\'btn-icon btn-xs-small-height\': $qualListCtrl.mediaSizeXs, \'btn-with-icon\': !$qualListCtrl.mediaSizeXs}" ng-click="$qualListCtrl.editQualification(qualification)"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit"></span></button><button ng-if="qualification.File" ng-click="$qualListCtrl.viewOrDownloadFile(qualification)" class="btn btn-xs btn-default" ng-class="{\'btn-icon btn-xs-small-height\': $qualListCtrl.mediaSizeXs, \'btn-with-icon\': !$qualListCtrl.mediaSizeXs}" title="{{(\'generalTerms.file\' | translate )}}"><span ng-if="$qualListCtrl.fileHasPreview(qualification.File)"><i class="fa fa-file-pdf-o"></i><span class="hidden-xs hidden-sm" translate="generalTerms.view"></span></span> <span ng-if="!$qualListCtrl.fileHasPreview(qualification.File)"><i class="fa fa-download"></i><span class="hidden-xs hidden-sm" translate="generalTerms.download"></span></span></button><button data-cy="components-qualificationlist-delete" class="btn btn-xs" type="button" ng-if="$qualListCtrl.displayKeepOrDeleteQualificationBtn(qualification)" ng-class="{\'btn-danger\':qualification.pendingAction !== \'delete\', \'btn-warning\': qualification.pendingAction === \'delete\', \'btn-icon btn-xs-small-height\': $qualListCtrl.mediaSizeXs, \'btn-with-icon\': !$qualListCtrl.mediaSizeXs}" ng-click="$qualListCtrl.onQualificationDelete(qualification)"><i ng-class="{\'ion-ios-trash\':qualification.pendingAction !== \'delete\', \'ion-plus-round\':qualification.pendingAction === \'delete\'}"></i> <span class="btn-span hidden-xs">{{qualification.pendingAction === \'delete\' ? ( \'modules.personnel.dossier.overview.qualificationList.maintain\' | translate ) : qualification.pendingAction === \'edit\' ? ( \'modules.personnel.dossier.overview.qualificationList.dontChange\' | translate ) : ( \'modules.personnel.dossier.overview.qualificationList.remove\' | translate )}}</span></button> <button type="button" class="btn btn-xs btn-danger" ng-if="$parent.qualificationAdd && qualification.pendingAction === \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $qualListCtrl.mediaSizeXs, \'btn-with-icon\': !$qualListCtrl.mediaSizeXs}" ng-click="$qualListCtrl.onQualificationPendingDelete(qualification)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.overview.qualificationList.dontAdd"></span></button></td><td ng-if="$qualListCtrl.onlyView && !$qualListCtrl.isOverviewTab"><button ng-if="qualification.File" ng-click="$qualListCtrl.viewOrDownloadFile(qualification)" class="btn btn-xs btn-default" ng-class="{\'btn-icon btn-xs-small-height\': $qualListCtrl.mediaSizeXs, \'btn-with-icon\': !$qualListCtrl.mediaSizeXs}" title="{{(\'generalTerms.file\' | translate )}}"><span ng-if="$qualListCtrl.fileHasPreview(qualification.File)"><i class="fa fa-file-pdf-o"></i><span class="hidden-xs hidden-sm" translate="generalTerms.view"></span></span> <span ng-if="!$qualListCtrl.fileHasPreview(qualification.File)"><i class="fa fa-download"></i><span class="hidden-xs hidden-sm" translate="generalTerms.download"></span></span></button></td></tr></tbody><tbody ng-show="!filteredItems.length || !$qualListCtrl.qualificationList"><tr><td colspan="99" class="text-center"><i translate="modules.personnel.dossier.overview.qualificationList.noEntriesPlaceholder" translate-values="{ entries: $qualListCtrl.translateValues.typePlural }"></i></td></tr></tbody></table></div></div></div></div><div class="row" ng-show="$qualListCtrl.flatQualificationHierarchy && !$qualListCtrl.onlyView && !$qualListCtrl.displayMemberQualMode && $qualListCtrl.getShowElement(\'addQualification\')"><div class="col-xs-12 {{$qualListCtrl.cssConfigs.addQualificationBottomBarClass}}"><div class="form-group list-form-add-new"><label translate="modules.personnel.dossier.overview.qualificationList.addQualificationsLabel" translate-values="$qualListCtrl.translateValues"></label><div class="input-group input-group-with-select input-group-with-btn-text"><ui-select ng-model="$qualListCtrl.qualificationToAdd" class="btn-group bootstrap-select form-control" append-to-body="!$qualListCtrl.isModalOpen()" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.searchPlaceholder\' | translate:$qualListCtrl.translateValues )}}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" repeat="qualificationChoice in $qualListCtrl.flatQualificationHierarchy | filter: {$: $select.search} | orderBy:[\'GroupName\',\'Name\']" group-by="\'GroupName\'"><i ng-class="{\'ion-ios-people\':!qualificationChoice.DivisionId,\'ion-ios-people-outline\':qualificationChoice.DivisionId}"></i> <span>{{ qualificationChoice.Name }}</span></ui-select-choices></ui-select><span class="input-group-btn ui-select-fixed-button-position"><button type="button" class="btn btn-success" ng-click="$qualListCtrl.qualificationAdd($qualListCtrl.qualificationToAdd)" ng-disabled="!$qualListCtrl.qualificationToAdd"><i class="ion-plus-round"></i> {{ (\'generalTerms.add\' | translate) }}</button></span></div></div></div></div></div>');
$templateCache.put('app/theme/components/serviceAttendanceInterestList/serviceAttendanceInterestList.html','<div><div class="table-responsive"><table class="table table-condensed table-hover"><thead ng-if="$svcIntCtrl.openServiceAttendeeInterest.length"><tr><th class="col-xs-4" translate="models.Service">Dienst</th><th class="col-xs-4" translate="components.serviceInterest.origin">Ursprung</th><th class="col-xs-4 pl-15" translate="generalTerms.actions">Aktionen</th></tr></thead><tbody ng-class="{\'without-top-border\': !$svcIntCtrl.openServiceAttendeeInterest.length}"><tr ng-repeat="service in $svcIntCtrl.openServiceAttendeeInterest"><td>{{ ::service.Subject }}</td><td>{{ ::service.SourceDivision.Name }}</td><td class="force-minimal pl-15"><button class="btn btn-info btn-with-icon btn-xs" ng-click="$svcIntCtrl.openServiceDetails(service)" title="Teilnehmer pr\xFCfen"><i class="glyphicon glyphicon-calendar"></i><span class="hidden-xs" translate="components.serviceInterest.checkParticipants">Teilnehmer pr\xFCfen</span></button></td></tr><tr ng-if="!$svcIntCtrl.openServiceAttendeeInterest.length"><td colspan="99" class="text-center"><i translate="components.serviceInterest.noReports">Keine Interessensmeldungen ausstehend.</i></td></tr></tbody></table></div></div>');
$templateCache.put('app/theme/components/serviceDivisionShareList/serviceDivisionShareList.html','<div><div class="table-responsive"><table class="table table-condensed table-hover"><thead ng-if="$svcDivCtrl.divisionShares.length"><tr><th class="col-xs-1" ng-if="$svcDivCtrl.eventShareCtx.length > 1" translate="modules.arnoDashboard.board.requestFor"></th><th class="col-xs-2" translate="modules.arnoDashboard.board.event"></th><th ng-class="{\'col-xs-1\': $svcDivCtrl.eventShareCtx.length > 1, \'col-xs-2\': $svcDivCtrl.eventShareCtx.length < 1}" translate="modules.arnoDashboard.board.typ"></th><th class="col-xs-2" translate="modules.arnoDashboard.board.start"></th><th class="col-xs-2" translate="modules.arnoDashboard.board.origin"></th><th class="col-xs-4 pl-15" translate="generalTerms.actions"></th></tr></thead><tbody ng-class="{\'without-top-border\': !$svcDivCtrl.divisionShares.length}"><tr ng-repeat="divisionShare in $svcDivCtrl.divisionShares"><td ng-if="$svcDivCtrl.eventShareCtx.length > 1"><i class="ion-ios-people-outline"></i> {{ ::divisionShare.Division.Name }}</td><td>{{ ::divisionShare.Event.Subject }}</td><td>{{ ::divisionShare.Service ? \'modules.arnoDashboard.board.service\' : \'modules.arnoDashboard.board.date\' |translate}}</td><td>{{ ::divisionShare.Event.StartDate | date:\'dd.MM.yyyy HH:mm\' }}</td><td>{{ ::divisionShare.Event.SourceDivision.Name }}</td><td class="arno-default-pointer pl-15"><div class="nowrap text-left"><button class="btn btn-info btn-with-icon btn-xs" ng-click="$svcDivCtrl.handleShare(\'DETAILS\', divisionShare)" title="{{\'modules.arnoDashboard.board.details\' |translate}}"><i class="glyphicon glyphicon-calendar"></i><span class="hidden-xs" translate="modules.arnoDashboard.board.details"></span></button> <button class="btn btn-success btn-with-icon btn-xs" ng-click="$svcDivCtrl.handleShare(\'ACCEPT\', divisionShare)" title="{{\'modules.arnoDashboard.board.accept\' |translate}}"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.arnoDashboard.board.acception"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$svcDivCtrl.handleShare(\'DECLINE\', divisionShare)" title="{{\'modules.arnoDashboard.board.decline\' |translate}}"><i class="fa fa-times"></i><span class="hidden-xs" translate="modules.arnoDashboard.board.decline"></span></button></div></td></tr><tr ng-if="!$svcDivCtrl.divisionShares.length"><td colspan="99" class="text-center"><i translate="modules.arnoDashboard.board.noPendingDiv"></i></td></tr></tbody></table></div></div>');
$templateCache.put('app/theme/components/setDatespanModal/setDateSpan.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.modals.setDateSpan.title">Zeitspanne definieren</h4></div><div class="modal-body"><label class="control-label" translate="components.modals.setDateSpan.startDate">Startdatum:</label><div class="input-group"><input name="startdate" type="text" class="form-control" is-open="$dateCtrl.datePickerStates.startDate" uib-datepicker-popup="{{$dateCtrl.datepicker.format}}" datepicker-options="$dateCtrl.datepicker.options" invalid-message="\'components.modals.setDateSpan.invalidMsg\' | translate" ng-model="$dateCtrl.startDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$dateCtrl.datePickerStates.startDate = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label class="control-label" translate="components.modals.setDateSpan.endDate">Enddatum:</label><div class="input-group"><input name="enddate" type="text" class="form-control" is-open="$dateCtrl.datePickerStates.endDate" uib-datepicker-popup="{{$dateCtrl.datepicker.format}}" datepicker-options="$dateCtrl.datepicker.options" invalid-message="\'components.modals.setDateSpan.invalidMsg\' | translate" ng-model="$dateCtrl.endDate" close-text="Schlie\xDFen" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$dateCtrl.datePickerStates.endDate = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="modal-footer"><hr><button type="submit" ng-click="$dateCtrl.applyModal()" class="btn btn-primary" translate="components.modals.setDateSpan.apply">Anwenden</button> <button ng-click="$dismiss(null)" type="button" class="btn btn-default" translate="generalTerms.close">Schlie\xDFen</button></div></div>');
$templateCache.put('app/theme/components/shiftTemplate/shiftTemplate.html','<div class="row arno-shift-template"><div class="col-md-12"><div class="row btns-row" ng-if="!$shift.hide.shiftEdit"><div class="col-md-12 mb-0"><button type="button" class="btn btn-info btn-with-icon" ng-click="$shift.openMetaDetails()" ng-disabled="$shift.mediaSizeXS && !$shift.options.mobileEdit"><i class="ion-plus"></i> {{ (\'modules.events.shiftTemplate.newShift\' | translate) }}</button> <button type="button" class="btn btn-default btn-with-icon" ng-click="$shift.importFromTemplate()" ng-disabled="$shift.mediaSizeXS && !$shift.options.mobileEdit"><i class="fa fa-plus-circle"></i> {{ (\'modules.events.shiftTemplate.shiftFromTemplate\' | translate) }}</button></div></div><div class="mb-5" ng-if="$shift.shifts.length"><div class="shift-gnatt-preview"><div class="gnatt-milestone-container"><div ng-repeat="milestone in $shift.gnattMilestones track by milestone.id" class="gnatt-milestone" ng-class="milestone.classlist" ng-style="milestone.style || ({left: milestone.percentStart + \'%\'})" uib-popover="{{milestone.gnattLabel}}" popover-placement="{{milestone.percentStart < 25 ? \'bottom-left\' : (milestone.percentStart > 75 ? \'bottom-right\' : \'bottom\')}}" popover-trigger="mouseenter"></div></div><div ng-repeat="lane in $shift.gnattLanes track by $index" class="gnatt-lane"><div ng-repeat="shift in lane track by shift.id" class="gnatt-shift" ng-class="[{\'hide-inner-text\': (100 - (shift.percentStart + (100 - shift.percentEnd))) <= 2}, {\'undetermined-timeframe\': (!shift.StartDate && !shift.EndDate)}, shift.attendanceClass]" ng-style="{left: shift.percentStart + \'%\', right: (100 - shift.percentEnd) + \'%\'}" uib-popover="{{shift.gnattLabel}}" popover-placement="bottom-left" popover-trigger="mouseenter" ng-click="$shift.jumpToShift(shift)"><span>{{shift.Subject}}</span></div></div></div><div class="shift-gnatt-key mt-5" ng-if="::!$shift.templateMode"><div class="font-weight-500 font-size-12 inline mr-1">{{ (\'modules.events.shiftTemplate.ownParticipation\' | translate) }}</div><span>{{ (\'modules.events.shiftTemplate.open\' | translate) }}</span> <span class="key-warning">{{ (\'modules.events.shiftTemplate.interest\' | translate) }}</span> <span class="key-success">{{ (\'modules.events.shiftTemplate.confirmed\' | translate) }}</span> <span class="key-danger">{{ (\'modules.events.shiftTemplate.canceled\' | translate) }}</span> <span class="key-unavailable">{{ (\'modules.events.shiftTemplate.notPossible\' | translate) }}</span></div></div><div ng-if="!$shift.shifts.length" class="mt-20 mb-10"><i>{{ (\'modules.events.shiftTemplate.noShiftsLogged\' | translate) }}</i></div><div ng-repeat="shift in $shift.shifts | orderBy:[$shift.orderByStartDate, \'Subject\'] track by shift.id" class="shift-rows"><h5 class="with-line mb-5" toggle-next="$shift.toggleNextState[shift.id]" toggle-skip-next-animation="$shift.skipNextToggleAnimation" id="{{::$shift.shiftScrollRef(shift)}}"><span>{{shift.Subject}}</span> <button type="button" class="btn btn-xs btn-danger mt-9 pull-right ml-5" ng-if="!$shift.hide.shiftEdit && (!$shift.mediaSizeXS || $shift.options.mobileEdit)" title="{{ (\'modules.events.shiftTemplate.remove\' | translate) }}" ng-click="$shift.removeShiftOrPosition($event, shift)"><i class="ion-ios-trash"></i> {{ (\'modules.events.shiftTemplate.remove\' | translate) }}</button> <button type="button" ng-if="::!$shift.templateMode" class="btn btn-default btn-xs btn-with-icon mt-9 pull-right ml-5" ng-click="$shift.downloadICAL($event, [shift])"><i class="fa fa-download"></i> {{ (\'modules.events.shiftTemplate.date\' | translate) }}</button><div class="btn-group pull-right" ng-if="!$shift.templateMode && $shift.canEditAttendance(shift)" ng-click="$event.stopPropagation()" uib-dropdown=""><button uib-dropdown-toggle="" type="button" class="btn btn-default btn-xs btn-with-icon mt-9"><i class="fa fa-envelope-o"></i><span class="hidden-xs">{{ (\'modules.events.shiftTemplate.message\' | translate) }}</span><span class="caret ml-3 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li class="dropdown-header">{{ (\'modules.events.shiftTemplate.toShiftEmail\' | translate) }}</li><li role="menuitem"><a href="" ng-click="$shift.closeDropdown() && $shift.sendMessage([shift], \'ACCEPTED_PLANNED\')">{{ (\'modules.events.shiftTemplate.toConfirmed\' | translate) }}</a></li><li role="separator" class="divider"></li><li class="dropdown-header">{{ (\'modules.events.shiftTemplate.toShiftArno\' | translate) }}</li><li role="menuitem" ng-class="{\'disabled\': $shift.hide.flowSelfAttend}" title="{{$shift.hide.flowSelfAttend ? (\'modules.events.shiftTemplate.toShiftText\' | translate) : \'\'}}"><a href="" ng-click="!$shift.hide.flowSelfAttend && $shift.closeDropdown() && $shift.inviteAttendee([shift])">{{ (\'modules.events.shiftTemplate.invitation\' | translate) }}</a></li></ul></div></h5><div class="row shift-row-main pt-5"><div ng-class="{\'col-md-12\': !($shift.templateMode || $shift.hide.positions), \'col-md-6\': ($shift.templateMode || $shift.hide.positions)}"><div ng-class="{\'row mb-20\': !($shift.templateMode || $shift.hide.positions)}"><div ng-class="{\'col-md-6\': !($shift.templateMode || $shift.hide.positions)}"><div class="table-responsive"><table class="table table-condensed shift-metadata"><thead><tr><td colspan="99"><span class="table-title-with-button"><i class="fa fa-hashtag mr-3"></i><strong>{{ (\'modules.events.shiftTemplate.shiftDetails\' | translate) }}</strong></span> <button type="button" class="btn btn-xs btn-default btn-with-icon pull-right" ng-if="!$shift.hide.shiftEdit && (!$shift.mediaSizeXS || $shift.options.mobileEdit)" ng-click="$shift.openMetaDetails(shift)"><i class="fa fa-pencil"></i> {{ (\'modules.events.shiftTemplate.edit\' | translate) }}</button></td></tr></thead><tbody><tr ng-repeat="line in $shift.shiftMetaDataMap track by line.ident" ng-if="shift[line.ident] || line.showFunc(shift)"><td>{{::line.label}}</td><td ng-if="::line.type === \'static\'">{{::line.value}}</td><td ng-if="::line.type === \'text\'">{{shift[line.ident]}}</td><td ng-if="::line.type === \'datetime\'">{{shift[line.ident] | date:\'dd.MM.yyyy, HH:mm\' }} Uhr</td><td ng-if="::line.type === \'time\'">{{shift[line.ident] | date:\'HH:mm\' }} Uhr</td><td ng-if="::line.type === \'offsetDate\'">{{$shift.dateOffsetTextHelper(shift, line.ident)}} {{shift[line.ident] | date:\'HH:mm\' }} Uhr</td><td ng-if="::line.type === \'share\'"><div class="mb-8" ng-if="$shift.dynShiftShare[shift.id].length"><div ng-repeat="shiftShare in $shift.dynShiftShare[shift.id] | orderBy:[\'Division.Name\'] track by shiftShare.id" class="arno-tag tag label label-tag label-info" title="{{shiftShare.IsGlobal ? (\'modules.events.shiftTemplate.shareText\' | translate) : ((\'modules.events.shiftTemplate.shareText2\' | translate) + shiftShare.Division.Name + (\'modules.events.shiftTemplate.shareText3\' | translate))}}"><i class="fa fa-bullhorn" ng-if="shiftShare.IsGlobal"></i> {{::shiftShare.Division.Name}}</div></div></td></tr></tbody></table></div></div></div></div><div class="col-md-6" ng-if="::!$shift.templateMode"><div class="table-responsive"><table class="table table-condensed shift-positions"><thead><tr><td colspan="99"><span class="table-title-with-button"><i class="fa fa-user mr-5"></i><strong>{{ (\'modules.events.shiftTemplate.participant\' | translate) }}</strong></span> <button type="button" class="btn btn-danger ml-7 btn-xs pull-right no-animation" ng-if="!shift.resetAttendees && $shift.canSelfAttend(shift) && (!$shift.ownAttendanceState[shift.id] || ($shift.ownAttendanceState[shift.id].Acceptance || $shift.ownAttendanceState[shift.id].Interested))" ng-click="$shift.attendanceAdd(shift, null, false, false, true)" title="{{ \'modules.events.shiftTemplate.cancelYourself\' | translate }}"><i class="fa fa-user-times"></i> {{ (\'modules.events.shiftTemplate.cancelYourself\' | translate) }}</button> <button type="button" class="btn btn-success btn-dual btn-xs pull-right no-animation" ng-if="!shift.resetAttendees && $shift.canSelfAttend(shift) && (!$shift.ownAttendanceState[shift.id] || (!$shift.ownAttendanceState[shift.id].Acceptance && !$shift.ownAttendanceState[shift.id].Interested))" ng-click="$shift.attendanceAdd(shift, null, true, false, true)" title="{{ (\'modules.events.shiftTemplate.confirmYourself\' | translate) }}"><i class="fa-user-check fix-btn"><i class="fa fa-user"></i> <i class="fa fa-check offset-color"></i></i> {{ (\'modules.events.shiftTemplate.confirmYourself\' | translate) }}</button> <button type="button" ng-if="!shift.resetAttendees && $shift.canSelfAttend(shift) && $shift.ownAttendanceState[shift.id].Acceptance" class="btn btn-secondary btn-with-icon btn-xs pull-right" ng-click="$shift.addRemark(attendee, true, shift)" title="{{ (\'modules.events.event.partials.editRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{$shift.ownAttendanceState[shift.id].Remark ? ($shift.ownAttendanceState[shift.id].Remark.length > 15 ? (\'modules.events.event.partials.editRemark\' | translate) : $shift.ownAttendanceState[shift.id].Remark) : (\'modules.events.event.partials.addRemark\' | translate)}}</span></button></td></tr></thead><tbody><tr ng-if="shift.resetAttendees"><td colspan="99" class="p-4"><div class="alert bg-warning mb-10 clearfix"><p>{{ (\'modules.events.shiftTemplate.resetText\' | translate) }}</p><p>{{ (\'modules.events.shiftTemplate.resetText2\' | translate) }}</p></div><button type="button" class="btn btn-danger btn-with-icon btn-sm mb-5" ng-click="$shift.cancelResetAttendees(shift)"><i class="fa fa-times"></i> {{ (\'modules.events.shiftTemplate.resetText3\' | translate) }}</button></td></tr><tr ng-repeat="attendance in shift.ServiceShiftMembers | orderBy:[\'Division.Name\', \'Member.fullName\'] track by attendance.MemberId"><td class="align-left-force force-minimal shift-position-schedule-conflict" ng-if="$shift.scheduleConflictWarning[attendance.MemberId][shift.id]" ng-class="$shift.scheduleConflictWarning[attendance.MemberId][shift.id].ownCollision ? \'arno-pointing-pointer\' : \'arno-help-pointer\'" ng-click="$shift.scheduleConflictWarning[attendance.MemberId][shift.id].ownCollision && $shift.jumpToShiftById($shift.scheduleConflictWarning[attendance.MemberId][shift.id].ownCollision)" title="{{$shift.scheduleConflictWarningTitle[attendance.MemberId][shift.id]}}"><i class="fa fa-clock-o text-danger"></i></td><td class="align-left-force force-minimal" colspan="{{$shift.scheduleConflictWarning[attendance.MemberId][shift.id] ? 1 : 2}}"><div ng-if="attendance.Acceptance === null && attendance.Interested" class="arno-tag tag label label-tag label-warning event-status-tag wide mr-0">{{ \'modules.events.shiftTemplate.interested\' | translate }}</div><div ng-if="attendance.Acceptance" class="arno-tag tag label label-tag label-success event-status-tag wide mr-0">{{attendance.ServiceFunctionId ? (\'modules.events.shiftTemplate.scheduled\' | translate) : (\'modules.events.shiftTemplate.agreed\' | translate)}}</div><div ng-if="attendance.Acceptance === false" class="arno-tag tag label label-tag label-danger event-status-tag wide mr-0">{{ (\'modules.events.shiftTemplate.cancelled\' | translate) }}</div><div ng-if="$shift.attendanceRemovalWarning[attendance.MemberId][shift.id]" class="inline-block mr-3" title="{{ (\'modules.events.shiftTemplate.changeText\' | translate) }}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div ng-if="attendance.ServiceFunctionId" class="font-size-12"><div class="inline-block" uib-popover-html="$shift.getPositionReqValidPopover( null, $shift.requirementValidityMap[shift.id][attendance.ServiceFunctionId].qualification[attendance.MemberId].validList, $shift.requirementValidityMap[shift.id][attendance.ServiceFunctionId].activity[attendance.MemberId].validList, $shift.qualificationHelperMap, $shift.activityHelperMap )" popover-placement="top-left" popover-trigger="mouseenter" popover-append-to-body="true"><status-light class="\'light-inline attendance-status-light mr-5\'" ng-if="$shift.options.hasManagePermsInSourceDivOrForItem" is-green="$shift.shiftPositionMemberValidStateMap[shift.id][attendance.ServiceFunctionId][attendance.MemberId] === true" use-yellow-light="true" is-inactive="$shift.shiftPositionMemberValidStateMap[shift.id][attendance.ServiceFunctionId][attendance.MemberId] === undefined" is-yellow="$shift.shiftPositionMemberValidStateMap[shift.id][attendance.ServiceFunctionId][attendance.MemberId] === false"></status-light>{{$shift.positionNameMap[shift.id][attendance.ServiceFunctionId]}}</div><i class="fa fa-times text-danger arno-pointing-pointer" ng-if="!($shift.hide.positionEdit || shift.resetAttendees)" ng-click="$shift.removePositionAssoc(shift, attendance)"></i></div></td><td class="align-left-force white-space-no-wrap force-minimal" ng-class="{ \'member-inactive\': attendance.Member.isInactive }"><i class="fa fa-child underage-indicator" ng-if="!(attendance.BirthDate || attendance.Member.BirthDate) || $shift.isUnderaged[attendance.MemberId]" title="{{(attendance.BirthDate || attendance.Member.BirthDate) ? ((\'modules.events.shiftTemplate.birthdayTitle\' | translate) + $shift.isUnderaged[attendance.MemberId] + (\'modules.events.shiftTemplate.birthdayTitle2\' | translate)) : (\'modules.events.shiftTemplate.birthdayTitle3\' | translate)}}" ng-class="{\'text-primary\': $shift.isUnderaged[attendance.MemberId], \'text-warning\': !(attendance.BirthDate || attendance.Member.BirthDate)}"></i> {{::attendance.fullName || attendance.Member.fullName}}</td><td class="align-left-force white-space-no-wrap force-minimal"><div class="arno-tag tag label label-tag pull-right mt-2" ng-if="attendance.Division.Name && $shift.sharedWithDivision" ng-class="{\'label-success\': $shift.isInternalAttendee(shift, attendance), \'label-warning\': $shift.isInternalAttendee(shift, attendance) === false, \'label-danger\': $shift.isInternalAttendee(shift, attendance) === null}" title="{{ ($shift.isInternalAttendee(shift, attendance) ? (\'modules.events.shiftTemplate.attendanceText\' | translate) : \'\') + ($shift.isInternalAttendee(shift, attendance) === false ? (\'modules.events.shiftTemplate.attendanceText2\' | translate) : \'\') + ($shift.isInternalAttendee(shift, attendance) === null ? (\'modules.events.shiftTemplate.attendanceText3\' | translate) : \'\') }}">{{ attendance.Division.Name }}</div></td><td class="align-left-force"><div ng-if="attendance.Acceptance && attendance.Remark != null && $shift.hide.attendeeEdit && $shift.ownAttendanceState[shift.id].MemberId != attendance.MemberId && $shift.ownAttendanceState[shift.id].state != \'ADDED\'"><button type="button" ng-click="$shift.addRemark(attendance, false, shift)" class="btn btn-secondary btn-with-icon btn-xs event-status-tag wide mr-0" title="{{ (\'modules.events.event.partials.seeRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{ attendance.Remark.length > 15 ? (\'modules.events.event.partials.seeRemark\' | translate) : attendance.Remark }}</span></button></div><div ng-if="attendance.Acceptance && !$shift.hide.attendeeEdit && $shift.ownAttendanceState[shift.id].MemberId != attendance.MemberId && attendance.state != \'ADDED\'"><button type="button" class="btn btn-secondary btn-with-icon btn-xs pull-right" ng-click="$shift.addRemark(attendance, true, shift)" title="{{ (\'modules.events.event.partials.editRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{attendance.Remark ? (attendance.Remark.length > 15 ? (\'modules.events.event.partials.editRemark\' | translate) : attendance.Remark) : (\'modules.events.event.partials.addRemark\' | translate)}}</span></button></div><div class="arno-tag tag label label-tag event-status-tag without-width" ng-if="attendance.state === \'ADDED\'">{{ \'modules.events.shiftTemplate.new\' | translate }}</div><div class="arno-tag tag label label-tag event-status-tag without-width" ng-if="attendance.state === \'UPDATED\'">{{ \'modules.events.shiftTemplate.update\' | translate }}</div></td><td class="align-right-force pr-0"><div ng-if="!($shift.hide.attendeeEdit || shift.resetAttendees) && $shift.canHandleAttendance(shift, attendance)"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$shift.removeAttendance(shift, attendance)" ng-if="attendance.state === \'ADDED\'"><i class="ion-ios-trash"></i><span>{{ (\'modules.events.shiftTemplate.noReport\' | translate) }}</span></button> <button type="button" ng-if="!attendance.Member.isInactive" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$shift.attendanceAdd(shift, attendance, !attendance.Acceptance)" title="{{ \'modules.events.shiftTemplate.editNotification\' | translate }}"><i class="fa fa-user-times" ng-if="attendance.Acceptance"></i> <i class="fa-user-check fix-btn" ng-if="!attendance.Acceptance"><i class="fa fa-user"></i> <i class="fa fa-check"></i></i> <span class="hidden-xs">{{ attendance.Acceptance ? (\'modules.events.shiftTemplate.reportCancellation\' | translate) : (\'modules.events.shiftTemplate.reportConfirmation\' | translate)}}</span></button></div></td></tr><tr ng-if="!shift.ServiceShiftMembers.length"><td colspan="99"><i>{{ (\'modules.events.shiftTemplate.noParticipantsReported\' | translate) }}</i></td></tr></tbody></table></div><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="!($shift.hide.attendeeEdit || shift.resetAttendees) && $shift.canEditAttendance(shift) && (!$shift.mediaSizeXS || $shift.options.mobileEdit)"><ui-select ng-model="$shift.attendanceStore[shift.id].target" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="true"><ui-select-match placeholder="{{ (\'modules.events.shiftTemplate.searchParticipants\' | translate) }}">{{ $shift.attendanceStore[shift.id].target.fullName }}</ui-select-match><ui-select-choices position="down" repeat="attendee in $shift.attendanceStore[shift.id].choices" refresh="$shift.attendanceSearch($select.search, shift)" refresh-delay="200" group-by="$shift.attendanceGroupFunc"><div ng-if="!attendee.none"><div class="arno-tag tag label label-tag event-status-tag" ng-class="$shift.currentAcceptance(shift, attendee).className">{{ $shift.currentAcceptance(shift, attendee).label }}</div><i class="fa fa-child underage-indicator" ng-if="!attendee.BirthDate || $shift.isUnderaged[attendee.MemberId]" title="{{attendee.BirthDate ? ((\'modules.events.shiftTemplate.attendeeBirthDateText\' | translate) + $shift.isUnderaged[attendee.MemberId] + (\'modules.events.shiftTemplate.attendeeBirthDateText2\' | translate)) : (\'modules.events.shiftTemplate.attendeeBirthDateText3\' | translate)}}" ng-class="{\'text-primary\': $shift.isUnderaged[attendee.MemberId], \'text-warning\': !attendee.BirthDate}"></i> <span>{{ attendee.fullName }} ({{ attendee.ContactEMail || (attendee.Account.Type === \'offline\' ? \'----\' : attendee.Account.EMail)}})</span></div><div ng-if="attendee.none" class="btn-with-icon"><span ng-if="attendee.foundNone"><i class="fa fa-times"></i><span><i>{{ (\'modules.events.shiftTemplate.foundNoParticipants\' | translate) }}</i></span></span> <span ng-if="!attendee.foundNone"><i>{{ (\'modules.events.shiftTemplate.pleaseEnterParticipant\' | translate) }}</i></span></div></ui-select-choices></ui-select><div class="input-group-btn"><button type="button" class="btn btn-success-outline btn-dual" ng-click="$shift.attendanceAdd(shift, $shift.attendanceStore[shift.id].target, true, true)" ng-disabled="!$shift.attendanceStore[shift.id].target" title="{{ \'modules.events.shiftTemplate.commitment\' | translate }}"><span class="fa-user-check"><i class="fa fa-user"></i> <i class="fa fa-check"></i></span></button> <button type="button" class="btn btn-danger" ng-click="$shift.attendanceAdd(shift, $shift.attendanceStore[shift.id].target, false, true)" ng-disabled="!$shift.attendanceStore[shift.id].target" title="{{ \'modules.events.shiftTemplate.cancellation\' | translate }}"><i class="fa fa-user-times"></i></button></div></div></div><div class="col-md-6" ng-if="!$shift.hide.positions"><div class="table-responsive"><table class="table table-condensed shift-positions"><thead><tr><td colspan="99"><span class="table-title-with-button"><i class="fa fa-user-o mr-5"></i><strong>{{ (\'modules.events.shiftTemplate.positions\' | translate) }}</strong></span> <button type="button" class="btn btn-xs btn-success btn-with-icon pull-right" ng-if="!($shift.hide.positionEdit || shift.resetAttendees) && (!$shift.mediaSizeXS || $shift.options.mobileEdit)" ng-click="$shift.openPositionDetails(shift)"><i class="fa fa-user-plus"></i> {{ (\'modules.events.shiftTemplate.newPosition\' | translate) }}</button> <button type="button" class="btn btn-xs btn-default btn-with-icon pull-right mr-5" ng-if="!($shift.hide.positionEdit || shift.resetAttendees) && (!$shift.mediaSizeXS || $shift.options.mobileEdit)" ng-click="$shift.importFromTemplate(shift)"><i class="fa fa-plus-circle"></i> {{ (\'modules.events.shiftTemplate.PositionFromTemplate\' | translate) }}</button> <button type="button" class="btn btn-xs btn-info btn-with-icon pull-right mr-5" ng-if="!($shift.hide.positionEdit || shift.resetAttendees) && $shift.hasServiceFunctionInQuotationBase && (!$shift.mediaSizeXS || $shift.options.mobileEdit)" ng-click="$shift.importFromQuotation(shift)"><i class="af af-finance-coins pl-3 pr-4"></i> {{ \'modules.events.shiftTemplate.positionFromQuotation\' | translate }}</button></td></tr></thead><tbody><tr ng-if="shift.resetAttendees"><td colspan="99" class="p-4"><div class="alert bg-warning mb-10 clearfix"><p>{{ (\'modules.events.shiftTemplate.resetText\' | translate) }}</p><p>{{ (\'modules.events.shiftTemplate.resetText2\' | translate) }}</p></div><button type="button" class="btn btn-danger btn-with-icon btn-sm mb-5" ng-click="$shift.cancelResetAttendees(shift)"><i class="fa fa-times"></i> {{ (\'modules.events.shiftTemplate.resetText3\' | translate) }}</button></td></tr><tr ng-repeat="position in shift.ServiceFunctions | orderBy:[\'Function\'] track by position.id"><td>{{position.Function}}<div ng-if="$shift.removalWarningInMemberPositionListMap[shift.id][position.id]" class="inline-block mr-3" title="{{(\'modules.events.shiftTemplate.removalWarning\' | translate) + ($shift.removalWarningInMemberPositionListMap[shift.id][position.id] > 1 ? (\'modules.events.shiftTemplate.removalWarning2\' | translate) : (\'modules.events.shiftTemplate.removalWarning3\' | translate)) + (\'modules.events.shiftTemplate.removalWarning4\' | translate)}}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div ng-if="$shift.qualificationRemovalWarning[shift.id][position.id].length + $shift.activityRemovalWarning[shift.id][position.id].length" class="inline-block mr-3" title="{{(\'modules.events.shiftTemplate.qualificationRemovalWarning\' | translate) + (($shift.qualificationRemovalWarning[shift.id][position.id].length + $shift.activityRemovalWarning[shift.id][position.id].length) > 1 ? (\'modules.events.shiftTemplate.qualificationRemovalWarning2\' | translate) : (\'modules.events.shiftTemplate.qualificationRemovalWarning3\' | translate)) + \', \' + (($shift.qualificationRemovalWarning[shift.id][position.id].length + $shift.activityRemovalWarning[shift.id][position.id].length) > 1 ? (\'modules.events.shiftTemplate.qualificationRemovalWarning4\' | translate) : (\'modules.events.shiftTemplate.qualificationRemovalWarning5\' | translate)) + (\'modules.events.shiftTemplate.qualificationRemovalWarning6\' | translate)}}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div><div class="arno-tag tag label label-tag label-info mt-2 block" ng-if="position.ReferenceServiceFunctionId && $shift.options.hasManagePermsInSourceDivOrForItem" title="{{ \'modules.events.shiftTemplate.positionOfAdministrationTemplate\' | translate }}"><i class="fa fa-link"></i> {{ (\'modules.events.shiftTemplate.adminTemplate\' | translate) }}</div></div></td><td><div class="ml-2 position-visualization"><i class="fa mr-2" ng-repeat="i in $shift.positionCountMap[shift.id][position.id] track by $index" uib-popover-html="$shift.getPositionReqValidPopover( $shift.memberPositionList[shift.id][position.id][$index].Member, $shift.requirementValidityMap[shift.id][$shift.memberPositionList[shift.id][position.id][$index].ServiceFunctionId].qualification[$shift.memberPositionList[shift.id][position.id][$index].MemberId].validList, $shift.requirementValidityMap[shift.id][$shift.memberPositionList[shift.id][position.id][$index].ServiceFunctionId].activity[$shift.memberPositionList[shift.id][position.id][$index].MemberId].validList, $shift.qualificationHelperMap, $shift.activityHelperMap )" popover-placement="top" popover-trigger="mouseenter" popover-append-to-body="true" ng-class="{\'mr-6\': ($index+1)%5 === 0, \'fa-user\': !$shift.templateMode && $index < $shift.memberPositionList[shift.id][position.id].length, \'text-success\': (!$shift.templateMode && $shift.memberPositionList[shift.id][position.id].length === position.PositionCount && $shift.requirementValidityMap[shift.id][$shift.memberPositionList[shift.id][position.id][$index].ServiceFunctionId].qualification[$shift.memberPositionList[shift.id][position.id][$index].MemberId].validState == true) || (!$shift.templateMode && $index < $shift.memberPositionList[shift.id][position.id].length), \'text-warning\': !$shift.templateMode && $index >= position.PositionCount, \'text-danger\': $shift.requirementValidityMap[shift.id][$shift.memberPositionList[shift.id][position.id][$index].ServiceFunctionId].qualification[$shift.memberPositionList[shift.id][position.id][$index].MemberId].validState != true, \'fa-user-o\': ($shift.templateMode || !$shift.memberPositionList[shift.id][position.id] || $index >= $shift.memberPositionList[shift.id][position.id].length)}"></i> <span ng-if="position.PositionCount > $shift.spudc"><strong>...</strong></span><div class="arno-tag tag label label-tag pull-right mt-2" ng-class="{\'label-danger\': ($shift.templateMode || !$shift.memberPositionList[shift.id][position.id] || $shift.memberPositionList[shift.id][position.id].length < position.PositionCount), \'label-success\': (!$shift.templateMode && $shift.memberPositionList[shift.id][position.id].length === position.PositionCount), \'label-warning\': (!$shift.templateMode && $shift.memberPositionList[shift.id][position.id].length > position.PositionCount)}"><span ng-if="::$shift.templateMode">&times;&ThinSpace;{{position.PositionCount}}</span> <span ng-if="::!$shift.templateMode">{{$shift.memberPositionList[shift.id][position.id].length || 0}}/{{position.PositionCount}}</span></div></div><div><div ng-if="position.Qualifications.length"><div class="arno-tag tag label label-tag mt-2" ng-repeat="quali in position.Qualifications track by quali.id" ng-class="{\'label-success\': (!$shift.templateMode && $shift.memberPositionList[shift.id][position.id].length === position.PositionCount), \'label-warning\': ($shift.templateMode || !$shift.memberPositionList[shift.id][position.id] || $shift.memberPositionList[shift.id][position.id].length < position.PositionCount), \'label-danger\': $shift.requirementsNotFullfilled(shift.id,position.id) }" title="{{ ((quali.Division || {}).Name) || ($root.ctx.organization.current.name + (\'modules.events.shiftTemplate.orgBrackets\' | translate)) }}"><i class="ion-ribbon-b"></i> {{::quali.Name}}</div></div><div ng-if="position.Activities.length"><div class="arno-tag tag label label-tag mt-2" ng-repeat="act in position.Activities track by act.id" ng-class="{\'label-success\': $shift.isInternalActivity(shift, position, act), \'label-warning\': $shift.isInternalActivity(shift, position, act) === false, \'label-danger\': $shift.isInternalActivity(shift, position, act) === null}" title="{{((act.Division || {}).Name) || ($root.ctx.organization.current.name + (\'modules.events.shiftTemplate.orgBrackets\' | translate))}}"><i class="fa fa-paint-brush"></i> {{::act.Title}}</div></div></div></td><td class="force-minimal pr-5 white-space-no-wrap"><button type="button" class="btn btn-xs btn-default px-10" title="{{ \'modules.events.shiftTemplate.edit\' | translate }}" ng-if="!($shift.hide.positionEdit || shift.resetAttendees)" ng-click="$shift.openPositionDetails(shift, position)"><i class="fa fa-pencil"></i></button> <button type="button" class="btn btn-xs btn-danger px-12" title="{{ \'modules.events.shiftTemplate.remove\' | translate }}" ng-if="!($shift.hide.positionEdit || shift.resetAttendees)" ng-click="$shift.removeShiftOrPosition($event, shift, position)"><i class="ion-ios-trash"></i></button></td></tr><tr ng-if="!shift.ServiceFunctions.length"><td colspan="99"><i>{{ (\'modules.events.shiftTemplate.noPositionsRecorded\' | translate) }}</i></td></tr></tbody></table></div></div><div class="col-md-12 mt-10" ng-if="::!$shift.templateMode"><table class="table table-condensed shift-positions"><thead><tr><td colspan="99"><span class="table-title-with-button"><i class="fa fa fa-cube mr-5"></i><strong>{{ (!$shift.options.hasManagePermsInSourceDivOrForItem && shift.ServiceShiftMaterialClothings.length == 0 && shift.ServiceShiftMaterialConsumables.length == 0 && shift.ServiceShiftMaterialMedicalProducts.length == 0 && shift.ServiceShiftMaterialMedicines.length == 0 && shift.ServiceShiftMaterialOthers.length == 0 && shift.ServiceShiftMaterialVehicles.length == 0) ? (\'modules.events.shiftTemplate.noMaterials\' | translate) : (\'modules.events.shiftTemplate.materials\' | translate) }}</strong></span> <button type="button" class="btn btn-xs btn-info btn-with-icon pull-right" ng-if="!$shift.hide.materialEdit" ng-click="$shift.editBookingPeriods(shift)"><i class="fa fa-clock-o"></i> {{ (\'modules.events.shiftTemplate.bookingPeriods\' | translate) }}</button></td></tr></thead></table><div class="mt-5"><event-material base-type="\'SERVICE\'" reverse-share="$shift.eventMaterialReverseShare" shift="shift" shifts="$shift.shifts" hide-edit="$shift.hide.materialEdit" ctx="$shift.ctx" ctx-name="$shift.ctxName" material-meta="$shift.options.serviceMaterialMeta" has-manage-perm="$shift.options.hasManagePermsInSourceDivOrForItem" initial-booking-material-utilization="$shift.options.template.bookingMaterialUtilization" booking-material-utilization-fetch="$shift.bookingMaterialUtilizationFetch" quotation-position-importer="$shift.quotationPositionImporter" quotation-base="$shift.quotationBase" initial-booking-material-included-tree="$shift.options.template.bookingMaterialIncludedTree"></event-material></div></div></div></div><div class="row btns-row mt-20" ng-if="!$shift.hide.shiftEdit && $shift.shifts.length > 2"><div class="col-md-12 mb-0"><button type="button" class="btn btn-info btn-with-icon" ng-click="$shift.openMetaDetails()" ng-disabled="$shift.mediaSizeXS && !$shift.options.mobileEdit"><i class="ion-plus"></i> {{ (\'modules.events.shiftTemplate.newShift\' | translate) }}</button> <button type="button" class="btn btn-default btn-with-icon" ng-click="$shift.importFromTemplate()" ng-disabled="$shift.mediaSizeXS && !$shift.options.mobileEdit"><i class="fa fa-plus-circle"></i> {{ (\'modules.events.shiftTemplate.shiftFromTemplate\' | translate) }}</button></div></div></div></div>');
$templateCache.put('app/theme/components/statisticHelperHours/statisticHelperHours.html','<div class="arno-statistic-helper-hours"><div class="row"><div class="col-md-12"><h4 class="with-line" toggle-next="true" ng-if="self.collapseFilter">{{ \'components.statisticHelperHours.filter\' | translate}}</h4><div><div class="row"><div class="col-md-6"><ba-switcher switcher-style="primary" switcher-value="self.timeSpanType" switcher-width="146" switcher-keys="self.timeSpanSwitcherKeys"></ba-switcher><div class="time-range-picker"><div uib-datepicker="" ng-if="self.timeSpanType" class="no-animation" ng-model="self.timeSpanFrom" multi-select="self.timeSpanDates" select-range="true" datepicker-options="self.datepickerOptions.range"></div><div uib-datepicker="" ng-if="!self.timeSpanType" class="no-animation" ng-model="self.timeSpanFrom" datepicker-options="self.datepickerOptions.day"></div></div><div class="time-range-buttons" ng-if="self.timeSpanType"><button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'year\', 1)"><i class="fa fa-circle"></i> <span translate="components.statisticHelperHours.previousYear"></span></button> <button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'month\', 1)"><i class="fa fa-dot-circle-o"></i> <span translate="components.statisticHelperHours.previousMonth"></span></button> <button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'week\', 1)"><i class="fa fa-circle-thin"></i> <span translate="components.statisticHelperHours.previousWeek"></span></button></div><div class="time-range-buttons" ng-if="self.timeSpanType"><button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'year\')" ng-disabled="!self.validTimeFrameJump(\'year\')"><i class="fa fa-circle"></i> <span translate="components.statisticHelperHours.sinceYear"></span></button> <button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'month\')" ng-disabled="!self.validTimeFrameJump(\'month\')"><i class="fa fa-dot-circle-o"></i> <span translate="components.statisticHelperHours.sinceMonth"></span></button> <button type="button" class="btn btn-default btn-with-icon" ng-click="self.setDateSpan(\'week\')" ng-disabled="!self.validTimeFrameJump(\'week\')"><i class="fa fa-circle-thin"></i> <span translate="components.statisticHelperHours.sinceWeek"></span></button></div></div><div class="col-md-3"><div class="form-group"><label class="control-label"><span translate="components.statisticHelperHours.activity"></span><arno-ba-help-tooltip text="{{\'modules.helperHours.hours.chooseDependent\' | translate}}"></arno-ba-help-tooltip></label><ui-select class="btn-group bootstrap-select form-control" name="selectActivity" search-enabled="true" reset-search-input="false" ng-model="self.selectedActivity"><ui-select-match placeholder="{{ \'components.statisticHelperHours.allActivities\' | translate}}">{{ self.selectedActivity.Title }}</ui-select-match><ui-select-choices position="down" repeat="activity in self.activities" refresh="self.searchActivities($select.search)" refresh-delay="200"><span ng-if="!activity.none">{{ activity.Title }}</span> <i ng-if="activity.none"><span translate="components.statisticHelperHours.allActivities"></span></i></ui-select-choices><ui-select-no-choice><i class="p-7"><span translate="components.statisticHelperHours.noActivities"></span></i></ui-select-no-choice></ui-select></div><div class="form-group"><label class="control-label"><span translate="components.statisticHelperHours.baseCategory"></span><arno-ba-help-tooltip text="{{\'modules.helperHours.hours.chooseDependent\' | translate}}"></arno-ba-help-tooltip></label><ui-select class="btn-group bootstrap-select form-control" name="selectBaseCategory" search-enabled="true" reset-search-input="false" ng-model="self.selectedBaseCategory"><ui-select-match placeholder="{{ \'modules.events.overview.allCategories\' | translate}}">{{ self.selectedBaseCategory.Name }}</ui-select-match><ui-select-choices position="down" repeat="baseCategory in self.baseCategories" refresh="self.searchBaseCategories($select.search)" refresh-delay="200"><span ng-if="!baseCategory.none">{{ baseCategory.Name }}</span> <i ng-if="baseCategory.none"><span translate="components.statisticHelperHours.allBaseCategories"></span></i></ui-select-choices><ui-select-no-choice><i class="p-7"><span translate="components.statisticHelperHours.noBaseCategories"></span></i></ui-select-no-choice></ui-select></div></div></div></div></div></div><div class="row mb-20"><div class="col-md-5"><div class="table-responsive mt-30"><table class="table table-condensed table-hover"><thead><tr><th colspan="2" translate="components.statisticHelperHours.statistic"></th><th translate="components.statisticHelperHours.value"></th></tr></thead><tbody><tr><td colspan="2" translate="components.statisticHelperHours.timePeriod"></td><td>{{ self.currentData.detailList.detailTimespanDays }} <span translate="components.statisticHelperHours.day" translate-values="{ PLURAL: self.currentData.detailList.detailTimespanDays !== 1 }"></span></td></tr><tr><td colspan="2" translate="components.statisticHelperHours.volunteerHourEntries"></td><td>{{ self.currentData.detailList.affectedEntries }}</td></tr><tr ng-if="self.currentData.detailList.membersInTimespan"><td colspan="2" translate="components.statisticHelperHours.volunteerCount"></td><td>{{ self.currentData.detailList.membersInTimespan }}</td></tr><tr><td colspan="2" translate="components.statisticHelperHours.volunteerHours"></td><td>{{ self.currentData.detailList.hours }} h</td></tr><tr><td colspan="2" translate="components.statisticHelperHours.volunteerHoursPerDayAvg"></td><td>{{ self.currentData.detailList.hoursPerDay || 0 }} h</td></tr><tr><td colspan="2" translate="components.statisticHelperHours.volunteerHoursPerEventAvg"></td><td>{{ self.currentData.detailList.hoursPerEvent || 0 }} h</td></tr><tr><td colspan="2" translate="components.statisticHelperHours.volunteerHoursPerServiceAvg"></td><td>{{ self.currentData.detailList.hoursPerService || 0 }} h</td></tr><tr ng-if="self.currentData.detailList.hoursByMonth"><td rowspan="{{self.rowSpanByKey(self.currentData.detailList.hoursByMonth)}}"><span translate="components.statisticHelperHours.volunteerHoursPerMonth"></span><br><small><i translate="components.statisticHelperHours.volunteerHoursPerMonthInfo"></i></small></td></tr><tr ng-if="self.currentData.detailList.hoursByMonth" ng-repeat="(key, value) in self.currentData.detailList.hoursByMonth"><td>{{ self.monthYearLabel(key) }}</td><td>{{ value }} h</td></tr><tr ng-if="self.currentData.detailList.hoursByYear"><td rowspan="{{self.rowSpanByKey(self.currentData.detailList.hoursByMonth)}}"><span translate="components.statisticHelperHours.volunteerHoursPerYear"></span><br><small><i translate="components.statisticHelperHours.volunteerHoursPerYearInfo"></i></small></td></tr><tr ng-if="self.currentData.detailList.hoursByYear" ng-repeat="(key, value) in self.currentData.detailList.hoursByYear"><td>{{ key }}</td><td>{{ value }} h</td></tr></tbody></table></div></div><div class="col-md-7" ng-if="self.timeSpanType"><canvas class="chart chart-line" chart-data="self.activityData" chart-labels="self.activityLabel" chart-options="self.timeChartOpts" chart-dataset-override="self.activityDataset"></canvas></div></div><div class="row" ng-if="self.tableShow"><div class="col-md-5"><table class="table table-condensed table-hover" st-table="self.tableData.helperList" st-pipe="self.tableUpdate"><thead><tr class="sortable"><th st-sort="fullNameSort">{{ \'components.statisticHelperHours.volunteer\' | translate }}</th><th st-sort="helperHoursSort">{{ \'components.statisticHelperHours.volunteerHours\' | translate }}</th></tr><tr><th><input st-search="fullNameSearch" class="form-control" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="helper in self.tableData.helperList"><td ng-if="helper.fullName">{{ helper.fullName }}</td><td ng-if="!helper.fullName">{{ \'generalTerms.formerUser\' | translate:{PLURAL:true} }}</td><td>{{ helper.helperHours }} h</td></tr></tbody><tfoot><tr><td colspan="{{self.helperListColumns}}" class="text-center"><st-pagination st-items-by-page="self.rowsPerPage" st-template="app/theme/components/paging/paging.html" st-displayed-pages="self.tableData.maxPages"></st-pagination></td></tr></tfoot></table></div></div><div class="row" ng-if="self.timeSpanType"><div class="col-md-12"><cal-heatmap heatmap="self.heatmapData" start-date="self.rangeStart" end-date="self.rangeEnd" label-func="self.heatmapLabel"></cal-heatmap></div></div><h4 class="with-line" toggle-next="true" ng-if="self.collapseFilter">{{ \'components.statisticHelperHours.details\' | translate}}</h4><div><div class="row" ng-if="self.currentData.detailList.affectedEntries"><div class="col-lg-6 mb-40" ng-if="self.memberDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.memberDoughnutData" chart-labels="self.memberDoughnutLabel" chart-options="self.memberDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.divisionDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.divisionDoughnutData" chart-labels="self.divisionDoughnutLabel" chart-options="self.divisionDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.activityDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.activityDoughnutData" chart-labels="self.activityDoughnutLabel" chart-options="self.activityDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.baseCategoryDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.baseCategoryDoughnutData" chart-labels="self.baseCategoryDoughnutLabel" chart-options="self.baseCategoryDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.memberHDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.memberHDoughnutData" chart-labels="self.memberHDoughnutLabel" chart-options="self.memberHDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.divisionHDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.divisionHDoughnutData" chart-labels="self.divisionHDoughnutLabel" chart-options="self.divisionHDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.activityHDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.activityHDoughnutData" chart-labels="self.activityHDoughnutLabel" chart-options="self.activityHDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.baseCategoryHDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.baseCategoryHDoughnutData" chart-labels="self.baseCategoryHDoughnutLabel" chart-options="self.baseCategoryHDoughnutOpts"></canvas></div></div><div class="col-lg-6 mb-40" ng-if="self.evtSvcDoughnutData.length"><div class="doughnut-chart-buffer"><canvas class="chart chart-doughnut" chart-data="self.evtSvcDoughnutData" chart-labels="self.evtSvcDoughnutLabel" chart-options="self.evtSvcDoughnutOpts"></canvas></div></div></div></div></div>');
$templateCache.put('app/theme/components/statusLight/statusLight.html','<div class="arno-status-light {{$slight.class}}"><i ng-if="!$slight.useOneLight" class="status-light status-green" title="{{($slight.greenTitle || \'\')}}" ng-class="{\'light-active\': !$slight.isInactive && $slight.isGreen && !$slight.isYellow}"></i> <i ng-if="!$slight.useOneLight && $slight.useYellowLight" class="status-light status-yellow" title="{{($slight.yellowTitle || \'\')}}" ng-class="{\'light-active\': !$slight.isInactive && $slight.isYellow}"></i> <i ng-if="!$slight.useOneLight" class="status-light status-red" title="{{($slight.redTitle || \'\')}}" ng-class="{\'light-active\': !$slight.isInactive && !$slight.isGreen && !$slight.isYellow}"></i> <i ng-if="$slight.useOneLight" class="status-light" title="{{($slight.isGreen ? $slight.greenTitle : $slight.isYellow ? $slight.yellowTitle : $slight.isInactive ? $slight.inactiveTitle : $slight.redTitle) || \'\'}}" ng-class="{\'status-green\': $slight.isGreen && !$slight.isYellow, \'status-yellow\': $slight.useYellowLight && $slight.isYellow, \'status-red\': !$slight.isGreen && !$slight.isYellow, \'light-active\': !$slight.isInactive}"></i></div>');
$templateCache.put('app/theme/components/supervisorsList/adminSupervisorsList.tpl.html','<div class="row" ng-if="$ctrl.isPermitted()"><div class="col-sm-12"><div class="row"><div ng-if="$ctrl.config.positionMembersActionsbar === \'top\' || !$ctrl.config.positionMembersActionsbar" class="col-sm-12 mb-5"><div class="btns-row align-left"><button data-cy="components-supervisorlist-choosesupervisor" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openModal(\'chooseMember\', $ctrl.config.scopeOfMembers)"><span><i data-cy="theme-supervisorslist-add" class="ion-plus"></i> {{ $ctrl.config.btnChooseMemberLabel || (\'components.superVisorsList.selectResponsibleMember\' | translate) }}</span></button> <button ng-if="$ctrl.selectedDivision.id" class="btn btn-default btn-with-icon" ng-click="$ctrl.pushToSubdivisions($ctrl.config.scopeOfMembers, $ctrl.selectedDivision)" ng-show="$ctrl.supervisors.length > 0" data-cy="administration-supervisors-add-supervisor"><span><i class="fa fa-clone"></i> {{ $ctrl.config.btnCopyToSubDivsLabel || (\'components.superVisorsList.copyResponsible\' | translate) }}</span></button></div></div><div class="col-sm-12 mb-10 mt-10"><div ng-show="!($ctrl.supervisors.length > 0)" class="text-center">{{ $ctrl.config.emptyListLabel || (\'components.superVisorsList.noResponsibleAssigned\' | translate) }}</div><div ng-show="$ctrl.supervisors.length" class="horizontal-scroll"><table class="table table-condensed table-hover"><thead><tr><th translate="models.Member.FirstName">Vorname</th><th translate="models.Member.LastName">Nachname</th><th translate="models.Account.EMail">E-Mail</th><th translate="generalTerms.action">Aktion</th></tr></thead><tbody><tr ng-hide="supervisor.delete" ng-repeat="supervisor in $ctrl.supervisors" track=""><td>{{supervisor.FirstName}}</td><td>{{supervisor.LastName}}</td><td><a class="email-link" ng-href="mailto:{{supervisor.EMail}}">{{supervisor.EMail}}</a></td><td><button class="btn btn-xs btn-danger btn-with-icon" title="{{(\'generalTerms.delete\' | translate)}}" ng-click="$ctrl.deleteSupervisor($index)"><i class="ion-ios-trash"></i><span translate="generalTerms.delete">L\xF6schen</span></button></td></tr></tbody></table></div></div><div ng-if="$ctrl.config.positionMembersActionsbar === \'bottom\'" class="col-sm-12 mt-5"><div class="btns-row align-right"><button ng-if="$ctrl.selectedDivision.id" title="{{ $ctrl.config.btnCopyToSubDivsLabel || \'Verantwortliche(n) in Untergliederung(en) kopieren\'}}" class="btn btn-default btn-with-icon" ng-click="$ctrl.pushToSubdivisions($ctrl.config.scopeOfMembers, $ctrl.selectedDivision)" ng-show="$ctrl.supervisors.length > 0" data-cy="administration-supervisors-add-supervisor"><i class="fa fa-clone"></i> <span class="hidden-xs">{{ $ctrl.config.btnCopyToSubDivsLabel || (\'components.superVisorsList.copyResponsible\' | translate) }}</span></button> <button class="btn btn-primary btn-with-icon" ng-click="$ctrl.openModal(\'chooseMember\', $ctrl.config.scopeOfMembers)"><span><i class="ion-plus"></i> {{ $ctrl.config.btnChooseMemberLabel || \'\' }}</span></button></div></div></div></div><div ng-if="$ctrl.config.showBottomActionsbar !== false" class="col-sm-12 mt-10"><div class="btns-row align-right"><div class="col-sm-12 align-right control-side"><button class="btn btn-default btn-with-icon" title="{{(\'components.superVisorsList.discardChanges\' | translate)}}" type="button" ng-click="$ctrl.refresh()" ng-show="$ctrl.changeIndicator.potentialChanges"><i class="ion-ios-trash"></i><span translate="components.superVisorsList.discardChanges">\xC4nderungen verwerfen</span></button> <button class="btn btn-primary btn-with-icon" ng-click="$ctrl.save()" ng-show="$ctrl.changeIndicator.potentialChanges" data-cy="administration-supervisors-save" type="button"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></div></div></div>');
$templateCache.put('app/theme/components/tableConfig/customListName.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.tableConfig.customModalTitle">Bitte hinterlege einen Listennamen</h4></div><div class="modal-body"><div class="section-block red-text"><input type="text" name="listName" class="form-control" ng-model="name" ng-keypress="enter($event)" placeholder="Bitte Namen angeben" translate-attr="{placeholder : \'components.tableConfig.listNamePlaceholder\'}"></div><label class="custom-checkbox" ng-if="showSelectAllCheckBox"><input type="checkbox" ng-model="$parent.preSelectAll" class="custom-control-input"> <span translate="components.tableConfig.preselectAllFields">Alle verf\xFCgbaren Felder vorselektieren</span></label></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="close()" ng-disabled="!name" translate="generalTerms.save">Speichern</button> <button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button></div></div>');
$templateCache.put('app/theme/components/tableConfig/removeList.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="components.tableConfig.deleteList">Liste l\xF6schen</h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="components.tableConfig.removeModalText1" translate-values="{ list: name }">Willst du die Liste "{{ name }}" wirklich entfernen?</p><p><b translate="components.tableConfig.attention">Achtung:</b> {{ (\'components.tableConfig.removeModalText2\' | translate) }}</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i> {{ (\'generalTerms.remove\' | translate) }}</button></div></div>');
$templateCache.put('app/theme/components/tableConfig/tableConfig.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.tableConfig.tblConfigTitle">Tabellenkonfiguration</h4></div><div class="modal-body tableViewConf"><div class="col-12 mb-10"><button class="btn btn-primary btn-with-icon" ng-click="$tableConfigCtrl.createNewList()"><i class="ion-plus"></i><span class="hidden-xs" translate="components.tableConfig.addView">Neue Ansicht hinzuf\xFCgen</span></button></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th class="left-col top-row force-minimal" translate="components.tableConfig.availableFields">Verf\xFCgbare Felder</th><th class="top-row force-minimal text-center"><div translate="components.tableConfig.currentView">Aktuelle Ansicht</div></th><th class="top-row force-minimal text-center" ng-repeat="(key, val) in $tableConfigCtrl.availableLists"><span>{{ val.Name }}</span> <button class="btn btn-danger btn-with-icon btn-xs ml-4" title="Liste umbenennen" translate-attr="{title : \'components.tableConfig.renameList\'}" ng-if="key !== \'current\'" ng-click="$tableConfigCtrl.editListName(key, val)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-with-icon btn-xs" title="Liste l\xF6schen" translate-attr="{title : \'components.tableConfig.deleteList\'}" ng-if="key !== \'current\'" ng-click="$tableConfigCtrl.removeList(key, val)"><i class="ion-ios-trash"></i></button></th><th></th></tr></thead><tbody><tr ng-repeat="field in $tableConfigCtrl.availableFields"><th class="left-col force-minimal vertical-align-middle">{{ field.label | translate }}</th><td ng-repeat="list in $tableConfigCtrl.currentList" class="text-center force-minimal"><label class="custom-checkbox" ng-click="$tableConfigCtrl.tempModification=true"><input type="checkbox" ng-model="list[field.prop]" class="custom-control-input ng-pristine ng-untouched ng-valid ng-not-empty vertical-align-middle"> <span></span></label></td><td ng-repeat="list in $tableConfigCtrl.availableLists" class="text-center force-minimal white-space-no-wrap"><label class="custom-checkbox" ng-class="{\'sortable-counterweight\': $tableConfigCtrl.isSortable(field.prop)}" ng-click="$tableConfigCtrl.updateCurrentSortAggSettings(field.prop, list);"><input type="checkbox" ng-model="list.Fields[field.prop]" class="custom-control-input ng-pristine ng-untouched ng-valid ng-not-empty vertical-align-middle"> <span></span></label> <i class="fa fa-sort-alpha-asc listHandler sortHandler" ng-if="$tableConfigCtrl.isSortable(field.prop)" ng-class="{ \'active\': list.Sort[field.prop] && list.Sort[field.prop].direction===\'asc\', \'disabled\': !list.Fields[field.prop] }" ng-click="$tableConfigCtrl.sort(\'asc\', list, field.prop)"></i> <i class="fa fa-sort-alpha-desc listHandler sortHandler" ng-if="$tableConfigCtrl.isSortable(field.prop)" ng-class="{ \'active\': list.Sort[field.prop] && list.Sort[field.prop].direction===\'desc\', \'disabled\': !list.Fields[field.prop] }" ng-click="$tableConfigCtrl.sort(\'desc\', list, field.prop)"></i> <i class="ion-arrow-shrink listHandler" title="Diese Eigenschaft aggregieren" translate-attr="{title : \'components.tableConfig.aggregate\'}" ng-class="{ \'active\': list.Aggregations[field.prop], \'disabled\': !list.Fields[field.prop], \'full-invisible\': !$tableConfigCtrl.isMaterialList || !$tableConfigCtrl.checkAggExclusion(field.prop) }" ng-click="$tableConfigCtrl.aggregate(field.prop, list)"></i></td><td></td></tr></tbody></table></div></div><div class="modal-footer"><button data-cy="personnel-personnellist-tableconfig-close" ng-click="$close()" type="button" class="btn btn-default" translate="generalTerms.close">Schlie\xDFen</button> <button data-cy="personnel-personnellist-tableconfig-close" ng-click="$tableConfigCtrl.save()" type="button" class="btn btn-primary" translate="generalTerms.save">Speichern</button></div></div>');
$templateCache.put('app/theme/components/tagPicker/tagPicker.html','<div class="arno-tag-picker input-group-with-select input-group {{$tagPick.aTBC || \'arno-tag-picker input-group-with-select\'}}"><div ng-switch="$tagPick.allowNewTags"><div ng-switch-when="true"><ui-select multiple="" ng-model="$parent.$parent.selectedTags" tagging="$tagPick.tagTransform" tagging-label="$tagPick.newTagsTaggingLabel" ng-disabled="disabled" search-enabled="true" validator="$tagPick.validator" class="form-control arno-tag-picker-select {{$tagPick.aTBC}}" append-to-body="$tagPick.aTB"><ui-select-match placeholder="{{defaultLabel | translate}}"><span class="arno-tag-picker-single-tag" ng-style="$tagPick.setColor($item)">{{$item.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="item in tags | filter: $select.search" group-by="$tagPick.onGroupFunc"><span ng-class="{\'text-italic\':item.italic}">{{item.Name}}{{!$tagPick.hideDivisionName && item.Division ? (\' (\' + item.Division.Name +\')\') : \'\'}}</span></ui-select-choices></ui-select></div><div ng-switch-default=""><ui-select multiple="" ng-model="$parent.$parent.selectedTags" ng-disabled="disabled" validator="$tagPick.validator" search-enabled="true" class="form-control arno-tag-picker-select {{$tagPick.aTBC}}" append-to-body="$tagPick.aTB"><ui-select-match placeholder="{{defaultLabel | translate}}"><span class="arno-tag-picker-single-tag" ng-style="$tagPick.setColor($item)">{{$item.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="item in tags | filter: $select.search" group-by="$tagPick.onGroupFunc"><span ng-class="{\'text-italic\':item.italic}">{{item.Name}}{{!$tagPick.hideDivisionName && item.Division ? (\' (\' + item.Division.Name +\')\') : \'\'}}</span></ui-select-choices></ui-select></div></div><span class="input-group-btn {{$tagPick.buttonClass}}"><button type="button" ng-click="$tagPick.emptySelection()" ng-disabled="disabled" class="btn btn-danger"><span class="ion-ios-trash"></span></button></span></div>');
$templateCache.put('app/theme/components/templateUpload/templateUpload.html','<div class="row"><div class="col-xs-12 col-sm-7 col-lg-6"><div><h4 translate="components.templateUpload.general.templates"></h4><div class="mb-20"><h5 class="with-line" toggle-next="false">{{ \'components.templateUpload.general.currentTemplate\' | translate }}</h5><div><button type="button" class="btn btn-primary btn-with-icon" ng-click="self.btnSetStateUpload()" ng-if="self.state !== \'upload\'"><i class="fa fa-upload"></i> <span>{{ self.changeFileBtnText }}</span></button><div id="uploader-quotation" ng-if="self.state === \'upload\'"><div nv-file-drop="" uploadlogo="" data-upload-target="invoice-extended-fileinput" :options="{alias: \'extended\'}" uploader="self.uploader" class="col-9 well arno-file-drop-area" ng-class="!(self.currentExtendedLogoSrc || portalLogo.dataExt) ? \'placeholder\' : \'mt-10\'"><div ng-if="self.currentFileName"><b>{{self.currentFileName}}</b> {{\'components.templateUpload.general.dragOrChange\' | translate}}</div><div ng-if="!self.currentFileName"><span translate="components.templateUpload.general.new"></span> <span>{{self.tplName}}</span> <span translate="components.templateUpload.general.uploadOrClick"></span></div></div><input type="file" accept=".docx" class="hidden" nv-file-select="" id="invoice-extended-fileinput" :options="{alias: \'extended\'}" uploader="self.uploader"> <button class="btn btn-default btn-sm btn-with-icon mr-5 my-5" type="button" uploadlogo="" data-upload-target="invoice-extended-fileinput"><i class="ion-plus"></i><span class="ml-5" translate="components.templateUpload.general.uploadTemplate"></span></button><div class="format-hints mt-25"><h5 translate="components.templateUpload.general.notes"></h5><ul style="padding-left: 1.25em; margin-left: 0"><li class="mt-5" translate="components.templateUpload.general.notLargerDocument"></li><li class="mt-5" translate="components.templateUpload.general.mustWordDocument"></li></ul></div><button class="btn btn-primary" ng-disabled="!self.uploader.queue.length" ng-click="self.uploadTemplate()"><i class="ion-checkmark mb-4"></i> <span translate="generalTerms.save"></span></button></div><div class="row mt-10 mb-10" ng-if="self.template.exists"><div class="col-xs-6 mr-5"><button type="button" class="btn btn-default btn-with-icon" ng-click="self.btnDownloadTemplate()"><i class="fa fa-download"></i> <span translate="components.templateUpload.general.downloadTemplate"></span></button></div><div class="col-xs-6 mt-10"><button type="button" class="btn btn-danger btn-with-icon" ng-click="self.btnRemoveTemplate()" ng-if="self.currentDivision !== \'rootOrg\' || self.allowRootOrgRemoval"><i class="ion-ios-trash"></i> <span translate="components.templateUpload.general.removeTemplate"></span></button></div></div></div></div><div class="mb-20" ng-if="!self.disablePreviewGeneration"><h5 class="with-line" toggle-next="true">{{ \'components.templateUpload.general.templatePreview\' | translate}}</h5><div><div ng-if="!self.template.exists"><p translate="components.templateUpload.general.pleaseUploadTemplate"></p></div><button type="button" class="btn btn-primary btn-with-icon" ng-click="self.btnGeneratePdf()" ng-disabled="!self.template.exists" title="{{self.templateMissingText | translate}}"><i class="fa fa-download"></i> <span translate="components.templateUpload.general.generateTemplatePreview"></span></button></div></div><div class="mb-20"><h5 class="with-line" toggle-next="true">{{ \'components.templateUpload.general.previewTemplatesDownload\' | translate }}</h5><div><p translate="components.templateUpload.general.hereFindPreviewTemplate"></p><button type="button" class="btn btn-default btn-with-icon" ng-click="self.btnDownloadExample()"><i class="fa fa-download"></i> <span>{{self.name}}</span></button></div></div></div></div></div>');
$templateCache.put('app/theme/components/trainingsTreeview/trainingsTreeview.tpl.html','<div class="arno__trainings__treeview__wrapper"><arno-ba-treeview tree-nodes-data="$trainingsTreeviewCtrl.trainingsTreeData" selected-node="$trainingsTreeviewCtrl.selectedNode" node-select="$trainingsTreeviewCtrl.nodeSelect" has-error="$trainingsTreeviewCtrl.hasError"><arno-ba-treeview-header-bar-right-button-row ng-if="$trainingsTreeviewCtrl.uiConfig.showHeaderBarRightRow !== false"><div class="arno__trainings__treeview__header-bar__right"><tag-picker ng-if="$trainingsTreeviewCtrl.uiConfig.showStatusFilter !== false" default-label="(\'components.trainingsTreeView.headerDefaultLabel\' | translate)" tags="$trainingsTreeviewCtrl.TRAINING_STATUS" selected-tags="$trainingsTreeviewCtrl.trainingsStatusFilter"></tag-picker></div></arno-ba-treeview-header-bar-right-button-row><arno-ba-treeview-content><div ng-if="!$trainingsTreeviewCtrl.trainingsTreeData.length && !$trainingsTreeviewCtrl.isLoading" class="text-center mt-40 mb-40"><span ng-show="!$trainingsTreeviewCtrl.trainingsStatusFilter.length" translate="components.trainingsTreeView.noTrainingsPlaceholder"></span> <span ng-show="$trainingsTreeviewCtrl.trainingsStatusFilter.length" translate="components.trainingsTreeView.noSuitableTrainingsPlaceholder"></span></div><div ng-if="!$trainingsTreeviewCtrl.isLoading"><script type="text/ng-template" id="nodesRenderer.tpl.html"><div class="node-embed" ui-tree-handle ng-click="$baTreeviewCtrl.selectNodeHandler(node, this)" ng-class="{\'node-active\': node.isSelected || $baTreeviewCtrl.selectedNode.id === node.id, matched: node.matched}" ng-show="$baTreeviewCtrl.visible(node)" > <a ng-if="node.children.length" class="btn btn-clear btn-xs" ng-click="$baTreeviewCtrl.expandNodeHandler(this, $event)" > <i class="fa" ng-class="{\'fa-chevron-right\': collapsed, \'fa-chevron-down\': !collapsed}"></i> </a> <div ng-class="{inline: node.children.length}"> <div class="ba-treeview-node-icon {{node.iconCls}}" title="{{(node.model.Status ? $trainingsTreeviewCtrl.TRAINING_STATUS_LABELS[node.model.Status] : \'\')}}" ng-class="{\'trainings-tree-trainingsicon\': node.type === $trainingsTreeviewCtrl.NODE_TYPE_TRAINING}" ></div> <span ng-if="node.model.AssignedByExternalSystem"> <i class="fa fa-exchange" title="{{ \'modules.personnel.dossier.overview.qualificationList.externalSystemTooltip\' | translate:{sys:node.model.AssignedByExternalSystem} }}"></i> </span> <span class="ba-treeview-node-label {{node.labelCls}}" ng-bind="node.label"></span> <div class="inline pull-right arno__ba-treeview__panel__item__buttons__right"> <a ng-if="node.type === $trainingsTreeviewCtrl.NODE_TYPE_TRAINING" ng-click="$trainingsTreeviewCtrl.openTrainingStatistics(node, $event)" translate-attr="{title : \'components.trainingsTreeView.viewEvaluation\'}" translate-values="{ template: node.model.TrainingTemplate.Name }" class="btn btn-clear btn-xs" > <i class="fa fa-clock-o arno__ba-treeview__panel__item__buttons__right__icon"></i> </a> <a ng-if="node.type === $trainingsTreeviewCtrl.NODE_TYPE_TRAINING" acl-grant="\'arno.personnel.dossier.trainings.manage\'" ng-click="$trainingsTreeviewCtrl.deleteTraining(node, $event)" translate-attr="{title : \'components.trainingsTreeView.deleteTraining\'}" class="btn btn-clear btn-xs mr-10" > <i class="fa fa-trash arno__ba-treeview__panel__item__buttons__right__icon"></i> </a> </div> </div> </div> <ol ui-tree-nodes="options" ng-model="node.children" ng-class="{hidden: collapsed, displayed: !collapsed}"> <li ng-repeat="node in node.children" ui-tree-node ng-class="{\'ml-25\' : !node.children.length}" class="{{::node.id}}" collapsed="$baTreeviewCtrl.treeviewCollapsed" ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div ui-tree="" data-drag-enabled="false" ng-show="$trainingsTreeviewCtrl.trainingsTreeData.length"><ol id="ba-treeview-root" ng-class="{hidden: collapsed, displayed: !collapsed}" ui-tree-nodes="" ng-model="$trainingsTreeviewCtrl.trainingsTreeData"><li ng-repeat="node in $trainingsTreeviewCtrl.trainingsTreeData" collapsed="$baTreeviewCtrl.treeviewCollapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'" onload="$baTreeviewCtrl = $parent.$parent.$parent.$parent.$parent[\'$baTreeviewCtrl\']"></li></ol></div></div></arno-ba-treeview-content><arno-ba-treeview-footer-bar-right-button-row ng-if="$trainingsTreeviewCtrl.uiConfig.showFooterBarRightRow !== false"><div ng-if="$trainingsTreeviewCtrl.uiConfig.showAddTrainingBtn !== false"><button class="btn btn-primary btn-with-icon mt-10" ng-click="$trainingsTreeviewCtrl.addTraining()"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="components.trainingsTreeView.assignTraining"></span></button></div></arno-ba-treeview-footer-bar-right-button-row></arno-ba-treeview></div>');
$templateCache.put('app/pages/administration/apikey/apiKeyDetails/apiKeyDetails.html','<div ba-panel="" ba-panel-title="self.isNew ? \'modules.administration.apikey.panelTitleDetailsNew\' : \'modules.administration.apikey.panelTitleDetails\'" ba-panel-title-translate-vars="{ name: self.apiKey.Name }"><div><form id="apiKeyDetailsForm" name="self.apiKeyDetailsForm" novalidate="" angular-validator="" angular-validator-submit="self.saveApiKey()"><div class="row"><div class="col-md-6 form-group"><label for="keyName" translate="modules.administration.apikey.fields.name" class="control-label required-label"></label><div><input name="keyName" type="text" class="form-control" ng-model="self.apiKey.Name" required="" required-message="\'\'"></div></div><div class="col-md-6 form-group"><label translate="modules.administration.apikey.fields.generatedKey" class="control-label"></label> <input type="text" class="form-control" ng-model="self.apiKey.Key" disabled="true"></div></div><div class="alert bg-info" ng-if="!self.apiKey.id"><p translate="modules.administration.apikey.permAvailableOnSaveInfo"></p></div><div class="mt-20"><button type="button" class="btn btn-with-icon btn-default" ng-click="self.goBack()"><i class="fa fa-chevron-left"></i> <span translate="generalTerms.back"></span></button> <button type="submit" class="btn btn-with-icon btn-primary" ng-click="self.validationScroll(self.apiKeyDetailsForm); self.back = false"><i class="ion-checkmark"></i> <span translate="generalTerms.save"></span></button> <button type="submit" class="btn btn-with-icon btn-primary" ng-click="self.validationScroll(self.apiKeyDetailsForm); self.back = true"><span translate="generalTerms.saveAndBack"></span></button></div></form></div></div><div ng-if="self.apiKey.id" ba-panel="" ba-panel-title="\'modules.administration.apikey.panelTitlePerms\'" ba-panel-title-translate-vars="{ name: self.apiKey.Name }" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.administration.apikey.manage"><div><div class="input-group permissions-of-role input-group-with-select"><ui-select multiple="" id="permInput" name="permInput" ng-model="self.selectedPermissions" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control arno-roleselect"><ui-select-match placeholder="{{\'modules.administration.roles.chooseRightsOfRoles\' | translate}}"><arno-permission-popover roles-permission-data="self.fetchTooltip($item)" permission-popover-label="$item.Name" permission-popover-placement="bottom" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-match><ui-select-choices repeat="item in self.availablePermissions | filter: { Name: $select.search } | orderBy: \'Group\' track by item.id" ui-select-header-group-selectable="" position="down" group-by="\'Group\'"><arno-permission-popover roles-permission-data="::self.fetchTooltip(item)" permission-popover-label="item.Name" permission-popover-placement="left" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="!self.selectedPermissions.length" ng-click="self.selectedPermissions = []" class="btn btn-danger ion-ios-trash"></button></span></div><div class="mt-40"><button type="button" class="btn btn-with-icon btn-default" ng-click="self.goBack()"><i class="fa fa-chevron-left"></i> <span translate="generalTerms.back"></span></button> <button type="button" class="btn btn-with-icon btn-primary" ng-click="self.savePermissions(false)"><i class="ion-checkmark"></i> <span translate="generalTerms.save"></span></button> <button type="button" class="btn btn-with-icon btn-primary" ng-click="self.savePermissions(true)"><span translate="generalTerms.saveAndBack"></span></button></div></div></div>');
$templateCache.put('app/pages/administration/categories/categoryModal/createCategory.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminCategories.addCat"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" translate="modules.administration.adminCategories.inputCatName"></label> <input type="text" ng-model="$modalCtrl.name" class="form-control" id="nameInput" placeholder="{{\'generalTerms.createName\' | translate: {lowercase: true} }}" maxlength="254" required="true"></div><div class="form-group administration__categories__color-picker__wrapper"><label for="colorInput" translate="modules.administration.adminCategories.inputCatColor"></label><div class="row text-center"><div class="form-group col-xs-12"><material-picker ng-model="$modalCtrl.colorForNewCategory" format="\'hex\'" size="15"></material-picker></div><label class="col-xs-12"><span translate="modules.administration.adminCategories.actuallyColor"><span ng-style="{ \'background-color\': $modalCtrl.colorForNewCategory }" class="arno-colorpicker-preview"></span></span></label></div></div><div class="form-group" ng-if="$modalCtrl.showCategoryUsageField()"><label for="colorInput" translate="modules.administration.adminCategories.usageOfCat"></label><tag-picker default-label="\'modules.administration.adminCategories.definePurpose\' | translate" tags="$modalCtrl.ADMIN_CATEGORIES_USAGE_LIST" selected-tags="$modalCtrl.selectedCategoryUsages" class=""></tag-picker></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$modalCtrl.name" ng-click="$modalCtrl.createCategory($modalCtrl.name, $modalCtrl.colorForNewCategory)" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/categories/categoryModal/deleteCategory.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminCategories.deleteCat"></h4></div><div class="modal-body"><p translate="modules.administration.adminCategories.permanentDeleteCat"></p><p translate="modules.administration.adminCategories.requestDeleteCat" translate-values="{deleteCat: $modalCtrl.category.Name}"></p></div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-with-icon btn-danger pull-right" ng-click="$modalCtrl.confirmDelete($modalCtrl.category.id, $modalCtrl.category.Name)" translate="modules.administration.adminCategories.deleteCat"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/categories/categoryModal/editCategory.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminCategories.editCat"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" translate="modules.administration.adminCategories.inputCatName"></label> <input type="text" ng-model="$modalCtrl.category.Name" class="form-control" id="nameInput" placeholder="{{\'generalTerms.createName\' | translate: {lowercase: true} }}" required="true"></div><div class="form-group administration__categories__color-picker__wrapper"><label for="colorInput" translate="modules.administration.adminCategories.inputCatColor"></label><div class="row text-center"><div class="form-group col-xs-12"><material-picker ng-model="$modalCtrl.category.Color" format="\'hex\'" size="15"></material-picker></div><label class="col-xs-12"><span translate="modules.administration.adminCategories.actuallyColor"><i ng-style="{ \'background-color\': $modalCtrl.category.Color }" class="arno-colorpicker-preview"></i></span></label></div></div><div class="form-group" ng-if="$modalCtrl.showCategoryUsageField()"><label for="colorInput" translate="modules.administration.adminCategories.usageOfCat"></label><tag-picker default-label="\'modules.administration.adminCategories.manageUsageOfCat\' | translate" tags="$modalCtrl.ADMIN_CATEGORIES_USAGE_LIST" selected-tags="$modalCtrl.selectedCategoryUsages"></tag-picker></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$modalCtrl.category.Name" ng-click="$modalCtrl.editCategory($modalCtrl.category.Name, $modalCtrl.category.Color, $modalCtrl.category.id)" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/divisions/deactivationModal/deactivationModal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminDivision.divDeactivate" translate-values="{ deactivation: $modalCtrl.deactivation}"></h4></div><div class="modal-body"><div ng-if="!$modalCtrl.constrainedChildren.length" class="section-block red-text"><p translate="modules.administration.adminDivision.requestModelH4" translate-values="{ divisionText: $modalCtrl.division.text, deactivation: $modalCtrl.deactivation}"></p><p ng-if="$modalCtrl.deactivation" translate="modules.administration.adminDivision.noticeOfDelete"></p><div ng-if="$modalCtrl.constraint.isParent"><p translate="modules.administration.adminDivision.subDivDelete">{{ ($modalCtrl.deactivation ? \'generalTerms.deactivate\' : \'generalTerms.alreadyDelete\') | translate }}:</p><ul><li ng-repeat="division in $modalCtrl.constraint.children.divisions">{{division.name}}</li></ul></div></div><div class="section-block red-text" ng-if="$modalCtrl.constrainedChildren.length"><p translate="modules.administration.adminDivision.becauseDontDelete"></p><ul><li ng-repeat="division in $modalCtrl.constrainedChildren">{{division.name}}</li></ul><p translate="modules.administration.adminDivision.moveOrDeleteDiv"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button ng-if="$modalCtrl.deactivation" type="button" class="btn btn-danger" ng-click="$close()" translate="generalTerms.deactivate"></button> <button ng-if="!$modalCtrl.deactivation && !$modalCtrl.constrainedChildren.length" type="button" class="btn btn-with-icon btn-danger" ng-click="$close()" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/events/fileStorage/fileStorageAdmin.html','<file-storage-admin max-depth="3" folder-data="self.eventFolder" storage-ident="\'event\'" panel-title="\'modules.administration.events.fileStorage.event.folderStructure\'" view-perm-selector="self.viewPermSelector"></file-storage-admin><file-storage-admin max-depth="3" folder-data="self.serviceFolder" storage-ident="\'service\'" panel-title="\'modules.administration.events.fileStorage.service.folderStructure\'" view-perm-selector="self.viewPermSelector"></file-storage-admin>');
$templateCache.put('app/pages/administration/events/serviceTemplates/servicePositionTemplateDetails.html','<div class="row arno-events"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.administration.events.positionDetail.title\'" ba-panel-title-translate-vars="{ isNew: self.isNew, label: self.tpl.ServiceFunction.Function }"><form id="svcTplEditForm" name="svcTplEditForm" novalidate="" angular-validator="" angular-validator-submit="self.submit()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-12 control-label" translate="modules.administration.events.positionDetail.eventType"></label><div class="col-sm-12"><ui-select ng-model="self.chosenServiceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="true" on-select="self.serviceTypeChosen(self.chosenServiceType)" search-enabled="false"><ui-select-match><span ng-if="self.chosenServiceType.none || self.chosenServiceType.deprecated"><i>{{self.chosenServiceType.Name}}</i></span> <span ng-if="!self.chosenServiceType.none && !self.chosenServiceType.deprecated">{{self.chosenServiceType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="serviceType in self.availableServiceTypes"><span>{{serviceType.Name}}</span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group"><label translate="modules.administration.events.positionDetail.eventCategories"></label><tag-picker default-label="\'modules.administration.events.positionDetail.notCategorised\' | translate" tags="self.availableServiceCategories" selected-tags="self.tpl.BaseCategories" hide-division-name="true"></tag-picker></div></div></div><div class="row mt-10"><div class="col-md-6 form-group col-md-push-6"><label for="inputDescription" translate="generalTerms.description"></label> <textarea class="form-control no-resize" style="height: 100px;" id="inputDescription" name="inputDescription" max-char="4000" ng-model="self.tpl.Description" invalid-message="\'\'"></textarea></div><div class="col-md-6 col-md-pull-6"><shift-position-details is-template="true" template-division="self.ctx" position="self.tpl.ServiceFunction" submit="self.positionDetailsSubmit"></shift-position-details></div></div><div class="row btns-row mt-20"><div class="col-md-12 mb-0"><button type="button" class="btn btn-default btn-with-icon" ng-click="self.back()"><i class="ion-chevron-left font-size-12"></i><span translate="generalTerms.back"></span></button> <button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></div></form></div></div></div>');
$templateCache.put('app/pages/administration/events/serviceTemplates/serviceTemplateDetails.html','<div class="row arno-events"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.administration.events.templateOfEvents\'"><form id="svcTplEditForm" name="svcTplEditForm" novalidate="" angular-validator="" angular-validator-submit="$svctd.submitServiceTemplate()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLabel" class="col-sm-12 control-label primary-label required-label" translate="modules.administration.events.nameOfEvent"></label><div class="col-sm-12"><input type="text" class="form-control" id="inputLabel" name="inputSubject" maxlength="254" placeholder="" ng-model="$svctd.tpl.Label" ng-disabled="$svctd.viewMode === \'view\'" required-message="\'modules.administration.events.pleaseGiveNameOfEvent\'" required=""></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-12 control-label" translate="modules.administration.events.typeOfEvent"></label><div class="col-sm-12"><ui-select ng-model="$svctd.chosenServiceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="true" on-select="$svctd.serviceTypeChosen($svctd.chosenServiceType)" search-enabled="false"><ui-select-match><span ng-if="$svctd.chosenServiceType.none || $svctd.chosenServiceType.deprecated"><i>{{$svctd.chosenServiceType.Name}}</i></span> <span ng-if="!$svctd.chosenServiceType.none && !$svctd.chosenServiceType.deprecated">{{$svctd.chosenServiceType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="serviceType in $svctd.availableServiceTypes"><span>{{serviceType.Name}}</span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group"><label translate="modules.administration.events.categoryOfEvent"></label><tag-picker default-label="\'modules.administration.events.noCatEvents\'" tags="$svctd.availableServiceCategories" selected-tags="$svctd.tpl.BaseCategories" hide-division-name="true"></tag-picker></div></div></div><div class="mt-10"><shift-template options="$svctd.shiftTemplateOpts"></shift-template></div><div class="row btns-row mt-20"><div class="col-md-12 mb-0"><button type="button" class="btn btn-default btn-with-icon" ng-click="$svctd.back()"><i class="ion-chevron-left font-size-12"></i><span translate="modules.administration.events.back"></span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="!$svctd.tpl.ServiceShifts.length"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></div></form></div></div></div>');
$templateCache.put('app/pages/administration/events/serviceTemplates/serviceTemplates.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.administration.events.manageEventTemplate\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.administration.events.manage"><div class="row btns-row"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$svct.openTemplate()" ng-disabled="!$svct.ctxSelected"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.administration.events.addEventTemplate"></span></button></div></div><div class="row"><div class="col-md-12"><div class="table-responsive" ng-if="$svct.ctxSelected"><table st-table="$svct.serviceTemplateCollection" st-pipe="$svct.getServiceTemplateData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Label" st-sort-default="true" translate="modules.administration.events.template"></th><th translate="modules.administration.events.typeOfEvent"></th><th st-sort="createdAt" translate="modules.administration.events.eventCreated"></th><th st-sort="updatedAt" translate="modules.administration.events.lastUpdateEvent"></th><th translate="modules.administration.events.actionEvent"></th></tr></thead><tbody><tr ng-repeat="serviceTemplate in $svct.serviceTemplateCollection.rows"><td class="align-left-force"><span>{{ ::serviceTemplate.Label }}</span></td><td class="align-left-force"><span>{{ ::serviceTemplate.ServiceType.Name || \'---\' }}</span></td><td class="align-left-force"><span>{{ ::serviceTemplate.createdAt | date : \'dd.MM.yyyy, HH:mm\' }} <span translate="modules.administration.events.clock"></span></span></td><td class="align-left-force"><span>{{ ::serviceTemplate.updatedAt | date : \'dd.MM.yyyy, HH:mm\' }} <span translate="modules.administration.events.clock"></span></span></td><td class="align-left-force"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$svct.openTemplate(serviceTemplate)" title="modules.administration.events.eventTemplateEdit"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$svct.removeTemplate(serviceTemplate)" title="modules.administration.events.eventTemplateDelete"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="$svct.serviceTemplateCollection.rows && $svct.serviceTemplateCollection.rows.length === 0"><td class="text-center" colspan="99"><i translate="modules.administration.events.noEventTemplate"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$svct.serviceTemplateConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div ng-if="!$svct.ctxSelected" translate="modules.administration.events.eventTemplateOfData"></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.administration.events.position.title\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-division-selector-entry-permission="arno.administration.events.manage"><div class="row btns-row"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$svct.openPositionTemplate()" ng-disabled="!$svct.ctxSelected"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.administration.events.position.add"></span></button></div></div><div class="row"><div class="col-md-12"><div class="table-responsive" ng-if="$svct.ctxSelected"><table st-table="$svct.servicePositionTemplateCollection" st-pipe="$svct.getServicePositionTemplateData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Function" st-sort-default="true">{{ \'modules.administration.events.position.function\' | translate }}</th><th>{{ \'modules.administration.events.position.qualification\' | translate }}</th><th>{{ \'modules.administration.events.position.activity\' | translate }}</th><th>{{ \'modules.administration.events.position.eventCategory\' | translate }}</th><th st-sort="createdAt">{{ \'modules.administration.events.position.created\' | translate }}</th><th st-sort="updatedAt">{{ \'modules.administration.events.position.updated\' | translate }}</th><th>{{ \'generalTerms.actions\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Function" maxlength="254" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Qualification" maxlength="254" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Activity" maxlength="254" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="servicePositionTemplate in $svct.servicePositionTemplateCollection.rows"><td class="align-left-force"><span>{{ ::servicePositionTemplate.Function }}</span></td><td class="align-left-force"><ul class="pl-20"><li ng-repeat="quali in servicePositionTemplate.Qualifications">{{quali.Name}}</li></ul></td><td class="align-left-force"><ul class="pl-20"><li ng-repeat="activity in servicePositionTemplate.Activities">{{activity.Title}}</li></ul></td><td class="align-left-force"><span>{{ ::servicePositionTemplate.ServiceType.Name || \'---\' }}</span></td><td class="align-left-force"><span>{{ ::servicePositionTemplate.createdAt | date : \'dd.MM.yyyy, HH:mm\' }} <span translate="modules.administration.events.clock"></span></span></td><td class="align-left-force"><span>{{ ::servicePositionTemplate.updatedAt | date : \'dd.MM.yyyy, HH:mm\' }} <span translate="modules.administration.events.clock"></span></span></td><td class="align-left-force"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$svct.openPositionTemplate(servicePositionTemplate)" title="{{ \'modules.administration.events.position.editTooltip\' | translate }}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$svct.removePositionTemplate(servicePositionTemplate)" title="{{ \'modules.administration.events.position.deleteTooltip\' | translate }}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="$svct.servicePositionTemplateCollection.rows && $svct.servicePositionTemplateCollection.rows.length === 0"><td class="text-center" colspan="99"><i translate="modules.administration.events.position.noTemplates"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$svct.servicePositionTemplateConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div ng-if="!$svct.ctxSelected" translate="modules.administration.events.position.selectDivision"></div></div></div></div></div></div>');
$templateCache.put('app/pages/administration/events/serviceTypes/serviceTypes.html','<div ba-panel="" ba-panel-title="\'modules.administration.events.manageEventType\'"><div class="form-group"><button class="btn btn-with-icon btn-primary" ng-click="$ctrl.open(\'app/pages/administration/events/serviceTypes/serviceTypeModal/addServiceType.html\', \'md\', null)"><i class="ion-plus"></i><span translate="modules.administration.events.addEventType"></span></button></div><div class="table-responsive"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.serviceTypes" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Name" st-sort-default="true" translate="generalTerms.createName"></th><th translate="modules.administration.events.actionEvent"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$ctrl.displayedCollection.length" ng-repeat="serviceType in $ctrl.displayedCollection" class="arno-pointing-pointer" ng-click="$ctrl.edit(serviceType)"><td>{{ ::serviceType.Name }}</td><td class="arno-table-button-cell arno-default-pointer" ng-click="$ctrl.prevent($event)"><button class="btn btn-default btn-with-icon btn-xs" title="modules.administration.events.editEventGroup" ng-click="$ctrl.open(\'app/pages/administration/events/serviceTypes/serviceTypeModal/addServiceType.html\', \'md\', serviceType)"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteServiceType(serviceType)"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></td></tr><tr ng-if="!$ctrl.displayedCollection.length"><td colspan="9" class="text-center"><i translate="modules.administration.events.noEventTypes"></i></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/administration/finances/costCenters/costCenters.html','<div ba-panel="" ba-panel-title="\'modules.administration.finances.costCenters.title\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector="false"><div class="row btns-row mb-12"><div class="col-xs-6"><button type="button" ng-if="$ctrl.hasManagePermission" class="btn btn-with-icon btn-primary mb-0" ng-click="$ctrl.addCostCenter()"><i class="ion-plus"></i> <span translate="modules.administration.finances.costCenters.addBtnLabel">Kostenstelle hinzuf\xFCgen</span></button></div><div class="col-xs-6 d-inline-flex align-items-center justify-content-end"><div class="input-group maxw-240 mb-0"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$ctrl.searchTerm" ng-change="$ctrl.searchTermChanged($ctrl.searchTerm)" ng-model-options="{ debounce: 500 }" class="form-control with-default-addon input-sm" placeholder="{{ \'modules.administration.finances.costCenters.searchIdOrName\' | translate }}"></div></div></div><div class="row mt-12"><div class="col-md-12"><uib-accordion><uib-accordion-group ng-repeat="costCenter in $ctrl.filteredCostCenters | orderBy:[\'Identifier\', \'Name\']" ng-click="$ctrl.expandedCostCenterTab(costCenter)" ng-init="costCenter.tabOpen = costCenter.tabOpen || false" is-open="costCenter.tabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span><i class="ion-ios-people mr-4"></i> <strong>{{ costCenter.Identifier || \'----\' }}</strong></span> <span class="ml-2">| {{costCenter.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': costCenter.tabOpen, \'ion-chevron-right\': !costCenter.tabOpen}"></i><div class="btn-toolbar pull-right no-padding" ng-click="$ctrl.preventPropagation($event);"><button type="button" ng-if="$ctrl.hasManagePermission" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.editCostCenter(costCenter)"><i class="ion-edit"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.costCenters.editBtnLabel">Bearbeiten</span></button> <button type="button" ng-if="$ctrl.hasManagePermission" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteCostCenter(costCenter);"><i class="ion-ios-trash"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.costCenters.deleteBtnLabel">L\xF6schen</span></button></div></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-condensed table-hover"><col width="15%"><col width="35%"><col width="10%"><col width="20%"><tbody class="without-top-border"><tr ng-repeat="costCenterSpecification in (costCenter.CostCenterSpecifications || []) | orderBy:[\'Identifier\', \'Name\'] track by $index"><td class="align-left-force"><i class="fa fa-money mr-4"></i> <strong>{{ costCenterSpecification.Identifier || \'----\' }}</strong></td><td class="align-left-force">{{ costCenterSpecification.Name }}</td><td class="align-left-force">{{ costCenterSpecification.TaxRatePercent }}{{ costCenterSpecification.TaxRatePercent !== null ? \'%\' : \'---\'}}</td><td class="align-left-force">{{ costCenterSpecification.TaxRateReason || \'\' }}</td><td>{{ costCenterSpecification.Hint }}</td><td class="arno-default-pointer align-right-force" ng-click="$ctrl.preventPropagation($event);"><button type="button" ng-if="$ctrl.hasManagePermission" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.editSpecification(costCenterSpecification, costCenter)"><i class="ion-edit"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.costCenters.editSpecificationBtnLabel">Bearbeiten</span></button> <button type="button" ng-if="$ctrl.hasManagePermission" ng-disabled="(costCenter.CostCenterSpecifications || []).length < 2" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteSpecification(costCenterSpecification)"><i class="ion-ios-trash"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.costCenters.deleteSpecificationBtnLabel">L\xF6schen</span></button></td></tr><tr ng-if="!(costCenter.CostCenterSpecifications || []).length"><td colspan="2" class="text-center"><i translate="modules.administration.finances.costCenters.emptySpecificationsMsg">Keine Kostenstellenauspr\xE4gungen vorhanden</i></td></tr></tbody></table></div></div></div><div class="row"><div class="col-md-12 mt-10"><button ng-if="$ctrl.hasManagePermission" type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.preventPropagation($event); $ctrl.addSpecification(costCenter)"><i class="ion-plus"></i> <span translate="modules.administration.finances.costCenters.addSpecificationBtnLabel">Auspr\xE4gung hinzuf\xFCgen</span></button></div></div></uib-accordion-group></uib-accordion><div ng-if="!$ctrl.costCenters.length" class="text-center mb-10"><i translate="modules.administration.finances.costCenters.emptyListMsg">Keine Kostenstellen vorhanden</i></div><div ng-if="$ctrl.costCenters.length && !$ctrl.filteredCostCenters.length" class="text-center mb-10"><i translate="modules.administration.finances.costCenters.emptyResultListMsg">Keine Kostenstellen gefunden</i></div></div></div></div>');
$templateCache.put('app/pages/administration/finances/general/general.html','<div ng-if="self.isPermittedInOrg(\'arno.administration.finances.quotationsAndInvoices.manage\')"><div ba-panel="" ba-panel-title="\'modules.administration.finances.general.payableUntilPeriod\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-4"><div class="qualification-form-validity-input mb-0"><input type="number" class="form-control" min="0" step="1" ng-model="self.payableUntilPeriod"> <span translate="generalTerms.days">Tage</span></div></div></div><div class="row mt-20"><div class="col-md-12"><button type="submit" ng-disabled="(!self.payableUntilPeriod && self.payableUntilPeriod !== 0) || self.payableUntilPeriod < 0" ng-click="self.savePayableUntil()" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></div></div></div><div ng-if="self.invoiceExportAllowed"><div ba-panel="" ba-panel-title="\'modules.administration.finances.general.exportInvoices\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="arno.administration.finances.quotationsAndInvoices.manage"><div class="col-md-8 p-0"><invoice-export-input invoice-export-recipient="self.invoiceExportRecipient" invoice-export-settings="self.invoiceExportSettings" invoice-export-ctx="self.invoiceExportCtx"></invoice-export-input></div></div></div>');
$templateCache.put('app/pages/administration/finances/prices/prices.html','<div class="tab-content"><div><div class="arno-administration-finances-prices-panel-header clearfix"><div class="btn-toolbar pull-left" ng-if="self.priceType != PRICE_ITEM_TYPE.MATERIAL_TYPE || self.materialPricesViewMode != MATERIAL_PRICES_VIEWMODE.MATERIALS"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="controls.table.itemsPerPage"></span> ({{ self.currentTableConf.tableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="self.changePageSize(self.currentTableConf, i)">{{ i }}</a></li></ul></div><ba-switcher class="btn-height v-align-top ml-5" ng-if="self.priceType !== \'CUSTOM\'" switcher-style="primary" switcher-value="self.currentTableConf.tableConfig.FilterMissingPrices" switcher-width="130" switcher-keys="self.fmpKeys" switcher-hints="self.fmpHints"></ba-switcher></div><div class="btn-toolbar pull-right"><button type="button" ng-if="self.hasCurrentCtxManagePermission && self.priceType == PRICE_ITEM_TYPE.CUSTOM" class="btn btn-with-icon btn-primary mb-0 pull-right" ng-click="self.addCustomPriceItem()"><i class="ion-plus"></i> <span class="hidden-xs" translate="modules.administration.finances.prices.addBtnLabel">Preiselement hinzuf\xFCgen</span></button><div class="btn-group btn-group-toggle" data-toggle="buttons" ng-if="self.priceType === PRICE_ITEM_TYPE.MATERIAL_TYPE"><label class="btn btn-default" ng-class="{ \'active\': self.materialPricesViewMode === MATERIAL_PRICES_VIEWMODE.MATERIAL_TYPES }" ng-click="self.changeMaterialPricesViewMode(MATERIAL_PRICES_VIEWMODE.MATERIAL_TYPES)"><i class="fa fa-sitemap"></i> <input type="radio" name="recentMaterialPricesViewMode" autocomplete="off"> <span class="hidden-xs ml-4" translate="modules.administration.finances.prices.materials.materialTypesView"></span></label> <label class="btn btn-default ml-0" ng-class="{ \'active\': self.materialPricesViewMode === MATERIAL_PRICES_VIEWMODE.MATERIALS }" ng-click="self.changeMaterialPricesViewMode(MATERIAL_PRICES_VIEWMODE.MATERIALS)"><i class="fa fa-table"></i> <input type="radio" name="recentMaterialPricesViewMode" autocomplete="off"> <span class="hidden-xs ml-4" translate="modules.administration.finances.prices.materials.materialsView"></span></label></div></div></div><script type="text/ng-template" id="financesPricesPanelHeaderHelpTooltip.tpl.html"><div class="p-5"> <h6>{{(\'generalTerms.legend\' | translate)}}:</h6> <table> <tr> <td><i class="fa fa-circle-o text-success mr-10"></i></td> <td translate="modules.administration.finances.prices.overview.externalPriceTooltip"></td> </tr> <tr> <td><i class="fa fa-circle text-gray"></i></td> <td translate="modules.administration.finances.prices.overview.internalPriceTooltip"></td> </tr> </table> </div></script><div class="row" ng-if="self.priceType != PRICE_ITEM_TYPE.MATERIAL_TYPE || self.materialPricesViewMode != MATERIAL_PRICES_VIEWMODE.MATERIALS"><div class="col-xs-12"><div class="table-responsive mb-12"><table st-table="self.currentTableConf.displayedCollection" st-pipe="self.currentTableConf.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th ng-show="self.currentTableConf.tableConfig.Title" st-sort="Title" st-sort-default="{{self.currentTableConf.tableConfig.Sort}}">{{ \'modules.administration.finances.prices.overview.titleCol\' | translate }}</th><th ng-show="self.currentTableConf.tableConfig.Function" st-sort="Function" st-sort-default="true">{{ \'modules.administration.finances.prices.overview.functionCol\' | translate }}</th><th ng-show="self.currentTableConf.tableConfig.Name" st-sort="Name" st-sort-default="true">{{ \'modules.administration.finances.prices.overview.nameCol\' | translate}}</th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerHour" st-sort="ExternalPricePerHour">{{ \'modules.administration.finances.prices.overview.externalPricePerHourCol\' | translate }} <span uib-tooltip-template="\'financesPricesPanelHeaderHelpTooltip.tpl.html\'" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="false"><i class="fa fa-info-circle"></i></span></th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerDay" st-sort="ExternalPricePerDay">{{ \'modules.administration.finances.prices.overview.externalPricePerDayCol\' | translate }} <span uib-tooltip-template="\'financesPricesPanelHeaderHelpTooltip.tpl.html\'" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="false"><i class="fa fa-info-circle"></i></span></th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerCount" st-sort="ExternalPricePerCount">{{ \'modules.administration.finances.prices.overview.externalPricePerCountCol\' | translate }} <span uib-tooltip-template="\'financesPricesPanelHeaderHelpTooltip.tpl.html\'" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="false"><i class="fa fa-info-circle"></i></span></th><th ng-show="self.currentTableConf.tableConfig.CostCenterSpecification" colspan="3" translate="modules.administration.finances.prices.overview.costCenterSpecCol">Kostenstellenauspr\xE4gung</th><th translate="modules.administration.finances.prices.overview.actionsCol" class="text-right">Aktionen</th></tr><tr><th ng-show="self.currentTableConf.tableConfig.Title"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Title" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="self.currentTableConf.tableConfig.Function"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Function" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="self.currentTableConf.tableConfig.Name"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerHour"></th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerDay"></th><th ng-show="self.currentTableConf.tableConfig.ExternalPricePerCount"></th><th ng-show="self.currentTableConf.tableConfig.CostCenterSpecification" colspan="3"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="CostCenterSpecification" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="self.currentTableConf.displayedCollection && !(self.currentTableConf.tableConfig.FilterMissingPrices == true && priceItem.PriceItemOverrides[0])" ng-repeat="priceItem in self.currentTableConf.displayedCollection" ng-click="self.editPriceItem(priceItem)" class="editable-row arno-pointing-pointer"><td><i ng-class="{\'ion-ios-people-outline\': priceItem.DivisionId, \'ion-ios-people\': !priceItem.DivisionId && !priceItem.PriceItemOverrides[0], \'fa fa-exchange\': priceItem.PriceItemOverrides[0]}" title="{{::(self.getTooltipForMainCol(priceItem) | translate)}}"></i> <span ng-show="self.currentTableConf.tableConfig.Title">{{ priceItem.Title || \'\' }}</span> <span ng-show="self.currentTableConf.tableConfig.Function">{{ priceItem.Function || \'\' }}</span> <span ng-show="self.currentTableConf.tableConfig.Name">{{ priceItem.Name || \'\' }}</span></td><td ng-show="self.currentTableConf.tableConfig.ExternalPricePerHour"><div ng-if="priceItem.PriceItemOverrides[0].ExternalPricePerHour != null || (!priceItem.PriceItemOverrides[0] && priceItem.ExternalPricePerHour != null)" title="{{::(\'modules.administration.finances.prices.overview.externalPriceTooltip\' | translate)}}"><i class="fa fa-circle-o text-success"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].ExternalPricePerHour : priceItem.ExternalPricePerHour ) | currency: \'\u20AC\' }}</div><div ng-if="priceItem.PriceItemOverrides[0].InternalPricePerHour != null || (!priceItem.PriceItemOverrides[0] && priceItem.InternalPricePerHour != null)"><span title="{{::(\'modules.administration.finances.prices.overview.internalPriceTooltip\' | translate)}}"><i class="fa fa-circle text-gray"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].InternalPricePerHour : priceItem.InternalPricePerHour) | currency: \'\u20AC\' }}</span></div></td><td ng-show="self.currentTableConf.tableConfig.ExternalPricePerDay"><div ng-if="priceItem.PriceItemOverrides[0].ExternalPricePerDay != null || (!priceItem.PriceItemOverrides[0] && priceItem.ExternalPricePerDay != null)"><span title="{{::(\'modules.administration.finances.prices.overview.externalPriceTooltip\' | translate)}}"><i class="fa fa-circle-o text-success"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].ExternalPricePerDay : priceItem.ExternalPricePerDay) | currency: \'\u20AC\' }}</span></div><div ng-if="priceItem.PriceItemOverrides[0].InternalPricePerDay != null || (!priceItem.PriceItemOverrides[0] && priceItem.InternalPricePerDay != null)"><span title="{{::(\'modules.administration.finances.prices.overview.internalPriceTooltip\' | translate)}}"><i class="fa fa-circle text-gray"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].InternalPricePerDay : priceItem.InternalPricePerDay) | currency: \'\u20AC\' }}</span></div></td><td ng-show="self.currentTableConf.tableConfig.ExternalPricePerCount"><div ng-if="priceItem.PriceItemOverrides[0].ExternalPricePerCount != null || (!priceItem.PriceItemOverrides[0] && priceItem.ExternalPricePerCount != null)"><span title="{{::(\'modules.administration.finances.prices.overview.externalPriceTooltip\' | translate)}}"><i class="fa fa-circle-o text-success"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].ExternalPricePerCount : priceItem.ExternalPricePerCount) | currency: \'\u20AC\' }}</span></div><div ng-if="priceItem.PriceItemOverrides[0].InternalPricePerCount != null || (!priceItem.PriceItemOverrides[0] && priceItem.InternalPricePerCount != null)"><span title="{{::(\'modules.administration.finances.prices.overview.internalPriceTooltip\' | translate)}}"><i class="fa fa-circle text-gray"></i> {{ (priceItem.PriceItemOverrides[0] ? priceItem.PriceItemOverrides[0].InternalPricePerCount : priceItem.InternalPricePerCount) | currency: \'\u20AC\' }}</span></div></td><td class="arno-table-button-cell arno-default-pointer" ng-click="self.preventPropagation($event)"><div ng-show="!rowform.$visible" class="pull-right"><button class="btn btn-default btn-with-icon btn-xs" ng-if="self.divisionId == priceItem.DivisionId || (((priceItem || {}).PriceItemOverrides || [])[0] || {}).DivisionId == self.divisionId" ng-click="self.editPriceItem(priceItem)" title="{{ ::(\'modules.administration.finances.prices.editBtnLabel\' | translate) }}"><i class="fa" ng-class="{ \'fa-pencil\': self.canManageItem(priceItem), \'fa-eye\': !self.canManageItem(priceItem)}"></i> <span class="hidden-xs hidden-sm" translate="{{ self.canManageItem(priceItem) ? \'modules.administration.finances.prices.editBtnLabel\' : \'modules.administration.finances.prices.viewBtnLabel\'}}"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="self.showCopyOption && !self.canOverrideItem(priceItem) && self.canManageItem(priceItem)" ng-click="self.copyPriceItem(priceItem)"><i class="ion-ios-copy"></i> <span class="hidden-xs hidden-sm" translate="generalTerms.copy"></span></button> <button ng-show="self.canOverrideItem(priceItem)" class="btn btn-default btn-with-icon btn-xs" ng-click="self.overridePriceItem(priceItem)" title="{{ ::(\'modules.administration.finances.prices.overrideHelpTooltip\' | translate) }}"><i class="fa fa-exchange"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.prices.overrideBtnLabel"></span></button> <button ng-if="self.canManageItem(priceItem)" class="btn btn-danger btn-with-icon btn-xs" ng-disabled="!self.hasPriceDefinition(priceItem) && !priceItem.PriceItemOverrides[0]" ng-click="self.deletePriceItem(priceItem)" title="{{ ::(\'modules.administration.finances.prices.deleteBtnLabel\' | translate) }}"><i class="ion-ios-trash"></i> <span class="hidden-xs hidden-sm" translate="modules.administration.finances.prices.deleteBtnLabel"></span></button></div></td></tr><tr ng-if="(self.currentTableConf.displayedCollection || []).length === 0"><td class="text-center" colspan="{{self.getFullCSpan(self.currentTableConf.tableConfig)}}"><i translate="modules.administration.finances.prices.overview.noPrices"></i></td></tr></tbody><tfoot><tr ng-if="(self.currentTableConf.displayedCollection || []).length"><td colspan="16" class="text-center"><div st-pagination="" st-items-by-page="self.currentTableConf.tableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div></div></div><div ng-if="self.priceType == PRICE_ITEM_TYPE.MATERIAL_TYPE && self.materialPricesViewMode == MATERIAL_PRICES_VIEWMODE.MATERIALS"><arno-materials-prices initial-material-types="self.initialMaterialTypesTreeData" context="self.ctx"></arno-materials-prices></div></div>');
$templateCache.put('app/pages/administration/finances/prices/pricesTabs.html','<div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default"><tabs data="self.pricesTabs" template-url="app/pages/administration/finances/prices/pricesTabset.html"></tabs></div>');
$templateCache.put('app/pages/administration/finances/prices/pricesTabset.html','<div><uib-tabset active="tabs.active" class="suppress-tab-content"><uib-tab class="tab {{tab.class}}" ng-repeat="tab in tabs" disable="tab.disable" ng-click="go(tab)"><uib-tab-heading ng-bind-html="tab.heading"></uib-tab-heading></uib-tab><division-selector multiple="false" allow-org-selection="true" entry-permission="arno.administration.finances.prices.manage"></division-selector></uib-tabset><ui-view></ui-view></div>');
$templateCache.put('app/pages/administration/finances/quotationsAndInvoices/quotationsAndInvoices.html','<div class="row"><div class="col-12"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default"><div class="divisionAtTab"><uib-tabset active="$ctrl.activeTabIndex" class="suppress-tab-content"><uib-tab class="tab" ng-repeat="tab in $ctrl.tabs" ng-click="$ctrl.setTab(tab)"><uib-tab-heading><span>{{tab.heading}}</span></uib-tab-heading></uib-tab></uib-tabset><division-selector multiple="false" allow-org-selection="true" entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}"></division-selector><div class="clearfix"></div></div><div class="panel-body"><template-upload ctx="$ctrl.currentDivision" type="$ctrl.tabs[$ctrl.activeTabIndex].type" template="$ctrl.docxTemplate" i18n-key="$ctrl.tabs[$ctrl.activeTabIndex].type"></template-upload></div></div></div></div>');
$templateCache.put('app/pages/administration/language/modals/editTranslationModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.language.editDialogTitle"></h4></div><div class="modal-body"><div class="row mb-20" ng-repeat="lang in $modalCtrl.translations.availableLangs"><div class="col-md-2"><label translate="{{ (\'languages.\' + lang) }}"></label></div><div class="col-md-10"><div class="pull-right"><button type="button" class="btn btn-default btn-with-icon btn-sm" ng-disabled="$modalCtrl.retObj[lang] === $modalCtrl.translations.custom[lang] || !$modalCtrl.translations.custom[lang]" ng-click="$modalCtrl.undo(lang)" title="{{ \'generalTerms.undo\' | translate }}"><i class="fa fa-undo"></i></button> <button type="button" class="btn btn-danger btn-with-icon btn-sm" ng-disabled="!$modalCtrl.retObj[lang]" ng-click="$modalCtrl.reset(lang)" title="{{ \'generalTerms.reset\' | translate }}"><i class="ion-ios-trash"></i></button></div></div><div class="col-md-12 mt-5"><textarea type="text" class="form-control" placeholder="{{ $modalCtrl.translations.original[lang] }}" ng-model="$modalCtrl.retObj[lang]"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss(\'USER_DISMISS\')" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-primary" ng-click="$close({ ret: $modalCtrl.retObj, old: $modalCtrl.translations })"><i class="ion-checkmark"></i> <span translate="generalTerms.save"></span></button></div></div>');
$templateCache.put('app/pages/administration/material/exportTemplates/materialExportTemplates.html','<div class="row"><div class="col-12"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default"><div><uib-tabset active="self.activeTabIndex" class="suppress-tab-content"><uib-tab class="tab" ng-repeat="tab in self.tabs" ng-click="self.setTab(tab)"><uib-tab-heading><span>{{tab.heading}}</span></uib-tab-heading></uib-tab></uib-tabset><div class="clearfix"></div></div><div class="panel-body"><template-upload ctx="\'rootOrg\'" type="self.currentTab.type" template="self.docxTemplate" i18n-key="self.currentTab.type" disable-preview-generation="true" allow-root-org-removal="true"></template-upload></div></div></div></div>');
$templateCache.put('app/pages/administration/material/fileStorage/fileStorageAdminMaterial.html','<file-storage-admin max-depth="3" folder-data="$ctrl.folderData" storage-ident="\'material\'" panel-title="\'modules.administration.material.fileStorage.folderStructure\'" view-perm-selector="$ctrl.viewPermSelector"></file-storage-admin>');
$templateCache.put('app/pages/administration/material/inspection/inspection.html','<div ba-panel="" ba-panel-title="\'navigation.administration.material.inspection\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="true" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.administration.material.inspection.manage"><div class="mb-20"><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ self.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="self.setPageSize(i)">{{ i }}</a></li></ul></div><button type="button" ng-click="self.openModal(\'createInspection\', \'md\')" class="btn btn-primary btn-with-icon pull-right"><i class="ion-plus"></i> <span translate="modules.administration.material.inspection.addInspection"></span></button></div><div class="table-responsive"><table st-table="self.displayedCollection" st-pipe="self.getInspections" class="table"><thead><tr class="sortable"><th>ID</th><th st-sort="Title" translate="generalTerms.title"></th><th translate="generalTerms.description"></th><th translate="generalTerms.active"></th><th translate="modules.material.addMaterial.inspection.inspectionEventsHeader"></th><th translate="generalTerms.actions"></th></tr><tr><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="row in self.displayedCollection"><td><span>{{ row.id }}</span></td><td><span>{{ row.Name }}</span></td><td><span>{{ row.Description }}</span></td><td>{{ (row.Active ? \'generalTerms.yes\' : \'generalTerms.no\') | translate }}</td><td>{{ row.InspectionEventCount || \'-\' }}</td><td><button class="btn btn-default btn-with-icon btn-xs" ng-click="self.openDetails(row)" title="{{ \'generalTerms.edit\' | translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-default btn-with-icon btn-xs btn-danger" ng-if="!row.Assigned" ng-click="self.deleteInspection(row)" title="{{ \'generalTerms.delete\' | translate }}"><i class="fa fa-trash"></i><span translate="generalTerms.delete"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-click="self.setInspectionState(row.id, !row.Active)" ng-class="{ \'btn-success-outline\': !row.Active, \'btn-danger\': row.Active }" title="{{ (row.Active ? \'generalTerms.deactivate\' : \'generalTerms.activate\') | translate }}"><i class="ion-checkmark" ng-if="!row.Active"></i> <i class="fa fa-ban" ng-if="row.Active"></i> <span>{{ (row.Active ? \'generalTerms.deactivate\' : \'generalTerms.activate\') | translate }}</span></button></td></tr><tr ng-if="self.displayedCollection && self.displayedCollection.length === 0"><td class="text-center" colspan="99"><i translate="modules.administration.material.inspection.noInspection"></i></td></tr></tbody><tfoot><tr ng-if="self.displayedCollection && self.displayedCollection.length"><td colspan="99" class="text-center"><st-pagination st-items-by-page="self.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/administration/material/materialTypes/materialTypes.html','<div class="row"><script type="text/ng-template" id="actionButtons.tpl.html"><hr> <div class="d-flex align-items-center justify-content-between"> <div> <button ng-click="$ctrl.deleteSelectedNode()" class="btn btn-with-icon" ng-if="$ctrl.canDeleteNode()" ng-disabled="$ctrl.deleteButtonDisabled()"> <i class="ion-ios-trash"></i> {{\'generalTerms.delete\' | translate}} </button> </div> <div> <button ng-click="$ctrl.saveNodes()" type="submit" class="btn btn-primary btn-with-icon"> <i class="ion-checkmark"></i> {{\'generalTerms.save\' | translate}} </button> </div> </div></script><div class="col-xs-12 col-sm-7 col-lg-6"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default"><div class="divisionAtTab"><uib-tabset active="$ctrl.activeTabIndex" class="suppress-tab-content"><uib-tab class="tab {{tab.class}}" ng-repeat="tab in $ctrl.tabs" ng-click="$ctrl.setTab(tab)"><uib-tab-heading><i ng-class="::tab.icon"></i> <span>{{tab.heading}}</span></uib-tab-heading></uib-tab></uib-tabset><division-selector multiple="false" entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}" allow-org-selection="true"></division-selector><div class="clearfix"></div></div><arno-material-types-tree-view material-types-tree-data="$ctrl.materialTypesTreeData" selected-material-type="$ctrl.selectedMaterialType" tree-options="$ctrl.treeOptions" on-select-node="$ctrl.selectNode"><top-buttons><button type="button" class="btn btn-default btn-sm" ng-show="$ctrl.selectedMaterialType" ng-click="$ctrl.selectNode(false)">{{\'modules.administration.material.materialTypes.resetSelection\' | translate }}</button> <button class="btn btn-primary btn-sm btPn-with-icon" type="button" ng-disabled="!$ctrl.canAddNewNode()" ng-click="$ctrl.addNewNode()"><i class="ion-plus"></i> {{\'modules.administration.material.materialTypes.newMaterialType\' | translate}}</button></top-buttons><bottom-buttons></bottom-buttons></arno-material-types-tree-view><div ng-show="!$ctrl.selectedMaterialType" class="padded-container"><div ng-include="\'actionButtons.tpl.html\'"></div></div></div></div><div class="col-xs-12 col-sm-5 col-lg-6" ng-if="$ctrl.selectedMaterialType"><div ba-panel="" ba-panel-title="\'modules.administration.material.materialTypes.editMaterialTypes\'"><form id="materialTypeForm" name="materialTypeForm"><fieldset><h4 class="with-line" toggle-next="">{{\'modules.administration.material.materialTypes.generalInformation\' | translate}}</h4><div><div ng-if="!$ctrl.wouldOverwriteMaterialType()" class="form-group" ng-class="{\'has-error\': !$ctrl.validateField($ctrl.selectedMaterialType.Name, \'Name\')}"><label for="Name" class="control-label required-label" translate="modules.administration.material.materialTypes.formName"></label> <input type="text" id="Name" name="Name" ng-model="$ctrl.selectedMaterialType.Name" class="form-control"> <span ng-if="!$ctrl.validateField($ctrl.selectedMaterialType.Name, \'Name\')" class="help-block basic-block" translate="modules.administration.material.materialTypes.formNameInvalid"></span></div><div ng-if="!$ctrl.wouldOverwriteMaterialType()" class="form-group"><label for="Description" translate="modules.administration.material.materialTypes.formDescription"></label> <textarea rows="3" id="Description" ng-model="$ctrl.selectedMaterialType.Description" class="form-control"></textarea></div><div class="form-group"><label class="d-flex align-items-center"><ba-switcher class="arno-modeswitch" id="MaterialsAssignable" switcher-style="primary" switcher-value="$ctrl.selectedMaterialType.MaterialsAssignable" switcher-keys="$ctrl.switcherKeysText"></ba-switcher><div class="mb-5"><span translate="modules.administration.material.materialTypes.formMaterialsAssignable"></span><arno-ba-help-tooltip text="{{\'modules.administration.material.materialTypes.formMaterialsAssignableTooltip\' | translate}}"></arno-ba-help-tooltip></div></label></div><div ng-if="!$ctrl.wouldOverwriteMaterialType()" class="form-group"><label class="d-flex align-items-center"><ba-switcher class="arno-modeswitch" id="BriefingRequired" switcher-style="primary" switcher-value="$ctrl.selectedMaterialType.BriefingRequired" switcher-keys="$ctrl.switcherKeysText"></ba-switcher><div class="mb-5"><span translate="modules.administration.material.materialTypes.formBriefingRequired"></span><arno-ba-help-tooltip text="{{\'modules.administration.material.materialTypes.formBriefingRequiredTooltip\' | translate}}"></arno-ba-help-tooltip></div></label></div><div ng-if="!$ctrl.wouldOverwriteMaterialType()" class="form-group"><label class="d-flex align-items-center"><ba-switcher class="arno-modeswitch" id="BriefingInheritable" switcher-style="primary" switcher-value="$ctrl.selectedMaterialType.BriefingInheritable" switcher-keys="$ctrl.switcherKeysText"></ba-switcher><div class="mb-5"><span translate="modules.administration.material.materialTypes.formBriefingInheritable"></span><arno-ba-help-tooltip text="{{\'modules.administration.material.materialTypes.formBriefingInheritableTooltip\' | translate}}"></arno-ba-help-tooltip></div></label></div></div><h4 ng-if="!$ctrl.wouldOverwriteMaterialType() && $ctrl.currentDivision" class="with-line" toggle-next="">{{\'modules.administration.material.materialTypes.priceInformation\' | translate}}</h4><div ng-if="!$ctrl.wouldOverwriteMaterialType() && $ctrl.currentDivision"><div class="form-group"><label class="d-flex align-items-center"><ba-switcher class="arno-modeswitch" id="AvailableInFinance" switcher-style="primary" switcher-value="$ctrl.selectedMaterialType.AvailableInFinance" switcher-keys="$ctrl.switcherKeysText"></ba-switcher><span class="mb-5" translate="modules.administration.material.materialTypes.formAvailableInFinance"></span></label></div></div></fieldset><fieldset ng-if="!$ctrl.wouldOverwriteMaterialType()"><h4 class="with-line" toggle-next="">{{\'modules.administration.material.materialTypes.inspection\' | translate}}</h4><div ng-if="$ctrl.selectedMaterialType.newNode"><div class="alert bg-info">{{ \'modules.administration.material.materialTypes.savingRequired\' | translate }}</div></div><div ng-if="!$ctrl.selectedMaterialType.newNode"><button ng-click="$ctrl.upsertInspectionMaterialType()" type="submit" class="btn btn-primary btn-with-icon"><i class="ion-plus"></i> {{\'modules.administration.material.inspection.linkInspection\' | translate}}</button><div class="table-responsive pt-15"><table st-table="$ctrl.displayedInspectionMaterialType" st-pipe="$ctrl.getInspectionMaterialTypeViaTable" class="table"><thead><tr class="sortable"><th st-sort="Title" translate="generalTerms.title"></th><th translate="generalTerms.mandatory"></th><th translate="modules.material.addMaterial.inspection.interval"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="row in $ctrl.displayedInspectionMaterialType"><td><span ng-if="row.MaterialTypeId !== $ctrl.selectedMaterialType.id" class="mr-5" uib-tooltip="{{ \'generalTerms.inherited\' | translate }}" tooltip-class="arno-tooltip" tooltip-placement="bottom"><i class="fa fa-link"></i></span> <span>{{ row.Inspection.Name }}</span></td><td>{{ (row.Mandatory ? \'generalTerms.yes\' : \'generalTerms.no\') | translate }}</td><td><span>{{ row.Interval }}</span></td><td><button ng-if="row.MaterialTypeId === $ctrl.selectedMaterialType.id" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.upsertInspectionMaterialType(row)" title="{{ \'generalTerms.edit\' | translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button ng-if="row.MaterialTypeId === $ctrl.selectedMaterialType.id" class="btn btn-default btn-with-icon btn-xs btn-danger" ng-click="$ctrl.deleteInspectionMaterialType(row)" title="{{ \'generalTerms.delete\' | translate }}"><i class="fa fa-trash"></i><span translate="generalTerms.delete"></span></button></td></tr><tr ng-if="self.displayedInspectionMaterialType && self.displayedInspectionMaterialType.length === 0"><td class="text-center" colspan="99"><i translate="modules.administration.material.inspection.noInspection"></i></td></tr></tbody><tfoot><tr ng-if="self.displayedInspectionMaterialType && self.displayedInspectionMaterialType.length"><td colspan="99" class="text-center"><st-pagination st-items-by-page="self.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></fieldset></form><div ng-include="\'actionButtons.tpl.html\'" ng-show="$ctrl.selectedMaterialType"></div></div></div></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/addPermissionGroup.html','<div class="modal-content"><form name="memberForm" id="memberForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.createGroup($modalCtrl.curGroup.GroupName, $modalCtrl.curGroup.Description, $modalCtrl.curGroup.id)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminPerm.permissionsGroupEdit"></h4></div><div class="modal-body"><div ng-show="::($modalCtrl.division && !$modalCtrl.curGroup.Static)" class="mb-10"><ba-switcher class="arno-modeswitch" switcher-style="primary" switcher-width="160" switcher-keys="$modalCtrl.cKeys" ng-click="$modalCtrl.loadMembers(); $modalCtrl.selectedMember = null;" switcher-value="$modalCtrl.divisionMode"></ba-switcher></div><div class="form-group"><label for="nameInput" translate="modules.administration.adminPerm.nameOfGroup"></label> <input ng-if="::!$modalCtrl.curGroup.Static" type="text" ng-model="$modalCtrl.curGroup.GroupName" validator="$modalCtrl.validateGroupName($modalCtrl.curGroup.GroupName)" invalid-message="\'modules.administration.adminPerm.groupWithidentify\' | translate" class="form-control" id="nameInput" name="nameInput" placeholder="{{\'modules.administration.adminPerm.allGroupMember\' |translate}}" required-message="\'modules.administration.adminPerm.nameOfGroupIsMissing\' | translate" required=""> <input ng-if="::$modalCtrl.curGroup.Static" class="form-control" value="{{ ::($modalCtrl.curGroup.GroupName === \'all\' ? \'modules.administration.adminPerm.allGroupMember\' : $modalCtrl.curGroup.GroupName) | translate }}" ng-disabled="true"></div><br><div class="form-group"><label for="descInput" translate="modules.administration.adminPerm.descriptionOfGroup"></label> <textarea type="textarea" ng-model="$modalCtrl.curGroup.Description" class="form-control" id="descInput" placeholder="{{ \'generalTerms.description\' |translate }}" ng-disabled="::$modalCtrl.curGroup.Static"></textarea></div><div class="form-group" ng-hide="::$modalCtrl.curGroup.Static"><label translate="modules.administration.adminPerm.addMember"></label><div class="input-group"><ui-select ng-model="$modalCtrl.selectedMember" class="btn-group bootstrap-select form-control" name="memberSelect" id="memberSelect" on-select="$modalCtrl.addMember($modalCtrl.selectedMember)" search-enabled="true" spinner-enabled="true"><ui-select-match placeholder="{{\'modules.personnel.groups.memberSearchPlaceholder\' | translate }}">{{ $modalCtrl.selectedMember.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="$modalCtrl.checkTable(member.id) || member.hint" repeat="member in $modalCtrl.members" refresh="$modalCtrl.searchMembers($select.search)" refresh-delay="200" group-by="$modalCtrl.groupByFirstName"><span ng-if="!member.hint"><i class="ion-person"></i> <span>{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span> <span ng-show="$modalCtrl.checkTable(member.id)" style="color: #AAA; font-style: italic" translate="modules.administration.adminPerm.allreadyAdded"></span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="modules.administration.adminPerm.tapForResolves"></span></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="table-responsive"><table st-table="$modalCtrl.displayedCollection" st-safe-src="$modalCtrl.groupMembers" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="FirstName" st-sort-default="true" translate="modules.administration.adminPerm.firstName"></th><th st-sort="LastName" translate="generalTerms.createName"></th><th st-sort="Account.EMail" translate="generalTerms.eMail"></th><th ng-hide="::$modalCtrl.curGroup.Static" translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in $modalCtrl.displayedCollection"><td>{{ ::member.FirstName }}</td><td>{{ ::member.LastName }}</td><td>{{ ::member.Account.EMail }}</td><td class="arno-table-button-cell" ng-hide="::$modalCtrl.curGroup.Static"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$modalCtrl.removeMember(member)"><i class="ion-ios-trash"></i><span class="btn-span" translate="generalTerms.remove"></span></button></td></tr><tr ng-if="!$modalCtrl.groupMembers.length"><td colspan="4" translate="modules.administration.adminPerm.noMembersAdded"></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div><br><label for="roleInput" translate="modules.administration.adminPerm.chooseRoles"></label><div class="input-group input-group-with-select"><ui-select multiple="" id="roleInput" name="roleInput" ng-model="$modalCtrl.selectedRoles" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control arno-roleselect"><ui-select-match translate-attr="{ placeholder: \'modules.administration.adminPerm.chooseRoles\' }">{{$item.RoleName}}</ui-select-match><ui-select-choices position="down" repeat="item in $modalCtrl.roles | filter: $select.search"><arno-permission-popover roles-permission-data="$modalCtrl.fetchTooltip(item, item.RoleName, $modalCtrl.roles)" permission-popover-label="item.RoleName" permission-popover-placement="left" permission-popover-always-description="true" permission-popover-force-hide-descriptions="true" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="!$modalCtrl.selectedRoles.length" ng-click="$modalCtrl.selectedRoles = undefined" class="btn btn-danger"><i class="ion-ios-trash"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/addPermittedMembers.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminPerm.addRole"></h4></div><div class="modal-body"><div ng-show="::($modalCtrl.division && !$modalCtrl.curGroup.Static)" class="mb-10"><ba-switcher class="arno-modeswitch" switcher-style="primary" switcher-width="160" switcher-keys="$modalCtrl.cKeys" ng-click="$modalCtrl.loadMembers(); $modalCtrl.selectedMember = null;" switcher-value="$modalCtrl.divisionMode"></ba-switcher></div><div><label for="memberSelect">{{ ::$modalCtrl.selectState }}</label><ui-select ng-model="$modalCtrl.selectedMember" class="btn-group bootstrap-select form-control" name="memberSelect" id="memberSelect" ng-disabled="$modalCtrl.disableMemberChoice" on-select="$modalCtrl.checkForRoles($item)" search-enabled="true" spinner-enabled="true"><ui-select-match placeholder="{{ (\'modules.administration.adminPerm.searchMember\'|translate) }}">{{ $modalCtrl.selectedMember.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="member.hint" repeat="member in $modalCtrl.members | orderBy: \'fullName\'" refresh="$modalCtrl.searchMembers($select.search)" refresh-delay="200" group-by="$modalCtrl.groupByFirstName"><span class="person-select" ng-if="!member.hint"><i class="ion-person"></i> <span title="{{::member.fullName}}">{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="modules.administration.adminPerm.tapForResolves"></span></span></ui-select-choices></ui-select></div><br><label for="roleInput" translate="modules.administration.adminPerm.addRolls"></label><div class="input-group input-group-with-select"><ui-select multiple="" id="roleInput" name="roleInput" ng-model="$modalCtrl.selectedRoles" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control arno-roleselect"><ui-select-match placeholder="{{ \'modules.administration.adminPerm.chooseRoles\' |translate }}">{{ $item.RoleName }}</ui-select-match><ui-select-choices position="down" repeat="item in $modalCtrl.roles | filter: $select.search"><arno-permission-popover roles-permission-data="$modalCtrl.fetchTooltip(item, item.RoleName, $modalCtrl.roles)" permission-popover-label="item.RoleName" permission-popover-placement="left" permission-popover-force-hide-descriptions="true" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="!$modalCtrl.selectedRoles.length" ng-click="$modalCtrl.selectedRoles = undefined" class="btn btn-danger ion-ios-trash"></button></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-click="$modalCtrl.applyModal()" ng-disabled="$modalCtrl.selectedRoles.length === 0" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/copyPermission.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminPerm.copyPerm"></h4></div><div class="modal-body"><div class="alert bg-warning" ng-if="$modalCtrl.curGroup"><h4 translate="modules.administration.adminPerm.notice"></h4><strong translate="modules.administration.adminPerm.existingPermOverwrite"></strong></div><div class="table-responsive"><table st-table="$modalCtrl.divisionCollection" st-safe-src="$modalCtrl.divisionList" class="table table-condensed table-hover"><thead><tr class="sortable"><th colspan="2" st-sort="Name" st-sort-default="true" translate="generalTerms.divisions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th></tr></thead><tbody><tr ng-repeat="item in $modalCtrl.divisionCollection"><td class="arno-pointing-pointer" ng-click="item.state = !item.state">{{ ::item.Name }}</td><td><input class="from-control" type="checkbox" ng-model="item.state"></td></tr></tbody><tfoot><tr><td colspan="2" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><div class="clearfix mb-8" ng-if="$modalCtrl.childDivisionIds.length"><button class="btn btn-default pull-left" ng-click="$modalCtrl.selectChildDivisions()"><i class="fa fa-exclamation-triangle text-danger mr-3" ng-if="$modalCtrl.childDivisionIds.length > 100"></i> {{(\'modules.administration.adminPerm.selectSubDivisions\' | translate:{ length: $modalCtrl.childDivisionIds.length })}}</button></div><div><button class="btn btn-default pull-left" ng-click="$modalCtrl.selectAllDivisions($modalCtrl.divisionList)"><i class="fa fa-exclamation-triangle text-danger mr-3" ng-if="$modalCtrl.divisionList.length > 100 && !$modalCtrl.allSelectionMode"></i> {{$modalCtrl.allSelectionMode ? (\'modules.administration.adminPerm.selectAllDivisions\' | translate:{ length: $modalCtrl.divisionList.length, selected: true }) : (\'modules.administration.adminPerm.selectAllDivisions\' | translate:{ length: $modalCtrl.divisionList.length, selected: false }) }}</button> <button class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button class="btn btn-primary" ng-click="$modalCtrl.copyPermission()" translate="generalTerms.copy">Kopieren</button></div></div></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/removePermissionGroup.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminPerm.deletePermissionsGroup"></h4></div><div class="modal-body text-center"><h5 translate="modules.administration.adminPerm.exaclyDeletePermissionsGroup"></h5><br><h5 translate="modules.administration.adminPerm.requestDeletePermissionsGroup"></h5></div><div class="modal-footer"><button class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.removeGroup($modalCtrl.curGroup.id, $modalCtrl.curGroup.GroupName)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/removePermittedMember.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminPerm.deletePermissionsOfMember"></h4></div><div class="modal-body text-center"><h5 translate="modules.administration.adminPerm.exaclyRemovingMemberPermissions"></h5><br><h5 translate="modules.administration.adminPerm.requestOfRemovingMemberPermissions"></h5></div><div class="modal-footer"><button class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.confirmDelete($modalCtrl.curMember.MemberId, $modalCtrl.curMember.fullName)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/permissions/permissionModalTemplate/roleDataModalTemplate.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminPerm.rightsOfRoles"><span class="role-data-title">{{ $modalCtrl.roleName }}</span></h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-condensed"><thead><tr class="black-muted-bg"><th class="align-left-force" translate="generalTerms.perm"></th><th class="align-left-force" translate="modules.administration.adminPerm.explanation"></th></tr></thead><tbody><tr ng-repeat="permission in $modalCtrl.permissions" class="role-data-permission-column"><td class="align-left-force">{{permission.Name}}</td><td class="role-data-permission-description">{{ (permission.Description || \'modules.administration.adminTerms.noRights\') | translate }}</td></tr></tbody></table></div></div><div class="modal-footer"><button data-cy="personnel-personnellist-export-dismiss" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.close"></button></div></div>');
$templateCache.put('app/pages/administration/personnel/activities/activities.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\'modules.administration.adminActivities.manageActivityGroups\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="{{ $ctrl.divisionSelectorEntryPermission }}"><div class="row btns-row"><div class="col-md-12"><button data-cy="administration-personnel-activities-addactivitygroup" type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openGroup(\'addActivityGroup\')" ng-disabled="!$ctrl.ctxSelected"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.administration.adminActivities.addActivityGroup"></span></button></div></div><div class="row"><div class="col-md-12"><uib-accordion><uib-accordion-group ng-repeat="activityGroup in $ctrl.activityHierarchy | orderBy:[\'DivisionId\', \'Name\']" panel-class="panel-default bootstrap-panel accordion-panel" reopen-last="ACTIVITY_GROUP" reopen-key="{{activityGroup.id}}" reopen-retain-for="arno.administration.personnel.activityWindow"><uib-accordion-heading><span><i ng-class="{\'ion-ios-people-outline\': activityGroup.DivisionId, \'ion-ios-people\': !activityGroup.DivisionId}"></i> {{activityGroup.Title}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': activityGroup.tabOpen, \'ion-chevron-right\': !activityGroup.tabOpen}"></i><div class="btn-toolbar pull-right no-padding"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'editActivityGroup\', activityGroup, null)" ng-if="activityGroup.DivisionId || $ctrl.orgLevel" title="{{(\'generalTerms.edit\' | translate)}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button ng-if="activityGroup.DivisionId || $ctrl.orgLevel" class="btn btn-danger btn-with-icon btn-xs" ng-disabled="activityGroup.Activities.length" title="{{activityGroup.Activities.length ? \'Nur leere T\xE4tigkeitsgruppen k\xF6nnen gel\xF6scht werden\' : \'\'}}" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'deleteActivityGroup\', activityGroup, null)"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></uib-accordion-heading><div class="row" ng-if="activityGroup.tabOpen || activityGroup.tabWasOpenOnce"><div class="col-md-12" ng-init="activityGroup.tabWasOpenOnce = true"><div class="accent-info" ng-if="!activityGroup.DivisionId && !$ctrl.orgLevel" translate="modules.administration.adminActivities.restrictedActivityGroups"></div><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="activity in activityGroup.Activities | orderBy:[\'DivisionId\',\'Name\'] | filter:{ ActivityGroupId: activityGroup.id }:true track by $index"><td class="align-left-force"><i ng-class="{\'ion-ios-people\':!activity.DivisionId,\'ion-ios-people-outline\':activity.DivisionId}"></i> {{activity.Title}}</td><td class="align-right-force"><div ng-if="activity.DivisionId || $ctrl.orgLevel"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openActivity(\'edit\', activityGroup, activity)" ng-disabled="!activity.Active" title="{{(\'generalTerms.edit\' | translate)}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <span ng-if="!activity.Active"><button class="btn btn-success btn-with-icon btn-xs" ng-click="$ctrl.activateActivity(activity,activityGroup,true)" ng-show="!activity.Active" title="{{(\'generalTerms.activate\' | translate)}}"><i class="fa fa-paint-brush"></i><span translate="generalTerms.activate"></span></button></span> <span ng-if="activity.Active"><button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.activateActivity(activity,activityGroup,false)" ng-show="activity.Active" title="{{(\'generalTerms.deactivate\' | translate)}}"><i class="fa fa-ban"></i><span translate="generalTerms.deactivate"></span></button></span> <button ng-if="activityGroup.DivisionId || $ctrl.orgLevel" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteActivity(activity)" title="{{(\'generalTerms.delete\' | translate)}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!activityGroup.Activities.length"><td colspan="2" class="text-center"><i translate="modules.administration.adminActivities.noActivitysDeposited"></i></td></tr></tbody></table></div></div></div><div class="row" ng-if="activityGroup.tabOpen || activityGroup.tabWasOpenOnce || true"><div class="col-md-12 mt-10" ng-init="activityGroup.tabWasOpenOnce = true"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openActivity(\'add\', activityGroup, null)"><i class="ion-plus"></i><span translate="modules.administration.adminActivities.addActivity"></span></button></div></div></uib-accordion-group></uib-accordion><div ng-if="!$ctrl.activityHierarchy.length" class="text-center mb-10"><i translate="modules.administration.adminActivities.noActivityGroupsDeposited"></i></div></div></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/blockage/blockageList.html','<div ng-repeat="panel in $ctrl.displayPanels"><div ba-panel="" ba-panel-title="panel.title"><div class="arno-withdrawal-list-panel-header form-group clearfix"><div class="btn-toolbar"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.reasonAdd(panel)"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.administration.adminBlockage.addBlockageReason"></span></button><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.resultsPerSite"></span> ({{ panel.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="panel.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive"><table st-table="panel.displayedCollection" st-pipe="panel.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Reason" st-sort-default="true" translate="modules.administration.adminBlockage.lockReason"></th><th colspan="2" class="arno-table-button-cell" translate="generalTerms.actions"></th></tr></thead><tbody ng-class="{\'isLoading\': panel.isLoading}"><tr ng-show="!panel.isLoading" ng-repeat="reason in panel.displayedCollection.rows"><td class="align-left-force"><span>{{ ::reason.Reason }}</span></td><td><button ng-if="!reason.Immutable" ng-click="$ctrl.reasonEdit(reason.id, reason.Reason, panel)" class="btn btn-default btn-with-icon btn-xs" title="{{(\'generalTerms.edit\' | translate)}}"><i class="fa fa-pencil"></i><span class="hidden-xs" translate="generalTerms.edit"></span></button></td><td><button ng-if="!reason.Immutable" ng-click="$ctrl.reasonDelete(reason.id, reason.Reason, panel)" class="btn btn-danger btn-with-icon btn-xs" title="{{(generalTerms.delete) | translate}}"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="generalTerms.delete"></span></button></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="panel.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div><div><div ba-panel="" ba-panel-title="$ctrl.historyPanel.title"><div class="arno-withdrawal-list-panel-header form-group clearfix"><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.resultsPerSite"></span> ({{ $ctrl.historyPanel.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.historyPanel.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive"><table st-table="$ctrl.historyPanel.displayedCollection" st-pipe="$ctrl.historyPanel.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th translate="modules.administration.adminBlockage.lockReason"></th><th translate="modules.administration.adminBlockage.oldValueOfBlockage"></th><th st-sort="Type" translate="modules.administration.adminBlockage.changeReason"></th><th translate="modules.administration.adminBlockage.divReason"></th><th translate="modules.administration.adminBlockage.editorOfBlockage"></th></tr></thead><tbody ng-class="{\'isLoading\': $ctrl.historyPanel.isLoading}"><tr ng-show="!$ctrl.historyPanel.isLoading" ng-repeat="history in $ctrl.historyPanel.displayedCollection.rows"><td><span>{{ ::history.parsedJSON.newValue }}</span></td><td><span>{{ ::history.parsedJSON.oldValue }}</span></td><td class="align-center-force"><span ng-if="history.Type == \'BLOCKAGEREASON_CREATE\'" translate="modules.administration.adminBlockage.createdBlockage"></span> <span ng-if="history.Type == \'BLOCKAGEREASON_EDIT\'" translate="modules.administration.adminBlockage.editBlockage"></span> <span ng-if="history.Type == \'BLOCKAGEREASON_DELETE\'" translate="modules.administration.adminBlockage.deleteBlockage"></span></td><td><span ng-if="history.parsedJSON.isDiv"><i class="ion-android-checkbox-outline"></i></span> <span ng-if="!history.parsedJSON.isDiv"><i class="ion-android-checkbox-outline-blank"></i></span></td><td><span>{{ ::history.TriggeringMember.fullName }}</span></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="$ctrl.historyPanel.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearances.html','<div class="row"><div class="col-md-12"><div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.approval.manage\')" ba-panel="" ba-panel-title="\'modules.administration.adminClearances.manageReleases\'"><div class="row btns-row"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openGroup(\'addClearanceGroup\')"><i data-cy="administration-personnel-clearances-addgroup" class="ion-plus"></i><span class="hidden-xs" translate="modules.administration.adminClearances.addClearanceGroup"></span></button></div></div><div class="row"><div class="col-md-12"><uib-accordion><uib-accordion-group ng-if="$ctrl.unassignedClearanceGroup.Approvals.length > 0" is-open="$ctrl.unassignedClearanceGroup.viewExpando.tabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><i class="fa fa-warning"></i> <span translate="modules.administration.adminClearances.unassignedReleases"></span> (<span ng-bind="$ctrl.unassignedClearanceGroup.Approvals.length"></span>) <i class="pull-right" ng-class="{\'ion-chevron-down\': $ctrl.unassignedClearanceGroup.viewExpando.tabOpen, \'ion-chevron-right\': !$ctrl.unassignedClearanceGroup.viewExpando.tabOpen}"></i></uib-accordion-heading><div class="row" ng-if="$ctrl.unassignedClearanceGroup.viewExpando.tabOpen || $ctrl.unassignedClearanceGroup.viewExpando.clearanceMgmtGroupTabWasOpenOnce"><div class="col-md-12"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true" translate="generalTerms.release"></th><th class="force-minimal" translate="modules.administration.adminClearances.artOfRelease"></th><th class="text-center" translate="modules.administration.adminClearances.assignClearance"></th><th class="text-right" translate="generalTerms.actions"></th></tr></thead><tbody class="without-top-border"><tr ng-repeat="clearance in $ctrl.unassignedClearanceGroup.Approvals | orderBy:[\'Title\'] | filter:{ ClearanceGroupId: $ctrl.unassignedClearanceGroup.id }:true track by $index"><td class="align-left-force">{{clearance.Title}}</td><td class="alignnpm run cypress open-left-force force-minimal">{{$ctrl.CLEARANCES_TYPES_LABELS[clearance.Type] || \'modules.administration.adminClearances.noSpec\' | translate}}</td><td class="align-center"><ui-select ng-if="$ctrl.clearanceHierarchy.length > 0" is-active="!clearance.viewChangingSelectedGroup" ng-model="clearance.viewSelectedGroup" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input administration__clearance-change-group__select--width" append-to-body="true" on-select="$ctrl.onChangeClearanceGroupAssignment(clearance)" search-enabled="false"><ui-select-match placeholder="{{ \'modules.administration.adminClearances.chooseGroup\' |translate }}"><span ng-bind="clearance.viewSelectedGroup.Name"></span></ui-select-match><ui-select-choices position="down" repeat="clearanceGroup in $ctrl.clearanceHierarchy"><span ng-bind="::clearanceGroup.Name"></span></ui-select-choices></ui-select><div ng-if="!($ctrl.clearanceHierarchy.length > 0)" translate="modules.administration.adminClearances.createAClearanceGroup"></div></td><td><div class="align-right-force"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openClearance(\'addClearances\', $ctrl.unassignedClearanceGroup, clearance, \'md\')" title="{{(\'generalTerms.edit\' | translate)}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteThisClearance(\'app/pages/administration/personnel/clearances/clearanceModal/deleteClearance.html\', $ctrl.unassignedClearanceGroup, clearance, \'md\')" title="{{(\'generalTerms.delete\' | translate)}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group ng-repeat="clearanceGroup in $ctrl.clearanceHierarchy | orderBy:[\'Name\']" ng-init="clearanceGroup.clearanceMgmtGroupTabOpen = false" is-open="clearanceGroup.clearanceMgmtGroupTabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span>{{clearanceGroup.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': clearanceGroup.clearanceMgmtGroupTabOpen, \'ion-chevron-right\': !clearanceGroup.clearanceMgmtGroupTabOpen}"></i><div class="btn-toolbar pull-right no-padding"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'editClearanceGroup\', clearanceGroup, null)" title="{{(\'generalTerms.edit\' | translate)}}t"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'deleteClearanceGroup\', clearanceGroup, null)" title="{{(\'generalTerms.delete\' | translate)}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></uib-accordion-heading><div class="row" ng-if="clearanceGroup.clearanceMgmtGroupTabOpen || clearanceGroup.clearanceMgmtGroupTabWasOpenOnce"><div class="col-md-12" ng-init="clearanceGroup.clearanceMgmtGroupTabWasOpenOnce = true"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true" translate="generalTerms.release"></th><th class="force-minimal" translate="modules.administration.adminClearances.artOfRelease"></th><th class="text-right" translate="generalTerms.actions"></th></tr></thead><tbody class="without-top-border"><tr ng-if="!clearanceGroup.Approvals.length"><td colspan="3" class="text-center" translate="modules.administration.adminClearances.noExistReleases"></td></tr><tr ng-repeat="clearance in clearanceGroup.Approvals | orderBy:[\'Title\'] | filter:{ ClearanceGroupId: clearanceGroup.id }:true track by $index"><td class="align-left-force">{{clearance.Title}}</td><td class="align-left-force force-minimal">{{$ctrl.CLEARANCES_TYPES_LABELS[clearance.Type] || \'modules.administration.adminClearances.noSpec\' | translate}}</td><td class="align-right-force"><div><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openClearance(\'addClearances\', clearanceGroup, clearance, \'md\')" title="{{(\'generalTerms.edit\' | translate)}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.deleteThisClearance(\'app/pages/administration/personnel/clearances/clearanceModal/deleteClearance.html\', clearanceGroup, clearance, \'md\')" title="{{(\'generalTerms.delete\' | translate)}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></td></tr></tbody></table></div></div></div><br><div class="row" ng-if="clearanceGroup.clearanceMgmtGroupTabOpen || clearanceGroup.clearanceMgmtGroupTabWasOpenOnce"><div class="col-md-12" ng-init="clearanceGroup.clearanceMgmtGroupTabWasOpenOnce = true"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openClearance(\'addClearances\', clearanceGroup, null, \'md\')"><i data-cy="administration-personnel-clearances-addclearance" class="ion-plus"></i><span translate="generalTerms.addRelease"></span></button></div></div></uib-accordion-group></uib-accordion></div></div></div></div></div><div class="row"><div class="col-md-12"><div ng-if="$ctrl.permitted" ba-panel="" ba-panel-title="\'modules.administration.adminClearances.releaseManager\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="arno.administration.personnel.approval.assign.distributor"><div class="row"><div class="col-md-12"><uib-accordion ng-if="$ctrl.clearanceResponsiblePersons.length> 0"><uib-accordion-group ng-if="$ctrl.unassignedClearanceGroup.Approvals.length > 0" is-open="$ctrl.unassignedClearanceGroup.clearanceRespGroupTabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><i class="fa fa-warning"></i> <span translate="modules.administration.adminClearances.unassignedReleases"></span> (<span ng-bind="$ctrl.unassignedClearanceGroup.Approvals.length"></span>) <i data-cy="administration-personnel-clearances-accordion" class="pull-right" ng-class="{\'ion-chevron-down\': $ctrl.unassignedClearanceGroup.clearanceRespGroupTabOpen, \'ion-chevron-right\': !$ctrl.unassignedClearanceGroup.clearanceRespGroupTabOpen}"></i></uib-accordion-heading><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true" translate="generalTerms.release"></th><th translate="modules.administration.adminClearances.artOfRelease"></th><th translate="modules.administration.adminClearances.initiatingMember"><arno-ba-help-tooltip text="{{\'modules.administration.adminClearances.clearancesAdminClearanceMgmtInitiatingMemberInfo\' | translate}}"></arno-ba-help-tooltip></th><th translate="modules.administration.adminClearances.editedMember"><arno-ba-help-tooltip text="{{\'modules.administration.adminClearances.clearancesAdminClearanceMgmtEditingMemberInfo\' | translate}}"></arno-ba-help-tooltip></th><th class="text-center" translate="generalTerms.actions"></th></tr></thead><tbody class="without-top-border"><tr ng-repeat="clearance in $ctrl.clearanceResponsiblePersons | orderBy:[\'Title\'] | filter:{ ClearanceGroupId: null }:true track by $index"><td class="align-left-force">{{clearance.Clearance.Title}}</td><td class="align-left-force force-minimal">{{$ctrl.CLEARANCES_TYPES_LABELS[clearance.Clearance.Type] || \'modules.administration.adminClearances.noSpec\' | translate}}</td><td><span ng-class="{\'member-inactive\': member.isInactive}" ng-repeat="member in clearance.InitiatingMember">{{ member.fullName + (member.isInactive ? \' (inaktiv)\' : \'\') }}<br></span></td><td><span ng-class="{\'member-inactive\': member.isInactive}" ng-repeat="member in clearance.AcceptingMember">{{ member.fullName + (member.isInactive ? \' (inaktiv)\' : \'\') }}<br></span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button data-cy="administration-personnel-clearances-pesponsiblepersons-edit" class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openEditResponsiblePersons(clearance)" title="{{ \'modules.administration.adminClearances.editDevisionManager\' |translate }}"><i class="ion-edit"></i><span class="hidden-xs" translate="generalTerms.edit"></span></button></form></td></tr></tbody></table></uib-accordion-group><uib-accordion-group ng-if="clearanceGroup.Approvals.length > 0" ng-repeat="clearanceGroup in $ctrl.clearanceHierarchy | orderBy:[\'Name\']" ng-init="clearanceGroup.clearanceRespGroupTabOpen = false" is-open="clearanceGroup.clearanceRespGroupTabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span>{{clearanceGroup.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': clearanceGroup.clearanceRespGroupTabOpen, \'ion-chevron-right\': !clearanceGroup.clearanceRespGroupTabOpen}"></i></uib-accordion-heading><div class="pull-right mt-10 mb-20"><button class="btn btn-default btn-with-icon" ng-click="$ctrl.pushToSubDivs(clearanceGroup.id)" ng-disabled="!$ctrl.childrenDivs.length" title="{{ !$ctrl.childrenDivs.length ? \'modules.administration.adminClearances.noUnderDevisionExist\' : \'modules.administration.adminClearances.underDevisionCopy\' }}"><i class="fa fa-clone"></i><span translate="modules.administration.adminClearances.underDevisionCopy"></span></button> <button class="btn btn-default btn-with-icon" ng-click="$ctrl.openEditResponsiblePersons(null, clearanceGroup.id)" title="Alle bearbeiten"><i class="ion-edit"></i><span translate="modules.administration.adminClearances.allEdit"></span></button></div><div class="row" ng-if="clearanceGroup.clearanceRespGroupTabOpen || clearanceGroup.clearanceRespGroupTabWasOpenOnce"><div class="col-md-12" ng-init="clearanceGroup.clearanceRespGroupTabWasOpenOnce = true"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true" translate="generalTerms.release"></th><th translate="modules.administration.adminClearances.artOfRelease"></th><th translate="modules.administration.adminClearances.initiatingMember"><arno-ba-help-tooltip text="{{\'modules.administration.adminClearances.clearancesAdminClearanceMgmtInitiatingMemberInfo\' | translate}}"></arno-ba-help-tooltip></th><th translate="modules.administration.adminClearances.editedMember"><arno-ba-help-tooltip text="{{\'modules.administration.adminClearances.clearancesAdminClearanceMgmtEditingMemberInfo\' | translate}}"></arno-ba-help-tooltip></th><th class="text-center" translate="generalTerms.actions"></th></tr></thead><tbody class="without-top-border"><tr ng-repeat="clearance in $ctrl.clearanceResponsiblePersons | orderBy:[\'Title\'] | filter:{ ClearanceGroupId: clearanceGroup.id }:true track by $index" class="editable-row"><td><span>{{ ::clearance.Clearance.Title }}</span></td><td class="align-left-force force-minimal">{{$ctrl.CLEARANCES_TYPES_LABELS[clearance.Clearance.Type] || \'modules.administration.adminClearances.noSpec\' | translate}}</td><td><span ng-class="{\'member-inactive\': member.isInactive}" ng-repeat="member in clearance.InitiatingMember">{{ member.fullName + (member.isInactive ? \' (inaktiv)\' : \'\') }}<br></span></td><td><span ng-class="{\'member-inactive\': member.isInactive}" ng-repeat="member in clearance.AcceptingMember">{{ member.fullName + (member.isInactive ? \' (inaktiv)\' : \'\') }}<br></span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.pushToSubDivs(null, clearance.Clearance.id)" ng-disabled="!$ctrl.childrenDivs.length" title="{{ !$ctrl.childrenDivs.length ? \'Keine Untergliederungen verf\xFCgbar\' : \'Verantwortliche in Untergliederung(en) kopieren\' }}"><i class="fa fa-clone"></i><span class="hidden-xs" translate="modules.administration.adminClearances.underDevisionCopy"></span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openEditResponsiblePersons(clearance)" title="modules.administration.adminClearances.editDevisionManager"><i class="ion-edit"></i><span class="hidden-xs" translate="generalTerms.edit"></span></button></form></td></tr></tbody></table></div></div></div></uib-accordion-group></uib-accordion><div class="text-center" ng-if="!($ctrl.clearanceResponsiblePersons.length > 0)" translate="modules.administration.adminClearances.noExistSpecs"></div></div></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/fileStorage/fileStorage.html','<file-storage-admin max-depth="3" folder-data="$ctrl.folderData" storage-ident="\'dossier\'" panel-title="\'modules.administration.adminFileStorage.storageStructure\'" view-perm-selector="$ctrl.viewPermSelector"></file-storage-admin><div ba-panel="" ba-panel-title="\'Infotext\'" ba-panel-class="with-scroll administration__divisions__treeview"><div class="panel-body"><div class="row"><div class="col-md-8"><div class="form-group administration__welcomepage__intro-text-edit mt-20"><h5 translate="modules.administration.adminFileStorage.infoboxInStorage"></h5><textarea class="form-control administration__welcomepage__intro-text-edit__input --vresize" markdown-editor="$ctrl.markdownEditorConfig" name="infoboxTextContent" ng-model="$ctrl.infoboxTextContent" placeholder="{{ \'modules.administration.adminFileStorage.hereIsTheText\' |translate }}" maxlength="1000"></textarea></div></div><div class="col-md-4 hidden-xs hidden-sm" ng-include="\'app/theme/templates/syntax.tpl.html\'"></div></div></div><ba-panel-footer class="clearfix administration__divisions__treeview__footer-bar"><div class="pull-right"><button ng-click="$ctrl.saveText()" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></ba-panel-footer></div>');
$templateCache.put('app/pages/administration/personnel/general/general.html','<div><div ba-panel="" ng-if="$ctrl.hasManagePermAgeSettings" ba-panel-title="\'modules.administration.personnel.general.ageSettings.title\'" ba-panel-division-selector="false" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><form class="row administration__personnel__general__age-settings" novalidate="" angular-validator="" angular-validator-submit="$ctrl.saveAgeSettings()" name="ageSettingsForm"><div class="col-xs-12 d-flex align-items-center"><table><tbody><tr><td><div class="d-flex align-items-center justify-content-end"><label><span translate="modules.administration.personnel.general.ageSettings.ageRestrictionForLabel"></span><br><span translate="modules.administration.personnel.general.ageSettings.dossierBaseDataEditLabel"></span></label></div></td><td><div class="d-flex align-items-center pl-20 mt-8"><ba-switcher switcher-style="primary" switcher-value="$ctrl.ageRestrictionActive"></ba-switcher></div></td></tr><tr ng-if="$ctrl.ageRestrictionActive"><td><div class="d-flex align-items-center justify-content-end"><span translate="modules.administration.personnel.general.ageSettings.restrictedAgeProfileEditFieldLabel" class="text-right"></span></div></td><td><div class="d-flex align-items-center"><div class="form-group mb-0 pl-20 qualification-form-validity-input" ng-class="{ \'has-error\': (ageSettingsForm.$submitted || ageSettingsForm.restrictedAgeProfileEditInput.$touched) && ageSettingsForm.restrictedAgeProfileEditInput.$invalid }"><input type="number" name="restrictedAgeProfileEditInput" min="1" step="1" ng-pattern="/[0-9]+/" class="form-control" ng-model="$ctrl.restrictedAgeProfileEdit" required="" required-message="\'\'" invalid-message="\'\'" placeholder="{{ \'modules.administration.personnel.general.ageSettings.restrictedAgeProfileEditFieldPlaceholder\' | translate }}"> <span translate="generalTerms.years">Jahre</span><div ng-messages="(ageSettingsForm.$submitted || ageSettingsForm.restrictedAgeProfileEditInput.$touched) && ageSettingsForm.restrictedAgeProfileEditInput.$error" role="alert" class="control-label"><span ng-message="required" translate="modules.administration.personnel.general.ageSettings.restrictedAgeProfileEditError"></span> <span ng-message="min" translate="modules.administration.personnel.general.ageSettings.restrictedAgeProfileEditError"></span> <span ng-message="pattern" translate="modules.administration.personnel.general.ageSettings.restrictedAgeProfileEditError"></span></div></div></div></td></tr></tbody></table></div><div class="col-md-12 mt-20"><button type="submit" ng-disabled="ageSettingsForm.$pristine" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></form></div><div ng-if="$ctrl.hasManagePermDeletionPeriods"><div ba-panel="" ba-panel-title="\'modules.administration.personnel.general.deletionPeriods.titleDeletionPeriod\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-4"><div class="qualification-form-validity-input mb-0"><input type="number" class="form-control" name="withdrawalPeriodDays" id="withdrawalPeriodDays" min="0" step="1" ng-required="!!$ctrl.periods.withdrawalPeriodDays" ng-model="$ctrl.periods.withdrawalPeriodDays"> <span translate="generalTerms.days">Tage</span></div></div><div class="col-md-12 mt-8"><button type="submit" ng-click="$ctrl.changeRetrospectively(\'withdrawal\')" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></div></div><div ng-if="$ctrl.hasManagePermDeletionPeriods"><div ba-panel="" ba-panel-title="\'modules.administration.personnel.general.deletionPeriods.titleWithdrawal\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div class="row"><div class="col-md-4"><div class="qualification-form-validity-input mb-0"><input type="number" class="form-control" name="deletionPeriodMonths" id="deletionPeriodMonths" min="1" step="1" ng-blur="$ctrl.formatInput($ctrl.periods.deletionPeriodMonths)" ng-required="!!$ctrl.periods.deletionPeriodMonths" ng-model="$ctrl.periods.deletionPeriodMonths"> <span translate="generalTerms.months">Monate</span></div></div><div class="col-md-12 mt-8"><button type="submit" ng-click="$ctrl.changeRetrospectively(\'deletion\')" class="btn btn-primary btn-with-icon"><i class="ion-checkmark"></i><span translate="generalTerms.save">Speichern</span></button></div></div></div></div><div ba-panel="" ng-if="$ctrl.hasManagePermExternalSystems" ba-panel-title="\'modules.administration.personnel.general.externalPersonnelSystems.title\'" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA" ba-panel-division-selector-entry-permission="arno.personnel.inviteList.manage"><div class="external-personnelsystem-list row ng-scope"><div class="col-md-12"><div class="btn-toolbar"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.systemAdd()"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.administration.personnel.general.externalPersonnelSystems.addSystemBtn">System hinzuf\xFCgen</span></button></div></div><div class="col-md-12" ng-if="$ctrl.systemList.length === 0" translate="modules.administration.personnel.general.externalPersonnelSystems.emptySystemsListLabel">Es wurden noch keine Personalsysteme konfiguriert</div><div class="col-md-12" ng-if="$ctrl.systemList.length > 0"><uib-accordion panel-class="panel-default bootstrap-panel accordion-panel" ng-init="system.TabOpen = false" is-open="system.TabOpen" ng-click="system.TabOpen = !system.TabOpen" ng-repeat="system in $ctrl.systemList"><div uib-accordion-group="" class="panel-default accordion-panel"><uib-accordion-heading>{{system.Name}} (<span ng-bind="system.FieldIdentifier.length"></span>) <i class="pull-right" ng-class="{\'ion-chevron-down\': system.TabOpen, \'ion-chevron-right\': !system.TabOpen}"></i></uib-accordion-heading><div class="col-lg-10"><div class="systemNotificationEMail row" ng-if="system.EMail"><label><strong>Email:</strong></label> <span>{{ system.EMail || (\'modules.administration.personnel.general.externalPersonnelSystems.noNotificationEmailMsg\' | translate) }}</span></div><div class="infoText row" ng-if="system.InfoText"><label><strong>Beschreibung:</strong></label> {{ system.InfoText || (\'modules.administration.personnel.general.externalPersonnelSystems.noDescriptionMsg\' | translate) }}</div><div class="observedFields row" ng-if="system.RequiredFieldIdentifier.length > 0"><label><strong translate="modules.administration.personnel.general.externalPersonnelSystems.requiredFieldsNotificationLabel">Pflichtfelder zur Benachrichtigung:</strong></label><div class="systemFields"><button type="button" class="btn btn-xs btn-info" ng-repeat="(key, value) in system.RequiredFieldIdentifier | orderBy:\'Name\'" title="{{ value.Name }}"><span class="btn-span hidden-xs">{{ value.Name || value.FieldIdentifier }}</span></button></div></div><div class="observedFields row" ng-if="system.FieldIdentifier.length > 0"><label><strong translate="modules.administration.personnel.general.externalPersonnelSystems.relevantFieldsNotificationLabel">Benachrichtigungsrelevante Felder:</strong></label><div class="systemFields"><button type="button" class="btn btn-xs btn-info" ng-repeat="(key, value) in system.FieldIdentifier | orderBy:\'Name\'" title="{{ value.Name }}"><span class="btn-span hidden-xs">{{ value.Name || value.FieldIdentifier }}</span></button></div></div></div><div class="col-lg-2"><div class="row"><button type="button" class="btn btn-xs btn-default pull-right" ng-click="$ctrl.systemAdd(system)"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit">Bearbeiten</span></button></div><div class="row" style="margin-top: 5px;"><button type="button" class="btn btn-xs btn-primary pull-right" ng-click="$ctrl.deleteSystem(system)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.delete">L\xF6schen</span></button></div></div></div></uib-accordion></div></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualifications.html','<div class="tab-content"><div ng-if="$ctrl.isPermitted"><div class="row btns-row"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openGroup(\'addQualificationGroup\', null)" ng-disabled="!$ctrl.ctxSelected"><i class="ion-plus"></i><span class="hidden-xs" translate="modules.administration.adminQualification.addGroup" translate-values="$ctrl.translateValues"></span></button> <button type="button" class="btn btn-primary btn-with-icon pull-right" ng-click="$ctrl.runCalc()" ng-disabled="!$ctrl.ctxSelected"><i class="fa fa-refresh"></i><span class="hidden-xs" translate="modules.administration.adminQualification.calculateValidities"></span></button></div></div><div class="row"><div class="col-md-12"><uib-accordion><uib-accordion-group ng-repeat="group in $ctrl.qualificationHierarchy | orderBy:[\'DivisionId\', \'Name\']" ng-init="group.tabOpen = false" is-open="group.tabOpen" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span><i ng-class="{\'ion-ios-people-outline\': group.DivisionId, \'ion-ios-people\': !group.DivisionId}"></i> {{group.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': group.tabOpen, \'ion-chevron-right\': !group.tabOpen}"></i><div class="btn-toolbar pull-right no-padding"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'editQualificationGroup\', group)" ng-if="group.DivisionId || $ctrl.orgLevel" title="{{\'generalTerms.edit\' |translate}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button ng-if="group.DivisionId || $ctrl.orgLevel" class="btn btn-danger btn-with-icon btn-xs" ng-disabled="group.Qualifications.length" ng-click="$event.preventDefault(); $event.stopPropagation(); $ctrl.openGroup(\'deleteQualificationGroup\', group)" title="{{group.Qualifications.length ? (\'modules.administration.adminQualification.aGroupWithQualificationCantDelete\' | translate: { typePlural: $ctrl.translateValues.typePlural }) : (\'modules.administration.adminQualification.deleteQualificationGroup\' | translate: { typeGroupSingular: $ctrl.translateValues.typeGroupSingular })}}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></uib-accordion-heading><div class="row" ng-if="group.tabOpen || group.tabWasOpenOnce"><div class="col-md-12" ng-init="group.tabWasOpenOnce = true"><div class="accent-info" ng-if="!group.DivisionId && !$ctrl.orgLevel" translate="modules.administration.adminQualification.organisationGroupLevel"></div><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="qualification in group.Qualifications | orderBy:[\'DivisionId\',\'Name\'] | filter:{ QualificationGroupId: group.id }:true track by $index"><td class="align-left-force"><i ng-class="{\'ion-ios-people\':!qualification.DivisionId,\'ion-ios-people-outline\':qualification.DivisionId}"></i> {{qualification.Name}}</td><td class="align-right-force"><div><button class="btn btn-default btn-with-icon btn-xs" ng-click="$ctrl.openQualification(\'editQualification\', group, qualification)" ng-if="qualification.DivisionId || $ctrl.orgLevel" title="{{\'generalTerms.edit\' |translate}}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button ng-if="qualification.DivisionId || $ctrl.orgLevel" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ctrl.openQualification(\'deleteQualification\', group, qualification)" title="{{\'modules.administration.adminQualification.deleteQualificationGroup\' | translate: { typeGroupSingular: $ctrl.translateValues.typeSingular } }}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!group.Qualifications.length"><td colspan="2" class="text-center"><i translate="modules.administration.adminQualification.noAddedQualifications" translate-values="$ctrl.translateValues"></i></td></tr></tbody></table></div></div></div><div class="row" ng-if="group.tabOpen || group.tabWasOpenOnce"><div class="col-md-12 mt-10" ng-init="group.tabWasOpenOnce = true"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$ctrl.openQualification(\'addQualification\', group, null)"><i class="ion-plus"></i> <span translate="modules.administration.adminQualification.addQualification" translate-values="$ctrl.translateValues"></span></button></div></div></uib-accordion-group></uib-accordion><div ng-if="!$ctrl.qualificationHierarchy.length" class="text-center mb-10"><i translate="modules.administration.adminQualification.noAddedQualificationGroups" translate-values="$ctrl.translateValues"></i></div></div></div></div><div ng-if="!$ctrl.isPermitted" class="my-10"><span class="text-italic" translate="modules.administration.adminQualification.userNotPermitted" translate-values="$ctrl.translateValues"></span></div></div>');
$templateCache.put('app/pages/administration/personnel/withdrawal/withdrawalList.html','<div ng-repeat="panel in $ctrl.displayPanels"><div ba-panel="" ba-panel-title="panel.title"><div class="arno-withdrawal-list-panel-header form-group clearfix"><div class="btn-toolbar"><button class="btn btn-primary btn-with-icon" ng-click="$ctrl.reasonAdd(panel)"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.administration.adminWithdrawl.addReason"></span></button><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="modules.administration.adminWithdrawl.resultsPerSite"></span> ({{ panel.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="panel.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive"><table st-table="panel.displayedCollection" st-pipe="panel.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Reason" st-sort-default="true" translate="modules.administration.adminWithdrawl.exitReason"></th><th colspan="2" class="arno-table-button-cell" translate="generalTerms.actions"></th></tr></thead><tbody ng-class="{\'isLoading\': panel.isLoading}"><tr ng-show="!panel.isLoading" ng-repeat="reason in panel.displayedCollection.rows"><td class="align-left-force"><span>{{ ::reason.Reason }}</span></td><td><button ng-if="!reason.Immutable" ng-click="$ctrl.reasonEdit(reason.id, reason.Reason, panel)" class="btn btn-default btn-with-icon btn-xs" title="{{ \'generalTerms.edit\' |translate }}"><i class="fa fa-pencil"></i><span class="hidden-xs" translate="generalTerms.edit"></span></button></td><td><button ng-if="!reason.Immutable" ng-click="$ctrl.reasonDelete(reason.id, reason.Reason, panel)" class="btn btn-danger btn-with-icon btn-xs" title="{{ \'generalTerms.delete\' |translate }}"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="generalTerms.delete"></span></button></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="panel.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div><div><div ba-panel="" ba-panel-title="$ctrl.historyPanel.title"><div class="arno-withdrawal-list-panel-header form-group clearfix"><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="modules.administration.adminWithdrawl.resultsPerSite"></span> ({{ $ctrl.historyPanel.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$ctrl.historyPanel.changePageSize(i)">{{ i }}</a></li></ul></div></div><div class="table-responsive"><table st-table="$ctrl.historyPanel.displayedCollection" st-pipe="$ctrl.historyPanel.getData" class="table table-condensed table-hover"><thead><tr class="sortable"><th translate="modules.administration.adminWithdrawl.exitReason"></th><th translate="modules.administration.adminWithdrawl.oldValue"></th><th st-sort="Type" translate="modules.administration.adminWithdrawl.reasonForChange"></th><th translate="modules.administration.adminWithdrawl.outlineGround"></th><th translate="modules.administration.adminWithdrawl.editor"></th></tr></thead><tbody ng-class="{\'isLoading\': $ctrl.historyPanel.isLoading}"><tr ng-show="!$ctrl.historyPanel.isLoading" ng-repeat="history in $ctrl.historyPanel.displayedCollection.rows"><td><span>{{ ::history.parsedJSON.newValue }}</span></td><td><span>{{ ::history.parsedJSON.oldValue }}</span></td><td><span ng-if="history.Type == \'WITHDRAWALREASON_CREATE\'" translate="modules.administration.adminWithdrawl.createdWithdrawl"></span> <span ng-if="history.Type == \'WITHDRAWALREASON_EDIT\'" translate="modules.administration.adminWithdrawl.editedWithdrawl"></span> <span ng-if="history.Type == \'WITHDRAWALREASON_DELETE\'" translate="modules.administration.adminWithdrawl.deleteWithDrawl"></span></td><td><span ng-if="history.parsedJSON.isDiv"><i class="ion-android-checkbox-outline"></i></span> <span ng-if="!history.parsedJSON.isDiv"><i class="ion-android-checkbox-outline-blank"></i></span></td><td><span>{{ ::history.TriggeringMember.fullName }}</span></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="$ctrl.historyPanel.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/administration/roles/roleModalTemplate/addRoles.html','<div class="modal-content"><form id="roleForm" name="roleForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.curRole.RoleId)"><div class="modal-header"><h4 class="modal-title">{{$modalCtrl.title}}</h4></div><div class="modal-body"><div><div class="form-group"><label for="nameInput" translate="modules.administration.roles.nameOfRole"></label> <input type="text" maxlength="254" ng-model="$modalCtrl.curRole.RoleName" class="form-control" id="nameInput" name="nameInput" placeholder="{{ \'generalTerms.createName\' |translate:\'{lowercase: true}\' }}" validator="$modalCtrl.validateName($modalCtrl.curRole.RoleName)" invalid-message="\'modules.administration.roles.invalidRoleMessage\' | translate" required-message="\'modules.administration.roles.requiredRoleMessage\' | translate" required=""></div><br><div class="form-group"><label for="descInput" translate="modules.administration.roles.descriptionOfRole"></label> <textarea ng-model="$modalCtrl.curRole.Description" maxlength="254" class="form-control" id="descInput" placeholder="{{ \'modules.administration.roles.description\' | translate }}"></textarea></div></div><br><br><div class="form-group"><label for="permInput" translate="modules.administration.roles.permissionOfRole"></label><div class="input-group permissions-of-role input-group-with-select"><ui-select multiple="" id="permInput" name="permInput" ng-model="$modalCtrl.selectedPermissions" required-message="\'modules.administration.roles.requiredPermRoleMessage\'" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control arno-roleselect" required="" ng-required="true"><ui-select-match placeholder="{{\'modules.administration.roles.chooseRightsOfRoles\' | translate}}"><arno-permission-popover roles-permission-data="$modalCtrl.fetchTooltip($modalCtrl.curRole, $item)" permission-popover-label="$item.Name" permission-popover-placement="bottom" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-match><ui-select-choices repeat="item in $modalCtrl.permissions | filter: { Name: $select.search } | orderBy: \'Group\'" ui-select-header-group-selectable="" position="down" group-by="\'Group\'"><arno-permission-popover roles-permission-data="::$modalCtrl.fetchTooltip($modalCtrl.curRole, item)" permission-popover-label="item.Name" permission-popover-placement="left" permission-popover-append-to-body="true"></arno-permission-popover></ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="!$modalCtrl.selectedPermissions.length" ng-click="$modalCtrl.selectedPermissions = undefined" class="btn btn-danger ion-ios-trash"></button></span></div><label ng-messages="(roleForm.permInput.$touched || roleForm.$submitted) && roleForm.permInput.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.administration.roles.requiredPermRoleMessage"></span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/roles/roleModalTemplate/deleteRole.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.roles.deleteRole"></h4></div><div class="modal-body text-center"><div class="section-block"><p translate="modules.administration.roles.permanentDeleteRole"></p><p translate="modules.administration.roles.requestAboutDeleteRole" translate-values="{ roleName: $modalCtrl.curRole.RoleName }"></p></div></div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-with-icon btn-danger pull-right" ng-click="$modalCtrl.confirmDelete($modalCtrl.curRole.RoleId, $modalCtrl.curRole.RoleName)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/statistics/editResponsiblePersonsModal/editResponsiblePersonsModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">Gliederungsstatistikverantwortliche zuweisen</h4></div><div class="modal-body"><div ng-repeat="responsibleType in $ctrl.responsilbeTypes"><label>{{ responsibleType.name }}</label><table st-table="displayedCollection" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true">Vorname</th><th st-sort-default="true">Nachname</th><th class="text-center">Aktionen</th></tr></thead><tr ng-show="!responsibleType.members() || responsibleType.members().length === 0"><td colspan="3" class="arno-pointing-pointer text-center"><i>{{ responsibleType.noMemberMessage }}</i></td></tr><tr ng-repeat="member in responsibleType.members()" class="editable-row"><td class="arno-pointing-pointer"><span>{{ member.FirstName }}</span></td><td class="arno-pointing-pointer"><span>{{ member.LastName }}</span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button class="btn btn-default btn-with-icon btn-xs" ng-click="responsibleType.removeMethod(member.id)" title="Gliederungsstatistikverantwortliche bearbeiten"><i class="ion-edit"></i><span class="hidden-xs">Entfernen</span></button></form></td></tr></table><br><ui-select ng-model="$ctrl.selectedMember" class="btn-group bootstrap-select form-control" search-enabled="true" on-select="responsibleType.addMethod()" spinner-enabled="true"><ui-select-match placeholder="{{\'modules.personnel.groups.memberSearchPlaceholder\' | translate }}">{{ $select.selected.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="member.selected || member.hint" repeat="member in $ctrl.members" refresh="$ctrl.searchMembers($select.search, responsibleType.isUsingMember)" refresh-delay="200" group-by="$ctrl.groupByFirstName"><span class="person-select" ng-if="!member.hint"><i class="ion-person"></i> <span>{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span> <span ng-show="member.selected" style="color: #AAA; font-style: italic">(Bereits hinzugef\xFCgt)</span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span>... bitte tippe um weitere Ergebnisse zu erhalten</span></span></ui-select-choices></ui-select><hr></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">Speichern</button></div></div>');
$templateCache.put('app/pages/administration/statistics/statisticGroupModal/addStatisticGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.statisticGroup.Name, null, \'addStatisticGroup\', null)"><div class="modal-header"><h4 class="modal-title">Statistikgruppe hinzuf\xFCgen</h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label">Gruppenname</label> <input type="text" ng-model="$modalCtrl.statisticGroup.Name" autofocus="" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.statisticGroup.Name)" invalid-message="\'Eine Statistikgruppe mit identischem Gruppennamen existiert bereits!\'" required-message="\'Gruppename fehlt!\'" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <button type="submit" class="btn btn-primary">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/statistics/statisticGroupModal/editStatisticGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.statisticGroup.Name, $modalCtrl.statisticGroup.id, \'editStatisticGroup\', null)"><div class="modal-header"><h4 class="modal-title">Statistikgruppe bearbeiten</h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label">Gruppenname</label> <input type="text" ng-model="$modalCtrl.statisticGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.statisticGroup.Name, $modalCtrl.statisticGroup.id)" invalid-message="\'Eine Statistikgruppe mit identischem Gruppennamen existiert bereits!\'" required-message="\'Gruppename fehlt!\'" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <button type="submit" class="btn btn-primary">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/statistics/statisticModal/addStatistics.html','<div class="modal-content"><form id="statisticForm" name="statisticForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title">{{$modalCtrl.modalTitle}}</h4></div><div class="modal-body"><h3 class="with-line" toggle-next="">Statistik Details</h3><div class="row"><div class="col-md-12"><div class="form-group"><label for="titleInput">Name der Statistik</label> <input type="text" autofocus="" placeholder="Name" ng-model="$modalCtrl.title" class="form-control" id="titleInput" name="titleInput" ng-model-options="{ debounce: 200 }" validator="!$modalCtrl.isStatisticTitleExistent($modalCtrl.title)" invalid-message="\'Eine Statistik mit identischem Namen existiert bereits!\'" required-message="\'Statistikname fehlt!\'" required=""></div><div class="form-group"><label for="linkInput">Beschreibung</label> <input type="text" ng-model="$modalCtrl.description" class="form-control" id="linkInput" placeholder="Link/Bemerkung"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <button type="submit" class="btn btn-primary">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/supervisors/approvalSupervisors/approvalSupervisors.html','<div ba-panel="" ba-panel-title="\'components.superVisorsList.approvalSupervisorsTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="false" ba-panel-division-selector-entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}"><arno-dash-admin-divisions-supervisors-list ng-if="$ctrl.selectedDivision" config="$ctrl.supervisorsListConfig" organization-id="$ctrl.organizationId" division-tree="$ctrl.divisionTree" division-nodes-data="$ctrl.divisionNodesData" selected-division="$ctrl.selectedDivision" supervisors="$ctrl.selectedDivision.approvalsSupervisors" change-indicator="$ctrl.changes.approvalsSupervisors"></arno-dash-admin-divisions-supervisors-list></div>');
$templateCache.put('app/pages/administration/supervisors/statisticsSupervisors/statisticsSupervisors.html','<div ba-panel="" ba-panel-title="\'components.superVisorsList.statisticSupervisorsTitle\'" ba-panel-division-selector="true" ba-panel-division-selector-multiple="false" ba-panel-division-selector-allow-org-selection="$ctrl.allowOrgSelection" ba-panel-division-selector-entry-permission="{{ ::$ctrl.divisionSelectorEntryPermission }}"><arno-dash-admin-divisions-supervisors-list ng-if="$ctrl.selectedDivision && !$ctrl.organizationData" config="$ctrl.supervisorsListConfig" organization-id="$ctrl.organizationId" division-tree="$ctrl.divisionTree" division-nodes-data="$ctrl.divisionNodesData" selected-division="$ctrl.selectedDivision" supervisors="$ctrl.selectedDivision.statisticsSupervisors" change-indicator="$ctrl.changes.statisticsSupervisors"></arno-dash-admin-divisions-supervisors-list><arno-dash-admin-org-supervisors-list ng-if="!$ctrl.selectedDivision && $ctrl.organizationData" config="$ctrl.supervisorsListConfig" organization-data="$ctrl.organizationData" role-id="$ctrl.organizationData.roleId" supervisors="$ctrl.organizationData.statisticsSupervisors" change-indicator="$ctrl.changes.statisticsSupervisors"></arno-dash-admin-org-supervisors-list><div ng-if="!$ctrl.selectedDivision && !$ctrl.organizationData" class="text-center">{{ \'components.superVisorsList.statisticSupervisorsTitle\' | translate }}</div></div>');
$templateCache.put('app/pages/contacts/businessPartners/components/businessPartnerDuplicates.comp.html','<div ng-if="($duplicatesCtrl.duplicates || []).length"><h5 class="--color-danger">{{ $duplicatesCtrl.headerTitle | translate }}</h5><div class="table-responsive"><table class="table table-condensed"><thead><tr><th translate="modules.contacts.businessPartners.overview.nameCol">Name</th><th translate="modules.contacts.businessPartners.overview.tradeNameCol">Handelsname</th><th translate="modules.contacts.businessPartners.overview.CustomerNumber">Kundennummer</th><th translate="modules.contacts.businessPartners.overview.EMail">E-Mail</th><th translate="modules.contacts.businessPartners.overview.cityCol">Stadt</th><th translate="modules.contacts.businessPartners.overview.zipCol">PLZ</th><th translate="modules.contacts.businessPartners.overview.streetCol">Stra\xDFe</th><th translate="modules.contacts.businessPartners.overview.houseNumberCol">Nr</th><th translate="modules.contacts.businessPartners.overview.taxIdentCol">Steuernummer</th><th translate="modules.contacts.businessPartners.overview.legalRegIdentCol">Registernummer</th><th translate="modules.contacts.businessPartners.overview.vatIdentCol">Umsatzsteuer-ID</th><th></th></tr></thead><tbody><col><col><col><col><col><col><col><col><col><col><col><col width="200px"><tr ng-repeat="duplicateBusinessPartner in $duplicatesCtrl.duplicates" class="--cell-text-middle" ng-init="duplicateBusinessPartner.similarFields = $duplicatesCtrl.getSimilarFields($duplicatesCtrl.businessPartner, duplicateBusinessPartner)"><td ng-class="{success: duplicateBusinessPartner.similarFields[\'Name\'] == 1, warning: duplicateBusinessPartner.similarFields[\'Name\'] < 1 }"><i ng-if="duplicateBusinessPartner.DivisionId != null && duplicateBusinessPartner.IsInternal" class="fa fa-sitemap" title="{{ ::(\'modules.contacts.businessPartners.overview.systemDivisionBusinessPartnerTooltip\' | translate) }}"></i> <i ng-if="duplicateBusinessPartner.DivisionId != null && !duplicateBusinessPartner.IsInternal" class="ion-ios-people-outline" title="{{ ::(\'modules.contacts.businessPartners.overview.divisionBusinessPartnerTooltip\' | translate) }}"></i> <i ng-if="duplicateBusinessPartner.DivisionId == null" class="ion-ios-people" title="{{ ::(\'modules.contacts.businessPartners.overview.orgBusinessPartnerTooltip\' | translate) }}"></i> <span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.Name || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">({{ ::$duplicatesCtrl.orgName }})</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.Name || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'TradeName\'] == 1, warning: duplicateBusinessPartner.similarFields[\'TradeName\'] < 1 }">{{ duplicateBusinessPartner.TradeName || "" }}</td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'CustomerNumber\'] == 1, warning: duplicateBusinessPartner.similarFields[\'CustomerNumber\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.CustomerNumber || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.CustomerNumber || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'EMail\'] == 1, warning: duplicateBusinessPartner.similarFields[\'EMail\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.EMail || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.EMail || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'City\'] == 1, warning: duplicateBusinessPartner.similarFields[\'City\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.City || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.City || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'ZIP\'] == 1, warning: duplicateBusinessPartner.similarFields[\'ZIP\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.ZIP || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.ZipCode || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'Street\'] == 1, warning: duplicateBusinessPartner.similarFields[\'Street\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.Street || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.Street || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'HouseNumber\'] == 1, warning: duplicateBusinessPartner.similarFields[\'HouseNumber\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.HouseNumber || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.HouseNumber || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'TaxIdentifier\'] == 1, warning: duplicateBusinessPartner.similarFields[\'TaxIdentifier\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.TaxIdentifier || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.TaxIdentifier || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'LegalRegistrationIdentifier\'] == 1, warning: duplicateBusinessPartner.similarFields[\'LegalRegistrationIdentifier\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.LegalRegistrationIdentifier || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.LegalRegistrationIdentifier || "" }}</span></td><td ng-class="{success: duplicateBusinessPartner.similarFields[\'VatIdentifier\'] == 1, warning: duplicateBusinessPartner.similarFields[\'VatIdentifier\'] < 1 }"><span ng-if="!duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.VatIdentifier || "" }}</span> <span ng-if="duplicateBusinessPartner.IsInternal">{{ duplicateBusinessPartner.OwnerDivision.VatIdentifier || "" }}</span></td><td class="d-flex justify-content-end"><button ng-if="$duplicatesCtrl.hasDivManagePermission && $duplicatesCtrl.allowAddLinking && $duplicatesCtrl.notAddedYet(duplicateBusinessPartner) && duplicateBusinessPartner.DivisionId != null" type="button" ng-click="$duplicatesCtrl.addBusinessPartnerAsLinking(duplicateBusinessPartner)" class="btn btn-success btn-with-icon btn-xs" title="{{ ::(\'modules.contacts.businessPartners.overview.linkingAddBtnLabel\' | translate) }}"><i class="fa fa-link"></i> <span class="hidden-xs" translate="generalTerms.add">Hinzuf\xFCgen</span></button> <button type="button" ng-if="(duplicateBusinessPartner.DivisionId == null && $duplicatesCtrl.hasOrgViewPermission) || (duplicateBusinessPartner.DivisionId != null && $duplicatesCtrl.hasDivViewPermission)" ng-click="$duplicatesCtrl.gotoBusinessPartnerDetails(duplicateBusinessPartner)" class="btn btn-default btn-with-icon btn-xs ml-8" title="{{ ::(\'modules.contacts.businessPartners.duplicatesComp.accessBusinessPartner\' | translate) }}"><i class="fa fa-external-link"></i> <span class="hidden-xs hidden-sm" translate="modules.contacts.businessPartners.duplicatesComp.accessBusinessPartner">Aufrufen</span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/contacts/businessPartners/modals/businessPartnerDivSelector.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.contacts.businessPartners.details.divSelectorModal.title"></h4></div><div class="modal-body"><div class="alert bg-info"><h4 translate="modules.contacts.businessPartners.details.divSelectorModal.infoTitle"></h4><p translate="modules.contacts.businessPartners.details.divSelectorModal.infoText"></p></div><div><ui-select ng-model="$ctrl.selectedDiv" class="btn-group bootstrap-select form-control" search-enabled="true"><ui-select-match placeholder="{{ \'modules.contacts.businessPartners.details.divSelectorModal.selectorPH\' | translate }}">{{ $ctrl.selectedDiv.Division.Name }}</ui-select-match><ui-select-choices position="down" repeat="div in $ctrl.selectableDivs" refresh="$ctrl.searchDivs($select.search)" refresh-delay="200"><span>{{ div.Division.Name }}</span></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.selectedDiv" ng-click="$ctrl.applyModal()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/contacts/contactManagement/privacyAgreement/privacyAgreement.comp.html','<table class="emergency-contact-data-table"><tr><td class="pt-5"><div class="row pt-5"><div class="col-sm-12"><div class="form-group clearfix"><div class="inline-date"><label for="deliveredDateTime" class="control-label required-label" ng-class="{\'required-label\': $ctrl.privacyTermsAlreadyDelivered === \'1\'}" translate="modules.personnel.dossier.baseData.emergencyContactModal.alreadyPassedText3"></label><div class="input-group" ng-class="{\'has-error\': $ctrl.hasError($ctrl.emergencyContactForm , \'deliveredDateTime\', [\'required\'])}"><input type="text" id="deliveredDateTime" name="deliveredDateTime" class="form-control" uib-datepicker-popup="{{$ctrl.datepicker.format}}" datepicker-options="$ctrl.datepicker.options" ng-model="$ctrl.emergencyContact.PrivacyTermsDeliveredDateTime" is-open="$ctrl.openedDeliveredDateTime" close-text="{{ (\'generalTerms.close\' | translate) }}" show-button-bar="false" required-message="\'modules.personnel.dossier.baseData.emergencyContactModal.lastNameMissing\' | translate" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.openedDeliveredDateTime = !$ctrl.openedDeliveredDateTime"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="inline-time"><div uib-timepicker="" ng-model="$ctrl.emergencyContact.PrivacyTermsDeliveredDateTime" hour-step="$ctrl.hstep" minute-step="$ctrl.mstep" max="$ctrl.maxTimepick" show-meridian="$ctrl.isMeridian"></div></div></div><div class="alert bg-warning" ng-if="$ctrl.outdatedTermsDelivered"><h4 translate="modules.personnel.inviteList.outdatedWarningHeader"></h4><p translate="modules.personnel.inviteList.outdatedWarningP1"></p><p translate="modules.personnel.inviteList.outdatedWarningP2"></p><p translate="modules.personnel.inviteList.outdatedWarningP3" translate-values="{ date: $ctrl.privacyTermDate }"></p></div><div class="form-group clearfix" ng-class="{\'has-error\': $ctrl.hasError($ctrl.emergencyContactForm , \'deliveredPerson\', [\'required\'])}"><label for="deliveredPerson" class="control-label required-label" ng-class="{\'required-label\': $ctrl.privacyTermsAlreadyDelivered === \'1\'}" translate="modules.personnel.inviteList.deliveredByLabel1"></label> <input type="text" class="form-control" name="deliveredPerson" id="deliveredPerson" ng-model="$ctrl.emergencyContact.PrivacyTermsDeliveredPerson" equired-message="{{(\'modules.personnel.dossier.baseData.emergencyContactModal.lastNameMissing\' | translate )}}" required=""></div><div class="form-group clearfix" ng-class="{\'has-error\': $ctrl.hasError($ctrl.emergencyContactForm , \'deliveredChannel\', [\'required\'])}"><label for="deliveredChannel" class="control-label required-label" ng-class="{\'required-label\': $ctrl.privacyTermsAlreadyDelivered === \'1\'}" translate="modules.personnel.inviteList.deliveredByLabel2"></label><select name="deliveredChannel" id="deliveredChannel" class="form-control" ng-model="$ctrl.emergencyContact.PrivacyTermsDeliveredChannel" required=""><option value="IN_PERSON" translate="models.Member.PrivacyTermsDeliveredChannel.IN_PERSON"></option><option value="POSTAL" translate="models.Member.PrivacyTermsDeliveredChannel.POSTAL"></option><option value="E_MAIL_EXT" translate="models.Member.PrivacyTermsDeliveredChannel.E_MAIL_EXT"></option></select></div><div class="form-group clearfix"><button type="button" class="btn btn-default" ng-click="$ctrl.downloadPrivacyAgreement()" translate="modules.personnel.dossier.baseData.emergencyContactModal.downloadPrivacyAgreement"></button></div></div></div></td></tr></table>');
$templateCache.put('app/pages/events/event/modals/attendeeRemarkModal.html','<div class="modal-content"><form id="periodicEventHelperForm" name="periodicEventHelperForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyPerodicPattern()"><div class="modal-header pb-0"><h4 class="modal-title"><i class="fa fa-user"></i>{{$modalCtrl.canEditRemark ? ((\'modules.events.event.modals.remarkTitle1\' | translate) + $modalCtrl.attendeeName + (\'modules.events.event.modals.remarkTitle2\' | translate)) : ((\'modules.events.event.modals.remarkTitle1\' | translate) + $modalCtrl.attendeeName)}}</h4></div><div class="modal-body theme"><div class="panel-body pt-0"><div class="form-group"><textarea ng-disabled="::!$modalCtrl.canEditRemark" class="form-control" ng-model="$modalCtrl.remark" rows="3">Ich komme etwas sp\xE4ter</textarea></div><div class="alert bg-primary" role="alert" ng-if="$modalCtrl.canEditRemark"><i class="fa fa-eye"></i> {{(\'modules.events.event.modals.remarkHint\' | translate)}}</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ $modalCtrl.canEditRemark ? (\'generalTerms.cancel\' | translate) : (\'generalTerms.close\' | translate)}}</button> <button ng-if="$modalCtrl.canEditRemark" type="submit" class="btn btn-primary" ng-click="$modalCtrl.applyModal()">{{ \'generalTerms.confirm\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/events/event/modals/periodicEventHelper.html','<div class="modal-content"><form id="periodicEventHelperForm" name="periodicEventHelperForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyPerodicPattern()"><div class="modal-header"><h4 class="modal-title"><i class="fa fa-magic"></i> {{ \'modules.events.event.modals.seriesAssistent\' | translate }}</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 mb-5"><label><i class="ion-clock pr-3"></i> {{ \'modules.events.event.modals.seriesDuration\' | translate }}<arno-ba-help-tooltip ng-if="$ceEvent.viewMode !== \'view\'" text="{{ modules.events.event.modals.startDayOfSeriesTooltip }}"></arno-ba-help-tooltip></label></div><div class="form-group clearfix mb-20 fixed-radio-line-height"><div class="col-md-12 height-exception mb-6"><label class="control-label">{{ \'modules.events.event.modals.beginning\' | translate }}</label><p class="input-group"><input type="text" name="inputSeriesStartDate" class="form-control" uib-datepicker-popup="{{$modalCtrl.edCtrl.datepicker.format}}" datepicker-options="$modalCtrl.edCtrl.datepicker.options" ng-model="$modalCtrl.edCtrl.eventData.series.startDate" is-open="$modalCtrl.edCtrl.openedInputSeriesStartDate" close-text="Schlie\xDFen" show-button-bar="false" ng-value="$modalCtrl.edCtrl.eventData.series.startDate | date: \'dd.MM.yyyy\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.edCtrl.openedInputSeriesStartDate = !$modalCtrl.edCtrl.openedInputSeriesStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-12"><label class="custom-radio with-inputs"><input type="radio" name="seriesEventEndRadio{{$modalCtrl.edCtrl.ident}}" ng-model="$modalCtrl.edCtrl.eventData.series.eventEndType" value="count"> <span><span>{{ \'modules.events.event.modals.endsAfter\' | translate }}</span> <input class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.eventEndCount" type="number" min="1" max="500" step="1"> <span>{{ \'modules.events.event.modals.meetings\' | translate: { plural: $modalCtrl.edCtrl.eventData.series.eventEndCount > 1 } }}</span></span></label></div><div class="col-md-12"><label class="custom-radio with-inputs"><input type="radio" name="seriesEventEndRadio{{$modalCtrl.edCtrl.ident}}" ng-model="$modalCtrl.edCtrl.eventData.series.eventEndType" value="date"> <span><span>{{ \'modules.events.event.modals.endsAtThe\' | translate }}</span> <span class="input-group-span"><span class="input-group"><input type="text" name="inputSeriesEndDate" class="form-control" uib-datepicker-popup="{{$modalCtrl.edCtrl.datepicker.format}}" datepicker-options="$modalCtrl.edCtrl.datepicker.options" ng-model="$modalCtrl.edCtrl.eventData.series.endDate" is-open="$modalCtrl.edCtrl.openedInputSeriesEndDate" close-text="{{ \'generalTerms.close\' | translate }}" show-button-bar="false" ng-value="$modalCtrl.edCtrl.eventData.series.endDate | date: \'dd.MM.yyyy\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.edCtrl.openedInputSeriesEndDate = !$modalCtrl.edCtrl.openedInputSeriesEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></span></span></span></label></div></div><div class="col-md-12"><label><i class="fa fa-cubes pr-3"></i> {{ \'modules.events.event.modals.seriesTemplate\' | translate }}<arno-ba-help-tooltip ng-if="$ceEvent.viewMode !== \'view\'" text="{{ modules.events.event.modals.daysOfSeriesTemplateTooltip }}"></arno-ba-help-tooltip></label></div><div class="col-md-12 mt-10"><div ba-panel="" ba-panel-class="tabs-panel with-scroll inline-panel"><uib-tabset class="inline-tabset"><uib-tab heading="{{ \'modules.events.event.modals.dayly\' | translate }}" select="$modalCtrl.setActiveTab(\'daily\')"><div class="row form-group"><div class="col-md-12"><label class="custom-radio with-inputs without-top-margin"><input type="radio" name="seriesEventDailyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.daily.type" value="count"> <span><span>{{ $modalCtrl.edCtrl.eventData.series.daily.count && $modalCtrl.edCtrl.eventData.series.daily.count > 1 ? (\'modules.events.event.modals.EveryAll\' | translate) : (\'modules.events.event.modals.EveryMale\' | translate) }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.daily.count" min="1" max="365" step="1"> <span>{{ $modalCtrl.edCtrl.eventData.series.daily.count && $modalCtrl.edCtrl.eventData.series.daily.count > 1 ? (\'modules.events.event.modals.days\' | translate) : (\'modules.events.event.modals.day\' | translate) }}</span></span></label></div><div class="col-md-12"><label class="custom-radio"><input type="radio" name="seriesEventDailyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.daily.type" value="moToFr"> <span>{{ \'modules.events.event.modals.Day\' | translate }}</span></label></div><div class="col-md-12"><label class="custom-radio"><input type="radio" name="seriesEventDailyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.daily.type" value="businessDay"> <span>{{ \'modules.events.event.modals.everyWorkingdayInclSaturday\' | translate }}</span></label></div></div></uib-tab><uib-tab heading="{{ \'modules.events.event.modals.weekly\' | translate }}" select="$modalCtrl.setActiveTab(\'weekly\')"><div class="row form-group"><div class="col-md-12"><label class="with-inputs"><span><span>{{ $modalCtrl.edCtrl.eventData.series.weekly.count && $modalCtrl.edCtrl.eventData.series.weekly.count > 1 ? (\'modules.events.event.modals.EveryAll\' | translate) : (\'modules.events.event.modals.EveryFemale\' | translate) }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.weekly.count" min="1" max="53" step="1"> <span>{{ $modalCtrl.edCtrl.eventData.series.weekly.count && $modalCtrl.edCtrl.eventData.series.weekly.count > 1 ? (\'modules.events.event.modals.weeks\' | translate) : (\'modules.events.event.modals.week\' | translate) }} {{ \'modules.events.event.modals.atThe\' | translate }}</span></span></label></div><div class="col-md-12 checkbox-array"><label class="custom-checkbox" ng-repeat="checkboxDay in $modalCtrl.edCtrl.checkboxDays track by checkboxDay.id"><input type="checkbox" ng-model="$modalCtrl.edCtrl.eventData.series.weekly.days[checkboxDay.id]"> <span>{{checkboxDay.name}}</span></label></div></div></uib-tab><uib-tab heading="{{ \'modules.events.event.modals.monthly\' | translate }}" select="$modalCtrl.setActiveTab(\'monthly\')"><div class="row form-group"><div class="col-md-12"><label class="custom-radio with-inputs without-top-margin"><input type="radio" name="seriesEventMonthlyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.type" value="date"> <span><span>{{ \'modules.events.event.modals.AtThe\' | translate }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.dateDay" min="1" max="31" step="1"> <span>. {{ \'modules.events.event.modals.day\' | translate }} {{ \'modules.events.event.modals.every\' | translate }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.dateMonth" min="1" max="12" step="1"> <span>. {{ \'modules.events.event.modals.month\' | translate }}s</span></span></label></div><div class="col-md-12"><label class="custom-radio with-inputs"><input type="radio" name="seriesEventMonthlyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.type" value="day"> <span><span>{{ \'modules.events.event.modals.AtThe\' | translate }}</span><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.dayPlace" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.place track by option.id"></select><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.dayDay" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.day track by option.id"></select><span>{{ $modalCtrl.edCtrl.eventData.series.monthly.dayMonthCount && $modalCtrl.edCtrl.eventData.series.monthly.dayMonthCount > 1 ? (\'modules.events.event.modals.everyAll\' | translate) : (\'modules.events.event.modals.everyMale\' | translate) }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.monthly.dayMonthCount" min="1" max="12" step="1"> <span>. {{$modalCtrl.edCtrl.eventData.series.monthly.dayMonthCount && $modalCtrl.edCtrl.eventData.series.monthly.dayMonthCount > 1 ? (\'modules.events.event.modals.months\' | translate) : (\'modules.events.event.modals.month\' | translate) }}</span></span></label></div></div></uib-tab><uib-tab heading="{{ \'modules.events.event.modals.yearly\' | translate }}" select="$modalCtrl.setActiveTab(\'yearly\')"><div class="row form-group"><div class="col-md-12"><label class="with-inputs"><span><span>{{ $modalCtrl.edCtrl.eventData.series.yearly.count && $modalCtrl.edCtrl.eventData.series.yearly.count > 1 ? (\'modules.events.event.modals.EveryAll\' | translate) : (\'modules.events.event.modals.Every\' | translate) }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.count" min="1" max="100" step="1"> <span>{{ $modalCtrl.edCtrl.eventData.series.yearly.count && $modalCtrl.edCtrl.eventData.series.yearly.count > 1 ? (\'modules.events.event.modals.years\' | translate) : (\'modules.events.event.modals.year\' | translate) }}</span></span></label></div><div class="col-md-12"><label class="custom-radio with-inputs"><input type="radio" name="seriesEventYearlyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.type" value="date"> <span><span>{{ \'modules.events.event.modals.AtThe\' | translate }}</span> <input class="form-control" type="number" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.dateDay" min="1" max="31" step="1"><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.dateMonth" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.month track by option.id"></select></span></label></div><div class="col-md-12"><label class="custom-radio with-inputs"><input type="radio" name="seriesEventYearlyRadio" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.type" value="day"> <span><span>{{ \'modules.events.event.modals.AtThe\' | translate }}</span><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.dayPlace" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.place track by option.id"></select><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.dayDay" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.day track by option.id"></select><span>{{ \'modules.events.event.modals.inThe\' | translate }}</span><select class="form-control" ng-model="$modalCtrl.edCtrl.eventData.series.yearly.dayMonth" ng-options="option.name for option in $modalCtrl.edCtrl.commonSelectValues.month track by option.id"></select></span></label></div></div></uib-tab></uib-tabset></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'generalTerms.cancel\' | translate }}</button> <button type="submit" class="btn btn-primary"><i class="ion-wand"></i> <span>{{ \'modules.events.event.modals.useTemplate\' | translate }}</span></button></div></form></div>');
$templateCache.put('app/pages/events/event/modals/recordEventModal.html','<div class="modal-content"><form id="periodicEventHelperForm" name="periodicEventHelperForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyPerodicPattern()"><div class="modal-header"><h4 class="modal-title"><i class="fa fa-user"></i>{{ \'modules.events.event.trainingAndQualification\' | translate}}</h4></div><div class="modal-body theme"><div class="panel-body"><table class="table"><thead><tr><th class="ng-scope">{{(\'modules.events.shiftTemplate.participant\' | translate) }}</th><th class="ng-scope"></th></tr></thead><tbody><tr ng-repeat="person in $modalCtrl.attendances"><td>{{ person.fullName }}</td><td><input type="checkbox" ng-model="person.checked"></td></tr></tbody></table></div><div class="mt-10 p-10 pb-13 border-top border-bottom ng-scope"><input class="from-control" type="checkbox" ng-model="$modalCtrl.recordQualification"> <span class="pr-10">{{ \'generalTerms.qualifications\' | translate}}</span> <input class="from-control" type="checkbox" ng-model="$modalCtrl.recordTraining"> <span></span>{{ \'generalTerms.trainings\' | translate}}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'generalTerms.cancel\' | translate }}</button> <button type="submit" class="btn btn-primary" ng-click="$modalCtrl.applyModal()">{{ \'generalTerms.confirm\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/events/event/modals/recordEventQualificationModal.html','<div class="modal-content"><form id="qualificationForm" name="qualificationForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.title" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><ui-select multiple="" ng-model="$modalCtrl.qualifications" search-enabled="true" append-to-body="false" ng-disabled="self.disabled" class="form-control arno-roleselect" ng-change="$modalCtrl.onQualificationsChanged()"><ui-select-match placeholder="{{ \'components.inspectionSelector.searchInspection\' | translate }}"><span>{{ $item.Name }}</span></ui-select-match><ui-select-choices position="down" repeat="qualificationChoice in $modalCtrl.flatQualificationHierarchy | filter: {$: $select.search} | orderBy:[\'GroupName\',\'Name\']" group-by="\'GroupName\'"><i ng-class="{\'ion-ios-people\':!qualificationChoice.DivisionId, \'ion-ios-people-outline\':qualificationChoice.DivisionId }"></i> <span>{{ qualificationChoice.Name }}</span></ui-select-choices></ui-select><div ng-show="$modalCtrl.qualifications[0]"><div class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="$modalCtrl.qualification.InitialInstructionByManufacturerOrAuthorizedPerson"> <span>{{ ($modalCtrl.type === \'instruction\' ? \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturer\' : \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturerQual\' ) | translate }}</span></label></div><div class="row"><div class="form-group col-md-6"><label for="acquireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.aquireDateLabel" class="control-label required-label" translate-values="{ qualification: $modalCtrl.qualification.Name, typeSingular: $modalCtrl.translateValues.typeSingular }"></label><div class="input-group"><input data-cy="components-qualificationlist-modal-acquiredate" id="acquireDate" name="acquireDate" class="form-control" type="text" uib-datepicker-popup="{{$modalCtrl.acquireDatepicker.format}}" datepicker-options="$modalCtrl.acquireDatepicker.options" is-open="$modalCtrl.acquireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="$modalCtrl.qualification.AcquireDate" ng-model-options="{ debounce: 200 }" required-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.noRefDate\' | translate)" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.acquireDateOpened = !$modalCtrl.acquireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-6"><label for="expireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateLabel" translate-values="{ qualification: $modalCtrl.qualification.Name, typeSingular: $modalCtrl.translateValues.typeSingular }"></label><div class="input-group"><input data-cy="components-qualificationlist-modal-expiredate" id="expireDate" name="expireDate" class="form-control" type="text" validator="$modalCtrl.checkForValidExpireDate()" uib-datepicker-popup="{{$modalCtrl.expireDatepicker.format}}" datepicker-options="$modalCtrl.expireDatepicker.options" is-open="$modalCtrl.expireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="$modalCtrl.qualification.ExpireDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.expireDateOpened = !$modalCtrl.expireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block sub-little-text" ng-if="$modalCtrl.ExpireDateViaValidityPeriodHelper">> <i class="fa fa-info-circle"></i> {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText1\' | translate }} {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText2\' | translate }}</span></div></div><div class="form-group"><label for="instructingPersonTypeSelection" class="control-label required-label" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructingPerson" translate-values="$modalCtrl.translateValues"></label><div class="d-flex"><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio1" ng-model="$modalCtrl.selectedPersonFieldType" value="member"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionMember"></span></label></div><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio2" ng-model="$modalCtrl.selectedPersonFieldType" value="contact"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionContact"></span></label></div><div><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio3" ng-model="$modalCtrl.selectedPersonFieldType" value="organisation"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionOrganisation"></span></label></div></div><div class="form-group"><member-selector ng-show="$modalCtrl.selectedPersonFieldType === \'member\'" initial-member-value="$modalCtrl.qualification.InstructingMember" on-member-select="$modalCtrl.instructingMemberSelected" blank-search-on-click="true" only-active="true" keep-after-selection="true" member-exclude="$modalCtrl.memberExclude" divisions="$modalCtrl.divisionIds"></member-selector><contact-selector ng-show="$modalCtrl.selectedPersonFieldType === \'contact\'" on-select="$modalCtrl.instructingContactSelected" selected-contact="$modalCtrl.qualification.InstructingContact" blank-search-on-click="true" only-active="true" divisions="$modalCtrl.divisionIds"></contact-selector><business-partners-selector ng-show="$modalCtrl.selectedPersonFieldType === \'organisation\'" division="$modalCtrl.divisionIds" on-business-partner-select="$modalCtrl.instructingOrganisationSelected" selected-business-partner="$modalCtrl.qualification.InstructingBusinessPartner" append-to-body="false"></business-partners-selector><div ng-if="$modalCtrl.qualifications[0]" class="hidden-inputs"><div><input type="hidden" class="form-control" name="InstructingMemberSelected" ng-model="$modalCtrl.qualification.InstructingMemberId" validator="$modalCtrl.selectedPersonFieldType === \'member\' ? !!$modalCtrl.qualifications[0].InstructingMemberId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div><div><input type="hidden" class="form-control" name="InstructingContactSelected" ng-model="$modalCtrl.qualification.InstructingContactId" validator="$modalCtrl.selectedPersonFieldType === \'contact\' ? !!$modalCtrl.qualifications[0].InstructingContactId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div><div><input type="hidden" class="form-control" name="InstructingBusinessPartnerSelected" ng-model="$modalCtrl.qualification.InstructingBusinessPartnerId" validator="$modalCtrl.selectedPersonFieldType === \'organisation\' ? !!$modalCtrl.qualifications[0].InstructingBusinessPartnerId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div></div></div></div><div ng-if="$modalCtrl.type === \'qualification\'" class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="$modalCtrl.qualification.ForeignQualificationAccepted"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.foreignQualificationText"></span></label> <textarea class="form-control --vresize" placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.foreignQualificationPlaceholder\' | translate)}}" ng-model="$modalCtrl.qualification.ForeignQualificationRemark" ng-disabled="!$modalCtrl.qualification.ForeignQualificationAccepted"></textarea></div><div ng-if="$modalCtrl.type === \'instruction\'" class="form-group"><label translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructionMaterial" translate-values="$modalCtrl.translateValues"></label><ui-select ng-model="$modalCtrl.qualification.InstructionMaterial" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructionMaterialPlaceholder\'| translate:$modalCtrl.translateValues)}}">{{$select.selected.asString}}</ui-select-match><ui-select-choices position="down" repeat="material in $modalCtrl.availableMaterials | filter: {$: $select.search} | orderBy:[\'asString\']" group-by="\'TypeTranslated\'"><span>{{ material.asString }}</span></ui-select-choices></ui-select></div><div class="mb-10 form-group"><file-upload unallowed-file-types="$modalCtrl.unallowedFileTypes" upload-url="$modalCtrl.fileUploadUrl" on-file-uploaded="$modalCtrl.onFileUploaded" on-file-download="$modalCtrl.onFileDownload" on-file-preview="$modalCtrl.onFilePreview" on-file-delete="$modalCtrl.onFileDelete" on-upload-started="$modalCtrl.onUploadStarted" file-name="$modalCtrl.qualification.File || $modalCtrl.qualification.FileName" downloadable-file="$modalCtrl.qualification.File" show-remove-button="true" label-text="\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.fileProof\'"></file-upload></div></div></div><div class="modal-footer"><button data-cy="components-qualificationlist-modal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="components-qualificationlist-modal-submit" type="submit" class="btn btn-primary" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.accept"></button></div></form></div>');
$templateCache.put('app/pages/events/event/partials/attendance.html','<div class="row"><div class="col-md-6"><div class="form-group clearfix"><div ng-if="$ceEvent.viewMode === \'view\' && $ceEvent.canSelfAttend && !$ceEvent.canPartiallyEdit" class="mb-25"><label class="control-label">Teilnahme von {{::$root.ctx.currentUser.fullName}}</label><table class="table table-condensed table-hover"><thead><tr><th>{{ (\'modules.events.event.partials.participantStatus\' | translate) }}</th><th>{{ (\'generalTerms.division\' | translate) }}</th><th>{{ (\'modules.events.event.partials.action\' | translate) }}</th></tr></thead><tbody><tr><td class="align-left-force"><div class="arno-tag tag label label-tag event-status-tag wide" ng-class="$ceEvent.currentAcceptance().className">{{ $ceEvent.currentAcceptance().label }}</div></td><td class="align-left-force"><i class="ion-ios-people-outline"></i> {{$ceEvent.currentAcceptance().division}}</td><td class="align-left-force"><div ng-if="!$ceEvent.isArchived"><button type="button" ng-if="$ceEvent.currentAcceptance().label == \'Accepted\' || $ceEvent.currentAcceptance().label == \'Zugesagt\'" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$ceEvent.addRemark(attendee, true)" title="{{ (\'modules.events.event.partials.editRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{$ceEvent.currentRemark() ? ($ceEvent.currentRemark().length > 15 ? (\'modules.events.event.partials.editRemark\' | translate) : $ceEvent.currentRemark()) : (\'modules.events.event.partials.addRemark\' | translate)}}</span></button> <button type="button" class="btn btn-success btn-dual btn-sm" ng-if="$ceEvent.currentAcceptance().label == \'Declined\' || $ceEvent.currentAcceptance().label == \'Abgesagt\' || $ceEvent.currentAcceptance().label == \'Open\' || $ceEvent.currentAcceptance().label == \'Offen\'" ng-click="$ceEvent.attendanceAdd(null, true, false, true)" title="{{ (\'modules.events.event.partials.approve\' | translate) }}"><i class="fa-user-check fix-btn"><i class="fa fa-user"></i> <i class="fa fa-check offset-color"></i></i> {{ (\'modules.events.event.partials.approve\' | translate) }}</button> <button type="button" class="btn btn-danger ml-7 btn-sm" ng-if="$ceEvent.currentAcceptance().label == \'Accepted\' || $ceEvent.currentAcceptance().label == \'Zugesagt\'|| $ceEvent.currentAcceptance().label == \'Open\' || $ceEvent.currentAcceptance().label == \'Offen\'" ng-click="$ceEvent.attendanceAdd(null, false, false, true)" title="{{ (\'modules.events.event.partials.approve\' | translate) }}"><i class="fa fa-user-times"></i> {{ (\'modules.events.event.partials.cancel\' | translate) }}</button></div></td></tr></tbody></table></div><div class="clearfix"><label class="control-label">{{$ceEvent.viewMode === \'view\' && !$ceEvent.canPartiallyEdit ? (\'modules.events.event.partials.participantMessage\' | translate) : \'\'}}{{ (\'modules.events.event.partials.participantMessage2\' | translate) }}</label><div class="btn-group pull-right" ng-if="$ceEvent.viewMode !== \'view\' || $ceEvent.canPartiallyEdit" uib-dropdown=""><button uib-dropdown-toggle="" type="button" class="btn btn-default btn-xs btn-with-icon"><i class="fa fa-envelope"></i><span class="hidden-xs">{{ (\'modules.events.event.partials.message\' | translate) }}</span><span class="caret ml-3 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li class="dropdown-header">{{ (\'modules.events.event.partials.wideViaEmail\' | translate) }}</li><li role="menuitem"><a href="" ng-click="$ceEvent.sendMessage(\'ACCEPTED\')">{{ (\'modules.events.event.partials.ToPlannedParticipants\' | translate) }}</a></li><li role="separator" class="divider"></li><li class="dropdown-header">{{ (\'modules.events.event.partials.wideViaArno\' | translate) }}</li><li role="menuitem" ng-class="{\'disabled\': $ceEvent.isArchived}" title="{{$ceEvent.isArchived ? (\'modules.events.event.partials.participantInvitationText\' | translate) : \'\'}}"><a href="" ng-click="$ceEvent.inviteAttendee()">{{ (\'modules.events.event.partials.participantInvitation\' | translate) }}</a></li></ul></div><button type="button" ng-if="!$ceEvent.eventData.isEventSeries || $ceEvent.eventData.EventSeriesId" class="btn btn-default btn-xs btn-with-icon pull-right mr-3" ng-click="$ceEvent.downloadICAL($event)"><i class="fa fa-download"></i> {{ (\'modules.events.shiftTemplate.date\' | translate) }}</button> <button type="button" ng-if="$ceEvent.viewMode !== \'view\'" class="btn btn-default btn-xs btn-with-icon pull-right mr-3" ng-click="$ceEvent.attendeeListExport()"><i class="fa fa-download"></i> {{ (\'modules.events.event.partials.export\' | translate) }}</button></div><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="attendee in $ceEvent.eventData.attendance | filter:$ceEvent.attendeeTblFilter | orderBy:[\'Division.Name\', \'fullName\'] as attendanceTbl track by $index"><td class="align-left-force force-minimal"><div class="arno-tag tag label label-tag label-success event-status-tag wide mr-0" ng-if="attendee.Acceptance">{{ (\'modules.events.event.partials.approved\' | translate) }}</div><div class="arno-tag tag label label-tag label-danger event-status-tag wide mr-0" ng-if="!attendee.Acceptance">{{ (\'modules.events.event.partials.canceled\' | translate) }}</div></td><td ng-class="{\'member-inactive\': attendee.isInactive}" class="align-left-force white-space-no-wrap force-minimal"><i class="fa fa-child underage-indicator" ng-if="!(attendee.BirthDate || attendee.Member.BirthDate) || $ceEvent.isUnderaged[attendee.id]" title="{{(attendee.BirthDate || attendee.Member.BirthDate) ? ( (\'modules.events.event.partials.underageText\' | translate) + $ceEvent.isUnderaged[attendee.id] + (\'modules.events.event.partials.underageText2\' | translate)) : (\'modules.events.event.partials.underageText3\' | translate)}}" ng-class="{\'text-primary\': $ceEvent.isUnderaged[attendee.id], \'text-warning\': !(attendee.BirthDate || attendee.Member.BirthDate)}"></i> {{attendee.fullName + (attendee.isInactive ? \' (inaktiv)\' : \'\')}}</td><td class="align-left-force white-space-no-wrap force-minimal"><i class="ion-ios-people-outline"></i> {{attendee.Division.Name}}</td><td ng-if="!$ceEvent.canHandleAttendance(attendee) && attendee.Remark != null && attendee.state != \'ADDED\'" class="align-left-force white-space-no-wrap force-minimal"><button type="button" ng-if="attendee.Acceptance" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$ceEvent.addRemark(attendee, false)" title="{{ (\'modules.events.event.partials.seeRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{attendee.Remark.length > 15 ? (\'modules.events.event.partials.seeRemark\' | translate) : attendee.Remark }}</span></button></td><td class="align-left-force"><div ng-if="$ceEvent.attendanceRemovalWarning[attendee.id]" class="inline-block mr-3" title="{{ (\'modules.events.event.partials.divisionChange\' | translate) }}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div class="arno-tag tag label label-tag event-status-tag without-width" ng-if="attendee.state === \'ADDED\'">{{ (\'modules.events.event.partials.new\' | translate) }}</div><div class="arno-tag tag label label-tag event-status-tag without-width" ng-if="attendee.state === \'UPDATED\'">{{ (\'modules.events.event.partials.update\' | translate) }}</div><div class="arno-tag tag label label-tag label-info event-status-tag without-width" ng-if="attendee.fromSeries && !attendee.state" title="{{ (\'modules.events.event.partials.eventSeries\' | translate) }}"><i class="fa fa-repeat"></i> {{ (\'modules.events.event.partials.series\' | translate) }}</div></td><td class="align-right-force pr-0"><div ng-if="$ceEvent.canHandleAttendance(attendee)"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceEvent.removeAttendance(attendee)" ng-if="attendee.state === \'ADDED\'"><i class="ion-ios-trash"></i><span>{{ (\'modules.events.event.partials.noReport\' | translate) }}</span></button> <button type="button" ng-if="attendee.Acceptance && attendee.state != \'ADDED\'" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$ceEvent.addRemark(attendee, true)" title="{{ (\'modules.events.event.partials.editRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{attendee.Remark ? (attendee.Remark.length > 15 ? (\'modules.events.event.partials.editRemark\' | translate) : attendee.Remark) : (\'modules.events.event.partials.addRemark\' | translate)}}</span></button> <button type="button" ng-if="!attendee.isDeletedDivMember" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$ceEvent.attendanceAdd(attendee, !attendee.Acceptance, null, null, true)" title="{{ (\'modules.events.event.partials.updateReport\' | translate) }}"><i class="fa fa-user-times" ng-if="attendee.Acceptance"></i> <i class="fa-user-check fix-btn" ng-if="!attendee.Acceptance"><i class="fa fa-user"></i> <i class="fa fa-check"></i></i> <span class="hidden-xs">{{ attendee.Acceptance ? (\'modules.events.event.partials.reportCancellation\' | translate) : (\'modules.events.event.partials.reportConfirmation\' | translate)}}</span></button></div></td></tr><tr ng-if="!attendanceTbl.length"><td colspan="99" class="text-center"><i>{{ (\'modules.events.event.partials.noParticipantsReportedText\' | translate) }} {{$ceEvent.viewMode === \'view\' && !$ceEvent.canPartiallyEdit ? (\'modules.events.event.partials.noParticipantsReportedText2\' | translate) : \'\'}} {{ (\'modules.events.event.partials.noParticipantsReportedText3\' | translate) }}</i></td></tr></tbody></table></div><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="!$ceEvent.isArchived && ($ceEvent.viewMode !== \'view\' || $ceEvent.canPartiallyEdit)"><ui-select ng-model="$ceEvent.attendanceTarget" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="true"><ui-select-match placeholder="{{\'modules.events.event.partials.searchMember\' | translate}}">{{ $ceEvent.attendanceTarget.fullName }}</ui-select-match><ui-select-choices position="down" repeat="attendee in $ceEvent.attendanceChoices" refresh="$ceEvent.attendanceSearch($select.search)" refresh-delay="200" group-by="$ceEvent.genericEventMemberGroupFunc"><div ng-if="!attendee.none"><div class="arno-tag tag label label-tag event-status-tag" ng-class="$ceEvent.currentAcceptance(attendee).className">{{ $ceEvent.currentAcceptance(attendee).label }}</div><button type="button" ng-if="$ceEvent.currentAcceptance(attendee).label == \'Accepted\' || $ceEvent.currentAcceptance(attendee).label == \'Zugesagt\' && attendee.Remark != null && attendee.state != \'ADDED\'" class="btn btn-secondary btn-with-icon btn-xs" ng-click="$ceEvent.addRemark(attendee, false)" title="{{ (\'modules.events.event.partials.seeRemark\' | translate) }}"><i class="fa fa-commenting-o"></i> <span class="hidden-xs">{{attendee.Remark.length > 15 ? (\'modules.events.event.partials.seeRemark\' | translate) : attendee.Remark}}</span></button> <i class="fa fa-child underage-indicator" ng-if="!(attendee.BirthDate || attendee.Member.BirthDate) || $ceEvent.isUnderaged[attendee.id]" title="{{(attendee.BirthDate || attendee.Member.BirthDate) ? ((\'modules.events.event.partials.underageText\' | translate) + $ceEvent.isUnderaged[attendee.id] + (\'modules.events.event.partials.underageText2\' | translate)) : (\'modules.events.event.partials.underageText3\' | translate)}}" ng-class="{\'text-warning\': $ceEvent.isUnderaged[attendee.id], \'text-primary\': !(attendee.BirthDate || attendee.Member.BirthDate)}"></i> <span>{{ attendee.fullName }} ({{ attendee.ContactEMail || (attendee.Account.Type === \'offline\' ? \'----\' : attendee.Account.EMail)}})</span></div><div ng-if="attendee.none" class="btn-with-icon"><span ng-if="attendee.foundNone"><i class="fa fa-times"></i><span><i>{{ (\'modules.events.event.partials.noValidParticipantsFound\' | translate) }}</i></span></span> <span ng-if="!attendee.foundNone"><i>{{ (\'modules.events.event.partials.pleaseEnterParticipant\' | translate) }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-success-outline btn-dual" ng-click="$ceEvent.attendanceAdd($ceEvent.attendanceTarget, true, true)" ng-disabled="!$ceEvent.attendanceTarget" title="{{ (\'modules.events.event.partials.confirmation\' | translate) }}"><span class="fa-user-check"><i class="fa fa-user"></i> <i class="fa fa-check"></i></span></button> <button type="button" class="btn btn-danger" ng-click="$ceEvent.attendanceAdd($ceEvent.attendanceTarget, false, true)" ng-disabled="!$ceEvent.attendanceTarget" title="{{ (\'modules.events.event.partials.cancellation\' | translate) }}"><i class="fa fa-user-times"></i></button></span></div></div></div></div>');
$templateCache.put('app/pages/events/event/partials/divisionShare.html','<div class="row"><div class="col-md-6"><div class="form-group clearfix"><label class="control-label">{{ (\'modules.events.event.partials.shareWithDivision\' | translate) }}<arno-ba-help-tooltip ng-if="!$ceEvent.metaFieldFrozen" text="{{ (\'modules.events.event.partials.shareWithDivisionText\' | translate) }}"></arno-ba-help-tooltip></label><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="division in $ceEvent.eventData.divisionShare | orderBy:[\'IsShared\',\'Name\'] track by $index"><td class="align-left-force force-minimal"><div class="arno-tag tag label label-tag label-info event-status-tag wide mr-0" ng-if="division.IsShared === null || division.IsShared === undefined">{{ (\'modules.events.event.partials.inRequest\' | translate) }}</div><div class="arno-tag tag label label-tag label-danger event-status-tag wide mr-0" ng-if="division.IsShared === false">{{ (\'modules.events.event.partials.rejected\' | translate) }}</div><div class="arno-tag tag label label-tag label-success event-status-tag wide mr-0" ng-if="division.IsShared">{{ (\'modules.events.event.partials.shared\' | translate) }}</div></td><td class="align-left-force white-space-no-wrap force-minimal"><i class="ion-ios-people-outline"></i> {{division.Name}}</td><td class="align-left-force white-space-no-wrap force-minimal"><div class="arno-tag tag label label-tag v-align-text-bottom" ng-if="division.state === \'ADDED\'">{{ (\'modules.events.event.partials.new\' | translate) }}</div><div class="arno-tag tag label label-tag label-warning v-align-text-bottom" ng-if="division.state === \'REMOVED\'">{{ (\'modules.events.event.partials.toBeRemoved\' | translate) }}</div></td><td class="align-right-force pr-0"><div ng-if="$ceEvent.canHandleDivisionShare(division)" class="inline-block"><button type="button" class="btn btn-success btn-with-icon btn-xs" ng-click="$ceEvent.handleDivisionShare(\'ACCEPT\', division)" title="{{ (\'modules.events.event.partials.accept\' | translate) }}"><i class="ion-plus"></i><span class="hidden-xs">{{ (\'modules.events.event.partials.accept\' | translate) }}</span></button> <button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceEvent.handleDivisionShare(\'DECLINE\', division)" title="{{ (\'modules.events.event.partials.decline\' | translate) }}"><i class="fa fa-times"></i><span class="hidden-xs">{{ (\'modules.events.event.partials.decline\' | translate) }}</span></button></div><button type="button" ng-if="!$ceEvent.isArchived && (($ceEvent.viewMode !== \'view\' && !$ceEvent.canHandleDivisionShare(division)) || $ceEvent.managePermissionsIn(division))" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceEvent.removeDivisionShare(division)" title="{{$ceEvent.removeDivisionShareTitle(division)}}"><i class="ion-ios-trash"></i><span>{{$ceEvent.removeDivisionShareTitle(division)}}</span></button></td></tr><tr ng-if="!$ceEvent.eventData.divisionShare.length"><td colspan="99" class="text-center"><i>{{ (\'modules.events.event.partials.noDivsionsRecorded\' | translate) }}</i></td></tr></tbody></table></div><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="!$ceEvent.metaFieldFrozen"><ui-select ng-model="$ceEvent.divisionShareTarget" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="true"><ui-select-match placeholder="{{ (\'modules.events.event.partials.searchInDivision\' | translate) }}">{{ $ceEvent.divisionShareTarget.Name }}</ui-select-match><ui-select-choices position="down" repeat="division in $ceEvent.divisionShareChoices" refresh="$ceEvent.divisionShareSearch($select.search)" refresh-delay="200" group-by="$ceEvent.divisionShareGroupFunc"><div ng-if="!division.none"><i class="ion-ios-people-outline"></i> <span>{{ division.Name }}</span></div><div ng-if="division.none" class="btn-with-icon"><span ng-if="division.foundNone"><i class="fa fa-times"></i><span><i>{{ (\'modules.events.event.partials.noValidDivisionsFound\' | translate) }}</i></span></span> <span ng-if="!division.foundNone"><i>{{ (\'modules.events.event.partials.pleaseEnterSearchedDivision\' | translate) }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn"><span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ceEvent.divisionShareAdd($ceEvent.divisionShareTarget)" ng-disabled="!$ceEvent.divisionShareTarget"><i class="fa fa-share-square-o"></i> {{ (\'modules.events.event.partials.share\' | translate) }}</button></span></span></div></div></div><div class="col-sm"><button ng-if="$ceEvent.SubDivisionsExist && !$ceEvent.isArchived && $ceEvent.viewMode != \'view\'" class="btn btn-default btn-xs btn-with-icon pull-left" type="button" ng-click="$ceEvent.divisionShareAddAllSubs()"><i class="fa fa-share-square-o"></i><span class="ml-5" translate="modules.events.event.partials.shareAllSubDivs"></span></button></div></div>');
$templateCache.put('app/pages/events/event/partials/eventMeta.html','<div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label">{{ (\'modules.events.event.partials.responsible\' | translate) }}<arno-ba-help-tooltip ng-if="$ceEvent.viewMode !== \'view\'" text="{{ (\'modules.events.event.partials.responsibleText\' | translate) }}"></arno-ba-help-tooltip></label><table class="table table-condensed"><tbody class="without-top-border"><tr ng-if="$ceEvent.eventData.eventResponsibles.length" ng-repeat="eventResponsible in $ceEvent.eventData.eventResponsibles | filter:$ceEvent.eventResponsibleFilter | orderBy:\'Member.fullName\' track by eventResponsible.MemberId" class="no-top-border"><td class="align-left-force white-space-no-wrap force-minimal"><span class="mr-3" ng-class="{\'member-inactive\': eventResponsible.isInactive}">{{::(eventResponsible.isInactive ? eventResponsible.Member.fullName + \' (inaktiv)\' : eventResponsible.Member.fullName)}}</span><div class="arno-tag tag label label-tag label-info event-status-tag without-width" ng-if="eventResponsible.fromSeries" title="{{ (\'modules.events.event.partials.eventResponsible\' | translate) }}"><i class="fa fa-repeat"></i> {{ (\'modules.events.event.partials.series\' | translate) }}</div><div ng-if="$ceEvent.eventResponsibleRemovalWarning[eventResponsible.MemberId]" class="inline-block mr-3" title="{{ (\'modules.events.event.partials.eventResponsibleRemovalWarning\' | translate) }}"><i class="fa fa-exclamation-triangle text-danger"></i></div></td><td class="align-right-force pr-0" ng-if="$ceEvent.viewMode !== \'view\'"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceEvent.removeEventResponsible(eventResponsible)"><i class="ion-ios-trash"></i><span>{{ (\'generalTerms.remove\' | translate) }}</span></button></td></tr><tr ng-if="!$ceEvent.eventData.eventResponsibles.length"><td colspan="99" class="text-center"><i>{{ (\'modules.events.event.partials.noResponsiblePersonRecorded\' | translate) }}</i></td></tr></tbody></table><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="$ceEvent.viewMode !== \'view\' && !$ceEvent.metaFieldFrozen"><ui-select ng-model="$ceEvent.selectedEventResponsible" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="true"><ui-select-match placeholder="{{ (\'modules.events.event.partials.searchMember\' | translate) }}">{{ $ceEvent.selectedEventResponsible.fullName }}</ui-select-match><ui-select-choices position="down" repeat="eventResponsible in $ceEvent.responsibleChoices" refresh="$ceEvent.responsibleSearch($select.search)" refresh-delay="200" group-by="$ceEvent.genericEventMemberGroupFunc"><div ng-if="!eventResponsible.none"><span>{{ eventResponsible.fullName }} ({{ eventResponsible.ContactEMail || (eventResponsible.Account.Type === \'offline\' ? \'----\' : eventResponsible.Account.EMail)}})</span></div><div ng-if="eventResponsible.none" class="btn-with-icon"><span ng-if="eventResponsible.foundNone"><i class="fa fa-times"></i><span><i>{{ (\'modules.events.event.partials.noValidMemberFound\' | translate) }}</i></span></span> <span ng-if="!eventResponsible.foundNone"><i>{{ (\'modules.events.event.partials.pleaseEnterSearchedMember\' | translate) }}</i></span></div></ui-select-choices></ui-select><div class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ceEvent.addEventResponsible()" ng-disabled="!$ceEvent.selectedEventResponsible"><i class="ion-plus"></i> {{ (\'modules.events.event.partials.add\' | translate) }}</button></div></div></div></div></div>');
$templateCache.put('app/pages/events/event/partials/mainEventData.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputSubject" class="col-sm-12 control-label primary-label required-label">{{ (\'modules.events.event.partials.subject\' | translate) }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputSubject" name="inputSubject" maxlength="254" placeholder="" ng-model="$ceEvent.eventData.Subject" ng-disabled="$ceEvent.metaFieldFrozen" required-message="\'modules.events.event.partials.subjectRequired\' | translate" required=""></div></div><div class="form-group row clearfix"><label for="inputDescription" class="col-sm-12 control-label">{{ (\'modules.events.event.partials.description\' | translate) }}</label><div class="col-sm-12"><textarea class="form-control no-resize" id="inputDescription" ng-model="$ceEvent.eventData.Description" ng-disabled="$ceEvent.metaFieldFrozen"></textarea></div></div><div class="form-group row clearfix"><label for="inputLocationName" class="col-sm-12 control-label">{{ (\'modules.events.event.partials.location\' | translate) }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputLocationName" placeholder="" ng-model="$ceEvent.eventData.LocationName" ng-disabled="$ceEvent.metaFieldFrozen"></div></div><div class="pt-20 hidden-sm hidden-xs"></div><div class="form-group"><label>{{ (\'modules.events.event.partials.dateCategorie\' | translate) }}</label><tag-picker default-label="\'modules.administration.events.noCatEvents\'" tags="$ceEvent.categories" disabled="$ceEvent.metaFieldFrozen" selected-tags="$ceEvent.eventData.categories" hide-division-name="true" on-group-func="$ceEvent.categoryGroupFunc"></tag-picker></div></div><div class="col-md-6 align-center hidden-sm hidden-xs"><i class="glyphicon glyphicon-calendar icon-fullsize-pagerow"></i></div></div><div class="pt-20 hidden-sm hidden-xs"></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="eventSeriesSwitcher" class="col-sm-12 control-label">{{ (\'modules.events.event.partials.series\' | translate) }}</label><div class="col-sm-12" id="eventSeriesSwitcher"><div ng-hide="$ceEvent.viewMode"><ba-switcher switcher-style="primary" switcher-keys="$ceEvent.eventSeriesSwitch.keys" switcher-width="$ceEvent.eventSeriesSwitch.width" switcher-value="$ceEvent.eventData.isSingleEvent"></ba-switcher></div><div ng-show="$ceEvent.viewMode">{{$ceEvent.eventData.isEventSeries ? ($ceEvent.eventData.EventSeriesId ? (\'modules.events.event.partials.dateText\' | translate) : (\'modules.events.event.partials.dateText2\' | translate)) : (\'modules.events.event.partials.dateText3\' | translate)}}</div></div></div></div><div class="col-md-12"><div class="form-group clearfix" ng-show="$ceEvent.viewMode && $ceEvent.eventData.isEventSeries && $ceEvent.eventData.EventSeriesId"><label class="control-label">{{ (\'modules.events.event.partials.eventDate\' | translate) }}</label><div>{{ $ceEvent.eventData.StartDate | date:\'dd.MM.yyyy\' }}</div></div></div></div><div class="row"><div ng-show="$ceEvent.eventData.isEventSeries && (!$ceEvent.viewMode || ($ceEvent.viewMode === \'edit\' && $ceEvent.viewModeSeries === \'eventSeriesMeta\'))"><div class="col-md-6"><div class="row form-group"><div class="col-md-12"><label class="control-label">{{ (\'modules.events.event.partials.datesOfTheSeries\' | translate) }}<arno-ba-help-tooltip ng-if="$ceEvent.viewMode !== \'view\'" text="{{ (\'modules.events.event.partials.datesOfTheSeriesText\' | translate) }}"></arno-ba-help-tooltip></label></div><div class="col-lg-12 col-series-date-select"><div uib-datepicker="" class="calender-series-date-select" ng-model="$ceEvent.seriesPicker.active" multi-select="$ceEvent.eventData.seriesDates" select-range="false" datepicker-options="$ceEvent.seriesPicker.options"></div><button type="button" class="btn btn-info btn-with-icon mt-10" ng-click="$ceEvent.openPeriodicEventHelper()"><i class="fa fa-magic"></i> <span>{{ (\'modules.events.event.partials.serialSampleAssistent\' | translate) }}</span></button> <button type="button" class="btn btn-danger btn-with-icon mt-10 ml-5" ng-click="$ceEvent.resetPerodicPatterns()" ng-if="$ceEvent.eventData.seriesDates.length"><i class="ion-ios-trash"></i> <span>{{$ceEvent.eventData.seriesDates.length + (\'modules.events.event.partials.date\' | translate) + ($ceEvent.eventData.seriesDates.length > 1 ? \'e\' : \'\')}} {{ (\'modules.events.event.partials.reset\' | translate) }}</span></button></div></div></div></div><div ng-class="{\'col-md-6\': !$ceEvent.eventData.isEventSeries, \'col-md-3 col-lg-2\': $ceEvent.eventData.isEventSeries}"><div class="form-group row clearfix"><div class="col-sm-12"><div class="row event-combined-date-time-picker" ng-class="{\'is-series\': $ceEvent.eventData.isEventSeries}"><div ng-show="!$ceEvent.eventData.isEventSeries" class="col-sm-8"><label for="inputStartDate" class="control-label">{{ (\'modules.events.event.partials.start\' | translate) }}</label><p class="input-group"><input type="text" id="inputStartDate" name="inputStartDate" class="form-control" ng-disabled="$ceEvent.metaFieldFrozen" uib-datepicker-popup="{{$ceEvent.datepicker.format}}" datepicker-options="$ceEvent.datepicker.options" ng-model="$ceEvent.eventData.StartDate" is-open="$ceEvent.openedInputStartDate" close-text="Schlie\xDFen" show-button-bar="false" validator="$ceEvent.isValidDate()" invalid-message="\'modules.events.event.partials.correctDate\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ceEvent.openedInputStartDate = !$ceEvent.openedInputStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-class="{\'col-sm-4\':!$ceEvent.eventData.isEventSeries, \'col-sm-12\':$ceEvent.eventData.isEventSeries}"><label ng-show="$ceEvent.eventData.isEventSeries" for="inputStartDate" class="control-label">{{ (\'modules.events.event.partials.start\' | translate) }}</label><div uib-timepicker="" ng-disabled="$ceEvent.metaFieldFrozen" ng-model="$ceEvent.eventData.StartDate" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div></div></div><div ng-class="{\'col-md-6\': !$ceEvent.eventData.isEventSeries, \'col-md-3 col-lg-2\': $ceEvent.eventData.isEventSeries}"><div class="form-group row clearfix"><div class="col-sm-12"><div class="row event-combined-date-time-picker" ng-class="{\'is-series\': $ceEvent.eventData.isEventSeries}"><div ng-show="!$ceEvent.eventData.isEventSeries" class="col-sm-8"><label for="inputEndDate" class="control-label">{{ (\'modules.events.event.partials.end\' | translate) }}</label><p class="input-group"><input type="text" id="inputEndDate" name="inputEndDate" ng-disabled="$ceEvent.metaFieldFrozen" class="form-control" uib-datepicker-popup="{{$ceEvent.datepicker.format}}" datepicker-options="$ceEvent.datepicker.options" ng-model="$ceEvent.eventData.EndDate" is-open="$ceEvent.openedInputEndDate" close-text="{{ (\'modules.events.event.partials.close\' | translate) }}" show-button-bar="false" validator="$ceEvent.isValidDate()" invalid-message="\'modules.events.event.partials.correctDate\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ceEvent.openedInputEndDate = !$ceEvent.openedInputEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-class="{\'col-sm-4\':!$ceEvent.eventData.isEventSeries, \'col-sm-12\':$ceEvent.eventData.isEventSeries}"><label ng-show="$ceEvent.eventData.isEventSeries" for="inputStartDate" class="control-label">{{ (\'modules.events.event.partials.end\' | translate) }}</label><div uib-timepicker="" ng-disabled="$ceEvent.metaFieldFrozen" ng-model="$ceEvent.eventData.EndDate" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/events/event/partials/material.html','<div class="row"><div class="col-md-12"><div class="form-group clearfix"><label class="control-label" ng-if="$ceEvent.viewMode === \'view\' && $ceEvent.compatShift.ServiceShiftMaterialClothings.length == 0 && $ceEvent.compatShift.ServiceShiftMaterialConsumables.length == 0 && $ceEvent.compatShift.ServiceShiftMaterialMedicalProducts.length == 0 && $ceEvent.compatShift.ServiceShiftMaterialMedicines.length == 0 && $ceEvent.compatShift.ServiceShiftMaterialOthers.length == 0 && $ceEvent.compatShift.ServiceShiftMaterialVehicles.length == 0">{{ (\'modules.events.shiftTemplate.noMaterials\' | translate) }}</label> <label class="control-label" ng-if="$ceEvent.viewMode === \'edit\' || (!$ceEvent.compatShift.ServiceShiftMaterialClothings.length == 0 || !$ceEvent.compatShift.ServiceShiftMaterialConsumables.length == 0 || !$ceEvent.compatShift.ServiceShiftMaterialMedicalProducts.length == 0 || !$ceEvent.compatShift.ServiceShiftMaterialMedicines.length == 0 || !$ceEvent.compatShift.ServiceShiftMaterialOthers.length == 0 || !$ceEvent.compatShift.ServiceShiftMaterialVehicles.length == 0)">{{ (\'modules.events.shiftTemplate.materials\' | translate) }}</label> <button type="button" class="btn btn-default btn-xs btn-with-icon pull-right mr-3" ng-click="$ceEvent.eventMaterialReverseShare.editBookingPeriods($ceEvent.compatShift)"><i class="fa fa-clock-o"></i> {{ (\'modules.events.shiftTemplate.bookingPeriods\' | translate) }}</button></div><event-material base-type="\'EVENT\'" reverse-share="$ceEvent.eventMaterialReverseShare" shift="$ceEvent.compatShift" shifts="$ceEvent.compatShifts" hide-edit="$ceEvent.hideMaterialEdit" ctx="$ceEvent.division" ctx-name="$ceEvent.sourceDivisionName" material-meta="$ceEvent.eventMaterialMeta" has-manage-perm="$ceEvent.hasManageFromSourceDivOrItemPerm" initial-booking-material-utilization="$ceEvent.bookingMaterialUtilization" booking-material-utilization-fetch="$ceEvent.bookingMaterialUtilizationFetch" initial-booking-material-included-tree="$ceEvent.bookingMaterialIncludedTree"></event-material></div></div>');
$templateCache.put('app/pages/events/event/partials/meetingData.html','<div class="row"><div class="col-md-6"><div class="row event-combined-date-time-picker"><div class="col-sm-8"><div class="form-group clearfix"><label for="inputMeetingPlaceName" class="control-label">{{ (\'modules.events.event.partials.comingTogether\' | translate) }}</label> <input type="text" class="form-control" id="inputMeetingPlaceName" placeholder="{{\'modules.events.event.partials.eventPlace\' | translate}}" ng-model="$ceEvent.eventData.MeetingPlaceName" ng-disabled="$ceEvent.metaFieldFrozen"></div></div><div class="col-sm-4"><div class="form-group clearfix"><div uib-timepicker="" ng-disabled="$ceEvent.metaFieldFrozen" ng-model="$ceEvent.eventData.MeetingTime" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div></div></div>');
$templateCache.put('app/pages/events/service/partials/mainServiceData.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputSubject" class="col-sm-12 control-label primary-label required-label">{{ (\'modules.events.ServiceData.titel\' | translate) }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputSubject" name="inputSubject" placeholder="" ng-model="$ceService.serviceData.Subject" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" max-char="255" required="" required-message="\'modules.events.ServiceData.pleaseEnterSubject\' | translate" invalid-message="\'modules.events.ServiceData.inputInvalid\' | translate"></div></div><div class="pt-10 hidden-sm hidden-xs"></div><div class="form-group row clearfix"><label class="col-sm-12 control-label" ng-class="$ceService.flowFieldRequired().label">{{ (\'modules.events.overview.eventType\' | translate) }}</label><div class="col-sm-12"><ui-select ng-model="$ceService.chosenServiceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="false" search-enabled="false" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)"><ui-select-match><span>{{$ceService.chosenServiceType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="serviceType in $ceService.availableServiceTypes"><span>{{serviceType.Name}}</span></ui-select-choices></ui-select><input type="hidden" class="form-control" name="chosenServiceTypeValidation" ng-model="$ceService.chosenServiceTypeValidationEmpty" validator="!$ceService.flowFieldRequired().val || !!$ceService.chosenServiceType" invalid-message="\'modules.events.ServiceData.pleaseAddEvent\' | translate"></div></div><div class="form-group" ng-if="$ceService.viewMode !== \'view\' || $ceService.serviceData.BaseCategories.length > 0"><label>{{ (\'modules.events.ServiceData.eventCategories\' | translate) }}</label><tag-picker default-label="\'modules.administration.events.noCatEvents\'" tags="$ceService.availableServiceCategories" selected-tags="$ceService.serviceData.BaseCategories" hide-division-name="true" disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)"></tag-picker></div><div class="pt-10 hidden-sm hidden-xs"></div><div class="form-group row clearfix"><div class="col-sm-12"><div ng-class="{\'service-client-chosen\': $ceService.serviceData.BusinessPartner.id}"><business-partners-selector division="[$ceService.division]" is-buyer="true" selection-proposals="$ceService.divisionBusinessPartners" on-business-partner-select="$ceService.setBusinessPartner" selected-business-partner="$ceService.BusinessPartner" details-extra-label="\'modules.events.ServiceData.eventClient\'" extra-label-cls="(\'control-label\' + $ceService.flowFieldRequired().label)" enable-details="true" ng-disabled="$ceService.quotationBaseId || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)"></business-partners-selector><input type="hidden" class="form-control" name="clientValidation" ng-model="$ceService.businessPartnerValidationEmpty" validator="!$ceService.flowFieldRequired().val || !!$ceService.serviceData.BusinessPartner.id" invalid-message="\'modules.events.ServiceData.pleaseSpecifyClient\' | translate"><div ng-if="$ceService.serviceData.BusinessPartner.id"><div class="font-size-12 alert bg-light-gray mb-0 p-5 px-10"><div><div>{{$ceService.serviceData.BusinessPartner.Street}} {{$ceService.serviceData.BusinessPartner.HouseNumber}}</div><div>{{$ceService.serviceData.BusinessPartner.ZIP}} {{$ceService.serviceData.BusinessPartner.City}}</div></div><div ng-if="$ceService.serviceData.BusinessPartner.IsInternal"><div>{{$ceService.serviceData.BusinessPartner.OwnerDivision.Street}} {{$ceService.serviceData.BusinessPartner.OwnerDivision.HouseNumber}}</div><div>{{$ceService.serviceData.BusinessPartner.OwnerDivision.ZipCode}} {{$ceService.serviceData.BusinessPartner.OwnerDivision.City}}</div></div></div></div></div></div></div><div class="form-group row clearfix"><label for="inputEventContact" class="col-sm-12 control-label" ng-class="$ceService.flowFieldRequired().label">{{ (\'modules.events.ServiceData.ClientContact\' | translate) }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputEventContact" name="inputEventContact" max-char="255" ng-model="$ceService.serviceData.EventContact" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" validator="!$ceService.flowFieldRequired().val || !!$ceService.serviceData.EventContact" invalid-message="$ceService.serviceData.EventContact.length ? (\'modules.events.ServiceData.inputInvalid\' | translate) : (\'modules.events.ServiceData.pleaseSpecifyContactPerson\' | translate)"></div></div></div><div class="col-md-6 align-center hidden-sm hidden-xs"><i class="glyphicon glyphicon-calendar icon-fullsize-pagerow"></i></div></div><div class="pt-40 hidden-sm hidden-xs"></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><div class="col-sm-12"><div class="row event-combined-date-time-picker"><div class="col-sm-8"><label class="control-label required-label">{{ (\'modules.events.ServiceData.eventStart\' | translate) }}</label><p class="input-group"><input type="text" name="inputEventStartDate" class="form-control" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" uib-datepicker-popup="{{$ceService.datepicker.format}}" datepicker-options="$ceService.datepicker.options" ng-model="$ceService.serviceData.EventStartDate" is-open="$ceService.openedInputEventStartDate" close-text="{{ (\'modules.events.ServiceData.close\' | translate) }}" show-button-bar="false" validator="$ceService.isValidDate()" invalid-message="\'modules.events.ServiceData.pleaseCorrectStartEndTime\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ceService.openedInputEventStartDate = !$ceService.openedInputEventStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-4"><div uib-timepicker="" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" ng-model="$ceService.serviceData.EventStartDate" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><div class="col-sm-12"><div class="row event-combined-date-time-picker"><div class="col-sm-8"><label class="control-label required-label">{{ (\'modules.events.ServiceData.eventEnd\' | translate) }}</label><p class="input-group"><input type="text" name="inputEventEndDate" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" class="form-control" uib-datepicker-popup="{{$ceService.datepicker.format}}" datepicker-options="$ceService.datepicker.options" ng-model="$ceService.serviceData.EventEndDate" is-open="$ceService.openedInputEventEndDate" close-text="{{ (\'modules.events.ServiceData.close\' | translate) }}" show-button-bar="false" validator="$ceService.isValidDate()" invalid-message="\'modules.events.ServiceData.pleaseCorrectStartEndTime\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ceService.openedInputEventEndDate = !$ceService.openedInputEventEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-4"><div uib-timepicker="" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" ng-model="$ceService.serviceData.EventEndDate" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div></div></div></div><div class="pt-10 hidden-sm hidden-xs"></div><div class="row"><div class="col-md-6"><div class="row"><arno-ba-address address="$ceService.serviceData" form-ref="serviceEditForm" country-ids-catalogue="$ceService.MEMBER_COUNTRY_IDS" fields-config="$ceService.eventAddressConf" ui-config="$ceService.eventAddressUIConf" can-edit="$ceService.viewMode !== \'view\'" view-only="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)"></arno-ba-address></div></div></div><div class="col-sm-12"><div class="pt-20 hidden-sm hidden-xs"></div></div><div class="row" ng-if="$ceService.viewMode !== \'view\' || $ceService.serviceData.ServiceOperationsManagers.length > 0"><div class="col-md-6"><div class="form-group"><label class="control-label">{{ (\'modules.events.ServiceData.Operationsmanager\' | translate) }}<arno-ba-help-tooltip ng-if="$ceService.viewMode !== \'view\'" text="{{ (\'modules.events.ServiceData.OperationsmanagerText\' | translate) }}"></arno-ba-help-tooltip></label><div ng-if="!$ceService.serviceData.ServiceOperationsManagers.length && $ceService.metaFieldFrozen"><i>{{ \'modules.events.ServiceData.noOperationsManagerDeposited\' | translate }}.</i></div><table class="table table-condensed" ng-if="$ceService.serviceData.ServiceOperationsManagers.length"><tbody><tr ng-repeat="operationsManager in $ceService.serviceData.ServiceOperationsManagers | orderBy:\'Member.fullName\' track by operationsManager.MemberId" class="no-top-border"><td class="align-left-force white-space-no-wrap force-minimal"><span ng-class="{\'member-inactive\': operationsManager.isInactive}">{{ operationsManager.isInactive ? (\'modules.events.ServiceData.valueInactive\' | translate:{ value: operationsManager.Member.fullName }) : operationsManager.Member.fullName }}</span></td><td class="align-right-force pr-0"><button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-if="!$ceService.metaFieldFrozen && (!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)" ng-click="$ceService.removeOperationsManager(operationsManager)"><i class="ion-ios-trash"></i><span>{{ (\'modules.events.ServiceData.remove\' | translate) }}</span></button></td></tr></tbody></table><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="!$ceService.metaFieldFrozen && (!$ceService.mediaSizeXS || $ceService.shiftTemplateOpts.mobileEdit)"><member-selector selected-member="$ceService.selectedOperationsManager" only-active="true" divisions="$ceService.managePermissionListWithItemPerm" member-exclude="$ceService.operationsManagerExclude"></member-selector><div class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ceService.addOperationsManager()" ng-disabled="!$ceService.selectedOperationsManager.value"><i class="ion-plus"></i> {{ (\'modules.events.ServiceData.add\' | translate) }}</button></div></div></div></div></div><div class="row" ng-if="$ceService.viewMode !== \'view\' || $ceService.serviceData.AttendanceReminderDate"><div class="col-md-6"><div class="form-group"><label class="control-label">{{ (\'modules.events.ServiceData.attendanceReminder\' | translate) }}<arno-ba-help-tooltip ng-if="$ceService.viewMode !== \'view\'" text="{{ (\'modules.events.ServiceData.attendanceReminderText\' | translate) }}"></arno-ba-help-tooltip></label><p class="input-group"><input type="text" name="inputAttendanceReminderDate" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" class="form-control" uib-datepicker-popup="{{$ceService.datepickerReminder.format}}" datepicker-options="$ceService.datepickerReminder.options" ng-model="$ceService.serviceData.AttendanceReminderDate" is-open="$ceService.openedInputAttendanceReminderDate" close-text="{{ (\'modules.events.ServiceData.close\' | translate) }}" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ceService.openedInputAttendanceReminderDate = !$ceService.openedInputAttendanceReminderDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-12"><div class="pt-20 hidden-sm hidden-xs"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-if="$ceService.viewMode !== \'view\' || $ceService.chosenCateringType.id != \'NOT_PROVIDED\'"><label class="col-sm-12 control-label">{{ (\'modules.events.ServiceData.catering\' | translate) }}</label><div class="col-sm-12"><ui-select ng-model="$ceService.chosenCateringType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="true" on-select="$ceService.cateringTypeChosen($ceService.chosenCateringType)" search-enabled="false" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)"><ui-select-match placeholder="{{ \'modules.events.ServiceData.selectCatering\' | translate }}"><span>{{$ceService.chosenCateringType.label}}</span></ui-select-match><ui-select-choices position="down" repeat="cateringType in $ceService.availableCateringTypes"><span>{{cateringType.label}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix" ng-if="$ceService.viewMode !== \'view\' && $ceService.serviceData.SpecificLocation"><label for="inputSpecificLocation" class="col-sm-12 control-label">{{ (\'modules.events.ServiceData.specificLocation\' | translate) }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputSpecificLocation" name="inputSpecificLocation" ng-model="$ceService.serviceData.SpecificLocation" max-char="4000" ng-disabled="$ceService.metaFieldFrozen || ($ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit)" invalid-message="\'modules.events.ServiceData.inputInvalid\' | translate"></div></div></div><div class="col-md-6" ng-if="$ceService.viewMode !== \'view\' && $ceService.serviceData.Specifics"><div class="form-group row clearfix"><label for="inputSpecifics" class="col-sm-12 control-label">{{ (\'modules.events.ServiceData.specifics\' | translate) }}</label><div class="col-sm-12"><textarea ng-if="!$ceService.metaFieldFrozen" class="form-control no-resize" style="height: 104px;" id="inputSpecifics" name="inputSpecifics" max-char="4000" ng-model="$ceService.serviceData.Specifics" invalid-message="\'modules.events.ServiceData.inputInvalid\' | translate" ng-disabled="$ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit"></textarea><div ng-if="$ceService.metaFieldFrozen" style="min-height: 104px;" class="alert bg-light-gray mb-0 white-space-pre-line">{{$ceService.serviceData.Specifics}}</div></div></div></div><div class="col-md-12" ng-show="$ceService.showReportField()"><div class="pt-20 hidden-sm hidden-xs"></div><div class="form-group row clearfix"><label for="inputReport" class="col-sm-12 control-label" ng-class="$ceService.flowFieldRequired(\'reportRequired\').label">{{ (\'modules.events.ServiceData.endReport\' | translate) }}<div class="arno-tag tag label label-tag label-warning pull-right mr-0" title="{{ (\'modules.events.ServiceData.showReportTitle\' | translate) }}"><i class="fa fa-eye"></i> {{ (\'modules.events.ServiceData.AdministratorsOnly\' | translate) }}</div></label><div class="col-sm-12"><textarea ng-if="$ceService.showReportField(true)" class="form-control no-resize" style="height: 104px;" id="inputReport" name="inputReport" max-char="4000" ng-model="$ceService.serviceData.Report" validator="!$ceService.flowFieldRequired(\'reportRequired\').val || !!$ceService.serviceData.Report" invalid-message="\'\'" ng-disabled="$ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit"></textarea><div ng-if="!$ceService.showReportField(true)" class="alert bg-light-gray mb-0 white-space-pre-line">{{$ceService.serviceData.Report}}</div></div></div></div><div class="col-md-12" ng-if="$ceService.serviceData.id && $ceService.fileStorage"><h5 class="with-line mb-5" toggle-next=""><span>{{ (\'modules.events.ServiceData.documentFiling\' | translate) }}<arno-ba-help-tooltip text="{{ (\'modules.events.ServiceData.documentFilingText\' | translate) }}"></arno-ba-help-tooltip></span></h5><div class="row"><file-storage item-id="$ceService.serviceData.id" storage-ident="\'service\'" ctx="$ceService.division" folder-data="$ceService.fileStorage" edit-permission="$ceService.fileStorageEditPermissionCheck" show-edit-perm-icon="true"></file-storage></div></div><div class="col-md-12" ng-if="$ceService.hasManagePermsInSourceDivOrForItem || $ceService.canPartiallyEdit"><h5 class="with-line" toggle-next=""><span>{{ (\'modules.events.ServiceData.remarks\' | translate) }}</span><div class="arno-tag tag label label-tag label-warning pull-right mt-12 mr-0" title="{{ (\'modules.events.ServiceData.showReportTitle\' | translate) }}"><i class="fa fa-eye"></i> {{ (\'modules.events.ServiceData.AdministratorsOnly\' | translate) }}</div></h5><div><div class="form-group row clearfix mb-10"><div class="col-md-12"><div ng-if="!$ceService.metaRemarkAvailable && !$ceService.serviceData.ServiceRemarks.length"><i>{{ (\'modules.events.ServiceData.noRemarks\' | translate) }}</i></div></div><div class="col-md-6 mt-1" ng-if="$ceService.serviceData.ServiceRemarks.length"><div class="service-remark" ng-repeat="serviceRemark in $ceService.serviceData.ServiceRemarks | orderBy:[\'createdAt\'] track by $index"><h5 class="service-remark-heading" title="{{ (\'modules.events.ServiceData.serviceRemarksTitle1\' | translate) }} {{serviceRemark.Member.fullName}} {{ (\'modules.events.ServiceData.serviceRemarksTitle2\' | translate) }} {{serviceRemark.createdAt | date:\'dd.MM.yyyy HH:mm\'}} {{ (\'modules.events.ServiceData.serviceRemarksTitle3\' | translate) }} {{$ceService.flowStateMap[serviceRemark.FlowState].label}}">{{serviceRemark.Member.fullName}} <span>{{ (\'modules.events.ServiceData.oclock\' | translate: { time: (serviceRemark.createdAt | date:\'dd.MM.yyyy HH:mm\') }) }}</span></h5><div class="service-remark-body white-space-pre-line word-break">{{serviceRemark.Content}}</div></div></div><div class="col-md-6" ng-if="$ceService.metaRemarkAvailable"><label for="inputRemark" class="control-label">{{ (\'modules.events.ServiceData.remark\' | translate) }}<arno-ba-help-tooltip text="{{ (\'modules.events.ServiceData.metaRemarkAvailableText\' | translate) }}"></arno-ba-help-tooltip></label> <textarea class="form-control no-resize" style="height: 104px;" id="inputRemark" name="inputRemark" max-char="4000" ng-model="$ceService.serviceData.newRemark" invalid-message="\'modules.events.ServiceData.inputInvalid\' | translate" ng-disabled="$ceService.mediaSizeXS && !$ceService.shiftTemplateOpts.mobileEdit"></textarea></div></div></div></div></div>');
$templateCache.put('app/pages/events/service/partials/serviceShare.html','<div><h5 class="with-line" toggle-next=""><span>{{ (\'modules.events.serviceShare.share\' | translate) }}</span></h5><div class="row"><div class="col-lg-12 col-md-9 col-xs-6"><div class="form-group clearfix"><label class="control-label">{{ (\'modules.events.serviceShare.shareWithDivision\' | translate) }}<arno-ba-help-tooltip ng-if="$ceService.viewMode !== \'view\'" text="{{ (\'modules.events.serviceShare.shareWithDivisionText\' | translate) }}"></arno-ba-help-tooltip></label><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="serviceShare in $ceService.serviceData.ServiceShares | orderBy:[\'IsShared\',\'Division.Name\'] track by serviceShare.id"><td class="align-left-force force-minimal"><div class="arno-tag tag label label-tag label-info event-status-tag wide mr-0" ng-if="serviceShare.IsShared === null || serviceShare.IsShared === undefined">{{ (\'modules.events.serviceShare.inRequest\' | translate) }}</div><div class="arno-tag tag label label-tag label-danger event-status-tag wide mr-0" ng-if="serviceShare.IsShared === false">{{ (\'modules.events.serviceShare.rejected\' | translate) }}</div><div class="arno-tag tag label label-tag label-success event-status-tag wide mr-0" ng-if="serviceShare.IsShared">{{ (\'modules.events.serviceShare.shared\' | translate) }}</div></td><td class="align-left-force white-space-no-wrap force-minimal"><i class="ion-ios-people-outline"></i> {{::serviceShare.Division.Name}}</td><td class="align-left-force white-space-no-wrap force-minimal"><div class="arno-tag tag label label-tag label-info v-align-text-bottom" title="{{ (\'modules.events.serviceShare.shareAllLayers\' | translate) }}"><i ng-class="{\'slash-icon\': !serviceShare.IsGlobal}" class="fa fa-bullhorn"></i> {{ serviceShare.IsGlobal ? (\'modules.events.serviceShare.allLayers\' | translate):(\'modules.events.serviceShare.singleLayers\' | translate) }}</div><div class="arno-tag tag label label-tag v-align-text-bottom" ng-if="serviceShare.state === \'ADDED\'">{{ (\'modules.events.serviceShare.new\' | translate) }}</div><div class="arno-tag tag label label-tag label-warning v-align-text-bottom" ng-if="serviceShare.state === \'CHANGED\'">{{ (\'modules.events.serviceShare.changed\' | translate) }}</div><div class="arno-tag tag label label-tag label-warning v-align-text-bottom" ng-if="serviceShare.state === \'REMOVED\'">{{ (\'modules.events.serviceShare.toBeRemoved\' | translate) }}</div></td><td class="align-right-force pr-0"><div ng-if="(!$ceService.metaFieldFrozen || $ceService.metaFieldPartialShareThaw) && $ceService.canHandleServiceShare(serviceShare) && !$ceService.mediaSizeXS" class="inline-block"><button type="button" class="btn btn-success btn-with-icon btn-xs" ng-click="$ceService.handleServiceShare(\'ACCEPT\', serviceShare)" title="{{ (\'modules.events.serviceShare.agree\' | translate) }}"><i class="ion-plus"></i><span class="hidden-xs">{{ (\'modules.events.serviceShare.accept\' | translate) }}</span></button> <button type="button" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceService.handleServiceShare(\'DECLINE\', serviceShare)" title="{{ (\'modules.events.serviceShare.disagree\' | translate) }}"><i class="fa fa-times"></i><span class="hidden-xs">{{ (\'modules.events.serviceShare.reject\' | translate) }}</span></button></div><button type="button" ng-if="$ceService.viewMode !== \'view\' && !$ceService.metaFieldFrozen && !serviceShare.IsGlobal && serviceShare.IsShared && !$ceService.mediaSizeXS" class="btn btn-default btn-with-icon btn-xs no-animation" ng-click="$ceService.setServiceShareGlobal(serviceShare)" title="{{ (\'modules.events.serviceShare.shareAllLayers\' | translate) }}"><i class="fa fa-bullhorn" aria-hidden="true"></i><span>{{ (\'modules.events.serviceShare.allLayers\' | translate) }}</span></button> <button type="button" ng-if="$ceService.viewMode !== \'view\' && !$ceService.metaFieldFrozen && serviceShare.IsGlobal && serviceShare.IsShared && !$ceService.mediaSizeXS" class="btn btn-default btn-with-icon btn-xs no-animation" ng-click="$ceService.setServiceShareGlobal(serviceShare)" title="{{ (\'modules.events.serviceShare.sharesingleLayer\' | translate) }}"><i class="fa fa-bullhorn slash-icon"></i><span>{{ (\'modules.events.serviceShare.singleLayers\' | translate) }}</span></button> <button type="button" ng-if="( (!$ceService.viewMode || ($ceService.viewMode === \'edit\' && !$ceService.canHandleServiceShare(serviceShare))) || (serviceShare.IsShared && $ceService.managePermissionsIn(serviceShare.DivisionId)) ) && ( $ceService.hasManagePermsInSourceDiv || ($ceService.canPartiallyEdit && !$ceService.flow.steps[$ceService.flow.lastSavedStep].requirements.allPositionsTaken) ) && !$ceService.metaFieldFrozen && !$ceService.mediaSizeXS" class="btn btn-danger btn-with-icon btn-xs" ng-click="$ceService.removeServiceShare(serviceShare)" title="{{$ceService.removeServiceShareTitle(serviceShare)}}"><i class="ion-ios-trash"></i><span>{{$ceService.removeServiceShareTitle(serviceShare)}}</span></button></td></tr><tr ng-if="!$ceService.serviceData.ServiceShares.length"><td colspan="99"><i>{{ (\'modules.events.serviceShare.serviceNotShared\' | translate) }}</i></td></tr></tbody></table></div><div class="input-group input-group-with-select input-group-with-btn-text mt-5 fix-height" ng-if="$ceService.viewMode !== \'view\' && !$ceService.metaFieldFrozen && !$ceService.mediaSizeXS"><ui-select ng-model="$ceService.serviceShareTarget" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input in-input-group" search-enabled="true" append-to-body="true"><ui-select-match placeholder="{{ (\'modules.events.serviceShare.searchDivison\' | translate) }}">{{ $ceService.serviceShareTarget.Name }}</ui-select-match><ui-select-choices position="down" repeat="division in $ceService.serviceShareChoices" refresh="$ceService.serviceShareSearch($select.search)" refresh-delay="200" group-by="$ceService.serviceShareGroupFunc"><div ng-if="!division.none"><i class="ion-ios-people-outline"></i> <span>{{ division.Name }}</span></div><div ng-if="division.none" class="btn-with-icon"><span ng-if="division.foundNone"><i class="fa fa-times"></i><span><i>{{ (\'modules.events.serviceShare.noValidDivisionsFound\' | translate) }}</i></span></span> <span ng-if="!division.foundNone"><i>{{ (\'modules.events.serviceShare.enterDivison\' | translate) }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="$ceService.serviceShareAdd($ceService.serviceShareTarget)" ng-disabled="!$ceService.serviceShareTarget"><i class="fa fa-share-square-o"></i> {{ (\'modules.events.serviceShare.share\' | translate) }}</button></span></div></div></div><div class="col-sm"><button ng-if="$ceService.SubDivisionsExist && !$ceService.isArchived && $ceService.viewMode != \'view\'" class="btn btn-default btn-xs btn-with-icon pull-left" type="button" ng-click="$ceService.divisionShareAddAllSubs()"><i class="fa fa-share-square-o"></i><span class="ml-5" translate="modules.events.event.partials.shareAllSubDivs"></span></button></div></div></div>');
$templateCache.put('app/pages/material/addMaterial/addInspectionEvent/addInspectionEvent.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.material.addMaterial.inspection.assignInspectionEvent"></h4></div><form id="inspEvtModalForm" name="self.inspEvtModalForm" novalidate="" angular-validator="" angular-validator-submit="self.applyModal()"><div class="modal-body"><div class="row"><div class="form-group col-sm-12"><label class="control-label" translate="generalTerms.inspection"></label> <span uib-tooltip="{{ self.preSetInspections ? (\'modules.material.addMaterial.inspection.multiSelectInspectionPreSetInfo\' | translate) : (\'modules.material.addMaterial.inspection.multiSelectInspectionInfo\' | translate) }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-info-circle text-info ml-5"></i></span><inspection-selector ctx="self.divisionId" selected-inspection="self.inspections" excluded-ids="self.excludedIds" ng-disabled="self.viewMode || self.preSetInspections" multiple="true" pick-from-selected-material-id="self.materialId" material-model="self.materialModel"></inspection-selector></div><div class="col-sm-6 form-group"><label for="inspDate" class="control-label required-label" translate="generalTerms.date"></label><div><div class="input-group"><input id="inspDate" name="inspDate" class="form-control" type="text" required="" required-message="\'\'" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" is-open="self.dateOpen" close-text="{{ \'generalTerms.close\' | translate }}" show-button-bar="false" ng-model="self.inspectionEventMeta.Date" ng-model-options="{ debounce: 200 }" ng-disabled="self.viewMode"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.dateOpen = !self.dateOpen" ng-disabled="self.viewMode"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-sm-6 form-group"><label class="control-label" translate="generalTerms.validUntil"></label><div class="input-group"><input id="expDate" name="expDate" class="form-control" type="text" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.expoptions" is-open="self.vuOpen" close-text="{{ \'generalTerms.close\' | translate }}" show-button-bar="false" ng-model="self.inspectionEventMeta.ValidUntil" ng-model-options="{ debounce: 200 }" ng-disabled="self.viewMode"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.vuOpen = !self.vuOpen" ng-disabled="self.viewMode"><i class="glyphicon glyphicon-calendar"></i></button></span></div><input type="hidden" class="form-control" ng-if="!self.viewMode" name="expDateValidation" ng-model="self.expDateValidation" validator="self.isValidDate()" invalid-message="\'modules.material.addMaterial.inspection.invalidExpireDate\' | translate"></div><div class="form-group col-sm-12"><label for="stateInput" class="control-label required-label" translate="generalTerms.state"></label><div><ui-select id="stateInput" name="stateInput" ng-model="self.inspectionEventMeta.Result" search-enabled="false" append-to-body="false" required="" required-message="\'\'" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" ng-disabled="self.viewMode"><ui-select-match><span>{{ self.states[self.inspectionEventMeta.Result.value] }}</span></ui-select-match><ui-select-choices repeat="item in self.selectorProps" position="down" group-by="self.resultGroupFn"><span>{{ item.label }}</span></ui-select-choices></ui-select></div></div><div class="form-group col-sm-3"><label class="control-label" translate="modules.material.addMaterial.inspection.hasTasks"></label><div><ba-switcher switcher-style="primary" switcher-keys="self.switcherKeys" switcher-value="self.inspectionEventMeta.HasTasks" switcher-disabled="self.viewMode"></ba-switcher></div></div><div class="form-group col-sm-9"><label class="control-label" translate="modules.material.addMaterial.inspection.taskDescription"></label> <textarea type="text" class="form-control" placeholder="{{ \'modules.material.addMaterial.inspection.taskDescription\' | translate }}" ng-disabled="self.viewMode || !self.inspectionEventMeta.HasTasks" ng-model="self.inspectionEventMeta.Description">\n          </textarea></div><div class="form-group col-sm-12"><label class="control-label" translate="generalTerms.annotation"></label> <textarea type="text" class="form-control" placeholder="{{ \'generalTerms.annotation\' | translate }}" ng-model="self.inspectionEventMeta.Annotation" ng-disabled="self.viewMode">\n          </textarea></div><div class="form-group col-sm-12"><label for="instructingPersonTypeSelection" class="control-label" translate="modules.material.addMaterial.inspection.selectInstructors"></label><div class="d-flex"><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio1" ng-model="self.selectedPersonFieldType" ng-disabled="self.viewMode" value="member"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionMember"></span></label></div><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio2" ng-model="self.selectedPersonFieldType" ng-disabled="self.viewMode" value="contact"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionContact"></span></label></div><div><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio3" ng-model="self.selectedPersonFieldType" ng-disabled="self.viewMode" value="organisation"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionOrganisation"></span></label></div></div></div><div class="form-group col-sm-12"><div ng-if="self.selectedPersonFieldType === \'organisation\'" class="mt-20 col-md-12 p-0"><business-partners-selector division="self.divisionId" append-to-body="false" selection-proposals="self.businessPartnerList" on-business-partner-select="self.setOrg" selected-business-partner="self.inspectionEventMeta.TestingOrg" details-extra-label="\'modules.material.addMaterial.inspection.testingOrg\'" extra-label-cls="\'control-label required-label\'" enable-details="true" ng-disabled="self.viewMode"></business-partners-selector></div><div ng-if="self.selectedPersonFieldType === \'contact\'" class="mt-20 col-md-12 p-0"><label translate="modules.material.addMaterial.inspection.testingContact"></label><contact-selector on-select="self.setContact" selected-contact="self.inspectionEventMeta.TestingContact" blank-search-on-click="true" only-active="true" divisions="self.divisionId" ng-disabled="self.viewMode"></contact-selector></div><div ng-if="self.selectedPersonFieldType === \'member\'"><div class="mt-20 col-md-12 p-0"><label class="control-label required-label" translate="modules.material.addMaterial.inspection.testingPerson" translate-values="{v:1}"></label><member-selector on-member-select="self.setTestingMemberOne" selected-member="self.inspectionEventMeta.TestingMemberOne" member-exclude="self.responsibleExcludeList" blank-search-on-click="true" keep-after-selection="true" only-active="true" divisions="self.divisionId" initial-member-value="self.inspectionEventMeta.TestingMemberOneInitial" ng-disabled="self.viewMode"></member-selector></div><div class="mt-20 col-md-12 p-0"><label translate="modules.material.addMaterial.inspection.testingPerson" translate-values="{v:2}"></label><member-selector on-member-select="self.setTestingMemberTwo" selected-member="self.inspectionEventMeta.TestingMemberTwo" member-exclude="self.responsibleExcludeList" blank-search-on-click="true" keep-after-selection="true" only-active="true" divisions="self.divisionId" initial-member-value="self.inspectionEventMeta.TestingMemberTwoInitial" ng-disabled="self.viewMode" enable-delete="true"></member-selector></div></div></div><div class="form-group col-sm-6"><label translate="modules.material.addMaterial.inspection.costs"></label> <input name="InsEvtCostsInput" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="self.inspectionEventMeta.Cost" class="form-control" ng-disabled="self.viewMode"></div><div class="form-group col-sm-6"><label translate="modules.material.addMaterial.inspection.mileageOperatingHours"></label> <input type="number" class="form-control" min="0" ng-model="self.inspectionEventMeta.Mileage" ng-disabled="self.viewMode"></div><div class="form-group col-sm-12"><file-upload ng-if="!self.viewMode" unallowed-file-types="self.unallowedFileTypes" upload-url="self.fileUploadUrl" on-file-uploaded="self.onFileUploaded" on-file-delete="self.onFileDelete" file-name="self.inspectionEventMeta.FileName" is-uploading="self.isUploading" downloadable-file="self.inspectionEventMeta.FileName" show-remove-button="true"></file-upload><div ng-if="self.viewMode && self.inspectionEventMeta.FileName"><div><label translate="components.fileUpload.attachedFile"></label></div><button type="button" ng-click="self.viewOrDownloadFile()" class="btn btn-default" title="{{(\'generalTerms.file\' | translate )}}"><span ng-if="self.fileHasPreview(self.inspectionEventMeta.FileName)"><i class="fa fa-file-pdf-o pr-5"></i><span>{{ \'generalTerms.view\' | translate }} - {{ self.inspectionEventMeta.FileName }}</span></span> <span ng-if="!self.fileHasPreview(self.inspectionEventMeta.FileName)"><i class="fa fa-download pr-5"></i><span>{{ \'generalTerms.download\' | translate }} - {{ self.inspectionEventMeta.FileName }}</span></span></button></div></div></div></div><div class="modal-footer"><button type="button" ng-if="!self.viewMode" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" ng-if="!self.viewMode" ng-disabled="!self.inspections.length || self.inspEvtModalForm.$invalid || self.isUploading" class="btn btn-primary" translate="generalTerms.add"></button> <button type="button" ng-if="self.viewMode" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.close"></button></div></form></div>');
$templateCache.put('app/pages/material/addMaterial/partials/baseData.html','<form id="materialAddForm" name="$matAddCtrl.materialAddForm"><div class="modal-body row arno-material-inputlist"><div ng-if="$matAddCtrl.isAggregatedView" class="col-sm-4"><span title="{{ \'modules.material.materialUtils.aggregatedMaterial\' | translate : {amount: $matAddCtrl.aggregatedAmount} }}"><b>{{ \'modules.material.materialUtils.aggregatedMaterial\' | translate : {amount: $matAddCtrl.aggregatedAmount} }}</b></span> <input name="aggregatedMaterial" type="string" ng-model="$matAddCtrl.aggregatedAmount" class="form-control mt-4" ng-disabled="true"></div><div class="form-field-group" ng-repeat="group in $matAddCtrl.fieldGroups"><div class="col-xs-12 mt-20 form-section-header" ng-if="group.title"><h5>{{group.title}}</h5></div><div class="{{ ::($matAddCtrl.fieldConfig[field.prop].customClass || \'col-sm-4\') }}" ng-repeat="field in group.fields" ng-if="!$matAddCtrl.fieldConfig[field.prop] || ($matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type !== \'special\' && $matAddCtrl.fieldConfig[field.prop].type !== \'tagpicker\')"><label class="control-label arno-material-label" ng-if="$matAddCtrl.fieldConfig[field.prop].type !== \'businessPartner\'" ng-class="{ \'required-label\': $matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].required }">{{field.label}}</label><arno-ba-help-tooltip ng-if="$matAddCtrl.fieldConfig[field.prop].tooltip" text="{{$matAddCtrl.fieldConfig[field.prop].tooltip}}"></arno-ba-help-tooltip><i class="fa fa-magic text-warning" title="{{\'generalTerms.autoCalc\' | translate}}" ng-if="$matAddCtrl.materialAddForm[field.prop + \'Input\'].autoCalc"></i> <a href="{{ $matAddCtrl.addModel[field.prop] }}" target="_blank" title="{{ \'modules.material.materialUtils.MATERIAL_EXT_LINK_LEAVE\' | translate }}" ng-if="$matAddCtrl.fieldConfig[field.prop].type === \'link\'" ng-disabled="!$matAddCtrl.addModel[field.prop].startsWith(\'http://\') && !$matAddCtrl.addModel[field.prop].startsWith(\'https://\')" class="btn btn-xs btn-default pull-right"><i class="fa fa-external-link"></i></a><div ng-if="!$matAddCtrl.fieldConfig[field.prop] || ($matAddCtrl.fieldConfig[field.prop] && ($matAddCtrl.fieldConfig[field.prop].type === \'string\' || $matAddCtrl.fieldConfig[field.prop].type === \'link\'))"><input name="{{field.prop}}Input" type="text" ng-change="$matAddCtrl.removePlaceholder(field.prop)" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" ng-model="$matAddCtrl.addModel[field.prop]" class="form-control" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled"></div><div ng-if="($matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'text\')"><textarea class="form-control --vresize" name="{{field.prop}}Input" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" ng-model="$matAddCtrl.addModel[field.prop]" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\' }}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" ng-change="$matAddCtrl.removePlaceholder(field.prop)"></textarea></div><div ng-if="($matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop] == $matAddCtrl.fieldConfig[\'VehicleType\'])"><div class="col w-100"><ui-select ng-model="$matAddCtrl.addModel[\'VehicleType\']" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="false" search-enabled="false"><ui-select-match placeholder="{{(\'models.MaterialVehicles.NoMotorVehicle\' | translate)}}">{{ $matAddCtrl.addModel[\'VehicleType\'].Name }}</ui-select-match><ui-select-choices position="down" repeat="option in $matAddCtrl.VehicleTypes">{{option.Name}}</ui-select-choices></ui-select></div></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'decimal\'"><input name="{{field.prop}}Input" type="number" min="0" decimal="true" ng-change="$matAddCtrl.removePlaceholder(field.prop)" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" ng-model="$matAddCtrl.addModel[field.prop]" class="form-control" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled"></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'int\'" class="fixed-height"><input name="{{field.prop}}Input" type="number" ng-change="$matAddCtrl.removePlaceholder(field.prop)" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" min="{{ ::(field.prop === \'Amount\' ? 1 : 0) }}" step="1" ng-if="!$matAddCtrl.fieldConfig[field.prop].usePicker" ng-model="$matAddCtrl.addModel[field.prop]" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" class="form-control"><div class="input-group" ng-if="$matAddCtrl.fieldConfig[field.prop].usePicker"><input name="{{field.prop}}Input" type="text" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] }}" class="form-control" ng-change="$matAddCtrl.removePlaceholder(field.prop)" is-open="$matAddCtrl.datePickerStates[field.prop]" uib-datepicker-popup="{{ ($matAddCtrl.fieldConfig[field.prop].pickerDateFormat || $matAddCtrl.datepicker.format) }}" datepicker-options="$matAddCtrl.fieldConfig[field.prop].pickerOptions || $matAddCtrl.datepicker.options" ng-model="$matAddCtrl.addModel[field.prop]" close-text="Schlie\xDFen" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" show-button-bar="false" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$matAddCtrl.datePickerStates[field.prop] = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'bool\' && $matAddCtrl.fieldConfig[field.prop] != $matAddCtrl.fieldConfig[\'TrailerHitch\']"><ba-switcher switcher-style="primary" !="" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" switcher-value="$matAddCtrl.addModel[field.prop]" switcher-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" switcher-keys="$matAddCtrl.switcherKeys" switcher-force-default="true"></ba-switcher></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'bool\' && $matAddCtrl.fieldConfig[field.prop] === $matAddCtrl.fieldConfig[\'TrailerHitch\']"><row style="width: 100%; display: inline-flex;"><div class="col"><ba-switcher switcher-style="primary" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" switcher-value="$matAddCtrl.addModel[field.prop]" switcher-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" switcher-keys="$matAddCtrl.switcherKeys" switcher-force-default="true"></ba-switcher></div><div class="col w-100" ng-if="$matAddCtrl.addModel[\'TrailerHitch\']"><ui-select ng-model="$matAddCtrl.addModel[\'HitchType\']" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="false" search-enabled="false"><ui-select-match placeholder="Anh\xE4ngertyp w\xE4hlen">{{ $matAddCtrl.addModel[\'HitchType\'].Name }}</ui-select-match><ui-select-choices position="down" repeat="option in $matAddCtrl.HitchTypes">{{option.Name}}</ui-select-choices></ui-select></div></row></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'dropdownMaterialType\'"><ui-select name="{{field.prop}}Input" ng-model="$matAddCtrl.addModel[field.prop]" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" ng-change="$matAddCtrl.removePlaceholder(field.prop)" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}"><span ng-bind="$select.selected.Name"></span></ui-select-match><ui-select-choices position="down" group-by="$matAddCtrl.materialTypeGroupByParent" repeat="option.id as option in $matAddCtrl.materialTypes"><span ng-bind="option.Name" title="{{option.Name}}"></span></ui-select-choices></ui-select></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'dropdown\'"><ui-select name="{{field.prop}}Input" ng-model="$matAddCtrl.addModel[field.prop]" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" ng-change="$matAddCtrl.removePlaceholder(field.prop)" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match><span ng-bind="$matAddCtrl.addModel[field.prop]"></span></ui-select-match><ui-select-choices position="down" repeat="option in $matAddCtrl.fieldConfig[field.prop].opts"><span ng-bind="::option" title="{{::option}}"></span></ui-select-choices></ui-select></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'date\'" class="fixed-height"><div class="input-group"><input name="{{field.prop}}Input" type="text" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' | date:$matAddCtrl.datepicker.format}}" class="form-control" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" ng-change="$matAddCtrl.removePlaceholder(field.prop)" is-open="$matAddCtrl.datePickerStates[field.prop]" uib-datepicker-popup="{{$matAddCtrl.datepicker.format}}" datepicker-options="$matAddCtrl.fieldConfig[field.prop].pickerOptions || $matAddCtrl.datepicker.options" invalid-message="\'Das eingegebene Datum ist ung\xFCltig!\'" ng-model="$matAddCtrl.addModel[field.prop]" close-text="Schlie\xDFen" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$matAddCtrl.datePickerStates[field.prop] = true" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="arno-typeahead" ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'autocompletion\'"><input type="text" title="{{ $matAddCtrl.tooltipStates[field.prop] && $matAddCtrl.fieldConfig[field.prop].hookTooltip ? $matAddCtrl.fieldConfig[field.prop].hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" ng-change="$matAddCtrl.removePlaceholder(field.prop)" placeholder="{{ $matAddCtrl.editPlaceholders[field.prop] || \'\' }}" ng-model="$matAddCtrl.addModel[field.prop]" uib-typeahead="storage for storage in $matAddCtrl.fieldConfig[field.prop].source | filter:$viewValue | limitTo:5" class="form-control"></div><div ng-if="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].type === \'businessPartner\'" class="fixed-height-bp"><business-partners-selector division="[$matAddCtrl.divisionId]" ng-disabled="$matAddCtrl.execHooks(field.prop) || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig[field.prop].disabled" is-material-provider="true" append-to-body="false" on-business-partner-select="$matAddCtrl.setBusinessPartner" additional-on-select-params="[field.prop]" selected-business-partner="$matAddCtrl.addModel[field.prop]" enable-delete="true" enable-details="true" details-extra-label="field.label" required-label="$matAddCtrl.fieldConfig[field.prop] && $matAddCtrl.fieldConfig[field.prop].required" extra-label-cls="\'control-label arno-material-label\'" custom-placeholder="$matAddCtrl.getPH(($matAddCtrl.isAdd && $matAddCtrl.fieldConfig[field.prop].onModeAddPlaceholder) || $matAddCtrl.editPlaceholders[field.prop])"></business-partners-selector></div></div><div class="col-sm-12" ng-if="$matAddCtrl.fieldConfig.LicenseClass && $matAddCtrl.fieldConfig.LicenseClass.type === \'tagpicker\' && group.title === \'Grunddaten\'"><label>F\xFChrerscheinklasse</label><div class="input-group input-group-with-select"><ui-select multiple="" id="licenseInput" name="licenseInput" ng-model="$matAddCtrl.addModel.LicenseClass" search-enabled="true" append-to-body="false" ng-disabled="$matAddCtrl.viewOnly" class="form-control arno-roleselect"><ui-select-match placeholder="F\xFChrerscheinklasse w\xE4hlen...">{{ $item.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $matAddCtrl.licenseClasses | filter: $select.search">{{ item.Name }}</ui-select-choices></ui-select><span class="input-group-btn arno-btn-roleselect"><button type="button" ng-disabled="!$matAddCtrl.addModel.LicenseClass.length" ng-click="$matAddCtrl.addModel.LicenseClass = undefined" class="btn btn-danger ion-ios-trash"></button></span></div></div></div></div></form>');
$templateCache.put('app/pages/material/addMaterial/partials/bookingCalendar.html','<div><booking-material-calendar version="$matAddCtrl.bookingMaterialCalendarVersion" model="$matAddCtrl.model" material-id="$matAddCtrl.materialId" division-id="$matAddCtrl.divisionId" material-amount="$matAddCtrl.addModel.Amount" material-name="$matAddCtrl.materialName"></booking-material-calendar></div>');
$templateCache.put('app/pages/material/addMaterial/partials/fileStorage.html','<div class="clearfix mb-40"><div class="row"><file-storage item-id="$matAddCtrl.addModel.id" storage-ident="$matAddCtrl.storageIdent" ctx="$matAddCtrl.divisionId" folder-data="$matAddCtrl.folderData" edit-permission="\'arno.virtual.item.materialMedicalProducts.edit,arno.material.edit,arno.virtual.item.materialMedicine.edit,arno.virtual.item.materialClothing.edit,arno.virtual.item.materialOthers.edit,arno.virtual.item.materialConsumables.edit,arno.virtual.item.materialTools.edit,arno.virtual.item.materialVehicles.edit\'" show-edit-perm-icon="true"></file-storage></div></div>');
$templateCache.put('app/pages/material/addMaterial/partials/finance.html','<div class="clearfix mb-40" ng-if="!$matAddCtrl.isNew"><arno-prices-input price-item="$matAddCtrl.priceInfo" disabled="true" class="col-xs-12"></arno-prices-input></div><div class="row mb-5"><div class="col-sm-12"><label class="control-label arno-material-label">{{ (\'models.\' + $matAddCtrl.model + \'.CostCenterSpecification\') | translate }}</label><cost-center-spec-selector selected-cost-center-spec="$matAddCtrl.addModel.CostCenterSpecification" on-cost-center-spec-select="$matAddCtrl.setCostCenterSpec" append-to-body="false" enable-delete="true" ng-disabled="$matAddCtrl.execHooks(\'CostCenterSpecification\') || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig.CostCenterSpecification.disabled"></cost-center-spec-selector></div><div class="col-sm-6"><label class="control-label arno-material-label">{{ (\'models.\' + $matAddCtrl.model + \'.InternalOrder\') | translate }}</label> <input name="InternalOrderInput" type="text" ng-change="$matAddCtrl.removePlaceholder(\'InternalOrder\')" placeholder="{{ $matAddCtrl.editPlaceholders.InternalOrder || \'\' }}" ng-model="$matAddCtrl.addModel.InternalOrder" class="form-control" title="{{ $matAddCtrl.tooltipStates.InternalOrder && $matAddCtrl.fieldConfig.InternalOrder.hookTooltip ? $matAddCtrl.fieldConfig.InternalOrder.hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(\'InternalOrder\') || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig.InternalOrder.disabled"></div><div class="col-sm-6"><label class="control-label arno-material-label">{{ (\'models.\' + $matAddCtrl.model + \'.AcquisitionPrice\') | translate }}</label> <input name="AcquisitionPriceInput" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-change="$matAddCtrl.removePlaceholder(\'AcquisitionPrice\')" placeholder="{{ $matAddCtrl.editPlaceholders.AcquisitionPrice || \'\' }}" ng-model="$matAddCtrl.addModel.AcquisitionPrice" class="form-control" title="{{ $matAddCtrl.tooltipStates.AcquisitionPrice && $matAddCtrl.fieldConfig.AcquisitionPrice.hookTooltip ? $matAddCtrl.fieldConfig.AcquisitionPrice.hookTooltip : \'\'}}" ng-disabled="$matAddCtrl.execHooks(\'AcquisitionPrice\') || $matAddCtrl.viewOnly || $matAddCtrl.fieldConfig.AcquisitionPrice.disabled"></div></div>');
$templateCache.put('app/pages/material/addMaterial/partials/handed-over-to-member.html','<member-selector on-member-select="$matAddCtrl.setHandedOverTo" blank-search-on-click="true" only-active="true" ng-if="!$matAddCtrl.viewOnly" divisions="$matAddCtrl.divisionId" ng-disabled="$matAddCtrl.HandedOverToMember.length > 0 || $matAddCtrl.divisionId.length > 1"></member-selector><div class="alert bg-info ng-scope">{{ (\'modules.material.addMaterial.handedOverToInfo\' | translate) }}</div><div class="table-responsive" ng-class="{\'mt-40\': !$matAddCtrl.viewOnly}"><table st-safe-src="$matAddCtrl.HandedOverToMember" class="table table-condensed table-hover"><thead><tr><th>{{ (\' generalTerms.firstName\' | translate) }}</th><th>{{ (\' generalTerms.lastName\' | translate) }}</th><th>{{ (\' generalTerms.email\' | translate) }}</th><th>{{ (\' generalTerms.action\' | translate) }}</th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in $matAddCtrl.HandedOverToMember"><td>{{ member.FirstName || \'\' }}</td><td>{{ member.LastName || \'\' }}</td><td>{{ member.Account.EMail || \'\' }}</td><td class="arno-table-button-cell"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$matAddCtrl.removeHandedOverTo(member.HandedOverToId)" ng-disabled="$matAddCtrl.divisionId.length > 1"><i class="ion-ios-trash"></i><span class="btn-span">Entfernen</span></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/material/addMaterial/partials/inspections.html','<div class="clearfix mb-20"><div class="col-xs-12 mt-20 form-section-header"><h5>{{ \'modules.material.addMaterial.inspection.assignedInspectionHeader\' | translate }}</h5></div><div class="col-xs-12 mt-10 mb-20"><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $matAddCtrl.itemsPerPageAssignedInspections }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$matAddCtrl.setPageSize(i, \'addmat_assigned_inspections\', \'itemsPerPageAssignedInspections\')">{{ i }}</a></li></ul></div><div class="material-inspection-switcher ml-10 btn-toolbar"><div><ba-switcher switcher-style="primary" switcher-value="$matAddCtrl.showOptionalInspections" switcher-width="120" switcher-keys="$matAddCtrl.inspSwitcherKeys"></ba-switcher></div></div><button type="button" ng-if="!$matAddCtrl.viewOnly" class="btn btn-with-icon btn-primary pull-right" ng-click="$matAddCtrl.addInspection()"><i class="ion-plus"></i> <span translate="modules.material.addMaterial.inspection.assignInspection"></span></button></div><div class="table-responsive col-xs-12"><table st-table="$matAddCtrl.materialInspectionColl" st-pipe="$matAddCtrl.getAssignedInspections" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Name">{{ \'generalTerms.name\' | translate }}</th><th st-sort="Inspection.Interval">{{ \'modules.material.addMaterial.inspection.interval\' | translate }}</th><th st-sort="Inspection.NextDueDate" st-sort-default="true">{{ \'modules.material.addMaterial.inspection.dueDate\' | translate }}</th><th st-sort="Inspection.Mandatory" ng-if="$matAddCtrl.showOptionalInspections">{{ \'generalTerms.mandatory\' | translate }}</th><th>{{ \'generalTerms.actions\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Inspection.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th ng-if="$matAddCtrl.showOptionalInspections"></th><th></th></tr></thead><tbody><tr ng-repeat="row in $matAddCtrl.materialInspectionColl"><td><span>{{ row.Inspection.Name }}</span> <span ng-if="row.FromMaterialType !== \'NO\' && $matAddCtrl.currentMaterialType.Name" class="arno-tag tag label label-tag label-warning ml-5" title="{{ (row.FromMaterialType === \'ALTERED\' ? \'modules.material.addMaterial.inspection.inheritedFromTypeEdited\' : \'modules.material.addMaterial.inspection.inheritedFromType\') | translate}}"><i class="fa fa-pencil mr-5" ng-if="row.FromMaterialType === \'ALTERED\'"></i> {{ $matAddCtrl.currentMaterialType.Name }}</span></td><td><span>{{ row.Interval }}</span></td><td><span>{{ row.NextDueDate | date:\'dd.MM.yyyy\' }}</span></td><td ng-if="$matAddCtrl.showOptionalInspections"><span>{{ (row.Mandatory ? \'generalTerms.yes\' : \'generalTerms.no\') | translate }}</span></td><td><button ng-if="!$matAddCtrl.viewOnly" class="btn btn-default btn-with-icon btn-xs" ng-click="$matAddCtrl.addInspection(row)" title="{{ \'generalTerms.edit\' | translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button ng-if="$matAddCtrl.viewOnly" class="btn btn-default btn-with-icon btn-xs" ng-click="$matAddCtrl.addInspection(row)" title="{{ \'generalTerms.view\' | translate }}"><i class="fa fa-eye"></i><span translate="generalTerms.view"></span></button> <button ng-if="!$matAddCtrl.viewOnly && row.FromMaterialType === \'NO\'" class="btn btn-default btn-with-icon btn-xs btn-danger" ng-click="$matAddCtrl.removeInspection(row)" title="{{ \'generalTerms.delete\' | translate }}"><i class="fa fa-trash"></i><span translate="generalTerms.delete"></span></button> <button ng-if="!$matAddCtrl.viewOnly && row.FromMaterialType === \'ALTERED\'" class="btn btn-default btn-with-icon btn-xs" ng-click="$matAddCtrl.removeInspection(row, true)" title="{{ \'generalTerms.reset\' | translate }}"><i class="fa fa-undo"></i><span translate="generalTerms.reset"></span></button></td></tr><tr ng-if="$matAddCtrl.materialInspectionColl && $matAddCtrl.materialInspectionColl.length === 0"><td class="text-center" colspan="99"><i translate="modules.material.addMaterial.inspection.noneAssigned"></i></td></tr></tbody><tfoot><tr ng-if="$matAddCtrl.materialInspectionColl && $matAddCtrl.materialInspectionColl.length"><td colspan="99" class="text-center"><st-pagination st-items-by-page="$matAddCtrl.itemsPerPageAssignedInspections" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div><div class="clearfix mb-40"><div class="col-xs-12 mt-20 form-section-header"><h5>{{ \'modules.material.addMaterial.inspection.inspectionEventsHeader\' | translate }}</h5></div><div class="col-xs-12 mt-10 mb-20"><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="generalTerms.entriesPerPage"></span> ({{ $matAddCtrl.itemsPerPageAssignedInspectionEvents }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$matAddCtrl.setPageSize(i, \'addmat_assigned_inspection_events\', \'itemsPerPageAssignedInspectionEvents\')">{{ i }}</a></li></ul></div><button type="button" ng-if="!$matAddCtrl.viewOnly" class="btn btn-with-icon btn-primary pull-right" ng-click="$matAddCtrl.addInspectionEvent()"><i class="ion-plus"></i> <span translate="modules.material.addMaterial.inspection.assignInspectionEvent"></span></button></div><div class="table-responsive col-xs-12"><table st-table="$matAddCtrl.materialInspectionEventsColl" st-pipe="$matAddCtrl.getInspectionEvents" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Inspection.Name">{{ \'generalTerms.name\' | translate }}</th><th st-sort="Date" st-sort-default="reverse">{{ \'generalTerms.date\' | translate }}</th><th st-sort="ValidUntil">{{ \'modules.material.addMaterial.inspection.validUntil\' | translate }}</th><th st-sort="Result">{{ \'modules.material.addMaterial.inspection.eventResult\' | translate }}</th><th st-sort="HasTasks">{{ \'modules.material.addMaterial.inspection.hasTasks\' | translate }}</th><th st-sort="Mandatory" ng-if="$matAddCtrl.showOptionalInspectionEvents">{{ \'generalTerms.mandatory\' | translate }}</th><th>{{ \'modules.material.addMaterial.inspection.taskDescription\' | translate }}</th><th>{{ \'generalTerms.actions\' | translate }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Inspection.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="row in $matAddCtrl.materialInspectionEventsColl"><td><span>{{ row.Inspection.Name }}</span></td><td><span>{{ row.Date | date:\'dd.MM.yyyy\' }}</span></td><td><span>{{ row.ValidUntil | date:\'dd.MM.yyyy\' }}</span></td><td><span>{{ $matAddCtrl.inspectionEventResults[row.Result] }}</span></td><td><span>{{ (row.HasTasks ? \'generalTerms.yes\' : \'generalTerms.no\') | translate }}</span></td><td class="arno-material-instruction-event-taskcol"><span>{{ row.Description }}</span></td><td><button class="btn btn-default btn-with-icon btn-xs" ng-click="$matAddCtrl.addInspectionEvent(row)" title="{{ \'generalTerms.view\' | translate }}"><i class="fa fa-eye"></i> <span>{{ \'generalTerms.view\' | translate}}</span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="$matAddCtrl.showDescent(row) && !$matAddCtrl.viewOnly" ng-click="$matAddCtrl.addInspectionEvent(row, true)" title="{{ \'generalTerms.view\' | translate }}"><i class="fa fa-check-square-o"></i> <span>{{ \'modules.material.addMaterial.inspection.completeTask\' | translate}}</span></button> <button class="btn btn-default btn-with-icon btn-xs" ng-if="$matAddCtrl.showDescent(row, true) && !$matAddCtrl.viewOnly" ng-click="$matAddCtrl.addInspectionEvent(row, true)" title="{{ \'generalTerms.view\' | translate }}"><i class="fa fa-repeat"></i> <span>{{ \'modules.material.addMaterial.inspection.repeat\' | translate}}</span></button></td></tr><tr ng-if="$matAddCtrl.materialInspectionEventsColl && $matAddCtrl.materialInspectionEventsColl.length === 0"><td class="text-center" colspan="99"><i translate="modules.material.addMaterial.inspection.noEventsAssigned"></i></td></tr></tbody><tfoot><tr ng-if="$matAddCtrl.materialInspectionEventsColl && $matAddCtrl.materialInspectionEventsColl.length"><td colspan="99" class="text-center"><st-pagination st-items-by-page="$matAddCtrl.itemsPerPageAssignedInspectionEvents" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/material/addMaterial/partials/instructions.html','<div><button type="button" class="btn btn-primary btn-with-icon mb-10" ng-if="!$matAddCtrl.viewOnly" ng-click="$matAddCtrl.openDocumentQualificationModal(\'add\')"><i class="ion-plus"></i> {{ (\'modules.material.addMaterial.documentInstructions\' | translate) }}</button><button ng-if="!$matAddCtrl.viewOnly" class="btn btn-default btn-with-icon pull-right mr-10" ng-click="$matAddCtrl.openQualificationModal(\'add\')"><i class="fa fa-cog"></i> <span class="hidden-xs">{{ (\'modules.material.addMaterial.configureInstructions\' | translate) }}</span> <span ng-if="$matAddCtrl.instructionConfigurationPendingActions > 0" uib-tooltip="{{ \'modules.material.addMaterial.unsavedChanges\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-exclamation-triangle"></i></span></button><div class="row"><div class="col-md-12">{{ $matAddCtrl.documentationsTableShowMultiplicator }}<uib-accordion><uib-accordion-group ng-repeat="entry in $matAddCtrl.materialQualificationDocumentationsGrouped" panel-class="panel-default bootstrap-panel accordion-panel" is-open="entry.open"><uib-accordion-heading>{{ entry.Qualification.Name }} ({{ entry.personCount }}) <i class="pull-right" ng-class="{\'ion-chevron-down\': costCenter.tabOpen, \'ion-chevron-right\': !costCenter.tabOpen}"></i></uib-accordion-heading><div class="table-responsive mb-20"><table ng-if="$index > 0" st-table="entry.content" st-input-event="change" class="table table-condensed table-hover"><col><col><col><col width="300px"><thead><tr class="sortable"><th st-sort="Member.fullName" class="align-bottom">{{ (\'modules.material.addMaterial.instructedPersonName\' | translate) }}</th><th st-sort="AcquireDate" class="align-bottom">{{ (\'generalTerms.date\' | translate) }}</th><th st-sort="ExpireDate" class="align-bottom">{{ (\'generalTerms.validUntil\' | translate) }}</th><th class="align-bottom">{{ (\'generalTerms.actions\' | translate) }}</th></tr></thead><tbody><tr ng-repeat="documentation in entry.content"><td><span ng-if="documentation.InitialInstructionByManufacturerOrAuthorizedPerson" uib-tooltip="{{ \'modules.material.addMaterial.instructorMultiplicator\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-graduation-cap"></i></span> {{ documentation.Member.Member.fullName || documentation.Member.fullName}}</td><td class="align-left-force">{{ documentation.AcquireDate | date : \'dd.MM.yyyy\' }}</td><td><span>{{ documentation.ExpireDate | date: \'dd.MM.yyyy\'}}</span></td><td><button class="btn btn-xs btn-default" ng-if="documentation.pendingAction !== \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $matAddCtrl.mediaSizeXs, \'btn-with-icon\': !$matAddCtrl.mediaSizeXs}" ng-click="$matAddCtrl.openDocumentQualificationModal(\'view\', documentation)"><i class="ion-eye"></i> <span class="btn-span hidden-xs" translate="modules.material.addMaterial.title3"></span></button> <a ng-if="$matAddCtrl.isPermittedForDossier() && documentation.pendingAction !== \'add\'" class="btn btn-xs btn-default" ng-href="{{ $matAddCtrl.getDossierUrl(documentation.Member) }}" target="_blank"><i class="fa fa-user"></i> <span>{{(\'modules.material.addMaterial.linkInstructedPerson\' | translate) }}</span></a> <button type="button" class="btn btn-xs btn-danger" ng-if="documentation.pendingAction === \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $matAddCtrl.mediaSizeXs, \'btn-with-icon\': !$matAddCtrl.mediaSizeXs}" ng-click="$matAddCtrl.onDocumentationPendingDelete($index)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.overview.qualificationList.dontAdd"></span></button></td></tr><tr ng-if="!entry.content.length"><td colspan="4" class="text-center"><i translate="modules.material.addMaterial.noEntriesPlaceholder"></i></td></tr></tbody></table><div ng-if="$index === 0"><div ng-repeat="member in entry.content"><div class="mt-10 mb-10 bold-text"><span class="arno-pointing-pointer" ng-click="$matAddCtrl.setInstructionMemberTabState(member.member.id)"><span ng-if="member.withIcon" uib-tooltip="{{ \'modules.material.addMaterial.instructorMultiplicator\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-graduation-cap"></i></span> {{ member.member.fullName }} ({{ member.entries.length }})</span> <i class="pull-right arno-pointing-pointer" ng-class="{\'ion-chevron-down\': $matAddCtrl.instructionTabState(member.member.id), \'ion-chevron-right\': !$matAddCtrl.instructionTabState(member.member.id)}" ng-click="$matAddCtrl.setInstructionMemberTabState(member.member.id)"></i></div><table ng-if="$matAddCtrl.instructionTabState(member.member.id)" st-table="member.entries" st-input-event="change" class="table table-condensed table-hover"><col><col><col><col width="300px"><thead><tr class="sortable"><th st-sort="Qualification.Name" class="align-bottom">{{ (\'modules.material.addMaterial.qualOrInstruction\' | translate) }}</th><th st-sort="AcquireDate" class="align-bottom">{{ (\'generalTerms.date\' | translate) }}</th><th st-sort="ExpireDate" class="align-bottom">{{ (\'generalTerms.validUntil\' | translate) }}</th><th class="align-bottom">{{ (\'generalTerms.actions\' | translate) }}</th></tr></thead><tbody><tr ng-repeat="documentation in member.entries"><td>{{ documentation.Qualification.Name }}</td><td class="align-left-force">{{ documentation.AcquireDate | date : \'dd.MM.yyyy\' }}</td><td><span>{{ documentation.ExpireDate | date: \'dd.MM.yyyy\'}}</span></td><td><button class="btn btn-xs btn-default" ng-if="documentation.pendingAction !== \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $matAddCtrl.mediaSizeXs, \'btn-with-icon\': !$matAddCtrl.mediaSizeXs}" ng-click="$matAddCtrl.openDocumentQualificationModal(\'view\', documentation)"><i class="ion-eye"></i> <span class="btn-span hidden-xs" translate="modules.material.addMaterial.title3"></span></button> <a ng-if="$matAddCtrl.isPermittedForDossier() && documentation.pendingAction !== \'add\'" class="btn btn-xs btn-default" ng-href="{{ $matAddCtrl.getDossierUrl(documentation.Member) }}" target="_blank"><i class="fa fa-user"></i> <span>{{(\'modules.material.addMaterial.linkInstructedPerson\' | translate) }}</span></a> <button type="button" class="btn btn-xs btn-danger" ng-if="documentation.pendingAction === \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': $matAddCtrl.mediaSizeXs, \'btn-with-icon\': !$matAddCtrl.mediaSizeXs}" ng-click="$matAddCtrl.onDocumentationPendingDelete($index)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.overview.qualificationList.dontAdd"></span></button></td></tr><tr ng-if="!entry.content.length"><td colspan="4" class="text-center"><i translate="modules.material.addMaterial.noEntriesPlaceholder"></i></td></tr></tbody></table></div></div></div></uib-accordion-group></uib-accordion></div></div></div>');
$templateCache.put('app/pages/material/addMaterial/partials/responsibleMember.html','<member-selector on-member-select="$matAddCtrl.addResponsibleMember" blank-search-on-click="true" only-active="true" ng-if="!$matAddCtrl.viewOnly" divisions="$matAddCtrl.divisionId" member-exclude="$matAddCtrl.memberExclude" ng-disabled="$matAddCtrl.divisionId.length > 1"></member-selector><div class="table-responsive" ng-class="{\'mt-40\': !$matAddCtrl.viewOnly}"><table st-table="$matAddCtrl.displayCollection" st-safe-src="$matAddCtrl.responsibleMembers" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="FirstName" st-sort-default="true">{{ (\' generalTerms.firstName\' | translate) }}</th><th st-sort="LastName">{{ (\' generalTerms.lastName\' | translate) }}</th><th st-sort="Account.EMail">{{ (\' generalTerms.email\' | translate) }}</th><th>{{ (\' generalTerms.action\' | translate) }}</th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in $matAddCtrl.displayCollection"><td ng-class="{ \'member-inactive\': member.isInactive || member.Member.isInactive }" title="{{ ::(member.isInactive || member.Member.isInactive ? \'Mitglied ist inaktiv\' : \'\') }}">{{ ::(member.FirstName || member.Member.FirstName) }}</td><td ng-class="{ \'member-inactive\': member.isInactive || member.Member.isInactive }" title="{{ ::(member.isInactive || member.Member.isInactive ? \'Mitglied ist inaktiv\' : \'\') }}">{{ ::(member.LastName || member.Member.LastName) }}</td><td ng-class="{ \'member-inactive\': member.isInactive || member.Member.isInactive }" title="{{ ::(member.isInactive || member.Member.isInactive ? \'Mitglied ist inaktiv\' : \'\') }}">{{ ::(member.Account.EMail || member.Member.Account.EMail) }}</td><td class="arno-table-button-cell"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$matAddCtrl.removeMember(member)" ng-disabled="$matAddCtrl.divisionId.length > 1"><i class="ion-ios-trash"></i><span class="btn-span">Entfernen</span></button></td></tr><tr ng-if="!$matAddCtrl.displayCollection.length"><td colspan="4">{{ (\'modules.material.addMaterial.noChoosenPersonInCharge\' | translate) }}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="5" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/material/addMaterial/partials/saveRequired.html','<div><div class="alert bg-info">{{ \'modules.material.addMaterial.saveRequiredHint\' | translate }}</div></div>');
$templateCache.put('app/pages/material/addMaterial/partials/storageContents.html','<uib-accordion ng-repeat="(key, content) in $matAddCtrl.StorageContents" ng-if="content.length" panel-class="panel-default bootstrap-panel accordion-panel" is-open="$matAddCtrl.tabStates[key]" ng-click="$matAddCtrl.tabStates[key] = !$matAddCtrl.tabStates[key]"><div uib-accordion-group="" class="panel-default accordion-panel"><uib-accordion-heading><i class="pull-left mr-5" ng-class="$matAddCtrl.storageIconMap[key]"></i> {{($matAddCtrl.modelMap[key] + \' (\' + content.length + \')\')}} <i class="pull-right" ng-class="{\'ion-chevron-down\': $matAddCtrl.tabStates[key], \'ion-chevron-right\': !$matAddCtrl.tabStates[key]}"></i></uib-accordion-heading><div><ul class="arno-storage-list"><li ng-repeat="row in content">{{row.Definition || row.Name || row.VehicleModel || row.Type}}</li></ul></div></div></uib-accordion>');
$templateCache.put('app/pages/material/addMaterial/partials/storageLocation.html','<div class="mb-40"><div class="mt-10 alert bg-warning"><h4>{{ (\'modules.material.addMaterial.note\' | translate) }}</h4><span>{{ (\'modules.material.addMaterial.noteText\' | translate) }}</span></div><div class="input-group input-group-with-select"><span class="input-group-addon addon-left arno-material-category-select" uib-dropdown=""><span uib-dropdown-toggle="">{{ $matAddCtrl.activeCategory.label }}</span> <span class="caret mb-2"></span><ul class="dropdown-menu" uib-dropdown-menu=""><li ng-repeat="category in $matAddCtrl.storageCategoryOptions"><a ng-click="$matAddCtrl.activeCategory = category">{{ category.label }}</a></li></ul></span><ui-select ng-model="$matAddCtrl.addModel.Storage" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" reset-search-input="false" on-select="$matAddCtrl.removePlaceholder(\'Storage\')" ng-disabled="$matAddCtrl.viewOnly" search-enabled="true"><ui-select-match placeholder="{{ ( $matAddCtrl.editPlaceholders.Storage && $matAddCtrl.editPlaceholders.Storage.Name || (\'modules.material.addMaterial.searchstorageLocation\' | translate) ) }}">{{ $matAddCtrl.addModel.Storage.Name }}</ui-select-match><ui-select-choices position="down" repeat="storage in $matAddCtrl.storageResults" refresh="$matAddCtrl.searchOrSetStorageLocations($select.search)" refresh-delay="200" group-by=""><div class="btn-with-icon"><span class="inline-block arno-material-storage-icon"><i ng-class="$matAddCtrl.getStorageIcon(storage.OriginModel)"></i></span> <span>{{ storage.Name }}</span></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" title="Auswahl l\xF6schen" translate-attr="{title : \'modules.material.addMaterial.deleteSelection\'}" ng-disabled="$matAddCtrl.viewOnly" class="btn btn-danger ion-ios-trash" ng-click="$matAddCtrl.removePlaceholder(\'Storage\'); $matAddCtrl.addModel.Storage = null"></button></span></div></div>');
$templateCache.put('app/pages/material/addMaterialModal/materialQualificationModal/materiaQualificationDocumentModal.html','<div class="modal-content"><form id="qualificationForm" name="qualificationForm" novalidate="" angular-validator="" angular-validator-submit="self.applyModal()"><div class="modal-header"><h4 class="modal-title" ng-if="self.mode === \'add\'">{{ (\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.title\' | translate:self.translateValues) }}</h4><h4 class="modal-title" ng-if="self.mode === \'view\'">{{ (\'modules.material.addMaterial.title3\' | translate:self.translateValues) }}</h4><i class="fa fa-times modal-close" ng-click="$dismiss(null)"></i></div><div><div class="modal-body"><div class="form-group"><label>{{ (\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectLabel\' | translate:self.translateValues) }}<arno-ba-help-tooltip text="{{(\'modules.material.addMaterial.qualificationSelectInfo\' | translate) }}"></arno-ba-help-tooltip></label><ui-select ng-model="self.formData.MaterialQualification" multiple="" class="form-control arno-roleselect" append-to-body="false" ng-disabled="self.mode === \'edit\' || self.mode === \'view\'"><ui-select-match placeholder="{{ (\'modules.personnel.dossier.overview.qualificationList.searchPlaceholder\'| translate:self.translateValues) }}">{{$item.Qualification.Name}}</ui-select-match><ui-select-choices position="down" repeat="item in self.configuredQualifications | filter: {$: $select.search} | orderBy:[\'GroupName\',\'Name\']"><i ng-class="{\'ion-ios-people\':!item.DivisionId,\'ion-ios-people-outline\':item.DivisionId}"></i> <span>{{ item.Qualification.Name }}</span></ui-select-choices></ui-select></div><div ng-show="(self.formData.MaterialQualification && self.formData.MaterialQualification.length) || self.mode === \'view\'"><div class="row"><div class="form-group col-md-6"><label for="acquireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.aquireDateLabel" class="control-label required-label" translate-values="{ typeSingular: self.typeSingular }"></label><div class="input-group"><input id="acquireDate" name="acquireDate" class="form-control" type="text" uib-datepicker-popup="{{self.acquireDatepicker.format}}" datepicker-options="self.acquireDatepicker.options" is-open="self.acquireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="self.formData.AcquireDate" ng-model-options="{ debounce: 200 }" required-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.noRefDate\' | translate)" required="" ng-disabled="self.mode === \'view\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-disabled="self.mode === \'view\'" ng-click="self.acquireDateOpened = !self.acquireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-6"><label for="expireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateLabel"></label><div class="input-group"><input data-cy="components-qualificationlist-modal-expiredate" id="expireDate" name="expireDate" class="form-control" type="text" validator="self.checkForValidExpireDate()" uib-datepicker-popup="{{self.expireDatepicker.format}}" datepicker-options="self.expireDatepicker.options" is-open="self.expireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="self.formData.ExpireDate" ng-model-options="{ debounce: 200 }" ng-disabled="self.mode === \'view\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-disabled="self.mode === \'view\'" ng-click="self.expireDateOpened = !self.expireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block sub-little-text" ng-if="self.ExpireDateViaValidityPeriodHelper"><i class="fa fa-info-circle"></i> {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText1\' | translate }} {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText2\' | translate }}</span></div></div><div class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-disabled="self.mode === \'view\'" ng-model="self.formData.InitialInstructionByManufacturerOrAuthorizedPerson"> <span translate="modules.material.addMaterial.instructorMultiplicator" style="color: rgba(0,0,0, 0.8);"></span></label></div><div class="form-group"><label class="control-label required-label" translate="modules.material.addMaterial.instructedMember"></label><member-selector ng-if="self.mode !== \'view\'" on-member-select="self.addInstructedMember" blank-search-on-click="true" only-active="true" divisions="self.divisionIds" member-exclude="self.instructedMemberExclude"></member-selector><div><input type="hidden" class="form-control" name="InstructedMembersSelected" ng-model="self.formData.InstructedMembers" validator="self.formData.InstructedMembers.length > 0" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div><div class="table-responsive" ng-class="{\'mt-10\': !self.viewOnly}"><table class="table table-condensed table-hover" st-table="self.formData.InstructedMembers"><thead><tr class="black-muted-bg"><th>{{ (\' generalTerms.name\' | translate) }}</th><th>{{ (\' generalTerms.action\' | translate) }}</th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in self.formData.InstructedMembers"><td ng-class="{ \'member-inactive\': member.isInactive || member.Member.isInactive }">{{ ::(member.fullName || member.Member.fullName) }}</td><td class="arno-table-button-cell"><button ng-if="self.mode !== \'view\'" class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="self.removeInstructedMember(member)"><i class="ion-ios-trash"></i><span class="btn-span">Entfernen</span></button></td></tr><tr ng-if="!self.formData.InstructedMembers.length"><td colspan="4">{{ (\'modules.material.addMaterial.noInstructedMembersSelected\' | translate) }}</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="5" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div><div class="form-group"><label for="instructingPersonTypeSelection" class="control-label required-label" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructingPerson" translate-values="self.translateValues"></label><div class="d-flex"><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio1" ng-model="self.selectedPersonFieldType" value="member" ng-disabled="self.mode === \'view\'"> <span style="color: rgba(0,0,0, 0.8);" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionMember"></span></label></div><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio2" ng-model="self.selectedPersonFieldType" value="contact" ng-disabled="self.mode === \'view\'"> <span style="color: rgba(0,0,0, 0.8);" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionContact"></span></label></div><div><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio3" ng-model="self.selectedPersonFieldType" value="organisation" ng-disabled="self.mode === \'view\'"> <span style="color: rgba(0,0,0, 0.8);" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionOrganisation"></span></label></div></div><div ng-if="self.mode !== \'view\'" class="form-group"><member-selector ng-show="self.selectedPersonFieldType === \'member\'" initial-member-value="self.formData.InstructingMember" on-member-select="self.instructingMemberSelected" blank-search-on-click="true" only-active="true" keep-after-selection="true" divisions="self.divisionIds" member-exclude="self.instructingMemberExclude" ng-disabled="self.mode === \'view\'"></member-selector><contact-selector ng-show="self.selectedPersonFieldType === \'contact\'" on-select="self.instructingContactSelected" selected-contact="self.formData.InstructingContact" blank-search-on-click="true" only-active="true" divisions="self.divisionIds" ng-disabled="self.mode === \'view\'"></contact-selector><business-partners-selector ng-show="self.selectedPersonFieldType === \'organisation\'" division="self.divisionIds" on-business-partner-select="self.instructingOrganisationSelected" selected-business-partner="self.formData.InstructingBusinessPartner" append-to-body="false" ng-disabled="self.mode === \'view\'"></business-partners-selector><div class="hidden-inputs"><div><input type="hidden" class="form-control" name="InstructingMemberSelected" ng-model="self.formData.InstructingMemberId" validator="self.selectedPersonFieldType === \'member\' ? !!self.formData.InstructingMemberId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div><div><input type="hidden" class="form-control" name="InstructingContactSelected" ng-model="self.formData.InstructingContactId" validator="self.selectedPersonFieldType === \'contact\' ? !!self.formData.InstructingContactId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div><div><input type="hidden" class="form-control" name="InstructingBusinessPartnerSelected" ng-model="self.formData.InstructingBusinessPartnerId" validator="self.selectedPersonFieldType === \'organisation\' ? !!self.formData.InstructingBusinessPartnerId : true" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingPersonRequired\'| translate)"></div></div></div><div ng-if="self.mode === \'view\'"><input class="form-control" ng-model="self.formData.InstructingPerson.asString" ng-disabled="true"></div></div></div></div></div><div class="modal-footer"><button data-cy="components-qualificationlist-modal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()">{{ (self.mode === \'view\' ? \'generalTerms.back\' : \'generalTerms.cancel\') | translate }}</button> <button ng-if="self.mode !== \'view\'" data-cy="components-qualificationlist-modal-submit" type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/material/addMaterialModal/materialQualificationModal/materialQualificationAddModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.title\' | translate:self.translateValues) }}</h4><i class="fa fa-times modal-close" ng-click="$dismiss(null)"></i></div><div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-group"><label translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectLabel" translate-values="self.translateValues"></label><ui-select ng-model="self.formData.Qualification" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="self.mode === \'edit\'" search-enabled="true"><ui-select-match placeholder="{{ (\'modules.personnel.dossier.overview.qualificationList.searchPlaceholder\'| translate:self.translateValues) }}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" repeat="qualificationChoice in self.flatQualificationHierarchy | filter: {$: $select.search} | orderBy:[\'GroupName\',\'Name\']" group-by="\'GroupName\'"><i ng-class="{\'ion-ios-people\':!qualificationChoice.DivisionId,\'ion-ios-people-outline\':qualificationChoice.DivisionId}"></i> <span>{{ qualificationChoice.Name }}</span></ui-select-choices></ui-select></div><div class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="self.formData.Required"> <span translate="modules.material.addMaterial.instructionRequired"></span></label></div><div class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="self.formData.PartOfInstruction"> <span translate="modules.material.addMaterial.partOfInstruction"></span></label></div></div></div></div></div></div><div class="modal-footer"><button data-cy="components-qualificationlist-modal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="components-qualificationlist-modal-submit" type="submit" class="btn btn-primary" ng-click="self.applyModal()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/material/addMaterialModal/materialQualificationModal/materialQualificationModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.material.addMaterial.configureInstructions\' | translate:self.translateValues) }}</h4><i class="fa fa-times modal-close" ng-click="$dismiss(null)"></i></div><div class="modal-body"><button type="button" class="btn btn-primary btn-with-icon mb-20" ng-if="!self.viewOnly" ng-click="self.openQualificationModal(\'add\')"><i class="ion-plus"></i> {{ (\'modules.material.addMaterial.addInstruction\' | translate) }}</button><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-condensed table-hover"><col><col width="150px"><col width="220px"><col ng-show="!self.viewOnly" width="240px"><thead><tr class="black-muted-bg"><th translate="generalTerms.title"></th><th class="text-center" translate="modules.material.addMaterial.instructionRequired"></th><th class="text-center"><span translate="modules.material.addMaterial.partOfInstruction"></span> <span uib-tooltip="{{ \'modules.material.addMaterial.partOfInstructionTooltip\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__ba-panel__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></th><th ng-show="!self.viewOnly" translate="generalTerms.actions"></th></tr></thead><tbody class="without-top-border"><tr ng-repeat="qualification in self.materialQualifications | groupBy:\'GroupName\' as filteredItems"><td>{{qualification.Qualification.Name}}</td><td class="text-center"><span><i ng-if="qualification.Required" class="fa fa-check color-success"></i></span></td><td class="text-center"><span><i ng-if="qualification.PartOfInstruction" class="fa fa-check color-success"></i></span></td><td ng-show="!self.viewOnly"><button class="btn btn-xs btn-default" ng-if="!self.viewOnly" ng-class="{\'btn-icon btn-xs-small-height\': self.mediaSizeXs, \'btn-with-icon\': !self.mediaSizeXs}" ng-click="self.openQualificationModal(\'edit\', qualification)"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit"></span></button> <button class="btn btn-xs" type="button" ng-if="self.displayKeepOrDeleteQualificationBtn(qualification) && !self.viewOnly" ng-class="{\'btn-danger\':qualification.pendingAction !== \'delete\', \'btn-warning\': qualification.pendingAction === \'delete\', \'btn-icon btn-xs-small-height\': self.mediaSizeXs, \'btn-with-icon\': !self.mediaSizeXs}" ng-click="self.onQualificationDelete(qualification)"><i ng-class="{\'ion-ios-trash\':qualification.pendingAction !== \'delete\', \'ion-plus-round\':qualification.pendingAction === \'delete\'}"></i> <span class="btn-span hidden-xs">{{ qualification.pendingAction === \'delete\' ? (\'modules.personnel.dossier.overview.qualificationList.maintain\' | translate ) : qualification.pendingAction === \'edit\' ? (\'modules.personnel.dossier.overview.qualificationList.dontChange\' | translate ) : (\'modules.personnel.dossier.overview.qualificationList.remove\'| translate ) }}</span></button> <button type="button" class="btn btn-xs btn-danger" ng-if="qualification.pendingAction === \'add\'" ng-class="{\'btn-icon btn-xs-small-height\': self.mediaSizeXs, \'btn-with-icon\': !self.mediaSizeXs}" ng-click="self.onQualificationPendingDelete(qualification)"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.overview.qualificationList.dontAdd"></span></button></td></tr><tr ng-if="!self.materialQualifications.length"><td colspan="4" class="text-center"><i translate="modules.material.addMaterial.noEntriesPlaceholder"></i></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button data-cy="components-qualificationlist-modal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="components-qualificationlist-modal-submit" type="submit" class="btn btn-primary" ng-click="self.applyModal()" translate="generalTerms.takeOver"></button></div></div>');
$templateCache.put('app/pages/material/overview/deleteModal/deleteMaterial.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title">{{ $delCtrl.title }}</h4></div><div class="modal-body" ng-class="{\'text-center\': $delCtrl.centerContent === true}"><p>{{ (\'modules.material.overview.DeleteText\' | translate) + (Array.isArray($delCtrl.material) ? (\'modules.material.overview.DeleteText2\' | translate) : (\'modules.material.overview.DeleteText3\' | translate)) + \' \' + (\'modules.material.overview.DeleteText4\' | translate) }}</p><div ng-if="$delCtrl.storageMaterials && $delCtrl.storageMaterials.length"><p>{{(\'modules.material.overview.FollowMaterialStorageLocation\' | translate)}}</p><ul><li ng-repeat="material in $delCtrl.storageMaterials">{{ material }}</li></ul><p>{{(\'modules.material.overview.ForMoreInformation\' | translate)}}</p><br></div><p>{{(\'modules.material.overview.CantRevert\' | translate)}}</p></div><div class="modal-footer"><span><button type="button" class="btn btn-danger" ng-click="$close()">{{(\'generalTerms.delete\' | translate)}}</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">{{(\'generalTerms.cancel\' | translate)}}</button></span></div></div>');
$templateCache.put('app/pages/material/overview/migrate-responsible-to-handover/migrate-responsible-to-handover.html','<div class="modal-content"><form name="migrateResponsibleToHandoverForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title"><span translate="modules.material.overview.migrateResponsiblePersonTitle">{{ \'modules.material.overview.migrateResponsiblePersonTitle\' | translate }}</span></h4></div><div class="alert bg-info"><b>{{ \'modules.material.overview.migrateResponsiblePersonInfo\' | translate }}</b></div><fieldset class="modal-body"><p><span><input type="checkbox" ng-model="$modalCtrl.isResponsibleMemberDeleted" class="custom-control-input"><span></span></span> {{ \'modules.material.overview.migrateResponsiblePersonCheckbox\' | translate }}</p></fieldset><div class="alert bg-warning"><b>{{ \'modules.material.overview.migrateResponsiblePersonWarning\' | translate }}</b></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="submit" class="btn btn-primary" translate="generalTerms.save">Speichern</button></div></form></div>');
$templateCache.put('app/pages/personnel/demandForAction/modals/importSelection.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.demandForAction.importModalTitle"></h4></div><div class="modal-body pt-0"><p translate="modules.personnel.demandForAction.importModalParagraph"></p><div class="alert bg-warning" translate="modules.personnel.demandForAction.importModalAlertWarning"></div><div class="alert bg-primary" translate="modules.personnel.demandForAction.importModalAlertPrimary"></div><div class="well" nv-file-drop="" nv-file-over="" over-class="" uploader="$dfaism.uploader"><span translate="modules.personnel.demandForAction.importModalUploaderSpan"></span><div class="mt-10"><input type="file" id="inputFile" nv-file-select="" uploader="$dfaism.uploader"></div></div><table class="table"><tbody><tr ng-repeat="item in $dfaism.uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="$dfaism.uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td width="30%" ng-show="$dfaism.uploader.isHTML5"><div class="progress"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div></td><td class="text-center"><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok text-success"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle text-danger"></i></span> <span ng-show="item.isError" title="{{ \'modules.personnel.demandForAction.importModalUploadErr\' | translate }}"><i class="glyphicon glyphicon-remove text-danger"></i></span></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button></div></div>');
$templateCache.put('app/pages/personnel/dossier/activity/activity.html','<div class="tab-content"><div class="btns-row"><button data-cy="personnel-dossier-activity-assign" type="button" class="btn btn-primary btn-with-icon" ng-if="$act.isPermitted(\'arno.personnel.dossier.activity.assign\', true)" ng-click="$act.addPendingActivity()" translate="modules.personnel.dossier.activity.assignOccupation"><i class="ion-plus"></i></button></div><div ng-switch="$act.isOrgScope" class="arno-activity-dossier mb-15"><div ng-switch-when="true"><div ng-repeat="activityHistory in $act.allActivityHistories"><h3 class="with-line" toggle-next="">{{activityHistory.Name}}</h3><div class="horizontal-scroll"><table class="table table-condensed"><colgroup><col width="15%"><col width="26px"><col width="20%"><col width="10%"><col width="15%"><col width="20%"></colgroup><thead><tr class="black-muted-bg"><th translate="modules.personnel.dossier.activity.occupationGroup"></th><th></th><th class="align-left-force" translate="modules.personnel.dossier.activity.name"></th><th translate="modules.personnel.dossier.activity.state"></th><th translate="modules.personnel.dossier.activity.characteristic"></th><th translate="modules.personnel.dossier.activity.assignedUntilLastActive"></th><th translate="modules.personnel.dossier.activity.action"></th></tr></thead><tbody ng-repeat="activiyGroup in activityHistory.activityGroups track by $index"><tr ng-repeat="activityAllocation in activiyGroup.activityAllocations | orderBy: \'calculatedState\' | groupBy: \'vm.activity.ActivityGroup.id\'"><td ng-if="activityAllocation.byGroupNewItem" rowspan="{{activiyGroup.activityAllocations.length}}" class="align-left-force">{{activityAllocation.vm.activity.ActivityGroup.Title}}</td><td><span ng-if="(activityAllocation.calculatedState === \'ACTIVE\' || activityAllocation.calculatedState === \'INACTIVE\')"><status-light class="\'light-inline light-pad-right\'" is-green="($act.allActivityFulfillmentStates && $act.allActivityFulfillmentStates[activityHistory.divisionId][activityAllocation.vm.activity.id])"></status-light></span></td><td class="align-left-force">{{activityAllocation.vm.activity.Title}}</td><td><div ng-switch="activityAllocation.calculatedState"><div ng-switch-when="PENDING" translate="modules.personnel.dossier.activity.pending"><i class="fa fa-spinner"></i></div><div ng-switch-when="ACTIVE" translate="modules.personnel.dossier.activity.active"><i class="ion-checkmark text-success"></i></div><div ng-switch-when="INACTIVE" translate="modules.personnel.dossier.activity.inactive"><i class="ion-close-round text-danger"></i></div></div></td><td class="align-left-force">{{$act.characteristicMap[activityAllocation.Characteristic] || activityAllocation.Characteristic}}</td><td><div ng-if="(activityAllocation.calculatedState === \'ACTIVE\' || activityAllocation.calculatedState === \'INACTIVE\')">{{(activityAllocation.ActivityAllocationPeriods [activityAllocation.ActivityAllocationPeriods.length - 1] .EndDate | date:\'dd.MM.yyyy\') || (activityAllocation.calculatedState === \'ACTIVE\' ? (\'modules.personnel.dossier.overview.unlimited\' | translate) : (\'modules.personnel.dossier.overview.never\' | translate)) }}</div></td><td><button class="btn btn-xs btn-default btn-with-icon" ng-click="$act.editActivityAssociation(activityAllocation.vm.activity, activityAllocation, [activityHistory.divisionId])" ng-if="activityAllocation.calculatedState !== \'PENDING\' && ( $act.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\', null, [ activityHistory.divisionId ]) || $act.isPermitted(\'arno.personnel.dossier.activity.assign\', null, [ activityHistory.divisionId ]) )"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit"></span></button> <button class="btn btn-xs btn-danger btn-with-icon ml-5" ng-click="$act.deleteActivity(activityAllocation.vm.activity, [activityHistory.divisionId])" ng-if="activityAllocation.calculatedState !== \'PENDING\' && ( $act.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\', null, [ activityHistory.divisionId ]) || $act.isPermitted(\'arno.personnel.dossier.activity.assign\', null, [ activityHistory.divisionId ]) )"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.delete"></span></button> <button class="btn btn-xs btn-default btn-with-icon" ng-click="$act.editActivityAssociation(activityAllocation.vm.activity, activityAllocation, [activityHistory.divisionId])" ng-if="activityAllocation.calculatedState === \'PENDING\' && $act.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\', null, [ activityHistory.divisionId ])"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.activity.assignCharacteristic"></span></button></td></tr><tr ng-if="!activityHistory.activityGroups.length"><td class="align-center" colspan="100"><i translate="modules.personnel.dossier.activity.emptyListMessage"></i></td></tr></tbody></table></div></div><div ng-if="!$act.hasAllActivity" class="text-center mt-25"><i translate="modules.personnel.dossier.activity.emptyListMessage"></i></div></div><div ng-switch-default="" class="arno-activity-section" ng-repeat="activityState in $act.activityStates"><h3 class="with-line" toggle-next="">{{activityState.title}}</h3><div class="horizontal-scroll"><div class="table-responsive"><table class="table table-condensed"><thead><tr class="black-muted-bg"><th translate="modules.personnel.dossier.activity.occupationGroup"></th><th class="align-left-force" translate="modules.personnel.dossier.activity.name"></th><th translate="modules.personnel.dossier.activity.characteristic"></th><th ng-if="activityState.state === \'ACTIVE\'" translate="modules.personnel.dossier.activity.assignedUntil"></th><th ng-if="activityState.state === \'INACTIVE\'" translate="modules.personnel.dossier.activity.lastActive"></th><th ng-if="activityState.state === \'PENDING\'"></th><th translate="modules.personnel.dossier.activity.action"></th></tr></thead><tbody ng-repeat="stateGroup in $act.activitiesGroupedByState"><tr ng-if="stateGroup.state === activityState.state" ng-repeat="activity in stateGroup.activities | orderBy: \'ActivityGroup.id\' | groupBy: \'ActivityGroup.id\'"><td ng-if="activity.byGroupNewItem" rowspan="{{activity.byGroup.unchangedFor + 1}}" class="align-left-force">{{activity.ActivityGroup.Title}}</td><td class="align-left-force"><status-light ng-if="activity.ActivityAllocations[0] && activity.ActivityAllocations[0].Characteristic" is-green="($act.activityFulfillmentStates && $act.activityFulfillmentStates[activity.id])" class="\'light-inline light-pad-right\'"></status-light><span>{{activity.Title}}</span></td><td class="align-left-force" colspan="{{activityState.state === \'PENDING\' ? 2 : 1}}">{{$act.characteristicMap[activity.ActivityAllocations[0].Characteristic] || activity.ActivityAllocations[0].Characteristic || (\'modules.personnel.dossier.trainings.trainingState.PENDING\' | translate)}}</td><td ng-if="(activityState.state === \'ACTIVE\' || activityState.state === \'INACTIVE\')">{{(activity.ActivityAllocations[0].ActivityAllocationPeriods [activity.ActivityAllocations[0].ActivityAllocationPeriods.length - 1] .EndDate | date:\'dd.MM.yyyy\') || (activityState.state === \'ACTIVE\' ? (\'modules.personnel.dossier.overview.unlimited\' | translate) : (\'modules.personnel.dossier.overview.never\' | translate)) }}</td><td><button class="btn btn-xs btn-default btn-with-icon" ng-click="$act.editActivityAssociation(activity)" ng-if="activityState.state !== \'PENDING\' && ( $act.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\') || $act.isPermitted(\'arno.personnel.dossier.activity.assign\') )"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="generalTerms.edit"></span></button> <button class="btn btn-xs btn-danger btn-with-icon ml-5" ng-click="$act.deleteActivity(activity)" ng-if="activityState.state !== \'PENDING\' && activity.ActivityAllocations[0] && $act.isPermitted(\'arno.personnel.dossier.activity.assign\')"><i class="ion-ios-trash"></i> <span class="btn-span hidden-xs" translate="generalTerms.delete"></span></button> <button class="btn btn-xs btn-default btn-with-icon" ng-click="$act.editActivityAssociation(activity)" ng-if="activityState.state === \'PENDING\' && activity.ActivityAllocations[0] && $act.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\')"><i class="ion-edit"></i> <span class="btn-span hidden-xs" translate="modules.personnel.dossier.activity.assignCharacteristic"></span></button></td></tr><tr ng-if="!stateGroup.activities.length"><td colspan="{{ (activityState.state === \'ACTIVE\' || activityState.state === \'INACTIVE\') ? 4 : 3 }}" class="align-center"><span translate="modules.personnel.dossier.activity.groupEmptyMessage"></span></td></tr></tbody></table></div></div></div></div><div class="row btns-row"><div class="col-md-12"><button ng-show="$act.isPermitted(\'arno.personnel.personnelList.view\', true)" ng-if="!$act.backToOverview && $act.backToPersonnelList" type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.activity.backToPersonnelList"></span></button> <button ng-if="$act.backToOverview" type="button" ui-sref="arno.personnel.dossier.overview" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.activity.backToOverview"></span></button><div class="row btns-row pull-right" style="margin-right: 13px;" ng-if="$act.hasAllActivity"><button type="button" class="btn btn-default btn-with-icon" ng-click="$act.activityExport()"><i class="fa fa-download"></i><span class="hidden-xs" translate="modules.personnel.dossier.activity.export"></span></button></div></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/administration/administration.html','<div class="tab-content"><div class="pb-20"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.administration.general\' | translate}}</h3><div class="row"><div class="col-md-12" ng-if="!$admin.isOrg && $admin.isPermitted(\'arno.personnel.dossier.activeState.manage\') && !$admin.member.DivisionMembers[0].WithdrawalTriggeredDate"><ba-switcher switcher-style="primary" switcher-value="$admin.divActive" switcher-width="60" switcher-keys="$admin.divActiveSwitcherKeys"></ba-switcher><span class="dossier-div-active-switcher-label">in {{$admin.currentDivisionName}}.</span></div><div class="col-md-12 mt-10" ng-if="$admin.ownDossier && $root.ctx.currentUser.loginType === \'local\'"><button type="button" class="btn btn-default btn-with-icon" data-cy="personnel-dossier-administration-button-password-local" ng-if="$root.ctx.currentUser.loginType === \'local\'" ng-click="$admin.changePassword()"><i class="fa fa-key fa-rotate-90"></i><span translate="modules.personnel.dossier.administration.changePassword"></span></button></div><div class="col-md-6 mt-10" ng-if="!$admin.accountTypeChanged && $admin.isPermitted(\'arno.administration.personnel.accountType.manage\')"><div id="arnoAzureSwitch" class="mb-5" ng-if="$admin.authInfo.AzureAuth && $admin.member.Account.Type !== \'azure\'"><button data-cy="personnel-dossier-masterdata-button-accounttype" type="button" class="btn btn-success btn-with-icon" ng-click="$admin.changeAccountType(\'azure\')" translate="modules.personnel.dossier.administration.transformToAzureAccount"><i class="fa fa-exchange"></i></button></div><div id="offlineArnoSwitch" class="mb-5" ng-if="$admin.member.Account.Type === \'offline\' && $admin.authInfo.ArnoAuth"><button data-cy="personnel-dossier-masterdata-button-accounttype" type="button" class="btn btn-success btn-with-icon" ng-click="$admin.changeAccountType(\'local\')" translate="modules.personnel.dossier.administration.transformToArnoAccount"><i class="fa fa-exchange"></i></button></div><div class="mb-5" ng-if="$admin.authInfo.Offline && $admin.member.Account.Type === \'azure\'"><button data-cy="personnel-dossier-masterdata-button-accounttype" type="button" class="btn btn-success btn-with-icon" ng-click="$admin.changeAccountType(\'offline\')"><i class="fa fa-exchange"></i> Zu Offline-Account umwandeln</button></div></div><div class="col-md-12 mt-10" ng-if="!$admin.isOrg"><div id="leaveDiv" class="mb-5" ng-if="!$admin.member.DivisionMembers[0].WithdrawalTriggeredDate && ($admin.ownDossier || $admin.isPermitted(\'arno.personnel.administration.deleteMember\'))"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.leave(true)" translate="modules.personnel.dossier.administration.startDivExit"><i class="fa fa-sign-out"></i></button></div><div id="reEnterDiv" class="mb-5" ng-if="$admin.member.DivisionMembers[0].WithdrawalTriggeredDate && !$admin.ownDossier && $admin.isPermitted(\'arno.personnel.administration.deleteMember\')"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.removeWithdrawal(true)" translate="modules.personnel.dossier.administration.cancelDivExit"><i class="fa fa-remove"></i></button></div><span ng-if="!$admin.member.DivisionMembers[0].WithdrawalTriggeredDate"><div id="blockDiv" class="mb-5" ng-if="!$admin.member.DivisionMembers[0].BlockReasonId && !$admin.ownDossier && $admin.isPermitted(\'arno.personnel.administration.deleteMember\')"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.block(true)" translate="modules.personnel.dossier.administration.block"><i class="fa fa-ban"></i></button></div><div id="deBlockDiv" class="mb-5" ng-if="$admin.member.DivisionMembers[0].BlockReasonId && !$admin.ownDossier && $admin.isPermitted(\'arno.personnel.administration.deleteMember\')"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.removeBlockage(true)" translate="modules.personnel.dossier.administration.unblock"><i class="fa fa-check"></i></button></div></span></div><div class="col-md-12 mt-10" ng-if="$admin.isOrg"><div id="leaveOrg" class="mb-5" ng-if="!$admin.member.WithdrawalTriggeredDate && ($admin.ownDossier || $admin.isPermitted(\'arno.personnel.administration.deleteMember\'))"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.leave(false)" translate="modules.personnel.dossier.administration.startOrgExit"><i class="fa fa-sign-out"></i></button></div><div id="reEnterOrg" class="mb-5" ng-if="$admin.member.WithdrawalTriggeredDate && $admin.isPermitted(\'arno.personnel.administration.deleteMember\')"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.removeWithdrawal(false)" translate="modules.personnel.dossier.administration.cancelOrgExit"><i class="fa fa-remove"></i></button></div><span ng-if="!$admin.member.WithdrawalTriggeredDate"><div id="blockOrg" class="mb-5" ng-if="!$admin.member.BlockReasonId && !$admin.ownDossier && $admin.isPermitted(\'arno.personnel.administration.deleteMember\')"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.block(false)" translate="modules.personnel.dossier.administration.block"><i class="fa fa-ban"></i></button></div><div id="deBlockOrg" class="mb-5" ng-if="$admin.member.BlockReasonId && $admin.isPermitted(\'arno.personnel.administration.deleteMember\') && !$admin.ownDossier"><button type="button" class="btn btn-danger btn-with-icon" ng-click="$admin.removeBlockage(false)" translate="modules.personnel.dossier.administration.unblock"><i class="fa fa-check"></i></button></div></span></div><div class="col-md-12 mt-10" ng-if="$admin.ownDossier"><label class="checkbox-inline custom-checkbox nowrap m-0"><input type="checkbox" ng-model="$admin.isUserOptedIn" ng-change="$admin.matomoTrackingChanged()"> <span><b>{{\'modules.personnel.dossier.administration.track\' | translate}}</b></span></label></div></div></div><div class="pb-20"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.administration.notifications\' | translate}}</h3><div class="row"><div class="col-xs-12"><style>\n          .push-notification-table tr:first-of-type td {\n            border-top: 0;\n          }\n\n          .push-notification-table td {\n            text-align: left;\n          }\n        </style><table class="table table-responsive push-notification-table"><colgroup><col width="40%"><col width="20%"><col width="20%"><col width="20%"></colgroup><tbody><tr><td><span class="control-label" translate="modules.personnel.dossier.administration.events"></span></td><td><label><input ng-disabled="!$admin.ownDossier" ng-model="$admin.notifications.preferences.Events" type="radio" name="events" value="BOTH"> {{\'constants.notificationPreference.both\' | translate}}</label></td><td><label><input ng-disabled="!$admin.ownDossier" ng-model="$admin.notifications.preferences.Events" type="radio" name="events" value="EMAIL"> {{\'constants.notificationPreference.email\' | translate}}</label></td><td><label><input ng-disabled="!$admin.ownDossier" ng-model="$admin.notifications.preferences.Events" type="radio" name="events" value="PUSH"> {{\'constants.notificationPreference.push\' | translate}}</label></td></tr><tr><td><span class="control-label" translate="modules.personnel.dossier.administration.services"></span></td><td><label><input ng-disabled="!$admin.ownDossier" type="radio" name="services" ng-model="$admin.notifications.preferences.Services" value="BOTH"> {{\'constants.notificationPreference.both\' | translate}}</label></td><td><label><input ng-disabled="!$admin.ownDossier" type="radio" name="services" ng-model="$admin.notifications.preferences.Services" value="EMAIL"> {{\'constants.notificationPreference.email\' | translate}}</label></td><td><label><input ng-disabled="!$admin.ownDossier" type="radio" name="services" ng-model="$admin.notifications.preferences.Services" value="PUSH"> {{\'constants.notificationPreference.push\' | translate}}</label></td></tr><tr><td><span class="control-label" translate="modules.personnel.dossier.administration.notifyAll"></span></td><td><label><input ng-disabled="!$admin.ownDossier" type="radio" name="notifyAll" ng-model="$admin.notifications.preferences.NotifyAll" ng-value="true"> {{\'components.switcher.on\' | translate}}</label></td><td colspan="2"><label><input ng-disabled="!$admin.ownDossier" type="radio" name="notifyAll" ng-model="$admin.notifications.preferences.NotifyAll" ng-value="false"> {{\'components.switcher.off\' | translate}}</label></td></tr><tr><td><span class="control-label" translate="modules.personnel.dossier.administration.notifyImportant"></span></td><td><label><input ng-disabled="!$admin.ownDossier" type="radio" name="notifyImportant" ng-model="$admin.notifications.preferences.NotifyImportant" ng-value="true"> {{\'components.switcher.on\' | translate}}</label></td><td colspan="2"><label><input ng-disabled="!$admin.ownDossier" type="radio" name="notifyImportant" ng-model="$admin.notifications.preferences.NotifyImportant" ng-value="false"> {{\'components.switcher.off\' | translate}}</label></td></tr></tbody></table><button type="button" class="btn btn-primary" style="font-size: 1.2rem; width: 23rem;" ng-click="$admin.sendTestPushMessage(\'Services\')" translate="modules.personnel.dossier.administration.testServicePush"></button></div></div><div class="pb-15" ng-if="$admin.isPermittedOrOwn(\'arno.personnel.dossier.permissions.view\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.administration.permissionOverview\' | translate}}</h3><div class="row"><div class="col-md-12"><div class="typography accent info mb-10" translate="modules.personnel.dossier.administration.permissionDecription"></div></div><div class="col-md-6" ng-if="$admin.fetchPermissions.organization"><h4 translate="modules.personnel.dossier.administration.organization"></h4><div class="dossier-administration-permission-list"><div ng-repeat="permission in $admin.fetchPermissions.organization | orderBy:\'+Name\'" class="dossier-administration-permission-entry"><span title="{{permission.Description}}"><i class="fa fa-check"></i> {{permission.Name}}</span></div></div><div ng-if="!$admin.fetchPermissions.organization.length"><i translate="modules.personnel.dossier.administration.noPermissions"></i></div></div><div class="col-md-6" ng-if="!$admin.isOrg"><h4>{{ (\'modules.personnel.dossier.administration.permissionOverviewDivisionHeadline\' | translate:{ division: $admin.currentDivisionName } ) }}</h4><div class="dossier-administration-permission-list"><div ng-repeat="permission in $admin.fetchPermissions.division" class="dossier-administration-permission-entry"><span title="{{permission.Description}}"><i class="fa fa-check"></i> {{permission.Name}}</span></div></div><div ng-if="!$admin.fetchPermissions.division.length"><i translate="modules.personnel.dossier.administration.noPermissions"></i></div></div><div class="col-md-12 mt-40" ng-if="$admin.isOrg"><div ng-if="!$admin.allDivisionPermissions.length"><h4 translate="modules.personnel.dossier.administration.allDivisions"></h4><div><i translate="modules.personnel.dossier.administration.noPermissions"></i></div></div><div ng-if="$admin.allDivisionPermissions.length && $admin.warnDivisionMatrixLength"><h4 translate="modules.personnel.dossier.administration.allDivisions"></h4><p>{{ (\'modules.personnel.dossier.administration.divisionPermissionTextPart1\' | translate) }} <strong>{{ (\'modules.personnel.dossier.administration.divisionPermissionTextPart2\' | translate:{ length: $admin.warnDivisionMatrixLength }) }}</strong> {{ (\'modules.personnel.dossier.administration.divisionPermissionTextPart3\' | translate) }}</p><button type="button" class="btn btn-default" ng-click="$admin.warnDivisionMatrixLength = false" translate="modules.personnel.dossier.administration.showDivPermissions"></button></div><div class="table-responsive arno-table-scrollable" ng-if="$admin.allDivisionPermissions.length && !$admin.warnDivisionMatrixLength"><table class="table table-condensed table-hover dossier-administration-permission-table"><thead><tr><th><h4 translate="modules.personnel.dossier.administration.allDivisions"></h4></th><th ng-repeat="zone in ::$admin.fetchPermissions.divisionMatrix.allZoneIds | orderBy:$admin.matrixOrderXAxis" class="text-center"><strong>{{::$admin.fetchPermissions.divisionMatrix.zoneIdMap[zone]}}</strong></th></tr></thead><tbody><tr ng-repeat="permission in ::$admin.allDivisionPermissions | orderBy:$admin.matrixOrderYAxis"><td>{{::$admin.fetchPermissions.divisionMatrix.internalNameMap[permission].Name}}<p class="dossier-administration-permission-row-desc">{{::$admin.fetchPermissions.divisionMatrix.internalNameMap[permission].Description}}</p></td><td ng-repeat="zone in ::$admin.fetchPermissions.divisionMatrix.allZoneIds | orderBy:$admin.matrixOrderXAxis" class="text-center"><i ng-if="$admin.fetchPermissions.divisionMatrix.data[permission].indexOf(zone) >= 0" class="fa fa-check" title="{{::$admin.fetchPermissions.divisionMatrix.zoneIdMap[zone]}}"></i></td></tr></tbody></table></div></div></div></div><div class="pb-15" ng-if="$admin.isPermittedOrOwn(\'arno.personnel.dossier.history.view\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.administration.history\' | translate}}</h3><div class="row"><div class="col-md-12"><div class="btn-toolbar"><div uib-dropdown="" dropdown-toggle=""><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.administration.pageSize"></span> ({{ $admin.historyTableConfig.pageSize }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$admin.historyTableConfig.pageSize = i">{{ i }}</a></li></ul></div></div></div><div class="col-md-12"><div class="table-responsive"><table st-table="$admin.historyCollection" st-pipe="$admin.getHistoryData" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort="Type">{{ (\'modules.personnel.dossier.administration.historyTableName\' | translate) }}</th><th>{{ (\'modules.personnel.dossier.administration.historyTableDesc\' | translate) }}</th><th st-sort="createdAt" st-sort-default="reverse">{{ (\'modules.personnel.dossier.administration.historyTableTime\' | translate) }}</th><th>{{ (\'modules.personnel.dossier.administration.historyTableTrigger\' | translate) }}</th><th ng-if="$admin.isOrg">{{ (\'modules.personnel.dossier.administration.historyTableDiv\' | translate) }}</th></tr></thead><tbody><tr ng-repeat="history in $admin.historyCollection.data"><td class="align-left-force"><span history-label-mapper="{{::history.Type}}"></span></td><td class="align-left-force"><span history-data-mapper="{{::history.Type}}"></span></td><td class="align-left-force"><span>{{ ::history.createdAt | date : \'dd.MM.yyyy - HH:mm:ss\' }}</span></td><td class="align-left-force"><span>{{ ::history.TriggeringMember }}</span></td><td class="align-left-force" ng-if="$admin.isOrg"><span>{{ ::((history.Division && history.Division.Name) || history.Division) }}</span></td></tr><tr ng-if="$admin.historyCollection.data && $admin.historyCollection.data.length === 0"><td class="text-center" colspan="{{$admin.isOrg ? 5 : 4}}"><i translate="modules.personnel.dossier.administration.noHistoryEntries"></i></td></tr></tbody><tfoot><tr><td colspan="{{$admin.isOrg ? 5 : 4}}" class="text-center"><st-pagination st-items-by-page="$admin.historyTableConfig.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div><div class="row btns-row mt-10"><div class="col-md-12"><button type="button" ng-show="$admin.isPermitted(\'arno.personnel.personnelList.view\')" ng-if="$admin.backToPersonnelList" ng-click="$admin.back()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.administration.backToPersonnelList"></span></button></div></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/administration/changeAccountType.html','<div class="modal-content personnel-add-modal"><form id="orgDataForm" ng-submit="OnlineSwitchModalCtrl.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.administration.changeAccountType.title"></h4></div><div class="modal-body" ng-if="$onlineSwitchModalCtrl.newType === \'azure\'"><h5 class="modal-subtitle"><i class="ion-mail"></i> <span ng-if="!$onlineSwitchModalCtrl.searchedUser.Name" translate="modules.personnel.dossier.administration.changeAccountType.searchUser"></span> <span ng-if="$onlineSwitchModalCtrl.searchedUser.searchUser" translate="modules.personnel.dossier.administration.changeAccountType.chooseUser"></span></h5><member-selector ng-if="!$onlineSwitchModalCtrl.userIdentifiers" organization-scope="true" on-member-select="$onlineSwitchModalCtrl.selectedADUser" azure="true" member-exclude="$onlineSwitchModalCtrl.azureMemberExclude"></member-selector><span ng-if="$onlineSwitchModalCtrl.duplicate && $onlineSwitchModalCtrl.newType === \'azure\'" class="help-block basic-block">{{ (\'modules.personnel.dossier.administration.changeAccountType.accAlredyExistsText\' | translate:{ username: $onlineSwitchModalCtrl.searchedUser.Name }) }}</span><h4 ng-if="$onlineSwitchModalCtrl.searchedUser.Name">{{ $onlineSwitchModalCtrl.searchedUser.Name }} <i ng-click="$onlineSwitchModalCtrl.clearAzureSearch()" class="fa fa-refresh pull-right arno-pointing-pointer"></i></h4></div><div class="modal-body" ng-if="$onlineSwitchModalCtrl.newType === \'local\'"><h5 class="modal-subtitle"><i class="ion-mail"></i> <span translate="modules.personnel.dossier.administration.changeAccountType.addEmail"></span></h5><div><div class="row col-sm-12"><div class="alert bg-warning"><h4 translate="modules.personnel.dossier.administration.changeAccountType.hint"></h4><strong translate="modules.personnel.dossier.administration.changeAccountType.emailHint"></strong></div></div><div class="row"><div class="col-sm-6"><div class="form-group clearfix"><label for="accountEmail" class="control-label required-label" translate="modules.personnel.dossier.administration.changeAccountType.accountEmail"></label> <input type="text" class="form-control" name="accountEmail" id="accountEmail" ng-model="$onlineSwitchModalCtrl.searchedUser.EMail" ui-validate-async="{ alreadyExists: \'$onlineSwitchModalCtrl.checkForDuplicates($value)\' }"> <span ng-if="$onlineSwitchModalCtrl.duplicate && $onlineSwitchModalCtrl.newType === \'local\'" class="help-block basic-block" translate="modules.personnel.dossier.administration.changeAccountType.emailDuplicate"></span></div></div><div class="col-sm-6"><div class="form-group clearfix"><label for="contactEmail" class="control-label" translate="modules.personnel.dossier.administration.changeAccountType.contactEmail"></label> <input type="email" class="form-control" name="contactEmail" id="contactEmail" ng-model="$onlineSwitchModalCtrl.searchedUser.ContactEMail"></div></div></div></div></div><div class="modal-body" ng-if="$onlineSwitchModalCtrl.newType === \'offline\'"><h5 class="modal-subtitle"><i class="ion-mail"></i> <span>Details des neuen Offline-Accounts</span></h5><div class="row"><div class="col-sm-12"><div class="alert bg-warning"><h4>Hinweis</h4><strong>Das Mitglied wird jedweder Material- & Freigabeverantwortung enthoben. Weiterhin werden alle Einsatzleiter- bzw. Terminverantwortlichkeiten des Mitglieds aus zuk\xFCnftigen Terminen & Diensten entfernt. Letzteres hat jedoch keine Auswirkung auf die eigentliche Teilnahme an Terminen & Diensten. Bitte organisieren Sie, sofern zutreffend, Ersatzverantwortliche f\xFCr Materialien, Freigaben, Termine und Dienste. Das Mitglied verliert alle zugewiesenen Berechtigungen. Alle ausstehenden Gliederungseinladungen werden automatisch angenommen.</strong></div></div><div class="col-sm-12"><div class="form-group clearfix"><label for="contactEmail" class="control-label">Kontakt E-Mail (optional)</label> <input type="email" class="form-control" name="contactEmail" ng-model="$onlineSwitchModalCtrl.newOffline.ContactEMail"></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$onlineSwitchModalCtrl.modalInstance.close(0)" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" ng-disabled="($onlineSwitchModalCtrl.newType === \'local\' && ($onlineSwitchModalCtrl.invalidInput || $onlineSwitchModalCtrl.duplicate)) || (!$onlineSwitchModalCtrl.userIdentifiers && $onlineSwitchModalCtrl.newType !== \'offline\')" class="btn btn-primary btn-with-icon" ng-click="$onlineSwitchModalCtrl.finishLinking(1)" translate="generalTerms.resume"><i class="ion-checkmark-round"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/clearance/clearance.html','<div class="tab-content"><div class="row btns-row"><div class="col-xs-12"><button class="btn btn-primary btn-with-icon" ng-if="$ctrl.permittedToStartAnyClearance" ng-click="$ctrl.approvalprocessModal(\'add\')"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.clearance.addClearance"></span></button></div></div><approval-process-list approval-processes="$ctrl.approvalProcesses" affected-member-id="$ctrl.dossierOwnerId" show-member-name="false" disallow-edit="$ctrl.ctx[0] === \'rootOrg\'" ctx="$ctrl.ctx" allow-export="false" allowed-references="$ctrl.allowedReferences" table-config="$ctrl.tableConfig" member-groups="$ctrl.memberGroups" only-demand-for-action="false"></approval-process-list><div class="row btns-row"><div class="col-md-12"><button ng-show="$ctrl.isPermitted(\'arno.personnel.personnelList.view\')" ng-if="!$ctrl.backToOverview && $ctrl.backToPersonnelList" type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToPersonnelList"></span></button> <button ng-if="$ctrl.backToOverview" type="button" ui-sref="arno.personnel.dossier.overview" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToOverview"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/baseData.html','<div class="tab-content"><form id="baseDataForm" name="$baseData.baseDataForm" class="arno__personnel__dossier__basedata" novalidate="" angular-validator="" angular-validator-submit="$baseData.updateBaseData()"><div ng-if="::$baseData.isPermitted(\'arno.personnel.dossier.baseData.manage\', true)"><h3 class="with-line" toggle-next="$baseData.toggleSection.division" toggle-skip-next-animation="$baseData.toggleSectionSkip.division">{{\'modules.personnel.dossier.baseData.divisionInfo\' | translate}}</h3><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="inputSince" class="control-label" translate="modules.personnel.dossier.baseData.memberSince"></label><div class="input-group"><input type="text" name="inputSince" class="form-control" uib-datepicker-popup="{{$baseData.datepicker.format}}" datepicker-options="$baseData.datepicker.options" ng-blur="$baseData.divisionMember.MemberSince = $baseData.moment($baseData.divisionMember.MemberSince).toDate()" invalid-message="\'modules.personnel.dossier.baseData.dateInvalidMessage\' | translate" ng-model="$baseData.divisionMember.MemberSince" is-open="$baseData.openedSince" close-text="{{(\'modules.personnel.dossier.baseData.closeText\' | translate )}}" show-button-bar="false" ng-disabled="!$baseData.canEdit"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$baseData.openedSince = !$baseData.openedSince"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'divisionMemberStatusValidation\', \'angularValidator\', true)}"><label class="control-label required-label" translate="modules.personnel.dossier.baseData.memberStatus"></label><tag-picker class="--ui-select-dropdown-width-fix" data-cy="personnel-dossier-basedata-choice-memberstatus" default-label="(\'modules.personnel.dossier.baseData.defaultLabel\' | translate)" tags="$baseData.MEMBER_STATUSES" selected-tags="$baseData.divisionMember.MemberStatus" disabled="!$baseData.canEdit"></tag-picker><input type="hidden" class="form-control" name="divisionMemberStatusValidation" ng-model="$baseData.memberStatusEmpty" ng-model-options="{ debounce: 200 }" validator="$baseData.checkRequiredData($baseData.divisionMember.MemberStatus)" invalid-message="\'\'"><span ng-messages="$baseData.hasErrorClass($baseData.baseDataForm, \'divisionMemberStatusValidation\', [\'required\', \'angularValidator\'], true)" role="alert" class="control-label"><span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.statusMissing"></span></span></div><div ng-if="$baseData.showDivisionMemberHelperFields()" class="form-group col-xs-12 col-sm-6 col-md-3"><label for="helperIdNumber" class="control-label" translate="modules.personnel.dossier.baseData.helperIdNumber"></label> <input data-cy="personnel-dossier-masterdata-helper-idnumber" type="text" class="form-control" placeholder="" ng-model="$baseData.divisionMember.HelperIdNumber" name="helperIdNumber" ng-disabled="!$baseData.canEdit"></div><div ng-if="$baseData.showDivisionMemberHelperFields()" class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputHelperIdValidUntil" class="control-label" translate="modules.personnel.dossier.baseData.helperIdValidUntil"></label><div class="input-group"><input type="text" name="inputHelperIdValidUntil" class="form-control" uib-datepicker-popup="{{$baseData.datepicker.format}}" datepicker-options="$baseData.datepicker.helperIdValidOptions" ng-blur="$baseData.divisionMember.HelperIdValidUntil = $baseData.moment($baseData.divisionMember.HelperIdValidUntil).toDate()" invalid-message="\'Das eingegebene Datum ist ung\xFCltig!\'" ng-model="$baseData.divisionMember.HelperIdValidUntil" is-open="$baseData.openedHelperIdValidUntil" close-text="{{(\'modules.personnel.dossier.baseData.closeText\' | translate )}}" show-button-bar="false" ng-disabled="!$baseData.canEdit"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$baseData.openedHelperIdValidUntil = !$baseData.openedHelperIdValidUntil"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.membership" toggle-skip-next-animation="$baseData.toggleSectionSkip.membership">{{\'modules.personnel.dossier.baseData.membershipInfo\' | translate}}</h3><div class="row"><div class="col-xs-12"><div class="row"><div class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputMainDiv" class="control-label" translate="models.Division"></label><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.divisionTootipText\' | translate )}}"></arno-ba-help-tooltip><ui-select name="selectMainDiv" ng-model="$baseData.member.MainDivision" search-enabled="true" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><ui-select-match placeholder="{{(\'modules.personnel.dossier.baseData.selectDivisionPlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.availableDivs | filter: $select.search"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div><div class="form-group col-xs-12 col-sm-6 col-md-3" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'selectMemberTypeHidden\', \'angularValidator\')}"><label class="control-label required-label" translate="modules.personnel.dossier.baseData.membershipType"></label><ui-select name="selectMemberType" ng-model="$baseData.member.MemberType" ng-model-options="{ debounce: 200 }" class="btn-group bootstrap-select form-control --ui-select-dropdown-width-fix" ng-disabled="!$baseData.canEdit" ng-required="false"><ui-select-match data-cy="personnel-dossier-basedata-choice-membertype" placeholder="{{(\'modules.personnel.dossier.baseData.membershipTypePlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.MEMBER_TYPES"><span ng-bind="item.Name"></span></ui-select-choices></ui-select><input type="hidden" ng-if="$baseData.canEdit" class="form-control" name="selectMemberTypeHidden" ng-model="$baseData.memberTypeEmpty" validator="$baseData.checkRequiredData($baseData.member.MemberType)" invalid-message="\'\'"> <label ng-messages="$baseData.hasErrorClass($baseData.baseDataForm , \'selectMemberTypeHidden\', \'angularValidator\')" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.dossier.baseData.membershipTypeMissing"></span></label></div><div class="form-group col-xs-12 col-sm-6 col-md-3 clearfix" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'memberNumber\', \'angularValidator\')}"><label for="memberNumber" class="control-label" ng-class="{\'required-label\': $baseData.isMemberNumberRequired($baseData.member.MemberType)}" translate="modules.personnel.dossier.baseData.memberNumber"></label> <input data-cy="personnel-dossier-masterdata-membernumber" type="text" class="form-control" id="memberNumber" placeholder="" name="memberNumber" ng-model="$baseData.member.MemberNumber" ng-disabled="!$baseData.canEdit" validator="!$baseData.isMemberNumberRequired($baseData.member.MemberType) || !!$baseData.member.MemberNumber" invalid-message="\'\'"> <label ng-messages="$baseData.hasErrorClass($baseData.baseDataForm , \'memberNumber\', \'angularValidator\')" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.dossier.baseData.memberNumberMissing"></span></label></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="form-group"><label for="inputJoiningDate" class="control-label" translate="modules.personnel.dossier.baseData.joiningDate"></label><div class="input-group"><input type="text" name="inputJoiningDate" class="form-control" uib-datepicker-popup="{{$baseData.datepicker.format}}" datepicker-options="$baseData.datepicker.options" ng-blur="$baseData.member.JoiningDate = $baseData.moment($baseData.member.JoiningDate).toDate()" invalid-message="\'modules.personnel.dossier.baseData.dateInvalidMessage\' | translate" ng-model="$baseData.member.JoiningDate" is-open="$baseData.openedJoiningDate" close-text="\'modules.personnel.dossier.baseData.closeText\' | translate" show-button-bar="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" ng-required="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$baseData.openedJoiningDate = !$baseData.openedJoiningDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group col-xs-12 col-sm-6 col-md-3 clearfix"><label for="staffNumber" class="control-label" translate="modules.personnel.dossier.baseData.personnelNumber"></label> <input data-cy="personnel-dossier-masterdata-staffnumber" type="text" class="form-control" placeholder="" ng-model="$baseData.member.StaffNumber" name="staffNumber" ng-disabled="!$baseData.canEdit"></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.nameAndAddress" toggle-skip-next-animation="$baseData.toggleSectionSkip.nameAndAddress">{{\'modules.personnel.dossier.baseData.nameAndAddressInfo\' | translate}}</h3><div class="row"><div class="col-md-6"><div class="row clearfix"><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm , \'selectMemberSalutation\', \'required\')}"><label for="selectMemberSalutation" class="control-label required-label" translate="modules.personnel.dossier.baseData.salutation"></label><ui-select name="selectMemberSalutation" ng-model="$baseData.member.Salutation" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" ng-required="true"><ui-select-match data-cy="personnel-dossier-basedata-choice-membersalutations" placeholder="{{(\'modules.personnel.dossier.baseData.salutationPlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.MEMBER_SALUTATIONS"><span ng-bind="item.Name"></span></ui-select-choices></ui-select><label ng-messages="$baseData.hasErrorClass($baseData.baseDataForm , \'selectMemberSalutation\', \'required\')" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.dossier.baseData.salutationMissing"></span></label></div><div class="form-group col-xs-12 col-sm-6"><label for="inputTitle" class="control-label" translate="modules.personnel.dossier.baseData.memberTitle"><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.memberTitleTooltip\' | translate )}}"></arno-ba-help-tooltip></label><ui-select name="selectMemberTitle" ng-model="$baseData.member.Title" search-enabled="true" tagging="$baseData.tagTransform" tagging-label="false" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><ui-select-match placeholder="{{(\'modules.personnel.dossier.baseData.memberTitlePlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.MEMBER_TITLES | filter: $select.search"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div></div><div class="row clearfix"><div class="form-group col-xs-12"><label for="inputMailSalutation" class="control-label" translate="modules.personnel.dossier.baseData.mailSalutation"></label> <input data-cy="personnel-dossier-masterdata-mail-salutation" type="text" class="form-control" placeholder="" ng-model="$baseData.member.MailSalutation" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div></div><div class="row clearfix"><div class="form-group col-xs-12 col-sm-6"><label for="inputFirstName" class="control-label required-label" translate="modules.personnel.dossier.baseData.firstName"></label> <input data-cy="personnel-dossier-masterdata-firstname" maxlength="254" type="text" class="form-control" id="inputFirstName" name="inputFirstName" placeholder="" ng-model="$baseData.member.FirstName" ng-disabled="$baseData.isADUser || (!$baseData.canEdit && !$baseData.canEditOwn)" required-message="\'modules.personnel.dossier.baseData.firstNameMissing\' | translate" required=""></div><div class="form-group col-xs-12 col-sm-6"><label for="inputLastName" class="control-label required-label" translate="modules.personnel.dossier.baseData.lastName"></label> <input data-cy="personnel-dossier-masterdata-lastname" maxlength="254" type="text" class="form-control" id="inputLastName" name="inputLastName" placeholder="" ng-model="$baseData.member.LastName" ng-disabled="$baseData.isADUser || (!$baseData.canEdit && !$baseData.canEditOwn)" required-message="\'modules.personnel.dossier.baseData.lastNameMissing\' | translate" required=""></div></div><div class="row clearfix"><div class="form-group col-xs-12"><label for="inputNameAffix" class="control-label" translate="modules.personnel.dossier.baseData.nameAffix"></label> <input data-cy="personnel-dossier-masterdata-name-affix" type="text" class="form-control" name="inputNameAffix" placeholder="" ng-model="$baseData.member.NameAffix" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div></div><arno-ba-address class="row clearfix" address="$baseData.member.address" form-ref="$baseData.baseDataForm" country-ids-catalogue="$baseData.MEMBER_COUNTRY_IDS" fields-config="$baseData.memberAddressCompFieldsConfig" ui-config="$baseData.memberAddressCompUiConfig" view-only="!$baseData.canEdit && !$baseData.canEditOwn"></arno-ba-address><div class="row clearfix"><div class="form-group col-sm-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm , \'inputBirthDate\', [\'required\'])}"><label for="inputBirthDate" class="control-label required-label" translate="modules.personnel.dossier.baseData.birthDate"></label><p class="input-group"><input data-cy="personnel-dossier-masterdata-birthdate" type="text" id="inputBirthDate" name="inputBirthDate" class="form-control" uib-datepicker-popup="{{$baseData.datepicker.format}}" datepicker-options="$baseData.datepicker.options" ng-model="$baseData.member.BirthDate" is-open="$baseData.openedDatepickerBirthDate" close-text="{{(\'modules.personnel.dossier.baseData.closeText\' | translate )}}" show-button-bar="false" ng-blur="$baseData.member.BirthDate = $baseData.moment($baseData.member.BirthDate).toDate()" invalid-message="\'modules.personnel.dossier.baseData.birthDateInvalidMessage\' | translate" ng-required="true" required-message="\'modules.personnel.dossier.baseData.birthDateRequiredMessage\' | translate" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"> <span class="input-group-btn"><button data-cy="personnel-dossier-masterdata-calender-birthdate" type="button" class="btn btn-default" ng-click="$baseData.openedDatepickerBirthDate = !$baseData.openedDatepickerBirthDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="form-group col-sm-6"><label for="inputBirthLocation" class="control-label" translate="modules.personnel.dossier.baseData.birthLocation"></label> <input data-cy="personnel-dossier-masterdata-birthlocation" maxlength="254" type="text" class="form-control" id="inputBirthLocation" placeholder="" ng-model="$baseData.member.BirthLocation" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div></div><div class="row clearfix"><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm , \'selectMemberGender\', \'required\')}"><label for="selectMemberGender" class="control-label required-label" translate="modules.personnel.dossier.baseData.gender"></label><ui-select data-cy="personnel-dossier-basedata-choice-gender-select" name="selectMemberGender" ng-model="$baseData.member.Gender" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" ng-required="true"><ui-select-match data-cy="personnel-dossier-basedata-choice-gender-match" placeholder="{{(\'modules.personnel.dossier.baseData.genderPlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices data-cy="personnel-dossier-basedata-choice-gender" position="down" repeat="item in $baseData.MEMBER_GENDERS"><span ng-bind="item.Name"></span></ui-select-choices></ui-select><label ng-messages="$baseData.hasErrorClass($baseData.baseDataForm , \'selectMemberGender\', \'required\')" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.dossier.baseData.genderRequiredMessage"></span></label></div><div class="form-group col-xs-12 col-sm-6"><label for="selectMemberConfession" class="control-label" translate="modules.personnel.dossier.baseData.confession"></label><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.confessionTooltip\' | translate )}}"></arno-ba-help-tooltip><ui-select name="selectMemberConfession" ng-model="$baseData.member.Confession" tagging="$baseData.tagTransform" tagging-label="false" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><ui-select-match data-cy="personnel-dossier-basedata-choice-confession" placeholder="{{(\'modules.personnel.dossier.baseData.confessionPlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.MEMBER_CONFESSIONS"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><div class="col-xs-12 col-sm-6"><label for="selectMemberNationality" class="control-label" translate="modules.personnel.dossier.baseData.nationality"></label><ui-select name="selectMemberNationality" ng-model="$baseData.member.Nationality" search-enabled="true" class="btn-group bootstrap-select form-control" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><ui-select-match placeholder="{{(\'modules.personnel.dossier.baseData.nationalityPlaceholder\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseData.MEMBER_NATIONALITIES | filter: $select.search"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-12 control-label" translate="modules.personnel.dossier.baseData.profilePicture"></label><div class="col-sm-12"><div class="userpic" ng-class="{editable:($baseData.canEdit || $baseData.canEditOwn)}" ng-click="$baseData.openProfilePicEditor()"><div class="userpic-wrapper"><img profile-picture="$baseData.profilePictureData"></div><a href="" class="change-userpic" ng-if="$baseData.canEdit || $baseData.canEditOwn" translate="modules.personnel.dossier.baseData.changeProfilePicture"></a></div></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.contact" toggle-skip-next-animation="$baseData.toggleSectionSkip.contact">{{\'modules.personnel.dossier.baseData.contactInfo\' | translate}}</h3><div class="row"><div class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputPhone" class="control-label" translate="modules.personnel.dossier.baseData.phone"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><a href="{{ $baseData.member.Phone | asTel }}" ng-if="$baseData.member.Phone" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-phone"></i></a> <input data-cy="personnel-dossier-masterdata-phone" type="text" class="form-control" placeholder="" name="inputPhone" ng-model="$baseData.member.Phone" validator="$baseData.checkPhoneNumber($baseData.member.Phone)" invalid-message="\'modules.personnel.dossier.baseData.phoneInvalidMessage\' | translate" ng-required="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputPhoneWork" class="control-label" translate="modules.personnel.dossier.baseData.phoneWork"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><a href="{{ $baseData.member.PhoneWork | asTel }}" ng-if="$baseData.member.PhoneWork" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-phone"></i></a> <input data-cy="personnel-dossier-masterdata-phonework" type="text" class="form-control" name="inputPhoneWork" placeholder="" ng-model="$baseData.member.PhoneWork" validator="$baseData.checkPhoneNumber($baseData.member.PhoneWork)" invalid-message="\'modules.personnel.dossier.baseData.phoneInvalidMessage\' | translate" ng-required="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputMobilePhone" class="control-label" translate="modules.personnel.dossier.baseData.mobilePhone"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><a href="{{ $baseData.member.Mobile | asTel }}" ng-if="$baseData.member.Mobile" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-phone"></i></a> <input data-cy="personnel-dossier-masterdata-mobile" type="text" class="form-control" id="inputMobilePhone" name="inputMobilePhone" placeholder="" ng-model="$baseData.member.Mobile" validator="$baseData.checkPhoneNumber($baseData.member.Mobile)" invalid-message="\'modules.personnel.dossier.baseData.phoneInvalidMessage\' | translate" ng-required="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-sm-6 col-md-3"><label for="inputMobilePhoneWork" class="control-label" translate="modules.personnel.dossier.baseData.mobilePhoneWork"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><a href="{{ $baseData.member.MobileWork | asTel }}" ng-if="$baseData.member.MobileWork" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-phone"></i></a> <input data-cy="personnel-dossier-masterdata-mobilework" type="text" class="form-control" name="inputMobilePhoneWork" placeholder="" ng-model="$baseData.member.MobileWork" validator="$baseData.checkPhoneNumber($baseData.member.MobileWork)" invalid-message="\'modules.personnel.dossier.baseData.phoneInvalidMessage\' | translate" ng-required="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="col-xs-12"><div class="row clearfix"><div class="form-group col-xs-12 col-md-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, [\'inputEmail3\', \'inputEmail3-1\'], [\'required\', \'email\'])}"><label for="inputEmail3{{$baseData.account.Type !== \'offline\' ? \'-1\' : \'\'}}" class="control-label">{{$baseData.account.Type === \'offline\' ? (\'models.Member.ContactEMail\' | translate) : (\'models.Account.EMail\' | translate) }}</label> <a href="{{ \'mailto:\' + ($baseData.account.Type === \'offline\' ? $baseData.member.ContactEMail : $baseData.account.EMail) }}" ng-if="$baseData.account.Type === \'offline\' ? $baseData.member.ContactEMail : $baseData.account.EMail" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-envelope-o"></i></a><div class="input-group"><input data-cy="personnel-dossier-masterdata-contactemail" type="email" class="form-control" id="inputEmail3" name="inputEmail3" placeholder="" ng-if="$baseData.account.Type === \'offline\'" ng-model="$baseData.member.ContactEMail" invalid-message="\'modules.personnel.dossier.baseData.emailInvalidMessage\' | translate" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"> <input data-cy="personnel-dossier-masterdata-contactemail-account" type="email" class="form-control" id="inputEmail3-1" name="inputEmail3-1" placeholder="" ng-if="$baseData.account.Type !== \'offline\'" ng-model="$baseData.account.EMail" disabled="" ng-required="true" required-message="\'modules.personnel.dossier.baseData.emailRequiredMessage\' | translate" invalid-message="\'modules.personnel.dossier.baseData.emailInvalidMessage\' | translate"> <span ng-if="$root.ctx.currentUser.loginType === \'local\' && $baseData.ownDossier && ($baseData.hasAllowedAge || $baseData.canEdit)" class="input-group-btn"><button data-cy="personnel-dossier-masterdata-button-contactemail" type="button" ng-click="$baseData.changeEMail()" class="btn btn-default btn-with-icon"><i class="ion-edit"></i><span translate="modules.personnel.dossier.baseData.editEmail"></span></button></span></div></div><div class="form-group col-xs-12 col-md-6" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'memberAdditionalEmailsValidation\', \'angularValidator\', true)}"><label class="control-label" translate="modules.personnel.dossier.baseData.additionalEmails"></label><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.additionalEmailsTooltip\' | translate )}}"></arno-ba-help-tooltip><span class="mt-6 pull-right" uib-dropdown=""><button type="button" uib-dropdown-toggle="" class="btn btn-xs btn-default"><i class="fa fa-envelope-o"></i></button> <span class="list-group list-group-flush" uib-dropdown-menu=""><a class="list-group-item" style="border: 0px" ng-repeat="additionalEMail in $baseData.member.AdditionalEMails" href="{{ \'mailto:\' + additionalEMail.mapping }}">{{additionalEMail.Name}}</a></span></span><ui-select multiple="" name="memberAdditionalEmails" ng-model="$baseData.member.AdditionalEMails" tagging="$baseData.tagTransform" tagging-label="false" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" class="form-control arno-tag-picker-select"><ui-select-match placeholder="{{(\'modules.personnel.dossier.baseData.additionalEmailsPlaceholder\' | translate )}}"><span class="arno-tag-picker-single-tag" ng-style="$baseData.setColor($item)">{{$item.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="item in []">{{item.Name}}</ui-select-choices></ui-select><input type="hidden" class="form-control" name="memberAdditionalEmailsValidation" ng-model="$baseData.memberAdditionalEMailsEmpty" ng-model-options="{ debounce: 200 }" validator="$baseData.checkEmails($baseData.member.AdditionalEMails)" invalid-message="\'\'"><span ng-messages="$baseData.hasErrorClass($baseData.baseDataForm, \'memberAdditionalEmailsValidation\', \'angularValidator\', true)" role="alert" class="control-label"><span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.checkEmailMessage"></span></span></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.profession" toggle-skip-next-animation="$baseData.toggleSectionSkip.profession">{{\'modules.personnel.dossier.baseData.profession\' | translate}}</h3><div class="row clearfix"><div class="form-group col-sm-12 col-sm-6"><label for="inputOccupation" class="control-label" translate="modules.personnel.dossier.baseData.occupation"></label> <input data-cy="personnel-dossier-masterdata-profession" maxlength="254" type="text" class="form-control" id="inputOccupation" placeholder="" ng-model="$baseData.member.Profession" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="col-xs-12 mt-15"><h5 translate="modules.personnel.dossier.baseData.employerInfo"></h5></div><div class="row"><div class="col-xs-12"><div class="form-group col-xs-12 col-sm-6"><label for="inputMemberEmployerName" class="control-label" translate="modules.personnel.dossier.baseData.employerName"></label> <input data-cy="personnel-dossier-masterdata-employername" type="text" class="form-control" name="inputMemberEmployerName" placeholder="" ng-model="$baseData.member.EmployerName" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-sm-6"><label for="inputMemberEmployerContactPerson" class="control-label" translate="modules.personnel.dossier.baseData.employerContactPerson"></label> <input data-cy="personnel-dossier-masterdata-employercontactperson" type="text" class="form-control" name="inputMemberEmployerContactPerson" placeholder="" ng-model="$baseData.member.EmployerContactPerson" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><arno-ba-address class="row" address="$baseData.member.employerAddress" form-ref="$baseData.baseDataForm" fields-config="$baseData.memberEmployerAddressCompFieldsConfig" ui-config="$baseData.memberEmployerAddressCompUiConfig" view-only="!$baseData.canEdit && !$baseData.canEditOwn"></arno-ba-address><div class="form-group col-xs-12 col-md-6"><label for="inputMemberEmployerEmail" class="control-label" translate="modules.personnel.dossier.baseData.employerEmail"></label> <a href="{{ \'mailto:\' + $baseData.member.EmployerEmail }}" ng-if="$baseData.member.EmployerEmail" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-envelope-o"></i></a> <input data-cy="personnel-dossier-masterdata-employeremail" type="email" class="form-control" name="inputMemberEmployerEmail" invalid-message="\'modules.personnel.dossier.baseData.emailInvalidMessage\' | translate" placeholder="" ng-model="$baseData.member.EmployerEmail" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-md-6"><label for="inputMemberEmployerPhone" class="control-label" translate="modules.personnel.dossier.baseData.employerPhone"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><a href="{{ $baseData.member.EmployerPhone | asTel }}" ng-if="$baseData.member.EmployerPhone" class="btn btn-xs btn-default mt-6 pull-right"><i class="fa fa-phone"></i></a> <input data-cy="personnel-dossier-masterdata-employerphonenumber" type="text" class="form-control" name="inputMemberEmployerPhone" placeholder="" validator="$baseData.checkPhoneNumber($baseData.member.EmployerPhone)" invalid-message="\'modules.personnel.dossier.baseData.phoneInvalidMessage\' | translate" ng-required="false" ng-model="$baseData.member.EmployerPhone" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div><div class="form-group col-xs-12 col-md-12"><label class="control-label" translate="models.Member.EmployerActivitiesLabel"></label><arno-ba-help-tooltip text="{{\'models.Member.EmployerActivitiesTooltip\' | translate}}"></arno-ba-help-tooltip><tag-picker class="--ui-select-dropdown-width-fix" data-cy="personnel-dossier-masterdata-employeractivities" tags="$baseData.EmployerActivities" selected-tags="$baseData.choosenEmployerActivities" disabled="!$baseData.canEdit && !$baseData.canEditOwn"></tag-picker></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.emergency" toggle-skip-next-animation="$baseData.toggleSectionSkip.emergency">{{\'modules.personnel.dossier.baseData.emergencyContacts\' | translate}}</h3><div class="row mb-15"><arno-personnel-dossier-basedata-emergency-contacts emergency-contacts="$baseData.member.EmergencyContacts" form-ref="$baseData.baseDataForm" view-only="!$baseData.canEdit && !$baseData.canEditOwn"></arno-personnel-dossier-basedata-emergency-contacts></div><h3 class="with-line" toggle-next="$baseData.toggleSection.languages" toggle-skip-next-animation="$baseData.toggleSectionSkip.languages">{{\'modules.personnel.dossier.baseData.languages\' | translate}}</h3><fieldset class="row" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><div class="form-group col-xs-12"><arno-personnel-dossier-basedata-languages language-skills="$baseData.member.LanguageSkills" languages-catalogue="$baseData.MEMBER_LANGUAGES" view-only="!$baseData.canEdit && !$baseData.canEditOwn"></arno-personnel-dossier-basedata-languages></div></fieldset><h3 class="with-line" toggle-next="$baseData.toggleSection.misc" toggle-skip-next-animation="$baseData.toggleSectionSkip.misc">{{\'modules.personnel.dossier.baseData.otherInformation\' | translate}}</h3><fieldset class="row" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"><div class="form-group col-xs-12"><label for="inputMemberAdditionalNotes" class="control-label" translate="modules.personnel.dossier.baseData.notes"></label> <textarea data-cy="personnel-dossier-masterdata-additionalnotes" class="form-control --vresize" name="inputMemberAdditionalNotes" placeholder="" ng-model="$baseData.member.AdditionalNotes"></textarea></div><div class="form-group col-xs-12" ng-show="$baseData.isPermitted(\'arno.personnel.dossier.baseData.sensitiveData.manage\') || $baseData.ownDossier"><label class="control-label" translate="models.Member.SensitiveData"></label><arno-ba-help-tooltip text="{{ \'modules.personnel.dossier.baseData.sensitiveDataTooltip\' | translate }}"></arno-ba-help-tooltip><textarea class="form-control --vresize" name="inputMemberSensitiveData" placeholder="" ng-model="$baseData.sensitiveData"></textarea></div></fieldset><div ng-show="$baseData.canEdit || $baseData.ownDossier || $baseData.account.Type === \'offline\' || $baseData.banktransfer === \'transfer\'"><h3 class="with-line" toggle-next="$baseData.toggleSection.banking" toggle-skip-next-animation="$baseData.toggleSectionSkip.banking">{{\'modules.personnel.dossier.baseData.banking\' | translate}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-show="$baseData.canEdit || $baseData.ownDossier || $baseData.account.Type === \'offline\'"><label class="col-sm-12 control-label">{{$baseData.ownDossier ? (\'modules.personnel.dossier.baseData.bankingInfoText\' | translate ) : (\'modules.personnel.dossier.baseData.bankingInfoText\' | translate:{ member: ($baseData.member.FirstName + \' \' + $baseData.member.LastName) } ) }} <small class="clearfix"><strong>{{ (\'modules.personnel.dossier.baseData.note\' | translate) }}:</strong> {{ (\'modules.personnel.dossier.baseData.bankingInfoNoteText1\' | translate) }} <strong>"{{ (\'modules.personnel.dossier.baseData.bankTransfer\' | translate) }}"</strong> {{ (\'modules.personnel.dossier.baseData.bankingInfoNoteText2\' | translate) }} <strong>"{{ (\'modules.personnel.dossier.baseData.payMethodCash\' | translate) }}"</strong> {{ (\'modules.personnel.dossier.baseData.bankingInfoNoteText3\' | translate) }}</small></label><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input data-cy="personnel-dossier-masterdata-radio-banktransfer-transfer" class="form-control" type="radio" name="radioOptions" id="bankRadio1" value="transfer" ng-model="$baseData.banktransfer" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"> <span translate="modules.personnel.dossier.baseData.bankTransfer"></span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input data-cy="personnel-dossier-masterdata-radio-banktransfer-cash" class="form-control" type="radio" name="radioOptions" id="bankRadio2" value="cash" ng-model="$baseData.banktransfer" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"> <span translate="modules.personnel.dossier.baseData.cash"></span></label></div></div><div ng-if="$baseData.banktransfer === \'transfer\'"><div class="form-group row clearfix"><label for="inputBankName" class="col-sm-12 control-label" translate="modules.personnel.dossier.baseData.bankName"></label><div class="col-sm-12"><input data-cy="personnel-dossier-masterdata-bankaccount" type="text" class="form-control" id="inputBankName" placeholder="" ng-model="$baseData.member.BankAccount" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn"></div></div><div class="form-group row clearfix" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'inputIBAN\', [\'required\', \'angularValidator\'], true)}"><label for="inputIBAN" class="col-sm-12 control-label" translate="modules.personnel.dossier.baseData.iban"></label><div class="col-sm-12"><input data-cy="personnel-dossier-masterdata-bankiban" type="text" class="form-control" id="inputIBAN" name="inputIBAN" placeholder="" ng-model="$baseData.member.BankIBAN" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" required-message="\'\'" invalid-message="\'\'" validator="$baseData.validIBAN($baseData.member.BankIBAN)" ng-required="true"><span ng-messages="$baseData.hasErrorClass($baseData.baseDataForm, \'inputIBAN\', [\'required\', \'angularValidator\'], true)" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.dossier.baseData.ibanRequiredMessage"></span> <span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.ibanInvalidMessage"></span></span></div></div><div class="form-group row clearfix" ng-class="{\'has-error\': $baseData.hasErrorClass($baseData.baseDataForm, \'inputBIC\', [\'angularValidator\'], true)}"><label for="inputBIC" class="col-sm-12 control-label" translate="modules.personnel.dossier.baseData.bic"></label><div class="col-sm-12"><input data-cy="personnel-dossier-masterdata-bankbic" type="text" class="form-control" id="inputBIC" placeholder="" name="inputBIC" ng-model="$baseData.member.BankBIC" ng-disabled="!$baseData.canEdit && !$baseData.canEditOwn" invalid-message="\'\'" validator="!$baseData.member.BankBIC || $baseData.validBIC($baseData.member.BankBIC)"><span ng-messages="$baseData.hasErrorClass($baseData.baseDataForm, \'inputBIC\', [\'angularValidator\'], true)" role="alert" class="control-label"><span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.bicInvalidMessage"></span></span></div></div></div></div></div></div><h3 class="with-line" toggle-next="$baseData.toggleSection.legal" toggle-skip-next-animation="$baseData.toggleSectionSkip.legal">{{\'modules.personnel.dossier.baseData.legal\' | translate}}</h3><div class="row"><div class="col-xs-12 col-sm-6 col-md-3"><table class="table table-condensed" ng-if="$baseData.member.PrivacyTermsDeliveredDateTime"><head><tr><th colspan="2"><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOver"></strong></th></tr></head><tbody><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverOn"></strong></td><td>{{$baseData.moment($baseData.member.PrivacyTermsDeliveredDateTime).format(\'DD.MM.YYYY # HH:mm\').replace(\'#\', \'um\')}} Uhr</td></tr><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverBy"></strong></td><td>{{$baseData.member.PrivacyTermsDeliveredPerson}}</td></tr><tr><td><strong translate="modules.personnel.dossier.baseData.privacyPolicyHandedOverVia"></strong></td><td>{{$baseData.privacyTermsChannelMap[$baseData.member.PrivacyTermsDeliveredChannel]}}</td></tr></tbody></table><p ng-if="!$baseData.member.PrivacyTermsDeliveredDateTime"><strong class="text-warning" translate="modules.personnel.dossier.baseData.privacyPolicyWarning"></strong></p></div></div><div class="row btns-row mt-20"><div class="col-md-12"><button data-cy="personnel-dossier-masterdata-back" type="button" ng-if="!$baseData.backToOverview && $baseData.backToPersonnelList" ng-show="$baseData.isPermitted(\'arno.personnel.personnelList.view\')" ng-click="$baseData.back()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.baseData.toPersonnelList"></span></button> <button data-cy="personnel-dossier-masterdata-backToOverview" ng-if="$baseData.backToOverview" type="button" ng-click="$baseData.backOverview()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.baseData.backToOverview"></span></button> <button data-cy="personnel-dossier-masterdata-save" type="submit" ng-click="$baseData.hasError()" class="btn btn-primary btn-with-icon pull-right" ng-if="$baseData.canEdit || $baseData.canEditOwn" ng-disabled="$baseData.actionInProgress"><i class="ion-checkmark"></i> <span translate="modules.personnel.dossier.baseData.save"></span></button> <button data-cy="personnel-dossier-masterdata-cancel" type="button" ng-click="$baseData.cancel()" class="btn btn-default btn-with-icon pull-right mr-10" ng-if="$baseData.baseDataForm.$dirty" ng-disabled="$baseData.actionInProgress"><i class="ion-close"></i> <span translate="modules.personnel.dossier.baseData.cancel"></span></button></div></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/fileStorage/fileStorage.html','<div class="tab-content"><div class="col-xs-12 mt-20 mb-20" ng-show="$fs.infoboxTextContent"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.fileStorage.info\' | translate}}</h3><div ng-bind-html="$fs.infoboxTextContent"></div></div><div><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.fileStorage.fileStorage\' | translate}}</h3><div class="row"><file-storage is-own-dossier="$fs.isOwnDossier" item-id="$fs.dossierOwner.id" storage-ident="\'dossier\'" ctx="$fs.ctx" folder-data="$fs.folderData" edit-permission="\'arno.personnel.files.edit\'"></file-storage></div></div><div class="row btns-row"><div class="col-md-12"><button type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span class="hidden-xs" translate="modules.personnel.dossier.general.backToPersonnelList"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/helperHours/helperHours.html','<div class="tab-content"><div ng-if="$helperCtrl.isPermittedOrOwn(\'arno.personnel.dossier.helperHours.view\', false)"><h3 class="with-line" toggle-next="">{{\'modules.helperHours.hours.volunteerHoursOverview\' |translate}}</h3><div><div class="mb-20"><div class="btn-group dropdown mr-10" uib-dropdown="" dropdown-append-to-body=""><div class="btn-group" role="group"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span ng-if="!$helperCtrl.dateSpan && $helperCtrl.daysInPast">{{\'modules.helperHours.hours.noteOfTheLastDayOne\' |translate}} {{ $helperCtrl.daysInPast }} {{\'modules.helperHours.hours.noteOfTheLastDayTwo\' |translate}}</span> <span ng-if="!$helperCtrl.dateSpan && !$helperCtrl.daysInPast" translate="modules.helperHours.hours.allNotes"></span> <span ng-if="$helperCtrl.dateSpan">{{ $helperCtrl.dateSpan.start | date:\'dd.MM.yyyy\'}} - {{ $helperCtrl.dateSpan.end | date:\'dd.MM.yyyy\'}}</span> <span class="ml-10 caret"></span></button><ul uib-dropdown-menu="" role="menu"><li role="menuitem" ng-repeat="i in [7,31,365,null]"><a href="" ng-if="i" ng-click="$helperCtrl.daysInPast = i; $helperCtrl.dateSpan = null; $helperCtrl.reloadHelperHours()" translate="modules.helperHours.hours.lastDays" translate-values="{ days: i }">Letzte {{ i }} Tage</a> <a href="" ng-if="!i" ng-click="$helperCtrl.daysInPast = null; $helperCtrl.dateSpan = null; $helperCtrl.reloadHelperHours()" translate="modules.helperHours.hours.allEntries">Alle Eintr\xE4ge</a></li></ul></div><button type="button" class="btn btn-default" ng-click="$helperCtrl.openDatespanModal()"><span><i class="ion-wrench"></i></span></button></div><div uib-dropdown="" dropdown-toggle="" class="inline"><button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="hidden-xs hidden-sm" translate="modules.helperHours.hours.reasonsProSite"></span> ({{ $helperCtrl.itemsPerPage }}) <span class="caret"></span></button><ul uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="i in [5,10,20,50]"><a href="" ng-click="$helperCtrl.setPageSize(i)">{{ i }}</a></li></ul></div><div ng-if="$helperCtrl.isPermittedOrOwn(\'arno.personnel.dossier.helperHours.edit\')" class="pull-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$helperCtrl.createNewRecord()"><i class="ion-plus"></i> <span translate="modules.helperHours.hours.trackVolunteerHours"></span></button></div></div><div class="table-responsive mb-15"><table st-table="$helperCtrl.helperHours" st-pipe="$helperCtrl.reloadHelperHours" class="table table-condensed table-hover"><thead><tr class="sortable"><th></th><th st-sort="Title" translate="modules.helperHours.hours.title"></th><th st-sort="ActivityStartDate" st-sort-default="reverse" translate="modules.helperHours.hours.date"></th><th st-sort="ActivityMinutes" translate="modules.helperHours.hours.hourNumbers"></th><th st-sort="Activity" translate="modules.helperHours.hours.volunteerActivity"></th><th translate="modules.helperHours.hours.categories"></th><th translate="modules.helperHours.hours.notice"></th><th ng-if="$helperCtrl.dossierCtx === \'rootOrg\'" translate="modules.helperHours.hours.div"></th><th translate="generalTerms.actions"></th></tr><tr><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Title" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Activity" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="BaseCategory" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Note" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$helperCtrl.dossierCtx === \'rootOrg\'"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$helperCtrl.helperHours && $helperCtrl.helperHours.length" ng-repeat="row in $helperCtrl.helperHours"><td><status-light class="\'light-inline\'" is-green="row.Approved" is-yellow="!row.Approved" use-one-light="true" use-yellow-light="true" yellow-title="modules.helperHours.hours.noRelease" green-title="modules.helperHours.hours.release"></status-light></td><td class="align-left-force">{{ row.Title }}</td><td class="align-left-force">{{ row.ActivityStartDate | date:\'dd.MM.yyyy\' }}</td><td class="align-left-force">{{ $helperCtrl.formatDuration(row.ActivityMinutes) | date:\'dd.MM.yyyy\' }}</td><td class="align-left-force">{{ row.Activity.Title }}</td><td class="align-left-force"><span ng-repeat="tag in row.BaseCategories" ng-style="$helperCtrl.setColor(tag.Color)" class="ui-select-match-item btn-default btn-xs mr-5"><span class="arno-tag-picker-single-tag">{{ tag.Name }}</span></span></td><td class="align-left-force text-overflow overflow-title arno-overflow-cell">{{ row.Note }}</td><td class="align-left-force" ng-if="$helperCtrl.dossierCtx === \'rootOrg\'">{{ row.Division.Name }}</td><td><div class="nowrap"><button ng-if="$helperCtrl.checkEditPermission(row)" class="btn btn-default btn-with-icon btn-xs" ng-click="$helperCtrl.editRecord(row)" title="{{\'modules.helperHours.hours.editEntry\' |translate}}"><i class="ion-edit"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></button> <button ng-if="$helperCtrl.checkEditPermission(row)" class="btn btn-danger btn-with-icon btn-xs" ng-click="$helperCtrl.deleteRecord(row)" title="{{\'modules.helperHours.hours.deleteEntry\' |translate}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!$helperCtrl.helperHours || !$helperCtrl.helperHours.length"><td class="text-center" colspan="99"><i translate="modules.helperHours.hours.noVolunteerEntryExisst"></i></td></tr></tbody><tfoot><tr><td colspan="99" class="text-center"><st-pagination st-items-by-page="$helperCtrl.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div><div class="mt-20 mb-10" ng-if="$helperCtrl.totalRows"><hr><div class="arno-helper-hours-status"><div class="display-flex"><h3 class="text-center">{{ $helperCtrl.totalTimeSpent }}h</h3><span class="mt-2"><span translate="modules.helperHours.hours.releaseHours"></span></span></div><div class="display-flex"><h3 class="text-center">{{ $helperCtrl.totalRows }}</h3><span class="mt-2" translate="modules.helperHours.hours.entries"></span></div></div></div></div><h3 class="with-line" toggle-next="">{{\'modules.helperHours.hours.HelperHourStatistics\' |translate}}</h3><div><statistic-helper-hours current-data="$helperCtrl.helperHoursStatisticData" provider="$helperCtrl.statisticalDataProvider" collapse-filter="$helperCtrl.collapseFilter" division-ids="$helperCtrl.dossierCtx"></statistic-helper-hours></div><div class="row btns-row"><div class="col-md-12"><button type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span class="hidden-xs" translate="modules.personnel.dossier.general.backToPersonnelList"></span></button></div></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/notAssigned/notAssigned.html','<div class="arno-no-division-member"><div class="person-missing"><i class="ion-android-person"></i><i class="ion-help"></i></div><div class="missing-text" ng-if="$notAssigned.unknownMember.fullName">{{ \'modules.personnel.dossier.notAssigned.text1\' | translate:$notAssigned.translationData }}<br>{{ \'modules.personnel.dossier.notAssigned.text2\' | translate }}</div><div class="missing-text" ng-if="!$notAssigned.unknownMember.fullName" translate="modules.personnel.dossier.notAssigned.unknownMember"></div></div>');
$templateCache.put('app/pages/personnel/dossier/overview/overview.html','<div class="tab-content"><div class="overview-section" ng-if="$over.isPermittedOrOwn(\'arno.personnel.dossier.baseData\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.tabs.baseData\' | translate}}</h3><div class="row"><div class="col-sm-6 col-md-8"><div class="form-group"><table cellspacing="0" cellpadding="0" class="col-md-6 --no-border"><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.MemberNumber"></b>:</label></td><td><span ng-if="$over.member.MemberNumber" ng-bind="$over.member.MemberNumber"></span> <i ng-if="!$over.member.MemberNumber" translate="modules.personnel.dossier.general.notSpecified"></i></td></tr><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.Salutation"></b>:</label></td><td><span ng-if="$over.member.Salutation" ng-bind="$over.SALUTATION_LABELS[$over.member.Salutation] || $over.member.Salutation"></span> <i ng-if="!$over.member.Salutation" translate="modules.personnel.dossier.general.notSpecified"></i></td></tr><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.Title"></b>:</label></td><td><span ng-if="$over.member.Title" ng-bind="$over.MEMBER_TITLES[$over.member.Title] || $over.member.Title"></span> <i ng-if="!$over.member.Title" translate="modules.personnel.dossier.general.notSpecified"></i></td></tr><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.FirstName"></b>:</label></td><td>{{ $over.member.FirstName }}</td></tr><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.LastName"></b>:</label></td><td>{{ $over.member.LastName }}</td></tr><tr><td><label class="col-sm-12 control-label"><b translate="models.Member.BirthDate"></b>:</label></td><td><span ng-if="$over.member.BirthDate">{{ $over.member.BirthDate | date: \'dd.MM.yyyy\' : \'UTC\' }}</span> <i ng-if="!$over.member.BirthDate" translate="modules.personnel.dossier.general.notSpecified"></i></td></tr></table></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-click="$over.open(\'arno.personnel.dossier.baseData\');" ng-if="$over.isPermitted(\'arno.personnel.dossier.baseData\')" class="btn btn-default btn-with-icon"><i class="fa fa-eye"></i><span translate="modules.personnel.dossier.overview.showAndEdit" translate-values="{ edit: $over.isPermitted(\'arno.personnel.dossier.baseData.manage\') }"></span></button> <button class="btn btn-default btn-with-icon" ng-if="$over.isPermitted(\'arno.personnel.dossier.baseData.manage\')" ng-click="$over.exportVCard()" title="Visitenkarte exportieren"><i class="fa fa-address-card-o"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.overview.vCard"></span></button></div></div></div><div class="col-sm-6 col-md-4"><div class="userpic" style="float:right; margin-top: 8px;"><div class="userpic-wrapper"><img profile-picture="$over.profilePictureData" size="345" font-size="16"></div></div></div></div></div><div class="overview-section" ng-if="$over.isPermittedOrOwn(\'arno.personnel.dossier.activity\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.tabs.activity\' | translate}}</h3><div class="row"><div class="col-md-12"><div ng-switch="$over.isOrgScope" class="form-group"><div class="horizontal-scroll"><div class="table-reponsive"><table ng-switch-when="true" class="table table-condensed table-hover"><col width="15%"><col width="10%"><col width="30px"><thead><tr class="black-muted-bg"><th class="align-left-force" translate="modules.personnel.dossier.activity.occupationGroup"></th><th translate="modules.personnel.dossier.activity.state"></th><th></th><th class="align-left-force" translate="modules.personnel.dossier.activity.name"></th><th class="align-left-force" translate="generalTerms.division"></th><th translate="modules.personnel.dossier.activity.characteristic"></th><th translate="modules.personnel.dossier.activity.assignedUntilLastActive"></th></tr></thead><tbody ng-repeat="activitiesByGroup in $over.activityHistoryByGroup"><tr ng-repeat="activityAllocation in activitiesByGroup.activityAllocations | orderBy: \'calculatedState\' | groupBy: \'activity.ActivityGroup.id\'"><td ng-if="activityAllocation.byGroupNewItem" rowspan="{{1 + activityAllocation.byGroup.unchangedFor}}" class="align-left-force">{{activityAllocation.activity.ActivityGroup.Title}}</td><td class="white-space-nowrap"><span ng-if="activityAllocation.calculatedState === \'ACTIVE\'" translate="modules.personnel.dossier.activity.active"><i class="ion-checkmark text-success"></i></span> <span ng-if="activityAllocation.calculatedState === \'INACTIVE\'" translate="modules.personnel.dossier.activity.inactive"><i class="ion-close-round text-danger"></i></span> <span ng-if="activityAllocation.calculatedState === \'PENDING\'" translate="modules.personnel.dossier.activity.pending"><i class="fa fa-spinner"></i></span></td><td><status-light ng-if="activityAllocation && activityAllocation.Characteristic" is-green="($over.allActivityFulfillmentStates && $over.allActivityFulfillmentStates[activityAllocation.DivisionMember.Division.id][activityAllocation.activity.id])" class="\'light-inline light-pad-right\'"></status-light></td><td>{{activityAllocation.activity.Title}}</td><td><span ng-bind="activityAllocation.DivisionMember.Division.Name"></span></td><td class="align-left-force">{{ activityAllocation.Characteristic ? (\'modules.personnel.charMap.\' + activityAllocation.Characteristic | translate) : \'\'}}</td><td>{{(activityAllocation.ActivityAllocationPeriods [activityAllocation.ActivityAllocationPeriods.length - 1].EndDate | date:\'dd.MM.yyyy\') || (activityAllocation.calculatedState === \'ACTIVE\' ? (\'modules.personnel.dossier.overview.unlimited\' | translate) : (\'modules.personnel.dossier.overview.never\' | translate)) }}</td></tr></tbody><tbody><tr ng-if="!$over.activityHistory.length"><td class="align-center" colspan="100"><i translate="modules.personnel.dossier.overview.noOccupations"></i></td></tr></tbody></table></div></div><table ng-switch-default="" class="table table-condensed table-hover"><thead><tr class="black-muted-bg"><th class="align-left-force" translate="modules.personnel.dossier.activity.occupationGroup"></th><th translate="modules.personnel.dossier.activity.state"></th><th class="align-left-force" translate="modules.personnel.dossier.activity.name"></th><th translate="modules.personnel.dossier.activity.characteristic"></th><th translate="modules.personnel.dossier.activity.assignedUntilLastActive"></th></tr></thead><tbody ng-repeat="activitiesByGroup in $over.activityHistoryByGroup"><tr ng-repeat="activityAllocation in activitiesByGroup.activityAllocations | orderBy: \'calculatedState\' | groupBy: \'activity.ActivityGroup.id\'"><td ng-if="activityAllocation.byGroupNewItem" rowspan="{{1 + activityAllocation.byGroup.unchangedFor}}" class="align-left-force">{{activityAllocation.activity.ActivityGroup.Title}}</td><td class="align-left-force"><span ng-if="activityAllocation.calculatedState === \'ACTIVE\'" translate="modules.personnel.dossier.activity.active"><i class="ion-checkmark text-success"></i></span> <span ng-if="activityAllocation.calculatedState === \'INACTIVE\'" translate="modules.personnel.dossier.activity.inactive"><i class="ion-close-round text-danger"></i></span> <span ng-if="activityAllocation.calculatedState === \'PENDING\'" translate="modules.personnel.dossier.activity.pending"><i class="fa fa-spinner"></i></span></td><td class="align-left-force"><status-light ng-if="activityAllocation && activityAllocation.Characteristic" is-green="($over.activityFulfillmentStates && $over.activityFulfillmentStates[activityAllocation.activity.id])" class="\'light-inline light-pad-right\'"></status-light>{{activityAllocation.activity.Title}}</td><td class="align-left-force">{{ activityAllocation.Characteristic ? (\'modules.personnel.charMap.\' + activityAllocation.Characteristic | translate) : \'\'}}</td><td ng-if="(activityAllocation.calculatedState === \'ACTIVE\' || activityAllocation.calculatedState === \'INACTIVE\')">{{(activityAllocation.ActivityAllocationPeriods [activityAllocation.ActivityAllocationPeriods.length - 1].EndDate | date:\'dd.MM.yyyy\') || (activityAllocation.calculatedState === \'ACTIVE\' ? (\'modules.personnel.dossier.overview.unlimited\' | translate) : (\'modules.personnel.dossier.overview.never\' | translate)) }}</td><td ng-if="activityAllocation.calculatedState === \'PENDING\'"></td></tr></tbody><tbody><tr ng-if="!$over.activityHistory.length"><td class="align-center" colspan="100"><i translate="modules.personnel.dossier.overview.noOccupations"></i></td></tr></tbody></table></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-if="$over.isPermitted(\'arno.personnel.dossier.activity\')" ng-click="$over.open(\'arno.personnel.dossier.activity\')" class="btn btn-default btn-with-icon"><i class="fa fa-eye"></i><span translate="modules.personnel.dossier.overview.showAndEdit" translate-values="{ edit: ($over.isPermitted(\'arno.personnel.dossier.activity.assign\')|| $over.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\')) }"></span></button></div></div></div></div></div><div class="overview-section" ng-if="$over.isPermittedOrOwn(\'arno.personnel.dossier.qualification\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.tabs.qualifications\' | translate}}</h3><div class="row"><div class="col-md-12"><div class="form-group"><qualification-list always-show="true" qualification-list-member-data="true" qualification-only-view="true" qualification-list="$over.userQualifications" qualification-states="[{ title: (\'modules.personnel.dossier.overview.qualifications\' | translate), intext: (\'modules.personnel.dossier.overview.qualificationsInText\' | translate), showSectionHeader: false }]" qualification-delete="false" division-ids="$over.divisionIds" member="$over.member"></qualification-list></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-if="$over.isPermitted(\'arno.personnel.dossier.qualification\')" ng-click="$over.open(\'arno.personnel.dossier.qualification\')" class="btn btn-default btn-with-icon"><i class="fa fa-eye"></i><span translate="modules.personnel.dossier.overview.showAndEdit" translate-values="{ edit: $over.isPermitted(\'arno.personnel.dossier.qualification.manageAll\') }"></span></button></div></div></div></div></div><div class="overview-section" ng-if="$over.isPermittedOrOwn(\'arno.personnel.dossier.trainings\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.tabs.trainings\' | translate}}</h3><div class="row"><div class="col-md-12"><div class="form-group"><arno-personnel-dossier-trainings-table-panel selected-ctx="$over.ctx" member="$over.member" categories="$over.trainingCategories" is-overview="true"></arno-personnel-dossier-trainings-table-panel></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-if="$over.isPermitted(\'arno.personnel.dossier.trainings\')" ng-click="$over.open(\'arno.personnel.dossier.trainings.main\')" class="btn btn-default btn-with-icon"><i class="fa fa-eye"></i><span translate="modules.personnel.dossier.overview.showAndEdit" translate-values="{ edit: $over.isPermitted(\'arno.personnel.dossier.trainings.manage\') }"></span></button></div></div></div></div></div><div class="overview-section" ng-if="$over.isPermittedOrOwn(\'arno.personnel.dossier.clearance\')"><h3 class="with-line" toggle-next="">{{\'modules.personnel.dossier.tabs.clearance\' | translate}}</h3><div class="row"><div class="col-md-12"><div class="form-group"><approval-process-list approval-processes="$over.approvalProcesses" affected-member-id="$over.member.id" ctx="$over.ctx" table-config="$over.tableConfig" show-member-name="false" disallow-edit="true" only-demand-for-action="false" allow-export="false"></approval-process-list></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-if="$over.isPermitted(\'arno.personnel.dossier.clearance\')" ng-click="$over.open(\'arno.personnel.dossier.clearance\')" class="btn btn-default btn-with-icon"><i class="fa fa-eye"></i><span translate="modules.personnel.dossier.overview.showAndEdit" translate-values="{ edit: $over.permittedToStartAnyClearance }"></span></button></div></div></div></div></div><div class="overview-section" ng-if="!$over.isPermittedOrOwn(\'arno.personnel.dossier.baseData\') && !$over.isPermittedOrOwn(\'arno.personnel.dossier.activity\', true) && !$over.isPermittedOrOwn(\'arno.personnel.dossier.qualification\') && !$over.isPermittedOrOwn(\'arno.personnel.dossier.clearance\')"><p translate="modules.personnel.dossier.overview.restrictedPermissions"></p></div><div class="row btns-row"><div class="col-md-12"><button type="button" ng-show="$over.isPermitted(\'arno.personnel.personnelList.view\')" ng-if="$over.backToPersonnelList" ng-click="$over.back()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToPersonnelList"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/qualification/qualification.html','<div class="tab-content"><qualification-list ng-if="!$qual.reloadQual" qualification-list-member-data="true" qualification-only-view="!$qual.hasEditRights" qualification-list="$qual.userQualifications" qualification-add="$qual.choosableQualifications" qualification-delete="true" always-show="true" css-configs="{ addQualificationBottomBarClass: \'col-md-6\' }" qualification-change-model="$qual.changedQualifications" qualification-translations="$qual.translateValues" instruction-materials="$qual.availableMaterials" division-ids="$qual.divisionIds" member="$qual.member" is-own-dossier="$qual.isOwnDossier"></qualification-list><div class="row btns-row"><div class="col-md-12"><button type="button" ng-if="$qual.isPermitted(\'arno.personnel.personnelList.view\') && !$qual.backToOverview && $qual.backToPersonnelList" ng-click="$qual.back()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToPersonnelList"></span></button> <button ng-if="$qual.backToOverview" type="button" ng-click="$qual.backOverview()" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToOverview"></span></button> <button data-cy="personnel-dossier-qualification-save" type="button" class="btn btn-primary btn-with-icon" ng-click="$qual.updateQualification()" ng-if="::$qual.getShowElement(\'actions\',[])"><i class="ion-checkmark"></i><span translate="generalTerms.save"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainings.tpl.html','<div class="tab-content" arno-acl="" acl-ctx="$trainingsCtrl.selectedCtx" acl-scope="\'Division\'"><div class="row arno__personnel__dossier__trainings__wrapper mb-10"><div class="col-xs-12"><div class="row arno__personnel__dossier__trainings__header-top-bar mb-10"><div class="col-xs-12"><h3 class="with-line" ng-if="$trainingsCtrl.hasViewPermission"><span class="hidden-xs" translate="modules.personnel.dossier.trainings.title"></span><div class="btn-group btn-group-toggle pull-right" data-toggle="buttons"><label class="btn btn-default" ng-class="{ \'active\': $trainingsCtrl.viewMode === $trainingsCtrl.TRAININGS.VIEWMODE.TABLE }" ng-click="$trainingsCtrl.changeViewMode($trainingsCtrl.TRAININGS.VIEWMODE.TABLE)"><i class="fa fa-table"></i> <input type="radio" name="recentTrainingsViewMode" autocomplete="off"> <span class="hidden-xs" translate="modules.personnel.dossier.trainings.tableView"></span></label> <label class="btn btn-default" ng-class="{ \'active\': $trainingsCtrl.viewMode === $trainingsCtrl.TRAININGS.VIEWMODE.TREE }" ng-click="$trainingsCtrl.changeViewMode($trainingsCtrl.TRAININGS.VIEWMODE.TREE)"><i class="fa fa-sitemap"></i> <input type="radio" name="recentTrainingsViewMode" autocomplete="off"> <span class="hidden-xs" translate="modules.personnel.dossier.trainings.treeView"></span></label></div></h3></div></div><div class="row"><div class="col-xs-12"><div ng-switch="$trainingsCtrl.viewMode"><div ng-switch-when="tableview"><arno-personnel-dossier-trainings-table-panel selected-ctx="$trainingsCtrl.selectedCtx" member="$trainingsCtrl.member" categories="$trainingsCtrl.trainingCategories"></arno-personnel-dossier-trainings-table-panel></div><div ng-switch-when="treeview"><arno-personnel-dossier-trainings-tree-panel selected-ctx="$trainingsCtrl.selectedCtx" member="$trainingsCtrl.member" trainings-tree="$trainingsCtrl.trainingsTree" categories="$trainingsCtrl.trainingCategories"></arno-personnel-dossier-trainings-tree-panel></div><div ng-switch-default="" class="text-center" translate="modules.personnel.dossier.trainings.chooseView"></div></div></div></div></div></div><div class="row btns-row mt-20"><div class="col-md-12"><button type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span class="hidden-xs" translate="modules.personnel.dossier.general.backToPersonnelList"></span></button><div class="pull-right"><button acl-grant="\'arno.administration.personnel.trainings.manage\'" acl-ctx="$trainingsCtrl.organizationId" acl-scope="\'Organization\'" type="button" ui-sref="arno.administration.personnel.trainings" class="btn btn-default btn-with-icon"><i class="ion-android-open"></i><span class="hidden-xs" translate="modules.personnel.dossier.trainings.templateAdmin"></span></button></div></div></div></div>');
$templateCache.put('app/pages/personnel/inviteAdd/modals/inviteData.html','<div modal="inviteDataCheck" class="modal-content personnel-add-modal" close="CloseModal()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.inviteList.inviteDataHeading"></h4></div><div class="modal-body"><div class="row" ng-if="!$inviteDataCtrl.matchIsDismissable"><div class="col-md-12 text-left"><div class="alert bg-warning"><h4 translate="modules.personnel.inviteList.inviteDataHeadline"></h4><p><strong>{{ (\'modules.personnel.inviteList.emailExists\' | translate:{ adress: $inviteDataCtrl.currentMember.Account.EMail }) }}</strong> <strong ng-if="$inviteDataCtrl.currentMember.toastr === \'differentOrgaExists\'">{{ (\'modules.personnel.inviteList.inOtherOrg\' | translate) }}</strong> <strong ng-if="$inviteDataCtrl.currentMember.toastr === \'sameOrgaExists\'">{{ (\'modules.personnel.inviteList.inOtherMember\' | translate) }}</strong> <strong ng-if="$inviteDataCtrl.currentMember.toastr === \'differentTypeExists\'">{{ (\'modules.personnel.inviteList.inOtherAccType\' | translate) }}</strong></p><p><strong>{{ (\'modules.personnel.inviteList.chooseDublicate\' | translate) }}</strong></p><p><strong>{{ (\'modules.personnel.inviteList.noLabeling\' | translate) }}</strong></p></div></div></div><table class="table table-condensed"><thead><tr class="black-muted-bg"><td colspan="3"><strong>{{ (\'modules.personnel.inviteList.newMember\' | translate) }}</strong></td></tr></thead><tbody><tr><td class="pt-12 underline" style="width:20%">{{ $inviteDataCtrl.currentMember.FirstName }} {{ $inviteDataCtrl.currentMember.LastName }}</td><td style="width:60%"><table class="table table-condensed"><tbody class="without-top-border"><tr ng-if="$inviteDataCtrl.currentMember.Account.Type === \'offline\' || $inviteDataCtrl.currentMember.Account.EMail"><td style="width:30%" translate="models.Account.EMail"></td><td style="width:70%">{{ $inviteDataCtrl.currentMember.Account.Type === \'offline\' ? \'-----\' : $inviteDataCtrl.currentMember.Account.EMail }}</td></tr><tr ng-if="$inviteDataCtrl.currentMember.StaffNumber"><td translate="models.Member.StaffNumber"></td><td>{{ $inviteDataCtrl.currentMember.StaffNumber }}</td></tr><tr ng-if="$inviteDataCtrl.currentMember.MemberNumber"><td translate="models.Member.MemberNumber"></td><td>{{ $inviteDataCtrl.currentMember.MemberNumber }}</td></tr></tbody></table></td><td></td></tr></tbody></table><table class="table table-condensed mt-20"><thead><tr class="black-muted-bg"><td colspan="3"><strong>{{ (\'modules.personnel.inviteList.potentialDublicates\' | translate:{ count: $inviteDataCtrl.currentMember.matches.length }) }}</strong></td></tr></thead><tbody><tr ng-repeat="selectedMatch in $inviteDataCtrl.currentMember.matches"><td class="pt-12 underline" style="width:20%">{{ selectedMatch.FirstName }} {{ selectedMatch.LastName }}</td><td style="width:60%"><table class="table table-condensed"><tbody class="without-top-border"><tr><td style="width:30%" translate="models.Account.EMail"></td><td style="width:70%">{{ selectedMatch.Account.Type === \'offline\' ? \'-----\' : selectedMatch.Account.EMail }}</td></tr><tr ng-if="selectedMatch.StaffNumber"><td translate="models.Member.StaffNumber"></td><td>{{ selectedMatch.StaffNumber }}</td></tr><tr ng-if="selectedMatch.MemberNumber"><td translate="models.Member.MemberNumber"></td><td>{{ selectedMatch.MemberNumber }}</td></tr><tr ng-if="selectedMatch.inviteStatus"><td translate="models.Invite.State"></td><td>{{ selectedMatch.inviteStatus === 1 ? (\'modules.personnel.inviteList.alreadyInvited\' | translate) : (\'modules.personnel.inviteList.alreadyMember\' | translate) }}</td></tr><tr ng-if="selectedMatch.isInDivisions.length"><td translate="modules.personnel.inviteList.representedInDiv"></td><td>{{ selectedMatch.isInDivisions.join(\', \') }}{{ selectedMatch.isInMoreDivisions ? (\'modules.personnel.inviteList.andOthers\' | translate) : \'\'}}</td></tr><tr ng-if="selectedMatch.isInvitedInDivisions.length"><td translate="modules.personnel.inviteList.invitedInDiv"></td><td>{{ selectedMatch.isInvitedInDivisions.join(\', \') }}{{ selectedMatch.isInvitedMoreDivisions ? (\'modules.personnel.inviteList.andOthers\' | translate) : \'\'}}</td></tr><tr ng-if="$inviteDataCtrl.currentMember.Account.Type !== selectedMatch.Account.Type"><td translate="models.Account.Type"></td><td>{{ $inviteDataCtrl.displayTypeOf(selectedMatch.Account.Type) + \' \' + (\'models.Member\' | translate) }}</td></tr></tbody></table></td><td class="vertical-align-bottom align-right"><button type="button" class="btn btn-info btn-with-icon btn-sm" ng-click="$inviteDataCtrl.acceptMatch(selectedMatch)"><i class="fa fa-clone"></i> {{ (\'modules.personnel.inviteList.dublicate\' | translate) }}</button></td></tr></tbody></table></div><div class="modal-footer"><div class="row" ng-if="$inviteDataCtrl.matchIsDismissable"><div class="col-md-6 text-left"><button type="button" class="btn btn-default btn-with-icon" ng-click="$inviteDataCtrl.close()"><i class="ion-ios-trash"></i> {{ (\'modules.personnel.inviteList.discardInvite\' | translate) }}</button></div><div class="col-md-6 text-right"><button type="button" class="btn btn-success btn-with-icon" ng-click="$inviteDataCtrl.dismissMatch()"><i class="ion-checkmark-round"></i> {{ (\'modules.personnel.inviteList.noDublicate\' | translate) }}</button></div></div><div class="row" ng-if="!$inviteDataCtrl.matchIsDismissable"><div class="col-md-12"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$inviteDataCtrl.close()"><i class="ion-ios-trash"></i> {{ (\'modules.personnel.inviteList.discardInvite\' | translate) }}</button></div></div></div></div>');
$templateCache.put('app/pages/personnel/inviteAdd/modals/inviteImport.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.inviteList.importModalTitle"></h4></div><div class="modal-body pt-0"><div class="alert bg-warning">{{ (\'modules.personnel.inviteList.infoText\' | translate) }}</div><button type="button" class="btn btn-info mb-15" ng-click="$inviteImportModalCtrl.downloadTemplate()"><span class="glyphicon glyphicon-download"></span> {{ (\'modules.personnel.inviteList.downloadBtnText\' | translate) }}</button><div class="well" nv-file-drop="" nv-file-over="" over-class="" uploader="$inviteImportModalCtrl.uploader"><span translate="modules.personnel.inviteList.dragAndDropText"></span><div class="mt-10"><input type="file" id="inputFile" nv-file-select="" uploader="$inviteImportModalCtrl.uploader"></div></div><table class="table"><tbody><tr ng-repeat="item in $inviteImportModalCtrl.uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="$inviteImportModalCtrl.uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td width="30%" ng-show="$inviteImportModalCtrl.uploader.isHTML5"><div class="progress"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div></td><td class="text-center"><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok text-success"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle text-danger"></i></span> <span ng-show="item.isError" title="{{ (\'modules.personnel.inviteList.uploadErr\' | translate) }}"><i class="glyphicon glyphicon-remove text-danger"></i></span></td></tr></tbody></table><div ng-if="$inviteImportModalCtrl.enableCheckbox"><label class="custom-checkbox"><input class="from-control" ng-click="$inviteImportModalCtrl.validate(true)" type="checkbox"> <span translate="modules.personnel.inviteList.assuranceText"></span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" ng-disabled="$inviteImportModalCtrl.okDisabled" class="btn btn-primary" ng-click="$inviteImportModalCtrl.applyModal()">OK</button></div></div>');
$templateCache.put('app/pages/personnel/inviteAdd/modals/showMemberData.html','<div class="modal-content personnel-show-member-data"><div class="modal-body"><div class="row"><div class="col-md-12"><h3 class="with-line with-icon text-center act-selection-heading"><i class="fa fa-flag-checkered"></i> {{ (\'modules.personnel.inviteList.showMemberDataHeading\' | translate) }}</h3><div class="alert bg-warning" ng-if="$showCtrl.showDifferingTypeAlert()"><h4 translate="modules.personnel.inviteList.dublicateWarningHeadline"></h4><p translate="modules.personnel.inviteList.dublicateWarningParagraph1"></p><p>{{ (\'modules.personnel.inviteList.dublicateWarningParagraph2\' | translate) }} <strong>{{ (\'modules.personnel.inviteList.not\' | translate) }}</strong> {{ (\'modules.personnel.inviteList.dublicateWarningParagraph3\' | translate:{ accounttype: $showCtrl.utils.translateMemberAuthType($showCtrl.initialInviteType) }) }}</p></div><div class="table-responsive"><table st-table="$showCtrl.memberCollection" st-safe-src="$showCtrl.membersToAdd" class="table table-condensed table-hover"><thead><tr class="sortable"><th translate="models.Account.Type"></th><th translate="models.Account.EMail"></th><th translate="models.Member.FirstName"></th><th translate="models.Member.LastName"></th><th class="text-center"><i class="ion-ios-people-outline"></i> {{ (\'models.Invite.State\' | translate) }}</th><th class="arno-table-button-cell text-center" translate="generalTerms.actions"></th></tr><tr ng-if="$showCtrl.memberCollection.length > 1"><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Type" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="memberToAdd in $showCtrl.memberCollection" ng-class="{ \'notValid\' : memberToAdd.notValid || memberToAdd.matches || memberToAdd.toastr.length > 0 }"><td class="align-left-force"><i class="fa fa-exclamation-triangle text-warning pr-3" ng-if="$showCtrl.differingTypeAlert[memberToAdd[\'$$hashKey\']]"></i> <span>{{ ::$showCtrl.utils.translateMemberAuthType(memberToAdd.Account.Type) }}</span></td><td><span ng-if="memberToAdd.Account.Type !== \'offline\'">{{ memberToAdd.Account.EMail }}</span> <span ng-if="memberToAdd.Account.Type === \'offline\' && memberToAdd.ContactEMail.length > 4">{{ memberToAdd.ContactEMail }}</span> <span ng-if="memberToAdd.Account.Type === \'offline\' && !memberToAdd.ContactEMail">---</span></td><td><span>{{ ::memberToAdd.FirstName }}</span></td><td><span>{{ ::memberToAdd.LastName }}</span></td><td class="text-center inviteState"><span ng-if="memberToAdd.inviteStatus === false" translate="models.Invite.State.notPossible"></span> <span ng-if="memberToAdd.inviteStatus === 0" translate="models.Invite.State.invitePending"></span> <span ng-if="memberToAdd.inviteStatus === 1" translate="models.Invite.State.inviteSent"></span> <span ng-if="memberToAdd.inviteStatus === 2" translate="models.Invite.State.alreadyMember"></span></td><td class="arno-default-pointer text-center"><button class="btn btn-danger btn-with-icon btn-xs" ng-click="$showCtrl.removeMemberToAdd(memberToAdd, false)" title="{{\'modules.arnoDashboard.board.removeOfList\' |translate}}"><i class="ion-ios-trash"></i><span class="hidden-xs" translate="generalTerms.delete"></span></button></td></tr><tr ng-show="!$showCtrl.memberCollection.length"><td colspan="7" class="text-center"><i translate="modules.personnel.inviteList.noSelectablePerson"></i></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination st-items-by-page="$showCtrl.pageSize" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div></div></div><div class="modal-footer"><div class="row"><div class="col-md-6 text-left"><button type="button" class="btn btn-default btn-with-icon" ng-click="$showCtrl.close()"><i class="ion-close-round"></i> {{ (\'generalTerms.cancel\' | translate) }}</button></div><div class="col-md-6 text-right"><button type="button" class="btn btn-success btn-with-icon" ng-if="$showCtrl.membersToAdd.length && $showCtrl.hasSomethingToSend()" ng-click="$showCtrl.add()"><i class="ion-checkmark-round"></i> {{ (\'modules.personnel.inviteList.sent\' | translate) }}</button> <button type="button" class="btn btn-default btn-with-icon" ng-if="$showCtrl.membersToAdd.length && !$showCtrl.hasSomethingToSend()" ng-click="$showCtrl.add()"><i class="ion-checkmark-round"></i> {{ (\'generalTerms.ok\' | translate) }}</button></div></div></div></div>');
$templateCache.put('app/pages/personnel/inviteAdd/partials/offlineAndArnoUser.html','<div class="form-group clearfix"><div ng-if="$inviteAddCtrl.userType===\'local\' && $inviteAddCtrl.isDemo" class="alert bg-warning"><h4>Hinweis</h4><strong>In Demo-Organisationen sind Nutzeraccounts auf Offline Accounts beschr\xE4nkt.</strong></div><div class="row"><div class="col-md-12"><label for="firstname" class="required-label control-label" translate="models.Member.FirstName"></label> <input data-cy="personnel-inviteadd-firstname" id="firstname" type="text" tabindex="1" class="form-control" required="" ng-model="$inviteAddCtrl.newUser.FirstName" placeholder="{{ (\'models.Member.FirstName\' | translate) }}"></div></div><div class="row"><div class="col-md-12"><label for="lastname" class="required-label control-label" translate="models.Member.LastName"></label> <input data-cy="personnel-inviteadd-lastname" id="lastname" tabindex="2" type="text" class="form-control" required="" ng-model="$inviteAddCtrl.newUser.LastName" placeholder="{{ (\'models.Member.LastName\' | translate) }}"></div></div><div class="row" ng-if="$inviteAddCtrl.userType===\'local\'"><div class="col-md-12"><label for="email" class="required-label control-label" translate="models.Account.EMail"></label> <input data-cy="personnel-inviteadd-email" id="email" tabindex="3" type="email" class="form-control" required="" ng-model="$inviteAddCtrl.newUser.Account.EMail" placeholder="{{ (\'models.Account.EMail\' | translate) }}"></div></div><div class="row" ng-if="$inviteAddCtrl.userType===\'offline\'"><div class="col-md-12"><label for="contactEmail" class="control-label" translate="models.Member.ContactEMail"></label> <input data-cy="personnel-inviteadd-email" id="contactEmail" tabindex="3" type="email" class="form-control" ng-model="$inviteAddCtrl.newUser.ContactEMail" placeholder="{{ (\'models.Member.ContactEMail\' | translate) }}"></div></div><div class="row btns-row align-right"><div class="col-md-12 mb-0"><div class="smlBtn" ng-if="$inviteAddCtrl.userType===\'local\'"><button data-cy="personnel-inviteadd-check" ng-if="!$inviteAddCtrl.userChecked" tabindex="4" class="btn btn-primary btn-with-icon" type="button" ng-disabled="!$inviteAddCtrl.newUser.FirstName || !$inviteAddCtrl.newUser.LastName || !$inviteAddCtrl.newUser.Account.EMail || $inviteAddCtrl.isDemo" ng-click="$inviteAddCtrl.checkForDuplicates($inviteAddCtrl.newUser)" title="{{($inviteAddCtrl.isDemo ? \'Funktion nicht f\xFCr Demo-Organisationen verf\xFCgbar\' : \'\')}}"><i class="ion-wand"></i> {{ (\'modules.personnel.inviteList.inviteBtnText\' | translate) }}</button></div><div class="smlBtn" ng-if="$inviteAddCtrl.userType===\'offline\'"><button data-cy="personnel-inviteadd-check" ng-if="!$inviteAddCtrl.userChecked" tabindex="4" class="btn btn-primary btn-with-icon" type="button" ng-disabled="!$inviteAddCtrl.newUser.FirstName || !$inviteAddCtrl.newUser.LastName" ng-click="$inviteAddCtrl.checkForDuplicates($inviteAddCtrl.newUser)"><i class="ion-wand"></i> {{ (\'modules.personnel.inviteList.inviteBtnText\' | translate) }}</button></div></div></div></div>');
$templateCache.put('app/pages/personnel/personnelList/export/personnelChooseExportTypeModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.personnelList.exportModalTitle"></h4></div><div class="modal-body"><div class="section-block"><p><b translate="modules.personnel.personnelList.exportModalPrivacyNoteText"></b></p><div ng-bind-html="$chooseExportTypeCtrl.exportPrivacyNoteContent"></div><label class="custom-checkbox"><input type="checkbox" ng-model="$chooseExportTypeCtrl.readAndAccepted" class="custom-control-input"> <span translate="generalTerms.readAndAccepted"></span></label></div><form name="groupForm"><div ng-if="$chooseExportTypeCtrl.includeCalcOption" class="arno-personnel-list-custom-switcher"><div><ba-switcher class="arno-modeswitch" switcher-style="primary" switcher-value="$chooseExportTypeCtrl.liveCalc" switcher-keys="$chooseExportTypeCtrl.cKeys" switcher-width="130" switcher-hints="$chooseExportTypeCtrl.calcHints"></ba-switcher></div></div><div class="form-group"><ui-select ng-model="$chooseExportTypeCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $chooseExportTypeCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $chooseExportTypeCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div><div class="text-left"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" ng-model="$chooseExportTypeCtrl.fieldOption" value="tableConfig"> <span translate="modules.personnel.personnelList.exportModalTblConfRadio"></span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" ng-model="$chooseExportTypeCtrl.fieldOption" value="all"> <span translate="modules.personnel.personnelList.exportModalAllFieldsRadio"></span></label></div></div></div><div class="text-left mt-10"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio3" ng-model="$chooseExportTypeCtrl.filterOption" value="filtered"> <span translate="modules.personnel.personnelList.exportModalfilteredDataRadio"></span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio4" ng-model="$chooseExportTypeCtrl.filterOption" value="all"> <span translate="modules.personnel.personnelList.exportModalAllDataRadio"></span></label></div></div></div></form></div><div class="modal-footer"><button data-cy="personnel-personnellist-export-dismiss" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <span><button data-cy="personnel-personnellist-export-apply" type="button" class="btn btn-primary" ng-disabled="!$chooseExportTypeCtrl.readAndAccepted" ng-click="$chooseExportTypeCtrl.applyModal()" translate="generalTerms.download"></button></span></div></div>');
$templateCache.put('app/pages/personnel/personnelList/export/personnelQualificationExportModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.personnelList.exportModalTitle"></h4></div><div class="modal-body"><div class="section-block"><p><b translate="modules.personnel.personnelList.exportModalPrivacyNoteText"></b></p><div ng-bind-html="$qualificationExportTypeCtrl.exportPrivacyNoteContent"></div><label class="custom-checkbox"><input type="checkbox" ng-model="$qualificationExportTypeCtrl.readAndAccepted" class="custom-control-input"> <span translate="generalTerms.readAndAccepted"></span></label></div><form name="groupForm"><div class="form-group"><ui-select ng-model="$qualificationExportTypeCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $qualificationExportTypeCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $qualificationExportTypeCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <span><button type="button" class="btn btn-primary" ng-disabled="!$qualificationExportTypeCtrl.readAndAccepted" ng-click="$qualificationExportTypeCtrl.applyModal()" translate="generalTerms.download"></button></span></div></div>');
$templateCache.put('app/theme/components/approvalList/memberApprovalModal/memberApproval.html','<div class="modal-content"><form id="approvalForm" name="approvalForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title">Freigabe hinzuf\xFCgen</h4></div><div class="modal-body"><div class="form-group"><label for="acquireDate">Wann hat das Mitglied die Freigabe "{{$modalCtrl.approval.Name}}" erhalten?</label><div class="input-group"><input id="acquireDate" name="acquireDate" class="form-control" type="text" uib-datepicker-popup="{{$modalCtrl.datepicker.format}}" datepicker-options="$modalCtrl.datepicker.options" is-open="$modalCtrl.acquireDateOpened" close-text="Schlie\xDFen" show-button-bar="false" ng-model="$modalCtrl.approval.AcquireDate" ng-model-options="{ debounce: 200 }" required-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.noRefDate\' | translate)" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.acquireDateOpened = !$modalCtrl.acquireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="expireDate">Wann l\xE4uft die Freigabe "{{$modalCtrl.approval.Name}}" ab?</label><div class="input-group"><input id="expireDate" name="expireDate" class="form-control" type="text" uib-datepicker-popup="{{$modalCtrl.datepicker.format}}" datepicker-options="$modalCtrl.datepicker.options" is-open="$modalCtrl.expireDateOpened" close-text="Schlie\xDFen" show-button-bar="false" ng-model="$modalCtrl.approval.ExpireDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.expireDateOpened = !$modalCtrl.expireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Abbrechen</button> <button type="submit" class="btn btn-primary">Speichern</button></div></form></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalExportModal/approvalExport.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.approvals.exportModalTitle"></h4></div><div class="modal-body"><div class="section-block"><p><b translate="modules.personnel.approvals.exportModalPrivacyNoteText"></b></p><div ng-bind-html="$approvalExportCtrl.exportPrivacyNoteContent"></div><label class="custom-checkbox"><input type="checkbox" ng-model="$approvalExportCtrl.readAndAccepted" class="custom-control-input"> <span translate="generalTerms.readAndAccepted"></span></label></div><div class="text-left"><div class="section-block"><label class="custom-checkbox"><input type="checkbox" ng-model="$approvalExportCtrl.groupByOption" class="custom-control-input"> <span translate="modules.personnel.approvals.exportModalGroupByMember"></span></label></div><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" ng-model="$approvalExportCtrl.fieldOption" value="tableConfig"> <span translate="modules.personnel.approvals.exportModalTblConfRadio"></span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" ng-model="$approvalExportCtrl.fieldOption" value="all"> <span translate="modules.personnel.approvals.exportModalAllFieldsRadio"></span></label></div></div><div class="text-left mt-10"><div class="input-demo radio-demo row"><div ng-class="{\'col-md-4\': $approvalExportCtrl.hasSelection, \'col-md-6\': !$approvalExportCtrl.hasSelection}"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio3" ng-model="$approvalExportCtrl.filterOption" value="filtered"> <span translate="modules.personnel.approvals.exportModalfilteredDataRadio"></span></label></div><div ng-if="$approvalExportCtrl.hasSelection" class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio4" ng-model="$approvalExportCtrl.filterOption" value="selected"> <span translate="modules.personnel.approvals.exportModalSelectedDataRadio"></span></label></div><div ng-class="{\'col-md-4\': $approvalExportCtrl.hasSelection, \'col-md-6\': !$approvalExportCtrl.hasSelection}"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio5" ng-model="$approvalExportCtrl.filterOption" value="all"> <span translate="modules.personnel.approvals.exportModalAllDataRadio"></span></label></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <span><button type="button" class="btn btn-primary" ng-disabled="!$approvalExportCtrl.readAndAccepted" ng-click="$approvalExportCtrl.applyModal()" translate="generalTerms.download"></button></span></div></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalprocessModal/addApprovalprocess.html','<div class="modal-content"><form name="$ctrl.form" ba-rescue-panel="approvalprocessForm" novalidate="" ng-submit="$ctrl.saveApprovalprocess($ctrl.form)"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.approvals.addApprovalModalTitle"></h4></div><div class="modal-body"><div ng-if="!$ctrl.filteredApprovals.length || $ctrl.allApprovalsDisabled()"><h5 class="text-center mt-15 mb-15" translate="modules.personnel.approvals.noApprovalPlaceholder"></h5></div><div ng-if="$ctrl.filteredApprovals.length && !$ctrl.allApprovalsDisabled()"><div><div class="form-group" ng-class="{\'has-error\': $ctrl.hasError($ctrl.form, \'selectedApproval\', \'required\')}"><h5 class="modal-subtitle"><i class="fa fa-thumbs-o-up"></i> <span translate="modules.personnel.approvals.addApprovalSubTitle"></span></h5><ui-select required="" ng-model="$ctrl.selectedApproval" class="btn-group bootstrap-select form-control" name="selectedApproval" ng-disabled="false" search-enabled="true" ng-change="$ctrl.disableMembers($ctrl.selectedApproval)" ng-required="true"><ui-select-match placeholder="{{ \'modules.personnel.approvals.selectApprovalPlaceholder\' | translate }}"><span>{{ $ctrl.selectedApproval.Title }}</span></ui-select-match><ui-select-choices position="down" repeat="approval in $ctrl.filteredApprovals | filter: {$: $select.search}" ui-disable-choice="$ctrl.checkIfDisabledApproval(approval)" group-by="$ctrl.approvalGroupBy"><span>{{approval.Title}}</span> <span ng-show="approval.disabled" translate="modules.personnel.approvals.alreadyAdded"></span></ui-select-choices></ui-select><label ng-messages="$ctrl.hasError($ctrl.form, \'selectedApproval\', \'required\')" role="alert" class="control-label"><span ng-message="required" translate="modules.personnel.approvals.noApprovalSelectedErrMsg"></span></label></div><div ng-if="$ctrl.fixedMembers !== true" class="form-group mt-15"><h5 class="modal-subtitle"><i class="fa fa-thumbs-o-up"></i> <span translate="modules.personnel.approvals.addMembersSubtitle"></span></h5><div class="input-group"><ui-select ng-disabled="!$ctrl.selectedApproval" ng-model="$ctrl.selectedMember" class="btn-group bootstrap-select form-control" search-enabled="true" on-select="$ctrl.addMember()" spinner-enabled="true"><ui-select-match placeholder="{{ \'modules.personnel.approvals.selectMemberPlaceholder\' | translate }}">{{ $ctrl.selectedMember.fullName }}</ui-select-match><ui-select-choices position="down" repeat="member in $ctrl.divisionMembers" ui-disable-choice="member.selected || member.hint || $ctrl.checkIfDisabled(member, $ctrl.selectedApproval.id)" refresh="$ctrl.searchMembers($select.search)" refresh-delay="200" group-by="$ctrl.groupByFirstName"><span class="person-select" ng-if="!member.hint"><i ng-show="!member.disabledTooltip && !member.voidTooltip" class="ion-person"></i> <i ng-show="member.disabledTooltip && !member.voidTooltip" class="ion-close"></i> <i ng-show="member.voidTooltip" class="fa fa-exchange"></i> <span tooltip-enable="member.disabledTooltip || member.voidTooltip" uib-tooltip="{{(member.disabledTooltip || member.voidTooltip)}}" tooltip-placement="bottom" tooltip-append-to-body="true">{{member.fullName + \' (\' + member.Account.EMail + \')\'}}</span> <span ng-show="member.selected" style="color: #AAA; font-style: italic" translate="modules.personnel.approvals.alreadyAdded"></span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="modules.personnel.approvals.memberSelectHint"></span></span></ui-select-choices></ui-select></div></div></div><div ng-if="$ctrl.fixedMembers !== true" class="table-responsive"><table st-table="$ctrl.displayedCollection" st-safe-src="$ctrl.affectedMembers" class="table table-condensed table-hover"><thead><tr><th translate="models.Member.FirstName"></th><th translate="models.Member.LastName"></th><th translate="models.Account.EMail"></th><th translate="generalTerms.actions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="FirstName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="LastName" type="search" class="form-control with-default-addon input-sm"></div></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Account.EMail" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr class="arno-pointing-pointer" ng-repeat="member in $ctrl.displayedCollection"><td>{{ member.FirstName }}</td><td>{{ member.LastName }}</td><td>{{ member.Account.EMail }}</td><td class="arno-table-button-cell"><button class="btn btn-danger btn-block btn-with-icon btn-xs" ng-click="$ctrl.removeMember(member)"><i class="ion-ios-trash"></i><span class="btn-span hidden-xs" translate="generalTerms.remove"></span></button></td></tr><tr ng-if="!$ctrl.affectedMembers.length"><td colspan="4" class="text-center"><i translate="modules.personnel.approvals.noMembersAssigned"></i></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.affectedMembers.length" ng-if="$ctrl.filteredApprovals.length && !$ctrl.allApprovalsDisabled()">{{ (\'generalTerms.save\' | translate) }}</button></div></form></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalprocessModal/detailsApprovalprocess.html','<div class="modal-content"><form name="$ctrl.form" ba-rescue-panel="approvalprocessForm" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.approvals.detailModalTitle"></h4></div><div class="modal-body"><table class="table table-condensed mb-10"><tr><td>{{ (\'models.Approval\' | translate) }}:</td><td>{{$ctrl.approvalprocess.Approval.Title}}</td></tr><tr><td>{{ (\'generalTerms.description\' | translate) }}:</td><td>{{$ctrl.approvalprocess.Approval.Description}}</td></tr><tr><td>{{ (\'modules.personnel.approvals.affectedPerson\' | translate) }}:</td><td>{{$ctrl.approvalprocess.AffectedMember.fullName}}</td></tr><tr><td>{{ (\'models.Division\' | translate) }}:</td><td>{{$ctrl.approvalprocess.Division.Name || (\'modules.personnel.approvals.noDivision\' | translate)}}</td></tr><tr><td>{{ (\'modules.personnel.approvals.currentState\' | translate) }}:</td><td>{{$ctrl.approvalprocess.DisplayState}}</td></tr><tr><td></td><td></td></tr></table><div class="form-group"><div class="row" ng-repeat="(i, date) in $ctrl.dates"><div ng-hide="!date.value && (i == 1 || i == 2)" class="col-sm-12"><div class="form-group clearfix"><label for="inputDate" class="overflow-label" title="{{date.title}}">{{date.title}}</label><div class="input-group"><input type="text" id="inputDate" class="form-control arno-default-pointer" required="" uib-datepicker-popup="d!.M!.yyyy" datepicker-options="date.options" ng-model="date.value" is-open="date.isOpen" close-text="Schlie\xDFen" show-button-bar="false" ng-value="date.value | date: \'dd.MM.yyyy\'" disabled=""></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.return"></button></div></form></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalprocessModal/editApprovalprocess.html','<div class="modal-content"><form name="$ctrl.form" ba-rescue-panel="approvalprocessForm" novalidate=""><div class="modal-header"><h4 ng-if="$ctrl.approvalProccessMode == 0" class="modal-title">{{ ($ctrl.bulkApprovals ? (\'modules.personnel.approvals.editApprovalsModalTitle\' | translate:{ number: $ctrl.bulkApprovals.length } ) : (\'modules.personnel.approvals.editApprovalModalTitle\' | translate )) }}</h4><h4 ng-if="$ctrl.approvalProccessMode == 1" class="modal-title">{{ ($ctrl.bulkApprovals ? (\'modules.personnel.approvals.editApprovalsInspectionsModalTitle\' | translate:{ number: $ctrl.bulkApprovals.length } ) : (\'modules.personnel.approvals.editApprovalsInspectionsModalTitle\' | translate )) }}</h4><h4 ng-if="$ctrl.approvalProccessMode == 2" class="modal-title">{{ ($ctrl.bulkApprovals ? (\'modules.personnel.approvals.editApprovalsLetterModalTitle\' | translate:{ number: $ctrl.bulkApprovals.length } ) : (\'modules.personnel.approvals.editApprovalsLetterModalTitle\' | translate )) }}</h4></div><div class="modal-body"><div ng-if="$ctrl.approvalProccessMode == 2"><strong translate="modules.personnel.approvals.letterModalInfoBold"></strong> <span translate="modules.personnel.approvals.letterModalInfoText"></span><br><br></div><table ng-if="!$ctrl.bulkApprovals" class="table table-condensed mb-10 two-columns"><tr><td class="half-width">{{ (\'models.Approval\' | translate) }}:</td><td>{{$ctrl.approvalprocess.Approval.Title}}</td></tr><tr><td>{{ (\'generalTerms.description\' | translate) }}:</td><td>{{$ctrl.approvalprocess.Approval.Description}}</td></tr><tr><td>{{ (\'modules.personnel.approvals.affectedPerson\' | translate) }}:</td><td>{{$ctrl.approvalprocess.AffectedMember.fullName}}</td></tr><tr><td>{{ (\'models.Division\' | translate) }}:</td><td><div><ui-select name="divisionInput" ng-model="$ctrl.selectedDivision" title="" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match><span ng-bind="$ctrl.selectedDivision.Name || $ctrl.approvalprocess.Division.Name"></span></ui-select-match><ui-select-choices position="down" repeat="option in $ctrl.permittedDivs"><span ng-bind="::option.Name" title="{{::option.Name}}"></span></ui-select-choices></ui-select></div></td></tr><tr><td>{{ (\'modules.personnel.approvals.currentState\' | translate) }}:</td><td>{{$ctrl.approvalprocess.DisplayState}}</td></tr><tr><td translate="modules.personnel.dossier.fileStorage.fileUpdatedAt">Letzte \xC4nderung:</td><td>{{$ctrl.approvalprocess.updatedAt | date:\'dd.MM.yyyy\'}}</td></tr><tr><td></td><td></td></tr></table><div class="form-group"><div class="row" ng-repeat="(i, date) in $ctrl.dates"><div ng-hide="date.isHidden" class="col-sm-12"><div class="form-group clearfix"><label for="inputDate" class="control-label overflow-label" title="{{date.title}}">{{ date.title }}</label> <label ng-if="date.isReminder">{{ (\'modules.personnel.approvals.optional\' | translate) }}</label><div class="input-group"><input ng-disabled="$ctrl.isBlockField(i) || $ctrl.approvalprocess.Rejected" type="text" class="form-control" ng-click="date.isOpen = !date.isOpen" required="" uib-datepicker-popup="d!.M!.yyyy" datepicker-options="date.options" ng-change="$ctrl.fillNextField(date)" ng-model="date.value" is-open="date.isOpen" close-text="Schlie\xDFen" show-button-bar="false" ng-blur="$ctrl.checkForUpdates()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="date.isOpen = !date.isOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div></div><div class="modal-footer"><span ng-if="$ctrl.approvalprocess.Approval.AllowRejected"><button type="button" ng-if="!$ctrl.approvalprocess.Rejected" class="btn btn btn-with-icon btn-danger" ng-click="$ctrl.toggleRejection(true, $ctrl.approvalprocess)"><i class="fa fa-ban"></i><span translate="modules.personnel.approvals.rejectApproval"></span></button> <button type="button" ng-if="$ctrl.approvalprocess.Rejected" class="btn btn btn-with-icon btn-success-outline" ng-click="$ctrl.toggleRejection(false,$ctrl.approvalprocess)"><i class="fa fa-check"></i><span translate="modules.personnel.approvals.resetApproval"></span></button></span> <button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" ng-click="$ctrl.saveDates()" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/theme/components/approvalProcessList/approvalprocessModal/incompatibleApproval.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.approvals.incompatibleModalTitle"></h4></div><div class="modal-body"><p translate="modules.personnel.approvals.incompatibleModalText"></p><div class="table-responsive mt-20"><table class="table table-condensed table-hover"><thead><tr><th translate="modules.personnel.approvals.affectedPerson"></th><th translate="models.Approval"></th><th translate="models.Division"></th></tr></thead><tbody><tr ng-repeat="approvalProcess in $ctrl.failedApprovals"><td>{{ approvalProcess.AffectedMember.fullName }}</td><td>{{ approvalProcess.Approval.Title }}</td><td>{{ approvalProcess.Division.Name }}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.confirm"></button></div></div>');
$templateCache.put('app/theme/components/bookingMaterialCalendar/modals/bookingMaterialCalendarDetail.html','<div class="modal-content"><form id="bookingMaterialCalendarDetailForm" name="bookingMaterialCalendarDetailForm"><div class="modal-header"><h4 class="modal-title">{{ \'modules.material.addMaterial.bookingMaterialCalendar.detailTitle\' | translate:{ title: self.materialName } }}</h4></div><div class="modal-body pt-0 booking-material-calendar-detail-body"><table class="table table-condensed table-hover"><thead><tr><th><strong>{{ \'modules.material.addMaterial.bookingMaterialCalendar.property\' | translate }}</strong></th><th><strong>{{ \'modules.material.addMaterial.bookingMaterialCalendar.value\' | translate }}</strong></th></tr></thead><tbody><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.startDate\' | translate }}</td><td>{{ self.startDate | date:\'dd.MM.yyyy, HH:mm\' }} {{ \'generalTerms.oClock\' | translate }}</td></tr><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.endDate\' | translate }}</td><td>{{ self.endDate | date:\'dd.MM.yyyy, HH:mm\' }} {{ \'generalTerms.oClock\' | translate }}</td></tr><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.type\' | translate }}</td><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.typeVal\' | translate:{ isService: self.isService } }}</td></tr><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.event\' | translate }}</td><td>{{ self.event.title }}</td></tr><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.timeframe\' | translate }}</td><td>{{ self.event.timeframeTitle }}</td></tr><tr><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.state\' | translate }}</td><td><span class="state-legend" ng-class="self.eventColorClass()"></span> <span ng-if="self.showAsked">({{ self.showAsked }})</span> <span>{{ self.event.amount }}</span> <small class="muted pull-right">{{ \'modules.material.addMaterial.bookingMaterialCalendar.amountHint\' | translate: { showAsked:self.showAsked } }}</small></td></tr><tr ng-if="self.canOpenEvent"><td>{{ \'modules.material.addMaterial.bookingMaterialCalendar.openEvent\' | translate }}</td><td><button class="btn btn-info btn-sm btn-with-icon" type="button" ng-click="self.openEvent()"><i class="fa fa-external-link"></i> <span translate="generalTerms.open"></span></button></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="self.applyModal()">{{ \'generalTerms.close\' | translate }}</button></div></form></div>');
$templateCache.put('app/theme/components/businessPartnersSelector/modals/businessPartnerDetailsModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="navigation.contacts.businessPartnerDetails"></h4></div><div class="modal-body"><div><table class="table table-condensed arno-details-table"><tbody><tr ng-repeat="key in $modalCtrl.relevantCols" class="arno-material-detail-column">{{key}}<td class="align-left-force">{{ $modalCtrl.i18nMap[key] }}</td><td title="{{ ($modalCtrl.bp.IsInternal ? ($modalCtrl.bp.OwnerDivision || {})[key] : $modalCtrl.bp[key]) }}">{{ ($modalCtrl.bp.IsInternal ? ($modalCtrl.bp.OwnerDivision || {})[key] : $modalCtrl.bp[key]) }}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.close"></button></div></div>');
$templateCache.put('app/theme/components/divisionSelector/divisionSelectorModal/help.html','<div class="modal-content" ng-click="$event.stopPropagation();"><div class="modal-header"><h4 class="modal-title" translate="components.divisionSelector.help.helpTitle">Bereichsw\xE4hler Hilfe</h4></div><div class="modal-body division-selector-modal-help-content"><div class="row"><div class="col-md-12"><h3 class="with-line"><i class="divison-selector-hint-icon ion-close-round"></i>{{ (\'components.divisionSelector.noMultiSelection\' | translate) }}</h3></div></div><div class="row with-center-columns"><div class="col-sm-5 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/single.gif" class="img-responsive center-block"></div><div class="col-sm-7 column-align-center"><ul><li translate="components.divisionSelector.help.helpText1">Ein Klick auf eine Gliederung bzw. dessen Kontrollk\xE4stchen w\xE4hlt die entsprechende Gliederung aus. (Zu keinem Zeitpunkt k\xF6nnen zwei oder mehr Gliederungen gleichzeitig aktiviert werden.)</li></ul></div></div><div class="row"><div class="col-md-12"><h3 class="align-center"><i class="divison-selector-hint-icon ion-checkmark-round align-center"></i>{{ (\'components.divisionSelector.orgSelectableIndividually\' | translate) }}</h3></div></div><div class="row with-center-columns"><div class="col-sm-5 col-sm-push-7 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/single_allow_org.gif" class="img-responsive center-block"></div><div class="col-sm-7 col-sm-pull-5 column-align-center"><ul><li translate="components.divisionSelector.help.helpText2">Ein Klick auf deine Organisation bzw. dessen Kontrollk\xE4stchen setzt den gew\xE4hlten Bereich auf die Organisation. (Dies bedeutet du siehst ausschlie\xDFlich Daten welche deine Organisation selbst, jedoch keine untergeordnete Gliederung im speziellen, betreffen.)</li></ul></div></div><div class="row"><div class="col-md-12"><h3 class="with-line"><i class="divison-selector-hint-icon ion-checkmark-round"></i>{{ (\'components.divisionSelector.multiSelection\' | translate) }}</h3></div></div><div class="row with-center-columns"><div class="col-sm-5 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/multiple_1.gif" class="img-responsive center-block"></div><div class="col-sm-7 column-align-center"><ul><li translate="components.divisionSelector.help.helpText3">Ein Klick auf das Kontrollk\xE4stchen deiner Organisation bzw. einer Gliederung aktiviert die Auswahl f\xFCr den entsprechenden Knoten und f\xFCr alle untergeordneten Gliederungen bzw. hebt eine bestehende Auswahl wieder auf.</li><li translate="components.divisionSelector.help.helpText4">Wenn du \xFCbergeordnete Knoten ausw\xE4hlst, kannst du anschlie\xDFend untergeordnete Gliederungen deselektieren um die Gesamtauswahl nach deinen W\xFCnschen anzupassen.</li></ul></div></div><div class="row with-center-columns"><div class="col-sm-5 col-sm-push-7 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/multiple_2.gif" class="img-responsive center-block"></div><div class="col-sm-7 col-sm-pull-5 column-align-center"><ul><li translate="components.divisionSelector.help.helpText5">Du kannst die Auswahl aller anderen Knoten aufheben und einen einzelnen Knoten ausw\xE4hlen, indem du auf dessen Titel klickst anstelle das Kontrollk\xE4stchen zu bedienen.</li></ul></div></div><div class="row"><div class="col-md-12"><h3 class="align-center"><i class="divison-selector-hint-icon ion-checkmark-round align-center"></i>{{ (\'components.divisionSelector.orgSelectableIndividually\' | translate) }}</h3></div></div><div class="row with-center-columns"><div class="col-sm-5 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/multiple_allow_org_1.gif" class="img-responsive center-block"></div><div class="col-sm-7 column-align-center"><ul><li translate="components.divisionSelector.help.helpText6">Ein Klick auf deine Organisation (jedoch nicht dessen Kontrollk\xE4stchen!) setzt den gew\xE4hlten Bereich auf die Organisation. (Dies bedeutet du siehst ausschlie\xDFlich Daten, welche deine Organisation selbst, jedoch keine untergeordnete Gliederung im speziellen, betreffen.)</li></ul></div></div><div class="row with-center-columns"><div class="col-sm-5 col-sm-push-7 column-align-center"><img src="app/theme/components/divisionSelector/divisionSelectorModal/img/multiple_allow_org_2.gif" class="img-responsive center-block"></div><div class="col-sm-7 col-sm-pull-5 column-align-center"><ul><li translate="components.divisionSelector.help.helpText7">Ein Klick auf das Kontrollk\xE4stchen deiner Organisation w\xE4hlt alle untergeordneten Gliederungen aus. (Dies bedeutet du siehst ausschlie\xDFlich Daten, welche die gew\xE4hlten Gliederungen, jedoch nicht deine Organisation selbst, betreffen.)</li></ul></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Okay</button></div></div>');
$templateCache.put('app/theme/components/eventMaterial/modals/materialHierarchy.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ \'modules.events.shiftTemplate.matBookingImplicitMaterialModal\' | translate:{ label: self.hierarchy[0].label } }}</h4></div><div class="modal-body arno-events implicit-material-hierarchy pt-0"><script type="text/ng-template" id="recursive.mat.html"><div class="mt-4"> <status-light class="\'light-inline\'" use-one-light="true" use-yellow-light="true" is-inactive="!mat.utilization" is-green="mat.utilization && mat.utilization.fullyAvailable" is-yellow="mat.utilization && !mat.utilization.fullyAvailable && mat.utilization.EffectiveAmount" green-title="(\'modules.events.shiftTemplate.matBookingGreen\' | translate)" red-title="(\'modules.events.shiftTemplate.matBookingRed\' | translate: { available: mat.utilization.EffectiveAmount })" yellow-title="(\'modules.events.shiftTemplate.matBookingRed\' | translate: { available: mat.utilization.EffectiveAmount })" ></status-light> <span class="ml-8 implicit-material-label" title="{{ mat.label }}">{{ mat.label }}</span> <span class="mat-icon-container pull-right"> <i ng-class="self.storageIconMap[mat.materialModel]"></i> </span> <span class="badge ml-3 material-booking-amount-badge pull-right" ng-class="{\'active\': self.active}" ng-if="mat.utilization"> <span ng-if="mat.utilization.AskedAmount === mat.utilization.EffectiveAmount">{{ mat.utilization.EffectiveAmount }}</span> <span ng-if="mat.utilization.AskedAmount !== mat.utilization.EffectiveAmount"> {{ mat.utilization.EffectiveAmount }} / {{ mat.utilization.AskedAmount }} </span> </span> <ul ng-if="mat.children && mat.children.length" class="ul-booking-hierarchy"> <li ng-repeat="mat in mat.children" ng-include="\'recursive.mat.html\'"></li> </ul> </div></script><ul class="ul-booking-hierarchy pl-0"><li ng-repeat="mat in self.hierarchy" ng-include="\'recursive.mat.html\'"></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'generalTerms.close\' | translate }}</button></div></div>');
$templateCache.put('app/theme/components/eventMaterial/modals/shiftAddMaterial.html','<div class="modal-content modal-shift-add-material"><form id="shiftAddMaterialForm" name="shiftAddMaterialForm" novalidate=""><div class="modal-header"><h4 class="modal-title">{{ \'modules.events.shiftTemplate.modals.title\' | translate: { isShift: $ama.baseType === \'SERVICE\', name: $ama.materialModelName, ctx: $ama.ctxName } }}</h4></div><div class="modal-body pt-0"><div class="mb-10"><div class="btn-group" uib-dropdown=""><button uib-dropdown-toggle="" type="button" class="btn btn-info btn-with-icon"><i class="fa fa-table"></i> <span>{{ \'modules.events.shiftTemplate.modals.view\' | translate }}</span> <span class="caret ml-6 v-align-top mt-7"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-left"><li role="menuitem" ng-repeat="view in $ama.tableConfig"><a href="" ng-click="$ama.setMaterialView(view)">{{ view.Name }}</a></li></ul></div></div><div class="table-responsive"><table st-table="$ama.matData" st-pipe="$ama.reloadMaterial" st-safe-src="$ama.tableData" class="table table-condensed table-hover arno-aggregatable-table"><thead><tr class="sortable"><th class="arno-table-button-cell">{{ \'modules.events.shiftTemplate.modals.status\' | translate }}</th><th st-sort="\'Amount\'" class="force-minimal">{{ \'modules.events.shiftTemplate.modals.amount\' | translate }}</th><th st-sort="{{ header.prop }}" ng-repeat="header in $ama.materialColumns" ng-if="!$ama.sharedTblState.view || $ama.sharedTblState.view.Fields.indexOf(header.prop) !== -1" ng-class="{aggregatable: $ama.checkAggExcludes(header.prop)}"><span>{{ header.label }}</span> <button ng-if="$ama.checkAggExcludes(header.prop)" title="{{ \'modules.events.shiftTemplate.modals.aggregate\' | translate: { label: header.label } }}" class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-class="{active: $ama.isIn($ama.sharedTblState.agg, header.prop)}" ng-click="$ama.toggleMaterialAggregate($event, header.prop)"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th ng-if="$ama.isMultiDiv" st-sort="Division.Name" class="aggregatable"><span>{{ \'modules.events.shiftTemplate.modals.division\' | translate }}</span> <button ng-if="$ama.checkAggExcludes(header.prop)" title="{{ \'modules.events.shiftTemplate.modals.aggregateDivision\' | translate }}" class="btn btn-default btn-with-icon btn-xs agg-icon column-control" ng-class="{active: $ama.isIn($ama.sharedTblState.agg, \'Division.Name\')}" ng-click="$ama.toggleMaterialAggregate($event, \'Division.Name\')"><i class="ion-arrow-shrink" aria-hidden="true"></i></button></th><th class="arno-table-button-cell force-minimal">{{ \'modules.events.shiftTemplate.modals.actions\' | translate }}</th></tr><tr><th></th><th></th><th ng-repeat="header in $ama.materialColumns" ng-if="!$ama.sharedTblState.view || $ama.sharedTblState.view.Fields.indexOf(header.prop) !== -1"><div class="input-group" ng-if="$ama.searchableCheck(header)"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="{{ header.prop }}" type="search" class="form-control with-default-addon input-sm"></div></th><th ng-if="$ama.isMultiDiv"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Division.Name" type="search" class="form-control with-default-addon input-sm"></div></th><th></th></tr></thead><tbody><tr ng-if="$ama.matData && $ama.matData.length" ng-repeat="material in $ama.matData track by $index"><td><span class="arno-tag arno-storage-tag tag label label-tag state-tag" ng-if="$ama.diff(material.id, $ama.associatedMaterials) < material.id.length" ng-class="{\'label-success\': $ama.diff(material.id, $ama.associatedMaterials) === 0, \'label-warning\': $ama.diff(material.id, $ama.associatedMaterials) !== 0}">{{ $ama.diff(material.id, $ama.associatedMaterials) === 0 ? (\'modules.events.shiftTemplate.modals.deposited\' | translate) : (\'modules.events.shiftTemplate.modals.partiallyDeposited\' | translate) }}</span> <span class="arno-tag arno-storage-tag tag label label-tag state-tag" ng-if="$ama.diff(material.id, $ama.associatedMaterials) === material.id.length">{{ \'modules.events.shiftTemplate.modals.notDeposited\' | translate }}</span></td><td class="align-left-force text-overflow overflow-title"><span>{{ material.Amount || \'0\' }}</span></td><td ng-repeat="header in $ama.materialColumns" ng-if="!$ama.sharedTblState.view || $ama.sharedTblState.view.Fields.indexOf(header.prop) !== -1" class="align-left-force text-overflow overflow-title"><div ng-if="header.prop !== \'Storage\' && header.prop !== \'ResponsibleMember\'"><span ng-if="!$ama.currentPropSet[header.prop] || ($ama.currentPropSet[header.prop] && $ama.currentPropSet[header.prop].type !== \'date\' && $ama.currentPropSet[header.prop].type !== \'bool\')">{{ (material[header.prop] === false ? (\'modules.events.shiftTemplate.modals.no\' | translate) : material[header.prop] === true ? (\'modules.events.shiftTemplate.modals.yes\' | translate) : $ama.applyFieldConfig($ama.currentPropSet, material[header.prop], header.prop)) || \'-\' }}</span> <span ng-if="$ama.currentPropSet[header.prop] && $ama.currentPropSet[header.prop].type === \'date\'">{{ $ama.parseDate(material[header.prop]) || \'-\' | date:\'dd.MM.yyyy\'}}</span> <span ng-if="$ama.currentPropSet[header.prop] && $ama.currentPropSet[header.prop].type === \'bool\'">{{ $ama.boolFormatter(material[header.prop]) || \'-\' }}</span></div><ul ng-if="header.prop === \'ResponsibleMember\' && material[header.prop]"><li ng-repeat="member in material[header.prop].split(\', \')" ng-class="{\'member-inactive\': (member.indexOf(\'(inaktiv)\') > -1)}">{{ member }}</li></ul><div ng-if="header.prop === \'Storage\'"><span class="arno-tag arno-storage-tag tag label label-tag label-info" ng-repeat="storage in material.StorageTags" ng-if="material.StorageTags && material.StorageTags.length">{{ storage.label }}</span> <span ng-if="!material.StorageTags || !material.StorageTags.length">{{ material[header.prop] }}</span></div></td><td ng-if="$ama.isMultiDiv" class="align-left-force"><span>{{ material[\'Division.Name\'] }}</span></td><td><div class="row-actions pull-right"><button class="btn btn-default btn-with-icon btn-xs" title="{{(\'modules.material.demandForAction.toDossier\' | translate)}}" ng-click="$ama.openMaterialDossier(material.id)"><i class="fa fa-eye"></i></button> <button class="btn btn-success btn-xs no-animation" ng-if="$ama.diff(material.id, $ama.associatedMaterials) > 0" title="{{$ama.diff(material.id, $ama.associatedMaterials) > 1 ? (\'modules.events.shiftTemplate.modals.addAll\' | translate) : (\'modules.events.shiftTemplate.add\' | translate) }}" ng-click="$ama.linkMaterial(material)"><i class="ion-plus"></i></button> <button class="btn btn-danger btn-xs no-animation" ng-if="$ama.diff(material.id, $ama.associatedMaterials) < material.id.length" title="{{material.id.length - $ama.diff(material.id, $ama.associatedMaterials) > 1 ? (\'modules.events.shiftTemplate.removeAll\' | translate) : (\'modules.events.shiftTemplate.remove\' | translate) }}" ng-click="$ama.linkMaterial(material, true)"><i class="ion-ios-trash"></i></button></div></td></tr><tr ng-if="!$ama.matData || !$ama.matData.length"><td class="text-center" colspan="99"><i>{{ \'modules.events.shiftTemplate.modals.noMaterials\' | translate }}</i></td></tr></tbody><tfoot><tr><td colspan="99" class="p-0"><st-pagination st-items-by-page="$ama.itemsPerPage" st-template="app/theme/components/paging/paging.html"></st-pagination></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'modules.events.shiftTemplate.cancel\' | translate }}</button> <button type="button" class="btn btn-primary" ng-click="$ama.applyModal()">{{ \'modules.events.shiftTemplate.takeOver\' | translate }}</button></div></form></div>');
$templateCache.put('app/theme/components/eventMaterial/modals/shiftImportQuotation.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{self.materialKey ? (self.isMaterialTypeImport ? \'Materialtyp\' : \'Material\') : \'Dienstposition\'}} aus Angebot zu "{{self.parentLabel}}" hinzuf\xFCgen</h4></div><div class="modal-body arno-events"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th>Status<arno-ba-help-tooltip text="Dieses Statusfeld kann dazu verwendet werden abschlie\xDFend bearbeitete Angebotspositionen zu markieren. Eine Markierung hat keinerlei funktionale Auswirkungen."></arno-ba-help-tooltip></th><th>{{self.materialKey ? (self.isMaterialTypeImport ? \'Materialtyp\' : \'Material\') : \'Dienstposition\'}}</th><th>Aktionen</th></tr></thead><tbody><tr ng-repeat="position in self.positions"><td class="force-minimal white-space-no-wrap"><status-light class="\'vertical-align-middle mr-3\'" use-one-light="true" use-yellow-light="true" is-inactive="!position.done && !self.positionInUseStatusMap[(self.materialKey || \'\') + position.AdditionalMetaJson.PriceItemId]" is-yellow="!position.done && self.positionInUseStatusMap[(self.materialKey || \'\') + position.AdditionalMetaJson.PriceItemId]" is-green="position.done"></status-light><button class="btn btn-default btn-xs" ng-click="position.done = !position.done">{{ position.done ? \'Markierung aufheben\' : \'Als erledigt markieren\' }}</button></td><td ng-class="{\'position-done\': position.done}">{{ position.Title }}</td><td><button class="btn btn-with-icon btn-xs no-animation" ng-class="position.done ? \'btn-default\' : \'btn-success\'" ng-click="self.applyPosition(position)"><i class="ion-plus"></i><span>Hinzuf\xFCgen</span></button> <button class="btn btn-default btn-with-icon btn-xs no-animation" ng-if="!position.done" ng-click="position.done = !position.done; self.applyPosition(position)"><i class="fa fa-check"></i><span>Markieren & hinzuf\xFCgen</span></button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Schlie\xDFen</button></div></div>');
$templateCache.put('app/theme/components/eventMaterial/modals/shiftMaterialBookingPeriod.html','<div class="modal-content"><form id="shiftMaterialBookingPeriodForm" name="shiftMaterialBookingPeriodForm" novalidate="" angular-validator="" angular-validator-submit="self.applyModal()"><div class="modal-header"><h4 class="modal-title">{{ \'modules.events.shiftTemplate.bookingPeriods\' | translate }} {{ self.shift.Subject ? (\'- \' + self.shift.Subject) : \'\' }}</h4></div><div class="modal-body arno-events pt-0"><div class="alert bg-info" ng-if="self.hasManagePerm"><h4 translate="modules.events.shiftTemplate.modals.bookingPeriodFillInHintTitle"></h4><span>{{ \'modules.events.shiftTemplate.modals.bookingPeriodFillInHint\' | translate }}</span></div><div ng-repeat="bookingPeriod in self.bookingPeriods" class="mt-20"><strong>{{\'modules.events.shiftTemplate.modals.bookingPeriodN\' | translate:{ n: ($index + 1) } }}:</strong><div ng-if="!bookingPeriod.IsDefaultPeriod"><div class="row ml-0 mt-10"><div class="form-group col-sm-12"><label for="{{\'inputSubject\' + $index}}" class="control-label primary-label required-label">{{ \'modules.events.shiftTemplate.modals.justTitle\' | translate }}</label> <input type="text" class="form-control" name="{{\'inputSubject\' + $index}}" placeholder="" ng-model="bookingPeriod.Title" max-char="255" ng-disabled="bookingPeriod.IsDefaultPeriod || !self.hasManagePerm" required-message="\'modules.events.shiftTemplate.modals.pleaseEnterTitle\' | translate" required=""></div><div class="col-sm-12"><div class="row event-combined-date-time-picker form-group mt-0 mb-0"><div class="col-sm-8"><label class="control-label required-label">{{ \'modules.events.shiftTemplate.modals.bookingPeriodWithdrawal\' | translate }}</label><p class="input-group"><input type="text" name="{{\'inputStartDate-\' + $index}}" class="form-control" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="bookingPeriod.StartDate" ng-disabled="bookingPeriod.IsDefaultPeriod || !self.hasManagePerm" is-open="bookingPeriod.openedInputStartDate" close-text="{{ (\'modules.events.ServiceData.close\' | translate) }}" show-button-bar="false" required-message="\'generalTerms.requiredField\' | translate" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-if="self.hasManagePerm" ng-click="bookingPeriod.openedInputStartDate = !bookingPeriod.openedInputStartDate" ng-disabled="bookingPeriod.IsDefaultPeriod"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-4"><div ng-if="self.hasManagePerm" uib-timepicker="" ng-model="bookingPeriod.StartDate" ng-disabled="bookingPeriod.IsDefaultPeriod" mousewheel="false" minute-step="15" show-meridian="false"></div></div><div class="col-sm-12 w-100"><input ng-if="self.hasManagePerm" type="hidden" class="form-control" name="templateStartDateValidation" ng-model="self.templateStartDateValidationEmpty" validator="self.isValidDate({{$index}})" invalid-message="\'modules.events.ServiceData.pleaseCorrectStartEndTime\' | translate"></div></div></div><div class="col-sm-12"><div class="row event-combined-date-time-picker form-group mt-0 mb-0"><div class="col-sm-8"><label class="control-label required-label">{{ \'modules.events.shiftTemplate.modals.bookingPeriodRelease\' | translate }}</label><p class="input-group"><input type="text" name="{{\'inputEndDate-\' + $index}}" class="form-control" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="bookingPeriod.EndDate" ng-disabled="bookingPeriod.IsDefaultPeriod || !self.hasManagePerm" is-open="bookingPeriod.openedInputEndDate" close-text="{{ (\'modules.events.ServiceData.close\' | translate) }}" show-button-bar="false" required-message="\'generalTerms.requiredField\' | translate" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-if="self.hasManagePerm" ng-click="bookingPeriod.openedInputEndDate = !bookingPeriod.openedInputEndDate" ng-disabled="bookingPeriod.IsDefaultPeriod"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-4"><div uib-timepicker="" ng-model="bookingPeriod.EndDate" ng-if="self.hasManagePerm" ng-disabled="bookingPeriod.IsDefaultPeriod" mousewheel="false" minute-step="15" show-meridian="false"></div></div><div class="col-sm-12 w-100"><input type="hidden" class="form-control" ng-if="self.hasManagePerm" name="templateEndDateValidation" ng-model="self.templateEndDateValidationEmpty" validator="self.isValidDate({{$index}})" invalid-message="\'modules.events.ServiceData.pleaseCorrectStartEndTime\' | translate"></div></div></div><div class="col-sm-12"><button type="button" class="btn btn-danger w-100" ng-disabled="self.bookingPeriods.length < 2" ng-if="!bookingPeriod.IsDefaultPeriod && self.hasManagePerm" ng-click="self.remove(bookingPeriod)">{{ \'generalTerms.remove\' | translate }}</button></div></div></div><div ng-if="bookingPeriod.IsDefaultPeriod" class="mt-10 ml-15"><i>{{ bookingPeriod.Title }}</i><div class="text-muted mt-3">{{ bookingPeriod.StartDate | date:\'dd.MM.yyyy, HH:mm\'}} Uhr&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;{{ bookingPeriod.EndDate | date:\'dd.MM.yyyy, HH:mm\'}} Uhr</div></div></div><div class="mt-20"><button ng-if="self.hasManagePerm" type="button" class="btn btn-success w-100" ng-click="self.add()">{{ \'generalTerms.add\' | translate }}</button></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ (self.hasManagePerm ? \'modules.events.shiftTemplate.cancel\' : \'generalTerms.close\') | translate }}</button> <button type="submit" ng-if="self.hasManagePerm" class="btn btn-primary">{{ \'modules.events.shiftTemplate.save\' | translate }}</button></div></form></div>');
$templateCache.put('app/theme/components/fileStorage/modals/uploadModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.fileStorage.uploadModal.title" translate-values="{ node: $modalCtrl.node.text }"></h4></div><div class="modal-body"><p class="mb-20" translate="modules.personnel.dossier.fileStorage.uploadModal.uploadNote"></p><div><label class="btn arno-file-upload mb-30">{{ (\'modules.personnel.dossier.fileStorage.uploadModal.selectFiles\' | translate) }} <input type="file" class="hidden" multiple="" nv-file-select="" uploader="$modalCtrl.uploader" hidden=""></label></div><div ng-if="$modalCtrl.uploader.queue && $modalCtrl.uploader.queue.length"><h4 translate="modules.personnel.dossier.fileStorage.uploadModal.queue"></h4><table class="table table-condensed table-hover" st-table="$modalCtrl.uploader.queue"><thead><tr class="sortable"><th st-sort="item.name">{{ (\'modules.personnel.dossier.fileStorage.uploadModal.name\' | translate) }}</th><th st-sort="item.size">{{ (\'modules.personnel.dossier.fileStorage.uploadModal.size\' | translate) }}</th><th st-sort="progress">{{ (\'modules.personnel.dossier.fileStorage.uploadModal.progress\' | translate) }}</th><th>{{ (\'modules.personnel.dossier.fileStorage.uploadModal.state\' | translate) }}</th><th>{{ (\'generalTerms.actions\' | translate) }}</th></tr></thead><tbody><tr ng-repeat="item in $modalCtrl.uploader.queue"><td>{{ item.file.name }}</td><td>{{ $modalCtrl.calcFileSize(item.file.size) }}</td><td><div class="progress"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div></td><td>{{ $modalCtrl.getState(item) }}</td><td><button ng-disabled="item.isUploaded || item.isUploading" class="btn btn-default btn-with-icon btn-xs" ng-click="item.upload()"><i class="fa fa-arrow-up"></i> <span translate="modules.personnel.dossier.fileStorage.uploadModal.upload"></span></button> <button ng-disabled="(item.isUploaded || item.isUploading) && !item.isError" class="btn btn-danger btn-with-icon btn-xs" ng-click="item.remove()"><i class="ion-ios-trash"></i> <span translate="generalTerms.remove"></span></button></td></tr></tbody></table></div></div><div class="modal-footer"><button ng-disabled="!$modalCtrl.uploader.queue.length" class="btn btn-primary btn-with-icon pull-right ml-10" ng-click="$modalCtrl.uploadAll()"><i class="fa fa-arrow-up"></i><span translate="modules.personnel.dossier.fileStorage.uploadModal.uploadAll"></span></button> <button type="button" class="btn btn-default" ng-click="$close()"><span>{{ $modalCtrl.getCloseButtonText() }}</span></button></div></div>');
$templateCache.put('app/theme/components/modals/contactPrivacyModal/contactPrivacyModal.html','<form class="modal-content" name="$contactPrivacyModalCtrl.privacyModalForm" novalidate="" angular-validator=""><div class="modal-header"><h4 class="modal-title">{{ (\'components.contactPrivacy.offlineContactModalTitle\' | translate:{ firstname: ($contactPrivacyModalCtrl.contact.FirstName ? \'- \' : \'\') + $contactPrivacyModalCtrl.contact.FirstName, lastname: $contactPrivacyModalCtrl.contact.LastName }) }}</h4></div><div class="modal-body"><h5 class="modal-subtitle"><i class="ion-book"></i> <span ng-if="!$contactPrivacyModalCtrl.demandForAction && $contactPrivacyModalCtrl.privacyTermDate" translate="components.contactPrivacy.demandForActionText1" translate-values="{ date: $contactPrivacyModalCtrl.privacyTermDateDisplay }"></span> <span ng-if="!$contactPrivacyModalCtrl.demandForAction && !$contactPrivacyModalCtrl.privacyTermDate" translate="components.contactPrivacy.thirdPartyAgreementDeliveredModalTitle"></span> <span ng-if="$contactPrivacyModalCtrl.demandForAction" translate="components.contactPrivacy.demandForActionText2" translate-values="{ date: $contactPrivacyModalCtrl.privacyTermDateDisplay }"></span></h5><table class="privacy-contact-modal-table"><tr><td class="form-group pt-5"><contact-privacy contact="$contactPrivacyModalCtrl.contact" form-reference="$contactPrivacyModalCtrl.privacyModalForm" privacy-term-date="$contactPrivacyModalCtrl.privacyTermDate" demand-for-action="$contactPrivacyModalCtrl.demandForAction"></contact-privacy></td></tr></table></div><div class="modal-footer"><div class="row"><div class="col-md-6 text-left"><button type="button" class="btn btn-default btn-with-icon" ng-click="$contactPrivacyModalCtrl.close()"><i class="ion-close-round"></i> {{ (\'generalTerms.cancel\' | translate) }}</button></div><div class="col-md-6 text-right"><button type="submit" class="btn btn-with-icon btn-primary" ng-click="$contactPrivacyModalCtrl.add($contactPrivacyModalCtrl.privacyModalForm)"><i class="ion-checkmark-round"></i> {{ (\'generalTerms.add\' | translate) }}</button></div></div></div></form>');
$templateCache.put('app/theme/components/modals/copyToDivisionsModal/copyDivision.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.modals.copyDivision.title"></h4></div><div class="modal-body"><div class="table-responsive"><table st-table="self.divisionCollection" st-safe-src="self.divisionList" class="table table-condensed table-hover"><thead><tr class="sortable"><th colspan="2" st-sort="Name" st-sort-default="true" translate="generalTerms.divisions"></th></tr><tr><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input st-search="Name" type="text" class="form-control with-default-addon input-sm form-control"></div></th><th></th></tr></thead><tbody><tr ng-repeat="item in self.divisionCollection"><td class="arno-pointing-pointer" ng-click="item.state = !item.state">{{ ::item.Name }}</td><td><input class="from-control" type="checkbox" ng-model="item.state"></td></tr></tbody><tfoot><tr><td colspan="2" class="text-center"><div st-pagination="" st-items-by-page="10" st-template="app/theme/components/paging/paging.html"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><div class="clearfix mb-8" ng-if="self.childDivisionIds.length"><button class="btn btn-default pull-left" ng-click="self.selectChildDivisions()"><i class="fa fa-exclamation-triangle text-danger mr-3" ng-if="self.childDivisionIds.length > 100"></i> <span translate="components.modals.copyDivision.subDivisions" translate-values="{count: self.childDivisionIds.length}"></span></button></div><div><button class="btn btn-default pull-left" ng-click="self.selectAllDivisions(self.divisionList)"><i class="fa fa-exclamation-triangle text-danger mr-3" ng-if="self.divisionList.length > 100 && !self.allSelectionMode"></i> <span translate="components.modals.copyDivision.allDivisionDeSelect" translate-values="{count: self.divisionList.length, deselect: self.allSelectionMode}"></span></button> <button class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-primary" ng-click="self.copyDivision()" translate="generalTerms.copy"></button></div></div></div>');
$templateCache.put('app/theme/components/modals/exportModal/exportModal.tpl.html','<div class="modal-content"><div class="modal-header pb-0"><h4 class="modal-title" translate="components.modals.exportModal.title">Dateityp des Exportes w\xE4hlen</h4></div><div class="modal-body"><p><span ng-if="$baExportModalCtrl.modalData.contentEntryText" ng-bind-html="$baExportModalCtrl.modalData.contentEntryText"></span></p><p><form name="groupForm"><div class="section-block"><p><b translate="components.modals.exportModal.privacyNote">Hinweis zur datenschutzkonformen Speicherung</b></p><div ng-bind-html="$baExportModalCtrl.exportPrivacyNoteContent"></div><label class="custom-checkbox"><input type="checkbox" ng-model="$baExportModalCtrl.readAndAccepted" class="custom-control-input"> <span translate="components.modals.exportModal.readAndAccepted">Gelesen und akzeptiert</span></label></div><div class="form-group"><ui-select ng-model="$baExportModalCtrl.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" spinner-class=""><ui-select-match placeholder=""><span>{{ $baExportModalCtrl.selected.label }}</span></ui-select-match><ui-select-choices position="down" repeat="item in $baExportModalCtrl.selectItems"><span>{{ item.label }}</span></ui-select-choices></ui-select></div><div class="text-left"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" ng-model="$baExportModalCtrl.fieldOption" value="tableConfig"> <span translate="components.modals.exportModal.useTblConf">Tabellenkonfiguration beachten</span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" ng-model="$baExportModalCtrl.fieldOption" value="all"> <span translate="components.modals.exportModal.selectAllFields">Alle Felder ausw\xE4hlen</span></label></div></div></div><div class="text-left mt-10"><div class="input-demo radio-demo row"><div ng-class="{\'col-md-4\': $baExportModalCtrl.modalData.hasSelection, \'col-md-6\': !$baExportModalCtrl.modalData.hasSelection}"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio3" ng-model="$baExportModalCtrl.filterOption" value="filtered"> <span translate="components.modals.exportModal.filteredData">Gefilterte Daten</span></label></div><div ng-if="$baExportModalCtrl.modalData.hasSelection" class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio4" ng-model="$baExportModalCtrl.filterOption" value="selected"> <span translate="components.modals.exportModal.selectedData">Ausgew\xE4hlte Daten</span></label></div><div ng-class="{\'col-md-4\': $baExportModalCtrl.modalData.hasSelection, \'col-md-6\': !$baExportModalCtrl.modalData.hasSelection}"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions2" id="inlineRadio5" ng-model="$baExportModalCtrl.filterOption" value="all"> <span translate="components.modals.exportModal.allData">Alle Daten</span></label></div></div></div></form></p></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <span><button type="button" class="btn btn-primary" ng-disabled="!$baExportModalCtrl.readAndAccepted" ng-click="$baExportModalCtrl.applyModal()" translate="generalTerms.download">Herunterladen</button></span></div></div>');
$templateCache.put('app/theme/components/modals/helperHoursTransferModal/helperHoursTransferModal.html','<div class="modal-content helper-hours-transfer-modal"><form id="helperHoursTransferModalForm" name="helperHoursTransferModalForm" novalidate=""><div class="modal-header pb-0"><h4 class="modal-title" translate="modules.helperHours.hours.carryoverVolunteerHours"></h4></div><div class="modal-body pt-0"><div ng-if="self.groupedHelperHours.length > 1" class="progress ba-wizard-progress"><div class="progress-bar" ng-class="((self.step+1)===self.groupedHelperHours.length) ? \'progress-bar-success\' : \'progress-bar-info\'" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: ((100/self.groupedHelperHours.length)*(self.step+1)) + \'%\'}"></div></div><div class="mt-30"><div class="mb-15">{{\'modules.helperHours.hours.volunteerHoursFor\' |translate}} <strong>{{self.group.initialTitle}}</strong> {{\'modules.helperHours.hours.volunteerHoursForTwo\' |translate}} <i class="fa fa-clock-o ml-1"></i> <strong>{{self.group.StartDate | date : \'dd.MM.yyyy, HH:mm\'}} {{\'generalTerms.oClock\' |translate}}</strong> <i class="fa fa-clock-o ml-1"></i> <strong>{{self.group.EndDate | date : \'dd.MM.yyyy, HH:mm\'}} {{\'generalTerms.oClock\' |translate}}</strong></div><div class="form-group"><label class="required-label" translate="modules.helperHours.hours.title"></label> <input name="{{\'modules.helperHours.hours.title\' |translate}}" type="text" class="form-control" ng-model="self.group.Title" required="" required-message="\'modules.helperHours.hours.volunteerHoursNeededTitle\' | translate"></div><div class="form-group mb-0"><label translate="modules.helperHours.hours.volunteer"></label></div><uib-accordion panel-class="panel-default bootstrap-panel accordion-panel" close-others="true" class="helper-hours-transfer-accordion"><div uib-accordion-group="" template-url="app/theme/components/modals/helperHoursTransferModal/uib-accordion-group.tpl.html" class="panel-default accordion-panel" ng-repeat="helperHour in self.group.helperHours track by helperHour.id" is-open="self.accordionTrack[self.group.id][helperHour.id]"><uib-accordion-heading><div ng-click="self.accordionClick($event, self.group.id, helperHour.id)"><label class="custom-checkbox no-propagation" ng-click="self.stopPropagation($event)"><input type="checkbox" ng-model="helperHour.active" class="custom-control-input no-propagation"> <span class="vertical-align-bottom no-propagation"></span></label> <span class="heading-title inline-block" ng-class="{\'no-sub-title\': !helperHour.Function}">{{ helperHour.Member.fullName }} <i class="fa fa-files-o" ng-if="helperHour.id !== helperHour.parentId"></i> <span class="heading-sub-title text-success no-propagation">{{helperHour.Function}}</span></span> <i class="pull-right" ng-class="{\'ion-document-text mr-3\': self.accordionTrack[self.group.id][helperHour.id], \'ion-edit\': !self.accordionTrack[self.group.id][helperHour.id]}"></i> <span class="arno-tag tag label label-tag pull-right" ng-class="{\'label-info\': helperHour.active && (helperHour.hours + helperHour.minutes > 0), \'label-danger\': helperHour.active && (helperHour.hours + helperHour.minutes === 0)}">{{self.leftPad(helperHour.hours, \'00\')}}:{{self.leftPad(helperHour.minutes, \'00\')}}</span> <span class="arno-tag tag label label-tag label-success pull-right" ng-if="helperHour.Activity.Title">{{helperHour.Activity.Title}}</span></div></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group mt-13"><label class="required-label" translate="modules.helperHours.hours.releaseDate"></label><div class="input-group"><input type="text" class="form-control" name="helperHourDate" required="" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" invalid-message="\'modules.helperHours.hours.invalidDate\' |translate" required-message="\'modules.helperHours.hours.requiredDate\' |translate" ng-model="helperHour.date" is-open="self.openedDatePicker" close-text="{{\'generalTerms.close\' |translate}}" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.openedDatePicker = !self.openedDatePicker"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><div class="form-group"><label class="required-label time-label-in-form" translate="modules.helperHours.hours.releaseTime"></label><div uib-timepicker="" ng-model="helperHour.dateStartTime" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div><div class="col-md-6"><div class="form-group mt-13"><label class="required-label" translate="modules.helperHours.hours.endDate"></label><div class="input-group"><input type="text" class="form-control" name="helperHourEndDate" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" ng-model="helperHour.dateEnd" is-open="self.openedEndDatePicker" close-text="{{\'generalTerms.close\' |translate}}" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.openedEndDatePicker = !self.openedEndDatePicker"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><div class="form-group"><label class="required-label time-label-in-form" translate="modules.helperHours.hours.endTime"></label><div uib-timepicker="" ng-model="helperHour.dateEndTime" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" translate="modules.helperHours.hours.volunteerActivity"></label><ui-select name="selectActivity" ng-model="helperHour.Activity" search-enabled="false" ng-disabled="disableActivities" class="btn-group bootstrap-select form-control" ng-if="helperHour.Activities.length > 1"><ui-select-match placeholder="{{\'chooseHelperActivity\' |translate}}">{{ $select.selected.none ? \'modules.helperHours.hours.noTrackActivity\' : $select.selected.Title }}</ui-select-match><ui-select-choices position="down" repeat="activity in helperHour.Activities | filter: $select.search"><span ng-if="!activity.none">{{activity.Title}}</span> <i ng-if="activity.none" translate="modules.helperHours.hours.noTrackActivity"></i></ui-select-choices></ui-select><input ng-if="helperHour.Activities.length <= 1" name="disabledActivity" class="form-control" value="{{\'modules.helperHours.hours.noTrackActivity\' |translate}}" disabled=""></div><div class="form-group"><div class="row"><div class="col-xs-6"><label class="control-label required-label" translate="modules.helperHours.hours.hours"></label> <input name="inputHours" required="" class="form-control" min="0" step="1" type="number" ng-model="helperHour.hours"></div><div class="col-xs-6"><label class="control-label required-label" translate="modules.helperHours.hours.minutes"></label> <input name="inputMinutes" required="" class="form-control" min="0" max="59" step="1" type="number" ng-model="helperHour.minutes"></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" translate="modules.helperHours.hours.remark"></label> <textarea type="textarea" class="form-control helper-hours-note" ng-model="helperHour.Note"></textarea></div><div class="form-group clearfix"><button type="button" class="btn btn-default pull-right" ng-click="self.accordionClick($event, self.group.id, helperHour.id)" translate="generalTerms.close"></button> <button type="button" class="btn btn-info pull-right mr-10" title="{{\'modules.helperHours.hours.newDiv\' |translate}}" ng-click="self.duplicate(self.group.id, helperHour.id)"><i class="fa fa-files-o"></i></button> <button type="button" class="btn btn-danger pull-right mr-10" ng-if="helperHour.id !== helperHour.parentId" title="{{\'modules.helperHours.hours.removeHelperHoursDate\' |translate}}" ng-click="self.remove(self.group.id, helperHour.id)"><i class="ion-ios-trash"></i></button></div></div></div></div></uib-accordion><div ng-if="!self.group.helperHours.length"><i translate="modules.helperHours.hours.noHelperRecords"></i></div><button class="btn btn-sm btn-info" ng-if="self.group.helperHours.length" ng-click="self.allSelect(self.group.id)">{{self.someSelected[self.group.id] ? (\'modules.helperHours.hours.allDeSelect\' |translate) : (\'modules.helperHours.hours.allSelect\' |translate)}}</button></div><div class="mt-20 p-10 pb-13 border-top border-bottom" ng-if="(self.step+1)===self.groupedHelperHours.length"><label class="custom-checkbox"><input type="checkbox" name="acceptTransferCheckbox" class="from-control" ng-model="self.acceptTransferCheckbox" required="" required-message="\'modules.helperHours.hours.requiredSafe\' |translate"> <span><span class="font-weight-500" ng-if="self.combinedHelpers">{{\'modules.helperHours.hours.acceptTransferTextOne\' |translate}} <span class="text-info">{{self.leftPad(self.combinedHours, \'00\')}}:{{self.leftPad(self.combinedMinutes, \'00\')}}</span> {{\'modules.helperHours.hours.acceptTransferTextTwo\' |translate}} <span class="text-info">{{self.combinedHelpers}}</span> {{\'modules.helperHours.hours.acceptTransferTextthree\' |translate}}</span> <span class="font-weight-500" ng-if="!self.combinedHelpers">{{\'modules.helperHours.hours.forThisEvent\' |translate}} <strong translate="modules.helperHours.hours.none"></strong> {{\'modules.helperHours.hours.forThisEventTwo\' |translate}}</span></span></label><div class="ml-20 pl-2"><i translate="modules.helperHours.hours.thisDialog"><span class="font-weight-500" translate="modules.helperHours.hours.note"></span></i></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-default no-animation" ng-if="self.step > 0" ng-click="self.prevNextSave()" translate="generalTerms.back"></button> <button type="submit" class="btn btn-primary no-animation" ng-disabled="!self.acceptTransferCheckbox" ng-if="(self.step + 1) === self.groupedHelperHours.length" ng-click="self.prevNextSave(true)" translate="generalTerms.save"></button> <button type="button" class="btn btn-info no-animation" ng-if="(self.step + 1) !== self.groupedHelperHours.length" ng-click="self.prevNextSave(true)" translate="modules.helperHours.hours.next"></button></div></form></div>');
$templateCache.put('app/theme/components/modals/helperHoursTransferModal/uib-accordion-group.tpl.html','<div class="panel" ng-class="panelClass || \'panel-default\'"><div role="tab" id="{{::headingId}}" aria-selected="{{isOpen}}" class="panel-heading" ng-keypress="toggleOpen($event)"><h4 class="panel-title"><div role="button" data-toggle="collapse" href="" aria-expanded="{{isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle" uib-accordion-transclude="heading"><span uib-accordion-header="" ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></div></h4></div><div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!isOpen}}" role="tabpanel" class="panel-collapse collapse" uib-collapse="!isOpen"><div class="panel-body" ng-transclude=""></div></div></div>');
$templateCache.put('app/theme/components/modals/inspectionAssignmentModal/addInspection.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.material.addMaterial.inspection.assignInspection"></h4></div><div class="modal-body"><div class="form-group"><div><label translate="generalTerms.inspection"></label><inspection-selector ctx="self.divisionId" selected-inspection="self.selectedInspection" excluded-ids="self.excludedIds" ng-disabled="self.isEdit || self.viewOnly"></inspection-selector></div><div ng-if="self.selectedInspection" class="mt-20"><div class="col-md-12 p-0"><label translate="generalTerms.description"></label> <span uib-tooltip="{{ \'modules.material.addMaterial.inspection.autoSetDescText\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-magic text-warning ml-5" ng-if="self.autoSetDesc"></i></span> <textarea type="text" class="form-control" ng-disabled="self.viewOnly" placeholder="{{ \'generalTerms.description\' | translate }}" ng-model="self.inspectionToAdd.meta.Description">\n          </textarea></div><div class="mt-20 col-md-12 p-0"><label translate="generalTerms.mandatory"></label><div><ba-switcher switcher-style="primary" switcher-disabled="self.disableMandatoryChange || self.viewOnly" switcher-keys="self.switcherKeys" switcher-value="self.inspectionToAdd.meta.Mandatory"></ba-switcher></div></div><div class="mt-20 col-md-6 p-0"><div><span><label translate="modules.material.addMaterial.inspection.interval"></label> <span ng-if="self.selectedInspection.PeriodicInspection" uib-tooltip="{{ \'modules.material.addMaterial.inspection.inheritedIntervalText\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-magic text-warning ml-5" ng-if="self.isInheritedInterval"></i></span> <span ng-if="self.selectedInspection.PeriodicInspection && self.selectedInspection.MaximumInterval" uib-tooltip="{{ \'modules.material.addMaterial.inspection.maxIntervalText\' | translate:{interval: self.maxInterval || self.selectedInspection.MaximumInterval} }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-info-circle text-info ml-5"></i></span></span> <input type="number" min="1" ng-disabled="self.viewOnly" class="form-control" ng-model="self.inspectionToAdd.meta.Interval" ng-change="self.validateInterval(self.inspectionToAdd.meta.Interval)"></div></div><div class="mt-20 col-md-12 p-0" ng-if="self.materialMode"><label ng-class="{\'required-label\': self.firstDueDateRequired}" translate="modules.material.addMaterial.inspection.firstDueDate"></label> <span uib-tooltip="{{ \'modules.material.addMaterial.inspection.autoSetfddText\' | translate }}" tooltip-class="arno-tooltip" class="arno-tooltip__help" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-magic text-warning ml-10" ng-if="self.fddAutoSet"></i></span><div class="input-group"><input id="firstDueDate" name="firstDueDate" class="form-control" type="text" uib-datepicker-popup="{{self.datepicker.format}}" datepicker-options="self.datepicker.options" is-open="self.fddOpen" close-text="{{ \'generalTerms.close\' | translate }}" show-button-bar="false" ng-model="self.inspectionToAdd.meta.FirstDueDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="self.fddOpen = !self.fddOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()"><span ng-if="self.viewOnly" translate="generalTerms.close"></span> <span ng-if="!self.viewOnly" translate="generalTerms.cancel"></span></button> <button type="button" class="btn btn-primary" ng-if="!self.viewOnly" ng-click="self.applyModal()" ng-disabled="(!self.inspectionToAdd.meta.FirstDueDate && self.firstDueDateRequired && self.materialMode) || !self.selectedInspection" translate="generalTerms.add"></button></div></div>');
$templateCache.put('app/theme/components/modals/mailModal/sendMailToMembers.html','<div class="modal-content"><form id="sendMailToMembersForm" name="sendMailToMembersForm" novalidate=""><div class="modal-header" ng-class="{\'bg-warning text-white\': $ctrl.noMembers}"><h4 ng-class="{\'modal-title\': !$ctrl.noMembers}" translate="components.modals.mailModal.title">Nachricht an Mitglieder versenden</h4></div><div class="modal-body"><div ng-if="$ctrl.noMembers"><p translate="components.modals.mailModal.noMembersText">Es kann keine E-Mail an Mitglieder versendet werden. Dies k\xF6nnte verschiedene Ursachen haben:</p><ul><li translate="components.modals.mailModal.noMemberCause1">Es wurden keine Mitglieder selektiert</li><li translate="components.modals.mailModal.noMemberCause2">F\xFCr die Mitglieder wurden keine g\xFCltigen E-Mail Adressen hinterlegt</li></ul></div><div ng-if="!$ctrl.noMembers"><p translate="components.modals.mailModal.confirmText">Bet\xE4tige die Schaltfl\xE4che "Senden" um dein E-Mail Programm zu \xF6ffnen.</p><p>{{ (\'components.modals.mailModal.textPart1\' | translate:{ memberInfos: $ctrl.memberInfos.length }) }} <strong translate="components.modals.mailModal.textPart2" translate-values="{ memberInfos: $ctrl.memberInfos.length }"></strong> {{ (\'components.modals.mailModal.textPart3\' | translate:{ memberInfos: $ctrl.memberInfos.length }) }}</p><p ng-if="$ctrl.missingMemberInfos.length"><strong translate="components.modals.mailModal.note">Hinweis:</strong> {{ (\'components.modals.mailModal.missingInfosText1\' | translate:{ missingInfos: $ctrl.missingMemberInfos.length }) }}<br>{{ (\'components.modals.mailModal.missingInfosText2\' | translate:{ missingInfos: $ctrl.missingMemberInfos.length }) }}&nbsp;<u translate="components.modals.mailModal.missingInfosText3">nicht in der Empf\xE4ngerliste</u>&nbsp; {{ (\'components.modals.mailModal.missingInfosText4\' | translate:{ missingInfos: $ctrl.missingMemberInfos.length }) }}<br>{{$ctrl.missingMemberNames}}</p><p ng-if="$ctrl.memberInfos.length > 1"><strong translate="components.modals.mailModal.note">Hinweis:</strong>{{ (\'components.modals.mailModal.text1\' | translate) }}<br><span class="my-5 inline-block"><u>{{ (\'components.modals.mailModal.text2\' | translate) }}</u>&nbsp;{{ (\'components.modals.mailModal.text3\' | translate) }}&nbsp;<u>{{ (\'components.modals.mailModal.text4\' | translate) }}</u>&nbsp;{{ (\'components.modals.mailModal.text5\' | translate) }}</span><br>{{ (\'components.modals.mailModal.text6\' | translate) }}</p><p ng-if="$ctrl.memberInfos.length > 70"><strong translate="components.modals.mailModal.note"></strong> {{ \'components.modals.mailModal.warnManyRecipients\' | translate }}</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="{\'pull-left\': !$ctrl.noMembers}" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="submit" class="btn btn-default" ng-if="!$ctrl.noMembers" ng-click="$ctrl.applyModal(\'\\n\', true)" title="In Zwischenablage kopieren" translate-attr="{title : \'components.modals.mailModal.copyToClipboard\'}"><i class="fa fa-clipboard"></i></button> <button type="submit" class="btn btn-info" ng-if="!$ctrl.noMembers && $ctrl.memberInfos.length === 1" ng-click="$ctrl.applyModal()"><i class="fa fa-envelope"></i>{{ (\'components.modals.mailModal.send\' | translate) }}</button> <button type="submit" class="btn btn-info" ng-if="!$ctrl.noMembers && $ctrl.memberInfos.length > 1" ng-click="$ctrl.applyModal(\';\')"><i class="fa fa-envelope"></i>{{ (\'components.modals.mailModal.sendOutlook\' | translate) }}</button> <button type="submit" class="btn btn-info" ng-if="!$ctrl.noMembers && $ctrl.memberInfos.length > 1" ng-click="$ctrl.applyModal(\',\')"><i class="fa fa-envelope"></i>{{ (\'components.modals.mailModal.sendOther\' | translate) }}</button></div></form></div>');
$templateCache.put('app/theme/components/pageTop/pageTopModal/pageTopModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.pageTop.termsOfOrga"></h4></div><div class="modal-body"><div>{{$modalCtrl.agbText}}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$modalCtrl.dismissModal()" translate="components.pageTop.decline"></button> <button type="button" class="btn btn-primary" ng-click="$modalCtrl.applyModal()" translate="components.pageTop.acceptTerms"></button></div></div>');
$templateCache.put('app/theme/components/qualificationList/memberQualificationModal/memberQualification.html','<div class="modal-content"><form id="qualificationForm" name="qualificationForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.title" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><div ng-show="$modalCtrl.qualification"><div ng-if="$modalCtrl.type === \'instruction\'" class="form-group"><label translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructionMaterial" translate-values="$modalCtrl.translateValues"></label><ui-select ng-model="$modalCtrl.qualification.InstructionMaterial" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructionMaterialPlaceholder\'| translate:$modalCtrl.translateValues)}}">{{$select.selected.asString}}</ui-select-match><ui-select-choices position="down" repeat="material in $modalCtrl.availableMaterials | filter: {$: $select.search} | orderBy:[\'asString\']" group-by="\'TypeTranslated\'"><span>{{ material.asString }}</span></ui-select-choices></ui-select></div></div><div class="form-group list-form-add-new" ng-if="!$modalCtrl.editMode"><label translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectLabel" translate-values="$modalCtrl.translateValues" class="control-label required-label"></label><ui-select ng-model="$modalCtrl.qualificationToAdd" class="btn-group bootstrap-select form-control" append-to-body="false" on-select="$modalCtrl.qualificationAdd($modalCtrl.qualificationToAdd)" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.searchPlaceholder\'| translate:$modalCtrl.translateValues)}}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" repeat="qualificationChoice in $modalCtrl.flatQualificationHierarchy | filter: {$: $select.search} | orderBy:[\'GroupName\',\'Name\']" group-by="\'GroupName\'"><i ng-class="{\'ion-ios-people\':!qualificationChoice.DivisionId,\'ion-ios-people-outline\':qualificationChoice.DivisionId}"></i> <span>{{ qualificationChoice.Name }}</span></ui-select-choices></ui-select></div><div ng-show="$modalCtrl.qualification"><div class="row"><div class="form-group col-md-6"><label for="acquireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.aquireDateLabel" class="control-label required-label" translate-values="{ qualification: $modalCtrl.qualification.Name, typeSingular: $modalCtrl.translateValues.typeSingular }"></label><div class="input-group"><input data-cy="components-qualificationlist-modal-acquiredate" id="acquireDate" name="acquireDate" class="form-control" type="text" uib-datepicker-popup="{{$modalCtrl.acquireDatepicker.format}}" datepicker-options="$modalCtrl.acquireDatepicker.options" is-open="$modalCtrl.acquireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="$modalCtrl.qualification.AcquireDate" ng-model-options="{ debounce: 200 }" required-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.noRefDate\' | translate)" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.acquireDateOpened = !$modalCtrl.acquireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-6"><label for="expireDate" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateLabel" translate-values="{ qualification: $modalCtrl.qualification.Name, typeSingular: $modalCtrl.translateValues.typeSingular }"></label><div class="input-group"><input data-cy="components-qualificationlist-modal-expiredate" id="expireDate" name="expireDate" class="form-control" type="text" validator="$modalCtrl.checkForValidExpireDate()" uib-datepicker-popup="{{$modalCtrl.expireDatepicker.format}}" datepicker-options="$modalCtrl.expireDatepicker.options" is-open="$modalCtrl.expireDateOpened" close-text="(\'generalTerms.close\'| translate)" show-button-bar="false" invalid-message="(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.dateInValidMsg\'| translate)" ng-model="$modalCtrl.qualification.ExpireDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.expireDateOpened = !$modalCtrl.expireDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block sub-little-text" ng-if="$modalCtrl.ExpireDateViaValidityPeriodHelper">> <i class="fa fa-info-circle"></i> {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText1\' | translate }} {{ \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.expireDateHelperText2\' | translate }}</span></div></div><div class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="$modalCtrl.qualification.InitialInstructionByManufacturerOrAuthorizedPerson"> <span>{{ ($modalCtrl.type === \'instruction\' ? \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturer\' : \'modules.personnel.dossier.overview.qualificationList.memberQualiModal.initialInstructionManufacturerQual\' ) | translate }}</span></label></div><div class="form-group"><label for="instructingPersonTypeSelection" class="control-label" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.selectInstructingPerson" translate-values="$modalCtrl.translateValues"></label><div class="d-flex"><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio1" ng-model="$modalCtrl.selectedPersonFieldType" value="member"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionMember"></span></label></div><div class="pr-15"><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio2" ng-model="$modalCtrl.selectedPersonFieldType" value="contact"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionContact"></span></label></div><div><label class="radio-inline custom-radio nowrap"><input type="radio" name="instructingPersonTypeSelection" id="inlineRadio3" ng-model="$modalCtrl.selectedPersonFieldType" value="organisation"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.instructingSelectionOrganisation"></span></label></div></div><div class="form-group"><member-selector ng-show="$modalCtrl.selectedPersonFieldType === \'member\'" initial-member-value="$modalCtrl.qualification.InstructingMember" on-member-select="$modalCtrl.instructingMemberSelected" blank-search-on-click="true" only-active="true" keep-after-selection="true" member-exclude="$modalCtrl.memberExclude" divisions="$modalCtrl.divisionIds"></member-selector><contact-selector ng-show="$modalCtrl.selectedPersonFieldType === \'contact\'" on-select="$modalCtrl.instructingContactSelected" selected-contact="$modalCtrl.qualification.InstructingContact" blank-search-on-click="true" only-active="true" divisions="$modalCtrl.divisionIds"></contact-selector><business-partners-selector ng-show="$modalCtrl.selectedPersonFieldType === \'organisation\'" division="$modalCtrl.divisionIds" on-business-partner-select="$modalCtrl.instructingOrganisationSelected" selected-business-partner="$modalCtrl.qualification.InstructingBusinessPartner" append-to-body="false"></business-partners-selector><div ng-if="$modalCtrl.qualification" class="hidden-inputs"><div><input type="hidden" class="form-control" name="InstructingMemberSelected" ng-model="$modalCtrl.qualification.InstructingMemberId"></div><div><input type="hidden" class="form-control" name="InstructingContactSelected" ng-model="$modalCtrl.qualification.InstructingContactId"></div><div><input type="hidden" class="form-control" name="InstructingBusinessPartnerSelected" ng-model="$modalCtrl.qualification.InstructingBusinessPartnerId"></div></div></div></div><div ng-if="$modalCtrl.type === \'qualification\'" class="form-group"><label class="custom-checkbox"><input class="form-control" type="checkbox" ng-model="$modalCtrl.qualification.ForeignQualificationAccepted"> <span translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.foreignQualificationText"></span></label> <textarea class="form-control --vresize" placeholder="{{(\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.foreignQualificationPlaceholder\' | translate)}}" ng-model="$modalCtrl.qualification.ForeignQualificationRemark" ng-disabled="!$modalCtrl.qualification.ForeignQualificationAccepted"></textarea></div><div class="mb-10 form-group"><file-upload unallowed-file-types="$modalCtrl.unallowedFileTypes" upload-url="$modalCtrl.fileUploadUrl" on-file-uploaded="$modalCtrl.onFileUploaded" on-file-download="$modalCtrl.onFileDownload" on-file-preview="$modalCtrl.onFilePreview" on-file-delete="$modalCtrl.onFileDelete" on-upload-started="$modalCtrl.onUploadStarted" file-name="$modalCtrl.qualification.File || $modalCtrl.qualification.FileName" downloadable-file="$modalCtrl.qualification.File" show-remove-button="true" label-text="\'modules.personnel.dossier.overview.qualificationList.memberQualiModal.fileProof\'"></file-upload></div></div></div><div class="modal-footer"><button data-cy="components-qualificationlist-modal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="components-qualificationlist-modal-submit" type="submit" class="btn btn-primary" translate="modules.personnel.dossier.overview.qualificationList.memberQualiModal.accept"></button></div></form></div>');
$templateCache.put('app/theme/components/shiftTemplate/helper/positionValidPopoverContent.html','<div><table class="table table-condensed"><label ng-if="member">{{::member}}</label><tr ng-repeat="statusMap in shiftPositionAttendeeStatusMap" class="no-top-border" ng-if="qualificationValidList[statusMap.prop].length || activityValidList[statusMap.prop].length"><td>{{statusMap.label}}</td><td><div class="arno-tag tag label label-tag" ng-class="statusMap.className" ng-repeat="qualificationId in qualificationValidList[statusMap.prop]"><i class="ion-ribbon-b"></i> {{ ::qualificationIdNameMap[qualificationId].Name }}</div><div class="arno-tag tag label label-tag" ng-class="statusMap.className" ng-repeat="activityId in activityValidList[statusMap.prop]"><i class="fa fa-paint-brush"></i> {{ ::activityIdNameMap[activityId].Title }}</div></td></tr></table></div>');
$templateCache.put('app/theme/components/shiftTemplate/helper/shiftPositionDetails.html','<form id="shiftPositionDetailsForm" name="shiftPositionDetailsForm" novalidate="" angular-validator="" angular-validator-submit="self.submit()"><div class="arno-events arno-shift-template"><div class="row"><div ng-class="{\'col-sm-9\': !self.isTemplate, \'col-sm-12\': self.isTemplate}"><div class="form-group" ng-class="{\'has-error\': !self.hasFunctionSet() && self.shiftPositionDetailsForm.$submitted}"><label class="control-label required-label mr-5">{{ \'modules.events.shiftTemplate.function\' | translate }}</label><arno-ba-help-tooltip text="{{ \'modules.events.shiftTemplate.tooltip.manyFunctionTitles\' | translate }}"></arno-ba-help-tooltip><ui-select name="selectMemberConfession" ng-model="self.position.Function" tagging="self.tagTransform" tagging-label="false" class="btn-group bootstrap-select form-control" reset-search-input="false"><ui-select-match placeholder="{{\'modules.events.shiftTemplate.functionPickerPlaceholder\' | translate}}">{{ $select.selected }}</ui-select-match><ui-select-choices position="down" repeat="function in self.functionProposals" refresh="self.searchFunction($select.search)" refresh-delay="200"><span>{{ function }}</span></ui-select-choices></ui-select><input type="hidden" class="form-control" name="selectMemberConfessionValidation" ng-model="self.selectMemberConfessionEmpty" validator="self.hasFunctionSet()" invalid-message="\'\'"></div></div><div class="col-sm-3 pl-4" ng-if="!self.isTemplate"><div class="form-group row clearfix"><label for="inputPositionCount" class="col-sm-12 control-label primary-label required-label">{{ \'modules.events.shiftTemplate.numberOfPositions\' | translate }}</label><div class="col-sm-12"><input type="number" class="form-control" id="inputPositionCount" name="inputPositionCount" min="1" step="1" placeholder="" ng-model="self.position.PositionCount"></div></div></div></div><div class="row mt-20"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed spd-qualification-add"><thead><tr><th><i class="ion-ribbon-b icon-width"></i>{{ \'modules.events.shiftTemplate.requiredQualifications\' | translate }}</th><th>{{ \'modules.events.shiftTemplate.actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat="qualification in self.position.Qualifications | orderBy:[\'-DivisionId\', \'Name\']"><td class="align-left-force"><i class="icon-width" ng-class="{\'ion-ios-people\':!qualification.DivisionId,\'ion-ios-people-outline\':qualification.DivisionId}"></i> <span>{{ ::qualification.Name }}</span><div ng-if="self.parentCtrl.qualificationRemovalWarning[self.shift.id][self.position.id] && self.parentCtrl.qualificationRemovalWarning[self.shift.id][self.position.id].indexOf(qualification.id) !== -1" class="inline-block mr-3" title="{{ \'modules.events.shiftTemplate.removeQualification\' | translate:{ division: qualification.Division.Name, name: qualification.Name } }}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div class="arno-tag tag label label-tag pull-right mt-2" ng-if="qualification.Division.Name" ng-class="{\'label-success\': self.parentCtrl.isInternalQualification(self.shift, self.position, qualification), \'label-warning\': self.parentCtrl.isInternalQualification(self.shift, self.position, qualification) === false, \'label-danger\': self.parentCtrl.isInternalQualification(self.shift, self.position, qualification) === null}" title="{{ (self.parentCtrl.isInternalQualification(self.shift, self.position, qualification) ? (self.parentCtrl.templateMode ? (\'modules.events.shiftTemplate.templateBaseDivision\' | translate) : (\'modules.events.shiftTemplate.serviceDivision\' | translate)) : \'\') + (self.parentCtrl.isInternalQualification(self.shift, self.position, qualification) === false ? (self.parentCtrl.templateMode ? (\'modules.events.shiftTemplate.templateSubdivision\' | translate) : (\'modules.events.shiftTemplate.sharedDivision\' | translate)) : \'\') + (self.parentCtrl.isInternalQualification(self.shift, self.position, qualification) === null ? (\'modules.events.shiftTemplate.unlinkedDivision\' | translate) : \'\') }}">{{ ::qualification.Division.Name }}</div></td><td><button class="btn btn-danger btn-with-icon btn-xs" ng-click="self.removeQualification(qualification)" title="{{ \'modules.events.shiftTemplate.removeQualification\' | translate }}"><i class="ion-ios-trash"></i>{{ \'modules.events.shiftTemplate.delete\' | translate }}</button></td></tr><tr ng-if="!self.position.Qualifications.length"><td class="text-center" colspan="99"><i>{{ \'modules.events.shiftTemplate.noQualificationsRequired\' | translate }}</i></td></tr></tbody></table></div></div><div class="col-xs-12"><div class="form-group list-form-add-new mt-5"><div class="input-group input-group-with-select input-group-with-btn-text"><ui-select ng-model="self.qualificationToAdd" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{ \'modules.events.shiftTemplate.addQualification\' | translate }}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" repeat="qualification in self.qualificationProposals" refresh="self.searchQualification($select.search)" refresh-delay="200" group-by="self.reqEntityGroupFunc"><div ng-if="!qualification.none"><i ng-class="{\'ion-ios-people\':!qualification.DivisionId,\'ion-ios-people-outline\':qualification.DivisionId}"></i> <span>{{ qualification.Name }}</span><div class="arno-tag tag label label-tag label-info pull-right" ng-if="qualification.Division">{{qualification.Division.Name}}</div></div><div ng-if="qualification.none" class="btn-with-icon"><span ng-if="qualification.foundNone"><i class="fa fa-times"></i> <span><i>{{ \'modules.events.shiftTemplate.foundNoValidQualification\' | translate }}</i></span></span> <span ng-if="!qualification.foundNone"><i>{{ \'modules.events.shiftTemplate.enterQualification\' | translate }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn ui-select-fixed-button-position"><button type="button" class="btn btn-success" ng-click="self.qualificationAdd(self.qualificationToAdd)" ng-disabled="!self.qualificationToAdd || self.qualificationToAdd.none"><i class="ion-plus-round"></i>{{ \'modules.events.shiftTemplate.add\' | translate }}</button></span></div></div></div></div><div class="row mt-10"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed spd-activity-add"><thead><tr><th><i class="fa fa-paint-brush icon-width"></i>{{ \'modules.events.shiftTemplate.requiredTask\' | translate }}</th><th>{{ \'modules.events.shiftTemplate.actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat="activity in self.position.Activities | orderBy:[\'-DivisionId\', \'Name\']"><td class="align-left-force"><i class="icon-width" ng-class="{\'ion-ios-people\':!activity.DivisionId,\'ion-ios-people-outline\':activity.DivisionId}"></i> <span>{{ ::activity.Title }}</span><div ng-if="self.parentCtrl.activityRemovalWarning[self.shift.id][self.position.id] && self.parentCtrl.activityRemovalWarning[self.shift.id][self.position.id].indexOf(activity.id) !== -1" class="inline-block mr-3" title="{{ \'modules.events.shiftTemplate.unlinkedShiftRemoveTask\' | translate: { division: activity.Division.Name, title: activity.Title } }}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div class="arno-tag tag label label-tag pull-right mt-2" ng-if="activity.Division.Name" ng-class="{ \'label-success\': self.parentCtrl.isInternalActivity(self.shift, self.position, activity), \'label-warning\': self.parentCtrl.isInternalActivity(self.shift, self.position, activity) === false, \'label-danger\': self.parentCtrl.isInternalActivity(self.shift, self.position, activity) === null }" title="{{ (self.parentCtrl.isInternalActivity(self.shift, self.position, activity) ? (self.parentCtrl.templateMode ? ( \'modules.events.shiftTemplate.templateBaseDivision\' | translate ) : ( \'modules.events.shiftTemplate.serviceDivision\' | translate )) : \'\') + (self.parentCtrl.isInternalActivity(self.shift, self.position, activity) === false ? (self.parentCtrl.templateMode ? ( \'modules.events.shiftTemplate.templateSubdivision\' | translate ) : ( \'modules.events.shiftTemplate.sharedDivision\' | translate )) : \'\') + (self.parentCtrl.isInternalActivity(self.shift, self.position, activity) === null ? ( \'modules.events.shiftTemplate.unlinkedDivision\' | translate ) : \'\') }}">{{ ::activity.Division.Name }}</div><div><span class="icon-width"></span><div class="arno-tag tag label label-tag label-info mt-2">{{ ::self.characteristicMap[activity.Characteristic] }}</div></div></td><td><button class="btn btn-danger btn-with-icon btn-xs" ng-click="self.removeActivity(activity)" title="{{ \'modules.events.shiftTemplate.removeTask\' | translate }}"><i class="ion-ios-trash"></i>{{ \'modules.events.shiftTemplate.delete\' | translate }}</button></td></tr><tr ng-if="!self.position.Activities.length"><td class="text-center" colspan="99"><i>{{ \'modules.events.shiftTemplate.noTasksRequired\' | translate }}</i></td></tr></tbody></table></div></div><div class="col-xs-12"><div class="form-group list-form-add-new mt-5"><div class="input-group input-group-with-select input-group-with-btn-text"><ui-select ng-model="self.activityToAdd" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{ \'modules.events.shiftTemplate.addTask\' | translate }}">{{$select.selected.Title}}</ui-select-match><ui-select-choices position="down" repeat="activity in self.activityProposals" refresh="self.searchActivity($select.search)" refresh-delay="200" group-by="self.reqEntityGroupFunc"><div ng-if="!activity.none"><i ng-class="{\'ion-ios-people\':!activity.DivisionId,\'ion-ios-people-outline\':activity.DivisionId}"></i> <span>{{ activity.Title }}</span><div class="arno-tag tag label label-tag label-info pull-right" ng-if="activity.Division">{{activity.Division.Name}}</div></div><div ng-if="activity.none" class="btn-with-icon"><span ng-if="activity.foundNone"><i class="fa fa-times"></i> <span><i>{{ \'modules.events.shiftTemplate.foundNoValidTask\' | translate }}</i></span></span> <span ng-if="!activity.foundNone"><i>{{ \'modules.events.shiftTemplate.enterTask\' | translate }}</i></span></div></ui-select-choices></ui-select><span class="input-group-btn ui-select-fixed-button-position"><button type="button" class="btn btn-success" ng-click="self.activityAdd(self.activityToAdd)" ng-disabled="!self.activityToAdd || self.activityToAdd.none"><i class="ion-plus-round"></i>{{ \'modules.events.shiftTemplate.add\' | translate }}</button></span></div></div></div></div><div class="row mt-20" ng-if="!self.parentCtrl.templateMode && !self.isTemplate"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed spd-positioned-member-add"><thead><tr><th>{{ \'modules.events.shiftTemplate.assignedPeople\' | translate }}</th><th>{{ \'modules.events.shiftTemplate.actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat="memberPosition in self.memberPositionList"><td class="align-left-force"><div class="inline-block" popover-placement="top-left" popover-trigger="mouseenter" popover-append-to-body="true" uib-popover-html="self.getPositionReqValidPopover( memberPosition.Member, self.qualificationMap[memberPosition.MemberId].validList, self.activityMap[memberPosition.MemberId].validList, self.qualificationHelperMap, self.activityHelperMap )"><status-light ng-if="self.showRequirementValidity" class="\'light-inline mr-5\'" is-green="self.combinedValidStateMap[memberPosition.MemberId] === true" use-yellow-light="true" is-yellow="self.combinedValidStateMap[memberPosition.MemberId] === false"></status-light><i class="fa fa-child underage-indicator" ng-if="!self.checkAttendeesIsLegalAge[memberPosition.MemberId || memberPosition.Member.id]" title="{{ (self.checkAttendeesIsLegalAge[memberPosition.MemberId || memberPosition.Member.id] === false) ? ( \'modules.events.shiftTemplate.underage\' | translate ) : ( \'modules.events.shiftTemplate.possiblyUnderage\' | translate ) }}" ng-class="self.checkAttendeesIsLegalAge[memberPosition.MemberId || memberPosition.Member.id] === false ? \'text-primary\' : \'text-warning\'"></i> <span ng-class="{ \'member-inactive\': memberPosition.Member.isInactive }">{{ memberPosition.fullName || memberPosition.Member.fullName }}</span></div><div ng-if="self.parentCtrl.attendanceRemovalWarning[memberPosition.MemberId][self.shift.id]" class="inline-block mr-3" title="{{ \'modules.events.shiftTemplate.changeDivisionRemoveDivision\' | translate: { name: memberPosition.fullName || memberPosition.Member.fullName } }}"><i class="fa fa-exclamation-triangle text-danger"></i></div><div class="arno-tag tag label label-tag pull-right mt-2" ng-if="memberPosition.Division.Name" ng-class="{ \'label-success\': self.parentCtrl.isInternalAttendee(self.shift, memberPosition), \'label-warning\': self.parentCtrl.isInternalAttendee(self.shift, memberPosition) === false, \'label-danger\': self.parentCtrl.isInternalAttendee(self.shift, memberPosition) === null}" title="{{ (self.parentCtrl.isInternalAttendee(self.shift, memberPosition) ? ( \'modules.events.shiftTemplate.fromShiftDivision\' | translate ) : \'\') + (self.parentCtrl.isInternalAttendee(self.shift, memberPosition) === false ? ( \'modules.events.shiftTemplate.fromSharedDivision\' | translate ) : \'\') + (self.parentCtrl.isInternalAttendee(self.shift, memberPosition) === null ? ( \'modules.events.shiftTemplate.fromUnlinkedDivision\' | translate ) : \'\') }}">{{ memberPosition.Division.Name }}</div></td><td><button class="btn btn-danger btn-with-icon btn-xs" ng-click="self.removeMemberPosition(memberPosition)" title="{{ \'modules.events.shiftTemplate.removeLink\' | translate }}"><i class="ion-ios-trash"></i>{{ \'modules.events.shiftTemplate.delete\' | translate }}</button></td></tr><tr ng-if="!self.memberPositionList.length"><td class="text-center" colspan="99"><i>{{ \'modules.events.shiftTemplate.noParticipantsAssigned\' | translate }}</i></td></tr></tbody></table></div></div><div class="col-xs-12"><div class="form-group list-form-add-new mt-5"><div class="input-group input-group-with-select input-group-with-btn-text"><ui-select ng-model="self.shiftMemberToAdd" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="{{ \'modules.events.shiftTemplate.assignPerson\' | translate }}">{{$select.selected.fullName || $select.selected.Member.fullName}}</ui-select-match><ui-select-choices position="down" repeat="shiftMember in self.attendeeChoices | filter: self.shiftMemberFilter($select.search) | orderBy:[self.attendeeChoiceSortGroup,self.attendeeChoiceSortBase]" group-by="self.groupByRequirementValidity"><div><div popover-placement="top-left" popover-trigger="mouseenter" popover-append-to-body="true" uib-popover-html="self.getPositionReqValidPopover( self.qualificationMap[shiftMember.MemberId].validList, self.activityMap[shiftMember.MemberId].validList, self.qualificationHelperMap, self.activityHelperMap)"><i class="fa fa-child underage-indicator" ng-if="!self.checkAttendeesIsLegalAge[shiftMember.MemberId || shiftMember.Member.id]" title="{{ (self.checkAttendeesIsLegalAge[shiftMember.MemberId || shiftMember.Member.id] === false) ? ( \'modules.events.shiftTemplate.underage\' | translate ) : ( \'modules.events.shiftTemplate.possiblyUnderage\' | translate ) }}" ng-class="self.checkAttendeesIsLegalAge[shiftMember.MemberId || shiftMember.Member.id] === false ? \'text-primary\' : \'text-warning\'"></i> <span>{{ shiftMember.fullName || shiftMember.Member.fullName }}</span><div class="arno-tag tag label label-tag label-info pull-right">{{shiftMember.Division.Name}}</div></div></div></ui-select-choices></ui-select><span class="input-group-btn ui-select-fixed-button-position"><button type="button" class="btn btn-success" ng-click="self.shiftMemberAdd(self.shiftMemberToAdd)" ng-disabled="!self.shiftMemberToAdd"><i class="ion-plus-round"></i>{{ \'modules.events.shiftTemplate.assign\' | translate }}</button></span></div></div></div></div></div><button type="submit" class="btn btn-primary no-animation" ng-hide="true"></button></form>');
$templateCache.put('app/theme/components/shiftTemplate/modals/shiftImportTemplate.html','<div class="modal-content"><form id="importFromTemplateForm" name="importFromTemplateForm" novalidate=""><div class="modal-header" ng-if="$sit.searchView"><h4 class="modal-title">{{ \'modules.events.shiftTemplate.modals.addFromTemplate\' | translate: { positionSource: !!$sit.positionMode, label: $sit.parentLabel } }}</h4></div><div class="modal-body arno-events shift-import-template" ng-class="{\'pt-0\': $sit.searchView, \'pt-5\': !$sit.searchView}"><div class="search-group no-animation" ng-if="$sit.searchView"><div class="form-group row clearfix"><label class="col-sm-12 control-label primary-label">{{ \'modules.events.shiftTemplate.modals.searchTerm\' | translate }}</label><div class="col-sm-12"><input type="text" class="form-control" maxlength="254" placeholder="" ng-model="$sit.searchTerm"></div></div><div class="form-group row clearfix"><label class="col-sm-12 control-label">{{ \'modules.events.shiftTemplate.modals.eventType\' | translate }}</label><div class="col-sm-12"><ui-select ng-model="$sit.searchServiceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" append-to-body="false" search-enabled="false"><ui-select-match><span ng-if="$sit.searchServiceType.none"><i>{{$sit.searchServiceType.Name}}</i></span> <span ng-if="!$sit.searchServiceType.none">{{$sit.searchServiceType.Name}}</span></ui-select-match><ui-select-choices position="down" repeat="serviceType in $sit.availableServiceTypes"><span>{{serviceType.Name}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label class="col-sm-12 control-label">{{ \'modules.events.shiftTemplate.modals.eventCategories\' | translate }}</label><div class="col-sm-12"><tag-picker default-label="(\'modules.events.shiftTemplate.modals.allCategories\' | translate)" tags="$sit.availableServiceCategories" selected-tags="$sit.searchServiceCategories" hide-division-name="true"></tag-picker></div></div></div><div class="search-group no-animation" ng-if="!$sit.searchView"><div ba-panel="" ba-panel-class="tabs-panel with-scroll inline-panel"><uib-tabset class="inline-tabset"><uib-tab ng-repeat="tab in $sit.tabsConfig" select="$sit.setActiveTab(tab.ident)"><uib-tab-heading>{{ tab.heading }}<arno-ba-help-tooltip text="{{tab.description}}"></arno-ba-help-tooltip></uib-tab-heading><div ng-if="$sit.searchMode === tab.ident"><label>{{ \'modules.events.shiftTemplate.modals.searchResults\' | translate }}</label><div ng-if="$sit.templateResults.length"><div js-tree="$sit.treeOptions" tree="$sit.templateTree" ng-model="$sit.templateResults"></div></div><div ng-if="$sit.possibleResultCutoff" class="text-center my-10"><i>{{ \'modules.events.shiftTemplate.modals.toManyResultsMsg\' | translate }}</i></div><div ng-if="!$sit.templateResults.length" class="text-center my-10"><i>{{ \'modules.events.shiftTemplate.modals.toManyResultsMsg\' | translate }}</i></div></div></uib-tab></uib-tabset></div></div></div><div class="modal-footer"><div style="display:flex; justify-content:space-between;"><button type="button" class="btn btn-default" ng-click="$sit.resetAllInput()">{{ \'modules.events.shiftTemplate.modals.resetAllFilter\' | translate }}</button><div><button type="button" class="btn btn-default btn-with-icon no-animation pull-left" ng-click="$sit.showSearchView()" ng-if="!$sit.searchView"><i class="ion-chevron-left font-size-12"></i> <span>{{ \'modules.events.shiftTemplate.modals.backToSearch\' | translate }}</span></button> <button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'modules.events.shiftTemplate.cancel\' | translate }}</button> <button type="button" class="btn btn-info btn-with-icon no-animation" ng-click="$sit.search()" ng-if="$sit.searchView"><i class="fa fa-search"></i>{{ \'modules.events.shiftTemplate.search\' | translate }}</button> <button type="submit" class="btn btn-primary no-animation" ng-if="!$sit.searchView" ng-click="$sit.applyModal()" ng-disabled="!$sit.getCheckedTemplateResults(true)">{{ \'modules.events.shiftTemplate.add\' | translate }}</button></div></div></div></form></div>');
$templateCache.put('app/theme/components/shiftTemplate/modals/shiftMetaDetails.html','<div class="modal-content"><form id="shiftMetaDetailsForm" name="shiftMetaDetailsForm" novalidate="" angular-validator="" angular-validator-submit="$smd.applyModal()"><div class="modal-header"><h4 class="modal-title">{{$smd.isNew ? (\'modules.events.shiftTemplate.newShift\' | translate) : (\'modules.events.shiftTemplate.modals.editSubject\' | translate: { subject: $smd.shift.Subject }) }}</h4></div><div class="modal-body arno-events"><div class="form-group row clearfix"><label for="inputSubject" class="col-sm-12 control-label primary-label required-label">{{ \'modules.events.shiftTemplate.modals.justTitle\' | translate }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputSubject" name="inputSubject" placeholder="" ng-model="$smd.shift.Subject" max-char="255" required-message="\'modules.events.shiftTemplate.modals.pleaseEnterTitle\' | translate" required="" invalid-message="\'modules.events.shiftTemplate.modals.entryInvalid\' | translate"></div></div><div class="form-group row clearfix mt-40"><div class="col-sm-12"><div class="row" ng-class="{\'event-combined-date-time-picker\': !$smd.parentCtrl.options.templateMode}"><div class="col-sm-12 mb-10" ng-if="$smd.parentCtrl.options.templateMode"><div class="clearfix"><label class="control-label with-help-tooltip" ng-class="{\'required-label\': $smd.templateShiftTimespan}">{{ \'modules.events.shiftTemplate.shiftStart\' | translate }}<arno-ba-help-tooltip ng-if="$ceEvent.viewMode !== \'view\'" text="{{ \'modules.events.shiftTemplate.tooltip.shiftTemplate\' | translate }}"></arno-ba-help-tooltip></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$smd.templateShiftTimespan"></ba-switcher></div></div><div class="row"><div class="col-sm-4"><input type="number" ng-model="$smd.startDateOffsetDays" class="form-control" ng-disabled="!$smd.templateShiftTimespan"></div><div class="col-sm-8 pt-9 pl-0">{{ \'modules.events.shiftTemplate.modals.daysOffset\' | translate: { plural: $smd.abs($smd.startDateOffsetDays) !== 1 } }} <span class="font-weight-500">{{ \'modules.events.shiftTemplate.startOfEvent\' | translate }}</span>.</div></div><div class="text-center mt-15 text-italic">{{ $smd.parentCtrl.calcDateOffsetText($smd.startDateOffsetDays, true) }}</div></div><div class="col-sm-8" ng-if="!$smd.parentCtrl.options.templateMode"><label class="control-label required-label">{{ \'modules.events.shiftTemplate.shiftStart\' | translate }}</label><p class="input-group"><input type="text" name="inputStartDate" class="form-control" uib-datepicker-popup="{{$smd.datepicker.format}}" datepicker-options="$smd.datepicker.options" ng-model="$smd.shift.StartDate" is-open="$smd.openedInputStartDate" close-text="{{ \'modules.events.shiftTemplate.close\' | translate }}" show-button-bar="false" validator="$smd.isValidDate()" invalid-message="\'modules.events.shiftTemplate.modals.pleaseCorrectTime\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$smd.openedInputStartDate = !$smd.openedInputStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-class="{\'col-sm-4\': !$smd.parentCtrl.options.templateMode, \'col-sm-12\': $smd.parentCtrl.options.templateMode}"><div uib-timepicker="" ng-model="$smd.shift.StartDate" mousewheel="false" minute-step="15" ng-disabled="!$smd.templateShiftTimespan" show-meridian="false"></div><input type="hidden" class="form-control" ng-if="$smd.parentCtrl.options.templateMode" name="templateStartDateValidation" ng-model="$smd.templateStartDateValidationEmpty" validator="$smd.isValidDate()" invalid-message="\'modules.events.shiftTemplate.modals.pleaseCorrectTime\' | translate"></div></div></div></div><div class="form-group row clearfix"><div class="col-sm-12"><div class="row" ng-class="{\'event-combined-date-time-picker\': !$smd.parentCtrl.options.templateMode}"><div class="col-sm-12 mb-10" ng-if="$smd.parentCtrl.options.templateMode"><div class="clearfix"><label class="control-label" ng-class="{\'required-label\': $smd.templateShiftTimespan}">{{ \'modules.events.shiftTemplate.shiftEnd\' | translate }}</label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$smd.templateShiftTimespan"></ba-switcher></div></div><div class="row"><div class="col-sm-4"><input type="number" ng-model="$smd.endDateOffsetDays" min="0" class="form-control" ng-disabled="!$smd.templateShiftTimespan"></div><div class="col-sm-8 pt-9 pl-0">{{ \'modules.events.shiftTemplate.modals.daysOffset\' | translate: { plural: $smd.endDateOffsetDays !== 1 } }} <span class="font-weight-500">{{ \'modules.events.shiftTemplate.shiftStart\' | translate }}</span>.</div></div><div class="text-center mt-15 text-italic">{{ $smd.parentCtrl.calcDateOffsetText($smd.endDateOffsetDays) }}</div></div><div class="col-sm-8" ng-if="!$smd.parentCtrl.options.templateMode"><label class="control-label required-label">{{ \'modules.events.shiftTemplate.shiftEnd\' | translate }}</label><p class="input-group"><input type="text" name="inputEndDate" class="form-control" uib-datepicker-popup="{{$smd.datepicker.format}}" datepicker-options="$smd.datepicker.options" ng-model="$smd.shift.EndDate" is-open="$smd.openedInputEndDate" close-text="{{ \'modules.events.shiftTemplate.close\' | translate }}" show-button-bar="false" validator="$smd.isValidDate()" invalid-message="\'modules.events.shiftTemplate.modals.pleaseCorrectTime\' | translate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$smd.openedInputEndDate = !$smd.openedInputEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-class="{\'col-sm-4\': !$smd.parentCtrl.options.templateMode, \'col-sm-12\': $smd.parentCtrl.options.templateMode}"><div uib-timepicker="" ng-model="$smd.shift.EndDate" mousewheel="false" minute-step="15" ng-disabled="!$smd.templateShiftTimespan" show-meridian="false"></div><input type="hidden" class="form-control" ng-if="$smd.parentCtrl.options.templateMode" name="templateEndDateValidation" ng-model="$smd.templateEndDateValidationEmpty" validator="$smd.isValidDate()" invalid-message="\'modules.events.shiftTemplate.modals.pleaseCorrectTime\' | translate"></div></div></div></div><div class="form-group row clearfix"><label for="inputJobSite" class="col-sm-12 control-label primary-label">{{ \'modules.events.shiftTemplate.placeOfUse\' | translate }}</label><div class="col-sm-12"><input type="text" class="form-control" id="inputJobSite" name="inputJobSite" placeholder="" max-char="255" invalid-message="\'modules.events.shiftTemplate.modals.entryInvalid\' | translate" ng-model="$smd.shift.JobSite"></div></div><div class="row event-combined-date-time-picker mt-20"><div class="col-sm-8"><div class="form-group clearfix"><label for="inputMeetingPlaceName" class="control-label">{{ \'modules.events.shiftTemplate.modals.comingTogether\' | translate }}</label> <input type="text" class="form-control" id="inputMeetingPlaceName" name="inputMeetingPlaceName" placeholder="{{ \'modules.events.shiftTemplate.modals.meetingPoint\' | translate }}" max-char="255" invalid-message="\'modules.events.shiftTemplate.modals.entryInvalid\' | translate" ng-model="$smd.shift.MeetingPlaceName"></div></div><div class="col-sm-4"><div class="form-group clearfix mb-0"><div uib-timepicker="" ng-model="$smd.shift.MeetingTime" mousewheel="false" minute-step="15" show-meridian="false"></div></div></div></div><div class="form-group row clearfix"><label for="inputRemark" class="col-sm-12 control-label">{{ \'modules.events.shiftTemplate.comment\' | translate }}</label><div class="col-sm-12"><textarea class="form-control no-resize" id="inputRemark" name="inputRemark" max-char="4000" invalid-message="\'modules.events.shiftTemplate.modals.entryInvalid\' | translate" ng-model="$smd.shift.Remark"></textarea></div></div><div class="form-group row clearfix" ng-if="!$smd.templateMode"><label for="inputRemark" class="col-sm-12 control-label">{{ \'modules.events.shiftTemplate.sharedDivisions\' | translate }}</label><div class="col-sm-12"><tag-picker default-label="(\'modules.events.service.noExplicitShare\' | translate)" tags="$smd.dynShiftShareAvailable" selected-tags="$smd.dynShiftShareChosen" class=""></tag-picker></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'modules.events.shiftTemplate.cancel\' | translate }}</button> <button type="submit" class="btn btn-primary">{{ \'modules.events.shiftTemplate.save\' | translate }}</button></div></form></div>');
$templateCache.put('app/theme/components/shiftTemplate/modals/shiftPositionDetails.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ ($spd.isNew) ? (\'modules.events.shiftTemplate.newPosition\' | translate) : (\'modules.events.shiftTemplate.editSomething\' | translate: { value: $spd.position.Function ? (\'modules.events.shiftTemplate.inBrackets\' | translate: { value: $spd.position.Function }) : (\'modules.events.shiftTemplate.modals.existingPosition\' | translate) }) }}</h4></div><div class="modal-body"><shift-position-details position="$spd.position" parent-ctrl="$spd.parentCtrl" available-shift-members="$spd.availableShiftMembers" member-position-list="$spd.memberPositionList" shift="$spd.shift" shift-divisions="$spd.shiftDivisions" check-attendees-is-legal-age="$spd.checkAttendeesIsLegalAge" attendee-requirement-fulfillment="$spd.attendeeRequirementFulfillment" requirement-validity-calc="$spd.requirementValidityCalc" combined-valid-state-calc="$spd.combinedValidStateCalc" get-position-req-valid-popover="$spd.getPositionReqValidPopover" submit="$spd.submit"></shift-position-details></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">{{ \'modules.events.shiftTemplate.cancel\' | translate }}</button> <button type="button" class="btn btn-primary" ng-click="$spd.triggerSubmit()">{{ \'modules.events.shiftTemplate.save\' | translate }}</button></div></div>');
$templateCache.put('app/theme/components/supervisorsList/membersModal/chooseMember.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.superVisorsList.chooseMemberTitle">Person angeben</h4></div><span ng-show="$modalCtrl.members.length<=0" translate="components.superVisorsList.person404">Es konnten keine Personen gefunden werden!</span><div class="modal-body"><div class="panel-group"><div class="input-group"><ui-select ng-model="$modalCtrl.selectedMember" class="btn-group bootstrap-select form-control" search-enabled="true" spinner-enabled="true" data-cy="org-admin-add-division-administrator-pick-selector"><ui-select-match placeholder="{{\'modules.personnel.groups.memberSearchPlaceholder\' | translate }}">{{ $modalCtrl.selectedMember.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="member.hint" repeat="member in $modalCtrl.members | orderBy: \'fullName\'" refresh="$modalCtrl.searchMembers($select.search)" refresh-delay="200" group-by="$modalCtrl.groupByFirstName"><span ng-if="!member.hint"><i class="ion-person"></i> <span>{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="components.superVisorsList.pleaseTypeForResults">... bitte tippen um weitere Ergebnisse zu erhalten</span></span></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="button" class="btn btn-primary" ng-disable="!$modalCtrl.selectedMember" ng-click="$modalCtrl.applyMemberModal()" data-cy="org-admin-add-division-administrator-pick-selector-save" translate="generalTerms.save">\xDCbernehmen</button></div></div>');
$templateCache.put('app/theme/components/supervisorsList/membersModal/newMember.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="components.superVisorsList.newMemberTitle">Konto anlegen</h4></div><div class="modal-body"><form id="newAccountForm" name="newAccountForm"><div class="col-sm-12 row"><div class="col-sm-6"><div class="form-group clearfix" ng-class="{\'has-error\': !newAccountForm.inputGender.$valid && $modalCtrl.triedSubmit}"><label for="inputGender" class="required-label">Anrede</label><ui-select id="inputGender" name="inputGender" ng-model="$modalCtrl.member.Gender" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Herr/Frau">{{ $select.selected.name }}</ui-select-match><ui-select-choices position="down" repeat="value.value as value in $modalCtrl.gender | filter: $select.search"><span>{{ value.name }}</span></ui-select-choices></ui-select><span class="help-block error-block basic-block" translate="components.superVisorsList.selectSalutation">Bitte w\xE4hle eine Anrede!</span></div></div><div class="col-sm-6"><label for="inputTitle" class="control-label" translate="generalTerms.title">Titel</label> <input type="text" class="form-control" id="inputTitle" placeholder="{{(\'generalTerms.title\' | translate)}}" ng-model="$modalCtrl.member.Title"></div></div><div class="col-sm-12 row"><div class="col-sm-6"><div class="form-group clearfix" ng-class="{\'has-error\': !newAccountForm.inputFirstName.$valid && $modalCtrl.triedSubmit}"><label for="inputFirstName" class="required-label" translate="models.Member.FirstName">Vorname</label> <input type="text" class="form-control" id="inputFirstName" name="inputFirstName" placeholder="{{(\'models.Member.FirstName\' | translate)}}" ng-model="$modalCtrl.member.FirstName" required=""> <span ng-show="newAccountForm.inputFirstName.$error.required || newAccountForm.inputFirstName.$error" class="help-block error-block basic-block" translate="components.superVisorsList.enterFirstName">Bitte gib einen Vornamen ein!</span></div></div><div class="col-sm-6"><div class="form-group clearfix" ng-class="{\'has-error\': !newAccountForm.inputLastName.$valid && $modalCtrl.triedSubmit}"><label for="inputLastName" class="required-label">Nachname</label> <input type="text" class="form-control" id="inputLastName" name="inputLastName" placeholder="{{(\'models.Member.LastName\' | translate)}}" ng-model="$modalCtrl.member.LastName" required=""> <span ng-show="newAccountForm.inputLastName.$error.required || newAccountForm.inputLastName.$error" class="help-block error-block basic-block" translate="components.superVisorsList.enterLastName">Bitte gib einen Nachnamen ein!</span></div></div></div><div class="col-sm-12 row"><div class="form-group clearfix" ng-class="{\'has-error\': !newAccountForm.inputEmail.$valid && $modalCtrl.triedSubmit}"><label for="inputEmail" class="col-sm-3 control-label required-label">E-Mail</label><div class="col-sm-12"><input type="email" class="form-control" name="inputEmail" id="inputEmail" ng-model="$modalCtrl.member.Account.EMail" ng-model-options="{ debounce: 250 }" placeholder="{{(\'models.Account.EMail\' | translate)}}" ui-validate-async="{ alreadyExists: \'$modalCtrl.checkMail($value)\' }" required=""> <span ng-show="newAccountForm.inputEmail.$error.required || newAccountForm.inputEmail.$error.email" class="help-block error-block basic-block" translate="components.superVisorsList.enterEMail">Bitte gib eine g\xFCltige E-Mail Adresse ein!</span> <span ng-show="newAccountForm.inputEmail.$error.alreadyExists" class="help-block error-block basic-block" translate="components.superVisorsList.mailAlreadyExists">Diese E-Mail Adresse exisistiert bereits.</span></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="button" class="btn btn-primary" ng-disable="newAccountForm.inputEMail.$invalid || !$modalCtrl.areInputsValid()" ng-click="$modalCtrl.applyNewAccountModal(newAccountForm)" translate="generalTerms.save">Speichern</button></div></div>');
$templateCache.put('app/pages/administration/finances/components/financePositions/financePositionModal.html','<div class="modal-content finances-financepositions__details-modal"><form id="financePositionForm" name="financePositionForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.positionData)"><div class="modal-header"><h4 class="modal-title"><span ng-switch="$modalCtrl.costCenterData.id == null"><span ng-switch-when="true" translate="modules.administration.finances.financePositions.detailsModal.titleAdd">Position hinzuf\xFCgen</span> <span ng-switch-when="false" translate="modules.administration.finances.financePositions.detailsModal.titleEdit">Position bearbeiten</span> <span ng-switch-default="" translate="modules.administration.finances.financePositions.detailsModal.title">Position</span></span></h4></div><fieldset class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group" ng-class="{ \'has-error\': financePositionForm.$submitted && financePositionForm.titleInput.$invalid }"><label for="titleInput" class="control-label required-label" translate="modules.administration.finances.financePositions.detailsModal.titleFieldLabel">Titel</label> <input type="text" maxlength="1000" ng-model="$modalCtrl.positionData.Title" ng-model-options="{ debounce: 300 }" class="form-control" name="titleInput" placeholder="{{ \'modules.administration.finances.financePositions.detailsModal.titleFieldLabel\' | translate }}" required="" required-message="\'modules.administration.finances.financePositions.titleFieldRequiredError\' | translate"></div></div></div><div class="row"><div class="col-xs-12 col-sm-8 form-group mb-0" ng-class="{ \'has-error\': financePositionForm.$submitted && financePositionForm.priceInput.$invalid }"><label for="priceInput" class="control-label required-label" translate="modules.administration.finances.financePositions.detailsModal.priceFieldLabel"></label><div class="btn-group pull-right ml-5" ng-if="$modalCtrl.priceOptions.length" title="{{ \'modules.administration.finances.financePositions.detailsModal.administrativePrices\' | translate }}"><button ng-click="$modalCtrl.openPriceOptions()" type="button" class="btn btn-xs btn-with-icon font-size-11" ng-class="$modalCtrl.administrativePriceSet() ? \'btn-default\' : \'btn-primary\'"><i class="fa fa-magic"></i></button></div><ui-select ng-if="$modalCtrl.priceOptions.length" id="financepositions-details-modal-arno-ui-select-price-options" ng-model="$modalCtrl.selectedPriceOption" class="arno-ui-select-hidden" search-enabled="false" on-select="$modalCtrl.setPrice($item, $model)"><ui-select-match>{{ priceOption.price }}</ui-select-match><ui-select-choices position="down" repeat="priceOption in $modalCtrl.priceOptions" refresh-delay="200" group-by="\'name\'"><span><span>{{ priceOption.price | currency: \'\u20AC\' }}</span> <span>{{ (\'modules.administration.finances.financePositions.priceUnitTypes.\' + priceOption.type) | translate }}</span></span></ui-select-choices></ui-select><div class="row"><div class="col-xs-6 form-group pr-0"><input type="text" arno-currency-input="" allow-zero="true" precision="2" suffix="\u20AC" ng-model="$modalCtrl.positionData.Price" ng-model-options="{ allowInvalid: true }" class="form-control" name="priceInput" required="" required-message="\'modules.administration.finances.financePositions.priceFieldRequiredError\' | translate"></div><div class="col-xs-6 form-group pl-2 d-flex align-items-center"><ui-select ng-model="$modalCtrl.positionData.PriceUnitType" ng-model-options="{ debounce: 300 }" class="btn-group bootstrap-select fix-dropdown-overlaying-input" append-to-body="false" name="priceUnitTypeInput" ng-change="$modalCtrl.priceInputsChanged($modalCtrl.positionData)" search-enabled="false" required=""><ui-select-match><span>\u20AC {{ (\'modules.administration.finances.financePositions.priceUnitTypes.\' + $select.selected) | translate }}</span></ui-select-match><ui-select-choices position="down" repeat="priceUnitType in $modalCtrl.PRICE_UNIT_TYPES"><span>{{ (\'modules.administration.finances.financePositions.priceUnitTypes.\' + priceUnitType) | translate }}</span></ui-select-choices></ui-select></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group" ng-class="{ \'has-error\': financePositionForm.$submitted && financePositionForm.priceUnitCountInput.$invalid }"><div class="label-container"><label for="priceUnitCountInput" class="control-label required-label" translate="modules.administration.finances.financePositions.detailsModal.priceUnitCountFieldLabel">Menge</label><arno-ba-help-tooltip text="{{\'modules.administration.finances.financePositions.detailsModal.priceUnitCountFieldTooltip\' | translate }}"></arno-ba-help-tooltip></div><input type="number" min="0" step="0.01" data-control-step="1" maxlength="1000" ng-model="$modalCtrl.positionData.PriceUnitCount" ng-model-options="{ debounce: 300 }" class="form-control" name="priceUnitCountInput" placeholder="{{ \'modules.administration.finances.financePositions.detailsModal.priceUnitCountFieldLabel\' | translate }}" required="" required-message="\'modules.administration.finances.financePositions.countFieldRequiredError\' | translate" invalid-message="\'modules.administration.finances.financePositions.detailsModal.inputInvalidError\' | translate"></div></div></div><div class="row"><div class="form-group col-md-12"><label class="control-label required-label" translate="modules.administration.finances.financePositions.detailsModal.costCenterSpec"></label><div class="alert bg-warning mb-5" ng-if="!$modalCtrl.defaultCostCenterSpecification">{{ \'modules.administration.finances.financePositions.detailsModal.costCenterSpecNoDefaultHint\' | translate }}</div><cost-center-spec-selector selected-cost-center-spec="$modalCtrl.positionData.CostCenterSpecification" on-cost-center-spec-select="$modalCtrl.costCenterOnSelect" append-to-body="false" cost-center-id-filter="$modalCtrl.quotInvBaseData.CostCenterSpecification.CostCenter.id" ng-disabled="!$modalCtrl.defaultCostCenterSpecification"></cost-center-spec-selector></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="submit" class="btn btn-primary" translate="generalTerms.save">Speichern</button></div></form></div><style>\n  .label-container {\n    display: flex;\n  }\n\n  .label-container > arno-ba-help-tooltip,\n  .label-container > label {\n    display: inline;\n  }\n\n  .label-container > label {\n    margin-right: 5px;\n  }\n</style>');
$templateCache.put('app/pages/administration/finances/components/financePositions/financePositions.comp.html','<ng-form name="financePositionsForm" novalidate="" angular-validator="" class="finances-financepositions"><div class="row mb-20" ng-if="!$positionsCtrl.disabled"><div class="col-md-6 d-flex align-items-center flex-wrap"><div class="input-group input-group-with-select input-group-with-btn-text mb-0"><span class="input-group-addon addon-left position-category-type-select" uib-dropdown="" uib-dropdown-toggle=""><span><i ng-class="$positionsCtrl.PRICE_ITEM_TYPE_ICON[$positionsCtrl.selectedSearchPriceItemType]" class="mr-3"></i> {{ (\'modules.administration.finances.financePositions.priceItemTypes.\' + $positionsCtrl.selectedSearchPriceItemType) | translate }}</span> <span class="caret mb-2"></span><ul class="dropdown-menu" uib-dropdown-menu=""><li ng-repeat="priceItemType in $positionsCtrl.PRICE_ITEM_TYPES"><a ng-click="$positionsCtrl.selectedSearchPriceItemTypeChanged(priceItemType)"><i class="price-item-type-icon" ng-class="$positionsCtrl.PRICE_ITEM_TYPE_ICON[priceItemType]"></i> {{ (\'modules.administration.finances.financePositions.priceItemTypes.\' + priceItemType) | translate }} <i ng-if="priceItemType === \'MATERIAL\'" class="fa fa-external-link-square icon-linked-to-modal"></i></a></li></ul></span><ui-select ng-model="$positionsCtrl.selectedPriceItem" class="btn-group bootstrap-select form-control" append-to-body="false" ng-disabled="false" search-enabled="true" on-select-open="$positionsCtrl.selectOpenGuard(selectCtrl)"><ui-select-match placeholder="{{(\'modules.administration.finances.financePositions.priceItemSearchPlaceholder\' | translate )}}"><i class="ion-plus-round"></i> <i class="ion-close mr-4" ng-click="$positionsCtrl.deselectPriceItem($event)" title="{{ \'modules.administration.finances.financePositions.priceItemSearchDeselect\' | translate }}"></i> {{ $select.selected.Title || $select.selected.Function || $select.selected.Name }}</ui-select-match><ui-select-choices repeat="priceItem in $positionsCtrl.priceItems | orderBy:[\'Title\']" refresh="$positionsCtrl.priceItemsSearch($select.search)" refresh-delay="300" group-by="$positionsCtrl.priceItemGroupFunc" ui-disable-choice="priceItem.isHint"><div ng-if="!priceItem.isHint" class="d-flex align-items-center w-100"><i ng-class="{\'ion-ios-people\':!priceItem.DivisionId,\'ion-ios-people-outline\':priceItem.DivisionId}"></i><div class="ml-6 flex-grow-1 mr-12">{{ priceItem.Title || priceItem.Function || priceItem.Name }}</div><div ng-repeat="priceItemBase in [priceItem, priceItem.PriceItemOverrides[0]]" ng-if="(priceItem.PriceItemOverrides[0] && $index) || (!priceItem.PriceItemOverrides[0] && !$index)"><div ng-if="priceItemBase.ExternalPricePerHour != null" class="arno-tag tag label label-tag mr-0" title="{{ \'controls.pricesInput.pricePerHourFieldLabel\' | translate }}">{{ priceItemBase.ExternalPricePerHour | currency: \'\u20AC\' }} / h</div><div ng-if="priceItemBase.ExternalPricePerDay != null" class="arno-tag tag label label-tag mr-0 ml-5" title="{{ \'controls.pricesInput.pricePerDayFieldLabel\' | translate }}">{{ priceItemBase.ExternalPricePerDay | currency: \'\u20AC\' }} / d</div><div ng-if="priceItemBase.ExternalPricePerCount != null" class="arno-tag tag label label-tag mr-0 ml-5" title="{{ \'controls.pricesInput.pricePerCountFieldLabel\' | translate }}">{{ priceItemBase.ExternalPricePerCount | currency: \'\u20AC\' }}</div></div></div><span ng-if="priceItem.isHint"><i class="glyphicon glyphicon-ban-circle"></i> <span translate="{{priceItem.messageKey}}" class="ml-4"></span></span></ui-select-choices></ui-select><span class="input-group-btn ui-select-fixed-button-position"><button type="button" class="btn btn-success" ng-click="$positionsCtrl.addPosition()"><i class="ion-plus-round"></i> <span>{{ (\'modules.administration.finances.financePositions.addBtnLabel\' | translate) }}</span></button></span></div></div><div class="col-md-6"><button type="button" class="btn btn-success pull-right" ng-click="$positionsCtrl.addFreePosition()"><i class="ion-plus-round"></i> <span>{{ (\'modules.administration.finances.financePositions.addCustomBtnLabel\' | translate) }}</span></button></div></div><div class="row mb-5"><div class="col-md-12"><div class="table-responsive finances-financepositions-table"><table class="table table-condensed table-hover"><thead><tr><th>{{ \'modules.administration.finances.financePositions.numberIdCol\' | translate}}</th><th>{{ \'modules.administration.finances.financePositions.ccsCol\' | translate}}</th><th>{{ \'modules.administration.finances.financePositions.titleCol\' | translate}}</th><th>{{ \'modules.administration.finances.financePositions.priceUnitTypeCol\' | translate}}</th><th>{{ \'modules.administration.finances.financePositions.priceUnitCountCol\' | translate}}</th><th>{{ \'modules.administration.finances.financePositions.taxrateCol\' | translate}}</th><th><span class="pull-right">{{ \'modules.administration.finances.financePositions.totalCol\' | translate}}</span></th><th ng-if="!$positionsCtrl.disabled"></th></tr></thead><colgroup><col width="5%"><col width="13%"><col width="25%"><col width="17%"><col width="10%"><col width="10%"><col><col width="50px" ng-if="!$positionsCtrl.disabled"></colgroup><tbody><tr ng-repeat="position in $positionsCtrl.positions | orderBy:\'Order\' track by $index"><td><span class="finance-position-order"><i class="fa fa-chevron-circle-up" ng-class="{\'disabled\': $first || $positionsCtrl.disabled}" ng-disabled="$positionsCtrl.disabled" ng-click="$positionsCtrl.movePosition(position, true)"></i> <i class="fa fa-chevron-circle-down" ng-class="{\'disabled\': $last || $positionsCtrl.disabled}" ng-disabled="$positionsCtrl.disabled" ng-click="$positionsCtrl.movePosition(position, false)"></i></span> <strong>{{ $index + 1 }}</strong></td><td><div class="arno-tag tag label label-tag label-success mr-3"><i class="ion-ios-people mr-2"></i> {{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.CostCenter.Identifier || \'\' }}{{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.CostCenter.Identifier ? \' - \' : \'\' }}{{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.CostCenter.Name }}</div><div class="arno-tag tag label label-tag mr-3" ng-if="position.CostCenterSpecification !== null || $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification"><i class="fa fa-money mr-2"></i> <span ng-if="position.CostCenterSpecification !== null && !position.CostCenterSpecification.defaultSelection">{{ position.CostCenterSpecification.Identifier || \'\' }}{{ position.CostCenterSpecification.Identifier ? \' - \' : \'\' }}{{ position.CostCenterSpecification.Name }}</span> <span ng-if="!(position.CostCenterSpecification !== null && !position.CostCenterSpecification.defaultSelection) && $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification !== null">{{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.Identifier || \'\' }}{{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.Identifier ? \' - \' : \'\' }}{{ $positionsCtrl.metaData.quotInvBaseData.CostCenterSpecification.Name }}</span></div></td><td><span ng-bind="position.Title"></span></td><td><span ng-if="position.PriceUnitType && position.Price" ng-bind="position.Price | currency: \'\u20AC\'"></span> <span ng-class="{\'text-danger\': !(position.PriceUnitType && position.Price), \'text-italic\': !position.PriceUnitType}" translate="{{ $positionsCtrl.getPriceTypeTranslation(position.PriceUnitType, position.Price) }}"></span></td><td><span ng-bind="position.PriceUnitCount | number"></span></td><td><span ng-if="position._taxRate !== null && position._taxRate !== undefined">{{ position._taxRate }} %</span> <span ng-if="position._taxRate === null">---</span></td><td class="text-right"><span ng-if="position._sum !== null">{{ position._sum | currency: \'\u20AC\' }}</span> <span ng-if="position._sum === null">{{ \'modules.administration.finances.financePositions.calcSumError\' | translate }}</span></td><td ng-if="!$positionsCtrl.disabled"><div class="d-flex align-items-center justify-content-end h-100"><button type="button" class="btn btn-default btn-with-icon btn-xs" ng-click="$positionsCtrl.editPosition(position)" title="{{ ::(\'modules.administration.finances.financePositions.editBtnLabel\' | translate) }}"><i class="fa fa-pencil"></i></button> <button type="button" class="btn btn-danger btn-with-icon btn-xs ml-4" ng-click="$positionsCtrl.deletePosition($index)" title="{{ ::(\'modules.administration.finances.financePositions.deleteBtnLabel\' | translate) }}"><i class="ion-close"></i></button></div></td></tr><tr ng-if="($positionsCtrl.positions || []).length" class="totalsum-row with-separator"><td colspan="7"><div class="row"><div class="col-xs-9"><span translate="modules.administration.finances.financePositions.discountLabel" class="mb-4 text-right block"></span></div><div class="col-xs-3"><div class="input-group discount-dropdown dropdown" uib-dropdown="" dropdown-append-to-body="true" style=""><input type="text" arno-currency-input="" allow-zero="true" precision="2" allow-empty="false" allow-negative="true" ng-disabled="$positionsCtrl.disabled" ng-model="$positionsCtrl.metaData.discount" class="form-control input-xs pr-5"> <button ng-disabled="$positionsCtrl.disabled" type="button" class="btn dropdown-toggle btn-dropdown-addon btn-xs" uib-dropdown-toggle=""><span>{{ ($positionsCtrl.metaData.discountUnit === $positionsCtrl.DISCOUNT_UNIT_TYPES.FLAT ? \'\u20AC\' : \'%\') }}</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu"><li role="menuitem" ng-click="$positionsCtrl.changeDiscountUnit(true, \'\u20AC\')"><a href="" translate="modules.administration.finances.financePositions.discountSelect" translate-values="{ unit: \'\u20AC\' }">Rabatt in \u20AC</a></li><li role="menuitem" ng-click="$positionsCtrl.changeDiscountUnit(false)"><a href="" translate="modules.administration.finances.financePositions.discountSelect" translate-values="{ unit: \'%\' }">Rabatt in %</a></li></ul></div><h5 ng-bind="$positionsCtrl.calcDiscount($positionsCtrl.positions)" class="mb-4 text-right"></h5></div></div></td><td ng-if="!$positionsCtrl.disabled"></td></tr><tr ng-if="($positionsCtrl.positions || []).length" class="totalsum-row"><td colspan="7"><div class="row"><div class="col-xs-9"><h5 translate="modules.administration.finances.financePositions.totalSumLabel" class="mb-4 text-right"></h5></div><div class="col-xs-3"><h5 class="mb-4 text-right" ng-if="$positionsCtrl.metaData.FinalAmount !== null">{{ $positionsCtrl.metaData.FinalAmount | currency: \'\u20AC\' }}</h5><h5 class="mb-4 text-right" ng-if="$positionsCtrl.metaData.FinalAmount === null">{{ \'modules.administration.finances.financePositions.calcSumError\' | translate }}</h5></div></div></td><td ng-if="!$positionsCtrl.disabled"></td></tr><tr ng-if="!($positionsCtrl.positions || []).length"><td colspan="99" class="text-center"><i translate="modules.administration.finances.financePositions.emptyMsg">Bitte Preiselement ausw\xE4hlen, um neue Position hinzuzuf\xFCgen</i></td></tr></tbody></table></div></div></div></ng-form>');
$templateCache.put('app/pages/administration/events/serviceTypes/serviceTypeModal/addServiceType.html','<div class="modal-content"><form id="serviceTypeForm" name="serviceTypeForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.ServiceType.id, $modalCtrl.ServiceType.Name)"><div class="modal-header"><h4 class="modal-title">{{$modalCtrl.title}}</h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" translate="generalTerms.createName"></label> <input type="text" maxlength="254" ng-model="$modalCtrl.ServiceType.Name" class="form-control" id="nameInput" name="nameInput" placeholder="{{ \'generalTerms.createName\' | translate: {lowercase: true} }}" validator="$modalCtrl.validateName($modalCtrl.ServiceType.Name)" invalid-message="\'modules.administration.events.oneEventIdentifyName\' | translate" required-message="\'modules.administration.events.nameIsMissing\' | translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/finances/costCenters/modals/detailsModal.html','<div class="modal-content"><form id="costCenterForm" name="costCenterForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal( $modalCtrl.costCenterData.id, $modalCtrl.costCenterData.Identifier, $modalCtrl.costCenterData.Name, $modalCtrl.costCenterSpecifications )"><div class="modal-header"><h4 class="modal-title"><span ng-switch="$modalCtrl.costCenterData.id == null"><span ng-switch-when="true" translate="modules.administration.finances.costCenters.detailsModal.titleAdd">Kostenstelle hinzuf\xFCgen</span> <span ng-switch-when="false" translate="modules.administration.finances.costCenters.detailsModal.titleEdit">Kostenstelle bearbeiten</span> <span ng-switch-default="" translate="modules.administration.finances.costCenters.detailsModal.title">Kostenstelle</span></span></h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-4"><div class="form-group"><label for="identifierInput" class="control-label" translate="modules.administration.finances.costCenters.detailsModal.identifierFieldLabel">ID</label> <input type="text" maxlength="255" ng-model="$modalCtrl.costCenterData.Identifier" class="form-control" id="identifierInput" name="identifierInput" placeholder="{{ \'modules.administration.finances.costCenters.detailsModal.identifierFieldLabel\' | translate }}"></div></div><div class="col-xs-12 col-sm-8"><div class="form-group"><label for="nameInput" class="control-label required-label" translate="modules.administration.finances.costCenters.detailsModal.nameFieldLabel">Name</label> <input type="text" maxlength="255" ng-model="$modalCtrl.costCenterData.Name" class="form-control" id="nameInput" name="nameInput" placeholder="{{ \'modules.administration.finances.costCenters.detailsModal.nameFieldLabel\' | translate }}" required="" validator="$modalCtrl.validateField(\'Name\', $modalCtrl.costCenterData.Name)" invalid-message="\'modules.administration.finances.costCenters.detailsModal.nameFieldAlreadyExistsError\' | translate" required-message="\'modules.administration.finances.costCenters.detailsModal.nameFieldRequiredError\' | translate"></div></div></div><div ng-if="!($modalCtrl.costCenterData || {}).id" class="row mt-8 mb-3"><div class="col-xs-12"><div class="table-responsive overflow-visible"><table class="table table-condensed --embedded cost-center-detail-table"><thead><tr><td colspan="99"><span class="table-title-with-button"><i class="fa fa-money mr-5"></i> <strong translate="modules.administration.finances.costCenters.detailsModal.specificationsLabel">Kostenstellenauspr\xE4gungen</strong></span> <button type="button" class="btn btn-xs btn-success btn-with-icon pull-right" ng-click="$modalCtrl.addSpecificationEntry()"><i class="fa fa-plus"></i> <span translate="modules.administration.finances.costCenters.addSpecificationBtnLabel">Auspr\xE4gung hinzuf\xFCgen</span></button></td></tr></thead><col width="15%"><col width="45%"><col width="20%"><col width="20%"><tbody><tr ng-repeat-start="specification in $modalCtrl.costCenterSpecifications track by $index"><td><div class="form-group mb-0"><input type="text" maxlength="255" ng-model="specification.Identifier" class="form-control" name="{{\'identifierInput-\' + $index}}" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.identifierFieldLabel\' | translate }}"></div></td><td colspan="{{ specification.TaxRatePercent !== 0 ? 2 : 1 }}"><div class="form-group mb-0"><input type="text" maxlength="1500" ng-model="specification.Name" class="form-control" name="{{\'nameInput-\' + $index}}" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.nameFieldLabel\' | translate }}" required="" validator="$modalCtrl.validateSpecificationField(\'Name\', {{ $index }})" invalid-message="\'modules.administration.finances.costCenters.specificationModal.nameFieldAlreadyExistsError\' | translate" required-message="\'modules.administration.finances.costCenters.specificationModal.nameFieldRequiredError\' | translate"></div></td><td class="pr-0"><div class="form-group mb-0"><input type="number" min="0" ng-model="specification.TaxRatePercent" class="form-control" name="{{\'taxRateInput-\' + $index}}" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.taxRateFieldPh\' | translate }}" validator="$modalCtrl.validateTaxRate({{ specification.TaxRatePercent }})" invalid-message="\'modules.administration.finances.costCenters.specificationModal.taxRateInvalidError\' | translate"></div></td><td ng-if="specification.TaxRatePercent === 0" class="pr-0"><div class="form-group mb-0"><input type="text" maxlength="1000" ng-model="specification.TaxRateReason" class="form-control" id="{{\'taxRateReasonInput-\' + $index}}" name="{{\'taxRateReasonInput-\' + $index}}" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.taxRateReasonFieldLabel\' | translate }}" required=""></div></td><td class="pr-0" ng-if="($modalCtrl.costCenterSpecifications || []).length > 1" rowspan="2"><button type="button" class="btn btn-danger btn-with-icon w-100 h-100" ng-click="$modalCtrl.deleteSpecificationEntry($index)" title="{{ ::(\'modules.administration.finances.costCenters.deleteSpecificationBtnLabel\' | translate) }}"><i class="ion-ios-trash"></i><div>{{\'generalTerms.remove\' | translate}}</div></button></td></tr><tr><td colspan="4" class="form-group mb-0 pr-0 pt-0"><input ng-model="specification.Hint" class="form-control" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.hint\' | translate }}"></td></tr><tr ng-repeat-end=""><td colspan="99" ng-if="!$last" class="pr-0"><div class="row-separator"></div></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.administration.finances.costCenters.detailsModal.cancelBtnLabel">Abbrechen</button> <button type="submit" class="btn btn-primary" translate="modules.administration.finances.costCenters.detailsModal.saveBtnLabel">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/finances/costCenters/modals/specificationModal.html','<div class="modal-content"><form id="costCenterSpecificationForm" name="costCenterSpecificationForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal( $modalCtrl.specificationData.id, $modalCtrl.specificationData.Identifier, $modalCtrl.specificationData.Name, $modalCtrl.specificationData.TaxRatePercent, $modalCtrl.selectedTaxRateReason, $modalCtrl.specificationData.Hint )"><div class="modal-header"><h4 class="modal-title"><span ng-switch="$modalCtrl.specificationData.id == null"><span ng-switch-when="true" translate="modules.administration.finances.costCenters.specificationModal.titleAdd">Kostenstellenauspr\xE4gung hinzuf\xFCgen</span> <span ng-switch-when="false" translate="modules.administration.finances.costCenters.specificationModal.titleEdit">Kostenstellenauspr\xE4gung bearbeiten</span> <span ng-switch-default="" translate="modules.administration.finances.costCenters.specificationModal.title">Kostenstellenauspr\xE4gung</span></span></h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-4"><div class="form-group"><label for="identifierInput" class="control-label" translate="modules.administration.finances.costCenters.specificationModal.identifierFieldLabel">ID</label> <input type="text" maxlength="255" ng-model="$modalCtrl.specificationData.Identifier" class="form-control" id="identifierInput" name="identifierInput" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.identifierFieldLabel\' | translate }}"></div></div><div class="col-xs-12 col-sm-8"><div class="form-group"><label for="nameInput" class="control-label required-label" translate="modules.administration.finances.costCenters.specificationModal.nameFieldLabel">Name</label> <input type="text" maxlength="1500" ng-model="$modalCtrl.specificationData.Name" class="form-control" id="nameInput" name="nameInput" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.nameFieldLabel\' | translate }}" required="" validator="$modalCtrl.validateField(\'Name\', $modalCtrl.specificationData.Name)" invalid-message="\'modules.administration.finances.costCenters.specificationModal.nameFieldAlreadyExistsError\' | translate" required-message="\'modules.administration.finances.costCenters.specificationModal.nameFieldRequiredError\' | translate"></div></div></div><div class="row"><div class="col-xs-12 col-sm-4"><div class="form-group"><label for="taxRateInput" class="control-label" translate="modules.administration.finances.costCenters.specificationModal.taxRateFieldLabel">Steuersatz</label> <input type="number" min="0" ng-model="$modalCtrl.specificationData.TaxRatePercent" class="form-control" id="taxRateInput" name="taxRateInput" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.taxRateFieldPh\' | translate }}" validator="$modalCtrl.validateTaxRate()" invalid-message="\'modules.administration.finances.costCenters.specificationModal.taxRateInvalidError\' | translate"></div></div><div ng-if="$modalCtrl.specificationData.TaxRatePercent === 0" class="col-xs-12 col-sm-8"><div class="form-group"><label class="control-label required-label" translate="modules.administration.finances.costCenters.specificationModal.taxRateReasonFieldLabel">Befreiungsgrund</label> <input type="text" maxlength="1000" ng-model="$modalCtrl.selectedTaxRateReason" class="form-control" id="taxRateReasonInput" name="taxRateReasonInput" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.taxRateReasonFieldLabel\' | translate }}" required=""></div></div><div class="col-xs-12" ng-class="{ \'col-sm-8\': $modalCtrl.specificationData.TaxRatePercent !== 0 }"><div class="form-group"><label for="descriptionInput" class="control-label" translate="modules.administration.finances.costCenters.specificationModal.hint">Hinweis</label> <input type="text" maxlength="1500" ng-model="$modalCtrl.specificationData.Hint" class="form-control" id="descriptionInput" name="descriptionInput" placeholder="{{ \'modules.administration.finances.costCenters.specificationModal.hint\' | translate }}"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.administration.finances.costCenters.specificationModal.cancelBtnLabel">Abbrechen</button> <button type="submit" class="btn btn-primary" translate="modules.administration.finances.costCenters.specificationModal.saveBtnLabel">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/finances/prices/modals/detailsModal.html','<div class="modal-content"><form id="customPriceItemForm" name="customPriceItemForm" novalidate="" angular-validator="" angular-validator-submit="self.applyModal(self.priceItemData)"><div class="modal-header"><h4 class="modal-title"><span ng-if="self.uiConfig.titlePrefix" translate="{{ self.uiConfig.titlePrefix }}"></span> <span ng-if="self.priceItemData.Name">"{{self.priceItemData.Name}}" -</span> <span ng-if="!self.uiConfig.title"><span ng-switch="self.isNew()"><span ng-switch-when="true" translate="modules.administration.finances.prices.detailsModal.titleAdd" translate-values="{ countTp: self.targetPriceItems.length }">Preiselement hinzuf\xFCgen</span> <span ng-switch-when="false" translate="modules.administration.finances.prices.detailsModal.titleEdit" translate-values="{ countTp: self.targetPriceItems.length }">Preiselement bearbeiten</span></span></span> <span ng-if="self.uiConfig.title" translate="{{ self.uiConfig.title }}" translate-values="{ countTp: self.targetPriceItems.length }"></span></h4></div><fieldset ng-disabled="!self.hasManagePermission" class="modal-body"><h4 ng-if="self.targetPriceItems.length > 1" class="with-line" toggle-next=""><span><arno-ba-help-tooltip text="{{(\'modules.administration.finances.prices.detailsModal.affectedItemsHint\' | translate )}}" custom-icon-cls="fa fa-warning text-warning arno-help-pointer"></arno-ba-help-tooltip><span translate="modules.administration.finances.prices.detailsModal.affectedItems"></span></span></h4><div ng-if="self.targetPriceItems.length > 1" class="row"><div class="col-xs-12"><table st-table="self.targetPriceItems" class="table table-condensed table-hover"><thead><tr class="sortable"><th ng-repeat="(key, colLabel) in self.uiConfig.targetPriceItemsTableConf" st-sort="{{key}}"><strong>{{ colLabel | translate }}</strong></th></tr></thead><tbody><tr ng-repeat="targetPriceItem in self.targetPriceItems"><td ng-repeat="(key, colLabel) in self.uiConfig.targetPriceItemsTableConf"><span>{{ targetPriceItem[key] || \'-\' }}</span></td></tr></tbody></table></div></div><h4 ng-if="self.targetPriceItems.length > 1" class="with-line mt-20" toggle-next=""><span><span translate="modules.administration.finances.prices.detailsModal.priceItemData"></span></span></h4><div class="row"><div class="col-xs-12"><div class="row"><div ng-if="self.uiConfig.showTitleField != false" class="col-xs-12"><div class="form-group"><label for="titleInput" class="control-label required-label" translate="modules.administration.finances.prices.detailsModal.titleFieldLabel">Titel</label> <input type="text" maxlength="255" ng-model="self.priceItemData.Title" ng-model-options="{ debounce: 500 }" class="form-control" id="titleInput" name="titleInput" placeholder="{{ \'modules.administration.finances.prices.detailsModal.titleFieldLabel\' | translate }}" required="" required-message="\'modules.administration.finances.prices.detailsModal.titleFieldRequiredError\' | translate"></div></div></div><div class="row mt-12"><arno-prices-input price-item="self.priceItemData" disabled="!self.hasManagePermission" class="col-xs-12"></arno-prices-input></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.administration.finances.prices.detailsModal.cancelBtnLabel">Abbrechen</button> <button ng-if="self.hasManagePermission" type="submit" class="btn btn-primary" translate="modules.administration.finances.prices.detailsModal.saveBtnLabel">Speichern</button></div></form></div>');
$templateCache.put('app/pages/administration/finances/prices/modals/materialSearchModal.html','<div class="modal-content"><div><div class="modal-header"><h4 class="modal-title"><span translate="modules.administration.finances.prices.materialSearchModal.title">Material Preiselemente suchen</span></h4></div><div class="modal-body mb-20"><div class="row"><uib-tabset active="$modalCtrl.currentActiveMaterialsTab" class="suppress-tab-content"><uib-tab ng-repeat="category in $modalCtrl.ALLOWED_MATERIALS_CATEGORIES" ng-click="$modalCtrl.selectMaterialTab(category)"><uib-tab-heading><i class="{{ $modalCtrl.materialsTabsIconMapping[\'Material\' + category] || \'\' }}"></i> <span translate="{{ \'modules.administration.finances.prices.materialSearchModal.materialsCategoriesLabels.\' + category }}"></span></uib-tab-heading></uib-tab></uib-tabset></div><div class="row mt-20"><div class="col-xs-12"><financial-material-picker material-model="\'Material\' + $modalCtrl.selectedMaterialCategory" division-ids="[$modalCtrl.divisionId]" material-meta="$modalCtrl.materialMeta" material-table-configs="$modalCtrl.materialTableConfigs" allow-aggregation="false" filter-with-prices="false" on-select-func="$modalCtrl.selectedMaterial" ui-config="{ chooseBtnIcon: \'fa fa-check\', chooseBtnLabel: \'components.financialMaterialPicker.choose\', showRemovePricesBtn: false, showOnlyWithPricesSwitcher: true, showOnlyMissingPricesSwitcher: false }"></financial-material-picker></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.close">Schlie\xDFen</button></div></div></div>');
$templateCache.put('app/pages/administration/finances/components/materialsPrices/materialsPrices.comp.html','<div><script type="text/ng-template" id="financeMaterialTypesPricesTreePanelHeaderHelpTooltip.tpl.html"><div class="p-5"> <h6>{{(\'generalTerms.legend\' | translate)}}:</h6> <table> <tr> <td><i class="fa fa-users color-primary mr-10"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypeOrgTooltip"></td> </tr> <tr> <td><i class="fa fa-exchange color-primary mr-10"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypeOrgOverrideTooltip"></td> </tr> <tr> <td><i class="fa fa-sitemap color-primary mr-10"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypeDivTooltip"></td> </tr> <tr><td>&nbsp;</td></tr> <tr> <td colspan="2"><h6 translate="modules.administration.finances.prices.materials.materialTypesTooltipTitle" class="text-gray"></h6></td> </tr> <tr> <td><i class="fa fa-medkit"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipMedicine"></td> </tr> <tr> <td><i class="fa fa-car"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipVehicles"></td> </tr> <tr> <td><i class="ion-tshirt"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipClothing"></td> </tr> <tr> <td><i class="ion-hammer"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipTools"></td> </tr> <tr> <td><i class="ion-cube"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipConsumables"></td> </tr> <tr> <td><i class="fa fa-archive"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypesTooltipOthers"></td> </tr> <tr><td>&nbsp;</td></tr> <tr> <td colspan="2"><h6 translate="generalTerms.actions" class="text-gray"></h6></td> </tr> <tr> <td><i class="af af-finance-add"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypePriceAddBtnLabel"></td> </tr> <tr> <td><i class="af af-finance-edit"></i></td> <td translate="modules.administration.finances.prices.materials.materialTypePriceEditBtnLabel"></td> </tr> </table> </div></script><div class="row mt-5"><div class="col-xs-12 col-md-6 col-lg-5"><div ba-panel="" ba-panel-title="\'modules.administration.finances.prices.materials.materialTypesTitle\'" ba-panel-header-tooltip-template="financeMaterialTypesPricesTreePanelHeaderHelpTooltip.tpl.html"><arno-material-types-prices-treeview material-types-tree-data="$materialsPricesCtrl.initialMaterialTypes" filter-items-with-missing-prices="$materialsPricesCtrl.filterItemsWithMissingPrices" selected-ctx="$materialsPricesCtrl.context" is-loading="false" selected-node="$materialsPricesCtrl.selectedMaterialTypeNode" ui-config="$materialsPricesCtrl.materialsTypesTreeUiConfig" node-select="$materialsPricesCtrl.materialTypeNodeSelect" add-handler="$materialsPricesCtrl.addMaterialTypePriceItem" edit-handler="$materialsPricesCtrl.editMaterialTypePriceItem"></arno-material-types-prices-treeview></div></div><div class="col-xs-12 col-md-6 col-lg-7"><div ba-panel="" ba-panel-division-selector="false" ba-panel-class="tabs-panel horizontal-tabs"><uib-tabset active="$materialsPricesCtrl.currentActiveMaterialsTab" class="suppress-tab-content"><uib-tab ng-repeat="category in $materialsPricesCtrl.ALLOWED_MATERIALS_CATEGORIES" ng-click="$materialsPricesCtrl.selectMaterialTab(category)"><uib-tab-heading><i class="{{ $materialsPricesCtrl.materialsTabsIconMapping[\'Material\' + category] || \'\' }}"></i> <span translate="{{ \'modules.administration.finances.prices.materialSearchModal.materialsCategoriesLabels.\' + category }}"></span></uib-tab-heading></uib-tab></uib-tabset><div ng-switch="$materialsPricesCtrl.isOrgContext()"><div ng-switch-default="" class="tab-content mb-12"><financial-material-picker ng-if="$materialsPricesCtrl.selectedMaterialCategory && $materialsPricesCtrl.materialTableConfigs && $materialsPricesCtrl.materialMeta" material-model="$materialsPricesCtrl.getMaterialCategory()" material-type-id="$materialsPricesCtrl.selectedMaterialTypeNode.model.OverwrittenMaterialTypeId || $materialsPricesCtrl.selectedMaterialTypeNode.model.id" division-ids="$materialsPricesCtrl.context" material-meta="$materialsPricesCtrl.materialMeta" material-table-configs="$materialsPricesCtrl.materialTableConfigs" on-select-func="$materialsPricesCtrl.selectedMaterials" on-remove-prices-fn="$materialsPricesCtrl.removeMaterialsPrices" ui-config="{ chooseBtnIcon: \'ion-edit\', chooseBtnLabel: \'generalTerms.edit\', showRemovePricesBtn: true, showOnlyWithPricesSwitcher: false, showOnlyMissingPricesSwitcher: true }"></financial-material-picker></div><div ng-switch-when="true" class="text-center mt-20 mb-20"><strong translate="modules.administration.finances.prices.materials.chooseDivision"></strong></div></div></div></div></div></div>');
$templateCache.put('app/pages/administration/material/inspection/inspectionModal/createInspection.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.material.inspection.addInspection"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" translate="modules.administration.material.inspection.modal.name"></label> <input type="text" ng-model="$modalCtrl.inspection.name" class="form-control" id="nameInput" placeholder="{{\'generalTerms.createName\' | translate: {lowercase: false} }}" maxlength="254" required="true"></div><div class="form-group"><label for="descriptionInput" translate="modules.administration.material.inspection.modal.description"></label> <textarea type="textarea" ng-model="$modalCtrl.inspection.description" class="form-control" style="resize: none" id="descriptionInput" placeholder="{{ \'generalTerms.description\' | translate }}"></textarea></div><div class="form-group"><label for="periodicInspectionSwitch" translate="modules.administration.material.inspection.addInterval"></label><br><ba-switcher id="periodicInspectionSwitch" switcher-keys="$modalCtrl.switcherKeys" switcher-style="primary" switcher-value="$modalCtrl.inspection.periodicInspection"></ba-switcher></div><div ng-show="$modalCtrl.inspection.periodicInspection" class="modal-body row"><div class="col-md-6 pl-0"><div class="form-group"><label for="intervalInput" translate="modules.administration.material.inspection.modal.inspectionIntervalRecommended"></label> <input type="number" class="form-control" id="intervalInputRec" ng-model="$modalCtrl.inspection.inspectionIntervalRecommended" min="1" max="1000000" step="1" required="true"></div></div><div class="col-md-6 pr-0"><div class="form-group"><label for="intervalInput" translate="modules.administration.material.inspection.modal.inspectionIntervalMaximum"></label> <input type="number" class="form-control" id="intervalInputMax" ng-model="$modalCtrl.inspection.inspectionIntervalMaximum" min="1" max="1000000" step="1" required="true"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$modalCtrl.valid($modalCtrl.inspection)" ng-click="$modalCtrl.upsertInspection($modalCtrl.inspection)" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/material/inspection/inspectionModal/deleteInspection.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.material.inspection.modal.deleteInspection"></h4></div><div class="modal-body"><p translate="modules.administration.material.inspection.modal.permanentDeleteInspection"></p><p translate="modules.administration.material.inspection.modal.requestDeleteInspection" translate-values="{name: $modalCtrl.inspection.name}"></p></div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button class="btn btn-with-icon btn-danger pull-right" ng-click="$modalCtrl.confirmDelete($modalCtrl.inspection.id, $modalCtrl.inspection.name)" translate="modules.administration.material.inspection.modal.deleteInspection"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/material/inspection/inspectionModal/editInspection.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.material.inspection.editInspection"></h4></div><div class="modal-body"><div class="form-group"><label for="idInput">ID</label> <input type="text" disabled="" ng-model="$modalCtrl.inspection.id" class="form-control" id="idInput" required="false"></div><div class="form-group"><label for="nameInput" translate="modules.administration.material.inspection.modal.name"></label> <input type="text" ng-model="$modalCtrl.inspection.name" class="form-control" id="nameInput" placeholder="{{\'generalTerms.createName\' | translate: {lowercase: false} }}" maxlength="254" required="true"></div><div>{{ name }}</div><div class="form-group"><label for="descriptionInput" translate="modules.administration.material.inspection.modal.description"></label> <textarea type="textarea" ng-model="$modalCtrl.inspection.description" class="form-control" style="resize: none" id="descriptionInput" placeholder="{{ \'generalTerms.description\' | translate }}"></textarea></div><div class="form-group"><label for="periodicInspectionSwitch" translate="modules.administration.material.inspection.addInterval"></label><br><ba-switcher id="periodicInspectionSwitch" switcher-keys="$modalCtrl.switcherKeys" switcher-style="primary" switcher-value="$modalCtrl.inspection.periodicInspection"></ba-switcher></div><div ng-show="$modalCtrl.inspection.periodicInspection" class="modal-body row"><div class="col-md-6 pl-0 pr-0"><div class="form-group"><label for="intervalInput" translate="modules.administration.material.inspection.modal.inspectionIntervalRecommended"></label> <input type="number" ng-model="$modalCtrl.inspection.inspectionIntervalRecommended" class="form-control" id="intervalInput" min="1" step="1" required="true"></div></div><div class="col-md-6 pr-0"><div class="form-group"><label for="intervalInput" translate="modules.administration.material.inspection.modal.inspectionIntervalMaximum"></label> <input type="number" ng-model="$modalCtrl.inspection.inspectionIntervalMaximum" class="form-control" id="intervalInput" min="1" step="1" required="true"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-disabled="!$modalCtrl.valid($modalCtrl.inspection)" ng-click="$modalCtrl.upsertInspection($modalCtrl.inspection)" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/material/materialTypes/modals/deleteWarningModal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title">Materialtyp wird bereits verwendet</h4></div><div class="modal-body text-center"><div class="section-block red-text"><div ng-if="$modalCtrl.data.modalType === \'overwrittenDivisions\'"><p>Die L\xF6schung ist nicht m\xF6glich, da der ausgew\xE4hlte Materialtyp bereits in den folgenden Gliederungen \xFCberschrieben wurde:</p><ul><li class="align-left" ng-repeat="division in $modalCtrl.data.overwrittenDivisions">{{division.Name}}</li></ul><br><p>Um fortzufahren muss der entsprechende Materialtyp erst aus den genannten Gliederungen gel\xF6scht werden.</p></div><div ng-if="$modalCtrl.data.modalType === \'divisionChildren\'"><p>Der Materialtyp besitzt angeh\xE4ngte Untertypen innerhalb der folgenden Gliderungen:</p><ul><li class="align-left" ng-repeat="division in $modalCtrl.data.divisionChildren">{{division.Name}}</li></ul><br><p>Um fortzufahren m\xFCssen die Untertypen innerhalb der genannten Gliederungen verschoben oder gel\xF6scht werden.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close()" data-cy="terms-update-re-approve">Zur\xFCck</button></div></div>');
$templateCache.put('app/pages/administration/personnel/activities/activityWindow/activity.html','<div class="row"><div class="col-md-12"><div ba-panel=""><form id="activityForm" name="activityForm" novalidate="" angular-validator="" angular-validator-submit="$activityWindowCtrl.applyWindow(\'add\')"><h3 class="with-line"><span translate="generalTerms.general"></span></h3><div class="row"><div class="col-md-6"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminActivities.nameOfActivity"></label> <input type="text" class="form-control" id="nameInput" name="nameInput" ng-model="$activityWindowCtrl.activity.title" ng-model-options="{ debounce: 200 }" validator="!$activityWindowCtrl.isActivityNameExistent($activityWindowCtrl.activity.Id)" invalid-message="\'modules.administration.adminActivities.invalidActivity\' |translate" required-message="\'modules.administration.adminActivities.requiredActivity\' |translate" required=""></div><div class="form-group"><label for="descInput" translate="generalTerms.description"></label> <textarea type="text" class="form-control" id="descInput" name="descInput" ng-model="$activityWindowCtrl.activity.description"></textarea></div></div></div><div ng-if="$activityWindowCtrl.activityHierarchy.length" class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.designmentOfGroups"></label><ui-select ng-model="$activityWindowCtrl.pickedGroup" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match placeholder="{{\'modules.administration.adminClearances.chooseGroup\' | translate}}"><span ng-bind="$activityWindowCtrl.pickedGroup.Title"></span></ui-select-match><ui-select-choices position="down" repeat="activityGroup in $activityWindowCtrl.activityHierarchy"><span ng-bind="::activityGroup.Title"></span></ui-select-choices></ui-select></div><div class="form-group"><label translate="modules.administration.adminActivities.mainPeriodOfValidity"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$activityWindowCtrl.validityHelper.active"></ba-switcher></div><div class="qualification-form-validity-input" ng-class="{\'inactive\': !$activityWindowCtrl.validityHelper.active}"><input type="number" min="0" step="1" class="form-control" id="validityInputDay" name="validityInputDay" ng-disabled="!$activityWindowCtrl.validityHelper.active" ng-model="$activityWindowCtrl.validityHelper.days"><span translate="modules.administration.adminActivities.days" translate-values="{ PLURAL: !($activityWindowCtrl.validityHelper.days === 1) }">Tag{{$activityWindowCtrl.validityHelper.days === 1 ? \'\' : \'e\'}}</span> <input type="number" min="0" step="1" class="form-control" id="validityInputMonth" name="validityInputMonth" ng-disabled="!$activityWindowCtrl.validityHelper.active" ng-model="$activityWindowCtrl.validityHelper.months"><span translate="modules.administration.adminActivities.months" translate-values="{ PLURAL: !($activityWindowCtrl.validityHelper.months === 1) }">Monat{{$activityWindowCtrl.validityHelper.months === 1 ? \'\' : \'e\'}}</span> <input type="number" min="0" step="1" class="form-control" id="validityInputYear" name="validityInputYear" ng-disabled="!$activityWindowCtrl.validityHelper.active" ng-model="$activityWindowCtrl.validityHelper.years"><span translate="modules.administration.adminActivities.years" translate-values="{ PLURAL: !($activityWindowCtrl.validityHelper.years === 1) }">Jahr{{$activityWindowCtrl.validityHelper.years === 1 ? \'\' : \'e\'}}</span></div><span class="help-block sub-little-text" translate="modules.administration.adminActivities.longActivityText"></span></div><div class="row"><div class="col-md-12"><uib-accordion><uib-accordion-group ng-repeat="requirementsSetGroup in $activityWindowCtrl.requirementsSetGroups | orderBy:[\'Name\']" ng-init="requirementsSetGroup.tabOpen = false" is-open="$first" panel-class="panel-default bootstrap-panel accordion-panel"><uib-accordion-heading><span>{{requirementsSetGroup.Name}}</span> <i class="pull-right" ng-class="{\'ion-chevron-down\': requirementsSetGroup.tabOpen, \'ion-chevron-right\': !requirementsSetGroup.tabOpen}"></i><div class="btn-toolbar pull-right no-padding" ng-if="$activityWindowCtrl.showActions"><button class="btn btn-default btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $activityWindowCtrl.openGroup(\'editRequirementsSetGroup\', requirementsSetGroup, null)" title="{{ \'generalTerms.edit\' |translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" ng-click="$event.preventDefault(); $event.stopPropagation(); $activityWindowCtrl.openGroup(\'deleteRequirementsSetGroup\', requirementsSetGroup, null)" title="{{ \'generalTerms.delete\' |translate }}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></uib-accordion-heading><div class="row" ng-if="requirementsSetGroup.tabOpen || requirementsSetGroup.tabWasOpenOnce"><div class="col-md-12" ng-init="requirementsSetGroup.tabWasOpenOnce = true"><div class="table-responsive"><table class="table table-condensed table-hover"><tbody class="without-top-border"><tr ng-repeat="requirementsSet in $activityWindowCtrl.activity.requirementsSets | orderBy:[\'Name\'] | filter:{ requirementsSetId: requirementsSetGroup.id }:true track by $index"><td class="align-left-force"><i class="ion-android-list"></i> {{requirementsSet.title}}</td><td class="align-right-force"><div><button class="btn btn-default btn-with-icon btn-xs" type="button" ng-click="$activityWindowCtrl.openRequirementsSetModal(requirementsSet)" title="{{ \'generalTerms.edit\' |translate }}"><i class="ion-edit"></i><span translate="generalTerms.edit"></span></button> <button class="btn btn-danger btn-with-icon btn-xs" type="button" ng-click="$activityWindowCtrl.deleteRequirementsSet(requirementsSet)" title="{{ \'generalTerms.delete\' |translate }}"><i class="ion-ios-trash"></i><span translate="generalTerms.delete"></span></button></div></td></tr><tr ng-if="!$activityWindowCtrl.activity.requirementsSets.length"><td colspan="2" class="text-center"><i translate="modules.administration.adminActivities.noRequirementSetsDeposited"></i></td></tr></tbody></table></div></div></div><div class="row" ng-if="requirementsSetGroup.tabOpen || requirementsSetGroup.tabWasOpenOnce || true"><div class="col-md-12 mt-10" ng-init="requirementsSetGroup.tabWasOpenOnce = true"><button type="button" class="btn btn-primary btn-with-icon" ng-click="$activityWindowCtrl.openRequirementsSetModal()"><i class="ion-plus"></i><span translate="modules.administration.adminActivities.addRequirementSet"></span></button></div></div></uib-accordion-group></uib-accordion></div></div><div class="row btns-row align-right"><div class="col-md-12"><button data-cy="administration-personnel-activities-activitywindow-cancel" type="button" class="btn btn-default" ng-click="$activityWindowCtrl.applyWindow(\'cancel\')" translate="generalTerms.cancel"></button> <button data-cy="administration-personnel-activities-activitywindow-submit" type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></div></form></div></div></div>');
$templateCache.put('app/pages/administration/personnel/activities/activityGroupModal/addActivityGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.activityGroup.Name, null, \'addActivityGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminActivities.addActivGroup"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminActivities.nameOfActiveGroup"></label> <input type="text" ng-model="$modalCtrl.activityGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.activityGroup.Name)" invalid-message="\'modules.administration.adminActivities.invalidMessageAddActiveGroup\' |translate" required-message="\'modules.administration.adminActivities.requiredMessageAddActiveGroup\' |translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/activities/activityGroupModal/deleteActivityGroup.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminActivities.deleteActivGroup"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminActivities.reallyDelteActiveGroup" translate-values="{activeGroupTitle: $modalCtrl.activityGroup.Title}"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.applyModal($modalCtrl.activityGroup.Title, $modalCtrl.activityGroup.id, \'deleteActivityGroup\', null)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/activities/activityGroupModal/editActivityGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.activityGroup.Title, $modalCtrl.activityGroup.id, \'editActivityGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminActivities.editQualiGroup"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminActivities.nameOfActiveGroup"></label> <input type="text" ng-model="$modalCtrl.activityGroup.Title" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.activityGroup.Name, $modalCtrl.activityGroup.id)" invalid-message="\'modules.administration.adminActivities.invalidMessageAddActiveGroup\' |translate" required-message="\'modules.administration.adminActivities.requiredMessageAddActiveGroup\' |translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/blockage/modals/deleteReason.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminBlockage.deleteLockReason"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminBlockage.blockageDeleteText" translate-values="{deletionElement: deletionElement}"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i> <span translate="generalTerms.delete"></span></button></div></div>');
$templateCache.put('app/pages/administration/personnel/blockage/modals/handleReason.html','<div class="modal-content reason-add-modal"><form ng-submit="$ctrl.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminBlockage.lockReasonEditOrAdd" translate-values="{blockageReasonId: $ctrl.reasonId}"></h4></div><div class="modal-body"><div><div class="row"><div class="form-group clearfix col-sm-12"><label for="reason" class="control-label required-label" translate="modules.administration.adminBlockage.designationOfLockReason"></label> <input type="text" tabindex="1" class="form-control" name="reason" id="reason" ng-model="$ctrl.reasonName"></div></div></div></div><div class="modal-footer"><button type="submit" tabindex="3" class="btn btn-with-icon btn-primary" ng-click="$ctrl.handleReason()"><i class="ion-checkmark-round"></i> {{ $ctrl.reasonId ? \'generalTerms.edit\' : \'generalTerms.add\' | translate}}</button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceGroupModal/addClearanceGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.clearanceGroup.Name, null, \'addClearanceGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminClearances.addReleaseGroup"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminClearances.clearanceGroupName"></label> <input data-cy="administration-personnel-clearances-addgroupmodal-nameinput" type="text" ng-model="$modalCtrl.clearanceGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.clearanceGroup.Name)" invalid-message="\'modules.administration.adminClearances.identReleaseGroup\' |translate" required-message="\'modules.administration.adminClearances.groupNameIsMissing\' |translate" required=""></div></div><div class="modal-footer"><button data-cy="administration-personnel-clearances-addgroupmodal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="administration-personnel-clearances-addgroupmodal-submit" type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceGroupModal/deleteClearanceGroup.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminClearances.releaseGroupDelete"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminClearances.reallyDeleteClearanceGroup" translate-values="{clearGroup: $modalCtrl.clearanceGroup.Name}"><span ng-if="$modalCtrl.clearanceGroup.Approvals.length > 0" translate="modules.administration.adminClearances.cantAssigned"></span></p><p ng-if="$modalCtrl.clearanceGroup.Approvals.length > 0" translate="modules.administration.adminClearances.followOfCompletelyDelete"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.applyModal($modalCtrl.clearanceGroup.Name, $modalCtrl.clearanceGroup.id, \'deleteClearanceGroup\', null)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button> <button ng-if="$modalCtrl.clearanceGroup.Approvals.length > 0" type="button" class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.onClickFullDelete($modalCtrl.clearanceGroup.Name, $modalCtrl.clearanceGroup.id, \'deleteClearanceGroup\', null)" translate="modules.administration.adminClearances.completelyDelete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceGroupModal/editClearanceGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.clearanceGroup.Name, $modalCtrl.clearanceGroup.id, \'editClearanceGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminClearances.editReleaseGroup"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminClearances.clearanceGroupName"></label> <input type="text" ng-model="$modalCtrl.clearanceGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.clearanceGroup.Name, $modalCtrl.clearanceGroup.id)" invalid-message="\'modules.administration.adminClearances.identReleaseGroup\' |translate" required-message="\'modules.administration.adminClearances.groupNameIsMissing\' |translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceModal/addClearances.html','<div class="modal-content"><form id="clearanceForm" name="clearanceForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-header"><h4 class="modal-title">{{$modalCtrl.modalTitle}}</h4></div><div class="modal-body"><h3 class="with-line" toggle-next="">{{ \'modules.administration.adminClearances.detailsOfRelease\' |translate}}</h3><div class="row"><div class="col-md-12"><div class="form-group"><label for="titleInput" class="required-label" translate="modules.administration.adminClearances.nameOfRelease"></label> <input data-cy="administration-personnel-clearances-modal-nameinput" type="text" placeholder="{{ \'generalTerms.createName\' |translate: {lowercase: true} }}" ng-model="$modalCtrl.title" class="form-control" id="titleInput" name="titleInput" ng-model-options="{ debounce: 200 }" validator="!$modalCtrl.isClearanceTitleExistent($modalCtrl.title)" invalid-message="\'modules.administration.adminClearances.releaseNameIsExist\' |translate" required-message="\'modules.administration.adminClearances.releaseNameIsMissing\' |translate" required=""></div><div class="form-group"><label for="linkInput" translate="generalTerms.description"></label> <input data-cy="administration-personnel-clearances-modal-descriptioninput" type="text" ng-model="$modalCtrl.description" class="form-control" id="linkInput" placeholder="{{ \'modules.administration.adminClearances.linkAndNote\' |translate }}"></div></div></div><div class="form-group"><h3 class="with-line" toggle-next="">{{ \'generalTerms.settings\' |translate}}</h3><div class="row"><div class="col-md-12"><div ng-if="$modalCtrl.CLEARANCES_TYPES.length > 0" class="form-group mb-0" ng-class="{\'has-error\': (clearanceForm.clearanceType.$touched || clearanceForm.$submitted) && clearanceForm.clearanceType.$error.required}"><label for="linkInput" translate="modules.administration.adminClearances.artOfRelease"><arno-ba-help-tooltip text="{{\'modules.administration.adminClearances.clearancesAdminClearanceTypeInfo\' | translate}}"></arno-ba-help-tooltip></label><ui-select ng-model="$modalCtrl.clearanceType" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" name="clearanceType" search-enabled="false" ng-required="true"><ui-select-match placeholder="{{ \'modules.administration.adminClearances.releaseTypeChoose\' |translate }}"><span ng-bind="$modalCtrl.clearanceType.Name"></span></ui-select-match><ui-select-choices position="down" repeat="clearanceType in $modalCtrl.CLEARANCES_TYPES"><span ng-bind="::clearanceType.Name"></span></ui-select-choices></ui-select><label ng-messages="(clearanceForm.clearanceType.$touched || clearanceForm.$submitted) && clearanceForm.clearanceType.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.administration.adminClearances.typeOfRelease"></span></label></div></div><div class="col-md-12 mt-20 mb-20"><label translate="modules.administration.adminClearances.maxTimeActive"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$modalCtrl.maxResubTime.active" switcher-keys="$modalCtrl.switcherKeys" switcher-force-default="true"></ba-switcher></div><div class="qualification-form-validity-input" ng-class="{\'inactive\': !$modalCtrl.maxResubTime.active}"><input type="number" class="form-control" id="validityInputDay" name="validityInputDay" min="0" step="1" ng-disabled="!$modalCtrl.maxResubTime.active" ng-model="$modalCtrl.maxResubTime.days"><span translate="modules.administration.adminClearances.days" translate-values="{validityDays: $modalCtrl.maxResubTime.days}"></span> <input type="number" class="form-control" id="validityInputMonth" name="validityInputMonth" min="0" step="1" ng-disabled="!$modalCtrl.maxResubTime.active" ng-model="$modalCtrl.maxResubTime.months"><span translate="modules.administration.adminClearances.months" translate-values="{validityMonths: $modalCtrl.maxResubTime.months}"></span> <input type="number" class="form-control" id="validityInputYear" name="validityInputYear" min="0" step="1" ng-disabled="!$modalCtrl.maxResubTime.active" ng-model="$modalCtrl.maxResubTime.years"><span translate="modules.administration.adminClearances.years" translate-values="{validityYears: $modalCtrl.maxResubTime.years}"></span></div></div><div class="col-md-12"><label for="rejectionInput" translate="modules.administration.adminClearances.discardStatus"></label><div class="form-group mb-0"><ba-switcher name="rejectionInput" switcher-style="primary" switcher-value="$modalCtrl.allowRejected" switcher-keys="$modalCtrl.switcherKeys" switcher-force-default="true"></ba-switcher></div></div><div class="col-md-12"><div ng-if="$modalCtrl.clearanceHierarchy.length > 0 && $modalCtrl.clearance.id != null" class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.designmentOfGroups"></label><ui-select ng-model="$modalCtrl.clearance.viewSelectedGroup" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match placeholder="{{\'modules.administration.adminClearances.chooseGroup\' | translate}}"><span ng-bind="$modalCtrl.clearance.viewSelectedGroup.Name"></span></ui-select-match><ui-select-choices position="down" repeat="clearanceGroup in $modalCtrl.clearanceHierarchy"><span ng-bind="::clearanceGroup.Name"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">{{ \'modules.administration.adminClearances.namingTheDateFields\' | translate }}</h3><div class="row"><div class="col-md-12"><div class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.coverLetter"></label> <input data-cy="administration-personnel-clearances-modal-add-letter" type="text" ng-model="$modalCtrl.letterTitle" class="form-control" placeholder="{{ \'modules.administration.adminClearances.coverLetter\' |translate }}"></div><div class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.firstReminder"></label> <input data-cy="administration-personnel-clearances-modal-add-reminder1" type="text" ng-model="$modalCtrl.reminder1Title" class="form-control" placeholder="{{ \'modules.administration.adminClearances.firstReminder\' |translate }}"></div><div class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.secondReminder"></label> <input data-cy="administration-personnel-clearances-modal-add-reminder2" type="text" ng-model="$modalCtrl.reminder2Title" class="form-control" placeholder="{{ \'modules.administration.adminClearances.secondReminder\' |translate }}"></div><div class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.inspection"></label> <input data-cy="administration-personnel-clearances-modal-add-inspection" type="text" ng-model="$modalCtrl.inspectionTitle" class="form-control" placeholder="{{ \'modules.administration.adminClearances.inspection\' |translate }}"></div><div class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.resubmission"></label> <input data-cy="administration-personnel-clearances-modal-add-resubmission" type="text" ng-model="$modalCtrl.resubmissionTitle" class="form-control" placeholder="{{ \'modules.administration.adminClearances.resubmission\' |translate }}"></div></div></div></div><div class="modal-footer"><button data-cy="administration-personnel-clearances-modal-add-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button data-cy="administration-personnel-clearances-modal-add-submit" type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceModal/confirmSubDivCopy.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminClearances.confirmManagerCopy"></h4></div><div class="modal-body"><p translate="modules.administration.adminClearances.whichMembersShouldBeCopied"></p><div class="alert bg-warning mt-10"><h4 translate="modules.administration.adminClearances.attention"></h4><span translate="modules.administration.adminClearances.thisProcessOverwritesAll"></span></div><div><div><label class="custom-checkbox"><input type="checkbox" ng-model="$ctrl.opts.copyInit"><span translate="modules.administration.adminClearances.initiatingMember"></span></label></div><div><label class="custom-checkbox"><input type="checkbox" ng-model="$ctrl.opts.copyEdit"><span translate="modules.administration.adminClearances.editedMember"></span></label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-click="$ctrl.applyModal()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/personnel/clearances/clearanceModal/deleteClearance.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminClearances.deleteOfAnClearances"></h4></div><div class="modal-body"><span translate="modules.administration.adminClearances.reallyDeleteTheClearance"></span></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-danger" ng-click="$modalCtrl.applyDeleteModal()" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/clearances/editResponsiblePersonsModal/editResponsiblePersonsModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminClearances.divReleaseAssign"></h4></div><div class="modal-body"><div ng-if="$ctrl.isBulk" class="alert bg-warning mt-10"><h4 translate="modules.administration.adminClearances.attention"></h4><span translate="modules.administration.adminClearances.initiationAndEditMembers"></span></div><div ng-repeat="responsibleType in $ctrl.responsilbeTypes"><label>{{ responsibleType.name }}</label><table st-table="displayedCollection" class="table table-condensed table-hover"><thead><tr class="sortable"><th st-sort-default="true" translate="generalTerms.firstName"></th><th st-sort-default="true" translate="generalTerms.lastName"></th><th class="text-center" translate="generalTerms.actions"></th></tr></thead><tr ng-show="!responsibleType.members() || responsibleType.members().length === 0"><td colspan="3" class="arno-pointing-pointer text-center"><i>{{ responsibleType.noMemberMessage }}</i></td></tr><tr ng-repeat="member in responsibleType.members()" class="editable-row"><td class="arno-pointing-pointer"><span>{{ member.FirstName }}</span></td><td class="arno-pointing-pointer"><span>{{ member.LastName }}</span></td><td class="arno-table-button-cell"><form editable-form="" name="rowform"><button class="btn btn-default btn-with-icon btn-xs" ng-click="responsibleType.removeMethod(member.id)" title="{{ \'modules.administration.adminClearances.editDivReleaseAssign\' |translate }}"><i class="ion-edit"></i><span class="hidden-xs" translate="generalTerms.remove"></span></button></form></td></tr></table><br><ui-select ng-model="$ctrl.selectedMember" class="btn-group bootstrap-select form-control" search-enabled="true" on-select="responsibleType.addMethod()" spinner-enabled="true"><ui-select-match placeholder="{{ \'modules.administration.adminClearances.searchMember\' |translate }}">{{ $select.selected.fullName }}</ui-select-match><ui-select-choices position="down" ui-disable-choice="member.selected || member.hint" repeat="member in $ctrl.members" refresh="$ctrl.searchMembers($select.search, responsibleType.isInitiatingMember)" refresh-delay="200" group-by="$ctrl.groupByFirstName"><span class="person-select" ng-if="!member.hint"><i class="ion-person"></i> <span>{{ member.fullName + \' (\' + member.Account.EMail + \')\' }}</span> <span ng-show="member.selected" style="color: #AAA; font-style: italic" translate="modules.administration.adminClearances.alreadyAdded"></span></span> <span ng-if="member.hint"><i class="ion-search"></i> <span translate="modules.administration.adminClearances.pleaseTabForMoreResults"></span></span></ui-select-choices></ui-select><hr></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-click="$ctrl.save()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationGroupModal/addQualificationGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.qualificationGroup.Name, null, \'addQualificationGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminQualification.groupCreate" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminQualification.qualificationGroupName" translate-values="$modalCtrl.translateValues"></label> <input type="text" ng-model="$modalCtrl.qualificationGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.qualificationGroup.Name)" invalid-message="\'modules.administration.adminQualification.invalidQualificationAdd\' |translate" required-message="\'modules.administration.adminQualification.requiredQualificationAdd\' |translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationGroupModal/deleteQualificationGroup.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminQualification.deleteQualificationGroup" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminQualification.requiredDeleteQualificationGroup" translate-values="$modalCtrl.translateValues"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.applyModal($modalCtrl.qualificationGroup.Name, $modalCtrl.qualificationGroup.id, \'deleteQualificationGroup\', null)" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationGroupModal/editQualificationGroup.html','<div class="modal-content"><form id="groupForm" name="groupForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal($modalCtrl.qualificationGroup.Name, $modalCtrl.qualificationGroup.id, \'editQualificationGroup\', null)"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminQualification.editQualificationGroup" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminQualification.qualificationGroupName" translate-values="$modalCtrl.translateValues"></label> <input type="text" ng-model="$modalCtrl.qualificationGroup.Name" class="form-control" ng-model-options="{ debounce: 200 }" name="nameInput" id="nameInput" validator="!$modalCtrl.isGroupNameExistent($modalCtrl.qualificationGroup.Name, $modalCtrl.qualificationGroup.id)" invalid-message="\'modules.administration.adminQualification.invalidQualificationAdd\' |translate" required-message="\'modules.administration.adminQualification.requiredQualificationAdd\' |translate" required=""></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationModal/addQualification.html','<div class="modal-content"><form id="qualificationForm" name="qualificationForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal(\'addQualification\')"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminQualification.addQualification" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><h5 class="modal-subtitle" translate="modules.administration.adminQualification.main"><i class="ion-android-list"></i></h5><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminQualification.nameOfQualification" translate-values="$modalCtrl.translateValues"></label> <input type="text" class="form-control" id="nameInput" name="nameInput" ng-model="$modalCtrl.qualification.Name" ng-model-options="{ debounce: 200 }" validator="!$modalCtrl.isQualificationNameExistent($modalCtrl.qualification.Name)" invalid-message="\'modules.administration.adminQualification.invalidQualificationAdd\' |translate" required-message="\'modules.administration.adminQualification.requiredQualificationAdd\' |translate" required=""></div><div class="form-group"><label for="descInput" translate="generalTerms.description"></label> <textarea type="text" class="form-control" id="descInput" name="descInput" ng-model="$modalCtrl.qualification.Description"></textarea></div><div class="form-group"><label translate="modules.administration.adminQualification.mainPeriodOfValidity"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$modalCtrl.validityHelper.active"></ba-switcher></div><div class="qualification-form-validity-input" ng-class="{\'inactive\': !$modalCtrl.validityHelper.active}"><input type="number" class="form-control" id="validityInputDay" name="validityInputDay" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.days"><span translate="generalTerms.days" translate-values="{validityDays: $modalCtrl.validityHelper.days}"></span> <input type="number" class="form-control" id="validityInputMonth" name="validityInputMonth" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.months"><span translate="generalTerms.months" translate-values="{validityMonths: $modalCtrl.validityHelper.months}"></span> <input type="number" class="form-control" id="validityInputYear" name="validityInputYear" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.years"><span translate="generalTerms.years" translate-values="{validityYears: $modalCtrl.validityHelper.years}"></span></div><span class="help-block sub-little-text" translate="modules.administration.adminQualification.longQualificationText"></span></div><div class="form-group" ng-if="$modalCtrl.isOrg"><label translate="modules.administration.adminQualification.autoUpdateValidity"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$modalCtrl.qualification.AutoUpdateValidity"></ba-switcher></div></div><div ng-if="$modalCtrl.type === \'qualification\'"><h5 class="modal-subtitle"><i class="ion-pricetag"></i> <span translate="modules.administration.adminQualification.adultsQualification" translate-values="$modalCtrl.translateValues"></span></h5><qualification-list qualification-list="$modalCtrl.parentQualifications" qualification-states="[{ title: \'$modalCtrl.translateValues.typeSingular\', intext: \'$modalCtrl.translateValues.typeSingular\', showSectionHeader: false }]" qualification-add="$modalCtrl.qualificationHierarchy" qualification-exclude="$modalCtrl.excludedParentQualifications" qualification-delete="true" qualification-change-model="$modalCtrl.parentQualificationsChanges" qualification-translations="$modalCtrl.translateValues" qualification-type="$modalCtrl.type"></qualification-list><h5 class="modal-subtitle"><i class="ion-pricetags"></i> <span translate="modules.administration.adminQualification.kidsQualification" translate-values="$modalCtrl.translateValues"></span></h5><qualification-list qualification-list="$modalCtrl.childQualifications" qualification-states="[{ title: \'$modalCtrl.translateValues.typeSingular\', intext: \'$modalCtrl.translateValues.typeSingular\', showSectionHeader: false }]" qualification-add="$modalCtrl.qualificationHierarchy" qualification-exclude="$modalCtrl.excludedChildQualifications" qualification-delete="true" qualification-change-model="$modalCtrl.childQualificationsChanges" qualification-translations="$modalCtrl.translateValues" qualification-type="$modalCtrl.type"></qualification-list></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationModal/deleteQualification.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminQualification.deleteQualification" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminQualification.reallyDeleteQualificationMember" translate-values="$modalCtrl.translateValues"></p><p translate="modules.administration.adminQualification.deleteModalQualificationName" translate-values="$modalCtrl.translateValues"></p><p translate="modules.administration.adminQualification.deleteArchiveMessages" translate-values="$modalCtrl.translateValues"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$modalCtrl.applyModal(\'deleteQualification\')" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/qualificationModal/editQualification.html','<div class="modal-content"><form id="qualificationForm" name="qualificationForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal(\'editQualification\')"><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminQualification.editQualification" translate-values="$modalCtrl.translateValues"></h4></div><div class="modal-body"><h5 class="modal-subtitle" translate="modules.administration.adminQualification.main"><i class="ion-android-list"></i></h5><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminQualification.nameOfQualification" translate-values="$modalCtrl.translateValues"></label> <input type="text" class="form-control" id="nameInput" name="nameInput" ng-model="$modalCtrl.qualification.Name" ng-model-options="{ debounce: 200 }" validator="!$modalCtrl.isQualificationNameExistent($modalCtrl.qualification.Name, $modalCtrl.qualification.id)" invalid-message="\'modules.administration.adminQualification.invalidQualificationAdd\' |translate" required-message="\'modules.administration.adminQualification.requiredQualificationAdd\' |translate" required=""></div><div class="form-group"><label for="descInput" translate="generalTerms.description"></label> <textarea type="text" class="form-control" id="descInput" name="descInput" ng-model="$modalCtrl.qualification.Description"></textarea></div><div ng-if="$modalCtrl.qualificationHierarchy.length" class="form-group"><label for="linkInput" translate="modules.administration.adminClearances.designmentOfGroups"></label><ui-select ng-model="$modalCtrl.qualificationGroup" class="btn-group bootstrap-select form-control fix-dropdown-overlaying-input" search-enabled="false"><ui-select-match placeholder="{{\'modules.administration.adminClearances.chooseGroup\' | translate}}"><span ng-bind="$modalCtrl.qualificationGroup.Name"></span></ui-select-match><ui-select-choices position="down" repeat="qualificationGroup in $modalCtrl.qualificationHierarchy"><span ng-bind="::qualificationGroup.Name"></span></ui-select-choices></ui-select></div><div class="form-group"><label translate="modules.administration.adminQualification.mainPeriodOfValidity"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$modalCtrl.validityHelper.active"></ba-switcher></div><div class="qualification-form-validity-input" ng-class="{\'inactive\': !$modalCtrl.validityHelper.active}"><input type="number" class="form-control" id="validityInputDay" name="validityInputDay" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.days"><span translate="generalTerms.days" translate-values="{validityDays: $modalCtrl.validityHelper.days}"></span> <input type="number" class="form-control" id="validityInputMonth" name="validityInputMonth" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.months"><span translate="generalTerms.months" translate-values="{validityMonths: $modalCtrl.validityHelper.months}"></span> <input type="number" class="form-control" id="validityInputYear" name="validityInputYear" min="0" step="1" ng-disabled="!$modalCtrl.validityHelper.active" ng-model="$modalCtrl.validityHelper.years"><span translate="generalTerms.years" translate-values="{validityYears: $modalCtrl.validityHelper.years}"></span></div><span class="help-block sub-little-text" translate="modules.administration.adminQualification.longQualificationText"></span></div><div class="form-group" ng-if="$modalCtrl.isOrg"><label translate="modules.administration.adminQualification.autoUpdateValidity"></label><div class="pull-right"><ba-switcher switcher-style="primary" switcher-value="$modalCtrl.qualification.AutoUpdateValidity"></ba-switcher></div></div><div ng-if="$modalCtrl.type === \'qualification\'"><h5 class="modal-subtitle" translate="modules.administration.adminQualification.adultsQualification" translate-values="$modalCtrl.translateValues"><i class="ion-pricetag"></i></h5><qualification-list qualification-list="$modalCtrl.parentQualifications" qualification-states="[{ title: $modalCtrl.translateValues.typeSingular, intext: $modalCtrl.translateValues.typeSingular, showSectionHeader: false }]" qualification-add="$modalCtrl.qualificationHierarchy" qualification-exclude="$modalCtrl.excludedParentQualifications" qualification-delete="true" qualification-change-model="$modalCtrl.parentQualificationsChanges" qualification-translations="$modalCtrl.translateValues" qualification-type="$modalCtrl.type"></qualification-list><h5 class="modal-subtitle" translate="modules.administration.adminQualification.kidsQualification" translate-values="$modalCtrl.translateValues"><i class="ion-pricetags"></i></h5><qualification-list qualification-list="$modalCtrl.childQualifications" qualification-states="[{ title: $modalCtrl.translateValues.typeSingular, intext: $modalCtrl.translateValues.typeSingular, showSectionHeader: false }]" qualification-add="$modalCtrl.qualificationHierarchy" qualification-exclude="$modalCtrl.excludedChildQualifications" qualification-delete="true" qualification-change-model="$modalCtrl.childQualificationsChanges" qualification-translations="$modalCtrl.translateValues" qualification-type="$modalCtrl.type"></qualification-list></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.save"></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/qualifications/tabset/tabset.html','<div class="row arno-material"><div class="col-md-12"><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs panel-default" ba-panel-help-icon-type="directLink" ba-panel-help-icon="ARNO_SOCURA"><div><div class="divisionAtTab"><uib-tabset active="tabs.active" class="suppress-tab-content"><uib-tab class="tab {{tab.class}}" ng-repeat="tab in tabs" ng-click="go(tab)"><uib-tab-heading ng-bind-html="tab.heading" class="d-flex align-items-center"></uib-tab-heading></uib-tab></uib-tabset><division-selector multiple="false" allow-org-selection="true" entry-permission="arno.administration.personnel.qualifications.manageQualifications,arno.administration.personnel.qualifications.manageInstructions"></division-selector><div class="clearfix"></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/trainings/components/trainingTemplateEdit.tpl.html','');
$templateCache.put('app/pages/administration/personnel/trainings/overview/trainings.tpl.html','<div class="row administration__personnel__trainings__overview"><script type="text/ng-template" id="adminTrainingsTemplateTreePanelHeaderHelpTooltip.tpl.html"><div class="p-5"> <h6 translate="modules.administration.adminTrainings.legend"></h6> <table> <tr><td><i class="fa fa-sitemap mr-10"></i></td><td translate="modules.administration.adminTrainings.trainingsGroup"></td></tr> <tr><td><i class="fa fa-file-text-o"></i></td><td translate="modules.administration.adminTrainings.trainingsTemplate"></td></tr> </table> </div></script><div class="col-lg-6"><div ba-panel="" ba-panel-title="\'modules.administration.adminTrainings.trainingOverview\'" ba-panel-class="with-scroll administration__personnel__trainings__overview__treeview" ba-panel-header-tooltip-template="adminTrainingsTemplateTreePanelHeaderHelpTooltip.tpl.html"><div class="form-group clearfix administration__personnel__trainings__overview__treeview__header-top-bar"><div class="btn-toolbar"><button type="button" class="btn btn-default btn-sm btn-with-icon" ng-click="$ctrl.toggleCollapsed()"><i ng-class="{\'ion-chevron-up\': $ctrl.treeviewCollapsed === false, \'ion-chevron-down\': $ctrl.treeviewCollapsed === true }"></i> <span class="hidden-xs" translate="modules.administration.adminTrainings.trainingAll"><span ng-show="!$ctrl.treeviewCollapsed" translate="generalTerms.foldIn"></span> <span ng-show="$ctrl.treeviewCollapsed" translate="generalTerms.foldOut"></span></span></button></div><div class="btn-toolbar pull-right"><ba-switcher ng-if="$ctrl.showSwitcher()" switcher-style="primary" switcher-value="$ctrl.showTrainingsTemplates" switcher-width="120" switcher-keys="$ctrl.filterTrainingTemplateOptions" switcher-hints="$ctrl.filterTrainingTemplateHints"></ba-switcher></div></div><div class="row"><div class="col-sm-12"><script type="text/ng-template" id="nodesRenderer.tpl.html"><div class="node-embed" ui-tree-handle ng-dblClick="node.collapsed = !node.collapsed" ng-click="$ctrl.selectNode(node, $ctrl.trainingTemplateForm)" ng-class="{\'node-active\': node.id === $ctrl.selectedNode.id, \'hidden\': node.hidden, \'ml-5\': !node.children.length}"> <a class="btn btn-clear btn-xs division-chevron" ng-if="node.children.length"> <i ng-if="!node.hideChevron" ng-click="node.collapsed = !node.collapsed" class="fa" ng-class="{\'fa-chevron-right\': node.collapsed, \'fa-chevron-down\': !node.collapsed}"></i> </a> <div ng-class="{inline: node.children.length}"> <div class="ba-treeview-node-icon {{::node.iconCls}}"></div> <span class="ba-treeview-node-label {{node.labelCls}}" ng-bind="node.label"></span> </div> </div> </div> <ol ui-tree-nodes="options" ng-model="node.children" ng-class="{hidden: node.collapsed, displayed: !node.collapsed}"> <li ng-repeat="node in node.children" ui-tree-node ng-class="{\'ml-25\' : !node.children.length}" class="{{::node.id}}" collapsed="node.collapsed" ng-include="\'nodesRenderer.tpl.html\'" ></li> </ol></script><div class="" ui-tree="" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="$ctrl.trainingsNodesData"><li ng-repeat="node in $ctrl.trainingsNodesData" collapsed="node.collapsed" ui-tree-node="" ng-include="\'nodesRenderer.tpl.html\'"></li></ol></div></div></div><ba-panel-footer ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.trainings.manage\')" class="clearfix administration__personnel__trainings__overview__treeview__footer-bar"><div class="pull-right"><button class="btn btn-primary btn-sm btn-with-icon" type="button" ng-click="$ctrl.addNewNode($ctrl.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_TEMPLATE)" ng-disabled="!$ctrl.showAddTrainingTemplateBtn()" data-cy="org-admin-add-training-template-groups"><i class="ion-plus"></i> <span class="hidden-xs" translate="modules.administration.adminTrainings.trainingsTemplate"></span></button> <button class="btn btn-primary btn-sm btn-with-icon" type="button" ng-click="$ctrl.addNewNode($ctrl.ADMIN_PERSONNEL_TRAININGS_NODE_TYPE_GROUP)" ng-disabled="!$ctrl.showAddTrainingTemplateGroupBtn() || !$ctrl.selectedNode.id" data-cy="org-admin-add-training-template-groups"><i class="ion-plus"></i> <span class="hidden-xs" translate="modules.administration.adminTrainings.trainingsGroup"></span></button></div></ba-panel-footer></div></div><div class="col-lg-6"><div ba-panel="" ba-panel-title="\'Details\'" data-cy="org-admin-training-template-group-details-panel" ng-if="$ctrl.showTrainingTemplateGroupsEdit()"><div class="row"><div class="col-sm-12"><form name="$ctrl.trainingTemplateGroupForm" novalidate="" ng-submit="$ctrl.saveTrainingTemplateGroup($ctrl.selectedNode, $ctrl.trainingTemplateGroupForm)"><fieldset ng-disabled="!$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.trainings.manage\')"><div class="form-group" ng-class="{ \'has-error\': $ctrl.isFieldInvalid($ctrl.trainingTemplateGroupForm, $ctrl.trainingTemplateGroupForm.trainingTemplateGroupName) }"><label for="trainingTemplateGroupName" translate="generalTerms.createName"></label> <input type="text" class="form-control" autofocus="" name="trainingTemplateGroupName" maxlength="1000" ng-model="$ctrl.selectedNode.label" ng-model-options="{ debounce: 200, allowInvalid: true }" ui-validate-async="{ conflictingName: \'$ctrl.checkName($ctrl.selectedNode)\' }" ng-required="true" placeholder="{{ \'generalTerms.createName\' |translate}}" data-cy="org-admin-add-training-template-group-name"> <label ng-messages="($ctrl.trainingTemplateGroupForm.trainingTemplateGroupName.$touched || $ctrl.trainingTemplateGroupForm.$submitted) && $ctrl.trainingTemplateGroupForm.trainingTemplateGroupName.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.administration.adminTrainings.groupNameMusstHave"></span> <span ng-message="conflictingName" translate="modules.administration.adminTrainings.itExistAThingWithThisName"></span> <span ng-message="maxlength" translate="modules.administration.adminTrainings.groupNameToLong"></span></label></div></fieldset><div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.trainings.manage\')" class="align-right"><button class="btn btn-default btn-with-icon no-animation" ng-show="$ctrl.deletableNewNode()" ng-click="$ctrl.removeUnsavedNode()" type="button"><i class="ion-ios-trash"></i> <span class="hidden-xs" translate="generalTerms.discard"></span></button> <button class="btn btn-default btn-with-icon no-animation" ng-show="!$ctrl.isNewNode($ctrl.selectedNode) && $ctrl.trainingTemplateGroupForm.$dirty" ng-click="$ctrl.rollbackTrainingTemplateGroupChanges($ctrl.selectedNode, $ctrl.trainingTemplateGroupForm)" type="button"><i class="ion-android-close"></i> <span class="hidden-xs" translate="generalTerms.cancel"></span></button> <button type="button" class="btn btn-primary btn-with-icon no-animation" ng-show="!$ctrl.deletableNewNode()" ng-click="$ctrl.removeTrainingTemplateGroup($ctrl.selectedNode, $ctrl.trainingTemplateGroupForm)"><i class="ion-ios-trash"></i> <span class="hidden-xs" translate="generalTerms.delete"></span></button> <button class="btn btn-primary btn-with-icon" type="submit"><i class="ion-checkmark"></i> <span class="hidden-xs" ng-show="$ctrl.isNewNode($ctrl.selectedNode)" translate="generalTerms.create"></span> <span class="hidden-xs" ng-show="!$ctrl.isNewNode($ctrl.selectedNode)" translate="generalTerms.save"></span></button></div></form></div></div></div><div ba-panel="" ba-panel-title="\'modules.administration.adminTrainings.details\'" data-cy="org-admin-training-template-details-panel" ng-if="$ctrl.showTrainingTemplateEdit()"><div class="row"><div class="col-sm-12"><form name="$ctrl.trainingTemplateForm" class="row" novalidate="" ng-submit="$ctrl.saveTrainingTemplate($ctrl.selectedNode, $ctrl.trainingTemplateForm)"><fieldset ng-disabled="!$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.trainings.manage\')"><div class="form-group col-xs-12 col-sm-12" ng-class="{ \'has-error\': $ctrl.isFieldInvalid($ctrl.trainingTemplateForm, $ctrl.trainingTemplateForm.trainingTemplateName) }"><label for="trainingTemplateName" translate="generalTerms.createName"></label> <input type="text" class="form-control" name="trainingTemplateName" autofocus="" maxlength="1000" ng-model="$ctrl.selectedNode.label" ng-model-options="{ debounce: 200, allowInvalid: true }" ui-validate-async="{ conflictingName: \'$ctrl.checkName($ctrl.selectedNode)\' }" ng-required="true" placeholder="{{ \'generalTerms.createName\' |translate }}" data-cy="org-admin-add-training-template-name"> <label ng-messages="($ctrl.trainingTemplateForm.trainingTemplateName.$touched || $ctrl.trainingTemplateForm.$submitted) && $ctrl.trainingTemplateForm.trainingTemplateName.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.administration.adminTrainings.templateNameMusstHave"></span> <span ng-message="conflictingName" translate="modules.administration.adminTrainings.itExistAnotherGroup"></span> <span ng-message="maxlength" translate="modules.administration.adminTrainings.templateNameToLong"></span></label></div><div class="form-group col-xs-12"><label for="trainingTemplateCategory" translate="generalTerms.category"><arno-ba-help-tooltip text="{{\'modules.administration.adminTrainings.TRAINING_TEMPLATE_HELP_CATEGORY_FIELD\' | translate}}"></arno-ba-help-tooltip></label><tag-picker default-label="\'modules.administration.adminTrainings.noCategory\' |translate" tags="$ctrl.categories" selected-tags="$ctrl.selectedNode.data.vm.BaseCategories" data-cy="org-admin-add-training-template-category"></tag-picker></div><div class="form-group col-xs-12 col-sm-8"><label for="validityInputDay" class="control-label" translate="modules.administration.adminTrainings.basicValidaty"><arno-ba-help-tooltip text="{{\'modules.administration.adminTrainings.TRAINING_TEMPLATE_HELP_VALIDITY_FIELDS\' | translate}}"></arno-ba-help-tooltip></label><div class="administration__personnel__trainings__overview__training-template-form__validity-input"><div><input type="number" class="form-control" name="validityInputDay" min="0" step="1" max="2147483647" ng-model="$ctrl.selectedNode.data.validityHelper.days"> <span translate="generalTerms.days" translate-values="{validityDays: $ctrl.selectedNode.data.validityHelper.days}"></span></div><div class="mt-8"><input type="number" class="form-control" name="validityInputMonth" min="0" step="1" max="2147483647" ng-model="$ctrl.selectedNode.data.validityHelper.months"> <span translate="generalTerms.months" translate-values="{validityMonths: $ctrl.selectedNode.data.validityHelper.months}"></span></div><div class="mt-8"><input type="number" class="form-control" name="validityInputYear" min="0" step="1" max="2147483647" ng-model="$ctrl.selectedNode.data.validityHelper.years"> <span translate="generalTerms.years" translate-values="{validityYears: $ctrl.selectedNode.data.validityHelper.years}"></span></div></div><label ng-messages="($ctrl.trainingTemplateForm.$submitted || $ctrl.validityInputDay.$touched)&& $ctrl.trainingTemplateForm.validityInputDay.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="min" translate="modules.administration.adminTrainings.dayNumberLargeOrSmall"></span> <span ng-message="max" translate="modules.administration.adminTrainings.dayExceed"></span></label> <label ng-messages="($ctrl.trainingTemplateForm.$submitted || $ctrl.trainingTemplateForm.validityInputMonth.$touched) && $ctrl.trainingTemplateForm.validityInputMonth.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="min" translate="modules.administration.adminTrainings.monthNumberLargeOrSmall"></span> <span ng-message="max" translate="modules.administration.adminTrainings.monthExceed"></span></label> <label ng-messages="($ctrl.trainingTemplateForm.$submitted || $ctrl.trainingTemplateForm.validityInputYear.$touched) && $ctrl.trainingTemplateForm.validityInputYear.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="min" translate="modules.administration.adminTrainings.yearNumberLargeOrSmall"></span> <span ng-message="max" translate="modules.administration.adminTrainings.yearExceed"></span></label></div><div class="form-group col-xs-12 col-sm-4"><label for="trainingTemplateCountableHours" class="control-label" translate="modules.administration.adminTrainings.trainingHours"><arno-ba-help-tooltip text="{{\'modules.administration.adminTrainings.TRAINING_TEMPLATE_HELP_COUNTABLE_HOURS\' | translate}}"></arno-ba-help-tooltip></label> <input type="number" class="form-control" name="trainingTemplateCountableHours" ng-model="$ctrl.selectedNode.data.vm.CountableHours" min="0" max="2147483647" data-cy="org-admin-add-training-template-countable-hours"> <label ng-messages="($ctrl.trainingTemplateForm.trainingTemplateCountableHours.$touched || $ctrl.trainingTemplateForm.$submitted) && $ctrl.trainingTemplateForm.trainingTemplateCountableHours.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="min" translate="modules.administration.adminTrainings.minNumber"></span> <span ng-message="max" translate="modules.administration.adminTrainings.maxNumber"></span></label></div><div class="form-group col-xs-12"><label class="control-label" translate="modules.administration.adminTrainings.assignedQualifications"><arno-ba-help-tooltip text="{{\'modules.administration.adminTrainings.TRAINING_TEMPLATE_HELP_QUALIFICATION_FIELD\' | translate}}"></arno-ba-help-tooltip></label><qualification-list qualification-delete="true" always-show="true" qualification-list="$ctrl.selectedNode.data.vm.Qualifications" qualification-add="$ctrl.qualificationsHierarchy" qualification-change-model="$ctrl.selectedNode.data.changedQualifications" qualification-states="[{ title: \'Qualifikationen\', intext: \'Qualifikationen\', showSectionHeader: false }]" qualification-change-property="id" ng-required="false"></qualification-list></div><div class="form-group col-xs-12"><label for="trainingTemplateNotes" translate="modules.administration.adminTrainings.remark"></label> <textarea type="text" class="form-control" name="trainingTemplateNotes" ng-model="$ctrl.selectedNode.data.vm.Notes" maxlength="4000" placeholder="{{ \'modules.administration.adminTrainings.remark\' |translate}}" data-cy="org-admin-add-training-template-notes"></textarea> <label ng-messages="($ctrl.trainingTemplateForm.trainingTemplateNotes.$touched || $ctrl.trainingTemplateForm.$submitted) && $ctrl.trainingTemplateForm.trainingTemplateNotes.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="maxlength" translate="modules.administration.adminTrainings.theRemarkIsToLong"></span></label></div></fieldset><div ng-if="$ctrl.isPermittedInCurrentOrg(\'arno.administration.personnel.trainings.manage\')" class="align-right"><button class="btn btn-default btn-with-icon" ng-show="$ctrl.deletableNewNode()" ng-click="$ctrl.removeUnsavedNode()" type="button"><i class="ion-ios-trash"></i> <span class="hidden-xs" translate="generalTerms.discard"></span></button> <button class="btn btn-default btn-with-icon" ng-show="!$ctrl.isNewNode($ctrl.selectedNode) && $ctrl.trainingTemplateForm.$dirty" ng-click="$ctrl.rollbackTrainingTemplateChanges($ctrl.selectedNode, $ctrl.trainingTemplateForm)" type="button"><i class="ion-android-close"></i> <span class="hidden-xs" translate="generalTerms.cancel"></span></button> <button type="button" class="btn btn-primary btn-with-icon" ng-show="!$ctrl.deletableNewNode()" ng-click="$ctrl.removeTrainingTemplate($ctrl.selectedNode)"><i class="ion-ios-trash"></i> <span class="hidden-xs" translate="generalTerms.delete"></span></button> <button class="btn btn-primary btn-with-icon" type="submit"><i class="ion-checkmark"></i> <span class="hidden-xs" ng-show="$ctrl.isNewNode($ctrl.selectedNode)" translate="generalTerms.create"></span> <span class="hidden-xs" ng-show="!$ctrl.isNewNode($ctrl.selectedNode)" translate="generalTerms.save"></span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/administration/personnel/withdrawal/modals/deleteReason.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.adminWithdrawl.deleteExitReason"></h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.adminWithdrawl.withdrawalReasonDeletionText" translate-values="{deletionElement: ::deletionElement}">{{ \'modules.administration.adminWithdrawl.withdrawalReasonDeletionText\' | translate:{DeletionElement: deletionElement} }}</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()" translate="generalTerms.delete"><i class="ion-ios-trash"></i></button></div></div>');
$templateCache.put('app/pages/administration/personnel/withdrawal/modals/handleReason.html','<div class="modal-content reason-add-modal"><form ng-submit="$ctrl.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.administration.adminWithdrawl.editAndAddedReason" translate-values="{reasonID: $ctrl.reasonId}">Austrittsgrund {{ $ctrl.reasonId ? \'bearbeiten\' : \'hinzuf\xFCgen\'}}</h4></div><div class="modal-body"><div><div class="row"><div class="form-group clearfix col-sm-12"><label for="reason" class="control-label required-label" translate="modules.administration.adminWithdrawl.nameOfTheReasonForLeaving"></label> <input type="text" tabindex="1" class="form-control" name="reason" id="reason" ng-model="$ctrl.reasonName"></div></div></div></div><div class="modal-footer"><button type="submit" tabindex="3" class="btn btn-with-icon btn-primary" ng-click="$ctrl.handleReason()"><i class="ion-checkmark-round"></i> {{ $ctrl.reasonId ? \'generalTerms.edit\' : \'generalTerms.add\' | translate}}</button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/general/modals/addSystemModal.html','<div class="modal-content personnel-system-add-modal"><form id="orgDataForm" ng-submit="$addSystemModalCtrl.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.title">Externes Personalsystem konfigurieren</h4></div><div class="modal-body"><div class="form-group"><label for="Name" class="required-label control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.nameFieldLabel">Name</label> <input type="text" class="form-control" name="Name" id="Name" ng-model="$addSystemModalCtrl.system.Name"></div><div class="form-group"><label for="EMail" class="control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.emailFieldLabel">E-Mail</label> <input type="text" class="form-control" name="EMail" id="EMail" ng-model="$addSystemModalCtrl.system.EMail"></div><div class="form-group"><label for="infoText" class="control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.additionalInfoFieldLabel">Zus\xE4tzliche Informationen</label> <textarea type="text" maxlength="254" rows="4" cols="50" class="form-control" id="infoText" ng-model="$addSystemModalCtrl.system.InfoText"></textarea></div><div class="form-group"><label class="required-label control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.requiredFieldsNotificationLabel">Pflichtfelder zur Benachrichtigung</label><tag-picker tags="$addSystemModalCtrl.tagFieldList" selected-tags="$addSystemModalCtrl.system.RequiredFieldIdentifier"></tag-picker></div><div class="form-group"><label class="control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.addModal.relevantFieldsNotificationLabel">Benachrichtigungsrelevante Felder</label><tag-picker tags="$addSystemModalCtrl.tagFieldList" selected-tags="$addSystemModalCtrl.system.FieldIdentifier"></tag-picker></div><div class="form-group"><label class="control-label" translate="modules.administration.personnel.general.externalPersonnelSystems.ignoreInitialValues"></label><div><ba-switcher switcher-style="primary" switcher-value="$addSystemModalCtrl.system.IgnoreInitialValues" switcher-keys="$addSystemModalCtrl.switcherKeys" switcher-force-default="true"></ba-switcher></div></div></div><div class="modal-footer"><button type="button" class="btn btn-with-icon btn-default" ng-click="$addSystemModalCtrl.close()"><i class="ion-close-round"></i> <span translate="generalTerms.cancel">Abbrechen</span></button> <button type="button" class="btn btn-with-icon btn-primary" ng-click="$addSystemModalCtrl.updateSystem()"><i class="ion-checkmark-round"></i> <span translate="generalTerms.save">Speichern</span></button></div></form></div>');
$templateCache.put('app/pages/administration/personnel/general/modals/changeRetrospectively.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.personnel.general.deletionPeriods.changeModal.title">\xC4nderungen r\xFCckwirkend auf bestehende Vorg\xE4nge anwenden?</h4></div><div class="modal-body"><div class="section-block red-text"><p translate="modules.administration.personnel.general.deletionPeriods.changeModal.applyMsg">Willst du, dass die neue Frist auf bereits in der L\xF6schung befindliche Mitglieder angewendet wird?</p></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$close()"><i class="ion-close-round"></i> <span translate="generalTerms.cancel">Abbrechen</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$close(false)"><i class="ion-checkmark-round"></i> <span translate="generalTerms.no">Nein</span></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$close(true)"><i class="ion-checkmark-round"></i> <span translate="generalTerms.yes">Ja</span></button></div></div>');
$templateCache.put('app/pages/administration/personnel/general/modals/removeSystem.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.administration.personnel.general.externalPersonnelSystems.removalModal.title">System entfernen</h4></div><div class="modal-body text-center"><div class="section-block red-text"><p translate="modules.administration.personnel.general.externalPersonnelSystems.removalModal.deleteMsg">Willst du dieses externe Personalsystem wirklich entfernen?</p><p><b translate="generalTerms.caution">Achtung</b>: <span translate="modules.administration.personnel.general.externalPersonnelSystems.removalModal.deleteHint">Diese Aktion kann nicht r\xFCckg\xE4ngig gemacht werden.</span></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel">Abbrechen</button> <button type="button" class="btn btn-with-icon btn-danger" ng-click="$close()"><i class="ion-ios-trash"></i>{{(\'generalTerms.remove\' | translate)}}</button></div></div>');
$templateCache.put('app/pages/personnel/dossier/administration/blockage/blockHintModal.html','<div class="modal-content personnel-leave-modal"><form id="orgDataForm" ng-submit="$blockCtrl.modalInstance.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" ng-if="$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.titleDiv"></h4><h4 class="modal-title" ng-if="!$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.titleOrg"></h4></div><div class="modal-body"><p translate="modules.personnel.dossier.administration.blockModal.description"><span ng-if="$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.division"></span> <span ng-if="!$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.organization"><span ng-if="$blockCtrl.divList.length>0" translate="modules.personnel.dossier.administration.blockModal.divList"></span></span></p><ul ng-if="$blockCtrl.divList.length>0"><li ng-repeat="div in $blockCtrl.divList">{{ div }}</li></ul><div style="margin-top:10px;" class="alert bg-warning"><h4>{{ (\'generalTerms.hint\'| translate) }}:</h4><span translate="modules.personnel.dossier.administration.blockModal.hintText"></span></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$blockCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$blockCtrl.nextStep()" translate="generalTerms.next"><i class="fa fa-arrow-right"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/administration/blockage/blockModal.html','<div class="modal-content personnel-leave-modal"><form id="orgDataForm" ng-submit="$blockCtrl.modalInstance.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" ng-if="$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.titleDiv"></h4><h4 class="modal-title" ng-if="!$blockCtrl.isDiv" translate="modules.personnel.dossier.administration.blockModal.titleOrg"></h4></div><div class="modal-body"><div style="margin-top:10px;"><label class="control-label required-label" for="blockReason" translate="modules.personnel.dossier.administration.blockModal.blockReason"></label><select id="blockReason" class="form-control" ng-model="$blockCtrl.selectedReason"><option ng-repeat="reason in $blockCtrl.reasons" value="{{reason}}">{{reason.Reason}}</option></select></div><div style="margin-top:10px;"><label class="control-label" for="blockComment" translate="modules.personnel.dossier.administration.blockModal.blockComment"></label> <input id="blockComment" class="form-control" type="text" ng-model="$blockCtrl.reasonComment"></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$blockCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="!$blockCtrl.selectedReason" ng-click="$blockCtrl.finishSelection()" translate="generalTerms.resume"><i class="ion-checkmark-round"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/administration/blockage/deBlockMember.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.dossier.administration.blockModal.unblockTitle"></h4></div><div class="modal-body"><div class="section-block red-text"><p translate="modules.personnel.dossier.administration.blockModal.unblockDesc"></p></div><div class="section-bloc"><label class="control-label" for="deBlockComment" translate="modules.personnel.dossier.administration.blockModal.unblockComment"></label> <input id="deBlockComment" class="form-control" type="text" ng-model="$deBlockCtrl.reasonComment"></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$deBlockCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$deBlockCtrl.finishSelection()" translate="generalTerms.resume"><i class="ion-checkmark-round"></i></button></div></div>');
$templateCache.put('app/pages/personnel/dossier/administration/withdrawal/activateMember.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><h4 class="modal-title" translate="modules.personnel.dossier.administration.cancelDeleteRequest.title"></h4></div><div class="modal-body"><div class="section-block red-text"><p translate="modules.personnel.dossier.administration.cancelDeleteRequest.description"></p></div><div class="section-bloc"><label class="control-label" for="withdrawalComment" translate="modules.personnel.dossier.administration.cancelDeleteRequest.comment"></label> <input id="withdrawalComment" class="form-control" type="text" ng-model="$activateCtrl.reasonComment"></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$activateCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$activateCtrl.finishSelection()" translate="generalTerms.resume"><i class="ion-checkmark-round"></i></button></div></div>');
$templateCache.put('app/pages/personnel/dossier/administration/withdrawal/askForOrgDelete.html','<div class="modal-content personnel-leave-modal"><form id="orgDataForm" ng-submit="$close()" novalidate=""><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.administration.withdrawalModal.orgDeleteTitle"></h4></div><div class="modal-body" translate="modules.personnel.dossier.administration.withdrawalModal.orgDeleteDesc"></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$close(1)" translate="modules.personnel.dossier.administration.withdrawalModal.leaveDiv"><i class="ion-ios-people-outline"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$close(0)" translate="modules.personnel.dossier.administration.withdrawalModal.leaveOrg"><i class="ion-ios-people"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/administration/withdrawal/leaveHintModal.html','<div class="modal-content personnel-leave-modal"><form id="orgDataForm" ng-submit="$leaveCtrl.modalInstance.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" ng-if="$leaveCtrl.isDiv" translate="modules.personnel.dossier.administration.withdrawalModal.title" translate-values="{ isDiv: $leaveCtrl.isDiv }"></h4></div><div class="modal-body"><p translate="modules.personnel.dossier.administration.withdrawalModal.description" translate-values="{ withdrawalDays: $leaveCtrl.periods.withdrawalDays, isDiv: $leaveCtrl.isDiv, divList: $leaveCtrl.divList, isOwn: $leaveCtrl.isOwn }"></p><ul ng-if="$leaveCtrl.divList.length>0 && !$leaveCtrl.isDiv"><li ng-repeat="div in $leaveCtrl.divList">{{ div }}</li></ul><div style="margin-top:10px;" class="alert bg-warning"><h4 translate="modules.personnel.dossier.administration.withdrawalModal.hint"></h4><span ng-if="!$leaveCtrl.isDiv && $leaveCtrl.periods.deletionMonths > 1" translate="modules.personnel.dossier.administration.withdrawalModal.hintTextOrg" translate-values="{ deletionMonths: $leaveCtrl.periods.deletionMonths }"></span> <span ng-if="$leaveCtrl.isDiv" translate="modules.personnel.dossier.administration.withdrawalModal.hintTextDiv"></span></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$leaveCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-click="$leaveCtrl.nextStep()" translate="generalTerms.next"><i class="fa fa-arrow-right"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/administration/withdrawal/leaveModal.html','<div class="modal-content personnel-leave-modal"><form id="orgDataForm" ng-submit="$leaveCtrl.modalInstance.close()" novalidate=""><div class="modal-header"><h4 class="modal-title" ng-if="$leaveCtrl.isDiv" translate="modules.personnel.dossier.administration.withdrawalModal.title" translate-values="{ isDiv: $leaveCtrl.isDiv }"></h4></div><div class="modal-body"><div style="margin-top:10px;"><label ng-class="{\'required-label\': !$leaveCtrl.isOwn}" class="control-label" for="withdrawalReason" translate="modules.personnel.dossier.administration.withdrawalModal.withdrawalReason"></label><select id="withdrawalReason" class="form-control" ng-model="$leaveCtrl.selectedReason"><option ng-repeat="reason in $leaveCtrl.reasons" value="{{reason}}">{{reason.Reason}}</option></select></div><div style="margin-top:10px;"><label class="control-label" for="withdrawalComment" translate="modules.personnel.dossier.administration.withdrawalModal.withdrawalComment"></label> <input id="withdrawalComment" class="form-control" type="text" ng-model="$leaveCtrl.reasonComment"></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-with-icon" ng-click="$leaveCtrl.modalInstance.close()" translate="generalTerms.cancel"><i class="ion-close-round"></i></button> <button type="submit" class="btn btn-primary btn-with-icon" ng-disabled="!$leaveCtrl.selectedReason && !$leaveCtrl.isOwn" ng-click="$leaveCtrl.finishSelection()" translate="generalTerms.resume"><i class="ion-checkmark-round"></i></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/components/emergencyContacts.comp.html','<div class="row clearfix"><div class="col-xs-12"><div class="col-xs-12"><button ng-if="!$baseDataEmergencyContacts.viewOnly" type="button" class="btn btn-primary btn-with-icon mr-10" ng-click="$baseDataEmergencyContacts.addNewEmergencyContact()"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.title"></span></button></div><div class="col-xs-12 mt-15"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.firstName"></th><th translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.lastName"></th><th translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.address"></th><th translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.contact"></th><th translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.relationship"></th><th ng-if="$baseDataEmergencyContacts.NoEmergencyContactTerms"></th><th class="pull-right pr-20" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.action"></th></tr></thead><tbody ng-if="$baseDataEmergencyContacts.emergencyContacts.length"><tr ng-repeat="contact in $baseDataEmergencyContacts.emergencyContacts"><td><span ng-bind="contact.FirstName"></span></td><td><span ng-bind="contact.LastName"></span></td><td><div><span ng-bind="contact.address.ZIP"></span> <span ng-bind="contact.address.City"></span></div><div><span ng-bind="contact.address.Street"></span> <span ng-bind="contact.address.HouseNumber"></span></div><div ng-if="contact.address.AddressAffix">(<span ng-bind="contact.address.AddressAffix"></span>)</div></td><td><table class="w-100"><tr ng-if="contact.PhoneNumber"><td class="pr-20 force-minimal" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.mobilePhone"></td><td ng-bind="contact.PhoneNumber"></td><td class="align-right"><a href="{{ contact.PhoneNumber | asTel }}" ng-if="contact.PhoneNumber" class="btn btn-xs btn-default pl-3"><i class="fa fa-phone pl-2"></i></a></td></tr><tr ng-if="contact.MobileNumber"><td class="pr-20 force-minimal" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.phone"></td><td ng-bind="contact.MobileNumber"></td><td class="align-right"><a href="{{ contact.MobileNumber | asTel }}" ng-if="contact.MobileNumber" class="btn btn-xs btn-default pl-3"><i class="fa fa-phone pl-2"></i></a></td></tr><tr ng-if="contact.Email"><td class="pr-20 force-minimal" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.email"></td><td ng-bind="contact.Email"></td><td class="align-right"><a href="{{ \'mailto:\' + contact.Email }}" ng-if="contact.Email" class="btn btn-xs btn-default pl-3"><i class="fa fa-envelope-o"></i></a></td></tr></table></td><td><div><span ng-bind="contact.Function"></span></div></td><td ng-if="$baseDataEmergencyContacts.NoEmergencyContactTerms"><span class="no-emergency-contact-term" ng-if="contact.PrivacyTermsDeliveredDateTime == null" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.NoTermsDelivered"></span></td><td><div class="pull-right nowrap"><button ng-if="!$baseDataEmergencyContacts.viewOnly" type="button" ng-click="$baseDataEmergencyContacts.editEmergencyContact(contact, $event)" class="btn btn-default btn-with-icon btn-xs" title="Notfallkontakt bearbeiten"><i class="fa fa-pencil"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.edit"></span></button> <button type="button" ng-click="$baseDataEmergencyContacts.removeEmergencyContact(contact)" class="btn btn-danger btn-with-icon btn-xs" title="{{(\'modules.personnel.dossier.baseData.emergencyContactTableHeader.removeButton\' | translate )}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.remove"></span></button></div></td></tr></tbody><tbody ng-if="!$baseDataEmergencyContacts.emergencyContacts.length"><tr class="mt-20 mb-20"><td class="text-center" colspan="5" translate="modules.personnel.dossier.baseData.emergencyContactTableHeader.empty"></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/components/languageSelection.comp.html','<div><div class="row"><div class="col-xs-12"><label for="inputMemberLanguageSkills" class="control-label" translate="modules.personnel.dossier.baseData.languageTableHeader.title"><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.languageTableHeader.niveauTooltip\' | translate )}}"></arno-ba-help-tooltip></label><ui-select name="selectMemberLanguage" ng-model="$baseDataLanguages.selectedMemberLanguage" tagging="$baseDataLanguages.tagTransform" tagging-label="false" class="btn-group bootstrap-select form-control" ng-disabled="$baseDataLanguages.viewOnly" on-select="$baseDataLanguages.addMemberLanguage()"><ui-select-match placeholder="{{(\'modules.personnel.dossier.baseData.languageTableHeader.niveauTooltip\' | translate )}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseDataLanguages.getMemberLanguages() | filter: $select.search"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div></div><div class="row mt-20"><div class="col-xs-12"><div ng-if="$baseDataLanguages.languageSkills.length" class="table-repsonsive"><table class="table table-condensed table-hover"><col width="20%"><col width="30%"><col width="50%"><thead><tr><th translate="modules.personnel.dossier.baseData.languageTableHeader.language"></th><th translate="modules.personnel.dossier.baseData.languageTableHeader.niveau"><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.baseData.languageTableHeader.niveauTooltip\' | translate )}}"></arno-ba-help-tooltip></th><th translate="modules.personnel.dossier.baseData.languageTableHeader.notes"></th><th translate="modules.personnel.dossier.baseData.languageTableHeader.action"></th></tr></thead><tbody><tr ng-repeat="language in $baseDataLanguages.languageSkills"><td><span ng-bind="language.vm.Name"></span></td><td><div><ui-select ng-model="language.vm.Level" tagging="$baseDataLanguages.tagTransform" tagging-label="false" class="btn-group bootstrap-select form-control" ng-disabled="$baseDataLanguages.viewOnly"><ui-select-match placeholder="Niveau">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $baseDataLanguages.MEMBER_LANGUAGES_LEVEL"><span ng-bind="item.Name"></span></ui-select-choices></ui-select></div></td><td><input data-cy="personnel-dossier-masterdata-languagenotes" type="text" class="form-control" name="inputMemberLanguageNotes" placeholder="" ng-model="language.Notes" ng-disabled="$baseDataLanguages.viewOnly"></td><td class="align-right"><button type="button" ng-click="$baseDataLanguages.removeMemberLanguage(language, $event)" class="btn btn-danger btn-with-icon btn-xs" title="{{(\'modules.personnel.dossier.baseData.languageTableHeader.removeTitle\' | translate )}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.baseData.languageTableHeader.remove"></span></button></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/emergencyContactModal/emergencyContactModal.tpl.html','<form class="modal-content" name="$emergencyContactCtrl.emergencyContactForm" novalidate="" angular-validator=""><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.baseData.emergencyContactModal.title"><span ng-if="!$emergencyContactCtrl.emergencyContact.id" translate="modules.personnel.dossier.baseData.emergencyContactModal.create"></span> <span ng-if="$emergencyContactCtrl.emergencyContact.id" translate="modules.personnel.dossier.baseData.emergencyContactModal.edit"></span></h4></div><div class="modal-body"><div class="row"><div class="form-group col-xs-12"><p translate="modules.personnel.dossier.baseData.emergencyContactModal.noteContent"><strong translate="modules.personnel.dossier.baseData.emergencyContactModal.noteCaption"></strong></p><p ng-if="$emergencyContactCtrl.emergencyContactForm.$submitted && !$emergencyContactCtrl.isAtLEastOneFieldFilled()" class="control-label has-error validationMessage" translate="modules.personnel.dossier.baseData.emergencyContactModal.dataMissingMessage"></p><p ng-if="$emergencyContactCtrl.emergencyContactForm.$submitted && $emergencyContactCtrl.emergencyContactForm.$invalid" class="control-label has-error validationMessage" translate="modules.personnel.dossier.baseData.emergencyContactModal.dataInvalidMessage"></p></div></div><div class="row"><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $emergencyContactCtrl.hasError($emergencyContactCtrl.emergencyContactForm , \'inputMemberEmergencyFirstName\', [\'required\'])}"><label for="inputMemberEmergencyFirstName" class="control-label required-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.firstName"></label> <input data-cy="personnel-dossier-masterdata-emergencyfirstname" type="text" class="form-control" name="inputMemberEmergencyFirstName" placeholder="" ng-model="$emergencyContactCtrl.emergencyContact.FirstName" ng-disabled="$emergencyContactCtrl.viewOnly" required-message="\'modules.personnel.dossier.baseData.emergencyContactModal.firstNameMissing\' | translate" required=""></div><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $emergencyContactCtrl.hasError($emergencyContactCtrl.emergencyContactForm , \'inputMemberEmergencyLastName\', [\'required\'])}"><label for="inputMemberEmergencyLastName" class="control-label required-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.lastName"></label> <input data-cy="personnel-dossier-masterdata-emergencylastname" type="text" class="form-control" name="inputMemberEmergencyLastName" placeholder="" ng-model="$emergencyContactCtrl.emergencyContact.LastName" ng-disabled="$emergencyContactCtrl.viewOnly" required-message="\'modules.personnel.dossier.baseData.emergencyContactModal.lastNameMissing\' | translate" required=""></div><arno-ba-address class="col-xs-12" address="$emergencyContactCtrl.emergencyContact.address" form-ref="$emergencyContactCtrl.emergencyContactForm" ui-config="$emergencyContactCtrl.addressCompUiConfig"></arno-ba-address><div class="row clearfix"><div class="col-xs-12"><div class="form-group col-xs-12 col-sm-6"><label for="inputMemberEmergencyMobileNumber" class="control-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.mobilePhone"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><input data-cy="personnel-dossier-masterdata-emergencymobilenumber" type="text" class="form-control" name="inputMemberEmergencyMobileNumber" placeholder="" validator="$emergencyContactCtrl.checkPhoneNumber($emergencyContactCtrl.emergencyContact.MobileNumber)" invalid-message="\'modules.personnel.dossier.baseData.emergencyContactModal.phoneInvalidMessage\' | translate" ng-required="false" ng-model="$emergencyContactCtrl.emergencyContact.MobileNumber" ng-disabled="$emergencyContactCtrl.viewOnly"></div><div class="form-group col-xs-12 col-sm-6"><label for="inputMemberEmergencyPhoneNumber" class="control-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.phone"></label><arno-ba-help-tooltip text="{{\'modules.personnel.dossier.baseData.PHONENUMBER_HELP_FORMAT\' | translate}}"></arno-ba-help-tooltip><input data-cy="personnel-dossier-masterdata-emergencyphonenumber" type="text" class="form-control" name="inputMemberEmergencyPhoneNumber" placeholder="" validator="$emergencyContactCtrl.checkPhoneNumber($emergencyContactCtrl.emergencyContact.PhoneNumber)" invalid-message="\'modules.personnel.dossier.baseData.emergencyContactModal.phoneInvalidMessage\' | translate" ng-required="false" ng-model="$emergencyContactCtrl.emergencyContact.PhoneNumber" ng-disabled="$emergencyContactCtrl.viewOnly"></div></div></div><div class="form-group col-xs-12" ng-class="{\'has-error\': $emergencyContactCtrl.hasError($emergencyContactCtrl.emergencyContactForm , \'inputMemberEmergencyEmail\')}"><label for="inputMemberEmergencyEmail" class="control-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.email"></label> <input data-cy="personnel-dossier-masterdata-emergencyemail" type="email" class="form-control" name="inputMemberEmergencyEmail" placeholder="" ng-model="$emergencyContactCtrl.emergencyContact.Email" invalid-message="\'modules.personnel.dossier.baseData.emergencyContactModal.emailInvalidMessage\' | translate" ng-disabled="$emergencyContactCtrl.viewOnly"></div><div class="form-group col-xs-12 col-sm-6" ng-class="{\'has-error\': $emergencyContactCtrl.hasError($emergencyContactCtrl.emergencyContactForm , \'inputMemberEmergencyFunction\', [\'required\'])}"><label class="control-label required-label" translate="modules.personnel.dossier.baseData.emergencyContactModal.relationship"></label> <input data-cy="personnel-dossier-masterdata-emergencyfunction" type="text" class="form-control" name="inputMemberEmergencyFunction" placeholder="" ng-model="$emergencyContactCtrl.emergencyContact.Function" ng-disabled="$emergencyContactCtrl.viewOnly" required-message="\'modules.personnel.dossier.baseData.emergencyContactModal.relationshipMissingMessage\' | translate" required=""></div><div class="form-group col-md-12"><div><div class="form-group row clearfix mb-10"><div class="col-md-12"><div><table class="emergency-contact-data-table"><tr><td class="pt-5"><contact-privacy contact="$emergencyContactCtrl.emergencyContact" form-reference="$emergencyContactCtrl.emergencyContactForm"></contact-privacy></td></tr></table></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.personnel.dossier.baseData.emergencyContactModal.cancel"></button> <button type="submit" class="btn btn-primary" ng-click="$emergencyContactCtrl.saveEmergencyContact($emergencyContactCtrl.emergencyContactForm)"><span ng-if="!$emergencyContactCtrl.emergencyContact.id" translate="modules.personnel.dossier.baseData.emergencyContactModal.add"></span> <span ng-if="$emergencyContactCtrl.emergencyContact.id" translate="modules.personnel.dossier.baseData.emergencyContactModal.apply"></span></button></div></form>');
$templateCache.put('app/pages/personnel/dossier/baseData/passwordModal/changePassword.html','<div class="modal-content dossierChangePassword"><form id="passwordChangeForm" class="password-change-form" name="$pwdModal.passwordChangeForm" novalidate="" angular-validator="" angular-validator-submit="$pwdModal.submit()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.baseData.editPasswordModal.title"></h4></div><div class="modal-body"><div class="form-group"><label for="actPwd" translate="modules.personnel.dossier.baseData.editPasswordModal.currentPassword"></label><div class="input-group"><input data-cy="personnel-dossier-basedata-passwordmodal-actpwd" type="{{ $pwdModal.actPwdInputType }}" class="form-control" id="actPwd" name="actPwd" ng-model="$pwdModal.actPwd" required-message="\'\'" required=""> <span ng-click="$pwdModal.actPwdInputType = $pwdModal.actPwdInputType === \'password\'? \'text\' : \'password\'" class="btn input-group-addon addon-right"><i class="fa" ng-class="{ \'fa-eye\': $pwdModal.actPwdInputType !== \'text\', \'fa-eye-slash\': $pwdModal.actPwdInputType === \'text\'}"></i></span></div><label ng-messages="($pwdModal.passwordChangeForm.actPwd.$touched || $pwdModal.passwordChangeForm.$submitted) && $pwdModal.passwordChangeForm.actPwd.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.baseData.editPasswordModal.currentPasswordRequired"></span></label></div><div class="form-group"><label for="newPwd" translate="modules.personnel.dossier.baseData.editPasswordModal.newPassword"></label><div class="input-group"><input data-cy="personnel-dossier-basedata-passwordmodal-newpwd" type="{{ $pwdModal.newPwdInputType }}" class="form-control" name="newPwd" ng-model="$pwdModal.newPwd" validator="$pwdModal.isPwdGoodEnough($pwdModal.newPwd)" invalid-message="\'\'" required-message="\'\'" required=""> <span ng-click="$pwdModal.newPwdInputType = $pwdModal.newPwdInputType === \'password\'? \'text\' : \'password\'" class="btn input-group-addon addon-right"><i class="fa" ng-class="{ \'fa-eye\': $pwdModal.newPwdInputType !== \'text\', \'fa-eye-slash\': $pwdModal.newPwdInputType === \'text\'}"></i></span></div><label ng-messages="($pwdModal.passwordChangeForm.newPwd.$touched || $pwdModal.passwordChangeForm.$submitted) && $pwdModal.passwordChangeForm.newPwd.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.baseData.editPasswordModal.newPasswordRequired"></span> <span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.editPasswordModal.invalidPassword"></span></label></div><div class="form-group"><label for="newPwdRepeat" translate="modules.personnel.dossier.baseData.editPasswordModal.newPasswordRepeat"></label><div class="input-group"><input data-cy="personnel-dossier-basedata-passwordmodal-newpwdrepeat" type="{{ $pwdModal.newPwdRepeatInputType }}" class="form-control" name="newPwdRepeat" ng-model="$pwdModal.newPwdRepeat" ng-model-options="{ debounce: 200}" validator="($pwdModal.newPwd === $pwdModal.newPwdRepeat)" invalid-message="\'\'" required-message="\'\'" ng-required="true"> <span ng-click="$pwdModal.newPwdRepeatInputType = $pwdModal.newPwdRepeatInputType === \'password\'? \'text\' : \'password\'" class="btn input-group-addon addon-right"><i class="fa" ng-class="{ \'fa-eye\': $pwdModal.newPwdRepeatInputType !== \'text\', \'fa-eye-slash\': $pwdModal.newPwdRepeatInputType === \'text\'}"></i></span></div><label ng-messages="($pwdModal.passwordChangeForm.newPwdRepeat.$touched || $pwdModal.passwordChangeForm.$submitted) && $pwdModal.passwordChangeForm.newPwdRepeat.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.baseData.editPasswordModal.newPasswordRepeatRequired"></span> <span ng-message="angularValidator" translate="modules.personnel.dossier.baseData.editPasswordModal.newPasswordRepeatInvalid"></span></label></div></div><div class="modal-footer"><button data-cy="personnel-dossier-basedata-passwordmodal-cancel" type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.personnel.dossier.baseData.editPasswordModal.cancel"></button> <button data-cy="personnel-dossier-basedata-passwordmodal-save" type="submit" class="btn btn-primary" translate="modules.personnel.dossier.baseData.editPasswordModal.save"></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/profilePicModal/profilePicModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.baseData.profilePicModal.title"></h4></div><div class="modal-body"><div class="row"><div class="col-sm-12" style="min-height: 400px;"><div class="profilePicEditor"><form><div class="dropzone-container" file-dropzone="[image/png, image/jpeg, image/gif]" file="image" data-max-file-size="2000" ng-class="{ \'dragover\': containerClass === \'on-drag-enter\', \'image-loaded\': imageloaded, \'image-confirmed\': state === \'confirmed\', }"><div class="current-image" ng-if="state === \'initial\'"><img src="{{currentImage}}"></div><div class="upload-info"><i class="ion-images"></i><span class="info-text" translate="modules.personnel.dossier.baseData.profilePicModal.infoText"></span></div><div class="dropzone"></div><input type="file" name="profilepicture" id="profilepicture-fileinput"><div class="image-container" ng-show="state === \'crop\'"><ui-cropper image="imagedata" area-type="square" result-image="croppedImage" url-blob="blobUrl" result-image-size="400" init-max-area="true" change-on-fly="true" canvas-scalemode="fixed-height" area-init-size="250" result-image-format="image/jpeg" result-image-quality="0.65"></ui-cropper></div></div><div class="cropped-container" ng-class="{\'image-confirmed\': state === \'confirmed\'}"><img ng-src="{{ blobUrl || \'//:0\' }}" ng-hide="blobUrl === \'\'" class="large"> <img ng-src="{{ blobUrl || \'//:0\' }}" ng-hide="blobUrl === \'\'" class="small"></div></form><div class="button-controls"><button type="button" class="btn btn-default mr-15 no-animation" ng-if="([\'initial\']).indexOf(state) > -1" ng-click="removeCurrentImage()" translate="modules.personnel.dossier.baseData.profilePicModal.deleteCurrentPic"><i class="ion-ios-trash mr-10"></i></button> <button type="button" class="btn btn-default no-animation" ng-if="([\'initial\']).indexOf(state) > -1" ng-click="setSelectState()" translate="modules.personnel.dossier.baseData.profilePicModal.newPic"><i class="ion-ios-cloud-upload mr-10"></i></button> <button type="button" class="btn btn-default no-animation" ng-click="removePendingImage()" ng-if="([\'crop\', \'confirmed\']).indexOf(state) > -1" translate="modules.personnel.dossier.baseData.profilePicModal.deletePic"><i class="ion-ios-trash mr-10"></i></button> <button type="button" class="btn btn-default ml-15 no-animation" ng-if="state === \'crop\'" ng-click="setState(\'confirmed\')" translate="modules.personnel.dossier.baseData.profilePicModal.applyCrop"><i class="ion-checkmark mr-10"></i></button> <button type="button" class="btn btn-default ml-15 no-animation" ng-if="state === \'confirmed\'" ng-click="setState(\'crop\')" translate="modules.personnel.dossier.baseData.profilePicModal.newCrop"><i class="ion-crop mr-10"></i></button></div><div class="format-hints text-center" ng-if="state === \'select\'" translate="modules.personnel.dossier.baseData.profilePicModal.formatHints"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.personnel.dossier.baseData.profilePicModal.cancel"></button> <button type="submit" class="btn btn-primary disabled" ng-if="([\'initial\', \'select\', \'crop\']).indexOf(state) > -1" translate="modules.personnel.dossier.baseData.profilePicModal.save"></button> <button type="submit" class="btn btn-primary" ng-click="onSubmit()" ng-if="state === \'confirmed\'" translate="modules.personnel.dossier.baseData.profilePicModal.save"></button></div></div>');
$templateCache.put('app/pages/personnel/dossier/helperHours/modals/editHelperHours.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.helperHours.hours.timeTrack"></h4></div><form name="$modalCtrl.submitHoursForm" id="submitHoursForm" novalidate="" angular-validator="" angular-validator-submit="$modalCtrl.applyModal()"><div class="modal-body arno-helper-hours-dossier"><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="helperHoursTitle" class="required-label" translate="modules.helperHours.hours.title"></label> <input name="helperHoursTitle" class="form-control" type="text" required="" required-message="\'modules.helperHours.hours.theEntryNeededATitle\' |translate" ng-model="$modalCtrl.newRecord.title"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group mt-13"><label for="helperHoursDate" class="required-label" translate="modules.helperHours.hours.dateAndStartDate"></label><div class="input-group"><input type="text" class="form-control" name="helperHoursDate" required="" uib-datepicker-popup="{{$modalCtrl.datepickerStart.format}}" datepicker-options="$modalCtrl.datepickerStart.options" invalid-message="\'modules.helperHours.hours.checkAllTime\' | translate" validator="$modalCtrl.isValidDate()" required-message="\'modules.helperHours.hours.entryNeededADate\' |translate" ng-model="$modalCtrl.newRecord.date" is-open="$modalCtrl.openedDatePicker" close-text="generalTerms.close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.openedDatePicker = !$modalCtrl.openedDatePicker"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"><label class="time-label-in-form" ng-class="{\'required-label\': $modalCtrl.allTimespanFieldsRequired}" translate="modules.helperHours.hours.startTime"></label><div uib-timepicker="" ng-model="$modalCtrl.newRecord.dateStartTime" mousewheel="false" minute-step="15" show-meridian="false"></div><button type="button" class="btn btn-danger time-removal no-animation" ng-if="$modalCtrl.newRecord.dateStartTime" ng-click="$modalCtrl.newRecord.dateStartTime = undefined"><span class="ion-ios-trash"></span></button></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group mt-13"><label for="helperHoursDate" ng-class="{\'required-label\': $modalCtrl.allTimespanFieldsRequired}" translate="modules.helperHours.hours.endDateTime"></label><div class="input-group"><input type="text" class="form-control" name="helperHoursEndDate" uib-datepicker-popup="{{$modalCtrl.datepickerEnd.format}}" datepicker-options="$modalCtrl.datepickerEnd.options" ng-model="$modalCtrl.newRecord.dateEnd" is-open="$modalCtrl.openedDateEndPicker" close-text="generalTerms.close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$modalCtrl.openedDateEndPicker = !$modalCtrl.openedDateEndPicker"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-danger no-animation" ng-if="$modalCtrl.newRecord.dateEnd" ng-click="$modalCtrl.newRecord.dateEnd = undefined"><span class="ion-ios-trash"></span></button></span></div></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"><label class="time-label-in-form" ng-class="{\'required-label\': $modalCtrl.allTimespanFieldsRequired}" translate="modules.helperHours.hours.endTime"></label><div uib-timepicker="" ng-model="$modalCtrl.newRecord.dateEndTime" mousewheel="false" minute-step="15" show-meridian="false"></div><button type="button" class="btn btn-danger time-removal no-animation" ng-if="$modalCtrl.newRecord.dateEndTime" ng-click="$modalCtrl.newRecord.dateEndTime = undefined"><span class="ion-ios-trash"></span></button></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="row"><div class="col-xs-6"><div class="form-group"><label for="inputHours" class="control-label required-label" translate="modules.helperHours.hours.hours"><i class="fa fa-magic text-warning" title="{{\'modules.helperHours.hours.basicHelpEntry\' |translate}}" ng-if="$modalCtrl.automaticHHCalculation"></i></label> <input name="inputHours" required="" class="form-control" invalid-message="\'modules.helperHours.hours.invalidEntryMessage\' | translate" validator="$modalCtrl.isValidHelperHour()" min="0" type="number" ng-model="$modalCtrl.newRecord.hours"></div></div><div class="col-xs-6"><div class="form-group"><label for="inputMinutes" class="control-label required-label">{{\'modules.helperHours.hours.minutes\' |translate}} <i class="fa fa-magic text-warning" title="{{\'modules.helperHours.hours.volunteerEntrysFilled\' |translate}}" ng-if="$modalCtrl.automaticHHCalculation"></i></label> <input name="inputMinutes" required="" class="form-control" invalid-message="\'modules.helperHours.hours.invalidEntryMessage\' | translate" validator="$modalCtrl.isValidHelperHour()" min="0" max="59" step="1" type="number" ng-model="$modalCtrl.newRecord.minutes"></div></div></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"><label translate="modules.helperHours.hours.eventCategories"></label><tag-picker default-label="\'modules.helperHours.hours.noCategories\' |translate" tags="$modalCtrl.availableCategories" selected-tags="$modalCtrl.newRecord.categories" hide-division-name="true"></tag-picker></div></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="inputActivity" class="control-label" translate="modules.helperHours.hours.helpActivity"><arno-ba-help-tooltip text="modules.helperHours.hours.chooseDependent"></arno-ba-help-tooltip></label><ui-select name="selectActivity" ng-model="$modalCtrl.newRecord.activity" search-enabled="true" ng-disabled="disableActivities" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{\'modules.helperHours.hours.chooseActivity\' |translate}}">{{ $select.selected.Title }}</ui-select-match><ui-select-choices position="down" repeat="item in $modalCtrl.availableActivities | filter: $select.search"><span ng-bind="item.Title"></span></ui-select-choices><ui-select-no-choice><i class="p-7" translate="modules.helperHours.hours.noActiveActivities"></i></ui-select-no-choice></ui-select></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"><label for="inputDiv" class="control-label" translate="modules.helperHours.hours.div"><arno-ba-help-tooltip text="modules.helperHours.hours.mainSettingsAreBasic"></arno-ba-help-tooltip></label><ui-select name="selectDiv" ng-model="$modalCtrl.newRecord.division" search-enabled="true" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{\'modules.helperHours.hours.chooseDiv\' |translate}}">{{ $select.selected.Name }}</ui-select-match><ui-select-choices position="down" repeat="item in $modalCtrl.availableDivisions | filter: $select.search"><span ng-bind="item.Name"></span></ui-select-choices></ui-select><label role="warning" ng-if="$modalCtrl.dossierCtx != $modalCtrl.newRecord.division.id && $modalCtrl.dossierCtx !== \'rootOrg\'" class="control-label text-warning mt-5"><span translate="modules.helperHours.hours.divWarning"></span></label></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label for="inputNote" class="control-label" translate="modules.helperHours.hours.notice"></label> <textarea type="textarea" class="form-control" ng-model="$modalCtrl.newRecord.note"></textarea></div></div></div></div><div class="modal-footer"><div class="pull-right"><button type="button" ng-click="$close(null)" class="btn btn-default"><span translate="generalTerms.cancel"></span></button> <button type="submit" ng-disabled="!$modalCtrl.newRecord.title || !$modalCtrl.newRecord.date" ng-click="$modalCtrl.setDirty()" class="btn btn-primary"><span translate="generalTerms.save"></span></button></div></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/baseData/changeEMailModal/changeEMail.html','<div class="modal-content dossierChangeEMail"><form id="eMailChangeForm" name="eMailChangeForm" novalidate="" angular-validator="" angular-validator-submit="$eMailCtrl.submit()"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.baseData.editEmailModal.title"></h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group clearfix" ng-class="{\'has-error\': !eMailChangeForm.email.$valid && eMailChangeForm.$submitted}"><label for="email" class="col-sm-4 control-label required-label" translate="modules.personnel.dossier.baseData.editEmailModal.mail"></label><div class="col-sm-12"><input type="email" class="form-control" name="email" id="email" ng-model="$eMailCtrl.email" ng-model-options="{ debounce: 250 }" placeholder="{{(\'modules.personnel.dossier.baseData.editEmailModal.placeholder\' | translate )}}" ui-validate-async="{ alreadyExists: \'$eMailCtrl.checkEMail($value)\' }" required="" invalid-message="\'\'" required-message="\'\'"> <span ng-show="eMailChangeForm.email.$error.required || eMailChangeForm.email.$error.email || !eMailChangeForm.valid" class="help-block error-block basic-block mt-0 --color-danger" translate="modules.personnel.dossier.baseData.editEmailModal.mailRequired"></span> <span ng-show="eMailChangeForm.$error.alreadyExists" class="help-block error-block basic-block mt-0 --color-danger" translate="modules.personnel.dossier.baseData.editEmailModal.mailExists"></span></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="modules.personnel.dossier.baseData.editEmailModal.cancel"></button> <button type="submit" class="btn btn-primary" translate="modules.personnel.dossier.baseData.editEmailModal.save"></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/activity/modal/activityAssoc.html','<div class="modal-content"><form id="activityAssocForm" name="$aassoc.activityAssocForm" novalidate="" angular-validator="" angular-validator-submit="$aassoc.applyModal()"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.personnel.dossier.activity.assocModalTitle\' | translate:{ member: $aassoc.member.fullName, activity: $aassoc.activity.Title }) }}</h4></div><div class="modal-body arno-activity-assoc-modal"><div class="form-group"><label for="aassocCharacteristic" translate="modules.personnel.dossier.activity.characteristic"></label><ui-select ng-model="$aassoc.currentCharacteristic" id="aassocCharacteristic" class="btn-group bootstrap-select form-control" search-enabled="false" ng-disabled="!$aassoc.isPermitted(\'arno.personnel.dossier.activity.characteristicAssign\')"><ui-select-match placeholder="{{(\'modules.personnel.dossier.activity.characteristic\' | translate)}}"><span>{{ $aassoc.currentCharacteristic.value }}</span></ui-select-match><ui-select-choices position="down" repeat="characterisitc in $aassoc.characteristicMap | orderBy: \'activated\':true" ui-disable-choice="!characterisitc.activated"><span>{{ characterisitc.value }}</span></ui-select-choices></ui-select></div><div class="alert bg-warning" ng-if="!$aassoc.currentCharacteristic"><strong translate="modules.personnel.dossier.activity.pendingWarning"></strong></div><div ng-if="$aassoc.currentCharacteristic"><alloc-req-fulfillment division-id="$aassoc.divisionId" member-id="$aassoc.member.id" activity-id="$aassoc.activity.id" characteristic="$aassoc.currentCharacteristic.key"></alloc-req-fulfillment></div><div ng-if="$aassoc.currentCharacteristic"><table class="table table-condensed"><thead><tr class="black-muted-bg"><th translate="modules.personnel.dossier.activity.period"></th><th class="align-left-force" translate="modules.personnel.dossier.activity.startDate"></th><th translate="modules.personnel.dossier.activity.endDate"></th><th class="hidden-xs hidden-sm" translate="modules.personnel.dossier.activity.terminationReason"></th><th translate="modules.personnel.dossier.activity.action"></th></tr></thead><tbody><tr ng-repeat="period in $aassoc.parsedActivityAllocationPeriods"><td class="align-left-force force-minimal"><span ng-if="period.id">{{$index + 1}}</span></td><td class="align-left-force" style="width: 150px;"><div class="input-group"><input id="{{\'startDate\'+$index}}" name="{{\'startDate\'+$index}}" class="form-control" type="text" uib-datepicker-popup="{{$aassoc.datepicker.format}}" datepicker-options="$aassoc.datepicker.options" close-text="{{(\'modules.personnel.dossier.activity.close\' | translate)}}" show-button-bar="false" is-open="period.startDateOpened" ng-model="period.StartDate" ng-model-options="{ debounce: 200 }" required-message="\'Startdatum fehlt!\'" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="period.startDateOpened = !period.startDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td><td class="align-left-force" style="width: 150px;"><div class="input-group"><input id="{{\'endDate\'+$index}}" name="{{\'endDate\'+$index}}" class="form-control" type="text" uib-datepicker-popup="{{$aassoc.datepicker.format}}" datepicker-options="$aassoc.allocationPeriodEndDatepickerOpts[$index].options" close-text="{{(\'modules.personnel.dossier.activity.close\' | translate)}}" show-button-bar="false" is-open="period.endDateOpened" ng-model="period.EndDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="period.endDateOpened = !period.endDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></td><td class="align-left-force hidden-xs hidden-sm"><ui-select ng-model="period.CauseOfTermination" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="">{{ period.CauseOfTermination }}</ui-select-match><ui-select-choices repeat="cause in $aassoc.getCausesOfTermination($select.search) | filter: $select.search"><div ng-bind="cause"></div></ui-select-choices></ui-select></td><td class="v-align-middle force-minimal"><button class="btn btn-xs btn-with-icon" type="button" ng-class="{\'btn-danger\': !period.pendingDelete, \'btn-warning\': period.pendingDelete}" ng-click="$aassoc.deletePeriod(period)"><i ng-class="{\'ion-ios-trash\': !period.pendingDelete, \'ion-plus-round\': period.pendingDelete}"></i> <span class="btn-span">{{period.pendingDelete ? (\'modules.personnel.dossier.activity.keep\' | translate) : (\'generalTerms.remove\' | translate)}}</span></button></td></tr><tr ng-if="!$aassoc.parsedActivityAllocationPeriods.length"><td colspan="5" class="align-center" translate="modules.personnel.dossier.activity.noAssignedPeriods"></td></tr></tbody></table><label class="arno-activity-new-assoc-period-label" translate="modules.personnel.dossier.activity.newPeriod"></label><div class="row"><div class="col-md-4"><div class="form-group"><div class="input-group"><input name="newStartDate" class="form-control" type="text" placeholder="{{(\'modules.personnel.dossier.activity.startDatePlaceholder\' | translate)}}" uib-datepicker-popup="{{$aassoc.datepicker.format}}" datepicker-options="$aassoc.datepicker.options" is-open="$aassoc.newStartDateOpened" close-text="{{(\'modules.personnel.dossier.activity.close\' | translate)}}" show-button-bar="false" ng-model="$aassoc.newStartDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$aassoc.newStartDateOpened = !$aassoc.newStartDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-4"><div class="form-group"><div class="input-group"><input name="newEndDate" class="form-control" type="text" placeholder="{{(\'modules.personnel.dossier.activity.endDatePlaceholder\' | translate)}}" uib-datepicker-popup="{{$aassoc.datepicker.format}}" datepicker-options="$aassoc.expireDatepicker.options" is-open="$aassoc.newEndDateOpened" close-text="{{(\'modules.personnel.dossier.activity.close\' | translate)}}" show-button-bar="false" ng-model="$aassoc.newEndDate" ng-model-options="{ debounce: 200 }"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$aassoc.newEndDateOpened = !$aassoc.newEndDateOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block sub-little-text" ng-if="$aassoc.ExpireDateViaValidityPeriodHelper" translate="modules.personnel.dossier.activity.endDateCalculated_1"><i class="fa fa-info-circle"></i><br translate="modules.personnel.dossier.activity.endDateCalculated_2"></span></div></div><div class="col-md-4"></div></div><div class="row"><div class="col-md-8 mb-5"><ui-select ng-model="$aassoc.causeOftermination" class="btn-group bootstrap-select form-control"><ui-select-match placeholder="{{(\'modules.personnel.dossier.activity.terminationReason\' | translate)}}">{{ $aassoc.causeOftermination }}</ui-select-match><ui-select-choices repeat="cause in $aassoc.getCausesOfTermination($select.search) | filter: $select.search"><div ng-bind="cause"></div></ui-select-choices></ui-select></div><div class="col-md-4"><button type="button" class="btn btn-success btn-with-icon arno-activity-new-assoc-btn" ng-click="$aassoc.addNewDate()" ng-disabled="!$aassoc.newStartDate || Object.keys(activityAssocForm.newStartDate.$error).length || !$aassoc.checkForValidExpireDate()"><i class="ion-plus"></i><span class="hidden-xs btn-span" translate="modules.personnel.dossier.activity.addPeriod"></span></button></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-if="$aassoc.activity.calculatedState === \'PENDING\'" ng-click="$aassoc.denyAssociation()" translate="modules.personnel.dossier.activity.decline"></button> <button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" ng-disabled="!$aassoc.currentCharacteristic">{{$aassoc.activity.calculatedState === \'PENDING\' ? (\'modules.personnel.dossier.activity.assign\' | translate) : (\'generalTerms.save\' | translate)}}</button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/activity/modal/activityCheckFulfillment.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ (\'modules.personnel.dossier.activity.checkFullfilmentModalTitle\' | translate:{ member: $acful.member.fullName, activity: $acful.newActivity.value }) }}</h4></div><div class="modal-body arno-activity-check-fulfillment"><div ng-class="{\'mb-15\': $acful.newActivity}"><ui-select ng-if="$acful.activityGroups.length" ng-model="$acful.newActivity" class="btn-group bootstrap-select form-control" search-enabled="true" append-to-body="false"><ui-select-match placeholder="{{(\'modules.personnel.dossier.activity.checkFullfilmentSelectPlaceholder\' | translate)}}"><span>{{ $acful.newActivity.value }}</span></ui-select-match><ui-select-choices position="down" repeat="activity in $acful.activityGroups | filterAllocatedOrPending:$acful.allocatedOrPendingActivities | filter: $select.search | orderBy:[\'groupName\',\'value\']" group-by="\'groupName\'"><span>{{ activity.value }}</span></ui-select-choices></ui-select><div ng-if="!$acful.activityGroups.length" class="text-center"><label translate="modules.personnel.dossier.activity.noAssignableOccupations_1"><br translate="modules.personnel.dossier.activity.noAssignableOccupation_2"></label></div></div><div ng-if="$acful.newActivity"><alloc-req-fulfillment division-id="$acful.fulfillmentCheckData.divisionId" member-id="$acful.fulfillmentCheckData.memberId" activity-id="$acful.fulfillmentCheckData.activityId" characteristic="$acful.fulfillmentCheckData.characteristic"></alloc-req-fulfillment><div class="alert bg-warning"><h4 translate="modules.personnel.dossier.activity.note"></h4><strong>{{ (\'modules.personnel.dossier.activity.checkFullfilmentWarnTextLine1\' | translate:{ member: $acful.member.fullName, activity: $acful.newActivity.value }) }}<br>{{ (\'modules.personnel.dossier.activity.checkFullfilmentWarnTextLine2\' | translate ) }}<br><br>{{ (\'modules.personnel.dossier.activity.checkFullfilmentWarnTextLine3\' | translate ) }}</strong></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" ng-if="$acful.newActivity" class="btn btn-primary" ng-click="$acful.applyModal()" translate="generalTerms.save"></button></div></div>');
$templateCache.put('app/pages/personnel/dossier/activity/modal/activityExport.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="modules.personnel.dossier.activity.chooseFileType"></h4></div><div class="modal-body"><div class="section-block"><p><b translate="modules.personnel.dossier.activity.noteForGDPR"></b></p><div ng-bind-html="$activityExportCtrl.exportPrivacyNoteContent"></div><label class="custom-checkbox"><input type="checkbox" ng-model="$activityExportCtrl.readAndAccepted" class="custom-control-input"> <span translate="modules.personnel.dossier.activity.readAndAccepted"></span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <span><button type="button" class="btn btn-primary" ng-disabled="!$activityExportCtrl.readAndAccepted" ng-click="$activityExportCtrl.applyModal()" translate="modules.personnel.dossier.activity.download"></button></span></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsEdit/trainingsEdit.tpl.html','<div ng-if="!$trainingsEditCtrl.isDeleted" class="arno__trainings__edit-component"><h5 ng-if="$trainingsEditCtrl.trainingData.TrainingTemplate.Name"><div class="row"><span class="col-xs-12 col-sm-7" translate="modules.personnel.dossier.trainings.edit.template" translate-values="{ name: $trainingsEditCtrl.trainingData.TrainingTemplate.Name }"></span> <span class="col-xs-12 col-sm-5" ng-if="$trainingsEditCtrl.trainingData.Status"><span class="pull-right">{{ (\'modules.personnel.dossier.trainings.edit.state\' | translate) }} <i class="{{$trainingsEditCtrl.getIconClassForStatus($trainingsEditCtrl.trainingData.Status)}} ml-5"></i> {{$trainingsEditCtrl.TRAINING_STATUS_LABELS[$trainingsEditCtrl.trainingData.Status]}}</span></span> <span ng-if="$trainingsEditCtrl.checkTrainingValidity($trainingsEditCtrl.trainingData)" class="col-xs-12 col-sm-offset-7 col-sm-5 text-right arno__personnel__dossier__trainings__validity --expired mt-10" translate="modules.personnel.dossier.trainings.edit.expired"></span></div></h5><form name="$trainingsEditCtrl.formRef" class="row" novalidate="" ng-submit="$trainingsEditCtrl.saveTraining($trainingsEditCtrl.trainingData, $trainingsEditCtrl.formRef)"><fieldset ng-disabled="$trainingsEditCtrl.uiConfig.disableFields === true"><div class="form-group col-xs-12" ng-class="{ \'has-error\': $trainingsEditCtrl.isFieldInvalid($trainingsEditCtrl.formRef, $trainingsEditCtrl.formRef.trainingName) }"><label for="trainingName" translate="modules.personnel.dossier.trainings.edit.name"></label> <input type="text" class="form-control" name="trainingName" autofocus="" maxlength="1000" ng-model="$trainingsEditCtrl.trainingData.vm.Name" ng-model-options="{ debounce: 200, allowInvalid: true }" ng-required="true" placeholder="Name" data-cy="personnel-dossier-add-training-name"> <label ng-messages="($trainingsEditCtrl.formRef.trainingName.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingName.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.trainings.edit.nameRequired"></span> <span ng-message="maxlength" translate="modules.personnel.dossier.trainings.edit.nameMaxLength"></span></label></div><div class="form-group col-xs-12"><label for="trainingCategory">{{(\'modules.personnel.dossier.trainings.edit.category\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_CATEGORY_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><tag-picker default-label="(\'modules.personnel.dossier.trainings.edit.notCategorized\' | translate)" tags="$trainingsEditCtrl.categories" selected-tags="$trainingsEditCtrl.trainingData.vm.BaseCategories" data-cy="personnel-dossier-add-training-category"></tag-picker></div><div class="form-group col-xs-12 col-sm-6"><label for="trainingStartDate" class="control-label">{{(\'modules.personnel.dossier.trainings.edit.start\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_START_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><div class="input-group"><input type="text" class="form-control" name="trainingStartDate" uib-datepicker-popup="{{ $trainingsEditCtrl.datepicker.format }}" datepicker-options="$trainingsEditCtrl.datepicker.options" ng-model="$trainingsEditCtrl.trainingData.vm.StartDate" is-open="$trainingsEditCtrl.openedStartDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsEditCtrl.openedStartDate = !$trainingsEditCtrl.openedStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-if="$trainingsEditCtrl.showStartDateCompletionDateWarning($trainingsEditCtrl.trainingData)" role="alert" class="control-label text-warning"><span><strong>{{ (\'generalTerms.warning\' | translate) }}:</strong> {{ (\'modules.personnel.dossier.trainings.edit.warningTextStart\' | translate) }}</span></label> <label ng-messages="($trainingsEditCtrl.formRef.trainingStartDate.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingStartDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="parse" translate="modules.personnel.dossier.trainings.edit.dateInvalid"></span></label></div><div class="form-group col-xs-12 col-sm-6"><label for="trainingEndDate" class="control-label">{{(\'modules.personnel.dossier.trainings.edit.end\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_END_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><div class="input-group"><input type="text" class="form-control" name="trainingEndDate" uib-datepicker-popup="{{ $trainingsEditCtrl.endDatepicker.format }}" datepicker-options="$trainingsEditCtrl.endDatepicker.options" ng-model="$trainingsEditCtrl.trainingData.vm.EndDate" is-open="$trainingsEditCtrl.openedEndDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}" start-date="{{ $trainingsEditCtrl.trainingData.vm.StartDate }}" compare-with-start-date=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsEditCtrl.openedEndDate = !$trainingsEditCtrl.openedEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-messages="($trainingsEditCtrl.formRef.trainingEndDate.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingEndDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="parse" translate="modules.personnel.dossier.trainings.edit.dateInvalid"></span> <span ng-message="checkEndDate" translate="modules.personnel.dossier.trainings.edit.datesInconsistent"></span></label></div><div class="row"><div class="col-xs-12"><div class="form-group col-xs-12 col-sm-6"><label for="trainingCountableHours" class="control-label">{{(\'modules.personnel.dossier.trainings.hours\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COUNTABLE_HOURS_FIELD\' | translate )}}"></arno-ba-help-tooltip></label> <input type="number" class="form-control" name="trainingCountableHours" ng-model="$trainingsEditCtrl.trainingData.vm.CountableHours" ng-required="true" max="2147483647" min="0" data-cy="personnel-dossier-add-training-countable-hours"> <label ng-messages="($trainingsEditCtrl.formRef.trainingCountableHours.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingCountableHours.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.trainings.edit.hoursRequired"></span> <span ng-message="min" translate="modules.personnel.dossier.trainings.edit.hoursMin"></span> <span ng-message="max" translate="modules.personnel.dossier.trainings.edit.hoursMax"></span></label></div><div class="form-group col-xs-12 col-sm-6"><label for="trainingValidityEndDate" class="control-label">{{(\'modules.personnel.dossier.trainings.edit.validityEndDate\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_VALIDITY_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><div class="input-group"><input type="text" class="form-control" name="trainingValidityEndDate" uib-datepicker-popup="{{ $trainingsEditCtrl.datepicker.format }}" datepicker-options="$trainingsEditCtrl.datepicker.options" ng-model="$trainingsEditCtrl.trainingData.vm.ValidityEndDate" is-open="$trainingsEditCtrl.openedValidityEndDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsEditCtrl.openedValidityEndDate = !$trainingsEditCtrl.openedValidityEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-if="$trainingsEditCtrl.showValidityWarning($trainingsEditCtrl.trainingData)" role="alert" class="control-label text-warning"><span><strong>{{ (\'generalTerms.warning\' | translate) }}:</strong> {{ (\'modules.personnel.dossier.trainings.edit.warningTextValidity\' | translate) }}</span></label> <label ng-messages="($trainingsEditCtrl.formRef.trainingValidityEndDate.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingValidityEndDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="parse" translate="modules.personnel.dossier.trainings.edit.dateInvalid"></span></label></div></div></div><div class="form-group col-xs-12 col-sm-6"><label for="trainingCompletionStatus">{{ (\'modules.personnel.dossier.trainings.edit.completion\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COMPLETION_STATUS_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><ui-select ng-model="$trainingsEditCtrl.trainingData.vm.CompletionStatus" class="btn-group bootstrap-select form-control" ng-required="true" required="" name="trainingCompletionStatus" search-enabled="false" spinner-enabled="false"><ui-select-match placeholder="{{ (\'modules.personnel.dossier.trainings.edit.completionPlaceholder\' | translate) }}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" ui-disable-choice="$trainingsEditCtrl.uiConfig.disableFields === true" repeat="completionStatus in $trainingsEditCtrl.TRAINING_COMPLETION_STATUS_LIST"><span ng-bind="completionStatus.Name"></span></ui-select-choices></ui-select><label ng-messages="($trainingsEditCtrl.formRef.trainingCompletionStatus.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingCompletionStatus.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.trainings.edit.completionStateRequired"></span></label></div><div ng-if="$trainingsEditCtrl.trainingData.vm.CompletionStatus.mapping === \'COMPLETED\'" class="col-md-12"><div class="row"><div class="form-group col-xs-12 col-sm-6"><label for="trainingCompletionDate" class="control-label">{{ (\'modules.personnel.dossier.trainings.edit.completionDate\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COMPLETION_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><div class="input-group"><input type="text" class="form-control" name="trainingCompletionDate" uib-datepicker-popup="{{ $trainingsEditCtrl.datepicker.format }}" datepicker-options="$trainingsEditCtrl.datepicker.options" ng-model="$trainingsEditCtrl.trainingData.vm.CompletionDate" ng-required="$trainingsEditCtrl.trainingData.vm.CompletionStatus.mapping === \'COMPLETED\'" is-open="$trainingsEditCtrl.openedCompletionDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsEditCtrl.openedCompletionDate = !$trainingsEditCtrl.openedCompletionDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-messages="($trainingsEditCtrl.formRef.trainingCompletionDate.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingCompletionDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.trainings.edit.completionDateRequired"></span></label> <label ng-if="$trainingsEditCtrl.showCompletionDateWarning($trainingsEditCtrl.trainingData)" role="alert" class="control-label text-warning"><span><strong>{{ (\'generalTerms.warning\' | translate) }}:</strong> {{ (\'modules.personnel.dossier.trainings.edit.warningTextCompletionDate\' | translate) }}</span></label></div><div class="form-group col-xs-12 col-sm-6"><label for="trainingGraduation">{{ (\'modules.personnel.dossier.trainings.edit.graduation\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_GRADUATION_FIELD\' | translate )}}"></arno-ba-help-tooltip></label><ui-select ng-model="$trainingsEditCtrl.trainingData.vm.Graduation" on-select="$trainingsEditCtrl.graduationChanged($select.selected)" class="btn-group bootstrap-select form-control" name="trainingGraduation" ng-required="$trainingsEditCtrl.trainingData.vm.CompletionStatus.mapping === \'COMPLETED\'" search-enabled="false" spinner-enabled="false"><ui-select-match placeholder="{{(\'modules.personnel.dossier.trainings.edit.graduationPlaceholder\' | translate)}}">{{$select.selected.Name}}</ui-select-match><ui-select-choices position="down" repeat="graduation in $trainingsEditCtrl.TRAINING_GRADUATION_LIST"><span ng-bind="graduation.Name"></span></ui-select-choices></ui-select><label ng-messages="($trainingsEditCtrl.formRef.trainingGraduation.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingGraduation.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="required" translate="modules.personnel.dossier.trainings.edit.graduationRequired"></span></label></div></div></div><div class="form-group col-xs-12"><label for="trainingNotes" translate="modules.personnel.dossier.trainings.edit.notes"></label> <textarea type="text" class="form-control" name="trainingNotes" ng-model="$trainingsEditCtrl.trainingData.vm.Notes" maxlength="4000" placeholder="{{(\'modules.personnel.dossier.trainings.edit.notesPlaceholder\' | translate)}}" data-cy="personnel-dossier-add-training-notes"></textarea> <label ng-messages="($trainingsEditCtrl.formRef.trainingNotes.$touched || $trainingsEditCtrl.formRef.$submitted) && $trainingsEditCtrl.formRef.trainingNotes.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="maxlength" translate="modules.personnel.dossier.trainings.edit.notesMaxLength"></span></label></div><div class="col-xs-12 form-group"><file-upload unallowed-file-types="$trainingsEditCtrl.unallowedFileTypes" upload-url="$trainingsEditCtrl.fileUploadUrl" on-file-uploaded="$trainingsEditCtrl.onFileUploaded" on-file-download="$trainingsEditCtrl.onFileDownload" on-file-preview="$trainingsEditCtrl.onFilePreview" on-file-delete="$trainingsEditCtrl.onFileDelete" on-upload-started="$trainingsEditCtrl.onUploadStarted" file-name="$trainingsEditCtrl.trainingData.FileName || $trainingsEditCtrl.trainingData.File" downloadable-file="$trainingsEditCtrl.trainingData.File" show-remove-button="true"></file-upload></div></fieldset><div ng-if="$trainingsEditCtrl.uiConfig.showBottomActionsbar !== false" class="col-xs-12 align-right"><button class="btn btn-default btn-with-icon" ng-if="$trainingsEditCtrl.uiConfig.showCancelBtn !== false && ($trainingsEditCtrl.formRef.$dirty || $trainingsEditCtrl.uiConfig.alwaysShowCancelBtn)" ng-click="$trainingsEditCtrl.cancelAndRollbackTrainingChanges($trainingsEditCtrl.trainingData, $trainingsEditCtrl.formRef)" type="button"><i class="ion-android-close"></i> <span class="hidden-xs" translate="generalTerms.cancel"></span></button> <button class="btn btn-primary btn-with-icon" ng-if="$trainingsEditCtrl.uiConfig.showDeleteBtn !== false" ng-click="$trainingsEditCtrl.deleteTraining($trainingsEditCtrl.trainingData)" type="button"><i class="ion-ios-trash"></i> <span class="hidden-xs" translate="generalTerms.delete"></span></button> <button ng-show="$trainingsEditCtrl.formRef.$dirty || $trainingsEditCtrl.fileChanged" ng-if="$trainingsEditCtrl.uiConfig.showSaveBtn !== false" class="btn btn-primary btn-with-icon" type="submit" ng-disabled="$trainingsEditCtrl.fileUploadActive"><i class="ion-checkmark"></i> <span class="hidden-xs" translate="generalTerms.save"></span></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsStatistics.tpl.html','<div class="col-xs-12 mt-15 mb-20 arno__personnel__dossier__trainings__statistics"><div class="row"><div class="col-xs-12"><h3 class="with-line">{{(\'modules.personnel.dossier.trainings.hours\' | translate)}} <span ng-switch="$trainingsStatisticsCtrl.trainingTemplates.length"><span ng-switch-when="1">{{(\'modules.personnel.dossier.trainings.statistics.byTemplate\' | translate)}} <span ng-bind="::$trainingsStatisticsCtrl.trainingTemplates[0].Name"></span></span> <span ng-switch-default="">{{(\'modules.personnel.dossier.trainings.statistics.byTemplates\' | translate)}}</span><arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_PERSONNEL_DOSSIER_COUNTABLE_HOURS_SECTION\' | translate )}}"></arno-ba-help-tooltip></span> <button type="button" class="btn btn-default btn-with-icon pull-right" ng-click="$trainingsStatisticsCtrl.back()"><i class="ion-ios-arrow-back"></i><span translate="generalTerms.return"></span></button></h3></div><div class="col-xs-12"><form name="$trainingsStatisticsCtrl.statisticsForm" class="row arno__personnel__dossier__trainings__statistics__filter-form" novalidate=""><div class="form-group col-xs-12 col-sm-2"><div class="input-group"><input type="text" class="form-control" name="selectedMinDate" uib-datepicker-popup="{{ $trainingsStatisticsCtrl.datepicker.format }}" datepicker-options="$trainingsStatisticsCtrl.datepicker.options" ng-model="$trainingsStatisticsCtrl.selectedMinDate" is-open="$trainingsStatisticsCtrl.openedMinDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsStatisticsCtrl.openedMinDate = !$trainingsStatisticsCtrl.openedMinDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-messages="($trainingsStatisticsCtrl.statisticsForm.selectedMinDate.$touched || $trainingsStatisticsCtrl.statisticsForm.$submitted) && $trainingsStatisticsCtrl.statisticsForm.selectedMinDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="parse" translate="modules.personnel.dossier.trainings.edit.dateInvalid"></span></label></div><div class="form-group col-xs-12 col-sm-2"><div class="input-group"><input type="text" class="form-control" name="selectedMaxDate" uib-datepicker-popup="{{ $trainingsStatisticsCtrl.datepicker.format }}" datepicker-options="$trainingsStatisticsCtrl.selectedEndDatepicker.options" ng-model="$trainingsStatisticsCtrl.selectedMaxDate" is-open="$trainingsStatisticsCtrl.openedMaxDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.edit.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$trainingsStatisticsCtrl.openedMaxDate = !$trainingsStatisticsCtrl.openedMaxDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label ng-messages="($trainingsStatisticsCtrl.statisticsForm.selectedMaxDate.$touched || $trainingsStatisticsCtrl.statisticsForm.$submitted) && $trainingsStatisticsCtrl.statisticsForm.selectedMaxDate.$error" role="alert" class="control-label has-error validationMessage"><span ng-message="parse" translate="modules.personnel.dossier.trainings.edit.dateInvalid"></span></label></div><div class="col-xs-12 col-sm-2 pull-right text-right mt-10">{{(\'modules.personnel.dossier.trainings.statistics.count\' | translate)}} <span ng-bind="$trainingsStatisticsCtrl.allTrainingsByTrainingTemplates.length"></span></div></form></div><div class="col-xs-12 mb-30"><h4 class="with-line" toggle-next="">{{\'modules.personnel.dossier.trainings.statistics.chronological\' | translate}}</h4><arno-personnel-dossier-trainings-timeline trainings-data="$trainingsStatisticsCtrl.allTrainingsByTrainingTemplates" selected-min-date="$trainingsStatisticsCtrl.selectedMinDate" selected-max-date="$trainingsStatisticsCtrl.selectedMaxDate"></arno-personnel-dossier-trainings-timeline></div><div class="col-xs-12 mb-20"><h4 class="with-line" toggle-next="">{{\'modules.personnel.dossier.trainings.statistics.tabular\' | translate}}</h4><div><h4 ng-if="$trainingsStatisticsCtrl.trainingTemplates.length > 1" translate="modules.personnel.dossier.trainings.statistics.templateOverview"></h4><arno-personnel-dossier-trainings-hours-table trainings-data="$trainingsStatisticsCtrl.allTrainingsByTrainingTemplates" visible-cols="$trainingsStatisticsCtrl.allTrainingsTemplatesTableVisibleCols"></arno-personnel-dossier-trainings-hours-table><div ng-if="$trainingsStatisticsCtrl.trainingTemplates.length > 1"><div ng-repeat="trainingTemplate in $trainingsStatisticsCtrl.trainingTemplates" class="mt-25"><h4 ng-if="trainingTemplate.Name" ng-bind="::trainingTemplate.Name"></h4><arno-personnel-dossier-trainings-hours-table trainings-data="trainingTemplate.vmTrainings" visible-cols="$trainingsStatisticsCtrl.trainingsTemplateTableVisibleCols"></arno-personnel-dossier-trainings-hours-table></div></div></div></div><div class="col-xs-12 mt-15"><h3 class="with-line">{{(\'generalTerms.qualifications\' | translate)}} <span ng-switch="$trainingsStatisticsCtrl.trainingTemplates.length"><span ng-switch-when="1">{{(\'modules.personnel.dossier.trainings.statistics.byTemplate\' | translate)}} <span ng-bind="::$trainingsStatisticsCtrl.trainingTemplates[0].Name"></span></span> <span ng-switch-default="">{{(\'modules.personnel.dossier.trainings.statistics.byTemplates\' | translate)}}</span></span></h3><div class="row"><arno-personnel-dossier-trainings-qualifications-table selected-ctx="$trainingsStatisticsCtrl.selectedCtx" training-templates="$trainingsStatisticsCtrl.trainingTemplates" member-qualifications="$trainingsStatisticsCtrl.memberQualifications" qualifications-hierarchy="$trainingsStatisticsCtrl.qualificationsHierarchy" member="$trainingsStatisticsCtrl.member"></arno-personnel-dossier-trainings-qualifications-table></div></div></div><div class="row btns-row mt-20"><div class="col-xs-12"><button type="button" class="btn btn-default btn-with-icon" ng-click="$trainingsStatisticsCtrl.back()"><i class="ion-ios-arrow-back"></i><span translate="generalTerms.return"></span></button> <button type="button" ui-sref="arno.personnel.personnelList" class="btn btn-default btn-with-icon"><i class="fa fa-chevron-left"></i><span translate="modules.personnel.dossier.general.backToPersonnelList"></span></button></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsTablePanel/trainingsTablePanel.tpl.html','<div class="arno__personnel__dossier__trainings__table-panel" arno-acl="" acl-ctx="$trainingsTablePanelCtrl.selectedCtx"><arno-ba-tableview list-selected-entry="$trainingsTablePanelCtrl.selectedTraining" list-visible-cols="$trainingsTablePanelCtrl.visibleCols" list-page-sizes="$trainingsTablePanelCtrl.tablePageSizes" list-page-size="$trainingsTablePanelCtrl.tablePageSize"><arno-ba-tableview-header-bar-left-button-row ng-if="!$trainingsTablePanelCtrl.isOverview"><button acl-grant="\'arno.personnel.dossier.trainings.manage\'" class="btn btn-primary btn-with-icon mr-10" ng-click="$trainingsTablePanelCtrl.addTraining()"><i class="ion-plus"></i><span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.trainings.table.add"></span></button> <button ng-show="$trainingsTablePanelCtrl.selectedCtx && $trainingsTablePanelCtrl.showStatisticsBtn()" ng-click="$trainingsTablePanelCtrl.openMultipleTrainingStatistics()" class="btn btn-default btn-with-icon mr-10 ml-0"><i class="fa fa-clock-o"></i> <span class="hidden-xs hidden-sm" translate="modules.personnel.dossier.trainings.table.evaluateTemplate"></span></button></arno-ba-tableview-header-bar-left-button-row><arno-ba-tableview-header-bar-right-button-row ng-if="!$trainingsTablePanelCtrl.isOverview"><button ng-if="$trainingsTablePanelCtrl.currentFilters" class="btn btn-default btn-with-icon pull-right mr-10" ng-click="$trainingsTablePanelCtrl.resetFilters()"><i class="ion-close-circled"></i> <span class="hidden-xs" translate="modules.personnel.dossier.trainings.table.resetFilter"></span></button> <button ng-if="$trainingsTablePanelCtrl.trainings.length" class="btn btn-default btn-with-icon pull-right mr-10" ng-click="$trainingsTablePanelCtrl.exportTable()"><i class="fa fa-download"></i> <span class="hidden-xs"><span translate="generalTerms.export"></span></span></button></arno-ba-tableview-header-bar-right-button-row><arno-ba-tableview-content><div class="row"><div class="col-xs-12"><h5 ng-show="$trainingsTablePanelCtrl.currentFilters" class="text-center ml-5">{{ (\'generalTerms.searchResults\' | translate) }}: <span ng-show="$trainingsTablePanelCtrl.lastFilterResultCount === 0" translate="generalTerms.noResults"></span> <span ng-show="$trainingsTablePanelCtrl.lastFilterResultCount > 0" ng-bind="$trainingsTablePanelCtrl.lastFilterResultCount"></span></h5></div></div><div class="table-responsive"><table st-table="$trainingsTablePanelCtrl.trainings" st-pipe="$trainingsTablePanelCtrl.refreshTrainingsList" class="table table-condensed table-hover"><col width="75"><col width="200"><col width="175"><col width="300"><thead><tr class="sortable black-muted-bg" ng-if="!$trainingsTablePanelCtrl.isOverview"><th class="text-center">{{ (\'modules.personnel.dossier.trainings.table.selection\' | translate) }}</th><th st-sort="Name">{{ (\'modules.personnel.dossier.trainings.name\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CountableHours.value" st-sort="CountableHours">{{ (\'modules.personnel.dossier.trainings.hours\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COUNTABLE_HOURS_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Status.value" st-sort="Status">{{ (\'modules.personnel.dossier.trainings.state\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_STATUS_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th st-sort="StartDate" ng-if="$trainingsTablePanelCtrl.visibleCols.StartDate.value">{{ (\'modules.personnel.dossier.trainings.begin\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_START_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th st-sort="EndDate" ng-if="$trainingsTablePanelCtrl.visibleCols.EndDate.value">{{ (\'modules.personnel.dossier.trainings.end\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_END_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th st-sort="CompletionDate" ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionDate.value">{{ (\'modules.personnel.dossier.trainings.completionDate\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COMPLETION_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionStatus.value" st-sort="CompletionStatus">{{ (\'modules.personnel.dossier.trainings.completion\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COMPLETION_STATUS_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Graduation.value" st-sort="Graduation">{{ (\'modules.personnel.dossier.trainings.graduation\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_GRADUATION_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.TrainingTemplate.value">{{ (\'modules.personnel.dossier.trainings.template\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_TRAINING_TEMPLATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th st-sort="ValidityEndDate" st-sort-default="reverse" ng-if="$trainingsTablePanelCtrl.visibleCols.ValidityEndDate.value" title="{{ (\'modules.personnel.dossier.trainings.TRAINING_HELP_VALIDITY_DATE_FIELD\' | translate) }}">{{ (\'modules.personnel.dossier.trainings.validityEndDate\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Notes.value" st-sort="Notes">{{ (\'modules.personnel.dossier.trainings.notes\' | translate) }}</th><th class="text-right">{{ (\'generalTerms.action\' | translate) }}</th></tr><tr class="sortable black-muted-bg" ng-if="$trainingsTablePanelCtrl.isOverview"><th ng-if="!$trainingsTablePanelCtrl.isOverview"></th><th width="210px">{{ (\'modules.personnel.dossier.trainings.name\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CountableHours.value">{{ (\'modules.personnel.dossier.trainings.hours\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Status.value">{{ (\'modules.personnel.dossier.trainings.state\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.StartDate.value">{{ (\'modules.personnel.dossier.trainings.begin\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.EndDate.value">{{ (\'modules.personnel.dossier.trainings.end\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionDate.value">{{ (\'modules.personnel.dossier.trainings.completionDate\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionStatus.value">{{ (\'modules.personnel.dossier.trainings.completion\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Graduation.value">{{ (\'modules.personnel.dossier.trainings.graduation\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.TrainingTemplate.value">{{ (\'modules.personnel.dossier.trainings.template\' | translate) }}</th><th st-sort="ValidityEndDate" st-sort-default="reverse" ng-if="$trainingsTablePanelCtrl.visibleCols.ValidityEndDate.value" title="{{ (\'modules.personnel.dossier.trainings.TRAINING_HELP_VALIDITY_DATE_FIELD\' | translate) }}">{{ (\'modules.personnel.dossier.trainings.validityEndDate\' | translate) }}</th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Notes.value">{{ (\'modules.personnel.dossier.trainings.notes\' | translate) }}</th></tr><tr ng-if="!$trainingsTablePanelCtrl.isOverview"><th class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-change="$trainingsTablePanelCtrl.selectAllTableEntries()" ng-model="$trainingsTablePanelCtrl.selectedAllTableEntries" ng-disabled="!$trainingsTablePanelCtrl.trainings.length || $trainingsTablePanelCtrl.isLoadingData"> <span></span></label></th><th><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$trainingsTablePanelCtrl.nameSearchValue" ng-model-options="{debounce: 500}" st-search="Name" class="form-control with-default-addon input-sm" placeholder="{{(\'modules.personnel.dossier.trainings.table.nameFilterPlaceholder\' | translate)}}"></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CountableHours.value"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="number" ng-model="$trainingsTablePanelCtrl.countableHoursSearchValue" ng-model-options="{debounce: 500}" st-search="CountableHours" min="0" class="form-control with-default-addon input-sm inherit-spinbutton" placeholder="{{(\'modules.personnel.dossier.trainings.table.hourFilterPlaceholder\' | translate)}}"></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Status.value"><tag-picker default-label="(\'modules.personnel.dossier.trainings.state\' | translate)" tags="$trainingsTablePanelCtrl.TRAINING_STATUS" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'" selected-tags="$trainingsTablePanelCtrl.selectedTrainingsStatusFilter"></tag-picker></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.StartDate.value"><div class="input-group"><input type="text" class="form-control input-sm" name="trainingStartDate" datepicker-append-to-body="true" uib-datepicker-popup="{{ $trainingsTablePanelCtrl.datepicker.format }}" datepicker-options="$trainingsTablePanelCtrl.datepicker.options" ng-model="$trainingsTablePanelCtrl.dates.trainingStartDate" is-open="$trainingsTablePanelCtrl.openedStartDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="$trainingsTablePanelCtrl.openedStartDate = !$trainingsTablePanelCtrl.openedStartDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.EndDate.value"><div class="input-group"><input type="text" class="form-control input-sm" name="trainingEndDate" datepicker-append-to-body="true" uib-datepicker-popup="{{ $trainingsTablePanelCtrl.datepicker.format }}" datepicker-options="$trainingsTablePanelCtrl.datepicker.options" ng-model="$trainingsTablePanelCtrl.dates.trainingEndDate" is-open="$trainingsTablePanelCtrl.openedEndDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="$trainingsTablePanelCtrl.openedEndDate = !$trainingsTablePanelCtrl.openedEndDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionDate.value"><div class="input-group"><input type="text" class="form-control input-sm" name="trainingCompletionDate" datepicker-append-to-body="true" uib-datepicker-popup="{{ $trainingsTablePanelCtrl.datepicker.format }}" datepicker-options="$trainingsTablePanelCtrl.datepicker.options" ng-model="$trainingsTablePanelCtrl.dates.trainingCompletionDate" is-open="$trainingsTablePanelCtrl.openedCompletionDate" close-text="{{(\'generalTerms.close\' | translate)}}" show-button-bar="false" placeholder="{{(\'modules.personnel.dossier.trainings.datePlaceholder\' | translate)}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="$trainingsTablePanelCtrl.openedCompletionDate = !$trainingsTablePanelCtrl.openedCompletionDate"><i class="glyphicon glyphicon-calendar"></i></button></span></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionStatus.value"><tag-picker default-label="(\'modules.personnel.dossier.trainings.completion\' | translate)" tags="$trainingsTablePanelCtrl.TRAINING_COMPLETION_STATUS" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'" selected-tags="$trainingsTablePanelCtrl.selectedTrainingsCompletionStatusFilter"></tag-picker></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Graduation.value"><tag-picker default-label="(\'modules.personnel.dossier.trainings.graduation\' | translate)" tags="$trainingsTablePanelCtrl.GRADUATIONS" append-to-body-with-class="\'arno-tag-picker-tbl-header arno-tag-picker-tbl-header-body\'" append-to-button-with-class="\'ui-select-fixed-button-position\'" selected-tags="$trainingsTablePanelCtrl.selectedTrainingsGraduationFilter"></tag-picker></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.TrainingTemplate.value"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$trainingsTablePanelCtrl.templateNameSearchValue" ng-model-options="{debounce: 500}" st-search="TrainingTemplateName" class="form-control with-default-addon input-sm" placeholder="{{(\'modules.personnel.dossier.trainings.table.templateFilterPlaceholder\' | translate)}}"></div></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.ValidityEndDate.value"></th><th ng-if="$trainingsTablePanelCtrl.visibleCols.Notes.value"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left ion-search"></span> <input type="search" ng-model="$trainingsTablePanelCtrl.notesSearchValue" ng-model-options="{debounce: 500}" st-search="Notes" class="form-control with-default-addon input-sm" placeholder="{{(\'modules.personnel.dossier.trainings.table.noteFilterPlaceholder\' | translate)}}"></div></th><th></th></tr></thead><tbody><tr ng-if="!$trainingsTablePanelCtrl.trainings.length && !$trainingsTablePanelCtrl.isLoadingData"><td colspan="10" class="align-center"><i ng-show="$trainingsTablePanelCtrl.currentFilters" translate="modules.personnel.dossier.trainings.table.noTrainingsFoundForFilter"></i> <i ng-show="!$trainingsTablePanelCtrl.currentFilters" translate="modules.personnel.dossier.trainings.table.noTrainingsFound"></i></td></tr><tr ng-if="$trainingsTablePanelCtrl.trainings.length && !$trainingsTablePanelCtrl.isLoadingData" ng-repeat="listEntry in $trainingsTablePanelCtrl.trainings" class="editable-row arno-pointing-pointer" ng-click="$trainingsTablePanelCtrl.openTrainingDetails(listEntry, $event)"><td class="align-center" ng-if="!$trainingsTablePanelCtrl.isOverview"><label class="checkbox-inline custom-checkbox nowrap" ng-click="$event.stopPropagation()"><input type="checkbox" ng-model="listEntry.vm.selected"> <span></span></label></td><td><span ng-if="listEntry.AssignedByExternalSystem"><i class="fa fa-exchange" title="{{ \'modules.personnel.dossier.overview.qualificationList.externalSystemTooltip\' | translate:{sys:listEntry.AssignedByExternalSystem} }}"></i></span> {{ listEntry.Name }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.CountableHours.value">{{ listEntry.CountableHours }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.Status.value">{{ $trainingsTablePanelCtrl.TRAINING_STATUS_LABELS[listEntry.Status] }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.StartDate.value">{{ listEntry.StartDate | date: \'shortDate\' }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.EndDate.value">{{ listEntry.EndDate | date: \'shortDate\' }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionDate.value">{{ listEntry.CompletionDate | date: \'shortDate\' }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.CompletionStatus.value">{{ $trainingsTablePanelCtrl.TRAINING_COMPLETION_STATUS_LABELS[listEntry.CompletionStatus] }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.Graduation.value">{{ $trainingsTablePanelCtrl.GRADUATIONS_LABELS[listEntry.Graduation] }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.TrainingTemplate.value">{{ listEntry.TrainingTemplate.Name }}</td><td ng-if="$trainingsTablePanelCtrl.visibleCols.ValidityEndDate.value"><span ng-class="{\'arno__personnel__dossier__trainings__validity --expired\': $trainingsTablePanelCtrl.checkTrainingValidity(listEntry)}">{{ listEntry.ValidityEndDate | date: \'shortDate\' }}</span></td><td ng-if="$trainingsTablePanelCtrl.visibleCols.Notes.value">{{ listEntry.Notes }}</td><td ng-if="!$trainingsTablePanelCtrl.isOverview"><div class="pull-right nowrap"><button ng-if="$trainingsTablePanelCtrl.hasViewPermission || $trainingsTablePanelCtrl.hasManagePermission" ng-click="$trainingsTablePanelCtrl.openTrainingDetails(listEntry, $event)" class="btn btn-default btn-with-icon btn-xs" title="{{(\'modules.personnel.dossier.trainings.table.showTrainings\' | translate )}}"><span ng-if="$trainingsTablePanelCtrl.hasManagePermission"><i class="fa fa-pencil"></i><span class="hidden-xs hidden-sm" translate="generalTerms.edit"></span></span> <span ng-if="$trainingsTablePanelCtrl.hasViewPermission && !$trainingsTablePanelCtrl.hasManagePermission"><i class="fa fa-eye"></i><span class="hidden-xs hidden-sm" translate="generalTerms.details"></span></span></button> <button ng-if="listEntry.File" ng-click="$trainingsTablePanelCtrl.viewOrDownloadFile(listEntry, $event)" class="btn btn-default btn-with-icon btn-xs" title="{{(\'generalTerms.file\' | translate )}}"><span ng-if="$trainingsTablePanelCtrl.fileHasPreview(listEntry.File)"><i class="fa fa-file-pdf-o"></i><span class="hidden-xs hidden-sm" translate="generalTerms.view"></span></span> <span ng-if="!$trainingsTablePanelCtrl.fileHasPreview(listEntry.File)"><i class="fa fa-download"></i><span class="hidden-xs hidden-sm" translate="generalTerms.download"></span></span></button> <button ng-click="$trainingsTablePanelCtrl.openTrainingStatistics(listEntry, $event)" class="btn btn-default btn-with-icon btn-xs" translate-attr="{ title: \'modules.personnel.dossier.trainings.table.showTrainingsText\' }" translate-values="{ template: listEntry.TrainingTemplate.Name }"><i class="fa fa-clock-o"></i><span class="hidden-xs hidden-sm" translate="generalTerms.report"></span></button> <button acl-grant="\'arno.personnel.dossier.trainings.manage\'" ng-click="$trainingsTablePanelCtrl.deleteTraining(listEntry, $event)" class="btn btn-danger btn-with-icon btn-xs" title="{{(\'modules.personnel.dossier.trainings.table.deleteTraining\' | translate )}}"><i class="ion-ios-trash"></i><span class="hidden-xs hidden-sm" translate="generalTerms.delete"></span></button></div></td></tr></tbody><tfoot ng-hide="$trainingsTablePanelCtrl.isLoadingData"><tr><td colspan="13" class="align-center"><st-pagination st-items-by-page="$trainingsTablePanelCtrl.tablePageSize" st-template="app/theme/components/paging/paging.html" st-displayed-pages="5"></st-pagination></td></tr></tfoot></table></div></arno-ba-tableview-content></arno-ba-tableview></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsTreePanel/trainingsTreePanel.tpl.html','<div class="row arno__personnel__dossier__trainings__treeview"><script type="text/ng-template" id="personnelDossierTrainingsTreePanelHeaderHelpTooltip.tpl.html"><div class="p-5"> <h6>{{(\'generalTerms.legend\' | translate)}}:</h6> <table> <tr><td><i class="fa fa-sitemap mr-10"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.group"></td></tr> <tr><td><i class="fa fa-file-text-o"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.template"></td></tr> <tr><td>&nbsp;</td></tr> <tr><td><i class="af af-graduation-cap-question mr-10"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.inPlanning"></td></tr> <tr><td><i class="af af-graduation-cap-gear"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.inExecution"></td></tr> <tr><td><i class="af af-graduation-cap-hourglass training-status-pending"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.pending"></td></tr> <tr><td><i class="fa fa-graduation-cap training-status-succeeded"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.successful"></td></tr> <tr><td><i class="fa fa-graduation-cap training-status-failed"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.notSuccessful"></td></tr> <tr><td>&nbsp;</td></tr> <tr><td>---</td><td class="training-validity-expired" translate="modules.personnel.dossier.trainings.treePanel.expired"></td></tr> <tr><td>&nbsp;</td></tr> <tr><td colspan="2"><h6 translate="modules.personnel.dossier.trainings.treePanel.actions"></h6></td></tr> <tr><td><i class="fa fa-clock-o"></i></td><td translate="modules.personnel.dossier.trainings.treePanel.showReport"></td></tr> </table> </div></script><div><div ba-panel="" ba-panel-title="\'generalTerms.trainings\'" class="col-xs-12 col-sm-6" ba-panel-header-tooltip-template="personnelDossierTrainingsTreePanelHeaderHelpTooltip.tpl.html"><arno-trainings-treeview selected-ctx="$trainingsTreePanelCtrl.selectedCtx" trainings-tree-data="$trainingsTreePanelCtrl.trainingsTree" selected-node="$trainingsTreePanelCtrl.selectedNode" node-select="$trainingsTreePanelCtrl.nodeSelect" add-training-handler="$trainingsTreePanelCtrl.addTraining" delete-training-handler="$trainingsTreePanelCtrl.deleteTraining" open-statistics-handler="$trainingsTreePanelCtrl.openTrainingStatistics" is-loading="$trainingsTreePanelCtrl.isLoadingData" ui-config="$trainingsTreePanelCtrl.treeviewConfig" trainings-status-filter="$trainingsTreePanelCtrl.selectedTrainingsStatusFilter"></arno-trainings-treeview></div><div ng-if="$trainingsTreePanelCtrl.selectedNode" ba-panel="" ba-panel-title="\'generalTerms.detail\'" class="col-xs-12 col-sm-6"><arno-personnel-dossier-trainings-edit selected-ctx="$trainingsTreePanelCtrl.selectedCtx" member="$trainingsTreePanelCtrl.member" training-data="$trainingsTreePanelCtrl.selectedNode.model" form-ref="$trainingsTreePanelCtrl.trainingEditForm" feedback-receiver="$trainingsTreePanelCtrl.trainingsEditFeedbackReceiver" categories="$trainingsTreePanelCtrl.categories" ui-config="$trainingsTreePanelCtrl.trainingsEditUiConfig"></arno-personnel-dossier-trainings-edit></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsWizardModal/trainingsWizardModal.tpl.html','<div class="modal-content arno__personnel__dossier__trainings__wizard-add-training"><div class="modal-header pb-0"><h4 class="with-line" translate="modules.personnel.dossier.trainings.wizardModal.create"><h4></h4></h4></div><div class="modal-body pt-0"><ba-wizard on-cancel="$trainingWizardCtrl.cancel" allow-back="true" on-finish="$trainingWizardCtrl.finish"><ba-wizard-step title="{{(\'modules.personnel.dossier.trainings.trainingTemplate\' | translate)}}" form="$trainingWizardCtrl.chooseTrainingTemplateForm" on-submit="$trainingWizardCtrl.chosedTrainingTemplate"><form name="$trainingWizardCtrl.chooseTrainingTemplateForm" novalidate="" ng-if="$trainingWizardCtrl.hasTrainingTemplates()"><div class="row form-group mt-10 mb-20"><div class="col-xs-12"><arno-trainings-treeview trainings-tree-data="$trainingWizardCtrl.trainingTemplateTreeData" selected-node="$trainingWizardCtrl.selectedNode" node-select="$trainingWizardCtrl.selectNode" has-error="!$trainingWizardCtrl.chooseTrainingTemplateForm.$valid" ui-config="$trainingWizardCtrl.treeviewConfig"></arno-trainings-treeview></div><label ng-if="$trainingWizardCtrl.chooseTrainingTemplateForm.$valid === false" class="col-xs-12 animated fadeIn control-label has-error validationMessage" translate="modules.personnel.dossier.trainings.wizardModal.chooseTemplate"></label></div></form><div ng-if="!$trainingWizardCtrl.hasTrainingTemplates()" class="form-group text-center mt-30 mb-30"><span class="has-error validationMessage" translate="modules.personnel.dossier.trainings.wizardModal.createTemplate"><div class="mt-20"><div ng-switch="$trainingWizardCtrl.hasManagePermission" class="text-center"><div ng-switch-when="true"><button class="btn btn-default btn-with-icon" ng-click="$trainingWizardCtrl.gotoTrainingsTemplateAdministration()"><i class="ion-android-open mr-5"></i><span translate="modules.personnel.dossier.trainings.wizardModal.toTemplateAdmin"></span></button></div><div ng-switch-default="" translate="modules.personnel.dossier.trainings.wizardModal.noPermissions"></div></div></div></span></div></ba-wizard-step><ba-wizard-step title="{{(\'generalTerms.edit\' | translate)}}" form="$trainingWizardCtrl.addTrainingForm"><div class="row form-group"><arno-personnel-dossier-trainings-edit class="col-xs-12" form-ref="$trainingWizardCtrl.addTrainingForm" training-data="$trainingWizardCtrl.training" ui-config="$trainingWizardCtrl.trainingEditUiConfig" categories="$trainingWizardCtrl.categories"></arno-personnel-dossier-trainings-edit></div></ba-wizard-step></ba-wizard></div></div>');
$templateCache.put('app/pages/administration/material/inspection/inspectionModal/assignmentOverride/assignmentOverride.modal.html','<div class="modal-content"><div class="modal-header bg-warning"><h4 class="modal-title" translate="modules.material.addMaterial.inspection.intervalOverrideWarningTitle"></h4></div><div class="modal-body"><div><p translate="modules.material.addMaterial.inspection.intervalOverrideWarningContent" translate-values="{materialCount: self.assignmentCount}"></p></div><label class="custom-checkbox mt-20"><input type="checkbox" ng-model="self.override"><span translate="modules.material.addMaterial.inspection.intervalOverrideCheckbox"></span></label></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="button" class="btn btn-primary" ng-click="$close(!!self.override)" translate="generalTerms.continue"></button></div></div>');
$templateCache.put('app/pages/administration/personnel/activities/activityWindow/requirementsSetModal/characteristicsTabs.html','<uib-tabset active="tab.active"><uib-tab index="$index" class="tab {{tab.class}}" ng-repeat="tab in tabs" disable="tab.disabled" ng-if="tab.visible"><uib-tab-heading><i class="fa" ng-class="{\'fa-check-circle-o\': tab.activeCharacteristic, \'fa-circle-o\': !tab.activeCharacteristic}"></i> {{tab.heading}}</uib-tab-heading><div><label class="arno-requirementset-admin-modal-tabset-activate-label" translate="modules.administration.adminActivities.assignFeature"></label><ba-switcher switcher-style="primary" switcher-value="tab.activeCharacteristic"></ba-switcher><div ng-if="tab.activeCharacteristic"><h5 class="modal-subtitle"><i class="ion-ribbon-b"></i> <span translate="modules.administration.adminActivities.qualifications"></span></h5><qualification-list qualification-list="tab.quali" qualification-states="[{ title: \'modules.administration.adminActivities.qualifications\', intext: \'modules.administration.adminActivities.qualifications\', showSectionHeader: false }]" qualification-add="tab.requirementsSetModalCtrl.Qualifications" qualification-delete="true" qualification-change-model="tab.requirements.Qualifications" qualification-change-property="id"></qualification-list><h5 class="modal-subtitle"><i class="fa fa-thumbs-o-up"></i> <span translate="modules.administration.adminActivities.releases"></span></h5><approval-list approval-list="tab.approvals" approval-add="tab.requirementsSetModalCtrl.Approvals" approval-delete="true" approval-change-model="tab.requirements.Approvals" approval-change-property="id"></approval-list></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/administration/personnel/activities/activityWindow/requirementsSetModal/requirementsSetModal.html','<div class="modal-content"><form id="activitySetForm" name="activitySetForm" novalidate="" angular-validator="" angular-validator-submit="$requirementsSetModalCtrl.applyModal(\'applyReqSetModal\')"><div class="modal-header"><h3 class="modal-title" translate="modules.administration.adminActivities.requirementSetFor" translate-values="{setModalActivityTitle: $requirementsSetModalCtrl.activity.title}"></h3></div><div class="modal-body arno-requirementset-admin-modal"><div class="form-group"><label for="nameInput" class="required-label" translate="modules.administration.adminActivities.nameOfRequirementSet"></label> <input type="text" class="form-control" id="nameInput" name="nameInput" ng-model="$requirementsSetModalCtrl.requirementsSet.title" ng-model-options="{ debounce: 200 }" validator="!$requirementsSetModalCtrl.isActivityNameExistent($requirementsSetModalCtrl.requirementsSet.title)" invalid-message="\'modules.administration.adminActivities.invalidActivity\' |translate" required-message="\'modules.administration.adminActivities.requiredActivity\' |translate" required=""></div><h4 class="with-line without-margin"><span translate="modules.administration.adminActivities.workInFunction"></span></h4><div class="arno-requirementset-admin-modal-default"><h5 class="modal-subtitle"><i class="ion-ribbon-b"></i> <span translate="modules.administration.adminActivities.qualifications"></span></h5><qualification-list qualification-list="$requirementsSetModalCtrl.defaultQualifications" qualification-states="[{ title: \'modules.administration.adminActivities.qualifications\', intext: \'modules.administration.adminActivities.qualifications\', showSectionHeader: false }]" qualification-add="$requirementsSetModalCtrl.Qualifications" qualification-delete="true" qualification-change-model="$requirementsSetModalCtrl.tabs[0].requirements.Qualifications" always-show="true" qualification-change-property="id"></qualification-list><h5 class="modal-subtitle"><i class="fa fa-thumbs-o-up"></i> <span translate="modules.administration.adminActivities.releases"></span></h5><approval-list approval-list="$requirementsSetModalCtrl.defaultApprovals" approval-add="$requirementsSetModalCtrl.Approvals" approval-delete="true" approval-change-model="$requirementsSetModalCtrl.tabs[0].requirements.Approvals" approval-change-property="id"></approval-list></div><h4 class="with-line"><span translate="modules.administration.adminActivities.requirementOfAdditionalCharacters"></span></h4><div ba-panel="" ba-panel-class="tabs-panel horizontal-tabs"><tabs data="$requirementsSetModalCtrl.tabs" template-url="app/pages/administration/personnel/activities/activityWindow/requirementsSetModal/characteristicsTabs.html"></tabs></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()" translate="generalTerms.cancel"></button> <button type="submit" class="btn btn-primary" translate="generalTerms.takeOver"></button></div></form></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsHoursTable/trainingsHoursTable.tpl.html','<div><arno-ba-tableview ng-if="$trainingsHoursTableCtrl.trainingsData.length" list-visible-cols="$trainingsHoursTableCtrl.visibleCols" list-page-sizes="$trainingsHoursTableCtrl.pageSizes" ui-config="$trainingsHoursTableCtrl.tablesUiConfig"><arno-ba-tableview-content><div class="table-responsive"><table st-table="$trainingsHoursTableCtrl.displayedTableEntries" st-pipe="$trainingsHoursTableCtrl.trainingsData" class="table table-condensed table-hover"><col width="21%"><col width="8%"><col width="8%"><col width="10%"><col width="8%"><col width="12%"><col width="15%"><thead><tr class="sortable arno__ba-tableview__list__header --grey"><th>Name</th><th ng-if="$trainingsHoursTableCtrl.visibleCols.StartDate.value">{{ (\'modules.personnel.dossier.trainings.begin\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_START_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.EndDate.value">{{ (\'modules.personnel.dossier.trainings.end\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_END_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.CompletionDate.value">{{ (\'modules.personnel.dossier.trainings.completionDate\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_COMPLETION_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.ValidityEndDate.value">{{ (\'modules.personnel.dossier.trainings.validityEndDate\' | translate) }}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_VALIDITY_DATE_FIELD\' | translate )}}"></arno-ba-help-tooltip></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.CountableHours.value" class="text-center" translate="modules.personnel.dossier.trainings.hours"></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.Status.value" translate="modules.personnel.dossier.trainings.state"></th><th ng-if="$trainingsHoursTableCtrl.visibleCols.TrainingTemplate.value" translate="modules.personnel.dossier.trainings.template"></th></tr></thead><tbody><tr ng-repeat="listEntry in $trainingsHoursTableCtrl.trainingsData" class="editable-row"><td>{{ listEntry.Name }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.StartDate.value">{{ listEntry.StartDate | date: \'shortDate\' }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.EndDate.value">{{ listEntry.EndDate | date: \'shortDate\' }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.CompletionDate.value">{{ listEntry.CompletionDate | date: \'shortDate\' }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.ValidityEndDate.value"><span ng-class="{\'arno__personnel__dossier__trainings__validity --expired\': $trainingsHoursTableCtrl.checkTrainingValidity(listEntry)}">{{ listEntry.ValidityEndDate | date: \'shortDate\' }}</span></td><td ng-if="$trainingsHoursTableCtrl.visibleCols.CountableHours.value" class="text-center">{{ listEntry.CountableHours }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.Status.value">{{ $trainingsHoursTableCtrl.TRAINING_STATUS_LABELS[listEntry.Status] }}</td><td ng-if="$trainingsHoursTableCtrl.visibleCols.TrainingTemplate.value">{{ listEntry.TrainingTemplate.Name }}</td></tr><tr class="arno__personnel__dossier__trainings__table__countable-hours__total"><td><strong translate="modules.personnel.dossier.trainings.totalHours"></strong></td><td ng-if="$trainingsHoursTableCtrl.visibleCols.StartDate.value"></td><td ng-if="$trainingsHoursTableCtrl.visibleCols.EndDate.value"></td><td ng-if="$trainingsHoursTableCtrl.visibleCols.CompletionDate.value"></td><td ng-if="$trainingsHoursTableCtrl.visibleCols.ValidityEndDate.value"></td><td class="text-center"><strong ng-bind="$trainingsHoursTableCtrl.recalcCountableHours($trainingsHoursTableCtrl.trainingsData)"></strong></td><td colspan="3"></td></tr></tbody></table></div></arno-ba-tableview-content></arno-ba-tableview><div ng-if="!$trainingsHoursTableCtrl.trainingsData.length"><div class="text-center pt-15 pb-15" translate="modules.personnel.dossier.trainings.statistics.noTrainingHours"></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsTimeline/trainingsTimeline.tpl.html','<div class="col-xs-12"><div class="row"><div ng-if="$trainingsTimelineCtrl.trainingsData.length" class="col-xs-12"><timeline control="$trainingsTimelineCtrl.timeline" class="mt-15 arno__personnel__dossier__trainings__statistics__timeline" options="$trainingsTimelineCtrl.timelineOptions"></timeline></div><div ng-if="!$trainingsTimelineCtrl.trainingsData.length" class="col-xs-12 text-center mt-20 mb-20" translate="modules.personnel.dossier.trainings.statistics.noTrainings"></div></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsTablePanel/trainingsDetailModal/trainingsDetailModal.tpl.html','<div class="modal-content arno__personnel__dossier__trainings__wizard-add-training"><div class="modal-header pb-0"><h4 class="with-line" translate="modules.personnel.dossier.trainings.detailsTitle" translate-values="{ trainingName: $trainingsDetailsCtrl.training.Name }"><h4></h4></h4></div><div class="modal-body pt-0"><arno-personnel-dossier-trainings-edit selected-ctx="$trainingsDetailsCtrl.selectedCtx" training-data="$trainingsDetailsCtrl.training" member="$trainingsDetailsCtrl.member" feedback-receiver="$trainingsDetailsCtrl.trainingsEditFeedbackReceiver" categories="$trainingsDetailsCtrl.categories" form-ref="$trainingsDetailsCtrl.trainingsEditForm" ui-config="$trainingsDetailsCtrl.trainingsEditUiConfig"></arno-personnel-dossier-trainings-edit></div></div>');
$templateCache.put('app/pages/personnel/dossier/trainings/trainingsStatistics/trainingsQualificationsTable/trainingsQualificationsTable.tpl.html','<div><div ng-if="!$trainingsQualificationsTableCtrl.trainingTemplates.length" class="text-center mt-15 mb-15" translate="modules.personnel.dossier.trainings.statistics.noQualifications"></div><div ng-if="$trainingsQualificationsTableCtrl.trainingTemplates.length"><div ng-if="$trainingsQualificationsTableCtrl.affectedMemberTrainingTemplatesQualifications.length || $trainingsQualificationsTableCtrl.allTrainingTemplatesQualifications.length" class="col-xs-12 mb-15"><h4>{{(\'modules.personnel.dossier.trainings.statistics.affectedQualifications\' | translate)}}<arno-ba-help-tooltip text="{{(\'modules.personnel.dossier.trainings.TRAINING_HELP_PERSONNEL_DOSSIER_QUALIFICATION_SECTION\' | translate )}}"></arno-ba-help-tooltip></h4><p ng-if="!$trainingsQualificationsTableCtrl.qualificationsViewOnly" class="mb-20"><strong>{{ (\'generalTerms.hint\' | translate) }}:</strong> {{ (\'modules.personnel.dossier.trainings.statistics.hintTextQualifications\' | translate) }} <span ng-if="$trainingsQualificationsTableCtrl.hasDossierQualificationViewPerm">(<a href="" ui-sref="arno.personnel.dossier.qualification" translate="modules.personnel.dossier.trainings.statistics.showAllQualifications"></a>).</span></p><qualification-list ng-if="$trainingsQualificationsTableCtrl.actionInProgress === false" qualification-list="$trainingsQualificationsTableCtrl.affectedMemberTrainingTemplatesQualifications" qualification-change-model="$trainingsQualificationsTableCtrl.changedQualifications" qualification-states="[{ title: (\'modules.personnel.dossier.trainings.qualification\' | translate), intext: (\'modules.personnel.dossier.trainings.affectedQualification\' | translate), showSectionHeader: false }]" qualification-list-member-data="$trainingsQualificationsTableCtrl.member" qualification-add="$trainingsQualificationsTableCtrl.qualificationsHierarchyForAdd" qualification-delete="$trainingsQualificationsTableCtrl.allowQualificationsDelete" qualification-only-view="$trainingsQualificationsTableCtrl.qualificationsViewOnly" division-ids="$trainingsQualificationsTableCtrl.selectedCtx" member="$trainingsQualificationsTableCtrl.member" always-show="true" css-configs="{ addQualificationBottomBarClass: \'col-md-5\' }"></qualification-list><div class="pull-right"><button ng-if="!$trainingsQualificationsTableCtrl.qualificationsViewOnly" class="btn btn-primary btn-with-icon pull-right" ng-click="$trainingsQualificationsTableCtrl.saveQualifications()"><i class="ion-checkmark"></i> <span class="hidden-xs" translate="generalTerms.save"></span></button></div></div><div ng-if="$trainingsQualificationsTableCtrl.trainingTemplates.length < 2" class="col-xs-12 mb-15"><div ng-repeat="trainingTemplate in $trainingsQualificationsTableCtrl.trainingTemplates" class="row mt-15"><div class="col-xs-12"><h4 translate="modules.personnel.dossier.trainings.statistics.associatedQualifications"></h4><qualification-list qualification-list="$trainingsQualificationsTableCtrl.allTrainingTemplatesQualifications" qualification-states="[{ title: \'Qualifikationen\', intext: \'Qualifikationen\', showSectionHeader: false }]" qualification-list-member-data="$trainingsQualificationsTableCtrl.member" qualification-only-view="true" division-ids="$trainingsQualificationsTableCtrl.selectedCtx" member="$trainingsQualificationsTableCtrl.member" always-show="true"></qualification-list></div></div></div></div><div ng-if="$trainingsQualificationsTableCtrl.trainingTemplates.length > 1" class="col-xs-12 mb-15"><div ng-repeat="trainingTemplate in $trainingsQualificationsTableCtrl.trainingTemplates" class="row mt-15"><div class="col-xs-12"><h4 ng-bind="::trainingTemplate.Name"></h4><qualification-list qualification-list="trainingTemplate.Qualifications" qualification-states="[{ title: \'Qualifikationen\', intext: \'Qualifikationen assoziiert\', showSectionHeader: false }]" qualification-list-member-data="$trainingsQualificationsTableCtrl.member" qualification-only-view="true" division-ids="$trainingsQualificationsTableCtrl.selectedCtx" member="$trainingsQualificationsTableCtrl.member" always-show="true"></qualification-list></div></div></div></div>');}]);